/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1258);
	module.exports = __webpack_require__(932);


/***/ },
/* 1 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1270);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(1082)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.4';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)(module)))

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(205);
	function _defineProperty(obj, key, value) {
	  key = toPropertyKey(key);
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 5 */
/***/ function(module, exports) {

	function _typeof(o) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 6 */
/***/ function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(205);
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  Object.defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(139);
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  Object.defineProperty(subClass, "prototype", {
	    writable: false
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	
	'use strict'
	
	if (true) {
	  module.exports = __webpack_require__(1077)
	} else {
	  module.exports = require('./mobxreact.cjs.development.js')
	}


/***/ },
/* 10 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	  return self;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1095)();
	}


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = translate;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	function translate(key) {
	  return function (Component) {
	    var TranslationComponent = function (_React$Component) {
	      _inherits(TranslationComponent, _React$Component);
	
	      function TranslationComponent() {
	        _classCallCheck(this, TranslationComponent);
	
	        return _possibleConstructorReturn(this, (TranslationComponent.__proto__ || Object.getPrototypeOf(TranslationComponent)).apply(this, arguments));
	      }
	
	      _createClass(TranslationComponent, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	          // Get the current translation data
	          var SessionStore = this.props.store.SessionStore;
	
	          if (!SessionStore.translationLoaded) {
	
	            SessionStore.getTranslation(SessionStore.locale);
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var SessionStore = this.props.store.SessionStore;
	
	
	          if (SessionStore.translation) {
	            // Return the translation for the provided component (key)
	            var translation = SessionStore.translation[key];
	            return _react2.default.createElement(Component, Object.assign({}, this.props, { translation: translation }));
	          } else {
	            return null;
	          }
	        }
	      }]);
	
	      return TranslationComponent;
	    }(_react2.default.Component);
	
	    return (0, _mobxReact.observer)(TranslationComponent);
	  };
	}

/***/ },
/* 13 */
/***/ function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _getPrototypeOf(o);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 14 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requiredArgs;
	function requiredArgs(required, args) {
	  if (args.length < required) {
	    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
	  }
	}
	module.exports = exports.default;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(5)["default"];
	var assertThisInitialized = __webpack_require__(10);
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }
	  return assertThisInitialized(self);
	}
	module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _index = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If the argument is none of the above, the function returns Invalid Date.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 *
	 * @param {Date|Number} argument - the value to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Clone the date:
	 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert the timestamp to date:
	 * const result = toDate(1392098430000)
	 * //=> Tue Feb 11 2014 11:30:30
	 */
	function toDate(argument) {
	  (0, _index.default)(1, arguments);
	  var argStr = Object.prototype.toString.call(argument);
	
	  // Clone the date
	  if (argument instanceof Date || (0, _typeof2.default)(argument) === 'object' && argStr === '[object Date]') {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument === 'number' || argStr === '[object Number]') {
	    return new Date(argument);
	  } else {
	    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
	      // eslint-disable-next-line no-console
	      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
	      // eslint-disable-next-line no-console
	      console.warn(new Error().stack);
	    }
	    return new Date(NaN);
	  }
	}
	module.exports = exports.default;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isAuthenticated = isAuthenticated;
	exports.toggleDrawer = toggleDrawer;
	exports.closeDrawer = closeDrawer;
	exports.checkValidityHybrid = checkValidityHybrid;
	exports.checkValidity = checkValidity;
	exports.toHours = toHours;
	exports.toTop = toTop;
	exports.confirm = confirm;
	exports.promptUser = promptUser;
	exports.roundTime = roundTime;
	exports.getMapUrl = getMapUrl;
	exports.getURLSegment = getURLSegment;
	exports.pushHrefToRouting = pushHrefToRouting;
	exports.getParam = getParam;
	exports.findAncestor = findAncestor;
	exports.flagPortrait = flagPortrait;
	exports.isLocalStorageSupported = isLocalStorageSupported;
	exports.getCookie = getCookie;
	exports.deleteCookie = deleteCookie;
	exports.getPath = getPath;
	exports.formatTime = formatTime;
	exports.extractTime = extractTime;
	exports.checkInput = checkInput;
	exports.parentHasClass = parentHasClass;
	exports.convertMinutesToTimeString = convertMinutesToTimeString;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _config = __webpack_require__(24);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Unauthenticated redirect
	
	
	// Store
	function isAuthenticated() {
	  var token = null;
	
	  if (_SessionStore2.default.hasSessionStorage) {
	    token = sessionStorage.getItem('token');
	  } else {
	    token = getCookie('token');
	  }
	
	  if (token === null || typeof token === 'undefined') {
	    return false;
	  }
	
	  document.querySelector('body').className = document.querySelector('body').className.replace('logged-out', '');
	
	  return true;
	}
	
	// Open and close drawers
	
	
	// Dependencies
	function toggleDrawer(e, component, drawerContent) {
	  if (e) {
	    e.preventDefault();
	  }
	
	  if (component) {
	    component.setState({
	      drawerOpen: true,
	      drawerContent: drawerContent
	    }, function () {
	      var drawer = document.querySelector('.drawer');
	
	      if (drawer) {
	        drawer.focus();
	      }
	    });
	  } else {
	    var drawer = document.querySelector('.drawer');
	    if (drawer) drawer.focus();
	  }
	}
	
	function closeDrawer(e, component, closePath, callback) {
	  if (e) {
	    e.preventDefault();
	  }
	
	  document.querySelector('body').classList.remove('drawer-open');
	
	  // Wait for the drawer to slide out before updating the URL
	  // or running a function
	
	  setTimeout(function () {
	    if (component) {
	      component.setState({
	        drawerOpen: false,
	        drawerContent: null
	      });
	    }
	
	    if (closePath && component) {
	      if (closePath[0] !== '/') {
	        component.props.routing.history.push('/' + closePath);
	      } else {
	        component.props.routing.history.push(closePath);
	      }
	    }
	
	    if (callback) {
	      callback();
	    }
	
	    // Make sure the close button will show up the next time a drawer opens
	    _SessionStore2.default.hideDrawerClose = false;
	    document.querySelector('body').classList.remove('drawer-open');
	    document.querySelector('body').classList.remove('drawer-open');
	  }, 250);
	
	  // Focus the main content
	  setTimeout(function () {
	    var content = document.querySelector('#main-content');
	
	    if (content) {
	      content.focus();
	    }
	  });
	}
	
	/**
	 * Check form validity before submission
	 *
	 * @function checkValidity
	 * @param {Event} e
	 * @param {function} onValid
	 * @param {function} onInvalid
	 */
	function checkValidityHybrid(e, onValid) {
	  var onInvalid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  e.preventDefault();
	
	  var form = e.target;
	  var invalidFields = [];
	  var existingErrorMsg = form.querySelector('.error');
	
	  // Mark the form as submitted
	  form.classList.add('hybrid-form--submitted');
	
	  var ie = document.querySelector('html').className.indexOf('ie-true') > -1 ? true : false;
	  var oldMoz = navigator.userAgent.indexOf('Firefox') && parseInt(navigator.userAgent.slice(-4), 10) < 51 ? true : false;
	  var edge = false;
	
	  if (navigator.userAgent.indexOf('Edge/14') > -1 || navigator.userAgent.indexOf('Edge/15') > -1 || navigator.userAgent.indexOf('Edge/16') > -1 || navigator.userAgent.indexOf('Edge/17') > -1) {
	    edge = true;
	  }
	
	  // Old versions of Firefox and IE don’t support one of the invalid selectors used below
	  if (!ie && !oldMoz && !edge) {
	    invalidFields = form.querySelectorAll('input[required]:invalid, select[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"], input[aria-invalid="true"]:not(:placeholder-shown), select[aria-invalid="true"');
	  } else if (edge) {
	    invalidFields = form.querySelectorAll('input[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"], select[aria-invalid="true"');
	  } else {
	    invalidFields = form.querySelectorAll('input[required]:invalid, select[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"], select[aria-invalid="true"');
	  }
	
	  // Remove existing error messages
	  if (existingErrorMsg) {
	    existingErrorMsg.parentNode.removeChild(existingErrorMsg);
	  }
	
	  if (!invalidFields.length) {
	    // If everything is valid proceed
	    if (onValid) {
	      onValid(e);
	    }
	  } else {
	    /**
	     * Create a static list of invalid fields and direct focus to it.
	     * Use this method instead of aria-live or role=alert. To use this
	     * feature, all form inputs MUST have a valid label associated.
	     */
	    var errorMsg = document.createElement('div');
	    errorMsg.className = 'error';
	    errorMsg.setAttribute('tabIndex', '-1');
	
	    var errorMsgNote = document.createElement('p');
	    errorMsgNote.innerText = 'Sorry, your form contained errors. Please correct the problems before submitting.';
	
	    var errorMsgList = document.createElement('ul');
	
	    invalidFields.forEach(function (field) {
	      var errorMsgListItem = document.createElement('li');
	      var label = form.querySelector('[for="' + field.id + '"]');
	
	      errorMsgListItem.innerText = field.getAttribute('data-errormsg') || label.innerText;
	
	      errorMsgList.appendChild(errorMsgListItem);
	    });
	
	    errorMsg.appendChild(errorMsgNote).appendChild(errorMsgList);
	
	    var fields = form.querySelector('.hybrid-form__fields:first-of-type');
	    var fieldsParent = fields.parentNode;
	
	    fieldsParent.insertBefore(errorMsg, fields);
	    errorMsg.focus();
	
	    if (onInvalid) {
	      onInvalid(e);
	    }
	  }
	}
	
	// Check form validity before submission
	function checkValidity(e, submitFunction, selector, invalidCallback) {
	  e.preventDefault();
	
	  var form = null;
	
	  if (selector) {
	    form = document.querySelector(selector);
	  } else {
	    form = e.target;
	  }
	
	  form.classList.add('submitted');
	
	  var ie = false;
	  var oldMoz = false;
	  var safari = false;
	  var edge = false;
	  var puffin = false;
	  var invalidFields = [];
	
	  if (document.querySelector('html').className.indexOf('ie-true') > -1) {
	    ie = true;
	  }
	
	  if (navigator.userAgent.indexOf('Firefox') && parseInt(navigator.userAgent.slice(-4), 10) < 51) {
	    oldMoz = true;
	  }
	
	  if (navigator.userAgent.indexOf('Safari')) {
	    safari = true;
	  }
	
	  if (navigator.userAgent.indexOf('Edge/14') > -1 || navigator.userAgent.indexOf('Edge/15') > -1 || navigator.userAgent.indexOf('Edge/16') > -1 || navigator.userAgent.indexOf('Edge/17') > -1) {
	    edge = true;
	  }
	
	  if (navigator.userAgent.indexOf('Puffin') > -1) {
	    puffin = true;
	  }
	
	  // Old versions of Firefox and IE don’t support one of the invalid selectors used below
	  if (!ie && !oldMoz && !edge && !puffin && !safari) {
	    invalidFields = form.querySelectorAll('input[required]:invalid, select[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"], input[aria-invalid="true"]:not(:placeholder-shown)');
	  } else if (edge) {
	    invalidFields = form.querySelectorAll('input[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"]');
	  } else {
	    invalidFields = form.querySelectorAll('input[required]:invalid, select[required]:invalid, textarea[required]:invalid, input[required][aria-invalid="true"]');
	  }
	
	  if (!invalidFields.length) {
	    if (submitFunction) {
	      submitFunction(e);
	    }
	
	    // Remove error message
	    var existingErrorMsg = form.querySelector('.note--error');
	
	    if (existingErrorMsg) {
	      existingErrorMsg.parentNode.removeChild(existingErrorMsg);
	    }
	  } else {
	    var _existingErrorMsg = form.querySelector('.note--error');
	
	    if (!_existingErrorMsg) {
	      var errorMsg = document.createElement('SPAN');
	      errorMsg.className = 'note note--prominent note--error';
	      errorMsg.innerHTML = 'Sorry, your form contained errors. Please correct the problems before submitting.';
	      var fields = form.querySelector('.fields:first-child');
	      var fieldsParent = fields.parentNode;
	      fieldsParent.insertBefore(errorMsg, fields);
	    }
	
	    if (invalidCallback) {
	      invalidCallback();
	    }
	
	    window.scrollTo(0, 0);
	  }
	}
	
	// Convert minutes to hours
	function toHours(time, isFirst, textOnly, unabbreviated, showLabel) {
	  var hours = 'hr';
	  var minutes = 'min';
	
	  if (unabbreviated) {
	    hours = ' hour';
	    minutes = ' minute';
	  }
	
	  if (time >= 30) {
	    if (isFirst) {
	      if (textOnly) {
	        return time / 60;
	      } else {
	        if (showLabel) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            time / 60,
	            ' ',
	            hours
	          );
	        } else {
	          return _react2.default.createElement(
	            'span',
	            null,
	            time / 60
	          );
	        }
	      }
	    } else {
	      if (parseInt(time / 60, 10) > 1 && unabbreviated) {
	        hours = ' hours';
	      }
	
	      if (unabbreviated) {
	        minutes = 'minutes';
	      }
	
	      if (textOnly) {
	        var minuteText = time % 60 > 0 ? ' ' + time % 60 + ' ' + minutes : '';
	
	        return parseInt(time / 60, 10) + hours + minuteText;
	      } else {
	        return _react2.default.createElement(
	          'span',
	          null,
	          parseInt(time / 60, 10),
	          ' ',
	          hours,
	          time % 60 > 0 && ' ' + time % 60 + ' ' + minutes
	        );
	      }
	    }
	  } else {
	    if (isFirst) {
	      if (textOnly) {
	        return time;
	      } else {
	        return _react2.default.createElement(
	          'span',
	          null,
	          time
	        );
	      }
	    } else {
	      if (time > 1) {
	        minutes = ' minutes';
	      }
	
	      if (textOnly) {
	        return time + ' ' + minutes;
	      } else {
	        return _react2.default.createElement(
	          'span',
	          null,
	          time,
	          ' ',
	          minutes
	        );
	      }
	    }
	  }
	}
	
	// Scroll to top of element
	function toTop(element) {
	  if (element) {
	    element.scrollTop = 0;
	  } else {
	    window.scrollTo(0, 0);
	  }
	}
	
	// Confirm
	function confirm(msg, func) {
	  _SessionStore2.default.showConfirm(msg, func);
	}
	
	// Prompt
	function promptUser(msg, selectFunc, callback) {
	  _SessionStore2.default.showPrompt(msg, selectFunc, callback);
	}
	
	// Round time
	function roundTime(time) {
	  if (time && time.minute() !== 0 && time.minute() !== 30) {
	    var remainder = 30 - time.minute() % 30;
	    return _moment2.default.utc(time).local().add('minutes', remainder).format('HH:mm');
	  }
	
	  return _moment2.default.utc(time).local().format('HH:mm');
	}
	
	/**
	 * Get static map url from google maps API for a given <latitude, longitude> pair
	 * @export
	 * @param {number} latitude
	 * @param {number} longitude
	 * @returns {string}
	 */
	function getMapUrl(latitude, longitude) {
	  return 'https://maps.googleapis.com/maps/api/staticmap?center=' + latitude + ',' + longitude + ('&zoom=16&scale=2&size=400x250&maptype=roadmap&key=' + _config.config.mapsApiKey) + ('&format=png&visual_refresh=true&markers=icon:' + _config.config.domain + '/static/img/marker.png%7C' + latitude + ',' + longitude);
	}
	
	/**
	 * Get URL segments
	 * @export
	 * @param {Component} component
	 * @param {number} segment
	 */
	function getURLSegment(component, segment) {
	  var pathname = component.props.routing.location.pathname;
	
	
	  var pathArray = pathname.split('/');
	
	  if (pathArray[0] === '') {
	    pathArray.splice(0, 1);
	  }
	
	  return pathArray[segment - 1];
	}
	
	/**
	 * Push the href, usually received from a html element event, to routing history
	 * @export
	 * @param {string} href
	 * @param {Component} component
	 */
	function pushHrefToRouting(href, component) {
	  // Regex to grab the domain name part of url
	  // For example grab 'http://www.url.com/' from 'http://www.url.com/page'
	  var domainRegex = /^(?:\/\/|[^\/]+)*\//;
	
	  // Replace the domain name and the '#' with empty string because the react router excludes them from path
	  // For example 'http://www.url.com/#/page' becomes '/page'
	  var path = href.replace(domainRegex, '').replace('#', '');
	
	  // Push the path to routing if it's not there already
	  if (component.props.routing.location.pathname !== path) {
	    component.props.routing.history.push(path);
	  }
	}
	
	/**
	 * Get query params from a string
	 * @export
	 * @param {name} string
	 * @param {url} string
	 */
	function getParam(name, url) {
	  name = name.replace(/[\[\]]/g, "\\$&");
	  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
	  var results = regex.exec(url);
	
	  if (!results) {
	    return null;
	  }
	
	  if (!results[2]) {
	    return '';
	  }
	
	  return decodeURIComponent(results[2].replace(/\+/g, " "));
	}
	
	/**
	* Find ancestor by class
	* @export
	* @param {el} string
	* @param {className} string
	*/
	function findAncestor(el, className) {
	  while (el.parentNode) {
	    el = el.parentNode;
	
	    if (el && el.className.indexOf(className) > -1) {
	      return el;
	    }
	  }
	
	  return null;
	}
	
	/**
	* Flag portrait oriented image
	* @export
	* @param {e} string
	* @param {src} string
	*/
	function flagPortrait(e, src) {
	  var img = new Image();
	  var imgEl = e.target;
	  var width = 0;
	  var height = 0;
	
	  img.onload = function () {
	    width = img.width;
	    height = img.height;
	
	    if (height > width) {
	      imgEl.className += ' portrait';
	    }
	  };
	
	  img.src = src;
	}
	
	/**
	* Check if sessionStorage is available
	* @export
	*/
	function isLocalStorageSupported() {
	  var testKey = 'test';
	  var storage = window.sessionStorage;
	
	  try {
	    storage.setItem(testKey, '1');
	    storage.removeItem(testKey);
	    return true;
	  } catch (error) {
	    return false;
	  }
	}
	
	/**
	* Get cookie by name
	* @export
	* @param {name} string
	*/
	function getCookie(name) {
	  var match = document.cookie.match(new RegExp(name + '=([^;]+)'));
	
	  if (match) {
	    return match[1];
	  }
	}
	
	/**
	* Delete cookie by name
	* @export
	* @param {name} string
	*/
	function deleteCookie(name) {
	  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	}
	
	/**
	 * Get url path and query from a string
	 * @export
	 * @param {url} string
	 */
	function getPath(url) {
	  var parser = document.createElement('a');
	  parser.href = url;
	  var pathname = parser.pathname;
	  var search = parser.search;
	
	  return pathname + search;
	}
	
	/**
	* Format time as h:mm
	* @export
	* @param {duration} integer (minutes)
	*/
	function formatTime(duration) {
	  var minutes = duration % 60;
	  var hours = Math.floor(duration / 60);
	
	  if (minutes < 10) {
	    minutes = '0' + minutes;
	  }
	
	  return hours + ':' + minutes;
	}
	
	/**
	* Extract time from date
	* @param {time} string
	*/
	function extractTime(time) {
	  var userTimezone = _SessionStore2.default.userTimezone;
	
	
	  if ((0, _moment2.default)(time, _moment2.default.ISO_8601).isValid()) {
	    return _moment2.default.utc(time).tz(userTimezone).format('HH:mm');
	  } else {
	    return '';
	  }
	}
	
	/**
	* Check if input type is supported
	* @export
	* @param {type} string
	*/
	function checkInput(type) {
	  var input = document.createElement('input');
	  input.setAttribute('type', type);
	  return input.type === type;
	}
	
	/**
	 * Check if any ancestor has a given class
	 *
	 * @exports
	 * @function parentHasClass
	 * @param {element} child
	 * @param {string} classname
	 * @returns {boolean}
	 */
	function parentHasClass(child, className) {
	  if (child.classList && child.classList.contains(className)) {
	    return true;
	  }
	
	  return child.parentNode && parentHasClass(child.parentNode, className);
	}
	
	function convertMinutesToTimeString(totalMinutes) {
	  var hours = Math.floor(totalMinutes / 60);
	  var minutes = totalMinutes % 60;
	  return hours + ':' + minutes.toString().padStart(2, '0');
	}

/***/ },
/* 18 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGlobal = getGlobal;
	function getGlobal() {
	  return typeof globalThis !== 'undefined' ? globalThis : window;
	}

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(523);
	var iterableToArray = __webpack_require__(528);
	var unsupportedIterableToArray = __webpack_require__(140);
	var nonIterableSpread = __webpack_require__(531);
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
	}
	module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var notEmpty = function notEmpty(x) {
	  return !!x && x !== true;
	};
	function _default() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	  if (args.length == 1 && Array.isArray(args[0])) {
	    args = args[0];
	  }
	  return (0, _toConsumableArray2.default)(args).filter(notEmpty).join(' ');
	}

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototypeOf = __webpack_require__(13);
	var isNativeReflectConstruct = __webpack_require__(203);
	var possibleConstructorReturn = __webpack_require__(15);
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = isNativeReflectConstruct();
	  return function _createSuperInternal() {
	    var Super = getPrototypeOf(Derived),
	      result;
	    if (hasNativeReflectConstruct) {
	      var NewTarget = getPrototypeOf(this).constructor;
	      result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }
	    return possibleConstructorReturn(this, result);
	  };
	}
	module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.iconAccess = iconAccess;
	exports.iconApple = iconApple;
	exports.iconArchive = iconArchive;
	exports.iconArrow = iconArrow;
	exports.iconBarChart = iconBarChart;
	exports.iconBadgeCheck = iconBadgeCheck;
	exports.iconCalendar = iconCalendar;
	exports.iconUSD = iconUSD;
	exports.iconCalendarPlus = iconCalendarPlus;
	exports.iconCalendarTimes = iconCalendarTimes;
	exports.iconCamera = iconCamera;
	exports.iconCap = iconCap;
	exports.iconChainBroken = iconChainBroken;
	exports.iconCheck = iconCheck;
	exports.iconCheckCircle = iconCheckCircle;
	exports.iconCheckSquare = iconCheckSquare;
	exports.iconChevronDown = iconChevronDown;
	exports.iconChevronLeft = iconChevronLeft;
	exports.iconChevronRight = iconChevronRight;
	exports.iconChevronUp = iconChevronUp;
	exports.iconCircleRight = iconCircleRight;
	exports.iconCircleUp = iconCircleUp;
	exports.iconCrown = iconCrown;
	exports.iconClipboardDisable = iconClipboardDisable;
	exports.iconClipboard = iconClipboard;
	exports.iconClock = iconClock;
	exports.iconCloudDownload = iconCloudDownload;
	exports.iconCoffee = iconCoffee;
	exports.iconComment = iconComment;
	exports.iconContrast = iconContrast;
	exports.iconDashboard = iconDashboard;
	exports.iconDesktop = iconDesktop;
	exports.iconDesktopFullscreen = iconDesktopFullscreen;
	exports.iconDesktopRecord = iconDesktopRecord;
	exports.iconDesktopOne = iconDesktopOne;
	exports.iconDownload = iconDownload;
	exports.iconEdit = iconEdit;
	exports.iconEnvelope = iconEnvelope;
	exports.iconEraser = iconEraser;
	exports.iconExclamation = iconExclamation;
	exports.iconExtensionBlock = iconExtensionBlock;
	exports.iconDesktopAppCheck = iconDesktopAppCheck;
	exports.iconExternal = iconExternal;
	exports.iconEye = iconEye;
	exports.iconEyeSlash = iconEyeSlash;
	exports.iconFiles = iconFiles;
	exports.iconFolder = iconFolder;
	exports.iconFont = iconFont;
	exports.iconGraph = iconGraph;
	exports.iconHourglass = iconHourglass;
	exports.iconGear = iconGear;
	exports.iconCopy = iconCopy;
	exports.iconID = iconID;
	exports.iconIDBack = iconIDBack;
	exports.iconImport = iconImport;
	exports.iconInbox = iconInbox;
	exports.iconInfo = iconInfo;
	exports.iconLaptop = iconLaptop;
	exports.iconLightbulb = iconLightbulb;
	exports.iconLink = iconLink;
	exports.iconList = iconList;
	exports.iconLock = iconLock;
	exports.iconMapMarker = iconMapMarker;
	exports.iconGoogle = iconGoogle;
	exports.iconYahoo = iconYahoo;
	exports.iconMicrophone = iconMicrophone;
	exports.iconMicrosoft = iconMicrosoft;
	exports.iconMinus = iconMinus;
	exports.iconMinusHybrid = iconMinusHybrid;
	exports.iconPlusHybrid = iconPlusHybrid;
	exports.iconPicture = iconPicture;
	exports.iconMobile = iconMobile;
	exports.iconMoon = iconMoon;
	exports.iconNo = iconNo;
	exports.iconPage = iconPage;
	exports.iconPerson = iconPerson;
	exports.iconPaper = iconPaper;
	exports.iconPaperclip = iconPaperclip;
	exports.iconPause = iconPause;
	exports.iconPencil = iconPencil;
	exports.iconPencilPaper = iconPencilPaper;
	exports.iconPhone = iconPhone;
	exports.iconPlay = iconPlay;
	exports.iconPlus = iconPlus;
	exports.iconPower = iconPower;
	exports.iconPrint = iconPrint;
	exports.iconPrintDisable = iconPrintDisable;
	exports.iconQuestion = iconQuestion;
	exports.iconRandom = iconRandom;
	exports.iconRedo = iconRedo;
	exports.iconRefresh = iconRefresh;
	exports.iconReply = iconReply;
	exports.iconRightClickDisable = iconRightClickDisable;
	exports.iconScale = iconScale;
	exports.iconSettings = iconSettings;
	exports.iconStop = iconStop;
	exports.iconTabsClose = iconTabsClose;
	exports.iconTabsOne = iconTabsOne;
	exports.iconTimes = iconTimes;
	exports.iconTimesCircle = iconTimesCircle;
	exports.iconTrash = iconTrash;
	exports.iconTrash2 = iconTrash2;
	exports.iconUndo = iconUndo;
	exports.iconUnlock = iconUnlock;
	exports.iconUniversity = iconUniversity;
	exports.iconUpload = iconUpload;
	exports.iconUser = iconUser;
	exports.iconUsers = iconUsers;
	exports.iconVideoCamera = iconVideoCamera;
	exports.iconVideoCamera360 = iconVideoCamera360;
	exports.iconVolumeOff = iconVolumeOff;
	exports.iconVolumeUp = iconVolumeUp;
	exports.iconWifi = iconWifi;
	exports.iconWindows = iconWindows;
	exports.iconAttended = iconAttended;
	exports.iconUnattended = iconUnattended;
	exports.iconIndividual = iconIndividual;
	exports.iconInstructor = iconInstructor;
	exports.iconTestingCenters = iconTestingCenters;
	exports.iconCentersIndivuals = iconCentersIndivuals;
	exports.iconExamity = iconExamity;
	exports.iconProctorU = iconProctorU;
	exports.icon_injured = icon_injured;
	exports.icon_technical = icon_technical;
	exports.icon_space = icon_space;
	exports.icon_outside_help = icon_outside_help;
	exports.icon_non_permitted_items = icon_non_permitted_items;
	exports.icon_noisy = icon_noisy;
	exports.icon_ill = icon_ill;
	exports.icon_time = icon_time;
	exports.icon_other = icon_other;
	exports.icon_file = icon_file;
	exports.icon_image = icon_image;
	exports.icon_pdf = icon_pdf;
	exports.icon_text = icon_text;
	exports.icon_spreadsheet = icon_spreadsheet;
	exports.icon_video = icon_video;
	exports.icon_audio = icon_audio;
	exports.icon_zip = icon_zip;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function iconAccess() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-access", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-access-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-access-title" },
	      "Access"
	    ),
	    _react2.default.createElement("path", { d: "M1374 657q-6-26-28.5-39.5t-48.5-7.5q-261 62-401 62t-401-62q-26-6-48.5 7.5t-28.5 39.5 7.5 48.5 39.5 28.5q194 46 303 58-2 158-15.5 269t-26.5 155.5-41 115.5l-9 21q-10 25 1 49t36 34q9 4 23 4 44 0 60-41l8-20q54-139 71-259h42q17 120 71 259l8 20q16 41 60 41 14 0 23-4 25-10 36-34t1-49l-9-21q-28-71-41-115.5t-26.5-155.5-15.5-269q109-12 303-58 26-6 39.5-28.5t7.5-48.5zm-350-145q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm576 384q0 143-55.5 273.5t-150 225-225 150-273.5 55.5-273.5-55.5-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5zm-704-768q-156 0-298 61t-245 164-164 245-61 298 61 298 164 245 245 164 298 61 298-61 245-164 164-245 61-298-61-298-164-245-245-164-298-61zm896 768q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z" })
	  );
	}
	
	function iconApple() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-apple", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-apple-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-apple-title" },
	      "Apple"
	    ),
	    _react2.default.createElement("path", { d: "M1585 1215q-39 125-123 250-129 196-257 196-49 0-140-32-86-32-151-32-61 0-142 33-81 34-132 34-152 0-301-259-147-261-147-503 0-228 113-374 113-144 284-144 72 0 177 30 104 30 138 30 45 0 143-34 102-34 173-34 119 0 213 65 52 36 104 100-79 67-114 118-65 94-65 207 0 124 69 223t158 126zm-376-1173q0 61-29 136-30 75-93 138-54 54-108 72-37 11-104 17 3-149 78-257 74-107 250-148 1 3 2.5 11t2.5 11q0 4 .5 10t.5 10z" })
	  );
	}
	
	function iconArchive() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-archive", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-archive-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-archive-title" },
	      "Archive"
	    ),
	    _react2.default.createElement("path", { d: "M1088 832q0-26-19-45t-45-19h-256q-26 0-45 19t-19 45 19 45 45 19h256q26 0 45-19t19-45zm576-192v960q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-960q0-26 19-45t45-19h1408q26 0 45 19t19 45zm64-448v256q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1536q26 0 45 19t19 45z" })
	  );
	}
	
	function iconArrow() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-arrow", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-arrow-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-arrow-title" },
	      "Arrow"
	    ),
	    _react2.default.createElement("path", { d: "M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z" })
	  );
	}
	
	function iconBarChart() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-bar-chart", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-bar-chart-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-bar-chart-title" },
	      "Bar Chart"
	    ),
	    _react2.default.createElement("path", { d: "M640 896v512h-256v-512h256zm384-512v1024h-256v-1024h256zm1024 1152v128h-2048v-1536h128v1408h1920zm-640-896v768h-256v-768h256zm384-384v1152h-256v-1152h256z" })
	  );
	}
	
	function iconBadgeCheck() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-badge-check", xmlns: "http://www.w3.org/2000/svg", width: "128", height: "128", viewBox: "0 0 128 128", "aria-labelledby": "icn-badge-check-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-badge-check-title" },
	      "Badge check"
	    ),
	    _react2.default.createElement("path", { d: "M75.2372 7.50677L64 0L52.7628 7.50677L39.5083 4.87171L31.9992 16.1074L18.7452 18.7452L16.1074 31.9992L4.87171 39.5083L7.50677 52.7628L0 64L7.50677 75.2372L4.87171 88.4917L16.1074 96.0008L18.7452 109.255L31.9992 111.893L39.5083 123.128L52.7628 120.493L64 128L75.2372 120.493L88.4917 123.128L96.0008 111.893L109.255 109.255L111.893 96.0008L123.128 88.4917L120.493 75.2372L128 64L120.493 52.7628L123.128 39.5083L111.893 31.9992L109.255 18.7452L96.0008 16.1074L88.4917 4.87171L75.2372 7.50677ZM55.7487 71.6413L87.9221 39.468L97.2029 48.7487L65.0295 80.9221L55.7487 90.2029L31 65.4541L40.2808 56.1734L55.7487 71.6413Z" })
	  );
	}
	
	function iconCalendar() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-calendar", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-calendar-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-calendar-title" },
	      "Calendar"
	    ),
	    _react2.default.createElement("path", { d: "M192 1664h288v-288h-288v288zm352 0h320v-288h-320v288zm-352-352h288v-320h-288v320zm352 0h320v-320h-320v320zm-352-384h288v-288h-288v288zm736 736h320v-288h-320v288zm-384-736h320v-288h-320v288zm768 736h288v-288h-288v288zm-384-352h320v-320h-320v320zm-352-864v-288q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zm736 864h288v-320h-288v320zm-384-384h320v-288h-320v288zm384 0h288v-288h-288v288zm32-480v-288q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zm384-64v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z" })
	  );
	}
	
	function iconUSD() {
	  return _react2.default.createElement(
	    "svg",
	    { className: "icn icn-usd", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-usd-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-usd-title" },
	      "USD"
	    ),
	    _react2.default.createElement("path", { d: "M1362 1185q0 153-99.5 263.5t-258.5 136.5v175q0 14-9 23t-23 9h-135q-13 0-22.5-9.5t-9.5-22.5v-175q-66-9-127.5-31t-101.5-44.5-74-48-46.5-37.5-17.5-18q-17-21-2-41l103-135q7-10 23-12 15-2 24 9l2 2q113 99 243 125 37 8 74 8 81 0 142.5-43t61.5-122q0-28-15-53t-33.5-42-58.5-37.5-66-32-80-32.5q-39-16-61.5-25t-61.5-26.5-62.5-31-56.5-35.5-53.5-42.5-43.5-49-35.5-58-21-66.5-8.5-78q0-138 98-242t255-134v-180q0-13 9.5-22.5t22.5-9.5h135q14 0 23 9t9 23v176q57 6 110.5 23t87 33.5 63.5 37.5 39 29 15 14q17 18 5 38l-81 146q-8 15-23 16-14 3-27-7-3-3-14.5-12t-39-26.5-58.5-32-74.5-26-85.5-11.5q-95 0-155 43t-60 111q0 26 8.5 48t29.5 41.5 39.5 33 56 31 60.5 27 70 27.5q53 20 81 31.5t76 35 75.5 42.5 62 50 53 63.5 31.5 76.5 13 94z" })
	  );
	}
	
	function iconCalendarPlus() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-calendar-plus", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-calendar-plus-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-calendar-plus-title" },
	      "Calendar Plus"
	    ),
	    _react2.default.createElement("path", { d: "M1536 256q52 0 90 38t38 90v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128zm-384-96v288q0 14 9 23t23 9h64q14 0 23-9t9-23v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zm-768 0v288q0 14 9 23t23 9h64q14 0 23-9t9-23v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zm1152 1504v-1024h-1408v1024h1408zm-640-576h224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-224h-224q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-224q0-14 9-23t23-9h64q14 0 23 9t9 23v224z" })
	  );
	}
	
	function iconCalendarTimes() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-calendar-times", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-calendar-times-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-calendar-times-title" },
	      "Calendar Times"
	    ),
	    _react2.default.createElement("path", { d: "M1111 1385l-46 46q-9 9-22 9t-23-9l-188-189-188 189q-10 9-23 9t-22-9l-46-46q-9-9-9-22t9-23l189-188-189-188q-9-10-9-23t9-22l46-46q9-9 22-9t23 9l188 188 188-188q10-9 23-9t22 9l46 46q9 9 9 22t-9 23l-188 188 188 188q9 10 9 23t-9 22zm-983 279h1408v-1024h-1408v1024zm384-1216v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zm768 0v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zm384-64v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z" })
	  );
	}
	
	function iconCamera() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-camera", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2000 2000", "aria-labelledby": "icn-camera-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-camera-title" },
	      "Camera"
	    ),
	    _react2.default.createElement("path", { d: "M1024 672q119 0 203.5 84.5t84.5 203.5-84.5 203.5-203.5 84.5-203.5-84.5-84.5-203.5 84.5-203.5 203.5-84.5zm704-416q106 0 181 75t75 181v896q0 106-75 181t-181 75h-1408q-106 0-181-75t-75-181v-896q0-106 75-181t181-75h224l51-136q19-49 69.5-84.5t103.5-35.5h512q53 0 103.5 35.5t69.5 84.5l51 136h224zm-704 1152q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z" })
	  );
	}
	
	function iconCap() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-cap", xmlns: "http://www.w3.org/2000/svg", width: "2300", height: "1792", viewBox: "0 0 2300 1792", "aria-labelledby": "icn-cap-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-cap-title" },
	      "Cap"
	    ),
	    _react2.default.createElement("path", { transform: "translate(-20, 0)", d: "M1774 836l18 316q4 69-82 128t-235 93.5-323 34.5-323-34.5-235-93.5-82-128l18-316 574 181q22 7 48 7t48-7zm530-324q0 23-22 31l-1120 352q-4 1-10 1t-10-1l-652-206q-43 34-71 111.5t-34 178.5q63 36 63 109 0 69-58 107l58 433q2 14-8 25-9 11-24 11h-192q-15 0-24-11-10-11-8-25l58-433q-58-38-58-107 0-73 65-111 11-207 98-330l-333-104q-22-8-22-31t22-31l1120-352q4-1 10-1t10 1l1120 352q22 8 22 31z" })
	  );
	}
	
	function iconChainBroken() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-chain-broken", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-chain-broken-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-chain-broken-title" },
	      "Chain Broken"
	    ),
	    _react2.default.createElement("path", { d: "M503 1271l-256 256q-10 9-23 9-12 0-23-9-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23zm169 41v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm-224-224q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm1264 128q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-334-335q-21-21-42-56l239-18 273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67 0-40-28-68l-274-275 18-239q35 21 56 42l336 336q84 86 84 204zm-617-724l-239 18-273-274q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l274 274-18 240q-35-21-56-42l-336-336q-84-86-84-204 0-120 85-203l147-146q83-83 203-83 121 0 204 85l334 335q21 21 42 56zm633 84q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm-544-544v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm407 151l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23z" })
	  );
	}
	
	function iconCheck() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-check", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-check-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-check-title" },
	      "Check"
	    ),
	    _react2.default.createElement("path", { d: "M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z" })
	  );
	}
	
	function iconCheckCircle() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-check-circle", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-check-circle-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-check-circle-title" },
	      "Check"
	    ),
	    _react2.default.createElement("path", { d: "M1299 813l-422 422q-19 19-45 19t-45-19l-294-294q-19-19-19-45t19-45l102-102q19-19 45-19t45 19l147 147 275-275q19-19 45-19t45 19l102 102q19 19 19 45t-19 45zm141 83q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconCheckSquare() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-check-square", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-check-square-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-check-square-title" },
	      "Check"
	    ),
	    _react2.default.createElement("path", { d: "M1472 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z" })
	  );
	}
	
	function iconChevronDown() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-chevron-down", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-chevron-down-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-chevron-down-title" },
	      "Chevron Down"
	    ),
	    _react2.default.createElement("path", { d: "M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z" })
	  );
	}
	
	function iconChevronLeft() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-chevron-left", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-chevron-left-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-chevron-left-title" },
	      "Chevron Left"
	    ),
	    _react2.default.createElement("path", { d: "M1427 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z" })
	  );
	}
	
	function iconChevronRight() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-chevron-right", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-chevron-right-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-chevron-right-title" },
	      "Chevron Right"
	    ),
	    _react2.default.createElement("path", { d: "M1363 877l-742 742q-19 19-45 19t-45-19l-166-166q-19-19-19-45t19-45l531-531-531-531q-19-19-19-45t19-45l166-166q19-19 45-19t45 19l742 742q19 19 19 45t-19 45z" })
	  );
	}
	
	function iconChevronUp() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-chevron-up", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-chevron-up-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-chevron-up-title" },
	      "Chevron Up"
	    ),
	    _react2.default.createElement("path", { d: "M1683 1331l-166 165q-19 19-45 19t-45-19l-531-531-531 531q-19 19-45 19t-45-19l-166-165q-19-19-19-45.5t19-45.5l742-741q19-19 45-19t45 19l742 741q19 19 19 45.5t-19 45.5z" })
	  );
	}
	
	function iconCircleRight() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-circleRight", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-circleRight-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-circleRight-title" },
	      "Circle Right"
	    ),
	    _react2.default.createElement("path", { d: "M1413 896q0-27-18-45l-91-91-362-362q-18-18-45-18t-45 18l-91 91q-18 18-18 45t18 45l189 189h-502q-26 0-45 19t-19 45v128q0 26 19 45t45 19h502l-189 189q-19 19-19 45t19 45l91 91q18 18 45 18t45-18l362-362 91-91q18-18 18-45zm251 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconCircleUp() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-circleUp", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-circleUp-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-circleUp-title" },
	      "Circle Up"
	    ),
	    _react2.default.createElement("path", { d: "M1412 895q0-27-18-45l-362-362-91-91q-18-18-45-18t-45 18l-91 91-362 362q-18 18-18 45t18 45l91 91q18 18 45 18t45-18l189-189v502q0 26 19 45t45 19h128q26 0 45-19t19-45v-502l189 189q19 19 45 19t45-19l91-91q18-18 18-45zm252 1q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	function iconCrown() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 16 16", className: "icon icon--crown", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-crown-title" },
	      "Crown"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.5 5L0 3L1 10C0.447715 10 0 10.4477 0 11C0 11.5523 0.447716 12 1 12H13C13.5523 12 14 11.5523 14 11C14 10.4477 13.5523 10 13 10L14 3L9.5 5L7 0L4.5 5Z", fill: "currentColor" })
	  );
	}
	
	function iconClipboardDisable() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-clipboard-disable", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-clipboard-disable-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-clipboard-disable-title" },
	      "Clipboard Disable"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M61.4903 148.51L152 58L236 142H1138.36C1160.8 142 1179.87 149.854 1195.58 165.562C1211.29 181.271 1219.14 200.345 1219.14 222.786V498.804C1230.92 506.097 1241.02 513.951 1249.44 522.366L1592.78 865.705C1608.49 881.414 1621.95 902.732 1633.17 929.661C1644.39 956.589 1650 981.274 1650 1003.71V1556L1733 1639L1642.49 1729.51L1600.49 1687.51L1601 1687L120 206L119.49 206.51L61.4903 148.51ZM142 409.019V1353.79C142 1376.23 149.854 1395.3 165.562 1411.01C181.271 1426.72 200.345 1434.57 222.786 1434.57H680.571V1569.21C680.571 1591.65 688.426 1610.73 704.134 1626.44C719.842 1642.15 738.917 1650 761.357 1650H1382.98L1275.27 1542.29H788.286V1055.31L142 409.019ZM359.737 265.737L451.429 357.429H976.786C984.079 357.429 990.39 354.764 995.72 349.434C1001.05 344.105 1003.71 337.793 1003.71 330.5V276.643C1003.71 269.35 1001.05 263.038 995.72 257.709C990.39 252.379 984.079 249.714 976.786 249.714H384.357C377.064 249.714 370.753 252.379 365.423 257.709C362.957 260.175 361.062 262.851 359.737 265.737ZM788.286 694.286L1542.29 1448.29V1003.71H1192.21C1169.77 1003.71 1150.7 995.86 1134.99 980.152C1119.28 964.443 1111.43 945.369 1111.43 922.929V572.857H788.286V694.286ZM1219.14 896H1470.76L1219.14 644.386V896Z" })
	  );
	}
	
	function iconClipboard() {
	  return _react2.default.createElement(
	    "svg",
	    { className: "icn icn-clipboard", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-clipboard-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-clipboard-title" },
	      "Clipboard"
	    ),
	    _react2.default.createElement("path", { d: "M1400,224l-280,0c0,-123.515 -100.485,-224 -224,-224c-123.515,0 -224,100.485 -224,224l-280,0c-92.785,0 -168,75.215 -168,168l0,1232c0,92.785 75.215,168 168,168l1008,0c92.785,0 168,-75.215 168,-168l0,-1232c0,-92.785 -75.215,-168 -168,-168Zm-21,1400l-966,0c-11.52,0 -21,-9.48 -21,-21l0,-1190c0,-11.52 9.48,-21 21,-21l147,0l0,126c0,23.195 18.805,42 42,42l588,0c23.195,0 42,-18.805 42,-42l0,-126l147,0c11.52,0 21,9.48 21,21l0,1190c0,11.52 -9.48,21 -21,21Zm-483,-1484c46.392,0 84,37.607 84,84c0,46.392 -37.608,84 -84,84c-46.392,0 -84,-37.608 -84,-84c0,-46.392 37.608,-84 84,-84" })
	  );
	}
	
	function iconClock() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-clock", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-clock-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-clock-title" },
	      "Clock"
	    ),
	    _react2.default.createElement("path", { d: "M1024 544v448q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-352q0-14 9-23t23-9h64q14 0 23 9t9 23zm416 352q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconCloudDownload() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-cloud-download", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2000 2000", "aria-labelledby": "icn-cloud-download-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-cloud-download-title" },
	      "Cloud Download"
	    ),
	    _react2.default.createElement("path", { d: "M1344 928q0-14-9-23t-23-9h-224v-352q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v352h-224q-13 0-22.5 9.5t-9.5 22.5q0 14 9 23l352 352q9 9 23 9t23-9l351-351q10-12 10-24zm640 224q0 159-112.5 271.5t-271.5 112.5h-1088q-185 0-316.5-131.5t-131.5-316.5q0-130 70-240t188-165q-2-30-2-43 0-212 150-362t362-150q156 0 285.5 87t188.5 231q71-62 166-62 106 0 181 75t75 181q0 76-41 138 130 31 213.5 135.5t83.5 238.5z" })
	  );
	}
	
	function iconCoffee() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-coffee", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2000 2000", "aria-labelledby": "icn-coffee-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-coffee-title" },
	      "Coffee"
	    ),
	    _react2.default.createElement("path", { d: "M1728 640q0-80-56-136t-136-56h-64v384h64q80 0 136-56t56-136zm-1664 768h1792q0 106-75 181t-181 75h-1280q-106 0-181-75t-75-181zm1856-768q0 159-112.5 271.5t-271.5 112.5h-64v32q0 92-66 158t-158 66h-704q-92 0-158-66t-66-158v-736q0-26 19-45t45-19h1152q159 0 271.5 112.5t112.5 271.5z" })
	  );
	}
	
	function iconComment() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-comment", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-comment-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-comment-title" },
	      "Comment"
	    ),
	    _react2.default.createElement("path", { d: "M1792 896q0 174-120 321.5t-326 233-450 85.5q-70 0-145-8-198 175-460 242-49 14-114 22-17 2-30.5-9t-17.5-29v-1q-3-4-.5-12t2-10 4.5-9.5l6-9 7-8.5 8-9q7-8 31-34.5t34.5-38 31-39.5 32.5-51 27-59 26-76q-157-89-247.5-220t-90.5-281q0-130 71-248.5t191-204.5 286-136.5 348-50.5q244 0 450 85.5t326 233 120 321.5z" })
	  );
	}
	
	function iconContrast() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-contrast", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-contrast-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-contrast-title" },
	      "Contrast"
	    ),
	    _react2.default.createElement("path", { d: "M896 1440v-1088q-148 0-273 73t-198 198-73 273 73 273 198 198 273 73zm768-544q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconDashboard() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-dashboard", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-dashboard-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-dashboard-title" },
	      "Dashboard"
	    ),
	    _react2.default.createElement("path", { d: "M384 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm192-448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm428 481l101-382q6-26-7.5-48.5t-38.5-29.5-48 6.5-30 39.5l-101 382q-60 5-107 43.5t-63 98.5q-20 77 20 146t117 89 146-20 89-117q16-60-6-117t-72-91zm660-33q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm-640-640q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm448 192q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm320 448q0 261-141 483-19 29-54 29h-1402q-35 0-54-29-141-221-141-483 0-182 71-348t191-286 286-191 348-71 348 71 286 191 191 286 71 348z" })
	  );
	}
	
	function iconDesktop() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-desktop", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-desktop-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-desktop-title" },
	      "Desktop"
	    ),
	    _react2.default.createElement("path", { transform: "translate(65, 0)", d: "M1728 992v-832q0-13-9.5-22.5t-22.5-9.5h-1600q-13 0-22.5 9.5t-9.5 22.5v832q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5zm128-832v1088q0 66-47 113t-113 47h-544q0 37 16 77.5t32 71 16 43.5q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45q0-14 16-44t32-70 16-78h-544q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1600q66 0 113 47t47 113z" })
	  );
	}
	
	function iconDesktopFullscreen() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-desktop-fullscreen", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-desktop-fullscreen-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-desktop-fullscreen-title" },
	      "Desktop"
	    ),
	    _react2.default.createElement("path", { d: "m1668.9 1044.1v-772.51c0-8.047-2.94-15.011-8.82-20.892-5.88-5.88-12.85-8.82-20.89-8.82h-1485.6c-8.047 0-15.011 2.94-20.892 8.82-5.88 5.881-8.82 12.845-8.82 20.892v772.51c0 8.05 2.94 15.01 8.82 20.89 5.881 5.88 12.845 8.82 20.892 8.82h1485.6c8.04 0 15.01-2.94 20.89-8.82s8.82-12.84 8.82-20.89zm118.85-772.51v1010.2c0 40.86-14.55 75.83-43.64 104.93-29.1 29.09-64.07 43.63-104.92 43.63h-505.11c0 22.91 4.95 46.89 14.86 71.96 9.9 25.07 19.81 47.05 29.71 65.93s14.86 32.34 14.86 40.39c0 16.09-5.88 30.02-17.64 41.78-11.77 11.76-25.69 17.64-41.79 17.64h-475.39c-16.094 0-30.021-5.88-41.782-17.64s-17.642-25.69-17.642-41.78c0-8.67 4.952-22.29 14.856-40.86s19.808-40.23 29.712-64.99 14.856-48.9 14.856-72.43h-505.1c-40.854 0-75.828-14.54-104.92-43.63-29.093-29.1-43.639-64.07-43.639-104.93v-1010.2c0-40.854 14.546-75.828 43.639-104.92s64.067-43.639 104.92-43.639h1485.6c40.85 0 75.82 14.546 104.92 43.639 29.09 29.093 43.64 64.067 43.64 104.92zm-317.59 55.5c6.81 0 13.62 0.028 20.43 0.056h0.01c13.6 0.056 27.19 0.113 40.78-0.056 22.6-0.339 30.13 5.542 30.42 27.502 0.34 27.236 0.23 54.472 0.12 81.733v0.019 0.069c-0.06 13.62-0.12 27.247-0.12 40.882 0 10.07-0.71 20.479-11.76 24.964-9.55 3.898-15.87-1.937-22.26-7.843-0.55-0.504-1.1-1.009-1.64-1.508-33.24-30.909-33.26-30.887-65.4 1.29l-0.06 0.064c-6.26 6.258-12.54 12.484-18.83 18.708v4e-3c-14.24 14.103-28.47 28.198-42.35 42.64-12.7 13.37-24.5 14.555-37.53 0.507-10.54-11.381-21.58-22.298-32.84-32.918-13.2-12.439-11.97-23.779 0.47-36.049 10.45-10.314 20.74-20.777 31.04-31.24v-4e-3c15.89-16.148 31.78-32.294 48.21-47.879 12.35-11.762 12.06-20.098-0.59-30.591-8.18-6.71-15.55-14.349-21.96-22.763-9.86-13.117-4.45-25.387 12.01-26.318 16.73-0.801 33.5-0.625 50.34-0.447 7.19 0.075 14.38 0.151 21.59 0.151l-0.08-0.973zm-1239.7 67.655c-0.028 7.264-0.056 14.527-0.056 21.791 0 7.377-0.117 14.759-0.234 22.138v3e-3c-0.262 16.528-0.523 33.039 0.53 49.45 1.185 19.167 14.005 23.948 28.856 11.762 8.221-6.656 15.762-14.111 22.51-22.256 10.282-12.651 18.152-10.831 28.814 0.297 13.664 14.327 27.81 28.233 41.937 42.121l2e-3 1e-3 1e-3 2e-3c11.989 11.785 23.964 23.556 35.617 35.559 13.497 13.836 25.81 15.275 39.477 0.635 10.197-10.832 20.436-21.41 31.352-31.31 14.09-12.863 13.202-24.88 0-37.573-19.167-18.49-38.291-37.319-56.824-56.57-3.535-3.719-7.864-7.198-12.2-10.683-9.676-7.777-19.386-15.58-20.38-26.128-0.848-9.079 7.888-16.078 16.756-23.183 4.4-3.525 8.832-7.076 12.143-10.92l0.23-0.268c5.596-6.512 11.222-13.059 7.048-22.2-3.724-7.997-11.594-9.52-19.717-9.52h-133.03c-15.866-0.042-23.102 7.405-22.89 23.272 0.169 14.526 0.113 29.053 0.056 43.58zm1328.6 477.05v67.698c0 13.963-6.94 20.86-20.69 20.902h-135.4c-8.25 0-15.57-2.327-19.38-10.239s0.51-14.851 6.14-20.733c0.32-0.355 0.67-0.69 1.01-1.047 0.14-0.154 0.29-0.311 0.42-0.476 3.29-4.081 7.81-7.734 12.27-11.343 8.54-6.904 16.89-13.649 16-22.929-0.9-8.206-9.73-15.606-18.47-22.936v-1e-3c-3.61-3.026-7.2-6.039-10.22-9.093-2.11-2.142-4.22-4.285-6.33-6.429l-0.01-0.015c-17.65-17.918-35.3-35.849-53.36-53.342-13.84-13.413-15.49-25.598 0-39.053 11.09-9.798 21.65-20.194 31.61-31.142 12.69-13.92 24.11-13.878 37.36-0.211 11.27 11.633 22.86 22.957 34.44 34.274 14.11 13.791 28.22 27.571 41.72 41.886 12.9 13.794 22.89 16.925 35.03 0.423 4.07-4.883 8.54-9.413 13.37-13.539 0.81-0.776 1.61-1.58 2.41-2.387 6.2-6.235 12.57-12.642 22.98-7.472 9.99 4.978 9.84 14.209 9.68 23.423-0.01 0.811-0.03 1.622-0.03 2.43v61.224l-0.55 0.127zm-1261.4 88.797c7.278 0.028 14.555 0.057 21.833 0.057v0.338h69.729c8.293 0 15.486-1.988 18.913-10.451 3.047-7.785-0.719-13.709-5.754-18.998-7.024-7.912-14.512-15.401-22.425-22.425-11.636-9.731-10.155-17.22 0.254-27.333 16.815-16.345 33.243-33.109 49.682-49.884 10.201-10.409 20.405-20.822 30.709-31.142 11.594-11.594 12.652-22.764 0.551-34.569-12.102-11.805-24.583-24.286-35.669-36.134-11.086-11.847-21.452-11.339-32.538 0-19.745 20.112-39.688 40.041-59.828 59.786-3.23 3.171-6.394 6.822-9.572 10.489-8.142 9.398-16.376 18.899-26.054 20.695-9.023 1.674-16.049-7.156-23.207-16.153-3.516-4.419-7.064-8.878-10.896-12.153-0.262-0.224-0.523-0.448-0.785-0.672-6.366-5.453-12.617-10.807-21.64-6.987-9.393 3.977-10.155 12.651-10.155 21.41v131.16c-0.085 15.74 7.108 23.314 23.187 23.018 14.555-0.17 29.11-0.113 43.665-0.057z", clipRule: "evenodd", fillRule: "evenodd" })
	  );
	}
	
	function iconDesktopRecord() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-desktop-record", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-desktop-record-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-desktop-record-title" },
	      "Record Desktop"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1663.87 148.56V921.069C1663.87 929.116 1660.93 936.08 1655.05 941.961C1649.17 947.841 1642.2 950.781 1634.16 950.781H148.56C140.513 950.781 133.549 947.841 127.668 941.961C121.788 936.08 118.848 929.116 118.848 921.069V148.56C118.848 140.513 121.788 133.549 127.668 127.668C133.549 121.788 140.513 118.848 148.56 118.848H1634.16C1642.2 118.848 1649.17 121.788 1655.05 127.668C1660.93 133.549 1663.87 140.513 1663.87 148.56ZM1782.72 1158.76V148.56C1782.72 107.706 1768.17 72.7323 1739.08 43.6394C1709.98 14.5464 1675.01 -2.28882e-05 1634.16 -2.28882e-05H148.56C107.706 -2.28882e-05 72.7323 14.5464 43.6394 43.6394C14.5465 72.7323 0 107.706 0 148.56V1158.76C0 1199.62 14.5465 1234.59 43.6394 1263.68C72.7323 1292.78 107.706 1307.32 148.56 1307.32H653.662C653.662 1330.85 648.71 1354.99 638.806 1379.75C628.902 1404.51 618.998 1426.17 609.094 1444.74C599.19 1463.31 594.238 1476.93 594.238 1485.6C594.238 1501.69 600.119 1515.62 611.88 1527.38C623.641 1539.14 637.568 1545.02 653.662 1545.02H1129.05C1145.15 1545.02 1159.07 1539.14 1170.84 1527.38C1182.6 1515.62 1188.48 1501.69 1188.48 1485.6C1188.48 1477.55 1183.52 1464.09 1173.62 1445.21C1163.72 1426.33 1153.81 1404.35 1143.91 1379.28C1134 1354.21 1129.05 1330.23 1129.05 1307.32H1634.16C1675.01 1307.32 1709.98 1292.78 1739.08 1263.68C1768.17 1234.59 1782.72 1199.62 1782.72 1158.76ZM1241 756.5V331.5C1241 320.563 1235.92 312.88 1225.77 308.453C1222.38 307.151 1219.12 306.5 1216 306.5C1208.97 306.5 1203.11 308.974 1198.42 313.922L1041 470.953V406.5C1041 375.51 1030 349.013 1007.99 327.008C985.987 305.003 959.49 294 928.5 294H653.5C622.51 294 596.013 305.003 574.008 327.008C552.003 349.013 541 375.51 541 406.5V681.5C541 712.49 552.003 738.987 574.008 760.992C596.013 782.997 622.51 794 653.5 794H928.5C959.49 794 985.987 782.997 1007.99 760.992C1030 738.987 1041 712.49 1041 681.5V616.656L1198.42 774.078C1203.11 779.026 1208.97 781.5 1216 781.5C1219.12 781.5 1222.38 780.849 1225.77 779.547C1235.92 775.12 1241 767.437 1241 756.5Z" })
	  );
	}
	
	function iconDesktopOne() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-desktop-one", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-desktop-one-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-desktop-one-title" },
	      "Only One Display"
	    ),
	    _react2.default.createElement("path", { d: "m1188.7 1169.4v-548c0-5.709-2.08-10.649-6.25-14.82-4.17-4.172-9.11-6.257-14.81-6.257h-1053.3c-5.705 0-10.643 2.085-14.812 6.257-4.1694 4.171-6.2541 9.111-6.2541 14.82v548c0 5.71 2.0847 10.65 6.2541 14.82 4.1692 4.18 9.1072 6.26 14.812 6.26h1053.3c5.7 0 10.64-2.08 14.81-6.26 4.17-4.17 6.25-9.11 6.25-14.82zm84.27-548v716.62c0 28.98-10.31 53.79-30.94 74.43s-45.43 30.95-74.39 30.95h-358.14c0 16.25 3.511 33.27 10.534 51.05 7.022 17.78 14.044 33.37 21.066 46.76 7.023 13.4 10.534 22.95 10.534 28.66 0 11.41-4.17 21.29-12.509 29.64-8.339 8.34-18.214 12.51-29.625 12.51h-337.07c-11.411 0-21.286-4.17-29.625-12.51-8.339-8.35-12.509-18.23-12.509-29.64 0-6.15 3.511-15.81 10.534-28.98 7.022-13.18 14.044-28.55 21.066-46.11 7.023-17.56 10.534-34.69 10.534-51.38h-358.13c-28.966 0-53.764-10.31-74.391-30.95-20.628-20.64-30.942-45.45-30.942-74.43v-716.62c0-28.981 10.314-53.79 30.942-74.428 20.628-20.638 45.425-30.957 74.391-30.957h1053.3c28.96 0 53.76 10.319 74.39 30.957s30.94 45.447 30.94 74.428zm-845 134.41l62.797-62.797 150.2 150.2 150.2-150.2 62.797 62.797-150.2 150.2 150.2 150.2-62.797 62.8-150.2-150.2-150.2 150.2-62.797-62.8 150.2-150.2-150.2-150.2z", clipRule: "evenodd", fillRule: "evenodd" }),
	    _react2.default.createElement("path", { d: "m1696.7 285.38v548c0 5.708-2.08 10.648-6.25 14.819-4.17 4.172-9.11 6.258-14.81 6.258h-455.67v353.54h-272.77c-5.93 11.58-8.895 20.2-8.895 25.85 0 11.41 4.17 21.29 12.509 29.64 8.339 8.34 18.214 12.51 29.625 12.51h337.06c11.41 0 21.29-4.17 29.63-12.51 8.34-8.35 12.51-18.23 12.51-29.64 0-5.71-3.51-15.26-10.54-28.66-7.02-13.39-14.04-28.98-21.06-46.76-7.03-17.78-10.54-34.8-10.54-51.05h358.14c28.96 0 53.76-10.31 74.39-30.95s30.94-45.45 30.94-74.43v-716.62c0-28.981-10.31-53.79-30.94-74.428s-45.43-30.957-74.39-30.957h-1053.3c-28.966 0-53.764 10.319-74.391 30.957-20.628 20.638-30.942 45.447-30.942 74.428v308.62h84.267v-308.62c0-5.709 2.084-10.649 6.254-14.82 4.169-4.172 9.107-6.257 14.812-6.257h1053.3c5.7 0 10.64 2.085 14.81 6.257 4.17 4.171 6.25 9.111 6.25 14.82z", clipRule: "evenodd", fillRule: "evenodd" })
	  );
	}
	
	function iconDownload() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-download", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-download-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-download-title" },
	      "Download"
	    ),
	    _react2.default.createElement("path", { d: "M1344 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h465l135 136q58 56 136 56t136-56l136-136h464q40 0 68 28t28 68zm-325-569q17 41-14 70l-448 448q-18 19-45 19t-45-19l-448-448q-31-29-14-70 17-39 59-39h256v-448q0-26 19-45t45-19h256q26 0 45 19t19 45v448h256q42 0 59 39z" })
	  );
	}
	
	function iconEdit() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-edit", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-edit-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-edit-title" },
	      "Edit"
	    ),
	    _react2.default.createElement("path", { d: "M888 1184l116-116-152-152-116 116v56h96v96h56zm440-720q-16-16-33 1l-350 350q-17 17-1 33t33-1l350-350q17-17 1-33zm80 594v190q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-14 14-32 8-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-126q0-13 9-22l64-64q15-15 35-7t20 29zm-96-738l288 288-672 672h-288v-288zm444 132l-92 92-288-288 92-92q28-28 68-28t68 28l152 152q28 28 28 68t-28 68z" })
	  );
	}
	
	function iconEnvelope() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-envelope", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-envelope-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-envelope-title" },
	      "Envelope"
	    ),
	    _react2.default.createElement("path", { d: "M1664 1504v-768q-32 36-69 66-268 206-426 338-51 43-83 67t-86.5 48.5-102.5 24.5h-2q-48 0-102.5-24.5t-86.5-48.5-83-67q-158-132-426-338-37-30-69-66v768q0 13 9.5 22.5t22.5 9.5h1472q13 0 22.5-9.5t9.5-22.5zm0-1051v-24.5l-.5-13-3-12.5-5.5-9-9-7.5-14-2.5h-1472q-13 0-22.5 9.5t-9.5 22.5q0 168 147 284 193 152 401 317 6 5 35 29.5t46 37.5 44.5 31.5 50.5 27.5 43 9h2q20 0 43-9t50.5-27.5 44.5-31.5 46-37.5 35-29.5q208-165 401-317 54-43 100.5-115.5t46.5-131.5zm128-37v1088q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1472q66 0 113 47t47 113z" })
	  );
	}
	
	function iconEraser() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-eraser", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-eraser-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-eraser-title" },
	      "Eraser"
	    ),
	    _react2.default.createElement("path", { d: "M1710.66 956.391C1773.78 893.294 1773.78 790.992 1710.66 727.895L1171.91 189.324C1108.79 126.227 1006.46 126.224 943.337 189.324L81.3384 1051.04C18.2205 1114.14 18.2205 1216.44 81.3384 1279.53L404.588 1602.68C434.9 1632.98 476.01 1650 518.877 1650H1717.59C1739.91 1650 1758 1631.91 1758 1609.61V1474.96C1758 1452.66 1739.91 1434.57 1717.59 1434.57H1232.33L1710.66 956.391V956.391ZM691.66 745.584L1154.22 1207.99L927.562 1434.57H541.195L271.82 1165.29L691.66 745.584V745.584Z" })
	  );
	}
	
	function iconExclamation() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-exclamation", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-exclamation-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-exclamation-title" },
	      "Exclamation"
	    ),
	    _react2.default.createElement("path", { d: "M1024 1375v-190q0-14-9.5-23.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 23.5v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zm-2-374l18-459q0-12-10-19-13-11-24-11h-220q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zm-14-934l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17h-1536q-34 0-63.5-17t-46.5-46q-37-63-2-126l768-1408q17-31 47-49t65-18 65 18 47 49z" })
	  );
	}
	
	function iconExtensionBlock() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-extension", width: "1566", height: "1565", viewBox: "0 0 1566 1565", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": "icn-extension-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-extension-title" },
	      "Blocked Extension"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M91.5391 0L0.769531 90.7695L1475 1565L1565.77 1474.23L1368.86 1277.32C1368.95 1275.12 1369 1272.92 1369 1270.7V1019.05H1354.89C1262.76 1019.05 1188.08 944.371 1188.08 852.245C1188.08 760.119 1262.76 685.436 1354.89 685.436H1369V433.791C1369 350.948 1301.84 283.791 1219 283.791H926.829V229.474C926.829 137.348 852.146 62.665 760.02 62.665C667.893 62.665 593.21 137.348 593.21 229.474V283.791H375.33L91.5391 0ZM159 433.791C159 429.651 159.168 425.551 159.497 421.497L1158.7 1420.7H926.829V1406.59C926.829 1314.46 852.146 1239.78 760.02 1239.78C667.894 1239.78 593.21 1314.46 593.21 1406.59V1420.7H309C226.157 1420.7 159 1353.54 159 1270.7V1019.05H173.112C265.238 1019.05 339.921 944.371 339.921 852.245C339.921 760.119 265.238 685.436 173.112 685.436H159V433.791Z" })
	  );
	}
	
	function iconDesktopAppCheck() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-desktop-app-check", width: "288", height: "288", viewBox: "0 0 288 288", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": "icn-desktop-app-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-desktop-app-title" },
	      "Desktop App Check"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M156 51H171C178.992 51 183.012 60.708 177.36 66.36L150.36 93.36C148.608 95.124 146.304 96 144 96C141.696 96 139.392 95.124 137.64 93.36L110.64 66.36C104.988 60.708 109.008 51 117 51H132V12C132 5.376 137.376 0 144 0C150.624 0 156 5.376 156 12V51ZM84 120C84 133.236 94.764 144 108 144H180C193.236 144 204 133.236 204 120V108C204 101.376 198.624 96 192 96C185.376 96 180 101.376 180 108V120H108V108C108 101.376 102.624 96 96 96C89.376 96 84 101.376 84 108V120ZM201.696 48H267C278.58 48 288 57.42 288 69V231C288 242.58 278.58 252 267 252H174.948C176.436 258.024 180.276 267.78 190.248 277.752C191.952 279.468 192.468 282.048 191.544 284.292C190.62 286.536 188.424 288 186 288H102C99.576 288 97.38 286.536 96.456 284.292C95.52 282.048 96.036 279.468 97.752 277.752C107.748 267.768 111.48 258.012 112.896 252H21C9.42 252 0 242.58 0 231V69C0 57.42 9.42 48 21 48H86.304C83.208 55.896 83.328 64.416 86.304 72H24V204H264V72H201.696C204.66 64.416 204.78 55.896 201.696 48Z" })
	  );
	}
	
	function iconExternal() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-external", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-external-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-external-title" },
	      "External Link"
	    ),
	    _react2.default.createElement("path", { d: "M1408 928v320q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-320q0-14 9-23t23-9h64q14 0 23 9t9 23zm384-864v512q0 26-19 45t-45 19-45-19l-176-176-652 652q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l652-652-176-176q-19-19-19-45t19-45 45-19h512q26 0 45 19t19 45z" })
	  );
	}
	
	function iconEye() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-eye", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-eye-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-eye-title" },
	      "Eye"
	    ),
	    _react2.default.createElement("path", { d: "M1664 960q-152-236-381-353 61 104 61 225 0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-121 61-225-229 117-381 353 133 205 333.5 326.5t434.5 121.5 434.5-121.5 333.5-326.5zm-720-384q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zm848 384q0 34-20 69-140 230-376.5 368.5t-499.5 138.5-499.5-139-376.5-368q-20-35-20-69t20-69q140-229 376.5-368t499.5-139 499.5 139 376.5 368q20 35 20 69z" })
	  );
	}
	
	function iconEyeSlash() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-eye-slash", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-eye-slash-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-eye-slash-title" },
	      "Eye Slash"
	    ),
	    _react2.default.createElement("path", { d: "M555 1335l78-141q-87-63-136-159t-49-203q0-121 61-225-229 117-381 353 167 258 427 375zm389-759q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zm363-191q0 7-1 9-106 189-316 567t-315 566l-49 89q-10 16-28 16-12 0-134-70-16-10-16-28 0-12 44-87-143-65-263.5-173t-208.5-245q-20-31-20-69t20-69q153-235 380-371t496-136q89 0 180 17l54-97q10-16 28-16 5 0 18 6t31 15.5 33 18.5 31.5 18.5 19.5 11.5q16 10 16 27zm37 447q0 139-79 253.5t-209 164.5l280-502q8 45 8 84zm448 128q0 35-20 69-39 64-109 145-150 172-347.5 267t-419.5 95l74-132q212-18 392.5-137t301.5-307q-115-179-282-294l63-112q95 64 182.5 153t144.5 184q20 34 20 69z" })
	  );
	}
	
	function iconFiles() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-files", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-files-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-files-title" },
	      "Files"
	    ),
	    _react2.default.createElement("path", { d: "M1696 384q40 0 68 28t28 68v1216q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-288h-544q-40 0-68-28t-28-68v-672q0-40 20-88t48-76l408-408q28-28 76-48t88-20h416q40 0 68 28t28 68v328q68-40 128-40h416zm-544 213l-299 299h299v-299zm-640-384l-299 299h299v-299zm196 647l316-316v-416h-384v416q0 40-28 68t-68 28h-416v640h512v-256q0-40 20-88t48-76zm956 804v-1152h-384v416q0 40-28 68t-68 28h-416v640h896z" })
	  );
	}
	
	function iconFolder() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-folder", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-folder-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-folder-title" },
	      "Folder"
	    ),
	    _react2.default.createElement("path", { d: "M1943 952q0 31-31 66l-336 396q-43 51-120.5 86.5t-143.5 35.5h-1088q-34 0-60.5-13t-26.5-43q0-31 31-66l336-396q43-51 120.5-86.5t143.5-35.5h1088q34 0 60.5 13t26.5 43zm-343-344v160h-832q-94 0-197 47.5t-164 119.5l-337 396-5 6q0-4-.5-12.5t-.5-12.5v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h544q92 0 158 66t66 158z" })
	  );
	}
	
	function iconFont() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-font", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-font-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-font-title" },
	      "Font"
	    ),
	    _react2.default.createElement("path", { d: "M789 559l-170 450q33 0 136.5 2t160.5 2q19 0 57-2-87-253-184-452zm-725 1105l2-79q23-7 56-12.5t57-10.5 49.5-14.5 44.5-29 31-50.5l237-616 280-724h128q8 14 11 21l205 480q33 78 106 257.5t114 274.5q15 34 58 144.5t72 168.5q20 45 35 57 19 15 88 29.5t84 20.5q6 38 6 57 0 5-.5 13.5t-.5 12.5q-63 0-190-8t-191-8q-76 0-215 7t-178 8q0-43 4-78l131-28q1 0 12.5-2.5t15.5-3.5 14.5-4.5 15-6.5 11-8 9-11 2.5-14q0-16-31-96.5t-72-177.5-42-100l-450-2q-26 58-76.5 195.5t-50.5 162.5q0 22 14 37.5t43.5 24.5 48.5 13.5 57 8.5 41 4q1 19 1 58 0 9-2 27-58 0-174.5-10t-174.5-10q-8 0-26.5 4t-21.5 4q-80 14-188 14z" })
	  );
	}
	
	function iconGraph() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-graph", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-graph-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-graph-title" },
	      "Graph"
	    ),
	    _react2.default.createElement("path", { d: "M512 896v512h-256v-512h256zm384-512v1024h-256v-1024h256zm1024 1152v128h-2048v-1536h128v1408h1920zm-640-896v768h-256v-768h256zm384-384v1152h-256v-1152h256z" })
	  );
	}
	
	function iconHourglass() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-hourglass", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-hourglass-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-hourglass-title" },
	      "Hourglass"
	    ),
	    _react2.default.createElement("path", { d: "M1536 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zm-128 0h-1024q0 206 85 384h854q85-178 85-384zm-57 1216q-54-141-145.5-241.5t-194.5-142.5h-230q-103 42-194.5 142.5t-145.5 241.5h910z" })
	  );
	}
	function iconGear() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-gear", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-gear-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-gear-title" },
	      "Gear"
	    ),
	    _react2.default.createElement("path", { d: "M1152 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm512-109v222q0 12-8 23t-20 13l-185 28q-19 54-39 91 35 50 107 138 10 12 10 25t-9 23q-27 37-99 108t-94 71q-12 0-26-9l-138-108q-44 23-91 38-16 136-29 186-7 28-36 28h-222q-14 0-24.5-8.5t-11.5-21.5l-28-184q-49-16-90-37l-141 107q-10 9-25 9-14 0-25-11-126-114-165-168-7-10-7-23 0-12 8-23 15-21 51-66.5t54-70.5q-27-50-41-99l-183-27q-13-2-21-12.5t-8-23.5v-222q0-12 8-23t19-13l186-28q14-46 39-92-40-57-107-138-10-12-10-24 0-10 9-23 26-36 98.5-107.5t94.5-71.5q13 0 26 10l138 107q44-23 91-38 16-136 29-186 7-28 36-28h222q14 0 24.5 8.5t11.5 21.5l28 184q49 16 90 37l142-107q9-9 24-9 13 0 25 10 129 119 165 170 7 8 7 22 0 12-8 23-15 21-51 66.5t-54 70.5q26 50 41 98l183 28q13 2 21 12.5t8 23.5z" })
	  );
	}
	function iconCopy() {
	  return _react2.default.createElement(
	    "svg",
	    { className: "icn icn-copy", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-copy-title" },
	    _react2.default.createElement("path", { d: "M1696 384q40 0 68 28t28 68v1216q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-288h-544q-40 0-68-28t-28-68v-672q0-40 20-88t48-76l408-408q28-28 76-48t88-20h416q40 0 68 28t28 68v328q68-40 128-40h416zm-544 213l-299 299h299v-299zm-640-384l-299 299h299v-299zm196 647l316-316v-416h-384v416q0 40-28 68t-68 28h-416v640h512v-256q0-40 20-88t48-76zm956 804v-1152h-384v416q0 40-28 68t-68 28h-416v640h896z" })
	  );
	}
	
	function iconID() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-id", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2020 2020", "aria-labelledby": "icn-id-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-id-title" },
	      "ID"
	    ),
	    _react2.default.createElement("path", { d: "M896 1212q0 55-31.5 93.5t-75.5 38.5h-426q-44 0-75.5-38.5t-31.5-93.5q0-54 7.5-100.5t24.5-90 51-68.5 81-25q64 64 156 64t156-64q47 0 81 25t51 68.5 24.5 90 7.5 100.5zm-128-444q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1024 416v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23zm-384-256v64q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h320q14 0 23 9t9 23zm384 0v64q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h192q14 0 23 9t9 23zm0-256v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23zm128 832v-1120h-1792v1120q0 13 9.5 22.5t22.5 9.5h1728q13 0 22.5-9.5t9.5-22.5zm128-1216v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z" })
	  );
	}
	
	function iconIDBack() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-id-back", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2020 2020", "aria-labelledby": "icn-id-back-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-id-back-title" },
	      "ID Back"
	    ),
	    _react2.default.createElement("path", { d: "M1824 128q66 0 113 47t47 113v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600zm-1600 128q-13 0-22.5 9.5t-9.5 22.5v224h1664v-224q0-13-9.5-22.5t-22.5-9.5h-1600zm1600 1280q13 0 22.5-9.5t9.5-22.5v-608h-1664v608q0 13 9.5 22.5t22.5 9.5h1600zm-1504-128v-128h256v128h-256zm384 0v-128h384v128h-384z" })
	  );
	}
	
	function iconImport() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-import", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2020 2020", "aria-labelledby": "icn-import-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-import-title" },
	      "Import"
	    ),
	    _react2.default.createElement("path", { d: "M1344 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h465l135 136q58 56 136 56t136-56l136-136h464q40 0 68 28t28 68zm-325-569q17 41-14 70l-448 448q-18 19-45 19t-45-19l-448-448q-31-29-14-70 17-39 59-39h256v-448q0-26 19-45t45-19h256q26 0 45 19t19 45v448h256q42 0 59 39z" })
	  );
	}
	
	function iconInbox() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-inbox", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-inbox-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-inbox-title" },
	      "Inbox"
	    ),
	    _react2.default.createElement("path", { d: "M1151 960h316q-1-3-2.5-8.5t-2.5-7.5l-212-496h-708l-212 496q-1 3-2.5 8.5t-2.5 7.5h316l95 192h320zm513 30v482q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-482q0-62 25-123l238-552q10-25 36.5-42t52.5-17h832q26 0 52.5 17t36.5 42l238 552q25 61 25 123z" })
	  );
	}
	
	function iconInfo() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-info", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-info-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-info-title" },
	      "Info"
	    ),
	    _react2.default.createElement("path", { d: "M1216 1344v128q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h64v-384h-64q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h384q26 0 45 19t19 45v576h64q26 0 45 19t19 45zm-128-1152v192q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-192q0-26 19-45t45-19h256q26 0 45 19t19 45z" })
	  );
	}
	
	function iconLaptop() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-laptop", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1970 1970", "aria-labelledby": "icn-laptop-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-laptop-title" },
	      "Online"
	    ),
	    _react2.default.createElement("path", { d: "M480 1280q-66 0-113-47t-47-113v-704q0-66 47-113t113-47h1088q66 0 113 47t47 113v704q0 66-47 113t-113 47h-1088zm-32-864v704q0 13 9.5 22.5t22.5 9.5h1088q13 0 22.5-9.5t9.5-22.5v-704q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5zm1376 928h160v96q0 40-47 68t-113 28h-1600q-66 0-113-28t-47-68v-96h1760zm-720 96q16 0 16-16t-16-16h-160q-16 0-16 16t16 16h160z" })
	  );
	}
	
	function iconLightbulb() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-lightbulb", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-lightbulb-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-lightbulb-title" },
	      "Lightbulb"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M896 7C876.67 7 861 22.67 861 42V222C861 241.33 876.67 257 896 257C915.33 257 931 241.33 931 222V42C931 22.67 915.33 7 896 7ZM1078.24 741.435C1083.62 736.058 1086.31 729.691 1086.31 722.333C1086.31 692.903 1075.69 667.434 1054.45 645.927C1033.21 624.42 1008.57 609.139 980.536 600.083C952.499 591.028 924.32 586.5 896 586.5C888.637 586.5 882.265 589.188 876.884 594.565C871.503 599.942 868.812 606.309 868.812 613.667C868.812 621.024 871.503 627.391 876.884 632.768C882.265 638.145 888.637 640.833 896 640.833C925.453 640.833 955.473 647.908 986.059 662.057C1016.64 676.207 1031.94 696.299 1031.94 722.333C1031.94 729.691 1034.63 736.058 1040.01 741.435C1045.39 746.812 1051.76 749.5 1059.12 749.5C1066.49 749.5 1072.86 746.812 1078.24 741.435ZM1192.94 608.573C1212.48 643.663 1222.25 681.583 1222.25 722.333C1222.25 779.497 1202.99 830.434 1164.48 875.146C1158.81 881.372 1150.17 890.71 1138.56 903.161C1126.95 915.613 1118.31 924.951 1112.65 931.177C1040.15 1017.77 1000.22 1102.1 992.855 1184.17H799.145C791.781 1102.1 751.85 1017.77 679.35 931.177C673.686 924.951 665.048 915.613 653.437 903.161C641.825 890.71 633.188 881.372 627.523 875.146C589.008 830.434 569.75 779.497 569.75 722.333C569.75 681.583 579.521 643.663 599.062 608.573C618.603 573.483 644.091 544.76 675.526 522.404C706.962 500.048 741.796 482.503 780.028 469.768C818.261 457.034 856.918 450.667 896 450.667C935.082 450.667 973.739 457.034 1011.97 469.768C1050.2 482.503 1085.04 500.048 1116.47 522.404C1147.91 544.76 1173.4 573.483 1192.94 608.573ZM1243.49 949.854C1301.83 885.899 1331 810.059 1331 722.333C1331 666.302 1318.4 614.091 1293.19 565.701C1267.99 517.31 1234.85 477.126 1193.79 445.148C1152.72 413.171 1106.28 387.985 1054.45 369.591C1002.63 351.197 949.809 342 896 342C842.191 342 789.374 351.197 737.548 369.591C685.722 387.985 639.276 413.171 598.212 445.148C557.147 477.126 524.013 517.31 498.808 565.701C473.603 614.091 461 666.302 461 722.333C461 810.059 490.17 885.899 548.51 949.854C573.998 977.587 595.097 1002.21 611.806 1023.71C628.515 1045.22 645.365 1072.25 662.357 1104.79C679.35 1137.33 688.979 1167.75 691.244 1196.05C664.623 1211.9 651.312 1235.1 651.312 1265.67C651.312 1286.61 658.393 1304.72 672.553 1320C658.393 1335.28 651.312 1353.39 651.312 1374.33C651.312 1403.76 664.057 1426.69 689.545 1443.1C682.182 1456.12 678.5 1469.42 678.5 1483C678.5 1509.03 687.421 1529.13 705.263 1543.28C723.104 1557.43 745.053 1564.5 771.107 1564.5C782.436 1589.4 799.428 1609.21 822.084 1623.93C844.74 1638.64 869.379 1646 896 1646C922.621 1646 947.26 1638.64 969.916 1623.93C992.572 1609.21 1009.56 1589.4 1020.89 1564.5C1046.95 1564.5 1068.9 1557.43 1086.74 1543.28C1104.58 1529.13 1113.5 1509.03 1113.5 1483C1113.5 1469.42 1109.82 1456.12 1102.46 1443.1C1127.94 1426.69 1140.69 1403.76 1140.69 1374.33C1140.69 1353.39 1133.61 1335.28 1119.45 1320C1133.61 1304.72 1140.69 1286.61 1140.69 1265.67C1140.69 1235.1 1127.38 1211.9 1100.76 1196.05C1103.02 1167.75 1112.65 1137.33 1129.64 1104.79C1146.63 1072.25 1163.49 1045.22 1180.19 1023.71C1196.9 1002.21 1218 977.587 1243.49 949.854ZM184 789C164.67 789 149 773.33 149 754C149 734.67 164.67 719 184 719H364C383.33 719 399 734.67 399 754C399 773.33 383.33 789 364 789H184ZM1393 754C1393 773.33 1408.67 789 1428 789H1608C1627.33 789 1643 773.33 1643 754C1643 734.67 1627.33 719 1608 719H1428C1408.67 719 1393 734.67 1393 754ZM367.791 275.289C354.123 261.62 354.123 239.46 367.791 225.791C381.46 212.123 403.62 212.123 417.289 225.791L544.568 353.07C558.236 366.739 558.236 388.9 544.568 402.568C530.9 416.236 508.739 416.236 495.07 402.568L367.791 275.289ZM1247.43 1105.43C1233.76 1119.1 1233.76 1141.26 1247.43 1154.93L1374.71 1282.21C1388.38 1295.88 1410.54 1295.88 1424.21 1282.21C1437.88 1268.54 1437.88 1246.38 1424.21 1232.71L1296.93 1105.43C1283.26 1091.76 1261.1 1091.76 1247.43 1105.43ZM417.289 1282.21C403.62 1295.88 381.46 1295.88 367.791 1282.21C354.123 1268.54 354.123 1246.38 367.791 1232.71L495.07 1105.43C508.739 1091.76 530.9 1091.76 544.568 1105.43C558.236 1119.1 558.236 1141.26 544.568 1154.93L417.289 1282.21ZM1247.43 402.568C1261.1 416.236 1283.26 416.236 1296.93 402.568L1424.21 275.289C1437.88 261.62 1437.88 239.46 1424.21 225.791C1410.54 212.123 1388.38 212.123 1374.71 225.791L1247.43 353.07C1233.76 366.739 1233.76 388.9 1247.43 402.568Z" })
	  );
	}
	
	function iconLink() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-link", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-link-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-link-title" },
	      "Link"
	    ),
	    _react2.default.createElement("path", { d: "M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z" })
	  );
	}
	
	function iconList() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-list", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-list-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-list-title" },
	      "List"
	    ),
	    _react2.default.createElement("path", { d: "M256 1312v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm1536 768v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm-1536-1152v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zm1536 768v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5z" })
	  );
	}
	
	function iconLock() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-lock", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-lock-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-lock-title" },
	      "Lock"
	    ),
	    _react2.default.createElement("path", { d: "M640 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zm832 96v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z" })
	  );
	}
	
	function iconMapMarker() {
	  return _react2.default.createElement(
	    "svg",
	    { className: "icn icn-map-marker", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-map-marker-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-map-marker-title" },
	      "Map Marker"
	    ),
	    _react2.default.createElement("path", { d: "M1152 640q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm256 0q0 109-33 179l-364 774q-16 33-47.5 52t-67.5 19-67.5-19-46.5-52l-365-774q-33-70-33-179 0-212 150-362t362-150 362 150 150 362z" })
	  );
	}
	function iconGoogle() {
	  return _react2.default.createElement(
	    "svg",
	    { className: "icn icn-google", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-google-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-google-title" },
	      "Google"
	    ),
	    _react2.default.createElement("path", { d: "M896 786h725q12 67 12 128 0 217-91 387.5t-259.5 266.5-386.5 96q-157 0-299-60.5t-245-163.5-163.5-245-60.5-299 60.5-299 163.5-245 245-163.5 299-60.5q300 0 515 201l-209 201q-123-119-306-119-129 0-238.5 65t-173.5 176.5-64 243.5 64 243.5 173.5 176.5 238.5 65q87 0 160-24t120-60 82-82 51.5-87 22.5-78h-436v-264z" })
	  );
	}
	function iconYahoo() {
	  return _react2.default.createElement(
	    "svg",
	    { className: "icn icn-yahoo", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-yahoo-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-yahoo-title" },
	      "Yahoo"
	    ),
	    _react2.default.createElement("path", { d: "M987 957l13 707q-62-11-105-11-41 0-105 11l13-707q-40-69-168.5-295.5t-216.5-374.5-181-287q58 15 108 15 44 0 111-15 63 111 133.5 229.5t167 276.5 138.5 227q37-61 109.5-177.5t117.5-190 105-176 107-189.5q54 14 107 14 56 0 114-14-28 39-60 88.5t-49.5 78.5-56.5 96-49 84q-146 248-353 610z" })
	  );
	}
	
	function iconMicrophone() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-microphone", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-microphone-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-microphone-title" },
	      "Microphone"
	    ),
	    _react2.default.createElement("path", { d: "M1472 704v128q0 221-147.5 384.5t-364.5 187.5v132h256q26 0 45 19t19 45-19 45-45 19h-640q-26 0-45-19t-19-45 19-45 45-19h256v-132q-217-24-364.5-187.5t-147.5-384.5v-128q0-26 19-45t45-19 45 19 19 45v128q0 185 131.5 316.5t316.5 131.5 316.5-131.5 131.5-316.5v-128q0-26 19-45t45-19 45 19 19 45zm-256-384v512q0 132-94 226t-226 94-226-94-94-226v-512q0-132 94-226t226-94 226 94 94 226z" })
	  );
	}
	function iconMicrosoft() {
	  return _react2.default.createElement(
	    "svg",
	    { className: "icn icn-microsoft", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-microsoft-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-microsoft-title" },
	      "Microsoft"
	    ),
	    _react2.default.createElement("path", { d: "M746 1006v651l-682-94v-557h682zm0-743v659h-682v-565zm982 743v786l-907-125v-661h907zm0-878v794h-907v-669z" })
	  );
	}
	
	function iconMinus() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-minus", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-minus-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-minus-title" },
	      "Minus"
	    ),
	    _react2.default.createElement("path", { d: "M1344 960v-128q0-26-19-45t-45-19h-768q-26 0-45 19t-19 45v128q0 26 19 45t45 19h768q26 0 45-19t19-45zm320-64q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	function iconMinusHybrid() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 16 16", className: "icon icon--minus", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-minus-hybrid" },
	      "Minus-Hybrid"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 6.6875H15V9.3125H1V6.6875Z", fill: "currentColor" })
	  );
	}
	function iconPlusHybrid() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 16 16", className: "icon icon--plus", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-plus-hybrid" },
	      "Plus-Hybrid"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.3125 1H6.6875V6.6875H1V9.3125H6.6875V15H9.3125V9.3125H15V6.6875H9.3125V1Z", fill: "currentColor" })
	  );
	}
	function iconPicture() {
	  return _react2.default.createElement(
	    "svg",
	    { className: "icn icn-picture", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-picture-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-picture-title" },
	      "Picture"
	    ),
	    _react2.default.createElement("path", { transform: "translate(65, 0)", d: "M576 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1024 384v448h-1408v-192l320-320 160 160 512-512zm96-704h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zm160 32v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z" })
	  );
	}
	
	function iconMobile() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-mobile", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-mobile-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-mobile-title" },
	      "Mobile"
	    ),
	    _react2.default.createElement("path", { d: "M976 1408q0-33-23.5-56.5t-56.5-23.5-56.5 23.5-23.5 56.5 23.5 56.5 56.5 23.5 56.5-23.5 23.5-56.5zm208-160v-704q0-13-9.5-22.5t-22.5-9.5h-512q-13 0-22.5 9.5t-9.5 22.5v704q0 13 9.5 22.5t22.5 9.5h512q13 0 22.5-9.5t9.5-22.5zm-192-848q0-16-16-16h-160q-16 0-16 16t16 16h160q16 0 16-16zm288-16v1024q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-1024q0-52 38-90t90-38h512q52 0 90 38t38 90z" })
	  );
	}
	
	function iconMoon() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-moon", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-moon-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-moon-title" },
	      "Moon"
	    ),
	    _react2.default.createElement("path", { d: "M1390 1303q-54 9-110 9-182 0-337-90t-245-245-90-337q0-192 104-357-201 60-328.5 229t-127.5 384q0 130 51 248.5t136.5 204 204 136.5 248.5 51q144 0 273.5-61.5t220.5-171.5zm203-85q-94 203-283.5 324.5t-413.5 121.5q-156 0-298-61t-245-164-164-245-61-298q0-153 57.5-292.5t156-241.5 235.5-164.5 290-68.5q44-2 61 39 18 41-15 72-86 78-131.5 181.5t-45.5 218.5q0 148 73 273t198 198 273 73q118 0 228-51 41-18 72 13 14 14 17.5 34t-4.5 38z" })
	  );
	}
	
	function iconNo() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-no", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-no-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-no-title" },
	      "No"
	    ),
	    _react2.default.createElement("path", { d: "M1440 893q0-161-87-295l-754 753q137 89 297 89 111 0 211.5-43.5t173.5-116.5 116-174.5 43-212.5zm-999 299l755-754q-135-91-300-91-148 0-273 73t-198 199-73 274q0 162 89 299zm1223-299q0 157-61 300t-163.5 246-245 164-298.5 61-298.5-61-245-164-163.5-246-61-300 61-299.5 163.5-245.5 245-164 298.5-61 298.5 61 245 164 163.5 245.5 61 299.5z" })
	  );
	}
	
	function iconPage() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-page", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-page-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-page-title" },
	      "Page"
	    ),
	    _react2.default.createElement("path", { d: "M1596 476q14 14 28 36h-472v-472q22 14 36 28zm-476 164h544v1056q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h800v544q0 40 28 68t68 28zm160 736v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23z" })
	  );
	}
	
	function iconPerson() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 16 16", className: "icn icon--people", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-people" },
	      "Person"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "currentColor", d: "M8.85714 5.25C8.85714 6.76878 7.80181 8 6.5 8C5.19819 8 4.14286 6.76878 4.14286 5.25C4.14286 3.73122 5.19819 2.5 6.5 2.5C7.80181 2.5 8.85714 3.73122 8.85714 5.25ZM1.65106 10.4093C1.73287 10.0209 2.03666 9.71762 2.4252 9.6365L5.47808 8.99908C6.15209 8.85835 6.84791 8.85835 7.52192 8.99908L10.5748 9.6365C10.9633 9.71762 11.2671 10.0209 11.3489 10.4093L12 13.5H1L1.65106 10.4093ZM9.5 8C9.2378 8 8.9856 7.95005 8.75 7.85787C9.68412 7.49237 10.3571 6.46288 10.3571 5.25C10.3571 4.03712 9.68412 3.00763 8.75 2.64213C8.9856 2.54995 9.2378 2.5 9.5 2.5C10.8018 2.5 11.8571 3.73122 11.8571 5.25C11.8571 6.76878 10.8018 8 9.5 8ZM15 13.5H13.5L12.8489 10.4093C12.7671 10.0209 12.4633 9.71762 12.0748 9.6365L9.02192 8.99908C8.93164 8.98023 8.84096 8.96391 8.75 8.95011C9.33811 8.86088 9.93819 8.8772 10.5219 8.99908L13.5748 9.6365C13.9633 9.71762 14.2671 10.0209 14.3489 10.4093L15 13.5Z" })
	  );
	}
	
	function iconPaper() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-paper", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-paper-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-paper-title" },
	      "Paper"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280z" })
	  );
	}
	
	function iconPaperclip() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-paperclip", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-paperclip-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-paperclip-title" },
	      "Paperclip"
	    ),
	    _react2.default.createElement("path", { d: "M1596 1385q0 117-79 196t-196 79q-135 0-235-100l-777-776q-113-115-113-271 0-159 110-270t269-111q158 0 273 113l605 606q10 10 10 22 0 16-30.5 46.5t-46.5 30.5q-13 0-23-10l-606-607q-79-77-181-77-106 0-179 75t-73 181q0 105 76 181l776 777q63 63 145 63 64 0 106-42t42-106q0-82-63-145l-581-581q-26-24-60-24-29 0-48 19t-19 48q0 32 25 59l410 410q10 10 10 22 0 16-31 47t-47 31q-12 0-22-10l-410-410q-63-61-63-149 0-82 57-139t139-57q88 0 149 63l581 581q100 98 100 235z" })
	  );
	}
	
	function iconPause() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-pause", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-pause-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-pause-title" },
	      "Pause"
	    ),
	    _react2.default.createElement("path", { d: "M1664 192v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45zm-896 0v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45z" })
	  );
	}
	
	function iconPencil() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-pencil", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-pencil-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-pencil-title" },
	      "Pencil"
	    ),
	    _react2.default.createElement("path", { d: "M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z" })
	  );
	}
	
	function iconPencilPaper() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-pencil-paper", xmlns: "http://www.w3.org/2000/svg", width: "384", height: "512", viewBox: "0 0 384 512", "aria-labelledby": "icn-pencil-paper-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-pencil-paper-title" },
	      "Written"
	    ),
	    _react2.default.createElement("path", { d: "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zM219.2 247.2l29.6 29.6c1.8 1.8 1.8 4.6 0 6.4L136.4 395.6l-30.1 4.3c-5.9.8-11-4.2-10.2-10.2l4.3-30.1 112.4-112.4c1.8-1.8 4.6-1.8 6.4 0zm64.4 1.2l-16.4 16.4c-1.8 1.8-4.6 1.8-6.4 0l-29.6-29.6c-1.8-1.8-1.8-4.6 0-6.4l16.4-16.4c5.9-5.9 15.4-5.9 21.2 0l14.8 14.8c5.9 5.8 5.9 15.3 0 21.2z" })
	  );
	}
	
	function iconPhone() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-phone", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-phone-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-phone-title" },
	      "Phone"
	    ),
	    _react2.default.createElement("path", { d: "M1600 1240q0 27-10 70.5t-21 68.5q-21 50-122 106-94 51-186 51-27 0-52.5-3.5t-57.5-12.5-47.5-14.5-55.5-20.5-49-18q-98-35-175-83-128-79-264.5-215.5t-215.5-264.5q-48-77-83-175-3-9-18-49t-20.5-55.5-14.5-47.5-12.5-57.5-3.5-52.5q0-92 51-186 56-101 106-122 25-11 68.5-21t70.5-10q14 0 21 3 18 6 53 76 11 19 30 54t35 63.5 31 53.5q3 4 17.5 25t21.5 35.5 7 28.5q0 20-28.5 50t-62 55-62 53-28.5 46q0 9 5 22.5t8.5 20.5 14 24 11.5 19q76 137 174 235t235 174q2 1 19 11.5t24 14 20.5 8.5 22.5 5q18 0 46-28.5t53-62 55-62 50-28.5q14 0 28.5 7t35.5 21.5 25 17.5q25 15 53.5 31t63.5 35 54 30q70 35 76 53 3 7 3 21z" })
	  );
	}
	
	function iconPlay() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-play", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-play-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-play-title" },
	      "Play"
	    ),
	    _react2.default.createElement("path", { d: "M1576 927l-1328 738q-23 13-39.5 3t-16.5-36v-1472q0-26 16.5-36t39.5 3l1328 738q23 13 23 31t-23 31z" })
	  );
	}
	
	function iconPlus() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-plus", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-plus-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-plus-title" },
	      "Plus"
	    ),
	    _react2.default.createElement("path", { d: "M1344 960v-128q0-26-19-45t-45-19h-256v-256q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v256h-256q-26 0-45 19t-19 45v128q0 26 19 45t45 19h256v256q0 26 19 45t45 19h128q26 0 45-19t19-45v-256h256q26 0 45-19t19-45zm320-64q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconPower() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-power", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-power-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-power-title" },
	      "Power"
	    ),
	    _react2.default.createElement("path", { d: "M1664 896q0 156-61 298t-164 245-245 164-298 61-298-61-245-164-164-245-61-298q0-182 80.5-343t226.5-270q43-32 95.5-25t83.5 50q32 42 24.5 94.5t-49.5 84.5q-98 74-151.5 181t-53.5 228q0 104 40.5 198.5t109.5 163.5 163.5 109.5 198.5 40.5 198.5-40.5 163.5-109.5 109.5-163.5 40.5-198.5q0-121-53.5-228t-151.5-181q-42-32-49.5-84.5t24.5-94.5q31-43 84-50t95 25q146 109 226.5 270t80.5 343zm-640-768v640q0 52-38 90t-90 38-90-38-38-90v-640q0-52 38-90t90-38 90 38 38 90z" })
	  );
	}
	
	function iconPrint() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-print", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-print-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-print-title" },
	      "Print"
	    ),
	    _react2.default.createElement("path", { d: "M448 1536h896v-256h-896v256zm0-640h896v-384h-160q-40 0-68-28t-28-68v-160h-640v640zm1152 64q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128 0v416q0 13-9.5 22.5t-22.5 9.5h-224v160q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-224q-13 0-22.5-9.5t-9.5-22.5v-416q0-79 56.5-135.5t135.5-56.5h64v-544q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v256h64q79 0 135.5 56.5t56.5 135.5z" })
	  );
	}
	
	function iconPrintDisable() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-print-disable", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-print-disable-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-print-disable-title" },
	      "Print Disable"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M115 201L205.51 110.49L320 224.981V224C320 197.333 329.333 174.667 348 156C366.667 137.333 389.333 128 416 128H1088C1114.67 128 1144 134.667 1176 148C1208 161.333 1233.33 177.333 1252 196L1404 348C1422.67 366.667 1438.67 392 1452 424C1465.33 456 1472 485.333 1472 512V768H1536C1588.67 768 1633.83 786.833 1671.5 824.5C1709.17 862.167 1728 907.333 1728 960V1376C1728 1384.67 1724.83 1392.17 1718.5 1398.5C1712.17 1404.83 1704.67 1408 1696 1408H1503.02L1726.51 1631.49L1636 1722L1577 1663L1472 1558L1344 1430L1194 1280L810 896L448 534L320 406L140.51 226.51L115 201ZM320 587.019V768H256C203.333 768 158.167 786.833 120.5 824.5C82.8333 862.167 64 907.333 64 960V1376C64 1384.67 67.1667 1392.17 73.5 1398.5C79.8333 1404.83 87.3333 1408 96 1408H320V1568C320 1594.67 329.333 1617.33 348 1636C366.667 1654.67 389.333 1664 416 1664H1376C1382.66 1664 1389.07 1663.42 1395.23 1662.25L1268.98 1536H448V1280H1012.98L628.981 896H448V715.019L320 587.019ZM448 352.981L991.019 896H1344V512H1184C1157.33 512 1134.67 502.667 1116 484C1097.33 465.333 1088 442.667 1088 416V256H448V352.981ZM1600 960C1600 942.667 1593.67 927.667 1581 915C1568.33 902.333 1553.33 896 1536 896C1518.67 896 1503.67 902.333 1491 915C1478.33 927.667 1472 942.667 1472 960C1472 977.333 1478.33 992.333 1491 1005C1503.67 1017.67 1518.67 1024 1536 1024C1553.33 1024 1568.33 1017.67 1581 1005C1593.67 992.333 1600 977.333 1600 960Z" })
	  );
	}
	
	function iconQuestion() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-question", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-question-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-question-title" },
	      "Question"
	    ),
	    _react2.default.createElement("path", { d: "M1024 1376v-192q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v192q0 14 9 23t23 9h192q14 0 23-9t9-23zm256-672q0-88-55.5-163t-138.5-116-170-41q-243 0-371 213-15 24 8 42l132 100q7 6 19 6 16 0 25-12 53-68 86-92 34-24 86-24 48 0 85.5 26t37.5 59q0 38-20 61t-68 45q-63 28-115.5 86.5t-52.5 125.5v36q0 14 9 23t23 9h192q14 0 23-9t9-23q0-19 21.5-49.5t54.5-49.5q32-18 49-28.5t46-35 44.5-48 28-60.5 12.5-81zm384 192q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconRandom() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-random", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-random-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-random-title" },
	      "Random"
	    ),
	    _react2.default.createElement("path", { d: "M666 481q-60 92-137 273-22-45-37-72.5t-40.5-63.5-51-56.5-63-35-81.5-14.5h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224q250 0 410 225zm1126 799q0 14-9 23l-320 320q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-192q-32 0-85 .5t-81 1-73-1-71-5-64-10.5-63-18.5-58-28.5-59-40-55-53.5-56-69.5q59-93 136-273 22 45 37 72.5t40.5 63.5 51 56.5 63 35 81.5 14.5h256v-192q0-14 9-23t23-9q12 0 24 10l319 319q9 9 9 23zm0-896q0 14-9 23l-320 320q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-192h-256q-48 0-87 15t-69 45-51 61.5-45 77.5q-32 62-78 171-29 66-49.5 111t-54 105-64 100-74 83-90 68.5-106.5 42-128 16.5h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224q48 0 87-15t69-45 51-61.5 45-77.5q32-62 78-171 29-66 49.5-111t54-105 64-100 74-83 90-68.5 106.5-42 128-16.5h256v-192q0-14 9-23t23-9q12 0 24 10l319 319q9 9 9 23z" })
	  );
	}
	
	function iconRedo() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-redo", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-redo-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-redo-title" },
	      "Redo"
	    ),
	    _react2.default.createElement("path", { d: "M1664 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 15 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z" })
	  );
	}
	
	function iconRefresh() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-refresh", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-refresh-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-refresh-title" },
	      "Refresh"
	    ),
	    _react2.default.createElement("path", { d: "M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z" })
	  );
	}
	
	function iconReply() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-reply", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-reply-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-reply-title" },
	      "Reply"
	    ),
	    _react2.default.createElement("path", { d: "M1792 1120q0 166-127 451-3 7-10.5 24t-13.5 30-13 22q-12 17-28 17-15 0-23.5-10t-8.5-25q0-9 2.5-26.5t2.5-23.5q5-68 5-123 0-101-17.5-181t-48.5-138.5-80-101-105.5-69.5-133-42.5-154-21.5-175.5-6h-224v256q0 26-19 45t-45 19-45-19l-512-512q-19-19-19-45t19-45l512-512q19-19 45-19t45 19 19 45v256h224q713 0 875 403 53 134 53 333z" })
	  );
	}
	
	function iconRightClickDisable() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-right-click-disable", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-right-click-disable-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-right-click-disable-title" },
	      "Right Click Disable"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1782.12 613.235C1779.11 591.349 1758.93 576.047 1737.05 579.056L1600.33 597.852C1578.45 600.861 1563.15 621.042 1566.15 642.928C1569.16 664.813 1589.34 680.116 1611.23 677.107L1747.94 658.31C1769.83 655.301 1785.13 635.12 1782.12 613.235ZM730.588 383.39C889.269 220.006 1143.28 205.168 1319.21 341.408L1017.39 652.173L1089.12 721.844L1390.94 411.078C1532.26 582.954 1524.85 837.288 1366.17 1000.67L1232.4 1138.4L1691 1597L1601 1687L120 206L210 116L605.838 511.838L730.588 383.39ZM427.964 694.984L269.806 857.829C99.3485 1033.34 103.444 1313.8 278.954 1484.26C454.464 1654.72 734.927 1650.62 905.384 1475.11L1054.53 1321.55L427.964 694.984ZM1701.56 878.206C1719.16 891.554 1722.61 916.644 1709.27 934.247C1695.92 951.851 1670.83 955.3 1653.22 941.953L1543.26 858.573C1525.66 845.225 1522.21 820.134 1535.56 802.531C1548.9 784.928 1573.99 781.478 1591.6 794.826L1701.56 878.206ZM1625.33 323.795C1607.73 310.448 1582.64 313.897 1569.29 331.5L1485.91 441.463C1472.57 459.066 1476.02 484.157 1493.62 497.504C1511.22 510.852 1536.31 507.402 1549.66 489.799L1633.04 379.837C1646.39 362.233 1642.94 337.143 1625.33 323.795Z" })
	  );
	}
	
	function iconScale() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-scale", xmlns: "http://www.w3.org/2000/svg", width: "2304", height: "1792", viewBox: "0 0 2304 1792", "aria-labelledby": "icn-scale-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-scale-title" },
	      "Scale"
	    ),
	    _react2.default.createElement("path", { d: "M1728 448l-384 704h768zm-1280 0l-384 704h768zm821-192q-14 40-45.5 71.5t-71.5 45.5v1291h608q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1344q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h608v-1291q-40-14-71.5-45.5t-45.5-71.5h-491q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h491q21-57 70-92.5t111-35.5 111 35.5 70 92.5h491q14 0 23 9t9 23v64q0 14-9 23t-23 9h-491zm-181 16q33 0 56.5-23.5t23.5-56.5-23.5-56.5-56.5-23.5-56.5 23.5-23.5 56.5 23.5 56.5 56.5 23.5zm1088 880q0 73-46.5 131t-117.5 91-144.5 49.5-139.5 16.5-139.5-16.5-144.5-49.5-117.5-91-46.5-131q0-11 35-81t92-174.5 107-195.5 102-184 56-100q18-33 56-33t56 33q4 7 56 100t102 184 107 195.5 92 174.5 35 81zm-1280 0q0 73-46.5 131t-117.5 91-144.5 49.5-139.5 16.5-139.5-16.5-144.5-49.5-117.5-91-46.5-131q0-11 35-81t92-174.5 107-195.5 102-184 56-100q18-33 56-33t56 33q4 7 56 100t102 184 107 195.5 92 174.5 35 81z" })
	  );
	}
	
	function iconSettings() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-settings", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-settings-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-settings-title" },
	      "Settings"
	    ),
	    _react2.default.createElement("path", { d: "M1152 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zm512-109v222q0 12-8 23t-20 13l-185 28q-19 54-39 91 35 50 107 138 10 12 10 25t-9 23q-27 37-99 108t-94 71q-12 0-26-9l-138-108q-44 23-91 38-16 136-29 186-7 28-36 28h-222q-14 0-24.5-8.5t-11.5-21.5l-28-184q-49-16-90-37l-141 107q-10 9-25 9-14 0-25-11-126-114-165-168-7-10-7-23 0-12 8-23 15-21 51-66.5t54-70.5q-27-50-41-99l-183-27q-13-2-21-12.5t-8-23.5v-222q0-12 8-23t19-13l186-28q14-46 39-92-40-57-107-138-10-12-10-24 0-10 9-23 26-36 98.5-107.5t94.5-71.5q13 0 26 10l138 107q44-23 91-38 16-136 29-186 7-28 36-28h222q14 0 24.5 8.5t11.5 21.5l28 184q49 16 90 37l142-107q9-9 24-9 13 0 25 10 129 119 165 170 7 8 7 22 0 12-8 23-15 21-51 66.5t-54 70.5q26 50 41 98l183 28q13 2 21 12.5t8 23.5z" })
	  );
	}
	
	function iconStop() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-stop", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-stop-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-stop-title" },
	      "Stop"
	    ),
	    _react2.default.createElement("path", { d: "M1664 192v1408q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h1408q26 0 45 19t19 45z" })
	  );
	}
	
	function iconTabsClose() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-tabs-close", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-tabs-close-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-tabs-close-title" },
	      "Close Tabs"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M134 284C78.7715 284 34 328.772 34 384V1408C34 1463.23 78.7715 1508 134 1508H1658C1713.23 1508 1758 1463.23 1758 1408V384C1758 328.772 1713.23 284 1658 284H134ZM214 554C186.386 554 164 576.386 164 604V1328C164 1355.61 186.386 1378 214 1378H1578C1605.61 1378 1628 1355.61 1628 1328V604C1628 576.386 1605.61 554 1578 554H214ZM1682 421C1682 458.003 1652 488 1615 488C1578 488 1548 458.003 1548 421C1548 383.997 1578 354 1615 354C1652 354 1682 383.997 1682 421ZM1425 488C1462 488 1492 458.003 1492 421C1492 383.997 1462 354 1425 354C1388 354 1358 383.997 1358 421C1358 458.003 1388 488 1425 488ZM1302 421C1302 458.003 1272 488 1235 488C1198 488 1168 458.003 1168 421C1168 383.997 1198 354 1235 354C1272 354 1302 383.997 1302 421ZM745.797 773L683 835.797L833.203 986L683 1136.2L745.797 1199L896 1048.8L1046.2 1199L1109 1136.2L958.797 986L1109 835.797L1046.2 773L896 923.203L745.797 773Z" })
	  );
	}
	
	function iconTabsOne() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-tabs-one", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-tabs-one-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-tabs-one-title" },
	      "Disable New Tabs"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M517 379C517 323.772 561.772 279 617 279H1681C1736.23 279 1781 323.772 1781 379V1076.41C1781 1131.64 1736.23 1176.41 1681 1176.41H1273V1412.41C1273 1467.64 1228.23 1512.41 1173 1512.41H109C53.7715 1512.41 9 1467.64 9 1412.41V715C9 659.772 53.7715 615 109 615H517V379ZM517 812.958V813H612.313V812.958H1127.69C1155.3 812.958 1177.69 835.344 1177.69 862.958V1367.1C1177.69 1394.71 1155.3 1417.1 1127.69 1417.1H154.313C126.699 1417.1 104.313 1394.71 104.313 1367.1V862.958C104.313 835.344 126.699 812.958 154.313 812.958H517ZM612.313 615V526.958C612.313 499.344 634.699 476.958 662.313 476.958H1635.69C1663.3 476.958 1685.69 499.344 1685.69 526.958V1031.1C1685.69 1058.71 1663.3 1081.1 1635.69 1081.1H1273V715C1273 659.772 1228.23 615 1173 615H612.313ZM1676.16 428.568C1703.29 428.568 1725.28 406.575 1725.28 379.445C1725.28 352.316 1703.29 330.322 1676.16 330.322C1649.03 330.322 1627.03 352.316 1627.03 379.445C1627.03 406.575 1649.03 428.568 1676.16 428.568ZM1585.97 379.445C1585.97 406.575 1563.98 428.568 1536.85 428.568C1509.72 428.568 1487.73 406.575 1487.73 379.445C1487.73 352.316 1509.72 330.322 1536.85 330.322C1563.98 330.322 1585.97 352.316 1585.97 379.445ZM1397.55 428.568C1424.68 428.568 1446.67 406.575 1446.67 379.445C1446.67 352.316 1424.68 330.322 1397.55 330.322C1370.42 330.322 1348.42 352.316 1348.42 379.445C1348.42 406.575 1370.42 428.568 1397.55 428.568ZM1168.16 764.568C1195.29 764.568 1217.28 742.575 1217.28 715.445C1217.28 688.316 1195.29 666.322 1168.16 666.322C1141.03 666.322 1119.03 688.316 1119.03 715.445C1119.03 742.575 1141.03 764.568 1168.16 764.568ZM1077.97 715.445C1077.97 742.575 1055.98 764.568 1028.85 764.568C1001.72 764.568 979.729 742.575 979.729 715.445C979.729 688.316 1001.72 666.322 1028.85 666.322C1055.98 666.322 1077.97 688.316 1077.97 715.445ZM889.548 764.568C916.677 764.568 938.67 742.575 938.67 715.445C938.67 688.316 916.677 666.322 889.548 666.322C862.418 666.322 840.425 688.316 840.425 715.445C840.425 742.575 862.418 764.568 889.548 764.568ZM484.833 1019.57L530.874 973.524L641 1083.65L751.126 973.524L797.167 1019.57L687.041 1129.69L797.167 1239.82L751.126 1285.86L641 1175.73L530.874 1285.86L484.833 1239.82L594.959 1129.69L484.833 1019.57Z" })
	  );
	}
	
	function iconTimes() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-times", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-times-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-times-title" },
	      "Times"
	    ),
	    _react2.default.createElement("path", { d: "M895.97,818.548l452.548,-452.548l141.421,141.421l-452.548,452.549l452.548,452.548l-141.421,141.421l-452.548,-452.548l-452.549,452.548l-141.421,-141.421l452.548,-452.548l-452.548,-452.549l141.421,-141.421l452.549,452.548Z" })
	  );
	}
	
	function iconTimesCircle() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-times-circle", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-times-circle-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-times-circle-title" },
	      "Times Circle"
	    ),
	    _react2.default.createElement("path", { d: "M1277 1122q0-26-19-45l-181-181 181-181q19-19 19-45 0-27-19-46l-90-90q-19-19-46-19-26 0-45 19l-181 181-181-181q-19-19-45-19-27 0-46 19l-90 90q-19 19-19 46 0 26 19 45l181 181-181 181q-19 19-19 45 0 27 19 46l90 90q19 19 46 19 26 0 45-19l181-181 181 181q19 19 45 19 27 0 46-19l90-90q19-19 19-46zm387-226q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function iconTrash() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-trash", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-trash-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-trash-title" },
	      "Trash"
	    ),
	    _react2.default.createElement("path", { d: "M704 736v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zm256 0v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zm256 0v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zm128 724v-948h-896v948q0 22 7 40.5t14.5 27 10.5 8.5h832q3 0 10.5-8.5t14.5-27 7-40.5zm-672-1076h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z" })
	  );
	}
	function iconTrash2() {
	  return _react2.default.createElement(
	    "svg",
	    { width: "16", height: "16", viewBox: "0 0 16 16", className: "hybrid-icon hybrid-icon--trash", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-trash-title" },
	      "Trash"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.5 1H6.5L6 2H2V3H14V2H10L9.5 1ZM4 5H12V14H4V5ZM3 14.5V4H13V14.5C13 14.7761 12.7761 15 12.5 15H3.5C3.22386 15 3 14.7761 3 14.5ZM6 6H5V13H6V6ZM10 6H11V13H10V6ZM8.5 6H7.5V13H8.5V6Z", fill: "currentColor" })
	  );
	}
	
	function iconUndo() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-undo", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-undo-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-undo-title" },
	      "Undo"
	    ),
	    _react2.default.createElement("path", { d: "M1664 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298z" })
	  );
	}
	
	function iconUnlock() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-unlock", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-unlock-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-unlock-title" },
	      "Unlock"
	    ),
	    _react2.default.createElement("path", { d: "M1728 576v256q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45v-256q0-106-75-181t-181-75-181 75-75 181v192h96q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h672v-192q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5z" })
	  );
	}
	
	function iconUniversity() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-university", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-university-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-university-title" },
	      "University"
	    ),
	    _react2.default.createElement("path", { d: "M960 0l960 384v128h-128q0 26-20.5 45t-48.5 19h-1526q-28 0-48.5-19t-20.5-45h-128v-128zm-704 640h256v768h128v-768h256v768h128v-768h256v768h128v-768h256v768h59q28 0 48.5 19t20.5 45v64h-1664v-64q0-26 20.5-45t48.5-19h59v-768zm1595 960q28 0 48.5 19t20.5 45v128h-1920v-128q0-26 20.5-45t48.5-19h1782z" })
	  );
	}
	
	function iconUpload() {
	  return _react2.default.createElement(
	    "svg",
	    { className: "icn icn-upload", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-upload-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-upload-title" },
	      "Upload"
	    ),
	    _react2.default.createElement("path", { d: "M1344 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h427q21 56 70.5 92t110.5 36h256q61 0 110.5-36t70.5-92h427q40 0 68 28t28 68zm-325-648q-17 40-59 40h-256v448q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-448h-256q-42 0-59-40-17-39 14-69l448-448q18-19 45-19t45 19l448 448q31 30 14 69z" })
	  );
	}
	
	function iconUser() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-user", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-user-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-user-title" },
	      "User"
	    ),
	    _react2.default.createElement("path", { d: "M1600 1405q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q9 0 42 21.5t74.5 48 108 48 133.5 21.5 133.5-21.5 108-48 74.5-48 42-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zm-320-893q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5z" })
	  );
	}
	
	function iconUsers() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-users", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-users-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-users-title" },
	      "Users"
	    ),
	    _react2.default.createElement("path", { transform: "translate(65, 0)", d: "M529 896q-162 5-265 128h-134q-82 0-138-40.5t-56-118.5q0-353 124-353 6 0 43.5 21t97.5 42.5 119 21.5q67 0 133-23-5 37-5 66 0 139 81 256zm1071 637q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q10 0 43 21.5t73 48 107 48 135 21.5 135-21.5 107-48 73-48 43-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zm-1024-1277q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zm704 384q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5zm576 225q0 78-56 118.5t-138 40.5h-134q-103-123-265-128 81-117 81-256 0-29-5-66 66 23 133 23 59 0 119-21.5t97.5-42.5 43.5-21q124 0 124 353zm-128-609q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181z" })
	  );
	}
	
	function iconVideoCamera() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-video-camera", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-video-camera-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-video-camera-title" },
	      "Video Camera"
	    ),
	    _react2.default.createElement("path", { d: "M1792 352v1088q0 42-39 59-13 5-25 5-27 0-45-19l-403-403v166q0 119-84.5 203.5t-203.5 84.5h-704q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h704q119 0 203.5 84.5t84.5 203.5v165l403-402q18-19 45-19 12 0 25 5 39 17 39 59z" })
	  );
	}
	
	function iconVideoCamera360() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-video-camera-360", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-video-camera-360-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-video-camera-360-title" },
	      "Video Camera Spin"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1246 933.5V508.5C1246 497.562 1240.92 489.88 1230.77 485.453C1227.38 484.151 1224.12 483.5 1221 483.5C1213.97 483.5 1208.11 485.974 1203.42 490.922L1046 647.953V583.5C1046 552.51 1035 526.013 1012.99 504.008C990.987 482.003 964.49 471 933.5 471H658.5C627.51 471 601.013 482.003 579.008 504.008C557.003 526.013 546 552.51 546 583.5V858.5C546 889.49 557.003 915.987 579.008 937.992C601.013 959.997 627.51 971 658.5 971H933.5C964.49 971 990.987 959.997 1012.99 937.992C1035 915.987 1046 889.49 1046 858.5V793.656L1203.42 951.078C1208.11 956.026 1213.97 958.5 1221 958.5C1224.12 958.5 1227.38 957.849 1230.77 956.547C1240.92 952.12 1246 944.438 1246 933.5ZM751.165 1135.23C794.202 1143.95 805.058 1124.37 803.023 1090.06C802.911 1088.1 802.691 1086.03 802.464 1083.9C801.308 1073.03 799.995 1060.69 812.231 1055.26C823.602 1050.21 831.346 1057.87 838.69 1065.12C840.799 1067.2 842.874 1069.25 844.993 1070.96C861.011 1083.9 876.93 1097.06 892.872 1110.25L892.885 1110.26L892.89 1110.26C915.531 1128.99 938.22 1147.76 961.309 1165.95C983.118 1183.3 984.475 1197.07 961.309 1215.1C931.503 1238.56 902.433 1263 873.401 1287.41L873.383 1287.42C861.635 1297.3 849.893 1307.17 838.111 1316.97C815.624 1335.68 800.115 1330.64 803.507 1301.46C809.905 1247.28 782.28 1238.26 735.657 1235.74C580.569 1227.41 426.741 1211.8 276.403 1171.09C210.878 1153.26 145.742 1133.87 88.6499 1095.39C6.06571 1039.75 6.16263 975.584 90.6854 921.497C170.943 870.125 262.639 848.994 354.141 828.542C354.36 828.493 354.582 828.443 354.807 828.392C355.118 828.321 355.434 828.249 355.754 828.176C364.377 826.207 375.936 823.568 378.761 835.23C379.787 844.666 377.748 854.182 372.945 862.37C366.238 876.269 352.929 879.254 339.702 882.222L339.701 882.222C337.062 882.814 334.426 883.405 331.847 884.082C329.31 884.755 326.772 885.425 324.233 886.095C279.93 897.791 235.566 909.502 196.145 933.614C142.155 966.473 142.446 1002.24 197.599 1034.52C257.988 1069.96 325.907 1083.27 393.281 1096.48C395.55 1096.92 397.818 1097.37 400.085 1097.81C517.564 1120.88 636.788 1129.12 751.165 1135.23ZM1016.07 1185.73C1007.02 1134.37 1043.87 1133.03 1077.62 1131.8L1078.91 1131.76L1079.37 1131.74C1213.37 1128.24 1346.61 1110.33 1476.78 1078.33C1511.08 1069.32 1544.62 1057.65 1577.1 1043.43L1577.84 1043.11C1603.84 1031.75 1633.53 1018.78 1634.68 984.599C1635.84 951.434 1610.55 939.545 1586.77 928.368L1586.77 928.368C1582.75 926.478 1578.77 924.609 1574.97 922.66C1540.62 905.033 1503.33 895.386 1466.08 885.747L1466.06 885.741C1459.48 884.04 1452.9 882.338 1446.35 880.593C1443.33 879.779 1439.88 879.209 1436.32 878.62C1420.81 876.051 1403.2 873.135 1409.9 848.218C1416.51 823.571 1435.62 827.884 1453.75 831.975L1453.76 831.978C1455.31 832.326 1456.84 832.673 1458.37 833C1538.72 851.611 1618.59 871.772 1690.51 914.421C1788.7 971.901 1790.93 1043.14 1693.9 1101.11C1578.27 1169.64 1448.48 1190.87 1319.17 1210.25C1268.51 1217.81 1217.36 1222.23 1166.19 1226.65L1166.19 1226.65C1132.1 1229.6 1098.01 1232.55 1064.05 1236.42C1023.83 1240.78 1010.55 1223.63 1016.07 1185.73Z" })
	  );
	}
	
	function iconVolumeOff() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-volume-off", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", preserveAspectRatio: "xMinYMin meet", "aria-labelledby": "icn-volume-off-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-volume-off-title" },
	      "Volume Off"
	    ),
	    _react2.default.createElement("path", { d: "M1280 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45z" })
	  );
	}
	
	function iconVolumeUp() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-volume-up", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-volume-up-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-volume-up-title" },
	      "Volume Up"
	    ),
	    _react2.default.createElement("path", { d: "M832 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45zm384 544q0 76-42.5 141.5t-112.5 93.5q-10 5-25 5-26 0-45-18.5t-19-45.5q0-21 12-35.5t29-25 34-23 29-36 12-56.5-12-56.5-29-36-34-23-29-25-12-35.5q0-27 19-45.5t45-18.5q15 0 25 5 70 27 112.5 93t42.5 142zm256 0q0 153-85 282.5t-225 188.5q-13 5-25 5-27 0-46-19t-19-45q0-39 39-59 56-29 76-44 74-54 115.5-135.5t41.5-173.5-41.5-173.5-115.5-135.5q-20-15-76-44-39-20-39-59 0-26 19-45t45-19q13 0 26 5 140 59 225 188.5t85 282.5zm256 0q0 230-127 422.5t-338 283.5q-13 5-26 5-26 0-45-19t-19-45q0-36 39-59 7-4 22.5-10.5t22.5-10.5q46-25 82-51 123-91 192-227t69-289-69-289-192-227q-36-26-82-51-7-4-22.5-10.5t-22.5-10.5q-39-23-39-59 0-26 19-45t45-19q13 0 26 5 211 91 338 283.5t127 422.5z" })
	  );
	}
	
	function iconWifi() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-wifi", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 2000 2000", "aria-labelledby": "icn-wifi-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-windows-title" },
	      "Windows"
	    ),
	    _react2.default.createElement("path", { d: "M1024 1523q-20 0-93-73.5t-73-93.5q0-32 62.5-54t103.5-22 103.5 22 62.5 54q0 20-73 93.5t-93 73.5zm270-271q-2 0-40-25t-101.5-50-128.5-25-128.5 25-101 50-40.5 25q-18 0-93.5-75t-75.5-93q0-13 10-23 78-77 196-121t233-44 233 44 196 121q10 10 10 23 0 18-75.5 93t-93.5 75zm273-272q-11 0-23-8-136-105-252-154.5t-268-49.5q-85 0-170.5 22t-149 53-113.5 62-79 53-31 22q-17 0-92-75t-75-93q0-12 10-22 132-132 320-205t380-73 380 73 320 205q10 10 10 22 0 18-75 93t-92 75zm271-271q-11 0-22-9-179-157-371.5-236.5t-420.5-79.5-420.5 79.5-371.5 236.5q-11 9-22 9-17 0-92.5-75t-75.5-93q0-13 10-23 187-186 445-288t527-102 527 102 445 288q10 10 10 23 0 18-75.5 93t-92.5 75z" })
	  );
	}
	
	function iconWindows() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-windows", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-windows-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-windows-title" },
	      "Windows"
	    ),
	    _react2.default.createElement("path", { d: "M746 1006v651l-682-94v-557h682zm0-743v659h-682v-565zm982 743v786l-907-125v-661h907zm0-878v794h-907v-669z" })
	  );
	}
	
	// Custom Proctor Type Icons
	function iconAttended() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-attended", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 121 121", "aria-labelledby": "icn-attended-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-attended-title" },
	      "Attended Virtual"
	    ),
	    _react2.default.createElement(
	      "g",
	      { fillRule: "evenodd" },
	      _react2.default.createElement("path", { d: "m113.93,78.28l0,-60.32872c0,-2.26579 -1.83927,-4.10128 -4.10813,-4.10128l-98.24374,0c-2.26032,0 -4.10813,1.8362 -4.10813,4.10128l0,60.32872l-6.22,0c-0.27377,-0.01371 -0.54116,0.08557 -0.73966,0.27461c-0.19849,0.18904 -0.31068,0.45128 -0.31034,0.72539c-0.11978,1.94226 -0.09972,3.89062 0.06,5.83c0.24,3.61 4.98,6.61 12.16,6.61l93.12,0c12.68,0 15.27,-3.98 15.27,-7.33l0,-5.11c0,-0.55228 -0.44772,-1 -1,-1l-5.88,0zm-5.91,0l0,-57.71993c0,-0.55912 -0.44907,-1.00007 -1.00304,-1.00007l-93.03392,0c-0.55816,0 -1.00304,0.44775 -1.00304,1.00007l0,57.71993l95.04,0zm-45.73,-67.34835c2.20071,-0.67844 3.8,-2.72828 3.8,-5.15165c0,-2.97681 -2.41319,-5.39 -5.39,-5.39c-2.97681,0 -5.39,2.41319 -5.39,5.39c0,2.42337 1.59929,4.47321 3.8,5.15165l0,1.33835l-4.89,0l0,1.58l12.96,0l0,-1.58l-4.89,0l0,-1.33835zm-1.59,-2.89165c1.24816,0 2.26,-1.01184 2.26,-2.26c0,-1.24816 -1.01184,-2.26 -2.26,-2.26c-1.24816,0 -2.26,1.01184 -2.26,2.26c0,1.24816 1.01184,2.26 2.26,2.26zm25.81,70.24l-51.86,0c0,0 0.04333,-4.31333 0.13,-5.52c0.10148,-1.34169 0.27507,-2.67696 0.52,-4c0.2448,-1.35392 0.57886,-2.69017 1,-4c0.401,-1.24812 0.93051,-2.45124 1.58,-3.59c0.61027,-1.10542 1.37834,-2.11604 2.28,-3c0.90925,-0.86606 1.97942,-1.54554 3.15,-2c1.31058,-0.50542 2.70544,-0.75656 4.11,-0.74c0.56314,0.16 1.08964,0.42835 1.55,0.79l2.72,1.78c1.25342,0.75619 2.59741,1.35091 4,1.77c3.19174,1.05506 6.63826,1.05506 9.83,0c1.40244,-0.41949 2.74638,-1.01419 4,-1.77l2.74,-1.77c0.4605,-0.36143 0.98696,-0.62976 1.55,-0.79c1.40454,-0.01632 2.79936,0.23482 4.11,0.74c1.17047,0.4547 2.24059,1.13414 3.15,2c0.90166,0.88397 1.66973,1.89458 2.28,3c0.64911,1.13895 1.17859,2.34203 1.58,3.59c0.42066,1.30997 0.75472,2.64619 1,4c0.24493,1.32304 0.41852,2.65831 0.52,4c0.04,1.23333 0.06,2.5 0.06,3.8l0,1.71zm-15.93,-44.6c2.65269,2.65189 4.14302,6.2491 4.14302,10c0,3.7509 -1.49033,7.34811 -4.14302,10c-2.65189,2.65269 -6.2491,4.14302 -10,4.14302c-3.7509,0 -7.34811,-1.49033 -10,-4.14302c-2.65269,-2.65189 -4.14302,-6.2491 -4.14302,-10c0,-3.7509 1.49033,-7.34811 4.14302,-10c2.65189,-2.65269 6.2491,-4.14302 10,-4.14302c3.7509,0 7.34811,1.49033 10,4.14302l0,0z" })
	    )
	  );
	}
	
	function iconUnattended() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-unattended", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 120 120", "aria-labelledby": "icn-unattended-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-unattended-title" },
	      "Unattended Virtual"
	    ),
	    _react2.default.createElement("path", { fillRule: "evenodd", d: "m113.93,78.28l0,-60.328725c0,-2.265783 -1.839271,-4.101275 -4.108126,-4.101275l-98.243748,0c-2.260313,0 -4.108126,1.836203 -4.108126,4.101275l0,60.328725l-6.22,0l0,0c-0.273769,-0.013706 -0.541161,0.085569 -0.739656,0.274611c-0.198494,0.189043 -0.310687,0.451278 -0.310344,0.725389c-0.119776,1.942259 -0.099724,3.890617 0.06,5.83c0.24,3.61 4.98,6.61 12.16,6.61l93.12,0c12.68,0 15.27,-3.98 15.27,-7.33l0,-5.11c0,-0.552285 -0.447715,-1 -1,-1l-5.88,0zm-5.91,0l0,-57.719932c0,-0.559121 -0.449075,-1.000068 -1.003038,-1.000068l-93.033924,0c-0.558155,0 -1.003038,0.447746 -1.003038,1.000068l0,57.719932l95.04,0zm-45.73,-67.348354c2.200712,-0.678438 3.8,-2.728275 3.8,-5.151646c0,-2.976815 -2.413185,-5.39 -5.39,-5.39c-2.976815,0 -5.39,2.413185 -5.39,5.39c0,2.423371 1.599288,4.473208 3.8,5.151646l0,1.338354l-4.89,0l0,1.58l12.96,0l0,-1.58l-4.89,0l0,-1.338354zm-1.59,-2.891646c1.248163,0 2.26,-1.011836 2.26,-2.26c0,-1.248164 -1.011837,-2.26 -2.26,-2.26c-1.248164,0 -2.26,1.011836 -2.26,2.26c0,1.248164 1.011836,2.26 2.26,2.26z" })
	  );
	}
	
	function iconIndividual() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-individual", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 100 100", "aria-labelledby": "icn-individual-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-individual-title" },
	      "Individual"
	    ),
	    _react2.default.createElement("path", { d: "m83,75.31c0,4.666667 -1.426667,8.366667 -4.28,11.1c-2.853333,2.733333 -6.64,4.09 -11.36,4.07l-51.16,0c-4.726667,0 -8.513333,-1.356667 -11.36,-4.07c-2.846667,-2.713333 -4.273333,-6.413333 -4.28,-11.1c0,-2.066667 0.066667,-4.086667 0.2,-6.06c0.158423,-2.139863 0.432154,-4.269624 0.82,-6.38c0.376568,-2.148427 0.894357,-4.269693 1.55,-6.35c0.640068,-1.985438 1.484598,-3.899035 2.52,-5.71c0.973526,-1.747811 2.196353,-3.34456 3.63,-4.74c1.447386,-1.358398 3.145737,-2.421565 5,-3.13c2.082755,-0.800645 4.298827,-1.197705 6.53,-1.17c0.898809,0.244768 1.741218,0.662575 2.48,1.23c1.286667,0.84 2.74,1.776667 4.36,2.81c1.989574,1.203451 4.123106,2.15094 6.35,2.82c5.078024,1.679774 10.561976,1.679774 15.64,0c2.219321,-0.667965 4.345962,-1.61202 6.33,-2.81c1.6,-1.033333 3.043333,-1.973333 4.33,-2.82c0.730522,-0.575569 1.566043,-1.003518 2.46,-1.26c2.231153,-0.027462 4.447179,0.36959 6.53,1.17c1.85392,0.709124 3.552144,1.772212 5,3.13c1.433221,1.395818 2.655998,2.992502 3.63,4.74c1.035402,1.810965 1.879932,3.724562 2.52,5.71c0.659148,2.08682 1.180274,4.21475 1.56,6.37c0.387846,2.110376 0.661577,4.240137 0.82,6.38c0.12,1.98 0.18,4.003333 0.18,6.07l0,0zm-25.31,-68.2c4.294957,4.160565 6.679797,9.910962 6.59,15.89c0.092571,5.982495 -2.29249,11.737042 -6.59,15.9c-4.162958,4.29751 -9.917505,6.682571 -15.9,6.59c-5.982495,0.092571 -11.737042,-2.29249 -15.9,-6.59c-4.29751,-4.162958 -6.682571,-9.917505 -6.59,-15.9c-0.092571,-5.982495 2.29249,-11.737042 6.59,-15.9c4.162958,-4.29751 9.917505,-6.682571 15.9,-6.59c5.983986,-0.089959 11.738754,2.298813 15.9,6.6l0,0z" })
	  );
	}
	
	function iconInstructor() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-instructor", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 100 100", "aria-labelledby": "icn-instructor-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-instructor-title" },
	      "Instructor"
	    ),
	    _react2.default.createElement("path", { d: "m81.48,88.48l-68,0c-1.622538,-0.016347 -3.037216,-1.135228 -3.429258,-2.720124l-7.681434,-30.285724c-0.276351,-1.075327 -0.040317,-2.214764 0.638536,-3.089322c0.678853,-0.874558 1.724141,-1.385833 2.831251,-1.38483l83.330905,0c1.103372,0.000228 2.145168,0.509417 2.823334,1.380035c0.678165,0.870618 0.916898,2.005351 0.647027,3.075423l-7.689632,30.298546c-0.396368,1.601957 -1.827765,2.723863 -3.472027,2.725997l0.001298,-0.000001zm0.001298,1.999999c2.562843,-0.003325 4.793903,-1.751995 5.409432,-4.239825l7.688541,-30.294178c0.421004,-1.669333 0.048902,-3.437994 -1.008128,-4.794992c-1.057029,-1.356997 -2.680834,-2.150649 -4.400936,-2.151004l-83.330207,0c-1.724702,-0.001562 -3.353949,0.795341 -4.412049,2.158479c-1.058101,1.363139 -1.425997,3.139132 -0.996478,4.81043l7.679219,30.276939c0.609626,2.464589 2.814626,4.208543 5.359265,4.234102l68.010043,0.00005l0.001298,-0.000001zm-66.811298,-41.479999c0,-1.327247 0.046667,-2.654493 0.14,-3.98174c0.104032,-1.40559 0.284295,-2.804557 0.54,-4.190781c0.240849,-1.410665 0.574907,-2.80398 1,-4.170873c0.41976,-1.294218 0.972694,-2.541814 1.65,-3.722927c0.641162,-1.145138 1.446258,-2.191345 2.39,-3.105757c0.955491,-0.890752 2.076446,-1.587305 3.3,-2.050596c1.371568,-0.524502 2.830817,-0.784617 4.3,-0.766485c0.588832,0.167927 1.139107,0.44857 1.62,0.826211l2.9,1.8316c1.306907,0.78552 2.70791,1.404231 4.17,1.841555c3.344242,1.101078 6.955758,1.101078 10.3,0c1.458525,-0.438398 2.856088,-1.057073 4.16,-1.841555l2.86,-1.841554c0.481032,-0.377426 1.031262,-0.658047 1.62,-0.826211c1.469183,-0.018132 2.928432,0.241982 4.3,0.766485c1.223325,0.463749 2.344195,1.16025 3.3,2.050596c0.94353,0.9146 1.748601,1.960774 2.39,3.105757c0.686966,1.176759 1.249955,2.421023 1.68,3.712972c0.424619,1.367023 0.75867,2.760306 1,4.170873c0.255705,1.386224 0.435968,2.785191 0.54,4.190781c0.093333,1.294066 0.14,2.621313 0.14,3.98174l-54.3,0.019909zm62.646195,-16.546566c-0.385313,0.114872 -0.793549,0.176566 -1.216195,0.176566c-2.34721,0 -4.25,-1.90279 -4.25,-4.25c0,-2.34721 1.90279,-4.25 4.25,-4.25c2.34721,0 4.25,1.90279 4.25,4.25c0,1.204601 -0.501156,2.292151 -1.306344,3.065524l4.790362,8.221015l0.131719,0.22605l0.004138,0.261594l0.14,8.85l-1.99975,0.031634l-0.14,-8.85l0.135857,0.487644l-4.789787,-8.220027zm-25.016195,-27.953434c2.837694,2.748383 4.40909,6.550147 4.34,10.5c-0.016535,8.16924 -6.640745,14.784504 -14.81,14.79c-8.177062,0.005534 -14.813449,-6.612953 -14.83,-14.79c-0.005312,-3.935706 1.555104,-7.711889 4.337133,-10.495793c2.782028,-2.783905 6.557159,-4.346866 10.492867,-4.344207c3.939486,-0.060753 7.72879,1.50998 10.47,4.34l0,0z" })
	  );
	}
	
	function iconTestingCenters() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-testing-centers", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 100 100", "aria-labelledby": "icn-testing-centers-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-testing-centers-title" },
	      "Testing Centers"
	    ),
	    _react2.default.createElement("path", { d: "m24.15,91l-18.103814,0c-1.867581,0 -3.381554,-1.392394 -3.381554,-3.11l0,-65.28c0,-1.717606 1.513973,-3.11 3.381554,-3.11l13.754549,0l0,-2l-13.754549,0c-3.068597,0 -5.556186,2.287825 -5.556186,5.11l0,65.28c0,2.822175 2.487589,5.11 5.556186,5.11l18.103814,0l0,-2l0,0zm-0.72,2l35.57,0c2.822175,0 5.11,-2.287825 5.11,-5.11l0,-82.2c0,-2.822175 -2.287825,-5.11 -5.11,-5.11l-35.57,0c-2.822175,0 -5.11,2.287825 -5.11,5.11l0,86.31l0,1l1,0l4.11,0l0,0zm0,-2l-4.11,0l1,1l0,-86.31c0,-1.717606 1.392394,-3.11 3.11,-3.11l35.57,0c1.717606,0 3.11,1.392394 3.11,3.11l0,82.2c0,1.717606 -1.392394,3.11 -3.11,3.11l-35.57,0l0,0zm16.77,-16.67l0,17.67l2,0l0,-17.67l-2,0l0,0zm-34.87,-48.14l9.88,0l0,9.88l-9.88,0l0,-9.88zm0,15.73l9.88,0l0,9.88l-9.88,0l0,-9.88zm0,15.74l9.88,0l0,9.88l-9.88,0l0,-9.88zm0,15.73l9.88,0l0,9.88l-9.88,0l0,-9.88zm17.12,-63.14l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,15.94l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,15.93l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,15.94l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-5.89,17.27l21.66,0l-1,-1l0,17.33l1,-1l-21.66,0l1,1l0,-17.33l-1,1l0,0zm0,-2l-1,0l0,1l0,17.33l0,1l1,0l21.66,0l1,0l0,-1l0,-17.33l0,-1l-1,0l-21.66,0l0,0z" })
	  );
	}
	
	function iconCentersIndivuals() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-centers-individuals", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 100 100", "aria-labelledby": "icn-centers-individuals-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-centers-individuals-title" },
	      "Testing Centers and Individuals"
	    ),
	    _react2.default.createElement("path", { d: "m2.32,5.395257c0,-1.716208 1.391547,-3.105257 3.115894,-3.105257l35.518212,0c1.717928,0 3.115894,1.396503 3.115894,3.105257l0,82.209486c0,1.716208 -1.391547,3.105257 -3.115894,3.105257l-35.518212,0c-1.717928,0 -3.115894,-1.396503 -3.115894,-3.105257l0,-82.209486l0,0zm-2,82.209486c0,2.813793 2.293865,5.105257 5.115894,5.105257l35.518212,0c2.828113,0 5.115894,-2.283674 5.115894,-5.105257l0,-82.209486c0,-2.813793 -2.293865,-5.105257 -5.115894,-5.105257l-35.518212,0c-2.828113,0 -5.115894,2.283674 -5.115894,5.105257l0,82.209486zm4.13,-77.654743l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,15.94l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,15.94l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,15.93l9.88,0l0,9.88l-9.88,0l0,-9.88zm27.62,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-13.81,0l9.88,0l0,9.88l-9.88,0l0,-9.88zm-5.89,17.28l21.66,0l-1,-1l0,17.33l1,-1l-21.66,0l1,1l0,-17.33l-1,1l0,0zm0,-2l-1,0l0,1l0,17.33l0,1l1,0l21.66,0l1,0l0,-1l0,-17.33l0,-1l-1,0l-21.66,0zm9.83,1l0,17.66l2,0l0,-17.66l-2,0zm67.15,15.87c-2.073744,1.876381 -4.80659,2.854452 -7.6,2.72c0,0 -23.364112,-0.036478 -34.394054,-0.055995c-4.028229,-0.007127 -6.535261,0.000001 -5.534413,0.000001c1.79689,0 3.447571,-2.038971 3.674927,-2.525299c0.496025,-1.20282 0.57354,-2.177202 0.57354,-2.177202l0,-27.061505c0,0 3.001606,-0.828942 4.52,-0.81c0.599396,0.170026 1.159864,0.455355 1.65,0.84l2.92,1.88c1.325681,0.801386 2.746814,1.433001 4.23,1.88c3.396252,1.122937 7.063748,1.122937 10.46,0c1.483075,-0.447297 2.904173,-1.078896 4.23,-1.88l2.92,-1.85c0.490274,-0.384428 1.050698,-0.669735 1.65,-0.84c1.492935,-0.019288 2.975927,0.245411 4.37,0.78c1.242486,0.475726 2.380359,1.18902 3.35,2.1c0.95923,0.933422 1.777777,2.001239 2.43,3.17c0.694086,1.21138 1.260459,2.491583 1.69,3.82c0.425697,1.393333 0.759744,2.813034 1,4.25c0.259988,1.412407 0.443588,2.837812 0.55,4.27c0.113333,1.326667 0.17,2.68 0.17,4.06c0.144768,2.770389 -0.895037,5.471701 -2.86,7.43zm-14.09,-53.07c2.833533,2.815717 4.426902,6.645357 4.426902,10.64c0,3.994643 -1.593369,7.824283 -4.426902,10.64c-4.286057,4.35465 -10.785107,5.674357 -16.430187,3.33634c-5.645081,-2.338017 -9.30785,-7.866434 -9.259813,-13.97634c-0.048037,-6.109906 3.614732,-11.638323 9.259813,-13.97634c5.64508,-2.338017 12.14413,-1.01831 16.430187,3.33634l0,0z" })
	  );
	}
	
	function iconExamity() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-examity", xmlns: "http://www.w3.org/2000/svg", width: "369", height: "413", viewBox: "0 0 369 413", "aria-labelledby": "icn-examity-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-examity-title" },
	      "Examity"
	    ),
	    _react2.default.createElement(
	      "g",
	      { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
	      _react2.default.createElement("path", { d: "M0,0 L369,0 L369,245.000561 C369,245.000561 366.378906,281.325473 346.394531,298.860669 C326.410156,316.395866 184.5,413.290009 184.5,413.290009 C184.5,413.290009 41.9213646,316.951358 21.9345703,298.860669 C1.94777598,280.76998 0,245.000561 0,245.000561 L0,0 Z", fill: "#F99500" }),
	      _react2.default.createElement("path", { d: "M345,21 L345,233 C345,233 346.260742,269.49707 322.394531,286.859985 C298.52832,304.2229 184.5,384.289062 184.5,384.289062 L184.5,21 L345,21 Z", fill: "#FEB130" }),
	      _react2.default.createElement("path", { d: "M165.5,205 L115.490833,205 C106.107055,205 98.5,212.609095 98.5,222 C98.5,231.388841 106.113054,239 115.490833,239 L175.75,239 L167,239 L171.921312,216.361967 C167.989025,213.611282 165.5,209.541321 165.5,205 Z M184.5,190.005372 L184.5,164 L115.490833,164 C106.107055,164 98.5,171.609095 98.5,181 C98.5,190.388841 106.113054,198 115.490833,198 L167.633773,198 C170.7356,193.242196 176.900826,190 184,190 C184.167194,190 184.33387,190.001798 184.5,190.005372 Z M184.5,246 L184.5,280 L115.490833,280 C106.113054,280 98.5,272.388841 98.5,263 C98.5,253.609095 106.107055,246 115.490833,246 L184.5,246 Z", fill: "#E7E7E9" }),
	      _react2.default.createElement("path", { d: "M202.5,205 L253.509167,205 C262.892945,205 270.5,212.609095 270.5,222 C270.5,231.388841 262.886946,239 253.509167,239 L192.75,239 L201,239 L196.078688,216.361967 C200.010975,213.611282 202.5,209.541321 202.5,205 Z M200.366218,198 L253.509167,198 C262.886946,198 270.5,190.388841 270.5,181 C270.5,171.609095 262.892945,164 253.509167,164 L184.5,164 L184.5,190.005372 C191.387873,190.153556 197.337453,193.354249 200.366218,198 Z M184.5,246 L253.509167,246 C262.892945,246 270.5,253.609095 270.5,263 C270.5,272.388841 262.886946,280 253.509167,280 L184.5,280 L184.5,246 Z", fill: "#FFFFFF" }),
	      _react2.default.createElement("path", { d: "M150,158 L128,158 L128,166.5 L128,122 C128,92.7289083 151.735198,69 181.007127,69 L186.992873,69 C216.267901,69 240,92.7224724 240,122 L240,166.5 L240,158 L218,158 L218,149.955357 L218,123.732143 C218,106.203111 203.791587,92 186.264622,92 L181.735378,92 C164.213622,92 150,106.206964 150,123.732143 L150,149.955357 L150,158 Z", fill: "#E7E7E9" }),
	      _react2.default.createElement("path", { d: "M128,162 L128,166.5 L128,162 L128,162 Z M184.5,69 L186.992873,69 C216.267901,69 240,92.7224724 240,122 L240,166.5 L240,158 L218,158 L218,149.955357 L218,123.732143 C218,106.203111 203.791587,92 186.264622,92 L184.5,92 L184.5,69 Z", fill: "#FFFFFF" })
	    )
	  );
	}
	
	function iconProctorU() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-proctoru", xmlns: "http://www.w3.org/2000/svg", width: "56", height: "89", viewBox: "0 0 56 89", "aria-labelledby": "icn-proctoru-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-proctoru-title" },
	      "ProctorU"
	    ),
	    _react2.default.createElement(
	      "g",
	      { stroke: "none", fillRule: "nonzero", fill: "#00B2E3" },
	      _react2.default.createElement("path", { d: "M54.4,84.1 C52.3,83.7 51.3,81.8 51.2,78.3 L51.2,36.2 L42,36.2 L42,62.6 C42.1127672,67.3637433 40.3118817,71.9740102 37,75.4 C34.0836635,78.2267451 30.1607863,79.7743021 26.1,79.7 C17.2,79.6 10.7,72.2 10.7,62.1 L10.7,42.3 C10.6835833,38.8826577 7.91734235,36.1164167 4.5,36.1 L1.5,36.1 L1.5,62.5 C1.36209305,69.7762934 4.21818418,76.7899855 9.4,81.9 C13.9454313,86.3240817 20.05739,88.7688652 26.4,88.7 L27.1,88.7 C32.9,88.5 37.3,86.6 42.1,82 C42.3009589,83.3904082 42.9301113,84.6836658 43.9,85.7 C45.435538,87.3469725 47.6637748,88.1639926 49.9,87.9 C51.8811342,87.7836371 53.6939423,86.7477468 54.8,85.1 L55.4,84.1 L54.4,84.1 Z" }),
	      _react2.default.createElement("path", { d: "M14.4,25 C17.7137085,25 20.4,22.3137085 20.4,19 C20.4,15.6862915 17.7137085,13 14.4,13 C11.0862915,13 8.4,15.6862915 8.4,19 C8.4,22.3137085 11.0862915,25 14.4,25 L14.4,25 Z" }),
	      _react2.default.createElement("path", { d: "M14.4,32.9 C17.3532259,32.9093841 20.230077,31.9621283 22.6,30.2 L25.7,34 C25.8891647,34.1816809 26.1379796,34.2883159 26.4,34.3 C26.6659703,34.3071418 26.9217438,34.1975245 27.1,34 L30.2,30.2 C32.569923,31.9621283 35.4467741,32.9093841 38.4,32.9 C42.0889521,32.9079877 45.6291144,31.4460927 48.2376036,28.8376036 C50.8460927,26.2291144 52.3079877,22.6889521 52.3,19 C52.3125218,15.264544 50.7947419,11.6869199 48.1,9.1 L51.6,5 C52.1906073,4.11849265 52.4394876,3.05186283 52.3,2 C52.3,0.6 52.1,-0.3 51,0.1 C51,0.1 34.3,7.3 26.3,7.3 C18.3,7.3 1.6,0.1 1.6,0.1 C0.5,-0.3 0.3,0.6 0.3,2 C0.172248407,3.05125881 0.420184084,4.11384028 1,5 L4.5,9.1 C1.80525811,11.6869199 0.287478185,15.264544 0.3,19 C0.446526091,26.6930833 6.70560851,32.8633844 14.4,32.9 Z M38.3,9.3 C42.2232838,9.3 45.7602558,11.6633291 47.2616315,15.2879707 C48.7630072,18.9126123 47.9331163,23.0847552 45.1589358,25.8589358 C42.3847552,28.6331163 38.2126123,29.4630072 34.5879707,27.9616315 C30.9633291,26.4602558 28.6,22.9232838 28.6,19 C28.605512,13.6451227 32.9451227,9.30551197 38.3,9.3 L38.3,9.3 Z M26.4,26.1 L26.4,31.3 C26.4053603,31.4004141 26.3387857,31.4905356 26.2412311,31.5149242 C26.1436764,31.5393129 26.042524,31.4911232 26,31.4 L23.9,28.9 C24.836032,28.063705 25.6746743,27.1244256 26.4,26.1 L26.4,26.1 Z M14.4,9.3 C19.7571621,9.3 24.1,13.6428379 24.1,19 C24.1,24.3571621 19.7571621,28.7 14.4,28.7 C9.04283793,28.7 4.7,24.3571621 4.7,19 C4.70551197,13.6451227 9.04512272,9.30551197 14.4,9.3 L14.4,9.3 Z" }),
	      _react2.default.createElement("path", { d: "M38.3,25 C41.6137085,25 44.3,22.3137085 44.3,19 C44.3,15.6862915 41.6137085,13 38.3,13 C34.9862915,13 32.3,15.6862915 32.3,19 C32.3,22.3137085 34.9862915,25 38.3,25 L38.3,25 Z" })
	    )
	  );
	}
	
	// Incident type icons
	function icon_injured() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-injured", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-injured-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-injured-title" },
	      "Injured"
	    ),
	    _react2.default.createElement("path", { d: "M1280 1120v-192q0-14-9-23t-23-9h-224v-224q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v224h-224q-14 0-23 9t-9 23v192q0 14 9 23t23 9h224v224q0 14 9 23t23 9h192q14 0 23-9t9-23v-224h224q14 0 23-9t9-23zm-640-736h512v-128h-512v128zm-384 0v1280h-32q-92 0-158-66t-66-158v-832q0-92 66-158t158-66h32zm1184 0v1280h-1088v-1280h160v-160q0-40 28-68t68-28h576q40 0 68 28t28 68v160h160zm352 224v832q0 92-66 158t-158 66h-32v-1280h32q92 0 158 66t66 158z" })
	  );
	}
	
	function icon_technical() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-technical", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-technical-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-technical-title" },
	      "Technical"
	    ),
	    _react2.default.createElement("path", { d: "M352 1280q-66 0-113-47t-47-113v-704q0-66 47-113t113-47h1088q66 0 113 47t47 113v704q0 66-47 113t-113 47h-1088zm-32-864v704q0 13 9.5 22.5t22.5 9.5h1088q13 0 22.5-9.5t9.5-22.5v-704q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5zm1376 928h160v96q0 40-47 68t-113 28h-1600q-66 0-113-28t-47-68v-96h1760zm-720 96q16 0 16-16t-16-16h-160q-16 0-16 16t16 16h160z" })
	  );
	}
	
	function icon_space() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-space", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-space-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-space-title" },
	      "space"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-1024-864q0-14 9-23t23-9h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64zm736 224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704zm0 256q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704z" })
	  );
	}
	
	function icon_outside_help() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-outside-help", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-outside-help-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-outside-help-title" },
	      "Outside Help"
	    ),
	    _react2.default.createElement("path", { transform: "translate(65, 0)", d: "M529 896q-162 5-265 128h-134q-82 0-138-40.5t-56-118.5q0-353 124-353 6 0 43.5 21t97.5 42.5 119 21.5q67 0 133-23-5 37-5 66 0 139 81 256zm1071 637q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q10 0 43 21.5t73 48 107 48 135 21.5 135-21.5 107-48 73-48 43-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zm-1024-1277q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zm704 384q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5zm576 225q0 78-56 118.5t-138 40.5h-134q-103-123-265-128 81-117 81-256 0-29-5-66 66 23 133 23 59 0 119-21.5t97.5-42.5 43.5-21q124 0 124 353zm-128-609q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181z" })
	  );
	}
	
	function icon_non_permitted_items() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-items", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-items-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-items-title" },
	      "Non-permitted Items"
	    ),
	    _react2.default.createElement("path", { d: "M1703 478q40 57 18 129l-275 906q-19 64-76.5 107.5t-122.5 43.5h-923q-77 0-148.5-53.5t-99.5-131.5q-24-67-2-127 0-4 3-27t4-37q1-8-3-21.5t-3-19.5q2-11 8-21t16.5-23.5 16.5-23.5q23-38 45-91.5t30-91.5q3-10 .5-30t-.5-28q3-11 17-28t17-23q21-36 42-92t25-90q1-9-2.5-32t.5-28q4-13 22-30.5t22-22.5q19-26 42.5-84.5t27.5-96.5q1-8-3-25.5t-2-26.5q2-8 9-18t18-23 17-21q8-12 16.5-30.5t15-35 16-36 19.5-32 26.5-23.5 36-11.5 47.5 5.5l-1 3q38-9 51-9h761q74 0 114 56t18 130l-274 906q-36 119-71.5 153.5t-128.5 34.5h-869q-27 0-38 15-11 16-1 43 24 70 144 70h923q29 0 56-15.5t35-41.5l300-987q7-22 5-57 38 15 59 43zm-1064 2q-4 13 2 22.5t20 9.5h608q13 0 25.5-9.5t16.5-22.5l21-64q4-13-2-22.5t-20-9.5h-608q-13 0-25.5 9.5t-16.5 22.5zm-83 256q-4 13 2 22.5t20 9.5h608q13 0 25.5-9.5t16.5-22.5l21-64q4-13-2-22.5t-20-9.5h-608q-13 0-25.5 9.5t-16.5 22.5z" })
	  );
	}
	
	function icon_noisy() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-noisy-help", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-noisy-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-noisy-title" },
	      "Noisy"
	    ),
	    _react2.default.createElement("path", { d: "M832 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45zm384 544q0 76-42.5 141.5t-112.5 93.5q-10 5-25 5-26 0-45-18.5t-19-45.5q0-21 12-35.5t29-25 34-23 29-35.5 12-57-12-57-29-35.5-34-23-29-25-12-35.5q0-27 19-45.5t45-18.5q15 0 25 5 70 27 112.5 93t42.5 142zm256 0q0 153-85 282.5t-225 188.5q-13 5-25 5-27 0-46-19t-19-45q0-39 39-59 56-29 76-44 74-54 115.5-135.5t41.5-173.5-41.5-173.5-115.5-135.5q-20-15-76-44-39-20-39-59 0-26 19-45t45-19q13 0 26 5 140 59 225 188.5t85 282.5zm256 0q0 230-127 422.5t-338 283.5q-13 5-26 5-26 0-45-19t-19-45q0-36 39-59 7-4 22.5-10.5t22.5-10.5q46-25 82-51 123-91 192-227t69-289-69-289-192-227q-36-26-82-51-7-4-22.5-10.5t-22.5-10.5q-39-23-39-59 0-26 19-45t45-19q13 0 26 5 211 91 338 283.5t127 422.5z" })
	  );
	}
	
	function icon_ill() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-ill", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1930 1930", "aria-labelledby": "icn-ill-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-ill-title" },
	      "Ill"
	    ),
	    _react2.default.createElement("path", { transform: "translate(65, 0)", d: "M576 1408q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm-384-512h384v-256h-158q-14 2-22 9l-195 195q-7 12-9 22v30zm1280 512q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm128-672v-192q0-14-9-23t-23-9h-224v-224q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v224h-224q-14 0-23 9t-9 23v192q0 14 9 23t23 9h224v224q0 14 9 23t23 9h192q14 0 23-9t9-23v-224h224q14 0 23-9t9-23zm256-544v1152q0 26-19 45t-45 19h-192q0 106-75 181t-181 75-181-75-75-181h-384q0 106-75 181t-181 75-181-75-75-181h-128q-26 0-45-19t-19-45 19-45 45-19v-416q0-26 13-58t32-51l198-198q19-19 51-32t58-13h160v-320q0-26 19-45t45-19h1152q26 0 45 19t19 45z" })
	  );
	}
	
	function icon_time() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-time", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-time-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-time-title" },
	      "Time"
	    ),
	    _react2.default.createElement("path", { d: "M1024 544v448q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-352q0-14 9-23t23-9h64q14 0 23 9t9 23zm416 352q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zm224 0q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z" })
	  );
	}
	
	function icon_other() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-other", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-other-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-other-title" },
	      "Other"
	    ),
	    _react2.default.createElement("path", { d: "M576 736v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zm512 0v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zm512 0v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68z" })
	  );
	}
	
	// File types
	function icon_file() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-file", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-file-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-file-title" },
	      "File"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280z" })
	  );
	}
	
	function icon_image() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-image", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-image-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-image-title" },
	      "Image"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-128-448v320h-1024v-192l192-192 128 128 384-384zm-832-192q-80 0-136-56t-56-136 56-136 136-56 136 56 56 136-56 136-136 56z" })
	  );
	}
	
	function icon_pdf() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-pdf", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-pdf-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-pdf-title" },
	      "PDF"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-514-593q33 26 84 56 59-7 117-7 147 0 177 49 16 22 2 52 0 1-1 2l-2 2v1q-6 38-71 38-48 0-115-20t-130-53q-221 24-392 83-153 262-242 262-15 0-28-7l-24-12q-1-1-6-5-10-10-6-36 9-40 56-91.5t132-96.5q14-9 23 6 2 2 2 4 52-85 107-197 68-136 104-262-24-82-30.5-159.5t6.5-127.5q11-40 42-40h22q23 0 35 15 18 21 9 68-2 6-4 8 1 3 1 8v30q-2 123-14 192 55 164 146 238zm-576 411q52-24 137-158-51 40-87.5 84t-49.5 74zm398-920q-15 42-2 132 1-7 7-44 0-3 7-43 1-4 4-8-1-1-1-2-1-2-1-3-1-22-13-36 0 1-1 2v2zm-124 661q135-54 284-81-2-1-13-9.5t-16-13.5q-76-67-127-176-27 86-83 197-30 56-45 83zm646-16q-24-24-140-24 76 28 124 28 14 0 18-1 0-1-2-3z" })
	  );
	}
	
	function icon_text() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-text", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-text-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-text-title" },
	      "Text"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-1024-864q0-14 9-23t23-9h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64zm736 224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704zm0 256q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704z" })
	  );
	}
	
	function icon_spreadsheet() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-spreadsheet", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-spreadsheet-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-spreadsheet-title" },
	      "Spreadsheet"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-979-234v106h281v-106h-75l103-161q5-7 10-16.5t7.5-13.5 3.5-4h2q1 4 5 10 2 4 4.5 7.5t6 8 6.5 8.5l107 161h-76v106h291v-106h-68l-192-273 195-282h67v-107h-279v107h74l-103 159q-4 7-10 16.5t-9 13.5l-2 3h-2q-1-4-5-10-6-11-17-23l-106-159h76v-107h-290v107h68l189 272-194 283h-68z" })
	  );
	}
	
	function icon_video() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-video", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-video-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-video-title" },
	      "Video"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-640-896q52 0 90 38t38 90v384q0 52-38 90t-90 38h-384q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h384zm492 2q20 8 20 30v576q0 22-20 30-8 2-12 2-14 0-23-9l-265-266v-90l265-266q9-9 23-9 4 0 12 2z" })
	  );
	}
	
	function icon_audio() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-audio", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-audio-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-audio-title" },
	      "Audio"
	    ),
	    _react2.default.createElement("path", { d: "M1596 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zm-788-814q20 8 20 30v544q0 22-20 30-8 2-12 2-12 0-23-9l-166-167h-131q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h131l166-167q16-15 35-7zm417 689q31 0 50-24 129-159 129-363t-129-363q-16-21-43-24t-47 14q-21 17-23.5 43.5t14.5 47.5q100 123 100 282t-100 282q-17 21-14.5 47.5t23.5 42.5q18 15 40 15zm-211-148q27 0 47-20 87-93 87-219t-87-219q-18-19-45-20t-46 17-20 44.5 18 46.5q52 57 52 131t-52 131q-19 20-18 46.5t20 44.5q20 17 44 17z" })
	  );
	}
	
	function icon_zip() {
	  return _react2.default.createElement(
	    "svg",
	    { "aria-hidden": "true", className: "icn icn-zip", xmlns: "http://www.w3.org/2000/svg", width: "1792", height: "1792", viewBox: "0 0 1792 1792", "aria-labelledby": "icn-zip-title" },
	    _react2.default.createElement(
	      "title",
	      { id: "icn-zip-title" },
	      "Zip"
	    ),
	    _react2.default.createElement("path", { d: "M768 384v-128h-128v128h128zm128 128v-128h-128v128h128zm-128 128v-128h-128v128h128zm128 128v-128h-128v128h128zm700-388q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zm-444-244v376h376q-10-29-22-41l-313-313q-12-12-41-22zm384 1528v-1024h-416q-40 0-68-28t-28-68v-416h-128v128h-128v-128h-512v1536h1280zm-627-721l107 349q8 27 8 52 0 83-72.5 137.5t-183.5 54.5-183.5-54.5-72.5-137.5q0-25 8-52 21-63 120-396v-128h128v128h79q22 0 39 13t23 34zm-141 465q53 0 90.5-19t37.5-45-37.5-45-90.5-19-90.5 19-37.5 45 37.5 45 90.5 19z" })
	  );
	}

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(522);
	var iterableToArrayLimit = __webpack_require__(529);
	var unsupportedIterableToArray = __webpack_require__(140);
	var nonIterableRest = __webpack_require__(530);
	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
	}
	module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getSmarterElementsInstance = exports.Validate = exports.schApi = exports.api = exports.config = undefined;
	exports.setToken = setToken;
	exports.setValidate = setValidate;
	
	var _axios = __webpack_require__(161);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _iamReactClient = __webpack_require__(58);
	
	var _iamReactClient2 = _interopRequireDefault(_iamReactClient);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _helpers = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Using global SmarterElements from CDN script instead of import
	var SmarterElementsInstance = null;
	
	// Helpers
	var config = exports.config = {
	  apiUrl: 'http://localhost:8011/v1',
	  // apiUrl: 'https://api.dev.smarterproctoring.com/v1',
	  schUrl: 'http://localhost:8013/v1',
	  domain: 'http://localhost:3002',
	  mapsApiKey: 'AIzaSyBXUGDThYYVJOIcfKhKiUCbkQJz8LDVvXg',
	  ldApiKey: '59edfdfd082f980b153ac148',
	  logRocket: 'bkdp5p/proctor-ui-production',
	  testingCenterSid: 'TC180270c80a324de68af4ac8c5a151423',
	  testingAdministratorSid: 'TSc8a267352ced49f1886db9ad972ec797',
	  generalPublicSid: 'TSf2372716b074429a8253af78afd3d51c',
	  onlineLocationSid: 'LT6ed9000faf944bfbb7af4924a3068fc1',
	  coffeeShopSid: 'LT25c1697388414af2a73cc7dd25e49abb',
	  docsDomain: 'https://smarterproctoring.zendesk.com/hc/en-us/',
	  defaultTimeZoneSid: 'TZ356c0b38525c4d94a1b60e76ded97066',
	  gaProctor: 'UA-42156997-3',
	  hybridDomain: 'http://localhost:3009',
	  hybridBetaDomain: 'http://localhost:3009',
	  hybridAlphaDomain: 'http://localhost:3009',
	  schedulingDomain: 'https://proctor.scheduling.dev.smarterproctoring.com',
	  checkoutUrlBase: 'https://support.dev.smarterservices.com/index.cfm?action=hybridCheckout',
	  supportScriptUrl: 'https://help.dev.smarterservices.com/embed/in-app-widget.js'
	};
	
	if (true) {
	  config.apiUrl =  true ? 'https://api.smarterproctoring.com/v1' : 'https://api-b.smarterproctoring.com/v1';
	  config.schUrl = 'https://scheduling.smarterproctoring.com/v1';
	  config.domain =  true ? 'https://app.smarterproctoring.com' : 'https://app-b.smarterproctoring.com';
	  config.ldApiKey = '55b25a2f133767270f000092';
	  config.testingCenterSid = 'TCd350ab0c17b846f799b51f15f684e77c';
	  config.testingAdministratorSid = 'TSde44f39d587d4acc8d6c3fc8a8aa7282';
	  config.generalPublicSid = 'TSf2372716b074429a8253af78afd3d51c';
	  config.onlineLocationSid = 'LT07b8055c8a9c457c82c58b235a05d53b';
	  config.coffeeShopSid = 'LT1fef2992eda74744a432dc963c9877ed';
	  config.defaultTimeZoneSid = 'TZ87effa3d827b480ba4919ef38175fe5f';
	  config.hybridDomain = 'https://hybrid.smarterproctoring.com';
	  config.hybridBetaDomain = 'https://hybrid.beta.smarterproctoring.com';
	  config.hybridAlphaDomain = 'https://hybrid.alpha.smarterproctoring.com';
	  config.schedulingDomain = 'https://proctor.scheduling.smarterproctoring.com';
	  config.platformDomain = 'https://app.smarterservices.com';
	  config.checkoutUrlBase = 'https://support.smarterservices.com/index.cfm?action=hybridCheckout';
	  config.supportScriptUrl = 'https://help.smarterservices.com/embed/in-app-widget.js';
	}
	
	if (false) {
	  config.apiUrl = 'https://api.dev.smarterproctoring.com/v1';
	  config.schUrl = 'https://scheduling.smarterproctoring.com/v1';
	  config.domain = 'https://app-qa.smarterproctoring.com';
	  config.ldApiKey = '55b25a2f133767270f000092';
	  config.testingCenterSid = 'TCd350ab0c17b846f799b51f15f684e77c';
	  config.testingAdministratorSid = 'TSde44f39d587d4acc8d6c3fc8a8aa7282';
	  config.generalPublicSid = 'TSf2372716b074429a8253af78afd3d51c';
	  config.onlineLocationSid = 'LT07b8055c8a9c457c82c58b235a05d53b';
	  config.coffeeShopSid = 'LT1fef2992eda74744a432dc963c9877ed';
	  config.defaultTimeZoneSid = 'TZ87effa3d827b480ba4919ef38175fe5f';
	  config.hybridDomain = 'https://hybrid-qa.smarterproctoring.com';
	  config.hybridBetaDomain = 'https://hybrid-qa.smarterproctoring.com';
	  config.hybridAlphaDomain = 'https://hybrid-qa.smarterproctoring.com';
	  config.platformDomain = 'https://app.qa.smarterservices.com';
	}
	
	if (false) {
	  config.apiUrl = 'http://localhost:8011/v1';
	  config.schUrl = 'https://scheduling-stage.smarterproctoring.com/v1';
	  config.domain = 'http://localhost:3002';
	  config.hybridDomain = 'http://localhost:3009';
	  config.schedulingDomain = 'http://localhost:8017';
	  config.platformDomain = 'http://localhost:4000';
	}
	
	if (false) {
	  config.apiUrl = 'https://api-stage.smarterproctoring.com/v1';
	  config.schUrl = 'https://scheduling-stage.smarterproctoring.com/v1';
	  config.domain = 'https://stage.smarterproctoring.com';
	  config.hybridDomain = 'https://hybrid-stage.smarterproctoring.com';
	  config.hybridBetaDomain = 'https://hybrid-stage.smarterproctoring.com';
	  config.hybridAlphaDomain = 'https://hybrid-stage.smarterproctoring.com';
	  config.schedulingDomain = 'https://proctor.scheduling.stage.smarterproctoring.com';
	  config.platformDomain = 'https://app.stage.smarterservices.com';
	}
	
	if (false) {
	  config.apiUrl = 'https://api.dev.smarterproctoring.com/v1';
	  config.schUrl = 'https://scheduling.dev.smarterproctoring.com/v1';
	  config.domain = 'https://dev.smarterproctoring.com';
	  config.hybridDomain = 'https://hybrid.dev.smarterproctoring.com';
	  config.hybridBetaDomain = 'https://hybrid.dev.smarterproctoring.com';
	  config.hybridAlphaDomain = 'https://hybrid.dev.smarterproctoring.com';
	  config.schedulingDomain = 'https://proctor.scheduling.dev.smarterproctoring.com';
	  config.platformDomain = 'https://app.dev.smarterservices.com';
	}
	
	if (false) {
	  config.apiUrl = 'https://api.sub.smarterproctoring.com/v1';
	  config.schUrl = 'https://scheduling-stage.smarterproctoring.com/v1';
	  config.domain = 'https://sub.smarterproctoring.com';
	  config.hybridDomain = 'https://hybrid.sub.smarterproctoring.com';
	  config.hybridBetaDomain = 'https://hybrid.sub.smarterproctoring.com';
	  config.hybridAlphaDomain = 'https://hybrid.sub.smarterproctoring.com';
	  config.schedulingDomain = 'https://proctor.scheduling.dev.smarterproctoring.com';
	  config.platformDomain = 'https://app.sub.smarterservices.com';
	}
	
	var api = exports.api = _axios2.default.create({
	  baseURL: config.apiUrl
	});
	
	var schApi = exports.schApi = _axios2.default.create({
	  baseURL: config.schedulingUrl
	});
	
	function setToken(token, callback) {
	  exports.api = api = _axios2.default.create({
	    baseURL: config.apiUrl,
	    headers: { token: token }
	  });
	
	  exports.schApi = schApi = _axios2.default.create({
	    baseURL: config.schUrl,
	    headers: { token: token }
	  });
	
	  if (token && callback) {
	    setTimeout(function () {
	      callback();
	    });
	  }
	}
	
	var Validate = exports.Validate = null;
	
	if (_SessionStore2.default && _SessionStore2.default.hasSessionStorage) {
	  exports.Validate = Validate = new _iamReactClient2.default({ iam: JSON.parse(sessionStorage.getItem('iam')) });
	} else {
	  try {
	    exports.Validate = Validate = new _iamReactClient2.default({ iam: JSON.parse((0, _helpers.getCookie)('iam')) });
	  } catch (err) {
	    exports.Validate = Validate = new _iamReactClient2.default({ iam: undefined });
	  }
	}
	
	function setValidate() {
	  if (_SessionStore2.default.hasSessionStorage) {
	    exports.Validate = Validate = new _iamReactClient2.default({ iam: JSON.parse(sessionStorage.getItem('iam')) });
	  } else {
	    try {
	      exports.Validate = Validate = new _iamReactClient2.default({ iam: JSON.parse((0, _helpers.getCookie)('iam')) });
	    } catch (err) {
	      exports.Validate = Validate = new _iamReactClient2.default({ iam: undefined });
	    }
	  }
	}
	
	var getSmarterElementsInstance = exports.getSmarterElementsInstance = function getSmarterElementsInstance() {
	  if (!SmarterElementsInstance) {
	    // set the environment based on where we are running. Switch through them
	    var environment = 'local';
	    switch (("production")) {
	      case 'local':
	        environment = 'local';
	        break;
	      case 'dev':
	        environment = 'development';
	        break;
	      case 'stage':
	        environment = 'stage';
	        break;
	      case 'sub':
	        environment = 'subenvironment';
	        break;
	      case 'production':
	        environment = 'production';
	        break;
	      default:
	        environment = 'local';
	        break;
	    }
	
	    // Use the global SmarterElements variable from the CDN script
	    if (window && window.SmarterElements) {
	      try {
	        SmarterElementsInstance = new window.SmarterElements({
	          environment: environment
	        });
	      } catch (e) {
	        console.error(e);
	      }
	    } else {
	      console.error('SmarterElements not found. Make sure the CDN script is loaded properly.');
	    }
	  }
	  return SmarterElementsInstance;
	};

/***/ },
/* 25 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInteger;
	function toInteger(dirtyNumber) {
	  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
	    return NaN;
	  }
	  var number = Number(dirtyNumber);
	  if (isNaN(number)) {
	    return number;
	  }
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	module.exports = exports.default;

/***/ },
/* 26 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assign = assign;
	exports.default = void 0;
	function assign(target) {
	  if (target === null || target === undefined) {
	    throw new TypeError('Object.assign cannot be called with null or undefined');
	  }
	  for (var _len = arguments.length, to = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    to[_key - 1] = arguments[_key];
	  }
	  to.forEach(function (toItem) {
	    toItem = Object(toItem);
	    Object.keys(toItem).forEach(function (key) {
	      target[key] = toItem[key];
	    });
	  });
	  return target;
	}
	var _default = typeof Object.assign === 'function' ? Object.assign : assign;
	exports.default = _default;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Setter = __webpack_require__(325);
	var Parser = /*#__PURE__*/function () {
	  function Parser() {
	    (0, _classCallCheck2.default)(this, Parser);
	    (0, _defineProperty2.default)(this, "incompatibleTokens", void 0);
	    (0, _defineProperty2.default)(this, "priority", void 0);
	    (0, _defineProperty2.default)(this, "subPriority", void 0);
	  }
	  (0, _createClass2.default)(Parser, [{
	    key: "run",
	    value: function run(dateString, token, match, options) {
	      var result = this.parse(dateString, token, match, options);
	      if (!result) {
	        return null;
	      }
	      return {
	        setter: new _Setter.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
	        rest: result.rest
	      };
	    }
	  }, {
	    key: "validate",
	    value: function validate(_utcDate, _value, _options) {
	      return true;
	    }
	  }]);
	  return Parser;
	}();
	exports.Parser = Parser;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dayPeriodEnumToHours = dayPeriodEnumToHours;
	exports.isLeapYearIndex = isLeapYearIndex;
	exports.mapValue = mapValue;
	exports.normalizeTwoDigitYear = normalizeTwoDigitYear;
	exports.parseAnyDigitsSigned = parseAnyDigitsSigned;
	exports.parseNDigits = parseNDigits;
	exports.parseNDigitsSigned = parseNDigitsSigned;
	exports.parseNumericPattern = parseNumericPattern;
	exports.parseTimezonePattern = parseTimezonePattern;
	var _index = __webpack_require__(322);
	var _constants = __webpack_require__(39);
	function mapValue(parseFnResult, mapFn) {
	  if (!parseFnResult) {
	    return parseFnResult;
	  }
	  return {
	    value: mapFn(parseFnResult.value),
	    rest: parseFnResult.rest
	  };
	}
	function parseNumericPattern(pattern, dateString) {
	  var matchResult = dateString.match(pattern);
	  if (!matchResult) {
	    return null;
	  }
	  return {
	    value: parseInt(matchResult[0], 10),
	    rest: dateString.slice(matchResult[0].length)
	  };
	}
	function parseTimezonePattern(pattern, dateString) {
	  var matchResult = dateString.match(pattern);
	  if (!matchResult) {
	    return null;
	  }
	
	  // Input is 'Z'
	  if (matchResult[0] === 'Z') {
	    return {
	      value: 0,
	      rest: dateString.slice(1)
	    };
	  }
	  var sign = matchResult[1] === '+' ? 1 : -1;
	  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
	  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
	  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
	  return {
	    value: sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * _index.millisecondsInSecond),
	    rest: dateString.slice(matchResult[0].length)
	  };
	}
	function parseAnyDigitsSigned(dateString) {
	  return parseNumericPattern(_constants.numericPatterns.anyDigitsSigned, dateString);
	}
	function parseNDigits(n, dateString) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(_constants.numericPatterns.singleDigit, dateString);
	    case 2:
	      return parseNumericPattern(_constants.numericPatterns.twoDigits, dateString);
	    case 3:
	      return parseNumericPattern(_constants.numericPatterns.threeDigits, dateString);
	    case 4:
	      return parseNumericPattern(_constants.numericPatterns.fourDigits, dateString);
	    default:
	      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
	  }
	}
	function parseNDigitsSigned(n, dateString) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(_constants.numericPatterns.singleDigitSigned, dateString);
	    case 2:
	      return parseNumericPattern(_constants.numericPatterns.twoDigitsSigned, dateString);
	    case 3:
	      return parseNumericPattern(_constants.numericPatterns.threeDigitsSigned, dateString);
	    case 4:
	      return parseNumericPattern(_constants.numericPatterns.fourDigitsSigned, dateString);
	    default:
	      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
	  }
	}
	function dayPeriodEnumToHours(dayPeriod) {
	  switch (dayPeriod) {
	    case 'morning':
	      return 4;
	    case 'evening':
	      return 17;
	    case 'pm':
	    case 'noon':
	    case 'afternoon':
	      return 12;
	    case 'am':
	    case 'midnight':
	    case 'night':
	    default:
	      return 0;
	  }
	}
	function normalizeTwoDigitYear(twoDigitYear, currentYear) {
	  var isCommonEra = currentYear > 0;
	  // Absolute number of the current year:
	  // 1 -> 1 AC
	  // 0 -> 1 BC
	  // -1 -> 2 BC
	  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
	  var result;
	  if (absCurrentYear <= 50) {
	    result = twoDigitYear || 100;
	  } else {
	    var rangeEnd = absCurrentYear + 50;
	    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
	    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
	    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
	  }
	  return isCommonEra ? result : 1 - result;
	}
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	if (typeof process !== 'undefined' && ("production") === 'production') {
	    module.exports = __webpack_require__(1079);
	} else {
	    module.exports = __webpack_require__(1078);
	}
	        
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Component = void 0;
	Object.defineProperty(exports, "autoBind", {
	  enumerable: true,
	  get: function get() {
	    return _autoBind.default;
	  }
	});
	exports.default = void 0;
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _autoBind = _interopRequireDefault(__webpack_require__(52));
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var ReactClass = function (_React$Component) {
	  (0, _inherits2.default)(ReactClass, _React$Component);
	  var _super = _createSuper(ReactClass);
	  function ReactClass(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, ReactClass);
	    _this = _super.call(this, props);
	    (0, _autoBind.default)((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	  return (0, _createClass2.default)(ReactClass);
	}(_react.default.Component);
	exports.Component = ReactClass;
	var _default = ReactClass;
	exports.default = _default;

/***/ },
/* 31 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var notEmpty = function notEmpty(x) {
	  return !!x;
	};
	var _default = function _default() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	  if (args.length == 1 && Array.isArray(args[0])) {
	    args = args[0];
	  }
	  return args.filter(notEmpty).join(' ');
	};
	exports.default = _default;

/***/ },
/* 32 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function cleanProps(props, propTypes) {
	  if (!props || !propTypes) {
	    return Object.assign({}, props);
	  }
	  var newProps = Object.keys(props).reduce(function (acc, propName) {
	    if (!propTypes[propName]) {
	      acc[propName] = props[propName];
	    }
	    return acc;
	  }, {});
	  return newProps;
	}
	var _default = cleanProps;
	exports.default = _default;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	var _helpers = __webpack_require__(17);
	
	var _axios = __webpack_require__(161);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _logrocket = __webpack_require__(334);
	
	var _logrocket2 = _interopRequireDefault(_logrocket);
	
	var _browserUpdate = __webpack_require__(936);
	
	var _browserUpdate2 = _interopRequireDefault(_browserUpdate);
	
	var _ExamStore = __webpack_require__(305);
	
	var _ExamStore2 = _interopRequireDefault(_ExamStore);
	
	var _LocationStore = __webpack_require__(306);
	
	var _LocationStore2 = _interopRequireDefault(_LocationStore);
	
	var _MessageStore = __webpack_require__(308);
	
	var _MessageStore2 = _interopRequireDefault(_MessageStore);
	
	var _PaymentStore = __webpack_require__(309);
	
	var _PaymentStore2 = _interopRequireDefault(_PaymentStore);
	
	var _ScheduleStore = __webpack_require__(75);
	
	var _ScheduleStore2 = _interopRequireDefault(_ScheduleStore);
	
	var _SettingsStore = __webpack_require__(166);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ReportStore = __webpack_require__(117);
	
	var _ReportStore2 = _interopRequireDefault(_ReportStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Other stores
	
	
	// Dependencies
	var obx = (0, _mobx.observable)({
	  locale: 'en',
	  logRocketInit: false,
	  translation: null,
	  translationLoaded: false,
	  loadingCalls: [],
	  loading: false,
	  loadingMessage: null,
	  loadingClass: '',
	  backgroundLoadingCalls: [],
	  backgroundLoading: false,
	  authenticated: false,
	  userData: null,
	  profile: null,
	  smarterscheduling: false,
	  hasSessionStorage: (0, _helpers.isLocalStorageSupported)(),
	  tokenSet: false,
	  sessionTimeout: 120,
	  timeoutHandler: null,
	  timerSet: false,
	  getLocalStorage: (0, _mobx.action)(function (data) {
	    obx.userData = data;
	  }),
	  removeLocalStorage: (0, _mobx.action)(function () {
	    if (obx.hasSessionStorage) {
	      sessionStorage.removeItem('registerData');
	      sessionStorage.removeItem('userData');
	    } else {
	      (0, _helpers.deleteCookie)('registerData');
	      (0, _helpers.deleteCookie)('userData');
	    }
	  }),
	  browserUnsupported: false,
	  checkBrowser: (0, _mobx.action)(function () {
	    // Check if browser is supported
	    var _this = this;
	
	    (0, _browserUpdate2.default)({
	      notify: {
	        e: -1,
	        i: 11,
	        f: -1,
	        o: -1,
	        s: -1,
	        c: -1
	      },
	      reminder: 0,
	      onshow: function onshow() {
	        obx.browserUnsupported = true;
	      }
	    });
	  }),
	  login: (0, _mobx.action)(function (username, password, func) {
	    obx.startLoading('Loading…', 'Login');
	
	    var payload = {
	      username: username, password: password
	    };
	
	    _config.api.post('/proctors/login', payload).then(function (response) {
	      obx.finishLoading('Login');
	      obx.userData = response.data;
	
	      if (func) {
	        func();
	      }
	
	      if (obx.hasSessionStorage) {
	        sessionStorage.setItem('token', response.data.authentication.token);
	        sessionStorage.setItem('iam', JSON.stringify(response.data.authentication.iam));
	        sessionStorage.setItem('userData', JSON.stringify(obx.userData));
	        sessionStorage.removeItem('registerData');
	      } else {
	        document.cookie = 'token=' + response.data.authentication.token;
	        document.cookie = 'iam=' + JSON.stringify(response.data.authentication.iam);
	        document.cookie = 'userData=' + JSON.stringify(obx.userData);
	        (0, _helpers.deleteCookie)('registerData');
	      }
	      (0, _config.setValidate)();
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  logout: (0, _mobx.action)(function (history) {
	    if (obx.hasSessionStorage) {
	      sessionStorage.removeItem('token');
	      sessionStorage.removeItem('iam');
	      sessionStorage.removeItem('userData');
	    } else {
	      (0, _helpers.deleteCookie)('token');
	      (0, _helpers.deleteCookie)('iam');
	    }
	
	    obx.resetStores();
	
	    if (history) {
	      history.push('/account/sign-in');
	    }
	  }),
	  resetStores: (0, _mobx.action)(function () {
	    // Reset user data
	    obx.userData = null;
	    obx.profile = null;
	    obx.account = null;
	
	    // Reset exam data
	    _ExamStore2.default.resetExam();
	
	    // Reset location data
	    _LocationStore2.default.locations = [];
	    _LocationStore2.default.resetLocation();
	    _LocationStore2.default.examGroups = [];
	
	    // Reset message data
	    _MessageStore2.default.threads = [];
	    _MessageStore2.default.threadMessages = [];
	    _MessageStore2.default.threadObject = {};
	
	    // Reset payment data
	    _PaymentStore2.default.balance = 0;
	    _PaymentStore2.default.paymentSessions = [];
	    _PaymentStore2.default.paymentHistory = [];
	
	    // Reset schedule data
	    _ScheduleStore2.default.events = [];
	    _ScheduleStore2.default.session = {};
	
	    // Reset user settings
	    _SettingsStore2.default.settings = {};
	    _SettingsStore2.default.userSettings = null;
	  }),
	  // Get proctor account data
	  account: null,
	  getProctorAccount: (0, _mobx.action)(function (sid) {
	    obx.startLoading('Loading…', 'GetProctorAccount');
	
	    _config.api.get('/proctors/' + sid).then(function (response) {
	      obx.account = response.data;
	      obx.finishLoading('GetProctorAccount');
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  startLoading: (0, _mobx.action)(function (message, request) {
	    obx.loading = true;
	    obx.loadingMessage = message;
	    obx.loadingCalls.push(request);
	  }),
	  finishLoading: (0, _mobx.action)(function (request) {
	    var requestIndex = obx.loadingCalls.indexOf(request);
	
	    if (requestIndex >= 0) {
	      obx.loadingCalls.splice(requestIndex, 1);
	    } else {
	      obx.loadingCalls.length = 0;
	    }
	
	    if (obx.loadingCalls.length === 0 || typeof request === 'undefined') {
	      obx.loadingClass = 'leave';
	      obx.loading = false;
	
	      // Wait for loader to fade out before removing
	      setTimeout(function () {
	        obx.loadingClass = '';
	        obx.loadingMessage = null;
	      }, 250);
	    }
	  }),
	  startBackgroundLoading: (0, _mobx.action)(function (request) {
	    obx.backgroundLoading = true;
	    obx.backgroundLoadingCalls.push(request);
	  }),
	  finishBackgroundLoading: (0, _mobx.action)(function (request) {
	    var requestIndex = obx.backgroundLoadingCalls.indexOf(request);
	
	    if (requestIndex >= 0) {
	      obx.backgroundLoadingCalls.splice(requestIndex, 1);
	    } else {
	      obx.backgroundLoadingCalls.length = 0;
	    }
	
	    if (obx.backgroundLoadingCalls.length === 0 || typeof request === 'undefined') {
	      obx.backgroundLoading = false;
	    }
	  }),
	  dialog: false,
	  featureNotice: false,
	  featureNoticeSetting: null,
	  featureNoticeToggle: null,
	  dialogContent: {
	    heading: null,
	    body: null,
	    button: null,
	    code: null,
	    label: null
	  },
	  confirm: false,
	  confirmContent: {
	    heading: null,
	    body: null,
	    button: null
	  },
	  confirmCallback: null,
	  prompt: false,
	  promptContent: {
	    heading: null,
	    body: null,
	    options: null,
	    button: null
	  },
	  promptSelectFunc: null,
	  promptCallback: null,
	  throwError: (0, _mobx.action)(function (error) {
	    console.error(error);
	    obx.finishLoading();
	
	    if (typeof error.response !== 'undefined') {
	      // API errors will return an error object with a response
	      // which means we have a message for them
	      obx.showError(error.response.data);
	      console.error('Server response logged below.');
	      console.log(error.response);
	    } else {
	      // If there’s no response with the error, it’s a server
	      // connection error (i.e. axios can’t reach the URL)
	      obx.showError();
	      console.error('Server connection error.');
	    }
	  }),
	  expireWarning: false,
	  expireSession: (0, _mobx.action)(function () {
	    obx.logout();
	    window.location.href = '/session-expired';
	  }),
	  showExpireWarning: (0, _mobx.action)(function () {
	    obx.expireWarning = true;
	  }),
	  removeExpireWarning: (0, _mobx.action)(function () {
	    obx.expireWarning = false;
	  }),
	  extendSession: (0, _mobx.action)(function (callback) {
	    var headers = {};
	
	    if (obx.hasSessionStorage) {
	      headers = {
	        'token': sessionStorage.getItem('token')
	      };
	    } else {
	      headers = {
	        'token': (0, _helpers.getCookie)('token')
	      };
	    }
	
	    _config.api.get('/check', { headers: headers }).then(function (response) {
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  showDialog: (0, _mobx.action)(function (content) {
	    if (content) {
	      obx.dialogContent = content;
	    }
	
	    obx.dialog = true;
	
	    // Focus the confirmation dialog for screen readers
	    setTimeout(function () {
	      document.querySelector('.dialog__msg').focus();
	    });
	  }),
	  showFeatureNotice: (0, _mobx.action)(function (content) {
	    if (content) {
	      obx.dialogContent = content;
	    }
	
	    obx.featureNotice = true;
	
	    // Focus the confirmation dialog for screen readers
	    setTimeout(function () {
	      document.querySelector('.dialog__msg').focus();
	    });
	  }),
	  showError: (0, _mobx.action)(function (data) {
	
	    obx.dialog = true;
	
	    obx.dialogContent.heading = obx.translation.Errors.heading;
	    obx.dialogContent.button = obx.translation.Errors.button;
	
	    if (typeof data !== 'undefined') {
	      obx.dialogContent.code = data.code;
	    }
	
	    // Server error (no data present because API didn’t return anything)
	    if (!data || typeof data === 'undefined') {
	      obx.dialogContent.body = obx.translation.Errors[1301].message;
	    } else {
	      // API returned data
	      if (typeof obx.translation.Errors[data.code] !== 'undefined') {
	        obx.dialogContent.body = obx.translation.Errors[data.code].message;
	
	        if (obx.dialogContent.body.indexOf('%contact us%') > -1) {
	          obx.dialogContent.body = obx.dialogContent.body.replace('%contact us%', 'contact us');
	          obx.dialogContent.typeForm = true;
	        }
	      } else {
	        console.warn('Error code not present in translation file. Falling back to API response message');
	        obx.dialogContent.body = data.message;
	      }
	    }
	  }),
	  showConfirm: (0, _mobx.action)(function (msg, func) {
	    obx.confirm = true;
	    obx.confirmContent.heading = msg.heading;
	    obx.confirmContent.body = msg.body;
	    obx.confirmContent.button = msg.button;
	    obx.confirmCallback = func;
	  }),
	  exportSessionsCSV: (0, _mobx.action)(function () {
	    var msg = {
	      heading: "Export to CSV",
	      input: "Title",
	      button: "Export"
	    };
	    _ReportStore2.default.reportDefinition = {
	      "Student": "{% if enrollment.lastName and enrollment.firstName %}{{enrollment.lastName | customEscape}}, {{enrollment.firstName | customEscape}}{% endif %}",
	      "Student Email": "{% if enrollment.email %}{{enrollment.email | customEscape}}{% endif %}",
	      "Date": "{% if appointmentDate %}{{appointmentDate | time_zone: '" + _moment2.default.tz.guess() + "', 'M/D/YYYY [at] h:mma z'}}{% endif %}",
	      "Exam": "{% if exam %}{{exam.title | customEscape}}{% endif %}",
	      "Exam Type": "{% if exam.type == 'Online' %}Computer Based{% else %}Written{% endif %}",
	      "Exam Duration": "{% if examConfiguration %}{{examConfiguration.duration | customEscape}}{% endif %}",
	      "Exam Open Date": "{% if examConfiguration %}{{examConfiguration.examOpenDate | time_zone: '" + _moment2.default.tz.guess() + "', 'M/D/YYYY [at] h:mma z'}}{% endif %}",
	      "Exam Close Date": "{% if examConfiguration %}{{examConfiguration.examCloseDate | time_zone: '" + _moment2.default.tz.guess() + "', 'M/D/YYYY [at] h:mma z'}}{% endif %}",
	      "Seat": "{% if appointment && appointment.seat %}{{appointment.seat.title | customEscape}}{% endif %}",
	      "Incidents": "{% if sessionReportCount %}{{sessionReportCount | customEscape}}{% endif %}",
	      "Status": "{% if status %}{{status | customEscape}}{% endif %}",
	      "Location Name": "{% if location %}{{ location.name | customEscape}}{% endif %}",
	      "Session Type": "{% if location.type.type == 'online' %}Live Virtual{% else %}In Person{% endif %}",
	      "Course": "{{course.title | customEscape}}",
	      "Course Code": "{% if course %}{{course.code | customEscape}}{% endif %}",
	      "Instructor": "{% if course %}{{course.instructor.lastName | customEscape}}, {{course.instructor.firstName | customEscape}}{% endif %}",
	      "Instructor Email": "{% if course and course.instructor.email %}{{course.instructor.email | customEscape}}{% endif %}",
	      "Course Offering": "{% if course  %}{{course.offering.title | customEscape}}{% endif %}"
	    };
	    var finishExport = function finishExport() {
	      var callback = function callback() {
	        return obx.showToaster("Exported successfully", 'success');
	      };
	      _ReportStore2.default.exportData(callback);
	    };
	    (0, _helpers.promptUser)(msg, function () {
	      return finishExport();
	    }, null, _ReportStore2.default.reportExportTitle);
	  }),
	  showPrompt: (0, _mobx.action)(function (msg, selectFunc, callback, text) {
	    obx.prompt = true;
	    obx.promptContent.heading = msg.heading;
	    obx.promptContent.body = msg.body;
	    obx.promptContent.options = msg.options;
	    obx.promptContent.button = msg.button;
	    obx.promptSelectFunc = selectFunc;
	    obx.promptCallback = callback;
	
	    if (msg.input) {
	      obx.promptContent.input = msg.input;
	    }
	
	    if (text) {
	      obx.promptText = text;
	    }
	
	    // Focus the prompt dialog for screen readers
	    setTimeout(function () {
	      var dialogMsg = document.querySelector('.dialog__msg');
	
	      if (dialogMsg) {
	        dialogMsg.focus();
	      }
	    });
	  }),
	  closeDialog: (0, _mobx.action)(function () {
	    obx.dialog = false;
	    obx.confirm = false;
	    obx.expireWarning = false;
	    obx.prompt = false;
	    obx.promptContent.options = null;
	    obx.featureNotice = false;
	    obx.featureNoticeSetting = null;
	    obx.featureNoticeToggle = null;
	  }),
	  confirmFunc: (0, _mobx.action)(function () {
	    obx.confirm = false;
	    obx.confirmCallback();
	  }),
	  promptFunc: (0, _mobx.action)(function () {
	    obx.prompt = false;
	    if (obx.promptCallback) {
	      obx.promptCallback();
	    }
	  }),
	  proctorTypeList: [],
	  currencyList: [],
	  timezoneList: [],
	  accountList: [],
	  getProctorTypes: (0, _mobx.action)(function () {
	    _config.api.get('/proctors/categories').then(function (response) {
	      obx.proctorTypeList = response.data.results;
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  getTimezones: (0, _mobx.action)(function (callback) {
	    _config.api.get('/timeZones').then(function (response) {
	      obx.timezoneList = response.data.results;
	
	      if (callback) {
	        callback(response.data.results);
	      }
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  // Current time
	  currentTime: null,
	  getCurrentTime: (0, _mobx.action)(function (backgroundLoad) {
	    if (!backgroundLoad) {
	      obx.startLoading('Loading…', 'CurrentTime');
	    }
	
	    _config.api.get('/currentTime').then(function (response) {
	      obx.currentTime = response.data.currentTime;
	
	      if (!backgroundLoad) {
	        obx.finishLoading('CurrentTime');
	      }
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  // Currencies
	  getCurrencies: (0, _mobx.action)(function (data) {
	    _config.api.get('/currencies').then(function (response) {
	      obx.currencyList = response.data.results;
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  getAccounts: (0, _mobx.action)(function (data) {
	    _config.api.get('/accounts').then(function (response) {
	      obx.accountList = response.data.results;
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  getTranslation: (0, _mobx.action)(function (locale) {
	    obx.translationLoaded = true;
	
	    var timestamp = new Date().getTime();
	
	    _axios2.default.get('/json/' + locale + '.json?t=' + timestamp).then(function (response) {
	      obx.translation = response.data.content;
	    });
	  }),
	  ldClient: null,
	  ldReady: false,
	  getProfile: (0, _mobx.action)(function (router) {
	    if (!obx.tokenSet) return;
	    obx.startLoading('Loading…', 'GetProfile');
	
	    _config.api.get('/proctors/' + obx.userData.proctorAccountSid).then(function (response) {
	      obx.profile = response.data;
	
	      if (response.data.forceSetupVerification && router) {
	        router.push('/checkup');
	      }
	
	      // Set LogRocket identity data
	      _logrocket2.default.identify(obx.profile.sid, {
	        name: obx.profile.lastName + ', ' + obx.profile.firstName,
	        email: obx.profile.email,
	        sid: obx.profile.sid
	      });
	
	      obx.finishLoading('GetProfile');
	
	      // Set up Google Analytics
	      var gaTrackingId = _config.config.gaProctor;
	
	      var gaScript = document.createElement('script');
	      gaScript.id = 'ga-script';
	      gaScript.type = 'text/javascript';
	      gaScript.async = true;
	      gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaTrackingId;
	
	      // Append Google Analytics script
	      document.body.appendChild(gaScript);
	
	      // Config Google Analtyics
	      window.dataLayer = window.dataLayer || [];
	      function gtag() {
	        window.dataLayer.push(arguments);
	      }
	      gtag('js', new Date());
	
	      // Add installSid dimension
	      gtag('config', gaTrackingId, {
	        'custom_map': { 'dimension1': 'proctorSid' }
	      });
	
	      gtag('event', 'proctorSid', { 'proctorSid': obx.userData.proctorAccountSid });
	
	      // Initialize Google Analytics
	      gtag('config', gaTrackingId);
	
	      // Create tracker
	      var gaDelay = setInterval(function () {
	        if (window.ga) {
	          clearInterval(gaDelay);
	          window.ga('create', gaTrackingId, 'auto');
	        }
	      }, 100);
	
	      // Set up LaundDarkly client
	      var environment = 'develop';
	
	      if (true) {
	        environment = 'production';
	      }
	
	      if (false) {
	        environment = 'stage';
	      }
	
	      var user = {
	        key: obx.userData.proctorAccountSid,
	        custom: {
	          domain: window.location.hostname,
	          environment: environment,
	          account: obx.userData.proctorAccountSid,
	          user: obx.userData.sid
	        }
	      };
	
	      obx.ldClient = window.LDClient.initialize(_config.config.ldApiKey, user);
	
	      // Check if SmarterScheduling is enabled
	      obx.ldClient.on('ready', function () {
	        obx.ldReady = true;
	
	        if (obx.ldClient.variation('proctor-schedules', false)) {
	          obx.smarterscheduling = true;
	        }
	      });
	
	      // Check if written exams are accepted
	      // if not, check if a cookie exists
	      // noting that we've already told them
	      // about written exams
	      if (obx.profile.acceptWrittenExams === false) {
	        var writtenCookie = (0, _helpers.getCookie)('sp-written');
	
	        if (!writtenCookie && !obx.profile.locked) {
	          var content = {
	            heading: 'Announcing Written Exams',
	            body: '<p>You can now choose to accept written exams.</p><p>Written exam files are provided by instructors and must be printed for the student. After the exam session, the completed exam must be scanned and uploaded for return to the instructor.</p><p>Written exams can be enabled or disabled later from your settings page.</p>',
	            label: 'Accept written exams',
	            button: 'Okay'
	          };
	
	          obx.featureNoticeSetting = obx.profile.acceptWrittenExams;
	          obx.featureNoticeToggle = function () {
	            _SettingsStore2.default.toggleSetting(obx.profile, 'acceptWrittenExams');
	          };
	
	          obx.showFeatureNotice(content);
	
	          // Store a cookie so the notice
	          // doesn’t keep coming up
	          document.cookie = 'sp-written=true';
	        }
	      }
	    }).catch(function (error) {
	      obx.throwError(error);
	      obx.finishLoading('GetProfile');
	    });
	  }),
	  checkToken: (0, _mobx.action)(function () {
	    obx.startLoading('Loading…', 'CheckToken');
	
	    var headers = {};
	
	    if (obx.hasSessionStorage) {
	      headers = {
	        'token': sessionStorage.getItem('token')
	      };
	    } else {
	      headers = {
	        'token': (0, _helpers.getCookie)('token')
	      };
	    }
	
	    Promise.all([_config.api.get('/check', { headers: headers }), _config.api.get('/permissions', { headers: headers })]).then(function (arr) {
	      // API returns the user sid differently than elsewhere,
	      // so create a new property
	      if (arr[0].data.proctorAccountUserSid) {
	        arr[0].data.sid = arr[0].data.proctorAccountUserSid;
	      }
	
	      if (obx.hasSessionStorage) {
	        sessionStorage.setItem('userData', JSON.stringify(arr[0].data));
	        sessionStorage.setItem('iam', JSON.stringify(arr[1].data.iam));
	      } else {
	        document.cookie = 'userData=' + JSON.stringify(arr[0].data);
	        document.cookie = 'iam=' + JSON.stringify(arr[1].data.iam);
	      }
	
	      obx.userData = arr[0].data;
	      obx.iam = arr[1].data;
	
	      obx.getProfile();
	      obx.finishLoading('CheckToken');
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  unreadCount: 0,
	  getUnreadCount: (0, _mobx.action)(function () {
	    obx.startLoading('Loading…', 'GetUnreadCount');
	
	    _config.api.get('/messages/counts?userSid=' + obx.userData.sid).then(function (response) {
	      obx.unreadCount = parseInt(response.data.unread, 10);
	      obx.finishLoading('GetUnreadCount');
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  // Get associated installations
	  installs: null,
	  getInstalls: (0, _mobx.action)(function (callback) {
	    obx.startLoading('Loading…', 'getInstalls');
	
	    _config.api.get('/proctors/' + obx.userData.proctorAccountSid + '/associatedInstalls').then(function (response) {
	      obx.installs = response.data.results;
	      obx.finishLoading('getInstalls');
	
	      if (callback) {
	        callback(response.data.results);
	      }
	    }).catch(function (error) {
	      obx.throwError(error);
	    });
	  }),
	  // Notifications
	  notification: false,
	  notificationContent: null,
	  notificationLink: null,
	  notificationClass: null,
	  showNotification: (0, _mobx.action)(function (content, link) {
	    if (content) {
	      obx.notificationContent = content;
	    }
	
	    if (link) {
	      obx.notificationLink = link;
	    }
	
	    obx.notification = true;
	  }),
	  closeNotification: (0, _mobx.action)(function () {
	    obx.notification = false;
	    obx.notificationContent = null;
	    obx.notificationLink = null;
	  }),
	  showToaster: (0, _mobx.action)(function (content, type) {
	    if (content) {
	      obx.notificationContent = content;
	    }
	
	    if (type === 'success') {
	      obx.notificationClass = 'notify--success';
	    }
	    if (type === 'warning') {
	      obx.notificationClass = 'notify--warning';
	    }
	    if (type === 'error') {
	      obx.notificationClass = 'notify--error';
	    }
	
	    obx.notification = true;
	
	    // Remove the toaster after 5 seconds
	    setTimeout(function () {
	      obx.notificationClass += ' notify--closing';
	    }, 5000);
	
	    setTimeout(function () {
	      obx.closeNotification();
	    }, 7500);
	  }),
	  createNewTimer: (0, _mobx.action)(function (timeInSecond, token) {
	    obx.timerSet = true;
	
	    function checkTtl(token) {
	
	      return new Promise(function (resolve, reject) {
	        var headers = {
	          'token': token
	        };
	        _config.api.get('/ttl', { headers: headers }).then(function (response) {
	          return resolve(response.data.ttl);
	        }).catch(function (error) {
	
	          return resolve(-2);
	        });
	      });
	    }
	
	    setTimeout(function () {
	      // Check how much time is left
	      checkTtl(token).then(function (res) {
	
	        if (res <= 120 && res > 10) {
	          // If 2 minutes or less remain, show the warning
	          obx.showExpireWarning();
	
	          // Also start a new timer to expire the session if the user doesn’t extend
	          obx.timeoutHandler = obx.createNewTimer(res + 120, token);
	        } else if (res <= 10) {
	          // If the session times out, expire it
	          obx.expireSession();
	          clearTimeout(obx.timeoutHandler);
	        } else {
	          // Otherwise, create a new timer with the ttl response
	          clearTimeout(obx.timeoutHandler);
	          obx.removeExpireWarning();
	          obx.timeoutHandler = obx.createNewTimer(res, token);
	        }
	      }).catch(function (error) {
	        console.log(error);
	      });
	    }, (timeInSecond - 120) * 1000);
	  }),
	
	  // Check how much time is left
	
	  startTokenTimer: (0, _mobx.action)(function (token) {
	    if (!obx.timerSet) {
	      // Create a new timer for session timeout
	      obx.createNewTimer(obx.sessionTimeout / 1000, token);
	    }
	  })
	
	});
	
	// Temporarily using default axios instance for translations
	exports.default = obx;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(4);
	function ownKeys(e, r) {
	  var t = Object.keys(e);
	  if (Object.getOwnPropertySymbols) {
	    var o = Object.getOwnPropertySymbols(e);
	    r && (o = o.filter(function (r) {
	      return Object.getOwnPropertyDescriptor(e, r).enumerable;
	    })), t.push.apply(t, o);
	  }
	  return t;
	}
	function _objectSpread2(e) {
	  for (var r = 1; r < arguments.length; r++) {
	    var t = null != arguments[r] ? arguments[r] : {};
	    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
	      defineProperty(e, r, t[r]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
	      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
	    });
	  }
	  return e;
	}
	module.exports = _objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(1251);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(5)["default"];
	function _getRequireWildcardCache(e) {
	  if ("function" != typeof WeakMap) return null;
	  var r = new WeakMap(),
	    t = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
	    return e ? t : r;
	  })(e);
	}
	function _interopRequireWildcard(e, r) {
	  if (!r && e && e.__esModule) return e;
	  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
	    "default": e
	  };
	  var t = _getRequireWildcardCache(r);
	  if (t && t.has(e)) return t.get(e);
	  var n = {
	      __proto__: null
	    },
	    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
	  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
	    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
	    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
	  }
	  return n["default"] = e, t && t.set(e, n), n;
	}
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(1142);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
		var nativeCodeString = '[native code]';
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}
	
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 39 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.timezonePatterns = exports.numericPatterns = void 0;
	var numericPatterns = {
	  month: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  date: /^(3[0-1]|[0-2]?\d)/,
	  // 0 to 31
	  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	  // 0 to 366
	  week: /^(5[0-3]|[0-4]?\d)/,
	  // 0 to 53
	  hour23h: /^(2[0-3]|[0-1]?\d)/,
	  // 0 to 23
	  hour24h: /^(2[0-4]|[0-1]?\d)/,
	  // 0 to 24
	  hour11h: /^(1[0-1]|0?\d)/,
	  // 0 to 11
	  hour12h: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  minute: /^[0-5]?\d/,
	  // 0 to 59
	  second: /^[0-5]?\d/,
	  // 0 to 59
	
	  singleDigit: /^\d/,
	  // 0 to 9
	  twoDigits: /^\d{1,2}/,
	  // 0 to 99
	  threeDigits: /^\d{1,3}/,
	  // 0 to 999
	  fourDigits: /^\d{1,4}/,
	  // 0 to 9999
	
	  anyDigitsSigned: /^-?\d+/,
	  singleDigitSigned: /^-?\d/,
	  // 0 to 9, -0 to -9
	  twoDigitsSigned: /^-?\d{1,2}/,
	  // 0 to 99, -0 to -99
	  threeDigitsSigned: /^-?\d{1,3}/,
	  // 0 to 999, -0 to -999
	  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
	};
	exports.numericPatterns = numericPatterns;
	var timezonePatterns = {
	  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	  basic: /^([+-])(\d{2})(\d{2})|Z/,
	  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	  extended: /^([+-])(\d{2}):(\d{2})|Z/,
	  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
	};
	exports.timezonePatterns = timezonePatterns;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _moment = _interopRequireDefault(__webpack_require__(3));
	var _default = function _default(value, dateFormat, config) {
	  if ((0, _typeof2.default)(dateFormat) === 'object') {
	    config = dateFormat;
	    dateFormat = null;
	  }
	  var strict = !!(config && config.strict);
	  var locale = config && config.locale;
	  dateFormat = dateFormat || config && config.dateFormat || 'YYYY-MM-DD';
	  if (typeof value == 'string') {
	    return (0, _moment.default)(value, dateFormat, locale, strict);
	  }
	  value = value == null ? new Date() : value;
	  return (0, _moment.default)(value, undefined, locale, strict);
	};
	exports.default = _default;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Flex", {
	  enumerable: true,
	  get: function get() {
	    return _src.Flex;
	  }
	});
	Object.defineProperty(exports, "Item", {
	  enumerable: true,
	  get: function get() {
	    return _src.Item;
	  }
	});
	exports.default = void 0;
	var _src = _interopRequireWildcard(__webpack_require__(684));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var _default = {
	  Flex: _src.default,
	  Item: _src.default
	};
	exports.default = _default;

/***/ },
/* 42 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _extends.apply(this, arguments);
	}
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 43 */
[1296, 771],
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(204);
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	  return target;
	}
	module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(284);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Edit = __webpack_require__(874);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _ScheduleManage = __webpack_require__(908);
	
	var _ScheduleManage2 = _interopRequireDefault(_ScheduleManage);
	
	var _MessagesDetail = __webpack_require__(882);
	
	var _MessagesDetail2 = _interopRequireDefault(_MessagesDetail);
	
	var _MessageThread = __webpack_require__(293);
	
	var _MessageThread2 = _interopRequireDefault(_MessageThread);
	
	var _SessionDetail = __webpack_require__(303);
	
	var _SessionDetail2 = _interopRequireDefault(_SessionDetail);
	
	var _PaymentForm = __webpack_require__(889);
	
	var _PaymentForm2 = _interopRequireDefault(_PaymentForm);
	
	var _SupportTicketDetail = __webpack_require__(918);
	
	var _SupportTicketDetail2 = _interopRequireDefault(_SupportTicketDetail);
	
	var _AddSupportTicket = __webpack_require__(917);
	
	var _AddSupportTicket2 = _interopRequireDefault(_AddSupportTicket);
	
	var _ReportFilter = __webpack_require__(901);
	
	var _ReportFilter2 = _interopRequireDefault(_ReportFilter);
	
	var _EditUsers = __webpack_require__(922);
	
	var _EditUsers2 = _interopRequireDefault(_EditUsers);
	
	var _CreateUser = __webpack_require__(921);
	
	var _CreateUser2 = _interopRequireDefault(_CreateUser);
	
	var _Session = __webpack_require__(302);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _Checkout = __webpack_require__(846);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var Drawer = function (_React$Component) {
	  _inherits(Drawer, _React$Component);
	
	  function Drawer() {
	    _classCallCheck(this, Drawer);
	
	    return _possibleConstructorReturn(this, (Drawer.__proto__ || Object.getPrototypeOf(Drawer)).apply(this, arguments));
	  }
	
	  _createClass(Drawer, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          content = _props.content,
	          isOpen = _props.isOpen,
	          translation = _props.translation;
	
	      var closeBtnClass = null;
	      var closePath = null;
	
	      var DrawerComponents = {
	        LocationEdit: _Edit2.default,
	        ScheduleManage: _ScheduleManage2.default,
	        MessagesDetail: _MessagesDetail2.default,
	        MessageThread: _MessageThread2.default,
	        SessionDetail: _SessionDetail2.default,
	        PaymentForm: _PaymentForm2.default,
	        SupportTicketDetail: _SupportTicketDetail2.default,
	        AddSupportTicket: _AddSupportTicket2.default,
	        ReportFilter: _ReportFilter2.default,
	        UserEdit: _EditUsers2.default,
	        CreateUser: _CreateUser2.default,
	        Session: _Session2.default,
	        Checkout: _Checkout2.default
	      };
	
	      if (content === 'SupportTicketDetail' || content === 'AddSupportTicket' || content === 'LocationEdit' || content === 'ScheduleManage' || content === 'MessageDetail' || content === 'UserEdit' || content === 'CreateUser' || content === 'SessionDetail' && (0, _helpers.getURLSegment)(this, 1) === 'sessions') {
	        closePath = (0, _helpers.getURLSegment)(this, 1);
	      }
	
	      if (isOpen) {
	        setTimeout(function () {
	          document.querySelector('body').className += ' drawer-open';
	        });
	      }
	
	      if (content) {
	        var _props2 = this.props,
	            large = _props2.large,
	            store = _props2.store;
	        var SessionStore = store.SessionStore;
	
	        var DrawerComponent = DrawerComponents[content];
	
	        return _react2.default.createElement(
	          'aside',
	          { id: content, className: 'drawer ' + (large ? 'drawer--large' : '') },
	          !SessionStore.hideDrawerClose && _react2.default.createElement(
	            'button',
	            {
	              className: 'drawer__close ' + closeBtnClass,
	              onClick: function onClick(e) {
	                return (0, _helpers.closeDrawer)(e, _this2.props.parent, closePath, _this2.props.callback);
	              }
	            },
	            _react2.default.createElement(icons.iconTimes, null),
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              translation.close
	            )
	          ),
	          _react2.default.createElement(DrawerComponent, Object.assign({}, this.props, { drawer: true }))
	        );
	      } else {
	        return null;
	      }
	    }
	  }]);
	
	  return Drawer;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('Drawer')(Drawer);

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var document = globalObject ? globalObject.document : null;
	var scrollbarWidth;
	var hideNativeScrollbarWidth;
	var _default = function _default(hideNativeScrollbarIfPossible) {
	  if (hideNativeScrollbarIfPossible) {
	    if (hideNativeScrollbarWidth !== undefined) {
	      return hideNativeScrollbarWidth;
	    }
	  } else {
	    if (scrollbarWidth !== undefined) {
	      return scrollbarWidth;
	    }
	  }
	  var result;
	  if (document) {
	    var div = document.createElement('div');
	    var divStyle = div.style;
	    if (hideNativeScrollbarIfPossible) {
	      div.className = 'inovua--hide-native-scroll-if-possible';
	    }
	    divStyle.width = '100px';
	    divStyle.height = '100px';
	    divStyle.position = 'absolute';
	    divStyle.visibility = 'hidden';
	    divStyle.boxSizing = 'content-box';
	    divStyle.top = '-99999px';
	    divStyle.overflow = 'scroll';
	    divStyle.MsOverflowStyle = 'scrollbar';
	    document.body.appendChild(div);
	    var inner = document.createElement('div');
	    div.appendChild(inner);
	    result = div.offsetWidth - inner.offsetWidth;
	    document.body.removeChild(div);
	  } else {
	    result = 0;
	  }
	  if (hideNativeScrollbarIfPossible) {
	    hideNativeScrollbarWidth = result;
	  }
	  return result;
	};
	exports.default = _default;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = __webpack_require__(2);
	var _isControlledValue = _interopRequireDefault(__webpack_require__(272));
	var _toUpperFirst = _interopRequireDefault(__webpack_require__(803));
	var emptyFn = function emptyFn() {};
	var useProperty = function useProperty(props, propName, defaultValue, config) {
	  var context = (0, _react.useContext)(props.context);
	  var PropName = (0, _toUpperFirst.default)(propName);
	  var defaultValueFromProps = props["default".concat(PropName)];
	  var defaultValueFromRestoredState = context.state[propName];
	  if (defaultValueFromRestoredState !== undefined) {
	    defaultValueFromProps = defaultValueFromRestoredState;
	  }
	  defaultValue = defaultValueFromProps === undefined ? defaultValue : defaultValueFromProps;
	  var _useState = (0, _react.useState)(defaultValue),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    stateValue = _useState2[0],
	    setStateProperty = _useState2[1];
	  var value = props[propName];
	  var controlled = (0, _isControlledValue.default)(value);
	  var onChange = config && config.onChange ? config.onChange : props["on".concat(PropName, "Change")] || emptyFn;
	  var setter = function setter(value) {
	    context.state[propName] = value;
	    if (!controlled) {
	      setStateProperty(value);
	    }
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	    onChange.apply(void 0, [value].concat(args));
	  };
	  if (!controlled) {
	    value = stateValue;
	  }
	  return [value, setter];
	};
	var _default = useProperty;
	exports.default = _default;

/***/ },
/* 49 */
32,
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _reactDom = __webpack_require__(37);
	var _default = function _default() {
	  var commited = false;
	  var fns = [];
	  var queue = function queue(fn) {
	    fns.push(fn);
	  };
	  queue.commit = function (extraFn) {
	    if (commited) {
	      return Promise.resolve(true);
	    }
	    commited = true;
	    return new Promise(function (resolve) {
	      (0, _reactDom.unstable_batchedUpdates)(function () {
	        if (extraFn) {
	          fns.push(extraFn);
	        }
	        fns.forEach(function (fn) {
	          return fn();
	        });
	        fns = undefined;
	        resolve(true);
	      });
	    });
	  };
	  return queue;
	};
	exports.default = _default;

/***/ },
/* 51 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDefaultOptions = getDefaultOptions;
	exports.setDefaultOptions = setDefaultOptions;
	var defaultOptions = {};
	function getDefaultOptions() {
	  return defaultOptions;
	}
	function setDefaultOptions(newOptions) {
	  defaultOptions = newOptions;
	}

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var skipMethods = {
	  constructor: 1,
	  render: 1,
	  shouldComponentUpdate: 1,
	  componentWillMount: 1,
	  componentDidMount: 1,
	  componentWillReceiveProps: 1,
	  componentWillUpdate: 1,
	  componentDidUpdate: 1,
	  componentWillUnmount: 1
	};
	function autoBind(object, filter) {
	  var proto = object.constructor.prototype;
	  var filterFn = typeof filter == 'function' ? filter : filter && (0, _typeof2.default)(filter) == 'object' ? function (key) {
	    return !filter[key] && skipMethods[key] !== 1 && typeof proto[key] === 'function';
	  } : function (key) {
	    return skipMethods[key] !== 1 && typeof proto[key] === 'function';
	  };
	  var names = Object.getOwnPropertyNames(proto).filter(filterFn);
	  names.push('setState');
	  names.forEach(function (key) {
	    object[key] = object[key].bind(object);
	  });
	  return object;
	}
	var _default = autoBind;
	exports.default = _default;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(502);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 54 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _region = _interopRequireDefault(__webpack_require__(43));
	__webpack_require__(768);
	__webpack_require__(767);
	var _computeAlignRegion = _interopRequireDefault(__webpack_require__(770));
	_region.default.alignRegions = function (sourceRegion, targetRegion, positions, config) {
	  var result = (0, _computeAlignRegion.default)(sourceRegion, targetRegion, positions, config);
	  var alignedRegion = result.region;
	  if (!alignedRegion.equals(sourceRegion)) {
	    sourceRegion.setRegion(alignedRegion);
	  }
	  return result.position;
	};
	_region.default.prototype.alignTo = function (target, positions, config) {
	  config = config || {};
	  var sourceRegion = this;
	  var targetRegion = _region.default.from(target);
	  var result = (0, _computeAlignRegion.default)(sourceRegion, targetRegion, positions, config);
	  var resultRegion = result.region;
	  if (!resultRegion.equalsSize(sourceRegion)) {
	    this.setSize(resultRegion.getSize());
	  }
	  if (!resultRegion.equalsPosition(sourceRegion)) {
	    this.setPosition(resultRegion.getPosition(), {
	      absolute: !!config.absolute
	    });
	  }
	  return result.position;
	};
	var _default = _region.default;
	exports.default = _default;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _shallowequal = _interopRequireDefault(__webpack_require__(73));
	var _default = function _default(inst, nextProps, nextState) {
	  var props = inst.props;
	  var state = inst.state;
	  if (nextProps.shouldComponentUpdate) {
	    return nextProps.shouldComponentUpdate({
	      nextProps: nextProps,
	      props: props,
	      nextState: nextState,
	      state: state
	    });
	  }
	  return !(0, _shallowequal.default)(nextProps, props) || !(0, _shallowequal.default)(nextState, state);
	};
	exports.default = _default;

/***/ },
/* 57 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function myFunction() {}
	var _default = myFunction.toString() != 'function myFunction(abc) { /* this is a simple comment */ }';
	exports.default = _default;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isAuthorized = exports["default"] = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(816));
	var _openIam = _interopRequireDefault(__webpack_require__(1088));
	function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
	function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
	function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
	function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
	function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
	function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
	function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
	function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
	function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
	function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
	function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
	function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
	function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
	function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
	function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
	function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
	function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
	function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
	function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
	var isAuthorized = exports.isAuthorized = function isAuthorized(iamAction, iamResource, localIam) {
	  if (_typeof(localIam) === 'object') {
	    return _openIam["default"].authorize(iamResource, iamAction, _openIam["default"].processIamData(localIam));
	  } else if (typeof localIam === 'string') {
	    try {
	      return _openIam["default"].authorize(iamResource, iamAction, _openIam["default"].processIamData(JSON.parse(localIam)));
	    } catch (err) {
	      return false;
	    }
	  } else {
	    console.warn("Please pass a valid iam object or string to use the function 'isAuthorized'");
	    return false;
	  }
	};
	var ValidateConstructor = function ValidateConstructor(config) {
	  return /*#__PURE__*/function (_Component) {
	    function Validate() {
	      _classCallCheck(this, Validate);
	      return _callSuper(this, Validate, arguments);
	    }
	    _inherits(Validate, _Component);
	    return _createClass(Validate, [{
	      key: "deepMap",
	      value: function deepMap(children, deepMapFn) {
	        var _this = this;
	        return _react.Children.map(children, function (child) {
	          if (child) {
	            if (child.props && child.props.children && _typeof(child.props.children) === 'object') {
	              // Clone the child that has children and map them too
	              return deepMapFn( /*#__PURE__*/(0, _react.cloneElement)(child, _objectSpread(_objectSpread({}, child.props), {}, {
	                children: _this.deepMap(child.props.children, deepMapFn)
	              })));
	            }
	            return deepMapFn(child);
	          } else {
	            return child;
	          }
	        });
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var localIam = config.iam;
	        var children = null;
	
	        //if action and resource was tagged to validate then it is applyed to every child nested inside
	        if (this.props && this.props.iamAction && this.props.iamResource) {
	          //check auth based on the iam doc action and resource to decide if this child content should be displayed.
	          if (_openIam["default"].authorize(this.props.iamResource, this.props.iamAction, _openIam["default"].processIamData(localIam))) {
	            //set childWithProps to the unaltered children because auth returned true
	            children = this.props.children;
	          } else {
	            //return nothing to display to the dom because authorize returned false
	            children = null;
	          }
	        } else {
	          //else validate will loop its children recursively and look for action/resources tagged to any ui element
	          children = this.deepMap(this.props.children, function (child) {
	            //if this child has action and resource run auth against it
	            if (child.props && child.props.iamAction && child.props.iamResource) {
	              //either return the child or blank based on iam authorize
	              return _openIam["default"].authorize(child.props.iamResource, child.props.iamAction, _openIam["default"].processIamData(localIam)) ? child : '';
	            } else {
	              //no action or resource so its a normal dom element
	              return child;
	            }
	          });
	        }
	        return children;
	      }
	    }]);
	  }(_react.Component);
	};
	var _default = exports["default"] = ValidateConstructor;


/***/ },
/* 59 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.feature = exports.track = exports.identify = exports.getAllFeatureFlags = exports.FeatureFlag = exports.LaunchDarkly = undefined;
	
	var _utils = __webpack_require__(494);
	
	Object.defineProperty(exports, "getAllFeatureFlags", {
	  enumerable: true,
	  get: function get() {
	    return _utils.getAllFeatureFlags;
	  }
	});
	Object.defineProperty(exports, "identify", {
	  enumerable: true,
	  get: function get() {
	    return _utils.identify;
	  }
	});
	Object.defineProperty(exports, "track", {
	  enumerable: true,
	  get: function get() {
	    return _utils.track;
	  }
	});
	Object.defineProperty(exports, "feature", {
	  enumerable: true,
	  get: function get() {
	    return _utils.feature;
	  }
	});
	
	var _LaunchDarkly2 = __webpack_require__(1148);
	
	var _LaunchDarkly3 = _interopRequireDefault(_LaunchDarkly2);
	
	var _FeatureFlag2 = __webpack_require__(1146);
	
	var _FeatureFlag3 = _interopRequireDefault(_FeatureFlag2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.LaunchDarkly = _LaunchDarkly3.default;
	exports.FeatureFlag = _FeatureFlag3.default;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _react = __webpack_require__(2);
	var usePrevious = function usePrevious(value, initialValue) {
	  var ref = (0, _react.useRef)(initialValue);
	  (0, _react.useEffect)(function () {
	    ref.current = value;
	  });
	  return ref.current;
	};
	var _default = usePrevious;
	exports.default = _default;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var filter = function filter(object) {
	  return Object.keys(object).reduce(function (acc, prop) {
	    var value = object[prop];
	    if (value !== undefined) {
	      acc[prop] = value;
	    }
	    return acc;
	  }, {});
	};
	var _default = function _default(target) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	  return _assign.default.apply(void 0, [target].concat((0, _toConsumableArray2.default)(args.map(filter))));
	};
	exports.default = _default;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _lodash = _interopRequireDefault(__webpack_require__(1067));
	var _default = _lodash.default;
	exports.default = _default;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _hasTouch = _interopRequireDefault(__webpack_require__(264));
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var mobileTest = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(globalObject.navigator ? globalObject.navigator.userAgent : '');
	var _default = _hasTouch.default && mobileTest;
	exports.default = _default;

/***/ },
/* 65 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(value, min, max) {
	  if (min == null) {
	    min = value;
	  }
	  return value < min ? min : max != null && value > max ? max : value;
	};
	exports.default = _default;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $SyntaxError = SyntaxError;
	var $Function = Function;
	var $TypeError = TypeError;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(1046)();
	var hasProto = __webpack_require__(1045)();
	
	var getProto = Object.getPrototypeOf || (
		hasProto
			? function (x) { return x.__proto__; } // eslint-disable-line no-proto
			: null
	);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%ReferenceError%': ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(178);
	var hasOwn = __webpack_require__(1047);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	var $strSlice = bind.call(Function.call, String.prototype.slice);
	var $exec = bind.call(Function.call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 67 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports,__webpack_require__(2),__webpack_require__(11),__webpack_require__(38),__webpack_require__(323),__webpack_require__(324),__webpack_require__(955),__webpack_require__(319),__webpack_require__(318),__webpack_require__(171),__webpack_require__(320),__webpack_require__(173),__webpack_require__(321),__webpack_require__(1032),__webpack_require__(1031),__webpack_require__(1030),__webpack_require__(1034),__webpack_require__(1033),__webpack_require__(1035),__webpack_require__(963),__webpack_require__(960),__webpack_require__(959),__webpack_require__(957),__webpack_require__(956),__webpack_require__(965),__webpack_require__(961),__webpack_require__(962),__webpack_require__(967),__webpack_require__(964),__webpack_require__(1025),__webpack_require__(1023),__webpack_require__(1022),__webpack_require__(326),__webpack_require__(1024),__webpack_require__(1026),__webpack_require__(987),__webpack_require__(986),__webpack_require__(948),__webpack_require__(949),__webpack_require__(950),__webpack_require__(951),__webpack_require__(174),__webpack_require__(90),__webpack_require__(1027),__webpack_require__(327),__webpack_require__(1029),__webpack_require__(952),__webpack_require__(954),__webpack_require__(953),__webpack_require__(970),__webpack_require__(971),__webpack_require__(972),__webpack_require__(974),__webpack_require__(973),__webpack_require__(968),__webpack_require__(969),__webpack_require__(975),__webpack_require__(16),__webpack_require__(1020),__webpack_require__(1021),__webpack_require__(1149),__webpack_require__(1152)):"function"==typeof define&&define.amd?define(["exports","react","prop-types","classnames","date-fns/isDate","date-fns/isValid","date-fns/format","date-fns/addMinutes","date-fns/addHours","date-fns/addDays","date-fns/addWeeks","date-fns/addMonths","date-fns/addYears","date-fns/subMinutes","date-fns/subHours","date-fns/subDays","date-fns/subWeeks","date-fns/subMonths","date-fns/subYears","date-fns/getSeconds","date-fns/getMinutes","date-fns/getHours","date-fns/getDay","date-fns/getDate","date-fns/getWeek","date-fns/getMonth","date-fns/getQuarter","date-fns/getYear","date-fns/getTime","date-fns/setSeconds","date-fns/setMinutes","date-fns/setHours","date-fns/setMonth","date-fns/setQuarter","date-fns/setYear","date-fns/min","date-fns/max","date-fns/differenceInCalendarDays","date-fns/differenceInCalendarMonths","date-fns/differenceInCalendarWeeks","date-fns/differenceInCalendarYears","date-fns/startOfDay","date-fns/startOfWeek","date-fns/startOfMonth","date-fns/startOfQuarter","date-fns/startOfYear","date-fns/endOfDay","date-fns/endOfWeek","date-fns/endOfMonth","date-fns/isEqual","date-fns/isSameDay","date-fns/isSameMonth","date-fns/isSameYear","date-fns/isSameQuarter","date-fns/isAfter","date-fns/isBefore","date-fns/isWithinInterval","date-fns/toDate","date-fns/parse","date-fns/parseISO","react-onclickoutside","react-popper"],t):t((e=e||self).DatePicker={},e.React,e.PropTypes,e.classNames,e.isDate,e.isValidDate,e.format,e.addMinutes,e.addHours,e.utils,e.utils$1,e.addMonths,e.addYears,e.subMinutes,e.subHours,e.subDays,e.subWeeks,e.subMonths,e.subYears,e.getSeconds,e.getMinutes,e.getHours,e.getDay,e.getDate,e.dfgetWeek,e.getMonth,e.getQuarter,e.getYear,e.getTime,e.setSeconds,e.setMinutes,e.setHours,e.utils$2,e.utils$3,e.setYear,e.min,e.max,e.differenceInCalendarDays,e.differenceInCalendarMonths,e.differenceInCalendarWeeks,e.differenceInCalendarYears,e.startOfDay,e.startOfWeek,e.startOfMonth,e.startOfQuarter,e.startOfYear,e.endOfDay,e.endOfWeek,e.endOfMonth,e.dfIsEqual,e.dfIsSameDay,e.dfIsSameMonth,e.dfIsSameYear,e.dfIsSameQuarter,e.isAfter,e.isBefore,e.isWithinInterval,e.toDate,e.parse,e.parseISO,e.onClickOutside,e.ReactPopper)}(this,(function(e,t,r,n,a,o,s,p,i,c,l,d,u,h,f,m,y,v,w,D,k,g,b,C,_,O,S,P,M,E,N,Y,x,T,I,L,j,F,q,W,R,A,B,H,K,Q,V,U,$,z,G,J,X,Z,ee,te,re,ne,ae,oe,se,pe){"use strict";function ie(e){return(ie="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ce(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function le(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function de(e,t,r){return t&&le(e.prototype,t),r&&le(e,r),e}function ue(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function he(){return(he=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function fe(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n)}return r}function me(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?fe(Object(r),!0).forEach((function(t){ue(e,t,r[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):fe(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}return e}function ye(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&we(e,t)}function ve(e){return(ve=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function we(e,t){return(we=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function De(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function ke(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?De(e):t}function ge(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}();return function(){var r,n=ve(e);if(t){var a=ve(this).constructor;r=Reflect.construct(n,arguments,a)}else r=n.apply(this,arguments);return ke(this,r)}}function be(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function Ce(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}t=t&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t,r=r&&Object.prototype.hasOwnProperty.call(r,"default")?r.default:r,n=n&&Object.prototype.hasOwnProperty.call(n,"default")?n.default:n,a=a&&Object.prototype.hasOwnProperty.call(a,"default")?a.default:a,o=o&&Object.prototype.hasOwnProperty.call(o,"default")?o.default:o,s=s&&Object.prototype.hasOwnProperty.call(s,"default")?s.default:s,p=p&&Object.prototype.hasOwnProperty.call(p,"default")?p.default:p,i=i&&Object.prototype.hasOwnProperty.call(i,"default")?i.default:i,c=c&&Object.prototype.hasOwnProperty.call(c,"default")?c.default:c,l=l&&Object.prototype.hasOwnProperty.call(l,"default")?l.default:l,d=d&&Object.prototype.hasOwnProperty.call(d,"default")?d.default:d,u=u&&Object.prototype.hasOwnProperty.call(u,"default")?u.default:u,h=h&&Object.prototype.hasOwnProperty.call(h,"default")?h.default:h,f=f&&Object.prototype.hasOwnProperty.call(f,"default")?f.default:f,m=m&&Object.prototype.hasOwnProperty.call(m,"default")?m.default:m,y=y&&Object.prototype.hasOwnProperty.call(y,"default")?y.default:y,v=v&&Object.prototype.hasOwnProperty.call(v,"default")?v.default:v,w=w&&Object.prototype.hasOwnProperty.call(w,"default")?w.default:w,D=D&&Object.prototype.hasOwnProperty.call(D,"default")?D.default:D,k=k&&Object.prototype.hasOwnProperty.call(k,"default")?k.default:k,g=g&&Object.prototype.hasOwnProperty.call(g,"default")?g.default:g,b=b&&Object.prototype.hasOwnProperty.call(b,"default")?b.default:b,C=C&&Object.prototype.hasOwnProperty.call(C,"default")?C.default:C,_=_&&Object.prototype.hasOwnProperty.call(_,"default")?_.default:_,O=O&&Object.prototype.hasOwnProperty.call(O,"default")?O.default:O,S=S&&Object.prototype.hasOwnProperty.call(S,"default")?S.default:S,P=P&&Object.prototype.hasOwnProperty.call(P,"default")?P.default:P,M=M&&Object.prototype.hasOwnProperty.call(M,"default")?M.default:M,E=E&&Object.prototype.hasOwnProperty.call(E,"default")?E.default:E,N=N&&Object.prototype.hasOwnProperty.call(N,"default")?N.default:N,Y=Y&&Object.prototype.hasOwnProperty.call(Y,"default")?Y.default:Y,x=x&&Object.prototype.hasOwnProperty.call(x,"default")?x.default:x,T=T&&Object.prototype.hasOwnProperty.call(T,"default")?T.default:T,I=I&&Object.prototype.hasOwnProperty.call(I,"default")?I.default:I,L=L&&Object.prototype.hasOwnProperty.call(L,"default")?L.default:L,j=j&&Object.prototype.hasOwnProperty.call(j,"default")?j.default:j,F=F&&Object.prototype.hasOwnProperty.call(F,"default")?F.default:F,q=q&&Object.prototype.hasOwnProperty.call(q,"default")?q.default:q,W=W&&Object.prototype.hasOwnProperty.call(W,"default")?W.default:W,R=R&&Object.prototype.hasOwnProperty.call(R,"default")?R.default:R,A=A&&Object.prototype.hasOwnProperty.call(A,"default")?A.default:A,B=B&&Object.prototype.hasOwnProperty.call(B,"default")?B.default:B,H=H&&Object.prototype.hasOwnProperty.call(H,"default")?H.default:H,K=K&&Object.prototype.hasOwnProperty.call(K,"default")?K.default:K,Q=Q&&Object.prototype.hasOwnProperty.call(Q,"default")?Q.default:Q,V=V&&Object.prototype.hasOwnProperty.call(V,"default")?V.default:V,U=U&&Object.prototype.hasOwnProperty.call(U,"default")?U.default:U,$=$&&Object.prototype.hasOwnProperty.call($,"default")?$.default:$,z=z&&Object.prototype.hasOwnProperty.call(z,"default")?z.default:z,G=G&&Object.prototype.hasOwnProperty.call(G,"default")?G.default:G,J=J&&Object.prototype.hasOwnProperty.call(J,"default")?J.default:J,X=X&&Object.prototype.hasOwnProperty.call(X,"default")?X.default:X,Z=Z&&Object.prototype.hasOwnProperty.call(Z,"default")?Z.default:Z,ee=ee&&Object.prototype.hasOwnProperty.call(ee,"default")?ee.default:ee,te=te&&Object.prototype.hasOwnProperty.call(te,"default")?te.default:te,re=re&&Object.prototype.hasOwnProperty.call(re,"default")?re.default:re,ne=ne&&Object.prototype.hasOwnProperty.call(ne,"default")?ne.default:ne,ae=ae&&Object.prototype.hasOwnProperty.call(ae,"default")?ae.default:ae,oe=oe&&Object.prototype.hasOwnProperty.call(oe,"default")?oe.default:oe,se=se&&Object.prototype.hasOwnProperty.call(se,"default")?se.default:se;var _e={p:Ce,P:function(e,t){var r,n=e.match(/(P+)(p+)?/),a=n[1],o=n[2];if(!o)return be(e,t);switch(a){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;case"PPPP":default:r=t.dateTime({width:"full"})}return r.replace("{{date}}",be(a,t)).replace("{{time}}",Ce(o,t))}},Oe=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function Se(e){var t=e?"string"==typeof e||e instanceof String?oe(e):ne(e):new Date;return Me(t)?t:null}function Pe(e,t,r,n){var a=null,o=Ke(r)||He(),p=!0;return Array.isArray(t)?(t.forEach((function(t){var r=ae(e,t,new Date,{locale:o});n&&(p=Me(r)&&e===s(r,t,{awareOfUnicodeTokens:!0})),Me(r)&&p&&(a=r)})),a):(a=ae(e,t,new Date,{locale:o}),n?p=Me(a)&&e===s(a,t,{awareOfUnicodeTokens:!0}):Me(a)||(t=t.match(Oe).map((function(e){var t=e[0];return"p"===t||"P"===t?o?(0,_e[t])(e,o.formatLong):t:e})).join(""),e.length>0&&(a=ae(e,t.slice(0,e.length),new Date)),Me(a)||(a=new Date(e))),Me(a)&&p?a:null)}function Me(e){return o(e)&&ee(e,new Date("1/1/1000"))}function Ee(e,t,r){if("en"===r)return s(e,t,{awareOfUnicodeTokens:!0});var n=Ke(r);return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&He()&&Ke(He())&&(n=Ke(He())),s(e,t,{locale:n||null,awareOfUnicodeTokens:!0})}function Ne(e,t){var r=t.hour,n=void 0===r?0:r,a=t.minute,o=void 0===a?0:a,s=t.second;return Y(N(E(e,void 0===s?0:s),o),n)}function Ye(e,t){var r=t&&Ke(t)||He()&&Ke(He());return _(e,r?{locale:r}:null)}function xe(e,t){return Ee(e,"ddd",t)}function Te(e){return A(e)}function Ie(e,t){var r=Ke(t||He());return B(e,{locale:r})}function Le(e){return H(e)}function je(e){return K(e)}function Fe(e,t){return e&&t?X(e,t):!e&&!t}function qe(e,t){return e&&t?J(e,t):!e&&!t}function We(e,t){return e&&t?Z(e,t):!e&&!t}function Re(e,t){return e&&t?G(e,t):!e&&!t}function Ae(e,t){return e&&t?z(e,t):!e&&!t}function Be(e,t,r){var n,a=A(t),o=V(r);try{n=re(e,{start:a,end:o})}catch(e){n=!1}return n}function He(){return("undefined"!=typeof window?window:global).__localeId__}function Ke(e){if("string"==typeof e){var t="undefined"!=typeof window?window:global;return t.__localeData__?t.__localeData__[e]:null}return e}function Qe(e,t){return Ee(x(Se(),e),"LLLL",t)}function Ve(e,t){return Ee(x(Se(),e),"LLL",t)}function Ue(e,t){return Ee(T(Se(),e),"QQQ",t)}function $e(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return et(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return Re(e,t)}))||o&&!o.some((function(t){return Re(e,t)}))||s&&!s(Se(e))||!1}function ze(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates;return r&&r.some((function(t){return Re(e,t)}))||!1}function Ge(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return et(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return qe(e,t)}))||o&&!o.some((function(t){return qe(e,t)}))||s&&!s(Se(e))||!1}function Je(e,t,r,n){var a=P(e),o=O(e),s=P(t),p=O(t),i=P(n);return a===s&&a===i?o<=r&&r<=p:a<s?i===a&&o<=r||i===s&&p>=r||i<s&&i>a:void 0}function Xe(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return et(e,{minDate:r,maxDate:n})||a&&a.some((function(t){return We(e,t)}))||o&&!o.some((function(t){return We(e,t)}))||s&&!s(Se(e))||!1}function Ze(e,t,r,n){var a=P(e),o=S(e),s=P(t),p=S(t),i=P(n);return a===s&&a===i?o<=r&&r<=p:a<s?i===a&&o<=r||i===s&&p>=r||i<s&&i>a:void 0}function et(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate;return r&&F(e,r)<0||n&&F(e,n)>0}function tt(e,t){for(var r=t.length,n=0;n<r;n++)if(g(t[n])===g(e)&&k(t[n])===k(e))return!0;return!1}function rt(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var a,o=Se(),s=Y(N(o,k(e)),g(e)),p=Y(N(o,k(r)),g(r)),i=Y(N(o,k(n)),g(n));try{a=!re(s,{start:p,end:i})}catch(e){a=!1}return a}function nt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=v(e,1);return r&&q(r,a)>0||n&&n.every((function(e){return q(e,a)>0}))||!1}function at(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=d(e,1);return r&&q(a,r)>0||n&&n.every((function(e){return q(a,e)>0}))||!1}function ot(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=w(e,1);return r&&R(r,a)>0||n&&n.every((function(e){return R(e,a)>0}))||!1}function st(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=u(e,1);return r&&R(a,r)>0||n&&n.every((function(e){return R(a,e)>0}))||!1}function pt(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return F(e,t)>=0}));return L(n)}return r?L(r):t}function it(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return F(e,t)<=0}));return j(n)}return r?j(r):t}function ct(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,n=0,o=e.length;n<o;n++){var s=e[n];if(a(s)){var p=Ee(s,"MM.dd.yyyy"),i=r.get(p)||[];i.includes(t)||(i.push(t),r.set(p,i))}else if("object"===ie(s)){var c=Object.keys(s),l=c[0],d=s[c[0]];if("string"==typeof l&&d.constructor===Array)for(var u=0,h=d.length;u<h;u++){var f=Ee(d[u],"MM.dd.yyyy"),m=r.get(f)||[];m.includes(l)||(m.push(l),r.set(f,m))}}}return r}function lt(e,t,r,n,a){for(var o=a.length,s=[],c=0;c<o;c++){var l=p(i(e,g(a[c])),k(a[c])),d=p(e,(r+1)*n);ee(l,t)&&te(l,d)&&s.push(a[c])}return s}function dt(e){return e<10?"0".concat(e):"".concat(e)}function ut(e,t,r,n){for(var a=[],o=0;o<2*t+1;o++){var s=e+t-o,p=!0;r&&(p=P(r)<=s),n&&p&&(p=P(n)>=s),p&&a.push(s)}return a}var ht=se(function(e){ye(a,e);var r=ge(a);function a(e){var n;ce(this,a),ue(De(n=r.call(this,e)),"renderOptions",(function(){var e=n.props.year,r=n.state.yearsList.map((function(r){return t.createElement("div",{className:e===r?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:r,onClick:n.onChange.bind(De(n),r)},e===r?t.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",r)})),a=n.props.minDate?P(n.props.minDate):null,o=n.props.maxDate?P(n.props.maxDate):null;return o&&n.state.yearsList.find((function(e){return e===o}))||r.unshift(t.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:n.incrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),a&&n.state.yearsList.find((function(e){return e===a}))||r.push(t.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:n.decrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),r})),ue(De(n),"onChange",(function(e){n.props.onChange(e)})),ue(De(n),"handleClickOutside",(function(){n.props.onCancel()})),ue(De(n),"shiftYears",(function(e){var t=n.state.yearsList.map((function(t){return t+e}));n.setState({yearsList:t})})),ue(De(n),"incrementYears",(function(){return n.shiftYears(1)})),ue(De(n),"decrementYears",(function(){return n.shiftYears(-1)}));var o=e.yearDropdownItemNumber,s=e.scrollableYearDropdown,p=o||(s?10:5);return n.state={yearsList:ut(n.props.year,p,n.props.minDate,n.props.maxDate)},n}return de(a,[{key:"render",value:function(){var e=n({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),a}(t.Component)),ft=function(e){ye(n,e);var r=ge(n);function n(){var e;ce(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return ue(De(e=r.call.apply(r,[this].concat(o))),"state",{dropdownVisible:!1}),ue(De(e),"renderSelectOptions",(function(){for(var r=e.props.minDate?P(e.props.minDate):1900,n=e.props.maxDate?P(e.props.maxDate):2100,a=[],o=r;o<=n;o++)a.push(t.createElement("option",{key:o,value:o},o));return a})),ue(De(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),ue(De(e),"renderSelectMode",(function(){return t.createElement("select",{value:e.props.year,className:"react-datepicker__year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),ue(De(e),"renderReadView",(function(r){return t.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(t){return e.toggleDropdown(t)}},t.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},e.props.year))})),ue(De(e),"renderDropdown",(function(){return t.createElement(ht,{key:"dropdown",year:e.props.year,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableYearDropdown:e.props.scrollableYearDropdown,yearDropdownItemNumber:e.props.yearDropdownItemNumber})})),ue(De(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),ue(De(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.year&&e.props.onChange(t)})),ue(De(e),"toggleDropdown",(function(t){e.setState({dropdownVisible:!e.state.dropdownVisible},(function(){e.props.adjustDateOnChange&&e.handleYearChange(e.props.date,t)}))})),ue(De(e),"handleYearChange",(function(t,r){e.onSelect(t,r),e.setOpen()})),ue(De(e),"onSelect",(function(t,r){e.props.onSelect&&e.props.onSelect(t,r)})),ue(De(e),"setOpen",(function(){e.props.setOpen&&e.props.setOpen(!0)})),e}return de(n,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),n}(t.Component),mt=se(function(e){ye(n,e);var r=ge(n);function n(){var e;ce(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return ue(De(e=r.call.apply(r,[this].concat(o))),"renderOptions",(function(){return e.props.monthNames.map((function(r,n){return t.createElement("div",{className:e.props.month===n?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:r,onClick:e.onChange.bind(De(e),n)},e.props.month===n?t.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",r)}))})),ue(De(e),"onChange",(function(t){return e.props.onChange(t)})),ue(De(e),"handleClickOutside",(function(){return e.props.onCancel()})),e}return de(n,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),n}(t.Component)),yt=function(e){ye(n,e);var r=ge(n);function n(){var e;ce(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return ue(De(e=r.call.apply(r,[this].concat(o))),"state",{dropdownVisible:!1}),ue(De(e),"renderSelectOptions",(function(e){return e.map((function(e,r){return t.createElement("option",{key:r,value:r},e)}))})),ue(De(e),"renderSelectMode",(function(r){return t.createElement("select",{value:e.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},e.renderSelectOptions(r))})),ue(De(e),"renderReadView",(function(r,n){return t.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:e.toggleDropdown},t.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},n[e.props.month]))})),ue(De(e),"renderDropdown",(function(r){return t.createElement(mt,{key:"dropdown",month:e.props.month,monthNames:r,onChange:e.onChange,onCancel:e.toggleDropdown})})),ue(De(e),"renderScrollMode",(function(t){var r=e.state.dropdownVisible,n=[e.renderReadView(!r,t)];return r&&n.unshift(e.renderDropdown(t)),n})),ue(De(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.month&&e.props.onChange(t)})),ue(De(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return de(n,[{key:"render",value:function(){var e,r=this,n=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Ve(e,r.props.locale)}:function(e){return Qe(e,r.props.locale)});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(n);break;case"select":e=this.renderSelectMode(n)}return t.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),n}(t.Component);function vt(e,t){for(var r=[],n=Le(e),a=Le(t);!ee(n,a);)r.push(Se(n)),n=d(n,1);return r}var wt=se(function(e){ye(a,e);var r=ge(a);function a(e){var n;return ce(this,a),ue(De(n=r.call(this,e)),"renderOptions",(function(){return n.state.monthYearsList.map((function(e){var r=M(e),a=Fe(n.props.date,e)&&qe(n.props.date,e);return t.createElement("div",{className:a?"react-datepicker__month-year-option --selected_month-year":"react-datepicker__month-year-option",key:r,onClick:n.onChange.bind(De(n),r)},a?t.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Ee(e,n.props.dateFormat))}))})),ue(De(n),"onChange",(function(e){return n.props.onChange(e)})),ue(De(n),"handleClickOutside",(function(){n.props.onCancel()})),n.state={monthYearsList:vt(n.props.minDate,n.props.maxDate)},n}return de(a,[{key:"render",value:function(){var e=n({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),a}(t.Component)),Dt=function(e){ye(n,e);var r=ge(n);function n(){var e;ce(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return ue(De(e=r.call.apply(r,[this].concat(o))),"state",{dropdownVisible:!1}),ue(De(e),"renderSelectOptions",(function(){for(var r=Le(e.props.minDate),n=Le(e.props.maxDate),a=[];!ee(r,n);){var o=M(r);a.push(t.createElement("option",{key:o,value:o},Ee(r,e.props.dateFormat,e.props.locale))),r=d(r,1)}return a})),ue(De(e),"onSelectChange",(function(t){e.onChange(t.target.value)})),ue(De(e),"renderSelectMode",(function(){return t.createElement("select",{value:M(Le(e.props.date)),className:"react-datepicker__month-year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),ue(De(e),"renderReadView",(function(r){var n=Ee(e.props.date,e.props.dateFormat,e.props.locale);return t.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(t){return e.toggleDropdown(t)}},t.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},n))})),ue(De(e),"renderDropdown",(function(){return t.createElement(wt,{key:"dropdown",date:e.props.date,dateFormat:e.props.dateFormat,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableMonthYearDropdown:e.props.scrollableMonthYearDropdown})})),ue(De(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),ue(De(e),"onChange",(function(t){e.toggleDropdown();var r=Se(parseInt(t));Fe(e.props.date,r)&&qe(e.props.date,r)||e.props.onChange(r)})),ue(De(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return de(n,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),n}(t.Component),kt=function(e){ye(a,e);var r=ge(a);function a(){var e;ce(this,a);for(var o=arguments.length,s=new Array(o),p=0;p<o;p++)s[p]=arguments[p];return ue(De(e=r.call.apply(r,[this].concat(s))),"dayEl",t.createRef()),ue(De(e),"handleClick",(function(t){!e.isDisabled()&&e.props.onClick&&e.props.onClick(t)})),ue(De(e),"handleMouseEnter",(function(t){!e.isDisabled()&&e.props.onMouseEnter&&e.props.onMouseEnter(t)})),ue(De(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t)})),ue(De(e),"isSameDay",(function(t){return Re(e.props.day,t)})),ue(De(e),"isKeyboardSelected",(function(){return!e.props.disabledKeyboardNavigation&&!e.props.inline&&!e.isSameDay(e.props.selected)&&e.isSameDay(e.props.preSelection)})),ue(De(e),"isDisabled",(function(){return $e(e.props.day,e.props)})),ue(De(e),"isExcluded",(function(){return ze(e.props.day,e.props)})),ue(De(e),"getHighLightedClass",(function(t){var r=e.props,n=r.day,a=r.highlightDates;if(!a)return!1;var o=Ee(n,"MM.dd.yyyy");return a.get(o)})),ue(De(e),"isInRange",(function(){var t=e.props,r=t.day,n=t.startDate,a=t.endDate;return!(!n||!a)&&Be(r,n,a)})),ue(De(e),"isInSelectingRange",(function(){var t=e.props,r=t.day,n=t.selectsStart,a=t.selectsEnd,o=t.selectingDate,s=t.startDate,p=t.endDate;return!(!n&&!a||!o||e.isDisabled())&&(n&&p&&(te(o,p)||Ae(o,p))?Be(r,o,p):!(!a||!s||!ee(o,s)&&!Ae(o,s))&&Be(r,s,o))})),ue(De(e),"isSelectingRangeStart",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,n=t.selectingDate,a=t.startDate;return Re(r,t.selectsStart?n:a)})),ue(De(e),"isSelectingRangeEnd",(function(){if(!e.isInSelectingRange())return!1;var t=e.props,r=t.day,n=t.selectingDate,a=t.endDate;return Re(r,t.selectsEnd?n:a)})),ue(De(e),"isRangeStart",(function(){var t=e.props,r=t.day,n=t.startDate,a=t.endDate;return!(!n||!a)&&Re(n,r)})),ue(De(e),"isRangeEnd",(function(){var t=e.props,r=t.day,n=t.startDate,a=t.endDate;return!(!n||!a)&&Re(a,r)})),ue(De(e),"isWeekend",(function(){var t=b(e.props.day);return 0===t||6===t})),ue(De(e),"isOutsideMonth",(function(){return void 0!==e.props.month&&e.props.month!==O(e.props.day)})),ue(De(e),"getClassNames",(function(t){var r=e.props.dayClassName?e.props.dayClassName(t):void 0;return n("react-datepicker__day",r,"react-datepicker__day--"+xe(e.props.day),{"react-datepicker__day--disabled":e.isDisabled(),"react-datepicker__day--excluded":e.isExcluded(),"react-datepicker__day--selected":e.isSameDay(e.props.selected),"react-datepicker__day--keyboard-selected":e.isKeyboardSelected(),"react-datepicker__day--range-start":e.isRangeStart(),"react-datepicker__day--range-end":e.isRangeEnd(),"react-datepicker__day--in-range":e.isInRange(),"react-datepicker__day--in-selecting-range":e.isInSelectingRange(),"react-datepicker__day--selecting-range-start":e.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":e.isSelectingRangeEnd(),"react-datepicker__day--today":e.isSameDay(Se()),"react-datepicker__day--weekend":e.isWeekend(),"react-datepicker__day--outside-month":e.isOutsideMonth()},e.getHighLightedClass("react-datepicker__day--highlighted"))})),ue(De(e),"getAriaLabel",(function(){var t=e.props,r=t.day,n=t.ariaLabelPrefixWhenEnabled,a=void 0===n?"Choose":n,o=t.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,p=e.isDisabled()||e.isExcluded()?s:a;return"".concat(p," ").concat(Ee(r,"PPPP"))})),ue(De(e),"getTabIndex",(function(t,r){var n=t||e.props.selected,a=r||e.props.preSelection;return e.isKeyboardSelected()||e.isSameDay(n)&&Re(a,n)?0:-1})),ue(De(e),"handleFocusDay",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===e.getTabIndex()&&!t.isInputFocused&&e.isSameDay(e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(r=!0)),r&&e.dayEl.current.focus()})),ue(De(e),"render",(function(){return t.createElement("div",{ref:e.dayEl,className:e.getClassNames(e.props.day),onKeyDown:e.handleOnKeyDown,onClick:e.handleClick,onMouseEnter:e.handleMouseEnter,tabIndex:e.getTabIndex(),"aria-label":e.getAriaLabel(),role:"button","aria-disabled":e.isDisabled()},e.props.renderDayContents?e.props.renderDayContents(C(e.props.day),e.props.day):C(e.props.day))})),e}return de(a,[{key:"componentDidMount",value:function(){this.handleFocusDay()}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e)}}]),a}(t.Component),gt=function(e){ye(a,e);var r=ge(a);function a(){var e;ce(this,a);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return ue(De(e=r.call.apply(r,[this].concat(n))),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t)})),e}return de(a,[{key:"render",value:function(){var e=this.props,r=e.weekNumber,a=e.ariaLabelPrefix,o=void 0===a?"week ":a,s={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!e.onClick};return t.createElement("div",{className:n(s),"aria-label":"".concat(o," ").concat(this.props.weekNumber),onClick:this.handleClick},r)}}]),a}(t.Component),bt=function(e){ye(n,e);var r=ge(n);function n(){var e;ce(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return ue(De(e=r.call.apply(r,[this].concat(o))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r)})),ue(De(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),ue(De(e),"handleWeekClick",(function(t,r,n){"function"==typeof e.props.onWeekSelect&&e.props.onWeekSelect(t,r,n),e.props.shouldCloseOnSelect&&e.props.setOpen(!1)})),ue(De(e),"formatWeekNumber",(function(t){return e.props.formatWeekNumber?e.props.formatWeekNumber(t):Ye(t,e.props.locale)})),ue(De(e),"renderDays",(function(){var r=Ie(e.props.day,e.props.locale),n=[],a=e.formatWeekNumber(r);if(e.props.showWeekNumber){var o=e.props.onWeekSelect?e.handleWeekClick.bind(De(e),r,a):void 0;n.push(t.createElement(gt,{key:"W",weekNumber:a,onClick:o,ariaLabelPrefix:e.props.ariaLabelPrefix}))}return n.concat([0,1,2,3,4,5,6].map((function(n){var a=c(r,n);return t.createElement(kt,{ariaLabelPrefixWhenEnabled:e.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:e.props.disabledDayAriaLabelPrefix,key:a.valueOf(),day:a,month:e.props.month,onClick:e.handleDayClick.bind(De(e),a),onMouseEnter:e.handleDayMouseEnter.bind(De(e),a),minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,inline:e.props.inline,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,renderDayContents:e.props.renderDayContents,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef})})))})),e}return de(n,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),n}(t.Component),Ct=function(e){ye(a,e);var r=ge(a);function a(){var e;ce(this,a);for(var o=arguments.length,s=new Array(o),p=0;p<o;p++)s[p]=arguments[p];return ue(De(e=r.call.apply(r,[this].concat(s))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r,e.props.orderInDisplay)})),ue(De(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t)})),ue(De(e),"handleMouseLeave",(function(){e.props.onMouseLeave&&e.props.onMouseLeave()})),ue(De(e),"isRangeStartMonth",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&qe(x(n,t),a)})),ue(De(e),"isRangeStartQuarter",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&We(T(n,t),a)})),ue(De(e),"isRangeEndMonth",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&qe(x(n,t),o)})),ue(De(e),"isRangeEndQuarter",(function(t){var r=e.props,n=r.day,a=r.startDate,o=r.endDate;return!(!a||!o)&&We(T(n,t),o)})),ue(De(e),"isWeekInMonth",(function(t){var r=e.props.day,n=c(t,6);return qe(t,r)||qe(n,r)})),ue(De(e),"renderWeeks",(function(){for(var r=[],n=e.props.fixedHeight,a=Ie(Le(e.props.day),e.props.locale),o=0,s=!1;r.push(t.createElement(bt,{ariaLabelPrefix:e.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:e.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:e.props.disabledDayAriaLabelPrefix,key:o,day:a,month:O(e.props.day),onDayClick:e.handleDayClick,onDayMouseEnter:e.handleDayMouseEnter,onWeekSelect:e.props.onWeekSelect,formatWeekNumber:e.props.formatWeekNumber,locale:e.props.locale,minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,includeDates:e.props.includeDates,inline:e.props.inline,highlightDates:e.props.highlightDates,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,showWeekNumber:e.props.showWeekNumbers,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,setOpen:e.props.setOpen,shouldCloseOnSelect:e.props.shouldCloseOnSelect,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,renderDayContents:e.props.renderDayContents,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef})),!s;){o++,a=l(a,1);var p=n&&o>=6,i=!n&&!e.isWeekInMonth(a);if(p||i){if(!e.props.peekNextMonth)break;s=!0}}return r})),ue(De(e),"onMonthClick",(function(t,r){e.handleDayClick(Le(x(e.props.day,r)),t)})),ue(De(e),"onQuarterClick",(function(t,r){e.handleDayClick(je(T(e.props.day,r)),t)})),ue(De(e),"getMonthClassNames",(function(t){var r=e.props,a=r.day,o=r.startDate,s=r.endDate,p=r.selected,i=r.minDate,c=r.maxDate;return n("react-datepicker__month-text","react-datepicker__month-".concat(t),{"react-datepicker__month--disabled":(i||c)&&Ge(x(a,t),e.props),"react-datepicker__month--selected":O(a)===t&&P(a)===P(p),"react-datepicker__month--in-range":Je(o,s,t,a),"react-datepicker__month--range-start":e.isRangeStartMonth(t),"react-datepicker__month--range-end":e.isRangeEndMonth(t)})})),ue(De(e),"getQuarterClassNames",(function(t){var r=e.props,a=r.day,o=r.startDate,s=r.endDate,p=r.selected,i=r.minDate,c=r.maxDate;return n("react-datepicker__quarter-text","react-datepicker__quarter-".concat(t),{"react-datepicker__quarter--disabled":(i||c)&&Xe(T(a,t),e.props),"react-datepicker__quarter--selected":S(a)===t&&P(a)===P(p),"react-datepicker__quarter--in-range":Ze(o,s,t,a),"react-datepicker__quarter--range-start":e.isRangeStartQuarter(t),"react-datepicker__quarter--range-end":e.isRangeEndQuarter(t)})})),ue(De(e),"renderMonths",(function(){var r=e.props,n=r.showFullMonthYearPicker,a=r.locale;return[[0,1,2],[3,4,5],[6,7,8],[9,10,11]].map((function(r,o){return t.createElement("div",{className:"react-datepicker__month-wrapper",key:o},r.map((function(r,o){return t.createElement("div",{key:o,onClick:function(t){e.onMonthClick(t,r)},className:e.getMonthClassNames(r)},n?Qe(r,a):Ve(r,a))})))}))})),ue(De(e),"renderQuarters",(function(){return t.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(r,n){return t.createElement("div",{key:n,onClick:function(t){e.onQuarterClick(t,r)},className:e.getQuarterClassNames(r)},Ue(r,e.props.locale))})))})),ue(De(e),"getClassNames",(function(){var t=e.props,r=t.selectingDate,a=t.selectsStart,o=t.selectsEnd,s=t.showMonthYearPicker,p=t.showQuarterYearPicker;return n("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(a||o)},{"react-datepicker__monthPicker":s},{"react-datepicker__quarterPicker":p})})),e}return de(a,[{key:"render",value:function(){var e=this.props,r=e.showMonthYearPicker,n=e.showQuarterYearPicker,a=e.day,o=e.ariaLabelPrefix,s=void 0===o?"month ":o;return t.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(s," ").concat(Ee(a,"yyyy-MM"))},r?this.renderMonths():n?this.renderQuarters():this.renderWeeks())}}]),a}(t.Component),_t=function(e){ye(n,e);var r=ge(n);function n(){var e;ce(this,n);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return ue(De(e=r.call.apply(r,[this].concat(o))),"state",{height:null}),ue(De(e),"handleClick",(function(t){(e.props.minTime||e.props.maxTime)&&rt(t,e.props)||e.props.excludeTimes&&tt(t,e.props.excludeTimes)||e.props.includeTimes&&!tt(t,e.props.includeTimes)||e.props.onChange(t)})),ue(De(e),"liClasses",(function(t,r,n){var a=["react-datepicker__time-list-item",e.props.timeClassName?e.props.timeClassName(t,r,n):void 0];return e.props.selected&&r===g(t)&&n===k(t)&&a.push("react-datepicker__time-list-item--selected"),((e.props.minTime||e.props.maxTime)&&rt(t,e.props)||e.props.excludeTimes&&tt(t,e.props.excludeTimes)||e.props.includeTimes&&!tt(t,e.props.includeTimes))&&a.push("react-datepicker__time-list-item--disabled"),e.props.injectTimes&&(60*g(t)+k(t))%e.props.intervals!=0&&a.push("react-datepicker__time-list-item--injected"),a.join(" ")})),ue(De(e),"renderTimes",(function(){for(var r=[],n=e.props.format?e.props.format:"p",a=e.props.intervals,o=e.props.selected||e.props.openToDate||Se(),s=g(o),i=k(o),c=Te(Se()),l=1440/a,d=e.props.injectTimes&&e.props.injectTimes.sort((function(e,t){return e-t})),u=0;u<l;u++){var h=p(c,u*a);if(r.push(h),d){var f=lt(c,h,u,a,d);r=r.concat(f)}}return r.map((function(r,a){return t.createElement("li",{key:a,onClick:e.handleClick.bind(De(e),r),className:e.liClasses(r,s,i),ref:function(t){s===g(r)&&i>=k(r)&&(e.centerLi=t)}},Ee(r,n,e.props.locale))}))})),e}return de(n,[{key:"componentDidMount",value:function(){this.list.scrollTop=n.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,r=this.state.height;return t.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},t.createElement("div",{className:"react-datepicker__header react-datepicker__header--time",ref:function(t){e.header=t}},t.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),t.createElement("div",{className:"react-datepicker__time"},t.createElement("div",{className:"react-datepicker__time-box"},t.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:r?{height:r}:{}},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),n}(t.Component);ue(_t,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var Ot=function(e){ye(n,e);var r=ge(n);function n(e){var t;return ce(this,n),ue(De(t=r.call(this,e)),"handleYearClick",(function(e,r){t.props.onDayClick&&t.props.onDayClick(e,r)})),ue(De(t),"onYearClick",(function(e,r){var n;t.handleYearClick((n=I(t.props.date,r),Q(n)),e)})),t}return de(n,[{key:"render",value:function(){for(var e=this,r=[],n=this.props.date,a=function(n,a){r.push(t.createElement("div",{onClick:function(t){e.onYearClick(t,n)},className:"react-datepicker__year-container-text",key:n},n))},o=P(n)-11,s=0;o<=P(n);o++,s++)a(o);return t.createElement("div",{className:"react-datepicker__year-container"},r)}}]),n}(t.Component),St=function(e){ye(n,e);var r=ge(n);function n(e){var a;return ce(this,n),ue(De(a=r.call(this,e)),"onTimeChange",(function(e){a.setState({time:e});var t=new Date;t.setHours(e.split(":")[0]),t.setMinutes(e.split(":")[1]),a.props.onChange(t)})),ue(De(a),"renderTimeInput",(function(){var e=a.state.time,r=a.props,n=r.timeString,o=r.customTimeInput;return o?t.cloneElement(o,{value:e,onChange:a.onTimeChange}):t.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:e,onChange:function(e){a.onTimeChange(e.target.value||n)}})})),a.state={time:a.props.timeString},a}return de(n,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__input-time-container"},t.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),t.createElement("div",{className:"react-datepicker-time__input-container"},t.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}]),n}(t.Component);function Pt(e){var r=e.className,n=e.children,a=e.showPopperArrow,o=e.arrowProps,s=void 0===o?{}:o;return t.createElement("div",{className:r},a&&t.createElement("div",he({className:"react-datepicker__triangle"},s)),n)}var Mt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],Et=function(e){ye(a,e);var r=ge(a);function a(e){var o;return ce(this,a),ue(De(o=r.call(this,e)),"handleClickOutside",(function(e){o.props.onClickOutside(e)})),ue(De(o),"setClickOutsideRef",(function(){return o.containerRef.current})),ue(De(o),"handleDropdownFocus",(function(e){(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return Mt.some((function(e){return t.indexOf(e)>=0}))})(e.target)&&o.props.onDropdownFocus()})),ue(De(o),"getDateInView",(function(){var e=o.props,t=e.preSelection,r=e.selected,n=e.openToDate,a=pt(o.props),s=it(o.props),p=Se(),i=n||r||t;return i||(a&&te(p,a)?a:s&&ee(p,s)?s:p)})),ue(De(o),"increaseMonth",(function(){o.setState((function(e){var t=e.date;return{date:d(t,1)}}),(function(){return o.handleMonthChange(o.state.date)}))})),ue(De(o),"decreaseMonth",(function(){o.setState((function(e){var t=e.date;return{date:v(t,1)}}),(function(){return o.handleMonthChange(o.state.date)}))})),ue(De(o),"handleDayClick",(function(e,t,r){return o.props.onSelect(e,t,r)})),ue(De(o),"handleDayMouseEnter",(function(e){o.setState({selectingDate:e}),o.props.onDayMouseEnter&&o.props.onDayMouseEnter(e)})),ue(De(o),"handleMonthMouseLeave",(function(){o.setState({selectingDate:null}),o.props.onMonthMouseLeave&&o.props.onMonthMouseLeave()})),ue(De(o),"handleYearChange",(function(e){o.props.onYearChange&&o.props.onYearChange(e)})),ue(De(o),"handleMonthChange",(function(e){o.props.onMonthChange&&o.props.onMonthChange(e),o.props.adjustDateOnChange&&(o.props.onSelect&&o.props.onSelect(e),o.props.setOpen&&o.props.setOpen(!0)),o.props.setPreSelection&&o.props.setPreSelection(e)})),ue(De(o),"handleMonthYearChange",(function(e){o.handleYearChange(e),o.handleMonthChange(e)})),ue(De(o),"changeYear",(function(e){o.setState((function(t){var r=t.date;return{date:I(r,e)}}),(function(){return o.handleYearChange(o.state.date)}))})),ue(De(o),"changeMonth",(function(e){o.setState((function(t){var r=t.date;return{date:x(r,e)}}),(function(){return o.handleMonthChange(o.state.date)}))})),ue(De(o),"changeMonthYear",(function(e){o.setState((function(t){var r=t.date;return{date:I(x(r,O(e)),P(e))}}),(function(){return o.handleMonthYearChange(o.state.date)}))})),ue(De(o),"header",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:o.state.date,r=Ie(e,o.props.locale),a=[];return o.props.showWeekNumbers&&a.push(t.createElement("div",{key:"W",className:"react-datepicker__day-name"},o.props.weekLabel||"#")),a.concat([0,1,2,3,4,5,6].map((function(e){var a=c(r,e),s=o.formatWeekday(a,o.props.locale),p=o.props.weekDayClassName?o.props.weekDayClassName(a):void 0;return t.createElement("div",{key:e,className:n("react-datepicker__day-name",p)},s)})))})),ue(De(o),"formatWeekday",(function(e,t){return o.props.formatWeekDay?function(e,t,r){return t(Ee(e,"EEEE",r))}(e,o.props.formatWeekDay,t):o.props.useWeekdaysShort?function(e,t){return Ee(e,"EEE",t)}(e,t):function(e,t){return Ee(e,"EEEEEE",t)}(e,t)})),ue(De(o),"decreaseYear",(function(){o.setState((function(e){var t=e.date;return{date:w(t,o.props.showYearPicker?11:1)}}),(function(){return o.handleYearChange(o.state.date)}))})),ue(De(o),"renderPreviousButton",(function(){if(!o.props.renderCustomHeader){var e=o.props.showMonthYearPicker?ot(o.state.date,o.props):nt(o.state.date,o.props);if((o.props.forceShowMonthNavigation||o.props.showDisabledMonthNavigation||!e)&&!o.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--previous"],n=o.decreaseMonth;(o.props.showMonthYearPicker||o.props.showQuarterYearPicker||o.props.showYearPicker)&&(n=o.decreaseYear),e&&o.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--previous--disabled"),n=null);var a=o.props.showMonthYearPicker||o.props.showQuarterYearPicker,s=o.props,p=s.previousMonthAriaLabel,i=void 0===p?"Previous Month":p,c=s.previousYearAriaLabel,l=void 0===c?"Previous Year":c;return t.createElement("button",{type:"button",className:r.join(" "),onClick:n,"aria-label":a?l:i},a?o.props.previousYearButtonLabel:o.props.previousMonthButtonLabel)}}})),ue(De(o),"increaseYear",(function(){o.setState((function(e){var t=e.date;return{date:u(t,o.props.showYearPicker?11:1)}}),(function(){return o.handleYearChange(o.state.date)}))})),ue(De(o),"renderNextButton",(function(){if(!o.props.renderCustomHeader){var e=o.props.showMonthYearPicker?st(o.state.date,o.props):at(o.state.date,o.props);if((o.props.forceShowMonthNavigation||o.props.showDisabledMonthNavigation||!e)&&!o.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--next"];o.props.showTimeSelect&&r.push("react-datepicker__navigation--next--with-time"),o.props.todayButton&&r.push("react-datepicker__navigation--next--with-today-button");var n=o.increaseMonth;(o.props.showMonthYearPicker||o.props.showQuarterYearPicker||o.props.showYearPicker)&&(n=o.increaseYear),e&&o.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--next--disabled"),n=null);var a=o.props.showMonthYearPicker||o.props.showQuarterYearPicker,s=o.props,p=s.nextMonthAriaLabel,i=void 0===p?"Next Month":p,c=s.nextYearAriaLabel,l=void 0===c?"Next Year":c;return t.createElement("button",{type:"button",className:r.join(" "),onClick:n,"aria-label":a?l:i},a?o.props.nextYearButtonLabel:o.props.nextMonthButtonLabel)}}})),ue(De(o),"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:o.state.date,r=["react-datepicker__current-month"];return o.props.showYearDropdown&&r.push("react-datepicker__current-month--hasYearDropdown"),o.props.showMonthDropdown&&r.push("react-datepicker__current-month--hasMonthDropdown"),o.props.showMonthYearDropdown&&r.push("react-datepicker__current-month--hasMonthYearDropdown"),t.createElement("div",{className:r.join(" ")},Ee(e,o.props.dateFormat,o.props.locale))})),ue(De(o),"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(o.props.showYearDropdown&&!e)return t.createElement(ft,{adjustDateOnChange:o.props.adjustDateOnChange,date:o.state.date,onSelect:o.props.onSelect,setOpen:o.props.setOpen,dropdownMode:o.props.dropdownMode,onChange:o.changeYear,minDate:o.props.minDate,maxDate:o.props.maxDate,year:P(o.state.date),scrollableYearDropdown:o.props.scrollableYearDropdown,yearDropdownItemNumber:o.props.yearDropdownItemNumber})})),ue(De(o),"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(o.props.showMonthDropdown&&!e)return t.createElement(yt,{dropdownMode:o.props.dropdownMode,locale:o.props.locale,onChange:o.changeMonth,month:O(o.state.date),useShortMonthInDropdown:o.props.useShortMonthInDropdown})})),ue(De(o),"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(o.props.showMonthYearDropdown&&!e)return t.createElement(Dt,{dropdownMode:o.props.dropdownMode,locale:o.props.locale,dateFormat:o.props.dateFormat,onChange:o.changeMonthYear,minDate:o.props.minDate,maxDate:o.props.maxDate,date:o.state.date,scrollableMonthYearDropdown:o.props.scrollableMonthYearDropdown})})),ue(De(o),"renderTodayButton",(function(){if(o.props.todayButton&&!o.props.showTimeSelectOnly)return t.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return o.props.onSelect(A(Se()),e)}},o.props.todayButton)})),ue(De(o),"renderDefaultHeader",(function(e){var r=e.monthDate,n=e.i;return t.createElement("div",{className:"react-datepicker__header"},o.renderCurrentMonth(r),t.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(o.props.dropdownMode),onFocus:o.handleDropdownFocus},o.renderMonthDropdown(0!==n),o.renderMonthYearDropdown(0!==n),o.renderYearDropdown(0!==n)),t.createElement("div",{className:"react-datepicker__day-names"},o.header(r)))})),ue(De(o),"renderCustomHeader",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=e.monthDate,n=e.i;if(0!==n&&void 0!==n)return null;var a=nt(o.state.date,o.props),s=at(o.state.date,o.props),p=ot(o.state.date,o.props),i=st(o.state.date,o.props),c=!o.props.showMonthYearPicker&&!o.props.showQuarterYearPicker&&!o.props.showYearPicker;return t.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:o.props.onDropdownFocus},o.props.renderCustomHeader(me(me({},o.state),{},{changeMonth:o.changeMonth,changeYear:o.changeYear,decreaseMonth:o.decreaseMonth,increaseMonth:o.increaseMonth,decreaseYear:o.decreaseYear,increaseYear:o.increaseYear,prevMonthButtonDisabled:a,nextMonthButtonDisabled:s,prevYearButtonDisabled:p,nextYearButtonDisabled:i})),c&&t.createElement("div",{className:"react-datepicker__day-names"},o.header(r)))})),ue(De(o),"renderYearHeader",(function(){return t.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},o.props.showYearPicker?"".concat(P(o.state.date)-11," - ").concat(P(o.state.date)):P(o.state.date))})),ue(De(o),"renderHeader",(function(e){switch(!0){case void 0!==o.props.renderCustomHeader:return o.renderCustomHeader(e);case o.props.showMonthYearPicker||o.props.showQuarterYearPicker||o.props.showYearPicker:return o.renderYearHeader(e);default:return o.renderDefaultHeader(e)}})),ue(De(o),"renderMonths",(function(){if(!o.props.showTimeSelectOnly&&!o.props.showYearPicker){for(var e=[],r=o.props.showPreviousMonths?o.props.monthsShown-1:0,n=v(o.state.date,r),a=0;a<o.props.monthsShown;++a){var s=a-o.props.monthSelectedIn,p=d(n,s),i="month-".concat(a);e.push(t.createElement("div",{key:i,ref:function(e){o.monthContainer=e},className:"react-datepicker__month-container"},o.renderHeader({monthDate:p,i:a}),t.createElement(Ct,{chooseDayAriaLabelPrefix:o.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:o.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:o.props.weekAriaLabelPrefix,onChange:o.changeMonthYear,day:p,dayClassName:o.props.dayClassName,monthClassName:o.props.monthClassName,onDayClick:o.handleDayClick,handleOnKeyDown:o.props.handleOnKeyDown,onDayMouseEnter:o.handleDayMouseEnter,onMouseLeave:o.handleMonthMouseLeave,onWeekSelect:o.props.onWeekSelect,orderInDisplay:a,formatWeekNumber:o.props.formatWeekNumber,locale:o.props.locale,minDate:o.props.minDate,maxDate:o.props.maxDate,excludeDates:o.props.excludeDates,highlightDates:o.props.highlightDates,selectingDate:o.state.selectingDate,includeDates:o.props.includeDates,inline:o.props.inline,fixedHeight:o.props.fixedHeight,filterDate:o.props.filterDate,preSelection:o.props.preSelection,selected:o.props.selected,selectsStart:o.props.selectsStart,selectsEnd:o.props.selectsEnd,showWeekNumbers:o.props.showWeekNumbers,startDate:o.props.startDate,endDate:o.props.endDate,peekNextMonth:o.props.peekNextMonth,setOpen:o.props.setOpen,shouldCloseOnSelect:o.props.shouldCloseOnSelect,renderDayContents:o.props.renderDayContents,disabledKeyboardNavigation:o.props.disabledKeyboardNavigation,showMonthYearPicker:o.props.showMonthYearPicker,showFullMonthYearPicker:o.props.showFullMonthYearPicker,showYearPicker:o.props.showYearPicker,showQuarterYearPicker:o.props.showQuarterYearPicker,isInputFocused:o.props.isInputFocused,containerRef:o.containerRef})))}return e}})),ue(De(o),"renderYears",(function(){if(!o.props.showTimeSelectOnly)return o.props.showYearPicker?t.createElement("div",{className:"react-datepicker__year"},o.renderHeader(),t.createElement(Ot,{onDayClick:o.handleDayClick,date:o.state.date})):void 0})),ue(De(o),"renderTimeSection",(function(){if(o.props.showTimeSelect&&(o.state.monthContainer||o.props.showTimeSelectOnly))return t.createElement(_t,{selected:o.props.selected,openToDate:o.props.openToDate,onChange:o.props.onTimeChange,timeClassName:o.props.timeClassName,format:o.props.timeFormat,includeTimes:o.props.includeTimes,intervals:o.props.timeIntervals,minTime:o.props.minTime,maxTime:o.props.maxTime,excludeTimes:o.props.excludeTimes,timeCaption:o.props.timeCaption,todayButton:o.props.todayButton,showMonthDropdown:o.props.showMonthDropdown,showMonthYearDropdown:o.props.showMonthYearDropdown,showYearDropdown:o.props.showYearDropdown,withPortal:o.props.withPortal,monthRef:o.state.monthContainer,injectTimes:o.props.injectTimes,locale:o.props.locale})})),ue(De(o),"renderInputTimeSection",(function(){var e=new Date(o.props.selected),r="".concat(dt(e.getHours()),":").concat(dt(e.getMinutes()));if(o.props.showTimeInput)return t.createElement(St,{timeString:r,timeInputLabel:o.props.timeInputLabel,onChange:o.props.onTimeChange,customTimeInput:o.props.customTimeInput})})),o.containerRef=t.createRef(),o.state={date:o.getDateInView(),selectingDate:null,monthContainer:null},o}return de(a,null,[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null}}}]),de(a,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!Re(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!Re(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate})}},{key:"render",value:function(){var e=this.props.container||Pt;return t.createElement("div",{ref:this.containerRef},t.createElement(e,{className:n("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}]),a}(t.Component),Nt=function(e){return!e.disabled&&-1!==e.tabIndex},Yt=function(e){ye(n,e);var r=ge(n);function n(e){var a;return ce(this,n),ue(De(a=r.call(this,e)),"getTabChildren",(function(){return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(Nt)})),ue(De(a),"handleFocusStart",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[t.length-1].focus()})),ue(De(a),"handleFocusEnd",(function(e){var t=a.getTabChildren();t&&t.length>1&&t[0].focus()})),a.tabLoopRef=t.createRef(),a}return de(n,null,[{key:"defaultProps",get:function(){return{enableTabLoop:!0}}}]),de(n,[{key:"render",value:function(){return this.props.enableTabLoop?t.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},t.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,t.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}]),n}(t.Component),xt=function(e){ye(a,e);var r=ge(a);function a(){return ce(this,a),r.apply(this,arguments)}return de(a,[{key:"render",value:function(){var e,r=this.props,a=r.className,o=r.wrapperClassName,s=r.hidePopper,p=r.popperComponent,i=r.popperModifiers,c=r.popperPlacement,l=r.popperProps,d=r.targetComponent,u=r.enableTabLoop,h=r.popperOnKeyDown;if(!s){var f=n("react-datepicker-popper",a);e=t.createElement(pe.Popper,he({modifiers:i,placement:c},l),(function(e){var r=e.ref,n=e.style,a=e.placement,o=e.arrowProps;return t.createElement(Yt,{enableTabLoop:u},t.createElement("div",he({ref:r,style:n},{className:f,"data-placement":a,onKeyDown:h}),t.cloneElement(p,{arrowProps:o})))}))}this.props.popperContainer&&(e=t.createElement(this.props.popperContainer,{},e));var m=n("react-datepicker-wrapper",o);return t.createElement(pe.Manager,{className:"react-datepicker-manager"},t.createElement(pe.Reference,null,(function(e){var r=e.ref;return t.createElement("div",{ref:r,className:m},d)})),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperProps:{},popperPlacement:"bottom-start"}}}]),a}(t.Component),Tt=se(Et);var It=function(e){ye(o,e);var r=ge(o);function o(e){var s;return ce(this,o),ue(De(s=r.call(this,e)),"getPreSelection",(function(){return s.props.openToDate?s.props.openToDate:s.props.selectsEnd&&s.props.startDate?s.props.startDate:s.props.selectsStart&&s.props.endDate?s.props.endDate:Se()})),ue(De(s),"calcInitialState",(function(){var e=s.getPreSelection(),t=pt(s.props),r=it(s.props),n=t&&te(e,t)?t:r&&ee(e,r)?r:e;return{open:s.props.startOpen||!1,preventFocus:!1,preSelection:s.props.selected?s.props.selected:n,highlightDates:ct(s.props.highlightDates),focused:!1}})),ue(De(s),"clearPreventFocusTimeout",(function(){s.preventFocusTimeout&&clearTimeout(s.preventFocusTimeout)})),ue(De(s),"setFocus",(function(){s.input&&s.input.focus&&s.input.focus()})),ue(De(s),"setBlur",(function(){s.input&&s.input.blur&&s.input.blur(),s.cancelFocusInput()})),ue(De(s),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];s.setState({open:e,preSelection:e&&s.state.open?s.state.preSelection:s.calcInitialState().preSelection,lastPreSelectChange:jt},(function(){e||s.setState((function(e){return{focused:!!t&&e.focused}}),(function(){!t&&s.setBlur(),s.setState({inputValue:null})}))}))})),ue(De(s),"inputOk",(function(){return a(s.state.preSelection)})),ue(De(s),"isCalendarOpen",(function(){return void 0===s.props.open?s.state.open&&!s.props.disabled&&!s.props.readOnly:s.props.open})),ue(De(s),"handleFocus",(function(e){s.state.preventFocus||(s.props.onFocus(e),s.props.preventOpenOnFocus||s.props.readOnly||s.setOpen(!0)),s.setState({focused:!0})})),ue(De(s),"cancelFocusInput",(function(){clearTimeout(s.inputFocusTimeout),s.inputFocusTimeout=null})),ue(De(s),"deferFocusInput",(function(){s.cancelFocusInput(),s.inputFocusTimeout=setTimeout((function(){return s.setFocus()}),1)})),ue(De(s),"handleDropdownFocus",(function(){s.cancelFocusInput()})),ue(De(s),"handleBlur",(function(e){(!s.state.open||s.props.withPortal||s.props.showTimeInput)&&s.props.onBlur(e),s.setState({focused:!1})})),ue(De(s),"handleCalendarClickOutside",(function(e){s.props.inline||s.setOpen(!1),s.props.onClickOutside(e),s.props.withPortal&&e.preventDefault()})),ue(De(s),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!s.props.onChangeRaw||(s.props.onChangeRaw.apply(De(s),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){s.setState({inputValue:n.target.value,lastPreSelectChange:Lt});var a=Pe(n.target.value,s.props.dateFormat,s.props.locale,s.props.strictParsing);!a&&n.target.value||s.setSelected(a,n,!0)}})),ue(De(s),"handleSelect",(function(e,t,r){s.setState({preventFocus:!0},(function(){return s.preventFocusTimeout=setTimeout((function(){return s.setState({preventFocus:!1})}),50),s.preventFocusTimeout})),s.setSelected(e,t,!1,r),!s.props.shouldCloseOnSelect||s.props.showTimeSelect?s.setPreSelection(e):s.props.inline||s.setOpen(!1)})),ue(De(s),"setSelected",(function(e,t,r,n){var a=e;null!==a&&$e(a,s.props)||(Ae(s.props.selected,a)&&!s.props.allowSameDay||(null!==a&&(!s.props.selected||r&&(s.props.showTimeSelect||s.props.showTimeSelectOnly||s.props.showTimeInput)||(a=Ne(a,{hour:g(s.props.selected),minute:k(s.props.selected),second:D(s.props.selected)})),s.props.inline||s.setState({preSelection:a}),s.props.inline&&s.props.monthsShown>1&&!s.props.inlineFocusSelectedMonth&&s.setState({monthSelectedIn:n})),s.props.onChange(a,t)),s.props.onSelect(a,t),r||s.setState({inputValue:null}))})),ue(De(s),"setPreSelection",(function(e){var t=void 0!==s.props.minDate,r=void 0!==s.props.maxDate,n=!0;e&&(t&&r?n=Be(e,s.props.minDate,s.props.maxDate):t?n=ee(e,s.props.minDate):r&&(n=te(e,s.props.maxDate))),n&&s.setState({preSelection:e})})),ue(De(s),"handleTimeChange",(function(e){var t=Ne(s.props.selected?s.props.selected:s.getPreSelection(),{hour:g(e),minute:k(e)});s.setState({preSelection:t}),s.props.onChange(t),s.props.shouldCloseOnSelect&&s.setOpen(!1),s.props.showTimeInput&&s.setOpen(!0),s.setState({inputValue:null})})),ue(De(s),"onInputClick",(function(){s.props.disabled||s.props.readOnly||s.setOpen(!0),s.props.onInputClick()})),ue(De(s),"onInputKeyDown",(function(e){s.props.onKeyDown(e);var t=e.key;if(s.state.open||s.props.inline||s.props.preventOpenOnFocus){if(s.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=s.calendar.componentNode&&s.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');return void(r&&r.focus())}var n=Se(s.state.preSelection);"Enter"===t?(e.preventDefault(),s.inputOk()&&s.state.lastPreSelectChange===jt?(s.handleSelect(n,e),!s.props.shouldCloseOnSelect&&s.setPreSelection(n)):s.setOpen(!1)):"Escape"===t&&(e.preventDefault(),s.setOpen(!1)),s.inputOk()||s.props.onInputError({code:1,msg:"Date input not valid."})}}else"ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||s.onInputClick()})),ue(De(s),"onDayKeyDown",(function(e){s.props.onKeyDown(e);var t=e.key,r=Se(s.state.preSelection);if("Enter"===t)e.preventDefault(),s.handleSelect(r,e),!s.props.shouldCloseOnSelect&&s.setPreSelection(r);else if("Escape"===t)e.preventDefault(),s.setOpen(!1),s.inputOk()||s.props.onInputError({code:1,msg:"Date input not valid."});else if(!s.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=m(r,1);break;case"ArrowRight":n=c(r,1);break;case"ArrowUp":n=y(r,1);break;case"ArrowDown":n=l(r,1);break;case"PageUp":n=v(r,1);break;case"PageDown":n=d(r,1);break;case"Home":n=w(r,1);break;case"End":n=u(r,1)}if(!n)return void(s.props.onInputError&&s.props.onInputError({code:1,msg:"Date input not valid."}));e.preventDefault(),s.setState({lastPreSelectChange:jt}),s.props.adjustDateOnChange&&s.setSelected(n),s.setPreSelection(n)}})),ue(De(s),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),s.setState({preventFocus:!0},(function(){s.setOpen(!1),setTimeout((function(){s.setFocus(),s.setState({preventFocus:!1})}))})))})),ue(De(s),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),s.props.onChange(null,e),s.setState({inputValue:null})})),ue(De(s),"clear",(function(){s.onClearClick()})),ue(De(s),"renderCalendar",(function(){return s.props.inline||s.isCalendarOpen()?t.createElement(Tt,{ref:function(e){s.calendar=e},locale:s.props.locale,chooseDayAriaLabelPrefix:s.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:s.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:s.props.weekAriaLabelPrefix,adjustDateOnChange:s.props.adjustDateOnChange,setOpen:s.setOpen,shouldCloseOnSelect:s.props.shouldCloseOnSelect,dateFormat:s.props.dateFormatCalendar,useWeekdaysShort:s.props.useWeekdaysShort,formatWeekDay:s.props.formatWeekDay,dropdownMode:s.props.dropdownMode,selected:s.props.selected,preSelection:s.state.preSelection,onSelect:s.handleSelect,onWeekSelect:s.props.onWeekSelect,openToDate:s.props.openToDate,minDate:s.props.minDate,maxDate:s.props.maxDate,selectsStart:s.props.selectsStart,selectsEnd:s.props.selectsEnd,startDate:s.props.startDate,endDate:s.props.endDate,excludeDates:s.props.excludeDates,filterDate:s.props.filterDate,onClickOutside:s.handleCalendarClickOutside,formatWeekNumber:s.props.formatWeekNumber,highlightDates:s.state.highlightDates,includeDates:s.props.includeDates,includeTimes:s.props.includeTimes,injectTimes:s.props.injectTimes,inline:s.props.inline,peekNextMonth:s.props.peekNextMonth,showMonthDropdown:s.props.showMonthDropdown,showPreviousMonths:s.props.showPreviousMonths,useShortMonthInDropdown:s.props.useShortMonthInDropdown,showMonthYearDropdown:s.props.showMonthYearDropdown,showWeekNumbers:s.props.showWeekNumbers,showYearDropdown:s.props.showYearDropdown,withPortal:s.props.withPortal,forceShowMonthNavigation:s.props.forceShowMonthNavigation,showDisabledMonthNavigation:s.props.showDisabledMonthNavigation,scrollableYearDropdown:s.props.scrollableYearDropdown,scrollableMonthYearDropdown:s.props.scrollableMonthYearDropdown,todayButton:s.props.todayButton,weekLabel:s.props.weekLabel,outsideClickIgnoreClass:"react-datepicker-ignore-onclickoutside",fixedHeight:s.props.fixedHeight,monthsShown:s.props.monthsShown,monthSelectedIn:s.state.monthSelectedIn,onDropdownFocus:s.handleDropdownFocus,onMonthChange:s.props.onMonthChange,onYearChange:s.props.onYearChange,dayClassName:s.props.dayClassName,weekDayClassName:s.props.weekDayClassName,monthClassName:s.props.monthClassName,timeClassName:s.props.timeClassName,showTimeSelect:s.props.showTimeSelect,showTimeSelectOnly:s.props.showTimeSelectOnly,onTimeChange:s.handleTimeChange,timeFormat:s.props.timeFormat,timeIntervals:s.props.timeIntervals,minTime:s.props.minTime,maxTime:s.props.maxTime,excludeTimes:s.props.excludeTimes,timeCaption:s.props.timeCaption,className:s.props.calendarClassName,container:s.props.calendarContainer,yearDropdownItemNumber:s.props.yearDropdownItemNumber,previousMonthButtonLabel:s.props.previousMonthButtonLabel,nextMonthButtonLabel:s.props.nextMonthButtonLabel,previousYearButtonLabel:s.props.previousYearButtonLabel,nextYearButtonLabel:s.props.nextYearButtonLabel,timeInputLabel:s.props.timeInputLabel,disabledKeyboardNavigation:s.props.disabledKeyboardNavigation,renderCustomHeader:s.props.renderCustomHeader,popperProps:s.props.popperProps,renderDayContents:s.props.renderDayContents,onDayMouseEnter:s.props.onDayMouseEnter,onMonthMouseLeave:s.props.onMonthMouseLeave,showTimeInput:s.props.showTimeInput,showMonthYearPicker:s.props.showMonthYearPicker,showFullMonthYearPicker:s.props.showFullMonthYearPicker,showYearPicker:s.props.showYearPicker,showQuarterYearPicker:s.props.showQuarterYearPicker,showPopperArrow:s.props.showPopperArrow,excludeScrollbar:s.props.excludeScrollbar,handleOnKeyDown:s.onDayKeyDown,isInputFocused:s.state.focused,customTimeInput:s.props.customTimeInput,setPreSelection:s.setPreSelection},s.props.children):null})),ue(De(s),"renderDateInput",(function(){var e,r,a,o,p,i=n(s.props.className,ue({},"react-datepicker-ignore-onclickoutside",s.state.open)),c=s.props.customInput||t.createElement("input",{type:"text"}),l=s.props.customInputRef||"ref",d="string"==typeof s.props.value?s.props.value:"string"==typeof s.state.inputValue?s.state.inputValue:(r=s.props.selected,a=s.props,o=a.dateFormat,p=a.locale,r&&Ee(r,Array.isArray(o)?o[0]:o,p)||"");return t.cloneElement(c,(ue(e={},l,(function(e){s.input=e})),ue(e,"value",d),ue(e,"onBlur",s.handleBlur),ue(e,"onChange",s.handleChange),ue(e,"onClick",s.onInputClick),ue(e,"onFocus",s.handleFocus),ue(e,"onKeyDown",s.onInputKeyDown),ue(e,"id",s.props.id),ue(e,"name",s.props.name),ue(e,"autoFocus",s.props.autoFocus),ue(e,"placeholder",s.props.placeholderText),ue(e,"disabled",s.props.disabled),ue(e,"autoComplete",s.props.autoComplete),ue(e,"className",n(c.props.className,i)),ue(e,"title",s.props.title),ue(e,"readOnly",s.props.readOnly),ue(e,"required",s.props.required),ue(e,"tabIndex",s.props.tabIndex),ue(e,"aria-labelledby",s.props.ariaLabelledBy),e))})),ue(De(s),"renderClearButton",(function(){var e=s.props,r=e.isClearable,n=e.selected,a=e.clearButtonTitle,o=e.ariaLabelClose,p=void 0===o?"Close":o;return r&&null!=n?t.createElement("button",{type:"button",className:"react-datepicker__close-icon","aria-label":p,onClick:s.onClearClick,title:a,tabIndex:-1}):null})),s.state=s.calcInitialState(),s}return de(o,null,[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,renderDayContents:function(e){return e},inlineFocusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null}}}]),de(o,[{key:"componentDidUpdate",value:function(e,t){var r,n;e.inline&&(r=e.selected,n=this.props.selected,r&&n?O(r)!==O(n)||P(r)!==P(n):r!==n)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:ct(this.props.highlightDates)}),t.focused||Ae(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose())}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout()}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?t.createElement("div",null,this.props.inline?null:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?t.createElement("div",{className:"react-datepicker__portal"},e):null):t.createElement(xt,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),popperModifiers:this.props.popperModifiers,targetComponent:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}]),o}(t.Component),Lt="input",jt="navigate";e.CalendarContainer=Pt,e.default=It,e.getDefaultLocale=He,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:global;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:global).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 69 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	FullCalendar v5.11.5
	Docs & License: https://fullcalendar.io/
	(c) 2022 Adam Shaw
	*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	;
	var tslib = __webpack_require__(80);
	var vdom_cjs = __webpack_require__(535);
	
	// no public types yet. when there are, export from:
	// import {} from './api-type-deps'
	var EventSourceApi = /** @class */ (function () {
	    function EventSourceApi(context, internalEventSource) {
	        this.context = context;
	        this.internalEventSource = internalEventSource;
	    }
	    EventSourceApi.prototype.remove = function () {
	        this.context.dispatch({
	            type: 'REMOVE_EVENT_SOURCE',
	            sourceId: this.internalEventSource.sourceId,
	        });
	    };
	    EventSourceApi.prototype.refetch = function () {
	        this.context.dispatch({
	            type: 'FETCH_EVENT_SOURCES',
	            sourceIds: [this.internalEventSource.sourceId],
	            isRefetch: true,
	        });
	    };
	    Object.defineProperty(EventSourceApi.prototype, "id", {
	        get: function () {
	            return this.internalEventSource.publicId;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventSourceApi.prototype, "url", {
	        get: function () {
	            return this.internalEventSource.meta.url;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventSourceApi.prototype, "format", {
	        get: function () {
	            return this.internalEventSource.meta.format; // TODO: bad. not guaranteed
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return EventSourceApi;
	}());
	
	function removeElement(el) {
	    if (el.parentNode) {
	        el.parentNode.removeChild(el);
	    }
	}
	// Querying
	// ----------------------------------------------------------------------------------------------------------------
	function elementClosest(el, selector) {
	    if (el.closest) {
	        return el.closest(selector);
	        // really bad fallback for IE
	        // from https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
	    }
	    if (!document.documentElement.contains(el)) {
	        return null;
	    }
	    do {
	        if (elementMatches(el, selector)) {
	            return el;
	        }
	        el = (el.parentElement || el.parentNode);
	    } while (el !== null && el.nodeType === 1);
	    return null;
	}
	function elementMatches(el, selector) {
	    var method = el.matches || el.matchesSelector || el.msMatchesSelector;
	    return method.call(el, selector);
	}
	// accepts multiple subject els
	// returns a real array. good for methods like forEach
	// TODO: accept the document
	function findElements(container, selector) {
	    var containers = container instanceof HTMLElement ? [container] : container;
	    var allMatches = [];
	    for (var i = 0; i < containers.length; i += 1) {
	        var matches = containers[i].querySelectorAll(selector);
	        for (var j = 0; j < matches.length; j += 1) {
	            allMatches.push(matches[j]);
	        }
	    }
	    return allMatches;
	}
	// accepts multiple subject els
	// only queries direct child elements // TODO: rename to findDirectChildren!
	function findDirectChildren(parent, selector) {
	    var parents = parent instanceof HTMLElement ? [parent] : parent;
	    var allMatches = [];
	    for (var i = 0; i < parents.length; i += 1) {
	        var childNodes = parents[i].children; // only ever elements
	        for (var j = 0; j < childNodes.length; j += 1) {
	            var childNode = childNodes[j];
	            if (!selector || elementMatches(childNode, selector)) {
	                allMatches.push(childNode);
	            }
	        }
	    }
	    return allMatches;
	}
	// Style
	// ----------------------------------------------------------------------------------------------------------------
	var PIXEL_PROP_RE = /(top|left|right|bottom|width|height)$/i;
	function applyStyle(el, props) {
	    for (var propName in props) {
	        applyStyleProp(el, propName, props[propName]);
	    }
	}
	function applyStyleProp(el, name, val) {
	    if (val == null) {
	        el.style[name] = '';
	    }
	    else if (typeof val === 'number' && PIXEL_PROP_RE.test(name)) {
	        el.style[name] = val + "px";
	    }
	    else {
	        el.style[name] = val;
	    }
	}
	// Event Handling
	// ----------------------------------------------------------------------------------------------------------------
	// if intercepting bubbled events at the document/window/body level,
	// and want to see originating element (the 'target'), use this util instead
	// of `ev.target` because it goes within web-component boundaries.
	function getEventTargetViaRoot(ev) {
	    var _a, _b;
	    return (_b = (_a = ev.composedPath) === null || _a === void 0 ? void 0 : _a.call(ev)[0]) !== null && _b !== void 0 ? _b : ev.target;
	}
	// Shadow DOM consuderations
	// ----------------------------------------------------------------------------------------------------------------
	function getElRoot(el) {
	    return el.getRootNode ? el.getRootNode() : document;
	}
	// Unique ID for DOM attribute
	var guid$1 = 0;
	function getUniqueDomId() {
	    guid$1 += 1;
	    return 'fc-dom-' + guid$1;
	}
	
	// Stops a mouse/touch event from doing it's native browser action
	function preventDefault(ev) {
	    ev.preventDefault();
	}
	// Event Delegation
	// ----------------------------------------------------------------------------------------------------------------
	function buildDelegationHandler(selector, handler) {
	    return function (ev) {
	        var matchedChild = elementClosest(ev.target, selector);
	        if (matchedChild) {
	            handler.call(matchedChild, ev, matchedChild);
	        }
	    };
	}
	function listenBySelector(container, eventType, selector, handler) {
	    var attachedHandler = buildDelegationHandler(selector, handler);
	    container.addEventListener(eventType, attachedHandler);
	    return function () {
	        container.removeEventListener(eventType, attachedHandler);
	    };
	}
	function listenToHoverBySelector(container, selector, onMouseEnter, onMouseLeave) {
	    var currentMatchedChild;
	    return listenBySelector(container, 'mouseover', selector, function (mouseOverEv, matchedChild) {
	        if (matchedChild !== currentMatchedChild) {
	            currentMatchedChild = matchedChild;
	            onMouseEnter(mouseOverEv, matchedChild);
	            var realOnMouseLeave_1 = function (mouseLeaveEv) {
	                currentMatchedChild = null;
	                onMouseLeave(mouseLeaveEv, matchedChild);
	                matchedChild.removeEventListener('mouseleave', realOnMouseLeave_1);
	            };
	            // listen to the next mouseleave, and then unattach
	            matchedChild.addEventListener('mouseleave', realOnMouseLeave_1);
	        }
	    });
	}
	// Animation
	// ----------------------------------------------------------------------------------------------------------------
	var transitionEventNames = [
	    'webkitTransitionEnd',
	    'otransitionend',
	    'oTransitionEnd',
	    'msTransitionEnd',
	    'transitionend',
	];
	// triggered only when the next single subsequent transition finishes
	function whenTransitionDone(el, callback) {
	    var realCallback = function (ev) {
	        callback(ev);
	        transitionEventNames.forEach(function (eventName) {
	            el.removeEventListener(eventName, realCallback);
	        });
	    };
	    transitionEventNames.forEach(function (eventName) {
	        el.addEventListener(eventName, realCallback); // cross-browser way to determine when the transition finishes
	    });
	}
	// ARIA workarounds
	// ----------------------------------------------------------------------------------------------------------------
	function createAriaClickAttrs(handler) {
	    return tslib.__assign({ onClick: handler }, createAriaKeyboardAttrs(handler));
	}
	function createAriaKeyboardAttrs(handler) {
	    return {
	        tabIndex: 0,
	        onKeyDown: function (ev) {
	            if (ev.key === 'Enter' || ev.key === ' ') {
	                handler(ev);
	                ev.preventDefault(); // if space, don't scroll down page
	            }
	        },
	    };
	}
	
	var guidNumber = 0;
	function guid() {
	    guidNumber += 1;
	    return String(guidNumber);
	}
	/* FullCalendar-specific DOM Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	// Make the mouse cursor express that an event is not allowed in the current area
	function disableCursor() {
	    document.body.classList.add('fc-not-allowed');
	}
	// Returns the mouse cursor to its original look
	function enableCursor() {
	    document.body.classList.remove('fc-not-allowed');
	}
	/* Selection
	----------------------------------------------------------------------------------------------------------------------*/
	function preventSelection(el) {
	    el.classList.add('fc-unselectable');
	    el.addEventListener('selectstart', preventDefault);
	}
	function allowSelection(el) {
	    el.classList.remove('fc-unselectable');
	    el.removeEventListener('selectstart', preventDefault);
	}
	/* Context Menu
	----------------------------------------------------------------------------------------------------------------------*/
	function preventContextMenu(el) {
	    el.addEventListener('contextmenu', preventDefault);
	}
	function allowContextMenu(el) {
	    el.removeEventListener('contextmenu', preventDefault);
	}
	function parseFieldSpecs(input) {
	    var specs = [];
	    var tokens = [];
	    var i;
	    var token;
	    if (typeof input === 'string') {
	        tokens = input.split(/\s*,\s*/);
	    }
	    else if (typeof input === 'function') {
	        tokens = [input];
	    }
	    else if (Array.isArray(input)) {
	        tokens = input;
	    }
	    for (i = 0; i < tokens.length; i += 1) {
	        token = tokens[i];
	        if (typeof token === 'string') {
	            specs.push(token.charAt(0) === '-' ?
	                { field: token.substring(1), order: -1 } :
	                { field: token, order: 1 });
	        }
	        else if (typeof token === 'function') {
	            specs.push({ func: token });
	        }
	    }
	    return specs;
	}
	function compareByFieldSpecs(obj0, obj1, fieldSpecs) {
	    var i;
	    var cmp;
	    for (i = 0; i < fieldSpecs.length; i += 1) {
	        cmp = compareByFieldSpec(obj0, obj1, fieldSpecs[i]);
	        if (cmp) {
	            return cmp;
	        }
	    }
	    return 0;
	}
	function compareByFieldSpec(obj0, obj1, fieldSpec) {
	    if (fieldSpec.func) {
	        return fieldSpec.func(obj0, obj1);
	    }
	    return flexibleCompare(obj0[fieldSpec.field], obj1[fieldSpec.field])
	        * (fieldSpec.order || 1);
	}
	function flexibleCompare(a, b) {
	    if (!a && !b) {
	        return 0;
	    }
	    if (b == null) {
	        return -1;
	    }
	    if (a == null) {
	        return 1;
	    }
	    if (typeof a === 'string' || typeof b === 'string') {
	        return String(a).localeCompare(String(b));
	    }
	    return a - b;
	}
	/* String Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	function padStart(val, len) {
	    var s = String(val);
	    return '000'.substr(0, len - s.length) + s;
	}
	function formatWithOrdinals(formatter, args, fallbackText) {
	    if (typeof formatter === 'function') {
	        return formatter.apply(void 0, args);
	    }
	    if (typeof formatter === 'string') { // non-blank string
	        return args.reduce(function (str, arg, index) { return (str.replace('$' + index, arg || '')); }, formatter);
	    }
	    return fallbackText;
	}
	/* Number Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	function compareNumbers(a, b) {
	    return a - b;
	}
	function isInt(n) {
	    return n % 1 === 0;
	}
	/* FC-specific DOM dimension stuff
	----------------------------------------------------------------------------------------------------------------------*/
	function computeSmallestCellWidth(cellEl) {
	    var allWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-frame');
	    var contentWidthEl = cellEl.querySelector('.fc-scrollgrid-shrink-cushion');
	    if (!allWidthEl) {
	        throw new Error('needs fc-scrollgrid-shrink-frame className'); // TODO: use const
	    }
	    if (!contentWidthEl) {
	        throw new Error('needs fc-scrollgrid-shrink-cushion className');
	    }
	    return cellEl.getBoundingClientRect().width - allWidthEl.getBoundingClientRect().width + // the cell padding+border
	        contentWidthEl.getBoundingClientRect().width;
	}
	
	var DAY_IDS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
	// Adding
	function addWeeks(m, n) {
	    var a = dateToUtcArray(m);
	    a[2] += n * 7;
	    return arrayToUtcDate(a);
	}
	function addDays(m, n) {
	    var a = dateToUtcArray(m);
	    a[2] += n;
	    return arrayToUtcDate(a);
	}
	function addMs(m, n) {
	    var a = dateToUtcArray(m);
	    a[6] += n;
	    return arrayToUtcDate(a);
	}
	// Diffing (all return floats)
	// TODO: why not use ranges?
	function diffWeeks(m0, m1) {
	    return diffDays(m0, m1) / 7;
	}
	function diffDays(m0, m1) {
	    return (m1.valueOf() - m0.valueOf()) / (1000 * 60 * 60 * 24);
	}
	function diffHours(m0, m1) {
	    return (m1.valueOf() - m0.valueOf()) / (1000 * 60 * 60);
	}
	function diffMinutes(m0, m1) {
	    return (m1.valueOf() - m0.valueOf()) / (1000 * 60);
	}
	function diffSeconds(m0, m1) {
	    return (m1.valueOf() - m0.valueOf()) / 1000;
	}
	function diffDayAndTime(m0, m1) {
	    var m0day = startOfDay(m0);
	    var m1day = startOfDay(m1);
	    return {
	        years: 0,
	        months: 0,
	        days: Math.round(diffDays(m0day, m1day)),
	        milliseconds: (m1.valueOf() - m1day.valueOf()) - (m0.valueOf() - m0day.valueOf()),
	    };
	}
	// Diffing Whole Units
	function diffWholeWeeks(m0, m1) {
	    var d = diffWholeDays(m0, m1);
	    if (d !== null && d % 7 === 0) {
	        return d / 7;
	    }
	    return null;
	}
	function diffWholeDays(m0, m1) {
	    if (timeAsMs(m0) === timeAsMs(m1)) {
	        return Math.round(diffDays(m0, m1));
	    }
	    return null;
	}
	// Start-Of
	function startOfDay(m) {
	    return arrayToUtcDate([
	        m.getUTCFullYear(),
	        m.getUTCMonth(),
	        m.getUTCDate(),
	    ]);
	}
	function startOfHour(m) {
	    return arrayToUtcDate([
	        m.getUTCFullYear(),
	        m.getUTCMonth(),
	        m.getUTCDate(),
	        m.getUTCHours(),
	    ]);
	}
	function startOfMinute(m) {
	    return arrayToUtcDate([
	        m.getUTCFullYear(),
	        m.getUTCMonth(),
	        m.getUTCDate(),
	        m.getUTCHours(),
	        m.getUTCMinutes(),
	    ]);
	}
	function startOfSecond(m) {
	    return arrayToUtcDate([
	        m.getUTCFullYear(),
	        m.getUTCMonth(),
	        m.getUTCDate(),
	        m.getUTCHours(),
	        m.getUTCMinutes(),
	        m.getUTCSeconds(),
	    ]);
	}
	// Week Computation
	function weekOfYear(marker, dow, doy) {
	    var y = marker.getUTCFullYear();
	    var w = weekOfGivenYear(marker, y, dow, doy);
	    if (w < 1) {
	        return weekOfGivenYear(marker, y - 1, dow, doy);
	    }
	    var nextW = weekOfGivenYear(marker, y + 1, dow, doy);
	    if (nextW >= 1) {
	        return Math.min(w, nextW);
	    }
	    return w;
	}
	function weekOfGivenYear(marker, year, dow, doy) {
	    var firstWeekStart = arrayToUtcDate([year, 0, 1 + firstWeekOffset(year, dow, doy)]);
	    var dayStart = startOfDay(marker);
	    var days = Math.round(diffDays(firstWeekStart, dayStart));
	    return Math.floor(days / 7) + 1; // zero-indexed
	}
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	    var fwd = 7 + dow - doy;
	    // first-week day local weekday -- which local weekday is fwd
	    var fwdlw = (7 + arrayToUtcDate([year, 0, fwd]).getUTCDay() - dow) % 7;
	    return -fwdlw + fwd - 1;
	}
	// Array Conversion
	function dateToLocalArray(date) {
	    return [
	        date.getFullYear(),
	        date.getMonth(),
	        date.getDate(),
	        date.getHours(),
	        date.getMinutes(),
	        date.getSeconds(),
	        date.getMilliseconds(),
	    ];
	}
	function arrayToLocalDate(a) {
	    return new Date(a[0], a[1] || 0, a[2] == null ? 1 : a[2], // day of month
	    a[3] || 0, a[4] || 0, a[5] || 0);
	}
	function dateToUtcArray(date) {
	    return [
	        date.getUTCFullYear(),
	        date.getUTCMonth(),
	        date.getUTCDate(),
	        date.getUTCHours(),
	        date.getUTCMinutes(),
	        date.getUTCSeconds(),
	        date.getUTCMilliseconds(),
	    ];
	}
	function arrayToUtcDate(a) {
	    // according to web standards (and Safari), a month index is required.
	    // massage if only given a year.
	    if (a.length === 1) {
	        a = a.concat([0]);
	    }
	    return new Date(Date.UTC.apply(Date, a));
	}
	// Other Utils
	function isValidDate(m) {
	    return !isNaN(m.valueOf());
	}
	function timeAsMs(m) {
	    return m.getUTCHours() * 1000 * 60 * 60 +
	        m.getUTCMinutes() * 1000 * 60 +
	        m.getUTCSeconds() * 1000 +
	        m.getUTCMilliseconds();
	}
	
	function createEventInstance(defId, range, forcedStartTzo, forcedEndTzo) {
	    return {
	        instanceId: guid(),
	        defId: defId,
	        range: range,
	        forcedStartTzo: forcedStartTzo == null ? null : forcedStartTzo,
	        forcedEndTzo: forcedEndTzo == null ? null : forcedEndTzo,
	    };
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	// Merges an array of objects into a single object.
	// The second argument allows for an array of property names who's object values will be merged together.
	function mergeProps(propObjs, complexPropsMap) {
	    var dest = {};
	    if (complexPropsMap) {
	        for (var name_1 in complexPropsMap) {
	            var complexObjs = [];
	            // collect the trailing object values, stopping when a non-object is discovered
	            for (var i = propObjs.length - 1; i >= 0; i -= 1) {
	                var val = propObjs[i][name_1];
	                if (typeof val === 'object' && val) { // non-null object
	                    complexObjs.unshift(val);
	                }
	                else if (val !== undefined) {
	                    dest[name_1] = val; // if there were no objects, this value will be used
	                    break;
	                }
	            }
	            // if the trailing values were objects, use the merged value
	            if (complexObjs.length) {
	                dest[name_1] = mergeProps(complexObjs);
	            }
	        }
	    }
	    // copy values into the destination, going from last to first
	    for (var i = propObjs.length - 1; i >= 0; i -= 1) {
	        var props = propObjs[i];
	        for (var name_2 in props) {
	            if (!(name_2 in dest)) { // if already assigned by previous props or complex props, don't reassign
	                dest[name_2] = props[name_2];
	            }
	        }
	    }
	    return dest;
	}
	function filterHash(hash, func) {
	    var filtered = {};
	    for (var key in hash) {
	        if (func(hash[key], key)) {
	            filtered[key] = hash[key];
	        }
	    }
	    return filtered;
	}
	function mapHash(hash, func) {
	    var newHash = {};
	    for (var key in hash) {
	        newHash[key] = func(hash[key], key);
	    }
	    return newHash;
	}
	function arrayToHash(a) {
	    var hash = {};
	    for (var _i = 0, a_1 = a; _i < a_1.length; _i++) {
	        var item = a_1[_i];
	        hash[item] = true;
	    }
	    return hash;
	}
	function buildHashFromArray(a, func) {
	    var hash = {};
	    for (var i = 0; i < a.length; i += 1) {
	        var tuple = func(a[i], i);
	        hash[tuple[0]] = tuple[1];
	    }
	    return hash;
	}
	function hashValuesToArray(obj) {
	    var a = [];
	    for (var key in obj) {
	        a.push(obj[key]);
	    }
	    return a;
	}
	function isPropsEqual(obj0, obj1) {
	    if (obj0 === obj1) {
	        return true;
	    }
	    for (var key in obj0) {
	        if (hasOwnProperty.call(obj0, key)) {
	            if (!(key in obj1)) {
	                return false;
	            }
	        }
	    }
	    for (var key in obj1) {
	        if (hasOwnProperty.call(obj1, key)) {
	            if (obj0[key] !== obj1[key]) {
	                return false;
	            }
	        }
	    }
	    return true;
	}
	function getUnequalProps(obj0, obj1) {
	    var keys = [];
	    for (var key in obj0) {
	        if (hasOwnProperty.call(obj0, key)) {
	            if (!(key in obj1)) {
	                keys.push(key);
	            }
	        }
	    }
	    for (var key in obj1) {
	        if (hasOwnProperty.call(obj1, key)) {
	            if (obj0[key] !== obj1[key]) {
	                keys.push(key);
	            }
	        }
	    }
	    return keys;
	}
	function compareObjs(oldProps, newProps, equalityFuncs) {
	    if (equalityFuncs === void 0) { equalityFuncs = {}; }
	    if (oldProps === newProps) {
	        return true;
	    }
	    for (var key in newProps) {
	        if (key in oldProps && isObjValsEqual(oldProps[key], newProps[key], equalityFuncs[key])) ;
	        else {
	            return false;
	        }
	    }
	    // check for props that were omitted in the new
	    for (var key in oldProps) {
	        if (!(key in newProps)) {
	            return false;
	        }
	    }
	    return true;
	}
	/*
	assumed "true" equality for handler names like "onReceiveSomething"
	*/
	function isObjValsEqual(val0, val1, comparator) {
	    if (val0 === val1 || comparator === true) {
	        return true;
	    }
	    if (comparator) {
	        return comparator(val0, val1);
	    }
	    return false;
	}
	function collectFromHash(hash, startIndex, endIndex, step) {
	    if (startIndex === void 0) { startIndex = 0; }
	    if (step === void 0) { step = 1; }
	    var res = [];
	    if (endIndex == null) {
	        endIndex = Object.keys(hash).length;
	    }
	    for (var i = startIndex; i < endIndex; i += step) {
	        var val = hash[i];
	        if (val !== undefined) { // will disregard undefined for sparse arrays
	            res.push(val);
	        }
	    }
	    return res;
	}
	
	function parseRecurring(refined, defaultAllDay, dateEnv, recurringTypes) {
	    for (var i = 0; i < recurringTypes.length; i += 1) {
	        var parsed = recurringTypes[i].parse(refined, dateEnv);
	        if (parsed) {
	            var allDay = refined.allDay;
	            if (allDay == null) {
	                allDay = defaultAllDay;
	                if (allDay == null) {
	                    allDay = parsed.allDayGuess;
	                    if (allDay == null) {
	                        allDay = false;
	                    }
	                }
	            }
	            return {
	                allDay: allDay,
	                duration: parsed.duration,
	                typeData: parsed.typeData,
	                typeId: i,
	            };
	        }
	    }
	    return null;
	}
	function expandRecurring(eventStore, framingRange, context) {
	    var dateEnv = context.dateEnv, pluginHooks = context.pluginHooks, options = context.options;
	    var defs = eventStore.defs, instances = eventStore.instances;
	    // remove existing recurring instances
	    // TODO: bad. always expand events as a second step
	    instances = filterHash(instances, function (instance) { return !defs[instance.defId].recurringDef; });
	    for (var defId in defs) {
	        var def = defs[defId];
	        if (def.recurringDef) {
	            var duration = def.recurringDef.duration;
	            if (!duration) {
	                duration = def.allDay ?
	                    options.defaultAllDayEventDuration :
	                    options.defaultTimedEventDuration;
	            }
	            var starts = expandRecurringRanges(def, duration, framingRange, dateEnv, pluginHooks.recurringTypes);
	            for (var _i = 0, starts_1 = starts; _i < starts_1.length; _i++) {
	                var start = starts_1[_i];
	                var instance = createEventInstance(defId, {
	                    start: start,
	                    end: dateEnv.add(start, duration),
	                });
	                instances[instance.instanceId] = instance;
	            }
	        }
	    }
	    return { defs: defs, instances: instances };
	}
	/*
	Event MUST have a recurringDef
	*/
	function expandRecurringRanges(eventDef, duration, framingRange, dateEnv, recurringTypes) {
	    var typeDef = recurringTypes[eventDef.recurringDef.typeId];
	    var markers = typeDef.expand(eventDef.recurringDef.typeData, {
	        start: dateEnv.subtract(framingRange.start, duration),
	        end: framingRange.end,
	    }, dateEnv);
	    // the recurrence plugins don't guarantee that all-day events are start-of-day, so we have to
	    if (eventDef.allDay) {
	        markers = markers.map(startOfDay);
	    }
	    return markers;
	}
	
	var INTERNAL_UNITS = ['years', 'months', 'days', 'milliseconds'];
	var PARSE_RE = /^(-?)(?:(\d+)\.)?(\d+):(\d\d)(?::(\d\d)(?:\.(\d\d\d))?)?/;
	// Parsing and Creation
	function createDuration(input, unit) {
	    var _a;
	    if (typeof input === 'string') {
	        return parseString(input);
	    }
	    if (typeof input === 'object' && input) { // non-null object
	        return parseObject(input);
	    }
	    if (typeof input === 'number') {
	        return parseObject((_a = {}, _a[unit || 'milliseconds'] = input, _a));
	    }
	    return null;
	}
	function parseString(s) {
	    var m = PARSE_RE.exec(s);
	    if (m) {
	        var sign = m[1] ? -1 : 1;
	        return {
	            years: 0,
	            months: 0,
	            days: sign * (m[2] ? parseInt(m[2], 10) : 0),
	            milliseconds: sign * ((m[3] ? parseInt(m[3], 10) : 0) * 60 * 60 * 1000 + // hours
	                (m[4] ? parseInt(m[4], 10) : 0) * 60 * 1000 + // minutes
	                (m[5] ? parseInt(m[5], 10) : 0) * 1000 + // seconds
	                (m[6] ? parseInt(m[6], 10) : 0) // ms
	            ),
	        };
	    }
	    return null;
	}
	function parseObject(obj) {
	    var duration = {
	        years: obj.years || obj.year || 0,
	        months: obj.months || obj.month || 0,
	        days: obj.days || obj.day || 0,
	        milliseconds: (obj.hours || obj.hour || 0) * 60 * 60 * 1000 + // hours
	            (obj.minutes || obj.minute || 0) * 60 * 1000 + // minutes
	            (obj.seconds || obj.second || 0) * 1000 + // seconds
	            (obj.milliseconds || obj.millisecond || obj.ms || 0), // ms
	    };
	    var weeks = obj.weeks || obj.week;
	    if (weeks) {
	        duration.days += weeks * 7;
	        duration.specifiedWeeks = true;
	    }
	    return duration;
	}
	// Equality
	function durationsEqual(d0, d1) {
	    return d0.years === d1.years &&
	        d0.months === d1.months &&
	        d0.days === d1.days &&
	        d0.milliseconds === d1.milliseconds;
	}
	function asCleanDays(dur) {
	    if (!dur.years && !dur.months && !dur.milliseconds) {
	        return dur.days;
	    }
	    return 0;
	}
	// Simple Math
	function addDurations(d0, d1) {
	    return {
	        years: d0.years + d1.years,
	        months: d0.months + d1.months,
	        days: d0.days + d1.days,
	        milliseconds: d0.milliseconds + d1.milliseconds,
	    };
	}
	function subtractDurations(d1, d0) {
	    return {
	        years: d1.years - d0.years,
	        months: d1.months - d0.months,
	        days: d1.days - d0.days,
	        milliseconds: d1.milliseconds - d0.milliseconds,
	    };
	}
	function multiplyDuration(d, n) {
	    return {
	        years: d.years * n,
	        months: d.months * n,
	        days: d.days * n,
	        milliseconds: d.milliseconds * n,
	    };
	}
	// Conversions
	// "Rough" because they are based on average-case Gregorian months/years
	function asRoughYears(dur) {
	    return asRoughDays(dur) / 365;
	}
	function asRoughMonths(dur) {
	    return asRoughDays(dur) / 30;
	}
	function asRoughDays(dur) {
	    return asRoughMs(dur) / 864e5;
	}
	function asRoughMinutes(dur) {
	    return asRoughMs(dur) / (1000 * 60);
	}
	function asRoughSeconds(dur) {
	    return asRoughMs(dur) / 1000;
	}
	function asRoughMs(dur) {
	    return dur.years * (365 * 864e5) +
	        dur.months * (30 * 864e5) +
	        dur.days * 864e5 +
	        dur.milliseconds;
	}
	// Advanced Math
	function wholeDivideDurations(numerator, denominator) {
	    var res = null;
	    for (var i = 0; i < INTERNAL_UNITS.length; i += 1) {
	        var unit = INTERNAL_UNITS[i];
	        if (denominator[unit]) {
	            var localRes = numerator[unit] / denominator[unit];
	            if (!isInt(localRes) || (res !== null && res !== localRes)) {
	                return null;
	            }
	            res = localRes;
	        }
	        else if (numerator[unit]) {
	            // needs to divide by something but can't!
	            return null;
	        }
	    }
	    return res;
	}
	function greatestDurationDenominator(dur) {
	    var ms = dur.milliseconds;
	    if (ms) {
	        if (ms % 1000 !== 0) {
	            return { unit: 'millisecond', value: ms };
	        }
	        if (ms % (1000 * 60) !== 0) {
	            return { unit: 'second', value: ms / 1000 };
	        }
	        if (ms % (1000 * 60 * 60) !== 0) {
	            return { unit: 'minute', value: ms / (1000 * 60) };
	        }
	        if (ms) {
	            return { unit: 'hour', value: ms / (1000 * 60 * 60) };
	        }
	    }
	    if (dur.days) {
	        if (dur.specifiedWeeks && dur.days % 7 === 0) {
	            return { unit: 'week', value: dur.days / 7 };
	        }
	        return { unit: 'day', value: dur.days };
	    }
	    if (dur.months) {
	        return { unit: 'month', value: dur.months };
	    }
	    if (dur.years) {
	        return { unit: 'year', value: dur.years };
	    }
	    return { unit: 'millisecond', value: 0 };
	}
	
	// timeZoneOffset is in minutes
	function buildIsoString(marker, timeZoneOffset, stripZeroTime) {
	    if (stripZeroTime === void 0) { stripZeroTime = false; }
	    var s = marker.toISOString();
	    s = s.replace('.000', '');
	    if (stripZeroTime) {
	        s = s.replace('T00:00:00Z', '');
	    }
	    if (s.length > 10) { // time part wasn't stripped, can add timezone info
	        if (timeZoneOffset == null) {
	            s = s.replace('Z', '');
	        }
	        else if (timeZoneOffset !== 0) {
	            s = s.replace('Z', formatTimeZoneOffset(timeZoneOffset, true));
	        }
	        // otherwise, its UTC-0 and we want to keep the Z
	    }
	    return s;
	}
	// formats the date, but with no time part
	// TODO: somehow merge with buildIsoString and stripZeroTime
	// TODO: rename. omit "string"
	function formatDayString(marker) {
	    return marker.toISOString().replace(/T.*$/, '');
	}
	// TODO: use Date::toISOString and use everything after the T?
	function formatIsoTimeString(marker) {
	    return padStart(marker.getUTCHours(), 2) + ':' +
	        padStart(marker.getUTCMinutes(), 2) + ':' +
	        padStart(marker.getUTCSeconds(), 2);
	}
	function formatTimeZoneOffset(minutes, doIso) {
	    if (doIso === void 0) { doIso = false; }
	    var sign = minutes < 0 ? '-' : '+';
	    var abs = Math.abs(minutes);
	    var hours = Math.floor(abs / 60);
	    var mins = Math.round(abs % 60);
	    if (doIso) {
	        return sign + padStart(hours, 2) + ":" + padStart(mins, 2);
	    }
	    return "GMT" + sign + hours + (mins ? ":" + padStart(mins, 2) : '');
	}
	
	// TODO: new util arrayify?
	function removeExact(array, exactVal) {
	    var removeCnt = 0;
	    var i = 0;
	    while (i < array.length) {
	        if (array[i] === exactVal) {
	            array.splice(i, 1);
	            removeCnt += 1;
	        }
	        else {
	            i += 1;
	        }
	    }
	    return removeCnt;
	}
	function isArraysEqual(a0, a1, equalityFunc) {
	    if (a0 === a1) {
	        return true;
	    }
	    var len = a0.length;
	    var i;
	    if (len !== a1.length) { // not array? or not same length?
	        return false;
	    }
	    for (i = 0; i < len; i += 1) {
	        if (!(equalityFunc ? equalityFunc(a0[i], a1[i]) : a0[i] === a1[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function memoize(workerFunc, resEquality, teardownFunc) {
	    var currentArgs;
	    var currentRes;
	    return function () {
	        var newArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            newArgs[_i] = arguments[_i];
	        }
	        if (!currentArgs) {
	            currentRes = workerFunc.apply(this, newArgs);
	        }
	        else if (!isArraysEqual(currentArgs, newArgs)) {
	            if (teardownFunc) {
	                teardownFunc(currentRes);
	            }
	            var res = workerFunc.apply(this, newArgs);
	            if (!resEquality || !resEquality(res, currentRes)) {
	                currentRes = res;
	            }
	        }
	        currentArgs = newArgs;
	        return currentRes;
	    };
	}
	function memoizeObjArg(workerFunc, resEquality, teardownFunc) {
	    var _this = this;
	    var currentArg;
	    var currentRes;
	    return function (newArg) {
	        if (!currentArg) {
	            currentRes = workerFunc.call(_this, newArg);
	        }
	        else if (!isPropsEqual(currentArg, newArg)) {
	            if (teardownFunc) {
	                teardownFunc(currentRes);
	            }
	            var res = workerFunc.call(_this, newArg);
	            if (!resEquality || !resEquality(res, currentRes)) {
	                currentRes = res;
	            }
	        }
	        currentArg = newArg;
	        return currentRes;
	    };
	}
	function memoizeArraylike(// used at all?
	workerFunc, resEquality, teardownFunc) {
	    var _this = this;
	    var currentArgSets = [];
	    var currentResults = [];
	    return function (newArgSets) {
	        var currentLen = currentArgSets.length;
	        var newLen = newArgSets.length;
	        var i = 0;
	        for (; i < currentLen; i += 1) {
	            if (!newArgSets[i]) { // one of the old sets no longer exists
	                if (teardownFunc) {
	                    teardownFunc(currentResults[i]);
	                }
	            }
	            else if (!isArraysEqual(currentArgSets[i], newArgSets[i])) {
	                if (teardownFunc) {
	                    teardownFunc(currentResults[i]);
	                }
	                var res = workerFunc.apply(_this, newArgSets[i]);
	                if (!resEquality || !resEquality(res, currentResults[i])) {
	                    currentResults[i] = res;
	                }
	            }
	        }
	        for (; i < newLen; i += 1) {
	            currentResults[i] = workerFunc.apply(_this, newArgSets[i]);
	        }
	        currentArgSets = newArgSets;
	        currentResults.splice(newLen); // remove excess
	        return currentResults;
	    };
	}
	function memoizeHashlike(workerFunc, resEquality, teardownFunc) {
	    var _this = this;
	    var currentArgHash = {};
	    var currentResHash = {};
	    return function (newArgHash) {
	        var newResHash = {};
	        for (var key in newArgHash) {
	            if (!currentResHash[key]) {
	                newResHash[key] = workerFunc.apply(_this, newArgHash[key]);
	            }
	            else if (!isArraysEqual(currentArgHash[key], newArgHash[key])) {
	                if (teardownFunc) {
	                    teardownFunc(currentResHash[key]);
	                }
	                var res = workerFunc.apply(_this, newArgHash[key]);
	                newResHash[key] = (resEquality && resEquality(res, currentResHash[key]))
	                    ? currentResHash[key]
	                    : res;
	            }
	            else {
	                newResHash[key] = currentResHash[key];
	            }
	        }
	        currentArgHash = newArgHash;
	        currentResHash = newResHash;
	        return newResHash;
	    };
	}
	
	var EXTENDED_SETTINGS_AND_SEVERITIES = {
	    week: 3,
	    separator: 0,
	    omitZeroMinute: 0,
	    meridiem: 0,
	    omitCommas: 0,
	};
	var STANDARD_DATE_PROP_SEVERITIES = {
	    timeZoneName: 7,
	    era: 6,
	    year: 5,
	    month: 4,
	    day: 2,
	    weekday: 2,
	    hour: 1,
	    minute: 1,
	    second: 1,
	};
	var MERIDIEM_RE = /\s*([ap])\.?m\.?/i; // eats up leading spaces too
	var COMMA_RE = /,/g; // we need re for globalness
	var MULTI_SPACE_RE = /\s+/g;
	var LTR_RE = /\u200e/g; // control character
	var UTC_RE = /UTC|GMT/;
	var NativeFormatter = /** @class */ (function () {
	    function NativeFormatter(formatSettings) {
	        var standardDateProps = {};
	        var extendedSettings = {};
	        var severity = 0;
	        for (var name_1 in formatSettings) {
	            if (name_1 in EXTENDED_SETTINGS_AND_SEVERITIES) {
	                extendedSettings[name_1] = formatSettings[name_1];
	                severity = Math.max(EXTENDED_SETTINGS_AND_SEVERITIES[name_1], severity);
	            }
	            else {
	                standardDateProps[name_1] = formatSettings[name_1];
	                if (name_1 in STANDARD_DATE_PROP_SEVERITIES) { // TODO: what about hour12? no severity
	                    severity = Math.max(STANDARD_DATE_PROP_SEVERITIES[name_1], severity);
	                }
	            }
	        }
	        this.standardDateProps = standardDateProps;
	        this.extendedSettings = extendedSettings;
	        this.severity = severity;
	        this.buildFormattingFunc = memoize(buildFormattingFunc);
	    }
	    NativeFormatter.prototype.format = function (date, context) {
	        return this.buildFormattingFunc(this.standardDateProps, this.extendedSettings, context)(date);
	    };
	    NativeFormatter.prototype.formatRange = function (start, end, context, betterDefaultSeparator) {
	        var _a = this, standardDateProps = _a.standardDateProps, extendedSettings = _a.extendedSettings;
	        var diffSeverity = computeMarkerDiffSeverity(start.marker, end.marker, context.calendarSystem);
	        if (!diffSeverity) {
	            return this.format(start, context);
	        }
	        var biggestUnitForPartial = diffSeverity;
	        if (biggestUnitForPartial > 1 && // the two dates are different in a way that's larger scale than time
	            (standardDateProps.year === 'numeric' || standardDateProps.year === '2-digit') &&
	            (standardDateProps.month === 'numeric' || standardDateProps.month === '2-digit') &&
	            (standardDateProps.day === 'numeric' || standardDateProps.day === '2-digit')) {
	            biggestUnitForPartial = 1; // make it look like the dates are only different in terms of time
	        }
	        var full0 = this.format(start, context);
	        var full1 = this.format(end, context);
	        if (full0 === full1) {
	            return full0;
	        }
	        var partialDateProps = computePartialFormattingOptions(standardDateProps, biggestUnitForPartial);
	        var partialFormattingFunc = buildFormattingFunc(partialDateProps, extendedSettings, context);
	        var partial0 = partialFormattingFunc(start);
	        var partial1 = partialFormattingFunc(end);
	        var insertion = findCommonInsertion(full0, partial0, full1, partial1);
	        var separator = extendedSettings.separator || betterDefaultSeparator || context.defaultSeparator || '';
	        if (insertion) {
	            return insertion.before + partial0 + separator + partial1 + insertion.after;
	        }
	        return full0 + separator + full1;
	    };
	    NativeFormatter.prototype.getLargestUnit = function () {
	        switch (this.severity) {
	            case 7:
	            case 6:
	            case 5:
	                return 'year';
	            case 4:
	                return 'month';
	            case 3:
	                return 'week';
	            case 2:
	                return 'day';
	            default:
	                return 'time'; // really?
	        }
	    };
	    return NativeFormatter;
	}());
	function buildFormattingFunc(standardDateProps, extendedSettings, context) {
	    var standardDatePropCnt = Object.keys(standardDateProps).length;
	    if (standardDatePropCnt === 1 && standardDateProps.timeZoneName === 'short') {
	        return function (date) { return (formatTimeZoneOffset(date.timeZoneOffset)); };
	    }
	    if (standardDatePropCnt === 0 && extendedSettings.week) {
	        return function (date) { return (formatWeekNumber(context.computeWeekNumber(date.marker), context.weekText, context.weekTextLong, context.locale, extendedSettings.week)); };
	    }
	    return buildNativeFormattingFunc(standardDateProps, extendedSettings, context);
	}
	function buildNativeFormattingFunc(standardDateProps, extendedSettings, context) {
	    standardDateProps = tslib.__assign({}, standardDateProps); // copy
	    extendedSettings = tslib.__assign({}, extendedSettings); // copy
	    sanitizeSettings(standardDateProps, extendedSettings);
	    standardDateProps.timeZone = 'UTC'; // we leverage the only guaranteed timeZone for our UTC markers
	    var normalFormat = new Intl.DateTimeFormat(context.locale.codes, standardDateProps);
	    var zeroFormat; // needed?
	    if (extendedSettings.omitZeroMinute) {
	        var zeroProps = tslib.__assign({}, standardDateProps);
	        delete zeroProps.minute; // seconds and ms were already considered in sanitizeSettings
	        zeroFormat = new Intl.DateTimeFormat(context.locale.codes, zeroProps);
	    }
	    return function (date) {
	        var marker = date.marker;
	        var format;
	        if (zeroFormat && !marker.getUTCMinutes()) {
	            format = zeroFormat;
	        }
	        else {
	            format = normalFormat;
	        }
	        var s = format.format(marker);
	        return postProcess(s, date, standardDateProps, extendedSettings, context);
	    };
	}
	function sanitizeSettings(standardDateProps, extendedSettings) {
	    // deal with a browser inconsistency where formatting the timezone
	    // requires that the hour/minute be present.
	    if (standardDateProps.timeZoneName) {
	        if (!standardDateProps.hour) {
	            standardDateProps.hour = '2-digit';
	        }
	        if (!standardDateProps.minute) {
	            standardDateProps.minute = '2-digit';
	        }
	    }
	    // only support short timezone names
	    if (standardDateProps.timeZoneName === 'long') {
	        standardDateProps.timeZoneName = 'short';
	    }
	    // if requesting to display seconds, MUST display minutes
	    if (extendedSettings.omitZeroMinute && (standardDateProps.second || standardDateProps.millisecond)) {
	        delete extendedSettings.omitZeroMinute;
	    }
	}
	function postProcess(s, date, standardDateProps, extendedSettings, context) {
	    s = s.replace(LTR_RE, ''); // remove left-to-right control chars. do first. good for other regexes
	    if (standardDateProps.timeZoneName === 'short') {
	        s = injectTzoStr(s, (context.timeZone === 'UTC' || date.timeZoneOffset == null) ?
	            'UTC' : // important to normalize for IE, which does "GMT"
	            formatTimeZoneOffset(date.timeZoneOffset));
	    }
	    if (extendedSettings.omitCommas) {
	        s = s.replace(COMMA_RE, '').trim();
	    }
	    if (extendedSettings.omitZeroMinute) {
	        s = s.replace(':00', ''); // zeroFormat doesn't always achieve this
	    }
	    // ^ do anything that might create adjacent spaces before this point,
	    // because MERIDIEM_RE likes to eat up loading spaces
	    if (extendedSettings.meridiem === false) {
	        s = s.replace(MERIDIEM_RE, '').trim();
	    }
	    else if (extendedSettings.meridiem === 'narrow') { // a/p
	        s = s.replace(MERIDIEM_RE, function (m0, m1) { return m1.toLocaleLowerCase(); });
	    }
	    else if (extendedSettings.meridiem === 'short') { // am/pm
	        s = s.replace(MERIDIEM_RE, function (m0, m1) { return m1.toLocaleLowerCase() + "m"; });
	    }
	    else if (extendedSettings.meridiem === 'lowercase') { // other meridiem transformers already converted to lowercase
	        s = s.replace(MERIDIEM_RE, function (m0) { return m0.toLocaleLowerCase(); });
	    }
	    s = s.replace(MULTI_SPACE_RE, ' ');
	    s = s.trim();
	    return s;
	}
	function injectTzoStr(s, tzoStr) {
	    var replaced = false;
	    s = s.replace(UTC_RE, function () {
	        replaced = true;
	        return tzoStr;
	    });
	    // IE11 doesn't include UTC/GMT in the original string, so append to end
	    if (!replaced) {
	        s += " " + tzoStr;
	    }
	    return s;
	}
	function formatWeekNumber(num, weekText, weekTextLong, locale, display) {
	    var parts = [];
	    if (display === 'long') {
	        parts.push(weekTextLong);
	    }
	    else if (display === 'short' || display === 'narrow') {
	        parts.push(weekText);
	    }
	    if (display === 'long' || display === 'short') {
	        parts.push(' ');
	    }
	    parts.push(locale.simpleNumberFormat.format(num));
	    if (locale.options.direction === 'rtl') { // TODO: use control characters instead?
	        parts.reverse();
	    }
	    return parts.join('');
	}
	// Range Formatting Utils
	// 0 = exactly the same
	// 1 = different by time
	// and bigger
	function computeMarkerDiffSeverity(d0, d1, ca) {
	    if (ca.getMarkerYear(d0) !== ca.getMarkerYear(d1)) {
	        return 5;
	    }
	    if (ca.getMarkerMonth(d0) !== ca.getMarkerMonth(d1)) {
	        return 4;
	    }
	    if (ca.getMarkerDay(d0) !== ca.getMarkerDay(d1)) {
	        return 2;
	    }
	    if (timeAsMs(d0) !== timeAsMs(d1)) {
	        return 1;
	    }
	    return 0;
	}
	function computePartialFormattingOptions(options, biggestUnit) {
	    var partialOptions = {};
	    for (var name_2 in options) {
	        if (!(name_2 in STANDARD_DATE_PROP_SEVERITIES) || // not a date part prop (like timeZone)
	            STANDARD_DATE_PROP_SEVERITIES[name_2] <= biggestUnit) {
	            partialOptions[name_2] = options[name_2];
	        }
	    }
	    return partialOptions;
	}
	function findCommonInsertion(full0, partial0, full1, partial1) {
	    var i0 = 0;
	    while (i0 < full0.length) {
	        var found0 = full0.indexOf(partial0, i0);
	        if (found0 === -1) {
	            break;
	        }
	        var before0 = full0.substr(0, found0);
	        i0 = found0 + partial0.length;
	        var after0 = full0.substr(i0);
	        var i1 = 0;
	        while (i1 < full1.length) {
	            var found1 = full1.indexOf(partial1, i1);
	            if (found1 === -1) {
	                break;
	            }
	            var before1 = full1.substr(0, found1);
	            i1 = found1 + partial1.length;
	            var after1 = full1.substr(i1);
	            if (before0 === before1 && after0 === after1) {
	                return {
	                    before: before0,
	                    after: after0,
	                };
	            }
	        }
	    }
	    return null;
	}
	
	function expandZonedMarker(dateInfo, calendarSystem) {
	    var a = calendarSystem.markerToArray(dateInfo.marker);
	    return {
	        marker: dateInfo.marker,
	        timeZoneOffset: dateInfo.timeZoneOffset,
	        array: a,
	        year: a[0],
	        month: a[1],
	        day: a[2],
	        hour: a[3],
	        minute: a[4],
	        second: a[5],
	        millisecond: a[6],
	    };
	}
	
	function createVerboseFormattingArg(start, end, context, betterDefaultSeparator) {
	    var startInfo = expandZonedMarker(start, context.calendarSystem);
	    var endInfo = end ? expandZonedMarker(end, context.calendarSystem) : null;
	    return {
	        date: startInfo,
	        start: startInfo,
	        end: endInfo,
	        timeZone: context.timeZone,
	        localeCodes: context.locale.codes,
	        defaultSeparator: betterDefaultSeparator || context.defaultSeparator,
	    };
	}
	
	/*
	TODO: fix the terminology of "formatter" vs "formatting func"
	*/
	/*
	At the time of instantiation, this object does not know which cmd-formatting system it will use.
	It receives this at the time of formatting, as a setting.
	*/
	var CmdFormatter = /** @class */ (function () {
	    function CmdFormatter(cmdStr) {
	        this.cmdStr = cmdStr;
	    }
	    CmdFormatter.prototype.format = function (date, context, betterDefaultSeparator) {
	        return context.cmdFormatter(this.cmdStr, createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
	    };
	    CmdFormatter.prototype.formatRange = function (start, end, context, betterDefaultSeparator) {
	        return context.cmdFormatter(this.cmdStr, createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
	    };
	    return CmdFormatter;
	}());
	
	var FuncFormatter = /** @class */ (function () {
	    function FuncFormatter(func) {
	        this.func = func;
	    }
	    FuncFormatter.prototype.format = function (date, context, betterDefaultSeparator) {
	        return this.func(createVerboseFormattingArg(date, null, context, betterDefaultSeparator));
	    };
	    FuncFormatter.prototype.formatRange = function (start, end, context, betterDefaultSeparator) {
	        return this.func(createVerboseFormattingArg(start, end, context, betterDefaultSeparator));
	    };
	    return FuncFormatter;
	}());
	
	function createFormatter(input) {
	    if (typeof input === 'object' && input) { // non-null object
	        return new NativeFormatter(input);
	    }
	    if (typeof input === 'string') {
	        return new CmdFormatter(input);
	    }
	    if (typeof input === 'function') {
	        return new FuncFormatter(input);
	    }
	    return null;
	}
	
	// base options
	// ------------
	var BASE_OPTION_REFINERS = {
	    navLinkDayClick: identity,
	    navLinkWeekClick: identity,
	    duration: createDuration,
	    bootstrapFontAwesome: identity,
	    buttonIcons: identity,
	    customButtons: identity,
	    defaultAllDayEventDuration: createDuration,
	    defaultTimedEventDuration: createDuration,
	    nextDayThreshold: createDuration,
	    scrollTime: createDuration,
	    scrollTimeReset: Boolean,
	    slotMinTime: createDuration,
	    slotMaxTime: createDuration,
	    dayPopoverFormat: createFormatter,
	    slotDuration: createDuration,
	    snapDuration: createDuration,
	    headerToolbar: identity,
	    footerToolbar: identity,
	    defaultRangeSeparator: String,
	    titleRangeSeparator: String,
	    forceEventDuration: Boolean,
	    dayHeaders: Boolean,
	    dayHeaderFormat: createFormatter,
	    dayHeaderClassNames: identity,
	    dayHeaderContent: identity,
	    dayHeaderDidMount: identity,
	    dayHeaderWillUnmount: identity,
	    dayCellClassNames: identity,
	    dayCellContent: identity,
	    dayCellDidMount: identity,
	    dayCellWillUnmount: identity,
	    initialView: String,
	    aspectRatio: Number,
	    weekends: Boolean,
	    weekNumberCalculation: identity,
	    weekNumbers: Boolean,
	    weekNumberClassNames: identity,
	    weekNumberContent: identity,
	    weekNumberDidMount: identity,
	    weekNumberWillUnmount: identity,
	    editable: Boolean,
	    viewClassNames: identity,
	    viewDidMount: identity,
	    viewWillUnmount: identity,
	    nowIndicator: Boolean,
	    nowIndicatorClassNames: identity,
	    nowIndicatorContent: identity,
	    nowIndicatorDidMount: identity,
	    nowIndicatorWillUnmount: identity,
	    showNonCurrentDates: Boolean,
	    lazyFetching: Boolean,
	    startParam: String,
	    endParam: String,
	    timeZoneParam: String,
	    timeZone: String,
	    locales: identity,
	    locale: identity,
	    themeSystem: String,
	    dragRevertDuration: Number,
	    dragScroll: Boolean,
	    allDayMaintainDuration: Boolean,
	    unselectAuto: Boolean,
	    dropAccept: identity,
	    eventOrder: parseFieldSpecs,
	    eventOrderStrict: Boolean,
	    handleWindowResize: Boolean,
	    windowResizeDelay: Number,
	    longPressDelay: Number,
	    eventDragMinDistance: Number,
	    expandRows: Boolean,
	    height: identity,
	    contentHeight: identity,
	    direction: String,
	    weekNumberFormat: createFormatter,
	    eventResizableFromStart: Boolean,
	    displayEventTime: Boolean,
	    displayEventEnd: Boolean,
	    weekText: String,
	    weekTextLong: String,
	    progressiveEventRendering: Boolean,
	    businessHours: identity,
	    initialDate: identity,
	    now: identity,
	    eventDataTransform: identity,
	    stickyHeaderDates: identity,
	    stickyFooterScrollbar: identity,
	    viewHeight: identity,
	    defaultAllDay: Boolean,
	    eventSourceFailure: identity,
	    eventSourceSuccess: identity,
	    eventDisplay: String,
	    eventStartEditable: Boolean,
	    eventDurationEditable: Boolean,
	    eventOverlap: identity,
	    eventConstraint: identity,
	    eventAllow: identity,
	    eventBackgroundColor: String,
	    eventBorderColor: String,
	    eventTextColor: String,
	    eventColor: String,
	    eventClassNames: identity,
	    eventContent: identity,
	    eventDidMount: identity,
	    eventWillUnmount: identity,
	    selectConstraint: identity,
	    selectOverlap: identity,
	    selectAllow: identity,
	    droppable: Boolean,
	    unselectCancel: String,
	    slotLabelFormat: identity,
	    slotLaneClassNames: identity,
	    slotLaneContent: identity,
	    slotLaneDidMount: identity,
	    slotLaneWillUnmount: identity,
	    slotLabelClassNames: identity,
	    slotLabelContent: identity,
	    slotLabelDidMount: identity,
	    slotLabelWillUnmount: identity,
	    dayMaxEvents: identity,
	    dayMaxEventRows: identity,
	    dayMinWidth: Number,
	    slotLabelInterval: createDuration,
	    allDayText: String,
	    allDayClassNames: identity,
	    allDayContent: identity,
	    allDayDidMount: identity,
	    allDayWillUnmount: identity,
	    slotMinWidth: Number,
	    navLinks: Boolean,
	    eventTimeFormat: createFormatter,
	    rerenderDelay: Number,
	    moreLinkText: identity,
	    moreLinkHint: identity,
	    selectMinDistance: Number,
	    selectable: Boolean,
	    selectLongPressDelay: Number,
	    eventLongPressDelay: Number,
	    selectMirror: Boolean,
	    eventMaxStack: Number,
	    eventMinHeight: Number,
	    eventMinWidth: Number,
	    eventShortHeight: Number,
	    slotEventOverlap: Boolean,
	    plugins: identity,
	    firstDay: Number,
	    dayCount: Number,
	    dateAlignment: String,
	    dateIncrement: createDuration,
	    hiddenDays: identity,
	    monthMode: Boolean,
	    fixedWeekCount: Boolean,
	    validRange: identity,
	    visibleRange: identity,
	    titleFormat: identity,
	    eventInteractive: Boolean,
	    // only used by list-view, but languages define the value, so we need it in base options
	    noEventsText: String,
	    viewHint: identity,
	    navLinkHint: identity,
	    closeHint: String,
	    timeHint: String,
	    eventHint: String,
	    moreLinkClick: identity,
	    moreLinkClassNames: identity,
	    moreLinkContent: identity,
	    moreLinkDidMount: identity,
	    moreLinkWillUnmount: identity,
	};
	// do NOT give a type here. need `typeof BASE_OPTION_DEFAULTS` to give real results.
	// raw values.
	var BASE_OPTION_DEFAULTS = {
	    eventDisplay: 'auto',
	    defaultRangeSeparator: ' - ',
	    titleRangeSeparator: ' \u2013 ',
	    defaultTimedEventDuration: '01:00:00',
	    defaultAllDayEventDuration: { day: 1 },
	    forceEventDuration: false,
	    nextDayThreshold: '00:00:00',
	    dayHeaders: true,
	    initialView: '',
	    aspectRatio: 1.35,
	    headerToolbar: {
	        start: 'title',
	        center: '',
	        end: 'today prev,next',
	    },
	    weekends: true,
	    weekNumbers: false,
	    weekNumberCalculation: 'local',
	    editable: false,
	    nowIndicator: false,
	    scrollTime: '06:00:00',
	    scrollTimeReset: true,
	    slotMinTime: '00:00:00',
	    slotMaxTime: '24:00:00',
	    showNonCurrentDates: true,
	    lazyFetching: true,
	    startParam: 'start',
	    endParam: 'end',
	    timeZoneParam: 'timeZone',
	    timeZone: 'local',
	    locales: [],
	    locale: '',
	    themeSystem: 'standard',
	    dragRevertDuration: 500,
	    dragScroll: true,
	    allDayMaintainDuration: false,
	    unselectAuto: true,
	    dropAccept: '*',
	    eventOrder: 'start,-duration,allDay,title',
	    dayPopoverFormat: { month: 'long', day: 'numeric', year: 'numeric' },
	    handleWindowResize: true,
	    windowResizeDelay: 100,
	    longPressDelay: 1000,
	    eventDragMinDistance: 5,
	    expandRows: false,
	    navLinks: false,
	    selectable: false,
	    eventMinHeight: 15,
	    eventMinWidth: 30,
	    eventShortHeight: 30,
	};
	// calendar listeners
	// ------------------
	var CALENDAR_LISTENER_REFINERS = {
	    datesSet: identity,
	    eventsSet: identity,
	    eventAdd: identity,
	    eventChange: identity,
	    eventRemove: identity,
	    windowResize: identity,
	    eventClick: identity,
	    eventMouseEnter: identity,
	    eventMouseLeave: identity,
	    select: identity,
	    unselect: identity,
	    loading: identity,
	    // internal
	    _unmount: identity,
	    _beforeprint: identity,
	    _afterprint: identity,
	    _noEventDrop: identity,
	    _noEventResize: identity,
	    _resize: identity,
	    _scrollRequest: identity,
	};
	// calendar-specific options
	// -------------------------
	var CALENDAR_OPTION_REFINERS = {
	    buttonText: identity,
	    buttonHints: identity,
	    views: identity,
	    plugins: identity,
	    initialEvents: identity,
	    events: identity,
	    eventSources: identity,
	};
	var COMPLEX_OPTION_COMPARATORS = {
	    headerToolbar: isMaybeObjectsEqual,
	    footerToolbar: isMaybeObjectsEqual,
	    buttonText: isMaybeObjectsEqual,
	    buttonHints: isMaybeObjectsEqual,
	    buttonIcons: isMaybeObjectsEqual,
	    dateIncrement: isMaybeObjectsEqual,
	};
	function isMaybeObjectsEqual(a, b) {
	    if (typeof a === 'object' && typeof b === 'object' && a && b) { // both non-null objects
	        return isPropsEqual(a, b);
	    }
	    return a === b;
	}
	// view-specific options
	// ---------------------
	var VIEW_OPTION_REFINERS = {
	    type: String,
	    component: identity,
	    buttonText: String,
	    buttonTextKey: String,
	    dateProfileGeneratorClass: identity,
	    usesMinMaxTime: Boolean,
	    classNames: identity,
	    content: identity,
	    didMount: identity,
	    willUnmount: identity,
	};
	// util funcs
	// ----------------------------------------------------------------------------------------------------
	function mergeRawOptions(optionSets) {
	    return mergeProps(optionSets, COMPLEX_OPTION_COMPARATORS);
	}
	function refineProps(input, refiners) {
	    var refined = {};
	    var extra = {};
	    for (var propName in refiners) {
	        if (propName in input) {
	            refined[propName] = refiners[propName](input[propName]);
	        }
	    }
	    for (var propName in input) {
	        if (!(propName in refiners)) {
	            extra[propName] = input[propName];
	        }
	    }
	    return { refined: refined, extra: extra };
	}
	function identity(raw) {
	    return raw;
	}
	
	function parseEvents(rawEvents, eventSource, context, allowOpenRange) {
	    var eventStore = createEmptyEventStore();
	    var eventRefiners = buildEventRefiners(context);
	    for (var _i = 0, rawEvents_1 = rawEvents; _i < rawEvents_1.length; _i++) {
	        var rawEvent = rawEvents_1[_i];
	        var tuple = parseEvent(rawEvent, eventSource, context, allowOpenRange, eventRefiners);
	        if (tuple) {
	            eventTupleToStore(tuple, eventStore);
	        }
	    }
	    return eventStore;
	}
	function eventTupleToStore(tuple, eventStore) {
	    if (eventStore === void 0) { eventStore = createEmptyEventStore(); }
	    eventStore.defs[tuple.def.defId] = tuple.def;
	    if (tuple.instance) {
	        eventStore.instances[tuple.instance.instanceId] = tuple.instance;
	    }
	    return eventStore;
	}
	// retrieves events that have the same groupId as the instance specified by `instanceId`
	// or they are the same as the instance.
	// why might instanceId not be in the store? an event from another calendar?
	function getRelevantEvents(eventStore, instanceId) {
	    var instance = eventStore.instances[instanceId];
	    if (instance) {
	        var def_1 = eventStore.defs[instance.defId];
	        // get events/instances with same group
	        var newStore = filterEventStoreDefs(eventStore, function (lookDef) { return isEventDefsGrouped(def_1, lookDef); });
	        // add the original
	        // TODO: wish we could use eventTupleToStore or something like it
	        newStore.defs[def_1.defId] = def_1;
	        newStore.instances[instance.instanceId] = instance;
	        return newStore;
	    }
	    return createEmptyEventStore();
	}
	function isEventDefsGrouped(def0, def1) {
	    return Boolean(def0.groupId && def0.groupId === def1.groupId);
	}
	function createEmptyEventStore() {
	    return { defs: {}, instances: {} };
	}
	function mergeEventStores(store0, store1) {
	    return {
	        defs: tslib.__assign(tslib.__assign({}, store0.defs), store1.defs),
	        instances: tslib.__assign(tslib.__assign({}, store0.instances), store1.instances),
	    };
	}
	function filterEventStoreDefs(eventStore, filterFunc) {
	    var defs = filterHash(eventStore.defs, filterFunc);
	    var instances = filterHash(eventStore.instances, function (instance) { return (defs[instance.defId] // still exists?
	    ); });
	    return { defs: defs, instances: instances };
	}
	function excludeSubEventStore(master, sub) {
	    var defs = master.defs, instances = master.instances;
	    var filteredDefs = {};
	    var filteredInstances = {};
	    for (var defId in defs) {
	        if (!sub.defs[defId]) { // not explicitly excluded
	            filteredDefs[defId] = defs[defId];
	        }
	    }
	    for (var instanceId in instances) {
	        if (!sub.instances[instanceId] && // not explicitly excluded
	            filteredDefs[instances[instanceId].defId] // def wasn't filtered away
	        ) {
	            filteredInstances[instanceId] = instances[instanceId];
	        }
	    }
	    return {
	        defs: filteredDefs,
	        instances: filteredInstances,
	    };
	}
	
	function normalizeConstraint(input, context) {
	    if (Array.isArray(input)) {
	        return parseEvents(input, null, context, true); // allowOpenRange=true
	    }
	    if (typeof input === 'object' && input) { // non-null object
	        return parseEvents([input], null, context, true); // allowOpenRange=true
	    }
	    if (input != null) {
	        return String(input);
	    }
	    return null;
	}
	
	function parseClassNames(raw) {
	    if (Array.isArray(raw)) {
	        return raw;
	    }
	    if (typeof raw === 'string') {
	        return raw.split(/\s+/);
	    }
	    return [];
	}
	
	// TODO: better called "EventSettings" or "EventConfig"
	// TODO: move this file into structs
	// TODO: separate constraint/overlap/allow, because selection uses only that, not other props
	var EVENT_UI_REFINERS = {
	    display: String,
	    editable: Boolean,
	    startEditable: Boolean,
	    durationEditable: Boolean,
	    constraint: identity,
	    overlap: identity,
	    allow: identity,
	    className: parseClassNames,
	    classNames: parseClassNames,
	    color: String,
	    backgroundColor: String,
	    borderColor: String,
	    textColor: String,
	};
	var EMPTY_EVENT_UI = {
	    display: null,
	    startEditable: null,
	    durationEditable: null,
	    constraints: [],
	    overlap: null,
	    allows: [],
	    backgroundColor: '',
	    borderColor: '',
	    textColor: '',
	    classNames: [],
	};
	function createEventUi(refined, context) {
	    var constraint = normalizeConstraint(refined.constraint, context);
	    return {
	        display: refined.display || null,
	        startEditable: refined.startEditable != null ? refined.startEditable : refined.editable,
	        durationEditable: refined.durationEditable != null ? refined.durationEditable : refined.editable,
	        constraints: constraint != null ? [constraint] : [],
	        overlap: refined.overlap != null ? refined.overlap : null,
	        allows: refined.allow != null ? [refined.allow] : [],
	        backgroundColor: refined.backgroundColor || refined.color || '',
	        borderColor: refined.borderColor || refined.color || '',
	        textColor: refined.textColor || '',
	        classNames: (refined.className || []).concat(refined.classNames || []), // join singular and plural
	    };
	}
	// TODO: prevent against problems with <2 args!
	function combineEventUis(uis) {
	    return uis.reduce(combineTwoEventUis, EMPTY_EVENT_UI);
	}
	function combineTwoEventUis(item0, item1) {
	    return {
	        display: item1.display != null ? item1.display : item0.display,
	        startEditable: item1.startEditable != null ? item1.startEditable : item0.startEditable,
	        durationEditable: item1.durationEditable != null ? item1.durationEditable : item0.durationEditable,
	        constraints: item0.constraints.concat(item1.constraints),
	        overlap: typeof item1.overlap === 'boolean' ? item1.overlap : item0.overlap,
	        allows: item0.allows.concat(item1.allows),
	        backgroundColor: item1.backgroundColor || item0.backgroundColor,
	        borderColor: item1.borderColor || item0.borderColor,
	        textColor: item1.textColor || item0.textColor,
	        classNames: item0.classNames.concat(item1.classNames),
	    };
	}
	
	var EVENT_NON_DATE_REFINERS = {
	    id: String,
	    groupId: String,
	    title: String,
	    url: String,
	    interactive: Boolean,
	};
	var EVENT_DATE_REFINERS = {
	    start: identity,
	    end: identity,
	    date: identity,
	    allDay: Boolean,
	};
	var EVENT_REFINERS = tslib.__assign(tslib.__assign(tslib.__assign({}, EVENT_NON_DATE_REFINERS), EVENT_DATE_REFINERS), { extendedProps: identity });
	function parseEvent(raw, eventSource, context, allowOpenRange, refiners) {
	    if (refiners === void 0) { refiners = buildEventRefiners(context); }
	    var _a = refineEventDef(raw, context, refiners), refined = _a.refined, extra = _a.extra;
	    var defaultAllDay = computeIsDefaultAllDay(eventSource, context);
	    var recurringRes = parseRecurring(refined, defaultAllDay, context.dateEnv, context.pluginHooks.recurringTypes);
	    if (recurringRes) {
	        var def = parseEventDef(refined, extra, eventSource ? eventSource.sourceId : '', recurringRes.allDay, Boolean(recurringRes.duration), context);
	        def.recurringDef = {
	            typeId: recurringRes.typeId,
	            typeData: recurringRes.typeData,
	            duration: recurringRes.duration,
	        };
	        return { def: def, instance: null };
	    }
	    var singleRes = parseSingle(refined, defaultAllDay, context, allowOpenRange);
	    if (singleRes) {
	        var def = parseEventDef(refined, extra, eventSource ? eventSource.sourceId : '', singleRes.allDay, singleRes.hasEnd, context);
	        var instance = createEventInstance(def.defId, singleRes.range, singleRes.forcedStartTzo, singleRes.forcedEndTzo);
	        return { def: def, instance: instance };
	    }
	    return null;
	}
	function refineEventDef(raw, context, refiners) {
	    if (refiners === void 0) { refiners = buildEventRefiners(context); }
	    return refineProps(raw, refiners);
	}
	function buildEventRefiners(context) {
	    return tslib.__assign(tslib.__assign(tslib.__assign({}, EVENT_UI_REFINERS), EVENT_REFINERS), context.pluginHooks.eventRefiners);
	}
	/*
	Will NOT populate extendedProps with the leftover properties.
	Will NOT populate date-related props.
	*/
	function parseEventDef(refined, extra, sourceId, allDay, hasEnd, context) {
	    var def = {
	        title: refined.title || '',
	        groupId: refined.groupId || '',
	        publicId: refined.id || '',
	        url: refined.url || '',
	        recurringDef: null,
	        defId: guid(),
	        sourceId: sourceId,
	        allDay: allDay,
	        hasEnd: hasEnd,
	        interactive: refined.interactive,
	        ui: createEventUi(refined, context),
	        extendedProps: tslib.__assign(tslib.__assign({}, (refined.extendedProps || {})), extra),
	    };
	    for (var _i = 0, _a = context.pluginHooks.eventDefMemberAdders; _i < _a.length; _i++) {
	        var memberAdder = _a[_i];
	        tslib.__assign(def, memberAdder(refined));
	    }
	    // help out EventApi from having user modify props
	    Object.freeze(def.ui.classNames);
	    Object.freeze(def.extendedProps);
	    return def;
	}
	function parseSingle(refined, defaultAllDay, context, allowOpenRange) {
	    var allDay = refined.allDay;
	    var startMeta;
	    var startMarker = null;
	    var hasEnd = false;
	    var endMeta;
	    var endMarker = null;
	    var startInput = refined.start != null ? refined.start : refined.date;
	    startMeta = context.dateEnv.createMarkerMeta(startInput);
	    if (startMeta) {
	        startMarker = startMeta.marker;
	    }
	    else if (!allowOpenRange) {
	        return null;
	    }
	    if (refined.end != null) {
	        endMeta = context.dateEnv.createMarkerMeta(refined.end);
	    }
	    if (allDay == null) {
	        if (defaultAllDay != null) {
	            allDay = defaultAllDay;
	        }
	        else {
	            // fall back to the date props LAST
	            allDay = (!startMeta || startMeta.isTimeUnspecified) &&
	                (!endMeta || endMeta.isTimeUnspecified);
	        }
	    }
	    if (allDay && startMarker) {
	        startMarker = startOfDay(startMarker);
	    }
	    if (endMeta) {
	        endMarker = endMeta.marker;
	        if (allDay) {
	            endMarker = startOfDay(endMarker);
	        }
	        if (startMarker && endMarker <= startMarker) {
	            endMarker = null;
	        }
	    }
	    if (endMarker) {
	        hasEnd = true;
	    }
	    else if (!allowOpenRange) {
	        hasEnd = context.options.forceEventDuration || false;
	        endMarker = context.dateEnv.add(startMarker, allDay ?
	            context.options.defaultAllDayEventDuration :
	            context.options.defaultTimedEventDuration);
	    }
	    return {
	        allDay: allDay,
	        hasEnd: hasEnd,
	        range: { start: startMarker, end: endMarker },
	        forcedStartTzo: startMeta ? startMeta.forcedTzo : null,
	        forcedEndTzo: endMeta ? endMeta.forcedTzo : null,
	    };
	}
	function computeIsDefaultAllDay(eventSource, context) {
	    var res = null;
	    if (eventSource) {
	        res = eventSource.defaultAllDay;
	    }
	    if (res == null) {
	        res = context.options.defaultAllDay;
	    }
	    return res;
	}
	
	/* Date stuff that doesn't belong in datelib core
	----------------------------------------------------------------------------------------------------------------------*/
	// given a timed range, computes an all-day range that has the same exact duration,
	// but whose start time is aligned with the start of the day.
	function computeAlignedDayRange(timedRange) {
	    var dayCnt = Math.floor(diffDays(timedRange.start, timedRange.end)) || 1;
	    var start = startOfDay(timedRange.start);
	    var end = addDays(start, dayCnt);
	    return { start: start, end: end };
	}
	// given a timed range, computes an all-day range based on how for the end date bleeds into the next day
	// TODO: give nextDayThreshold a default arg
	function computeVisibleDayRange(timedRange, nextDayThreshold) {
	    if (nextDayThreshold === void 0) { nextDayThreshold = createDuration(0); }
	    var startDay = null;
	    var endDay = null;
	    if (timedRange.end) {
	        endDay = startOfDay(timedRange.end);
	        var endTimeMS = timedRange.end.valueOf() - endDay.valueOf(); // # of milliseconds into `endDay`
	        // If the end time is actually inclusively part of the next day and is equal to or
	        // beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
	        // Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
	        if (endTimeMS && endTimeMS >= asRoughMs(nextDayThreshold)) {
	            endDay = addDays(endDay, 1);
	        }
	    }
	    if (timedRange.start) {
	        startDay = startOfDay(timedRange.start); // the beginning of the day the range starts
	        // If end is within `startDay` but not past nextDayThreshold, assign the default duration of one day.
	        if (endDay && endDay <= startDay) {
	            endDay = addDays(startDay, 1);
	        }
	    }
	    return { start: startDay, end: endDay };
	}
	// spans from one day into another?
	function isMultiDayRange(range) {
	    var visibleRange = computeVisibleDayRange(range);
	    return diffDays(visibleRange.start, visibleRange.end) > 1;
	}
	function diffDates(date0, date1, dateEnv, largeUnit) {
	    if (largeUnit === 'year') {
	        return createDuration(dateEnv.diffWholeYears(date0, date1), 'year');
	    }
	    if (largeUnit === 'month') {
	        return createDuration(dateEnv.diffWholeMonths(date0, date1), 'month');
	    }
	    return diffDayAndTime(date0, date1); // returns a duration
	}
	
	function parseRange(input, dateEnv) {
	    var start = null;
	    var end = null;
	    if (input.start) {
	        start = dateEnv.createMarker(input.start);
	    }
	    if (input.end) {
	        end = dateEnv.createMarker(input.end);
	    }
	    if (!start && !end) {
	        return null;
	    }
	    if (start && end && end < start) {
	        return null;
	    }
	    return { start: start, end: end };
	}
	// SIDE-EFFECT: will mutate ranges.
	// Will return a new array result.
	function invertRanges(ranges, constraintRange) {
	    var invertedRanges = [];
	    var start = constraintRange.start; // the end of the previous range. the start of the new range
	    var i;
	    var dateRange;
	    // ranges need to be in order. required for our date-walking algorithm
	    ranges.sort(compareRanges);
	    for (i = 0; i < ranges.length; i += 1) {
	        dateRange = ranges[i];
	        // add the span of time before the event (if there is any)
	        if (dateRange.start > start) { // compare millisecond time (skip any ambig logic)
	            invertedRanges.push({ start: start, end: dateRange.start });
	        }
	        if (dateRange.end > start) {
	            start = dateRange.end;
	        }
	    }
	    // add the span of time after the last event (if there is any)
	    if (start < constraintRange.end) { // compare millisecond time (skip any ambig logic)
	        invertedRanges.push({ start: start, end: constraintRange.end });
	    }
	    return invertedRanges;
	}
	function compareRanges(range0, range1) {
	    return range0.start.valueOf() - range1.start.valueOf(); // earlier ranges go first
	}
	function intersectRanges(range0, range1) {
	    var start = range0.start, end = range0.end;
	    var newRange = null;
	    if (range1.start !== null) {
	        if (start === null) {
	            start = range1.start;
	        }
	        else {
	            start = new Date(Math.max(start.valueOf(), range1.start.valueOf()));
	        }
	    }
	    if (range1.end != null) {
	        if (end === null) {
	            end = range1.end;
	        }
	        else {
	            end = new Date(Math.min(end.valueOf(), range1.end.valueOf()));
	        }
	    }
	    if (start === null || end === null || start < end) {
	        newRange = { start: start, end: end };
	    }
	    return newRange;
	}
	function rangesEqual(range0, range1) {
	    return (range0.start === null ? null : range0.start.valueOf()) === (range1.start === null ? null : range1.start.valueOf()) &&
	        (range0.end === null ? null : range0.end.valueOf()) === (range1.end === null ? null : range1.end.valueOf());
	}
	function rangesIntersect(range0, range1) {
	    return (range0.end === null || range1.start === null || range0.end > range1.start) &&
	        (range0.start === null || range1.end === null || range0.start < range1.end);
	}
	function rangeContainsRange(outerRange, innerRange) {
	    return (outerRange.start === null || (innerRange.start !== null && innerRange.start >= outerRange.start)) &&
	        (outerRange.end === null || (innerRange.end !== null && innerRange.end <= outerRange.end));
	}
	function rangeContainsMarker(range, date) {
	    return (range.start === null || date >= range.start) &&
	        (range.end === null || date < range.end);
	}
	// If the given date is not within the given range, move it inside.
	// (If it's past the end, make it one millisecond before the end).
	function constrainMarkerToRange(date, range) {
	    if (range.start != null && date < range.start) {
	        return range.start;
	    }
	    if (range.end != null && date >= range.end) {
	        return new Date(range.end.valueOf() - 1);
	    }
	    return date;
	}
	
	/*
	Specifying nextDayThreshold signals that all-day ranges should be sliced.
	*/
	function sliceEventStore(eventStore, eventUiBases, framingRange, nextDayThreshold) {
	    var inverseBgByGroupId = {};
	    var inverseBgByDefId = {};
	    var defByGroupId = {};
	    var bgRanges = [];
	    var fgRanges = [];
	    var eventUis = compileEventUis(eventStore.defs, eventUiBases);
	    for (var defId in eventStore.defs) {
	        var def = eventStore.defs[defId];
	        var ui = eventUis[def.defId];
	        if (ui.display === 'inverse-background') {
	            if (def.groupId) {
	                inverseBgByGroupId[def.groupId] = [];
	                if (!defByGroupId[def.groupId]) {
	                    defByGroupId[def.groupId] = def;
	                }
	            }
	            else {
	                inverseBgByDefId[defId] = [];
	            }
	        }
	    }
	    for (var instanceId in eventStore.instances) {
	        var instance = eventStore.instances[instanceId];
	        var def = eventStore.defs[instance.defId];
	        var ui = eventUis[def.defId];
	        var origRange = instance.range;
	        var normalRange = (!def.allDay && nextDayThreshold) ?
	            computeVisibleDayRange(origRange, nextDayThreshold) :
	            origRange;
	        var slicedRange = intersectRanges(normalRange, framingRange);
	        if (slicedRange) {
	            if (ui.display === 'inverse-background') {
	                if (def.groupId) {
	                    inverseBgByGroupId[def.groupId].push(slicedRange);
	                }
	                else {
	                    inverseBgByDefId[instance.defId].push(slicedRange);
	                }
	            }
	            else if (ui.display !== 'none') {
	                (ui.display === 'background' ? bgRanges : fgRanges).push({
	                    def: def,
	                    ui: ui,
	                    instance: instance,
	                    range: slicedRange,
	                    isStart: normalRange.start && normalRange.start.valueOf() === slicedRange.start.valueOf(),
	                    isEnd: normalRange.end && normalRange.end.valueOf() === slicedRange.end.valueOf(),
	                });
	            }
	        }
	    }
	    for (var groupId in inverseBgByGroupId) { // BY GROUP
	        var ranges = inverseBgByGroupId[groupId];
	        var invertedRanges = invertRanges(ranges, framingRange);
	        for (var _i = 0, invertedRanges_1 = invertedRanges; _i < invertedRanges_1.length; _i++) {
	            var invertedRange = invertedRanges_1[_i];
	            var def = defByGroupId[groupId];
	            var ui = eventUis[def.defId];
	            bgRanges.push({
	                def: def,
	                ui: ui,
	                instance: null,
	                range: invertedRange,
	                isStart: false,
	                isEnd: false,
	            });
	        }
	    }
	    for (var defId in inverseBgByDefId) {
	        var ranges = inverseBgByDefId[defId];
	        var invertedRanges = invertRanges(ranges, framingRange);
	        for (var _a = 0, invertedRanges_2 = invertedRanges; _a < invertedRanges_2.length; _a++) {
	            var invertedRange = invertedRanges_2[_a];
	            bgRanges.push({
	                def: eventStore.defs[defId],
	                ui: eventUis[defId],
	                instance: null,
	                range: invertedRange,
	                isStart: false,
	                isEnd: false,
	            });
	        }
	    }
	    return { bg: bgRanges, fg: fgRanges };
	}
	function hasBgRendering(def) {
	    return def.ui.display === 'background' || def.ui.display === 'inverse-background';
	}
	function setElSeg(el, seg) {
	    el.fcSeg = seg;
	}
	function getElSeg(el) {
	    return el.fcSeg ||
	        el.parentNode.fcSeg || // for the harness
	        null;
	}
	// event ui computation
	function compileEventUis(eventDefs, eventUiBases) {
	    return mapHash(eventDefs, function (eventDef) { return compileEventUi(eventDef, eventUiBases); });
	}
	function compileEventUi(eventDef, eventUiBases) {
	    var uis = [];
	    if (eventUiBases['']) {
	        uis.push(eventUiBases['']);
	    }
	    if (eventUiBases[eventDef.defId]) {
	        uis.push(eventUiBases[eventDef.defId]);
	    }
	    uis.push(eventDef.ui);
	    return combineEventUis(uis);
	}
	function sortEventSegs(segs, eventOrderSpecs) {
	    var objs = segs.map(buildSegCompareObj);
	    objs.sort(function (obj0, obj1) { return compareByFieldSpecs(obj0, obj1, eventOrderSpecs); });
	    return objs.map(function (c) { return c._seg; });
	}
	// returns a object with all primitive props that can be compared
	function buildSegCompareObj(seg) {
	    var eventRange = seg.eventRange;
	    var eventDef = eventRange.def;
	    var range = eventRange.instance ? eventRange.instance.range : eventRange.range;
	    var start = range.start ? range.start.valueOf() : 0; // TODO: better support for open-range events
	    var end = range.end ? range.end.valueOf() : 0; // "
	    return tslib.__assign(tslib.__assign(tslib.__assign({}, eventDef.extendedProps), eventDef), { id: eventDef.publicId, start: start,
	        end: end, duration: end - start, allDay: Number(eventDef.allDay), _seg: seg });
	}
	function computeSegDraggable(seg, context) {
	    var pluginHooks = context.pluginHooks;
	    var transformers = pluginHooks.isDraggableTransformers;
	    var _a = seg.eventRange, def = _a.def, ui = _a.ui;
	    var val = ui.startEditable;
	    for (var _i = 0, transformers_1 = transformers; _i < transformers_1.length; _i++) {
	        var transformer = transformers_1[_i];
	        val = transformer(val, def, ui, context);
	    }
	    return val;
	}
	function computeSegStartResizable(seg, context) {
	    return seg.isStart && seg.eventRange.ui.durationEditable && context.options.eventResizableFromStart;
	}
	function computeSegEndResizable(seg, context) {
	    return seg.isEnd && seg.eventRange.ui.durationEditable;
	}
	function buildSegTimeText(seg, timeFormat, context, defaultDisplayEventTime, // defaults to true
	defaultDisplayEventEnd, // defaults to true
	startOverride, endOverride) {
	    var dateEnv = context.dateEnv, options = context.options;
	    var displayEventTime = options.displayEventTime, displayEventEnd = options.displayEventEnd;
	    var eventDef = seg.eventRange.def;
	    var eventInstance = seg.eventRange.instance;
	    if (displayEventTime == null) {
	        displayEventTime = defaultDisplayEventTime !== false;
	    }
	    if (displayEventEnd == null) {
	        displayEventEnd = defaultDisplayEventEnd !== false;
	    }
	    var wholeEventStart = eventInstance.range.start;
	    var wholeEventEnd = eventInstance.range.end;
	    var segStart = startOverride || seg.start || seg.eventRange.range.start;
	    var segEnd = endOverride || seg.end || seg.eventRange.range.end;
	    var isStartDay = startOfDay(wholeEventStart).valueOf() === startOfDay(segStart).valueOf();
	    var isEndDay = startOfDay(addMs(wholeEventEnd, -1)).valueOf() === startOfDay(addMs(segEnd, -1)).valueOf();
	    if (displayEventTime && !eventDef.allDay && (isStartDay || isEndDay)) {
	        segStart = isStartDay ? wholeEventStart : segStart;
	        segEnd = isEndDay ? wholeEventEnd : segEnd;
	        if (displayEventEnd && eventDef.hasEnd) {
	            return dateEnv.formatRange(segStart, segEnd, timeFormat, {
	                forcedStartTzo: startOverride ? null : eventInstance.forcedStartTzo,
	                forcedEndTzo: endOverride ? null : eventInstance.forcedEndTzo,
	            });
	        }
	        return dateEnv.format(segStart, timeFormat, {
	            forcedTzo: startOverride ? null : eventInstance.forcedStartTzo, // nooooo, same
	        });
	    }
	    return '';
	}
	function getSegMeta(seg, todayRange, nowDate) {
	    var segRange = seg.eventRange.range;
	    return {
	        isPast: segRange.end < (nowDate || todayRange.start),
	        isFuture: segRange.start >= (nowDate || todayRange.end),
	        isToday: todayRange && rangeContainsMarker(todayRange, segRange.start),
	    };
	}
	function getEventClassNames(props) {
	    var classNames = ['fc-event'];
	    if (props.isMirror) {
	        classNames.push('fc-event-mirror');
	    }
	    if (props.isDraggable) {
	        classNames.push('fc-event-draggable');
	    }
	    if (props.isStartResizable || props.isEndResizable) {
	        classNames.push('fc-event-resizable');
	    }
	    if (props.isDragging) {
	        classNames.push('fc-event-dragging');
	    }
	    if (props.isResizing) {
	        classNames.push('fc-event-resizing');
	    }
	    if (props.isSelected) {
	        classNames.push('fc-event-selected');
	    }
	    if (props.isStart) {
	        classNames.push('fc-event-start');
	    }
	    if (props.isEnd) {
	        classNames.push('fc-event-end');
	    }
	    if (props.isPast) {
	        classNames.push('fc-event-past');
	    }
	    if (props.isToday) {
	        classNames.push('fc-event-today');
	    }
	    if (props.isFuture) {
	        classNames.push('fc-event-future');
	    }
	    return classNames;
	}
	function buildEventRangeKey(eventRange) {
	    return eventRange.instance
	        ? eventRange.instance.instanceId
	        : eventRange.def.defId + ":" + eventRange.range.start.toISOString();
	    // inverse-background events don't have specific instances. TODO: better solution
	}
	function getSegAnchorAttrs(seg, context) {
	    var _a = seg.eventRange, def = _a.def, instance = _a.instance;
	    var url = def.url;
	    if (url) {
	        return { href: url };
	    }
	    var emitter = context.emitter, options = context.options;
	    var eventInteractive = options.eventInteractive;
	    if (eventInteractive == null) {
	        eventInteractive = def.interactive;
	        if (eventInteractive == null) {
	            eventInteractive = Boolean(emitter.hasHandlers('eventClick'));
	        }
	    }
	    // mock what happens in EventClicking
	    if (eventInteractive) {
	        // only attach keyboard-related handlers because click handler is already done in EventClicking
	        return createAriaKeyboardAttrs(function (ev) {
	            emitter.trigger('eventClick', {
	                el: ev.target,
	                event: new EventApi(context, def, instance),
	                jsEvent: ev,
	                view: context.viewApi,
	            });
	        });
	    }
	    return {};
	}
	
	var STANDARD_PROPS = {
	    start: identity,
	    end: identity,
	    allDay: Boolean,
	};
	function parseDateSpan(raw, dateEnv, defaultDuration) {
	    var span = parseOpenDateSpan(raw, dateEnv);
	    var range = span.range;
	    if (!range.start) {
	        return null;
	    }
	    if (!range.end) {
	        if (defaultDuration == null) {
	            return null;
	        }
	        range.end = dateEnv.add(range.start, defaultDuration);
	    }
	    return span;
	}
	/*
	TODO: somehow combine with parseRange?
	Will return null if the start/end props were present but parsed invalidly.
	*/
	function parseOpenDateSpan(raw, dateEnv) {
	    var _a = refineProps(raw, STANDARD_PROPS), standardProps = _a.refined, extra = _a.extra;
	    var startMeta = standardProps.start ? dateEnv.createMarkerMeta(standardProps.start) : null;
	    var endMeta = standardProps.end ? dateEnv.createMarkerMeta(standardProps.end) : null;
	    var allDay = standardProps.allDay;
	    if (allDay == null) {
	        allDay = (startMeta && startMeta.isTimeUnspecified) &&
	            (!endMeta || endMeta.isTimeUnspecified);
	    }
	    return tslib.__assign({ range: {
	            start: startMeta ? startMeta.marker : null,
	            end: endMeta ? endMeta.marker : null,
	        }, allDay: allDay }, extra);
	}
	function isDateSpansEqual(span0, span1) {
	    return rangesEqual(span0.range, span1.range) &&
	        span0.allDay === span1.allDay &&
	        isSpanPropsEqual(span0, span1);
	}
	// the NON-DATE-RELATED props
	function isSpanPropsEqual(span0, span1) {
	    for (var propName in span1) {
	        if (propName !== 'range' && propName !== 'allDay') {
	            if (span0[propName] !== span1[propName]) {
	                return false;
	            }
	        }
	    }
	    // are there any props that span0 has that span1 DOESN'T have?
	    // both have range/allDay, so no need to special-case.
	    for (var propName in span0) {
	        if (!(propName in span1)) {
	            return false;
	        }
	    }
	    return true;
	}
	function buildDateSpanApi(span, dateEnv) {
	    return tslib.__assign(tslib.__assign({}, buildRangeApi(span.range, dateEnv, span.allDay)), { allDay: span.allDay });
	}
	function buildRangeApiWithTimeZone(range, dateEnv, omitTime) {
	    return tslib.__assign(tslib.__assign({}, buildRangeApi(range, dateEnv, omitTime)), { timeZone: dateEnv.timeZone });
	}
	function buildRangeApi(range, dateEnv, omitTime) {
	    return {
	        start: dateEnv.toDate(range.start),
	        end: dateEnv.toDate(range.end),
	        startStr: dateEnv.formatIso(range.start, { omitTime: omitTime }),
	        endStr: dateEnv.formatIso(range.end, { omitTime: omitTime }),
	    };
	}
	function fabricateEventRange(dateSpan, eventUiBases, context) {
	    var res = refineEventDef({ editable: false }, context);
	    var def = parseEventDef(res.refined, res.extra, '', // sourceId
	    dateSpan.allDay, true, // hasEnd
	    context);
	    return {
	        def: def,
	        ui: compileEventUi(def, eventUiBases),
	        instance: createEventInstance(def.defId, dateSpan.range),
	        range: dateSpan.range,
	        isStart: true,
	        isEnd: true,
	    };
	}
	
	function triggerDateSelect(selection, pev, context) {
	    context.emitter.trigger('select', tslib.__assign(tslib.__assign({}, buildDateSpanApiWithContext(selection, context)), { jsEvent: pev ? pev.origEvent : null, view: context.viewApi || context.calendarApi.view }));
	}
	function triggerDateUnselect(pev, context) {
	    context.emitter.trigger('unselect', {
	        jsEvent: pev ? pev.origEvent : null,
	        view: context.viewApi || context.calendarApi.view,
	    });
	}
	function buildDateSpanApiWithContext(dateSpan, context) {
	    var props = {};
	    for (var _i = 0, _a = context.pluginHooks.dateSpanTransforms; _i < _a.length; _i++) {
	        var transform = _a[_i];
	        tslib.__assign(props, transform(dateSpan, context));
	    }
	    tslib.__assign(props, buildDateSpanApi(dateSpan, context.dateEnv));
	    return props;
	}
	// Given an event's allDay status and start date, return what its fallback end date should be.
	// TODO: rename to computeDefaultEventEnd
	function getDefaultEventEnd(allDay, marker, context) {
	    var dateEnv = context.dateEnv, options = context.options;
	    var end = marker;
	    if (allDay) {
	        end = startOfDay(end);
	        end = dateEnv.add(end, options.defaultAllDayEventDuration);
	    }
	    else {
	        end = dateEnv.add(end, options.defaultTimedEventDuration);
	    }
	    return end;
	}
	
	// applies the mutation to ALL defs/instances within the event store
	function applyMutationToEventStore(eventStore, eventConfigBase, mutation, context) {
	    var eventConfigs = compileEventUis(eventStore.defs, eventConfigBase);
	    var dest = createEmptyEventStore();
	    for (var defId in eventStore.defs) {
	        var def = eventStore.defs[defId];
	        dest.defs[defId] = applyMutationToEventDef(def, eventConfigs[defId], mutation, context);
	    }
	    for (var instanceId in eventStore.instances) {
	        var instance = eventStore.instances[instanceId];
	        var def = dest.defs[instance.defId]; // important to grab the newly modified def
	        dest.instances[instanceId] = applyMutationToEventInstance(instance, def, eventConfigs[instance.defId], mutation, context);
	    }
	    return dest;
	}
	function applyMutationToEventDef(eventDef, eventConfig, mutation, context) {
	    var standardProps = mutation.standardProps || {};
	    // if hasEnd has not been specified, guess a good value based on deltas.
	    // if duration will change, there's no way the default duration will persist,
	    // and thus, we need to mark the event as having a real end
	    if (standardProps.hasEnd == null &&
	        eventConfig.durationEditable &&
	        (mutation.startDelta || mutation.endDelta)) {
	        standardProps.hasEnd = true; // TODO: is this mutation okay?
	    }
	    var copy = tslib.__assign(tslib.__assign(tslib.__assign({}, eventDef), standardProps), { ui: tslib.__assign(tslib.__assign({}, eventDef.ui), standardProps.ui) });
	    if (mutation.extendedProps) {
	        copy.extendedProps = tslib.__assign(tslib.__assign({}, copy.extendedProps), mutation.extendedProps);
	    }
	    for (var _i = 0, _a = context.pluginHooks.eventDefMutationAppliers; _i < _a.length; _i++) {
	        var applier = _a[_i];
	        applier(copy, mutation, context);
	    }
	    if (!copy.hasEnd && context.options.forceEventDuration) {
	        copy.hasEnd = true;
	    }
	    return copy;
	}
	function applyMutationToEventInstance(eventInstance, eventDef, // must first be modified by applyMutationToEventDef
	eventConfig, mutation, context) {
	    var dateEnv = context.dateEnv;
	    var forceAllDay = mutation.standardProps && mutation.standardProps.allDay === true;
	    var clearEnd = mutation.standardProps && mutation.standardProps.hasEnd === false;
	    var copy = tslib.__assign({}, eventInstance);
	    if (forceAllDay) {
	        copy.range = computeAlignedDayRange(copy.range);
	    }
	    if (mutation.datesDelta && eventConfig.startEditable) {
	        copy.range = {
	            start: dateEnv.add(copy.range.start, mutation.datesDelta),
	            end: dateEnv.add(copy.range.end, mutation.datesDelta),
	        };
	    }
	    if (mutation.startDelta && eventConfig.durationEditable) {
	        copy.range = {
	            start: dateEnv.add(copy.range.start, mutation.startDelta),
	            end: copy.range.end,
	        };
	    }
	    if (mutation.endDelta && eventConfig.durationEditable) {
	        copy.range = {
	            start: copy.range.start,
	            end: dateEnv.add(copy.range.end, mutation.endDelta),
	        };
	    }
	    if (clearEnd) {
	        copy.range = {
	            start: copy.range.start,
	            end: getDefaultEventEnd(eventDef.allDay, copy.range.start, context),
	        };
	    }
	    // in case event was all-day but the supplied deltas were not
	    // better util for this?
	    if (eventDef.allDay) {
	        copy.range = {
	            start: startOfDay(copy.range.start),
	            end: startOfDay(copy.range.end),
	        };
	    }
	    // handle invalid durations
	    if (copy.range.end < copy.range.start) {
	        copy.range.end = getDefaultEventEnd(eventDef.allDay, copy.range.start, context);
	    }
	    return copy;
	}
	
	// no public types yet. when there are, export from:
	// import {} from './api-type-deps'
	var ViewApi = /** @class */ (function () {
	    function ViewApi(type, getCurrentData, dateEnv) {
	        this.type = type;
	        this.getCurrentData = getCurrentData;
	        this.dateEnv = dateEnv;
	    }
	    Object.defineProperty(ViewApi.prototype, "calendar", {
	        get: function () {
	            return this.getCurrentData().calendarApi;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ViewApi.prototype, "title", {
	        get: function () {
	            return this.getCurrentData().viewTitle;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ViewApi.prototype, "activeStart", {
	        get: function () {
	            return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.start);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ViewApi.prototype, "activeEnd", {
	        get: function () {
	            return this.dateEnv.toDate(this.getCurrentData().dateProfile.activeRange.end);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ViewApi.prototype, "currentStart", {
	        get: function () {
	            return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.start);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ViewApi.prototype, "currentEnd", {
	        get: function () {
	            return this.dateEnv.toDate(this.getCurrentData().dateProfile.currentRange.end);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    ViewApi.prototype.getOption = function (name) {
	        return this.getCurrentData().options[name]; // are the view-specific options
	    };
	    return ViewApi;
	}());
	
	var EVENT_SOURCE_REFINERS = {
	    id: String,
	    defaultAllDay: Boolean,
	    url: String,
	    format: String,
	    events: identity,
	    eventDataTransform: identity,
	    // for any network-related sources
	    success: identity,
	    failure: identity,
	};
	function parseEventSource(raw, context, refiners) {
	    if (refiners === void 0) { refiners = buildEventSourceRefiners(context); }
	    var rawObj;
	    if (typeof raw === 'string') {
	        rawObj = { url: raw };
	    }
	    else if (typeof raw === 'function' || Array.isArray(raw)) {
	        rawObj = { events: raw };
	    }
	    else if (typeof raw === 'object' && raw) { // not null
	        rawObj = raw;
	    }
	    if (rawObj) {
	        var _a = refineProps(rawObj, refiners), refined = _a.refined, extra = _a.extra;
	        var metaRes = buildEventSourceMeta(refined, context);
	        if (metaRes) {
	            return {
	                _raw: raw,
	                isFetching: false,
	                latestFetchId: '',
	                fetchRange: null,
	                defaultAllDay: refined.defaultAllDay,
	                eventDataTransform: refined.eventDataTransform,
	                success: refined.success,
	                failure: refined.failure,
	                publicId: refined.id || '',
	                sourceId: guid(),
	                sourceDefId: metaRes.sourceDefId,
	                meta: metaRes.meta,
	                ui: createEventUi(refined, context),
	                extendedProps: extra,
	            };
	        }
	    }
	    return null;
	}
	function buildEventSourceRefiners(context) {
	    return tslib.__assign(tslib.__assign(tslib.__assign({}, EVENT_UI_REFINERS), EVENT_SOURCE_REFINERS), context.pluginHooks.eventSourceRefiners);
	}
	function buildEventSourceMeta(raw, context) {
	    var defs = context.pluginHooks.eventSourceDefs;
	    for (var i = defs.length - 1; i >= 0; i -= 1) { // later-added plugins take precedence
	        var def = defs[i];
	        var meta = def.parseMeta(raw);
	        if (meta) {
	            return { sourceDefId: i, meta: meta };
	        }
	    }
	    return null;
	}
	
	function reduceCurrentDate(currentDate, action) {
	    switch (action.type) {
	        case 'CHANGE_DATE':
	            return action.dateMarker;
	        default:
	            return currentDate;
	    }
	}
	function getInitialDate(options, dateEnv) {
	    var initialDateInput = options.initialDate;
	    // compute the initial ambig-timezone date
	    if (initialDateInput != null) {
	        return dateEnv.createMarker(initialDateInput);
	    }
	    return getNow(options.now, dateEnv); // getNow already returns unzoned
	}
	function getNow(nowInput, dateEnv) {
	    if (typeof nowInput === 'function') {
	        nowInput = nowInput();
	    }
	    if (nowInput == null) {
	        return dateEnv.createNowMarker();
	    }
	    return dateEnv.createMarker(nowInput);
	}
	
	var CalendarApi = /** @class */ (function () {
	    function CalendarApi() {
	    }
	    CalendarApi.prototype.getCurrentData = function () {
	        return this.currentDataManager.getCurrentData();
	    };
	    CalendarApi.prototype.dispatch = function (action) {
	        return this.currentDataManager.dispatch(action);
	    };
	    Object.defineProperty(CalendarApi.prototype, "view", {
	        get: function () { return this.getCurrentData().viewApi; } // for public API
	        ,
	        enumerable: false,
	        configurable: true
	    });
	    CalendarApi.prototype.batchRendering = function (callback) {
	        callback();
	    };
	    CalendarApi.prototype.updateSize = function () {
	        this.trigger('_resize', true);
	    };
	    // Options
	    // -----------------------------------------------------------------------------------------------------------------
	    CalendarApi.prototype.setOption = function (name, val) {
	        this.dispatch({
	            type: 'SET_OPTION',
	            optionName: name,
	            rawOptionValue: val,
	        });
	    };
	    CalendarApi.prototype.getOption = function (name) {
	        return this.currentDataManager.currentCalendarOptionsInput[name];
	    };
	    CalendarApi.prototype.getAvailableLocaleCodes = function () {
	        return Object.keys(this.getCurrentData().availableRawLocales);
	    };
	    // Trigger
	    // -----------------------------------------------------------------------------------------------------------------
	    CalendarApi.prototype.on = function (handlerName, handler) {
	        var currentDataManager = this.currentDataManager;
	        if (currentDataManager.currentCalendarOptionsRefiners[handlerName]) {
	            currentDataManager.emitter.on(handlerName, handler);
	        }
	        else {
	            console.warn("Unknown listener name '" + handlerName + "'");
	        }
	    };
	    CalendarApi.prototype.off = function (handlerName, handler) {
	        this.currentDataManager.emitter.off(handlerName, handler);
	    };
	    // not meant for public use
	    CalendarApi.prototype.trigger = function (handlerName) {
	        var _a;
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        (_a = this.currentDataManager.emitter).trigger.apply(_a, tslib.__spreadArray([handlerName], args));
	    };
	    // View
	    // -----------------------------------------------------------------------------------------------------------------
	    CalendarApi.prototype.changeView = function (viewType, dateOrRange) {
	        var _this = this;
	        this.batchRendering(function () {
	            _this.unselect();
	            if (dateOrRange) {
	                if (dateOrRange.start && dateOrRange.end) { // a range
	                    _this.dispatch({
	                        type: 'CHANGE_VIEW_TYPE',
	                        viewType: viewType,
	                    });
	                    _this.dispatch({
	                        type: 'SET_OPTION',
	                        optionName: 'visibleRange',
	                        rawOptionValue: dateOrRange,
	                    });
	                }
	                else {
	                    var dateEnv = _this.getCurrentData().dateEnv;
	                    _this.dispatch({
	                        type: 'CHANGE_VIEW_TYPE',
	                        viewType: viewType,
	                        dateMarker: dateEnv.createMarker(dateOrRange),
	                    });
	                }
	            }
	            else {
	                _this.dispatch({
	                    type: 'CHANGE_VIEW_TYPE',
	                    viewType: viewType,
	                });
	            }
	        });
	    };
	    // Forces navigation to a view for the given date.
	    // `viewType` can be a specific view name or a generic one like "week" or "day".
	    // needs to change
	    CalendarApi.prototype.zoomTo = function (dateMarker, viewType) {
	        var state = this.getCurrentData();
	        var spec;
	        viewType = viewType || 'day'; // day is default zoom
	        spec = state.viewSpecs[viewType] || this.getUnitViewSpec(viewType);
	        this.unselect();
	        if (spec) {
	            this.dispatch({
	                type: 'CHANGE_VIEW_TYPE',
	                viewType: spec.type,
	                dateMarker: dateMarker,
	            });
	        }
	        else {
	            this.dispatch({
	                type: 'CHANGE_DATE',
	                dateMarker: dateMarker,
	            });
	        }
	    };
	    // Given a duration singular unit, like "week" or "day", finds a matching view spec.
	    // Preference is given to views that have corresponding buttons.
	    CalendarApi.prototype.getUnitViewSpec = function (unit) {
	        var _a = this.getCurrentData(), viewSpecs = _a.viewSpecs, toolbarConfig = _a.toolbarConfig;
	        var viewTypes = [].concat(toolbarConfig.header ? toolbarConfig.header.viewsWithButtons : [], toolbarConfig.footer ? toolbarConfig.footer.viewsWithButtons : []);
	        var i;
	        var spec;
	        for (var viewType in viewSpecs) {
	            viewTypes.push(viewType);
	        }
	        for (i = 0; i < viewTypes.length; i += 1) {
	            spec = viewSpecs[viewTypes[i]];
	            if (spec) {
	                if (spec.singleUnit === unit) {
	                    return spec;
	                }
	            }
	        }
	        return null;
	    };
	    // Current Date
	    // -----------------------------------------------------------------------------------------------------------------
	    CalendarApi.prototype.prev = function () {
	        this.unselect();
	        this.dispatch({ type: 'PREV' });
	    };
	    CalendarApi.prototype.next = function () {
	        this.unselect();
	        this.dispatch({ type: 'NEXT' });
	    };
	    CalendarApi.prototype.prevYear = function () {
	        var state = this.getCurrentData();
	        this.unselect();
	        this.dispatch({
	            type: 'CHANGE_DATE',
	            dateMarker: state.dateEnv.addYears(state.currentDate, -1),
	        });
	    };
	    CalendarApi.prototype.nextYear = function () {
	        var state = this.getCurrentData();
	        this.unselect();
	        this.dispatch({
	            type: 'CHANGE_DATE',
	            dateMarker: state.dateEnv.addYears(state.currentDate, 1),
	        });
	    };
	    CalendarApi.prototype.today = function () {
	        var state = this.getCurrentData();
	        this.unselect();
	        this.dispatch({
	            type: 'CHANGE_DATE',
	            dateMarker: getNow(state.calendarOptions.now, state.dateEnv),
	        });
	    };
	    CalendarApi.prototype.gotoDate = function (zonedDateInput) {
	        var state = this.getCurrentData();
	        this.unselect();
	        this.dispatch({
	            type: 'CHANGE_DATE',
	            dateMarker: state.dateEnv.createMarker(zonedDateInput),
	        });
	    };
	    CalendarApi.prototype.incrementDate = function (deltaInput) {
	        var state = this.getCurrentData();
	        var delta = createDuration(deltaInput);
	        if (delta) { // else, warn about invalid input?
	            this.unselect();
	            this.dispatch({
	                type: 'CHANGE_DATE',
	                dateMarker: state.dateEnv.add(state.currentDate, delta),
	            });
	        }
	    };
	    // for external API
	    CalendarApi.prototype.getDate = function () {
	        var state = this.getCurrentData();
	        return state.dateEnv.toDate(state.currentDate);
	    };
	    // Date Formatting Utils
	    // -----------------------------------------------------------------------------------------------------------------
	    CalendarApi.prototype.formatDate = function (d, formatter) {
	        var dateEnv = this.getCurrentData().dateEnv;
	        return dateEnv.format(dateEnv.createMarker(d), createFormatter(formatter));
	    };
	    // `settings` is for formatter AND isEndExclusive
	    CalendarApi.prototype.formatRange = function (d0, d1, settings) {
	        var dateEnv = this.getCurrentData().dateEnv;
	        return dateEnv.formatRange(dateEnv.createMarker(d0), dateEnv.createMarker(d1), createFormatter(settings), settings);
	    };
	    CalendarApi.prototype.formatIso = function (d, omitTime) {
	        var dateEnv = this.getCurrentData().dateEnv;
	        return dateEnv.formatIso(dateEnv.createMarker(d), { omitTime: omitTime });
	    };
	    // Date Selection / Event Selection / DayClick
	    // -----------------------------------------------------------------------------------------------------------------
	    // this public method receives start/end dates in any format, with any timezone
	    // NOTE: args were changed from v3
	    CalendarApi.prototype.select = function (dateOrObj, endDate) {
	        var selectionInput;
	        if (endDate == null) {
	            if (dateOrObj.start != null) {
	                selectionInput = dateOrObj;
	            }
	            else {
	                selectionInput = {
	                    start: dateOrObj,
	                    end: null,
	                };
	            }
	        }
	        else {
	            selectionInput = {
	                start: dateOrObj,
	                end: endDate,
	            };
	        }
	        var state = this.getCurrentData();
	        var selection = parseDateSpan(selectionInput, state.dateEnv, createDuration({ days: 1 }));
	        if (selection) { // throw parse error otherwise?
	            this.dispatch({ type: 'SELECT_DATES', selection: selection });
	            triggerDateSelect(selection, null, state);
	        }
	    };
	    // public method
	    CalendarApi.prototype.unselect = function (pev) {
	        var state = this.getCurrentData();
	        if (state.dateSelection) {
	            this.dispatch({ type: 'UNSELECT_DATES' });
	            triggerDateUnselect(pev, state);
	        }
	    };
	    // Public Events API
	    // -----------------------------------------------------------------------------------------------------------------
	    CalendarApi.prototype.addEvent = function (eventInput, sourceInput) {
	        if (eventInput instanceof EventApi) {
	            var def = eventInput._def;
	            var instance = eventInput._instance;
	            var currentData = this.getCurrentData();
	            // not already present? don't want to add an old snapshot
	            if (!currentData.eventStore.defs[def.defId]) {
	                this.dispatch({
	                    type: 'ADD_EVENTS',
	                    eventStore: eventTupleToStore({ def: def, instance: instance }), // TODO: better util for two args?
	                });
	                this.triggerEventAdd(eventInput);
	            }
	            return eventInput;
	        }
	        var state = this.getCurrentData();
	        var eventSource;
	        if (sourceInput instanceof EventSourceApi) {
	            eventSource = sourceInput.internalEventSource;
	        }
	        else if (typeof sourceInput === 'boolean') {
	            if (sourceInput) { // true. part of the first event source
	                eventSource = hashValuesToArray(state.eventSources)[0];
	            }
	        }
	        else if (sourceInput != null) { // an ID. accepts a number too
	            var sourceApi = this.getEventSourceById(sourceInput); // TODO: use an internal function
	            if (!sourceApi) {
	                console.warn("Could not find an event source with ID \"" + sourceInput + "\""); // TODO: test
	                return null;
	            }
	            eventSource = sourceApi.internalEventSource;
	        }
	        var tuple = parseEvent(eventInput, eventSource, state, false);
	        if (tuple) {
	            var newEventApi = new EventApi(state, tuple.def, tuple.def.recurringDef ? null : tuple.instance);
	            this.dispatch({
	                type: 'ADD_EVENTS',
	                eventStore: eventTupleToStore(tuple),
	            });
	            this.triggerEventAdd(newEventApi);
	            return newEventApi;
	        }
	        return null;
	    };
	    CalendarApi.prototype.triggerEventAdd = function (eventApi) {
	        var _this = this;
	        var emitter = this.getCurrentData().emitter;
	        emitter.trigger('eventAdd', {
	            event: eventApi,
	            relatedEvents: [],
	            revert: function () {
	                _this.dispatch({
	                    type: 'REMOVE_EVENTS',
	                    eventStore: eventApiToStore(eventApi),
	                });
	            },
	        });
	    };
	    // TODO: optimize
	    CalendarApi.prototype.getEventById = function (id) {
	        var state = this.getCurrentData();
	        var _a = state.eventStore, defs = _a.defs, instances = _a.instances;
	        id = String(id);
	        for (var defId in defs) {
	            var def = defs[defId];
	            if (def.publicId === id) {
	                if (def.recurringDef) {
	                    return new EventApi(state, def, null);
	                }
	                for (var instanceId in instances) {
	                    var instance = instances[instanceId];
	                    if (instance.defId === def.defId) {
	                        return new EventApi(state, def, instance);
	                    }
	                }
	            }
	        }
	        return null;
	    };
	    CalendarApi.prototype.getEvents = function () {
	        var currentData = this.getCurrentData();
	        return buildEventApis(currentData.eventStore, currentData);
	    };
	    CalendarApi.prototype.removeAllEvents = function () {
	        this.dispatch({ type: 'REMOVE_ALL_EVENTS' });
	    };
	    // Public Event Sources API
	    // -----------------------------------------------------------------------------------------------------------------
	    CalendarApi.prototype.getEventSources = function () {
	        var state = this.getCurrentData();
	        var sourceHash = state.eventSources;
	        var sourceApis = [];
	        for (var internalId in sourceHash) {
	            sourceApis.push(new EventSourceApi(state, sourceHash[internalId]));
	        }
	        return sourceApis;
	    };
	    CalendarApi.prototype.getEventSourceById = function (id) {
	        var state = this.getCurrentData();
	        var sourceHash = state.eventSources;
	        id = String(id);
	        for (var sourceId in sourceHash) {
	            if (sourceHash[sourceId].publicId === id) {
	                return new EventSourceApi(state, sourceHash[sourceId]);
	            }
	        }
	        return null;
	    };
	    CalendarApi.prototype.addEventSource = function (sourceInput) {
	        var state = this.getCurrentData();
	        if (sourceInput instanceof EventSourceApi) {
	            // not already present? don't want to add an old snapshot
	            if (!state.eventSources[sourceInput.internalEventSource.sourceId]) {
	                this.dispatch({
	                    type: 'ADD_EVENT_SOURCES',
	                    sources: [sourceInput.internalEventSource],
	                });
	            }
	            return sourceInput;
	        }
	        var eventSource = parseEventSource(sourceInput, state);
	        if (eventSource) { // TODO: error otherwise?
	            this.dispatch({ type: 'ADD_EVENT_SOURCES', sources: [eventSource] });
	            return new EventSourceApi(state, eventSource);
	        }
	        return null;
	    };
	    CalendarApi.prototype.removeAllEventSources = function () {
	        this.dispatch({ type: 'REMOVE_ALL_EVENT_SOURCES' });
	    };
	    CalendarApi.prototype.refetchEvents = function () {
	        this.dispatch({ type: 'FETCH_EVENT_SOURCES', isRefetch: true });
	    };
	    // Scroll
	    // -----------------------------------------------------------------------------------------------------------------
	    CalendarApi.prototype.scrollToTime = function (timeInput) {
	        var time = createDuration(timeInput);
	        if (time) {
	            this.trigger('_scrollRequest', { time: time });
	        }
	    };
	    return CalendarApi;
	}());
	
	var EventApi = /** @class */ (function () {
	    // instance will be null if expressing a recurring event that has no current instances,
	    // OR if trying to validate an incoming external event that has no dates assigned
	    function EventApi(context, def, instance) {
	        this._context = context;
	        this._def = def;
	        this._instance = instance || null;
	    }
	    /*
	    TODO: make event struct more responsible for this
	    */
	    EventApi.prototype.setProp = function (name, val) {
	        var _a, _b;
	        if (name in EVENT_DATE_REFINERS) {
	            console.warn('Could not set date-related prop \'name\'. Use one of the date-related methods instead.');
	            // TODO: make proper aliasing system?
	        }
	        else if (name === 'id') {
	            val = EVENT_NON_DATE_REFINERS[name](val);
	            this.mutate({
	                standardProps: { publicId: val }, // hardcoded internal name
	            });
	        }
	        else if (name in EVENT_NON_DATE_REFINERS) {
	            val = EVENT_NON_DATE_REFINERS[name](val);
	            this.mutate({
	                standardProps: (_a = {}, _a[name] = val, _a),
	            });
	        }
	        else if (name in EVENT_UI_REFINERS) {
	            var ui = EVENT_UI_REFINERS[name](val);
	            if (name === 'color') {
	                ui = { backgroundColor: val, borderColor: val };
	            }
	            else if (name === 'editable') {
	                ui = { startEditable: val, durationEditable: val };
	            }
	            else {
	                ui = (_b = {}, _b[name] = val, _b);
	            }
	            this.mutate({
	                standardProps: { ui: ui },
	            });
	        }
	        else {
	            console.warn("Could not set prop '" + name + "'. Use setExtendedProp instead.");
	        }
	    };
	    EventApi.prototype.setExtendedProp = function (name, val) {
	        var _a;
	        this.mutate({
	            extendedProps: (_a = {}, _a[name] = val, _a),
	        });
	    };
	    EventApi.prototype.setStart = function (startInput, options) {
	        if (options === void 0) { options = {}; }
	        var dateEnv = this._context.dateEnv;
	        var start = dateEnv.createMarker(startInput);
	        if (start && this._instance) { // TODO: warning if parsed bad
	            var instanceRange = this._instance.range;
	            var startDelta = diffDates(instanceRange.start, start, dateEnv, options.granularity); // what if parsed bad!?
	            if (options.maintainDuration) {
	                this.mutate({ datesDelta: startDelta });
	            }
	            else {
	                this.mutate({ startDelta: startDelta });
	            }
	        }
	    };
	    EventApi.prototype.setEnd = function (endInput, options) {
	        if (options === void 0) { options = {}; }
	        var dateEnv = this._context.dateEnv;
	        var end;
	        if (endInput != null) {
	            end = dateEnv.createMarker(endInput);
	            if (!end) {
	                return; // TODO: warning if parsed bad
	            }
	        }
	        if (this._instance) {
	            if (end) {
	                var endDelta = diffDates(this._instance.range.end, end, dateEnv, options.granularity);
	                this.mutate({ endDelta: endDelta });
	            }
	            else {
	                this.mutate({ standardProps: { hasEnd: false } });
	            }
	        }
	    };
	    EventApi.prototype.setDates = function (startInput, endInput, options) {
	        if (options === void 0) { options = {}; }
	        var dateEnv = this._context.dateEnv;
	        var standardProps = { allDay: options.allDay };
	        var start = dateEnv.createMarker(startInput);
	        var end;
	        if (!start) {
	            return; // TODO: warning if parsed bad
	        }
	        if (endInput != null) {
	            end = dateEnv.createMarker(endInput);
	            if (!end) { // TODO: warning if parsed bad
	                return;
	            }
	        }
	        if (this._instance) {
	            var instanceRange = this._instance.range;
	            // when computing the diff for an event being converted to all-day,
	            // compute diff off of the all-day values the way event-mutation does.
	            if (options.allDay === true) {
	                instanceRange = computeAlignedDayRange(instanceRange);
	            }
	            var startDelta = diffDates(instanceRange.start, start, dateEnv, options.granularity);
	            if (end) {
	                var endDelta = diffDates(instanceRange.end, end, dateEnv, options.granularity);
	                if (durationsEqual(startDelta, endDelta)) {
	                    this.mutate({ datesDelta: startDelta, standardProps: standardProps });
	                }
	                else {
	                    this.mutate({ startDelta: startDelta, endDelta: endDelta, standardProps: standardProps });
	                }
	            }
	            else { // means "clear the end"
	                standardProps.hasEnd = false;
	                this.mutate({ datesDelta: startDelta, standardProps: standardProps });
	            }
	        }
	    };
	    EventApi.prototype.moveStart = function (deltaInput) {
	        var delta = createDuration(deltaInput);
	        if (delta) { // TODO: warning if parsed bad
	            this.mutate({ startDelta: delta });
	        }
	    };
	    EventApi.prototype.moveEnd = function (deltaInput) {
	        var delta = createDuration(deltaInput);
	        if (delta) { // TODO: warning if parsed bad
	            this.mutate({ endDelta: delta });
	        }
	    };
	    EventApi.prototype.moveDates = function (deltaInput) {
	        var delta = createDuration(deltaInput);
	        if (delta) { // TODO: warning if parsed bad
	            this.mutate({ datesDelta: delta });
	        }
	    };
	    EventApi.prototype.setAllDay = function (allDay, options) {
	        if (options === void 0) { options = {}; }
	        var standardProps = { allDay: allDay };
	        var maintainDuration = options.maintainDuration;
	        if (maintainDuration == null) {
	            maintainDuration = this._context.options.allDayMaintainDuration;
	        }
	        if (this._def.allDay !== allDay) {
	            standardProps.hasEnd = maintainDuration;
	        }
	        this.mutate({ standardProps: standardProps });
	    };
	    EventApi.prototype.formatRange = function (formatInput) {
	        var dateEnv = this._context.dateEnv;
	        var instance = this._instance;
	        var formatter = createFormatter(formatInput);
	        if (this._def.hasEnd) {
	            return dateEnv.formatRange(instance.range.start, instance.range.end, formatter, {
	                forcedStartTzo: instance.forcedStartTzo,
	                forcedEndTzo: instance.forcedEndTzo,
	            });
	        }
	        return dateEnv.format(instance.range.start, formatter, {
	            forcedTzo: instance.forcedStartTzo,
	        });
	    };
	    EventApi.prototype.mutate = function (mutation) {
	        var instance = this._instance;
	        if (instance) {
	            var def = this._def;
	            var context_1 = this._context;
	            var eventStore_1 = context_1.getCurrentData().eventStore;
	            var relevantEvents = getRelevantEvents(eventStore_1, instance.instanceId);
	            var eventConfigBase = {
	                '': {
	                    display: '',
	                    startEditable: true,
	                    durationEditable: true,
	                    constraints: [],
	                    overlap: null,
	                    allows: [],
	                    backgroundColor: '',
	                    borderColor: '',
	                    textColor: '',
	                    classNames: [],
	                },
	            };
	            relevantEvents = applyMutationToEventStore(relevantEvents, eventConfigBase, mutation, context_1);
	            var oldEvent = new EventApi(context_1, def, instance); // snapshot
	            this._def = relevantEvents.defs[def.defId];
	            this._instance = relevantEvents.instances[instance.instanceId];
	            context_1.dispatch({
	                type: 'MERGE_EVENTS',
	                eventStore: relevantEvents,
	            });
	            context_1.emitter.trigger('eventChange', {
	                oldEvent: oldEvent,
	                event: this,
	                relatedEvents: buildEventApis(relevantEvents, context_1, instance),
	                revert: function () {
	                    context_1.dispatch({
	                        type: 'RESET_EVENTS',
	                        eventStore: eventStore_1,
	                    });
	                },
	            });
	        }
	    };
	    EventApi.prototype.remove = function () {
	        var context = this._context;
	        var asStore = eventApiToStore(this);
	        context.dispatch({
	            type: 'REMOVE_EVENTS',
	            eventStore: asStore,
	        });
	        context.emitter.trigger('eventRemove', {
	            event: this,
	            relatedEvents: [],
	            revert: function () {
	                context.dispatch({
	                    type: 'MERGE_EVENTS',
	                    eventStore: asStore,
	                });
	            },
	        });
	    };
	    Object.defineProperty(EventApi.prototype, "source", {
	        get: function () {
	            var sourceId = this._def.sourceId;
	            if (sourceId) {
	                return new EventSourceApi(this._context, this._context.getCurrentData().eventSources[sourceId]);
	            }
	            return null;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "start", {
	        get: function () {
	            return this._instance ?
	                this._context.dateEnv.toDate(this._instance.range.start) :
	                null;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "end", {
	        get: function () {
	            return (this._instance && this._def.hasEnd) ?
	                this._context.dateEnv.toDate(this._instance.range.end) :
	                null;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "startStr", {
	        get: function () {
	            var instance = this._instance;
	            if (instance) {
	                return this._context.dateEnv.formatIso(instance.range.start, {
	                    omitTime: this._def.allDay,
	                    forcedTzo: instance.forcedStartTzo,
	                });
	            }
	            return '';
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "endStr", {
	        get: function () {
	            var instance = this._instance;
	            if (instance && this._def.hasEnd) {
	                return this._context.dateEnv.formatIso(instance.range.end, {
	                    omitTime: this._def.allDay,
	                    forcedTzo: instance.forcedEndTzo,
	                });
	            }
	            return '';
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "id", {
	        // computable props that all access the def
	        // TODO: find a TypeScript-compatible way to do this at scale
	        get: function () { return this._def.publicId; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "groupId", {
	        get: function () { return this._def.groupId; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "allDay", {
	        get: function () { return this._def.allDay; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "title", {
	        get: function () { return this._def.title; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "url", {
	        get: function () { return this._def.url; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "display", {
	        get: function () { return this._def.ui.display || 'auto'; } // bad. just normalize the type earlier
	        ,
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "startEditable", {
	        get: function () { return this._def.ui.startEditable; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "durationEditable", {
	        get: function () { return this._def.ui.durationEditable; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "constraint", {
	        get: function () { return this._def.ui.constraints[0] || null; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "overlap", {
	        get: function () { return this._def.ui.overlap; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "allow", {
	        get: function () { return this._def.ui.allows[0] || null; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "backgroundColor", {
	        get: function () { return this._def.ui.backgroundColor; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "borderColor", {
	        get: function () { return this._def.ui.borderColor; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "textColor", {
	        get: function () { return this._def.ui.textColor; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "classNames", {
	        // NOTE: user can't modify these because Object.freeze was called in event-def parsing
	        get: function () { return this._def.ui.classNames; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(EventApi.prototype, "extendedProps", {
	        get: function () { return this._def.extendedProps; },
	        enumerable: false,
	        configurable: true
	    });
	    EventApi.prototype.toPlainObject = function (settings) {
	        if (settings === void 0) { settings = {}; }
	        var def = this._def;
	        var ui = def.ui;
	        var _a = this, startStr = _a.startStr, endStr = _a.endStr;
	        var res = {};
	        if (def.title) {
	            res.title = def.title;
	        }
	        if (startStr) {
	            res.start = startStr;
	        }
	        if (endStr) {
	            res.end = endStr;
	        }
	        if (def.publicId) {
	            res.id = def.publicId;
	        }
	        if (def.groupId) {
	            res.groupId = def.groupId;
	        }
	        if (def.url) {
	            res.url = def.url;
	        }
	        if (ui.display && ui.display !== 'auto') {
	            res.display = ui.display;
	        }
	        // TODO: what about recurring-event properties???
	        // TODO: include startEditable/durationEditable/constraint/overlap/allow
	        if (settings.collapseColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) {
	            res.color = ui.backgroundColor;
	        }
	        else {
	            if (ui.backgroundColor) {
	                res.backgroundColor = ui.backgroundColor;
	            }
	            if (ui.borderColor) {
	                res.borderColor = ui.borderColor;
	            }
	        }
	        if (ui.textColor) {
	            res.textColor = ui.textColor;
	        }
	        if (ui.classNames.length) {
	            res.classNames = ui.classNames;
	        }
	        if (Object.keys(def.extendedProps).length) {
	            if (settings.collapseExtendedProps) {
	                tslib.__assign(res, def.extendedProps);
	            }
	            else {
	                res.extendedProps = def.extendedProps;
	            }
	        }
	        return res;
	    };
	    EventApi.prototype.toJSON = function () {
	        return this.toPlainObject();
	    };
	    return EventApi;
	}());
	function eventApiToStore(eventApi) {
	    var _a, _b;
	    var def = eventApi._def;
	    var instance = eventApi._instance;
	    return {
	        defs: (_a = {}, _a[def.defId] = def, _a),
	        instances: instance
	            ? (_b = {}, _b[instance.instanceId] = instance, _b) : {},
	    };
	}
	function buildEventApis(eventStore, context, excludeInstance) {
	    var defs = eventStore.defs, instances = eventStore.instances;
	    var eventApis = [];
	    var excludeInstanceId = excludeInstance ? excludeInstance.instanceId : '';
	    for (var id in instances) {
	        var instance = instances[id];
	        var def = defs[instance.defId];
	        if (instance.instanceId !== excludeInstanceId) {
	            eventApis.push(new EventApi(context, def, instance));
	        }
	    }
	    return eventApis;
	}
	
	var calendarSystemClassMap = {};
	function registerCalendarSystem(name, theClass) {
	    calendarSystemClassMap[name] = theClass;
	}
	function createCalendarSystem(name) {
	    return new calendarSystemClassMap[name]();
	}
	var GregorianCalendarSystem = /** @class */ (function () {
	    function GregorianCalendarSystem() {
	    }
	    GregorianCalendarSystem.prototype.getMarkerYear = function (d) {
	        return d.getUTCFullYear();
	    };
	    GregorianCalendarSystem.prototype.getMarkerMonth = function (d) {
	        return d.getUTCMonth();
	    };
	    GregorianCalendarSystem.prototype.getMarkerDay = function (d) {
	        return d.getUTCDate();
	    };
	    GregorianCalendarSystem.prototype.arrayToMarker = function (arr) {
	        return arrayToUtcDate(arr);
	    };
	    GregorianCalendarSystem.prototype.markerToArray = function (marker) {
	        return dateToUtcArray(marker);
	    };
	    return GregorianCalendarSystem;
	}());
	registerCalendarSystem('gregory', GregorianCalendarSystem);
	
	var ISO_RE = /^\s*(\d{4})(-?(\d{2})(-?(\d{2})([T ](\d{2}):?(\d{2})(:?(\d{2})(\.(\d+))?)?(Z|(([-+])(\d{2})(:?(\d{2}))?))?)?)?)?$/;
	function parse(str) {
	    var m = ISO_RE.exec(str);
	    if (m) {
	        var marker = new Date(Date.UTC(Number(m[1]), m[3] ? Number(m[3]) - 1 : 0, Number(m[5] || 1), Number(m[7] || 0), Number(m[8] || 0), Number(m[10] || 0), m[12] ? Number("0." + m[12]) * 1000 : 0));
	        if (isValidDate(marker)) {
	            var timeZoneOffset = null;
	            if (m[13]) {
	                timeZoneOffset = (m[15] === '-' ? -1 : 1) * (Number(m[16] || 0) * 60 +
	                    Number(m[18] || 0));
	            }
	            return {
	                marker: marker,
	                isTimeUnspecified: !m[6],
	                timeZoneOffset: timeZoneOffset,
	            };
	        }
	    }
	    return null;
	}
	
	var DateEnv = /** @class */ (function () {
	    function DateEnv(settings) {
	        var timeZone = this.timeZone = settings.timeZone;
	        var isNamedTimeZone = timeZone !== 'local' && timeZone !== 'UTC';
	        if (settings.namedTimeZoneImpl && isNamedTimeZone) {
	            this.namedTimeZoneImpl = new settings.namedTimeZoneImpl(timeZone);
	        }
	        this.canComputeOffset = Boolean(!isNamedTimeZone || this.namedTimeZoneImpl);
	        this.calendarSystem = createCalendarSystem(settings.calendarSystem);
	        this.locale = settings.locale;
	        this.weekDow = settings.locale.week.dow;
	        this.weekDoy = settings.locale.week.doy;
	        if (settings.weekNumberCalculation === 'ISO') {
	            this.weekDow = 1;
	            this.weekDoy = 4;
	        }
	        if (typeof settings.firstDay === 'number') {
	            this.weekDow = settings.firstDay;
	        }
	        if (typeof settings.weekNumberCalculation === 'function') {
	            this.weekNumberFunc = settings.weekNumberCalculation;
	        }
	        this.weekText = settings.weekText != null ? settings.weekText : settings.locale.options.weekText;
	        this.weekTextLong = (settings.weekTextLong != null ? settings.weekTextLong : settings.locale.options.weekTextLong) || this.weekText;
	        this.cmdFormatter = settings.cmdFormatter;
	        this.defaultSeparator = settings.defaultSeparator;
	    }
	    // Creating / Parsing
	    DateEnv.prototype.createMarker = function (input) {
	        var meta = this.createMarkerMeta(input);
	        if (meta === null) {
	            return null;
	        }
	        return meta.marker;
	    };
	    DateEnv.prototype.createNowMarker = function () {
	        if (this.canComputeOffset) {
	            return this.timestampToMarker(new Date().valueOf());
	        }
	        // if we can't compute the current date val for a timezone,
	        // better to give the current local date vals than UTC
	        return arrayToUtcDate(dateToLocalArray(new Date()));
	    };
	    DateEnv.prototype.createMarkerMeta = function (input) {
	        if (typeof input === 'string') {
	            return this.parse(input);
	        }
	        var marker = null;
	        if (typeof input === 'number') {
	            marker = this.timestampToMarker(input);
	        }
	        else if (input instanceof Date) {
	            input = input.valueOf();
	            if (!isNaN(input)) {
	                marker = this.timestampToMarker(input);
	            }
	        }
	        else if (Array.isArray(input)) {
	            marker = arrayToUtcDate(input);
	        }
	        if (marker === null || !isValidDate(marker)) {
	            return null;
	        }
	        return { marker: marker, isTimeUnspecified: false, forcedTzo: null };
	    };
	    DateEnv.prototype.parse = function (s) {
	        var parts = parse(s);
	        if (parts === null) {
	            return null;
	        }
	        var marker = parts.marker;
	        var forcedTzo = null;
	        if (parts.timeZoneOffset !== null) {
	            if (this.canComputeOffset) {
	                marker = this.timestampToMarker(marker.valueOf() - parts.timeZoneOffset * 60 * 1000);
	            }
	            else {
	                forcedTzo = parts.timeZoneOffset;
	            }
	        }
	        return { marker: marker, isTimeUnspecified: parts.isTimeUnspecified, forcedTzo: forcedTzo };
	    };
	    // Accessors
	    DateEnv.prototype.getYear = function (marker) {
	        return this.calendarSystem.getMarkerYear(marker);
	    };
	    DateEnv.prototype.getMonth = function (marker) {
	        return this.calendarSystem.getMarkerMonth(marker);
	    };
	    // Adding / Subtracting
	    DateEnv.prototype.add = function (marker, dur) {
	        var a = this.calendarSystem.markerToArray(marker);
	        a[0] += dur.years;
	        a[1] += dur.months;
	        a[2] += dur.days;
	        a[6] += dur.milliseconds;
	        return this.calendarSystem.arrayToMarker(a);
	    };
	    DateEnv.prototype.subtract = function (marker, dur) {
	        var a = this.calendarSystem.markerToArray(marker);
	        a[0] -= dur.years;
	        a[1] -= dur.months;
	        a[2] -= dur.days;
	        a[6] -= dur.milliseconds;
	        return this.calendarSystem.arrayToMarker(a);
	    };
	    DateEnv.prototype.addYears = function (marker, n) {
	        var a = this.calendarSystem.markerToArray(marker);
	        a[0] += n;
	        return this.calendarSystem.arrayToMarker(a);
	    };
	    DateEnv.prototype.addMonths = function (marker, n) {
	        var a = this.calendarSystem.markerToArray(marker);
	        a[1] += n;
	        return this.calendarSystem.arrayToMarker(a);
	    };
	    // Diffing Whole Units
	    DateEnv.prototype.diffWholeYears = function (m0, m1) {
	        var calendarSystem = this.calendarSystem;
	        if (timeAsMs(m0) === timeAsMs(m1) &&
	            calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1) &&
	            calendarSystem.getMarkerMonth(m0) === calendarSystem.getMarkerMonth(m1)) {
	            return calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0);
	        }
	        return null;
	    };
	    DateEnv.prototype.diffWholeMonths = function (m0, m1) {
	        var calendarSystem = this.calendarSystem;
	        if (timeAsMs(m0) === timeAsMs(m1) &&
	            calendarSystem.getMarkerDay(m0) === calendarSystem.getMarkerDay(m1)) {
	            return (calendarSystem.getMarkerMonth(m1) - calendarSystem.getMarkerMonth(m0)) +
	                (calendarSystem.getMarkerYear(m1) - calendarSystem.getMarkerYear(m0)) * 12;
	        }
	        return null;
	    };
	    // Range / Duration
	    DateEnv.prototype.greatestWholeUnit = function (m0, m1) {
	        var n = this.diffWholeYears(m0, m1);
	        if (n !== null) {
	            return { unit: 'year', value: n };
	        }
	        n = this.diffWholeMonths(m0, m1);
	        if (n !== null) {
	            return { unit: 'month', value: n };
	        }
	        n = diffWholeWeeks(m0, m1);
	        if (n !== null) {
	            return { unit: 'week', value: n };
	        }
	        n = diffWholeDays(m0, m1);
	        if (n !== null) {
	            return { unit: 'day', value: n };
	        }
	        n = diffHours(m0, m1);
	        if (isInt(n)) {
	            return { unit: 'hour', value: n };
	        }
	        n = diffMinutes(m0, m1);
	        if (isInt(n)) {
	            return { unit: 'minute', value: n };
	        }
	        n = diffSeconds(m0, m1);
	        if (isInt(n)) {
	            return { unit: 'second', value: n };
	        }
	        return { unit: 'millisecond', value: m1.valueOf() - m0.valueOf() };
	    };
	    DateEnv.prototype.countDurationsBetween = function (m0, m1, d) {
	        // TODO: can use greatestWholeUnit
	        var diff;
	        if (d.years) {
	            diff = this.diffWholeYears(m0, m1);
	            if (diff !== null) {
	                return diff / asRoughYears(d);
	            }
	        }
	        if (d.months) {
	            diff = this.diffWholeMonths(m0, m1);
	            if (diff !== null) {
	                return diff / asRoughMonths(d);
	            }
	        }
	        if (d.days) {
	            diff = diffWholeDays(m0, m1);
	            if (diff !== null) {
	                return diff / asRoughDays(d);
	            }
	        }
	        return (m1.valueOf() - m0.valueOf()) / asRoughMs(d);
	    };
	    // Start-Of
	    // these DON'T return zoned-dates. only UTC start-of dates
	    DateEnv.prototype.startOf = function (m, unit) {
	        if (unit === 'year') {
	            return this.startOfYear(m);
	        }
	        if (unit === 'month') {
	            return this.startOfMonth(m);
	        }
	        if (unit === 'week') {
	            return this.startOfWeek(m);
	        }
	        if (unit === 'day') {
	            return startOfDay(m);
	        }
	        if (unit === 'hour') {
	            return startOfHour(m);
	        }
	        if (unit === 'minute') {
	            return startOfMinute(m);
	        }
	        if (unit === 'second') {
	            return startOfSecond(m);
	        }
	        return null;
	    };
	    DateEnv.prototype.startOfYear = function (m) {
	        return this.calendarSystem.arrayToMarker([
	            this.calendarSystem.getMarkerYear(m),
	        ]);
	    };
	    DateEnv.prototype.startOfMonth = function (m) {
	        return this.calendarSystem.arrayToMarker([
	            this.calendarSystem.getMarkerYear(m),
	            this.calendarSystem.getMarkerMonth(m),
	        ]);
	    };
	    DateEnv.prototype.startOfWeek = function (m) {
	        return this.calendarSystem.arrayToMarker([
	            this.calendarSystem.getMarkerYear(m),
	            this.calendarSystem.getMarkerMonth(m),
	            m.getUTCDate() - ((m.getUTCDay() - this.weekDow + 7) % 7),
	        ]);
	    };
	    // Week Number
	    DateEnv.prototype.computeWeekNumber = function (marker) {
	        if (this.weekNumberFunc) {
	            return this.weekNumberFunc(this.toDate(marker));
	        }
	        return weekOfYear(marker, this.weekDow, this.weekDoy);
	    };
	    // TODO: choke on timeZoneName: long
	    DateEnv.prototype.format = function (marker, formatter, dateOptions) {
	        if (dateOptions === void 0) { dateOptions = {}; }
	        return formatter.format({
	            marker: marker,
	            timeZoneOffset: dateOptions.forcedTzo != null ?
	                dateOptions.forcedTzo :
	                this.offsetForMarker(marker),
	        }, this);
	    };
	    DateEnv.prototype.formatRange = function (start, end, formatter, dateOptions) {
	        if (dateOptions === void 0) { dateOptions = {}; }
	        if (dateOptions.isEndExclusive) {
	            end = addMs(end, -1);
	        }
	        return formatter.formatRange({
	            marker: start,
	            timeZoneOffset: dateOptions.forcedStartTzo != null ?
	                dateOptions.forcedStartTzo :
	                this.offsetForMarker(start),
	        }, {
	            marker: end,
	            timeZoneOffset: dateOptions.forcedEndTzo != null ?
	                dateOptions.forcedEndTzo :
	                this.offsetForMarker(end),
	        }, this, dateOptions.defaultSeparator);
	    };
	    /*
	    DUMB: the omitTime arg is dumb. if we omit the time, we want to omit the timezone offset. and if we do that,
	    might as well use buildIsoString or some other util directly
	    */
	    DateEnv.prototype.formatIso = function (marker, extraOptions) {
	        if (extraOptions === void 0) { extraOptions = {}; }
	        var timeZoneOffset = null;
	        if (!extraOptions.omitTimeZoneOffset) {
	            if (extraOptions.forcedTzo != null) {
	                timeZoneOffset = extraOptions.forcedTzo;
	            }
	            else {
	                timeZoneOffset = this.offsetForMarker(marker);
	            }
	        }
	        return buildIsoString(marker, timeZoneOffset, extraOptions.omitTime);
	    };
	    // TimeZone
	    DateEnv.prototype.timestampToMarker = function (ms) {
	        if (this.timeZone === 'local') {
	            return arrayToUtcDate(dateToLocalArray(new Date(ms)));
	        }
	        if (this.timeZone === 'UTC' || !this.namedTimeZoneImpl) {
	            return new Date(ms);
	        }
	        return arrayToUtcDate(this.namedTimeZoneImpl.timestampToArray(ms));
	    };
	    DateEnv.prototype.offsetForMarker = function (m) {
	        if (this.timeZone === 'local') {
	            return -arrayToLocalDate(dateToUtcArray(m)).getTimezoneOffset(); // convert "inverse" offset to "normal" offset
	        }
	        if (this.timeZone === 'UTC') {
	            return 0;
	        }
	        if (this.namedTimeZoneImpl) {
	            return this.namedTimeZoneImpl.offsetForArray(dateToUtcArray(m));
	        }
	        return null;
	    };
	    // Conversion
	    DateEnv.prototype.toDate = function (m, forcedTzo) {
	        if (this.timeZone === 'local') {
	            return arrayToLocalDate(dateToUtcArray(m));
	        }
	        if (this.timeZone === 'UTC') {
	            return new Date(m.valueOf()); // make sure it's a copy
	        }
	        if (!this.namedTimeZoneImpl) {
	            return new Date(m.valueOf() - (forcedTzo || 0));
	        }
	        return new Date(m.valueOf() -
	            this.namedTimeZoneImpl.offsetForArray(dateToUtcArray(m)) * 1000 * 60);
	    };
	    return DateEnv;
	}());
	
	var globalLocales = [];
	
	var MINIMAL_RAW_EN_LOCALE = {
	    code: 'en',
	    week: {
	        dow: 0,
	        doy: 4, // 4 days need to be within the year to be considered the first week
	    },
	    direction: 'ltr',
	    buttonText: {
	        prev: 'prev',
	        next: 'next',
	        prevYear: 'prev year',
	        nextYear: 'next year',
	        year: 'year',
	        today: 'today',
	        month: 'month',
	        week: 'week',
	        day: 'day',
	        list: 'list',
	    },
	    weekText: 'W',
	    weekTextLong: 'Week',
	    closeHint: 'Close',
	    timeHint: 'Time',
	    eventHint: 'Event',
	    allDayText: 'all-day',
	    moreLinkText: 'more',
	    noEventsText: 'No events to display',
	};
	var RAW_EN_LOCALE = tslib.__assign(tslib.__assign({}, MINIMAL_RAW_EN_LOCALE), { 
	    // Includes things we don't want other locales to inherit,
	    // things that derive from other translatable strings.
	    buttonHints: {
	        prev: 'Previous $0',
	        next: 'Next $0',
	        today: function (buttonText, unit) {
	            return (unit === 'day')
	                ? 'Today'
	                : "This " + buttonText;
	        },
	    }, viewHint: '$0 view', navLinkHint: 'Go to $0', moreLinkHint: function (eventCnt) {
	        return "Show " + eventCnt + " more event" + (eventCnt === 1 ? '' : 's');
	    } });
	function organizeRawLocales(explicitRawLocales) {
	    var defaultCode = explicitRawLocales.length > 0 ? explicitRawLocales[0].code : 'en';
	    var allRawLocales = globalLocales.concat(explicitRawLocales);
	    var rawLocaleMap = {
	        en: RAW_EN_LOCALE,
	    };
	    for (var _i = 0, allRawLocales_1 = allRawLocales; _i < allRawLocales_1.length; _i++) {
	        var rawLocale = allRawLocales_1[_i];
	        rawLocaleMap[rawLocale.code] = rawLocale;
	    }
	    return {
	        map: rawLocaleMap,
	        defaultCode: defaultCode,
	    };
	}
	function buildLocale(inputSingular, available) {
	    if (typeof inputSingular === 'object' && !Array.isArray(inputSingular)) {
	        return parseLocale(inputSingular.code, [inputSingular.code], inputSingular);
	    }
	    return queryLocale(inputSingular, available);
	}
	function queryLocale(codeArg, available) {
	    var codes = [].concat(codeArg || []); // will convert to array
	    var raw = queryRawLocale(codes, available) || RAW_EN_LOCALE;
	    return parseLocale(codeArg, codes, raw);
	}
	function queryRawLocale(codes, available) {
	    for (var i = 0; i < codes.length; i += 1) {
	        var parts = codes[i].toLocaleLowerCase().split('-');
	        for (var j = parts.length; j > 0; j -= 1) {
	            var simpleId = parts.slice(0, j).join('-');
	            if (available[simpleId]) {
	                return available[simpleId];
	            }
	        }
	    }
	    return null;
	}
	function parseLocale(codeArg, codes, raw) {
	    var merged = mergeProps([MINIMAL_RAW_EN_LOCALE, raw], ['buttonText']);
	    delete merged.code; // don't want this part of the options
	    var week = merged.week;
	    delete merged.week;
	    return {
	        codeArg: codeArg,
	        codes: codes,
	        week: week,
	        simpleNumberFormat: new Intl.NumberFormat(codeArg),
	        options: merged,
	    };
	}
	
	function formatDate(dateInput, options) {
	    if (options === void 0) { options = {}; }
	    var dateEnv = buildDateEnv$1(options);
	    var formatter = createFormatter(options);
	    var dateMeta = dateEnv.createMarkerMeta(dateInput);
	    if (!dateMeta) { // TODO: warning?
	        return '';
	    }
	    return dateEnv.format(dateMeta.marker, formatter, {
	        forcedTzo: dateMeta.forcedTzo,
	    });
	}
	function formatRange(startInput, endInput, options) {
	    var dateEnv = buildDateEnv$1(typeof options === 'object' && options ? options : {}); // pass in if non-null object
	    var formatter = createFormatter(options);
	    var startMeta = dateEnv.createMarkerMeta(startInput);
	    var endMeta = dateEnv.createMarkerMeta(endInput);
	    if (!startMeta || !endMeta) { // TODO: warning?
	        return '';
	    }
	    return dateEnv.formatRange(startMeta.marker, endMeta.marker, formatter, {
	        forcedStartTzo: startMeta.forcedTzo,
	        forcedEndTzo: endMeta.forcedTzo,
	        isEndExclusive: options.isEndExclusive,
	        defaultSeparator: BASE_OPTION_DEFAULTS.defaultRangeSeparator,
	    });
	}
	// TODO: more DRY and optimized
	function buildDateEnv$1(settings) {
	    var locale = buildLocale(settings.locale || 'en', organizeRawLocales([]).map); // TODO: don't hardcode 'en' everywhere
	    return new DateEnv(tslib.__assign(tslib.__assign({ timeZone: BASE_OPTION_DEFAULTS.timeZone, calendarSystem: 'gregory' }, settings), { locale: locale }));
	}
	
	var DEF_DEFAULTS = {
	    startTime: '09:00',
	    endTime: '17:00',
	    daysOfWeek: [1, 2, 3, 4, 5],
	    display: 'inverse-background',
	    classNames: 'fc-non-business',
	    groupId: '_businessHours', // so multiple defs get grouped
	};
	/*
	TODO: pass around as EventDefHash!!!
	*/
	function parseBusinessHours(input, context) {
	    return parseEvents(refineInputs(input), null, context);
	}
	function refineInputs(input) {
	    var rawDefs;
	    if (input === true) {
	        rawDefs = [{}]; // will get DEF_DEFAULTS verbatim
	    }
	    else if (Array.isArray(input)) {
	        // if specifying an array, every sub-definition NEEDS a day-of-week
	        rawDefs = input.filter(function (rawDef) { return rawDef.daysOfWeek; });
	    }
	    else if (typeof input === 'object' && input) { // non-null object
	        rawDefs = [input];
	    }
	    else { // is probably false
	        rawDefs = [];
	    }
	    rawDefs = rawDefs.map(function (rawDef) { return (tslib.__assign(tslib.__assign({}, DEF_DEFAULTS), rawDef)); });
	    return rawDefs;
	}
	
	function pointInsideRect(point, rect) {
	    return point.left >= rect.left &&
	        point.left < rect.right &&
	        point.top >= rect.top &&
	        point.top < rect.bottom;
	}
	// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
	function intersectRects(rect1, rect2) {
	    var res = {
	        left: Math.max(rect1.left, rect2.left),
	        right: Math.min(rect1.right, rect2.right),
	        top: Math.max(rect1.top, rect2.top),
	        bottom: Math.min(rect1.bottom, rect2.bottom),
	    };
	    if (res.left < res.right && res.top < res.bottom) {
	        return res;
	    }
	    return false;
	}
	function translateRect(rect, deltaX, deltaY) {
	    return {
	        left: rect.left + deltaX,
	        right: rect.right + deltaX,
	        top: rect.top + deltaY,
	        bottom: rect.bottom + deltaY,
	    };
	}
	// Returns a new point that will have been moved to reside within the given rectangle
	function constrainPoint(point, rect) {
	    return {
	        left: Math.min(Math.max(point.left, rect.left), rect.right),
	        top: Math.min(Math.max(point.top, rect.top), rect.bottom),
	    };
	}
	// Returns a point that is the center of the given rectangle
	function getRectCenter(rect) {
	    return {
	        left: (rect.left + rect.right) / 2,
	        top: (rect.top + rect.bottom) / 2,
	    };
	}
	// Subtracts point2's coordinates from point1's coordinates, returning a delta
	function diffPoints(point1, point2) {
	    return {
	        left: point1.left - point2.left,
	        top: point1.top - point2.top,
	    };
	}
	
	var canVGrowWithinCell;
	function getCanVGrowWithinCell() {
	    if (canVGrowWithinCell == null) {
	        canVGrowWithinCell = computeCanVGrowWithinCell();
	    }
	    return canVGrowWithinCell;
	}
	function computeCanVGrowWithinCell() {
	    // for SSR, because this function is call immediately at top-level
	    // TODO: just make this logic execute top-level, immediately, instead of doing lazily
	    if (typeof document === 'undefined') {
	        return true;
	    }
	    var el = document.createElement('div');
	    el.style.position = 'absolute';
	    el.style.top = '0px';
	    el.style.left = '0px';
	    el.innerHTML = '<table><tr><td><div></div></td></tr></table>';
	    el.querySelector('table').style.height = '100px';
	    el.querySelector('div').style.height = '100%';
	    document.body.appendChild(el);
	    var div = el.querySelector('div');
	    var possible = div.offsetHeight > 0;
	    document.body.removeChild(el);
	    return possible;
	}
	
	var EMPTY_EVENT_STORE = createEmptyEventStore(); // for purecomponents. TODO: keep elsewhere
	var Splitter = /** @class */ (function () {
	    function Splitter() {
	        this.getKeysForEventDefs = memoize(this._getKeysForEventDefs);
	        this.splitDateSelection = memoize(this._splitDateSpan);
	        this.splitEventStore = memoize(this._splitEventStore);
	        this.splitIndividualUi = memoize(this._splitIndividualUi);
	        this.splitEventDrag = memoize(this._splitInteraction);
	        this.splitEventResize = memoize(this._splitInteraction);
	        this.eventUiBuilders = {}; // TODO: typescript protection
	    }
	    Splitter.prototype.splitProps = function (props) {
	        var _this = this;
	        var keyInfos = this.getKeyInfo(props);
	        var defKeys = this.getKeysForEventDefs(props.eventStore);
	        var dateSelections = this.splitDateSelection(props.dateSelection);
	        var individualUi = this.splitIndividualUi(props.eventUiBases, defKeys); // the individual *bases*
	        var eventStores = this.splitEventStore(props.eventStore, defKeys);
	        var eventDrags = this.splitEventDrag(props.eventDrag);
	        var eventResizes = this.splitEventResize(props.eventResize);
	        var splitProps = {};
	        this.eventUiBuilders = mapHash(keyInfos, function (info, key) { return _this.eventUiBuilders[key] || memoize(buildEventUiForKey); });
	        for (var key in keyInfos) {
	            var keyInfo = keyInfos[key];
	            var eventStore = eventStores[key] || EMPTY_EVENT_STORE;
	            var buildEventUi = this.eventUiBuilders[key];
	            splitProps[key] = {
	                businessHours: keyInfo.businessHours || props.businessHours,
	                dateSelection: dateSelections[key] || null,
	                eventStore: eventStore,
	                eventUiBases: buildEventUi(props.eventUiBases[''], keyInfo.ui, individualUi[key]),
	                eventSelection: eventStore.instances[props.eventSelection] ? props.eventSelection : '',
	                eventDrag: eventDrags[key] || null,
	                eventResize: eventResizes[key] || null,
	            };
	        }
	        return splitProps;
	    };
	    Splitter.prototype._splitDateSpan = function (dateSpan) {
	        var dateSpans = {};
	        if (dateSpan) {
	            var keys = this.getKeysForDateSpan(dateSpan);
	            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
	                var key = keys_1[_i];
	                dateSpans[key] = dateSpan;
	            }
	        }
	        return dateSpans;
	    };
	    Splitter.prototype._getKeysForEventDefs = function (eventStore) {
	        var _this = this;
	        return mapHash(eventStore.defs, function (eventDef) { return _this.getKeysForEventDef(eventDef); });
	    };
	    Splitter.prototype._splitEventStore = function (eventStore, defKeys) {
	        var defs = eventStore.defs, instances = eventStore.instances;
	        var splitStores = {};
	        for (var defId in defs) {
	            for (var _i = 0, _a = defKeys[defId]; _i < _a.length; _i++) {
	                var key = _a[_i];
	                if (!splitStores[key]) {
	                    splitStores[key] = createEmptyEventStore();
	                }
	                splitStores[key].defs[defId] = defs[defId];
	            }
	        }
	        for (var instanceId in instances) {
	            var instance = instances[instanceId];
	            for (var _b = 0, _c = defKeys[instance.defId]; _b < _c.length; _b++) {
	                var key = _c[_b];
	                if (splitStores[key]) { // must have already been created
	                    splitStores[key].instances[instanceId] = instance;
	                }
	            }
	        }
	        return splitStores;
	    };
	    Splitter.prototype._splitIndividualUi = function (eventUiBases, defKeys) {
	        var splitHashes = {};
	        for (var defId in eventUiBases) {
	            if (defId) { // not the '' key
	                for (var _i = 0, _a = defKeys[defId]; _i < _a.length; _i++) {
	                    var key = _a[_i];
	                    if (!splitHashes[key]) {
	                        splitHashes[key] = {};
	                    }
	                    splitHashes[key][defId] = eventUiBases[defId];
	                }
	            }
	        }
	        return splitHashes;
	    };
	    Splitter.prototype._splitInteraction = function (interaction) {
	        var splitStates = {};
	        if (interaction) {
	            var affectedStores_1 = this._splitEventStore(interaction.affectedEvents, this._getKeysForEventDefs(interaction.affectedEvents));
	            // can't rely on defKeys because event data is mutated
	            var mutatedKeysByDefId = this._getKeysForEventDefs(interaction.mutatedEvents);
	            var mutatedStores_1 = this._splitEventStore(interaction.mutatedEvents, mutatedKeysByDefId);
	            var populate = function (key) {
	                if (!splitStates[key]) {
	                    splitStates[key] = {
	                        affectedEvents: affectedStores_1[key] || EMPTY_EVENT_STORE,
	                        mutatedEvents: mutatedStores_1[key] || EMPTY_EVENT_STORE,
	                        isEvent: interaction.isEvent,
	                    };
	                }
	            };
	            for (var key in affectedStores_1) {
	                populate(key);
	            }
	            for (var key in mutatedStores_1) {
	                populate(key);
	            }
	        }
	        return splitStates;
	    };
	    return Splitter;
	}());
	function buildEventUiForKey(allUi, eventUiForKey, individualUi) {
	    var baseParts = [];
	    if (allUi) {
	        baseParts.push(allUi);
	    }
	    if (eventUiForKey) {
	        baseParts.push(eventUiForKey);
	    }
	    var stuff = {
	        '': combineEventUis(baseParts),
	    };
	    if (individualUi) {
	        tslib.__assign(stuff, individualUi);
	    }
	    return stuff;
	}
	
	function getDateMeta(date, todayRange, nowDate, dateProfile) {
	    return {
	        dow: date.getUTCDay(),
	        isDisabled: Boolean(dateProfile && !rangeContainsMarker(dateProfile.activeRange, date)),
	        isOther: Boolean(dateProfile && !rangeContainsMarker(dateProfile.currentRange, date)),
	        isToday: Boolean(todayRange && rangeContainsMarker(todayRange, date)),
	        isPast: Boolean(nowDate ? (date < nowDate) : todayRange ? (date < todayRange.start) : false),
	        isFuture: Boolean(nowDate ? (date > nowDate) : todayRange ? (date >= todayRange.end) : false),
	    };
	}
	function getDayClassNames(meta, theme) {
	    var classNames = [
	        'fc-day',
	        "fc-day-" + DAY_IDS[meta.dow],
	    ];
	    if (meta.isDisabled) {
	        classNames.push('fc-day-disabled');
	    }
	    else {
	        if (meta.isToday) {
	            classNames.push('fc-day-today');
	            classNames.push(theme.getClass('today'));
	        }
	        if (meta.isPast) {
	            classNames.push('fc-day-past');
	        }
	        if (meta.isFuture) {
	            classNames.push('fc-day-future');
	        }
	        if (meta.isOther) {
	            classNames.push('fc-day-other');
	        }
	    }
	    return classNames;
	}
	function getSlotClassNames(meta, theme) {
	    var classNames = [
	        'fc-slot',
	        "fc-slot-" + DAY_IDS[meta.dow],
	    ];
	    if (meta.isDisabled) {
	        classNames.push('fc-slot-disabled');
	    }
	    else {
	        if (meta.isToday) {
	            classNames.push('fc-slot-today');
	            classNames.push(theme.getClass('today'));
	        }
	        if (meta.isPast) {
	            classNames.push('fc-slot-past');
	        }
	        if (meta.isFuture) {
	            classNames.push('fc-slot-future');
	        }
	    }
	    return classNames;
	}
	
	var DAY_FORMAT = createFormatter({ year: 'numeric', month: 'long', day: 'numeric' });
	var WEEK_FORMAT = createFormatter({ week: 'long' });
	function buildNavLinkAttrs(context, dateMarker, viewType, isTabbable) {
	    if (viewType === void 0) { viewType = 'day'; }
	    if (isTabbable === void 0) { isTabbable = true; }
	    var dateEnv = context.dateEnv, options = context.options, calendarApi = context.calendarApi;
	    var dateStr = dateEnv.format(dateMarker, viewType === 'week' ? WEEK_FORMAT : DAY_FORMAT);
	    if (options.navLinks) {
	        var zonedDate = dateEnv.toDate(dateMarker);
	        var handleInteraction = function (ev) {
	            var customAction = viewType === 'day' ? options.navLinkDayClick :
	                viewType === 'week' ? options.navLinkWeekClick : null;
	            if (typeof customAction === 'function') {
	                customAction.call(calendarApi, dateEnv.toDate(dateMarker), ev);
	            }
	            else {
	                if (typeof customAction === 'string') {
	                    viewType = customAction;
	                }
	                calendarApi.zoomTo(dateMarker, viewType);
	            }
	        };
	        return tslib.__assign({ title: formatWithOrdinals(options.navLinkHint, [dateStr, zonedDate], dateStr), 'data-navlink': '' }, (isTabbable
	            ? createAriaClickAttrs(handleInteraction)
	            : { onClick: handleInteraction }));
	    }
	    return { 'aria-label': dateStr };
	}
	
	var _isRtlScrollbarOnLeft = null;
	function getIsRtlScrollbarOnLeft() {
	    if (_isRtlScrollbarOnLeft === null) {
	        _isRtlScrollbarOnLeft = computeIsRtlScrollbarOnLeft();
	    }
	    return _isRtlScrollbarOnLeft;
	}
	function computeIsRtlScrollbarOnLeft() {
	    var outerEl = document.createElement('div');
	    applyStyle(outerEl, {
	        position: 'absolute',
	        top: -1000,
	        left: 0,
	        border: 0,
	        padding: 0,
	        overflow: 'scroll',
	        direction: 'rtl',
	    });
	    outerEl.innerHTML = '<div></div>';
	    document.body.appendChild(outerEl);
	    var innerEl = outerEl.firstChild;
	    var res = innerEl.getBoundingClientRect().left > outerEl.getBoundingClientRect().left;
	    removeElement(outerEl);
	    return res;
	}
	
	var _scrollbarWidths;
	function getScrollbarWidths() {
	    if (!_scrollbarWidths) {
	        _scrollbarWidths = computeScrollbarWidths();
	    }
	    return _scrollbarWidths;
	}
	function computeScrollbarWidths() {
	    var el = document.createElement('div');
	    el.style.overflow = 'scroll';
	    el.style.position = 'absolute';
	    el.style.top = '-9999px';
	    el.style.left = '-9999px';
	    document.body.appendChild(el);
	    var res = computeScrollbarWidthsForEl(el);
	    document.body.removeChild(el);
	    return res;
	}
	// WARNING: will include border
	function computeScrollbarWidthsForEl(el) {
	    return {
	        x: el.offsetHeight - el.clientHeight,
	        y: el.offsetWidth - el.clientWidth,
	    };
	}
	
	function computeEdges(el, getPadding) {
	    if (getPadding === void 0) { getPadding = false; }
	    var computedStyle = window.getComputedStyle(el);
	    var borderLeft = parseInt(computedStyle.borderLeftWidth, 10) || 0;
	    var borderRight = parseInt(computedStyle.borderRightWidth, 10) || 0;
	    var borderTop = parseInt(computedStyle.borderTopWidth, 10) || 0;
	    var borderBottom = parseInt(computedStyle.borderBottomWidth, 10) || 0;
	    var badScrollbarWidths = computeScrollbarWidthsForEl(el); // includes border!
	    var scrollbarLeftRight = badScrollbarWidths.y - borderLeft - borderRight;
	    var scrollbarBottom = badScrollbarWidths.x - borderTop - borderBottom;
	    var res = {
	        borderLeft: borderLeft,
	        borderRight: borderRight,
	        borderTop: borderTop,
	        borderBottom: borderBottom,
	        scrollbarBottom: scrollbarBottom,
	        scrollbarLeft: 0,
	        scrollbarRight: 0,
	    };
	    if (getIsRtlScrollbarOnLeft() && computedStyle.direction === 'rtl') { // is the scrollbar on the left side?
	        res.scrollbarLeft = scrollbarLeftRight;
	    }
	    else {
	        res.scrollbarRight = scrollbarLeftRight;
	    }
	    if (getPadding) {
	        res.paddingLeft = parseInt(computedStyle.paddingLeft, 10) || 0;
	        res.paddingRight = parseInt(computedStyle.paddingRight, 10) || 0;
	        res.paddingTop = parseInt(computedStyle.paddingTop, 10) || 0;
	        res.paddingBottom = parseInt(computedStyle.paddingBottom, 10) || 0;
	    }
	    return res;
	}
	function computeInnerRect(el, goWithinPadding, doFromWindowViewport) {
	    if (goWithinPadding === void 0) { goWithinPadding = false; }
	    var outerRect = doFromWindowViewport ? el.getBoundingClientRect() : computeRect(el);
	    var edges = computeEdges(el, goWithinPadding);
	    var res = {
	        left: outerRect.left + edges.borderLeft + edges.scrollbarLeft,
	        right: outerRect.right - edges.borderRight - edges.scrollbarRight,
	        top: outerRect.top + edges.borderTop,
	        bottom: outerRect.bottom - edges.borderBottom - edges.scrollbarBottom,
	    };
	    if (goWithinPadding) {
	        res.left += edges.paddingLeft;
	        res.right -= edges.paddingRight;
	        res.top += edges.paddingTop;
	        res.bottom -= edges.paddingBottom;
	    }
	    return res;
	}
	function computeRect(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	        left: rect.left + window.pageXOffset,
	        top: rect.top + window.pageYOffset,
	        right: rect.right + window.pageXOffset,
	        bottom: rect.bottom + window.pageYOffset,
	    };
	}
	function computeClippedClientRect(el) {
	    var clippingParents = getClippingParents(el);
	    var rect = el.getBoundingClientRect();
	    for (var _i = 0, clippingParents_1 = clippingParents; _i < clippingParents_1.length; _i++) {
	        var clippingParent = clippingParents_1[_i];
	        var intersection = intersectRects(rect, clippingParent.getBoundingClientRect());
	        if (intersection) {
	            rect = intersection;
	        }
	        else {
	            return null;
	        }
	    }
	    return rect;
	}
	function computeHeightAndMargins(el) {
	    return el.getBoundingClientRect().height + computeVMargins(el);
	}
	function computeVMargins(el) {
	    var computed = window.getComputedStyle(el);
	    return parseInt(computed.marginTop, 10) +
	        parseInt(computed.marginBottom, 10);
	}
	// does not return window
	function getClippingParents(el) {
	    var parents = [];
	    while (el instanceof HTMLElement) { // will stop when gets to document or null
	        var computedStyle = window.getComputedStyle(el);
	        if (computedStyle.position === 'fixed') {
	            break;
	        }
	        if ((/(auto|scroll)/).test(computedStyle.overflow + computedStyle.overflowY + computedStyle.overflowX)) {
	            parents.push(el);
	        }
	        el = el.parentNode;
	    }
	    return parents;
	}
	
	// given a function that resolves a result asynchronously.
	// the function can either call passed-in success and failure callbacks,
	// or it can return a promise.
	// if you need to pass additional params to func, bind them first.
	function unpromisify(func, success, failure) {
	    // guard against success/failure callbacks being called more than once
	    // and guard against a promise AND callback being used together.
	    var isResolved = false;
	    var wrappedSuccess = function () {
	        if (!isResolved) {
	            isResolved = true;
	            success.apply(this, arguments); // eslint-disable-line prefer-rest-params
	        }
	    };
	    var wrappedFailure = function () {
	        if (!isResolved) {
	            isResolved = true;
	            if (failure) {
	                failure.apply(this, arguments); // eslint-disable-line prefer-rest-params
	            }
	        }
	    };
	    var res = func(wrappedSuccess, wrappedFailure);
	    if (res && typeof res.then === 'function') {
	        res.then(wrappedSuccess, wrappedFailure);
	    }
	}
	
	var Emitter = /** @class */ (function () {
	    function Emitter() {
	        this.handlers = {};
	        this.thisContext = null;
	    }
	    Emitter.prototype.setThisContext = function (thisContext) {
	        this.thisContext = thisContext;
	    };
	    Emitter.prototype.setOptions = function (options) {
	        this.options = options;
	    };
	    Emitter.prototype.on = function (type, handler) {
	        addToHash(this.handlers, type, handler);
	    };
	    Emitter.prototype.off = function (type, handler) {
	        removeFromHash(this.handlers, type, handler);
	    };
	    Emitter.prototype.trigger = function (type) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var attachedHandlers = this.handlers[type] || [];
	        var optionHandler = this.options && this.options[type];
	        var handlers = [].concat(optionHandler || [], attachedHandlers);
	        for (var _a = 0, handlers_1 = handlers; _a < handlers_1.length; _a++) {
	            var handler = handlers_1[_a];
	            handler.apply(this.thisContext, args);
	        }
	    };
	    Emitter.prototype.hasHandlers = function (type) {
	        return Boolean((this.handlers[type] && this.handlers[type].length) ||
	            (this.options && this.options[type]));
	    };
	    return Emitter;
	}());
	function addToHash(hash, type, handler) {
	    (hash[type] || (hash[type] = []))
	        .push(handler);
	}
	function removeFromHash(hash, type, handler) {
	    if (handler) {
	        if (hash[type]) {
	            hash[type] = hash[type].filter(function (func) { return func !== handler; });
	        }
	    }
	    else {
	        delete hash[type]; // remove all handler funcs for this type
	    }
	}
	
	/*
	Records offset information for a set of elements, relative to an origin element.
	Can record the left/right OR the top/bottom OR both.
	Provides methods for querying the cache by position.
	*/
	var PositionCache = /** @class */ (function () {
	    function PositionCache(originEl, els, isHorizontal, isVertical) {
	        this.els = els;
	        var originClientRect = this.originClientRect = originEl.getBoundingClientRect(); // relative to viewport top-left
	        if (isHorizontal) {
	            this.buildElHorizontals(originClientRect.left);
	        }
	        if (isVertical) {
	            this.buildElVerticals(originClientRect.top);
	        }
	    }
	    // Populates the left/right internal coordinate arrays
	    PositionCache.prototype.buildElHorizontals = function (originClientLeft) {
	        var lefts = [];
	        var rights = [];
	        for (var _i = 0, _a = this.els; _i < _a.length; _i++) {
	            var el = _a[_i];
	            var rect = el.getBoundingClientRect();
	            lefts.push(rect.left - originClientLeft);
	            rights.push(rect.right - originClientLeft);
	        }
	        this.lefts = lefts;
	        this.rights = rights;
	    };
	    // Populates the top/bottom internal coordinate arrays
	    PositionCache.prototype.buildElVerticals = function (originClientTop) {
	        var tops = [];
	        var bottoms = [];
	        for (var _i = 0, _a = this.els; _i < _a.length; _i++) {
	            var el = _a[_i];
	            var rect = el.getBoundingClientRect();
	            tops.push(rect.top - originClientTop);
	            bottoms.push(rect.bottom - originClientTop);
	        }
	        this.tops = tops;
	        this.bottoms = bottoms;
	    };
	    // Given a left offset (from document left), returns the index of the el that it horizontally intersects.
	    // If no intersection is made, returns undefined.
	    PositionCache.prototype.leftToIndex = function (leftPosition) {
	        var _a = this, lefts = _a.lefts, rights = _a.rights;
	        var len = lefts.length;
	        var i;
	        for (i = 0; i < len; i += 1) {
	            if (leftPosition >= lefts[i] && leftPosition < rights[i]) {
	                return i;
	            }
	        }
	        return undefined; // TODO: better
	    };
	    // Given a top offset (from document top), returns the index of the el that it vertically intersects.
	    // If no intersection is made, returns undefined.
	    PositionCache.prototype.topToIndex = function (topPosition) {
	        var _a = this, tops = _a.tops, bottoms = _a.bottoms;
	        var len = tops.length;
	        var i;
	        for (i = 0; i < len; i += 1) {
	            if (topPosition >= tops[i] && topPosition < bottoms[i]) {
	                return i;
	            }
	        }
	        return undefined; // TODO: better
	    };
	    // Gets the width of the element at the given index
	    PositionCache.prototype.getWidth = function (leftIndex) {
	        return this.rights[leftIndex] - this.lefts[leftIndex];
	    };
	    // Gets the height of the element at the given index
	    PositionCache.prototype.getHeight = function (topIndex) {
	        return this.bottoms[topIndex] - this.tops[topIndex];
	    };
	    return PositionCache;
	}());
	
	/* eslint max-classes-per-file: "off" */
	/*
	An object for getting/setting scroll-related information for an element.
	Internally, this is done very differently for window versus DOM element,
	so this object serves as a common interface.
	*/
	var ScrollController = /** @class */ (function () {
	    function ScrollController() {
	    }
	    ScrollController.prototype.getMaxScrollTop = function () {
	        return this.getScrollHeight() - this.getClientHeight();
	    };
	    ScrollController.prototype.getMaxScrollLeft = function () {
	        return this.getScrollWidth() - this.getClientWidth();
	    };
	    ScrollController.prototype.canScrollVertically = function () {
	        return this.getMaxScrollTop() > 0;
	    };
	    ScrollController.prototype.canScrollHorizontally = function () {
	        return this.getMaxScrollLeft() > 0;
	    };
	    ScrollController.prototype.canScrollUp = function () {
	        return this.getScrollTop() > 0;
	    };
	    ScrollController.prototype.canScrollDown = function () {
	        return this.getScrollTop() < this.getMaxScrollTop();
	    };
	    ScrollController.prototype.canScrollLeft = function () {
	        return this.getScrollLeft() > 0;
	    };
	    ScrollController.prototype.canScrollRight = function () {
	        return this.getScrollLeft() < this.getMaxScrollLeft();
	    };
	    return ScrollController;
	}());
	var ElementScrollController = /** @class */ (function (_super) {
	    tslib.__extends(ElementScrollController, _super);
	    function ElementScrollController(el) {
	        var _this = _super.call(this) || this;
	        _this.el = el;
	        return _this;
	    }
	    ElementScrollController.prototype.getScrollTop = function () {
	        return this.el.scrollTop;
	    };
	    ElementScrollController.prototype.getScrollLeft = function () {
	        return this.el.scrollLeft;
	    };
	    ElementScrollController.prototype.setScrollTop = function (top) {
	        this.el.scrollTop = top;
	    };
	    ElementScrollController.prototype.setScrollLeft = function (left) {
	        this.el.scrollLeft = left;
	    };
	    ElementScrollController.prototype.getScrollWidth = function () {
	        return this.el.scrollWidth;
	    };
	    ElementScrollController.prototype.getScrollHeight = function () {
	        return this.el.scrollHeight;
	    };
	    ElementScrollController.prototype.getClientHeight = function () {
	        return this.el.clientHeight;
	    };
	    ElementScrollController.prototype.getClientWidth = function () {
	        return this.el.clientWidth;
	    };
	    return ElementScrollController;
	}(ScrollController));
	var WindowScrollController = /** @class */ (function (_super) {
	    tslib.__extends(WindowScrollController, _super);
	    function WindowScrollController() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    WindowScrollController.prototype.getScrollTop = function () {
	        return window.pageYOffset;
	    };
	    WindowScrollController.prototype.getScrollLeft = function () {
	        return window.pageXOffset;
	    };
	    WindowScrollController.prototype.setScrollTop = function (n) {
	        window.scroll(window.pageXOffset, n);
	    };
	    WindowScrollController.prototype.setScrollLeft = function (n) {
	        window.scroll(n, window.pageYOffset);
	    };
	    WindowScrollController.prototype.getScrollWidth = function () {
	        return document.documentElement.scrollWidth;
	    };
	    WindowScrollController.prototype.getScrollHeight = function () {
	        return document.documentElement.scrollHeight;
	    };
	    WindowScrollController.prototype.getClientHeight = function () {
	        return document.documentElement.clientHeight;
	    };
	    WindowScrollController.prototype.getClientWidth = function () {
	        return document.documentElement.clientWidth;
	    };
	    return WindowScrollController;
	}(ScrollController));
	
	var Theme = /** @class */ (function () {
	    function Theme(calendarOptions) {
	        if (this.iconOverrideOption) {
	            this.setIconOverride(calendarOptions[this.iconOverrideOption]);
	        }
	    }
	    Theme.prototype.setIconOverride = function (iconOverrideHash) {
	        var iconClassesCopy;
	        var buttonName;
	        if (typeof iconOverrideHash === 'object' && iconOverrideHash) { // non-null object
	            iconClassesCopy = tslib.__assign({}, this.iconClasses);
	            for (buttonName in iconOverrideHash) {
	                iconClassesCopy[buttonName] = this.applyIconOverridePrefix(iconOverrideHash[buttonName]);
	            }
	            this.iconClasses = iconClassesCopy;
	        }
	        else if (iconOverrideHash === false) {
	            this.iconClasses = {};
	        }
	    };
	    Theme.prototype.applyIconOverridePrefix = function (className) {
	        var prefix = this.iconOverridePrefix;
	        if (prefix && className.indexOf(prefix) !== 0) { // if not already present
	            className = prefix + className;
	        }
	        return className;
	    };
	    Theme.prototype.getClass = function (key) {
	        return this.classes[key] || '';
	    };
	    Theme.prototype.getIconClass = function (buttonName, isRtl) {
	        var className;
	        if (isRtl && this.rtlIconClasses) {
	            className = this.rtlIconClasses[buttonName] || this.iconClasses[buttonName];
	        }
	        else {
	            className = this.iconClasses[buttonName];
	        }
	        if (className) {
	            return this.baseIconClass + " " + className;
	        }
	        return '';
	    };
	    Theme.prototype.getCustomButtonIconClass = function (customButtonProps) {
	        var className;
	        if (this.iconOverrideCustomButtonOption) {
	            className = customButtonProps[this.iconOverrideCustomButtonOption];
	            if (className) {
	                return this.baseIconClass + " " + this.applyIconOverridePrefix(className);
	            }
	        }
	        return '';
	    };
	    return Theme;
	}());
	Theme.prototype.classes = {};
	Theme.prototype.iconClasses = {};
	Theme.prototype.baseIconClass = '';
	Theme.prototype.iconOverridePrefix = '';
	
	var ScrollResponder = /** @class */ (function () {
	    function ScrollResponder(execFunc, emitter, scrollTime, scrollTimeReset) {
	        var _this = this;
	        this.execFunc = execFunc;
	        this.emitter = emitter;
	        this.scrollTime = scrollTime;
	        this.scrollTimeReset = scrollTimeReset;
	        this.handleScrollRequest = function (request) {
	            _this.queuedRequest = tslib.__assign({}, _this.queuedRequest || {}, request);
	            _this.drain();
	        };
	        emitter.on('_scrollRequest', this.handleScrollRequest);
	        this.fireInitialScroll();
	    }
	    ScrollResponder.prototype.detach = function () {
	        this.emitter.off('_scrollRequest', this.handleScrollRequest);
	    };
	    ScrollResponder.prototype.update = function (isDatesNew) {
	        if (isDatesNew && this.scrollTimeReset) {
	            this.fireInitialScroll(); // will drain
	        }
	        else {
	            this.drain();
	        }
	    };
	    ScrollResponder.prototype.fireInitialScroll = function () {
	        this.handleScrollRequest({
	            time: this.scrollTime,
	        });
	    };
	    ScrollResponder.prototype.drain = function () {
	        if (this.queuedRequest && this.execFunc(this.queuedRequest)) {
	            this.queuedRequest = null;
	        }
	    };
	    return ScrollResponder;
	}());
	
	var ViewContextType = vdom_cjs.createContext({}); // for Components
	function buildViewContext(viewSpec, viewApi, viewOptions, dateProfileGenerator, dateEnv, theme, pluginHooks, dispatch, getCurrentData, emitter, calendarApi, registerInteractiveComponent, unregisterInteractiveComponent) {
	    return {
	        dateEnv: dateEnv,
	        options: viewOptions,
	        pluginHooks: pluginHooks,
	        emitter: emitter,
	        dispatch: dispatch,
	        getCurrentData: getCurrentData,
	        calendarApi: calendarApi,
	        viewSpec: viewSpec,
	        viewApi: viewApi,
	        dateProfileGenerator: dateProfileGenerator,
	        theme: theme,
	        isRtl: viewOptions.direction === 'rtl',
	        addResizeHandler: function (handler) {
	            emitter.on('_resize', handler);
	        },
	        removeResizeHandler: function (handler) {
	            emitter.off('_resize', handler);
	        },
	        createScrollResponder: function (execFunc) {
	            return new ScrollResponder(execFunc, emitter, createDuration(viewOptions.scrollTime), viewOptions.scrollTimeReset);
	        },
	        registerInteractiveComponent: registerInteractiveComponent,
	        unregisterInteractiveComponent: unregisterInteractiveComponent,
	    };
	}
	
	/* eslint max-classes-per-file: off */
	var PureComponent = /** @class */ (function (_super) {
	    tslib.__extends(PureComponent, _super);
	    function PureComponent() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    PureComponent.prototype.shouldComponentUpdate = function (nextProps, nextState) {
	        if (this.debug) {
	            // eslint-disable-next-line no-console
	            console.log(getUnequalProps(nextProps, this.props), getUnequalProps(nextState, this.state));
	        }
	        return !compareObjs(this.props, nextProps, this.propEquality) ||
	            !compareObjs(this.state, nextState, this.stateEquality);
	    };
	    // HACK for freakin' React StrictMode
	    PureComponent.prototype.safeSetState = function (newState) {
	        if (!compareObjs(this.state, tslib.__assign(tslib.__assign({}, this.state), newState), this.stateEquality)) {
	            this.setState(newState);
	        }
	    };
	    PureComponent.addPropsEquality = addPropsEquality;
	    PureComponent.addStateEquality = addStateEquality;
	    PureComponent.contextType = ViewContextType;
	    return PureComponent;
	}(vdom_cjs.Component));
	PureComponent.prototype.propEquality = {};
	PureComponent.prototype.stateEquality = {};
	var BaseComponent = /** @class */ (function (_super) {
	    tslib.__extends(BaseComponent, _super);
	    function BaseComponent() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BaseComponent.contextType = ViewContextType;
	    return BaseComponent;
	}(PureComponent));
	function addPropsEquality(propEquality) {
	    var hash = Object.create(this.prototype.propEquality);
	    tslib.__assign(hash, propEquality);
	    this.prototype.propEquality = hash;
	}
	function addStateEquality(stateEquality) {
	    var hash = Object.create(this.prototype.stateEquality);
	    tslib.__assign(hash, stateEquality);
	    this.prototype.stateEquality = hash;
	}
	// use other one
	function setRef(ref, current) {
	    if (typeof ref === 'function') {
	        ref(current);
	    }
	    else if (ref) {
	        // see https://github.com/facebook/react/issues/13029
	        ref.current = current;
	    }
	}
	
	/*
	an INTERACTABLE date component
	
	PURPOSES:
	- hook up to fg, fill, and mirror renderers
	- interface for dragging and hits
	*/
	var DateComponent = /** @class */ (function (_super) {
	    tslib.__extends(DateComponent, _super);
	    function DateComponent() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.uid = guid();
	        return _this;
	    }
	    // Hit System
	    // -----------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.prepareHits = function () {
	    };
	    DateComponent.prototype.queryHit = function (positionLeft, positionTop, elWidth, elHeight) {
	        return null; // this should be abstract
	    };
	    // Pointer Interaction Utils
	    // -----------------------------------------------------------------------------------------------------------------
	    DateComponent.prototype.isValidSegDownEl = function (el) {
	        return !this.props.eventDrag && // HACK
	            !this.props.eventResize && // HACK
	            !elementClosest(el, '.fc-event-mirror');
	    };
	    DateComponent.prototype.isValidDateDownEl = function (el) {
	        return !elementClosest(el, '.fc-event:not(.fc-bg-event)') &&
	            !elementClosest(el, '.fc-more-link') && // a "more.." link
	            !elementClosest(el, 'a[data-navlink]') && // a clickable nav link
	            !elementClosest(el, '.fc-popover'); // hack
	    };
	    return DateComponent;
	}(BaseComponent));
	
	// TODO: easier way to add new hooks? need to update a million things
	function createPlugin(input) {
	    return {
	        id: guid(),
	        deps: input.deps || [],
	        reducers: input.reducers || [],
	        isLoadingFuncs: input.isLoadingFuncs || [],
	        contextInit: [].concat(input.contextInit || []),
	        eventRefiners: input.eventRefiners || {},
	        eventDefMemberAdders: input.eventDefMemberAdders || [],
	        eventSourceRefiners: input.eventSourceRefiners || {},
	        isDraggableTransformers: input.isDraggableTransformers || [],
	        eventDragMutationMassagers: input.eventDragMutationMassagers || [],
	        eventDefMutationAppliers: input.eventDefMutationAppliers || [],
	        dateSelectionTransformers: input.dateSelectionTransformers || [],
	        datePointTransforms: input.datePointTransforms || [],
	        dateSpanTransforms: input.dateSpanTransforms || [],
	        views: input.views || {},
	        viewPropsTransformers: input.viewPropsTransformers || [],
	        isPropsValid: input.isPropsValid || null,
	        externalDefTransforms: input.externalDefTransforms || [],
	        viewContainerAppends: input.viewContainerAppends || [],
	        eventDropTransformers: input.eventDropTransformers || [],
	        componentInteractions: input.componentInteractions || [],
	        calendarInteractions: input.calendarInteractions || [],
	        themeClasses: input.themeClasses || {},
	        eventSourceDefs: input.eventSourceDefs || [],
	        cmdFormatter: input.cmdFormatter,
	        recurringTypes: input.recurringTypes || [],
	        namedTimeZonedImpl: input.namedTimeZonedImpl,
	        initialView: input.initialView || '',
	        elementDraggingImpl: input.elementDraggingImpl,
	        optionChangeHandlers: input.optionChangeHandlers || {},
	        scrollGridImpl: input.scrollGridImpl || null,
	        contentTypeHandlers: input.contentTypeHandlers || {},
	        listenerRefiners: input.listenerRefiners || {},
	        optionRefiners: input.optionRefiners || {},
	        propSetHandlers: input.propSetHandlers || {},
	    };
	}
	function buildPluginHooks(pluginDefs, globalDefs) {
	    var isAdded = {};
	    var hooks = {
	        reducers: [],
	        isLoadingFuncs: [],
	        contextInit: [],
	        eventRefiners: {},
	        eventDefMemberAdders: [],
	        eventSourceRefiners: {},
	        isDraggableTransformers: [],
	        eventDragMutationMassagers: [],
	        eventDefMutationAppliers: [],
	        dateSelectionTransformers: [],
	        datePointTransforms: [],
	        dateSpanTransforms: [],
	        views: {},
	        viewPropsTransformers: [],
	        isPropsValid: null,
	        externalDefTransforms: [],
	        viewContainerAppends: [],
	        eventDropTransformers: [],
	        componentInteractions: [],
	        calendarInteractions: [],
	        themeClasses: {},
	        eventSourceDefs: [],
	        cmdFormatter: null,
	        recurringTypes: [],
	        namedTimeZonedImpl: null,
	        initialView: '',
	        elementDraggingImpl: null,
	        optionChangeHandlers: {},
	        scrollGridImpl: null,
	        contentTypeHandlers: {},
	        listenerRefiners: {},
	        optionRefiners: {},
	        propSetHandlers: {},
	    };
	    function addDefs(defs) {
	        for (var _i = 0, defs_1 = defs; _i < defs_1.length; _i++) {
	            var def = defs_1[_i];
	            if (!isAdded[def.id]) {
	                isAdded[def.id] = true;
	                addDefs(def.deps);
	                hooks = combineHooks(hooks, def);
	            }
	        }
	    }
	    if (pluginDefs) {
	        addDefs(pluginDefs);
	    }
	    addDefs(globalDefs);
	    return hooks;
	}
	function buildBuildPluginHooks() {
	    var currentOverrideDefs = [];
	    var currentGlobalDefs = [];
	    var currentHooks;
	    return function (overrideDefs, globalDefs) {
	        if (!currentHooks || !isArraysEqual(overrideDefs, currentOverrideDefs) || !isArraysEqual(globalDefs, currentGlobalDefs)) {
	            currentHooks = buildPluginHooks(overrideDefs, globalDefs);
	        }
	        currentOverrideDefs = overrideDefs;
	        currentGlobalDefs = globalDefs;
	        return currentHooks;
	    };
	}
	function combineHooks(hooks0, hooks1) {
	    return {
	        reducers: hooks0.reducers.concat(hooks1.reducers),
	        isLoadingFuncs: hooks0.isLoadingFuncs.concat(hooks1.isLoadingFuncs),
	        contextInit: hooks0.contextInit.concat(hooks1.contextInit),
	        eventRefiners: tslib.__assign(tslib.__assign({}, hooks0.eventRefiners), hooks1.eventRefiners),
	        eventDefMemberAdders: hooks0.eventDefMemberAdders.concat(hooks1.eventDefMemberAdders),
	        eventSourceRefiners: tslib.__assign(tslib.__assign({}, hooks0.eventSourceRefiners), hooks1.eventSourceRefiners),
	        isDraggableTransformers: hooks0.isDraggableTransformers.concat(hooks1.isDraggableTransformers),
	        eventDragMutationMassagers: hooks0.eventDragMutationMassagers.concat(hooks1.eventDragMutationMassagers),
	        eventDefMutationAppliers: hooks0.eventDefMutationAppliers.concat(hooks1.eventDefMutationAppliers),
	        dateSelectionTransformers: hooks0.dateSelectionTransformers.concat(hooks1.dateSelectionTransformers),
	        datePointTransforms: hooks0.datePointTransforms.concat(hooks1.datePointTransforms),
	        dateSpanTransforms: hooks0.dateSpanTransforms.concat(hooks1.dateSpanTransforms),
	        views: tslib.__assign(tslib.__assign({}, hooks0.views), hooks1.views),
	        viewPropsTransformers: hooks0.viewPropsTransformers.concat(hooks1.viewPropsTransformers),
	        isPropsValid: hooks1.isPropsValid || hooks0.isPropsValid,
	        externalDefTransforms: hooks0.externalDefTransforms.concat(hooks1.externalDefTransforms),
	        viewContainerAppends: hooks0.viewContainerAppends.concat(hooks1.viewContainerAppends),
	        eventDropTransformers: hooks0.eventDropTransformers.concat(hooks1.eventDropTransformers),
	        calendarInteractions: hooks0.calendarInteractions.concat(hooks1.calendarInteractions),
	        componentInteractions: hooks0.componentInteractions.concat(hooks1.componentInteractions),
	        themeClasses: tslib.__assign(tslib.__assign({}, hooks0.themeClasses), hooks1.themeClasses),
	        eventSourceDefs: hooks0.eventSourceDefs.concat(hooks1.eventSourceDefs),
	        cmdFormatter: hooks1.cmdFormatter || hooks0.cmdFormatter,
	        recurringTypes: hooks0.recurringTypes.concat(hooks1.recurringTypes),
	        namedTimeZonedImpl: hooks1.namedTimeZonedImpl || hooks0.namedTimeZonedImpl,
	        initialView: hooks0.initialView || hooks1.initialView,
	        elementDraggingImpl: hooks0.elementDraggingImpl || hooks1.elementDraggingImpl,
	        optionChangeHandlers: tslib.__assign(tslib.__assign({}, hooks0.optionChangeHandlers), hooks1.optionChangeHandlers),
	        scrollGridImpl: hooks1.scrollGridImpl || hooks0.scrollGridImpl,
	        contentTypeHandlers: tslib.__assign(tslib.__assign({}, hooks0.contentTypeHandlers), hooks1.contentTypeHandlers),
	        listenerRefiners: tslib.__assign(tslib.__assign({}, hooks0.listenerRefiners), hooks1.listenerRefiners),
	        optionRefiners: tslib.__assign(tslib.__assign({}, hooks0.optionRefiners), hooks1.optionRefiners),
	        propSetHandlers: tslib.__assign(tslib.__assign({}, hooks0.propSetHandlers), hooks1.propSetHandlers),
	    };
	}
	
	var StandardTheme = /** @class */ (function (_super) {
	    tslib.__extends(StandardTheme, _super);
	    function StandardTheme() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    return StandardTheme;
	}(Theme));
	StandardTheme.prototype.classes = {
	    root: 'fc-theme-standard',
	    tableCellShaded: 'fc-cell-shaded',
	    buttonGroup: 'fc-button-group',
	    button: 'fc-button fc-button-primary',
	    buttonActive: 'fc-button-active',
	};
	StandardTheme.prototype.baseIconClass = 'fc-icon';
	StandardTheme.prototype.iconClasses = {
	    close: 'fc-icon-x',
	    prev: 'fc-icon-chevron-left',
	    next: 'fc-icon-chevron-right',
	    prevYear: 'fc-icon-chevrons-left',
	    nextYear: 'fc-icon-chevrons-right',
	};
	StandardTheme.prototype.rtlIconClasses = {
	    prev: 'fc-icon-chevron-right',
	    next: 'fc-icon-chevron-left',
	    prevYear: 'fc-icon-chevrons-right',
	    nextYear: 'fc-icon-chevrons-left',
	};
	StandardTheme.prototype.iconOverrideOption = 'buttonIcons'; // TODO: make TS-friendly
	StandardTheme.prototype.iconOverrideCustomButtonOption = 'icon';
	StandardTheme.prototype.iconOverridePrefix = 'fc-icon-';
	
	function compileViewDefs(defaultConfigs, overrideConfigs) {
	    var hash = {};
	    var viewType;
	    for (viewType in defaultConfigs) {
	        ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
	    }
	    for (viewType in overrideConfigs) {
	        ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs);
	    }
	    return hash;
	}
	function ensureViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
	    if (hash[viewType]) {
	        return hash[viewType];
	    }
	    var viewDef = buildViewDef(viewType, hash, defaultConfigs, overrideConfigs);
	    if (viewDef) {
	        hash[viewType] = viewDef;
	    }
	    return viewDef;
	}
	function buildViewDef(viewType, hash, defaultConfigs, overrideConfigs) {
	    var defaultConfig = defaultConfigs[viewType];
	    var overrideConfig = overrideConfigs[viewType];
	    var queryProp = function (name) { return ((defaultConfig && defaultConfig[name] !== null) ? defaultConfig[name] :
	        ((overrideConfig && overrideConfig[name] !== null) ? overrideConfig[name] : null)); };
	    var theComponent = queryProp('component');
	    var superType = queryProp('superType');
	    var superDef = null;
	    if (superType) {
	        if (superType === viewType) {
	            throw new Error('Can\'t have a custom view type that references itself');
	        }
	        superDef = ensureViewDef(superType, hash, defaultConfigs, overrideConfigs);
	    }
	    if (!theComponent && superDef) {
	        theComponent = superDef.component;
	    }
	    if (!theComponent) {
	        return null; // don't throw a warning, might be settings for a single-unit view
	    }
	    return {
	        type: viewType,
	        component: theComponent,
	        defaults: tslib.__assign(tslib.__assign({}, (superDef ? superDef.defaults : {})), (defaultConfig ? defaultConfig.rawOptions : {})),
	        overrides: tslib.__assign(tslib.__assign({}, (superDef ? superDef.overrides : {})), (overrideConfig ? overrideConfig.rawOptions : {})),
	    };
	}
	
	/* eslint max-classes-per-file: off */
	// NOTE: in JSX, you should always use this class with <HookProps> arg. otherwise, will default to any???
	var RenderHook = /** @class */ (function (_super) {
	    tslib.__extends(RenderHook, _super);
	    function RenderHook() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.rootElRef = vdom_cjs.createRef();
	        _this.handleRootEl = function (el) {
	            setRef(_this.rootElRef, el);
	            if (_this.props.elRef) {
	                setRef(_this.props.elRef, el);
	            }
	        };
	        return _this;
	    }
	    RenderHook.prototype.render = function () {
	        var _this = this;
	        var props = this.props;
	        var hookProps = props.hookProps;
	        return (vdom_cjs.createElement(MountHook, { hookProps: hookProps, didMount: props.didMount, willUnmount: props.willUnmount, elRef: this.handleRootEl }, function (rootElRef) { return (vdom_cjs.createElement(ContentHook, { hookProps: hookProps, content: props.content, defaultContent: props.defaultContent, backupElRef: _this.rootElRef }, function (innerElRef, innerContent) { return props.children(rootElRef, normalizeClassNames(props.classNames, hookProps), innerElRef, innerContent); })); }));
	    };
	    return RenderHook;
	}(BaseComponent));
	// TODO: rename to be about function, not default. use in above type
	// for forcing rerender of components that use the ContentHook
	var CustomContentRenderContext = vdom_cjs.createContext(0);
	function ContentHook(props) {
	    return (vdom_cjs.createElement(CustomContentRenderContext.Consumer, null, function (renderId) { return (vdom_cjs.createElement(ContentHookInner, tslib.__assign({ renderId: renderId }, props))); }));
	}
	var ContentHookInner = /** @class */ (function (_super) {
	    tslib.__extends(ContentHookInner, _super);
	    function ContentHookInner() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.innerElRef = vdom_cjs.createRef();
	        return _this;
	    }
	    ContentHookInner.prototype.render = function () {
	        return this.props.children(this.innerElRef, this.renderInnerContent());
	    };
	    ContentHookInner.prototype.componentDidMount = function () {
	        this.updateCustomContent();
	    };
	    ContentHookInner.prototype.componentDidUpdate = function () {
	        this.updateCustomContent();
	    };
	    ContentHookInner.prototype.componentWillUnmount = function () {
	        if (this.customContentInfo && this.customContentInfo.destroy) {
	            this.customContentInfo.destroy();
	        }
	    };
	    ContentHookInner.prototype.renderInnerContent = function () {
	        var customContentInfo = this.customContentInfo; // only populated if using non-[p]react node(s)
	        var innerContent = this.getInnerContent();
	        var meta = this.getContentMeta(innerContent);
	        // initial run, or content-type changing? (from vue -> react for example)
	        if (!customContentInfo || customContentInfo.contentKey !== meta.contentKey) {
	            // clearing old value
	            if (customContentInfo) {
	                if (customContentInfo.destroy) {
	                    customContentInfo.destroy();
	                }
	                customContentInfo = this.customContentInfo = null;
	            }
	            // assigning new value
	            if (meta.contentKey) {
	                customContentInfo = this.customContentInfo = tslib.__assign({ contentKey: meta.contentKey, contentVal: innerContent[meta.contentKey] }, meta.buildLifecycleFuncs());
	            }
	            // updating
	        }
	        else if (customContentInfo) {
	            customContentInfo.contentVal = innerContent[meta.contentKey];
	        }
	        return customContentInfo
	            ? [] // signal that something was specified
	            : innerContent; // assume a [p]react vdom node. use it
	    };
	    ContentHookInner.prototype.getInnerContent = function () {
	        var props = this.props;
	        var innerContent = normalizeContent(props.content, props.hookProps);
	        if (innerContent === undefined) { // use the default
	            innerContent = normalizeContent(props.defaultContent, props.hookProps);
	        }
	        return innerContent == null ? null : innerContent; // convert undefined to null (better for React)
	    };
	    ContentHookInner.prototype.getContentMeta = function (innerContent) {
	        var contentTypeHandlers = this.context.pluginHooks.contentTypeHandlers;
	        var contentKey = '';
	        var buildLifecycleFuncs = null;
	        if (innerContent) { // allowed to be null, for convenience to caller
	            for (var searchKey in contentTypeHandlers) {
	                if (innerContent[searchKey] !== undefined) {
	                    contentKey = searchKey;
	                    buildLifecycleFuncs = contentTypeHandlers[searchKey];
	                    break;
	                }
	            }
	        }
	        return { contentKey: contentKey, buildLifecycleFuncs: buildLifecycleFuncs };
	    };
	    ContentHookInner.prototype.updateCustomContent = function () {
	        if (this.customContentInfo) { // for non-[p]react
	            this.customContentInfo.render(this.innerElRef.current || this.props.backupElRef.current, // the element to render into
	            this.customContentInfo.contentVal);
	        }
	    };
	    return ContentHookInner;
	}(BaseComponent));
	var MountHook = /** @class */ (function (_super) {
	    tslib.__extends(MountHook, _super);
	    function MountHook() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleRootEl = function (rootEl) {
	            _this.rootEl = rootEl;
	            if (_this.props.elRef) {
	                setRef(_this.props.elRef, rootEl);
	            }
	        };
	        return _this;
	    }
	    MountHook.prototype.render = function () {
	        return this.props.children(this.handleRootEl);
	    };
	    MountHook.prototype.componentDidMount = function () {
	        var callback = this.props.didMount;
	        if (callback) {
	            callback(tslib.__assign(tslib.__assign({}, this.props.hookProps), { el: this.rootEl }));
	        }
	    };
	    MountHook.prototype.componentWillUnmount = function () {
	        var callback = this.props.willUnmount;
	        if (callback) {
	            callback(tslib.__assign(tslib.__assign({}, this.props.hookProps), { el: this.rootEl }));
	        }
	    };
	    return MountHook;
	}(BaseComponent));
	function buildClassNameNormalizer() {
	    var currentGenerator;
	    var currentHookProps;
	    var currentClassNames = [];
	    return function (generator, hookProps) {
	        if (!currentHookProps || !isPropsEqual(currentHookProps, hookProps) || generator !== currentGenerator) {
	            currentGenerator = generator;
	            currentHookProps = hookProps;
	            currentClassNames = normalizeClassNames(generator, hookProps);
	        }
	        return currentClassNames;
	    };
	}
	function normalizeClassNames(classNames, hookProps) {
	    if (typeof classNames === 'function') {
	        classNames = classNames(hookProps);
	    }
	    return parseClassNames(classNames);
	}
	function normalizeContent(input, hookProps) {
	    if (typeof input === 'function') {
	        return input(hookProps, vdom_cjs.createElement); // give the function the vdom-creation func
	    }
	    return input;
	}
	
	var ViewRoot = /** @class */ (function (_super) {
	    tslib.__extends(ViewRoot, _super);
	    function ViewRoot() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.normalizeClassNames = buildClassNameNormalizer();
	        return _this;
	    }
	    ViewRoot.prototype.render = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        var options = context.options;
	        var hookProps = { view: context.viewApi };
	        var customClassNames = this.normalizeClassNames(options.viewClassNames, hookProps);
	        return (vdom_cjs.createElement(MountHook, { hookProps: hookProps, didMount: options.viewDidMount, willUnmount: options.viewWillUnmount, elRef: props.elRef }, function (rootElRef) { return props.children(rootElRef, ["fc-" + props.viewSpec.type + "-view", 'fc-view'].concat(customClassNames)); }));
	    };
	    return ViewRoot;
	}(BaseComponent));
	
	function parseViewConfigs(inputs) {
	    return mapHash(inputs, parseViewConfig);
	}
	function parseViewConfig(input) {
	    var rawOptions = typeof input === 'function' ?
	        { component: input } :
	        input;
	    var component = rawOptions.component;
	    if (rawOptions.content) {
	        component = createViewHookComponent(rawOptions);
	        // TODO: remove content/classNames/didMount/etc from options?
	    }
	    return {
	        superType: rawOptions.type,
	        component: component,
	        rawOptions: rawOptions,
	    };
	}
	function createViewHookComponent(options) {
	    return function (viewProps) { return (vdom_cjs.createElement(ViewContextType.Consumer, null, function (context) { return (vdom_cjs.createElement(ViewRoot, { viewSpec: context.viewSpec }, function (viewElRef, viewClassNames) {
	        var hookProps = tslib.__assign(tslib.__assign({}, viewProps), { nextDayThreshold: context.options.nextDayThreshold });
	        return (vdom_cjs.createElement(RenderHook, { hookProps: hookProps, classNames: options.classNames, content: options.content, didMount: options.didMount, willUnmount: options.willUnmount, elRef: viewElRef }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (vdom_cjs.createElement("div", { className: viewClassNames.concat(customClassNames).join(' '), ref: rootElRef }, innerContent)); }));
	    })); })); };
	}
	
	function buildViewSpecs(defaultInputs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
	    var defaultConfigs = parseViewConfigs(defaultInputs);
	    var overrideConfigs = parseViewConfigs(optionOverrides.views);
	    var viewDefs = compileViewDefs(defaultConfigs, overrideConfigs);
	    return mapHash(viewDefs, function (viewDef) { return buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults); });
	}
	function buildViewSpec(viewDef, overrideConfigs, optionOverrides, dynamicOptionOverrides, localeDefaults) {
	    var durationInput = viewDef.overrides.duration ||
	        viewDef.defaults.duration ||
	        dynamicOptionOverrides.duration ||
	        optionOverrides.duration;
	    var duration = null;
	    var durationUnit = '';
	    var singleUnit = '';
	    var singleUnitOverrides = {};
	    if (durationInput) {
	        duration = createDurationCached(durationInput);
	        if (duration) { // valid?
	            var denom = greatestDurationDenominator(duration);
	            durationUnit = denom.unit;
	            if (denom.value === 1) {
	                singleUnit = durationUnit;
	                singleUnitOverrides = overrideConfigs[durationUnit] ? overrideConfigs[durationUnit].rawOptions : {};
	            }
	        }
	    }
	    var queryButtonText = function (optionsSubset) {
	        var buttonTextMap = optionsSubset.buttonText || {};
	        var buttonTextKey = viewDef.defaults.buttonTextKey;
	        if (buttonTextKey != null && buttonTextMap[buttonTextKey] != null) {
	            return buttonTextMap[buttonTextKey];
	        }
	        if (buttonTextMap[viewDef.type] != null) {
	            return buttonTextMap[viewDef.type];
	        }
	        if (buttonTextMap[singleUnit] != null) {
	            return buttonTextMap[singleUnit];
	        }
	        return null;
	    };
	    var queryButtonTitle = function (optionsSubset) {
	        var buttonHints = optionsSubset.buttonHints || {};
	        var buttonKey = viewDef.defaults.buttonTextKey; // use same key as text
	        if (buttonKey != null && buttonHints[buttonKey] != null) {
	            return buttonHints[buttonKey];
	        }
	        if (buttonHints[viewDef.type] != null) {
	            return buttonHints[viewDef.type];
	        }
	        if (buttonHints[singleUnit] != null) {
	            return buttonHints[singleUnit];
	        }
	        return null;
	    };
	    return {
	        type: viewDef.type,
	        component: viewDef.component,
	        duration: duration,
	        durationUnit: durationUnit,
	        singleUnit: singleUnit,
	        optionDefaults: viewDef.defaults,
	        optionOverrides: tslib.__assign(tslib.__assign({}, singleUnitOverrides), viewDef.overrides),
	        buttonTextOverride: queryButtonText(dynamicOptionOverrides) ||
	            queryButtonText(optionOverrides) || // constructor-specified buttonText lookup hash takes precedence
	            viewDef.overrides.buttonText,
	        buttonTextDefault: queryButtonText(localeDefaults) ||
	            viewDef.defaults.buttonText ||
	            queryButtonText(BASE_OPTION_DEFAULTS) ||
	            viewDef.type,
	        // not DRY
	        buttonTitleOverride: queryButtonTitle(dynamicOptionOverrides) ||
	            queryButtonTitle(optionOverrides) ||
	            viewDef.overrides.buttonHint,
	        buttonTitleDefault: queryButtonTitle(localeDefaults) ||
	            viewDef.defaults.buttonHint ||
	            queryButtonTitle(BASE_OPTION_DEFAULTS),
	        // will eventually fall back to buttonText
	    };
	}
	// hack to get memoization working
	var durationInputMap = {};
	function createDurationCached(durationInput) {
	    var json = JSON.stringify(durationInput);
	    var res = durationInputMap[json];
	    if (res === undefined) {
	        res = createDuration(durationInput);
	        durationInputMap[json] = res;
	    }
	    return res;
	}
	
	var DateProfileGenerator = /** @class */ (function () {
	    function DateProfileGenerator(props) {
	        this.props = props;
	        this.nowDate = getNow(props.nowInput, props.dateEnv);
	        this.initHiddenDays();
	    }
	    /* Date Range Computation
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Builds a structure with info about what the dates/ranges will be for the "prev" view.
	    DateProfileGenerator.prototype.buildPrev = function (currentDateProfile, currentDate, forceToValid) {
	        var dateEnv = this.props.dateEnv;
	        var prevDate = dateEnv.subtract(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), // important for start-of-month
	        currentDateProfile.dateIncrement);
	        return this.build(prevDate, -1, forceToValid);
	    };
	    // Builds a structure with info about what the dates/ranges will be for the "next" view.
	    DateProfileGenerator.prototype.buildNext = function (currentDateProfile, currentDate, forceToValid) {
	        var dateEnv = this.props.dateEnv;
	        var nextDate = dateEnv.add(dateEnv.startOf(currentDate, currentDateProfile.currentRangeUnit), // important for start-of-month
	        currentDateProfile.dateIncrement);
	        return this.build(nextDate, 1, forceToValid);
	    };
	    // Builds a structure holding dates/ranges for rendering around the given date.
	    // Optional direction param indicates whether the date is being incremented/decremented
	    // from its previous value. decremented = -1, incremented = 1 (default).
	    DateProfileGenerator.prototype.build = function (currentDate, direction, forceToValid) {
	        if (forceToValid === void 0) { forceToValid = true; }
	        var props = this.props;
	        var validRange;
	        var currentInfo;
	        var isRangeAllDay;
	        var renderRange;
	        var activeRange;
	        var isValid;
	        validRange = this.buildValidRange();
	        validRange = this.trimHiddenDays(validRange);
	        if (forceToValid) {
	            currentDate = constrainMarkerToRange(currentDate, validRange);
	        }
	        currentInfo = this.buildCurrentRangeInfo(currentDate, direction);
	        isRangeAllDay = /^(year|month|week|day)$/.test(currentInfo.unit);
	        renderRange = this.buildRenderRange(this.trimHiddenDays(currentInfo.range), currentInfo.unit, isRangeAllDay);
	        renderRange = this.trimHiddenDays(renderRange);
	        activeRange = renderRange;
	        if (!props.showNonCurrentDates) {
	            activeRange = intersectRanges(activeRange, currentInfo.range);
	        }
	        activeRange = this.adjustActiveRange(activeRange);
	        activeRange = intersectRanges(activeRange, validRange); // might return null
	        // it's invalid if the originally requested date is not contained,
	        // or if the range is completely outside of the valid range.
	        isValid = rangesIntersect(currentInfo.range, validRange);
	        return {
	            // constraint for where prev/next operations can go and where events can be dragged/resized to.
	            // an object with optional start and end properties.
	            validRange: validRange,
	            // range the view is formally responsible for.
	            // for example, a month view might have 1st-31st, excluding padded dates
	            currentRange: currentInfo.range,
	            // name of largest unit being displayed, like "month" or "week"
	            currentRangeUnit: currentInfo.unit,
	            isRangeAllDay: isRangeAllDay,
	            // dates that display events and accept drag-n-drop
	            // will be `null` if no dates accept events
	            activeRange: activeRange,
	            // date range with a rendered skeleton
	            // includes not-active days that need some sort of DOM
	            renderRange: renderRange,
	            // Duration object that denotes the first visible time of any given day
	            slotMinTime: props.slotMinTime,
	            // Duration object that denotes the exclusive visible end time of any given day
	            slotMaxTime: props.slotMaxTime,
	            isValid: isValid,
	            // how far the current date will move for a prev/next operation
	            dateIncrement: this.buildDateIncrement(currentInfo.duration),
	            // pass a fallback (might be null) ^
	        };
	    };
	    // Builds an object with optional start/end properties.
	    // Indicates the minimum/maximum dates to display.
	    // not responsible for trimming hidden days.
	    DateProfileGenerator.prototype.buildValidRange = function () {
	        var input = this.props.validRangeInput;
	        var simpleInput = typeof input === 'function'
	            ? input.call(this.props.calendarApi, this.nowDate)
	            : input;
	        return this.refineRange(simpleInput) ||
	            { start: null, end: null }; // completely open-ended
	    };
	    // Builds a structure with info about the "current" range, the range that is
	    // highlighted as being the current month for example.
	    // See build() for a description of `direction`.
	    // Guaranteed to have `range` and `unit` properties. `duration` is optional.
	    DateProfileGenerator.prototype.buildCurrentRangeInfo = function (date, direction) {
	        var props = this.props;
	        var duration = null;
	        var unit = null;
	        var range = null;
	        var dayCount;
	        if (props.duration) {
	            duration = props.duration;
	            unit = props.durationUnit;
	            range = this.buildRangeFromDuration(date, direction, duration, unit);
	        }
	        else if ((dayCount = this.props.dayCount)) {
	            unit = 'day';
	            range = this.buildRangeFromDayCount(date, direction, dayCount);
	        }
	        else if ((range = this.buildCustomVisibleRange(date))) {
	            unit = props.dateEnv.greatestWholeUnit(range.start, range.end).unit;
	        }
	        else {
	            duration = this.getFallbackDuration();
	            unit = greatestDurationDenominator(duration).unit;
	            range = this.buildRangeFromDuration(date, direction, duration, unit);
	        }
	        return { duration: duration, unit: unit, range: range };
	    };
	    DateProfileGenerator.prototype.getFallbackDuration = function () {
	        return createDuration({ day: 1 });
	    };
	    // Returns a new activeRange to have time values (un-ambiguate)
	    // slotMinTime or slotMaxTime causes the range to expand.
	    DateProfileGenerator.prototype.adjustActiveRange = function (range) {
	        var _a = this.props, dateEnv = _a.dateEnv, usesMinMaxTime = _a.usesMinMaxTime, slotMinTime = _a.slotMinTime, slotMaxTime = _a.slotMaxTime;
	        var start = range.start, end = range.end;
	        if (usesMinMaxTime) {
	            // expand active range if slotMinTime is negative (why not when positive?)
	            if (asRoughDays(slotMinTime) < 0) {
	                start = startOfDay(start); // necessary?
	                start = dateEnv.add(start, slotMinTime);
	            }
	            // expand active range if slotMaxTime is beyond one day (why not when negative?)
	            if (asRoughDays(slotMaxTime) > 1) {
	                end = startOfDay(end); // necessary?
	                end = addDays(end, -1);
	                end = dateEnv.add(end, slotMaxTime);
	            }
	        }
	        return { start: start, end: end };
	    };
	    // Builds the "current" range when it is specified as an explicit duration.
	    // `unit` is the already-computed greatestDurationDenominator unit of duration.
	    DateProfileGenerator.prototype.buildRangeFromDuration = function (date, direction, duration, unit) {
	        var _a = this.props, dateEnv = _a.dateEnv, dateAlignment = _a.dateAlignment;
	        var start;
	        var end;
	        var res;
	        // compute what the alignment should be
	        if (!dateAlignment) {
	            var dateIncrement = this.props.dateIncrement;
	            if (dateIncrement) {
	                // use the smaller of the two units
	                if (asRoughMs(dateIncrement) < asRoughMs(duration)) {
	                    dateAlignment = greatestDurationDenominator(dateIncrement).unit;
	                }
	                else {
	                    dateAlignment = unit;
	                }
	            }
	            else {
	                dateAlignment = unit;
	            }
	        }
	        // if the view displays a single day or smaller
	        if (asRoughDays(duration) <= 1) {
	            if (this.isHiddenDay(start)) {
	                start = this.skipHiddenDays(start, direction);
	                start = startOfDay(start);
	            }
	        }
	        function computeRes() {
	            start = dateEnv.startOf(date, dateAlignment);
	            end = dateEnv.add(start, duration);
	            res = { start: start, end: end };
	        }
	        computeRes();
	        // if range is completely enveloped by hidden days, go past the hidden days
	        if (!this.trimHiddenDays(res)) {
	            date = this.skipHiddenDays(date, direction);
	            computeRes();
	        }
	        return res;
	    };
	    // Builds the "current" range when a dayCount is specified.
	    DateProfileGenerator.prototype.buildRangeFromDayCount = function (date, direction, dayCount) {
	        var _a = this.props, dateEnv = _a.dateEnv, dateAlignment = _a.dateAlignment;
	        var runningCount = 0;
	        var start = date;
	        var end;
	        if (dateAlignment) {
	            start = dateEnv.startOf(start, dateAlignment);
	        }
	        start = startOfDay(start);
	        start = this.skipHiddenDays(start, direction);
	        end = start;
	        do {
	            end = addDays(end, 1);
	            if (!this.isHiddenDay(end)) {
	                runningCount += 1;
	            }
	        } while (runningCount < dayCount);
	        return { start: start, end: end };
	    };
	    // Builds a normalized range object for the "visible" range,
	    // which is a way to define the currentRange and activeRange at the same time.
	    DateProfileGenerator.prototype.buildCustomVisibleRange = function (date) {
	        var props = this.props;
	        var input = props.visibleRangeInput;
	        var simpleInput = typeof input === 'function'
	            ? input.call(props.calendarApi, props.dateEnv.toDate(date))
	            : input;
	        var range = this.refineRange(simpleInput);
	        if (range && (range.start == null || range.end == null)) {
	            return null;
	        }
	        return range;
	    };
	    // Computes the range that will represent the element/cells for *rendering*,
	    // but which may have voided days/times.
	    // not responsible for trimming hidden days.
	    DateProfileGenerator.prototype.buildRenderRange = function (currentRange, currentRangeUnit, isRangeAllDay) {
	        return currentRange;
	    };
	    // Compute the duration value that should be added/substracted to the current date
	    // when a prev/next operation happens.
	    DateProfileGenerator.prototype.buildDateIncrement = function (fallback) {
	        var dateIncrement = this.props.dateIncrement;
	        var customAlignment;
	        if (dateIncrement) {
	            return dateIncrement;
	        }
	        if ((customAlignment = this.props.dateAlignment)) {
	            return createDuration(1, customAlignment);
	        }
	        if (fallback) {
	            return fallback;
	        }
	        return createDuration({ days: 1 });
	    };
	    DateProfileGenerator.prototype.refineRange = function (rangeInput) {
	        if (rangeInput) {
	            var range = parseRange(rangeInput, this.props.dateEnv);
	            if (range) {
	                range = computeVisibleDayRange(range);
	            }
	            return range;
	        }
	        return null;
	    };
	    /* Hidden Days
	    ------------------------------------------------------------------------------------------------------------------*/
	    // Initializes internal variables related to calculating hidden days-of-week
	    DateProfileGenerator.prototype.initHiddenDays = function () {
	        var hiddenDays = this.props.hiddenDays || []; // array of day-of-week indices that are hidden
	        var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
	        var dayCnt = 0;
	        var i;
	        if (this.props.weekends === false) {
	            hiddenDays.push(0, 6); // 0=sunday, 6=saturday
	        }
	        for (i = 0; i < 7; i += 1) {
	            if (!(isHiddenDayHash[i] = hiddenDays.indexOf(i) !== -1)) {
	                dayCnt += 1;
	            }
	        }
	        if (!dayCnt) {
	            throw new Error('invalid hiddenDays'); // all days were hidden? bad.
	        }
	        this.isHiddenDayHash = isHiddenDayHash;
	    };
	    // Remove days from the beginning and end of the range that are computed as hidden.
	    // If the whole range is trimmed off, returns null
	    DateProfileGenerator.prototype.trimHiddenDays = function (range) {
	        var start = range.start, end = range.end;
	        if (start) {
	            start = this.skipHiddenDays(start);
	        }
	        if (end) {
	            end = this.skipHiddenDays(end, -1, true);
	        }
	        if (start == null || end == null || start < end) {
	            return { start: start, end: end };
	        }
	        return null;
	    };
	    // Is the current day hidden?
	    // `day` is a day-of-week index (0-6), or a Date (used for UTC)
	    DateProfileGenerator.prototype.isHiddenDay = function (day) {
	        if (day instanceof Date) {
	            day = day.getUTCDay();
	        }
	        return this.isHiddenDayHash[day];
	    };
	    // Incrementing the current day until it is no longer a hidden day, returning a copy.
	    // DOES NOT CONSIDER validRange!
	    // If the initial value of `date` is not a hidden day, don't do anything.
	    // Pass `isExclusive` as `true` if you are dealing with an end date.
	    // `inc` defaults to `1` (increment one day forward each time)
	    DateProfileGenerator.prototype.skipHiddenDays = function (date, inc, isExclusive) {
	        if (inc === void 0) { inc = 1; }
	        if (isExclusive === void 0) { isExclusive = false; }
	        while (this.isHiddenDayHash[(date.getUTCDay() + (isExclusive ? inc : 0) + 7) % 7]) {
	            date = addDays(date, inc);
	        }
	        return date;
	    };
	    return DateProfileGenerator;
	}());
	
	function reduceViewType(viewType, action) {
	    switch (action.type) {
	        case 'CHANGE_VIEW_TYPE':
	            viewType = action.viewType;
	    }
	    return viewType;
	}
	
	function reduceDynamicOptionOverrides(dynamicOptionOverrides, action) {
	    var _a;
	    switch (action.type) {
	        case 'SET_OPTION':
	            return tslib.__assign(tslib.__assign({}, dynamicOptionOverrides), (_a = {}, _a[action.optionName] = action.rawOptionValue, _a));
	        default:
	            return dynamicOptionOverrides;
	    }
	}
	
	function reduceDateProfile(currentDateProfile, action, currentDate, dateProfileGenerator) {
	    var dp;
	    switch (action.type) {
	        case 'CHANGE_VIEW_TYPE':
	            return dateProfileGenerator.build(action.dateMarker || currentDate);
	        case 'CHANGE_DATE':
	            return dateProfileGenerator.build(action.dateMarker);
	        case 'PREV':
	            dp = dateProfileGenerator.buildPrev(currentDateProfile, currentDate);
	            if (dp.isValid) {
	                return dp;
	            }
	            break;
	        case 'NEXT':
	            dp = dateProfileGenerator.buildNext(currentDateProfile, currentDate);
	            if (dp.isValid) {
	                return dp;
	            }
	            break;
	    }
	    return currentDateProfile;
	}
	
	function initEventSources(calendarOptions, dateProfile, context) {
	    var activeRange = dateProfile ? dateProfile.activeRange : null;
	    return addSources({}, parseInitialSources(calendarOptions, context), activeRange, context);
	}
	function reduceEventSources(eventSources, action, dateProfile, context) {
	    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
	    switch (action.type) {
	        case 'ADD_EVENT_SOURCES': // already parsed
	            return addSources(eventSources, action.sources, activeRange, context);
	        case 'REMOVE_EVENT_SOURCE':
	            return removeSource(eventSources, action.sourceId);
	        case 'PREV': // TODO: how do we track all actions that affect dateProfile :(
	        case 'NEXT':
	        case 'CHANGE_DATE':
	        case 'CHANGE_VIEW_TYPE':
	            if (dateProfile) {
	                return fetchDirtySources(eventSources, activeRange, context);
	            }
	            return eventSources;
	        case 'FETCH_EVENT_SOURCES':
	            return fetchSourcesByIds(eventSources, action.sourceIds ? // why no type?
	                arrayToHash(action.sourceIds) :
	                excludeStaticSources(eventSources, context), activeRange, action.isRefetch || false, context);
	        case 'RECEIVE_EVENTS':
	        case 'RECEIVE_EVENT_ERROR':
	            return receiveResponse(eventSources, action.sourceId, action.fetchId, action.fetchRange);
	        case 'REMOVE_ALL_EVENT_SOURCES':
	            return {};
	        default:
	            return eventSources;
	    }
	}
	function reduceEventSourcesNewTimeZone(eventSources, dateProfile, context) {
	    var activeRange = dateProfile ? dateProfile.activeRange : null; // need this check?
	    return fetchSourcesByIds(eventSources, excludeStaticSources(eventSources, context), activeRange, true, context);
	}
	function computeEventSourcesLoading(eventSources) {
	    for (var sourceId in eventSources) {
	        if (eventSources[sourceId].isFetching) {
	            return true;
	        }
	    }
	    return false;
	}
	function addSources(eventSourceHash, sources, fetchRange, context) {
	    var hash = {};
	    for (var _i = 0, sources_1 = sources; _i < sources_1.length; _i++) {
	        var source = sources_1[_i];
	        hash[source.sourceId] = source;
	    }
	    if (fetchRange) {
	        hash = fetchDirtySources(hash, fetchRange, context);
	    }
	    return tslib.__assign(tslib.__assign({}, eventSourceHash), hash);
	}
	function removeSource(eventSourceHash, sourceId) {
	    return filterHash(eventSourceHash, function (eventSource) { return eventSource.sourceId !== sourceId; });
	}
	function fetchDirtySources(sourceHash, fetchRange, context) {
	    return fetchSourcesByIds(sourceHash, filterHash(sourceHash, function (eventSource) { return isSourceDirty(eventSource, fetchRange, context); }), fetchRange, false, context);
	}
	function isSourceDirty(eventSource, fetchRange, context) {
	    if (!doesSourceNeedRange(eventSource, context)) {
	        return !eventSource.latestFetchId;
	    }
	    return !context.options.lazyFetching ||
	        !eventSource.fetchRange ||
	        eventSource.isFetching || // always cancel outdated in-progress fetches
	        fetchRange.start < eventSource.fetchRange.start ||
	        fetchRange.end > eventSource.fetchRange.end;
	}
	function fetchSourcesByIds(prevSources, sourceIdHash, fetchRange, isRefetch, context) {
	    var nextSources = {};
	    for (var sourceId in prevSources) {
	        var source = prevSources[sourceId];
	        if (sourceIdHash[sourceId]) {
	            nextSources[sourceId] = fetchSource(source, fetchRange, isRefetch, context);
	        }
	        else {
	            nextSources[sourceId] = source;
	        }
	    }
	    return nextSources;
	}
	function fetchSource(eventSource, fetchRange, isRefetch, context) {
	    var options = context.options, calendarApi = context.calendarApi;
	    var sourceDef = context.pluginHooks.eventSourceDefs[eventSource.sourceDefId];
	    var fetchId = guid();
	    sourceDef.fetch({
	        eventSource: eventSource,
	        range: fetchRange,
	        isRefetch: isRefetch,
	        context: context,
	    }, function (res) {
	        var rawEvents = res.rawEvents;
	        if (options.eventSourceSuccess) {
	            rawEvents = options.eventSourceSuccess.call(calendarApi, rawEvents, res.xhr) || rawEvents;
	        }
	        if (eventSource.success) {
	            rawEvents = eventSource.success.call(calendarApi, rawEvents, res.xhr) || rawEvents;
	        }
	        context.dispatch({
	            type: 'RECEIVE_EVENTS',
	            sourceId: eventSource.sourceId,
	            fetchId: fetchId,
	            fetchRange: fetchRange,
	            rawEvents: rawEvents,
	        });
	    }, function (error) {
	        console.warn(error.message, error);
	        if (options.eventSourceFailure) {
	            options.eventSourceFailure.call(calendarApi, error);
	        }
	        if (eventSource.failure) {
	            eventSource.failure(error);
	        }
	        context.dispatch({
	            type: 'RECEIVE_EVENT_ERROR',
	            sourceId: eventSource.sourceId,
	            fetchId: fetchId,
	            fetchRange: fetchRange,
	            error: error,
	        });
	    });
	    return tslib.__assign(tslib.__assign({}, eventSource), { isFetching: true, latestFetchId: fetchId });
	}
	function receiveResponse(sourceHash, sourceId, fetchId, fetchRange) {
	    var _a;
	    var eventSource = sourceHash[sourceId];
	    if (eventSource && // not already removed
	        fetchId === eventSource.latestFetchId) {
	        return tslib.__assign(tslib.__assign({}, sourceHash), (_a = {}, _a[sourceId] = tslib.__assign(tslib.__assign({}, eventSource), { isFetching: false, fetchRange: fetchRange }), _a));
	    }
	    return sourceHash;
	}
	function excludeStaticSources(eventSources, context) {
	    return filterHash(eventSources, function (eventSource) { return doesSourceNeedRange(eventSource, context); });
	}
	function parseInitialSources(rawOptions, context) {
	    var refiners = buildEventSourceRefiners(context);
	    var rawSources = [].concat(rawOptions.eventSources || []);
	    var sources = []; // parsed
	    if (rawOptions.initialEvents) {
	        rawSources.unshift(rawOptions.initialEvents);
	    }
	    if (rawOptions.events) {
	        rawSources.unshift(rawOptions.events);
	    }
	    for (var _i = 0, rawSources_1 = rawSources; _i < rawSources_1.length; _i++) {
	        var rawSource = rawSources_1[_i];
	        var source = parseEventSource(rawSource, context, refiners);
	        if (source) {
	            sources.push(source);
	        }
	    }
	    return sources;
	}
	function doesSourceNeedRange(eventSource, context) {
	    var defs = context.pluginHooks.eventSourceDefs;
	    return !defs[eventSource.sourceDefId].ignoreRange;
	}
	
	function reduceEventStore(eventStore, action, eventSources, dateProfile, context) {
	    switch (action.type) {
	        case 'RECEIVE_EVENTS': // raw
	            return receiveRawEvents(eventStore, eventSources[action.sourceId], action.fetchId, action.fetchRange, action.rawEvents, context);
	        case 'ADD_EVENTS': // already parsed, but not expanded
	            return addEvent(eventStore, action.eventStore, // new ones
	            dateProfile ? dateProfile.activeRange : null, context);
	        case 'RESET_EVENTS':
	            return action.eventStore;
	        case 'MERGE_EVENTS': // already parsed and expanded
	            return mergeEventStores(eventStore, action.eventStore);
	        case 'PREV': // TODO: how do we track all actions that affect dateProfile :(
	        case 'NEXT':
	        case 'CHANGE_DATE':
	        case 'CHANGE_VIEW_TYPE':
	            if (dateProfile) {
	                return expandRecurring(eventStore, dateProfile.activeRange, context);
	            }
	            return eventStore;
	        case 'REMOVE_EVENTS':
	            return excludeSubEventStore(eventStore, action.eventStore);
	        case 'REMOVE_EVENT_SOURCE':
	            return excludeEventsBySourceId(eventStore, action.sourceId);
	        case 'REMOVE_ALL_EVENT_SOURCES':
	            return filterEventStoreDefs(eventStore, function (eventDef) { return (!eventDef.sourceId // only keep events with no source id
	            ); });
	        case 'REMOVE_ALL_EVENTS':
	            return createEmptyEventStore();
	        default:
	            return eventStore;
	    }
	}
	function receiveRawEvents(eventStore, eventSource, fetchId, fetchRange, rawEvents, context) {
	    if (eventSource && // not already removed
	        fetchId === eventSource.latestFetchId // TODO: wish this logic was always in event-sources
	    ) {
	        var subset = parseEvents(transformRawEvents(rawEvents, eventSource, context), eventSource, context);
	        if (fetchRange) {
	            subset = expandRecurring(subset, fetchRange, context);
	        }
	        return mergeEventStores(excludeEventsBySourceId(eventStore, eventSource.sourceId), subset);
	    }
	    return eventStore;
	}
	function transformRawEvents(rawEvents, eventSource, context) {
	    var calEachTransform = context.options.eventDataTransform;
	    var sourceEachTransform = eventSource ? eventSource.eventDataTransform : null;
	    if (sourceEachTransform) {
	        rawEvents = transformEachRawEvent(rawEvents, sourceEachTransform);
	    }
	    if (calEachTransform) {
	        rawEvents = transformEachRawEvent(rawEvents, calEachTransform);
	    }
	    return rawEvents;
	}
	function transformEachRawEvent(rawEvents, func) {
	    var refinedEvents;
	    if (!func) {
	        refinedEvents = rawEvents;
	    }
	    else {
	        refinedEvents = [];
	        for (var _i = 0, rawEvents_1 = rawEvents; _i < rawEvents_1.length; _i++) {
	            var rawEvent = rawEvents_1[_i];
	            var refinedEvent = func(rawEvent);
	            if (refinedEvent) {
	                refinedEvents.push(refinedEvent);
	            }
	            else if (refinedEvent == null) {
	                refinedEvents.push(rawEvent);
	            } // if a different falsy value, do nothing
	        }
	    }
	    return refinedEvents;
	}
	function addEvent(eventStore, subset, expandRange, context) {
	    if (expandRange) {
	        subset = expandRecurring(subset, expandRange, context);
	    }
	    return mergeEventStores(eventStore, subset);
	}
	function rezoneEventStoreDates(eventStore, oldDateEnv, newDateEnv) {
	    var defs = eventStore.defs;
	    var instances = mapHash(eventStore.instances, function (instance) {
	        var def = defs[instance.defId];
	        if (def.allDay || def.recurringDef) {
	            return instance; // isn't dependent on timezone
	        }
	        return tslib.__assign(tslib.__assign({}, instance), { range: {
	                start: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.start, instance.forcedStartTzo)),
	                end: newDateEnv.createMarker(oldDateEnv.toDate(instance.range.end, instance.forcedEndTzo)),
	            }, forcedStartTzo: newDateEnv.canComputeOffset ? null : instance.forcedStartTzo, forcedEndTzo: newDateEnv.canComputeOffset ? null : instance.forcedEndTzo });
	    });
	    return { defs: defs, instances: instances };
	}
	function excludeEventsBySourceId(eventStore, sourceId) {
	    return filterEventStoreDefs(eventStore, function (eventDef) { return eventDef.sourceId !== sourceId; });
	}
	// QUESTION: why not just return instances? do a general object-property-exclusion util
	function excludeInstances(eventStore, removals) {
	    return {
	        defs: eventStore.defs,
	        instances: filterHash(eventStore.instances, function (instance) { return !removals[instance.instanceId]; }),
	    };
	}
	
	function reduceDateSelection(currentSelection, action) {
	    switch (action.type) {
	        case 'UNSELECT_DATES':
	            return null;
	        case 'SELECT_DATES':
	            return action.selection;
	        default:
	            return currentSelection;
	    }
	}
	
	function reduceSelectedEvent(currentInstanceId, action) {
	    switch (action.type) {
	        case 'UNSELECT_EVENT':
	            return '';
	        case 'SELECT_EVENT':
	            return action.eventInstanceId;
	        default:
	            return currentInstanceId;
	    }
	}
	
	function reduceEventDrag(currentDrag, action) {
	    var newDrag;
	    switch (action.type) {
	        case 'UNSET_EVENT_DRAG':
	            return null;
	        case 'SET_EVENT_DRAG':
	            newDrag = action.state;
	            return {
	                affectedEvents: newDrag.affectedEvents,
	                mutatedEvents: newDrag.mutatedEvents,
	                isEvent: newDrag.isEvent,
	            };
	        default:
	            return currentDrag;
	    }
	}
	
	function reduceEventResize(currentResize, action) {
	    var newResize;
	    switch (action.type) {
	        case 'UNSET_EVENT_RESIZE':
	            return null;
	        case 'SET_EVENT_RESIZE':
	            newResize = action.state;
	            return {
	                affectedEvents: newResize.affectedEvents,
	                mutatedEvents: newResize.mutatedEvents,
	                isEvent: newResize.isEvent,
	            };
	        default:
	            return currentResize;
	    }
	}
	
	function parseToolbars(calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
	    var header = calendarOptions.headerToolbar ? parseToolbar(calendarOptions.headerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
	    var footer = calendarOptions.footerToolbar ? parseToolbar(calendarOptions.footerToolbar, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) : null;
	    return { header: header, footer: footer };
	}
	function parseToolbar(sectionStrHash, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi) {
	    var sectionWidgets = {};
	    var viewsWithButtons = [];
	    var hasTitle = false;
	    for (var sectionName in sectionStrHash) {
	        var sectionStr = sectionStrHash[sectionName];
	        var sectionRes = parseSection(sectionStr, calendarOptions, calendarOptionOverrides, theme, viewSpecs, calendarApi);
	        sectionWidgets[sectionName] = sectionRes.widgets;
	        viewsWithButtons.push.apply(viewsWithButtons, sectionRes.viewsWithButtons);
	        hasTitle = hasTitle || sectionRes.hasTitle;
	    }
	    return { sectionWidgets: sectionWidgets, viewsWithButtons: viewsWithButtons, hasTitle: hasTitle };
	}
	/*
	BAD: querying icons and text here. should be done at render time
	*/
	function parseSection(sectionStr, calendarOptions, // defaults+overrides, then refined
	calendarOptionOverrides, // overrides only!, unrefined :(
	theme, viewSpecs, calendarApi) {
	    var isRtl = calendarOptions.direction === 'rtl';
	    var calendarCustomButtons = calendarOptions.customButtons || {};
	    var calendarButtonTextOverrides = calendarOptionOverrides.buttonText || {};
	    var calendarButtonText = calendarOptions.buttonText || {};
	    var calendarButtonHintOverrides = calendarOptionOverrides.buttonHints || {};
	    var calendarButtonHints = calendarOptions.buttonHints || {};
	    var sectionSubstrs = sectionStr ? sectionStr.split(' ') : [];
	    var viewsWithButtons = [];
	    var hasTitle = false;
	    var widgets = sectionSubstrs.map(function (buttonGroupStr) { return (buttonGroupStr.split(',').map(function (buttonName) {
	        if (buttonName === 'title') {
	            hasTitle = true;
	            return { buttonName: buttonName };
	        }
	        var customButtonProps;
	        var viewSpec;
	        var buttonClick;
	        var buttonIcon; // only one of these will be set
	        var buttonText; // "
	        var buttonHint;
	        // ^ for the title="" attribute, for accessibility
	        if ((customButtonProps = calendarCustomButtons[buttonName])) {
	            buttonClick = function (ev) {
	                if (customButtonProps.click) {
	                    customButtonProps.click.call(ev.target, ev, ev.target); // TODO: use Calendar this context?
	                }
	            };
	            (buttonIcon = theme.getCustomButtonIconClass(customButtonProps)) ||
	                (buttonIcon = theme.getIconClass(buttonName, isRtl)) ||
	                (buttonText = customButtonProps.text);
	            buttonHint = customButtonProps.hint || customButtonProps.text;
	        }
	        else if ((viewSpec = viewSpecs[buttonName])) {
	            viewsWithButtons.push(buttonName);
	            buttonClick = function () {
	                calendarApi.changeView(buttonName);
	            };
	            (buttonText = viewSpec.buttonTextOverride) ||
	                (buttonIcon = theme.getIconClass(buttonName, isRtl)) ||
	                (buttonText = viewSpec.buttonTextDefault);
	            var textFallback = viewSpec.buttonTextOverride ||
	                viewSpec.buttonTextDefault;
	            buttonHint = formatWithOrdinals(viewSpec.buttonTitleOverride ||
	                viewSpec.buttonTitleDefault ||
	                calendarOptions.viewHint, [textFallback, buttonName], // view-name = buttonName
	            textFallback);
	        }
	        else if (calendarApi[buttonName]) { // a calendarApi method
	            buttonClick = function () {
	                calendarApi[buttonName]();
	            };
	            (buttonText = calendarButtonTextOverrides[buttonName]) ||
	                (buttonIcon = theme.getIconClass(buttonName, isRtl)) ||
	                (buttonText = calendarButtonText[buttonName]); // everything else is considered default
	            if (buttonName === 'prevYear' || buttonName === 'nextYear') {
	                var prevOrNext = buttonName === 'prevYear' ? 'prev' : 'next';
	                buttonHint = formatWithOrdinals(calendarButtonHintOverrides[prevOrNext] ||
	                    calendarButtonHints[prevOrNext], [
	                    calendarButtonText.year || 'year',
	                    'year',
	                ], calendarButtonText[buttonName]);
	            }
	            else {
	                buttonHint = function (navUnit) { return formatWithOrdinals(calendarButtonHintOverrides[buttonName] ||
	                    calendarButtonHints[buttonName], [
	                    calendarButtonText[navUnit] || navUnit,
	                    navUnit,
	                ], calendarButtonText[buttonName]); };
	            }
	        }
	        return { buttonName: buttonName, buttonClick: buttonClick, buttonIcon: buttonIcon, buttonText: buttonText, buttonHint: buttonHint };
	    })); });
	    return { widgets: widgets, viewsWithButtons: viewsWithButtons, hasTitle: hasTitle };
	}
	
	var eventSourceDef$2 = {
	    ignoreRange: true,
	    parseMeta: function (refined) {
	        if (Array.isArray(refined.events)) {
	            return refined.events;
	        }
	        return null;
	    },
	    fetch: function (arg, success) {
	        success({
	            rawEvents: arg.eventSource.meta,
	        });
	    },
	};
	var arrayEventSourcePlugin = createPlugin({
	    eventSourceDefs: [eventSourceDef$2],
	});
	
	var eventSourceDef$1 = {
	    parseMeta: function (refined) {
	        if (typeof refined.events === 'function') {
	            return refined.events;
	        }
	        return null;
	    },
	    fetch: function (arg, success, failure) {
	        var dateEnv = arg.context.dateEnv;
	        var func = arg.eventSource.meta;
	        unpromisify(func.bind(null, buildRangeApiWithTimeZone(arg.range, dateEnv)), function (rawEvents) {
	            success({ rawEvents: rawEvents }); // needs an object response
	        }, failure);
	    },
	};
	var funcEventSourcePlugin = createPlugin({
	    eventSourceDefs: [eventSourceDef$1],
	});
	
	function requestJson(method, url, params, successCallback, failureCallback) {
	    method = method.toUpperCase();
	    var body = null;
	    if (method === 'GET') {
	        url = injectQueryStringParams(url, params);
	    }
	    else {
	        body = encodeParams(params);
	    }
	    var xhr = new XMLHttpRequest();
	    xhr.open(method, url, true);
	    if (method !== 'GET') {
	        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	    }
	    xhr.onload = function () {
	        if (xhr.status >= 200 && xhr.status < 400) {
	            var parsed = false;
	            var res = void 0;
	            try {
	                res = JSON.parse(xhr.responseText);
	                parsed = true;
	            }
	            catch (err) {
	                // will handle parsed=false
	            }
	            if (parsed) {
	                successCallback(res, xhr);
	            }
	            else {
	                failureCallback('Failure parsing JSON', xhr);
	            }
	        }
	        else {
	            failureCallback('Request failed', xhr);
	        }
	    };
	    xhr.onerror = function () {
	        failureCallback('Request failed', xhr);
	    };
	    xhr.send(body);
	}
	function injectQueryStringParams(url, params) {
	    return url +
	        (url.indexOf('?') === -1 ? '?' : '&') +
	        encodeParams(params);
	}
	function encodeParams(params) {
	    var parts = [];
	    for (var key in params) {
	        parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
	    }
	    return parts.join('&');
	}
	
	var JSON_FEED_EVENT_SOURCE_REFINERS = {
	    method: String,
	    extraParams: identity,
	    startParam: String,
	    endParam: String,
	    timeZoneParam: String,
	};
	
	var eventSourceDef = {
	    parseMeta: function (refined) {
	        if (refined.url && (refined.format === 'json' || !refined.format)) {
	            return {
	                url: refined.url,
	                format: 'json',
	                method: (refined.method || 'GET').toUpperCase(),
	                extraParams: refined.extraParams,
	                startParam: refined.startParam,
	                endParam: refined.endParam,
	                timeZoneParam: refined.timeZoneParam,
	            };
	        }
	        return null;
	    },
	    fetch: function (arg, success, failure) {
	        var meta = arg.eventSource.meta;
	        var requestParams = buildRequestParams(meta, arg.range, arg.context);
	        requestJson(meta.method, meta.url, requestParams, function (rawEvents, xhr) {
	            success({ rawEvents: rawEvents, xhr: xhr });
	        }, function (errorMessage, xhr) {
	            failure({ message: errorMessage, xhr: xhr });
	        });
	    },
	};
	var jsonFeedEventSourcePlugin = createPlugin({
	    eventSourceRefiners: JSON_FEED_EVENT_SOURCE_REFINERS,
	    eventSourceDefs: [eventSourceDef],
	});
	function buildRequestParams(meta, range, context) {
	    var dateEnv = context.dateEnv, options = context.options;
	    var startParam;
	    var endParam;
	    var timeZoneParam;
	    var customRequestParams;
	    var params = {};
	    startParam = meta.startParam;
	    if (startParam == null) {
	        startParam = options.startParam;
	    }
	    endParam = meta.endParam;
	    if (endParam == null) {
	        endParam = options.endParam;
	    }
	    timeZoneParam = meta.timeZoneParam;
	    if (timeZoneParam == null) {
	        timeZoneParam = options.timeZoneParam;
	    }
	    // retrieve any outbound GET/POST data from the options
	    if (typeof meta.extraParams === 'function') {
	        // supplied as a function that returns a key/value object
	        customRequestParams = meta.extraParams();
	    }
	    else {
	        // probably supplied as a straight key/value object
	        customRequestParams = meta.extraParams || {};
	    }
	    tslib.__assign(params, customRequestParams);
	    params[startParam] = dateEnv.formatIso(range.start);
	    params[endParam] = dateEnv.formatIso(range.end);
	    if (dateEnv.timeZone !== 'local') {
	        params[timeZoneParam] = dateEnv.timeZone;
	    }
	    return params;
	}
	
	var SIMPLE_RECURRING_REFINERS = {
	    daysOfWeek: identity,
	    startTime: createDuration,
	    endTime: createDuration,
	    duration: createDuration,
	    startRecur: identity,
	    endRecur: identity,
	};
	
	var recurring = {
	    parse: function (refined, dateEnv) {
	        if (refined.daysOfWeek || refined.startTime || refined.endTime || refined.startRecur || refined.endRecur) {
	            var recurringData = {
	                daysOfWeek: refined.daysOfWeek || null,
	                startTime: refined.startTime || null,
	                endTime: refined.endTime || null,
	                startRecur: refined.startRecur ? dateEnv.createMarker(refined.startRecur) : null,
	                endRecur: refined.endRecur ? dateEnv.createMarker(refined.endRecur) : null,
	            };
	            var duration = void 0;
	            if (refined.duration) {
	                duration = refined.duration;
	            }
	            if (!duration && refined.startTime && refined.endTime) {
	                duration = subtractDurations(refined.endTime, refined.startTime);
	            }
	            return {
	                allDayGuess: Boolean(!refined.startTime && !refined.endTime),
	                duration: duration,
	                typeData: recurringData, // doesn't need endTime anymore but oh well
	            };
	        }
	        return null;
	    },
	    expand: function (typeData, framingRange, dateEnv) {
	        var clippedFramingRange = intersectRanges(framingRange, { start: typeData.startRecur, end: typeData.endRecur });
	        if (clippedFramingRange) {
	            return expandRanges(typeData.daysOfWeek, typeData.startTime, clippedFramingRange, dateEnv);
	        }
	        return [];
	    },
	};
	var simpleRecurringEventsPlugin = createPlugin({
	    recurringTypes: [recurring],
	    eventRefiners: SIMPLE_RECURRING_REFINERS,
	});
	function expandRanges(daysOfWeek, startTime, framingRange, dateEnv) {
	    var dowHash = daysOfWeek ? arrayToHash(daysOfWeek) : null;
	    var dayMarker = startOfDay(framingRange.start);
	    var endMarker = framingRange.end;
	    var instanceStarts = [];
	    while (dayMarker < endMarker) {
	        var instanceStart 
	        // if everyday, or this particular day-of-week
	        = void 0;
	        // if everyday, or this particular day-of-week
	        if (!dowHash || dowHash[dayMarker.getUTCDay()]) {
	            if (startTime) {
	                instanceStart = dateEnv.add(dayMarker, startTime);
	            }
	            else {
	                instanceStart = dayMarker;
	            }
	            instanceStarts.push(instanceStart);
	        }
	        dayMarker = addDays(dayMarker, 1);
	    }
	    return instanceStarts;
	}
	
	var changeHandlerPlugin = createPlugin({
	    optionChangeHandlers: {
	        events: function (events, context) {
	            handleEventSources([events], context);
	        },
	        eventSources: handleEventSources,
	    },
	});
	/*
	BUG: if `event` was supplied, all previously-given `eventSources` will be wiped out
	*/
	function handleEventSources(inputs, context) {
	    var unfoundSources = hashValuesToArray(context.getCurrentData().eventSources);
	    var newInputs = [];
	    for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
	        var input = inputs_1[_i];
	        var inputFound = false;
	        for (var i = 0; i < unfoundSources.length; i += 1) {
	            if (unfoundSources[i]._raw === input) {
	                unfoundSources.splice(i, 1); // delete
	                inputFound = true;
	                break;
	            }
	        }
	        if (!inputFound) {
	            newInputs.push(input);
	        }
	    }
	    for (var _a = 0, unfoundSources_1 = unfoundSources; _a < unfoundSources_1.length; _a++) {
	        var unfoundSource = unfoundSources_1[_a];
	        context.dispatch({
	            type: 'REMOVE_EVENT_SOURCE',
	            sourceId: unfoundSource.sourceId,
	        });
	    }
	    for (var _b = 0, newInputs_1 = newInputs; _b < newInputs_1.length; _b++) {
	        var newInput = newInputs_1[_b];
	        context.calendarApi.addEventSource(newInput);
	    }
	}
	
	function handleDateProfile(dateProfile, context) {
	    context.emitter.trigger('datesSet', tslib.__assign(tslib.__assign({}, buildRangeApiWithTimeZone(dateProfile.activeRange, context.dateEnv)), { view: context.viewApi }));
	}
	
	function handleEventStore(eventStore, context) {
	    var emitter = context.emitter;
	    if (emitter.hasHandlers('eventsSet')) {
	        emitter.trigger('eventsSet', buildEventApis(eventStore, context));
	    }
	}
	
	/*
	this array is exposed on the root namespace so that UMD plugins can add to it.
	see the rollup-bundles script.
	*/
	var globalPlugins = [
	    arrayEventSourcePlugin,
	    funcEventSourcePlugin,
	    jsonFeedEventSourcePlugin,
	    simpleRecurringEventsPlugin,
	    changeHandlerPlugin,
	    createPlugin({
	        isLoadingFuncs: [
	            function (state) { return computeEventSourcesLoading(state.eventSources); },
	        ],
	        contentTypeHandlers: {
	            html: buildHtmlRenderer,
	            domNodes: buildDomNodeRenderer,
	        },
	        propSetHandlers: {
	            dateProfile: handleDateProfile,
	            eventStore: handleEventStore,
	        },
	    }),
	];
	function buildHtmlRenderer() {
	    var currentEl = null;
	    var currentHtml = '';
	    function render(el, html) {
	        if (el !== currentEl || html !== currentHtml) {
	            el.innerHTML = html;
	        }
	        currentEl = el;
	        currentHtml = html;
	    }
	    function destroy() {
	        currentEl.innerHTML = '';
	        currentEl = null;
	        currentHtml = '';
	    }
	    return { render: render, destroy: destroy };
	}
	function buildDomNodeRenderer() {
	    var currentEl = null;
	    var currentDomNodes = [];
	    function render(el, domNodes) {
	        var newDomNodes = Array.prototype.slice.call(domNodes);
	        if (el !== currentEl || !isArraysEqual(currentDomNodes, newDomNodes)) {
	            // append first, remove second (for scroll resetting)
	            for (var _i = 0, newDomNodes_1 = newDomNodes; _i < newDomNodes_1.length; _i++) {
	                var newNode = newDomNodes_1[_i];
	                el.appendChild(newNode);
	            }
	            destroy();
	        }
	        currentEl = el;
	        currentDomNodes = newDomNodes;
	    }
	    function destroy() {
	        currentDomNodes.forEach(removeElement);
	        currentDomNodes = [];
	        currentEl = null;
	    }
	    return { render: render, destroy: destroy };
	}
	
	var DelayedRunner = /** @class */ (function () {
	    function DelayedRunner(drainedOption) {
	        this.drainedOption = drainedOption;
	        this.isRunning = false;
	        this.isDirty = false;
	        this.pauseDepths = {};
	        this.timeoutId = 0;
	    }
	    DelayedRunner.prototype.request = function (delay) {
	        this.isDirty = true;
	        if (!this.isPaused()) {
	            this.clearTimeout();
	            if (delay == null) {
	                this.tryDrain();
	            }
	            else {
	                this.timeoutId = setTimeout(// NOT OPTIMAL! TODO: look at debounce
	                this.tryDrain.bind(this), delay);
	            }
	        }
	    };
	    DelayedRunner.prototype.pause = function (scope) {
	        if (scope === void 0) { scope = ''; }
	        var pauseDepths = this.pauseDepths;
	        pauseDepths[scope] = (pauseDepths[scope] || 0) + 1;
	        this.clearTimeout();
	    };
	    DelayedRunner.prototype.resume = function (scope, force) {
	        if (scope === void 0) { scope = ''; }
	        var pauseDepths = this.pauseDepths;
	        if (scope in pauseDepths) {
	            if (force) {
	                delete pauseDepths[scope];
	            }
	            else {
	                pauseDepths[scope] -= 1;
	                var depth = pauseDepths[scope];
	                if (depth <= 0) {
	                    delete pauseDepths[scope];
	                }
	            }
	            this.tryDrain();
	        }
	    };
	    DelayedRunner.prototype.isPaused = function () {
	        return Object.keys(this.pauseDepths).length;
	    };
	    DelayedRunner.prototype.tryDrain = function () {
	        if (!this.isRunning && !this.isPaused()) {
	            this.isRunning = true;
	            while (this.isDirty) {
	                this.isDirty = false;
	                this.drained(); // might set isDirty to true again
	            }
	            this.isRunning = false;
	        }
	    };
	    DelayedRunner.prototype.clear = function () {
	        this.clearTimeout();
	        this.isDirty = false;
	        this.pauseDepths = {};
	    };
	    DelayedRunner.prototype.clearTimeout = function () {
	        if (this.timeoutId) {
	            clearTimeout(this.timeoutId);
	            this.timeoutId = 0;
	        }
	    };
	    DelayedRunner.prototype.drained = function () {
	        if (this.drainedOption) {
	            this.drainedOption();
	        }
	    };
	    return DelayedRunner;
	}());
	
	var TaskRunner = /** @class */ (function () {
	    function TaskRunner(runTaskOption, drainedOption) {
	        this.runTaskOption = runTaskOption;
	        this.drainedOption = drainedOption;
	        this.queue = [];
	        this.delayedRunner = new DelayedRunner(this.drain.bind(this));
	    }
	    TaskRunner.prototype.request = function (task, delay) {
	        this.queue.push(task);
	        this.delayedRunner.request(delay);
	    };
	    TaskRunner.prototype.pause = function (scope) {
	        this.delayedRunner.pause(scope);
	    };
	    TaskRunner.prototype.resume = function (scope, force) {
	        this.delayedRunner.resume(scope, force);
	    };
	    TaskRunner.prototype.drain = function () {
	        var queue = this.queue;
	        while (queue.length) {
	            var completedTasks = [];
	            var task = void 0;
	            while ((task = queue.shift())) {
	                this.runTask(task);
	                completedTasks.push(task);
	            }
	            this.drained(completedTasks);
	        } // keep going, in case new tasks were added in the drained handler
	    };
	    TaskRunner.prototype.runTask = function (task) {
	        if (this.runTaskOption) {
	            this.runTaskOption(task);
	        }
	    };
	    TaskRunner.prototype.drained = function (completedTasks) {
	        if (this.drainedOption) {
	            this.drainedOption(completedTasks);
	        }
	    };
	    return TaskRunner;
	}());
	
	// Computes what the title at the top of the calendarApi should be for this view
	function buildTitle(dateProfile, viewOptions, dateEnv) {
	    var range;
	    // for views that span a large unit of time, show the proper interval, ignoring stray days before and after
	    if (/^(year|month)$/.test(dateProfile.currentRangeUnit)) {
	        range = dateProfile.currentRange;
	    }
	    else { // for day units or smaller, use the actual day range
	        range = dateProfile.activeRange;
	    }
	    return dateEnv.formatRange(range.start, range.end, createFormatter(viewOptions.titleFormat || buildTitleFormat(dateProfile)), {
	        isEndExclusive: dateProfile.isRangeAllDay,
	        defaultSeparator: viewOptions.titleRangeSeparator,
	    });
	}
	// Generates the format string that should be used to generate the title for the current date range.
	// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
	function buildTitleFormat(dateProfile) {
	    var currentRangeUnit = dateProfile.currentRangeUnit;
	    if (currentRangeUnit === 'year') {
	        return { year: 'numeric' };
	    }
	    if (currentRangeUnit === 'month') {
	        return { year: 'numeric', month: 'long' }; // like "September 2014"
	    }
	    var days = diffWholeDays(dateProfile.currentRange.start, dateProfile.currentRange.end);
	    if (days !== null && days > 1) {
	        // multi-day range. shorter, like "Sep 9 - 10 2014"
	        return { year: 'numeric', month: 'short', day: 'numeric' };
	    }
	    // one day. longer, like "September 9 2014"
	    return { year: 'numeric', month: 'long', day: 'numeric' };
	}
	
	// in future refactor, do the redux-style function(state=initial) for initial-state
	// also, whatever is happening in constructor, have it happen in action queue too
	var CalendarDataManager = /** @class */ (function () {
	    function CalendarDataManager(props) {
	        var _this = this;
	        this.computeOptionsData = memoize(this._computeOptionsData);
	        this.computeCurrentViewData = memoize(this._computeCurrentViewData);
	        this.organizeRawLocales = memoize(organizeRawLocales);
	        this.buildLocale = memoize(buildLocale);
	        this.buildPluginHooks = buildBuildPluginHooks();
	        this.buildDateEnv = memoize(buildDateEnv);
	        this.buildTheme = memoize(buildTheme);
	        this.parseToolbars = memoize(parseToolbars);
	        this.buildViewSpecs = memoize(buildViewSpecs);
	        this.buildDateProfileGenerator = memoizeObjArg(buildDateProfileGenerator);
	        this.buildViewApi = memoize(buildViewApi);
	        this.buildViewUiProps = memoizeObjArg(buildViewUiProps);
	        this.buildEventUiBySource = memoize(buildEventUiBySource, isPropsEqual);
	        this.buildEventUiBases = memoize(buildEventUiBases);
	        this.parseContextBusinessHours = memoizeObjArg(parseContextBusinessHours);
	        this.buildTitle = memoize(buildTitle);
	        this.emitter = new Emitter();
	        this.actionRunner = new TaskRunner(this._handleAction.bind(this), this.updateData.bind(this));
	        this.currentCalendarOptionsInput = {};
	        this.currentCalendarOptionsRefined = {};
	        this.currentViewOptionsInput = {};
	        this.currentViewOptionsRefined = {};
	        this.currentCalendarOptionsRefiners = {};
	        this.getCurrentData = function () { return _this.data; };
	        this.dispatch = function (action) {
	            _this.actionRunner.request(action); // protects against recursive calls to _handleAction
	        };
	        this.props = props;
	        this.actionRunner.pause();
	        var dynamicOptionOverrides = {};
	        var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
	        var currentViewType = optionsData.calendarOptions.initialView || optionsData.pluginHooks.initialView;
	        var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
	        // wire things up
	        // TODO: not DRY
	        props.calendarApi.currentDataManager = this;
	        this.emitter.setThisContext(props.calendarApi);
	        this.emitter.setOptions(currentViewData.options);
	        var currentDate = getInitialDate(optionsData.calendarOptions, optionsData.dateEnv);
	        var dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
	        if (!rangeContainsMarker(dateProfile.activeRange, currentDate)) {
	            currentDate = dateProfile.currentRange.start;
	        }
	        var calendarContext = {
	            dateEnv: optionsData.dateEnv,
	            options: optionsData.calendarOptions,
	            pluginHooks: optionsData.pluginHooks,
	            calendarApi: props.calendarApi,
	            dispatch: this.dispatch,
	            emitter: this.emitter,
	            getCurrentData: this.getCurrentData,
	        };
	        // needs to be after setThisContext
	        for (var _i = 0, _a = optionsData.pluginHooks.contextInit; _i < _a.length; _i++) {
	            var callback = _a[_i];
	            callback(calendarContext);
	        }
	        // NOT DRY
	        var eventSources = initEventSources(optionsData.calendarOptions, dateProfile, calendarContext);
	        var initialState = {
	            dynamicOptionOverrides: dynamicOptionOverrides,
	            currentViewType: currentViewType,
	            currentDate: currentDate,
	            dateProfile: dateProfile,
	            businessHours: this.parseContextBusinessHours(calendarContext),
	            eventSources: eventSources,
	            eventUiBases: {},
	            eventStore: createEmptyEventStore(),
	            renderableEventStore: createEmptyEventStore(),
	            dateSelection: null,
	            eventSelection: '',
	            eventDrag: null,
	            eventResize: null,
	            selectionConfig: this.buildViewUiProps(calendarContext).selectionConfig,
	        };
	        var contextAndState = tslib.__assign(tslib.__assign({}, calendarContext), initialState);
	        for (var _b = 0, _c = optionsData.pluginHooks.reducers; _b < _c.length; _b++) {
	            var reducer = _c[_b];
	            tslib.__assign(initialState, reducer(null, null, contextAndState));
	        }
	        if (computeIsLoading(initialState, calendarContext)) {
	            this.emitter.trigger('loading', true); // NOT DRY
	        }
	        this.state = initialState;
	        this.updateData();
	        this.actionRunner.resume();
	    }
	    CalendarDataManager.prototype.resetOptions = function (optionOverrides, append) {
	        var props = this.props;
	        props.optionOverrides = append
	            ? tslib.__assign(tslib.__assign({}, props.optionOverrides), optionOverrides) : optionOverrides;
	        this.actionRunner.request({
	            type: 'NOTHING',
	        });
	    };
	    CalendarDataManager.prototype._handleAction = function (action) {
	        var _a = this, props = _a.props, state = _a.state, emitter = _a.emitter;
	        var dynamicOptionOverrides = reduceDynamicOptionOverrides(state.dynamicOptionOverrides, action);
	        var optionsData = this.computeOptionsData(props.optionOverrides, dynamicOptionOverrides, props.calendarApi);
	        var currentViewType = reduceViewType(state.currentViewType, action);
	        var currentViewData = this.computeCurrentViewData(currentViewType, optionsData, props.optionOverrides, dynamicOptionOverrides);
	        // wire things up
	        // TODO: not DRY
	        props.calendarApi.currentDataManager = this;
	        emitter.setThisContext(props.calendarApi);
	        emitter.setOptions(currentViewData.options);
	        var calendarContext = {
	            dateEnv: optionsData.dateEnv,
	            options: optionsData.calendarOptions,
	            pluginHooks: optionsData.pluginHooks,
	            calendarApi: props.calendarApi,
	            dispatch: this.dispatch,
	            emitter: emitter,
	            getCurrentData: this.getCurrentData,
	        };
	        var currentDate = state.currentDate, dateProfile = state.dateProfile;
	        if (this.data && this.data.dateProfileGenerator !== currentViewData.dateProfileGenerator) { // hack
	            dateProfile = currentViewData.dateProfileGenerator.build(currentDate);
	        }
	        currentDate = reduceCurrentDate(currentDate, action);
	        dateProfile = reduceDateProfile(dateProfile, action, currentDate, currentViewData.dateProfileGenerator);
	        if (action.type === 'PREV' || // TODO: move this logic into DateProfileGenerator
	            action.type === 'NEXT' || // "
	            !rangeContainsMarker(dateProfile.currentRange, currentDate)) {
	            currentDate = dateProfile.currentRange.start;
	        }
	        var eventSources = reduceEventSources(state.eventSources, action, dateProfile, calendarContext);
	        var eventStore = reduceEventStore(state.eventStore, action, eventSources, dateProfile, calendarContext);
	        var isEventsLoading = computeEventSourcesLoading(eventSources); // BAD. also called in this func in computeIsLoading
	        var renderableEventStore = (isEventsLoading && !currentViewData.options.progressiveEventRendering) ?
	            (state.renderableEventStore || eventStore) : // try from previous state
	            eventStore;
	        var _b = this.buildViewUiProps(calendarContext), eventUiSingleBase = _b.eventUiSingleBase, selectionConfig = _b.selectionConfig; // will memoize obj
	        var eventUiBySource = this.buildEventUiBySource(eventSources);
	        var eventUiBases = this.buildEventUiBases(renderableEventStore.defs, eventUiSingleBase, eventUiBySource);
	        var newState = {
	            dynamicOptionOverrides: dynamicOptionOverrides,
	            currentViewType: currentViewType,
	            currentDate: currentDate,
	            dateProfile: dateProfile,
	            eventSources: eventSources,
	            eventStore: eventStore,
	            renderableEventStore: renderableEventStore,
	            selectionConfig: selectionConfig,
	            eventUiBases: eventUiBases,
	            businessHours: this.parseContextBusinessHours(calendarContext),
	            dateSelection: reduceDateSelection(state.dateSelection, action),
	            eventSelection: reduceSelectedEvent(state.eventSelection, action),
	            eventDrag: reduceEventDrag(state.eventDrag, action),
	            eventResize: reduceEventResize(state.eventResize, action),
	        };
	        var contextAndState = tslib.__assign(tslib.__assign({}, calendarContext), newState);
	        for (var _i = 0, _c = optionsData.pluginHooks.reducers; _i < _c.length; _i++) {
	            var reducer = _c[_i];
	            tslib.__assign(newState, reducer(state, action, contextAndState)); // give the OLD state, for old value
	        }
	        var wasLoading = computeIsLoading(state, calendarContext);
	        var isLoading = computeIsLoading(newState, calendarContext);
	        // TODO: use propSetHandlers in plugin system
	        if (!wasLoading && isLoading) {
	            emitter.trigger('loading', true);
	        }
	        else if (wasLoading && !isLoading) {
	            emitter.trigger('loading', false);
	        }
	        this.state = newState;
	        if (props.onAction) {
	            props.onAction(action);
	        }
	    };
	    CalendarDataManager.prototype.updateData = function () {
	        var _a = this, props = _a.props, state = _a.state;
	        var oldData = this.data;
	        var optionsData = this.computeOptionsData(props.optionOverrides, state.dynamicOptionOverrides, props.calendarApi);
	        var currentViewData = this.computeCurrentViewData(state.currentViewType, optionsData, props.optionOverrides, state.dynamicOptionOverrides);
	        var data = this.data = tslib.__assign(tslib.__assign(tslib.__assign({ viewTitle: this.buildTitle(state.dateProfile, currentViewData.options, optionsData.dateEnv), calendarApi: props.calendarApi, dispatch: this.dispatch, emitter: this.emitter, getCurrentData: this.getCurrentData }, optionsData), currentViewData), state);
	        var changeHandlers = optionsData.pluginHooks.optionChangeHandlers;
	        var oldCalendarOptions = oldData && oldData.calendarOptions;
	        var newCalendarOptions = optionsData.calendarOptions;
	        if (oldCalendarOptions && oldCalendarOptions !== newCalendarOptions) {
	            if (oldCalendarOptions.timeZone !== newCalendarOptions.timeZone) {
	                // hack
	                state.eventSources = data.eventSources = reduceEventSourcesNewTimeZone(data.eventSources, state.dateProfile, data);
	                state.eventStore = data.eventStore = rezoneEventStoreDates(data.eventStore, oldData.dateEnv, data.dateEnv);
	            }
	            for (var optionName in changeHandlers) {
	                if (oldCalendarOptions[optionName] !== newCalendarOptions[optionName]) {
	                    changeHandlers[optionName](newCalendarOptions[optionName], data);
	                }
	            }
	        }
	        if (props.onData) {
	            props.onData(data);
	        }
	    };
	    CalendarDataManager.prototype._computeOptionsData = function (optionOverrides, dynamicOptionOverrides, calendarApi) {
	        // TODO: blacklist options that are handled by optionChangeHandlers
	        var _a = this.processRawCalendarOptions(optionOverrides, dynamicOptionOverrides), refinedOptions = _a.refinedOptions, pluginHooks = _a.pluginHooks, localeDefaults = _a.localeDefaults, availableLocaleData = _a.availableLocaleData, extra = _a.extra;
	        warnUnknownOptions(extra);
	        var dateEnv = this.buildDateEnv(refinedOptions.timeZone, refinedOptions.locale, refinedOptions.weekNumberCalculation, refinedOptions.firstDay, refinedOptions.weekText, pluginHooks, availableLocaleData, refinedOptions.defaultRangeSeparator);
	        var viewSpecs = this.buildViewSpecs(pluginHooks.views, optionOverrides, dynamicOptionOverrides, localeDefaults);
	        var theme = this.buildTheme(refinedOptions, pluginHooks);
	        var toolbarConfig = this.parseToolbars(refinedOptions, optionOverrides, theme, viewSpecs, calendarApi);
	        return {
	            calendarOptions: refinedOptions,
	            pluginHooks: pluginHooks,
	            dateEnv: dateEnv,
	            viewSpecs: viewSpecs,
	            theme: theme,
	            toolbarConfig: toolbarConfig,
	            localeDefaults: localeDefaults,
	            availableRawLocales: availableLocaleData.map,
	        };
	    };
	    // always called from behind a memoizer
	    CalendarDataManager.prototype.processRawCalendarOptions = function (optionOverrides, dynamicOptionOverrides) {
	        var _a = mergeRawOptions([
	            BASE_OPTION_DEFAULTS,
	            optionOverrides,
	            dynamicOptionOverrides,
	        ]), locales = _a.locales, locale = _a.locale;
	        var availableLocaleData = this.organizeRawLocales(locales);
	        var availableRawLocales = availableLocaleData.map;
	        var localeDefaults = this.buildLocale(locale || availableLocaleData.defaultCode, availableRawLocales).options;
	        var pluginHooks = this.buildPluginHooks(optionOverrides.plugins || [], globalPlugins);
	        var refiners = this.currentCalendarOptionsRefiners = tslib.__assign(tslib.__assign(tslib.__assign(tslib.__assign(tslib.__assign({}, BASE_OPTION_REFINERS), CALENDAR_LISTENER_REFINERS), CALENDAR_OPTION_REFINERS), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
	        var extra = {};
	        var raw = mergeRawOptions([
	            BASE_OPTION_DEFAULTS,
	            localeDefaults,
	            optionOverrides,
	            dynamicOptionOverrides,
	        ]);
	        var refined = {};
	        var currentRaw = this.currentCalendarOptionsInput;
	        var currentRefined = this.currentCalendarOptionsRefined;
	        var anyChanges = false;
	        for (var optionName in raw) {
	            if (optionName !== 'plugins') { // because plugins is special-cased
	                if (raw[optionName] === currentRaw[optionName] ||
	                    (COMPLEX_OPTION_COMPARATORS[optionName] &&
	                        (optionName in currentRaw) &&
	                        COMPLEX_OPTION_COMPARATORS[optionName](currentRaw[optionName], raw[optionName]))) {
	                    refined[optionName] = currentRefined[optionName];
	                }
	                else if (refiners[optionName]) {
	                    refined[optionName] = refiners[optionName](raw[optionName]);
	                    anyChanges = true;
	                }
	                else {
	                    extra[optionName] = currentRaw[optionName];
	                }
	            }
	        }
	        if (anyChanges) {
	            this.currentCalendarOptionsInput = raw;
	            this.currentCalendarOptionsRefined = refined;
	        }
	        return {
	            rawOptions: this.currentCalendarOptionsInput,
	            refinedOptions: this.currentCalendarOptionsRefined,
	            pluginHooks: pluginHooks,
	            availableLocaleData: availableLocaleData,
	            localeDefaults: localeDefaults,
	            extra: extra,
	        };
	    };
	    CalendarDataManager.prototype._computeCurrentViewData = function (viewType, optionsData, optionOverrides, dynamicOptionOverrides) {
	        var viewSpec = optionsData.viewSpecs[viewType];
	        if (!viewSpec) {
	            throw new Error("viewType \"" + viewType + "\" is not available. Please make sure you've loaded all neccessary plugins");
	        }
	        var _a = this.processRawViewOptions(viewSpec, optionsData.pluginHooks, optionsData.localeDefaults, optionOverrides, dynamicOptionOverrides), refinedOptions = _a.refinedOptions, extra = _a.extra;
	        warnUnknownOptions(extra);
	        var dateProfileGenerator = this.buildDateProfileGenerator({
	            dateProfileGeneratorClass: viewSpec.optionDefaults.dateProfileGeneratorClass,
	            duration: viewSpec.duration,
	            durationUnit: viewSpec.durationUnit,
	            usesMinMaxTime: viewSpec.optionDefaults.usesMinMaxTime,
	            dateEnv: optionsData.dateEnv,
	            calendarApi: this.props.calendarApi,
	            slotMinTime: refinedOptions.slotMinTime,
	            slotMaxTime: refinedOptions.slotMaxTime,
	            showNonCurrentDates: refinedOptions.showNonCurrentDates,
	            dayCount: refinedOptions.dayCount,
	            dateAlignment: refinedOptions.dateAlignment,
	            dateIncrement: refinedOptions.dateIncrement,
	            hiddenDays: refinedOptions.hiddenDays,
	            weekends: refinedOptions.weekends,
	            nowInput: refinedOptions.now,
	            validRangeInput: refinedOptions.validRange,
	            visibleRangeInput: refinedOptions.visibleRange,
	            monthMode: refinedOptions.monthMode,
	            fixedWeekCount: refinedOptions.fixedWeekCount,
	        });
	        var viewApi = this.buildViewApi(viewType, this.getCurrentData, optionsData.dateEnv);
	        return { viewSpec: viewSpec, options: refinedOptions, dateProfileGenerator: dateProfileGenerator, viewApi: viewApi };
	    };
	    CalendarDataManager.prototype.processRawViewOptions = function (viewSpec, pluginHooks, localeDefaults, optionOverrides, dynamicOptionOverrides) {
	        var raw = mergeRawOptions([
	            BASE_OPTION_DEFAULTS,
	            viewSpec.optionDefaults,
	            localeDefaults,
	            optionOverrides,
	            viewSpec.optionOverrides,
	            dynamicOptionOverrides,
	        ]);
	        var refiners = tslib.__assign(tslib.__assign(tslib.__assign(tslib.__assign(tslib.__assign(tslib.__assign({}, BASE_OPTION_REFINERS), CALENDAR_LISTENER_REFINERS), CALENDAR_OPTION_REFINERS), VIEW_OPTION_REFINERS), pluginHooks.listenerRefiners), pluginHooks.optionRefiners);
	        var refined = {};
	        var currentRaw = this.currentViewOptionsInput;
	        var currentRefined = this.currentViewOptionsRefined;
	        var anyChanges = false;
	        var extra = {};
	        for (var optionName in raw) {
	            if (raw[optionName] === currentRaw[optionName] ||
	                (COMPLEX_OPTION_COMPARATORS[optionName] &&
	                    COMPLEX_OPTION_COMPARATORS[optionName](raw[optionName], currentRaw[optionName]))) {
	                refined[optionName] = currentRefined[optionName];
	            }
	            else {
	                if (raw[optionName] === this.currentCalendarOptionsInput[optionName] ||
	                    (COMPLEX_OPTION_COMPARATORS[optionName] &&
	                        COMPLEX_OPTION_COMPARATORS[optionName](raw[optionName], this.currentCalendarOptionsInput[optionName]))) {
	                    if (optionName in this.currentCalendarOptionsRefined) { // might be an "extra" prop
	                        refined[optionName] = this.currentCalendarOptionsRefined[optionName];
	                    }
	                }
	                else if (refiners[optionName]) {
	                    refined[optionName] = refiners[optionName](raw[optionName]);
	                }
	                else {
	                    extra[optionName] = raw[optionName];
	                }
	                anyChanges = true;
	            }
	        }
	        if (anyChanges) {
	            this.currentViewOptionsInput = raw;
	            this.currentViewOptionsRefined = refined;
	        }
	        return {
	            rawOptions: this.currentViewOptionsInput,
	            refinedOptions: this.currentViewOptionsRefined,
	            extra: extra,
	        };
	    };
	    return CalendarDataManager;
	}());
	function buildDateEnv(timeZone, explicitLocale, weekNumberCalculation, firstDay, weekText, pluginHooks, availableLocaleData, defaultSeparator) {
	    var locale = buildLocale(explicitLocale || availableLocaleData.defaultCode, availableLocaleData.map);
	    return new DateEnv({
	        calendarSystem: 'gregory',
	        timeZone: timeZone,
	        namedTimeZoneImpl: pluginHooks.namedTimeZonedImpl,
	        locale: locale,
	        weekNumberCalculation: weekNumberCalculation,
	        firstDay: firstDay,
	        weekText: weekText,
	        cmdFormatter: pluginHooks.cmdFormatter,
	        defaultSeparator: defaultSeparator,
	    });
	}
	function buildTheme(options, pluginHooks) {
	    var ThemeClass = pluginHooks.themeClasses[options.themeSystem] || StandardTheme;
	    return new ThemeClass(options);
	}
	function buildDateProfileGenerator(props) {
	    var DateProfileGeneratorClass = props.dateProfileGeneratorClass || DateProfileGenerator;
	    return new DateProfileGeneratorClass(props);
	}
	function buildViewApi(type, getCurrentData, dateEnv) {
	    return new ViewApi(type, getCurrentData, dateEnv);
	}
	function buildEventUiBySource(eventSources) {
	    return mapHash(eventSources, function (eventSource) { return eventSource.ui; });
	}
	function buildEventUiBases(eventDefs, eventUiSingleBase, eventUiBySource) {
	    var eventUiBases = { '': eventUiSingleBase };
	    for (var defId in eventDefs) {
	        var def = eventDefs[defId];
	        if (def.sourceId && eventUiBySource[def.sourceId]) {
	            eventUiBases[defId] = eventUiBySource[def.sourceId];
	        }
	    }
	    return eventUiBases;
	}
	function buildViewUiProps(calendarContext) {
	    var options = calendarContext.options;
	    return {
	        eventUiSingleBase: createEventUi({
	            display: options.eventDisplay,
	            editable: options.editable,
	            startEditable: options.eventStartEditable,
	            durationEditable: options.eventDurationEditable,
	            constraint: options.eventConstraint,
	            overlap: typeof options.eventOverlap === 'boolean' ? options.eventOverlap : undefined,
	            allow: options.eventAllow,
	            backgroundColor: options.eventBackgroundColor,
	            borderColor: options.eventBorderColor,
	            textColor: options.eventTextColor,
	            color: options.eventColor,
	            // classNames: options.eventClassNames // render hook will handle this
	        }, calendarContext),
	        selectionConfig: createEventUi({
	            constraint: options.selectConstraint,
	            overlap: typeof options.selectOverlap === 'boolean' ? options.selectOverlap : undefined,
	            allow: options.selectAllow,
	        }, calendarContext),
	    };
	}
	function computeIsLoading(state, context) {
	    for (var _i = 0, _a = context.pluginHooks.isLoadingFuncs; _i < _a.length; _i++) {
	        var isLoadingFunc = _a[_i];
	        if (isLoadingFunc(state)) {
	            return true;
	        }
	    }
	    return false;
	}
	function parseContextBusinessHours(calendarContext) {
	    return parseBusinessHours(calendarContext.options.businessHours, calendarContext);
	}
	function warnUnknownOptions(options, viewName) {
	    for (var optionName in options) {
	        console.warn("Unknown option '" + optionName + "'" +
	            (viewName ? " for view '" + viewName + "'" : ''));
	    }
	}
	
	// TODO: move this to react plugin?
	var CalendarDataProvider = /** @class */ (function (_super) {
	    tslib.__extends(CalendarDataProvider, _super);
	    function CalendarDataProvider(props) {
	        var _this = _super.call(this, props) || this;
	        _this.handleData = function (data) {
	            if (!_this.dataManager) { // still within initial run, before assignment in constructor
	                // eslint-disable-next-line react/no-direct-mutation-state
	                _this.state = data; // can't use setState yet
	            }
	            else {
	                _this.setState(data);
	            }
	        };
	        _this.dataManager = new CalendarDataManager({
	            optionOverrides: props.optionOverrides,
	            calendarApi: props.calendarApi,
	            onData: _this.handleData,
	        });
	        return _this;
	    }
	    CalendarDataProvider.prototype.render = function () {
	        return this.props.children(this.state);
	    };
	    CalendarDataProvider.prototype.componentDidUpdate = function (prevProps) {
	        var newOptionOverrides = this.props.optionOverrides;
	        if (newOptionOverrides !== prevProps.optionOverrides) { // prevent recursive handleData
	            this.dataManager.resetOptions(newOptionOverrides);
	        }
	    };
	    return CalendarDataProvider;
	}(vdom_cjs.Component));
	
	// HELPERS
	/*
	if nextDayThreshold is specified, slicing is done in an all-day fashion.
	you can get nextDayThreshold from context.nextDayThreshold
	*/
	function sliceEvents(props, allDay) {
	    return sliceEventStore(props.eventStore, props.eventUiBases, props.dateProfile.activeRange, allDay ? props.nextDayThreshold : null).fg;
	}
	
	var NamedTimeZoneImpl = /** @class */ (function () {
	    function NamedTimeZoneImpl(timeZoneName) {
	        this.timeZoneName = timeZoneName;
	    }
	    return NamedTimeZoneImpl;
	}());
	
	var SegHierarchy = /** @class */ (function () {
	    function SegHierarchy() {
	        // settings
	        this.strictOrder = false;
	        this.allowReslicing = false;
	        this.maxCoord = -1; // -1 means no max
	        this.maxStackCnt = -1; // -1 means no max
	        this.levelCoords = []; // ordered
	        this.entriesByLevel = []; // parallel with levelCoords
	        this.stackCnts = {}; // TODO: use better technique!?
	    }
	    SegHierarchy.prototype.addSegs = function (inputs) {
	        var hiddenEntries = [];
	        for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
	            var input = inputs_1[_i];
	            this.insertEntry(input, hiddenEntries);
	        }
	        return hiddenEntries;
	    };
	    SegHierarchy.prototype.insertEntry = function (entry, hiddenEntries) {
	        var insertion = this.findInsertion(entry);
	        if (this.isInsertionValid(insertion, entry)) {
	            this.insertEntryAt(entry, insertion);
	            return 1;
	        }
	        return this.handleInvalidInsertion(insertion, entry, hiddenEntries);
	    };
	    SegHierarchy.prototype.isInsertionValid = function (insertion, entry) {
	        return (this.maxCoord === -1 || insertion.levelCoord + entry.thickness <= this.maxCoord) &&
	            (this.maxStackCnt === -1 || insertion.stackCnt < this.maxStackCnt);
	    };
	    // returns number of new entries inserted
	    SegHierarchy.prototype.handleInvalidInsertion = function (insertion, entry, hiddenEntries) {
	        if (this.allowReslicing && insertion.touchingEntry) {
	            return this.splitEntry(entry, insertion.touchingEntry, hiddenEntries);
	        }
	        hiddenEntries.push(entry);
	        return 0;
	    };
	    SegHierarchy.prototype.splitEntry = function (entry, barrier, hiddenEntries) {
	        var partCnt = 0;
	        var splitHiddenEntries = [];
	        var entrySpan = entry.span;
	        var barrierSpan = barrier.span;
	        if (entrySpan.start < barrierSpan.start) {
	            partCnt += this.insertEntry({
	                index: entry.index,
	                thickness: entry.thickness,
	                span: { start: entrySpan.start, end: barrierSpan.start },
	            }, splitHiddenEntries);
	        }
	        if (entrySpan.end > barrierSpan.end) {
	            partCnt += this.insertEntry({
	                index: entry.index,
	                thickness: entry.thickness,
	                span: { start: barrierSpan.end, end: entrySpan.end },
	            }, splitHiddenEntries);
	        }
	        if (partCnt) {
	            hiddenEntries.push.apply(hiddenEntries, tslib.__spreadArray([{
	                    index: entry.index,
	                    thickness: entry.thickness,
	                    span: intersectSpans(barrierSpan, entrySpan), // guaranteed to intersect
	                }], splitHiddenEntries));
	            return partCnt;
	        }
	        hiddenEntries.push(entry);
	        return 0;
	    };
	    SegHierarchy.prototype.insertEntryAt = function (entry, insertion) {
	        var _a = this, entriesByLevel = _a.entriesByLevel, levelCoords = _a.levelCoords;
	        if (insertion.lateral === -1) {
	            // create a new level
	            insertAt(levelCoords, insertion.level, insertion.levelCoord);
	            insertAt(entriesByLevel, insertion.level, [entry]);
	        }
	        else {
	            // insert into existing level
	            insertAt(entriesByLevel[insertion.level], insertion.lateral, entry);
	        }
	        this.stackCnts[buildEntryKey(entry)] = insertion.stackCnt;
	    };
	    SegHierarchy.prototype.findInsertion = function (newEntry) {
	        var _a = this, levelCoords = _a.levelCoords, entriesByLevel = _a.entriesByLevel, strictOrder = _a.strictOrder, stackCnts = _a.stackCnts;
	        var levelCnt = levelCoords.length;
	        var candidateCoord = 0;
	        var touchingLevel = -1;
	        var touchingLateral = -1;
	        var touchingEntry = null;
	        var stackCnt = 0;
	        for (var trackingLevel = 0; trackingLevel < levelCnt; trackingLevel += 1) {
	            var trackingCoord = levelCoords[trackingLevel];
	            // if the current level is past the placed entry, we have found a good empty space and can stop.
	            // if strictOrder, keep finding more lateral intersections.
	            if (!strictOrder && trackingCoord >= candidateCoord + newEntry.thickness) {
	                break;
	            }
	            var trackingEntries = entriesByLevel[trackingLevel];
	            var trackingEntry = void 0;
	            var searchRes = binarySearch(trackingEntries, newEntry.span.start, getEntrySpanEnd); // find first entry after newEntry's end
	            var lateralIndex = searchRes[0] + searchRes[1]; // if exact match (which doesn't collide), go to next one
	            while ( // loop through entries that horizontally intersect
	            (trackingEntry = trackingEntries[lateralIndex]) && // but not past the whole entry list
	                trackingEntry.span.start < newEntry.span.end // and not entirely past newEntry
	            ) {
	                var trackingEntryBottom = trackingCoord + trackingEntry.thickness;
	                // intersects into the top of the candidate?
	                if (trackingEntryBottom > candidateCoord) {
	                    candidateCoord = trackingEntryBottom;
	                    touchingEntry = trackingEntry;
	                    touchingLevel = trackingLevel;
	                    touchingLateral = lateralIndex;
	                }
	                // butts up against top of candidate? (will happen if just intersected as well)
	                if (trackingEntryBottom === candidateCoord) {
	                    // accumulate the highest possible stackCnt of the trackingEntries that butt up
	                    stackCnt = Math.max(stackCnt, stackCnts[buildEntryKey(trackingEntry)] + 1);
	                }
	                lateralIndex += 1;
	            }
	        }
	        // the destination level will be after touchingEntry's level. find it
	        var destLevel = 0;
	        if (touchingEntry) {
	            destLevel = touchingLevel + 1;
	            while (destLevel < levelCnt && levelCoords[destLevel] < candidateCoord) {
	                destLevel += 1;
	            }
	        }
	        // if adding to an existing level, find where to insert
	        var destLateral = -1;
	        if (destLevel < levelCnt && levelCoords[destLevel] === candidateCoord) {
	            destLateral = binarySearch(entriesByLevel[destLevel], newEntry.span.end, getEntrySpanEnd)[0];
	        }
	        return {
	            touchingLevel: touchingLevel,
	            touchingLateral: touchingLateral,
	            touchingEntry: touchingEntry,
	            stackCnt: stackCnt,
	            levelCoord: candidateCoord,
	            level: destLevel,
	            lateral: destLateral,
	        };
	    };
	    // sorted by levelCoord (lowest to highest)
	    SegHierarchy.prototype.toRects = function () {
	        var _a = this, entriesByLevel = _a.entriesByLevel, levelCoords = _a.levelCoords;
	        var levelCnt = entriesByLevel.length;
	        var rects = [];
	        for (var level = 0; level < levelCnt; level += 1) {
	            var entries = entriesByLevel[level];
	            var levelCoord = levelCoords[level];
	            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
	                var entry = entries_1[_i];
	                rects.push(tslib.__assign(tslib.__assign({}, entry), { levelCoord: levelCoord }));
	            }
	        }
	        return rects;
	    };
	    return SegHierarchy;
	}());
	function getEntrySpanEnd(entry) {
	    return entry.span.end;
	}
	function buildEntryKey(entry) {
	    return entry.index + ':' + entry.span.start;
	}
	// returns groups with entries sorted by input order
	function groupIntersectingEntries(entries) {
	    var merges = [];
	    for (var _i = 0, entries_2 = entries; _i < entries_2.length; _i++) {
	        var entry = entries_2[_i];
	        var filteredMerges = [];
	        var hungryMerge = {
	            span: entry.span,
	            entries: [entry],
	        };
	        for (var _a = 0, merges_1 = merges; _a < merges_1.length; _a++) {
	            var merge = merges_1[_a];
	            if (intersectSpans(merge.span, hungryMerge.span)) {
	                hungryMerge = {
	                    entries: merge.entries.concat(hungryMerge.entries),
	                    span: joinSpans(merge.span, hungryMerge.span),
	                };
	            }
	            else {
	                filteredMerges.push(merge);
	            }
	        }
	        filteredMerges.push(hungryMerge);
	        merges = filteredMerges;
	    }
	    return merges;
	}
	function joinSpans(span0, span1) {
	    return {
	        start: Math.min(span0.start, span1.start),
	        end: Math.max(span0.end, span1.end),
	    };
	}
	function intersectSpans(span0, span1) {
	    var start = Math.max(span0.start, span1.start);
	    var end = Math.min(span0.end, span1.end);
	    if (start < end) {
	        return { start: start, end: end };
	    }
	    return null;
	}
	// general util
	// ---------------------------------------------------------------------------------------------------------------------
	function insertAt(arr, index, item) {
	    arr.splice(index, 0, item);
	}
	function binarySearch(a, searchVal, getItemVal) {
	    var startIndex = 0;
	    var endIndex = a.length; // exclusive
	    if (!endIndex || searchVal < getItemVal(a[startIndex])) { // no items OR before first item
	        return [0, 0];
	    }
	    if (searchVal > getItemVal(a[endIndex - 1])) { // after last item
	        return [endIndex, 0];
	    }
	    while (startIndex < endIndex) {
	        var middleIndex = Math.floor(startIndex + (endIndex - startIndex) / 2);
	        var middleVal = getItemVal(a[middleIndex]);
	        if (searchVal < middleVal) {
	            endIndex = middleIndex;
	        }
	        else if (searchVal > middleVal) {
	            startIndex = middleIndex + 1;
	        }
	        else { // equal!
	            return [middleIndex, 1];
	        }
	    }
	    return [startIndex, 0];
	}
	
	var Interaction = /** @class */ (function () {
	    function Interaction(settings) {
	        this.component = settings.component;
	        this.isHitComboAllowed = settings.isHitComboAllowed || null;
	    }
	    Interaction.prototype.destroy = function () {
	    };
	    return Interaction;
	}());
	function parseInteractionSettings(component, input) {
	    return {
	        component: component,
	        el: input.el,
	        useEventCenter: input.useEventCenter != null ? input.useEventCenter : true,
	        isHitComboAllowed: input.isHitComboAllowed || null,
	    };
	}
	function interactionSettingsToStore(settings) {
	    var _a;
	    return _a = {},
	        _a[settings.component.uid] = settings,
	        _a;
	}
	// global state
	var interactionSettingsStore = {};
	
	/*
	An abstraction for a dragging interaction originating on an event.
	Does higher-level things than PointerDragger, such as possibly:
	- a "mirror" that moves with the pointer
	- a minimum number of pixels or other criteria for a true drag to begin
	
	subclasses must emit:
	- pointerdown
	- dragstart
	- dragmove
	- pointerup
	- dragend
	*/
	var ElementDragging = /** @class */ (function () {
	    function ElementDragging(el, selector) {
	        this.emitter = new Emitter();
	    }
	    ElementDragging.prototype.destroy = function () {
	    };
	    ElementDragging.prototype.setMirrorIsVisible = function (bool) {
	        // optional if subclass doesn't want to support a mirror
	    };
	    ElementDragging.prototype.setMirrorNeedsRevert = function (bool) {
	        // optional if subclass doesn't want to support a mirror
	    };
	    ElementDragging.prototype.setAutoScrollEnabled = function (bool) {
	        // optional
	    };
	    return ElementDragging;
	}());
	
	// TODO: get rid of this in favor of options system,
	// tho it's really easy to access this globally rather than pass thru options.
	var config = {};
	
	/*
	Information about what will happen when an external element is dragged-and-dropped
	onto a calendar. Contains information for creating an event.
	*/
	var DRAG_META_REFINERS = {
	    startTime: createDuration,
	    duration: createDuration,
	    create: Boolean,
	    sourceId: String,
	};
	function parseDragMeta(raw) {
	    var _a = refineProps(raw, DRAG_META_REFINERS), refined = _a.refined, extra = _a.extra;
	    return {
	        startTime: refined.startTime || null,
	        duration: refined.duration || null,
	        create: refined.create != null ? refined.create : true,
	        sourceId: refined.sourceId,
	        leftoverProps: extra,
	    };
	}
	
	var ToolbarSection = /** @class */ (function (_super) {
	    tslib.__extends(ToolbarSection, _super);
	    function ToolbarSection() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ToolbarSection.prototype.render = function () {
	        var _this = this;
	        var children = this.props.widgetGroups.map(function (widgetGroup) { return _this.renderWidgetGroup(widgetGroup); });
	        return vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(['div', { className: 'fc-toolbar-chunk' }], children));
	    };
	    ToolbarSection.prototype.renderWidgetGroup = function (widgetGroup) {
	        var props = this.props;
	        var theme = this.context.theme;
	        var children = [];
	        var isOnlyButtons = true;
	        for (var _i = 0, widgetGroup_1 = widgetGroup; _i < widgetGroup_1.length; _i++) {
	            var widget = widgetGroup_1[_i];
	            var buttonName = widget.buttonName, buttonClick = widget.buttonClick, buttonText = widget.buttonText, buttonIcon = widget.buttonIcon, buttonHint = widget.buttonHint;
	            if (buttonName === 'title') {
	                isOnlyButtons = false;
	                children.push(vdom_cjs.createElement("h2", { className: "fc-toolbar-title", id: props.titleId }, props.title));
	            }
	            else {
	                var isPressed = buttonName === props.activeButton;
	                var isDisabled = (!props.isTodayEnabled && buttonName === 'today') ||
	                    (!props.isPrevEnabled && buttonName === 'prev') ||
	                    (!props.isNextEnabled && buttonName === 'next');
	                var buttonClasses = ["fc-" + buttonName + "-button", theme.getClass('button')];
	                if (isPressed) {
	                    buttonClasses.push(theme.getClass('buttonActive'));
	                }
	                children.push(vdom_cjs.createElement("button", { type: "button", title: typeof buttonHint === 'function' ? buttonHint(props.navUnit) : buttonHint, disabled: isDisabled, "aria-pressed": isPressed, className: buttonClasses.join(' '), onClick: buttonClick }, buttonText || (buttonIcon ? vdom_cjs.createElement("span", { className: buttonIcon }) : '')));
	            }
	        }
	        if (children.length > 1) {
	            var groupClassName = (isOnlyButtons && theme.getClass('buttonGroup')) || '';
	            return vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(['div', { className: groupClassName }], children));
	        }
	        return children[0];
	    };
	    return ToolbarSection;
	}(BaseComponent));
	
	var Toolbar = /** @class */ (function (_super) {
	    tslib.__extends(Toolbar, _super);
	    function Toolbar() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Toolbar.prototype.render = function () {
	        var _a = this.props, model = _a.model, extraClassName = _a.extraClassName;
	        var forceLtr = false;
	        var startContent;
	        var endContent;
	        var sectionWidgets = model.sectionWidgets;
	        var centerContent = sectionWidgets.center;
	        if (sectionWidgets.left) {
	            forceLtr = true;
	            startContent = sectionWidgets.left;
	        }
	        else {
	            startContent = sectionWidgets.start;
	        }
	        if (sectionWidgets.right) {
	            forceLtr = true;
	            endContent = sectionWidgets.right;
	        }
	        else {
	            endContent = sectionWidgets.end;
	        }
	        var classNames = [
	            extraClassName || '',
	            'fc-toolbar',
	            forceLtr ? 'fc-toolbar-ltr' : '',
	        ];
	        return (vdom_cjs.createElement("div", { className: classNames.join(' ') },
	            this.renderSection('start', startContent || []),
	            this.renderSection('center', centerContent || []),
	            this.renderSection('end', endContent || [])));
	    };
	    Toolbar.prototype.renderSection = function (key, widgetGroups) {
	        var props = this.props;
	        return (vdom_cjs.createElement(ToolbarSection, { key: key, widgetGroups: widgetGroups, title: props.title, navUnit: props.navUnit, activeButton: props.activeButton, isTodayEnabled: props.isTodayEnabled, isPrevEnabled: props.isPrevEnabled, isNextEnabled: props.isNextEnabled, titleId: props.titleId }));
	    };
	    return Toolbar;
	}(BaseComponent));
	
	// TODO: do function component?
	var ViewContainer = /** @class */ (function (_super) {
	    tslib.__extends(ViewContainer, _super);
	    function ViewContainer() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            availableWidth: null,
	        };
	        _this.handleEl = function (el) {
	            _this.el = el;
	            setRef(_this.props.elRef, el);
	            _this.updateAvailableWidth();
	        };
	        _this.handleResize = function () {
	            _this.updateAvailableWidth();
	        };
	        return _this;
	    }
	    ViewContainer.prototype.render = function () {
	        var _a = this, props = _a.props, state = _a.state;
	        var aspectRatio = props.aspectRatio;
	        var classNames = [
	            'fc-view-harness',
	            (aspectRatio || props.liquid || props.height)
	                ? 'fc-view-harness-active' // harness controls the height
	                : 'fc-view-harness-passive', // let the view do the height
	        ];
	        var height = '';
	        var paddingBottom = '';
	        if (aspectRatio) {
	            if (state.availableWidth !== null) {
	                height = state.availableWidth / aspectRatio;
	            }
	            else {
	                // while waiting to know availableWidth, we can't set height to *zero*
	                // because will cause lots of unnecessary scrollbars within scrollgrid.
	                // BETTER: don't start rendering ANYTHING yet until we know container width
	                // NOTE: why not always use paddingBottom? Causes height oscillation (issue 5606)
	                paddingBottom = (1 / aspectRatio) * 100 + "%";
	            }
	        }
	        else {
	            height = props.height || '';
	        }
	        return (vdom_cjs.createElement("div", { "aria-labelledby": props.labeledById, ref: this.handleEl, className: classNames.join(' '), style: { height: height, paddingBottom: paddingBottom } }, props.children));
	    };
	    ViewContainer.prototype.componentDidMount = function () {
	        this.context.addResizeHandler(this.handleResize);
	    };
	    ViewContainer.prototype.componentWillUnmount = function () {
	        this.context.removeResizeHandler(this.handleResize);
	    };
	    ViewContainer.prototype.updateAvailableWidth = function () {
	        if (this.el && // needed. but why?
	            this.props.aspectRatio // aspectRatio is the only height setting that needs availableWidth
	        ) {
	            this.setState({ availableWidth: this.el.offsetWidth });
	        }
	    };
	    return ViewContainer;
	}(BaseComponent));
	
	/*
	Detects when the user clicks on an event within a DateComponent
	*/
	var EventClicking = /** @class */ (function (_super) {
	    tslib.__extends(EventClicking, _super);
	    function EventClicking(settings) {
	        var _this = _super.call(this, settings) || this;
	        _this.handleSegClick = function (ev, segEl) {
	            var component = _this.component;
	            var context = component.context;
	            var seg = getElSeg(segEl);
	            if (seg && // might be the <div> surrounding the more link
	                component.isValidSegDownEl(ev.target)) {
	                // our way to simulate a link click for elements that can't be <a> tags
	                // grab before trigger fired in case trigger trashes DOM thru rerendering
	                var hasUrlContainer = elementClosest(ev.target, '.fc-event-forced-url');
	                var url = hasUrlContainer ? hasUrlContainer.querySelector('a[href]').href : '';
	                context.emitter.trigger('eventClick', {
	                    el: segEl,
	                    event: new EventApi(component.context, seg.eventRange.def, seg.eventRange.instance),
	                    jsEvent: ev,
	                    view: context.viewApi,
	                });
	                if (url && !ev.defaultPrevented) {
	                    window.location.href = url;
	                }
	            }
	        };
	        _this.destroy = listenBySelector(settings.el, 'click', '.fc-event', // on both fg and bg events
	        _this.handleSegClick);
	        return _this;
	    }
	    return EventClicking;
	}(Interaction));
	
	/*
	Triggers events and adds/removes core classNames when the user's pointer
	enters/leaves event-elements of a component.
	*/
	var EventHovering = /** @class */ (function (_super) {
	    tslib.__extends(EventHovering, _super);
	    function EventHovering(settings) {
	        var _this = _super.call(this, settings) || this;
	        // for simulating an eventMouseLeave when the event el is destroyed while mouse is over it
	        _this.handleEventElRemove = function (el) {
	            if (el === _this.currentSegEl) {
	                _this.handleSegLeave(null, _this.currentSegEl);
	            }
	        };
	        _this.handleSegEnter = function (ev, segEl) {
	            if (getElSeg(segEl)) { // TODO: better way to make sure not hovering over more+ link or its wrapper
	                _this.currentSegEl = segEl;
	                _this.triggerEvent('eventMouseEnter', ev, segEl);
	            }
	        };
	        _this.handleSegLeave = function (ev, segEl) {
	            if (_this.currentSegEl) {
	                _this.currentSegEl = null;
	                _this.triggerEvent('eventMouseLeave', ev, segEl);
	            }
	        };
	        _this.removeHoverListeners = listenToHoverBySelector(settings.el, '.fc-event', // on both fg and bg events
	        _this.handleSegEnter, _this.handleSegLeave);
	        return _this;
	    }
	    EventHovering.prototype.destroy = function () {
	        this.removeHoverListeners();
	    };
	    EventHovering.prototype.triggerEvent = function (publicEvName, ev, segEl) {
	        var component = this.component;
	        var context = component.context;
	        var seg = getElSeg(segEl);
	        if (!ev || component.isValidSegDownEl(ev.target)) {
	            context.emitter.trigger(publicEvName, {
	                el: segEl,
	                event: new EventApi(context, seg.eventRange.def, seg.eventRange.instance),
	                jsEvent: ev,
	                view: context.viewApi,
	            });
	        }
	    };
	    return EventHovering;
	}(Interaction));
	
	var CalendarContent = /** @class */ (function (_super) {
	    tslib.__extends(CalendarContent, _super);
	    function CalendarContent() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.buildViewContext = memoize(buildViewContext);
	        _this.buildViewPropTransformers = memoize(buildViewPropTransformers);
	        _this.buildToolbarProps = memoize(buildToolbarProps);
	        _this.headerRef = vdom_cjs.createRef();
	        _this.footerRef = vdom_cjs.createRef();
	        _this.interactionsStore = {};
	        // eslint-disable-next-line
	        _this.state = {
	            viewLabelId: getUniqueDomId(),
	        };
	        // Component Registration
	        // -----------------------------------------------------------------------------------------------------------------
	        _this.registerInteractiveComponent = function (component, settingsInput) {
	            var settings = parseInteractionSettings(component, settingsInput);
	            var DEFAULT_INTERACTIONS = [
	                EventClicking,
	                EventHovering,
	            ];
	            var interactionClasses = DEFAULT_INTERACTIONS.concat(_this.props.pluginHooks.componentInteractions);
	            var interactions = interactionClasses.map(function (TheInteractionClass) { return new TheInteractionClass(settings); });
	            _this.interactionsStore[component.uid] = interactions;
	            interactionSettingsStore[component.uid] = settings;
	        };
	        _this.unregisterInteractiveComponent = function (component) {
	            var listeners = _this.interactionsStore[component.uid];
	            if (listeners) {
	                for (var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++) {
	                    var listener = listeners_1[_i];
	                    listener.destroy();
	                }
	                delete _this.interactionsStore[component.uid];
	            }
	            delete interactionSettingsStore[component.uid];
	        };
	        // Resizing
	        // -----------------------------------------------------------------------------------------------------------------
	        _this.resizeRunner = new DelayedRunner(function () {
	            _this.props.emitter.trigger('_resize', true); // should window resizes be considered "forced" ?
	            _this.props.emitter.trigger('windowResize', { view: _this.props.viewApi });
	        });
	        _this.handleWindowResize = function (ev) {
	            var options = _this.props.options;
	            if (options.handleWindowResize &&
	                ev.target === window // avoid jqui events
	            ) {
	                _this.resizeRunner.request(options.windowResizeDelay);
	            }
	        };
	        return _this;
	    }
	    /*
	    renders INSIDE of an outer div
	    */
	    CalendarContent.prototype.render = function () {
	        var props = this.props;
	        var toolbarConfig = props.toolbarConfig, options = props.options;
	        var toolbarProps = this.buildToolbarProps(props.viewSpec, props.dateProfile, props.dateProfileGenerator, props.currentDate, getNow(props.options.now, props.dateEnv), // TODO: use NowTimer????
	        props.viewTitle);
	        var viewVGrow = false;
	        var viewHeight = '';
	        var viewAspectRatio;
	        if (props.isHeightAuto || props.forPrint) {
	            viewHeight = '';
	        }
	        else if (options.height != null) {
	            viewVGrow = true;
	        }
	        else if (options.contentHeight != null) {
	            viewHeight = options.contentHeight;
	        }
	        else {
	            viewAspectRatio = Math.max(options.aspectRatio, 0.5); // prevent from getting too tall
	        }
	        var viewContext = this.buildViewContext(props.viewSpec, props.viewApi, props.options, props.dateProfileGenerator, props.dateEnv, props.theme, props.pluginHooks, props.dispatch, props.getCurrentData, props.emitter, props.calendarApi, this.registerInteractiveComponent, this.unregisterInteractiveComponent);
	        var viewLabelId = (toolbarConfig.header && toolbarConfig.header.hasTitle)
	            ? this.state.viewLabelId
	            : '';
	        return (vdom_cjs.createElement(ViewContextType.Provider, { value: viewContext },
	            toolbarConfig.header && (vdom_cjs.createElement(Toolbar, tslib.__assign({ ref: this.headerRef, extraClassName: "fc-header-toolbar", model: toolbarConfig.header, titleId: viewLabelId }, toolbarProps))),
	            vdom_cjs.createElement(ViewContainer, { liquid: viewVGrow, height: viewHeight, aspectRatio: viewAspectRatio, labeledById: viewLabelId },
	                this.renderView(props),
	                this.buildAppendContent()),
	            toolbarConfig.footer && (vdom_cjs.createElement(Toolbar, tslib.__assign({ ref: this.footerRef, extraClassName: "fc-footer-toolbar", model: toolbarConfig.footer, titleId: "" }, toolbarProps)))));
	    };
	    CalendarContent.prototype.componentDidMount = function () {
	        var props = this.props;
	        this.calendarInteractions = props.pluginHooks.calendarInteractions
	            .map(function (CalendarInteractionClass) { return new CalendarInteractionClass(props); });
	        window.addEventListener('resize', this.handleWindowResize);
	        var propSetHandlers = props.pluginHooks.propSetHandlers;
	        for (var propName in propSetHandlers) {
	            propSetHandlers[propName](props[propName], props);
	        }
	    };
	    CalendarContent.prototype.componentDidUpdate = function (prevProps) {
	        var props = this.props;
	        var propSetHandlers = props.pluginHooks.propSetHandlers;
	        for (var propName in propSetHandlers) {
	            if (props[propName] !== prevProps[propName]) {
	                propSetHandlers[propName](props[propName], props);
	            }
	        }
	    };
	    CalendarContent.prototype.componentWillUnmount = function () {
	        window.removeEventListener('resize', this.handleWindowResize);
	        this.resizeRunner.clear();
	        for (var _i = 0, _a = this.calendarInteractions; _i < _a.length; _i++) {
	            var interaction = _a[_i];
	            interaction.destroy();
	        }
	        this.props.emitter.trigger('_unmount');
	    };
	    CalendarContent.prototype.buildAppendContent = function () {
	        var props = this.props;
	        var children = props.pluginHooks.viewContainerAppends.map(function (buildAppendContent) { return buildAppendContent(props); });
	        return vdom_cjs.createElement.apply(void 0, tslib.__spreadArray([vdom_cjs.Fragment, {}], children));
	    };
	    CalendarContent.prototype.renderView = function (props) {
	        var pluginHooks = props.pluginHooks;
	        var viewSpec = props.viewSpec;
	        var viewProps = {
	            dateProfile: props.dateProfile,
	            businessHours: props.businessHours,
	            eventStore: props.renderableEventStore,
	            eventUiBases: props.eventUiBases,
	            dateSelection: props.dateSelection,
	            eventSelection: props.eventSelection,
	            eventDrag: props.eventDrag,
	            eventResize: props.eventResize,
	            isHeightAuto: props.isHeightAuto,
	            forPrint: props.forPrint,
	        };
	        var transformers = this.buildViewPropTransformers(pluginHooks.viewPropsTransformers);
	        for (var _i = 0, transformers_1 = transformers; _i < transformers_1.length; _i++) {
	            var transformer = transformers_1[_i];
	            tslib.__assign(viewProps, transformer.transform(viewProps, props));
	        }
	        var ViewComponent = viewSpec.component;
	        return (vdom_cjs.createElement(ViewComponent, tslib.__assign({}, viewProps)));
	    };
	    return CalendarContent;
	}(PureComponent));
	function buildToolbarProps(viewSpec, dateProfile, dateProfileGenerator, currentDate, now, title) {
	    // don't force any date-profiles to valid date profiles (the `false`) so that we can tell if it's invalid
	    var todayInfo = dateProfileGenerator.build(now, undefined, false); // TODO: need `undefined` or else INFINITE LOOP for some reason
	    var prevInfo = dateProfileGenerator.buildPrev(dateProfile, currentDate, false);
	    var nextInfo = dateProfileGenerator.buildNext(dateProfile, currentDate, false);
	    return {
	        title: title,
	        activeButton: viewSpec.type,
	        navUnit: viewSpec.singleUnit,
	        isTodayEnabled: todayInfo.isValid && !rangeContainsMarker(dateProfile.currentRange, now),
	        isPrevEnabled: prevInfo.isValid,
	        isNextEnabled: nextInfo.isValid,
	    };
	}
	// Plugin
	// -----------------------------------------------------------------------------------------------------------------
	function buildViewPropTransformers(theClasses) {
	    return theClasses.map(function (TheClass) { return new TheClass(); });
	}
	
	var CalendarRoot = /** @class */ (function (_super) {
	    tslib.__extends(CalendarRoot, _super);
	    function CalendarRoot() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            forPrint: false,
	        };
	        _this.handleBeforePrint = function () {
	            _this.setState({ forPrint: true });
	        };
	        _this.handleAfterPrint = function () {
	            _this.setState({ forPrint: false });
	        };
	        return _this;
	    }
	    CalendarRoot.prototype.render = function () {
	        var props = this.props;
	        var options = props.options;
	        var forPrint = this.state.forPrint;
	        var isHeightAuto = forPrint || options.height === 'auto' || options.contentHeight === 'auto';
	        var height = (!isHeightAuto && options.height != null) ? options.height : '';
	        var classNames = [
	            'fc',
	            forPrint ? 'fc-media-print' : 'fc-media-screen',
	            "fc-direction-" + options.direction,
	            props.theme.getClass('root'),
	        ];
	        if (!getCanVGrowWithinCell()) {
	            classNames.push('fc-liquid-hack');
	        }
	        return props.children(classNames, height, isHeightAuto, forPrint);
	    };
	    CalendarRoot.prototype.componentDidMount = function () {
	        var emitter = this.props.emitter;
	        emitter.on('_beforeprint', this.handleBeforePrint);
	        emitter.on('_afterprint', this.handleAfterPrint);
	    };
	    CalendarRoot.prototype.componentWillUnmount = function () {
	        var emitter = this.props.emitter;
	        emitter.off('_beforeprint', this.handleBeforePrint);
	        emitter.off('_afterprint', this.handleAfterPrint);
	    };
	    return CalendarRoot;
	}(BaseComponent));
	
	// Computes a default column header formatting string if `colFormat` is not explicitly defined
	function computeFallbackHeaderFormat(datesRepDistinctDays, dayCnt) {
	    // if more than one week row, or if there are a lot of columns with not much space,
	    // put just the day numbers will be in each cell
	    if (!datesRepDistinctDays || dayCnt > 10) {
	        return createFormatter({ weekday: 'short' }); // "Sat"
	    }
	    if (dayCnt > 1) {
	        return createFormatter({ weekday: 'short', month: 'numeric', day: 'numeric', omitCommas: true }); // "Sat 11/12"
	    }
	    return createFormatter({ weekday: 'long' }); // "Saturday"
	}
	
	var CLASS_NAME = 'fc-col-header-cell'; // do the cushion too? no
	function renderInner$1(hookProps) {
	    return hookProps.text;
	}
	
	var TableDateCell = /** @class */ (function (_super) {
	    tslib.__extends(TableDateCell, _super);
	    function TableDateCell() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TableDateCell.prototype.render = function () {
	        var _a = this.context, dateEnv = _a.dateEnv, options = _a.options, theme = _a.theme, viewApi = _a.viewApi;
	        var props = this.props;
	        var date = props.date, dateProfile = props.dateProfile;
	        var dayMeta = getDateMeta(date, props.todayRange, null, dateProfile);
	        var classNames = [CLASS_NAME].concat(getDayClassNames(dayMeta, theme));
	        var text = dateEnv.format(date, props.dayHeaderFormat);
	        // if colCnt is 1, we are already in a day-view and don't need a navlink
	        var navLinkAttrs = (!dayMeta.isDisabled && props.colCnt > 1)
	            ? buildNavLinkAttrs(this.context, date)
	            : {};
	        var hookProps = tslib.__assign(tslib.__assign(tslib.__assign({ date: dateEnv.toDate(date), view: viewApi }, props.extraHookProps), { text: text }), dayMeta);
	        return (vdom_cjs.createElement(RenderHook, { hookProps: hookProps, classNames: options.dayHeaderClassNames, content: options.dayHeaderContent, defaultContent: renderInner$1, didMount: options.dayHeaderDidMount, willUnmount: options.dayHeaderWillUnmount }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (vdom_cjs.createElement("th", tslib.__assign({ ref: rootElRef, role: "columnheader", className: classNames.concat(customClassNames).join(' '), "data-date": !dayMeta.isDisabled ? formatDayString(date) : undefined, colSpan: props.colSpan }, props.extraDataAttrs),
	            vdom_cjs.createElement("div", { className: "fc-scrollgrid-sync-inner" }, !dayMeta.isDisabled && (vdom_cjs.createElement("a", tslib.__assign({ ref: innerElRef, className: [
	                    'fc-col-header-cell-cushion',
	                    props.isSticky ? 'fc-sticky' : '',
	                ].join(' ') }, navLinkAttrs), innerContent))))); }));
	    };
	    return TableDateCell;
	}(BaseComponent));
	
	var WEEKDAY_FORMAT = createFormatter({ weekday: 'long' });
	var TableDowCell = /** @class */ (function (_super) {
	    tslib.__extends(TableDowCell, _super);
	    function TableDowCell() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TableDowCell.prototype.render = function () {
	        var props = this.props;
	        var _a = this.context, dateEnv = _a.dateEnv, theme = _a.theme, viewApi = _a.viewApi, options = _a.options;
	        var date = addDays(new Date(259200000), props.dow); // start with Sun, 04 Jan 1970 00:00:00 GMT
	        var dateMeta = {
	            dow: props.dow,
	            isDisabled: false,
	            isFuture: false,
	            isPast: false,
	            isToday: false,
	            isOther: false,
	        };
	        var classNames = [CLASS_NAME].concat(getDayClassNames(dateMeta, theme), props.extraClassNames || []);
	        var text = dateEnv.format(date, props.dayHeaderFormat);
	        var hookProps = tslib.__assign(tslib.__assign(tslib.__assign(tslib.__assign({ // TODO: make this public?
	            date: date }, dateMeta), { view: viewApi }), props.extraHookProps), { text: text });
	        return (vdom_cjs.createElement(RenderHook, { hookProps: hookProps, classNames: options.dayHeaderClassNames, content: options.dayHeaderContent, defaultContent: renderInner$1, didMount: options.dayHeaderDidMount, willUnmount: options.dayHeaderWillUnmount }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (vdom_cjs.createElement("th", tslib.__assign({ ref: rootElRef, role: "columnheader", className: classNames.concat(customClassNames).join(' '), colSpan: props.colSpan }, props.extraDataAttrs),
	            vdom_cjs.createElement("div", { className: "fc-scrollgrid-sync-inner" },
	                vdom_cjs.createElement("a", { "aria-label": dateEnv.format(date, WEEKDAY_FORMAT), className: [
	                        'fc-col-header-cell-cushion',
	                        props.isSticky ? 'fc-sticky' : '',
	                    ].join(' '), ref: innerElRef }, innerContent)))); }));
	    };
	    return TableDowCell;
	}(BaseComponent));
	
	var NowTimer = /** @class */ (function (_super) {
	    tslib.__extends(NowTimer, _super);
	    function NowTimer(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        _this.initialNowDate = getNow(context.options.now, context.dateEnv);
	        _this.initialNowQueriedMs = new Date().valueOf();
	        _this.state = _this.computeTiming().currentState;
	        return _this;
	    }
	    NowTimer.prototype.render = function () {
	        var _a = this, props = _a.props, state = _a.state;
	        return props.children(state.nowDate, state.todayRange);
	    };
	    NowTimer.prototype.componentDidMount = function () {
	        this.setTimeout();
	    };
	    NowTimer.prototype.componentDidUpdate = function (prevProps) {
	        if (prevProps.unit !== this.props.unit) {
	            this.clearTimeout();
	            this.setTimeout();
	        }
	    };
	    NowTimer.prototype.componentWillUnmount = function () {
	        this.clearTimeout();
	    };
	    NowTimer.prototype.computeTiming = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        var unroundedNow = addMs(this.initialNowDate, new Date().valueOf() - this.initialNowQueriedMs);
	        var currentUnitStart = context.dateEnv.startOf(unroundedNow, props.unit);
	        var nextUnitStart = context.dateEnv.add(currentUnitStart, createDuration(1, props.unit));
	        var waitMs = nextUnitStart.valueOf() - unroundedNow.valueOf();
	        // there is a max setTimeout ms value (https://stackoverflow.com/a/3468650/96342)
	        // ensure no longer than a day
	        waitMs = Math.min(1000 * 60 * 60 * 24, waitMs);
	        return {
	            currentState: { nowDate: currentUnitStart, todayRange: buildDayRange(currentUnitStart) },
	            nextState: { nowDate: nextUnitStart, todayRange: buildDayRange(nextUnitStart) },
	            waitMs: waitMs,
	        };
	    };
	    NowTimer.prototype.setTimeout = function () {
	        var _this = this;
	        var _a = this.computeTiming(), nextState = _a.nextState, waitMs = _a.waitMs;
	        this.timeoutId = setTimeout(function () {
	            _this.setState(nextState, function () {
	                _this.setTimeout();
	            });
	        }, waitMs);
	    };
	    NowTimer.prototype.clearTimeout = function () {
	        if (this.timeoutId) {
	            clearTimeout(this.timeoutId);
	        }
	    };
	    NowTimer.contextType = ViewContextType;
	    return NowTimer;
	}(vdom_cjs.Component));
	function buildDayRange(date) {
	    var start = startOfDay(date);
	    var end = addDays(start, 1);
	    return { start: start, end: end };
	}
	
	var DayHeader = /** @class */ (function (_super) {
	    tslib.__extends(DayHeader, _super);
	    function DayHeader() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.createDayHeaderFormatter = memoize(createDayHeaderFormatter);
	        return _this;
	    }
	    DayHeader.prototype.render = function () {
	        var context = this.context;
	        var _a = this.props, dates = _a.dates, dateProfile = _a.dateProfile, datesRepDistinctDays = _a.datesRepDistinctDays, renderIntro = _a.renderIntro;
	        var dayHeaderFormat = this.createDayHeaderFormatter(context.options.dayHeaderFormat, datesRepDistinctDays, dates.length);
	        return (vdom_cjs.createElement(NowTimer, { unit: "day" }, function (nowDate, todayRange) { return (vdom_cjs.createElement("tr", { role: "row" },
	            renderIntro && renderIntro('day'),
	            dates.map(function (date) { return (datesRepDistinctDays ? (vdom_cjs.createElement(TableDateCell, { key: date.toISOString(), date: date, dateProfile: dateProfile, todayRange: todayRange, colCnt: dates.length, dayHeaderFormat: dayHeaderFormat })) : (vdom_cjs.createElement(TableDowCell, { key: date.getUTCDay(), dow: date.getUTCDay(), dayHeaderFormat: dayHeaderFormat }))); }))); }));
	    };
	    return DayHeader;
	}(BaseComponent));
	function createDayHeaderFormatter(explicitFormat, datesRepDistinctDays, dateCnt) {
	    return explicitFormat || computeFallbackHeaderFormat(datesRepDistinctDays, dateCnt);
	}
	
	var DaySeriesModel = /** @class */ (function () {
	    function DaySeriesModel(range, dateProfileGenerator) {
	        var date = range.start;
	        var end = range.end;
	        var indices = [];
	        var dates = [];
	        var dayIndex = -1;
	        while (date < end) { // loop each day from start to end
	            if (dateProfileGenerator.isHiddenDay(date)) {
	                indices.push(dayIndex + 0.5); // mark that it's between indices
	            }
	            else {
	                dayIndex += 1;
	                indices.push(dayIndex);
	                dates.push(date);
	            }
	            date = addDays(date, 1);
	        }
	        this.dates = dates;
	        this.indices = indices;
	        this.cnt = dates.length;
	    }
	    DaySeriesModel.prototype.sliceRange = function (range) {
	        var firstIndex = this.getDateDayIndex(range.start); // inclusive first index
	        var lastIndex = this.getDateDayIndex(addDays(range.end, -1)); // inclusive last index
	        var clippedFirstIndex = Math.max(0, firstIndex);
	        var clippedLastIndex = Math.min(this.cnt - 1, lastIndex);
	        // deal with in-between indices
	        clippedFirstIndex = Math.ceil(clippedFirstIndex); // in-between starts round to next cell
	        clippedLastIndex = Math.floor(clippedLastIndex); // in-between ends round to prev cell
	        if (clippedFirstIndex <= clippedLastIndex) {
	            return {
	                firstIndex: clippedFirstIndex,
	                lastIndex: clippedLastIndex,
	                isStart: firstIndex === clippedFirstIndex,
	                isEnd: lastIndex === clippedLastIndex,
	            };
	        }
	        return null;
	    };
	    // Given a date, returns its chronolocial cell-index from the first cell of the grid.
	    // If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
	    // If before the first offset, returns a negative number.
	    // If after the last offset, returns an offset past the last cell offset.
	    // Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
	    DaySeriesModel.prototype.getDateDayIndex = function (date) {
	        var indices = this.indices;
	        var dayOffset = Math.floor(diffDays(this.dates[0], date));
	        if (dayOffset < 0) {
	            return indices[0] - 1;
	        }
	        if (dayOffset >= indices.length) {
	            return indices[indices.length - 1] + 1;
	        }
	        return indices[dayOffset];
	    };
	    return DaySeriesModel;
	}());
	
	var DayTableModel = /** @class */ (function () {
	    function DayTableModel(daySeries, breakOnWeeks) {
	        var dates = daySeries.dates;
	        var daysPerRow;
	        var firstDay;
	        var rowCnt;
	        if (breakOnWeeks) {
	            // count columns until the day-of-week repeats
	            firstDay = dates[0].getUTCDay();
	            for (daysPerRow = 1; daysPerRow < dates.length; daysPerRow += 1) {
	                if (dates[daysPerRow].getUTCDay() === firstDay) {
	                    break;
	                }
	            }
	            rowCnt = Math.ceil(dates.length / daysPerRow);
	        }
	        else {
	            rowCnt = 1;
	            daysPerRow = dates.length;
	        }
	        this.rowCnt = rowCnt;
	        this.colCnt = daysPerRow;
	        this.daySeries = daySeries;
	        this.cells = this.buildCells();
	        this.headerDates = this.buildHeaderDates();
	    }
	    DayTableModel.prototype.buildCells = function () {
	        var rows = [];
	        for (var row = 0; row < this.rowCnt; row += 1) {
	            var cells = [];
	            for (var col = 0; col < this.colCnt; col += 1) {
	                cells.push(this.buildCell(row, col));
	            }
	            rows.push(cells);
	        }
	        return rows;
	    };
	    DayTableModel.prototype.buildCell = function (row, col) {
	        var date = this.daySeries.dates[row * this.colCnt + col];
	        return {
	            key: date.toISOString(),
	            date: date,
	        };
	    };
	    DayTableModel.prototype.buildHeaderDates = function () {
	        var dates = [];
	        for (var col = 0; col < this.colCnt; col += 1) {
	            dates.push(this.cells[0][col].date);
	        }
	        return dates;
	    };
	    DayTableModel.prototype.sliceRange = function (range) {
	        var colCnt = this.colCnt;
	        var seriesSeg = this.daySeries.sliceRange(range);
	        var segs = [];
	        if (seriesSeg) {
	            var firstIndex = seriesSeg.firstIndex, lastIndex = seriesSeg.lastIndex;
	            var index = firstIndex;
	            while (index <= lastIndex) {
	                var row = Math.floor(index / colCnt);
	                var nextIndex = Math.min((row + 1) * colCnt, lastIndex + 1);
	                segs.push({
	                    row: row,
	                    firstCol: index % colCnt,
	                    lastCol: (nextIndex - 1) % colCnt,
	                    isStart: seriesSeg.isStart && index === firstIndex,
	                    isEnd: seriesSeg.isEnd && (nextIndex - 1) === lastIndex,
	                });
	                index = nextIndex;
	            }
	        }
	        return segs;
	    };
	    return DayTableModel;
	}());
	
	var Slicer = /** @class */ (function () {
	    function Slicer() {
	        this.sliceBusinessHours = memoize(this._sliceBusinessHours);
	        this.sliceDateSelection = memoize(this._sliceDateSpan);
	        this.sliceEventStore = memoize(this._sliceEventStore);
	        this.sliceEventDrag = memoize(this._sliceInteraction);
	        this.sliceEventResize = memoize(this._sliceInteraction);
	        this.forceDayIfListItem = false; // hack
	    }
	    Slicer.prototype.sliceProps = function (props, dateProfile, nextDayThreshold, context) {
	        var extraArgs = [];
	        for (var _i = 4; _i < arguments.length; _i++) {
	            extraArgs[_i - 4] = arguments[_i];
	        }
	        var eventUiBases = props.eventUiBases;
	        var eventSegs = this.sliceEventStore.apply(this, tslib.__spreadArray([props.eventStore, eventUiBases, dateProfile, nextDayThreshold], extraArgs));
	        return {
	            dateSelectionSegs: this.sliceDateSelection.apply(this, tslib.__spreadArray([props.dateSelection, eventUiBases, context], extraArgs)),
	            businessHourSegs: this.sliceBusinessHours.apply(this, tslib.__spreadArray([props.businessHours, dateProfile, nextDayThreshold, context], extraArgs)),
	            fgEventSegs: eventSegs.fg,
	            bgEventSegs: eventSegs.bg,
	            eventDrag: this.sliceEventDrag.apply(this, tslib.__spreadArray([props.eventDrag, eventUiBases, dateProfile, nextDayThreshold], extraArgs)),
	            eventResize: this.sliceEventResize.apply(this, tslib.__spreadArray([props.eventResize, eventUiBases, dateProfile, nextDayThreshold], extraArgs)),
	            eventSelection: props.eventSelection,
	        }; // TODO: give interactionSegs?
	    };
	    Slicer.prototype.sliceNowDate = function (// does not memoize
	    date, context) {
	        var extraArgs = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            extraArgs[_i - 2] = arguments[_i];
	        }
	        return this._sliceDateSpan.apply(this, tslib.__spreadArray([{ range: { start: date, end: addMs(date, 1) }, allDay: false },
	            {},
	            context], extraArgs));
	    };
	    Slicer.prototype._sliceBusinessHours = function (businessHours, dateProfile, nextDayThreshold, context) {
	        var extraArgs = [];
	        for (var _i = 4; _i < arguments.length; _i++) {
	            extraArgs[_i - 4] = arguments[_i];
	        }
	        if (!businessHours) {
	            return [];
	        }
	        return this._sliceEventStore.apply(this, tslib.__spreadArray([expandRecurring(businessHours, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), context),
	            {},
	            dateProfile,
	            nextDayThreshold], extraArgs)).bg;
	    };
	    Slicer.prototype._sliceEventStore = function (eventStore, eventUiBases, dateProfile, nextDayThreshold) {
	        var extraArgs = [];
	        for (var _i = 4; _i < arguments.length; _i++) {
	            extraArgs[_i - 4] = arguments[_i];
	        }
	        if (eventStore) {
	            var rangeRes = sliceEventStore(eventStore, eventUiBases, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
	            return {
	                bg: this.sliceEventRanges(rangeRes.bg, extraArgs),
	                fg: this.sliceEventRanges(rangeRes.fg, extraArgs),
	            };
	        }
	        return { bg: [], fg: [] };
	    };
	    Slicer.prototype._sliceInteraction = function (interaction, eventUiBases, dateProfile, nextDayThreshold) {
	        var extraArgs = [];
	        for (var _i = 4; _i < arguments.length; _i++) {
	            extraArgs[_i - 4] = arguments[_i];
	        }
	        if (!interaction) {
	            return null;
	        }
	        var rangeRes = sliceEventStore(interaction.mutatedEvents, eventUiBases, computeActiveRange(dateProfile, Boolean(nextDayThreshold)), nextDayThreshold);
	        return {
	            segs: this.sliceEventRanges(rangeRes.fg, extraArgs),
	            affectedInstances: interaction.affectedEvents.instances,
	            isEvent: interaction.isEvent,
	        };
	    };
	    Slicer.prototype._sliceDateSpan = function (dateSpan, eventUiBases, context) {
	        var extraArgs = [];
	        for (var _i = 3; _i < arguments.length; _i++) {
	            extraArgs[_i - 3] = arguments[_i];
	        }
	        if (!dateSpan) {
	            return [];
	        }
	        var eventRange = fabricateEventRange(dateSpan, eventUiBases, context);
	        var segs = this.sliceRange.apply(this, tslib.__spreadArray([dateSpan.range], extraArgs));
	        for (var _a = 0, segs_1 = segs; _a < segs_1.length; _a++) {
	            var seg = segs_1[_a];
	            seg.eventRange = eventRange;
	        }
	        return segs;
	    };
	    /*
	    "complete" seg means it has component and eventRange
	    */
	    Slicer.prototype.sliceEventRanges = function (eventRanges, extraArgs) {
	        var segs = [];
	        for (var _i = 0, eventRanges_1 = eventRanges; _i < eventRanges_1.length; _i++) {
	            var eventRange = eventRanges_1[_i];
	            segs.push.apply(segs, this.sliceEventRange(eventRange, extraArgs));
	        }
	        return segs;
	    };
	    /*
	    "complete" seg means it has component and eventRange
	    */
	    Slicer.prototype.sliceEventRange = function (eventRange, extraArgs) {
	        var dateRange = eventRange.range;
	        // hack to make multi-day events that are being force-displayed as list-items to take up only one day
	        if (this.forceDayIfListItem && eventRange.ui.display === 'list-item') {
	            dateRange = {
	                start: dateRange.start,
	                end: addDays(dateRange.start, 1),
	            };
	        }
	        var segs = this.sliceRange.apply(this, tslib.__spreadArray([dateRange], extraArgs));
	        for (var _i = 0, segs_2 = segs; _i < segs_2.length; _i++) {
	            var seg = segs_2[_i];
	            seg.eventRange = eventRange;
	            seg.isStart = eventRange.isStart && seg.isStart;
	            seg.isEnd = eventRange.isEnd && seg.isEnd;
	        }
	        return segs;
	    };
	    return Slicer;
	}());
	/*
	for incorporating slotMinTime/slotMaxTime if appropriate
	TODO: should be part of DateProfile!
	TimelineDateProfile already does this btw
	*/
	function computeActiveRange(dateProfile, isComponentAllDay) {
	    var range = dateProfile.activeRange;
	    if (isComponentAllDay) {
	        return range;
	    }
	    return {
	        start: addMs(range.start, dateProfile.slotMinTime.milliseconds),
	        end: addMs(range.end, dateProfile.slotMaxTime.milliseconds - 864e5), // 864e5 = ms in a day
	    };
	}
	
	// high-level segmenting-aware tester functions
	// ------------------------------------------------------------------------------------------------------------------------
	function isInteractionValid(interaction, dateProfile, context) {
	    var instances = interaction.mutatedEvents.instances;
	    for (var instanceId in instances) {
	        if (!rangeContainsRange(dateProfile.validRange, instances[instanceId].range)) {
	            return false;
	        }
	    }
	    return isNewPropsValid({ eventDrag: interaction }, context); // HACK: the eventDrag props is used for ALL interactions
	}
	function isDateSelectionValid(dateSelection, dateProfile, context) {
	    if (!rangeContainsRange(dateProfile.validRange, dateSelection.range)) {
	        return false;
	    }
	    return isNewPropsValid({ dateSelection: dateSelection }, context);
	}
	function isNewPropsValid(newProps, context) {
	    var calendarState = context.getCurrentData();
	    var props = tslib.__assign({ businessHours: calendarState.businessHours, dateSelection: '', eventStore: calendarState.eventStore, eventUiBases: calendarState.eventUiBases, eventSelection: '', eventDrag: null, eventResize: null }, newProps);
	    return (context.pluginHooks.isPropsValid || isPropsValid)(props, context);
	}
	function isPropsValid(state, context, dateSpanMeta, filterConfig) {
	    if (dateSpanMeta === void 0) { dateSpanMeta = {}; }
	    if (state.eventDrag && !isInteractionPropsValid(state, context, dateSpanMeta, filterConfig)) {
	        return false;
	    }
	    if (state.dateSelection && !isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig)) {
	        return false;
	    }
	    return true;
	}
	// Moving Event Validation
	// ------------------------------------------------------------------------------------------------------------------------
	function isInteractionPropsValid(state, context, dateSpanMeta, filterConfig) {
	    var currentState = context.getCurrentData();
	    var interaction = state.eventDrag; // HACK: the eventDrag props is used for ALL interactions
	    var subjectEventStore = interaction.mutatedEvents;
	    var subjectDefs = subjectEventStore.defs;
	    var subjectInstances = subjectEventStore.instances;
	    var subjectConfigs = compileEventUis(subjectDefs, interaction.isEvent ?
	        state.eventUiBases :
	        { '': currentState.selectionConfig });
	    if (filterConfig) {
	        subjectConfigs = mapHash(subjectConfigs, filterConfig);
	    }
	    // exclude the subject events. TODO: exclude defs too?
	    var otherEventStore = excludeInstances(state.eventStore, interaction.affectedEvents.instances);
	    var otherDefs = otherEventStore.defs;
	    var otherInstances = otherEventStore.instances;
	    var otherConfigs = compileEventUis(otherDefs, state.eventUiBases);
	    for (var subjectInstanceId in subjectInstances) {
	        var subjectInstance = subjectInstances[subjectInstanceId];
	        var subjectRange = subjectInstance.range;
	        var subjectConfig = subjectConfigs[subjectInstance.defId];
	        var subjectDef = subjectDefs[subjectInstance.defId];
	        // constraint
	        if (!allConstraintsPass(subjectConfig.constraints, subjectRange, otherEventStore, state.businessHours, context)) {
	            return false;
	        }
	        // overlap
	        var eventOverlap = context.options.eventOverlap;
	        var eventOverlapFunc = typeof eventOverlap === 'function' ? eventOverlap : null;
	        for (var otherInstanceId in otherInstances) {
	            var otherInstance = otherInstances[otherInstanceId];
	            // intersect! evaluate
	            if (rangesIntersect(subjectRange, otherInstance.range)) {
	                var otherOverlap = otherConfigs[otherInstance.defId].overlap;
	                // consider the other event's overlap. only do this if the subject event is a "real" event
	                if (otherOverlap === false && interaction.isEvent) {
	                    return false;
	                }
	                if (subjectConfig.overlap === false) {
	                    return false;
	                }
	                if (eventOverlapFunc && !eventOverlapFunc(new EventApi(context, otherDefs[otherInstance.defId], otherInstance), // still event
	                new EventApi(context, subjectDef, subjectInstance))) {
	                    return false;
	                }
	            }
	        }
	        // allow (a function)
	        var calendarEventStore = currentState.eventStore; // need global-to-calendar, not local to component (splittable)state
	        for (var _i = 0, _a = subjectConfig.allows; _i < _a.length; _i++) {
	            var subjectAllow = _a[_i];
	            var subjectDateSpan = tslib.__assign(tslib.__assign({}, dateSpanMeta), { range: subjectInstance.range, allDay: subjectDef.allDay });
	            var origDef = calendarEventStore.defs[subjectDef.defId];
	            var origInstance = calendarEventStore.instances[subjectInstanceId];
	            var eventApi = void 0;
	            if (origDef) { // was previously in the calendar
	                eventApi = new EventApi(context, origDef, origInstance);
	            }
	            else { // was an external event
	                eventApi = new EventApi(context, subjectDef); // no instance, because had no dates
	            }
	            if (!subjectAllow(buildDateSpanApiWithContext(subjectDateSpan, context), eventApi)) {
	                return false;
	            }
	        }
	    }
	    return true;
	}
	// Date Selection Validation
	// ------------------------------------------------------------------------------------------------------------------------
	function isDateSelectionPropsValid(state, context, dateSpanMeta, filterConfig) {
	    var relevantEventStore = state.eventStore;
	    var relevantDefs = relevantEventStore.defs;
	    var relevantInstances = relevantEventStore.instances;
	    var selection = state.dateSelection;
	    var selectionRange = selection.range;
	    var selectionConfig = context.getCurrentData().selectionConfig;
	    if (filterConfig) {
	        selectionConfig = filterConfig(selectionConfig);
	    }
	    // constraint
	    if (!allConstraintsPass(selectionConfig.constraints, selectionRange, relevantEventStore, state.businessHours, context)) {
	        return false;
	    }
	    // overlap
	    var selectOverlap = context.options.selectOverlap;
	    var selectOverlapFunc = typeof selectOverlap === 'function' ? selectOverlap : null;
	    for (var relevantInstanceId in relevantInstances) {
	        var relevantInstance = relevantInstances[relevantInstanceId];
	        // intersect! evaluate
	        if (rangesIntersect(selectionRange, relevantInstance.range)) {
	            if (selectionConfig.overlap === false) {
	                return false;
	            }
	            if (selectOverlapFunc && !selectOverlapFunc(new EventApi(context, relevantDefs[relevantInstance.defId], relevantInstance), null)) {
	                return false;
	            }
	        }
	    }
	    // allow (a function)
	    for (var _i = 0, _a = selectionConfig.allows; _i < _a.length; _i++) {
	        var selectionAllow = _a[_i];
	        var fullDateSpan = tslib.__assign(tslib.__assign({}, dateSpanMeta), selection);
	        if (!selectionAllow(buildDateSpanApiWithContext(fullDateSpan, context), null)) {
	            return false;
	        }
	    }
	    return true;
	}
	// Constraint Utils
	// ------------------------------------------------------------------------------------------------------------------------
	function allConstraintsPass(constraints, subjectRange, otherEventStore, businessHoursUnexpanded, context) {
	    for (var _i = 0, constraints_1 = constraints; _i < constraints_1.length; _i++) {
	        var constraint = constraints_1[_i];
	        if (!anyRangesContainRange(constraintToRanges(constraint, subjectRange, otherEventStore, businessHoursUnexpanded, context), subjectRange)) {
	            return false;
	        }
	    }
	    return true;
	}
	function constraintToRanges(constraint, subjectRange, // for expanding a recurring constraint, or expanding business hours
	otherEventStore, // for if constraint is an even group ID
	businessHoursUnexpanded, // for if constraint is 'businessHours'
	context) {
	    if (constraint === 'businessHours') {
	        return eventStoreToRanges(expandRecurring(businessHoursUnexpanded, subjectRange, context));
	    }
	    if (typeof constraint === 'string') { // an group ID
	        return eventStoreToRanges(filterEventStoreDefs(otherEventStore, function (eventDef) { return eventDef.groupId === constraint; }));
	    }
	    if (typeof constraint === 'object' && constraint) { // non-null object
	        return eventStoreToRanges(expandRecurring(constraint, subjectRange, context));
	    }
	    return []; // if it's false
	}
	// TODO: move to event-store file?
	function eventStoreToRanges(eventStore) {
	    var instances = eventStore.instances;
	    var ranges = [];
	    for (var instanceId in instances) {
	        ranges.push(instances[instanceId].range);
	    }
	    return ranges;
	}
	// TODO: move to geom file?
	function anyRangesContainRange(outerRanges, innerRange) {
	    for (var _i = 0, outerRanges_1 = outerRanges; _i < outerRanges_1.length; _i++) {
	        var outerRange = outerRanges_1[_i];
	        if (rangeContainsRange(outerRange, innerRange)) {
	            return true;
	        }
	    }
	    return false;
	}
	
	var VISIBLE_HIDDEN_RE = /^(visible|hidden)$/;
	var Scroller = /** @class */ (function (_super) {
	    tslib.__extends(Scroller, _super);
	    function Scroller() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleEl = function (el) {
	            _this.el = el;
	            setRef(_this.props.elRef, el);
	        };
	        return _this;
	    }
	    Scroller.prototype.render = function () {
	        var props = this.props;
	        var liquid = props.liquid, liquidIsAbsolute = props.liquidIsAbsolute;
	        var isAbsolute = liquid && liquidIsAbsolute;
	        var className = ['fc-scroller'];
	        if (liquid) {
	            if (liquidIsAbsolute) {
	                className.push('fc-scroller-liquid-absolute');
	            }
	            else {
	                className.push('fc-scroller-liquid');
	            }
	        }
	        return (vdom_cjs.createElement("div", { ref: this.handleEl, className: className.join(' '), style: {
	                overflowX: props.overflowX,
	                overflowY: props.overflowY,
	                left: (isAbsolute && -(props.overcomeLeft || 0)) || '',
	                right: (isAbsolute && -(props.overcomeRight || 0)) || '',
	                bottom: (isAbsolute && -(props.overcomeBottom || 0)) || '',
	                marginLeft: (!isAbsolute && -(props.overcomeLeft || 0)) || '',
	                marginRight: (!isAbsolute && -(props.overcomeRight || 0)) || '',
	                marginBottom: (!isAbsolute && -(props.overcomeBottom || 0)) || '',
	                maxHeight: props.maxHeight || '',
	            } }, props.children));
	    };
	    Scroller.prototype.needsXScrolling = function () {
	        if (VISIBLE_HIDDEN_RE.test(this.props.overflowX)) {
	            return false;
	        }
	        // testing scrollWidth>clientWidth is unreliable cross-browser when pixel heights aren't integers.
	        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
	        // inner-child margins and absolute positioning
	        var el = this.el;
	        var realClientWidth = this.el.getBoundingClientRect().width - this.getYScrollbarWidth();
	        var children = el.children;
	        for (var i = 0; i < children.length; i += 1) {
	            var childEl = children[i];
	            if (childEl.getBoundingClientRect().width > realClientWidth) {
	                return true;
	            }
	        }
	        return false;
	    };
	    Scroller.prototype.needsYScrolling = function () {
	        if (VISIBLE_HIDDEN_RE.test(this.props.overflowY)) {
	            return false;
	        }
	        // testing scrollHeight>clientHeight is unreliable cross-browser when pixel heights aren't integers.
	        // much more reliable to see if children are taller than the scroller, even tho doesn't account for
	        // inner-child margins and absolute positioning
	        var el = this.el;
	        var realClientHeight = this.el.getBoundingClientRect().height - this.getXScrollbarWidth();
	        var children = el.children;
	        for (var i = 0; i < children.length; i += 1) {
	            var childEl = children[i];
	            if (childEl.getBoundingClientRect().height > realClientHeight) {
	                return true;
	            }
	        }
	        return false;
	    };
	    Scroller.prototype.getXScrollbarWidth = function () {
	        if (VISIBLE_HIDDEN_RE.test(this.props.overflowX)) {
	            return 0;
	        }
	        return this.el.offsetHeight - this.el.clientHeight; // only works because we guarantee no borders. TODO: add to CSS with important?
	    };
	    Scroller.prototype.getYScrollbarWidth = function () {
	        if (VISIBLE_HIDDEN_RE.test(this.props.overflowY)) {
	            return 0;
	        }
	        return this.el.offsetWidth - this.el.clientWidth; // only works because we guarantee no borders. TODO: add to CSS with important?
	    };
	    return Scroller;
	}(BaseComponent));
	
	/*
	TODO: somehow infer OtherArgs from masterCallback?
	TODO: infer RefType from masterCallback if provided
	*/
	var RefMap = /** @class */ (function () {
	    function RefMap(masterCallback) {
	        var _this = this;
	        this.masterCallback = masterCallback;
	        this.currentMap = {};
	        this.depths = {};
	        this.callbackMap = {};
	        this.handleValue = function (val, key) {
	            var _a = _this, depths = _a.depths, currentMap = _a.currentMap;
	            var removed = false;
	            var added = false;
	            if (val !== null) {
	                // for bug... ACTUALLY: can probably do away with this now that callers don't share numeric indices anymore
	                removed = (key in currentMap);
	                currentMap[key] = val;
	                depths[key] = (depths[key] || 0) + 1;
	                added = true;
	            }
	            else {
	                depths[key] -= 1;
	                if (!depths[key]) {
	                    delete currentMap[key];
	                    delete _this.callbackMap[key];
	                    removed = true;
	                }
	            }
	            if (_this.masterCallback) {
	                if (removed) {
	                    _this.masterCallback(null, String(key));
	                }
	                if (added) {
	                    _this.masterCallback(val, String(key));
	                }
	            }
	        };
	    }
	    RefMap.prototype.createRef = function (key) {
	        var _this = this;
	        var refCallback = this.callbackMap[key];
	        if (!refCallback) {
	            refCallback = this.callbackMap[key] = function (val) {
	                _this.handleValue(val, String(key));
	            };
	        }
	        return refCallback;
	    };
	    // TODO: check callers that don't care about order. should use getAll instead
	    // NOTE: this method has become less valuable now that we are encouraged to map order by some other index
	    // TODO: provide ONE array-export function, buildArray, which fails on non-numeric indexes. caller can manipulate and "collect"
	    RefMap.prototype.collect = function (startIndex, endIndex, step) {
	        return collectFromHash(this.currentMap, startIndex, endIndex, step);
	    };
	    RefMap.prototype.getAll = function () {
	        return hashValuesToArray(this.currentMap);
	    };
	    return RefMap;
	}());
	
	function computeShrinkWidth(chunkEls) {
	    var shrinkCells = findElements(chunkEls, '.fc-scrollgrid-shrink');
	    var largestWidth = 0;
	    for (var _i = 0, shrinkCells_1 = shrinkCells; _i < shrinkCells_1.length; _i++) {
	        var shrinkCell = shrinkCells_1[_i];
	        largestWidth = Math.max(largestWidth, computeSmallestCellWidth(shrinkCell));
	    }
	    return Math.ceil(largestWidth); // <table> elements work best with integers. round up to ensure contents fits
	}
	function getSectionHasLiquidHeight(props, sectionConfig) {
	    return props.liquid && sectionConfig.liquid; // does the section do liquid-height? (need to have whole scrollgrid liquid-height as well)
	}
	function getAllowYScrolling(props, sectionConfig) {
	    return sectionConfig.maxHeight != null || // if its possible for the height to max out, we might need scrollbars
	        getSectionHasLiquidHeight(props, sectionConfig); // if the section is liquid height, it might condense enough to require scrollbars
	}
	// TODO: ONLY use `arg`. force out internal function to use same API
	function renderChunkContent(sectionConfig, chunkConfig, arg, isHeader) {
	    var expandRows = arg.expandRows;
	    var content = typeof chunkConfig.content === 'function' ?
	        chunkConfig.content(arg) :
	        vdom_cjs.createElement('table', {
	            role: 'presentation',
	            className: [
	                chunkConfig.tableClassName,
	                sectionConfig.syncRowHeights ? 'fc-scrollgrid-sync-table' : '',
	            ].join(' '),
	            style: {
	                minWidth: arg.tableMinWidth,
	                width: arg.clientWidth,
	                height: expandRows ? arg.clientHeight : '', // css `height` on a <table> serves as a min-height
	            },
	        }, arg.tableColGroupNode, vdom_cjs.createElement(isHeader ? 'thead' : 'tbody', {
	            role: 'presentation',
	        }, typeof chunkConfig.rowContent === 'function'
	            ? chunkConfig.rowContent(arg)
	            : chunkConfig.rowContent));
	    return content;
	}
	function isColPropsEqual(cols0, cols1) {
	    return isArraysEqual(cols0, cols1, isPropsEqual);
	}
	function renderMicroColGroup(cols, shrinkWidth) {
	    var colNodes = [];
	    /*
	    for ColProps with spans, it would have been great to make a single <col span="">
	    HOWEVER, Chrome was getting messing up distributing the width to <td>/<th> elements with colspans.
	    SOLUTION: making individual <col> elements makes Chrome behave.
	    */
	    for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
	        var colProps = cols_1[_i];
	        var span = colProps.span || 1;
	        for (var i = 0; i < span; i += 1) {
	            colNodes.push(vdom_cjs.createElement("col", { style: {
	                    width: colProps.width === 'shrink' ? sanitizeShrinkWidth(shrinkWidth) : (colProps.width || ''),
	                    minWidth: colProps.minWidth || '',
	                } }));
	        }
	    }
	    return vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(['colgroup', {}], colNodes));
	}
	function sanitizeShrinkWidth(shrinkWidth) {
	    /* why 4? if we do 0, it will kill any border, which are needed for computeSmallestCellWidth
	    4 accounts for 2 2-pixel borders. TODO: better solution? */
	    return shrinkWidth == null ? 4 : shrinkWidth;
	}
	function hasShrinkWidth(cols) {
	    for (var _i = 0, cols_2 = cols; _i < cols_2.length; _i++) {
	        var col = cols_2[_i];
	        if (col.width === 'shrink') {
	            return true;
	        }
	    }
	    return false;
	}
	function getScrollGridClassNames(liquid, context) {
	    var classNames = [
	        'fc-scrollgrid',
	        context.theme.getClass('table'),
	    ];
	    if (liquid) {
	        classNames.push('fc-scrollgrid-liquid');
	    }
	    return classNames;
	}
	function getSectionClassNames(sectionConfig, wholeTableVGrow) {
	    var classNames = [
	        'fc-scrollgrid-section',
	        "fc-scrollgrid-section-" + sectionConfig.type,
	        sectionConfig.className, // used?
	    ];
	    if (wholeTableVGrow && sectionConfig.liquid && sectionConfig.maxHeight == null) {
	        classNames.push('fc-scrollgrid-section-liquid');
	    }
	    if (sectionConfig.isSticky) {
	        classNames.push('fc-scrollgrid-section-sticky');
	    }
	    return classNames;
	}
	function renderScrollShim(arg) {
	    return (vdom_cjs.createElement("div", { className: "fc-scrollgrid-sticky-shim", style: {
	            width: arg.clientWidth,
	            minWidth: arg.tableMinWidth,
	        } }));
	}
	function getStickyHeaderDates(options) {
	    var stickyHeaderDates = options.stickyHeaderDates;
	    if (stickyHeaderDates == null || stickyHeaderDates === 'auto') {
	        stickyHeaderDates = options.height === 'auto' || options.viewHeight === 'auto';
	    }
	    return stickyHeaderDates;
	}
	function getStickyFooterScrollbar(options) {
	    var stickyFooterScrollbar = options.stickyFooterScrollbar;
	    if (stickyFooterScrollbar == null || stickyFooterScrollbar === 'auto') {
	        stickyFooterScrollbar = options.height === 'auto' || options.viewHeight === 'auto';
	    }
	    return stickyFooterScrollbar;
	}
	
	var SimpleScrollGrid = /** @class */ (function (_super) {
	    tslib.__extends(SimpleScrollGrid, _super);
	    function SimpleScrollGrid() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.processCols = memoize(function (a) { return a; }, isColPropsEqual); // so we get same `cols` props every time
	        // yucky to memoize VNodes, but much more efficient for consumers
	        _this.renderMicroColGroup = memoize(renderMicroColGroup);
	        _this.scrollerRefs = new RefMap();
	        _this.scrollerElRefs = new RefMap(_this._handleScrollerEl.bind(_this));
	        _this.state = {
	            shrinkWidth: null,
	            forceYScrollbars: false,
	            scrollerClientWidths: {},
	            scrollerClientHeights: {},
	        };
	        // TODO: can do a really simple print-view. dont need to join rows
	        _this.handleSizing = function () {
	            _this.safeSetState(tslib.__assign({ shrinkWidth: _this.computeShrinkWidth() }, _this.computeScrollerDims()));
	        };
	        return _this;
	    }
	    SimpleScrollGrid.prototype.render = function () {
	        var _a = this, props = _a.props, state = _a.state, context = _a.context;
	        var sectionConfigs = props.sections || [];
	        var cols = this.processCols(props.cols);
	        var microColGroupNode = this.renderMicroColGroup(cols, state.shrinkWidth);
	        var classNames = getScrollGridClassNames(props.liquid, context);
	        if (props.collapsibleWidth) {
	            classNames.push('fc-scrollgrid-collapsible');
	        }
	        // TODO: make DRY
	        var configCnt = sectionConfigs.length;
	        var configI = 0;
	        var currentConfig;
	        var headSectionNodes = [];
	        var bodySectionNodes = [];
	        var footSectionNodes = [];
	        while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'header') {
	            headSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
	            configI += 1;
	        }
	        while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'body') {
	            bodySectionNodes.push(this.renderSection(currentConfig, microColGroupNode, false));
	            configI += 1;
	        }
	        while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'footer') {
	            footSectionNodes.push(this.renderSection(currentConfig, microColGroupNode, true));
	            configI += 1;
	        }
	        // firefox bug: when setting height on table and there is a thead or tfoot,
	        // the necessary height:100% on the liquid-height body section forces the *whole* table to be taller. (bug #5524)
	        // use getCanVGrowWithinCell as a way to detect table-stupid firefox.
	        // if so, use a simpler dom structure, jam everything into a lone tbody.
	        var isBuggy = !getCanVGrowWithinCell();
	        var roleAttrs = { role: 'rowgroup' };
	        return vdom_cjs.createElement('table', {
	            role: 'grid',
	            className: classNames.join(' '),
	            style: { height: props.height },
	        }, Boolean(!isBuggy && headSectionNodes.length) && vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(['thead', roleAttrs], headSectionNodes)), Boolean(!isBuggy && bodySectionNodes.length) && vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(['tbody', roleAttrs], bodySectionNodes)), Boolean(!isBuggy && footSectionNodes.length) && vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(['tfoot', roleAttrs], footSectionNodes)), isBuggy && vdom_cjs.createElement.apply(void 0, tslib.__spreadArray(tslib.__spreadArray(tslib.__spreadArray(['tbody', roleAttrs], headSectionNodes), bodySectionNodes), footSectionNodes)));
	    };
	    SimpleScrollGrid.prototype.renderSection = function (sectionConfig, microColGroupNode, isHeader) {
	        if ('outerContent' in sectionConfig) {
	            return (vdom_cjs.createElement(vdom_cjs.Fragment, { key: sectionConfig.key }, sectionConfig.outerContent));
	        }
	        return (vdom_cjs.createElement("tr", { key: sectionConfig.key, role: "presentation", className: getSectionClassNames(sectionConfig, this.props.liquid).join(' ') }, this.renderChunkTd(sectionConfig, microColGroupNode, sectionConfig.chunk, isHeader)));
	    };
	    SimpleScrollGrid.prototype.renderChunkTd = function (sectionConfig, microColGroupNode, chunkConfig, isHeader) {
	        if ('outerContent' in chunkConfig) {
	            return chunkConfig.outerContent;
	        }
	        var props = this.props;
	        var _a = this.state, forceYScrollbars = _a.forceYScrollbars, scrollerClientWidths = _a.scrollerClientWidths, scrollerClientHeights = _a.scrollerClientHeights;
	        var needsYScrolling = getAllowYScrolling(props, sectionConfig); // TODO: do lazily. do in section config?
	        var isLiquid = getSectionHasLiquidHeight(props, sectionConfig);
	        // for `!props.liquid` - is WHOLE scrollgrid natural height?
	        // TODO: do same thing in advanced scrollgrid? prolly not b/c always has horizontal scrollbars
	        var overflowY = !props.liquid ? 'visible' :
	            forceYScrollbars ? 'scroll' :
	                !needsYScrolling ? 'hidden' :
	                    'auto';
	        var sectionKey = sectionConfig.key;
	        var content = renderChunkContent(sectionConfig, chunkConfig, {
	            tableColGroupNode: microColGroupNode,
	            tableMinWidth: '',
	            clientWidth: (!props.collapsibleWidth && scrollerClientWidths[sectionKey] !== undefined) ? scrollerClientWidths[sectionKey] : null,
	            clientHeight: scrollerClientHeights[sectionKey] !== undefined ? scrollerClientHeights[sectionKey] : null,
	            expandRows: sectionConfig.expandRows,
	            syncRowHeights: false,
	            rowSyncHeights: [],
	            reportRowHeightChange: function () { },
	        }, isHeader);
	        return vdom_cjs.createElement(isHeader ? 'th' : 'td', {
	            ref: chunkConfig.elRef,
	            role: 'presentation',
	        }, vdom_cjs.createElement("div", { className: "fc-scroller-harness" + (isLiquid ? ' fc-scroller-harness-liquid' : '') },
	            vdom_cjs.createElement(Scroller, { ref: this.scrollerRefs.createRef(sectionKey), elRef: this.scrollerElRefs.createRef(sectionKey), overflowY: overflowY, overflowX: !props.liquid ? 'visible' : 'hidden' /* natural height? */, maxHeight: sectionConfig.maxHeight, liquid: isLiquid, liquidIsAbsolute // because its within a harness
	                : true }, content)));
	    };
	    SimpleScrollGrid.prototype._handleScrollerEl = function (scrollerEl, key) {
	        var section = getSectionByKey(this.props.sections, key);
	        if (section) {
	            setRef(section.chunk.scrollerElRef, scrollerEl);
	        }
	    };
	    SimpleScrollGrid.prototype.componentDidMount = function () {
	        this.handleSizing();
	        this.context.addResizeHandler(this.handleSizing);
	    };
	    SimpleScrollGrid.prototype.componentDidUpdate = function () {
	        // TODO: need better solution when state contains non-sizing things
	        this.handleSizing();
	    };
	    SimpleScrollGrid.prototype.componentWillUnmount = function () {
	        this.context.removeResizeHandler(this.handleSizing);
	    };
	    SimpleScrollGrid.prototype.computeShrinkWidth = function () {
	        return hasShrinkWidth(this.props.cols)
	            ? computeShrinkWidth(this.scrollerElRefs.getAll())
	            : 0;
	    };
	    SimpleScrollGrid.prototype.computeScrollerDims = function () {
	        var scrollbarWidth = getScrollbarWidths();
	        var _a = this, scrollerRefs = _a.scrollerRefs, scrollerElRefs = _a.scrollerElRefs;
	        var forceYScrollbars = false;
	        var scrollerClientWidths = {};
	        var scrollerClientHeights = {};
	        for (var sectionKey in scrollerRefs.currentMap) {
	            var scroller = scrollerRefs.currentMap[sectionKey];
	            if (scroller && scroller.needsYScrolling()) {
	                forceYScrollbars = true;
	                break;
	            }
	        }
	        for (var _i = 0, _b = this.props.sections; _i < _b.length; _i++) {
	            var section = _b[_i];
	            var sectionKey = section.key;
	            var scrollerEl = scrollerElRefs.currentMap[sectionKey];
	            if (scrollerEl) {
	                var harnessEl = scrollerEl.parentNode; // TODO: weird way to get this. need harness b/c doesn't include table borders
	                scrollerClientWidths[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().width - (forceYScrollbars
	                    ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
	                    : 0));
	                scrollerClientHeights[sectionKey] = Math.floor(harnessEl.getBoundingClientRect().height);
	            }
	        }
	        return { forceYScrollbars: forceYScrollbars, scrollerClientWidths: scrollerClientWidths, scrollerClientHeights: scrollerClientHeights };
	    };
	    return SimpleScrollGrid;
	}(BaseComponent));
	SimpleScrollGrid.addStateEquality({
	    scrollerClientWidths: isPropsEqual,
	    scrollerClientHeights: isPropsEqual,
	});
	function getSectionByKey(sections, key) {
	    for (var _i = 0, sections_1 = sections; _i < sections_1.length; _i++) {
	        var section = sections_1[_i];
	        if (section.key === key) {
	            return section;
	        }
	    }
	    return null;
	}
	
	var EventRoot = /** @class */ (function (_super) {
	    tslib.__extends(EventRoot, _super);
	    function EventRoot() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.elRef = vdom_cjs.createRef();
	        return _this;
	    }
	    EventRoot.prototype.render = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        var options = context.options;
	        var seg = props.seg;
	        var eventRange = seg.eventRange;
	        var ui = eventRange.ui;
	        var hookProps = {
	            event: new EventApi(context, eventRange.def, eventRange.instance),
	            view: context.viewApi,
	            timeText: props.timeText,
	            textColor: ui.textColor,
	            backgroundColor: ui.backgroundColor,
	            borderColor: ui.borderColor,
	            isDraggable: !props.disableDragging && computeSegDraggable(seg, context),
	            isStartResizable: !props.disableResizing && computeSegStartResizable(seg, context),
	            isEndResizable: !props.disableResizing && computeSegEndResizable(seg),
	            isMirror: Boolean(props.isDragging || props.isResizing || props.isDateSelecting),
	            isStart: Boolean(seg.isStart),
	            isEnd: Boolean(seg.isEnd),
	            isPast: Boolean(props.isPast),
	            isFuture: Boolean(props.isFuture),
	            isToday: Boolean(props.isToday),
	            isSelected: Boolean(props.isSelected),
	            isDragging: Boolean(props.isDragging),
	            isResizing: Boolean(props.isResizing),
	        };
	        var standardClassNames = getEventClassNames(hookProps).concat(ui.classNames);
	        return (vdom_cjs.createElement(RenderHook, { hookProps: hookProps, classNames: options.eventClassNames, content: options.eventContent, defaultContent: props.defaultContent, didMount: options.eventDidMount, willUnmount: options.eventWillUnmount, elRef: this.elRef }, function (rootElRef, customClassNames, innerElRef, innerContent) { return props.children(rootElRef, standardClassNames.concat(customClassNames), innerElRef, innerContent, hookProps); }));
	    };
	    EventRoot.prototype.componentDidMount = function () {
	        setElSeg(this.elRef.current, this.props.seg);
	    };
	    /*
	    need to re-assign seg to the element if seg changes, even if the element is the same
	    */
	    EventRoot.prototype.componentDidUpdate = function (prevProps) {
	        var seg = this.props.seg;
	        if (seg !== prevProps.seg) {
	            setElSeg(this.elRef.current, seg);
	        }
	    };
	    return EventRoot;
	}(BaseComponent));
	
	// should not be a purecomponent
	var StandardEvent = /** @class */ (function (_super) {
	    tslib.__extends(StandardEvent, _super);
	    function StandardEvent() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    StandardEvent.prototype.render = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        var seg = props.seg;
	        var timeFormat = context.options.eventTimeFormat || props.defaultTimeFormat;
	        var timeText = buildSegTimeText(seg, timeFormat, context, props.defaultDisplayEventTime, props.defaultDisplayEventEnd);
	        return (vdom_cjs.createElement(EventRoot, { seg: seg, timeText: timeText, disableDragging: props.disableDragging, disableResizing: props.disableResizing, defaultContent: props.defaultContent || renderInnerContent$1, isDragging: props.isDragging, isResizing: props.isResizing, isDateSelecting: props.isDateSelecting, isSelected: props.isSelected, isPast: props.isPast, isFuture: props.isFuture, isToday: props.isToday }, function (rootElRef, classNames, innerElRef, innerContent, hookProps) { return (vdom_cjs.createElement("a", tslib.__assign({ className: props.extraClassNames.concat(classNames).join(' '), style: {
	                borderColor: hookProps.borderColor,
	                backgroundColor: hookProps.backgroundColor,
	            }, ref: rootElRef }, getSegAnchorAttrs(seg, context)),
	            vdom_cjs.createElement("div", { className: "fc-event-main", ref: innerElRef, style: { color: hookProps.textColor } }, innerContent),
	            hookProps.isStartResizable &&
	                vdom_cjs.createElement("div", { className: "fc-event-resizer fc-event-resizer-start" }),
	            hookProps.isEndResizable &&
	                vdom_cjs.createElement("div", { className: "fc-event-resizer fc-event-resizer-end" }))); }));
	    };
	    return StandardEvent;
	}(BaseComponent));
	function renderInnerContent$1(innerProps) {
	    return (vdom_cjs.createElement("div", { className: "fc-event-main-frame" },
	        innerProps.timeText && (vdom_cjs.createElement("div", { className: "fc-event-time" }, innerProps.timeText)),
	        vdom_cjs.createElement("div", { className: "fc-event-title-container" },
	            vdom_cjs.createElement("div", { className: "fc-event-title fc-sticky" }, innerProps.event.title || vdom_cjs.createElement(vdom_cjs.Fragment, null, "\u00A0")))));
	}
	
	var NowIndicatorRoot = function (props) { return (vdom_cjs.createElement(ViewContextType.Consumer, null, function (context) {
	    var options = context.options;
	    var hookProps = {
	        isAxis: props.isAxis,
	        date: context.dateEnv.toDate(props.date),
	        view: context.viewApi,
	    };
	    return (vdom_cjs.createElement(RenderHook, { hookProps: hookProps, classNames: options.nowIndicatorClassNames, content: options.nowIndicatorContent, didMount: options.nowIndicatorDidMount, willUnmount: options.nowIndicatorWillUnmount }, props.children));
	})); };
	
	var DAY_NUM_FORMAT = createFormatter({ day: 'numeric' });
	var DayCellContent = /** @class */ (function (_super) {
	    tslib.__extends(DayCellContent, _super);
	    function DayCellContent() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DayCellContent.prototype.render = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        var options = context.options;
	        var hookProps = refineDayCellHookProps({
	            date: props.date,
	            dateProfile: props.dateProfile,
	            todayRange: props.todayRange,
	            showDayNumber: props.showDayNumber,
	            extraProps: props.extraHookProps,
	            viewApi: context.viewApi,
	            dateEnv: context.dateEnv,
	        });
	        return (vdom_cjs.createElement(ContentHook, { hookProps: hookProps, content: options.dayCellContent, defaultContent: props.defaultContent }, props.children));
	    };
	    return DayCellContent;
	}(BaseComponent));
	function refineDayCellHookProps(raw) {
	    var date = raw.date, dateEnv = raw.dateEnv;
	    var dayMeta = getDateMeta(date, raw.todayRange, null, raw.dateProfile);
	    return tslib.__assign(tslib.__assign(tslib.__assign({ date: dateEnv.toDate(date), view: raw.viewApi }, dayMeta), { dayNumberText: raw.showDayNumber ? dateEnv.format(date, DAY_NUM_FORMAT) : '' }), raw.extraProps);
	}
	
	var DayCellRoot = /** @class */ (function (_super) {
	    tslib.__extends(DayCellRoot, _super);
	    function DayCellRoot() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.refineHookProps = memoizeObjArg(refineDayCellHookProps);
	        _this.normalizeClassNames = buildClassNameNormalizer();
	        return _this;
	    }
	    DayCellRoot.prototype.render = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        var options = context.options;
	        var hookProps = this.refineHookProps({
	            date: props.date,
	            dateProfile: props.dateProfile,
	            todayRange: props.todayRange,
	            showDayNumber: props.showDayNumber,
	            extraProps: props.extraHookProps,
	            viewApi: context.viewApi,
	            dateEnv: context.dateEnv,
	        });
	        var classNames = getDayClassNames(hookProps, context.theme).concat(hookProps.isDisabled
	            ? [] // don't use custom classNames if disabled
	            : this.normalizeClassNames(options.dayCellClassNames, hookProps));
	        var dataAttrs = hookProps.isDisabled ? {} : {
	            'data-date': formatDayString(props.date),
	        };
	        return (vdom_cjs.createElement(MountHook, { hookProps: hookProps, didMount: options.dayCellDidMount, willUnmount: options.dayCellWillUnmount, elRef: props.elRef }, function (rootElRef) { return props.children(rootElRef, classNames, dataAttrs, hookProps.isDisabled); }));
	    };
	    return DayCellRoot;
	}(BaseComponent));
	
	function renderFill(fillType) {
	    return (vdom_cjs.createElement("div", { className: "fc-" + fillType }));
	}
	var BgEvent = function (props) { return (vdom_cjs.createElement(EventRoot, { defaultContent: renderInnerContent, seg: props.seg /* uselesss i think */, timeText: "", disableDragging: true, disableResizing: true, isDragging: false, isResizing: false, isDateSelecting: false, isSelected: false, isPast: props.isPast, isFuture: props.isFuture, isToday: props.isToday }, function (rootElRef, classNames, innerElRef, innerContent, hookProps) { return (vdom_cjs.createElement("div", { ref: rootElRef, className: ['fc-bg-event'].concat(classNames).join(' '), style: {
	        backgroundColor: hookProps.backgroundColor,
	    } }, innerContent)); })); };
	function renderInnerContent(props) {
	    var title = props.event.title;
	    return title && (vdom_cjs.createElement("div", { className: "fc-event-title" }, props.event.title));
	}
	
	var WeekNumberRoot = function (props) { return (vdom_cjs.createElement(ViewContextType.Consumer, null, function (context) {
	    var dateEnv = context.dateEnv, options = context.options;
	    var date = props.date;
	    var format = options.weekNumberFormat || props.defaultFormat;
	    var num = dateEnv.computeWeekNumber(date); // TODO: somehow use for formatting as well?
	    var text = dateEnv.format(date, format);
	    var hookProps = { num: num, text: text, date: date };
	    return (vdom_cjs.createElement(RenderHook, { hookProps: hookProps, classNames: options.weekNumberClassNames, content: options.weekNumberContent, defaultContent: renderInner, didMount: options.weekNumberDidMount, willUnmount: options.weekNumberWillUnmount }, props.children));
	})); };
	function renderInner(innerProps) {
	    return innerProps.text;
	}
	
	var PADDING_FROM_VIEWPORT = 10;
	var Popover = /** @class */ (function (_super) {
	    tslib.__extends(Popover, _super);
	    function Popover() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.state = {
	            titleId: getUniqueDomId(),
	        };
	        _this.handleRootEl = function (el) {
	            _this.rootEl = el;
	            if (_this.props.elRef) {
	                setRef(_this.props.elRef, el);
	            }
	        };
	        // Triggered when the user clicks *anywhere* in the document, for the autoHide feature
	        _this.handleDocumentMouseDown = function (ev) {
	            // only hide the popover if the click happened outside the popover
	            var target = getEventTargetViaRoot(ev);
	            if (!_this.rootEl.contains(target)) {
	                _this.handleCloseClick();
	            }
	        };
	        _this.handleDocumentKeyDown = function (ev) {
	            if (ev.key === 'Escape') {
	                _this.handleCloseClick();
	            }
	        };
	        _this.handleCloseClick = function () {
	            var onClose = _this.props.onClose;
	            if (onClose) {
	                onClose();
	            }
	        };
	        return _this;
	    }
	    Popover.prototype.render = function () {
	        var _a = this.context, theme = _a.theme, options = _a.options;
	        var _b = this, props = _b.props, state = _b.state;
	        var classNames = [
	            'fc-popover',
	            theme.getClass('popover'),
	        ].concat(props.extraClassNames || []);
	        return vdom_cjs.createPortal(vdom_cjs.createElement("div", tslib.__assign({ id: props.id, className: classNames.join(' '), "aria-labelledby": state.titleId }, props.extraAttrs, { ref: this.handleRootEl }),
	            vdom_cjs.createElement("div", { className: 'fc-popover-header ' + theme.getClass('popoverHeader') },
	                vdom_cjs.createElement("span", { className: "fc-popover-title", id: state.titleId }, props.title),
	                vdom_cjs.createElement("span", { className: 'fc-popover-close ' + theme.getIconClass('close'), title: options.closeHint, onClick: this.handleCloseClick })),
	            vdom_cjs.createElement("div", { className: 'fc-popover-body ' + theme.getClass('popoverContent') }, props.children)), props.parentEl);
	    };
	    Popover.prototype.componentDidMount = function () {
	        document.addEventListener('mousedown', this.handleDocumentMouseDown);
	        document.addEventListener('keydown', this.handleDocumentKeyDown);
	        this.updateSize();
	    };
	    Popover.prototype.componentWillUnmount = function () {
	        document.removeEventListener('mousedown', this.handleDocumentMouseDown);
	        document.removeEventListener('keydown', this.handleDocumentKeyDown);
	    };
	    Popover.prototype.updateSize = function () {
	        var isRtl = this.context.isRtl;
	        var _a = this.props, alignmentEl = _a.alignmentEl, alignGridTop = _a.alignGridTop;
	        var rootEl = this.rootEl;
	        var alignmentRect = computeClippedClientRect(alignmentEl);
	        if (alignmentRect) {
	            var popoverDims = rootEl.getBoundingClientRect();
	            // position relative to viewport
	            var popoverTop = alignGridTop
	                ? elementClosest(alignmentEl, '.fc-scrollgrid').getBoundingClientRect().top
	                : alignmentRect.top;
	            var popoverLeft = isRtl ? alignmentRect.right - popoverDims.width : alignmentRect.left;
	            // constrain
	            popoverTop = Math.max(popoverTop, PADDING_FROM_VIEWPORT);
	            popoverLeft = Math.min(popoverLeft, document.documentElement.clientWidth - PADDING_FROM_VIEWPORT - popoverDims.width);
	            popoverLeft = Math.max(popoverLeft, PADDING_FROM_VIEWPORT);
	            var origin_1 = rootEl.offsetParent.getBoundingClientRect();
	            applyStyle(rootEl, {
	                top: popoverTop - origin_1.top,
	                left: popoverLeft - origin_1.left,
	            });
	        }
	    };
	    return Popover;
	}(BaseComponent));
	
	var MorePopover = /** @class */ (function (_super) {
	    tslib.__extends(MorePopover, _super);
	    function MorePopover() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleRootEl = function (rootEl) {
	            _this.rootEl = rootEl;
	            if (rootEl) {
	                _this.context.registerInteractiveComponent(_this, {
	                    el: rootEl,
	                    useEventCenter: false,
	                });
	            }
	            else {
	                _this.context.unregisterInteractiveComponent(_this);
	            }
	        };
	        return _this;
	    }
	    MorePopover.prototype.render = function () {
	        var _a = this.context, options = _a.options, dateEnv = _a.dateEnv;
	        var props = this.props;
	        var startDate = props.startDate, todayRange = props.todayRange, dateProfile = props.dateProfile;
	        var title = dateEnv.format(startDate, options.dayPopoverFormat);
	        return (vdom_cjs.createElement(DayCellRoot, { date: startDate, dateProfile: dateProfile, todayRange: todayRange, elRef: this.handleRootEl }, function (rootElRef, dayClassNames, dataAttrs) { return (vdom_cjs.createElement(Popover, { elRef: rootElRef, id: props.id, title: title, extraClassNames: ['fc-more-popover'].concat(dayClassNames), extraAttrs: dataAttrs /* TODO: make these time-based when not whole-day? */, parentEl: props.parentEl, alignmentEl: props.alignmentEl, alignGridTop: props.alignGridTop, onClose: props.onClose },
	            vdom_cjs.createElement(DayCellContent, { date: startDate, dateProfile: dateProfile, todayRange: todayRange }, function (innerElRef, innerContent) { return (innerContent &&
	                vdom_cjs.createElement("div", { className: "fc-more-popover-misc", ref: innerElRef }, innerContent)); }),
	            props.children)); }));
	    };
	    MorePopover.prototype.queryHit = function (positionLeft, positionTop, elWidth, elHeight) {
	        var _a = this, rootEl = _a.rootEl, props = _a.props;
	        if (positionLeft >= 0 && positionLeft < elWidth &&
	            positionTop >= 0 && positionTop < elHeight) {
	            return {
	                dateProfile: props.dateProfile,
	                dateSpan: tslib.__assign({ allDay: true, range: {
	                        start: props.startDate,
	                        end: props.endDate,
	                    } }, props.extraDateSpan),
	                dayEl: rootEl,
	                rect: {
	                    left: 0,
	                    top: 0,
	                    right: elWidth,
	                    bottom: elHeight,
	                },
	                layer: 1, // important when comparing with hits from other components
	            };
	        }
	        return null;
	    };
	    return MorePopover;
	}(DateComponent));
	
	var MoreLinkRoot = /** @class */ (function (_super) {
	    tslib.__extends(MoreLinkRoot, _super);
	    function MoreLinkRoot() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.linkElRef = vdom_cjs.createRef();
	        _this.state = {
	            isPopoverOpen: false,
	            popoverId: getUniqueDomId(),
	        };
	        _this.handleClick = function (ev) {
	            var _a = _this, props = _a.props, context = _a.context;
	            var moreLinkClick = context.options.moreLinkClick;
	            var date = computeRange(props).start;
	            function buildPublicSeg(seg) {
	                var _a = seg.eventRange, def = _a.def, instance = _a.instance, range = _a.range;
	                return {
	                    event: new EventApi(context, def, instance),
	                    start: context.dateEnv.toDate(range.start),
	                    end: context.dateEnv.toDate(range.end),
	                    isStart: seg.isStart,
	                    isEnd: seg.isEnd,
	                };
	            }
	            if (typeof moreLinkClick === 'function') {
	                moreLinkClick = moreLinkClick({
	                    date: date,
	                    allDay: Boolean(props.allDayDate),
	                    allSegs: props.allSegs.map(buildPublicSeg),
	                    hiddenSegs: props.hiddenSegs.map(buildPublicSeg),
	                    jsEvent: ev,
	                    view: context.viewApi,
	                });
	            }
	            if (!moreLinkClick || moreLinkClick === 'popover') {
	                _this.setState({ isPopoverOpen: true });
	            }
	            else if (typeof moreLinkClick === 'string') { // a view name
	                context.calendarApi.zoomTo(date, moreLinkClick);
	            }
	        };
	        _this.handlePopoverClose = function () {
	            _this.setState({ isPopoverOpen: false });
	        };
	        return _this;
	    }
	    MoreLinkRoot.prototype.render = function () {
	        var _this = this;
	        var _a = this, props = _a.props, state = _a.state;
	        return (vdom_cjs.createElement(ViewContextType.Consumer, null, function (context) {
	            var viewApi = context.viewApi, options = context.options, calendarApi = context.calendarApi;
	            var moreLinkText = options.moreLinkText;
	            var moreCnt = props.moreCnt;
	            var range = computeRange(props);
	            var text = typeof moreLinkText === 'function' // TODO: eventually use formatWithOrdinals
	                ? moreLinkText.call(calendarApi, moreCnt)
	                : "+" + moreCnt + " " + moreLinkText;
	            var title = formatWithOrdinals(options.moreLinkHint, [moreCnt], text);
	            var hookProps = {
	                num: moreCnt,
	                shortText: "+" + moreCnt,
	                text: text,
	                view: viewApi,
	            };
	            return (vdom_cjs.createElement(vdom_cjs.Fragment, null,
	                Boolean(props.moreCnt) && (vdom_cjs.createElement(RenderHook, { elRef: _this.linkElRef, hookProps: hookProps, classNames: options.moreLinkClassNames, content: options.moreLinkContent, defaultContent: props.defaultContent || renderMoreLinkInner, didMount: options.moreLinkDidMount, willUnmount: options.moreLinkWillUnmount }, function (rootElRef, customClassNames, innerElRef, innerContent) { return props.children(rootElRef, ['fc-more-link'].concat(customClassNames), innerElRef, innerContent, _this.handleClick, title, state.isPopoverOpen, state.isPopoverOpen ? state.popoverId : ''); })),
	                state.isPopoverOpen && (vdom_cjs.createElement(MorePopover, { id: state.popoverId, startDate: range.start, endDate: range.end, dateProfile: props.dateProfile, todayRange: props.todayRange, extraDateSpan: props.extraDateSpan, parentEl: _this.parentEl, alignmentEl: props.alignmentElRef.current, alignGridTop: props.alignGridTop, onClose: _this.handlePopoverClose }, props.popoverContent()))));
	        }));
	    };
	    MoreLinkRoot.prototype.componentDidMount = function () {
	        this.updateParentEl();
	    };
	    MoreLinkRoot.prototype.componentDidUpdate = function () {
	        this.updateParentEl();
	    };
	    MoreLinkRoot.prototype.updateParentEl = function () {
	        if (this.linkElRef.current) {
	            this.parentEl = elementClosest(this.linkElRef.current, '.fc-view-harness');
	        }
	    };
	    return MoreLinkRoot;
	}(BaseComponent));
	function renderMoreLinkInner(props) {
	    return props.text;
	}
	function computeRange(props) {
	    if (props.allDayDate) {
	        return {
	            start: props.allDayDate,
	            end: addDays(props.allDayDate, 1),
	        };
	    }
	    var hiddenSegs = props.hiddenSegs;
	    return {
	        start: computeEarliestSegStart(hiddenSegs),
	        end: computeLatestSegEnd(hiddenSegs),
	    };
	}
	function computeEarliestSegStart(segs) {
	    return segs.reduce(pickEarliestStart).eventRange.range.start;
	}
	function pickEarliestStart(seg0, seg1) {
	    return seg0.eventRange.range.start < seg1.eventRange.range.start ? seg0 : seg1;
	}
	function computeLatestSegEnd(segs) {
	    return segs.reduce(pickLatestEnd).eventRange.range.end;
	}
	function pickLatestEnd(seg0, seg1) {
	    return seg0.eventRange.range.end > seg1.eventRange.range.end ? seg0 : seg1;
	}
	
	// exports
	// --------------------------------------------------------------------------------------------------
	var version = '5.11.5'; // important to type it, so .d.ts has generic string
	
	exports.BASE_OPTION_DEFAULTS = BASE_OPTION_DEFAULTS;
	exports.BASE_OPTION_REFINERS = BASE_OPTION_REFINERS;
	exports.BaseComponent = BaseComponent;
	exports.BgEvent = BgEvent;
	exports.CalendarApi = CalendarApi;
	exports.CalendarContent = CalendarContent;
	exports.CalendarDataManager = CalendarDataManager;
	exports.CalendarDataProvider = CalendarDataProvider;
	exports.CalendarRoot = CalendarRoot;
	exports.ContentHook = ContentHook;
	exports.CustomContentRenderContext = CustomContentRenderContext;
	exports.DateComponent = DateComponent;
	exports.DateEnv = DateEnv;
	exports.DateProfileGenerator = DateProfileGenerator;
	exports.DayCellContent = DayCellContent;
	exports.DayCellRoot = DayCellRoot;
	exports.DayHeader = DayHeader;
	exports.DaySeriesModel = DaySeriesModel;
	exports.DayTableModel = DayTableModel;
	exports.DelayedRunner = DelayedRunner;
	exports.ElementDragging = ElementDragging;
	exports.ElementScrollController = ElementScrollController;
	exports.Emitter = Emitter;
	exports.EventApi = EventApi;
	exports.EventRoot = EventRoot;
	exports.EventSourceApi = EventSourceApi;
	exports.Interaction = Interaction;
	exports.MoreLinkRoot = MoreLinkRoot;
	exports.MountHook = MountHook;
	exports.NamedTimeZoneImpl = NamedTimeZoneImpl;
	exports.NowIndicatorRoot = NowIndicatorRoot;
	exports.NowTimer = NowTimer;
	exports.PositionCache = PositionCache;
	exports.RefMap = RefMap;
	exports.RenderHook = RenderHook;
	exports.ScrollController = ScrollController;
	exports.ScrollResponder = ScrollResponder;
	exports.Scroller = Scroller;
	exports.SegHierarchy = SegHierarchy;
	exports.SimpleScrollGrid = SimpleScrollGrid;
	exports.Slicer = Slicer;
	exports.Splitter = Splitter;
	exports.StandardEvent = StandardEvent;
	exports.TableDateCell = TableDateCell;
	exports.TableDowCell = TableDowCell;
	exports.Theme = Theme;
	exports.ViewApi = ViewApi;
	exports.ViewContextType = ViewContextType;
	exports.ViewRoot = ViewRoot;
	exports.WeekNumberRoot = WeekNumberRoot;
	exports.WindowScrollController = WindowScrollController;
	exports.addDays = addDays;
	exports.addDurations = addDurations;
	exports.addMs = addMs;
	exports.addWeeks = addWeeks;
	exports.allowContextMenu = allowContextMenu;
	exports.allowSelection = allowSelection;
	exports.applyMutationToEventStore = applyMutationToEventStore;
	exports.applyStyle = applyStyle;
	exports.applyStyleProp = applyStyleProp;
	exports.asCleanDays = asCleanDays;
	exports.asRoughMinutes = asRoughMinutes;
	exports.asRoughMs = asRoughMs;
	exports.asRoughSeconds = asRoughSeconds;
	exports.binarySearch = binarySearch;
	exports.buildClassNameNormalizer = buildClassNameNormalizer;
	exports.buildEntryKey = buildEntryKey;
	exports.buildEventApis = buildEventApis;
	exports.buildEventRangeKey = buildEventRangeKey;
	exports.buildHashFromArray = buildHashFromArray;
	exports.buildIsoString = buildIsoString;
	exports.buildNavLinkAttrs = buildNavLinkAttrs;
	exports.buildSegCompareObj = buildSegCompareObj;
	exports.buildSegTimeText = buildSegTimeText;
	exports.collectFromHash = collectFromHash;
	exports.combineEventUis = combineEventUis;
	exports.compareByFieldSpec = compareByFieldSpec;
	exports.compareByFieldSpecs = compareByFieldSpecs;
	exports.compareNumbers = compareNumbers;
	exports.compareObjs = compareObjs;
	exports.computeEarliestSegStart = computeEarliestSegStart;
	exports.computeEdges = computeEdges;
	exports.computeFallbackHeaderFormat = computeFallbackHeaderFormat;
	exports.computeHeightAndMargins = computeHeightAndMargins;
	exports.computeInnerRect = computeInnerRect;
	exports.computeRect = computeRect;
	exports.computeSegDraggable = computeSegDraggable;
	exports.computeSegEndResizable = computeSegEndResizable;
	exports.computeSegStartResizable = computeSegStartResizable;
	exports.computeShrinkWidth = computeShrinkWidth;
	exports.computeSmallestCellWidth = computeSmallestCellWidth;
	exports.computeVisibleDayRange = computeVisibleDayRange;
	exports.config = config;
	exports.constrainPoint = constrainPoint;
	exports.createAriaClickAttrs = createAriaClickAttrs;
	exports.createDuration = createDuration;
	exports.createEmptyEventStore = createEmptyEventStore;
	exports.createEventInstance = createEventInstance;
	exports.createEventUi = createEventUi;
	exports.createFormatter = createFormatter;
	exports.createPlugin = createPlugin;
	exports.diffDates = diffDates;
	exports.diffDayAndTime = diffDayAndTime;
	exports.diffDays = diffDays;
	exports.diffPoints = diffPoints;
	exports.diffWeeks = diffWeeks;
	exports.diffWholeDays = diffWholeDays;
	exports.diffWholeWeeks = diffWholeWeeks;
	exports.disableCursor = disableCursor;
	exports.elementClosest = elementClosest;
	exports.elementMatches = elementMatches;
	exports.enableCursor = enableCursor;
	exports.eventTupleToStore = eventTupleToStore;
	exports.filterEventStoreDefs = filterEventStoreDefs;
	exports.filterHash = filterHash;
	exports.findDirectChildren = findDirectChildren;
	exports.findElements = findElements;
	exports.flexibleCompare = flexibleCompare;
	exports.formatDate = formatDate;
	exports.formatDayString = formatDayString;
	exports.formatIsoTimeString = formatIsoTimeString;
	exports.formatRange = formatRange;
	exports.getAllowYScrolling = getAllowYScrolling;
	exports.getCanVGrowWithinCell = getCanVGrowWithinCell;
	exports.getClippingParents = getClippingParents;
	exports.getDateMeta = getDateMeta;
	exports.getDayClassNames = getDayClassNames;
	exports.getDefaultEventEnd = getDefaultEventEnd;
	exports.getElRoot = getElRoot;
	exports.getElSeg = getElSeg;
	exports.getEntrySpanEnd = getEntrySpanEnd;
	exports.getEventClassNames = getEventClassNames;
	exports.getEventTargetViaRoot = getEventTargetViaRoot;
	exports.getIsRtlScrollbarOnLeft = getIsRtlScrollbarOnLeft;
	exports.getRectCenter = getRectCenter;
	exports.getRelevantEvents = getRelevantEvents;
	exports.getScrollGridClassNames = getScrollGridClassNames;
	exports.getScrollbarWidths = getScrollbarWidths;
	exports.getSectionClassNames = getSectionClassNames;
	exports.getSectionHasLiquidHeight = getSectionHasLiquidHeight;
	exports.getSegAnchorAttrs = getSegAnchorAttrs;
	exports.getSegMeta = getSegMeta;
	exports.getSlotClassNames = getSlotClassNames;
	exports.getStickyFooterScrollbar = getStickyFooterScrollbar;
	exports.getStickyHeaderDates = getStickyHeaderDates;
	exports.getUnequalProps = getUnequalProps;
	exports.getUniqueDomId = getUniqueDomId;
	exports.globalLocales = globalLocales;
	exports.globalPlugins = globalPlugins;
	exports.greatestDurationDenominator = greatestDurationDenominator;
	exports.groupIntersectingEntries = groupIntersectingEntries;
	exports.guid = guid;
	exports.hasBgRendering = hasBgRendering;
	exports.hasShrinkWidth = hasShrinkWidth;
	exports.identity = identity;
	exports.interactionSettingsStore = interactionSettingsStore;
	exports.interactionSettingsToStore = interactionSettingsToStore;
	exports.intersectRanges = intersectRanges;
	exports.intersectRects = intersectRects;
	exports.intersectSpans = intersectSpans;
	exports.isArraysEqual = isArraysEqual;
	exports.isColPropsEqual = isColPropsEqual;
	exports.isDateSelectionValid = isDateSelectionValid;
	exports.isDateSpansEqual = isDateSpansEqual;
	exports.isInt = isInt;
	exports.isInteractionValid = isInteractionValid;
	exports.isMultiDayRange = isMultiDayRange;
	exports.isPropsEqual = isPropsEqual;
	exports.isPropsValid = isPropsValid;
	exports.isValidDate = isValidDate;
	exports.joinSpans = joinSpans;
	exports.listenBySelector = listenBySelector;
	exports.mapHash = mapHash;
	exports.memoize = memoize;
	exports.memoizeArraylike = memoizeArraylike;
	exports.memoizeHashlike = memoizeHashlike;
	exports.memoizeObjArg = memoizeObjArg;
	exports.mergeEventStores = mergeEventStores;
	exports.multiplyDuration = multiplyDuration;
	exports.padStart = padStart;
	exports.parseBusinessHours = parseBusinessHours;
	exports.parseClassNames = parseClassNames;
	exports.parseDragMeta = parseDragMeta;
	exports.parseEventDef = parseEventDef;
	exports.parseFieldSpecs = parseFieldSpecs;
	exports.parseMarker = parse;
	exports.pointInsideRect = pointInsideRect;
	exports.preventContextMenu = preventContextMenu;
	exports.preventDefault = preventDefault;
	exports.preventSelection = preventSelection;
	exports.rangeContainsMarker = rangeContainsMarker;
	exports.rangeContainsRange = rangeContainsRange;
	exports.rangesEqual = rangesEqual;
	exports.rangesIntersect = rangesIntersect;
	exports.refineEventDef = refineEventDef;
	exports.refineProps = refineProps;
	exports.removeElement = removeElement;
	exports.removeExact = removeExact;
	exports.renderChunkContent = renderChunkContent;
	exports.renderFill = renderFill;
	exports.renderMicroColGroup = renderMicroColGroup;
	exports.renderScrollShim = renderScrollShim;
	exports.requestJson = requestJson;
	exports.sanitizeShrinkWidth = sanitizeShrinkWidth;
	exports.setElSeg = setElSeg;
	exports.setRef = setRef;
	exports.sliceEventStore = sliceEventStore;
	exports.sliceEvents = sliceEvents;
	exports.sortEventSegs = sortEventSegs;
	exports.startOfDay = startOfDay;
	exports.translateRect = translateRect;
	exports.triggerDateSelect = triggerDateSelect;
	exports.unpromisify = unpromisify;
	exports.version = version;
	exports.whenTransitionDone = whenTransitionDone;
	exports.wholeDivideDurations = wholeDivideDurations;
	Object.keys(vdom_cjs).forEach(function (k) {
	    if (k !== 'default' && !exports.hasOwnProperty(k)) Object.defineProperty(exports, k, {
	        enumerable: true,
	        get: function () {
	            return vdom_cjs[k];
	        }
	    });
	});


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	function containsNode(parent, child) {
	  if (!parent || !child || !(parent instanceof Element) || !(child instanceof Element)) {
	    return false;
	  }
	  if (!globalObject.document.body.contains(child)) {
	    return false;
	  }
	  var result = true;
	  if (parent !== child && !parent.contains(child)) {
	    result = false;
	  }
	  return result;
	}
	var _default = containsNode;
	exports.default = _default;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _isMobile.default;
	  }
	});
	var _isMobile = _interopRequireDefault(__webpack_require__(64));

/***/ },
/* 73 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = equal;
	exports.equalReturnKey = equalReturnKey;
	var keyList = Object.keys;
	var EMPTY_OBJECT = {};
	function equal(a, b) {
	  var except = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	  if (a === b) return true;
	  if (!(a instanceof Object) || !(b instanceof Object)) return false;
	  var keys = keyList(a);
	  var length = keys.length;
	  var key;
	  for (var i = 0; i < length; i++) {
	    key = keys[i];
	    if (except[key]) {
	      continue;
	    }
	    if (!(key in b)) return false;
	  }
	  for (var i = 0; i < length; i++) {
	    key = keys[i];
	    if (except[key]) {
	      continue;
	    }
	    if (a[key] !== b[key]) return false;
	  }
	  return length === keyList(b).length;
	}
	function equalReturnKey(a, b) {
	  var except = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	  if (a === b) return {
	    result: true,
	    key: undefined
	  };
	  if (!(a instanceof Object) || !(b instanceof Object)) return {
	    result: false,
	    key: undefined
	  };
	  var keys = keyList(a);
	  var length = keys.length;
	  var key;
	  for (var i = 0; i < length; i++) {
	    key = keys[i];
	    if (except[key]) {
	      continue;
	    }
	    if (!(key in b)) return {
	      result: false,
	      key: key
	    };
	  }
	  for (var i = 0; i < length; i++) {
	    key = keys[i];
	    if (except[key]) {
	      continue;
	    }
	    if (a[key] !== b[key]) return {
	      result: false,
	      key: key
	    };
	  }
	  return {
	    result: length === keyList(b).length,
	    key: undefined
	  };
	}

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(67);
	
	var ReactCurrentOwner = __webpack_require__(276);
	
	var warning = __webpack_require__(177);
	var canDefineProperty = __webpack_require__(279);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(277);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(76);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	var _helpers = __webpack_require__(17);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	// Helpers
	
	
	// Components
	
	
	var obx = (0, _mobx.observable)({
	  view: 'list',
	  events: [],
	  eventsNext: null,
	  /**
	   * Get sessions for proctor and store them in events array
	   */
	  getSessions: (0, _mobx.action)(function getSessions(limit, status, callback, sessionSid) {
	    var eatUnauthorized = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	    _SessionStore2.default.startLoading('Loading…', 'GetSessions');
	
	    var statusArray = false;
	
	    if (Array.isArray(status)) {
	      statusArray = true;
	    }
	
	    obx.events = [];
	
	    var query = '';
	
	    if (limit) {
	      query = '?limit=' + limit;
	
	      if (status && !statusArray) {
	        query += '&status=' + status;
	      } else if (status && statusArray) {
	        status.forEach(function (s) {
	          query += '&status=' + s;
	        });
	      }
	    } else {
	      if (status && !statusArray) {
	        query = '?status=' + status;
	      } else if (status && statusArray) {
	        status.forEach(function (s) {
	          query += '&status=' + s;
	        });
	      }
	    }
	
	    if (sessionSid && !limit && !status) {
	      query = '?sessionSids=' + sessionSid;
	    } else if (sessionSid && (limit || status)) {
	      query += '&sesssionSids=' + sessionSid;
	    }
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/sessions' + query).then(function (response) {
	      obx.events = response.data.results;
	
	      // Set pagination next url
	      if (response.data.next) {
	        // API returns a url with a different domain for the next link
	        // so create an anchor element and set its href to the next link
	        // and then grab the pathname and query from that
	        var nextUrl = (0, _helpers.getPath)(response.data.next);
	        nextUrl = nextUrl.replace('/v1', '');
	        if (obx.eventsNext !== nextUrl) {
	          obx.eventsNext = nextUrl;
	        }
	      } else {
	        obx.eventsNext = null;
	      }
	
	      _SessionStore2.default.finishLoading('GetSessions');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      if (eatUnauthorized && error.response.status === 401) {
	        //TODO: Delete this and conditionally make this call in componentWillMount of dashboard.js when we update iam client
	        return;
	      }
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get an individual session
	  sessionType: 'upcoming',
	  session: {},
	  getSingleSession: (0, _mobx.action)(function (sid) {
	    var sessionMatch = false;
	    obx.session = {};
	
	    _SessionStore2.default.startLoading('Loading…', 'GetSession');
	
	    obx.events.forEach(function (session) {
	      if (session.sid === sid) {
	        obx.session = session;
	        sessionMatch = true;
	      }
	    });
	
	    if (!sessionMatch) {
	      _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/singleSession?sessionSid=' + sid).then(function (response) {
	        obx.session = response.data;
	      }).catch(function (error) {
	        _SessionStore2.default.throwError(error);
	      });
	    }
	
	    _SessionStore2.default.finishLoading('GetSession');
	  }),
	  // Get written exam file
	  getExamFile: (0, _mobx.action)(function (installSid, configurationSid, sessionSid, fileName) {
	    _SessionStore2.default.startLoading('Loading…', 'getExamFile');
	
	    _config.api.get('/installs/' + installSid + '/examConfigurations/' + configurationSid + '/examFile?sessionSid=' + sessionSid, {
	      responseType: 'arraybuffer'
	    }).then(function (response) {
	      var tempLink = document.createElement('a');
	      var file = new Blob([response.data], { type: 'application/pdf' });
	
	      if (window.navigator.msSaveOrOpenBlob) {
	        window.navigator.msSaveOrOpenBlob(file, fileName);
	      } else {
	        var fileUrl = URL.createObjectURL(file);
	
	        tempLink.href = fileUrl;
	        tempLink.download = fileName;
	        tempLink.click();
	
	        window.URL.revokeObjectURL(fileUrl);
	      }
	
	      _SessionStore2.default.finishLoading('getExamFile');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Close a session
	  closeSession: (0, _mobx.action)(function (installSid, examSid, sessionSid, callback) {
	    // SessionStore.startLoading('Loading…', 'CloseSession');
	
	    var data = {
	      type: 'messaging',
	      reason: 'exam-completed'
	    };
	
	    _config.api.post('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/close', data).then(function (response) {
	      _SessionStore2.default.finishLoading('CloseSession');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get pending sessions
	  pendingSessions: [],
	  pendingNext: null,
	  getPendingSessions: (0, _mobx.action)(function (status, sortKey) {
	    _SessionStore2.default.startBackgroundLoading('GetPendingSessions');
	
	    obx.pendingSessions = [];
	
	    var sort = '';
	
	    if (sortKey) {
	      sort = '&sortKeys=' + sortKey;
	    }
	
	    _config.api.get('proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/sessions/pending?status=' + status + '&limit=25' + sort).then(function (response) {
	      obx.pendingSessions = response.data.results;
	
	      // Set pagination next url
	      if (response.data.next) {
	        // API returns a url with a different domain for the next link
	        // so create an anchor element and set its href to the next link
	        // and then grab the pathname and query from that
	        var nextUrl = (0, _helpers.getPath)(response.data.next);
	        nextUrl = nextUrl.replace('/v1', '');
	        obx.pendingNext = nextUrl;
	      } else {
	        obx.pendingNext = null;
	      }
	
	      _SessionStore2.default.finishBackgroundLoading('GetPendingSessions');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get scheduling account
	  scheduleAccountEnabled: false,
	  getScheduleAccount: (0, _mobx.action)(function (callback) {
	    _SessionStore2.default.startLoading('Loading…', 'getScheduleAccount');
	
	    _config.schApi.get('accounts/' + _SessionStore2.default.userData.proctorAccountSid).then(function (response) {
	      obx.scheduleAccountEnabled = true;
	      _SessionStore2.default.finishLoading('getScheduleAccount');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      obx.scheduleAccountEnabled = false;
	      _SessionStore2.default.finishLoading('getScheduleAccount');
	    });
	  }),
	  // Enable scheduling account
	  createScheduleAccount: (0, _mobx.action)(function (data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'createScheduleAccount');
	
	    _config.schApi.post('accounts', data).then(function (response) {
	      _SessionStore2.default.finishLoading('createScheduleAccount');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get schedule locations
	  scheduleLocations: [],
	  getScheduleLocations: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'getScheduleLocations');
	
	    _config.schApi.get('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/locations').then(function (response) {
	      obx.scheduleLocations = response.data.results;
	      _SessionStore2.default.finishLoading('getScheduleLocations');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Set schedule location
	  scheduleLocation: null,
	  setScheduleLocation: (0, _mobx.action)(function (scheduleLocationSid) {
	    obx.scheduleLocations.forEach(function (scheduleLocation) {
	      if (scheduleLocation.sid === scheduleLocationSid) {
	        obx.scheduleLocation = scheduleLocation;
	      }
	    });
	  }),
	  // Enable schedule for location
	  enableLocationSchedule: (0, _mobx.action)(function (data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'enableLocationSchedule');
	
	    _config.schApi.post('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/locations', data).then(function (response) {
	      _SessionStore2.default.finishLoading('enableLocationSchedule');
	
	      if (callback) {
	        callback(response.data);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get all location calendars
	  locationCalendars: [],
	  getLocationCalendars: (0, _mobx.action)(function (locationSid) {
	    var noErrorOnAvailability = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    _SessionStore2.default.startLoading('Loading…', 'getLocationCalendars');
	
	    _config.schApi.get('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/locations/' + locationSid + '/calendars').then(function (response) {
	      obx.locationCalendars = response.data.results;
	      _SessionStore2.default.finishLoading('getLocationCalendars');
	    }).catch(function (error) {
	      if (noErrorOnAvailability && error.response.data.code === '1205') {
	        console.log('No proctor location availability for this location...');
	        _SessionStore2.default.finishLoading('getLocationCalendars');
	      } else {
	        _SessionStore2.default.throwError(error);
	      }
	    });
	  }),
	  // Get single location calendar
	  locationCalendar: null,
	  getCalendar: (0, _mobx.action)(function (locationSid, calendarSid, callback) {
	    //SessionStore.startLoading('Loading…', 'getCalendar');
	
	    _config.schApi.get('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/locations/' + locationSid + '/calendars/' + calendarSid).then(function (response) {
	      obx.locationCalendar = response.data;
	      //SessionStore.finishLoading('getCalendar');
	
	      if (callback) {
	        callback(response.data);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  timelineEvents: null,
	  getTimelineEvents: (0, _mobx.action)(function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(start, end) {
	      var assignColorToEvent, _response, _eventsWithColor, response, eventsWithColor;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              assignColorToEvent = function assignColorToEvent(event) {
	                var status = event.extendedProps && event.extendedProps.session && event.extendedProps.session.status ? event.extendedProps.session.status.toLowerCase() : '';
	                var color = void 0;
	
	                switch (status) {
	                  case 'scheduled':
	                    color = '#224590';
	                    break;
	                  case 'in progress':
	                    color = 'rgba(141, 71, 232, 1)';
	                    break;
	                  case 'closed':
	                    color = '#0f5e29ff';
	                    break;
	                  case 'cancelled':
	                    color = 'black';
	                    break;
	                  case 'onboarding':
	                    color = '#00df4aff';
	                    break;
	                  case 'checked in':
	                    color = '#00df4aff';
	                    break;
	                  case 'pending reconnect':
	                    color = '#815930ff';
	                    break;
	                  default:
	                    color = '#224590';
	                }
	
	                return Object.assign({}, event, { color: color });
	              };
	
	              if (!(start && end)) {
	                _context.next = 8;
	                break;
	              }
	
	              _context.next = 4;
	              return _config.schApi.get('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/reports/timeline/events?startDateTime=' + start + '&endDateTime=' + end);
	
	            case 4:
	              _response = _context.sent;
	              _eventsWithColor = _response.data.events.map(assignColorToEvent);
	
	              obx.timelineEvents = Object.assign({}, _response.data, { events: _eventsWithColor });
	
	              return _context.abrupt('return', _response);
	
	            case 8:
	              _context.next = 10;
	              return _config.schApi.get('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/reports/timeline/events?startDateTime=' + (0, _moment2.default)().startOf('day').format('YYYY-MM-DDTHH:mm:ssZ') + '&endDateTime=' + (0, _moment2.default)().endOf('day').format('YYYY-MM-DDTHH:mm:ssZ'));
	
	            case 10:
	              response = _context.sent;
	              eventsWithColor = response.data.events.map(assignColorToEvent);
	
	              obx.timelineEvents = Object.assign({}, response.data, { events: eventsWithColor });
	              return _context.abrupt('return', response);
	
	            case 14:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, this);
	    }));
	
	    return function (_x3, _x4) {
	      return _ref.apply(this, arguments);
	    };
	  }()),
	  timelineResources: null,
	  getTimelineResources: (0, _mobx.action)(_asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    var response;
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.next = 2;
	            return _config.schApi.get('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/reports/timeline/resources');
	
	          case 2:
	            response = _context2.sent;
	
	            obx.timelineResources = response.data.results;
	            return _context2.abrupt('return', response);
	
	          case 5:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }))),
	  // Create calendar
	  calendar: null,
	  createCalendar: (0, _mobx.action)(function (locationSid, data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'createCalendar');
	
	    _config.schApi.post('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/locations/' + locationSid + '/calendars', data).then(function (response) {
	      obx.calendar = response.data;
	      _SessionStore2.default.finishLoading('createCalendar');
	
	      if (callback) {
	        callback(response.data);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update calendar
	  updateCalendar: (0, _mobx.action)(function (locationSid, calendarSid, data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'updateCalendar');
	
	    _config.schApi.put('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/locations/' + locationSid + '/calendars/' + calendarSid, data).then(function (response) {
	      obx.calendar = response.data;
	      _SessionStore2.default.finishLoading('updateCalendar');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  deleteCalendar: (0, _mobx.action)(function (locationSid, calendarSid) {
	    _SessionStore2.default.startLoading('Loading...', 'deleteCalendar');
	
	    _config.schApi.delete('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/locations/' + locationSid + '/calendars/' + calendarSid).then(function () {
	      obx.getLocationCalendars(locationSid);
	      _SessionStore2.default.finishLoading('deleteCalendar');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get availability (calendar)
	  availabilities: [],
	  getAvailability: (0, _mobx.action)(function (calendarSid, startDate, endDate, callback, skipStore) {
	
	    _config.schApi.get('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/calendars/' + calendarSid + '/availability?startDate=' + startDate + '&endDate=' + endDate).then(function (response) {
	
	      if (!skipStore) {
	        obx.availabilities = response.data.results;
	      }
	
	      if (callback) {
	        callback(response.data.results);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get availability (schedule)
	  getScheduleAvailability: (0, _mobx.action)(function (scheduleSid, callback) {
	
	    _config.schApi.get('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/schedules/' + scheduleSid + '/availability').then(function (response) {
	      console.log(response);
	
	      // Remove any overrides, since we
	      // just want the default availabilities
	      for (var i = 0; i < response.data.results.length; i++) {
	        if (response.data.results[i].override) {
	          response.data.results.splice(i, 1);
	        }
	      }
	
	      obx.availabilities = response.data.results;
	
	      if (callback) {
	        callback(response.data.results);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update availability
	  updateAvailability: (0, _mobx.action)(function (scheduleSid, data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'updateAvailability');
	
	    data.update.forEach(function (availability) {
	      if (availability.hasOwnProperty('override')) {
	        delete availability.override;
	      }
	    });
	
	    _config.schApi.post('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/schedules/' + scheduleSid + '/availability', data).then(function (response) {
	      _SessionStore2.default.finishLoading('updateAvailability');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get exclusions
	  exclusions: [],
	  getExclusions: (0, _mobx.action)(function (scheduleSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'getAvailability');
	
	    _config.schApi.get('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/exclusions?scheduleSid=' + scheduleSid).then(function (response) {
	      _SessionStore2.default.finishLoading('getAvailability');
	
	      obx.exclusions = response.data.results;
	
	      if (callback) {
	        callback(response.data.results);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  locationSeats: [],
	  listSeats: (0, _mobx.action)(function (accountSid, locationSid, appointmentSid) {
	    var sortKeys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	    var url = 'accounts/' + accountSid + '/locations/' + locationSid + '/seats';
	
	    if (appointmentSid) {
	      url = url + '?availableForAppointmentSid=' + appointmentSid;
	      if (sortKeys) {
	        url = url + '&sortKeys=' + sortKeys;
	      }
	    } else if (!appointmentSid && sortKeys) {
	      url = url + '?sortKeys=' + sortKeys;
	    }
	
	    _config.schApi.get(url).then(function (response) {
	      obx.locationSeats = response.data.results;
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  updateSeat: (0, _mobx.action)(function (payload, seatSid, callback) {
	    _SessionStore2.default.startLoading('Loading...', 'updateSeat');
	
	    _config.schApi.put('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/locations/' + obx.scheduleLocation.sid + '/seats/' + seatSid, payload).then(function () {
	      _SessionStore2.default.finishLoading('listSeats');
	
	      if (callback) callback();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  addSeat: (0, _mobx.action)(function (payload, callback) {
	    _SessionStore2.default.startLoading('Loading...', 'addSeat');
	
	    _config.schApi.post('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/locations/' + obx.scheduleLocation.sid + '/seats', payload).then(function () {
	      setTimeout(function () {
	        obx.listSeats(_SessionStore2.default.userData.proctorAccountSid, obx.scheduleLocation.sid);
	        _SessionStore2.default.finishLoading('addSeat');
	      }, 500);
	
	      if (callback) callback();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  deleteSeat: (0, _mobx.action)(function (seatSid) {
	    _SessionStore2.default.startLoading('Loading...', 'deleteSeat');
	
	    _config.schApi.delete('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/locations/' + obx.scheduleLocation.sid + '/seats/' + seatSid).then(function () {
	      // Wait a little before updating seats so we pull accurate data
	      setTimeout(function () {
	        obx.listSeats(_SessionStore2.default.userData.proctorAccountSid, obx.scheduleLocation.sid);
	        _SessionStore2.default.finishLoading('deleteSeat');
	      }, 500);
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  changeSeat: (0, _mobx.action)(function (seatSid, appointmentSid, callback) {
	    _SessionStore2.default.startLoading('changeSeat');
	    if (!seatSid.includes('SE')) {
	      seatSid = null;
	    }
	
	    _config.schApi.patch('accounts/' + _SessionStore2.default.userData.proctorAccountSid + '/appointments/' + appointmentSid, { seatSid: seatSid }).then(function () {
	      // Wait a little before updating seats so we pull accurate data
	      if (callback) {
	        callback(seatSid);
	      }
	      _SessionStore2.default.finishLoading('changeSeat');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	      _SessionStore2.default.finishLoading('changeSeat');
	    });
	  }),
	
	  changeSessionStatus: (0, _mobx.action)(function (installSid, examSid, sessionSid, status) {
	    _SessionStore2.default.startLoading('changeSessionStatus');
	    _config.api.patch('installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid, { status: status }).then(function () {
	      obx.session.status = status;
	      _SessionStore2.default.finishLoading('changeSessionStatus');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	      _SessionStore2.default.finishLoading('changeSessionStatus');
	    });
	  })
	});
	
	exports.default = obx;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(933);


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(2);
	var factory = __webpack_require__(310);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1177),
	    getValue = __webpack_require__(1201);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabPanel = exports.Tab = exports.TabList = exports.Tabs = undefined;
	
	var _Tabs = __webpack_require__(1265);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabList = __webpack_require__(514);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	var _Tab = __webpack_require__(135);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabPanel = __webpack_require__(1264);
	
	var _TabPanel2 = _interopRequireDefault(_TabPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tabs = _Tabs2.default;
	exports.TabList = _TabList2.default;
	exports.Tab = _Tab2.default;
	exports.TabPanel = _TabPanel2.default;
	
	// For bc we also export a default object, remove in 1.0
	
	exports.default = {
	  Tabs: _Tabs2.default,
	  TabList: _TabList2.default,
	  Tab: _Tab2.default,
	  TabPanel: _TabPanel2.default
	};

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/******************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global global, define, Symbol, Reflect, Promise, SuppressedError */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __esDecorate;
	var __runInitializers;
	var __propKey;
	var __setFunctionName;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __spreadArray;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __classPrivateFieldIn;
	var __createBinding;
	var __addDisposableResource;
	var __disposeResources;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __esDecorate = function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
	        function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
	        var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
	        var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
	        var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
	        var _, done = false;
	        for (var i = decorators.length - 1; i >= 0; i--) {
	            var context = {};
	            for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
	            for (var p in contextIn.access) context.access[p] = contextIn.access[p];
	            context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
	            var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
	            if (kind === "accessor") {
	                if (result === void 0) continue;
	                if (result === null || typeof result !== "object") throw new TypeError("Object expected");
	                if (_ = accept(result.get)) descriptor.get = _;
	                if (_ = accept(result.set)) descriptor.set = _;
	                if (_ = accept(result.init)) initializers.unshift(_);
	            }
	            else if (_ = accept(result)) {
	                if (kind === "field") initializers.unshift(_);
	                else descriptor[key] = _;
	            }
	        }
	        if (target) Object.defineProperty(target, contextIn.name, descriptor);
	        done = true;
	    };
	
	    __runInitializers = function (thisArg, initializers, value) {
	        var useValue = arguments.length > 2;
	        for (var i = 0; i < initializers.length; i++) {
	            value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
	        }
	        return useValue ? value : void 0;
	    };
	
	    __propKey = function (x) {
	        return typeof x === "symbol" ? x : "".concat(x);
	    };
	
	    __setFunctionName = function (f, name, prefix) {
	        if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
	        return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (g && (g = 0, op[0] && (_ = 0)), _) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __exportStar = function(m, o) {
	        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
	    };
	
	    __createBinding = Object.create ? (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        var desc = Object.getOwnPropertyDescriptor(m, k);
	        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	            desc = { enumerable: true, get: function() { return m[k]; } };
	        }
	        Object.defineProperty(o, k2, desc);
	    }) : (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    });
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    /** @deprecated */
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    /** @deprecated */
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __spreadArray = function (to, from, pack) {
	        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	            if (ar || !(i in from)) {
	                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	                ar[i] = from[i];
	            }
	        }
	        return to.concat(ar || Array.prototype.slice.call(from));
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    var __setModuleDefault = Object.create ? (function(o, v) {
	        Object.defineProperty(o, "default", { enumerable: true, value: v });
	    }) : function(o, v) {
	        o["default"] = v;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	        __setModuleDefault(result, mod);
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, state, kind, f) {
	        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
	        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
	        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, state, value, kind, f) {
	        if (kind === "m") throw new TypeError("Private method is not writable");
	        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
	        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
	        return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
	    };
	
	    __classPrivateFieldIn = function (state, receiver) {
	        if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
	        return typeof state === "function" ? receiver === state : state.has(receiver);
	    };
	
	    __addDisposableResource = function (env, value, async) {
	        if (value !== null && value !== void 0) {
	            if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
	            var dispose;
	            if (async) {
	                if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
	                dispose = value[Symbol.asyncDispose];
	            }
	            if (dispose === void 0) {
	                if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
	                dispose = value[Symbol.dispose];
	            }
	            if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
	            env.stack.push({ value: value, dispose: dispose, async: async });
	        }
	        else if (async) {
	            env.stack.push({ async: true });
	        }
	        return value;
	    };
	
	    var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
	        var e = new Error(message);
	        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
	    };
	
	    __disposeResources = function (env) {
	        function fail(e) {
	            env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
	            env.hasError = true;
	        }
	        function next() {
	            while (env.stack.length) {
	                var rec = env.stack.pop();
	                try {
	                    var result = rec.dispose && rec.dispose.call(rec.value);
	                    if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
	                }
	                catch (e) {
	                    fail(e);
	                }
	            }
	            if (env.hasError) throw env.error;
	        }
	        return next();
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__esDecorate", __esDecorate);
	    exporter("__runInitializers", __runInitializers);
	    exporter("__propKey", __propKey);
	    exporter("__setFunctionName", __setFunctionName);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__spreadArray", __spreadArray);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	    exporter("__classPrivateFieldIn", __classPrivateFieldIn);
	    exporter("__addDisposableResource", __addDisposableResource);
	    exporter("__disposeResources", __disposeResources);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 81 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function clamp(value, min, max) {
	  if (isNaN(value)) {
	    return value;
	  }
	  var minUndefined = typeof min === 'undefined';
	  var maxUndefined = typeof max === 'undefined';
	  if (minUndefined && maxUndefined) {
	    return value;
	  }
	  if (minUndefined) {
	    if (!maxUndefined) {
	      return value > max ? max : value;
	    }
	  }
	  if (maxUndefined) {
	    if (!minUndefined) {
	      return value < min ? min : value;
	    }
	  }
	  if (min > max) {
	    return clamp(value, max, min);
	  }
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	var _default = clamp;
	exports.default = _default;

/***/ },
/* 82 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(a, b) {
	  if (a && b) {
	    return function () {
	      a.apply(void 0, arguments);
	      b.apply(void 0, arguments);
	    };
	  }
	  return a || b;
	};
	exports.default = _default;

/***/ },
/* 83 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	var notEmpty = function notEmpty(x) {
	  return !!x;
	};
	function _default() {
	  return [].slice.call(arguments).filter(notEmpty).join(' ');
	}

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "NotifyResize", {
	  enumerable: true,
	  get: function get() {
	    return _reactNotifyResize.NotifyResize;
	  }
	});
	exports.default = void 0;
	var _reactNotifyResize = _interopRequireWildcard(__webpack_require__(752));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var _default = _reactNotifyResize.default;
	exports.default = _default;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.NotifyResize = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = __webpack_require__(11);
	var _shallowequal = _interopRequireDefault(__webpack_require__(753));
	var _debounce = _interopRequireDefault(__webpack_require__(63));
	var _getGlobal = __webpack_require__(18);
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var STYLE_DISPLAY_NONE = {
	  display: 'none'
	};
	var emptyFn = function emptyFn() {};
	var immediateFn = function immediateFn(fn) {
	  return fn();
	};
	var notifyResizeStyle = {
	  contain: 'strict',
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  width: '100%',
	  height: '100%',
	  zIndex: -1,
	  overflow: 'hidden',
	  display: 'block',
	  pointerEvents: 'none',
	  opacity: 0,
	  direction: 'ltr',
	  textAlign: 'start'
	};
	var expandToolStyle = {
	  contain: 'strict',
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  width: '100%',
	  height: '100%',
	  overflow: 'auto'
	};
	var contractToolStyle = {
	  contain: 'strict',
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  width: '100%',
	  height: '100%',
	  overflow: 'auto'
	};
	var contractToolInnerStyle = {
	  contain: 'strict',
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  width: '200%',
	  height: '200%'
	};
	var InovuaNotifyResize = function (_React$Component) {
	  (0, _inherits2.default)(InovuaNotifyResize, _React$Component);
	  var _super = _createSuper(InovuaNotifyResize);
	  function InovuaNotifyResize(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaNotifyResize);
	    _this = _super.call(this, props);
	    _this.checkResize = _this.checkResize.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onResize = _this.onResize.bind((0, _assertThisInitialized2.default)(_this));
	    if (props.notifyResizeDelay > 0) {
	      _this.onResize = (0, _debounce.default)(_this.onResize, props.notifyResizeDelay);
	    }
	    if (props.checkResizeDelay > 0) {
	      _this.checkResize = (0, _debounce.default)(_this.checkResize, props.checkResizeDelay);
	    }
	    _this.refNotifyResize = function (node) {
	      _this.notifyResizeNode = node;
	    };
	    _this.refContractTool = function (node) {
	      _this.contractToolNode = node;
	    };
	    _this.refExpandTool = function (node) {
	      _this.expandToolNode = node;
	    };
	    _this.refExpandToolInner = function (node) {
	      _this.expandToolInnerNode = node;
	    };
	    _this.refContractToolInner = function (node) {
	      _this.contractToolInnerNode = node;
	    };
	    _this.state = {
	      notifyResizeWidth: 0,
	      notifyResizeHeight: 0,
	      expandToolWidth: 0,
	      expandToolHeight: 0,
	      contractToolWidth: 0,
	      contractToolHeight: 0
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaNotifyResize, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (typeof nextProps.shouldComponentUpdate === 'function') {
	        return nextProps.shouldComponentUpdate(nextProps, this.props, nextState, this.state);
	      }
	      return !(0, _shallowequal.default)(nextState, this.state) || !(0, _shallowequal.default)(nextProps, this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.__willUnmount = true;
	      if (this.observer) {
	        if (this.observer.unobserve) {
	          this.observer.unobserve(this.target);
	        }
	        if (this.observer.disconnect) {
	          this.observer.disconnect();
	        }
	        delete this.observer;
	      }
	      delete this.target;
	    }
	  }, {
	    key: "getDOMNode",
	    value: function getDOMNode() {
	      return this.notifyResizeNode;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	      this.__willUnmount = false;
	      var ResizeObserver = globalObject.ResizeObserver || this.props.ResizeObserver;
	      if (this.props.useNativeIfAvailable && ResizeObserver) {
	        var node = this.getDOMNode();
	        var target = node.parentNode;
	        this.target = target;
	        var observer = new ResizeObserver(function (entries) {
	          if (_this2.props.onObserverResize) {
	            _this2.props.onObserverResize(entries);
	          }
	          var first = entries[0];
	          if (first) {
	            _this2.onResize(first.contentRect);
	          }
	        });
	        observer.observe(target);
	        this.observer = observer;
	      }
	      if (typeof this.props.onMount === 'function') {
	        this.props.onMount(this);
	      }
	      if (this.observer) {
	        return;
	      }
	      this.resetResizeTool(function () {
	        if (_this2.props.notifyOnMount) {
	          var _this2$state = _this2.state,
	            width = _this2$state.notifyResizeWidth,
	            height = _this2$state.notifyResizeHeight;
	          _this2.onResize({
	            width: width,
	            height: height
	          });
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var ResizeObserver = globalObject.ResizeObserver || this.props.ResizeObserver;
	      if (this.props.useNativeIfAvailable && ResizeObserver) {
	        return _react.default.createElement("div", {
	          ref: this.refNotifyResize,
	          style: STYLE_DISPLAY_NONE,
	          "data-name": "@inovua/react-observer-placeholder"
	        });
	      }
	      return _react.default.createElement("div", {
	        ref: this.refNotifyResize,
	        style: notifyResizeStyle,
	        onScroll: this.checkResize
	      }, this.renderExpandTool(), this.renderContractTool());
	    }
	  }, {
	    key: "renderExpandTool",
	    value: function renderExpandTool() {
	      return _react.default.createElement("div", {
	        ref: this.refExpandTool,
	        style: expandToolStyle
	      }, _react.default.createElement("div", {
	        ref: this.refExpandToolInner,
	        style: {
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          width: this.state.expandToolWidth,
	          height: this.state.expandToolHeight
	        }
	      }));
	    }
	  }, {
	    key: "renderContractTool",
	    value: function renderContractTool() {
	      return _react.default.createElement("div", {
	        ref: this.refContractTool,
	        style: contractToolStyle
	      }, _react.default.createElement("div", {
	        ref: this.refContractToolInner,
	        style: contractToolInnerStyle
	      }));
	    }
	  }, {
	    key: "resetResizeTool",
	    value: function resetResizeTool(callback) {
	      var _this3 = this;
	      this.setDimensions(function () {
	        _this3.scrollToBottomExpandTool();
	        if (typeof callback == 'function') {
	          callback();
	        }
	      });
	    }
	  }, {
	    key: "setDimensions",
	    value: function setDimensions(callback) {
	      var _this4 = this;
	      this.getDimensions(function (size) {
	        var notifyResizeWidth = size.notifyResizeWidth,
	          notifyResizeHeight = size.notifyResizeHeight;
	        if (_this4.__willUnmount) {
	          return;
	        }
	        _this4.setState({
	          notifyResizeWidth: notifyResizeWidth,
	          notifyResizeHeight: notifyResizeHeight,
	          expandToolWidth: notifyResizeWidth + 1,
	          expandToolHeight: notifyResizeHeight + 1
	        }, callback);
	      });
	    }
	  }, {
	    key: "getDimensions",
	    value: function getDimensions(callback) {
	      var _this5 = this;
	      if (!callback || typeof callback != 'function') {
	        callback = emptyFn;
	      }
	      var notifyResize = this.notifyResizeNode;
	      if (!notifyResize) {
	        return;
	      }
	      var node = notifyResize.parentElement || notifyResize;
	      var size;
	      var fn = this.props.useRaf ? requestAnimationFrame : immediateFn;
	      fn(function () {
	        if (typeof _this5.props.measureSize == 'function') {
	          size = _this5.props.measureSize(node, notifyResize);
	        } else {
	          size = {
	            width: node.offsetWidth,
	            height: node.offsetHeight
	          };
	        }
	        callback({
	          notifyResizeWidth: size.width,
	          notifyResizeHeight: size.height
	        });
	      });
	    }
	  }, {
	    key: "scrollToBottomExpandTool",
	    value: function scrollToBottomExpandTool(callback) {
	      var _this6 = this;
	      if (this.notifyResizeNode) {
	        requestAnimationFrame(function () {
	          var expandTool = _this6.expandToolNode;
	          var contractTool = _this6.contractToolNode;
	          var expandToolScrollHeight;
	          var expandToolScrollWidth;
	          var contractToolScrollHeight;
	          var contractToolScrollWidth;
	          if (expandTool) {
	            expandToolScrollHeight = expandTool.scrollHeight;
	            expandToolScrollWidth = expandTool.scrollWidth;
	          }
	          if (contractTool) {
	            contractToolScrollHeight = contractTool.scrollHeight;
	            contractToolScrollWidth = contractTool.scrollWidth;
	          }
	          if (expandTool) {
	            expandTool.scrollTop = expandToolScrollHeight;
	            expandTool.scrollLeft = expandToolScrollWidth;
	          }
	          if (contractTool) {
	            contractTool.scrollTop = contractToolScrollHeight;
	            contractTool.scrollLeft = contractToolScrollWidth;
	          }
	          if (typeof callback == 'function') {
	            callback();
	          }
	        });
	      }
	    }
	  }, {
	    key: "checkResize",
	    value: function checkResize() {
	      var _this7 = this;
	      this.getDimensions(function (_ref) {
	        var notifyResizeWidth = _ref.notifyResizeWidth,
	          notifyResizeHeight = _ref.notifyResizeHeight;
	        if (notifyResizeWidth !== _this7.state.notifyResizeWidth || notifyResizeHeight !== _this7.state.notifyResizeHeight) {
	          _this7.onResize({
	            width: notifyResizeWidth,
	            height: notifyResizeHeight
	          });
	          _this7.resetResizeTool();
	        }
	      });
	    }
	  }, {
	    key: "onResize",
	    value: function onResize(_ref2) {
	      var width = _ref2.width,
	        height = _ref2.height;
	      if (this.__willUnmount) {
	        return;
	      }
	      if (typeof this.props.onResize === 'function') {
	        this.props.onResize({
	          width: width,
	          height: height
	        });
	      }
	    }
	  }]);
	  return InovuaNotifyResize;
	}(_react.default.Component);
	exports.NotifyResize = InovuaNotifyResize;
	InovuaNotifyResize.defaultProps = {
	  useNativeIfAvailable: true,
	  useWillChange: false,
	  useRaf: true
	};
	InovuaNotifyResize.propTypes = {
	  ResizeObserver: _propTypes.func,
	  onResize: _propTypes.func,
	  onObserverResize: _propTypes.func,
	  useNativeIfAvailable: _propTypes.bool,
	  onMount: _propTypes.func,
	  useWillChange: _propTypes.bool,
	  useRaf: _propTypes.bool,
	  notifyOnMount: _propTypes.bool,
	  notifyResizeDelay: _propTypes.number,
	  checkResizeDelay: _propTypes.number
	};
	var _default = InovuaNotifyResize;
	exports.default = _default;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof3 = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "cleanProps", {
	  enumerable: true,
	  get: function get() {
	    return _reactCleanProps.default;
	  }
	});
	exports.default = void 0;
	Object.defineProperty(exports, "getScrollbarWidth", {
	  enumerable: true,
	  get: function get() {
	    return _getScrollbarWidth.default;
	  }
	});
	Object.defineProperty(exports, "isMobile", {
	  enumerable: true,
	  get: function get() {
	    return _isMobile.default;
	  }
	});
	exports.propTypes = void 0;
	Object.defineProperty(exports, "scrollPage", {
	  enumerable: true,
	  get: function get() {
	    return _scrollPage2.default;
	  }
	});
	Object.defineProperty(exports, "smoothScrollTo", {
	  enumerable: true,
	  get: function get() {
	    return _smoothScrollTo2.default;
	  }
	});
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _debounce = _interopRequireDefault(__webpack_require__(63));
	var _autoBind = _interopRequireDefault(__webpack_require__(52));
	var _reactCleanProps = _interopRequireDefault(__webpack_require__(49));
	var _src = _interopRequireDefault(__webpack_require__(85));
	var _isMobile = _interopRequireDefault(__webpack_require__(64));
	var _smoothScrollTo2 = _interopRequireDefault(__webpack_require__(114));
	var _scrollPage2 = _interopRequireDefault(__webpack_require__(774));
	var _getScrollbarWidth = _interopRequireDefault(__webpack_require__(47));
	var _shouldComponentUpdate2 = _interopRequireDefault(__webpack_require__(56));
	var _Scrollbar = _interopRequireDefault(__webpack_require__(755));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var callFn = function callFn(fn) {
	  return fn();
	};
	var raf = globalObject.requestAnimationFrame;
	var ua = globalObject.navigator ? globalObject.navigator.userAgent || '' : '';
	var IS_EDGE = ua.indexOf('Edge/') !== -1;
	var IS_MS_BROWSER = IS_EDGE || ua.indexOf('Trident') !== -1;
	var IS_IE = IS_MS_BROWSER && !IS_EDGE;
	var HAS_NEGATIVE_SCROLL = false;
	var WRAPPER_STYLE = {
	  overflow: 'hidden',
	  flex: '1 1 auto',
	  position: 'relative',
	  display: 'flex'
	};
	var VERTICAL = 'vertical';
	var HORIZONTAL = 'horizontal';
	var SIZES = {
	  vertical: 'height',
	  horizontal: 'width'
	};
	var OTHER_ORIENTATION = {
	  vertical: 'horizontal',
	  horizontal: 'vertical'
	};
	var InovuaScrollContainer = function (_Component) {
	  (0, _inherits2.default)(InovuaScrollContainer, _Component);
	  var _super = _createSuper(InovuaScrollContainer);
	  function InovuaScrollContainer(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaScrollContainer);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollerScrollSize", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollerClientSize", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refScroller", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollerNode", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "computeScrollWithThreshold", function (scrollTop, scrollThreshold, scrollMaxDelta) {
	      var scrollPercent = function scrollPercent(threshold) {
	        threshold = threshold < 0.4 ? 0.4 : threshold;
	        threshold = threshold > 1 ? 1 : threshold;
	        var scrollMax = scrollMaxDelta ? _this.scrollTopMax - scrollMaxDelta : _this.scrollTopMax;
	        var percent = scrollTop / scrollMax;
	        if (percent >= threshold) {
	          return true;
	        }
	        return false;
	      };
	      if (typeof scrollThreshold === 'number') {
	        return scrollPercent(scrollThreshold);
	      }
	      if (typeof scrollThreshold === 'string') {
	        if (scrollThreshold.match(/^(\d*(\.\d+)?)%$/)) {
	          var threshold = parseFloat(scrollThreshold) / 100;
	          return scrollPercent(threshold);
	        }
	        if (scrollThreshold.match(/^(\d*(\.\d+)?)px$/)) {
	          var scrollMax = scrollMaxDelta ? _this.scrollTopMax - scrollMaxDelta : _this.scrollTopMax;
	          var _threshold = parseFloat(scrollThreshold);
	          if (scrollTop >= scrollMax - _threshold) {
	            return true;
	          }
	        }
	      }
	      return false;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "applyCSSContainOnScrollUpdate", function (bool) {
	      var scrollerNode = _this.getScrollerNode();
	      if (scrollerNode) {
	        scrollerNode.style.contain = bool ? 'strict' : '';
	      }
	    });
	    (0, _autoBind.default)((0, _assertThisInitialized2.default)(_this), {
	      scrollTop: 1,
	      scrollLeft: 1,
	      scrollTopMax: 1,
	      scrollLeftMax: 1
	    });
	    _this.state = {
	      scrollbars: {
	        horizontal: false,
	        vertical: false
	      }
	    };
	    _this.scrollerResizerRef = function (s) {
	      _this._scrollerResizer = s;
	    };
	    if (props.scrollDebounceDelay > 0) {
	      _this.onScrollDebounce = (0, _debounce.default)(_this.onScrollDebounce, props.scrollDebounceDelay, {
	        leading: false
	      });
	    }
	    _this.onStop = (0, _debounce.default)(_this.onStop, props.scrollStopDelay, {
	      leading: false
	    });
	    _this.nativeScrollbarWidth = (0, _getScrollbarWidth.default)(_this.props.hideNativeScrollbarIfPossible);
	    _this.scroll = {
	      scrollTop: 0,
	      scrollLeft: 0
	    };
	    _this.trackSize = {};
	    _this.clientSize = {};
	    _this.scrollSize = {};
	    _this.scrollbars = {};
	    _this.scrollerClientSize = {};
	    _this.scrollerScrollSize = {};
	    _this.scrollbarRef = {
	      vertical: function vertical(c) {
	        _this.scrollbars.vertical = c;
	      },
	      horizontal: function horizontal(c) {
	        var wasDefined = !!_this.scrollbars.horizontal;
	        _this.scrollbars.horizontal = c;
	        if (!wasDefined && c && _this.props.rtl) {
	          c.setScrollPos(_this.scrollLeftMax);
	        }
	      }
	    };
	    _this.refThis = function (c) {
	      _this.domNode = c;
	    };
	    _this.refWrapper = function (c) {
	      if (c) {
	        _this.setupWrapperPassiveScrollListener(c);
	      } else {
	        _this.removeWrapperPassiveScrollListener(_this.wrapperNode);
	      }
	      _this.wrapperNode = c;
	    };
	    _this.refView = function (v) {
	      _this.viewNode = v;
	    };
	    _this.refScroller = (0, _react.createRef)();
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaScrollContainer, [{
	    key: "onWrapperScroll",
	    value: function onWrapperScroll(event) {
	      var _this2 = this;
	      var eventTarget = event.target;
	      if (eventTarget != this.wrapperNode) {
	        return;
	      }
	      var scrollLeft = eventTarget.scrollLeft,
	        scrollTop = eventTarget.scrollTop;
	      if (scrollLeft) {
	        eventTarget.scrollLeft = 0;
	        raf(function () {
	          _this2.scrollLeft += scrollLeft;
	        });
	      }
	      if (scrollTop) {
	        eventTarget.scrollTop = 0;
	        raf(function () {
	          _this2.scrollTop += scrollTop;
	        });
	      }
	    }
	  }, {
	    key: "setupWrapperPassiveScrollListener",
	    value: function setupWrapperPassiveScrollListener(node) {
	      node.addEventListener('scroll', this.onWrapperScroll, {
	        passive: true
	      });
	    }
	  }, {
	    key: "removeWrapperPassiveScrollListener",
	    value: function removeWrapperPassiveScrollListener() {
	      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.wrapperNode;
	      if (node) {
	        node.removeEventListener('scroll', this.onWrapperScroll, {
	          passive: true
	        });
	      }
	    }
	  }, {
	    key: "setupPassiveScrollListener",
	    value: function setupPassiveScrollListener(node) {
	      node.addEventListener('scroll', this.onScroll, {
	        passive: true
	      });
	    }
	  }, {
	    key: "removePassiveScrollListener",
	    value: function removePassiveScrollListener() {
	      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getScrollerNode();
	      if (node) {
	        node.removeEventListener('scroll', this.onScroll, {
	          passive: true
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unmounted = true;
	      if (this.props.usePassiveScroll) {
	        this.removePassiveScrollListener();
	      }
	      if (typeof this.props.onWillUnmount === 'function') {
	        this.props.onWillUnmount(this);
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.unmounted = false;
	      this.scrollerNode = this.refScroller.current;
	      var scrollerNode = this.getScrollerNode();
	      if (this.props.usePassiveScroll) {
	        if (scrollerNode) {
	          this.setupPassiveScrollListener(scrollerNode);
	        } else {
	          this.removePassiveScrollListener(scrollerNode);
	        }
	      }
	      if (typeof this.props.onDidMount === 'function') {
	        this.props.onDidMount(this, this.getDOMNode(), this._scrollerResizer);
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _shouldComponentUpdate2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: "ensureNonStaticStyle",
	    value: function ensureNonStaticStyle(style, domNode) {
	      if (!this.props.forceNonStaticPosition) {
	        return style;
	      }
	      style = style || {};
	      var _style = style,
	        position = _style.position;
	      var nonStatic = position == 'relative' || position == 'absolute';
	      if (nonStatic) {
	        return style;
	      }
	      if (domNode) {
	        position = globalObject.getComputedStyle(domNode).position;
	        nonStatic = position == 'relative' || position == 'absolute';
	        if (!nonStatic) {
	          return _objectSpread(_objectSpread({}, style), {}, {
	            position: 'relative'
	          });
	        }
	      }
	      return _objectSpread(_objectSpread({}, style), {}, {
	        position: 'relative'
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var renderScroller = props.renderScroller,
	        renderView = props.renderView,
	        Factory = props.factory,
	        inlineBlock = props.inlineBlock,
	        usePassiveScroll = props.usePassiveScroll,
	        theme = props.theme,
	        contain = props.contain,
	        nativeScroll = props.nativeScroll;
	      var style = props.style,
	        children = props.children;
	      var className = props.className || '';
	      style = _objectSpread({
	        overflow: 'hidden',
	        display: props.display ? props.display : inlineBlock ? 'inline-flex' : 'flex',
	        flexFlow: 'column'
	      }, this.ensureNonStaticStyle(style, this.domNode));
	      if (contain) {
	        if (contain === true) {
	          style.contain = 'style layout paint';
	        } else {
	          style.contain = contain;
	        }
	      }
	      var factoryProps = (0, _reactCleanProps.default)(props, InovuaScrollContainer.propTypes);
	      className += inlineBlock ? ' inovua-react-scroll-container--inline-block' : ' inovua-react-scroll-container--block';
	      className += ' inovua-react-scroll-container';
	      if (theme) {
	        className += " inovua-react-scroll-container--theme-".concat(theme);
	      }
	      var nativeScrollbarWidth = this.nativeScrollbarWidth;
	      var emptyScrollOffset = this.getEmptyScrollOffset();
	      var scrollerStyle = {};
	      if (this.props.inertialScroll) {
	        scrollerStyle.WebkitOverflowScrolling = 'touch';
	      }
	      if (this.props.scrollerStyle) {
	        scrollerStyle = _objectSpread(_objectSpread({}, scrollerStyle), this.props.scrollerStyle);
	      }
	      scrollerStyle.overflow = nativeScroll ? 'auto' : 'scroll';
	      scrollerStyle.direction = this.props.rtl ? 'rtl' : 'ltr';
	      if (!nativeScroll) {
	        scrollerStyle[this.props.rtl ? 'marginLeft' : 'marginRight'] = -emptyScrollOffset - nativeScrollbarWidth;
	        scrollerStyle.marginBottom = -emptyScrollOffset - nativeScrollbarWidth;
	      }
	      var viewClassName = "".concat(this.props.viewClassName || '', " inovua-react-scroll-container__view ").concat(!nativeScrollbarWidth ? 'inovua-react-scroll-container__view--zero-width-scrollbar' : '');
	      var viewChildren = children;
	      var viewStyle = {};
	      if (this.props.viewStyle) {
	        viewStyle = _objectSpread(_objectSpread({}, viewStyle), this.props.viewStyle);
	      }
	      if (!emptyScrollOffset || nativeScroll) {
	        viewChildren = children;
	      } else {
	        viewStyle[this.props.rtl ? 'paddingLeft' : 'paddingRight'] = emptyScrollOffset;
	        var viewChildrenStyle = {
	          paddingBottom: emptyScrollOffset
	        };
	        if (IS_IE) {
	          viewChildrenStyle.display = 'inline-block';
	        }
	        viewChildren = _react.default.createElement("div", {
	          key: "viewChildren",
	          style: viewChildrenStyle
	        }, children);
	      }
	      var resizer = !!this.props.resizer;
	      var viewProps = {
	        ref: this.refView,
	        className: viewClassName,
	        style: viewStyle,
	        children: [viewChildren, resizer && _react.default.createElement(_src.default, {
	          ResizeObserver: this.props.ResizeObserver,
	          checkResizeDelay: this.props.checkResizeDelay,
	          key: "viewResizer",
	          useRaf: this.props.rafOnResize,
	          onResize: this.onViewResize,
	          notifyOnMount: true
	        })]
	      };
	      var view = renderView ? renderView(viewProps) : _react.default.createElement("div", _objectSpread({
	        key: "view"
	      }, viewProps));
	      var scrollerProps = {
	        className: "inovua-react-scroll-container__scroller inovua-react-scroll-container__scroller--direction-".concat(this.props.rtl ? 'rtl' : 'ltr'),
	        style: scrollerStyle,
	        ref: this.refScroller,
	        children: [view, resizer ? _react.default.createElement(_src.default, _objectSpread(_objectSpread({
	          ref: this.scrollerResizerRef
	        }, props.scrollerResizerProps), {}, {
	          ResizeObserver: this.props.ResizeObserver,
	          checkResizeDelay: this.props.checkResizeDelay,
	          useRaf: this.props.rafOnResize,
	          key: "scrollerResizer",
	          onResize: this.onResize,
	          notifyOnMount: true
	        })) : null].filter(Boolean)
	      };
	      if (!usePassiveScroll) {
	        scrollerProps.onScroll = this.onScroll;
	      }
	      if (this.props.avoidRepaintOnScroll) {
	        scrollerProps.className += ' inovua-react-scroll-container__scroller--avoid-repaint';
	      }
	      if (this.props.hideNativeScrollbarIfPossible) {
	        scrollerProps.className += ' inovua-react-scroll-container__scroller--hide-native-scrollbar-if-possible';
	      }
	      if (this.props.dragToScroll) {
	        scrollerProps.tabIndex = -1;
	      }
	      var scroller = renderScroller ? renderScroller(scrollerProps) : _react.default.createElement("div", _objectSpread({}, scrollerProps));
	      children = [_react.default.createElement("div", {
	        key: "wrapper",
	        className: "inovua-react-scroll-container__wrapper",
	        ref: this.refWrapper,
	        style: this.props.wrapperStyle ? _objectSpread(_objectSpread({}, WRAPPER_STYLE), this.props.wrapperStyle) : WRAPPER_STYLE,
	        children: scroller
	      })].concat((0, _toConsumableArray2.default)(this.renderScrollbars()), [this.props.before ? _react.default.cloneElement(this.props.before, {
	        key: 'before'
	      }) : null, this.props.after ? _react.default.cloneElement(this.props.after, {
	        key: 'after',
	        style: _objectSpread(_objectSpread({}, this.props.after.props.style), {}, {
	          bottom: this.state.scrollbars.horizontal && this.props.nativeScroll ? this.nativeScrollbarWidth : 0
	        })
	      }) : null]);
	      if (this.props.showScrollbarsOnOver) {
	        factoryProps.onMouseEnter = this.onMouseEnter;
	        factoryProps.onMouseLeave = this.onMouseLeave;
	      }
	      return Factory ? _react.default.createElement(Factory, _objectSpread(_objectSpread({}, factoryProps), {}, {
	        ref: this.refThis,
	        style: style,
	        className: className,
	        children: children
	      })) : (0, _react.createElement)(props.tagName, _objectSpread(_objectSpread({}, factoryProps), {}, {
	        ref: this.refThis,
	        style: style,
	        className: className,
	        children: children
	      }));
	    }
	  }, {
	    key: "onMouseEnter",
	    value: function onMouseEnter(event) {
	      this.mouseEntered = true;
	      this.setScrollbarsVisible({
	        horizontal: true,
	        vertical: true
	      });
	      if (this.props.onMouseEnter) {
	        this.props.onMouseEnter(event);
	      }
	    }
	  }, {
	    key: "onMouseLeave",
	    value: function onMouseLeave() {
	      this.mouseEntered = false;
	      this.setScrollbarsVisible({
	        horizontal: false,
	        vertical: false
	      });
	      if (this.props.onMouseLeave) {
	        this.props.onMouseLeave(event);
	      }
	    }
	  }, {
	    key: "onViewResize",
	    value: function onViewResize(size) {
	      var _this3 = this;
	      this.rafSync(function () {
	        if (_this3.props.onViewResize) {
	          _this3.props.onViewResize(size, _this3);
	        }
	      });
	    }
	  }, {
	    key: "onResize",
	    value: function onResize(size) {
	      var _this4 = this;
	      if (this.props.rafOnResize) {
	        this.rafSync(function () {
	          if (_this4.props.onResize) {
	            _this4.props.onResize(size, _this4);
	          }
	        });
	      } else {
	        this.sync();
	        if (this.props.onResize) {
	          this.props.onResize(size, this);
	        }
	      }
	    }
	  }, {
	    key: "getDOMNode",
	    value: function getDOMNode() {
	      return this.domNode;
	    }
	  }, {
	    key: "scrollTop",
	    get: function get() {
	      return this.scroll.scrollTop;
	    },
	    set: function set(value) {
	      this.getScrollerNode().scrollTop = value;
	    }
	  }, {
	    key: "scrollLeft",
	    get: function get() {
	      return this.scroll.scrollLeft;
	    },
	    set: function set(value) {
	      this.getScrollerNode().scrollLeft = value;
	    }
	  }, {
	    key: "getScrollPosition",
	    value: function getScrollPosition() {
	      return this.scroll;
	    }
	  }, {
	    key: "scrollTopMax",
	    get: function get() {
	      if (!this.scrollerScrollSize.height || !this.scrollerClientSize.height) {
	        this.getScrollbars();
	      }
	      return this.scrollerScrollSize.height - this.scrollerClientSize.height;
	    }
	  }, {
	    key: "scrollLeftMax",
	    get: function get() {
	      if (!this.scrollerScrollSize.width || !this.scrollerClientSize.width) {
	        this.getScrollbars();
	      }
	      return this.scrollerScrollSize.width - this.scrollerClientSize.width;
	    }
	  }, {
	    key: "renderScrollbars",
	    value: function renderScrollbars() {
	      var scrollbars = this.state.scrollbars;
	      return [scrollbars.vertical && this.renderScrollbar('vertical', scrollbars), scrollbars.horizontal && this.renderScrollbar('horizontal', scrollbars)];
	    }
	  }, {
	    key: "getEmptyScrollOffset",
	    value: function getEmptyScrollOffset() {
	      return this.props.emptyScrollOffset == null ? _isMobile.default ? 17 : IS_IE ? 0 : (0, _getScrollbarWidth.default)() : this.props.emptyScrollOffset;
	    }
	  }, {
	    key: "renderScrollbar",
	    value: function renderScrollbar(orientation, scrollbars) {
	      if (this.checkAllowedScrollbars()[orientation] === false) {
	        return null;
	      }
	      var sizeName = SIZES[orientation];
	      var nativeScrollbarWidth = this.nativeScrollbarWidth;
	      var oppositeVisible = scrollbars[OTHER_ORIENTATION[orientation]];
	      var _this$props = this.props,
	        scrollThumbWidth = _this$props.scrollThumbWidth,
	        scrollThumbStartEndRespectMargin = _this$props.scrollThumbStartEndRespectMargin,
	        scrollThumbMargin = _this$props.scrollThumbMargin;
	      var trackSize = this.trackSize[sizeName];
	      trackSize -= scrollThumbMargin * (scrollThumbStartEndRespectMargin ? 2 : 1);
	      if (oppositeVisible) {
	        trackSize -= scrollThumbWidth;
	      }
	      var emptyScrollOffset = this.getEmptyScrollOffset();
	      var scrollbarProps = {
	        key: orientation,
	        ref: this.scrollbarRef[orientation],
	        emptyScrollOffset: emptyScrollOffset,
	        nativeScrollbarWidth: nativeScrollbarWidth,
	        orientation: orientation,
	        visible: !this.props.autoHide,
	        autoHide: this.props.autoHide,
	        rtl: this.props.rtl,
	        oppositeVisible: oppositeVisible,
	        scrollThumbStyle: this.props.scrollThumbStyle,
	        trackSize: trackSize,
	        scrollSize: this.scrollerScrollSize[sizeName],
	        clientSize: this.clientSize[sizeName] + emptyScrollOffset,
	        dragToScroll: this.props.dragToScroll,
	        scrollThumbMinSize: this.props.scrollThumbMinSize,
	        scrollThumbRadius: this.props.scrollThumbRadius,
	        scrollThumbStartEndRespectMargin: scrollThumbStartEndRespectMargin,
	        scrollThumbOverWidth: this.props.scrollThumbOverWidth,
	        scrollThumbWidth: scrollThumbWidth,
	        scrollThumbMargin: scrollThumbMargin,
	        scrollTrackOverTransitionDuration: this.props.scrollTrackOverTransitionDuration,
	        showTrackOnDrag: this.props.showTrackOnDrag,
	        alwaysShowTrack: this.props.alwaysShowTrack,
	        hideTransitionDuration: this.props.hideTransitionDuration,
	        showTransitionDuration: this.props.showTransitionDuration,
	        onScrollThumbScrollTop: this.onScrollThumbScrollTop,
	        onScrollThumbScrollLeft: this.onScrollThumbScrollLeft,
	        onStartDrag: this.props.dragToScroll && this.onScrollbarStartDrag,
	        onStopDrag: this.props.dragToScroll && this.onScrollbarStopDrag,
	        onWheelScroll: this.onScrollbarWheelScroll,
	        onPageScroll: this.onScrollbarPageScroll
	      };
	      return _react.default.createElement(_Scrollbar.default, _objectSpread({}, scrollbarProps));
	    }
	  }, {
	    key: "onScrollbarStartDrag",
	    value: function onScrollbarStartDrag(orientation) {
	      if (this.props.onScrollbarStartDrag) {
	        this.props.onScrollbarStartDrag(orientation);
	      }
	      if (orientation == VERTICAL && this.props.onVerticalScrollbarStartDrag) {
	        this.props.onVerticalScrollbarStartDrag();
	      } else if (this.props.onHorizontalScrollbarStartDrag) {
	        this.props.onHorizontalScrollbarStartDrag();
	      }
	    }
	  }, {
	    key: "onScrollbarStopDrag",
	    value: function onScrollbarStopDrag(orientation) {
	      this.focus();
	      if (this.props.onScrollbarStopDrag) {
	        this.props.onScrollbarStopDrag(orientation);
	      }
	      if (orientation == VERTICAL && this.props.onVerticalScrollbarStopDrag) {
	        this.props.onVerticalScrollbarStopDrag();
	      } else if (this.props.onHorizontalScrollbarStopDrag) {
	        this.props.onHorizontalScrollbarStopDrag();
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.getScrollerNode().focus();
	    }
	  }, {
	    key: "onScrollbarWheelScroll",
	    value: function onScrollbarWheelScroll(orientation, delta) {
	      var node = this.getScrollerNode();
	      var horiz = orientation == 'horizontal';
	      var scrollPosName = horiz ? 'scrollLeft' : 'scrollTop';
	      var currentValue = node[scrollPosName];
	      var newValue = currentValue + delta;
	      this.smoothScrollTo(newValue, {
	        orientation: orientation,
	        duration: 10
	      });
	    }
	  }, {
	    key: "onScrollbarPageScroll",
	    value: function onScrollbarPageScroll(orientation, direction) {
	      this.focus();
	      this.scrollPage(orientation, direction);
	    }
	  }, {
	    key: "scrollPage",
	    value: function scrollPage(orientation, direction) {
	      if (!direction) {
	        throw new Error('Please provide a scroll direction: 1 or -1!');
	      }
	      var node = this.getScrollerNode();
	      var horiz = orientation == 'horizontal';
	      (0, _scrollPage2.default)(node, {
	        orientation: orientation,
	        direction: direction,
	        pageSize: this.clientSize[horiz ? 'width' : 'height'] - 20
	      });
	    }
	  }, {
	    key: "scrollHorizontalPage",
	    value: function scrollHorizontalPage(direction) {
	      this.scrollPage('horizontal', direction);
	    }
	  }, {
	    key: "scrollVerticalPage",
	    value: function scrollVerticalPage(direction) {
	      this.scrollPage('vertical', direction);
	    }
	  }, {
	    key: "smoothScrollTo",
	    value: function smoothScrollTo(newValue, cfg, callback) {
	      return (0, _smoothScrollTo2.default)(this.getScrollerNode(), newValue, cfg, callback);
	    }
	  }, {
	    key: "onScrollThumbScrollTop",
	    value: function onScrollThumbScrollTop(pos) {
	      this.getScrollerNode().scrollTop = pos;
	    }
	  }, {
	    key: "onScrollThumbScrollLeft",
	    value: function onScrollThumbScrollLeft(pos) {
	      this.getScrollerNode().scrollLeft = pos;
	    }
	  }, {
	    key: "getScrollerNode",
	    value: function getScrollerNode() {
	      this.scrollerNode = this.scrollerNode || this.refScroller.current || this.getDOMNode().firstChild.firstChild;
	      return this.scrollerNode;
	    }
	  }, {
	    key: "getScrollerChild",
	    value: function getScrollerChild() {
	      this.scrollerChild = this.scrollerChild || this.getScrollerNode().firstChild;
	      return this.scrollerChild;
	    }
	  }, {
	    key: "getTrackSize",
	    value: function getTrackSize() {
	      var node = this.getDOMNode();
	      if (this.props.getTrackSize) {
	        return this.props.getTrackSize(node);
	      }
	      return {
	        width: node.clientWidth,
	        height: node.clientHeight
	      };
	    }
	  }, {
	    key: "getScrollSize",
	    value: function getScrollSize() {
	      if (this.props.getScrollSize) {
	        return this.props.getScrollSize(this.getScrollerNode());
	      }
	      var node = this.getScrollerChild();
	      return {
	        width: node.scrollWidth,
	        height: node.scrollHeight
	      };
	    }
	  }, {
	    key: "getClientSize",
	    value: function getClientSize() {
	      var n = this.getDOMNode();
	      if (this.props.getClientSize) {
	        return this.props.getClientSize(n);
	      }
	      var node = n.firstChild;
	      return {
	        width: node.clientWidth,
	        height: node.clientHeight
	      };
	    }
	  }, {
	    key: "getScrollbars",
	    value: function getScrollbars() {
	      this.trackSize = this.getTrackSize();
	      var scrollSize = this.scrollSize = this.getScrollSize();
	      this.clientSize = this.getClientSize();
	      var scrollerNode = this.getScrollerNode();
	      this.scrollerClientSize = this.props.getScrollerNodeClientSize ? this.props.getScrollerNodeClientSize(scrollerNode) : {
	        height: scrollerNode.clientHeight,
	        width: scrollerNode.clientWidth
	      };
	      var scrollerNodeClientSize = this.scrollerClientSize;
	      this.scrollerScrollSize = {
	        height: scrollerNode.scrollHeight,
	        width: scrollerNode.scrollWidth
	      };
	      if (this.props.rtl) {}
	      var scrollbars = {
	        vertical: scrollSize.height > scrollerNodeClientSize.height,
	        horizontal: scrollSize.width > scrollerNodeClientSize.width
	      };
	      return scrollbars;
	    }
	  }, {
	    key: "rafSync",
	    value: function rafSync(callback) {
	      var _this5 = this;
	      raf(function () {
	        _this5.sync();
	        if (callback) {
	          callback();
	        }
	      });
	    }
	  }, {
	    key: "sync",
	    value: function sync() {
	      var _this6 = this;
	      if (this.unmounted) {
	        return;
	      }
	      var oldScrollbars = this.state.scrollbars;
	      var scrollbars = this.getScrollbars();
	      this.setState({
	        scrollbars: scrollbars
	      }, function () {
	        if (_this6.props.onScrollbarsChange && (scrollbars.vertical != oldScrollbars.vertical || scrollbars.horizontal != oldScrollbars.horizontal)) {
	          _this6.props.onScrollbarsChange(scrollbars);
	        }
	      });
	      if (this.props.rtl) {
	        var scrollNode = this.getScrollerNode();
	        if (!scrollNode) {
	          return;
	        }
	        this.onScrollDebounce(scrollNode);
	      }
	    }
	  }, {
	    key: "hasScrollbar",
	    value: function hasScrollbar(orientation) {
	      return this.state.scrollbars[orientation];
	    }
	  }, {
	    key: "hasVerticalScrollbar",
	    value: function hasVerticalScrollbar() {
	      return this.hasScrollbar(VERTICAL);
	    }
	  }, {
	    key: "hasHorizontalScrollbar",
	    value: function hasHorizontalScrollbar() {
	      return this.hasScrollbar(HORIZONTAL);
	    }
	  }, {
	    key: "onScroll",
	    value: function onScroll(event) {
	      var eventTarget = event.target;
	      if (this.props.onScroll) {
	        this.props.onScroll(event);
	      }
	      var scrollerNode = this.getScrollerNode();
	      if (eventTarget != scrollerNode) {
	        return;
	      }
	      this.onScrollDebounce(eventTarget);
	    }
	  }, {
	    key: "onScrollDebounce",
	    value: function onScrollDebounce(eventTarget) {
	      var _this7 = this;
	      var props = this.props;
	      var rafOnScroll = props.rafOnScroll,
	        cancelPrevScrollRaf = props.cancelPrevScrollRaf,
	        avoidScrollTopBrowserLayout = props.avoidScrollTopBrowserLayout,
	        scrollMaxDelta = props.scrollMaxDelta,
	        scrollThreshold = props.scrollThreshold;
	      var rafFn = rafOnScroll ? raf : callFn;
	      if (this.scrollRafId && rafOnScroll && cancelPrevScrollRaf) {
	        globalObject.cancelAnimationFrame(this.scrollRafId);
	      }
	      this.scrollRafId = rafFn(function () {
	        if (_this7.unmounted) {
	          return;
	        }
	        delete _this7.scrollRafId;
	        var onScrollStart = props.onScrollStart,
	          onScrollStop = props.onScrollStop,
	          autoHide = props.autoHide,
	          applyCSSContainOnScroll = props.applyCSSContainOnScroll;
	        var startStop = !!(onScrollStart || onScrollStop || autoHide || avoidScrollTopBrowserLayout || applyCSSContainOnScroll);
	        var scrollTop;
	        var scrollLeft;
	        if (!avoidScrollTopBrowserLayout) {
	          scrollTop = eventTarget.scrollTop;
	          scrollLeft = eventTarget.scrollLeft;
	        } else {
	          var targetRect = _this7.targetRect || eventTarget.getBoundingClientRect();
	          _this7.targetRect = targetRect;
	          var viewRect = eventTarget.firstChild.getBoundingClientRect();
	          scrollTop = targetRect.top - viewRect.top;
	          scrollLeft = targetRect.left - viewRect.left;
	        }
	        var scrollLeftMax = _this7.scrollerScrollSize.width - _this7.scrollerClientSize.width;
	        var scrollPos = {
	          scrollTop: scrollTop,
	          scrollLeft: scrollLeft,
	          scrollLeftMax: scrollLeftMax
	        };
	        var prevScrollPos = _this7.scroll;
	        var prevScrollTop = prevScrollPos.scrollTop,
	          prevScrollLeft = prevScrollPos.scrollLeft,
	          prevScrollLeftMax = prevScrollPos.scrollLeftMax;
	        if (startStop) {
	          if (!_this7.scrollStarted) {
	            if (applyCSSContainOnScroll) {
	              _this7.applyCSSContainOnScrollUpdate(true);
	            }
	            if (onScrollStart) {
	              onScrollStart(scrollPos, prevScrollPos, eventTarget);
	            }
	          }
	        }
	        var scrollVertical = false;
	        var scrollHorizontal = false;
	        if (props.onContainerScroll) {
	          props.onContainerScroll(scrollPos, prevScrollPos, eventTarget, {
	            scrollerScrollSize: _this7.scrollerScrollSize,
	            scrollerClientSize: _this7.scrollerClientSize,
	            scrollLeftMax: scrollLeftMax
	          });
	        }
	        var scrollTopChange = scrollTop != prevScrollTop;
	        if (scrollTopChange) {
	          scrollVertical = true;
	          if (_this7.scrollbars.vertical) {
	            _this7.scrollbars.vertical.setScrollPos(scrollTop);
	          }
	          if (props.onContainerScrollVertical) {
	            props.onContainerScrollVertical(scrollTop, prevScrollTop, eventTarget);
	          }
	          if (props.onContainerScrollVerticalMin && scrollTop == 0) {
	            props.onContainerScrollVerticalMin(0, eventTarget);
	          }
	          if (props.onContainerScrollVerticalMax) {
	            if (scrollThreshold) {
	              var reachScrollMax = _this7.computeScrollWithThreshold(scrollTop, scrollThreshold, scrollMaxDelta);
	              if (reachScrollMax) {
	                props.onContainerScrollVerticalMax(scrollTop);
	              }
	            } else if (scrollMaxDelta ? scrollTop >= _this7.scrollTopMax - scrollMaxDelta : scrollTop == _this7.scrollTopMax) {
	              props.onContainerScrollVerticalMax(scrollTop);
	            }
	          }
	        }
	        var scrollLeftChange = scrollLeft != prevScrollLeft;
	        if (_this7.props.rtl && !scrollLeftChange) {
	          scrollLeftChange = scrollLeftMax != prevScrollLeftMax;
	        }
	        if (scrollLeftChange) {
	          scrollHorizontal = true;
	          if (_this7.scrollbars.horizontal) {
	            _this7.scrollbars.horizontal.setScrollPos(scrollLeft);
	          }
	          if (props.onContainerScrollHorizontal) {
	            props.onContainerScrollHorizontal(scrollLeft, prevScrollLeft, eventTarget, scrollLeftMax);
	          }
	          if (props.onContainerScrollHorizontalMin && scrollLeft == 0) {
	            props.onContainerScrollHorizontalMin(0, eventTarget);
	          }
	          if (props.onContainerScrollHorizontalMax && (scrollMaxDelta ? Math.abs(scrollLeft) >= scrollLeftMax - scrollMaxDelta : Math.abs(scrollLeft) == scrollLeftMax)) {
	            props.onContainerScrollHorizontalMax(scrollLeft, eventTarget);
	          }
	        }
	        if (startStop && (scrollTopChange || scrollLeftChange)) {
	          if (!_this7.scrollStarted || _this7.scrollStarted.vertical != scrollVertical || _this7.scrollStarted.horizontal != scrollHorizontal) {
	            _this7.lazyShowScrollbars();
	            _this7.scrollStarted = {
	              horizontal: scrollHorizontal,
	              vertical: scrollVertical
	            };
	          }
	          _this7.onStop(scrollPos, prevScrollPos, eventTarget);
	        }
	        _this7.scroll = scrollPos;
	      });
	    }
	  }, {
	    key: "getContainerTargetNode",
	    value: function getContainerTargetNode() {
	      var view = this.viewNode;
	      return !this.props.emptyScrollOffset ? view : view.firstChild;
	    }
	  }, {
	    key: "lazyShowScrollbars",
	    value: function lazyShowScrollbars() {
	      if (this.props.autoHide) {
	        setTimeout(this.showScrollbars, this.props.showDelay);
	      }
	    }
	  }, {
	    key: "onStop",
	    value: function onStop(scrollPos, prevScrollPos, eventTarget) {
	      this.scrollStarted = false;
	      if (this.props.applyCSSContainOnScroll) {
	        this.applyCSSContainOnScrollUpdate(false);
	      }
	      delete this.targetRect;
	      if (this.props.onScrollStop) {
	        this.props.onScrollStop(scrollPos, prevScrollPos, eventTarget);
	      }
	      setTimeout(this.hideScrollbars, this.props.hideDelay);
	    }
	  }, {
	    key: "showScrollbars",
	    value: function showScrollbars() {
	      if (this.props.autoHide && this.scrollStarted) {
	        var _this$scrollbars = this.scrollbars,
	          horizontal = _this$scrollbars.horizontal,
	          vertical = _this$scrollbars.vertical;
	        var _this$scrollStarted = this.scrollStarted,
	          scrollHorizontal = _this$scrollStarted.horizontal,
	          scrollVertical = _this$scrollStarted.vertical;
	        var visibleScrollbars = {};
	        if (scrollHorizontal) {
	          visibleScrollbars.horizontal = true;
	        }
	        if (scrollVertical) {
	          visibleScrollbars.vertical = true;
	        }
	        this.setScrollbarsVisible(visibleScrollbars);
	      }
	    }
	  }, {
	    key: "checkAllowedScrollbars",
	    value: function checkAllowedScrollbars() {
	      var result = {
	        vertical: true,
	        horizontal: true
	      };
	      var scrollbars = this.props.scrollbars;
	      if (scrollbars === false) {
	        result.vertical = false;
	        result.horizontal = false;
	      }
	      if ((0, _typeof2.default)(scrollbars) == 'object') {
	        if (scrollbars.horizontal === false) {
	          result.horizontal = false;
	        }
	        if (scrollbars.false === false) {
	          result.false = false;
	        }
	      }
	      var _this$props2 = this.props,
	        shouldAllowScrollbars = _this$props2.shouldAllowScrollbars,
	        showScrollbars = _this$props2.showScrollbars;
	      if (typeof shouldAllowScrollbars == 'function') {
	        var shouldAllow = showScrollbars || shouldAllowScrollbars(this.props, (0, _getScrollbarWidth.default)());
	        if (shouldAllow === false || shouldAllow && shouldAllow.horizontal === false) {
	          result.horizontal = false;
	        }
	        if (shouldAllow === false || shouldAllow && shouldAllow.vertical === false) {
	          result.vertical = false;
	        }
	      }
	      return result;
	    }
	  }, {
	    key: "setScrollbarsVisible",
	    value: function setScrollbarsVisible(scrollbars) {
	      var horizontalVisible = scrollbars.horizontal,
	        verticalVisible = scrollbars.vertical;
	      var _this$scrollbars2 = this.scrollbars,
	        horizontal = _this$scrollbars2.horizontal,
	        vertical = _this$scrollbars2.vertical;
	      if (horizontalVisible !== undefined && horizontal) {
	        horizontal.setVisible(horizontalVisible);
	      }
	      if (verticalVisible !== undefined && vertical) {
	        vertical.setVisible(verticalVisible);
	      }
	    }
	  }, {
	    key: "hideScrollbars",
	    value: function hideScrollbars() {
	      if (this.props.showScrollbarsOnOver && this.mouseEntered) {
	        return;
	      }
	      if (this.props.autoHide && !this.scrollStarted) {
	        this.setScrollbarsVisible({
	          horizontal: false,
	          vertical: false
	        });
	      }
	    }
	  }]);
	  return InovuaScrollContainer;
	}(_react.Component);
	exports.default = InovuaScrollContainer;
	InovuaScrollContainer.defaultProps = {
	  shouldAllowScrollbars: function shouldAllowScrollbars(props, scrollbarWidth) {
	    if (props.nativeScroll) {
	      return false;
	    }
	    if (!scrollbarWidth) {
	      return false;
	    }
	  },
	  avoidRepaintOnScroll: true,
	  avoidScrollTopBrowserLayout: false,
	  applyCSSContainOnScroll: true,
	  alwaysShowTrack: false,
	  autoHide: true,
	  cancelPrevScrollRaf: true,
	  contain: false,
	  dragToScroll: true,
	  forceNonStaticPosition: false,
	  hideDelay: 400,
	  hideTransitionDuration: '300ms',
	  inertialScroll: true,
	  inlineBlock: false,
	  rafOnScroll: false,
	  rafOnResize: false,
	  scrollDebounceDelay: 0,
	  resizer: true,
	  rtl: false,
	  scrollStopDelay: 180,
	  scrollThumbMargin: 2,
	  scrollThumbStartEndRespectMargin: true,
	  scrollThumbWidth: 7,
	  scrollThumbOverWidth: 10,
	  scrollThumbRadius: 3,
	  showDelay: 100,
	  showScrollbarsOnOver: true,
	  showTransitionDuration: '100ms',
	  showTrackOnDrag: false,
	  scrollTrackOverTransitionDuration: '100ms',
	  usePassiveScroll: true,
	  tagName: 'div',
	  theme: 'default-light'
	};
	var propTypes = {
	  alwaysShowTrack: _propTypes.default.bool,
	  avoidScrollTopBrowserLayout: _propTypes.default.bool,
	  applyCSSContainOnScroll: _propTypes.default.bool,
	  avoidRepaintOnScroll: _propTypes.default.bool,
	  autoHide: _propTypes.default.bool,
	  cancelPrevScrollRaf: _propTypes.default.bool,
	  dragToScroll: _propTypes.default.bool,
	  display: _propTypes.default.string,
	  checkResizeDelay: _propTypes.default.number,
	  emptyScrollOffset: _propTypes.default.number,
	  factory: _propTypes.default.func,
	  nativeScroll: _propTypes.default.bool,
	  forceNonStaticPosition: _propTypes.default.bool,
	  hideDelay: _propTypes.default.number,
	  getClientSize: _propTypes.default.func,
	  getScrollSize: _propTypes.default.func,
	  getTrackSize: _propTypes.default.func,
	  getScrollerNodeClientSize: _propTypes.default.func,
	  hideTransitionDuration: _propTypes.default.string,
	  hideNativeScrollbarIfPossible: _propTypes.default.bool,
	  inertialScroll: _propTypes.default.bool,
	  rtl: _propTypes.default.bool,
	  inlineBlock: _propTypes.default.bool,
	  rafOnResize: _propTypes.default.bool,
	  contain: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  onContainerScroll: _propTypes.default.func,
	  onContainerScrollHorizontal: _propTypes.default.func,
	  onContainerScrollHorizontalMax: _propTypes.default.func,
	  onContainerScrollHorizontalMin: _propTypes.default.func,
	  onContainerScrollVertical: _propTypes.default.func,
	  onContainerScrollVerticalMax: _propTypes.default.func,
	  onContainerScrollVerticalMin: _propTypes.default.func,
	  onResize: _propTypes.default.func,
	  onScroll: _propTypes.default.func,
	  onScrollbarsChange: _propTypes.default.func,
	  onScrollStart: _propTypes.default.func,
	  onScrollStop: _propTypes.default.func,
	  onViewResize: _propTypes.default.func,
	  rafOnScroll: _propTypes.default.bool,
	  scrollDebounceDelay: _propTypes.default.number,
	  renderScroller: _propTypes.default.func,
	  renderView: _propTypes.default.func,
	  resizer: _propTypes.default.bool,
	  scrollbars: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.shape({
	    vertical: _propTypes.default.bool,
	    horizontal: _propTypes.default.bool
	  })]),
	  usePassiveScroll: _propTypes.default.bool,
	  showScrollbarsOnOver: _propTypes.default.bool,
	  onScrollbarStartDrag: _propTypes.default.func,
	  onScrollbarStopDrag: _propTypes.default.func,
	  onHorizontalScrollbarStartDrag: _propTypes.default.func,
	  onHorizontalScrollbarStopDrag: _propTypes.default.func,
	  onVerticalScrollbarStartDrag: _propTypes.default.func,
	  onVerticalScrollbarStopDrag: _propTypes.default.func,
	  scrollerStyle: _propTypes.default.shape({}),
	  scrollStopDelay: _propTypes.default.number,
	  scrollThumbMargin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  scrollMaxDelta: _propTypes.default.number,
	  scrollThumbMinSize: _propTypes.default.number,
	  scrollThumbOverWidth: _propTypes.default.number,
	  scrollThumbRadius: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  scrollThumbStartEndRespectMargin: _propTypes.default.bool,
	  scrollThumbWidth: _propTypes.default.number,
	  scrollThumbStyle: _propTypes.default.shape(),
	  scrollTrackOverTransitionDuration: _propTypes.default.string,
	  showDelay: _propTypes.default.number,
	  showTrackOnDrag: _propTypes.default.bool,
	  shouldComponentUpdate: _propTypes.default.func,
	  shouldAllowScrollbars: _propTypes.default.func,
	  showTransitionDuration: _propTypes.default.string,
	  tagName: _propTypes.default.string,
	  theme: _propTypes.default.string,
	  scrollerResizerProps: _propTypes.default.object,
	  onDidMount: _propTypes.default.func,
	  onWillUnmount: _propTypes.default.func,
	  viewClassName: _propTypes.default.string,
	  viewStyle: _propTypes.default.shape({}),
	  wrapperStyle: _propTypes.default.shape({}),
	  ResizeObserver: _propTypes.default.func,
	  scrollThreshold: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  showScrollbars: _propTypes.default.bool
	};
	exports.propTypes = propTypes;
	InovuaScrollContainer.propTypes = propTypes;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var accounting = __webpack_require__(817)
	var assign = __webpack_require__(67)
	var localeCurrency = __webpack_require__(1065)
	var currencies = __webpack_require__(1058)
	var localeFormats = __webpack_require__(1059)
	
	var defaultCurrency = {
	  symbol: '',
	  thousandsSeparator: ',',
	  decimalSeparator: '.',
	  symbolOnLeft: true,
	  spaceBetweenAmountAndSymbol: false,
	  decimalDigits: 2
	}
	
	var defaultLocaleFormat = {}
	
	var formatMapping = [
	  {
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    format: {
	      pos: '%s%v',
	      neg: '-%s%v',
	      zero: '%s%v'
	    }
	  },
	  {
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    format: {
	      pos: '%s %v',
	      neg: '-%s %v',
	      zero: '%s %v'
	    }
	  },
	  {
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    format: {
	      pos: '%v%s',
	      neg: '-%v%s',
	      zero: '%v%s'
	    }
	  },
	  {
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    format: {
	      pos: '%v %s',
	      neg: '-%v %s',
	      zero: '%v %s'
	    }
	  }
	]
	
	function format(value, options) {
	  var code = options.code || (options.locale && localeCurrency.getCurrency(options.locale))
	  var localeFormat = localeFormats[options.locale] || defaultLocaleFormat
	  var currency = assign({}, defaultCurrency, findCurrency(code), localeFormat)
	  
	  var symbolOnLeft = currency.symbolOnLeft
	  var spaceBetweenAmountAndSymbol = currency.spaceBetweenAmountAndSymbol
	
	  var format = formatMapping.filter(function(f) {
	    return f.symbolOnLeft == symbolOnLeft && f.spaceBetweenAmountAndSymbol == spaceBetweenAmountAndSymbol
	  })[0].format
	
	  return accounting.formatMoney(value, {
	    symbol: isUndefined(options.symbol)
	              ? currency.symbol
	              : options.symbol,
	
	    decimal: isUndefined(options.decimal)
	              ? currency.decimalSeparator
	              : options.decimal,
	
	    thousand: isUndefined(options.thousand)
	              ? currency.thousandsSeparator
	              : options.thousand,
	
	    precision: typeof options.precision === 'number'
	              ? options.precision
	              : currency.decimalDigits,
	
	    format: ['string', 'object'].indexOf(typeof options.format) > -1
	              ? options.format
	              : format
	  })
	}
	
	function findCurrency (currencyCode) {
	  return currencies[currencyCode]
	}
	
	function isUndefined (val) {
	  return typeof val === 'undefined'
	}
	
	module.exports = {
	  defaultCurrency: defaultCurrency,
	  get currencies() {
	    // In favor of backwards compatibility, the currencies map is converted to an array here
	    return Object.keys(currencies).map(function(key) {
	      return currencies[key]
	    })
	  },
	  findCurrency: findCurrency,
	  format: format
	}

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	function startOfUTCISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeek;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	var _index4 = __webpack_require__(51);
	function startOfUTCWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeek;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(25));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	var _index4 = __webpack_require__(51);
	/**
	 * @name startOfWeek
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index3.default)(1, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setDate(date.getDate() - diff);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(475);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var defineDataProperty = __webpack_require__(175);
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var supportsDescriptors = __webpack_require__(120)();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object) {
			if (predicate === true) {
				if (object[name] === value) {
					return;
				}
			} else if (!isFunction(predicate) || !predicate()) {
				return;
			}
		}
	
		if (supportsDescriptors) {
			defineDataProperty(object, name, value, true);
		} else {
			defineDataProperty(object, name, value);
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;;(function(factory) {
	    'use strict';
	    /* global window: false, define: false, module: false */
	    var root = typeof window === 'undefined' ? null : window;
	
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){ return factory(root); }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module !== 'undefined') {
	        module.exports = factory(root);
	    } else {
	        root.DOMPurify = factory(root);
	    }
	}(function factory(window) {
	    'use strict';
	
	    var DOMPurify = function(window) {
	        return factory(window);
	    };
	
	    /**
	     * Version label, exposed for easier checks
	     * if DOMPurify is up to date or not
	     */
	    DOMPurify.version = '0.8.9';
	
	    /**
	     * Array of elements that DOMPurify removed during sanitation.
	     * Empty if nothing was removed.
	     */
	    DOMPurify.removed = [];
	
	    if (!window || !window.document || window.document.nodeType !== 9) {
	        // not running in a browser, provide a factory function
	        // so that you can pass your own Window
	        DOMPurify.isSupported = false;
	        return DOMPurify;
	    }
	
	    var document = window.document;
	    var originalDocument = document;
	    var DocumentFragment = window.DocumentFragment;
	    var HTMLTemplateElement = window.HTMLTemplateElement;
	    var Node = window.Node;
	    var NodeFilter = window.NodeFilter;
	    var NamedNodeMap = window.NamedNodeMap || window.MozNamedAttrMap;
	    var Text = window.Text;
	    var Comment = window.Comment;
	    var DOMParser = window.DOMParser;
	    var useDOMParser = false; // See comment below
	
	    // As per issue #47, the web-components registry is inherited by a
	    // new document created via createHTMLDocument. As per the spec
	    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
	    // a new empty registry is used when creating a template contents owner
	    // document, so we use that as our parent document to ensure nothing
	    // is inherited.
	    if (typeof HTMLTemplateElement === 'function') {
	        var template = document.createElement('template');
	        if (template.content && template.content.ownerDocument) {
	            document = template.content.ownerDocument;
	        }
	    }
	    var implementation = document.implementation;
	    var createNodeIterator = document.createNodeIterator;
	    var getElementsByTagName = document.getElementsByTagName;
	    var createDocumentFragment = document.createDocumentFragment;
	    var importNode = originalDocument.importNode;
	
	    var hooks = {};
	
	    /**
	     * Expose whether this browser supports running the full DOMPurify.
	     */
	    DOMPurify.isSupported =
	        typeof implementation.createHTMLDocument !== 'undefined' &&
	        document.documentMode !== 9;
	
	    /* Add properties to a lookup table */
	    var _addToSet = function(set, array) {
	        var l = array.length;
	        while (l--) {
	            if (typeof array[l] === 'string') {
	                array[l] = array[l].toLowerCase();
	            }
	            set[array[l]] = true;
	        }
	        return set;
	    };
	
	    /* Shallow clone an object */
	    var _cloneObj = function(object) {
	        var newObject = {};
	        var property;
	        for (property in object) {
	            if (object.hasOwnProperty(property)) {
	                newObject[property] = object[property];
	            }
	        }
	        return newObject;
	    };
	
	    /**
	     * We consider the elements and attributes below to be safe. Ideally
	     * don't add any new ones but feel free to remove unwanted ones.
	     */
	
	    /* allowed element names */
	    var ALLOWED_TAGS = null;
	    var DEFAULT_ALLOWED_TAGS = _addToSet({}, [
	
	        // HTML
	        'a','abbr','acronym','address','area','article','aside','audio','b',
	        'bdi','bdo','big','blink','blockquote','body','br','button','canvas',
	        'caption','center','cite','code','col','colgroup','content','data',
	        'datalist','dd','decorator','del','details','dfn','dir','div','dl','dt',
	        'element','em','fieldset','figcaption','figure','font','footer','form',
	        'h1','h2','h3','h4','h5','h6','head','header','hgroup','hr','html','i',
	        'img','input','ins','kbd','label','legend','li','main','map','mark',
	        'marquee','menu','menuitem','meter','nav','nobr','ol','optgroup',
	        'option','output','p','pre','progress','q','rp','rt','ruby','s','samp',
	        'section','select','shadow','small','source','spacer','span','strike',
	        'strong','style','sub','summary','sup','table','tbody','td','template',
	        'textarea','tfoot','th','thead','time','tr','track','tt','u','ul','var',
	        'video','wbr',
	
	        // SVG
	        'svg','altglyph','altglyphdef','altglyphitem','animatecolor',
	        'animatemotion','animatetransform','circle','clippath','defs','desc',
	        'ellipse','filter','font','g','glyph','glyphref','hkern','image','line',
	        'lineargradient','marker','mask','metadata','mpath','path','pattern',
	        'polygon','polyline','radialgradient','rect','stop','switch','symbol',
	        'text','textpath','title','tref','tspan','view','vkern',
	
	        // SVG Filters
	        'feBlend','feColorMatrix','feComponentTransfer','feComposite',
	        'feConvolveMatrix','feDiffuseLighting','feDisplacementMap',
	        'feFlood','feFuncA','feFuncB','feFuncG','feFuncR','feGaussianBlur',
	        'feMerge','feMergeNode','feMorphology','feOffset',
	        'feSpecularLighting','feTile','feTurbulence',
	
	        //MathML
	        'math','menclose','merror','mfenced','mfrac','mglyph','mi','mlabeledtr',
	        'mmuliscripts','mn','mo','mover','mpadded','mphantom','mroot','mrow',
	        'ms','mpspace','msqrt','mystyle','msub','msup','msubsup','mtable','mtd',
	        'mtext','mtr','munder','munderover',
	
	        //Text
	        '#text'
	    ]);
	
	    /* Allowed attribute names */
	    var ALLOWED_ATTR = null;
	    var DEFAULT_ALLOWED_ATTR = _addToSet({}, [
	
	        // HTML
	        'accept','action','align','alt','autocomplete','background','bgcolor',
	        'border','cellpadding','cellspacing','checked','cite','class','clear','color',
	        'cols','colspan','coords','datetime','default','dir','disabled',
	        'download','enctype','face','for','headers','height','hidden','high','href',
	        'hreflang','id','ismap','label','lang','list','loop', 'low','max',
	        'maxlength','media','method','min','multiple','name','noshade','novalidate',
	        'nowrap','open','optimum','pattern','placeholder','poster','preload','pubdate',
	        'radiogroup','readonly','rel','required','rev','reversed','role','rows',
	        'rowspan','spellcheck','scope','selected','shape','size','span',
	        'srclang','start','src','step','style','summary','tabindex','title',
	        'type','usemap','valign','value','width','xmlns',
	
	        // SVG
	        'accent-height','accumulate','additivive','alignment-baseline',
	        'ascent','attributename','attributetype','azimuth','basefrequency',
	        'baseline-shift','begin','bias','by','clip','clip-path','clip-rule',
	        'color','color-interpolation','color-interpolation-filters','color-profile',
	        'color-rendering','cx','cy','d','dx','dy','diffuseconstant','direction',
	        'display','divisor','dur','edgemode','elevation','end','fill','fill-opacity',
	        'fill-rule','filter','flood-color','flood-opacity','font-family','font-size',
	        'font-size-adjust','font-stretch','font-style','font-variant','font-weight',
	        'fx', 'fy','g1','g2','glyph-name','glyphref','gradientunits','gradienttransform',
	        'image-rendering','in','in2','k','k1','k2','k3','k4','kerning','keypoints',
	        'keysplines','keytimes','lengthadjust','letter-spacing','kernelmatrix',
	        'kernelunitlength','lighting-color','local','marker-end','marker-mid',
	        'marker-start','markerheight','markerunits','markerwidth','maskcontentunits',
	        'maskunits','max','mask','mode','min','numoctaves','offset','operator',
	        'opacity','order','orient','orientation','origin','overflow','paint-order',
	        'path','pathlength','patterncontentunits','patterntransform','patternunits',
	        'points','preservealpha','r','rx','ry','radius','refx','refy','repeatcount',
	        'repeatdur','restart','result','rotate','scale','seed','shape-rendering',
	        'specularconstant','specularexponent','spreadmethod','stddeviation','stitchtiles',
	        'stop-color','stop-opacity','stroke-dasharray','stroke-dashoffset','stroke-linecap',
	        'stroke-linejoin','stroke-miterlimit','stroke-opacity','stroke','stroke-width',
	        'surfacescale','targetx','targety','transform','text-anchor','text-decoration',
	        'text-rendering','textlength','u1','u2','unicode','values','viewbox',
	        'visibility','vert-adv-y','vert-origin-x','vert-origin-y','word-spacing',
	        'wrap','writing-mode','xchannelselector','ychannelselector','x','x1','x2',
	        'y','y1','y2','z','zoomandpan',
	
	        // MathML
	        'accent','accentunder','bevelled','close','columnsalign','columnlines',
	        'columnspan','denomalign','depth','display','displaystyle','fence',
	        'frame','largeop','length','linethickness','lspace','lquote',
	        'mathbackground','mathcolor','mathsize','mathvariant','maxsize',
	        'minsize','movablelimits','notation','numalign','open','rowalign',
	        'rowlines','rowspacing','rowspan','rspace','rquote','scriptlevel',
	        'scriptminsize','scriptsizemultiplier','selection','separator',
	        'separators','stretchy','subscriptshift','supscriptshift','symmetric',
	        'voffset',
	
	        // XML
	        'xlink:href','xml:id','xlink:title','xml:space','xmlns:xlink'
	    ]);
	
	    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
	    var FORBID_TAGS = null;
	
	    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
	    var FORBID_ATTR = null;
	
	    /* Decide if ARIA attributes are okay */
	    var ALLOW_ARIA_ATTR = true;
	
	    /* Decide if custom data attributes are okay */
	    var ALLOW_DATA_ATTR = true;
	
	    /* Decide if unknown protocols are okay */
	    var ALLOW_UNKNOWN_PROTOCOLS = false;
	
	    /* Output should be safe for jQuery's $() factory? */
	    var SAFE_FOR_JQUERY = false;
	
	    /* Output should be safe for common template engines.
	     * This means, DOMPurify removes data attributes, mustaches and ERB
	     */
	    var SAFE_FOR_TEMPLATES = false;
	
	    /* Specify template detection regex for SAFE_FOR_TEMPLATES mode */
	    var MUSTACHE_EXPR = /\{\{[\s\S]*|[\s\S]*\}\}/gm;
	    var ERB_EXPR = /<%[\s\S]*|[\s\S]*%>/gm;
	
	    /* Decide if document with <html>... should be returned */
	    var WHOLE_DOCUMENT = false;
	
	    /* Decide if all elements (e.g. style, script) must be children of
	     * document.body. By default, browsers might move them to document.head */
	    var FORCE_BODY = false;
	
	    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html string.
	     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
	     */
	    var RETURN_DOM = false;
	
	    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html string */
	    var RETURN_DOM_FRAGMENT = false;
	
	    /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
	     * `Node` is imported into the current `Document`. If this flag is not enabled the
	     * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
	     * DOMPurify. */
	    var RETURN_DOM_IMPORT = false;
	
	    /* Output should be free from DOM clobbering attacks? */
	    var SANITIZE_DOM = true;
	
	    /* Keep element content when removing element? */
	    var KEEP_CONTENT = true;
	
	    /* Tags to ignore content of when KEEP_CONTENT is true */
	    var FORBID_CONTENTS = _addToSet({}, [
	        'audio', 'head', 'math', 'script', 'style', 'template', 'svg', 'video'
	    ]);
	
	    /* Tags that are safe for data: URIs */
	    var DATA_URI_TAGS = _addToSet({}, [
	        'audio', 'video', 'img', 'source', 'image'
	    ]);
	
	    /* Attributes safe for values like "javascript:" */
	    var URI_SAFE_ATTRIBUTES = _addToSet({}, [
	        'alt','class','for','id','label','name','pattern','placeholder',
	        'summary','title','value','style','xmlns'
	    ]);
	
	    /* Keep a reference to config to pass to hooks */
	    var CONFIG = null;
	
	    /* Ideally, do not touch anything below this line */
	    /* ______________________________________________ */
	
	    var formElement = document.createElement('form');
	
	    /**
	     * _parseConfig
	     *
	     * @param  optional config literal
	     */
	    var _parseConfig = function(cfg) {
	        /* Shield configuration object from tampering */
	        if (typeof cfg !== 'object') {
	            cfg = {};
	        }
	
	        /* Set configuration parameters */
	        ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ?
	            _addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
	        ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ?
	            _addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
	        FORBID_TAGS = 'FORBID_TAGS' in cfg ?
	            _addToSet({}, cfg.FORBID_TAGS) : {};
	        FORBID_ATTR = 'FORBID_ATTR' in cfg ?
	            _addToSet({}, cfg.FORBID_ATTR) : {};
	        ALLOW_ARIA_ATTR     = cfg.ALLOW_ARIA_ATTR     !== false; // Default true
	        ALLOW_DATA_ATTR     = cfg.ALLOW_DATA_ATTR     !== false; // Default true
	        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
	        SAFE_FOR_JQUERY     = cfg.SAFE_FOR_JQUERY     ||  false; // Default false
	        SAFE_FOR_TEMPLATES  = cfg.SAFE_FOR_TEMPLATES  ||  false; // Default false
	        WHOLE_DOCUMENT      = cfg.WHOLE_DOCUMENT      ||  false; // Default false
	        RETURN_DOM          = cfg.RETURN_DOM          ||  false; // Default false
	        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT ||  false; // Default false
	        RETURN_DOM_IMPORT   = cfg.RETURN_DOM_IMPORT   ||  false; // Default false
	        FORCE_BODY          = cfg.FORCE_BODY          ||  false; // Default false
	        SANITIZE_DOM        = cfg.SANITIZE_DOM        !== false; // Default true
	        KEEP_CONTENT        = cfg.KEEP_CONTENT        !== false; // Default true
	
	        if (SAFE_FOR_TEMPLATES) {
	            ALLOW_DATA_ATTR = false;
	        }
	
	        if (RETURN_DOM_FRAGMENT) {
	            RETURN_DOM = true;
	        }
	
	        /* Merge configuration parameters */
	        if (cfg.ADD_TAGS) {
	            if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
	                ALLOWED_TAGS = _cloneObj(ALLOWED_TAGS);
	            }
	            _addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
	        }
	        if (cfg.ADD_ATTR) {
	            if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
	                ALLOWED_ATTR = _cloneObj(ALLOWED_ATTR);
	            }
	            _addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
	        }
	        if (cfg.ADD_URI_SAFE_ATTR) {
	            _addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
	        }
	
	        /* Add #text in case KEEP_CONTENT is set to true */
	        if (KEEP_CONTENT) { ALLOWED_TAGS['#text'] = true; }
	
	        // Prevent further manipulation of configuration.
	        // Not available in IE8, Safari 5, etc.
	        if (Object && 'freeze' in Object) { Object.freeze(cfg); }
	
	        CONFIG = cfg;
	    };
	
	   /**
	     * _forceRemove
	     *
	     * @param  a DOM node
	     */
	    var _forceRemove = function(node) {
	        DOMPurify.removed.push({element: node});
	        try {
	            node.parentNode.removeChild(node);
	        } catch (e) {
	            node.outerHTML = '';
	        }
	    };
	
	   /**
	     * _removeAttribute
	     *
	     * @param  an Attribute name
	     * @param  a DOM node
	     */
	    var _removeAttribute = function(name, node) {
	        DOMPurify.removed.push({
	            attribute: node.getAttributeNode(name),
	            from: node
	        });
	        node.removeAttribute(name);
	    };
	
	   /**
	     * _initDocument
	     *
	     * @param  a string of dirty markup
	     * @return a DOM, filled with the dirty markup
	     */
	    var _initDocument = function(dirty) {
	        /* Create a HTML document */
	        var doc, body;
	
	        /* Fill body with bogus element */
	        if (FORCE_BODY) {
	            dirty = '<remove></remove>' + dirty;
	        }
	
	        /* Use DOMParser to workaround Firefox bug (see comment below) */
	        if (useDOMParser) {
	            try {
	                doc = new DOMParser().parseFromString(dirty, 'text/html');
	            } catch (e) {}
	        }
	
	        /* Otherwise use createHTMLDocument, because DOMParser is unsafe in
	           Safari (see comment below) */
	        if (!doc || !doc.documentElement) {
	            doc = implementation.createHTMLDocument('');
	            body = doc.body;
	            body.parentNode.removeChild(body.parentNode.firstElementChild);
	            body.outerHTML = dirty;
	        }
	
	        /* Work on whole document or just its body */
	        return getElementsByTagName.call(doc,
	            WHOLE_DOCUMENT ? 'html' : 'body')[0];
	    };
	
	    // Safari 10.1+ (unfixed as of time of writing) has a catastrophic bug in
	    // its implementation of DOMParser such that the following executes the
	    // JavaScript:
	    //
	    // new DOMParser()
	    //   .parseFromString('<svg onload=alert(document.domain)>', 'text/html');
	    //
	    // However, Firefox uses a different parser for innerHTML rather than
	    // DOMParser (see https://bugzilla.mozilla.org/show_bug.cgi?id=1205631)
	    // which means that you *must* use DOMParser, otherwise the output may
	    // not be safe if used in a document.write context later.
	    //
	    // So we feature detect the Firefox bug and use the DOMParser if necessary.
	    if (DOMPurify.isSupported) {
	        (function () {
	            var doc = _initDocument('<svg><p><style><img src="</style><img src=x onerror=alert(1)//">');
	            if (doc.querySelector('svg img')) {
	                useDOMParser = true;
	            }
	        }());
	    }
	
	    /**
	     * _createIterator
	     *
	     * @param  document/fragment to create iterator for
	     * @return iterator instance
	     */
	    var _createIterator = function(root) {
	        return createNodeIterator.call(root.ownerDocument || root,
	            root,
	            NodeFilter.SHOW_ELEMENT
	            | NodeFilter.SHOW_COMMENT
	            | NodeFilter.SHOW_TEXT,
	            function() { return NodeFilter.FILTER_ACCEPT; },
	            false
	        );
	    };
	
	    /**
	     * _isClobbered
	     *
	     * @param  element to check for clobbering attacks
	     * @return true if clobbered, false if safe
	     */
	    var _isClobbered = function(elm) {
	        if (elm instanceof Text || elm instanceof Comment) {
	            return false;
	        }
	        if (  typeof elm.nodeName !== 'string'
	           || typeof elm.textContent !== 'string'
	           || typeof elm.removeChild !== 'function'
	           || !(elm.attributes instanceof NamedNodeMap)
	           || typeof elm.removeAttribute !== 'function'
	           || typeof elm.setAttribute !== 'function'
	        ) {
	            return true;
	        }
	        return false;
	    };
	
	    /**
	     * _isNode
	     *
	     * @param object to check whether it's a DOM node
	     * @return true is object is a DOM node
	     */
	    var _isNode = function(obj) {
	        return (
	            typeof Node === "object" ? obj instanceof Node : obj
	                && typeof obj === "object" && typeof obj.nodeType === "number"
	                && typeof obj.nodeName==="string"
	        );
	    };
	
	    /**
	     * _sanitizeElements
	     *
	     * @protect nodeName
	     * @protect textContent
	     * @protect removeChild
	     *
	     * @param   node to check for permission to exist
	     * @return  true if node was killed, false if left alive
	     */
	    var _sanitizeElements = function(currentNode) {
	        var tagName, content;
	
	        /* Execute a hook if present */
	        _executeHook('beforeSanitizeElements', currentNode, null);
	
	        /* Check if element is clobbered or can clobber */
	        if (_isClobbered(currentNode)) {
	            _forceRemove(currentNode);
	            return true;
	        }
	
	        /* Now let's check the element's type and name */
	        tagName = currentNode.nodeName.toLowerCase();
	
	        /* Execute a hook if present */
	        _executeHook('uponSanitizeElement', currentNode, {
	            tagName: tagName,
	            allowedTags: ALLOWED_TAGS
	        });
	
	        /* Remove element if anything forbids its presence */
	        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
	            /* Keep content except for black-listed elements */
	            if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]
	                    && typeof currentNode.insertAdjacentHTML === 'function') {
	                try {
	                    currentNode.insertAdjacentHTML('AfterEnd', currentNode.innerHTML);
	                } catch (e) {}
	            }
	            _forceRemove(currentNode);
	            return true;
	        }
	
	        /* Convert markup to cover jQuery behavior */
	        if (SAFE_FOR_JQUERY && !currentNode.firstElementChild &&
	                (!currentNode.content || !currentNode.content.firstElementChild) &&
	                /</g.test(currentNode.textContent)) {
	            DOMPurify.removed.push({element: currentNode.cloneNode()});
	            currentNode.innerHTML = currentNode.textContent.replace(/</g, '&lt;');
	        }
	
	        /* Sanitize element content to be template-safe */
	        if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
	            /* Get the element's text content */
	            content = currentNode.textContent;
	            content = content.replace(MUSTACHE_EXPR, ' ');
	            content = content.replace(ERB_EXPR, ' ');
	            if (currentNode.textContent !== content) {
	                DOMPurify.removed.push({element: currentNode.cloneNode()});
	                currentNode.textContent = content;
	            }
	        }
	
	        /* Execute a hook if present */
	        _executeHook('afterSanitizeElements', currentNode, null);
	
	        return false;
	    };
	
	    var DATA_ATTR = /^data-[\-\w.\u00B7-\uFFFF]/;
	    var ARIA_ATTR = /^aria-[\-\w]+$/;
	    var IS_ALLOWED_URI = /^(?:(?:(?:f|ht)tps?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i;
	    var IS_SCRIPT_OR_DATA = /^(?:\w+script|data):/i;
	    /* This needs to be extensive thanks to Webkit/Blink's behavior */
	    var ATTR_WHITESPACE = /[\x00-\x20\xA0\u1680\u180E\u2000-\u2029\u205f\u3000]/g;
	
	    /**
	     * _sanitizeAttributes
	     *
	     * @protect attributes
	     * @protect nodeName
	     * @protect removeAttribute
	     * @protect setAttribute
	     *
	     * @param   node to sanitize
	     * @return  void
	     */
	    var _sanitizeAttributes = function(currentNode) {
	        var attr, name, value, lcName, idAttr, attributes, hookEvent, l;
	        /* Execute a hook if present */
	        _executeHook('beforeSanitizeAttributes', currentNode, null);
	
	        attributes = currentNode.attributes;
	
	        /* Check if we have attributes; if not we might have a text node */
	        if (!attributes) { return; }
	
	        hookEvent = {
	            attrName: '',
	            attrValue: '',
	            keepAttr: true,
	            allowedAttributes: ALLOWED_ATTR
	        };
	        l = attributes.length;
	
	        /* Go backwards over all attributes; safely remove bad ones */
	        while (l--) {
	            attr = attributes[l];
	            name = attr.name;
	            value = attr.value.trim();
	            lcName = name.toLowerCase();
	
	            /* Execute a hook if present */
	            hookEvent.attrName = lcName;
	            hookEvent.attrValue = value;
	            hookEvent.keepAttr = true;
	            _executeHook('uponSanitizeAttribute', currentNode, hookEvent );
	            value = hookEvent.attrValue;
	
	            /* Remove attribute */
	            // Safari (iOS + Mac), last tested v8.0.5, crashes if you try to
	            // remove a "name" attribute from an <img> tag that has an "id"
	            // attribute at the time.
	            if (lcName === 'name'  &&
	                    currentNode.nodeName === 'IMG' && attributes.id) {
	                idAttr = attributes.id;
	                attributes = Array.prototype.slice.apply(attributes);
	                _removeAttribute('id', currentNode);
	                _removeAttribute(name, currentNode);
	                if (attributes.indexOf(idAttr) > l) {
	                    currentNode.setAttribute('id', idAttr.value);
	                }
	            } else if (
	                  // This works around a bug in Safari, where input[type=file]
	                  // cannot be dynamically set after type has been removed
	                  currentNode.nodeName === 'INPUT' && lcName === 'type' &&
	                  value === 'file' && (ALLOWED_ATTR[lcName] || !FORBID_ATTR[lcName])) {
	                  continue;
	            } else {
	                // This avoids a crash in Safari v9.0 with double-ids.
	                // The trick is to first set the id to be empty and then to
	                // remove the attribute
	                if (name === 'id') {
	                    currentNode.setAttribute(name, '');
	                }
	                _removeAttribute(name, currentNode);
	            }
	
	            /* Did the hooks approve of the attribute? */
	            if (!hookEvent.keepAttr) {
	                continue;
	            }
	
	            /* Make sure attribute cannot clobber */
	            if (SANITIZE_DOM &&
	                    (lcName === 'id' || lcName === 'name') &&
	                    (value in window || value in document || value in formElement)) {
	                continue;
	            }
	
	            /* Sanitize attribute content to be template-safe */
	            if (SAFE_FOR_TEMPLATES) {
	                value = value.replace(MUSTACHE_EXPR, ' ');
	                value = value.replace(ERB_EXPR, ' ');
	            }
	
	            /* Allow valid data-* attributes: At least one character after "-"
	               (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
	               XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
	               We don't need to check the value; it's always URI safe. */
	            if (ALLOW_DATA_ATTR && DATA_ATTR.test(lcName)) {
	                // This attribute is safe
	            }
	            else if (ALLOW_ARIA_ATTR && ARIA_ATTR.test(lcName)) {
	                // This attribute is safe
	            }
	            /* Otherwise, check the name is permitted */
	            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
	                continue;
	            }
	            /* Check value is safe. First, is attr inert? If so, is safe */
	            else if (URI_SAFE_ATTRIBUTES[lcName]) {
	                // This attribute is safe
	            }
	            /* Check no script, data or unknown possibly unsafe URI
	               unless we know URI values are safe for that attribute */
	            else if (IS_ALLOWED_URI.test(value.replace(ATTR_WHITESPACE,''))) {
	                // This attribute is safe
	            }
	            /* Keep image data URIs alive if src/xlink:href is allowed */
	            else if (
	                (lcName === 'src' || lcName === 'xlink:href') &&
	                value.indexOf('data:') === 0 &&
	                DATA_URI_TAGS[currentNode.nodeName.toLowerCase()]) {
	                // This attribute is safe
	            }
	            /* Allow unknown protocols: This provides support for links that
	               are handled by protocol handlers which may be unknown ahead of
	               time, e.g. fb:, spotify: */
	            else if (
	                ALLOW_UNKNOWN_PROTOCOLS &&
	                !IS_SCRIPT_OR_DATA.test(value.replace(ATTR_WHITESPACE,''))) {
	                // This attribute is safe
	            }
	            /* Check for binary attributes */
	            else if (!value) {
	                // binary attributes are safe at this point
	            }
	            /* Anything else, presume unsafe, do not add it back */
	            else {
	                continue;
	            }
	
	            /* Handle invalid data-* attribute set by try-catching it */
	            try {
	                currentNode.setAttribute(name, value);
	                DOMPurify.removed.pop();
	            } catch (e) {}
	        }
	
	        /* Execute a hook if present */
	        _executeHook('afterSanitizeAttributes', currentNode, null);
	    };
	
	    /**
	     * _sanitizeShadowDOM
	     *
	     * @param  fragment to iterate over recursively
	     * @return void
	     */
	    var _sanitizeShadowDOM = function(fragment) {
	        var shadowNode;
	        var shadowIterator = _createIterator(fragment);
	
	        /* Execute a hook if present */
	        _executeHook('beforeSanitizeShadowDOM', fragment, null);
	
	        while ( (shadowNode = shadowIterator.nextNode()) ) {
	            /* Execute a hook if present */
	            _executeHook('uponSanitizeShadowNode', shadowNode, null);
	
	            /* Sanitize tags and elements */
	            if (_sanitizeElements(shadowNode)) {
	                continue;
	            }
	
	            /* Deep shadow DOM detected */
	            if (shadowNode.content instanceof DocumentFragment) {
	                _sanitizeShadowDOM(shadowNode.content);
	            }
	
	            /* Check attributes, sanitize if necessary */
	            _sanitizeAttributes(shadowNode);
	        }
	
	        /* Execute a hook if present */
	        _executeHook('afterSanitizeShadowDOM', fragment, null);
	    };
	
	    /**
	     * _executeHook
	     * Execute user configurable hooks
	     *
	     * @param  {String} entryPoint  Name of the hook's entry point
	     * @param  {Node} currentNode
	     */
	    var _executeHook = function(entryPoint, currentNode, data) {
	        if (!hooks[entryPoint]) { return; }
	
	        hooks[entryPoint].forEach(function(hook) {
	            hook.call(DOMPurify, currentNode, data, CONFIG);
	        });
	    };
	
	    /**
	     * sanitize
	     * Public method providing core sanitation functionality
	     *
	     * @param {String|Node} dirty string or DOM node
	     * @param {Object} configuration object
	     */
	    DOMPurify.sanitize = function(dirty, cfg) {
	        var body, importedNode, currentNode, oldNode, nodeIterator, returnNode;
	        /* Make sure we have a string to sanitize.
	           DO NOT return early, as this will return the wrong type if
	           the user has requested a DOM object rather than a string */
	        if (!dirty) {
	            dirty = '<!-->';
	        }
	
	        /* Stringify, in case dirty is an object */
	        if (typeof dirty !== 'string' && !_isNode(dirty)) {
	            if (typeof dirty.toString !== 'function') {
	                throw new TypeError('toString is not a function');
	            } else {
	                dirty = dirty.toString();
	            }
	        }
	
	        /* Check we can run. Otherwise fall back or ignore */
	        if (!DOMPurify.isSupported) {
	            if (typeof window.toStaticHTML === 'object'
	                || typeof window.toStaticHTML === 'function') {
	                if (typeof dirty === 'string') {
	                    return window.toStaticHTML(dirty);
	                } else if (_isNode(dirty)) {
	                    return window.toStaticHTML(dirty.outerHTML);
	                }
	            }
	            return dirty;
	        }
	
	        /* Assign config vars */
	        _parseConfig(cfg);
	
	        /* Clean up removed elements */
	        DOMPurify.removed = [];
	
	        if (dirty instanceof Node) {
	            /* If dirty is a DOM element, append to an empty document to avoid
	               elements being stripped by the parser */
	            body = _initDocument('<!-->');
	            importedNode = body.ownerDocument.importNode(dirty, true);
	            if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
	                /* Node is already a body, use as is */
	                body = importedNode;
	            } else {
	                body.appendChild(importedNode);
	            }
	        } else {
	            /* Exit directly if we have nothing to do */
	            if (!RETURN_DOM && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
	                return dirty;
	            }
	
	            /* Initialize the document to work on */
	            body = _initDocument(dirty);
	
	            /* Check we have a DOM node from the data */
	            if (!body) {
	                return RETURN_DOM ? null : '';
	            }
	        }
	
	        /* Remove first element node (ours) if FORCE_BODY is set */
	        if (FORCE_BODY) {
	            _forceRemove(body.firstChild);
	        }
	
	        /* Get node iterator */
	        nodeIterator = _createIterator(body);
	
	        /* Now start iterating over the created document */
	        while ( (currentNode = nodeIterator.nextNode()) ) {
	
	            /* Fix IE's strange behavior with manipulated textNodes #89 */
	            if (currentNode.nodeType === 3 && currentNode === oldNode) {
	                continue;
	            }
	
	            /* Sanitize tags and elements */
	            if (_sanitizeElements(currentNode)) {
	                continue;
	            }
	
	            /* Shadow DOM detected, sanitize it */
	            if (currentNode.content instanceof DocumentFragment) {
	                _sanitizeShadowDOM(currentNode.content);
	            }
	
	            /* Check attributes, sanitize if necessary */
	            _sanitizeAttributes(currentNode);
	
	            oldNode = currentNode;
	        }
	
	        /* Return sanitized string or DOM */
	        if (RETURN_DOM) {
	
	            if (RETURN_DOM_FRAGMENT) {
	                returnNode = createDocumentFragment.call(body.ownerDocument);
	
	                while (body.firstChild) {
	                    returnNode.appendChild(body.firstChild);
	                }
	            } else {
	                returnNode = body;
	            }
	
	            if (RETURN_DOM_IMPORT) {
	                /* adoptNode() is not used because internal state is not reset
	                   (e.g. the past names map of a HTMLFormElement), this is safe
	                   in theory but we would rather not risk another attack vector.
	                   The state that is cloned by importNode() is explicitly defined
	                   by the specs. */
	                returnNode = importNode.call(originalDocument, returnNode, true);
	            }
	
	            return returnNode;
	        }
	
	        return WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
	    };
	
	    /**
	     * addHook
	     * Public method to add DOMPurify hooks
	     *
	     * @param {String} entryPoint
	     * @param {Function} hookFunction
	     */
	    DOMPurify.addHook = function(entryPoint, hookFunction) {
	        if (typeof hookFunction !== 'function') { return; }
	        hooks[entryPoint] = hooks[entryPoint] || [];
	        hooks[entryPoint].push(hookFunction);
	    };
	
	    /**
	     * removeHook
	     * Public method to remove a DOMPurify hook at a given entryPoint
	     * (pops it from the stack of hooks if more are present)
	     *
	     * @param {String} entryPoint
	     * @return void
	     */
	    DOMPurify.removeHook = function(entryPoint) {
	        if (hooks[entryPoint]) {
	            hooks[entryPoint].pop();
	        }
	    };
	
	    /**
	     * removeHooks
	     * Public method to remove all DOMPurify hooks at a given entryPoint
	     *
	     * @param  {String} entryPoint
	     * @return void
	     */
	    DOMPurify.removeHooks = function(entryPoint) {
	        if (hooks[entryPoint]) {
	            hooks[entryPoint] = [];
	        }
	    };
	
	    /**
	     * removeAllHooks
	     * Public method to remove all DOMPurify hooks
	     *
	     * @return void
	     */
	    DOMPurify.removeAllHooks = function() {
	        hooks = {};
	    };
	
	    return DOMPurify;
	}));


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_1 = __webpack_require__(2);
	var EMPTY_ARRAY = [];
	function useUnmount(fn) {
	    react_1.useEffect(function () { return fn; }, EMPTY_ARRAY);
	}
	exports.useUnmount = useUnmount;
	function useForceUpdate() {
	    var _a = __read(react_1.useState(0), 2), setTick = _a[1];
	    var update = react_1.useCallback(function () {
	        setTick(function (tick) { return tick + 1; });
	    }, []);
	    return update;
	}
	exports.useForceUpdate = useForceUpdate;
	function isPlainObject(value) {
	    if (!value || typeof value !== "object") {
	        return false;
	    }
	    var proto = Object.getPrototypeOf(value);
	    return !proto || proto === Object.prototype;
	}
	exports.isPlainObject = isPlainObject;
	function getSymbol(name) {
	    if (typeof Symbol === "function") {
	        return Symbol.for(name);
	    }
	    return "__$mobx-react " + name + "__";
	}
	exports.getSymbol = getSymbol;
	var mockGlobal = {};
	function getGlobal() {
	    if (typeof window !== "undefined") {
	        return window;
	    }
	    if (typeof global !== "undefined") {
	        return global;
	    }
	    if (typeof self !== "undefined") {
	        return self;
	    }
	    return mockGlobal;
	}
	exports.getGlobal = getGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(127),
	    getRawTag = __webpack_require__(1198),
	    objectToString = __webpack_require__(1226);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 96 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _calculateNodeHeight2 = __webpack_require__(1269);
	
	var _calculateNodeHeight3 = _interopRequireDefault(_calculateNodeHeight2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * <TextareaAutosize />
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var noop = function noop() {};
	
	var TextareaAutosize = function (_React$Component) {
	  _inherits(TextareaAutosize, _React$Component);
	
	  function TextareaAutosize(props) {
	    _classCallCheck(this, TextareaAutosize);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._onRootDOMNode = function (node) {
	      _this._rootDOMNode = node;
	      if (_this.props.inputRef) _this.props.inputRef(node);
	    };
	
	    _this._onChange = function (event) {
	      if (!_this._controlled) {
	        _this._resizeComponent();
	      }
	      var _this$props = _this.props,
	          valueLink = _this$props.valueLink,
	          onChange = _this$props.onChange;
	
	      if (valueLink) {
	        valueLink.requestChange(event.target.value);
	      } else {
	        onChange(event);
	      }
	    };
	
	    _this._resizeComponent = function () {
	      if (!_this._rootDOMNode) {
	        return;
	      }
	
	      var _calculateNodeHeight = (0, _calculateNodeHeight3.default)(_this._rootDOMNode, _this.props.useCacheForDOMMeasurements, _this.props.rows || _this.props.minRows, _this.props.maxRows),
	          height = _calculateNodeHeight.height,
	          minHeight = _calculateNodeHeight.minHeight,
	          maxHeight = _calculateNodeHeight.maxHeight;
	
	      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
	        _this.setState({ height: height, minHeight: minHeight, maxHeight: maxHeight });
	      }
	    };
	
	    _this.state = {
	      height: props.style && props.style.height || 0,
	      minHeight: -Infinity,
	      maxHeight: Infinity
	    };
	
	    _this._controlled = typeof props.value === 'string';
	    return _this;
	  }
	
	  TextareaAutosize.prototype.render = function render() {
	    var _props = this.props,
	        valueLink = _props.valueLink,
	        _minRows = _props.minRows,
	        _maxRows = _props.maxRows,
	        _onHeightChange = _props.onHeightChange,
	        _useCacheForDOMMeasurements = _props.useCacheForDOMMeasurements,
	        _inputRef = _props.inputRef,
	        props = _objectWithoutProperties(_props, ['valueLink', 'minRows', 'maxRows', 'onHeightChange', 'useCacheForDOMMeasurements', 'inputRef']);
	
	    if ((typeof valueLink === 'undefined' ? 'undefined' : _typeof(valueLink)) === 'object') {
	      props.value = valueLink.value;
	    }
	
	    props.style = _extends({}, props.style, {
	      height: this.state.height
	    });
	
	    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);
	
	    if (maxHeight < this.state.height) {
	      props.style.overflow = 'hidden';
	    }
	
	    return _react2.default.createElement('textarea', _extends({}, props, {
	      onChange: this._onChange,
	      ref: this._onRootDOMNode
	    }));
	  };
	
	  TextareaAutosize.prototype.componentDidMount = function componentDidMount() {
	    this._resizeComponent();
	    window.addEventListener('resize', this._resizeComponent);
	  };
	
	  TextareaAutosize.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    // Re-render with the new content then recalculate the height as required.
	    this._clearNextFrame();
	    this._onNextFrameActionId = onNextFrame(this._resizeComponent);
	  };
	
	  TextareaAutosize.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // Invoke callback when old height does not equal to new one.
	    if (this.state.height !== prevState.height) {
	      this.props.onHeightChange(this.state.height);
	    }
	  };
	
	  TextareaAutosize.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Remove any scheduled events to prevent manipulating the node after it's
	    // been unmounted.
	    this._clearNextFrame();
	    window.removeEventListener('resize', this._resizeComponent);
	  };
	
	  TextareaAutosize.prototype._clearNextFrame = function _clearNextFrame() {
	    if (this._onNextFrameActionId) {
	      clearNextFrameAction(this._onNextFrameActionId);
	    }
	  };
	
	  /**
	   * Put focus on a <textarea /> DOM element.
	   */
	  TextareaAutosize.prototype.focus = function focus() {
	    this._rootDOMNode.focus();
	  };
	
	  /**
	   * Shifts focus away from a <textarea /> DOM element.
	   */
	
	
	  TextareaAutosize.prototype.blur = function blur() {
	    this._rootDOMNode.blur();
	  };
	
	  _createClass(TextareaAutosize, [{
	    key: 'value',
	
	
	    /**
	     * Read the current value of <textarea /> from DOM.
	     */
	    get: function get() {
	      return this._rootDOMNode.value;
	    }
	
	    /**
	     * Set the current value of <textarea /> DOM node.
	     */
	    ,
	    set: function set(val) {
	      this._rootDOMNode.value = val;
	    }
	
	    /**
	     * Read the current selectionStart of <textarea /> from DOM.
	     */
	
	  }, {
	    key: 'selectionStart',
	    get: function get() {
	      return this._rootDOMNode.selectionStart;
	    }
	
	    /**
	     * Set the current selectionStart of <textarea /> DOM node.
	     */
	    ,
	    set: function set(selectionStart) {
	      this._rootDOMNode.selectionStart = selectionStart;
	    }
	
	    /**
	     * Read the current selectionEnd of <textarea /> from DOM.
	     */
	
	  }, {
	    key: 'selectionEnd',
	    get: function get() {
	      return this._rootDOMNode.selectionEnd;
	    }
	
	    /**
	     * Set the current selectionEnd of <textarea /> DOM node.
	     */
	    ,
	    set: function set(selectionEnd) {
	      this._rootDOMNode.selectionEnd = selectionEnd;
	    }
	  }]);
	
	  return TextareaAutosize;
	}(_react2.default.Component);
	
	TextareaAutosize.propTypes = {
	  /**
	   * Current textarea value.
	   */
	  value: _propTypes2.default.string,
	
	  /**
	   * Callback on value change.
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * Callback on height changes.
	   */
	  onHeightChange: _propTypes2.default.func,
	
	  /**
	   * Try to cache DOM measurements performed by component so that we don't
	   * touch DOM when it's not needed.
	   *
	   * This optimization doesn't work if we dynamically style <textarea />
	   * component.
	   */
	  useCacheForDOMMeasurements: _propTypes2.default.bool,
	
	  /**
	   * Minimal numbder of rows to show.
	   */
	  rows: _propTypes2.default.number,
	
	  /**
	   * Alias for `rows`.
	   */
	  minRows: _propTypes2.default.number,
	
	  /**
	   * Maximum number of rows to show.
	   */
	  maxRows: _propTypes2.default.number,
	
	  /**
	   * Allows an owner to retrieve the DOM node.
	   */
	  inputRef: _propTypes2.default.func
	};
	TextareaAutosize.defaultProps = {
	  onChange: noop,
	  onHeightChange: noop,
	  useCacheForDOMMeasurements: false
	};
	exports.default = TextareaAutosize;
	
	
	function onNextFrame(cb) {
	  if (window.requestAnimationFrame) {
	    return window.requestAnimationFrame(cb);
	  }
	  return window.setTimeout(cb, 1);
	}
	
	function clearNextFrameAction(nextFrameId) {
	  if (window.cancelAnimationFrame) {
	    window.cancelAnimationFrame(nextFrameId);
	  } else {
	    window.clearTimeout(nextFrameId);
	  }
	}

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	FullCalendar Scheduler v5.11.5
	Docs & License: https://fullcalendar.io/scheduler
	(c) 2022 Adam Shaw
	*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var common = __webpack_require__(70);
	
	var RELEASE_DATE = '2023-05-08'; // for Scheduler
	var UPGRADE_WINDOW = 365 + 7; // days. 1 week leeway, for tz shift reasons too
	var INVALID_LICENSE_URL = 'http://fullcalendar.io/docs/schedulerLicenseKey#invalid';
	var OUTDATED_LICENSE_URL = 'http://fullcalendar.io/docs/schedulerLicenseKey#outdated';
	var PRESET_LICENSE_KEYS = [
	    'GPL-My-Project-Is-Open-Source',
	    'CC-Attribution-NonCommercial-NoDerivatives',
	];
	var CSS = {
	    position: 'absolute',
	    zIndex: 99999,
	    bottom: '1px',
	    left: '1px',
	    background: '#eee',
	    borderColor: '#ddd',
	    borderStyle: 'solid',
	    borderWidth: '1px 1px 0 0',
	    padding: '2px 4px',
	    fontSize: '12px',
	    borderTopRightRadius: '3px',
	};
	function buildLicenseWarning(context) {
	    var key = context.options.schedulerLicenseKey;
	    var currentUrl = typeof window !== 'undefined' ? window.location.href : '';
	    if (!isImmuneUrl(currentUrl)) {
	        var status_1 = processLicenseKey(key);
	        if (status_1 !== 'valid') {
	            return (common.createElement("div", { className: "fc-license-message", style: CSS }, (status_1 === 'outdated') ? (common.createElement(common.Fragment, null,
	                'Your license key is too old to work with this version. ',
	                common.createElement("a", { href: OUTDATED_LICENSE_URL }, "More Info"))) : (common.createElement(common.Fragment, null,
	                'Your license key is invalid. ',
	                common.createElement("a", { href: INVALID_LICENSE_URL }, "More Info")))));
	        }
	    }
	    return null;
	}
	/*
	This decryption is not meant to be bulletproof. Just a way to remind about an upgrade.
	*/
	function processLicenseKey(key) {
	    if (PRESET_LICENSE_KEYS.indexOf(key) !== -1) {
	        return 'valid';
	    }
	    var parts = (key || '').match(/^(\d+)-fcs-(\d+)$/);
	    if (parts && (parts[1].length === 10)) {
	        var purchaseDate = new Date(parseInt(parts[2], 10) * 1000);
	        var releaseDate = new Date(common.config.mockSchedulerReleaseDate || RELEASE_DATE);
	        if (common.isValidDate(releaseDate)) { // token won't be replaced in dev mode
	            var minPurchaseDate = common.addDays(releaseDate, -UPGRADE_WINDOW);
	            if (minPurchaseDate < purchaseDate) {
	                return 'valid';
	            }
	            return 'outdated';
	        }
	    }
	    return 'invalid';
	}
	function isImmuneUrl(url) {
	    return /\w+:\/\/fullcalendar\.io\/|\/examples\/[\w-]+\.html$/.test(url);
	}
	
	var OPTION_REFINERS = {
	    schedulerLicenseKey: String,
	};
	
	var main = common.createPlugin({
	    optionRefiners: OPTION_REFINERS,
	    viewContainerAppends: [buildLicenseWarning],
	});
	
	exports.default = main;


/***/ },
/* 100 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.posiblePositions = exports.default = void 0;
	var positionMap = {
	  top: {
	    alias: 'top',
	    position: 'bc-tc',
	    offset: {
	      x: 1,
	      y: -1,
	      resetNumeric: 'x'
	    }
	  },
	  'bc-tc': {
	    alias: 'top',
	    position: 'bc-tc',
	    offset: {
	      x: 1,
	      y: -1,
	      resetNumeric: 'x'
	    }
	  },
	  'bl-tl': {
	    alias: 'topAlignedLeft',
	    position: 'bl-tl',
	    offset: {
	      x: 1,
	      y: -1,
	      resetNumeric: 'x'
	    }
	  },
	  'br-tr': {
	    alias: 'topAlignedRight',
	    position: 'br-tr',
	    offset: {
	      x: 1,
	      y: -1,
	      resetNumeric: 'x'
	    }
	  },
	  'br-tl': {
	    alias: 'topLeft',
	    position: 'br-tl',
	    offset: {
	      x: -1,
	      y: -1
	    }
	  },
	  right: {
	    position: 'lc-rc',
	    alias: 'right',
	    offset: {
	      x: 1,
	      y: 1,
	      resetNumeric: 'y'
	    }
	  },
	  'lc-rc': {
	    position: 'lc-rc',
	    alias: 'right',
	    offset: {
	      x: 1,
	      y: 1,
	      resetNumeric: 'y'
	    }
	  },
	  'tl-tr': {
	    position: 'tl-tr',
	    alias: 'rightAlignedTop',
	    offset: {
	      x: 1,
	      y: 1,
	      resetNumeric: 'y'
	    }
	  },
	  'bl-br': {
	    position: 'bl-br',
	    alias: 'rightAlignedBottom',
	    offset: {
	      x: 1,
	      y: 1,
	      resetNumeric: 'y'
	    }
	  },
	  'tl-br': {
	    position: 'tl-br',
	    alias: 'bottomRight',
	    offset: {
	      x: 1,
	      y: 1
	    }
	  },
	  bottom: {
	    position: 'tc-bc',
	    alias: 'bottom',
	    offset: {
	      x: 1,
	      y: 1,
	      resetNumeric: 'x'
	    }
	  },
	  'tc-bc': {
	    position: 'tc-bc',
	    alias: 'bottom',
	    offset: {
	      x: 1,
	      y: 1,
	      resetNumeric: 'x'
	    }
	  },
	  'tl-bl': {
	    position: 'tl-bl',
	    alias: 'bottomAlinedLeft',
	    offset: {
	      x: 1,
	      y: 1,
	      resetNumeric: 'x'
	    }
	  },
	  'tr-br': {
	    position: 'tr-br',
	    alias: 'bottomAlignedRight',
	    offset: {
	      x: 1,
	      y: 1,
	      resetNumeric: 'x'
	    }
	  },
	  'tr-tr': {
	    position: 'tr-tr',
	    offset: {
	      x: 1,
	      y: -1
	    }
	  },
	  'tr-bl': {
	    position: 'tr-bl',
	    alias: 'bottomLeft',
	    offset: {
	      x: -1,
	      y: 1
	    }
	  },
	  left: {
	    position: 'rc-lc',
	    alias: 'left',
	    offset: {
	      x: -1,
	      y: 1,
	      resetNumeric: 'y'
	    }
	  },
	  'rc-lc': {
	    position: 'rc-lc',
	    alias: 'left',
	    offset: {
	      x: -1,
	      y: 1,
	      resetNumeric: 'y'
	    }
	  },
	  'tr-tl': {
	    position: 'tr-tl',
	    alias: 'leftAlignedTop',
	    offset: {
	      x: -1,
	      y: 1,
	      resetNumeric: 'y'
	    }
	  },
	  'br-bl': {
	    position: 'br-bl',
	    alias: 'leftAlignedBottom',
	    offset: {
	      x: -1,
	      y: 1,
	      resetNumeric: 'y'
	    }
	  }
	};
	var posiblePositions = Object.keys(positionMap);
	exports.posiblePositions = posiblePositions;
	var _default = positionMap;
	exports.default = _default;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _matchesSelector = _interopRequireDefault(__webpack_require__(143));
	function selectParent(selector, node) {
	  node = node.parentElement;
	  while (node) {
	    if ((0, _matchesSelector.default)(node, selector)) {
	      return node;
	    }
	    node = node.parentElement;
	  }
	  return false;
	}
	var _default = selectParent;
	exports.default = _default;

/***/ },
/* 102 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function throttle(func, wait) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var context;
	  var args;
	  var result;
	  var timeout = null;
	  var previous = 0;
	  var later = function later() {
	    previous = options.leading === false ? 0 : Date.now();
	    timeout = null;
	    result = func.apply(context, args);
	    if (!timeout) {
	      context = null;
	      args = null;
	    }
	  };
	  return function () {
	    var now = Date.now();
	    if (!previous && options.leading === false) {
	      previous = now;
	    }
	    var remaining = wait - (now - previous);
	    context = this;
	    args = arguments;
	    if (remaining <= 0 || remaining > wait) {
	      if (timeout) {
	        clearTimeout(timeout);
	        timeout = null;
	      }
	      previous = now;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    } else if (!timeout && options.trailing !== false) {
	      timeout = setTimeout(later, remaining);
	    }
	    return result;
	  };
	}
	var _default = throttle;
	exports.default = _default;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_MS_BROWSER = exports.IS_IE = exports.IS_FF = exports.IS_EDGE = void 0;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var ua = globalObject.navigator ? globalObject.navigator.userAgent || '' : '';
	var IS_EDGE = ua.indexOf('Edge/') !== -1;
	exports.IS_EDGE = IS_EDGE;
	var IS_MS_BROWSER = IS_EDGE || ua.indexOf('Trident') !== -1;
	exports.IS_MS_BROWSER = IS_MS_BROWSER;
	var IS_IE = IS_MS_BROWSER && !IS_EDGE;
	exports.IS_IE = IS_IE;
	var IS_FF = ua.toLowerCase().indexOf('firefox') > -1;
	exports.IS_FF = IS_FF;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IS_MS_BROWSER = exports.IS_IE = exports.IS_EDGE = void 0;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var ua = globalObject.navigator ? globalObject.navigator.userAgent || '' : '';
	var IS_EDGE = ua.indexOf('Edge/') !== -1;
	exports.IS_EDGE = IS_EDGE;
	var IS_MS_BROWSER = IS_EDGE || ua.indexOf('Trident') !== -1;
	exports.IS_MS_BROWSER = IS_MS_BROWSER;
	var IS_IE = IS_MS_BROWSER && !IS_EDGE;
	exports.IS_IE = IS_IE;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = __webpack_require__(2);
	var _default = function _default(defaultValue, theContext, name) {
	  var context = (0, _react.useContext)(theContext);
	  if (context.state[name] !== undefined) {
	    defaultValue = context.state[name];
	  }
	  var _useState = (0, _react.useState)(defaultValue),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    value = _useState2[0],
	    setValue = _useState2[1];
	  return [value, function (newValue) {
	    if (typeof newValue === 'function') {
	      newValue = newValue(value);
	    }
	    context.state[name] = newValue;
	    setValue(newValue);
	  }];
	};
	exports.default = _default;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _NotifyResize = __webpack_require__(84);
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _toMoment = _interopRequireDefault(__webpack_require__(40));
	var _Clock$propTypes;
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var MINUTES = Array.apply(void 0, (0, _toConsumableArray2.default)(new Array(60))).map(function (_, index) {
	  return index;
	});
	var toUpperFirst = function toUpperFirst(str) {
	  return str ? str.charAt(0).toUpperCase() + str.substr(1) : '';
	};
	var transformStyle = {
	  transform: ''
	};
	var rotateTickStyle = function rotateTickStyle(tick, _ref, totalSize, offset) {
	  var width = _ref.width,
	    height = _ref.height;
	  var result = (0, _assign.default)({}, transformStyle);
	  var deg = tick * 6;
	  var transform = "translate3d(".concat(-width / 2, "px, ").concat(-height / 2, "px, 0px) ") + "rotate(".concat(deg, "deg) translate3d(0px, -").concat(offset, "px, 0px)");
	  Object.keys(result).forEach(function (name) {
	    result[name] = transform;
	  });
	  return result;
	};
	var Clock = function (_Component) {
	  (0, _inherits2.default)(Clock, _Component);
	  var _super = _createSuper(Clock);
	  function Clock(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, Clock);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
	      if (prevProps.run !== _this.props.run || prevProps.defaultSeconds !== _this.props.defaultSeconds || prevProps.defaultTime !== _this.props.defaultTime) {
	        var prevRun = _this.shouldRun(prevProps);
	        var currentRun = _this.shouldRun(_this.props);
	        if (!prevRun && currentRun) {
	          _this.start();
	        } else if (prevRun && !currentRun) {
	          _this.stop();
	        }
	      }
	    });
	    var time;
	    var seconds;
	    if (props.defaultSeconds) {
	      seconds = props.defaultSeconds == true ? Date.now() / 1000 : +props.defaultSeconds;
	    }
	    if (props.defaultTime) {
	      time = props.defaultTime == true ? Date.now() : +props.defaultTime;
	    }
	    _this.state = {};
	    if (seconds !== undefined) {
	      _this.state.seconds = seconds;
	      _this.state.defaultSeconds = seconds;
	    }
	    if (time !== undefined) {
	      _this.state.time = time;
	      _this.state.defaultTime = time;
	    }
	    return _this;
	  }
	  (0, _createClass2.default)(Clock, [{
	    key: "shouldRun",
	    value: function shouldRun(props) {
	      props = props || this.props;
	      if (props.run === false) {
	        return false;
	      }
	      return !!(props.defaultSeconds || props.defaultTime);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.shouldRun(this.props)) {
	        this.start();
	      }
	      if (this.props.size == 'auto') {
	        this.setState({
	          rendered: true
	        });
	      }
	    }
	  }, {
	    key: "start",
	    value: function start() {
	      this.startTime = Date.now ? Date.now() : +new Date();
	      this.run();
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      if (this.timeoutId) {
	        clearTimeout(this.timeoutId);
	      }
	    }
	  }, {
	    key: "run",
	    value: function run() {
	      var _this2 = this;
	      this.timeoutId = setTimeout(function () {
	        _this2.update();
	        _this2.run();
	      }, this.props.updateInterval);
	    }
	  }, {
	    key: "update",
	    value: function update() {
	      var now = Date.now ? Date.now() : +new Date();
	      var diff = now - this.startTime;
	      var seconds = this.getPropsSeconds();
	      if (seconds !== undefined) {
	        this.setSeconds(seconds + diff / 1000);
	        return;
	      }
	      var time = this.getPropsTime();
	      this.setTime(time + diff);
	    }
	  }, {
	    key: "setSeconds",
	    value: function setSeconds(seconds) {
	      this.setState({
	        seconds: seconds
	      });
	      if (this.props.onSecondsChange) {
	        this.props.onSecondsChange(seconds);
	      }
	    }
	  }, {
	    key: "setTime",
	    value: function setTime(time) {
	      this.setState({
	        time: time
	      });
	      if (this.props.onTimeChange) {
	        this.props.onTimeChange(time);
	      }
	    }
	  }, {
	    key: "getPropsTime",
	    value: function getPropsTime() {
	      return this.props.time || this.state.defaultTime || 0;
	    }
	  }, {
	    key: "getPropsSeconds",
	    value: function getPropsSeconds() {
	      return this.props.seconds || this.state.defaultSeconds;
	    }
	  }, {
	    key: "getSeconds",
	    value: function getSeconds() {
	      return this.state.seconds || this.getPropsSeconds();
	    }
	  }, {
	    key: "getTime",
	    value: function getTime() {
	      return this.state.time || this.getPropsTime();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.p = (0, _assign.default)({}, this.props);
	      var size = props.size;
	      if (size == 'auto') {
	        this.ignoreRender = false;
	        if (!this.state.rendered) {
	          this.ignoreRender = true;
	        }
	        size = props.size = this.state.size;
	      }
	      var valueSeconds = this.getSeconds();
	      var valueTime = this.getTime();
	      var width = size;
	      var height = size;
	      var className = (0, _join.default)(props.className, props.rootClassName, "".concat(props.rootClassName, "--theme-").concat(props.theme));
	      var seconds;
	      var minutes;
	      var hours;
	      if (valueSeconds != undefined) {
	        seconds = Math.floor(valueSeconds % 60);
	        minutes = valueSeconds / 60 % 60;
	        hours = valueSeconds / 3600 % 24;
	      } else {
	        var mom = (0, _toMoment.default)(valueTime);
	        seconds = mom.seconds();
	        minutes = mom.minutes() + seconds / 60;
	        hours = mom.hours() + minutes / 60;
	      }
	      hours *= 5;
	      var defaultStyle = {};
	      if (props.color) {
	        defaultStyle.borderColor = props.color;
	      }
	      var style = (0, _assign.default)(defaultStyle, props.style, {
	        width: width,
	        height: height,
	        borderWidth: props.borderWidth
	      });
	      var divProps = (0, _assign.default)({}, props);
	      delete divProps.rootClassName;
	      delete divProps.bigTickHeight;
	      delete divProps.bigTickOffset;
	      delete divProps.bigTickWidth;
	      delete divProps.borderColor;
	      delete divProps.borderWidth;
	      delete divProps.centerOverlaySize;
	      delete divProps.centerSize;
	      delete divProps.cleanup;
	      delete divProps.defaultSeconds;
	      delete divProps.defaultTime;
	      delete divProps.handHeight;
	      delete divProps.handOffset;
	      delete divProps.handWidth;
	      delete divProps.hourHandDiff;
	      delete divProps.isDatePickerClock;
	      delete divProps.minuteHandDiff;
	      delete divProps.seconds;
	      delete divProps.secondHandDiff;
	      delete divProps.secondHandWidth;
	      delete divProps.showHoursHand;
	      delete divProps.showMinutesHand;
	      delete divProps.showSecondsHand;
	      delete divProps.showSmallTicks;
	      delete divProps.smallTickHeight;
	      delete divProps.smallTickOffset;
	      delete divProps.smallTickWidth;
	      delete divProps.theme;
	      delete divProps.time;
	      delete divProps.tickHeight;
	      delete divProps.tickOffset;
	      delete divProps.tickWidth;
	      delete divProps.updateInterval;
	      delete divProps.rootClassName;
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(divProps);
	      }
	      return _react.default.createElement("div", _objectSpread(_objectSpread({}, divProps), {}, {
	        className: className,
	        style: style
	      }), this.renderCenter(), this.renderHourHand(hours), this.renderMinuteHand(minutes), this.renderSecondHand(seconds), this.renderCenterOverlay(), MINUTES.map(this.renderTick), this.props.size == 'auto' && _react.default.createElement(_NotifyResize.NotifyResize, {
	        notifyOnMount: true,
	        onResize: this.onResize
	      }));
	    }
	  }, {
	    key: "renderCenter",
	    value: function renderCenter() {
	      var props = this.props;
	      var centerSize = props.centerSize || (props.bigTickHeight || props.tickHeight) * 3;
	      return _react.default.createElement("div", {
	        className: "".concat(props.rootClassName, "-center"),
	        style: {
	          width: centerSize,
	          height: centerSize
	        }
	      });
	    }
	  }, {
	    key: "renderCenterOverlay",
	    value: function renderCenterOverlay() {
	      var props = this.props;
	      var centerOverlaySize = props.centerOverlaySize || props.handWidth * 4;
	      return _react.default.createElement("div", {
	        className: "".concat(props.rootClassName, "-overlay"),
	        style: {
	          width: centerOverlaySize,
	          height: centerOverlaySize,
	          borderWidth: props.handWidth
	        }
	      });
	    }
	  }, {
	    key: "onResize",
	    value: function onResize(_ref2) {
	      var width = _ref2.width,
	        height = _ref2.height;
	      if (width != height) {
	        console.warn("Clock width != height. Please make sure it's a square.");
	      }
	      this.setState({
	        size: width
	      });
	    }
	  }, {
	    key: "renderSecondHand",
	    value: function renderSecondHand(value) {
	      return this.props.showSecondsHand && this.renderHand('second', value);
	    }
	  }, {
	    key: "renderMinuteHand",
	    value: function renderMinuteHand(value) {
	      return this.props.showMinutesHand && this.renderHand('minute', value);
	    }
	  }, {
	    key: "renderHourHand",
	    value: function renderHourHand(value) {
	      return this.props.showHoursHand && this.renderHand('hour', value);
	    }
	  }, {
	    key: "renderHand",
	    value: function renderHand(name, value) {
	      if (this.ignoreRender) {
	        return null;
	      }
	      var props = this.p;
	      var size = props.size,
	        borderWidth = props.borderWidth;
	      var height = props["".concat(name, "HandHeight")] || props.handHeight || size / 2 - props["".concat(name, "HandDiff")] / 2;
	      var width = props["".concat(name, "HandWidth")] || props.handWidth || props.tickWidth;
	      var offset = props["".concat(name, "HandOffset")] || props.handOffset;
	      if (!offset && offset != 0) {
	        offset = 5;
	      }
	      var style = rotateTickStyle(value, {
	        width: width,
	        height: height
	      }, size - borderWidth, height / 2 - offset);
	      style.width = width;
	      style.height = height;
	      if (props.color) {
	        style.background = props.color;
	      }
	      var className = (0, _join.default)("".concat(props.rootClassName, "-hand"), "".concat(props.rootClassName, "-hand-").concat(name));
	      var renderName = "render".concat(toUpperFirst(name), "Hand");
	      if (props[renderName]) {
	        return props[renderName]({
	          key: name,
	          className: className,
	          style: style
	        });
	      }
	      return _react.default.createElement("div", {
	        key: name,
	        className: className,
	        style: style
	      });
	    }
	  }, {
	    key: "renderTick",
	    value: function renderTick(tick) {
	      if (this.ignoreRender) {
	        return null;
	      }
	      var _this$p = this.p,
	        size = _this$p.size,
	        borderWidth = _this$p.borderWidth,
	        tickWidth = _this$p.tickWidth,
	        smallTickWidth = _this$p.smallTickWidth,
	        bigTickWidth = _this$p.bigTickWidth,
	        tickHeight = _this$p.tickHeight,
	        smallTickHeight = _this$p.smallTickHeight,
	        bigTickHeight = _this$p.bigTickHeight,
	        tickOffset = _this$p.tickOffset,
	        smallTickOffset = _this$p.smallTickOffset,
	        bigTickOffset = _this$p.bigTickOffset,
	        rootClassName = _this$p.rootClassName;
	      var small = !!(tick % 5);
	      var sizeName = small ? 'small' : 'big';
	      if (small && !this.props.showSmallTicks) {
	        return false;
	      }
	      var className = (0, _join.default)("".concat(rootClassName, "-tick"), "".concat(rootClassName, "-tick--").concat(sizeName));
	      var offset = small ? smallTickOffset || tickOffset : bigTickOffset || tickOffset;
	      var tWidth = small ? smallTickWidth || tickWidth : bigTickWidth || tickWidth;
	      var tHeight = small ? smallTickHeight || tickHeight : bigTickHeight || tickHeight;
	      var totalSize = size - borderWidth;
	      var style = rotateTickStyle(tick, {
	        width: tWidth,
	        height: tHeight
	      }, totalSize, totalSize / 2 - (tHeight / 2 + offset));
	      style.height = tHeight;
	      style.width = tWidth;
	      if (this.props.color) {
	        style.background = this.props.color;
	      }
	      if (this.props.renderTick) {
	        return this.props.renderTick({
	          tick: tick,
	          className: className,
	          style: style
	        });
	      }
	      return _react.default.createElement("div", {
	        key: tick,
	        className: className,
	        style: style
	      });
	    }
	  }]);
	  return Clock;
	}(_reactClass.default);
	exports.default = Clock;
	Clock.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__clock',
	  centerSize: null,
	  centerOverlaySize: null,
	  size: 120,
	  updateInterval: 1000,
	  theme: 'default',
	  showSecondsHand: true,
	  showHoursHand: true,
	  showMinutesHand: true,
	  handWidth: 2,
	  secondHandWidth: 1,
	  handOffset: 10,
	  hourHandDiff: 35,
	  minuteHandDiff: 25,
	  secondHandDiff: 10,
	  tickWidth: 1,
	  bigTickWidth: 2,
	  tickOffset: 2,
	  smallTickHeight: 6,
	  bigTickHeight: 10,
	  color: '',
	  borderWidth: 0,
	  showSmallTicks: true,
	  isDatePickerClock: true
	};
	Clock.propTypes = (_Clock$propTypes = {
	  rootClassName: _propTypes.default.string,
	  centerSize: _propTypes.default.number,
	  centerOverlaySize: _propTypes.default.number,
	  defaultSeconds: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  seconds: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  defaultTime: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  time: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  theme: _propTypes.default.string,
	  showSecondsHand: _propTypes.default.bool,
	  showHoursHand: _propTypes.default.bool,
	  showMinutesHand: _propTypes.default.bool,
	  run: _propTypes.default.bool,
	  updateInterval: _propTypes.default.number,
	  handWidth: _propTypes.default.number,
	  secondHandWidth: _propTypes.default.number,
	  handOffset: _propTypes.default.number,
	  bigTickOffset: _propTypes.default.number,
	  hourHandDiff: _propTypes.default.number,
	  minuteHandDiff: _propTypes.default.number,
	  secondHandDiff: _propTypes.default.number,
	  borderColor: _propTypes.default.string,
	  handHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  tickWidth: _propTypes.default.number,
	  bigTickWidth: _propTypes.default.number,
	  smallTickWidth: _propTypes.default.number,
	  tickOffset: _propTypes.default.number,
	  smallTickOffset: _propTypes.default.number,
	  smallTickHeight: _propTypes.default.number,
	  bigTickHeight: _propTypes.default.number,
	  tickHeight: _propTypes.default.number,
	  color: _propTypes.default.string,
	  borderWidth: _propTypes.default.number,
	  showSmallTicks: _propTypes.default.bool,
	  isDatePickerClock: _propTypes.default.bool,
	  renderTick: _propTypes.default.func,
	  onSecondsChange: _propTypes.default.func,
	  onTimeChange: _propTypes.default.func
	}, (0, _defineProperty2.default)(_Clock$propTypes, "onTimeChange", _propTypes.default.func), (0, _defineProperty2.default)(_Clock$propTypes, "cleanup", _propTypes.default.func), _Clock$propTypes);

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var InovuaInlineBlock = function (_Component) {
	  (0, _inherits2.default)(InovuaInlineBlock, _Component);
	  var _super = _createSuper(InovuaInlineBlock);
	  function InovuaInlineBlock() {
	    (0, _classCallCheck2.default)(this, InovuaInlineBlock);
	    return _super.apply(this, arguments);
	  }
	  (0, _createClass2.default)(InovuaInlineBlock, [{
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var domProps = _objectSpread(_objectSpread({}, props), {}, {
	        style: _objectSpread({
	          display: 'inline-block'
	        }, props.style)
	      });
	      return _react.default.createElement("div", _objectSpread({}, props));
	    }
	  }]);
	  return InovuaInlineBlock;
	}(_react.Component);
	InovuaInlineBlock.defaultProps = {
	  style: {}
	};
	var _default = InovuaInlineBlock;
	exports.default = _default;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "NAV_KEYS", {
	  enumerable: true,
	  get: function get() {
	    return _navKeys.default;
	  }
	});
	exports.renderFooter = exports.default = void 0;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _moment = _interopRequireDefault(__webpack_require__(3));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _clampRange = _interopRequireDefault(__webpack_require__(237));
	var _toMoment = _interopRequireDefault(__webpack_require__(40));
	var _isInRange = _interopRequireDefault(__webpack_require__(239));
	var _NavBar = _interopRequireDefault(__webpack_require__(109));
	var _Footer = _interopRequireDefault(__webpack_require__(152));
	var _joinFunctions = _interopRequireDefault(__webpack_require__(82));
	var _assignDefined = _interopRequireDefault(__webpack_require__(62));
	var _BasicMonthView = _interopRequireWildcard(__webpack_require__(228));
	var _onKeyDown = _interopRequireDefault(__webpack_require__(234));
	var _navKeys = _interopRequireDefault(__webpack_require__(233));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var TODAY;
	var RENDER_DAY = function RENDER_DAY(props) {
	  var divProps = (0, _assign.default)({}, props);
	  delete divProps.date;
	  delete divProps.dateMoment;
	  delete divProps.day;
	  delete divProps.isAfterMaxDate;
	  delete divProps.isBeforeMinDate;
	  delete divProps.inRange;
	  delete divProps.timestamp;
	  return _react.default.createElement("div", _objectSpread({}, divProps));
	};
	var isDateInMinMax = function isDateInMinMax(timestamp, props) {
	  if (props.minDate && timestamp < props.minDate) {
	    return false;
	  }
	  if (props.maxDate && timestamp > props.maxDate) {
	    return false;
	  }
	  return true;
	};
	var _isValidActiveDate = function isValidActiveDate(timestamp, props) {
	  if (!props) {
	    throw new Error('props is mandatory in isValidActiveDate');
	  }
	  var dayProps = props.dayPropsMap[timestamp];
	  if (dayProps && dayProps.disabled) {
	    return false;
	  }
	  return isDateInMinMax(timestamp, props);
	};
	var _isInView = function isInView(mom, props) {
	  if (!props) {
	    throw new Error('props is mandatory in isInView');
	  }
	  var daysInView = props.daysInView;
	  return (0, _isInRange.default)(mom, {
	    range: daysInView,
	    inclusive: true
	  });
	};
	var prepareViewDate = function prepareViewDate(props, state) {
	  var viewDate = props.viewDate === undefined ? state.viewDate : props.viewDate;
	  if (!viewDate && props.moment) {
	    return (0, _toMoment.default)(props.moment);
	  }
	  return viewDate;
	};
	var prepareDate = function prepareDate(props, state) {
	  if (props.range) {
	    return null;
	  }
	  return props.date === undefined ? state.date : props.date;
	};
	var prepareRange = function prepareRange(props, state) {
	  if (props.moment) {
	    return null;
	  }
	  return props.partialRange ? props.range || state.range : state.range || props.range;
	};
	var prepareActiveDate = function prepareActiveDate(props, state) {
	  var fallbackDate = prepareDate(props, state) || (prepareRange(props, state) || [])[0];
	  var activeDate = props.activeDate === undefined ? state.activeDate || fallbackDate : props.activeDate;
	  var daysInView = props.daysInView;
	  if (activeDate && daysInView && props.constrainActiveInView) {
	    var activeMoment = this.toMoment(activeDate);
	    if (!_isInView(activeMoment, props)) {
	      var date = fallbackDate;
	      var dateMoment = this.toMoment(date);
	      if (date && _isInView(dateMoment, props) && _isValidActiveDate(+dateMoment, props)) {
	        return date;
	      }
	      return null;
	    }
	  }
	  return _isValidActiveDate(+activeDate, props) ? activeDate : null;
	};
	var _renderFooter = function renderFooter(props, buttonHandlers) {
	  if (!props.footer) {
	    return null;
	  }
	  buttonHandlers = buttonHandlers || props;
	  var renderFooter = props.renderFooter;
	  var footerFnProps = {
	    onTodayClick: buttonHandlers.onFooterTodayClick,
	    onClearClick: buttonHandlers.onFooterClearClick,
	    onOkClick: buttonHandlers.onFooterOkClick,
	    onCancelClick: buttonHandlers.onFooterCancelClick
	  };
	  var childFooter = _react.default.Children.toArray(props.children).filter(function (c) {
	    return c && c.props && c.props.isDatePickerFooter;
	  })[0];
	  var childFooterProps = childFooter ? childFooter.props : null;
	  if (childFooterProps) {
	    Object.keys(footerFnProps).forEach(function (key) {
	      if (childFooter.props[key]) {
	        footerFnProps[key] = (0, _joinFunctions.default)(footerFnProps[key], childFooter.props[key]);
	      }
	    });
	  }
	  var footerProps = (0, _assignDefined.default)({}, footerFnProps, {
	    key: 'footer_props_key',
	    todayButton: props.todayButton,
	    todayButtonText: props.todayButtonText,
	    clearButton: props.clearButton,
	    clearButtonText: props.clearButtonText,
	    theme: props.theme,
	    okButton: props.okButton === undefined && !props.insideField ? false : props.okButton,
	    okButtonText: props.okButtonText,
	    cancelButton: props.cancelButton === undefined && !props.insideField ? false : props.cancelButton,
	    cancelButtonText: props.cancelButtonText,
	    clearDate: props.clearDate || props.footerClearDate,
	    selectDate: props.selectDate
	  });
	  if (childFooter) {
	    if (renderFooter) {
	      return renderFooter((0, _assign.default)({}, childFooter.props, footerProps));
	    }
	    return _react.default.cloneElement(childFooter, footerProps);
	  }
	  if (renderFooter) {
	    return renderFooter(footerProps);
	  }
	  return _react.default.createElement(_Footer.default, _objectSpread({}, footerProps));
	};
	exports.renderFooter = _renderFooter;
	var MonthView = function (_Component) {
	  (0, _inherits2.default)(MonthView, _Component);
	  var _super = _createSuper(MonthView);
	  function MonthView(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, MonthView);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
	      if (prevProps.locale !== _this.props.locale || prevProps.dateFormat !== _this.props.dateFormat) {
	        _this.updateToMoment(_this.props);
	      }
	    });
	    _this.state = {
	      range: props.defaultRange,
	      date: props.defaultDate,
	      hoverRange: props.defaultHoverRange,
	      activeDate: props.defaultActiveDate,
	      viewDate: props.defaultViewDate
	    };
	    _this.monthViewRef = (0, _react.createRef)();
	    _this.updateToMoment(props);
	    return _this;
	  }
	  (0, _createClass2.default)(MonthView, [{
	    key: "isInView",
	    value: function isInView(mom, props) {
	      return _isInView(mom, props || this.p);
	    }
	  }, {
	    key: "updateToMoment",
	    value: function updateToMoment(props) {
	      this.toMoment = function (value, dateFormat) {
	        return (0, _toMoment.default)(value, {
	          locale: props.locale,
	          dateFormat: dateFormat || props.dateFormat
	        });
	      };
	      TODAY = +this.toMoment().startOf('day');
	    }
	  }, {
	    key: "prepareClassName",
	    value: function prepareClassName(props) {
	      return (0, _join.default)(props.className, props.rootClassName, "".concat(props.rootClassName, "--theme-").concat(props.theme), props.size === undefined ? "".concat(props.rootClassName, "-relative") : null);
	    }
	  }, {
	    key: "prepareProps",
	    value: function prepareProps(thisProps, state) {
	      var _this2 = this;
	      var props = this.p = (0, _assign.default)({}, thisProps);
	      state = state || this.state;
	      props.hoverRange = props.hoverRange === undefined ? this.state.hoverRange : props.hoverRange;
	      props.dayPropsMap = {};
	      props.className = this.prepareClassName && this.prepareClassName(props);
	      var minDate = props.minDate,
	        maxDate = props.maxDate;
	      if (minDate) {
	        props.minDateMoment = this.toMoment(props.minDate).startOf('day');
	        props.minDate = +props.minDateMoment;
	      }
	      if (maxDate) {
	        props.maxDateMoment = this.toMoment(props.maxDate);
	        props.maxDate = +props.maxDateMoment;
	      }
	      var date = prepareDate(props, state);
	      if (date) {
	        props.moment = props.moment || (props.range ? null : this.toMoment(date).startOf('day'));
	        props.timestamp = props.moment ? +props.moment : null;
	      }
	      props.viewMoment = props.viewMoment || this.toMoment(prepareViewDate(props, state));
	      if (props.constrainViewDate && props.minDate && props.viewMoment.isBefore(props.minDate)) {
	        props.minConstrained = true;
	        props.viewMoment = this.toMoment(props.minDate);
	      }
	      if (props.constrainViewDate && props.maxDate && props.viewMoment.isAfter(props.maxDate)) {
	        props.maxConstrained = true;
	        props.viewMoment = this.toMoment(props.maxDate);
	      }
	      props.viewMonthStart = this.toMoment(props.viewMoment).startOf('month');
	      props.viewMonthEnd = this.toMoment(props.viewMoment).endOf('month');
	      var range = prepareRange(props, state);
	      if (range) {
	        props.range = range.map(function (d) {
	          return _this2.toMoment(d).startOf('day');
	        });
	        props.rangeStart = state.rangeStart || (props.range.length == 1 ? props.range[0] : null);
	      }
	      props.daysInView = (0, _BasicMonthView.getDaysInMonthView)(props.viewMoment, props);
	      var activeDate = prepareActiveDate.call(this, props, state);
	      if (activeDate) {
	        props.activeDate = +this.toMoment(activeDate).startOf('day');
	      }
	      return props;
	    }
	  }, {
	    key: "getViewMoment",
	    value: function getViewMoment() {
	      return this.p.viewMoment;
	    }
	  }, {
	    key: "getViewSize",
	    value: function getViewSize() {
	      return 1;
	    }
	  }, {
	    key: "preparePrevNextClassName",
	    value: function preparePrevNextClassName(timestamp, props) {
	      var viewMonthStart = props.viewMonthStart,
	        viewMonthEnd = props.viewMonthEnd,
	        rootClassName = props.rootClassName;
	      var before = timestamp < viewMonthStart;
	      var after = timestamp > viewMonthEnd;
	      var thisMonth = !before && !after;
	      return (0, _join.default)(timestamp == TODAY && "".concat(rootClassName, "-day--today"), props.highlightToday && timestamp == TODAY && "".concat(rootClassName, "-day--today-highlight"), before && "".concat(rootClassName, "-day--prev-month"), before && !props.showDaysBeforeMonth && "".concat(rootClassName, "-day--hidden"), after && "".concat(rootClassName, "-day--next-month"), after && !props.showDaysAfterMonth && "".concat(rootClassName, "-day--hidden"), thisMonth && "".concat(rootClassName, "-day--this-month"));
	    }
	  }, {
	    key: "prepareMinMaxProps",
	    value: function prepareMinMaxProps(timestamp, props) {
	      var classes = [];
	      var rootClassName = this.props.rootClassName;
	      var isBeforeMinDate = false;
	      var isAfterMaxDate = false;
	      var minDate = props.minDate,
	        maxDate = props.maxDate;
	      if (minDate && timestamp < minDate) {
	        classes.push("".concat(rootClassName, "-day--disabled-min"));
	        isBeforeMinDate = true;
	      }
	      if (maxDate && timestamp > maxDate) {
	        classes.push("".concat(rootClassName, "-day--disabled-max"));
	        isAfterMaxDate = true;
	      }
	      return {
	        className: (0, _join.default)(classes),
	        isBeforeMinDate: isBeforeMinDate,
	        isAfterMaxDate: isAfterMaxDate,
	        disabled: isBeforeMinDate || isAfterMaxDate
	      };
	    }
	  }, {
	    key: "prepareWeekendClassName",
	    value: function prepareWeekendClassName(dateMoment, _ref) {
	      var highlightWeekends = _ref.highlightWeekends;
	      var weekDay = dateMoment.day();
	      var rootClassName = this.props.rootClassName;
	      if (weekDay === 0 || weekDay === 6) {
	        return (0, _join.default)("".concat(rootClassName, "-day--weekend"), highlightWeekends && "".concat(rootClassName, "-day--weekend-highlight"));
	      }
	      return '';
	    }
	  }, {
	    key: "prepareRangeProps",
	    value: function prepareRangeProps(dateMoment, props) {
	      var inRange = false;
	      var className = [];
	      var hoverRange = props.hoverRange,
	        range = props.range,
	        rootClassName = props.rootClassName;
	      if (range) {
	        var _range = (0, _slicedToArray2.default)(range, 2),
	          rangeStart = _range[0],
	          rangeEnd = _range[1];
	        if (!range.length) {
	          rangeStart = props.rangeStart;
	        }
	        var rangeName = 'range';
	        if (rangeStart && dateMoment.isSame(rangeStart)) {
	          className.push("".concat(rootClassName, "-day--").concat(rangeName, "-start"));
	          className.push("".concat(rootClassName, "-day--in-").concat(rangeName));
	          if (!rangeEnd) {
	            className.push("".concat(rootClassName, "-day--").concat(rangeName, "-end"));
	          }
	          inRange = true;
	        }
	        if (rangeEnd && dateMoment.isSame(rangeEnd)) {
	          className.push("".concat(rootClassName, "-day--").concat(rangeName, "-end"));
	          className.push("".concat(rootClassName, "-day--in-").concat(rangeName));
	          inRange = true;
	        }
	        if (!inRange && (0, _isInRange.default)(dateMoment, range)) {
	          className.push("".concat(rootClassName, "-day--in-").concat(rangeName));
	          inRange = true;
	        }
	      }
	      if (range && range.length < 2 && hoverRange && (0, _isInRange.default)(dateMoment, hoverRange)) {
	        className.push("".concat(rootClassName, "-day--in-hover-range"));
	        if (dateMoment.isSame(hoverRange[0])) {
	          className.push("".concat(rootClassName, "-day--hover-range-start"));
	        }
	        if (dateMoment.isSame(hoverRange[1])) {
	          className.push("".concat(rootClassName, "-day--hover-range-end"));
	        }
	      }
	      return {
	        inRange: inRange,
	        className: (0, _join.default)(className)
	      };
	    }
	  }, {
	    key: "prepareDayProps",
	    value: function prepareDayProps(renderDayProps, props) {
	      var timestamp = renderDayProps.timestamp,
	        dateMoment = renderDayProps.dateMoment,
	        className = renderDayProps.className;
	      props = props || this.p;
	      var _props = props,
	        rootClassName = _props.rootClassName;
	      var result = {};
	      var minMaxProps = this.prepareMinMaxProps(timestamp, props);
	      var rangeProps = this.prepareRangeProps(dateMoment, props);
	      var weekendClassName = this.prepareWeekendClassName(dateMoment, props);
	      var prevNextClassName = this.preparePrevNextClassName(timestamp, props);
	      var currentTimestamp = props.timestamp;
	      (0, _assign.default)(result, minMaxProps, rangeProps, {
	        children: _react.default.createElement("div", {
	          className: "".concat(rootClassName, "-day-text")
	        }, renderDayProps.day),
	        className: (0, _join.default)([minMaxProps.className, rangeProps.className, prevNextClassName, weekendClassName, timestamp == currentTimestamp ? "".concat(rootClassName, "-day--value") : null, timestamp == props.activeDate ? "".concat(rootClassName, "-day--active") : null, className])
	      });
	      if (!result.disabled && props.isDisabledDay) {
	        result.disabled = props.isDisabledDay(renderDayProps, props);
	      }
	      return result;
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      var domNode = this.getDOMNode();
	      if (domNode) {
	        domNode.focus();
	      }
	    }
	  }, {
	    key: "getDOMNode",
	    value: function getDOMNode() {
	      return this.monthViewRef.current;
	    }
	  }, {
	    key: "onDayTextMouseEnter",
	    value: function onDayTextMouseEnter(_ref2) {
	      var dateMoment = _ref2.dateMoment,
	        timestamp = _ref2.timestamp;
	      if (!this.state.focused) {
	        this.focus();
	      }
	      this.onActiveDateChange({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "renderDay",
	    value: function renderDay(renderProps) {
	      var props = this.p;
	      var _renderProps = renderProps,
	        dateMoment = _renderProps.dateMoment,
	        timestamp = _renderProps.timestamp;
	      var rootClassName = renderProps.rootClassName || this.props.rootClassName;
	      (0, _assign.default)(renderProps, this.prepareDayProps(renderProps, props));
	      if (props.range && props.highlightRangeOnMouseMove) {
	        renderProps.onMouseEnter = this.handleDayMouseEnter.bind(this, renderProps);
	      }
	      if (typeof props.onRenderDay === 'function') {
	        var newRenderProps = props.onRenderDay(renderProps);
	        if (newRenderProps !== undefined) {
	          renderProps = newRenderProps;
	        }
	      }
	      if (renderProps.disabled) {
	        renderProps.className = (0, _join.default)("".concat(rootClassName, "-day--disabled"), renderProps.className);
	      } else {
	        var eventParam = {
	          dateMoment: dateMoment,
	          timestamp: timestamp
	        };
	        var onClick = this.handleClick.bind(this, eventParam);
	        var prevOnClick = renderProps.onClick;
	        renderProps.onClick = prevOnClick ? function () {
	          prevOnClick.apply(void 0, arguments);
	          onClick.apply(void 0, arguments);
	        } : onClick;
	        if (props.activateOnHover && this.props.activeDate !== null) {
	          var onMouseEnter = this.onDayTextMouseEnter.bind(this, eventParam);
	          var prevOnMouseEnter = renderProps.onMouseEnter;
	          renderProps.onMouseEnter = prevOnMouseEnter ? function () {
	            prevOnMouseEnter.apply(void 0, arguments);
	            onMouseEnter.apply(void 0, arguments);
	          } : onMouseEnter;
	        }
	      }
	      props.dayPropsMap[timestamp] = renderProps;
	      var renderFunction = props.renderDay || RENDER_DAY;
	      var result = renderFunction(renderProps);
	      if (result === undefined) {
	        result = RENDER_DAY(renderProps);
	      }
	      return result;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.p = this.prepareProps(this.props);
	      var basicViewProps = (0, _assign.default)({}, props);
	      delete basicViewProps.activeDate;
	      delete basicViewProps.activateOnHover;
	      delete basicViewProps.arrows;
	      delete basicViewProps.cleanup;
	      delete basicViewProps.clockTabIndex;
	      delete basicViewProps.constrainViewDate;
	      delete basicViewProps.constrainActiveInView;
	      delete basicViewProps.dayPropsMap;
	      delete basicViewProps.date;
	      delete basicViewProps.defaultActiveDate;
	      delete basicViewProps.defaultDate;
	      delete basicViewProps.defaultRange;
	      delete basicViewProps.defaultViewDate;
	      delete basicViewProps.enableMonthDecadeView;
	      delete basicViewProps.focusOnFooterMouseDown;
	      delete basicViewProps.focusOnNavMouseDown;
	      delete basicViewProps.footer;
	      delete basicViewProps.footerClearDate;
	      delete basicViewProps.getTransitionTime;
	      delete basicViewProps.highlightRangeOnMouseMove;
	      delete basicViewProps.highlightToday;
	      delete basicViewProps.highlightWeekends;
	      delete basicViewProps.hoverRange;
	      delete basicViewProps.insideField;
	      delete basicViewProps.insideMultiView;
	      delete basicViewProps.isDatePicker;
	      delete basicViewProps.isDisabledDay;
	      delete basicViewProps.maxConstrained;
	      delete basicViewProps.maxDate;
	      delete basicViewProps.maxDateMoment;
	      delete basicViewProps.minConstrained;
	      delete basicViewProps.minDate;
	      delete basicViewProps.minDateMoment;
	      delete basicViewProps.navBarArrows;
	      delete basicViewProps.navNext;
	      delete basicViewProps.navigation;
	      delete basicViewProps.navigate;
	      delete basicViewProps.navOnDateClick;
	      delete basicViewProps.navPrev;
	      delete basicViewProps.onActiveDateChange;
	      delete basicViewProps.onChange;
	      delete basicViewProps.onHoverRangeChange;
	      delete basicViewProps.onRangeChange;
	      delete basicViewProps.onViewDateChange;
	      delete basicViewProps.onTransitionStart;
	      delete basicViewProps.partialRange;
	      delete basicViewProps.range;
	      delete basicViewProps.rangeStart;
	      delete basicViewProps.renderNavBar;
	      delete basicViewProps.select;
	      delete basicViewProps.showDaysAfterMonth;
	      delete basicViewProps.showDaysBeforeMonth;
	      delete basicViewProps.showClock;
	      delete basicViewProps.theme;
	      delete basicViewProps.viewDate;
	      delete basicViewProps.viewMonthEnd;
	      delete basicViewProps.viewMonthStart;
	      delete basicViewProps.okButtonText;
	      delete basicViewProps.okButton;
	      delete basicViewProps.enableMonthDecadeViewAnimation;
	      delete basicViewProps.showMonthDecadeViewAnimation;
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(basicViewProps);
	      }
	      return _react.default.createElement(_BasicMonthView.default, _objectSpread(_objectSpread({
	        key: "basic_month",
	        tabIndex: 0,
	        innerRef: this.monthViewRef
	      }, basicViewProps), {}, {
	        renderChildren: this.renderChildren,
	        onKeyDown: this.onViewKeyDown,
	        onFocus: this.onFocus,
	        onBlur: this.onBlur,
	        renderDay: this.renderDay,
	        viewMoment: props.viewMoment,
	        onMouseLeave: props.highlightRangeOnMouseMove ? this.handleViewMouseLeave : null
	      }));
	    }
	  }, {
	    key: "handleViewMouseLeave",
	    value: function handleViewMouseLeave(event) {
	      if (this.props.onMouseLeave) {
	        this.props.onMouseLeave(event);
	      }
	      if (this.state.hoverRange) {
	        this.setHoverRange(null);
	      }
	    }
	  }, {
	    key: "renderChildren",
	    value: function renderChildren(children) {
	      var props = this.p;
	      var navBar = this.renderNavBar(props);
	      var footer = this.renderFooter(props);
	      var result = [navBar, children, footer];
	      if (props.renderChildren) {
	        return props.renderChildren(result);
	      }
	      return result;
	    }
	  }, {
	    key: "focusFromFooter",
	    value: function focusFromFooter() {
	      if (!this.isFocused() && this.props.focusOnFooterMouseDown) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "onFooterTodayClick",
	    value: function onFooterTodayClick() {
	      this.focusFromFooter();
	      if (this.props.onFooterTodayClick) {
	        if (this.props.onFooterTodayClick() === false) {
	          return;
	        }
	      }
	      this.select({
	        dateMoment: this.toMoment(Date.now())
	      });
	    }
	  }, {
	    key: "onFooterClearClick",
	    value: function onFooterClearClick() {
	      this.focusFromFooter();
	      if (this.props.onFooterClearClick) {
	        if (this.props.onFooterClearClick() === false) {
	          return;
	        }
	      }
	      this.select({
	        dateMoment: null
	      });
	    }
	  }, {
	    key: "onFooterOkClick",
	    value: function onFooterOkClick() {
	      this.focusFromFooter();
	      if (this.props.onFooterOkClick) {
	        this.props.onFooterOkClick();
	      }
	    }
	  }, {
	    key: "onFooterCancelClick",
	    value: function onFooterCancelClick() {
	      if (this.props.onFooterCancelClick) {
	        this.props.onFooterCancelClick();
	      }
	    }
	  }, {
	    key: "renderFooter",
	    value: function renderFooter(props) {
	      return _renderFooter((0, _assign.default)({}, props, {
	        selectDate: this.select,
	        owner: this
	      }), this);
	    }
	  }, {
	    key: "renderNavBar",
	    value: function renderNavBar(props) {
	      var _this3 = this;
	      var theme = props.theme;
	      var childNavBar = _react.default.Children.toArray(props.children).filter(function (c) {
	        return c && c.props && c.props.isDatePickerNavBar;
	      })[0];
	      var ref = function ref(navBar) {
	        _this3.navBar = navBar;
	      };
	      var okButtonText = props.okButtonText,
	        cancelButtonText = props.cancelButtonText,
	        locale = props.locale;
	      var defaultProps = (0, _assignDefined.default)({}, {
	        okButtonText: okButtonText,
	        cancelButtonText: cancelButtonText,
	        locale: locale
	      });
	      if (!childNavBar) {
	        if (props.navigation || props.renderNavBar) {
	          return this.renderNavBarComponent((0, _assignDefined.default)(_objectSpread(_objectSpread({}, defaultProps), {}, {
	            minDate: props.minDate,
	            maxDate: props.maxDate,
	            theme: theme,
	            secondary: true,
	            date: props.moment,
	            viewMoment: props.viewMoment,
	            onViewDateChange: this.onNavViewDateChange,
	            onMouseDown: this.onNavMouseDown,
	            arrows: props.navBarArrows,
	            ref: ref,
	            enableMonthDecadeViewAnimation: props.enableMonthDecadeViewAnimation,
	            showMonthDecadeViewAnimation: props.showMonthDecadeViewAnimation
	          }), {
	            enableMonthDecadeView: props.enableMonthDecadeView
	          }));
	        }
	        return null;
	      }
	      var navBarProps = (0, _assign.default)({}, childNavBar.props, (0, _assignDefined.default)(_objectSpread(_objectSpread({}, defaultProps), {}, {
	        viewMoment: props.viewMoment,
	        date: props.moment,
	        theme: theme,
	        ref: ref,
	        minDate: props.minDate,
	        maxDate: props.maxDate
	      }), {
	        enableMonthDecadeView: props.enableMonthDecadeView
	      }));
	      var prevOnViewDateChange = navBarProps.onViewDateChange;
	      var onViewDateChange = this.onViewDateChange;
	      if (prevOnViewDateChange) {
	        onViewDateChange = function onViewDateChange() {
	          prevOnViewDateChange.apply(void 0, arguments);
	          _this3.onNavViewDateChange.apply(_this3, arguments);
	        };
	      }
	      navBarProps.onViewDateChange = onViewDateChange;
	      var prevOnMouseDown = navBarProps.onMouseDown;
	      var onMouseDown = this.onNavMouseDown;
	      if (prevOnMouseDown) {
	        onMouseDown = function onMouseDown() {
	          prevOnMouseDown.apply(void 0, arguments);
	          _this3.onNavMouseDown.apply(_this3, arguments);
	        };
	      }
	      navBarProps.onMouseDown = onMouseDown;
	      if (navBarProps) {
	        return this.renderNavBarComponent(navBarProps);
	      }
	      return null;
	    }
	  }, {
	    key: "onNavMouseDown",
	    value: function onNavMouseDown(event) {
	      if (this.props.focusOnNavMouseDown && !this.isFocused()) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "renderNavBarComponent",
	    value: function renderNavBarComponent(navBarProps) {
	      if (this.props.renderNavBar) {
	        return this.props.renderNavBar(navBarProps);
	      }
	      return _react.default.createElement(_NavBar.default, _objectSpread({
	        key: "month_navBar",
	        showClock: this.props.showClock
	      }, navBarProps));
	    }
	  }, {
	    key: "isFocused",
	    value: function isFocused() {
	      return this.state.focused;
	    }
	  }, {
	    key: "onFocus",
	    value: function onFocus(event) {
	      this.setState({
	        focused: true
	      });
	      this.props.onFocus(event);
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur(event) {
	      this.setState({
	        focused: false
	      });
	      this.hideMonthDecadeView();
	      this.props.onBlur(event);
	    }
	  }, {
	    key: "showMonthDecadeView",
	    value: function showMonthDecadeView() {
	      if (this.navBar) {
	        this.navBar.showMonthDecadeView();
	      }
	    }
	  }, {
	    key: "hideMonthDecadeView",
	    value: function hideMonthDecadeView() {
	      if (this.navBar) {
	        this.navBar.hideMonthDecadeView();
	      }
	    }
	  }, {
	    key: "isMonthDecadeViewVisible",
	    value: function isMonthDecadeViewVisible() {
	      if (this.navBar) {
	        return this.navBar.isMonthDecadeViewVisible();
	      }
	      return false;
	    }
	  }, {
	    key: "tryNavBarKeyDown",
	    value: function tryNavBarKeyDown(event) {
	      if (this.navBar && this.navBar.getMonthDecadeView) {
	        var monthDecadeViewView = this.navBar.getMonthDecadeView();
	        if (monthDecadeViewView && monthDecadeViewView.onKeyDown) {
	          monthDecadeViewView.onKeyDown(event);
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: "onViewKeyDown",
	    value: function onViewKeyDown(event) {
	      if (this.tryNavBarKeyDown(event)) {
	        return;
	      }
	      return _onKeyDown.default.call(this, event);
	    }
	  }, {
	    key: "confirm",
	    value: function confirm(date, event) {
	      event.preventDefault();
	      if (this.props.confirm) {
	        return this.props.confirm(date, event);
	      }
	      var dateMoment = this.toMoment(date);
	      this.select({
	        dateMoment: dateMoment,
	        timestamp: +dateMoment
	      }, event);
	      return undefined;
	    }
	  }, {
	    key: "navigate",
	    value: function navigate(dir, event) {
	      var _this4 = this;
	      var props = this.p;
	      var getNavigationDate = function getNavigationDate(dir, date, dateFormat) {
	        var mom = _moment.default.isMoment(date) ? date : _this4.toMoment(date, dateFormat);
	        return typeof dir == 'function' ? dir(mom) : mom.add(dir, 'day');
	      };
	      if (props.navigate) {
	        return props.navigate(dir, event, getNavigationDate);
	      }
	      event.preventDefault();
	      if (props.activeDate) {
	        var nextMoment = getNavigationDate(dir, props.activeDate);
	        this.gotoViewDate({
	          dateMoment: nextMoment
	        });
	      }
	      return undefined;
	    }
	  }, {
	    key: "handleDayMouseEnter",
	    value: function handleDayMouseEnter(dayProps) {
	      var props = this.p;
	      var rangeStart = props.rangeStart,
	        range = props.range;
	      var partial = !!(rangeStart && range.length < 2);
	      if (partial) {
	        this.setHoverRange((0, _clampRange.default)([rangeStart, dayProps.dateMoment]));
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(_ref3, event) {
	      var timestamp = _ref3.timestamp,
	        dateMoment = _ref3.dateMoment;
	      var props = this.p;
	      if (props.minDate && timestamp < props.minDate) {
	        return;
	      }
	      if (props.maxDate && timestamp > props.maxDate) {
	        return;
	      }
	      event.target.value = timestamp;
	      this.select({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      }, event);
	    }
	  }, {
	    key: "select",
	    value: function select(_ref4, event) {
	      var dateMoment = _ref4.dateMoment,
	        timestamp = _ref4.timestamp;
	      if (dateMoment && timestamp === undefined) {
	        timestamp = +dateMoment;
	      }
	      if (this.props.select) {
	        return this.props.select({
	          dateMoment: dateMoment,
	          timestamp: timestamp
	        }, event);
	      }
	      if (!timestamp) {
	        timestamp = +dateMoment;
	      }
	      this.gotoViewDate({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	      var props = this.p;
	      var range = props.range;
	      if (range) {
	        this.selectRange({
	          dateMoment: dateMoment,
	          timestamp: timestamp
	        }, event);
	      } else {
	        this.onChange({
	          dateMoment: dateMoment,
	          timestamp: timestamp
	        }, event);
	      }
	      return undefined;
	    }
	  }, {
	    key: "selectRange",
	    value: function selectRange(_ref5, event) {
	      var dateMoment = _ref5.dateMoment,
	        timestamp = _ref5.timestamp;
	      var props = this.p;
	      var range = props.range;
	      var rangeStart = props.rangeStart;
	      if (dateMoment == null) {
	        this.setState({
	          rangeStart: null
	        });
	        this.onRangeChange([], event);
	        return;
	      }
	      if (!rangeStart) {
	        this.setState({
	          rangeStart: dateMoment
	        });
	        if (range.length == 2) {
	          this.onRangeChange([], event);
	        }
	      } else {
	        this.setState({
	          rangeStart: null
	        });
	        this.onRangeChange((0, _clampRange.default)([rangeStart, dateMoment]), event);
	      }
	    }
	  }, {
	    key: "format",
	    value: function format(mom) {
	      return mom == null ? '' : mom.format(this.props.dateFormat);
	    }
	  }, {
	    key: "setHoverRange",
	    value: function setHoverRange(hoverRange) {
	      if (this.props.hoverRange === undefined) {
	        this.setState({
	          hoverRange: hoverRange
	        });
	      }
	      if (this.props.onHoverRangeChange) {
	        this.props.onHoverRangeChange(hoverRange);
	      }
	    }
	  }, {
	    key: "onRangeChange",
	    value: function onRangeChange(range, event) {
	      var _this5 = this;
	      this.setState({
	        range: this.props.range === undefined ? range : null
	      });
	      this.setHoverRange(null);
	      if (this.props.onRangeChange) {
	        var newRange = range.map(function (m) {
	          var dateMoment = _this5.toMoment(m);
	          return {
	            dateString: dateMoment.format(_this5.props.dateFormat),
	            dateMoment: dateMoment,
	            timestamp: +dateMoment
	          };
	        });
	        var formatted = newRange.map(function (o) {
	          return o.dateString;
	        });
	        this.props.onRangeChange(formatted, newRange, event);
	      }
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(_ref6, event) {
	      var dateMoment = _ref6.dateMoment,
	        timestamp = _ref6.timestamp,
	        noCollapse = _ref6.noCollapse;
	      if (this.props.date === undefined) {
	        this.setState({
	          date: timestamp
	        });
	      }
	      if (this.props.onChange) {
	        var dateString = this.format(dateMoment);
	        this.props.onChange(dateString, {
	          dateMoment: dateMoment,
	          timestamp: timestamp,
	          dateString: dateString,
	          noCollapse: noCollapse
	        }, event);
	      }
	    }
	  }, {
	    key: "onNavViewDateChange",
	    value: function onNavViewDateChange(dateString, _ref7) {
	      var dateMoment = _ref7.dateMoment,
	        timestamp = _ref7.timestamp;
	      this.onViewDateChange({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "onViewDateChange",
	    value: function onViewDateChange(_ref8) {
	      var dateMoment = _ref8.dateMoment,
	        timestamp = _ref8.timestamp;
	      var minDate;
	      var maxDate;
	      if (this.p.minDateMoment) {
	        minDate = +this.toMoment(this.p.minDateMoment).startOf('month');
	      }
	      if (this.p.maxDateMoment) {
	        maxDate = +this.toMoment(this.p.maxDateMoment).endOf('month');
	      }
	      if (this.props.constrainViewDate && !isDateInMinMax(timestamp, {
	        minDate: minDate,
	        maxDate: maxDate
	      })) {
	        return;
	      }
	      if (this.props.viewDate === undefined && this.props.navOnDateClick) {
	        this.setState({
	          viewDate: timestamp
	        });
	      }
	      if (this.props.onViewDateChange) {
	        var dateString = this.format(dateMoment);
	        this.props.onViewDateChange(dateString, {
	          dateMoment: dateMoment,
	          dateString: dateString,
	          timestamp: timestamp
	        });
	      }
	    }
	  }, {
	    key: "isValidActiveDate",
	    value: function isValidActiveDate(date, props) {
	      return _isValidActiveDate(date, props || this.p);
	    }
	  }, {
	    key: "onActiveDateChange",
	    value: function onActiveDateChange(_ref9) {
	      var dateMoment = _ref9.dateMoment,
	        timestamp = _ref9.timestamp;
	      if (!_isValidActiveDate(timestamp, this.p)) {
	        return;
	      }
	      var props = this.p;
	      var range = props.range;
	      if (range && props.rangeStart) {
	        var newRange = (0, _clampRange.default)([props.rangeStart, dateMoment]);
	        if (props.partialRange) {
	          this.onRangeChange(newRange);
	        }
	        this.setState({
	          rangeStart: props.rangeStart,
	          range: newRange
	        });
	      }
	      if (this.props.activeDate === undefined) {
	        this.setState({
	          activeDate: timestamp
	        });
	      }
	      if (this.props.onActiveDateChange) {
	        var dateString = this.format(dateMoment);
	        this.props.onActiveDateChange(dateString, {
	          dateMoment: dateMoment,
	          timestamp: timestamp,
	          dateString: dateString
	        });
	      }
	    }
	  }, {
	    key: "gotoViewDate",
	    value: function gotoViewDate(_ref10) {
	      var dateMoment = _ref10.dateMoment,
	        timestamp = _ref10.timestamp;
	      if (!timestamp) {
	        timestamp = dateMoment == null ? null : +dateMoment;
	      }
	      this.onViewDateChange({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	      this.onActiveDateChange({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }]);
	  return MonthView;
	}(_reactClass.default);
	exports.default = MonthView;
	MonthView.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__month-view',
	  dateFormat: 'YYYY-MM-DD',
	  theme: 'default',
	  onBlur: function onBlur() {},
	  onFocus: function onFocus() {},
	  footerClearDate: null,
	  okButton: true,
	  partialRange: true,
	  activateOnHover: false,
	  constrainActiveInView: false,
	  showDaysBeforeMonth: true,
	  showDaysAfterMonth: true,
	  highlightWeekends: true,
	  highlightToday: true,
	  navOnDateClick: true,
	  navigation: true,
	  constrainViewDate: true,
	  highlightRangeOnMouseMove: false,
	  isDatePicker: true,
	  enableMonthDecadeView: true,
	  focusOnNavMouseDown: true,
	  focusOnFooterMouseDown: true,
	  enableMonthDecadeViewAnimation: true,
	  showMonthDecadeViewAnimation: 300
	};
	var DateType = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object, _propTypes.default.string]);
	MonthView.propTypes = {
	  rootClassName: _propTypes.default.string,
	  navOnDateClick: _propTypes.default.bool,
	  isDisabledDay: _propTypes.default.func,
	  onChange: _propTypes.default.func,
	  onViewDateChange: _propTypes.default.func,
	  onActiveDateChange: _propTypes.default.func,
	  dateFormat: _propTypes.default.string,
	  date: DateType,
	  theme: _propTypes.default.string,
	  onBlur: _propTypes.default.func,
	  onFocus: _propTypes.default.func,
	  footerClearDate: _propTypes.default.object,
	  partialRange: _propTypes.default.bool,
	  activateOnHover: _propTypes.default.bool,
	  constrainActiveInView: _propTypes.default.bool,
	  showDaysBeforeMonth: _propTypes.default.bool,
	  showDaysAfterMonth: _propTypes.default.bool,
	  highlightWeekends: _propTypes.default.bool,
	  highlightToday: _propTypes.default.bool,
	  navigation: _propTypes.default.bool,
	  constrainViewDate: _propTypes.default.bool,
	  highlightRangeOnMouseMove: _propTypes.default.bool,
	  isDatePicker: _propTypes.default.bool,
	  onRenderDay: _propTypes.default.func,
	  getTransitionTime: _propTypes.default.func,
	  cleanup: _propTypes.default.func,
	  navigate: _propTypes.default.func,
	  onRangeChange: _propTypes.default.func,
	  onHoverRangeChange: _propTypes.default.func,
	  renderNavBar: _propTypes.default.func,
	  select: _propTypes.default.func,
	  renderChildren: _propTypes.default.func,
	  onFooterTodayClick: _propTypes.default.func,
	  onFooterClearClick: _propTypes.default.func,
	  onFooterCancelClick: _propTypes.default.func,
	  onMouseLeave: _propTypes.default.any,
	  clockTabIndex: _propTypes.default.number,
	  index: _propTypes.default.number,
	  dayPropsMap: _propTypes.default.object,
	  insideMultiView: _propTypes.default.bool,
	  insideField: _propTypes.default.bool,
	  enableMonthDecadeView: _propTypes.default.bool,
	  focusOnNavMouseDown: _propTypes.default.bool,
	  focusOnFooterMouseDown: _propTypes.default.bool,
	  maxConstrained: _propTypes.default.bool,
	  minConstrained: _propTypes.default.bool,
	  enableMonthDecadeViewAnimation: _propTypes.default.bool,
	  showMonthDecadeViewAnimation: _propTypes.default.number,
	  disabled: _propTypes.default.bool,
	  footer: _propTypes.default.bool,
	  navBarArrows: _propTypes.default.shape({
	    prev: _propTypes.default.node,
	    next: _propTypes.default.node,
	    right: _propTypes.default.node,
	    left: _propTypes.default.node
	  }),
	  cancelButton: _propTypes.default.bool,
	  cancelButtonText: _propTypes.default.node,
	  okButton: _propTypes.default.bool,
	  okButtonText: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  showClock: _propTypes.default.bool,
	  defaultDate: DateType,
	  activeDate: DateType,
	  defaultActiveDate: DateType,
	  rangeStart: DateType,
	  range: _propTypes.default.arrayOf(DateType),
	  defaultRange: _propTypes.default.arrayOf(DateType),
	  hoverRange: _propTypes.default.arrayOf(DateType),
	  defaultHoverRange: _propTypes.default.arrayOf(DateType),
	  minDate: DateType,
	  maxDate: DateType,
	  viewDate: DateType,
	  defaultViewDate: DateType
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _Flex = __webpack_require__(41);
	var _InlineBlock = _interopRequireDefault(__webpack_require__(107));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _assignDefined = _interopRequireDefault(__webpack_require__(62));
	var _toMoment2 = _interopRequireDefault(__webpack_require__(40));
	var _MonthDecadeView = _interopRequireDefault(__webpack_require__(232));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var ARROWS = {
	  prev: _react.default.createElement("svg", {
	    width: "6",
	    height: "10",
	    viewBox: "0 0 6 10"
	  }, _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M2.197 5l2.865-2.866c.311-.31.311-.814 0-1.125-.31-.31-.814-.31-1.125 0L.477 4.47c-.293.294-.293.769 0 1.061l3.46 3.46c.311.311.815.311 1.125 0 .311-.31.311-.814 0-1.124L2.197 5z"
	  })),
	  next: _react.default.createElement("svg", {
	    width: "6",
	    height: "10",
	    viewBox: "0 0 6 10"
	  }, _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M3.803 5L.938 7.866c-.311.31-.311.814 0 1.125.31.31.814.31 1.125 0l3.46-3.46c.293-.294.293-.769 0-1.061l-3.46-3.46c-.311-.311-.815-.311-1.126 0-.31.31-.31.814 0 1.124L3.803 5z"
	  })),
	  right: _react.default.createElement("svg", {
	    width: "12",
	    height: "10",
	    viewBox: "0 0 12 10"
	  }, _react.default.createElement("g", {
	    fillRule: "evenodd"
	  }, _react.default.createElement("path", {
	    d: "M3.803 4.5L.938 7.366c-.311.31-.311.814 0 1.125.31.31.814.31 1.125 0l3.46-3.46c.293-.294.293-.769 0-1.061L2.063.51C1.751.198 1.247.198.936.51c-.31.31-.31.814 0 1.124L3.803 4.5zM9.803 4.5L6.937 7.366c-.31.31-.31.814 0 1.125.311.31.815.31 1.125 0l3.461-3.46c.293-.294.293-.769 0-1.061L8.063.51c-.311-.311-.815-.311-1.126 0-.31.31-.31.814 0 1.124L9.803 4.5z",
	    transform: "translate(0 .5)"
	  }))),
	  left: _react.default.createElement("svg", {
	    width: "12",
	    height: "10",
	    viewBox: "0 0 12 10"
	  }, _react.default.createElement("g", {
	    fillRule: "evenodd"
	  }, _react.default.createElement("path", {
	    d: "M3.803 4.5L.938 7.366c-.311.31-.311.814 0 1.125.31.31.814.31 1.125 0l3.46-3.46c.293-.294.293-.769 0-1.061L2.063.51C1.751.198 1.247.198.936.51c-.31.31-.31.814 0 1.124L3.803 4.5zM9.803 4.5L6.937 7.366c-.31.31-.31.814 0 1.125.311.31.815.31 1.125 0l3.461-3.46c.293-.294.293-.769 0-1.061L8.063.51c-.311-.311-.815-.311-1.126 0-.31.31-.31.814 0 1.124L9.803 4.5z",
	    transform: "rotate(180 6 4.75)"
	  })))
	};
	var NavBar = function (_Component) {
	  (0, _inherits2.default)(NavBar, _Component);
	  var _super = _createSuper(NavBar);
	  function NavBar(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, NavBar);
	    _this = _super.call(this, props);
	    _this.state = {
	      viewDate: props.defaultViewDate
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(NavBar, [{
	    key: "prepareViewDate",
	    value: function prepareViewDate(props) {
	      return props.viewDate === undefined ? this.state.viewDate : props.viewDate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.p = (0, _assign.default)({}, this.props);
	      var rootClassName = props.rootClassName,
	        index = props.index;
	      var viewMoment = props.viewMoment = props.viewMoment || this.toMoment(this.prepareViewDate(props));
	      props.monthDecadeViewEnabled = props.expandedMonthDecadeView || props.enableMonthDecadeView;
	      var secondary = props.secondary;
	      var className = (0, _join.default)(props.className, rootClassName, "".concat(rootClassName, "--theme-").concat(props.theme), "".concat(rootClassName, "--with-month-decade-view"));
	      var monthDecadeView = props.monthDecadeViewEnabled ? this.renderMonthDecadeView() : null;
	      var flexProps = (0, _assign.default)({}, props);
	      delete flexProps.rootClassName;
	      delete flexProps.arrows;
	      delete flexProps.doubleArrows;
	      delete flexProps.date;
	      delete flexProps.enableMonthDecadeView;
	      delete flexProps.monthDecadeViewEnabled;
	      delete flexProps.isDatePickerNavBar;
	      delete flexProps.minDate;
	      delete flexProps.maxDate;
	      delete flexProps.mainNavBar;
	      delete flexProps.multiView;
	      delete flexProps.navDateFormat;
	      delete flexProps.onNavClick;
	      delete flexProps.onUpdate;
	      delete flexProps.onViewDateChange;
	      delete flexProps.renderNavNext;
	      delete flexProps.renderNavPrev;
	      delete flexProps.secondary;
	      delete flexProps.theme;
	      delete flexProps.viewDate;
	      delete flexProps.viewMoment;
	      delete flexProps.showClock;
	      delete flexProps.enableMonthDecadeViewAnimation;
	      delete flexProps.showMonthDecadeViewAnimation;
	      delete flexProps.cancelButtonText;
	      delete flexProps.clearButtonText;
	      delete flexProps.okButtonText;
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	      return _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({
	        key: "navBar",
	        inline: true,
	        row: true
	      }, flexProps), {}, {
	        className: className
	      }), secondary && this.renderNav(-2, viewMoment, 'left'), this.renderNav(-1, viewMoment, 'prev'), _react.default.createElement(_Flex.Item, {
	        key: "month_year",
	        className: (0, _join.default)("".concat(rootClassName, "-date"), props.monthDecadeViewEnabled ? '' : "".concat(rootClassName, "-date-disabled")),
	        style: {
	          textAlign: 'center'
	        },
	        onMouseDown: props.monthDecadeViewEnabled ? this.toggleMonthDecadeView : null
	      }, this.renderNavDate(viewMoment)), this.renderNav(1, viewMoment, 'next'), secondary && this.renderNav(2, viewMoment, 'right'), monthDecadeView);
	    }
	  }, {
	    key: "renderMonthDecadeView",
	    value: function renderMonthDecadeView() {
	      var _this2 = this;
	      if (!this.state.monthDecadeView) {
	        return null;
	      }
	      var _this$p = this.p,
	        viewMoment = _this$p.viewMoment,
	        theme = _this$p.theme,
	        locale = _this$p.locale,
	        minDate = _this$p.minDate,
	        maxDate = _this$p.maxDate,
	        rootClassName = _this$p.rootClassName,
	        size = _this$p.size,
	        okButtonText = _this$p.okButtonText,
	        cancelButtonText = _this$p.cancelButtonText,
	        showClock = _this$p.showClock,
	        enableMonthDecadeViewAnimation = _this$p.enableMonthDecadeViewAnimation,
	        showMonthDecadeViewAnimation = _this$p.showMonthDecadeViewAnimation;
	      var className = (0, _join.default)("".concat(rootClassName, "-month-decade-view"), (size <= 1 || size === undefined) && "".concat(rootClassName, "-month-decade-view-month"), showClock && "".concat(rootClassName, "-month-decade-view-calendar"));
	      var modalClassName = (0, _join.default)("".concat(rootClassName, "-month-decade-view-modal"), enableMonthDecadeViewAnimation && "".concat(rootClassName, "-month-decade-view-show-animation"));
	      var modalWrapperClassName = size || size === undefined ? modalClassName : null;
	      var monthDecadeViewProps = (0, _assignDefined.default)({
	        defaultViewDate: viewMoment,
	        defaultDate: viewMoment,
	        ref: function ref(view) {
	          _this2.monthDecadeView = view;
	        },
	        focusDecadeView: false,
	        className: className,
	        theme: theme,
	        okButtonText: okButtonText,
	        cancelButtonText: cancelButtonText,
	        onOkClick: this.onMonthDecadeViewOk,
	        onCancelClick: this.onMonthDecadeViewCancel
	      }, {
	        minDate: minDate,
	        maxDate: maxDate,
	        locale: locale
	      });
	      if (this.props.renderMonthDecadeView) {
	        return this.props.renderMonthDecadeView(monthDecadeViewProps);
	      }
	      return _react.default.createElement("div", {
	        style: {
	          animationDuration: "".concat(showMonthDecadeViewAnimation, "ms")
	        },
	        className: modalWrapperClassName
	      }, _react.default.createElement(_MonthDecadeView.default, _objectSpread({}, monthDecadeViewProps)));
	    }
	  }, {
	    key: "toggleMonthDecadeView",
	    value: function toggleMonthDecadeView(event) {
	      if (this.isMonthDecadeViewVisible()) {
	        this.hideMonthDecadeView(event);
	      } else {
	        this.showMonthDecadeView(event);
	      }
	    }
	  }, {
	    key: "getMonthDecadeViewView",
	    value: function getMonthDecadeViewView() {
	      return this.monthDecadeView;
	    }
	  }, {
	    key: "isMonthDecadeViewVisible",
	    value: function isMonthDecadeViewVisible() {
	      return !!this.monthDecadeView;
	    }
	  }, {
	    key: "onMonthDecadeViewOk",
	    value: function onMonthDecadeViewOk(dateString, _ref) {
	      var dateMoment = _ref.dateMoment,
	        timestamp = _ref.timestamp;
	      this.hideMonthDecadeView();
	      this.onViewDateChange({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "onMonthDecadeViewCancel",
	    value: function onMonthDecadeViewCancel() {
	      this.hideMonthDecadeView();
	    }
	  }, {
	    key: "showMonthDecadeView",
	    value: function showMonthDecadeView(event) {
	      event.preventDefault();
	      this.setState({
	        monthDecadeView: true
	      });
	      if (this.props.onShowMonthDecadeView) {
	        this.props.onShowMonthDecadeView();
	      }
	    }
	  }, {
	    key: "hideMonthDecadeView",
	    value: function hideMonthDecadeView(event) {
	      if (event && event.preventDefault) {
	        event.preventDefault();
	      }
	      this.setState({
	        monthDecadeView: false
	      });
	      if (this.props.onHideMonthDecadeView) {
	        this.props.onHideMonthDecadeView();
	      }
	    }
	  }, {
	    key: "toMoment",
	    value: function toMoment(value, props) {
	      props = props || this.props;
	      return (0, _toMoment2.default)(value, {
	        locale: props.locale,
	        dateFormat: props.dateFormat
	      });
	    }
	  }, {
	    key: "renderNav",
	    value: function renderNav(dir, viewMoment, name) {
	      var props = this.p;
	      var disabled = dir < 0 ? props.prevDisabled : props.nextDisabled;
	      var secondary = Math.abs(dir) == 2;
	      if (dir < 0 && props.minDate) {
	        var gotoMoment = this.getGotoMoment(dir, viewMoment).endOf('month');
	        if (gotoMoment.isBefore(this.toMoment(props.minDate))) {
	          disabled = true;
	        }
	      }
	      if (dir > 0 && props.maxDate) {
	        var _gotoMoment = this.getGotoMoment(dir, viewMoment).startOf('month');
	        if (_gotoMoment.isAfter(this.toMoment(props.maxDate))) {
	          disabled = true;
	        }
	      }
	      if (this.state.monthDecadeView) {
	        disabled = true;
	      }
	      var rootClassName = props.rootClassName;
	      var className = (0, _join.default)("".concat(rootClassName, "-arrow"), "".concat(rootClassName, "-arrow--").concat(name), secondary && "".concat(rootClassName, "-secondary-arrow"), disabled && "".concat(rootClassName, "-arrow--disabled"));
	      var arrowClass = "".concat(rootClassName, "-arrows-pos");
	      var arrowDivClass = "".concat(rootClassName, "-arrows-div");
	      var arrow = props.arrows[dir] || props.arrows[name] || ARROWS[name];
	      var children;
	      var dirArrow = props.arrows[dir];
	      if (dirArrow) {
	        children = dirArrow;
	      } else {
	        var doubleArrows = dir < -1 ? arrow : dir > 1 ? arrow : null;
	        children = dir < 0 ? _react.default.createElement("div", {
	          className: arrowDivClass
	        }, secondary ? _react.default.createElement("div", {
	          className: arrowClass
	        }, doubleArrows) : _react.default.createElement("div", {
	          className: arrowClass
	        }, arrow)) : _react.default.createElement("div", {
	          className: arrowDivClass
	        }, secondary ? _react.default.createElement("div", {
	          className: arrowClass
	        }, doubleArrows) : _react.default.createElement("div", {
	          className: arrowClass
	        }, arrow));
	      }
	      var navProps = {
	        dir: dir,
	        name: name,
	        disabled: disabled,
	        onClick: !disabled ? this.onNavClick.bind(this, dir, viewMoment) : null,
	        className: className,
	        children: children
	      };
	      if (props.renderNav) {
	        return props.renderNav(navProps);
	      }
	      if (dir < 0 && props.renderNavPrev) {
	        return props.renderNavPrev(navProps);
	      }
	      if (dir > 0 && props.renderNavNext) {
	        return props.renderNavNext(navProps);
	      }
	      return _react.default.createElement(_InlineBlock.default, _objectSpread(_objectSpread({
	        key: name
	      }, navProps), {}, {
	        disabled: null,
	        name: null
	      }));
	    }
	  }, {
	    key: "getGotoMoment",
	    value: function getGotoMoment(dir, viewMoment) {
	      viewMoment = viewMoment || this.p.viewMoment;
	      var sign = dir < 0 ? -1 : 1;
	      var abs = Math.abs(dir);
	      var mom = this.toMoment(viewMoment);
	      mom.add(sign, abs == 1 ? 'month' : 'year');
	      return mom;
	    }
	  }, {
	    key: "onNavClick",
	    value: function onNavClick(dir, viewMoment, event) {
	      var props = this.props;
	      var dateMoment = this.toMoment(viewMoment);
	      if (props.onUpdate) {
	        dateMoment = props.onUpdate(dateMoment, dir);
	      } else {
	        var sign = dir < 0 ? -1 : 1;
	        var abs = Math.abs(dir);
	        dateMoment.add(sign, abs == 1 ? 'month' : 'year');
	      }
	      var timestamp = +dateMoment;
	      props.onNavClick(dir, viewMoment, event);
	      var disabled = dir < 0 ? props.prevDisabled : props.nextDisabled;
	      if (disabled) {
	        return;
	      }
	      this.onViewDateChange({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "renderNavDate",
	    value: function renderNavDate(viewMoment) {
	      var props = this.props;
	      var text = viewMoment.format(props.navDateFormat);
	      if (props.renderNavDate) {
	        return props.renderNavDate(viewMoment, text);
	      }
	      return text;
	    }
	  }, {
	    key: "onViewDateChange",
	    value: function onViewDateChange(_ref2) {
	      var dateMoment = _ref2.dateMoment,
	        timestamp = _ref2.timestamp;
	      if (this.props.viewDate === undefined) {
	        this.setState({
	          viewDate: timestamp
	        });
	      }
	      if (this.props.onViewDateChange) {
	        var dateString = dateMoment.format(this.props.dateFormat);
	        this.props.onViewDateChange(dateString, {
	          dateString: dateString,
	          dateMoment: dateMoment,
	          timestamp: timestamp
	        });
	      }
	    }
	  }]);
	  return NavBar;
	}(_reactClass.default);
	exports.default = NavBar;
	NavBar.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__nav-bar',
	  arrows: {},
	  doubleArrows: {},
	  theme: 'default',
	  isDatePickerNavBar: true,
	  navDateFormat: 'MMM YYYY',
	  enableMonthDecadeView: true,
	  onNavClick: function onNavClick(dir, viewMoment) {},
	  onViewDateChange: function onViewDateChange() {}
	};
	NavBar.propTypes = {
	  rootClassName: _propTypes.default.string,
	  secondary: _propTypes.default.bool,
	  showClock: _propTypes.default.bool,
	  enableMonthDecadeViewAnimation: _propTypes.default.bool,
	  showMonthDecadeViewAnimation: _propTypes.default.number,
	  renderNav: _propTypes.default.func,
	  renderNavPrev: _propTypes.default.func,
	  renderNavNext: _propTypes.default.func,
	  arrows: _propTypes.default.object,
	  doubleArrows: _propTypes.default.object,
	  navDateFormat: _propTypes.default.string,
	  onUpdate: _propTypes.default.func,
	  onNavClick: _propTypes.default.func,
	  onViewDateChange: _propTypes.default.func,
	  onClick: _propTypes.default.any
	};

/***/ },
/* 110 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(from, to) {
	  if (from) {
	    ['hour', 'minute', 'second', 'millisecond'].forEach(function (part) {
	      to.set(part, from.get ? from.get(part) : from[part]);
	    });
	  }
	  return to;
	};
	exports.default = _default;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var times = function times(count) {
	  return (count >= 0 ? (0, _toConsumableArray2.default)(new Array(count)) : []).map(function (v, i) {
	    return i;
	  });
	};
	var _default = times;
	exports.default = _default;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CloseIcon = CloseIcon;
	exports.LoadingIcon = LoadingIcon;
	exports.ToggleIcon = ToggleIcon;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(44));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _excluded = ["size", "className", "svgProps"],
	  _excluded2 = ["onClick", "className", "expanded", "size"],
	  _excluded3 = ["size", "svgProps", "className"];
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function CloseIcon(_ref) {
	  var _ref$size = _ref.size,
	    size = _ref$size === void 0 ? 10 : _ref$size,
	    className = _ref.className,
	    svgProps = _ref.svgProps,
	    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
	  return _react.default.createElement("div", _objectSpread(_objectSpread({}, rest), {}, {
	    className: className
	  }), _react.default.createElement("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
	    width: size,
	    height: size,
	    viewBox: "0 0 10 10"
	  }), _react.default.createElement("path", {
	    fill: "none",
	    fillRule: "evenodd",
	    strokeLinecap: "round",
	    strokeWidth: "1.33",
	    d: "M1 1l8 8m0-8L1 9"
	  })));
	}
	CloseIcon.propTypes = {
	  className: _propTypes.default.string,
	  size: _propTypes.default.number
	};
	function ToggleIcon(_ref2) {
	  var onClick = _ref2.onClick,
	    className = _ref2.className,
	    expanded = _ref2.expanded,
	    _ref2$size = _ref2.size,
	    size = _ref2$size === void 0 ? 10 : _ref2$size,
	    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
	  return _react.default.createElement("div", _objectSpread(_objectSpread({}, rest), {}, {
	    className: className,
	    onClick: onClick
	  }), _react.default.createElement("svg", {
	    width: size,
	    height: size / 2,
	    viewBox: "0 0 10 5"
	  }, expanded ? _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M5.262.262l4.106 4.106c.144.144.144.379 0 .524-.07.069-.164.108-.262.108H.894c-.204 0-.37-.166-.37-.37 0-.099.039-.193.108-.262L4.738.262c.145-.145.38-.145.524 0z"
	  }) : _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M4.738 4.738L.632.632C.488.488.488.253.632.108.702.04.796 0 .894 0h8.212c.204 0 .37.166.37.37 0 .099-.039.193-.108.262L5.262 4.738c-.145.145-.38.145-.524 0z"
	  })));
	}
	function LoadingIcon(_ref3) {
	  var _ref3$size = _ref3.size,
	    size = _ref3$size === void 0 ? 17 : _ref3$size,
	    _ref3$svgProps = _ref3.svgProps,
	    svgProps = _ref3$svgProps === void 0 ? {} : _ref3$svgProps,
	    className = _ref3.className,
	    rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
	  return _react.default.createElement("div", _objectSpread(_objectSpread({}, rest), {}, {
	    className: className
	  }), _react.default.createElement("svg", _objectSpread(_objectSpread({}, svgProps), {}, {
	    width: size,
	    height: size,
	    viewBox: "0 0 24 24"
	  }), _react.default.createElement("path", {
	    d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
	  })));
	}
	LoadingIcon.propTypes = {
	  size: _propTypes.default.number
	};

/***/ },
/* 113 */
[1296, 700],
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var DEFAULTS = {
	  duration: 100,
	  orientation: 'vertical'
	};
	var _default = function _default(node, newValue, config, callback) {
	  if (typeof config === 'function') {
	    callback = config;
	    config = null;
	  }
	  if (!config) {
	    config = DEFAULTS;
	  }
	  var _config = config,
	    orientation = _config.orientation;
	  var _config2 = config,
	    duration = _config2.duration;
	  var horiz = orientation == 'horizontal';
	  var scrollPosName = horiz ? 'scrollLeft' : 'scrollTop';
	  var currentValue = node[scrollPosName];
	  var diff = newValue - currentValue;
	  var now = Date.now();
	  duration = duration != null ? duration : 100;
	  var millisecondStep = diff / duration;
	  if (!duration) {
	    node[scrollPosName] = newValue;
	    if (typeof callback === 'function') {
	      callback(newValue);
	    }
	    return;
	  }
	  var scroll = function scroll() {
	    var elapsed = Date.now() - now;
	    node[scrollPosName] = currentValue + elapsed * millisecondStep;
	    if (elapsed < duration) {
	      globalObject.requestAnimationFrame(scroll);
	    } else {
	      node[scrollPosName] = newValue;
	      if (typeof callback === 'function') {
	        callback(newValue);
	      }
	    }
	  };
	  globalObject.requestAnimationFrame(scroll);
	};
	exports.default = _default;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _isControlledValue = _interopRequireDefault(__webpack_require__(272));
	var _default = function _default(props, propName) {
	  if (!props) {
	    return false;
	  }
	  return (0, _isControlledValue.default)(props[propName]);
	};
	exports.default = _default;

/***/ },
/* 116 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	var _helpers = __webpack_require__(17);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _ScheduleStore = __webpack_require__(75);
	
	var _ScheduleStore2 = _interopRequireDefault(_ScheduleStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	
	
	// Helpers
	var obx = (0, _mobx.observable)({
	  defaultQuery: '?limit=25',
	  reportFilters: {},
	  reportFilterMap: {},
	  reportData: null,
	  reportTotal: null,
	  reportFormat: null,
	  reportNext: null,
	  // Export data
	  reportMethod: 'GET',
	  reportUrl: null,
	  reportDefinition: null,
	  reportExportTitle: null,
	  // Create load more url
	  getNextUrl: (0, _mobx.action)(function (url) {
	    var nextUrl = (0, _helpers.getPath)(url);
	    return nextUrl.replace('/v1', '');
	  }),
	  // Append data to report
	  appendReportData: (0, _mobx.action)(function (data) {
	    obx.reportData = obx.reportData.concat(data);
	  }),
	  // Apply filters to query
	  applyFilters: (0, _mobx.action)(function () {
	    var query = obx.defaultQuery;
	
	    if (Object.keys(obx.reportFilters).length > 0) {
	      for (var key in obx.reportFilters) {
	        if (obx.reportFilters[key]) {
	          if (!Array.isArray((0, _mobx.toJS)(obx.reportFilters[key]))) {
	            query += '&' + key + '=' + obx.reportFilters[key];
	          } else {
	            for (var i = 0; i < obx.reportFilters[key].length; i++) {
	              query += '&' + key + '=' + obx.reportFilters[key][i];
	            }
	          }
	        }
	      }
	    }
	
	    return query;
	  }),
	  // Update a query parameter
	  updateQueryParam: function updateQueryParam(url, key, value) {
	    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
	    var separator = url.indexOf('?') !== -1 ? '&' : '?';
	
	    if (url.match(re)) {
	      return url.replace(re, '$1' + key + '=' + value + '$2');
	    } else {
	      return '' + url + separator + key + '=' + value;
	    }
	  },
	
	  // Generic function to get report data
	  getReportData: (0, _mobx.action)(function (report) {
	    switch (report) {
	      case 'exams':
	        obx.getExamReport();
	        break;
	
	      case 'sessions':
	        obx.getSessionReport();
	        break;
	
	      default:
	        return null;
	    }
	  }),
	  // Exam report
	  formatExamReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    data.forEach(function (record) {
	      var permittedItems = [];
	
	      if (record.configuration.permittedBathroomBreak) {
	        permittedItems.push('Bathroom Break');
	      }
	
	      if (record.configuration.permittedBlankPaper) {
	        permittedItems.push('Blank Paper');
	      }
	
	      if (record.configuration.permittedCalculator) {
	        permittedItems.push('Calculator');
	      }
	
	      if (record.configuration.permittedDictionary) {
	        permittedItems.push('Dictionary');
	      }
	
	      if (record.configuration.permittedEarplugs) {
	        permittedItems.push('Earplugs');
	      }
	
	      if (record.configuration.permittedFormulaSheet) {
	        permittedItems.push('Formula Sheet');
	      }
	
	      if (record.configuration.permittedNotes) {
	        permittedItems.push('Notes');
	      }
	
	      if (record.configuration.permittedTextbook) {
	        permittedItems.push('Textbook');
	      }
	
	      if (record.configuration.permittedWebsites) {
	        permittedItems.push('Websites');
	      }
	
	      if (record.configuration.permittedOtherItems) {
	        permittedItems.push(record.configuration.permittedOtherItems);
	      }
	
	      var newRow = {
	        account: record.accountName,
	        exam: {
	          examTitle: record.examTitle,
	          duration: 'Duration: ' + (0, _helpers.formatTime)(record.configuration.duration)
	        },
	        course: record.courseTitle,
	        examDate: {
	          examOpenDate: (0, _moment2.default)(record.configuration.examOpenDate),
	          examCloseDate: (0, _moment2.default)(record.configuration.examCloseDate)
	        },
	        password: record.configuration.password,
	        permittedItems: permittedItems
	      };
	
	      formattedData.push(newRow);
	    });
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Account": "{{accountName | customEscape}}",
	      "Exam": "{{examTitle | customEscape}}",
	      "Duration": "{{configuration.duration | customEscape}} minutes",
	      "Course": "{{courseTitle | customEscape}}",
	      "Open Date": "{{configuration.examOpenDate | time_zone: '" + _moment2.default.tz.guess() + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Closes": "{{configuration.examCloseDate | time_zone: '" + _moment2.default.tz.guess() + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Password": "{{configuration.password | customEscape}}",
	      "Bathroom Break Permitted": "{% if configuration.permittedBathroomBreak %}Yes{% endif %}",
	      "Blank Paper Permitted": "{% if configuration.permittedBlankPaper %}Yes{% endif %}",
	      "Calculator Permitted": "{% if configuration.permittedCalculator %}Yes{% endif %}",
	      "Dictionary Permitted": "{% if configuration.permittedDictionary %}Yes{% endif %}",
	      "Earplugs Permitted": "{% if configuration.permittedEarplugs %}Yes{% endif %}",
	      "Formula Sheets Permitted": "{% if configuration.permittedFormulaSheet %}Yes{% endif %}",
	      "Notes Permitted": "{% if configuration.permittedNotes %}Yes{% endif %}",
	      "Textbook Permitted": "{% if configuration.permittedTextbook %}Yes{% endif %}",
	      "Websites Permitted": "{% if configuration.permittedWebsites %}Yes{% endif %}",
	      "Other Permitted Items": "{{configuration.permittedOtherItems | customEscape}}"
	    };
	
	    return formattedData;
	  }),
	  getExamReport: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'getExamReport');
	
	    var query = obx.applyFilters();
	
	    obx.reportFormat = obx.formatExamReport;
	
	    // Set up the filter options
	    obx.reportFilterMap = {
	      institution: 'install',
	      examTitle: '',
	      courseTitle: '',
	      examWindowStart: 'date',
	      examWindowEnd: 'date'
	
	      // Store the report URL so we can use it to generate a CSV if we need to
	    };var reportQuery = obx.updateQueryParam(query, 'limit', '100');
	
	    obx.reportUrl = '/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/reports/examList' + reportQuery;
	
	    _config.api.get('proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/reports/examList' + query).then(function (response) {
	      obx.reportData = obx.reportFormat(response.data.results);
	      obx.reportTotal = response.data.total;
	
	      // Set pagination next url
	      if (response.data.next) {
	        obx.reportNext = obx.getNextUrl(response.data.next);
	      } else {
	        obx.reportNext = null;
	      }
	
	      _SessionStore2.default.finishLoading('getExamReport');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Session report
	  formatSessionReport: (0, _mobx.action)(function (data) {
	    var formattedData = [];
	
	    data.forEach(function (record) {
	      var newRow = {
	        student: record.enrollment.lastName + ', ' + record.enrollment.firstName,
	        date: record.appointmentDate,
	        exam: {
	          examTitle: record.exam ? record.exam.title : '',
	          duration: 'Duration: ' + (0, _helpers.formatTime)(record.examConfiguration.duration)
	        },
	        status: record.status,
	        details: {
	          url: '/reports/sessions?session=' + record.sid,
	          title: 'View session',
	          class: 'btn--outline',
	          action: 'SessionDetail',
	          actionType: 'drawer',
	          skipCSV: true
	        }
	      };
	
	      formattedData.push(newRow);
	    });
	
	    // Store CSV format
	    obx.reportDefinition = {
	      "Student": "{{enrollment.lastName | customEscape}}, {{enrollment.firstName | customEscape}}",
	      "Date": "{{appointmentDate | time_zone: '" + _moment2.default.tz.guess() + "', 'M/D/YYYY [at] h:mma z'}}",
	      "Exam": "{{exam.title | customEscape}}",
	      "Duration": "{{examConfiguration.duration | customEscape}} minutes",
	      "Status": "{{status | customEscape}}"
	    };
	
	    return formattedData;
	  }),
	  getSessionReport: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'getSessionReport');
	
	    var query = obx.applyFilters();
	
	    obx.reportFormat = obx.formatSessionReport;
	
	    // Set up the filter options
	    obx.reportFilterMap = {
	      status: ['Cancelled', 'Closed', 'Scheduled'],
	      period: ['upcoming', 'past']
	
	      // Store the report URL so we can use it to generate a CSV if we need to
	    };var reportQuery = obx.updateQueryParam(query, 'limit', '100');
	
	    obx.reportUrl = '/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/sessions' + reportQuery;
	
	    _config.api.get('proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/sessions' + query).then(function (response) {
	      obx.reportData = obx.reportFormat(response.data.results);
	      obx.reportTotal = response.data.total;
	
	      // Store the sessions in the schedule store
	      _ScheduleStore2.default.events = response.data.results;
	
	      // Set pagination next url
	      if (response.data.next) {
	        obx.reportNext = obx.getNextUrl(response.data.next);
	      } else {
	        obx.reportNext = null;
	      }
	
	      _SessionStore2.default.finishLoading('getSessionReport');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Generate CSV file
	  exportData: (0, _mobx.action)(function (callback) {
	    _SessionStore2.default.startLoading('Loading…', 'ExportData');
	
	    var urlBase = 'https://api.dev.smarterproctoring.com/v1';
	
	    if (true) {
	      urlBase = 'https://api.smarterproctoring.com/v1';
	    }
	
	    console.log(_SessionStore2.default.token);
	
	    var data = {
	      postMetadata: {
	        method: obx.reportMethod,
	        url: encodeURI('' + urlBase + obx.reportUrl),
	        headers: {
	          token: _SessionStore2.default.token
	        }
	      },
	      exportDocumentProperties: {
	        definition: obx.reportDefinition
	      },
	      title: obx.reportExportTitle
	    };
	
	    _config.api.post('proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/users/' + _SessionStore2.default.userData.sid + '/exports', data).then(function (response) {
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('ExportData');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get all generated CSV files
	  downloads: [],
	  getDownloads: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'GetDownloads');
	
	    _config.api.get('proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/users/' + _SessionStore2.default.userData.sid + '/exports').then(function (response) {
	      obx.downloads = response.data.results;
	      _SessionStore2.default.finishLoading('GetDownloads');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Dependencies
	exports.default = obx;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _EnrollmentStore = __webpack_require__(925);
	
	var _EnrollmentStore2 = _interopRequireDefault(_EnrollmentStore);
	
	var _ExamStore = __webpack_require__(305);
	
	var _ExamStore2 = _interopRequireDefault(_ExamStore);
	
	var _HelpStore = __webpack_require__(926);
	
	var _HelpStore2 = _interopRequireDefault(_HelpStore);
	
	var _HybridStore = __webpack_require__(927);
	
	var _HybridStore2 = _interopRequireDefault(_HybridStore);
	
	var _LocationStore = __webpack_require__(306);
	
	var _LocationStore2 = _interopRequireDefault(_LocationStore);
	
	var _ManagerStore = __webpack_require__(307);
	
	var _ManagerStore2 = _interopRequireDefault(_ManagerStore);
	
	var _MessageStore = __webpack_require__(308);
	
	var _MessageStore2 = _interopRequireDefault(_MessageStore);
	
	var _PaymentStore = __webpack_require__(309);
	
	var _PaymentStore2 = _interopRequireDefault(_PaymentStore);
	
	var _PolicyStore = __webpack_require__(928);
	
	var _PolicyStore2 = _interopRequireDefault(_PolicyStore);
	
	var _RegisterStore = __webpack_require__(929);
	
	var _RegisterStore2 = _interopRequireDefault(_RegisterStore);
	
	var _ReportStore = __webpack_require__(117);
	
	var _ReportStore2 = _interopRequireDefault(_ReportStore);
	
	var _ReviewStore = __webpack_require__(930);
	
	var _ReviewStore2 = _interopRequireDefault(_ReviewStore);
	
	var _ScheduleStore = __webpack_require__(75);
	
	var _ScheduleStore2 = _interopRequireDefault(_ScheduleStore);
	
	var _SettingsStore = __webpack_require__(166);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	var _TicketStore = __webpack_require__(931);
	
	var _TicketStore2 = _interopRequireDefault(_TicketStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Combine stores
	// Import stores
	var store = {
	  SessionStore: _SessionStore2.default,
	  EnrollmentStore: _EnrollmentStore2.default,
	  ExamStore: _ExamStore2.default,
	  HelpStore: _HelpStore2.default,
	  HybridStore: _HybridStore2.default,
	  LocationStore: _LocationStore2.default,
	  ManagerStore: _ManagerStore2.default,
	  MessageStore: _MessageStore2.default,
	  PaymentStore: _PaymentStore2.default,
	  PolicyStore: _PolicyStore2.default,
	  RegisterStore: _RegisterStore2.default,
	  ReportStore: _ReportStore2.default,
	  ReviewStore: _ReviewStore2.default,
	  ScheduleStore: _ScheduleStore2.default,
	  SettingsStore: _SettingsStore2.default,
	  TicketStore: _TicketStore2.default
	};
	
	exports.default = store;

/***/ },
/* 119 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimezoneOffsetInMilliseconds;
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	function getTimezoneOffsetInMilliseconds(date) {
	  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	  utcDate.setUTCFullYear(date.getFullYear());
	  return date.getTime() - utcDate.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(66);
	
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	
	var hasPropertyDescriptors = function hasPropertyDescriptors() {
		if ($defineProperty) {
			try {
				$defineProperty({}, 'a', { value: 1 });
				return true;
			} catch (e) {
				// IE 8 has a broken defineProperty
				return false;
			}
		}
		return false;
	};
	
	hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
		// node v0.6 has a bug where array lengths can be Set but not Defined
		if (!hasPropertyDescriptors()) {
			return null;
		}
		try {
			return $defineProperty([], 'length', { value: 1 }).length !== 1;
		} catch (e) {
			// In Firefox 4-22, defining length on an array throws an exception.
			return true;
		}
	};
	
	module.exports = hasPropertyDescriptors;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addEventListenerWrap;
	var _reactDom = _interopRequireDefault(__webpack_require__(37));
	function addEventListenerWrap(target, eventType, cb, option) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
	    _reactDom.default.unstable_batchedUpdates(cb, e);
	  } : cb;
	  if (target !== null && target !== void 0 && target.addEventListener) {
	    target.addEventListener(eventType, callback, option);
	  }
	  return {
	    remove: function remove() {
	      if (target !== null && target !== void 0 && target.removeEventListener) {
	        target.removeEventListener(eventType, callback, option);
	      }
	    }
	  };
	}

/***/ },
/* 122 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = canUseDom;
	function canUseDom() {
	  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	}

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var raf = function raf(callback) {
	  return +setTimeout(callback, 16);
	};
	var caf = function caf(num) {
	  return clearTimeout(num);
	};
	if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
	  raf = function raf(callback) {
	    return window.requestAnimationFrame(callback);
	  };
	  caf = function caf(handle) {
	    return window.cancelAnimationFrame(handle);
	  };
	}
	var rafUUID = 0;
	var rafIds = new Map();
	function cleanup(id) {
	  rafIds.delete(id);
	}
	var wrapperRaf = function wrapperRaf(callback) {
	  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  rafUUID += 1;
	  var id = rafUUID;
	  function callRef(leftTimes) {
	    if (leftTimes === 0) {
	      // Clean up
	      cleanup(id);
	
	      // Trigger
	      callback();
	    } else {
	      // Next raf
	      var realId = raf(function () {
	        callRef(leftTimes - 1);
	      });
	
	      // Bind real raf id
	      rafIds.set(id, realId);
	    }
	  }
	  callRef(times);
	  return id;
	};
	wrapperRaf.cancel = function (id) {
	  var realId = rafIds.get(id);
	  cleanup(id);
	  return caf(realId);
	};
	if (false) {
	  wrapperRaf.ids = function () {
	    return rafIds;
	  };
	}
	var _default = exports.default = wrapperRaf;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.composeRef = composeRef;
	exports.fillRef = fillRef;
	exports.supportNodeRef = supportNodeRef;
	exports.supportRef = supportRef;
	exports.useComposeRef = useComposeRef;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _react = __webpack_require__(2);
	var _reactIs = __webpack_require__(1134);
	var _useMemo = _interopRequireDefault(__webpack_require__(1130));
	/* eslint-disable no-param-reassign */
	
	function fillRef(ref, node) {
	  if (typeof ref === 'function') {
	    ref(node);
	  } else if ((0, _typeof2.default)(ref) === 'object' && ref && 'current' in ref) {
	    ref.current = node;
	  }
	}
	
	/**
	 * Merge refs into one ref function to support ref passing.
	 */
	function composeRef() {
	  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
	    refs[_key] = arguments[_key];
	  }
	  var refList = refs.filter(function (ref) {
	    return ref;
	  });
	  if (refList.length <= 1) {
	    return refList[0];
	  }
	  return function (node) {
	    refs.forEach(function (ref) {
	      fillRef(ref, node);
	    });
	  };
	}
	function useComposeRef() {
	  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    refs[_key2] = arguments[_key2];
	  }
	  return (0, _useMemo.default)(function () {
	    return composeRef.apply(void 0, refs);
	  }, refs, function (prev, next) {
	    return prev.length !== next.length || prev.every(function (ref, i) {
	      return ref !== next[i];
	    });
	  });
	}
	function supportRef(nodeOrComponent) {
	  var _type$prototype, _nodeOrComponent$prot;
	  var type = (0, _reactIs.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
	
	  // Function component node
	  if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render)) {
	    return false;
	  }
	
	  // Class component
	  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render)) {
	    return false;
	  }
	  return true;
	}
	function supportNodeRef(node) {
	  if (! /*#__PURE__*/(0, _react.isValidElement)(node)) {
	    return false;
	  }
	  if ((0, _reactIs.isFragment)(node)) {
	    return false;
	  }
	  return supportRef(node);
	}
	/* eslint-enable */

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.call = call;
	exports.default = void 0;
	exports.note = note;
	exports.noteOnce = noteOnce;
	exports.preMessage = void 0;
	exports.resetWarned = resetWarned;
	exports.warning = warning;
	exports.warningOnce = warningOnce;
	/* eslint-disable no-console */
	var warned = {};
	var preWarningFns = [];
	
	/**
	 * Pre warning enable you to parse content before console.error.
	 * Modify to null will prevent warning.
	 */
	var preMessage = exports.preMessage = function preMessage(fn) {
	  preWarningFns.push(fn);
	};
	function warning(valid, message) {
	  // Support uglify
	  if (false) {
	    var finalMessage = preWarningFns.reduce(function (msg, preMessageFn) {
	      return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'warning');
	    }, message);
	    if (finalMessage) {
	      console.error("Warning: ".concat(finalMessage));
	    }
	  }
	}
	function note(valid, message) {
	  // Support uglify
	  if (false) {
	    var finalMessage = preWarningFns.reduce(function (msg, preMessageFn) {
	      return preMessageFn(msg !== null && msg !== void 0 ? msg : '', 'note');
	    }, message);
	    if (finalMessage) {
	      console.warn("Note: ".concat(finalMessage));
	    }
	  }
	}
	function resetWarned() {
	  warned = {};
	}
	function call(method, valid, message) {
	  if (!valid && !warned[message]) {
	    method(false, message);
	    warned[message] = true;
	  }
	}
	function warningOnce(valid, message) {
	  call(warning, valid, message);
	}
	function noteOnce(valid, message) {
	  call(note, valid, message);
	}
	warningOnce.preMessage = preMessage;
	warningOnce.resetWarned = resetWarned;
	warningOnce.noteOnce = noteOnce;
	var _default = exports.default = warningOnce;
	/* eslint-enable */

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1212),
	    listCacheDelete = __webpack_require__(1213),
	    listCacheGet = __webpack_require__(1214),
	    listCacheHas = __webpack_require__(1215),
	    listCacheSet = __webpack_require__(1216);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(53);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(197);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1209);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(78);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(133);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(510),
	    isLength = __webpack_require__(198);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(95),
	    isObjectLike = __webpack_require__(97);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1165),
	    baseKeys = __webpack_require__(1179),
	    isArrayLike = __webpack_require__(132);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(77);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactDom = __webpack_require__(37);
	
	var _classnames = __webpack_require__(38);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'Tab',
	
	  propTypes: {
	    className: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    focus: _propTypes2.default.bool,
	    selected: _propTypes2.default.bool,
	    disabled: _propTypes2.default.bool,
	    activeTabClassName: _propTypes2.default.string,
	    disabledTabClassName: _propTypes2.default.string,
	    panelId: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.string])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      focus: false,
	      selected: false,
	      id: null,
	      panelId: null,
	      activeTabClassName: 'ReactTabs__Tab--selected',
	      disabledTabClassName: 'ReactTabs__Tab--disabled'
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.checkFocus();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.checkFocus();
	  },
	  checkFocus: function checkFocus() {
	    if (this.props.selected && this.props.focus) {
	      (0, _reactDom.findDOMNode)(this).focus();
	    }
	  },
	  render: function render() {
	    var _cx;
	
	    var _props = this.props,
	        selected = _props.selected,
	        disabled = _props.disabled,
	        panelId = _props.panelId,
	        activeTabClassName = _props.activeTabClassName,
	        disabledTabClassName = _props.disabledTabClassName,
	        className = _props.className,
	        children = _props.children,
	        id = _props.id,
	        attributes = _objectWithoutProperties(_props, ['selected', 'disabled', 'panelId', 'activeTabClassName', 'disabledTabClassName', 'className', 'children', 'id']);
	
	    delete attributes.focus;
	
	    return _react2.default.createElement(
	      'li',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs__Tab', className, (_cx = {}, _defineProperty(_cx, activeTabClassName, selected), _defineProperty(_cx, disabledTabClassName, disabled), _cx)),
	        role: 'tab',
	        id: id,
	        'aria-selected': selected ? 'true' : 'false',
	        'aria-disabled': disabled ? 'true' : 'false',
	        'aria-controls': panelId,
	        tabIndex: selected ? '0' : null
	      }),
	      children
	    );
	  }
	});

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	    if (condition) {
	        return;
	    }
	    if (isProduction) {
	        throw new Error(prefix);
	    }
	    var provided = typeof message === 'function' ? message() : message;
	    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
	    throw new Error(value);
	}
	
	module.exports = invariant;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(139);
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 139 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(202);
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
	}
	module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _region = _interopRequireDefault(__webpack_require__(43));
	var _shallowequal = _interopRequireWildcard(__webpack_require__(73));
	var _renderHeader = _interopRequireDefault(__webpack_require__(549));
	var _renderGroupTool = _interopRequireDefault(__webpack_require__(548));
	var _renderNodeTool = _interopRequireDefault(__webpack_require__(551));
	var _sealedObjectFactory = _interopRequireDefault(__webpack_require__(801));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _isFocusable = _interopRequireDefault(__webpack_require__(273));
	var _bemFactory = _interopRequireDefault(__webpack_require__(577));
	var _renderSortTool = _interopRequireDefault(__webpack_require__(552));
	var _defaultRowReorderColumnId = __webpack_require__(148);
	var _Text = _interopRequireDefault(__webpack_require__(546));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var cellBem = (0, _bemFactory.default)('InovuaReactDataGrid__cell');
	var headerBem = (0, _bemFactory.default)('InovuaReactDataGrid__column-header');
	var emptyObject = Object.freeze ? Object.freeze({}) : {};
	var emptyFn = function emptyFn() {};
	var CELL_RENDER_OBJECT = (0, _sealedObjectFactory.default)({
	  empty: null,
	  value: null,
	  data: null,
	  columnIndex: null,
	  rowIndex: null,
	  remoteRowIndex: null,
	  rowIndexInGroup: null,
	  nodeProps: null,
	  rowSelected: null,
	  rowExpanded: null,
	  treeColumn: null,
	  setRowSelected: null,
	  setRowExpanded: null,
	  isRowExpandable: null,
	  toggleRowExpand: null,
	  toggleNodeExpand: null,
	  loadNodeAsync: null,
	  toggleGroup: null,
	  cellProps: null,
	  totalDataCount: null,
	  rendersInlineEditor: null,
	  renderRowDetailsExpandIcon: null,
	  renderRowDetailsCollapsedIcon: null,
	  renderRowDetailsMoreIcon: null
	});
	var CELL_RENDER_SECOND_OBJ = (0, _sealedObjectFactory.default)({
	  cellProps: null,
	  column: null,
	  headerProps: null
	});
	var wrapInContent = function wrapInContent(value) {
	  return _react.default.createElement("div", {
	    key: "content",
	    className: "InovuaReactDataGrid__cell__content",
	    children: value
	  });
	};
	function InovuaDataGridCell(props) {
	  var domRef = (0, _react.useRef)(null);
	  var isCancelled = (0, _react.useRef)(false);
	  var sortTimeoutId = (0, _react.useRef)(null);
	  var lastEditCompleteTimestamp = (0, _react.useRef)(0);
	  var unmounted = (0, _react.useRef)(false);
	  var cleanupResizeObserver = (0, _react.useRef)(null);
	  var callbackRef = (0, _react.useRef)(undefined);
	  var _useState = (0, _react.useState)({
	      props: props
	    }),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    theState = _useState2[0],
	    setState = _useState2[1];
	  var useInitialProps = !theState.props || props.timestamp > theState.props.timestamp;
	  var state = useInitialProps ? _objectSpread(_objectSpread({}, theState), {}, {
	    props: props,
	    left: props.left || 0
	  }) : theState;
	  var latestPropsRef = (0, _react.useRef)(state.props);
	  latestPropsRef.current = state.props;
	  var getProps = (0, _react.useCallback)(function () {
	    return latestPropsRef.current;
	  }, []);
	  var updateState = (0, _react.useCallback)(function (newState, callback) {
	    callbackRef.current = callback;
	    setState(function (oldState) {
	      return _objectSpread(_objectSpread({}, oldState), newState);
	    });
	  }, []);
	  var updateProps = (0, _react.useCallback)(function (props, callback) {
	    props.timestamp = Date.now();
	    var newState = {
	      props: props
	    };
	    requestAnimationFrame(function () {
	      updateState(newState, callback);
	    });
	  }, []);
	  var setStateProps = (0, _react.useCallback)(function (stateProps) {
	    if (unmounted.current) {
	      return;
	    }
	    var newProps = Object.assign({}, InovuaDataGridCell.defaultProps, stateProps);
	    if (!(0, _shallowequal.default)(newProps, getProps(), {
	      timestamp: 1
	    })) {
	      updateProps(newProps);
	    }
	  }, [getProps]);
	  (0, _react.useEffect)(function () {
	    var callback = callbackRef.current;
	    if (callback && typeof callback === 'function') {
	      callback();
	    }
	    callbackRef.current = null;
	  }, [state]);
	  (0, _react.useEffect)(function () {
	    var _props$cellRef;
	    unmounted.current = false;
	    if (props.onMount) {
	      props.onMount(props, cellInstance);
	    }
	    (_props$cellRef = props.cellRef) === null || _props$cellRef === void 0 ? void 0 : _props$cellRef.call(props, cellInstance);
	    return function () {
	      if (cleanupResizeObserver.current) {
	        var cleanupResizeObserverFn = cleanupResizeObserver.current;
	        cleanupResizeObserverFn();
	      }
	      if (props.onUnmount) {
	        props.onUnmount(props, cellInstance);
	      }
	      unmounted.current = true;
	    };
	  }, []);
	  var getDOMNode = (0, _react.useCallback)(function () {
	    return domRef.current;
	  }, []);
	  var onUpdate = (0, _react.useCallback)(function () {
	    if (props.onUpdate) {
	      props.onUpdate(getProps(), cellInstance);
	    }
	  }, [props.onUpdate]);
	  var setDragging = (0, _react.useCallback)(function (dragging, callback) {
	    var newState = {
	      dragging: dragging
	    };
	    if (!dragging) {
	      newState.top = 0;
	      if (props.rtl) {
	        newState.right = 0;
	      } else {
	        newState.left = 0;
	      }
	    }
	    updateState(newState, callback);
	  }, [props.rtl]);
	  var setLeft = (0, _react.useCallback)(function (left) {
	    updateState({
	      left: left
	    });
	  }, []);
	  var setRight = (0, _react.useCallback)(function (right) {
	    updateState({
	      right: right
	    });
	  }, []);
	  var setTop = (0, _react.useCallback)(function (top) {
	    updateState({
	      top: top
	    });
	  }, []);
	  var setHeight = (0, _react.useCallback)(function (height) {
	    updateState({
	      height: height
	    });
	  }, []);
	  var setWidth = (0, _react.useCallback)(function (width) {
	    updateState({
	      width: width
	    });
	  }, []);
	  var prepareStyle = function prepareStyle(thisProps) {
	    var maxWidth = thisProps.maxWidth,
	      minRowHeight = thisProps.minRowHeight,
	      computedLocked = thisProps.computedLocked,
	      computedWidth = thisProps.computedWidth,
	      computedOffset = thisProps.computedOffset,
	      rowHeight = thisProps.rowHeight,
	      initialRowHeight = thisProps.initialRowHeight,
	      naturalRowHeight = thisProps.naturalRowHeight,
	      headerCell = thisProps.headerCell,
	      hidden = thisProps.hidden,
	      rtl = thisProps.rtl,
	      inTransition = thisProps.inTransition,
	      inShowTransition = thisProps.inShowTransition,
	      computedRowspan = thisProps.computedRowspan,
	      zIndex = thisProps.zIndex;
	    var style = {};
	    if (typeof thisProps.style === 'function') {
	      if (!headerCell) {
	        Object.assign(style, thisProps.style(thisProps));
	      }
	    } else {
	      Object.assign(style, thisProps.style);
	    }
	    style.width = computedWidth;
	    style.minWidth = computedWidth;
	    if (minRowHeight) {
	      style.minHeight = minRowHeight;
	    }
	    if (headerCell) {
	      style.maxWidth = computedWidth;
	    }
	    if (maxWidth) {
	      style.maxWidth = maxWidth;
	    }
	    if (!headerCell) {
	      if (rowHeight && !naturalRowHeight) {
	        style.height = rowHeight;
	      }
	      if (naturalRowHeight) {
	        style.minHeight = minRowHeight;
	      } else {
	        if (initialRowHeight) {
	          style.height = initialRowHeight;
	        }
	        if (rowHeight && computedRowspan > 1) {
	          style.height = (initialRowHeight || rowHeight) * computedRowspan;
	        }
	      }
	    }
	    if (hidden) {
	      style.display = 'none';
	    }
	    if (!headerCell && !computedLocked) {
	      style.position = naturalRowHeight ? 'relative' : 'absolute';
	      style.top = 0;
	      if (!naturalRowHeight) {
	        if (rtl) {
	          style.right = computedOffset;
	        } else {
	          style.left = computedOffset;
	        }
	      }
	    }
	    if (state && state.dragging) {
	      if (rtl) {
	        style.right = state.right || 0;
	      } else {
	        style.left = state.left || 0;
	      }
	      style.top = state.top || 0;
	      style.height = state.height || '';
	      if (!thisProps.computedResizable && thisProps.computedFilterable) {
	        if (rtl) {
	          style.right = 0;
	        } else {
	          style.left = 0;
	        }
	        style.top = 0;
	      }
	      style.position = 'absolute';
	      style.zIndex = 100;
	    }
	    if (zIndex) {
	      style.zIndex = zIndex;
	    }
	    if (computedWidth === 0) {
	      style.paddingLeft = 0;
	      style.paddingRight = 0;
	    }
	    if (inTransition) {
	      var duration = inShowTransition ? thisProps.showTransitionDuration : thisProps.hideTransitionDuration;
	      duration = duration || thisProps.visibilityTransitionDuration;
	      style.transitionDuration = typeof duration == 'number' ? "".concat(duration, "ms") : duration;
	    }
	    return style;
	  };
	  var prepareClassName = function prepareClassName(thisProps) {
	    var isGroupCell = thisProps.groupCell,
	      groupTitleCell = thisProps.groupTitleCell,
	      groupExpandCell = thisProps.groupExpandCell,
	      isHeaderCell = thisProps.headerCell,
	      headerCellDefaultClassName = thisProps.headerCellDefaultClassName,
	      cellDefaultClassName = thisProps.cellDefaultClassName,
	      computedGroupBy = thisProps.computedGroupBy,
	      depth = thisProps.depth,
	      computedVisibleIndex = thisProps.computedVisibleIndex,
	      headerCell = thisProps.headerCell,
	      headerEllipsis = thisProps.headerEllipsis,
	      groupProps = thisProps.groupProps,
	      hidden = thisProps.hidden,
	      showBorderRight = thisProps.showBorderRight,
	      showBorderTop = thisProps.showBorderTop,
	      showBorderBottom = thisProps.showBorderBottom,
	      showBorderLeft = thisProps.showBorderLeft,
	      firstInSection = thisProps.firstInSection,
	      lastInSection = thisProps.lastInSection,
	      noBackground = thisProps.noBackground,
	      computedLocked = thisProps.computedLocked,
	      computedWidth = thisProps.computedWidth,
	      inTransition = thisProps.inTransition,
	      rowSelected = thisProps.rowSelected,
	      computedRowspan = thisProps.computedRowspan,
	      cellSelected = thisProps.cellSelected,
	      cellActive = thisProps.cellActive,
	      groupSpacerColumn = thisProps.groupSpacerColumn,
	      computedPivot = thisProps.computedPivot,
	      computedResizable = thisProps.computedResizable,
	      groupColumnVisible = thisProps.groupColumnVisible,
	      computedFilterable = thisProps.computedFilterable,
	      rtl = thisProps.rtl,
	      inEdit = thisProps.inEdit,
	      columnIndex = thisProps.columnIndex,
	      columnIndexHovered = thisProps.columnIndexHovered,
	      columnHoverClassName = thisProps.columnHoverClassName,
	      bulkUpdate = thisProps.bulkUpdateMouseDown;
	    var userSelect = thisProps.userSelect,
	      headerUserSelect = thisProps.headerUserSelect;
	    if (typeof userSelect === 'boolean') {
	      userSelect = userSelect ? 'text' : 'none';
	    }
	    if (typeof headerUserSelect === 'boolean') {
	      headerUserSelect = headerUserSelect ? 'text' : 'none';
	    }
	    var nested = depth != null && computedVisibleIndex == 0 && !headerCell && !groupColumnVisible;
	    var baseClassName = isHeaderCell ? headerCellDefaultClassName : cellDefaultClassName;
	    var commonClassName = (0, _join.default)(!computedLocked && "".concat(baseClassName, "--unlocked"), computedLocked && "".concat(baseClassName, "--locked"), computedLocked && "".concat(baseClassName, "--locked-").concat(computedLocked));
	    var last = thisProps.last || thisProps.computedVisibleIndex == thisProps.computedVisibleCount - 1;
	    var propsClassName = typeof thisProps.className === 'function' ? thisProps.className(thisProps) : thisProps.className;
	    var className = (0, _join.default)(propsClassName, baseClassName, commonClassName, !isHeaderCell && thisProps.cellClassName, (nested || hidden) && "".concat(baseClassName, "--no-padding"), hidden && "".concat(baseClassName, "--hidden"), "".concat(baseClassName, "--direction-").concat(rtl ? 'rtl' : 'ltr'), computedRowspan > 1 && "".concat(baseClassName, "--rowspan"), inTransition && "".concat(baseClassName, "--transition"), inTransition && computedWidth && "".concat(baseClassName, "--showing"), inTransition && !computedWidth && "".concat(baseClassName, "--hiding"), computedWidth === 0 && "".concat(baseClassName, "--no-size"), nested && "".concat(baseClassName, "--stretch"), isHeaderCell && headerUserSelect == null || !isHeaderCell ? userSelect && "".concat(baseClassName, "--user-select-").concat(userSelect) : null, groupExpandCell && "".concat(baseClassName, "--group-expand-cell"), groupTitleCell && "".concat(baseClassName, "--group-title-cell"), rowSelected && "".concat(baseClassName, "--selected"), groupProps && "".concat(baseClassName, "--group-cell"), computedPivot && "".concat(baseClassName, "--pivot-enabled"), groupSpacerColumn && "".concat(baseClassName, "--group-column-cell"), inEdit && "".concat(baseClassName, "--in-edit"), cellSelected && "".concat(baseClassName, "--cell-selected"), cellActive && "".concat(baseClassName, "--cell-active"), bulkUpdate && cellSelected && "".concat(baseClassName, "--cell-bulk-update-mouse-down"), thisProps.textAlign && (isHeaderCell ? !thisProps.headerAlign : true) && "".concat(baseClassName, "--align-").concat(thisProps.textAlign), thisProps.textVerticalAlign && (isHeaderCell ? !thisProps.headerVerticalAlign : true) && "".concat(baseClassName, "--vertical-align-").concat(thisProps.textVerticalAlign), thisProps.virtualizeColumns && "".concat(baseClassName, "--virtualize-columns"), thisProps.computedVisibleIndex === 0 && "".concat(baseClassName, "--first"), thisProps.rowIndexInGroup === 0 && "".concat(baseClassName, "--first-row-in-group"), last && "".concat(baseClassName, "--last"), showBorderLeft && computedWidth !== 0 && (!isHeaderCell || !(computedResizable || computedFilterable)) && "".concat(baseClassName, "--show-border-").concat(rtl ? 'right' : 'left'), firstInSection && "".concat(baseClassName, "--first-in-section"), lastInSection && "".concat(baseClassName, "--last-in-section"), showBorderRight && computedWidth !== 0 && (!isHeaderCell || !(computedResizable || computedFilterable)) && "".concat(baseClassName, "--show-border-").concat(rtl ? 'left' : 'right'), showBorderTop && "".concat(baseClassName, "--show-border-top"), showBorderBottom && "".concat(baseClassName, "--show-border-bottom"), noBackground && "".concat(baseClassName, "--no-background"), columnIndex === columnIndexHovered ? columnHoverClassName ? (0, _join.default)("".concat(baseClassName, "--over"), columnHoverClassName) : "".concat(baseClassName, "--over") : '');
	    if (cellSelected) {
	      className = (0, _join.default)(className, thisProps.hasTopSelectedSibling && "".concat(baseClassName, "--cell-has-top-selected-sibling"), thisProps.hasBottomSelectedSibling && "".concat(baseClassName, "--cell-has-bottom-selected-sibling"), thisProps.hasLeftSelectedSibling && "".concat(baseClassName, "--cell-has-").concat(rtl ? 'right' : 'left', "-selected-sibling"), thisProps.hasRightSelectedSibling && "".concat(baseClassName, "--cell-has-").concat(rtl ? 'left' : 'right', "-selected-sibling"));
	    }
	    if (isHeaderCell) {
	      className = (0, _join.default)(className, commonClassName, thisProps.headerClassName, thisProps.titleClassName, state && state.dragging && "".concat(baseClassName, "--dragging"), state && state.left && "".concat(baseClassName, "--reordered"), thisProps.computedSortable && "".concat(baseClassName, "--sortable"), headerUserSelect && "".concat(baseClassName, "--user-select-").concat(headerUserSelect), last && !headerEllipsis && "".concat(baseClassName, "--overflow-hidden"), "".concat(baseClassName, "--align-").concat(thisProps.headerAlign || 'start'), thisProps.group ? "".concat(baseClassName, "--has-group") : "".concat(baseClassName, "--has-no-group"), thisProps.headerVerticalAlign && "".concat(baseClassName, "--vertical-align-").concat(thisProps.headerVerticalAlign), thisProps.computedResizable ? "".concat(baseClassName, "--resizable") : "".concat(baseClassName, "--unresizable"), thisProps.computedLockable ? "".concat(baseClassName, "--lockable") : "".concat(baseClassName, "--unlockable"), thisProps.lastInGroup && "".concat(baseClassName, "--last-in-group"));
	    } else {
	      className = (0, _join.default)(className, (groupProps ? groupProps.depth == computedVisibleIndex : computedGroupBy ? computedGroupBy.length === computedVisibleIndex : computedVisibleIndex === 0) && "".concat(baseClassName, "--active-row-left-border"));
	    }
	    if (isGroupCell) {
	      className = (0, _join.default)(className, 'InovuaReactDataGrid__group-cell');
	    }
	    return className;
	  };
	  var getInitialIndex = (0, _react.useCallback)(function () {
	    return props.computedVisibleIndex;
	  }, [props.computedVisibleIndex]);
	  var getcomputedVisibleIndex = (0, _react.useCallback)(function () {
	    return getProps().computedVisibleIndex;
	  }, []);
	  var renderNodeTool = function renderNodeTool(thisProps) {
	    var data = thisProps.data,
	      renderTreeCollapseTool = thisProps.renderTreeCollapseTool,
	      renderTreeExpandTool = thisProps.renderTreeExpandTool,
	      renderTreeLoadingTool = thisProps.renderTreeLoadingTool;
	    var nodeProps = data.__nodeProps || emptyObject;
	    var leafNode = nodeProps.leafNode;
	    var loading = nodeProps.loading;
	    var expanded = nodeProps.expanded;
	    var collapsed = !expanded;
	    var style = (0, _defineProperty2.default)({}, props.rtl ? 'marginRight' : 'marginLeft', (nodeProps.depth || 0) * thisProps.treeNestingSize);
	    if (props.rtl && collapsed) {
	      style.transform = 'rotate(180deg)';
	    }
	    var element = (0, _renderNodeTool.default)({
	      render: thisProps.renderNodeTool,
	      nodeExpanded: expanded,
	      nodeCollapsed: collapsed,
	      nodeLoading: loading,
	      leafNode: leafNode,
	      nodeProps: nodeProps,
	      node: data,
	      rtl: props.rtl,
	      size: 20,
	      style: style,
	      toggleNodeExpand: thisProps.toggleNodeExpand,
	      renderTreeCollapseTool: renderTreeCollapseTool,
	      renderTreeExpandTool: renderTreeExpandTool,
	      renderTreeLoadingTool: renderTreeLoadingTool
	    }, thisProps);
	    if (!element) {
	      return;
	    }
	    return (0, _react.cloneElement)(element, {
	      key: 'nodeTool'
	    });
	  };
	  var getInitialDOMProps = (0, _react.useCallback)(function () {
	    var thisProps = getProps();
	    var domProps = thisProps.domProps;
	    var specificDomProps = thisProps.headerCell ? thisProps.headerDOMProps : thisProps.cellDOMProps;
	    if (typeof domProps == 'function') {
	      domProps = domProps(thisProps);
	    }
	    if (typeof specificDomProps == 'function') {
	      specificDomProps = specificDomProps(thisProps);
	    }
	    return Object.assign({}, domProps, specificDomProps);
	  }, [getProps, props.domProps, props.headerCell, props.headerDOMProps, props.cellDOMProps]);
	  var renderEditor = function renderEditor(_props) {
	    var thisProps = getProps();
	    var editorProps = _objectSpread(_objectSpread({
	      nativeScroll: thisProps.nativeScroll
	    }, thisProps.editorProps), {}, {
	      editorProps: thisProps.editorProps,
	      cell: cellInstance,
	      cellProps: thisProps,
	      value: thisProps.editValue,
	      theme: thisProps.theme,
	      rtl: thisProps.rtl,
	      autoFocus: true,
	      onChange: onEditValueChange,
	      onComplete: onEditorComplete,
	      onCancel: onEditorCancel,
	      onEnterNavigation: onEditorEnterNavigation,
	      onTabNavigation: onEditorTabNavigation,
	      gotoNext: gotoNextEditor,
	      gotoPrev: gotoPrevEditor,
	      key: 'editor',
	      onClick: onEditorClick
	    });
	    var Editor = thisProps.editor;
	    if (Editor) {
	      return _react.default.createElement(Editor, _objectSpread({}, editorProps));
	    }
	    if (thisProps.renderEditor) {
	      return thisProps.renderEditor(editorProps, editorProps.cellProps, cellInstance);
	    }
	    return _react.default.createElement(_Text.default, _objectSpread({}, editorProps));
	  };
	  var isInEdit = (0, _react.useCallback)(function () {
	    return getProps().inEdit;
	  }, [props.inEdit]);
	  var getEditable = (0, _react.useCallback)(function (editValue) {
	    var thisProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getProps();
	    if (thisProps.groupSpacerColumn || thisProps.groupProps) {
	      return Promise.resolve(false);
	    }
	    var editable = thisProps.computedEditable;
	    if (typeof editable === 'function') {
	      return Promise.resolve(editable(editValue, thisProps));
	    }
	    return Promise.resolve(editable);
	  }, [props.groupSpacerColumn, props.groupProps, props.computedEditable]);
	  var onEditorTabLeave = function onEditorTabLeave(_direction) {};
	  var gotoNextEditor = (0, _react.useCallback)(function () {
	    return props.tryRowCellEdit && props.tryRowCellEdit(getProps().computedVisibleIndex + 1, +1);
	  }, [props.tryRowCellEdit, props.computedVisibleIndex]);
	  var gotoPrevEditor = (0, _react.useCallback)(function () {
	    props.tryRowCellEdit && props.tryRowCellEdit(getProps().computedVisibleIndex - 1, -1);
	  }, [props.tryRowCellEdit, props.computedVisibleIndex]);
	  var onEditorEnterNavigation = (0, _react.useCallback)(function (complete, dir) {
	    var thisProps = getProps();
	    if (typeof dir !== 'number') {
	      dir = 0;
	    }
	    var newIndex = props.rowIndex + dir;
	    if (!complete) {
	      stopEdit();
	      if (newIndex != props.rowIndex) {
	        thisProps.tryNextRowEdit && thisProps.tryNextRowEdit(dir, props.columnIndex, true);
	      }
	    } else {
	      onEditorComplete();
	      if (newIndex != thisProps.rowIndex) {
	        thisProps.tryNextRowEdit && thisProps.tryNextRowEdit(dir, thisProps.columnIndex, true);
	      }
	    }
	  }, [props.tryNextRowEdit, props.rowIndex, props.columnIndex]);
	  var onEditorTabNavigation = (0, _react.useCallback)(function (complete, dir) {
	    var thisProps = getProps();
	    if (typeof dir !== 'number') {
	      dir = 0;
	    }
	    var newIndex = thisProps.computedVisibleIndex + dir;
	    if (!complete) {
	      stopEdit();
	      if (newIndex != thisProps.computedVisibleIndex) {
	        thisProps.tryRowCellEdit && thisProps.tryRowCellEdit(newIndex, dir);
	      }
	    } else {
	      onEditorComplete();
	      if (newIndex != thisProps.computedVisibleIndex) {
	        thisProps.tryRowCellEdit && thisProps.tryRowCellEdit(newIndex, dir);
	      }
	    }
	  }, [props.computedVisibleIndex]);
	  var onEditorClick = (0, _react.useCallback)(function (event) {
	    event.stopPropagation();
	  }, []);
	  var onEditorCancel = (0, _react.useCallback)(function () {
	    cancelEdit();
	  }, []);
	  var startEdit = (0, _react.useCallback)(function (editValue, errBack) {
	    var thisProps = getProps();
	    isCancelled.current = false;
	    var editValuePromise = editValue === undefined ? getEditStartValue(thisProps) : Promise.resolve(editValue);
	    return editValuePromise.then(function (editValue) {
	      return getEditable(editValue, thisProps).then(function (editable) {
	        if (!editable) {
	          return Promise.reject(editable);
	        }
	        if (thisProps.onEditStart) {
	          thisProps.onEditStart(editValue, thisProps);
	        }
	        if (thisProps.onEditStartForRow) {
	          thisProps.onEditStartForRow(editValue, thisProps);
	        }
	        return editValue;
	      });
	    }).catch(errBack || function (_err) {});
	  }, [props.onEditStart, props.onEditStartForRow]);
	  var stopEdit = (0, _react.useCallback)(function () {
	    var editValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCurrentEditValue();
	    var thisProps = getProps();
	    if (thisProps.onEditStop) {
	      thisProps.onEditStop(editValue, thisProps);
	    }
	    if (thisProps.onEditStopForRow) {
	      thisProps.onEditStopForRow(editValue, thisProps);
	    }
	  }, [props.onEditStop, props.onEditStopForRow]);
	  var cancelEdit = (0, _react.useCallback)(function () {
	    isCancelled.current = true;
	    stopEdit();
	    var thisProps = getProps();
	    if (thisProps.onEditCancel) {
	      thisProps.onEditCancel(thisProps);
	    }
	    if (thisProps.onEditCancelForRow) {
	      thisProps.onEditCancelForRow(thisProps);
	    }
	  }, [props.onEditCancel, props.onEditCancelForRow]);
	  var onEditorComplete = (0, _react.useCallback)(function () {
	    var now = Date.now();
	    if (lastEditCompleteTimestamp.current && now - lastEditCompleteTimestamp.current < 50) {
	      return;
	    }
	    lastEditCompleteTimestamp.current = now;
	    if (!isCancelled.current) {
	      completeEdit();
	    }
	    isCancelled.current = false;
	  }, []);
	  var getEditCompleteValue = (0, _react.useCallback)(function () {
	    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCurrentEditValue();
	    if (props.getEditCompleteValue) {
	      return props.getEditCompleteValue(value, getProps());
	    }
	    return value;
	  }, [props.getEditCompleteValue, props.editValue]);
	  var completeEdit = (0, _react.useCallback)(function () {
	    var completeValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getEditCompleteValue();
	    var thisProps = getProps();
	    stopEdit();
	    if (thisProps.onEditComplete) {
	      thisProps.onEditComplete(completeValue, thisProps);
	    }
	    if (thisProps.onEditCompleteForRow) {
	      thisProps.onEditCompleteForRow(completeValue, thisProps);
	    }
	  }, [props.onEditComplete, props.onEditCompleteForRow, getEditCompleteValue]);
	  var getCurrentEditValue = function getCurrentEditValue() {
	    var editValue = getProps().editValue;
	    return editValue;
	  };
	  var onFilterValueChange = (0, _react.useCallback)(function (filterValue) {
	    var thisProps = getProps();
	    if (thisProps.onFilterValueChange) {
	      thisProps.onFilterValueChange(filterValue, thisProps);
	    }
	  }, [props.onFilterValueChange]);
	  var onEditValueChange = (0, _react.useCallback)(function (e) {
	    var value = e && e.target ? e.target.value : e;
	    var thisProps = getProps();
	    if (thisProps.onEditValueChange) {
	      thisProps.onEditValueChange(value, thisProps);
	    }
	    if (thisProps.onEditValueChangeForRow) {
	      thisProps.onEditValueChangeForRow(value, thisProps);
	    }
	  }, [props.onEditValueChange, props.onEditValueChangeForRow]);
	  var renderSelectionBox = (0, _react.useCallback)(function (_props) {
	    var thisProps = getProps();
	    var inTransition = thisProps.inTransition,
	      inShowTransition = thisProps.inShowTransition,
	      cellSelected = thisProps.cellSelected,
	      cellActive = thisProps.cellActive,
	      bulkUpdate = thisProps.bulkUpdateMouseDown;
	    if (!cellSelected && !cellActive) {
	      return null;
	    }
	    var style = {};
	    if (inTransition) {
	      var duration = inShowTransition ? props.showTransitionDuration : props.hideTransitionDuration;
	      duration = duration || props.visibilityTransitionDuration;
	      style.transitionDuration = typeof duration == 'number' ? "".concat(duration, "ms") : duration;
	    }
	    var className = (0, _join.default)('InovuaReactDataGrid__cell__selection', bulkUpdate && 'InovuaReactDataGrid__cell__selection__bulk-update-mouse-down');
	    return _react.default.createElement("div", {
	      key: "selectionBox",
	      style: style,
	      className: className
	    }, props.lastInRange && props.computedCellMultiSelectionEnabled && _react.default.createElement("div", {
	      className: "InovuaReactDataGrid__cell__selection-dragger InovuaReactDataGrid__cell__selection-dragger--direction-".concat(props.rtl ? 'rtl' : 'ltr'),
	      onMouseDown: onCellSelectionDraggerMouseDown
	    }));
	  }, [props.computedCellMultiSelectionEnabled, props.lastInRange, props.rtl, props.inTransition, props.inShowTransition, props.cellSelected, props.cellActive, props.showTransitionDuration, props.hideTransitionDuration, props.visibilityTransitionDuration]);
	  var onHeaderCellFocus = (0, _react.useCallback)(function (event) {
	    var thisProps = getProps();
	    if (thisProps.onFocus) {
	      thisProps.onFocus(event, thisProps);
	    }
	    var initialProps = getInitialDOMProps();
	    if (initialProps.onFocus) {
	      initialProps.onFocus(event, thisProps);
	    }
	  }, [props.onFocus, getInitialDOMProps]);
	  var onColumnHoverMouseEnter = (0, _react.useCallback)(function (thisProps) {
	    if (thisProps.groupProps || thisProps.groupSpacerColumn || thisProps.isRowDetailsCell || thisProps.isCheckboxColumn) {
	      return;
	    }
	    if (thisProps.onColumnMouseEnter) {
	      thisProps.onColumnMouseEnter(thisProps);
	    }
	  }, [props.groupProps, props.groupSpacerColumn, props.isRowDetailsCell, props.isCheckboxColumn, props.onColumnMouseEnter]);
	  var onColumnHoverMouseLeave = (0, _react.useCallback)(function (thisProps) {
	    if (thisProps.groupProps || thisProps.groupSpacerColumn || thisProps.isRowDetailsCell || thisProps.isCheckboxColumn) {
	      return;
	    }
	    if (thisProps.onColumnMouseLeave) {
	      thisProps.onColumnMouseLeave(thisProps);
	    }
	  }, [props.groupProps, props.groupSpacerColumn, props.isRowDetailsCell, props.isCheckboxColumn, props.onColumnMouseLeave]);
	  var onCellEnterHandle = (0, _react.useCallback)(function (event) {
	    var thisProps = getProps();
	    var initialProps = getInitialDOMProps();
	    if (thisProps.onCellEnter) {
	      thisProps.onCellEnter(event, thisProps);
	    }
	    if (thisProps.computedEnableColumnHover) {
	      onColumnHoverMouseEnter(thisProps);
	    }
	    if (initialProps.onMouseEnter) {
	      initialProps.onMouseEnter(event, thisProps);
	    }
	  }, [props.onCellEnter, props.computedEnableColumnHover, getInitialDOMProps]);
	  var onCellLeave = (0, _react.useCallback)(function (event) {
	    var thisProps = getProps();
	    var initialProps = getInitialDOMProps();
	    if (thisProps.onCellLeave) {
	      thisProps.onCellLeave(event, thisProps);
	    }
	    if (thisProps.computedEnableColumnHover) {
	      onColumnHoverMouseLeave(thisProps);
	    }
	    if (initialProps.onMouseLeave) {
	      initialProps.onMouseLeave(event, thisProps);
	    }
	  }, [props.onCellLeave, props.computedEnableColumnHover, getInitialDOMProps]);
	  var onCellSelectionDraggerMouseDown = (0, _react.useCallback)(function (event) {
	    event.preventDefault();
	    event.stopPropagation();
	    if (props.onCellSelectionDraggerMouseDown) {
	      props.onCellSelectionDraggerMouseDown(event, getProps());
	    }
	    if (props.onCellBulkUpdateMouseDown) {
	      props.onCellBulkUpdateMouseDown(event, getProps());
	    }
	  }, [props.onCellSelectionDraggerMouseDown, props.onCellBulkUpdateMouseDown]);
	  var prepareHeaderCellProps = (0, _react.useCallback)(function (cellProps) {
	    var thisProps = getProps();
	    var children = cellProps.children,
	      computedSortInfo = cellProps.computedSortInfo;
	    var computedSortable = thisProps.computedSortable;
	    var sortTools = computedSortable ? getSortTools(computedSortInfo ? computedSortInfo.dir : null, cellProps) : null;
	    if (sortTools) {
	      cellProps.children = [children && children.props ? (0, _react.cloneElement)(children, {
	        key: 'content'
	      }) : children, sortTools];
	      if (thisProps.headerAlign === 'end' || !thisProps.headerAlign && thisProps.textAlign == 'end') {
	        cellProps.children.reverse();
	      }
	    }
	    if (cellProps.renderHeader) {
	      if (!Array.isArray(cellProps.children)) {
	        cellProps.children = [cellProps.children];
	      }
	      cellProps.children = cellProps.renderHeader(cellProps);
	    }
	    if (computedSortInfo && computedSortInfo.dir) {
	      var dirName = computedSortInfo.dir === 1 ? 'asc' : 'desc';
	      cellProps.className = (0, _join.default)(cellProps.className, "".concat(thisProps.headerCellDefaultClassName, "--sort-").concat(dirName));
	    }
	    cellProps.onResizeMouseDown = onResizeMouseDown.bind(cellInstance, cellProps);
	    cellProps.onResizeTouchStart = onResizeTouchStart.bind(cellInstance, cellProps);
	    return cellProps;
	  }, [props.computedSortable, props.headerAlign, props.textAlign, props.headerCellDefaultClassName]);
	  var onMouseDown = (0, _react.useCallback)(function (event) {
	    var thisProps = getProps();
	    var initialDOMProps = getInitialDOMProps();
	    if (event.button === 2) {
	      return;
	    }
	    if (thisProps.onMouseDown) {
	      thisProps.onMouseDown(thisProps, event);
	    }
	    if (initialDOMProps.onMouseDown) {
	      initialDOMProps.onMouseDown(event, thisProps);
	    }
	    if (thisProps.onCellMouseDown) {
	      thisProps.onCellMouseDown(event, thisProps);
	    }
	    if (thisProps.onDragRowMouseDown && thisProps.id === _defaultRowReorderColumnId.id) {
	      thisProps.onDragRowMouseDown(event, thisProps.rowIndex, domRef);
	    }
	  }, [props.onMouseDown, props.onCellMouseDown, props.onDragRowMouseDown, props.id, props.rowIndex]);
	  var onContextMenu = (0, _react.useCallback)(function (event) {
	    var thisProps = getProps();
	    var initialDOMProps = getInitialDOMProps();
	    if (event.nativeEvent) {
	      event.nativeEvent.__cellProps = thisProps;
	    }
	    if (thisProps.onContextMenu) {
	      thisProps.onContextMenu(event, thisProps);
	    }
	    if (initialDOMProps.onContextMenu) {
	      initialDOMProps.onContextMenu(event, thisProps);
	    }
	  }, [props.onContextMenu, getProps]);
	  var onTouchStart = (0, _react.useCallback)(function (event) {
	    var thisProps = getProps();
	    var initialDOMProps = getInitialDOMProps();
	    if (thisProps.onTouchStart) {
	      thisProps.onTouchStart(thisProps, event);
	    }
	    if (initialDOMProps.onTouchStart) {
	      initialDOMProps.onTouchStart(event, thisProps);
	    }
	    if (thisProps.onCellTouchStart) {
	      thisProps.onCellTouchStart(event, thisProps);
	    }
	    if (thisProps.onDragRowMouseDown && thisProps.id === _defaultRowReorderColumnId.id) {
	      thisProps.onDragRowMouseDown(event, thisProps.rowIndex, domRef);
	    }
	    event.stopPropagation();
	  }, [props.onTouchStart, props.onCellTouchStart, props.onDragRowMouseDown, props.id, props.rowIndex]);
	  var onResizeMouseDown = (0, _react.useCallback)(function (cellProps, event) {
	    var thisProps = getProps();
	    hideFilterContextMenu();
	    if (thisProps.hideColumnContextMenu) {
	      thisProps.hideColumnContextMenu();
	    }
	    if (thisProps.onResizeMouseDown) {
	      var node = getDOMNode();
	      thisProps.onResizeMouseDown(cellProps, {
	        colHeaderNode: node,
	        event: event
	      });
	    }
	  }, [props.hideColumnContextMenu, props.onResizeMouseDown]);
	  var onResizeTouchStart = (0, _react.useCallback)(function (cellProps, event) {
	    var thisProps = getProps();
	    if (thisProps.onResizeTouchStart) {
	      thisProps.onResizeTouchStart(cellProps, {
	        colHeaderNode: getDOMNode(),
	        event: event
	      });
	    }
	  }, [props.onResizeTouchStart]);
	  var onClick = (0, _react.useCallback)(function (event) {
	    var thisProps = getProps();
	    var initialDOMProps = getInitialDOMProps();
	    if (thisProps.onClick) {
	      thisProps.onClick(event, thisProps);
	    }
	    if (initialDOMProps.onClick) {
	      initialDOMProps.onClick(event, thisProps);
	    }
	    if (!thisProps.headerCell && thisProps.onCellClick) {
	      thisProps.onCellClick(event, thisProps);
	    }
	    if (!thisProps.headerCell) {
	      if (thisProps.computedEditable && !thisProps.inEdit && (thisProps.editStartEvent === 'onClick' || thisProps.editStartEvent === 'click')) {
	        startEdit();
	      }
	      return;
	    }
	    if (thisProps.preventSortOnClick) {
	      if (thisProps.preventSortOnClick(event, thisProps) === true) {
	        return;
	      }
	    }
	    if (!thisProps.sortDelay || thisProps.sortDelay < 1) {
	      return onSortClick();
	    }
	    if (sortTimeoutId.current) {
	      clearTimeout(sortTimeoutId.current);
	      sortTimeoutId.current = null;
	    }
	    sortTimeoutId.current = setTimeout(function () {
	      onSortClick();
	      sortTimeoutId.current = null;
	    }, parseInt(thisProps.sortDelay, 10));
	    return undefined;
	  }, [props.onClick, props.onCellClick, props.headerCell, props.computedEditable, props.inEdit, props.editStartEvent, props.preventSortOnClick, props.sortDelay]);
	  var onDoubleClick = function onDoubleClick(event) {
	    var thisProps = getProps();
	    var initialDOMProps = getInitialDOMProps();
	    if (thisProps.onDoubleClick) {
	      thisProps.onDoubleClick(event, thisProps);
	    }
	    if (initialDOMProps.onDoubleClick) {
	      initialDOMProps.onDoubleClick(event, thisProps);
	    }
	    var headerProps = thisProps.headerProps,
	      headerCell = thisProps.headerCell;
	    if (!headerCell) {
	      if (thisProps.computedEditable && !thisProps.inEdit && (thisProps.editStartEvent === 'onDoubleClick' || thisProps.editStartEvent === 'dblclick' || thisProps.editStartEvent === 'doubleclick')) {
	        startEdit();
	      }
	      return;
	    }
	    if (headerProps && headerProps.onDoubleClick) {
	      headerProps.onDoubleClick(event, thisProps);
	    }
	    if (sortTimeoutId.current) {
	      clearTimeout(sortTimeoutId.current);
	      sortTimeoutId.current = null;
	    }
	  };
	  var getEditStartValue = function getEditStartValue() {
	    var thisProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getProps();
	    if (typeof thisProps.getEditStartValue == 'function') {
	      return Promise.resolve(thisProps.getEditStartValue(thisProps.value, thisProps));
	    }
	    return Promise.resolve(thisProps.value);
	  };
	  var onSortClick = function onSortClick() {
	    var thisProps = getProps();
	    if (thisProps.headerCell && thisProps.computedSortable) {
	      if (thisProps.onSortClick) {
	        thisProps.onSortClick(thisProps);
	      }
	    }
	  };
	  var getSortTools = (0, _react.useCallback)(function () {
	    var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var cellProps = arguments.length > 1 ? arguments[1] : undefined;
	    var _getProps = getProps(),
	      computedSortable = _getProps.computedSortable,
	      render = _getProps.renderSortTool;
	    return (0, _renderSortTool.default)({
	      sortable: computedSortable,
	      direction: direction,
	      renderSortTool: render
	    }, cellProps);
	  }, [props.computedSortable, props.renderSortTool]);
	  var showFilterContextMenu = (0, _react.useCallback)(function (node) {
	    if (props.showColumnFilterContextMenu) {
	      props.showColumnFilterContextMenu(node, getProps());
	    }
	  }, [props.showColumnFilterContextMenu]);
	  var hideFilterContextMenu = (0, _react.useCallback)(function (node) {
	    if (props.hideColumnFilterContextMenu) {
	      props.hideColumnFilterContextMenu(node);
	    }
	  }, [props.hideColumnFilterContextMenu]);
	  var showContextMenu = (0, _react.useCallback)(function (domRef, onHide) {
	    if (props.showColumnContextMenu) {
	      props.showColumnContextMenu(domRef ? domRef : null, getProps(), {
	        computedVisibleIndex: props.computedVisibleIndex
	      }, onHide);
	    }
	  }, [props.showColumnContextMenu]);
	  var getProxyRegion = (0, _react.useCallback)(function () {
	    var node = getDOMNode();
	    var _getProps2 = getProps(),
	      computedResizable = _getProps2.computedResizable,
	      computedFilterable = _getProps2.computedFilterable;
	    return computedFilterable ? _region.default.from(node.firstChild) : _region.default.from(computedResizable ? node.firstChild : node);
	  }, [props.computedResizable, props.computedFilterable]);
	  var renderGroupTool = (0, _react.useCallback)(function () {
	    var thisProps = getProps();
	    var rtl = thisProps.rtl,
	      collapsed = thisProps.collapsed,
	      groupProps = thisProps.groupProps,
	      renderGroupCollapseTool = thisProps.renderGroupCollapseTool,
	      renderGroupExpandTool = thisProps.renderGroupExpandTool;
	    return (0, _renderGroupTool.default)({
	      render: groupProps === null || groupProps === void 0 ? void 0 : groupProps.renderGroupTool,
	      collapsed: collapsed,
	      rtl: rtl,
	      size: 20,
	      renderGroupCollapseTool: renderGroupCollapseTool,
	      renderGroupExpandTool: renderGroupExpandTool,
	      toggleGroup: toggleGroup
	    });
	  }, [props.rtl, props.collapsed, props.groupProps]);
	  var toggleGroup = (0, _react.useCallback)(function (event) {
	    if (event && event.preventDefault) {
	      event.preventDefault();
	    }
	    var props = getProps();
	    if (typeof props.onGroupToggle === 'function') {
	      var _data = props.data;
	      props.onGroupToggle(_data.keyPath, props, event);
	    }
	  }, [props.onGroupToggle, props.data, getProps]);
	  var cellInstance = {
	    showContextMenu: showContextMenu,
	    getProps: getProps,
	    setLeft: setLeft,
	    setRight: setRight,
	    setTop: setTop,
	    setHeight: setHeight,
	    setWidth: setWidth,
	    setDragging: setDragging,
	    setStateProps: setStateProps,
	    updateState: updateState,
	    updateProps: updateProps,
	    getDOMNode: getDOMNode,
	    onUpdate: onUpdate,
	    getInitialIndex: getInitialIndex,
	    getcomputedVisibleIndex: getcomputedVisibleIndex,
	    getInitialDOMProps: getInitialDOMProps,
	    isInEdit: isInEdit,
	    getEditable: getEditable,
	    onEditorTabLeave: onEditorTabLeave,
	    gotoNextEditor: gotoNextEditor,
	    gotoPrevEditor: gotoPrevEditor,
	    onEditorEnterNavigation: onEditorEnterNavigation,
	    onEditorTabNavigation: onEditorTabNavigation,
	    onEditorClick: onEditorClick,
	    onEditorCancel: onEditorCancel,
	    startEdit: startEdit,
	    stopEdit: stopEdit,
	    cancelEdit: cancelEdit,
	    onEditorComplete: onEditorComplete,
	    getEditCompleteValue: getEditCompleteValue,
	    completeEdit: completeEdit,
	    getCurrentEditValue: getCurrentEditValue,
	    onFilterValueChange: onFilterValueChange,
	    onEditValueChange: onEditValueChange,
	    onHeaderCellFocus: onHeaderCellFocus,
	    onColumnHoverMouseEnter: onColumnHoverMouseEnter,
	    onColumnHoverMouseLeave: onColumnHoverMouseLeave,
	    onCellEnterHandle: onCellEnterHandle,
	    onCellLeave: onCellLeave,
	    onCellSelectionDraggerMouseDown: onCellSelectionDraggerMouseDown,
	    prepareHeaderCellProps: prepareHeaderCellProps,
	    onMouseDown: onMouseDown,
	    onContextMenu: onContextMenu,
	    onTouchStart: onTouchStart,
	    onResizeMouseDown: onResizeMouseDown,
	    onResizeTouchStart: onResizeTouchStart,
	    onClick: onClick,
	    onDoubleClick: onDoubleClick,
	    getEditStartValue: getEditStartValue,
	    onSortClick: onSortClick,
	    getSortTools: getSortTools,
	    showFilterContextMenu: showFilterContextMenu,
	    hideFilterContextMenu: hideFilterContextMenu,
	    getProxyRegion: getProxyRegion,
	    renderGroupTool: renderGroupTool,
	    toggleGroup: toggleGroup,
	    domRef: getDOMNode(),
	    props: props
	  };
	  var thisProps = getProps();
	  var cellActive = thisProps.cellActive,
	    cellSelected = thisProps.cellSelected,
	    data = thisProps.data,
	    empty = thisProps.empty,
	    groupProps = thisProps.groupProps,
	    headerCell = thisProps.headerCell,
	    hidden = thisProps.hidden,
	    name = thisProps.name,
	    onRender = thisProps.onRender,
	    treeColumn = thisProps.treeColumn,
	    groupSpacerColumn = thisProps.groupSpacerColumn,
	    loadNodeAsync = thisProps.loadNodeAsync,
	    groupColumnVisible = thisProps.groupColumnVisible,
	    rowIndex = thisProps.rowIndex,
	    remoteRowIndex = thisProps.remoteRowIndex,
	    rowSelected = thisProps.rowSelected,
	    rowExpanded = thisProps.rowExpanded,
	    setRowSelected = thisProps.setRowSelected,
	    setRowExpanded = thisProps.setRowExpanded,
	    isRowExpandable = thisProps.isRowExpandable,
	    toggleRowExpand = thisProps.toggleRowExpand,
	    toggleNodeExpand = thisProps.toggleNodeExpand,
	    totalDataCount = thisProps.totalDataCount,
	    computedVisibleIndex = thisProps.computedVisibleIndex,
	    inEdit = thisProps.inEdit,
	    renderRowDetailsMoreIcon = thisProps.renderRowDetailsMoreIcon,
	    renderRowDetailsExpandIcon = thisProps.renderRowDetailsExpandIcon,
	    renderRowDetailsCollapsedIcon = thisProps.renderRowDetailsCollapsedIcon,
	    notifyColumnFilterVisibleStateChange = thisProps.notifyColumnFilterVisibleStateChange;
	  var value = thisProps.value,
	    renderCell = thisProps.render,
	    renderSummary = thisProps.renderSummary;
	  var className = prepareClassName(thisProps);
	  var style = prepareStyle(thisProps);
	  var headerProps = headerCell ? thisProps.headerProps || emptyObject : null;
	  if (!headerCell && groupSpacerColumn && groupProps && groupProps.depth == computedVisibleIndex) {
	    value = renderGroupTool();
	  }
	  var children = value;
	  var cellProps = Object.assign({}, thisProps, headerCell ? headerProps : thisProps.cellProps, {
	    instance: cellInstance,
	    value: value,
	    name: name,
	    notifyColumnFilterVisibleStateChange: notifyColumnFilterVisibleStateChange,
	    columnIndex: computedVisibleIndex,
	    children: children,
	    onClick: onClick,
	    onDoubleClick: onDoubleClick,
	    onContextMenu: onContextMenu,
	    onMouseDown: onMouseDown,
	    onTouchStart: onTouchStart,
	    onMouseEnter: onCellEnterHandle,
	    onMouseLeave: onCellLeave
	  });
	  cellProps.className = headerCell ? headerProps.className ? "".concat(className, " ").concat(headerProps.className) : className : thisProps.cellProps && thisProps.cellProps.className ? typeof thisProps.cellProps.className === 'function' ? "".concat(className, " ").concat(thisProps.cellProps.className(cellProps)) : "".concat(className, " ").concat(thisProps.cellProps.className) : className;
	  if (!headerCell) {
	    CELL_RENDER_OBJECT.empty = empty;
	    CELL_RENDER_OBJECT.value = value;
	    CELL_RENDER_OBJECT.data = data;
	    CELL_RENDER_OBJECT.cellProps = cellProps;
	    CELL_RENDER_OBJECT.columnIndex = computedVisibleIndex;
	    CELL_RENDER_OBJECT.treeColumn = treeColumn;
	    CELL_RENDER_OBJECT.rowIndex = rowIndex;
	    CELL_RENDER_OBJECT.remoteRowIndex = remoteRowIndex;
	    CELL_RENDER_OBJECT.rowIndexInGroup = thisProps.rowIndexInGroup;
	    CELL_RENDER_OBJECT.rowSelected = rowSelected;
	    CELL_RENDER_OBJECT.rowExpanded = rowExpanded;
	    CELL_RENDER_OBJECT.nodeProps = data ? data.__nodeProps : emptyObject;
	    CELL_RENDER_OBJECT.setRowSelected = setRowSelected;
	    CELL_RENDER_OBJECT.setRowExpanded = setRowExpanded;
	    CELL_RENDER_OBJECT.toggleGroup = toggleGroup;
	    CELL_RENDER_OBJECT.toggleRowExpand = toggleRowExpand;
	    CELL_RENDER_OBJECT.toggleNodeExpand = toggleNodeExpand;
	    CELL_RENDER_OBJECT.loadNodeAsync = loadNodeAsync;
	    CELL_RENDER_OBJECT.isRowExpandable = isRowExpandable;
	    CELL_RENDER_OBJECT.totalDataCount = totalDataCount;
	    CELL_RENDER_OBJECT.renderRowDetailsExpandIcon = renderRowDetailsExpandIcon;
	    CELL_RENDER_OBJECT.renderRowDetailsCollapsedIcon = renderRowDetailsCollapsedIcon;
	  }
	  var rendersInlineEditor = headerCell ? false : cellProps.rendersInlineEditor;
	  if (rendersInlineEditor && typeof rendersInlineEditor === 'function') {
	    rendersInlineEditor = cellProps.rendersInlineEditor(CELL_RENDER_OBJECT);
	  }
	  CELL_RENDER_OBJECT.rendersInlineEditor = rendersInlineEditor;
	  cellProps.style = headerCell ? headerProps.style ? Object.assign({}, style, headerProps.style) : style : thisProps.cellProps && thisProps.cellProps.style ? typeof thisProps.cellProps.style === 'function' ? Object.assign({}, style, thisProps.cellProps.style(cellProps)) : Object.assign({}, style, thisProps.cellProps.style) : style;
	  if (inEdit || rendersInlineEditor) {
	    cellProps.editProps = {
	      inEdit: inEdit,
	      startEdit: startEdit,
	      value: thisProps.editValue,
	      onClick: onEditorClick,
	      onChange: onEditValueChange,
	      onComplete: onEditorComplete,
	      onCancel: onEditorCancel,
	      onEnterNavigation: onEditorEnterNavigation,
	      onTabNavigation: onEditorTabNavigation,
	      gotoNext: gotoNextEditor,
	      gotoPrev: gotoPrevEditor
	    };
	  }
	  if (headerCell) {
	    cellProps.onFocus = onHeaderCellFocus;
	  }
	  if (headerCell) {
	    CELL_RENDER_OBJECT.renderRowDetailsMoreIcon = renderRowDetailsMoreIcon;
	  }
	  if (headerCell) {
	    cellProps = prepareHeaderCellProps(cellProps);
	  } else {
	    if (data && (data.__summary || data.__group && data.groupColumnSummary) && renderSummary) {
	      renderCell = renderSummary;
	    }
	    if (renderCell) {
	      CELL_RENDER_SECOND_OBJ.cellProps = cellProps;
	      CELL_RENDER_SECOND_OBJ.column = cellProps;
	      CELL_RENDER_SECOND_OBJ.headerProps = null;
	      if (data && (!data.__group || groupColumnVisible)) {
	        cellProps.children = renderCell(CELL_RENDER_OBJECT, CELL_RENDER_SECOND_OBJ);
	      }
	    }
	    if (!hidden && cellProps.children != null && cellProps.textEllipsis !== false) {
	      cellProps.children = wrapInContent(cellProps.children);
	    }
	    if (onRender) {
	      onRender(cellProps, CELL_RENDER_OBJECT);
	    }
	    if (cellSelected || cellActive || inEdit || rendersInlineEditor) {
	      cellProps.children = [cellProps.children, renderSelectionBox(cellProps), inEdit && !rendersInlineEditor ? renderEditor(cellProps) : null];
	    }
	    if (treeColumn) {
	      if (Array.isArray(cellProps.children)) {
	        cellProps.children = [renderNodeTool(thisProps)].concat((0, _toConsumableArray2.default)(cellProps.children));
	      } else {
	        cellProps.children = [renderNodeTool(thisProps), cellProps.children];
	      }
	    }
	  }
	  var initialDOMProps = getInitialDOMProps();
	  var domProps = Object.assign({}, initialDOMProps, {
	    onFocus: cellProps.onFocus || initialDOMProps.onFocus,
	    onClick: cellProps.onClick || initialDOMProps.onClick,
	    onContextMenu: cellProps.onContextMenu || initialDOMProps.onContextMenu,
	    onDoubleClick: cellProps.onDoubleClick || initialDOMProps.onDoubleClick,
	    onMouseDown: cellProps.onMouseDown || initialDOMProps.onMouseDown,
	    onTouchStart: cellProps.onTouchStart || initialDOMProps.onTouchStart,
	    onMouseEnter: cellProps.onMouseEnter || initialDOMProps.onMouseEnter,
	    onMouseLeave: cellProps.onMouseLeave || initialDOMProps.onMouseLeave,
	    style: initialDOMProps.style ? Object.assign({}, initialDOMProps.style, cellProps.style) : cellProps.style,
	    className: (0, _join.default)(initialDOMProps.className, cellProps.className)
	  });
	  domProps.ref = domRef;
	  return headerCell ? (0, _renderHeader.default)(cellProps, domProps, cellInstance, state) : _react.default.createElement("div", _objectSpread(_objectSpread({}, domProps), {}, {
	    children: cellProps.children,
	    "data-props-id": props.id,
	    "data-state-props-id": getProps().id,
	    id: null,
	    name: null,
	    value: null,
	    title: null,
	    data: null
	  }));
	}
	InovuaDataGridCell.defaultProps = {
	  cellDefaultClassName: cellBem(),
	  headerCellDefaultClassName: headerBem(),
	  computedMinWidth: 40,
	  groupNestingSize: 10,
	  treeNestingSize: 10,
	  checkboxTabIndex: null,
	  onSortClick: emptyFn,
	  preventSortOnClick: function preventSortOnClick(event) {
	    var target = event.target;
	    return (0, _isFocusable.default)(target);
	  }
	};
	InovuaDataGridCell.propTypes = {
	  computedAbsoluteIndex: _propTypes.default.number,
	  checkboxTabIndex: _propTypes.default.number,
	  cellActive: _propTypes.default.bool,
	  cellClassName: _propTypes.default.string,
	  cellDefaultClassName: _propTypes.default.string,
	  cellDOMProps: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	  computedCellMultiSelectionEnabled: _propTypes.default.bool,
	  cellSelectable: _propTypes.default.bool,
	  cellSelected: _propTypes.default.bool,
	  checkboxColumn: _propTypes.default.any,
	  collapsed: _propTypes.default.bool,
	  computedColspan: _propTypes.default.number,
	  computedRowspan: _propTypes.default.number,
	  columnIndex: _propTypes.default.number,
	  columnResizeHandleWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  computedLocked: _propTypes.default.oneOf([false, 'start', 'end']),
	  computedWidth: _propTypes.default.number,
	  data: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.array]),
	  defaultWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  depth: _propTypes.default.number,
	  deselectAll: _propTypes.default.func,
	  domProps: _propTypes.default.object,
	  empty: _propTypes.default.bool,
	  first: _propTypes.default.bool,
	  firstInSection: _propTypes.default.bool,
	  computedFlex: _propTypes.default.number,
	  flex: _propTypes.default.number,
	  group: _propTypes.default.string,
	  computedGroupBy: _propTypes.default.any,
	  groupCell: _propTypes.default.bool,
	  groupSpacerColumn: _propTypes.default.bool,
	  groupNestingSize: _propTypes.default.number,
	  groupProps: _propTypes.default.object,
	  hasBottomSelectedSibling: _propTypes.default.bool,
	  hasLeftSelectedSibling: _propTypes.default.bool,
	  hasLockedStart: _propTypes.default.bool,
	  hasRightSelectedSibling: _propTypes.default.bool,
	  hasTopSelectedSibling: _propTypes.default.bool,
	  header: _propTypes.default.any,
	  headerAlign: _propTypes.default.oneOf(['start', 'center', 'end']),
	  headerCell: _propTypes.default.bool,
	  headerCellDefaultClassName: _propTypes.default.string,
	  headerClassName: _propTypes.default.string,
	  headerDOMProps: _propTypes.default.object,
	  headerEllipsis: _propTypes.default.bool,
	  headerHeight: _propTypes.default.number,
	  headerProps: _propTypes.default.any,
	  headerUserSelect: _propTypes.default.oneOf([true, false, 'text', 'none']),
	  headerVerticalAlign: _propTypes.default.oneOf(['top', 'middle', 'center', 'bottom', 'start', 'end']),
	  headerWrapperClassName: _propTypes.default.string,
	  hidden: _propTypes.default.bool,
	  hideIntermediateState: _propTypes.default.bool,
	  hideTransitionDuration: _propTypes.default.number,
	  hiding: _propTypes.default.bool,
	  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  inHideTransition: _propTypes.default.bool,
	  inShowTransition: _propTypes.default.bool,
	  inTransition: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
	  index: _propTypes.default.number,
	  initialIndex: _propTypes.default.number,
	  isColumn: _propTypes.default.bool,
	  last: _propTypes.default.bool,
	  lastInRange: _propTypes.default.bool,
	  lastInSection: _propTypes.default.bool,
	  lastRowInGroup: _propTypes.default.bool,
	  lastUnlocked: _propTypes.default.bool,
	  locked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  maxWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  computedMaxWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  minWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  computedMinWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  minRowHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  multiSelect: _propTypes.default.bool,
	  name: _propTypes.default.string,
	  nativeScroll: _propTypes.default.bool,
	  nextBorderLeft: _propTypes.default.bool,
	  noBackground: _propTypes.default.bool,
	  onCellClick: _propTypes.default.func,
	  onCellEnter: _propTypes.default.func,
	  onCellMouseDown: _propTypes.default.func,
	  preventSortOnClick: _propTypes.default.func,
	  onCellSelectionDraggerMouseDown: _propTypes.default.func,
	  onGroupToggle: _propTypes.default.func,
	  onMount: _propTypes.default.func,
	  onRender: _propTypes.default.func,
	  onResizeMouseDown: _propTypes.default.func,
	  onResizeTouchStart: _propTypes.default.func,
	  onSortClick: _propTypes.default.func,
	  onUnmount: _propTypes.default.func,
	  prevBorderRight: _propTypes.default.bool,
	  render: _propTypes.default.func,
	  renderCheckbox: _propTypes.default.func,
	  renderGroupTitle: _propTypes.default.func,
	  renderHeader: _propTypes.default.func,
	  renderSortTool: _propTypes.default.func,
	  computedResizable: _propTypes.default.bool,
	  lockable: _propTypes.default.bool,
	  resizeProxyStyle: _propTypes.default.object,
	  rowActive: _propTypes.default.bool,
	  rowHeight: _propTypes.default.number,
	  initialRowHeight: _propTypes.default.number,
	  rowIndex: _propTypes.default.number,
	  rowIndexInGroup: _propTypes.default.number,
	  rowRenderIndex: _propTypes.default.number,
	  rowSelected: _propTypes.default.bool,
	  scrollbarWidth: _propTypes.default.number,
	  indexInHeaderGroup: _propTypes.default.number,
	  parentGroups: _propTypes.default.array,
	  selectAll: _propTypes.default.func,
	  selectedCount: _propTypes.default.number,
	  selection: _propTypes.default.any,
	  setRowSelected: _propTypes.default.func,
	  setRowExpanded: _propTypes.default.func,
	  toggleRowExpand: _propTypes.default.func,
	  toggleNodeExpand: _propTypes.default.func,
	  shouldComponentUpdate: _propTypes.default.func,
	  showBorderBottom: _propTypes.default.bool,
	  showBorderLeft: _propTypes.default.bool,
	  showBorderRight: _propTypes.default.any,
	  showBorderTop: _propTypes.default.bool,
	  showColumnContextMenu: _propTypes.default.func,
	  showColumnMenuSortOptions: _propTypes.default.bool,
	  showColumnMenuFilterOptions: _propTypes.default.bool,
	  showColumnMenuLockOptions: _propTypes.default.bool,
	  showColumnMenuGroupOptions: _propTypes.default.bool,
	  showTransitionDuration: _propTypes.default.number,
	  sort: _propTypes.default.any,
	  sortDelay: _propTypes.default.number,
	  computedSortInfo: _propTypes.default.any,
	  computedSortable: _propTypes.default.bool,
	  textAlign: _propTypes.default.oneOf(['start', 'center', 'end']),
	  textEllipsis: _propTypes.default.bool,
	  textVerticalAlign: _propTypes.default.oneOf(['top', 'middle', 'center', 'bottom', 'start', 'end']),
	  titleClassName: _propTypes.default.string,
	  tryRowCellEdit: _propTypes.default.func,
	  totalCount: _propTypes.default.number,
	  totalDataCount: _propTypes.default.number,
	  unselectedCount: _propTypes.default.number,
	  userSelect: _propTypes.default.oneOf([true, false, 'text', 'none']),
	  value: _propTypes.default.any,
	  virtualizeColumns: _propTypes.default.bool,
	  visibilityTransitionDuration: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
	  computedVisible: _propTypes.default.bool,
	  computedVisibleCount: _propTypes.default.number,
	  computedVisibleIndex: _propTypes.default.number,
	  indexInColumns: _propTypes.default.number,
	  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  editable: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
	  onEditStop: _propTypes.default.func,
	  onEditStart: _propTypes.default.func,
	  onEditCancel: _propTypes.default.func,
	  onEditValueChange: _propTypes.default.func,
	  onEditComplete: _propTypes.default.func,
	  onEditStopForRow: _propTypes.default.func,
	  onEditStartForRow: _propTypes.default.func,
	  onEditCancelForRow: _propTypes.default.func,
	  onEditValueChangeForRow: _propTypes.default.func,
	  onEditCompleteForRow: _propTypes.default.func,
	  onDragRowMouseDown: _propTypes.default.func,
	  isRowExpandable: _propTypes.default.func,
	  editorProps: _propTypes.default.any,
	  editValue: _propTypes.default.any,
	  Editor: _propTypes.default.func,
	  renderEditor: _propTypes.default.func,
	  zIndex: _propTypes.default.number,
	  computedOffset: _propTypes.default.number,
	  groupTitleCell: _propTypes.default.bool,
	  groupExpandCell: _propTypes.default.bool,
	  rendersInlineEditor: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
	  groupColumn: _propTypes.default.bool,
	  treeColumn: _propTypes.default.bool,
	  renderNodeTool: _propTypes.default.func,
	  showInContextMenu: _propTypes.default.bool,
	  naturalRowHeight: _propTypes.default.bool,
	  rtl: _propTypes.default.bool,
	  computedFilterable: _propTypes.default.bool,
	  computedEditable: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
	  groupColumnVisible: _propTypes.default.bool,
	  filterTypes: _propTypes.default.any,
	  filterDelay: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
	  getFilterValue: _propTypes.default.func,
	  onFilterValueChange: _propTypes.default.func,
	  getEditStartValue: _propTypes.default.func,
	  getEditCompleteValue: _propTypes.default.func,
	  editStartEvent: _propTypes.default.string,
	  setActiveIndex: _propTypes.default.func,
	  renderColumnReorderProxy: _propTypes.default.func,
	  columnHoverClassName: _propTypes.default.string,
	  renderRowDetailsExpandIcon: _propTypes.default.func,
	  renderRowDetailsCollapsedIcon: _propTypes.default.func
	};
	var _default = _react.default.memo(InovuaDataGridCell, function (prevProps, nextProps) {
	  var areEqual = (0, _shallowequal.equalReturnKey)(nextProps, prevProps, {
	    computedActiveIndex: 1,
	    activeRowRef: 1,
	    active: 1,
	    timestamp: 1,
	    remoteRowIndex: 1,
	    onResizeMouseDown: 1,
	    onResizeTouchStart: 1,
	    onFocus: 1,
	    onSortClick: 1,
	    onTouchStart: 1,
	    onColumnMouseEnter: 1,
	    onColumnMouseLeave: 1
	  });
	  var equalProps = areEqual.result;
	  if (!equalProps) {
	    return false;
	  }
	  return true;
	});
	exports.default = _default;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	Object.defineProperty(exports, "getCellHeader", {
	  enumerable: true,
	  get: function get() {
	    return _getCellHeader.default;
	  }
	});
	exports.getParentGroups = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactCleanProps = _interopRequireDefault(__webpack_require__(49));
	var _region = _interopRequireDefault(__webpack_require__(43));
	var _selectParent = _interopRequireDefault(__webpack_require__(101));
	var _uglified = _interopRequireDefault(__webpack_require__(57));
	var _Cell = _interopRequireDefault(__webpack_require__(141));
	var _HeaderGroup = _interopRequireDefault(__webpack_require__(211));
	var _renderCellsMaybeLocked = _interopRequireDefault(__webpack_require__(210));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _getCellHeader = _interopRequireDefault(__webpack_require__(562));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var emptyFn = function emptyFn() {};
	var getParentGroups = function getParentGroups(groupName, groups) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	      includeSelf: false
	    },
	    includeSelf = _ref.includeSelf;
	  var parentGroups = [];
	  if (!groups) {
	    return parentGroups;
	  }
	  var nextGroup = groups[groupName] ? groups[groups[groupName].group] : null;
	  if (includeSelf && groups[groupName]) {
	    parentGroups.push(groups[groupName]);
	  }
	  while (nextGroup) {
	    parentGroups.push(nextGroup);
	    nextGroup = groups[nextGroup.group];
	  }
	  return parentGroups;
	};
	exports.getParentGroups = getParentGroups;
	var defaultProps = {
	  onResize: function onResize() {},
	  showWarnings: !_uglified.default
	};
	var propTypes = {
	  availableWidth: _propTypes.default.number,
	  columnHeaderUserSelect: _propTypes.default.bool,
	  columnRenderCount: _propTypes.default.number,
	  columnResizeHandleWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  columnUserSelect: _propTypes.default.bool,
	  columns: _propTypes.default.array,
	  columnsMap: _propTypes.default.object,
	  lockedStartColumns: _propTypes.default.array,
	  unlockedColumns: _propTypes.default.array,
	  lockedEndColumns: _propTypes.default.array,
	  deselectAll: _propTypes.default.func,
	  notifyColumnFilterVisibleStateChange: _propTypes.default.func,
	  firstLockedEndIndex: _propTypes.default.number,
	  firstLockedStartIndex: _propTypes.default.number,
	  isMultiSort: _propTypes.default.bool,
	  onGroupMouseDown: _propTypes.default.func,
	  onResizeMouseDown: _propTypes.default.func,
	  onResizeTouchStart: _propTypes.default.func,
	  resizable: _propTypes.default.bool,
	  resizeProxyStyle: _propTypes.default.object,
	  scrollbarWidth: _propTypes.default.number,
	  selectAll: _propTypes.default.func,
	  selectedCount: _propTypes.default.number,
	  sortInfo: _propTypes.default.any,
	  sortable: _propTypes.default.bool,
	  totalCount: _propTypes.default.number,
	  unselectedCount: _propTypes.default.number,
	  virtualListBorderLeft: _propTypes.default.number,
	  virtualListBorderRight: _propTypes.default.number,
	  nativeScroll: _propTypes.default.bool,
	  computedShowHeaderBorderRight: _propTypes.default.any,
	  hasLockedEnd: _propTypes.default.bool,
	  hasLockedStart: _propTypes.default.bool,
	  showColumnContextMenu: _propTypes.default.func,
	  showColumnFilterContextMenu: _propTypes.default.func,
	  hideColumnFilterContextMenu: _propTypes.default.func,
	  onColumnHeaderFocus: _propTypes.default.func,
	  showColumnMenuTool: _propTypes.default.bool,
	  showColumnMenuToolOnHover: _propTypes.default.bool,
	  firstUnlockedIndex: _propTypes.default.number,
	  lockedRows: _propTypes.default.any,
	  i18n: _propTypes.default.any,
	  filterable: _propTypes.default.bool,
	  filterTypes: _propTypes.default.any,
	  computedGroupsDepth: _propTypes.default.number,
	  computedGroupsMap: _propTypes.default.objectOf(_propTypes.default.shape({
	    name: _propTypes.default.string.isRequired
	  })),
	  headerHeight: _propTypes.default.number,
	  maxWidth: _propTypes.default.number,
	  renderSortTool: _propTypes.default.func,
	  minWidth: _propTypes.default.number,
	  onCellMouseDown: _propTypes.default.func,
	  onCellTouchStart: _propTypes.default.func,
	  onCellClick: _propTypes.default.func,
	  computedOnColumnFilterValueChange: _propTypes.default.func,
	  onSortClick: _propTypes.default.func,
	  onResize: _propTypes.default.func,
	  scrollLeft: _propTypes.default.number,
	  showWarnings: _propTypes.default.bool,
	  unselected: _propTypes.default.any,
	  virtualizeColumns: _propTypes.default.bool,
	  width: _propTypes.default.number,
	  updateLockedWrapperPositions: _propTypes.default.func,
	  lastLockedEndIndex: _propTypes.default.number,
	  lastLockedStartIndex: _propTypes.default.number,
	  lastUnlockedIndex: _propTypes.default.number,
	  getScrollLeftMax: _propTypes.default.func,
	  rtl: _propTypes.default.bool,
	  renderLockedEndCells: _propTypes.default.func,
	  renderLockedStartCells: _propTypes.default.func,
	  renderInPortal: _propTypes.default.any,
	  onFilterValueChange: _propTypes.default.func,
	  setScrollLeft: _propTypes.default.func,
	  sortedColumnsInfo: _propTypes.default.any,
	  renderMenuTool: _propTypes.default.func,
	  columnHoverClassName: _propTypes.default.string,
	  onColumnMouseEnter: _propTypes.default.func,
	  onColumnMouseLeave: _propTypes.default.func,
	  columnIndexHovered: _propTypes.default.number,
	  enableColumnFilterContextMenu: _propTypes.default.bool,
	  computedEnableColumnHover: _propTypes.default.bool,
	  renderRowDetailsMoreIcon: _propTypes.default.func,
	  hideColumnContextMenu: _propTypes.default.func,
	  updateMenuPosition: _propTypes.default.func,
	  computedFilterable: _propTypes.default.bool,
	  filterRowHeight: _propTypes.default.number
	};
	var InovuaDataGridHeader = function (_React$Component) {
	  (0, _inherits2.default)(InovuaDataGridHeader, _React$Component);
	  var _super = _createSuper(InovuaDataGridHeader);
	  function InovuaDataGridHeader(_props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaDataGridHeader);
	    _this = _super.call(this, _props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "domRef", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "unlockedCells", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cells", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "columnRenderStartIndex", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollLeft", 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "startIndex", 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "endIndex", 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
	      if (_this.props.columnRenderCount < prevProps.columnRenderCount) {
	        _this.getUnlockedCells(prevProps).forEach(function (cell) {
	          cell.setStateProps(null);
	        });
	      }
	      if (prevProps.hasLockedStart && !_this.props.hasLockedStart) {
	        setTimeout(function () {
	          return _this.updateColumns();
	        }, 0);
	      }
	      if (_this.props.virtualizeColumns && prevProps.columnRenderCount !== _this.props.columnRenderCount || _this.props.selectedCount !== prevProps.selectedCount || _this.props.unselectedCount !== prevProps.unselectedCount || _this.props.columns !== prevProps.columns || _this.props.columnIndexHovered !== prevProps.columnIndexHovered || _this.props.lockedStartColumns.length !== prevProps.lockedStartColumns.length) {
	        _this.setState({
	          children: _this.renderColumns()
	        });
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCellMount", function (cellProps, c) {
	      if (cellProps.dragging) {
	        return;
	      }
	      if (_this.props.virtualizeColumns && !cellProps.computedLocked) {
	        _this.unlockedCells.push(c);
	      }
	      _this.cells.push(c);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCellUnmount", function (cellProps, cell) {
	      if (cellProps.dragging) {
	        return;
	      }
	      if (_this.props.virtualizeColumns && !cellProps.computedLocked) {
	        if (_this.unlockedCells) {
	          _this.unlockedCells = _this.unlockedCells.filter(function (c) {
	            return c !== cell;
	          });
	        }
	      }
	      if (_this.cells) {
	        _this.cells = _this.cells.filter(function (c) {
	          return c !== cell;
	        });
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "findCellById", function (cellId) {
	      var cellsArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.cells;
	      return cellsArray.filter(function (c) {
	        return c.getProps().id === cellId;
	      })[0];
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getCells", function () {
	      var result = [];
	      _this.props.columns.forEach(function (c) {
	        var cell = _this.findCellById(c.id);
	        if (cell) {
	          var props = cell.getProps();
	          result[props.computedVisibleIndex] = cell;
	        }
	      });
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getGroupsAndCells", function () {
	      var cells = _this.getCells();
	      var result = [];
	      var add = function add(item) {
	        if (result.indexOf(item) == -1) {
	          result.push(item);
	        }
	      };
	      cells.forEach(function (cell) {
	        var target = cell;
	        while (target && target.props.parent) {
	          add(target);
	          target = target.props.parent;
	        }
	        if (target) {
	          add(target);
	        }
	      });
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setCellIndex", function (cell, index) {
	      var cellProps = _this.getPropsForCells(index)[0];
	      cell.setStateProps(cellProps);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getCellIndex", function (cell) {
	      return cell.getProps().index;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sortCells", function (cells) {
	      return cells.sort(function (cell1, cell2) {
	        return _this.getCellIndex(cell1) - _this.getCellIndex(cell2);
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getUnlockedCells", function () {
	      var thisProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	      var lockedStartColumns = thisProps.lockedStartColumns;
	      var result = [];
	      thisProps.columns.forEach(function (c) {
	        var cell = _this.findCellById(c.id, _this.unlockedCells);
	        if (cell) {
	          var props = cell.getProps();
	          var index = props.computedVisibleIndex - lockedStartColumns.length;
	          result[index] = cell;
	        }
	      });
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSortedCells", function () {
	      return _this.sortCells(_this.getUnlockedCells());
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getGaps", function (startIndex, endIndex) {
	      var visibleCellPositions = {};
	      _this.getSortedCells().forEach(function (cell) {
	        visibleCellPositions[_this.getCellIndex(cell)] = true;
	      });
	      var gaps = [];
	      for (; startIndex <= endIndex; startIndex++) {
	        if (!visibleCellPositions[startIndex]) {
	          gaps.push(startIndex);
	        }
	      }
	      return gaps;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setColumnRenderStartIndex", function (columnRenderStartIndex) {
	      _this.columnRenderStartIndex = columnRenderStartIndex;
	      var renderRange = _this.getColumnRenderRange();
	      if (!renderRange) {
	        return;
	      }
	      var start = renderRange.start,
	        end = renderRange.end;
	      var gaps = _this.getGaps(start, end);
	      if (!gaps.length) {
	        return;
	      }
	      _this.getUnlockedCells().forEach(function (cell) {
	        var cellProps = cell.getProps();
	        var cellIndex = cellProps.computedVisibleIndex,
	          computedLocked = cellProps.computedLocked;
	        if (computedLocked) {
	          return;
	        }
	        var outOfView = cellIndex < start || cellIndex > end;
	        var newIndex;
	        if (outOfView && gaps.length) {
	          newIndex = gaps[gaps.length - 1];
	          _this.setCellIndex(cell, newIndex);
	          gaps.length -= 1;
	        }
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getColumnRenderRange", function () {
	      var _this$props = _this.props,
	        columnRenderCount = _this$props.columnRenderCount,
	        lockedStartColumns = _this$props.lockedStartColumns,
	        lockedEndColumns = _this$props.lockedEndColumns,
	        virtualizeColumns = _this$props.virtualizeColumns,
	        columns = _this$props.columns;
	      if (!virtualizeColumns) {
	        return null;
	      }
	      var minStartIndex = lockedStartColumns.length;
	      var maxEndIndex = columns.length - lockedEndColumns.length - 1;
	      var columnRenderStartIndex = _this.columnRenderStartIndex == null ? _this.props.columnRenderStartIndex || 0 : _this.columnRenderStartIndex;
	      columnRenderStartIndex = Math.max(columnRenderStartIndex, minStartIndex);
	      if (columnRenderCount != null) {
	        var columnRenderEndIndex = columnRenderStartIndex + columnRenderCount;
	        columnRenderEndIndex = Math.min(columnRenderEndIndex, maxEndIndex);
	        if (columnRenderEndIndex - columnRenderCount != columnRenderStartIndex) {
	          columnRenderStartIndex = Math.max(columnRenderEndIndex - columnRenderCount, minStartIndex);
	        }
	        return {
	          start: columnRenderStartIndex,
	          end: columnRenderEndIndex
	        };
	      }
	      return null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "prepareStyle", function (props) {
	      var headerHeight = props.headerHeight,
	        width = props.width,
	        minWidth = props.minWidth,
	        index = props.index;
	      var style = _objectSpread({}, props.style);
	      if (width || minWidth) {
	        if (width) {
	          style.width = Math.max(width, minWidth || 0);
	        }
	        if (minWidth) {
	          style.minWidth = minWidth;
	        }
	      }
	      if (headerHeight) {
	        style.height = headerHeight;
	        if (props.computedFilterable) {
	          style.height += props.filterRowHeight;
	        }
	      }
	      style.zIndex = style.zIndex || 100 - (index || 0);
	      var scrollLeft = _this.props.scrollLeft != null ? _this.props.scrollLeft : _this.scrollLeft;
	      var transformPos = _this.props.rtl ? _this.props.getScrollLeftMax() - scrollLeft : -scrollLeft;
	      style.transform = "translate3d(".concat(transformPos || 0, "px, 0px, 0px)");
	      return style;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "notifyScrollLeftMax", function (scrollLeftMax) {
	      var resizerClassName = 'InovuaReactDataGrid__column-resizer';
	      var lastUnlockedResizer = _this.getDOMNode().querySelector(".".concat(resizerClassName, "--last-unlocked"));
	      if (lastUnlockedResizer) {
	        var columnResizeHandleWidth = _this.props.columnResizeHandleWidth;
	        var remaining = scrollLeftMax - (_this.scrollLeft + columnResizeHandleWidth / 2);
	        var visible = remaining <= 0;
	        lastUnlockedResizer.style.pointerEvents = visible ? 'auto' : 'none';
	        var classList = lastUnlockedResizer.classList;
	        if (classList && classList.add && classList.remove) {
	          if (visible) {
	            classList.add("".concat(resizerClassName, "--active"));
	          } else {
	            classList.remove("".concat(resizerClassName, "--active"));
	          }
	        } else {
	          lastUnlockedResizer.style.zIndex = visible ? 5000 : 2000;
	        }
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setScrollLeft", function (scrollLeft, scrollLeftMax) {
	      _this.scrollLeft = scrollLeft;
	      var node = _this.props.hasLocked ? _this.getDOMNode().querySelector('.InovuaReactDataGrid__unlocked-wrapper') : _this.getDOMNode();
	      if (node) {
	        var transformPos = _this.props.rtl ? _this.props.getScrollLeftMax() - scrollLeft : -scrollLeft;
	        node.style.transform = "translate3d(".concat(transformPos, "px, 0px, 0px)");
	      }
	      if (_this.props.updateLockedWrapperPositions) {
	        _this.props.updateLockedWrapperPositions.call((0, _assertThisInitialized2.default)(_this), _this.props, scrollLeft, {
	          isHeader: true
	        });
	      }
	      if (_this.props.virtualizeColumns) {
	        _this.maybeUpdateColumns();
	        if (scrollLeft === 0 || scrollLeft === scrollLeftMax) {
	          requestAnimationFrame(function () {
	            return _this.maybeUpdateColumns();
	          });
	        }
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "maybeUpdateColumns", function () {
	      var range = _this.getColumnRenderRange();
	      if (range && range.start !== _this.startIndex && range.end !== _this.endIndex) {
	        _this.updateColumns();
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateColumns", function () {
	      var newColumns = _this.renderColumns();
	      _this.setState({
	        children: newColumns
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFocus", function (event) {
	      var body = (0, _selectParent.default)('.InovuaReactDataGrid__body', event.target);
	      if (!body) {
	        return;
	      }
	      var OFFSET = 15;
	      var headerRegion = _region.default.from(body);
	      var targetRegion = _region.default.from(event.target);
	      var scrollLeft = _this.scrollLeft || _this.props.scrollLeft || 0;
	      if (!headerRegion.containsRegion(targetRegion)) {
	        if (targetRegion.left < headerRegion.left) {
	          var diff = headerRegion.left - targetRegion.left;
	          var newScrollLeft = scrollLeft - (diff + OFFSET);
	          _this.props.setScrollLeft(newScrollLeft);
	        }
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPropsForCells", function (startIndex) {
	      var endIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : startIndex + 1;
	      var props = _this.props;
	      var renderInPortal = props.renderInPortal,
	        columnHeaderUserSelect = props.columnHeaderUserSelect,
	        columnResizeHandleWidth = props.columnResizeHandleWidth,
	        columnUserSelect = props.columnUserSelect,
	        data = props.data,
	        showColumnContextMenu = props.showColumnContextMenu,
	        showColumnFilterContextMenu = props.showColumnFilterContextMenu,
	        hideColumnFilterContextMenu = props.hideColumnFilterContextMenu,
	        deselectAll = props.deselectAll,
	        notifyColumnFilterVisibleStateChange = props.notifyColumnFilterVisibleStateChange,
	        firstLockedEndIndex = props.firstLockedEndIndex,
	        firstUnlockedIndex = props.firstUnlockedIndex,
	        filterable = props.filterable,
	        computedShowHeaderBorderRight = props.computedShowHeaderBorderRight,
	        hasLockedEnd = props.hasLockedEnd,
	        hasLockedStart = props.hasLockedStart,
	        lockedEndColumns = props.lockedEndColumns,
	        nativeScroll = props.nativeScroll,
	        resizeProxyStyle = props.resizeProxyStyle,
	        rtl = props.rtl,
	        i18n = props.i18n,
	        scrollbarWidth = props.scrollbarWidth,
	        selectAll = props.selectAll,
	        selectedCount = props.selectedCount,
	        filterTypes = props.filterTypes,
	        totalCount = props.totalCount,
	        renderSortTool = props.renderSortTool,
	        unselectedCount = props.unselectedCount,
	        virtualizeColumns = props.virtualizeColumns,
	        showColumnMenuTool = props.showColumnMenuTool,
	        showColumnMenuToolOnHover = props.showColumnMenuToolOnHover,
	        lastUnlockedIndex = props.lastUnlockedIndex,
	        lastLockedStartIndex = props.lastLockedStartIndex,
	        lastLockedEndIndex = props.lastLockedEndIndex,
	        theme = props.theme,
	        renderMenuTool = props.renderMenuTool,
	        sortedColumnsInfo = props.sortedColumnsInfo,
	        onColumnMouseEnter = props.onColumnMouseEnter,
	        onColumnMouseLeave = props.onColumnMouseLeave,
	        columnIndexHovered = props.columnIndexHovered,
	        columnHoverClassName = props.columnHoverClassName,
	        enableColumnFilterContextMenu = props.enableColumnFilterContextMenu,
	        computedEnableColumnHover = props.computedEnableColumnHover,
	        renderRowDetailsMoreIcon = props.renderRowDetailsMoreIcon,
	        hideColumnContextMenu = props.hideColumnContextMenu,
	        updateMenuPosition = props.updateMenuPosition,
	        filterRowHeight = props.filterRowHeight;
	      var columns = props.columns;
	      if (startIndex !== undefined) {
	        columns = columns.slice(startIndex, endIndex);
	      }
	      var firstLockedIndex = hasLockedEnd ? props.columns.length - lockedEndColumns.length : -1;
	      return columns.map(function (column, i) {
	        var sortableColumn = column.computedSortable,
	          resizableColumn = column.computedResizable;
	        var isSortable = sortableColumn;
	        var isResizable = resizableColumn;
	        var cellStyle = column.style;
	        if (props.headerHeight) {
	          if (column.style) {
	            cellStyle = Object.assign({}, cellStyle);
	          }
	          if (!cellStyle) {
	            cellStyle = {};
	          }
	          cellStyle.height = props.headerHeight;
	          if (props.computedFilterable) {
	            cellStyle.height += props.filterRowHeight;
	          }
	        }
	        var defaults = {
	          filterable: filterable,
	          renderSortTool: renderSortTool,
	          renderMenuTool: renderMenuTool,
	          showColumnMenuTool: showColumnMenuTool,
	          showColumnMenuToolOnHover: showColumnMenuToolOnHover
	        };
	        if (columnUserSelect !== undefined) {
	          defaults.userSelect = columnUserSelect;
	        }
	        if (columnHeaderUserSelect !== undefined) {
	          defaults.headerUserSelect = columnHeaderUserSelect;
	        }
	        var displayColumnFilterContextMenu = enableColumnFilterContextMenu;
	        if (column.enableColumnFilterContextMenu != null) {
	          displayColumnFilterContextMenu = column.enableColumnFilterContextMenu;
	        }
	        var cellProps = Object.assign(defaults, column, {
	          headerCell: true,
	          headerHeight: props.headerHeight,
	          i18n: i18n,
	          selectedCount: selectedCount,
	          unselectedCount: unselectedCount,
	          totalCount: totalCount,
	          showColumnContextMenu: showColumnContextMenu,
	          showColumnFilterContextMenu: showColumnFilterContextMenu,
	          hideColumnFilterContextMenu: hideColumnFilterContextMenu,
	          selectAll: selectAll,
	          deselectAll: deselectAll,
	          style: cellStyle,
	          resizeProxyStyle: resizeProxyStyle,
	          renderInPortal: renderInPortal,
	          lastUnlockedIndex: lastUnlockedIndex,
	          lastLockedStartIndex: lastLockedStartIndex,
	          lastLockedEndIndex: lastLockedEndIndex,
	          notifyColumnFilterVisibleStateChange: notifyColumnFilterVisibleStateChange,
	          filterTypes: filterTypes,
	          onFilterValueChange: _this.onFilterValueChange,
	          lastUnlocked: column.computedVisibleIndex === firstLockedIndex - 1,
	          columnResizeHandleWidth: columnResizeHandleWidth,
	          virtualizeColumns: virtualizeColumns,
	          rtl: rtl,
	          onResizeMouseDown: props.onResizeMouseDown,
	          onResizeTouchStart: props.onResizeTouchStart,
	          onMouseDown: _this.onCellMouseDown,
	          onTouchStart: _this.onCellTouchStart,
	          computedSortable: isSortable,
	          computedResizable: isResizable,
	          hasLockedStart: hasLockedStart,
	          nativeScroll: nativeScroll,
	          scrollbarWidth: scrollbarWidth,
	          data: data,
	          theme: theme,
	          sortedColumnsInfo: sortedColumnsInfo,
	          onColumnMouseEnter: onColumnMouseEnter,
	          onColumnMouseLeave: onColumnMouseLeave,
	          columnIndex: i,
	          columnIndexHovered: columnIndexHovered,
	          columnHoverClassName: columnHoverClassName,
	          enableColumnFilterContextMenu: displayColumnFilterContextMenu,
	          computedEnableColumnHover: computedEnableColumnHover,
	          renderRowDetailsMoreIcon: renderRowDetailsMoreIcon,
	          hideColumnContextMenu: hideColumnContextMenu,
	          updateMenuPosition: updateMenuPosition,
	          filterRowHeight: filterRowHeight
	        });
	        cellProps.onFocus = _this.onHeaderCellFocus.bind((0, _assertThisInitialized2.default)(_this), cellProps, column);
	        if (cellProps.group) {
	          cellProps.parentGroups = getParentGroups(cellProps.group, _this.props.computedGroupsMap, {
	            includeSelf: true
	          });
	        }
	        if (props.onCellClick) {
	          cellProps.onClick = props.onCellClick;
	        }
	        if (cellProps.visibilityTransitionDuration || cellProps.hideTransitionDuration || cellProps.showTransitionDuration) {
	          cellProps.onTransitionEnd = _this.onTransitionEnd.bind((0, _assertThisInitialized2.default)(_this), cellProps, column);
	        }
	        cellProps.onSortClick = (props.onSortClick || emptyFn).bind(null, cellProps);
	        cellProps.value = (0, _getCellHeader.default)(cellProps, column, props);
	        cellProps.onUnmount = _this.onCellUnmount;
	        cellProps.onMount = _this.onCellMount;
	        var showBorderLeft = cellProps.showBorderLeft,
	          showBorderRight = cellProps.showBorderRight;
	        cellProps.showBorderRight = cellProps.computedLocked === 'start' && cellProps.computedVisibleIndex == firstUnlockedIndex - 1 || computedShowHeaderBorderRight && column.computedVisibleIndex === column.computedVisibleCount - 1;
	        cellProps.lastInSection = cellProps.computedLocked === 'start' ? cellProps.computedVisibleIndex === lastLockedStartIndex : cellProps.computedLocked === 'end' ? cellProps.computedVisibleIndex === lastLockedEndIndex : cellProps.computedVisibleIndex === lastUnlockedIndex;
	        cellProps.firstInSection = cellProps.computedLocked === 'start' ? cellProps.computedVisibleIndex == 0 : cellProps.computedLocked === 'end' ? cellProps.computedVisibleIndex === firstLockedEndIndex : cellProps.computedVisibleIndex === firstUnlockedIndex;
	        cellProps.showBorderLeft = cellProps.computedLocked === 'end' ? cellProps.computedVisibleIndex >= firstLockedEndIndex : cellProps.computedLocked === 'start' ? cellProps.computedVisibleIndex > 0 : cellProps.computedVisibleIndex > firstUnlockedIndex;
	        var prevColumn = columns[i - 1];
	        var nextColumn = columns[i + 1];
	        if (prevColumn && prevColumn.nextBorderLeft !== undefined) {
	          cellProps.showBorderLeft = prevColumn.nextBorderLeft;
	        }
	        if (nextColumn && nextColumn.prevBorderRight !== undefined) {
	          cellProps.showBorderRight = nextColumn.prevBorderRight;
	        }
	        if (showBorderLeft !== undefined) {
	          cellProps.showBorderLeft = showBorderLeft;
	        }
	        if (showBorderRight !== undefined) {
	          cellProps.showBorderRight = showBorderRight;
	        }
	        return cellProps;
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onHeaderCellFocus", function (headerCellProps, column, e) {
	      if (_this.props.onColumnHeaderFocus) {
	        _this.props.onColumnHeaderFocus(headerCellProps, column, e);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTransitionEnd", function (cellProps, column, e) {
	      e.stopPropagation();
	      if (column.onTransitionEnd) {
	        column.onTransitionEnd(e);
	      }
	      if (_this.props.onTransitionEnd) {
	        _this.props.onTransitionEnd(e, cellProps);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCellMouseDown", function (headerCellProps, event) {
	      if (_this.props.onCellMouseDown) {
	        _this.props.onCellMouseDown(headerCellProps, event);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCellTouchStart", function (headerCellProps, event) {
	      if (_this.props.onCellTouchStart) {
	        _this.props.onCellTouchStart(headerCellProps, event);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderColumns", function () {
	      var _result2;
	      var props = _this.props;
	      var groups = props.computedGroupsMap,
	        hasLockedStart = props.hasLockedStart,
	        hasLockedEnd = props.hasLockedEnd,
	        lockedStartColumns = props.lockedStartColumns,
	        lockedEndColumns = props.lockedEndColumns,
	        columns = props.columns;
	      var renderRange = _this.getColumnRenderRange();
	      _this.startIndex = renderRange === null || renderRange === void 0 ? void 0 : renderRange.start;
	      _this.endIndex = renderRange === null || renderRange === void 0 ? void 0 : renderRange.end;
	      var cellProps = renderRange ? _this.getPropsForCells(renderRange.start, renderRange.end + 1) : _this.getPropsForCells();
	      var lockedStartCells;
	      var lockedEndCells;
	      if (renderRange) {
	        if (hasLockedStart) {
	          lockedStartCells = _this.getPropsForCells(0, lockedStartColumns.length);
	        }
	        if (hasLockedEnd) {
	          lockedEndCells = _this.getPropsForCells(columns.length - lockedEndColumns.length, columns.length);
	        }
	      }
	      if (groups) {
	        if (hasLockedStart || hasLockedEnd) {
	          if (hasLockedStart) {
	            lockedStartCells = lockedStartCells || _this.getPropsForCells(0, lockedStartColumns.length);
	            lockedStartCells = _this.renderGroupedCells(lockedStartCells);
	          }
	          if (hasLockedEnd) {
	            lockedEndCells = lockedEndCells || _this.getPropsForCells(columns.length - lockedEndColumns.length, columns.length);
	            lockedEndCells = _this.renderGroupedCells(lockedEndCells);
	          }
	          var unlockedCells = renderRange ? cellProps : _this.getPropsForCells(lockedStartColumns.length, columns.length - lockedEndColumns.length);
	          unlockedCells = _this.renderGroupedCells(unlockedCells);
	          return (0, _renderCellsMaybeLocked.default)([], _this.props, props.scrollLeft, {
	            lockedStartContent: lockedStartCells,
	            lockedEndContent: lockedEndCells,
	            unlockedContent: unlockedCells,
	            isHeader: true
	          });
	        }
	        return _this.renderGroupedCells(cellProps);
	      }
	      var result = [];
	      if (hasLockedStart && lockedStartCells) {
	        var _result;
	        (_result = result).push.apply(_result, (0, _toConsumableArray2.default)(lockedStartCells));
	      }
	      (_result2 = result).push.apply(_result2, (0, _toConsumableArray2.default)(cellProps));
	      if (hasLockedEnd && lockedEndCells) {
	        var _result3;
	        (_result3 = result).push.apply(_result3, (0, _toConsumableArray2.default)(lockedEndCells));
	      }
	      result = result.map(function (cProps, i) {
	        var index = (renderRange === null || renderRange === void 0 ? void 0 : renderRange.start) + i;
	        return _react.default.createElement(_Cell.default, _objectSpread(_objectSpread({}, cProps), {}, {
	          timestamp: Date.now(),
	          key: "".concat(index, "__").concat(cProps.id),
	          left: _this.props.columnWidthPrefixSums[index]
	        }));
	      });
	      return (0, _renderCellsMaybeLocked.default)(result, _this.props, props.scrollLeft, {
	        isHeader: true
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getCellDOMNodeAt", function (index) {
	      var _this$props2 = _this.props,
	        columns = _this$props2.columns,
	        showWarnings = _this$props2.showWarnings,
	        virtualizeColumns = _this$props2.virtualizeColumns;
	      var column = columns[index];
	      if (!column) {
	        return null;
	      }
	      var arr = column.computedLocked || !virtualizeColumns ? _this.getCells() : _this.getUnlockedCells();
	      var cell = arr.filter(function (c) {
	        return c.getProps().computedVisibleIndex === index;
	      })[0];
	      if (!cell && showWarnings) {
	        console.error("Cannot find dom cell at ".concat(index, "."));
	      }
	      if (cell) {
	        return cell.getDOMNode ? cell.getDOMNode() : cell.domRef ? cell.domRef.current : null;
	      }
	      return;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderHeaderGroup", function (groupName, groupItems, _) {
	      var _this$props3 = _this.props,
	        groups = _this$props3.computedGroupsMap,
	        columnsMap = _this$props3.columnsMap,
	        hasLockedEnd = _this$props3.hasLockedEnd,
	        lockedStartColumns = _this$props3.lockedStartColumns,
	        lockedEndColumns = _this$props3.lockedEndColumns,
	        firstLockedEndIndex = _this$props3.firstLockedEndIndex,
	        lastLockedStartIndex = _this$props3.lastLockedStartIndex,
	        lastLockedEndIndex = _this$props3.lastLockedEndIndex,
	        firstUnlockedIndex = _this$props3.firstUnlockedIndex,
	        lastUnlockedIndex = _this$props3.lastUnlockedIndex,
	        resizeProxyStyle = _this$props3.resizeProxyStyle,
	        rtl = _this$props3.rtl;
	      var group = groups[groupName];
	      var parentGroups = getParentGroups(groupName, groups);
	      var depth = group ? group.computedDepth : 0;
	      var columns = groupItems.filter(function (x) {
	        return !!x;
	      }).reduce(function (acc, item) {
	        if (item.type == _HeaderGroup.default) {
	          acc.push.apply(acc, (0, _toConsumableArray2.default)(item.props.columns));
	        } else {
	          acc.push(item.props.id);
	        }
	        return acc;
	      }, []);
	      var style = {
	        width: columns.reduce(function (width, colId) {
	          return width + columnsMap[colId].computedWidth;
	        }, 0)
	      };
	      var resizable = group && group.resizable !== undefined ? group.resizable : _this.props.resizable;
	      var allColumnsUnresizable = columns.reduce(function (acc, colId) {
	        return acc && columnsMap[colId].computedResizable === false;
	      }, true);
	      if (allColumnsUnresizable) {
	        resizable = false;
	      }
	      var firstColumn = columnsMap[columns[0]];
	      var lastColumn = columnsMap[columns[columns.length - 1]];
	      var firstIndex = firstColumn.computedVisibleIndex;
	      var lastIndex = lastColumn.computedVisibleIndex;
	      var showBorderLeft = firstIndex >= lockedStartColumns.length ? firstIndex > lockedStartColumns.length || firstColumn.computedLocked === 'end' : firstIndex > 0;
	      var containsLastColumn = lastColumn.computedVisibleIndex === _this.props.columns.length - 1;
	      var showBorderRight = lastColumn.computedVisibleIndex === lockedStartColumns.length - 1;
	      var adjustResizer = hasLockedEnd && lastColumn.computedVisibleIndex === _this.props.columns.length - lockedEndColumns.length - 1;
	      var firstInSection = firstColumn.computedLocked === 'start' ? firstIndex === 0 : firstColumn.computedLocked === 'end' ? firstIndex == firstLockedEndIndex : firstIndex === firstUnlockedIndex;
	      var lastInSection = lastColumn.computedLocked === 'start' ? lastIndex === lastLockedStartIndex : lastColumn.computedLocked === 'end' ? lastIndex == lastLockedEndIndex : lastIndex === lastUnlockedIndex;
	      if (firstColumn.inTransition) {
	        var duration = firstColumn.inShowTransition ? firstColumn.showTransitionDuration : firstColumn.hideTransitionDuration;
	        duration = duration || firstColumn.visibilityTransitionDuration;
	        style.transitionDuration = typeof duration == 'number' ? "".concat(duration, "ms") : duration;
	      }
	      var key = "".concat(groupName, "-").concat(depth, "-").concat(columns.join('-'));
	      return _react.default.createElement(_HeaderGroup.default, {
	        key: key,
	        depth: depth,
	        group: group,
	        style: style,
	        rtl: rtl,
	        firstIndex: firstIndex,
	        lastUnlockedIndex: _this.props.lastUnlockedIndex,
	        lastLockedStartIndex: _this.props.lastLockedStartIndex,
	        lastLockedEndIndex: _this.props.lastLockedEndIndex,
	        filterable: _this.props.filterable,
	        inTransition: firstColumn.inTransition,
	        inShowTransition: firstColumn.inShowTransition,
	        inHideTransition: firstColumn.inHideTransition,
	        showTransitionDuration: firstColumn.showTransitionDuration,
	        hideTransitionDuration: firstColumn.hideTransitionDuration,
	        visibilityTransitionDuration: firstColumn.visibilityTransitionDuration,
	        onMouseDown: _this.props.onGroupMouseDown,
	        columns: columns,
	        resizeProxyStyle: resizeProxyStyle,
	        locked: lastColumn.computedLocked === 'start' ? 'start' : firstColumn.computedLocked === 'end' ? 'end' : false,
	        parentGroups: parentGroups,
	        containsLastColumn: containsLastColumn,
	        firstInSection: firstInSection,
	        lastInSection: lastInSection,
	        adjustResizer: adjustResizer,
	        showBorderLeft: showBorderLeft,
	        showBorderRight: showBorderRight,
	        children: groupItems,
	        resizable: resizable,
	        columnResizeHandleWidth: _this.props.columnResizeHandleWidth,
	        onResizeMouseDown: _this.onResizeMouseDown,
	        onResizeTouchStart: _this.onResizeTouchStart
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeMouseDown", function (groupProps, headerGroupInstance, event) {
	      if (_this.props.onResizeMouseDown) {
	        var colId = groupProps.columns[groupProps.columns.length - 1];
	        var visibleIndex = _this.props.columnsMap[colId].computedVisibleIndex;
	        _this.props.onResizeMouseDown({
	          visibleIndex: visibleIndex,
	          computedVisibleIndex: visibleIndex
	        }, {
	          colHeaderNode: headerGroupInstance.domRef ? headerGroupInstance.domRef.current : null,
	          event: event,
	          groupColumns: groupProps.columns
	        });
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeTouchStart", function (groupProps, headerGroupInstance, event) {
	      if (_this.props.onResizeTouchStart) {
	        var colId = groupProps.columns[groupProps.columns.length - 1];
	        var visibleIndex = _this.props.columnsMap[colId].computedVisibleIndex;
	        _this.props.onResizeTouchStart({
	          visibleIndex: visibleIndex
	        }, {
	          colHeaderNode: headerGroupInstance.domRef ? headerGroupInstance.domRef.current : null,
	          event: event,
	          groupColumns: groupProps.columns
	        });
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getItemsForDepth", function (items, depth) {
	      return items.map(function (item) {
	        return item.props.depth === depth ? item : null;
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderItems", function (items) {
	      var computedGroupsDepth = _this.props.computedGroupsDepth;
	      var currentDepth = computedGroupsDepth + 1;
	      while (currentDepth > 0) {
	        items = _this.groupItemsForDepth(items, currentDepth);
	        currentDepth--;
	      }
	      return items;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "groupItemsForDepth", function (items, depth) {
	      var depthItems = _this.getItemsForDepth(items, depth);
	      var index = 0;
	      var item = depthItems[index];
	      var currentGroupName = _this.getItemGroupName(item);
	      var itemGroupName;
	      var groupItems;
	      var headerGroup;
	      var groupStartIndex = 0;
	      var len = depthItems.length + 1;
	      while (index <= len) {
	        itemGroupName = _this.getItemGroupName(item);
	        if (currentGroupName == null && itemGroupName != null) {
	          groupStartIndex = index;
	          currentGroupName = itemGroupName;
	        } else if (itemGroupName != currentGroupName) {
	          groupItems = items.slice(groupStartIndex, index);
	          headerGroup = _this.renderHeaderGroup(currentGroupName, groupItems);
	          items.splice(groupStartIndex, groupItems.length, headerGroup);
	          depthItems.splice(groupStartIndex, groupItems.length, headerGroup);
	          index = groupStartIndex;
	          currentGroupName = null;
	        }
	        index++;
	        item = depthItems[index];
	      }
	      return items;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getItemGroupName", function (item) {
	      if (!item) {
	        return null;
	      }
	      var groups = _this.props.computedGroupsMap;
	      var groupName;
	      if (item.type == _HeaderGroup.default) {
	        groupName = item.props.group ? item.props.group.group : null;
	      } else {
	        groupName = item.props.group;
	      }
	      var group = groups[groupName];
	      return group ? group.name || '' : '';
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fixDepth", function (item, depthDiff) {
	      while (depthDiff >= 0) {
	        item = _this.renderHeaderGroup(_this.getItemGroupName(item), [item], {
	          depth: item.props.depth - 1,
	          forceHeader: true
	        });
	        depthDiff--;
	      }
	      return item;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderGroupedCells", function (cellProps) {
	      var _this$props4 = _this.props,
	        groups = _this$props4.computedGroupsMap,
	        showWarnings = _this$props4.showWarnings;
	      var items = cellProps.map(function (props) {
	        var group = groups[props.group];
	        if (showWarnings && props.group && !group) {
	          _this.warn("Column \"".concat(props.id, "\" references group \"").concat(props.group, "\", but the group is never defined in the groups prop."));
	        }
	        var depth = group ? group.computedDepth + 1 : 0;
	        return _react.default.createElement(_Cell.default, _objectSpread(_objectSpread({}, props), {}, {
	          key: props.id,
	          depth: depth,
	          timestamp: Date.now()
	        }));
	      });
	      return _this.renderItems(items);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFilterValueChange", function (filterValue, cellProps) {
	      if (_this.props.onFilterValueChange) {
	        _this.props.onFilterValueChange({
	          filterValue: filterValue,
	          columnId: cellProps.id,
	          columnIndex: cellProps.computedVisibleIndex,
	          cellProps: cellProps
	        });
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "warn", function (msg) {
	      console.error(msg);
	    });
	    _this.cells = [];
	    _this.unlockedCells = [];
	    _this.startIndex = 0;
	    _this.endIndex = 0;
	    _this.domRef = _react.default.createRef();
	    _this.state = {
	      children: _this.renderColumns()
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaDataGridHeader, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.cells = null;
	      this.unlockedCells = null;
	    }
	  }, {
	    key: "getDOMNode",
	    value: function getDOMNode() {
	      var _this$domRef;
	      return (_this$domRef = this.domRef) === null || _this$domRef === void 0 ? void 0 : _this$domRef.current;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var rtl = props.rtl,
	        virtualizeColumns = props.virtualizeColumns;
	      var className = (0, _join.default)('InovuaReactDataGrid__header', "InovuaReactDataGrid__header--direction-".concat(rtl ? 'rtl' : 'ltr'), props.className);
	      var style = this.prepareStyle(props);
	      var children = virtualizeColumns ? this.state.children : this.renderColumns();
	      var cleanedProps = (0, _reactCleanProps.default)(props, InovuaDataGridHeader.propTypes);
	      delete cleanedProps.columnWidthPrefixSums;
	      return _react.default.createElement("div", _objectSpread(_objectSpread({}, cleanedProps), {}, {
	        className: className,
	        data: null,
	        style: style,
	        ref: this.domRef,
	        onFocus: this.onFocus
	      }), children);
	    }
	  }]);
	  return InovuaDataGridHeader;
	}(_react.default.Component);
	exports.default = InovuaDataGridHeader;
	(0, _defineProperty2.default)(InovuaDataGridHeader, "defaultProps", defaultProps);
	(0, _defineProperty2.default)(InovuaDataGridHeader, "propTypes", propTypes);

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var proto = globalObject && globalObject.Element ? Element.prototype : {
	  matches: function matches() {
	    return false;
	  }
	};
	var vendor = proto.matches || proto.matchesSelector || proto.webkitMatchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector;
	var _default = match;
	exports.default = _default;
	function match(el, selector) {
	  if (vendor) return vendor.call(el, selector);
	  var nodes = el.parentNode.querySelectorAll(selector);
	  for (var i = 0; i < nodes.length; i++) {
	    if (nodes[i] == el) return true;
	  }
	  return false;
	}

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Provider = exports.Consumer = void 0;
	var _react = _interopRequireDefault(__webpack_require__(2));
	var DataGridContext = _react.default.createContext(null);
	var Provider = DataGridContext.Provider;
	exports.Provider = Provider;
	var Consumer = DataGridContext.Consumer;
	exports.Consumer = Consumer;
	var _default = DataGridContext;
	exports.default = _default;

/***/ },
/* 145 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stringTypes = exports.string = exports.selectTypes = exports.select = exports.numberTypes = exports.number = exports.default = exports.dateTypes = exports.date = exports.booleanTypes = exports.boolean = exports.boolTypes = exports.bool = void 0;
	var emptyObject = {};
	var stringTypes = {
	  type: 'string',
	  emptyValue: '',
	  operators: [{
	    name: 'contains',
	    fn: function fn(_ref) {
	      var value = _ref.value,
	        filterValue = _ref.filterValue;
	      value = value || '';
	      return !filterValue ? true : value.toLowerCase().indexOf(filterValue.toLowerCase()) != -1;
	    }
	  }, {
	    name: 'notContains',
	    fn: function fn(_ref2) {
	      var value = _ref2.value,
	        filterValue = _ref2.filterValue;
	      return !filterValue ? true : (value || '').toLowerCase().indexOf(filterValue.toLowerCase()) === -1;
	    }
	  }, {
	    name: 'eq',
	    fn: function fn(_ref3) {
	      var value = _ref3.value,
	        filterValue = _ref3.filterValue;
	      return !filterValue ? true : (value || '').toLowerCase() === filterValue.toLowerCase();
	    }
	  }, {
	    name: 'neq',
	    fn: function fn(_ref4) {
	      var value = _ref4.value,
	        filterValue = _ref4.filterValue;
	      return !filterValue ? true : (value || '').toLowerCase() !== filterValue.toLowerCase();
	    }
	  }, {
	    name: 'empty',
	    fn: function fn(_ref5) {
	      var value = _ref5.value;
	      return value === '';
	    },
	    filterOnEmptyValue: true,
	    valueOnOperatorSelect: '',
	    disableFilterEditor: true
	  }, {
	    name: 'notEmpty',
	    fn: function fn(_ref6) {
	      var value = _ref6.value;
	      return value !== '';
	    },
	    filterOnEmptyValue: true,
	    valueOnOperatorSelect: '',
	    disableFilterEditor: true
	  }, {
	    name: 'startsWith',
	    fn: function fn(_ref7) {
	      var value = _ref7.value,
	        filterValue = _ref7.filterValue;
	      return !filterValue ? true : (value || '').toLowerCase().startsWith(filterValue.toLowerCase());
	    }
	  }, {
	    name: 'endsWith',
	    fn: function fn(_ref8) {
	      var value = _ref8.value,
	        filterValue = _ref8.filterValue;
	      return !filterValue ? true : (value || '').toLowerCase().endsWith(filterValue.toLowerCase());
	    }
	  }]
	};
	exports.string = exports.stringTypes = stringTypes;
	var boolTypes = {
	  type: 'bool',
	  emptyValue: null,
	  operators: [{
	    name: 'eq',
	    fn: function fn(_ref9) {
	      var value = _ref9.value,
	        filterValue = _ref9.filterValue;
	      return filterValue != null ? filterValue === value : true;
	    }
	  }, {
	    name: 'neq',
	    fn: function fn(_ref10) {
	      var value = _ref10.value,
	        filterValue = _ref10.filterValue;
	      return filterValue != null ? filterValue !== value : true;
	    }
	  }]
	};
	exports.boolean = exports.bool = exports.boolTypes = boolTypes;
	var selectTypes = {
	  type: 'select',
	  emptyValue: null,
	  operators: [{
	    name: 'inlist',
	    fn: function fn(_ref11) {
	      var value = _ref11.value,
	        filterValue = _ref11.filterValue;
	      return !filterValue || !filterValue.length ? true : filterValue.indexOf(value) !== -1;
	    }
	  }, {
	    name: 'notinlist',
	    fn: function fn(_ref12) {
	      var value = _ref12.value,
	        filterValue = _ref12.filterValue;
	      return !filterValue || !filterValue.length ? true : filterValue.indexOf(value) === -1;
	    }
	  }, {
	    name: 'eq',
	    fn: function fn(_ref13) {
	      var value = _ref13.value,
	        filterValue = _ref13.filterValue,
	        emptyValue = _ref13.emptyValue;
	      return filterValue !== emptyValue ? filterValue === value : true;
	    }
	  }, {
	    name: 'neq',
	    fn: function fn(_ref14) {
	      var value = _ref14.value,
	        filterValue = _ref14.filterValue,
	        emptyValue = _ref14.emptyValue;
	      return filterValue !== emptyValue ? filterValue !== value : true;
	    }
	  }]
	};
	exports.select = exports.selectTypes = selectTypes;
	var booleanTypes = {
	  type: 'boolean',
	  emptyValue: null,
	  operators: boolTypes.operators
	};
	exports.booleanTypes = booleanTypes;
	var numberTypes = {
	  type: 'number',
	  emptyValue: null,
	  operators: [{
	    name: 'gt',
	    fn: function fn(_ref15) {
	      var value = _ref15.value,
	        filterValue = _ref15.filterValue;
	      return filterValue != null ? value > filterValue : true;
	    }
	  }, {
	    name: 'gte',
	    fn: function fn(_ref16) {
	      var value = _ref16.value,
	        filterValue = _ref16.filterValue;
	      return filterValue != null ? value >= filterValue : true;
	    }
	  }, {
	    name: 'lt',
	    fn: function fn(_ref17) {
	      var value = _ref17.value,
	        filterValue = _ref17.filterValue;
	      return filterValue != null ? value < filterValue : true;
	    }
	  }, {
	    name: 'lte',
	    fn: function fn(_ref18) {
	      var value = _ref18.value,
	        filterValue = _ref18.filterValue;
	      return filterValue != null ? value <= filterValue : true;
	    }
	  }, {
	    name: 'eq',
	    fn: function fn(_ref19) {
	      var value = _ref19.value,
	        filterValue = _ref19.filterValue;
	      return filterValue != null ? value === filterValue : true;
	    }
	  }, {
	    name: 'neq',
	    fn: function fn(_ref20) {
	      var value = _ref20.value,
	        filterValue = _ref20.filterValue;
	      return filterValue != null ? value !== filterValue : true;
	    }
	  }, {
	    name: 'inrange',
	    fn: function fn(_ref21) {
	      var value = _ref21.value,
	        filterValue = _ref21.filterValue;
	      var _ref22 = filterValue || emptyObject,
	        start = _ref22.start,
	        end = _ref22.end;
	      if (start != null && end != null) {
	        return value >= start && value <= end;
	      }
	      if (start != null) {
	        return value >= start;
	      }
	      if (end != null) {
	        return value <= end;
	      }
	      return true;
	    }
	  }, {
	    name: 'notinrange',
	    fn: function fn(_ref23) {
	      var value = _ref23.value,
	        filterValue = _ref23.filterValue;
	      var _ref24 = filterValue || emptyObject,
	        start = _ref24.start,
	        end = _ref24.end;
	      if (start != null && end != null) {
	        return value < start || value > end;
	      }
	      if (start != null) {
	        return value < start;
	      }
	      if (end != null) {
	        return value > end;
	      }
	      return true;
	    }
	  }]
	};
	exports.number = exports.numberTypes = numberTypes;
	var dateTypes = {
	  type: 'date',
	  emptyValue: '',
	  operators: [{
	    name: 'after',
	    fn: function fn(_ref25) {
	      var value = _ref25.value,
	        filterValue = _ref25.filterValue,
	        dateFormat = _ref25.column.dateFormat;
	      return filterValue ? window.moment(window.moment(value).format(dateFormat), dateFormat).isAfter(window.moment(filterValue, dateFormat)) : true;
	    }
	  }, {
	    name: 'afterOrOn',
	    fn: function fn(_ref26) {
	      var value = _ref26.value,
	        filterValue = _ref26.filterValue,
	        dateFormat = _ref26.column.dateFormat;
	      return filterValue != null ? window.moment(window.moment(value).format(dateFormat), dateFormat).isSameOrAfter(window.moment(filterValue, dateFormat)) : true;
	    }
	  }, {
	    name: 'before',
	    fn: function fn(_ref27) {
	      var value = _ref27.value,
	        filterValue = _ref27.filterValue,
	        dateFormat = _ref27.column.dateFormat;
	      return filterValue != null ? window.moment(window.moment(value).format(dateFormat), dateFormat).isBefore(window.moment(filterValue, dateFormat)) : true;
	    }
	  }, {
	    name: 'beforeOrOn',
	    fn: function fn(_ref28) {
	      var value = _ref28.value,
	        filterValue = _ref28.filterValue,
	        dateFormat = _ref28.column.dateFormat;
	      return filterValue != null ? window.moment(window.moment(value).format(dateFormat), dateFormat).isSameOrBefore(window.moment(filterValue, dateFormat)) : true;
	    }
	  }, {
	    name: 'eq',
	    fn: function fn(_ref29) {
	      var value = _ref29.value,
	        filterValue = _ref29.filterValue,
	        dateFormat = _ref29.column.dateFormat;
	      return filterValue ? window.moment(window.moment(value).format(dateFormat), dateFormat).isSame(window.moment(filterValue, dateFormat)) : true;
	    }
	  }, {
	    name: 'neq',
	    fn: function fn(_ref30) {
	      var value = _ref30.value,
	        filterValue = _ref30.filterValue,
	        dateFormat = _ref30.column.dateFormat;
	      return filterValue ? !window.moment(window.moment(value).format(dateFormat), dateFormat).isSame(window.moment(filterValue, dateFormat)) : true;
	    }
	  }, {
	    name: 'inrange',
	    fn: function fn(_ref31) {
	      var value = _ref31.value,
	        filterValue = _ref31.filterValue,
	        dateFormat = _ref31.column.dateFormat;
	      var _ref32 = filterValue || emptyObject,
	        start = _ref32.start,
	        end = _ref32.end;
	      if (start && end) {
	        return window.moment(window.moment(value).format(dateFormat), dateFormat).isSameOrAfter(window.moment(start, dateFormat)) && window.moment(window.moment(value).format(dateFormat), dateFormat).isSameOrBefore(window.moment(end, dateFormat));
	      }
	      if (start) {
	        return window.moment(window.moment(value).format(dateFormat), dateFormat).isSameOrAfter(window.moment(start, dateFormat));
	      }
	      if (end) {
	        return window.moment(window.moment(value).format(dateFormat), dateFormat).isSameOrBefore(window.moment(end, dateFormat));
	      }
	      return true;
	    }
	  }, {
	    name: 'notinrange',
	    fn: function fn(_ref33) {
	      var value = _ref33.value,
	        filterValue = _ref33.filterValue,
	        dateFormat = _ref33.column.dateFormat;
	      var _ref34 = filterValue || emptyObject,
	        start = _ref34.start,
	        end = _ref34.end;
	      if (start && end) {
	        return window.moment(window.moment(value).format(dateFormat), dateFormat).isBefore(window.moment(start, dateFormat)) || window.moment(window.moment(value).format(dateFormat), dateFormat).isAfter(window.moment(end, dateFormat));
	      }
	      if (start) {
	        return window.moment(window.moment(value).format(dateFormat), dateFormat).isBefore(window.moment(start, dateFormat));
	      }
	      if (end) {
	        return window.moment(window.moment(value).format(dateFormat), dateFormat).isAfter(window.moment(end, dateFormat));
	      }
	      return true;
	    }
	  }]
	};
	exports.date = exports.dateTypes = dateTypes;
	var defaultFilterTypes = {
	  select: selectTypes,
	  string: stringTypes,
	  number: numberTypes,
	  bool: boolTypes,
	  boolean: booleanTypes,
	  date: dateTypes
	};
	var _default = defaultFilterTypes;
	exports.default = _default;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.plugins = exports.default = void 0;
	var _factory = _interopRequireDefault(__webpack_require__(590));
	var _sortableColumns = _interopRequireDefault(__webpack_require__(789));
	var _filters = _interopRequireDefault(__webpack_require__(783));
	var _menus = _interopRequireDefault(__webpack_require__(785));
	var _cellSelection = _interopRequireDefault(__webpack_require__(779));
	var plugins = [_sortableColumns.default, _filters.default, _menus.default, _cellSelection.default];
	exports.plugins = plugins;
	var ReactDataGrid = (0, _factory.default)({
	  plugins: plugins
	}, 'community');
	var _default = ReactDataGrid;
	exports.default = _default;

/***/ },
/* 147 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.id = void 0;
	var id = '__checkbox-column';
	exports.id = id;

/***/ },
/* 148 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.id = void 0;
	var id = '__reorder-column';
	exports.id = id;

/***/ },
/* 149 */
[1296, 624],
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _throttle = _interopRequireDefault(__webpack_require__(102));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _TimeInput = __webpack_require__(153);
	var _toMoment2 = _interopRequireDefault(__webpack_require__(40));
	var _parseFormat2 = _interopRequireDefault(__webpack_require__(628));
	var _forwardTime = _interopRequireDefault(__webpack_require__(110));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var emptyFn = function emptyFn() {};
	var BACKWARDS = {
	  Backspace: 1,
	  ArrowUp: 1,
	  ArrowDown: 1,
	  PageUp: 1,
	  PageDown: 1
	};
	var DateFormatInput = function (_Component) {
	  (0, _inherits2.default)(DateFormatInput, _Component);
	  var _super = _createSuper(DateFormatInput);
	  function DateFormatInput(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, DateFormatInput);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
	      if (_this.props.value !== undefined && _this.caretPos && _this.isFocused()) {
	        _this.setCaretPosition(_this.caretPos);
	      }
	      var _this$getMinMax = _this.getMinMax(prevProps),
	        prevMinDate = _this$getMinMax.minDate,
	        prevMaxDate = _this$getMinMax.maxDate;
	      var _this$getMinMax2 = _this.getMinMax(_this.props),
	        currentMinDate = _this$getMinMax2.minDate,
	        currentMaxDate = _this$getMinMax2.maxDate;
	      if (prevMinDate !== currentMinDate) {
	        _this.setState({
	          minDate: currentMinDate
	        });
	      }
	      if (prevMaxDate !== currentMaxDate) {
	        _this.setState({
	          maxDate: currentMaxDate
	        });
	      }
	    });
	    var _parseFormat = (0, _parseFormat2.default)(props.dateFormat),
	      positions = _parseFormat.positions,
	      matches = _parseFormat.matches;
	    var defaultValue = props.defaultValue || Date.now();
	    var delay = props.changeDelay;
	    _this.throttleSetValue = delay == -1 ? _this.setValue : (0, _throttle.default)(_this.setValue, delay);
	    var _this$getMinMax3 = _this.getMinMax(props),
	      minDate = _this$getMinMax3.minDate,
	      maxDate = _this$getMinMax3.maxDate;
	    _this.state = {
	      positions: positions,
	      matches: matches,
	      propsValue: props.value !== undefined,
	      value: defaultValue,
	      minDate: minDate,
	      maxDate: maxDate
	    };
	    _this.dateFormatInputRef = (0, _react.createRef)();
	    return _this;
	  }
	  (0, _createClass2.default)(DateFormatInput, [{
	    key: "getMinMax",
	    value: function getMinMax(props) {
	      props = props || this.props;
	      var minDate = null;
	      if (props.minDate) {
	        minDate = this.toMoment(props.minDate, props);
	      }
	      var maxDate = null;
	      if (props.maxDate) {
	        maxDate = this.toMoment(props.maxDate, props);
	      }
	      return {
	        minDate: minDate,
	        maxDate: maxDate
	      };
	    }
	  }, {
	    key: "toMoment",
	    value: function toMoment(value, props) {
	      props = props || this.props;
	      return (0, _toMoment2.default)(value, {
	        locale: props.locale,
	        dateFormat: props.dateFormat === undefined ? this.props.dateFormat : props.dateFormat
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var value = this.state.propsValue ? props.value : this.state.value;
	      var displayValue = this.displayValue = this.toMoment(value).format(props.dateFormat);
	      var className = (0, _join.default)(props.className, props.rootClassName, "".concat(props.rootClassName, "--theme-").concat(props.theme));
	      var inputProps = (0, _assign.default)({}, props);
	      delete inputProps.changeDelay;
	      delete inputProps.date;
	      delete inputProps.dateFormat;
	      delete inputProps.isDateInput;
	      delete inputProps.maxDate;
	      delete inputProps.minDate;
	      delete inputProps.stopPropagation;
	      delete inputProps.updateOnWheel;
	      delete inputProps.theme;
	      delete inputProps.rootClassName;
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(inputProps);
	      }
	      return _react.default.createElement("input", _objectSpread(_objectSpread({}, inputProps), {}, {
	        ref: this.dateFormatInputRef,
	        defaultValue: undefined,
	        onFocus: this.onFocus,
	        onBlur: this.onBlur,
	        value: displayValue,
	        onKeyDown: this.onKeyDown,
	        onWheel: this.onWheel,
	        onChange: this.onChange,
	        className: className
	      }));
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.dateFormatInputRef.current.focus();
	    }
	  }, {
	    key: "onFocus",
	    value: function onFocus(event) {
	      if (this.props.onFocus) {
	        this.props.onFocus(event);
	      }
	      this.setState({
	        focused: true
	      });
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur(event) {
	      if (this.props.onBlur) {
	        this.props.onBlur(event);
	      }
	      this.setState({
	        focused: false
	      });
	    }
	  }, {
	    key: "isFocused",
	    value: function isFocused() {
	      return this.state.focused;
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(event) {
	      event.stopPropagation();
	    }
	  }, {
	    key: "onDirection",
	    value: function onDirection(dir) {
	      var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      this.onKeyDown({
	        key: dir > 0 ? 'ArrowUp' : 'ArrowDown',
	        type: event.type || 'unknown',
	        stopPropagation: typeof event.stopPropagation == 'function' ? function () {
	          return event.stopPropagation();
	        } : emptyFn,
	        preventDefault: typeof event.preventDefault == 'function' ? function () {
	          return event.preventDefault();
	        } : emptyFn
	      });
	    }
	  }, {
	    key: "onWheel",
	    value: function onWheel(event) {
	      if (this.props.updateOnWheel && this.isFocused()) {
	        this.onDirection(-event.deltaY, event);
	      }
	      if (this.props.onWheel) {
	        this.props.onWheel(event);
	      }
	    }
	  }, {
	    key: "onKeyDown",
	    value: function onKeyDown(event) {
	      var _this2 = this;
	      var props = this.props;
	      var key = event.key,
	        type = event.type,
	        which = event.which;
	      if (key !== 'Unidentified' && which && which >= 65 && which <= 90) {
	        key = ' ';
	      }
	      if (key != ' ' && key * 1 == key) {
	        key = 'Unidentified';
	      }
	      if (props.stopPropagation) {
	        event.stopPropagation();
	      }
	      var range = this.getSelectedRange();
	      var selectedValue = this.getSelectedValue(range);
	      var value = this.displayValue;
	      var _this$state = this.state,
	        positions = _this$state.positions,
	        matches = _this$state.matches;
	      var valueStr = "".concat(value);
	      var currentPosition = positions[range.start];
	      if (typeof currentPosition == 'string') {
	        currentPosition = positions[range.start + (key in BACKWARDS ? -1 : 1)];
	      }
	      if (!currentPosition) {
	        currentPosition = positions[range.start - 1];
	      }
	      if (props.onKeyDown && type == 'keydown') {
	        if (props.onKeyDown(event, currentPosition) === false) {
	          this.caretPos = range;
	          return;
	        }
	      }
	      var keyName = key;
	      if (key == 'ArrowUp' || key == 'ArrowDown') {
	        keyName = 'Arrow';
	      }
	      var handlerName = "handle".concat(keyName);
	      var preventDefault;
	      var newValue;
	      var newCaretPos;
	      if (currentPosition && currentPosition[handlerName]) {
	        var returnValue = currentPosition[handlerName](currentPosition, {
	          range: range,
	          selectedValue: selectedValue,
	          value: value,
	          positions: positions,
	          currentValue: valueStr.substring(currentPosition.start, currentPosition.end + 1),
	          matches: matches,
	          event: event,
	          key: key,
	          input: this.getInput(),
	          setCaretPosition: function setCaretPosition() {
	            return _this2.setCaretPosition.apply(_this2, arguments);
	          }
	        });
	        this.caretPos = range;
	        if (returnValue && returnValue.value !== undefined) {
	          newValue = valueStr.substring(0, currentPosition.start) + returnValue.value + valueStr.substring(currentPosition.end + 1);
	          newCaretPos = returnValue.caretPos || range;
	          if (newCaretPos === true) {
	            newCaretPos = {
	              start: currentPosition.start,
	              end: currentPosition.end + 1
	            };
	          }
	          preventDefault = returnValue.preventDefault !== false;
	        }
	      }
	      if (preventDefault || key == 'Backspace' || key == 'Delete' || key == ' ') {
	        if (!preventDefault) {
	          this.setCaretPosition(this.caretPos = {
	            start: range.start + (key == 'Backspace' ? -1 : 1)
	          });
	        }
	        preventDefault = true;
	      }
	      var config = {
	        currentPosition: currentPosition,
	        preventDefault: preventDefault,
	        event: event,
	        value: newValue,
	        stop: false
	      };
	      if (this.props.afterKeyDown && type == 'keydown') {
	        this.props.afterKeyDown(config);
	      }
	      if (!config.stop && newCaretPos !== undefined) {
	        var updateCaretPos = function updateCaretPos() {
	          return _this2.setCaretPosition(newCaretPos);
	        };
	        this.caretPos = newCaretPos;
	        this.setStateValue(newValue, updateCaretPos, {
	          key: key,
	          oldValue: valueStr,
	          currentPosition: currentPosition
	        });
	      }
	      if (config.preventDefault) {
	        event.preventDefault();
	      }
	    }
	  }, {
	    key: "getInput",
	    value: function getInput() {
	      return this.dateFormatInputRef.current;
	    }
	  }, {
	    key: "setCaretPosition",
	    value: function setCaretPosition(pos) {
	      var dom = this.getInput();
	      if (dom) {
	        (0, _TimeInput.setCaretPosition)(dom, pos);
	      }
	    }
	  }, {
	    key: "format",
	    value: function format(mom) {
	      var _format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.dateFormat;
	      return mom.format(_format);
	    }
	  }, {
	    key: "setStateValue",
	    value: function setStateValue(value, callback, _ref) {
	      var key = _ref.key,
	        oldValue = _ref.oldValue,
	        currentPosition = _ref.currentPosition;
	      var dateMoment = this.toMoment(value);
	      if (!dateMoment.isValid()) {
	        var dir = key == 'ArrowUp' || key == 'PageUp' ? 1 : -1;
	        if (currentPosition.format == 'MM') {
	          dateMoment = this.toMoment(oldValue).add(dir, 'month');
	        } else {
	          dateMoment = dir > 0 ? this.toMoment(oldValue).date(1) : this.toMoment(oldValue).endOf('month');
	        }
	        if (!dateMoment.isValid()) {
	          return;
	        }
	        value = this.format(dateMoment);
	      }
	      var _this$state2 = this.state,
	        minDate = _this$state2.minDate,
	        maxDate = _this$state2.maxDate;
	      if (minDate && dateMoment.isBefore(minDate)) {
	        var clone = this.toMoment(dateMoment);
	        dateMoment = (0, _forwardTime.default)(clone, this.toMoment(minDate));
	        if (dateMoment.isBefore(minDate)) {
	          dateMoment = this.toMoment(minDate);
	        }
	        value = this.format(dateMoment);
	      }
	      if (maxDate && dateMoment.isAfter(maxDate)) {
	        var _clone = this.toMoment(dateMoment);
	        dateMoment = (0, _forwardTime.default)(_clone, this.toMoment(maxDate));
	        if (dateMoment.isAfter(maxDate)) {
	          dateMoment = this.toMoment(maxDate);
	        }
	        value = this.format(dateMoment);
	      }
	      this.setState({
	        value: value,
	        propsValue: false
	      }, typeof callback == 'function' && callback);
	      if (this.props.onChange) {
	        this.throttleSetValue(value, dateMoment);
	      }
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value, dateMoment) {
	      if (this.props.value === undefined) {
	        this.setState({
	          value: value,
	          propsValue: false
	        });
	      } else {
	        this.setState({
	          propsValue: true,
	          value: undefined
	        });
	      }
	      if (this.props.onChange) {
	        this.props.onChange(value, {
	          dateMoment: dateMoment || this.toMoment(value)
	        });
	      }
	    }
	  }, {
	    key: "getSelectedRange",
	    value: function getSelectedRange() {
	      var dom = this.getInput();
	      return {
	        start: (0, _TimeInput.getSelectionStart)(dom),
	        end: (0, _TimeInput.getSelectionEnd)(dom)
	      };
	    }
	  }, {
	    key: "getSelectedValue",
	    value: function getSelectedValue(range) {
	      range = range || this.getSelectedRange();
	      var value = this.displayValue;
	      return value.substring(range.start, range.end);
	    }
	  }]);
	  return DateFormatInput;
	}(_reactClass.default);
	exports.default = DateFormatInput;
	DateFormatInput.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__input',
	  theme: 'default',
	  isDateInput: true,
	  stopPropagation: true,
	  updateOnWheel: true,
	  changeDelay: 100
	};
	DateFormatInput.propTypes = {
	  isDateInput: _propTypes.default.bool,
	  rootClassName: _propTypes.default.string,
	  theme: _propTypes.default.string,
	  stopPropagation: _propTypes.default.bool,
	  updateOnWheel: _propTypes.default.bool,
	  dateFormat: _propTypes.default.string.isRequired,
	  value: function value(props, propName) {
	    if (props[propName] !== undefined) {}
	  }
	};

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.onChange = exports.onActiveDateChange = exports.navigate = exports.isValidActiveDate = exports.isDateInMinMax = exports.gotoViewDate = exports.getInitialState = exports.default = exports.confirm = void 0;
	Object.defineProperty(exports, "onKeyDown", {
	  enumerable: true,
	  get: function get() {
	    return _onKeyDown.default;
	  }
	});
	exports.select = exports.prepareViewDate = exports.prepareMinMax = exports.prepareDateProps = exports.prepareDate = exports.prepareActiveDate = exports.onViewDateChange = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _moment = _interopRequireDefault(__webpack_require__(3));
	var _Flex = __webpack_require__(41);
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _times = _interopRequireDefault(__webpack_require__(111));
	var _toMoment2 = _interopRequireDefault(__webpack_require__(40));
	var _onKeyDown = _interopRequireDefault(__webpack_require__(234));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var ARROWS = {
	  prev: _react.default.createElement("svg", {
	    width: "5",
	    height: "10",
	    viewBox: "0 0 5 10"
	  }, _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M.262 4.738L4.368.632c.144-.144.379-.144.524 0C4.96.702 5 .796 5 .894v8.212c0 .204-.166.37-.37.37-.099 0-.193-.039-.262-.108L.262 5.262c-.145-.145-.145-.38 0-.524z"
	  })),
	  next: _react.default.createElement("svg", {
	    width: "5",
	    height: "10",
	    viewBox: "0 0 5 10"
	  }, _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M4.738 5.262L.632 9.368c-.144.144-.379.144-.524 0C.04 9.298 0 9.204 0 9.106V.894C0 .69.166.524.37.524c.099 0 .193.039.262.108l4.106 4.106c.145.145.145.38 0 .524z"
	  }))
	};
	var getDecadeStartYear = function getDecadeStartYear(mom) {
	  var year = mom.get('year');
	  return year - year % 10;
	};
	var getDecadeEndYear = function getDecadeEndYear(mom) {
	  return getDecadeStartYear(mom) + 9;
	};
	var NAV_KEYS = {
	  ArrowUp: function ArrowUp(mom) {
	    return mom.add(-5, 'year');
	  },
	  ArrowDown: function ArrowDown(mom) {
	    return mom.add(5, 'year');
	  },
	  ArrowLeft: function ArrowLeft(mom) {
	    return mom.add(-1, 'year');
	  },
	  ArrowRight: function ArrowRight(mom) {
	    return mom.add(1, 'year');
	  },
	  Home: function Home(mom) {
	    return mom.set('year', getDecadeStartYear(mom));
	  },
	  End: function End(mom) {
	    return mom.set('year', getDecadeEndYear(mom));
	  },
	  PageUp: function PageUp(mom) {
	    return mom.add(-10, 'year');
	  },
	  PageDown: function PageDown(mom) {
	    return mom.add(10, 'year');
	  }
	};
	var isDateInMinMax = function isDateInMinMax(timestamp, props) {
	  if (props.minDate && timestamp < props.minDate) {
	    return false;
	  }
	  if (props.maxDate && timestamp > props.maxDate) {
	    return false;
	  }
	  return true;
	};
	exports.isDateInMinMax = isDateInMinMax;
	var isValidActiveDate = function isValidActiveDate(timestamp, props) {
	  if (!props) {
	    throw new Error('props is mandatory in isValidActiveDate');
	  }
	  return isDateInMinMax(timestamp, props);
	};
	exports.isValidActiveDate = isValidActiveDate;
	var _select = function select(_ref, event) {
	  var dateMoment = _ref.dateMoment,
	    timestamp = _ref.timestamp;
	  if (this.props.select) {
	    return this.props.select({
	      dateMoment: dateMoment,
	      timestamp: timestamp
	    }, event);
	  }
	  if (!timestamp) {
	    timestamp = +dateMoment;
	  }
	  this.gotoViewDate({
	    dateMoment: dateMoment,
	    timestamp: timestamp
	  });
	  this.onChange({
	    dateMoment: dateMoment,
	    timestamp: timestamp
	  }, event);
	  return undefined;
	};
	exports.select = _select;
	var _confirm = function confirm(date, event) {
	  event.preventDefault();
	  if (this.props.confirm) {
	    return this.props.confirm(date, event);
	  }
	  var dateMoment = this.toMoment(date);
	  var timestamp = +dateMoment;
	  this.select({
	    dateMoment: dateMoment,
	    timestamp: timestamp
	  }, event);
	  if (this.props.onConfirm) {
	    this.props.onConfirm({
	      dateMoment: dateMoment,
	      timestamp: timestamp
	    });
	  }
	  return undefined;
	};
	exports.confirm = _confirm;
	var _onActiveDateChange = function onActiveDateChange(_ref2) {
	  var dateMoment = _ref2.dateMoment,
	    timestamp = _ref2.timestamp;
	  if (!isValidActiveDate(timestamp, this.p)) {
	    return;
	  }
	  if (this.props.activeDate === undefined) {
	    this.setState({
	      activeDate: timestamp
	    });
	  }
	  if (this.props.onActiveDateChange) {
	    var dateString = this.format(dateMoment);
	    this.props.onActiveDateChange(dateString, {
	      dateMoment: dateMoment,
	      timestamp: timestamp,
	      dateString: dateString
	    });
	  }
	};
	exports.onActiveDateChange = _onActiveDateChange;
	var _onViewDateChange = function onViewDateChange(_ref3) {
	  var dateMoment = _ref3.dateMoment,
	    timestamp = _ref3.timestamp;
	  if (dateMoment && timestamp === undefined) {
	    timestamp = +dateMoment;
	  }
	  if (this.props.constrainViewDate && !isDateInMinMax(timestamp, this.p)) {
	    return;
	  }
	  if (this.props.viewDate === undefined) {
	    this.setState({
	      viewDate: timestamp
	    });
	  }
	  if (this.props.onViewDateChange) {
	    var dateString = this.format(dateMoment);
	    this.props.onViewDateChange(dateString, {
	      dateMoment: dateMoment,
	      dateString: dateString,
	      timestamp: timestamp
	    });
	  }
	};
	exports.onViewDateChange = _onViewDateChange;
	var _onChange = function onChange(_ref4, event) {
	  var dateMoment = _ref4.dateMoment,
	    timestamp = _ref4.timestamp;
	  if (this.props.date === undefined) {
	    this.setState({
	      date: timestamp
	    });
	  }
	  if (this.props.onChange) {
	    var dateString = this.format(dateMoment);
	    this.props.onChange(dateString, {
	      dateMoment: dateMoment,
	      timestamp: timestamp,
	      dateString: dateString
	    }, event);
	  }
	};
	exports.onChange = _onChange;
	var _navigate = function navigate(direction, event) {
	  var _this = this;
	  var props = this.p;
	  var getNavigationDate = function getNavigationDate(dir, date, dateFormat) {
	    var mom = _moment.default.isMoment(date) ? date : _this.toMoment(date, dateFormat);
	    if (typeof dir == 'function') {
	      return dir(mom);
	    }
	    return mom;
	  };
	  if (props.navigate) {
	    return props.navigate(direction, event, getNavigationDate);
	  }
	  event.preventDefault();
	  if (props.activeDate) {
	    var nextMoment = getNavigationDate(direction, props.activeDate);
	    this.gotoViewDate({
	      dateMoment: nextMoment
	    });
	  }
	  return undefined;
	};
	exports.navigate = _navigate;
	var _gotoViewDate = function gotoViewDate(_ref5) {
	  var dateMoment = _ref5.dateMoment,
	    timestamp = _ref5.timestamp;
	  if (!timestamp) {
	    timestamp = dateMoment == null ? null : +dateMoment;
	  }
	  this.onViewDateChange({
	    dateMoment: dateMoment,
	    timestamp: timestamp
	  });
	  this.onActiveDateChange({
	    dateMoment: dateMoment,
	    timestamp: timestamp
	  });
	};
	exports.gotoViewDate = _gotoViewDate;
	var prepareDate = function prepareDate(props, state) {
	  return props.date === undefined ? state.date : props.date;
	};
	exports.prepareDate = prepareDate;
	var prepareViewDate = function prepareViewDate(props, state) {
	  var viewDate = props.viewDate === undefined ? state.viewDate : props.viewDate;
	  if (!viewDate && props.date) {
	    return props.date;
	  }
	  return viewDate;
	};
	exports.prepareViewDate = prepareViewDate;
	var prepareActiveDate = function prepareActiveDate(props, state) {
	  var activeDate = props.activeDate === undefined ? state.activeDate || prepareDate(props, state) : props.activeDate;
	  return activeDate;
	};
	exports.prepareActiveDate = prepareActiveDate;
	var prepareMinMax = function prepareMinMax(props) {
	  var minDate = props.minDate,
	    maxDate = props.maxDate;
	  var result = {};
	  if (minDate != null) {
	    result.minDateMoment = (0, _toMoment2.default)(props.minDate, props).startOf(props.adjustMinDateStartOf);
	    result.minDate = +result.minDateMoment;
	  }
	  if (maxDate != null) {
	    result.maxDateMoment = (0, _toMoment2.default)(props.maxDate, props).endOf(props.adjustMaxDateStartOf);
	    result.maxDate = +result.maxDateMoment;
	  }
	  return result;
	};
	exports.prepareMinMax = prepareMinMax;
	var prepareDateProps = function prepareDateProps(props, state) {
	  var result = {};
	  (0, _assign.default)(result, prepareMinMax(props));
	  result.date = prepareDate(props, state);
	  result.viewDate = prepareViewDate(props, state);
	  var activeDate = prepareActiveDate(props, state);
	  if (result.date != null) {
	    result.moment = (0, _toMoment2.default)(result.date, props);
	    if (props.adjustDateStartOf) {
	      result.moment.startOf(props.adjustDateStartOf);
	    }
	    result.timestamp = +result.moment;
	  }
	  if (activeDate) {
	    result.activeMoment = (0, _toMoment2.default)(activeDate, props);
	    if (props.adjustDateStartOf) {
	      result.activeMoment.startOf(props.adjustDateStartOf);
	    }
	    result.activeDate = +result.activeMoment;
	  }
	  var viewMoment = (0, _toMoment2.default)(result.viewDate, props);
	  if (props.constrainViewDate && result.minDate != null && viewMoment.isBefore(result.minDate)) {
	    result.minConstrained = true;
	    viewMoment = (0, _toMoment2.default)(result.minDate, props);
	  }
	  if (props.constrainViewDate && result.maxDate != null && viewMoment.isAfter(result.maxDate)) {
	    result.maxConstrained = true;
	    viewMoment = (0, _toMoment2.default)(result.maxDate, props);
	  }
	  if (props.adjustDateStartOf) {
	    viewMoment.startOf(props.adjustDateStartOf);
	  }
	  result.viewMoment = viewMoment;
	  return result;
	};
	exports.prepareDateProps = prepareDateProps;
	var getInitialState = function getInitialState(props) {
	  return {
	    date: props.defaultDate,
	    activeDate: props.defaultActiveDate,
	    viewDate: props.defaultViewDate
	  };
	};
	exports.getInitialState = getInitialState;
	var DecadeView = function (_Component) {
	  (0, _inherits2.default)(DecadeView, _Component);
	  var _super = _createSuper(DecadeView);
	  function DecadeView(props) {
	    var _this2;
	    (0, _classCallCheck2.default)(this, DecadeView);
	    _this2 = _super.call(this, props);
	    _this2.decadeViewRef = (0, _react.createRef)();
	    _this2.state = getInitialState(props);
	    return _this2;
	  }
	  (0, _createClass2.default)(DecadeView, [{
	    key: "getYearsInDecade",
	    value: function getYearsInDecade(value) {
	      var _this3 = this;
	      var year = getDecadeStartYear(this.toMoment(value));
	      var start = this.toMoment("".concat(year), 'YYYY').startOf('year');
	      return (0, _times.default)(10).map(function (i) {
	        return _this3.toMoment(start).add(i, 'year');
	      });
	    }
	  }, {
	    key: "toMoment",
	    value: function toMoment(date, format) {
	      return (0, _toMoment2.default)(date, format, this.props);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.p = (0, _assign.default)({}, this.props);
	      if (props.onlyCompareYear) {}
	      var dateProps = prepareDateProps(props, this.state);
	      (0, _assign.default)(props, dateProps);
	      var yearsInView = this.getYearsInDecade(props.viewMoment);
	      var rootClassName = props.rootClassName;
	      var className = (0, _join.default)(props.className, rootClassName, props.theme && "".concat(rootClassName, "--theme-").concat(props.theme));
	      var children = this.renderYears(props, yearsInView);
	      var align = 'stretch';
	      var column = true;
	      if (props.navigation) {
	        column = false;
	        align = 'center';
	        children = [this.renderNav(-1), _react.default.createElement(_Flex.Flex, {
	          key: "year_view",
	          inline: true,
	          flex: true,
	          column: true,
	          alignItems: "stretch",
	          children: children
	        }), this.renderNav(1)];
	      }
	      var flexProps = (0, _assign.default)({}, this.props);
	      delete flexProps.activeDate;
	      delete flexProps.adjustDateStartOf;
	      delete flexProps.adjustMaxDateStartOf;
	      delete flexProps.adjustMinDateStartOf;
	      delete flexProps.arrows;
	      delete flexProps.cleanup;
	      delete flexProps.constrainViewDate;
	      delete flexProps.date;
	      delete flexProps.dateFormat;
	      delete flexProps.isDecadeView;
	      delete flexProps.maxDate;
	      delete flexProps.minDate;
	      delete flexProps.navigation;
	      delete flexProps.navKeys;
	      delete flexProps.onActiveDateChange;
	      delete flexProps.onConfirm;
	      delete flexProps.onlyCompareYear;
	      delete flexProps.onViewDateChange;
	      delete flexProps.perRow;
	      delete flexProps.theme;
	      delete flexProps.viewDate;
	      delete flexProps.yearFormat;
	      delete flexProps.rootClassName;
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	      return _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({
	        inline: true,
	        ref: this.decadeViewRef,
	        column: column,
	        alignItems: align,
	        tabIndex: 0
	      }, flexProps), {}, {
	        onKeyDown: this.onKeyDown,
	        className: className,
	        children: children
	      }));
	    }
	  }, {
	    key: "renderNav",
	    value: function renderNav(dir) {
	      var _this4 = this;
	      var props = this.p;
	      var name = dir == -1 ? 'prev' : 'next';
	      var navMoment = this.toMoment(props.viewMoment).add(dir * 10, 'year');
	      var disabled = dir == -1 ? props.minDateMoment && getDecadeEndYear(navMoment) < getDecadeEndYear(props.minDateMoment) : props.maxDateMoment && getDecadeEndYear(navMoment) > getDecadeEndYear(props.maxDateMoment);
	      var rootClassName = props.rootClassName;
	      var className = (0, _join.default)("".concat(rootClassName, "-arrow"), "".concat(rootClassName, "-arrow--").concat(name), disabled && "".concat(rootClassName, "-arrow--disabled"));
	      var arrow = props.arrows[name] || ARROWS[name];
	      var arrowProps = {
	        className: className,
	        onClick: !disabled ? function () {
	          return _this4.onViewDateChange({
	            dateMoment: navMoment,
	            timestamp: _this4.toMoment(props.viewMoment)
	          });
	        } : null,
	        children: arrow,
	        disabled: disabled
	      };
	      if (props.renderNavigation) {
	        return props.renderNavigation(arrowProps, props);
	      }
	      return _react.default.createElement("div", _objectSpread({
	        key: "nav_arrow_".concat(dir)
	      }, arrowProps));
	    }
	  }, {
	    key: "renderYears",
	    value: function renderYears(props, years) {
	      var nodes = years.map(this.renderYear);
	      var perRow = props.perRow;
	      var buckets = (0, _times.default)(Math.ceil(nodes.length / perRow)).map(function (i) {
	        return nodes.slice(i * perRow, (i + 1) * perRow);
	      });
	      return buckets.map(function (bucket, i) {
	        return _react.default.createElement(_Flex.Flex, {
	          alignItems: "center",
	          flex: true,
	          row: true,
	          inline: true,
	          key: "row_".concat(i),
	          className: "".concat(props.rootClassName, "-row")
	        }, bucket);
	      });
	    }
	  }, {
	    key: "renderYear",
	    value: function renderYear(dateMoment) {
	      var props = this.p;
	      var yearText = this.format(dateMoment);
	      var timestamp = +dateMoment;
	      var isActiveDate = props.onlyCompareYear && props.activeMoment ? dateMoment.get('year') == props.activeMoment.get('year') : timestamp === props.activeDate;
	      var isValue = props.onlyCompareYear && props.moment ? dateMoment.get('year') == props.moment.get('year') : timestamp === props.timestamp;
	      var rootClassName = props.rootClassName;
	      var className = (0, _join.default)("".concat(rootClassName, "-year"), isActiveDate && "".concat(rootClassName, "-year--active"), isValue && "".concat(rootClassName, "-year--value"), props.minDate != null && timestamp < props.minDate && "".concat(rootClassName, "-year--disabled"), props.maxDate != null && timestamp > props.maxDate && "".concat(rootClassName, "-year--disabled"));
	      var onClick = this.handleClick.bind(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	      return _react.default.createElement(_Flex.Item, {
	        key: yearText,
	        className: className,
	        onClick: onClick
	      }, yearText);
	    }
	  }, {
	    key: "format",
	    value: function format(mom, _format) {
	      _format = _format || this.props.yearFormat;
	      return mom.format(_format);
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(_ref6, event) {
	      var timestamp = _ref6.timestamp,
	        dateMoment = _ref6.dateMoment;
	      event.target.value = timestamp;
	      var props = this.p;
	      if (props.minDate && timestamp < props.minDate) {
	        return;
	      }
	      if (props.maxDate && timestamp > props.maxDate) {
	        return;
	      }
	      this.select({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      }, event);
	    }
	  }, {
	    key: "onKeyDown",
	    value: function onKeyDown(event) {
	      return _onKeyDown.default.call(this, event);
	    }
	  }, {
	    key: "confirm",
	    value: function confirm(date, event) {
	      return _confirm.call(this, date, event);
	    }
	  }, {
	    key: "navigate",
	    value: function navigate(direction, event) {
	      return _navigate.call(this, direction, event);
	    }
	  }, {
	    key: "select",
	    value: function select(_ref7, event) {
	      var dateMoment = _ref7.dateMoment,
	        timestamp = _ref7.timestamp;
	      return _select.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      }, event);
	    }
	  }, {
	    key: "onViewDateChange",
	    value: function onViewDateChange(_ref8) {
	      var dateMoment = _ref8.dateMoment,
	        timestamp = _ref8.timestamp;
	      return _onViewDateChange.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "gotoViewDate",
	    value: function gotoViewDate(_ref9) {
	      var dateMoment = _ref9.dateMoment,
	        timestamp = _ref9.timestamp;
	      return _gotoViewDate.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "onActiveDateChange",
	    value: function onActiveDateChange(_ref10) {
	      var dateMoment = _ref10.dateMoment,
	        timestamp = _ref10.timestamp;
	      return _onActiveDateChange.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(_ref11, event) {
	      var dateMoment = _ref11.dateMoment,
	        timestamp = _ref11.timestamp;
	      return _onChange.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      }, event);
	    }
	  }, {
	    key: "getDOMNode",
	    value: function getDOMNode() {
	      return this.decadeViewRef.current;
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.decadeViewRef.current.focus();
	    }
	  }]);
	  return DecadeView;
	}(_reactClass.default);
	exports.default = DecadeView;
	DecadeView.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__decade-view',
	  isDecadeView: true,
	  arrows: {},
	  navigation: true,
	  constrainViewDate: true,
	  navKeys: NAV_KEYS,
	  theme: 'default',
	  yearFormat: 'YYYY',
	  dateFormat: 'YYYY-MM-DD',
	  perRow: 5,
	  onlyCompareYear: true,
	  adjustDateStartOf: 'year',
	  adjustMinDateStartOf: 'year',
	  adjustMaxDateStartOf: 'year'
	};
	DecadeView.propTypes = {
	  isDecadeView: _propTypes.default.bool,
	  rootClassName: _propTypes.default.string,
	  navigation: _propTypes.default.bool,
	  constrainViewDate: _propTypes.default.bool,
	  arrows: _propTypes.default.object,
	  navKeys: _propTypes.default.object,
	  theme: _propTypes.default.string,
	  yearFormat: _propTypes.default.string,
	  dateFormat: _propTypes.default.string,
	  perRow: _propTypes.default.number,
	  minDate: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object]),
	  maxDate: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object]),
	  viewDate: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object]),
	  date: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object]),
	  defaultDate: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object]),
	  viewMoment: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object]),
	  moment: _propTypes.default.object,
	  minDateMoment: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object]),
	  maxDateMoment: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object]),
	  onlyCompareYear: _propTypes.default.bool,
	  adjustDateStartOf: _propTypes.default.string,
	  adjustMinDateStartOf: _propTypes.default.string,
	  adjustMaxDateStartOf: _propTypes.default.string,
	  activeDate: _propTypes.default.number,
	  select: _propTypes.default.func,
	  confirm: _propTypes.default.func,
	  onConfirm: _propTypes.default.func,
	  onActiveDateChange: _propTypes.default.func,
	  onViewDateChange: _propTypes.default.func,
	  cleanup: _propTypes.default.func,
	  onChange: _propTypes.default.func,
	  renderNavigation: _propTypes.default.func,
	  navigate: _propTypes.default.func
	};

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.FooterButton = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _Flex = __webpack_require__(41);
	var _Button = _interopRequireDefault(__webpack_require__(149));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _joinFunctions = _interopRequireDefault(__webpack_require__(82));
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var numbers = [1];
	var SPACER = numbers.map(function (item, index) {
	  return _react.default.createElement(_Flex.Item, {
	    key: "footer_spacer_".concat(index * 37)
	  });
	});
	var preventDefault = function preventDefault(e) {
	  return e.preventDefault();
	};
	var FooterButton = function FooterButton(props) {
	  var disabledClassName = props.disabled ? "".concat(props.rootClassName, "-button--disabled") : '';
	  var cancelButtonClass = props.children === 'Cancel' ? "".concat(props.rootClassName, "-button-cancel") : '';
	  var todayButtonClass = props.children === 'Today' ? "".concat(props.rootClassName, "-button-today") : '';
	  var okButtonClass = props.children === 'OK' ? "".concat(props.rootClassName, "-button-ok") : '';
	  var className = (0, _join.default)(props.className || '', cancelButtonClass, todayButtonClass, okButtonClass, "".concat(props.rootClassName, "-button"), disabledClassName);
	  var buttonProps = _objectSpread({}, props);
	  delete buttonProps.rootClassName;
	  return _react.default.createElement(_Button.default, _objectSpread(_objectSpread({
	    tabIndex: -1
	  }, buttonProps), {}, {
	    className: className
	  }));
	};
	exports.FooterButton = FooterButton;
	var Footer = function (_Component) {
	  (0, _inherits2.default)(Footer, _Component);
	  var _super = _createSuper(Footer);
	  function Footer() {
	    (0, _classCallCheck2.default)(this, Footer);
	    return _super.apply(this, arguments);
	  }
	  (0, _createClass2.default)(Footer, [{
	    key: "render",
	    value: function render() {
	      var props = this.p = (0, _assign.default)({}, this.props);
	      var rootClassName = props.rootClassName;
	      var className = (0, _join.default)(props.className, rootClassName, "".concat(rootClassName, "--theme-").concat(props.theme), "".concat(rootClassName, "--button-cancel"));
	      var todayButton = this.renderTodayButton();
	      var clearButton = this.renderClearButton();
	      var okButton = this.renderOkButton();
	      var cancelButton = this.renderCancelButton();
	      if (!todayButton && !clearButton && !okButton && !cancelButton) {
	        return null;
	      }
	      var middleSpacer = okButton || cancelButton ? SPACER : null;
	      var spacer = !props.centerButtons ? middleSpacer : null;
	      var children = [props.centerButtons && SPACER, todayButton, clearButton, spacer, okButton, cancelButton, props.centerButtons && SPACER];
	      if (props.renderChildren) {
	        children = props.renderChildren(children, props);
	      }
	      var flexProps = (0, _assign.default)({}, props);
	      delete flexProps.rootClassName;
	      delete flexProps.actionEvent;
	      delete flexProps.buttonFactory;
	      delete flexProps.cancelButton;
	      delete flexProps.cancelButtonText;
	      delete flexProps.centerButtons;
	      delete flexProps.clearDate;
	      delete flexProps.cleanup;
	      delete flexProps.clearButton;
	      delete flexProps.clearButtonText;
	      delete flexProps.isDatePickerFooter;
	      delete flexProps.onCancelClick;
	      delete flexProps.onClearClick;
	      delete flexProps.onOkClick;
	      delete flexProps.onTodayClick;
	      delete flexProps.okButton;
	      delete flexProps.okButtonText;
	      delete flexProps.selectDate;
	      delete flexProps.theme;
	      delete flexProps.todayButton;
	      delete flexProps.todayButtonText;
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	      return _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({
	        key: "footer",
	        inline: true,
	        row: true
	      }, flexProps), {}, {
	        justifyContent: "center",
	        className: className,
	        children: children
	      }));
	    }
	  }, {
	    key: "renderTodayButton",
	    value: function renderTodayButton() {
	      if (!this.props.todayButton) {
	        return null;
	      }
	      var theme = this.props.theme;
	      return this.renderButton({
	        children: this.props.todayButtonText,
	        'data-name': 'today-button'
	      }, this.props.onTodayClick, theme);
	    }
	  }, {
	    key: "renderClearButton",
	    value: function renderClearButton() {
	      if (!this.props.clearButton) {
	        return null;
	      }
	      var theme = this.props.theme;
	      return this.renderButton({
	        children: this.props.clearButtonText,
	        disabled: this.props.clearDate === undefined,
	        'data-name': 'clear-button'
	      }, this.props.onClearClick, theme);
	    }
	  }, {
	    key: "renderOkButton",
	    value: function renderOkButton() {
	      if (!this.props.okButton) {
	        return null;
	      }
	      var theme = this.props.theme;
	      return this.renderButton({
	        children: this.props.okButtonText,
	        'data-name': 'ok-button'
	      }, this.props.onOkClick, theme);
	    }
	  }, {
	    key: "renderCancelButton",
	    value: function renderCancelButton() {
	      if (!this.props.cancelButton) {
	        return null;
	      }
	      var theme = this.props.theme;
	      return this.renderButton({
	        children: this.props.cancelButtonText,
	        'data-name': 'cancel-button'
	      }, this.props.onCancelClick, theme);
	    }
	  }, {
	    key: "renderButton",
	    value: function renderButton(props, fn, theme) {
	      var text = props.children;
	      var p = props;
	      if (typeof props == 'string') {
	        p = {};
	        text = props;
	      }
	      if (typeof fn == 'function' && !p.onClick && !p.disabled) {
	        p.onClick = fn;
	      }
	      var Factory = this.props.buttonFactory;
	      var onMouseDown = p.onMouseDown ? (0, _joinFunctions.default)(p.onMouseDown, preventDefault) : preventDefault;
	      return _react.default.createElement(Factory, _objectSpread(_objectSpread({
	        key: "footer_".concat(text),
	        tabIndex: 0
	      }, p), {}, {
	        rootClassName: this.props.rootClassName,
	        onMouseDown: onMouseDown,
	        theme: theme
	      }), text);
	    }
	  }]);
	  return Footer;
	}(_reactClass.default);
	exports.default = Footer;
	Footer.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__footer',
	  actionEvent: 'onClick',
	  theme: 'default',
	  buttonFactory: FooterButton,
	  todayButton: true,
	  clearButton: false,
	  okButton: true,
	  cancelButton: true,
	  todayButtonText: 'Today',
	  clearButtonText: 'Clear',
	  okButtonText: 'OK',
	  cancelButtonText: 'Cancel',
	  isDatePickerFooter: true
	};
	Footer.propTypes = {
	  isDatePickerFooter: _propTypes.default.bool,
	  rootClassName: _propTypes.default.string,
	  theme: _propTypes.default.string,
	  actionEvent: _propTypes.default.string,
	  centerButtons: _propTypes.default.bool,
	  buttonFactory: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	  clearDate: _propTypes.default.object,
	  okButtonText: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  clearButtonText: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  cancelButtonText: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  todayButtonText: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  todayButton: _propTypes.default.bool,
	  clearButton: _propTypes.default.bool,
	  okButton: _propTypes.default.bool,
	  cancelButton: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  onTodayClick: _propTypes.default.func,
	  onClearClick: _propTypes.default.func,
	  onOkClick: _propTypes.default.func,
	  onCancelClick: _propTypes.default.func,
	  renderChildren: _propTypes.default.func,
	  cleanup: _propTypes.default.func
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	Object.defineProperty(exports, "getNewValue", {
	  enumerable: true,
	  get: function get() {
	    return _getNewValue2.default;
	  }
	});
	Object.defineProperty(exports, "getSelectionEnd", {
	  enumerable: true,
	  get: function get() {
	    return _getSelectionEnd.default;
	  }
	});
	Object.defineProperty(exports, "getSelectionStart", {
	  enumerable: true,
	  get: function get() {
	    return _getSelectionStart.default;
	  }
	});
	Object.defineProperty(exports, "setCaretPosition", {
	  enumerable: true,
	  get: function get() {
	    return _setCaretPosition2.default;
	  }
	});
	Object.defineProperty(exports, "toTimeValue", {
	  enumerable: true,
	  get: function get() {
	    return _toTimeValue.default;
	  }
	});
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _raf = _interopRequireDefault(__webpack_require__(216));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _Clock = _interopRequireDefault(__webpack_require__(106));
	var _getSelectionStart = _interopRequireDefault(__webpack_require__(634));
	var _getSelectionEnd = _interopRequireDefault(__webpack_require__(633));
	var _setCaretPosition2 = _interopRequireDefault(__webpack_require__(635));
	var _getNewValue2 = _interopRequireDefault(__webpack_require__(632));
	var _toTimeValue = _interopRequireDefault(__webpack_require__(235));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var TimeInput = function (_Component) {
	  (0, _inherits2.default)(TimeInput, _Component);
	  var _super = _createSuper(TimeInput);
	  function TimeInput(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, TimeInput);
	    _this = _super.call(this, props);
	    var format = props.format || props.timeFormat;
	    _this.timeInputRef = (0, _react.createRef)();
	    if (format.indexOf('hh') != 0 && format.indexOf('HH') != 0 && format.indexOf('kk') != 0) {
	      console.warn('Please start your time format with 2 digit hours.');
	    }
	    var hours24 = true;
	    var meridiem = format.indexOf('a') != -1 || format.indexOf('A') != -1;
	    if (format.indexOf('hh') == 0 && format.indexOf('kk') == 0) {
	      hours24 = false;
	    }
	    var separator = props.separator || format && format.length > 2 ? format.charAt(2) : ':';
	    var hasSeconds = format.indexOf('ss') != -1;
	    if (hasSeconds && format.charAt(5) != separator) {
	      console.warn('Expected minutes-seconds separator to be same as hours-minutes separator. (at position 5)');
	    }
	    var defaultValue = "00".concat(separator, "00");
	    if (hasSeconds) {
	      defaultValue += "".concat(separator, "00");
	    }
	    if (meridiem) {
	      defaultValue += ' am';
	    }
	    _this.state = {
	      valueRange: props.valueRange || 0,
	      separator: separator,
	      hours24: hours24,
	      meridiem: meridiem,
	      value: props.defaultValue || defaultValue
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(TimeInput, [{
	    key: "render",
	    value: function render() {
	      var props = this.p = (0, _assign.default)({}, this.props);
	      props.value = this.state.value;
	      return _react.default.createElement("input", _objectSpread(_objectSpread({}, props), {}, {
	        ref: this.timeInputRef,
	        defaultValue: undefined,
	        value: props.value,
	        onKeyDown: this.onKeyDown,
	        onChange: this.onChange
	      }));
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(event) {
	      var value = event.target.value;
	    }
	  }, {
	    key: "onKeyDown",
	    value: function onKeyDown(event) {
	      var _this2 = this;
	      var value = this.p.value;
	      var valueRange = this.state.valueRange;
	      if (this.props.onKeyDown) {
	        this.props.onKeyDown(event);
	      }
	      var range = this.getSelectedRange();
	      var separator = this.props.separator || this.state.separator || ':';
	      var _getNewValue = (0, _getNewValue2.default)({
	          range: range,
	          event: event,
	          circular: this.props.circular,
	          propagate: this.props.propagate,
	          oldValue: value,
	          separator: separator,
	          meridiem: this.state.meridiem,
	          hours24: this.state.hours24,
	          incrementNext: this.props.incrementNext
	        }),
	        newValue = _getNewValue.value,
	        update = _getNewValue.update,
	        caretPos = _getNewValue.caretPos;
	      var updateCaretPos = function updateCaretPos() {
	        if (caretPos != undefined) {
	          _this2.setCaretPosition(caretPos);
	        }
	      };
	      if (update || caretPos) {
	        event.preventDefault();
	      }
	      if (update) {
	        this.setValue(newValue, updateCaretPos);
	      } else {
	        (0, _raf.default)(updateCaretPos);
	      }
	    }
	  }, {
	    key: "getInput",
	    value: function getInput() {
	      return this.timeInputRef.current;
	    }
	  }, {
	    key: "setCaretPosition",
	    value: function setCaretPosition(pos) {
	      var dom = this.getInput();
	      dom && (0, _setCaretPosition2.default)(dom, pos);
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value, callback) {
	      this.setState({
	        now: Date.now(),
	        value: value
	      }, typeof callback == 'function' && callback);
	      if (this.props.onChange) {
	        this.props.onChange(value);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.updateCallback) {
	        this.updateCallback();
	        this.updateCallback = null;
	      }
	    }
	  }, {
	    key: "getSelectedRange",
	    value: function getSelectedRange() {
	      var dom = this.getInput();
	      return {
	        start: (0, _getSelectionStart.default)(dom),
	        end: (0, _getSelectionEnd.default)(dom)
	      };
	    }
	  }, {
	    key: "getSelectedValue",
	    value: function getSelectedValue() {
	      var range = this.getSelectedRange();
	      var value = this.p.value;
	      return value.substring(range.start, range.end);
	    }
	  }, {
	    key: "onTimeChange",
	    value: function onTimeChange(value) {
	      var time = value.split(':');
	      this.setState({
	        minutes: time[0] * 60 + time[1]
	      });
	    }
	  }, {
	    key: "renderClock",
	    value: function renderClock() {
	      var props = this.p;
	      var clock = props.children.filter(function (child) {
	        return child && child.props && child.props.isTimePickerClock;
	      })[0];
	      var clockProps = {
	        time: this.state.minutes || props.date,
	        showSecondsHand: true
	      };
	      if (clock) {
	        return _react.default.cloneElement(clock, clockProps);
	      }
	      return _react.default.createElement(_Clock.default, _objectSpread({}, clockProps));
	    }
	  }]);
	  return TimeInput;
	}(_reactClass.default);
	exports.default = TimeInput;
	TimeInput.defaultProps = {
	  theme: 'default',
	  circular: true,
	  propagate: true,
	  incrementNext: true
	};
	TimeInput.propTypes = {
	  theme: _propTypes.default.string,
	  circular: _propTypes.default.bool,
	  propagate: _propTypes.default.bool,
	  incrementNext: _propTypes.default.bool,
	  format: _propTypes.default.string,
	  value: function value(props, propName) {
	    if (props[propName] !== undefined) {
	      console.warn('Due to performance considerations, TimeInput will only be uncontrolled.');
	    }
	  }
	};

/***/ },
/* 154 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(str) {
	  if (typeof str == 'string' && str.length < 2) {
	    return str.length ? "0".concat(str) : '00';
	  }
	  if (typeof str == 'number') {
	    return str < 10 ? "0".concat(str) : "".concat(str);
	  }
	  return str;
	};
	exports.default = _default;

/***/ },
/* 155 */
[1296, 644],
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var MenuItemCell = function (_Component) {
	  (0, _inherits2.default)(MenuItemCell, _Component);
	  var _super = _createSuper(MenuItemCell);
	  function MenuItemCell() {
	    (0, _classCallCheck2.default)(this, MenuItemCell);
	    return _super.apply(this, arguments);
	  }
	  (0, _createClass2.default)(MenuItemCell, [{
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var cellProps = props.cellProps,
	        rootClassName = props.rootClassName,
	        align = props.align,
	        rtl = props.rtl;
	      var children = props.expander || props.children;
	      var className = (0, _join.default)(props.className, cellProps.className, "".concat(rootClassName, "__cell"), rtl ? "".concat(rootClassName, "__cell--rtl") : "".concat(rootClassName, "__cell--ltr"), props.isDescription && "".concat(rootClassName, "__cell--secondaryLabel"), props.isIcon && "".concat(rootClassName, "__cell--icon"));
	      var style = _objectSpread(_objectSpread({}, props.style), cellProps.style);
	      if (align) {
	        style.textAlign = align;
	      }
	      return _react.default.createElement("td", _objectSpread(_objectSpread(_objectSpread({}, (0, _cleanProps.default)(props, MenuItemCell.propTypes)), cellProps), {}, {
	        style: style,
	        className: className
	      }), children);
	    }
	  }]);
	  return MenuItemCell;
	}(_reactClass.default);
	exports.default = MenuItemCell;
	MenuItemCell.defaultProps = {
	  cellProps: {}
	};
	MenuItemCell.propTypes = {
	  isDescription: _propTypes.default.bool,
	  isIcon: _propTypes.default.bool,
	  rootClassName: _propTypes.default.string,
	  column: _propTypes.default.object,
	  cellProps: _propTypes.default.object,
	  rtl: _propTypes.default.bool,
	  expander: _propTypes.default.node,
	  align: _propTypes.default.oneOf(['start', 'end', 'center', 'left', 'right'])
	};

/***/ },
/* 157 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var DOCUMENT_POSITION_CONTAINED_BY = 16;
	var _default = contains;
	exports.default = _default;
	function contains(container, elem) {
	  if (container.contains) {
	    return container.contains(elem);
	  }
	  var comparison = container.compareDocumentPosition(elem);
	  return comparison === 0 || comparison & DOCUMENT_POSITION_CONTAINED_BY;
	}

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sticky = exports.default = void 0;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var div = globalObject.document && globalObject.document.createElement ? globalObject.document.createElement('div') : null;
	var HAS_STICKY = false;
	var sticky;
	exports.sticky = sticky;
	if (div) {
	  div.style.position = 'sticky';
	  if (div.style.position === 'sticky') {
	    exports.sticky = sticky = 'sticky';
	    HAS_STICKY = true;
	  }
	  if (!HAS_STICKY) {
	    div.style.position = '-webkit-sticky';
	    if (div.style.position === '-webkit-sticky') {
	      HAS_STICKY = true;
	      exports.sticky = sticky = '-webkit-sticky';
	    }
	  }
	}
	var _default = function _default() {
	  return HAS_STICKY;
	};
	exports.default = _default;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var IS_SAFARI;
	var _default = function _default() {
	  if (IS_SAFARI !== undefined) {
	    return IS_SAFARI;
	  }
	  var ua = globalObject.navigator ? globalObject.navigator.userAgent : '';
	  return IS_SAFARI = ua.indexOf('Safari') !== -1 && ua.indexOf('Chrome') === -1;
	};
	exports.default = _default;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _reactDom = _interopRequireDefault(__webpack_require__(37));
	var _react = __webpack_require__(2);
	var _default = function _default(menu, computedProps, menusRef) {
	  var menuPortalContainer = computedProps.menuPortalContainer;
	  var didMount = menu ? menu.props.componentDidMount : null;
	  var willUnmount = menu ? menu.props.componentWillUnmount : null;
	  if (menu) {
	    menu = (0, _react.cloneElement)(menu, {
	      rtl: computedProps.rtl,
	      componentDidMount: function componentDidMount() {
	        if (didMount) {
	          didMount.apply(void 0, arguments);
	        }
	        menusRef = menusRef || computedProps.menusRef;
	        var menuInstance = arguments.length <= 0 ? undefined : arguments[0];
	        menusRef.current.push(menuInstance);
	      },
	      componentWillUnmount: function componentWillUnmount() {
	        if (willUnmount) {
	          willUnmount.apply(void 0, arguments);
	        }
	        var menuInstance = arguments.length <= 0 ? undefined : arguments[0];
	        menusRef = menusRef || computedProps.menusRef;
	        menusRef.current = menusRef.current.filter(function (it) {
	          return it !== menuInstance;
	        });
	      }
	    });
	  }
	  if (menuPortalContainer && _reactDom.default.createPortal) {
	    var container = menuPortalContainer;
	    if (typeof container === 'string') {
	      container = document.querySelector(container);
	    }
	    if (container) {
	      return _reactDom.default.createPortal(menu, container);
	    }
	  }
	  return menu;
	};
	exports.default = _default;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(821);

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(45);
	var normalizeHeaderName = __webpack_require__(835);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(280);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(280);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dialog = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Dialog, _React$Component);
	
	  function Dialog() {
	    _classCallCheck(this, Dialog);
	
	    var _this = _possibleConstructorReturn(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this));
	
	    _this.closeDialog = _this.closeDialog.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dialog, [{
	    key: 'closeDialog',
	    value: function closeDialog(e) {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      e.preventDefault();
	
	      // Clear out session storage and redirect if the session has expired
	      if (SessionStore.dialogContent.code === '5002' || SessionStore.dialogContent.code === '5003') {
	        sessionStorage.removeItem('token');
	        sessionStorage.removeItem('iam');
	        sessionStorage.removeItem('userData');
	        sessionStorage.removeItem('registerData');
	        this.props.routing.history.push('/account/sign-in');
	      }
	
	      // Remove dialog
	      this.props.store.SessionStore.closeDialog();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          LocationStore = _props$store.LocationStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dialog' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dialog__content' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'dialog__msg' },
	            SessionStore.dialogContent.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            SessionStore.dialogContent.body
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: '#app', className: 'btn', onClick: function onClick(e) {
	                return _this2.closeDialog(e);
	              } },
	            SessionStore.dialogContent.button
	          ),
	          SessionStore.dialogContent.typeForm && _react2.default.createElement(
	            'a',
	            {
	              className: 'btn btn--outline',
	              href: 'https://smarterservices.typeform.com/to/nsgGZf?proctorlocationsid=' + LocationStore.locationSid + '&proctoraccountsid=' + SessionStore.userData.proctorAccountSid + '&proctorusersid=' + SessionStore.userData.sid + '&firstname=' + SessionStore.userData.firstName + '&lastname=' + SessionStore.userData.lastName + '&email=' + SessionStore.userData.email,
	              target: '_blank'
	            },
	            'Contact us'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Dialog;
	}(_react2.default.Component));
	
	exports.default = Dialog;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Loader = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Loader, _React$Component);
	
	  function Loader() {
	    _classCallCheck(this, Loader);
	
	    return _possibleConstructorReturn(this, (Loader.__proto__ || Object.getPrototypeOf(Loader)).apply(this, arguments));
	  }
	
	  _createClass(Loader, [{
	    key: 'render',
	    value: function render() {
	      var store = this.props.store;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'loader ' + store.SessionStore.loadingClass },
	        _react2.default.createElement(
	          'strong',
	          { className: 'loader__msg' },
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            store.SessionStore.loadingMessage
	          )
	        )
	      );
	    }
	  }]);
	
	  return Loader;
	}(_react2.default.Component));
	
	exports.default = Loader;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var Password = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Password, _React$Component);
	
	  function Password() {
	    _classCallCheck(this, Password);
	
	    return _possibleConstructorReturn(this, (Password.__proto__ || Object.getPrototypeOf(Password)).apply(this, arguments));
	  }
	
	  _createClass(Password, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        valid: false
	      };
	    }
	  }, {
	    key: 'checkPassword',
	    value: function checkPassword(e, callback) {
	      if (e.target.value.length >= 6) {
	        e.target.setCustomValidity('');
	      } else {
	        e.target.setCustomValidity('invalid');
	      }
	
	      this.setState({
	        valid: e.target.value.length >= 6
	      });
	
	      if (callback) {
	        callback(e, 'password');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	
	      var placeholder = this.props.placeholder || '';
	
	      // If a parent component and a name are provided,
	      // add a ref attribute to the input
	      var ref = null;
	
	      if (this.props.parent && this.props.name) {
	        ref = function ref(input) {
	          _this2.props.parent[_this2.props.name] = input;
	        };
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'password-wrap ' + (this.state.valid ? 'valid' : 'invalid') },
	        _react2.default.createElement('input', {
	          type: 'password',
	          id: this.props.id,
	          onChange: function onChange(e) {
	            _this2.checkPassword(e, _this2.props.changeFunction);
	          },
	          placeholder: placeholder,
	          ref: ref,
	          required: true,
	          'aria-required': 'true',
	          'aria-describedby': 'password-tooltip'
	        }),
	        _react2.default.createElement(
	          'i',
	          { className: 'password-validity' },
	          this.state.valid && _react2.default.createElement(icons.iconCheckCircle, null),
	          !this.state.valid && _react2.default.createElement(icons.iconNo, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            this.state.valid ? 'Valid' : 'Invalid'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tooltip' },
	          _react2.default.createElement(
	            'div',
	            { id: 'password-tooltip', className: 'tooltip__body', role: 'tooltip' },
	            translation.tooltip_body,
	            _react2.default.createElement(
	              'ul',
	              { className: 'tooltip__list' },
	              translation.requirements.map(function (key, i) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  key
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Password;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Password')(Password);

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  settings: {},
	  userSettings: null,
	  // Get user settings
	  getUserSettings: (0, _mobx.action)(function (component) {
	    _SessionStore2.default.startLoading('Loading…', 'GetUserSettings');
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid).then(function (response) {
	      obx.userSettings = response.data;
	
	      if (component) {
	        component.setState({
	          proctorTypes: response.data.proctorTypes
	        });
	      }
	
	      if (component && response.data.image) {
	        component.setState({
	          existingImage: [response.data.image]
	        });
	      }
	
	      _SessionStore2.default.finishLoading('GetUserSettings');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update user settings data
	  updateUserData: (0, _mobx.action)(function (data) {
	    var newData = null;
	
	    for (var key in data) {
	      if (key) {
	        newData = data[key];
	        obx.userSettings[key] = newData;
	      }
	    }
	  }),
	  // Update user settings API call
	  updateUserSettings: (0, _mobx.action)(function (func) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateUserSettings');
	
	    if (!obx.userSettings.active) {
	      delete obx.userSettings.firstName;
	      delete obx.userSettings.lastName;
	      delete obx.userSettings.email;
	    }
	
	    // Make sure testing administrator cannot be selected
	    var taIndex = obx.userSettings.proctorTypes.indexOf(_config.config.testingAdministratorSid);
	
	    if (taIndex > -1) {
	      obx.userSettings.proctorTypes.splice(taIndex, 1);
	    }
	
	    // Make sure general public cannot be selected
	    var gpIndex = obx.userSettings.proctorTypes.indexOf(_config.config.generalPublicSid);
	
	    if (gpIndex > -1) {
	      obx.userSettings.proctorTypes.splice(gpIndex, 1);
	    }
	
	    // Remove unnecessary data
	    Object.keys(obx.userSettings).map(function (key) {
	      if (key !== 'accountName' && key !== 'proctorTypes' && key !== 'password' && key !== 'active' && key !== 'acceptWrittenExams') {
	        delete obx.userSettings[key];
	      }
	
	      return true;
	    });
	
	    _config.api.put('/proctors/' + _SessionStore2.default.userData.proctorAccountSid, obx.userSettings).then(function (response) {
	      _SessionStore2.default.profile = response.data;
	      setTimeout(function () {
	        obx.getUserSettings();
	        _SessionStore2.default.finishLoading('UpdateUserSettings');
	        func();
	      });
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Toggle setting
	  toggleSetting: (0, _mobx.action)(function (data, property) {
	    data[property] = !data[property];
	
	    // Remove unnecessary data
	    Object.keys(data).map(function (key) {
	      if (key !== 'accountName' && key !== 'proctorTypes' && key !== 'password' && key !== 'active' && key !== 'acceptWrittenExams') {
	        delete data[key];
	      }
	
	      return true;
	    });
	
	    _config.api.put('/proctors/' + _SessionStore2.default.userData.proctorAccountSid, data).then(function (response) {
	      _SessionStore2.default.profile = response.data;
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update profile photo
	  updateProfilePhoto: (0, _mobx.action)(function (data, callback, component) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateProfilePhoto');
	
	    var formData = new FormData();
	    formData.append('image', data.image);
	
	    _config.api.put('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/image', formData).then(function (response) {
	      _SessionStore2.default.finishLoading('UpdateProfilePhoto');
	
	      obx.getUserSettings(component);
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Delete profile photo
	  deleteProfilePhoto: (0, _mobx.action)(function (callback) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteProfilePhoto');
	
	    _config.api.delete('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/image').then(function (response) {
	      _SessionStore2.default.finishLoading('DeleteProfilePhoto');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update password
	  updatePassword: (0, _mobx.action)(function (data, callback, proctorAccountSid, proctorUserSid) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdatePassword');
	
	    var accountSid = proctorAccountSid;
	    var userSid = proctorUserSid;
	
	    if (!accountSid) {
	      accountSid = _SessionStore2.default.userData.proctorAccountSid;
	    }
	
	    if (!userSid) {
	      userSid = _SessionStore2.default.userData.sid;
	    }
	
	    _config.api.put('/proctors/' + accountSid + '/users/' + userSid + '/password', data).then(function (response) {
	      if (callback) {
	        callback();
	      }
	
	      if (_SessionStore2.default.userData) {
	        _SessionStore2.default.userData.forcePasswordReset = false;
	      }
	
	      if (_SessionStore2.default.hasSessionStorage) {
	        sessionStorage.setItem('passwordReset', 'true');
	      } else {
	        document.cookie = 'passwordReset=true';
	      }
	
	      _SessionStore2.default.finishLoading('UpdatePassword');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Trigger pasword reset
	  resetPassword: (0, _mobx.action)(function (email, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'ResetPassword');
	
	    var data = {
	      emailAddress: email,
	      domain: 'proctor.smarterproctoring.com'
	    };
	
	    _config.api.post('/proctors/resetPassword', data).then(function (response) {
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('ResetPassword');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(66);
	
	var callBind = __webpack_require__(168);
	
	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
	
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(178);
	var GetIntrinsic = __webpack_require__(66);
	var setFunctionLength = __webpack_require__(1276);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	var $max = GetIntrinsic('%Math.max%');
	
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}
	
	module.exports = function callBind(originalFunction) {
		if (typeof originalFunction !== 'function') {
			throw new $TypeError('a function is required');
		}
		var func = $reflectApply(bind, $call, arguments);
		return setFunctionLength(
			func,
			1 + $max(0, originalFunction.length - (arguments.length - 1)),
			true
		);
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(89));
	var _index4 = _interopRequireDefault(__webpack_require__(25));
	var _index5 = __webpack_require__(51);
	function getUTCWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCDay;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	var _index4 = __webpack_require__(51);
	function setUTCDay(dirtyDate, dirtyDay, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(2, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDays;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} - the new date with the days added
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * const result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	  if (!amount) {
	    // If 0 days, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var timestamp = (0, _index2.default)(dirtyDate).getTime();
	  var amount = (0, _index.default)(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	module.exports = exports.default;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMonths;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * const result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	  if (!amount) {
	    // If 0 months, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	  var dayOfMonth = date.getDate();
	
	  // The JS Date object supports date math by accepting out-of-bounds values for
	  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
	  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
	  // want except that dates will wrap around the end of a month, meaning that
	  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
	  // we'll default to the end of the desired month by adding 1 to the desired
	  // month and using a date of 0 to back up one day to the end of the desired
	  // month.
	  var endOfDesiredMonth = new Date(date.getTime());
	  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
	  var daysInMonth = endOfDesiredMonth.getDate();
	  if (dayOfMonth >= daysInMonth) {
	    // If we're already at the end of the month, then this is the correct date
	    // and we're done.
	    return endOfDesiredMonth;
	  } else {
	    // Otherwise, we now know that setting the original day-of-month value won't
	    // cause an overflow, so set the desired day-of-month. Note that we can't
	    // just set the date of `endOfDesiredMonth` because that object may have had
	    // its time changed in the unusual case where where a DST transition was on
	    // the last day of the month and its local time was in the hour skipped or
	    // repeated next to a DST transition.  So we use `date` instead which is
	    // guaranteed to still have the original time.
	    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
	    return date;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDay;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name startOfDay
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasPropertyDescriptors = __webpack_require__(120)();
	
	var GetIntrinsic = __webpack_require__(66);
	
	var $defineProperty = hasPropertyDescriptors && GetIntrinsic('%Object.defineProperty%', true);
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}
	
	var $SyntaxError = GetIntrinsic('%SyntaxError%');
	var $TypeError = GetIntrinsic('%TypeError%');
	
	var gopd = __webpack_require__(332);
	
	/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */
	module.exports = function defineDataProperty(
		obj,
		property,
		value
	) {
		if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
			throw new $TypeError('`obj` must be an object or a function`');
		}
		if (typeof property !== 'string' && typeof property !== 'symbol') {
			throw new $TypeError('`property` must be a string or a symbol`');
		}
		if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
			throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
			throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
			throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
			throw new $TypeError('`loose`, if provided, must be a boolean');
		}
	
		var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
		var nonWritable = arguments.length > 4 ? arguments[4] : null;
		var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
		var loose = arguments.length > 6 ? arguments[6] : false;
	
		/* @type {false | TypedPropertyDescriptor<unknown>} */
		var desc = !!gopd && gopd(obj, property);
	
		if ($defineProperty) {
			$defineProperty(obj, property, {
				configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
				enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
				value: value,
				writable: nonWritable === null && desc ? desc.writable : !nonWritable
			});
		} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
			// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
			obj[property] = value; // eslint-disable-line no-param-reassign
		} else {
			throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
		}
	};


/***/ },
/* 176 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(176);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1042);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(333);
	
	module.exports = function hasToStringTagShams() {
		return hasSymbols() && !!Symbol.toStringTag;
	};


/***/ },
/* 180 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 181 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var globalIsUsingStaticRendering = false;
	function useStaticRendering(enable) {
	    globalIsUsingStaticRendering = enable;
	}
	exports.useStaticRendering = useStaticRendering;
	function isUsingStaticRendering() {
	    return globalIsUsingStaticRendering;
	}
	exports.isUsingStaticRendering = isUsingStaticRendering;


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_1 = __webpack_require__(29);
	var react_1 = __importDefault(__webpack_require__(2));
	var printDebugValue_1 = __webpack_require__(1073);
	var reactionCleanupTracking_1 = __webpack_require__(1074);
	var staticRendering_1 = __webpack_require__(181);
	var utils_1 = __webpack_require__(94);
	var useQueuedForceUpdate_1 = __webpack_require__(337);
	var EMPTY_OBJECT = {};
	function observerComponentNameFor(baseComponentName) {
	    return "observer" + baseComponentName;
	}
	function useObserver(fn, baseComponentName, options) {
	    if (baseComponentName === void 0) { baseComponentName = "observed"; }
	    if (options === void 0) { options = EMPTY_OBJECT; }
	    if (staticRendering_1.isUsingStaticRendering()) {
	        return fn();
	    }
	    var wantedForceUpdateHook = options.useForceUpdate || utils_1.useForceUpdate;
	    var forceUpdate = wantedForceUpdateHook();
	    var queuedForceUpdate = useQueuedForceUpdate_1.useQueuedForceUpdate(forceUpdate);
	    // StrictMode/ConcurrentMode/Suspense may mean that our component is
	    // rendered and abandoned multiple times, so we need to track leaked
	    // Reactions.
	    var reactionTrackingRef = react_1.default.useRef(null);
	    if (!reactionTrackingRef.current) {
	        // First render for this component (or first time since a previous
	        // reaction from an abandoned render was disposed).
	        var newReaction_1 = new mobx_1.Reaction(observerComponentNameFor(baseComponentName), function () {
	            // Observable has changed, meaning we want to re-render
	            // BUT if we're a component that hasn't yet got to the useEffect()
	            // stage, we might be a component that _started_ to render, but
	            // got dropped, and we don't want to make state changes then.
	            // (It triggers warnings in StrictMode, for a start.)
	            if (trackingData_1.mounted) {
	                // We have reached useEffect(), so we're mounted, and can trigger an update
	                queuedForceUpdate();
	            }
	            else {
	                // We haven't yet reached useEffect(), so we'll need to trigger a re-render
	                // when (and if) useEffect() arrives.  The easiest way to do that is just to
	                // drop our current reaction and allow useEffect() to recreate it.
	                newReaction_1.dispose();
	                reactionTrackingRef.current = null;
	            }
	        });
	        var trackingData_1 = reactionCleanupTracking_1.createTrackingData(newReaction_1);
	        reactionTrackingRef.current = trackingData_1;
	        reactionCleanupTracking_1.scheduleCleanupOfReactionIfLeaked(reactionTrackingRef);
	    }
	    var reaction = reactionTrackingRef.current.reaction;
	    react_1.default.useDebugValue(reaction, printDebugValue_1.printDebugValue);
	    react_1.default.useEffect(function () {
	        // Called on first mount only
	        reactionCleanupTracking_1.recordReactionAsCommitted(reactionTrackingRef);
	        if (reactionTrackingRef.current) {
	            // Great. We've already got our reaction from our render;
	            // all we need to do is to record that it's now mounted,
	            // to allow future observable changes to trigger re-renders
	            reactionTrackingRef.current.mounted = true;
	        }
	        else {
	            // The reaction we set up in our render has been disposed.
	            // This is either due to bad timings of renderings, e.g. our
	            // component was paused for a _very_ long time, and our
	            // reaction got cleaned up, or we got a observable change
	            // between render and useEffect
	            // Re-create the reaction
	            reactionTrackingRef.current = {
	                reaction: new mobx_1.Reaction(observerComponentNameFor(baseComponentName), function () {
	                    // We've definitely already been mounted at this point
	                    queuedForceUpdate();
	                }),
	                cleanAt: Infinity
	            };
	            queuedForceUpdate();
	        }
	        return function () {
	            reactionTrackingRef.current.reaction.dispose();
	            reactionTrackingRef.current = null;
	        };
	    }, []);
	    // delay all force-update calls after rendering of this component
	    return useQueuedForceUpdate_1.useQueuedForceUpdateBlock(function () {
	        // render the original component, but have the
	        // reaction track the observables, so that rendering
	        // can be invalidated (see above) once a dependency changes
	        var rendering;
	        var exception;
	        reaction.track(function () {
	            try {
	                rendering = fn();
	            }
	            catch (e) {
	                exception = e;
	            }
	        });
	        if (exception) {
	            throw exception; // re-throw any exceptions caught during rendering
	        }
	        return rendering;
	    });
	}
	exports.useObserver = useObserver;


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "CSSMotionList", {
	  enumerable: true,
	  get: function get() {
	    return _CSSMotionList.default;
	  }
	});
	Object.defineProperty(exports, "Provider", {
	  enumerable: true,
	  get: function get() {
	    return _context.default;
	  }
	});
	exports.default = void 0;
	var _CSSMotion = _interopRequireDefault(__webpack_require__(479));
	var _CSSMotionList = _interopRequireDefault(__webpack_require__(1103));
	var _context = _interopRequireDefault(__webpack_require__(480));
	var _default = _CSSMotion.default;
	exports.default = _default;

/***/ },
/* 184 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STEP_START = exports.STEP_PREPARED = exports.STEP_PREPARE = exports.STEP_NONE = exports.STEP_ACTIVE = exports.STEP_ACTIVATED = exports.STATUS_NONE = exports.STATUS_LEAVE = exports.STATUS_ENTER = exports.STATUS_APPEAR = void 0;
	var STATUS_NONE = 'none';
	exports.STATUS_NONE = STATUS_NONE;
	var STATUS_APPEAR = 'appear';
	exports.STATUS_APPEAR = STATUS_APPEAR;
	var STATUS_ENTER = 'enter';
	exports.STATUS_ENTER = STATUS_ENTER;
	var STATUS_LEAVE = 'leave';
	exports.STATUS_LEAVE = STATUS_LEAVE;
	var STEP_NONE = 'none';
	exports.STEP_NONE = STEP_NONE;
	var STEP_PREPARE = 'prepare';
	exports.STEP_PREPARE = STEP_PREPARE;
	var STEP_START = 'start';
	exports.STEP_START = STEP_START;
	var STEP_ACTIVE = 'active';
	exports.STEP_ACTIVE = STEP_ACTIVE;
	var STEP_ACTIVATED = 'end';
	/**
	 * Used for disabled motion case.
	 * Prepare stage will still work but start & active will be skipped.
	 */
	exports.STEP_ACTIVATED = STEP_ACTIVATED;
	var STEP_PREPARED = 'prepared';
	exports.STEP_PREPARED = STEP_PREPARED;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationEndName = void 0;
	exports.getTransitionName = getTransitionName;
	exports.getVendorPrefixedEventName = getVendorPrefixedEventName;
	exports.getVendorPrefixes = getVendorPrefixes;
	exports.transitionEndName = exports.supportTransition = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _canUseDom = _interopRequireDefault(__webpack_require__(122));
	// ================= Transition =================
	// Event wrapper. Copy from react source code
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
	  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
	  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
	  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
	  return prefixes;
	}
	function getVendorPrefixes(domSupport, win) {
	  var prefixes = {
	    animationend: makePrefixMap('Animation', 'AnimationEnd'),
	    transitionend: makePrefixMap('Transition', 'TransitionEnd')
	  };
	  if (domSupport) {
	    if (!('AnimationEvent' in win)) {
	      delete prefixes.animationend.animation;
	    }
	    if (!('TransitionEvent' in win)) {
	      delete prefixes.transitionend.transition;
	    }
	  }
	  return prefixes;
	}
	var vendorPrefixes = getVendorPrefixes((0, _canUseDom.default)(), typeof window !== 'undefined' ? window : {});
	var style = {};
	if ((0, _canUseDom.default)()) {
	  var _document$createEleme = document.createElement('div');
	  style = _document$createEleme.style;
	}
	var prefixedEventNames = {};
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  }
	  var prefixMap = vendorPrefixes[eventName];
	  if (prefixMap) {
	    var stylePropList = Object.keys(prefixMap);
	    var len = stylePropList.length;
	    for (var i = 0; i < len; i += 1) {
	      var styleProp = stylePropList[i];
	      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
	        prefixedEventNames[eventName] = prefixMap[styleProp];
	        return prefixedEventNames[eventName];
	      }
	    }
	  }
	  return '';
	}
	var internalAnimationEndName = getVendorPrefixedEventName('animationend');
	var internalTransitionEndName = getVendorPrefixedEventName('transitionend');
	var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
	exports.supportTransition = supportTransition;
	var animationEndName = internalAnimationEndName || 'animationend';
	exports.animationEndName = animationEndName;
	var transitionEndName = internalTransitionEndName || 'transitionend';
	exports.transitionEndName = transitionEndName;
	function getTransitionName(transitionName, transitionType) {
	  if (!transitionName) return null;
	  if ((0, _typeof2.default)(transitionName) === 'object') {
	    var type = transitionType.replace(/-\w/g, function (match) {
	      return match[1].toUpperCase();
	    });
	    return transitionName[type];
	  }
	  return "".concat(transitionName, "-").concat(transitionType);
	}

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(42));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(44));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(38));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(121));
	
	var Handle = /*#__PURE__*/function (_React$Component) {
	  (0, _inherits2.default)(Handle, _React$Component);
	
	  var _super = (0, _createSuper2.default)(Handle);
	
	  function Handle() {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Handle);
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      clickFocused: false
	    };
	
	    _this.setHandleRef = function (node) {
	      _this.handle = node;
	    };
	
	    _this.handleMouseUp = function () {
	      if (document.activeElement === _this.handle) {
	        _this.setClickFocus(true);
	      }
	    };
	
	    _this.handleMouseDown = function (e) {
	      // avoid selecting text during drag
	      // https://github.com/ant-design/ant-design/issues/25010
	      e.preventDefault(); // fix https://github.com/ant-design/ant-design/issues/15324
	
	      _this.focus();
	    };
	
	    _this.handleBlur = function () {
	      _this.setClickFocus(false);
	    };
	
	    _this.handleKeyDown = function () {
	      _this.setClickFocus(false);
	    };
	
	    return _this;
	  }
	
	  (0, _createClass2.default)(Handle, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // mouseup won't trigger if mouse moved out of handle,
	      // so we listen on document here.
	      this.onMouseUpListener = (0, _addEventListener.default)(document, 'mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.onMouseUpListener) {
	        this.onMouseUpListener.remove();
	      }
	    }
	  }, {
	    key: "setClickFocus",
	    value: function setClickFocus(focused) {
	      this.setState({
	        clickFocused: focused
	      });
	    }
	  }, {
	    key: "clickFocus",
	    value: function clickFocus() {
	      this.setClickFocus(true);
	      this.focus();
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.handle.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.handle.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _ref, _ref2;
	
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          vertical = _this$props.vertical,
	          reverse = _this$props.reverse,
	          offset = _this$props.offset,
	          style = _this$props.style,
	          disabled = _this$props.disabled,
	          min = _this$props.min,
	          max = _this$props.max,
	          value = _this$props.value,
	          tabIndex = _this$props.tabIndex,
	          ariaLabel = _this$props.ariaLabel,
	          ariaLabelledBy = _this$props.ariaLabelledBy,
	          ariaValueTextFormatter = _this$props.ariaValueTextFormatter,
	          restProps = (0, _objectWithoutProperties2.default)(_this$props, ["prefixCls", "vertical", "reverse", "offset", "style", "disabled", "min", "max", "value", "tabIndex", "ariaLabel", "ariaLabelledBy", "ariaValueTextFormatter"]);
	      var className = (0, _classnames.default)(this.props.className, (0, _defineProperty2.default)({}, "".concat(prefixCls, "-handle-click-focused"), this.state.clickFocused));
	      var positionStyle = vertical ? (_ref = {}, (0, _defineProperty2.default)(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), (0, _defineProperty2.default)(_ref, reverse ? 'bottom' : 'top', 'auto'), (0, _defineProperty2.default)(_ref, "transform", reverse ? null : "translateY(+50%)"), _ref) : (_ref2 = {}, (0, _defineProperty2.default)(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), (0, _defineProperty2.default)(_ref2, reverse ? 'left' : 'right', 'auto'), (0, _defineProperty2.default)(_ref2, "transform", "translateX(".concat(reverse ? '+' : '-', "50%)")), _ref2);
	      var elStyle = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, style), positionStyle);
	      var mergedTabIndex = tabIndex || 0;
	
	      if (disabled || tabIndex === null) {
	        mergedTabIndex = null;
	      }
	
	      var ariaValueText;
	
	      if (ariaValueTextFormatter) {
	        ariaValueText = ariaValueTextFormatter(value);
	      }
	
	      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
	        ref: this.setHandleRef,
	        tabIndex: mergedTabIndex
	      }, restProps, {
	        className: className,
	        style: elStyle,
	        onBlur: this.handleBlur,
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleMouseDown // aria attribute
	        ,
	        role: "slider",
	        "aria-valuemin": min,
	        "aria-valuemax": max,
	        "aria-valuenow": value,
	        "aria-disabled": !!disabled,
	        "aria-label": ariaLabel,
	        "aria-labelledby": ariaLabelledBy,
	        "aria-valuetext": ariaValueText
	      }));
	    }
	  }]);
	  return Handle;
	}(_react.default.Component);
	
	exports.default = Handle;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isEventFromHandle = isEventFromHandle;
	exports.isValueOutOfRange = isValueOutOfRange;
	exports.isNotTouchEvent = isNotTouchEvent;
	exports.getClosestPoint = getClosestPoint;
	exports.getPrecision = getPrecision;
	exports.getMousePosition = getMousePosition;
	exports.getTouchPosition = getTouchPosition;
	exports.getHandleCenterPosition = getHandleCenterPosition;
	exports.ensureValueInRange = ensureValueInRange;
	exports.ensureValuePrecision = ensureValuePrecision;
	exports.pauseEvent = pauseEvent;
	exports.calculateNextValue = calculateNextValue;
	exports.getKeyboardValueMutator = getKeyboardValueMutator;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	
	var _reactDom = __webpack_require__(37);
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(1128));
	
	function isEventFromHandle(e, handles) {
	  try {
	    return Object.keys(handles).some(function (key) {
	      return e.target === (0, _reactDom.findDOMNode)(handles[key]);
	    });
	  } catch (error) {
	    return false;
	  }
	}
	
	function isValueOutOfRange(value, _ref) {
	  var min = _ref.min,
	      max = _ref.max;
	  return value < min || value > max;
	}
	
	function isNotTouchEvent(e) {
	  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
	}
	
	function getClosestPoint(val, _ref2) {
	  var marks = _ref2.marks,
	      step = _ref2.step,
	      min = _ref2.min,
	      max = _ref2.max;
	  var points = Object.keys(marks).map(parseFloat);
	
	  if (step !== null) {
	    var baseNum = Math.pow(10, getPrecision(step));
	    var maxSteps = Math.floor((max * baseNum - min * baseNum) / (step * baseNum));
	    var steps = Math.min((val - min) / step, maxSteps);
	    var closestStep = Math.round(steps) * step + min;
	    points.push(closestStep);
	  }
	
	  var diffs = points.map(function (point) {
	    return Math.abs(val - point);
	  });
	  return points[diffs.indexOf(Math.min.apply(Math, (0, _toConsumableArray2.default)(diffs)))];
	}
	
	function getPrecision(step) {
	  var stepString = step.toString();
	  var precision = 0;
	
	  if (stepString.indexOf('.') >= 0) {
	    precision = stepString.length - stepString.indexOf('.') - 1;
	  }
	
	  return precision;
	}
	
	function getMousePosition(vertical, e) {
	  return vertical ? e.clientY : e.pageX;
	}
	
	function getTouchPosition(vertical, e) {
	  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
	}
	
	function getHandleCenterPosition(vertical, handle) {
	  var coords = handle.getBoundingClientRect();
	  return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
	}
	
	function ensureValueInRange(val, _ref3) {
	  var max = _ref3.max,
	      min = _ref3.min;
	
	  if (val <= min) {
	    return min;
	  }
	
	  if (val >= max) {
	    return max;
	  }
	
	  return val;
	}
	
	function ensureValuePrecision(val, props) {
	  var step = props.step;
	  var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line
	
	  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
	}
	
	function pauseEvent(e) {
	  e.stopPropagation();
	  e.preventDefault();
	}
	
	function calculateNextValue(func, value, props) {
	  var operations = {
	    increase: function increase(a, b) {
	      return a + b;
	    },
	    decrease: function decrease(a, b) {
	      return a - b;
	    }
	  };
	  var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
	  var keyToGet = Object.keys(props.marks)[indexToGet];
	
	  if (props.step) {
	    return operations[func](value, props.step);
	  }
	
	  if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
	    return props.marks[keyToGet];
	  }
	
	  return value;
	}
	
	function getKeyboardValueMutator(e, vertical, reverse) {
	  var increase = 'increase';
	  var decrease = 'decrease';
	  var method = increase;
	
	  switch (e.keyCode) {
	    case _KeyCode.default.UP:
	      method = vertical && reverse ? decrease : increase;
	      break;
	
	    case _KeyCode.default.RIGHT:
	      method = !vertical && reverse ? decrease : increase;
	      break;
	
	    case _KeyCode.default.DOWN:
	      method = vertical && reverse ? increase : decrease;
	      break;
	
	    case _KeyCode.default.LEFT:
	      method = !vertical && reverse ? increase : decrease;
	      break;
	
	    case _KeyCode.default.END:
	      return function (value, props) {
	        return props.max;
	      };
	
	    case _KeyCode.default.HOME:
	      return function (value, props) {
	        return props.min;
	      };
	
	    case _KeyCode.default.PAGE_UP:
	      return function (value, props) {
	        return value + props.step * 2;
	      };
	
	    case _KeyCode.default.PAGE_DOWN:
	      return function (value, props) {
	        return value - props.step * 2;
	      };
	
	    default:
	      return undefined;
	  }
	
	  return function (value, props) {
	    return calculateNextValue(method, value, props);
	  };
	}

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36).default;
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useSafeState;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var React = _interopRequireWildcard(__webpack_require__(2));
	/**
	 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
	 * We do not make this auto is to avoid real memory leak.
	 * Developer should confirm it's safe to ignore themselves.
	 */
	function useSafeState(defaultValue) {
	  var destroyRef = React.useRef(false);
	  var _React$useState = React.useState(defaultValue),
	    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
	    value = _React$useState2[0],
	    setValue = _React$useState2[1];
	  React.useEffect(function () {
	    destroyRef.current = false;
	    return function () {
	      destroyRef.current = true;
	    };
	  }, []);
	  function safeSetState(updater, ignoreDestroy) {
	    if (ignoreDestroy && destroyRef.current) {
	      return;
	    }
	    setValue(updater);
	  }
	  return [value, safeSetState];
	}

/***/ },
/* 189 */
[1298, 1145],
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ManagerReferenceNodeSetterContext = exports.ManagerReferenceNodeContext = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(138));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(542));
	
	var ManagerReferenceNodeContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeContext = ManagerReferenceNodeContext;
	var ManagerReferenceNodeSetterContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeSetterContext = ManagerReferenceNodeSetterContext;
	
	var Manager =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Manager, _React$Component);
	
	  function Manager() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "referenceNode", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setReferenceNode", function (newReferenceNode) {
	      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
	        _this.referenceNode = newReferenceNode;
	
	        _this.forceUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = Manager.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.referenceNode = null;
	  };
	
	  _proto.render = function render() {
	    return React.createElement(ManagerReferenceNodeContext.Provider, {
	      value: this.referenceNode
	    }, React.createElement(ManagerReferenceNodeSetterContext.Provider, {
	      value: this.setReferenceNode
	    }, this.props.children));
	  };
	
	  return Manager;
	}(React.Component);
	
	exports.default = Manager;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(78),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1217),
	    mapCacheDelete = __webpack_require__(1218),
	    mapCacheGet = __webpack_require__(1219),
	    mapCacheHas = __webpack_require__(1220),
	    mapCacheSet = __webpack_require__(1221);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1175),
	    isObjectLike = __webpack_require__(97);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1180),
	    baseMatchesProperty = __webpack_require__(1181),
	    identity = __webpack_require__(1241),
	    isArray = __webpack_require__(54),
	    property = __webpack_require__(1243);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 195 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(54),
	    isSymbol = __webpack_require__(133);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 197 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 198 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DropdownContent = exports.DropdownTrigger = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(37);
	
	var _classnames = __webpack_require__(38);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dropdownTrigger = __webpack_require__(1263);
	
	var _dropdownTrigger2 = _interopRequireDefault(_dropdownTrigger);
	
	var _dropdownContent = __webpack_require__(1262);
	
	var _dropdownContent2 = _interopRequireDefault(_dropdownContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dropdown = function (_Component) {
	  _inherits(Dropdown, _Component);
	
	  _createClass(Dropdown, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('click', this._onWindowClick);
	      window.addEventListener('touchstart', this._onWindowClick);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('click', this._onWindowClick);
	      window.removeEventListener('touchstart', this._onWindowClick);
	    }
	  }]);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Dropdown).call(this, props));
	
	    _this.state = {
	      active: false
	    };
	
	    _this._onWindowClick = _this._onWindowClick.bind(_this);
	    _this._onToggleClick = _this._onToggleClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dropdown, [{
	    key: 'isActive',
	    value: function isActive() {
	      return typeof this.props.active === 'boolean' ? this.props.active : this.state.active;
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      var _this2 = this;
	
	      this.setState({
	        active: false
	      }, function () {
	        if (_this2.props.onHide) {
	          _this2.props.onHide();
	        }
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      var _this3 = this;
	
	      this.setState({
	        active: true
	      }, function () {
	        if (_this3.props.onShow) {
	          _this3.props.onShow();
	        }
	      });
	    }
	  }, {
	    key: '_onWindowClick',
	    value: function _onWindowClick(event) {
	      var dropdownElement = (0, _reactDom.findDOMNode)(this);
	      if (event.target !== dropdownElement && !dropdownElement.contains(event.target) && this.isActive()) {
	        this.hide();
	      }
	    }
	  }, {
	    key: '_onToggleClick',
	    value: function _onToggleClick(event) {
	      event.preventDefault();
	      if (this.isActive()) {
	        this.hide();
	      } else {
	        this.show();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this,
	          _arguments = arguments;
	
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	      var disabled = _props.disabled;
	      var removeElement = _props.removeElement;
	      // create component classes
	
	      var active = this.isActive();
	      var dropdownClasses = (0, _classnames2.default)({
	        dropdown: true,
	        'dropdown--active': active,
	        'dropdown--disabled': disabled
	      });
	      // stick callback on trigger element
	      var boundChildren = _react2.default.Children.map(children, function (child) {
	        if (child.type === _dropdownTrigger2.default) {
	          (function () {
	            var originalOnClick = child.props.onClick;
	            child = (0, _react.cloneElement)(child, {
	              ref: 'trigger',
	              onClick: function onClick(event) {
	                if (!disabled) {
	                  _this4._onToggleClick(event);
	                  if (originalOnClick) {
	                    originalOnClick.apply(child, _arguments);
	                  }
	                }
	              }
	            });
	          })();
	        } else if (child.type === _dropdownContent2.default && removeElement && !active) {
	          child = null;
	        }
	        return child;
	      });
	      var cleanProps = _extends({}, this.props);
	      delete cleanProps.active;
	      delete cleanProps.onShow;
	      delete cleanProps.onHide;
	      delete cleanProps.removeElement;
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, cleanProps, {
	          className: dropdownClasses + ' ' + className }),
	        boundChildren
	      );
	    }
	  }]);
	
	  return Dropdown;
	}(_react.Component);
	
	Dropdown.propTypes = {
	  disabled: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  onHide: _propTypes2.default.func,
	  onShow: _propTypes2.default.func,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  removeElement: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	};
	
	Dropdown.defaultProps = {
	  className: ''
	};
	
	exports.DropdownTrigger = _dropdownTrigger2.default;
	exports.DropdownContent = _dropdownContent2.default;
	exports.default = Dropdown;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 201 */
/***/ function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	var Format = {
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};
	
	module.exports = {
	    'default': Format.RFC3986,
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return String(value);
	        }
	    },
	    RFC1738: Format.RFC1738,
	    RFC3986: Format.RFC3986
	};


/***/ },
/* 202 */
/***/ function(module, exports) {

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	  return arr2;
	}
	module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 203 */
/***/ function(module, exports) {

	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;
	  try {
	    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 204 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	  return target;
	}
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(5)["default"];
	var toPrimitive = __webpack_require__(534);
	function _toPropertyKey(arg) {
	  var key = toPrimitive(arg, "string");
	  return _typeof(key) === "symbol" ? key : String(key);
	}
	module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	FullCalendar Scheduler v5.11.5
	Docs & License: https://fullcalendar.io/scheduler
	(c) 2022 Adam Shaw
	*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var common = __webpack_require__(70);
	var premiumCommonPlugin = __webpack_require__(99);
	var tslib = __webpack_require__(80);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var premiumCommonPlugin__default = /*#__PURE__*/_interopDefaultLegacy(premiumCommonPlugin);
	
	var WHEEL_EVENT_NAMES = 'wheel mousewheel DomMouseScroll MozMousePixelScroll'.split(' ');
	/*
	ALSO, with the ability to disable touch
	*/
	var ScrollListener = /** @class */ (function () {
	    function ScrollListener(el) {
	        var _this = this;
	        this.el = el;
	        this.emitter = new common.Emitter();
	        this.isScrolling = false;
	        this.isTouching = false; // user currently has finger down?
	        this.isRecentlyWheeled = false;
	        this.isRecentlyScrolled = false;
	        this.wheelWaiter = new common.DelayedRunner(this._handleWheelWaited.bind(this));
	        this.scrollWaiter = new common.DelayedRunner(this._handleScrollWaited.bind(this));
	        // Handlers
	        // ----------------------------------------------------------------------------------------------
	        this.handleScroll = function () {
	            _this.startScroll();
	            _this.emitter.trigger('scroll', _this.isRecentlyWheeled, _this.isTouching);
	            _this.isRecentlyScrolled = true;
	            _this.scrollWaiter.request(500);
	        };
	        // will fire *before* the scroll event is fired (might not cause a scroll)
	        this.handleWheel = function () {
	            _this.isRecentlyWheeled = true;
	            _this.wheelWaiter.request(500);
	        };
	        // will fire *before* the scroll event is fired (might not cause a scroll)
	        this.handleTouchStart = function () {
	            _this.isTouching = true;
	        };
	        this.handleTouchEnd = function () {
	            _this.isTouching = false;
	            // if the user ended their touch, and the scroll area wasn't moving,
	            // we consider this to be the end of the scroll.
	            if (!_this.isRecentlyScrolled) {
	                _this.endScroll(); // won't fire if already ended
	            }
	        };
	        el.addEventListener('scroll', this.handleScroll);
	        el.addEventListener('touchstart', this.handleTouchStart, { passive: true });
	        el.addEventListener('touchend', this.handleTouchEnd);
	        for (var _i = 0, WHEEL_EVENT_NAMES_1 = WHEEL_EVENT_NAMES; _i < WHEEL_EVENT_NAMES_1.length; _i++) {
	            var eventName = WHEEL_EVENT_NAMES_1[_i];
	            el.addEventListener(eventName, this.handleWheel);
	        }
	    }
	    ScrollListener.prototype.destroy = function () {
	        var el = this.el;
	        el.removeEventListener('scroll', this.handleScroll);
	        el.removeEventListener('touchstart', this.handleTouchStart, { passive: true });
	        el.removeEventListener('touchend', this.handleTouchEnd);
	        for (var _i = 0, WHEEL_EVENT_NAMES_2 = WHEEL_EVENT_NAMES; _i < WHEEL_EVENT_NAMES_2.length; _i++) {
	            var eventName = WHEEL_EVENT_NAMES_2[_i];
	            el.removeEventListener(eventName, this.handleWheel);
	        }
	    };
	    // Start / Stop
	    // ----------------------------------------------------------------------------------------------
	    ScrollListener.prototype.startScroll = function () {
	        if (!this.isScrolling) {
	            this.isScrolling = true;
	            this.emitter.trigger('scrollStart', this.isRecentlyWheeled, this.isTouching);
	        }
	    };
	    ScrollListener.prototype.endScroll = function () {
	        if (this.isScrolling) {
	            this.emitter.trigger('scrollEnd');
	            this.isScrolling = false;
	            this.isRecentlyScrolled = true;
	            this.isRecentlyWheeled = false;
	            this.scrollWaiter.clear();
	            this.wheelWaiter.clear();
	        }
	    };
	    ScrollListener.prototype._handleScrollWaited = function () {
	        this.isRecentlyScrolled = false;
	        // only end the scroll if not currently touching.
	        // if touching, the scrolling will end later, on touchend.
	        if (!this.isTouching) {
	            this.endScroll(); // won't fire if already ended
	        }
	    };
	    ScrollListener.prototype._handleWheelWaited = function () {
	        this.isRecentlyWheeled = false;
	    };
	    return ScrollListener;
	}());
	
	// TODO: assume the el has no borders?
	function getScrollCanvasOrigin(scrollEl) {
	    var rect = scrollEl.getBoundingClientRect();
	    var edges = common.computeEdges(scrollEl); // TODO: pass in isRtl?
	    return {
	        left: rect.left + edges.borderLeft + edges.scrollbarLeft - getScrollFromLeftEdge(scrollEl),
	        top: rect.top + edges.borderTop - scrollEl.scrollTop,
	    };
	}
	function getScrollFromLeftEdge(el) {
	    var scrollLeft = el.scrollLeft;
	    var computedStyles = window.getComputedStyle(el); // TODO: pass in isRtl instead?
	    if (computedStyles.direction === 'rtl') {
	        switch (getRtlScrollSystem()) {
	            case 'negative':
	                scrollLeft *= -1; // convert to 'reverse'. fall through...
	            case 'reverse': // scrollLeft is distance between scrollframe's right edge scrollcanvas's right edge
	                scrollLeft = el.scrollWidth - scrollLeft - el.clientWidth;
	        }
	    }
	    return scrollLeft;
	}
	function setScrollFromLeftEdge(el, scrollLeft) {
	    var computedStyles = window.getComputedStyle(el); // TODO: pass in isRtl instead?
	    if (computedStyles.direction === 'rtl') {
	        switch (getRtlScrollSystem()) {
	            case 'reverse':
	                scrollLeft = el.scrollWidth - scrollLeft;
	                break;
	            case 'negative':
	                scrollLeft = -(el.scrollWidth - scrollLeft);
	                break;
	        }
	    }
	    el.scrollLeft = scrollLeft;
	}
	// Horizontal Scroll System Detection
	// ----------------------------------------------------------------------------------------------
	var _rtlScrollSystem;
	function getRtlScrollSystem() {
	    return _rtlScrollSystem || (_rtlScrollSystem = detectRtlScrollSystem());
	}
	function detectRtlScrollSystem() {
	    var el = document.createElement('div');
	    el.style.position = 'absolute';
	    el.style.top = '-1000px';
	    el.style.width = '1px';
	    el.style.height = '1px';
	    el.style.overflow = 'scroll';
	    el.style.direction = 'rtl';
	    el.style.fontSize = '100px';
	    el.innerHTML = 'A';
	    document.body.appendChild(el);
	    var system;
	    if (el.scrollLeft > 0) {
	        system = 'positive'; // scroll is a positive number from the left edge
	    }
	    else {
	        el.scrollLeft = 1;
	        if (el.scrollLeft > 0) {
	            system = 'reverse'; // scroll is a positive number from the right edge
	        }
	        else {
	            system = 'negative'; // scroll is a negative number from the right edge
	        }
	    }
	    common.removeElement(el);
	    return system;
	}
	
	var IS_MS_EDGE = typeof navigator !== 'undefined' && /Edge/.test(navigator.userAgent); // TODO: what about Chromeum-based Edge?
	var STICKY_SELECTOR = '.fc-sticky';
	/*
	useful beyond the native position:sticky for these reasons:
	- support in IE11
	- nice centering support
	
	REQUIREMENT: fc-sticky elements, if the fc-sticky className is taken away, should NOT have relative or absolute positioning.
	This is because we attach the coords with JS, and the VDOM might take away the fc-sticky class but doesn't know kill the positioning.
	
	TODO: don't query text-align:center. isn't compatible with flexbox centering. instead, check natural X coord within parent container
	*/
	var StickyScrolling = /** @class */ (function () {
	    function StickyScrolling(scrollEl, isRtl) {
	        var _this = this;
	        this.scrollEl = scrollEl;
	        this.isRtl = isRtl;
	        this.usingRelative = null;
	        this.updateSize = function () {
	            var scrollEl = _this.scrollEl;
	            var els = common.findElements(scrollEl, STICKY_SELECTOR);
	            var elGeoms = _this.queryElGeoms(els);
	            var viewportWidth = scrollEl.clientWidth;
	            var viewportHeight = scrollEl.clientHeight;
	            if (_this.usingRelative) {
	                var elDestinations = _this.computeElDestinations(elGeoms, viewportWidth); // read before prepPositioning
	                assignRelativePositions(els, elGeoms, elDestinations, viewportWidth, viewportHeight);
	            }
	            else {
	                assignStickyPositions(els, elGeoms, viewportWidth);
	            }
	        };
	        this.usingRelative =
	            !getStickySupported() || // IE11
	                // https://stackoverflow.com/questions/56835658/in-microsoft-edge-sticky-positioning-doesnt-work-when-combined-with-dir-rtl
	                (IS_MS_EDGE && isRtl);
	        if (this.usingRelative) {
	            this.listener = new ScrollListener(scrollEl);
	            this.listener.emitter.on('scrollEnd', this.updateSize);
	        }
	    }
	    StickyScrolling.prototype.destroy = function () {
	        if (this.listener) {
	            this.listener.destroy();
	        }
	    };
	    StickyScrolling.prototype.queryElGeoms = function (els) {
	        var _a = this, scrollEl = _a.scrollEl, isRtl = _a.isRtl;
	        var canvasOrigin = getScrollCanvasOrigin(scrollEl);
	        var elGeoms = [];
	        for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
	            var el = els_1[_i];
	            var parentBound = common.translateRect(common.computeInnerRect(el.parentNode, true, true), // weird way to call this!!!
	            -canvasOrigin.left, -canvasOrigin.top);
	            var elRect = el.getBoundingClientRect();
	            var computedStyles = window.getComputedStyle(el);
	            var textAlign = window.getComputedStyle(el.parentNode).textAlign; // ask the parent
	            var naturalBound = null;
	            if (textAlign === 'start') {
	                textAlign = isRtl ? 'right' : 'left';
	            }
	            else if (textAlign === 'end') {
	                textAlign = isRtl ? 'left' : 'right';
	            }
	            if (computedStyles.position !== 'sticky') {
	                naturalBound = common.translateRect(elRect, -canvasOrigin.left - (parseFloat(computedStyles.left) || 0), // could be 'auto'
	                -canvasOrigin.top - (parseFloat(computedStyles.top) || 0));
	            }
	            elGeoms.push({
	                parentBound: parentBound,
	                naturalBound: naturalBound,
	                elWidth: elRect.width,
	                elHeight: elRect.height,
	                textAlign: textAlign,
	            });
	        }
	        return elGeoms;
	    };
	    // only for IE
	    StickyScrolling.prototype.computeElDestinations = function (elGeoms, viewportWidth) {
	        var scrollEl = this.scrollEl;
	        var viewportTop = scrollEl.scrollTop;
	        var viewportLeft = getScrollFromLeftEdge(scrollEl);
	        var viewportRight = viewportLeft + viewportWidth;
	        return elGeoms.map(function (elGeom) {
	            var elWidth = elGeom.elWidth, elHeight = elGeom.elHeight, parentBound = elGeom.parentBound, naturalBound = elGeom.naturalBound;
	            var destLeft; // relative to canvas topleft
	            var destTop; // "
	            switch (elGeom.textAlign) {
	                case 'left':
	                    destLeft = viewportLeft;
	                    break;
	                case 'right':
	                    destLeft = viewportRight - elWidth;
	                    break;
	                case 'center':
	                    destLeft = (viewportLeft + viewportRight) / 2 - elWidth / 2; /// noooo, use half-width insteadddddddd
	                    break;
	            }
	            destLeft = Math.min(destLeft, parentBound.right - elWidth);
	            destLeft = Math.max(destLeft, parentBound.left);
	            destTop = viewportTop;
	            destTop = Math.min(destTop, parentBound.bottom - elHeight);
	            destTop = Math.max(destTop, naturalBound.top); // better to use natural top for upper bound
	            return { left: destLeft, top: destTop };
	        });
	    };
	    return StickyScrolling;
	}());
	function assignRelativePositions(els, elGeoms, elDestinations, viewportWidth, viewportHeight) {
	    els.forEach(function (el, i) {
	        var _a = elGeoms[i], naturalBound = _a.naturalBound, parentBound = _a.parentBound;
	        var parentWidth = parentBound.right - parentBound.left;
	        var parentHeight = parentBound.bottom - parentBound.bottom;
	        var left;
	        var top;
	        if (parentWidth > viewportWidth ||
	            parentHeight > viewportHeight) {
	            left = elDestinations[i].left - naturalBound.left;
	            top = elDestinations[i].top - naturalBound.top;
	        }
	        else { // if parent container can be completely in view, we don't need stickiness
	            left = '';
	            top = '';
	        }
	        common.applyStyle(el, {
	            position: 'relative',
	            left: left,
	            right: -left,
	            top: top,
	        });
	    });
	}
	function assignStickyPositions(els, elGeoms, viewportWidth) {
	    els.forEach(function (el, i) {
	        var _a = elGeoms[i], textAlign = _a.textAlign, elWidth = _a.elWidth, parentBound = _a.parentBound;
	        var parentWidth = parentBound.right - parentBound.left;
	        var left;
	        if (textAlign === 'center' &&
	            parentWidth > viewportWidth) {
	            left = (viewportWidth - elWidth) / 2;
	        }
	        else { // if parent container can be completely in view, we don't need stickiness
	            left = '';
	        }
	        common.applyStyle(el, {
	            left: left,
	            right: left,
	            top: 0,
	        });
	    });
	}
	var _isStickySupported;
	function getStickySupported() {
	    if (_isStickySupported == null) {
	        _isStickySupported = computeStickySupported();
	    }
	    return _isStickySupported;
	}
	function computeStickySupported() {
	    var el = document.createElement('div');
	    el.style.position = 'sticky';
	    document.body.appendChild(el);
	    var val = window.getComputedStyle(el).position;
	    common.removeElement(el);
	    return val === 'sticky';
	}
	
	var ClippedScroller = /** @class */ (function (_super) {
	    tslib.__extends(ClippedScroller, _super);
	    function ClippedScroller() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.elRef = common.createRef();
	        _this.state = {
	            xScrollbarWidth: 0,
	            yScrollbarWidth: 0,
	        };
	        _this.handleScroller = function (scroller) {
	            _this.scroller = scroller;
	            common.setRef(_this.props.scrollerRef, scroller);
	        };
	        _this.handleSizing = function () {
	            var props = _this.props;
	            if (props.overflowY === 'scroll-hidden') {
	                _this.setState({ yScrollbarWidth: _this.scroller.getYScrollbarWidth() });
	            }
	            if (props.overflowX === 'scroll-hidden') {
	                _this.setState({ xScrollbarWidth: _this.scroller.getXScrollbarWidth() });
	            }
	        };
	        return _this;
	    }
	    ClippedScroller.prototype.render = function () {
	        var _a = this, props = _a.props, state = _a.state, context = _a.context;
	        var isScrollbarOnLeft = context.isRtl && common.getIsRtlScrollbarOnLeft();
	        var overcomeLeft = 0;
	        var overcomeRight = 0;
	        var overcomeBottom = 0;
	        if (props.overflowX === 'scroll-hidden') {
	            overcomeBottom = state.xScrollbarWidth;
	        }
	        if (props.overflowY === 'scroll-hidden') {
	            if (state.yScrollbarWidth != null) {
	                if (isScrollbarOnLeft) {
	                    overcomeLeft = state.yScrollbarWidth;
	                }
	                else {
	                    overcomeRight = state.yScrollbarWidth;
	                }
	            }
	        }
	        return (common.createElement("div", { ref: this.elRef, className: 'fc-scroller-harness' + (props.liquid ? ' fc-scroller-harness-liquid' : '') },
	            common.createElement(common.Scroller, { ref: this.handleScroller, elRef: this.props.scrollerElRef, overflowX: props.overflowX === 'scroll-hidden' ? 'scroll' : props.overflowX, overflowY: props.overflowY === 'scroll-hidden' ? 'scroll' : props.overflowY, overcomeLeft: overcomeLeft, overcomeRight: overcomeRight, overcomeBottom: overcomeBottom, maxHeight: typeof props.maxHeight === 'number'
	                    ? (props.maxHeight + (props.overflowX === 'scroll-hidden' ? state.xScrollbarWidth : 0))
	                    : '', liquid: props.liquid, liquidIsAbsolute: true }, props.children)));
	    };
	    ClippedScroller.prototype.componentDidMount = function () {
	        this.handleSizing();
	        this.context.addResizeHandler(this.handleSizing);
	    };
	    ClippedScroller.prototype.componentDidUpdate = function (prevProps) {
	        if (!common.isPropsEqual(prevProps, this.props)) { // an external change?
	            this.handleSizing();
	        }
	    };
	    ClippedScroller.prototype.componentWillUnmount = function () {
	        this.context.removeResizeHandler(this.handleSizing);
	    };
	    ClippedScroller.prototype.needsXScrolling = function () {
	        return this.scroller.needsXScrolling();
	    };
	    ClippedScroller.prototype.needsYScrolling = function () {
	        return this.scroller.needsYScrolling();
	    };
	    return ClippedScroller;
	}(common.BaseComponent));
	
	var ScrollSyncer = /** @class */ (function () {
	    function ScrollSyncer(isVertical, scrollEls) {
	        var _this = this;
	        this.isVertical = isVertical;
	        this.scrollEls = scrollEls;
	        this.isPaused = false;
	        this.scrollListeners = scrollEls.map(function (el) { return _this.bindScroller(el); });
	    }
	    ScrollSyncer.prototype.destroy = function () {
	        for (var _i = 0, _a = this.scrollListeners; _i < _a.length; _i++) {
	            var scrollListener = _a[_i];
	            scrollListener.destroy();
	        }
	    };
	    ScrollSyncer.prototype.bindScroller = function (el) {
	        var _this = this;
	        var _a = this, scrollEls = _a.scrollEls, isVertical = _a.isVertical;
	        var scrollListener = new ScrollListener(el);
	        var onScroll = function (isWheel, isTouch) {
	            if (!_this.isPaused) {
	                if (!_this.masterEl || (_this.masterEl !== el && (isWheel || isTouch))) {
	                    _this.assignMaster(el);
	                }
	                if (_this.masterEl === el) { // dealing with current
	                    for (var _i = 0, scrollEls_1 = scrollEls; _i < scrollEls_1.length; _i++) {
	                        var otherEl = scrollEls_1[_i];
	                        if (otherEl !== el) {
	                            if (isVertical) {
	                                otherEl.scrollTop = el.scrollTop;
	                            }
	                            else {
	                                otherEl.scrollLeft = el.scrollLeft;
	                            }
	                        }
	                    }
	                }
	            }
	        };
	        var onScrollEnd = function () {
	            if (_this.masterEl === el) {
	                _this.masterEl = null;
	            }
	        };
	        scrollListener.emitter.on('scroll', onScroll);
	        scrollListener.emitter.on('scrollEnd', onScrollEnd);
	        return scrollListener;
	    };
	    ScrollSyncer.prototype.assignMaster = function (el) {
	        this.masterEl = el;
	        for (var _i = 0, _a = this.scrollListeners; _i < _a.length; _i++) {
	            var scrollListener = _a[_i];
	            if (scrollListener.el !== el) {
	                scrollListener.endScroll(); // to prevent residual scrolls from reclaiming master
	            }
	        }
	    };
	    /*
	    will normalize the scrollLeft value
	    */
	    ScrollSyncer.prototype.forceScrollLeft = function (scrollLeft) {
	        this.isPaused = true;
	        for (var _i = 0, _a = this.scrollListeners; _i < _a.length; _i++) {
	            var listener = _a[_i];
	            setScrollFromLeftEdge(listener.el, scrollLeft);
	        }
	        this.isPaused = false;
	    };
	    ScrollSyncer.prototype.forceScrollTop = function (top) {
	        this.isPaused = true;
	        for (var _i = 0, _a = this.scrollListeners; _i < _a.length; _i++) {
	            var listener = _a[_i];
	            listener.el.scrollTop = top;
	        }
	        this.isPaused = false;
	    };
	    return ScrollSyncer;
	}());
	
	/*
	TODO: make <ScrollGridSection> subcomponent
	NOTE: doesn't support collapsibleWidth (which is sortof a hack anyway)
	*/
	var ScrollGrid = /** @class */ (function (_super) {
	    tslib.__extends(ScrollGrid, _super);
	    function ScrollGrid() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.compileColGroupStats = common.memoizeArraylike(compileColGroupStat, isColGroupStatsEqual);
	        _this.renderMicroColGroups = common.memoizeArraylike(common.renderMicroColGroup); // yucky to memoize VNodes, but much more efficient for consumers
	        _this.clippedScrollerRefs = new common.RefMap();
	        // doesn't hold non-scrolling els used just for padding
	        _this.scrollerElRefs = new common.RefMap(_this._handleScrollerEl.bind(_this));
	        _this.chunkElRefs = new common.RefMap(_this._handleChunkEl.bind(_this));
	        _this.stickyScrollings = [];
	        _this.scrollSyncersBySection = {};
	        _this.scrollSyncersByColumn = {};
	        // for row-height-syncing
	        _this.rowUnstableMap = new Map(); // no need to groom. always self-cancels
	        _this.rowInnerMaxHeightMap = new Map();
	        _this.anyRowHeightsChanged = false;
	        _this.recentSizingCnt = 0;
	        _this.state = {
	            shrinkWidths: [],
	            forceYScrollbars: false,
	            forceXScrollbars: false,
	            scrollerClientWidths: {},
	            scrollerClientHeights: {},
	            sectionRowMaxHeights: [],
	        };
	        _this.handleSizing = function (isForcedResize, sectionRowMaxHeightsChanged) {
	            if (!_this.allowSizing()) {
	                return;
	            }
	            if (!sectionRowMaxHeightsChanged) { // something else changed, probably external
	                _this.anyRowHeightsChanged = true;
	            }
	            var otherState = {};
	            // if reacting to self-change of sectionRowMaxHeightsChanged, or not stable, don't do anything
	            if (isForcedResize || (!sectionRowMaxHeightsChanged && !_this.rowUnstableMap.size)) {
	                otherState.sectionRowMaxHeights = _this.computeSectionRowMaxHeights();
	            }
	            _this.setState(tslib.__assign(tslib.__assign({ shrinkWidths: _this.computeShrinkWidths() }, _this.computeScrollerDims()), otherState), function () {
	                if (!_this.rowUnstableMap.size) {
	                    _this.updateStickyScrolling(); // needs to happen AFTER final positioning committed to DOM
	                }
	            });
	        };
	        _this.handleRowHeightChange = function (rowEl, isStable) {
	            var _a = _this, rowUnstableMap = _a.rowUnstableMap, rowInnerMaxHeightMap = _a.rowInnerMaxHeightMap;
	            if (!isStable) {
	                rowUnstableMap.set(rowEl, true);
	            }
	            else {
	                rowUnstableMap.delete(rowEl);
	                var innerMaxHeight = getRowInnerMaxHeight(rowEl);
	                if (!rowInnerMaxHeightMap.has(rowEl) || rowInnerMaxHeightMap.get(rowEl) !== innerMaxHeight) {
	                    rowInnerMaxHeightMap.set(rowEl, innerMaxHeight);
	                    _this.anyRowHeightsChanged = true;
	                }
	                if (!rowUnstableMap.size && _this.anyRowHeightsChanged) {
	                    _this.anyRowHeightsChanged = false;
	                    _this.setState({
	                        sectionRowMaxHeights: _this.computeSectionRowMaxHeights(),
	                    });
	                }
	            }
	        };
	        return _this;
	    }
	    ScrollGrid.prototype.render = function () {
	        var _a = this, props = _a.props, state = _a.state, context = _a.context;
	        var shrinkWidths = state.shrinkWidths;
	        var colGroupStats = this.compileColGroupStats(props.colGroups.map(function (colGroup) { return [colGroup]; }));
	        var microColGroupNodes = this.renderMicroColGroups(colGroupStats.map(function (stat, i) { return [stat.cols, shrinkWidths[i]]; }));
	        var classNames = common.getScrollGridClassNames(props.liquid, context);
	        var _b = this.getDims(); _b[0]; _b[1];
	        // TODO: make DRY
	        var sectionConfigs = props.sections;
	        var configCnt = sectionConfigs.length;
	        var configI = 0;
	        var currentConfig;
	        var headSectionNodes = [];
	        var bodySectionNodes = [];
	        var footSectionNodes = [];
	        while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'header') {
	            headSectionNodes.push(this.renderSection(currentConfig, configI, colGroupStats, microColGroupNodes, state.sectionRowMaxHeights, true));
	            configI += 1;
	        }
	        while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'body') {
	            bodySectionNodes.push(this.renderSection(currentConfig, configI, colGroupStats, microColGroupNodes, state.sectionRowMaxHeights, false));
	            configI += 1;
	        }
	        while (configI < configCnt && (currentConfig = sectionConfigs[configI]).type === 'footer') {
	            footSectionNodes.push(this.renderSection(currentConfig, configI, colGroupStats, microColGroupNodes, state.sectionRowMaxHeights, true));
	            configI += 1;
	        }
	        var isBuggy = !common.getCanVGrowWithinCell(); // see NOTE in SimpleScrollGrid
	        var roleAttrs = { role: 'rowgroup' };
	        return common.createElement('table', {
	            ref: props.elRef,
	            role: 'grid',
	            className: classNames.join(' '),
	        }, renderMacroColGroup(colGroupStats, shrinkWidths), Boolean(!isBuggy && headSectionNodes.length) && common.createElement.apply(void 0, tslib.__spreadArray(['thead', roleAttrs], headSectionNodes)), Boolean(!isBuggy && bodySectionNodes.length) && common.createElement.apply(void 0, tslib.__spreadArray(['tbody', roleAttrs], bodySectionNodes)), Boolean(!isBuggy && footSectionNodes.length) && common.createElement.apply(void 0, tslib.__spreadArray(['tfoot', roleAttrs], footSectionNodes)), isBuggy && common.createElement.apply(void 0, tslib.__spreadArray(tslib.__spreadArray(tslib.__spreadArray(['tbody', roleAttrs], headSectionNodes), bodySectionNodes), footSectionNodes)));
	    };
	    ScrollGrid.prototype.renderSection = function (sectionConfig, sectionIndex, colGroupStats, microColGroupNodes, sectionRowMaxHeights, isHeader) {
	        var _this = this;
	        if ('outerContent' in sectionConfig) {
	            return (common.createElement(common.Fragment, { key: sectionConfig.key }, sectionConfig.outerContent));
	        }
	        return (common.createElement("tr", { key: sectionConfig.key, role: "presentation", className: common.getSectionClassNames(sectionConfig, this.props.liquid).join(' ') }, sectionConfig.chunks.map(function (chunkConfig, i) { return _this.renderChunk(sectionConfig, sectionIndex, colGroupStats[i], microColGroupNodes[i], chunkConfig, i, (sectionRowMaxHeights[sectionIndex] || [])[i] || [], isHeader); })));
	    };
	    ScrollGrid.prototype.renderChunk = function (sectionConfig, sectionIndex, colGroupStat, microColGroupNode, chunkConfig, chunkIndex, rowHeights, isHeader) {
	        if ('outerContent' in chunkConfig) {
	            return (common.createElement(common.Fragment, { key: chunkConfig.key }, chunkConfig.outerContent));
	        }
	        var state = this.state;
	        var scrollerClientWidths = state.scrollerClientWidths, scrollerClientHeights = state.scrollerClientHeights;
	        var _a = this.getDims(), sectionCnt = _a[0], chunksPerSection = _a[1];
	        var index = sectionIndex * chunksPerSection + chunkIndex;
	        var sideScrollIndex = (!this.context.isRtl || common.getIsRtlScrollbarOnLeft()) ? chunksPerSection - 1 : 0;
	        var isVScrollSide = chunkIndex === sideScrollIndex;
	        var isLastSection = sectionIndex === sectionCnt - 1;
	        var forceXScrollbars = isLastSection && state.forceXScrollbars; // NOOOO can result in `null`
	        var forceYScrollbars = isVScrollSide && state.forceYScrollbars; // NOOOO can result in `null`
	        var allowXScrolling = colGroupStat && colGroupStat.allowXScrolling; // rename?
	        var allowYScrolling = common.getAllowYScrolling(this.props, sectionConfig); // rename? do in section func?
	        var chunkVGrow = common.getSectionHasLiquidHeight(this.props, sectionConfig); // do in section func?
	        var expandRows = sectionConfig.expandRows && chunkVGrow;
	        var tableMinWidth = (colGroupStat && colGroupStat.totalColMinWidth) || '';
	        var content = common.renderChunkContent(sectionConfig, chunkConfig, {
	            tableColGroupNode: microColGroupNode,
	            tableMinWidth: tableMinWidth,
	            clientWidth: scrollerClientWidths[index] !== undefined ? scrollerClientWidths[index] : null,
	            clientHeight: scrollerClientHeights[index] !== undefined ? scrollerClientHeights[index] : null,
	            expandRows: expandRows,
	            syncRowHeights: Boolean(sectionConfig.syncRowHeights),
	            rowSyncHeights: rowHeights,
	            reportRowHeightChange: this.handleRowHeightChange,
	        }, isHeader);
	        var overflowX = forceXScrollbars ? (isLastSection ? 'scroll' : 'scroll-hidden') :
	            !allowXScrolling ? 'hidden' :
	                (isLastSection ? 'auto' : 'scroll-hidden');
	        var overflowY = forceYScrollbars ? (isVScrollSide ? 'scroll' : 'scroll-hidden') :
	            !allowYScrolling ? 'hidden' :
	                (isVScrollSide ? 'auto' : 'scroll-hidden');
	        // it *could* be possible to reduce DOM wrappers by only doing a ClippedScroller when allowXScrolling or allowYScrolling,
	        // but if these values were to change, the inner components would be unmounted/remounted because of the parent change.
	        content = (common.createElement(ClippedScroller, { ref: this.clippedScrollerRefs.createRef(index), scrollerElRef: this.scrollerElRefs.createRef(index), overflowX: overflowX, overflowY: overflowY, liquid: chunkVGrow, maxHeight: sectionConfig.maxHeight }, content));
	        return common.createElement(isHeader ? 'th' : 'td', {
	            key: chunkConfig.key,
	            ref: this.chunkElRefs.createRef(index),
	            role: 'presentation',
	        }, content);
	    };
	    ScrollGrid.prototype.componentDidMount = function () {
	        this.getStickyScrolling = common.memoizeArraylike(initStickyScrolling, null, destroyStickyScrolling);
	        this.getScrollSyncersBySection = common.memoizeHashlike(initScrollSyncer.bind(this, true), null, destroyScrollSyncer);
	        this.getScrollSyncersByColumn = common.memoizeHashlike(initScrollSyncer.bind(this, false), null, destroyScrollSyncer);
	        this.updateScrollSyncers();
	        this.handleSizing(false);
	        this.context.addResizeHandler(this.handleSizing);
	    };
	    ScrollGrid.prototype.componentDidUpdate = function (prevProps, prevState) {
	        this.updateScrollSyncers();
	        // TODO: need better solution when state contains non-sizing things
	        this.handleSizing(false, prevState.sectionRowMaxHeights !== this.state.sectionRowMaxHeights);
	    };
	    ScrollGrid.prototype.componentWillUnmount = function () {
	        this.context.removeResizeHandler(this.handleSizing);
	        this.destroyStickyScrolling();
	        this.destroyScrollSyncers();
	    };
	    ScrollGrid.prototype.allowSizing = function () {
	        var now = new Date();
	        if (!this.lastSizingDate ||
	            now.valueOf() > this.lastSizingDate.valueOf() + common.config.SCROLLGRID_RESIZE_INTERVAL) {
	            this.lastSizingDate = now;
	            this.recentSizingCnt = 0;
	            return true;
	        }
	        return (this.recentSizingCnt += 1) <= 10;
	    };
	    ScrollGrid.prototype.computeShrinkWidths = function () {
	        var _this = this;
	        var colGroupStats = this.compileColGroupStats(this.props.colGroups.map(function (colGroup) { return [colGroup]; }));
	        var _a = this.getDims(), sectionCnt = _a[0], chunksPerSection = _a[1];
	        var cnt = sectionCnt * chunksPerSection;
	        var shrinkWidths = [];
	        colGroupStats.forEach(function (colGroupStat, i) {
	            if (colGroupStat.hasShrinkCol) {
	                var chunkEls = _this.chunkElRefs.collect(i, cnt, chunksPerSection); // in one col
	                shrinkWidths[i] = common.computeShrinkWidth(chunkEls);
	            }
	        });
	        return shrinkWidths;
	    };
	    // has the side effect of grooming rowInnerMaxHeightMap
	    // TODO: somehow short-circuit if there are no new height changes
	    ScrollGrid.prototype.computeSectionRowMaxHeights = function () {
	        var newHeightMap = new Map();
	        var _a = this.getDims(), sectionCnt = _a[0], chunksPerSection = _a[1];
	        var sectionRowMaxHeights = [];
	        for (var sectionI = 0; sectionI < sectionCnt; sectionI += 1) {
	            var sectionConfig = this.props.sections[sectionI];
	            var assignableHeights = []; // chunk, row
	            if (sectionConfig && sectionConfig.syncRowHeights) {
	                var rowHeightsByChunk = [];
	                for (var chunkI = 0; chunkI < chunksPerSection; chunkI += 1) {
	                    var index = sectionI * chunksPerSection + chunkI;
	                    var rowHeights = [];
	                    var chunkEl = this.chunkElRefs.currentMap[index];
	                    if (chunkEl) {
	                        rowHeights = common.findElements(chunkEl, '.fc-scrollgrid-sync-table tr').map(function (rowEl) {
	                            var max = getRowInnerMaxHeight(rowEl);
	                            newHeightMap.set(rowEl, max);
	                            return max;
	                        });
	                    }
	                    else {
	                        rowHeights = [];
	                    }
	                    rowHeightsByChunk.push(rowHeights);
	                }
	                var rowCnt = rowHeightsByChunk[0].length;
	                var isEqualRowCnt = true;
	                for (var chunkI = 1; chunkI < chunksPerSection; chunkI += 1) {
	                    var isOuterContent = sectionConfig.chunks[chunkI] && sectionConfig.chunks[chunkI].outerContent !== undefined; // can be null
	                    if (!isOuterContent && rowHeightsByChunk[chunkI].length !== rowCnt) { // skip outer content
	                        isEqualRowCnt = false;
	                        break;
	                    }
	                }
	                if (!isEqualRowCnt) {
	                    var chunkHeightSums = [];
	                    for (var chunkI = 0; chunkI < chunksPerSection; chunkI += 1) {
	                        chunkHeightSums.push(sumNumbers(rowHeightsByChunk[chunkI]) + rowHeightsByChunk[chunkI].length);
	                    }
	                    var maxTotalSum = Math.max.apply(Math, chunkHeightSums);
	                    for (var chunkI = 0; chunkI < chunksPerSection; chunkI += 1) {
	                        var rowInChunkCnt = rowHeightsByChunk[chunkI].length;
	                        var rowInChunkTotalHeight = maxTotalSum - rowInChunkCnt; // subtract border
	                        // height of non-first row. we do this to avoid rounding, because it's unreliable within a table
	                        var rowInChunkHeightOthers = Math.floor(rowInChunkTotalHeight / rowInChunkCnt);
	                        // whatever is leftover goes to the first row
	                        var rowInChunkHeightFirst = rowInChunkTotalHeight - rowInChunkHeightOthers * (rowInChunkCnt - 1);
	                        var rowInChunkHeights = [];
	                        var row = 0;
	                        if (row < rowInChunkCnt) {
	                            rowInChunkHeights.push(rowInChunkHeightFirst);
	                            row += 1;
	                        }
	                        while (row < rowInChunkCnt) {
	                            rowInChunkHeights.push(rowInChunkHeightOthers);
	                            row += 1;
	                        }
	                        assignableHeights.push(rowInChunkHeights);
	                    }
	                }
	                else {
	                    for (var chunkI = 0; chunkI < chunksPerSection; chunkI += 1) {
	                        assignableHeights.push([]);
	                    }
	                    for (var row = 0; row < rowCnt; row += 1) {
	                        var rowHeightsAcrossChunks = [];
	                        for (var chunkI = 0; chunkI < chunksPerSection; chunkI += 1) {
	                            var h = rowHeightsByChunk[chunkI][row];
	                            if (h != null) { // protect against outerContent
	                                rowHeightsAcrossChunks.push(h);
	                            }
	                        }
	                        var maxHeight = Math.max.apply(Math, rowHeightsAcrossChunks);
	                        for (var chunkI = 0; chunkI < chunksPerSection; chunkI += 1) {
	                            assignableHeights[chunkI].push(maxHeight);
	                        }
	                    }
	                }
	            }
	            sectionRowMaxHeights.push(assignableHeights);
	        }
	        this.rowInnerMaxHeightMap = newHeightMap;
	        return sectionRowMaxHeights;
	    };
	    ScrollGrid.prototype.computeScrollerDims = function () {
	        var scrollbarWidth = common.getScrollbarWidths();
	        var _a = this.getDims(), sectionCnt = _a[0], chunksPerSection = _a[1];
	        var sideScrollI = (!this.context.isRtl || common.getIsRtlScrollbarOnLeft()) ? chunksPerSection - 1 : 0;
	        var lastSectionI = sectionCnt - 1;
	        var currentScrollers = this.clippedScrollerRefs.currentMap;
	        var scrollerEls = this.scrollerElRefs.currentMap;
	        var forceYScrollbars = false;
	        var forceXScrollbars = false;
	        var scrollerClientWidths = {};
	        var scrollerClientHeights = {};
	        for (var sectionI = 0; sectionI < sectionCnt; sectionI += 1) { // along edge
	            var index = sectionI * chunksPerSection + sideScrollI;
	            var scroller = currentScrollers[index];
	            if (scroller && scroller.needsYScrolling()) {
	                forceYScrollbars = true;
	                break;
	            }
	        }
	        for (var chunkI = 0; chunkI < chunksPerSection; chunkI += 1) { // along last row
	            var index = lastSectionI * chunksPerSection + chunkI;
	            var scroller = currentScrollers[index];
	            if (scroller && scroller.needsXScrolling()) {
	                forceXScrollbars = true;
	                break;
	            }
	        }
	        for (var sectionI = 0; sectionI < sectionCnt; sectionI += 1) {
	            for (var chunkI = 0; chunkI < chunksPerSection; chunkI += 1) {
	                var index = sectionI * chunksPerSection + chunkI;
	                var scrollerEl = scrollerEls[index];
	                if (scrollerEl) {
	                    // TODO: weird way to get this. need harness b/c doesn't include table borders
	                    var harnessEl = scrollerEl.parentNode;
	                    scrollerClientWidths[index] = Math.floor(harnessEl.getBoundingClientRect().width - ((chunkI === sideScrollI && forceYScrollbars)
	                        ? scrollbarWidth.y // use global because scroller might not have scrollbars yet but will need them in future
	                        : 0));
	                    scrollerClientHeights[index] = Math.floor(harnessEl.getBoundingClientRect().height - ((sectionI === lastSectionI && forceXScrollbars)
	                        ? scrollbarWidth.x // use global because scroller might not have scrollbars yet but will need them in future
	                        : 0));
	                }
	            }
	        }
	        return { forceYScrollbars: forceYScrollbars, forceXScrollbars: forceXScrollbars, scrollerClientWidths: scrollerClientWidths, scrollerClientHeights: scrollerClientHeights };
	    };
	    ScrollGrid.prototype.updateStickyScrolling = function () {
	        var isRtl = this.context.isRtl;
	        var argsByKey = this.scrollerElRefs.getAll().map(function (scrollEl) { return [scrollEl, isRtl]; });
	        var stickyScrollings = this.getStickyScrolling(argsByKey);
	        stickyScrollings.forEach(function (stickyScrolling) { return stickyScrolling.updateSize(); });
	        this.stickyScrollings = stickyScrollings;
	    };
	    ScrollGrid.prototype.destroyStickyScrolling = function () {
	        this.stickyScrollings.forEach(destroyStickyScrolling);
	    };
	    ScrollGrid.prototype.updateScrollSyncers = function () {
	        var _a = this.getDims(), sectionCnt = _a[0], chunksPerSection = _a[1];
	        var cnt = sectionCnt * chunksPerSection;
	        var scrollElsBySection = {};
	        var scrollElsByColumn = {};
	        var scrollElMap = this.scrollerElRefs.currentMap;
	        for (var sectionI = 0; sectionI < sectionCnt; sectionI += 1) {
	            var startIndex = sectionI * chunksPerSection;
	            var endIndex = startIndex + chunksPerSection;
	            scrollElsBySection[sectionI] = common.collectFromHash(scrollElMap, startIndex, endIndex, 1); // use the filtered
	        }
	        for (var col = 0; col < chunksPerSection; col += 1) {
	            scrollElsByColumn[col] = this.scrollerElRefs.collect(col, cnt, chunksPerSection); // DON'T use the filtered
	        }
	        this.scrollSyncersBySection = this.getScrollSyncersBySection(scrollElsBySection);
	        this.scrollSyncersByColumn = this.getScrollSyncersByColumn(scrollElsByColumn);
	    };
	    ScrollGrid.prototype.destroyScrollSyncers = function () {
	        common.mapHash(this.scrollSyncersBySection, destroyScrollSyncer);
	        common.mapHash(this.scrollSyncersByColumn, destroyScrollSyncer);
	    };
	    ScrollGrid.prototype.getChunkConfigByIndex = function (index) {
	        var chunksPerSection = this.getDims()[1];
	        var sectionI = Math.floor(index / chunksPerSection);
	        var chunkI = index % chunksPerSection;
	        var sectionConfig = this.props.sections[sectionI];
	        return sectionConfig && sectionConfig.chunks[chunkI];
	    };
	    ScrollGrid.prototype.forceScrollLeft = function (col, scrollLeft) {
	        var scrollSyncer = this.scrollSyncersByColumn[col];
	        if (scrollSyncer) {
	            scrollSyncer.forceScrollLeft(scrollLeft);
	        }
	    };
	    ScrollGrid.prototype.forceScrollTop = function (sectionI, scrollTop) {
	        var scrollSyncer = this.scrollSyncersBySection[sectionI];
	        if (scrollSyncer) {
	            scrollSyncer.forceScrollTop(scrollTop);
	        }
	    };
	    ScrollGrid.prototype._handleChunkEl = function (chunkEl, key) {
	        var chunkConfig = this.getChunkConfigByIndex(parseInt(key, 10));
	        if (chunkConfig) { // null if section disappeared. bad, b/c won't null-set the elRef
	            common.setRef(chunkConfig.elRef, chunkEl);
	        }
	    };
	    ScrollGrid.prototype._handleScrollerEl = function (scrollerEl, key) {
	        var chunkConfig = this.getChunkConfigByIndex(parseInt(key, 10));
	        if (chunkConfig) { // null if section disappeared. bad, b/c won't null-set the elRef
	            common.setRef(chunkConfig.scrollerElRef, scrollerEl);
	        }
	    };
	    ScrollGrid.prototype.getDims = function () {
	        var sectionCnt = this.props.sections.length;
	        var chunksPerSection = sectionCnt ? this.props.sections[0].chunks.length : 0;
	        return [sectionCnt, chunksPerSection];
	    };
	    return ScrollGrid;
	}(common.BaseComponent));
	ScrollGrid.addStateEquality({
	    shrinkWidths: common.isArraysEqual,
	    scrollerClientWidths: common.isPropsEqual,
	    scrollerClientHeights: common.isPropsEqual,
	});
	function sumNumbers(numbers) {
	    var sum = 0;
	    for (var _i = 0, numbers_1 = numbers; _i < numbers_1.length; _i++) {
	        var n = numbers_1[_i];
	        sum += n;
	    }
	    return sum;
	}
	function getRowInnerMaxHeight(rowEl) {
	    var innerHeights = common.findElements(rowEl, '.fc-scrollgrid-sync-inner').map(getElHeight);
	    if (innerHeights.length) {
	        return Math.max.apply(Math, innerHeights);
	    }
	    return 0;
	}
	function getElHeight(el) {
	    return el.offsetHeight; // better to deal with integers, for rounding, for PureComponent
	}
	function renderMacroColGroup(colGroupStats, shrinkWidths) {
	    var children = colGroupStats.map(function (colGroupStat, i) {
	        var width = colGroupStat.width;
	        if (width === 'shrink') {
	            width = colGroupStat.totalColWidth + common.sanitizeShrinkWidth(shrinkWidths[i]) + 1; // +1 for border :(
	        }
	        return ( // eslint-disable-next-line react/jsx-key
	        common.createElement("col", { style: { width: width } }));
	    });
	    return common.createElement.apply(void 0, tslib.__spreadArray(['colgroup', {}], children));
	}
	function compileColGroupStat(colGroupConfig) {
	    var totalColWidth = sumColProp(colGroupConfig.cols, 'width'); // excludes "shrink"
	    var totalColMinWidth = sumColProp(colGroupConfig.cols, 'minWidth');
	    var hasShrinkCol = common.hasShrinkWidth(colGroupConfig.cols);
	    var allowXScrolling = colGroupConfig.width !== 'shrink' && Boolean(totalColWidth || totalColMinWidth || hasShrinkCol);
	    return {
	        hasShrinkCol: hasShrinkCol,
	        totalColWidth: totalColWidth,
	        totalColMinWidth: totalColMinWidth,
	        allowXScrolling: allowXScrolling,
	        cols: colGroupConfig.cols,
	        width: colGroupConfig.width,
	    };
	}
	function sumColProp(cols, propName) {
	    var total = 0;
	    for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
	        var col = cols_1[_i];
	        var val = col[propName];
	        if (typeof val === 'number') {
	            total += val * (col.span || 1);
	        }
	    }
	    return total;
	}
	var COL_GROUP_STAT_EQUALITY = {
	    cols: common.isColPropsEqual,
	};
	function isColGroupStatsEqual(stat0, stat1) {
	    return common.compareObjs(stat0, stat1, COL_GROUP_STAT_EQUALITY);
	}
	// for memoizers...
	function initScrollSyncer(isVertical) {
	    var scrollEls = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        scrollEls[_i - 1] = arguments[_i];
	    }
	    return new ScrollSyncer(isVertical, scrollEls);
	}
	function destroyScrollSyncer(scrollSyncer) {
	    scrollSyncer.destroy();
	}
	function initStickyScrolling(scrollEl, isRtl) {
	    return new StickyScrolling(scrollEl, isRtl);
	}
	function destroyStickyScrolling(stickyScrolling) {
	    stickyScrolling.destroy();
	}
	
	var main = common.createPlugin({
	    deps: [
	        premiumCommonPlugin__default['default'],
	    ],
	    scrollGridImpl: ScrollGrid,
	});
	common.config.SCROLLGRID_RESIZE_INTERVAL = 500;
	
	exports.ScrollGrid = ScrollGrid;
	exports.default = main;
	exports.setScrollFromLeftEdge = setScrollFromLeftEdge;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _Calendar = __webpack_require__(626);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var DateFilter = function (_Component) {
	  (0, _inherits2.default)(DateFilter, _Component);
	  var _super = _createSuper(DateFilter);
	  function DateFilter(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, DateFilter);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "input", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getInputRef", function () {
	      return _this.input.current;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onStartTextChange", function (start) {
	      var text = _this.state.text;
	      if (text && text.start && start === text.start) {
	        return;
	      }
	      var newText = typeof text === 'string' ? {} : _objectSpread({}, text);
	      newText.start = start;
	      _this.setState({
	        text: newText
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onEndTextChange", function (end) {
	      var text = _this.state.text;
	      if (text && text.end && end === text.end) {
	        return;
	      }
	      var newText = typeof text === 'string' ? {} : _objectSpread({}, text);
	      newText.end = end;
	      _this.setState({
	        text: newText
	      });
	    });
	    var filterValue = props.filterValue;
	    _this.input = (0, _react.createRef)();
	    _this.state = {
	      value: filterValue ? filterValue.value || '' : '',
	      text: ''
	    };
	    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onStartChange = _this.onStartChange.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onEndChange = _this.onEndChange.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onValueChange = _this.onValueChange.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onTextChange = _this.onTextChange.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	  (0, _createClass2.default)(DateFilter, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.filterValue && prevProps.filterValue && this.props.filterValue.value !== prevProps.filterValue.value) {
	        this.setValue(this.props.filterValue.value);
	      }
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(value) {
	      if (value === this.state.value) {
	        return;
	      }
	      this.onValueChange(value);
	      this.setValue(value);
	    }
	  }, {
	    key: "onStartChange",
	    value: function onStartChange(start) {
	      if (this.state.value) {
	        if (this.state.value.start && start === this.state.value.start) {
	          return;
	        }
	      }
	      var newValue = typeof this.state.value === 'string' ? {} : _objectSpread({}, this.state.value);
	      newValue.start = start;
	      this.onValueChange(newValue);
	      this.setValue(newValue);
	    }
	  }, {
	    key: "onEndChange",
	    value: function onEndChange(end) {
	      if (this.state.value) {
	        if (this.state.value.end && end === this.state.value.end) {
	          return;
	        }
	      }
	      var newValue = typeof this.state.value === 'string' ? {} : _objectSpread({}, this.state.value);
	      newValue.end = end;
	      this.onValueChange(newValue);
	      this.setValue(newValue);
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value) {
	      this.setState({
	        value: value
	      });
	      if (typeof value === 'string') {
	        this.onTextChange(value);
	      }
	    }
	  }, {
	    key: "onValueChange",
	    value: function onValueChange(value) {
	      this.props.onChange && this.props.onChange(_objectSpread(_objectSpread({}, this.props.filterValue), {}, {
	        value: value
	      }));
	    }
	  }, {
	    key: "onTextChange",
	    value: function onTextChange(value) {
	      this.setState({
	        text: value
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	        filterValue = _this$props.filterValue,
	        readOnly = _this$props.readOnly,
	        disabled = _this$props.disabled,
	        rtl = _this$props.rtl,
	        style = _this$props.style,
	        cell = _this$props.cell,
	        renderInPortal = _this$props.renderInPortal,
	        i18n = _this$props.i18n,
	        theme = _this$props.theme;
	      var _this$props2 = this.props,
	        filterEditorProps = _this$props2.filterEditorProps,
	        dateFormat = _this$props2.cellProps.dateFormat;
	      if (filterEditorProps === undefined) {
	        filterEditorProps = filterValue && filterValue.filterEditorProps;
	      }
	      if (dateFormat === undefined) {
	        if (typeof filterEditorProps === 'function') {
	          dateFormat = filterEditorProps(this.props, {
	            value: this.state.value,
	            index: 0
	          }).dateFormat;
	        } else {
	          dateFormat = filterEditorProps && filterEditorProps.dateFormat || '';
	        }
	      }
	      var calendarLabels = {
	        todayButtonText: i18n && i18n('calendar.todayButtonText'),
	        clearButtonText: i18n && i18n('calendar.clearButtonText'),
	        okButtonText: i18n && i18n('calendar.okButtonText'),
	        cancelButtonText: i18n && i18n('calendar.cancelButtonText')
	      };
	      var startTarget = function startTarget() {
	        return cell && cell.getDOMNode().querySelectorAll('.InovuaReactDataGrid__column-header__filter')[0] || cell && cell.getDOMNode();
	      };
	      var inputProps = {
	        ref: this.input,
	        calendarProps: _objectSpread({}, calendarLabels),
	        readOnly: readOnly,
	        disabled: disabled,
	        dateFormat: dateFormat,
	        forceValidDate: false,
	        relativeToViewport: true,
	        okButton: false,
	        cancelButton: false,
	        overlayProps: {
	          zIndex: null,
	          positions: ['tl-bl', 'bl-tl', 'tr-br', 'br-tr'],
	          target: startTarget
	        },
	        style: _objectSpread({
	          minWidth: 0
	        }, style),
	        theme: theme,
	        rtl: rtl
	      };
	      if (filterValue) {
	        inputProps.value = this.state.value;
	        if (!inputProps.value) {
	          inputProps.text = '';
	        }
	      }
	      var renderPicker = renderInPortal;
	      var editorClassName = 'InovuaReactDataGrid__column-header__filter InovuaReactDataGrid__column-header__filter--date';
	      switch (filterValue && filterValue.operator) {
	        case 'inrange':
	        case 'notinrange':
	          var _this$state = this.state,
	            value = _this$state.value,
	            text = _this$state.text;
	          var start = value.start,
	            end = value.end;
	          var startText = text.start,
	            endText = text.end,
	            startInputProps = _objectSpread(_objectSpread({}, inputProps), {}, {
	              value: start,
	              text: startText
	            }),
	            endInputProps = _objectSpread(_objectSpread({}, inputProps), {}, {
	              value: end,
	              text: endText,
	              overlayProps: {
	                target: function target() {
	                  var filterNodes = cell && cell.getDOMNode().querySelectorAll('.InovuaReactDataGrid__column-header__filter');
	                  return filterNodes[filterNodes.length - 1];
	                }
	              }
	            });
	          var startFilterEditorProps = typeof filterEditorProps === 'function' ? filterEditorProps(this.props, {
	            value: start,
	            index: 0
	          }) : filterEditorProps;
	          var endFilterEditorProps = typeof filterEditorProps === 'function' ? filterEditorProps(this.props, {
	            value: end,
	            index: 1
	          }) : filterEditorProps;
	          var startProps = _objectSpread(_objectSpread(_objectSpread({
	            okButton: true,
	            placeholder: i18n && i18n('start')
	          }, startFilterEditorProps), {}, {
	            onChange: this.onStartChange,
	            onTextChange: this.onStartTextChange,
	            className: editorClassName
	          }, startInputProps), {}, {
	            renderPicker: renderPicker
	          });
	          var startEditor = _react.default.createElement(_Calendar.DateInput, _objectSpread({}, startProps));
	          var endProps = _objectSpread(_objectSpread(_objectSpread({
	            okButton: true,
	            placeholder: i18n && i18n('end')
	          }, endFilterEditorProps), {}, {
	            onChange: this.onEndChange,
	            onTextChange: this.onEndTextChange,
	            className: editorClassName
	          }, endInputProps), {}, {
	            renderPicker: renderPicker,
	            endInput: true
	          });
	          var endEditor = _react.default.createElement(_Calendar.DateInput, _objectSpread({}, endProps));
	          return this.props.render(_react.default.createElement("div", {
	            style: {
	              display: 'flex'
	            }
	          }, startEditor, _react.default.createElement("div", {
	            className: "InovuaReactDataGrid__column-header__filter__binary_operator_separator"
	          }), endEditor));
	        default:
	          var finalEditorProps = typeof filterEditorProps === 'function' ? filterEditorProps(this.props, {
	            value: this.state.value
	          }) : filterEditorProps;
	          if (finalEditorProps !== null && finalEditorProps !== void 0 && finalEditorProps.inputRef) {
	            finalEditorProps.inputRef.current = this.getInputRef();
	          }
	          var finalProps = _objectSpread(_objectSpread(_objectSpread({}, finalEditorProps), {}, {
	            onChange: this.onChange,
	            onTextChange: this.onTextChange,
	            className: editorClassName
	          }, inputProps), {}, {
	            renderPicker: renderPicker
	          });
	          return this.props.render(_react.default.createElement(_Calendar.DateInput, _objectSpread({}, finalProps)));
	      }
	    }
	  }]);
	  return DateFilter;
	}(_react.Component);
	var _default = DateFilter;
	exports.default = _default;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(200));
	var _NotifyResize = _interopRequireDefault(__webpack_require__(84));
	var _autoBind = _interopRequireDefault(__webpack_require__(52));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var ResizeObserver = globalObject.ResizeObserver || _resizeObserverPolyfill.default;
	var useFragment = !!_react.default.Fragment;
	var coverStyle = !useFragment ? {
	  height: '100%',
	  position: 'absolute',
	  width: '100%',
	  top: 0,
	  left: 0
	} : null;
	var FLEX_1_STYLE = {
	  flex: 1
	};
	var nativeFlexCoverStyle = {
	  height: '100%',
	  position: 'absolute',
	  width: '100%',
	  top: 0,
	  left: 0,
	  display: 'flex',
	  flexFlow: 'column'
	};
	var FakeFlex = function (_Component) {
	  (0, _inherits2.default)(FakeFlex, _Component);
	  var _super = _createSuper(FakeFlex);
	  function FakeFlex(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, FakeFlex);
	    _this = _super.call(this, props);
	    (0, _autoBind.default)((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      flexHeight: null
	    };
	    _this.flexRef = (0, _react.createRef)();
	    return _this;
	  }
	  (0, _createClass2.default)(FakeFlex, [{
	    key: "onResize",
	    value: function onResize(size) {
	      var _this2 = this;
	      if (this.props.useNativeFlex) {
	        return;
	      }
	      this.size = size;
	      if (size.height === this.availableHeight) {
	        return;
	      }
	      this.availableHeight = size.height;
	      requestAnimationFrame(function () {
	        _this2.computeSize();
	        requestAnimationFrame(_this2.resync);
	      });
	    }
	  }, {
	    key: "resync",
	    value: function resync() {
	      var node = this.getNode();
	      if (!node || this.unmounted) {
	        return;
	      }
	      var _node$getBoundingClie = node.getBoundingClientRect(),
	        width = _node$getBoundingClie.width,
	        height = _node$getBoundingClie.height;
	      this.onResize({
	        width: width,
	        height: height
	      });
	    }
	  }, {
	    key: "onChildResize",
	    value: function onChildResize() {
	      this.computeSize();
	    }
	  }, {
	    key: "computeSize",
	    value: function computeSize() {
	      var _this3 = this;
	      var availableHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.availableHeight;
	      var node = this.getNode();
	      if (!node || this.unmounted) {
	        return;
	      }
	      var flexIndex = this.props.flexIndex;
	      var sum = [].slice.call(node.children).reduce(function (acc, child, index) {
	        if (index >= _this3.length) {
	          return acc;
	        }
	        if (index === flexIndex) {
	          return acc;
	        }
	        return acc + child.offsetHeight;
	      }, 0);
	      var flexHeight = availableHeight - sum;
	      if (flexHeight != this.state.flexHeight) {
	        this.setState({
	          flexHeight: flexHeight
	        });
	      }
	    }
	  }, {
	    key: "getNode",
	    value: function getNode() {
	      if (this.node) {
	        return this.node;
	      }
	      if (this.props.getNode) {
	        this.node = this.props.getNode();
	      } else {
	        this.node = this.flexRef.current;
	      }
	      return this.node;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this4 = this;
	      this.unmounted = false;
	      requestAnimationFrame(function () {
	        _this4.setupObservers();
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.prevLength && this.prevLength !== this.length) {
	        this.clearObservers();
	        this.setupObservers();
	      }
	      this.prevLength = this.length;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unmounted = true;
	      this.clearObservers();
	    }
	  }, {
	    key: "setupObservers",
	    value: function setupObservers() {
	      var _this5 = this;
	      if (this.props.useNativeFlex) {
	        return;
	      }
	      var node = this.getNode();
	      if (!node) {
	        return;
	      }
	      var flexIndex = this.props.flexIndex;
	      this.observers = [].slice.call(node.children).map(function (child, index) {
	        if (index >= _this5.length) {
	          return null;
	        }
	        if (index === flexIndex) {
	          return null;
	        }
	        if (child.__observer) {
	          return child.__observer;
	        }
	        var observer = new ResizeObserver(function (entries) {
	          var first = entries[0];
	          if (first) {
	            _this5.onChildResize(first.contentRect);
	          }
	        });
	        observer.observe(child);
	        observer.__obsTarget = child;
	        child.__observer = observer;
	        return observer;
	      }).filter(Boolean);
	    }
	  }, {
	    key: "clearObservers",
	    value: function clearObservers() {
	      var node = this.getNode();
	      if (!node) {
	        return;
	      }
	      [].slice.call(node.children).map(function (child) {
	        if (child && child.__observer) {
	          child.__observer.__obsTarget = null;
	          child.__observer = null;
	        }
	      });
	      if (this.observers) {
	        this.observers.forEach(function (o) {
	          if (o.unobserve && o.__obsTarget) {
	            o.__obsTarget.__observer = null;
	            o.unobserve(o.__obsTarget);
	          }
	          if (o.disconnect) {
	            o.disconnect();
	          }
	        });
	      }
	      delete this.observers;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var flexIndex = props.flexIndex,
	        useNativeFlex = props.useNativeFlex;
	      var flexHeight = this.state.flexHeight;
	      var children = _react.default.Children.toArray(props.children).filter(Boolean).map(function (x, i) {
	        if (i === flexIndex && (useNativeFlex || flexHeight)) {
	          var additionalStyle = useNativeFlex ? FLEX_1_STYLE : {
	            height: flexHeight
	          };
	          x = (0, _react.cloneElement)(x, {
	            style: x.props.style ? _objectSpread(_objectSpread({}, x.props.style), additionalStyle) : additionalStyle
	          });
	        }
	        return x;
	      });
	      this.length = children.length;
	      var resizer = !useNativeFlex ? _react.default.createElement(_NotifyResize.default, {
	        key: "fakeflexresizer",
	        onResize: this.onResize,
	        notifyOnMount: true,
	        ResizeObserver: ResizeObserver
	      }) : null;
	      if (useFragment && !useNativeFlex) {
	        return _react.default.createElement(_react.default.Fragment, {
	          key: "fragment"
	        }, children, resizer);
	      }
	      return _react.default.createElement("div", {
	        ref: this.flexRef,
	        style: useNativeFlex ? nativeFlexCoverStyle : coverStyle
	      }, children, resizer);
	    }
	  }]);
	  return FakeFlex;
	}(_react.Component);
	FakeFlex.propTypes = {
	  flexIndex: _propTypes.default.number.isRequired,
	  getNode: _propTypes.default.func.isRequired,
	  useNativeFlex: _propTypes.default.bool
	};
	var _default = FakeFlex;
	exports.default = _default;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _lodash = _interopRequireDefault(__webpack_require__(180));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var propTypes = {
	  onMouseDown: _propTypes.default.func.isRequired,
	  onTouchStart: _propTypes.default.func.isRequired,
	  resizeHandleClassName: _propTypes.default.string.isRequired
	};
	var ColumnResizer = function (_Component) {
	  (0, _inherits2.default)(ColumnResizer, _Component);
	  var _super = _createSuper(ColumnResizer);
	  function ColumnResizer(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, ColumnResizer);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "domRef", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "overHeight", 0);
	    _this.state = {
	      over: false
	    };
	    _this.domRef = _react.default.createRef();
	    _this.onMouseDown = _this.onMouseDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onTouchStart = _this.onTouchStart.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onMouseEnter = _this.onMouseEnter.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onMouseLeave = _this.onMouseLeave.bind((0, _assertThisInitialized2.default)(_this));
	    _this.setOver = (0, _lodash.default)(_this.setOver, 50, {
	      leading: false
	    });
	    return _this;
	  }
	  (0, _createClass2.default)(ColumnResizer, [{
	    key: "onMouseEnter",
	    value: function onMouseEnter() {
	      var parent = this.domRef.current.parentElement;
	      var overHeight = parent ? parent.offsetHeight : null;
	      this.overHeight = overHeight;
	      this.setOver(true);
	    }
	  }, {
	    key: "setOver",
	    value: function setOver(value) {
	      if (value) {
	        this.setState({
	          over: true,
	          overHeight: this.overHeight
	        });
	      } else {
	        this.setState({
	          over: false
	        });
	      }
	    }
	  }, {
	    key: "onMouseLeave",
	    value: function onMouseLeave() {
	      this.setOver(false);
	    }
	  }, {
	    key: "onMouseDown",
	    value: function onMouseDown(event) {
	      event.preventDefault();
	      if (this.props.onMouseDown) {
	        this.props.onMouseDown(event);
	      }
	      this.setState({
	        over: false
	      });
	    }
	  }, {
	    key: "onTouchStart",
	    value: function onTouchStart(event) {
	      event.preventDefault();
	      if (this.props.onTouchStart) {
	        this.props.onTouchStart(event);
	      }
	      this.setState({
	        over: false
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var _this$props = this.props,
	        className = _this$props.className,
	        resizeHandleClassName = _this$props.resizeHandleClassName;
	      var style = _objectSpread(_objectSpread({}, props.style), {}, {
	        height: this.state.overHeight
	      });
	      var resizeHandleStyle = _objectSpread({}, props.resizeHandleStyle);
	      if (this.state.over) {
	        resizeHandleStyle.visibility = 'visible';
	      } else {
	        resizeHandleStyle.visibility = 'hidden';
	      }
	      return _react.default.createElement("div", {
	        ref: this.domRef,
	        draggable: "false",
	        className: className,
	        onMouseDown: this.onMouseDown,
	        onTouchStart: this.onTouchStart,
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave,
	        style: style
	      }, _react.default.createElement("div", {
	        style: resizeHandleStyle,
	        className: resizeHandleClassName
	      }));
	    }
	  }]);
	  return ColumnResizer;
	}(_react.Component);
	exports.default = ColumnResizer;
	(0, _defineProperty2.default)(ColumnResizer, "propTypes", propTypes);

/***/ },
/* 210 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var emptyObject = Object.freeze ? Object.freeze({}) : null;
	var addTransitionDuration = function addTransitionDuration(cols, style) {
	  var firstCol = cols[0];
	  if (firstCol.inTransition) {
	    var duration = firstCol.inShowTransition ? firstCol.showTransitionDuration : firstCol.hideTransitionDuration;
	    duration = duration || firstCol.visibilityTransitionDuration;
	    style.transitionDuration = typeof duration == 'number' ? "".concat(duration, "ms") : duration;
	    return true;
	  }
	  return false;
	};
	var _default = function _default(initialCells, _ref, scrollLeft) {
	  var renderLockedStartCells = _ref.renderLockedStartCells,
	    renderLockedEndCells = _ref.renderLockedEndCells,
	    lockedStartColumns = _ref.lockedStartColumns,
	    lockedEndColumns = _ref.lockedEndColumns,
	    availableWidth = _ref.availableWidth,
	    virtualizeColumns = _ref.virtualizeColumns,
	    sticky = _ref.sticky,
	    rowHeight = _ref.rowHeight,
	    columns = _ref.columns,
	    depth = _ref.depth,
	    data = _ref.data,
	    initialRowHeight = _ref.initialRowHeight,
	    groupNestingSize = _ref.groupNestingSize,
	    nativeScroll = _ref.nativeScroll,
	    scrollbarWidth = _ref.scrollbarWidth,
	    groupProps = _ref.groupProps,
	    expandGroupTitle = _ref.expandGroupTitle,
	    computedRowExpandEnabled = _ref.computedRowExpandEnabled,
	    expanded = _ref.expanded,
	    shouldRenderCollapsedRowDetails = _ref.shouldRenderCollapsedRowDetails,
	    virtualListBorderLeft = _ref.virtualListBorderLeft,
	    virtualListBorderRight = _ref.virtualListBorderRight,
	    getScrollLeftMax = _ref.getScrollLeftMax,
	    rtl = _ref.rtl;
	  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : emptyObject,
	    lockedStartContent = _ref2.lockedStartContent,
	    lockedEndContent = _ref2.lockedEndContent,
	    unlockedContent = _ref2.unlockedContent,
	    isHeader = _ref2.isHeader;
	  var style = arguments.length > 4 ? arguments[4] : undefined;
	  var lockedStartCount = lockedStartColumns ? lockedStartColumns.length : 0;
	  var lockedEndCount = lockedEndColumns ? lockedEndColumns.length : 0;
	  var lockedEndStartIndex = initialCells.length - lockedEndCount;
	  var groupDepth = data && data.__group ? data.depth - 1 : depth || 0;
	  var lockedStartCells = null;
	  var lockedEndCells = null;
	  var unlockedCells = null;
	  var hasRowDetails = computedRowExpandEnabled && (expanded || shouldRenderCollapsedRowDetails);
	  var lockedStartEndArgs = {
	    lockedStartCount: lockedStartCount,
	    isHeader: isHeader,
	    virtualListBorderLeft: virtualListBorderLeft,
	    lockedStartColumns: lockedStartColumns,
	    style: style,
	    virtualizeColumns: virtualizeColumns,
	    rtl: rtl,
	    getScrollLeftMax: getScrollLeftMax,
	    addTransitionDuration: addTransitionDuration,
	    lockedStartContent: lockedStartContent,
	    initialCells: initialCells,
	    sticky: sticky,
	    scrollLeft: scrollLeft,
	    rowHeight: rowHeight,
	    groupProps: groupProps,
	    expandGroupTitle: expandGroupTitle,
	    lockedEndColumns: lockedEndColumns,
	    nativeScroll: nativeScroll,
	    scrollbarWidth: scrollbarWidth,
	    virtualListBorderRight: virtualListBorderRight,
	    lockedEndContent: lockedEndContent,
	    hasRowDetails: hasRowDetails,
	    initialRowHeight: initialRowHeight,
	    lockedEndStartIndex: lockedEndStartIndex,
	    availableWidth: availableWidth
	  };
	  if (lockedStartCount && renderLockedStartCells) {
	    lockedStartCells = renderLockedStartCells(lockedStartEndArgs);
	  }
	  if (lockedEndCount && renderLockedEndCells) {
	    lockedEndCells = renderLockedEndCells(lockedStartEndArgs);
	  }
	  unlockedCells = unlockedContent || initialCells.slice(lockedStartCount, lockedEndStartIndex);
	  if (lockedStartCount || lockedEndCount) {
	    return [lockedStartCells, unlockedCells, lockedEndCells];
	  }
	  return initialCells;
	};
	exports.default = _default;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _region = _interopRequireDefault(__webpack_require__(43));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _humanize = _interopRequireDefault(__webpack_require__(271));
	var _ColumnResizer = _interopRequireDefault(__webpack_require__(209));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var emptyObject = Object.freeze ? Object.freeze({}) : {};
	var BASE_CLASS_NAME = 'InovuaReactDataGrid__header-group__title';
	var TOP_Z_INDEX = 10000;
	var defaultProps = {
	  isHeaderGroup: true
	};
	var propTypes = {
	  columnResizeHandleWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  group: _propTypes.default.shape({
	    name: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
	    className: _propTypes.default.string,
	    style: _propTypes.default.object,
	    headerClassName: _propTypes.default.string,
	    headerStyle: _propTypes.default.object
	  }),
	  depth: _propTypes.default.number.isRequired,
	  columns: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])).isRequired,
	  children: _propTypes.default.node,
	  extraChildrenProps: _propTypes.default.object,
	  containsLastColumn: _propTypes.default.bool,
	  lastInSection: _propTypes.default.bool,
	  filterable: _propTypes.default.bool,
	  onResizeMouseDown: _propTypes.default.func,
	  onResizeTouchStart: _propTypes.default.func,
	  parentGroups: _propTypes.default.array,
	  showBorderLeft: _propTypes.default.bool,
	  showBorderRight: _propTypes.default.bool,
	  siblingCount: _propTypes.default.number,
	  siblingIndex: _propTypes.default.number
	};
	var getHeader = function getHeader() {
	  var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyObject;
	  var header = group.header,
	    name = group.name;
	  if (header) {
	    if (typeof header !== 'function') {
	      return header;
	    }
	    return header(group);
	  }
	  return (0, _humanize.default)(name || '');
	};
	var HeaderGroup = function (_React$Component) {
	  (0, _inherits2.default)(HeaderGroup, _React$Component);
	  var _super = _createSuper(HeaderGroup);
	  function HeaderGroup(_props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, HeaderGroup);
	    _this = _super.call(this, _props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "domRef", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDOMNode", function () {
	      return _this.domRef && _this.domRef.current;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setTop", function (top) {
	      _this.setState({
	        top: top
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setLeft", function (left) {
	      _this.setState({
	        left: left
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRight", function (right) {
	      _this.setState({
	        right: right
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setHeight", function (height) {
	      _this.setState({
	        height: height
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setWidth", function (width) {
	      _this.setState({
	        width: width
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setDragging", function (dragging, callback) {
	      var newState = {
	        dragging: dragging
	      };
	      if (!dragging) {
	        newState.top = 0;
	        newState.left = 0;
	        newState.width = 0;
	        newState.height = 0;
	      }
	      _this.setState(newState, callback);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "prepareStyle", function () {
	      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
	        state = _assertThisInitialize.state,
	        props = _assertThisInitialize.props;
	      var style = props.style || {};
	      var group = props.group;
	      var headerProps = group.headerProps;
	      if (props.group.style) {
	        style = _objectSpread(_objectSpread({}, style), props.group.style);
	      }
	      if (headerProps && headerProps.style) {
	        style = _objectSpread(_objectSpread({}, style), headerProps.style);
	      }
	      if (state.dragging) {
	        style = Object.assign({}, style, {
	          zIndex: TOP_Z_INDEX
	        });
	        if (_this.props.rtl) {
	          style.right = state.right || 0;
	        } else {
	          style.left = state.left || 0;
	        }
	        style.top = state.top || 0;
	        style.height = state.height || '';
	        style.width = state.width || '';
	        style.position = 'absolute';
	        style.overflow = 'hidden';
	      }
	      return style;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getProxyRegion", function () {
	      var node = _this.domRef ? _this.domRef.current : null;
	      var region = _region.default.from(node);
	      if (_this.props.filterable) {
	        var filterWrapper = node.querySelector('.InovuaReactDataGrid__column-header__filter-wrapper');
	        if (filterWrapper) {
	          region.setHeight(region.getHeight() - filterWrapper.offsetHeight);
	        }
	      }
	      return region;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderChild", function (child, index) {
	      var extraProps = {
	        parent: (0, _assertThisInitialized2.default)(_this),
	        indexInHeaderGroup: index
	      };
	      var dragging = _this.props.dragging || _this.state.dragging;
	      if (_this.props.extraChildrenProps) {
	        Object.assign(extraProps, _this.props.extraChildrenProps);
	      }
	      if (dragging) {
	        extraProps.dragging = dragging;
	      }
	      extraProps.key = index;
	      return (0, _react.cloneElement)(child, extraProps);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeMouseDown", function (event) {
	      if (_this.props.onResizeMouseDown) {
	        event.stopPropagation();
	        _this.props.onResizeMouseDown(_this.props, (0, _assertThisInitialized2.default)(_this), event);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeTouchStart", function (event) {
	      if (_this.props.onResizeTouchStart) {
	        event.stopPropagation();
	        _this.props.onResizeTouchStart(_this.props, (0, _assertThisInitialized2.default)(_this), event);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMouseDown", function (event) {
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event, _this.props, (0, _assertThisInitialized2.default)(_this));
	      }
	    });
	    _this.state = {
	      dragging: false
	    };
	    _this.domRef = _react.default.createRef();
	    return _this;
	  }
	  (0, _createClass2.default)(HeaderGroup, [{
	    key: "render",
	    value: function render() {
	      var _style;
	      var props = this.props;
	      var showBorderLeft = props.showBorderLeft,
	        showBorderRight = props.showBorderRight,
	        resizable = props.resizable,
	        children = props.children,
	        group = props.group,
	        dragging = props.dragging,
	        depth = props.depth,
	        columnResizeHandleWidth = props.columnResizeHandleWidth,
	        containsLastColumn = props.containsLastColumn,
	        firstInSection = props.firstInSection,
	        lastInSection = props.lastInSection,
	        adjustResizer = props.adjustResizer,
	        locked = props.locked,
	        rtl = props.rtl,
	        resizeProxyStyle = props.resizeProxyStyle;
	      var style = this.prepareStyle();
	      var resizerRight = containsLastColumn || adjustResizer || lastInSection ? 0 : -props.columnResizeHandleWidth / 2;
	      var header = getHeader(group);
	      var _ref = group || emptyObject,
	        headerAlign = _ref.headerAlign;
	      var className = (0, _join.default)(BASE_CLASS_NAME, firstInSection && 'InovuaReactDataGrid__header-group__title--first-in-section', "InovuaReactDataGrid__header-group__title--depth-".concat(depth), group.headerClassName, "InovuaReactDataGrid__header-group__title--direction-".concat(rtl ? 'rtl' : 'ltr'), showBorderLeft && "InovuaReactDataGrid__header-group__title--show-border-".concat(rtl ? 'right' : 'left'), showBorderRight && "InovuaReactDataGrid__header-group__title--show-border-".concat(rtl ? 'left' : 'right'), locked && "InovuaReactDataGrid__header-group__title--locked-".concat(locked), dragging && "InovuaReactDataGrid__header-group__title--dragging", containsLastColumn && 'InovuaReactDataGrid__header-group__title--last', !header ? 'InovuaReactDataGrid__header-group__title--empty' : null, "".concat(BASE_CLASS_NAME, "--align-").concat(headerAlign || 'start'));
	      var groupHeader = !header && !depth ? null : _react.default.createElement("div", {
	        style: group.headerStyle,
	        className: className
	      }, header || "\xA0");
	      var resizeHandleStyle;
	      if (resizable) {
	        resizeHandleStyle = {
	          width: columnResizeHandleWidth
	        };
	        if (resizeProxyStyle) {
	          resizeHandleStyle = Object.assign({}, resizeProxyStyle, resizeHandleStyle);
	        }
	      }
	      var resizer = resizable ? _react.default.createElement(_ColumnResizer.default, {
	        className: "InovuaReactDataGrid__header-group-resizer",
	        onMouseDown: this.onResizeMouseDown,
	        onTouchStart: this.onResizeTouchStart,
	        style: (_style = {
	          width: columnResizeHandleWidth
	        }, (0, _defineProperty2.default)(_style, rtl ? 'left' : 'right', resizerRight), (0, _defineProperty2.default)(_style, rtl ? 'right' : 'left', 'unset'), (0, _defineProperty2.default)(_style, "zIndex", depth * 10000 + (100 - this.props.firstIndex || 0)), _style),
	        resizeHandleStyle: resizeHandleStyle,
	        resizeHandleClassName: "InovuaReactDataGrid__header-group-resize-handle"
	      }) : null;
	      var headerProps = group.headerProps;
	      return _react.default.createElement("div", {
	        onMouseDown: this.onMouseDown,
	        style: style,
	        ref: this.domRef,
	        className: (0, _join.default)(props.className, 'InovuaReactDataGrid__header-group', group.className, props.inTransition && 'InovuaReactDataGrid__header-group--transition', this.state.dragging && 'InovuaReactDataGrid__header-group--dragging', headerProps && headerProps.className ? headerProps.className : '')
	      }, resizer, groupHeader, _react.default.createElement("div", {
	        className: "InovuaReactDataGrid__header-group-cells"
	      }, children.map(this.renderChild)));
	    }
	  }]);
	  return HeaderGroup;
	}(_react.default.Component);
	exports.default = HeaderGroup;
	(0, _defineProperty2.default)(HeaderGroup, "defaultProps", defaultProps);
	(0, _defineProperty2.default)(HeaderGroup, "propTypes", propTypes);

/***/ },
/* 212 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function debounce(func, wait) {
	  var _this = this;
	  var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var timeout;
	  var args;
	  var context;
	  var timestamp;
	  var result;
	  var later = function later() {
	    var last = Date.now() - timestamp;
	    if (last < wait && last >= 0) {
	      timeout = setTimeout(later, wait - last);
	    } else {
	      timeout = null;
	      if (!immediate) {
	        result = func.apply(context, args);
	        if (!timeout) {
	          context = null;
	          args = null;
	        }
	      }
	    }
	  };
	  return function () {
	    var callNow = immediate && !timeout;
	    context = _this;
	    for (var _len = arguments.length, internalArgs = new Array(_len), _key = 0; _key < _len; _key++) {
	      internalArgs[_key] = arguments[_key];
	    }
	    args = internalArgs;
	    timestamp = Date.now();
	    if (!timeout) {
	      timeout = setTimeout(later, wait);
	    }
	    if (callNow) {
	      result = func.apply(context, args);
	      context = args = null;
	    }
	    return result;
	  };
	}
	var _default = debounce;
	exports.default = _default;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _regionAlign = _interopRequireDefault(__webpack_require__(55));
	var _selectParent = _interopRequireDefault(__webpack_require__(101));
	var _getViewportRegion = _interopRequireDefault(__webpack_require__(215));
	var _default = function _default(constrainTo, domNode) {
	  var constrainRegion;
	  if (constrainTo === true) {
	    constrainRegion = (0, _getViewportRegion.default)();
	  }
	  if (!constrainRegion && typeof constrainTo === 'function') {
	    constrainTo = constrainTo(domNode);
	  }
	  if (!constrainRegion && typeof constrainTo === 'string') {
	    constrainTo = (0, _selectParent.default)(constrainTo, domNode);
	  }
	  if (!constrainRegion && constrainTo) {
	    constrainRegion = _regionAlign.default.from(constrainTo);
	  }
	  return constrainRegion;
	};
	exports.default = _default;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	Object.defineProperty(exports, "positionsMap", {
	  enumerable: true,
	  get: function get() {
	    return _positionsMap.default;
	  }
	});
	var _positionsMap = _interopRequireDefault(__webpack_require__(100));
	var _getPosition = _interopRequireDefault(__webpack_require__(585));
	var _default = _getPosition.default;
	exports.default = _default;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _region = _interopRequireDefault(__webpack_require__(43));
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var CACHED;
	var LISTENING_WINDOW_RESIZE;
	var setupWindowResize = function setupWindowResize() {
	  LISTENING_WINDOW_RESIZE = true;
	  globalObject.addEventListener('resize', function () {
	    CACHED = null;
	  });
	};
	function getViewportRegion() {
	  if (CACHED) {
	    return CACHED;
	  }
	  if (!LISTENING_WINDOW_RESIZE) {
	    setupWindowResize();
	  }
	  var viewportWidth = Math.max(globalObject.document.documentElement.clientWidth, globalObject.innerWidth || 0);
	  var viewportHeight = Math.max(globalObject.document.documentElement.clientHeight, globalObject.innerHeight || 0);
	  return CACHED = _region.default.from({
	    top: 0,
	    left: 0,
	    width: viewportWidth,
	    height: viewportHeight
	  });
	}
	var _default = getViewportRegion;
	exports.default = _default;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var _default = globalObject.requestAnimationFrame;
	exports.default = _default;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _shallowequal.default;
	  }
	});
	var _shallowequal = _interopRequireDefault(__webpack_require__(73));

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _shouldComponentUpdate.default;
	  }
	});
	var _shouldComponentUpdate = _interopRequireDefault(__webpack_require__(56));

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateFilters = exports.hasTypeOperators = exports.hasTypeOperator = exports.default = exports.checkForEmptyValue = exports.buildTypeOperators = exports.buildFilterParam = void 0;
	var _filterTypes = _interopRequireDefault(__webpack_require__(145));
	var buildTypeOperators = function buildTypeOperators(filterTypes) {
	  return Object.keys(filterTypes).reduce(function (acc, filterTypeName) {
	    var filterType = filterTypes[filterTypeName];
	    if (!filterType || !filterType.operators) {
	      return acc;
	    }
	    var operators = filterType.operators.reduce(function (operatorAccumulator, operator) {
	      operatorAccumulator[operator.name] = operator;
	      return operatorAccumulator;
	    }, {});
	    acc[filterTypeName] = operators;
	    return acc;
	  }, {});
	};
	exports.buildTypeOperators = buildTypeOperators;
	var buildFilterParam = function buildFilterParam(item, fv) {
	  var filterTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _filterTypes.default;
	  var columnsMap = arguments.length > 3 ? arguments[3] : undefined;
	  var filterParam = {};
	  var name = fv.name,
	    getFilterValue = fv.getFilterValue,
	    filterValue = fv.value,
	    type = fv.type;
	  filterParam.emptyValue = fv.hasOwnProperty('emptyValue') ? fv.emptyValue : filterTypes[type].emptyValue;
	  filterParam.filterValue = filterValue;
	  if (columnsMap) {
	    filterParam.column = columnsMap[name];
	  }
	  filterParam.data = item;
	  filterParam.value = typeof getFilterValue === 'function' ? getFilterValue({
	    data: item,
	    value: item[name]
	  }) : item[name];
	  return filterParam;
	};
	exports.buildFilterParam = buildFilterParam;
	var hasTypeOperators = function hasTypeOperators(fn, currentTypeOperators, type) {
	  if (!fn && !currentTypeOperators) {
	    console.error("No filter of type \"".concat(type, "\" found!"));
	    return true;
	  }
	  return false;
	};
	exports.hasTypeOperators = hasTypeOperators;
	var hasTypeOperator = function hasTypeOperator(fn, currentTypeOperators, type, operator) {
	  if (!fn && !currentTypeOperators[operator]) {
	    console.error("No operator \"".concat(operator, "\" found for filter type \"").concat(type, "\"!"));
	    return true;
	  }
	  return false;
	};
	exports.hasTypeOperator = hasTypeOperator;
	var checkForEmptyValue = function checkForEmptyValue(filterValue, emptyValue, filterOnEmptyValue) {
	  if (filterValue === emptyValue && !filterOnEmptyValue) {
	    return true;
	  }
	  return false;
	};
	exports.checkForEmptyValue = checkForEmptyValue;
	var validateFilters = function validateFilters(fv) {
	  var _currentTypeOperators;
	  var filterTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _filterTypes.default;
	  var currentTypeOperators = arguments.length > 2 ? arguments[2] : undefined;
	  var active = fv.active,
	    fn = fv.fn,
	    type = fv.type,
	    operator = fv.operator;
	  var emptyValue = fv.hasOwnProperty('emptyValue') ? fv.emptyValue : filterTypes[type].emptyValue;
	  var filterOnEmptyValue = currentTypeOperators ? (_currentTypeOperators = currentTypeOperators[operator]) === null || _currentTypeOperators === void 0 ? void 0 : _currentTypeOperators.filterOnEmptyValue : undefined;
	  if (active === false) {
	    return true;
	  }
	  if (!filterTypes[type]) {
	    return true;
	  }
	  if (hasTypeOperators(fn, currentTypeOperators, type)) {
	    return true;
	  }
	  if (hasTypeOperator(fn, currentTypeOperators, type, operator)) {
	    return true;
	  }
	  if (checkForEmptyValue(fv.value, emptyValue, filterOnEmptyValue)) {
	    return true;
	  }
	  return false;
	};
	exports.validateFilters = validateFilters;
	var doFilter = function doFilter(item, filterValueArray) {
	  var filterTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _filterTypes.default;
	  var columnsMap = arguments.length > 3 ? arguments[3] : undefined;
	  var typeOperators = buildTypeOperators(filterTypes);
	  for (var i = 0, len = filterValueArray.length; i < len; i++) {
	    var fv = filterValueArray[i];
	    var type = fv.type,
	      operator = fv.operator,
	      fn = fv.fn;
	    var currentTypeOperators = typeOperators[type];
	    if (validateFilters(fv, filterTypes, currentTypeOperators)) {
	      continue;
	    }
	    var filterParam = buildFilterParam(item, fv, filterTypes, columnsMap);
	    var filterFn = fn || currentTypeOperators[operator].fn;
	    if (filterFn(filterParam) !== true) {
	      return false;
	    }
	  }
	  return true;
	};
	var filter = function filter(data, filterValueArray, filterTypes, columnsMap) {
	  filterTypes = filterTypes || _filterTypes.default;
	  var filterFn = function filterFn(item) {
	    var result = doFilter(item, filterValueArray, filterTypes, columnsMap);
	    return result;
	  };
	  if (data === undefined) {
	    return filterFn;
	  }
	  return data.filter(filterFn);
	};
	var _default = filter;
	exports.default = _default;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var getFilterValueForColumns = function getFilterValueForColumns(filterValue, columnsMap) {
	  return (filterValue || []).map(function (filterValueObject) {
	    if (filterValueObject) {
	      var column = columnsMap[filterValueObject.name];
	      if (column) {
	        if (column.type && !filterValueObject.type) {
	          filterValueObject = _objectSpread(_objectSpread({}, filterValueObject), {}, {
	            type: column.filterType || column.type
	          });
	        }
	        if (typeof column.getFilterValue == 'function') {
	          filterValueObject = _objectSpread(_objectSpread({}, filterValueObject), {}, {
	            getFilterValue: column.getFilterValue
	          });
	        }
	        if (typeof column.filterName === 'string') {
	          filterValueObject = _objectSpread(_objectSpread({}, filterValueObject), {}, {
	            name: column.filterName
	          });
	        }
	      }
	    }
	    return filterValueObject;
	  });
	};
	var _default = getFilterValueForColumns;
	exports.default = _default;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.notifySelection = exports.handleSingleSelection = exports.handleSelection = exports.handleMultiSelectionRowToggle = exports.handleMultiSelection = exports.findInitialSelectionIndex = void 0;
	var _isControlledProperty = _interopRequireDefault(__webpack_require__(115));
	var _batchUpdate = _interopRequireDefault(__webpack_require__(50));
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var ua = globalObject.navigator ? globalObject.navigator.userAgent : '';
	var isSafari = ua.indexOf('Safari') !== -1 && ua.indexOf('Chrome') === -1;
	var delay35 = function delay35(fn) {
	  return function () {
	    return setTimeout(fn, 35);
	  };
	};
	var now = function now(fn) {
	  return function () {
	    return fn();
	  };
	};
	var findInitialSelectionIndex = function findInitialSelectionIndex(computedProps) {
	  var selected = computedProps.getSelectedMap();
	  var index = null;
	  if (!selected || !Object.keys(selected).length) {
	    return index;
	  }
	  var i = 0;
	  var data = computedProps.data;
	  var len = data.length;
	  var id;
	  for (; i < len; i++) {
	    id = computedProps.getItemId(data[i]);
	    if (selected[id]) {
	      index = i;
	    }
	  }
	  return index;
	};
	exports.findInitialSelectionIndex = findInitialSelectionIndex;
	var notifySelection = function notifySelection(computedProps, selected, data, unselected, queue) {
	  var queueDefined = !!queue;
	  queue = queue || (0, _batchUpdate.default)();
	  var onSelectionChange = (isSafari ? delay35 : now)(function () {
	    if (typeof computedProps.onSelectionChange == 'function') {
	      computedProps.onSelectionChange({
	        selected: selected,
	        data: data,
	        unselected: unselected,
	        originalData: (computedProps === null || computedProps === void 0 ? void 0 : computedProps.originalData) || null
	      });
	    }
	  });
	  if (!(0, _isControlledProperty.default)(computedProps.initialProps, 'unselected')) {
	    queue(function () {
	      computedProps.setUnselected(unselected);
	    });
	  }
	  if (!(0, _isControlledProperty.default)(computedProps.initialProps, 'selected')) {
	    queue(function () {
	      computedProps.setSelected(selected, {
	        silent: true
	      });
	    });
	  }
	  onSelectionChange();
	  if (!queueDefined) {
	    queue.commit();
	  }
	};
	exports.notifySelection = notifySelection;
	var handleSingleSelection = function handleSingleSelection(rowProps, computedProps, event, queue) {
	  var data = rowProps.data;
	  var rowSelected = computedProps.isRowSelected(data);
	  var newSelected = !rowSelected;
	  var ctrlKey = event.metaKey || event.ctrlKey;
	  if (!computedProps.toggleRowSelectOnClick && rowSelected && event && !ctrlKey) {
	    newSelected = true;
	  }
	  var selectedId = newSelected ? computedProps.getItemId(data) : null;
	  notifySelection(computedProps, selectedId, data, null, queue);
	};
	exports.handleSingleSelection = handleSingleSelection;
	var handleMultiSelection = function handleMultiSelection(computedProps, data, config, queue) {
	  var selIndex = config.selIndex;
	  var prevShiftKeyIndex = config.prevShiftKeyIndex;
	  var map = selIndex == null ? {} : Object.assign({}, computedProps.computedSelected);
	  if (prevShiftKeyIndex != null && selIndex != null) {
	    var min = Math.min(prevShiftKeyIndex, selIndex);
	    var max = Math.max(prevShiftKeyIndex, selIndex);
	    var removeArray = computedProps.data.slice(min, max + 1) || [];
	    removeArray.forEach(function (item) {
	      if (item) {
	        var id = computedProps.getItemId(item);
	        delete map[id];
	      }
	    });
	  }
	  data.forEach(function (item) {
	    if (item) {
	      var id = computedProps.getItemId(item);
	      map[id] = item;
	    }
	  });
	  notifySelection(computedProps, map, data, null, queue);
	};
	exports.handleMultiSelection = handleMultiSelection;
	var handleMultiSelectionRowToggle = function handleMultiSelectionRowToggle(computedProps, data, queue) {
	  var selected = computedProps.computedSelected;
	  var isSelected = computedProps.isRowSelected(data);
	  if (selected !== true) {
	    var clone = Object.assign({}, selected);
	    var id = computedProps.getItemId(data);
	    if (isSelected) {
	      delete clone[id];
	    } else {
	      clone[id] = data;
	    }
	    notifySelection(computedProps, clone, data, null, queue);
	  } else {
	    var _id = computedProps.getItemId(data);
	    var unselected = Object.assign({}, computedProps.computedUnselected);
	    if (isSelected) {
	      unselected[_id] = data;
	    } else {
	      delete unselected[_id];
	    }
	    notifySelection(computedProps, true, data, unselected, queue);
	  }
	  return isSelected;
	};
	exports.handleMultiSelectionRowToggle = handleMultiSelectionRowToggle;
	var handleSelection = function handleSelection(rowProps, computedProps, event, queue) {
	  var queueDefined = !!queue;
	  if (!queue) {
	    queue = (0, _batchUpdate.default)();
	  }
	  if (!computedProps.computedRowSelectionEnabled) {
	    return;
	  }
	  if (!computedProps.computedRowMultiSelectionEnabled) {
	    handleSingleSelection(rowProps, computedProps, event, queue);
	    if (!queueDefined) {
	      queue.commit();
	    }
	    return;
	  }
	  var selIndex = computedProps.selectionIndexRef.current;
	  if (selIndex === null) {
	    selIndex = findInitialSelectionIndex(computedProps);
	  }
	  var index = rowProps.rowIndex;
	  var prevShiftKeyIndex = computedProps.shiftKeyIndexRef.current;
	  var start;
	  var end;
	  var data;
	  if (event.metaKey || event.ctrlKey || computedProps.toggleRowSelectOnClick && computedProps.getSelectedCount() === 1 && computedProps.isRowSelected(computedProps.data[index])) {
	    computedProps.selectionIndexRef.current = index;
	    computedProps.shiftKeyIndexRef.current = null;
	    var unselect = handleMultiSelectionRowToggle(computedProps, computedProps.data[index], queue);
	    if (!queueDefined) {
	      queue.commit();
	    }
	    if (unselect) {
	      computedProps.selectionIndexRef.current++;
	      computedProps.shiftKeyIndexRef.current = prevShiftKeyIndex;
	      return false;
	    }
	    return;
	  }
	  if (!event.shiftKey) {
	    computedProps.selectionIndexRef.current = index;
	    computedProps.shiftKeyIndexRef.current = null;
	    selIndex = null;
	  } else {
	    computedProps.shiftKeyIndexRef.current = index;
	  }
	  if (selIndex == null) {
	    data = [computedProps.data[index]];
	  } else {
	    start = Math.min(index, selIndex);
	    end = Math.max(index, selIndex) + 1;
	    data = computedProps.data.slice(start, end);
	  }
	  handleMultiSelection(computedProps, data, {
	    selIndex: selIndex,
	    prevShiftKeyIndex: prevShiftKeyIndex
	  }, queue);
	  if (!queueDefined) {
	    queue.commit();
	  }
	};
	exports.handleSelection = handleSelection;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _isControlledProperty = _interopRequireDefault(__webpack_require__(115));
	var isSelectionControlled = function isSelectionControlled(props) {
	  return (0, _isControlledProperty.default)(props, 'selected');
	};
	var _default = isSelectionControlled;
	exports.default = _default;

/***/ },
/* 223 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var isSelectionEnabled = function isSelectionEnabled(props) {
	  var selected = props.selected,
	    defaultSelected = props.defaultSelected,
	    enableSelection = props.enableSelection,
	    cellSelection = props.cellSelection,
	    checkboxColumn = props.checkboxColumn;
	  if (enableSelection !== undefined) {
	    return !!enableSelection;
	  }
	  return selected !== undefined || defaultSelected !== undefined && cellSelection === undefined || !!checkboxColumn;
	};
	var _default = isSelectionEnabled;
	exports.default = _default;

/***/ },
/* 224 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var emptyObject = {};
	var _default = function _default(columns) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyObject,
	    showWarnings = _ref.showWarnings;
	  return columns.reduce(function (acc, col) {
	    if (col.id) {
	      if (showWarnings && acc[col.id]) {
	        console.error("Duplicate column with id \"".concat(col.id, "\" found!"));
	      }
	      acc[col.id] = col;
	    }
	    if (col.name && col.name != col.id) {
	      if (showWarnings && !col.id && acc[col.name]) {
	        console.error("Duplicate column with name \"".concat(col.name, "\" found!"));
	      }
	      if (!col.id) {
	        acc[col.name] = col;
	      }
	    }
	    if (typeof col.groupBy == 'string' || col.groupByName) {
	      var key = col.groupBy || col.groupByName;
	      acc[key] = col;
	    }
	    return acc;
	  }, {});
	};
	exports.default = _default;

/***/ },
/* 225 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.id = void 0;
	var id = '__row-expand-column';
	exports.id = id;

/***/ },
/* 226 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.id = void 0;
	var id = '__row-index-column';
	exports.id = id;

/***/ },
/* 227 */
[1296, 622],
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getWeekendStartDay = exports.getWeekStartMoment = exports.getWeekStartDay = exports.getDaysInMonthView = exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _Flex = __webpack_require__(41);
	var _moment = _interopRequireDefault(__webpack_require__(3));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _whitespace = _interopRequireDefault(__webpack_require__(589));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _format = _interopRequireDefault(__webpack_require__(640));
	var _toMoment = _interopRequireDefault(__webpack_require__(40));
	var _getWeekDayNames = _interopRequireDefault(__webpack_require__(641));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var RENDER_DAY = function RENDER_DAY(props) {
	  var divProps = (0, _assign.default)({}, props);
	  delete divProps.date;
	  delete divProps.dateMoment;
	  delete divProps.day;
	  delete divProps.timestamp;
	  return _react.default.createElement("div", _objectSpread({}, divProps));
	};
	var getWeekStartDay = function getWeekStartDay(props) {
	  var locale = props.locale;
	  var weekStartDay = props.weekStartDay;
	  if (weekStartDay == null) {
	    var localeData = props.localeData || _moment.default.localeData(locale);
	    weekStartDay = localeData._week ? localeData._week.dow : null;
	  }
	  return weekStartDay;
	};
	exports.getWeekStartDay = getWeekStartDay;
	var getWeekendStartDay = function getWeekendStartDay(props) {
	  var weekendStartDay = props.weekendStartDay;
	  if (weekendStartDay == null) {
	    return getWeekStartDay(props) + 5 % 7;
	  }
	  return weekendStartDay;
	};
	exports.getWeekendStartDay = getWeekendStartDay;
	var getWeekStartMoment = function getWeekStartMoment(value, props) {
	  var locale = props.locale;
	  var dateFormat = props.dateFormat;
	  var weekStartDay = getWeekStartDay(props);
	  return (0, _toMoment.default)(value, {
	    locale: locale,
	    dateFormat: dateFormat
	  }).day(weekStartDay);
	};
	exports.getWeekStartMoment = getWeekStartMoment;
	var getDaysInMonthView = function getDaysInMonthView(value, props) {
	  var locale = props.locale,
	    dateFormat = props.dateFormat;
	  var toMomentParam = {
	    locale: locale,
	    dateFormat: dateFormat
	  };
	  var first = (0, _toMoment.default)(value, toMomentParam).startOf('month');
	  var beforeFirst = (0, _toMoment.default)(value, toMomentParam).startOf('month').add(-1, 'days');
	  var start = getWeekStartMoment(first, props);
	  var result = [];
	  var i = 0;
	  if (beforeFirst.isBefore(start) && (props.alwaysShowPrevWeek || !start.isSame(first))) {
	    start.add(-1, 'weeks');
	  }
	  for (; i < 42; i++) {
	    result.push((0, _toMoment.default)(start, toMomentParam));
	    start.add(1, 'days');
	  }
	  return result;
	};
	exports.getDaysInMonthView = getDaysInMonthView;
	var getWeekDayNames = function getWeekDayNames(props) {
	  var weekStartDay = props.weekStartDay,
	    weekDayNames = props.weekDayNames,
	    locale = props.locale;
	  var names = weekDayNames;
	  if (typeof names == 'function') {
	    names = names(weekStartDay, locale);
	  } else if (Array.isArray(names)) {
	    names = (0, _toConsumableArray2.default)(names);
	    var index = weekStartDay;
	    while (index > 0) {
	      names.push(names.shift());
	      index--;
	    }
	  }
	  return names;
	};
	var BasicMonthView = function (_Component) {
	  (0, _inherits2.default)(BasicMonthView, _Component);
	  var _super = _createSuper(BasicMonthView);
	  function BasicMonthView(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, BasicMonthView);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
	      if (prevProps.locale !== _this.props.locale || prevProps.dateFormat !== _this.props.dateFormat) {
	        _this.updateToMoment(_this.props);
	      }
	    });
	    _this.updateToMoment(props);
	    return _this;
	  }
	  (0, _createClass2.default)(BasicMonthView, [{
	    key: "updateToMoment",
	    value: function updateToMoment(props) {
	      this.toMoment = function (value, dateFormat) {
	        return (0, _toMoment.default)(value, {
	          locale: props.locale,
	          dateFormat: dateFormat || props.dateFormat
	        });
	      };
	    }
	  }, {
	    key: "prepareProps",
	    value: function prepareProps(thisProps) {
	      var props = (0, _assign.default)({}, thisProps);
	      props.viewMoment = props.viewMoment || this.toMoment(props.viewDate);
	      props.weekStartDay = getWeekStartDay(props);
	      props.className = this.prepareClassName(props);
	      return props;
	    }
	  }, {
	    key: "prepareClassName",
	    value: function prepareClassName(props) {
	      return (0, _join.default)(props.className, props.rootClassName);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.p = this.prepareProps(this.props);
	      var viewMoment = props.viewMoment;
	      var daysInView = props.daysInView || getDaysInMonthView(viewMoment, props);
	      var children = [this.renderWeekDayNames(), this.renderDays(props, daysInView)];
	      if (props.renderChildren) {
	        children = props.renderChildren(children, props);
	      }
	      var flexProps = (0, _assign.default)({}, props);
	      delete flexProps.alwaysShowPrevWeek;
	      delete flexProps.rootClassName;
	      delete flexProps.cleanup;
	      delete flexProps.dateFormat;
	      delete flexProps.daysInView;
	      delete flexProps.defaultDate;
	      delete flexProps.defaultValue;
	      delete flexProps.forceValidDate;
	      delete flexProps.locale;
	      delete flexProps.moment;
	      delete flexProps.onClockEnterKey;
	      delete flexProps.onClockEscapeKey;
	      delete flexProps.onClockInputBlur;
	      delete flexProps.onClockInputFocus;
	      delete flexProps.onClockInputMouseDown;
	      delete flexProps.onFooterCancelClick;
	      delete flexProps.onFooterClearClick;
	      delete flexProps.onFooterOkClick;
	      delete flexProps.onFooterTodayClick;
	      delete flexProps.onRenderDay;
	      delete flexProps.renderChildren;
	      delete flexProps.renderDay;
	      delete flexProps.timestamp;
	      delete flexProps.todayButton;
	      delete flexProps.todayButtonText;
	      delete flexProps.value;
	      delete flexProps.viewDate;
	      delete flexProps.viewMoment;
	      delete flexProps.weekDayNames;
	      delete flexProps.weekNumbers;
	      delete flexProps.weekNumberName;
	      delete flexProps.weekStartDay;
	      delete flexProps.index;
	      delete flexProps.cancelButton;
	      delete flexProps.expanded;
	      delete flexProps.clearIcon;
	      delete flexProps.showClock;
	      delete flexProps.enableMonthDecadeViewAnimation;
	      delete flexProps.showMonthDecadeViewAnimation;
	      delete flexProps.triggerChangeOnTimeChange;
	      delete flexProps.cancelButtonText;
	      delete flexProps.clearButtonText;
	      delete flexProps.clearButton;
	      delete flexProps.innerRef;
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	      return _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({
	        column: true,
	        ref: props.innerRef,
	        wrap: false,
	        inline: true,
	        alignItems: "stretch"
	      }, flexProps), {}, {
	        children: children
	      }));
	    }
	  }, {
	    key: "renderWeekNumber",
	    value: function renderWeekNumber(props, days) {
	      var firstDayOfWeek = days[0];
	      var week = firstDayOfWeek.weeks();
	      var weekNumberProps = {
	        key: "week_".concat(days),
	        className: "".concat(props.rootClassName, "-cell ").concat(props.rootClassName, "-week-number"),
	        week: week,
	        days: days,
	        date: firstDayOfWeek,
	        children: week
	      };
	      var renderWeekNumber = props.renderWeekNumber;
	      var result;
	      if (renderWeekNumber) {
	        result = renderWeekNumber(weekNumberProps);
	      }
	      if (result === undefined) {
	        var divProps = (0, _assign.default)({}, weekNumberProps);
	        delete divProps.date;
	        delete divProps.days;
	        delete divProps.week;
	        delete divProps.showClock;
	        delete divProps.rootClassName;
	        result = _react.default.createElement("div", _objectSpread({
	          key: weekNumberProps.key
	        }, divProps));
	      }
	      return result;
	    }
	  }, {
	    key: "renderDays",
	    value: function renderDays(props, days) {
	      var _this2 = this;
	      var nodes = days.map(function (date) {
	        return _this2.renderDay(props, date);
	      });
	      var len = days.length;
	      var buckets = [];
	      var bucketsLen = Math.ceil(len / 7);
	      var i = 0;
	      var weekStart;
	      var weekEnd;
	      for (; i < bucketsLen; i++) {
	        weekStart = i * 7;
	        weekEnd = (i + 1) * 7;
	        buckets.push([props.weekNumbers && this.renderWeekNumber(props, days.slice(weekStart, weekEnd))].concat(nodes.slice(weekStart, weekEnd)));
	      }
	      var rootClassName = props.rootClassName;
	      return buckets.map(function (bucket, index) {
	        return _react.default.createElement("div", {
	          key: "row_".concat(index),
	          className: "".concat(rootClassName, "-row"),
	          children: bucket
	        });
	      });
	    }
	  }, {
	    key: "renderDay",
	    value: function renderDay(props, dateMoment) {
	      var dayText = _format.default.day(dateMoment, props.dayFormat);
	      var className = (0, _join.default)("".concat(props.rootClassName, "-cell"), "".concat(props.rootClassName, "-day"));
	      var renderDayProps = {
	        day: dayText,
	        dateMoment: dateMoment,
	        timestamp: +dateMoment,
	        key: dayText,
	        className: className,
	        children: dayText
	      };
	      if (typeof props.onRenderDay === 'function') {
	        var newRenderDayProps = props.onRenderDay(renderDayProps);
	        if (newRenderDayProps !== undefined) {
	          renderDayProps = newRenderDayProps;
	        }
	      }
	      var renderFunction = props.renderDay || RENDER_DAY;
	      var result = renderFunction(renderDayProps);
	      if (result === undefined) {
	        result = RENDER_DAY(renderDayProps);
	      }
	      return result;
	    }
	  }, {
	    key: "renderWeekDayNames",
	    value: function renderWeekDayNames() {
	      var props = this.p;
	      var weekNumbers = props.weekNumbers,
	        weekNumberName = props.weekNumberName,
	        weekDayNames = props.weekDayNames,
	        renderWeekDayNames = props.renderWeekDayNames,
	        renderWeekDayName = props.renderWeekDayName,
	        weekStartDay = props.weekStartDay,
	        rootClassName = props.rootClassName;
	      if (weekDayNames === false) {
	        return null;
	      }
	      var names = weekNumbers ? [weekNumberName].concat(getWeekDayNames(props)) : getWeekDayNames(props);
	      var className = "".concat(rootClassName, "-row ").concat(rootClassName, "-week-day-names");
	      var renderProps = {
	        className: className,
	        names: names
	      };
	      if (renderWeekDayNames) {
	        return renderWeekDayNames(renderProps);
	      }
	      return _react.default.createElement("div", {
	        key: "week_day_names",
	        className: className
	      }, names.map(function (name, index) {
	        var props = {
	          weekStartDay: weekStartDay,
	          index: index,
	          name: name,
	          className: "".concat(rootClassName, "-cell ").concat(rootClassName, "-week-day-name"),
	          children: name
	        };
	        if (renderWeekDayName) {
	          return renderWeekDayName(props);
	        }
	        var divProps = (0, _assign.default)({}, props);
	        var keys = "week_".concat(index);
	        delete divProps.index;
	        delete divProps.weekStartDay;
	        delete divProps.name;
	        delete divProps.showClock;
	        delete divProps.rootClassName;
	        return _react.default.createElement("div", _objectSpread({
	          key: keys
	        }, divProps));
	      }));
	    }
	  }]);
	  return BasicMonthView;
	}(_reactClass.default);
	BasicMonthView.propTypes = {
	  rootClassName: _propTypes.default.string,
	  defaultClassName: _propTypes.default.string,
	  className: _propTypes.default.string,
	  dateFormat: _propTypes.default.string,
	  alwaysShowPrevWeek: _propTypes.default.bool,
	  viewDate: _propTypes.default.any,
	  viewMoment: _propTypes.default.any,
	  index: _propTypes.default.number,
	  showClock: _propTypes.default.bool,
	  onMouseLeave: _propTypes.default.any,
	  locale: _propTypes.default.string,
	  weekStartDay: _propTypes.default.number,
	  weekNumbers: _propTypes.default.bool,
	  weekNumberName: _propTypes.default.string,
	  weekDayNames: function weekDayNames(props, propName) {
	    var value = props[propName];
	    if (typeof value != 'function' && value !== false && !Array.isArray(value)) {
	      return new Error('"weekDayNames" should be a function, an array or the boolean "false"');
	    }
	    return undefined;
	  },
	  renderWeekDayNames: _propTypes.default.func,
	  renderWeekDayName: _propTypes.default.func,
	  renderWeekNumber: _propTypes.default.func,
	  renderDay: _propTypes.default.func,
	  onRenderDay: _propTypes.default.func
	};
	BasicMonthView.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__basic-month-view',
	  dateFormat: 'YYYY-MM-DD',
	  alwaysShowPrevWeek: false,
	  weekNumbers: true,
	  weekNumberName: "".concat(_whitespace.default).concat(_whitespace.default),
	  weekDayNames: _getWeekDayNames.default
	};
	var _default = (0, _react.forwardRef)(function (props, ref) {
	  return _react.default.createElement(BasicMonthView, _objectSpread({
	    innerRef: ref
	  }, props));
	});
	exports.default = _default;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "NAV_KEYS", {
	  enumerable: true,
	  get: function get() {
	    return _MonthView.NAV_KEYS;
	  }
	});
	exports.default = void 0;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _Flex = __webpack_require__(41);
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _assignDefined = _interopRequireDefault(__webpack_require__(62));
	var _MonthView = _interopRequireWildcard(__webpack_require__(108));
	var _toMoment = _interopRequireDefault(__webpack_require__(40));
	var _ClockInput = _interopRequireDefault(__webpack_require__(230));
	var _forwardTime = _interopRequireDefault(__webpack_require__(110));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var hasTime = function hasTime(dateFormat) {
	  dateFormat = dateFormat ? dateFormat.toLowerCase() : '';
	  return dateFormat.indexOf('k') != -1 || dateFormat.indexOf('h') != -1;
	};
	var Calendar = function (_Component) {
	  (0, _inherits2.default)(Calendar, _Component);
	  var _super = _createSuper(Calendar);
	  function Calendar(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, Calendar);
	    _this = _super.call(this, props);
	    _this.state = {
	      timeFocused: false
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(Calendar, [{
	    key: "getDOMNode",
	    value: function getDOMNode() {
	      return this.view ? this.view.getDOMNode() : null;
	    }
	  }, {
	    key: "prepareDate",
	    value: function prepareDate(props) {
	      return (0, _toMoment.default)(props.date, props);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	      var props = this.p = (0, _assign.default)({}, this.props);
	      var dateFormat = props.dateFormat.toLowerCase();
	      props.date = this.prepareDate(props);
	      if (props.showClock === undefined) {
	        props.showClock = dateFormat.indexOf('k') != -1 || dateFormat.indexOf('h') != -1;
	      }
	      var startTimeIndex = dateFormat.toLowerCase().indexOf('h');
	      if (startTimeIndex === -1) {
	        startTimeIndex = dateFormat.toLowerCase().indexOf('k');
	      }
	      var timeFormat = dateFormat.substring(startTimeIndex);
	      props.timeFormat = timeFormat;
	      var rootClassName = props.rootClassName;
	      var className = (0, _join.default)(props.className, rootClassName, props.theme && "".concat(rootClassName, "--theme-").concat(props.theme));
	      var monthViewProps = (0, _assign.default)({}, this.props);
	      var keys = monthViewProps.date / 7;
	      delete monthViewProps.onTimeChange;
	      delete monthViewProps.updateOnWheel;
	      delete monthViewProps.wrapTime;
	      delete monthViewProps.rootClassName;
	      delete monthViewProps.showClock;
	      if (typeof this.props.cleanup == 'function') {
	        this.props.cleanup(monthViewProps);
	      }
	      var monthView = _react.default.createElement(_MonthView.default, _objectSpread(_objectSpread({}, monthViewProps), {}, {
	        onChange: this.onChange,
	        className: null,
	        style: null,
	        ref: function ref(view) {
	          _this2.view = view;
	        },
	        renderChildren: this.renderChildren,
	        showClock: props.showClock
	      }));
	      return _react.default.createElement(_Flex.Flex, {
	        inline: true,
	        row: true,
	        wrap: false,
	        className: className,
	        style: props.style
	      }, monthView);
	    }
	  }, {
	    key: "isMonthDecadeViewVisible",
	    value: function isMonthDecadeViewVisible() {
	      if (this.view && this.view.isMonthDecadeViewVisible) {
	        return this.view.isMonthDecadeViewVisible();
	      }
	      return false;
	    }
	  }, {
	    key: "renderChildren",
	    value: function renderChildren(_ref) {
	      var _ref2 = (0, _slicedToArray2.default)(_ref, 3),
	        navBar = _ref2[0],
	        inner = _ref2[1],
	        footer = _ref2[2];
	      var props = this.p;
	      var clockInput = props.showClock ? this.renderClockInput() : null;
	      return _react.default.createElement(_Flex.Flex, {
	        key: "date_picker_comp",
	        column: true,
	        wrap: false,
	        alignItems: "stretch"
	      }, [navBar ? _react.default.cloneElement(navBar, {
	        key: 'calendar_navBar'
	      }) : null, _react.default.createElement(_Flex.Flex, {
	        key: "calendar_inner",
	        justifyContent: "center",
	        wrap: this.props.wrap || this.props.wrapTime
	      }, _react.default.createElement(_Flex.Flex, {
	        flexGrow: "1",
	        flexShrink: "0",
	        flexBasis: "auto",
	        column: true,
	        wrap: false,
	        alignItems: "stretch",
	        children: inner
	      }), clockInput), footer ? _react.default.cloneElement(footer, {
	        key: 'calendar_footer'
	      }) : null]);
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      if (this.view) {
	        this.view.focus();
	      }
	    }
	  }, {
	    key: "isFocused",
	    value: function isFocused() {
	      if (this.view) {
	        return this.view.isFocused();
	      }
	      return false;
	    }
	  }, {
	    key: "onViewKeyDown",
	    value: function onViewKeyDown() {
	      if (this.view) {
	        var _this$view;
	        (_this$view = this.view).onViewKeyDown.apply(_this$view, arguments);
	      }
	    }
	  }, {
	    key: "isTimeInputFocused",
	    value: function isTimeInputFocused() {
	      return this.state.timeFocused;
	    }
	  }, {
	    key: "renderClockInput",
	    value: function renderClockInput() {
	      var _this3 = this,
	        _clockInputProps;
	      var clockInput = null;
	      var readOnly = this.props.readOnly;
	      var clockInputProps = (_clockInputProps = {
	        ref: function ref(clkInput) {
	          _this3.clockInput = clkInput;
	        },
	        theme: this.props.theme,
	        viewIndex: this.props.viewIndex,
	        dateFormat: this.p.dateFormat
	      }, (0, _defineProperty2.default)(_clockInputProps, readOnly ? 'value' : 'defaultValue', this.p.date), (0, _defineProperty2.default)(_clockInputProps, "onFocus", this.onClockInputFocus), (0, _defineProperty2.default)(_clockInputProps, "onBlur", this.onClockInputBlur), (0, _defineProperty2.default)(_clockInputProps, "onChange", this.onTimeChange), (0, _defineProperty2.default)(_clockInputProps, "onMouseDown", this.onClockInputMouseDown), _clockInputProps);
	      (0, _assignDefined.default)(clockInputProps, {
	        onEnterKey: this.props.onClockEnterKey,
	        onEscapeKey: this.props.onClockEscapeKey,
	        readOnly: readOnly,
	        tabIndex: readOnly ? null : this.props.clockTabIndex,
	        theme: this.props.theme,
	        updateOnWheel: this.props.updateOnWheel
	      });
	      if (clockInput) {
	        return _react.default.cloneElement(clockInput, clockInputProps);
	      }
	      return _react.default.createElement(_ClockInput.default, _objectSpread({}, clockInputProps));
	    }
	  }, {
	    key: "onClockInputFocus",
	    value: function onClockInputFocus() {
	      this.setState({
	        timeFocused: true
	      });
	      this.props.onClockInputFocus();
	    }
	  }, {
	    key: "onClockInputBlur",
	    value: function onClockInputBlur() {
	      this.setState({
	        timeFocused: false
	      });
	      this.props.onClockInputBlur();
	    }
	  }, {
	    key: "onClockInputMouseDown",
	    value: function onClockInputMouseDown(event) {
	      event.stopPropagation();
	      if (event.target && event.target.type != 'text') {
	        event.preventDefault();
	      }
	      this.clockInput.focus();
	    }
	  }, {
	    key: "onTimeChange",
	    value: function onTimeChange(value, timeFormat) {
	      this.time = value;
	      this.props.onTimeChange(value, timeFormat);
	      var view = this.view;
	      var moment = view.p.moment;
	      if (moment == null) {
	        return;
	      }
	      if (this.props.triggerChangeOnTimeChange) {
	        view.onChange({
	          dateMoment: moment,
	          timestamp: +moment,
	          noCollapse: this.props.triggerChangeOnTimeChange
	        });
	      }
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(dateString, _ref3, event) {
	      var dateMoment = _ref3.dateMoment,
	        timestamp = _ref3.timestamp,
	        noCollapse = _ref3.noCollapse;
	      var props = this.p;
	      if (props.showClock) {
	        var time = (0, _toMoment.default)(this.time || this.clockInput.getValue(), {
	          dateFormat: props.timeFormat,
	          locale: props.locale
	        });
	        (0, _forwardTime.default)(time, dateMoment);
	        timestamp = +dateMoment;
	        dateString = this.view.format(dateMoment);
	      } else if (hasTime(props.dateFormat)) {
	        (0, _forwardTime.default)(props.date, dateMoment);
	        timestamp = +dateMoment;
	        dateString = this.view.format(dateMoment);
	      }
	      if (this.props.onChange) {
	        this.props.onChange(dateString, {
	          dateMoment: dateMoment,
	          timestamp: timestamp,
	          dateString: dateString,
	          noCollapse: noCollapse
	        }, event);
	      }
	    }
	  }]);
	  return Calendar;
	}(_reactClass.default);
	exports.default = Calendar;
	Calendar.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__calendar',
	  dateFormat: 'YYYY-MM-DD',
	  theme: 'default-light',
	  isDatePicker: true,
	  triggerChangeOnTimeChange: true,
	  enableMonthDecadeViewAnimation: true,
	  showMonthDecadeViewAnimation: 300,
	  wrapTime: false,
	  onTimeChange: function onTimeChange() {},
	  onClockEnterKey: function onClockEnterKey() {},
	  onClockInputBlur: function onClockInputBlur() {},
	  onClockInputFocus: function onClockInputFocus() {},
	  onFooterTodayClick: function onFooterTodayClick() {},
	  onFooterCancelClick: function onFooterCancelClick() {},
	  onFooterClearClick: function onFooterClearClick() {},
	  onFooterOkClick: function onFooterOkClick() {}
	};
	Calendar.propTypes = {
	  rootClassName: _propTypes.default.string,
	  dateFormat: _propTypes.default.string,
	  theme: _propTypes.default.string,
	  clockTabIndex: _propTypes.default.number,
	  updateOnWheel: _propTypes.default.bool,
	  isDatePicker: _propTypes.default.bool,
	  wrap: _propTypes.default.bool,
	  wrapTime: _propTypes.default.bool,
	  viewIndex: _propTypes.default.number,
	  showClock: _propTypes.default.bool,
	  onTimeChange: _propTypes.default.func,
	  onClockEnterKey: _propTypes.default.func,
	  onClockInputBlur: _propTypes.default.func,
	  onClockInputFocus: _propTypes.default.func,
	  onFooterTodayClick: _propTypes.default.func,
	  onFooterCancelClick: _propTypes.default.func,
	  onFooterClearClick: _propTypes.default.func,
	  onClockInputMouseDown: _propTypes.default.func,
	  onClockEscapeKey: _propTypes.default.func,
	  onFooterOkClick: _propTypes.default.func,
	  onChange: _propTypes.default.func,
	  cleanup: _propTypes.default.func,
	  triggerChangeOnTimeChange: _propTypes.default.bool,
	  showMonthDecadeViewAnimation: _propTypes.default.number,
	  enableMonthDecadeViewAnimation: _propTypes.default.bool
	};

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _autoBind = _interopRequireDefault(__webpack_require__(52));
	var _Flex = __webpack_require__(41);
	var _throttle = _interopRequireDefault(__webpack_require__(102));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _toMoment = _interopRequireDefault(__webpack_require__(40));
	var _Clock = _interopRequireDefault(__webpack_require__(106));
	var _DateFormatSpinnerInput = _interopRequireDefault(__webpack_require__(231));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var ClockInput = function (_Component) {
	  (0, _inherits2.default)(ClockInput, _Component);
	  var _super = _createSuper(ClockInput);
	  function ClockInput(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, ClockInput);
	    _this = _super.call(this, props);
	    (0, _autoBind.default)((0, _assertThisInitialized2.default)(_this));
	    var delay = props.changeDelay;
	    _this.throttleSetValue = delay == -1 ? _this.setValue : (0, _throttle.default)(_this.setValue, delay);
	    _this.state = {
	      value: props.defaultValue || Date.now()
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(ClockInput, [{
	    key: "getValue",
	    value: function getValue() {
	      return this.value;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var format = props.dateFormat || props.format;
	      var startIndex = format.toLowerCase().indexOf('h');
	      if (startIndex === -1) {
	        startIndex = format.toLowerCase().indexOf('k');
	      }
	      var dateFormat = format.substring(startIndex);
	      this.dateFormat = dateFormat;
	      this.value = props.value !== undefined ? props.value : this.state.value;
	      var rootClassName = props.rootClassName;
	      var className = (0, _join.default)(props.className, rootClassName, props.theme && "".concat(rootClassName, "--theme-").concat(props.theme));
	      var flexProps = (0, _assign.default)({}, this.props);
	      delete flexProps.changeDelay;
	      delete flexProps.cleanup;
	      delete flexProps.dateFormat;
	      delete flexProps.isClockInput;
	      delete flexProps.onEnterKey;
	      delete flexProps.onEscapeKey;
	      delete flexProps.onTimeChange;
	      delete flexProps.updateOnWheel;
	      delete flexProps.theme;
	      delete flexProps.viewIndex;
	      delete flexProps.wrapTime;
	      delete flexProps.rootClassName;
	      if (typeof this.props.cleanup == 'function') {
	        this.props.cleanup(flexProps);
	      }
	      return _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({
	        column: true
	      }, flexProps), {}, {
	        value: null,
	        defaultValue: null,
	        className: className
	      }), this.renderClock(), this.renderTimeInput());
	    }
	  }, {
	    key: "renderTimeInput",
	    value: function renderTimeInput() {
	      var _this2 = this;
	      var props = this.props;
	      var dateInput = _react.default.Children.toArray(props.children).filter(function (child) {
	        return child && child.props && child.props.isDateInput;
	      })[0];
	      var dateInputProps = (0, _assign.default)({}, this.props, {
	        ref: function ref(field) {
	          _this2.field = field;
	        },
	        tabIndex: props.readOnly ? -1 : props.tabIndex || 0,
	        readOnly: props.readOnly,
	        value: this.value,
	        dateFormat: this.dateFormat,
	        onChange: this.onChange,
	        onKeyDown: this.onKeyDown,
	        size: props.size || this.dateFormat.length + 2,
	        theme: props.theme
	      });
	      if (dateInput) {
	        return _react.default.cloneElement(dateInput, dateInputProps);
	      }
	      return _react.default.createElement(_DateFormatSpinnerInput.default, _objectSpread(_objectSpread({}, dateInputProps), {}, {
	        style: null
	      }));
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      if (this.field) {
	        this.field.focus();
	      }
	    }
	  }, {
	    key: "onKeyDown",
	    value: function onKeyDown(event) {
	      if (this.props.onEnterKey && event.key == 'Enter') {
	        this.props.onEnterKey(event);
	      }
	      if (this.props.onEscapeKey && event.key == 'Escape') {
	        this.props.onEscapeKey(event);
	      }
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(value) {
	      if (this.props.value === undefined) {
	        this.setState({
	          value: value
	        });
	      }
	      if (this.props.onChange) {
	        this.throttleSetValue(value);
	      }
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value) {
	      if (this.props.value === undefined) {
	        this.setState({
	          value: value
	        });
	      }
	      if (this.props.onChange) {
	        this.props.onChange(value, this.dateFormat);
	      }
	    }
	  }, {
	    key: "renderClock",
	    value: function renderClock() {
	      var props = this.props;
	      var clock = _react.default.Children.toArray(props.children).filter(function (child) {
	        return child && child.props && child.props.isDatePickerClock;
	      })[0];
	      var dateFormat = this.dateFormat;
	      var time = (0, _toMoment.default)(this.value, {
	        dateFormat: dateFormat
	      });
	      var clockProps = {
	        time: time,
	        theme: props.theme,
	        showMinutesHand: dateFormat.indexOf('mm') != -1,
	        showSecondsHand: dateFormat.indexOf('ss') != -1
	      };
	      if (clock) {
	        return _react.default.cloneElement(clock, clockProps);
	      }
	      return _react.default.createElement(_Clock.default, _objectSpread({}, clockProps));
	    }
	  }]);
	  return ClockInput;
	}(_react.Component);
	exports.default = ClockInput;
	ClockInput.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__clock-input',
	  changeDelay: 50,
	  dateFormat: 'YYYY-MM-DD',
	  updateOnWheel: true,
	  theme: 'default',
	  wrapTime: false,
	  isClockInput: true,
	  onTimeChange: function onTimeChange() {}
	};
	ClockInput.propTypes = {
	  rootClassName: _propTypes.default.string,
	  value: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  viewIndex: _propTypes.default.number,
	  dateFormat: _propTypes.default.string,
	  format: _propTypes.default.string,
	  theme: _propTypes.default.string,
	  changeDelay: _propTypes.default.number,
	  updateOnWheel: _propTypes.default.bool,
	  wrapTime: _propTypes.default.bool,
	  isClockInput: _propTypes.default.bool,
	  cleanup: _propTypes.default.func,
	  onEnterKey: _propTypes.default.func,
	  onEscapeKey: _propTypes.default.func,
	  onTimeChange: _propTypes.default.func
	};

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _Flex = __webpack_require__(41);
	var _DateFormatInput = _interopRequireDefault(__webpack_require__(150));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _joinFunctions = _interopRequireDefault(__webpack_require__(82));
	var _assignDefined = _interopRequireDefault(__webpack_require__(62));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var DateFormatSpinnerInput = function (_Component) {
	  (0, _inherits2.default)(DateFormatSpinnerInput, _Component);
	  var _super = _createSuper(DateFormatSpinnerInput);
	  function DateFormatSpinnerInput(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, DateFormatSpinnerInput);
	    _this = _super.call(this, props);
	    _this.state = {
	      focused: false
	    };
	    _this.input = (0, _react.createRef)();
	    return _this;
	  }
	  (0, _createClass2.default)(DateFormatSpinnerInput, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.started = true;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.started = false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var rootClassName = props.rootClassName;
	      var children = _react.default.Children.toArray(props.children);
	      var input = this.inputChild = children.filter(function (c) {
	        return c && c.type == 'input';
	      })[0];
	      var inputProps = input ? (0, _assign.default)({}, input.props) : {};
	      var onKeyDown = (0, _joinFunctions.default)(props.onKeyDown, inputProps.onKeyDown);
	      var onChange = (0, _joinFunctions.default)(props.onChange, inputProps.onChange);
	      var disabled = props.disabled || inputProps.disabled;
	      (0, _assignDefined.default)(inputProps, {
	        size: props.size || inputProps.size,
	        minDate: props.minDate || inputProps.minDate,
	        maxDate: props.maxDate || inputProps.maxDate,
	        changeDelay: props.changeDelay === undefined ? inputProps.changeDelay : props.changeDelay,
	        tabIndex: props.tabIndex,
	        onKeyDown: onKeyDown,
	        onChange: onChange,
	        disabled: disabled,
	        dateFormat: props.dateFormat === undefined ? inputProps.dateFormat : props.dateFormat,
	        stopPropagation: props.stopPropagation,
	        updateOnWheel: props.updateOnWheel,
	        onBlur: this.onBlur,
	        onFocus: this.onFocus
	      });
	      this.inputProps = inputProps;
	      var arrowSize = this.props.arrowSize;
	      this.arrows = {
	        1: _react.default.createElement("svg", {
	          height: arrowSize / 2,
	          width: arrowSize,
	          viewBox: "0 0 10 5"
	        }, _react.default.createElement("path", {
	          fillRule: "evenodd",
	          d: "M5.262.262l4.106 4.106c.144.144.144.379 0 .524-.07.069-.164.108-.262.108H.894c-.204 0-.37-.166-.37-.37 0-.099.039-.193.108-.262L4.738.262c.145-.145.38-.145.524 0z"
	        })),
	        '-1': _react.default.createElement("svg", {
	          height: arrowSize / 2,
	          width: arrowSize,
	          viewBox: "0 0 10 5"
	        }, _react.default.createElement("path", {
	          fillRule: "evenodd",
	          d: "M4.738 4.738L.632.632C.488.488.488.253.632.108.702.04.796 0 .894 0h8.212c.204 0 .37.166.37.37 0 .099-.039.193-.108.262L5.262 4.738c-.145.145-.38.145-.524 0z"
	        }))
	      };
	      var className = (0, _join.default)(props.className, rootClassName, this.state.focused ? "".concat(rootClassName, "-spinner--focused") : "".concat(rootClassName, "-spinner"), disabled && "".concat(rootClassName, "--disabled"), this.isFocused() && "".concat(rootClassName, "--focused"), "".concat(rootClassName, "--theme-").concat(props.theme));
	      return _react.default.createElement(_Flex.Flex, {
	        inline: true,
	        row: true,
	        className: className,
	        disabled: props.disabled
	      }, _react.default.createElement(_DateFormatInput.default, _objectSpread({
	        ref: this.input,
	        theme: props.theme,
	        value: props.value
	      }, inputProps)), this.renderArrows());
	    }
	  }, {
	    key: "renderArrows",
	    value: function renderArrows() {
	      if (this.props.renderArrows) {
	        return this.props.renderArrows(this.props);
	      }
	      return _react.default.createElement("div", {
	        className: "".concat(this.props.rootClassName, "-spinner-arrow-wrapper")
	      }, this.renderArrow(1), this.renderArrow(-1));
	    }
	  }, {
	    key: "renderArrow",
	    value: function renderArrow(dir) {
	      var rootClassName = this.props.rootClassName;
	      var direction = dir === 1 ? 'up' : 'down';
	      var className = (0, _join.default)("".concat(rootClassName, "-spinner-arrow"), "".concat(rootClassName, "-spinner-arrow--").concat(direction));
	      return _react.default.createElement("div", {
	        className: className,
	        onMouseDown: this.onMouseDown.bind(this, dir),
	        onMouseUp: this.stop,
	        onMouseLeave: this.stop
	      }, this.arrows[dir]);
	    }
	  }, {
	    key: "onMouseDown",
	    value: function onMouseDown(dir, event) {
	      var _this2 = this;
	      if (this.props.disabled) {
	        event.preventDefault();
	        return;
	      }
	      event.preventDefault();
	      if (this.isFocused()) {
	        this.start(dir);
	      } else {
	        this.focus();
	        setTimeout(function () {
	          _this2.increment(dir);
	        }, 1);
	      }
	    }
	  }, {
	    key: "start",
	    value: function start(dir) {
	      var _this3 = this;
	      this.started = true;
	      this.startTime = Date.now();
	      this.step(dir);
	      this.timeoutId = setTimeout(function () {
	        _this3.step(dir);
	        _this3.timeoutId = setTimeout(function () {
	          var lazyStep = function lazyStep() {
	            var delay = _this3.props.stepDelay - (Date.now() - _this3.startTime) / 500;
	            _this3.step(dir, lazyStep, delay);
	          };
	          lazyStep();
	        }, _this3.props.secondStepDelay);
	      }, this.props.firstStepDelay);
	    }
	  }, {
	    key: "isStarted",
	    value: function isStarted() {
	      return !!(this.started && this.input);
	    }
	  }, {
	    key: "increment",
	    value: function increment(dir) {
	      if (this.input && this.input.current) {
	        this.input.current.onDirection(dir);
	      }
	    }
	  }, {
	    key: "step",
	    value: function step(dir, callback, delay) {
	      var _this4 = this;
	      if (this.isStarted()) {
	        this.increment(dir);
	        if (typeof callback == 'function') {
	          this.timeoutId = setTimeout(function () {
	            if (_this4.isStarted()) {
	              callback();
	            }
	          }, delay === undefined ? this.props.stepDelay : delay);
	        }
	      }
	    }
	  }, {
	    key: "stop",
	    value: function stop() {
	      this.started = false;
	      if (this.timeoutId) {
	        globalObject.clearTimeout(this.timeoutId);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      if (this.input && this.input.current) {
	        this.input.current.focus();
	      }
	    }
	  }, {
	    key: "isFocused",
	    value: function isFocused() {
	      return this.state.focused;
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur(event) {
	      var props = this.props;
	      var onBlur = (0, _joinFunctions.default)(props.onBlur, this.inputChild && this.inputChild.props && this.inputChild.props.onBlur);
	      if (onBlur) {
	        onBlur(event);
	      }
	      this.setState({
	        focused: false
	      });
	    }
	  }, {
	    key: "onFocus",
	    value: function onFocus(event) {
	      var props = this.props;
	      var onFocus = (0, _joinFunctions.default)(props.onFocus, this.inputChild && this.inputChild.props && this.inputChild.props.onFocus);
	      if (onFocus) {
	        onFocus(event);
	      }
	      this.setState({
	        focused: true
	      });
	    }
	  }]);
	  return DateFormatSpinnerInput;
	}(_reactClass.default);
	exports.default = DateFormatSpinnerInput;
	DateFormatSpinnerInput.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__date-format-spinner',
	  firstStepDelay: 150,
	  secondStepDelay: 100,
	  stepDelay: 50,
	  changeDelay: undefined,
	  theme: 'default',
	  disabled: false,
	  arrowSize: 10,
	  isDateInput: true,
	  stopPropagation: true,
	  updateOnWheel: true
	};
	DateFormatSpinnerInput.propTypes = {
	  rootClassName: _propTypes.default.string,
	  firstStepDelay: _propTypes.default.number,
	  secondStepDelay: _propTypes.default.number,
	  stepDelay: _propTypes.default.number,
	  changeDelay: _propTypes.default.number,
	  theme: _propTypes.default.string,
	  disabled: _propTypes.default.bool,
	  arrowSize: _propTypes.default.number,
	  isDateInput: _propTypes.default.bool,
	  stopPropagation: _propTypes.default.bool,
	  updateOnWheel: _propTypes.default.bool
	};

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _Flex = __webpack_require__(41);
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _toMoment2 = _interopRequireDefault(__webpack_require__(40));
	var _joinFunctions = _interopRequireDefault(__webpack_require__(82));
	var _Footer = _interopRequireDefault(__webpack_require__(152));
	var _YearView = _interopRequireDefault(__webpack_require__(236));
	var _assignDefined = _interopRequireDefault(__webpack_require__(62));
	var _DecadeView = _interopRequireWildcard(__webpack_require__(151));
	var _MonthDecadeView$prop;
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var preventDefault = function preventDefault(e) {
	  e.preventDefault();
	};
	var MonthDecadeView = function (_Component) {
	  (0, _inherits2.default)(MonthDecadeView, _Component);
	  var _super = _createSuper(MonthDecadeView);
	  function MonthDecadeView(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, MonthDecadeView);
	    _this = _super.call(this, props);
	    _this.state = (0, _DecadeView.getInitialState)(props);
	    return _this;
	  }
	  (0, _createClass2.default)(MonthDecadeView, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.unmounted = false;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unmounted = true;
	    }
	  }, {
	    key: "toMoment",
	    value: function toMoment(date, format) {
	      return (0, _toMoment2.default)(date, format, this.props);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	      var dateProps = (0, _DecadeView.prepareDateProps)(this.props, this.state);
	      var props = this.p = _objectSpread(_objectSpread({}, this.props), dateProps);
	      props.children = _react.default.Children.toArray(props.children);
	      var rootClassName = props.rootClassName;
	      var className = (0, _join.default)(props.className, rootClassName, props.theme && "".concat(rootClassName, "--theme-").concat(props.theme));
	      var separatorClassName = "".concat(rootClassName, "__separator");
	      var commonProps = (0, _assignDefined.default)({}, {
	        locale: props.locale,
	        theme: props.theme,
	        minDate: props.minDate,
	        maxDate: props.maxDate,
	        viewDate: props.viewMoment,
	        activeDate: props.activeDate,
	        date: props.date,
	        dateFormat: props.dateFormat
	      });
	      var yearViewProps = (0, _assign.default)({}, commonProps);
	      var decadeViewProps = (0, _assign.default)({}, commonProps, {
	        ref: function ref(view) {
	          _this2.decadeView = view;
	        }
	      });
	      var flexProps = (0, _assign.default)({}, this.props);
	      delete flexProps.rootClassName;
	      delete flexProps.activeDate;
	      delete flexProps.adjustDateStartOf;
	      delete flexProps.adjustMaxDateStartOf;
	      delete flexProps.adjustMinDateStartOf;
	      delete flexProps.cleanup;
	      delete flexProps.date;
	      delete flexProps.dateFormat;
	      delete flexProps.defaultDate;
	      delete flexProps.defaultViewDate;
	      delete flexProps.focusDecadeView;
	      delete flexProps.focusYearView;
	      delete flexProps.okButtonText;
	      delete flexProps.cancelButtonText;
	      delete flexProps.footer;
	      delete flexProps.locale;
	      delete flexProps.maxDate;
	      delete flexProps.minDate;
	      delete flexProps.onOkClick;
	      delete flexProps.onCancelClick;
	      delete flexProps.okOnEnter;
	      delete flexProps.navigation;
	      delete flexProps.theme;
	      delete flexProps.viewMoment;
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	      return _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({
	        inline: true,
	        column: true,
	        alignItems: "stretch"
	      }, flexProps), {}, {
	        className: className
	      }), this.renderYearView(yearViewProps), _react.default.createElement("div", {
	        className: separatorClassName
	      }), this.renderDecadeView(decadeViewProps), _react.default.createElement("div", {
	        className: separatorClassName
	      }), this.renderFooter());
	    }
	  }, {
	    key: "renderFooter",
	    value: function renderFooter() {
	      var props = this.p;
	      var children = props.children;
	      if (!props.footer) {
	        return null;
	      }
	      var okButtonText = props.okButtonText,
	        cancelButtonText = props.cancelButtonText;
	      var defaultFooterProps = (0, _assignDefined.default)({}, {
	        okButtonText: okButtonText,
	        cancelButtonText: cancelButtonText,
	        theme: props.theme
	      });
	      var footerChild = children.filter(function (c) {
	        return c && c.props && c.props.isDatePickerFooter;
	      })[0];
	      if (footerChild) {
	        var newFooterProps = {
	          onOkClick: (0, _joinFunctions.default)(this.onOkClick, footerChild.props.onOkClick),
	          onCancelClick: (0, _joinFunctions.default)(this.onCancelClick, footerChild.props.onCancelClick)
	        };
	        (0, _assignDefined.default)(newFooterProps, defaultFooterProps);
	        if (footerChild.props.centerButtons === undefined) {
	          newFooterProps.centerButtons = true;
	        }
	        if (footerChild.props.todayButton === undefined) {
	          newFooterProps.todayButton = false;
	        }
	        if (footerChild.props.clearButton === undefined) {
	          newFooterProps.clearButton = false;
	        }
	        return _react.default.cloneElement(footerChild, newFooterProps);
	      }
	      return _react.default.createElement(_Footer.default, _objectSpread(_objectSpread({
	        key: "month_decade_footer"
	      }, defaultFooterProps), {}, {
	        todayButton: false,
	        clearButton: false,
	        onOkClick: this.onOkClick,
	        onCancelClick: this.onCancelClick,
	        centerButtons: true
	      }));
	    }
	  }, {
	    key: "onOkClick",
	    value: function onOkClick() {
	      if (this.props.onOkClick) {
	        var dateMoment = this.p.activeMoment;
	        var dateString = this.format(dateMoment);
	        var timestamp = +dateMoment;
	        this.props.onOkClick(dateString, {
	          dateMoment: dateMoment,
	          timestamp: timestamp
	        });
	      }
	    }
	  }, {
	    key: "onCancelClick",
	    value: function onCancelClick() {
	      if (this.props.onCancelClick) {
	        this.props.onCancelClick();
	      }
	    }
	  }, {
	    key: "renderYearView",
	    value: function renderYearView(yearViewProps) {
	      var props = this.p;
	      var children = props.children;
	      var yearViewChild = children.filter(function (c) {
	        return c && c.props && c.props.isYearView;
	      })[0];
	      var yearViewChildProps = yearViewChild ? yearViewChild.props : {};
	      var tabIndex = yearViewChildProps.tabIndex == null ? null : yearViewChildProps.tabIndex;
	      yearViewProps.tabIndex = tabIndex;
	      if (props.focusYearView === false || tabIndex == null) {
	        yearViewProps.tabIndex = null;
	        yearViewProps.onFocus = this.onYearViewFocus;
	        yearViewProps.onMouseDown = this.onYearViewMouseDown;
	      }
	      (0, _assign.default)(yearViewProps, {
	        onViewDateChange: (0, _joinFunctions.default)(this.onViewDateChange, yearViewChildProps.onViewDateChange),
	        onActiveDateChange: (0, _joinFunctions.default)(this.onActiveDateChange, yearViewChildProps.onActiveDateChange),
	        onChange: (0, _joinFunctions.default)(this.handleYearViewOnChange, yearViewChildProps.onChange)
	      });
	      if (yearViewChild) {
	        return _react.default.cloneElement(yearViewChild, yearViewProps);
	      }
	      return _react.default.createElement(_YearView.default, _objectSpread({}, yearViewProps));
	    }
	  }, {
	    key: "renderDecadeView",
	    value: function renderDecadeView(decadeViewProps) {
	      var props = this.p;
	      var children = props.children;
	      var decadeViewChild = children.filter(function (c) {
	        return c && c.props && c.props.isDecadeView;
	      })[0];
	      var decadeViewChildProps = decadeViewChild ? decadeViewChild.props : {};
	      var tabIndex = decadeViewChildProps.tabIndex == null ? null : decadeViewChildProps.tabIndex;
	      decadeViewProps.tabIndex = tabIndex;
	      if (props.focusDecadeView === false || tabIndex == null) {
	        decadeViewProps.tabIndex = null;
	        decadeViewProps.onMouseDown = this.onDecadeViewMouseDown;
	      }
	      (0, _assign.default)(decadeViewProps, {
	        onConfirm: (0, _joinFunctions.default)(this.handleDecadeViewOnConfirm, decadeViewChildProps.onConfirm),
	        onViewDateChange: (0, _joinFunctions.default)(this.handleDecadeOnViewDateChange, decadeViewChildProps.onViewDateChange),
	        onActiveDateChange: (0, _joinFunctions.default)(this.handleDecadeOnActiveDateChange, decadeViewChildProps.onActiveDateChange),
	        onChange: (0, _joinFunctions.default)(this.handleDecadeOnChange, decadeViewChildProps.onChange)
	      });
	      if (decadeViewChild) {
	        return _react.default.cloneElement(decadeViewChild, decadeViewProps);
	      }
	      return _react.default.createElement(_DecadeView.default, _objectSpread({}, decadeViewProps));
	    }
	  }, {
	    key: "onYearViewFocus",
	    value: function onYearViewFocus() {
	      if (this.props.focusYearView === false) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      if (this.decadeView && this.props.focusDecadeView) {
	        this.decadeView.focus();
	      }
	    }
	  }, {
	    key: "getDOMNode",
	    value: function getDOMNode() {
	      return this.decadeView;
	    }
	  }, {
	    key: "onYearViewMouseDown",
	    value: function onYearViewMouseDown(e) {
	      preventDefault(e);
	      this.focus();
	    }
	  }, {
	    key: "onDecadeViewMouseDown",
	    value: function onDecadeViewMouseDown(e) {
	      preventDefault(e);
	    }
	  }, {
	    key: "format",
	    value: function format(mom, _format) {
	      _format = _format || this.props.dateFormat;
	      return mom.format(_format);
	    }
	  }, {
	    key: "handleDecadeViewOnConfirm",
	    value: function handleDecadeViewOnConfirm() {
	      if (this.props.okOnEnter) {
	        this.onOkClick();
	      }
	    }
	  }, {
	    key: "onKeyDown",
	    value: function onKeyDown(event) {
	      if (event.key == 'Escape') {
	        return this.onCancelClick();
	      }
	      if (this.decadeView) {
	        this.decadeView.onKeyDown(event);
	      }
	      return undefined;
	    }
	  }, {
	    key: "confirm",
	    value: function confirm(date, event) {
	      return _DecadeView.confirm.call(this, date, event);
	    }
	  }, {
	    key: "navigate",
	    value: function navigate(direction, event) {
	      return _DecadeView.navigate.call(this, direction, event);
	    }
	  }, {
	    key: "select",
	    value: function select(_ref, event) {
	      var dateMoment = _ref.dateMoment,
	        timestamp = _ref.timestamp;
	      return _DecadeView.select.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      }, event);
	    }
	  }, {
	    key: "handleDecadeOnViewDateChange",
	    value: function handleDecadeOnViewDateChange(dateString, _ref2) {
	      var dateMoment = _ref2.dateMoment,
	        timestamp = _ref2.timestamp;
	      var props = this.p;
	      var currentViewMoment = props.viewMoment;
	      if (currentViewMoment) {
	        dateMoment.set('month', currentViewMoment.get('month'));
	        dateString = this.format(dateMoment);
	        timestamp = +dateMoment;
	      }
	      this.onViewDateChange(dateString, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "handleDecadeOnActiveDateChange",
	    value: function handleDecadeOnActiveDateChange(dateString, _ref3) {
	      var dateMoment = _ref3.dateMoment,
	        timestamp = _ref3.timestamp;
	      var props = this.p;
	      var currentViewMoment = props.viewMoment;
	      if (currentViewMoment) {
	        dateMoment.set('month', currentViewMoment.get('month'));
	        dateString = this.format(dateMoment);
	        timestamp = +dateMoment;
	      }
	      this.onActiveDateChange(dateString, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "handleDecadeOnChange",
	    value: function handleDecadeOnChange(dateString, _ref4, event) {
	      var dateMoment = _ref4.dateMoment,
	        timestamp = _ref4.timestamp;
	      var props = this.p;
	      var currentViewMoment = props.viewMoment;
	      if (currentViewMoment) {
	        dateMoment.set('month', currentViewMoment.get('month'));
	        dateString = this.format(dateMoment);
	        timestamp = +dateMoment;
	      }
	      this.onChange(dateString, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      }, event);
	    }
	  }, {
	    key: "handleYearViewOnChange",
	    value: function handleYearViewOnChange(dateString, _ref5, event) {
	      var dateMoment = _ref5.dateMoment,
	        timestamp = _ref5.timestamp;
	      var props = this.p;
	      var currentMoment = props.moment;
	      if (currentMoment) {
	        dateMoment.set('year', currentMoment.get('year'));
	        dateString = this.format(dateMoment);
	        timestamp = +dateMoment;
	      }
	      this.onChange(dateString, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      }, event);
	    }
	  }, {
	    key: "onViewDateChange",
	    value: function onViewDateChange(dateString, _ref6) {
	      var dateMoment = _ref6.dateMoment,
	        timestamp = _ref6.timestamp;
	      return _DecadeView.onViewDateChange.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "gotoViewDate",
	    value: function gotoViewDate(_ref7) {
	      var dateMoment = _ref7.dateMoment,
	        timestamp = _ref7.timestamp;
	      return _DecadeView.gotoViewDate.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "onActiveDateChange",
	    value: function onActiveDateChange(dateString, _ref8) {
	      var dateMoment = _ref8.dateMoment,
	        timestamp = _ref8.timestamp;
	      return _DecadeView.onActiveDateChange.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(dateString, _ref9, event) {
	      var dateMoment = _ref9.dateMoment,
	        timestamp = _ref9.timestamp;
	      return _DecadeView.onChange.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      }, event);
	    }
	  }]);
	  return MonthDecadeView;
	}(_reactClass.default);
	exports.default = MonthDecadeView;
	MonthDecadeView.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__month-decade-view',
	  okOnEnter: true,
	  footer: true,
	  theme: 'default',
	  navigation: true,
	  focusYearView: false,
	  focusDecadeView: true,
	  dateFormat: 'YYYY-MM-DD',
	  adjustDateStartOf: 'month',
	  adjustMinDateStartOf: 'month',
	  adjustMaxDateStartOf: 'month'
	};
	MonthDecadeView.propTypes = (_MonthDecadeView$prop = {
	  okOnEnter: _propTypes.default.bool,
	  navigation: _propTypes.default.bool,
	  focusYearView: _propTypes.default.bool,
	  focusDecadeView: _propTypes.default.bool,
	  footer: _propTypes.default.bool,
	  minDate: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object, _propTypes.default.string]),
	  maxDate: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object, _propTypes.default.string]),
	  viewMoment: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object, _propTypes.default.string]),
	  activeDate: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object, _propTypes.default.string]),
	  date: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object, _propTypes.default.string]),
	  defaultDate: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object, _propTypes.default.string]),
	  defaultViewDate: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object, _propTypes.default.string]),
	  dateFormat: _propTypes.default.string,
	  moment: _propTypes.default.object,
	  locale: _propTypes.default.string,
	  theme: _propTypes.default.string
	}, (0, _defineProperty2.default)(_MonthDecadeView$prop, "dateFormat", _propTypes.default.string), (0, _defineProperty2.default)(_MonthDecadeView$prop, "adjustDateStartOf", _propTypes.default.string), (0, _defineProperty2.default)(_MonthDecadeView$prop, "adjustMinDateStartOf", _propTypes.default.string), (0, _defineProperty2.default)(_MonthDecadeView$prop, "adjustMaxDateStartOf", _propTypes.default.string), (0, _defineProperty2.default)(_MonthDecadeView$prop, "cleanup", _propTypes.default.func), (0, _defineProperty2.default)(_MonthDecadeView$prop, "onCancelClick", _propTypes.default.func), (0, _defineProperty2.default)(_MonthDecadeView$prop, "onOkClick", _propTypes.default.func), (0, _defineProperty2.default)(_MonthDecadeView$prop, "onChange", _propTypes.default.func), _MonthDecadeView$prop);

/***/ },
/* 233 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = {
	  ArrowUp: -7,
	  ArrowDown: 7,
	  ArrowLeft: -1,
	  ArrowRight: 1,
	  PageUp: function PageUp(mom) {
	    return mom.add(-1, 'month');
	  },
	  PageDown: function PageDown(mom) {
	    return mom.add(1, 'month');
	  },
	  Home: function Home(mom) {
	    return mom.startOf('month');
	  },
	  End: function End(mom) {
	    return mom.endOf('month');
	  }
	};
	exports.default = _default;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	var _navKeys = _interopRequireDefault(__webpack_require__(233));
	function _default(event) {
	  var key = event.key;
	  if (this.props.onKeyDown) {
	    if (this.props.onKeyDown(event) === false) {
	      return;
	    }
	  }
	  if (key == 'Enter' && this.p.activeDate) {
	    this.confirm(this.p.activeDate, event);
	  }
	  var navKeys = this.p.navKeys || _navKeys.default;
	  var dir = navKeys[key];
	  if (!dir) {
	    return;
	  }
	  event.preventDefault();
	  this.navigate(dir, event);
	}

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _leftPad = _interopRequireDefault(__webpack_require__(154));
	var _default = function _default(_ref) {
	  var value = _ref.value,
	    _ref$separator = _ref.separator,
	    separator = _ref$separator === void 0 ? ':' : _ref$separator,
	    meridiem = _ref.meridiem;
	  var parts = value.split(separator);
	  var hours = parts[0];
	  var minutes = parts[1];
	  var seconds = parts[2];
	  var result = {
	    hours: hours,
	    minutes: minutes
	  };
	  if (typeof seconds == 'string' && seconds.length) {
	    result.seconds = seconds;
	  }
	  if (meridiem && seconds !== undefined && seconds * 1 != seconds) {
	    result.seconds = (0, _leftPad.default)(parseInt(seconds, 10));
	  }
	  if (meridiem && seconds === undefined && minutes * 1 != minutes) {
	    result.minutes = (0, _leftPad.default)(parseInt(minutes, 10));
	  }
	  if (meridiem) {
	    var meridiems = ['am', 'AM', 'pm', 'PM'];
	    var indexes = meridiems.map(function (m) {
	      return (seconds || minutes).indexOf(m);
	    });
	    indexes.forEach(function (indexOf, i) {
	      if (indexOf != -1) {
	        result.meridiem = meridiems[i];
	      }
	    });
	  }
	  return result;
	};
	exports.default = _default;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _Flex = __webpack_require__(41);
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _times = _interopRequireDefault(__webpack_require__(111));
	var _toMoment2 = _interopRequireDefault(__webpack_require__(40));
	var _bemFactory = _interopRequireDefault(__webpack_require__(638));
	var _DecadeView = __webpack_require__(151);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var bem = (0, _bemFactory.default)('react-calendar__year-view');
	var NAV_KEYS = {
	  ArrowUp: function ArrowUp(mom) {
	    if (mom.get('month') >= 4) {
	      mom.add(-4, 'month');
	    }
	    return mom;
	  },
	  ArrowDown: function ArrowDown(mom) {
	    if (mom.get('month') <= 7) {
	      mom.add(4, 'month');
	    }
	    return mom;
	  },
	  ArrowLeft: function ArrowLeft(mom) {
	    if (mom.get('month') >= 1) {
	      mom.add(-1, 'month');
	    }
	    return mom;
	  },
	  ArrowRight: function ArrowRight(mom) {
	    if (mom.get('month') <= 10) {
	      mom.add(1, 'month');
	    }
	    return mom;
	  },
	  Home: function Home(mom) {
	    return mom.startOf('year').startOf('month');
	  },
	  End: function End(mom) {
	    return mom.endOf('year').startOf('month');
	  },
	  PageUp: function PageUp(mom) {
	    var month = mom.get('month') - 4;
	    var extra4 = month - 4;
	    if (month >= 0) {
	      if (extra4 >= 0) {
	        return mom.set('month', extra4);
	      }
	      return mom.set('month', month);
	    }
	    return mom;
	  },
	  PageDown: function PageDown(mom) {
	    var month = mom.get('month') + 4;
	    var extra4 = month + 4;
	    if (month <= 11) {
	      if (extra4 <= 11) {
	        return mom.set('month', extra4);
	      }
	      return mom.set('month', month);
	    }
	    return mom;
	  }
	};
	var YearView = function (_Component) {
	  (0, _inherits2.default)(YearView, _Component);
	  var _super = _createSuper(YearView);
	  function YearView(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, YearView);
	    _this = _super.call(this, props);
	    _this.state = (0, _DecadeView.getInitialState)(props);
	    _this.yearViewRef = (0, _react.createRef)();
	    return _this;
	  }
	  (0, _createClass2.default)(YearView, [{
	    key: "getMonthsInYear",
	    value: function getMonthsInYear(value) {
	      var _this2 = this;
	      var start = this.toMoment(value).startOf('year');
	      return (0, _times.default)(12).map(function (i) {
	        return _this2.toMoment(start).add(i, 'month');
	      });
	    }
	  }, {
	    key: "toMoment",
	    value: function toMoment(date) {
	      return (0, _toMoment2.default)(date, this.props);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.p = (0, _assign.default)({}, this.props);
	      var rootClassName = props.rootClassName;
	      var dateProps = (0, _DecadeView.prepareDateProps)(props, this.state);
	      (0, _assign.default)(props, dateProps);
	      var className = (0, _join.default)(props.className, rootClassName, props.theme && "".concat(rootClassName, "--theme-").concat(props.theme));
	      var monthsInView = this.getMonthsInYear(props.viewMoment);
	      var flexProps = (0, _assign.default)({}, props);
	      delete flexProps.rootClassName;
	      delete flexProps.activeDate;
	      delete flexProps.activeMoment;
	      delete flexProps.adjustDateStartOf;
	      delete flexProps.adjustMaxDateStartOf;
	      delete flexProps.adjustMinDateStartOf;
	      delete flexProps.cleanup;
	      delete flexProps.constrainViewDate;
	      delete flexProps.date;
	      delete flexProps.dateFormat;
	      delete flexProps.isYearView;
	      delete flexProps.maxConstrained;
	      delete flexProps.maxDate;
	      delete flexProps.maxDateMoment;
	      delete flexProps.minConstrained;
	      delete flexProps.minDate;
	      delete flexProps.minDateMoment;
	      delete flexProps.moment;
	      delete flexProps.monthFormat;
	      delete flexProps.navKeys;
	      delete flexProps.onActiveDateChange;
	      delete flexProps.onViewDateChange;
	      delete flexProps.onlyCompareMonth;
	      delete flexProps.timestamp;
	      delete flexProps.theme;
	      delete flexProps.viewDate;
	      delete flexProps.viewMoment;
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	      return _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({
	        inline: true,
	        column: true,
	        ref: this.yearViewRef,
	        alignItems: "stretch",
	        tabIndex: 0
	      }, flexProps), {}, {
	        onKeyDown: this.onKeyDown,
	        className: className
	      }), this.renderMonths(props, monthsInView));
	    }
	  }, {
	    key: "renderMonths",
	    value: function renderMonths(props, months) {
	      var _this3 = this;
	      var nodes = months.map(function (monthMoment) {
	        return _this3.renderMonth(props, monthMoment);
	      });
	      var buckets = (0, _times.default)(Math.ceil(nodes.length / 4)).map(function (i) {
	        return nodes.slice(i * 4, (i + 1) * 4);
	      });
	      var className = "".concat(this.props.rootClassName, "-row");
	      return buckets.map(function (bucket, i) {
	        return _react.default.createElement(_Flex.Flex, {
	          alignItems: "center",
	          flex: true,
	          row: true,
	          inline: true,
	          key: "row_".concat(i),
	          className: className
	        }, bucket);
	      });
	    }
	  }, {
	    key: "format",
	    value: function format(mom, _format) {
	      _format = _format || this.props.monthFormat;
	      return mom.format(_format);
	    }
	  }, {
	    key: "renderMonth",
	    value: function renderMonth(props, dateMoment) {
	      var index = dateMoment.get('month');
	      var monthText = props.monthNames ? props.monthNames[index] || this.format(dateMoment) : this.format(dateMoment);
	      var timestamp = +dateMoment;
	      var isActiveDate = props.onlyCompareMonth && props.activeMoment ? dateMoment.get('month') == props.activeMoment.get('month') : timestamp === props.activeDate;
	      var isValue = props.onlyCompareMonth && props.moment ? dateMoment.get('month') == props.moment.get('month') : timestamp === props.timestamp;
	      var disabled = props.minDate != null && timestamp < props.minDate || props.maxDate != null && timestamp > props.maxDate;
	      var rootClassName = props.rootClassName;
	      var className = (0, _join.default)("".concat(rootClassName, "-month"), !disabled && isActiveDate && "".concat(rootClassName, "-month--active"), !disabled && isValue && "".concat(rootClassName, "-month--value"), disabled && "".concat(rootClassName, "-month--disabled"));
	      var onClick = disabled ? null : this.handleClick.bind(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	      return _react.default.createElement(_Flex.Item, {
	        key: monthText,
	        className: className,
	        onClick: onClick
	      }, monthText);
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(_ref, event) {
	      var timestamp = _ref.timestamp,
	        dateMoment = _ref.dateMoment;
	      event.target.value = timestamp;
	      this.select({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      }, event);
	    }
	  }, {
	    key: "onKeyDown",
	    value: function onKeyDown(event) {
	      return _DecadeView.onKeyDown.call(this, event);
	    }
	  }, {
	    key: "confirm",
	    value: function confirm(date, event) {
	      return _DecadeView.confirm.call(this, date, event);
	    }
	  }, {
	    key: "navigate",
	    value: function navigate(direction, event) {
	      return _DecadeView.navigate.call(this, direction, event);
	    }
	  }, {
	    key: "select",
	    value: function select(_ref2, event) {
	      var dateMoment = _ref2.dateMoment,
	        timestamp = _ref2.timestamp;
	      return _DecadeView.select.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      }, event);
	    }
	  }, {
	    key: "onViewDateChange",
	    value: function onViewDateChange(_ref3) {
	      var dateMoment = _ref3.dateMoment,
	        timestamp = _ref3.timestamp;
	      return _DecadeView.onViewDateChange.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "gotoViewDate",
	    value: function gotoViewDate(_ref4) {
	      var dateMoment = _ref4.dateMoment,
	        timestamp = _ref4.timestamp;
	      return _DecadeView.gotoViewDate.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "onActiveDateChange",
	    value: function onActiveDateChange(_ref5) {
	      var dateMoment = _ref5.dateMoment,
	        timestamp = _ref5.timestamp;
	      return _DecadeView.onActiveDateChange.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(_ref6, event) {
	      var dateMoment = _ref6.dateMoment,
	        timestamp = _ref6.timestamp;
	      return _DecadeView.onChange.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      }, event);
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.yearViewRef.current.focus();
	    }
	  }, {
	    key: "getDOMNode",
	    value: function getDOMNode() {
	      return this.yearViewRef.current;
	    }
	  }]);
	  return YearView;
	}(_reactClass.default);
	exports.default = YearView;
	YearView.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__year-view',
	  isYearView: true,
	  navKeys: NAV_KEYS,
	  constrainViewDate: true,
	  theme: 'default',
	  monthFormat: 'MMM',
	  dateFormat: 'YYYY-MM-DD',
	  onlyCompareMonth: true,
	  adjustDateStartOf: 'month',
	  adjustMinDateStartOf: 'month',
	  adjustMaxDateStartOf: 'month'
	};
	YearView.propTypes = {
	  rootClassName: _propTypes.default.string,
	  navKeys: _propTypes.default.object,
	  isYearView: _propTypes.default.bool,
	  constrainViewDate: _propTypes.default.bool,
	  onlyCompareMonth: _propTypes.default.bool,
	  theme: _propTypes.default.string,
	  monthFormat: _propTypes.default.string,
	  dateFormat: _propTypes.default.string,
	  adjustDateStartOf: _propTypes.default.string,
	  adjustMinDateStartOf: _propTypes.default.string,
	  adjustMaxDateStartOf: _propTypes.default.string
	};

/***/ },
/* 237 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(range) {
	  if (range[1] && range[0].isAfter(range[1])) {
	    range = [range[1], range[0]];
	  }
	  return range;
	};
	exports.default = _default;

/***/ },
/* 238 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.clampSecond = exports.clampNamed = exports.clampMinute = exports.clampHour = void 0;
	var clamp = function clamp(value, _ref) {
	  var min = _ref.min,
	    max = _ref.max,
	    _ref$circular = _ref.circular,
	    circular = _ref$circular === void 0 ? true : _ref$circular;
	  return value < min ? circular ? max : min : value > max ? circular ? min : max : value;
	};
	var clampHour = function clampHour(value, _ref2) {
	  var max = _ref2.max,
	    min = _ref2.min,
	    circular = _ref2.circular;
	  return clamp(value, {
	    min: min || 0,
	    max: max || 23,
	    circular: circular
	  });
	};
	exports.clampHour = clampHour;
	var clampMinute = function clampMinute(value, _ref3) {
	  var circular = _ref3.circular;
	  return clamp(value, {
	    min: 0,
	    max: 59,
	    circular: circular
	  });
	};
	exports.clampMinute = clampMinute;
	var clampSecond = function clampSecond(value, _ref4) {
	  var circular = _ref4.circular;
	  return clamp(value, {
	    min: 0,
	    max: 59,
	    circular: circular
	  });
	};
	exports.clampSecond = clampSecond;
	var MAP = {
	  second: clampSecond,
	  seconds: clampSecond,
	  minute: clampMinute,
	  minutes: clampMinute,
	  hour: clampHour,
	  hours: clampHour
	};
	var clampNamed = function clampNamed(name, value, _ref5) {
	  var circular = _ref5.circular,
	    max = _ref5.max,
	    min = _ref5.min;
	  return MAP[name](value, {
	    circular: circular,
	    max: max,
	    min: min
	  });
	};
	exports.clampNamed = clampNamed;
	var _default = clamp;
	exports.default = _default;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _default = function _default(moment, configOrRange) {
	  var range = configOrRange;
	  var inclusive = true;
	  if (!Array.isArray(configOrRange) && (0, _typeof2.default)(configOrRange) == 'object') {
	    range = configOrRange.range;
	    if (configOrRange.inclusive !== undefined) {
	      inclusive = !!configOrRange.inclusive;
	    }
	  }
	  var start = range[0];
	  var end = range.length >= 2 && range[range.length - 1];
	  if (!moment) {
	    return false;
	  }
	  if (start && end) {
	    var insideRange = start.isBefore(moment) && end.isAfter(moment);
	    return inclusive ? insideRange || start.isSame(moment) || end.isSame(moment) : insideRange;
	  }
	  return false;
	};
	exports.default = _default;

/***/ },
/* 240 */
[1296, 656],
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof3 = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.REMAINING_ITEMS = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _NotifyResize = __webpack_require__(84);
	var _throttle = _interopRequireDefault(__webpack_require__(102));
	var _containsNode = _interopRequireDefault(__webpack_require__(71));
	var _TextInput = _interopRequireDefault(__webpack_require__(653));
	var _Value = _interopRequireDefault(__webpack_require__(655));
	var _ClearButton = _interopRequireDefault(__webpack_require__(646));
	var _ToggleButton = _interopRequireDefault(__webpack_require__(654));
	var _List = _interopRequireDefault(__webpack_require__(650));
	var _Icons = __webpack_require__(112);
	var _shouldComponentUpdate2 = _interopRequireDefault(__webpack_require__(677));
	var _getRootClassName = _interopRequireDefault(__webpack_require__(669));
	var _getListProps2 = _interopRequireDefault(__webpack_require__(663));
	var _getValueProps2 = _interopRequireDefault(__webpack_require__(673));
	var _getDataProp = _interopRequireDefault(__webpack_require__(661));
	var _getNewMultipleValue = _interopRequireDefault(__webpack_require__(666));
	var _getNewSingleValue = _interopRequireDefault(__webpack_require__(667));
	var _findItemIndex = _interopRequireDefault(__webpack_require__(242));
	var _filterByValue = _interopRequireDefault(__webpack_require__(659));
	var _filterByText = _interopRequireDefault(__webpack_require__(658));
	var _deselectValue = _interopRequireDefault(__webpack_require__(657));
	var _getNewActiveTagOnRemove = _interopRequireDefault(__webpack_require__(665));
	var _getNextItem = _interopRequireDefault(__webpack_require__(668));
	var _groupItems = _interopRequireDefault(__webpack_require__(674));
	var _getValueMap = _interopRequireDefault(__webpack_require__(672));
	var _getGroups = _interopRequireDefault(__webpack_require__(662));
	var _PaginationToolbar = __webpack_require__(255);
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var REMAINING_ITEMS = 'REMAINING_ITEMS';
	exports.REMAINING_ITEMS = REMAINING_ITEMS;
	var emptyObject = {};
	var InovuaComboBox = function (_Component) {
	  (0, _inherits2.default)(InovuaComboBox, _Component);
	  var _super = _createSuper(InovuaComboBox);
	  function InovuaComboBox(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaComboBox);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
	      if (_this.isExpandedControlled() && _this.props.expanded !== prevProps.expanded) {
	        _this.onExpand();
	      }
	      if (prevProps.dataSource !== _this.props.dataSource) {
	        _this.loadDataSource(_this.props.dataSource, _this.props);
	      }
	      if (_this.props.idProperty !== prevProps.idProperty) {
	        _this.updateGetIdProperty(_this.props);
	      }
	      if (_this.props.displayProperty !== prevProps.displayProperty) {
	        _this.updateGetDisplayProperty(_this.props);
	      }
	      if (_this.props.filterProperty !== prevProps.filterProperty) {
	        _this.updateGetFilterProperty(_this.props);
	      }
	      if (_this.props.groupProperty !== prevProps.groupProperty) {
	        _this.updateGroups({
	          groupProperty: _this.props.groupProperty
	        });
	      }
	      if (_this.isTextControled() && _this.props.text !== prevProps.text) {
	        _this.onTextUpdate(_this.props.text);
	      }
	      if (_this.isActiveItemControlled() && prevProps.changeValueOnNavigation && !prevProps.multiple && prevProps.activeItem !== _this.props.activeItem) {
	        _this.setValue(_this.props.activeItem, {
	          action: 'navigate'
	        });
	      }
	      if (_this.isExpandedControlled() && !prevProps.expanded && _this.props.expanded) {
	        _this.loadLazyDataSource({
	          action: 'expand',
	          text: ''
	        });
	      }
	    });
	    _this.refTools = function (tools) {
	      _this.toolsNode = tools;
	    };
	    _this.state = {
	      loading: props.defaultLoading || !!(props.dataSource && props.dataSource.then),
	      value: props.defaultValue,
	      valueMap: {},
	      text: props.defaultText,
	      activeTag: props.defaultActiveTag,
	      activeItem: props.defaultActiveItem || !props.multiple && props.defaultValue,
	      expanded: props.defaultExpanded,
	      toolsSize: {
	        width: 0,
	        height: 0
	      },
	      over: false,
	      focus: false
	    };
	    _this.getData = _this.getData.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleItemClick = _this.handleItemClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleTextChange = _this.handleTextChange.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleTextInputClick = _this.handleTextInputClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleTagClick = _this.handleTagClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleRemoveTag = _this.handleRemoveTag.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleComboClick = _this.handleComboClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleComboKeyDown = _this.handleComboKeyDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleComboFocus = _this.handleComboFocus.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleComboBlur = _this.handleComboBlur.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getComboNode = _this.getComboNode.bind((0, _assertThisInitialized2.default)(_this));
	    _this.clear = _this.clear.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleMouseEnter = _this.handleMouseEnter.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleMouseLeave = _this.handleMouseLeave.bind((0, _assertThisInitialized2.default)(_this));
	    _this.toggleExpand = _this.toggleExpand.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleToolsSize = _this.handleToolsSize.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleRemoveMultipleTag = _this.handleRemoveMultipleTag.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleListScrollBottom = _this.handleListScrollBottom.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleDelete = _this.handleDelete.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getListNode = _this.getListNode.bind((0, _assertThisInitialized2.default)(_this));
	    _this.updateGetIdProperty();
	    _this.updateGetDisplayProperty();
	    _this.updateGetFilterProperty();
	    _this.addTextInputRef = function (ref) {
	      _this.textInput = ref;
	    };
	    _this.addRootRef = function (ref) {
	      _this.comboNode = ref;
	    };
	    _this.addListRef = function (ref) {
	      _this.listNode = ref;
	    };
	    _this.setActiveItem = (0, _throttle.default)(_this.setActiveItem, 16);
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaComboBox, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.autoFocus) {
	        this.focus();
	      }
	      if (this.state.activeItem && this.state.activeItemIndex == null) {
	        this.setState({
	          activeItemIndex: this.getItemIndexById(this.state.activeItem)
	        });
	      }
	      if (!this.isRemoteFilter()) {
	        this.doFilter();
	      }
	      if (!this.props.lazyDataSource) {
	        this.loadDataSource(this.props.dataSource);
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _shouldComponentUpdate2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props,
	        state = this.state;
	      var textInput = this.renderTextInput();
	      var className = (0, _getRootClassName.default)({
	        props: props,
	        state: state,
	        computed: {
	          value: this.getValue()
	        }
	      });
	      var expanded = this.getExpanded();
	      var items = this.getSelectedItems();
	      var groupedItems = this.groupedItems = this.getGroupedItems(this.getSelectedItems());
	      this.areItemsGrouped = this.groupedItems && this.groupedItems.remainingItems && this.groupedItems.remainingItems.length;
	      var style = this.getRootStyle();
	      var filteredData = this.getFilteredData();
	      var text = this.getText();
	      this.isNewCustomTagValid = (!filteredData || filteredData.length === 0) && !!text && props.allowCustomTagCreation;
	      return _react.default.createElement("div", _objectSpread(_objectSpread({}, (0, _cleanProps.default)(props, InovuaComboBox.propTypes)), {}, {
	        onClick: this.handleComboClick,
	        onMouseDown: this.handleComboMouseDown,
	        onKeyDown: this.handleComboKeyDown,
	        onFocus: this.handleComboFocus,
	        onBlur: this.handleComboBlur,
	        className: className,
	        style: style,
	        ref: this.addRootRef,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        tabIndex: 0
	      }), _react.default.createElement(_Value.default, _objectSpread(_objectSpread({}, this.getValueProps({
	        items: items,
	        groupedItems: groupedItems
	      })), {}, {
	        textInput: textInput,
	        toolsSize: state.toolsSize
	      })), _react.default.createElement("div", {
	        className: "".concat(props.rootClassName, "__tools"),
	        ref: this.refTools
	      }, this.renderSpinner(), this.renderClearIcon(), this.renderToggleIcon(), this.props.tagEllipsis && _react.default.createElement(_NotifyResize.NotifyResize, {
	        notifyOnMount: true,
	        onResize: this.handleToolsSize
	      })), expanded && this.renderList());
	    }
	  }, {
	    key: "getRootStyle",
	    value: function getRootStyle() {
	      var props = this.props,
	        state = this.state;
	      var style = _objectSpread({}, props.style);
	      if (props.borderRadius) {
	        style.borderRadius = props.borderRadius;
	      }
	      if (props.padding) {
	        style.padding = props.padding;
	      }
	      if (props.border) {
	        style.border = props.border;
	      }
	      if (props.background) {
	        style.background = props.background;
	      }
	      if (!this.getValue() && props.emptyStyle) {
	        style = _objectSpread(_objectSpread({}, style), props.emptyStyle);
	      }
	      if (props.disabledStyle && props.disabled) {
	        style = _objectSpread(_objectSpread({}, style), props.disabledStyle);
	      }
	      if (state.focus && props.focusedStyle) {
	        style = _objectSpread(_objectSpread({}, style), props.focusedStyle);
	      }
	      return style;
	    }
	  }, {
	    key: "renderList",
	    value: function renderList() {
	      var listProps = this.getListProps();
	      var result;
	      if (typeof this.props.renderList === 'function') {
	        result = this.props.renderList({
	          domProps: listProps,
	          items: this.getFilteredData()
	        });
	      }
	      if (result === undefined) {
	        result = _react.default.createElement(_List.default, _objectSpread({}, listProps));
	      }
	      if (typeof this.props.renderListComponent === 'function') {
	        var res = this.props.renderListComponent(result);
	        if ((0, _typeof2.default)(res) !== undefined) {
	          return res;
	        }
	        result = res;
	      }
	      return result;
	    }
	  }, {
	    key: "renderClearIcon",
	    value: function renderClearIcon() {
	      var props = this.props,
	        state = this.state;
	      var searchable = props.searchable;
	      var text = this.getText();
	      var value = this.getValue();
	      var showClearIcon = (text || value != null) && props.clearIcon;
	      if (props.showClearIconOnMouseOver) {
	        if (!state.over) {
	          showClearIcon = false;
	        }
	      }
	      if (searchable === false) {
	        showClearIcon = false;
	      }
	      if (!showClearIcon) {
	        return null;
	      }
	      var clearButton = _react.default.createElement(_ClearButton.default, {
	        onClear: this.clear,
	        closeIcon: props.clearIcon,
	        className: "".concat(props.rootClassName, "__clear-icon")
	      });
	      return clearButton;
	    }
	  }, {
	    key: "renderToggleIcon",
	    value: function renderToggleIcon() {
	      var props = this.props;
	      if (!props.toggleIcon) {
	        return null;
	      }
	      return _react.default.createElement(_ToggleButton.default, {
	        onToggle: this.toggleExpand,
	        className: "".concat(props.rootClassName, "__toggle-icon"),
	        toggleIcon: props.toggleIcon,
	        expanded: this.getExpanded()
	      });
	    }
	  }, {
	    key: "renderTextInput",
	    value: function renderTextInput() {
	      if (this.props.disabled) {
	        return null;
	      }
	      var text = this.getText();
	      var value = text;
	      if (!this.props.multiple) {
	        if (text == null) {
	          value = this.getValue() == null ? '' : this.getItemLabel();
	        } else {
	          value = text;
	        }
	      }
	      var data = this.getFilteredData();
	      var suggestion = null;
	      if (this.props.minAutocompleteLength <= (value && value.length) && data && data[0]) {
	        suggestion = this.getDisplayProperty(data[0]);
	      }
	      var inputProps = {
	        key: 'text_input',
	        value: value,
	        theme: this.props.theme,
	        suggestion: suggestion,
	        placeholder: this.props.placeholder,
	        rootClassName: "".concat(this.props.rootClassName, "__input"),
	        className: this.props.inputClassName,
	        style: this.props.inputStyle,
	        onChange: this.handleTextChange,
	        ref: this.addTextInputRef,
	        onClick: this.handleTextInputClick,
	        throttle: this.props.filterDelay,
	        autocomplete: this.props.autocomplete,
	        tabIndex: this.props.tabIndex,
	        autocompleteDelay: this.props.autocompleteDelay,
	        searchable: this.props.searchable
	      };
	      var result;
	      if (typeof this.props.renderInput === 'function') {
	        result = this.props.renderInput({
	          text: text,
	          domProps: inputProps,
	          onChange: inputProps.onChange
	        });
	      }
	      if (result === undefined) {
	        result = _react.default.createElement(_TextInput.default, _objectSpread({}, inputProps));
	      }
	      return result;
	    }
	  }, {
	    key: "renderSpinner",
	    value: function renderSpinner() {
	      if (!this.props.loadingSpinner) {
	        return null;
	      }
	      var loading = this.getLoading();
	      if (!loading && !this.getExpanded()) {
	        return null;
	      }
	      var spinner = this.props.loadingSpinner === true ? _react.default.createElement(_Icons.LoadingIcon, {
	        className: "".concat(this.props.rootClassName, "__loading-spinner")
	      }) : this.props.loadingSpinner;
	      return loading ? spinner : (0, _react.cloneElement)(spinner, {
	        style: spinner.props.style ? _objectSpread(_objectSpread({}, spinner.props.style), {}, {
	          display: 'none'
	        }) : {
	          display: 'none'
	        }
	      });
	    }
	  }, {
	    key: "getListProps",
	    value: function getListProps() {
	      var props = this.props,
	        state = this.state;
	      var data = this.getFilteredData();
	      var groupsLength = this.state.groups && Object.keys(this.state.groups).length || 0;
	      var listProps = (0, _getListProps2.default)({
	        props: props,
	        state: state,
	        computed: {
	          data: data,
	          loading: this.getLoading(),
	          activeItem: this.getActiveItem(),
	          value: this.getValue(),
	          dataLength: data && data.length + groupsLength || 0,
	          getIdProperty: this.getIdProperty,
	          getDisplayProperty: this.getDisplayProperty,
	          onItemClick: this.handleItemClick,
	          getComboNode: this.getComboNode,
	          ref: this.addListRef,
	          onScrollBottom: this.handleListScrollBottom,
	          text: this.getText(),
	          isNewCustomTagValid: this.isNewCustomTagValid
	        }
	      });
	      return listProps;
	    }
	  }, {
	    key: "getValueProps",
	    value: function getValueProps(_ref) {
	      var items = _ref.items,
	        groupedItems = _ref.groupedItems,
	        item = _ref.item;
	      var props = this.props,
	        state = this.state;
	      var value = this.getValue();
	      return (0, _getValueProps2.default)({
	        props: props,
	        state: state,
	        computed: {
	          items: items,
	          item: item,
	          groupedItems: groupedItems,
	          value: value,
	          label: this.getItemLabel(),
	          activeTag: this.getActiveTag()
	        },
	        tagProps: {
	          activeStyle: props.tagActiveStyle,
	          onClick: this.handleTagClick,
	          onCloseTagClick: this.handleRemoveTag,
	          onMultipleTagClose: this.handleRemoveMultipleTag
	        }
	      });
	    }
	  }, {
	    key: "loadDataSource",
	    value: function loadDataSource(dataSource) {
	      var _this2 = this;
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
	      var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : emptyObject,
	        appendTo = _ref2.appendTo,
	        action = _ref2.action,
	        value = _ref2.value,
	        text = _ref2.text,
	        skip = _ref2.skip,
	        limit = _ref2.limit,
	        hasNextPage = _ref2.hasNextPage;
	      if (Array.isArray(dataSource)) {
	        if (this.getLoading()) {
	          this.setLoading(false);
	        }
	        this.setData(dataSource, props, {
	          appendTo: appendTo
	        });
	        return;
	      }
	      if (dataSource && Array.isArray(dataSource.data)) {
	        if (this.getLoading()) {
	          this.setLoading(false);
	        }
	        this.setData(dataSource.data, props, {
	          remoteCount: dataSource.count != null ? dataSource.count * 1 : null,
	          appendTo: appendTo
	        });
	        return;
	      }
	      if (dataSource && dataSource.then) {
	        this.setLoading(true);
	        dataSource.then(function (data) {
	          _this2.props.onDataSourceLoad(data);
	          _this2.loadDataSource(data, props, {
	            appendTo: appendTo
	          });
	        });
	        return;
	      }
	      if (typeof dataSource === 'function') {
	        var config = _objectSpread(_objectSpread({}, props), {}, {
	          data: this.state.data,
	          hasNextPage: hasNextPage !== undefined ? hasNextPage : this.hasNextPage(),
	          text: this.isRemoteFilter() ? text !== undefined ? text : this.getText() : undefined,
	          skip: skip || 0,
	          action: action,
	          append: !!appendTo,
	          value: value !== undefined ? value : this.getValue(),
	          limit: limit !== undefined ? limit : this.props.limit
	        });
	        var dataResult = dataSource(config);
	        this.loadDataSource(dataResult, undefined, {
	          appendTo: config.append === false ? null : appendTo
	        });
	      }
	      if (!dataSource) {
	        this.setData(null, props);
	      }
	    }
	  }, {
	    key: "setData",
	    value: function setData(data) {
	      var _this3 = this;
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
	      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : emptyObject,
	        remoteCount = _ref3.remoteCount,
	        appendTo = _ref3.appendTo;
	      if (!data) {
	        this.setState({
	          data: null,
	          dataMap: null,
	          filteredData: null,
	          remoteCount: null
	        });
	        return null;
	      }
	      if (Array.isArray(appendTo)) {
	        data = appendTo.concat(data);
	      }
	      var dataMap = data.reduce(function (acc, item) {
	        acc[_this3.getIdProperty(item)] = item;
	        return acc;
	      }, {});
	      if (props.groupProperty) {
	        this.updateGroups({
	          data: data,
	          groupProperty: props.groupProperty
	        });
	      }
	      this.updateValueMap({
	        value: this.getValue(props),
	        dataMap: dataMap,
	        oldValueMap: this.getValueMap()
	      });
	      this.updateFilteredData({
	        data: data
	      });
	      this.setState({
	        data: data,
	        dataMap: dataMap,
	        remoteCount: remoteCount
	      });
	    }
	  }, {
	    key: "getPageCount",
	    value: function getPageCount() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var count = this.getDataCountForPagination(props);
	      return (0, _PaginationToolbar.getPageCount)({
	        count: count,
	        limit: props.limit
	      });
	    }
	  }, {
	    key: "hasNextPage",
	    value: function hasNextPage() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      return this.getCurrentPage(props) < this.getPageCount(props);
	    }
	  }, {
	    key: "getCurrentPage",
	    value: function getCurrentPage() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var limit = props.limit,
	        skip = props.skip;
	      return (0, _PaginationToolbar.getCurrentPage)({
	        skip: this.previousSkip ? this.previousSkip : 0,
	        limit: limit
	      });
	    }
	  }, {
	    key: "isLastPage",
	    value: function isLastPage() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	    }
	  }, {
	    key: "getDataCountForPagination",
	    value: function getDataCountForPagination() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var data = this.getData();
	      var count = this.isPaginationEnabled(props) ? props.remoteCount || this.state.remoteCount : data ? data.length : 0;
	      return count || 0;
	    }
	  }, {
	    key: "getFilteredData",
	    value: function getFilteredData() {
	      return this.state.filteredData;
	    }
	  }, {
	    key: "getData",
	    value: function getData() {
	      return this.state.data;
	    }
	  }, {
	    key: "loadLazyDataSource",
	    value: function loadLazyDataSource(_ref4) {
	      var action = _ref4.action,
	        text = _ref4.text;
	      if (!this.props.lazyDataSource) {
	        return null;
	      }
	      var params = {
	        action: action,
	        text: text,
	        value: this.getValue()
	      };
	      this.setData(null);
	      this.loadDataSource(this.props.dataSource, undefined, params);
	      return null;
	    }
	  }, {
	    key: "isPaginationEnabled",
	    value: function isPaginationEnabled() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var hasLoadNextPage = typeof props.loadNextPage === 'function';
	      var hasFunctionalDataSource = typeof props.dataSource === 'function';
	      if (props.enablePagination === false) {
	        return false;
	      }
	      return props.enablePagination ? hasLoadNextPage || hasFunctionalDataSource : hasLoadNextPage;
	    }
	  }, {
	    key: "remoteFilterData",
	    value: function remoteFilterData() {
	      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref5$text = _ref5.text,
	        text = _ref5$text === void 0 ? this.getText() : _ref5$text,
	        _ref5$value = _ref5.value,
	        value = _ref5$value === void 0 ? this.getValue() : _ref5$value,
	        filterType = _ref5.filterType;
	      this.previousSkip = null;
	      this.loadDataSource(this.props.dataSource, undefined, {
	        text: text,
	        skip: 0
	      });
	    }
	  }, {
	    key: "loadNextPage",
	    value: function loadNextPage() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var filteredData = this.getFilteredData();
	      if (filteredData && filteredData.length < 3) {
	        return null;
	      }
	      if (this.previousSkip == null) {
	        this.previousSkip = props.skip;
	      }
	      var limit = props.limit;
	      var hasNextPage = this.hasNextPage();
	      var newSkip = this.previousSkip + limit;
	      this.previousSkip = newSkip;
	      if (!this.isPaginationEnabled()) {
	        return;
	      }
	      var fn = typeof props.dataSource === 'function' ? props.dataSource : null;
	      if (fn && hasNextPage) {
	        var currentData = this.state.data;
	        this.loadDataSource(this.props.dataSource, undefined, {
	          appendTo: currentData,
	          hasNextPage: hasNextPage,
	          skip: newSkip,
	          limit: limit,
	          filter: this.currentFilter
	        });
	      }
	    }
	  }, {
	    key: "isRemoteDataSource",
	    value: function isRemoteDataSource() {
	      return typeof this.props.dataSource === 'function';
	    }
	  }, {
	    key: "isRemoteFilter",
	    value: function isRemoteFilter() {
	      return (0, _typeof2.default)(this.isRemoteDataSource()) && this.props.remoteFilter;
	    }
	  }, {
	    key: "doFilter",
	    value: function doFilter() {
	      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        text = _ref6.text,
	        value = _ref6.value,
	        force = _ref6.force,
	        data = _ref6.data,
	        filterType = _ref6.filterType,
	        action = _ref6.action;
	      if (this.currentFilter === text && !force) {
	        return;
	      }
	      this.currentFilter = text;
	      if (this.isRemoteFilter()) {
	        if (action === 'select') {
	          return;
	        }
	        this.remoteFilterData({
	          value: value,
	          text: text,
	          filterType: filterType
	        });
	      } else {
	        this.updateFilteredData({
	          text: text,
	          value: value,
	          data: data,
	          filterType: filterType
	        });
	      }
	    }
	  }, {
	    key: "updateFilteredData",
	    value: function updateFilteredData() {
	      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref7$text = _ref7.text,
	        text = _ref7$text === void 0 ? this.getText() : _ref7$text,
	        _ref7$value = _ref7.value,
	        value = _ref7$value === void 0 ? this.getValue() : _ref7$value,
	        _ref7$data = _ref7.data,
	        data = _ref7$data === void 0 ? this.state.data : _ref7$data,
	        filterType = _ref7.filterType;
	      var filteredData = data;
	      if (!Array.isArray(filteredData)) {
	        return filteredData;
	      }
	      if (!this.isRemoteFilter()) {
	        filteredData = this.filterDataByText({
	          text: text,
	          data: filteredData
	        });
	        filteredData = this.filterDataByValue({
	          value: value,
	          text: text,
	          data: filteredData
	        });
	      }
	      var isFilteredByText = filterType === 'text' && data.length !== filteredData.length;
	      if (isFilteredByText && this.props.activeFirstItemOnFilter) {
	        var firstItem = filteredData && filteredData[0];
	        if (firstItem) {
	          var id = this.getIdProperty(firstItem);
	          this.setActiveItem(id);
	        } else {
	          this.setActiveItem(null);
	        }
	      }
	      this.setState({
	        filteredData: filteredData
	      });
	    }
	  }, {
	    key: "filterDataByValue",
	    value: function filterDataByValue(_ref8) {
	      var _ref8$value = _ref8.value,
	        value = _ref8$value === void 0 ? this.getValue() : _ref8$value,
	        _ref8$data = _ref8.data,
	        data = _ref8$data === void 0 ? this.state.data : _ref8$data;
	      if (!Array.isArray(data)) {
	        return data;
	      }
	      var newData = data;
	      if (data && value && this.props.removeSelectedItems) {
	        newData = (0, _filterByValue.default)({
	          data: newData,
	          getIdProperty: this.getIdProperty,
	          value: value
	        });
	      }
	      return newData;
	    }
	  }, {
	    key: "filterDataByText",
	    value: function filterDataByText(_ref9) {
	      var _ref9$text = _ref9.text,
	        text = _ref9$text === void 0 ? this.getText() : _ref9$text,
	        _ref9$data = _ref9.data,
	        data = _ref9$data === void 0 ? this.state.data : _ref9$data;
	      if (!data || !text) {
	        return data;
	      }
	      var newData = data;
	      if (this.isFilterTextActive()) {
	        var filterFunction = this.props.filterFunction;
	        newData = (0, _filterByText.default)({
	          data: data,
	          text: text,
	          filterFunction: filterFunction,
	          getFilterProperty: this.getFilterProperty || this.getDisplayProperty,
	          mode: this.props.filterMode,
	          hightlight: this.props.highlightMatchedText
	        });
	      }
	      return newData;
	    }
	  }, {
	    key: "getDataMap",
	    value: function getDataMap() {
	      return this.state.dataMap;
	    }
	  }, {
	    key: "getValueMap",
	    value: function getValueMap() {
	      return this.state.valueMap;
	    }
	  }, {
	    key: "isValueControlled",
	    value: function isValueControlled() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      return props.value !== undefined;
	    }
	  }, {
	    key: "getValue",
	    value: function getValue() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      return this.isValueControlled(props) ? props.value : this.state.value;
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(newValue) {
	      var _ref10 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        action = _ref10.action;
	      if (this.props.disabled) {
	        return null;
	      }
	      if (this.props.readOnly) {
	        return null;
	      }
	      if (this.props.maxValueLength && newValue && newValue.length > this.props.maxValueLength) {
	        return null;
	      }
	      if (this.props.collapseOnSelect && action !== 'navigate') {
	        this.collapse();
	      }
	      if (this.props.autoBlur) {
	        this.blur();
	      }
	      if (!this.isValueControlled()) {
	        this.setState({
	          value: newValue
	        });
	      }
	      this.setText(null, {
	        skipFilter: true
	      });
	      this.updateValueMap({
	        value: newValue
	      });
	      this.props.onChange(newValue);
	    }
	  }, {
	    key: "isFilterTextActive",
	    value: function isFilterTextActive() {
	      var text = this.getText();
	      var data = this.getFilteredData();
	      return data && text && this.props.searchable && text.length >= this.props.filterMinLength;
	    }
	  }, {
	    key: "updateValueMap",
	    value: function updateValueMap(_ref11) {
	      var _this4 = this;
	      var value = _ref11.value,
	        dataMap = _ref11.dataMap,
	        oldValueMap = _ref11.oldValueMap;
	      var newValueMap = (0, _getValueMap.default)({
	        value: value,
	        dataMap: dataMap || this.getDataMap(),
	        oldValueMap: oldValueMap || this.getValueMap()
	      });
	      if (newValueMap) {
	        newValueMap = Object.keys(newValueMap).reduce(function (acc, id) {
	          var item = newValueMap[id];
	          acc[id] = _objectSpread(_objectSpread({}, item), {}, {
	            id: _this4.getIdProperty(item),
	            label: _this4.getDisplayProperty(item) || item
	          });
	          return acc;
	        }, {});
	      }
	      this.setState({
	        valueMap: newValueMap
	      });
	    }
	  }, {
	    key: "selectItem",
	    value: function selectItem(id) {
	      var dataMap = this.getDataMap();
	      var item = dataMap && dataMap[id];
	      if (!item && !this.props.allowCustomTagCreation) {
	        return null;
	      }
	      if (typeof this.props.isSelectedItemValid === 'function') {
	        var isItemValid = this.props.isSelectedItemValid(item);
	        if (!isItemValid) {
	          return null;
	        }
	      }
	      var value = this.getValue();
	      var newValue;
	      if (this.props.multiple) {
	        newValue = (0, _getNewMultipleValue.default)({
	          id: id,
	          value: value
	        });
	      } else {
	        newValue = (0, _getNewSingleValue.default)({
	          id: id,
	          value: value,
	          toggle: this.props.changeValueOnNavigation ? false : this.props.allowSelectionToggle
	        });
	      }
	      this.setValue(newValue, {
	        action: 'select'
	      });
	      this.props.onItemClick({
	        item: item,
	        id: id
	      });
	    }
	  }, {
	    key: "deselectItem",
	    value: function deselectItem(id) {
	      var value = this.getValue();
	      var newValue = (0, _deselectValue.default)({
	        id: id,
	        value: value,
	        getIdProperty: this.getIdProperty
	      });
	      this.setValue(newValue);
	    }
	  }, {
	    key: "deselectItems",
	    value: function deselectItems() {
	      var _this5 = this;
	      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var value = this.getValue();
	      var newValue = ids.reduce(function (acc, id) {
	        acc = (0, _deselectValue.default)({
	          id: id,
	          value: acc,
	          getIdProperty: _this5.getIdProperty
	        });
	        return acc;
	      }, value);
	      this.setValue(newValue);
	    }
	  }, {
	    key: "getExpanded",
	    value: function getExpanded() {
	      return this.isExpandedControlled() ? this.props.expanded : this.expanded != null ? this.expanded : this.state.expanded;
	    }
	  }, {
	    key: "isExpandedControlled",
	    value: function isExpandedControlled() {
	      return this.props.expanded !== undefined;
	    }
	  }, {
	    key: "setExpanded",
	    value: function setExpanded(expanded) {
	      var _this6 = this;
	      if (this.expandedPromise) {
	        this.expandedPromise.then(function (result) {
	          if (_this6.getExpanded() !== expanded) {
	            _this6.setExpanded(expanded);
	          }
	        });
	        return;
	      }
	      this.expandedPromise = this.doSetExpanded(expanded).then(function () {
	        delete _this6.expandedPromise;
	      });
	    }
	  }, {
	    key: "doSetExpanded",
	    value: function doSetExpanded(expanded) {
	      var _this7 = this;
	      if (this.props.disabled) {
	        return Promise.resolve(null);
	      }
	      var currentExpanded = this.getExpanded();
	      if (currentExpanded === expanded) {
	        return Promise.resolve(expanded);
	      }
	      if (!expanded && this.isRemoteFilter()) {
	        this.previousSkip = null;
	      }
	      globalObject.requestAnimationFrame(function () {
	        if (_this7.toolsNode) {
	          _this7.handleToolsSize();
	        }
	      });
	      var promise;
	      if (!this.isExpandedControlled()) {
	        promise = new Promise(function (resolve, reject) {
	          _this7.setState({
	            expanded: expanded
	          }, function () {
	            resolve(expanded);
	          });
	        });
	      } else {
	        promise = Promise.resolve(expanded);
	      }
	      if (expanded) {
	        if (this.isRemoteDataSource() && this.state.data === undefined) {
	          this.loadDataSource(this.props.dataSource);
	        } else {
	          if (this.wasExpandedAtLeastOnce) {
	            this.doFilter({
	              text: '',
	              action: 'expand',
	              force: true
	            });
	          }
	        }
	      }
	      if (expanded && !this.wasExpandedAtLeastOnce) {
	        this.wasExpandedAtLeastOnce = true;
	      }
	      if (expanded) {
	        this.onExpand();
	      } else {
	        this.props.onCollapse();
	      }
	      this.props.onExpandChange(expanded);
	      this.props.onExpandedChange(expanded);
	      return promise;
	    }
	  }, {
	    key: "onExpand",
	    value: function onExpand() {
	      this.props.onExpand();
	      if (this.props.highlightFirst) {
	        var activeItem = this.getActiveItem();
	        if (!activeItem) {
	          var firstItem = this.getItemByIndex(0);
	          if (firstItem) {
	            var id = this.getIdProperty(firstItem);
	            this.setActiveItem(id);
	          }
	        }
	      }
	    }
	  }, {
	    key: "isActiveTagControlled",
	    value: function isActiveTagControlled() {
	      return this.props.activeTag !== undefined;
	    }
	  }, {
	    key: "setActiveTag",
	    value: function setActiveTag(id) {
	      if (this.props.disabled) {
	        return null;
	      }
	      if (!this.isActiveTagControlled()) {
	        this.setState({
	          activeTag: id
	        });
	      }
	      this.props.onActiveTagChange(id);
	    }
	  }, {
	    key: "deselectActiveTag",
	    value: function deselectActiveTag() {
	      var activeTag = this.getActiveTag();
	      if (activeTag) {
	        this.setActiveTag(null);
	      }
	    }
	  }, {
	    key: "getActiveTag",
	    value: function getActiveTag() {
	      return this.isActiveTagControlled() ? this.props.activeTag : this.state.activeTag;
	    }
	  }, {
	    key: "getSelectedItems",
	    value: function getSelectedItems() {
	      var _this8 = this;
	      var valueMap = this.getValueMap();
	      var value = this.getValue();
	      var items = null;
	      if (value) {
	        value = Array.isArray(value) ? value : [value];
	        items = value.map(function (id) {
	          return valueMap[id] || {
	            id: (0, _typeof2.default)(id) === 'object' ? _this8.getIdProperty(id) : id,
	            label: (0, _typeof2.default)(id) === 'object' ? _this8.getDisplayProperty(id) : _this8.getItemLabel(id)
	          };
	        });
	      }
	      return items;
	    }
	  }, {
	    key: "getItemLabel",
	    value: function getItemLabel(id) {
	      id = id === undefined ? this.getValue() : id;
	      var valueMap = this.getValueMap();
	      var dataMap = this.getDataMap();
	      var label;
	      if (valueMap && valueMap[id]) {
	        label = valueMap[id].label;
	      } else if (dataMap && dataMap[id]) {
	        label = this.getDisplayProperty(dataMap[id]);
	      }
	      if (label === undefined) {
	        label = this.props.defaultDisplayValue !== undefined && id != null ? this.props.defaultDisplayValue : id;
	      }
	      return label;
	    }
	  }, {
	    key: "getGroupedItems",
	    value: function getGroupedItems(items) {
	      var maxTagsLength = this.props.maxTagsLength;
	      if (maxTagsLength == null || !items) {
	        return null;
	      }
	      return (0, _groupItems.default)({
	        maxTagsLength: maxTagsLength,
	        items: items
	      });
	    }
	  }, {
	    key: "isActiveItemControlled",
	    value: function isActiveItemControlled() {
	      return this.props.activeItem !== undefined;
	    }
	  }, {
	    key: "setActiveItem",
	    value: function setActiveItem(id) {
	      if (this.props.disabled) {
	        return null;
	      }
	      var activeItem = this.getActiveItem();
	      if (activeItem === id) {
	        return null;
	      }
	      if (!this.isActiveItemControlled()) {
	        var activeItemIndex = null;
	        if (id) {
	          activeItemIndex = this.getItemIndexById(id);
	        }
	        this.setState({
	          activeItemIndex: activeItemIndex,
	          activeItem: id
	        });
	        if (this.props.changeValueOnNavigation && !this.props.multiple) {
	          this.setValue(id, {
	            action: 'navigate'
	          });
	        }
	      }
	      this.scrollToId(id);
	      this.props.onActiveItemChange(id);
	    }
	  }, {
	    key: "getActiveItem",
	    value: function getActiveItem() {
	      return this.isActiveItemControlled() ? this.props.activeItem : this.state.activeItem;
	    }
	  }, {
	    key: "isTextControled",
	    value: function isTextControled() {
	      return this.props.text != null;
	    }
	  }, {
	    key: "getText",
	    value: function getText() {
	      return this.isTextControled() ? this.props.text : this.state.text;
	    }
	  }, {
	    key: "setText",
	    value: function setText(text) {
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyObject;
	      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : emptyFn;
	      if (typeof config === 'function') {
	        callback = config;
	        config = emptyObject;
	      }
	      if (text === this.getText()) {
	        callback();
	        return;
	      }
	      if (!this.isTextControled()) {
	        this.setStateText(text, config, callback);
	      }
	      this.props.onTextChange(text);
	    }
	  }, {
	    key: "setStateText",
	    value: function setStateText(text) {
	      var _this9 = this;
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyObject;
	      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : emptyFn;
	      if (typeof config === 'function') {
	        callback = config;
	        config = emptyObject;
	      }
	      this.setState({
	        text: text
	      }, function () {
	        _this9.onTextUpdate(text, config);
	        callback();
	      });
	    }
	  }, {
	    key: "onTextUpdate",
	    value: function onTextUpdate(text) {
	      var _ref12 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyObject,
	        skipFilter = _ref12.skipFilter;
	      this.clearValueOnEmptyIfNecessary(text);
	      if (!skipFilter) {
	        this.doFilter({
	          text: text,
	          filterType: 'text'
	        });
	      }
	    }
	  }, {
	    key: "clearValueOnEmptyIfNecessary",
	    value: function clearValueOnEmptyIfNecessary(text) {
	      if (this.props.clearValueOnEmpty && !this.props.multiple && text === '') {
	        this.setValue(null);
	      }
	    }
	  }, {
	    key: "getLoading",
	    value: function getLoading() {
	      return this.isLoadingControlled() ? this.props.loading : this.state.loading;
	    }
	  }, {
	    key: "isLoadingControlled",
	    value: function isLoadingControlled() {
	      return this.props.loading != null;
	    }
	  }, {
	    key: "setLoading",
	    value: function setLoading(loading) {
	      if (loading === this.state.loading) {
	        return;
	      }
	      if (!this.isLoadingControlled()) {
	        this.setState({
	          loading: loading
	        });
	      }
	      this.props.onLoadingChange(loading);
	    }
	  }, {
	    key: "handleComboClick",
	    value: function handleComboClick(event) {
	      event.preventDefault();
	      if (this.props.toggleExpandOnClick) {
	        this.toggleExpand();
	      } else if (this.props.expandOnClick) {
	        this.expand();
	      }
	      if (this.props.focusOnClick && !this.hasFocus()) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter() {
	      this.setState({
	        over: true
	      });
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave() {
	      this.setState({
	        over: false
	      });
	    }
	  }, {
	    key: "handleComboFocus",
	    value: function handleComboFocus() {
	      if (this.props.expandOnFocus) {
	        this.expand();
	      }
	      this.setState({
	        focus: true
	      });
	      this.props.onFocus();
	    }
	  }, {
	    key: "handleComboBlur",
	    value: function handleComboBlur(event) {
	      var _this10 = this;
	      if (this.isFocused() && event && event.relatedTarget && (0, _containsNode.default)(this.comboNode, event.relatedTarget)) {
	        globalObject.requestAnimationFrame(function () {
	          _this10.focus();
	        });
	        return;
	      }
	      if (this.props.collapseOnBlur) {
	        this.collapse();
	      }
	      if (this.props.clearTextOnBlur) {
	        this.setText(null);
	      }
	      this.setState({
	        focus: false
	      });
	      this.props.onBlur();
	    }
	  }, {
	    key: "isFocused",
	    value: function isFocused() {
	      return this.state.focus;
	    }
	  }, {
	    key: "handleItemClick",
	    value: function handleItemClick(id) {
	      if (!this.isFocused() && this.props.focusOnClick) {
	        this.focus();
	      }
	      this.setActiveItem(id);
	      this.selectItem(id);
	    }
	  }, {
	    key: "handleTextChange",
	    value: function handleTextChange(text) {
	      var _this11 = this;
	      this.deselectActiveTag();
	      this.setText(text, {
	        skipFilter: this.props.expandOnTextChange && !this.getExpanded()
	      }, function () {
	        if (_this11.props.expandOnTextChange) {
	          _this11.expand();
	        }
	      });
	    }
	  }, {
	    key: "handleTextInputClick",
	    value: function handleTextInputClick() {
	      this.deselectActiveTag();
	    }
	  }, {
	    key: "handleRemoveTag",
	    value: function handleRemoveTag(id) {
	      this.removeTag(id);
	    }
	  }, {
	    key: "handleRemoveMultipleTag",
	    value: function handleRemoveMultipleTag(ids) {
	      this.deselectItems(ids);
	    }
	  }, {
	    key: "handleListScrollBottom",
	    value: function handleListScrollBottom() {
	      this.loadNextPage();
	    }
	  }, {
	    key: "removeTag",
	    value: function removeTag(id) {
	      var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
	      var activeTag = this.getActiveTag();
	      if (activeTag === id && activeTag != null) {
	        var value = this.getValue();
	        var newActiveTag = (0, _getNewActiveTagOnRemove.default)({
	          id: id,
	          value: value,
	          dir: dir
	        });
	        this.setActiveTag(newActiveTag);
	      }
	      this.deselectItem(id);
	    }
	  }, {
	    key: "removeRemainingTags",
	    value: function removeRemainingTags() {
	      var ids = this.groupedItems.remainingItems.map(function (item) {
	        return item.id;
	      });
	      var visibleItems = this.groupedItems.visibleItems;
	      var activeTag = this.getActiveTag();
	      if (activeTag === REMAINING_ITEMS) {
	        var lastItem = Array.isArray(visibleItems) && visibleItems[visibleItems.length - 1];
	        if (lastItem) {
	          this.setActiveTag(lastItem.id);
	        }
	      } else {
	        this.deselectActiveTag();
	      }
	      this.removeTags(ids);
	    }
	  }, {
	    key: "removeTags",
	    value: function removeTags(ids) {
	      this.deselectItems(ids);
	    }
	  }, {
	    key: "handleTagClick",
	    value: function handleTagClick(id) {
	      var activeTag = this.getActiveTag();
	      if (activeTag === id) {
	        this.setActiveTag(null);
	      } else {
	        this.setActiveTag(id);
	      }
	      this.props.onTagClick(this.getItemById(id));
	      if (this.props.focusOnClick && !this.hasFocus()) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "handleComboMouseDown",
	    value: function handleComboMouseDown(event) {
	      event.preventDefault();
	    }
	  }, {
	    key: "handleComboKeyDown",
	    value: function handleComboKeyDown(event) {
	      if (this.props.allowCustomTagCreation && event.key === 'Enter') {
	        if (this.isNewCustomTagValid) {
	          this.selectItem(this.getText());
	          this.setText(null);
	        }
	      }
	      if (this.props.enableNavigation) {
	        if (this.props.enableListNavigation) {
	          switch (event.key) {
	            case 'ArrowDown':
	              this.navigateToNextItem(1, event);
	              break;
	            case 'ArrowUp':
	              this.navigateToNextItem(-1, event);
	              break;
	            case 'Enter':
	              this.handleEnterKeyPress(event);
	              break;
	            case 'Space':
	              this.selectActiveItem();
	              break;
	          }
	        }
	        if (this.props.enableTagNavigation) {
	          switch (event.key) {
	            case 'ArrowLeft':
	              this.navigateToNextTag(-1, event);
	              break;
	            case 'ArrowRight':
	              this.navigateToNextTag(1, event);
	              break;
	            case 'Backspace':
	              this.handleBackspace(event);
	              break;
	            case 'Delete':
	              this.handleDelete(event);
	          }
	        }
	      }
	      if (event.key === 'Escape') {
	        var expanded = this.getExpanded();
	        if (this.props.collapseOnEscape) {
	          if (expanded) {
	            this.collapse();
	          }
	        }
	        if (!expanded && this.getActiveTag()) {
	          this.setActiveTag(null);
	        }
	        if (!this.props.multiple) {
	          this.setText(null);
	        }
	      }
	      if (this.props.onKeyDown) {
	        this.props.onKeyDown(event, this);
	      }
	    }
	  }, {
	    key: "navigateToNextItem",
	    value: function navigateToNextItem(direction, event) {
	      var data = this.getFilteredData();
	      if (event && event.preventDefault) {
	        event.preventDefault();
	      }
	      if (this.getExpanded()) {
	        var activeItem = this.getActiveItem();
	        var newActiveItem;
	        if (activeItem != null) {
	          newActiveItem = (0, _getNextItem.default)({
	            direction: direction,
	            data: data,
	            id: activeItem,
	            activeItem: activeItem,
	            getIdProperty: this.getIdProperty
	          });
	        } else {
	          var firstItemId;
	          var lastItemId;
	          if (data && data.length) {
	            firstItemId = this.getIdProperty(data[0]);
	            lastItemId = this.getIdProperty(data[data.length - 1]);
	            if (direction && firstItemId != null) {
	              newActiveItem = firstItemId;
	            }
	            if (direction === -1 && lastItemId != null) {
	              newActiveItem = lastItemId;
	            }
	          }
	        }
	        this.setActiveItem(newActiveItem);
	      } else {
	        this.expand();
	      }
	    }
	  }, {
	    key: "selectActiveItem",
	    value: function selectActiveItem() {
	      var activeItem = this.getActiveItem();
	      if (activeItem) {
	        this.selectItem(activeItem);
	      }
	    }
	  }, {
	    key: "handleEnterKeyPress",
	    value: function handleEnterKeyPress(event) {
	      var expanded = this.getExpanded();
	      if (expanded) {
	        this.selectActiveItem();
	      }
	      var activeItem = this.getActiveItem();
	      if (this.props.collapseOnSelectWithEnter) {
	        if (activeItem && expanded) {
	          this.collapse();
	        }
	      }
	      if (this.props.navigateToNextAfterSelection && this.props.multiple && activeItem) {
	        this.navigateToNextItem(1, event);
	      }
	    }
	  }, {
	    key: "navigateToNextTag",
	    value: function navigateToNextTag(direction, event) {
	      if (!this.isNavigationAllowed(direction)) {
	        return null;
	      }
	      if (event && event.preventDefault) {
	        event.preventDefault();
	      }
	      var newActiveTag;
	      var items = this.getSelectedItems();
	      var itemsIds;
	      if (this.areItemsGrouped) {
	        var visibleItems = this.groupedItems.visibleItems.map(function (item) {
	          return item.id;
	        });
	        itemsIds = [].concat((0, _toConsumableArray2.default)(visibleItems), [REMAINING_ITEMS]);
	      } else {
	        itemsIds = items.map(function (item) {
	          return item.id;
	        });
	      }
	      var currentActiveTag = this.getActiveTag();
	      var currentIndex = itemsIds.indexOf(currentActiveTag);
	      var lastIndex = itemsIds.length - 1;
	      var lastTag = itemsIds[lastIndex];
	      var firstTag = itemsIds[0];
	      var isFirstTag = currentIndex === 0;
	      var isLastTag = currentIndex === lastIndex;
	      if (direction === -1 && isFirstTag) {
	        this.setActiveTag(null);
	        return null;
	      }
	      if (direction === 1 && isLastTag) {
	        this.setActiveTag(null);
	        return null;
	      }
	      if (currentActiveTag === null || currentIndex === -1) {
	        newActiveTag = direction === -1 ? lastTag : firstTag;
	      } else {
	        if (direction === -1) {
	          newActiveTag = isFirstTag ? lastTag : itemsIds[currentIndex - 1];
	        } else if (direction === 1) {
	          newActiveTag = isLastTag ? firstTag : itemsIds[currentIndex + 1];
	        }
	      }
	      this.setActiveTag(newActiveTag);
	      return null;
	    }
	  }, {
	    key: "isNavigationAllowed",
	    value: function isNavigationAllowed(direction) {
	      if (!this.props.multiple) {
	        return false;
	      }
	      var inputNode = this.getTextInputNode();
	      if (inputNode.hasSelection()) {
	        return false;
	      }
	      var currentActiveTag = this.getActiveTag();
	      var canNavigateLeft = inputNode.isCursorAtStartPosition() && direction === -1;
	      var canNavigateRight = inputNode.isCursorAtEndPosition() && direction === 1;
	      if (!canNavigateRight && !canNavigateLeft && !currentActiveTag) {
	        return false;
	      }
	      var items = this.getSelectedItems();
	      if (!Array.isArray(items)) {
	        return false;
	      }
	      if (items.length === 1 && currentActiveTag) {
	        this.setActiveTag(null);
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: "handleBackspace",
	    value: function handleBackspace(event) {
	      if (this.props.multiple) {
	        this.handleTagBackspaceRemove(event);
	      }
	    }
	  }, {
	    key: "handleDelete",
	    value: function handleDelete(event) {
	      var activeTag = this.getActiveTag();
	      if (this.props.multiple && activeTag) {
	        this.removeTag(activeTag, 1);
	      }
	    }
	  }, {
	    key: "handleTagBackspaceRemove",
	    value: function handleTagBackspaceRemove(event) {
	      if (!this.props.removeTagOnBackspace) {
	        return null;
	      }
	      var value = this.getValue();
	      if (!value) {
	        return null;
	      }
	      var activeTag = this.getActiveTag();
	      if (activeTag != null) {
	        event.preventDefault();
	        if (activeTag === REMAINING_ITEMS) {
	          this.removeRemainingTags();
	        } else {
	          this.removeTag(activeTag, -1);
	        }
	        return null;
	      }
	      var inputNode = this.getTextInputNode();
	      var canDeleteTag = value && value.length && inputNode.isCursorAtStartPosition();
	      if (canDeleteTag) {
	        if (this.areItemsGrouped) {
	          var ids = this.groupedItems.remainingItems.map(function (item) {
	            return item.id;
	          });
	          this.removeTags(ids);
	        } else {
	          var items = this.getSelectedItems();
	          var lastItem = items[items.length - 1];
	          var lastItemId = lastItem.id;
	          if (this.props.keepTagTextOnRemove) {
	            var label = lastItem.label;
	            if (label && typeof label === 'string') {
	              this.setText(label);
	            }
	          }
	          this.removeTag(lastItemId);
	        }
	      }
	      return null;
	    }
	  }, {
	    key: "handleToolsSize",
	    value: function handleToolsSize() {
	      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.toolsNode ? this.toolsNode.getBoundingClientRect() : {
	        width: 0,
	        height: 0
	      };
	      var node = this.comboNode;
	      var computedStyle = globalObject.getComputedStyle(node);
	      var width = size.width + parseInt(computedStyle.paddingLeft, 10) + parseInt(computedStyle.paddingRight, 10);
	      this.setState({
	        toolsSize: {
	          height: size.height,
	          width: width
	        }
	      });
	    }
	  }, {
	    key: "expand",
	    value: function expand() {
	      this.setExpanded(true);
	    }
	  }, {
	    key: "collapse",
	    value: function collapse() {
	      this.setExpanded(false);
	    }
	  }, {
	    key: "scrollToIndex",
	    value: function scrollToIndex(index) {
	      var listNode = this.getListNode();
	      return listNode && listNode.scrollToIndex(index);
	    }
	  }, {
	    key: "getItemIndexById",
	    value: function getItemIndexById(id) {
	      var index = (0, _findItemIndex.default)({
	        id: id,
	        data: this.getFilteredData(),
	        getIdProperty: this.getIdProperty
	      });
	      return index;
	    }
	  }, {
	    key: "scrollToId",
	    value: function scrollToId(id) {
	      var index = this.getItemIndexById(id);
	      if (index != null) {
	        this.scrollToIndex(index);
	      }
	    }
	  }, {
	    key: "toggleExpand",
	    value: function toggleExpand() {
	      var expanded = this.getExpanded();
	      if (expanded) {
	        this.collapse();
	      } else {
	        this.expand();
	      }
	    }
	  }, {
	    key: "getItemByIndex",
	    value: function getItemByIndex(index) {
	      var data = this.getFilteredData();
	      if (!data || !Array.isArray(data) || !data[index]) {
	        return null;
	      }
	      return data[index];
	    }
	  }, {
	    key: "getItemById",
	    value: function getItemById(id) {
	      var dataMap = this.getDataMap();
	      return dataMap && dataMap[id] || id;
	    }
	  }, {
	    key: "updateGetIdProperty",
	    value: function updateGetIdProperty(props) {
	      props = props || this.props;
	      this.getIdProperty = (0, _getDataProp.default)(props.idProperty);
	    }
	  }, {
	    key: "updateGetDisplayProperty",
	    value: function updateGetDisplayProperty(props) {
	      props = props || this.props;
	      this.getDisplayProperty = (0, _getDataProp.default)(props.displayProperty);
	    }
	  }, {
	    key: "updateGetFilterProperty",
	    value: function updateGetFilterProperty(props) {
	      props = props || this.props;
	      this.getFilterProperty = (0, _getDataProp.default)(props.filterProperty);
	    }
	  }, {
	    key: "updateGroups",
	    value: function updateGroups(_ref13) {
	      var _ref13$groupProperty = _ref13.groupProperty,
	        groupProperty = _ref13$groupProperty === void 0 ? this.props.groupProperty : _ref13$groupProperty,
	        _ref13$data = _ref13.data,
	        data = _ref13$data === void 0 ? this.getFilteredData() : _ref13$data;
	      if (!data) {
	        return null;
	      }
	      var groups = (0, _getGroups.default)(data, groupProperty);
	      this.setState({
	        groups: groups
	      });
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      var textInput = this.getTextInputNode();
	      if (textInput && textInput.focus && !this.hasFocus()) {
	        textInput.focus();
	      }
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      var textInput = this.getTextInputNode();
	      if (textInput && textInput.blur) {
	        textInput.blur();
	      }
	    }
	  }, {
	    key: "hasFocus",
	    value: function hasFocus() {
	      var textInput = this.getTextInputNode();
	      if (textInput && textInput.hasFocus) {
	        return textInput.hasFocus();
	      }
	      return false;
	    }
	  }, {
	    key: "getTextInputNode",
	    value: function getTextInputNode() {
	      return this.textInput;
	    }
	  }, {
	    key: "getComboNode",
	    value: function getComboNode() {
	      return this.comboNode;
	    }
	  }, {
	    key: "getListNode",
	    value: function getListNode() {
	      return this.listNode;
	    }
	  }, {
	    key: "getVirtualListNode",
	    value: function getVirtualListNode() {
	      return this.listNode && this.listNode.getVirtualListNode();
	    }
	  }, {
	    key: "getlListNode",
	    value: function getlListNode() {
	      return this.listNode && this.listNode.getlListNode();
	    }
	  }, {
	    key: "addItem",
	    value: function addItem(item) {
	      var newData = [].concat((0, _toConsumableArray2.default)(this.getData()), [item]);
	      this.setData(newData);
	    }
	  }, {
	    key: "clear",
	    value: function clear() {
	      var _this12 = this;
	      this.setValue(null);
	      this.setText(null);
	      globalObject.requestAnimationFrame(function () {
	        if (_this12.toolsNode) {
	          _this12.handleToolsSize();
	        }
	      });
	    }
	  }, {
	    key: "getItem",
	    value: function getItem(id) {
	      return this.getItemById(id);
	    }
	  }, {
	    key: "getItemCount",
	    value: function getItemCount() {
	      var data = this.getData();
	      return Array.isArray(data) ? data.length : null;
	    }
	  }, {
	    key: "insertItem",
	    value: function insertItem(_ref14) {
	      var index = _ref14.index,
	        item = _ref14.item;
	      var data = this.getData();
	      var newData = [].concat((0, _toConsumableArray2.default)(data.slice(0, index)), [item], (0, _toConsumableArray2.default)(data.slice(index)));
	      this.setData(newData);
	    }
	  }, {
	    key: "removeItems",
	    value: function removeItems(ids) {
	      var _this13 = this;
	      ids = Array.isArray(ids) ? ids : [ids];
	      var data = this.getData();
	      var newData = data.filter(function (item) {
	        var id = _this13.getIdProperty(item);
	        return ids.indexOf(id) === -1;
	      });
	      this.setData(newData);
	    }
	  }, {
	    key: "toggle",
	    value: function toggle() {
	      var expanded = this.getExpanded();
	      this.setExpanded(!expanded);
	    }
	  }]);
	  return InovuaComboBox;
	}(_react.Component);
	function emptyFn() {}
	InovuaComboBox.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-combo-box',
	  inlineFlex: false,
	  itemEllipsis: true,
	  borderRadius: 0,
	  shadow: true,
	  showShadowOnMouseOver: false,
	  clearTextOnBlur: true,
	  onKeyDown: emptyFn,
	  autoFocus: false,
	  autoBlur: false,
	  focusOnClick: true,
	  onFocus: emptyFn,
	  onBlur: emptyFn,
	  defaultActiveItem: null,
	  highlightFirst: false,
	  onTextChange: emptyFn,
	  searchable: true,
	  tagCloseIconPosition: 'end',
	  removeTagOnBackspace: true,
	  tagEllipsis: true,
	  filterMinLength: 0,
	  filterDelay: 300,
	  activeFirstItemOnFilter: true,
	  clearIcon: true,
	  toggleIcon: true,
	  showClearIconOnMouseOver: false,
	  clearTextOnSelect: true,
	  filterMode: 'contains',
	  highlightMatchedText: false,
	  onActiveTagChange: emptyFn,
	  enableTagNavigation: true,
	  onTagClick: emptyFn,
	  onActiveItemChange: emptyFn,
	  keepTagTextOnRemove: true,
	  onItemClick: emptyFn,
	  onChange: emptyFn,
	  minAutocompleteLength: 3,
	  autocompleteDelay: 300,
	  autocomplete: false,
	  defaultValue: null,
	  multiple: false,
	  removeSelectedItems: false,
	  allowSelectionToggle: true,
	  clearValueOnEmpty: true,
	  onDataSourceLoad: emptyFn,
	  idProperty: 'id',
	  displayProperty: 'label',
	  groupProperty: 'group',
	  limit: 50,
	  skip: 0,
	  onLoadingChange: emptyFn,
	  listLoadingText: 'Loading...',
	  loadingSpinner: true,
	  listEmptyText: 'No data found',
	  defaultText: null,
	  defaultExpanded: false,
	  onExpandedChange: emptyFn,
	  onExpandChange: emptyFn,
	  collapseOnEscape: true,
	  expandOnClick: true,
	  expandOnFocus: true,
	  collapseOnBlur: true,
	  onExpand: emptyFn,
	  onCollapse: emptyFn,
	  expandOnTextChange: true,
	  toggleExpandOnClick: true,
	  wrapMultiple: true,
	  theme: 'default-light',
	  enableNavigation: true,
	  enableListNavigation: true,
	  navigateToNextAfterSelection: true,
	  positions: ['bottom', 'top'],
	  offset: 2,
	  constrainTo: true
	};
	var VALUE_TYPE = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object, _propTypes.default.bool]))]);
	InovuaComboBox.propTypes = {
	  rootClassName: _propTypes.default.string,
	  theme: _propTypes.default.string,
	  inlineFlex: _propTypes.default.bool,
	  shouldComponentUpdate: _propTypes.default.func,
	  lazyDataSource: _propTypes.default.bool,
	  remoteFilter: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  readOnly: _propTypes.default.bool,
	  rtl: _propTypes.default.bool,
	  tabIndex: _propTypes.default.number,
	  collapseOnSelect: _propTypes.default.bool,
	  clearTextOnBlur: _propTypes.default.bool,
	  listEmptyText: _propTypes.default.node,
	  listMaxHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  listMinHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  maxTagsLength: _propTypes.default.number,
	  defaultLoading: _propTypes.default.bool,
	  loading: _propTypes.default.bool,
	  onLoadingChange: _propTypes.default.func,
	  listLoadingText: _propTypes.default.node,
	  loadingSpinner: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.bool]),
	  onKeyDown: _propTypes.default.func,
	  onTagClick: _propTypes.default.func,
	  clearIcon: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func, _propTypes.default.node]),
	  toggleIcon: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func, _propTypes.default.node]),
	  showClearIconOnMouseOver: _propTypes.default.bool,
	  autoFocus: _propTypes.default.bool,
	  autoBlur: _propTypes.default.bool,
	  focusOnClick: _propTypes.default.bool,
	  onFocus: _propTypes.default.func,
	  onBlur: _propTypes.default.func,
	  borderRadius: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  padding: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  border: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  background: _propTypes.default.string,
	  shadow: _propTypes.default.bool,
	  showShadowOnMouseOver: _propTypes.default.bool,
	  emptyClassName: _propTypes.default.string,
	  emptyStyle: _propTypes.default.object,
	  disabledClassName: _propTypes.default.string,
	  disabledStyle: _propTypes.default.object,
	  focusedClassName: _propTypes.default.string,
	  focusedStyle: _propTypes.default.object,
	  itemBackground: _propTypes.default.string,
	  disabledItemStyle: _propTypes.default.object,
	  disabledItemClassName: _propTypes.default.string,
	  renderItem: _propTypes.default.func,
	  itemEllipsis: _propTypes.default.bool,
	  activeItemStyle: _propTypes.default.object,
	  activeItemClassName: _propTypes.default.string,
	  selectedItemStyle: _propTypes.default.object,
	  limit: _propTypes.default.number,
	  skip: _propTypes.default.number,
	  loadNextPage: _propTypes.default.func,
	  searchable: _propTypes.default.bool,
	  placeholder: _propTypes.default.node,
	  text: _propTypes.default.string,
	  defaultText: _propTypes.default.string,
	  onTextChange: _propTypes.default.func,
	  filterFunction: _propTypes.default.func,
	  filterProperty: _propTypes.default.string,
	  loadLazyDataSource: _propTypes.default.func,
	  filterMinLength: _propTypes.default.number,
	  filterDelay: _propTypes.default.number,
	  activeFirstItemOnFilter: _propTypes.default.bool,
	  renderInput: _propTypes.default.func,
	  inputClassName: _propTypes.default.string,
	  inputStyle: _propTypes.default.object,
	  clearTextOnSelect: _propTypes.default.bool,
	  filterMode: _propTypes.default.oneOf(['startsWith', 'contains']),
	  highlightMatchedText: _propTypes.default.bool,
	  autocomplete: _propTypes.default.bool,
	  minAutocompleteLength: _propTypes.default.number,
	  autocompleteDelay: _propTypes.default.number,
	  enableNavigatio: _propTypes.default.bool,
	  keepTagTextOnRemove: _propTypes.default.bool,
	  tagActiveStyle: _propTypes.default.object,
	  enableTagNavigation: _propTypes.default.bool,
	  activeTag: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  defaultActiveTag: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  onActiveTagChange: _propTypes.default.func,
	  allowCustomTagCreation: _propTypes.default.bool,
	  enableNavigation: _propTypes.default.bool,
	  enableListNavigation: _propTypes.default.bool,
	  highlightFirst: _propTypes.default.bool,
	  activeItem: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  defaultActiveItem: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  onActiveItemChange: _propTypes.default.func,
	  navigateToNextAfterSelection: _propTypes.default.bool,
	  onItemClick: _propTypes.default.func,
	  onChange: _propTypes.default.func,
	  listClassName: _propTypes.default.string,
	  selectedStyle: _propTypes.default.object,
	  selectedClassName: _propTypes.default.string,
	  renderGroup: _propTypes.default.func,
	  renderFooter: _propTypes.default.func,
	  renderHeader: _propTypes.default.func,
	  renderList: _propTypes.default.func,
	  renderListComponent: _propTypes.default.func,
	  value: VALUE_TYPE,
	  defaultValue: VALUE_TYPE,
	  defaultDisplayValue: VALUE_TYPE,
	  removeSelectedItems: _propTypes.default.bool,
	  isSelectedItemValid: _propTypes.default.func,
	  maxValueLength: _propTypes.default.number,
	  changeValueOnNavigation: _propTypes.default.bool,
	  allowSelectionToggle: _propTypes.default.bool,
	  clearSelectedOnTextChange: _propTypes.default.bool,
	  clearValueOnEmpty: _propTypes.default.bool,
	  isNewCustomTagValid: _propTypes.default.func,
	  multiple: _propTypes.default.bool,
	  renderTag: _propTypes.default.func,
	  renderTagLabel: _propTypes.default.func,
	  renderRemainingTags: _propTypes.default.func,
	  renderTags: _propTypes.default.func,
	  tagStyle: _propTypes.default.object,
	  tagBorder: _propTypes.default.string,
	  tagPadding: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  tagHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  tagWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  tagMinSize: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
	    height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  })]),
	  tagMaxSize: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
	    height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  })]),
	  tagCloseIcon: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node, _propTypes.default.func]),
	  tagCloseIconPosition: _propTypes.default.oneOf(['start', 'end']),
	  tagEllipsis: _propTypes.default.bool,
	  removeTagOnBackspace: _propTypes.default.bool,
	  renderDisplayValue: _propTypes.default.func,
	  dataSource: function dataSource(props, propName) {
	    var dataSource = props[propName];
	    if (dataSource != null && typeof dataSource !== 'function' && !Array.isArray(dataSource) && !(dataSource && dataSource.then)) {
	      return new Error('dataSource must be an array, null, a promise or a function returning a promise.');
	    }
	    return null;
	  },
	  onDataSourceLoad: _propTypes.default.func,
	  idProperty: _propTypes.default.string,
	  displayProperty: _propTypes.default.string,
	  groupProperty: _propTypes.default.string,
	  listStyle: _propTypes.default.object,
	  relativeToViewport: _propTypes.default.bool,
	  expanded: _propTypes.default.bool,
	  defaultExpanded: _propTypes.default.bool,
	  onExpandedChange: _propTypes.default.func,
	  onExpandChange: _propTypes.default.func,
	  collapseOnEscape: _propTypes.default.bool,
	  expandOnClick: _propTypes.default.bool,
	  expandOnFocus: _propTypes.default.bool,
	  collapseOnBlur: _propTypes.default.bool,
	  enablePagination: _propTypes.default.bool,
	  onExpand: _propTypes.default.func,
	  onCollapse: _propTypes.default.func,
	  virtualListFactory: _propTypes.default.func,
	  renderListScroller: _propTypes.default.func,
	  renderVirtualList: _propTypes.default.func,
	  expandOnTextChange: _propTypes.default.bool,
	  toggleExpandOnClick: _propTypes.default.bool,
	  collapseOnSelectWithEnter: _propTypes.default.bool,
	  wrapMultiple: _propTypes.default.bool,
	  newCustomTagText: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	  positions: _propTypes.default.arrayOf(_propTypes.default.string),
	  constrainTo: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object, _propTypes.default.bool]),
	  offset: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }), _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  })]))])
	};
	var _default = InovuaComboBox;
	exports.default = _default;

/***/ },
/* 242 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function findItemIndex(_ref) {
	  var id = _ref.id,
	    data = _ref.data,
	    getIdProperty = _ref.getIdProperty;
	  if (!Array.isArray(data) || !getIdProperty || id == null) {
	    return null;
	  }
	  var filteredList = data.reduce(function (acc, item, index) {
	    if (getIdProperty(item) === id) {
	      acc = index;
	    }
	    return acc;
	  }, null);
	  return filteredList !== null ? filteredList : null;
	}
	var _default = findItemIndex;
	exports.default = _default;

/***/ },
/* 243 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function isSelected(_ref) {
	  var id = _ref.id,
	    value = _ref.value;
	  if (Array.isArray(value)) {
	    return value.indexOf(id) !== -1;
	  }
	  return id === value;
	}
	var _default = isSelected;
	exports.default = _default;

/***/ },
/* 244 */
[1296, 681],
/* 245 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(props) {
	  delete props.display;
	  delete props.shouldComponentUpdate;
	  delete props.wrap;
	  delete props.row;
	  delete props.column;
	  delete props.alignItems;
	  delete props.alignSelf;
	  delete props.alignContent;
	  delete props.justifyContent;
	  delete props.flex;
	  delete props.flexGrow;
	  delete props.flexFlow;
	  delete props.flexShrink;
	  delete props.flexBasis;
	  delete props.inline;
	  delete props.wrap;
	};
	exports.default = _default;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _props2flex = _interopRequireDefault(__webpack_require__(686));
	var _prefix = _interopRequireDefault(__webpack_require__(685));
	var PREFIX = _prefix.default;
	var _default = function _default(props) {
	  var column = !!props.column;
	  var row = !column && !!props.row;
	  var reverse = props.reverse ? '-reverse' : '';
	  var flex = (0, _props2flex.default)(props);
	  var flexGrow = props.flexGrow;
	  var flexShrink = props.flexShrink;
	  var flexBasis = props.flexBasis;
	  var display = props.inline ? 'inline-flex' : props.display;
	  var className = (0, _join.default)(props.className, props.alignItems ? "".concat(PREFIX, "--align-items-").concat(props.alignItems) : null, props.alignContent ? "".concat(PREFIX, "--align-content-").concat(props.alignContent) : null, props.justifyContent ? "".concat(PREFIX, "--justify-content-").concat(props.justifyContent) : null, props.wrap ? "".concat(PREFIX, "--wrap") : null, props.alignSelf ? "".concat(PREFIX, "--align-self-").concat(props.alignSelf) : null, row ? "".concat(PREFIX, "--row").concat(reverse) : null, column ? "".concat(PREFIX, "--column").concat(reverse) : null, flex != null ? "".concat(PREFIX, "--flex-").concat(flex) : null, flexGrow != null ? "".concat(PREFIX, "--flex-grow-").concat(flexGrow) : null, flexShrink != null ? "".concat(PREFIX, "--flex-shrink-").concat(flexShrink) : null, flexBasis != null ? "".concat(PREFIX, "--flex-basis-").concat(flexBasis) : null, display != null ? "".concat(PREFIX, "--display-").concat(display) : null);
	  return className;
	};
	exports.default = _default;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _isMobile = _interopRequireDefault(__webpack_require__(72));
	var _clamp = _interopRequireDefault(__webpack_require__(81));
	var _containsNode = _interopRequireDefault(__webpack_require__(71));
	var _matchesSelector = _interopRequireDefault(__webpack_require__(143));
	function ypos(e) {
	  if (e.targetTouches && e.targetTouches.length >= 1) {
	    return e.targetTouches[0].clientY;
	  }
	  return e.clientY;
	}
	var InertialManager = function () {
	  function InertialManager(_ref) {
	    var node = _ref.node,
	      viewNode = _ref.viewNode,
	      arrowSelector = _ref.arrowSelector,
	      _ref$threshold = _ref.threshold,
	      threshold = _ref$threshold === void 0 ? 5 : _ref$threshold,
	      _ref$timeConstant = _ref.timeConstant,
	      timeConstant = _ref$timeConstant === void 0 ? 360 : _ref$timeConstant,
	      _ref$initialAmplitude = _ref.initialAmplitude,
	      initialAmplitude = _ref$initialAmplitude === void 0 ? 0.8 : _ref$initialAmplitude,
	      _ref$enableMouseDrag = _ref.enableMouseDrag,
	      enableMouseDrag = _ref$enableMouseDrag === void 0 ? true : _ref$enableMouseDrag,
	      _ref$enableTouchDrag = _ref.enableTouchDrag,
	      enableTouchDrag = _ref$enableTouchDrag === void 0 ? true : _ref$enableTouchDrag,
	      _ref$setScrollPositio = _ref.setScrollPosition,
	      setScrollPosition = _ref$setScrollPositio === void 0 ? function () {} : _ref$setScrollPositio;
	    (0, _classCallCheck2.default)(this, InertialManager);
	    this.node = node;
	    this.viewNode = viewNode;
	    if (!arrowSelector) {
	      throw 'Please provide an arrowselector';
	    }
	    this.arrowSelector = arrowSelector;
	    this.tap = this.tap.bind(this);
	    this.drag = this.drag.bind(this);
	    this.release = this.release.bind(this);
	    this.track = this.track.bind(this);
	    this.autoScroll = this.autoScroll.bind(this);
	    this.min = 0;
	    this.max = null;
	    this.pressed = null;
	    this.reference = null;
	    this.offset = 0;
	    this.threshold = threshold;
	    this.timeConstant = timeConstant;
	    this.enableTouchDrag = enableTouchDrag;
	    this.enableMouseDrag = enableMouseDrag;
	    this.setScrollPosition = setScrollPosition;
	    this.initialAmplitude = initialAmplitude;
	    this.updateMaxScroll();
	    this.addEventListeners();
	  }
	  (0, _createClass2.default)(InertialManager, [{
	    key: "addEventListeners",
	    value: function addEventListeners() {
	      if (!this.node || !this.node.addEventListener) {
	        return;
	      }
	      if (_isMobile.default && this.enableTouchDrag) {
	        this.node.addEventListener('touchstart', this.tap, {
	          passive: false
	        });
	        this.node.addEventListener('touchend', this.release, {
	          passive: false
	        });
	        this.node.addEventListener('touchmove', this.drag, {
	          passive: false
	        });
	      }
	      if (!_isMobile.default && this.enableMouseDrag) {
	        this.node.addEventListener('mousedown', this.tap, {
	          passive: false
	        });
	        this.node.addEventListener('mouseup', this.release, {
	          passive: false
	        });
	        this.node.addEventListener('mousemove', this.drag, {
	          passive: false
	        });
	      }
	    }
	  }, {
	    key: "removeEventListeners",
	    value: function removeEventListeners() {
	      if (this.node && this.node.removeEventListener) {
	        this.node.removeEventListener('touchstart', this.tap, {
	          passive: false
	        });
	        this.node.removeEventListener('touchend', this.release, {
	          passive: false
	        });
	        this.node.removeEventListener('touchmove', this.drag, {
	          passive: false
	        });
	        this.node.removeEventListener('mousedown', this.tap, {
	          passive: false
	        });
	        this.node.removeEventListener('mouseup', this.release, {
	          passive: false
	        });
	        this.node.removeEventListener('mousemove', this.drag, {
	          passive: false
	        });
	      }
	    }
	  }, {
	    key: "getEventListneres",
	    value: function getEventListneres() {
	      var events;
	      if (_isMobile.default && this.enableTouchDrag) {
	        events = {
	          onTouchStart: this.tap,
	          onTouchEnd: this.release,
	          onTouchMove: this.drag
	        };
	      }
	      if (!_isMobile.default && this.enableMouseDrag) {
	        events = {
	          onMouseDown: this.tap,
	          onMouseUp: this.release,
	          onMouseMove: this.drag
	        };
	      }
	      return events;
	    }
	  }, {
	    key: "isArrowTarget",
	    value: function isArrowTarget(target) {
	      if ((0, _matchesSelector.default)(target, this.arrowSelector)) {
	        return true;
	      }
	      var arrows = this.arrowSelector ? this.arrows || (0, _toConsumableArray2.default)(this.node.querySelectorAll(this.arrowSelector)) : [];
	      if (arrows.length) {
	        this.arrows = arrows;
	      }
	      if (arrows.length && arrows.map(function (arrow) {
	        return (0, _containsNode.default)(arrow, target);
	      }).filter(function (x) {
	        return x;
	      })[0]) {
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: "tap",
	    value: function tap(event) {
	      if (!this.hasScroll()) {
	        return;
	      }
	      if (this.isArrowTarget(event.target)) {
	        event.preventDefault();
	      }
	      this.pressed = true;
	      this.reference = ypos(event);
	      this.timeStamp = Date.now();
	      this.frame = this.offset;
	      this.velocity = 0;
	      this.amplitude = 0;
	      clearInterval(this.ticker);
	      this.ticker = setInterval(this.track, 16);
	    }
	  }, {
	    key: "drag",
	    value: function drag(event) {
	      if (this.pressed) {
	        if (!this.hasScroll()) {
	          return;
	        }
	        event.preventDefault();
	        var y = ypos(event);
	        var delta = this.reference - y;
	        if (delta > this.threshold || delta < -this.threshold) {
	          this.reference = y;
	          this.scrollTo(this.offset + delta);
	        }
	      }
	    }
	  }, {
	    key: "release",
	    value: function release(event) {
	      if (!this.hasScroll() || !this.pressed) {
	        return;
	      }
	      this.pressed = false;
	      this.updateMaxScroll();
	      if (this.isArrowTarget(event.target)) {
	        event.preventDefault();
	      }
	      clearInterval(this.ticker);
	      if (this.velocity > 10 || this.velocity < -10) {
	        this.amplitude = this.initialAmplitude * this.velocity;
	        this.target = Math.round(this.offset + this.amplitude);
	        this.timestamp = Date.now();
	        requestAnimationFrame(this.autoScroll);
	      }
	    }
	  }, {
	    key: "scrollTo",
	    value: function scrollTo(offset) {
	      if (!this.viewNode) {
	        return null;
	      }
	      this.offset = (0, _clamp.default)(offset, 0, this.max);
	      this.setScrollPosition(this.offset);
	    }
	  }, {
	    key: "autoScroll",
	    value: function autoScroll() {
	      var elapsed, delta;
	      var timeConstant = this.timeConstant;
	      if (this.amplitude) {
	        elapsed = Date.now() - this.timestamp;
	        delta = -this.amplitude * Math.exp(-elapsed / timeConstant);
	        if (delta > 0.1 || delta < -0.1) {
	          this.scrollTo(this.target + delta);
	          requestAnimationFrame(this.autoScroll);
	        } else {
	          this.scrollTo(this.target);
	        }
	      }
	    }
	  }, {
	    key: "updateMaxScroll",
	    value: function updateMaxScroll() {
	      this.max = this.viewNode && this.viewNode.offsetHeight - this.node.offsetHeight;
	    }
	  }, {
	    key: "hasScroll",
	    value: function hasScroll() {
	      if ((this.viewNode && this.viewNode.offsetHeight) !== undefined && (this.node && this.node.offsetHeight) !== undefined) {
	        return this.viewNode.offsetHeight > this.node.offsetHeight;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: "track",
	    value: function track() {
	      var now, elapsed, delta, v;
	      now = Date.now();
	      elapsed = now - this.timeStamp;
	      this.timeStamp = now;
	      delta = this.offset - this.frame;
	      this.frame = this.offset;
	      v = 1000 * delta / (1 + elapsed);
	      this.velocity = 0.8 * v + 0.2 * this.velocity;
	    }
	  }]);
	  return InertialManager;
	}();
	var _default = InertialManager;
	exports.default = _default;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _MenuItemCell = _interopRequireDefault(__webpack_require__(156));
	var _Expander = _interopRequireDefault(__webpack_require__(695));
	var _renderCell = _interopRequireDefault(__webpack_require__(697));
	var _CheckBox = _interopRequireDefault(__webpack_require__(155));
	var _RadioButton = _interopRequireDefault(__webpack_require__(741));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _getRegionRelativeToParent = _interopRequireDefault(__webpack_require__(250));
	var _getGlobal = __webpack_require__(18);
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var emptyFn = function emptyFn() {};
	var MenuItem = function (_Component) {
	  (0, _inherits2.default)(MenuItem, _Component);
	  var _super = _createSuper(MenuItem);
	  function MenuItem(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, MenuItem);
	    _this = _super.call(this, props);
	    _this.state = {};
	    return _this;
	  }
	  (0, _createClass2.default)(MenuItem, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	      var props = this.preparedProps = this.prepareProps(this.props, this.state);
	      var className = props.className;
	      return _react.default.createElement("tr", _objectSpread(_objectSpread({}, (0, _cleanProps.default)(props, MenuItem.propTypes)), {}, {
	        style: props.style,
	        className: className,
	        ref: function ref(node) {
	          return _this2.node = node;
	        }
	      }), this.renderCells());
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentIsMounted = true;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.componentIsMounted = false;
	    }
	  }, {
	    key: "prepareProps",
	    value: function prepareProps(props, state) {
	      var preparedProps = _objectSpread(_objectSpread({}, props), {}, {
	        mouseOver: !!state.mouseOver,
	        active: !!state.active,
	        disabled: !!props.disabled,
	        className: this.getClassName(),
	        style: this.getStyle(),
	        onClick: this.handleClick,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseDown: this.handleMouseDown,
	        onTouchStart: this.handleTouchStart
	      });
	      if (props.item.isTitle) {
	        delete preparedProps.mouseOver;
	        delete preparedProps.active;
	        delete preparedProps.onClick;
	        delete preparedProps.onMouseEnter;
	        delete preparedProps.onMouseLeave;
	        delete preparedProps.onMouseDown;
	        delete preparedProps.onTouchStart;
	      }
	      return preparedProps;
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      var props = this.props;
	      if (props.disabled && event.stopPropagation) {
	        event.stopPropagation();
	        return;
	      }
	      if (this.props.onClick) {
	        this.props.onClick(event, props, props.index);
	      }
	      if (this.props.item.onClick) {
	        this.props.item.onClick(event, props, props.index);
	      }
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown() {
	      var _this3 = this;
	      var mouseUpListener = function mouseUpListener() {
	        if (_this3.componentIsMounted) {
	          _this3.setState({
	            active: false
	          });
	        }
	        globalObject.removeEventListener('mouseup', mouseUpListener);
	      };
	      globalObject.addEventListener('mouseup', mouseUpListener);
	      if (this.componentIsMounted) {
	        this.setState({
	          active: true
	        });
	      }
	    }
	  }, {
	    key: "handleTouchStart",
	    value: function handleTouchStart(event) {
	      var _this4 = this;
	      var props = this.props;
	      var mouseUpListener = function mouseUpListener() {
	        if (_this4.componentIsMounted) {
	          _this4.setState({
	            active: false
	          });
	        }
	        globalObject.removeEventListener('touchend', mouseUpListener);
	      };
	      globalObject.addEventListener('touchend', mouseUpListener);
	      if (this.componentIsMounted) {
	        this.setState({
	          active: true
	        });
	      }
	      if (!this.props.item.items) {
	        return;
	      }
	      if (this.state.mouseOver) {
	        this.handleMouseLeave(event);
	      } else {
	        this.handleMouseEnter(event);
	      }
	    }
	  }, {
	    key: "showMenu",
	    value: function showMenu(menu, props) {
	      props.showMenu(menu, this.getOffset());
	    }
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(event) {
	      var props = this.props;
	      if (props.disabled) {
	        return;
	      }
	      this.mouseInside = true;
	      this.setState({
	        mouseOver: true
	      });
	      if (props.onMouseOver) {
	        var menuOffset;
	        if (props.hasSubMenu) {
	          menuOffset = this.getOffset();
	        }
	        props.onMouseOver({
	          event: event,
	          menuOffset: menuOffset,
	          itemProps: props,
	          index: props.index,
	          hasSubMenu: props.hasSubMenu
	        });
	      }
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(event) {
	      var props = this.props;
	      if (props.disabled) {
	        return;
	      }
	      var offset = {
	        x: event.clientX,
	        y: event.clientY
	      };
	      if (this.componentIsMounted) {
	        this.setState({
	          active: false,
	          mouseOver: false
	        });
	      }
	      if (props.onMouseOut) {
	        props.onMouseOut({
	          itemPorps: props,
	          leaveOffset: offset,
	          index: props.index,
	          hasSubMenu: props.hasSubMenu
	        });
	      }
	    }
	  }, {
	    key: "renderCells",
	    value: function renderCells() {
	      var props = this.props;
	      var cells = props.columns.map(function () {
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	        return _renderCell.default.apply(void 0, [props].concat(args));
	      });
	      if (props.enableSelection && props.name) {
	        var input = this.renderSelectInput();
	        if (this.props.selectionInputPosition === 'end') {
	          cells.push(input);
	        } else {
	          cells.unshift(input);
	        }
	      }
	      if (props.hasSubMenu) {
	        var expander = this.renderExpander();
	        cells.push(expander);
	      }
	      return cells;
	    }
	  }, {
	    key: "getCommonCellProps",
	    value: function getCommonCellProps() {
	      var props = this.props;
	      return {
	        rootClassName: props.rootClassName,
	        rtl: props.rtl
	      };
	    }
	  }, {
	    key: "renderSelectInput",
	    value: function renderSelectInput() {
	      var _this5 = this;
	      var props = this.props;
	      var multiple = props.multiple;
	      var className = (0, _join.default)("".concat(props.rootClassName, "__cell__input"), props.browserNativeSelectInputs && "".concat(props.rootClassName, "__cell__input--browser-native"), multiple && "".concat(props.rootClassName, "__cell__input--multiple"));
	      var onChange = function onChange(checked) {
	        if (checked === undefined) {
	          checked = !props.checked;
	        }
	        if (typeof checked !== 'boolean' && _this5.props.showWarnings) {
	          console.warn('"onChange" should be called with a boolean param!');
	        }
	        props.onSelectChange({
	          name: props.name,
	          value: props.value,
	          multiple: multiple,
	          checked: checked
	        });
	      };
	      var inputProps = {
	        className: className,
	        onChange: props.selectOnClick ? emptyFn : onChange,
	        iconSize: multiple ? props.checkIconSize : props.radioIconSize,
	        name: props.name,
	        disabled: props.disabled,
	        checked: props.checked,
	        focusable: false,
	        supportIndeterminate: false,
	        browserNative: props.browserNativeSelectInputs,
	        theme: props.theme
	      };
	      var cellProps = _objectSpread({
	        key: 'select'
	      }, this.getCommonCellProps());
	      cellProps.className = (0, _join.default)(cellProps.className, "".concat(props.rootClassName, "__cell--has-input"), props.multiple && "".concat(props.rootClassName, "__cell--checkbox"), !props.multiple && "".concat(props.rootClassName, "__cell--radio"));
	      var Input = multiple ? _CheckBox.default : _RadioButton.default;
	      var renderFunction = multiple ? this.props.renderCheckInput : this.props.renderRadioInput;
	      var result;
	      if (typeof renderFunction === 'function') {
	        result = renderFunction({
	          domProps: inputProps,
	          onChange: onChange,
	          disabled: props.disabled,
	          checked: props.checked
	        });
	      }
	      if (result === undefined) {
	        result = _react.default.createElement(Input, _objectSpread({}, inputProps));
	      }
	      return _react.default.createElement(_MenuItemCell.default, _objectSpread({}, cellProps), result);
	    }
	  }, {
	    key: "renderExpander",
	    value: function renderExpander() {
	      var props = this.props;
	      var expander = props.expander;
	      if (props.item && props.item.expander !== undefined) {
	        expander = props.item.expander;
	      }
	      var style = _objectSpread(_objectSpread({}, props.expanderStyle), props.item && props.item.expanderStyle);
	      var expanderProps = _objectSpread({
	        style: style,
	        size: props.expanderSize,
	        onClick: props.onExpanderClick
	      }, this.getCommonCellProps());
	      if (typeof expander === 'function') {
	        expander = expander(expanderProps, props.item);
	      }
	      if (expander === undefined || expander === true) {
	        expander = _react.default.createElement(_Expander.default, _objectSpread({}, expanderProps));
	      }
	      return _react.default.createElement(_MenuItemCell.default, _objectSpread({
	        key: "expander",
	        className: "".concat(props.rootClassName, "__cell--has-expander"),
	        expander: expander
	      }, expanderProps));
	    }
	  }, {
	    key: "getStyle",
	    value: function getStyle() {
	      var props = this.props,
	        state = this.state;
	      var style = (0, _assign.default)({}, props.style, props.item.style);
	      if (props.item.isTitle && props.titleStyle) {
	        (0, _assign.default)(style, props.titleStyle, props.item.titleStyle);
	      }
	      if (state.mouseOver) {
	        (0, _assign.default)(style, props.itemOverStyle, props.overStyle, props.item.overStyle);
	      }
	      if (state.active) {
	        (0, _assign.default)(style, props.itemActiveStyle, props.activeStyle, props.item.activeStyle);
	      }
	      if (props.expanded) {
	        (0, _assign.default)(style, props.expandedStyle, props.item.expandedStyle);
	      }
	      if (props.focused) {
	        (0, _assign.default)(style, props.focusedStyle, props.item.focusedStyle);
	      }
	      if (props.focused && state.mouseOver) {
	        (0, _assign.default)(style, props.overFocusedStyle, props.item.overFocusedStyle);
	      }
	      if (props.height) {
	        (0, _assign.default)(style, {
	          height: props.height
	        });
	      }
	      if (props.disabled) {
	        (0, _assign.default)(style, props.itemDisabledStyle, props.disabledStyle, props.item.disabledStyle);
	      }
	      return style;
	    }
	  }, {
	    key: "getClassName",
	    value: function getClassName() {
	      var props = this.props,
	        state = this.state;
	      var baseClassName = "".concat(props.rootClassName, "__row");
	      var className = (0, _join.default)(props.className, props.item.className, baseClassName, state.mouseOver && "".concat(baseClassName, "--over"), state.mouseOver && props.item.overClassName, state.mouseOver && props.overClassName, state.active && "".concat(baseClassName, "--active"), state.active && props.item.activeClassName, state.active && props.activeClassName, props.expanded && "".concat(baseClassName, "--expanded"), props.expanded && props.item.expandedClassName, props.expanded && props.expandedClassName, props.focused && "".concat(baseClassName, "--focused"), props.focused && props.item.focusedClassName, props.focused && props.focusedClassName, props.item.isTitle && "".concat(baseClassName, "--title"), props.checked && "".concat(baseClassName, "--checked"));
	      if (props.disabled) {
	        className = (0, _join.default)(props.className, baseClassName, props.disabled && "".concat(baseClassName, "--disabled"), props.disabled && props.itemDisabledClassName, props.disabled && props.item.disabledClassName);
	      }
	      return className;
	    }
	  }, {
	    key: "getOffset",
	    value: function getOffset() {
	      return (0, _getRegionRelativeToParent.default)(this.node, this.props.rootClassName);
	    }
	  }, {
	    key: "getPreparedProps",
	    value: function getPreparedProps() {
	      return this.preparedProps;
	    }
	  }, {
	    key: "hasSubmenu",
	    value: function hasSubmenu() {
	      return !!this.props.hasSubMenu;
	    }
	  }, {
	    key: "getDOMNode",
	    value: function getDOMNode() {
	      return this.node;
	    }
	  }, {
	    key: "getValue",
	    value: function getValue() {
	      var props = this.props;
	      return props.item[props.valueProperty];
	    }
	  }, {
	    key: "getName",
	    value: function getName() {
	      var props = this.props;
	      return props.item[props.valueProperty];
	    }
	  }]);
	  return MenuItem;
	}(_reactClass.default);
	MenuItem.defaultProps = {
	  isMenuItem: true,
	  item: {},
	  columns: ['label'],
	  enableSelection: false,
	  allowUnselect: false
	};
	MenuItem.propTypes = {
	  rootClassName: _propTypes.default.string,
	  style: _propTypes.default.object,
	  titleStyle: _propTypes.default.object,
	  height: _propTypes.default.number,
	  dismissOnClick: _propTypes.default.bool,
	  siblingItemHasSubMenu: _propTypes.default.bool,
	  overStyle: _propTypes.default.object,
	  overClassName: _propTypes.default.string,
	  activeStyle: _propTypes.default.object,
	  activeClassName: _propTypes.default.string,
	  disabledStyle: _propTypes.default.object,
	  disabledClassName: _propTypes.default.string,
	  expandedStyle: _propTypes.default.object,
	  expandedClassName: _propTypes.default.string,
	  focusedStyle: _propTypes.default.object,
	  focusedClassName: _propTypes.default.string,
	  cellStyle: _propTypes.default.object,
	  expanderStyle: _propTypes.default.object,
	  overFocusedStyle: _propTypes.default.object,
	  columns: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])),
	  item: _propTypes.default.object,
	  expanded: _propTypes.default.bool,
	  globalCellStyle: _propTypes.default.object,
	  itemDisabledStyle: _propTypes.default.object,
	  itemDisabledClassName: _propTypes.default.string,
	  itemOverStyle: _propTypes.default.object,
	  itemActiveStyle: _propTypes.default.object,
	  menuHasSubmenu: _propTypes.default.bool,
	  hasSubMenu: _propTypes.default.bool,
	  items: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string])),
	  isMenuItem: _propTypes.default.bool,
	  focused: _propTypes.default.bool,
	  index: _propTypes.default.number,
	  rtl: _propTypes.default.bool,
	  expander: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.bool, _propTypes.default.func]),
	  expanderSize: _propTypes.default.number,
	  expandedIndex: _propTypes.default.number,
	  onExpanderClick: _propTypes.default.func,
	  closeSubMenu: _propTypes.default.func,
	  closeSubmenuRecursively: _propTypes.default.func,
	  submenuWillUnmount: _propTypes.default.func,
	  onMouseOver: _propTypes.default.func,
	  onMouseOut: _propTypes.default.func,
	  mouseOver: _propTypes.default.bool,
	  active: _propTypes.default.bool,
	  menu: _propTypes.default.node,
	  onSelectChange: _propTypes.default.func,
	  enableSelection: _propTypes.default.bool,
	  allowUnselect: _propTypes.default.bool,
	  selectOnClick: _propTypes.default.bool,
	  name: _propTypes.default.any,
	  value: _propTypes.default.any,
	  renderCheckInput: _propTypes.default.func,
	  renderRadioInput: _propTypes.default.func,
	  selectionInputPosition: _propTypes.default.oneOf(['start', 'end']),
	  checkIconSize: _propTypes.default.number,
	  radioIconSize: _propTypes.default.number,
	  browserNativeSelectInputs: _propTypes.default.bool,
	  showWarnings: _propTypes.default.bool
	};
	var _default = MenuItem;
	exports.default = _default;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _join = _interopRequireDefault(__webpack_require__(20));
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var MenuSeparator = function (_Component) {
	  (0, _inherits2.default)(MenuSeparator, _Component);
	  var _super = _createSuper(MenuSeparator);
	  function MenuSeparator() {
	    (0, _classCallCheck2.default)(this, MenuSeparator);
	    return _super.apply(this, arguments);
	  }
	  (0, _createClass2.default)(MenuSeparator, [{
	    key: "render",
	    value: function render() {
	      var props = this.prepareProps(this.props);
	      return _react.default.createElement("tr", {
	        className: props.className
	      }, _react.default.createElement("td", {
	        colSpan: 100
	      }, _react.default.createElement("div", {
	        className: "".concat(props.rootClassName, "__menu-separator__tool"),
	        style: props.style
	      })));
	    }
	  }, {
	    key: "prepareProps",
	    value: function prepareProps(thisProps) {
	      var props = {};
	      (0, _assign.default)(props, thisProps);
	      props.style = this.prepareStyle(props);
	      props.className = this.prepareClassName(props);
	      return props;
	    }
	  }, {
	    key: "prepareClassName",
	    value: function prepareClassName(props) {
	      var className = (0, _join.default)("".concat(props.rootClassName, "__menu-separator"), props.className);
	      return className;
	    }
	  }, {
	    key: "prepareStyle",
	    value: function prepareStyle(props) {
	      return (0, _assign.default)({}, props.style, props.menuSeparatorStyle);
	    }
	  }]);
	  return MenuSeparator;
	}(_reactClass.default);
	MenuSeparator.defaultProps = {
	  isSeparator: true
	};
	var _default = MenuSeparator;
	exports.default = _default;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _regionAlign = _interopRequireDefault(__webpack_require__(55));
	var _selectParent = _interopRequireDefault(__webpack_require__(101));
	function getRegionRelativeToParent(child, prentClassName) {
	  var parent = (0, _selectParent.default)(".".concat(prentClassName), child);
	  var menuRegion = _regionAlign.default.from(parent);
	  var thisRegion = _regionAlign.default.from(child);
	  return {
	    left: thisRegion.left - menuRegion.left,
	    top: thisRegion.top - menuRegion.top,
	    width: thisRegion.width,
	    height: thisRegion.height
	  };
	}
	var _default = getRegionRelativeToParent;
	exports.default = _default;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _range = _interopRequireDefault(__webpack_require__(588));
	function prepareAlignOffset(alignOffset, positionsLength) {
	  var offset;
	  if (Array.isArray(alignOffset)) {
	    offset = alignOffset.map(function (alignOffsetItem) {
	      if (typeof alignOffsetItem === 'number') {
	        return {
	          x: alignOffsetItem,
	          y: alignOffsetItem
	        };
	      } else {
	        return alignOffsetItem;
	      }
	    });
	  }
	  if (typeof alignOffset === 'number') {
	    offset = {
	      x: alignOffset,
	      y: alignOffset
	    };
	  }
	  if ((0, _typeof2.default)(alignOffset) === 'object') {
	    offset = alignOffset;
	  }
	  if (!Array.isArray(offset) && positionsLength) {
	    offset = (0, _range.default)(0, positionsLength).map(function () {
	      return offset;
	    });
	  }
	  return offset;
	}
	var _default = prepareAlignOffset;
	exports.default = _default;

/***/ },
/* 252 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDecimalDelimiter;
	function getDecimalDelimiter(locale) {
	  return 1.1.toLocaleString(locale).replace(/1/g, '') || '.';
	}

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSelectionStart;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var document = globalObject.document;
	function getSelectionStart(o) {
	  if (o.createTextRange && !globalObject.getSelection) {
	    var r = document.selection.createRange().duplicate();
	    r.moveEnd('character', o.value.length);
	    if (r.text == '') return o.value.length;
	    return o.value.lastIndexOf(r.text);
	  }
	  return o.selectionStart;
	}

/***/ },
/* 254 */
[1296, 731],
/* 255 */
[1297, 740],
/* 256 */
[1296, 744],
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _NotifyResize = __webpack_require__(84);
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _DropdownButton = _interopRequireDefault(__webpack_require__(678));
	var _getGroupedItems = _interopRequireDefault(__webpack_require__(748));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var firstRenderStyle = {
	  visibility: 'hidden',
	  overflow: 'hidden'
	};
	var ghostStyle = {
	  visibility: 'hidden',
	  overflow: 'hidden',
	  position: 'absolute'
	};
	var DropDownOverflow = function (_Component) {
	  (0, _inherits2.default)(DropDownOverflow, _Component);
	  var _super = _createSuper(DropDownOverflow);
	  function DropDownOverflow(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, DropDownOverflow);
	    _this = _super.call(this, props);
	    _this.setRootRef = function (ref) {
	      _this.rootNode = ref;
	    };
	    _this.setGhostRef = function (ref) {
	      _this.ghostNode = ref;
	    };
	    _this.state = {};
	    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2.default)(_this));
	    _this.isFirstRender = true;
	    return _this;
	  }
	  (0, _createClass2.default)(DropDownOverflow, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateOverflowItems();
	      this.isFirstRender = false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var style = _objectSpread(_objectSpread({}, props.style), this.isFirstRender && firstRenderStyle);
	      var className = (0, _join.default)(props.rootClassName, props.className, props.rtl && "".concat(props.rootClassName, "--rtl"));
	      var dropdownProps = (0, _assign.default)({}, props);
	      delete dropdownProps.scrollOnClick;
	      delete dropdownProps.mouseoverScrollSpeed;
	      delete dropdownProps.scrollSpeed;
	      delete dropdownProps.scrollStep;
	      delete dropdownProps.useTransformOnScroll;
	      var domProps = (0, _cleanProps.default)(dropdownProps, DropDownOverflow.propTypes);
	      return _react.default.createElement("div", _objectSpread(_objectSpread({}, domProps), {}, {
	        ref: this.setRootRef,
	        style: style,
	        className: className
	      }), _react.default.createElement(_NotifyResize.NotifyResize, {
	        key: "notify",
	        rafOnResize: true,
	        notifyOnMount: false,
	        onResize: this.handleResize
	      }), this.renderVisibleItems(), (this.isFirstRender || this.state.overflowIndexes) && this.renderDropdownButton(), this.renderGhost());
	    }
	  }, {
	    key: "renderVisibleItems",
	    value: function renderVisibleItems() {
	      var visibleItems = this.props.children;
	      if (this.state.visibleIndexes) {
	        var children = this.getChildrenArray();
	        visibleItems = this.state.visibleIndexes.map(function (index) {
	          return children[index];
	        });
	      }
	      return visibleItems;
	    }
	  }, {
	    key: "renderDropdownButton",
	    value: function renderDropdownButton() {
	      var items = [];
	      if (this.state.overflowIndexes) {
	        var children = this.getChildrenArray();
	        items = this.state.overflowIndexes.map(function (index) {
	          return {
	            id: index,
	            label: children[index]
	          };
	        });
	      }
	      var domProps = _objectSpread({
	        items: items,
	        constrainTo: this.props.constrainTo,
	        menuProps: _objectSpread(_objectSpread({
	          constrainTo: this.props.constrainTo
	        }, this.props.dropdownButtonProps && this.props.dropdownButtonProps.menuProps), {}, {
	          theme: null,
	          disableScroller: true
	        })
	      }, this.props.dropdownButtonProps);
	      var result;
	      if (typeof this.props.renderDropdownButton === 'function') {
	        result = this.props.renderDropdownButton({
	          items: items,
	          domProps: domProps,
	          overflowIndexes: this.state.overflowIndexes
	        });
	      }
	      if (result === undefined) {
	        result = _react.default.createElement(_DropdownButton.default, _objectSpread({}, domProps));
	      }
	      return result;
	    }
	  }, {
	    key: "renderGhost",
	    value: function renderGhost() {
	      if (!this.state.ghostVisible) {
	        return null;
	      }
	      return _react.default.createElement("div", {
	        ref: this.setGhostRef,
	        style: _objectSpread(_objectSpread({}, ghostStyle), {}, {
	          width: this.state.width,
	          height: this.state.height
	        })
	      }, this.props.children, this.renderDropdownButton());
	    }
	  }, {
	    key: "getRootSize",
	    value: function getRootSize() {
	      var maxSize = this.rootNode[this.getSizeName()];
	      return maxSize;
	    }
	  }, {
	    key: "updateOverflowItems",
	    value: function updateOverflowItems() {
	      var _this2 = this;
	      if (!this.rootNode) {
	        return;
	      }
	      var parentNode = this.state.ghostVisible ? this.ghostNode : this.rootNode;
	      var children = parentNode.children;
	      var maxSize = this.getRootSize();
	      var boxes = [].slice.call(children).map(function (child) {
	        return child[_this2.getSizeName()];
	      });
	      var overflowControlSize = boxes[boxes.length - 1];
	      if (this.isFirstRender) {
	        boxes = boxes.slice(1);
	      }
	      boxes = boxes.slice(0, -1);
	      var groupedItems = (0, _getGroupedItems.default)({
	        boxes: boxes,
	        maxSize: maxSize,
	        overflowControlSize: overflowControlSize
	      });
	      if (groupedItems) {
	        this.setState({
	          visibleIndexes: groupedItems.visibleIndexes,
	          overflowIndexes: groupedItems.overflowIndexes
	        });
	      } else {
	        this.setState({
	          visibleIndexes: null,
	          overflowIndexes: null
	        });
	      }
	    }
	  }, {
	    key: "handleResize",
	    value: function handleResize(_ref) {
	      var _this3 = this;
	      var width = _ref.width,
	        height = _ref.height;
	      this.setState({
	        width: width,
	        height: height,
	        ghostVisible: true
	      }, function () {
	        _this3.updateOverflowItems();
	        _this3.setState({
	          ghostVisible: false
	        });
	      });
	    }
	  }, {
	    key: "getSizeName",
	    value: function getSizeName() {
	      return 'offsetWidth';
	    }
	  }, {
	    key: "getChildrenArray",
	    value: function getChildrenArray() {
	      return _react.default.Children.toArray(this.props.children);
	    }
	  }]);
	  return DropDownOverflow;
	}(_react.Component);
	DropDownOverflow.defaultProps = {
	  rootClassName: 'react-toolkit-dropdown-overflow',
	  rtl: false
	};
	DropDownOverflow.propTypes = {
	  rootClassName: _propTypes.default.string,
	  dropdownButtonProps: _propTypes.default.object,
	  constrainTo: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.bool, _propTypes.default.func]),
	  renderDropdownButton: _propTypes.default.func,
	  rtl: _propTypes.default.bool
	};
	var _default = DropDownOverflow;
	exports.default = _default;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "DropdownOverflow", {
	  enumerable: true,
	  get: function get() {
	    return _DropdownOverflow.default;
	  }
	});
	Object.defineProperty(exports, "Separator", {
	  enumerable: true,
	  get: function get() {
	    return _ToolBar.Separator;
	  }
	});
	exports.default = void 0;
	var _ToolBar = _interopRequireWildcard(__webpack_require__(747));
	var _DropdownOverflow = _interopRequireDefault(__webpack_require__(257));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var _default = _ToolBar.default;
	exports.default = _default;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _assignFilter = _interopRequireDefault(__webpack_require__(749));
	function isDefined(value) {
	  return value !== undefined;
	}
	var _default = function _default(target) {
	  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    sources[_key - 1] = arguments[_key];
	  }
	  return _assignFilter.default.apply(void 0, [isDefined, target].concat(sources));
	};
	exports.default = _default;

/***/ },
/* 260 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(haystack, needle, comparator, low, high) {
	  var mid, cmp;
	  if (low === undefined) low = 0;else {
	    low = low | 0;
	    if (low < 0 || low >= haystack.length) throw new RangeError('invalid lower bound');
	  }
	  if (high === undefined) high = haystack.length - 1;else {
	    high = high | 0;
	    if (high < low || high >= haystack.length) throw new RangeError('invalid upper bound');
	  }
	  while (low <= high) {
	    mid = low + (high - low >> 1);
	    cmp = +comparator(haystack[mid], needle, mid, haystack);
	    if (cmp < 0.0) low = mid + 1;else if (cmp > 0.0) high = mid - 1;else return mid;
	  }
	  return ~low;
	};
	exports.default = _default;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	var _regionAlign = _interopRequireDefault(__webpack_require__(55));
	var _once = _interopRequireDefault(__webpack_require__(751));
	var _isMobile = _interopRequireDefault(__webpack_require__(64));
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var Helper = function Helper(config) {
	  this.config = config;
	};
	var getEvents = function getEvents(mobile) {
	  return {
	    move: mobile ? 'touchmove' : 'mousemove',
	    up: mobile ? 'touchend' : 'mouseup'
	  };
	};
	function getPageCoords(event, mobile) {
	  var firstTouch;
	  var pageX = event.pageX;
	  var pageY = event.pageY;
	  if (mobile && event.touches && (firstTouch = event.touches[0])) {
	    pageX = firstTouch.pageX;
	    pageY = firstTouch.pageY;
	  }
	  return {
	    pageX: pageX,
	    pageY: pageY
	  };
	}
	Object.assign(Helper.prototype, {
	  initDrag: function initDrag(event) {
	    this.onDragInit(event);
	    var mobile = this.config.mobile;
	    if (mobile === undefined) {
	      mobile = _isMobile.default;
	    }
	    var events = this.config.events || getEvents(mobile);
	    var onDragStart = (0, _once.default)(this.onDragStart, this);
	    var target = mobile ? event.target : globalObject;
	    var mouseUpListener = function (event) {
	      this.onDrop(event);
	      target && target.removeEventListener(events.move, mouseMoveListener);
	      target && target.removeEventListener(events.up, mouseUpListener);
	    }.bind(this);
	    var mouseMoveListener = function (event) {
	      if (!mobile && event.which !== 1) {
	        mouseUpListener(event);
	        return;
	      }
	      onDragStart(event, mobile);
	      this.onDrag(event, mobile);
	    }.bind(this);
	    target && target.addEventListener(events.move, mouseMoveListener, false);
	    target && target.addEventListener(events.up, mouseUpListener);
	  },
	  onDragInit: function onDragInit(event) {
	    var config = {
	      diff: {
	        left: 0,
	        top: 0
	      }
	    };
	    this.state = {
	      config: config
	    };
	    if (this.config.region) {
	      this.state.initialRegion = _regionAlign.default.from(this.config.region);
	      this.state.dragRegion = config.dragRegion = this.state.initialRegion.clone();
	    }
	    if (this.config.constrainTo) {
	      this.state.constrainTo = _regionAlign.default.from(this.config.constrainTo);
	    }
	    this.callConfig('onDragInit', event);
	  },
	  onDragStart: function onDragStart(event, mobile) {
	    this.state.initPageCoords = getPageCoords(event, mobile);
	    this.state.didDrag = this.state.config.didDrag = true;
	    this.callConfig('onDragStart', event);
	  },
	  onDrag: function onDrag(event, mobile) {
	    var config = this.state.config;
	    var initPageCoords = this.state.initPageCoords;
	    var eventCoords = getPageCoords(event, mobile);
	    var diff = config.diff = {
	      left: eventCoords.pageX - initPageCoords.pageX,
	      top: eventCoords.pageY - initPageCoords.pageY
	    };
	    if (this.state.initialRegion) {
	      var dragRegion = config.dragRegion;
	      dragRegion.set(this.state.initialRegion);
	      dragRegion.shift(diff);
	      if (this.state.constrainTo) {
	        diff.left = dragRegion.left - this.state.initialRegion.left;
	        diff.top = dragRegion.top - this.state.initialRegion.top;
	      }
	      config.dragRegion = dragRegion;
	    }
	    this.callConfig('onDrag', event);
	  },
	  onDrop: function onDrop(event) {
	    this.callConfig('onDrop', event);
	    this.state = null;
	  },
	  callConfig: function callConfig(fnName, event) {
	    var config = this.state.config;
	    var args = [event, config];
	    var fn = this.config[fnName];
	    if (fn) {
	      fn.apply(this, args);
	    }
	  }
	});
	function _default(event, config) {
	  if (config.scope) {
	    var skippedKeys = {
	      scope: 1,
	      region: 1,
	      constrainTo: 1
	    };
	    Object.keys(config).forEach(function (key) {
	      var value = config[key];
	      if (key in skippedKeys) {
	        return;
	      }
	      if (typeof value == 'function') {
	        config[key] = value.bind(config.scope);
	      }
	    });
	  }
	  var helper = new Helper(config);
	  helper.initDrag(event);
	  return helper;
	}

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var focusableSelector = 'input, select, textarea, button, object, a[href], [tabindex]';
	var _default = function _default(node) {
	  if (!node) {
	    return null;
	  }
	  var nodes = (0, _toConsumableArray2.default)(node.querySelectorAll(focusableSelector));
	  nodes = nodes.filter(function (el) {
	    return !!el.offsetParent;
	  });
	  return nodes;
	};
	exports.default = _default;

/***/ },
/* 263 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var hasOwn = Object.prototype.hasOwnProperty;
	function curry(fn, n) {
	  if (typeof n !== 'number') {
	    n = fn.length;
	  }
	  function getCurryClosure(prevArgs) {
	    function curryClosure() {
	      var len = arguments.length;
	      var args = [].concat(prevArgs);
	      if (len) {
	        args.push.apply(args, arguments);
	      }
	      if (args.length < n) {
	        return getCurryClosure(args);
	      }
	      return fn.apply(this, args);
	    }
	    return curryClosure;
	  }
	  return getCurryClosure([]);
	}
	var _default = curry(function (object, property) {
	  return hasOwn.call(object, property);
	});
	exports.default = _default;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var _default = !!('ontouchstart' in globalObject || globalObject.DocumentTouch && document instanceof DocumentTouch);
	exports.default = _default;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _binarySearch = _interopRequireDefault(__webpack_require__(260));
	var _eventemitter = _interopRequireDefault(__webpack_require__(329));
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var sortAsc = function sortAsc(a, b) {
	  return a - b;
	};
	var RowHeightManager = function (_EventEmitter) {
	  (0, _inherits2.default)(RowHeightManager, _EventEmitter);
	  var _super = _createSuper(RowHeightManager);
	  function RowHeightManager(rowHeight) {
	    var _this;
	    var rowHeightsMap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var config = arguments.length > 2 ? arguments[2] : undefined;
	    (0, _classCallCheck2.default)(this, RowHeightManager);
	    _this = _super.call(this);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rowHeight", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rowHeightFn", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "map", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "heights", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "indexes", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "offsets", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "minHeight", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "maxHeight", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "indexesToOffsets", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "offsetsToIndexes", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lazyRowHeightRafId", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rowToOffsetCache", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cache", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "__id", '');
	    _this.rowHeight = (0, _typeof2.default)(rowHeight) === 'object' ? typeof rowHeight.rowHeight === 'number' ? rowHeight.rowHeight : rowHeight.minRowHeight || 40 : 40;
	    _this.map = rowHeightsMap;
	    if ((0, _typeof2.default)(rowHeight) === 'object' && typeof rowHeight.rowHeight === 'function') {
	      _this.rowHeightFn = rowHeight.rowHeight;
	    }
	    if (!config || config.cache !== false) {
	      _this.setCache({});
	    }
	    _this.index(_this.rowHeight, rowHeightsMap);
	    return _this;
	  }
	  (0, _createClass2.default)(RowHeightManager, [{
	    key: "setRowHeight",
	    value: function setRowHeight(_ref) {
	      var index = _ref.index,
	        height = _ref.height,
	        defaultRowHeight = _ref.defaultRowHeight,
	        skipIndex = _ref.skipIndex;
	      if (this.map[index] === height && !defaultRowHeight) {
	        console.warn('NOOP');
	        return;
	      }
	      this.map[index] = height;
	      if (defaultRowHeight) {
	        this.rowHeight = defaultRowHeight;
	      }
	      if (this.cache) {
	        this.setCache({});
	      }
	      if (!skipIndex) {
	        this.index();
	      }
	    }
	  }, {
	    key: "indexRaf",
	    value: function indexRaf() {
	      var _this2 = this;
	      if (this.lazyRowHeightRafId) {
	        cancelAnimationFrame(this.lazyRowHeightRafId);
	        this.lazyRowHeightRafId = 0;
	      }
	      this.lazyRowHeightRafId = requestAnimationFrame(function () {
	        _this2.lazyRowHeightRafId = 0;
	        _this2.index();
	      });
	    }
	  }, {
	    key: "setRowHeightLazy",
	    value: function setRowHeightLazy(_ref2) {
	      var index = _ref2.index,
	        height = _ref2.height,
	        defaultRowHeight = _ref2.defaultRowHeight;
	      this.setRowHeight({
	        index: index,
	        height: height,
	        defaultRowHeight: defaultRowHeight || this.rowHeight,
	        skipIndex: true
	      });
	      this.indexRaf();
	    }
	  }, {
	    key: "setHeights",
	    value: function setHeights(map) {
	      this.map = map;
	      if (this.cache) {
	        this.setCache({});
	      }
	      this.index(this.rowHeight, this.map);
	    }
	  }, {
	    key: "setValues",
	    value: function setValues(_ref3) {
	      var defaultRowHeight = _ref3.defaultRowHeight,
	        map = _ref3.map;
	      if (defaultRowHeight) {
	        this.rowHeight = defaultRowHeight;
	      }
	      if (this.map) {
	        this.map = map;
	      }
	      if (this.cache) {
	        this.setCache({});
	      }
	      this.index(this.rowHeight, this.map);
	    }
	  }, {
	    key: "setDefaultRowHeight",
	    value: function setDefaultRowHeight(defaultRowHeight) {
	      this.rowHeight = defaultRowHeight;
	      if (this.cache) {
	        this.setCache({});
	      }
	      this.index(this.rowHeight, this.map);
	    }
	  }, {
	    key: "index",
	    value: function index() {
	      var _this3 = this;
	      var defaultRowHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.rowHeight;
	      var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.map;
	      this.rowToOffsetCache = {};
	      var indexes = map ? Object.keys(map).map(function (x) {
	        return +x;
	      }).sort(sortAsc) : [];
	      this.minHeight = defaultRowHeight;
	      this.maxHeight = defaultRowHeight;
	      this.__id = JSON.stringify(this.heights);
	      this.heights = indexes.map(function (index) {
	        var height = map[index];
	        if (height > _this3.maxHeight) {
	          _this3.maxHeight = height;
	        }
	        if (height < _this3.minHeight) {
	          _this3.minHeight = height;
	        }
	        return [index, height];
	      });
	      var prev = 0;
	      this.indexes = indexes;
	      this.offsets = indexes.map(function (index, i) {
	        var prevIndex = i === 0 ? -1 : indexes[i - 1];
	        var prevIndexRowHeight = map[prevIndex] || 0;
	        return prev = prev + (index - (prevIndex + 1)) * defaultRowHeight + prevIndexRowHeight;
	      });
	      this.offsetsToIndexes = {};
	      this.indexesToOffsets = this.offsets.reduce(function (acc, offset, i) {
	        var index = indexes[i];
	        acc[index] = offset;
	        _this3.offsetsToIndexes[offset] = index;
	        return acc;
	      }, {});
	      var __id = JSON.stringify(this.heights);
	      if (__id === this.__id) {
	        return;
	      }
	      this.afterIndex();
	    }
	  }, {
	    key: "afterIndex",
	    value: function afterIndex() {
	      this.emit('index');
	    }
	  }, {
	    key: "setCache",
	    value: function setCache(cache) {
	      this.cache = cache;
	    }
	  }, {
	    key: "getTotalSize",
	    value: function getTotalSize(count) {
	      if (count == null) {
	        throw new Error('Specify a count when calling getTotalSize!');
	      }
	      if (count <= 0 || isNaN(count)) {
	        return 0;
	      }
	      var sum = 0;
	      for (var i = 0; i < count; i++) {
	        var value = this.map[i];
	        sum += value === undefined ? this.rowHeight : value;
	      }
	      return sum;
	    }
	  }, {
	    key: "getDefaultRowHeight",
	    value: function getDefaultRowHeight() {
	      return this.rowHeight;
	    }
	  }, {
	    key: "getMinHeight",
	    value: function getMinHeight() {
	      return this.minHeight || this.rowHeight;
	    }
	  }, {
	    key: "getMaxHeight",
	    value: function getMaxHeight() {
	      return this.maxHeight || this.rowHeight;
	    }
	  }, {
	    key: "getRowOffset",
	    value: function getRowOffset(index) {
	      var offset = this.indexesToOffsets[index];
	      if (offset !== undefined) {
	        return offset;
	      }
	      offset = this.rowToOffsetCache[index];
	      if (offset !== undefined) {
	        return offset;
	      }
	      var insertPos = ~(0, _binarySearch.default)(this.indexes, index, sortAsc);
	      var closestIndex = this.indexes[insertPos - 1];
	      if (insertPos === 0) {
	        offset = index * this.rowHeight;
	      } else {
	        var closestOffset = this.indexesToOffsets[closestIndex];
	        offset = closestOffset + this.map[closestIndex] + (index - closestIndex - 1) * this.rowHeight;
	      }
	      this.rowToOffsetCache[index] = offset;
	      return offset;
	    }
	  }, {
	    key: "getRowHeight",
	    value: function getRowHeight(index, fn) {
	      var value = this.map[index];
	      if (value !== undefined) {
	        return value;
	      }
	      if (fn) {
	        return fn();
	      }
	      return this.rowHeight;
	    }
	  }, {
	    key: "getRowAt",
	    value: function getRowAt(offset) {
	      if (offset < 0) {
	        return 0;
	      }
	      var roundedOffset = Math.floor(offset / this.rowHeight) * this.rowHeight;
	      var result = this.cache ? this.cache[roundedOffset] : undefined;
	      if (result !== undefined) {
	        return result;
	      }
	      if (!this.map) {
	        result = roundedOffset / this.rowHeight;
	        if (this.cache) {
	          this.cache[roundedOffset] = result;
	        }
	        return result;
	      }
	      var index = (0, _binarySearch.default)(this.offsets, offset, sortAsc);
	      if (index < 0) {
	        var insertPos = ~index;
	        var beforeKnownIndex = this.indexes[insertPos - 1];
	        if (beforeKnownIndex !== undefined) {
	          var beforeKnownOffset = this.indexesToOffsets[beforeKnownIndex];
	          var nextOffset = beforeKnownOffset + this.map[beforeKnownIndex];
	          if (offset < nextOffset) {
	            result = beforeKnownIndex;
	          } else {
	            result = beforeKnownIndex + Math.floor((offset - nextOffset) / this.rowHeight) + 1;
	          }
	        } else {
	          result = Math.floor(offset / this.rowHeight);
	        }
	      } else {
	        result = this.indexes[index];
	      }
	      if (this.cache) {
	        this.cache[roundedOffset] = result;
	      }
	      return result;
	    }
	  }]);
	  return RowHeightManager;
	}(_eventemitter.default);
	var _default = RowHeightManager;
	exports.default = _default;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.StickyRowsContainerClassName = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _hasSticky = __webpack_require__(158);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var StickyRowsContainerClassName = 'InovuaReactDataGrid__virtual-list-sticky-rows-container';
	exports.StickyRowsContainerClassName = StickyRowsContainerClassName;
	var StickyRowsContainer = function StickyRowsContainer(props) {
	  var latestProps = (0, _react.useRef)(props);
	  var _useState = (0, _react.useState)(null),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    content = _useState2[0],
	    setContent = _useState2[1];
	  var currentHeightRef = (0, _react.useRef)(0);
	  var domNodeRef = (0, _react.useRef)(null);
	  var nonEmptyRowElementsRefRef = (0, _react.useRef)(null);
	  var rowElementsRef = (0, _react.useRef)(null);
	  var renderedRowsRef = (0, _react.useRef)([]);
	  var scrollTopRef = (0, _react.useRef)(0);
	  latestProps.current = props;
	  var setEnteringRow = function setEnteringRow(_ref) {
	    var scrollTop = _ref.scrollTop,
	      enteringRow = _ref.enteringRow;
	    if (enteringRow == null) {
	      scrollTopRef.current = scrollTop;
	      var domNode = domNodeRef.current;
	      (0, _toConsumableArray2.default)(domNode.children).forEach(function (rowNode) {
	        rowNode.style.transform = "translate3d(0px, 0px, 0px)";
	      });
	      return;
	    }
	    scrollTopRef.current = scrollTop;
	    var rowsToTranslateIndexes = [];
	    var rowsToTranslate = renderedRowsRef.current.filter(function (r, i) {
	      var result = r.scale >= enteringRow.scale;
	      if (result) {
	        rowsToTranslateIndexes.push(i);
	      }
	      return result;
	    });
	    rowsToTranslate.forEach(function (_rowToTranslate, i) {
	      var rowToTranslateIndex = rowsToTranslateIndexes[i];
	      var domNode = domNodeRef.current;
	      var rowNode = domNode.children[rowToTranslateIndex];
	      if (rowNode) {
	        var y = props.rowHeightManager.getRowOffset(enteringRow.index) - scrollTop - currentHeightRef.current;
	        rowNode.style.transform = "translate3d(0px, ".concat(y, "px, 0px)");
	      }
	    });
	  };
	  var setStickyRows = function setStickyRows(content, rows, config) {
	    var domNode = domNodeRef.current;
	    var renderedContent = content;
	    if (content == null) {
	      renderedContent = nonEmptyRowElementsRefRef.current;
	      if (domNode && rowElementsRef.current) {
	        domNode.style.opacity = '0';
	        domNode.style.pointerEvents = 'none';
	      }
	    } else {
	      if (domNode && !rowElementsRef.current) {
	        domNode.style.opacity = '1';
	        domNode.style.pointerEvents = 'all';
	      }
	    }
	    setContent(renderedContent);
	    if (content) {
	      nonEmptyRowElementsRefRef.current = content;
	    }
	    renderedRowsRef.current = rows;
	    rowElementsRef.current = content;
	    requestAnimationFrame(function () {
	      setEnteringRow(config);
	    });
	  };
	  var getCurrentVisibleStickyRowsCount = function getCurrentVisibleStickyRowsCount() {
	    return rowElementsRef.current ? rowElementsRef.current.length : 0;
	  };
	  (0, _react.useLayoutEffect)(function () {
	    var domNode = domNodeRef.current;
	    var totalHeight = 0;
	    if (domNode && domNode.children) {
	      (0, _toConsumableArray2.default)(domNode.children).forEach(function (c, i) {
	        c.style.zIndex = 1000 - i;
	        totalHeight += c.offsetHeight;
	      });
	      currentHeightRef.current = totalHeight;
	    }
	  }, [content]);
	  (0, _react.useLayoutEffect)(function () {
	    if (props.handle) {
	      props.handle({
	        setStickyRows: setStickyRows,
	        getCurrentVisibleStickyRowsCount: getCurrentVisibleStickyRowsCount,
	        setEnteringRow: setEnteringRow
	      });
	    }
	    return function () {
	      var props = latestProps.current;
	      if (props && typeof props.handle === 'function') {
	        props.handle(null);
	      }
	    };
	  }, []);
	  return _react.default.createElement("div", {
	    className: StickyRowsContainerClassName,
	    ref: domNodeRef,
	    style: (0, _defineProperty2.default)({
	      position: _hasSticky.sticky,
	      top: 0,
	      left: 0,
	      right: 0,
	      height: 0,
	      zIndex: 1,
	      contain: 'layout'
	    }, props.rtl ? 'transform' : '', props.rtl ? "translate3d(".concat(props.stickyOffset, "px, 0px, 0px)") : '')
	  }, content);
	};
	var _default = _react.default.memo(StickyRowsContainer);
	exports.default = _default;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactCleanProps = _interopRequireDefault(__webpack_require__(49));
	var _debounce = _interopRequireDefault(__webpack_require__(63));
	var _src = _interopRequireDefault(__webpack_require__(85));
	var _smoothScrollTo = _interopRequireDefault(__webpack_require__(114));
	var _uglified = _interopRequireDefault(__webpack_require__(57));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _isSafari = _interopRequireDefault(__webpack_require__(159));
	var _getScrollbarWidth = _interopRequireDefault(__webpack_require__(47));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var raf = globalObject.requestAnimationFrame;
	var HAS_NEGATIVE_SCROLL;
	var ua = globalObject.navigator ? globalObject.navigator.userAgent : '';
	var IS_EDGE = ua.indexOf('Edge/') !== -1;
	var IS_MS_BROWSER = IS_EDGE || ua.indexOf('Trident') !== -1;
	var IS_IE = IS_MS_BROWSER && !IS_EDGE;
	var IS_FF = ua.toLowerCase().indexOf('firefox') > -1;
	var SCROLLER_Z_INDEX = 1000;
	var SCROLLER_STYLE = {
	  overflow: 'auto',
	  position: 'static',
	  flex: '1 1 auto',
	  WebkitOverflowScrolling: 'auto'
	};
	if (IS_EDGE) {
	  SCROLLER_STYLE.position = 'relative';
	} else {
	  SCROLLER_STYLE.zIndex = SCROLLER_Z_INDEX;
	}
	var _default = function _default(displayName, CONFIG) {
	  var VirtualScrollContainer = function (_React$Component) {
	    (0, _inherits2.default)(VirtualScrollContainer, _React$Component);
	    var _super = _createSuper(VirtualScrollContainer);
	    function VirtualScrollContainer(props) {
	      var _this;
	      (0, _classCallCheck2.default)(this, VirtualScrollContainer);
	      _this = _super.call(this, props);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResize", function () {
	        if (_this.props.onResize) {
	          var _this$props;
	          (_this$props = _this.props).onResize.apply(_this$props, arguments);
	        }
	        _this.sync();
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sync", function () {
	        if (!_this.domNode) {
	          return;
	        }
	        CONFIG.sync.call((0, _assertThisInitialized2.default)(_this));
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "smoothScrollTo", function (newValue, config, callback) {
	        (0, _smoothScrollTo.default)(_this.scroller, newValue, config, callback);
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollbars", function () {
	        return {
	          horizontal: _this.hasHorizontalScrollbar(),
	          vertical: _this.hasVerticalScrollbar()
	        };
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasScrollbar", function (orientation) {
	        return CONFIG.hasScrollbar.call((0, _assertThisInitialized2.default)(_this), orientation);
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasVerticalScrollbar", function () {
	        return _this.hasScrollbar('vertical');
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasHorizontalScrollbar", function () {
	        return _this.hasScrollbar('horizontal');
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focus", function () {
	        _this.scroller.focus();
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFocus", function (event) {
	        if (event.target === _this.domNode) {
	          _this.focus();
	        }
	        if (_this.props.onFocus) {
	          _this.props.onFocus(event);
	        }
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChildResize", function (scrollSize) {
	        _this.setState({
	          scrollSize: scrollSize
	        }, _this.sync);
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollPosition", function () {
	        return CONFIG.getScrollPosition.call((0, _assertThisInitialized2.default)(_this));
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateScrollStyle", function (scrollPos) {
	        scrollPos = scrollPos || _this.getScrollPosition();
	        var _scrollPos = scrollPos,
	          scrollTop = _scrollPos.scrollTop;
	        var _scrollPos2 = scrollPos,
	          scrollLeft = _scrollPos2.scrollLeft;
	        if (_this.props.rtl && scrollLeft < 0) {
	          HAS_NEGATIVE_SCROLL = true;
	        }
	        var node = _this.childNode.current ? _this.childNode.current.firstChild : null;
	        if (_this.props.rtl) {
	          if (!HAS_NEGATIVE_SCROLL) {
	            if (IS_MS_BROWSER) {
	              scrollLeft = -scrollLeft;
	            } else {
	              scrollLeft = -(_this.scrollLeftMax - scrollLeft);
	            }
	          }
	        }
	        if (_this.props.applyScrollStyle) {
	          _this.props.applyScrollStyle({
	            scrollLeft: scrollLeft,
	            scrollTop: scrollTop
	          }, node);
	        } else {
	          node.style.top = "".concat(-scrollTop, "px");
	          node.style.left = "".concat(-scrollLeft, "px");
	        }
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNotifyResizeMount", function () {
	        _this.notifierMounted = true;
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getBefore", function () {
	        var before = _this.props.before;
	        if (!before) {
	          return null;
	        }
	        return _react.default.cloneElement(before, {
	          key: 'before',
	          style: _objectSpread({
	            position: 'absolute',
	            top: 0,
	            zIndex: 2 * SCROLLER_Z_INDEX + 1
	          }, before.props.style),
	          children: _react.default.createElement(_react.default.Fragment, null, before.props.children, _react.default.createElement(_src.default, {
	            notifyOnMount: true,
	            onResize: _this.onBeforeElementResize
	          }))
	        });
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAfter", function () {
	        var after = _this.props.after;
	        if (!after) {
	          return null;
	        }
	        var bottom = _this.props.nativeScroll ? _this.oldScrollbars && _this.oldScrollbars.horizontal ? (0, _getScrollbarWidth.default)() : 0 : 0;
	        return _react.default.cloneElement(after, {
	          key: 'after',
	          style: _objectSpread(_objectSpread({
	            position: 'absolute',
	            zIndex: 2 * SCROLLER_Z_INDEX + 1
	          }, after.props.style), {}, {
	            bottom: bottom
	          }),
	          children: _react.default.createElement(_react.default.Fragment, null, after.props.children, _react.default.createElement(_src.default, {
	            notifyOnMount: true,
	            onResize: _this.onAfterElementResize
	          }))
	        });
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getBeforeHeight", function () {
	        return _this.props.before ? _this.state.beforeElementSize.height || 0 : 0;
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAfterHeight", function () {
	        return _this.props.after ? _this.state.afterElementSize.height || 0 : 0;
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBeforeElementResize", function (size) {
	        _this.setState({
	          beforeElementSize: size
	        });
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAfterElementResize", function (size) {
	        _this.setState({
	          afterElementSize: size
	        });
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollIntoView", function (_ref) {
	        var target = _ref.target;
	        if (target === _this.childNode.current) {
	          if (target.scrollTop !== 0) {
	            _this.scrollTop += target.scrollTop;
	            target.scrollTop = 0;
	          }
	          if (target.scrollLeft !== 0) {
	            _this.scrollLeft += target.scrollLeft;
	            target.scrollLeft = 0;
	          }
	        }
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScrollIntent", function () {
	        if (!_this.wheelCapturedOnScroller || IS_EDGE) {
	          return;
	        }
	        _this.clear();
	        _this.lazyRestorePointerEvents();
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lazyRestorePointerEvents", function () {
	        if (_this.childNode.current && _this.wheelCapturedOnScroller) {
	          _this.clear();
	          _this.rafHandle = raf(function () {
	            _this.wheelCapturedOnScroller = false;
	            delete _this.rafHandle;
	            _this.childNode.current.style.pointerEvents = 'auto';
	          });
	        }
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onWheelEvent", function (event) {
	        if ((0, _isSafari.default)() && globalObject.WheelEvent) {
	          _this.scrollerNode.dispatchEvent(new WheelEvent('wheel', event.nativeEvent));
	          event.stopPropagation();
	          event.preventDefault();
	          return;
	        }
	        _this.childNode.current.style.pointerEvents = 'none';
	        _this.wheelCapturedOnScroller = true;
	        event.stopPropagation();
	        var isProbablyChrome = !IS_MS_BROWSER && !IS_FF && !(0, _isSafari.default)();
	        var now = Date.now ? Date.now() : +new Date();
	        if (isProbablyChrome) {
	          if (now - _this.wheelEventTimestamp < 150) {
	            event.preventDefault();
	          }
	        } else {
	          event.preventDefault();
	        }
	        _this.wheelEventTimestamp = now;
	        _this.onScrollIntent();
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "clear", function () {
	        if (_this.rafHandle) {
	          cancelAnimationFrame(_this.rafHandle);
	          _this.rafHandle = null;
	        }
	      });
	      _this.wheelEventTimestamp = 0;
	      _this.lazyRestorePointerEvents = (0, _debounce.default)(_this.lazyRestorePointerEvents, props.pointerEventsRestoreDelay, {
	        leading: false,
	        trailing: true
	      });
	      _this.childNode = (0, _react.createRef)();
	      _this.refThis = function (c) {
	        _this.domNode = c;
	      };
	      if (CONFIG.init) {
	        CONFIG.init.call((0, _assertThisInitialized2.default)(_this), props);
	      }
	      _this.state = {
	        beforeElementSize: {
	          height: 0
	        },
	        afterElementSize: {
	          height: 0
	        }
	      };
	      return _this;
	    }
	    (0, _createClass2.default)(VirtualScrollContainer, [{
	      key: "ensureNonStaticStyle",
	      value: function ensureNonStaticStyle(style, domNode) {
	        if (!this.props.forceNonStaticPosition) {
	          return style;
	        }
	        style = style || {};
	        var _style = style,
	          position = _style.position;
	        var nonStatic = position === 'relative' || position === 'absolute';
	        if (nonStatic) {
	          return style;
	        }
	        if (domNode) {
	          position = globalObject.getComputedStyle(domNode).position;
	          nonStatic = position === 'relative' || position === 'absolute';
	          if (!nonStatic) {
	            return Object.assign({}, style, {
	              position: 'relative'
	            });
	          }
	        }
	        return Object.assign({}, style, {
	          position: 'relative'
	        });
	      }
	    }, {
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        if (this.props.showWarnings) {
	          if (!this.props.scrollSize) {
	            if (!this.notifierMounted) {
	              console.warn("The component inside the ".concat(displayName, " has not rendered its children. Please either render its children, or specify a 'scrollSize' prop to determine the size of the scrolling content."));
	            }
	          }
	          if (!this.props.forceNonStaticPosition && getComputedStyle(this.domNode).position === 'static') {
	            console.warn("".concat(displayName, " has position: \"static\". It should have a non-static position!"));
	          }
	        }
	        var contentNode = this.childNode.current ? this.childNode.current.firstChild : null;
	        if (contentNode) {
	          contentNode.style.willChange = 'transform';
	        }
	        if (this.props.rtl && !this.scrollLeft) {
	          this.updateScrollStyle();
	        }
	        this.sync();
	      }
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        var prevScrollSize = prevProps.scrollSize;
	        var scrollSize = this.props.scrollSize;
	        if (prevScrollSize && !scrollSize) {
	          this.sync();
	        } else if (prevScrollSize && scrollSize) {
	          if (prevScrollSize.width !== scrollSize.width || prevScrollSize.height !== scrollSize.height) {
	            this.sync();
	          }
	        }
	      }
	    }, {
	      key: "clientSize",
	      get: function get() {
	        return CONFIG.getClientSize.call(this);
	      }
	    }, {
	      key: "scrollTopMax",
	      get: function get() {
	        return CONFIG.getScrollTopMax.call(this);
	      }
	    }, {
	      key: "scrollLeftMax",
	      get: function get() {
	        return CONFIG.getScrollLeftMax.call(this);
	      }
	    }, {
	      key: "scrollTop",
	      get: function get() {
	        return this.scroller.scrollTop;
	      },
	      set: function set(value) {
	        this.scroller.scrollTop = value;
	      }
	    }, {
	      key: "scrollLeft",
	      get: function get() {
	        return this.scroller.scrollLeft;
	      },
	      set: function set(value) {
	        this.scroller.scrollLeft = value;
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var props = this.props;
	        var style = props.style,
	          className = props.className;
	        var rtl = props.rtl,
	          inertialScroll = props.inertialScroll,
	          useWheelCapture = props.useWheelCapture,
	          contain = props.contain,
	          renderView = props.renderView;
	        style = Object.assign({}, this.ensureNonStaticStyle(style, this.domNode), {
	          overflow: 'hidden',
	          display: 'flex',
	          alignItems: 'stretch',
	          alignContent: 'stretch',
	          flexFlow: 'column',
	          flexWrap: 'nowrap',
	          transform: 'translate3d(0px, 0px, 0px)'
	        });
	        if (contain) {
	          if (contain === true) {
	            style.contain = 'style layout paint';
	          } else {
	            style.contain = contain;
	          }
	        }
	        className = (0, _join.default)(className, 'inovua-react-virtual-scroll-container', rtl && 'inovua-react-virtual-scroll-container--rtl');
	        if (CONFIG.prepareClassName) {
	          className = CONFIG.prepareClassName.call(this, className);
	        }
	        var content = _react.default.Children.only(props.children);
	        var newContentProps = {};
	        if (!this.props.scrollSize) {
	          newContentProps.children = [_react.default.createElement(_src.default, {
	            key: "notify-resize",
	            onResize: this.onChildResize,
	            notifyOnMount: true,
	            ResizeObserver: this.props.ResizeObserver,
	            useRaf: this.props.rafOnResize,
	            checkResizeDelay: this.props.checkResizeDelay,
	            onMount: this.onNotifyResizeMount
	          }), content.props.children];
	        }
	        newContentProps.style = Object.assign({}, content.props.style, (0, _defineProperty2.default)({
	          position: 'absolute',
	          top: 0
	        }, rtl ? 'right' : 'left', 0));
	        var beforeHeight = this.getBeforeHeight();
	        var useAbsolutePosition = IS_IE || IS_FF;
	        var childStyle = {
	          overflow: 'hidden',
	          position: useAbsolutePosition ? 'absolute' : 'fixed',
	          top: beforeHeight,
	          left: 0,
	          right: 0,
	          bottom: 0
	        };
	        if (!useAbsolutePosition) {
	          childStyle.backfaceVisibility = 'hidden';
	          if ((0, _isSafari.default)()) {
	            childStyle.WebkitBackfaceVisibility = 'hidden';
	          }
	        }
	        if (!IS_EDGE) {
	          childStyle.zIndex = 2 * SCROLLER_Z_INDEX;
	        }
	        var domProps = (0, _defineProperty2.default)({
	          ref: this.childNode,
	          style: childStyle,
	          onScroll: this.scrollIntoView
	        }, useWheelCapture ? 'onWheelCapture' : 'onWheel', IS_EDGE ? null : this.onWheelEvent);
	        content = _react.default.createElement(_react.default.Fragment, null, this.getBefore(), _react.default.createElement("div", _objectSpread({
	          key: "content"
	        }, domProps), (0, _react.cloneElement)(content, newContentProps)), this.getAfter());
	        var scrollSize = this.props.scrollSize || this.state.scrollSize;
	        var afterHeight = this.getAfterHeight();
	        var extraHeight = beforeHeight + afterHeight;
	        if (extraHeight && scrollSize) {
	          scrollSize = Object.assign({}, scrollSize, {
	            height: scrollSize.height + extraHeight
	          });
	        }
	        var spacer = _react.default.createElement("div", {
	          "data-name": "spacer",
	          key: "spacer",
	          style: Object.assign({
	            pointerEvents: 'none'
	          }, scrollSize)
	        });
	        if (this.props.renderSpacer) {
	          spacer = this.props.renderSpacer(spacer, {
	            scrollSize: scrollSize
	          });
	        }
	        var scrollerStyle = inertialScroll ? Object.assign({}, SCROLLER_STYLE, {
	          WebkitOverflowScrolling: 'touch'
	        }) : SCROLLER_STYLE;
	        return _react.default.createElement("div", _objectSpread(_objectSpread({
	          tabIndex: -1
	        }, (0, _reactCleanProps.default)(this.props, this.constructor.propTypes)), {}, {
	          onFocus: this.onFocus,
	          style: style,
	          className: className,
	          ref: this.refThis
	        }), _react.default.createElement(_src.default, {
	          onResize: this.onResize,
	          notifyOnMount: true,
	          ResizeObserver: this.props.ResizeObserver,
	          useRaf: this.props.rafOnResize,
	          checkResizeDelay: this.props.checkResizeDelay,
	          measureSize: this.props.measureSize
	        }), CONFIG.renderScroller.call(this, {
	          props: props,
	          content: content,
	          spacer: spacer,
	          scrollerStyle: scrollerStyle,
	          renderView: renderView
	        }));
	      }
	    }]);
	    return VirtualScrollContainer;
	  }(_react.default.Component);
	  VirtualScrollContainer.propTypes = {
	    applyScrollStyle: _propTypes.default.func,
	    avoidRepaintOnScroll: _propTypes.default.bool,
	    forceNonStaticPosition: _propTypes.default.bool,
	    hideNativeScrollbarIfPossible: _propTypes.default.bool,
	    inertialScroll: _propTypes.default.bool,
	    measureSize: _propTypes.default.func,
	    onResize: _propTypes.default.func,
	    contain: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	    onScrollbarsChange: _propTypes.default.func,
	    pointerEventsRestoreDelay: _propTypes.default.number,
	    checkResizeDelay: _propTypes.default.number,
	    rafOnResize: _propTypes.default.bool,
	    rtl: _propTypes.default.bool,
	    scrollSize: _propTypes.default.shape({
	      height: _propTypes.default.number,
	      width: _propTypes.default.number
	    }),
	    scrollerStyle: _propTypes.default.shape({}),
	    viewStyle: _propTypes.default.shape({}),
	    showWarnings: _propTypes.default.bool,
	    useWheelCapture: _propTypes.default.bool
	  };
	  VirtualScrollContainer.defaultProps = {
	    avoidRepaintOnScroll: true,
	    inertialScroll: true,
	    rtl: false,
	    rafOnResize: true,
	    useWheelCapture: true,
	    forceNonStaticPosition: false,
	    pointerEventsRestoreDelay: 250,
	    showWarnings: !_uglified.default
	  };
	  return VirtualScrollContainer;
	};
	exports.default = _default;

/***/ },
/* 268 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = validate;
	function validate(region) {
	  var isValid = true;
	  if (region.right < region.left) {
	    isValid = false;
	    region.right = region.left;
	  }
	  if (region.bottom < region.top) {
	    isValid = false;
	    region.bottom = region.top;
	  }
	  return isValid;
	}

/***/ },
/* 269 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function throttle(func, wait) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var context;
	  var args;
	  var result;
	  var timeout = null;
	  var previous = 0;
	  var later = function later() {
	    previous = options.leading === false ? 0 : Date.now();
	    timeout = null;
	    result = func.apply(context, args);
	    if (!timeout) {
	      context = null;
	      args = null;
	    }
	  };
	  return function () {
	    for (var _len = arguments.length, _rest = new Array(_len), _key = 0; _key < _len; _key++) {
	      _rest[_key] = arguments[_key];
	    }
	    var now = Date.now();
	    if (!previous && options.leading === false) {
	      previous = now;
	    }
	    var remaining = wait - (now - previous);
	    context = this;
	    args = arguments;
	    if (remaining <= 0 || remaining > wait) {
	      if (timeout) {
	        clearTimeout(timeout);
	        timeout = null;
	      }
	      previous = now;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    } else if (!timeout && options.trailing !== false) {
	      timeout = setTimeout(later, remaining);
	    }
	    return result;
	  }.apply(this, [func, wait, options]);
	}
	var _default = throttle;
	exports.default = _default;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _react = _interopRequireDefault(__webpack_require__(2));
	var STYLE = {
	  display: 'inline-block'
	};
	var _default = function _default(content) {
	  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'empty';
	  var style = arguments.length > 2 ? arguments[2] : undefined;
	  if (typeof content === 'function') {
	    content = content();
	  }
	  if (content == null || content == false || content == '') {
	    return null;
	  }
	  if (typeof content === 'string') {
	    content = _react.default.createElement("div", {
	      className: "InovuaReactDataGrid__".concat(name, "-text"),
	      style: STYLE
	    }, content);
	  }
	  return _react.default.createElement("div", {
	    key: "emptyContentWrapper",
	    className: "InovuaReactDataGrid__".concat(name, "-wrapper"),
	    style: style
	  }, content);
	};
	exports.default = _default;

/***/ },
/* 271 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(x) {
	  return x || '';
	};
	exports.default = _default;

/***/ },
/* 272 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(value) {
	  return value !== undefined;
	};
	exports.default = _default;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _matchesSelector = _interopRequireDefault(__webpack_require__(796));
	var FOCUSABLE_SELECTOR = 'input, select, textarea, button, object, a[href], [tabindex]';
	var _default = function _default(element) {
	  return (0, _matchesSelector.default)(element, FOCUSABLE_SELECTOR);
	};
	exports.default = _default;

/***/ },
/* 274 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warnOnce = exports.warn = exports.communityFeatureWarn = void 0;
	var warn = function warn(msg) {
	  console.warn("**************************************** INOVUA REACTDATAGRID COMMUNITY EDITION WARNING ****************************************\n\n                             ".concat(msg, "\n\n*********************************************************************************************************************************\n    "));
	};
	exports.warn = warn;
	var onceMessages = {};
	var warnOnce = function warnOnce(msg) {
	  if (onceMessages[msg]) {
	    return;
	  }
	  onceMessages[msg] = true;
	  console.warn("**************************************** INOVUA REACTDATAGRID COMMUNITY EDITION WARNING ****************************************\n\n                             ".concat(msg, "\n\n*********************************************************************************************************************************\n    "));
	};
	exports.warnOnce = warnOnce;
	var communityFeatureWarn = function communityFeatureWarn(featureName, checkObj) {
	  if (checkObj[featureName]) {
	    return;
	  }
	  checkObj[featureName] = true;
	  warn("".concat(featureName, " is only supported in ENTERPRISE Edition, but you're using the Community Edition!"));
	};
	exports.communityFeatureWarn = communityFeatureWarn;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(116),
	    _assign = __webpack_require__(67);
	
	var ReactNoopUpdateQueue = __webpack_require__(278);
	
	var canDefineProperty = __webpack_require__(279);
	var emptyObject = __webpack_require__(1041);
	var invariant = __webpack_require__(93);
	var lowPriorityWarning = __webpack_require__(813);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 276 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 277 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(177);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(45);
	var settle = __webpack_require__(827);
	var buildURL = __webpack_require__(830);
	var parseHeaders = __webpack_require__(836);
	var isURLSameOrigin = __webpack_require__(834);
	var createError = __webpack_require__(283);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(829);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(832);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        if (request.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 281 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 282 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(826);
	
	/**
	 * Create an Error with the specified message, config, error code, and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, response);
	};


/***/ },
/* 284 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Password = __webpack_require__(165);
	
	var _Password2 = _interopRequireDefault(_Password);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var ResetPassword = function (_React$Component) {
	  _inherits(ResetPassword, _React$Component);
	
	  function ResetPassword() {
	    _classCallCheck(this, ResetPassword);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).call(this));
	
	    _this.checkPassword = _this.checkPassword.bind(_this);
	    _this.resetPassword = _this.resetPassword.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResetPassword, [{
	    key: 'checkPassword',
	    value: function checkPassword(e) {
	      e.preventDefault();
	
	      if (this.password.value !== this.confirm.value) {
	        this.confirm.setCustomValidity('Passwords do not match.');
	      } else {
	        this.confirm.setCustomValidity('');
	      }
	
	      this.props.checkValidity(e, this.resetPassword);
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	      console.log(this.props);
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          SettingsStore = _props$store.SettingsStore;
	
	
	      var search = new URLSearchParams(this.props.routing.location.search);
	
	      var account = search.get('account');
	      var key = search.get('key');
	      var user = search.get('user');
	      var username = search.get('username');
	
	      var data = {
	        newPassword: this.password.value,
	        confirmPassword: this.confirm.value
	      };
	
	      if (key) {
	        // If a change key was in the url, use it
	        data.passwordChangeKey = key;
	      } else {
	        // Otherwise require the current password
	        data.currentPassword = this.current.value;
	      }
	
	      var callback = null;
	
	      if (username) {
	        // If a username was provided in the url,
	        // automatically log in after changing
	        var reroute = function reroute() {
	          _this2.props.routing.history.push('/');
	        };
	
	        callback = function callback() {
	          SessionStore.login(username, _this2.password.value, reroute);
	        };
	      } else {
	        // Otherwise, redirect to the dashboard
	        callback = function callback() {
	          _this2.props.routing.history.push('/');
	          SessionStore.showToaster(translation.success, 'success');
	        };
	      }
	
	      SettingsStore.updatePassword(data, callback, account, user);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	
	      var search = new URLSearchParams(this.props.routing.location.search);
	      var key = search.get('key');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'pane__content' },
	        !this.props.standalone && _react2.default.createElement(
	          'h1',
	          { className: 'pane__title' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          'form',
	          {
	            onSubmit: function onSubmit(e) {
	              return _this3.checkPassword(e);
	            },
	            noValidate: true
	          },
	          _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	              'ul',
	              { className: 'fields' },
	              !key && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  {
	                    className: 'meta',
	                    htmlFor: 'reset-current'
	                  },
	                  translation.current_password
	                ),
	                _react2.default.createElement('input', {
	                  type: 'password',
	                  id: 'reset-current',
	                  placeholder: translation.current_password,
	                  required: true,
	                  'aria-required': 'true',
	                  ref: function ref(input) {
	                    return _this3.current = input;
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  {
	                    className: 'meta',
	                    htmlFor: 'reset-password'
	                  },
	                  translation.password
	                ),
	                _react2.default.createElement(_Password2.default, Object.assign({
	                  id: 'reset-password',
	                  placeholder: translation.password,
	                  changeFunction: this.handleInput,
	                  parent: this,
	                  name: 'password'
	                }, this.props))
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  {
	                    className: 'meta',
	                    htmlFor: 'reset-confirm'
	                  },
	                  translation.confirm_password
	                ),
	                _react2.default.createElement('input', {
	                  type: 'password',
	                  id: 'reset-confirm',
	                  placeholder: translation.confirm_password,
	                  required: true,
	                  'aria-required': 'true',
	                  ref: function ref(input) {
	                    return _this3.confirm = input;
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn--link',
	              type: 'button'
	            },
	            translation.cancel
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn',
	              type: 'submit'
	            },
	            translation.reset
	          )
	        )
	      );
	    }
	  }]);
	
	  return ResetPassword;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('ResetPassword')(ResetPassword);

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Confirm = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Confirm, _React$Component);
	
	  function Confirm() {
	    _classCallCheck(this, Confirm);
	
	    var _this = _possibleConstructorReturn(this, (Confirm.__proto__ || Object.getPrototypeOf(Confirm)).call(this));
	
	    _this.closeDialog = _this.closeDialog.bind(_this);
	    _this.confirmDialog = _this.confirmDialog.bind(_this);
	    return _this;
	  }
	
	  _createClass(Confirm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('keydown', this.confirmDialog, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.confirmDialog, false);
	    }
	  }, {
	    key: 'closeDialog',
	    value: function closeDialog(e) {
	      e.preventDefault();
	      this.props.store.SessionStore.closeDialog();
	    }
	  }, {
	    key: 'confirmDialog',
	    value: function confirmDialog(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      if (e.keyCode === 13) {
	        this.props.store.SessionStore.confirmFunc();
	      } else if (e.keyCode === 27) {
	        this.closeDialog(e);
	      } else if (typeof e.keyCode === 'undefined') {
	        this.props.store.SessionStore.confirmFunc();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dialog dialog--confirm' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dialog__content' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'dialog__msg' },
	            SessionStore.confirmContent.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            SessionStore.confirmContent.body
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dialog__btns' },
	            _react2.default.createElement(
	              'a',
	              { href: '#app', className: 'btn btn--outline', onClick: function onClick(e) {
	                  return _this2.closeDialog(e);
	                } },
	              'Cancel'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: '#app', className: 'btn', onClick: function onClick(e) {
	                  return _this2.confirmDialog(e);
	                } },
	              SessionStore.confirmContent.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Confirm;
	}(_react2.default.Component));
	
	exports.default = Confirm;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _mobxReact = __webpack_require__(9);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var Footer = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Footer, _React$Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
	  }
	
	  _createClass(Footer, [{
	    key: 'render',
	
	    // changeLocale(locale) {
	    //   if(locale) {
	    //     this.props.store.SessionStore.updateLocale(locale);
	    //   }
	    // }
	
	    value: function render() {
	      // Hund system status (check on a 100ms interval if anchor is there)
	      // const statusElDelay = setInterval(function(){
	      //   if(document.querySelector('#status') && window.Status) {
	      //     new window.Status.Widget({
	      //       hostname: 'status.smarterproctoring.com',
	      //       selector: '#status',
	      //       css: false,
	      //       display: {
	      //         hideOnError: true,
	      //         ledOnly: true,
	      //         panePosition: 'top-left'
	      //       }
	      //     });
	      //
	      //     clearInterval(statusElDelay);
	      //   }
	      // }, 100)
	
	      return _react2.default.createElement(
	        'footer',
	        { className: 'site-foot' },
	        _react2.default.createElement(
	          'div',
	          { className: 'site-foot__copy wrap' },
	          _react2.default.createElement(
	            'span',
	            null,
	            '\xA9 ',
	            new Date().getFullYear(),
	            ' SmarterServices, LLC'
	          ),
	          _react2.default.createElement(
	            'nav',
	            null,
	            _react2.default.createElement(
	              'ul',
	              { className: 'site-foot__nav' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: 'https://www.smarterservices.com/privacy-policy',
	                    target: '_blank',
	                    rel: 'noopener noreferrer'
	                  },
	                  'Privacy Policy'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: 'https://www.smarterservices.com/terms-of-use',
	                    target: '_blank',
	                    rel: 'noopener noreferrer'
	                  },
	                  'Terms of Use'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: 'https://www.smarterservices.com/accessibility',
	                    target: '_blank',
	                    rel: 'noopener noreferrer'
	                  },
	                  'Accessibility Statement'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Footer')(Footer);

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _reactSimpleDropdown = __webpack_require__(199);
	
	var _reactSimpleDropdown2 = _interopRequireDefault(_reactSimpleDropdown);
	
	var _mobxReact = __webpack_require__(9);
	
	var _logoWhite = __webpack_require__(1282);
	
	var _logoWhite2 = _interopRequireDefault(_logoWhite);
	
	var _checkOut = __webpack_require__(1283);
	
	var _checkOut2 = _interopRequireDefault(_checkOut);
	
	var _config = __webpack_require__(24);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactLaunchDarkly = __webpack_require__(60);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Help = __webpack_require__(871);
	
	var _Help2 = _interopRequireDefault(_Help);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Header = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this));
	
	    _this.renderHybrid = function () {
	      if (!_this.state.firstRender) return null;
	
	      _this.setState({ firstRender: false });
	      var SessionStore = _this.props.store.SessionStore;
	
	
	      _this.setState({ showHybrid: true });
	
	      try {
	        if (SessionStore.account.enableHybridCheckout) {
	          _this.setState({ showHybridCheckout: true });
	        }
	      } catch (error) {
	        // no op
	      }
	      return null;
	    };
	
	    _this.state = {
	      navOpen: false,
	      activePage: '',
	      firstRender: true,
	      showHybrid: false,
	      showHybridCheckout: false
	
	      // Bind this to functions
	    };_this.handleLinkClick = _this.handleLinkClick.bind(_this);
	    _this.toggleNav = _this.toggleNav.bind(_this);
	    _this.renderPoliciesButton = _this.renderPoliciesButton.bind(_this);
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          HybridStore = _props$store.HybridStore;
	
	      SessionStore.getUnreadCount();
	      if (SessionStore.account && SessionStore.account.enableHybridCheckout) {
	        HybridStore.listCheckoutSessions(1);
	        setInterval(function () {
	          return HybridStore.listCheckoutSessions(1);
	        }, 60000);
	      }
	    }
	  }, {
	    key: 'handleLinkClick',
	    value: function handleLinkClick() {
	      var dropdowns = [];
	      dropdowns.push(this.refs.pagesDropdown);
	      dropdowns.push(this.refs.accountDropdown);
	      for (var i = 0; i < dropdowns.length; i++) {
	        if (typeof dropdowns[i] !== 'undefined') {
	          dropdowns[i].hide();
	        }
	      }
	      this.setState({
	        navOpen: false
	      });
	    }
	  }, {
	    key: 'toggleNav',
	    value: function toggleNav(e) {
	      e.preventDefault();
	      this.setState({
	        navOpen: !this.state.navOpen
	      });
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive(url) {
	      if (url === this.props.routing.location.pathname) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'renderPoliciesButton',
	    value: function renderPoliciesButton() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          {
	            className: 'navbar__item ' + (this.isActive('policies') ? 'navbar__item--active' : ''),
	            to: '/policies',
	            onClick: this.handleLinkClick
	          },
	          _react2.default.createElement(icons.iconClipboard, null),
	          translation.navigation.policies
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var openClass = null;
	      var menuText = 'Menu';
	
	      if (this.state.navOpen) {
	        openClass = 'open';
	        menuText = 'Close';
	      } else {
	        menuText = 'Menu';
	      }
	
	      var _props = this.props,
	          translation = _props.translation,
	          store = _props.store;
	      var SessionStore = store.SessionStore,
	          HybridStore = store.HybridStore;
	      var checkoutSessionCount = HybridStore.checkoutSessionCount;
	      var userData = SessionStore.userData;
	      var proctorAccountSid = userData.proctorAccountSid;
	      var _state = this.state,
	          showHybrid = _state.showHybrid,
	          showHybridCheckout = _state.showHybridCheckout;
	
	
	      return _react2.default.createElement(
	        _config.Validate,
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: 'site-head wrap' },
	          !this.props.hideNav && _react2.default.createElement(
	            'a',
	            { href: '\'/\'', className: 'nav-btn ' + openClass, onClick: this.toggleNav },
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              menuText
	            )
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'meta' },
	            'SmarterProctoring'
	          ),
	          !this.props.hideNav && _react2.default.createElement(
	            _reactRouterDom.Link,
	            { className: 'branding', to: '/' },
	            _react2.default.createElement('img', { src: _logoWhite2.default, width: '191', alt: 'SmarterProctoring' })
	          ),
	          this.props.hideNav && _react2.default.createElement(
	            'span',
	            { className: 'branding' },
	            _react2.default.createElement('img', { src: _logoWhite2.default, width: '191', alt: 'SmarterProctoring' })
	          ),
	          this.props.hideNav && _react2.default.createElement(
	            'ul',
	            { className: 'account-menu dropdown' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(_Help2.default, Object.assign({
	                btnClass: 'account-menu__item'
	              }, this.props))
	            )
	          ),
	          userData && !this.props.hideNav && _react2.default.createElement(
	            'ul',
	            { className: 'account-menu dropdown', 'aria-haspopup': 'true' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactSimpleDropdown2.default,
	                { ref: 'accountDropdown' },
	                _react2.default.createElement(
	                  _reactSimpleDropdown.DropdownTrigger,
	                  { className: 'dropdown__trigger', 'aria-controls': '#nav-account' },
	                  _react2.default.createElement(icons.iconGear, null)
	                ),
	                _react2.default.createElement(
	                  _reactSimpleDropdown.DropdownContent,
	                  null,
	                  _react2.default.createElement(
	                    'ul',
	                    { id: 'nav-pages', className: 'dropdown__menu', role: 'menu', 'aria-hidden': 'true' },
	                    _react2.default.createElement(
	                      'li',
	                      { iamAction: 'sp:DescribeBalance', iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':balance' },
	                      _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        { className: 'dropdown__item', to: '/settings', onClick: this.handleLinkClick },
	                        translation.navigation.account.settings
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      { className: 'dropdown__separated' },
	                      _react2.default.createElement(
	                        'a',
	                        { className: 'dropdown__item', href: '#', onClick: function onClick() {
	                            SessionStore.logout(_this2.props.routing.history);
	                          } },
	                        translation.navigation.account.sign_out
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'separator' },
	              _react2.default.createElement(_Help2.default, Object.assign({
	                btnClass: 'account-menu__item'
	              }, this.props))
	            )
	          ),
	          _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'hybrid',
	            renderFeatureCallback: this.renderHybrid
	          }),
	          !this.props.hideNav && _react2.default.createElement(
	            'nav',
	            { id: 'nav', className: 'navbar ' + openClass, role: 'menubar' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'meta' },
	              translation.navigation.heading
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'navbar__menu' },
	              _react2.default.createElement(
	                'li',
	                { iamAction: 'sp:DescribeBalance', iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':balance' },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: 'navbar__item ' + (this.isActive('/') ? 'navbar__item--active' : ''), to: '/', onClick: this.handleLinkClick },
	                  _react2.default.createElement(icons.iconDashboard, null),
	                  translation.navigation.dashboard
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { iamAction: 'sp:CreateMessageThread', iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':message' },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: 'navbar__item notification-anchor ' + (this.isActive('/messages') ? 'navbar__item--active' : ''), to: '/messages', onClick: this.handleLinkClick },
	                  _react2.default.createElement(icons.iconEnvelope, null),
	                  translation.navigation.messages,
	                  SessionStore.unreadCount > 0 && _react2.default.createElement(
	                    'span',
	                    { className: 'notification__count badge' },
	                    SessionStore.unreadCount
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { iamAction: 'sp:DescribeExamSessions', iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':session' },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  {
	                    className: '\n                      navbar__item\n                      ' + (this.isActive('/sessions') ? 'navbar__item--active' : '') + '\n                      ' + (this.isActive('/pending-sessions') ? 'navbar__item--active' : '') + '\n                    ',
	                    to: '/sessions',
	                    onClick: this.handleLinkClick
	                  },
	                  _react2.default.createElement(icons.iconClock, null),
	                  translation.navigation.sessions
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { iamAction: 'sp:CreateProctorAccountLocationAvailability', iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':location' },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: 'navbar__item ' + (this.isActive('/locations') ? 'navbar__item--active' : ''), to: '/locations', onClick: this.handleLinkClick },
	                  _react2.default.createElement(icons.iconMapMarker, null),
	                  translation.navigation.locations
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { iamAction: 'sp:DescribeBalance', iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':balance' },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: 'navbar__item ' + (this.isActive('/payments') ? 'navbar__item--active' : ''), to: '/payments', onClick: this.handleLinkClick },
	                  _react2.default.createElement(icons.iconUSD, null),
	                  translation.navigation.payments
	                )
	              ),
	              _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                flagKey: 'proctor-cancellation-policies',
	                renderFeatureCallback: this.renderPoliciesButton
	              }),
	              _react2.default.createElement(
	                'li',
	                { iamAction: ['sp:DescribeExamSessions', 'sp:DescribeAppointmentTimeline', 'sp:DescribeExamList'], iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':*' },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: 'navbar__item ' + (this.isActive('/reports') ? 'navbar__item--active' : ''), to: '/reports', onClick: this.handleLinkClick },
	                  _react2.default.createElement(icons.iconGraph, null),
	                  translation.navigation.reports
	                )
	              ),
	              SessionStore.userData.isSuperAdmin && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: 'navbar__item ' + (this.isActive('/users') ? 'navbar__item--active' : ''), to: '/users', onClick: this.handleLinkClick },
	                  _react2.default.createElement(icons.iconPerson, null),
	                  translation.navigation.users
	                )
	              ),
	              showHybrid && _react2.default.createElement(
	                _config.Validate,
	                null,
	                _react2.default.createElement(
	                  'li',
	                  { iamAction: 'sp:DescribeHybridRooms', iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':hybridRoom' },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      className: 'navbar__item ' + (this.isActive('/hybrid-proctoring') ? 'navbar__item--active' : ''),
	                      to: '/hybrid-proctoring',
	                      onClick: this.handleLinkClick
	                    },
	                    _react2.default.createElement(icons.iconEye, null),
	                    translation.navigation.hybrid_proctoring
	                  )
	                )
	              ),
	              showHybrid && showHybridCheckout && _react2.default.createElement(
	                _config.Validate,
	                null,
	                _react2.default.createElement(
	                  'li',
	                  { iamAction: 'sp:DescribeCheckoutQueue', iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':checkoutQueue' },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      className: 'navbar__item notification-anchor ' + (this.isActive('/checkout') ? 'navbar__item--active' : ''),
	                      to: '/checkout'
	                    },
	                    _react2.default.createElement('img', { src: _checkOut2.default, className: 'icn', alt: 'Checkout queue' }),
	                    translation.navigation.checkout_queue,
	                    checkoutSessionCount > 0 && _react2.default.createElement(
	                      'span',
	                      { className: 'notification__count badge' },
	                      checkoutSessionCount
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Header;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Header')(Header);

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	// Helpers
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _config = __webpack_require__(24);
	
	var _helpers = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoadMore = (0, _mobxReact.observer)(function (props) {
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      url = _useState2[0],
	      setUrl = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      clicked = _useState4[0],
	      setClicked = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      done = _useState6[0],
	      setDone = _useState6[1];
	
	  var buttonRef = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    setUrl(props.url);
	  }, []);
	
	  var loadFunction = function loadFunction() {
	    var SessionStore = props.store.SessionStore;
	
	    if (!url) return;
	    if (!done) {
	      _config.api.get(url).then(function (response) {
	        if (!props.dataFormat || props.concat) {
	          Array.prototype.push.apply(props.group, response.data.results);
	        }
	
	        if (props.dataFormat) {
	          props.dataSet(props.dataFormat(response.data.results));
	        }
	
	        setClicked(false);
	
	        if (response.data.next) {
	          // API returns a url with a different domain for the next link
	          // so create an anchor element and set its href to the next link
	          // and then grab the pathname and query from that
	          var nextUrl = (0, _helpers.getPath)(response.data.next);
	          nextUrl = nextUrl.replace('/v1', '');
	
	          if (nextUrl !== url) {
	            setUrl(nextUrl);
	          } else {
	            setUrl(null);
	          }
	        } else {
	
	          setUrl(null);
	          setDone(true);
	        }
	      }).catch(function (error) {
	        SessionStore.throwError(error);
	      });
	    }
	  };
	
	  var isVisible = function isVisible() {
	    if (buttonRef) {
	      var button = buttonRef.current.getBoundingClientRect();
	      return button.top <= window.innerHeight;
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	
	    var scrollHandler = function scrollHandler() {
	      if (isVisible()) {
	        setClicked(true);
	        loadFunction();
	      }
	    };
	    if (props.drawer) {
	      var drawer = document.querySelector('.drawer');
	      drawer.addEventListener('scroll', scrollHandler);
	    } else if (props.wrapper) {
	      var wrapper = document.querySelector(props.wrapper);
	      wrapper.addEventListener('scroll', scrollHandler);
	    } else {
	      window.addEventListener('scroll', scrollHandler);
	    }
	
	    return function () {
	      if (props.drawer) {
	        var _drawer = document.querySelector('.drawer');
	        _drawer.removeEventListener('scroll', scrollHandler);
	      } else if (props.wrapper) {
	        var _wrapper = document.querySelector(props.wrapper);
	        if (_wrapper) {
	          _wrapper.removeEventListener('scroll', scrollHandler);
	        }
	      } else {
	        window.removeEventListener('scroll', scrollHandler);
	      }
	      // Cleanup: Remove the event listener when the component is unmounted
	    };
	  }, [url]);
	
	  var SessionStore = props.store.SessionStore;
	
	
	  if (!SessionStore.loading) {
	    if (url && !done) {
	      if (!clicked) {
	        return _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn--more',
	            onClick: function onClick() {
	              return loadFunction();
	            },
	            ref: buttonRef
	          },
	          props.text
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { className: 'loader-bar' },
	          'Loading\u2026'
	        );
	      }
	    }
	  }
	});
	
	exports.default = LoadMore;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Step = function (_React$Component) {
	  _inherits(Step, _React$Component);
	
	  function Step() {
	    _classCallCheck(this, Step);
	
	    var _this = _possibleConstructorReturn(this, (Step.__proto__ || Object.getPrototypeOf(Step)).call(this));
	
	    _this.isComplete = _this.isComplete.bind(_this);
	    return _this;
	  }
	
	  _createClass(Step, [{
	    key: 'isComplete',
	    value: function isComplete(step) {
	      if (this.props.step > step) {
	        return 'complete';
	      } else if (this.props.step === step) {
	        return 'active';
	      } else {
	        return '';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          skippable = _props.skippable;
	
	
	      if (skippable) {
	        return _react2.default.createElement(
	          'ol',
	          { className: 'step' },
	          data.map(function (key, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'a',
	                { href: '#exam-details', className: 'step__point tooltip ' + _this2.isComplete(i + 1), onClick: function onClick(e) {
	                    _this2.props.setStep(e, i + 1);
	                  } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tooltip__body', role: 'tooltip' },
	                  data[i]
	                )
	              )
	            );
	          })
	        );
	      } else {
	        return _react2.default.createElement(
	          'ol',
	          { className: 'step' },
	          data.map(function (key, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'span',
	                { className: 'step__point tooltip ' + _this2.isComplete(i + 1) },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tooltip__body', role: 'tooltip' },
	                  data[i]
	                )
	              )
	            );
	          })
	        );
	      }
	    }
	  }]);
	
	  return Step;
	}(_react2.default.Component);
	
	exports.default = Step;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Toaster = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Toaster, _React$Component);
	
	  function Toaster() {
	    _classCallCheck(this, Toaster);
	
	    var _this = _possibleConstructorReturn(this, (Toaster.__proto__ || Object.getPrototypeOf(Toaster)).call(this));
	
	    _this.closeDialog = _this.closeDialog.bind(_this);
	    return _this;
	  }
	
	  _createClass(Toaster, [{
	    key: 'closeDialog',
	    value: function closeDialog(e) {
	      e.preventDefault();
	      this.props.store.SessionStore.closeDialog();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'toaster ' + SessionStore.toasterClass },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(
	            'p',
	            null,
	            SessionStore.toasterContent.body
	          )
	        )
	      );
	    }
	  }]);
	
	  return Toaster;
	}(_react2.default.Component));
	
	exports.default = Toaster;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(76);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _SpinButton = __webpack_require__(863);
	
	var _SpinButton2 = _interopRequireDefault(_SpinButton);
	
	var _MultiSelect = __webpack_require__(858);
	
	var _MultiSelect2 = _interopRequireDefault(_MultiSelect);
	
	var _helpers = __webpack_require__(17);
	
	var _config = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translate
	
	//import Toggle from "../Common/Toggle"
	
	
	var HybridSettings = (0, _mobxReact.observer)(function (_React$Component) {
	    _inherits(Settings, _React$Component);
	
	    function Settings() {
	        var _this2 = this;
	
	        _classCallCheck(this, Settings);
	
	        // Set the initial state
	        var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this));
	
	        _this.handleInput = function (e) {
	            var _e$target = e.target,
	                name = _e$target.name,
	                value = _e$target.value;
	
	
	            _this.setState(_defineProperty({}, name, value));
	        };
	
	        _this.handleSelectInstall = function (installSids) {
	            _this.setState({
	                installSids: installSids,
	                installSidManual: false
	            });
	        };
	
	        _this.handleSelectCourse = function (courseSids) {
	            _this.setState({
	                courseSids: courseSids
	            });
	        };
	
	        _this.handleSubmit = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _this$state, installSids, courseSids, isShared, maxStudents, roomName, HybridStore, setCreateNew, roomSid, data;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _this$state = _this.state, installSids = _this$state.installSids, courseSids = _this$state.courseSids, isShared = _this$state.isShared, maxStudents = _this$state.maxStudents, roomName = _this$state.roomName;
	                            HybridStore = _this.props.store.HybridStore;
	                            setCreateNew = _this.props.setCreateNew;
	                            roomSid = (0, _helpers.getURLSegment)(_this, 3);
	                            data = {
	                                installSids: installSids,
	                                courseSids: courseSids,
	                                isShared: isShared,
	                                maxStudents: maxStudents,
	                                roomName: roomName
	                            };
	
	                            if (!HybridStore.isEditing) {
	                                _context.next = 10;
	                                break;
	                            }
	
	                            _context.next = 8;
	                            return HybridStore.updateProctorRoom(HybridStore.roomDefaultValues.sid, data);
	
	                        case 8:
	                            _context.next = 12;
	                            break;
	
	                        case 10:
	                            _context.next = 12;
	                            return HybridStore.createProctorRoom(data);
	
	                        case 12:
	
	                            if (!roomSid) {
	                                HybridStore.stopEditing();
	                                setCreateNew(false);
	                            }
	
	                        case 13:
	                        case "end":
	                            return _context.stop();
	                    }
	                }
	            }, _callee, _this2);
	        }));
	
	        _this.handleCancel = function () {
	            var HybridStore = _this.props.store.HybridStore;
	            var setCreateNew = _this.props.setCreateNew;
	
	
	            HybridStore.stopEditing();
	            setCreateNew(false);
	        };
	
	        _this.state = {
	            installs: [],
	            installSids: [],
	            installSidManual: false,
	            courses: [],
	            courseSids: [],
	            isShared: true,
	            maxStudents: 1,
	            roomName: null
	        };
	        return _this;
	    }
	
	    _createClass(Settings, [{
	        key: "componentDidMount",
	        value: function () {
	            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var _props$store, SessionStore, HybridStore, roomSid, token, installData, installs, courseData, courses, roomDefaults;
	
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                _props$store = this.props.store, SessionStore = _props$store.SessionStore, HybridStore = _props$store.HybridStore;
	                                roomSid = (0, _helpers.getURLSegment)(this, 3);
	                                token = (0, _helpers.getParam)('token', window.location.href);
	
	                                if (!(roomSid && token)) {
	                                    _context2.next = 10;
	                                    break;
	                                }
	
	                                (0, _config.setToken)(token);
	                                SessionStore.startTokenTimer(token);
	                                _context2.next = 8;
	                                return HybridStore.listAvailableRooms();
	
	                            case 8:
	                                _context2.next = 10;
	                                return HybridStore.editProctorRoomStartingOutside(roomSid);
	
	                            case 10:
	                                if (SessionStore.userData.role) {
	                                    _context2.next = 17;
	                                    break;
	                                }
	
	                                _context2.next = 13;
	                                return HybridStore.listInstalls(SessionStore.userData.proctorAccountSid);
	
	                            case 13:
	                                installData = _context2.sent;
	
	
	                                if (installData.length > 0) {
	                                    installs = [];
	
	                                    installData.forEach(function (install) {
	                                        installs.push({
	                                            label: install.installName,
	                                            value: install.installSid
	                                        });
	                                    });
	                                    this.setState({
	                                        installs: installs
	                                    });
	                                }
	                                _context2.next = 24;
	                                break;
	
	                            case 17:
	                                if (!(SessionStore.userData.role === 'instructor')) {
	                                    _context2.next = 24;
	                                    break;
	                                }
	
	                                _context2.next = 20;
	                                return HybridStore.listInstructorCourses(HybridStore.userData.installSid, HybridStore.userData.userSid);
	
	                            case 20:
	                                courseData = _context2.sent;
	                                courses = [];
	
	
	                                courseData.forEach(function (course) {
	                                    courses.push({
	                                        label: course.title,
	                                        value: course.sid
	                                    });
	                                });
	                                this.setState({
	                                    courses: courses
	                                });
	
	                            case 24:
	
	                                // If we are editing a room, we need to populate the default values
	                                if (HybridStore.isEditing) {
	                                    roomDefaults = HybridStore.roomDefaultValues;
	
	                                    this.setState({
	                                        courseSids: roomDefaults.courseSids || [],
	                                        installSids: roomDefaults.installSids || [],
	                                        isShared: roomDefaults.isShared || false,
	                                        maxStudents: roomDefaults.maxStudents || 1,
	                                        roomName: roomDefaults.roomName || null
	                                    });
	                                }
	
	                            case 25:
	                            case "end":
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function componentDidMount() {
	                return _ref2.apply(this, arguments);
	            }
	
	            return componentDidMount;
	        }()
	
	        /**
	         * Store input values.
	         *
	         * @function handleInput
	         * @param {event} e
	         */
	
	
	        /**
	         * Store the selected school’s installSid.
	         *
	         * @function handleSelectInstall
	         * @param {array} installSids
	         */
	
	
	        /**
	         * Store the selected course's courseSid
	         *
	         * @function handleSelectCourse
	         * @param {array} courseSids
	         */
	
	
	        /**
	         * Submit the settings form.
	         *
	         * @function handleSubmit
	         */
	
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var translation = this.props.translation;
	            var HybridStore = this.props.store.HybridStore;
	            var _state = this.state,
	                roomName = _state.roomName,
	                maxStudents = _state.maxStudents,
	                installs = _state.installs,
	                installSids = _state.installSids,
	                courses = _state.courses,
	                courseSids = _state.courseSids;
	
	            var roomSid = (0, _helpers.getURLSegment)(this, 3);
	
	            return _react2.default.createElement(
	                "main",
	                { tabIndex: "0", id: "main-content", className: "page" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "wrap" },
	                    _react2.default.createElement(
	                        "header",
	                        { className: "page__header" },
	                        _react2.default.createElement(
	                            "h1",
	                            { className: "page__title" },
	                            translation.heading
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "form",
	                    {
	                        className: "hybrid-form hybrid-form--separated hybrid-panel hybrid-panel--md hybrid-panel--solo",
	                        noValidate: true,
	                        onSubmit: function onSubmit(e) {
	                            return (0, _helpers.checkValidityHybrid)(e, _this3.handleSubmit);
	                        }
	                    },
	                    _react2.default.createElement(
	                        "fieldset",
	                        null,
	                        _react2.default.createElement(
	                            "legend",
	                            null,
	                            HybridStore.isEditing && _react2.default.createElement(
	                                "h1",
	                                { className: "hybrid-panel__title" },
	                                translation.edit_hybrid_room
	                            ),
	                            !HybridStore.isEditing && _react2.default.createElement(
	                                "h1",
	                                { className: "hybrid-panel__title" },
	                                translation.create_new_hybrid_room
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "ul",
	                            { className: "hybrid-form__fields" },
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "label",
	                                    {
	                                        className: "hybrid-form__lbl lbl-required",
	                                        htmlFor: "room-name"
	                                    },
	                                    translation.room_name.label
	                                ),
	                                _react2.default.createElement("input", {
	                                    "aria-required": "true",
	                                    "data-errormsg": translation.room_name.error_msg,
	                                    value: roomName || '',
	                                    id: "room-name",
	                                    name: "roomName",
	                                    onChange: this.handleInput,
	                                    placeholder: translation.room_name.placeholder,
	                                    required: true,
	                                    type: "text"
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(_SpinButton2.default, {
	                                    defaultValue: maxStudents,
	                                    errorMsg: translation.max_students.error_msg,
	                                    helper: translation.max_students.helper,
	                                    id: "max-students",
	                                    label: translation.max_students.label,
	                                    layout: "horizontal",
	                                    max: 10,
	                                    min: 1,
	                                    onChange: function onChange(maxStudents) {
	                                        return _this3.setState({ maxStudents: maxStudents });
	                                    },
	                                    required: true
	                                })
	                            ),
	                            installs && installs.length > 0 && _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(_MultiSelect2.default, {
	                                    className: "multi-select--horizontal",
	                                    errorMsg: translation.install.error_msg,
	                                    helper: translation.install.helper,
	                                    id: "install",
	                                    label: translation.install.label,
	                                    onChange: this.handleSelectInstall,
	                                    options: installs,
	                                    required: true,
	                                    value: installSids
	                                })
	                            ),
	                            courses && courses.length > 0 && _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(_MultiSelect2.default, {
	                                    className: "multi-select--horizontal",
	                                    errorMsg: translation.instructor_courses.error_msg,
	                                    helper: translation.instructor_courses.helper,
	                                    id: "courses",
	                                    label: translation.instructor_courses.label,
	                                    onChange: this.handleSelectCourse,
	                                    options: courses,
	                                    required: true,
	                                    value: courseSids
	                                })
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "hybrid-panel__action" },
	                        !roomSid && _react2.default.createElement(
	                            "button",
	                            {
	                                className: "btn btn--outline",
	                                onClick: this.handleCancel,
	                                type: "reset"
	                            },
	                            translation.cancel
	                        ),
	                        _react2.default.createElement(
	                            "button",
	                            { className: "btn", type: "submit" },
	                            translation.save
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Settings;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)("HybridSettings")(HybridSettings);

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dompurify = __webpack_require__(92);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _MessageForm = __webpack_require__(881);
	
	var _MessageForm2 = _interopRequireDefault(_MessageForm);
	
	var _MessageContext = __webpack_require__(880);
	
	var _MessageContext2 = _interopRequireDefault(_MessageContext);
	
	var _RequestedDates = __webpack_require__(883);
	
	var _RequestedDates2 = _interopRequireDefault(_RequestedDates);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var MessageThread = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(MessageThread, _React$Component);
	
	  function MessageThread() {
	    _classCallCheck(this, MessageThread);
	
	    var _this = _possibleConstructorReturn(this, (MessageThread.__proto__ || Object.getPrototypeOf(MessageThread)).call(this));
	
	    _this.showForm = _this.showForm.bind(_this);
	    return _this;
	  }
	
	  _createClass(MessageThread, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        renderForm: false
	      };
	
	      this.getThread();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(nextProps) {
	      if (nextProps.messageSid !== this.props.messageSid) {
	        this.setState({
	          renderForm: false
	        });
	
	        this.getThread();
	      }
	    }
	  }, {
	    key: 'getThread',
	    value: function getThread() {
	      var messageSid = this.props.messageSid;
	
	
	      if (messageSid) {
	        this.props.store.MessageStore.getThread(messageSid);
	      } else {
	        this.props.store.MessageStore.getThreadId(this.props.toUserSid, this.props.contextType, this.props.contextId);
	      }
	
	      // Highlight the newly selected thread
	      var prevThread = document.querySelector('.thread.active');
	
	      if (prevThread && prevThread.className.indexOf('active') > -1) {
	        prevThread.className = prevThread.className.replace('active', '');
	      }
	
	      var thread = null;
	
	      var getThread = setInterval(function () {
	        thread = document.querySelector('#thread-' + messageSid);
	
	        if (thread) {
	          thread.className += ' active';
	          clearInterval(getThread);
	        }
	      }, 100);
	    }
	  }, {
	    key: 'showForm',
	    value: function showForm() {
	      this.setState({
	        renderForm: true
	      });
	    }
	  }, {
	    key: 'initials',
	    value: function initials(name, className) {
	      var names = name.split(' ');
	      var firstInitial = names[0].charAt(0);
	      var secondInitial = names[1].charAt(0);
	
	      if (className) {
	        return '' + firstInitial.toLowerCase();
	      }
	
	      return firstInitial + secondInitial;
	    }
	  }, {
	    key: 'renderContext',
	    value: function renderContext() {
	      var translation = this.props.translation;
	      var threadObject = this.props.store.MessageStore.threadObject;
	      var exam = threadObject.exam,
	          examSession = threadObject.examSession;
	
	
	      var examConfiguration = null;
	
	      if (examSession && examSession.examConfiguration) {
	        examConfiguration = examSession.examConfiguration;
	      }
	
	      var title = null;
	      var data = [];
	
	      if (examConfiguration && exam) {
	        title = exam.title;
	
	        if (threadObject.confirmedDate) {
	          data = [{
	            title: translation.context.exam_date,
	            value: '' + _moment2.default.utc(threadObject.confirmedDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	          }, {
	            title: translation.context.duration,
	            value: (0, _helpers.toHours)(examConfiguration.duration, false, false, false)
	          }];
	        } else {
	          data = [{
	            title: translation.context.exam_date,
	            value: _moment2.default.utc(examConfiguration.examOpenDate).local().format('M/D/YYYY [at] h:mma') + ' \u2013 ' + _moment2.default.utc(examConfiguration.examCloseDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	          }, {
	            title: translation.context.duration,
	            value: (0, _helpers.toHours)(examConfiguration.duration, false, false, false)
	          }];
	        }
	      } else if (threadObject.examSid && exam) {
	        title = exam.title;
	
	        data = [{
	          title: translation.context.exam_date,
	          value: _moment2.default.utc(exam.examOpenDate).local().format('M/D/YYYY [at] h:mma') + ' \u2013 ' + _moment2.default.utc(exam.examCloseDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	        }, {
	          title: translation.context.duration,
	          value: (0, _helpers.toHours)(exam.duration, false, false, false)
	        }];
	      }
	
	      if (threadObject.proctorAccountLocation) {
	        var location = threadObject.proctorAccountLocation;
	        var address = location.address1;
	
	        if (location.address2) {
	          address += ', ' + location.address2;
	        }
	
	        var proctorData = [{
	          title: translation.context.location,
	          value: address + ', ' + location.place + ', ' + location.region + ' ' + location.postalCode + ' ' + location.country
	        }];
	
	        data = data.concat(proctorData);
	      }
	
	      if (title) {
	        return _react2.default.createElement(_MessageContext2.default, Object.assign({
	          title: title,
	          data: data
	        }, this.props));
	      }
	
	      return '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          MessageStore = _props$store.MessageStore,
	          SessionStore = _props$store.SessionStore;
	      var threadMessages = MessageStore.threadMessages,
	          threadObject = MessageStore.threadObject;
	
	      var studentName = null;
	
	      if (!SessionStore.loading) {
	        if (threadMessages.length > 0) {
	          return _react2.default.createElement(
	            'article',
	            { className: 'inbox__thread' },
	            this.props.drawer && _react2.default.createElement(
	              'header',
	              { className: 'drawer__header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'drawer__title' },
	                  'Subject'
	                ),
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'inbox__tools' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'button',
	                      { onClick: this.showForm },
	                      _react2.default.createElement(icons.iconReply, null),
	                      translation.reply
	                    )
	                  )
	                )
	              )
	            ),
	            !this.props.drawer && _react2.default.createElement(
	              'header',
	              { className: 'inbox__thread-header' },
	              _react2.default.createElement(
	                'h5',
	                { className: 'inbox__thread-title' },
	                'Subject'
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'inbox__tools' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'button',
	                    { onClick: this.showForm },
	                    _react2.default.createElement(icons.iconReply, null),
	                    translation.reply
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'inbox__thread-body' },
	              this.renderContext(),
	              _react2.default.createElement(
	                'ol',
	                { className: 'conversation' },
	                threadMessages.map(function (message, i) {
	                  var fromUser = null;
	
	                  if (message.fromUser) {
	                    fromUser = message.fromUser;
	                    studentName = message.fromUser.firstName + ' ' + message.fromUser.lastName.charAt(0) + '.';
	                  } else {
	                    fromUser = message.fromProctorAccountUser;
	                  }
	
	                  return _react2.default.createElement(
	                    'li',
	                    { key: i },
	                    _react2.default.createElement(
	                      'blockquote',
	                      { className: 'conversation__message ' + (fromUser.sid === SessionStore.userData.sid ? 'sent' : 'received') },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'conversation__body' },
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'conversation__content' },
	                          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(message.content.replace(/\r?\n|\r/g, ' ')) } })
	                        ),
	                        _react2.default.createElement(
	                          'time',
	                          { className: 'conversation__timestamp' },
	                          _moment2.default.utc(message.createdDate).local().format('M/D/YYYY h:mma')
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'cite',
	                        { className: 'conversation__author conversation__author--sm' },
	                        _react2.default.createElement(
	                          'abbr',
	                          {
	                            className: '\n                                avatar--initials conversation__avatar ' + _this2.initials(fromUser.firstName + ' ' + fromUser.lastName, true) + '\n                              ',
	                            title: fromUser.firstName + ' ' + fromUser.lastName },
	                          fromUser.firstName.charAt(0),
	                          fromUser.lastName.charAt(0)
	                        )
	                      )
	                    )
	                  );
	                })
	              ),
	              threadObject.proctorAccountLocation && (threadObject.dateOption1 || threadObject.confirmedDate) && _react2.default.createElement(_RequestedDates2.default, Object.assign({
	                locationSid: threadObject.proctorAccountLocation.sid,
	                confirmedDate: threadObject.confirmedDate,
	                studentName: studentName
	              }, this.props)),
	              _react2.default.createElement(_MessageForm2.default, Object.assign({
	                sessionRequest: this.props.sessionRequest,
	                renderForm: this.state.renderForm,
	                showForm: this.showForm,
	                mode: 'reply',
	                threadSid: threadMessages[0].messageThreadSid,
	                parentThread: this
	              }, this.props))
	            )
	          );
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return MessageThread;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('MessageThread')(MessageThread);

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDropzone = __webpack_require__(492);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var PhotoUpload = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(PhotoUpload, _React$Component);
	
	  function PhotoUpload() {
	    _classCallCheck(this, PhotoUpload);
	
	    var _this = _possibleConstructorReturn(this, (PhotoUpload.__proto__ || Object.getPrototypeOf(PhotoUpload)).call(this));
	
	    _this.handleDrop = _this.handleDrop.bind(_this);
	    _this.handleDragEnter = _this.handleDragEnter.bind(_this);
	    _this.handleDragLeave = _this.handleDragLeave.bind(_this);
	    _this.removePhoto = _this.removePhoto.bind(_this);
	    return _this;
	  }
	
	  _createClass(PhotoUpload, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        dropClass: ''
	      };
	    }
	  }, {
	    key: 'handleDrop',
	    value: function handleDrop(file, rejected) {
	      var SessionStore = this.props.store.SessionStore;
	
	      var size = 0;
	
	      if (file.length === 0) {
	        var dialogContent = this.props.translation.invalid;
	        SessionStore.showDialog(dialogContent);
	
	        this.setState({
	          dropClass: ''
	        });
	      } else {
	        for (var i = 0; i < file.length; i++) {
	          size += file[i].size;
	        }
	      }
	
	      if (this.props.attachment.length + file.length <= 5 && size <= 1048576) {
	        this.setState({
	          dropClass: ''
	        });
	
	        var attachment = [].concat(_toConsumableArray(this.props.attachment.concat(file)));
	
	        console.log(attachment);
	
	        this.props.parent.setState({
	          attachment: attachment
	        });
	      } else {
	        var _dialogContent = this.props.translation.limit;
	
	        if (size > 1048576) {
	          _dialogContent = this.props.translation.too_large;
	        }
	
	        SessionStore.showDialog(_dialogContent);
	
	        this.setState({
	          dropClass: ''
	        });
	      }
	    }
	  }, {
	    key: 'handleDragEnter',
	    value: function handleDragEnter() {
	      this.setState({
	        dropClass: 'file-drop--drag-enter'
	      });
	    }
	  }, {
	    key: 'handleDragLeave',
	    value: function handleDragLeave() {
	      this.setState({
	        dropClass: ''
	      });
	    }
	  }, {
	    key: 'removePhoto',
	    value: function removePhoto(type) {
	      if (type === 'existingImage') {
	        this.props.parent.setState({
	          oldImage: this.props.existingImage
	        });
	      }
	
	      this.props.parent.setState(_defineProperty({}, type, []));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          attachment = _props.attachment,
	          translation = _props.translation;
	
	
	      var existingImage = this.props.existingImage;
	
	      if (typeof existingImage === 'undefined') {
	        existingImage = [];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        !attachment.length && !existingImage.length && _react2.default.createElement(
	          _reactDropzone2.default,
	          {
	            className: 'file-drop ' + this.state.dropClass,
	            onDrop: this.handleDrop,
	            onDragEnter: this.handleDragEnter,
	            onDragLeave: this.handleDragLeave,
	            multiple: false,
	            accept: 'image/*'
	          },
	          _react2.default.createElement(icons.iconPicture, null),
	          _react2.default.createElement(
	            'label',
	            { className: 'file-drop__label' },
	            translation.upload_label
	          )
	        ),
	        attachment.map(function (photo, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i, className: 'file-drop__preview' },
	            _react2.default.createElement(
	              'div',
	              { className: 'file-drop__preview-wrap' },
	              _react2.default.createElement(
	                'span',
	                { className: 'avatar-wrap' },
	                _react2.default.createElement('img', {
	                  className: 'avatar',
	                  src: photo.preview,
	                  alt: '',
	                  onLoad: function onLoad(e) {
	                    (0, _helpers.flagPortrait)(e, photo.preview);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'file-drop__remove',
	                  onClick: function onClick() {
	                    _this2.removePhoto('attachment');
	                  }
	                },
	                _react2.default.createElement(icons.iconMinus, null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation.choose_another
	                )
	              )
	            )
	          );
	        }),
	        existingImage.map(function (photo, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i, className: 'file-drop__preview' },
	            _react2.default.createElement(
	              'div',
	              { className: 'file-drop__preview-wrap' },
	              _react2.default.createElement(
	                'span',
	                { className: 'avatar-wrap' },
	                _react2.default.createElement('img', {
	                  className: 'avatar',
	                  src: photo,
	                  alt: '',
	                  onLoad: function onLoad(e) {
	                    (0, _helpers.flagPortrait)(e, photo);
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'file-drop__remove',
	                  onClick: function onClick() {
	                    _this2.removePhoto('existingImage');
	                  }
	                },
	                _react2.default.createElement(icons.iconMinus, null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation.choose_another
	                )
	              )
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return PhotoUpload;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('PhotoUpload')(PhotoUpload);

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var Activate = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Activate, _React$Component);
	
	  function Activate() {
	    _classCallCheck(this, Activate);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (Activate.__proto__ || Object.getPrototypeOf(Activate)).call(this));
	
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Activate, [{
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var _this = this;
	
	      var data = {
	        active: this.active.checked,
	        forceSetupVerification: false
	      };
	
	      var callback = function callback() {
	        _this.props.routing.history.push('/');
	      };
	
	      this.props.store.RegisterStore.updateProctor(data, callback);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          SettingsStore = _props$store.SettingsStore;
	      var userSettings = SettingsStore.userSettings;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'form',
	          {
	            className: 'panel',
	            onSubmit: function onSubmit(e) {
	              return _this3.props.checkValidity(e, _this3.handleSubmit);
	            },
	            noValidate: true
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__header' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'panel__title' },
	              _react2.default.createElement(
	                'legend',
	                null,
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__body' },
	            userSettings.active && _react2.default.createElement(
	              'p',
	              { className: 'note note--prominent' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.body_active
	              ),
	              ' ',
	              translation.body
	            ),
	            !userSettings.active && _react2.default.createElement(
	              'p',
	              { className: 'note note--prominent' },
	              _react2.default.createElement(
	                'strong',
	                null,
	                translation.body_inactive
	              ),
	              ' ',
	              translation.body
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement('input', {
	                    type: 'checkbox',
	                    id: 'activate',
	                    className: 'switch-input',
	                    ref: function ref(input) {
	                      return _this3.active = input;
	                    },
	                    value: true,
	                    defaultChecked: userSettings.active
	                  }),
	                  _react2.default.createElement(
	                    'label',
	                    {
	                      className: 'switch-label',
	                      htmlFor: 'activate'
	                    },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'meta' },
	                      translation.activate
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    {
	                      className: 'switch-label--alt',
	                      htmlFor: 'activate'
	                    },
	                    translation.activate
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel__actions actions' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'actions__btn actions__btn--secondary',
	                  onClick: this.props.prevStep,
	                  type: 'button'
	                },
	                translation.back
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'actions__btn actions__btn--primary',
	                  type: 'submit'
	                },
	                translation.button
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return Activate;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Activate')(Activate);

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _config = __webpack_require__(24);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _rcSlider = __webpack_require__(1114);
	
	var _rcSlider2 = _interopRequireDefault(_rcSlider);
	
	var _reactTabs = __webpack_require__(79);
	
	var _reactCheckboxGroup = __webpack_require__(1139);
	
	var _reactRadioGroup = __webpack_require__(512);
	
	var _reactTextareaAutosize = __webpack_require__(98);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	var _reactLaunchDarkly = __webpack_require__(60);
	
	var _icnRegisterblast = __webpack_require__(1281);
	
	var _icnRegisterblast2 = _interopRequireDefault(_icnRegisterblast);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Map = __webpack_require__(878);
	
	var _Map2 = _interopRequireDefault(_Map);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	// Slider tooltips
	var createSliderWithTooltip = _rcSlider2.default.createSliderWithTooltip;
	var Range = createSliderWithTooltip(_rcSlider2.default.Range);
	
	var Location = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Location, _React$Component);
	
	  function Location() {
	    _classCallCheck(this, Location);
	
	    // Default state that we will manipulate and send to the API
	    var _this2 = _possibleConstructorReturn(this, (Location.__proto__ || Object.getPrototypeOf(Location)).call(this));
	
	    _this2.state = {
	      priceGroups: [{
	        title: 'Global',
	        registerBlastExamGroup: null,
	        registerBlastWrittenExamGroupKey: null,
	        registerBlastHybridExamGroupKey: null,
	        smarterSchedulingCalendarSid: null,
	        enabled: true,
	        priceModel: 'tiered',
	        currencies: ['USD'],
	        editingCurrencies: false,
	        sessionLength: [0, 480],
	        account: {
	          sid: null,
	          name: null
	        },
	        fees: [{
	          minimumSessionLength: 0,
	          maximumSessionLength: 480,
	          amounts: {
	            USD: {
	              service: 0,
	              late: 0
	            }
	          }
	        }]
	      }],
	      timeZoneSid: null,
	      currencyCode: null,
	      tabs: ['Location', 'Details', 'Pricing'],
	      tabsDisabled: false,
	      activeTab: 1,
	      create: true,
	      newLocation: false
	    };
	
	    // Bind this to functions
	    _this2.handlePriceOpts = _this2.handlePriceOpts.bind(_this2);
	    _this2.setLocation = _this2.setLocation.bind(_this2);
	    _this2.updateLocationOpts = _this2.updateLocationOpts.bind(_this2);
	    _this2.updateCurrencies = _this2.updateCurrencies.bind(_this2);
	    _this2.editCurrencies = _this2.editCurrencies.bind(_this2);
	    _this2.addPriceGroup = _this2.addPriceGroup.bind(_this2);
	    _this2.onRangeChange = _this2.onRangeChange.bind(_this2);
	    _this2.addRange = _this2.addRange.bind(_this2);
	    _this2.updateFee = _this2.updateFee.bind(_this2);
	    _this2.handleTabs = _this2.handleTabs.bind(_this2);
	    _this2.handleContinue = _this2.handleContinue.bind(_this2);
	    _this2.handleBack = _this2.handleBack.bind(_this2);
	    _this2.handleInput = _this2.handleInput.bind(_this2);
	    _this2.handleToggle = _this2.handleToggle.bind(_this2);
	    _this2.handleLocationSubmit = _this2.handleLocationSubmit.bind(_this2);
	    _this2.createLocation = _this2.createLocation.bind(_this2);
	    _this2.updateLocation = _this2.updateLocation.bind(_this2);
	    _this2.createLocationAvailability = _this2.createLocationAvailability.bind(_this2);
	    _this2.handleFeesSubmit = _this2.handleFeesSubmit.bind(_this2);
	    _this2.renderPolicies = _this2.renderPolicies.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Location, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var _props$store = this.props.store,
	          LocationStore = _props$store.LocationStore,
	          ScheduleStore = _props$store.ScheduleStore,
	          SessionStore = _props$store.SessionStore,
	          PolicyStore = _props$store.PolicyStore;
	
	      // Get API data for time zones, currencies, and location types
	
	      SessionStore.getTimezones();
	      SessionStore.getCurrencies();
	      SessionStore.getAccounts();
	      LocationStore.getLocationTypes();
	
	      // Make sure data from previous locations has been removed
	      LocationStore.resetLocation();
	
	      // Get cancellation policies
	      PolicyStore.getCancellationPolicies();
	
	      // Check and clear location calendars array
	      if (ScheduleStore.locationCalendars && ScheduleStore.locationCalendars.length && ScheduleStore.locationCalendars.length > 0) {
	        ScheduleStore.locationCalendars = [];
	      }
	
	      // If this is the register location form, or the add a new location form,
	      // set newLocation to true since we’re creating a new location
	      if (this.props.routing.location.pathname.indexOf('register') > -1 || this.props.routing.location.pathname.indexOf('add') > -1) {
	        this.setState({
	          newLocation: true
	        });
	      }
	
	      // If this is a pre-existing location, get the data
	      if (this.props.locationSid) {
	        LocationStore.getLocation(this.props.locationSid);
	        LocationStore.getLocationAvailability(this);
	
	        if (LocationStore.locations && LocationStore.locations.length && LocationStore.locations.length > 0) {
	          // Find corresponding location based on locationSid
	          var _JSON$parse$filter = JSON.parse(JSON.stringify(LocationStore.locations)).filter(function (x) {
	            return x.sid === _this3.props.locationSid;
	          }),
	              _JSON$parse$filter2 = _slicedToArray(_JSON$parse$filter, 1),
	              currentLocationData = _JSON$parse$filter2[0];
	
	          // If the location scheduling module is 'smarter-scheduling', get location calendars
	
	
	          if (currentLocationData && currentLocationData.schedulingModule === 'smarter-scheduling') {
	            ScheduleStore.getLocationCalendars(this.props.locationSid, true);
	          }
	        }
	
	        // Set create to false since we’re updating
	        this.setState({
	          create: false
	        });
	      } else {
	        // Make sure there isn’t an old locationSid in the LocationStore
	        this.props.store.LocationStore.locationSid = null;
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      var _props$store2 = this.props.store,
	          LocationStore = _props$store2.LocationStore,
	          ScheduleStore = _props$store2.ScheduleStore,
	          SessionStore = _props$store2.SessionStore;
	
	
	      if (nextState.activeTab === 3 && SessionStore.account && !LocationStore.gettingGroups && LocationStore.examGroups.length === 0) {
	        // Check if there are exam groups
	        if (SessionStore.account.metadata && SessionStore.account.metadata.campusKey || LocationStore.locationData.registerBlastCampusKey) {
	          LocationStore.getExamGroups(LocationStore.locationSid);
	        }
	      }
	
	      // Get location calendars
	      if (SessionStore.smarterscheduling && LocationStore.locationData.schedulingModule === 'smarter-scheduling' && ScheduleStore.locationCalendars.length === 0) {
	        if (nextState.activeTab === 3 && SessionStore.loadingCalls.indexOf('getLocationCalendars') < 0) {
	          ScheduleStore.getLocationCalendars(LocationStore.locationSid);
	        }
	      }
	    }
	
	    // Format location data and send it to the LocationStore
	
	  }, {
	    key: 'setLocation',
	    value: function setLocation(name, address1, address2, city, region, country, postalCode, lat, lng, preventRender) {
	      var LocationStore = this.props.store.LocationStore;
	
	
	      var data = {
	        address1: address1,
	        address2: address2,
	        place: city,
	        region: region,
	        country: country,
	        postalCode: postalCode,
	        locationLatitude: lat,
	        locationLongitude: lng,
	        preventRender: preventRender
	
	        // If there is no location name set and there's a name returned from google, set name to data object for location update
	      };if (!LocationStore.locationData.name && name) {
	        data.name = name;
	      }
	
	      this.props.store.LocationStore.updateLocationData(data);
	    }
	
	    // Handle price model switching (i.e. flat or tiered)
	
	  }, {
	    key: 'handlePriceOpts',
	    value: function handlePriceOpts(value, index) {
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[index]);
	
	      updatedPriceGroup.priceModel = value;
	
	      priceGroups.splice(index, 1, updatedPriceGroup);
	
	      // If setting pricing model to flat, remove the extra fee object
	      if (value === 'flat') {
	        updatedPriceGroup.fees.length = 1;
	        updatedPriceGroup.fees[0].maximumSessionLength = 480;
	        updatedPriceGroup.sessionLength = [0, 480];
	      }
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Update late lead time
	
	  }, {
	    key: 'updatePriceGroupData',
	    value: function updatePriceGroupData(i) {
	      var LocationStore = this.props.store.LocationStore;
	
	
	      var data = parseInt(this['leadTime' + i].value, 10) || 0;
	
	      LocationStore.updateAvailabilityData(i, data, 'lateSchedulingLeadTime');
	
	      // Update local state
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[i]);
	      updatedPriceGroup.lateSchedulingLeadTime = parseInt(this['leadTime' + i].value, 10) || 0;
	
	      if (data === 0) {
	        updatedPriceGroup.fees.forEach(function (element) {
	          Object.keys(element.amounts).map(function (key) {
	            element.amounts[key].late = 0;
	            return true;
	          });
	        });
	      }
	
	      priceGroups.splice(i, 1, updatedPriceGroup);
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Update calendar
	
	  }, {
	    key: 'updateCalendar',
	    value: function updateCalendar(e, i) {
	      var LocationStore = this.props.store.LocationStore;
	
	
	      var data = e.target.value;
	
	      LocationStore.updateAvailabilityData(i, data, 'smarterSchedulingCalendarSid');
	
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[i]);
	      updatedPriceGroup.smarterSchedulingCalendarSid = data;
	
	      priceGroups.splice(i, 1, updatedPriceGroup);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Update exam group
	
	  }, {
	    key: 'updateExamGroup',
	    value: function updateExamGroup(e, i, name) {
	      var LocationStore = this.props.store.LocationStore;
	
	
	      var data = e.target.value;
	      var prop = 'registerBlastExamGroup';
	
	      if (name === 'written') {
	        prop = 'registerBlastWrittenExamGroupKey';
	      }
	
	      if (name === 'hybrid') {
	        prop = 'registerBlastHybridExamGroupKey';
	      }
	
	      LocationStore.updateAvailabilityData(i, data, prop);
	
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[i]);
	      updatedPriceGroup[prop] = data;
	
	      priceGroups.splice(i, 1, updatedPriceGroup);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Set default timezone and currency
	
	  }, {
	    key: 'updateLocationOpts',
	    value: function updateLocationOpts() {
	      var timeZoneSid = this.timezone.value || null;
	      var currencyCode = this.defaultCurrency.value || null;
	      var proctorLocationTypeSid = this.locationType.value || null;
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[0]);
	
	      var data = {
	        timeZoneSid: timeZoneSid,
	        currencyCode: currencyCode,
	        proctorLocationTypeSid: proctorLocationTypeSid,
	        preventRender: true
	      };
	
	      var fees = {
	        minimumSessionLength: 0,
	        maximumSessionLength: 480,
	        amounts: _defineProperty({}, currencyCode, {
	          service: 0,
	          late: 0
	        })
	      };
	
	      updatedPriceGroup.fees = [fees];
	      updatedPriceGroup.currencies = [currencyCode];
	      updatedPriceGroup.sessionLength = [0, 480];
	
	      priceGroups.splice(0, 1, updatedPriceGroup);
	
	      this.setState({
	        currencyCode: currencyCode,
	        timeZoneSid: timeZoneSid,
	        proctorLocationTypeSid: proctorLocationTypeSid,
	        priceGroups: priceGroups
	      });
	
	      this.props.store.LocationStore.updateLocationData(data);
	    }
	
	    // Add or remove currencies
	
	  }, {
	    key: 'updateCurrencies',
	    value: function updateCurrencies(value, index) {
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[index]);
	
	      // Add to currencies array
	      updatedPriceGroup.currencies = value;
	
	      // Add new currencies to fees array
	      var updatedFees = [];
	      var updatedAmounts = {};
	
	      for (var i = 0; i < updatedPriceGroup.fees.length; i++) {
	        var _removeOld = function _removeOld(updatedAmounts) {
	          Object.keys(updatedAmounts).map(function (key) {
	            if (updatedPriceGroup.currencies.indexOf(key) === -1) {
	              delete updatedAmounts[key];
	            }
	            return updatedAmounts;
	          });
	        };
	
	        var newFeeObject = {};
	
	        for (var j = 0; j < value.length; j++) {
	          if (j > updatedPriceGroup.fees.length) {
	            updatedAmounts[value[j]] = {
	              service: 0,
	              late: 0
	            };
	          } else {
	            updatedAmounts = updatedPriceGroup.fees[i].amounts;
	
	            // Remove old currencies
	            _removeOld(updatedAmounts);
	          }
	        }
	
	        newFeeObject.minimumSessionLength = updatedPriceGroup.fees[i].minimumSessionLength;
	        newFeeObject.maximumSessionLength = updatedPriceGroup.fees[i].maximumSessionLength;
	        newFeeObject.amounts = updatedAmounts;
	        updatedFees.push(newFeeObject);
	      }
	
	      updatedPriceGroup.fees = updatedFees;
	
	      // Update state
	      priceGroups.splice(index, 1, updatedPriceGroup);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Show or hide the currency selector
	
	  }, {
	    key: 'editCurrencies',
	    value: function editCurrencies(index) {
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[index]);
	
	      updatedPriceGroup.editingCurrencies = !updatedPriceGroup.editingCurrencies;
	
	      priceGroups.splice(index, 1, updatedPriceGroup);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Add new price group (availability)
	
	  }, {
	    key: 'addPriceGroup',
	    value: function addPriceGroup() {
	      // Make API call
	      if (this.priceGroup.value) {
	        this.props.store.LocationStore.createLocationAvailability(this.priceGroup.value, this);
	      }
	
	      // Reset select element
	      this.priceGroup.value = '';
	    }
	
	    // Remove price group (availability)
	
	  }, {
	    key: 'removePriceGroup',
	    value: function removePriceGroup(index, sid) {
	      this.props.store.LocationStore.removeLocationAvailability(sid, this);
	
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      priceGroups.splice(index, 1);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Enable or disable price group (availability)
	
	  }, {
	    key: 'togglePriceGroup',
	    value: function togglePriceGroup(e, i) {
	      var translation = this.props.translation;
	      var _props$store3 = this.props.store,
	          LocationStore = _props$store3.LocationStore,
	          SessionStore = _props$store3.SessionStore;
	
	      LocationStore.toggleLocationAvailability(i);
	
	      // Show a warning message if user is disabling
	      // the global price group
	      if (!e.target.checked && !this.state.priceGroups[i].account) {
	        var content = translation.disable_msg;
	        SessionStore.showDialog(content);
	      }
	    }
	  }, {
	    key: 'sortNumber',
	    value: function sortNumber(a, b) {
	      return a - b;
	    }
	  }, {
	    key: 'sortObject',
	    value: function sortObject(a, b) {
	      if (a.minimumSessionLength < b.minimumSessionLength) {
	        return -1;
	      } else if (a.minimumSessionLength > b.minimumSessionLength) {
	        return 1;
	      }
	
	      return 0;
	    }
	
	    // Add new range to tiered pricing
	
	  }, {
	    key: 'addRange',
	    value: function addRange(activePriceGroup, index) {
	      var rangeCount = activePriceGroup.sessionLength.length;
	      var upperBound = activePriceGroup.sessionLength[rangeCount - 1];
	      var lowerBound = activePriceGroup.sessionLength[rangeCount - 2];
	      var newBound = (upperBound - lowerBound) / 2 + lowerBound;
	      newBound = Math.ceil(newBound / 30) * 30;
	
	      // Make sure the new range is smaller than the limit
	      if (newBound < upperBound) {
	        var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	        var updatedPriceGroup = Object.assign({}, priceGroups[index]);
	
	        // Add new session length
	        var sessionLength = [].concat(_toConsumableArray(updatedPriceGroup.sessionLength.concat(newBound)));
	        sessionLength.sort(this.sortNumber);
	        updatedPriceGroup.sessionLength = sessionLength;
	
	        // Add new fees object and modify existing
	        var fees = [].concat(_toConsumableArray(updatedPriceGroup.fees));
	        var lastFees = fees.pop();
	        var newFees = Object.assign({}, lastFees);
	
	        newFees.minimumSessionLength = lowerBound;
	        newFees.maximumSessionLength = newBound;
	        lastFees.minimumSessionLength = newBound;
	
	        updatedPriceGroup.fees = updatedPriceGroup.fees.concat(newFees);
	        updatedPriceGroup.fees.sort(this.sortObject);
	
	        // Update state
	        priceGroups.splice(index, 1, updatedPriceGroup);
	
	        this.setState({
	          priceGroups: priceGroups
	        });
	      }
	    }
	
	    // Remove range from tiered pricing
	
	  }, {
	    key: 'removeRange',
	    value: function removeRange(activePriceGroup, index, i) {
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[index]);
	      var sessionLength = [].concat(_toConsumableArray(updatedPriceGroup.sessionLength));
	      var fees = [].concat(_toConsumableArray(updatedPriceGroup.fees));
	      sessionLength.splice(i, 1);
	      fees.splice(i - 1, 1);
	
	      updatedPriceGroup.sessionLength = sessionLength;
	      updatedPriceGroup.fees = fees;
	      priceGroups.splice(index, 1, updatedPriceGroup);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Update ranges when dragged
	
	  }, {
	    key: 'onRangeChange',
	    value: function onRangeChange(sessionLength, index) {
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[index]);
	
	      // Update session lengths
	      updatedPriceGroup.sessionLength = sessionLength;
	
	      // Update fees objects
	      var fees = [].concat(_toConsumableArray(updatedPriceGroup.fees));
	
	      for (var j = 0; j < fees.length; j++) {
	        var updatedFees = Object.assign({}, fees[j]);
	        var lowerBound = updatedPriceGroup.sessionLength[j];
	        var upperBound = updatedPriceGroup.sessionLength[j + 1];
	
	        updatedFees.minimumSessionLength = lowerBound;
	        updatedFees.maximumSessionLength = upperBound;
	
	        fees[j] = updatedFees;
	      }
	
	      updatedPriceGroup.fees = fees;
	
	      // Update state
	      priceGroups.splice(index, 1, updatedPriceGroup);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	
	    // Update fee properties on input
	
	  }, {
	    key: 'updateFee',
	    value: function updateFee(e, priceGroupIndex, currencyIndex, sessionIndex, fieldType, priceType) {
	      var newFee = e.target.value || 0;
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[priceGroupIndex]);
	      var currencyName = updatedPriceGroup.currencies[currencyIndex];
	
	      // If flat, set the session index to 0 since there is only one fee element
	      if (priceType === 'flat') {
	        sessionIndex = 0;
	      }
	
	      // Update fees objects
	      var fees = [].concat(_toConsumableArray(updatedPriceGroup.fees));
	
	      if (fieldType === 'service') {
	        var amounts = Object.assign({}, fees[sessionIndex].amounts);
	        var currency = Object.assign({}, amounts[currencyName]);
	        var service = Object.assign({}, currency.service);
	
	        for (var i = 0; i < fees.length; i++) {
	          if (i === sessionIndex) {
	            service = newFee;
	            currency.service = service;
	            amounts[currencyName] = currency;
	            fees[i].amounts = amounts;
	          }
	        }
	      } else {
	        for (var _i = 0; _i < fees.length; _i++) {
	          var _amounts2 = Object.assign({}, fees[_i].amounts);
	          var _currency = Object.assign({}, _amounts2[currencyName]);
	          var late = Object.assign({}, _currency.late);
	
	          late = newFee;
	          _currency.late = late;
	          _amounts2[currencyName] = _currency;
	          fees[_i].amounts = _amounts2;
	        }
	      }
	
	      // Update state
	      priceGroups.splice(priceGroupIndex, 1, updatedPriceGroup);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	  }, {
	    key: 'applyPolicy',
	    value: function applyPolicy(e, priceGroupIndex) {
	      var LocationStore = this.props.store.LocationStore;
	
	      var priceGroups = [].concat(_toConsumableArray(this.state.priceGroups));
	      var updatedPriceGroup = Object.assign({}, priceGroups[priceGroupIndex]);
	
	      var data = e.target.value;
	
	      if (data) {
	        updatedPriceGroup.cancellationPolicySid = data;
	
	        LocationStore.updateAvailabilityData(priceGroupIndex, data, 'cancellationPolicySid');
	      } else {
	        updatedPriceGroup.cancellationPolicySid = null;
	      }
	
	      // Update state
	      priceGroups.splice(priceGroupIndex, 1, updatedPriceGroup);
	
	      this.setState({
	        priceGroups: priceGroups
	      });
	    }
	  }, {
	    key: 'handleTabs',
	    value: function handleTabs(index) {
	      this.setState({
	        activeTab: index + 1
	      });
	    }
	
	    // Decide what to do when tab form is submitted
	
	  }, {
	    key: 'handleContinue',
	    value: function handleContinue(e) {
	      (0, _helpers.toTop)(document.querySelector('.drawer.open'));
	
	      // If it’s the last tab
	      if (this.state.activeTab === this.state.tabs.length) {
	        // If we’re registering, go to next step
	        if (this.props.routing.location.pathname.indexOf('register') > -1) {
	          this.props.nextStep(e);
	        }
	        // Otherwise, close the drawer
	        else if (this.props.checkup) {
	            (0, _helpers.closeDrawer)(null, this.props.parent);
	
	            // Mark the location as confirmed
	            var confirmedLocations = [].concat(_toConsumableArray(this.props.parent.state.confirmedLocations));
	
	            confirmedLocations.push(this.props.locationSid);
	
	            this.props.parent.setState({
	              confirmedLocations: confirmedLocations
	            });
	          } else {
	            (0, _helpers.closeDrawer)(null, this.props.parent, '/locations');
	
	            this.props.store.SessionStore.showToaster(this.props.translation.success, 'success');
	
	            this.props.store.LocationStore.getLocations();
	
	            document.querySelector('body').classList.remove('drawer-open');
	            document.querySelector('body').classList.remove('drawer-open');
	          }
	      } else {
	        document.querySelector('form.location-form').className = document.querySelector('form.location-form').className.replace('submitted', '');
	
	        // Click the next tab if we’re not already on the last one
	        var tabs = document.querySelectorAll('.ReactTabs__Tab');
	        var nextTab = tabs[this.state.activeTab];
	        nextTab.click();
	      }
	    }
	
	    // Decide what to do when the back button is clicked
	
	  }, {
	    key: 'handleBack',
	    value: function handleBack(e) {
	      this.props.store.LocationStore.renderMap = true;
	
	      // If we’re registering and we’re already on the first tab,
	      // go back to the previous step
	      if (this.state.activeTab === 1) {
	        this.props.prevStep(e);
	      } else {
	        // Otherwise go back to the previous tab
	        document.querySelector('form.location-form').className = document.querySelector('form.location-form').className.replace('submitted', '');
	
	        var tabs = document.querySelectorAll('.ReactTabs__Tab');
	        var prevTab = tabs[this.state.activeTab - 2];
	        prevTab.click();
	      }
	    }
	
	    // Update boolean location data (smoke free, technology available, etc.)
	
	  }, {
	    key: 'handleToggle',
	    value: function handleToggle(key) {
	      var LocationStore = this.props.store.LocationStore;
	
	      LocationStore.locationData[key] = !LocationStore.locationData[key];
	      this.handleInput();
	    }
	
	    // Handle location text input
	
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      var data = null;
	
	      if (this.state.activeTab === 1) {
	        // We only submit the name and address on the first tab
	        data = {
	          name: this.name.value || null,
	          address1: this.address1.value || null,
	          address2: this.address2.value || null,
	          place: this.place.value || null,
	          region: this.region.value || null,
	          postalCode: this.postalCode.value || null,
	          country: this.country.value || null
	        };
	      } else {
	        // Second tab contains more detailed location data
	        data = {
	          notes: this.notes.value || null,
	          smokeFree: this.smokeFree.checked,
	          parkingInformation: this.parkingInformation.value || null,
	          hasComputerAvailable: this.hasComputerAvailable.checked,
	          hasPrinterAvailable: this.hasPrinterAvailable.checked,
	          hasCopierAvailable: this.hasCopierAvailable.checked,
	          hasFaxAvailable: this.hasFaxAvailable.checked,
	          hasElevator: this.hasElevator.checked,
	          hasWheelchairRamp: this.hasWheelchairRamp.checked,
	          hasAlternativeKeyboards: this.hasAlternativeKeyboards.checked,
	          hasScreenEnlarger: this.hasScreenEnlarger.checked,
	          hasScreenReader: this.hasScreenReader.checked,
	          hasSpeechRecognition: this.hasSpeechRecognition.checked,
	          hasTextToSpeech: this.hasTextToSpeech.checked,
	          hasDistractionFreeRooms: this.hasDistractionFreeRooms.checked,
	          timeZoneSid: this.timezone.value || null,
	          currencyCode: this.defaultCurrency.value || null,
	          proctorLocationTypeSid: this.locationType.value || null
	        };
	      }
	
	      // Don’t re-render
	      data.preventRender = true;
	
	      this.props.store.LocationStore.updateLocationData(data);
	    }
	
	    // Decide what to do when a location form is submitted
	
	  }, {
	    key: 'handleLocationSubmit',
	    value: function handleLocationSubmit(e) {
	      if (this.state.create) {
	        // If this is the first submission for the location (i.e. first tab of add form)
	        // create it and set the state create to false so it doesn’t get created again
	        this.createLocation(e);
	        this.setState({
	          create: false
	        });
	      } else {
	        // Otherwise, update it
	        this.updateLocation(e);
	      }
	
	      if (document.querySelector('.drawer')) {
	        document.querySelector('.drawer').scrollTop = 0;
	      }
	    }
	  }, {
	    key: 'createLocation',
	    value: function createLocation(e) {
	      this.props.store.LocationStore.createLocation(this.handleContinue, this.props.parent);
	    }
	  }, {
	    key: 'updateLocation',
	    value: function updateLocation(e) {
	      this.props.store.LocationStore.updateLocation(this.handleContinue, this.props.locationSid);
	    }
	  }, {
	    key: 'createLocationAvailability',
	    value: function createLocationAvailability() {
	      this.props.store.LocationStore.createLocationAvailability();
	    }
	  }, {
	    key: 'handleFeesSubmit',
	    value: function handleFeesSubmit(e) {
	      this.props.store.LocationStore.updateFees(this.state.priceGroups, this.handleContinue);
	    }
	  }, {
	    key: 'renderPolicies',
	    value: function renderPolicies(i) {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'fieldset',
	        { className: 'form-section' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: 'cancellation-' + i },
	          translation.cancellation_policy
	        ),
	        _react2.default.createElement(
	          'label',
	          { className: 'select' },
	          _react2.default.createElement(
	            'select',
	            {
	              id: 'cancellation-' + i,
	              onChange: function onChange(e) {
	                return _this4.applyPolicy(e, i);
	              },
	              defaultValue: this.state.priceGroups[i].cancellationPolicySid
	            },
	            _react2.default.createElement(
	              'option',
	              { value: '' },
	              translation.none_selected
	            ),
	            this.props.store.PolicyStore.cancellationPolicies.map(function (policy) {
	              return _react2.default.createElement(
	                'option',
	                { key: policy.sid, value: policy.sid },
	                policy.title
	              );
	            })
	          )
	        )
	      );
	    }
	
	    // Main render
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var translation = this.props.translation;
	      var _props$store4 = this.props.store,
	          LocationStore = _props$store4.LocationStore,
	          SessionStore = _props$store4.SessionStore;
	      var locationData = LocationStore.locationData;
	
	
	      var center = {
	        lat: locationData.locationLatitude || 37.09024,
	        lng: locationData.locationLongitude || -95.712891
	      };
	
	      var tabClass = '';
	
	      // Disable clicking of tabs if we’re creating a new location
	      if (this.state.newLocation || this.props.checkup) {
	        tabClass = 'tabs-disabled';
	      } else {
	        tabClass = 'tabs-enabled';
	      }
	
	      // Don’t use the default tab styles
	      _reactTabs.Tabs.setUseDefaultStyles(false);
	
	      // Default map options
	      var zoom = 4;
	      var dropPin = false;
	      var locationClass = null;
	
	      if (locationData.locationLatitude) {
	        // If it’s not a new location, increase the zoom and drop a pin
	        zoom = 17;
	        dropPin = true;
	        locationClass = 'location--selected';
	      } else {
	        // Otherwise, just render the map with the default options
	        LocationStore.renderMap = true;
	      }
	
	      // Default select values
	      var _this = this;
	      function defaultValue(value) {
	        if (_this.state.newLocation) {
	          return '';
	        } else {
	          return value;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__header' },
	          this.state.newLocation && _react2.default.createElement(
	            'h3',
	            { className: 'panel__title' },
	            _react2.default.createElement(
	              'legend',
	              null,
	              translation.add_heading
	            )
	          ),
	          !this.state.newLocation && _react2.default.createElement(
	            'h3',
	            { className: 'panel__title' },
	            _react2.default.createElement(
	              'legend',
	              null,
	              translation.edit_heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__body' },
	          _react2.default.createElement(
	            'article',
	            { className: 'location ' + locationClass },
	            _react2.default.createElement(
	              _reactTabs.Tabs,
	              {
	                onSelect: this.handleTabs
	              },
	              _react2.default.createElement(
	                _reactTabs.TabList,
	                { className: tabClass },
	                _react2.default.createElement(
	                  _reactTabs.Tab,
	                  null,
	                  translation.location
	                ),
	                _react2.default.createElement(
	                  _reactTabs.Tab,
	                  null,
	                  translation.details
	                ),
	                _react2.default.createElement(
	                  _reactTabs.Tab,
	                  null,
	                  translation.pricing
	                )
	              ),
	              _react2.default.createElement(
	                _reactTabs.TabPanel,
	                { className: 'location__search' },
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'meta' },
	                  translation.location
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'note note--prominent' },
	                  _react2.default.createElement(icons.iconExclamation, null),
	                  ' ',
	                  translation.disclaimer
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { className: 'location-form', onSubmit: function onSubmit(e) {
	                      e.preventDefault();
	                    }, noValidate: true },
	                  _react2.default.createElement(_Map2.default, {
	                    setLocation: this.setLocation,
	                    store: this.props.store,
	                    center: center,
	                    zoom: zoom,
	                    dropPin: dropPin,
	                    locationSid: this.props.locationSid
	                  }),
	                  _react2.default.createElement(
	                    'fieldset',
	                    { className: 'location__address' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'fields' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'lbl-required',
	                            htmlFor: 'map-name'
	                          },
	                          translation.location_name
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'text',
	                          id: 'map-name',
	                          value: locationData.name || '',
	                          onChange: this.handleInput,
	                          ref: function ref(input) {
	                            return _this5.name = input;
	                          },
	                          required: true,
	                          'aria-required': 'true',
	                          disabled: locationData.locked
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'lbl-required',
	                            htmlFor: 'map-addr1'
	                          },
	                          translation.address
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'text',
	                          id: 'map-addr1',
	                          value: locationData.address1 || '',
	                          placeholder: translation.street_address,
	                          onChange: this.handleInput,
	                          ref: function ref(input) {
	                            return _this5.address1 = input;
	                          },
	                          required: true,
	                          'aria-required': 'true',
	                          disabled: locationData.locked
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'meta',
	                            htmlFor: 'map-addr2'
	                          },
	                          translation.address_2
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'text',
	                          id: 'map-addr2',
	                          value: locationData.address2 || '',
	                          placeholder: translation.suite,
	                          onChange: this.handleInput,
	                          ref: function ref(input) {
	                            return _this5.address2 = input;
	                          },
	                          disabled: locationData.locked
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'lbl-required',
	                            htmlFor: 'map-city'
	                          },
	                          translation.city
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'text',
	                          id: 'map-city',
	                          value: locationData.place || '',
	                          onChange: this.handleInput,
	                          ref: function ref(input) {
	                            return _this5.place = input;
	                          },
	                          disabled: locationData.locked
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { className: 'field--third' },
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'lbl-required',
	                            htmlFor: 'map-region'
	                          },
	                          translation.region
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'text',
	                          id: 'map-city',
	                          value: locationData.region || '',
	                          onChange: this.handleInput,
	                          ref: function ref(input) {
	                            return _this5.region = input;
	                          },
	                          disabled: locationData.locked
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { className: 'field--third' },
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'lbl-required',
	                            htmlFor: 'map-postal'
	                          },
	                          translation.postal
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'text',
	                          id: 'map-city',
	                          value: locationData.postalCode || '',
	                          onChange: this.handleInput,
	                          ref: function ref(input) {
	                            return _this5.postalCode = input;
	                          },
	                          disabled: locationData.locked
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        { className: 'field--third' },
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'lbl-required',
	                            htmlFor: 'map-country'
	                          },
	                          translation.country
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'text',
	                          id: 'map-city',
	                          value: locationData.postalCode || '',
	                          onChange: this.handleInput,
	                          ref: function ref(input) {
	                            return _this5.country = input;
	                          },
	                          disabled: locationData.locked
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactTabs.TabPanel,
	                null,
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'meta' },
	                  translation.details
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { className: 'location-form', onSubmit: function onSubmit(e) {
	                      return (0, _helpers.checkValidity)(e, _this5.handleLocationSubmit, 'form.location-form');
	                    }, noValidate: true },
	                  _react2.default.createElement(
	                    'fieldset',
	                    null,
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'fields' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'location-timezone' },
	                          translation.timezone
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select' },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: 'location-timezone',
	                              defaultValue: (0, _helpers.getURLSegment)(this, 1) === 'checkup' ? '' : defaultValue(locationData.timeZoneSid),
	                              onChange: this.updateLocationOpts,
	                              ref: function ref(input) {
	                                _this5.timezone = input;
	                              },
	                              required: true,
	                              'aria-required': 'true',
	                              disabled: locationData.locked
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation.timezone_helper
	                            ),
	                            SessionStore.timezoneList.map(function (key, i) {
	                              return _react2.default.createElement(
	                                'option',
	                                { key: i, value: key.sid },
	                                key.name.replace('_', ' ')
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-required', htmlFor: 'location-default-currency' },
	                          translation.default_currency
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select' },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: 'location-default-currency',
	                              defaultValue: defaultValue(locationData.currencyCode),
	                              onChange: this.updateLocationOpts,
	                              ref: function ref(input) {
	                                _this5.defaultCurrency = input;
	                              },
	                              required: true,
	                              'aria-required': 'true',
	                              disabled: locationData.locked
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation.currency_helper
	                            ),
	                            SessionStore.currencyList.map(function (key, i) {
	                              return _react2.default.createElement(
	                                'option',
	                                { key: i, value: key.code },
	                                key.name
	                              );
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            className: 'lbl-required',
	                            htmlFor: 'location-type'
	                          },
	                          translation.location_type.heading
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select' },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: 'location-type',
	                              defaultValue: (0, _helpers.getURLSegment)(this, 1) === 'checkup' ? '' : defaultValue(locationData.proctorLocationTypeSid),
	                              onChange: this.updateLocationOpts,
	                              ref: function ref(input) {
	                                _this5.locationType = input;
	                              },
	                              required: true,
	                              'aria-required': 'true',
	                              disabled: locationData.locked
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation.location_type_helper
	                            ),
	                            LocationStore.locationTypesList.map(function (key, i) {
	                              if (key.sid !== _config.config.coffeeShopSid) {
	                                return _react2.default.createElement(
	                                  'option',
	                                  { key: i, value: key.sid },
	                                  key.title
	                                );
	                              }
	
	                              return null;
	                            })
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-optional', htmlFor: 'location-notes' },
	                          translation.notes.label
	                        ),
	                        _react2.default.createElement(_reactTextareaAutosize2.default, {
	                          id: 'location-notes',
	                          className: 'textarea-grow',
	                          onChange: this.handleInput,
	                          ref: function ref(input) {
	                            _this5.notes = input;
	                          },
	                          defaultValue: locationData.notes
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: 'location-smoke-free' },
	                          translation.smoke_free
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'checkbox',
	                          id: 'location-smoke-free',
	                          className: 'switch-input',
	                          checked: locationData.smokeFree,
	                          onChange: function onChange() {
	                            _this5.handleToggle('smokeFree');
	                          },
	                          ref: function ref(input) {
	                            _this5.smokeFree = input;
	                          },
	                          disabled: locationData.locked
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: 'location-smoke-free', className: 'switch-label' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'meta' },
	                            translation.smoke_free
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'lbl-optional', htmlFor: 'location-parking' },
	                          translation.parking_instructions.label
	                        ),
	                        _react2.default.createElement(_reactTextareaAutosize2.default, {
	                          id: 'location-parking',
	                          className: 'textarea-grow',
	                          onChange: this.handleInput,
	                          ref: function ref(input) {
	                            _this5.parkingInformation = input;
	                          },
	                          defaultValue: locationData.parkingInformation,
	                          disabled: locationData.locked
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'h4',
	                      { className: 'form-heading' },
	                      translation.technology.heading
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'switch-list' },
	                      Object.keys(translation.technology.options).map(function (key) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: key },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'location-tech-' + key },
	                            translation.technology.options[key].label
	                          ),
	                          _react2.default.createElement('input', {
	                            type: 'checkbox',
	                            id: 'location-tech-' + key,
	                            name: 'tech[]',
	                            className: 'switch-input',
	                            checked: locationData[key],
	                            onChange: function onChange() {
	                              _this5.handleToggle(key);
	                            },
	                            ref: function ref(input) {
	                              _this5[key] = input;
	                            },
	                            disabled: locationData.locked
	                          }),
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'switch-label', htmlFor: 'location-tech-' + key },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'meta' },
	                              translation.technology.options[key].label
	                            )
	                          )
	                        );
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'h4',
	                      { className: 'form-heading' },
	                      translation.accessibility.heading
	                    ),
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'switch-list' },
	                      Object.keys(translation.accessibility.options).map(function (key) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: key },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'location-accessibility-' + key },
	                            translation.accessibility.options[key].label
	                          ),
	                          _react2.default.createElement('input', {
	                            type: 'checkbox',
	                            id: 'location-accessibility-' + key,
	                            name: 'accessibility[]',
	                            className: 'switch-input',
	                            checked: locationData[key],
	                            onChange: function onChange() {
	                              _this5.handleToggle(key);
	                            },
	                            ref: function ref(input) {
	                              _this5[key] = input;
	                            },
	                            disabled: locationData.locked
	                          }),
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'switch-label', htmlFor: 'location-accessibility-' + key },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'meta' },
	                              translation.accessibility.options[key].label
	                            )
	                          )
	                        );
	                      })
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactTabs.TabPanel,
	                null,
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'meta' },
	                  translation.pricing
	                ),
	                _react2.default.createElement(
	                  'form',
	                  { className: 'location-form', onSubmit: function onSubmit(e) {
	                      return (0, _helpers.checkValidity)(e, _this5.handleContinue, 'form.location-form');
	                    }, noValidate: true },
	                  _react2.default.createElement(
	                    'fieldset',
	                    null,
	                    this.renderPriceGroup()
	                  )
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'select' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.institution_pricing
	                  ),
	                  _react2.default.createElement(
	                    'select',
	                    { ref: function ref(input) {
	                        _this5.priceGroup = input;
	                      } },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '' },
	                      translation.institution_pricing
	                    ),
	                    SessionStore.accountList.map(function (key, i) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: i, value: key.sid },
	                        key.name
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  { className: 'btn btn--outline', onClick: this.addPriceGroup, type: 'button' },
	                  translation.add_institution
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.state.newLocation && _react2.default.createElement(
	              'div',
	              { className: 'panel__actions actions' },
	              (this.state.activeTab !== 1 || this.props.routing.location.pathname.indexOf('register') > -1) && _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--secondary', onClick: function onClick(e) {
	                    return _this5.handleBack(e);
	                  }, type: 'button' },
	                translation.back
	              ),
	              this.state.activeTab !== 2 && this.state.activeTab !== 1 && _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--primary', onClick: function onClick(e) {
	                    return (0, _helpers.checkValidity)(e, _this5.handleFeesSubmit, 'form.location-form');
	                  } },
	                translation.button
	              ),
	              (this.state.activeTab === 2 || this.state.activeTab === 1) && _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--primary', onClick: function onClick(e) {
	                    return (0, _helpers.checkValidity)(e, _this5.handleLocationSubmit, 'form.location-form');
	                  } },
	                translation.button
	              )
	            ),
	            !this.state.newLocation && _react2.default.createElement(
	              'div',
	              { className: 'panel__actions actions' },
	              this.state.activeTab !== 2 && this.state.activeTab !== 1 && _react2.default.createElement(
	                'button',
	                {
	                  className: 'actions__btn actions__btn--primary',
	                  onClick: function onClick(e) {
	                    return (0, _helpers.checkValidity)(e, _this5.handleFeesSubmit, 'form.location-form');
	                  }
	                },
	                this.props.checkup && translation.button,
	                !this.props.checkup && translation.save
	              ),
	              (this.state.activeTab === 2 || this.state.activeTab === 1) && _react2.default.createElement(
	                'button',
	                {
	                  className: 'actions__btn actions__btn--primary',
	                  onClick: function onClick(e) {
	                    return (0, _helpers.checkValidity)(e, _this5.handleLocationSubmit, 'form.location-form');
	                  }
	                },
	                this.props.checkup && translation.button,
	                !this.props.checkup && translation.save
	              )
	            )
	          )
	        )
	      );
	    }
	
	    // Render price groups (i.e. availabilities)
	
	  }, {
	    key: 'renderPriceGroup',
	    value: function renderPriceGroup() {
	      var _this6 = this;
	
	      var _props$store5 = this.props.store,
	          LocationStore = _props$store5.LocationStore,
	          ScheduleStore = _props$store5.ScheduleStore,
	          SessionStore = _props$store5.SessionStore;
	      var translation = this.props.translation;
	
	
	      if (LocationStore.locationAvailability.length === 0) {
	        return null;
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'fields' },
	          this.state.priceGroups.map(function (key, i) {
	            return _react2.default.createElement(
	              'div',
	              {
	                className: '\n                price-group\n                ' + (!LocationStore.locationAvailability[i].enabled ? 'disabled' : '') + '\n              ',
	                key: i
	              },
	              _react2.default.createElement(
	                'h4',
	                { className: 'form-heading' },
	                _this6.state.priceGroups[i].account && _react2.default.createElement(
	                  'span',
	                  null,
	                  _this6.state.priceGroups[i].account.sid && _this6.state.priceGroups[i].account.name + ' ' + translation.pricing,
	                  _this6.state.priceGroups[i].account.sid && _react2.default.createElement(
	                    'button',
	                    { className: 'btn--link alt-link', onClick: function onClick() {
	                        return _this6.removePriceGroup(i, _this6.state.priceGroups[i].sid);
	                      }, type: 'button' },
	                    translation.remove
	                  )
	                ),
	                !_this6.state.priceGroups[i].account && _react2.default.createElement(
	                  'span',
	                  null,
	                  translation.global,
	                  ' ',
	                  translation.pricing
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'price-group__enabled' },
	                _react2.default.createElement(
	                  'label',
	                  {
	                    htmlFor: 'g' + i + '-enabled',
	                    className: 'switch-label--alt'
	                  },
	                  LocationStore.locationAvailability[i].enabled ? translation.enabled : translation.disabled
	                ),
	                _react2.default.createElement('input', {
	                  type: 'checkbox',
	                  id: 'g' + i + '-enabled',
	                  className: 'switch-input',
	                  checked: LocationStore.locationAvailability[i].enabled,
	                  onChange: function onChange(e) {
	                    return _this6.togglePriceGroup(e, i);
	                  }
	                }),
	                _react2.default.createElement(
	                  'label',
	                  {
	                    htmlFor: 'g' + i + '-enabled',
	                    className: 'switch-label'
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    LocationStore.locationAvailability[i].enabled ? translation.enabled : translation.disabled
	                  )
	                )
	              ),
	              LocationStore.locationAvailability[i].enabled && _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-optional', htmlFor: 'g' + i + '-lead-time', 'aria-describedby': 'leadtime-tooltip' },
	                      translation.lead_time.label,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tooltip' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'tooltip__label' },
	                          '(?)'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { id: 'leadtime-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                          _this6.state.priceGroups[i].lateSchedulingLeadTime !== 0 && _react2.default.createElement(
	                            'span',
	                            null,
	                            translation.lead_time.late_fee_start,
	                            ' ',
	                            _this6.state.priceGroups[i].lateSchedulingLeadTime,
	                            ' ',
	                            translation.lead_time.hours,
	                            ' ',
	                            translation.lead_time.late_fee_end
	                          ),
	                          _this6.state.priceGroups[i].lateSchedulingLeadTime === 0 && _react2.default.createElement(
	                            'span',
	                            null,
	                            translation.lead_time.no_late_fee
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select', htmlFor: 'g' + i + '-lead-time' },
	                      _react2.default.createElement(
	                        'select',
	                        { id: 'g' + i + '-lead-time', defaultValue: _this6.state.priceGroups[i].lateSchedulingLeadTime, onChange: function onChange() {
	                            return _this6.updatePriceGroupData(i);
	                          }, ref: function ref(input) {
	                            _this6['leadTime' + i] = input;
	                          } },
	                        _react2.default.createElement(
	                          'option',
	                          { value: 0 },
	                          '0 ',
	                          translation.lead_time.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 6 },
	                          '6 ',
	                          translation.lead_time.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 12 },
	                          '12 ',
	                          translation.lead_time.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 18 },
	                          '18 ',
	                          translation.lead_time.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 24 },
	                          '24 ',
	                          translation.lead_time.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 30 },
	                          '30 ',
	                          translation.lead_time.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 36 },
	                          '36 ',
	                          translation.lead_time.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 42 },
	                          '42 ',
	                          translation.lead_time.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 48 },
	                          '48 ',
	                          translation.lead_time.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 60 },
	                          '60 ',
	                          translation.lead_time.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: 72 },
	                          '72 ',
	                          translation.lead_time.hours
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required' },
	                      translation.price_model
	                    ),
	                    _react2.default.createElement(
	                      _reactRadioGroup.RadioGroup,
	                      {
	                        name: 'price-model' + i,
	                        selectedValue: _this6.state.priceGroups[i].priceModel,
	                        onChange: function onChange(value) {
	                          return _this6.handlePriceOpts(value, i);
	                        }
	                      },
	                      _react2.default.createElement(_reactRadioGroup.Radio, {
	                        id: 'g' + i + '-pricing-tiered',
	                        value: 'tiered'
	                      }),
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          htmlFor: 'g' + i + '-pricing-tiered',
	                          className: 'lbl-inline'
	                        },
	                        translation.tiered
	                      ),
	                      _react2.default.createElement(_reactRadioGroup.Radio, {
	                        id: 'g' + i + '-pricing-flat',
	                        value: 'flat'
	                      }),
	                      _react2.default.createElement(
	                        'label',
	                        {
	                          htmlFor: 'g' + i + '-pricing-flat',
	                          className: 'lbl-inline'
	                        },
	                        translation.flat_rate
	                      )
	                    )
	                  )
	                ),
	                _this6.renderPricing(_this6.state.priceGroups[i], i),
	                _react2.default.createElement(
	                  _reactCheckboxGroup.CheckboxGroup,
	                  {
	                    className: 'location__currencies form-section',
	                    name: 'currencies',
	                    value: _this6.state.priceGroups[i].currencies,
	                    onChange: function onChange(value) {
	                      return _this6.updateCurrencies(value, i);
	                    }
	                  },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn--link',
	                      onClick: function onClick() {
	                        return _this6.editCurrencies(i);
	                      },
	                      type: 'button'
	                    },
	                    !_this6.state.priceGroups[i].editingCurrencies && _react2.default.createElement(
	                      'span',
	                      null,
	                      translation.edit_currencies
	                    ),
	                    _this6.state.priceGroups[i].editingCurrencies && _react2.default.createElement(
	                      'span',
	                      null,
	                      translation.done_editing
	                    )
	                  ),
	                  _this6.state.priceGroups[i].editingCurrencies && _react2.default.createElement(
	                    'ul',
	                    { id: 'location-currencies', className: 'checklist' },
	                    SessionStore.currencyList.map(function (key, j) {
	                      return _react2.default.createElement(
	                        'li',
	                        { key: j },
	                        _react2.default.createElement(_reactCheckboxGroup.Checkbox, {
	                          id: 'g' + i + 'c' + j,
	                          className: 'switch-input',
	                          value: key.code
	                        }),
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            htmlFor: 'g' + i + 'c' + j,
	                            className: 'switch-label'
	                          },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'meta' },
	                            key.name
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          {
	                            htmlFor: 'g' + i + 'c' + j,
	                            className: 'switch-label--alt'
	                          },
	                          key.name
	                        )
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                  flagKey: 'proctor-cancellation-policies',
	                  renderFeatureCallback: function renderFeatureCallback() {
	                    return _this6.renderPolicies(i);
	                  }
	                }),
	                ScheduleStore.locationCalendars.length > 0 && _react2.default.createElement(
	                  'div',
	                  { className: 'location__exam-group' },
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    translation.calendar.heading
	                  ),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'select' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'meta' },
	                      translation.calendar.label
	                    ),
	                    _react2.default.createElement(
	                      'select',
	                      {
	                        defaultValue: _this6.state.priceGroups[i].smarterSchedulingCalendarSid,
	                        onChange: function onChange(e) {
	                          return _this6.updateCalendar(e, i);
	                        },
	                        ref: function ref(input) {
	                          _this6['calendar' + i] = input;
	                        }
	                      },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        translation.calendar.label
	                      ),
	                      ScheduleStore.locationCalendars.map(function (key, i) {
	                        return _react2.default.createElement(
	                          'option',
	                          { key: i, value: key.sid },
	                          key.title
	                        );
	                      })
	                    )
	                  )
	                ),
	                LocationStore.examGroups.length > 0 && _react2.default.createElement(
	                  'div',
	                  { className: 'location__exam-group' },
	                  _react2.default.createElement(
	                    'h5',
	                    null,
	                    _react2.default.createElement('img', { className: 'exam-group-logo', src: _icnRegisterblast2.default, alt: 'RegisterBlast', height: '30' }),
	                    translation.exam_group.heading
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'field form-inline' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'rb-online-exam-group' },
	                        translation.exam_group.label_online
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'select' },
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            defaultValue: _this6.state.priceGroups[i].registerBlastExamGroup,
	                            id: 'rb-online-exam-group',
	                            onChange: function onChange(e) {
	                              return _this6.updateExamGroup(e, i, 'online');
	                            },
	                            ref: function ref(input) {
	                              _this6['examGroup' + i] = input;
	                            }
	                          },
	                          _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            translation.exam_group.helper
	                          ),
	                          LocationStore.examGroups.map(function (key, i) {
	                            return _react2.default.createElement(
	                              'option',
	                              { key: i, value: key.id },
	                              key.name
	                            );
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'rb-written-exam-group' },
	                        translation.exam_group.label_written
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'select' },
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            defaultValue: _this6.state.priceGroups[i].registerBlastWrittenExamGroupKey || _this6.state.priceGroups[i].registerBlastExamGroup,
	                            id: 'rb-written-exam-group',
	                            onChange: function onChange(e) {
	                              return _this6.updateExamGroup(e, i, 'written');
	                            },
	                            ref: function ref(input) {
	                              _this6['writtenExamGroup' + i] = input;
	                            }
	                          },
	                          _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            translation.exam_group.helper
	                          ),
	                          LocationStore.examGroups.map(function (key, i) {
	                            return _react2.default.createElement(
	                              'option',
	                              { key: i, value: key.id },
	                              key.name
	                            );
	                          })
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'rb-hybrid-exam-group' },
	                        translation.exam_group.label_hybrid
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'select' },
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            defaultValue: _this6.state.priceGroups[i].registerBlastHybridExamGroupKey,
	                            id: 'rb-hybrid-exam-group',
	                            onChange: function onChange(e) {
	                              return _this6.updateExamGroup(e, i, 'hybrid');
	                            },
	                            ref: function ref(input) {
	                              _this6['hybridExamGroup' + i] = input;
	                            }
	                          },
	                          _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            translation.exam_group.helper
	                          ),
	                          LocationStore.examGroups.map(function (key, i) {
	                            return _react2.default.createElement(
	                              'option',
	                              { key: i, value: key.id },
	                              key.name
	                            );
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            );
	          })
	        );
	      }
	    }
	
	    // Render pricing fields
	
	  }, {
	    key: 'renderPricing',
	    value: function renderPricing(activePriceGroup, index) {
	      var _this7 = this;
	
	      var sessionLoop = [].concat(_toConsumableArray(activePriceGroup.sessionLength));
	      sessionLoop.splice(0, 1);
	
	      var translation = this.props.translation;
	
	
	      if (activePriceGroup.priceModel === 'tiered') {
	        // Render tiered pricing fields
	        return _react2.default.createElement(
	          'div',
	          { className: 'pricing--tiered' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'label-faux' },
	            translation.prices
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'pricing--tiered range' },
	            _react2.default.createElement(
	              'li',
	              { className: 'range__slider' },
	              _react2.default.createElement(
	                'span',
	                null,
	                translation.session_length
	              ),
	              _react2.default.createElement(Range, { min: 0, max: 480, step: 5, dots: true, pushable: true, tipFormatter: function tipFormatter(value) {
	                  return (0, _helpers.convertMinutesToTimeString)(value);
	                }, value: activePriceGroup.sessionLength, onChange: function onChange(sessionLength) {
	                  return _this7.onRangeChange(sessionLength, index);
	                } }),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn--add', onClick: function onClick() {
	                    return _this7.addRange(activePriceGroup, index);
	                  }, type: 'button' },
	                _react2.default.createElement(icons.iconPlus, null),
	                ' ',
	                translation.add_range
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              { className: 'range__data' },
	              _react2.default.createElement(
	                'div',
	                { className: 'table-scrollable table-scrollable--alt' },
	                _react2.default.createElement(
	                  'table',
	                  { className: 'price-table' },
	                  _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement('td', null),
	                      sessionLoop.map(function (key, i) {
	                        return _this7.renderTHead(key, i, sessionLoop, activePriceGroup, index);
	                      }),
	                      this.state.priceGroups[index].lateSchedulingLeadTime > 0 && _react2.default.createElement(
	                        'th',
	                        { className: 'price-table__last' },
	                        translation.late_fee
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    activePriceGroup.currencies.map(function (key, i) {
	                      return _react2.default.createElement(
	                        'tr',
	                        { key: i },
	                        _react2.default.createElement(
	                          'th',
	                          { scope: 'row' },
	                          key
	                        ),
	                        sessionLoop.map(function (key, j) {
	                          return _react2.default.createElement(
	                            'td',
	                            { key: j, 'data-col': (0, _helpers.convertMinutesToTimeString)(activePriceGroup.sessionLength[i], true, true) + '\u2013' + (0, _helpers.convertMinutesToTimeString)(key, false, true) },
	                            _this7.state.priceGroups[index].fees[j].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                              type: 'number',
	                              step: '0.01',
	                              min: '0',
	                              pattern: '[0-9]+([\\.][0-9]+)?',
	                              onChange: function onChange(e) {
	                                return _this7.updateFee(e, index, i, j, 'service', 'tiered');
	                              },
	                              required: true,
	                              'aria-required': 'true',
	                              value: _this7.state.priceGroups[index].fees[j].amounts[activePriceGroup.currencies[i]].service ? _this7.state.priceGroups[index].fees[j].amounts[activePriceGroup.currencies[i]].service : ''
	                            }),
	                            !_this7.state.priceGroups[index].fees[j].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                              type: 'number',
	                              step: '0.01',
	                              min: '0',
	                              pattern: '[0-9]+([\\.][0-9]+)?',
	                              onInput: function onInput(e) {
	                                return _this7.updateFee(e, index, i, j, 'service', 'tiered');
	                              },
	                              required: true,
	                              'aria-required': 'true'
	                            })
	                          );
	                        }),
	                        _this7.state.priceGroups[index].lateSchedulingLeadTime > 0 && _react2.default.createElement(
	                          'td',
	                          { className: 'price-table__last', 'data-col': 'Late Fee' },
	                          _this7.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                            type: 'number',
	                            step: '0.01',
	                            min: '0',
	                            pattern: '[0-9]+([\\.][0-9]+)?',
	                            onChange: function onChange(e) {
	                              return _this7.updateFee(e, index, i, null, 'late', 'tiered');
	                            },
	                            value: _this7.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]].late ? _this7.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]].late : ''
	                          }),
	                          !_this7.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                            type: 'number',
	                            step: '0.01',
	                            min: '0',
	                            pattern: '[0-9]+([\\.][0-9]+)?',
	                            onInput: function onInput(e) {
	                              return _this7.updateFee(e, index, i, null, 'late', 'tiered');
	                            }
	                          })
	                        )
	                      );
	                    })
	                  )
	                )
	              )
	            )
	          )
	        );
	      } else {
	        // Render flat-rate pricing fields
	        return _react2.default.createElement(
	          'div',
	          { className: 'pricing--flat' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'label-faux' },
	            translation.price
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields' },
	            activePriceGroup.currencies.map(function (key, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required label-inline', htmlFor: 'g' + index + '-' + key + '-price' },
	                  key,
	                  ' ',
	                  translation.price
	                ),
	                _this7.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                  type: 'number',
	                  step: '0.01',
	                  min: '0',
	                  pattern: '[0-9]+([\\.][0-9]+)?',
	                  id: 'g' + index + '-' + key + '-price',
	                  onChange: function onChange(e) {
	                    return _this7.updateFee(e, index, i, null, 'service', 'flat');
	                  },
	                  required: true,
	                  'aria-required': 'true',
	                  value: _this7.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]].service ? _this7.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]].service : '0'
	                }),
	                !_this7.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                  type: 'number',
	                  step: '0.01',
	                  min: '0',
	                  pattern: '[0-9]+([\\.][0-9]+)?',
	                  id: 'g' + index + '-' + key + '-price',
	                  onInput: function onInput(e) {
	                    return _this7.updateFee(e, index, i, null, 'service', 'flat');
	                  },
	                  required: true,
	                  'aria-required': 'true'
	                }),
	                _this7.state.priceGroups[index].lateSchedulingLeadTime > 0 && _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'lbl-required label-inline late', htmlFor: 'g' + index + '-' + key + '-late' },
	                    translation.late_fee
	                  ),
	                  _this7.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                    type: 'number',
	                    step: '0.01',
	                    min: '0',
	                    pattern: '[0-9]+([\\.][0-9]+)?',
	                    id: 'g' + index + '-' + key + '-late',
	                    onChange: function onChange(e) {
	                      return _this7.updateFee(e, index, i, null, 'late', 'flat');
	                    },
	                    value: _this7.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]].late ? _this7.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]].late : '0'
	                  }),
	                  !_this7.state.priceGroups[index].fees[0].amounts[activePriceGroup.currencies[i]] && _react2.default.createElement('input', {
	                    type: 'number',
	                    step: '0.01',
	                    min: '0',
	                    pattern: '[0-9]+([\\.][0-9]+)?',
	                    id: 'g' + index + '-' + key + '-late',
	                    onInput: function onInput(e) {
	                      return _this7.updateFee(e, index, i, null, 'late', 'flat');
	                    }
	                  })
	                )
	              );
	            })
	          )
	        );
	      }
	    }
	
	    // Render pricing table
	
	  }, {
	    key: 'renderTHead',
	    value: function renderTHead(key, i, sessionLoop, activePriceGroup, index) {
	      var _this8 = this;
	
	      console.log(activePriceGroup.sessionLength[i], key);
	      var startTime = activePriceGroup.sessionLength[i];
	      if (startTime !== 0) {
	        startTime += 1;
	      }
	      return _react2.default.createElement(
	        'th',
	        { key: i, scope: 'col', className: 'lbl-required' },
	        (0, _helpers.convertMinutesToTimeString)(startTime, true),
	        '\u2013',
	        (0, _helpers.convertMinutesToTimeString)(key, true, false, false, true),
	        sessionLoop.length > 1 && _react2.default.createElement(
	          'button',
	          { className: 'btn--remove', onClick: function onClick() {
	              return _this8.removeRange(activePriceGroup, index, i + 1);
	            }, type: 'button' },
	          _react2.default.createElement(icons.iconMinus, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            'Remove Range'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Location;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Location')(Location);

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _config = __webpack_require__(24);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var ProctoringInfo = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(RegisterStep02, _React$Component);
	
	  function RegisterStep02() {
	    _classCallCheck(this, RegisterStep02);
	
	    var _this = _possibleConstructorReturn(this, (RegisterStep02.__proto__ || Object.getPrototypeOf(RegisterStep02)).call(this));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(RegisterStep02, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          SettingsStore = _props$store.SettingsStore;
	
	
	      this.state = {
	        proctorTypes: [],
	        invalid: false
	      };
	
	      SessionStore.getProctorTypes();
	      SettingsStore.getUserSettings(this);
	    }
	  }, {
	    key: 'handleToggle',
	    value: function handleToggle(e) {
	      var proctorTypes = [].concat(_toConsumableArray(this.state.proctorTypes));
	
	      if (e.target.checked) {
	        proctorTypes.push(e.target.value);
	      } else {
	        var index = proctorTypes.indexOf(e.target.value);
	        proctorTypes.splice(index, 1);
	      }
	
	      this.setState({
	        proctorTypes: proctorTypes
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var checked = document.querySelectorAll('.proctor-type-cbox:checked').length;
	
	      if (checked < 1) {
	        this.setState({
	          invalid: true
	        }, function () {
	          window.scrollTo(0, 0);
	        });
	
	        return false;
	      }
	
	      var data = {
	        proctorTypes: this.state.proctorTypes
	      };
	
	      this.props.store.RegisterStore.updateProctor(data, this.props.nextStep);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          lock = _props.lock,
	          translation = _props.translation;
	      var _props$store2 = this.props.store,
	          SessionStore = _props$store2.SessionStore,
	          SettingsStore = _props$store2.SettingsStore;
	      var userSettings = SettingsStore.userSettings;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'form',
	          {
	            className: 'panel proctor-type-form',
	            onSubmit: !lock ? function (e) {
	              return _this2.props.checkValidity(e, _this2.handleSubmit);
	            } : this.props.nextStep,
	            noValidate: true
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__header' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'panel__title' },
	              _react2.default.createElement(
	                'legend',
	                null,
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'panel__body' },
	            !lock && _react2.default.createElement(
	              'p',
	              { className: 'note note--prominent' },
	              translation.proctor_type.tooltip
	            ),
	            this.state.invalid && _react2.default.createElement(
	              'span',
	              { className: 'note note--prominent note--error' },
	              translation.proctor_type.none_selected
	            ),
	            SessionStore.proctorTypeList.map(function (key, i) {
	              if (userSettings.type === 'individual-proctor' && key.sid !== _config.config.testingCenterSid || userSettings.type !== 'individual-proctor' && key.sid === _config.config.testingCenterSid) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'form-subgroup', key: i },
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'switch-list' },
	                    key.subCategories.filter(function (obj) {
	                      return obj.allowSelfSelection;
	                    }).map(function (subKey, j) {
	                      if (subKey.sid !== _config.config.testingAdministratorSid) {
	                        return _react2.default.createElement(
	                          'li',
	                          { key: j },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'register-type' + i + '-' + j },
	                            subKey.title
	                          ),
	                          _react2.default.createElement('input', {
	                            type: 'checkbox',
	                            id: 'register-type' + i + '-' + j,
	                            className: 'switch-input proctor-type-cbox',
	                            value: subKey.sid,
	                            onChange: function onChange(e) {
	                              return _this2.handleToggle(e);
	                            },
	                            defaultChecked: _this2.state.proctorTypes.indexOf(subKey.sid) > -1,
	                            disabled: lock ? true : false
	                          }),
	                          _react2.default.createElement(
	                            'label',
	                            {
	                              className: 'switch-label',
	                              htmlFor: 'register-type' + i + '-' + j
	                            },
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'meta' },
	                              subKey.title
	                            )
	                          )
	                        );
	                      }
	
	                      return null;
	                    })
	                  )
	                );
	              }
	
	              return null;
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel__actions actions' },
	              _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--secondary', onClick: this.props.prevStep, type: 'button' },
	                translation.back
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--primary', type: 'submit' },
	                translation.button
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return RegisterStep02;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ProctoringInfo')(ProctoringInfo);

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _PhotoUpload = __webpack_require__(294);
	
	var _PhotoUpload2 = _interopRequireDefault(_PhotoUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var ProfilePhoto = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ProfilePhoto, _React$Component);
	
	  function ProfilePhoto() {
	    _classCallCheck(this, ProfilePhoto);
	
	    var _this = _possibleConstructorReturn(this, (ProfilePhoto.__proto__ || Object.getPrototypeOf(ProfilePhoto)).call(this));
	
	    _this.handlePhotoSubmit = _this.handlePhotoSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(ProfilePhoto, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        attachment: []
	      };
	    }
	  }, {
	    key: 'handlePhotoSubmit',
	    value: function handlePhotoSubmit() {
	      // const { translation } = this.props;
	
	      if (this.state.attachment.length > 0) {
	        var data = {
	          image: this.state.attachment[0]
	        };
	
	        this.props.store.SettingsStore.updateProfilePhoto(data, this.props.nextStep);
	      } else {
	        // const content = {
	        //   heading: translation.no_photo.heading,
	        //   body: translation.no_photo.body,
	        //   button: translation.no_photo.button
	        // }
	        //
	        // this.props.store.SessionStore.showDialog(content);
	
	        this.props.nextStep();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'panel', onSubmit: function onSubmit(e) {
	            return (0, _helpers.checkValidity)(e, _this2.handlePhotoSubmit);
	          }, noValidate: true },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__header' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'panel__title' },
	            _react2.default.createElement(
	              'legend',
	              null,
	              translation.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__body' },
	          _react2.default.createElement(_PhotoUpload2.default, Object.assign({}, this.props, {
	            attachment: this.state.attachment,
	            parent: this
	          })),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__actions actions' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'actions__btn actions__btn--secondary',
	                onClick: this.props.prevStep,
	                type: 'button'
	              },
	              translation.back
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'actions__btn actions__btn--primary',
	                type: 'submit'
	              },
	              translation.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProfilePhoto;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ProfilePhoto')(ProfilePhoto);

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	// Dependencies
	
	
	// Components
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDatepicker = __webpack_require__(68);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _reactRadioGroup = __webpack_require__(512);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Availability = function Availability(props) {
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      isValidated = _useState2[0],
	      setIsValidated = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      createArray = _useState4[0],
	      setCreateArray = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      updateArray = _useState6[0],
	      setUpdateArray = _useState6[1];
	
	  var _useState7 = (0, _react.useState)([]),
	      _useState8 = _slicedToArray(_useState7, 2),
	      deleteArray = _useState8[0],
	      setDeleteArray = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      removeOverrideObject = _useState10[0],
	      setRemoveOverrideObject = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      customize = _useState12[0],
	      setCustomize = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      inputObject = _useState14[0],
	      setInputObject = _useState14[1];
	
	  var _useState15 = (0, _react.useState)({
	    0: [],
	    1: [],
	    2: [],
	    3: [],
	    4: [],
	    5: [],
	    6: []
	  }),
	      _useState16 = _slicedToArray(_useState15, 2),
	      daysOfWeekObject = _useState16[0],
	      setDaysOfWeekObject = _useState16[1];
	
	  var translation = props.translation;
	  (0, _react.useEffect)(function () {
	    if (props.cleanedAvailabilities && props.calendar) {
	      if (props.cleanedAvailabilities.length > 0) {
	        setCustomize(props.cleanedAvailabilities[0].override);
	      } else {
	        setCustomize(false);
	      }
	      setDaysOfWeekObject(_defineProperty({}, props.dayOfWeek, [].concat(_toConsumableArray(props.cleanedAvailabilities))));
	    } else if (!props.calendar) {
	      // eslint-disable-next-line
	      getDefaultDates();
	    }
	  }, [props.cleanedAvailabilities]);
	
	  var removeAvailability = function removeAvailability() {
	    var ScheduleStore = props.store.ScheduleStore;
	    var schedule = ScheduleStore.locationCalendar.schedule;
	
	
	    var deleteArray = [];
	    var dateToSearch = (0, _moment2.default)(props.startDate).format('YYYY-MM-DD');
	    var availabilities = ScheduleStore.availabilities[dateToSearch];
	    var noAvailability = availabilities.filter(function (obj) {
	      return obj.excludeDate;
	    });
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = daysOfWeekObject[props.dayOfWeek][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var availability = _step.value;
	
	        if (availability.sid.indexOf('temp') === -1) {
	          deleteArray.push({ sid: availability.sid });
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    deleteArray = [].concat(_toConsumableArray(deleteArray), _toConsumableArray(noAvailability));
	    var data = {
	      create: [],
	      update: [],
	      delete: deleteArray
	    };
	    var callback = function callback() {
	      props.callback();
	      props.closeView();
	    };
	    ScheduleStore.updateAvailability(schedule.sid, data, callback);
	  };
	
	  (0, _react.useEffect)(function () {
	    if (inputObject) {
	      //eslint-disable-next-line
	      handleInput(inputObject.sid, inputObject.day);
	      setInputObject(null);
	    }
	  }, [inputObject]);
	
	  var customizeAvailability = function customizeAvailability() {
	
	    var create = [].concat(_toConsumableArray(createArray));
	    var availabilities = props.cleanedAvailabilities;
	
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = availabilities[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var availability = _step2.value;
	
	        availability.startDate = props.startDate;
	        availability.endDate = props.endDate;
	        availability.sid = 'temp-' + new Date().getTime() + Math.random();
	
	        delete availability.createdDate;
	        delete availability.editDate;
	        delete availability.name;
	        delete availability.override;
	        delete availability.recurring;
	        delete availability.scheduleSid;
	
	        create.push(availability);
	      }
	
	      // Remove temporary sids from the create array
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	
	    setDaysOfWeekObject(_defineProperty({}, props.dayOfWeek, [].concat(_toConsumableArray(availabilities))));
	    setCreateArray(create);
	    setCustomize(true);
	  };
	
	  var parseAvailabilities = function parseAvailabilities(data, daysOfWeek) {
	    data.forEach(function (availability) {
	      availability.startTime = availability.startTime.split(':')[0] + ':' + availability.startTime.split(':')[1];
	      availability.endTime = availability.endTime.split(':')[0] + ':' + availability.endTime.split(':')[1];
	
	      daysOfWeek[availability.dayOfWeek].push(availability);
	
	      if (!props.calendar) {
	        // Remove overrides if we’re editing the default
	        for (var i = 0; i < daysOfWeek[availability.dayOfWeek].length; i++) {
	          if (daysOfWeek[availability.dayOfWeek][i].override) {
	            daysOfWeek[availability.dayOfWeek].splice(i, 1);
	          }
	        }
	      }
	    });
	    setDaysOfWeekObject(function () {
	      var newArr = Object.assign({}, daysOfWeek);
	      return newArr;
	    });
	  };
	
	  var copyHours = function copyHours(row, dayOfWeek) {
	    var daysOfWeek = Object.assign({}, daysOfWeekObject);
	    var create = createArray;
	
	    Object.keys(daysOfWeek).forEach(function (day) {
	      if (daysOfWeek[day].length === 0) {
	        // Make a copy of the provided row
	        // and apply it to each empty day
	        for (var i = 0; i < row.length; i++) {
	          daysOfWeek[day][i] = Object.assign({}, row[i]);
	          daysOfWeek[day][i].sid = 'temp-' + new Date().getTime() + i + day;
	          daysOfWeek[day][i].startDate = row[i].startDate;
	          daysOfWeek[day][i].endDate = row[i].endDate;
	          daysOfWeek[day][i].dayOfWeek = day;
	
	          // Delete unnecessary data
	          delete daysOfWeek[day][i].createdDate;
	          delete daysOfWeek[day][i].editDate;
	          delete daysOfWeek[day][i].name;
	          delete daysOfWeek[day][i].override;
	          delete daysOfWeek[day][i].recurring;
	          delete daysOfWeek[day][i].scheduleSid;
	
	          // Push these new records to create
	          create.push(daysOfWeek[day][i]);
	        }
	      }
	    });
	
	    setDaysOfWeekObject(daysOfWeek);
	    setCreateArray(create);
	  };
	  var getDefaultDates = function getDefaultDates() {
	    var ScheduleStore = props.store.ScheduleStore;
	    var schedule = ScheduleStore.locationCalendar.schedule;
	
	
	    var callback = function callback(data) {
	      parseAvailabilities(data, daysOfWeekObject);
	    };
	    ScheduleStore.getScheduleAvailability(schedule.sid, callback);
	  };
	
	  var handleInput = function handleInput(sid, dayOfWeek) {
	    // Make copies of state data
	    var daysOfWeek = Object.assign({}, daysOfWeekObject);
	    var create = createArray;
	    var update = updateArray;
	
	    if (sid.indexOf('temp') > -1) {
	      // Find the correct object from the create array
	      var createRowObj = daysOfWeek[dayOfWeek].filter(function (obj) {
	        return obj.sid === sid;
	      })[0];
	
	      create = create.filter(function (obj) {
	        return obj.sid !== sid;
	      });
	
	      // Update the start and end time
	      create.push(createRowObj);
	    } else {
	      var updateRowObj = daysOfWeek[dayOfWeek].filter(function (obj) {
	        return obj.sid === sid;
	      })[0];
	
	      // Delete properties we don't need
	      delete updateRowObj.createdDate;
	      delete updateRowObj.editDate;
	      delete updateRowObj.pilname;
	      delete updateRowObj.scheduleSid;
	      delete updateRowObj.recurring;
	
	      if (!props.calendar || updateRowObj.override) {
	        update.push(updateRowObj);
	      } else {
	        updateRowObj.sid = 'temp-' + new Date().getTime();
	        updateRowObj.startDate = (0, _moment2.default)(props.startDate).format('YYYY-MM-DD');
	        updateRowObj.endDate = (0, _moment2.default)(props.endDate).format('YYYY-MM-DD');
	        delete updateRowObj.override;
	        update.push(updateRowObj);
	      }
	    }
	
	    setDaysOfWeekObject(daysOfWeek);
	    setCreateArray(create);
	    setUpdateArray(update);
	  };
	
	  var updateValidationText = function updateValidationText(availabilitySid) {
	    var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    var validationId = availabilitySid + '-validation';
	    var validationItem = document.getElementById(validationId);
	    validationItem.innerHTML = !text ? '' : text;
	  };
	
	  var isDateBetween = function isDateBetween(checkDate, startDate, endDate) {
	    var inclusive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	    if (inclusive) {
	      return checkDate >= startDate && checkDate <= endDate;
	    } else {
	      return checkDate > startDate && checkDate < endDate;
	    }
	  };
	
	  var validateTimeInputs = function validateTimeInputs(day) {
	    var isValid = true;
	    var availabilityForDay = daysOfWeekObject[day];
	
	    var _iteratorNormalCompletion3 = true;
	    var _didIteratorError3 = false;
	    var _iteratorError3 = undefined;
	
	    try {
	      for (var _iterator3 = availabilityForDay.entries()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	        var _ref = _step3.value;
	
	        var _ref2 = _slicedToArray(_ref, 2);
	
	        var index = _ref2[0];
	        var availability = _ref2[1];
	
	        if (availability.startTime && availability.endTime) {
	          var startTime = availability.startTime.split(':');
	          var endTime = availability.endTime.split(':');
	          var start = new Date(availability.startDate);
	          if (typeof availability.startDate === 'string' || availability.startDate instanceof String) {
	            start.setDate(start.getDate() + 1);
	          }
	          start.setHours(startTime[0], startTime[1]);
	          var end = new Date(availability.endDate);
	          if (typeof availability.endDate === 'string' || availability.endDate instanceof String) {
	            end.setDate(end.getDate() + 1);
	          }
	          end.setHours(endTime[0], endTime[1]);
	          // Creating "normalized" times here so that we can compare just the actual times for a day. Otherwise we are
	          // comparing the date times for overlaps, and those are not restricted to a single day
	          // By using epoch, it will start at time zero, so it will just be the time of day
	          var epoch = '1970-01-01T';
	          var normalizedStartTime = new Date(epoch + startTime[0] + ':' + startTime[1] + ':00');
	          var normalizedEndTime = new Date(epoch + endTime[0] + ':' + endTime[1] + ':00');
	          // Check start time is before end time
	          if (start >= end || normalizedStartTime >= normalizedEndTime) {
	            isValid = false;
	            updateValidationText(availability.sid, translation.end_before_start_time);
	          } else {
	            updateValidationText(availability.sid);
	          }
	          // Make sure the availability does not overlap with any previous availabilities
	          for (var i = 0; i < index; i++) {
	            var previousAvailability = availabilityForDay[i];
	
	            var previousStartTime = previousAvailability.startTime.split(':');
	            var previousStart = new Date(previousAvailability.startDate);
	            if (typeof previousAvailability.startDate === 'string' || previousAvailability.startDate instanceof String) {
	              previousStart.setDate(previousStart.getDate() + 1);
	            }
	            previousStart.setHours(previousStartTime[0], previousStartTime[1]);
	
	            var previousEndTime = previousAvailability.endTime.split(':');
	            var previousEnd = new Date(previousAvailability.endDate);
	            if (typeof previousAvailability.endDate === 'string' || previousAvailability.endDate instanceof String) {
	              previousEnd.setDate(previousEnd.getDate() + 1);
	            }
	            previousEnd.setHours(previousEndTime[0], previousEndTime[1]);
	
	            // Check if start time is between previous start and end
	            // Check if end time is between previous start and end
	            // Check if previous start time is between new start and end
	            // Check if previous end time is between new start and end
	            if (isDateBetween(start, previousStart, previousEnd) || isDateBetween(end, previousStart, previousEnd) || isDateBetween(previousStart, start, end) || isDateBetween(previousEnd, start, end)) {
	              // Availability is already set on this day, lets see if the times overlap now
	              // We will follow the same process as above, but we will set the date to always be the date of the epoch
	              // so we will then always be comparing based off time only
	              var normalizedPrevStartTime = new Date(epoch + previousStartTime[0] + ':' + previousStartTime[1] + ':00');
	              var normalizedPrevEndTime = new Date(epoch + previousEndTime[0] + ':' + previousEndTime[1] + ':00');
	              if (isDateBetween(normalizedStartTime, normalizedPrevStartTime, normalizedPrevEndTime) || isDateBetween(normalizedEndTime, normalizedPrevStartTime, normalizedPrevEndTime) || isDateBetween(normalizedPrevStartTime, normalizedStartTime, normalizedEndTime) || isDateBetween(normalizedPrevEndTime, normalizedStartTime, normalizedEndTime)) {
	                isValid = false;
	                updateValidationText(availability.sid, translation.times_overlap);
	              }
	            }
	          }
	        } else {
	          isValid = false;
	          updateValidationText(availability.sid, translation.required);
	        }
	      }
	    } catch (err) {
	      _didIteratorError3 = true;
	      _iteratorError3 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion3 && _iterator3.return) {
	          _iterator3.return();
	        }
	      } finally {
	        if (_didIteratorError3) {
	          throw _iteratorError3;
	        }
	      }
	    }
	
	    setIsValidated(isValid);
	  };
	
	  var addRow = function addRow(day, i) {
	    setRemoveOverrideObject(null);
	    var daysOfWeek = Object.assign({}, daysOfWeekObject);
	    var create = [].concat(_toConsumableArray(createArray));
	
	    var startDate = (0, _moment2.default)();
	    var endDate = (0, _moment2.default)().add(1, 'day');
	
	    if (props.startDate) {
	      startDate = (0, _moment2.default)(props.startDate).format('YYYY-MM-DD');
	    }
	
	    if (props.endDate) {
	      endDate = (0, _moment2.default)(props.endDate).format('YYYY-MM-DD');
	    }
	
	    var row = {
	      sid: 'temp-' + new Date().getTime(),
	      dayOfWeek: i || day,
	      startTime: null,
	      endTime: null,
	      startDate: startDate,
	      endDate: endDate,
	      numberOfSeats: null
	    };
	
	    daysOfWeek[day].push(row);
	    create.push(row);
	
	    setDaysOfWeekObject(daysOfWeek);
	    setCreateArray(create);
	
	    // Do not allow saving until the fields have been updated
	    setTimeout(function () {
	      validateTimeInputs(day);
	    }, 100);
	  };
	
	  var deleteRow = function deleteRow(dayOfWeek, i, sid, override, row, isCalendar) {
	    var daysOfWeek = Object.assign({}, daysOfWeekObject);
	    var createArr = [].concat(_toConsumableArray(createArray));
	    var deleteArr = [].concat(_toConsumableArray(deleteArray));
	
	    // Remove the row from the day of week in state
	    daysOfWeek[dayOfWeek].splice(i, 1);
	
	    // Add the sid to the delete array if it isn't new
	    if (!props.calendar) {
	      if (sid.indexOf('temp') < 0) {
	        // If it’s not temporary, delete it
	        deleteArr.push({ sid: sid });
	      }
	    } else if (props.calendar && override) {
	      deleteArr.push({ sid: sid });
	    }
	    // If it’s a new row, remove it from the create array
	    if (sid.indexOf('temp') >= 0) {
	      for (var j = 0; j < createArr.length; j++) {
	        if (createArr[j].sid === sid) {
	          createArr.splice(j, 1);
	        }
	      }
	    }
	    // If we remove the last availability for the day, we need to add an "availability" to remove availabilities
	    if (isCalendar && daysOfWeek[dayOfWeek].length === 0) {
	      setRemoveOverrideObject(row);
	    }
	
	    setDaysOfWeekObject(daysOfWeek);
	    setDeleteArray(deleteArr);
	    setCreateArray(createArr);
	
	    // allow state to update before validating
	    setTimeout(function () {
	      validateTimeInputs(dayOfWeek);
	    }, 100);
	  };
	  var handleStartDate = function handleStartDate(date, day, i) {
	    var copy = Object.assign({}, daysOfWeekObject);
	    copy[day][i].startDate = date;
	
	    if (copy[day][i].startDate >= copy[day][i].endDate) {
	      copy[day][i].endDate = (0, _moment2.default)(date).add(1, 'day');
	    }
	    setDaysOfWeekObject(copy);
	    setInputObject({ sid: copy[day][i].sid, day: day });
	    validateTimeInputs(day);
	  };
	
	  var handleEndDate = function handleEndDate(day, j, date, row) {
	    var copy = Object.assign({}, daysOfWeekObject);
	    copy[day][j].endDate = date;
	    setDaysOfWeekObject(copy);
	    handleInput(row.sid, day);
	    validateTimeInputs(day);
	  };
	
	  var handleTimeOnChange = function handleTimeOnChange(e, day, j, row, isStartTime) {
	    var startOrEnd = isStartTime ? 'startTime' : 'endTime';
	    var copy = daysOfWeekObject;
	    copy[day][j][startOrEnd] = e.target.value;
	    setDaysOfWeekObject(copy);
	    setInputObject({ sid: row.sid, day: day });
	    validateTimeInputs(day);
	  };
	
	  var handleCancel = function handleCancel() {
	    if (props.calendar) {
	      props.parent.setState({
	        editAvailability: false,
	        editAvailabilityDate: null,
	        editAvailabilityDayOfWeek: null,
	        editAvailabilitiesDefault: []
	      });
	      try {
	        props.parent.getAvailability();
	      } catch (err) {
	        // no-op
	      }
	    } else {
	      props.setStep(1);
	    }
	  };
	
	  var cleanData = function cleanData(array) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    array.forEach(function (row) {
	      row.startDate = (0, _moment2.default)(row.startDate).format('YYYY-MM-DD');
	      row.startDate = (0, _moment2.default)(row.startDate).format('YYYY-MM-DD');
	      row.startTime = (0, _moment2.default)(row.startTime, "HH:mm:ss").format('HH:mm');
	      row.endTime = (0, _moment2.default)(row.endTime, "HH:mm:ss").format('HH:mm');
	      if (create === true) delete row.sid;
	    });
	    return array;
	  };
	
	  var handleSubmit = function handleSubmit(e) {
	    e.preventDefault();
	    var _props$store = props.store,
	        ScheduleStore = _props$store.ScheduleStore,
	        SessionStore = _props$store.SessionStore;
	    var schedule = ScheduleStore.locationCalendar.schedule;
	
	    // Set the data
	
	    var data = {
	      create: createArray,
	      update: updateArray,
	      delete: deleteArray
	      // Remove temporary sids from the create array
	    };data.create = cleanData(data.create, true);
	    data.update = cleanData(data.update);
	    data.delete = cleanData(data.delete);
	
	    // check if we need to remove the availability to remove availabilities
	    if (data.create.length > 0) {
	      try {
	        var availabilities = ScheduleStore.availabilities[data.create[0].startDate];
	        var noAvailability = availabilities.filter(function (obj) {
	          return obj.excludeDate;
	        });
	        if (noAvailability.length > 0) {
	          data.delete = cleanData(noAvailability);
	        }
	      } catch (err) {
	        // no op
	      }
	    }
	
	    // If there are no updates, and we have removed the availabilities for a day
	    if (data.create.length === 0 && data.update.length === 0 && removeOverrideObject) {
	      var removeAvailabilityObj = {
	        dayOfWeek: removeOverrideObject.dayOfWeek,
	        startDate: removeOverrideObject.startDate,
	        endDate: removeOverrideObject.endDate,
	        startTime: '00:00',
	        endTime: '00:00',
	        numberOfSeats: null
	      };
	
	      data.create = [removeAvailabilityObj];
	    }
	
	    var callback = function callback() {
	      if (!props.calendar) {
	        SessionStore.showToaster(translation.updated, 'success');
	        setDaysOfWeekObject({
	          0: [],
	          1: [],
	          2: [],
	          3: [],
	          4: [],
	          5: [],
	          6: []
	        });
	        setCreateArray([]);
	        setUpdateArray([]);
	        setDeleteArray([]);
	        getDefaultDates();
	      } else {
	        props.callback();
	        props.closeView();
	      }
	    };
	    ScheduleStore.updateAvailability(schedule.sid, data, callback);
	  };
	
	  return _react2.default.createElement(
	    'form',
	    {
	      className: 'availability',
	      onSubmit: function onSubmit(e) {
	        return handleSubmit(e);
	      },
	      noValidate: true
	    },
	    _react2.default.createElement(
	      'fieldset',
	      null,
	      _react2.default.createElement(
	        'ol',
	        { className: 'fields availability__list' },
	        (customize || !props.calendar) && props.dayOfWeek.map(function (day, i) {
	          if (daysOfWeekObject[day] && daysOfWeekObject[day].length === 0) {
	            return _react2.default.createElement(
	              'li',
	              { key: i, className: 'enabled' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-inline' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'availability__label --large', htmlFor: 'sunday-start' },
	                  Object.keys(daysOfWeekObject).length > 1 && translation.days[day],
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.start
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'availability__copy' },
	                  translation.closed,
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn--link',
	                      type: 'button',
	                      onClick: function onClick() {
	                        return addRow(day, i);
	                      }
	                    },
	                    translation.add_hours
	                  )
	                )
	              )
	            );
	          } else if (daysOfWeekObject[day].length !== 0) {
	            var dayRows = [];
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'div',
	                { className: 'header-div' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'availability__label --large', htmlFor: day + '-start' },
	                  translation.days[day],
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.start
	                  ),
	                  !props.calendar && _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'availability__copy-btn',
	                      type: 'button',
	                      onClick: function onClick() {
	                        return copyHours(daysOfWeekObject[day], day);
	                      },
	                      title: translation.copy
	                    },
	                    _react2.default.createElement(icons.iconCopy, null)
	                  )
	                )
	              ),
	              daysOfWeekObject[day].map(function (row, j) {
	                if (dayRows.indexOf(row.startTime + '-' + row.endTime) === -1 || row.sid.includes('temp')) {
	                  // Make sure we aren’t showing duplicate
	                  // start and end times, which can happen
	                  // if we are editing a span of multiple weeks.
	                  // If we just created the availability always show it
	                  // by checking if temp is in the sid
	                  dayRows.push(row.startTime + '-' + row.endTime);
	
	                  return _react2.default.createElement(
	                    'div',
	                    { key: row.sid + '-availability-item__sp' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'availability__item ' + (props.calendar ? 'calendar__view' : '') },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'availability__item_wrap' },
	                        _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement('p', { id: row.sid + '-validation', className: 'availability__validation' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { key: row.sid + '-form__inline-sp', className: 'form-inline' },
	                          j !== 0 && _react2.default.createElement(
	                            'label',
	                            { className: 'meta', htmlFor: day + '-start' },
	                            translation.days[day],
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'meta' },
	                              translation.start
	                            )
	                          ),
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'lbl-inline longer-label' },
	                            translation.hours,
	                            ' '
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'availability-content' },
	                            _react2.default.createElement('input', {
	                              type: 'time',
	                              id: row.sid + '-start',
	                              defaultValue: row.startTime || null,
	                              onChange: function onChange(e) {
	                                return handleTimeOnChange(e, day, j, row, true);
	                              },
	                              placeholder: 'hh:mm',
	                              required: true
	                            }),
	                            _react2.default.createElement(
	                              'span',
	                              null,
	                              translation.to
	                            ),
	                            _react2.default.createElement('input', {
	                              type: 'time',
	                              id: row.sid + '-end',
	                              defaultValue: row.endTime || null,
	                              onChange: function onChange(e) {
	                                return handleTimeOnChange(e, day, j, row, false);
	                              },
	                              placeholder: 'hh:mm',
	                              required: true
	                            })
	                          )
	                        ),
	                        !props.calendar && _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'form-inline' },
	                            _react2.default.createElement(
	                              'label',
	                              { className: 'lbl-inline longer-label' },
	                              translation.effective_period
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'availability-content' },
	                              _react2.default.createElement(_reactDatepicker2.default, {
	                                className: 'calendar-by-day',
	                                selected: new Date((0, _moment2.default)(row.startDate)),
	                                onChange: function onChange(date) {
	                                  return handleStartDate(date, day, j);
	                                },
	                                placeholderText: 'Select a date',
	                                required: true
	                              }),
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                translation.to
	                              ),
	                              _react2.default.createElement(_reactDatepicker2.default, {
	                                className: 'calendar-by-day',
	                                minDate: new Date(row.startDate ? (0, _moment2.default)(row.startDate).add(1, 'day') : (0, _moment2.default)().add(1, 'day')),
	                                selected: new Date(row.endDate ? (0, _moment2.default)(row.endDate) : (0, _moment2.default)(row.startDate).add(1, 'day')),
	                                onChange: function onChange(date) {
	                                  return handleEndDate(day, j, date, row);
	                                },
	                                placeholderText: 'Select a date',
	                                required: true
	                              })
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'form-inline default--radio' },
	                          _react2.default.createElement(
	                            'label',
	                            { className: 'lbl-inline longer-label' },
	                            'Seats: '
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'availability-content' },
	                            _react2.default.createElement(
	                              _reactRadioGroup.RadioGroup,
	                              {
	                                className: 'default--radio',
	                                name: 'default_seats' + j + day,
	                                onChange: function onChange(value) {
	                                  var copy = Object.assign({}, daysOfWeekObject);
	                                  if (value === "true") copy[day][j].numberOfSeats = null;
	                                  if (value === "false") copy[day][j].numberOfSeats = undefined;
	                                  setDaysOfWeekObject(copy);
	                                },
	                                selectedValue: row.numberOfSeats === null ? "true" : "false"
	                              },
	                              _react2.default.createElement(_reactRadioGroup.Radio, {
	                                id: 'g' + j + day + '-seats',
	                                value: 'true' }),
	                              ' ',
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                translation.default,
	                                ' ',
	                                props.defaultNumberOfSeats
	                              ),
	                              _react2.default.createElement(_reactRadioGroup.Radio, {
	                                id: 'g' + j + day + '-seats',
	                                value: 'false'
	                              }),
	                              row.numberOfSeats !== null && _react2.default.createElement('input', { type: 'number', className: 'small-input', id: row.sid + '-seats', onChange: function onChange(e) {
	                                  var value = e.target.value;
	                                  if (isNaN(parseInt(value, 10)) === false) value = parseInt(value, 10);
	                                  var copy = daysOfWeekObject;
	                                  copy[day][j].numberOfSeats = value;
	                                  setDaysOfWeekObject(copy);
	                                  setInputObject({ sid: row.sid, day: day });
	                                },
	                                required: true
	                                // numberOfSeats value in the text input is an empty string if default number of seats is selected or if is null
	                                , value: row.numberOfSeats === null ? "" : row.numberOfSeats
	                              }),
	                              row.numberOfSeats === null && _react2.default.createElement(
	                                'span',
	                                null,
	                                translation.custom
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'delete__icn_wrap' },
	                        _react2.default.createElement(
	                          'button',
	                          { className: 'delete__icn',
	                            type: 'button',
	                            onClick: function onClick() {
	                              return deleteRow(day, j, row.sid, row.override, row, props.calendar);
	                            }
	                          },
	                          _react2.default.createElement(icons.iconTimes, null)
	                        )
	                      )
	                    )
	                  );
	                }
	                return null;
	              }),
	              _react2.default.createElement(
	                'div',
	                { className: 'footer--button' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    type: 'button',
	                    className: 'btn--outline ',
	                    onClick: function onClick() {
	                      return addRow(day, i);
	                    }
	                  },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    ' Add Hours '
	                  ),
	                  _react2.default.createElement(icons.iconPlus, null)
	                )
	              )
	            );
	          }
	          return null;
	        })
	      ),
	      !customize && props.cleanedAvailabilities && props.cleanedAvailabilities.map(function (availability, i) {
	        return _react2.default.createElement(
	          'h3',
	          { key: availability.sid + '-h3-cleaned' },
	          (0, _moment2.default)(availability.startTime, 'HH:mm:ss').format('h:mma'),
	          ' \u2013 ',
	          (0, _moment2.default)(availability.endTime, 'HH:mm:ss').format('h:mma')
	        );
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'panel__btns' },
	        (customize || !props.calendar) && !isValidated && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'p',
	            { className: 'availability__validation' },
	            translation.not_validated
	          )
	        ),
	        (customize || !props.calendar) && _react2.default.createElement(
	          'button',
	          {
	            className: 'btn btn--inline',
	            type: 'submit',
	            disabled: !isValidated
	          },
	          translation.button
	        ),
	        !customize && props.calendar && _react2.default.createElement(
	          'button',
	          { className: 'btn', type: 'button', onClick: function onClick() {
	              return customizeAvailability();
	            } },
	          translation.customize
	        ),
	        customize && _react2.default.createElement(
	          'button',
	          { className: 'btn--line btn--negative', type: 'button', onClick: function onClick() {
	              return removeAvailability();
	            } },
	          translation.remove
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'end btn--link',
	            onClick: function onClick() {
	              return handleCancel();
	            },
	            type: 'button'
	          },
	          translation.cancel
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _Translate2.default)('Availability')((0, _mobxReact.observer)(Availability));

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDatepicker = __webpack_require__(68);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _reactTextareaAutosize = __webpack_require__(98);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeSelect = __webpack_require__(886);
	
	var _TimeSelect2 = _interopRequireDefault(_TimeSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	// import Phone, { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';
	
	
	// Components
	
	
	var IncidentForm = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(IncidentForm, _React$Component);
	
	  function IncidentForm() {
	    _classCallCheck(this, IncidentForm);
	
	    var _this = _possibleConstructorReturn(this, (IncidentForm.__proto__ || Object.getPrototypeOf(IncidentForm)).call(this));
	
	    _this.handleInput = _this.handleInput.bind(_this);
	    _this.handleDateChange = _this.handleDateChange.bind(_this);
	    _this.handlePhoneInput = _this.handlePhoneInput.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.cancelIncident = _this.cancelIncident.bind(_this);
	    return _this;
	  }
	
	  _createClass(IncidentForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var _props$store$SessionS = this.props.store.SessionStore,
	          profile = _props$store$SessionS.profile,
	          userData = _props$store$SessionS.userData;
	
	
	      this.state = {
	        date: null,
	        incidentData: {
	          subject: '',
	          details: '',
	          status: 'Open',
	          eventTime: null,
	          potentialDamage: '',
	          correctiveActionDetails: '',
	          directWitness: '',
	          contactPerson: userData.firstName + ' ' + userData.lastName,
	          contactPhone: profile.phoneNumber,
	          contactEmail: userData.email,
	          eventTypeSid: '',
	          draft: false
	        }
	      };
	
	      this.props.store.ExamStore.getIncidentTypes();
	
	      // If we’re editing an incident, get its data
	      if (this.props.store.ExamStore.incidentSid) {
	
	        this.props.store.ExamStore.getSingleSessionEvent(this.props.installSid, this.props.examSid, this.props.store.ManagerStore.incidentSession, this.props.store.ExamStore.incidentSid, this).then(function (response) {
	          _this2.setState({ incidentData: response });
	        });
	      }
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      var incidentData = Object.assign({}, this.state.incidentData);
	
	      incidentData.subject = this.subject.value || '';
	      incidentData.details = this.details.value || '';
	      incidentData.potentialDamage = this.potentialDamage.value || '';
	      incidentData.correctiveActionDetails = this.correctiveActionDetails.value || '';
	      incidentData.directWitness = this.directWitness.value || '';
	      // incidentData.contactPerson = this.contactPerson.value || '';
	      // incidentData.contactEmail = this.contactEmail.value || '';
	      incidentData.eventTypeSid = this.eventTypeSid.value || '';
	
	      this.setState({
	        incidentData: incidentData
	      });
	    }
	  }, {
	    key: 'handleDateChange',
	    value: function handleDateChange(date, isDateField) {
	      if (isDateField) {
	        this.setState({
	          date: date
	        });
	      } else {
	        date = this.state.date;
	      }
	
	      var time = this.time.value;
	
	      var incidentData = Object.assign({}, this.state.incidentData);
	      var dateString = (0, _moment2.default)(date).format('YYYY-MM-DD HH:mm Z');
	
	      incidentData.eventTime = _moment2.default.utc(dateString + ' ' + time, 'YYYY-MM-DD Z HH:mm').toISOString();
	
	      this.setState({
	        incidentData: incidentData
	      });
	    }
	  }, {
	    key: 'handlePhoneInput',
	    value: function handlePhoneInput(e) {
	      var incidentData = Object.assign({}, this.state.incidentData);
	      incidentData.contactPhone = e;
	      this.setState({
	        incidentData: incidentData
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var session = this.props.store.ScheduleStore.session;
	      var installSid = session.installSid,
	          examSid = session.examSid,
	          sid = session.sid;
	
	
	      if (this.props.store.ExamStore.incidentSid) {
	        // If we’re editing an incident, update it
	        this.props.store.ExamStore.updateSessionEvent(installSid, examSid, sid, this.props.store.ExamStore.incidentSid, this.state.incidentData, this.props.complete('incident'));
	      } else {
	        // Otherwise, create a new one
	        this.props.store.ExamStore.createSessionEvent(installSid, examSid, sid, this.state.incidentData, this.props.complete('incident'));
	      }
	    }
	  }, {
	    key: 'cancelIncident',
	    value: function cancelIncident() {
	      this.props.store.ManagerStore.reportIncident = false;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ExamStore = _props$store.ExamStore,
	          SessionStore = _props$store.SessionStore;
	
	
	      if (!SessionStore.loading && ExamStore.incidentTypes.length > 0) {
	        return _react2.default.createElement(
	          'form',
	          { className: 'incident-form', onSubmit: function onSubmit(e) {
	              return (0, _helpers.checkValidity)(e, _this3.handleSubmit, '.incident-form');
	            }, noValidate: true },
	          _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	              'ul',
	              { className: 'fields' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'incident-subject' },
	                  translation.subject
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  id: 'incident-subject',
	                  ref: function ref(input) {
	                    _this3.subject = input;
	                  },
	                  onChange: this.handleInput,
	                  required: true,
	                  'aria-required': 'true',
	                  autoFocus: true,
	                  defaultValue: this.state.incidentData.subject
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'field--auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'incident-type' },
	                  translation.type.label
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'select', htmlFor: 'incident-type' },
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      id: 'incident-type',
	                      ref: function ref(input) {
	                        _this3.eventTypeSid = input;
	                      },
	                      onChange: this.handleInput,
	                      required: true,
	                      'aria-required': 'true',
	                      defaultValue: this.state.incidentData.eventType ? this.state.incidentData.eventType.sid : null
	                    },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '' },
	                      translation.type.helper
	                    ),
	                    ExamStore.incidentTypes.map(function (key, i) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: i, value: key.sid },
	                        key.title.charAt(0).toUpperCase() + key.title.slice(1)
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'field--auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'incident-date' },
	                  translation.date.label
	                ),
	                _react2.default.createElement(_reactDatepicker2.default, {
	                  id: 'incident-date',
	                  selected: this.props.store.ExamStore.incidentSid ? new Date((0, _moment2.default)(this.state.date)) : this.state.date,
	                  onChange: function onChange(date) {
	                    _this3.handleDateChange(date, true);
	                  },
	                  placeholderText: translation.date.helper,
	                  required: true,
	                  'aria-required': 'true',
	                  ref: function ref(input) {
	                    _this3.eventTime = input;
	                  } }),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'preposition' },
	                  translation.date.at
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'select', htmlFor: 'incident-time' },
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      id: 'incident-time',
	                      ref: function ref(input) {
	                        _this3.time = input;
	                      },
	                      onChange: function onChange() {
	                        return _this3.handleDateChange(null, false);
	                      },
	                      defaultValue: _moment2.default.utc(ExamStore.incident.eventTime).local().format('HH:mm')
	                    },
	                    _react2.default.createElement(_TimeSelect2.default, null)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-optional', htmlFor: 'incident-details' },
	                  translation.details
	                ),
	                _react2.default.createElement(_reactTextareaAutosize2.default, {
	                  id: 'incident-details',
	                  className: 'textarea-grow',
	                  ref: function ref(input) {
	                    _this3.details = input;
	                  },
	                  onChange: this.handleInput,
	                  defaultValue: this.state.incidentData.details
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-optional', htmlFor: 'incident-damage', 'aria-describedby': 'damage-tooltip' },
	                  translation.potential_damage.label,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tooltip' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                      '(?)'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'damage-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                      translation.potential_damage.tooltip
	                    )
	                  )
	                ),
	                _react2.default.createElement(_reactTextareaAutosize2.default, {
	                  id: 'incident-damage',
	                  className: 'textarea-grow',
	                  ref: function ref(input) {
	                    _this3.potentialDamage = input;
	                  },
	                  onChange: this.handleInput,
	                  defaultValue: this.state.incidentData.potentialDamage
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-optional', htmlFor: 'incident-action' },
	                  translation.corrective_action
	                ),
	                _react2.default.createElement(_reactTextareaAutosize2.default, {
	                  id: 'incident-action',
	                  className: 'textarea-grow',
	                  ref: function ref(input) {
	                    _this3.correctiveActionDetails = input;
	                  },
	                  onChange: this.handleInput,
	                  defaultValue: this.state.incidentData.correctiveActionDetails,
	                  maxLength: '255'
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'incident-witness', 'aria-describedby': 'witness-tooltip' },
	                  translation.direct_witness.label,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tooltip' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip__label', role: 'presentation', 'aria-hidden': 'true' },
	                      '(?)'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'witness-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                      translation.direct_witness.tooltip
	                    )
	                  )
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  id: 'incident-subject',
	                  ref: function ref(input) {
	                    _this3.directWitness = input;
	                  },
	                  onChange: this.handleInput,
	                  required: true,
	                  'aria-required': 'true',
	                  defaultValue: this.state.incidentData.directWitness
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', type: 'submit' },
	            translation.button
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'preposition preposition--vertical' },
	            translation.or
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn--link', type: 'button', onClick: this.cancelIncident },
	            translation.cancel
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return IncidentForm;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('IncidentForm')(IncidentForm);

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactTabs = __webpack_require__(79);
	
	var _PendingSessionList = __webpack_require__(911);
	
	var _PendingSessionList2 = _interopRequireDefault(_PendingSessionList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var PendingSessions = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(PendingSessions, _React$Component);
	
	  function PendingSessions() {
	    _classCallCheck(this, PendingSessions);
	
	    var _this = _possibleConstructorReturn(this, (PendingSessions.__proto__ || Object.getPrototypeOf(PendingSessions)).call(this));
	
	    _this.handleTabs = _this.handleTabs.bind(_this);
	    return _this;
	  }
	
	  _createClass(PendingSessions, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        activeTab: 1
	      };
	
	      this.getPending('request', 'createdDate');
	    }
	  }, {
	    key: 'getPending',
	    value: function getPending(status, sortKey) {
	      this.props.store.ScheduleStore.getPendingSessions(status, sortKey);
	    }
	  }, {
	    key: 'handleTabs',
	    value: function handleTabs(index) {
	      this.setState({
	        activeTab: index + 1
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	      // Don’t use the default tab styles
	
	      _reactTabs.Tabs.setUseDefaultStyles(false);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.root && _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'page__title' },
	            translation.heading
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              className: 'page__link',
	              to: 'sessions'
	            },
	            translation.upcoming
	          )
	        ),
	        !this.props.root && _react2.default.createElement(
	          'h2',
	          { className: 'page__title' },
	          translation.heading
	        ),
	        _react2.default.createElement(
	          _reactTabs.Tabs,
	          {
	            onSelect: this.handleTabs
	          },
	          _react2.default.createElement(
	            _reactTabs.TabList,
	            null,
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              { onClick: function onClick() {
	                  return _this2.getPending('request', 'createdDate');
	                } },
	              translation.action_required
	            ),
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              { onClick: function onClick() {
	                  return _this2.getPending('pending', 'confirmedDateExpiration');
	                } },
	              translation.awaiting_student
	            )
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            _react2.default.createElement(_PendingSessionList2.default, Object.assign({ type: 'request' }, this.props))
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            _react2.default.createElement(_PendingSessionList2.default, Object.assign({ type: 'pending' }, this.props))
	          )
	        )
	      );
	    }
	  }]);
	
	  return PendingSessions;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('PendingSessions')(PendingSessions);

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactTabs = __webpack_require__(79);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _ExamAttachmentsList = __webpack_require__(884);
	
	var _ExamAttachmentsList2 = _interopRequireDefault(_ExamAttachmentsList);
	
	var _Privacy = __webpack_require__(860);
	
	var _Privacy2 = _interopRequireDefault(_Privacy);
	
	var _FileUpload = __webpack_require__(885);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var SessionInformation = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionInformation, _React$Component);
	
	  function SessionInformation() {
	    _classCallCheck(this, SessionInformation);
	
	    var _this2 = _possibleConstructorReturn(this, (SessionInformation.__proto__ || Object.getPrototypeOf(SessionInformation)).call(this));
	
	    _this2.showPassword = _this2.showPassword.bind(_this2);
	    _this2.minimizeSession = _this2.minimizeSession.bind(_this2);
	    _this2.closeSession = _this2.closeSession.bind(_this2);
	    _this2.closeCompletedSession = _this2.closeCompletedSession.bind(_this2);
	    _this2.closeWrittenSession = _this2.closeWrittenSession.bind(_this2);
	    _this2.handleTabs = _this2.handleTabs.bind(_this2);
	    _this2.getRoster = _this2.getRoster.bind(_this2);
	    _this2.getIncidents = _this2.getIncidents.bind(_this2);
	    _this2.reportIncident = _this2.reportIncident.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(SessionInformation, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          ManagerStore = _props$store.ManagerStore,
	          SessionStore = _props$store.SessionStore,
	          ScheduleStore = _props$store.ScheduleStore;
	      var session = this.props.session;
	
	
	      if (ScheduleStore.session !== session) ScheduleStore.session = session;
	      this.state = {
	        activeTab: 0,
	        minimize: this.props.minimize,
	        showPassword: false,
	        returnFiles: ManagerStore.returnFiles,
	        hideUpload: false
	
	        // Get the current time
	      };SessionStore.getCurrentTime(true);
	
	      // Hide the upload field if the exam has been returned
	      if (session.returnedFile && session.returnedFile.file) {
	        this.setState({
	          hideUpload: true
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          location = _props.location,
	          store = _props.store,
	          appointmentTimeline = _props.appointmentTimeline;
	      var ScheduleStore = store.ScheduleStore,
	          SessionStore = store.SessionStore;
	
	      if (appointmentTimeline) {
	
	        var appointment = {};
	
	        var accountSid = SessionStore.userData.proctorAccountSid;
	
	        if (ScheduleStore.events[0] && ScheduleStore.events[0].appointment) {
	          appointment = ScheduleStore.events[0].appointment;
	          ScheduleStore.listSeats(accountSid, location.sid, appointment.sid, 'title');
	          ScheduleStore.getCalendar(location.sid, appointment.calendar.sid);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        minimize: nextProps.minimize
	      });
	    }
	  }, {
	    key: 'showPassword',
	    value: function showPassword() {
	      this.setState({
	        showPassword: !this.state.showPassword
	      });
	    }
	  }, {
	    key: 'minimizeSession',
	    value: function minimizeSession(accessKey) {
	      this.setState({
	        minimize: !this.state.minimize
	      });
	
	      var minimized = [].concat(_toConsumableArray(this.props.parent.state.minimized));
	
	      minimized.push(accessKey);
	
	      this.props.parent.setState({
	        minimized: minimized
	      });
	    }
	  }, {
	    key: 'closeSession',
	    value: function closeSession() {
	      this.props.store.ManagerStore.closeExamSession(this.props.session.sid);
	    }
	  }, {
	    key: 'confirmComplete',
	    value: function confirmComplete(installSid, examSid, sessionSid) {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	
	
	      var msg = {
	        heading: translation.complete_prompt.heading,
	        body: translation.complete_prompt.body,
	        button: translation.complete_prompt.button
	      };
	
	      (0, _helpers.confirm)(msg, function () {
	        return _this3.completeSession(installSid, examSid, sessionSid);
	      });
	    }
	  }, {
	    key: 'completeSession',
	    value: function completeSession(installSid, examSid, sessionSid) {
	      var session = this.props.session;
	      var ManagerStore = this.props.store.ManagerStore;
	
	
	      var callback = null;
	
	      if (session.exam.type.toLowerCase() !== 'written') {
	        callback = this.closeCompletedSession;
	      } else {
	        callback = this.closeWrittenSession;
	      }
	
	      ManagerStore.completeExamSession(installSid, examSid, sessionSid, callback, this.props.session.schedulingModule);
	    }
	  }, {
	    key: 'closeCompletedSession',
	    value: function closeCompletedSession() {
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.closeSession();
	
	      (0, _helpers.closeDrawer)(null, this.props.parent, (0, _helpers.getURLSegment)(this, 1));
	
	      SessionStore.showToaster(translation.session_closed, 'success');
	    }
	  }, {
	    key: 'closeWrittenSession',
	    value: function closeWrittenSession() {
	      var _props2 = this.props,
	          session = _props2.session,
	          translation = _props2.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      session.status = 'Closed';
	
	      SessionStore.showToaster(translation.session_closed, 'success');
	    }
	  }, {
	    key: 'confirmCancel',
	    value: function confirmCancel(sessionSid) {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	
	
	      var msg = {
	        heading: translation.cancel_confirm_prompt.heading,
	        body: translation.cancel_confirm_prompt.body,
	        button: translation.cancel_confirm_prompt.button
	      };
	
	      (0, _helpers.confirm)(msg, function () {
	        return _this4.initCancel(sessionSid);
	      });
	    }
	  }, {
	    key: 'changeSeat',
	    value: function changeSeat() {
	      var _this5 = this;
	
	      var _props3 = this.props,
	          store = _props3.store,
	          translation = _props3.translation;
	      var ScheduleStore = store.ScheduleStore;
	      var locationSeats = ScheduleStore.locationSeats; // These are the seats for the location
	
	      var appointmentSid = ScheduleStore.events[0].appointment.sid;
	      var options = locationSeats.map(function (seat) {
	        return {
	          label: seat.title,
	          value: seat.sid
	        };
	      });
	      options.push({ label: 'Unassigned', value: null });
	
	      var callback = function callback(seatSid) {
	        // Refresh the calendar and update seat name for session
	        _this5.props.refreshEvents();
	        var newSeat = ScheduleStore.locationSeats.find(function (seat) {
	          return seat.sid === seatSid;
	        });
	        ScheduleStore.events[0].appointment.seat.title = newSeat.title;
	      };
	
	      var msg = {
	        heading: translation.seat_prompt.heading,
	        body: translation.seat_prompt.body,
	        button: translation.seat_prompt.button,
	        options: options
	      };
	
	      (0, _helpers.promptUser)(msg, function (value) {
	        return ScheduleStore.changeSeat(value, appointmentSid, callback);
	      });
	    }
	  }, {
	    key: 'changeStatus',
	    value: function changeStatus() {
	      var _this6 = this;
	
	      var _props4 = this.props,
	          store = _props4.store,
	          session = _props4.session,
	          translation = _props4.translation;
	      var ScheduleStore = store.ScheduleStore;
	
	      var currentStatus = ScheduleStore.session.status;
	      var options = [{
	        label: 'Checked In',
	        value: 'Checked In'
	      }, {
	        label: 'In Progress',
	        value: 'In Progress'
	      }, {
	        label: 'Closed',
	        value: 'Closed'
	      }];
	
	      var index = options.findIndex(function (option) {
	        return option.label === currentStatus;
	      });
	      if (index !== -1) {
	        options.splice(0, index + 1);
	      }
	
	      var msg = {
	        heading: translation.status_prompt.heading,
	        body: translation.status_prompt.body,
	        button: translation.status_prompt.button,
	        options: options
	      };
	
	      (0, _helpers.promptUser)(msg, function (value) {
	        return ScheduleStore.changeSessionStatus(session.installSid, session.exam.sid, session.sid, value);
	      }, function () {
	        return _this6.props.refreshEvents();
	      });
	    }
	  }, {
	    key: 'initCancel',
	    value: function initCancel(sessionSid) {
	      var _this = this;
	      var translation = this.props.translation;
	
	
	      var options = [{
	        label: translation.cancel_options.helper,
	        value: ''
	      }, {
	        label: translation.cancel_options.no_show,
	        value: 'no-show'
	      }, {
	        label: translation.cancel_options.changed_time,
	        value: 'changed-time'
	      }, {
	        label: translation.cancel_options.technical_issue,
	        value: 'technical-issue'
	      }, {
	        label: translation.cancel_options.other,
	        value: 'other-reason'
	      }];
	
	      var msg = {
	        heading: translation.cancel_prompt.heading,
	        options: options,
	        button: translation.cancel_prompt.button
	      };
	
	      var setReason = function setReason(memo, selectedReason) {
	        var data = {
	          cancellationMemo: memo,
	          reason: selectedReason
	        };
	
	        _this.cancelSession(sessionSid, data);
	      };
	
	      (0, _helpers.promptUser)(msg, setReason, null);
	    }
	  }, {
	    key: 'cancelSession',
	    value: function cancelSession(sessionSid, data) {
	      var _this7 = this;
	
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          ManagerStore = _props$store2.ManagerStore,
	          SessionStore = _props$store2.SessionStore;
	
	
	      var callback = function callback() {
	        (0, _helpers.closeDrawer)(null, _this7.props.parent, null);
	        SessionStore.showToaster(translation.session_cancelled, 'success');
	      };
	
	      ManagerStore.cancelExamSession(sessionSid, data, callback);
	    }
	  }, {
	    key: 'handleTabs',
	    value: function handleTabs(index) {
	      this.setState({
	        activeTab: index
	      });
	    }
	  }, {
	    key: 'permittedItems',
	    value: function permittedItems() {
	      var translation = this.props.translation;
	      var examConfiguration = this.props.session.examConfiguration;
	
	
	      var items = [{
	        item: 'Bathroom Break',
	        permitted: examConfiguration.permittedBathroomBreak,
	        notes: examConfiguration.permittedBathroomBreakInformation
	      }, {
	        item: 'Blank Paper',
	        permitted: examConfiguration.permittedBlankPaper,
	        notes: examConfiguration.permittedBlankPaperInformation
	      }, {
	        item: 'Calculator',
	        permitted: examConfiguration.permittedCalculator,
	        notes: examConfiguration.permittedCalculatorInformation
	      }, {
	        item: 'Dictionary',
	        permitted: examConfiguration.permittedDictionary,
	        notes: examConfiguration.permittedDictionaryInformation
	      }, {
	        item: 'Earplugs',
	        permitted: examConfiguration.permittedEarplugs,
	        notes: examConfiguration.permittedEarplugsInformation
	      }, {
	        item: 'Formula Sheets',
	        permitted: examConfiguration.permittedFormulaSheet,
	        notes: examConfiguration.permittedFormulaSheetInformation
	      }, {
	        item: 'Notes',
	        permitted: examConfiguration.permittedNotes,
	        notes: examConfiguration.permittedNotesInformation
	      }, {
	        item: 'Textbook',
	        permitted: examConfiguration.permittedTextbook,
	        notes: examConfiguration.permittedTextbookInformation
	      }, {
	        item: 'Websites',
	        permitted: examConfiguration.permittedWebsites,
	        notes: examConfiguration.permittedWebsitesInformation
	      }];
	
	      var permittedItems = [];
	
	      for (var i = 0; i < items.length; i++) {
	        if (items[i].permitted) {
	          var permittedItem = _react2.default.createElement('li', { key: '' + i }, _react2.default.createElement('strong', null, items[i].item + ':'), _react2.default.createElement('p', null, items[i].notes || translation.permitted_items.permitted));
	          permittedItems.push(permittedItem);
	        }
	      }
	
	      if (examConfiguration.permittedOtherItems) {
	        var _permittedItem = _react2.default.createElement('li', { key: 'other' }, _react2.default.createElement('strong', null, translation.permitted_items.other_items + ':'), _react2.default.createElement('p', null, examConfiguration.permittedOtherItems));
	        permittedItems.push(_permittedItem);
	      }
	
	      var itemList = _react2.default.createElement('ul', { className: 'data--alt' }, permittedItems);
	
	      if (permittedItems.length > 0) {
	        return itemList;
	      } else {
	        return _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            translation.none
	          )
	        );
	      }
	    }
	  }, {
	    key: 'getRoster',
	    value: function getRoster() {
	      var EnrollmentStore = this.props.store.EnrollmentStore;
	      var _props5 = this.props,
	          courseSid = _props5.courseSid,
	          installSid = _props5.installSid;
	
	      var roles = ['instructor'];
	
	      // EnrollmentStore.getCourseData(installSid, courseSid, true)
	      EnrollmentStore.getCourseRoster(roles, installSid, courseSid, true);
	    }
	  }, {
	    key: 'getIncidents',
	    value: function getIncidents() {
	      this.props.store.ExamStore.getSessionEvents(this.props.installSid, this.props.examSid, this.props.session.sid, true);
	    }
	  }, {
	    key: 'reportIncident',
	    value: function reportIncident(sid) {
	      this.props.store.ManagerStore.reportIncident = true;
	      this.props.store.ManagerStore.incidentSession = sid;
	      this.props.store.ManagerStore.incidentSid = null;
	    }
	  }, {
	    key: 'editIncident',
	    value: function editIncident(sessionSid, incidentSid) {
	      this.props.store.ManagerStore.reportIncident = true;
	      this.props.store.ManagerStore.incidentSession = sessionSid;
	      this.props.store.ExamStore.incidentSid = incidentSid;
	    }
	  }, {
	    key: 'deleteIncident',
	    value: function deleteIncident(incidentSid) {
	      var _this8 = this;
	
	      var translation = this.props.translation;
	
	
	      var msg = {
	        heading: translation.delete_incident.heading + '?',
	        body: translation.delete_incident.body,
	        button: translation.delete_incident.button
	      };
	
	      (0, _helpers.confirm)(msg, function () {
	        return _this8.props.store.ExamStore.deleteSessionEvent(_this8.props.installSid, _this8.props.examSid, _this8.props.session.sid, incidentSid);
	      });
	    }
	  }, {
	    key: 'renderCancelButton',
	    value: function renderCancelButton(session) {
	      var _this9 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel__section' },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'btn--link negative',
	            onClick: function onClick() {
	              return _this9.confirmCancel(session.sid);
	            }
	          },
	          translation.actions.cancel_button
	        )
	      );
	    }
	  }, {
	    key: 'getExamFile',
	    value: function getExamFile() {
	      var ScheduleStore = this.props.store.ScheduleStore;
	      var _props6 = this.props,
	          session = _props6.session,
	          installSid = _props6.installSid;
	
	      var fileName = session.enrollment.firstName + ' ' + session.enrollment.lastName + ' - ' + session.exam.title;
	
	      ScheduleStore.getExamFile(installSid, session.examConfiguration.sid, session.sid, fileName);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this10 = this;
	
	      var _this = this;
	      var _props7 = this.props,
	          examSid = _props7.examSid,
	          installSid = _props7.installSid,
	          location = _props7.location,
	          session = _props7.session,
	          translation = _props7.translation;
	      var _props$store3 = this.props.store,
	          EnrollmentStore = _props$store3.EnrollmentStore,
	          ExamStore = _props$store3.ExamStore,
	          ManagerStore = _props$store3.ManagerStore,
	          ScheduleStore = _props$store3.ScheduleStore,
	          SessionStore = _props$store3.SessionStore;
	
	      var address = location ? (location.address1 || '') + ' ' + (location.address2 || '') : '';
	      var seatName = 'Unassigned';
	      var useSeatManagement = false;
	
	      if (ScheduleStore.events[0] && ScheduleStore.events[0].appointment && ScheduleStore.events[0].appointment.seat && ScheduleStore.events[0].appointment.seat.title) {
	        seatName = ScheduleStore.events[0].appointment.seat.title;
	      }
	
	      if (ScheduleStore.locationCalendar) {
	        useSeatManagement = ScheduleStore.locationCalendar.useSeatManagement;
	      }
	
	      // Don’t use the default tab styles
	      _reactTabs.Tabs.setUseDefaultStyles(false);
	
	      // Check if session has started
	      var now = (0, _moment2.default)(this.props.store.SessionStore.currentTime);
	      var appointmentDate = (0, _moment2.default)(ScheduleStore.session.appointmentDate).local();
	      var appointmentDiff = _moment2.default.duration(appointmentDate.diff(now)).asHours();
	
	      return _react2.default.createElement(
	        'li',
	        { className: 'panel--medium session ' + (this.state.minimize ? 'minimized' : '') },
	        _react2.default.createElement(
	          'article',
	          null,
	          this.props.multi && _react2.default.createElement(
	            'header',
	            { className: 'panel__header session__header' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              session.accessKey
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel__tools' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'minimize__btn',
	                  onClick: function onClick() {
	                    _this10.minimizeSession(session.accessKey);
	                  }
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation.minimize
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'minimize__btn minimize__btn--close',
	                  onClick: this.closeSession
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation.close
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'session__body' },
	            !this.props.noInteract && ScheduleStore.session.status.toLowerCase() !== 'closed' && ScheduleStore.session.status.toLowerCase() !== 'cancelled' && ScheduleStore.session.exam.type.toLowerCase() !== 'written' && ScheduleStore.session.workflowModule !== 'hybrid-scheduling' && appointmentDiff <= -.25 && _react2.default.createElement(
	              'section',
	              { className: 'session__section' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'meta' },
	                translation.exam_details.heading
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'btn-group' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn--outline',
	                    onClick: function onClick() {
	                      return _this10.confirmComplete(installSid, examSid, session.sid);
	                    }
	                  },
	                  _react2.default.createElement(icons.iconCheck, null),
	                  translation.actions.button
	                )
	              )
	            ),
	            ScheduleStore.session.exam.type.toLowerCase() === 'written' && ScheduleStore.session.examFile && ScheduleStore.session.status.toLowerCase() !== 'closed' && ScheduleStore.session.status.toLowerCase() !== 'cancelled' && _react2.default.createElement(
	              'button',
	              {
	                className: 'btn',
	                onClick: function onClick() {
	                  return _this10.getExamFile();
	                }
	              },
	              _react2.default.createElement(icons.iconDownload, null),
	              translation.download_exam.button
	            ),
	            !this.props.noInteract && ScheduleStore.session.exam.type.toLowerCase() === 'written' && appointmentDiff <= -.25 && _react2.default.createElement(
	              'section',
	              { className: 'session__section' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'meta' },
	                translation.upload_exam.heading
	              ),
	              session.returnedFile && session.returnedFile.file && _react2.default.createElement(
	                'div',
	                { className: 'text-block text-block--push' },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'files__title',
	                    target: '_blank',
	                    href: session.returnedFile.file
	                  },
	                  _react2.default.createElement(icons.icon_pdf, null),
	                  translation.returned_file,
	                  ' (',
	                  _moment2.default.utc(session.returnedFile.createdDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma'),
	                  ')'
	                ),
	                this.state.hideUpload && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn--link files__new',
	                    onClick: function onClick() {
	                      return _this10.setState({ hideUpload: false });
	                    }
	                  },
	                  translation.upload_exam.new
	                )
	              ),
	              !this.state.hideUpload && _react2.default.createElement(_FileUpload2.default, Object.assign({}, this.props, {
	                label: translation.upload_exam.label,
	                helper: translation.upload_exam.helper,
	                onDrop: function onDrop(attachments) {
	                  return ManagerStore.returnFiles = attachments;
	                },
	                files: this.state.returnFiles,
	                single: true,
	                fileType: 'application/pdf',
	                maxSize: 10000000
	              })),
	              ManagerStore.returnFiles.length > 0 && _react2.default.createElement(
	                'div',
	                { className: 'btn-group file__submit' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn',
	                    onClick: function onClick() {
	                      _this10.setState({ hideUpload: true, returnFiles: [] });
	                      ManagerStore.returnExam(installSid, examSid, session.sid);
	                    }
	                  },
	                  _react2.default.createElement(icons.iconUpload, null),
	                  (!session.returnedFile || !session.returnedFile.file) && translation.upload_exam.button,
	                  session.returnedFile && session.returnedFile.file && translation.upload_exam.new_button
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactTabs.Tabs,
	              {
	                className: 'panel__tabs',
	                onSelect: this.handleTabs
	              },
	              _react2.default.createElement(
	                _reactTabs.TabList,
	                { className: 'tabs-enabled' },
	                _react2.default.createElement(
	                  _reactTabs.Tab,
	                  null,
	                  translation.tabs.exam_details
	                ),
	                _react2.default.createElement(
	                  _reactTabs.Tab,
	                  null,
	                  translation.tabs.location
	                ),
	                _react2.default.createElement(
	                  _reactTabs.Tab,
	                  null,
	                  translation.tabs.notes
	                ),
	                _react2.default.createElement(
	                  _reactTabs.Tab,
	                  { onClick: this.getRoster },
	                  translation.tabs.faculty
	                ),
	                !this.props.noInteract && _react2.default.createElement(
	                  _reactTabs.Tab,
	                  { onClick: this.getIncidents },
	                  translation.tabs.incidents
	                )
	              ),
	              _react2.default.createElement(
	                _reactTabs.TabPanel,
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'meta' },
	                  translation.exam_details.heading
	                ),
	                _react2.default.createElement(
	                  'section',
	                  { className: 'session__section' },
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'data-heading' },
	                    translation.exam_details.heading
	                  ),
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'data--alt session__data' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        translation.exam_details.date,
	                        ':'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _moment2.default.utc(session.appointmentDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        translation.exam_details.duration,
	                        ':'
	                      ),
	                      session.examConfiguration.duration >= 60 && _react2.default.createElement(
	                        'p',
	                        null,
	                        (0, _helpers.toHours)(session.examConfiguration.duration, false, false, true)
	                      ),
	                      session.examConfiguration.duration < 60 && _react2.default.createElement(
	                        'p',
	                        null,
	                        session.examConfiguration.duration,
	                        ' ',
	                        translation.exam_details.minutes
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        translation.exam_details.title,
	                        ':'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        session.exam.title
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        translation.exam_details.type,
	                        ':'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        session.exam.type
	                      )
	                    ),
	                    session.exam.type.toLowerCase() !== 'written' && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: 'session-url' },
	                          translation.exam_details.url,
	                          ':'
	                        )
	                      ),
	                      _react2.default.createElement('input', {
	                        id: 'session-url',
	                        type: 'text',
	                        defaultValue: session.exam.url,
	                        readOnly: true,
	                        onFocus: function onFocus(e) {
	                          return e.target.setSelectionRange(0, 9999);
	                        }
	                      })
	                    ),
	                    session.exam.type.toLowerCase() !== 'written' && session.examConfiguration.password && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        translation.exam_details.password,
	                        ':'
	                      ),
	                      _react2.default.createElement(_Privacy2.default, Object.assign({
	                        className: 'faux-input faux-input--enabled',
	                        show: translation.reveal_password,
	                        hide: translation.hide_password,
	                        'private': session.examConfiguration.password
	                      }, this.props))
	                    ),
	                    session.schedulingModule === 'smarter-scheduling' && useSeatManagement && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        translation.exam_details.seat
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        seatName
	                      ),
	                      !this.props.noInteract && _react2.default.createElement(
	                        'button',
	                        { onClick: function onClick() {
	                            return _this10.changeSeat();
	                          }, className: 'btn--link' },
	                        translation.exam_details.move_seat
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'strong',
	                        null,
	                        translation.exam_details.status
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        ScheduleStore.session.status
	                      ),
	                      !this.props.noInteract && ScheduleStore.session.status.toLowerCase() !== 'closed' && ScheduleStore.session.status.toLowerCase() !== 'cancelled' && ScheduleStore.session.status.toLowerCase() !== 'processing' && _react2.default.createElement(
	                        'button',
	                        { onClick: function onClick() {
	                            return _this10.changeStatus();
	                          }, className: 'btn--link' },
	                        translation.exam_details.change_status
	                      )
	                    )
	                  ),
	                  !this.props.noInteract && ScheduleStore.session.status.toLowerCase() !== 'closed' && ScheduleStore.session.status.toLowerCase() !== 'cancelled' && ScheduleStore.session.status.toLowerCase() !== 'processing' && this.renderCancelButton(session)
	                ),
	                _react2.default.createElement(
	                  'section',
	                  { className: 'session__section' },
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'data-heading' },
	                    translation.permitted_items.heading
	                  ),
	                  this.permittedItems()
	                ),
	                session.examConfiguration.attachments && session.examConfiguration.attachments.length > 0 && _react2.default.createElement(
	                  'section',
	                  { className: 'session__section' },
	                  _react2.default.createElement(_ExamAttachmentsList2.default, Object.assign({
	                    parent: this,
	                    examDashboard: false
	                  }, this.props, {
	                    exam: session.exam,
	                    examConfiguration: session.examConfiguration,
	                    sessionManager: true
	                  }))
	                )
	              ),
	              _react2.default.createElement(
	                _reactTabs.TabPanel,
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'meta' },
	                  translation.location_information.heading
	                ),
	                _react2.default.createElement(
	                  'section',
	                  { className: 'session__section' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'session-detail__location' },
	                    _react2.default.createElement(
	                      'ul',
	                      { className: 'data--alt vcard' },
	                      _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                          'strong',
	                          null,
	                          translation.location_information.address
	                        ),
	                        _react2.default.createElement(
	                          'p',
	                          { className: 'adr' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'street-address' },
	                            address
	                          ),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'locality' },
	                            location.place
	                          ),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'region' },
	                            location.region ? ', ' + location.region : ''
	                          ),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'postal-code' },
	                            ' ',
	                            location.postalCode
	                          ),
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'country' },
	                            location.country
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement('img', {
	                      className: 'map--static session-detail__map',
	                      width: '400', height: '250',
	                      src: (0, _helpers.getMapUrl)(location.latitude, location.longitude),
	                      alt: 'A map of the location'
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactTabs.TabPanel,
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  translation.notes.proctor_notes
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: session.examConfiguration.proctorNotes ? '' : 'empty' },
	                  session.examConfiguration.proctorNotes || 'No proctor notes provided.'
	                ),
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  translation.notes.student_notes
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: session.examConfiguration.studentNotes ? '' : 'empty' },
	                  session.examConfiguration.studentNotes || 'No student notes provided.'
	                )
	              ),
	              _react2.default.createElement(
	                _reactTabs.TabPanel,
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'meta' },
	                  translation.faculty.heading
	                ),
	                EnrollmentStore.courseRoster.length > 0 && _react2.default.createElement(
	                  'table',
	                  null,
	                  _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'th',
	                        { className: 'subtitle', scope: 'col' },
	                        translation.faculty.name
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        { className: 'subtitle', scope: 'col' },
	                        translation.faculty.role
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        { className: 'subtitle', scope: 'col' },
	                        translation.faculty.email
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    EnrollmentStore.courseRoster.map(function (key, i) {
	                      return _react2.default.createElement(
	                        'tr',
	                        { key: i },
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          key.lastName,
	                          ', ',
	                          key.firstName
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'capitalize' },
	                          key.role
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          key.email
	                        )
	                      );
	                    })
	                  )
	                ),
	                EnrollmentStore.courseRoster.length === 0 && SessionStore.backgroundLoadingCalls.indexOf('CourseRoster') < 0 && _react2.default.createElement(
	                  'span',
	                  { className: 'no-results' },
	                  translation.faculty.no_results
	                ),
	                EnrollmentStore.courseRoster.length === 0 && SessionStore.backgroundLoadingCalls.indexOf('CourseRoster') >= 0 && _react2.default.createElement(
	                  'span',
	                  { className: 'loader-bar' },
	                  'Loading\u2026'
	                )
	              ),
	              !this.props.noInteract && _react2.default.createElement(
	                _reactTabs.TabPanel,
	                null,
	                _react2.default.createElement(
	                  'h3',
	                  { className: 'meta' },
	                  translation.incidents.heading
	                ),
	                ExamStore.sessionEvents.length > 0 && _react2.default.createElement(
	                  'table',
	                  null,
	                  _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                      'tr',
	                      null,
	                      _react2.default.createElement(
	                        'th',
	                        { className: 'subtitle', scope: 'col' },
	                        translation.incidents.type
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        { className: 'subtitle', scope: 'col' },
	                        translation.incidents.subject
	                      ),
	                      _react2.default.createElement(
	                        'th',
	                        { className: 'subtitle', scope: 'col' },
	                        'Actions'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'tbody',
	                    null,
	                    ExamStore.sessionEvents.map(function (key, i) {
	                      return _react2.default.createElement(
	                        'tr',
	                        { key: i },
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          key.eventType.title
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          key.subject
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          { className: 'actions' },
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              className: 'btn--outline',
	                              onClick: function onClick() {
	                                _this10.editIncident(session.sid, key.sid);
	                              }
	                            },
	                            _react2.default.createElement(icons.iconEdit, null),
	                            translation.incidents.edit
	                          ),
	                          _react2.default.createElement(
	                            'button',
	                            {
	                              className: 'btn--outline btn--negative',
	                              onClick: function onClick() {
	                                _this10.deleteIncident(key.sid);
	                              }
	                            },
	                            _react2.default.createElement(icons.iconTrash, null),
	                            translation.incidents.delete
	                          )
	                        )
	                      );
	                    })
	                  )
	                ),
	                ExamStore.sessionEvents.length === 0 && SessionStore.backgroundLoadingCalls.indexOf('GetSessionEvents') < 0 && _react2.default.createElement(
	                  'span',
	                  { className: 'no-results' },
	                  translation.incidents.no_results
	                ),
	                ExamStore.sessionEvents.length === 0 && SessionStore.backgroundLoadingCalls.indexOf('GetSessionEvents') >= 0 && _react2.default.createElement(
	                  'span',
	                  { className: 'loader-bar' },
	                  'Loading\u2026'
	                ),
	                SessionStore.backgroundLoadingCalls.indexOf('GetSessionEvents') < 0 && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn--negative',
	                    onClick: function onClick() {
	                      return _this10.reportIncident(session.sid);
	                    }
	                  },
	                  translation.incidents.report_incident
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SessionInformation;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionInformation')(SessionInformation);

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Session = __webpack_require__(302);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _SessionPlayer = __webpack_require__(912);
	
	var _SessionPlayer2 = _interopRequireDefault(_SessionPlayer);
	
	var _AddToCalendar = __webpack_require__(844);
	
	var _AddToCalendar2 = _interopRequireDefault(_AddToCalendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var SessionDetail = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionDetail, _React$Component);
	
	  function SessionDetail() {
	    _classCallCheck(this, SessionDetail);
	
	    var _this = _possibleConstructorReturn(this, (SessionDetail.__proto__ || Object.getPrototypeOf(SessionDetail)).call(this));
	
	    _this.closeSession = _this.closeSession.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    return _this;
	  }
	
	  _createClass(SessionDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var ScheduleStore = this.props.store.ScheduleStore;
	
	      var sessionSid = (0, _helpers.getURLSegment)(this, 2);
	
	      if (this.props.sessionSid) {
	        sessionSid = this.props.sessionSid;
	      }
	
	      if (ScheduleStore.events.length > 0 && !this.props.timeline) {
	        ScheduleStore.getSingleSession(sessionSid);
	      } else {
	        var callback = function callback() {
	          ScheduleStore.getSingleSession(sessionSid);
	        };
	
	        ScheduleStore.getSessions(null, null, callback, sessionSid);
	      }
	
	      this.state = {
	        slideoutHidden: true,
	        hideForm: true
	      };
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.timeline) {
	        this.props.store.ScheduleStore.getSessions(100, 'Scheduled');
	      }
	    }
	  }, {
	    key: 'closeSession',
	    value: function closeSession() {
	      var _this2 = this;
	
	      var session = this.props.store.ScheduleStore.session;
	      var examSid = session.examSid,
	          installSid = session.installSid,
	          sid = session.sid;
	
	
	      var callback = function callback() {
	        return _this2.complete('closed');
	      };
	
	      this.props.store.ScheduleStore.closeSession(installSid, examSid, sid, callback);
	    }
	  }, {
	    key: 'complete',
	    value: function complete(action) {
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (action === 'closed') {
	        (0, _helpers.closeDrawer)(null, this.props.parent, (0, _helpers.getURLSegment)(this, 1));
	        SessionStore.showToaster(translation.closed_message, 'success');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var session = this.props.store.ScheduleStore.session;
	      var location = session.location;
	
	      var address = location ? (location.address1 || '') + ' ' + (location.address2 || '') : '';
	
	      var embed = false;
	
	      if (SessionStore.userData.skin && SessionStore.userData.skin === 'embed') {
	        embed = true;
	      }
	
	      if ((!SessionStore.loading || SessionStore.loadingCalls.indexOf('getExamFile') > -1) && session.sid) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          session.platformVersion === "3" && session.workflowModule === 'hybrid-scheduling' && ['closed', 'cancelled'].includes(session.status.toLowerCase()) ? _react2.default.createElement(_SessionPlayer2.default, Object.assign({
	            session: session,
	            parent: this,
	            installSid: session.installSid,
	            courseSid: session.course.sid,
	            examSid: session.examSid
	          }, this.props)) : _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            !embed && _react2.default.createElement(
	              'header',
	              { className: 'drawer__header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'h1',
	                    { className: 'drawer__title' },
	                    session.enrollment.firstName,
	                    ' ',
	                    session.enrollment.lastName
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'drawer__note' },
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      _moment2.default.utc(session.appointmentDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	                    ),
	                    session.examConfiguration.duration >= 60 && _react2.default.createElement(
	                      'span',
	                      null,
	                      (0, _helpers.toHours)(session.examConfiguration.duration, false, false, true)
	                    ),
	                    session.examConfiguration.duration < 60 && _react2.default.createElement(
	                      'span',
	                      null,
	                      session.examConfiguration.duration,
	                      ' ',
	                      translation.exam_details.minutes
	                    )
	                  )
	                ),
	                _react2.default.createElement(_AddToCalendar2.default, Object.assign({
	                  title: session.enrollment.firstName + ' ' + session.enrollment.lastName + ' \u2013 ' + (session.exam ? session.exam.title : ''),
	                  start: new Date(session.appointmentDate),
	                  duration: session.examConfiguration.duration,
	                  location: address + ' ' + location.place + ', ' + location.region + ', ' + location.postalCode + ' ' + location.country,
	                  lat: location.latitude,
	                  lon: location.longitude
	                }, this.props))
	              )
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'block-list session-list' },
	              _react2.default.createElement(_Session2.default, Object.assign({
	                session: session,
	                parent: this,
	                installSid: session.installSid,
	                courseSid: session.course.sid,
	                examSid: session.examSid,
	                location: location,
	                address: address
	              }, this.props))
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return SessionDetail;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionDetail')(SessionDetail);

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactTextareaAutosize = __webpack_require__(98);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	var _platform = __webpack_require__(1091);
	
	var _platform2 = _interopRequireDefault(_platform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// import Dropzone from 'react-dropzone';
	
	// Components
	// import * as icons from '../Icons/Icons';
	
	var TicketForm = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(TicketForm, _React$Component);
	
	  function TicketForm() {
	    _classCallCheck(this, TicketForm);
	
	    // this.handleDrop = this.handleDrop.bind(this);
	    // this.handleDragEnter = this.handleDragEnter.bind(this);
	    // this.handleDragLeave = this.handleDragLeave.bind(this);
	    // this.removeFile = this.removeFile.bind(this);
	    var _this = _possibleConstructorReturn(this, (TicketForm.__proto__ || Object.getPrototypeOf(TicketForm)).call(this));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    _this.resolve = _this.resolve.bind(_this);
	    return _this;
	  }
	
	  _createClass(TicketForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        attachment: [],
	        dropClass: '',
	        status: 'open',
	        body: '',
	        formClass: ''
	      };
	
	      if (this.props.newTicket) {
	        this.props.store.TicketStore.getTicketTypes();
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          TicketStore = _props$store.TicketStore;
	      var activeTicket = TicketStore.activeTicket;
	
	
	      var data = null;
	
	      if (this.props.newTicket) {
	        data = {
	          subject: this.subject.value,
	          type: this.type.value,
	          details: this.comment.value,
	          browserInformation: _platform2.default.toString(),
	          domain: window.location.host
	        };
	
	        TicketStore.postTicket(data, this.complete);
	      } else {
	        data = {
	          body: this.comment.value,
	          proctorUserSid: SessionStore.userData.sid
	        };
	
	        this.comment.value = '';
	
	        this.setState({
	          formClass: 'form-sending'
	        });
	
	        TicketStore.postReply(activeTicket.sid, data, this.complete);
	      }
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      if (this.props.newTicket) {
	        var segment1 = (0, _helpers.getURLSegment)(this, 1);
	
	        (0, _helpers.closeDrawer)(null, this.props.parent, segment1);
	
	        this.props.store.SessionStore.showToaster(this.props.translation.ticket_submitted, 'success');
	      } else {
	        this.setState({
	          formClass: ''
	        });
	
	        // Remove any errors
	        var form = document.querySelector('.reply__form');
	        var fieldset = form.querySelector('fieldset');
	        var error = form.querySelector('.note--error');
	        form.classList.remove('submitted');
	        if (error) {
	          fieldset.removeChild(error);
	        }
	      }
	    }
	  }, {
	    key: 'resolve',
	    value: function resolve(e) {
	      e.preventDefault();
	
	      var TicketStore = this.props.store.TicketStore;
	      var activeTicket = TicketStore.activeTicket;
	
	
	      TicketStore.updateTicket(activeTicket.sid, 'Resolved');
	
	      if (typeof this.comment !== 'undefined' && this.comment.value) {
	        this.handleSubmit(e);
	      }
	    }
	  }, {
	    key: 'reopen',
	    value: function reopen(e) {
	      e.preventDefault();
	
	      var TicketStore = this.props.store.TicketStore;
	      var activeTicket = TicketStore.activeTicket;
	
	
	      TicketStore.updateTicket(activeTicket.sid, 'Open');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          activeTicket = _props.activeTicket,
	          newTicket = _props.newTicket,
	          store = _props.store,
	          translation = _props.translation;
	      var ticketTypes = store.TicketStore.ticketTypes;
	
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'reply__form ' + this.state.formClass, onSubmit: function onSubmit(e) {
	            return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	          }, noValidate: true },
	        (newTicket || typeof activeTicket !== 'undefined' && activeTicket.status.toLowerCase() === 'open') && _react2.default.createElement(
	          'div',
	          { className: 'panel--medium' },
	          _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	              'ul',
	              { className: 'fields' },
	              newTicket && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'ticket-subject' },
	                  translation.subject.label
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  id: 'ticket-subject',
	                  placeholder: translation.subject.helper,
	                  ref: function ref(input) {
	                    _this2.subject = input;
	                  },
	                  required: true,
	                  'aria-required': 'true'
	                })
	              ),
	              newTicket && _react2.default.createElement(
	                'li',
	                { className: 'field--auto' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'ticket-type' },
	                  translation.type.label
	                ),
	                _react2.default.createElement(
	                  'label',
	                  { className: 'select', htmlFor: 'ticket-type' },
	                  _react2.default.createElement(
	                    'select',
	                    {
	                      ref: function ref(input) {
	                        _this2.type = input;
	                      },
	                      required: true,
	                      'aria-required': 'true'
	                    },
	                    _react2.default.createElement(
	                      'option',
	                      { value: '' },
	                      translation.type.helper
	                    ),
	                    ticketTypes.map(function (key, i) {
	                      return _react2.default.createElement(
	                        'option',
	                        { key: i, value: key },
	                        key
	                      );
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'ticket-comment' },
	                  translation.comments.label
	                ),
	                _react2.default.createElement(_reactTextareaAutosize2.default, {
	                  id: 'ticket-comment',
	                  className: 'textarea-grow',
	                  placeholder: translation.comments.helper,
	                  ref: function ref(input) {
	                    _this2.comment = input;
	                  },
	                  onChange: this.handleInput,
	                  required: true,
	                  'aria-required': 'true'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'em',
	            { className: 'form-note' },
	            translation.note
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', type: 'submit' },
	            translation.submit
	          ),
	          typeof activeTicket !== 'undefined' && activeTicket.status.toLowerCase() === 'open' && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn--outline',
	              type: 'submit',
	              onClick: function onClick(e) {
	                _this2.resolve(e);
	              }
	            },
	            translation.resolve
	          )
	        ),
	        typeof activeTicket !== 'undefined' && activeTicket.status.toLowerCase() === 'resolved' && _react2.default.createElement(
	          'div',
	          { className: 'panel--medium' },
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.resolved_note
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn--outline',
	              onClick: function onClick(e) {
	                _this2.reopen(e);
	              }
	            },
	            translation.reopen
	          )
	        )
	      );
	    }
	  }]);
	
	  return TicketForm;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('TicketForm')(TicketForm);

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	__webpack_require__(1293);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var obx = (0, _mobx.observable)({
	  exam: {
	    title: '',
	    type: "Online",
	    description: '',
	    useProctorManager: false,
	    requireApproval: false,
	    url: '',
	    enableAppointmentSuggestions: false,
	    configuration: {
	      examOpenDate: '',
	      examCloseDate: '',
	      scheduleOpenDate: '',
	      scheduleCloseDate: '',
	      password: '',
	      duration: 0,
	      attempts: 1,
	      requiredSoftware: '',
	      studentNotes: '',
	      proctorNotes: '',
	      proctorTypes: []
	    }
	  },
	  configuration: null,
	  // Reset exam data
	  resetExam: (0, _mobx.action)(function () {
	    obx.exam = {
	      title: '',
	      type: "Online",
	      description: '',
	      useProctorManager: false,
	      requireApproval: false,
	      url: '',
	      enableAppointmentSuggestions: false,
	      configuration: {
	        examOpenDate: '',
	        examCloseDate: '',
	        scheduleOpenDate: '',
	        scheduleCloseDate: '',
	        password: '',
	        duration: 0,
	        attempts: 1,
	        requiredSoftware: '',
	        studentNotes: '',
	        proctorNotes: '',
	        proctorTypes: [],
	        permittedBathroomBreak: false,
	        permittedBathroomBreakInformation: '',
	        permittedBlankPaper: false,
	        permittedBlankPaperInformation: '',
	        permittedCalculator: false,
	        permittedCalculatorInformation: '',
	        permittedDictionary: false,
	        permittedDictionaryInformation: '',
	        permittedEarplugs: false,
	        permittedEarplugsInformation: '',
	        permittedFormulaSheet: false,
	        permittedFormulaSheetInformation: '',
	        permittedNotes: false,
	        permittedNotesInformation: '',
	        permittedOtherItems: '',
	        permittedTextbook: false,
	        permittedTextbookInformation: '',
	        permittedWebsites: false,
	        permittedWebsitesInformation: '',
	        instructorAsProctor: []
	      }
	    };
	  }),
	  // Get a specific exam
	  getExam: (0, _mobx.action)(function (sid) {
	    _SessionStore2.default.startLoading('Loading…', 'Exam');
	    obx.resetExam();
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + _SessionStore2.default.userData.courseSid + '/exams/' + sid).then(function (response) {
	      obx.exam = response.data;
	      obx.defaultExam = response.data;
	      _SessionStore2.default.finishLoading('Exam');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Reset custom configuration data
	  resetConfigurationData: (0, _mobx.action)(function () {
	    obx.customConfiguration = null;
	  }),
	  // Get custom configuration data
	  getConfigurationData: (0, _mobx.action)(function (examSid, sid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetConfiguration');
	    obx.resetConfigurationData();
	
	    _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + _SessionStore2.default.userData.courseSid + '/exams/' + examSid + '/configurations/' + sid).then(function (response) {
	      obx.configuration = response.data;
	      _SessionStore2.default.finishLoading('GetConfiguration');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get incident types
	  incidentTypes: [],
	  incidentSid: null,
	  incidentSession: null,
	  getIncidentTypes: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'GetIncidentTypes');
	
	    obx.incidentTypes = [];
	
	    _config.api.get('/sessions/events/types').then(function (response) {
	      obx.incidentTypes = response.data.results;
	      _SessionStore2.default.finishLoading('GetIncidentTypes');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Create session incident
	  createSessionEvent: (0, _mobx.action)(function (installSid, examSid, sessionSid, data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateSessionEvent');
	
	    _config.api.post('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/events', data).then(function () {
	      // obx.getSessionEvents(installSid, examSid, sessionSid);
	      _SessionStore2.default.finishLoading('CreateSessionEvent');
	
	      obx.getSessionEvents(installSid, examSid, sessionSid);
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update session incident
	  updateSessionEvent: (0, _mobx.action)(function (installSid, examSid, sessionSid, eventSid, data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateSessionEvent');
	
	    delete data.sid;
	    delete data.examSessionSid;
	    delete data.createdDate;
	    delete data.eventType;
	
	    _config.api.put('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/events/' + eventSid, data).then(function () {
	      // obx.getSessionEvents(installSid, examSid, sessionSid);
	      obx.incidentSid = null;
	      _SessionStore2.default.finishLoading('UpdateSessionEvent');
	
	      obx.getSessionEvents(installSid, examSid, sessionSid);
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Delete session incident
	  deleteSessionEvent: (0, _mobx.action)(function (installSid, examSid, sessionSid, eventSid) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteSessionEvent');
	
	    _config.api.delete('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/events/' + eventSid).then(function () {
	      _SessionStore2.default.finishLoading('DeleteSessionEvent');
	      obx.getSessionEvents(installSid, examSid, sessionSid);
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get a specific incident
	  incident: {},
	  getSingleSessionEvent: (0, _mobx.action)(function (installSid, examSid, sessionSid, incidentSid, component) {
	    _SessionStore2.default.startLoading('Loading…', 'GetSpecificEvent');
	
	    obx.incident = {};
	
	    return _config.api.get('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/events/' + incidentSid).then(function (response) {
	      obx.incident = response.data;
	
	      if (component) {
	        component.setState({
	          incidentData: response.data
	        });
	
	        // Make sure date is the right format
	        var incidentData = Object.assign({}, component.state.incidentData);
	        incidentData.eventTime = response.data.eventTime;
	
	        component.setState({
	          incidentData: incidentData
	        });
	        component.setState({
	          date: (0, _moment2.default)(response.data.eventTime)
	        });
	      }
	
	      _SessionStore2.default.finishLoading('GetSpecificEvent');
	      return response.data;
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get incidents for a session
	  sessionEvents: [],
	  getSessionEvents: (0, _mobx.action)(function (installSid, examSid, sessionSid, backgroundLoad) {
	    if (!backgroundLoad) {
	      _SessionStore2.default.startLoading('Loading…', 'GetSessionEvents');
	    } else {
	      _SessionStore2.default.startBackgroundLoading('GetSessionEvents');
	    }
	
	    obx.sessionEvents = [];
	
	    _config.api.get('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/events').then(function (response) {
	      obx.sessionEvents = response.data.results;
	
	      if (!backgroundLoad) {
	        _SessionStore2.default.finishLoading('GetSessionEvents');
	      } else {
	        _SessionStore2.default.finishBackgroundLoading('GetSessionEvents');
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Dependencies
	exports.default = obx;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// Components
	
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  locations: [],
	  locationSid: null,
	  locationData: {
	    name: null,
	    address1: null,
	    address2: null,
	    place: null,
	    region: null,
	    country: null,
	    postalCode: null,
	    locationLatitude: 0,
	    locationLongitude: 0,
	    notes: null,
	    smokeFree: false,
	    parkingInformation: null,
	    hasComputerAvailable: false,
	    hasPrinterAvailable: false,
	    hasCopierAvailable: false,
	    hasFaxAvailable: false,
	    hasElevator: false,
	    hasWheelchairRamp: false,
	    hasAlternativeKeyboards: false,
	    hasScreenEnlarger: false,
	    hasScreenReader: false,
	    hasSpeechRecognition: false,
	    hasTextToSpeech: false,
	    hasDistractionFreeRooms: false,
	    timeZoneSid: 'TZ356c0b38525c4d94a1b60e76ded97066',
	    currencyCode: 'USD',
	    proctorLocationTypeSid: 'LT5e18eda572134379939dd2ef766ebf43'
	  },
	  locationAvailability: [],
	  locationAvailabilityData: {
	    accountSid: null,
	    lateSchedulingLeadTime: 0,
	    enabled: true,
	    registerBlastExamGroup: null
	  },
	  locationTypesList: [],
	  getLocationTypes: (0, _mobx.action)(function () {
	    _config.api.get('/proctors/locations/types').then(function (response) {
	      obx.locationTypesList = response.data.results;
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  renderMap: true,
	  getLocations: (0, _mobx.action)(function (callback) {
	    _SessionStore2.default.startLoading('Loading…', 'Locations');
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/locations').then(function (response) {
	      _SessionStore2.default.finishLoading('Locations');
	      obx.locations = response.data.results;
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  updateLocationData: (0, _mobx.action)(function (data) {
	    if (data.preventRender) {
	      obx.renderMap = false;
	    } else {
	      obx.resetLocation();
	    }
	
	    for (var key in data) {
	      if (data.hasOwnProperty(key)) {
	        var newData = data[key];
	        obx.locationData[key] = newData;
	      }
	    }
	
	    // sessionStorage.setItem('registerData', JSON.stringify(obx.registerData));
	  }),
	  cleanData: (0, _mobx.action)(function () {
	    delete obx.locationData.sid;
	    delete obx.locationData.proctorSid;
	    delete obx.locationData.createdDate;
	    delete obx.locationData.lastModifiedDate;
	    delete obx.locationData.preventRender;
	    delete obx.locationData.distance;
	    delete obx.locationData.schedulingModule;
	
	    if (!obx.locationData.hasScreenEnlarger) {
	      obx.locationData.hasScreenEnlarger = false;
	    }
	  }),
	  getLocation: (0, _mobx.action)(function (locationSid) {
	    _SessionStore2.default.startLoading('Loading…', 'Location');
	    obx.resetLocation();
	    obx.locationSid = locationSid;
	    obx.renderMap = false;
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/locations/' + locationSid).then(function (response) {
	      _SessionStore2.default.finishLoading('Location');
	      obx.renderMap = false;
	      obx.locationData = response.data;
	
	      // Tell map to render after data is received
	      obx.renderMap = true;
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  createLocation: (0, _mobx.action)(function (func, component) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateLocation');
	
	    obx.cleanData();
	
	    _config.api.post('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/locations', obx.locationData).then(function (response) {
	      _SessionStore2.default.finishLoading('CreateLocation');
	      obx.locationSid = response.data.sid;
	      component.state.locationSid = obx.locationSid;
	      obx.getLocationAvailability(component);
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  updateLocation: (0, _mobx.action)(function (func, locationSid) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateLocation');
	
	    obx.cleanData();
	
	    if (!obx.locationData.timeZoneSid) {
	      obx.locationData.timeZoneSid = _config.config.defaultTimeZoneSid;
	    }
	
	    _config.api.put('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/locations/' + locationSid, obx.locationData).then(function (response) {
	      _SessionStore2.default.finishLoading('UpdateLocation');
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  resetLocation: (0, _mobx.action)(function () {
	    obx.locationData.name = null;
	    obx.locationData.address1 = null;
	    obx.locationData.address2 = null;
	    obx.locationData.place = null;
	    obx.locationData.region = null;
	    obx.locationData.country = null;
	    obx.locationData.postalCode = null;
	    obx.locationData.locationLatitude = 0;
	    obx.locationData.locationLongitude = 0;
	    obx.locationData.notes = null;
	    obx.locationData.smokeFree = false;
	    obx.locationData.parkingInformation = null;
	    obx.locationData.hasComputerAvailable = false;
	    obx.locationData.hasPrinterAvailable = false;
	    obx.locationData.hasCopierAvailable = false;
	    obx.locationData.hasFaxAvailable = false;
	    obx.locationData.hasElevator = false;
	    obx.locationData.hasWheelchairRamp = false;
	    obx.locationData.hasAlternativeKeyboards = false;
	    obx.locationData.hasScreenEnlarger = false;
	    obx.locationData.hasScreenReader = false;
	    obx.locationData.hasSpeechRecognition = false;
	    obx.locationData.hasTextToSpeech = false;
	    obx.locationData.hasDistractionFreeRooms = false;
	    obx.locationData.timeZoneSid = 'TZ356c0b38525c4d94a1b60e76ded97066';
	    obx.locationData.currencyCode = 'USD';
	    obx.locationData.proctorLocationTypeSid = 'LT5e18eda572134379939dd2ef766ebf43';
	    obx.examGroups = [];
	  }),
	  deleteLocation: (0, _mobx.action)(function (locationSid) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteLocation');
	
	    _config.api.delete('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/locations/' + locationSid, obx.locationData).then(function (response) {
	      _SessionStore2.default.finishLoading('DeleteLocation');
	      obx.getLocations();
	    }).catch(function (error) {
	      console.log(error);
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  getLocationAvailability: (0, _mobx.action)(function (component) {
	    _SessionStore2.default.startLoading('Loading…', 'GetLocationAvailability');
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/location/' + obx.locationSid + '/availability').then(function (response) {
	      _SessionStore2.default.finishLoading('GetLocationAvailability');
	      obx.locationAvailability = response.data.results;
	      obx.locationAvailability.forEach(function (element) {
	        // Set the default price model
	        if (element.fees.length < 2 && element.fees[0].maximumSessionLength === 480) {
	          element.priceModel = 'flat';
	        } else {
	          element.priceModel = 'tiered';
	        }
	
	        // Set the default currencies
	        element.currencies = [];
	
	        Object.keys(element.fees[0].amounts).map(function (key) {
	          return element.currencies.push(key);
	        });
	
	        // If session lengths are null, it’s a new location and we need to
	        // set some defaults
	        if (element.fees[0].minimumSessionLength === null) {
	          element.fees[0].minimumSessionLength = 0;
	          element.fees[0].maximumSessionLength = 480;
	          element.fees[0].amounts = {
	            USD: {
	              service: 0,
	              late: 0
	            }
	          };
	          element.currencies = ['USD'];
	        }
	
	        // Set array of session lengths
	        element.sessionLength = [];
	        element.fees.forEach(function (sessionTime) {
	          element.sessionLength.push(sessionTime.minimumSessionLength);
	        });
	        element.sessionLength.push(element.fees[element.fees.length - 1].maximumSessionLength);
	      });
	
	      component.setState({
	        priceGroups: (0, _mobx.toJS)(obx.locationAvailability)
	      });
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  createLocationAvailability: (0, _mobx.action)(function (sid, component) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateLocationAvailability');
	    obx.locationAvailabilityData.accountSid = sid;
	
	    var data = obx.locationAvailabilityData;
	
	    if (!data.registerBlastExamGroup) {
	      delete data.registerBlastExamGroup;
	    }
	
	    if (!data.registerBlastWrittenExamGroupKey) {
	      delete data.registerBlastWrittenExamGroupKey;
	    }
	
	    if (!data.registerBlastHybridExamGroupKey) {
	      delete data.registerBlastHybridExamGroupKey;
	    }
	
	    _config.api.post('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/location/' + obx.locationSid + '/availability', data).then(function (response) {
	      _SessionStore2.default.finishLoading('CreateLocationAvailability');
	
	      // Set up new availability object
	      obx.locationAvailability = component.state.priceGroups;
	      var newAvailability = Object.assign({}, obx.locationAvailability[0]);
	      newAvailability.sid = response.data.sid;
	      newAvailability.account = {};
	      newAvailability.account.sid = response.data.account.sid;
	      newAvailability.account.name = response.data.account.name;
	      newAvailability.fees = [(0, _mobx.toJS)(newAvailability.fees[0])];
	      newAvailability.fees[0].minimumSessionLength = 0;
	      newAvailability.fees[0].maximumSessionLength = 480;
	      newAvailability.sessionLength = [0, 480];
	      newAvailability.lateSchedulingLeadTime = 0;
	      obx.locationAvailability.push(newAvailability);
	
	      component.setState({
	        priceGroups: (0, _mobx.toJS)(obx.locationAvailability)
	      });
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  removeLocationAvailability: (0, _mobx.action)(function (sid, component) {
	    _SessionStore2.default.startLoading('Loading…', 'DeleteLocationAvailability');
	
	    _config.api.delete('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/location/' + obx.locationSid + '/availability/' + sid).then(function (response) {
	      _SessionStore2.default.finishLoading('DeleteLocationAvailability');
	      obx.getLocationAvailability(component);
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  toggleLocationAvailability: (0, _mobx.action)(function (i) {
	    obx.locationAvailability[i].enabled = !obx.locationAvailability[i].enabled;
	    obx.locationAvailability[i].updated = true;
	  }),
	  setPriceGroupModel: (0, _mobx.action)(function (i, value) {
	    obx.locationAvailability[i].priceModel = value;
	  }),
	  updateAvailabilityData: (0, _mobx.action)(function (i, data, prop) {
	    obx.locationAvailability[i][prop] = data;
	    obx.locationAvailability[i].updated = true;
	
	    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
	      for (var key in data) {
	        if (data[key]) {
	          var newData = data[key];
	          obx.locationAvailability[i][key] = newData;
	        }
	      }
	    }
	  }),
	  updateLocationAvailability: (0, _mobx.action)(function (i) {
	    if (obx.locationAvailability[i].updated) {
	      _SessionStore2.default.startLoading('Loading…', 'UpdateLocationAvailability');
	
	      var payload = {};
	
	      if (obx.locationAvailability[i].account) {
	        payload.accountSid = obx.locationAvailability[i].account.sid;
	      } else {
	        payload.accountSid = null;
	      }
	
	      payload.lateSchedulingLeadTime = obx.locationAvailability[i].lateSchedulingLeadTime;
	      payload.enabled = obx.locationAvailability[i].enabled;
	      payload.cancellationPolicySid = obx.locationAvailability[i].cancellationPolicySid;
	
	      if (obx.locationAvailability[i].registerBlastExamGroup) {
	        payload.registerBlastExamGroup = obx.locationAvailability[i].registerBlastExamGroup;
	      }
	
	      if (obx.locationAvailability[i].registerBlastWrittenExamGroupKey) {
	        payload.registerBlastWrittenExamGroupKey = obx.locationAvailability[i].registerBlastWrittenExamGroupKey;
	      }
	
	      if (obx.locationAvailability[i].registerBlastHybridExamGroupKey) {
	        payload.registerBlastHybridExamGroupKey = obx.locationAvailability[i].registerBlastHybridExamGroupKey;
	      }
	
	      if (obx.locationAvailability[i].smarterSchedulingCalendarSid) {
	        payload.smarterSchedulingCalendarSid = obx.locationAvailability[i].smarterSchedulingCalendarSid;
	      }
	
	      obx.locationAvailability[i].updated = false;
	
	      _config.api.put('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/location/' + obx.locationSid + '/availability/' + obx.locationAvailability[i].sid, payload).then(function (response) {
	        _SessionStore2.default.finishLoading('UpdateLocationAvailability');
	      }).catch(function (error) {
	        _SessionStore2.default.throwError(error);
	      });
	    }
	  }),
	  updateFeeData: (0, _mobx.action)(function (value, availabilityIndex, feeIndex, currency, fieldType) {
	    obx.locationAvailability[availabilityIndex].fees[feeIndex].amounts[currency][fieldType] = parseInt(value, 10);
	  }),
	  updateFees: (0, _mobx.action)(function (availabilityGroups, func) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateFees');
	
	    var _loop = function _loop(i) {
	      // API expects different property names than what the get API provides
	      availabilityGroups[i].fees.forEach(function (element) {
	        if (element.hasOwnProperty('minimumSessionLength')) {
	          element.minimumLength = element.minimumSessionLength;
	          element.maximumLength = element.maximumSessionLength;
	          delete element.minimumSessionLength;
	          delete element.maximumSessionLength;
	        }
	      });
	
	      _config.api.put('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/locations/' + obx.locationSid + '/availability/' + obx.locationAvailability[i].sid + '/fees', availabilityGroups[i].fees).then(function (response) {
	        if (i + 1 === obx.locationAvailability.length) {
	          func();
	        }
	
	        _SessionStore2.default.finishLoading('UpdateFees');
	
	        obx.updateLocationAvailability(i);
	      }).catch(function (error) {
	        _SessionStore2.default.throwError(error);
	      });
	    };
	
	    for (var i = 0; i < availabilityGroups.length; i++) {
	      _loop(i);
	    }
	  }),
	  // Get RegisterBlast Exam Groups
	  examGroups: [],
	  gettingGroups: false,
	  getExamGroups: (0, _mobx.action)(function (locationSid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetExamGroups');
	
	    obx.examGroups = [];
	    obx.gettingGroups = true;
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/locations/' + locationSid + '/registerBlast/examGroups').then(function (response) {
	      obx.examGroups = response.data.results;
	      obx.gettingGroups = false;
	
	      // Loop through availabilities and remove any
	      // exam group IDs that don't exist
	      if (obx.locationAvailability && obx.locationAvailability.length > 0) {
	        // Create an array of just the existing exam group IDs
	        var examGroupIds = [];
	
	        obx.examGroups.forEach(function (examGroup) {
	          examGroupIds.push(examGroup.id);
	        });
	
	        obx.locationAvailability.forEach(function (availability) {
	          // Remove outdated registerBlastExamGroup
	          if (availability.registerBlastExamGroup && examGroupIds.indexOf(availability.registerBlastExamGroup) < 0) {
	            availability.registerBlastExamGroup = null;
	          }
	
	          // Remove outdated registerBlastWrittenExamGroupKey
	          if (availability.registerBlastWrittenExamGroupKey && examGroupIds.indexOf(availability.registerBlastWrittenExamGroupKey) < 0) {
	            availability.registerBlastWrittenExamGroupKey = null;
	          }
	
	          // Remove outdated registerBlastHybridExamGroupKey
	          if (availability.registerBlastHybridExamGroupKey && examGroupIds.indexOf(availability.registerBlastHybridExamGroupKey) < 0) {
	            availability.registerBlastHybridExamGroupKey = null;
	          }
	        });
	      }
	
	      _SessionStore2.default.finishLoading('GetExamGroups');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	exports.default = obx;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _ScheduleStore = __webpack_require__(75);
	
	var _ScheduleStore2 = _interopRequireDefault(_ScheduleStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var obx = (0, _mobx.observable)({
	  sessions: [],
	  multi: false,
	  addSession: false,
	  reportIncident: false,
	  incidentSession: null,
	  incidentSid: null,
	  // Get session
	  getSession: (0, _mobx.action)(function (accessKey, component, dialogContent) {
	    // Check if the session is already being viewed
	    var session = obx.sessions.filter(function (key) {
	      return key.accessKey === accessKey;
	    })[0];
	
	    if (typeof session === 'undefined') {
	      _SessionStore2.default.startLoading('Loading…', 'GetManagerSession');
	
	      _config.api.get('/sessions/' + accessKey).then(function (response) {
	        obx.sessions.push(response.data);
	        _SessionStore2.default.finishLoading('GetManagerSession');
	
	        var _response$data = response.data,
	            installSid = _response$data.installSid,
	            courseSid = _response$data.courseSid,
	            enrollmentSid = _response$data.enrollmentSid,
	            examSid = _response$data.examSid,
	            sid = _response$data.sid,
	            schedulingModule = _response$data.schedulingModule;
	
	
	        component.setState({
	          installSid: installSid,
	          courseSid: courseSid,
	          examSid: examSid,
	          schedulingModule: schedulingModule
	        });
	
	        obx.getSessionEnrollment(installSid, courseSid, enrollmentSid, sid);
	        obx.getSessionExam(installSid, courseSid, examSid, sid);
	      }).catch(function (error) {
	        _SessionStore2.default.throwError(error);
	      });
	    } else {
	      obx.addSession = false;
	      _SessionStore2.default.showDialog(dialogContent);
	    }
	  }),
	  // Get the session details
	  appointmentTimelineSession: null,
	  getExamSession: (0, _mobx.action)(function (installSid, examSid, sessionSid, dialogContent, component) {
	    var appointmentTimeline = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	    // Check if the session is already being viewed
	    var session = obx.sessions.filter(function (key) {
	      return key.sid === sessionSid;
	    })[0];
	
	    if (typeof session === 'undefined') {
	      _SessionStore2.default.startLoading('Loading…', 'GetManagerExamSession');
	
	      return _config.api.get('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid).then(function (response) {
	        obx.sessions.push(response.data);
	
	        // Get enrollment and exam data
	        var _response$data2 = response.data,
	            courseSid = _response$data2.courseSid,
	            enrollmentSid = _response$data2.enrollmentSid,
	            examSid = _response$data2.examSid,
	            sid = _response$data2.sid;
	
	        obx.getSessionEnrollment(installSid, courseSid, enrollmentSid, sid);
	        if (!appointmentTimeline) {
	          obx.getSessionExam(installSid, courseSid, examSid, sid);
	        }
	
	        // Add the courseSid to the parent state so we can use it later
	        component.setState({
	          courseSid: courseSid
	        });
	
	        // Finish loading
	        _SessionStore2.default.finishLoading('GetManagerExamSession');
	
	        if (appointmentTimeline) {
	          return response.data;
	        }
	      }).catch(function (error) {
	        _SessionStore2.default.throwError(error);
	      });
	    } else {
	      obx.addSession = false;
	      if (!appointmentTimeline) {
	        _SessionStore2.default.showDialog(dialogContent);
	      } else {
	        return session;
	      }
	    }
	  }),
	  // Get the session enrollment
	  getSessionEnrollment: (0, _mobx.action)(function (installSid, courseSid, enrollmentSid, sessionSid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetManagerExamEnrollment');
	
	    _config.api.get('/installs/' + installSid + '/courses/' + courseSid + '/enrollments?enrollmentSid=' + enrollmentSid).then(function (response) {
	      // Filter the response to only the current enrollment
	      var enrollment = response.data.results[0];
	
	      // Get this session from the array
	      var session = obx.sessions.filter(function (key) {
	        return key.sid === sessionSid;
	      })[0];
	
	      // Add the enrollment data to this session
	      session.enrollment = enrollment;
	
	      // Finish loading
	      _SessionStore2.default.finishLoading('GetManagerExamEnrollment');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get the session exam data
	  getSessionExam: (0, _mobx.action)(function (installSid, courseSid, examSid, sessionSid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetManagerExamData');
	
	    _config.api.get('/installs/' + installSid + '/courses/' + courseSid + '/exams/' + examSid).then(function (response) {
	      // Get this session from the array
	      var session = obx.sessions.filter(function (key) {
	        return key.sid === sessionSid;
	      })[0];
	
	      // Add the exam data to this session
	      session.exam = response.data;
	
	      // Finish loading
	      _SessionStore2.default.finishLoading('GetManagerExamData');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Close a session
	  closeExamSession: (0, _mobx.action)(function (sessionSid) {
	    obx.sessions = obx.sessions.filter(function (key) {
	      return key.sid !== sessionSid;
	    });
	  }),
	  // Complete a session
	  completeExamSession: (0, _mobx.action)(function (installSid, examSid, sessionSid, callback, schedulingModule) {
	    _SessionStore2.default.startLoading('Loading…', 'CloseManagerSession');
	
	    var data = {
	      type: 'messaging',
	      reason: 'exam-completed'
	    };
	
	    if (schedulingModule) {
	      console.log(schedulingModule);
	
	      data.type = schedulingModule;
	    }
	
	    _config.api.post('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/close', data).then(function (response) {
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('CloseManagerSession');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Cancel exam session
	  cancelExamSession: (0, _mobx.action)(function (sessionSid, data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'cancelExamSession');
	
	    _config.api.delete('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/sessions/' + sessionSid, { data: data }).then(function (response) {
	      _SessionStore2.default.finishLoading('cancelExamSession');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Return written files
	  returnFiles: [],
	  returnExam: (0, _mobx.action)(function (installSid, examSid, sessionSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'returnExam');
	
	    var formData = new FormData();
	
	    for (var i = 0; i < obx.returnFiles.length; i++) {
	      formData.append('returnFiles[]', obx.returnFiles[i]);
	    }
	
	    _config.api.put('/installs/' + installSid + '/exams/' + examSid + '/sessions/' + sessionSid + '/returnFile', formData).then(function (response) {
	      obx.returnFiles = [];
	
	      _ScheduleStore2.default.session.returnedFile = {
	        createdDate: response.data.dateCreated,
	        file: response.data.url
	      };
	
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('returnExam');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	exports.default = obx;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import ExamStore from './ExamStore';
	
	var obx = (0, _mobx.observable)({
	  threads: [],
	  // Get all message threads
	  getThreads: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'GetThreads');
	
	    // Temporarily hardcoded install sid. Probably will drop the install from the endpoint
	    _config.api.get('/messages?userSid=' + _SessionStore2.default.userData.sid).then(function (response) {
	      obx.threads = response.data.results;
	      _SessionStore2.default.finishLoading('GetThreads');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get thread ID
	  activeThread: {},
	  getThreadId: (0, _mobx.action)(function (toUserSid, contextType, contextId) {
	    obx.activeThread = {};
	
	    _config.api.get('/messages?userSid=' + _SessionStore2.default.userData.sid).then(function (response) {
	      var threadId = null;
	
	      // Filter the result by recipient, context type (e.g. examSid), and context id
	      var existingThread = response.data.results.filter(function (thread) {
	        if (contextType === 'courseSid') {
	          return thread.courseSid === contextId && thread.examConfiguration === null && thread.examSessionEventReport === null && thread.examSid === null && thread.proctorApproval === null;
	        } else {
	          return thread[contextType] === contextId;
	        }
	      });
	
	      if (existingThread.length > 0) {
	        threadId = existingThread[0].sid;
	        obx.activeThread = existingThread[0];
	      }
	
	      if (threadId) {
	        // Get the actual thread
	        obx.getThread(threadId);
	      } else {
	        // Otherwise if no thread matches, reset the thread message array
	        obx.threadMessages = [];
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get an individual thread
	  threadMessages: [],
	  threadObject: {},
	  getThread: (0, _mobx.action)(function (sid, forceScroll) {
	    obx.threadMessages = [];
	
	    _SessionStore2.default.startBackgroundLoading('GetThread');
	
	    _config.api.get('/messages/' + sid + '?includeItems=true').then(function (response) {
	      obx.threadMessages = response.data.items;
	      obx.threadObject = response.data;
	
	      // // If there’s a configuration sid, get that data
	      // if(response.data.examConfigurationSid) {
	      //   ExamStore.getConfigurationData(response.data.examSid, response.data.examConfigurationSid);
	      // }
	
	      // // If there’s an exam sid, get that data
	      // if(response.data.examSid) {
	      //   ExamStore.getExam(response.data.examSid);
	      // }
	
	      _SessionStore2.default.finishBackgroundLoading('GetThread');
	
	      // If we want the thread scrolled to the bottom
	      if (forceScroll) {
	        setTimeout(function () {
	          var drawer = document.querySelector('.drawer');
	          var inbox = document.querySelector('.inbox__content');
	
	          if (drawer) {
	            drawer.scrollTop = drawer.scrollHeight;
	          } else {
	            inbox.scrollTop = inbox.scrollHeight;
	          }
	        }, 100);
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	
	    // Mark the thread as read
	    var readUser = {
	      userSid: _SessionStore2.default.userData.sid
	    };
	
	    _config.api.put('/messages/' + sid + '/read', readUser).then(function (response) {
	      _SessionStore2.default.getUnreadCount();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Create a thread
	  createThread: (0, _mobx.action)(function (data, callback) {
	    _SessionStore2.default.startBackgroundLoading('CreateThread');
	
	    _config.api.post('/messages', data).then(function (response) {
	      _SessionStore2.default.finishBackgroundLoading('CreateThread');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Reply to a thread
	  replyToThread: (0, _mobx.action)(function (sid, data) {
	    _SessionStore2.default.startBackgroundLoading('ReplyToThread');
	
	    _config.api.post('/messages/' + sid + '/items', data).then(function (response) {
	      _SessionStore2.default.finishBackgroundLoading('ReplyToThread');
	      obx.getThread(response.data.messageThreadSid);
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Confirm date
	  confirmDate: (0, _mobx.action)(function (sid, data, callback) {
	    _SessionStore2.default.startBackgroundLoading('ConfirmDate');
	
	    _config.api.put('/messages/' + sid + '/confirm', data).then(function (response) {
	      _SessionStore2.default.finishBackgroundLoading('ConfirmDate');
	      obx.getThread(sid, true);
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Cancel request/clear schedule dates
	  cancelRequest: (0, _mobx.action)(function (sid, datesEl) {
	    _SessionStore2.default.startBackgroundLoading('DeleteRequest');
	
	    _config.api.delete('/messages/' + sid + '/dates').then(function (response) {
	      if (datesEl) {
	        // Fade the request out
	        datesEl.className += ' fade-out';
	
	        // Then remove it after the fade
	        setTimeout(function () {
	          datesEl.remove();
	        }, 250);
	      }
	
	      _SessionStore2.default.finishBackgroundLoading('DeleteRequest');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  balance: 0,
	  totalBalance: null,
	  paymentSessions: [],
	  paymentData: {
	    type: null,
	    startDate: '2000-01-01T00:00:00.000Z',
	    endDate: '2070-01-01T00:00:00.000Z',
	    payTo: null
	  },
	  // Reset payment data
	  resetPaymentData: (0, _mobx.action)(function () {
	    obx.paymentData = {
	      type: null,
	      startDate: '2000-01-01T00:00:00.000Z',
	      endDate: '2070-01-01T00:00:00.000Z',
	      payTo: null
	    };
	
	    obx.checkUrl = null;
	  }),
	  location: {},
	  // Get balance
	  getBalance: (0, _mobx.action)(function (totalBalance, backgroundLoad) {
	    if (!backgroundLoad) {
	      _SessionStore2.default.startLoading('Loading…', 'GetBalance');
	    } else {
	      _SessionStore2.default.startBackgroundLoading('GetBalance');
	    }
	
	    var query = '';
	
	    if (!totalBalance) {
	      query = '?startDate=' + obx.paymentData.startDate + '&endDate=' + obx.paymentData.endDate;
	
	      if (obx.paymentData.locationSid) {
	        query += '&locationSid=' + obx.paymentData.locationSid;
	      }
	    }
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/balance' + query).then(function (response) {
	      if (totalBalance) {
	        obx.totalBalance = response.data.summary.total;
	      }
	
	      obx.balance = response.data.summary.total;
	      obx.paymentSessions = response.data.results;
	
	      if (!backgroundLoad) {
	        _SessionStore2.default.finishLoading('GetBalance');
	      } else {
	        _SessionStore2.default.finishBackgroundLoading('GetBalance');
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get payment history
	  paymentHistory: [],
	  getPaymentHistory: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'GetPaymentHistory');
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/payments?sortOrder=DESC').then(function (response) {
	      obx.paymentHistory = response.data.results;
	      _SessionStore2.default.finishLoading('GetPaymentHistory');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get an individual payment
	  selectedPayment: {},
	  getPayment: (0, _mobx.action)(function (sid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetPayment');
	
	    obx.selectedPayment = {};
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/payments/' + sid).then(function (response) {
	      obx.selectedPayment = response.data;
	      _SessionStore2.default.finishLoading('GetPayment');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Validate payment credentials
	  validatePayment: (0, _mobx.action)(function (password, errorMsg, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'ValidatePayment');
	
	    var data = {
	      password: password,
	      username: _SessionStore2.default.userData.username
	
	      // Proctors coming over from the old system seem to
	      // not have a username property given when they
	      // log in with their token, so fall back to the
	      // email address if a username is not set
	    };if (!data.username) {
	      data.username = _SessionStore2.default.userData.email;
	    }
	
	    console.log(data);
	
	    _config.api.post('/proctors/login', data).then(function (response) {
	      obx.createPayment(callback);
	      _SessionStore2.default.finishLoading('ValidatePayment');
	    }).catch(function (error) {
	      _SessionStore2.default.finishLoading('ValidatePayment');
	      _SessionStore2.default.showDialog(errorMsg);
	    });
	  }),
	  // Generate check
	  checkUrl: null,
	  createPayment: (0, _mobx.action)(function (callback) {
	    _SessionStore2.default.startLoading('Loading…', 'CreatePayment');
	
	    var data = obx.paymentData;
	
	    if (!data.payTo) {
	      data.payTo = _SessionStore2.default.profile.firstName + ' ' + _SessionStore2.default.profile.lastName;
	    }
	
	    // Insert location data into payment data
	    Object.keys(obx.location).forEach(function (key, i) {
	      if (obx.location[key]) {
	        data[key] = obx.location[key];
	      }
	    });
	
	    if (!data.locationSid) {
	      delete data.locationSid;
	    }
	
	    _config.api.post('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/payments', data).then(function (response) {
	      _SessionStore2.default.finishLoading('CreatePayment');
	
	      if (data.type === 'online-check') {
	        obx.checkUrl = response.data.pdfUrl;
	      }
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(67);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 311 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addLeadingZeros;
	function addLeadingZeros(number, targetLength) {
	  var sign = number < 0 ? '-' : '';
	  var output = Math.abs(number).toString();
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	  return sign + output;
	}
	module.exports = exports.default;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(985));
	var _default = _index.default;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 313 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'P':
	      return formatLong.date({
	        width: 'short'
	      });
	    case 'PP':
	      return formatLong.date({
	        width: 'medium'
	      });
	    case 'PPP':
	      return formatLong.date({
	        width: 'long'
	      });
	    case 'PPPP':
	    default:
	      return formatLong.date({
	        width: 'full'
	      });
	  }
	};
	var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'p':
	      return formatLong.time({
	        width: 'short'
	      });
	    case 'pp':
	      return formatLong.time({
	        width: 'medium'
	      });
	    case 'ppp':
	      return formatLong.time({
	        width: 'long'
	      });
	    case 'pppp':
	    default:
	      return formatLong.time({
	        width: 'full'
	      });
	  }
	};
	var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
	  var matchResult = pattern.match(/(P+)(p+)?/) || [];
	  var datePattern = matchResult[1];
	  var timePattern = matchResult[2];
	  if (!timePattern) {
	    return dateLongFormatter(pattern, formatLong);
	  }
	  var dateTimeFormat;
	  switch (datePattern) {
	    case 'P':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'short'
	      });
	      break;
	    case 'PP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'medium'
	      });
	      break;
	    case 'PPP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'long'
	      });
	      break;
	    case 'PPPP':
	    default:
	      dateTimeFormat = formatLong.dateTime({
	        width: 'full'
	      });
	      break;
	  }
	  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
	};
	var longFormatters = {
	  p: timeLongFormatter,
	  P: dateTimeLongFormatter
	};
	var _default = longFormatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(88));
	var _index3 = _interopRequireDefault(__webpack_require__(946));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_WEEK = 604800000;
	function getUTCISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(88));
	function getUTCISOWeekYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeek;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(89));
	var _index3 = _interopRequireDefault(__webpack_require__(947));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_WEEK = 604800000;
	function getUTCWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 317 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
	exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
	exports.throwProtectedError = throwProtectedError;
	var protectedDayOfYearTokens = ['D', 'DD'];
	var protectedWeekYearTokens = ['YY', 'YYYY'];
	function isProtectedDayOfYearToken(token) {
	  return protectedDayOfYearTokens.indexOf(token) !== -1;
	}
	function isProtectedWeekYearToken(token) {
	  return protectedWeekYearTokens.indexOf(token) !== -1;
	}
	function throwProtectedError(token, format, input) {
	  if (token === 'YYYY') {
	    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  } else if (token === 'YY') {
	    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  } else if (token === 'D') {
	    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  } else if (token === 'DD') {
	    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  }
	}

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addHours;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(172));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_HOUR = 3600000;
	
	/**
	 * @name addHours
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	function addHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
	}
	module.exports = exports.default;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMinutes;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(172));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_MINUTE = 60000;
	
	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	function addMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
	}
	module.exports = exports.default;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addWeeks;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(171));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name addWeeks
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * const result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var days = amount * 7;
	  return (0, _index2.default)(dirtyDate, days);
	}
	module.exports = exports.default;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addYears;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(173));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * const result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12);
	}
	module.exports = exports.default;

/***/ },
/* 322 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.secondsInYear = exports.secondsInWeek = exports.secondsInQuarter = exports.secondsInMonth = exports.secondsInMinute = exports.secondsInHour = exports.secondsInDay = exports.quartersInYear = exports.monthsInYear = exports.monthsInQuarter = exports.minutesInHour = exports.minTime = exports.millisecondsInSecond = exports.millisecondsInMinute = exports.millisecondsInHour = exports.maxTime = exports.daysInYear = exports.daysInWeek = void 0;
	/**
	 * Days in 1 week.
	 *
	 * @name daysInWeek
	 * @constant
	 * @type {number}
	 * @default
	 */
	var daysInWeek = 7;
	
	/**
	 * Days in 1 year
	 * One years equals 365.2425 days according to the formula:
	 *
	 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	 *
	 * @name daysInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.daysInWeek = daysInWeek;
	var daysInYear = 365.2425;
	
	/**
	 * Maximum allowed time.
	 *
	 * @name maxTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.daysInYear = daysInYear;
	var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
	
	/**
	 * Milliseconds in 1 minute
	 *
	 * @name millisecondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.maxTime = maxTime;
	var millisecondsInMinute = 60000;
	
	/**
	 * Milliseconds in 1 hour
	 *
	 * @name millisecondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.millisecondsInMinute = millisecondsInMinute;
	var millisecondsInHour = 3600000;
	
	/**
	 * Milliseconds in 1 second
	 *
	 * @name millisecondsInSecond
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.millisecondsInHour = millisecondsInHour;
	var millisecondsInSecond = 1000;
	
	/**
	 * Minimum allowed time.
	 *
	 * @name minTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.millisecondsInSecond = millisecondsInSecond;
	var minTime = -maxTime;
	
	/**
	 * Minutes in 1 hour
	 *
	 * @name minutesInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.minTime = minTime;
	var minutesInHour = 60;
	
	/**
	 * Months in 1 quarter
	 *
	 * @name monthsInQuarter
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.minutesInHour = minutesInHour;
	var monthsInQuarter = 3;
	
	/**
	 * Months in 1 year
	 *
	 * @name monthsInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.monthsInQuarter = monthsInQuarter;
	var monthsInYear = 12;
	
	/**
	 * Quarters in 1 year
	 *
	 * @name quartersInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.monthsInYear = monthsInYear;
	var quartersInYear = 4;
	
	/**
	 * Seconds in 1 hour
	 *
	 * @name secondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.quartersInYear = quartersInYear;
	var secondsInHour = 3600;
	
	/**
	 * Seconds in 1 minute
	 *
	 * @name secondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInHour = secondsInHour;
	var secondsInMinute = 60;
	
	/**
	 * Seconds in 1 day
	 *
	 * @name secondsInDay
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInMinute = secondsInMinute;
	var secondsInDay = secondsInHour * 24;
	
	/**
	 * Seconds in 1 week
	 *
	 * @name secondsInWeek
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInDay = secondsInDay;
	var secondsInWeek = secondsInDay * 7;
	
	/**
	 * Seconds in 1 year
	 *
	 * @name secondsInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInWeek = secondsInWeek;
	var secondsInYear = secondsInDay * daysInYear;
	
	/**
	 * Seconds in 1 month
	 *
	 * @name secondsInMonth
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInYear = secondsInYear;
	var secondsInMonth = secondsInYear / 12;
	
	/**
	 * Seconds in 1 quarter
	 *
	 * @name secondsInQuarter
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInMonth = secondsInMonth;
	var secondsInQuarter = secondsInMonth * 3;
	exports.secondsInQuarter = secondsInQuarter;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDate;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _index = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isDate
	 * @category Common Helpers
	 * @summary Is the given value a date?
	 *
	 * @description
	 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
	 *
	 * @param {*} value - the value to check
	 * @returns {boolean} true if the given value is a date
	 * @throws {TypeError} 1 arguments required
	 *
	 * @example
	 * // For a valid date:
	 * const result = isDate(new Date())
	 * //=> true
	 *
	 * @example
	 * // For an invalid date:
	 * const result = isDate(new Date(NaN))
	 * //=> true
	 *
	 * @example
	 * // For some value:
	 * const result = isDate('2014-02-31')
	 * //=> false
	 *
	 * @example
	 * // For an object:
	 * const result = isDate({})
	 * //=> false
	 */
	function isDate(value) {
	  (0, _index.default)(1, arguments);
	  return value instanceof Date || (0, _typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
	}
	module.exports = exports.default;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	var _index = _interopRequireDefault(__webpack_require__(323));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {*} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // For the valid date:
	 * const result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * const result = isValid(1393804800000)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * const result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') {
	    return false;
	  }
	  var date = (0, _index2.default)(dirtyDate);
	  return !isNaN(Number(date));
	}
	module.exports = exports.default;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValueSetter = exports.Setter = exports.DateToSystemTimezoneSetter = void 0;
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var TIMEZONE_UNIT_PRIORITY = 10;
	var Setter = /*#__PURE__*/function () {
	  function Setter() {
	    (0, _classCallCheck2.default)(this, Setter);
	    (0, _defineProperty2.default)(this, "priority", void 0);
	    (0, _defineProperty2.default)(this, "subPriority", 0);
	  }
	  (0, _createClass2.default)(Setter, [{
	    key: "validate",
	    value: function validate(_utcDate, _options) {
	      return true;
	    }
	  }]);
	  return Setter;
	}();
	exports.Setter = Setter;
	var ValueSetter = /*#__PURE__*/function (_Setter) {
	  (0, _inherits2.default)(ValueSetter, _Setter);
	  var _super = (0, _createSuper2.default)(ValueSetter);
	  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
	    var _this;
	    (0, _classCallCheck2.default)(this, ValueSetter);
	    _this = _super.call(this);
	    _this.value = value;
	    _this.validateValue = validateValue;
	    _this.setValue = setValue;
	    _this.priority = priority;
	    if (subPriority) {
	      _this.subPriority = subPriority;
	    }
	    return _this;
	  }
	  (0, _createClass2.default)(ValueSetter, [{
	    key: "validate",
	    value: function validate(utcDate, options) {
	      return this.validateValue(utcDate, this.value, options);
	    }
	  }, {
	    key: "set",
	    value: function set(utcDate, flags, options) {
	      return this.setValue(utcDate, flags, this.value, options);
	    }
	  }]);
	  return ValueSetter;
	}(Setter);
	exports.ValueSetter = ValueSetter;
	var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
	  (0, _inherits2.default)(DateToSystemTimezoneSetter, _Setter2);
	  var _super2 = (0, _createSuper2.default)(DateToSystemTimezoneSetter);
	  function DateToSystemTimezoneSetter() {
	    var _this2;
	    (0, _classCallCheck2.default)(this, DateToSystemTimezoneSetter);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this2 = _super2.call.apply(_super2, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "subPriority", -1);
	    return _this2;
	  }
	  (0, _createClass2.default)(DateToSystemTimezoneSetter, [{
	    key: "set",
	    value: function set(date, flags) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	      var convertedDate = new Date(0);
	      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
	      return convertedDate;
	    }
	  }]);
	  return DateToSystemTimezoneSetter;
	}(Setter);
	exports.DateToSystemTimezoneSetter = DateToSystemTimezoneSetter;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMonth;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(958));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name setMonth
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @returns {Date} the new date with the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * const result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth(dirtyDate, dirtyMonth) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var month = (0, _index.default)(dirtyMonth);
	  var year = date.getFullYear();
	  var day = date.getDate();
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(year, month, 15);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth);
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(month, Math.min(day, daysInMonth));
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfQuarter;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name startOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the start of a year quarter for the given date.
	 *
	 * @description
	 * Return the start of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a quarter for 2 September 2014 11:55:00:
	 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Jul 01 2014 00:00:00
	 */
	function startOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3;
	  date.setMonth(month, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(172));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	/**
	 * @name subMilliseconds
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }
	
	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;
	
	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];
	
	  return emitter;
	}
	
	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];
	
	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];
	
	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];
	
	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ },
/* 330 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 331 */
330,
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(66);
	
	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ },
/* 333 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else {
			var a = factory();
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 8);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mapValues;
	function mapValues(obj, f) {
	  if (obj == null) {
	    return {};
	  }
	
	  var res = {};
	  Object.keys(obj).forEach(function (key) {
	    res[key] = f(obj[key]);
	  });
	  return res;
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setActive = setActive;
	exports.default = registerXHR;
	
	var _mapValues = __webpack_require__(0);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _enhanceFunc = __webpack_require__(2);
	
	var _enhanceFunc2 = _interopRequireDefault(_enhanceFunc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isActive = true;
	
	function setActive(shouldBeActive) {
	  isActive = shouldBeActive;
	}
	
	var currentXHRId = 0;
	function registerXHR(_ref) {
	  var addRequest = _ref.addRequest,
	      addResponse = _ref.addResponse;
	
	  var _XHR = XMLHttpRequest;
	  var xhrMap = new WeakMap();
	  var unsubscribedFromXhr = false;
	  // const LOGROCKET_XHR_LABEL = 'logrocket_xhr';
	  var LOGROCKET_XHR_LABEL = 'xhr-';
	
	  window._lrXMLHttpRequest = XMLHttpRequest;
	
	  // eslint-disable-next-line no-native-reassign
	  XMLHttpRequest = function XMLHttpRequest(mozAnon, mozSystem) {
	    var xhrObject = new _XHR(mozAnon, mozSystem);
	    if (!isActive) {
	      return xhrObject;
	    }
	
	    xhrMap.set(xhrObject, {
	      xhrId: ++currentXHRId,
	      headers: {}
	    });
	
	    // ..., 'open', (method, url, async, username, password) => {
	    (0, _enhanceFunc2.default)(xhrObject, 'open', function (method, url) {
	      if (unsubscribedFromXhr) return;
	      var currentXHR = xhrMap.get(xhrObject);
	      currentXHR.method = method;
	      currentXHR.url = url;
	    });
	
	    (0, _enhanceFunc2.default)(xhrObject, 'send', function (data) {
	      if (unsubscribedFromXhr) return;
	      var currentXHR = xhrMap.get(xhrObject);
	      if (!currentXHR) return;
	
	      var request = {
	        url: currentXHR.url,
	        method: currentXHR.method && currentXHR.method.toUpperCase(),
	        headers: (0, _mapValues2.default)(currentXHR.headers || {}, function (headerValues) {
	          return headerValues.join(', ');
	        }),
	        body: data
	      };
	      addRequest('' + LOGROCKET_XHR_LABEL + currentXHR.xhrId, request);
	    });
	
	    (0, _enhanceFunc2.default)(xhrObject, 'setRequestHeader', function (header, value) {
	      if (unsubscribedFromXhr) return;
	      var currentXHR = xhrMap.get(xhrObject);
	      if (!currentXHR) return;
	
	      currentXHR.headers = currentXHR.headers || {};
	      currentXHR.headers[header] = currentXHR.headers[header] || [];
	      currentXHR.headers[header].push(value);
	    });
	
	    var xhrListeners = {
	      readystatechange: function readystatechange() {
	        if (unsubscribedFromXhr) return;
	
	        if (xhrObject.readyState === 4) {
	          var currentXHR = xhrMap.get(xhrObject);
	          if (!currentXHR) return;
	
	          var headerString = xhrObject.getAllResponseHeaders();
	
	          var headers = headerString.split(/[\r\n]+/).reduce(function (previous, current) {
	            var next = previous;
	            var headerParts = current.split(': ');
	            if (headerParts.length > 0) {
	              var key = headerParts.shift(); // first index of the array
	              var value = headerParts.join(': '); // rest of the array repaired
	              if (previous[key]) {
	                next[key] += ', ' + value;
	              } else {
	                next[key] = value;
	              }
	            }
	            return next;
	          }, {});
	
	          var body = void 0;
	
	          // IE 11 sometimes throws when trying to access a large responses:
	          // https://connect.microsoft.com/IE/Feedback/Details/1053110
	          try {
	            switch (xhrObject.responseType) {
	              case 'json':
	              case 'arraybuffer':
	              case 'blob':
	                {
	                  body = xhrObject.response;
	                  break;
	                }
	              case 'document':
	                {
	                  body = xhrObject.responseXML;
	                  break;
	                }
	              case 'text':
	              case '':
	                {
	                  body = xhrObject.responseText;
	                  break;
	                }
	              default:
	                {
	                  body = '';
	                }
	            }
	          } catch (err) {
	            body = 'LogRocket: Error accessing response.';
	          }
	
	          var response = {
	            url: currentXHR.url,
	            status: xhrObject.status,
	            headers: headers,
	            body: body,
	            method: (currentXHR.method || '').toUpperCase()
	          };
	
	          addResponse('' + LOGROCKET_XHR_LABEL + currentXHR.xhrId, response);
	        }
	      }
	      // // Unused Event Listeners
	      // loadstart: () => {},
	      // progress: () => {},
	      // abort: () => {},
	      // error: () => {},
	      // load: () => {},
	      // timeout: () => {},
	      // loadend: () => {},
	    };
	
	    Object.keys(xhrListeners).forEach(function (key) {
	      xhrObject.addEventListener(key, xhrListeners[key]);
	    });
	
	    return xhrObject;
	  };
	
	  // this allows "instanceof XMLHttpRequest" to work
	  XMLHttpRequest.prototype = _XHR.prototype;
	
	  // Persist the static variables.
	  ['UNSENT', 'OPENED', 'HEADERS_RECEIVED', 'LOADING', 'DONE'].forEach(function (variable) {
	    XMLHttpRequest[variable] = _XHR[variable];
	  });
	
	  return function () {
	    unsubscribedFromXhr = true;
	    // eslint-disable-next-line no-native-reassign
	    XMLHttpRequest = _XHR;
	  };
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = enhanceFunc;
	/* eslint no-param-reassign: ["error", { "props": false }] */
	
	function enhanceFunc(obj, method, handler) {
	  var original = obj[method];
	
	  function shim() {
	    var res = void 0;
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (original) {
	      res = original.apply(this, args);
	    }
	
	    handler.apply(this, args);
	    return res;
	  }
	
	  obj[method] = shim;
	
	  return function () {
	    obj[method] = original;
	  };
	}
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Capture = exports.registerExceptions = undefined;
	
	var _registerExceptions = __webpack_require__(16);
	
	var _registerExceptions2 = _interopRequireDefault(_registerExceptions);
	
	var _Capture = __webpack_require__(6);
	
	var Capture = _interopRequireWildcard(_Capture);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.registerExceptions = _registerExceptions2.default;
	exports.Capture = Capture;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
	var g;
	
	// This works in non-strict mode
	g = (function() {
		return this;
	})();
	
	try {
		// This works if eval is allowed (see CSP)
		g = g || Function("return this")() || (1, eval)("this");
	} catch (e) {
		// This works if the window reference is available
		if (typeof window === "object") g = window;
	}
	
	// g can still be undefined, but nothing to do about it...
	// We return undefined, instead of nothing here, so it's
	// easier to handle this case. if(!global) { ...}
	
	module.exports = g;
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {/* eslint-disable */
	
	
	
	/*
	 TraceKit - Cross brower stack traces - github.com/occ/TraceKit
	
	 This was originally forked from github.com/occ/TraceKit, but has since been
	 largely re-written and is now maintained as part of raven-js.  Tests for
	 this are in test/vendor.
	
	 MIT license
	*/
	
	var TraceKit = {
	    collectWindowErrors: true,
	    debug: false
	};
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;
	
	function getLocationHref() {
	    if (typeof document === 'undefined' || typeof document.location === 'undefined') return '';
	
	    return document.location.href;
	}
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = function reportModuleWrapper() {
	    var handlers = [],
	        lastArgs = null,
	        lastException = null,
	        lastExceptionStack = null;
	
	    /**
	     * Add a crash handler.
	     * @param {Function} handler
	     */
	    function subscribe(handler) {
	        installGlobalHandler();
	        handlers.push(handler);
	    }
	
	    /**
	     * Remove a crash handler.
	     * @param {Function} handler
	     */
	    function unsubscribe(handler) {
	        for (var i = handlers.length - 1; i >= 0; --i) {
	            if (handlers[i] === handler) {
	                handlers.splice(i, 1);
	            }
	        }
	    }
	
	    /**
	     * Remove all crash handlers.
	     */
	    function unsubscribeAll() {
	        uninstallGlobalHandler();
	        handlers = [];
	    }
	
	    /**
	     * Dispatch stack information to all handlers.
	     * @param {Object.<string, *>} stack
	     */
	    function notifyHandlers(stack, isWindowError) {
	        var exception = null;
	        if (isWindowError && !TraceKit.collectWindowErrors) {
	            return;
	        }
	        for (var i in handlers) {
	            if (handlers.hasOwnProperty(i)) {
	                try {
	                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	                } catch (inner) {
	                    exception = inner;
	                }
	            }
	        }
	
	        if (exception) {
	            throw exception;
	        }
	    }
	
	    var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	    /**
	     * Ensures all global unhandled exceptions are recorded.
	     * Supported by Gecko and IE.
	     * @param {string} message Error message.
	     * @param {string} url URL of script that generated the exception.
	     * @param {(number|string)} lineNo The line number at which the error
	     * occurred.
	     * @param {?(number|string)} colNo The column number at which the error
	     * occurred.
	     * @param {?Error} ex The actual Error object.
	     */
	    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
	        var stack = null;
	
	        if (lastExceptionStack) {
	            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
	            processLastException();
	        } else if (ex) {
	            // New chrome and blink send along a real error object
	            // Let's just report that like a normal error.
	            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	            stack = TraceKit.computeStackTrace(ex);
	            notifyHandlers(stack, true);
	        } else {
	            var location = {
	                'url': url,
	                'line': lineNo,
	                'column': colNo
	            };
	
	            var name = undefined;
	            var msg = message; // must be new var or will modify original `arguments`
	            var groups;
	            if ({}.toString.call(message) === '[object String]') {
	                var groups = message.match(ERROR_TYPES_RE);
	                if (groups) {
	                    name = groups[1];
	                    msg = groups[2];
	                }
	            }
	
	            location.func = UNKNOWN_FUNCTION;
	
	            stack = {
	                'name': name,
	                'message': msg,
	                'url': getLocationHref(),
	                'stack': [location]
	            };
	            notifyHandlers(stack, true);
	        }
	
	        if (_oldOnerrorHandler) {
	            return _oldOnerrorHandler.apply(this, arguments);
	        }
	
	        return false;
	    }
	
	    function installGlobalHandler() {
	        if (_onErrorHandlerInstalled) {
	            return;
	        }
	        _oldOnerrorHandler = _window.onerror;
	        _window.onerror = traceKitWindowOnError;
	        _onErrorHandlerInstalled = true;
	    }
	
	    function uninstallGlobalHandler() {
	        if (!_onErrorHandlerInstalled) {
	            return;
	        }
	        _window.onerror = _oldOnerrorHandler;
	        _onErrorHandlerInstalled = false;
	        _oldOnerrorHandler = undefined;
	    }
	
	    function processLastException() {
	        var _lastExceptionStack = lastExceptionStack,
	            _lastArgs = lastArgs;
	        lastArgs = null;
	        lastExceptionStack = null;
	        lastException = null;
	        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	    }
	
	    /**
	     * Reports an unhandled Error to TraceKit.
	     * @param {Error} ex
	     * @param {?boolean} rethrow If false, do not re-throw the exception.
	     * Only used for window.onerror to not cause an infinite loop of
	     * rethrowing.
	     */
	    function report(ex, rethrow) {
	        var args = _slice.call(arguments, 1);
	        if (lastExceptionStack) {
	            if (lastException === ex) {
	                return; // already caught by an inner catch block, ignore
	            } else {
	                processLastException();
	            }
	        }
	
	        var stack = TraceKit.computeStackTrace(ex);
	        lastExceptionStack = stack;
	        lastException = ex;
	        lastArgs = args;
	
	        // If the stack trace is incomplete, wait for 2 seconds for
	        // slow slow IE to see if onerror occurs or not before reporting
	        // this exception; otherwise, we will end up with an incomplete
	        // stack trace
	        setTimeout(function () {
	            if (lastException === ex) {
	                processLastException();
	            }
	        }, stack.incomplete ? 2000 : 0);
	
	        if (rethrow !== false) {
	            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	        }
	    }
	
	    report.subscribe = subscribe;
	    report.unsubscribe = unsubscribe;
	    report.uninstall = unsubscribeAll;
	    return report;
	}();
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = function computeStackTraceWrapper() {
	    /**
	     * Escapes special characters, except for whitespace, in a string to be
	     * used inside a regular expression as a string literal.
	     * @param {string} text The string.
	     * @return {string} The escaped string literal.
	     */
	    function escapeRegExp(text) {
	        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
	    }
	
	    /**
	     * Escapes special characters in a string to be used inside a regular
	     * expression as a string literal. Also ensures that HTML entities will
	     * be matched the same as their literal friends.
	     * @param {string} body The string.
	     * @return {string} The escaped string.
	     */
	    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
	        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
	    }
	
	    // Contents of Exception in various browsers.
	    //
	    // SAFARI:
	    // ex.message = Can't find variable: qq
	    // ex.line = 59
	    // ex.sourceId = 580238192
	    // ex.sourceURL = http://...
	    // ex.expressionBeginOffset = 96
	    // ex.expressionCaretOffset = 98
	    // ex.expressionEndOffset = 98
	    // ex.name = ReferenceError
	    //
	    // FIREFOX:
	    // ex.message = qq is not defined
	    // ex.fileName = http://...
	    // ex.lineNumber = 59
	    // ex.columnNumber = 69
	    // ex.stack = ...stack trace... (see the example below)
	    // ex.name = ReferenceError
	    //
	    // CHROME:
	    // ex.message = qq is not defined
	    // ex.name = ReferenceError
	    // ex.type = not_defined
	    // ex.arguments = ['aa']
	    // ex.stack = ...stack trace...
	    //
	    // INTERNET EXPLORER:
	    // ex.message = ...
	    // ex.name = ReferenceError
	    //
	    // OPERA:
	    // ex.message = ...message... (see the example below)
	    // ex.name = ReferenceError
	    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	    /**
	     * Computes stack trace information from the stack property.
	     * Chrome and Gecko use this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStackProp(ex) {
	        if (typeof ex.stack === 'undefined' || !ex.stack) return;
	
	        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
	            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
	            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
	            lines = ex.stack.split('\n'),
	            stack = [],
	            parts,
	            element,
	            reference = /^(.*) is undefined$/.exec(ex.message);
	
	        for (var i = 0, j = lines.length; i < j; ++i) {
	            if (parts = chrome.exec(lines[i])) {
	                var isNative = parts[2] && parts[2].indexOf('native') !== -1;
	                element = {
	                    'url': !isNative ? parts[2] : null,
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': isNative ? [parts[2]] : [],
	                    'line': parts[3] ? +parts[3] : null,
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if (parts = winjs.exec(lines[i])) {
	                element = {
	                    'url': parts[2],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': [],
	                    'line': +parts[3],
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if (parts = gecko.exec(lines[i])) {
	                element = {
	                    'url': parts[3],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': parts[2] ? parts[2].split(',') : [],
	                    'line': parts[4] ? +parts[4] : null,
	                    'column': parts[5] ? +parts[5] : null
	                };
	            } else {
	                continue;
	            }
	
	            if (!element.func && element.line) {
	                element.func = UNKNOWN_FUNCTION;
	            }
	
	            stack.push(element);
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
	            // FireFox uses this awesome columnNumber property for its top frame
	            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	            // so adding 1
	            stack[0].column = ex.columnNumber + 1;
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	    }
	
	    /**
	     * Adds information about the first frame to incomplete stack traces.
	     * Safari and IE require this to get complete data on the first frame.
	     * @param {Object.<string, *>} stackInfo Stack trace information from
	     * one of the compute* methods.
	     * @param {string} url The URL of the script that caused an error.
	     * @param {(number|string)} lineNo The line number of the script that
	     * caused an error.
	     * @param {string=} message The error generated by the browser, which
	     * hopefully contains the name of the object that caused the error.
	     * @return {boolean} Whether or not the stack information was
	     * augmented.
	     */
	    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	        var initial = {
	            'url': url,
	            'line': lineNo
	        };
	
	        if (initial.url && initial.line) {
	            stackInfo.incomplete = false;
	
	            if (!initial.func) {
	                initial.func = UNKNOWN_FUNCTION;
	            }
	
	            if (stackInfo.stack.length > 0) {
	                if (stackInfo.stack[0].url === initial.url) {
	                    if (stackInfo.stack[0].line === initial.line) {
	                        return false; // already in stack trace
	                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
	                        stackInfo.stack[0].line = initial.line;
	                        return false;
	                    }
	                }
	            }
	
	            stackInfo.stack.unshift(initial);
	            stackInfo.partial = true;
	            return true;
	        } else {
	            stackInfo.incomplete = true;
	        }
	
	        return false;
	    }
	
	    /**
	     * Computes stack trace information by walking the arguments.caller
	     * chain at the time the exception occurred. This will cause earlier
	     * frames to be missed but is the only way to get any stack trace in
	     * Safari and IE. The top frame is restored by
	     * {@link augmentStackTraceWithInitialElement}.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceByWalkingCallerChain(ex, depth) {
	        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	            stack = [],
	            funcs = {},
	            recursion = false,
	            parts,
	            item,
	            source;
	
	        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
	            if (curr === computeStackTrace || curr === TraceKit.report) {
	                // console.log('skipping internal function');
	                continue;
	            }
	
	            item = {
	                'url': null,
	                'func': UNKNOWN_FUNCTION,
	                'line': null,
	                'column': null
	            };
	
	            if (curr.name) {
	                item.func = curr.name;
	            } else if (parts = functionName.exec(curr.toString())) {
	                item.func = parts[1];
	            }
	
	            if (typeof item.func === 'undefined') {
	                try {
	                    item.func = parts.input.substring(0, parts.input.indexOf('{'));
	                } catch (e) {}
	            }
	
	            if (funcs['' + curr]) {
	                recursion = true;
	            } else {
	                funcs['' + curr] = true;
	            }
	
	            stack.push(item);
	        }
	
	        if (depth) {
	            // console.log('depth is ' + depth);
	            // console.log('stack is ' + stack.length);
	            stack.splice(0, depth);
	        }
	
	        var result = {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
	        return result;
	    }
	
	    /**
	     * Computes a stack trace for an exception.
	     * @param {Error} ex
	     * @param {(string|number)=} depth
	     */
	    function computeStackTrace(ex, depth) {
	        var stack = null;
	        depth = depth == null ? 0 : +depth;
	
	        try {
	            stack = computeStackTraceFromStackProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref()
	        };
	    }
	
	    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	
	    return computeStackTrace;
	}();
	
	module.exports = TraceKit;
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint-disable no-param-reassign */
	
	
	exports.captureMessage = captureMessage;
	exports.captureException = captureException;
	
	var _TraceKit = __webpack_require__(5);
	
	var _TraceKit2 = _interopRequireDefault(_TraceKit);
	
	var _stackTraceFromError = __webpack_require__(18);
	
	var _stackTraceFromError2 = _interopRequireDefault(_stackTraceFromError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isScalar(value) {
	  return (/boolean|number|string/.test(typeof value === 'undefined' ? 'undefined' : _typeof(value))
	  );
	}
	
	function scrub(data, options) {
	  if (options) {
	    var optionalScalars = [
	    // Valid values for 'level' are 'fatal', 'error', 'warning', 'info',
	    // and 'debug'. Defaults to 'error'.
	    'level', 'logger'];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = optionalScalars[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var field = _step.value;
	
	        var value = options[field];
	
	        if (isScalar(value)) {
	          data[field] = value.toString();
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    var optionalMaps = ['tags', 'extra'];
	    var _iteratorNormalCompletion2 = true;
	    var _didIteratorError2 = false;
	    var _iteratorError2 = undefined;
	
	    try {
	      for (var _iterator2 = optionalMaps[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	        var _field = _step2.value;
	
	        var dirty = options[_field] || {};
	        var scrubbed = {};
	
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = Object.keys(dirty)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var key = _step3.value;
	
	            var _value = dirty[key];
	
	            if (isScalar(_value)) {
	              scrubbed[key.toString()] = _value.toString();
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	
	        data[_field] = scrubbed;
	      }
	    } catch (err) {
	      _didIteratorError2 = true;
	      _iteratorError2 = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	          _iterator2.return();
	        }
	      } finally {
	        if (_didIteratorError2) {
	          throw _iteratorError2;
	        }
	      }
	    }
	  }
	}
	
	function captureMessage(logger, message) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var isConsole = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  var data = {
	    exceptionType: isConsole ? 'CONSOLE' : 'MESSAGE',
	    message: message,
	    browserHref: window.location.href
	  };
	
	  scrub(data, options);
	
	  logger.addEvent('lr.core.Exception', function () {
	    return data;
	  });
	}
	
	function captureException(logger, exception) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var preppedTrace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var trace = preppedTrace || _TraceKit2.default.computeStackTrace(exception);
	
	  var data = {
	    exceptionType: 'WINDOW',
	    errorType: trace.name,
	    message: trace.message,
	    browserHref: window.location.href
	  };
	
	  scrub(data, options);
	
	  var addEventOptions = {
	    _stackTrace: (0, _stackTraceFromError2.default)(trace)
	  };
	
	  logger.addEvent('lr.core.Exception', function () {
	    return data;
	  }, addEventOptions);
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
	Object.defineProperty(exports,"__esModule",{value:true});var dateNow=Date.now.bind(Date);var loadTime=dateNow();exports.default=typeof performance!=='undefined'&&performance.now?performance.now.bind(performance):function(){return dateNow()-loadTime;};module.exports=exports['default'];
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(9);
	
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _setup = __webpack_require__(10);
	
	var _setup2 = _interopRequireDefault(_setup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var instance = (0, _setup2.default)();
	
	exports.default = instance;
	module.exports = exports['default'];
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setup;
	
	var _makeLogRocket = __webpack_require__(11);
	
	var _makeLogRocket2 = _interopRequireDefault(_makeLogRocket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function setup() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var enterpriseServer = _ref.enterpriseServer,
	      opts = _objectWithoutProperties(_ref, ['enterpriseServer']);
	
	  var sdkServer = opts.sdkServer || enterpriseServer;
	  var ingestServer = opts.ingestServer || enterpriseServer;
	
	  var instance = (0, _makeLogRocket2.default)(function () {
	    var script = document.createElement('script');
	
	    if (ingestServer) {
	      if (typeof window.__SDKCONFIG__ === 'undefined') {
	        window.__SDKCONFIG__ = {};
	      }
	
	      window.__SDKCONFIG__.serverURL = ingestServer + '/i';
	      window.__SDKCONFIG__.statsURL = ingestServer + '/s';
	    }
	
	    if (sdkServer) {
	      script.src = sdkServer + '/logger.min.js';
	    } else if (window.__SDKCONFIG__ && window.__SDKCONFIG__.loggerURL) {
	      script.src = window.__SDKCONFIG__.loggerURL;
	    } else if (window._lrAsyncScript) {
	      script.src = window._lrAsyncScript;
	    } else {
	      script.src = undefined === 'staging' ? 'https://cdn-staging.logrocket.io/logger.min.js' : 'https://cdn.logrocket.io/logger.min.js';
	    }
	
	    script.async = true;
	    document.head.appendChild(script);
	    script.onload = function () {
	      instance.onLogger(new window._LRLogger({
	        sdkVersion: "0.6.21" // eslint-disable-line no-undef
	      }));
	    };
	    script.onerror = function () {
	      console.warn('LogRocket: script could not load. Check that you have a valid network connection.');
	      instance.uninstall();
	    };
	  });
	
	  return instance;
	}
	module.exports = exports['default'];
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = makeLogRocket;
	
	var _LogRocket = __webpack_require__(12);
	
	var _LogRocket2 = _interopRequireDefault(_LogRocket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var REACT_NATIVE_NOTICE = 'LogRocket does not yet support React Native.';
	var makeNoopPolyfill = function makeNoopPolyfill() {
	  return {
	    init: function init() {},
	    uninstall: function uninstall() {},
	    log: function log() {},
	    info: function info() {},
	    warn: function warn() {},
	    error: function error() {},
	    debug: function debug() {},
	    addEvent: function addEvent() {},
	    identify: function identify() {},
	    start: function start() {},
	
	
	    get threadID() {
	      return null;
	    },
	    get recordingID() {
	      return null;
	    },
	    get recordingURL() {
	      return null;
	    },
	
	    reduxEnhancer: function reduxEnhancer() {
	      return function (store) {
	        return function () {
	          return store.apply(undefined, arguments);
	        };
	      };
	    },
	    reduxMiddleware: function reduxMiddleware() {
	      return function () {
	        return function (next) {
	          return function (action) {
	            return next(action);
	          };
	        };
	      };
	    },
	    track: function track() {},
	    getSessionURL: function getSessionURL() {},
	    getVersion: function getVersion() {},
	    startNewSession: function startNewSession() {},
	    onLogger: function onLogger() {},
	    setClock: function setClock() {},
	    captureMessage: function captureMessage() {},
	    captureException: function captureException() {}
	  };
	};
	
	function makeLogRocket() {
	  var getLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
	
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    throw new Error(REACT_NATIVE_NOTICE);
	  }
	
	  if (typeof window !== 'undefined') {
	    if (window._disableLogRocket) {
	      return makeNoopPolyfill();
	    }
	
	    if (window.MutationObserver) {
	      // Save window globals that we rely on.
	      window._lrMutationObserver = window.MutationObserver;
	
	      var instance = new _LogRocket2.default();
	      getLogger(instance);
	      return instance;
	    }
	  }
	
	  return makeNoopPolyfill();
	}
	module.exports = exports['default'];
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MAX_QUEUE_SIZE = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _logrocketNetwork = __webpack_require__(13);
	
	var _logrocketNetwork2 = _interopRequireDefault(_logrocketNetwork);
	
	var _logrocketExceptions = __webpack_require__(3);
	
	var _logrocketConsole = __webpack_require__(19);
	
	var _logrocketConsole2 = _interopRequireDefault(_logrocketConsole);
	
	var _logrocketRedux = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var MAX_QUEUE_SIZE = exports.MAX_QUEUE_SIZE = 1000;
	
	var considerIngestServerOption = function considerIngestServerOption() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var ingestServer = _ref.ingestServer,
	      options = _objectWithoutProperties(_ref, ['ingestServer']);
	
	  if (ingestServer) {
	    return _extends({
	      serverURL: ingestServer + '/i',
	      statsURL: ingestServer + '/s'
	    }, options);
	  }
	
	  return options;
	};
	
	var LogRocket = function () {
	  function LogRocket() {
	    var _this = this;
	
	    _classCallCheck(this, LogRocket);
	
	    this._buffer = [];
	
	    // TODO: tests for these exposed methods.
	    ['log', 'info', 'warn', 'error', 'debug'].forEach(function (method) {
	      _this[method] = function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this.addEvent('lr.core.LogEvent', function () {
	          var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
	            _logrocketExceptions.Capture.captureMessage(_this, args[0], {}, true);
	          }
	
	          return {
	            logLevel: method.toUpperCase(),
	            args: args
	          };
	        }, { shouldCaptureStackTrace: true });
	      };
	    });
	    this._isInitialized = false;
	    this._installed = [];
	  }
	
	  _createClass(LogRocket, [{
	    key: 'addEvent',
	    value: function addEvent(type, getMessage) {
	      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var time = Date.now();
	      this._run(function (logger) {
	        logger.addEvent(type, getMessage, _extends({}, opts, {
	          timeOverride: time
	        }));
	      });
	    }
	  }, {
	    key: 'onLogger',
	    value: function onLogger(logger) {
	      this._logger = logger;
	
	      while (this._buffer.length > 0) {
	        var f = this._buffer.shift();
	        f(this._logger);
	      }
	    }
	  }, {
	    key: '_run',
	    value: function _run(f) {
	      if (this._isDisabled) {
	        return;
	      }
	
	      if (this._logger) {
	        f(this._logger);
	      } else {
	        if (this._buffer.length >= MAX_QUEUE_SIZE) {
	          this._isDisabled = true;
	          console.warn('LogRocket: script did not load. Check that you have a valid network connection.');
	          this.uninstall();
	          return;
	        }
	
	        this._buffer.push(f.bind(this));
	      }
	    }
	  }, {
	    key: 'init',
	    value: function init(appID, opts) {
	      if (!this._isInitialized) {
	        this._installed.push((0, _logrocketExceptions.registerExceptions)(this));
	        this._installed.push((0, _logrocketNetwork2.default)(this));
	        this._installed.push((0, _logrocketConsole2.default)(this));
	
	        this._isInitialized = true;
	
	        this._run(function (logger) {
	          logger.init(appID, considerIngestServerOption(opts));
	        });
	      }
	    }
	  }, {
	    key: 'start',
	    value: function start() {
	      this._run(function (logger) {
	        logger.start();
	      });
	    }
	  }, {
	    key: 'uninstall',
	    value: function uninstall() {
	      this._installed.forEach(function (f) {
	        return f();
	      });
	      this._buffer = [];
	
	      this._run(function (logger) {
	        logger.uninstall();
	      });
	    }
	  }, {
	    key: 'identify',
	    value: function identify(id, opts) {
	      this._run(function (logger) {
	        logger.identify(id, opts);
	      });
	    }
	  }, {
	    key: 'startNewSession',
	    value: function startNewSession() {
	      this._run(function (logger) {
	        logger.startNewSession();
	      });
	    }
	  }, {
	    key: 'track',
	    value: function track(customEventName) {
	      this._run(function (logger) {
	        logger.track(customEventName);
	      });
	    }
	  }, {
	    key: 'getSessionURL',
	    value: function getSessionURL(cb) {
	      if (typeof cb !== 'function') {
	        throw new Error('LogRocket: must pass callback to getSessionURL()');
	      }
	
	      this._run(function (logger) {
	        if (logger.getSessionURL) {
	          logger.getSessionURL(cb);
	        } else {
	          cb(logger.recordingURL);
	        }
	      });
	    }
	  }, {
	    key: 'getVersion',
	    value: function getVersion(cb) {
	      this._run(function (logger) {
	        cb(logger.version);
	      });
	    }
	  }, {
	    key: 'startTransaction',
	    value: function startTransaction(transactionID) {
	      this.addEvent('lr.transaction.Start', function () {
	        return { id: transactionID };
	      });
	    }
	  }, {
	    key: 'endTransaction',
	    value: function endTransaction(transactionID) {
	      this.addEvent('lr.transaction.End', function () {
	        return { id: transactionID };
	      });
	    }
	  }, {
	    key: 'captureMessage',
	    value: function captureMessage(message) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _logrocketExceptions.Capture.captureMessage(this, message, options);
	    }
	  }, {
	    key: 'captureException',
	    value: function captureException(exception) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      _logrocketExceptions.Capture.captureException(this, exception, options);
	    }
	  }, {
	    key: 'reduxEnhancer',
	    value: function reduxEnhancer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return (0, _logrocketRedux.createEnhancer)(this, options);
	    }
	  }, {
	    key: 'reduxMiddleware',
	    value: function reduxMiddleware() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      return (0, _logrocketRedux.createMiddleware)(this, options);
	    }
	  }, {
	    key: 'version',
	    get: function get() {
	      return this._logger && this._logger.version;
	    }
	  }, {
	    key: 'sessionURL',
	    get: function get() {
	      return this._logger && this._logger.recordingURL;
	    }
	  }, {
	    key: 'recordingURL',
	    get: function get() {
	      return this._logger && this._logger.recordingURL;
	    }
	  }, {
	    key: 'recordingID',
	    get: function get() {
	      return this._logger && this._logger.recordingID;
	    }
	  }, {
	    key: 'threadID',
	    get: function get() {
	      return this._logger && this._logger.threadID;
	    }
	  }, {
	    key: 'tabID',
	    get: function get() {
	      return this._logger && this._logger.tabID;
	    }
	  }]);
	
	  return LogRocket;
	}();
	
	exports.default = LogRocket;
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	// import registerWebSocket from './registerWebSocket';
	
	
	exports.default = registerNetwork;
	
	var _registerFetch = __webpack_require__(14);
	
	var _registerFetch2 = _interopRequireDefault(_registerFetch);
	
	var _registerXHR = __webpack_require__(1);
	
	var _registerXHR2 = _interopRequireDefault(_registerXHR);
	
	var _mapValues = __webpack_require__(0);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registerNetwork(logger) {
	  var ignoredNetwork = {};
	
	  // truncate if > 4MB in size
	  var truncate = function truncate(data) {
	    var limit = 1024 * 1000 * 4;
	    var str = data;
	
	    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && data != null) {
	      var proto = Object.getPrototypeOf(data);
	
	      if (proto === Object.prototype || proto === null) {
	        // plain object - jsonify for the size check
	        str = JSON.stringify(data);
	      }
	    }
	
	    if (str && str.length && str.length > limit && typeof str === 'string') {
	      var beginning = str.substring(0, 1000);
	      return beginning + ' ... LogRocket truncating to first 1000 characters.\n      Keep data under 4MB to prevent truncation. https://docs.logrocket.com/reference#network';
	    }
	
	    return data;
	  };
	
	  var addRequest = function addRequest(reqId, request) {
	    var method = request.method;
	    logger.addEvent('lr.network.RequestEvent', function () {
	      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref$isEnabled = _ref.isEnabled,
	          isEnabled = _ref$isEnabled === undefined ? true : _ref$isEnabled,
	          _ref$requestSanitizer = _ref.requestSanitizer,
	          requestSanitizer = _ref$requestSanitizer === undefined ? function (f) {
	        return f;
	      } : _ref$requestSanitizer;
	
	      if (!isEnabled) {
	        return null;
	      }
	      var sanitized = null;
	      try {
	        // only try catch user defined functions
	        sanitized = requestSanitizer(request);
	      } catch (err) {
	        console.error(err);
	      }
	      if (sanitized) {
	        // Writing and then reading from an a tag turns a relative
	        // url into an absolute one.
	        var a = document.createElement('a');
	        a.href = sanitized.url;
	
	        return {
	          reqId: reqId, // default
	          url: a.href, // sanitized
	          headers: (0, _mapValues2.default)(sanitized.headers, function (headerValue) {
	            // sanitized
	            return '' + headerValue;
	          }),
	          body: truncate(sanitized.body), // sanitized
	          method: method, // default
	          referrer: sanitized.referrer || undefined, // sanitized
	          mode: sanitized.mode || undefined, // sanitized
	          credentials: sanitized.credentials || undefined // sanitized
	        };
	      }
	      ignoredNetwork[reqId] = true;
	      return null;
	    });
	  };
	
	  var addResponse = function addResponse(reqId, response) {
	    var method = response.method,
	        status = response.status;
	
	    logger.addEvent('lr.network.ResponseEvent', function () {
	      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          _ref2$isEnabled = _ref2.isEnabled,
	          isEnabled = _ref2$isEnabled === undefined ? true : _ref2$isEnabled,
	          _ref2$responseSanitiz = _ref2.responseSanitizer,
	          responseSanitizer = _ref2$responseSanitiz === undefined ? function (f) {
	        return f;
	      } : _ref2$responseSanitiz;
	
	      if (!isEnabled) {
	        return null;
	      } else if (ignoredNetwork[reqId]) {
	        delete ignoredNetwork[reqId];
	        return null;
	      }
	      var sanitized = null;
	
	      try {
	        // only try catch user defined functions
	        sanitized = responseSanitizer(response);
	      } catch (err) {
	        console.error(err);
	        // fall through to redacted log
	      }
	      if (sanitized) {
	        return {
	          reqId: reqId, // default
	          status: sanitized.status, // sanitized
	          headers: (0, _mapValues2.default)(sanitized.headers, function (headerValue) {
	            // sanitized
	            return '' + headerValue;
	          }),
	          body: truncate(sanitized.body), // sanitized
	          method: method // default
	        };
	      }
	      return {
	        reqId: reqId, // default
	        status: status, // default
	        headers: {}, // redacted
	        body: null, // redacted
	        method: method // default
	      };
	    });
	  };
	
	  var unsubFetch = (0, _registerFetch2.default)({ addRequest: addRequest, addResponse: addResponse });
	  var unsubXHR = (0, _registerXHR2.default)({ addRequest: addRequest, addResponse: addResponse });
	  // const unsubWebSocket = registerWebSocket(logger);
	
	  return function () {
	    unsubFetch();
	    unsubXHR();
	    // unsubWebSocket();
	  };
	}
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = registerFetch;
	
	var _mapValues = __webpack_require__(0);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _fetchIntercept = __webpack_require__(15);
	
	var _fetchIntercept2 = _interopRequireDefault(_fetchIntercept);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeObjectFromHeaders(headers) {
	  // If using real fetch, we must stringify the Headers object.
	  if (headers == null || typeof headers.forEach !== 'function') {
	    return headers;
	  }
	
	  var result = {};
	  headers.forEach(function (value, key) {
	    if (result[key]) {
	      result[key] = result[key] + ',' + value;
	    } else {
	      result[key] = '' + value;
	    }
	  });
	  return result;
	}
	
	// XHR specification is unclear of what types to allow in value so using toString method for now
	var stringifyHeaders = function stringifyHeaders(headers) {
	  return (0, _mapValues2.default)(makeObjectFromHeaders(headers), function (value) {
	    return '' + value;
	  });
	};
	
	function pluckFetchFields() {
	  var arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    url: arg.url,
	    headers: stringifyHeaders(arg.headers),
	    method: arg.method && arg.method.toUpperCase(),
	    referrer: arg.referrer || undefined,
	    mode: arg.mode || undefined,
	    credentials: arg.credentials || undefined
	  };
	}
	
	function registerFetch(_ref) {
	  var addRequest = _ref.addRequest,
	      addResponse = _ref.addResponse;
	
	  var LOGROCKET_XHR_LABEL = 'fetch-';
	  var fetchMethodMap = {};
	
	  var unregister = _fetchIntercept2.default.register({
	    request: function request(fetchId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var p = void 0;
	
	      if (typeof Request !== 'undefined' && args[0] instanceof Request) {
	        p = args[0].clone().text().then(function (body) {
	          return _extends({}, pluckFetchFields(args[0]), {
	            body: body
	          });
	        });
	      } else {
	        p = Promise.resolve(_extends({}, pluckFetchFields(args[1]), {
	          url: '' + args[0],
	          body: (args[1] || {}).body
	        }));
	      }
	
	      return p.then(function (req) {
	        fetchMethodMap[fetchId] = req.method;
	        addRequest('' + LOGROCKET_XHR_LABEL + fetchId, req);
	        return args;
	      });
	    },
	    requestError: function requestError(fetchId, error) {
	      return Promise.reject(error);
	    },
	    response: function response(fetchId, _response) {
	      var clonedText = void 0;
	
	      try {
	        // TODO: enhance function on original response and future clones for:
	        // text(), json(), blob(), formdata(), arraybuffer()
	        clonedText = _response.clone().text();
	      } catch (err) {
	        // safari has a bug where cloning can fail
	        clonedText = Promise.resolve('LogRocket fetch error: ' + err.message);
	      }
	
	      return clonedText.then(function (data) {
	        var responseHash = {
	          url: _response.url,
	          status: _response.status,
	          headers: stringifyHeaders(_response.headers),
	          body: data,
	          method: fetchMethodMap[fetchId]
	        };
	        delete fetchMethodMap[fetchId];
	        addResponse('' + LOGROCKET_XHR_LABEL + fetchId, responseHash);
	        return _response;
	      });
	    },
	    responseError: function responseError(fetchId, error) {
	      var response = {
	        url: undefined,
	        status: 0,
	        headers: {},
	        body: '' + error
	      };
	      addResponse('' + LOGROCKET_XHR_LABEL + fetchId, response);
	      return Promise.reject(error);
	    }
	  });
	
	  return unregister;
	}
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _registerXHR = __webpack_require__(1);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var interceptors = [];
	
	function makeInterceptor(fetch, fetchId) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var reversedInterceptors = interceptors.reduce(function (array, interceptor) {
	    return [interceptor].concat(array);
	  }, []);
	  var promise = Promise.resolve(args);
	
	  // Register request interceptors
	  reversedInterceptors.forEach(function (_ref) {
	    var request = _ref.request,
	        requestError = _ref.requestError;
	
	    if (request || requestError) {
	      promise = promise.then(function (args) {
	        return request.apply(undefined, [fetchId].concat(_toConsumableArray(args)));
	      }, function (args) {
	        return requestError.apply(undefined, [fetchId].concat(_toConsumableArray(args)));
	      });
	    }
	  });
	
	  promise = promise.then(function (args) {
	    (0, _registerXHR.setActive)(false);
	
	    var res = void 0;
	    var err = void 0;
	    try {
	      res = fetch.apply(undefined, _toConsumableArray(args));
	    } catch (_err) {
	      err = _err;
	    }
	
	    (0, _registerXHR.setActive)(true);
	
	    if (err) {
	      throw err;
	    }
	    return res;
	  });
	
	  reversedInterceptors.forEach(function (_ref2) {
	    var response = _ref2.response,
	        responseError = _ref2.responseError;
	
	    if (response || responseError) {
	      promise = promise.then(function (res) {
	        return response(fetchId, res);
	      }, function (err) {
	        return responseError && responseError(fetchId, err);
	      });
	    }
	  });
	
	  return promise;
	}
	
	function attach(env) {
	  if (!env.fetch || !env.Promise) {
	    // Make sure fetch is avaibale in the given environment. If it's not, then
	    // default to using XHR intercept.
	    return;
	  }
	
	  var isPolyfill = env.fetch.polyfill;
	
	  // eslint-disable-next-line no-param-reassign
	  env.fetch = function (fetch) {
	    var fetchId = 0;
	
	    return function () {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return makeInterceptor.apply(undefined, [fetch, fetchId++].concat(args));
	    };
	  }(env.fetch);
	
	  // Forward the polyfill propery from fetch (set by github/whatwg-fetch).
	  if (isPolyfill) {
	    // eslint-disable-next-line no-param-reassign
	    env.fetch.polyfill = isPolyfill;
	  }
	}
	
	// TODO: React Native
	//   attach(global);
	
	var didAttach = false;
	
	exports.default = {
	  register: function register(interceptor) {
	    if (!didAttach) {
	      didAttach = true;
	      attach(window);
	    }
	
	    interceptors.push(interceptor);
	    return function () {
	      var index = interceptors.indexOf(interceptor);
	
	      if (index >= 0) {
	        interceptors.splice(index, 1);
	      }
	    };
	  },
	  clear: function clear() {
	    interceptors = [];
	  }
	};
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = registerCore;
	
	var _raven = __webpack_require__(17);
	
	var _raven2 = _interopRequireDefault(_raven);
	
	var _Capture = __webpack_require__(6);
	
	var Capture = _interopRequireWildcard(_Capture);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registerCore(logger) {
	  var raven = new _raven2.default({
	    captureException: function captureException(errorReport) {
	      Capture.captureException(logger, null, null, errorReport);
	    }
	  });
	
	  var rejectionHandler = function rejectionHandler(evt) {
	    // http://2ality.com/2016/04/unhandled-rejections.html
	    logger.addEvent('lr.core.Exception', function () {
	      return {
	        exceptionType: 'UNHANDLED_REJECTION',
	        message: evt.reason || 'Unhandled Promise rejection'
	      };
	    });
	  };
	
	  window.addEventListener('unhandledrejection', rejectionHandler);
	
	  return function () {
	    window.removeEventListener('unhandledrejection', rejectionHandler);
	    raven.uninstall();
	  };
	}
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	/* WEBPACK VAR INJECTION */(function(global) {
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable */
	
	var _TraceKit = __webpack_require__(5);
	
	var _TraceKit2 = _interopRequireDefault(_TraceKit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var objectPrototype = Object.prototype;
	
	function isUndefined(what) {
	  return what === void 0;
	}
	
	function isFunction(what) {
	  return typeof what === 'function';
	}
	
	function each(obj, callback) {
	  var i, j;
	
	  if (isUndefined(obj.length)) {
	    for (i in obj) {
	      if (hasKey(obj, i)) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  } else {
	    j = obj.length;
	    if (j) {
	      for (i = 0; i < j; i++) {
	        callback.call(null, i, obj[i]);
	      }
	    }
	  }
	}
	
	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	  return objectPrototype.hasOwnProperty.call(object, key);
	}
	
	/**
	 * Polyfill a method
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	  var orig = obj[name];
	  obj[name] = replacement(orig);
	  if (track) {
	    track.push([obj, name, orig]);
	  }
	}
	
	var _window = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	var _document = _window.document;
	
	var Handler = function () {
	  function Handler(_ref) {
	    var captureException = _ref.captureException;
	
	    _classCallCheck(this, Handler);
	
	    this._errorHandler = this._errorHandler.bind(this);
	
	    this._ignoreOnError = 0;
	    this._wrappedBuiltIns = [];
	    this.captureException = captureException;
	    _TraceKit2.default.report.subscribe(this._errorHandler);
	    this._instrumentTryCatch();
	  }
	
	  _createClass(Handler, [{
	    key: 'uninstall',
	    value: function uninstall() {
	      _TraceKit2.default.report.unsubscribe(this._errorHandler);
	
	      // restore any wrapped builtins
	      var builtin;
	      while (this._wrappedBuiltIns.length) {
	        builtin = this._wrappedBuiltIns.shift();
	
	        var obj = builtin[0],
	            name = builtin[1],
	            orig = builtin[2];
	
	        obj[name] = orig;
	      }
	    }
	  }, {
	    key: '_errorHandler',
	    value: function _errorHandler(report) {
	      if (!this._ignoreOnError) {
	        this.captureException(report);
	      }
	    }
	  }, {
	    key: '_ignoreNextOnError',
	    value: function _ignoreNextOnError() {
	      var _this = this;
	
	      this._ignoreOnError += 1;
	      setTimeout(function () {
	        // onerror should trigger before setTimeout
	        _this._ignoreOnError -= 1;
	      });
	    }
	
	    /*
	     * Wrap code within a context so Handler can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	
	  }, {
	    key: 'context',
	    value: function context(options, func, args) {
	      if (isFunction(options)) {
	        args = func || [];
	        func = options;
	        options = undefined;
	      }
	
	      return this.wrap(options, func).apply(this, args);
	    }
	  }, {
	    key: 'wrap',
	
	
	    /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @param {function} func A function to call before the try/catch wrapper [optional, private]
	     * @return {function} The newly wrapped functions with a context
	     */
	    value: function wrap(options, func, _before) {
	      var self = this;
	      // 1 argument has been passed, and it's not a function
	      // so just return it
	      if (isUndefined(func) && !isFunction(options)) {
	        return options;
	      }
	
	      // options is optional
	      if (isFunction(options)) {
	        func = options;
	        options = undefined;
	      }
	
	      // At this point, we've passed along 2 arguments, and the second one
	      // is not a function either, so we'll just return the second argument.
	      if (!isFunction(func)) {
	        return func;
	      }
	
	      // We don't wanna wrap it twice!
	      try {
	        if (func.__lr__) {
	          return func;
	        }
	
	        // If this has already been wrapped in the past, return that
	        if (func.__lr_wrapper__) {
	          return func.__lr_wrapper__;
	        }
	      } catch (e) {
	        // Just accessing custom props in some Selenium environments
	        // can cause a "Permission denied" exception (see lr-js#495).
	        // Bail on wrapping and return the function as-is (defers to window.onerror).
	        return func;
	      }
	
	      function wrapped() {
	        var args = [],
	            i = arguments.length,
	            deep = !options || options && options.deep !== false;
	
	        if (_before && isFunction(_before)) {
	          _before.apply(this, arguments);
	        }
	
	        // Recursively wrap all of a function's arguments that are
	        // functions themselves.
	        while (i--) {
	          args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
	        }try {
	          // Attempt to invoke user-land function. This is part of the LogRocket SDK.
	          // If you're seeing this frame in a stack trace, it means that LogRocket caught
	          // an unhandled error thrown by your application code, reported it, then bubbled
	          // it up. This is expected behavior and is not a bug with LogRocket.
	          return func.apply(this, args);
	        } catch (e) {
	          self._ignoreNextOnError();
	          self.captureException(_TraceKit2.default.computeStackTrace(e), options);
	          throw e;
	        }
	      }
	
	      // copy over properties of the old function
	      for (var property in func) {
	        if (hasKey(func, property)) {
	          wrapped[property] = func[property];
	        }
	      }
	      wrapped.prototype = func.prototype;
	
	      func.__lr_wrapper__ = wrapped;
	      // Signal that this function has been wrapped already
	      // for both debugging and to prevent it to being wrapped twice
	      wrapped.__lr__ = true;
	      wrapped.__inner__ = func;
	
	      return wrapped;
	    }
	  }, {
	    key: '_instrumentTryCatch',
	
	
	    /**
	     * Install any queued plugins
	     */
	    value: function _instrumentTryCatch() {
	      var self = this;
	
	      var wrappedBuiltIns = self._wrappedBuiltIns;
	
	      function wrapTimeFn(orig) {
	        return function (fn, t) {
	          // preserve arity
	          // Make a copy of the arguments to prevent deoptimization
	          // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	          var args = new Array(arguments.length);
	          for (var i = 0; i < args.length; ++i) {
	            args[i] = arguments[i];
	          }
	          var originalCallback = args[0];
	          if (isFunction(originalCallback)) {
	            args[0] = self.wrap(originalCallback);
	          }
	
	          // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	          // also supports only two arguments and doesn't care what this is, so we
	          // can just call the original function directly.
	          if (orig.apply) {
	            return orig.apply(this, args);
	          } else {
	            return orig(args[0], args[1]);
	          }
	        };
	      }
	
	      function wrapEventTarget(global) {
	        var proto = _window[global] && _window[global].prototype;
	        if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
	          fill(proto, 'addEventListener', function (orig) {
	            return function (evtName, fn, capture, secure) {
	              // preserve arity
	              try {
	                if (fn && fn.handleEvent) {
	                  fn.handleEvent = self.wrap(fn.handleEvent);
	                }
	              } catch (err) {}
	              // can sometimes get 'Permission denied to access property "handle Event'
	
	
	              // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
	              // so that we don't have more than one wrapper function
	              var before;
	
	              return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
	            };
	          }, wrappedBuiltIns);
	          fill(proto, 'removeEventListener', function (orig) {
	            return function (evt, fn, capture, secure) {
	              try {
	                fn = fn && (fn.__lr_wrapper__ ? fn.__lr_wrapper__ : fn);
	              } catch (e) {
	                // ignore, accessing __lr_wrapper__ will throw in some Selenium environments
	              }
	              return orig.call(this, evt, fn, capture, secure);
	            };
	          }, wrappedBuiltIns);
	        }
	      }
	
	      fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
	      fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
	      if (_window.requestAnimationFrame) {
	        fill(_window, 'requestAnimationFrame', function (orig) {
	          return function (cb) {
	            return orig(self.wrap(cb));
	          };
	        }, wrappedBuiltIns);
	      }
	
	      // event targets borrowed from bugsnag-js:
	      // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
	      var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
	      for (var i = 0; i < eventTargets.length; i++) {
	        wrapEventTarget(eventTargets[i]);
	      }
	
	      var $ = _window.jQuery || _window.$;
	      if ($ && $.fn && $.fn.ready) {
	        fill($.fn, 'ready', function (orig) {
	          return function (fn) {
	            return orig.call(this, self.wrap(fn));
	          };
	        }, wrappedBuiltIns);
	      }
	    }
	  }]);
	
	  return Handler;
	}();
	
	exports.default = Handler;
	;
	/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(4)))
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = stackTraceFromError;
	function stackTraceFromError(errorReport) {
	  function makeNotNull(val) {
	    return val === null ? undefined : val;
	  }
	
	  return errorReport.stack ? errorReport.stack.map(function (frame) {
	    return {
	      lineNumber: makeNotNull(frame.line),
	      columnNumber: makeNotNull(frame.column),
	      fileName: makeNotNull(frame.url),
	      functionName: makeNotNull(frame.func)
	    };
	  }) : undefined;
	}
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _registerConsole = __webpack_require__(20);
	
	var _registerConsole2 = _interopRequireDefault(_registerConsole);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _registerConsole2.default;
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = registerConsole;
	
	var _enhanceFunc = __webpack_require__(2);
	
	var _enhanceFunc2 = _interopRequireDefault(_enhanceFunc);
	
	var _logrocketExceptions = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function registerConsole(logger) {
	  var unsubFunctions = [];
	  var methods = ['log', 'warn', 'info', 'error', 'debug'];
	
	  methods.forEach(function (method) {
	    unsubFunctions.push((0, _enhanceFunc2.default)(console, method, function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      logger.addEvent('lr.core.LogEvent', function () {
	        var consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        var isEnabled = consoleOptions.isEnabled;
	
	        if ((typeof isEnabled === 'undefined' ? 'undefined' : _typeof(isEnabled)) === 'object' && isEnabled[method] === false || isEnabled === false) {
	          return null;
	        }
	
	        if (method === 'error' && consoleOptions.shouldAggregateConsoleErrors) {
	          _logrocketExceptions.Capture.captureMessage(logger, args[0], {}, true);
	        }
	
	        return {
	          logLevel: method.toUpperCase(),
	          args: args
	        };
	      });
	    }));
	  });
	
	  return function () {
	    unsubFunctions.forEach(function (unsubFunction) {
	      return unsubFunction();
	    });
	  };
	}
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createEnhancer = exports.createMiddleware = undefined;
	
	var _createEnhancer = __webpack_require__(22);
	
	var _createEnhancer2 = _interopRequireDefault(_createEnhancer);
	
	var _createMiddleware = __webpack_require__(23);
	
	var _createMiddleware2 = _interopRequireDefault(_createMiddleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createMiddleware = _createMiddleware2.default;
	exports.createEnhancer = _createEnhancer2.default;
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createEnhancer;
	
	var _now = __webpack_require__(7);
	
	var _now2 = _interopRequireDefault(_now);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storeIdCounter = 0;
	
	function createEnhancer(logger) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$stateSanitizer = _ref.stateSanitizer,
	      stateSanitizer = _ref$stateSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$stateSanitizer,
	      _ref$actionSanitizer = _ref.actionSanitizer,
	      actionSanitizer = _ref$actionSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$actionSanitizer;
	
	  // an enhancer is a function that returns a Store
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var originalDispatch = store.dispatch;
	      var storeId = storeIdCounter++;
	      logger.addEvent('lr.redux.InitialState', function () {
	        var sanitizedState = void 0;
	        try {
	          // only try catch user defined functions
	          sanitizedState = stateSanitizer(store.getState());
	        } catch (err) {
	          console.error(err.toString());
	        }
	
	        return {
	          state: sanitizedState,
	          storeId: storeId
	        };
	      });
	
	      var dispatch = function dispatch(action) {
	        var start = (0, _now2.default)();
	
	        var err = void 0;
	        var res = void 0;
	        try {
	          res = originalDispatch(action);
	        } catch (_err) {
	          err = _err;
	        } finally {
	          var duration = (0, _now2.default)() - start;
	
	          logger.addEvent('lr.redux.ReduxAction', function () {
	            var sanitizedState = null;
	            var sanitizedAction = null;
	
	            try {
	              // only try catch user defined functions
	              sanitizedState = stateSanitizer(store.getState());
	              sanitizedAction = actionSanitizer(action);
	            } catch (err) {
	              console.error(err.toString());
	            }
	
	            if (sanitizedState && sanitizedAction) {
	              return {
	                storeId: storeId,
	                action: sanitizedAction,
	                duration: duration,
	                stateDelta: sanitizedState
	              };
	            }
	            return null;
	          });
	        }
	
	        if (err) {
	          throw err;
	        }
	
	        return res;
	      };
	
	      return _extends({}, store, {
	        dispatch: dispatch
	      });
	    };
	  };
	}
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMiddleware;
	
	var _now = __webpack_require__(7);
	
	var _now2 = _interopRequireDefault(_now);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storeIdCounter = 0;
	
	function createMiddleware(logger) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$stateSanitizer = _ref.stateSanitizer,
	      stateSanitizer = _ref$stateSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$stateSanitizer,
	      _ref$actionSanitizer = _ref.actionSanitizer,
	      actionSanitizer = _ref$actionSanitizer === undefined ? function (f) {
	    return f;
	  } : _ref$actionSanitizer;
	
	  return function (store) {
	    var storeId = storeIdCounter++;
	    logger.addEvent('lr.redux.InitialState', function () {
	      var sanitizedState = void 0;
	      try {
	        // only try catch user defined functions
	        sanitizedState = stateSanitizer(store.getState());
	      } catch (err) {
	        console.error(err.toString());
	      }
	
	      return {
	        state: sanitizedState,
	        storeId: storeId
	      };
	    });
	
	    return function (next) {
	      return function (action) {
	        var start = (0, _now2.default)();
	
	        var err = void 0;
	        var res = void 0;
	        try {
	          res = next(action);
	        } catch (_err) {
	          err = _err;
	        } finally {
	          var duration = (0, _now2.default)() - start;
	
	          logger.addEvent('lr.redux.ReduxAction', function () {
	            var sanitizedState = null;
	            var sanitizedAction = null;
	
	            try {
	              // only try catch user defined functions
	              sanitizedState = stateSanitizer(store.getState());
	              sanitizedAction = actionSanitizer(action);
	            } catch (err) {
	              console.error(err.toString());
	            }
	
	            if (sanitizedState && sanitizedAction) {
	              return {
	                storeId: storeId,
	                action: sanitizedAction,
	                duration: duration,
	                stateDelta: sanitizedState
	              };
	            }
	            return null;
	          });
	        }
	
	        if (err) {
	          throw err;
	        }
	
	        return res;
	      };
	    };
	  };
	}
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_1 = __webpack_require__(29);
	var utils_1 = __webpack_require__(94);
	var observerBatchingConfiguredSymbol = utils_1.getSymbol("observerBatching");
	function defaultNoopBatch(callback) {
	    callback();
	}
	exports.defaultNoopBatch = defaultNoopBatch;
	function observerBatching(reactionScheduler) {
	    if (!reactionScheduler) {
	        reactionScheduler = defaultNoopBatch;
	        if (false) {
	            console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native");
	        }
	    }
	    mobx_1.configure({ reactionScheduler: reactionScheduler });
	    utils_1.getGlobal()[observerBatchingConfiguredSymbol] = true;
	}
	exports.observerBatching = observerBatching;
	exports.isObserverBatched = function () { return !!utils_1.getGlobal()[observerBatchingConfiguredSymbol]; };


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __read = (this && this.__read) || function (o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	};
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_1 = __webpack_require__(29);
	var react_1 = __importDefault(__webpack_require__(2));
	var utils_1 = __webpack_require__(94);
	function useAsObservableSourceInternal(current, usedByLocalStore) {
	    var culprit = usedByLocalStore ? "useLocalStore" : "useAsObservableSource";
	    if (false) {
	        var _a = __read(react_1.default.useState(current), 1), initialSource = _a[0];
	        if ((initialSource !== undefined && current === undefined) ||
	            (initialSource === undefined && current !== undefined)) {
	            throw new Error("make sure you never pass `undefined` to " + culprit);
	        }
	    }
	    if (usedByLocalStore && current === undefined) {
	        return undefined;
	    }
	    if (false) {
	        throw new Error(culprit + " expects a plain object as " + (usedByLocalStore ? "second" : "first") + " argument");
	    }
	    var _b = __read(react_1.default.useState(function () { return mobx_1.observable(current, {}, { deep: false }); }), 1), res = _b[0];
	    if (false) {
	        throw new Error("the shape of objects passed to " + culprit + " should be stable");
	    }
	    mobx_1.runInAction(function () {
	        Object.assign(res, current);
	    });
	    return res;
	}
	exports.useAsObservableSourceInternal = useAsObservableSourceInternal;
	function useAsObservableSource(current) {
	    return useAsObservableSourceInternal(current, false);
	}
	exports.useAsObservableSource = useAsObservableSource;


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_1 = __importDefault(__webpack_require__(2));
	var insideRender = false;
	var forceUpdateQueue = [];
	function useQueuedForceUpdate(forceUpdate) {
	    return function () {
	        if (insideRender) {
	            forceUpdateQueue.push(forceUpdate);
	        }
	        else {
	            forceUpdate();
	        }
	    };
	}
	exports.useQueuedForceUpdate = useQueuedForceUpdate;
	function useQueuedForceUpdateBlock(callback) {
	    // start intercepting force-update calls
	    insideRender = true;
	    forceUpdateQueue = [];
	    try {
	        var result = callback();
	        // stop intercepting force-update
	        insideRender = false;
	        // store queue or nothing if it was empty to execute useLayoutEffect only when necessary
	        var queue_1 = forceUpdateQueue.length > 0 ? forceUpdateQueue : undefined;
	        // run force-update queue in useLayoutEffect
	        react_1.default.useLayoutEffect(function () {
	            if (queue_1) {
	                queue_1.forEach(function (x) { return x(); });
	            }
	        }, [queue_1]);
	        return result;
	    }
	    finally {
	        insideRender = false;
	    }
	}
	exports.useQueuedForceUpdateBlock = useQueuedForceUpdateBlock;


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                '_'
	            ),
	            standalone:
	                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                    '_'
	                ),
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 473 */
/***/ function(module, exports) {

	'use strict';
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(473);
	
	module.exports = function getPolyfill() {
		return typeof Object.is === 'function' ? Object.is : implementation;
	};


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(476);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1087);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 476 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 477 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	 * Quill Editor v1.3.7
	 * https://quilljs.com/
	 * Copyright (c) 2014, Jason Chen
	 * Copyright (c) 2013, salesforce.com
	 */
	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory();
		else if(typeof define === 'function' && define.amd)
			define([], factory);
		else if(typeof exports === 'object')
			exports["Quill"] = factory();
		else
			root["Quill"] = factory();
	})(typeof self !== 'undefined' ? self : this, function() {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 109);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var format_1 = __webpack_require__(18);
	var leaf_1 = __webpack_require__(19);
	var scroll_1 = __webpack_require__(45);
	var inline_1 = __webpack_require__(46);
	var block_1 = __webpack_require__(47);
	var embed_1 = __webpack_require__(48);
	var text_1 = __webpack_require__(49);
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var store_1 = __webpack_require__(31);
	var Registry = __webpack_require__(1);
	var Parchment = {
	    Scope: Registry.Scope,
	    create: Registry.create,
	    find: Registry.find,
	    query: Registry.query,
	    register: Registry.register,
	    Container: container_1.default,
	    Format: format_1.default,
	    Leaf: leaf_1.default,
	    Embed: embed_1.default,
	    Scroll: scroll_1.default,
	    Block: block_1.default,
	    Inline: inline_1.default,
	    Text: text_1.default,
	    Attributor: {
	        Attribute: attributor_1.default,
	        Class: class_1.default,
	        Style: style_1.default,
	        Store: store_1.default,
	    },
	};
	exports.default = Parchment;
	
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var ParchmentError = /** @class */ (function (_super) {
	    __extends(ParchmentError, _super);
	    function ParchmentError(message) {
	        var _this = this;
	        message = '[Parchment] ' + message;
	        _this = _super.call(this, message) || this;
	        _this.message = message;
	        _this.name = _this.constructor.name;
	        return _this;
	    }
	    return ParchmentError;
	}(Error));
	exports.ParchmentError = ParchmentError;
	var attributes = {};
	var classes = {};
	var tags = {};
	var types = {};
	exports.DATA_KEY = '__blot';
	var Scope;
	(function (Scope) {
	    Scope[Scope["TYPE"] = 3] = "TYPE";
	    Scope[Scope["LEVEL"] = 12] = "LEVEL";
	    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
	    Scope[Scope["BLOT"] = 14] = "BLOT";
	    Scope[Scope["INLINE"] = 7] = "INLINE";
	    Scope[Scope["BLOCK"] = 11] = "BLOCK";
	    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
	    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
	    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
	    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
	    Scope[Scope["ANY"] = 15] = "ANY";
	})(Scope = exports.Scope || (exports.Scope = {}));
	function create(input, value) {
	    var match = query(input);
	    if (match == null) {
	        throw new ParchmentError("Unable to create " + input + " blot");
	    }
	    var BlotClass = match;
	    var node = 
	    // @ts-ignore
	    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
	    return new BlotClass(node, value);
	}
	exports.create = create;
	function find(node, bubble) {
	    if (bubble === void 0) { bubble = false; }
	    if (node == null)
	        return null;
	    // @ts-ignore
	    if (node[exports.DATA_KEY] != null)
	        return node[exports.DATA_KEY].blot;
	    if (bubble)
	        return find(node.parentNode, bubble);
	    return null;
	}
	exports.find = find;
	function query(query, scope) {
	    if (scope === void 0) { scope = Scope.ANY; }
	    var match;
	    if (typeof query === 'string') {
	        match = types[query] || attributes[query];
	        // @ts-ignore
	    }
	    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
	        match = types['text'];
	    }
	    else if (typeof query === 'number') {
	        if (query & Scope.LEVEL & Scope.BLOCK) {
	            match = types['block'];
	        }
	        else if (query & Scope.LEVEL & Scope.INLINE) {
	            match = types['inline'];
	        }
	    }
	    else if (query instanceof HTMLElement) {
	        var names = (query.getAttribute('class') || '').split(/\s+/);
	        for (var i in names) {
	            match = classes[names[i]];
	            if (match)
	                break;
	        }
	        match = match || tags[query.tagName];
	    }
	    if (match == null)
	        return null;
	    // @ts-ignore
	    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
	        return match;
	    return null;
	}
	exports.query = query;
	function register() {
	    var Definitions = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        Definitions[_i] = arguments[_i];
	    }
	    if (Definitions.length > 1) {
	        return Definitions.map(function (d) {
	            return register(d);
	        });
	    }
	    var Definition = Definitions[0];
	    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
	        throw new ParchmentError('Invalid definition');
	    }
	    else if (Definition.blotName === 'abstract') {
	        throw new ParchmentError('Cannot register abstract class');
	    }
	    types[Definition.blotName || Definition.attrName] = Definition;
	    if (typeof Definition.keyName === 'string') {
	        attributes[Definition.keyName] = Definition;
	    }
	    else {
	        if (Definition.className != null) {
	            classes[Definition.className] = Definition;
	        }
	        if (Definition.tagName != null) {
	            if (Array.isArray(Definition.tagName)) {
	                Definition.tagName = Definition.tagName.map(function (tagName) {
	                    return tagName.toUpperCase();
	                });
	            }
	            else {
	                Definition.tagName = Definition.tagName.toUpperCase();
	            }
	            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
	            tagNames.forEach(function (tag) {
	                if (tags[tag] == null || Definition.className == null) {
	                    tags[tag] = Definition;
	                }
	            });
	        }
	    }
	    return Definition;
	}
	exports.register = register;
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var diff = __webpack_require__(51);
	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);
	var op = __webpack_require__(20);
	
	
	var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()
	
	
	var Delta = function (ops) {
	  // Assume we are given a well formed ops
	  if (Array.isArray(ops)) {
	    this.ops = ops;
	  } else if (ops != null && Array.isArray(ops.ops)) {
	    this.ops = ops.ops;
	  } else {
	    this.ops = [];
	  }
	};
	
	
	Delta.prototype.insert = function (text, attributes) {
	  var newOp = {};
	  if (text.length === 0) return this;
	  newOp.insert = text;
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};
	
	Delta.prototype['delete'] = function (length) {
	  if (length <= 0) return this;
	  return this.push({ 'delete': length });
	};
	
	Delta.prototype.retain = function (length, attributes) {
	  if (length <= 0) return this;
	  var newOp = { retain: length };
	  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
	    newOp.attributes = attributes;
	  }
	  return this.push(newOp);
	};
	
	Delta.prototype.push = function (newOp) {
	  var index = this.ops.length;
	  var lastOp = this.ops[index - 1];
	  newOp = extend(true, {}, newOp);
	  if (typeof lastOp === 'object') {
	    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
	      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
	      return this;
	    }
	    // Since it does not matter if we insert before or after deleting at the same index,
	    // always prefer to insert first
	    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
	      index -= 1;
	      lastOp = this.ops[index - 1];
	      if (typeof lastOp !== 'object') {
	        this.ops.unshift(newOp);
	        return this;
	      }
	    }
	    if (equal(newOp.attributes, lastOp.attributes)) {
	      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
	        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
	        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
	        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
	        return this;
	      }
	    }
	  }
	  if (index === this.ops.length) {
	    this.ops.push(newOp);
	  } else {
	    this.ops.splice(index, 0, newOp);
	  }
	  return this;
	};
	
	Delta.prototype.chop = function () {
	  var lastOp = this.ops[this.ops.length - 1];
	  if (lastOp && lastOp.retain && !lastOp.attributes) {
	    this.ops.pop();
	  }
	  return this;
	};
	
	Delta.prototype.filter = function (predicate) {
	  return this.ops.filter(predicate);
	};
	
	Delta.prototype.forEach = function (predicate) {
	  this.ops.forEach(predicate);
	};
	
	Delta.prototype.map = function (predicate) {
	  return this.ops.map(predicate);
	};
	
	Delta.prototype.partition = function (predicate) {
	  var passed = [], failed = [];
	  this.forEach(function(op) {
	    var target = predicate(op) ? passed : failed;
	    target.push(op);
	  });
	  return [passed, failed];
	};
	
	Delta.prototype.reduce = function (predicate, initial) {
	  return this.ops.reduce(predicate, initial);
	};
	
	Delta.prototype.changeLength = function () {
	  return this.reduce(function (length, elem) {
	    if (elem.insert) {
	      return length + op.length(elem);
	    } else if (elem.delete) {
	      return length - elem.delete;
	    }
	    return length;
	  }, 0);
	};
	
	Delta.prototype.length = function () {
	  return this.reduce(function (length, elem) {
	    return length + op.length(elem);
	  }, 0);
	};
	
	Delta.prototype.slice = function (start, end) {
	  start = start || 0;
	  if (typeof end !== 'number') end = Infinity;
	  var ops = [];
	  var iter = op.iterator(this.ops);
	  var index = 0;
	  while (index < end && iter.hasNext()) {
	    var nextOp;
	    if (index < start) {
	      nextOp = iter.next(start - index);
	    } else {
	      nextOp = iter.next(end - index);
	      ops.push(nextOp);
	    }
	    index += op.length(nextOp);
	  }
	  return new Delta(ops);
	};
	
	
	Delta.prototype.compose = function (other) {
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var ops = [];
	  var firstOther = otherIter.peek();
	  if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
	    var firstLeft = firstOther.retain;
	    while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
	      firstLeft -= thisIter.peekLength();
	      ops.push(thisIter.next());
	    }
	    if (firstOther.retain - firstLeft > 0) {
	      otherIter.next(firstOther.retain - firstLeft);
	    }
	  }
	  var delta = new Delta(ops);
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else if (thisIter.peekType() === 'delete') {
	      delta.push(thisIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (typeof otherOp.retain === 'number') {
	        var newOp = {};
	        if (typeof thisOp.retain === 'number') {
	          newOp.retain = length;
	        } else {
	          newOp.insert = thisOp.insert;
	        }
	        // Preserve null when composing with a retain, otherwise remove it for inserts
	        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
	        if (attributes) newOp.attributes = attributes;
	        delta.push(newOp);
	
	        // Optimization if rest of other is just retain
	        if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
	          var rest = new Delta(thisIter.rest());
	          return delta.concat(rest).chop();
	        }
	
	      // Other op should be delete, we could be an insert or retain
	      // Insert + delete cancels out
	      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
	        delta.push(otherOp);
	      }
	    }
	  }
	  return delta.chop();
	};
	
	Delta.prototype.concat = function (other) {
	  var delta = new Delta(this.ops.slice());
	  if (other.ops.length > 0) {
	    delta.push(other.ops[0]);
	    delta.ops = delta.ops.concat(other.ops.slice(1));
	  }
	  return delta;
	};
	
	Delta.prototype.diff = function (other, index) {
	  if (this.ops === other.ops) {
	    return new Delta();
	  }
	  var strings = [this, other].map(function (delta) {
	    return delta.map(function (op) {
	      if (op.insert != null) {
	        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
	      }
	      var prep = (delta === other) ? 'on' : 'with';
	      throw new Error('diff() called ' + prep + ' non-document');
	    }).join('');
	  });
	  var delta = new Delta();
	  var diffResult = diff(strings[0], strings[1], index);
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  diffResult.forEach(function (component) {
	    var length = component[1].length;
	    while (length > 0) {
	      var opLength = 0;
	      switch (component[0]) {
	        case diff.INSERT:
	          opLength = Math.min(otherIter.peekLength(), length);
	          delta.push(otherIter.next(opLength));
	          break;
	        case diff.DELETE:
	          opLength = Math.min(length, thisIter.peekLength());
	          thisIter.next(opLength);
	          delta['delete'](opLength);
	          break;
	        case diff.EQUAL:
	          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
	          var thisOp = thisIter.next(opLength);
	          var otherOp = otherIter.next(opLength);
	          if (equal(thisOp.insert, otherOp.insert)) {
	            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
	          } else {
	            delta.push(otherOp)['delete'](opLength);
	          }
	          break;
	      }
	      length -= opLength;
	    }
	  });
	  return delta.chop();
	};
	
	Delta.prototype.eachLine = function (predicate, newline) {
	  newline = newline || '\n';
	  var iter = op.iterator(this.ops);
	  var line = new Delta();
	  var i = 0;
	  while (iter.hasNext()) {
	    if (iter.peekType() !== 'insert') return;
	    var thisOp = iter.peek();
	    var start = op.length(thisOp) - iter.peekLength();
	    var index = typeof thisOp.insert === 'string' ?
	      thisOp.insert.indexOf(newline, start) - start : -1;
	    if (index < 0) {
	      line.push(iter.next());
	    } else if (index > 0) {
	      line.push(iter.next(index));
	    } else {
	      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
	        return;
	      }
	      i += 1;
	      line = new Delta();
	    }
	  }
	  if (line.length() > 0) {
	    predicate(line, {}, i);
	  }
	};
	
	Delta.prototype.transform = function (other, priority) {
	  priority = !!priority;
	  if (typeof other === 'number') {
	    return this.transformPosition(other, priority);
	  }
	  var thisIter = op.iterator(this.ops);
	  var otherIter = op.iterator(other.ops);
	  var delta = new Delta();
	  while (thisIter.hasNext() || otherIter.hasNext()) {
	    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
	      delta.retain(op.length(thisIter.next()));
	    } else if (otherIter.peekType() === 'insert') {
	      delta.push(otherIter.next());
	    } else {
	      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
	      var thisOp = thisIter.next(length);
	      var otherOp = otherIter.next(length);
	      if (thisOp['delete']) {
	        // Our delete either makes their delete redundant or removes their retain
	        continue;
	      } else if (otherOp['delete']) {
	        delta.push(otherOp);
	      } else {
	        // We retain either their retain or insert
	        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
	      }
	    }
	  }
	  return delta.chop();
	};
	
	Delta.prototype.transformPosition = function (index, priority) {
	  priority = !!priority;
	  var thisIter = op.iterator(this.ops);
	  var offset = 0;
	  while (thisIter.hasNext() && offset <= index) {
	    var length = thisIter.peekLength();
	    var nextType = thisIter.peekType();
	    thisIter.next();
	    if (nextType === 'delete') {
	      index -= Math.min(length, index - offset);
	      continue;
	    } else if (nextType === 'insert' && (offset < index || !priority)) {
	      index += length;
	    }
	    offset += length;
	  }
	  return index;
	};
	
	
	module.exports = Delta;
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	'use strict';
	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var defineProperty = Object.defineProperty;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var isArray = function isArray(arr) {
		if (typeof Array.isArray === 'function') {
			return Array.isArray(arr);
		}
	
		return toStr.call(arr) === '[object Array]';
	};
	
	var isPlainObject = function isPlainObject(obj) {
		if (!obj || toStr.call(obj) !== '[object Object]') {
			return false;
		}
	
		var hasOwnConstructor = hasOwn.call(obj, 'constructor');
		var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
		// Not own constructor property must be Object
		if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
			return false;
		}
	
		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own.
		var key;
		for (key in obj) { /**/ }
	
		return typeof key === 'undefined' || hasOwn.call(obj, key);
	};
	
	// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
	var setProperty = function setProperty(target, options) {
		if (defineProperty && options.name === '__proto__') {
			defineProperty(target, options.name, {
				enumerable: true,
				configurable: true,
				value: options.newValue,
				writable: true
			});
		} else {
			target[options.name] = options.newValue;
		}
	};
	
	// Return undefined instead of __proto__ if '__proto__' is not an own property
	var getProperty = function getProperty(obj, name) {
		if (name === '__proto__') {
			if (!hasOwn.call(obj, name)) {
				return void 0;
			} else if (gOPD) {
				// In early versions of node, obj['__proto__'] is buggy when obj has
				// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
				return gOPD(obj, name).value;
			}
		}
	
		return obj[name];
	};
	
	module.exports = function extend() {
		var options, name, src, copy, copyIsArray, clone;
		var target = arguments[0];
		var i = 1;
		var length = arguments.length;
		var deep = false;
	
		// Handle a deep copy situation
		if (typeof target === 'boolean') {
			deep = target;
			target = arguments[1] || {};
			// skip the boolean and the target
			i = 2;
		}
		if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
			target = {};
		}
	
		for (; i < length; ++i) {
			options = arguments[i];
			// Only deal with non-null/undefined values
			if (options != null) {
				// Extend the base object
				for (name in options) {
					src = getProperty(target, name);
					copy = getProperty(options, name);
	
					// Prevent never-ending loop
					if (target !== copy) {
						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
							if (copyIsArray) {
								copyIsArray = false;
								clone = src && isArray(src) ? src : [];
							} else {
								clone = src && isPlainObject(src) ? src : {};
							}
	
							// Never move original objects, clone them
							setProperty(target, { name: name, newValue: extend(deep, clone, copy) });
	
						// Don't bring in undefined values
						} else if (typeof copy !== 'undefined') {
							setProperty(target, { name: name, newValue: copy });
						}
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NEWLINE_LENGTH = 1;
	
	var BlockEmbed = function (_Parchment$Embed) {
	  _inherits(BlockEmbed, _Parchment$Embed);
	
	  function BlockEmbed() {
	    _classCallCheck(this, BlockEmbed);
	
	    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
	  }
	
	  _createClass(BlockEmbed, [{
	    key: 'attach',
	    value: function attach() {
	      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
	      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
	    }
	  }, {
	    key: 'delta',
	    value: function delta() {
	      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
	      if (attribute != null) {
	        this.attributes.attribute(attribute, value);
	      }
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      this.format(name, value);
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (typeof value === 'string' && value.endsWith('\n')) {
	        var block = _parchment2.default.create(Block.blotName);
	        this.parent.insertBefore(block, index === 0 ? this : this.next);
	        block.insertAt(0, value.slice(0, -1));
	      } else {
	        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	    }
	  }]);
	
	  return BlockEmbed;
	}(_parchment2.default.Embed);
	
	BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
	// It is important for cursor behavior BlockEmbeds use tags that are block level elements
	
	
	var Block = function (_Parchment$Block) {
	  _inherits(Block, _Parchment$Block);
	
	  function Block(domNode) {
	    _classCallCheck(this, Block);
	
	    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));
	
	    _this2.cache = {};
	    return _this2;
	  }
	
	  _createClass(Block, [{
	    key: 'delta',
	    value: function delta() {
	      if (this.cache.delta == null) {
	        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
	          if (leaf.length() === 0) {
	            return delta;
	          } else {
	            return delta.insert(leaf.value(), bubbleFormats(leaf));
	          }
	        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
	      }
	      return this.cache.delta;
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
	      this.cache = {};
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length <= 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	        if (index + length === this.length()) {
	          this.format(name, value);
	        }
	      } else {
	        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
	      if (value.length === 0) return;
	      var lines = value.split('\n');
	      var text = lines.shift();
	      if (text.length > 0) {
	        if (index < this.length() - 1 || this.children.tail == null) {
	          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
	        } else {
	          this.children.tail.insertAt(this.children.tail.length(), text);
	        }
	        this.cache = {};
	      }
	      var block = this;
	      lines.reduce(function (index, line) {
	        block = block.split(index, true);
	        block.insertAt(0, line);
	        return line.length;
	      }, index + text.length);
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      var head = this.children.head;
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
	      if (head instanceof _break2.default) {
	        head.remove();
	      }
	      this.cache = {};
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      if (this.cache.length == null) {
	        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
	      }
	      return this.cache.length;
	    }
	  }, {
	    key: 'moveChildren',
	    value: function moveChildren(target, ref) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
	      this.cache = {};
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
	      this.cache = {};
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
	    }
	  }, {
	    key: 'removeChild',
	    value: function removeChild(child) {
	      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
	      this.cache = {};
	    }
	  }, {
	    key: 'split',
	    value: function split(index) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
	        var clone = this.clone();
	        if (index === 0) {
	          this.parent.insertBefore(clone, this);
	          return this;
	        } else {
	          this.parent.insertBefore(clone, this.next);
	          return clone;
	        }
	      } else {
	        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
	        this.cache = {};
	        return next;
	      }
	    }
	  }]);
	
	  return Block;
	}(_parchment2.default.Block);
	
	Block.blotName = 'block';
	Block.tagName = 'P';
	Block.defaultChild = 'break';
	Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];
	
	function bubbleFormats(blot) {
	  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (blot == null) return formats;
	  if (typeof blot.formats === 'function') {
	    formats = (0, _extend2.default)(formats, blot.formats());
	  }
	  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
	    return formats;
	  }
	  return bubbleFormats(blot.parent, formats);
	}
	
	exports.bubbleFormats = bubbleFormats;
	exports.BlockEmbed = BlockEmbed;
	exports.default = Block;
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.overload = exports.expandConfig = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(50);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _editor = __webpack_require__(14);
	
	var _editor2 = _interopRequireDefault(_editor);
	
	var _emitter3 = __webpack_require__(8);
	
	var _emitter4 = _interopRequireDefault(_emitter3);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _selection = __webpack_require__(15);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _theme = __webpack_require__(34);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var debug = (0, _logger2.default)('quill');
	
	var Quill = function () {
	  _createClass(Quill, null, [{
	    key: 'debug',
	    value: function debug(limit) {
	      if (limit === true) {
	        limit = 'log';
	      }
	      _logger2.default.level(limit);
	    }
	  }, {
	    key: 'find',
	    value: function find(node) {
	      return node.__quill || _parchment2.default.find(node);
	    }
	  }, {
	    key: 'import',
	    value: function _import(name) {
	      if (this.imports[name] == null) {
	        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
	      }
	      return this.imports[name];
	    }
	  }, {
	    key: 'register',
	    value: function register(path, target) {
	      var _this = this;
	
	      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      if (typeof path !== 'string') {
	        var name = path.attrName || path.blotName;
	        if (typeof name === 'string') {
	          // register(Blot | Attributor, overwrite)
	          this.register('formats/' + name, path, target);
	        } else {
	          Object.keys(path).forEach(function (key) {
	            _this.register(key, path[key], target);
	          });
	        }
	      } else {
	        if (this.imports[path] != null && !overwrite) {
	          debug.warn('Overwriting ' + path + ' with', target);
	        }
	        this.imports[path] = target;
	        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
	          _parchment2.default.register(target);
	        } else if (path.startsWith('modules') && typeof target.register === 'function') {
	          target.register();
	        }
	      }
	    }
	  }]);
	
	  function Quill(container) {
	    var _this2 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Quill);
	
	    this.options = expandConfig(container, options);
	    this.container = this.options.container;
	    if (this.container == null) {
	      return debug.error('Invalid Quill container', container);
	    }
	    if (this.options.debug) {
	      Quill.debug(this.options.debug);
	    }
	    var html = this.container.innerHTML.trim();
	    this.container.classList.add('ql-container');
	    this.container.innerHTML = '';
	    this.container.__quill = this;
	    this.root = this.addContainer('ql-editor');
	    this.root.classList.add('ql-blank');
	    this.root.setAttribute('data-gramm', false);
	    this.scrollingContainer = this.options.scrollingContainer || this.root;
	    this.emitter = new _emitter4.default();
	    this.scroll = _parchment2.default.create(this.root, {
	      emitter: this.emitter,
	      whitelist: this.options.formats
	    });
	    this.editor = new _editor2.default(this.scroll);
	    this.selection = new _selection2.default(this.scroll, this.emitter);
	    this.theme = new this.options.theme(this, this.options);
	    this.keyboard = this.theme.addModule('keyboard');
	    this.clipboard = this.theme.addModule('clipboard');
	    this.history = this.theme.addModule('history');
	    this.theme.init();
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
	      if (type === _emitter4.default.events.TEXT_CHANGE) {
	        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
	      var range = _this2.selection.lastRange;
	      var index = range && range.length === 0 ? range.index : undefined;
	      modify.call(_this2, function () {
	        return _this2.editor.update(null, mutations, index);
	      }, source);
	    });
	    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
	    this.setContents(contents);
	    this.history.clear();
	    if (this.options.placeholder) {
	      this.root.setAttribute('data-placeholder', this.options.placeholder);
	    }
	    if (this.options.readOnly) {
	      this.disable();
	    }
	  }
	
	  _createClass(Quill, [{
	    key: 'addContainer',
	    value: function addContainer(container) {
	      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      if (typeof container === 'string') {
	        var className = container;
	        container = document.createElement('div');
	        container.classList.add(className);
	      }
	      this.container.insertBefore(container, refNode);
	      return container;
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.selection.setRange(null);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length, source) {
	      var _this3 = this;
	
	      var _overload = overload(index, length, source);
	
	      var _overload2 = _slicedToArray(_overload, 4);
	
	      index = _overload2[0];
	      length = _overload2[1];
	      source = _overload2[3];
	
	      return modify.call(this, function () {
	        return _this3.editor.deleteText(index, length);
	      }, source, index, -1 * length);
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      this.enable(false);
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.scroll.enable(enabled);
	      this.container.classList.toggle('ql-disabled', !enabled);
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      var scrollTop = this.scrollingContainer.scrollTop;
	      this.selection.focus();
	      this.scrollingContainer.scrollTop = scrollTop;
	      this.scrollIntoView();
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      var _this4 = this;
	
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        var range = _this4.getSelection(true);
	        var change = new _quillDelta2.default();
	        if (range == null) {
	          return change;
	        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
	          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
	        } else if (range.length === 0) {
	          _this4.selection.format(name, value);
	          return change;
	        } else {
	          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
	        }
	        _this4.setSelection(range, _emitter4.default.sources.SILENT);
	        return change;
	      }, source);
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length, name, value, source) {
	      var _this5 = this;
	
	      var formats = void 0;
	
	      var _overload3 = overload(index, length, name, value, source);
	
	      var _overload4 = _slicedToArray(_overload3, 4);
	
	      index = _overload4[0];
	      length = _overload4[1];
	      formats = _overload4[2];
	      source = _overload4[3];
	
	      return modify.call(this, function () {
	        return _this5.editor.formatLine(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length, name, value, source) {
	      var _this6 = this;
	
	      var formats = void 0;
	
	      var _overload5 = overload(index, length, name, value, source);
	
	      var _overload6 = _slicedToArray(_overload5, 4);
	
	      index = _overload6[0];
	      length = _overload6[1];
	      formats = _overload6[2];
	      source = _overload6[3];
	
	      return modify.call(this, function () {
	        return _this6.editor.formatText(index, length, formats);
	      }, source, index, 0);
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var bounds = void 0;
	      if (typeof index === 'number') {
	        bounds = this.selection.getBounds(index, length);
	      } else {
	        bounds = this.selection.getBounds(index.index, index.length);
	      }
	      var containerBounds = this.container.getBoundingClientRect();
	      return {
	        bottom: bounds.bottom - containerBounds.top,
	        height: bounds.height,
	        left: bounds.left - containerBounds.left,
	        right: bounds.right - containerBounds.left,
	        top: bounds.top - containerBounds.top,
	        width: bounds.width
	      };
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
	
	      var _overload7 = overload(index, length);
	
	      var _overload8 = _slicedToArray(_overload7, 2);
	
	      index = _overload8[0];
	      length = _overload8[1];
	
	      return this.editor.getContents(index, length);
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (typeof index === 'number') {
	        return this.editor.getFormat(index, length);
	      } else {
	        return this.editor.getFormat(index.index, index.length);
	      }
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(blot) {
	      return blot.offset(this.scroll);
	    }
	  }, {
	    key: 'getLength',
	    value: function getLength() {
	      return this.scroll.length();
	    }
	  }, {
	    key: 'getLeaf',
	    value: function getLeaf(index) {
	      return this.scroll.leaf(index);
	    }
	  }, {
	    key: 'getLine',
	    value: function getLine(index) {
	      return this.scroll.line(index);
	    }
	  }, {
	    key: 'getLines',
	    value: function getLines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	
	      if (typeof index !== 'number') {
	        return this.scroll.lines(index.index, index.length);
	      } else {
	        return this.scroll.lines(index, length);
	      }
	    }
	  }, {
	    key: 'getModule',
	    value: function getModule(name) {
	      return this.theme.modules[name];
	    }
	  }, {
	    key: 'getSelection',
	    value: function getSelection() {
	      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (focus) this.focus();
	      this.update(); // Make sure we access getRange with editor in consistent state
	      return this.selection.getRange()[0];
	    }
	  }, {
	    key: 'getText',
	    value: function getText() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;
	
	      var _overload9 = overload(index, length);
	
	      var _overload10 = _slicedToArray(_overload9, 2);
	
	      index = _overload10[0];
	      length = _overload10[1];
	
	      return this.editor.getText(index, length);
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return this.selection.hasFocus();
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      var _this7 = this;
	
	      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;
	
	      return modify.call(this, function () {
	        return _this7.editor.insertEmbed(index, embed, value);
	      }, source, index);
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text, name, value, source) {
	      var _this8 = this;
	
	      var formats = void 0;
	
	      var _overload11 = overload(index, 0, name, value, source);
	
	      var _overload12 = _slicedToArray(_overload11, 4);
	
	      index = _overload12[0];
	      formats = _overload12[2];
	      source = _overload12[3];
	
	      return modify.call(this, function () {
	        return _this8.editor.insertText(index, text, formats);
	      }, source, index, text.length);
	    }
	  }, {
	    key: 'isEnabled',
	    value: function isEnabled() {
	      return !this.container.classList.contains('ql-disabled');
	    }
	  }, {
	    key: 'off',
	    value: function off() {
	      return this.emitter.off.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'on',
	    value: function on() {
	      return this.emitter.on.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'once',
	    value: function once() {
	      return this.emitter.once.apply(this.emitter, arguments);
	    }
	  }, {
	    key: 'pasteHTML',
	    value: function pasteHTML(index, html, source) {
	      this.clipboard.dangerouslyPasteHTML(index, html, source);
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length, source) {
	      var _this9 = this;
	
	      var _overload13 = overload(index, length, source);
	
	      var _overload14 = _slicedToArray(_overload13, 4);
	
	      index = _overload14[0];
	      length = _overload14[1];
	      source = _overload14[3];
	
	      return modify.call(this, function () {
	        return _this9.editor.removeFormat(index, length);
	      }, source, index);
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView() {
	      this.selection.scrollIntoView(this.scrollingContainer);
	    }
	  }, {
	    key: 'setContents',
	    value: function setContents(delta) {
	      var _this10 = this;
	
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        var length = _this10.getLength();
	        var deleted = _this10.editor.deleteText(0, length);
	        var applied = _this10.editor.applyDelta(delta);
	        var lastOp = applied.ops[applied.ops.length - 1];
	        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
	          _this10.editor.deleteText(_this10.getLength() - 1, 1);
	          applied.delete(1);
	        }
	        var ret = deleted.compose(applied);
	        return ret;
	      }, source);
	    }
	  }, {
	    key: 'setSelection',
	    value: function setSelection(index, length, source) {
	      if (index == null) {
	        this.selection.setRange(null, length || Quill.sources.API);
	      } else {
	        var _overload15 = overload(index, length, source);
	
	        var _overload16 = _slicedToArray(_overload15, 4);
	
	        index = _overload16[0];
	        length = _overload16[1];
	        source = _overload16[3];
	
	        this.selection.setRange(new _selection.Range(index, length), source);
	        if (source !== _emitter4.default.sources.SILENT) {
	          this.selection.scrollIntoView(this.scrollingContainer);
	        }
	      }
	    }
	  }, {
	    key: 'setText',
	    value: function setText(text) {
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      var delta = new _quillDelta2.default().insert(text);
	      return this.setContents(delta, source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
	
	      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
	      this.selection.update(source);
	      return change;
	    }
	  }, {
	    key: 'updateContents',
	    value: function updateContents(delta) {
	      var _this11 = this;
	
	      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;
	
	      return modify.call(this, function () {
	        delta = new _quillDelta2.default(delta);
	        return _this11.editor.applyDelta(delta, source);
	      }, source, true);
	    }
	  }]);
	
	  return Quill;
	}();
	
	Quill.DEFAULTS = {
	  bounds: null,
	  formats: null,
	  modules: {},
	  placeholder: '',
	  readOnly: false,
	  scrollingContainer: null,
	  strict: true,
	  theme: 'default'
	};
	Quill.events = _emitter4.default.events;
	Quill.sources = _emitter4.default.sources;
	// eslint-disable-next-line no-undef
	Quill.version =  false ? 'dev' : "1.3.7";
	
	Quill.imports = {
	  'delta': _quillDelta2.default,
	  'parchment': _parchment2.default,
	  'core/module': _module2.default,
	  'core/theme': _theme2.default
	};
	
	function expandConfig(container, userConfig) {
	  userConfig = (0, _extend2.default)(true, {
	    container: container,
	    modules: {
	      clipboard: true,
	      keyboard: true,
	      history: true
	    }
	  }, userConfig);
	  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
	    userConfig.theme = _theme2.default;
	  } else {
	    userConfig.theme = Quill.import('themes/' + userConfig.theme);
	    if (userConfig.theme == null) {
	      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
	    }
	  }
	  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
	  [themeConfig, userConfig].forEach(function (config) {
	    config.modules = config.modules || {};
	    Object.keys(config.modules).forEach(function (module) {
	      if (config.modules[module] === true) {
	        config.modules[module] = {};
	      }
	    });
	  });
	  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
	  var moduleConfig = moduleNames.reduce(function (config, name) {
	    var moduleClass = Quill.import('modules/' + name);
	    if (moduleClass == null) {
	      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
	    } else {
	      config[name] = moduleClass.DEFAULTS || {};
	    }
	    return config;
	  }, {});
	  // Special case toolbar shorthand
	  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
	    userConfig.modules.toolbar = {
	      container: userConfig.modules.toolbar
	    };
	  }
	  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
	  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
	    if (typeof userConfig[key] === 'string') {
	      userConfig[key] = document.querySelector(userConfig[key]);
	    }
	  });
	  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
	    if (userConfig.modules[name]) {
	      config[name] = userConfig.modules[name];
	    }
	    return config;
	  }, {});
	  return userConfig;
	}
	
	// Handle selection preservation and TEXT_CHANGE emission
	// common to modification APIs
	function modify(modifier, source, index, shift) {
	  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
	    return new _quillDelta2.default();
	  }
	  var range = index == null ? null : this.getSelection();
	  var oldDelta = this.editor.delta;
	  var change = modifier();
	  if (range != null) {
	    if (index === true) index = range.index;
	    if (shift == null) {
	      range = shiftRange(range, change, source);
	    } else if (shift !== 0) {
	      range = shiftRange(range, index, shift, source);
	    }
	    this.setSelection(range, _emitter4.default.sources.SILENT);
	  }
	  if (change.length() > 0) {
	    var _emitter;
	
	    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
	    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	    if (source !== _emitter4.default.sources.SILENT) {
	      var _emitter2;
	
	      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	    }
	  }
	  return change;
	}
	
	function overload(index, length, name, value, source) {
	  var formats = {};
	  if (typeof index.index === 'number' && typeof index.length === 'number') {
	    // Allow for throwaway end (used by insertText/insertEmbed)
	    if (typeof length !== 'number') {
	      source = value, value = name, name = length, length = index.length, index = index.index;
	    } else {
	      length = index.length, index = index.index;
	    }
	  } else if (typeof length !== 'number') {
	    source = value, value = name, name = length, length = 0;
	  }
	  // Handle format being object, two format name/value strings or excluded
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    formats = name;
	    source = value;
	  } else if (typeof name === 'string') {
	    if (value != null) {
	      formats[name] = value;
	    } else {
	      source = name;
	    }
	  }
	  // Handle optional source
	  source = source || _emitter4.default.sources.API;
	  return [index, length, formats, source];
	}
	
	function shiftRange(range, index, length, source) {
	  if (range == null) return null;
	  var start = void 0,
	      end = void 0;
	  if (index instanceof _quillDelta2.default) {
	    var _map = [range.index, range.index + range.length].map(function (pos) {
	      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
	    });
	
	    var _map2 = _slicedToArray(_map, 2);
	
	    start = _map2[0];
	    end = _map2[1];
	  } else {
	    var _map3 = [range.index, range.index + range.length].map(function (pos) {
	      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
	      if (length >= 0) {
	        return pos + length;
	      } else {
	        return Math.max(index, pos + length);
	      }
	    });
	
	    var _map4 = _slicedToArray(_map3, 2);
	
	    start = _map4[0];
	    end = _map4[1];
	  }
	  return new _selection.Range(start, end - start);
	}
	
	exports.expandConfig = expandConfig;
	exports.overload = overload;
	exports.default = Quill;
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Inline = function (_Parchment$Inline) {
	  _inherits(Inline, _Parchment$Inline);
	
	  function Inline() {
	    _classCallCheck(this, Inline);
	
	    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
	  }
	
	  _createClass(Inline, [{
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
	        var blot = this.isolate(index, length);
	        if (value) {
	          blot.wrap(name, value);
	        }
	      } else {
	        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
	      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
	        var parent = this.parent.isolate(this.offset(), this.length());
	        this.moveChildren(parent);
	        parent.wrap(this);
	      }
	    }
	  }], [{
	    key: 'compare',
	    value: function compare(self, other) {
	      var selfIndex = Inline.order.indexOf(self);
	      var otherIndex = Inline.order.indexOf(other);
	      if (selfIndex >= 0 || otherIndex >= 0) {
	        return selfIndex - otherIndex;
	      } else if (self === other) {
	        return 0;
	      } else if (self < other) {
	        return -1;
	      } else {
	        return 1;
	      }
	    }
	  }]);
	
	  return Inline;
	}(_parchment2.default.Inline);
	
	Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
	// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
	Inline.order = ['cursor', 'inline', // Must be lower
	'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
	];
	
	exports.default = Inline;
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextBlot = function (_Parchment$Text) {
	  _inherits(TextBlot, _Parchment$Text);
	
	  function TextBlot() {
	    _classCallCheck(this, TextBlot);
	
	    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
	  }
	
	  return TextBlot;
	}(_parchment2.default.Text);
	
	exports.default = TextBlot;
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _eventemitter = __webpack_require__(54);
	
	var _eventemitter2 = _interopRequireDefault(_eventemitter);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:events');
	
	var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];
	
	EVENTS.forEach(function (eventName) {
	  document.addEventListener(eventName, function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
	      // TODO use WeakMap
	      if (node.__quill && node.__quill.emitter) {
	        var _node$__quill$emitter;
	
	        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
	      }
	    });
	  });
	});
	
	var Emitter = function (_EventEmitter) {
	  _inherits(Emitter, _EventEmitter);
	
	  function Emitter() {
	    _classCallCheck(this, Emitter);
	
	    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));
	
	    _this.listeners = {};
	    _this.on('error', debug.error);
	    return _this;
	  }
	
	  _createClass(Emitter, [{
	    key: 'emit',
	    value: function emit() {
	      debug.log.apply(debug, arguments);
	      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
	    }
	  }, {
	    key: 'handleDOM',
	    value: function handleDOM(event) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }
	
	      (this.listeners[event.type] || []).forEach(function (_ref) {
	        var node = _ref.node,
	            handler = _ref.handler;
	
	        if (event.target === node || node.contains(event.target)) {
	          handler.apply(undefined, [event].concat(args));
	        }
	      });
	    }
	  }, {
	    key: 'listenDOM',
	    value: function listenDOM(eventName, node, handler) {
	      if (!this.listeners[eventName]) {
	        this.listeners[eventName] = [];
	      }
	      this.listeners[eventName].push({ node: node, handler: handler });
	    }
	  }]);
	
	  return Emitter;
	}(_eventemitter2.default);
	
	Emitter.events = {
	  EDITOR_CHANGE: 'editor-change',
	  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
	  SCROLL_OPTIMIZE: 'scroll-optimize',
	  SCROLL_UPDATE: 'scroll-update',
	  SELECTION_CHANGE: 'selection-change',
	  TEXT_CHANGE: 'text-change'
	};
	Emitter.sources = {
	  API: 'api',
	  SILENT: 'silent',
	  USER: 'user'
	};
	
	exports.default = Emitter;
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Module = function Module(quill) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  _classCallCheck(this, Module);
	
	  this.quill = quill;
	  this.options = options;
	};
	
	Module.DEFAULTS = {};
	
	exports.default = Module;
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var levels = ['error', 'warn', 'log', 'info'];
	var level = 'warn';
	
	function debug(method) {
	  if (levels.indexOf(method) <= levels.indexOf(level)) {
	    var _console;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
	  }
	}
	
	function namespace(ns) {
	  return levels.reduce(function (logger, method) {
	    logger[method] = debug.bind(console, method, ns);
	    return logger;
	  }, {});
	}
	
	debug.level = namespace.level = function (newLevel) {
	  level = newLevel;
	};
	
	exports.default = namespace;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(52);
	var isArguments = __webpack_require__(53);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}
	
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var Attributor = /** @class */ (function () {
	    function Attributor(attrName, keyName, options) {
	        if (options === void 0) { options = {}; }
	        this.attrName = attrName;
	        this.keyName = keyName;
	        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
	        if (options.scope != null) {
	            // Ignore type bits, force attribute bit
	            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
	        }
	        else {
	            this.scope = Registry.Scope.ATTRIBUTE;
	        }
	        if (options.whitelist != null)
	            this.whitelist = options.whitelist;
	    }
	    Attributor.keys = function (node) {
	        return [].map.call(node.attributes, function (item) {
	            return item.name;
	        });
	    };
	    Attributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        node.setAttribute(this.keyName, value);
	        return true;
	    };
	    Attributor.prototype.canAdd = function (node, value) {
	        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
	        if (match == null)
	            return false;
	        if (this.whitelist == null)
	            return true;
	        if (typeof value === 'string') {
	            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
	        }
	        else {
	            return this.whitelist.indexOf(value) > -1;
	        }
	    };
	    Attributor.prototype.remove = function (node) {
	        node.removeAttribute(this.keyName);
	    };
	    Attributor.prototype.value = function (node) {
	        var value = node.getAttribute(this.keyName);
	        if (this.canAdd(node, value) && value) {
	            return value;
	        }
	        return '';
	    };
	    return Attributor;
	}());
	exports.default = Attributor;
	
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Code = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Code = function (_Inline) {
	  _inherits(Code, _Inline);
	
	  function Code() {
	    _classCallCheck(this, Code);
	
	    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
	  }
	
	  return Code;
	}(_inline2.default);
	
	Code.blotName = 'code';
	Code.tagName = 'CODE';
	
	var CodeBlock = function (_Block) {
	  _inherits(CodeBlock, _Block);
	
	  function CodeBlock() {
	    _classCallCheck(this, CodeBlock);
	
	    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
	  }
	
	  _createClass(CodeBlock, [{
	    key: 'delta',
	    value: function delta() {
	      var _this3 = this;
	
	      var text = this.domNode.textContent;
	      if (text.endsWith('\n')) {
	        // Should always be true
	        text = text.slice(0, -1);
	      }
	      return text.split('\n').reduce(function (delta, frag) {
	        return delta.insert(frag).insert('\n', _this3.formats());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (name === this.statics.blotName && value) return;
	
	      var _descendant = this.descendant(_text2.default, this.length() - 1),
	          _descendant2 = _slicedToArray(_descendant, 1),
	          text = _descendant2[0];
	
	      if (text != null) {
	        text.deleteAt(text.length() - 1, 1);
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, name, value) {
	      if (length === 0) return;
	      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
	        return;
	      }
	      var nextNewline = this.newlineIndex(index);
	      if (nextNewline < 0 || nextNewline >= index + length) return;
	      var prevNewline = this.newlineIndex(index, true) + 1;
	      var isolateLength = nextNewline - prevNewline + 1;
	      var blot = this.isolate(prevNewline, isolateLength);
	      var next = blot.next;
	      blot.format(name, value);
	      if (next instanceof CodeBlock) {
	        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
	      }
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null) return;
	
	      var _descendant3 = this.descendant(_text2.default, index),
	          _descendant4 = _slicedToArray(_descendant3, 2),
	          text = _descendant4[0],
	          offset = _descendant4[1];
	
	      text.insertAt(offset, value);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      var length = this.domNode.textContent.length;
	      if (!this.domNode.textContent.endsWith('\n')) {
	        return length + 1;
	      }
	      return length;
	    }
	  }, {
	    key: 'newlineIndex',
	    value: function newlineIndex(searchIndex) {
	      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!reverse) {
	        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
	        return offset > -1 ? searchIndex + offset : -1;
	      } else {
	        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      if (!this.domNode.textContent.endsWith('\n')) {
	        this.appendChild(_parchment2.default.create('text', '\n'));
	      }
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
	        next.optimize(context);
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
	      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
	        var blot = _parchment2.default.find(node);
	        if (blot == null) {
	          node.parentNode.removeChild(node);
	        } else if (blot instanceof _parchment2.default.Embed) {
	          blot.remove();
	        } else {
	          blot.unwrap();
	        }
	      });
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
	      domNode.setAttribute('spellcheck', false);
	      return domNode;
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);
	
	  return CodeBlock;
	}(_block2.default);
	
	CodeBlock.blotName = 'code-block';
	CodeBlock.tagName = 'PRE';
	CodeBlock.TAB = '  ';
	
	exports.Code = Code;
	exports.default = CodeBlock;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _op = __webpack_require__(20);
	
	var _op2 = _interopRequireDefault(_op);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _cursor = __webpack_require__(24);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ASCII = /^[ -~]*$/;
	
	var Editor = function () {
	  function Editor(scroll) {
	    _classCallCheck(this, Editor);
	
	    this.scroll = scroll;
	    this.delta = this.getDelta();
	  }
	
	  _createClass(Editor, [{
	    key: 'applyDelta',
	    value: function applyDelta(delta) {
	      var _this = this;
	
	      var consumeNextNewline = false;
	      this.scroll.update();
	      var scrollLength = this.scroll.length();
	      this.scroll.batchStart();
	      delta = normalizeDelta(delta);
	      delta.reduce(function (index, op) {
	        var length = op.retain || op.delete || op.insert.length || 1;
	        var attributes = op.attributes || {};
	        if (op.insert != null) {
	          if (typeof op.insert === 'string') {
	            var text = op.insert;
	            if (text.endsWith('\n') && consumeNextNewline) {
	              consumeNextNewline = false;
	              text = text.slice(0, -1);
	            }
	            if (index >= scrollLength && !text.endsWith('\n')) {
	              consumeNextNewline = true;
	            }
	            _this.scroll.insertAt(index, text);
	
	            var _scroll$line = _this.scroll.line(index),
	                _scroll$line2 = _slicedToArray(_scroll$line, 2),
	                line = _scroll$line2[0],
	                offset = _scroll$line2[1];
	
	            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
	            if (line instanceof _block2.default) {
	              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
	                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
	                  leaf = _line$descendant2[0];
	
	              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
	            }
	            attributes = _op2.default.attributes.diff(formats, attributes) || {};
	          } else if (_typeof(op.insert) === 'object') {
	            var key = Object.keys(op.insert)[0]; // There should only be one key
	            if (key == null) return index;
	            _this.scroll.insertAt(index, key, op.insert[key]);
	          }
	          scrollLength += length;
	        }
	        Object.keys(attributes).forEach(function (name) {
	          _this.scroll.formatAt(index, length, name, attributes[name]);
	        });
	        return index + length;
	      }, 0);
	      delta.reduce(function (index, op) {
	        if (typeof op.delete === 'number') {
	          _this.scroll.deleteAt(index, op.delete);
	          return index;
	        }
	        return index + (op.retain || op.insert.length || 1);
	      }, 0);
	      this.scroll.batchEnd();
	      return this.update(delta);
	    }
	  }, {
	    key: 'deleteText',
	    value: function deleteText(index, length) {
	      this.scroll.deleteAt(index, length);
	      return this.update(new _quillDelta2.default().retain(index).delete(length));
	    }
	  }, {
	    key: 'formatLine',
	    value: function formatLine(index, length) {
	      var _this2 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      this.scroll.update();
	      Object.keys(formats).forEach(function (format) {
	        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
	        var lines = _this2.scroll.lines(index, Math.max(length, 1));
	        var lengthRemaining = length;
	        lines.forEach(function (line) {
	          var lineLength = line.length();
	          if (!(line instanceof _code2.default)) {
	            line.format(format, formats[format]);
	          } else {
	            var codeIndex = index - line.offset(_this2.scroll);
	            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
	            line.formatAt(codeIndex, codeLength, format, formats[format]);
	          }
	          lengthRemaining -= lineLength;
	        });
	      });
	      this.scroll.optimize();
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'formatText',
	    value: function formatText(index, length) {
	      var _this3 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      Object.keys(formats).forEach(function (format) {
	        _this3.scroll.formatAt(index, length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'getContents',
	    value: function getContents(index, length) {
	      return this.delta.slice(index, index + length);
	    }
	  }, {
	    key: 'getDelta',
	    value: function getDelta() {
	      return this.scroll.lines().reduce(function (delta, line) {
	        return delta.concat(line.delta());
	      }, new _quillDelta2.default());
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var lines = [],
	          leaves = [];
	      if (length === 0) {
	        this.scroll.path(index).forEach(function (path) {
	          var _path = _slicedToArray(path, 1),
	              blot = _path[0];
	
	          if (blot instanceof _block2.default) {
	            lines.push(blot);
	          } else if (blot instanceof _parchment2.default.Leaf) {
	            leaves.push(blot);
	          }
	        });
	      } else {
	        lines = this.scroll.lines(index, length);
	        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
	      }
	      var formatsArr = [lines, leaves].map(function (blots) {
	        if (blots.length === 0) return {};
	        var formats = (0, _block.bubbleFormats)(blots.shift());
	        while (Object.keys(formats).length > 0) {
	          var blot = blots.shift();
	          if (blot == null) return formats;
	          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
	        }
	        return formats;
	      });
	      return _extend2.default.apply(_extend2.default, formatsArr);
	    }
	  }, {
	    key: 'getText',
	    value: function getText(index, length) {
	      return this.getContents(index, length).filter(function (op) {
	        return typeof op.insert === 'string';
	      }).map(function (op) {
	        return op.insert;
	      }).join('');
	    }
	  }, {
	    key: 'insertEmbed',
	    value: function insertEmbed(index, embed, value) {
	      this.scroll.insertAt(index, embed, value);
	      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
	    }
	  }, {
	    key: 'insertText',
	    value: function insertText(index, text) {
	      var _this4 = this;
	
	      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      this.scroll.insertAt(index, text);
	      Object.keys(formats).forEach(function (format) {
	        _this4.scroll.formatAt(index, text.length, format, formats[format]);
	      });
	      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
	    }
	  }, {
	    key: 'isBlank',
	    value: function isBlank() {
	      if (this.scroll.children.length == 0) return true;
	      if (this.scroll.children.length > 1) return false;
	      var block = this.scroll.children.head;
	      if (block.statics.blotName !== _block2.default.blotName) return false;
	      if (block.children.length > 1) return false;
	      return block.children.head instanceof _break2.default;
	    }
	  }, {
	    key: 'removeFormat',
	    value: function removeFormat(index, length) {
	      var text = this.getText(index, length);
	
	      var _scroll$line3 = this.scroll.line(index + length),
	          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
	          line = _scroll$line4[0],
	          offset = _scroll$line4[1];
	
	      var suffixLength = 0,
	          suffix = new _quillDelta2.default();
	      if (line != null) {
	        if (!(line instanceof _code2.default)) {
	          suffixLength = line.length() - offset;
	        } else {
	          suffixLength = line.newlineIndex(offset) - offset + 1;
	        }
	        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
	      }
	      var contents = this.getContents(index, length + suffixLength);
	      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
	      var delta = new _quillDelta2.default().retain(index).concat(diff);
	      return this.applyDelta(delta);
	    }
	  }, {
	    key: 'update',
	    value: function update(change) {
	      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	
	      var oldDelta = this.delta;
	      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
	        // Optimization for character changes
	        var textBlot = _parchment2.default.find(mutations[0].target);
	        var formats = (0, _block.bubbleFormats)(textBlot);
	        var index = textBlot.offset(this.scroll);
	        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
	        var oldText = new _quillDelta2.default().insert(oldValue);
	        var newText = new _quillDelta2.default().insert(textBlot.value());
	        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
	        change = diffDelta.reduce(function (delta, op) {
	          if (op.insert) {
	            return delta.insert(op.insert, formats);
	          } else {
	            return delta.push(op);
	          }
	        }, new _quillDelta2.default());
	        this.delta = oldDelta.compose(change);
	      } else {
	        this.delta = this.getDelta();
	        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
	          change = oldDelta.diff(this.delta, cursorIndex);
	        }
	      }
	      return change;
	    }
	  }]);
	
	  return Editor;
	}();
	
	function combineFormats(formats, combined) {
	  return Object.keys(combined).reduce(function (merged, name) {
	    if (formats[name] == null) return merged;
	    if (combined[name] === formats[name]) {
	      merged[name] = combined[name];
	    } else if (Array.isArray(combined[name])) {
	      if (combined[name].indexOf(formats[name]) < 0) {
	        merged[name] = combined[name].concat([formats[name]]);
	      }
	    } else {
	      merged[name] = [combined[name], formats[name]];
	    }
	    return merged;
	  }, {});
	}
	
	function normalizeDelta(delta) {
	  return delta.reduce(function (delta, op) {
	    if (op.insert === 1) {
	      var attributes = (0, _clone2.default)(op.attributes);
	      delete attributes['image'];
	      return delta.insert({ image: op.attributes.image }, attributes);
	    }
	    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
	      op = (0, _clone2.default)(op);
	      if (op.attributes.list) {
	        op.attributes.list = 'ordered';
	      } else {
	        op.attributes.list = 'bullet';
	        delete op.attributes.bullet;
	      }
	    }
	    if (typeof op.insert === 'string') {
	      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
	      return delta.insert(text, op.attributes);
	    }
	    return delta.push(op);
	  }, new _quillDelta2.default());
	}
	
	exports.default = Editor;
	
	/***/ }),
	/* 15 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Range = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _emitter3 = __webpack_require__(8);
	
	var _emitter4 = _interopRequireDefault(_emitter3);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var debug = (0, _logger2.default)('quill:selection');
	
	var Range = function Range(index) {
	  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  _classCallCheck(this, Range);
	
	  this.index = index;
	  this.length = length;
	};
	
	var Selection = function () {
	  function Selection(scroll, emitter) {
	    var _this = this;
	
	    _classCallCheck(this, Selection);
	
	    this.emitter = emitter;
	    this.scroll = scroll;
	    this.composing = false;
	    this.mouseDown = false;
	    this.root = this.scroll.domNode;
	    this.cursor = _parchment2.default.create('cursor', this);
	    // savedRange is last non-null range
	    this.lastRange = this.savedRange = new Range(0, 0);
	    this.handleComposition();
	    this.handleDragging();
	    this.emitter.listenDOM('selectionchange', document, function () {
	      if (!_this.mouseDown) {
	        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
	      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
	        _this.update(_emitter4.default.sources.SILENT);
	      }
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
	      if (!_this.hasFocus()) return;
	      var native = _this.getNativeRange();
	      if (native == null) return;
	      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
	      // TODO unclear if this has negative side effects
	      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
	        try {
	          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
	        } catch (ignored) {}
	      });
	    });
	    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
	      if (context.range) {
	        var _context$range = context.range,
	            startNode = _context$range.startNode,
	            startOffset = _context$range.startOffset,
	            endNode = _context$range.endNode,
	            endOffset = _context$range.endOffset;
	
	        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
	      }
	    });
	    this.update(_emitter4.default.sources.SILENT);
	  }
	
	  _createClass(Selection, [{
	    key: 'handleComposition',
	    value: function handleComposition() {
	      var _this2 = this;
	
	      this.root.addEventListener('compositionstart', function () {
	        _this2.composing = true;
	      });
	      this.root.addEventListener('compositionend', function () {
	        _this2.composing = false;
	        if (_this2.cursor.parent) {
	          var range = _this2.cursor.restore();
	          if (!range) return;
	          setTimeout(function () {
	            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
	          }, 1);
	        }
	      });
	    }
	  }, {
	    key: 'handleDragging',
	    value: function handleDragging() {
	      var _this3 = this;
	
	      this.emitter.listenDOM('mousedown', document.body, function () {
	        _this3.mouseDown = true;
	      });
	      this.emitter.listenDOM('mouseup', document.body, function () {
	        _this3.mouseDown = false;
	        _this3.update(_emitter4.default.sources.USER);
	      });
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.hasFocus()) return;
	      this.root.focus();
	      this.setRange(this.savedRange);
	    }
	  }, {
	    key: 'format',
	    value: function format(_format, value) {
	      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
	      this.scroll.update();
	      var nativeRange = this.getNativeRange();
	      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
	      if (nativeRange.start.node !== this.cursor.textNode) {
	        var blot = _parchment2.default.find(nativeRange.start.node, false);
	        if (blot == null) return;
	        // TODO Give blot ability to not split
	        if (blot instanceof _parchment2.default.Leaf) {
	          var after = blot.split(nativeRange.start.offset);
	          blot.parent.insertBefore(this.cursor, after);
	        } else {
	          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
	        }
	        this.cursor.attach();
	      }
	      this.cursor.format(_format, value);
	      this.scroll.optimize();
	      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
	      this.update();
	    }
	  }, {
	    key: 'getBounds',
	    value: function getBounds(index) {
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var scrollLength = this.scroll.length();
	      index = Math.min(index, scrollLength - 1);
	      length = Math.min(index + length, scrollLength - 1) - index;
	      var node = void 0,
	          _scroll$leaf = this.scroll.leaf(index),
	          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
	          leaf = _scroll$leaf2[0],
	          offset = _scroll$leaf2[1];
	      if (leaf == null) return null;
	
	      var _leaf$position = leaf.position(offset, true);
	
	      var _leaf$position2 = _slicedToArray(_leaf$position, 2);
	
	      node = _leaf$position2[0];
	      offset = _leaf$position2[1];
	
	      var range = document.createRange();
	      if (length > 0) {
	        range.setStart(node, offset);
	
	        var _scroll$leaf3 = this.scroll.leaf(index + length);
	
	        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
	
	        leaf = _scroll$leaf4[0];
	        offset = _scroll$leaf4[1];
	
	        if (leaf == null) return null;
	
	        var _leaf$position3 = leaf.position(offset, true);
	
	        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
	
	        node = _leaf$position4[0];
	        offset = _leaf$position4[1];
	
	        range.setEnd(node, offset);
	        return range.getBoundingClientRect();
	      } else {
	        var side = 'left';
	        var rect = void 0;
	        if (node instanceof Text) {
	          if (offset < node.data.length) {
	            range.setStart(node, offset);
	            range.setEnd(node, offset + 1);
	          } else {
	            range.setStart(node, offset - 1);
	            range.setEnd(node, offset);
	            side = 'right';
	          }
	          rect = range.getBoundingClientRect();
	        } else {
	          rect = leaf.domNode.getBoundingClientRect();
	          if (offset > 0) side = 'right';
	        }
	        return {
	          bottom: rect.top + rect.height,
	          height: rect.height,
	          left: rect[side],
	          right: rect[side],
	          top: rect.top,
	          width: 0
	        };
	      }
	    }
	  }, {
	    key: 'getNativeRange',
	    value: function getNativeRange() {
	      var selection = document.getSelection();
	      if (selection == null || selection.rangeCount <= 0) return null;
	      var nativeRange = selection.getRangeAt(0);
	      if (nativeRange == null) return null;
	      var range = this.normalizeNative(nativeRange);
	      debug.info('getNativeRange', range);
	      return range;
	    }
	  }, {
	    key: 'getRange',
	    value: function getRange() {
	      var normalized = this.getNativeRange();
	      if (normalized == null) return [null, null];
	      var range = this.normalizedToRange(normalized);
	      return [range, normalized];
	    }
	  }, {
	    key: 'hasFocus',
	    value: function hasFocus() {
	      return document.activeElement === this.root;
	    }
	  }, {
	    key: 'normalizedToRange',
	    value: function normalizedToRange(range) {
	      var _this4 = this;
	
	      var positions = [[range.start.node, range.start.offset]];
	      if (!range.native.collapsed) {
	        positions.push([range.end.node, range.end.offset]);
	      }
	      var indexes = positions.map(function (position) {
	        var _position = _slicedToArray(position, 2),
	            node = _position[0],
	            offset = _position[1];
	
	        var blot = _parchment2.default.find(node, true);
	        var index = blot.offset(_this4.scroll);
	        if (offset === 0) {
	          return index;
	        } else if (blot instanceof _parchment2.default.Container) {
	          return index + blot.length();
	        } else {
	          return index + blot.index(node, offset);
	        }
	      });
	      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
	      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
	      return new Range(start, end - start);
	    }
	  }, {
	    key: 'normalizeNative',
	    value: function normalizeNative(nativeRange) {
	      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
	        return null;
	      }
	      var range = {
	        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
	        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
	        native: nativeRange
	      };
	      [range.start, range.end].forEach(function (position) {
	        var node = position.node,
	            offset = position.offset;
	        while (!(node instanceof Text) && node.childNodes.length > 0) {
	          if (node.childNodes.length > offset) {
	            node = node.childNodes[offset];
	            offset = 0;
	          } else if (node.childNodes.length === offset) {
	            node = node.lastChild;
	            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
	          } else {
	            break;
	          }
	        }
	        position.node = node, position.offset = offset;
	      });
	      return range;
	    }
	  }, {
	    key: 'rangeToNative',
	    value: function rangeToNative(range) {
	      var _this5 = this;
	
	      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
	      var args = [];
	      var scrollLength = this.scroll.length();
	      indexes.forEach(function (index, i) {
	        index = Math.min(scrollLength - 1, index);
	        var node = void 0,
	            _scroll$leaf5 = _this5.scroll.leaf(index),
	            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
	            leaf = _scroll$leaf6[0],
	            offset = _scroll$leaf6[1];
	        var _leaf$position5 = leaf.position(offset, i !== 0);
	
	        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
	
	        node = _leaf$position6[0];
	        offset = _leaf$position6[1];
	
	        args.push(node, offset);
	      });
	      if (args.length < 2) {
	        args = args.concat(args);
	      }
	      return args;
	    }
	  }, {
	    key: 'scrollIntoView',
	    value: function scrollIntoView(scrollingContainer) {
	      var range = this.lastRange;
	      if (range == null) return;
	      var bounds = this.getBounds(range.index, range.length);
	      if (bounds == null) return;
	      var limit = this.scroll.length() - 1;
	
	      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
	          _scroll$line2 = _slicedToArray(_scroll$line, 1),
	          first = _scroll$line2[0];
	
	      var last = first;
	      if (range.length > 0) {
	        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
	
	        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
	
	        last = _scroll$line4[0];
	      }
	      if (first == null || last == null) return;
	      var scrollBounds = scrollingContainer.getBoundingClientRect();
	      if (bounds.top < scrollBounds.top) {
	        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
	      } else if (bounds.bottom > scrollBounds.bottom) {
	        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
	      }
	    }
	  }, {
	    key: 'setNativeRange',
	    value: function setNativeRange(startNode, startOffset) {
	      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
	      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
	      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
	      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
	        return;
	      }
	      var selection = document.getSelection();
	      if (selection == null) return;
	      if (startNode != null) {
	        if (!this.hasFocus()) this.root.focus();
	        var native = (this.getNativeRange() || {}).native;
	        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
	
	          if (startNode.tagName == "BR") {
	            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
	            startNode = startNode.parentNode;
	          }
	          if (endNode.tagName == "BR") {
	            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
	            endNode = endNode.parentNode;
	          }
	          var range = document.createRange();
	          range.setStart(startNode, startOffset);
	          range.setEnd(endNode, endOffset);
	          selection.removeAllRanges();
	          selection.addRange(range);
	        }
	      } else {
	        selection.removeAllRanges();
	        this.root.blur();
	        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
	      }
	    }
	  }, {
	    key: 'setRange',
	    value: function setRange(range) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;
	
	      if (typeof force === 'string') {
	        source = force;
	        force = false;
	      }
	      debug.info('setRange', range);
	      if (range != null) {
	        var args = this.rangeToNative(range);
	        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
	      } else {
	        this.setNativeRange(null);
	      }
	      this.update(source);
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;
	
	      var oldRange = this.lastRange;
	
	      var _getRange = this.getRange(),
	          _getRange2 = _slicedToArray(_getRange, 2),
	          lastRange = _getRange2[0],
	          nativeRange = _getRange2[1];
	
	      this.lastRange = lastRange;
	      if (this.lastRange != null) {
	        this.savedRange = this.lastRange;
	      }
	      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
	        var _emitter;
	
	        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
	          this.cursor.restore();
	        }
	        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
	        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
	        if (source !== _emitter4.default.sources.SILENT) {
	          var _emitter2;
	
	          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
	        }
	      }
	    }
	  }]);
	
	  return Selection;
	}();
	
	function contains(parent, descendant) {
	  try {
	    // Firefox inserts inaccessible nodes around video elements
	    descendant.parentNode;
	  } catch (e) {
	    return false;
	  }
	  // IE11 has bug with Text nodes
	  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
	  if (descendant instanceof Text) {
	    descendant = descendant.parentNode;
	  }
	  return parent.contains(descendant);
	}
	
	exports.Range = Range;
	exports.default = Selection;
	
	/***/ }),
	/* 16 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Break = function (_Parchment$Embed) {
	  _inherits(Break, _Parchment$Embed);
	
	  function Break() {
	    _classCallCheck(this, Break);
	
	    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
	  }
	
	  _createClass(Break, [{
	    key: 'insertInto',
	    value: function insertInto(parent, ref) {
	      if (parent.children.length === 0) {
	        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
	      } else {
	        this.remove();
	      }
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return 0;
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }], [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);
	
	  return Break;
	}(_parchment2.default.Embed);
	
	Break.blotName = 'break';
	Break.tagName = 'BR';
	
	exports.default = Break;
	
	/***/ }),
	/* 17 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var linked_list_1 = __webpack_require__(44);
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var ContainerBlot = /** @class */ (function (_super) {
	    __extends(ContainerBlot, _super);
	    function ContainerBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.build();
	        return _this;
	    }
	    ContainerBlot.prototype.appendChild = function (other) {
	        this.insertBefore(other);
	    };
	    ContainerBlot.prototype.attach = function () {
	        _super.prototype.attach.call(this);
	        this.children.forEach(function (child) {
	            child.attach();
	        });
	    };
	    ContainerBlot.prototype.build = function () {
	        var _this = this;
	        this.children = new linked_list_1.default();
	        // Need to be reversed for if DOM nodes already in order
	        [].slice
	            .call(this.domNode.childNodes)
	            .reverse()
	            .forEach(function (node) {
	            try {
	                var child = makeBlot(node);
	                _this.insertBefore(child, _this.children.head || undefined);
	            }
	            catch (err) {
	                if (err instanceof Registry.ParchmentError)
	                    return;
	                else
	                    throw err;
	            }
	        });
	    };
	    ContainerBlot.prototype.deleteAt = function (index, length) {
	        if (index === 0 && length === this.length()) {
	            return this.remove();
	        }
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.deleteAt(offset, length);
	        });
	    };
	    ContainerBlot.prototype.descendant = function (criteria, index) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if ((criteria.blotName == null && criteria(child)) ||
	            (criteria.blotName != null && child instanceof criteria)) {
	            return [child, offset];
	        }
	        else if (child instanceof ContainerBlot) {
	            return child.descendant(criteria, offset);
	        }
	        else {
	            return [null, -1];
	        }
	    };
	    ContainerBlot.prototype.descendants = function (criteria, index, length) {
	        if (index === void 0) { index = 0; }
	        if (length === void 0) { length = Number.MAX_VALUE; }
	        var descendants = [];
	        var lengthLeft = length;
	        this.children.forEachAt(index, length, function (child, index, length) {
	            if ((criteria.blotName == null && criteria(child)) ||
	                (criteria.blotName != null && child instanceof criteria)) {
	                descendants.push(child);
	            }
	            if (child instanceof ContainerBlot) {
	                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
	            }
	            lengthLeft -= length;
	        });
	        return descendants;
	    };
	    ContainerBlot.prototype.detach = function () {
	        this.children.forEach(function (child) {
	            child.detach();
	        });
	        _super.prototype.detach.call(this);
	    };
	    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
	        this.children.forEachAt(index, length, function (child, offset, length) {
	            child.formatAt(offset, length, name, value);
	        });
	    };
	    ContainerBlot.prototype.insertAt = function (index, value, def) {
	        var _a = this.children.find(index), child = _a[0], offset = _a[1];
	        if (child) {
	            child.insertAt(offset, value, def);
	        }
	        else {
	            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	            this.appendChild(blot);
	        }
	    };
	    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
	        if (this.statics.allowedChildren != null &&
	            !this.statics.allowedChildren.some(function (child) {
	                return childBlot instanceof child;
	            })) {
	            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
	        }
	        childBlot.insertInto(this, refBlot);
	    };
	    ContainerBlot.prototype.length = function () {
	        return this.children.reduce(function (memo, child) {
	            return memo + child.length();
	        }, 0);
	    };
	    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
	        this.children.forEach(function (child) {
	            targetParent.insertBefore(child, refNode);
	        });
	    };
	    ContainerBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        if (this.children.length === 0) {
	            if (this.statics.defaultChild != null) {
	                var child = Registry.create(this.statics.defaultChild);
	                this.appendChild(child);
	                child.optimize(context);
	            }
	            else {
	                this.remove();
	            }
	        }
	    };
	    ContainerBlot.prototype.path = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
	        var position = [[this, index]];
	        if (child instanceof ContainerBlot) {
	            return position.concat(child.path(offset, inclusive));
	        }
	        else if (child != null) {
	            position.push([child, offset]);
	        }
	        return position;
	    };
	    ContainerBlot.prototype.removeChild = function (child) {
	        this.children.remove(child);
	    };
	    ContainerBlot.prototype.replace = function (target) {
	        if (target instanceof ContainerBlot) {
	            target.moveChildren(this);
	        }
	        _super.prototype.replace.call(this, target);
	    };
	    ContainerBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = this.clone();
	        this.parent.insertBefore(after, this.next);
	        this.children.forEachAt(index, this.length(), function (child, offset, length) {
	            child = child.split(offset, force);
	            after.appendChild(child);
	        });
	        return after;
	    };
	    ContainerBlot.prototype.unwrap = function () {
	        this.moveChildren(this.parent, this.next);
	        this.remove();
	    };
	    ContainerBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        var addedNodes = [];
	        var removedNodes = [];
	        mutations.forEach(function (mutation) {
	            if (mutation.target === _this.domNode && mutation.type === 'childList') {
	                addedNodes.push.apply(addedNodes, mutation.addedNodes);
	                removedNodes.push.apply(removedNodes, mutation.removedNodes);
	            }
	        });
	        removedNodes.forEach(function (node) {
	            // Check node has actually been removed
	            // One exception is Chrome does not immediately remove IFRAMEs
	            // from DOM but MutationRecord is correct in its reported removal
	            if (node.parentNode != null &&
	                // @ts-ignore
	                node.tagName !== 'IFRAME' &&
	                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	                return;
	            }
	            var blot = Registry.find(node);
	            if (blot == null)
	                return;
	            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
	                blot.detach();
	            }
	        });
	        addedNodes
	            .filter(function (node) {
	            return node.parentNode == _this.domNode;
	        })
	            .sort(function (a, b) {
	            if (a === b)
	                return 0;
	            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
	                return 1;
	            }
	            return -1;
	        })
	            .forEach(function (node) {
	            var refBlot = null;
	            if (node.nextSibling != null) {
	                refBlot = Registry.find(node.nextSibling);
	            }
	            var blot = makeBlot(node);
	            if (blot.next != refBlot || blot.next == null) {
	                if (blot.parent != null) {
	                    blot.parent.removeChild(_this);
	                }
	                _this.insertBefore(blot, refBlot || undefined);
	            }
	        });
	    };
	    return ContainerBlot;
	}(shadow_1.default));
	function makeBlot(node) {
	    var blot = Registry.find(node);
	    if (blot == null) {
	        try {
	            blot = Registry.create(node);
	        }
	        catch (e) {
	            blot = Registry.create(Registry.Scope.INLINE);
	            [].slice.call(node.childNodes).forEach(function (child) {
	                // @ts-ignore
	                blot.domNode.appendChild(child);
	            });
	            if (node.parentNode) {
	                node.parentNode.replaceChild(blot.domNode, node);
	            }
	            blot.attach();
	        }
	    }
	    return blot;
	}
	exports.default = ContainerBlot;
	
	
	/***/ }),
	/* 18 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var store_1 = __webpack_require__(31);
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var FormatBlot = /** @class */ (function (_super) {
	    __extends(FormatBlot, _super);
	    function FormatBlot(domNode) {
	        var _this = _super.call(this, domNode) || this;
	        _this.attributes = new store_1.default(_this.domNode);
	        return _this;
	    }
	    FormatBlot.formats = function (domNode) {
	        if (typeof this.tagName === 'string') {
	            return true;
	        }
	        else if (Array.isArray(this.tagName)) {
	            return domNode.tagName.toLowerCase();
	        }
	        return undefined;
	    };
	    FormatBlot.prototype.format = function (name, value) {
	        var format = Registry.query(name);
	        if (format instanceof attributor_1.default) {
	            this.attributes.attribute(format, value);
	        }
	        else if (value) {
	            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
	                this.replaceWith(name, value);
	            }
	        }
	    };
	    FormatBlot.prototype.formats = function () {
	        var formats = this.attributes.values();
	        var format = this.statics.formats(this.domNode);
	        if (format != null) {
	            formats[this.statics.blotName] = format;
	        }
	        return formats;
	    };
	    FormatBlot.prototype.replaceWith = function (name, value) {
	        var replacement = _super.prototype.replaceWith.call(this, name, value);
	        this.attributes.copy(replacement);
	        return replacement;
	    };
	    FormatBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        _super.prototype.update.call(this, mutations, context);
	        if (mutations.some(function (mutation) {
	            return mutation.target === _this.domNode && mutation.type === 'attributes';
	        })) {
	            this.attributes.build();
	        }
	    };
	    FormatBlot.prototype.wrap = function (name, value) {
	        var wrapper = _super.prototype.wrap.call(this, name, value);
	        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
	            this.attributes.move(wrapper);
	        }
	        return wrapper;
	    };
	    return FormatBlot;
	}(container_1.default));
	exports.default = FormatBlot;
	
	
	/***/ }),
	/* 19 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var shadow_1 = __webpack_require__(30);
	var Registry = __webpack_require__(1);
	var LeafBlot = /** @class */ (function (_super) {
	    __extends(LeafBlot, _super);
	    function LeafBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    LeafBlot.value = function (domNode) {
	        return true;
	    };
	    LeafBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node ||
	            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
	            return Math.min(offset, 1);
	        }
	        return -1;
	    };
	    LeafBlot.prototype.position = function (index, inclusive) {
	        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
	        if (index > 0)
	            offset += 1;
	        return [this.parent.domNode, offset];
	    };
	    LeafBlot.prototype.value = function () {
	        var _a;
	        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
	    };
	    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
	    return LeafBlot;
	}(shadow_1.default));
	exports.default = LeafBlot;
	
	
	/***/ }),
	/* 20 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var equal = __webpack_require__(11);
	var extend = __webpack_require__(3);
	
	
	var lib = {
	  attributes: {
	    compose: function (a, b, keepNull) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = extend(true, {}, b);
	      if (!keepNull) {
	        attributes = Object.keys(attributes).reduce(function (copy, key) {
	          if (attributes[key] != null) {
	            copy[key] = attributes[key];
	          }
	          return copy;
	        }, {});
	      }
	      for (var key in a) {
	        if (a[key] !== undefined && b[key] === undefined) {
	          attributes[key] = a[key];
	        }
	      }
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },
	
	    diff: function(a, b) {
	      if (typeof a !== 'object') a = {};
	      if (typeof b !== 'object') b = {};
	      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
	        if (!equal(a[key], b[key])) {
	          attributes[key] = b[key] === undefined ? null : b[key];
	        }
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    },
	
	    transform: function (a, b, priority) {
	      if (typeof a !== 'object') return b;
	      if (typeof b !== 'object') return undefined;
	      if (!priority) return b;  // b simply overwrites us without priority
	      var attributes = Object.keys(b).reduce(function (attributes, key) {
	        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
	        return attributes;
	      }, {});
	      return Object.keys(attributes).length > 0 ? attributes : undefined;
	    }
	  },
	
	  iterator: function (ops) {
	    return new Iterator(ops);
	  },
	
	  length: function (op) {
	    if (typeof op['delete'] === 'number') {
	      return op['delete'];
	    } else if (typeof op.retain === 'number') {
	      return op.retain;
	    } else {
	      return typeof op.insert === 'string' ? op.insert.length : 1;
	    }
	  }
	};
	
	
	function Iterator(ops) {
	  this.ops = ops;
	  this.index = 0;
	  this.offset = 0;
	};
	
	Iterator.prototype.hasNext = function () {
	  return this.peekLength() < Infinity;
	};
	
	Iterator.prototype.next = function (length) {
	  if (!length) length = Infinity;
	  var nextOp = this.ops[this.index];
	  if (nextOp) {
	    var offset = this.offset;
	    var opLength = lib.length(nextOp)
	    if (length >= opLength - offset) {
	      length = opLength - offset;
	      this.index += 1;
	      this.offset = 0;
	    } else {
	      this.offset += length;
	    }
	    if (typeof nextOp['delete'] === 'number') {
	      return { 'delete': length };
	    } else {
	      var retOp = {};
	      if (nextOp.attributes) {
	        retOp.attributes = nextOp.attributes;
	      }
	      if (typeof nextOp.retain === 'number') {
	        retOp.retain = length;
	      } else if (typeof nextOp.insert === 'string') {
	        retOp.insert = nextOp.insert.substr(offset, length);
	      } else {
	        // offset should === 0, length should === 1
	        retOp.insert = nextOp.insert;
	      }
	      return retOp;
	    }
	  } else {
	    return { retain: Infinity };
	  }
	};
	
	Iterator.prototype.peek = function () {
	  return this.ops[this.index];
	};
	
	Iterator.prototype.peekLength = function () {
	  if (this.ops[this.index]) {
	    // Should never return 0 if our index is being managed correctly
	    return lib.length(this.ops[this.index]) - this.offset;
	  } else {
	    return Infinity;
	  }
	};
	
	Iterator.prototype.peekType = function () {
	  if (this.ops[this.index]) {
	    if (typeof this.ops[this.index]['delete'] === 'number') {
	      return 'delete';
	    } else if (typeof this.ops[this.index].retain === 'number') {
	      return 'retain';
	    } else {
	      return 'insert';
	    }
	  }
	  return 'retain';
	};
	
	Iterator.prototype.rest = function () {
	  if (!this.hasNext()) {
	    return [];
	  } else if (this.offset === 0) {
	    return this.ops.slice(this.index);
	  } else {
	    var offset = this.offset;
	    var index = this.index;
	    var next = this.next();
	    var rest = this.ops.slice(this.index);
	    this.offset = offset;
	    this.index = index;
	    return [next].concat(rest);
	  }
	};
	
	
	module.exports = lib;
	
	
	/***/ }),
	/* 21 */
	/***/ (function(module, exports) {
	
	var clone = (function() {
	'use strict';
	
	function _instanceof(obj, type) {
	  return type != null && obj instanceof type;
	}
	
	var nativeMap;
	try {
	  nativeMap = Map;
	} catch(_) {
	  // maybe a reference error because no `Map`. Give it a dummy value that no
	  // value will ever be an instanceof.
	  nativeMap = function() {};
	}
	
	var nativeSet;
	try {
	  nativeSet = Set;
	} catch(_) {
	  nativeSet = function() {};
	}
	
	var nativePromise;
	try {
	  nativePromise = Promise;
	} catch(_) {
	  nativePromise = function() {};
	}
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
	 *    should be cloned as well. Non-enumerable properties on the prototype
	 *    chain will be ignored. (optional - false by default)
	*/
	function clone(parent, circular, depth, prototype, includeNonEnumerable) {
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    includeNonEnumerable = circular.includeNonEnumerable;
	    circular = circular.circular;
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth === 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      child = new nativeMap();
	    } else if (_instanceof(parent, nativeSet)) {
	      child = new nativeSet();
	    } else if (_instanceof(parent, nativePromise)) {
	      child = new nativePromise(function (resolve, reject) {
	        parent.then(function(value) {
	          resolve(_clone(value, depth - 1));
	        }, function(err) {
	          reject(_clone(err, depth - 1));
	        });
	      });
	    } else if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      if (Buffer.allocUnsafe) {
	        // Node.js >= 4.5.0
	        child = Buffer.allocUnsafe(parent.length);
	      } else {
	        // Older Node.js versions
	        child = new Buffer(parent.length);
	      }
	      parent.copy(child);
	      return child;
	    } else if (_instanceof(parent, Error)) {
	      child = Object.create(parent);
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    if (_instanceof(parent, nativeMap)) {
	      parent.forEach(function(value, key) {
	        var keyChild = _clone(key, depth - 1);
	        var valueChild = _clone(value, depth - 1);
	        child.set(keyChild, valueChild);
	      });
	    }
	    if (_instanceof(parent, nativeSet)) {
	      parent.forEach(function(value) {
	        var entryChild = _clone(value, depth - 1);
	        child.add(entryChild);
	      });
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    if (Object.getOwnPropertySymbols) {
	      var symbols = Object.getOwnPropertySymbols(parent);
	      for (var i = 0; i < symbols.length; i++) {
	        // Don't need to worry about cloning a symbol because it is a primitive,
	        // like a number or string.
	        var symbol = symbols[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
	        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
	          continue;
	        }
	        child[symbol] = _clone(parent[symbol], depth - 1);
	        if (!descriptor.enumerable) {
	          Object.defineProperty(child, symbol, {
	            enumerable: false
	          });
	        }
	      }
	    }
	
	    if (includeNonEnumerable) {
	      var allPropertyNames = Object.getOwnPropertyNames(parent);
	      for (var i = 0; i < allPropertyNames.length; i++) {
	        var propertyName = allPropertyNames[i];
	        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
	        if (descriptor && descriptor.enumerable) {
	          continue;
	        }
	        child[propertyName] = _clone(parent[propertyName], depth - 1);
	        Object.defineProperty(child, propertyName, {
	          enumerable: false
	        });
	      }
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	}
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	}
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	}
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	}
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	}
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	
	/***/ }),
	/* 22 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function isLine(blot) {
	  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
	}
	
	var Scroll = function (_Parchment$Scroll) {
	  _inherits(Scroll, _Parchment$Scroll);
	
	  function Scroll(domNode, config) {
	    _classCallCheck(this, Scroll);
	
	    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));
	
	    _this.emitter = config.emitter;
	    if (Array.isArray(config.whitelist)) {
	      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
	        whitelist[format] = true;
	        return whitelist;
	      }, {});
	    }
	    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
	    _this.domNode.addEventListener('DOMNodeInserted', function () {});
	    _this.optimize();
	    _this.enable();
	    return _this;
	  }
	
	  _createClass(Scroll, [{
	    key: 'batchStart',
	    value: function batchStart() {
	      this.batch = true;
	    }
	  }, {
	    key: 'batchEnd',
	    value: function batchEnd() {
	      this.batch = false;
	      this.optimize();
	    }
	  }, {
	    key: 'deleteAt',
	    value: function deleteAt(index, length) {
	      var _line = this.line(index),
	          _line2 = _slicedToArray(_line, 2),
	          first = _line2[0],
	          offset = _line2[1];
	
	      var _line3 = this.line(index + length),
	          _line4 = _slicedToArray(_line3, 1),
	          last = _line4[0];
	
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
	      if (last != null && first !== last && offset > 0) {
	        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
	          this.optimize();
	          return;
	        }
	        if (first instanceof _code2.default) {
	          var newlineIndex = first.newlineIndex(first.length(), true);
	          if (newlineIndex > -1) {
	            first = first.split(newlineIndex + 1);
	            if (first === last) {
	              this.optimize();
	              return;
	            }
	          }
	        } else if (last instanceof _code2.default) {
	          var _newlineIndex = last.newlineIndex(0);
	          if (_newlineIndex > -1) {
	            last.split(_newlineIndex + 1);
	          }
	        }
	        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
	        first.moveChildren(last, ref);
	        first.remove();
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'enable',
	    value: function enable() {
	      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.domNode.setAttribute('contenteditable', enabled);
	    }
	  }, {
	    key: 'formatAt',
	    value: function formatAt(index, length, format, value) {
	      if (this.whitelist != null && !this.whitelist[format]) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
	      this.optimize();
	    }
	  }, {
	    key: 'insertAt',
	    value: function insertAt(index, value, def) {
	      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
	      if (index >= this.length()) {
	        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
	          var blot = _parchment2.default.create(this.statics.defaultChild);
	          this.appendChild(blot);
	          if (def == null && value.endsWith('\n')) {
	            value = value.slice(0, -1);
	          }
	          blot.insertAt(0, value, def);
	        } else {
	          var embed = _parchment2.default.create(value, def);
	          this.appendChild(embed);
	        }
	      } else {
	        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
	      }
	      this.optimize();
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
	        var wrapper = _parchment2.default.create(this.statics.defaultChild);
	        wrapper.appendChild(blot);
	        blot = wrapper;
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
	    }
	  }, {
	    key: 'leaf',
	    value: function leaf(index) {
	      return this.path(index).pop() || [null, -1];
	    }
	  }, {
	    key: 'line',
	    value: function line(index) {
	      if (index === this.length()) {
	        return this.line(index - 1);
	      }
	      return this.descendant(isLine, index);
	    }
	  }, {
	    key: 'lines',
	    value: function lines() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;
	
	      var getLines = function getLines(blot, index, length) {
	        var lines = [],
	            lengthLeft = length;
	        blot.children.forEachAt(index, length, function (child, index, length) {
	          if (isLine(child)) {
	            lines.push(child);
	          } else if (child instanceof _parchment2.default.Container) {
	            lines = lines.concat(getLines(child, index, lengthLeft));
	          }
	          lengthLeft -= length;
	        });
	        return lines;
	      };
	      return getLines(this, index, length);
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize() {
	      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (this.batch === true) return;
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
	      }
	    }
	  }, {
	    key: 'path',
	    value: function path(index) {
	      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations) {
	      if (this.batch === true) return;
	      var source = _emitter2.default.sources.USER;
	      if (typeof mutations === 'string') {
	        source = mutations;
	      }
	      if (!Array.isArray(mutations)) {
	        mutations = this.observer.takeRecords();
	      }
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
	      }
	      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
	      if (mutations.length > 0) {
	        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
	      }
	    }
	  }]);
	
	  return Scroll;
	}(_parchment2.default.Scroll);
	
	Scroll.blotName = 'scroll';
	Scroll.className = 'ql-editor';
	Scroll.tagName = 'DIV';
	Scroll.defaultChild = 'block';
	Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];
	
	exports.default = Scroll;
	
	/***/ }),
	/* 23 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SHORTKEY = exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _clone = __webpack_require__(21);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _deepEqual = __webpack_require__(11);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _op = __webpack_require__(20);
	
	var _op2 = _interopRequireDefault(_op);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:keyboard');
	
	var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';
	
	var Keyboard = function (_Module) {
	  _inherits(Keyboard, _Module);
	
	  _createClass(Keyboard, null, [{
	    key: 'match',
	    value: function match(evt, binding) {
	      binding = normalize(binding);
	      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
	        return !!binding[key] !== evt[key] && binding[key] !== null;
	      })) {
	        return false;
	      }
	      return binding.key === (evt.which || evt.keyCode);
	    }
	  }]);
	
	  function Keyboard(quill, options) {
	    _classCallCheck(this, Keyboard);
	
	    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));
	
	    _this.bindings = {};
	    Object.keys(_this.options.bindings).forEach(function (name) {
	      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
	        return;
	      }
	      if (_this.options.bindings[name]) {
	        _this.addBinding(_this.options.bindings[name]);
	      }
	    });
	    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
	    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
	    if (/Firefox/i.test(navigator.userAgent)) {
	      // Need to handle delete and backspace for Firefox in the general case #1171
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
	    } else {
	      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
	      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
	    }
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
	    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
	    _this.listen();
	    return _this;
	  }
	
	  _createClass(Keyboard, [{
	    key: 'addBinding',
	    value: function addBinding(key) {
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      var binding = normalize(key);
	      if (binding == null || binding.key == null) {
	        return debug.warn('Attempted to add invalid keyboard binding', binding);
	      }
	      if (typeof context === 'function') {
	        context = { handler: context };
	      }
	      if (typeof handler === 'function') {
	        handler = { handler: handler };
	      }
	      binding = (0, _extend2.default)(binding, context, handler);
	      this.bindings[binding.key] = this.bindings[binding.key] || [];
	      this.bindings[binding.key].push(binding);
	    }
	  }, {
	    key: 'listen',
	    value: function listen() {
	      var _this2 = this;
	
	      this.quill.root.addEventListener('keydown', function (evt) {
	        if (evt.defaultPrevented) return;
	        var which = evt.which || evt.keyCode;
	        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
	          return Keyboard.match(evt, binding);
	        });
	        if (bindings.length === 0) return;
	        var range = _this2.quill.getSelection();
	        if (range == null || !_this2.quill.hasFocus()) return;
	
	        var _quill$getLine = _this2.quill.getLine(range.index),
	            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
	            line = _quill$getLine2[0],
	            offset = _quill$getLine2[1];
	
	        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
	            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
	            leafStart = _quill$getLeaf2[0],
	            offsetStart = _quill$getLeaf2[1];
	
	        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
	            _ref2 = _slicedToArray(_ref, 2),
	            leafEnd = _ref2[0],
	            offsetEnd = _ref2[1];
	
	        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
	        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
	        var curContext = {
	          collapsed: range.length === 0,
	          empty: range.length === 0 && line.length() <= 1,
	          format: _this2.quill.getFormat(range),
	          offset: offset,
	          prefix: prefixText,
	          suffix: suffixText
	        };
	        var prevented = bindings.some(function (binding) {
	          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
	          if (binding.empty != null && binding.empty !== curContext.empty) return false;
	          if (binding.offset != null && binding.offset !== curContext.offset) return false;
	          if (Array.isArray(binding.format)) {
	            // any format is present
	            if (binding.format.every(function (name) {
	              return curContext.format[name] == null;
	            })) {
	              return false;
	            }
	          } else if (_typeof(binding.format) === 'object') {
	            // all formats must match
	            if (!Object.keys(binding.format).every(function (name) {
	              if (binding.format[name] === true) return curContext.format[name] != null;
	              if (binding.format[name] === false) return curContext.format[name] == null;
	              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
	            })) {
	              return false;
	            }
	          }
	          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
	          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
	          return binding.handler.call(_this2, range, curContext) !== true;
	        });
	        if (prevented) {
	          evt.preventDefault();
	        }
	      });
	    }
	  }]);
	
	  return Keyboard;
	}(_module2.default);
	
	Keyboard.keys = {
	  BACKSPACE: 8,
	  TAB: 9,
	  ENTER: 13,
	  ESCAPE: 27,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46
	};
	
	Keyboard.DEFAULTS = {
	  bindings: {
	    'bold': makeFormatHandler('bold'),
	    'italic': makeFormatHandler('italic'),
	    'underline': makeFormatHandler('underline'),
	    'indent': {
	      // highlight tab or tab at beginning of list, indent or blockquote
	      key: Keyboard.keys.TAB,
	      format: ['blockquote', 'indent', 'list'],
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '+1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      format: ['blockquote', 'indent', 'list'],
	      // highlight tab or tab at beginning of list, indent or blockquote
	      handler: function handler(range, context) {
	        if (context.collapsed && context.offset !== 0) return true;
	        this.quill.format('indent', '-1', _quill2.default.sources.USER);
	      }
	    },
	    'outdent backspace': {
	      key: Keyboard.keys.BACKSPACE,
	      collapsed: true,
	      shiftKey: null,
	      metaKey: null,
	      ctrlKey: null,
	      altKey: null,
	      format: ['indent', 'list'],
	      offset: 0,
	      handler: function handler(range, context) {
	        if (context.format.indent != null) {
	          this.quill.format('indent', '-1', _quill2.default.sources.USER);
	        } else if (context.format.list != null) {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'indent code-block': makeCodeBlockHandler(true),
	    'outdent code-block': makeCodeBlockHandler(false),
	    'remove tab': {
	      key: Keyboard.keys.TAB,
	      shiftKey: true,
	      collapsed: true,
	      prefix: /\t$/,
	      handler: function handler(range) {
	        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
	      }
	    },
	    'tab': {
	      key: Keyboard.keys.TAB,
	      handler: function handler(range) {
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	      }
	    },
	    'list empty enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['list'],
	      empty: true,
	      handler: function handler(range, context) {
	        this.quill.format('list', false, _quill2.default.sources.USER);
	        if (context.format.indent) {
	          this.quill.format('indent', false, _quill2.default.sources.USER);
	        }
	      }
	    },
	    'checklist enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: { list: 'checked' },
	      handler: function handler(range) {
	        var _quill$getLine3 = this.quill.getLine(range.index),
	            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
	            line = _quill$getLine4[0],
	            offset = _quill$getLine4[1];
	
	        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'header enter': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['header'],
	      suffix: /^$/,
	      handler: function handler(range, context) {
	        var _quill$getLine5 = this.quill.getLine(range.index),
	            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
	            line = _quill$getLine6[0],
	            offset = _quill$getLine6[1];
	
	        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	        this.quill.scrollIntoView();
	      }
	    },
	    'list autofill': {
	      key: ' ',
	      collapsed: true,
	      format: { list: false },
	      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
	      handler: function handler(range, context) {
	        var length = context.prefix.length;
	
	        var _quill$getLine7 = this.quill.getLine(range.index),
	            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
	            line = _quill$getLine8[0],
	            offset = _quill$getLine8[1];
	
	        if (offset > length) return true;
	        var value = void 0;
	        switch (context.prefix.trim()) {
	          case '[]':case '[ ]':
	            value = 'unchecked';
	            break;
	          case '[x]':
	            value = 'checked';
	            break;
	          case '-':case '*':
	            value = 'bullet';
	            break;
	          default:
	            value = 'ordered';
	        }
	        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	        this.quill.history.cutoff();
	        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
	      }
	    },
	    'code exit': {
	      key: Keyboard.keys.ENTER,
	      collapsed: true,
	      format: ['code-block'],
	      prefix: /\n\n$/,
	      suffix: /^\s+$/,
	      handler: function handler(range) {
	        var _quill$getLine9 = this.quill.getLine(range.index),
	            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
	            line = _quill$getLine10[0],
	            offset = _quill$getLine10[1];
	
	        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
	        this.quill.updateContents(delta, _quill2.default.sources.USER);
	      }
	    },
	    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
	    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
	    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
	    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
	  }
	};
	
	function makeEmbedArrowHandler(key, shiftKey) {
	  var _ref3;
	
	  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
	  return _ref3 = {
	    key: key,
	    shiftKey: shiftKey,
	    altKey: null
	  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
	    var index = range.index;
	    if (key === Keyboard.keys.RIGHT) {
	      index += range.length + 1;
	    }
	
	    var _quill$getLeaf3 = this.quill.getLeaf(index),
	        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
	        leaf = _quill$getLeaf4[0];
	
	    if (!(leaf instanceof _parchment2.default.Embed)) return true;
	    if (key === Keyboard.keys.LEFT) {
	      if (shiftKey) {
	        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
	      }
	    } else {
	      if (shiftKey) {
	        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
	      } else {
	        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
	      }
	    }
	    return false;
	  }), _ref3;
	}
	
	function handleBackspace(range, context) {
	  if (range.index === 0 || this.quill.getLength() <= 1) return;
	
	  var _quill$getLine11 = this.quill.getLine(range.index),
	      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
	      line = _quill$getLine12[0];
	
	  var formats = {};
	  if (context.offset === 0) {
	    var _quill$getLine13 = this.quill.getLine(range.index - 1),
	        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
	        prev = _quill$getLine14[0];
	
	    if (prev != null && prev.length() > 1) {
	      var curFormats = line.formats();
	      var prevFormats = this.quill.getFormat(range.index - 1, 1);
	      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
	    }
	  }
	  // Check for astral symbols
	  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
	  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
	  }
	  this.quill.focus();
	}
	
	function handleDelete(range, context) {
	  // Check for astral symbols
	  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
	  if (range.index >= this.quill.getLength() - length) return;
	  var formats = {},
	      nextLength = 0;
	
	  var _quill$getLine15 = this.quill.getLine(range.index),
	      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
	      line = _quill$getLine16[0];
	
	  if (context.offset >= line.length() - 1) {
	    var _quill$getLine17 = this.quill.getLine(range.index + 1),
	        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
	        next = _quill$getLine18[0];
	
	    if (next) {
	      var curFormats = line.formats();
	      var nextFormats = this.quill.getFormat(range.index, 1);
	      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
	      nextLength = next.length();
	    }
	  }
	  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
	  }
	}
	
	function handleDeleteRange(range) {
	  var lines = this.quill.getLines(range);
	  var formats = {};
	  if (lines.length > 1) {
	    var firstFormats = lines[0].formats();
	    var lastFormats = lines[lines.length - 1].formats();
	    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
	  }
	  this.quill.deleteText(range, _quill2.default.sources.USER);
	  if (Object.keys(formats).length > 0) {
	    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
	  }
	  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
	  this.quill.focus();
	}
	
	function handleEnter(range, context) {
	  var _this3 = this;
	
	  if (range.length > 0) {
	    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
	  }
	  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
	    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
	      lineFormats[format] = context.format[format];
	    }
	    return lineFormats;
	  }, {});
	  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
	  // Earlier scroll.deleteAt might have messed up our selection,
	  // so insertText's built in selection preservation is not reliable
	  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
	  this.quill.focus();
	  Object.keys(context.format).forEach(function (name) {
	    if (lineFormats[name] != null) return;
	    if (Array.isArray(context.format[name])) return;
	    if (name === 'link') return;
	    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
	  });
	}
	
	function makeCodeBlockHandler(indent) {
	  return {
	    key: Keyboard.keys.TAB,
	    shiftKey: !indent,
	    format: { 'code-block': true },
	    handler: function handler(range) {
	      var CodeBlock = _parchment2.default.query('code-block');
	      var index = range.index,
	          length = range.length;
	
	      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
	          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	          block = _quill$scroll$descend2[0],
	          offset = _quill$scroll$descend2[1];
	
	      if (block == null) return;
	      var scrollIndex = this.quill.getIndex(block);
	      var start = block.newlineIndex(offset, true) + 1;
	      var end = block.newlineIndex(scrollIndex + offset + length);
	      var lines = block.domNode.textContent.slice(start, end).split('\n');
	      offset = 0;
	      lines.forEach(function (line, i) {
	        if (indent) {
	          block.insertAt(start + offset, CodeBlock.TAB);
	          offset += CodeBlock.TAB.length;
	          if (i === 0) {
	            index += CodeBlock.TAB.length;
	          } else {
	            length += CodeBlock.TAB.length;
	          }
	        } else if (line.startsWith(CodeBlock.TAB)) {
	          block.deleteAt(start + offset, CodeBlock.TAB.length);
	          offset -= CodeBlock.TAB.length;
	          if (i === 0) {
	            index -= CodeBlock.TAB.length;
	          } else {
	            length -= CodeBlock.TAB.length;
	          }
	        }
	        offset += line.length + 1;
	      });
	      this.quill.update(_quill2.default.sources.USER);
	      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
	    }
	  };
	}
	
	function makeFormatHandler(format) {
	  return {
	    key: format[0].toUpperCase(),
	    shortKey: true,
	    handler: function handler(range, context) {
	      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
	    }
	  };
	}
	
	function normalize(binding) {
	  if (typeof binding === 'string' || typeof binding === 'number') {
	    return normalize({ key: binding });
	  }
	  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
	    binding = (0, _clone2.default)(binding, false);
	  }
	  if (typeof binding.key === 'string') {
	    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
	      binding.key = Keyboard.keys[binding.key.toUpperCase()];
	    } else if (binding.key.length === 1) {
	      binding.key = binding.key.toUpperCase().charCodeAt(0);
	    } else {
	      return null;
	    }
	  }
	  if (binding.shortKey) {
	    binding[SHORTKEY] = binding.shortKey;
	    delete binding.shortKey;
	  }
	  return binding;
	}
	
	exports.default = Keyboard;
	exports.SHORTKEY = SHORTKEY;
	
	/***/ }),
	/* 24 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cursor = function (_Parchment$Embed) {
	  _inherits(Cursor, _Parchment$Embed);
	
	  _createClass(Cursor, null, [{
	    key: 'value',
	    value: function value() {
	      return undefined;
	    }
	  }]);
	
	  function Cursor(domNode, selection) {
	    _classCallCheck(this, Cursor);
	
	    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));
	
	    _this.selection = selection;
	    _this.textNode = document.createTextNode(Cursor.CONTENTS);
	    _this.domNode.appendChild(_this.textNode);
	    _this._length = 0;
	    return _this;
	  }
	
	  _createClass(Cursor, [{
	    key: 'detach',
	    value: function detach() {
	      // super.detach() will also clear domNode.__blot
	      if (this.parent != null) this.parent.removeChild(this);
	    }
	  }, {
	    key: 'format',
	    value: function format(name, value) {
	      if (this._length !== 0) {
	        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
	      }
	      var target = this,
	          index = 0;
	      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
	        index += target.offset(target.parent);
	        target = target.parent;
	      }
	      if (target != null) {
	        this._length = Cursor.CONTENTS.length;
	        target.optimize();
	        target.formatAt(index, Cursor.CONTENTS.length, name, value);
	        this._length = 0;
	      }
	    }
	  }, {
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.textNode) return 0;
	      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'length',
	    value: function length() {
	      return this._length;
	    }
	  }, {
	    key: 'position',
	    value: function position() {
	      return [this.textNode, this.textNode.data.length];
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
	      this.parent = null;
	    }
	  }, {
	    key: 'restore',
	    value: function restore() {
	      if (this.selection.composing || this.parent == null) return;
	      var textNode = this.textNode;
	      var range = this.selection.getNativeRange();
	      var restoreText = void 0,
	          start = void 0,
	          end = void 0;
	      if (range != null && range.start.node === textNode && range.end.node === textNode) {
	        var _ref = [textNode, range.start.offset, range.end.offset];
	        restoreText = _ref[0];
	        start = _ref[1];
	        end = _ref[2];
	      }
	      // Link format will insert text outside of anchor tag
	      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
	        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
	      }
	      if (this.textNode.data !== Cursor.CONTENTS) {
	        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
	        if (this.next instanceof _text2.default) {
	          restoreText = this.next.domNode;
	          this.next.insertAt(0, text);
	          this.textNode.data = Cursor.CONTENTS;
	        } else {
	          this.textNode.data = text;
	          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
	          this.textNode = document.createTextNode(Cursor.CONTENTS);
	          this.domNode.appendChild(this.textNode);
	        }
	      }
	      this.remove();
	      if (start != null) {
	        var _map = [start, end].map(function (offset) {
	          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
	        });
	
	        var _map2 = _slicedToArray(_map, 2);
	
	        start = _map2[0];
	        end = _map2[1];
	
	        return {
	          startNode: restoreText,
	          startOffset: start,
	          endNode: restoreText,
	          endOffset: end
	        };
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;
	
	      if (mutations.some(function (mutation) {
	        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
	      })) {
	        var range = this.restore();
	        if (range) context.range = range;
	      }
	    }
	  }, {
	    key: 'value',
	    value: function value() {
	      return '';
	    }
	  }]);
	
	  return Cursor;
	}(_parchment2.default.Embed);
	
	Cursor.blotName = 'cursor';
	Cursor.className = 'ql-cursor';
	Cursor.tagName = 'span';
	Cursor.CONTENTS = '\uFEFF'; // Zero width no break space
	
	
	exports.default = Cursor;
	
	/***/ }),
	/* 25 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Container = function (_Parchment$Container) {
	  _inherits(Container, _Parchment$Container);
	
	  function Container() {
	    _classCallCheck(this, Container);
	
	    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
	  }
	
	  return Container;
	}(_parchment2.default.Container);
	
	Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];
	
	exports.default = Container;
	
	/***/ }),
	/* 26 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorAttributor = function (_Parchment$Attributor) {
	  _inherits(ColorAttributor, _Parchment$Attributor);
	
	  function ColorAttributor() {
	    _classCallCheck(this, ColorAttributor);
	
	    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
	  }
	
	  _createClass(ColorAttributor, [{
	    key: 'value',
	    value: function value(domNode) {
	      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
	      if (!value.startsWith('rgb(')) return value;
	      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
	      return '#' + value.split(',').map(function (component) {
	        return ('00' + parseInt(component).toString(16)).slice(-2);
	      }).join('');
	    }
	  }]);
	
	  return ColorAttributor;
	}(_parchment2.default.Attributor.Style);
	
	var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var ColorStyle = new ColorAttributor('color', 'color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	exports.ColorAttributor = ColorAttributor;
	exports.ColorClass = ColorClass;
	exports.ColorStyle = ColorStyle;
	
	/***/ }),
	/* 27 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sanitize = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Link = function (_Inline) {
	  _inherits(Link, _Inline);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
	  }
	
	  _createClass(Link, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
	      value = this.constructor.sanitize(value);
	      this.domNode.setAttribute('href', value);
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
	      value = this.sanitize(value);
	      node.setAttribute('href', value);
	      node.setAttribute('rel', 'noopener noreferrer');
	      node.setAttribute('target', '_blank');
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.getAttribute('href');
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
	    }
	  }]);
	
	  return Link;
	}(_inline2.default);
	
	Link.blotName = 'link';
	Link.tagName = 'A';
	Link.SANITIZED_URL = 'about:blank';
	Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];
	
	function _sanitize(url, protocols) {
	  var anchor = document.createElement('a');
	  anchor.href = url;
	  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
	  return protocols.indexOf(protocol) > -1;
	}
	
	exports.default = Link;
	exports.sanitize = _sanitize;
	
	/***/ }),
	/* 28 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _dropdown = __webpack_require__(107);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var optionsCounter = 0;
	
	function toggleAriaAttribute(element, attribute) {
	  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
	}
	
	var Picker = function () {
	  function Picker(select) {
	    var _this = this;
	
	    _classCallCheck(this, Picker);
	
	    this.select = select;
	    this.container = document.createElement('span');
	    this.buildPicker();
	    this.select.style.display = 'none';
	    this.select.parentNode.insertBefore(this.container, this.select);
	
	    this.label.addEventListener('mousedown', function () {
	      _this.togglePicker();
	    });
	    this.label.addEventListener('keydown', function (event) {
	      switch (event.keyCode) {
	        // Allows the "Enter" key to open the picker
	        case _keyboard2.default.keys.ENTER:
	          _this.togglePicker();
	          break;
	
	        // Allows the "Escape" key to close the picker
	        case _keyboard2.default.keys.ESCAPE:
	          _this.escape();
	          event.preventDefault();
	          break;
	        default:
	      }
	    });
	    this.select.addEventListener('change', this.update.bind(this));
	  }
	
	  _createClass(Picker, [{
	    key: 'togglePicker',
	    value: function togglePicker() {
	      this.container.classList.toggle('ql-expanded');
	      // Toggle aria-expanded and aria-hidden to make the picker accessible
	      toggleAriaAttribute(this.label, 'aria-expanded');
	      toggleAriaAttribute(this.options, 'aria-hidden');
	    }
	  }, {
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var _this2 = this;
	
	      var item = document.createElement('span');
	      item.tabIndex = '0';
	      item.setAttribute('role', 'button');
	
	      item.classList.add('ql-picker-item');
	      if (option.hasAttribute('value')) {
	        item.setAttribute('data-value', option.getAttribute('value'));
	      }
	      if (option.textContent) {
	        item.setAttribute('data-label', option.textContent);
	      }
	      item.addEventListener('click', function () {
	        _this2.selectItem(item, true);
	      });
	      item.addEventListener('keydown', function (event) {
	        switch (event.keyCode) {
	          // Allows the "Enter" key to select an item
	          case _keyboard2.default.keys.ENTER:
	            _this2.selectItem(item, true);
	            event.preventDefault();
	            break;
	
	          // Allows the "Escape" key to close the picker
	          case _keyboard2.default.keys.ESCAPE:
	            _this2.escape();
	            event.preventDefault();
	            break;
	          default:
	        }
	      });
	
	      return item;
	    }
	  }, {
	    key: 'buildLabel',
	    value: function buildLabel() {
	      var label = document.createElement('span');
	      label.classList.add('ql-picker-label');
	      label.innerHTML = _dropdown2.default;
	      label.tabIndex = '0';
	      label.setAttribute('role', 'button');
	      label.setAttribute('aria-expanded', 'false');
	      this.container.appendChild(label);
	      return label;
	    }
	  }, {
	    key: 'buildOptions',
	    value: function buildOptions() {
	      var _this3 = this;
	
	      var options = document.createElement('span');
	      options.classList.add('ql-picker-options');
	
	      // Don't want screen readers to read this until options are visible
	      options.setAttribute('aria-hidden', 'true');
	      options.tabIndex = '-1';
	
	      // Need a unique id for aria-controls
	      options.id = 'ql-picker-options-' + optionsCounter;
	      optionsCounter += 1;
	      this.label.setAttribute('aria-controls', options.id);
	
	      this.options = options;
	
	      [].slice.call(this.select.options).forEach(function (option) {
	        var item = _this3.buildItem(option);
	        options.appendChild(item);
	        if (option.selected === true) {
	          _this3.selectItem(item);
	        }
	      });
	      this.container.appendChild(options);
	    }
	  }, {
	    key: 'buildPicker',
	    value: function buildPicker() {
	      var _this4 = this;
	
	      [].slice.call(this.select.attributes).forEach(function (item) {
	        _this4.container.setAttribute(item.name, item.value);
	      });
	      this.container.classList.add('ql-picker');
	      this.label = this.buildLabel();
	      this.buildOptions();
	    }
	  }, {
	    key: 'escape',
	    value: function escape() {
	      var _this5 = this;
	
	      // Close menu and return focus to trigger label
	      this.close();
	      // Need setTimeout for accessibility to ensure that the browser executes
	      // focus on the next process thread and after any DOM content changes
	      setTimeout(function () {
	        return _this5.label.focus();
	      }, 1);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.container.classList.remove('ql-expanded');
	      this.label.setAttribute('aria-expanded', 'false');
	      this.options.setAttribute('aria-hidden', 'true');
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item) {
	      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var selected = this.container.querySelector('.ql-selected');
	      if (item === selected) return;
	      if (selected != null) {
	        selected.classList.remove('ql-selected');
	      }
	      if (item == null) return;
	      item.classList.add('ql-selected');
	      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
	      if (item.hasAttribute('data-value')) {
	        this.label.setAttribute('data-value', item.getAttribute('data-value'));
	      } else {
	        this.label.removeAttribute('data-value');
	      }
	      if (item.hasAttribute('data-label')) {
	        this.label.setAttribute('data-label', item.getAttribute('data-label'));
	      } else {
	        this.label.removeAttribute('data-label');
	      }
	      if (trigger) {
	        if (typeof Event === 'function') {
	          this.select.dispatchEvent(new Event('change'));
	        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
	          // IE11
	          var event = document.createEvent('Event');
	          event.initEvent('change', true, true);
	          this.select.dispatchEvent(event);
	        }
	        this.close();
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      var option = void 0;
	      if (this.select.selectedIndex > -1) {
	        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
	        option = this.select.options[this.select.selectedIndex];
	        this.selectItem(item);
	      } else {
	        this.selectItem(null);
	      }
	      var isActive = option != null && option !== this.select.querySelector('option[selected]');
	      this.label.classList.toggle('ql-active', isActive);
	    }
	  }]);
	
	  return Picker;
	}();
	
	exports.default = Picker;
	
	/***/ }),
	/* 29 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _break = __webpack_require__(16);
	
	var _break2 = _interopRequireDefault(_break);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _cursor = __webpack_require__(24);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _embed = __webpack_require__(35);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _scroll = __webpack_require__(22);
	
	var _scroll2 = _interopRequireDefault(_scroll);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _clipboard = __webpack_require__(55);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	var _history = __webpack_require__(42);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_quill2.default.register({
	  'blots/block': _block2.default,
	  'blots/block/embed': _block.BlockEmbed,
	  'blots/break': _break2.default,
	  'blots/container': _container2.default,
	  'blots/cursor': _cursor2.default,
	  'blots/embed': _embed2.default,
	  'blots/inline': _inline2.default,
	  'blots/scroll': _scroll2.default,
	  'blots/text': _text2.default,
	
	  'modules/clipboard': _clipboard2.default,
	  'modules/history': _history2.default,
	  'modules/keyboard': _keyboard2.default
	});
	
	_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
	
	exports.default = _quill2.default;
	
	/***/ }),
	/* 30 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var Registry = __webpack_require__(1);
	var ShadowBlot = /** @class */ (function () {
	    function ShadowBlot(domNode) {
	        this.domNode = domNode;
	        // @ts-ignore
	        this.domNode[Registry.DATA_KEY] = { blot: this };
	    }
	    Object.defineProperty(ShadowBlot.prototype, "statics", {
	        // Hack for accessing inherited static methods
	        get: function () {
	            return this.constructor;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ShadowBlot.create = function (value) {
	        if (this.tagName == null) {
	            throw new Registry.ParchmentError('Blot definition missing tagName');
	        }
	        var node;
	        if (Array.isArray(this.tagName)) {
	            if (typeof value === 'string') {
	                value = value.toUpperCase();
	                if (parseInt(value).toString() === value) {
	                    value = parseInt(value);
	                }
	            }
	            if (typeof value === 'number') {
	                node = document.createElement(this.tagName[value - 1]);
	            }
	            else if (this.tagName.indexOf(value) > -1) {
	                node = document.createElement(value);
	            }
	            else {
	                node = document.createElement(this.tagName[0]);
	            }
	        }
	        else {
	            node = document.createElement(this.tagName);
	        }
	        if (this.className) {
	            node.classList.add(this.className);
	        }
	        return node;
	    };
	    ShadowBlot.prototype.attach = function () {
	        if (this.parent != null) {
	            this.scroll = this.parent.scroll;
	        }
	    };
	    ShadowBlot.prototype.clone = function () {
	        var domNode = this.domNode.cloneNode(false);
	        return Registry.create(domNode);
	    };
	    ShadowBlot.prototype.detach = function () {
	        if (this.parent != null)
	            this.parent.removeChild(this);
	        // @ts-ignore
	        delete this.domNode[Registry.DATA_KEY];
	    };
	    ShadowBlot.prototype.deleteAt = function (index, length) {
	        var blot = this.isolate(index, length);
	        blot.remove();
	    };
	    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
	        var blot = this.isolate(index, length);
	        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
	            blot.wrap(name, value);
	        }
	        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
	            var parent = Registry.create(this.statics.scope);
	            blot.wrap(parent);
	            parent.format(name, value);
	        }
	    };
	    ShadowBlot.prototype.insertAt = function (index, value, def) {
	        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
	        var ref = this.split(index);
	        this.parent.insertBefore(blot, ref);
	    };
	    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
	        if (refBlot === void 0) { refBlot = null; }
	        if (this.parent != null) {
	            this.parent.children.remove(this);
	        }
	        var refDomNode = null;
	        parentBlot.children.insertBefore(this, refBlot);
	        if (refBlot != null) {
	            refDomNode = refBlot.domNode;
	        }
	        if (this.domNode.parentNode != parentBlot.domNode ||
	            this.domNode.nextSibling != refDomNode) {
	            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
	        }
	        this.parent = parentBlot;
	        this.attach();
	    };
	    ShadowBlot.prototype.isolate = function (index, length) {
	        var target = this.split(index);
	        target.split(length);
	        return target;
	    };
	    ShadowBlot.prototype.length = function () {
	        return 1;
	    };
	    ShadowBlot.prototype.offset = function (root) {
	        if (root === void 0) { root = this.parent; }
	        if (this.parent == null || this == root)
	            return 0;
	        return this.parent.children.offset(this) + this.parent.offset(root);
	    };
	    ShadowBlot.prototype.optimize = function (context) {
	        // TODO clean up once we use WeakMap
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY] != null) {
	            // @ts-ignore
	            delete this.domNode[Registry.DATA_KEY].mutations;
	        }
	    };
	    ShadowBlot.prototype.remove = function () {
	        if (this.domNode.parentNode != null) {
	            this.domNode.parentNode.removeChild(this.domNode);
	        }
	        this.detach();
	    };
	    ShadowBlot.prototype.replace = function (target) {
	        if (target.parent == null)
	            return;
	        target.parent.insertBefore(this, target.next);
	        target.remove();
	    };
	    ShadowBlot.prototype.replaceWith = function (name, value) {
	        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
	        replacement.replace(this);
	        return replacement;
	    };
	    ShadowBlot.prototype.split = function (index, force) {
	        return index === 0 ? this : this.next;
	    };
	    ShadowBlot.prototype.update = function (mutations, context) {
	        // Nothing to do by default
	    };
	    ShadowBlot.prototype.wrap = function (name, value) {
	        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
	        if (this.parent != null) {
	            this.parent.insertBefore(wrapper, this.next);
	        }
	        wrapper.appendChild(this);
	        return wrapper;
	    };
	    ShadowBlot.blotName = 'abstract';
	    return ShadowBlot;
	}());
	exports.default = ShadowBlot;
	
	
	/***/ }),
	/* 31 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	var class_1 = __webpack_require__(32);
	var style_1 = __webpack_require__(33);
	var Registry = __webpack_require__(1);
	var AttributorStore = /** @class */ (function () {
	    function AttributorStore(domNode) {
	        this.attributes = {};
	        this.domNode = domNode;
	        this.build();
	    }
	    AttributorStore.prototype.attribute = function (attribute, value) {
	        // verb
	        if (value) {
	            if (attribute.add(this.domNode, value)) {
	                if (attribute.value(this.domNode) != null) {
	                    this.attributes[attribute.attrName] = attribute;
	                }
	                else {
	                    delete this.attributes[attribute.attrName];
	                }
	            }
	        }
	        else {
	            attribute.remove(this.domNode);
	            delete this.attributes[attribute.attrName];
	        }
	    };
	    AttributorStore.prototype.build = function () {
	        var _this = this;
	        this.attributes = {};
	        var attributes = attributor_1.default.keys(this.domNode);
	        var classes = class_1.default.keys(this.domNode);
	        var styles = style_1.default.keys(this.domNode);
	        attributes
	            .concat(classes)
	            .concat(styles)
	            .forEach(function (name) {
	            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
	            if (attr instanceof attributor_1.default) {
	                _this.attributes[attr.attrName] = attr;
	            }
	        });
	    };
	    AttributorStore.prototype.copy = function (target) {
	        var _this = this;
	        Object.keys(this.attributes).forEach(function (key) {
	            var value = _this.attributes[key].value(_this.domNode);
	            target.format(key, value);
	        });
	    };
	    AttributorStore.prototype.move = function (target) {
	        var _this = this;
	        this.copy(target);
	        Object.keys(this.attributes).forEach(function (key) {
	            _this.attributes[key].remove(_this.domNode);
	        });
	        this.attributes = {};
	    };
	    AttributorStore.prototype.values = function () {
	        var _this = this;
	        return Object.keys(this.attributes).reduce(function (attributes, name) {
	            attributes[name] = _this.attributes[name].value(_this.domNode);
	            return attributes;
	        }, {});
	    };
	    return AttributorStore;
	}());
	exports.default = AttributorStore;
	
	
	/***/ }),
	/* 32 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function match(node, prefix) {
	    var className = node.getAttribute('class') || '';
	    return className.split(/\s+/).filter(function (name) {
	        return name.indexOf(prefix + "-") === 0;
	    });
	}
	var ClassAttributor = /** @class */ (function (_super) {
	    __extends(ClassAttributor, _super);
	    function ClassAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ClassAttributor.keys = function (node) {
	        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
	            return name
	                .split('-')
	                .slice(0, -1)
	                .join('-');
	        });
	    };
	    ClassAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        this.remove(node);
	        node.classList.add(this.keyName + "-" + value);
	        return true;
	    };
	    ClassAttributor.prototype.remove = function (node) {
	        var matches = match(node, this.keyName);
	        matches.forEach(function (name) {
	            node.classList.remove(name);
	        });
	        if (node.classList.length === 0) {
	            node.removeAttribute('class');
	        }
	    };
	    ClassAttributor.prototype.value = function (node) {
	        var result = match(node, this.keyName)[0] || '';
	        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
	        return this.canAdd(node, value) ? value : '';
	    };
	    return ClassAttributor;
	}(attributor_1.default));
	exports.default = ClassAttributor;
	
	
	/***/ }),
	/* 33 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var attributor_1 = __webpack_require__(12);
	function camelize(name) {
	    var parts = name.split('-');
	    var rest = parts
	        .slice(1)
	        .map(function (part) {
	        return part[0].toUpperCase() + part.slice(1);
	    })
	        .join('');
	    return parts[0] + rest;
	}
	var StyleAttributor = /** @class */ (function (_super) {
	    __extends(StyleAttributor, _super);
	    function StyleAttributor() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    StyleAttributor.keys = function (node) {
	        return (node.getAttribute('style') || '').split(';').map(function (value) {
	            var arr = value.split(':');
	            return arr[0].trim();
	        });
	    };
	    StyleAttributor.prototype.add = function (node, value) {
	        if (!this.canAdd(node, value))
	            return false;
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = value;
	        return true;
	    };
	    StyleAttributor.prototype.remove = function (node) {
	        // @ts-ignore
	        node.style[camelize(this.keyName)] = '';
	        if (!node.getAttribute('style')) {
	            node.removeAttribute('style');
	        }
	    };
	    StyleAttributor.prototype.value = function (node) {
	        // @ts-ignore
	        var value = node.style[camelize(this.keyName)];
	        return this.canAdd(node, value) ? value : '';
	    };
	    return StyleAttributor;
	}(attributor_1.default));
	exports.default = StyleAttributor;
	
	
	/***/ }),
	/* 34 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Theme = function () {
	  function Theme(quill, options) {
	    _classCallCheck(this, Theme);
	
	    this.quill = quill;
	    this.options = options;
	    this.modules = {};
	  }
	
	  _createClass(Theme, [{
	    key: 'init',
	    value: function init() {
	      var _this = this;
	
	      Object.keys(this.options.modules).forEach(function (name) {
	        if (_this.modules[name] == null) {
	          _this.addModule(name);
	        }
	      });
	    }
	  }, {
	    key: 'addModule',
	    value: function addModule(name) {
	      var moduleClass = this.quill.constructor.import('modules/' + name);
	      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
	      return this.modules[name];
	    }
	  }]);
	
	  return Theme;
	}();
	
	Theme.DEFAULTS = {
	  modules: {}
	};
	Theme.themes = {
	  'default': Theme
	};
	
	exports.default = Theme;
	
	/***/ }),
	/* 35 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _text = __webpack_require__(7);
	
	var _text2 = _interopRequireDefault(_text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GUARD_TEXT = '\uFEFF';
	
	var Embed = function (_Parchment$Embed) {
	  _inherits(Embed, _Parchment$Embed);
	
	  function Embed(node) {
	    _classCallCheck(this, Embed);
	
	    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));
	
	    _this.contentNode = document.createElement('span');
	    _this.contentNode.setAttribute('contenteditable', false);
	    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
	      _this.contentNode.appendChild(childNode);
	    });
	    _this.leftGuard = document.createTextNode(GUARD_TEXT);
	    _this.rightGuard = document.createTextNode(GUARD_TEXT);
	    _this.domNode.appendChild(_this.leftGuard);
	    _this.domNode.appendChild(_this.contentNode);
	    _this.domNode.appendChild(_this.rightGuard);
	    return _this;
	  }
	
	  _createClass(Embed, [{
	    key: 'index',
	    value: function index(node, offset) {
	      if (node === this.leftGuard) return 0;
	      if (node === this.rightGuard) return 1;
	      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
	    }
	  }, {
	    key: 'restore',
	    value: function restore(node) {
	      var range = void 0,
	          textNode = void 0;
	      var text = node.data.split(GUARD_TEXT).join('');
	      if (node === this.leftGuard) {
	        if (this.prev instanceof _text2.default) {
	          var prevLength = this.prev.length();
	          this.prev.insertAt(prevLength, text);
	          range = {
	            startNode: this.prev.domNode,
	            startOffset: prevLength + text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      } else if (node === this.rightGuard) {
	        if (this.next instanceof _text2.default) {
	          this.next.insertAt(0, text);
	          range = {
	            startNode: this.next.domNode,
	            startOffset: text.length
	          };
	        } else {
	          textNode = document.createTextNode(text);
	          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
	          range = {
	            startNode: textNode,
	            startOffset: text.length
	          };
	        }
	      }
	      node.data = GUARD_TEXT;
	      return range;
	    }
	  }, {
	    key: 'update',
	    value: function update(mutations, context) {
	      var _this2 = this;
	
	      mutations.forEach(function (mutation) {
	        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
	          var range = _this2.restore(mutation.target);
	          if (range) context.range = range;
	        }
	      });
	    }
	  }]);
	
	  return Embed;
	}(_parchment2.default.Embed);
	
	exports.default = Embed;
	
	/***/ }),
	/* 36 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['right', 'center', 'justify']
	};
	
	var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
	var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
	var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);
	
	exports.AlignAttribute = AlignAttribute;
	exports.AlignClass = AlignClass;
	exports.AlignStyle = AlignStyle;
	
	/***/ }),
	/* 37 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BackgroundStyle = exports.BackgroundClass = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _color = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
	  scope: _parchment2.default.Scope.INLINE
	});
	var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	exports.BackgroundClass = BackgroundClass;
	exports.BackgroundStyle = BackgroundStyle;
	
	/***/ }),
	/* 38 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: ['rtl']
	};
	
	var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
	var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
	var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);
	
	exports.DirectionAttribute = DirectionAttribute;
	exports.DirectionClass = DirectionClass;
	exports.DirectionStyle = DirectionStyle;
	
	/***/ }),
	/* 39 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FontClass = exports.FontStyle = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var config = {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['serif', 'monospace']
	};
	
	var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);
	
	var FontStyleAttributor = function (_Parchment$Attributor) {
	  _inherits(FontStyleAttributor, _Parchment$Attributor);
	
	  function FontStyleAttributor() {
	    _classCallCheck(this, FontStyleAttributor);
	
	    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
	  }
	
	  _createClass(FontStyleAttributor, [{
	    key: 'value',
	    value: function value(node) {
	      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
	    }
	  }]);
	
	  return FontStyleAttributor;
	}(_parchment2.default.Attributor.Style);
	
	var FontStyle = new FontStyleAttributor('font', 'font-family', config);
	
	exports.FontStyle = FontStyle;
	exports.FontClass = FontClass;
	
	/***/ }),
	/* 40 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SizeStyle = exports.SizeClass = undefined;
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['small', 'large', 'huge']
	});
	var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
	  scope: _parchment2.default.Scope.INLINE,
	  whitelist: ['10px', '18px', '32px']
	});
	
	exports.SizeClass = SizeClass;
	exports.SizeStyle = SizeStyle;
	
	/***/ }),
	/* 41 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	module.exports = {
	  'align': {
	    '': __webpack_require__(76),
	    'center': __webpack_require__(77),
	    'right': __webpack_require__(78),
	    'justify': __webpack_require__(79)
	  },
	  'background': __webpack_require__(80),
	  'blockquote': __webpack_require__(81),
	  'bold': __webpack_require__(82),
	  'clean': __webpack_require__(83),
	  'code': __webpack_require__(58),
	  'code-block': __webpack_require__(58),
	  'color': __webpack_require__(84),
	  'direction': {
	    '': __webpack_require__(85),
	    'rtl': __webpack_require__(86)
	  },
	  'float': {
	    'center': __webpack_require__(87),
	    'full': __webpack_require__(88),
	    'left': __webpack_require__(89),
	    'right': __webpack_require__(90)
	  },
	  'formula': __webpack_require__(91),
	  'header': {
	    '1': __webpack_require__(92),
	    '2': __webpack_require__(93)
	  },
	  'italic': __webpack_require__(94),
	  'image': __webpack_require__(95),
	  'indent': {
	    '+1': __webpack_require__(96),
	    '-1': __webpack_require__(97)
	  },
	  'link': __webpack_require__(98),
	  'list': {
	    'ordered': __webpack_require__(99),
	    'bullet': __webpack_require__(100),
	    'check': __webpack_require__(101)
	  },
	  'script': {
	    'sub': __webpack_require__(102),
	    'super': __webpack_require__(103)
	  },
	  'strike': __webpack_require__(104),
	  'underline': __webpack_require__(105),
	  'video': __webpack_require__(106)
	};
	
	/***/ }),
	/* 42 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLastChangeIndex = exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var History = function (_Module) {
	  _inherits(History, _Module);
	
	  function History(quill, options) {
	    _classCallCheck(this, History);
	
	    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));
	
	    _this.lastRecorded = 0;
	    _this.ignoreChange = false;
	    _this.clear();
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
	      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
	      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
	        _this.record(delta, oldDelta);
	      } else {
	        _this.transform(delta);
	      }
	    });
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
	    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
	    if (/Win/i.test(navigator.platform)) {
	      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
	    }
	    return _this;
	  }
	
	  _createClass(History, [{
	    key: 'change',
	    value: function change(source, dest) {
	      if (this.stack[source].length === 0) return;
	      var delta = this.stack[source].pop();
	      this.stack[dest].push(delta);
	      this.lastRecorded = 0;
	      this.ignoreChange = true;
	      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
	      this.ignoreChange = false;
	      var index = getLastChangeIndex(delta[source]);
	      this.quill.setSelection(index);
	    }
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.stack = { undo: [], redo: [] };
	    }
	  }, {
	    key: 'cutoff',
	    value: function cutoff() {
	      this.lastRecorded = 0;
	    }
	  }, {
	    key: 'record',
	    value: function record(changeDelta, oldDelta) {
	      if (changeDelta.ops.length === 0) return;
	      this.stack.redo = [];
	      var undoDelta = this.quill.getContents().diff(oldDelta);
	      var timestamp = Date.now();
	      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
	        var delta = this.stack.undo.pop();
	        undoDelta = undoDelta.compose(delta.undo);
	        changeDelta = delta.redo.compose(changeDelta);
	      } else {
	        this.lastRecorded = timestamp;
	      }
	      this.stack.undo.push({
	        redo: changeDelta,
	        undo: undoDelta
	      });
	      if (this.stack.undo.length > this.options.maxStack) {
	        this.stack.undo.shift();
	      }
	    }
	  }, {
	    key: 'redo',
	    value: function redo() {
	      this.change('redo', 'undo');
	    }
	  }, {
	    key: 'transform',
	    value: function transform(delta) {
	      this.stack.undo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	      this.stack.redo.forEach(function (change) {
	        change.undo = delta.transform(change.undo, true);
	        change.redo = delta.transform(change.redo, true);
	      });
	    }
	  }, {
	    key: 'undo',
	    value: function undo() {
	      this.change('undo', 'redo');
	    }
	  }]);
	
	  return History;
	}(_module2.default);
	
	History.DEFAULTS = {
	  delay: 1000,
	  maxStack: 100,
	  userOnly: false
	};
	
	function endsWithNewlineChange(delta) {
	  var lastOp = delta.ops[delta.ops.length - 1];
	  if (lastOp == null) return false;
	  if (lastOp.insert != null) {
	    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
	  }
	  if (lastOp.attributes != null) {
	    return Object.keys(lastOp.attributes).some(function (attr) {
	      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
	    });
	  }
	  return false;
	}
	
	function getLastChangeIndex(delta) {
	  var deleteLength = delta.reduce(function (length, op) {
	    length += op.delete || 0;
	    return length;
	  }, 0);
	  var changeIndex = delta.length() - deleteLength;
	  if (endsWithNewlineChange(delta)) {
	    changeIndex -= 1;
	  }
	  return changeIndex;
	}
	
	exports.default = History;
	exports.getLastChangeIndex = getLastChangeIndex;
	
	/***/ }),
	/* 43 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BaseTooltip = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _keyboard = __webpack_require__(23);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _theme = __webpack_require__(34);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _colorPicker = __webpack_require__(59);
	
	var _colorPicker2 = _interopRequireDefault(_colorPicker);
	
	var _iconPicker = __webpack_require__(60);
	
	var _iconPicker2 = _interopRequireDefault(_iconPicker);
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	var _tooltip = __webpack_require__(61);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ALIGNS = [false, 'center', 'right', 'justify'];
	
	var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];
	
	var FONTS = [false, 'serif', 'monospace'];
	
	var HEADERS = ['1', '2', '3', false];
	
	var SIZES = ['small', false, 'large', 'huge'];
	
	var BaseTheme = function (_Theme) {
	  _inherits(BaseTheme, _Theme);
	
	  function BaseTheme(quill, options) {
	    _classCallCheck(this, BaseTheme);
	
	    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));
	
	    var listener = function listener(e) {
	      if (!document.body.contains(quill.root)) {
	        return document.body.removeEventListener('click', listener);
	      }
	      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
	        _this.tooltip.hide();
	      }
	      if (_this.pickers != null) {
	        _this.pickers.forEach(function (picker) {
	          if (!picker.container.contains(e.target)) {
	            picker.close();
	          }
	        });
	      }
	    };
	    quill.emitter.listenDOM('click', document.body, listener);
	    return _this;
	  }
	
	  _createClass(BaseTheme, [{
	    key: 'addModule',
	    value: function addModule(name) {
	      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
	      if (name === 'toolbar') {
	        this.extendToolbar(module);
	      }
	      return module;
	    }
	  }, {
	    key: 'buildButtons',
	    value: function buildButtons(buttons, icons) {
	      buttons.forEach(function (button) {
	        var className = button.getAttribute('class') || '';
	        className.split(/\s+/).forEach(function (name) {
	          if (!name.startsWith('ql-')) return;
	          name = name.slice('ql-'.length);
	          if (icons[name] == null) return;
	          if (name === 'direction') {
	            button.innerHTML = icons[name][''] + icons[name]['rtl'];
	          } else if (typeof icons[name] === 'string') {
	            button.innerHTML = icons[name];
	          } else {
	            var value = button.value || '';
	            if (value != null && icons[name][value]) {
	              button.innerHTML = icons[name][value];
	            }
	          }
	        });
	      });
	    }
	  }, {
	    key: 'buildPickers',
	    value: function buildPickers(selects, icons) {
	      var _this2 = this;
	
	      this.pickers = selects.map(function (select) {
	        if (select.classList.contains('ql-align')) {
	          if (select.querySelector('option') == null) {
	            fillSelect(select, ALIGNS);
	          }
	          return new _iconPicker2.default(select, icons.align);
	        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
	          var format = select.classList.contains('ql-background') ? 'background' : 'color';
	          if (select.querySelector('option') == null) {
	            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
	          }
	          return new _colorPicker2.default(select, icons[format]);
	        } else {
	          if (select.querySelector('option') == null) {
	            if (select.classList.contains('ql-font')) {
	              fillSelect(select, FONTS);
	            } else if (select.classList.contains('ql-header')) {
	              fillSelect(select, HEADERS);
	            } else if (select.classList.contains('ql-size')) {
	              fillSelect(select, SIZES);
	            }
	          }
	          return new _picker2.default(select);
	        }
	      });
	      var update = function update() {
	        _this2.pickers.forEach(function (picker) {
	          picker.update();
	        });
	      };
	      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
	    }
	  }]);
	
	  return BaseTheme;
	}(_theme2.default);
	
	BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        formula: function formula() {
	          this.quill.theme.tooltip.edit('formula');
	        },
	        image: function image() {
	          var _this3 = this;
	
	          var fileInput = this.container.querySelector('input.ql-image[type=file]');
	          if (fileInput == null) {
	            fileInput = document.createElement('input');
	            fileInput.setAttribute('type', 'file');
	            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
	            fileInput.classList.add('ql-image');
	            fileInput.addEventListener('change', function () {
	              if (fileInput.files != null && fileInput.files[0] != null) {
	                var reader = new FileReader();
	                reader.onload = function (e) {
	                  var range = _this3.quill.getSelection(true);
	                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
	                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
	                  fileInput.value = "";
	                };
	                reader.readAsDataURL(fileInput.files[0]);
	              }
	            });
	            this.container.appendChild(fileInput);
	          }
	          fileInput.click();
	        },
	        video: function video() {
	          this.quill.theme.tooltip.edit('video');
	        }
	      }
	    }
	  }
	});
	
	var BaseTooltip = function (_Tooltip) {
	  _inherits(BaseTooltip, _Tooltip);
	
	  function BaseTooltip(quill, boundsContainer) {
	    _classCallCheck(this, BaseTooltip);
	
	    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));
	
	    _this4.textbox = _this4.root.querySelector('input[type="text"]');
	    _this4.listen();
	    return _this4;
	  }
	
	  _createClass(BaseTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this5 = this;
	
	      this.textbox.addEventListener('keydown', function (event) {
	        if (_keyboard2.default.match(event, 'enter')) {
	          _this5.save();
	          event.preventDefault();
	        } else if (_keyboard2.default.match(event, 'escape')) {
	          _this5.cancel();
	          event.preventDefault();
	        }
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.hide();
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
	      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	      this.root.classList.remove('ql-hidden');
	      this.root.classList.add('ql-editing');
	      if (preview != null) {
	        this.textbox.value = preview;
	      } else if (mode !== this.root.getAttribute('data-mode')) {
	        this.textbox.value = '';
	      }
	      this.position(this.quill.getBounds(this.quill.selection.savedRange));
	      this.textbox.select();
	      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
	      this.root.setAttribute('data-mode', mode);
	    }
	  }, {
	    key: 'restoreFocus',
	    value: function restoreFocus() {
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.quill.focus();
	      this.quill.scrollingContainer.scrollTop = scrollTop;
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      var value = this.textbox.value;
	      switch (this.root.getAttribute('data-mode')) {
	        case 'link':
	          {
	            var scrollTop = this.quill.root.scrollTop;
	            if (this.linkRange) {
	              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
	              delete this.linkRange;
	            } else {
	              this.restoreFocus();
	              this.quill.format('link', value, _emitter2.default.sources.USER);
	            }
	            this.quill.root.scrollTop = scrollTop;
	            break;
	          }
	        case 'video':
	          {
	            value = extractVideoUrl(value);
	          } // eslint-disable-next-line no-fallthrough
	        case 'formula':
	          {
	            if (!value) break;
	            var range = this.quill.getSelection(true);
	            if (range != null) {
	              var index = range.index + range.length;
	              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
	              if (this.root.getAttribute('data-mode') === 'formula') {
	                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
	              }
	              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
	            }
	            break;
	          }
	        default:
	      }
	      this.textbox.value = '';
	      this.hide();
	    }
	  }]);
	
	  return BaseTooltip;
	}(_tooltip2.default);
	
	function extractVideoUrl(url) {
	  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
	  if (match) {
	    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
	  }
	  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
	    // eslint-disable-line no-cond-assign
	    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
	  }
	  return url;
	}
	
	function fillSelect(select, values) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value === defaultValue) {
	      option.setAttribute('selected', 'selected');
	    } else {
	      option.setAttribute('value', value);
	    }
	    select.appendChild(option);
	  });
	}
	
	exports.BaseTooltip = BaseTooltip;
	exports.default = BaseTheme;
	
	/***/ }),
	/* 44 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var LinkedList = /** @class */ (function () {
	    function LinkedList() {
	        this.head = this.tail = null;
	        this.length = 0;
	    }
	    LinkedList.prototype.append = function () {
	        var nodes = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            nodes[_i] = arguments[_i];
	        }
	        this.insertBefore(nodes[0], null);
	        if (nodes.length > 1) {
	            this.append.apply(this, nodes.slice(1));
	        }
	    };
	    LinkedList.prototype.contains = function (node) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            if (cur === node)
	                return true;
	        }
	        return false;
	    };
	    LinkedList.prototype.insertBefore = function (node, refNode) {
	        if (!node)
	            return;
	        node.next = refNode;
	        if (refNode != null) {
	            node.prev = refNode.prev;
	            if (refNode.prev != null) {
	                refNode.prev.next = node;
	            }
	            refNode.prev = node;
	            if (refNode === this.head) {
	                this.head = node;
	            }
	        }
	        else if (this.tail != null) {
	            this.tail.next = node;
	            node.prev = this.tail;
	            this.tail = node;
	        }
	        else {
	            node.prev = null;
	            this.head = this.tail = node;
	        }
	        this.length += 1;
	    };
	    LinkedList.prototype.offset = function (target) {
	        var index = 0, cur = this.head;
	        while (cur != null) {
	            if (cur === target)
	                return index;
	            index += cur.length();
	            cur = cur.next;
	        }
	        return -1;
	    };
	    LinkedList.prototype.remove = function (node) {
	        if (!this.contains(node))
	            return;
	        if (node.prev != null)
	            node.prev.next = node.next;
	        if (node.next != null)
	            node.next.prev = node.prev;
	        if (node === this.head)
	            this.head = node.next;
	        if (node === this.tail)
	            this.tail = node.prev;
	        this.length -= 1;
	    };
	    LinkedList.prototype.iterator = function (curNode) {
	        if (curNode === void 0) { curNode = this.head; }
	        // TODO use yield when we can
	        return function () {
	            var ret = curNode;
	            if (curNode != null)
	                curNode = curNode.next;
	            return ret;
	        };
	    };
	    LinkedList.prototype.find = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            var length = cur.length();
	            if (index < length ||
	                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
	                return [cur, index];
	            }
	            index -= length;
	        }
	        return [null, 0];
	    };
	    LinkedList.prototype.forEach = function (callback) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            callback(cur);
	        }
	    };
	    LinkedList.prototype.forEachAt = function (index, length, callback) {
	        if (length <= 0)
	            return;
	        var _a = this.find(index), startNode = _a[0], offset = _a[1];
	        var cur, curIndex = index - offset, next = this.iterator(startNode);
	        while ((cur = next()) && curIndex < index + length) {
	            var curLength = cur.length();
	            if (index > curIndex) {
	                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
	            }
	            else {
	                callback(cur, 0, Math.min(curLength, index + length - curIndex));
	            }
	            curIndex += curLength;
	        }
	    };
	    LinkedList.prototype.map = function (callback) {
	        return this.reduce(function (memo, cur) {
	            memo.push(callback(cur));
	            return memo;
	        }, []);
	    };
	    LinkedList.prototype.reduce = function (callback, memo) {
	        var cur, next = this.iterator();
	        while ((cur = next())) {
	            memo = callback(memo, cur);
	        }
	        return memo;
	    };
	    return LinkedList;
	}());
	exports.default = LinkedList;
	
	
	/***/ }),
	/* 45 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var container_1 = __webpack_require__(17);
	var Registry = __webpack_require__(1);
	var OBSERVER_CONFIG = {
	    attributes: true,
	    characterData: true,
	    characterDataOldValue: true,
	    childList: true,
	    subtree: true,
	};
	var MAX_OPTIMIZE_ITERATIONS = 100;
	var ScrollBlot = /** @class */ (function (_super) {
	    __extends(ScrollBlot, _super);
	    function ScrollBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.scroll = _this;
	        _this.observer = new MutationObserver(function (mutations) {
	            _this.update(mutations);
	        });
	        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
	        _this.attach();
	        return _this;
	    }
	    ScrollBlot.prototype.detach = function () {
	        _super.prototype.detach.call(this);
	        this.observer.disconnect();
	    };
	    ScrollBlot.prototype.deleteAt = function (index, length) {
	        this.update();
	        if (index === 0 && length === this.length()) {
	            this.children.forEach(function (child) {
	                child.remove();
	            });
	        }
	        else {
	            _super.prototype.deleteAt.call(this, index, length);
	        }
	    };
	    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
	        this.update();
	        _super.prototype.formatAt.call(this, index, length, name, value);
	    };
	    ScrollBlot.prototype.insertAt = function (index, value, def) {
	        this.update();
	        _super.prototype.insertAt.call(this, index, value, def);
	    };
	    ScrollBlot.prototype.optimize = function (mutations, context) {
	        var _this = this;
	        if (mutations === void 0) { mutations = []; }
	        if (context === void 0) { context = {}; }
	        _super.prototype.optimize.call(this, context);
	        // We must modify mutations directly, cannot make copy and then modify
	        var records = [].slice.call(this.observer.takeRecords());
	        // Array.push currently seems to be implemented by a non-tail recursive function
	        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
	        while (records.length > 0)
	            mutations.push(records.pop());
	        // TODO use WeakMap
	        var mark = function (blot, markParent) {
	            if (markParent === void 0) { markParent = true; }
	            if (blot == null || blot === _this)
	                return;
	            if (blot.domNode.parentNode == null)
	                return;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [];
	            }
	            if (markParent)
	                mark(blot.parent);
	        };
	        var optimize = function (blot) {
	            // Post-order traversal
	            if (
	            // @ts-ignore
	            blot.domNode[Registry.DATA_KEY] == null ||
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations == null) {
	                return;
	            }
	            if (blot instanceof container_1.default) {
	                blot.children.forEach(optimize);
	            }
	            blot.optimize(context);
	        };
	        var remaining = mutations;
	        for (var i = 0; remaining.length > 0; i += 1) {
	            if (i >= MAX_OPTIMIZE_ITERATIONS) {
	                throw new Error('[Parchment] Maximum optimize iterations reached');
	            }
	            remaining.forEach(function (mutation) {
	                var blot = Registry.find(mutation.target, true);
	                if (blot == null)
	                    return;
	                if (blot.domNode === mutation.target) {
	                    if (mutation.type === 'childList') {
	                        mark(Registry.find(mutation.previousSibling, false));
	                        [].forEach.call(mutation.addedNodes, function (node) {
	                            var child = Registry.find(node, false);
	                            mark(child, false);
	                            if (child instanceof container_1.default) {
	                                child.children.forEach(function (grandChild) {
	                                    mark(grandChild, false);
	                                });
	                            }
	                        });
	                    }
	                    else if (mutation.type === 'attributes') {
	                        mark(blot.prev);
	                    }
	                }
	                mark(blot);
	            });
	            this.children.forEach(optimize);
	            remaining = [].slice.call(this.observer.takeRecords());
	            records = remaining.slice();
	            while (records.length > 0)
	                mutations.push(records.pop());
	        }
	    };
	    ScrollBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (context === void 0) { context = {}; }
	        mutations = mutations || this.observer.takeRecords();
	        // TODO use WeakMap
	        mutations
	            .map(function (mutation) {
	            var blot = Registry.find(mutation.target, true);
	            if (blot == null)
	                return null;
	            // @ts-ignore
	            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
	                return blot;
	            }
	            else {
	                // @ts-ignore
	                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
	                return null;
	            }
	        })
	            .forEach(function (blot) {
	            if (blot == null ||
	                blot === _this ||
	                //@ts-ignore
	                blot.domNode[Registry.DATA_KEY] == null)
	                return;
	            // @ts-ignore
	            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
	        });
	        // @ts-ignore
	        if (this.domNode[Registry.DATA_KEY].mutations != null) {
	            // @ts-ignore
	            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
	        }
	        this.optimize(mutations, context);
	    };
	    ScrollBlot.blotName = 'scroll';
	    ScrollBlot.defaultChild = 'block';
	    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
	    ScrollBlot.tagName = 'DIV';
	    return ScrollBlot;
	}(container_1.default));
	exports.default = ScrollBlot;
	
	
	/***/ }),
	/* 46 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	// Shallow object comparison
	function isEqual(obj1, obj2) {
	    if (Object.keys(obj1).length !== Object.keys(obj2).length)
	        return false;
	    // @ts-ignore
	    for (var prop in obj1) {
	        // @ts-ignore
	        if (obj1[prop] !== obj2[prop])
	            return false;
	    }
	    return true;
	}
	var InlineBlot = /** @class */ (function (_super) {
	    __extends(InlineBlot, _super);
	    function InlineBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    InlineBlot.formats = function (domNode) {
	        if (domNode.tagName === InlineBlot.tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    InlineBlot.prototype.format = function (name, value) {
	        var _this = this;
	        if (name === this.statics.blotName && !value) {
	            this.children.forEach(function (child) {
	                if (!(child instanceof format_1.default)) {
	                    child = child.wrap(InlineBlot.blotName, true);
	                }
	                _this.attributes.copy(child);
	            });
	            this.unwrap();
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    InlineBlot.prototype.formatAt = function (index, length, name, value) {
	        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
	            var blot = this.isolate(index, length);
	            blot.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    InlineBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        var formats = this.formats();
	        if (Object.keys(formats).length === 0) {
	            return this.unwrap(); // unformatted span
	        }
	        var next = this.next;
	        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
	            next.moveChildren(this);
	            next.remove();
	        }
	    };
	    InlineBlot.blotName = 'inline';
	    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
	    InlineBlot.tagName = 'SPAN';
	    return InlineBlot;
	}(format_1.default));
	exports.default = InlineBlot;
	
	
	/***/ }),
	/* 47 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var format_1 = __webpack_require__(18);
	var Registry = __webpack_require__(1);
	var BlockBlot = /** @class */ (function (_super) {
	    __extends(BlockBlot, _super);
	    function BlockBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BlockBlot.formats = function (domNode) {
	        var tagName = Registry.query(BlockBlot.blotName).tagName;
	        if (domNode.tagName === tagName)
	            return undefined;
	        return _super.formats.call(this, domNode);
	    };
	    BlockBlot.prototype.format = function (name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
	            return;
	        }
	        else if (name === this.statics.blotName && !value) {
	            this.replaceWith(BlockBlot.blotName);
	        }
	        else {
	            _super.prototype.format.call(this, name, value);
	        }
	    };
	    BlockBlot.prototype.formatAt = function (index, length, name, value) {
	        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    BlockBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
	            // Insert text or inline
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	        else {
	            var after = this.split(index);
	            var blot = Registry.create(value, def);
	            after.parent.insertBefore(blot, after);
	        }
	    };
	    BlockBlot.prototype.update = function (mutations, context) {
	        if (navigator.userAgent.match(/Trident/)) {
	            this.build();
	        }
	        else {
	            _super.prototype.update.call(this, mutations, context);
	        }
	    };
	    BlockBlot.blotName = 'block';
	    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
	    BlockBlot.tagName = 'P';
	    return BlockBlot;
	}(format_1.default));
	exports.default = BlockBlot;
	
	
	/***/ }),
	/* 48 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var EmbedBlot = /** @class */ (function (_super) {
	    __extends(EmbedBlot, _super);
	    function EmbedBlot() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EmbedBlot.formats = function (domNode) {
	        return undefined;
	    };
	    EmbedBlot.prototype.format = function (name, value) {
	        // super.formatAt wraps, which is what we want in general,
	        // but this allows subclasses to overwrite for formats
	        // that just apply to particular embeds
	        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
	    };
	    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
	        if (index === 0 && length === this.length()) {
	            this.format(name, value);
	        }
	        else {
	            _super.prototype.formatAt.call(this, index, length, name, value);
	        }
	    };
	    EmbedBlot.prototype.formats = function () {
	        return this.statics.formats(this.domNode);
	    };
	    return EmbedBlot;
	}(leaf_1.default));
	exports.default = EmbedBlot;
	
	
	/***/ }),
	/* 49 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	var leaf_1 = __webpack_require__(19);
	var Registry = __webpack_require__(1);
	var TextBlot = /** @class */ (function (_super) {
	    __extends(TextBlot, _super);
	    function TextBlot(node) {
	        var _this = _super.call(this, node) || this;
	        _this.text = _this.statics.value(_this.domNode);
	        return _this;
	    }
	    TextBlot.create = function (value) {
	        return document.createTextNode(value);
	    };
	    TextBlot.value = function (domNode) {
	        var text = domNode.data;
	        // @ts-ignore
	        if (text['normalize'])
	            text = text['normalize']();
	        return text;
	    };
	    TextBlot.prototype.deleteAt = function (index, length) {
	        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
	    };
	    TextBlot.prototype.index = function (node, offset) {
	        if (this.domNode === node) {
	            return offset;
	        }
	        return -1;
	    };
	    TextBlot.prototype.insertAt = function (index, value, def) {
	        if (def == null) {
	            this.text = this.text.slice(0, index) + value + this.text.slice(index);
	            this.domNode.data = this.text;
	        }
	        else {
	            _super.prototype.insertAt.call(this, index, value, def);
	        }
	    };
	    TextBlot.prototype.length = function () {
	        return this.text.length;
	    };
	    TextBlot.prototype.optimize = function (context) {
	        _super.prototype.optimize.call(this, context);
	        this.text = this.statics.value(this.domNode);
	        if (this.text.length === 0) {
	            this.remove();
	        }
	        else if (this.next instanceof TextBlot && this.next.prev === this) {
	            this.insertAt(this.length(), this.next.value());
	            this.next.remove();
	        }
	    };
	    TextBlot.prototype.position = function (index, inclusive) {
	        if (inclusive === void 0) { inclusive = false; }
	        return [this.domNode, index];
	    };
	    TextBlot.prototype.split = function (index, force) {
	        if (force === void 0) { force = false; }
	        if (!force) {
	            if (index === 0)
	                return this;
	            if (index === this.length())
	                return this.next;
	        }
	        var after = Registry.create(this.domNode.splitText(index));
	        this.parent.insertBefore(after, this.next);
	        this.text = this.statics.value(this.domNode);
	        return after;
	    };
	    TextBlot.prototype.update = function (mutations, context) {
	        var _this = this;
	        if (mutations.some(function (mutation) {
	            return mutation.type === 'characterData' && mutation.target === _this.domNode;
	        })) {
	            this.text = this.statics.value(this.domNode);
	        }
	    };
	    TextBlot.prototype.value = function () {
	        return this.text;
	    };
	    TextBlot.blotName = 'text';
	    TextBlot.scope = Registry.Scope.INLINE_BLOT;
	    return TextBlot;
	}(leaf_1.default));
	exports.default = TextBlot;
	
	
	/***/ }),
	/* 50 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	var elem = document.createElement('div');
	elem.classList.toggle('test-class', false);
	if (elem.classList.contains('test-class')) {
	  var _toggle = DOMTokenList.prototype.toggle;
	  DOMTokenList.prototype.toggle = function (token, force) {
	    if (arguments.length > 1 && !this.contains(token) === !force) {
	      return force;
	    } else {
	      return _toggle.call(this, token);
	    }
	  };
	}
	
	if (!String.prototype.startsWith) {
	  String.prototype.startsWith = function (searchString, position) {
	    position = position || 0;
	    return this.substr(position, searchString.length) === searchString;
	  };
	}
	
	if (!String.prototype.endsWith) {
	  String.prototype.endsWith = function (searchString, position) {
	    var subjectString = this.toString();
	    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
	      position = subjectString.length;
	    }
	    position -= searchString.length;
	    var lastIndex = subjectString.indexOf(searchString, position);
	    return lastIndex !== -1 && lastIndex === position;
	  };
	}
	
	if (!Array.prototype.find) {
	  Object.defineProperty(Array.prototype, "find", {
	    value: function value(predicate) {
	      if (this === null) {
	        throw new TypeError('Array.prototype.find called on null or undefined');
	      }
	      if (typeof predicate !== 'function') {
	        throw new TypeError('predicate must be a function');
	      }
	      var list = Object(this);
	      var length = list.length >>> 0;
	      var thisArg = arguments[1];
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return value;
	        }
	      }
	      return undefined;
	    }
	  });
	}
	
	document.addEventListener("DOMContentLoaded", function () {
	  // Disable resizing in Firefox
	  document.execCommand("enableObjectResizing", false, false);
	  // Disable automatic linkifying in IE11
	  document.execCommand("autoUrlDetect", false, false);
	});
	
	/***/ }),
	/* 51 */
	/***/ (function(module, exports) {
	
	/**
	 * This library modifies the diff-patch-match library by Neil Fraser
	 * by removing the patch and match functionality and certain advanced
	 * options in the diff function. The original license is as follows:
	 *
	 * ===
	 *
	 * Diff Match and Patch
	 *
	 * Copyright 2006 Google Inc.
	 * http://code.google.com/p/google-diff-match-patch/
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	
	/**
	 * The data structure representing a diff is an array of tuples:
	 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
	 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
	 */
	var DIFF_DELETE = -1;
	var DIFF_INSERT = 1;
	var DIFF_EQUAL = 0;
	
	
	/**
	 * Find the differences between two texts.  Simplifies the problem by stripping
	 * any common prefix or suffix off the texts before diffing.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {Int} cursor_pos Expected edit position in text1 (optional)
	 * @return {Array} Array of diff tuples.
	 */
	function diff_main(text1, text2, cursor_pos) {
	  // Check for equality (speedup).
	  if (text1 == text2) {
	    if (text1) {
	      return [[DIFF_EQUAL, text1]];
	    }
	    return [];
	  }
	
	  // Check cursor_pos within bounds
	  if (cursor_pos < 0 || text1.length < cursor_pos) {
	    cursor_pos = null;
	  }
	
	  // Trim off common prefix (speedup).
	  var commonlength = diff_commonPrefix(text1, text2);
	  var commonprefix = text1.substring(0, commonlength);
	  text1 = text1.substring(commonlength);
	  text2 = text2.substring(commonlength);
	
	  // Trim off common suffix (speedup).
	  commonlength = diff_commonSuffix(text1, text2);
	  var commonsuffix = text1.substring(text1.length - commonlength);
	  text1 = text1.substring(0, text1.length - commonlength);
	  text2 = text2.substring(0, text2.length - commonlength);
	
	  // Compute the diff on the middle block.
	  var diffs = diff_compute_(text1, text2);
	
	  // Restore the prefix and suffix.
	  if (commonprefix) {
	    diffs.unshift([DIFF_EQUAL, commonprefix]);
	  }
	  if (commonsuffix) {
	    diffs.push([DIFF_EQUAL, commonsuffix]);
	  }
	  diff_cleanupMerge(diffs);
	  if (cursor_pos != null) {
	    diffs = fix_cursor(diffs, cursor_pos);
	  }
	  diffs = fix_emoji(diffs);
	  return diffs;
	};
	
	
	/**
	 * Find the differences between two texts.  Assumes that the texts do not
	 * have any common prefix or suffix.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_compute_(text1, text2) {
	  var diffs;
	
	  if (!text1) {
	    // Just add some text (speedup).
	    return [[DIFF_INSERT, text2]];
	  }
	
	  if (!text2) {
	    // Just delete some text (speedup).
	    return [[DIFF_DELETE, text1]];
	  }
	
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  var i = longtext.indexOf(shorttext);
	  if (i != -1) {
	    // Shorter text is inside the longer text (speedup).
	    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
	             [DIFF_EQUAL, shorttext],
	             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
	    // Swap insertions for deletions if diff is reversed.
	    if (text1.length > text2.length) {
	      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
	    }
	    return diffs;
	  }
	
	  if (shorttext.length == 1) {
	    // Single character string.
	    // After the previous speedup, the character can't be an equality.
	    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	  }
	
	  // Check to see if the problem can be split in two.
	  var hm = diff_halfMatch_(text1, text2);
	  if (hm) {
	    // A half-match was found, sort out the return data.
	    var text1_a = hm[0];
	    var text1_b = hm[1];
	    var text2_a = hm[2];
	    var text2_b = hm[3];
	    var mid_common = hm[4];
	    // Send both pairs off for separate processing.
	    var diffs_a = diff_main(text1_a, text2_a);
	    var diffs_b = diff_main(text1_b, text2_b);
	    // Merge the results.
	    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
	  }
	
	  return diff_bisect_(text1, text2);
	};
	
	
	/**
	 * Find the 'middle snake' of a diff, split the problem in two
	 * and return the recursively constructed diff.
	 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @return {Array} Array of diff tuples.
	 * @private
	 */
	function diff_bisect_(text1, text2) {
	  // Cache the text lengths to prevent multiple calls.
	  var text1_length = text1.length;
	  var text2_length = text2.length;
	  var max_d = Math.ceil((text1_length + text2_length) / 2);
	  var v_offset = max_d;
	  var v_length = 2 * max_d;
	  var v1 = new Array(v_length);
	  var v2 = new Array(v_length);
	  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
	  // integers and undefined.
	  for (var x = 0; x < v_length; x++) {
	    v1[x] = -1;
	    v2[x] = -1;
	  }
	  v1[v_offset + 1] = 0;
	  v2[v_offset + 1] = 0;
	  var delta = text1_length - text2_length;
	  // If the total number of characters is odd, then the front path will collide
	  // with the reverse path.
	  var front = (delta % 2 != 0);
	  // Offsets for start and end of k loop.
	  // Prevents mapping of space beyond the grid.
	  var k1start = 0;
	  var k1end = 0;
	  var k2start = 0;
	  var k2end = 0;
	  for (var d = 0; d < max_d; d++) {
	    // Walk the front path one step.
	    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
	      var k1_offset = v_offset + k1;
	      var x1;
	      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
	        x1 = v1[k1_offset + 1];
	      } else {
	        x1 = v1[k1_offset - 1] + 1;
	      }
	      var y1 = x1 - k1;
	      while (x1 < text1_length && y1 < text2_length &&
	             text1.charAt(x1) == text2.charAt(y1)) {
	        x1++;
	        y1++;
	      }
	      v1[k1_offset] = x1;
	      if (x1 > text1_length) {
	        // Ran off the right of the graph.
	        k1end += 2;
	      } else if (y1 > text2_length) {
	        // Ran off the bottom of the graph.
	        k1start += 2;
	      } else if (front) {
	        var k2_offset = v_offset + delta - k1;
	        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
	          // Mirror x2 onto top-left coordinate system.
	          var x2 = text1_length - v2[k2_offset];
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	
	    // Walk the reverse path one step.
	    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
	      var k2_offset = v_offset + k2;
	      var x2;
	      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
	        x2 = v2[k2_offset + 1];
	      } else {
	        x2 = v2[k2_offset - 1] + 1;
	      }
	      var y2 = x2 - k2;
	      while (x2 < text1_length && y2 < text2_length &&
	             text1.charAt(text1_length - x2 - 1) ==
	             text2.charAt(text2_length - y2 - 1)) {
	        x2++;
	        y2++;
	      }
	      v2[k2_offset] = x2;
	      if (x2 > text1_length) {
	        // Ran off the left of the graph.
	        k2end += 2;
	      } else if (y2 > text2_length) {
	        // Ran off the top of the graph.
	        k2start += 2;
	      } else if (!front) {
	        var k1_offset = v_offset + delta - k2;
	        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
	          var x1 = v1[k1_offset];
	          var y1 = v_offset + x1 - k1_offset;
	          // Mirror x2 onto top-left coordinate system.
	          x2 = text1_length - x2;
	          if (x1 >= x2) {
	            // Overlap detected.
	            return diff_bisectSplit_(text1, text2, x1, y1);
	          }
	        }
	      }
	    }
	  }
	  // Diff took too long and hit the deadline or
	  // number of diffs equals number of characters, no commonality at all.
	  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
	};
	
	
	/**
	 * Given the location of the 'middle snake', split the diff in two parts
	 * and recurse.
	 * @param {string} text1 Old string to be diffed.
	 * @param {string} text2 New string to be diffed.
	 * @param {number} x Index of split point in text1.
	 * @param {number} y Index of split point in text2.
	 * @return {Array} Array of diff tuples.
	 */
	function diff_bisectSplit_(text1, text2, x, y) {
	  var text1a = text1.substring(0, x);
	  var text2a = text2.substring(0, y);
	  var text1b = text1.substring(x);
	  var text2b = text2.substring(y);
	
	  // Compute both diffs serially.
	  var diffs = diff_main(text1a, text2a);
	  var diffsb = diff_main(text1b, text2b);
	
	  return diffs.concat(diffsb);
	};
	
	
	/**
	 * Determine the common prefix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the start of each
	 *     string.
	 */
	function diff_commonPrefix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerstart = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(pointerstart, pointermid) ==
	        text2.substring(pointerstart, pointermid)) {
	      pointermin = pointermid;
	      pointerstart = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Determine the common suffix of two strings.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {number} The number of characters common to the end of each string.
	 */
	function diff_commonSuffix(text1, text2) {
	  // Quick check for common null cases.
	  if (!text1 || !text2 ||
	      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
	    return 0;
	  }
	  // Binary search.
	  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
	  var pointermin = 0;
	  var pointermax = Math.min(text1.length, text2.length);
	  var pointermid = pointermax;
	  var pointerend = 0;
	  while (pointermin < pointermid) {
	    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
	        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
	      pointermin = pointermid;
	      pointerend = pointermin;
	    } else {
	      pointermax = pointermid;
	    }
	    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
	  }
	  return pointermid;
	};
	
	
	/**
	 * Do the two texts share a substring which is at least half the length of the
	 * longer text?
	 * This speedup can produce non-minimal diffs.
	 * @param {string} text1 First string.
	 * @param {string} text2 Second string.
	 * @return {Array.<string>} Five element Array, containing the prefix of
	 *     text1, the suffix of text1, the prefix of text2, the suffix of
	 *     text2 and the common middle.  Or null if there was no match.
	 */
	function diff_halfMatch_(text1, text2) {
	  var longtext = text1.length > text2.length ? text1 : text2;
	  var shorttext = text1.length > text2.length ? text2 : text1;
	  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
	    return null;  // Pointless.
	  }
	
	  /**
	   * Does a substring of shorttext exist within longtext such that the substring
	   * is at least half the length of longtext?
	   * Closure, but does not reference any external variables.
	   * @param {string} longtext Longer string.
	   * @param {string} shorttext Shorter string.
	   * @param {number} i Start index of quarter length substring within longtext.
	   * @return {Array.<string>} Five element Array, containing the prefix of
	   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
	   *     of shorttext and the common middle.  Or null if there was no match.
	   * @private
	   */
	  function diff_halfMatchI_(longtext, shorttext, i) {
	    // Start with a 1/4 length substring at position i as a seed.
	    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
	    var j = -1;
	    var best_common = '';
	    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
	    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
	      var prefixLength = diff_commonPrefix(longtext.substring(i),
	                                           shorttext.substring(j));
	      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
	                                           shorttext.substring(0, j));
	      if (best_common.length < suffixLength + prefixLength) {
	        best_common = shorttext.substring(j - suffixLength, j) +
	            shorttext.substring(j, j + prefixLength);
	        best_longtext_a = longtext.substring(0, i - suffixLength);
	        best_longtext_b = longtext.substring(i + prefixLength);
	        best_shorttext_a = shorttext.substring(0, j - suffixLength);
	        best_shorttext_b = shorttext.substring(j + prefixLength);
	      }
	    }
	    if (best_common.length * 2 >= longtext.length) {
	      return [best_longtext_a, best_longtext_b,
	              best_shorttext_a, best_shorttext_b, best_common];
	    } else {
	      return null;
	    }
	  }
	
	  // First check if the second quarter is the seed for a half-match.
	  var hm1 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 4));
	  // Check again based on the third quarter.
	  var hm2 = diff_halfMatchI_(longtext, shorttext,
	                             Math.ceil(longtext.length / 2));
	  var hm;
	  if (!hm1 && !hm2) {
	    return null;
	  } else if (!hm2) {
	    hm = hm1;
	  } else if (!hm1) {
	    hm = hm2;
	  } else {
	    // Both matched.  Select the longest.
	    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
	  }
	
	  // A half-match was found, sort out the return data.
	  var text1_a, text1_b, text2_a, text2_b;
	  if (text1.length > text2.length) {
	    text1_a = hm[0];
	    text1_b = hm[1];
	    text2_a = hm[2];
	    text2_b = hm[3];
	  } else {
	    text2_a = hm[0];
	    text2_b = hm[1];
	    text1_a = hm[2];
	    text1_b = hm[3];
	  }
	  var mid_common = hm[4];
	  return [text1_a, text1_b, text2_a, text2_b, mid_common];
	};
	
	
	/**
	 * Reorder and merge like edit sections.  Merge equalities.
	 * Any edit section can move as long as it doesn't cross an equality.
	 * @param {Array} diffs Array of diff tuples.
	 */
	function diff_cleanupMerge(diffs) {
	  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
	  var pointer = 0;
	  var count_delete = 0;
	  var count_insert = 0;
	  var text_delete = '';
	  var text_insert = '';
	  var commonlength;
	  while (pointer < diffs.length) {
	    switch (diffs[pointer][0]) {
	      case DIFF_INSERT:
	        count_insert++;
	        text_insert += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_DELETE:
	        count_delete++;
	        text_delete += diffs[pointer][1];
	        pointer++;
	        break;
	      case DIFF_EQUAL:
	        // Upon reaching an equality, check for prior redundancies.
	        if (count_delete + count_insert > 1) {
	          if (count_delete !== 0 && count_insert !== 0) {
	            // Factor out any common prefixies.
	            commonlength = diff_commonPrefix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              if ((pointer - count_delete - count_insert) > 0 &&
	                  diffs[pointer - count_delete - count_insert - 1][0] ==
	                  DIFF_EQUAL) {
	                diffs[pointer - count_delete - count_insert - 1][1] +=
	                    text_insert.substring(0, commonlength);
	              } else {
	                diffs.splice(0, 0, [DIFF_EQUAL,
	                                    text_insert.substring(0, commonlength)]);
	                pointer++;
	              }
	              text_insert = text_insert.substring(commonlength);
	              text_delete = text_delete.substring(commonlength);
	            }
	            // Factor out any common suffixies.
	            commonlength = diff_commonSuffix(text_insert, text_delete);
	            if (commonlength !== 0) {
	              diffs[pointer][1] = text_insert.substring(text_insert.length -
	                  commonlength) + diffs[pointer][1];
	              text_insert = text_insert.substring(0, text_insert.length -
	                  commonlength);
	              text_delete = text_delete.substring(0, text_delete.length -
	                  commonlength);
	            }
	          }
	          // Delete the offending records and add the merged ones.
	          if (count_delete === 0) {
	            diffs.splice(pointer - count_insert,
	                count_delete + count_insert, [DIFF_INSERT, text_insert]);
	          } else if (count_insert === 0) {
	            diffs.splice(pointer - count_delete,
	                count_delete + count_insert, [DIFF_DELETE, text_delete]);
	          } else {
	            diffs.splice(pointer - count_delete - count_insert,
	                count_delete + count_insert, [DIFF_DELETE, text_delete],
	                [DIFF_INSERT, text_insert]);
	          }
	          pointer = pointer - count_delete - count_insert +
	                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
	        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
	          // Merge this equality with the previous one.
	          diffs[pointer - 1][1] += diffs[pointer][1];
	          diffs.splice(pointer, 1);
	        } else {
	          pointer++;
	        }
	        count_insert = 0;
	        count_delete = 0;
	        text_delete = '';
	        text_insert = '';
	        break;
	    }
	  }
	  if (diffs[diffs.length - 1][1] === '') {
	    diffs.pop();  // Remove the dummy entry at the end.
	  }
	
	  // Second pass: look for single edits surrounded on both sides by equalities
	  // which can be shifted sideways to eliminate an equality.
	  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
	  var changes = false;
	  pointer = 1;
	  // Intentionally ignore the first and last element (don't need checking).
	  while (pointer < diffs.length - 1) {
	    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
	        diffs[pointer + 1][0] == DIFF_EQUAL) {
	      // This is a single edit surrounded by equalities.
	      if (diffs[pointer][1].substring(diffs[pointer][1].length -
	          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
	        // Shift the edit over the previous equality.
	        diffs[pointer][1] = diffs[pointer - 1][1] +
	            diffs[pointer][1].substring(0, diffs[pointer][1].length -
	                                        diffs[pointer - 1][1].length);
	        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
	        diffs.splice(pointer - 1, 1);
	        changes = true;
	      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
	          diffs[pointer + 1][1]) {
	        // Shift the edit over the next equality.
	        diffs[pointer - 1][1] += diffs[pointer + 1][1];
	        diffs[pointer][1] =
	            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
	            diffs[pointer + 1][1];
	        diffs.splice(pointer + 1, 1);
	        changes = true;
	      }
	    }
	    pointer++;
	  }
	  // If shifts were made, the diff needs reordering and another shift sweep.
	  if (changes) {
	    diff_cleanupMerge(diffs);
	  }
	};
	
	
	var diff = diff_main;
	diff.INSERT = DIFF_INSERT;
	diff.DELETE = DIFF_DELETE;
	diff.EQUAL = DIFF_EQUAL;
	
	module.exports = diff;
	
	/*
	 * Modify a diff such that the cursor position points to the start of a change:
	 * E.g.
	 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
	 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
	 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
	 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
	 */
	function cursor_normalize_diff (diffs, cursor_pos) {
	  if (cursor_pos === 0) {
	    return [DIFF_EQUAL, diffs];
	  }
	  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
	    var d = diffs[i];
	    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
	      var next_pos = current_pos + d[1].length;
	      if (cursor_pos === next_pos) {
	        return [i + 1, diffs];
	      } else if (cursor_pos < next_pos) {
	        // copy to prevent side effects
	        diffs = diffs.slice();
	        // split d into two diff changes
	        var split_pos = cursor_pos - current_pos;
	        var d_left = [d[0], d[1].slice(0, split_pos)];
	        var d_right = [d[0], d[1].slice(split_pos)];
	        diffs.splice(i, 1, d_left, d_right);
	        return [i + 1, diffs];
	      } else {
	        current_pos = next_pos;
	      }
	    }
	  }
	  throw new Error('cursor_pos is out of bounds!')
	}
	
	/*
	 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
	 *
	 * Case 1)
	 *   Check if a naive shift is possible:
	 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
	 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
	 * Case 2)
	 *   Check if the following shifts are possible:
	 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
	 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
	 *         ^            ^
	 *         d          d_next
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
	 * @return {Array} Array of diff tuples
	 */
	function fix_cursor (diffs, cursor_pos) {
	  var norm = cursor_normalize_diff(diffs, cursor_pos);
	  var ndiffs = norm[1];
	  var cursor_pointer = norm[0];
	  var d = ndiffs[cursor_pointer];
	  var d_next = ndiffs[cursor_pointer + 1];
	
	  if (d == null) {
	    // Text was deleted from end of original string,
	    // cursor is now out of bounds in new string
	    return diffs;
	  } else if (d[0] !== DIFF_EQUAL) {
	    // A modification happened at the cursor location.
	    // This is the expected outcome, so we can return the original diff.
	    return diffs;
	  } else {
	    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
	      // Case 1)
	      // It is possible to perform a naive shift
	      ndiffs.splice(cursor_pointer, 2, d_next, d)
	      return merge_tuples(ndiffs, cursor_pointer, 2)
	    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
	      // Case 2)
	      // d[1] is a prefix of d_next[1]
	      // We can assume that d_next[0] !== 0, since d[0] === 0
	      // Shift edit locations..
	      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
	      var suffix = d_next[1].slice(d[1].length);
	      if (suffix.length > 0) {
	        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
	      }
	      return merge_tuples(ndiffs, cursor_pointer, 3)
	    } else {
	      // Not possible to perform any modification
	      return diffs;
	    }
	  }
	}
	
	/*
	 * Check diff did not split surrogate pairs.
	 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
	 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
	 *
	 * @param {Array} diffs Array of diff tuples
	 * @return {Array} Array of diff tuples
	 */
	function fix_emoji (diffs) {
	  var compact = false;
	  var starts_with_pair_end = function(str) {
	    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
	  }
	  var ends_with_pair_start = function(str) {
	    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
	  }
	  for (var i = 2; i < diffs.length; i += 1) {
	    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
	        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
	        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
	      compact = true;
	
	      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
	      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];
	
	      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
	    }
	  }
	  if (!compact) {
	    return diffs;
	  }
	  var fixed_diffs = [];
	  for (var i = 0; i < diffs.length; i += 1) {
	    if (diffs[i][1].length > 0) {
	      fixed_diffs.push(diffs[i]);
	    }
	  }
	  return fixed_diffs;
	}
	
	/*
	 * Try to merge tuples with their neigbors in a given range.
	 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
	 *
	 * @param {Array} diffs Array of diff tuples.
	 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
	 * @param {Int} length Number of consecutive elements to check.
	 * @return {Array} Array of merged diff tuples.
	 */
	function merge_tuples (diffs, start, length) {
	  // Check from (start-1) to (start+length).
	  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
	    if (i + 1 < diffs.length) {
	      var left_d = diffs[i];
	      var right_d = diffs[i+1];
	      if (left_d[0] === right_d[1]) {
	        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
	      }
	    }
	  }
	  return diffs;
	}
	
	
	/***/ }),
	/* 52 */
	/***/ (function(module, exports) {
	
	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}
	
	
	/***/ }),
	/* 53 */
	/***/ (function(module, exports) {
	
	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};
	
	
	/***/ }),
	/* 54 */
	/***/ (function(module, exports) {
	
	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @api private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {Mixed} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @api private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @api public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @api public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Boolean} exists Only check if there are listeners.
	 * @returns {Array|Boolean}
	 * @api public
	 */
	EventEmitter.prototype.listeners = function listeners(event, exists) {
	  var evt = prefix ? prefix + event : event
	    , available = this._events[evt];
	
	  if (exists) return !!available;
	  if (!available) return [];
	  if (available.fn) return [available.fn];
	
	  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
	    ee[i] = available[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @api public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  var listener = new EE(fn, context || this)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {Mixed} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  var listener = new EE(fn, context || this, true)
	    , evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
	  else if (!this._events[evt].fn) this._events[evt].push(listener);
	  else this._events[evt] = [this._events[evt], listener];
	
	  return this;
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {String|Symbol} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {Mixed} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	         listeners.fn === fn
	      && (!once || listeners.once)
	      && (!context || listeners.context === context)
	    ) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	           listeners[i].fn !== fn
	        || (once && !listeners[i].once)
	        || (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else if (--this._eventsCount === 0) this._events = new Events();
	    else delete this._events[evt];
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {String|Symbol} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @api public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) {
	      if (--this._eventsCount === 0) this._events = new Events();
	      else delete this._events[evt];
	    }
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// This function doesn't apply anymore.
	//
	EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
	  return this;
	};
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if ('undefined' !== typeof module) {
	  module.exports = EventEmitter;
	}
	
	
	/***/ }),
	/* 55 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend2 = __webpack_require__(3);
	
	var _extend3 = _interopRequireDefault(_extend2);
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _align = __webpack_require__(36);
	
	var _background = __webpack_require__(37);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _color = __webpack_require__(26);
	
	var _direction = __webpack_require__(38);
	
	var _font = __webpack_require__(39);
	
	var _size = __webpack_require__(40);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:clipboard');
	
	var DOM_KEY = '__ql-matcher';
	
	var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];
	
	var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	
	var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
	  memo[attr.keyName] = attr;
	  return memo;
	}, {});
	
	var Clipboard = function (_Module) {
	  _inherits(Clipboard, _Module);
	
	  function Clipboard(quill, options) {
	    _classCallCheck(this, Clipboard);
	
	    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));
	
	    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
	    _this.container = _this.quill.addContainer('ql-clipboard');
	    _this.container.setAttribute('contenteditable', true);
	    _this.container.setAttribute('tabindex', -1);
	    _this.matchers = [];
	    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
	      var _ref2 = _slicedToArray(_ref, 2),
	          selector = _ref2[0],
	          matcher = _ref2[1];
	
	      if (!options.matchVisual && matcher === matchSpacing) return;
	      _this.addMatcher(selector, matcher);
	    });
	    return _this;
	  }
	
	  _createClass(Clipboard, [{
	    key: 'addMatcher',
	    value: function addMatcher(selector, matcher) {
	      this.matchers.push([selector, matcher]);
	    }
	  }, {
	    key: 'convert',
	    value: function convert(html) {
	      if (typeof html === 'string') {
	        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
	        return this.convert();
	      }
	      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
	      if (formats[_code2.default.blotName]) {
	        var text = this.container.innerText;
	        this.container.innerHTML = '';
	        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
	      }
	
	      var _prepareMatching = this.prepareMatching(),
	          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
	          elementMatchers = _prepareMatching2[0],
	          textMatchers = _prepareMatching2[1];
	
	      var delta = traverse(this.container, elementMatchers, textMatchers);
	      // Remove trailing newline
	      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
	        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
	      }
	      debug.log('convert', this.container.innerHTML, delta);
	      this.container.innerHTML = '';
	      return delta;
	    }
	  }, {
	    key: 'dangerouslyPasteHTML',
	    value: function dangerouslyPasteHTML(index, html) {
	      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;
	
	      if (typeof index === 'string') {
	        this.quill.setContents(this.convert(index), html);
	        this.quill.setSelection(0, _quill2.default.sources.SILENT);
	      } else {
	        var paste = this.convert(html);
	        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
	        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
	      }
	    }
	  }, {
	    key: 'onPaste',
	    value: function onPaste(e) {
	      var _this2 = this;
	
	      if (e.defaultPrevented || !this.quill.isEnabled()) return;
	      var range = this.quill.getSelection();
	      var delta = new _quillDelta2.default().retain(range.index);
	      var scrollTop = this.quill.scrollingContainer.scrollTop;
	      this.container.focus();
	      this.quill.selection.update(_quill2.default.sources.SILENT);
	      setTimeout(function () {
	        delta = delta.concat(_this2.convert()).delete(range.length);
	        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
	        // range.length contributes to delta.length()
	        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
	        _this2.quill.scrollingContainer.scrollTop = scrollTop;
	        _this2.quill.focus();
	      }, 1);
	    }
	  }, {
	    key: 'prepareMatching',
	    value: function prepareMatching() {
	      var _this3 = this;
	
	      var elementMatchers = [],
	          textMatchers = [];
	      this.matchers.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            selector = _pair[0],
	            matcher = _pair[1];
	
	        switch (selector) {
	          case Node.TEXT_NODE:
	            textMatchers.push(matcher);
	            break;
	          case Node.ELEMENT_NODE:
	            elementMatchers.push(matcher);
	            break;
	          default:
	            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
	              // TODO use weakmap
	              node[DOM_KEY] = node[DOM_KEY] || [];
	              node[DOM_KEY].push(matcher);
	            });
	            break;
	        }
	      });
	      return [elementMatchers, textMatchers];
	    }
	  }]);
	
	  return Clipboard;
	}(_module2.default);
	
	Clipboard.DEFAULTS = {
	  matchers: [],
	  matchVisual: true
	};
	
	function applyFormat(delta, format, value) {
	  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
	    return Object.keys(format).reduce(function (delta, key) {
	      return applyFormat(delta, key, format[key]);
	    }, delta);
	  } else {
	    return delta.reduce(function (delta, op) {
	      if (op.attributes && op.attributes[format]) {
	        return delta.push(op);
	      } else {
	        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
	      }
	    }, new _quillDelta2.default());
	  }
	}
	
	function computeStyle(node) {
	  if (node.nodeType !== Node.ELEMENT_NODE) return {};
	  var DOM_KEY = '__ql-computed-style';
	  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
	}
	
	function deltaEndsWith(delta, text) {
	  var endText = "";
	  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
	    var op = delta.ops[i];
	    if (typeof op.insert !== 'string') break;
	    endText = op.insert + endText;
	  }
	  return endText.slice(-1 * text.length) === text;
	}
	
	function isLine(node) {
	  if (node.childNodes.length === 0) return false; // Exclude embed blocks
	  var style = computeStyle(node);
	  return ['block', 'list-item'].indexOf(style.display) > -1;
	}
	
	function traverse(node, elementMatchers, textMatchers) {
	  // Post-order
	  if (node.nodeType === node.TEXT_NODE) {
	    return textMatchers.reduce(function (delta, matcher) {
	      return matcher(node, delta);
	    }, new _quillDelta2.default());
	  } else if (node.nodeType === node.ELEMENT_NODE) {
	    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
	      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
	      if (childNode.nodeType === node.ELEMENT_NODE) {
	        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
	          return matcher(childNode, childrenDelta);
	        }, childrenDelta);
	      }
	      return delta.concat(childrenDelta);
	    }, new _quillDelta2.default());
	  } else {
	    return new _quillDelta2.default();
	  }
	}
	
	function matchAlias(format, node, delta) {
	  return applyFormat(delta, format, true);
	}
	
	function matchAttributor(node, delta) {
	  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
	  var classes = _parchment2.default.Attributor.Class.keys(node);
	  var styles = _parchment2.default.Attributor.Style.keys(node);
	  var formats = {};
	  attributes.concat(classes).concat(styles).forEach(function (name) {
	    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
	    if (attr != null) {
	      formats[attr.attrName] = attr.value(node);
	      if (formats[attr.attrName]) return;
	    }
	    attr = ATTRIBUTE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	    attr = STYLE_ATTRIBUTORS[name];
	    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
	      attr = STYLE_ATTRIBUTORS[name];
	      formats[attr.attrName] = attr.value(node) || undefined;
	    }
	  });
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  return delta;
	}
	
	function matchBlot(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null) return delta;
	  if (match.prototype instanceof _parchment2.default.Embed) {
	    var embed = {};
	    var value = match.value(node);
	    if (value != null) {
	      embed[match.blotName] = value;
	      delta = new _quillDelta2.default().insert(embed, match.formats(node));
	    }
	  } else if (typeof match.formats === 'function') {
	    delta = applyFormat(delta, match.blotName, match.formats(node));
	  }
	  return delta;
	}
	
	function matchBreak(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    delta.insert('\n');
	  }
	  return delta;
	}
	
	function matchIgnore() {
	  return new _quillDelta2.default();
	}
	
	function matchIndent(node, delta) {
	  var match = _parchment2.default.query(node);
	  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
	    return delta;
	  }
	  var indent = -1,
	      parent = node.parentNode;
	  while (!parent.classList.contains('ql-clipboard')) {
	    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
	      indent += 1;
	    }
	    parent = parent.parentNode;
	  }
	  if (indent <= 0) return delta;
	  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
	}
	
	function matchNewline(node, delta) {
	  if (!deltaEndsWith(delta, '\n')) {
	    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}
	
	function matchSpacing(node, delta) {
	  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
	    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
	    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
	      delta.insert('\n');
	    }
	  }
	  return delta;
	}
	
	function matchStyles(node, delta) {
	  var formats = {};
	  var style = node.style || {};
	  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
	    formats.italic = true;
	  }
	  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
	    formats.bold = true;
	  }
	  if (Object.keys(formats).length > 0) {
	    delta = applyFormat(delta, formats);
	  }
	  if (parseFloat(style.textIndent || 0) > 0) {
	    // Could be 0.5in
	    delta = new _quillDelta2.default().insert('\t').concat(delta);
	  }
	  return delta;
	}
	
	function matchText(node, delta) {
	  var text = node.data;
	  // Word represents empty line with <o:p>&nbsp;</o:p>
	  if (node.parentNode.tagName === 'O:P') {
	    return delta.insert(text.trim());
	  }
	  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
	    return delta;
	  }
	  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
	    // eslint-disable-next-line func-style
	    var replacer = function replacer(collapse, match) {
	      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
	      return match.length < 1 && collapse ? ' ' : match;
	    };
	    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
	    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
	    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
	      text = text.replace(/^\s+/, replacer.bind(replacer, false));
	    }
	    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
	      text = text.replace(/\s+$/, replacer.bind(replacer, false));
	    }
	  }
	  return delta.insert(text);
	}
	
	exports.default = Clipboard;
	exports.matchAttributor = matchAttributor;
	exports.matchBlot = matchBlot;
	exports.matchNewline = matchNewline;
	exports.matchSpacing = matchSpacing;
	exports.matchText = matchText;
	
	/***/ }),
	/* 56 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bold = function (_Inline) {
	  _inherits(Bold, _Inline);
	
	  function Bold() {
	    _classCallCheck(this, Bold);
	
	    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
	  }
	
	  _createClass(Bold, [{
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
	      if (this.domNode.tagName !== this.statics.tagName[0]) {
	        this.replaceWith(this.statics.blotName);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create() {
	      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      return true;
	    }
	  }]);
	
	  return Bold;
	}(_inline2.default);
	
	Bold.blotName = 'bold';
	Bold.tagName = ['STRONG', 'B'];
	
	exports.default = Bold;
	
	/***/ }),
	/* 57 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addControls = exports.default = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _quillDelta = __webpack_require__(2);
	
	var _quillDelta2 = _interopRequireDefault(_quillDelta);
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _logger = __webpack_require__(10);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var debug = (0, _logger2.default)('quill:toolbar');
	
	var Toolbar = function (_Module) {
	  _inherits(Toolbar, _Module);
	
	  function Toolbar(quill, options) {
	    _classCallCheck(this, Toolbar);
	
	    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));
	
	    if (Array.isArray(_this.options.container)) {
	      var container = document.createElement('div');
	      addControls(container, _this.options.container);
	      quill.container.parentNode.insertBefore(container, quill.container);
	      _this.container = container;
	    } else if (typeof _this.options.container === 'string') {
	      _this.container = document.querySelector(_this.options.container);
	    } else {
	      _this.container = _this.options.container;
	    }
	    if (!(_this.container instanceof HTMLElement)) {
	      var _ret;
	
	      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
	    }
	    _this.container.classList.add('ql-toolbar');
	    _this.controls = [];
	    _this.handlers = {};
	    Object.keys(_this.options.handlers).forEach(function (format) {
	      _this.addHandler(format, _this.options.handlers[format]);
	    });
	    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
	      _this.attach(input);
	    });
	    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
	      if (type === _quill2.default.events.SELECTION_CHANGE) {
	        _this.update(range);
	      }
	    });
	    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      var _this$quill$selection = _this.quill.selection.getRange(),
	          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
	          range = _this$quill$selection2[0]; // quill.getSelection triggers update
	
	
	      _this.update(range);
	    });
	    return _this;
	  }
	
	  _createClass(Toolbar, [{
	    key: 'addHandler',
	    value: function addHandler(format, handler) {
	      this.handlers[format] = handler;
	    }
	  }, {
	    key: 'attach',
	    value: function attach(input) {
	      var _this2 = this;
	
	      var format = [].find.call(input.classList, function (className) {
	        return className.indexOf('ql-') === 0;
	      });
	      if (!format) return;
	      format = format.slice('ql-'.length);
	      if (input.tagName === 'BUTTON') {
	        input.setAttribute('type', 'button');
	      }
	      if (this.handlers[format] == null) {
	        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
	          debug.warn('ignoring attaching to disabled format', format, input);
	          return;
	        }
	        if (_parchment2.default.query(format) == null) {
	          debug.warn('ignoring attaching to nonexistent format', format, input);
	          return;
	        }
	      }
	      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
	      input.addEventListener(eventName, function (e) {
	        var value = void 0;
	        if (input.tagName === 'SELECT') {
	          if (input.selectedIndex < 0) return;
	          var selected = input.options[input.selectedIndex];
	          if (selected.hasAttribute('selected')) {
	            value = false;
	          } else {
	            value = selected.value || false;
	          }
	        } else {
	          if (input.classList.contains('ql-active')) {
	            value = false;
	          } else {
	            value = input.value || !input.hasAttribute('value');
	          }
	          e.preventDefault();
	        }
	        _this2.quill.focus();
	
	        var _quill$selection$getR = _this2.quill.selection.getRange(),
	            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
	            range = _quill$selection$getR2[0];
	
	        if (_this2.handlers[format] != null) {
	          _this2.handlers[format].call(_this2, value);
	        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
	          value = prompt('Enter ' + format);
	          if (!value) return;
	          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
	        } else {
	          _this2.quill.format(format, value, _quill2.default.sources.USER);
	        }
	        _this2.update(range);
	      });
	      // TODO use weakmap
	      this.controls.push([format, input]);
	    }
	  }, {
	    key: 'update',
	    value: function update(range) {
	      var formats = range == null ? {} : this.quill.getFormat(range);
	      this.controls.forEach(function (pair) {
	        var _pair = _slicedToArray(pair, 2),
	            format = _pair[0],
	            input = _pair[1];
	
	        if (input.tagName === 'SELECT') {
	          var option = void 0;
	          if (range == null) {
	            option = null;
	          } else if (formats[format] == null) {
	            option = input.querySelector('option[selected]');
	          } else if (!Array.isArray(formats[format])) {
	            var value = formats[format];
	            if (typeof value === 'string') {
	              value = value.replace(/\"/g, '\\"');
	            }
	            option = input.querySelector('option[value="' + value + '"]');
	          }
	          if (option == null) {
	            input.value = ''; // TODO make configurable?
	            input.selectedIndex = -1;
	          } else {
	            option.selected = true;
	          }
	        } else {
	          if (range == null) {
	            input.classList.remove('ql-active');
	          } else if (input.hasAttribute('value')) {
	            // both being null should match (default values)
	            // '1' should match with 1 (headers)
	            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
	            input.classList.toggle('ql-active', isActive);
	          } else {
	            input.classList.toggle('ql-active', formats[format] != null);
	          }
	        }
	      });
	    }
	  }]);
	
	  return Toolbar;
	}(_module2.default);
	
	Toolbar.DEFAULTS = {};
	
	function addButton(container, format, value) {
	  var input = document.createElement('button');
	  input.setAttribute('type', 'button');
	  input.classList.add('ql-' + format);
	  if (value != null) {
	    input.value = value;
	  }
	  container.appendChild(input);
	}
	
	function addControls(container, groups) {
	  if (!Array.isArray(groups[0])) {
	    groups = [groups];
	  }
	  groups.forEach(function (controls) {
	    var group = document.createElement('span');
	    group.classList.add('ql-formats');
	    controls.forEach(function (control) {
	      if (typeof control === 'string') {
	        addButton(group, control);
	      } else {
	        var format = Object.keys(control)[0];
	        var value = control[format];
	        if (Array.isArray(value)) {
	          addSelect(group, format, value);
	        } else {
	          addButton(group, format, value);
	        }
	      }
	    });
	    container.appendChild(group);
	  });
	}
	
	function addSelect(container, format, values) {
	  var input = document.createElement('select');
	  input.classList.add('ql-' + format);
	  values.forEach(function (value) {
	    var option = document.createElement('option');
	    if (value !== false) {
	      option.setAttribute('value', value);
	    } else {
	      option.setAttribute('selected', 'selected');
	    }
	    input.appendChild(option);
	  });
	  container.appendChild(input);
	}
	
	Toolbar.DEFAULTS = {
	  container: null,
	  handlers: {
	    clean: function clean() {
	      var _this3 = this;
	
	      var range = this.quill.getSelection();
	      if (range == null) return;
	      if (range.length == 0) {
	        var formats = this.quill.getFormat();
	        Object.keys(formats).forEach(function (name) {
	          // Clean functionality in existing apps only clean inline formats
	          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
	            _this3.quill.format(name, false);
	          }
	        });
	      } else {
	        this.quill.removeFormat(range, _quill2.default.sources.USER);
	      }
	    },
	    direction: function direction(value) {
	      var align = this.quill.getFormat()['align'];
	      if (value === 'rtl' && align == null) {
	        this.quill.format('align', 'right', _quill2.default.sources.USER);
	      } else if (!value && align === 'right') {
	        this.quill.format('align', false, _quill2.default.sources.USER);
	      }
	      this.quill.format('direction', value, _quill2.default.sources.USER);
	    },
	    indent: function indent(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      var indent = parseInt(formats.indent || 0);
	      if (value === '+1' || value === '-1') {
	        var modifier = value === '+1' ? 1 : -1;
	        if (formats.direction === 'rtl') modifier *= -1;
	        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
	      }
	    },
	    link: function link(value) {
	      if (value === true) {
	        value = prompt('Enter link URL:');
	      }
	      this.quill.format('link', value, _quill2.default.sources.USER);
	    },
	    list: function list(value) {
	      var range = this.quill.getSelection();
	      var formats = this.quill.getFormat(range);
	      if (value === 'check') {
	        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
	          this.quill.format('list', false, _quill2.default.sources.USER);
	        } else {
	          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
	        }
	      } else {
	        this.quill.format('list', value, _quill2.default.sources.USER);
	      }
	    }
	  }
	};
	
	exports.default = Toolbar;
	exports.addControls = addControls;
	
	/***/ }),
	/* 58 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";
	
	/***/ }),
	/* 59 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorPicker = function (_Picker) {
	  _inherits(ColorPicker, _Picker);
	
	  function ColorPicker(select, label) {
	    _classCallCheck(this, ColorPicker);
	
	    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));
	
	    _this.label.innerHTML = label;
	    _this.container.classList.add('ql-color-picker');
	    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
	      item.classList.add('ql-primary');
	    });
	    return _this;
	  }
	
	  _createClass(ColorPicker, [{
	    key: 'buildItem',
	    value: function buildItem(option) {
	      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
	      item.style.backgroundColor = option.getAttribute('value') || '';
	      return item;
	    }
	  }, {
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      var colorLabel = this.label.querySelector('.ql-color-label');
	      var value = item ? item.getAttribute('data-value') || '' : '';
	      if (colorLabel) {
	        if (colorLabel.tagName === 'line') {
	          colorLabel.style.stroke = value;
	        } else {
	          colorLabel.style.fill = value;
	        }
	      }
	    }
	  }]);
	
	  return ColorPicker;
	}(_picker2.default);
	
	exports.default = ColorPicker;
	
	/***/ }),
	/* 60 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IconPicker = function (_Picker) {
	  _inherits(IconPicker, _Picker);
	
	  function IconPicker(select, icons) {
	    _classCallCheck(this, IconPicker);
	
	    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));
	
	    _this.container.classList.add('ql-icon-picker');
	    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
	      item.innerHTML = icons[item.getAttribute('data-value') || ''];
	    });
	    _this.defaultItem = _this.container.querySelector('.ql-selected');
	    _this.selectItem(_this.defaultItem);
	    return _this;
	  }
	
	  _createClass(IconPicker, [{
	    key: 'selectItem',
	    value: function selectItem(item, trigger) {
	      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
	      item = item || this.defaultItem;
	      this.label.innerHTML = item.innerHTML;
	    }
	  }]);
	
	  return IconPicker;
	}(_picker2.default);
	
	exports.default = IconPicker;
	
	/***/ }),
	/* 61 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Tooltip = function () {
	  function Tooltip(quill, boundsContainer) {
	    var _this = this;
	
	    _classCallCheck(this, Tooltip);
	
	    this.quill = quill;
	    this.boundsContainer = boundsContainer || document.body;
	    this.root = quill.addContainer('ql-tooltip');
	    this.root.innerHTML = this.constructor.TEMPLATE;
	    if (this.quill.root === this.quill.scrollingContainer) {
	      this.quill.root.addEventListener('scroll', function () {
	        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
	      });
	    }
	    this.hide();
	  }
	
	  _createClass(Tooltip, [{
	    key: 'hide',
	    value: function hide() {
	      this.root.classList.add('ql-hidden');
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
	      // root.scrollTop should be 0 if scrollContainer !== root
	      var top = reference.bottom + this.quill.root.scrollTop;
	      this.root.style.left = left + 'px';
	      this.root.style.top = top + 'px';
	      this.root.classList.remove('ql-flip');
	      var containerBounds = this.boundsContainer.getBoundingClientRect();
	      var rootBounds = this.root.getBoundingClientRect();
	      var shift = 0;
	      if (rootBounds.right > containerBounds.right) {
	        shift = containerBounds.right - rootBounds.right;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.left < containerBounds.left) {
	        shift = containerBounds.left - rootBounds.left;
	        this.root.style.left = left + shift + 'px';
	      }
	      if (rootBounds.bottom > containerBounds.bottom) {
	        var height = rootBounds.bottom - rootBounds.top;
	        var verticalShift = reference.bottom - reference.top + height;
	        this.root.style.top = top - verticalShift + 'px';
	        this.root.classList.add('ql-flip');
	      }
	      return shift;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      this.root.classList.remove('ql-editing');
	      this.root.classList.remove('ql-hidden');
	    }
	  }]);
	
	  return Tooltip;
	}();
	
	exports.default = Tooltip;
	
	/***/ }),
	/* 62 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _base = __webpack_require__(43);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _selection = __webpack_require__(15);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];
	
	var SnowTheme = function (_BaseTheme) {
	  _inherits(SnowTheme, _BaseTheme);
	
	  function SnowTheme(quill, options) {
	    _classCallCheck(this, SnowTheme);
	
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }
	
	    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));
	
	    _this.quill.container.classList.add('ql-snow');
	    return _this;
	  }
	
	  _createClass(SnowTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      toolbar.container.classList.add('ql-snow');
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
	      if (toolbar.container.querySelector('.ql-link')) {
	        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
	          toolbar.handlers['link'].call(toolbar, !context.format.link);
	        });
	      }
	    }
	  }]);
	
	  return SnowTheme;
	}(_base2.default);
	
	SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (value) {
	            var range = this.quill.getSelection();
	            if (range == null || range.length == 0) return;
	            var preview = this.quill.getText(range);
	            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
	              preview = 'mailto:' + preview;
	            }
	            var tooltip = this.quill.theme.tooltip;
	            tooltip.edit('link', preview);
	          } else {
	            this.quill.format('link', false);
	          }
	        }
	      }
	    }
	  }
	});
	
	var SnowTooltip = function (_BaseTooltip) {
	  _inherits(SnowTooltip, _BaseTooltip);
	
	  function SnowTooltip(quill, bounds) {
	    _classCallCheck(this, SnowTooltip);
	
	    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));
	
	    _this2.preview = _this2.root.querySelector('a.ql-preview');
	    return _this2;
	  }
	
	  _createClass(SnowTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;
	
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
	        if (_this3.root.classList.contains('ql-editing')) {
	          _this3.save();
	        } else {
	          _this3.edit('link', _this3.preview.textContent);
	        }
	        event.preventDefault();
	      });
	      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
	        if (_this3.linkRange != null) {
	          var range = _this3.linkRange;
	          _this3.restoreFocus();
	          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
	          delete _this3.linkRange;
	        }
	        event.preventDefault();
	        _this3.hide();
	      });
	      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
	        if (range == null) return;
	        if (range.length === 0 && source === _emitter2.default.sources.USER) {
	          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
	              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
	              link = _quill$scroll$descend2[0],
	              offset = _quill$scroll$descend2[1];
	
	          if (link != null) {
	            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
	            var preview = _link2.default.formats(link.domNode);
	            _this3.preview.textContent = preview;
	            _this3.preview.setAttribute('href', preview);
	            _this3.show();
	            _this3.position(_this3.quill.getBounds(_this3.linkRange));
	            return;
	          }
	        } else {
	          delete _this3.linkRange;
	        }
	        _this3.hide();
	      });
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
	      this.root.removeAttribute('data-mode');
	    }
	  }]);
	
	  return SnowTooltip;
	}(_base.BaseTooltip);
	
	SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');
	
	exports.default = SnowTheme;
	
	/***/ }),
	/* 63 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(29);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _align = __webpack_require__(36);
	
	var _direction = __webpack_require__(38);
	
	var _indent = __webpack_require__(64);
	
	var _blockquote = __webpack_require__(65);
	
	var _blockquote2 = _interopRequireDefault(_blockquote);
	
	var _header = __webpack_require__(66);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _list = __webpack_require__(67);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _background = __webpack_require__(37);
	
	var _color = __webpack_require__(26);
	
	var _font = __webpack_require__(39);
	
	var _size = __webpack_require__(40);
	
	var _bold = __webpack_require__(56);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	var _italic = __webpack_require__(68);
	
	var _italic2 = _interopRequireDefault(_italic);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _script = __webpack_require__(69);
	
	var _script2 = _interopRequireDefault(_script);
	
	var _strike = __webpack_require__(70);
	
	var _strike2 = _interopRequireDefault(_strike);
	
	var _underline = __webpack_require__(71);
	
	var _underline2 = _interopRequireDefault(_underline);
	
	var _image = __webpack_require__(72);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _video = __webpack_require__(73);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _formula = __webpack_require__(74);
	
	var _formula2 = _interopRequireDefault(_formula);
	
	var _syntax = __webpack_require__(75);
	
	var _syntax2 = _interopRequireDefault(_syntax);
	
	var _toolbar = __webpack_require__(57);
	
	var _toolbar2 = _interopRequireDefault(_toolbar);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	var _picker = __webpack_require__(28);
	
	var _picker2 = _interopRequireDefault(_picker);
	
	var _colorPicker = __webpack_require__(59);
	
	var _colorPicker2 = _interopRequireDefault(_colorPicker);
	
	var _iconPicker = __webpack_require__(60);
	
	var _iconPicker2 = _interopRequireDefault(_iconPicker);
	
	var _tooltip = __webpack_require__(61);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _bubble = __webpack_require__(108);
	
	var _bubble2 = _interopRequireDefault(_bubble);
	
	var _snow = __webpack_require__(62);
	
	var _snow2 = _interopRequireDefault(_snow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_core2.default.register({
	  'attributors/attribute/direction': _direction.DirectionAttribute,
	
	  'attributors/class/align': _align.AlignClass,
	  'attributors/class/background': _background.BackgroundClass,
	  'attributors/class/color': _color.ColorClass,
	  'attributors/class/direction': _direction.DirectionClass,
	  'attributors/class/font': _font.FontClass,
	  'attributors/class/size': _size.SizeClass,
	
	  'attributors/style/align': _align.AlignStyle,
	  'attributors/style/background': _background.BackgroundStyle,
	  'attributors/style/color': _color.ColorStyle,
	  'attributors/style/direction': _direction.DirectionStyle,
	  'attributors/style/font': _font.FontStyle,
	  'attributors/style/size': _size.SizeStyle
	}, true);
	
	_core2.default.register({
	  'formats/align': _align.AlignClass,
	  'formats/direction': _direction.DirectionClass,
	  'formats/indent': _indent.IndentClass,
	
	  'formats/background': _background.BackgroundStyle,
	  'formats/color': _color.ColorStyle,
	  'formats/font': _font.FontClass,
	  'formats/size': _size.SizeClass,
	
	  'formats/blockquote': _blockquote2.default,
	  'formats/code-block': _code2.default,
	  'formats/header': _header2.default,
	  'formats/list': _list2.default,
	
	  'formats/bold': _bold2.default,
	  'formats/code': _code.Code,
	  'formats/italic': _italic2.default,
	  'formats/link': _link2.default,
	  'formats/script': _script2.default,
	  'formats/strike': _strike2.default,
	  'formats/underline': _underline2.default,
	
	  'formats/image': _image2.default,
	  'formats/video': _video2.default,
	
	  'formats/list/item': _list.ListItem,
	
	  'modules/formula': _formula2.default,
	  'modules/syntax': _syntax2.default,
	  'modules/toolbar': _toolbar2.default,
	
	  'themes/bubble': _bubble2.default,
	  'themes/snow': _snow2.default,
	
	  'ui/icons': _icons2.default,
	  'ui/picker': _picker2.default,
	  'ui/icon-picker': _iconPicker2.default,
	  'ui/color-picker': _colorPicker2.default,
	  'ui/tooltip': _tooltip2.default
	}, true);
	
	exports.default = _core2.default;
	
	/***/ }),
	/* 64 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IndentClass = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IdentAttributor = function (_Parchment$Attributor) {
	  _inherits(IdentAttributor, _Parchment$Attributor);
	
	  function IdentAttributor() {
	    _classCallCheck(this, IdentAttributor);
	
	    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
	  }
	
	  _createClass(IdentAttributor, [{
	    key: 'add',
	    value: function add(node, value) {
	      if (value === '+1' || value === '-1') {
	        var indent = this.value(node) || 0;
	        value = value === '+1' ? indent + 1 : indent - 1;
	      }
	      if (value === 0) {
	        this.remove(node);
	        return true;
	      } else {
	        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
	      }
	    }
	  }, {
	    key: 'canAdd',
	    value: function canAdd(node, value) {
	      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
	    }
	  }, {
	    key: 'value',
	    value: function value(node) {
	      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
	    }
	  }]);
	
	  return IdentAttributor;
	}(_parchment2.default.Attributor.Class);
	
	var IndentClass = new IdentAttributor('indent', 'ql-indent', {
	  scope: _parchment2.default.Scope.BLOCK,
	  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
	});
	
	exports.IndentClass = IndentClass;
	
	/***/ }),
	/* 65 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Blockquote = function (_Block) {
	  _inherits(Blockquote, _Block);
	
	  function Blockquote() {
	    _classCallCheck(this, Blockquote);
	
	    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
	  }
	
	  return Blockquote;
	}(_block2.default);
	
	Blockquote.blotName = 'blockquote';
	Blockquote.tagName = 'blockquote';
	
	exports.default = Blockquote;
	
	/***/ }),
	/* 66 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Block) {
	  _inherits(Header, _Block);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	  }
	
	  _createClass(Header, null, [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return this.tagName.indexOf(domNode.tagName) + 1;
	    }
	  }]);
	
	  return Header;
	}(_block2.default);
	
	Header.blotName = 'header';
	Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
	
	exports.default = Header;
	
	/***/ }),
	/* 67 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ListItem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _block = __webpack_require__(4);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _container = __webpack_require__(25);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ListItem = function (_Block) {
	  _inherits(ListItem, _Block);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
	  }
	
	  _createClass(ListItem, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (name === List.blotName && !value) {
	        this.replaceWith(_parchment2.default.create(this.statics.scope));
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }, {
	    key: 'remove',
	    value: function remove() {
	      if (this.prev == null && this.next == null) {
	        this.parent.remove();
	      } else {
	        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
	      }
	    }
	  }, {
	    key: 'replaceWith',
	    value: function replaceWith(name, value) {
	      this.parent.isolate(this.offset(this.parent), this.length());
	      if (name === this.parent.statics.blotName) {
	        this.parent.replaceWith(name, value);
	        return this;
	      } else {
	        this.parent.unwrap();
	        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'formats',
	    value: function formats(domNode) {
	      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
	    }
	  }]);
	
	  return ListItem;
	}(_block2.default);
	
	ListItem.blotName = 'list-item';
	ListItem.tagName = 'LI';
	
	var List = function (_Container) {
	  _inherits(List, _Container);
	
	  _createClass(List, null, [{
	    key: 'create',
	    value: function create(value) {
	      var tagName = value === 'ordered' ? 'OL' : 'UL';
	      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
	      if (value === 'checked' || value === 'unchecked') {
	        node.setAttribute('data-checked', value === 'checked');
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'OL') return 'ordered';
	      if (domNode.tagName === 'UL') {
	        if (domNode.hasAttribute('data-checked')) {
	          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
	        } else {
	          return 'bullet';
	        }
	      }
	      return undefined;
	    }
	  }]);
	
	  function List(domNode) {
	    _classCallCheck(this, List);
	
	    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));
	
	    var listEventHandler = function listEventHandler(e) {
	      if (e.target.parentNode !== domNode) return;
	      var format = _this2.statics.formats(domNode);
	      var blot = _parchment2.default.find(e.target);
	      if (format === 'checked') {
	        blot.format('list', 'unchecked');
	      } else if (format === 'unchecked') {
	        blot.format('list', 'checked');
	      }
	    };
	
	    domNode.addEventListener('touchstart', listEventHandler);
	    domNode.addEventListener('mousedown', listEventHandler);
	    return _this2;
	  }
	
	  _createClass(List, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (this.children.length > 0) {
	        this.children.tail.format(name, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats() {
	      // We don't inherit from FormatBlot
	      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
	    }
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(blot, ref) {
	      if (blot instanceof ListItem) {
	        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
	      } else {
	        var index = ref == null ? this.length() : ref.offset(this);
	        var after = this.split(index);
	        after.parent.insertBefore(blot, after);
	      }
	    }
	  }, {
	    key: 'optimize',
	    value: function optimize(context) {
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
	      var next = this.next;
	      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
	        next.moveChildren(this);
	        next.remove();
	      }
	    }
	  }, {
	    key: 'replace',
	    value: function replace(target) {
	      if (target.statics.blotName !== this.statics.blotName) {
	        var item = _parchment2.default.create(this.statics.defaultChild);
	        target.moveChildren(item);
	        this.appendChild(item);
	      }
	      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
	    }
	  }]);
	
	  return List;
	}(_container2.default);
	
	List.blotName = 'list';
	List.scope = _parchment2.default.Scope.BLOCK_BLOT;
	List.tagName = ['OL', 'UL'];
	List.defaultChild = 'list-item';
	List.allowedChildren = [ListItem];
	
	exports.ListItem = ListItem;
	exports.default = List;
	
	/***/ }),
	/* 68 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bold = __webpack_require__(56);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Italic = function (_Bold) {
	  _inherits(Italic, _Bold);
	
	  function Italic() {
	    _classCallCheck(this, Italic);
	
	    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
	  }
	
	  return Italic;
	}(_bold2.default);
	
	Italic.blotName = 'italic';
	Italic.tagName = ['EM', 'I'];
	
	exports.default = Italic;
	
	/***/ }),
	/* 69 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Script = function (_Inline) {
	  _inherits(Script, _Inline);
	
	  function Script() {
	    _classCallCheck(this, Script);
	
	    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
	  }
	
	  _createClass(Script, null, [{
	    key: 'create',
	    value: function create(value) {
	      if (value === 'super') {
	        return document.createElement('sup');
	      } else if (value === 'sub') {
	        return document.createElement('sub');
	      } else {
	        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
	      }
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      if (domNode.tagName === 'SUB') return 'sub';
	      if (domNode.tagName === 'SUP') return 'super';
	      return undefined;
	    }
	  }]);
	
	  return Script;
	}(_inline2.default);
	
	Script.blotName = 'script';
	Script.tagName = ['SUB', 'SUP'];
	
	exports.default = Script;
	
	/***/ }),
	/* 70 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Strike = function (_Inline) {
	  _inherits(Strike, _Inline);
	
	  function Strike() {
	    _classCallCheck(this, Strike);
	
	    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
	  }
	
	  return Strike;
	}(_inline2.default);
	
	Strike.blotName = 'strike';
	Strike.tagName = 'S';
	
	exports.default = Strike;
	
	/***/ }),
	/* 71 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inline = __webpack_require__(6);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Underline = function (_Inline) {
	  _inherits(Underline, _Inline);
	
	  function Underline() {
	    _classCallCheck(this, Underline);
	
	    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
	  }
	
	  return Underline;
	}(_inline2.default);
	
	Underline.blotName = 'underline';
	Underline.tagName = 'U';
	
	exports.default = Underline;
	
	/***/ }),
	/* 72 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _link = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['alt', 'height', 'width'];
	
	var Image = function (_Parchment$Embed) {
	  _inherits(Image, _Parchment$Embed);
	
	  function Image() {
	    _classCallCheck(this, Image);
	
	    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
	  }
	
	  _createClass(Image, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        node.setAttribute('src', this.sanitize(value));
	      }
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'match',
	    value: function match(url) {
	      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
	      );
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);
	
	  return Image;
	}(_parchment2.default.Embed);
	
	Image.blotName = 'image';
	Image.tagName = 'IMG';
	
	exports.default = Image;
	
	/***/ }),
	/* 73 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _block = __webpack_require__(4);
	
	var _link = __webpack_require__(27);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['height', 'width'];
	
	var Video = function (_BlockEmbed) {
	  _inherits(Video, _BlockEmbed);
	
	  function Video() {
	    _classCallCheck(this, Video);
	
	    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
	  }
	
	  _createClass(Video, [{
	    key: 'format',
	    value: function format(name, value) {
	      if (ATTRIBUTES.indexOf(name) > -1) {
	        if (value) {
	          this.domNode.setAttribute(name, value);
	        } else {
	          this.domNode.removeAttribute(name);
	        }
	      } else {
	        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
	      }
	    }
	  }], [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
	      node.setAttribute('frameborder', '0');
	      node.setAttribute('allowfullscreen', true);
	      node.setAttribute('src', this.sanitize(value));
	      return node;
	    }
	  }, {
	    key: 'formats',
	    value: function formats(domNode) {
	      return ATTRIBUTES.reduce(function (formats, attribute) {
	        if (domNode.hasAttribute(attribute)) {
	          formats[attribute] = domNode.getAttribute(attribute);
	        }
	        return formats;
	      }, {});
	    }
	  }, {
	    key: 'sanitize',
	    value: function sanitize(url) {
	      return _link2.default.sanitize(url);
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('src');
	    }
	  }]);
	
	  return Video;
	}(_block.BlockEmbed);
	
	Video.blotName = 'video';
	Video.className = 'ql-video';
	Video.tagName = 'IFRAME';
	
	exports.default = Video;
	
	/***/ }),
	/* 74 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.FormulaBlot = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _embed = __webpack_require__(35);
	
	var _embed2 = _interopRequireDefault(_embed);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormulaBlot = function (_Embed) {
	  _inherits(FormulaBlot, _Embed);
	
	  function FormulaBlot() {
	    _classCallCheck(this, FormulaBlot);
	
	    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
	  }
	
	  _createClass(FormulaBlot, null, [{
	    key: 'create',
	    value: function create(value) {
	      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
	      if (typeof value === 'string') {
	        window.katex.render(value, node, {
	          throwOnError: false,
	          errorColor: '#f00'
	        });
	        node.setAttribute('data-value', value);
	      }
	      return node;
	    }
	  }, {
	    key: 'value',
	    value: function value(domNode) {
	      return domNode.getAttribute('data-value');
	    }
	  }]);
	
	  return FormulaBlot;
	}(_embed2.default);
	
	FormulaBlot.blotName = 'formula';
	FormulaBlot.className = 'ql-formula';
	FormulaBlot.tagName = 'SPAN';
	
	var Formula = function (_Module) {
	  _inherits(Formula, _Module);
	
	  _createClass(Formula, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(FormulaBlot, true);
	    }
	  }]);
	
	  function Formula() {
	    _classCallCheck(this, Formula);
	
	    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));
	
	    if (window.katex == null) {
	      throw new Error('Formula module requires KaTeX.');
	    }
	    return _this2;
	  }
	
	  return Formula;
	}(_module2.default);
	
	exports.FormulaBlot = FormulaBlot;
	exports.default = Formula;
	
	/***/ }),
	/* 75 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CodeToken = exports.CodeBlock = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _parchment = __webpack_require__(0);
	
	var _parchment2 = _interopRequireDefault(_parchment);
	
	var _quill = __webpack_require__(5);
	
	var _quill2 = _interopRequireDefault(_quill);
	
	var _module = __webpack_require__(9);
	
	var _module2 = _interopRequireDefault(_module);
	
	var _code = __webpack_require__(13);
	
	var _code2 = _interopRequireDefault(_code);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SyntaxCodeBlock = function (_CodeBlock) {
	  _inherits(SyntaxCodeBlock, _CodeBlock);
	
	  function SyntaxCodeBlock() {
	    _classCallCheck(this, SyntaxCodeBlock);
	
	    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
	  }
	
	  _createClass(SyntaxCodeBlock, [{
	    key: 'replaceWith',
	    value: function replaceWith(block) {
	      this.domNode.textContent = this.domNode.textContent;
	      this.attach();
	      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(_highlight) {
	      var text = this.domNode.textContent;
	      if (this.cachedText !== text) {
	        if (text.trim().length > 0 || this.cachedText == null) {
	          this.domNode.innerHTML = _highlight(text);
	          this.domNode.normalize();
	          this.attach();
	        }
	        this.cachedText = text;
	      }
	    }
	  }]);
	
	  return SyntaxCodeBlock;
	}(_code2.default);
	
	SyntaxCodeBlock.className = 'ql-syntax';
	
	var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
	  scope: _parchment2.default.Scope.INLINE
	});
	
	var Syntax = function (_Module) {
	  _inherits(Syntax, _Module);
	
	  _createClass(Syntax, null, [{
	    key: 'register',
	    value: function register() {
	      _quill2.default.register(CodeToken, true);
	      _quill2.default.register(SyntaxCodeBlock, true);
	    }
	  }]);
	
	  function Syntax(quill, options) {
	    _classCallCheck(this, Syntax);
	
	    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));
	
	    if (typeof _this2.options.highlight !== 'function') {
	      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
	    }
	    var timer = null;
	    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
	      clearTimeout(timer);
	      timer = setTimeout(function () {
	        _this2.highlight();
	        timer = null;
	      }, _this2.options.interval);
	    });
	    _this2.highlight();
	    return _this2;
	  }
	
	  _createClass(Syntax, [{
	    key: 'highlight',
	    value: function highlight() {
	      var _this3 = this;
	
	      if (this.quill.selection.composing) return;
	      this.quill.update(_quill2.default.sources.USER);
	      var range = this.quill.getSelection();
	      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
	        code.highlight(_this3.options.highlight);
	      });
	      this.quill.update(_quill2.default.sources.SILENT);
	      if (range != null) {
	        this.quill.setSelection(range, _quill2.default.sources.SILENT);
	      }
	    }
	  }]);
	
	  return Syntax;
	}(_module2.default);
	
	Syntax.DEFAULTS = {
	  highlight: function () {
	    if (window.hljs == null) return null;
	    return function (text) {
	      var result = window.hljs.highlightAuto(text);
	      return result.value;
	    };
	  }(),
	  interval: 1000
	};
	
	exports.CodeBlock = SyntaxCodeBlock;
	exports.CodeToken = CodeToken;
	exports.default = Syntax;
	
	/***/ }),
	/* 76 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 77 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 78 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 79 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";
	
	/***/ }),
	/* 80 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";
	
	/***/ }),
	/* 81 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";
	
	/***/ }),
	/* 82 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";
	
	/***/ }),
	/* 83 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";
	
	/***/ }),
	/* 84 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";
	
	/***/ }),
	/* 85 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";
	
	/***/ }),
	/* 86 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";
	
	/***/ }),
	/* 87 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 88 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 89 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";
	
	/***/ }),
	/* 90 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";
	
	/***/ }),
	/* 91 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";
	
	/***/ }),
	/* 92 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";
	
	/***/ }),
	/* 93 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";
	
	/***/ }),
	/* 94 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";
	
	/***/ }),
	/* 95 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";
	
	/***/ }),
	/* 96 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";
	
	/***/ }),
	/* 97 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";
	
	/***/ }),
	/* 98 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";
	
	/***/ }),
	/* 99 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";
	
	/***/ }),
	/* 100 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";
	
	/***/ }),
	/* 101 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";
	
	/***/ }),
	/* 102 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";
	
	/***/ }),
	/* 103 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";
	
	/***/ }),
	/* 104 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";
	
	/***/ }),
	/* 105 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";
	
	/***/ }),
	/* 106 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";
	
	/***/ }),
	/* 107 */
	/***/ (function(module, exports) {
	
	module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";
	
	/***/ }),
	/* 108 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BubbleTooltip = undefined;
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extend = __webpack_require__(3);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _emitter = __webpack_require__(8);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _base = __webpack_require__(43);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _selection = __webpack_require__(15);
	
	var _icons = __webpack_require__(41);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];
	
	var BubbleTheme = function (_BaseTheme) {
	  _inherits(BubbleTheme, _BaseTheme);
	
	  function BubbleTheme(quill, options) {
	    _classCallCheck(this, BubbleTheme);
	
	    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
	      options.modules.toolbar.container = TOOLBAR_CONFIG;
	    }
	
	    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));
	
	    _this.quill.container.classList.add('ql-bubble');
	    return _this;
	  }
	
	  _createClass(BubbleTheme, [{
	    key: 'extendToolbar',
	    value: function extendToolbar(toolbar) {
	      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
	      this.tooltip.root.appendChild(toolbar.container);
	      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
	      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
	    }
	  }]);
	
	  return BubbleTheme;
	}(_base2.default);
	
	BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
	  modules: {
	    toolbar: {
	      handlers: {
	        link: function link(value) {
	          if (!value) {
	            this.quill.format('link', false);
	          } else {
	            this.quill.theme.tooltip.edit();
	          }
	        }
	      }
	    }
	  }
	});
	
	var BubbleTooltip = function (_BaseTooltip) {
	  _inherits(BubbleTooltip, _BaseTooltip);
	
	  function BubbleTooltip(quill, bounds) {
	    _classCallCheck(this, BubbleTooltip);
	
	    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));
	
	    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
	      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
	      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
	        _this2.show();
	        // Lock our width so we will expand beyond our offsetParent boundaries
	        _this2.root.style.left = '0px';
	        _this2.root.style.width = '';
	        _this2.root.style.width = _this2.root.offsetWidth + 'px';
	        var lines = _this2.quill.getLines(range.index, range.length);
	        if (lines.length === 1) {
	          _this2.position(_this2.quill.getBounds(range));
	        } else {
	          var lastLine = lines[lines.length - 1];
	          var index = _this2.quill.getIndex(lastLine);
	          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
	          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
	          _this2.position(_bounds);
	        }
	      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
	        _this2.hide();
	      }
	    });
	    return _this2;
	  }
	
	  _createClass(BubbleTooltip, [{
	    key: 'listen',
	    value: function listen() {
	      var _this3 = this;
	
	      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
	      this.root.querySelector('.ql-close').addEventListener('click', function () {
	        _this3.root.classList.remove('ql-editing');
	      });
	      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
	        // Let selection be restored by toolbar handlers before repositioning
	        setTimeout(function () {
	          if (_this3.root.classList.contains('ql-hidden')) return;
	          var range = _this3.quill.getSelection();
	          if (range != null) {
	            _this3.position(_this3.quill.getBounds(range));
	          }
	        }, 1);
	      });
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this.show();
	    }
	  }, {
	    key: 'position',
	    value: function position(reference) {
	      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
	      var arrow = this.root.querySelector('.ql-tooltip-arrow');
	      arrow.style.marginLeft = '';
	      if (shift === 0) return shift;
	      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
	    }
	  }]);
	
	  return BubbleTooltip;
	}(_base.BaseTooltip);
	
	BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');
	
	exports.BubbleTooltip = BubbleTooltip;
	exports.default = BubbleTheme;
	
	/***/ }),
	/* 109 */
	/***/ (function(module, exports, __webpack_require__) {
	
	module.exports = __webpack_require__(63);
	
	
	/***/ })
	/******/ ])["default"];
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(937).Buffer))

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof3 = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	exports.genCSSMotion = genCSSMotion;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _classnames = _interopRequireDefault(__webpack_require__(38));
	var _findDOMNode = _interopRequireDefault(__webpack_require__(489));
	var _ref2 = __webpack_require__(124);
	var React = _interopRequireWildcard(__webpack_require__(2));
	var _context = __webpack_require__(480);
	var _DomWrapper = _interopRequireDefault(__webpack_require__(1104));
	var _useStatus3 = _interopRequireDefault(__webpack_require__(1107));
	var _useStepQueue = __webpack_require__(482);
	var _interface = __webpack_require__(184);
	var _motion = __webpack_require__(185);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */
	
	/**
	 * `transitionSupport` is used for none transition test case.
	 * Default we use browser transition event support check.
	 */
	function genCSSMotion(config) {
	  var transitionSupport = config;
	  if ((0, _typeof2.default)(config) === 'object') {
	    transitionSupport = config.transitionSupport;
	  }
	  function isSupportTransition(props, contextMotion) {
	    return !!(props.motionName && transitionSupport && contextMotion !== false);
	  }
	  var CSSMotion = /*#__PURE__*/React.forwardRef(function (props, ref) {
	    var _props$visible = props.visible,
	      visible = _props$visible === void 0 ? true : _props$visible,
	      _props$removeOnLeave = props.removeOnLeave,
	      removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave,
	      forceRender = props.forceRender,
	      children = props.children,
	      motionName = props.motionName,
	      leavedClassName = props.leavedClassName,
	      eventProps = props.eventProps;
	    var _React$useContext = React.useContext(_context.Context),
	      contextMotion = _React$useContext.motion;
	    var supportMotion = isSupportTransition(props, contextMotion);
	
	    // Ref to the react node, it may be a HTMLElement
	    var nodeRef = (0, React.useRef)();
	    // Ref to the dom wrapper in case ref can not pass to HTMLElement
	    var wrapperNodeRef = (0, React.useRef)();
	    function getDomElement() {
	      try {
	        // Here we're avoiding call for findDOMNode since it's deprecated
	        // in strict mode. We're calling it only when node ref is not
	        // an instance of DOM HTMLElement. Otherwise use
	        // findDOMNode as a final resort
	        return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, _findDOMNode.default)(wrapperNodeRef.current);
	      } catch (e) {
	        // Only happen when `motionDeadline` trigger but element removed.
	        return null;
	      }
	    }
	    var _useStatus = (0, _useStatus3.default)(supportMotion, visible, getDomElement, props),
	      _useStatus2 = (0, _slicedToArray2.default)(_useStatus, 4),
	      status = _useStatus2[0],
	      statusStep = _useStatus2[1],
	      statusStyle = _useStatus2[2],
	      mergedVisible = _useStatus2[3];
	
	    // Record whether content has rendered
	    // Will return null for un-rendered even when `removeOnLeave={false}`
	    var renderedRef = React.useRef(mergedVisible);
	    if (mergedVisible) {
	      renderedRef.current = true;
	    }
	
	    // ====================== Refs ======================
	    var setNodeRef = React.useCallback(function (node) {
	      nodeRef.current = node;
	      (0, _ref2.fillRef)(ref, node);
	    }, [ref]);
	
	    // ===================== Render =====================
	    var motionChildren;
	    var mergedProps = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, eventProps), {}, {
	      visible: visible
	    });
	    if (!children) {
	      // No children
	      motionChildren = null;
	    } else if (status === _interface.STATUS_NONE) {
	      // Stable children
	      if (mergedVisible) {
	        motionChildren = children((0, _objectSpread2.default)({}, mergedProps), setNodeRef);
	      } else if (!removeOnLeave && renderedRef.current && leavedClassName) {
	        motionChildren = children((0, _objectSpread2.default)((0, _objectSpread2.default)({}, mergedProps), {}, {
	          className: leavedClassName
	        }), setNodeRef);
	      } else if (forceRender || !removeOnLeave && !leavedClassName) {
	        motionChildren = children((0, _objectSpread2.default)((0, _objectSpread2.default)({}, mergedProps), {}, {
	          style: {
	            display: 'none'
	          }
	        }), setNodeRef);
	      } else {
	        motionChildren = null;
	      }
	    } else {
	      var _classNames;
	      // In motion
	      var statusSuffix;
	      if (statusStep === _interface.STEP_PREPARE) {
	        statusSuffix = 'prepare';
	      } else if ((0, _useStepQueue.isActive)(statusStep)) {
	        statusSuffix = 'active';
	      } else if (statusStep === _interface.STEP_START) {
	        statusSuffix = 'start';
	      }
	      var motionCls = (0, _motion.getTransitionName)(motionName, "".concat(status, "-").concat(statusSuffix));
	      motionChildren = children((0, _objectSpread2.default)((0, _objectSpread2.default)({}, mergedProps), {}, {
	        className: (0, _classnames.default)((0, _motion.getTransitionName)(motionName, status), (_classNames = {}, (0, _defineProperty2.default)(_classNames, motionCls, motionCls && statusSuffix), (0, _defineProperty2.default)(_classNames, motionName, typeof motionName === 'string'), _classNames)),
	        style: statusStyle
	      }), setNodeRef);
	    }
	
	    // Auto inject ref if child node not have `ref` props
	    if ( /*#__PURE__*/React.isValidElement(motionChildren) && (0, _ref2.supportRef)(motionChildren)) {
	      var _ref = motionChildren,
	        originNodeRef = _ref.ref;
	      if (!originNodeRef) {
	        motionChildren = /*#__PURE__*/React.cloneElement(motionChildren, {
	          ref: setNodeRef
	        });
	      }
	    }
	    return /*#__PURE__*/React.createElement(_DomWrapper.default, {
	      ref: wrapperNodeRef
	    }, motionChildren);
	  });
	  CSSMotion.displayName = 'CSSMotion';
	  return CSSMotion;
	}
	var _default = genCSSMotion(_motion.supportTransition);
	exports.default = _default;

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Context = void 0;
	exports.default = MotionProvider;
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(44));
	var React = _interopRequireWildcard(__webpack_require__(2));
	var _excluded = ["children"];
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var Context = /*#__PURE__*/React.createContext({});
	exports.Context = Context;
	function MotionProvider(_ref) {
	  var children = _ref.children,
	    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
	  return /*#__PURE__*/React.createElement(Context.Provider, {
	    value: props
	  }, children);
	}

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _canUseDom = _interopRequireDefault(__webpack_require__(122));
	var _react = __webpack_require__(2);
	// It's safe to use `useLayoutEffect` but the warning is annoying
	var useIsomorphicLayoutEffect = (0, _canUseDom.default)() ? _react.useLayoutEffect : _react.useEffect;
	var _default = useIsomorphicLayoutEffect;
	exports.default = _default;

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.SkipStep = exports.DoStep = void 0;
	exports.isActive = isActive;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _useState3 = _interopRequireDefault(__webpack_require__(188));
	var React = _interopRequireWildcard(__webpack_require__(2));
	var _interface = __webpack_require__(184);
	var _useIsomorphicLayoutEffect = _interopRequireDefault(__webpack_require__(481));
	var _useNextFrame3 = _interopRequireDefault(__webpack_require__(1106));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var FULL_STEP_QUEUE = [_interface.STEP_PREPARE, _interface.STEP_START, _interface.STEP_ACTIVE, _interface.STEP_ACTIVATED];
	var SIMPLE_STEP_QUEUE = [_interface.STEP_PREPARE, _interface.STEP_PREPARED];
	
	/** Skip current step */
	var SkipStep = false;
	/** Current step should be update in */
	exports.SkipStep = SkipStep;
	var DoStep = true;
	exports.DoStep = DoStep;
	function isActive(step) {
	  return step === _interface.STEP_ACTIVE || step === _interface.STEP_ACTIVATED;
	}
	var _default = function _default(status, prepareOnly, callback) {
	  var _useState = (0, _useState3.default)(_interface.STEP_NONE),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    step = _useState2[0],
	    setStep = _useState2[1];
	  var _useNextFrame = (0, _useNextFrame3.default)(),
	    _useNextFrame2 = (0, _slicedToArray2.default)(_useNextFrame, 2),
	    nextFrame = _useNextFrame2[0],
	    cancelNextFrame = _useNextFrame2[1];
	  function startQueue() {
	    setStep(_interface.STEP_PREPARE, true);
	  }
	  var STEP_QUEUE = prepareOnly ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
	  (0, _useIsomorphicLayoutEffect.default)(function () {
	    if (step !== _interface.STEP_NONE && step !== _interface.STEP_ACTIVATED) {
	      var index = STEP_QUEUE.indexOf(step);
	      var nextStep = STEP_QUEUE[index + 1];
	      var result = callback(step);
	      if (result === SkipStep) {
	        // Skip when no needed
	        setStep(nextStep, true);
	      } else if (nextStep) {
	        // Do as frame for step update
	        nextFrame(function (info) {
	          function doNext() {
	            // Skip since current queue is ood
	            if (info.isCanceled()) return;
	            setStep(nextStep, true);
	          }
	          if (result === true) {
	            doNext();
	          } else {
	            // Only promise should be async
	            Promise.resolve(result).then(doNext);
	          }
	        });
	      }
	    }
	  }, [status, step]);
	  React.useEffect(function () {
	    return function () {
	      cancelNextFrame();
	    };
	  }, []);
	  return [startQueue, step];
	};
	exports.default = _default;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(42));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _rcTooltip = _interopRequireDefault(__webpack_require__(1116));
	
	var _ref = __webpack_require__(124);
	
	var _raf = _interopRequireDefault(__webpack_require__(123));
	
	var SliderTooltip = /*#__PURE__*/React.forwardRef(function (props, ref) {
	  var visible = props.visible,
	      overlay = props.overlay;
	  var innerRef = React.useRef(null);
	  var tooltipRef = (0, _ref.composeRef)(ref, innerRef);
	  var rafRef = React.useRef(null);
	
	  function cancelKeepAlign() {
	    _raf.default.cancel(rafRef.current);
	  }
	
	  function keepAlign() {
	    rafRef.current = (0, _raf.default)(function () {
	      var _innerRef$current;
	
	      (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.forcePopupAlign();
	    });
	  }
	
	  React.useEffect(function () {
	    if (visible) {
	      keepAlign();
	    } else {
	      cancelKeepAlign();
	    }
	
	    return cancelKeepAlign;
	  }, [visible, overlay]);
	  return /*#__PURE__*/React.createElement(_rcTooltip.default, (0, _extends2.default)({
	    ref: tooltipRef
	  }, props));
	});
	var _default = SliderTooltip;
	exports.default = _default;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var Track = function Track(props) {
	  var _ref, _ref2;
	
	  var className = props.className,
	      included = props.included,
	      vertical = props.vertical,
	      style = props.style;
	  var length = props.length,
	      offset = props.offset,
	      reverse = props.reverse;
	
	  if (length < 0) {
	    reverse = !reverse;
	    length = Math.abs(length);
	    offset = 100 - offset;
	  }
	
	  var positonStyle = vertical ? (_ref = {}, (0, _defineProperty2.default)(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), (0, _defineProperty2.default)(_ref, reverse ? 'bottom' : 'top', 'auto'), (0, _defineProperty2.default)(_ref, "height", "".concat(length, "%")), _ref) : (_ref2 = {}, (0, _defineProperty2.default)(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), (0, _defineProperty2.default)(_ref2, reverse ? 'left' : 'right', 'auto'), (0, _defineProperty2.default)(_ref2, "width", "".concat(length, "%")), _ref2);
	  var elStyle = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, style), positonStyle);
	  return included ? /*#__PURE__*/_react.default.createElement("div", {
	    className: className,
	    style: elStyle
	  }) : null;
	};
	
	var _default = Track;
	exports.default = _default;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSlider;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(42));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(44));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _get2 = _interopRequireDefault(__webpack_require__(527));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(121));
	
	var _classnames = _interopRequireDefault(__webpack_require__(38));
	
	var _warning = _interopRequireDefault(__webpack_require__(125));
	
	var _Steps = _interopRequireDefault(__webpack_require__(1112));
	
	var _Marks = _interopRequireDefault(__webpack_require__(1111));
	
	var _Handle = _interopRequireDefault(__webpack_require__(186));
	
	var utils = _interopRequireWildcard(__webpack_require__(187));
	
	/* eslint-disable @typescript-eslint/no-explicit-any */
	function noop() {}
	
	function createSlider(Component) {
	  var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
	
	
	  return _a = /*#__PURE__*/function (_Component) {
	    (0, _inherits2.default)(ComponentEnhancer, _Component);
	
	    var _super = (0, _createSuper2.default)(ComponentEnhancer);
	
	    function ComponentEnhancer(props) {
	      var _this;
	
	      (0, _classCallCheck2.default)(this, ComponentEnhancer);
	      _this = _super.call(this, props);
	
	      _this.onDown = function (e, position) {
	        var p = position;
	        var _this$props = _this.props,
	            draggableTrack = _this$props.draggableTrack,
	            isVertical = _this$props.vertical;
	        var bounds = _this.state.bounds;
	        var value = draggableTrack && _this.positionGetValue ? _this.positionGetValue(p) || [] : [];
	        var inPoint = utils.isEventFromHandle(e, _this.handlesRefs);
	        _this.dragTrack = draggableTrack && bounds.length >= 2 && !inPoint && !value.map(function (n, i) {
	          var v = !i ? n >= bounds[i] : true;
	          return i === value.length - 1 ? n <= bounds[i] : v;
	        }).some(function (c) {
	          return !c;
	        });
	
	        if (_this.dragTrack) {
	          _this.dragOffset = p;
	          _this.startBounds = (0, _toConsumableArray2.default)(bounds);
	        } else {
	          if (!inPoint) {
	            _this.dragOffset = 0;
	          } else {
	            var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
	            _this.dragOffset = p - handlePosition;
	            p = handlePosition;
	          }
	
	          _this.onStart(p);
	        }
	      };
	
	      _this.onMouseDown = function (e) {
	        if (e.button !== 0) {
	          return;
	        }
	
	        _this.removeDocumentEvents();
	
	        var isVertical = _this.props.vertical;
	        var position = utils.getMousePosition(isVertical, e);
	
	        _this.onDown(e, position);
	
	        _this.addDocumentMouseEvents();
	      };
	
	      _this.onTouchStart = function (e) {
	        if (utils.isNotTouchEvent(e)) return;
	        var isVertical = _this.props.vertical;
	        var position = utils.getTouchPosition(isVertical, e);
	
	        _this.onDown(e, position);
	
	        _this.addDocumentTouchEvents();
	
	        utils.pauseEvent(e);
	      };
	
	      _this.onFocus = function (e) {
	        var _this$props2 = _this.props,
	            onFocus = _this$props2.onFocus,
	            vertical = _this$props2.vertical;
	
	        if (utils.isEventFromHandle(e, _this.handlesRefs) && !_this.dragTrack) {
	          var handlePosition = utils.getHandleCenterPosition(vertical, e.target);
	          _this.dragOffset = 0;
	
	          _this.onStart(handlePosition);
	
	          utils.pauseEvent(e);
	
	          if (onFocus) {
	            onFocus(e);
	          }
	        }
	      };
	
	      _this.onBlur = function (e) {
	        var onBlur = _this.props.onBlur;
	
	        if (!_this.dragTrack) {
	          _this.onEnd();
	        }
	
	        if (onBlur) {
	          onBlur(e);
	        }
	      };
	
	      _this.onMouseUp = function () {
	        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
	          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
	        }
	      };
	
	      _this.onMouseMove = function (e) {
	        if (!_this.sliderRef) {
	          _this.onEnd();
	
	          return;
	        }
	
	        var position = utils.getMousePosition(_this.props.vertical, e);
	
	        _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
	      };
	
	      _this.onTouchMove = function (e) {
	        if (utils.isNotTouchEvent(e) || !_this.sliderRef) {
	          _this.onEnd();
	
	          return;
	        }
	
	        var position = utils.getTouchPosition(_this.props.vertical, e);
	
	        _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
	      };
	
	      _this.onKeyDown = function (e) {
	        if (_this.sliderRef && utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.onKeyboard(e);
	        }
	      };
	
	      _this.onClickMarkLabel = function (e, value) {
	        e.stopPropagation();
	
	        _this.onChange({
	          value: value
	        }); // eslint-disable-next-line react/no-unused-state
	
	
	        _this.setState({
	          value: value
	        }, function () {
	          return _this.onEnd(true);
	        });
	      };
	
	      _this.saveSlider = function (slider) {
	        _this.sliderRef = slider;
	      };
	
	      var step = props.step,
	          max = props.max,
	          min = props.min;
	      var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
	
	      (0, _warning.default)(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (".concat(max - min, ") should be a multiple of Slider[step] (").concat(step, ")"));
	      _this.handlesRefs = {};
	      return _this;
	    }
	
	    (0, _createClass2.default)(ComponentEnhancer, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        // Snapshot testing cannot handle refs, so be sure to null-check this.
	        this.document = this.sliderRef && this.sliderRef.ownerDocument;
	        var _this$props3 = this.props,
	            autoFocus = _this$props3.autoFocus,
	            disabled = _this$props3.disabled;
	
	        if (autoFocus && !disabled) {
	          this.focus();
	        }
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        if ((0, _get2.default)((0, _getPrototypeOf2.default)(ComponentEnhancer.prototype), "componentWillUnmount", this)) (0, _get2.default)((0, _getPrototypeOf2.default)(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
	        this.removeDocumentEvents();
	      }
	    }, {
	      key: "getSliderStart",
	      value: function getSliderStart() {
	        var slider = this.sliderRef;
	        var _this$props4 = this.props,
	            vertical = _this$props4.vertical,
	            reverse = _this$props4.reverse;
	        var rect = slider.getBoundingClientRect();
	
	        if (vertical) {
	          return reverse ? rect.bottom : rect.top;
	        }
	
	        return window.pageXOffset + (reverse ? rect.right : rect.left);
	      }
	    }, {
	      key: "getSliderLength",
	      value: function getSliderLength() {
	        var slider = this.sliderRef;
	
	        if (!slider) {
	          return 0;
	        }
	
	        var coords = slider.getBoundingClientRect();
	        return this.props.vertical ? coords.height : coords.width;
	      }
	    }, {
	      key: "addDocumentTouchEvents",
	      value: function addDocumentTouchEvents() {
	        // just work for Chrome iOS Safari and Android Browser
	        this.onTouchMoveListener = (0, _addEventListener.default)(this.document, 'touchmove', this.onTouchMove);
	        this.onTouchUpListener = (0, _addEventListener.default)(this.document, 'touchend', this.onEnd);
	      }
	    }, {
	      key: "addDocumentMouseEvents",
	      value: function addDocumentMouseEvents() {
	        this.onMouseMoveListener = (0, _addEventListener.default)(this.document, 'mousemove', this.onMouseMove);
	        this.onMouseUpListener = (0, _addEventListener.default)(this.document, 'mouseup', this.onEnd);
	      }
	    }, {
	      key: "removeDocumentEvents",
	      value: function removeDocumentEvents() {
	        /* eslint-disable @typescript-eslint/no-unused-expressions */
	        this.onTouchMoveListener && this.onTouchMoveListener.remove();
	        this.onTouchUpListener && this.onTouchUpListener.remove();
	        this.onMouseMoveListener && this.onMouseMoveListener.remove();
	        this.onMouseUpListener && this.onMouseUpListener.remove();
	        /* eslint-enable no-unused-expressions */
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        var _this$handlesRefs$;
	
	        if (this.props.disabled) {
	          return;
	        }
	
	        (_this$handlesRefs$ = this.handlesRefs[0]) === null || _this$handlesRefs$ === void 0 ? void 0 : _this$handlesRefs$.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        var _this2 = this;
	
	        if (this.props.disabled) {
	          return;
	        }
	
	        Object.keys(this.handlesRefs).forEach(function (key) {
	          var _this2$handlesRefs$ke, _this2$handlesRefs$ke2;
	
	          (_this2$handlesRefs$ke = _this2.handlesRefs[key]) === null || _this2$handlesRefs$ke === void 0 ? void 0 : (_this2$handlesRefs$ke2 = _this2$handlesRefs$ke.blur) === null || _this2$handlesRefs$ke2 === void 0 ? void 0 : _this2$handlesRefs$ke2.call(_this2$handlesRefs$ke);
	        });
	      }
	    }, {
	      key: "calcValue",
	      value: function calcValue(offset) {
	        var _this$props5 = this.props,
	            vertical = _this$props5.vertical,
	            min = _this$props5.min,
	            max = _this$props5.max;
	        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
	        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
	        return value;
	      }
	    }, {
	      key: "calcValueByPos",
	      value: function calcValueByPos(position) {
	        var sign = this.props.reverse ? -1 : +1;
	        var pixelOffset = sign * (position - this.getSliderStart());
	        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
	        return nextValue;
	      }
	    }, {
	      key: "calcOffset",
	      value: function calcOffset(value) {
	        var _this$props6 = this.props,
	            min = _this$props6.min,
	            max = _this$props6.max;
	        var ratio = (value - min) / (max - min);
	        return Math.max(0, ratio * 100);
	      }
	    }, {
	      key: "saveHandle",
	      value: function saveHandle(index, handle) {
	        this.handlesRefs[index] = handle;
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _classNames;
	
	        var _this$props7 = this.props,
	            prefixCls = _this$props7.prefixCls,
	            className = _this$props7.className,
	            marks = _this$props7.marks,
	            dots = _this$props7.dots,
	            step = _this$props7.step,
	            included = _this$props7.included,
	            disabled = _this$props7.disabled,
	            vertical = _this$props7.vertical,
	            reverse = _this$props7.reverse,
	            min = _this$props7.min,
	            max = _this$props7.max,
	            children = _this$props7.children,
	            maximumTrackStyle = _this$props7.maximumTrackStyle,
	            style = _this$props7.style,
	            railStyle = _this$props7.railStyle,
	            dotStyle = _this$props7.dotStyle,
	            activeDotStyle = _this$props7.activeDotStyle;
	
	        var _get$call = (0, _get2.default)((0, _getPrototypeOf2.default)(ComponentEnhancer.prototype), "render", this).call(this),
	            tracks = _get$call.tracks,
	            handles = _get$call.handles;
	
	        var sliderClassName = (0, _classnames.default)(prefixCls, (_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-vertical"), vertical), (0, _defineProperty2.default)(_classNames, className, className), _classNames));
	        return /*#__PURE__*/_react.default.createElement("div", {
	          ref: this.saveSlider,
	          className: sliderClassName,
	          onTouchStart: disabled ? noop : this.onTouchStart,
	          onMouseDown: disabled ? noop : this.onMouseDown,
	          onMouseUp: disabled ? noop : this.onMouseUp,
	          onKeyDown: disabled ? noop : this.onKeyDown,
	          onFocus: disabled ? noop : this.onFocus,
	          onBlur: disabled ? noop : this.onBlur,
	          style: style
	        }, /*#__PURE__*/_react.default.createElement("div", {
	          className: "".concat(prefixCls, "-rail"),
	          style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, maximumTrackStyle), railStyle)
	        }), tracks, /*#__PURE__*/_react.default.createElement(_Steps.default, {
	          prefixCls: prefixCls,
	          vertical: vertical,
	          reverse: reverse,
	          marks: marks,
	          dots: dots,
	          step: step,
	          included: included,
	          lowerBound: this.getLowerBound(),
	          upperBound: this.getUpperBound(),
	          max: max,
	          min: min,
	          dotStyle: dotStyle,
	          activeDotStyle: activeDotStyle
	        }), handles, /*#__PURE__*/_react.default.createElement(_Marks.default, {
	          className: "".concat(prefixCls, "-mark"),
	          onClickLabel: disabled ? noop : this.onClickMarkLabel,
	          vertical: vertical,
	          marks: marks,
	          included: included,
	          lowerBound: this.getLowerBound(),
	          upperBound: this.getUpperBound(),
	          max: max,
	          min: min,
	          reverse: reverse
	        }), children);
	      }
	    }]);
	    return ComponentEnhancer;
	  }(Component), _a.displayName = "ComponentEnhancer(".concat(Component.displayName, ")"), _a.defaultProps = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, Component.defaultProps), {}, {
	    prefixCls: 'rc-slider',
	    className: '',
	    min: 0,
	    max: 100,
	    step: 1,
	    marks: {},
	    handle: function handle(props) {
	      var index = props.index,
	          restProps = (0, _objectWithoutProperties2.default)(props, ["index"]);
	      delete restProps.dragging;
	
	      if (restProps.value === null) {
	        return null;
	      }
	
	      return /*#__PURE__*/_react.default.createElement(_Handle.default, (0, _extends2.default)({}, restProps, {
	        key: index
	      }));
	    },
	    onBeforeChange: noop,
	    onChange: noop,
	    onAfterChange: noop,
	    included: true,
	    disabled: false,
	    dots: false,
	    vertical: false,
	    reverse: false,
	    trackStyle: [{}],
	    handleStyle: [{}],
	    railStyle: {},
	    dotStyle: {},
	    activeDotStyle: {}
	  }), _a;
	}

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Popup;
	var React = _interopRequireWildcard(__webpack_require__(2));
	var _classnames = _interopRequireDefault(__webpack_require__(38));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function Popup(props) {
	  var showArrow = props.showArrow,
	    arrowContent = props.arrowContent,
	    children = props.children,
	    prefixCls = props.prefixCls,
	    id = props.id,
	    overlayInnerStyle = props.overlayInnerStyle,
	    className = props.className,
	    style = props.style;
	  return /*#__PURE__*/React.createElement("div", {
	    className: (0, _classnames.default)("".concat(prefixCls, "-content"), className),
	    style: style
	  }, showArrow !== false && /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-arrow"),
	    key: "arrow"
	  }, arrowContent), /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-inner"),
	    id: id,
	    role: "tooltip",
	    style: overlayInnerStyle
	  }, typeof children === 'function' ? children() : children));
	}

/***/ },
/* 487 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMotion = getMotion;
	
	function getMotion(_ref) {
	  var prefixCls = _ref.prefixCls,
	      motion = _ref.motion,
	      animation = _ref.animation,
	      transitionName = _ref.transitionName;
	
	  if (motion) {
	    return motion;
	  }
	
	  if (animation) {
	    return {
	      motionName: "".concat(prefixCls, "-").concat(animation)
	    };
	  }
	
	  if (transitionName) {
	    return {
	      motionName: transitionName
	    };
	  }
	
	  return null;
	}

/***/ },
/* 488 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	function contains(root, n) {
	  if (!root) {
	    return false;
	  }
	
	  // Use native if support
	  if (root.contains) {
	    return root.contains(n);
	  }
	
	  // `document.contains` not support with IE11
	  var node = n;
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	  return false;
	}

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findDOMNode;
	exports.isDOM = isDOM;
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _reactDom = _interopRequireDefault(__webpack_require__(37));
	function isDOM(node) {
	  // https://developer.mozilla.org/en-US/docs/Web/API/Element
	  // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
	  return node instanceof HTMLElement || node instanceof SVGElement;
	}
	
	/**
	 * Return if a node is a DOM node. Else will return by `findDOMNode`
	 */
	function findDOMNode(node) {
	  if (isDOM(node)) {
	    return node;
	  }
	  if (node instanceof _react.default.Component) {
	    return _reactDom.default.findDOMNode(node);
	  }
	  return null;
	}

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	var _interopRequireWildcard = __webpack_require__(36).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useLayoutUpdateEffect = exports.default = void 0;
	var React = _interopRequireWildcard(__webpack_require__(2));
	var _canUseDom = _interopRequireDefault(__webpack_require__(122));
	/**
	 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
	 */
	var useInternalLayoutEffect = ("production") !== 'test' && (0, _canUseDom.default)() ? React.useLayoutEffect : React.useEffect;
	var useLayoutEffect = function useLayoutEffect(callback, deps) {
	  var firstMountRef = React.useRef(true);
	  useInternalLayoutEffect(function () {
	    return callback(firstMountRef.current);
	  }, deps);
	
	  // We tell react that first mount has passed
	  useInternalLayoutEffect(function () {
	    firstMountRef.current = false;
	    return function () {
	      firstMountRef.current = true;
	    };
	  }, []);
	};
	var useLayoutUpdateEffect = exports.useLayoutUpdateEffect = function useLayoutUpdateEffect(callback, deps) {
	  useLayoutEffect(function (firstMount) {
	    if (!firstMount) {
	      return callback();
	    }
	  }, deps);
	};
	var _default = exports.default = useLayoutEffect;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function(f) {
	  if (true) {
	    module.exports = f(__webpack_require__(2));
	    /* global define */
	  } else if (typeof define === 'function' && define.amd) {
	    define(['react'], f);
	  } else {
	    var g;
	    if (typeof window !== 'undefined') {
	      g = window;
	    } else if (typeof global !== 'undefined') {
	      g = global;
	    } else if (typeof self !== 'undefined') {
	      g = self;
	    } else {
	      g = this;
	    }
	
	    if (typeof g.React === 'undefined') {
	      throw Error('React module should be required before ReactDOMFactories');
	    }
	
	    g.ReactDOMFactories = f(g.React);
	  }
	})(function(React) {
	  /**
	   * Create a factory that creates HTML tag elements.
	   */
	  function createDOMFactory(type) {
	    var factory = React.createElement.bind(null, type);
	    // Expose the type on the factory and the prototype so that it can be
	    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	    // This should not be named `constructor` since this may not be the function
	    // that created the element, and it may not even be a constructor.
	    factory.type = type;
	    return factory;
	  };
	
	  /**
	   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	   */
	  var ReactDOMFactories = {
	    a: createDOMFactory('a'),
	    abbr: createDOMFactory('abbr'),
	    address: createDOMFactory('address'),
	    area: createDOMFactory('area'),
	    article: createDOMFactory('article'),
	    aside: createDOMFactory('aside'),
	    audio: createDOMFactory('audio'),
	    b: createDOMFactory('b'),
	    base: createDOMFactory('base'),
	    bdi: createDOMFactory('bdi'),
	    bdo: createDOMFactory('bdo'),
	    big: createDOMFactory('big'),
	    blockquote: createDOMFactory('blockquote'),
	    body: createDOMFactory('body'),
	    br: createDOMFactory('br'),
	    button: createDOMFactory('button'),
	    canvas: createDOMFactory('canvas'),
	    caption: createDOMFactory('caption'),
	    cite: createDOMFactory('cite'),
	    code: createDOMFactory('code'),
	    col: createDOMFactory('col'),
	    colgroup: createDOMFactory('colgroup'),
	    data: createDOMFactory('data'),
	    datalist: createDOMFactory('datalist'),
	    dd: createDOMFactory('dd'),
	    del: createDOMFactory('del'),
	    details: createDOMFactory('details'),
	    dfn: createDOMFactory('dfn'),
	    dialog: createDOMFactory('dialog'),
	    div: createDOMFactory('div'),
	    dl: createDOMFactory('dl'),
	    dt: createDOMFactory('dt'),
	    em: createDOMFactory('em'),
	    embed: createDOMFactory('embed'),
	    fieldset: createDOMFactory('fieldset'),
	    figcaption: createDOMFactory('figcaption'),
	    figure: createDOMFactory('figure'),
	    footer: createDOMFactory('footer'),
	    form: createDOMFactory('form'),
	    h1: createDOMFactory('h1'),
	    h2: createDOMFactory('h2'),
	    h3: createDOMFactory('h3'),
	    h4: createDOMFactory('h4'),
	    h5: createDOMFactory('h5'),
	    h6: createDOMFactory('h6'),
	    head: createDOMFactory('head'),
	    header: createDOMFactory('header'),
	    hgroup: createDOMFactory('hgroup'),
	    hr: createDOMFactory('hr'),
	    html: createDOMFactory('html'),
	    i: createDOMFactory('i'),
	    iframe: createDOMFactory('iframe'),
	    img: createDOMFactory('img'),
	    input: createDOMFactory('input'),
	    ins: createDOMFactory('ins'),
	    kbd: createDOMFactory('kbd'),
	    keygen: createDOMFactory('keygen'),
	    label: createDOMFactory('label'),
	    legend: createDOMFactory('legend'),
	    li: createDOMFactory('li'),
	    link: createDOMFactory('link'),
	    main: createDOMFactory('main'),
	    map: createDOMFactory('map'),
	    mark: createDOMFactory('mark'),
	    menu: createDOMFactory('menu'),
	    menuitem: createDOMFactory('menuitem'),
	    meta: createDOMFactory('meta'),
	    meter: createDOMFactory('meter'),
	    nav: createDOMFactory('nav'),
	    noscript: createDOMFactory('noscript'),
	    object: createDOMFactory('object'),
	    ol: createDOMFactory('ol'),
	    optgroup: createDOMFactory('optgroup'),
	    option: createDOMFactory('option'),
	    output: createDOMFactory('output'),
	    p: createDOMFactory('p'),
	    param: createDOMFactory('param'),
	    picture: createDOMFactory('picture'),
	    pre: createDOMFactory('pre'),
	    progress: createDOMFactory('progress'),
	    q: createDOMFactory('q'),
	    rp: createDOMFactory('rp'),
	    rt: createDOMFactory('rt'),
	    ruby: createDOMFactory('ruby'),
	    s: createDOMFactory('s'),
	    samp: createDOMFactory('samp'),
	    script: createDOMFactory('script'),
	    section: createDOMFactory('section'),
	    select: createDOMFactory('select'),
	    small: createDOMFactory('small'),
	    source: createDOMFactory('source'),
	    span: createDOMFactory('span'),
	    strong: createDOMFactory('strong'),
	    style: createDOMFactory('style'),
	    sub: createDOMFactory('sub'),
	    summary: createDOMFactory('summary'),
	    sup: createDOMFactory('sup'),
	    table: createDOMFactory('table'),
	    tbody: createDOMFactory('tbody'),
	    td: createDOMFactory('td'),
	    textarea: createDOMFactory('textarea'),
	    tfoot: createDOMFactory('tfoot'),
	    th: createDOMFactory('th'),
	    thead: createDOMFactory('thead'),
	    time: createDOMFactory('time'),
	    title: createDOMFactory('title'),
	    tr: createDOMFactory('tr'),
	    track: createDOMFactory('track'),
	    u: createDOMFactory('u'),
	    ul: createDOMFactory('ul'),
	    var: createDOMFactory('var'),
	    video: createDOMFactory('video'),
	    wbr: createDOMFactory('wbr'),
	
	    // SVG
	    circle: createDOMFactory('circle'),
	    clipPath: createDOMFactory('clipPath'),
	    defs: createDOMFactory('defs'),
	    ellipse: createDOMFactory('ellipse'),
	    g: createDOMFactory('g'),
	    image: createDOMFactory('image'),
	    line: createDOMFactory('line'),
	    linearGradient: createDOMFactory('linearGradient'),
	    mask: createDOMFactory('mask'),
	    path: createDOMFactory('path'),
	    pattern: createDOMFactory('pattern'),
	    polygon: createDOMFactory('polygon'),
	    polyline: createDOMFactory('polyline'),
	    radialGradient: createDOMFactory('radialGradient'),
	    rect: createDOMFactory('rect'),
	    stop: createDOMFactory('stop'),
	    svg: createDOMFactory('svg'),
	    text: createDOMFactory('text'),
	    tspan: createDOMFactory('tspan'),
	  };
	
	  // due to wrapper and conditionals at the top, this will either become
	  // `module.exports ReactDOMFactories` if that is available,
	  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
	  // if that is available,
	  // otherwise it will be defined as global variable.
	  return ReactDOMFactories;
	});
	


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(2), __webpack_require__(11));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else if(typeof exports === 'object')
			exports["Dropzone"] = factory(require("react"), require("prop-types"));
		else
			root["Dropzone"] = factory(root["react"], root["prop-types"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
		
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
		
		var _react = __webpack_require__(2);
		
		var _react2 = _interopRequireDefault(_react);
		
		var _propTypes = __webpack_require__(3);
		
		var _propTypes2 = _interopRequireDefault(_propTypes);
		
		var _attrAccept = __webpack_require__(4);
		
		var _attrAccept2 = _interopRequireDefault(_attrAccept);
		
		var _getDataTransferItems = __webpack_require__(5);
		
		var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
		
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
		
		function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
		
		function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
		
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
		
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
		
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
		
		var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
		
		function fileAccepted(file, accept) {
		  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
		  // that MIME type will always be accepted
		  return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, accept);
		}
		
		var Dropzone = function (_React$Component) {
		  _inherits(Dropzone, _React$Component);
		
		  _createClass(Dropzone, null, [{
		    key: 'onDocumentDragOver',
		    value: function onDocumentDragOver(evt) {
		      // allow the entire document to be a drag target
		      evt.preventDefault();
		    }
		  }]);
		
		  function Dropzone(props, context) {
		    _classCallCheck(this, Dropzone);
		
		    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
		
		    _this.renderChildren = function (children, isDragActive, isDragReject) {
		      if (typeof children === 'function') {
		        return children(_extends({}, _this.state, { isDragActive: isDragActive, isDragReject: isDragReject }));
		      }
		      return children;
		    };
		
		    _this.onClick = _this.onClick.bind(_this);
		    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
		    _this.onDragStart = _this.onDragStart.bind(_this);
		    _this.onDragEnter = _this.onDragEnter.bind(_this);
		    _this.onDragLeave = _this.onDragLeave.bind(_this);
		    _this.onDragOver = _this.onDragOver.bind(_this);
		    _this.onDrop = _this.onDrop.bind(_this);
		    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
		    _this.setRef = _this.setRef.bind(_this);
		    _this.setRefs = _this.setRefs.bind(_this);
		    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
		    _this.isFileDialogActive = false;
		    _this.state = {
		      draggedFiles: [],
		      acceptedFiles: [],
		      rejectedFiles: []
		    };
		    return _this;
		  }
		
		  _createClass(Dropzone, [{
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      this.dragTargets = [];
		
		      if (preventDropOnDocument) {
		        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
		        document.addEventListener('drop', this.onDocumentDrop, false);
		      }
		      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
		      // Tried implementing addEventListener, but didn't work out
		      document.body.onfocus = this.onFileDialogCancel;
		    }
		  }, {
		    key: 'componentWillUnmount',
		    value: function componentWillUnmount() {
		      var preventDropOnDocument = this.props.preventDropOnDocument;
		
		      if (preventDropOnDocument) {
		        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
		        document.removeEventListener('drop', this.onDocumentDrop);
		      }
		      this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
		      // Can be replaced with removeEventListener, if addEventListener works
		      document.body.onfocus = null;
		    }
		  }, {
		    key: 'onDocumentDrop',
		    value: function onDocumentDrop(evt) {
		      if (this.node.contains(evt.target)) {
		        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
		        return;
		      }
		      evt.preventDefault();
		      this.dragTargets = [];
		    }
		  }, {
		    key: 'onDragStart',
		    value: function onDragStart(evt) {
		      if (this.props.onDragStart) {
		        this.props.onDragStart.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDragEnter',
		    value: function onDragEnter(evt) {
		      evt.preventDefault();
		
		      // Count the dropzone and any children that are entered.
		      if (this.dragTargets.indexOf(evt.target) === -1) {
		        this.dragTargets.push(evt.target);
		      }
		
		      this.setState({ draggedFiles: (0, _getDataTransferItems2.default)(evt) });
		
		      if (this.props.onDragEnter) {
		        this.props.onDragEnter.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDragOver',
		    value: function onDragOver(evt) {
		      // eslint-disable-line class-methods-use-this
		      evt.preventDefault();
		      evt.stopPropagation();
		      try {
		        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
		      } catch (err) {
		        // continue regardless of error
		      }
		
		      if (this.props.onDragOver) {
		        this.props.onDragOver.call(this, evt);
		      }
		      return false;
		    }
		  }, {
		    key: 'onDragLeave',
		    value: function onDragLeave(evt) {
		      var _this2 = this;
		
		      evt.preventDefault();
		
		      // Only deactivate once the dropzone and all children have been left.
		      this.dragTargets = this.dragTargets.filter(function (el) {
		        return el !== evt.target && _this2.node.contains(el);
		      });
		      if (this.dragTargets.length > 0) {
		        return;
		      }
		
		      // Clear dragging files state
		      this.setState({ draggedFiles: [] });
		
		      if (this.props.onDragLeave) {
		        this.props.onDragLeave.call(this, evt);
		      }
		    }
		  }, {
		    key: 'onDrop',
		    value: function onDrop(evt) {
		      var _this3 = this;
		
		      var _props = this.props,
		          onDrop = _props.onDrop,
		          onDropAccepted = _props.onDropAccepted,
		          onDropRejected = _props.onDropRejected,
		          multiple = _props.multiple,
		          disablePreview = _props.disablePreview,
		          accept = _props.accept;
		
		      var fileList = (0, _getDataTransferItems2.default)(evt);
		      var acceptedFiles = [];
		      var rejectedFiles = [];
		
		      // Stop default browser behavior
		      evt.preventDefault();
		
		      // Reset the counter along with the drag on a drop.
		      this.dragTargets = [];
		      this.isFileDialogActive = false;
		
		      fileList.forEach(function (file) {
		        if (!disablePreview) {
		          try {
		            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
		          } catch (err) {
		            if (process.env.NODE_ENV !== 'production') {
		              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
		            }
		          }
		        }
		
		        if (fileAccepted(file, accept) && _this3.fileMatchSize(file)) {
		          acceptedFiles.push(file);
		        } else {
		          rejectedFiles.push(file);
		        }
		      });
		
		      if (!multiple) {
		        // if not in multi mode add any extra accepted files to rejected.
		        // This will allow end users to easily ignore a multi file drop in "single" mode.
		        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
		      }
		
		      if (onDrop) {
		        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
		      }
		
		      if (rejectedFiles.length > 0 && onDropRejected) {
		        onDropRejected.call(this, rejectedFiles, evt);
		      }
		
		      if (acceptedFiles.length > 0 && onDropAccepted) {
		        onDropAccepted.call(this, acceptedFiles, evt);
		      }
		
		      // Clear files value
		      this.draggedFiles = null;
		
		      // Reset drag state
		      this.setState({
		        draggedFiles: [],
		        acceptedFiles: acceptedFiles,
		        rejectedFiles: rejectedFiles
		      });
		    }
		  }, {
		    key: 'onClick',
		    value: function onClick(evt) {
		      var _props2 = this.props,
		          onClick = _props2.onClick,
		          disableClick = _props2.disableClick;
		
		      if (!disableClick) {
		        evt.stopPropagation();
		
		        if (onClick) {
		          onClick.call(this, evt);
		        }
		
		        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
		        // this is so react can handle state changes in the onClick prop above above
		        // see: https://github.com/okonet/react-dropzone/issues/450
		        setTimeout(this.open.bind(this), 0);
		      }
		    }
		  }, {
		    key: 'onInputElementClick',
		    value: function onInputElementClick(evt) {
		      evt.stopPropagation();
		      if (this.props.inputProps && this.props.inputProps.onClick) {
		        this.props.inputProps.onClick();
		      }
		    }
		  }, {
		    key: 'onFileDialogCancel',
		    value: function onFileDialogCancel() {
		      // timeout will not recognize context of this method
		      var onFileDialogCancel = this.props.onFileDialogCancel;
		      var fileInputEl = this.fileInputEl;
		      var isFileDialogActive = this.isFileDialogActive;
		      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
		      // is opened in the browser
		
		      if (onFileDialogCancel && isFileDialogActive) {
		        setTimeout(function () {
		          // Returns an object as FileList
		          var FileList = fileInputEl.files;
		          if (!FileList.length) {
		            isFileDialogActive = false;
		            onFileDialogCancel();
		          }
		        }, 300);
		      }
		    }
		  }, {
		    key: 'setRef',
		    value: function setRef(ref) {
		      this.node = ref;
		    }
		  }, {
		    key: 'setRefs',
		    value: function setRefs(ref) {
		      this.fileInputEl = ref;
		    }
		  }, {
		    key: 'fileMatchSize',
		    value: function fileMatchSize(file) {
		      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
		    }
		  }, {
		    key: 'allFilesAccepted',
		    value: function allFilesAccepted(files) {
		      var _this4 = this;
		
		      return files.every(function (file) {
		        return fileAccepted(file, _this4.props.accept);
		      });
		    }
		
		    /**
		     * Open system file upload dialog.
		     *
		     * @public
		     */
		
		  }, {
		    key: 'open',
		    value: function open() {
		      this.isFileDialogActive = true;
		      this.fileInputEl.value = null;
		      this.fileInputEl.click();
		    }
		  }, {
		    key: 'render',
		    value: function render() {
		      var _props3 = this.props,
		          accept = _props3.accept,
		          activeClassName = _props3.activeClassName,
		          inputProps = _props3.inputProps,
		          multiple = _props3.multiple,
		          name = _props3.name,
		          rejectClassName = _props3.rejectClassName,
		          children = _props3.children,
		          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
		
		      var activeStyle = rest.activeStyle,
		          className = rest.className,
		          rejectStyle = rest.rejectStyle,
		          style = rest.style,
		          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
		
		      var draggedFiles = this.state.draggedFiles;
		
		      var filesCount = draggedFiles.length;
		      var isMultipleAllowed = multiple || filesCount <= 1;
		      var isDragActive = filesCount > 0 && this.allFilesAccepted(draggedFiles);
		      var isDragReject = filesCount > 0 && (!isDragActive || !isMultipleAllowed);
		
		      className = className || '';
		
		      if (isDragActive && activeClassName) {
		        className += ' ' + activeClassName;
		      }
		      if (isDragReject && rejectClassName) {
		        className += ' ' + rejectClassName;
		      }
		
		      if (!className && !style && !activeStyle && !rejectStyle) {
		        style = {
		          width: 200,
		          height: 200,
		          borderWidth: 2,
		          borderColor: '#666',
		          borderStyle: 'dashed',
		          borderRadius: 5
		        };
		        activeStyle = {
		          borderStyle: 'solid',
		          borderColor: '#6c6',
		          backgroundColor: '#eee'
		        };
		        rejectStyle = {
		          borderStyle: 'solid',
		          borderColor: '#c66',
		          backgroundColor: '#eee'
		        };
		      }
		
		      var appliedStyle = void 0;
		      if (activeStyle && isDragActive) {
		        appliedStyle = _extends({}, style, activeStyle);
		      } else if (rejectStyle && isDragReject) {
		        appliedStyle = _extends({}, style, rejectStyle);
		      } else {
		        appliedStyle = _extends({}, style);
		      }
		
		      var inputAttributes = {
		        accept: accept,
		        type: 'file',
		        style: { display: 'none' },
		        multiple: supportMultiple && multiple,
		        ref: this.setRefs,
		        onChange: this.onDrop
		      };
		
		      if (name && name.length) {
		        inputAttributes.name = name;
		      }
		
		      // Remove custom properties before passing them to the wrapper div element
		      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
		      var divProps = _extends({}, props);
		      customProps.forEach(function (prop) {
		        return delete divProps[prop];
		      });
		
		      return _react2.default.createElement(
		        'div',
		        _extends({
		          className: className,
		          style: appliedStyle
		        }, divProps /* expand user provided props first so event handlers are never overridden */, {
		          onClick: this.onClick,
		          onDragStart: this.onDragStart,
		          onDragEnter: this.onDragEnter,
		          onDragOver: this.onDragOver,
		          onDragLeave: this.onDragLeave,
		          onDrop: this.onDrop,
		          ref: this.setRef
		        }),
		        this.renderChildren(children, isDragActive, isDragReject),
		        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
		      );
		    }
		  }]);
		
		  return Dropzone;
		}(_react2.default.Component);
		
		Dropzone.propTypes = {
		  /**
		   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
		   * Keep in mind that mime type determination is not reliable accross platforms. CSV files,
		   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
		   * Windows. In some cases there might not be a mime type set at all.
		   * See: https://github.com/okonet/react-dropzone/issues/276
		   */
		  accept: _propTypes2.default.string,
		
		  /**
		   * Contents of the dropzone
		   */
		  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
		
		  /**
		   * Disallow clicking on the dropzone container to open file dialog
		   */
		  disableClick: _propTypes2.default.bool,
		
		  /**
		   * Enable/disable preview generation
		   */
		  disablePreview: _propTypes2.default.bool,
		
		  /**
		   * If false, allow dropped items to take over the current browser window
		   */
		  preventDropOnDocument: _propTypes2.default.bool,
		
		  /**
		   * Pass additional attributes to the `<input type="file"/>` tag
		   */
		  inputProps: _propTypes2.default.object,
		
		  /**
		   * Allow dropping multiple files
		   */
		  multiple: _propTypes2.default.bool,
		
		  /**
		   * `name` attribute for the input tag
		   */
		  name: _propTypes2.default.string,
		
		  /**
		   * Maximum file size
		   */
		  maxSize: _propTypes2.default.number,
		
		  /**
		   * Minimum file size
		   */
		  minSize: _propTypes2.default.number,
		
		  /**
		   * className
		   */
		  className: _propTypes2.default.string,
		
		  /**
		   * className for accepted state
		   */
		  activeClassName: _propTypes2.default.string,
		
		  /**
		   * className for rejected state
		   */
		  rejectClassName: _propTypes2.default.string,
		
		  /**
		   * CSS styles to apply
		   */
		  style: _propTypes2.default.object,
		
		  /**
		   * CSS styles to apply when drop will be accepted
		   */
		  activeStyle: _propTypes2.default.object,
		
		  /**
		   * CSS styles to apply when drop will be rejected
		   */
		  rejectStyle: _propTypes2.default.object,
		
		  /**
		   * onClick callback
		   * @param {Event} event
		   */
		  onClick: _propTypes2.default.func,
		
		  /**
		   * onDrop callback
		   */
		  onDrop: _propTypes2.default.func,
		
		  /**
		   * onDropAccepted callback
		   */
		  onDropAccepted: _propTypes2.default.func,
		
		  /**
		   * onDropRejected callback
		   */
		  onDropRejected: _propTypes2.default.func,
		
		  /**
		   * onDragStart callback
		   */
		  onDragStart: _propTypes2.default.func,
		
		  /**
		   * onDragEnter callback
		   */
		  onDragEnter: _propTypes2.default.func,
		
		  /**
		   * onDragOver callback
		   */
		  onDragOver: _propTypes2.default.func,
		
		  /**
		   * onDragLeave callback
		   */
		  onDragLeave: _propTypes2.default.func,
		
		  /**
		   * Provide a callback on clicking the cancel button of the file dialog
		   */
		  onFileDialogCancel: _propTypes2.default.func
		};
		
		Dropzone.defaultProps = {
		  preventDropOnDocument: true,
		  disablePreview: false,
		  disableClick: false,
		  multiple: true,
		  maxSize: Infinity,
		  minSize: 0
		};
		
		exports.default = Dropzone;
		module.exports = exports['default'];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports) {
	
		// shim for using process in browser
		var process = module.exports = {};
		
		// cached from whatever global is present so that test runners that stub it
		// don't break things.  But we need to wrap it in a try catch in case it is
		// wrapped in strict mode code which doesn't define any globals.  It's inside a
		// function because try/catches deoptimize in certain engines.
		
		var cachedSetTimeout;
		var cachedClearTimeout;
		
		function defaultSetTimout() {
		    throw new Error('setTimeout has not been defined');
		}
		function defaultClearTimeout () {
		    throw new Error('clearTimeout has not been defined');
		}
		(function () {
		    try {
		        if (typeof setTimeout === 'function') {
		            cachedSetTimeout = setTimeout;
		        } else {
		            cachedSetTimeout = defaultSetTimout;
		        }
		    } catch (e) {
		        cachedSetTimeout = defaultSetTimout;
		    }
		    try {
		        if (typeof clearTimeout === 'function') {
		            cachedClearTimeout = clearTimeout;
		        } else {
		            cachedClearTimeout = defaultClearTimeout;
		        }
		    } catch (e) {
		        cachedClearTimeout = defaultClearTimeout;
		    }
		} ())
		function runTimeout(fun) {
		    if (cachedSetTimeout === setTimeout) {
		        //normal enviroments in sane situations
		        return setTimeout(fun, 0);
		    }
		    // if setTimeout wasn't available but was latter defined
		    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
		        cachedSetTimeout = setTimeout;
		        return setTimeout(fun, 0);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedSetTimeout(fun, 0);
		    } catch(e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
		            return cachedSetTimeout.call(null, fun, 0);
		        } catch(e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
		            return cachedSetTimeout.call(this, fun, 0);
		        }
		    }
		
		
		}
		function runClearTimeout(marker) {
		    if (cachedClearTimeout === clearTimeout) {
		        //normal enviroments in sane situations
		        return clearTimeout(marker);
		    }
		    // if clearTimeout wasn't available but was latter defined
		    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
		        cachedClearTimeout = clearTimeout;
		        return clearTimeout(marker);
		    }
		    try {
		        // when when somebody has screwed with setTimeout but no I.E. maddness
		        return cachedClearTimeout(marker);
		    } catch (e){
		        try {
		            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
		            return cachedClearTimeout.call(null, marker);
		        } catch (e){
		            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
		            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
		            return cachedClearTimeout.call(this, marker);
		        }
		    }
		
		
		
		}
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
		
		function cleanUpNextTick() {
		    if (!draining || !currentQueue) {
		        return;
		    }
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
		
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = runTimeout(cleanUpNextTick);
		    draining = true;
		
		    var len = queue.length;
		    while(len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    runClearTimeout(timeout);
		}
		
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        runTimeout(drainQueue);
		    }
		};
		
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
		
		function noop() {}
		
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
		process.prependListener = noop;
		process.prependOnceListener = noop;
		
		process.listeners = function (name) { return [] }
		
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
		
		process.cwd = function () { return '/' };
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function() { return 0; };
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_2__;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports) {
	
		module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports) {
	
		"use strict";
		
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = getDataTransferFiles;
		function getDataTransferFiles(event) {
		  var dataTransferItemsList = [];
		  if (event.dataTransfer) {
		    var dt = event.dataTransfer;
		    if (dt.files && dt.files.length) {
		      dataTransferItemsList = dt.files;
		    } else if (dt.items && dt.items.length) {
		      // During the drag even the dataTransfer.files is null
		      // but Chrome implements some drag store, which is accesible via dataTransfer.items
		      dataTransferItemsList = dt.items;
		    }
		  } else if (event.target && event.target.files) {
		    dataTransferItemsList = event.target.files;
		  }
		  // Convert from DataTransferItemsList to the native Array
		  return Array.prototype.slice.call(dataTransferItemsList);
		}
		module.exports = exports["default"];
	
	/***/ })
	/******/ ])
	});
	;
	//# sourceMappingURL=index.js.map

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LaunchDarklyConsumer = exports.LaunchDarklyProvider = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$createContext = _react2.default.createContext(),
	    LaunchDarklyProvider = _React$createContext.Provider,
	    LaunchDarklyConsumer = _React$createContext.Consumer;
	
	exports.LaunchDarklyProvider = LaunchDarklyProvider;
	exports.LaunchDarklyConsumer = LaunchDarklyConsumer;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.testExports = undefined;
	exports.getLocation = getLocation;
	exports.ldClientWrapper = ldClientWrapper;
	exports.ldOverrideFlag = ldOverrideFlag;
	exports.getAllFeatureFlags = getAllFeatureFlags;
	exports.identify = identify;
	exports.track = track;
	exports.feature = feature;
	
	var _ldclientJs = __webpack_require__(1064);
	
	var url = __webpack_require__(1288);
	
	function getLocation() {
	  if (window.location) {
	    return window.location.toString();
	  }
	  return "";
	}
	
	var ldClient = void 0;
	var ldClientReady = false;
	function ldClientWrapper(key, user) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var queue = [];
	
	  if (!ldClient) {
	    ldClient = (0, _ldclientJs.initialize)(key, user, options);
	  }
	
	  if (!ldClientReady) {
	    ldClient.on("ready", function () {
	      ldClientReady = true;
	
	      if (queue.length) {
	        while (queue.length) {
	          queue.shift()();
	        }
	      }
	    });
	  }
	
	  // Create our own implementation of the ldclient-js' `on` function.
	  // Multiple calls with `on('ready')` seem to not fire after the original client has been initialized.
	  // By implementing our own, we can track the initial "ready" fire and decide how to proceed.
	  ldClient.onReady = function (callback) {
	    if (ldClientReady) {
	      callback();
	    } else {
	      queue.push(callback);
	    }
	  };
	
	  return ldClient;
	}
	
	function ldOverrideFlag(flagKey, typeFlagValue) {
	  var override = void 0;
	  /*
	   POST /users?features=send-onboarding-email
	   # Overrides the `send-onboarding-email` boolean feature flag, setting it to `true`
	   GET /users/101?features=show-user-email,user-nicknames,hide-inactive-users
	   # Enables the `show-user-email`, `user-nicknames`, and `hide-inactive-users` feature flags
	   POST /users?features.verify-email=false&features.email-frequency=weekly
	   # Disables the `verify-email` feature flag and sets the `email-frequency` variation to "weekly"
	   */
	  var query = url.parse(exports.getLocation(), true).query;
	  var queryFlag = query["features." + flagKey];
	  var queryFeatures = query["features"];
	
	  if (typeof queryFlag !== "undefined") {
	    if (queryFlag === "") {
	      override = true;
	    } else if (queryFlag === "false") {
	      override = false;
	    } else {
	      override = queryFlag;
	    }
	
	    if (typeFlagValue === "number") {
	      override = parseFloat(override);
	    }
	  } else if (queryFeatures) {
	    queryFeatures.split(",").forEach(function (f) {
	      if (f === flagKey) {
	        override = true;
	      }
	    });
	  }
	  return override;
	}
	
	function getAllFeatureFlags(key, user) {
	  var ldClient = ldClientWrapper(key, user);
	  return new Promise(function (resolve) {
	    ldClient.onReady(function () {
	      resolve(ldClient.allFlags());
	    });
	  });
	}
	
	/*
	
	  https://docs.launchdarkly.com/docs/js-sdk-reference#section-changing-the-user-context
	
	  "The hash parameter is the hash for the new user, assuming that the user's key has changed.
	  It is only required in secure mode-- if secure mode is not enabled,
	  you can pass in `null` for the hash."
	
	*/
	function identify(key, user) {
	  var hash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var ldClient = ldClientWrapper(key, user);
	  return new Promise(function (resolve) {
	    ldClient.onReady(function () {
	      resolve(ldClient.identify(user, hash));
	    });
	  });
	}
	
	function track(key, user, goalKey) {
	  var ldClient = ldClientWrapper(key, user);
	  return new Promise(function (resolve) {
	    ldClient.onReady(function () {
	      resolve(ldClient.track(goalKey));
	    });
	  });
	}
	
	function feature(key, user, variation) {
	  var ldClient = ldClientWrapper(key, user);
	  return new Promise(function (resolve) {
	    ldClient.onReady(function () {
	      resolve(ldClient.variation(variation));
	    });
	  });
	}
	
	var testExports = exports.testExports = {
	  reset: function reset() {
	    ldClient = null;
	  }
	};

/***/ },
/* 495 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setRef = exports.shallowEqual = exports.safeInvoke = exports.unwrapArray = void 0;
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array,
	 * otherwise returns the argument. Used for Preact compatibility.
	 */
	var unwrapArray = function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	};
	/**
	 * Takes a maybe-undefined function and arbitrary args and invokes the function
	 * only if it is defined.
	 */
	
	
	exports.unwrapArray = unwrapArray;
	
	var safeInvoke = function safeInvoke(fn) {
	  if (typeof fn === "function") {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return fn.apply(void 0, args);
	  }
	};
	/**
	 * Does a shallow equality check of two objects by comparing the reference
	 * equality of each value.
	 */
	
	
	exports.safeInvoke = safeInvoke;
	
	var shallowEqual = function shallowEqual(objA, objB) {
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (bKeys.length !== aKeys.length) {
	    return false;
	  }
	
	  for (var i = 0; i < bKeys.length; i++) {
	    var key = aKeys[i];
	
	    if (objA[key] !== objB[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Sets a ref using either a ref callback or a ref object
	 */
	
	
	exports.shallowEqual = shallowEqual;
	
	var setRef = function setRef(ref, node) {
	  // if its a function call it
	  if (typeof ref === "function") {
	    return safeInvoke(ref, node);
	  } // otherwise we should treat it as a ref object
	  else if (ref != null) {
	      ref.current = node;
	    }
	};
	
	exports.setRef = setRef;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Quill = __webpack_require__(478);
	
	var QuillMixin = {
	
		/**
		Creates an editor on the given element. The editor will
		be passed the configuration, have its events bound,
		*/
		createEditor: function($el, config) {
			var editor = new Quill($el, config);
			if (config.tabIndex !== undefined) {
				this.setEditorTabIndex(editor, config.tabIndex);
			}
			this.hookEditor(editor);
			return editor;
		},
	
		hookEditor: function(editor) {
			// Expose the editor on change events via a weaker,
			// unprivileged proxy object that does not allow
			// accidentally modifying editor state.
			var unprivilegedEditor = this.makeUnprivilegedEditor(editor);
	
			this.handleTextChange = function(delta, oldDelta, source) {
				if (this.onEditorChangeText) {
					this.onEditorChangeText(
						editor.root.innerHTML, delta, source,
						unprivilegedEditor
					);
					this.onEditorChangeSelection(
						editor.getSelection(), source,
						unprivilegedEditor
					);
				}
			}.bind(this);
	
			this.handleSelectionChange = function(range, oldRange, source) {
				if (this.onEditorChangeSelection) {
					this.onEditorChangeSelection(
						range, source,
						unprivilegedEditor
					);
				}
			}.bind(this);
	
			editor.on('editor-change', function(eventType, rangeOrDelta, oldRangeOrOldDelta, source) {
				if (eventType === Quill.events.SELECTION_CHANGE) {
					this.handleSelectionChange(rangeOrDelta, oldRangeOrOldDelta, source);
				}
				
				if (eventType === Quill.events.TEXT_CHANGE) {
					this.handleTextChange(rangeOrDelta, oldRangeOrOldDelta, source);
				}
			}.bind(this));
		},
	
		unhookEditor: function(editor) {
			editor.off('selection-change');
			editor.off('text-change');
		},
	
		setEditorReadOnly: function(editor, value) {
			value? editor.disable()
			     : editor.enable();
		},
	
		/*
		Replace the contents of the editor, but keep
		the previous selection hanging around so that
		the cursor won't move.
		*/
		setEditorContents: function(editor, value) {
			var sel = editor.getSelection();
	
			if (typeof value === 'string') {
				editor.setContents(editor.clipboard.convert(value));
			} else {
				editor.setContents(value);
			}
	
			if (sel && editor.hasFocus()) this.setEditorSelection(editor, sel);
		},
	
		setEditorSelection: function(editor, range) {
			if (range) {
				// Validate bounds before applying.
				var length = editor.getLength();
				range.index = Math.max(0, Math.min(range.index, length-1));
				range.length = Math.max(0, Math.min(range.length, (length-1) - range.index));
			}
			editor.setSelection(range);
		},
	
		setEditorTabIndex: function(editor, tabIndex) {
			if (editor.editor && editor.editor.scroll && editor.editor.scroll.domNode) {
				editor.editor.scroll.domNode.tabIndex = tabIndex;
			}
		},
	
		/*
		Returns an weaker, unprivileged proxy object that only
		exposes read-only accessors found on the editor instance,
		without any state-modificating methods.
		*/
		makeUnprivilegedEditor: function(editor) {
			var e = editor;
			return {
				getLength:    function(){ return e.getLength.apply(e, arguments); },
				getText:      function(){ return e.getText.apply(e, arguments); },
				getHTML:      function(){ return e.root.innerHTML },
				getContents:  function(){ return e.getContents.apply(e, arguments); },
				getSelection: function(){ return e.getSelection.apply(e, arguments); },
				getBounds:    function(){ return e.getBounds.apply(e, arguments); },
			};
		}
	
	};
	
	module.exports = QuillMixin;


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(126),
	    stackClear = __webpack_require__(1231),
	    stackDelete = __webpack_require__(1232),
	    stackGet = __webpack_require__(1233),
	    stackHas = __webpack_require__(1234),
	    stackSet = __webpack_require__(1235);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 498 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(500),
	    toKey = __webpack_require__(131);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(54),
	    isKey = __webpack_require__(196),
	    stringToPath = __webpack_require__(1236),
	    toString = __webpack_require__(1250);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1161),
	    arraySome = __webpack_require__(498),
	    cacheHas = __webpack_require__(1189);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 502 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(96);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 504 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 505 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(1193),
	    findIndex = __webpack_require__(1238);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1174),
	    isObjectLike = __webpack_require__(97);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(53),
	    stubFalse = __webpack_require__(1246);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)(module)))

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(193);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(95),
	    isObject = __webpack_require__(96);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1178),
	    baseUnary = __webpack_require__(1188),
	    nodeUtil = __webpack_require__(1225);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Radio = (function (_React$Component) {
	  _inherits(Radio, _React$Component);
	
	  function Radio() {
	    _classCallCheck(this, Radio);
	
	    _get(Object.getPrototypeOf(Radio.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Radio, [{
	    key: 'render',
	    value: function render() {
	      var _context$radioGroup = this.context.radioGroup;
	      var name = _context$radioGroup.name;
	      var selectedValue = _context$radioGroup.selectedValue;
	      var onChange = _context$radioGroup.onChange;
	
	      var optional = {};
	      if (selectedValue !== undefined) {
	        optional.checked = this.props.value === selectedValue;
	      }
	      if (typeof onChange === 'function') {
	        optional.onChange = onChange.bind(null, this.props.value);
	      }
	
	      return _react2['default'].createElement('input', _extends({}, this.props, {
	        type: 'radio',
	        name: name
	      }, optional));
	    }
	  }]);
	
	  return Radio;
	})(_react2['default'].Component);
	
	exports.Radio = Radio;
	;
	
	Radio.contextTypes = {
	  radioGroup: _propTypes2['default'].object
	};
	
	var RadioGroup = (function (_React$Component2) {
	  _inherits(RadioGroup, _React$Component2);
	
	  function RadioGroup() {
	    _classCallCheck(this, RadioGroup);
	
	    _get(Object.getPrototypeOf(RadioGroup.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(RadioGroup, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _props = this.props;
	      var name = _props.name;
	      var selectedValue = _props.selectedValue;
	      var onChange = _props.onChange;
	
	      return {
	        radioGroup: {
	          name: name, selectedValue: selectedValue, onChange: onChange
	        }
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var Component = _props2.Component;
	      var name = _props2.name;
	      var selectedValue = _props2.selectedValue;
	      var onChange = _props2.onChange;
	      var children = _props2.children;
	
	      var rest = _objectWithoutProperties(_props2, ['Component', 'name', 'selectedValue', 'onChange', 'children']);
	
	      return _react2['default'].createElement(
	        Component,
	        rest,
	        children
	      );
	    }
	  }]);
	
	  return RadioGroup;
	})(_react2['default'].Component);
	
	exports.RadioGroup = RadioGroup;
	;
	
	RadioGroup.defaultProps = {
	  Component: "div"
	};
	
	RadioGroup.propTypes = {
	  name: _propTypes2['default'].string,
	  selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].bool]),
	  onChange: _propTypes2['default'].func,
	  children: _propTypes2['default'].node.isRequired,
	  Component: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func, _propTypes2['default'].object])
	};
	
	RadioGroup.childContextTypes = {
	  radioGroup: _propTypes2['default'].object
	};

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(818);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(77);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(38);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Tab = __webpack_require__(135);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function renderChildren(props) {
	  return _react2.default.Children.map(props.children, function (child) {
	    // if child is not a tab we don't need to clone it
	    // since we don't need to add custom props
	
	    if (child.type !== _Tab2.default) {
	      return child;
	    }
	
	    var clonedProps = {
	      activeTabClassName: props.activeTabClassName,
	      disabledTabClassName: props.disabledTabClassName
	    };
	
	    return _react2.default.cloneElement(child, clonedProps);
	  });
	}
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'TabList',
	
	  propTypes: {
	    className: _propTypes2.default.string,
	    activeTabClassName: _propTypes2.default.string,
	    disabledTabClassName: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array])
	  },
	
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        activeTabClassName = _props.activeTabClassName,
	        disabledTabClassName = _props.disabledTabClassName,
	        children = _props.children,
	        attributes = _objectWithoutProperties(_props, ['className', 'activeTabClassName', 'disabledTabClassName', 'children']);
	
	    return _react2.default.createElement(
	      'ul',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs__TabList', className),
	        role: 'tablist'
	      }),
	      renderChildren({ activeTabClassName: activeTabClassName, disabledTabClassName: disabledTabClassName, children: children })
	    );
	  }
	});

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var setFunctionName = __webpack_require__(1277);
	
	var $Object = Object;
	var $TypeError = TypeError;
	
	module.exports = setFunctionName(function flags() {
		if (this != null && this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.hasIndices) {
			result += 'd';
		}
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.unicodeSets) {
			result += 'v';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	}, 'get flags', true);
	


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(515);
	
	var supportsDescriptors = __webpack_require__(91).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	
	module.exports = function getPolyfill() {
		if (supportsDescriptors && (/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (
				descriptor
				&& typeof descriptor.get === 'function'
				&& typeof RegExp.prototype.dotAll === 'boolean'
				&& typeof RegExp.prototype.hasIndices === 'boolean'
			) {
				/* eslint getter-return: 0 */
				var calls = '';
				var o = {};
				Object.defineProperty(o, 'hasIndices', {
					get: function () {
						calls += 'd';
					}
				});
				Object.defineProperty(o, 'sticky', {
					get: function () {
						calls += 'y';
					}
				});
				if (calls === 'dy') {
					return descriptor.get;
				}
			}
		}
		return implementation;
	};


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1273);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var formats = __webpack_require__(201);
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    while (queue.length > 1) {
	        var item = queue.pop();
	        var obj = item.obj[item.prop];
	
	        if (isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    /* eslint no-param-reassign: 0 */
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (isArray(target)) {
	            target.push(source);
	        } else if (target && typeof target === 'object') {
	            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (!target || typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (isArray(target) && !isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (isArray(target) && isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                var targetItem = target[i];
	                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
	                    target[i] = merge(targetItem, item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str, decoder, charset) {
	    var strWithoutPlus = str.replace(/\+/g, ' ');
	    if (charset === 'iso-8859-1') {
	        // unescape never throws, no try...catch needed:
	        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
	    }
	    // utf-8
	    try {
	        return decodeURIComponent(strWithoutPlus);
	    } catch (e) {
	        return strWithoutPlus;
	    }
	};
	
	var encode = function encode(str, defaultEncoder, charset, kind, format) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = str;
	    if (typeof str === 'symbol') {
	        string = Symbol.prototype.toString.call(str);
	    } else if (typeof str !== 'string') {
	        string = String(str);
	    }
	
	    if (charset === 'iso-8859-1') {
	        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
	            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
	        });
	    }
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        /* eslint operator-linebreak: [2, "before"] */
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    compactQueue(queue);
	
	    return value;
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (!obj || typeof obj !== 'object') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	var combine = function combine(a, b) {
	    return [].concat(a, b);
	};
	
	var maybeMap = function maybeMap(val, fn) {
	    if (isArray(val)) {
	        var mapped = [];
	        for (var i = 0; i < val.length; i += 1) {
	            mapped.push(fn(val[i]));
	        }
	        return mapped;
	    }
	    return fn(val);
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    combine: combine,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    maybeMap: maybeMap,
	    merge: merge
	};


/***/ },
/* 519 */
/***/ function(module, exports) {

	/**
	 * Convert array of 16 byte values to UUID string format of the form:
	 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
	 */
	var byteToHex = [];
	for (var i = 0; i < 256; ++i) {
	  byteToHex[i] = (i + 0x100).toString(16).substr(1);
	}
	
	function bytesToUuid(buf, offset) {
	  var i = offset || 0;
	  var bth = byteToHex;
	  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	  return ([
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]], '-',
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]],
	    bth[buf[i++]], bth[buf[i++]]
	  ]).join('');
	}
	
	module.exports = bytesToUuid;


/***/ },
/* 520 */
/***/ function(module, exports) {

	// Unique ID creation requires a high quality random # generator.  In the
	// browser this is a little complicated due to unknown quality of Math.random()
	// and inconsistent support for the `crypto` API.  We do the best we can via
	// feature-detection
	
	// getRandomValues needs to be invoked in a context where "this" is a Crypto
	// implementation. Also, find the complete implementation of crypto on IE11.
	var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
	                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));
	
	if (getRandomValues) {
	  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
	  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
	
	  module.exports = function whatwgRNG() {
	    getRandomValues(rnds8);
	    return rnds8;
	  };
	} else {
	  // Math.random()-based (RNG)
	  //
	  // If all else fails, use Math.random().  It's fast, but is of unspecified
	  // quality.
	  var rnds = new Array(16);
	
	  module.exports = function mathRNG() {
	    for (var i = 0, r; i < 16; i++) {
	      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
	      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
	    }
	
	    return rnds;
	  };
	}


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1292);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ },
/* 522 */
/***/ function(module, exports) {

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(202);
	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) return arrayLikeToArray(arr);
	}
	module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 524 */
/***/ function(module, exports) {

	function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
	  try {
	    var info = gen[key](arg);
	    var value = info.value;
	  } catch (error) {
	    reject(error);
	    return;
	  }
	  if (info.done) {
	    resolve(value);
	  } else {
	    Promise.resolve(value).then(_next, _throw);
	  }
	}
	function _asyncToGenerator(fn) {
	  return function () {
	    var self = this,
	      args = arguments;
	    return new Promise(function (resolve, reject) {
	      var gen = fn.apply(self, args);
	      function _next(value) {
	        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
	      }
	      function _throw(err) {
	        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
	      }
	      _next(undefined);
	    });
	  };
	}
	module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(139);
	var isNativeReflectConstruct = __webpack_require__(203);
	function _construct(Parent, args, Class) {
	  if (isNativeReflectConstruct()) {
	    module.exports = _construct = Reflect.construct.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
	  } else {
	    module.exports = _construct = function _construct(Parent, args, Class) {
	      var a = [null];
	      a.push.apply(a, args);
	      var Constructor = Function.bind.apply(Parent, a);
	      var instance = new Constructor();
	      if (Class) setPrototypeOf(instance, Class.prototype);
	      return instance;
	    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  }
	  return _construct.apply(null, arguments);
	}
	module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	var unsupportedIterableToArray = __webpack_require__(140);
	function _createForOfIteratorHelper(o, allowArrayLike) {
	  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
	  if (!it) {
	    if (Array.isArray(o) || (it = unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
	      if (it) o = it;
	      var i = 0;
	      var F = function F() {};
	      return {
	        s: F,
	        n: function n() {
	          if (i >= o.length) return {
	            done: true
	          };
	          return {
	            done: false,
	            value: o[i++]
	          };
	        },
	        e: function e(_e) {
	          throw _e;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var normalCompletion = true,
	    didErr = false,
	    err;
	  return {
	    s: function s() {
	      it = it.call(o);
	    },
	    n: function n() {
	      var step = it.next();
	      normalCompletion = step.done;
	      return step;
	    },
	    e: function e(_e2) {
	      didErr = true;
	      err = _e2;
	    },
	    f: function f() {
	      try {
	        if (!normalCompletion && it["return"] != null) it["return"]();
	      } finally {
	        if (didErr) throw err;
	      }
	    }
	  };
	}
	module.exports = _createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	var superPropBase = __webpack_require__(533);
	function _get() {
	  if (typeof Reflect !== "undefined" && Reflect.get) {
	    module.exports = _get = Reflect.get.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
	  } else {
	    module.exports = _get = function _get(target, property, receiver) {
	      var base = superPropBase(target, property);
	      if (!base) return;
	      var desc = Object.getOwnPropertyDescriptor(base, property);
	      if (desc.get) {
	        return desc.get.call(arguments.length < 3 ? target : receiver);
	      }
	      return desc.value;
	    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  }
	  return _get.apply(this, arguments);
	}
	module.exports = _get, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 528 */
/***/ function(module, exports) {

	function _iterableToArray(iter) {
	  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
	}
	module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 529 */
/***/ function(module, exports) {

	function _iterableToArrayLimit(r, l) {
	  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
	  if (null != t) {
	    var e,
	      n,
	      i,
	      u,
	      a = [],
	      f = !0,
	      o = !1;
	    try {
	      if (i = (t = t.call(r)).next, 0 === l) {
	        if (Object(t) !== t) return;
	        f = !1;
	      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
	    } catch (r) {
	      o = !0, n = r;
	    } finally {
	      try {
	        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
	      } finally {
	        if (o) throw n;
	      }
	    }
	    return a;
	  }
	}
	module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 530 */
/***/ function(module, exports) {

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 531 */
/***/ function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(5)["default"];
	function _regeneratorRuntime() {
	  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
	  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
	    return e;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  var t,
	    e = {},
	    r = Object.prototype,
	    n = r.hasOwnProperty,
	    o = Object.defineProperty || function (t, e, r) {
	      t[e] = r.value;
	    },
	    i = "function" == typeof Symbol ? Symbol : {},
	    a = i.iterator || "@@iterator",
	    c = i.asyncIterator || "@@asyncIterator",
	    u = i.toStringTag || "@@toStringTag";
	  function define(t, e, r) {
	    return Object.defineProperty(t, e, {
	      value: r,
	      enumerable: !0,
	      configurable: !0,
	      writable: !0
	    }), t[e];
	  }
	  try {
	    define({}, "");
	  } catch (t) {
	    define = function define(t, e, r) {
	      return t[e] = r;
	    };
	  }
	  function wrap(t, e, r, n) {
	    var i = e && e.prototype instanceof Generator ? e : Generator,
	      a = Object.create(i.prototype),
	      c = new Context(n || []);
	    return o(a, "_invoke", {
	      value: makeInvokeMethod(t, r, c)
	    }), a;
	  }
	  function tryCatch(t, e, r) {
	    try {
	      return {
	        type: "normal",
	        arg: t.call(e, r)
	      };
	    } catch (t) {
	      return {
	        type: "throw",
	        arg: t
	      };
	    }
	  }
	  e.wrap = wrap;
	  var h = "suspendedStart",
	    l = "suspendedYield",
	    f = "executing",
	    s = "completed",
	    y = {};
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	  var p = {};
	  define(p, a, function () {
	    return this;
	  });
	  var d = Object.getPrototypeOf,
	    v = d && d(d(values([])));
	  v && v !== r && n.call(v, a) && (p = v);
	  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
	  function defineIteratorMethods(t) {
	    ["next", "throw", "return"].forEach(function (e) {
	      define(t, e, function (t) {
	        return this._invoke(e, t);
	      });
	    });
	  }
	  function AsyncIterator(t, e) {
	    function invoke(r, o, i, a) {
	      var c = tryCatch(t[r], t, o);
	      if ("throw" !== c.type) {
	        var u = c.arg,
	          h = u.value;
	        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
	          invoke("next", t, i, a);
	        }, function (t) {
	          invoke("throw", t, i, a);
	        }) : e.resolve(h).then(function (t) {
	          u.value = t, i(u);
	        }, function (t) {
	          return invoke("throw", t, i, a);
	        });
	      }
	      a(c.arg);
	    }
	    var r;
	    o(this, "_invoke", {
	      value: function value(t, n) {
	        function callInvokeWithMethodAndArg() {
	          return new e(function (e, r) {
	            invoke(t, n, e, r);
	          });
	        }
	        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	      }
	    });
	  }
	  function makeInvokeMethod(e, r, n) {
	    var o = h;
	    return function (i, a) {
	      if (o === f) throw new Error("Generator is already running");
	      if (o === s) {
	        if ("throw" === i) throw a;
	        return {
	          value: t,
	          done: !0
	        };
	      }
	      for (n.method = i, n.arg = a;;) {
	        var c = n.delegate;
	        if (c) {
	          var u = maybeInvokeDelegate(c, n);
	          if (u) {
	            if (u === y) continue;
	            return u;
	          }
	        }
	        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
	          if (o === h) throw o = s, n.arg;
	          n.dispatchException(n.arg);
	        } else "return" === n.method && n.abrupt("return", n.arg);
	        o = f;
	        var p = tryCatch(e, r, n);
	        if ("normal" === p.type) {
	          if (o = n.done ? s : l, p.arg === y) continue;
	          return {
	            value: p.arg,
	            done: n.done
	          };
	        }
	        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
	      }
	    };
	  }
	  function maybeInvokeDelegate(e, r) {
	    var n = r.method,
	      o = e.iterator[n];
	    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
	    var i = tryCatch(o, e.iterator, r.arg);
	    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
	    var a = i.arg;
	    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
	  }
	  function pushTryEntry(t) {
	    var e = {
	      tryLoc: t[0]
	    };
	    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
	  }
	  function resetTryEntry(t) {
	    var e = t.completion || {};
	    e.type = "normal", delete e.arg, t.completion = e;
	  }
	  function Context(t) {
	    this.tryEntries = [{
	      tryLoc: "root"
	    }], t.forEach(pushTryEntry, this), this.reset(!0);
	  }
	  function values(e) {
	    if (e || "" === e) {
	      var r = e[a];
	      if (r) return r.call(e);
	      if ("function" == typeof e.next) return e;
	      if (!isNaN(e.length)) {
	        var o = -1,
	          i = function next() {
	            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
	            return next.value = t, next.done = !0, next;
	          };
	        return i.next = i;
	      }
	    }
	    throw new TypeError(_typeof(e) + " is not iterable");
	  }
	  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
	    value: GeneratorFunctionPrototype,
	    configurable: !0
	  }), o(GeneratorFunctionPrototype, "constructor", {
	    value: GeneratorFunction,
	    configurable: !0
	  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
	    var e = "function" == typeof t && t.constructor;
	    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
	  }, e.mark = function (t) {
	    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
	  }, e.awrap = function (t) {
	    return {
	      __await: t
	    };
	  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
	    return this;
	  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
	    void 0 === i && (i = Promise);
	    var a = new AsyncIterator(wrap(t, r, n, o), i);
	    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
	      return t.done ? t.value : a.next();
	    });
	  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
	    return this;
	  }), define(g, "toString", function () {
	    return "[object Generator]";
	  }), e.keys = function (t) {
	    var e = Object(t),
	      r = [];
	    for (var n in e) r.push(n);
	    return r.reverse(), function next() {
	      for (; r.length;) {
	        var t = r.pop();
	        if (t in e) return next.value = t, next.done = !1, next;
	      }
	      return next.done = !0, next;
	    };
	  }, e.values = values, Context.prototype = {
	    constructor: Context,
	    reset: function reset(e) {
	      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
	    },
	    stop: function stop() {
	      this.done = !0;
	      var t = this.tryEntries[0].completion;
	      if ("throw" === t.type) throw t.arg;
	      return this.rval;
	    },
	    dispatchException: function dispatchException(e) {
	      if (this.done) throw e;
	      var r = this;
	      function handle(n, o) {
	        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
	      }
	      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
	        var i = this.tryEntries[o],
	          a = i.completion;
	        if ("root" === i.tryLoc) return handle("end");
	        if (i.tryLoc <= this.prev) {
	          var c = n.call(i, "catchLoc"),
	            u = n.call(i, "finallyLoc");
	          if (c && u) {
	            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
	            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
	          } else if (c) {
	            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
	          } else {
	            if (!u) throw new Error("try statement without catch or finally");
	            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
	          }
	        }
	      }
	    },
	    abrupt: function abrupt(t, e) {
	      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
	        var o = this.tryEntries[r];
	        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
	          var i = o;
	          break;
	        }
	      }
	      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
	      var a = i ? i.completion : {};
	      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
	    },
	    complete: function complete(t, e) {
	      if ("throw" === t.type) throw t.arg;
	      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
	    },
	    finish: function finish(t) {
	      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
	        var r = this.tryEntries[e];
	        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
	      }
	    },
	    "catch": function _catch(t) {
	      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
	        var r = this.tryEntries[e];
	        if (r.tryLoc === t) {
	          var n = r.completion;
	          if ("throw" === n.type) {
	            var o = n.arg;
	            resetTryEntry(r);
	          }
	          return o;
	        }
	      }
	      throw new Error("illegal catch attempt");
	    },
	    delegateYield: function delegateYield(e, r, n) {
	      return this.delegate = {
	        iterator: values(e),
	        resultName: r,
	        nextLoc: n
	      }, "next" === this.method && (this.arg = t), y;
	    }
	  }, e;
	}
	module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototypeOf = __webpack_require__(13);
	function _superPropBase(object, property) {
	  while (!Object.prototype.hasOwnProperty.call(object, property)) {
	    object = getPrototypeOf(object);
	    if (object === null) break;
	  }
	  return object;
	}
	module.exports = _superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(5)["default"];
	function _toPrimitive(input, hint) {
	  if (_typeof(input) !== "object" || input === null) return input;
	  var prim = input[Symbol.toPrimitive];
	  if (prim !== undefined) {
	    var res = prim.call(input, hint || "default");
	    if (_typeof(res) !== "object") return res;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return (hint === "string" ? String : Number)(input);
	}
	module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 535 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/// <reference types="@fullcalendar/core-preact" />
	if (typeof FullCalendarVDom === 'undefined') {
	    throw new Error('Please import the top-level fullcalendar lib before attempting to import a plugin.');
	}
	var Component = FullCalendarVDom.Component;
	var createElement = FullCalendarVDom.createElement;
	var render = FullCalendarVDom.render;
	var createRef = FullCalendarVDom.createRef;
	var Fragment = FullCalendarVDom.Fragment;
	var createContext = FullCalendarVDom.createContext;
	var createPortal = FullCalendarVDom.createPortal;
	var flushSync = FullCalendarVDom.flushSync;
	var unmountComponentAtNode = FullCalendarVDom.unmountComponentAtNode;
	/* eslint-enable */
	
	exports.Component = Component;
	exports.Fragment = Fragment;
	exports.createContext = createContext;
	exports.createElement = createElement;
	exports.createPortal = createPortal;
	exports.createRef = createRef;
	exports.flushSync = flushSync;
	exports.render = render;
	exports.unmountComponentAtNode = unmountComponentAtNode;


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(80);
	__webpack_require__(537);
	var React = __webpack_require__(2);
	var common = __webpack_require__(70);
	
	var FullCalendar = /** @class */ (function (_super) {
	    tslib.__extends(FullCalendar, _super);
	    function FullCalendar() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this._calendarApi = new common.CalendarApi();
	        return _this;
	    }
	    FullCalendar.prototype.render = function () {
	        return (React.createElement(common.CalendarDataProvider, { optionOverrides: this.props, calendarApi: this._calendarApi }, function (data) { return (React.createElement(common.CalendarRoot, { options: data.calendarOptions, theme: data.theme, emitter: data.emitter }, function (classNames, height, isHeightAuto, forPrint) { return (React.createElement("div", { className: classNames.join(' '), style: { height: height } },
	            React.createElement(common.CalendarContent, tslib.__assign({ isHeightAuto: isHeightAuto, forPrint: forPrint }, data)))); })); }));
	    };
	    FullCalendar.prototype.getApi = function () {
	        return this._calendarApi;
	    };
	    return FullCalendar;
	}(React.Component));
	
	Object.keys(common).forEach(function (k) {
	    if (k !== 'default') Object.defineProperty(exports, k, {
	        enumerable: true,
	        get: function () {
	            return common[k];
	        }
	    });
	});
	exports.default = FullCalendar;


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var React = __webpack_require__(2);
	var reactDom = __webpack_require__(37);
	
	(typeof globalThis !== 'undefined' ? globalThis : window).FullCalendarVDom = {
	    Component: React.Component,
	    createElement: React.createElement,
	    render: reactDom.render,
	    createRef: React.createRef,
	    Fragment: React.Fragment,
	    createContext: React.createContext,
	    createPortal: reactDom.createPortal,
	    flushSync: flushSync,
	    unmountComponentAtNode: reactDom.unmountComponentAtNode // never called by FullCalendar's React component
	};
	function flushSync(callback) {
	    // always sync from top-level
	    callback();
	}
	
	exports.flushSync = flushSync;


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	FullCalendar Scheduler v5.11.5
	Docs & License: https://fullcalendar.io/scheduler
	(c) 2022 Adam Shaw
	*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var common = __webpack_require__(70);
	var premiumCommonPlugin = __webpack_require__(99);
	var tslib = __webpack_require__(80);
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var premiumCommonPlugin__default = /*#__PURE__*/_interopDefaultLegacy(premiumCommonPlugin);
	
	function massageEventDragMutation(eventMutation, hit0, hit1) {
	    var resource0 = hit0.dateSpan.resourceId;
	    var resource1 = hit1.dateSpan.resourceId;
	    if (resource0 && resource1 &&
	        resource0 !== resource1) {
	        eventMutation.resourceMutation = {
	            matchResourceId: resource0,
	            setResourceId: resource1,
	        };
	    }
	}
	/*
	TODO: all this would be much easier if we were using a hash!
	*/
	function applyEventDefMutation(eventDef, mutation, context) {
	    var resourceMutation = mutation.resourceMutation;
	    if (resourceMutation && computeResourceEditable(eventDef, context)) {
	        var index = eventDef.resourceIds.indexOf(resourceMutation.matchResourceId);
	        if (index !== -1) {
	            var resourceIds = eventDef.resourceIds.slice(); // copy
	            resourceIds.splice(index, 1); // remove
	            if (resourceIds.indexOf(resourceMutation.setResourceId) === -1) { // not already in there
	                resourceIds.push(resourceMutation.setResourceId); // add
	            }
	            eventDef.resourceIds = resourceIds;
	        }
	    }
	}
	/*
	HACK
	TODO: use EventUi system instead of this
	*/
	function computeResourceEditable(eventDef, context) {
	    var resourceEditable = eventDef.resourceEditable;
	    if (resourceEditable == null) {
	        var source = eventDef.sourceId && context.getCurrentData().eventSources[eventDef.sourceId];
	        if (source) {
	            resourceEditable = source.extendedProps.resourceEditable; // used the Source::extendedProps hack
	        }
	        if (resourceEditable == null) {
	            resourceEditable = context.options.eventResourceEditable;
	            if (resourceEditable == null) {
	                resourceEditable = context.options.editable; // TODO: use defaults system instead
	            }
	        }
	    }
	    return resourceEditable;
	}
	function transformEventDrop(mutation, context) {
	    var resourceMutation = mutation.resourceMutation;
	    if (resourceMutation) {
	        var calendarApi = context.calendarApi;
	        return {
	            oldResource: calendarApi.getResourceById(resourceMutation.matchResourceId),
	            newResource: calendarApi.getResourceById(resourceMutation.setResourceId),
	        };
	    }
	    return {
	        oldResource: null,
	        newResource: null,
	    };
	}
	
	var ResourceDataAdder = /** @class */ (function () {
	    function ResourceDataAdder() {
	        this.filterResources = common.memoize(filterResources);
	    }
	    ResourceDataAdder.prototype.transform = function (viewProps, calendarProps) {
	        if (calendarProps.viewSpec.optionDefaults.needsResourceData) {
	            return {
	                resourceStore: this.filterResources(calendarProps.resourceStore, calendarProps.options.filterResourcesWithEvents, calendarProps.eventStore, calendarProps.dateProfile.activeRange),
	                resourceEntityExpansions: calendarProps.resourceEntityExpansions,
	            };
	        }
	        return null;
	    };
	    return ResourceDataAdder;
	}());
	function filterResources(resourceStore, doFilterResourcesWithEvents, eventStore, activeRange) {
	    if (doFilterResourcesWithEvents) {
	        var instancesInRange = filterEventInstancesInRange(eventStore.instances, activeRange);
	        var hasEvents_1 = computeHasEvents(instancesInRange, eventStore.defs);
	        tslib.__assign(hasEvents_1, computeAncestorHasEvents(hasEvents_1, resourceStore));
	        return common.filterHash(resourceStore, function (resource, resourceId) { return hasEvents_1[resourceId]; });
	    }
	    return resourceStore;
	}
	function filterEventInstancesInRange(eventInstances, activeRange) {
	    return common.filterHash(eventInstances, function (eventInstance) { return common.rangesIntersect(eventInstance.range, activeRange); });
	}
	function computeHasEvents(eventInstances, eventDefs) {
	    var hasEvents = {};
	    for (var instanceId in eventInstances) {
	        var instance = eventInstances[instanceId];
	        for (var _i = 0, _a = eventDefs[instance.defId].resourceIds; _i < _a.length; _i++) {
	            var resourceId = _a[_i];
	            hasEvents[resourceId] = true;
	        }
	    }
	    return hasEvents;
	}
	/*
	mark resources as having events if any of their ancestors have them
	NOTE: resourceStore might not have all the resources that hasEvents{} has keyed
	*/
	function computeAncestorHasEvents(hasEvents, resourceStore) {
	    var res = {};
	    for (var resourceId in hasEvents) {
	        var resource = void 0;
	        while ((resource = resourceStore[resourceId])) {
	            resourceId = resource.parentId; // now functioning as the parentId
	            if (resourceId) {
	                res[resourceId] = true;
	            }
	            else {
	                break;
	            }
	        }
	    }
	    return res;
	}
	/*
	for making sure events that have editable resources are always draggable in resource views
	*/
	function transformIsDraggable(val, eventDef, eventUi, context) {
	    if (!val) {
	        var state = context.getCurrentData();
	        var viewSpec = state.viewSpecs[state.currentViewType];
	        if (viewSpec.optionDefaults.needsResourceData) {
	            if (computeResourceEditable(eventDef, context)) {
	                return true;
	            }
	        }
	    }
	    return val;
	}
	
	// for when non-resource view should be given EventUi info (for event coloring/constraints based off of resource data)
	var ResourceEventConfigAdder = /** @class */ (function () {
	    function ResourceEventConfigAdder() {
	        this.buildResourceEventUis = common.memoize(buildResourceEventUis, common.isPropsEqual);
	        this.injectResourceEventUis = common.memoize(injectResourceEventUis);
	    }
	    ResourceEventConfigAdder.prototype.transform = function (viewProps, calendarProps) {
	        if (!calendarProps.viewSpec.optionDefaults.needsResourceData) {
	            return {
	                eventUiBases: this.injectResourceEventUis(viewProps.eventUiBases, viewProps.eventStore.defs, this.buildResourceEventUis(calendarProps.resourceStore)),
	            };
	        }
	        return null;
	    };
	    return ResourceEventConfigAdder;
	}());
	function buildResourceEventUis(resourceStore) {
	    return common.mapHash(resourceStore, function (resource) { return resource.ui; });
	}
	function injectResourceEventUis(eventUiBases, eventDefs, resourceEventUis) {
	    return common.mapHash(eventUiBases, function (eventUi, defId) {
	        if (defId) { // not the '' key
	            return injectResourceEventUi(eventUi, eventDefs[defId], resourceEventUis);
	        }
	        return eventUi;
	    });
	}
	function injectResourceEventUi(origEventUi, eventDef, resourceEventUis) {
	    var parts = [];
	    // first resource takes precedence, which fights with the ordering of combineEventUis, thus the unshifts
	    for (var _i = 0, _a = eventDef.resourceIds; _i < _a.length; _i++) {
	        var resourceId = _a[_i];
	        if (resourceEventUis[resourceId]) {
	            parts.unshift(resourceEventUis[resourceId]);
	        }
	    }
	    parts.unshift(origEventUi);
	    return common.combineEventUis(parts);
	}
	
	var defs = []; // TODO: use plugin system
	function registerResourceSourceDef(def) {
	    defs.push(def);
	}
	function getResourceSourceDef(id) {
	    return defs[id];
	}
	function getResourceSourceDefs() {
	    return defs;
	}
	
	// TODO: make this a plugin-able parser
	// TODO: success/failure
	var RESOURCE_SOURCE_REFINERS = {
	    id: String,
	    // for array. TODO: move to resource-array
	    resources: common.identity,
	    // for json feed. TODO: move to resource-json-feed
	    url: String,
	    method: String,
	    startParam: String,
	    endParam: String,
	    timeZoneParam: String,
	    extraParams: common.identity,
	};
	function parseResourceSource(input) {
	    var inputObj;
	    if (typeof input === 'string') {
	        inputObj = { url: input };
	    }
	    else if (typeof input === 'function' || Array.isArray(input)) {
	        inputObj = { resources: input };
	    }
	    else if (typeof input === 'object' && input) { // non-null object
	        inputObj = input;
	    }
	    if (inputObj) {
	        var _a = common.refineProps(inputObj, RESOURCE_SOURCE_REFINERS), refined = _a.refined, extra = _a.extra;
	        warnUnknownProps(extra);
	        var metaRes = buildResourceSourceMeta(refined);
	        if (metaRes) {
	            return {
	                _raw: input,
	                sourceId: common.guid(),
	                sourceDefId: metaRes.sourceDefId,
	                meta: metaRes.meta,
	                publicId: refined.id || '',
	                isFetching: false,
	                latestFetchId: '',
	                fetchRange: null,
	            };
	        }
	    }
	    return null;
	}
	function buildResourceSourceMeta(refined) {
	    var defs = getResourceSourceDefs();
	    for (var i = defs.length - 1; i >= 0; i -= 1) { // later-added plugins take precedence
	        var def = defs[i];
	        var meta = def.parseMeta(refined);
	        if (meta) {
	            return { meta: meta, sourceDefId: i };
	        }
	    }
	    return null;
	}
	function warnUnknownProps(props) {
	    for (var propName in props) {
	        console.warn("Unknown resource prop '" + propName + "'");
	    }
	}
	
	function reduceResourceSource(source, action, context) {
	    var options = context.options, dateProfile = context.dateProfile;
	    if (!source || !action) {
	        return createSource(options.initialResources || options.resources, dateProfile.activeRange, options.refetchResourcesOnNavigate, context);
	    }
	    switch (action.type) {
	        case 'RESET_RESOURCE_SOURCE':
	            return createSource(action.resourceSourceInput, dateProfile.activeRange, options.refetchResourcesOnNavigate, context);
	        case 'PREV': // TODO: how do we track all actions that affect dateProfile :(
	        case 'NEXT':
	        case 'CHANGE_DATE':
	        case 'CHANGE_VIEW_TYPE':
	            return handleRangeChange(source, dateProfile.activeRange, options.refetchResourcesOnNavigate, context);
	        case 'RECEIVE_RESOURCES':
	        case 'RECEIVE_RESOURCE_ERROR':
	            return receiveResponse(source, action.fetchId, action.fetchRange);
	        case 'REFETCH_RESOURCES':
	            return fetchSource(source, dateProfile.activeRange, context);
	        default:
	            return source;
	    }
	}
	function createSource(input, activeRange, refetchResourcesOnNavigate, context) {
	    if (input) {
	        var source = parseResourceSource(input);
	        source = fetchSource(source, refetchResourcesOnNavigate ? activeRange : null, context);
	        return source;
	    }
	    return null;
	}
	function handleRangeChange(source, activeRange, refetchResourcesOnNavigate, context) {
	    if (refetchResourcesOnNavigate &&
	        !doesSourceIgnoreRange(source) &&
	        (!source.fetchRange || !common.rangesEqual(source.fetchRange, activeRange))) {
	        return fetchSource(source, activeRange, context);
	    }
	    return source;
	}
	function doesSourceIgnoreRange(source) {
	    return Boolean(getResourceSourceDef(source.sourceDefId).ignoreRange);
	}
	function fetchSource(source, fetchRange, context) {
	    var sourceDef = getResourceSourceDef(source.sourceDefId);
	    var fetchId = common.guid();
	    sourceDef.fetch({
	        resourceSource: source,
	        range: fetchRange,
	        context: context,
	    }, function (res) {
	        context.dispatch({
	            type: 'RECEIVE_RESOURCES',
	            fetchId: fetchId,
	            fetchRange: fetchRange,
	            rawResources: res.rawResources,
	        });
	    }, function (error) {
	        context.dispatch({
	            type: 'RECEIVE_RESOURCE_ERROR',
	            fetchId: fetchId,
	            fetchRange: fetchRange,
	            error: error,
	        });
	    });
	    return tslib.__assign(tslib.__assign({}, source), { isFetching: true, latestFetchId: fetchId });
	}
	function receiveResponse(source, fetchId, fetchRange) {
	    if (fetchId === source.latestFetchId) {
	        return tslib.__assign(tslib.__assign({}, source), { isFetching: false, fetchRange: fetchRange });
	    }
	    return source;
	}
	
	var PRIVATE_ID_PREFIX = '_fc:';
	var RESOURCE_REFINERS = {
	    id: String,
	    parentId: String,
	    children: common.identity,
	    title: String,
	    businessHours: common.identity,
	    extendedProps: common.identity,
	    // event-ui
	    eventEditable: Boolean,
	    eventStartEditable: Boolean,
	    eventDurationEditable: Boolean,
	    eventConstraint: common.identity,
	    eventOverlap: Boolean,
	    eventAllow: common.identity,
	    eventClassNames: common.parseClassNames,
	    eventBackgroundColor: String,
	    eventBorderColor: String,
	    eventTextColor: String,
	    eventColor: String,
	};
	/*
	needs a full store so that it can populate children too
	*/
	function parseResource(raw, parentId, store, context) {
	    if (parentId === void 0) { parentId = ''; }
	    var _a = common.refineProps(raw, RESOURCE_REFINERS), refined = _a.refined, extra = _a.extra;
	    var resource = {
	        id: refined.id || (PRIVATE_ID_PREFIX + common.guid()),
	        parentId: refined.parentId || parentId,
	        title: refined.title || '',
	        businessHours: refined.businessHours ? common.parseBusinessHours(refined.businessHours, context) : null,
	        ui: common.createEventUi({
	            editable: refined.eventEditable,
	            startEditable: refined.eventStartEditable,
	            durationEditable: refined.eventDurationEditable,
	            constraint: refined.eventConstraint,
	            overlap: refined.eventOverlap,
	            allow: refined.eventAllow,
	            classNames: refined.eventClassNames,
	            backgroundColor: refined.eventBackgroundColor,
	            borderColor: refined.eventBorderColor,
	            textColor: refined.eventTextColor,
	            color: refined.eventColor,
	        }, context),
	        extendedProps: tslib.__assign(tslib.__assign({}, extra), refined.extendedProps),
	    };
	    // help out ResourceApi from having user modify props
	    Object.freeze(resource.ui.classNames);
	    Object.freeze(resource.extendedProps);
	    if (store[resource.id]) ;
	    else {
	        store[resource.id] = resource;
	        if (refined.children) {
	            for (var _i = 0, _b = refined.children; _i < _b.length; _i++) {
	                var childInput = _b[_i];
	                parseResource(childInput, resource.id, store, context);
	            }
	        }
	    }
	    return resource;
	}
	/*
	TODO: use this in more places
	*/
	function getPublicId(id) {
	    if (id.indexOf(PRIVATE_ID_PREFIX) === 0) {
	        return '';
	    }
	    return id;
	}
	
	function reduceResourceStore(store, action, source, context) {
	    if (!store || !action) {
	        return {};
	    }
	    switch (action.type) {
	        case 'RECEIVE_RESOURCES':
	            return receiveRawResources(store, action.rawResources, action.fetchId, source, context);
	        case 'ADD_RESOURCE':
	            return addResource(store, action.resourceHash);
	        case 'REMOVE_RESOURCE':
	            return removeResource(store, action.resourceId);
	        case 'SET_RESOURCE_PROP':
	            return setResourceProp(store, action.resourceId, action.propName, action.propValue);
	        case 'SET_RESOURCE_EXTENDED_PROP':
	            return setResourceExtendedProp(store, action.resourceId, action.propName, action.propValue);
	        default:
	            return store;
	    }
	}
	function receiveRawResources(existingStore, inputs, fetchId, source, context) {
	    if (source.latestFetchId === fetchId) {
	        var nextStore = {};
	        for (var _i = 0, inputs_1 = inputs; _i < inputs_1.length; _i++) {
	            var input = inputs_1[_i];
	            parseResource(input, '', nextStore, context);
	        }
	        return nextStore;
	    }
	    return existingStore;
	}
	function addResource(existingStore, additions) {
	    // TODO: warn about duplicate IDs
	    return tslib.__assign(tslib.__assign({}, existingStore), additions);
	}
	function removeResource(existingStore, resourceId) {
	    var newStore = tslib.__assign({}, existingStore);
	    delete newStore[resourceId];
	    // promote children
	    for (var childResourceId in newStore) { // a child, *maybe* but probably not
	        if (newStore[childResourceId].parentId === resourceId) {
	            newStore[childResourceId] = tslib.__assign(tslib.__assign({}, newStore[childResourceId]), { parentId: '' });
	        }
	    }
	    return newStore;
	}
	function setResourceProp(existingStore, resourceId, name, value) {
	    var _a, _b;
	    var existingResource = existingStore[resourceId];
	    // TODO: sanitization
	    if (existingResource) {
	        return tslib.__assign(tslib.__assign({}, existingStore), (_a = {}, _a[resourceId] = tslib.__assign(tslib.__assign({}, existingResource), (_b = {}, _b[name] = value, _b)), _a));
	    }
	    return existingStore;
	}
	function setResourceExtendedProp(existingStore, resourceId, name, value) {
	    var _a, _b;
	    var existingResource = existingStore[resourceId];
	    if (existingResource) {
	        return tslib.__assign(tslib.__assign({}, existingStore), (_a = {}, _a[resourceId] = tslib.__assign(tslib.__assign({}, existingResource), { extendedProps: tslib.__assign(tslib.__assign({}, existingResource.extendedProps), (_b = {}, _b[name] = value, _b)) }), _a));
	    }
	    return existingStore;
	}
	
	function reduceResourceEntityExpansions(expansions, action) {
	    var _a;
	    if (!expansions || !action) {
	        return {};
	    }
	    switch (action.type) {
	        case 'SET_RESOURCE_ENTITY_EXPANDED':
	            return tslib.__assign(tslib.__assign({}, expansions), (_a = {}, _a[action.id] = action.isExpanded, _a));
	        default:
	            return expansions;
	    }
	}
	
	function reduceResources(state, action, context) {
	    var resourceSource = reduceResourceSource(state && state.resourceSource, action, context);
	    var resourceStore = reduceResourceStore(state && state.resourceStore, action, resourceSource, context);
	    var resourceEntityExpansions = reduceResourceEntityExpansions(state && state.resourceEntityExpansions, action);
	    return {
	        resourceSource: resourceSource,
	        resourceStore: resourceStore,
	        resourceEntityExpansions: resourceEntityExpansions,
	    };
	}
	
	var EVENT_REFINERS = {
	    resourceId: String,
	    resourceIds: common.identity,
	    resourceEditable: Boolean,
	};
	function generateEventDefResourceMembers(refined) {
	    return {
	        resourceIds: ensureStringArray(refined.resourceIds)
	            .concat(refined.resourceId ? [refined.resourceId] : []),
	        resourceEditable: refined.resourceEditable,
	    };
	}
	function ensureStringArray(items) {
	    return (items || []).map(function (item) { return String(item); });
	}
	
	function transformDateSelectionJoin(hit0, hit1) {
	    var resourceId0 = hit0.dateSpan.resourceId;
	    var resourceId1 = hit1.dateSpan.resourceId;
	    if (resourceId0 && resourceId1) {
	        return { resourceId: resourceId0 };
	    }
	    return null;
	}
	
	var ResourceApi = /** @class */ (function () {
	    function ResourceApi(_context, _resource) {
	        this._context = _context;
	        this._resource = _resource;
	    }
	    ResourceApi.prototype.setProp = function (name, value) {
	        var oldResource = this._resource;
	        this._context.dispatch({
	            type: 'SET_RESOURCE_PROP',
	            resourceId: oldResource.id,
	            propName: name,
	            propValue: value,
	        });
	        this.sync(oldResource);
	    };
	    ResourceApi.prototype.setExtendedProp = function (name, value) {
	        var oldResource = this._resource;
	        this._context.dispatch({
	            type: 'SET_RESOURCE_EXTENDED_PROP',
	            resourceId: oldResource.id,
	            propName: name,
	            propValue: value,
	        });
	        this.sync(oldResource);
	    };
	    ResourceApi.prototype.sync = function (oldResource) {
	        var context = this._context;
	        var resourceId = oldResource.id;
	        // TODO: what if dispatch didn't complete synchronously?
	        this._resource = context.getCurrentData().resourceStore[resourceId];
	        context.emitter.trigger('resourceChange', {
	            oldResource: new ResourceApi(context, oldResource),
	            resource: this,
	            revert: function () {
	                var _a;
	                context.dispatch({
	                    type: 'ADD_RESOURCE',
	                    resourceHash: (_a = {},
	                        _a[resourceId] = oldResource,
	                        _a),
	                });
	            },
	        });
	    };
	    ResourceApi.prototype.remove = function () {
	        var context = this._context;
	        var internalResource = this._resource;
	        var resourceId = internalResource.id;
	        context.dispatch({
	            type: 'REMOVE_RESOURCE',
	            resourceId: resourceId,
	        });
	        context.emitter.trigger('resourceRemove', {
	            resource: this,
	            revert: function () {
	                var _a;
	                context.dispatch({
	                    type: 'ADD_RESOURCE',
	                    resourceHash: (_a = {},
	                        _a[resourceId] = internalResource,
	                        _a),
	                });
	            },
	        });
	    };
	    ResourceApi.prototype.getParent = function () {
	        var context = this._context;
	        var parentId = this._resource.parentId;
	        if (parentId) {
	            return new ResourceApi(context, context.getCurrentData().resourceSource[parentId]);
	        }
	        return null;
	    };
	    ResourceApi.prototype.getChildren = function () {
	        var thisResourceId = this._resource.id;
	        var context = this._context;
	        var resourceStore = context.getCurrentData().resourceStore;
	        var childApis = [];
	        for (var resourceId in resourceStore) {
	            if (resourceStore[resourceId].parentId === thisResourceId) {
	                childApis.push(new ResourceApi(context, resourceStore[resourceId]));
	            }
	        }
	        return childApis;
	    };
	    /*
	    this is really inefficient!
	    TODO: make EventApi::resourceIds a hash or keep an index in the Calendar's state
	    */
	    ResourceApi.prototype.getEvents = function () {
	        var thisResourceId = this._resource.id;
	        var context = this._context;
	        var _a = context.getCurrentData().eventStore, defs = _a.defs, instances = _a.instances;
	        var eventApis = [];
	        for (var instanceId in instances) {
	            var instance = instances[instanceId];
	            var def = defs[instance.defId];
	            if (def.resourceIds.indexOf(thisResourceId) !== -1) { // inefficient!!!
	                eventApis.push(new common.EventApi(context, def, instance));
	            }
	        }
	        return eventApis;
	    };
	    Object.defineProperty(ResourceApi.prototype, "id", {
	        get: function () { return getPublicId(this._resource.id); },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ResourceApi.prototype, "title", {
	        get: function () { return this._resource.title; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ResourceApi.prototype, "eventConstraint", {
	        get: function () { return this._resource.ui.constraints[0] || null; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ResourceApi.prototype, "eventOverlap", {
	        get: function () { return this._resource.ui.overlap; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ResourceApi.prototype, "eventAllow", {
	        get: function () { return this._resource.ui.allows[0] || null; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ResourceApi.prototype, "eventBackgroundColor", {
	        get: function () { return this._resource.ui.backgroundColor; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ResourceApi.prototype, "eventBorderColor", {
	        get: function () { return this._resource.ui.borderColor; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ResourceApi.prototype, "eventTextColor", {
	        get: function () { return this._resource.ui.textColor; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ResourceApi.prototype, "eventClassNames", {
	        // NOTE: user can't modify these because Object.freeze was called in event-def parsing
	        get: function () { return this._resource.ui.classNames; },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ResourceApi.prototype, "extendedProps", {
	        get: function () { return this._resource.extendedProps; },
	        enumerable: false,
	        configurable: true
	    });
	    ResourceApi.prototype.toPlainObject = function (settings) {
	        if (settings === void 0) { settings = {}; }
	        var internal = this._resource;
	        var ui = internal.ui;
	        var publicId = this.id;
	        var res = {};
	        if (publicId) {
	            res.id = publicId;
	        }
	        if (internal.title) {
	            res.title = internal.title;
	        }
	        if (settings.collapseEventColor && ui.backgroundColor && ui.backgroundColor === ui.borderColor) {
	            res.eventColor = ui.backgroundColor;
	        }
	        else {
	            if (ui.backgroundColor) {
	                res.eventBackgroundColor = ui.backgroundColor;
	            }
	            if (ui.borderColor) {
	                res.eventBorderColor = ui.borderColor;
	            }
	        }
	        if (ui.textColor) {
	            res.eventTextColor = ui.textColor;
	        }
	        if (ui.classNames.length) {
	            res.eventClassNames = ui.classNames;
	        }
	        if (Object.keys(internal.extendedProps).length) {
	            if (settings.collapseExtendedProps) {
	                tslib.__assign(res, internal.extendedProps);
	            }
	            else {
	                res.extendedProps = internal.extendedProps;
	            }
	        }
	        return res;
	    };
	    ResourceApi.prototype.toJSON = function () {
	        return this.toPlainObject();
	    };
	    return ResourceApi;
	}());
	function buildResourceApis(resourceStore, context) {
	    var resourceApis = [];
	    for (var resourceId in resourceStore) {
	        resourceApis.push(new ResourceApi(context, resourceStore[resourceId]));
	    }
	    return resourceApis;
	}
	
	common.CalendarApi.prototype.addResource = function (input, scrollTo) {
	    var _a;
	    var _this = this;
	    if (scrollTo === void 0) { scrollTo = true; }
	    var currentState = this.getCurrentData();
	    var resourceHash;
	    var resource;
	    if (input instanceof ResourceApi) {
	        resource = input._resource;
	        resourceHash = (_a = {}, _a[resource.id] = resource, _a);
	    }
	    else {
	        resourceHash = {};
	        resource = parseResource(input, '', resourceHash, currentState);
	    }
	    this.dispatch({
	        type: 'ADD_RESOURCE',
	        resourceHash: resourceHash,
	    });
	    if (scrollTo) {
	        // TODO: wait til dispatch completes somehow
	        this.trigger('_scrollRequest', { resourceId: resource.id });
	    }
	    var resourceApi = new ResourceApi(currentState, resource);
	    currentState.emitter.trigger('resourceAdd', {
	        resource: resourceApi,
	        revert: function () {
	            _this.dispatch({
	                type: 'REMOVE_RESOURCE',
	                resourceId: resource.id,
	            });
	        },
	    });
	    return resourceApi;
	};
	common.CalendarApi.prototype.getResourceById = function (id) {
	    id = String(id);
	    var currentState = this.getCurrentData(); // eslint-disable-line react/no-this-in-sfc
	    if (currentState.resourceStore) { // guard against calendar with no resource functionality
	        var rawResource = currentState.resourceStore[id];
	        if (rawResource) {
	            return new ResourceApi(currentState, rawResource);
	        }
	    }
	    return null;
	};
	common.CalendarApi.prototype.getResources = function () {
	    var currentState = this.getCurrentData();
	    var resourceStore = currentState.resourceStore;
	    var resourceApis = [];
	    if (resourceStore) { // guard against calendar with no resource functionality
	        for (var resourceId in resourceStore) {
	            resourceApis.push(new ResourceApi(currentState, resourceStore[resourceId]));
	        }
	    }
	    return resourceApis;
	};
	common.CalendarApi.prototype.getTopLevelResources = function () {
	    var currentState = this.getCurrentData();
	    var resourceStore = currentState.resourceStore;
	    var resourceApis = [];
	    if (resourceStore) { // guard against calendar with no resource functionality
	        for (var resourceId in resourceStore) {
	            if (!resourceStore[resourceId].parentId) {
	                resourceApis.push(new ResourceApi(currentState, resourceStore[resourceId]));
	            }
	        }
	    }
	    return resourceApis;
	};
	common.CalendarApi.prototype.refetchResources = function () {
	    this.dispatch({
	        type: 'REFETCH_RESOURCES',
	    });
	};
	function transformDatePoint(dateSpan, context) {
	    return dateSpan.resourceId ?
	        { resource: context.calendarApi.getResourceById(dateSpan.resourceId) } :
	        {};
	}
	function transformDateSpan(dateSpan, context) {
	    return dateSpan.resourceId ?
	        { resource: context.calendarApi.getResourceById(dateSpan.resourceId) } :
	        {};
	}
	
	/*
	splits things BASED OFF OF which resources they are associated with.
	creates a '' entry which is when something has NO resource.
	*/
	var ResourceSplitter = /** @class */ (function (_super) {
	    tslib.__extends(ResourceSplitter, _super);
	    function ResourceSplitter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ResourceSplitter.prototype.getKeyInfo = function (props) {
	        return tslib.__assign({ '': {} }, props.resourceStore);
	    };
	    ResourceSplitter.prototype.getKeysForDateSpan = function (dateSpan) {
	        return [dateSpan.resourceId || ''];
	    };
	    ResourceSplitter.prototype.getKeysForEventDef = function (eventDef) {
	        var resourceIds = eventDef.resourceIds;
	        if (!resourceIds.length) {
	            return [''];
	        }
	        return resourceIds;
	    };
	    return ResourceSplitter;
	}(common.Splitter));
	
	function isPropsValidWithResources(combinedProps, context) {
	    var splitter = new ResourceSplitter();
	    var sets = splitter.splitProps(tslib.__assign(tslib.__assign({}, combinedProps), { resourceStore: context.getCurrentData().resourceStore }));
	    for (var resourceId in sets) {
	        var props = sets[resourceId];
	        // merge in event data from the non-resource segment
	        if (resourceId && sets['']) { // current segment is not the non-resource one, and there IS a non-resource one
	            props = tslib.__assign(tslib.__assign({}, props), { eventStore: common.mergeEventStores(sets[''].eventStore, props.eventStore), eventUiBases: tslib.__assign(tslib.__assign({}, sets[''].eventUiBases), props.eventUiBases) });
	        }
	        if (!common.isPropsValid(props, context, { resourceId: resourceId }, filterConfig.bind(null, resourceId))) {
	            return false;
	        }
	    }
	    return true;
	}
	function filterConfig(resourceId, config) {
	    return tslib.__assign(tslib.__assign({}, config), { constraints: filterConstraints(resourceId, config.constraints) });
	}
	function filterConstraints(resourceId, constraints) {
	    return constraints.map(function (constraint) {
	        var defs = constraint.defs;
	        if (defs) { // we are dealing with an EventStore
	            // if any of the events define constraints to resources that are NOT this resource,
	            // then this resource is unconditionally prohibited, which is what a `false` value does.
	            for (var defId in defs) {
	                var resourceIds = defs[defId].resourceIds;
	                if (resourceIds.length && resourceIds.indexOf(resourceId) === -1) { // TODO: use a hash?!!! (for other reasons too)
	                    return false;
	                }
	            }
	        }
	        return constraint;
	    });
	}
	
	function transformExternalDef(dateSpan) {
	    return dateSpan.resourceId ?
	        { resourceId: dateSpan.resourceId } :
	        {};
	}
	
	common.EventApi.prototype.getResources = function () {
	    var calendarApi = this._context.calendarApi;
	    return this._def.resourceIds.map(function (resourceId) { return calendarApi.getResourceById(resourceId); });
	};
	common.EventApi.prototype.setResources = function (resources) {
	    var resourceIds = [];
	    // massage resources -> resourceIds
	    for (var _i = 0, resources_1 = resources; _i < resources_1.length; _i++) {
	        var resource = resources_1[_i];
	        var resourceId = null;
	        if (typeof resource === 'string') {
	            resourceId = resource;
	        }
	        else if (typeof resource === 'number') {
	            resourceId = String(resource);
	        }
	        else if (resource instanceof ResourceApi) {
	            resourceId = resource.id; // guaranteed to always have an ID. hmmm
	        }
	        else {
	            console.warn('unknown resource type: ' + resource);
	        }
	        if (resourceId) {
	            resourceIds.push(resourceId);
	        }
	    }
	    this.mutate({
	        standardProps: {
	            resourceIds: resourceIds,
	        },
	    });
	};
	
	var optionChangeHandlers = {
	    resources: handleResources,
	};
	function handleResources(newSourceInput, context) {
	    var oldSourceInput = context.getCurrentData().resourceSource._raw;
	    if (oldSourceInput !== newSourceInput) {
	        context.dispatch({
	            type: 'RESET_RESOURCE_SOURCE',
	            resourceSourceInput: newSourceInput,
	        });
	    }
	}
	
	var DEFAULT_RESOURCE_ORDER = common.parseFieldSpecs('id,title');
	function handleResourceStore(resourceStore, calendarData) {
	    var emitter = calendarData.emitter;
	    if (emitter.hasHandlers('resourcesSet')) {
	        emitter.trigger('resourcesSet', buildResourceApis(resourceStore, calendarData));
	    }
	}
	
	var OPTION_REFINERS = {
	    initialResources: common.identity,
	    resources: common.identity,
	    eventResourceEditable: Boolean,
	    refetchResourcesOnNavigate: Boolean,
	    resourceOrder: common.parseFieldSpecs,
	    filterResourcesWithEvents: Boolean,
	    resourceGroupField: String,
	    resourceAreaWidth: common.identity,
	    resourceAreaColumns: common.identity,
	    resourcesInitiallyExpanded: Boolean,
	    datesAboveResources: Boolean,
	    needsResourceData: Boolean,
	    resourceAreaHeaderClassNames: common.identity,
	    resourceAreaHeaderContent: common.identity,
	    resourceAreaHeaderDidMount: common.identity,
	    resourceAreaHeaderWillUnmount: common.identity,
	    resourceGroupLabelClassNames: common.identity,
	    resourceGroupLabelContent: common.identity,
	    resourceGroupLabelDidMount: common.identity,
	    resourceGroupLabelWillUnmount: common.identity,
	    resourceLabelClassNames: common.identity,
	    resourceLabelContent: common.identity,
	    resourceLabelDidMount: common.identity,
	    resourceLabelWillUnmount: common.identity,
	    resourceLaneClassNames: common.identity,
	    resourceLaneContent: common.identity,
	    resourceLaneDidMount: common.identity,
	    resourceLaneWillUnmount: common.identity,
	    resourceGroupLaneClassNames: common.identity,
	    resourceGroupLaneContent: common.identity,
	    resourceGroupLaneDidMount: common.identity,
	    resourceGroupLaneWillUnmount: common.identity,
	};
	var LISTENER_REFINERS = {
	    resourcesSet: common.identity,
	    resourceAdd: common.identity,
	    resourceChange: common.identity,
	    resourceRemove: common.identity,
	};
	
	registerResourceSourceDef({
	    ignoreRange: true,
	    parseMeta: function (refined) {
	        if (Array.isArray(refined.resources)) {
	            return refined.resources;
	        }
	        return null;
	    },
	    fetch: function (arg, successCallback) {
	        successCallback({
	            rawResources: arg.resourceSource.meta,
	        });
	    },
	});
	
	registerResourceSourceDef({
	    parseMeta: function (refined) {
	        if (typeof refined.resources === 'function') {
	            return refined.resources;
	        }
	        return null;
	    },
	    fetch: function (arg, success, failure) {
	        var dateEnv = arg.context.dateEnv;
	        var func = arg.resourceSource.meta;
	        var publicArg = arg.range ? {
	            start: dateEnv.toDate(arg.range.start),
	            end: dateEnv.toDate(arg.range.end),
	            startStr: dateEnv.formatIso(arg.range.start),
	            endStr: dateEnv.formatIso(arg.range.end),
	            timeZone: dateEnv.timeZone,
	        } : {};
	        // TODO: make more dry with EventSourceFunc
	        // TODO: accept a response?
	        common.unpromisify(func.bind(null, publicArg), function (rawResources) {
	            success({ rawResources: rawResources }); // needs an object response
	        }, failure);
	    },
	});
	
	registerResourceSourceDef({
	    parseMeta: function (refined) {
	        if (refined.url) {
	            return {
	                url: refined.url,
	                method: (refined.method || 'GET').toUpperCase(),
	                extraParams: refined.extraParams,
	            };
	        }
	        return null;
	    },
	    fetch: function (arg, successCallback, failureCallback) {
	        var meta = arg.resourceSource.meta;
	        var requestParams = buildRequestParams(meta, arg.range, arg.context);
	        common.requestJson(meta.method, meta.url, requestParams, function (rawResources, xhr) {
	            successCallback({ rawResources: rawResources, xhr: xhr });
	        }, function (message, xhr) {
	            failureCallback({ message: message, xhr: xhr });
	        });
	    },
	});
	// TODO: somehow consolidate with event json feed
	function buildRequestParams(meta, range, context) {
	    var dateEnv = context.dateEnv, options = context.options;
	    var startParam;
	    var endParam;
	    var timeZoneParam;
	    var customRequestParams;
	    var params = {};
	    if (range) {
	        startParam = meta.startParam;
	        if (startParam == null) {
	            startParam = options.startParam;
	        }
	        endParam = meta.endParam;
	        if (endParam == null) {
	            endParam = options.endParam;
	        }
	        timeZoneParam = meta.timeZoneParam;
	        if (timeZoneParam == null) {
	            timeZoneParam = options.timeZoneParam;
	        }
	        params[startParam] = dateEnv.formatIso(range.start);
	        params[endParam] = dateEnv.formatIso(range.end);
	        if (dateEnv.timeZone !== 'local') {
	            params[timeZoneParam] = dateEnv.timeZone;
	        }
	    }
	    // retrieve any outbound GET/POST data from the options
	    if (typeof meta.extraParams === 'function') {
	        // supplied as a function that returns a key/value object
	        customRequestParams = meta.extraParams();
	    }
	    else {
	        // probably supplied as a straight key/value object
	        customRequestParams = meta.extraParams || {};
	    }
	    tslib.__assign(params, customRequestParams);
	    return params;
	}
	
	// TODO: not used for Spreadsheet. START USING. difficult because of col-specific rendering props
	function ResourceLabelRoot(props) {
	    return (common.createElement(common.ViewContextType.Consumer, null, function (context) {
	        var options = context.options;
	        var hookProps = {
	            resource: new ResourceApi(context, props.resource),
	            date: props.date ? context.dateEnv.toDate(props.date) : null,
	            view: context.viewApi,
	        };
	        var dataAttrs = {
	            'data-resource-id': props.resource.id,
	            'data-date': props.date ? common.formatDayString(props.date) : undefined,
	        };
	        return (common.createElement(common.RenderHook, { hookProps: hookProps, classNames: options.resourceLabelClassNames, content: options.resourceLabelContent, defaultContent: renderInnerContent, didMount: options.resourceLabelDidMount, willUnmount: options.resourceLabelWillUnmount }, function (rootElRef, classNames, innerElRef, innerContent) { return props.children(rootElRef, classNames, // TODO: pass in 'fc-resource' ?
	        dataAttrs, innerElRef, innerContent); }));
	    }));
	}
	function renderInnerContent(props) {
	    return props.resource.title || props.resource.id;
	}
	
	var ResourceCell = /** @class */ (function (_super) {
	    tslib.__extends(ResourceCell, _super);
	    function ResourceCell() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ResourceCell.prototype.render = function () {
	        var props = this.props;
	        return (common.createElement(ResourceLabelRoot, { resource: props.resource, date: props.date }, function (elRef, customClassNames, dataAttrs, innerElRef, innerContent) { return (common.createElement("th", tslib.__assign({ ref: elRef, role: "columnheader", className: ['fc-col-header-cell', 'fc-resource'].concat(customClassNames).join(' '), colSpan: props.colSpan }, dataAttrs),
	            common.createElement("div", { className: "fc-scrollgrid-sync-inner" },
	                common.createElement("span", { className: [
	                        'fc-col-header-cell-cushion',
	                        props.isSticky ? 'fc-sticky' : '',
	                    ].join(' '), ref: innerElRef }, innerContent)))); }));
	    };
	    return ResourceCell;
	}(common.BaseComponent));
	
	var ResourceDayHeader = /** @class */ (function (_super) {
	    tslib.__extends(ResourceDayHeader, _super);
	    function ResourceDayHeader() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.buildDateFormat = common.memoize(buildDateFormat);
	        return _this;
	    }
	    ResourceDayHeader.prototype.render = function () {
	        var _this = this;
	        var _a = this, props = _a.props, context = _a.context;
	        var dateFormat = this.buildDateFormat(context.options.dayHeaderFormat, props.datesRepDistinctDays, props.dates.length);
	        return (common.createElement(common.NowTimer, { unit: "day" }, function (nowDate, todayRange) {
	            if (props.dates.length === 1) {
	                return _this.renderResourceRow(props.resources, props.dates[0]);
	            }
	            if (context.options.datesAboveResources) {
	                return _this.renderDayAndResourceRows(props.dates, dateFormat, todayRange, props.resources);
	            }
	            return _this.renderResourceAndDayRows(props.resources, props.dates, dateFormat, todayRange);
	        }));
	    };
	    ResourceDayHeader.prototype.renderResourceRow = function (resources, date) {
	        var resourceCells = resources.map(function (resource) { return (common.createElement(ResourceCell, { key: resource.id, resource: resource, colSpan: 1, date: date })); });
	        return this.buildTr(resourceCells, 'resources');
	    };
	    ResourceDayHeader.prototype.renderDayAndResourceRows = function (dates, dateFormat, todayRange, resources) {
	        var dateCells = [];
	        var resourceCells = [];
	        for (var _i = 0, dates_1 = dates; _i < dates_1.length; _i++) {
	            var date = dates_1[_i];
	            dateCells.push(this.renderDateCell(date, dateFormat, todayRange, resources.length, null, true));
	            for (var _a = 0, resources_1 = resources; _a < resources_1.length; _a++) {
	                var resource = resources_1[_a];
	                resourceCells.push(common.createElement(ResourceCell, { key: resource.id + ':' + date.toISOString(), resource: resource, colSpan: 1, date: date }));
	            }
	        }
	        return (common.createElement(common.Fragment, null,
	            this.buildTr(dateCells, 'day'),
	            this.buildTr(resourceCells, 'resources')));
	    };
	    ResourceDayHeader.prototype.renderResourceAndDayRows = function (resources, dates, dateFormat, todayRange) {
	        var resourceCells = [];
	        var dateCells = [];
	        for (var _i = 0, resources_2 = resources; _i < resources_2.length; _i++) {
	            var resource = resources_2[_i];
	            resourceCells.push(common.createElement(ResourceCell, { key: resource.id, resource: resource, colSpan: dates.length, isSticky: true }));
	            for (var _a = 0, dates_2 = dates; _a < dates_2.length; _a++) {
	                var date = dates_2[_a];
	                dateCells.push(this.renderDateCell(date, dateFormat, todayRange, 1, resource));
	            }
	        }
	        return (common.createElement(common.Fragment, null,
	            this.buildTr(resourceCells, 'resources'),
	            this.buildTr(dateCells, 'day')));
	    };
	    // a cell with date text. might have a resource associated with it
	    ResourceDayHeader.prototype.renderDateCell = function (date, dateFormat, todayRange, colSpan, resource, isSticky) {
	        var props = this.props;
	        var keyPostfix = resource ? ":" + resource.id : '';
	        var extraHookProps = resource ? { resource: new ResourceApi(this.context, resource) } : {};
	        var extraDataAttrs = resource ? { 'data-resource-id': resource.id } : {};
	        return props.datesRepDistinctDays ? (common.createElement(common.TableDateCell, { key: date.toISOString() + keyPostfix, date: date, dateProfile: props.dateProfile, todayRange: todayRange, colCnt: props.dates.length * props.resources.length, dayHeaderFormat: dateFormat, colSpan: colSpan, isSticky: isSticky, extraHookProps: extraHookProps, extraDataAttrs: extraDataAttrs })) : (common.createElement(common.TableDowCell // we can't leverage the pure-componentness becausae the extra* props are new every time :(
	        , { key: date.getUTCDay() + keyPostfix, dow: date.getUTCDay(), dayHeaderFormat: dateFormat, colSpan: colSpan, isSticky: isSticky, extraHookProps: extraHookProps, extraDataAttrs: extraDataAttrs }));
	    };
	    ResourceDayHeader.prototype.buildTr = function (cells, key) {
	        var renderIntro = this.props.renderIntro;
	        if (!cells.length) {
	            cells = [common.createElement("td", { key: 0 }, "\u00A0")];
	        }
	        return (common.createElement("tr", { key: key, role: "row" },
	            renderIntro && renderIntro(key),
	            cells));
	    };
	    return ResourceDayHeader;
	}(common.BaseComponent));
	function buildDateFormat(dayHeaderFormat, datesRepDistinctDays, dayCnt) {
	    return dayHeaderFormat || common.computeFallbackHeaderFormat(datesRepDistinctDays, dayCnt);
	}
	
	var ResourceIndex = /** @class */ (function () {
	    function ResourceIndex(resources) {
	        var indicesById = {};
	        var ids = [];
	        for (var i = 0; i < resources.length; i += 1) {
	            var id = resources[i].id;
	            ids.push(id);
	            indicesById[id] = i;
	        }
	        this.ids = ids;
	        this.indicesById = indicesById;
	        this.length = resources.length;
	    }
	    return ResourceIndex;
	}());
	
	var AbstractResourceDayTableModel = /** @class */ (function () {
	    function AbstractResourceDayTableModel(dayTableModel, resources, context) {
	        this.dayTableModel = dayTableModel;
	        this.resources = resources;
	        this.context = context;
	        this.resourceIndex = new ResourceIndex(resources);
	        this.rowCnt = dayTableModel.rowCnt;
	        this.colCnt = dayTableModel.colCnt * resources.length;
	        this.cells = this.buildCells();
	    }
	    AbstractResourceDayTableModel.prototype.buildCells = function () {
	        var _a = this, rowCnt = _a.rowCnt, dayTableModel = _a.dayTableModel, resources = _a.resources;
	        var rows = [];
	        for (var row = 0; row < rowCnt; row += 1) {
	            var rowCells = [];
	            for (var dateCol = 0; dateCol < dayTableModel.colCnt; dateCol += 1) {
	                for (var resourceCol = 0; resourceCol < resources.length; resourceCol += 1) {
	                    var resource = resources[resourceCol];
	                    var extraHookProps = { resource: new ResourceApi(this.context, resource) };
	                    var extraDataAttrs = { 'data-resource-id': resource.id };
	                    var extraClassNames = ['fc-resource'];
	                    var extraDateSpan = { resourceId: resource.id };
	                    var date = dayTableModel.cells[row][dateCol].date;
	                    rowCells[this.computeCol(dateCol, resourceCol)] = {
	                        key: resource.id + ':' + date.toISOString(),
	                        date: date,
	                        extraHookProps: extraHookProps,
	                        extraDataAttrs: extraDataAttrs,
	                        extraClassNames: extraClassNames,
	                        extraDateSpan: extraDateSpan,
	                    };
	                }
	            }
	            rows.push(rowCells);
	        }
	        return rows;
	    };
	    return AbstractResourceDayTableModel;
	}());
	
	/*
	resources over dates
	*/
	var ResourceDayTableModel = /** @class */ (function (_super) {
	    tslib.__extends(ResourceDayTableModel, _super);
	    function ResourceDayTableModel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ResourceDayTableModel.prototype.computeCol = function (dateI, resourceI) {
	        return resourceI * this.dayTableModel.colCnt + dateI;
	    };
	    /*
	    all date ranges are intact
	    */
	    ResourceDayTableModel.prototype.computeColRanges = function (dateStartI, dateEndI, resourceI) {
	        return [
	            {
	                firstCol: this.computeCol(dateStartI, resourceI),
	                lastCol: this.computeCol(dateEndI, resourceI),
	                isStart: true,
	                isEnd: true,
	            },
	        ];
	    };
	    return ResourceDayTableModel;
	}(AbstractResourceDayTableModel));
	
	/*
	dates over resources
	*/
	var DayResourceTableModel = /** @class */ (function (_super) {
	    tslib.__extends(DayResourceTableModel, _super);
	    function DayResourceTableModel() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DayResourceTableModel.prototype.computeCol = function (dateI, resourceI) {
	        return dateI * this.resources.length + resourceI;
	    };
	    /*
	    every single day is broken up
	    */
	    DayResourceTableModel.prototype.computeColRanges = function (dateStartI, dateEndI, resourceI) {
	        var segs = [];
	        for (var i = dateStartI; i <= dateEndI; i += 1) {
	            var col = this.computeCol(i, resourceI);
	            segs.push({
	                firstCol: col,
	                lastCol: col,
	                isStart: i === dateStartI,
	                isEnd: i === dateEndI,
	            });
	        }
	        return segs;
	    };
	    return DayResourceTableModel;
	}(AbstractResourceDayTableModel));
	
	var NO_SEGS = []; // for memoizing
	var VResourceJoiner = /** @class */ (function () {
	    function VResourceJoiner() {
	        this.joinDateSelection = common.memoize(this.joinSegs);
	        this.joinBusinessHours = common.memoize(this.joinSegs);
	        this.joinFgEvents = common.memoize(this.joinSegs);
	        this.joinBgEvents = common.memoize(this.joinSegs);
	        this.joinEventDrags = common.memoize(this.joinInteractions);
	        this.joinEventResizes = common.memoize(this.joinInteractions);
	    }
	    /*
	    propSets also has a '' key for things with no resource
	    */
	    VResourceJoiner.prototype.joinProps = function (propSets, resourceDayTable) {
	        var dateSelectionSets = [];
	        var businessHoursSets = [];
	        var fgEventSets = [];
	        var bgEventSets = [];
	        var eventDrags = [];
	        var eventResizes = [];
	        var eventSelection = '';
	        var keys = resourceDayTable.resourceIndex.ids.concat(['']); // add in the all-resource key
	        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
	            var key = keys_1[_i];
	            var props = propSets[key];
	            dateSelectionSets.push(props.dateSelectionSegs);
	            businessHoursSets.push(key ? props.businessHourSegs : NO_SEGS); // don't include redundant all-resource businesshours
	            fgEventSets.push(key ? props.fgEventSegs : NO_SEGS); // don't include fg all-resource segs
	            bgEventSets.push(props.bgEventSegs);
	            eventDrags.push(props.eventDrag);
	            eventResizes.push(props.eventResize);
	            eventSelection = eventSelection || props.eventSelection;
	        }
	        return {
	            dateSelectionSegs: this.joinDateSelection.apply(this, tslib.__spreadArray([resourceDayTable], dateSelectionSets)),
	            businessHourSegs: this.joinBusinessHours.apply(this, tslib.__spreadArray([resourceDayTable], businessHoursSets)),
	            fgEventSegs: this.joinFgEvents.apply(this, tslib.__spreadArray([resourceDayTable], fgEventSets)),
	            bgEventSegs: this.joinBgEvents.apply(this, tslib.__spreadArray([resourceDayTable], bgEventSets)),
	            eventDrag: this.joinEventDrags.apply(this, tslib.__spreadArray([resourceDayTable], eventDrags)),
	            eventResize: this.joinEventResizes.apply(this, tslib.__spreadArray([resourceDayTable], eventResizes)),
	            eventSelection: eventSelection,
	        };
	    };
	    VResourceJoiner.prototype.joinSegs = function (resourceDayTable) {
	        var segGroups = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            segGroups[_i - 1] = arguments[_i];
	        }
	        var resourceCnt = resourceDayTable.resources.length;
	        var transformedSegs = [];
	        for (var i = 0; i < resourceCnt; i += 1) {
	            for (var _a = 0, _b = segGroups[i]; _a < _b.length; _a++) {
	                var seg = _b[_a];
	                transformedSegs.push.apply(transformedSegs, this.transformSeg(seg, resourceDayTable, i));
	            }
	            for (var _c = 0, _d = segGroups[resourceCnt]; _c < _d.length; _c++) { // one beyond. the all-resource
	                var seg = _d[_c];
	                transformedSegs.push.apply(// one beyond. the all-resource
	                transformedSegs, this.transformSeg(seg, resourceDayTable, i));
	            }
	        }
	        return transformedSegs;
	    };
	    /*
	    for expanding non-resource segs to all resources.
	    only for public use.
	    no memoizing.
	    */
	    VResourceJoiner.prototype.expandSegs = function (resourceDayTable, segs) {
	        var resourceCnt = resourceDayTable.resources.length;
	        var transformedSegs = [];
	        for (var i = 0; i < resourceCnt; i += 1) {
	            for (var _i = 0, segs_1 = segs; _i < segs_1.length; _i++) {
	                var seg = segs_1[_i];
	                transformedSegs.push.apply(transformedSegs, this.transformSeg(seg, resourceDayTable, i));
	            }
	        }
	        return transformedSegs;
	    };
	    VResourceJoiner.prototype.joinInteractions = function (resourceDayTable) {
	        var interactions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            interactions[_i - 1] = arguments[_i];
	        }
	        var resourceCnt = resourceDayTable.resources.length;
	        var affectedInstances = {};
	        var transformedSegs = [];
	        var anyInteractions = false;
	        var isEvent = false;
	        for (var i = 0; i < resourceCnt; i += 1) {
	            var interaction = interactions[i];
	            if (interaction) {
	                anyInteractions = true;
	                for (var _a = 0, _b = interaction.segs; _a < _b.length; _a++) {
	                    var seg = _b[_a];
	                    transformedSegs.push.apply(transformedSegs, this.transformSeg(seg, resourceDayTable, i));
	                }
	                tslib.__assign(affectedInstances, interaction.affectedInstances);
	                isEvent = isEvent || interaction.isEvent;
	            }
	            if (interactions[resourceCnt]) { // one beyond. the all-resource
	                for (var _c = 0, _d = interactions[resourceCnt].segs; _c < _d.length; _c++) {
	                    var seg = _d[_c];
	                    transformedSegs.push.apply(transformedSegs, this.transformSeg(seg, resourceDayTable, i));
	                }
	            }
	        }
	        if (anyInteractions) {
	            return {
	                affectedInstances: affectedInstances,
	                segs: transformedSegs,
	                isEvent: isEvent,
	            };
	        }
	        return null;
	    };
	    return VResourceJoiner;
	}());
	
	/*
	TODO: just use ResourceHash somehow? could then use the generic ResourceSplitter
	*/
	var VResourceSplitter = /** @class */ (function (_super) {
	    tslib.__extends(VResourceSplitter, _super);
	    function VResourceSplitter() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    VResourceSplitter.prototype.getKeyInfo = function (props) {
	        var resourceDayTableModel = props.resourceDayTableModel;
	        var hash = common.mapHash(resourceDayTableModel.resourceIndex.indicesById, function (i) { return resourceDayTableModel.resources[i]; }); // :(
	        hash[''] = {};
	        return hash;
	    };
	    VResourceSplitter.prototype.getKeysForDateSpan = function (dateSpan) {
	        return [dateSpan.resourceId || ''];
	    };
	    VResourceSplitter.prototype.getKeysForEventDef = function (eventDef) {
	        var resourceIds = eventDef.resourceIds;
	        if (!resourceIds.length) {
	            return [''];
	        }
	        return resourceIds;
	    };
	    return VResourceSplitter;
	}(common.Splitter));
	
	/*
	doesn't accept grouping
	*/
	function flattenResources(resourceStore, orderSpecs) {
	    return buildRowNodes(resourceStore, [], orderSpecs, false, {}, true)
	        .map(function (node) { return node.resource; });
	}
	function buildRowNodes(resourceStore, groupSpecs, orderSpecs, isVGrouping, expansions, expansionDefault) {
	    var complexNodes = buildHierarchy(resourceStore, isVGrouping ? -1 : 1, groupSpecs, orderSpecs);
	    var flatNodes = [];
	    flattenNodes(complexNodes, flatNodes, isVGrouping, [], 0, expansions, expansionDefault);
	    return flatNodes;
	}
	function flattenNodes(complexNodes, res, isVGrouping, rowSpans, depth, expansions, expansionDefault) {
	    for (var i = 0; i < complexNodes.length; i += 1) {
	        var complexNode = complexNodes[i];
	        var group = complexNode.group;
	        if (group) {
	            if (isVGrouping) {
	                var firstRowIndex = res.length;
	                var rowSpanIndex = rowSpans.length;
	                flattenNodes(complexNode.children, res, isVGrouping, rowSpans.concat(0), depth, expansions, expansionDefault);
	                if (firstRowIndex < res.length) {
	                    var firstRow = res[firstRowIndex];
	                    var firstRowSpans = firstRow.rowSpans = firstRow.rowSpans.slice();
	                    firstRowSpans[rowSpanIndex] = res.length - firstRowIndex;
	                }
	            }
	            else {
	                var id = group.spec.field + ':' + group.value;
	                var isExpanded = expansions[id] != null ? expansions[id] : expansionDefault;
	                res.push({ id: id, group: group, isExpanded: isExpanded });
	                if (isExpanded) {
	                    flattenNodes(complexNode.children, res, isVGrouping, rowSpans, depth + 1, expansions, expansionDefault);
	                }
	            }
	        }
	        else if (complexNode.resource) {
	            var id = complexNode.resource.id;
	            var isExpanded = expansions[id] != null ? expansions[id] : expansionDefault;
	            res.push({
	                id: id,
	                rowSpans: rowSpans,
	                depth: depth,
	                isExpanded: isExpanded,
	                hasChildren: Boolean(complexNode.children.length),
	                resource: complexNode.resource,
	                resourceFields: complexNode.resourceFields,
	            });
	            if (isExpanded) {
	                flattenNodes(complexNode.children, res, isVGrouping, rowSpans, depth + 1, expansions, expansionDefault);
	            }
	        }
	    }
	}
	function buildHierarchy(resourceStore, maxDepth, groupSpecs, orderSpecs) {
	    var resourceNodes = buildResourceNodes(resourceStore, orderSpecs);
	    var builtNodes = [];
	    for (var resourceId in resourceNodes) {
	        var resourceNode = resourceNodes[resourceId];
	        if (!resourceNode.resource.parentId) {
	            insertResourceNode(resourceNode, builtNodes, groupSpecs, 0, maxDepth, orderSpecs);
	        }
	    }
	    return builtNodes;
	}
	function buildResourceNodes(resourceStore, orderSpecs) {
	    var nodeHash = {};
	    for (var resourceId in resourceStore) {
	        var resource = resourceStore[resourceId];
	        nodeHash[resourceId] = {
	            resource: resource,
	            resourceFields: buildResourceFields(resource),
	            children: [],
	        };
	    }
	    for (var resourceId in resourceStore) {
	        var resource = resourceStore[resourceId];
	        if (resource.parentId) {
	            var parentNode = nodeHash[resource.parentId];
	            if (parentNode) {
	                insertResourceNodeInSiblings(nodeHash[resourceId], parentNode.children, orderSpecs);
	            }
	        }
	    }
	    return nodeHash;
	}
	function insertResourceNode(resourceNode, nodes, groupSpecs, depth, maxDepth, orderSpecs) {
	    if (groupSpecs.length && (maxDepth === -1 || depth <= maxDepth)) {
	        var groupNode = ensureGroupNodes(resourceNode, nodes, groupSpecs[0]);
	        insertResourceNode(resourceNode, groupNode.children, groupSpecs.slice(1), depth + 1, maxDepth, orderSpecs);
	    }
	    else {
	        insertResourceNodeInSiblings(resourceNode, nodes, orderSpecs);
	    }
	}
	function ensureGroupNodes(resourceNode, nodes, groupSpec) {
	    var groupValue = resourceNode.resourceFields[groupSpec.field];
	    var groupNode;
	    var newGroupIndex;
	    // find an existing group that matches, or determine the position for a new group
	    if (groupSpec.order) {
	        for (newGroupIndex = 0; newGroupIndex < nodes.length; newGroupIndex += 1) {
	            var node = nodes[newGroupIndex];
	            if (node.group) {
	                var cmp = common.flexibleCompare(groupValue, node.group.value) * groupSpec.order;
	                if (cmp === 0) {
	                    groupNode = node;
	                    break;
	                }
	                else if (cmp < 0) {
	                    break;
	                }
	            }
	        }
	    }
	    else { // the groups are unordered
	        for (newGroupIndex = 0; newGroupIndex < nodes.length; newGroupIndex += 1) {
	            var node = nodes[newGroupIndex];
	            if (node.group && groupValue === node.group.value) {
	                groupNode = node;
	                break;
	            }
	        }
	    }
	    if (!groupNode) {
	        groupNode = {
	            group: {
	                value: groupValue,
	                spec: groupSpec,
	            },
	            children: [],
	        };
	        nodes.splice(newGroupIndex, 0, groupNode);
	    }
	    return groupNode;
	}
	function insertResourceNodeInSiblings(resourceNode, siblings, orderSpecs) {
	    var i;
	    for (i = 0; i < siblings.length; i += 1) {
	        var cmp = common.compareByFieldSpecs(siblings[i].resourceFields, resourceNode.resourceFields, orderSpecs); // TODO: pass in ResourceApi?
	        if (cmp > 0) { // went 1 past. insert at i
	            break;
	        }
	    }
	    siblings.splice(i, 0, resourceNode);
	}
	function buildResourceFields(resource) {
	    var obj = tslib.__assign(tslib.__assign(tslib.__assign({}, resource.extendedProps), resource.ui), resource);
	    delete obj.ui;
	    delete obj.extendedProps;
	    return obj;
	}
	function isGroupsEqual(group0, group1) {
	    return group0.spec === group1.spec && group0.value === group1.value;
	}
	
	var main = common.createPlugin({
	    deps: [
	        premiumCommonPlugin__default['default'],
	    ],
	    reducers: [
	        reduceResources,
	    ],
	    isLoadingFuncs: [
	        function (state) { return state.resourceSource && state.resourceSource.isFetching; },
	    ],
	    eventRefiners: EVENT_REFINERS,
	    eventDefMemberAdders: [generateEventDefResourceMembers],
	    isDraggableTransformers: [transformIsDraggable],
	    eventDragMutationMassagers: [massageEventDragMutation],
	    eventDefMutationAppliers: [applyEventDefMutation],
	    dateSelectionTransformers: [transformDateSelectionJoin],
	    datePointTransforms: [transformDatePoint],
	    dateSpanTransforms: [transformDateSpan],
	    viewPropsTransformers: [ResourceDataAdder, ResourceEventConfigAdder],
	    isPropsValid: isPropsValidWithResources,
	    externalDefTransforms: [transformExternalDef],
	    eventDropTransformers: [transformEventDrop],
	    optionChangeHandlers: optionChangeHandlers,
	    optionRefiners: OPTION_REFINERS,
	    listenerRefiners: LISTENER_REFINERS,
	    propSetHandlers: { resourceStore: handleResourceStore },
	});
	
	exports.AbstractResourceDayTableModel = AbstractResourceDayTableModel;
	exports.DEFAULT_RESOURCE_ORDER = DEFAULT_RESOURCE_ORDER;
	exports.DayResourceTableModel = DayResourceTableModel;
	exports.ResourceApi = ResourceApi;
	exports.ResourceDayHeader = ResourceDayHeader;
	exports.ResourceDayTableModel = ResourceDayTableModel;
	exports.ResourceLabelRoot = ResourceLabelRoot;
	exports.ResourceSplitter = ResourceSplitter;
	exports.VResourceJoiner = VResourceJoiner;
	exports.VResourceSplitter = VResourceSplitter;
	exports.buildResourceFields = buildResourceFields;
	exports.buildRowNodes = buildRowNodes;
	exports.default = main;
	exports.flattenResources = flattenResources;
	exports.getPublicId = getPublicId;
	exports.isGroupsEqual = isGroupsEqual;


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	FullCalendar Scheduler v5.11.5
	Docs & License: https://fullcalendar.io/scheduler
	(c) 2022 Adam Shaw
	*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var common = __webpack_require__(70);
	var premiumCommonPlugin = __webpack_require__(99);
	var timelinePlugin = __webpack_require__(540);
	var resourceCommonPlugin = __webpack_require__(538);
	var tslib = __webpack_require__(80);
	var scrollgrid = __webpack_require__(206);
	;
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var premiumCommonPlugin__default = /*#__PURE__*/_interopDefaultLegacy(premiumCommonPlugin);
	var timelinePlugin__default = /*#__PURE__*/_interopDefaultLegacy(timelinePlugin);
	var resourceCommonPlugin__default = /*#__PURE__*/_interopDefaultLegacy(resourceCommonPlugin);
	
	/*
	Renders the DOM responsible for the subrow expander area,
	as well as the space before it (used to align expanders of similar depths)
	*/
	function ExpanderIcon(_a) {
	    var depth = _a.depth, hasChildren = _a.hasChildren, isExpanded = _a.isExpanded, onExpanderClick = _a.onExpanderClick;
	    var nodes = [];
	    for (var i = 0; i < depth; i += 1) {
	        nodes.push(common.createElement("span", { className: "fc-icon" }));
	    }
	    var iconClassNames = ['fc-icon'];
	    if (hasChildren) {
	        if (isExpanded) {
	            iconClassNames.push('fc-icon-minus-square');
	        }
	        else {
	            iconClassNames.push('fc-icon-plus-square');
	        }
	    }
	    nodes.push(common.createElement("span", { className: 'fc-datagrid-expander' + (hasChildren ? '' : ' fc-datagrid-expander-placeholder'), onClick: onExpanderClick },
	        common.createElement("span", { className: iconClassNames.join(' ') })));
	    return common.createElement.apply(void 0, tslib.__spreadArray([common.Fragment, {}], nodes));
	}
	
	function refineHookProps$1(raw) {
	    return {
	        resource: new resourceCommonPlugin.ResourceApi(raw.context, raw.resource),
	        fieldValue: raw.fieldValue,
	        view: raw.context.viewApi,
	    };
	}
	
	var SpreadsheetIndividualCellInner = /** @class */ (function (_super) {
	    tslib.__extends(SpreadsheetIndividualCellInner, _super);
	    function SpreadsheetIndividualCellInner() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SpreadsheetIndividualCellInner.prototype.render = function () {
	        var props = this.props;
	        return (common.createElement(common.ContentHook, { hookProps: props.hookProps, content: props.colSpec.cellContent, defaultContent: renderResourceInner }, function (innerElRef, innerContent) { return (common.createElement("span", { className: "fc-datagrid-cell-main", ref: innerElRef }, innerContent)); }));
	    };
	    return SpreadsheetIndividualCellInner;
	}(common.BaseComponent));
	function renderResourceInner(hookProps) {
	    return hookProps.fieldValue || common.createElement(common.Fragment, null, "\u00A0");
	}
	
	// worth making a PureComponent? (because of innerHeight)
	var SpreadsheetIndividualCell = /** @class */ (function (_super) {
	    tslib.__extends(SpreadsheetIndividualCell, _super);
	    function SpreadsheetIndividualCell() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.refineHookProps = common.memoizeObjArg(refineHookProps$1);
	        _this.normalizeClassNames = common.buildClassNameNormalizer();
	        _this.onExpanderClick = function (ev) {
	            var props = _this.props;
	            if (props.hasChildren) {
	                _this.context.dispatch({
	                    type: 'SET_RESOURCE_ENTITY_EXPANDED',
	                    id: props.resource.id,
	                    isExpanded: !props.isExpanded,
	                });
	            }
	        };
	        return _this;
	    }
	    SpreadsheetIndividualCell.prototype.render = function () {
	        var _this = this;
	        var _a = this, props = _a.props, context = _a.context;
	        var colSpec = props.colSpec;
	        var hookProps = this.refineHookProps({
	            resource: props.resource,
	            fieldValue: props.fieldValue,
	            context: context,
	        });
	        var customClassNames = this.normalizeClassNames(colSpec.cellClassNames, hookProps);
	        return (common.createElement(common.MountHook, { hookProps: hookProps, didMount: colSpec.cellDidMount, willUnmount: colSpec.cellWillUnmount }, function (rootElRef) { return (common.createElement("td", { ref: rootElRef, role: "gridcell", "data-resource-id": props.resource.id, className: [
	                'fc-datagrid-cell',
	                'fc-resource',
	            ].concat(customClassNames).join(' ') },
	            common.createElement("div", { className: "fc-datagrid-cell-frame", style: { height: props.innerHeight } },
	                common.createElement("div", { className: "fc-datagrid-cell-cushion fc-scrollgrid-sync-inner" },
	                    colSpec.isMain && (common.createElement(ExpanderIcon, { depth: props.depth, hasChildren: props.hasChildren, isExpanded: props.isExpanded, onExpanderClick: _this.onExpanderClick })),
	                    common.createElement(SpreadsheetIndividualCellInner, { hookProps: hookProps, colSpec: colSpec }))))); }));
	    };
	    return SpreadsheetIndividualCell;
	}(common.BaseComponent));
	
	// for VERTICAL cell grouping, in spreadsheet area
	var SpreadsheetGroupCell = /** @class */ (function (_super) {
	    tslib.__extends(SpreadsheetGroupCell, _super);
	    function SpreadsheetGroupCell() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SpreadsheetGroupCell.prototype.render = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        var colSpec = props.colSpec;
	        var hookProps = {
	            groupValue: props.fieldValue,
	            view: context.viewApi,
	        };
	        // a grouped cell. no data that is specific to this specific resource
	        // `colSpec` is for the group. a GroupSpec :(
	        return (common.createElement(common.RenderHook, { hookProps: hookProps, classNames: colSpec.cellClassNames, content: colSpec.cellContent, defaultContent: renderGroupInner, didMount: colSpec.cellDidMount, willUnmount: colSpec.cellWillUnmount }, function (rootElRef, classNames, innerElRef, innerContent) { return (
	        // TODO: make data-attr with group value?
	        common.createElement("td", { ref: rootElRef, role: "gridcell", rowSpan: props.rowSpan, className: ['fc-datagrid-cell', 'fc-resource-group'].concat(classNames).join(' ') },
	            common.createElement("div", { className: "fc-datagrid-cell-frame fc-datagrid-cell-frame-liquid" },
	                common.createElement("div", { className: "fc-datagrid-cell-cushion fc-sticky", ref: innerElRef }, innerContent)))); }));
	    };
	    return SpreadsheetGroupCell;
	}(common.BaseComponent));
	function renderGroupInner(hookProps) {
	    return hookProps.groupValue || common.createElement(common.Fragment, null, "\u00A0");
	}
	
	var SpreadsheetRow = /** @class */ (function (_super) {
	    tslib.__extends(SpreadsheetRow, _super);
	    function SpreadsheetRow() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SpreadsheetRow.prototype.render = function () {
	        var props = this.props;
	        var resource = props.resource, rowSpans = props.rowSpans, depth = props.depth;
	        var resourceFields = resourceCommonPlugin.buildResourceFields(resource); // slightly inefficient. already done up the call stack
	        return (common.createElement("tr", { role: "row" }, props.colSpecs.map(function (colSpec, i) {
	            var rowSpan = rowSpans[i];
	            if (rowSpan === 0) { // not responsible for group-based rows. VRowGroup is
	                return null;
	            }
	            if (rowSpan == null) {
	                rowSpan = 1;
	            }
	            var fieldValue = colSpec.field ? resourceFields[colSpec.field] :
	                (resource.title || resourceCommonPlugin.getPublicId(resource.id));
	            if (rowSpan > 1) {
	                return (common.createElement(SpreadsheetGroupCell, { key: i, colSpec: colSpec, fieldValue: fieldValue, rowSpan: rowSpan }));
	            }
	            return (common.createElement(SpreadsheetIndividualCell, { key: i, colSpec: colSpec, resource: resource, fieldValue: fieldValue, depth: depth, hasChildren: props.hasChildren, isExpanded: props.isExpanded, innerHeight: props.innerHeight }));
	        })));
	    };
	    return SpreadsheetRow;
	}(common.BaseComponent));
	SpreadsheetRow.addPropsEquality({
	    rowSpans: common.isArraysEqual,
	});
	
	// for HORIZONTAL cell grouping, in spreadsheet area
	var SpreadsheetGroupRow = /** @class */ (function (_super) {
	    tslib.__extends(SpreadsheetGroupRow, _super);
	    function SpreadsheetGroupRow() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.innerInnerRef = common.createRef();
	        _this.onExpanderClick = function () {
	            var props = _this.props;
	            _this.context.dispatch({
	                type: 'SET_RESOURCE_ENTITY_EXPANDED',
	                id: props.id,
	                isExpanded: !props.isExpanded,
	            });
	        };
	        return _this;
	    }
	    SpreadsheetGroupRow.prototype.render = function () {
	        var _this = this;
	        var _a = this, props = _a.props, context = _a.context;
	        var hookProps = { groupValue: props.group.value, view: context.viewApi };
	        var spec = props.group.spec;
	        return (common.createElement("tr", { role: "row" },
	            common.createElement(common.RenderHook, { hookProps: hookProps, classNames: spec.labelClassNames, content: spec.labelContent, defaultContent: renderCellInner, didMount: spec.labelDidMount, willUnmount: spec.labelWillUnmount }, function (rootElRef, classNames, innerElRef, innerContent) { return (common.createElement("th", { ref: rootElRef, 
	                // ARIA TODO: not really a columnheader
	                // extremely tedious to make this aria-compliant,
	                // to assign multiple headers to each cell
	                // https://www.w3.org/WAI/tutorials/tables/multi-level/
	                role: "columnheader", scope: "colgroup", colSpan: props.spreadsheetColCnt, className: [
	                    'fc-datagrid-cell',
	                    'fc-resource-group',
	                    context.theme.getClass('tableCellShaded'),
	                ].concat(classNames).join(' ') },
	                common.createElement("div", { className: "fc-datagrid-cell-frame", style: { height: props.innerHeight } },
	                    common.createElement("div", { className: "fc-datagrid-cell-cushion fc-scrollgrid-sync-inner", ref: _this.innerInnerRef },
	                        common.createElement(ExpanderIcon, { depth: 0, hasChildren: true, isExpanded: props.isExpanded, onExpanderClick: _this.onExpanderClick }),
	                        common.createElement("span", { className: "fc-datagrid-cell-main", ref: innerElRef }, innerContent))))); })));
	    };
	    return SpreadsheetGroupRow;
	}(common.BaseComponent));
	SpreadsheetGroupRow.addPropsEquality({
	    group: resourceCommonPlugin.isGroupsEqual,
	});
	function renderCellInner(hookProps) {
	    return hookProps.groupValue || common.createElement(common.Fragment, null, "\u00A0");
	}
	
	var SPREADSHEET_COL_MIN_WIDTH = 20;
	var SpreadsheetHeader = /** @class */ (function (_super) {
	    tslib.__extends(SpreadsheetHeader, _super);
	    function SpreadsheetHeader() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.resizerElRefs = new common.RefMap(_this._handleColResizerEl.bind(_this));
	        _this.colDraggings = {};
	        return _this;
	    }
	    SpreadsheetHeader.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, colSpecs = _a.colSpecs, superHeaderRendering = _a.superHeaderRendering, rowInnerHeights = _a.rowInnerHeights;
	        var hookProps = { view: this.context.viewApi };
	        var rowNodes = [];
	        rowInnerHeights = rowInnerHeights.slice(); // copy, because we're gonna pop
	        if (superHeaderRendering) {
	            var rowInnerHeight_1 = rowInnerHeights.shift();
	            rowNodes.push(common.createElement("tr", { key: "row-super", role: "row" },
	                common.createElement(common.RenderHook, { hookProps: hookProps, classNames: superHeaderRendering.headerClassNames, content: superHeaderRendering.headerContent, didMount: superHeaderRendering.headerDidMount, willUnmount: superHeaderRendering.headerWillUnmount }, function (rootElRef, classNames, innerElRef, innerContent) { return (common.createElement("th", { ref: rootElRef, role: "columnheader", scope: "colgroup", colSpan: colSpecs.length, className: [
	                        'fc-datagrid-cell',
	                        'fc-datagrid-cell-super',
	                    ].concat(classNames).join(' ') },
	                    common.createElement("div", { className: "fc-datagrid-cell-frame", style: { height: rowInnerHeight_1 } },
	                        common.createElement("div", { className: "fc-datagrid-cell-cushion fc-scrollgrid-sync-inner", ref: innerElRef }, innerContent)))); })));
	        }
	        var rowInnerHeight = rowInnerHeights.shift();
	        rowNodes.push(common.createElement("tr", { key: "row", role: "row" }, colSpecs.map(function (colSpec, i) {
	            var isLastCol = i === (colSpecs.length - 1);
	            // need empty inner div for abs positioning for resizer
	            return (common.createElement(common.RenderHook, { key: i, hookProps: hookProps, classNames: colSpec.headerClassNames, content: colSpec.headerContent, didMount: colSpec.headerDidMount, willUnmount: colSpec.headerWillUnmount }, function (rootElRef, classNames, innerElRef, innerContent) { return (common.createElement("th", { ref: rootElRef, role: "columnheader", className: ['fc-datagrid-cell'].concat(classNames).join(' ') },
	                common.createElement("div", { className: "fc-datagrid-cell-frame", style: { height: rowInnerHeight } },
	                    common.createElement("div", { className: "fc-datagrid-cell-cushion fc-scrollgrid-sync-inner" },
	                        colSpec.isMain && (common.createElement("span", { className: "fc-datagrid-expander fc-datagrid-expander-placeholder" },
	                            common.createElement("span", { className: "fc-icon" }))),
	                        common.createElement("span", { className: "fc-datagrid-cell-main", ref: innerElRef }, innerContent)),
	                    !isLastCol &&
	                        common.createElement("div", { className: "fc-datagrid-cell-resizer", ref: _this.resizerElRefs.createRef(i) })))); }));
	        })));
	        return (common.createElement(common.Fragment, null, rowNodes));
	    };
	    SpreadsheetHeader.prototype._handleColResizerEl = function (resizerEl, index) {
	        var colDraggings = this.colDraggings;
	        if (!resizerEl) {
	            var dragging = colDraggings[index];
	            if (dragging) {
	                dragging.destroy();
	                delete colDraggings[index];
	            }
	        }
	        else {
	            var dragging = this.initColResizing(resizerEl, parseInt(index, 10));
	            if (dragging) {
	                colDraggings[index] = dragging;
	            }
	        }
	    };
	    SpreadsheetHeader.prototype.initColResizing = function (resizerEl, index) {
	        var _a = this.context, pluginHooks = _a.pluginHooks, isRtl = _a.isRtl;
	        var onColWidthChange = this.props.onColWidthChange;
	        var ElementDraggingImpl = pluginHooks.elementDraggingImpl;
	        if (ElementDraggingImpl) {
	            var dragging = new ElementDraggingImpl(resizerEl);
	            var startWidth_1; // of just the single column
	            var currentWidths_1; // of all columns
	            dragging.emitter.on('dragstart', function () {
	                var allCells = common.findElements(common.elementClosest(resizerEl, 'tr'), 'th');
	                currentWidths_1 = allCells.map(function (cellEl) { return (cellEl.getBoundingClientRect().width); });
	                startWidth_1 = currentWidths_1[index];
	            });
	            dragging.emitter.on('dragmove', function (pev) {
	                currentWidths_1[index] = Math.max(startWidth_1 + pev.deltaX * (isRtl ? -1 : 1), SPREADSHEET_COL_MIN_WIDTH);
	                if (onColWidthChange) {
	                    onColWidthChange(currentWidths_1.slice()); // send a copy since currentWidths continues to be mutated
	                }
	            });
	            dragging.setAutoScrollEnabled(false); // because gets weird with auto-scrolling time area
	            return dragging;
	        }
	        return null;
	    };
	    return SpreadsheetHeader;
	}(common.BaseComponent));
	
	var ResourceTimelineLaneMisc = /** @class */ (function (_super) {
	    tslib.__extends(ResourceTimelineLaneMisc, _super);
	    function ResourceTimelineLaneMisc() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ResourceTimelineLaneMisc.prototype.render = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        var hookProps = { resource: new resourceCommonPlugin.ResourceApi(context, props.resource) }; // just easier to make directly
	        return (common.createElement(common.ContentHook, { hookProps: hookProps, content: context.options.resourceLaneContent }, function (innerElRef, innerContent) { return (innerContent && // TODO: test how this would interfere with height
	            common.createElement("div", { className: "fc-timeline-lane-misc", ref: innerElRef }, innerContent)); }));
	    };
	    return ResourceTimelineLaneMisc;
	}(common.BaseComponent));
	
	var ResourceTimelineLane = /** @class */ (function (_super) {
	    tslib.__extends(ResourceTimelineLane, _super);
	    function ResourceTimelineLane() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.refineHookProps = common.memoizeObjArg(refineHookProps);
	        _this.normalizeClassNames = common.buildClassNameNormalizer();
	        _this.handleHeightChange = function (innerEl, isStable) {
	            if (_this.props.onHeightChange) {
	                _this.props.onHeightChange(
	                // would want to use own <tr> ref, but not guaranteed to be ready when this fires
	                common.elementClosest(innerEl, 'tr'), isStable);
	            }
	        };
	        return _this;
	    }
	    ResourceTimelineLane.prototype.render = function () {
	        var _this = this;
	        var _a = this, props = _a.props, context = _a.context;
	        var options = context.options;
	        var hookProps = this.refineHookProps({ resource: props.resource, context: context });
	        var customClassNames = this.normalizeClassNames(options.resourceLaneClassNames, hookProps);
	        return (common.createElement("tr", { ref: props.elRef },
	            common.createElement(common.MountHook, { hookProps: hookProps, didMount: options.resourceLaneDidMount, willUnmount: options.resourceLaneWillUnmount }, function (rootElRef) { return (common.createElement("td", { ref: rootElRef, className: ['fc-timeline-lane', 'fc-resource'].concat(customClassNames).join(' '), "data-resource-id": props.resource.id },
	                common.createElement("div", { className: "fc-timeline-lane-frame", style: { height: props.innerHeight } },
	                    common.createElement(ResourceTimelineLaneMisc, { resource: props.resource }),
	                    common.createElement(timelinePlugin.TimelineLane, { dateProfile: props.dateProfile, tDateProfile: props.tDateProfile, nowDate: props.nowDate, todayRange: props.todayRange, nextDayThreshold: props.nextDayThreshold, businessHours: props.businessHours, eventStore: props.eventStore, eventUiBases: props.eventUiBases, dateSelection: props.dateSelection, eventSelection: props.eventSelection, eventDrag: props.eventDrag, eventResize: props.eventResize, timelineCoords: props.timelineCoords, onHeightChange: _this.handleHeightChange, resourceId: props.resource.id })))); }))); // important NOT to do liquid-height. dont want to shrink height smaller than content
	    };
	    return ResourceTimelineLane;
	}(common.BaseComponent));
	function refineHookProps(raw) {
	    return {
	        resource: new resourceCommonPlugin.ResourceApi(raw.context, raw.resource),
	    };
	}
	
	/*
	parallels the SpreadsheetGroupRow
	*/
	var DividerRow = /** @class */ (function (_super) {
	    tslib.__extends(DividerRow, _super);
	    function DividerRow() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DividerRow.prototype.render = function () {
	        var _this = this;
	        var props = this.props;
	        var renderingHooks = this.props.renderingHooks;
	        var hookProps = { groupValue: props.groupValue, view: this.context.viewApi };
	        return (common.createElement("tr", { ref: props.elRef },
	            common.createElement(common.RenderHook, { hookProps: hookProps, classNames: renderingHooks.laneClassNames, content: renderingHooks.laneContent, didMount: renderingHooks.laneDidMount, willUnmount: renderingHooks.laneWillUnmount }, function (rootElRef, classNames, innerElRef, innerContent) { return (common.createElement("td", { ref: rootElRef, className: [
	                    'fc-timeline-lane',
	                    'fc-resource-group',
	                    _this.context.theme.getClass('tableCellShaded'),
	                ].concat(classNames).join(' ') },
	                common.createElement("div", { style: { height: props.innerHeight }, ref: innerElRef }, innerContent))); })));
	    };
	    return DividerRow;
	}(common.BaseComponent));
	
	var ResourceTimelineLanesBody = /** @class */ (function (_super) {
	    tslib.__extends(ResourceTimelineLanesBody, _super);
	    function ResourceTimelineLanesBody() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ResourceTimelineLanesBody.prototype.render = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        var rowElRefs = props.rowElRefs, innerHeights = props.innerHeights;
	        return (common.createElement("tbody", null, props.rowNodes.map(function (node, index) {
	            if (node.group) {
	                return (common.createElement(DividerRow, { key: node.id, elRef: rowElRefs.createRef(node.id), groupValue: node.group.value, renderingHooks: node.group.spec, innerHeight: innerHeights[index] || '' }));
	            }
	            if (node.resource) {
	                var resource = node.resource;
	                return (common.createElement(ResourceTimelineLane, tslib.__assign({ key: node.id, elRef: rowElRefs.createRef(node.id) }, props.splitProps[resource.id], { resource: resource, dateProfile: props.dateProfile, tDateProfile: props.tDateProfile, nowDate: props.nowDate, todayRange: props.todayRange, nextDayThreshold: context.options.nextDayThreshold, businessHours: resource.businessHours || props.fallbackBusinessHours, innerHeight: innerHeights[index] || '', timelineCoords: props.slatCoords, onHeightChange: props.onRowHeightChange })));
	            }
	            return null;
	        })));
	    };
	    return ResourceTimelineLanesBody;
	}(common.BaseComponent));
	
	var ResourceTimelineLanes = /** @class */ (function (_super) {
	    tslib.__extends(ResourceTimelineLanes, _super);
	    function ResourceTimelineLanes() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.rootElRef = common.createRef();
	        _this.rowElRefs = new common.RefMap();
	        return _this;
	    }
	    ResourceTimelineLanes.prototype.render = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        return (common.createElement("table", { ref: this.rootElRef, "aria-hidden": true, className: 'fc-scrollgrid-sync-table ' + context.theme.getClass('table'), style: {
	                minWidth: props.tableMinWidth,
	                width: props.clientWidth,
	                height: props.minHeight,
	            } },
	            common.createElement(ResourceTimelineLanesBody, { rowElRefs: this.rowElRefs, rowNodes: props.rowNodes, dateProfile: props.dateProfile, tDateProfile: props.tDateProfile, nowDate: props.nowDate, todayRange: props.todayRange, splitProps: props.splitProps, fallbackBusinessHours: props.fallbackBusinessHours, slatCoords: props.slatCoords, innerHeights: props.innerHeights, onRowHeightChange: props.onRowHeightChange })));
	    };
	    ResourceTimelineLanes.prototype.componentDidMount = function () {
	        this.updateCoords();
	    };
	    ResourceTimelineLanes.prototype.componentDidUpdate = function () {
	        this.updateCoords();
	    };
	    ResourceTimelineLanes.prototype.componentWillUnmount = function () {
	        if (this.props.onRowCoords) {
	            this.props.onRowCoords(null);
	        }
	    };
	    ResourceTimelineLanes.prototype.updateCoords = function () {
	        var props = this.props;
	        if (props.onRowCoords && props.clientWidth !== null) { // a populated clientWidth means sizing has stabilized
	            this.props.onRowCoords(new common.PositionCache(this.rootElRef.current, collectRowEls(this.rowElRefs.currentMap, props.rowNodes), false, true));
	        }
	    };
	    return ResourceTimelineLanes;
	}(common.BaseComponent));
	function collectRowEls(elMap, rowNodes) {
	    return rowNodes.map(function (rowNode) { return elMap[rowNode.id]; });
	}
	
	var ResourceTimelineGrid = /** @class */ (function (_super) {
	    tslib.__extends(ResourceTimelineGrid, _super);
	    function ResourceTimelineGrid() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.computeHasResourceBusinessHours = common.memoize(computeHasResourceBusinessHours);
	        _this.resourceSplitter = new resourceCommonPlugin.ResourceSplitter(); // doesn't let it do businessHours tho
	        _this.bgSlicer = new timelinePlugin.TimelineLaneSlicer();
	        _this.slatsRef = common.createRef(); // needed for Hit creation :(
	        _this.state = {
	            slatCoords: null,
	        };
	        _this.handleEl = function (el) {
	            if (el) {
	                _this.context.registerInteractiveComponent(_this, { el: el });
	            }
	            else {
	                _this.context.unregisterInteractiveComponent(_this);
	            }
	        };
	        _this.handleSlatCoords = function (slatCoords) {
	            _this.setState({ slatCoords: slatCoords });
	            if (_this.props.onSlatCoords) {
	                _this.props.onSlatCoords(slatCoords);
	            }
	        };
	        _this.handleRowCoords = function (rowCoords) {
	            _this.rowCoords = rowCoords;
	            if (_this.props.onRowCoords) {
	                _this.props.onRowCoords(rowCoords);
	            }
	        };
	        return _this;
	    }
	    ResourceTimelineGrid.prototype.render = function () {
	        var _this = this;
	        var _a = this, props = _a.props, state = _a.state, context = _a.context;
	        var dateProfile = props.dateProfile, tDateProfile = props.tDateProfile;
	        var timerUnit = common.greatestDurationDenominator(tDateProfile.slotDuration).unit;
	        var hasResourceBusinessHours = this.computeHasResourceBusinessHours(props.rowNodes);
	        var splitProps = this.resourceSplitter.splitProps(props);
	        var bgLaneProps = splitProps[''];
	        var bgSlicedProps = this.bgSlicer.sliceProps(bgLaneProps, dateProfile, tDateProfile.isTimeScale ? null : props.nextDayThreshold, context, // wish we didn't need to pass in the rest of these args...
	        dateProfile, context.dateProfileGenerator, tDateProfile, context.dateEnv);
	        // WORKAROUND: make ignore slatCoords when out of sync with dateProfile
	        var slatCoords = state.slatCoords && state.slatCoords.dateProfile === props.dateProfile ? state.slatCoords : null;
	        return (common.createElement("div", { ref: this.handleEl, className: [
	                'fc-timeline-body',
	                props.expandRows ? 'fc-timeline-body-expandrows' : '',
	            ].join(' '), style: { minWidth: props.tableMinWidth } },
	            common.createElement(common.NowTimer, { unit: timerUnit }, function (nowDate, todayRange) { return (common.createElement(common.Fragment, null,
	                common.createElement(timelinePlugin.TimelineSlats, { ref: _this.slatsRef, dateProfile: dateProfile, tDateProfile: tDateProfile, nowDate: nowDate, todayRange: todayRange, clientWidth: props.clientWidth, tableColGroupNode: props.tableColGroupNode, tableMinWidth: props.tableMinWidth, onCoords: _this.handleSlatCoords, onScrollLeftRequest: props.onScrollLeftRequest }),
	                common.createElement(timelinePlugin.TimelineLaneBg, { businessHourSegs: hasResourceBusinessHours ? null : bgSlicedProps.businessHourSegs, bgEventSegs: bgSlicedProps.bgEventSegs, timelineCoords: slatCoords, 
	                    // empty array will result in unnecessary rerenders?
	                    eventResizeSegs: (bgSlicedProps.eventResize ? bgSlicedProps.eventResize.segs : []), dateSelectionSegs: bgSlicedProps.dateSelectionSegs, nowDate: nowDate, todayRange: todayRange }),
	                common.createElement(ResourceTimelineLanes, { rowNodes: props.rowNodes, dateProfile: dateProfile, tDateProfile: props.tDateProfile, nowDate: nowDate, todayRange: todayRange, splitProps: splitProps, fallbackBusinessHours: hasResourceBusinessHours ? props.businessHours : null, clientWidth: props.clientWidth, minHeight: props.expandRows ? props.clientHeight : '', tableMinWidth: props.tableMinWidth, innerHeights: props.rowInnerHeights, slatCoords: slatCoords, onRowCoords: _this.handleRowCoords, onRowHeightChange: props.onRowHeightChange }),
	                (context.options.nowIndicator && slatCoords && slatCoords.isDateInRange(nowDate)) && (common.createElement("div", { className: "fc-timeline-now-indicator-container" },
	                    common.createElement(common.NowIndicatorRoot, { isAxis: false, date: nowDate }, function (rootElRef, classNames, innerElRef, innerContent) { return (common.createElement("div", { ref: rootElRef, className: ['fc-timeline-now-indicator-line'].concat(classNames).join(' '), style: timelinePlugin.coordToCss(slatCoords.dateToCoord(nowDate), context.isRtl) }, innerContent)); }))))); })));
	    };
	    // Hit System
	    // ------------------------------------------------------------------------------------------
	    ResourceTimelineGrid.prototype.queryHit = function (positionLeft, positionTop) {
	        var rowCoords = this.rowCoords;
	        var rowIndex = rowCoords.topToIndex(positionTop);
	        if (rowIndex != null) {
	            var resource = this.props.rowNodes[rowIndex].resource;
	            if (resource) { // not a group
	                var slatHit = this.slatsRef.current.positionToHit(positionLeft);
	                if (slatHit) {
	                    return {
	                        dateProfile: this.props.dateProfile,
	                        dateSpan: {
	                            range: slatHit.dateSpan.range,
	                            allDay: slatHit.dateSpan.allDay,
	                            resourceId: resource.id,
	                        },
	                        rect: {
	                            left: slatHit.left,
	                            right: slatHit.right,
	                            top: rowCoords.tops[rowIndex],
	                            bottom: rowCoords.bottoms[rowIndex],
	                        },
	                        dayEl: slatHit.dayEl,
	                        layer: 0,
	                    };
	                }
	            }
	        }
	        return null;
	    };
	    return ResourceTimelineGrid;
	}(common.DateComponent));
	function computeHasResourceBusinessHours(rowNodes) {
	    for (var _i = 0, rowNodes_1 = rowNodes; _i < rowNodes_1.length; _i++) {
	        var node = rowNodes_1[_i];
	        var resource = node.resource;
	        if (resource && resource.businessHours) {
	            return true;
	        }
	    }
	    return false;
	}
	
	var MIN_RESOURCE_AREA_WIDTH = 30; // definitely bigger than scrollbars
	// RENAME?
	var ResourceTimelineViewLayout = /** @class */ (function (_super) {
	    tslib.__extends(ResourceTimelineViewLayout, _super);
	    function ResourceTimelineViewLayout() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.scrollGridRef = common.createRef();
	        _this.timeBodyScrollerElRef = common.createRef();
	        _this.spreadsheetHeaderChunkElRef = common.createRef();
	        _this.rootElRef = common.createRef();
	        _this.ensureScrollGridResizeId = 0;
	        _this.state = {
	            resourceAreaWidthOverride: null,
	        };
	        /*
	        ghetto debounce. don't race with ScrollGrid's resizing delay. solves #6140
	        */
	        _this.ensureScrollGridResize = function () {
	            if (_this.ensureScrollGridResizeId) {
	                clearTimeout(_this.ensureScrollGridResizeId);
	            }
	            _this.ensureScrollGridResizeId = setTimeout(function () {
	                _this.scrollGridRef.current.handleSizing(false);
	            }, common.config.SCROLLGRID_RESIZE_INTERVAL + 1);
	        };
	        return _this;
	    }
	    ResourceTimelineViewLayout.prototype.render = function () {
	        var _a = this, props = _a.props, state = _a.state, context = _a.context;
	        var options = context.options;
	        var stickyHeaderDates = !props.forPrint && common.getStickyHeaderDates(options);
	        var stickyFooterScrollbar = !props.forPrint && common.getStickyFooterScrollbar(options);
	        var sections = [
	            {
	                type: 'header',
	                key: 'header',
	                syncRowHeights: true,
	                isSticky: stickyHeaderDates,
	                chunks: [
	                    {
	                        key: 'datagrid',
	                        elRef: this.spreadsheetHeaderChunkElRef,
	                        // TODO: allow the content to specify this. have general-purpose 'content' with obj with keys
	                        tableClassName: 'fc-datagrid-header',
	                        rowContent: props.spreadsheetHeaderRows,
	                    },
	                    {
	                        key: 'divider',
	                        outerContent: (common.createElement("td", { role: "presentation", className: 'fc-resource-timeline-divider ' + context.theme.getClass('tableCellShaded') })),
	                    },
	                    {
	                        key: 'timeline',
	                        content: props.timeHeaderContent,
	                    },
	                ],
	            },
	            {
	                type: 'body',
	                key: 'body',
	                syncRowHeights: true,
	                liquid: true,
	                expandRows: Boolean(options.expandRows),
	                chunks: [
	                    {
	                        key: 'datagrid',
	                        tableClassName: 'fc-datagrid-body',
	                        rowContent: props.spreadsheetBodyRows,
	                    },
	                    {
	                        key: 'divider',
	                        outerContent: (common.createElement("td", { role: "presentation", className: 'fc-resource-timeline-divider ' + context.theme.getClass('tableCellShaded') })),
	                    },
	                    {
	                        key: 'timeline',
	                        scrollerElRef: this.timeBodyScrollerElRef,
	                        content: props.timeBodyContent,
	                    },
	                ],
	            },
	        ];
	        if (stickyFooterScrollbar) {
	            sections.push({
	                type: 'footer',
	                key: 'footer',
	                isSticky: true,
	                chunks: [
	                    {
	                        key: 'datagrid',
	                        content: common.renderScrollShim,
	                    },
	                    {
	                        key: 'divider',
	                        outerContent: (common.createElement("td", { role: "presentation", className: 'fc-resource-timeline-divider ' + context.theme.getClass('tableCellShaded') })),
	                    },
	                    {
	                        key: 'timeline',
	                        content: common.renderScrollShim,
	                    },
	                ],
	            });
	        }
	        var resourceAreaWidth = state.resourceAreaWidthOverride != null
	            ? state.resourceAreaWidthOverride
	            : options.resourceAreaWidth;
	        return (common.createElement(scrollgrid.ScrollGrid, { ref: this.scrollGridRef, elRef: this.rootElRef, liquid: !props.isHeightAuto && !props.forPrint, collapsibleWidth: false, colGroups: [
	                { cols: props.spreadsheetCols, width: resourceAreaWidth },
	                { cols: [] },
	                { cols: props.timeCols },
	            ], sections: sections }));
	    };
	    ResourceTimelineViewLayout.prototype.forceTimeScroll = function (left) {
	        var scrollGrid = this.scrollGridRef.current;
	        scrollGrid.forceScrollLeft(2, left); // 2 = the time area
	    };
	    ResourceTimelineViewLayout.prototype.forceResourceScroll = function (top) {
	        var scrollGrid = this.scrollGridRef.current;
	        scrollGrid.forceScrollTop(1, top); // 1 = the body
	    };
	    ResourceTimelineViewLayout.prototype.getResourceScroll = function () {
	        var timeBodyScrollerEl = this.timeBodyScrollerElRef.current;
	        return timeBodyScrollerEl.scrollTop;
	    };
	    // Resource Area Resizing
	    // ------------------------------------------------------------------------------------------
	    // NOTE: a callback Ref for the resizer was firing multiple times with same elements (Preact)
	    // that's why we use spreadsheetResizerElRef instead
	    ResourceTimelineViewLayout.prototype.componentDidMount = function () {
	        this.initSpreadsheetResizing();
	    };
	    ResourceTimelineViewLayout.prototype.componentWillUnmount = function () {
	        this.destroySpreadsheetResizing();
	    };
	    ResourceTimelineViewLayout.prototype.initSpreadsheetResizing = function () {
	        var _this = this;
	        var _a = this.context, isRtl = _a.isRtl, pluginHooks = _a.pluginHooks;
	        var ElementDraggingImpl = pluginHooks.elementDraggingImpl;
	        var spreadsheetHeadEl = this.spreadsheetHeaderChunkElRef.current;
	        if (ElementDraggingImpl) {
	            var rootEl_1 = this.rootElRef.current;
	            var dragging = this.spreadsheetResizerDragging = new ElementDraggingImpl(rootEl_1, '.fc-resource-timeline-divider');
	            var dragStartWidth_1;
	            var viewWidth_1;
	            dragging.emitter.on('dragstart', function () {
	                dragStartWidth_1 = spreadsheetHeadEl.getBoundingClientRect().width;
	                viewWidth_1 = rootEl_1.getBoundingClientRect().width;
	            });
	            dragging.emitter.on('dragmove', function (pev) {
	                var newWidth = dragStartWidth_1 + pev.deltaX * (isRtl ? -1 : 1);
	                newWidth = Math.max(newWidth, MIN_RESOURCE_AREA_WIDTH);
	                newWidth = Math.min(newWidth, viewWidth_1 - MIN_RESOURCE_AREA_WIDTH);
	                // scrollgrid will ignore resize requests if there are too many :|
	                _this.setState({
	                    resourceAreaWidthOverride: newWidth,
	                }, _this.ensureScrollGridResize);
	            });
	            dragging.setAutoScrollEnabled(false); // because gets weird with auto-scrolling time area
	        }
	    };
	    ResourceTimelineViewLayout.prototype.destroySpreadsheetResizing = function () {
	        if (this.spreadsheetResizerDragging) {
	            this.spreadsheetResizerDragging.destroy();
	        }
	    };
	    return ResourceTimelineViewLayout;
	}(common.BaseComponent));
	
	var ResourceTimelineView = /** @class */ (function (_super) {
	    tslib.__extends(ResourceTimelineView, _super);
	    function ResourceTimelineView(props, context) {
	        var _this = _super.call(this, props, context) || this;
	        _this.processColOptions = common.memoize(processColOptions);
	        _this.buildTimelineDateProfile = common.memoize(timelinePlugin.buildTimelineDateProfile);
	        _this.hasNesting = common.memoize(hasNesting);
	        _this.buildRowNodes = common.memoize(resourceCommonPlugin.buildRowNodes);
	        _this.layoutRef = common.createRef();
	        _this.rowNodes = [];
	        _this.renderedRowNodes = [];
	        _this.buildRowIndex = common.memoize(buildRowIndex);
	        _this.handleSlatCoords = function (slatCoords) {
	            _this.setState({ slatCoords: slatCoords });
	        };
	        _this.handleRowCoords = function (rowCoords) {
	            _this.rowCoords = rowCoords;
	            _this.scrollResponder.update(false); // TODO: could eliminate this if rowCoords lived in state
	        };
	        _this.handleMaxCushionWidth = function (slotCushionMaxWidth) {
	            _this.setState({
	                slotCushionMaxWidth: Math.ceil(slotCushionMaxWidth), // for less rerendering TODO: DRY
	            });
	        };
	        // Scrolling
	        // ------------------------------------------------------------------------------------------------------------------
	        // this is useful for scrolling prev/next dates while resource is scrolled down
	        _this.handleScrollLeftRequest = function (scrollLeft) {
	            var layout = _this.layoutRef.current;
	            layout.forceTimeScroll(scrollLeft);
	        };
	        _this.handleScrollRequest = function (request) {
	            var rowCoords = _this.rowCoords;
	            var layout = _this.layoutRef.current;
	            var rowId = request.rowId || request.resourceId;
	            if (rowCoords) {
	                if (rowId) {
	                    var rowIdToIndex = _this.buildRowIndex(_this.renderedRowNodes);
	                    var index = rowIdToIndex[rowId];
	                    if (index != null) {
	                        var scrollTop = (request.fromBottom != null ?
	                            rowCoords.bottoms[index] - request.fromBottom : // pixels from bottom edge
	                            rowCoords.tops[index] // just use top edge
	                        );
	                        layout.forceResourceScroll(scrollTop);
	                    }
	                }
	                return true;
	            }
	            return null;
	        };
	        // Resource INDIVIDUAL-Column Area Resizing
	        // ------------------------------------------------------------------------------------------
	        _this.handleColWidthChange = function (colWidths) {
	            _this.setState({
	                spreadsheetColWidths: colWidths,
	            });
	        };
	        _this.state = {
	            resourceAreaWidth: context.options.resourceAreaWidth,
	            spreadsheetColWidths: [],
	        };
	        return _this;
	    }
	    ResourceTimelineView.prototype.render = function () {
	        var _this = this;
	        var _a = this, props = _a.props, state = _a.state, context = _a.context;
	        var options = context.options, viewSpec = context.viewSpec;
	        var _b = this.processColOptions(context.options), superHeaderRendering = _b.superHeaderRendering, groupSpecs = _b.groupSpecs, orderSpecs = _b.orderSpecs, isVGrouping = _b.isVGrouping, colSpecs = _b.colSpecs;
	        var tDateProfile = this.buildTimelineDateProfile(props.dateProfile, context.dateEnv, options, context.dateProfileGenerator);
	        var rowNodes = this.rowNodes = this.buildRowNodes(props.resourceStore, groupSpecs, orderSpecs, isVGrouping, props.resourceEntityExpansions, options.resourcesInitiallyExpanded);
	        var extraClassNames = [
	            'fc-resource-timeline',
	            this.hasNesting(rowNodes) ? '' : 'fc-resource-timeline-flat',
	            'fc-timeline',
	            options.eventOverlap === false ? 'fc-timeline-overlap-disabled' : 'fc-timeline-overlap-enabled',
	        ];
	        var slotMinWidth = options.slotMinWidth;
	        var slatCols = timelinePlugin.buildSlatCols(tDateProfile, slotMinWidth || this.computeFallbackSlotMinWidth(tDateProfile));
	        return (common.createElement(common.ViewRoot, { viewSpec: viewSpec }, function (rootElRef, classNames) { return (common.createElement("div", { ref: rootElRef, className: extraClassNames.concat(classNames).join(' ') },
	            common.createElement(ResourceTimelineViewLayout, { ref: _this.layoutRef, forPrint: props.forPrint, isHeightAuto: props.isHeightAuto, spreadsheetCols: buildSpreadsheetCols(colSpecs, state.spreadsheetColWidths, ''), spreadsheetHeaderRows: function (contentArg) { return (common.createElement(SpreadsheetHeader // TODO: rename to SpreadsheetHeaderRows
	                , { superHeaderRendering: superHeaderRendering, colSpecs: colSpecs, onColWidthChange: _this.handleColWidthChange, rowInnerHeights: contentArg.rowSyncHeights })); }, spreadsheetBodyRows: function (contentArg) { return (common.createElement(common.Fragment, null, _this.renderSpreadsheetRows(rowNodes, colSpecs, contentArg.rowSyncHeights))); }, timeCols: slatCols, timeHeaderContent: function (contentArg) { return (common.createElement(timelinePlugin.TimelineHeader, { clientWidth: contentArg.clientWidth, clientHeight: contentArg.clientHeight, tableMinWidth: contentArg.tableMinWidth, tableColGroupNode: contentArg.tableColGroupNode, dateProfile: props.dateProfile, tDateProfile: tDateProfile, slatCoords: state.slatCoords, rowInnerHeights: contentArg.rowSyncHeights, onMaxCushionWidth: slotMinWidth ? null : _this.handleMaxCushionWidth })); }, timeBodyContent: function (contentArg) { return (common.createElement(ResourceTimelineGrid, { dateProfile: props.dateProfile, clientWidth: contentArg.clientWidth, clientHeight: contentArg.clientHeight, tableMinWidth: contentArg.tableMinWidth, tableColGroupNode: contentArg.tableColGroupNode, expandRows: contentArg.expandRows, tDateProfile: tDateProfile, rowNodes: rowNodes, businessHours: props.businessHours, dateSelection: props.dateSelection, eventStore: props.eventStore, eventUiBases: props.eventUiBases, eventSelection: props.eventSelection, eventDrag: props.eventDrag, eventResize: props.eventResize, resourceStore: props.resourceStore, nextDayThreshold: context.options.nextDayThreshold, rowInnerHeights: contentArg.rowSyncHeights, onSlatCoords: _this.handleSlatCoords, onRowCoords: _this.handleRowCoords, onScrollLeftRequest: _this.handleScrollLeftRequest, onRowHeightChange: contentArg.reportRowHeightChange })); } }))); }));
	    };
	    ResourceTimelineView.prototype.renderSpreadsheetRows = function (nodes, colSpecs, rowSyncHeights) {
	        return nodes.map(function (node, index) {
	            if (node.group) {
	                return (common.createElement(SpreadsheetGroupRow, { key: node.id, id: node.id, spreadsheetColCnt: colSpecs.length, isExpanded: node.isExpanded, group: node.group, innerHeight: rowSyncHeights[index] || '' }));
	            }
	            if (node.resource) {
	                return (common.createElement(SpreadsheetRow, { key: node.id, colSpecs: colSpecs, rowSpans: node.rowSpans, depth: node.depth, isExpanded: node.isExpanded, hasChildren: node.hasChildren, resource: node.resource, innerHeight: rowSyncHeights[index] || '' }));
	            }
	            return null;
	        });
	    };
	    ResourceTimelineView.prototype.componentDidMount = function () {
	        this.renderedRowNodes = this.rowNodes;
	        this.scrollResponder = this.context.createScrollResponder(this.handleScrollRequest);
	    };
	    ResourceTimelineView.prototype.getSnapshotBeforeUpdate = function () {
	        if (!this.props.forPrint) { // because print-view is always zero?
	            return { resourceScroll: this.queryResourceScroll() };
	        }
	        return {};
	    };
	    ResourceTimelineView.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
	        this.renderedRowNodes = this.rowNodes;
	        this.scrollResponder.update(prevProps.dateProfile !== this.props.dateProfile);
	        if (snapshot.resourceScroll) {
	            this.handleScrollRequest(snapshot.resourceScroll); // TODO: this gets triggered too often
	        }
	    };
	    ResourceTimelineView.prototype.componentWillUnmount = function () {
	        this.scrollResponder.detach();
	    };
	    ResourceTimelineView.prototype.computeFallbackSlotMinWidth = function (tDateProfile) {
	        return Math.max(30, ((this.state.slotCushionMaxWidth || 0) / tDateProfile.slotsPerLabel));
	    };
	    ResourceTimelineView.prototype.queryResourceScroll = function () {
	        var _a = this, rowCoords = _a.rowCoords, renderedRowNodes = _a.renderedRowNodes;
	        if (rowCoords) {
	            var layout = this.layoutRef.current;
	            var trBottoms = rowCoords.bottoms;
	            var scrollTop = layout.getResourceScroll();
	            var scroll_1 = {};
	            for (var i = 0; i < trBottoms.length; i += 1) {
	                var rowNode = renderedRowNodes[i];
	                var elBottom = trBottoms[i] - scrollTop; // from the top of the scroller
	                if (elBottom > 0) {
	                    scroll_1.rowId = rowNode.id;
	                    scroll_1.fromBottom = elBottom;
	                    break;
	                }
	            }
	            return scroll_1;
	        }
	        return null;
	    };
	    return ResourceTimelineView;
	}(common.BaseComponent));
	ResourceTimelineView.addStateEquality({
	    spreadsheetColWidths: common.isArraysEqual,
	});
	function buildRowIndex(rowNodes) {
	    var rowIdToIndex = {};
	    for (var i = 0; i < rowNodes.length; i += 1) {
	        rowIdToIndex[rowNodes[i].id] = i;
	    }
	    return rowIdToIndex;
	}
	function buildSpreadsheetCols(colSpecs, forcedWidths, fallbackWidth) {
	    if (fallbackWidth === void 0) { fallbackWidth = ''; }
	    return colSpecs.map(function (colSpec, i) { return ({
	        className: colSpec.isMain ? 'fc-main-col' : '',
	        width: forcedWidths[i] || colSpec.width || fallbackWidth,
	    }); });
	}
	function hasNesting(nodes) {
	    for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
	        var node = nodes_1[_i];
	        if (node.group) {
	            return true;
	        }
	        if (node.resource) {
	            if (node.hasChildren) {
	                return true;
	            }
	        }
	    }
	    return false;
	}
	function processColOptions(options) {
	    var allColSpecs = options.resourceAreaColumns || [];
	    var superHeaderRendering = null;
	    if (!allColSpecs.length) {
	        allColSpecs.push({
	            headerClassNames: options.resourceAreaHeaderClassNames,
	            headerContent: options.resourceAreaHeaderContent || 'Resources',
	            headerDidMount: options.resourceAreaHeaderDidMount,
	            headerWillUnmount: options.resourceAreaHeaderWillUnmount,
	        });
	    }
	    else if (options.resourceAreaHeaderContent) { // weird way to determine if content
	        superHeaderRendering = {
	            headerClassNames: options.resourceAreaHeaderClassNames,
	            headerContent: options.resourceAreaHeaderContent,
	            headerDidMount: options.resourceAreaHeaderDidMount,
	            headerWillUnmount: options.resourceAreaHeaderWillUnmount,
	        };
	    }
	    var plainColSpecs = [];
	    var groupColSpecs = []; // part of the colSpecs, but filtered out in order to put first
	    var groupSpecs = [];
	    var isVGrouping = false;
	    for (var _i = 0, allColSpecs_1 = allColSpecs; _i < allColSpecs_1.length; _i++) {
	        var colSpec = allColSpecs_1[_i];
	        if (colSpec.group) {
	            groupColSpecs.push(tslib.__assign(tslib.__assign({}, colSpec), { cellClassNames: colSpec.cellClassNames || options.resourceGroupLabelClassNames, cellContent: colSpec.cellContent || options.resourceGroupLabelContent, cellDidMount: colSpec.cellDidMount || options.resourceGroupLabelDidMount, cellWillUnmount: colSpec.cellWillUnmount || options.resourceGroupLaneWillUnmount }));
	        }
	        else {
	            plainColSpecs.push(colSpec);
	        }
	    }
	    // BAD: mutates a user-supplied option
	    var mainColSpec = plainColSpecs[0];
	    mainColSpec.isMain = true;
	    mainColSpec.cellClassNames = mainColSpec.cellClassNames || options.resourceLabelClassNames;
	    mainColSpec.cellContent = mainColSpec.cellContent || options.resourceLabelContent;
	    mainColSpec.cellDidMount = mainColSpec.cellDidMount || options.resourceLabelDidMount;
	    mainColSpec.cellWillUnmount = mainColSpec.cellWillUnmount || options.resourceLabelWillUnmount;
	    if (groupColSpecs.length) {
	        groupSpecs = groupColSpecs;
	        isVGrouping = true;
	    }
	    else {
	        var hGroupField = options.resourceGroupField;
	        if (hGroupField) {
	            groupSpecs.push({
	                field: hGroupField,
	                labelClassNames: options.resourceGroupLabelClassNames,
	                labelContent: options.resourceGroupLabelContent,
	                labelDidMount: options.resourceGroupLabelDidMount,
	                labelWillUnmount: options.resourceGroupLabelWillUnmount,
	                laneClassNames: options.resourceGroupLaneClassNames,
	                laneContent: options.resourceGroupLaneContent,
	                laneDidMount: options.resourceGroupLaneDidMount,
	                laneWillUnmount: options.resourceGroupLaneWillUnmount,
	            });
	        }
	    }
	    var allOrderSpecs = options.resourceOrder || resourceCommonPlugin.DEFAULT_RESOURCE_ORDER;
	    var plainOrderSpecs = [];
	    for (var _a = 0, allOrderSpecs_1 = allOrderSpecs; _a < allOrderSpecs_1.length; _a++) {
	        var orderSpec = allOrderSpecs_1[_a];
	        var isGroup = false;
	        for (var _b = 0, groupSpecs_1 = groupSpecs; _b < groupSpecs_1.length; _b++) {
	            var groupSpec = groupSpecs_1[_b];
	            if (groupSpec.field === orderSpec.field) {
	                groupSpec.order = orderSpec.order; // -1, 0, 1
	                isGroup = true;
	                break;
	            }
	        }
	        if (!isGroup) {
	            plainOrderSpecs.push(orderSpec);
	        }
	    }
	    return {
	        superHeaderRendering: superHeaderRendering,
	        isVGrouping: isVGrouping,
	        groupSpecs: groupSpecs,
	        colSpecs: groupColSpecs.concat(plainColSpecs),
	        orderSpecs: plainOrderSpecs,
	    };
	}
	
	var main = common.createPlugin({
	    deps: [
	        premiumCommonPlugin__default['default'],
	        resourceCommonPlugin__default['default'],
	        timelinePlugin__default['default'],
	    ],
	    initialView: 'resourceTimelineDay',
	    views: {
	        resourceTimeline: {
	            type: 'timeline',
	            component: ResourceTimelineView,
	            needsResourceData: true,
	            resourceAreaWidth: '30%',
	            resourcesInitiallyExpanded: true,
	            eventResizableFromStart: true, // TODO: not DRY with this same setting in the main timeline config
	        },
	        resourceTimelineDay: {
	            type: 'resourceTimeline',
	            duration: { days: 1 },
	        },
	        resourceTimelineWeek: {
	            type: 'resourceTimeline',
	            duration: { weeks: 1 },
	        },
	        resourceTimelineMonth: {
	            type: 'resourceTimeline',
	            duration: { months: 1 },
	        },
	        resourceTimelineYear: {
	            type: 'resourceTimeline',
	            duration: { years: 1 },
	        },
	    },
	});
	
	exports.ResourceTimelineLane = ResourceTimelineLane;
	exports.ResourceTimelineView = ResourceTimelineView;
	exports.SpreadsheetRow = SpreadsheetRow;
	exports.default = main;


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	FullCalendar Scheduler v5.11.5
	Docs & License: https://fullcalendar.io/scheduler
	(c) 2022 Adam Shaw
	*/
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var common = __webpack_require__(70);
	var premiumCommonPlugin = __webpack_require__(99);
	var tslib = __webpack_require__(80);
	var scrollgrid = __webpack_require__(206);
	;
	
	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }
	
	var premiumCommonPlugin__default = /*#__PURE__*/_interopDefaultLegacy(premiumCommonPlugin);
	
	var MIN_AUTO_LABELS = 18; // more than `12` months but less that `24` hours
	var MAX_AUTO_SLOTS_PER_LABEL = 6; // allows 6 10-min slots in an hour
	var MAX_AUTO_CELLS = 200; // allows 4-days to have a :30 slot duration
	common.config.MAX_TIMELINE_SLOTS = 1000;
	// potential nice values for slot-duration and interval-duration
	var STOCK_SUB_DURATIONS = [
	    { years: 1 },
	    { months: 1 },
	    { days: 1 },
	    { hours: 1 },
	    { minutes: 30 },
	    { minutes: 15 },
	    { minutes: 10 },
	    { minutes: 5 },
	    { minutes: 1 },
	    { seconds: 30 },
	    { seconds: 15 },
	    { seconds: 10 },
	    { seconds: 5 },
	    { seconds: 1 },
	    { milliseconds: 500 },
	    { milliseconds: 100 },
	    { milliseconds: 10 },
	    { milliseconds: 1 },
	];
	function buildTimelineDateProfile(dateProfile, dateEnv, allOptions, dateProfileGenerator) {
	    var tDateProfile = {
	        labelInterval: allOptions.slotLabelInterval,
	        slotDuration: allOptions.slotDuration,
	    };
	    validateLabelAndSlot(tDateProfile, dateProfile, dateEnv); // validate after computed grid duration
	    ensureLabelInterval(tDateProfile, dateProfile, dateEnv);
	    ensureSlotDuration(tDateProfile, dateProfile, dateEnv);
	    var input = allOptions.slotLabelFormat;
	    var rawFormats = Array.isArray(input) ? input :
	        (input != null) ? [input] :
	            computeHeaderFormats(tDateProfile, dateProfile, dateEnv, allOptions);
	    tDateProfile.headerFormats = rawFormats.map(function (rawFormat) { return common.createFormatter(rawFormat); });
	    tDateProfile.isTimeScale = Boolean(tDateProfile.slotDuration.milliseconds);
	    var largeUnit = null;
	    if (!tDateProfile.isTimeScale) {
	        var slotUnit = common.greatestDurationDenominator(tDateProfile.slotDuration).unit;
	        if (/year|month|week/.test(slotUnit)) {
	            largeUnit = slotUnit;
	        }
	    }
	    tDateProfile.largeUnit = largeUnit;
	    tDateProfile.emphasizeWeeks =
	        common.asCleanDays(tDateProfile.slotDuration) === 1 &&
	            currentRangeAs('weeks', dateProfile, dateEnv) >= 2 &&
	            !allOptions.businessHours;
	    /*
	    console.log('label interval =', timelineView.labelInterval.humanize())
	    console.log('slot duration =', timelineView.slotDuration.humanize())
	    console.log('header formats =', timelineView.headerFormats)
	    console.log('isTimeScale', timelineView.isTimeScale)
	    console.log('largeUnit', timelineView.largeUnit)
	    */
	    var rawSnapDuration = allOptions.snapDuration;
	    var snapDuration;
	    var snapsPerSlot;
	    if (rawSnapDuration) {
	        snapDuration = common.createDuration(rawSnapDuration);
	        snapsPerSlot = common.wholeDivideDurations(tDateProfile.slotDuration, snapDuration);
	        // ^ TODO: warning if not whole?
	    }
	    if (snapsPerSlot == null) {
	        snapDuration = tDateProfile.slotDuration;
	        snapsPerSlot = 1;
	    }
	    tDateProfile.snapDuration = snapDuration;
	    tDateProfile.snapsPerSlot = snapsPerSlot;
	    // more...
	    var timeWindowMs = common.asRoughMs(dateProfile.slotMaxTime) - common.asRoughMs(dateProfile.slotMinTime);
	    // TODO: why not use normalizeRange!?
	    var normalizedStart = normalizeDate(dateProfile.renderRange.start, tDateProfile, dateEnv);
	    var normalizedEnd = normalizeDate(dateProfile.renderRange.end, tDateProfile, dateEnv);
	    // apply slotMinTime/slotMaxTime
	    // TODO: View should be responsible.
	    if (tDateProfile.isTimeScale) {
	        normalizedStart = dateEnv.add(normalizedStart, dateProfile.slotMinTime);
	        normalizedEnd = dateEnv.add(common.addDays(normalizedEnd, -1), dateProfile.slotMaxTime);
	    }
	    tDateProfile.timeWindowMs = timeWindowMs;
	    tDateProfile.normalizedRange = { start: normalizedStart, end: normalizedEnd };
	    var slotDates = [];
	    var date = normalizedStart;
	    while (date < normalizedEnd) {
	        if (isValidDate(date, tDateProfile, dateProfile, dateProfileGenerator)) {
	            slotDates.push(date);
	        }
	        date = dateEnv.add(date, tDateProfile.slotDuration);
	    }
	    tDateProfile.slotDates = slotDates;
	    // more...
	    var snapIndex = -1;
	    var snapDiff = 0; // index of the diff :(
	    var snapDiffToIndex = [];
	    var snapIndexToDiff = [];
	    date = normalizedStart;
	    while (date < normalizedEnd) {
	        if (isValidDate(date, tDateProfile, dateProfile, dateProfileGenerator)) {
	            snapIndex += 1;
	            snapDiffToIndex.push(snapIndex);
	            snapIndexToDiff.push(snapDiff);
	        }
	        else {
	            snapDiffToIndex.push(snapIndex + 0.5);
	        }
	        date = dateEnv.add(date, tDateProfile.snapDuration);
	        snapDiff += 1;
	    }
	    tDateProfile.snapDiffToIndex = snapDiffToIndex;
	    tDateProfile.snapIndexToDiff = snapIndexToDiff;
	    tDateProfile.snapCnt = snapIndex + 1; // is always one behind
	    tDateProfile.slotCnt = tDateProfile.snapCnt / tDateProfile.snapsPerSlot;
	    // more...
	    tDateProfile.isWeekStarts = buildIsWeekStarts(tDateProfile, dateEnv);
	    tDateProfile.cellRows = buildCellRows(tDateProfile, dateEnv);
	    tDateProfile.slotsPerLabel = common.wholeDivideDurations(tDateProfile.labelInterval, tDateProfile.slotDuration);
	    return tDateProfile;
	}
	/*
	snaps to appropriate unit
	*/
	function normalizeDate(date, tDateProfile, dateEnv) {
	    var normalDate = date;
	    if (!tDateProfile.isTimeScale) {
	        normalDate = common.startOfDay(normalDate);
	        if (tDateProfile.largeUnit) {
	            normalDate = dateEnv.startOf(normalDate, tDateProfile.largeUnit);
	        }
	    }
	    return normalDate;
	}
	/*
	snaps to appropriate unit
	*/
	function normalizeRange(range, tDateProfile, dateEnv) {
	    if (!tDateProfile.isTimeScale) {
	        range = common.computeVisibleDayRange(range);
	        if (tDateProfile.largeUnit) {
	            var dayRange = range; // preserve original result
	            range = {
	                start: dateEnv.startOf(range.start, tDateProfile.largeUnit),
	                end: dateEnv.startOf(range.end, tDateProfile.largeUnit),
	            };
	            // if date is partially through the interval, or is in the same interval as the start,
	            // make the exclusive end be the *next* interval
	            if (range.end.valueOf() !== dayRange.end.valueOf() || range.end <= range.start) {
	                range = {
	                    start: range.start,
	                    end: dateEnv.add(range.end, tDateProfile.slotDuration),
	                };
	            }
	        }
	    }
	    return range;
	}
	function isValidDate(date, tDateProfile, dateProfile, dateProfileGenerator) {
	    if (dateProfileGenerator.isHiddenDay(date)) {
	        return false;
	    }
	    if (tDateProfile.isTimeScale) {
	        // determine if the time is within slotMinTime/slotMaxTime, which may have wacky values
	        var day = common.startOfDay(date);
	        var timeMs = date.valueOf() - day.valueOf();
	        var ms = timeMs - common.asRoughMs(dateProfile.slotMinTime); // milliseconds since slotMinTime
	        ms = ((ms % 86400000) + 86400000) % 86400000; // make negative values wrap to 24hr clock
	        return ms < tDateProfile.timeWindowMs; // before the slotMaxTime?
	    }
	    return true;
	}
	function validateLabelAndSlot(tDateProfile, dateProfile, dateEnv) {
	    var currentRange = dateProfile.currentRange;
	    // make sure labelInterval doesn't exceed the max number of cells
	    if (tDateProfile.labelInterval) {
	        var labelCnt = dateEnv.countDurationsBetween(currentRange.start, currentRange.end, tDateProfile.labelInterval);
	        if (labelCnt > common.config.MAX_TIMELINE_SLOTS) {
	            console.warn('slotLabelInterval results in too many cells');
	            tDateProfile.labelInterval = null;
	        }
	    }
	    // make sure slotDuration doesn't exceed the maximum number of cells
	    if (tDateProfile.slotDuration) {
	        var slotCnt = dateEnv.countDurationsBetween(currentRange.start, currentRange.end, tDateProfile.slotDuration);
	        if (slotCnt > common.config.MAX_TIMELINE_SLOTS) {
	            console.warn('slotDuration results in too many cells');
	            tDateProfile.slotDuration = null;
	        }
	    }
	    // make sure labelInterval is a multiple of slotDuration
	    if (tDateProfile.labelInterval && tDateProfile.slotDuration) {
	        var slotsPerLabel = common.wholeDivideDurations(tDateProfile.labelInterval, tDateProfile.slotDuration);
	        if (slotsPerLabel === null || slotsPerLabel < 1) {
	            console.warn('slotLabelInterval must be a multiple of slotDuration');
	            tDateProfile.slotDuration = null;
	        }
	    }
	}
	function ensureLabelInterval(tDateProfile, dateProfile, dateEnv) {
	    var currentRange = dateProfile.currentRange;
	    var labelInterval = tDateProfile.labelInterval;
	    if (!labelInterval) {
	        // compute based off the slot duration
	        // find the largest label interval with an acceptable slots-per-label
	        var input = void 0;
	        if (tDateProfile.slotDuration) {
	            for (var _i = 0, STOCK_SUB_DURATIONS_1 = STOCK_SUB_DURATIONS; _i < STOCK_SUB_DURATIONS_1.length; _i++) {
	                input = STOCK_SUB_DURATIONS_1[_i];
	                var tryLabelInterval = common.createDuration(input);
	                var slotsPerLabel = common.wholeDivideDurations(tryLabelInterval, tDateProfile.slotDuration);
	                if (slotsPerLabel !== null && slotsPerLabel <= MAX_AUTO_SLOTS_PER_LABEL) {
	                    labelInterval = tryLabelInterval;
	                    break;
	                }
	            }
	            // use the slot duration as a last resort
	            if (!labelInterval) {
	                labelInterval = tDateProfile.slotDuration;
	            }
	            // compute based off the view's duration
	            // find the largest label interval that yields the minimum number of labels
	        }
	        else {
	            for (var _a = 0, STOCK_SUB_DURATIONS_2 = STOCK_SUB_DURATIONS; _a < STOCK_SUB_DURATIONS_2.length; _a++) {
	                input = STOCK_SUB_DURATIONS_2[_a];
	                labelInterval = common.createDuration(input);
	                var labelCnt = dateEnv.countDurationsBetween(currentRange.start, currentRange.end, labelInterval);
	                if (labelCnt >= MIN_AUTO_LABELS) {
	                    break;
	                }
	            }
	        }
	        tDateProfile.labelInterval = labelInterval;
	    }
	    return labelInterval;
	}
	function ensureSlotDuration(tDateProfile, dateProfile, dateEnv) {
	    var currentRange = dateProfile.currentRange;
	    var slotDuration = tDateProfile.slotDuration;
	    if (!slotDuration) {
	        var labelInterval = ensureLabelInterval(tDateProfile, dateProfile, dateEnv); // will compute if necessary
	        // compute based off the label interval
	        // find the largest slot duration that is different from labelInterval, but still acceptable
	        for (var _i = 0, STOCK_SUB_DURATIONS_3 = STOCK_SUB_DURATIONS; _i < STOCK_SUB_DURATIONS_3.length; _i++) {
	            var input = STOCK_SUB_DURATIONS_3[_i];
	            var trySlotDuration = common.createDuration(input);
	            var slotsPerLabel = common.wholeDivideDurations(labelInterval, trySlotDuration);
	            if (slotsPerLabel !== null && slotsPerLabel > 1 && slotsPerLabel <= MAX_AUTO_SLOTS_PER_LABEL) {
	                slotDuration = trySlotDuration;
	                break;
	            }
	        }
	        // only allow the value if it won't exceed the view's # of slots limit
	        if (slotDuration) {
	            var slotCnt = dateEnv.countDurationsBetween(currentRange.start, currentRange.end, slotDuration);
	            if (slotCnt > MAX_AUTO_CELLS) {
	                slotDuration = null;
	            }
	        }
	        // use the label interval as a last resort
	        if (!slotDuration) {
	            slotDuration = labelInterval;
	        }
	        tDateProfile.slotDuration = slotDuration;
	    }
	    return slotDuration;
	}
	function computeHeaderFormats(tDateProfile, dateProfile, dateEnv, allOptions) {
	    var format1;
	    var format2;
	    var labelInterval = tDateProfile.labelInterval;
	    var unit = common.greatestDurationDenominator(labelInterval).unit;
	    var weekNumbersVisible = allOptions.weekNumbers;
	    var format0 = (format1 = (format2 = null));
	    // NOTE: weekNumber computation function wont work
	    if ((unit === 'week') && !weekNumbersVisible) {
	        unit = 'day';
	    }
	    switch (unit) {
	        case 'year':
	            format0 = { year: 'numeric' }; // '2015'
	            break;
	        case 'month':
	            if (currentRangeAs('years', dateProfile, dateEnv) > 1) {
	                format0 = { year: 'numeric' }; // '2015'
	            }
	            format1 = { month: 'short' }; // 'Jan'
	            break;
	        case 'week':
	            if (currentRangeAs('years', dateProfile, dateEnv) > 1) {
	                format0 = { year: 'numeric' }; // '2015'
	            }
	            format1 = { week: 'narrow' }; // 'Wk4'
	            break;
	        case 'day':
	            if (currentRangeAs('years', dateProfile, dateEnv) > 1) {
	                format0 = { year: 'numeric', month: 'long' }; // 'January 2014'
	            }
	            else if (currentRangeAs('months', dateProfile, dateEnv) > 1) {
	                format0 = { month: 'long' }; // 'January'
	            }
	            if (weekNumbersVisible) {
	                format1 = { week: 'short' }; // 'Wk 4'
	            }
	            format2 = { weekday: 'narrow', day: 'numeric' }; // 'Su 9'
	            break;
	        case 'hour':
	            if (weekNumbersVisible) {
	                format0 = { week: 'short' }; // 'Wk 4'
	            }
	            if (currentRangeAs('days', dateProfile, dateEnv) > 1) {
	                format1 = { weekday: 'short', day: 'numeric', month: 'numeric', omitCommas: true }; // Sat 4/7
	            }
	            format2 = {
	                hour: 'numeric',
	                minute: '2-digit',
	                omitZeroMinute: true,
	                meridiem: 'short',
	            };
	            break;
	        case 'minute':
	            // sufficiently large number of different minute cells?
	            if ((common.asRoughMinutes(labelInterval) / 60) >= MAX_AUTO_SLOTS_PER_LABEL) {
	                format0 = {
	                    hour: 'numeric',
	                    meridiem: 'short',
	                };
	                format1 = function (params) { return (':' + common.padStart(params.date.minute, 2) // ':30'
	                ); };
	            }
	            else {
	                format0 = {
	                    hour: 'numeric',
	                    minute: 'numeric',
	                    meridiem: 'short',
	                };
	            }
	            break;
	        case 'second':
	            // sufficiently large number of different second cells?
	            if ((common.asRoughSeconds(labelInterval) / 60) >= MAX_AUTO_SLOTS_PER_LABEL) {
	                format0 = { hour: 'numeric', minute: '2-digit', meridiem: 'lowercase' }; // '8:30 PM'
	                format1 = function (params) { return (':' + common.padStart(params.date.second, 2) // ':30'
	                ); };
	            }
	            else {
	                format0 = { hour: 'numeric', minute: '2-digit', second: '2-digit', meridiem: 'lowercase' }; // '8:30:45 PM'
	            }
	            break;
	        case 'millisecond':
	            format0 = { hour: 'numeric', minute: '2-digit', second: '2-digit', meridiem: 'lowercase' }; // '8:30:45 PM'
	            format1 = function (params) { return ('.' + common.padStart(params.millisecond, 3)); };
	            break;
	    }
	    return [].concat(format0 || [], format1 || [], format2 || []);
	}
	// Compute the number of the give units in the "current" range.
	// Won't go more precise than days.
	// Will return `0` if there's not a clean whole interval.
	function currentRangeAs(unit, dateProfile, dateEnv) {
	    var range = dateProfile.currentRange;
	    var res = null;
	    if (unit === 'years') {
	        res = dateEnv.diffWholeYears(range.start, range.end);
	    }
	    else if (unit === 'months') {
	        res = dateEnv.diffWholeMonths(range.start, range.end);
	    }
	    else if (unit === 'weeks') {
	        res = dateEnv.diffWholeMonths(range.start, range.end);
	    }
	    else if (unit === 'days') {
	        res = common.diffWholeDays(range.start, range.end);
	    }
	    return res || 0;
	}
	function buildIsWeekStarts(tDateProfile, dateEnv) {
	    var slotDates = tDateProfile.slotDates, emphasizeWeeks = tDateProfile.emphasizeWeeks;
	    var prevWeekNumber = null;
	    var isWeekStarts = [];
	    for (var _i = 0, slotDates_1 = slotDates; _i < slotDates_1.length; _i++) {
	        var slotDate = slotDates_1[_i];
	        var weekNumber = dateEnv.computeWeekNumber(slotDate);
	        var isWeekStart = emphasizeWeeks && (prevWeekNumber !== null) && (prevWeekNumber !== weekNumber);
	        prevWeekNumber = weekNumber;
	        isWeekStarts.push(isWeekStart);
	    }
	    return isWeekStarts;
	}
	function buildCellRows(tDateProfile, dateEnv) {
	    var slotDates = tDateProfile.slotDates;
	    var formats = tDateProfile.headerFormats;
	    var cellRows = formats.map(function () { return []; }); // indexed by row,col
	    var slotAsDays = common.asCleanDays(tDateProfile.slotDuration);
	    var guessedSlotUnit = slotAsDays === 7 ? 'week' :
	        slotAsDays === 1 ? 'day' :
	            null;
	    // specifically for navclicks
	    var rowUnitsFromFormats = formats.map(function (format) { return (format.getLargestUnit ? format.getLargestUnit() : null); });
	    // builds cellRows and slotCells
	    for (var i = 0; i < slotDates.length; i += 1) {
	        var date = slotDates[i];
	        var isWeekStart = tDateProfile.isWeekStarts[i];
	        for (var row = 0; row < formats.length; row += 1) {
	            var format = formats[row];
	            var rowCells = cellRows[row];
	            var leadingCell = rowCells[rowCells.length - 1];
	            var isLastRow = row === formats.length - 1;
	            var isSuperRow = formats.length > 1 && !isLastRow; // more than one row and not the last
	            var newCell = null;
	            var rowUnit = rowUnitsFromFormats[row] || (isLastRow ? guessedSlotUnit : null);
	            if (isSuperRow) {
	                var text = dateEnv.format(date, format);
	                if (!leadingCell || (leadingCell.text !== text)) {
	                    newCell = buildCellObject(date, text, rowUnit);
	                }
	                else {
	                    leadingCell.colspan += 1;
	                }
	            }
	            else if (!leadingCell ||
	                common.isInt(dateEnv.countDurationsBetween(tDateProfile.normalizedRange.start, date, tDateProfile.labelInterval))) {
	                var text = dateEnv.format(date, format);
	                newCell = buildCellObject(date, text, rowUnit);
	            }
	            else {
	                leadingCell.colspan += 1;
	            }
	            if (newCell) {
	                newCell.weekStart = isWeekStart;
	                rowCells.push(newCell);
	            }
	        }
	    }
	    return cellRows;
	}
	function buildCellObject(date, text, rowUnit) {
	    return { date: date, text: text, rowUnit: rowUnit, colspan: 1, isWeekStart: false };
	}
	
	var TimelineHeaderThInner = /** @class */ (function (_super) {
	    tslib.__extends(TimelineHeaderThInner, _super);
	    function TimelineHeaderThInner() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TimelineHeaderThInner.prototype.render = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        return (common.createElement(common.ContentHook, { hookProps: props.hookProps, content: context.options.slotLabelContent, defaultContent: renderInnerContent }, function (innerElRef, innerContent) { return (common.createElement("a", tslib.__assign({ ref: innerElRef, className: 'fc-timeline-slot-cushion fc-scrollgrid-sync-inner' + (props.isSticky ? ' fc-sticky' : '') }, props.navLinkAttrs), innerContent)); }));
	    };
	    return TimelineHeaderThInner;
	}(common.BaseComponent));
	function renderInnerContent(props) {
	    return props.text;
	}
	function refineHookProps(input) {
	    return {
	        level: input.level,
	        date: input.dateEnv.toDate(input.dateMarker),
	        view: input.viewApi,
	        text: input.text,
	    };
	}
	
	var TimelineHeaderTh = /** @class */ (function (_super) {
	    tslib.__extends(TimelineHeaderTh, _super);
	    function TimelineHeaderTh() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.refineHookProps = common.memoizeObjArg(refineHookProps);
	        _this.normalizeClassNames = common.buildClassNameNormalizer();
	        _this.buildCellNavLinkAttrs = common.memoize(buildCellNavLinkAttrs);
	        return _this;
	    }
	    TimelineHeaderTh.prototype.render = function () {
	        var _this = this;
	        var _a = this, props = _a.props, context = _a.context;
	        var dateEnv = context.dateEnv, options = context.options;
	        var cell = props.cell, dateProfile = props.dateProfile, tDateProfile = props.tDateProfile;
	        // the cell.rowUnit is f'd
	        // giving 'month' for a 3-day view
	        // workaround: to infer day, do NOT time
	        var dateMeta = common.getDateMeta(cell.date, props.todayRange, props.nowDate, dateProfile);
	        var classNames = ['fc-timeline-slot', 'fc-timeline-slot-label'].concat(cell.rowUnit === 'time' // TODO: so slot classnames for week/month/bigger. see note above about rowUnit
	            ? common.getSlotClassNames(dateMeta, context.theme)
	            : common.getDayClassNames(dateMeta, context.theme));
	        if (cell.isWeekStart) {
	            classNames.push('fc-timeline-slot-em');
	        }
	        var hookProps = this.refineHookProps({
	            level: props.rowLevel,
	            dateMarker: cell.date,
	            text: cell.text,
	            dateEnv: context.dateEnv,
	            viewApi: context.viewApi,
	        });
	        var customClassNames = this.normalizeClassNames(options.slotLabelClassNames, hookProps);
	        return (common.createElement(common.MountHook, { hookProps: hookProps, didMount: options.slotLabelDidMount, willUnmount: options.slotLabelWillUnmount }, function (rootElRef) { return (common.createElement("th", { ref: rootElRef, className: classNames.concat(customClassNames).join(' '), "data-date": dateEnv.formatIso(cell.date, { omitTime: !tDateProfile.isTimeScale, omitTimeZoneOffset: true }), colSpan: cell.colspan },
	            common.createElement("div", { className: "fc-timeline-slot-frame", style: { height: props.rowInnerHeight } },
	                common.createElement(TimelineHeaderThInner, { hookProps: hookProps, isSticky: props.isSticky, navLinkAttrs: _this.buildCellNavLinkAttrs(context, cell.date, cell.rowUnit) })))); }));
	    };
	    return TimelineHeaderTh;
	}(common.BaseComponent));
	function buildCellNavLinkAttrs(context, cellDate, rowUnit) {
	    return (rowUnit && rowUnit !== 'time')
	        ? common.buildNavLinkAttrs(context, cellDate, rowUnit)
	        : {};
	}
	
	var TimelineHeaderRows = /** @class */ (function (_super) {
	    tslib.__extends(TimelineHeaderRows, _super);
	    function TimelineHeaderRows() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TimelineHeaderRows.prototype.render = function () {
	        var _a = this.props, dateProfile = _a.dateProfile, tDateProfile = _a.tDateProfile, rowInnerHeights = _a.rowInnerHeights, todayRange = _a.todayRange, nowDate = _a.nowDate;
	        var cellRows = tDateProfile.cellRows;
	        return (common.createElement(common.Fragment, null, cellRows.map(function (rowCells, rowLevel) {
	            var isLast = rowLevel === cellRows.length - 1;
	            var isChrono = tDateProfile.isTimeScale && isLast; // the final row, with times?
	            var classNames = [
	                'fc-timeline-header-row',
	                isChrono ? 'fc-timeline-header-row-chrono' : '',
	            ];
	            return ( // eslint-disable-next-line react/no-array-index-key
	            common.createElement("tr", { key: rowLevel, className: classNames.join(' ') }, rowCells.map(function (cell) { return (common.createElement(TimelineHeaderTh, { key: cell.date.toISOString(), cell: cell, rowLevel: rowLevel, dateProfile: dateProfile, tDateProfile: tDateProfile, todayRange: todayRange, nowDate: nowDate, rowInnerHeight: rowInnerHeights && rowInnerHeights[rowLevel], isSticky: !isLast })); })));
	        })));
	    };
	    return TimelineHeaderRows;
	}(common.BaseComponent));
	
	var TimelineCoords = /** @class */ (function () {
	    function TimelineCoords(slatRootEl, // okay to expose?
	    slatEls, dateProfile, tDateProfile, dateEnv, isRtl) {
	        this.slatRootEl = slatRootEl;
	        this.dateProfile = dateProfile;
	        this.tDateProfile = tDateProfile;
	        this.dateEnv = dateEnv;
	        this.isRtl = isRtl;
	        this.outerCoordCache = new common.PositionCache(slatRootEl, slatEls, true, // isHorizontal
	        false);
	        // for the inner divs within the slats
	        // used for event rendering and scrollTime, to disregard slat border
	        this.innerCoordCache = new common.PositionCache(slatRootEl, common.findDirectChildren(slatEls, 'div'), true, // isHorizontal
	        false);
	    }
	    TimelineCoords.prototype.isDateInRange = function (date) {
	        return common.rangeContainsMarker(this.dateProfile.currentRange, date);
	    };
	    // results range from negative width of area to 0
	    TimelineCoords.prototype.dateToCoord = function (date) {
	        var tDateProfile = this.tDateProfile;
	        var snapCoverage = this.computeDateSnapCoverage(date);
	        var slotCoverage = snapCoverage / tDateProfile.snapsPerSlot;
	        var slotIndex = Math.floor(slotCoverage);
	        slotIndex = Math.min(slotIndex, tDateProfile.slotCnt - 1);
	        var partial = slotCoverage - slotIndex;
	        var _a = this, innerCoordCache = _a.innerCoordCache, outerCoordCache = _a.outerCoordCache;
	        if (this.isRtl) {
	            return outerCoordCache.originClientRect.width - (outerCoordCache.rights[slotIndex] -
	                (innerCoordCache.getWidth(slotIndex) * partial));
	        }
	        return (outerCoordCache.lefts[slotIndex] +
	            (innerCoordCache.getWidth(slotIndex) * partial));
	    };
	    TimelineCoords.prototype.rangeToCoords = function (range) {
	        return {
	            start: this.dateToCoord(range.start),
	            end: this.dateToCoord(range.end),
	        };
	    };
	    TimelineCoords.prototype.durationToCoord = function (duration) {
	        var _a = this, dateProfile = _a.dateProfile, tDateProfile = _a.tDateProfile, dateEnv = _a.dateEnv, isRtl = _a.isRtl;
	        var coord = 0;
	        if (dateProfile) {
	            var date = dateEnv.add(dateProfile.activeRange.start, duration);
	            if (!tDateProfile.isTimeScale) {
	                date = common.startOfDay(date);
	            }
	            coord = this.dateToCoord(date);
	            // hack to overcome the left borders of non-first slat
	            if (!isRtl && coord) {
	                coord += 1;
	            }
	        }
	        return coord;
	    };
	    TimelineCoords.prototype.coordFromLeft = function (coord) {
	        if (this.isRtl) {
	            return this.outerCoordCache.originClientRect.width - coord;
	        }
	        return coord;
	    };
	    // returned value is between 0 and the number of snaps
	    TimelineCoords.prototype.computeDateSnapCoverage = function (date) {
	        return computeDateSnapCoverage(date, this.tDateProfile, this.dateEnv);
	    };
	    return TimelineCoords;
	}());
	// returned value is between 0 and the number of snaps
	function computeDateSnapCoverage(date, tDateProfile, dateEnv) {
	    var snapDiff = dateEnv.countDurationsBetween(tDateProfile.normalizedRange.start, date, tDateProfile.snapDuration);
	    if (snapDiff < 0) {
	        return 0;
	    }
	    if (snapDiff >= tDateProfile.snapDiffToIndex.length) {
	        return tDateProfile.snapCnt;
	    }
	    var snapDiffInt = Math.floor(snapDiff);
	    var snapCoverage = tDateProfile.snapDiffToIndex[snapDiffInt];
	    if (common.isInt(snapCoverage)) { // not an in-between value
	        snapCoverage += snapDiff - snapDiffInt; // add the remainder
	    }
	    else {
	        // a fractional value, meaning the date is not visible
	        // always round up in this case. works for start AND end dates in a range.
	        snapCoverage = Math.ceil(snapCoverage);
	    }
	    return snapCoverage;
	}
	function coordToCss(hcoord, isRtl) {
	    if (hcoord === null) {
	        return { left: '', right: '' };
	    }
	    if (isRtl) {
	        return { right: hcoord, left: '' };
	    }
	    return { left: hcoord, right: '' };
	}
	function coordsToCss(hcoords, isRtl) {
	    if (!hcoords) {
	        return { left: '', right: '' };
	    }
	    if (isRtl) {
	        return { right: hcoords.start, left: -hcoords.end };
	    }
	    return { left: hcoords.start, right: -hcoords.end };
	}
	
	var TimelineHeader = /** @class */ (function (_super) {
	    tslib.__extends(TimelineHeader, _super);
	    function TimelineHeader() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.rootElRef = common.createRef();
	        return _this;
	    }
	    TimelineHeader.prototype.render = function () {
	        var _this = this;
	        var _a = this, props = _a.props, context = _a.context;
	        // TODO: very repetitive
	        // TODO: make part of tDateProfile?
	        var timerUnit = common.greatestDurationDenominator(props.tDateProfile.slotDuration).unit;
	        // WORKAROUND: make ignore slatCoords when out of sync with dateProfile
	        var slatCoords = props.slatCoords && props.slatCoords.dateProfile === props.dateProfile ? props.slatCoords : null;
	        return (common.createElement(common.NowTimer, { unit: timerUnit }, function (nowDate, todayRange) { return (common.createElement("div", { className: "fc-timeline-header", ref: _this.rootElRef },
	            common.createElement("table", { "aria-hidden": true, className: "fc-scrollgrid-sync-table", style: { minWidth: props.tableMinWidth, width: props.clientWidth } },
	                props.tableColGroupNode,
	                common.createElement("tbody", null,
	                    common.createElement(TimelineHeaderRows, { dateProfile: props.dateProfile, tDateProfile: props.tDateProfile, nowDate: nowDate, todayRange: todayRange, rowInnerHeights: props.rowInnerHeights }))),
	            context.options.nowIndicator && (
	            // need to have a container regardless of whether the current view has a visible now indicator
	            // because apparently removal of the element resets the scroll for some reasons (issue #5351).
	            // this issue doesn't happen for the timeline body however (
	            common.createElement("div", { className: "fc-timeline-now-indicator-container" }, (slatCoords && slatCoords.isDateInRange(nowDate)) && (common.createElement(common.NowIndicatorRoot, { isAxis: true, date: nowDate }, function (rootElRef, classNames, innerElRef, innerContent) { return (common.createElement("div", { ref: rootElRef, className: ['fc-timeline-now-indicator-arrow'].concat(classNames).join(' '), style: coordToCss(slatCoords.dateToCoord(nowDate), context.isRtl) }, innerContent)); })))))); }));
	    };
	    TimelineHeader.prototype.componentDidMount = function () {
	        this.updateSize();
	    };
	    TimelineHeader.prototype.componentDidUpdate = function () {
	        this.updateSize();
	    };
	    TimelineHeader.prototype.updateSize = function () {
	        if (this.props.onMaxCushionWidth) {
	            this.props.onMaxCushionWidth(this.computeMaxCushionWidth());
	        }
	    };
	    TimelineHeader.prototype.computeMaxCushionWidth = function () {
	        return Math.max.apply(Math, common.findElements(this.rootElRef.current, '.fc-timeline-header-row:last-child .fc-timeline-slot-cushion').map(function (el) { return el.getBoundingClientRect().width; }));
	    };
	    return TimelineHeader;
	}(common.BaseComponent));
	
	var TimelineSlatCell = /** @class */ (function (_super) {
	    tslib.__extends(TimelineSlatCell, _super);
	    function TimelineSlatCell() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TimelineSlatCell.prototype.render = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        var dateEnv = context.dateEnv, options = context.options, theme = context.theme;
	        var date = props.date, tDateProfile = props.tDateProfile, isEm = props.isEm;
	        var dateMeta = common.getDateMeta(props.date, props.todayRange, props.nowDate, props.dateProfile);
	        var classNames = ['fc-timeline-slot', 'fc-timeline-slot-lane'];
	        var dataAttrs = { 'data-date': dateEnv.formatIso(date, { omitTimeZoneOffset: true, omitTime: !tDateProfile.isTimeScale }) };
	        var hookProps = tslib.__assign(tslib.__assign({ date: dateEnv.toDate(props.date) }, dateMeta), { view: context.viewApi });
	        if (isEm) {
	            classNames.push('fc-timeline-slot-em');
	        }
	        if (tDateProfile.isTimeScale) {
	            classNames.push(common.isInt(dateEnv.countDurationsBetween(tDateProfile.normalizedRange.start, props.date, tDateProfile.labelInterval)) ?
	                'fc-timeline-slot-major' :
	                'fc-timeline-slot-minor');
	        }
	        classNames.push.apply(classNames, (props.isDay
	            ? common.getDayClassNames(dateMeta, theme)
	            : common.getSlotClassNames(dateMeta, theme)));
	        return (common.createElement(common.RenderHook, { hookProps: hookProps, classNames: options.slotLaneClassNames, content: options.slotLaneContent, didMount: options.slotLaneDidMount, willUnmount: options.slotLaneWillUnmount, elRef: props.elRef }, function (rootElRef, customClassNames, innerElRef, innerContent) { return (common.createElement("td", tslib.__assign({ ref: rootElRef, className: classNames.concat(customClassNames).join(' ') }, dataAttrs),
	            common.createElement("div", { ref: innerElRef }, innerContent))); }));
	    };
	    return TimelineSlatCell;
	}(common.BaseComponent));
	
	var TimelineSlatsBody = /** @class */ (function (_super) {
	    tslib.__extends(TimelineSlatsBody, _super);
	    function TimelineSlatsBody() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TimelineSlatsBody.prototype.render = function () {
	        var props = this.props;
	        var tDateProfile = props.tDateProfile, cellElRefs = props.cellElRefs;
	        var slotDates = tDateProfile.slotDates, isWeekStarts = tDateProfile.isWeekStarts;
	        var isDay = !tDateProfile.isTimeScale && !tDateProfile.largeUnit;
	        return (common.createElement("tbody", null,
	            common.createElement("tr", null, slotDates.map(function (slotDate, i) {
	                var key = slotDate.toISOString();
	                return (common.createElement(TimelineSlatCell, { key: key, elRef: cellElRefs.createRef(key), date: slotDate, dateProfile: props.dateProfile, tDateProfile: tDateProfile, nowDate: props.nowDate, todayRange: props.todayRange, isEm: isWeekStarts[i], isDay: isDay }));
	            }))));
	    };
	    return TimelineSlatsBody;
	}(common.BaseComponent));
	
	var TimelineSlats = /** @class */ (function (_super) {
	    tslib.__extends(TimelineSlats, _super);
	    function TimelineSlats() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.rootElRef = common.createRef();
	        _this.cellElRefs = new common.RefMap();
	        _this.handleScrollRequest = function (request) {
	            var onScrollLeftRequest = _this.props.onScrollLeftRequest;
	            var coords = _this.coords;
	            if (onScrollLeftRequest && coords) {
	                if (request.time) {
	                    var scrollLeft = coords.coordFromLeft(coords.durationToCoord(request.time));
	                    onScrollLeftRequest(scrollLeft);
	                }
	                return true;
	            }
	            return null; // best?
	        };
	        return _this;
	    }
	    TimelineSlats.prototype.render = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        return (common.createElement("div", { className: "fc-timeline-slots", ref: this.rootElRef },
	            common.createElement("table", { "aria-hidden": true, className: context.theme.getClass('table'), style: {
	                    minWidth: props.tableMinWidth,
	                    width: props.clientWidth,
	                } },
	                props.tableColGroupNode,
	                common.createElement(TimelineSlatsBody, { cellElRefs: this.cellElRefs, dateProfile: props.dateProfile, tDateProfile: props.tDateProfile, nowDate: props.nowDate, todayRange: props.todayRange }))));
	    };
	    TimelineSlats.prototype.componentDidMount = function () {
	        this.updateSizing();
	        this.scrollResponder = this.context.createScrollResponder(this.handleScrollRequest);
	    };
	    TimelineSlats.prototype.componentDidUpdate = function (prevProps) {
	        this.updateSizing();
	        this.scrollResponder.update(prevProps.dateProfile !== this.props.dateProfile);
	    };
	    TimelineSlats.prototype.componentWillUnmount = function () {
	        this.scrollResponder.detach();
	        if (this.props.onCoords) {
	            this.props.onCoords(null);
	        }
	    };
	    TimelineSlats.prototype.updateSizing = function () {
	        var _a = this, props = _a.props, context = _a.context;
	        if (props.clientWidth !== null && // is sizing stable?
	            this.scrollResponder
	        // ^it's possible to have clientWidth immediately after mount (when returning from print view), but w/o scrollResponder
	        ) {
	            var rootEl = this.rootElRef.current;
	            if (rootEl.offsetWidth) { // not hidden by css
	                this.coords = new TimelineCoords(this.rootElRef.current, collectCellEls(this.cellElRefs.currentMap, props.tDateProfile.slotDates), props.dateProfile, props.tDateProfile, context.dateEnv, context.isRtl);
	                if (props.onCoords) {
	                    props.onCoords(this.coords);
	                }
	                this.scrollResponder.update(false); // TODO: wouldn't have to do this if coords were in state
	            }
	        }
	    };
	    TimelineSlats.prototype.positionToHit = function (leftPosition) {
	        var outerCoordCache = this.coords.outerCoordCache;
	        var _a = this.context, dateEnv = _a.dateEnv, isRtl = _a.isRtl;
	        var tDateProfile = this.props.tDateProfile;
	        var slatIndex = outerCoordCache.leftToIndex(leftPosition);
	        if (slatIndex != null) {
	            // somewhat similar to what TimeGrid does. consolidate?
	            var slatWidth = outerCoordCache.getWidth(slatIndex);
	            var partial = isRtl ?
	                (outerCoordCache.rights[slatIndex] - leftPosition) / slatWidth :
	                (leftPosition - outerCoordCache.lefts[slatIndex]) / slatWidth;
	            var localSnapIndex = Math.floor(partial * tDateProfile.snapsPerSlot);
	            var start = dateEnv.add(tDateProfile.slotDates[slatIndex], common.multiplyDuration(tDateProfile.snapDuration, localSnapIndex));
	            var end = dateEnv.add(start, tDateProfile.snapDuration);
	            return {
	                dateSpan: {
	                    range: { start: start, end: end },
	                    allDay: !this.props.tDateProfile.isTimeScale,
	                },
	                dayEl: this.cellElRefs.currentMap[slatIndex],
	                left: outerCoordCache.lefts[slatIndex],
	                right: outerCoordCache.rights[slatIndex],
	            };
	        }
	        return null;
	    };
	    return TimelineSlats;
	}(common.BaseComponent));
	function collectCellEls(elMap, slotDates) {
	    return slotDates.map(function (slotDate) {
	        var key = slotDate.toISOString();
	        return elMap[key];
	    });
	}
	
	function computeSegHCoords(segs, minWidth, timelineCoords) {
	    var hcoords = [];
	    if (timelineCoords) {
	        for (var _i = 0, segs_1 = segs; _i < segs_1.length; _i++) {
	            var seg = segs_1[_i];
	            var res = timelineCoords.rangeToCoords(seg);
	            var start = Math.round(res.start); // for barely-overlapping collisions
	            var end = Math.round(res.end); //
	            if (end - start < minWidth) {
	                end = start + minWidth;
	            }
	            hcoords.push({ start: start, end: end });
	        }
	    }
	    return hcoords;
	}
	function computeFgSegPlacements(segs, segHCoords, // might not have for every seg
	eventInstanceHeights, // might not have for every seg
	moreLinkHeights, // might not have for every more-link
	strictOrder, maxStackCnt) {
	    var segInputs = [];
	    var crudePlacements = []; // when we don't know dims
	    for (var i = 0; i < segs.length; i += 1) {
	        var seg = segs[i];
	        var instanceId = seg.eventRange.instance.instanceId;
	        var height = eventInstanceHeights[instanceId];
	        var hcoords = segHCoords[i];
	        if (height && hcoords) {
	            segInputs.push({
	                index: i,
	                span: hcoords,
	                thickness: height,
	            });
	        }
	        else {
	            crudePlacements.push({
	                seg: seg,
	                hcoords: hcoords,
	                top: null,
	            });
	        }
	    }
	    var hierarchy = new common.SegHierarchy();
	    if (strictOrder != null) {
	        hierarchy.strictOrder = strictOrder;
	    }
	    if (maxStackCnt != null) {
	        hierarchy.maxStackCnt = maxStackCnt;
	    }
	    var hiddenEntries = hierarchy.addSegs(segInputs);
	    var hiddenPlacements = hiddenEntries.map(function (entry) { return ({
	        seg: segs[entry.index],
	        hcoords: entry.span,
	        top: null,
	    }); });
	    var hiddenGroups = common.groupIntersectingEntries(hiddenEntries);
	    var moreLinkInputs = [];
	    var moreLinkCrudePlacements = [];
	    var extractSeg = function (entry) { return segs[entry.index]; };
	    for (var i = 0; i < hiddenGroups.length; i += 1) {
	        var hiddenGroup = hiddenGroups[i];
	        var sortedSegs = hiddenGroup.entries.map(extractSeg);
	        var height = moreLinkHeights[common.buildIsoString(common.computeEarliestSegStart(sortedSegs))]; // not optimal :(
	        if (height != null) {
	            // NOTE: the hiddenGroup's spanStart/spanEnd are already computed by rangeToCoords. computed during input.
	            moreLinkInputs.push({
	                index: segs.length + i,
	                thickness: height,
	                span: hiddenGroup.span,
	            });
	        }
	        else {
	            moreLinkCrudePlacements.push({
	                seg: sortedSegs,
	                hcoords: hiddenGroup.span,
	                top: null,
	            });
	        }
	    }
	    // add more-links into the hierarchy, but don't limit
	    hierarchy.maxStackCnt = -1;
	    hierarchy.addSegs(moreLinkInputs);
	    var visibleRects = hierarchy.toRects();
	    var visiblePlacements = [];
	    var maxHeight = 0;
	    for (var _i = 0, visibleRects_1 = visibleRects; _i < visibleRects_1.length; _i++) {
	        var rect = visibleRects_1[_i];
	        var segIndex = rect.index;
	        visiblePlacements.push({
	            seg: segIndex < segs.length
	                ? segs[segIndex] // a real seg
	                : hiddenGroups[segIndex - segs.length].entries.map(extractSeg),
	            hcoords: rect.span,
	            top: rect.levelCoord,
	        });
	        maxHeight = Math.max(maxHeight, rect.levelCoord + rect.thickness);
	    }
	    return [
	        visiblePlacements.concat(crudePlacements, hiddenPlacements, moreLinkCrudePlacements),
	        maxHeight,
	    ];
	}
	
	var TimelineLaneBg = /** @class */ (function (_super) {
	    tslib.__extends(TimelineLaneBg, _super);
	    function TimelineLaneBg() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TimelineLaneBg.prototype.render = function () {
	        var props = this.props;
	        var highlightSeg = [].concat(props.eventResizeSegs, props.dateSelectionSegs);
	        return props.timelineCoords && (common.createElement("div", { className: "fc-timeline-bg" },
	            this.renderSegs(props.businessHourSegs || [], props.timelineCoords, 'non-business'),
	            this.renderSegs(props.bgEventSegs || [], props.timelineCoords, 'bg-event'),
	            this.renderSegs(highlightSeg, props.timelineCoords, 'highlight')));
	    };
	    TimelineLaneBg.prototype.renderSegs = function (segs, timelineCoords, fillType) {
	        var _a = this.props, todayRange = _a.todayRange, nowDate = _a.nowDate;
	        var isRtl = this.context.isRtl;
	        var segHCoords = computeSegHCoords(segs, 0, timelineCoords);
	        var children = segs.map(function (seg, i) {
	            var hcoords = segHCoords[i];
	            var hStyle = coordsToCss(hcoords, isRtl);
	            return (common.createElement("div", { key: common.buildEventRangeKey(seg.eventRange), className: "fc-timeline-bg-harness", style: hStyle }, fillType === 'bg-event' ?
	                common.createElement(common.BgEvent, tslib.__assign({ seg: seg }, common.getSegMeta(seg, todayRange, nowDate))) :
	                common.renderFill(fillType)));
	        });
	        return common.createElement(common.Fragment, null, children);
	    };
	    return TimelineLaneBg;
	}(common.BaseComponent));
	
	var TimelineLaneSlicer = /** @class */ (function (_super) {
	    tslib.__extends(TimelineLaneSlicer, _super);
	    function TimelineLaneSlicer() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TimelineLaneSlicer.prototype.sliceRange = function (origRange, dateProfile, dateProfileGenerator, tDateProfile, dateEnv) {
	        var normalRange = normalizeRange(origRange, tDateProfile, dateEnv);
	        var segs = [];
	        // protect against when the span is entirely in an invalid date region
	        if (computeDateSnapCoverage(normalRange.start, tDateProfile, dateEnv)
	            < computeDateSnapCoverage(normalRange.end, tDateProfile, dateEnv)) {
	            // intersect the footprint's range with the grid's range
	            var slicedRange = common.intersectRanges(normalRange, tDateProfile.normalizedRange);
	            if (slicedRange) {
	                segs.push({
	                    start: slicedRange.start,
	                    end: slicedRange.end,
	                    isStart: slicedRange.start.valueOf() === normalRange.start.valueOf()
	                        && isValidDate(slicedRange.start, tDateProfile, dateProfile, dateProfileGenerator),
	                    isEnd: slicedRange.end.valueOf() === normalRange.end.valueOf()
	                        && isValidDate(common.addMs(slicedRange.end, -1), tDateProfile, dateProfile, dateProfileGenerator),
	                });
	            }
	        }
	        return segs;
	    };
	    return TimelineLaneSlicer;
	}(common.Slicer));
	
	var DEFAULT_TIME_FORMAT = common.createFormatter({
	    hour: 'numeric',
	    minute: '2-digit',
	    omitZeroMinute: true,
	    meridiem: 'narrow',
	});
	var TimelineEvent = /** @class */ (function (_super) {
	    tslib.__extends(TimelineEvent, _super);
	    function TimelineEvent() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TimelineEvent.prototype.render = function () {
	        var props = this.props;
	        return (common.createElement(common.StandardEvent, tslib.__assign({}, props, { extraClassNames: ['fc-timeline-event', 'fc-h-event'], defaultTimeFormat: DEFAULT_TIME_FORMAT, defaultDisplayEventTime: !props.isTimeScale })));
	    };
	    return TimelineEvent;
	}(common.BaseComponent));
	
	var TimelineLaneMoreLink = /** @class */ (function (_super) {
	    tslib.__extends(TimelineLaneMoreLink, _super);
	    function TimelineLaneMoreLink() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.rootElRef = common.createRef();
	        return _this;
	    }
	    TimelineLaneMoreLink.prototype.render = function () {
	        var _this = this;
	        var _a = this, props = _a.props, context = _a.context;
	        var hiddenSegs = props.hiddenSegs, elRef = props.elRef, placement = props.placement, resourceId = props.resourceId;
	        var top = placement.top, hcoords = placement.hcoords;
	        var isVisible = hcoords && top !== null;
	        var hStyle = coordsToCss(hcoords, context.isRtl);
	        var extraDateSpan = resourceId ? { resourceId: resourceId } : {};
	        return (common.createElement(common.MoreLinkRoot, { allDayDate: null, moreCnt: hiddenSegs.length, allSegs: hiddenSegs, hiddenSegs: hiddenSegs, alignmentElRef: this.rootElRef, dateProfile: props.dateProfile, todayRange: props.todayRange, extraDateSpan: extraDateSpan, popoverContent: function () { return (common.createElement(common.Fragment, null, hiddenSegs.map(function (seg) {
	                var instanceId = seg.eventRange.instance.instanceId;
	                return (common.createElement("div", { key: instanceId, style: { visibility: props.isForcedInvisible[instanceId] ? 'hidden' : '' } },
	                    common.createElement(TimelineEvent, tslib.__assign({ isTimeScale: props.isTimeScale, seg: seg, isDragging: false, isResizing: false, isDateSelecting: false, isSelected: instanceId === props.eventSelection }, common.getSegMeta(seg, props.todayRange, props.nowDate)))));
	            }))); } }, function (rootElRef, classNames, innerElRef, innerContent, handleClick, title, isExpanded, popoverId) { return (common.createElement("a", { ref: function (el) {
	                common.setRef(rootElRef, el); // for MoreLinkRoot
	                common.setRef(elRef, el); // for props props
	                common.setRef(_this.rootElRef, el); // for this component
	            }, className: ['fc-timeline-more-link'].concat(classNames).join(' '), style: tslib.__assign({ visibility: isVisible ? '' : 'hidden', top: top || 0 }, hStyle), onClick: handleClick, title: title, "aria-expanded": isExpanded, "aria-controls": popoverId },
	            common.createElement("div", { ref: innerElRef, className: "fc-timeline-more-link-inner fc-sticky" }, innerContent))); }));
	    };
	    return TimelineLaneMoreLink;
	}(common.BaseComponent));
	
	var TimelineLane = /** @class */ (function (_super) {
	    tslib.__extends(TimelineLane, _super);
	    function TimelineLane() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.slicer = new TimelineLaneSlicer();
	        _this.sortEventSegs = common.memoize(common.sortEventSegs);
	        _this.harnessElRefs = new common.RefMap();
	        _this.moreElRefs = new common.RefMap();
	        _this.innerElRef = common.createRef();
	        // TODO: memoize event positioning
	        _this.state = {
	            eventInstanceHeights: {},
	            moreLinkHeights: {},
	        };
	        return _this;
	    }
	    TimelineLane.prototype.render = function () {
	        var _a = this, props = _a.props, state = _a.state, context = _a.context;
	        var options = context.options;
	        var dateProfile = props.dateProfile, tDateProfile = props.tDateProfile;
	        var slicedProps = this.slicer.sliceProps(props, dateProfile, tDateProfile.isTimeScale ? null : props.nextDayThreshold, context, // wish we didn't have to pass in the rest of the args...
	        dateProfile, context.dateProfileGenerator, tDateProfile, context.dateEnv);
	        var mirrorSegs = (slicedProps.eventDrag ? slicedProps.eventDrag.segs : null) ||
	            (slicedProps.eventResize ? slicedProps.eventResize.segs : null) ||
	            [];
	        var fgSegs = this.sortEventSegs(slicedProps.fgEventSegs, options.eventOrder);
	        var fgSegHCoords = computeSegHCoords(fgSegs, options.eventMinWidth, props.timelineCoords);
	        var _b = computeFgSegPlacements(fgSegs, fgSegHCoords, state.eventInstanceHeights, state.moreLinkHeights, options.eventOrderStrict, options.eventMaxStack), fgPlacements = _b[0], fgHeight = _b[1];
	        var isForcedInvisible = // TODO: more convenient
	         (slicedProps.eventDrag ? slicedProps.eventDrag.affectedInstances : null) ||
	            (slicedProps.eventResize ? slicedProps.eventResize.affectedInstances : null) ||
	            {};
	        return (common.createElement(common.Fragment, null,
	            common.createElement(TimelineLaneBg, { businessHourSegs: slicedProps.businessHourSegs, bgEventSegs: slicedProps.bgEventSegs, timelineCoords: props.timelineCoords, eventResizeSegs: slicedProps.eventResize ? slicedProps.eventResize.segs : [] /* bad new empty array? */, dateSelectionSegs: slicedProps.dateSelectionSegs, nowDate: props.nowDate, todayRange: props.todayRange }),
	            common.createElement("div", { className: "fc-timeline-events fc-scrollgrid-sync-inner", ref: this.innerElRef, style: { height: fgHeight } },
	                this.renderFgSegs(fgPlacements, isForcedInvisible, false, false, false),
	                this.renderFgSegs(buildMirrorPlacements(mirrorSegs, props.timelineCoords, fgPlacements), {}, Boolean(slicedProps.eventDrag), Boolean(slicedProps.eventResize), false))));
	    };
	    TimelineLane.prototype.componentDidMount = function () {
	        this.updateSize();
	    };
	    TimelineLane.prototype.componentDidUpdate = function (prevProps, prevState) {
	        if (prevProps.eventStore !== this.props.eventStore || // external thing changed?
	            prevProps.timelineCoords !== this.props.timelineCoords || // external thing changed?
	            prevState.moreLinkHeights !== this.state.moreLinkHeights // HACK. see addStateEquality
	        ) {
	            this.updateSize();
	        }
	    };
	    TimelineLane.prototype.updateSize = function () {
	        var props = this.props;
	        var timelineCoords = props.timelineCoords;
	        var innerEl = this.innerElRef.current;
	        if (props.onHeightChange) {
	            props.onHeightChange(innerEl, false);
	        }
	        if (timelineCoords) {
	            this.setState({
	                eventInstanceHeights: common.mapHash(this.harnessElRefs.currentMap, function (harnessEl) { return (Math.round(harnessEl.getBoundingClientRect().height)); }),
	                moreLinkHeights: common.mapHash(this.moreElRefs.currentMap, function (moreEl) { return (Math.round(moreEl.getBoundingClientRect().height)); }),
	            }, function () {
	                if (props.onHeightChange) {
	                    props.onHeightChange(innerEl, true);
	                }
	            });
	        }
	        // hack
	        if (props.syncParentMinHeight) {
	            innerEl.parentElement.style.minHeight = innerEl.style.height;
	        }
	    };
	    TimelineLane.prototype.renderFgSegs = function (segPlacements, isForcedInvisible, isDragging, isResizing, isDateSelecting) {
	        var _a = this, harnessElRefs = _a.harnessElRefs, moreElRefs = _a.moreElRefs, props = _a.props, context = _a.context;
	        var isMirror = isDragging || isResizing || isDateSelecting;
	        return (common.createElement(common.Fragment, null, segPlacements.map(function (segPlacement) {
	            var seg = segPlacement.seg, hcoords = segPlacement.hcoords, top = segPlacement.top;
	            if (Array.isArray(seg)) { // a more-link
	                var isoStr = common.buildIsoString(common.computeEarliestSegStart(seg));
	                return (common.createElement(TimelineLaneMoreLink, { key: 'm:' + isoStr /* "m" for "more" */, elRef: moreElRefs.createRef(isoStr), hiddenSegs: seg, placement: segPlacement, dateProfile: props.dateProfile, nowDate: props.nowDate, todayRange: props.todayRange, isTimeScale: props.tDateProfile.isTimeScale, eventSelection: props.eventSelection, resourceId: props.resourceId, isForcedInvisible: isForcedInvisible }));
	            }
	            var instanceId = seg.eventRange.instance.instanceId;
	            var isVisible = isMirror || Boolean(!isForcedInvisible[instanceId] && hcoords && top !== null);
	            var hStyle = coordsToCss(hcoords, context.isRtl);
	            return (common.createElement("div", { key: 'e:' + instanceId /* "e" for "event" */, ref: isMirror ? null : harnessElRefs.createRef(instanceId), className: "fc-timeline-event-harness", style: tslib.__assign({ visibility: isVisible ? '' : 'hidden', top: top || 0 }, hStyle) },
	                common.createElement(TimelineEvent, tslib.__assign({ isTimeScale: props.tDateProfile.isTimeScale, seg: seg, isDragging: isDragging, isResizing: isResizing, isDateSelecting: isDateSelecting, isSelected: instanceId === props.eventSelection /* TODO: bad for mirror? */ }, common.getSegMeta(seg, props.todayRange, props.nowDate)))));
	        })));
	    };
	    return TimelineLane;
	}(common.BaseComponent));
	TimelineLane.addStateEquality({
	    eventInstanceHeights: common.isPropsEqual,
	    moreLinkHeights: common.isPropsEqual,
	});
	function buildMirrorPlacements(mirrorSegs, timelineCoords, fgPlacements) {
	    if (!mirrorSegs.length || !timelineCoords) {
	        return [];
	    }
	    var topsByInstanceId = buildAbsoluteTopHash(fgPlacements); // TODO: cache this at first render?
	    return mirrorSegs.map(function (seg) { return ({
	        seg: seg,
	        hcoords: timelineCoords.rangeToCoords(seg),
	        top: topsByInstanceId[seg.eventRange.instance.instanceId],
	    }); });
	}
	function buildAbsoluteTopHash(placements) {
	    var topsByInstanceId = {};
	    for (var _i = 0, placements_1 = placements; _i < placements_1.length; _i++) {
	        var placement = placements_1[_i];
	        var seg = placement.seg;
	        if (!Array.isArray(seg)) { // doesn't represent a more-link
	            topsByInstanceId[seg.eventRange.instance.instanceId] = placement.top;
	        }
	    }
	    return topsByInstanceId;
	}
	
	var TimelineGrid = /** @class */ (function (_super) {
	    tslib.__extends(TimelineGrid, _super);
	    function TimelineGrid() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.slatsRef = common.createRef();
	        _this.state = {
	            coords: null,
	        };
	        _this.handeEl = function (el) {
	            if (el) {
	                _this.context.registerInteractiveComponent(_this, { el: el });
	            }
	            else {
	                _this.context.unregisterInteractiveComponent(_this);
	            }
	        };
	        _this.handleCoords = function (coords) {
	            _this.setState({ coords: coords });
	            if (_this.props.onSlatCoords) {
	                _this.props.onSlatCoords(coords);
	            }
	        };
	        return _this;
	    }
	    TimelineGrid.prototype.render = function () {
	        var _this = this;
	        var _a = this, props = _a.props, state = _a.state, context = _a.context;
	        var options = context.options;
	        var dateProfile = props.dateProfile, tDateProfile = props.tDateProfile;
	        var timerUnit = common.greatestDurationDenominator(tDateProfile.slotDuration).unit;
	        return (common.createElement("div", { className: "fc-timeline-body", ref: this.handeEl, style: {
	                minWidth: props.tableMinWidth,
	                height: props.clientHeight,
	                width: props.clientWidth,
	            } },
	            common.createElement(common.NowTimer, { unit: timerUnit }, function (nowDate, todayRange) { return (common.createElement(common.Fragment, null,
	                common.createElement(TimelineSlats, { ref: _this.slatsRef, dateProfile: dateProfile, tDateProfile: tDateProfile, nowDate: nowDate, todayRange: todayRange, clientWidth: props.clientWidth, tableColGroupNode: props.tableColGroupNode, tableMinWidth: props.tableMinWidth, onCoords: _this.handleCoords, onScrollLeftRequest: props.onScrollLeftRequest }),
	                common.createElement(TimelineLane, { dateProfile: dateProfile, tDateProfile: props.tDateProfile, nowDate: nowDate, todayRange: todayRange, nextDayThreshold: options.nextDayThreshold, businessHours: props.businessHours, eventStore: props.eventStore, eventUiBases: props.eventUiBases, dateSelection: props.dateSelection, eventSelection: props.eventSelection, eventDrag: props.eventDrag, eventResize: props.eventResize, timelineCoords: state.coords, syncParentMinHeight: true }),
	                (options.nowIndicator && state.coords && state.coords.isDateInRange(nowDate)) && (common.createElement("div", { className: "fc-timeline-now-indicator-container" },
	                    common.createElement(common.NowIndicatorRoot, { isAxis: false, date: nowDate }, function (rootElRef, classNames, innerElRef, innerContent) { return (common.createElement("div", { ref: rootElRef, className: ['fc-timeline-now-indicator-line'].concat(classNames).join(' '), style: coordToCss(state.coords.dateToCoord(nowDate), context.isRtl) }, innerContent)); }))))); })));
	    };
	    // Hit System
	    // ------------------------------------------------------------------------------------------
	    TimelineGrid.prototype.queryHit = function (positionLeft, positionTop, elWidth, elHeight) {
	        var slats = this.slatsRef.current;
	        var slatHit = slats.positionToHit(positionLeft);
	        if (slatHit) {
	            return {
	                dateProfile: this.props.dateProfile,
	                dateSpan: slatHit.dateSpan,
	                rect: {
	                    left: slatHit.left,
	                    right: slatHit.right,
	                    top: 0,
	                    bottom: elHeight,
	                },
	                dayEl: slatHit.dayEl,
	                layer: 0,
	            };
	        }
	        return null;
	    };
	    return TimelineGrid;
	}(common.DateComponent));
	
	var TimelineView = /** @class */ (function (_super) {
	    tslib.__extends(TimelineView, _super);
	    function TimelineView() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.buildTimelineDateProfile = common.memoize(buildTimelineDateProfile);
	        _this.scrollGridRef = common.createRef();
	        _this.state = {
	            slatCoords: null,
	            slotCushionMaxWidth: null,
	        };
	        _this.handleSlatCoords = function (slatCoords) {
	            _this.setState({ slatCoords: slatCoords });
	        };
	        _this.handleScrollLeftRequest = function (scrollLeft) {
	            var scrollGrid = _this.scrollGridRef.current;
	            scrollGrid.forceScrollLeft(0, scrollLeft);
	        };
	        _this.handleMaxCushionWidth = function (slotCushionMaxWidth) {
	            _this.setState({
	                slotCushionMaxWidth: Math.ceil(slotCushionMaxWidth), // for less rerendering TODO: DRY
	            });
	        };
	        return _this;
	    }
	    TimelineView.prototype.render = function () {
	        var _this = this;
	        var _a = this, props = _a.props, state = _a.state, context = _a.context;
	        var options = context.options;
	        var stickyHeaderDates = !props.forPrint && common.getStickyHeaderDates(options);
	        var stickyFooterScrollbar = !props.forPrint && common.getStickyFooterScrollbar(options);
	        var tDateProfile = this.buildTimelineDateProfile(props.dateProfile, context.dateEnv, options, context.dateProfileGenerator);
	        var extraClassNames = [
	            'fc-timeline',
	            options.eventOverlap === false ? 'fc-timeline-overlap-disabled' : '',
	        ];
	        var slotMinWidth = options.slotMinWidth;
	        var slatCols = buildSlatCols(tDateProfile, slotMinWidth || this.computeFallbackSlotMinWidth(tDateProfile));
	        var sections = [
	            {
	                type: 'header',
	                key: 'header',
	                isSticky: stickyHeaderDates,
	                chunks: [{
	                        key: 'timeline',
	                        content: function (contentArg) { return (common.createElement(TimelineHeader, { dateProfile: props.dateProfile, clientWidth: contentArg.clientWidth, clientHeight: contentArg.clientHeight, tableMinWidth: contentArg.tableMinWidth, tableColGroupNode: contentArg.tableColGroupNode, tDateProfile: tDateProfile, slatCoords: state.slatCoords, onMaxCushionWidth: slotMinWidth ? null : _this.handleMaxCushionWidth })); },
	                    }],
	            },
	            {
	                type: 'body',
	                key: 'body',
	                liquid: true,
	                chunks: [{
	                        key: 'timeline',
	                        content: function (contentArg) { return (common.createElement(TimelineGrid, tslib.__assign({}, props, { clientWidth: contentArg.clientWidth, clientHeight: contentArg.clientHeight, tableMinWidth: contentArg.tableMinWidth, tableColGroupNode: contentArg.tableColGroupNode, tDateProfile: tDateProfile, onSlatCoords: _this.handleSlatCoords, onScrollLeftRequest: _this.handleScrollLeftRequest }))); },
	                    }],
	            },
	        ];
	        if (stickyFooterScrollbar) {
	            sections.push({
	                type: 'footer',
	                key: 'footer',
	                isSticky: true,
	                chunks: [{
	                        key: 'timeline',
	                        content: common.renderScrollShim,
	                    }],
	            });
	        }
	        return (common.createElement(common.ViewRoot, { viewSpec: context.viewSpec }, function (rootElRef, classNames) { return (common.createElement("div", { ref: rootElRef, className: extraClassNames.concat(classNames).join(' ') },
	            common.createElement(scrollgrid.ScrollGrid, { ref: _this.scrollGridRef, liquid: !props.isHeightAuto && !props.forPrint, collapsibleWidth: false, colGroups: [
	                    { cols: slatCols },
	                ], sections: sections }))); }));
	    };
	    TimelineView.prototype.computeFallbackSlotMinWidth = function (tDateProfile) {
	        return Math.max(30, ((this.state.slotCushionMaxWidth || 0) / tDateProfile.slotsPerLabel));
	    };
	    return TimelineView;
	}(common.DateComponent));
	function buildSlatCols(tDateProfile, slotMinWidth) {
	    return [{
	            span: tDateProfile.slotCnt,
	            minWidth: slotMinWidth || 1, // needs to be a non-zero number to trigger horizontal scrollbars!??????
	        }];
	}
	
	var main = common.createPlugin({
	    deps: [
	        premiumCommonPlugin__default['default'],
	    ],
	    initialView: 'timelineDay',
	    views: {
	        timeline: {
	            component: TimelineView,
	            usesMinMaxTime: true,
	            eventResizableFromStart: true, // how is this consumed for TimelineView tho?
	        },
	        timelineDay: {
	            type: 'timeline',
	            duration: { days: 1 },
	        },
	        timelineWeek: {
	            type: 'timeline',
	            duration: { weeks: 1 },
	        },
	        timelineMonth: {
	            type: 'timeline',
	            duration: { months: 1 },
	        },
	        timelineYear: {
	            type: 'timeline',
	            duration: { years: 1 },
	        },
	    },
	});
	
	exports.TimelineCoords = TimelineCoords;
	exports.TimelineHeader = TimelineHeader;
	exports.TimelineHeaderRows = TimelineHeaderRows;
	exports.TimelineLane = TimelineLane;
	exports.TimelineLaneBg = TimelineLaneBg;
	exports.TimelineLaneSlicer = TimelineLaneSlicer;
	exports.TimelineSlats = TimelineSlats;
	exports.TimelineView = TimelineView;
	exports.buildSlatCols = buildSlatCols;
	exports.buildTimelineDateProfile = buildTimelineDateProfile;
	exports.coordToCss = coordToCss;
	exports.coordsToCss = coordsToCss;
	exports.default = main;


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(1044);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(543);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(541);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _usePrevious = _interopRequireDefault(__webpack_require__(61));
	var _getScrollbarWidth = _interopRequireDefault(__webpack_require__(47));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var CLASS_NAME = 'InovuaReactDataGrid__row';
	var SCROLLBAR_WIDTH = (0, _getScrollbarWidth.default)();
	var RTL_OFFSET = SCROLLBAR_WIDTH || 17;
	var ActiveRowIndicator = function ActiveRowIndicator(props) {
	  var _style;
	  var _useState = (0, _react.useState)(''),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    offset = _useState2[0],
	    setOffset = _useState2[1];
	  var _useState3 = (0, _react.useState)(0),
	    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
	    _scrollLeft = _useState4[0],
	    setScrollLeft = _useState4[1];
	  var activeIndex = props.activeIndex,
	    rtl = props.rtl,
	    rtlOffset = props.rtlOffset,
	    activeRowIndicatorClassName = props.activeRowIndicatorClassName;
	  var oldActiveIndex = (0, _usePrevious.default)(activeIndex, -1);
	  var _ref = props.activeRowRef.current || {},
	    _ref$instance = _ref.instance,
	    row = _ref$instance === void 0 ? {} : _ref$instance;
	  var hasBorderBottom = row.hasBorderBottom,
	    hasBorderTop = row.hasBorderTop;
	  var rowProps = row.props || {};
	  var groupColumn = rowProps.groupColumn,
	    data = rowProps.data,
	    depth = rowProps.depth,
	    groupNestingSize = rowProps.groupNestingSize;
	  var deps = [activeIndex, rtlOffset, oldActiveIndex, props.dataSourceCount, props.computedExpandedRows, props.computedExpandedNodes, props.computedRowHeights, row];
	  var updateLayout = function updateLayout(config) {
	    var node = (props.activeRowRef.current || {
	      node: null
	    }).node;
	    var instance = (props.activeRowRef.current || {
	      instance: null
	    }).instance;
	    if (!node || !node.parentNode || props.dataSourceCount < activeIndex) {
	      return setOffset('');
	    }
	    if (instance && instance.props.rowIndex !== props.activeIndex && props.activeIndex >= 0) {
	      requestAnimationFrame(function () {
	        return updateLayout({
	          raf: false
	        });
	      });
	      return;
	    }
	    var doSetOffset = function doSetOffset(left, top) {
	      top = Number.parseFloat(top) || 0;
	      setOffset("translate3d(".concat(left || 0, "px, ").concat(top, "px, 0px)"));
	    };
	    if (config && config.raf === false) {
	      doSetOffset(rtl ? -RTL_OFFSET : 0, node.style.top);
	    } else {
	      requestAnimationFrame(function () {
	        if (node && node.parentNode) {
	          doSetOffset(rtl ? -RTL_OFFSET : 0, node.style.top);
	        }
	      });
	    }
	  };
	  (0, _react.useLayoutEffect)(updateLayout, deps);
	  (0, _react.useEffect)(function () {
	    if (props.handle) {
	      props.handle({
	        setScrollLeft: setScrollLeft
	      });
	    }
	    return function () {
	      if (props.handle) {
	        props.handle(null);
	      }
	    };
	  }, [props.handle]);
	  var groupDepth = groupColumn ? 0 : data && data.__group ? data.depth - 1 : data && data.__summary ? rowProps.summaryProps.depth : depth || 0;
	  var scrollbarOffset = props.rtl ? RTL_OFFSET : 0;
	  var left = (groupNestingSize || 0) * groupDepth;
	  var style = (_style = {}, (0, _defineProperty2.default)(_style, rtl ? 'right' : 'left', left - scrollbarOffset), (0, _defineProperty2.default)(_style, "width", props.width - left), _style);
	  var transform;
	  if (!offset) {
	    style.opacity = 0;
	  } else {
	    style.willChange = 'transform';
	    transform = offset;
	    style.height = props.activeRowHeight;
	  }
	  if (transform) {
	    style.transform = transform;
	  }
	  var innerClassName = (0, _join.default)("".concat(CLASS_NAME, "-active-borders-inner"), activeRowIndicatorClassName ? activeRowIndicatorClassName : '');
	  return _react.default.createElement("div", {
	    key: "active-row-borders",
	    className: (0, _join.default)("".concat(CLASS_NAME, "-active-borders"), offset != '' ? "".concat(CLASS_NAME, "-active-borders--active") : '', hasBorderTop && "".concat(CLASS_NAME, "-active-borders--has-border-top"), hasBorderBottom && "".concat(CLASS_NAME, "-active-borders--has-border-bottom")),
	    style: style
	  }, _react.default.createElement("div", {
	    className: innerClassName
	  }));
	};
	var _default = ActiveRowIndicator;
	exports.default = _default;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _join = _interopRequireDefault(__webpack_require__(31));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var _default = function _default(_ref) {
	  var handle = _ref.handle;
	  var _useState = (0, _react.useState)(false),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    active = _useState2[0],
	    setActive = _useState2[1];
	  var _useState3 = (0, _react.useState)('inherit'),
	    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
	    cursor = _useState4[0],
	    setCursor = _useState4[1];
	  (0, _react.useEffect)(function () {
	    handle({
	      setActive: setActive,
	      setCursor: setCursor
	    });
	  }, []);
	  return _react.default.createElement("div", {
	    style: {
	      opacity: active ? 1 : 0,
	      cursor: active ? cursor || 'inherit' : 'inherit'
	    },
	    className: (0, _join.default)("InovuaReactDataGrid__cover", active && "InovuaReactDataGrid__cover--active")
	  });
	};
	exports.default = _default;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _TextInput = _interopRequireDefault(__webpack_require__(256));
	var _autoBind = _interopRequireDefault(__webpack_require__(52));
	var _reactCleanProps = _interopRequireDefault(__webpack_require__(49));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var InovuaTextEditor = function (_React$Component) {
	  (0, _inherits2.default)(InovuaTextEditor, _React$Component);
	  var _super = _createSuper(InovuaTextEditor);
	  function InovuaTextEditor(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaTextEditor);
	    _this = _super.call(this, props);
	    (0, _autoBind.default)((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaTextEditor, [{
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var value = props.value;
	      var domProps = (0, _reactCleanProps.default)(props, InovuaTextEditor.propTypes);
	      var className = 'InovuaReactDataGrid__cell__editor InovuaReactDataGrid__cell__editor--text ' + (domProps.className || '');
	      return _react.default.createElement(_TextInput.default, _objectSpread(_objectSpread({
	        autoFocus: props.autoFocus,
	        value: value,
	        theme: props.theme,
	        onChange: this.onChange,
	        onBlur: this.onBlur,
	        onKeyDown: this.onKeyDown,
	        enableClearButton: true
	      }, domProps), {}, {
	        className: className
	      }));
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(value, e) {
	      var onChange = this.props.onChange;
	      if (onChange) {
	        onChange(value, e);
	      }
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur(e) {
	      if (this.props.onComplete) {
	        this.props.onComplete(e);
	      }
	    }
	  }, {
	    key: "onKeyDown",
	    value: function onKeyDown(e) {
	      if (e.key === 'Enter') {
	        if (this.props.onComplete) {
	          this.props.onEnterNavigation(true, e.shiftKey ? -1 : 1, e);
	        }
	      }
	      if (e.key === 'Escape') {
	        if (this.props.onCancel) {
	          this.props.onCancel(e);
	        }
	      }
	      if (e.key == 'Tab') {
	        e.preventDefault();
	        this.props.onTabNavigation(true, e.shiftKey ? -1 : 1, e);
	      }
	    }
	  }]);
	  return InovuaTextEditor;
	}(_react.default.Component);
	InovuaTextEditor.propTypes = {
	  onCancel: _propTypes.default.func,
	  onChange: _propTypes.default.func,
	  onComplete: _propTypes.default.func,
	  onKeyDown: _propTypes.default.func,
	  onTabNavigation: _propTypes.default.func,
	  gotoNext: _propTypes.default.func,
	  gotoPrev: _propTypes.default.func,
	  value: _propTypes.default.any,
	  cell: _propTypes.default.any,
	  cellProps: _propTypes.default.any,
	  nativeScroll: _propTypes.default.any,
	  editorProps: _propTypes.default.any,
	  onEnterNavigation: _propTypes.default.func
	};
	var _default = InovuaTextEditor;
	exports.default = _default;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _StringFilter = _interopRequireDefault(__webpack_require__(576));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var filterWrapperClassName = 'InovuaReactDataGrid__column-header__filter-wrapper';
	var GenericFilter = function (_React$Component) {
	  (0, _inherits2.default)(GenericFilter, _React$Component);
	  var _super = _createSuper(GenericFilter);
	  function GenericFilter(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, GenericFilter);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSettingsClickListener", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "settings", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refSettings", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "specificFilter", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "unsubscribeColumnFilterVisibility", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setupEventListener", function () {
	      _this.unsubscribeColumnFilterVisibility = _this.props.props.notifyColumnFilterVisibleStateChange.onCalled(function (visible) {
	        if (!visible && _this.state.open) {
	          _this.close(_this.settings);
	        }
	      });
	      _this.refSettings = function (s) {
	        if (s) {
	          if (!_this.onSettingsClickListener) {
	            _this.onSettingsClickListener = s.addEventListener('mousedown', _this.onSettingsClick);
	          }
	        } else {
	          if (_this.settings && _this.onSettingsClickListener) {
	            _this.settings.removeEventListener(_this.onSettingsClickListener);
	          }
	        }
	        _this.settings = s;
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSettingsClick", function (e) {
	      if (!_this.state.open) {
	        _this.onMenuOpen(e);
	      } else {
	        _this.onMenuClose(e);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFocus", function () {
	      _this.setState({
	        focused: true
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBlur", function () {
	      _this.setState({
	        focused: false
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMenuOpen", function (e) {
	      e.preventDefault();
	      _this.props.cellInstance.showFilterContextMenu(_this.settings);
	      _this.setState({
	        focused: true,
	        open: true
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMenuClose", function (e) {
	      e.preventDefault();
	      _this.close();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onKeyDown", function (event) {
	      if (event.key === 'Enter') {
	        _this.onMenuOpen(event);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "close", function (settings) {
	      _this.setState({
	        focused: false,
	        open: false
	      }, function () {
	        _this.props.cellInstance.hideFilterContextMenu(settings);
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setValue", function (value) {
	      if (_this.specificFilter.setValue) {
	        _this.specificFilter.setValue(value);
	      }
	    });
	    _this.onSettingsClick = _this.onSettingsClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onSettingsClickListener = null;
	    _this.ref = function (specificFilter) {
	      var inputRef = props.inputRef || props.props.filterEditorProps && props.props.filterEditorProps.inputRef;
	      if (inputRef) {
	        if (typeof inputRef === 'function') {
	          inputRef(specificFilter);
	        } else {
	          inputRef.current = specificFilter;
	        }
	      }
	      _this.specificFilter = specificFilter;
	    };
	    _this.state = {
	      focused: false,
	      open: false
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(GenericFilter, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.cellInstance) {
	        this.props.cellInstance.filter = this;
	      }
	      this.setupEventListener();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.props.cellInstance) {
	        this.props.cellInstance.filter = null;
	      }
	      if (this.settings && this.onSettingsClickListener) {
	        this.settings.removeEventListener(this.onSettingsClickListener);
	      }
	      this.onSettingsClickListener = null;
	      this.settings = null;
	      if (this.unsubscribeColumnFilterVisibility) {
	        this.unsubscribeColumnFilterVisibility();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	        props = _this$props.props,
	        cellInstance = _this$props.cellInstance;
	      var filterValue = props.computedFilterValue;
	      var active = filterValue ? filterValue.active !== false : false;
	      var filterType = filterValue ? filterValue.type || props.filterType || props.type : props.filterType || props.type || 'string';
	      if (filterValue && !filterValue.type) {
	        filterValue = _objectSpread(_objectSpread({}, filterValue), {}, {
	          type: filterType
	        });
	      }
	      var className = filterWrapperClassName;
	      if (filterValue) {
	        if (!active) {
	          className += " ".concat(className, "--disabled");
	        }
	      }
	      var settings;
	      var style = {
	        minHeight: props.filterRowHeight + 1
	      };
	      if (filterValue) {
	        var settingsIconClassName = 'InovuaReactDataGrid__column-header__filter-settings-icon';
	        var settingsIcon = props.filterEditorProps && props.filterEditorProps.renderSettings ? props.filterEditorProps.renderSettings({
	          className: settingsIconClassName,
	          filterValue: filterValue
	        }) : _react.default.createElement("svg", {
	          tabIndex: 0,
	          className: settingsIconClassName,
	          width: "14",
	          height: "14",
	          viewBox: "0 0 14 14"
	        }, _react.default.createElement("path", {
	          fillRule: "evenodd",
	          d: "M13.222 2H.778C.348 2 0 1.552 0 1s.348-1 .778-1h12.444c.43 0 .778.448.778 1s-.348 1-.778 1zM1.556 3.111l3.888 4.667v5.444c0 .43.349.778.778.778h1.556c.43 0 .778-.348.778-.778V7.778l3.888-4.667H1.556z"
	        }));
	        settings = _react.default.createElement("div", {
	          className: "InovuaReactDataGrid__column-header__filter-settings",
	          ref: this.refSettings,
	          onKeyDown: this.onKeyDown,
	          onFocus: this.onFocus,
	          onBlur: this.onBlur
	        }, settingsIcon);
	      }
	      if (!filterValue) {
	        className += " ".concat(filterWrapperClassName, "--empty");
	        return _react.default.createElement("div", {
	          style: style,
	          className: className
	        });
	      }
	      var filterTypes = props.filterTypes;
	      var filterTypeDescription = filterTypes[filterType] || {
	        operators: []
	      };
	      var operator = filterTypeDescription.operators.filter(function (op) {
	        return op.name === filterValue.operator;
	      })[0];
	      var operatorDisabled = operator && operator.disableFilterEditor;
	      var filterProps = _objectSpread(_objectSpread({
	        i18n: props.i18n,
	        rtl: props.rtl,
	        nativeScroll: props.nativeScroll,
	        filterDelay: props.filterDelay !== undefined ? props.filterDelay : 250
	      }, props.filterEditorProps), {}, {
	        filterEditorProps: props.filterEditorProps,
	        ref: this.ref,
	        cellProps: props,
	        renderInPortal: props.renderInPortal,
	        cell: cellInstance,
	        filterValue: filterValue,
	        emptyValue: filterTypeDescription.emptyValue,
	        onChange: cellInstance.onFilterValueChange,
	        active: active,
	        disabled: !active || operatorDisabled,
	        filterType: filterType,
	        theme: props.theme,
	        render: function render(node) {
	          return _react.default.createElement("div", {
	            style: style,
	            className: className
	          }, node, props.enableColumnFilterContextMenu && settings);
	        }
	      });
	      var FilterEditor = props.filterEditor;
	      if (FilterEditor && typeof FilterEditor != 'string') {
	        return _react.default.createElement(FilterEditor, _objectSpread({}, filterProps));
	      }
	      if (props.renderFilterEditor) {
	        return props.renderFilterEditor(filterProps, props, cellInstance);
	      }
	      return _react.default.createElement(_StringFilter.default, _objectSpread({}, filterProps));
	    }
	  }]);
	  return GenericFilter;
	}(_react.default.Component);
	var _default = function _default(props, cellInstance) {
	  return _react.default.createElement(GenericFilter, {
	    key: "filter-".concat(cellInstance.getProps().id),
	    props: props,
	    rtl: props.rtl,
	    cellInstance: cellInstance
	  });
	};
	exports.default = _default;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var DEFAULT_STYLE = {
	  position: 'relative',
	  verticalAlign: 'middle',
	  cursor: 'pointer'
	};
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	var _default = function _default(_ref, cellProps) {
	  var render = _ref.render,
	    rtl = _ref.rtl,
	    collapsed = _ref.collapsed,
	    toggleGroup = _ref.toggleGroup,
	    style = _ref.style,
	    size = _ref.size,
	    renderGroupCollapseTool = _ref.renderGroupCollapseTool,
	    renderGroupExpandTool = _ref.renderGroupExpandTool;
	  size = size || 18;
	  style = style ? _objectSpread(_objectSpread({}, DEFAULT_STYLE), style) : DEFAULT_STYLE;
	  var domProps = {
	    onMouseDown: toggleGroup,
	    onClick: stopPropagation,
	    style: style
	  };
	  var result;
	  if (render) {
	    domProps.style = _objectSpread({}, domProps.style);
	    result = render(domProps, _objectSpread(_objectSpread({}, cellProps), {}, {
	      collapsed: collapsed,
	      toggleGroup: toggleGroup,
	      size: size
	    }));
	    if (result != undefined) {
	      return result;
	    }
	  }
	  var renderCollapseTool = function renderCollapseTool() {
	    var result;
	    if (renderGroupCollapseTool) {
	      result = renderGroupCollapseTool({
	        domProps: domProps,
	        size: size,
	        rtl: rtl
	      });
	    }
	    if (result === undefined) {
	      result = _react.default.createElement("svg", _objectSpread(_objectSpread({}, domProps), {}, {
	        height: size,
	        viewBox: "0 0 24 24",
	        width: size
	      }), rtl ? _react.default.createElement("path", {
	        d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
	      }) : _react.default.createElement("path", {
	        d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
	      }));
	    }
	    return result;
	  };
	  var renderExpandTool = function renderExpandTool() {
	    var result;
	    if (renderGroupExpandTool) {
	      result = renderGroupExpandTool({
	        domProps: domProps,
	        size: size,
	        rtl: rtl
	      });
	    }
	    if (result === undefined) {
	      result = _react.default.createElement("svg", _objectSpread(_objectSpread({}, domProps), {}, {
	        height: size,
	        viewBox: "0 0 24 24",
	        width: size
	      }), _react.default.createElement("path", {
	        d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
	      }));
	    }
	    return result;
	  };
	  if (collapsed) {
	    return renderCollapseTool();
	  }
	  return renderExpandTool();
	};
	exports.default = _default;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _renderFilter = _interopRequireDefault(__webpack_require__(547));
	var _ColumnResizer = _interopRequireDefault(__webpack_require__(209));
	var _renderMenuTool = _interopRequireDefault(__webpack_require__(550));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var RESIZE_WRAPPER_CLASS_NAME = 'InovuaReactDataGrid__column-header__resize-wrapper';
	var HEADER_CONTENT_CLASS_NAME = 'InovuaReactDataGrid__column-header__content';
	var EMPTY_OBJECT = {};
	var renderContent = function renderContent(props) {
	  if (!props) {
	    return;
	  }
	  if (props.renderColumnReorderProxy) {
	    return props.renderColumnReorderProxy(props);
	  }
	  return props.children;
	};
	var renderHeader = function renderHeader(props, domProps, cellInstance) {
	  var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : EMPTY_OBJECT;
	  var dragging = props.dragging !== undefined ? props.dragging : state.dragging;
	  var last = props.last || props.computedVisibleIndex == props.computedVisibleCount - 1;
	  var depth = props.depth,
	    showBorderRight = props.showBorderRight,
	    showBorderLeft = props.showBorderLeft,
	    computedLocked = props.computedLocked,
	    firstInSection = props.firstInSection,
	    lastInSection = props.lastInSection,
	    group = props.group,
	    rtl = props.rtl,
	    virtualizeColumns = props.virtualizeColumns,
	    headerProps = props.headerProps;
	  var style = headerProps && headerProps.headerCellStyle ? headerProps.headerCellStyle : null;
	  var content = _react.default.createElement("div", {
	    key: "content",
	    style: style,
	    className: "".concat(HEADER_CONTENT_CLASS_NAME, " ").concat(props.headerEllipsis !== false ? 'InovuaReactDataGrid__box--ellipsis' : ''),
	    children: renderContent(props)
	  });
	  var menuTool = (0, _renderMenuTool.default)(props, cellInstance);
	  var headerAlign = props.headerAlign != null ? props.headerAlign : props.textAlign;
	  content = [headerAlign == 'end' && menuTool, content, headerAlign != 'end' && menuTool];
	  if (props.computedResizable || props.computedFilterable) {
	    var innerStyle = Object.assign({}, domProps.style || EMPTY_OBJECT);
	    if (!dragging) {
	      delete innerStyle.width;
	      delete innerStyle.minWidth;
	    }
	    if (virtualizeColumns) {
	      delete innerStyle.position;
	    }
	    var resizeHandleStyle;
	    var right;
	    var resizerClassName;
	    if (props.computedResizable) {
	      right = props.computedVisibleIndex === props.computedVisibleCount - 1 && !showBorderRight || lastInSection ? 0 : -props.columnResizeHandleWidth / 2;
	      resizeHandleStyle = {
	        width: props.columnResizeHandleWidth,
	        zIndex: 10000 * (depth || 0)
	      };
	      if (lastInSection && computedLocked === 'start') {
	        right = -props.columnResizeHandleWidth + 1;
	      }
	      if (props.resizeProxyStyle) {
	        resizeHandleStyle = Object.assign({}, props.resizeProxyStyle, resizeHandleStyle);
	      }
	      if (dragging) {
	        delete innerStyle.top;
	        if (rtl) {
	          delete innerStyle.right;
	        } else {
	          delete innerStyle.left;
	        }
	      }
	      resizerClassName = 'InovuaReactDataGrid__column-resizer';
	      if (props.lastUnlocked && !props.last) {
	        resizerClassName += " ".concat(resizerClassName, "--last-unlocked");
	      }
	      resizerClassName += " InovuaReactDataGrid__column-resizer--direction-".concat(rtl ? 'rtl' : 'ltr');
	    }
	    if (innerStyle.transform) {
	      delete innerStyle.transform;
	    }
	    var theStyle = props.style;
	    var styleCloned = false;
	    if (computedLocked) {
	      theStyle = _objectSpread({}, theStyle);
	      styleCloned = true;
	    }
	    var resizeHandle;
	    if (!dragging && !computedLocked && virtualizeColumns) {
	      theStyle.left = props.computedOffset;
	      theStyle.position = 'absolute';
	    }
	    if (props.computedResizable) {
	      var _style;
	      resizeHandle = _react.default.createElement(_ColumnResizer.default, {
	        key: "columnResizer",
	        className: resizerClassName,
	        onMouseDown: props.onResizeMouseDown,
	        onTouchStart: props.onResizeTouchStart,
	        style: (_style = {
	          width: props.columnResizeHandleWidth
	        }, (0, _defineProperty2.default)(_style, props.rtl ? 'left' : 'right', right), (0, _defineProperty2.default)(_style, "zIndex", (depth || 0) * 10000 + (100 - props.computedVisibleIndex || 0)), (0, _defineProperty2.default)(_style, "height", props.headerHeight), _style),
	        resizeHandleStyle: resizeHandleStyle,
	        resizeHandleClassName: "InovuaReactDataGrid__column-resize-handle"
	      });
	    } else {
	      if (dragging && props.computedFilterable) {
	        if (!styleCloned) {
	          styleCloned = true;
	          theStyle = _objectSpread({}, theStyle);
	        }
	        if (rtl) {
	          theStyle.right = state.right || 0;
	        } else {
	          theStyle.left = state.left || 0;
	        }
	        theStyle.top = state.top || 0;
	      }
	    }
	    return _react.default.createElement("div", {
	      ref: domProps.ref,
	      style: theStyle,
	      onFocus: domProps.onFocus,
	      className: (0, _join.default)(RESIZE_WRAPPER_CLASS_NAME, dragging && "".concat(RESIZE_WRAPPER_CLASS_NAME, "--dragging"), group ? "".concat(RESIZE_WRAPPER_CLASS_NAME, "--has-group") : "".concat(RESIZE_WRAPPER_CLASS_NAME, "--has-no-group"), showBorderLeft && "".concat(RESIZE_WRAPPER_CLASS_NAME, "--show-border-").concat(rtl ? 'right' : 'left'), (showBorderRight || props.computedShowHeaderBorderRight && last && !firstInSection) && "".concat(RESIZE_WRAPPER_CLASS_NAME, "--show-border-").concat(rtl ? 'left' : 'right'), "".concat(RESIZE_WRAPPER_CLASS_NAME, "--direction-").concat(rtl ? 'rtl' : 'ltr'), computedLocked && "".concat(RESIZE_WRAPPER_CLASS_NAME, "--locked"), computedLocked && "".concat(RESIZE_WRAPPER_CLASS_NAME, "--locked-").concat(computedLocked), firstInSection && "".concat(RESIZE_WRAPPER_CLASS_NAME, "--first-in-section"), lastInSection && "".concat(RESIZE_WRAPPER_CLASS_NAME, "--last-in-section"), last && "".concat(RESIZE_WRAPPER_CLASS_NAME, "--last"), props.headerWrapperClassName)
	    }, _react.default.createElement("div", _objectSpread(_objectSpread({}, cleanup(domProps)), {}, {
	      style: innerStyle,
	      children: content
	    })), resizeHandle, props.computedFilterable && !dragging ? (0, _renderFilter.default)(props, cellInstance) : null);
	  }
	  var ref = domProps.ref;
	  return _react.default.createElement("div", _objectSpread(_objectSpread({}, cleanup(domProps)), {}, {
	    ref: ref,
	    id: null,
	    name: null,
	    title: null,
	    type: null,
	    value: null,
	    children: content
	  }));
	};
	var cleanup = function cleanup(domProps) {
	  delete domProps.ref;
	  delete domProps.id;
	  delete domProps.computedOffset;
	  delete domProps.name;
	  delete domProps.title;
	  delete domProps.type;
	  delete domProps.value;
	  delete domProps.onFocus;
	  return domProps;
	};
	var _default = renderHeader;
	exports.default = _default;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuTool = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _join = _interopRequireDefault(__webpack_require__(31));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var BASE_CLASS_NAME = 'InovuaReactDataGrid__column-header__menu-tool';
	var MenuTool = function MenuTool(props) {
	  var _useState = (0, _react.useState)(false),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    keepVisible = _useState2[0],
	    setKeepVisible = _useState2[1];
	  var domRef = (0, _react.useRef)();
	  var _unmounted = (0, _react.useRef)();
	  (0, _react.useEffect)(function () {
	    _unmounted.current = false;
	    return function () {
	      _unmounted.current = true;
	    };
	  }, []);
	  var onClick = function onClick(event) {
	    event.stopPropagation();
	  };
	  var onMouseDown = function onMouseDown(event) {
	    event.preventDefault();
	    props.showContextMenu && props.showContextMenu(domRef.current, props.showOnHover ? onHide : null);
	    if (_unmounted.current) {
	      return;
	    }
	    if (props.showOnHover && !keepVisible) {
	      setKeepVisible(true);
	    }
	  };
	  var onHide = function onHide() {
	    if (_unmounted.current) {
	      return;
	    }
	    setKeepVisible(false);
	  };
	  var renderMenuTool = function renderMenuTool() {
	    var domProps = {
	      className: (0, _join.default)('', 'InovuaReactDataGrid__sort-icon--desc'),
	      width: 14,
	      height: 12
	    };
	    if (props.renderMenuTool) {
	      return props.renderMenuTool(domProps);
	    }
	    return _react.default.createElement("svg", _objectSpread(_objectSpread({}, domProps), {}, {
	      viewBox: "0 0 14 12"
	    }), _react.default.createElement("g", {
	      fillRule: "evenodd"
	    }, _react.default.createElement("rect", {
	      width: "14",
	      height: "2",
	      rx: "1"
	    }), _react.default.createElement("rect", {
	      width: "14",
	      height: "2",
	      y: "5",
	      rx: "1"
	    }), _react.default.createElement("rect", {
	      width: "14",
	      height: "2",
	      y: "10",
	      rx: "1"
	    })));
	  };
	  var className = BASE_CLASS_NAME;
	  var showOnHover = props.showOnHover,
	    rtl = props.rtl;
	  if (showOnHover) {
	    className += " ".concat(BASE_CLASS_NAME, "--show-on-hover");
	  }
	  if (!showOnHover || keepVisible) {
	    className += " ".concat(BASE_CLASS_NAME, "--visible");
	  }
	  className += " ".concat(BASE_CLASS_NAME, "--direction-").concat(rtl ? 'rtl' : 'ltr');
	  return _react.default.createElement("div", {
	    className: className,
	    onMouseDown: onMouseDown,
	    onClick: onClick,
	    ref: domRef
	  }, renderMenuTool());
	};
	exports.MenuTool = MenuTool;
	var _default = function _default(props, cellInstance) {
	  if (props.groupSpacerColumn) {
	    return null;
	  }
	  if (!props.showColumnMenuTool) {
	    return null;
	  }
	  return _react.default.createElement(MenuTool, {
	    key: "menuTool",
	    name: props.name,
	    rtl: props.rtl,
	    showOnHover: props.showColumnMenuToolOnHover,
	    showContextMenu: cellInstance.showContextMenu,
	    renderMenuTool: props.renderMenuTool
	  });
	};
	exports.default = _default;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var DEFAULT_STYLE = {
	  position: 'relative',
	  verticalAlign: 'middle',
	  cursor: 'pointer'
	};
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	var _default = function _default(_ref, cellProps) {
	  var render = _ref.render,
	    nodeLoading = _ref.nodeLoading,
	    nodeCollapsed = _ref.nodeCollapsed,
	    leafNode = _ref.leafNode,
	    node = _ref.node,
	    nodeProps = _ref.nodeProps,
	    toggleNodeExpand = _ref.toggleNodeExpand,
	    style = _ref.style,
	    size = _ref.size,
	    renderTreeCollapseTool = _ref.renderTreeCollapseTool,
	    renderTreeExpandTool = _ref.renderTreeExpandTool,
	    renderTreeLoadingTool = _ref.renderTreeLoadingTool;
	  size = size || 18;
	  if (!leafNode) {
	    style = style ? _objectSpread(_objectSpread({}, DEFAULT_STYLE), style) : DEFAULT_STYLE;
	  }
	  var domProps = {
	    onMouseDown: leafNode ? null : toggleNodeExpand,
	    onClick: leafNode ? null : stopPropagation,
	    style: style
	  };
	  var result;
	  if (render) {
	    domProps.style = _objectSpread({}, domProps.style);
	    result = render(domProps, _objectSpread(_objectSpread({}, cellProps), {}, {
	      leafNode: leafNode,
	      nodeCollapsed: nodeCollapsed,
	      node: node,
	      nodeLoading: nodeLoading,
	      nodeProps: nodeProps,
	      toggleNodeExpand: toggleNodeExpand,
	      size: size
	    }));
	    if (result != undefined) {
	      return result;
	    }
	  }
	  if (leafNode) {
	    var tools = true;
	    if (renderTreeCollapseTool === null && renderTreeExpandTool === null) {
	      tools = false;
	    }
	    return _react.default.createElement("div", _objectSpread(_objectSpread({}, domProps), {}, {
	      style: _objectSpread(_objectSpread({}, domProps.style), {}, {
	        width: tools ? size : 0,
	        height: size
	      })
	    }));
	  }
	  var renderNodeLoading = function renderNodeLoading(_ref2) {
	    var domProps = _ref2.domProps,
	      size = _ref2.size;
	    var className = "".concat(domProps.className || '', " InovuaReactDataGrid__cell__node-tool--loading");
	    var loadingTool;
	    if (renderTreeLoadingTool === null) {
	      return _react.default.createElement("div", {
	        style: domProps.style
	      });
	    }
	    if (renderTreeLoadingTool) {
	      loadingTool = renderTreeLoadingTool({
	        domProps: domProps,
	        size: size,
	        className: className
	      });
	    }
	    if (loadingTool === undefined) {
	      loadingTool = _react.default.createElement("svg", _objectSpread(_objectSpread({}, domProps), {}, {
	        className: className,
	        height: size,
	        width: size,
	        viewBox: "0 0 24 24"
	      }), _react.default.createElement("path", {
	        d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
	      }));
	    }
	    return loadingTool;
	  };
	  if (nodeLoading) {
	    return renderNodeLoading({
	      domProps: domProps,
	      size: size
	    });
	  }
	  var renderCollapseToolHandle = function renderCollapseToolHandle() {
	    var result;
	    if (renderTreeCollapseTool === null) {
	      return _react.default.createElement("div", {
	        style: domProps.style
	      });
	    }
	    if (renderTreeCollapseTool) {
	      result = renderTreeCollapseTool({
	        domProps: domProps,
	        size: size
	      });
	    }
	    if (result === undefined) {
	      result = _react.default.createElement("svg", _objectSpread(_objectSpread({}, domProps), {}, {
	        height: size,
	        viewBox: "0 0 24 24",
	        width: size
	      }), _react.default.createElement("path", {
	        d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
	      }));
	    }
	    return result;
	  };
	  var renderExpandToolHandle = function renderExpandToolHandle() {
	    var result;
	    if (renderTreeExpandTool === null) {
	      return _react.default.createElement("div", {
	        style: domProps.style
	      });
	    }
	    if (renderTreeExpandTool) {
	      result = renderTreeExpandTool({
	        domProps: domProps,
	        size: size
	      });
	    }
	    if (result === undefined) {
	      result = _react.default.createElement("svg", _objectSpread(_objectSpread({}, domProps), {}, {
	        height: size,
	        viewBox: "0 0 24 24",
	        width: size
	      }), _react.default.createElement("path", {
	        d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
	      }));
	    }
	    return result;
	  };
	  if (nodeCollapsed) {
	    return renderCollapseToolHandle();
	  }
	  return renderExpandToolHandle();
	};
	exports.default = _default;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var DEFAULT_SIZE = 10;
	var _default = function _default(_ref, extraProps) {
	  var sortable = _ref.sortable,
	    size = _ref.size,
	    direction = _ref.direction,
	    renderSortTool = _ref.renderSortTool;
	  if (!sortable) {
	    return null;
	  }
	  size = size || DEFAULT_SIZE;
	  if (renderSortTool) {
	    return renderSortTool(direction, extraProps);
	  }
	  var visibilityClassName = 'InovuaReactDataGrid__sort-icon';
	  if (!direction) {
	    visibilityClassName += ' InovuaReactDataGrid__sort-icon--hidden';
	  }
	  return _react.default.createElement("div", {
	    className: "InovuaReactDataGrid__sort-icon-wrapper",
	    key: "iconWrapper"
	  }, _react.default.createElement("svg", {
	    key: "sortToolAsc",
	    className: (0, _join.default)(visibilityClassName, 'InovuaReactDataGrid__sort-icon--asc', direction === 1 && 'InovuaReactDataGrid__sort-icon--active'),
	    width: size,
	    height: size / 2,
	    viewBox: "0 0 10 5"
	  }, _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M4.767.276L8.395 4.04c.142.147.138.382-.01.524-.069.066-.16.104-.257.104H.872c-.205 0-.37-.166-.37-.37 0-.097.036-.189.103-.258L4.233.276c.142-.147.377-.151.524-.009l.01.01z"
	  })), _react.default.createElement("svg", {
	    key: "sortToolDesc",
	    className: (0, _join.default)(visibilityClassName, 'InovuaReactDataGrid__sort-icon--desc', direction === -1 && 'InovuaReactDataGrid__sort-icon--active'),
	    width: size,
	    height: size / 2,
	    viewBox: "0 0 10 5"
	  }, _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M4.233 4.724L.605.96C.463.814.467.579.615.437.684.371.775.333.872.333h7.256c.205 0 .37.166.37.37 0 .097-.036.189-.103.258L4.767 4.724c-.142.147-.377.151-.524.009l-.01-.01z"
	  })));
	};
	exports.default = _default;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _assignDefined = _interopRequireDefault(__webpack_require__(259));
	var _src = _interopRequireWildcard(__webpack_require__(760));
	var _shallowequal = _interopRequireDefault(__webpack_require__(73));
	var _renderRows = _interopRequireDefault(__webpack_require__(559));
	var _shouldComponentUpdate2 = _interopRequireDefault(__webpack_require__(56));
	var _searchClosestSmallerValue = _interopRequireDefault(__webpack_require__(802));
	var _renderEmptyContent = _interopRequireDefault(__webpack_require__(270));
	var _detectUa = __webpack_require__(104);
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var EMPTY_OBJECT = {};
	var returnTrue = function returnTrue() {
	  return true;
	};
	var CHUNKS_SIZE = 1;
	var raf = globalObject.requestAnimationFrame;
	var DEFAULT_SCROLL_POS = {
	  scrollLeft: 0,
	  scrollTop: 0
	};
	var initialSkip = 0;
	var timeout = false;
	var VirtualListClassName = 'InovuaReactDataGrid__virtual-list';
	var InovuaDataGridList = function (_Component) {
	  (0, _inherits2.default)(InovuaDataGridList, _Component);
	  var _super = _createSuper(InovuaDataGridList);
	  function InovuaDataGridList(_props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaDataGridList);
	    _this = _super.call(this, _props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollingDirection", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lastScrollTimestamp", 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollLeft", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "virtualListRef", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isRowFullyVisible", function (index) {
	      return _this.getVirtualList().isRowVisible(index);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setValue", function () {
	      var _this$props = _this.props,
	        hasValueSetter = _this$props.hasValueSetter,
	        data = _this$props.data,
	        columns = _this$props.columns,
	        idProperty = _this$props.idProperty,
	        setItemsAt = _this$props.setItemsAt;
	      if (!hasValueSetter) {
	        return;
	      }
	      var newDataMap = data.reduce(function (acc, current) {
	        var _iterator = _createForOfIteratorHelper(columns),
	          _step;
	        try {
	          for (_iterator.s(); !(_step = _iterator.n()).done;) {
	            var column = _step.value;
	            if (column.setValue) {
	              var columnName = column.name || column.id;
	              var value = current[columnName];
	              if (value) {
	                var result = column.setValue(_objectSpread({
	                  value: value,
	                  data: current
	                }, column));
	                if (value !== result) {
	                  var id = current[idProperty];
	                  acc[id] = _objectSpread(_objectSpread({}, acc[id]), {}, (0, _defineProperty2.default)({}, columnName, result));
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _iterator.e(err);
	        } finally {
	          _iterator.f();
	        }
	        return acc;
	      }, {});
	      var newData = Object.keys(newDataMap).map(function (key) {
	        var id = isNaN(Number(key)) ? key : Number(key);
	        return _objectSpread({
	          id: id
	        }, newDataMap[key]);
	      });
	      setItemsAt(newData, {
	        replace: false
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "computeRows", function (props) {
	      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT,
	        from = _ref.from,
	        to = _ref.to,
	        rowHeight = _ref.rowHeight,
	        renderIndex = _ref.renderIndex,
	        empty = _ref.empty,
	        setRowSpan = _ref.setRowSpan,
	        sticky = _ref.sticky;
	      var columnRenderCount = props.columnRenderCount;
	      return (0, _renderRows.default)({
	        empty: empty,
	        renderIndex: renderIndex,
	        setRowSpan: setRowSpan,
	        sticky: sticky,
	        from: from || _this.startIndex || 0,
	        to: to || _this.endIndex || CHUNKS_SIZE,
	        rowHeight: rowHeight,
	        columnRenderStartIndex: _this.columnRenderStartIndex,
	        columnRenderCount: columnRenderCount,
	        onEditStop: _this.onEditStop,
	        onEditStart: _this.onEditStart,
	        onEditValueChange: _this.onEditValueChange,
	        getScrollLeftMax: _this.props.getScrollLeftMax,
	        tryNextRowEdit: _this.tryRowEdit,
	        editValue: _this.editValue,
	        editRowIndex: _this.editRowIndex,
	        editColumnIndex: _this.editColumnIndex,
	        editColumnId: _this.editColumnId,
	        memorizedScrollLeft: _this.scrollLeft.current
	      }, props);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getVirtualList", function () {
	      var vl = _this.virtualListRef.current;
	      return vl;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "tryRowEdit", function (nextEditRowIndex, dir, columnIndex, isEnterNavigation) {
	      var columnEditIndex = columnIndex;
	      var row = _this.getRowAt(nextEditRowIndex);
	      if (!row) {
	        return;
	      }
	      var setActiveIndex = function setActiveIndex() {
	        return _this.props.setActiveIndex(nextEditRowIndex);
	      };
	      if (_this.props.livePagination) {
	        var skip = _this.props.computedSkip;
	        if (skip !== initialSkip) {
	          initialSkip = skip;
	          timeout = true;
	        }
	        timeout ? setTimeout(function () {
	          return setActiveIndex();
	        }, 50) : setActiveIndex();
	      } else {
	        setActiveIndex();
	      }
	      row.tryRowCellEdit(columnEditIndex, dir, isEnterNavigation);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isEditing", function () {
	      return !!_this.editColumnId;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onEditStop", function (args) {
	      if (_this.editColumnIndex !== args.columnIndex || _this.editRowIndex !== args.rowIndex) {
	        return;
	      }
	      if (_this.props.onEditStop) {
	        _this.props.onEditStop(args);
	      }
	      _this.updateEditing({
	        value: undefined,
	        rowIndex: undefined,
	        columnIndex: undefined
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onEditValueChange", function (args) {
	      if (_this.props.onEditValueChange) {
	        _this.props.onEditValueChange(args);
	      }
	      _this.updateEditing(args);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onEditStart", function (args) {
	      if (_this.props.onEditStart) {
	        _this.props.onEditStart(args);
	      }
	      _this.updateEditing(args);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateEditing", function (_ref2) {
	      var value = _ref2.value,
	        rowIndex = _ref2.rowIndex,
	        columnId = _ref2.columnId,
	        columnIndex = _ref2.columnIndex;
	      var oldEditRowIndex = _this.editRowIndex;
	      var oldEditValue = _this.editValue;
	      var oldEditColumnIndex = _this.editColumnIndex;
	      _this.editValue = value;
	      _this.editRowIndex = rowIndex;
	      _this.editColumnIndex = columnIndex;
	      _this.editColumnId = columnId;
	      if (_this.editTimeoutId) {
	        clearTimeout(_this.editTimeoutId);
	      }
	      _this.lazyEditColumnId = _this.editColumnId || _this.lazyEditColumnId;
	      _this.editTimeoutId = setTimeout(function () {
	        delete _this.editTimeoutId;
	        _this.lazyEditColumnId = _this.editColumnId;
	      }, 50);
	      if (oldEditRowIndex === rowIndex && oldEditColumnIndex === columnIndex && oldEditValue !== value) {
	        _this.getVirtualList().getRows().forEach(function (r) {
	          var row = r.getInstance();
	          if (row && row.props.rowIndex === rowIndex) {
	            r.update();
	          }
	        });
	        return;
	      }
	      _this.forceUpdate();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScrollHorizontal", function (scrollLeft, _, __, scrollLeftMax) {
	      _this.scrollLeft.current = scrollLeft;
	      _this.onContainerScrollHorizontal(scrollLeft, undefined, scrollLeftMax);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderRowContainer", function (props) {
	      return _react.default.createElement("div", _objectSpread({}, props), props.children, _this.props.renderActiveRowIndicator && _this.props.renderActiveRowIndicator(_this.setupActiveRowIndicatorHandle));
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setupActiveRowIndicatorHandle", function (activeRowHandle) {
	      _this.activeRowIndicatorHandle = activeRowHandle;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onStickyRowUpdate", function () {
	      _this.updateOnScrollLeft(undefined, true);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderEmptyContent", function () {
	      var SCROLLBAR_WIDTH = (0, _src.getScrollbarWidth)();
	      var _this$props2 = _this.props,
	        i18n = _this$props2.i18n,
	        data = _this$props2.data,
	        loading = _this$props2.computedLoading,
	        nativeScroll = _this$props2.nativeScroll;
	      var emptyText = _this.props.emptyText;
	      var length = data.length;
	      emptyText = i18n(emptyText, emptyText);
	      if (!length && !loading) {
	        return (0, _renderEmptyContent.default)(emptyText, 'empty', {
	          right: nativeScroll ? 0 : -SCROLLBAR_WIDTH,
	          bottom: nativeScroll ? 0 : -SCROLLBAR_WIDTH
	        });
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderView", function (viewProps) {
	      var _this$props3 = _this.props,
	        data = _this$props3.data,
	        loading = _this$props3.loading;
	      var scrollbarOffset = _this.getEmptyScrollOffset();
	      var length = data.length;
	      if (!length && !loading) {
	        viewProps.children = _react.default.Children.toArray(viewProps.children);
	        viewProps.children.push(_this.renderEmptyContent());
	        if (_detectUa.IS_EDGE) {
	          viewProps.style.minHeight = '99%';
	        }
	      }
	      var hasScrollbars = _this.scrollbars && _this.scrollbars.vertical && _this.scrollbars.horizontal;
	      if (!!_this.props.renderRowDetails || !!_this.props.renderDetailsGrid) {
	        if (_this.props.rtl && !(0, _src.getScrollbarWidth)() && !_this.props.nativeScroll) {
	          viewProps.style.transform = "translateX(".concat(-(hasScrollbars ? 2 : 1) * scrollbarOffset, "px)");
	        }
	      } else {
	        if (_this.props.rtl && !(0, _src.getScrollbarWidth)() && !_this.props.nativeScroll) {
	          viewProps.style.transform = "translateX(".concat(-scrollbarOffset, "px)");
	        }
	      }
	      var result;
	      if (_this.props.renderView) {
	        result = _this.props.renderView(viewProps);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("div", _objectSpread({}, viewProps));
	      }
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSizer", function (props, scrollHeight) {
	      if (!_this.props.nativeScroll) {
	        return;
	      }
	      if (!_this.props.virtualized) {
	        return null;
	      }
	      var minWidth = Math.max(_this.props.availableWidth || 0, _this.props.minRowWidth || 0) || 0;
	      var SCROLLBAR_WIDTH = (0, _src.getScrollbarWidth)();
	      var sizerStyle = _objectSpread(_objectSpread({}, props.style), {}, {
	        minWidth: minWidth,
	        minHeight: props.style ? (props.style.minHeight || 0) - (!SCROLLBAR_WIDTH ? _this.getEmptyScrollOffset() : 0) : 0
	      });
	      if (_this.props.naturalRowHeight) {
	        sizerStyle.height = scrollHeight;
	      }
	      return _react.default.createElement("div", _objectSpread(_objectSpread({
	        key: "grid-sizer",
	        "data-name": "sizer"
	      }, props), {}, {
	        style: sizerStyle
	      }));
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderScrollerSpacer", function (spacerProps) {
	      if (!_this.props.totalFlexColumnCount) {
	        spacerProps.style.width = _this.props.minRowWidth || 0;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderScroller", function (scrollerProps) {
	      var _style;
	      var _this$props4 = _this.props,
	        data = _this$props4.data,
	        loading = _this$props4.loading,
	        virtualized = _this$props4.virtualized,
	        maxVisibleRows = _this$props4.maxVisibleRows,
	        nativeScroll = _this$props4.nativeScroll,
	        availableWidth = _this$props4.availableWidth,
	        minRowWidth = _this$props4.minRowWidth;
	      var length = data.length;
	      scrollerProps.children.push(_react.default.createElement("div", {
	        key: "empty-spacer",
	        "data-name": "empty-spacer",
	        style: (_style = {
	          position: _detectUa.IS_IE && nativeScroll ? 'static' : 'absolute',
	          contain: 'strict'
	        }, (0, _defineProperty2.default)(_style, _this.props.rtl ? 'right' : 'left', 0), (0, _defineProperty2.default)(_style, "height", 1), (0, _defineProperty2.default)(_style, "top", 0), (0, _defineProperty2.default)(_style, "pointerEvents", 'none'), (0, _defineProperty2.default)(_style, "minWidth", Math.max(availableWidth, minRowWidth) || 0), _style)
	      }, _detectUa.IS_IE && nativeScroll ? _this.renderEmptyContent() : null));
	      if (!virtualized && length < maxVisibleRows) {
	        scrollerProps.style = scrollerProps.style || {};
	        scrollerProps.style.overflow = 'hidden';
	      }
	      var hasHorizontalScrollbar = _this.scrollbars && _this.scrollbars.horizontal;
	      if (!_this.props.renderRowDetails || !_this.props.renderDetailsGrid) {
	        if (!(0, _src.getScrollbarWidth)() && !nativeScroll && hasHorizontalScrollbar) {
	          scrollerProps.style.right = 0;
	        }
	      }
	      var result;
	      if (_this.props.renderScroller) {
	        result = _this.props.renderScroller(scrollerProps);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("div", _objectSpread({}, scrollerProps));
	      }
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRowAt", function (index) {
	      return _this.getRows().filter(function (r) {
	        var _r$props;
	        return (r === null || r === void 0 ? void 0 : (_r$props = r.props) === null || _r$props === void 0 ? void 0 : _r$props.rowIndex) === index;
	      })[0];
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "startEdit", function (_ref3) {
	      var rowIndex = _ref3.rowIndex,
	        columnIndex = _ref3.columnIndex,
	        value = _ref3.value;
	      var row = _this.getRowAt(rowIndex);
	      if (row) {
	        var cell = row.getCellAt(columnIndex);
	        if (cell) {
	          return cell.startEdit(value);
	        }
	      }
	      return Promise.reject(null);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "completeEdit", function (_ref4) {
	      var rowIndex = _ref4.rowIndex,
	        columnIndex = _ref4.columnIndex,
	        value = _ref4.value;
	      var row = _this.getRowAt(rowIndex);
	      if (row) {
	        var cell = row.getCellAt(columnIndex);
	        if (cell) {
	          cell.completeEdit(value);
	        }
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cancelEdit", function (_ref5) {
	      var rowIndex = _ref5.rowIndex,
	        columnIndex = _ref5.columnIndex;
	      var row = _this.getRowAt(rowIndex);
	      if (row) {
	        var cell = row.getCellAt(columnIndex);
	        if (cell) {
	          cell.cancelEdit();
	        }
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onContainerScroll", function (scrollPos) {
	      var prevScrollPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SCROLL_POS;
	      if (_this.props.onContainerScroll) {
	        _this.props.onContainerScroll(scrollPos, prevScrollPos);
	      }
	      var oldScrollingDirection = _this.scrollingDirection;
	      if (scrollPos.scrollTop === prevScrollPos.scrollTop && scrollPos.scrollLeft === prevScrollPos.scrollLeft) {
	        return;
	      }
	      _this.scrollingDirection = scrollPos.scrollLeft === prevScrollPos.scrollLeft ? 'vertical' : 'horizontal';
	      if (_this.scrollingDirection === oldScrollingDirection) {
	        return;
	      }
	      if (_this.props.virtualized) {
	        var _this$getDOMNode, _this$getDOMNode$clas;
	        (_this$getDOMNode = _this.getDOMNode()) === null || _this$getDOMNode === void 0 ? void 0 : (_this$getDOMNode$clas = _this$getDOMNode.classList) === null || _this$getDOMNode$clas === void 0 ? void 0 : _this$getDOMNode$clas.add("".concat(VirtualListClassName, "--scrolling"));
	        requestAnimationFrame(function () {
	          _this.getRows().forEach(function (r) {
	            return r ? r.setScrolling(_this.scrollingDirection) : null;
	          });
	        });
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScrollStop", function () {
	      _this.scrollingDirection = 'none';
	      if (_this.props.virtualized) {
	        var _this$getDOMNode2, _this$getDOMNode2$cla;
	        (_this$getDOMNode2 = _this.getDOMNode()) === null || _this$getDOMNode2 === void 0 ? void 0 : (_this$getDOMNode2$cla = _this$getDOMNode2.classList) === null || _this$getDOMNode2$cla === void 0 ? void 0 : _this$getDOMNode2$cla.remove("".concat(VirtualListClassName, "--scrolling"));
	        _this.getRows().forEach(function (r) {
	          if (!r) {
	            return;
	          }
	          r.setScrolling(false);
	        });
	      }
	      if (_this.props.onScrollStop) {
	        _this.props.onScrollStop();
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setColumnRenderStartIndex", function (columnRenderStartIndex, force) {
	      if (_this.__willUnmount) {
	        return;
	      }
	      if (_this.resizing && !force) {
	        return;
	      }
	      if (columnRenderStartIndex === _this.columnRenderStartIndex && !force) {
	        return;
	      }
	      if (!_this.getVirtualList()) {
	        return;
	      }
	      if (_this.props.onColumnRenderStartIndexChange) {
	        _this.props.onColumnRenderStartIndexChange(columnRenderStartIndex);
	      }
	      _this.columnRenderStartIndex = columnRenderStartIndex;
	      var rows = _this.getVirtualList().getRows();
	      rows.forEach(function (row) {
	        var rowInstance = row.getInstance();
	        if (rowInstance) {
	          requestAnimationFrame(function () {
	            rowInstance.setColumnRenderStartIndex(columnRenderStartIndex);
	          });
	        }
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRows", function () {
	      var virtualList = _this.getVirtualList();
	      if (!virtualList) {
	        return [];
	      }
	      return virtualList.getRows().map(function (row) {
	        return row.getInstance();
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScrollbarsChange", function (scrollbars) {
	      _this.scrollbars = scrollbars;
	      if (!scrollbars.horizontal) {
	        raf(function () {
	          _this.onContainerScrollHorizontal(0);
	        });
	      }
	      if (_this.props.onScrollbarsChange) {
	        raf(function () {
	          _this.props.onScrollbarsChange(scrollbars);
	        });
	      }
	      if (_this.props.scrollProps && _this.props.scrollProps.onScrollbarsChange) {
	        _this.props.scrollProps.onScrollbarsChange(scrollbars);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResize", function () {
	      if (_this.props.onResize) {
	        var _this$props5;
	        (_this$props5 = _this.props).onResize.apply(_this$props5, arguments);
	      }
	      _this.visibleCount = _this.getVisibleCount();
	      _this.resizing = true;
	      raf(function () {
	        _this.resizing = false;
	        var force;
	        _this.updateOnScrollLeft(undefined, force = true);
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onContainerScrollHorizontal", function (scrollLeft, force, scrollLeftMax) {
	      if (scrollLeft < 0) {
	        scrollLeft = 0;
	      }
	      scrollLeft = Math.round(scrollLeft);
	      _this._scrollLeft = scrollLeft;
	      if (_this.__willUnmount) {
	        return;
	      }
	      if (_this.props.onContainerScrollHorizontal) {
	        _this.props.onContainerScrollHorizontal(scrollLeft, scrollLeftMax);
	      }
	      if (_this.props.scrollProps && _this.props.scrollProps.onContainerScrollHorizontal) {
	        _this.props.scrollProps.onContainerScrollHorizontal(scrollLeft);
	      }
	      scrollLeft = _this._scrollLeft;
	      _this.updateOnScrollLeft(scrollLeft);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateOnScrollLeft", function () {
	      var scrollLeft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this._scrollLeft;
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.props;
	      if (_this.__willUnmount) {
	        return;
	      }
	      var columnRenderStartIndex;
	      if (props.virtualizeColumns) {
	        var lockedStartColumns = props.lockedStartColumns,
	          columnWidthPrefixSums = props.columnWidthPrefixSums;
	        if (!columnRenderStartIndex) {
	          var lockedOffset = lockedStartColumns.length && columnWidthPrefixSums[lockedStartColumns.length] ? columnWidthPrefixSums[lockedStartColumns.length] : 0;
	          columnRenderStartIndex = (0, _searchClosestSmallerValue.default)(props.columnWidthPrefixSums, scrollLeft + lockedOffset);
	        }
	        _this.setColumnRenderStartIndex(columnRenderStartIndex, force);
	      }
	      if (_this.activeRowIndicatorHandle) {
	        _this.activeRowIndicatorHandle.setScrollLeft(scrollLeft);
	      }
	      if (_this.props.updateLockedWrapperPositions) {
	        _this.props.updateLockedWrapperPositions.call((0, _assertThisInitialized2.default)(_this), _this.props, scrollLeft);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDOMNode", function () {
	      return _this.node || (_this.node = _this.getVirtualList().getDOMNode());
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderRow", function (args) {
	      var rowHeight = args.rowHeight,
	        index = args.index,
	        renderIndex = args.renderIndex,
	        empty = args.empty,
	        sticky = args.sticky;
	      var setRowSpan = function setRowSpan(rowSpan) {
	        args.rowSpan = rowSpan;
	      };
	      var result = _this.computeRows(_this.props, {
	        empty: empty,
	        from: index,
	        sticky: sticky,
	        to: index + 1,
	        renderIndex: renderIndex,
	        rowHeight: rowHeight,
	        setRowSpan: setRowSpan
	      })[0];
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getVisibleCount", function () {
	      return _this.getVirtualList() ? _this.getVirtualList().getVisibleCount() : -1;
	    });
	    _this.virtualListRef = (0, _react.createRef)();
	    _this._scrollLeft = 0;
	    _this._scrollTop = 0;
	    _this.startIndex = 0;
	    _this.endIndex = CHUNKS_SIZE;
	    _this.state = {
	      columnRenderCount: 0
	    };
	    _this.rows = [];
	    _this.scrollbars = {};
	    _this.scrollLeft = (0, _react.createRef)();
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaDataGridList, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextProps.shouldComponentUpdate) {
	        return (0, _shouldComponentUpdate2.default)(this, nextProps, nextState);
	      }
	      var equalProps = (0, _shallowequal.default)(this.props, nextProps);
	      if (!equalProps) {
	        return true;
	      }
	      return !(0, _shallowequal.default)(nextState, this.state);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	      if (this.props.hasValueSetter) {
	        setTimeout(function () {
	          _this2.setValue();
	        }, 100);
	      }
	      this.__willUnmount = false;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.__willUnmount = true;
	    }
	  }, {
	    key: "isLazyEditing",
	    value: function isLazyEditing() {
	      return !!this.lazyEditColumnId;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var thisProps = this.props;
	      var maybeProps = (0, _assignDefined.default)({}, {
	        minRowHeight: thisProps.minRowHeight,
	        rowHeight: thisProps.rowHeight
	      });
	      var pureRows = !!this.fromState;
	      var shouldUpdate = returnTrue;
	      var scrollProps = thisProps.scrollProps;
	      if (scrollProps && scrollProps.onContainerScrollHorizontal) {
	        scrollProps = _objectSpread({}, scrollProps);
	        scrollProps.onContainerScrollHorizontal = this.onScrollHorizontal;
	      }
	      var minRowWidth = Math.max(this.props.availableWidth, this.props.minRowWidth) || 0;
	      var naturalRowHeight = thisProps.naturalRowHeight;
	      var renderRow = this.renderRow;
	      if (naturalRowHeight) {
	        if (this.__data !== thisProps.data || !this.__minRowWidth) {
	          renderRow = renderRow.bind(this);
	        }
	        this.__minRowWidth = minRowWidth;
	        this.__data = thisProps.data;
	      }
	      return _react.default.createElement(_src.default, _objectSpread(_objectSpread({
	        rowHeight: null,
	        extraRows: naturalRowHeight ? 1 : 0,
	        style: thisProps.style,
	        theme: this.props.theme,
	        checkResizeDelay: thisProps.checkResizeDelay,
	        rowContain: thisProps.rowContain,
	        contain: thisProps.contain,
	        rtl: thisProps.rtl,
	        stickyOffset: thisProps.rtlOffset,
	        stickyRows: thisProps.computedStickyRows,
	        onStickyRowUpdate: this.onStickyRowUpdate,
	        enableRowSpan: thisProps.computedEnableRowspan,
	        recycleCoveredRows: false,
	        className: VirtualListClassName,
	        renderRowContainer: this.renderRowContainer
	      }, maybeProps), {}, {
	        overscrollBehavior: "auto",
	        rowHeightManager: thisProps.rowHeightManager,
	        before: thisProps.before,
	        after: thisProps.after,
	        showEmptyRows: thisProps.computedShowEmptyRows,
	        scrollProps: scrollProps,
	        emptyScrollOffset: this.getEmptyScrollOffset(),
	        nativeScroll: thisProps.nativeScroll,
	        onResize: this.onResize,
	        virtualized: thisProps.virtualized,
	        minRowWidth: minRowWidth,
	        naturalRowHeight: naturalRowHeight,
	        renderScroller: this.renderScroller,
	        renderScrollerSpacer: this.renderScrollerSpacer,
	        renderSizer: this.renderSizer,
	        renderView: this.renderView,
	        useTransformRowPosition: this.props.useTransformRowPosition,
	        useTransformPosition: this.props.useTransformPosition,
	        shouldComponentUpdate: shouldUpdate,
	        ref: this.virtualListRef,
	        count: thisProps.data.length || 0,
	        pureRows: pureRows,
	        renderRow: renderRow,
	        onContainerScrollHorizontal: this.onScrollHorizontal,
	        onContainerScroll: this.onContainerScroll,
	        onScrollbarsChange: this.onScrollbarsChange,
	        onContainerScrollVertical: this.props.onContainerScrollVertical,
	        onScrollStop: this.onScrollStop,
	        shouldFocusNextRow: this.shouldFocusNextRow
	      }));
	    }
	  }, {
	    key: "shouldFocusNextRow",
	    value: function shouldFocusNextRow(_ref6) {
	      var index = _ref6.index,
	        nextIndex = _ref6.nextIndex,
	        dir = _ref6.dir;
	      var shouldFocus = !this.isLazyEditing();
	      return shouldFocus;
	    }
	  }, {
	    key: "getEmptyScrollOffset",
	    value: function getEmptyScrollOffset() {
	      return this.props.emptyScrollOffset || (0, _src.getScrollbarWidth)() || 17;
	    }
	  }, {
	    key: "tryStartEdit",
	    value: function tryStartEdit(_ref7) {
	      var rowIndex = _ref7.rowIndex,
	        columnIndex = _ref7.columnIndex,
	        dir = _ref7.dir;
	      var row = this.getRowAt(rowIndex);
	      if (row) {
	        return row.tryRowCellEdit(columnIndex, dir);
	      }
	      return Promise.reject(null);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this3 = this;
	      if (prevProps.columnRenderCount != this.props.columnRenderCount) {
	        raf(function () {
	          _this3.updateOnScrollLeft(undefined, true, _this3.props);
	        });
	      }
	      var _this$props6 = this.props,
	        lockedStartColumns = _this$props6.lockedStartColumns,
	        lockedEndColumns = _this$props6.lockedEndColumns;
	      var hasLocked = lockedStartColumns && lockedStartColumns.length || lockedEndColumns && lockedEndColumns.length;
	      if (hasLocked) {
	        this.onContainerScrollHorizontal(this._scrollLeft);
	      }
	    }
	  }, {
	    key: "getScrollLeftMax",
	    value: function getScrollLeftMax() {
	      return this.getVirtualList() ? this.getVirtualList().scrollLeftMax : 0;
	    }
	  }]);
	  return InovuaDataGridList;
	}(_react.Component);
	exports.default = InovuaDataGridList;
	var propTypes = Object.assign({}, _src.propTypes, {
	  count: _propTypes.default.number,
	  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
	    name: _propTypes.default.string,
	    computedWidth: _propTypes.default.number,
	    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    render: _propTypes.default.func
	  })),
	  data: _propTypes.default.any,
	  from: _propTypes.default.number,
	  updateLockedWrapperPositions: _propTypes.default.any,
	  idProperty: _propTypes.default.string,
	  maxWidth: _propTypes.default.number,
	  minRowHeight: _propTypes.default.number,
	  minWidth: _propTypes.default.number,
	  onColumnRenderStartIndexChange: _propTypes.default.func,
	  rowHeight: _propTypes.default.number,
	  renderScroller: _propTypes.default.func,
	  renderScrollerSpacer: _propTypes.default.func,
	  renderActiveRowIndicator: _propTypes.default.func,
	  showWarnings: _propTypes.default.bool,
	  to: _propTypes.default.number,
	  virtualizeColumns: _propTypes.default.bool,
	  hasValueSetter: _propTypes.default.bool
	});
	delete propTypes.renderRow;
	InovuaDataGridList.propTypes = propTypes;
	InovuaDataGridList.defaultProps = {
	  showWarnings: false
	};

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactCleanProps = _interopRequireDefault(__webpack_require__(49));
	var _shallowequal = _interopRequireWildcard(__webpack_require__(73));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _clamp = _interopRequireDefault(__webpack_require__(65));
	var _Cell = _interopRequireDefault(__webpack_require__(141));
	var _renderCellsMaybeLocked = _interopRequireDefault(__webpack_require__(210));
	var _adjustCellProps = _interopRequireDefault(__webpack_require__(555));
	var _usePrevious = _interopRequireDefault(__webpack_require__(61));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var CLASS_NAME = 'InovuaReactDataGrid__row';
	var skipSelect = function skipSelect(event) {
	  event.nativeEvent.skipSelect = true;
	};
	var getValueForPivotColumn = function getValueForPivotColumn(item, path) {
	  return path.reduce(function (acc, field, index) {
	    if (!acc || acc[field] == null) {
	      return null;
	    }
	    if (index === path.length - 1) {
	      return acc[field];
	    }
	    return acc[field].pivotSummary || acc[field].values;
	  }, item);
	};
	var getValueForPivotColumnSummary = function getValueForPivotColumnSummary(item, _ref) {
	  var path = _ref.pivotSummaryPath;
	  var i = 0;
	  var root = item;
	  var current;
	  while ((current = path[i]) && root) {
	    if (!root.pivotSummary) {
	      return null;
	    }
	    root = root.pivotSummary[current.value];
	    i++;
	  }
	  if (root && root.pivotColumnSummary) {
	    return root.pivotColumnSummary[path[path.length - 1].field];
	  }
	  return null;
	};
	var DataGridRow = _react.default.forwardRef(function (props, ref) {
	  var cells = (0, _react.useRef)([]);
	  var cellRef = (0, _react.useCallback)(function (c) {
	    if (!c) {
	      return;
	    }
	    cells.current.push(c);
	  }, []);
	  var domRef = (0, _react.useRef)(null);
	  var columnRenderStartIndex = (0, _react.useRef)(0);
	  var hasBorderTop = (0, _react.useRef)(false);
	  var hasBorderBottom = (0, _react.useRef)(false);
	  var maxRowspan = (0, _react.useRef)(1);
	  var scrollingInProgress = (0, _react.useRef)(false);
	  var scrollingDirection = (0, _react.useRef)('vertical');
	  var cleanupCells = (0, _react.useCallback)(function () {
	    cells.current = cells.current.filter(Boolean);
	    return cells.current;
	  }, []);
	  var getCells = (0, _react.useCallback)(function () {
	    return cells.current;
	  }, []);
	  var prevColumnRenderCount = (0, _usePrevious.default)(props.columnRenderCount, props.columnRenderCount);
	  if (props.columnRenderCount < prevColumnRenderCount) {
	    cleanupCells();
	  }
	  var getDOMNode = (0, _react.useCallback)(function () {
	    return domRef.current;
	  }, []);
	  var setActiveRowRef = function setActiveRowRef() {
	    props.activeRowRef.current = {
	      instance: {
	        hasBorderBottom: hasBorderBottom.current,
	        hasBorderTop: hasBorderTop.current,
	        props: props
	      },
	      node: getDOMNode()
	    };
	  };
	  if (props.active) {
	    setActiveRowRef();
	  }
	  (0, _react.useEffect)(function () {
	    if (props.columnRenderStartIndex) {
	      setColumnRenderStartIndex(props.columnRenderStartIndex);
	    }
	    return function () {
	      cells.current = [];
	    };
	  }, []);
	  var prevRowIndex = (0, _usePrevious.default)(props.rowIndex, props.rowIndex);
	  var prevEditing = (0, _usePrevious.default)(props.editing, props.editing);
	  var prevActive = (0, _usePrevious.default)(props.active, props.active);
	  (0, _react.useEffect)(function () {
	    if (props.groupProps && props.rowIndex !== prevRowIndex) {
	      fixForColspan();
	    }
	    if (props.editing !== prevEditing) {
	      updateEditCell();
	    }
	    if (!prevActive && props.active) {
	      setActiveRowRef();
	    }
	  });
	  var onCellUnmount = (0, _react.useCallback)(function (_cellProps, cell) {
	    if (cells.current) {
	      cells.current = cells.current.filter(function (c) {
	        return c !== cell;
	      });
	    }
	  }, []);
	  var orderCells = (0, _react.useCallback)(function () {
	    var cells = cleanupCells();
	    var sortedProps = cells.map(function (c) {
	      return c.getProps();
	    }).sort(function (p1, p2) {
	      return p1.index - p2.index;
	    });
	    cells.sort(function (cell1, cell2) {
	      return cell1.props.renderIndex - cell2.props.renderIndex;
	    });
	    cells.forEach(function (c, i) {
	      c.setStateProps(sortedProps[i]);
	    });
	  }, [cleanupCells]);
	  var updateEditCell = (0, _react.useCallback)(function () {
	    var cells = getCells();
	    var editColumnIndex = props.editColumnIndex;
	    for (var i = 0, len = cells.length, cell; i < len; i++) {
	      cell = cells[i];
	      if (getCellIndex(cell) === editColumnIndex) {
	        setCellIndex(cell, editColumnIndex);
	      }
	      if (cell.getProps().inEdit) {
	        setCellIndex(cell, getCellIndex(cell));
	      }
	    }
	  }, [props.editColumnIndex]);
	  var fixForColspan = (0, _react.useCallback)(function () {
	    if (props.computedHasColSpan) {
	      setColumnRenderStartIndex(columnRenderStartIndex.current);
	    }
	  }, [props.computedHasColSpan]);
	  var setScrolling = (0, _react.useCallback)(function (scrolling) {
	    var node = getDOMNode() || domRef.current;
	    var scrollingDir = scrollingDirection.current;
	    if (scrolling !== false) {
	      scrollingDirection.current = scrolling;
	    }
	    var oldScrollingInProgress = scrollingInProgress.current;
	    scrollingDirection.current = scrollingDir;
	    scrollingInProgress.current = scrolling ? true : false;
	    if (!node) {
	      return;
	    }
	    if (oldScrollingInProgress !== scrollingInProgress.current) {
	      var _className = "".concat(CLASS_NAME, "--scrolling");
	      if (scrollingInProgress.current) {
	        node.classList.add(_className);
	      } else {
	        node.classList.remove(_className);
	      }
	    }
	    return;
	  }, []);
	  var renderRowDetails = (0, _react.useCallback)(function (rowDetailsInfo) {
	    if (props.computedRenderRowDetails) {
	      return props.computedRenderRowDetails(rowDetailsInfo);
	    }
	    return 'Please specify `renderRowDetails`';
	  }, []);
	  var onContextMenu = (0, _react.useCallback)(function (event) {
	    var passedProps = props.passedProps,
	      onRowContextMenu = props.onRowContextMenu;
	    if (onRowContextMenu) {
	      onRowContextMenu(props, event);
	    }
	    if (passedProps && passedProps.onContextMenu) {
	      passedProps.onContextMenu(event, props);
	    }
	  }, [props.passedProps, props.passedProps.onContextMenu, props.onRowContextMenu]);
	  var setCellIndex = (0, _react.useCallback)(function (cell, index, cellProps) {
	    cellProps = cellProps || (props.computedHasColSpan ? getPropsForCells().slice(index, index + 1)[0] : getPropsForCells(index, index)[0]);
	    cell.setStateProps(cellProps);
	  }, [props.computedHasColSpan]);
	  var getCellIndex = (0, _react.useCallback)(function (cell) {
	    return cell.getProps().computedVisibleIndex;
	  }, []);
	  var sortCells = (0, _react.useCallback)(function (cells) {
	    return cells.sort(function (cell1, cell2) {
	      return getCellIndex(cell1) - getCellIndex(cell2);
	    });
	  }, []);
	  var getCellAt = (0, _react.useCallback)(function (index) {
	    return getCells().filter(function (c) {
	      return c.getProps().computedVisibleIndex === index;
	    })[0];
	  }, []);
	  var getCellById = (0, _react.useCallback)(function (id) {
	    return getCells().filter(function (c) {
	      return c.getProps().id === id;
	    })[0];
	  }, []);
	  var getSortedCells = (0, _react.useCallback)(function () {
	    return sortCells(getCells().slice());
	  }, []);
	  var getGaps = (0, _react.useCallback)(function (startIndex, endIndex) {
	    var visibleCellPositions = {};
	    var sortedCells = getSortedCells();
	    sortedCells.forEach(function (cell) {
	      var cellProps = cell.getProps();
	      if (cellProps.computedLocked) {
	        return;
	      }
	      var computedVisibleIndex = cellProps.computedVisibleIndex,
	        computedColspan = cellProps.computedColspan,
	        groupProps = cellProps.groupProps;
	      if (groupProps && computedVisibleIndex <= groupProps.depth + 1) {
	        return;
	      }
	      visibleCellPositions[computedVisibleIndex] = true;
	      if (computedColspan) {
	        for (var i = 0; i < computedColspan; i++) {
	          visibleCellPositions[computedVisibleIndex + i] = true;
	        }
	      }
	    });
	    var gaps = [];
	    for (; startIndex <= endIndex; startIndex++) {
	      if (!visibleCellPositions[startIndex]) {
	        gaps.push(startIndex);
	      }
	    }
	    return gaps;
	  }, []);
	  var getVirtualizeColumns = (0, _react.useCallback)(function () {
	    return props.virtualizeColumns;
	    return scrollingDirection.current !== 'horizontal' ? props.virtualizeColumns : false;
	  }, [props.virtualizeColumns]);
	  var toggleRowExpand = (0, _react.useCallback)(function (rowIndex) {
	    if (typeof rowIndex !== 'number') {
	      rowIndex = props.realIndex;
	    }
	    props.toggleRowExpand(rowIndex);
	  }, [props.realIndex, props.toggleRowExpand]);
	  var toggleNodeExpand = (0, _react.useCallback)(function (rowIndex) {
	    if (typeof rowIndex !== 'number') {
	      rowIndex = props.realIndex;
	    }
	    props.toggleNodeExpand(rowIndex);
	  }, [props.realIndex, props.toggleNodeExpand]);
	  var loadNodeAsync = (0, _react.useCallback)(function () {
	    var _props$loadNodeAsync;
	    (_props$loadNodeAsync = props.loadNodeAsync) === null || _props$loadNodeAsync === void 0 ? void 0 : _props$loadNodeAsync.call(props, props.data);
	  }, [props.loadNodeAsync, props.data]);
	  var isRowExpandable = (0, _react.useCallback)(function (rowIndex) {
	    if (typeof rowIndex !== 'number') {
	      rowIndex = props.realIndex;
	    }
	    return props.isRowExpandableAt(rowIndex);
	  }, [props.realIndex, props.isRowExpandableAt]);
	  var setRowExpanded = (0, _react.useCallback)(function (expanded, _) {
	    var rowIndex = props.realIndex;
	    var _expanded = expanded;
	    if (typeof expanded === 'number') {
	      rowIndex = expanded;
	      _expanded = _;
	    }
	    props.setRowExpanded(rowIndex, _expanded);
	  }, [props.realIndex, props.setRowExpanded]);
	  var getCurrentGaps = function getCurrentGaps() {};
	  var setColumnRenderStartIndex = (0, _react.useCallback)(function (columnStartIndex) {
	    if (columnRenderStartIndex.current === columnStartIndex) {
	      return;
	    }
	    columnRenderStartIndex.current = columnStartIndex;
	    if (getVirtualizeColumns() === false) {
	      return;
	    }
	    var newCellProps;
	    var renderRange;
	    var cellPropsAt;
	    if (props.computedHasColSpan) {
	      newCellProps = getPropsForCells();
	      renderRange = getColumnRenderRange(newCellProps);
	      cellPropsAt = function cellPropsAt(index) {
	        return newCellProps[index];
	      };
	    } else {
	      var _renderRange, _renderRange2;
	      renderRange = getColumnRenderRange();
	      newCellProps = getPropsForCells((_renderRange = renderRange) === null || _renderRange === void 0 ? void 0 : _renderRange.start, (((_renderRange2 = renderRange) === null || _renderRange2 === void 0 ? void 0 : _renderRange2.end) || 0) + 1);
	      cellPropsAt = function cellPropsAt(index) {
	        return newCellProps.filter(function (cellProps) {
	          return cellProps.computedVisibleIndex === index;
	        })[0];
	      };
	    }
	    if (!renderRange) {
	      return;
	    }
	    var _renderRange3 = renderRange,
	      start = _renderRange3.start,
	      end = _renderRange3.end;
	    var gaps = getGaps(start, end);
	    if (!gaps.length) {
	      return;
	    }
	    var gapsMap = gaps.reduce(function (acc, gapIndex) {
	      acc[gapIndex] = true;
	      return acc;
	    }, {});
	    var tempCellMap = {};
	    var calls = [];
	    getCells().forEach(function (cell) {
	      var cellProps = cell.getProps();
	      var groupProps = cellProps.groupProps,
	        cellIndex = cellProps.computedVisibleIndex,
	        computedColspan = cellProps.computedColspan,
	        computedLocked = cellProps.computedLocked;
	      if (computedLocked) {
	        return;
	      }
	      if (!props.groupColumn && groupProps && cellIndex <= groupProps.depth + 1) {
	        return;
	      }
	      var outside = cellIndex < start || cellIndex > end || cellIndex === undefined;
	      if (outside && computedColspan) {
	        var endCellIndex = cellIndex + (computedColspan - 1);
	        outside = cellIndex < start && endCellIndex < start || cellIndex > end;
	      }
	      var outOfView = outside || tempCellMap[cellIndex] || gapsMap[cellIndex];
	      tempCellMap[cellIndex] = true;
	      var newIndex;
	      if (outOfView && gaps.length) {
	        newIndex = gaps[gaps.length - 1];
	        calls.push([cell, newIndex]);
	        gaps.length -= 1;
	      }
	    });
	    calls.forEach(function (call) {
	      var cell = call[0];
	      var newIndex = call[1];
	      setCellIndex(cell, newIndex, cellPropsAt(newIndex));
	    });
	  }, [props.columnRenderStartIndex, props.computedHasColSpan, props.columnRenderCount, props.virtualizeColumns]);
	  var propsRef = (0, _react.useRef)(props);
	  propsRef.current = props;
	  var lastDataSource = (0, _usePrevious.default)(propsRef.current.dataSourceArray, propsRef.current.dataSourceArray);
	  var lastColumns = (0, _usePrevious.default)(propsRef.current.columns, propsRef.current.columns);
	  var getPropsForCells = function getPropsForCells(startIndex, endIndex) {
	    var _columns$filter$;
	    var props = propsRef.current;
	    var initialColumns = props.columns;
	    var columns = initialColumns;
	    var hasLockedStart = props.hasLockedStart,
	      data = props.data,
	      onGroupToggle = props.onGroupToggle,
	      computedPivot = props.computedPivot,
	      rowHeight = props.rowHeight,
	      remoteRowIndex = props.remoteRowIndex,
	      initialRowHeight = props.initialRowHeight,
	      lastLockedStartIndex = props.lastLockedStartIndex,
	      lastLockedEndIndex = props.lastLockedEndIndex,
	      lastUnlockedIndex = props.lastUnlockedIndex,
	      minRowHeight = props.minRowHeight,
	      realIndex = props.realIndex,
	      showHorizontalCellBorders = props.showHorizontalCellBorders,
	      showVerticalCellBorders = props.showVerticalCellBorders,
	      empty = props.empty,
	      treeColumn = props.treeColumn,
	      groupColumn = props.groupColumn,
	      totalDataCount = props.totalDataCount,
	      depth = props.depth,
	      dataSourceArray = props.dataSourceArray,
	      computedGroupBy = props.computedGroupBy,
	      groupProps = props.groupProps,
	      summaryProps = props.summaryProps,
	      indexInGroup = props.indexInGroup,
	      firstUnlockedIndex = props.firstUnlockedIndex,
	      firstLockedEndIndex = props.firstLockedEndIndex,
	      selectAll = props.selectAll,
	      deselectAll = props.deselectAll,
	      columnUserSelect = props.columnUserSelect,
	      multiSelect = props.multiSelect,
	      selection = props.selection,
	      setRowSelected = props.setRowSelected,
	      computedRowExpandEnabled = props.computedRowExpandEnabled,
	      rtl = props.rtl,
	      lastRow = props.last,
	      computedCellSelection = props.computedCellSelection,
	      lastNonEmpty = props.lastNonEmpty,
	      maxVisibleRows = props.maxVisibleRows,
	      onCellClick = props.onCellClick,
	      editStartEvent = props.editStartEvent,
	      naturalRowHeight = props.naturalRowHeight,
	      renderNodeTool = props.renderNodeTool,
	      computedTreeEnabled = props.computedTreeEnabled,
	      rowExpanded = props.expanded,
	      expandGroupTitle = props.expandGroupTitle,
	      expandColumnFn = props.expandColumn,
	      onCellSelectionDraggerMouseDown = props.onCellSelectionDraggerMouseDown,
	      onCellMouseDown = props.onCellMouseDown,
	      onCellEnter = props.onCellEnter,
	      computedCellMultiSelectionEnabled = props.computedCellMultiSelectionEnabled,
	      getCellSelectionKey = props.getCellSelectionKey,
	      lastCellInRange = props.lastCellInRange,
	      computedRowspans = props.computedRowspans,
	      renderIndex = props.renderIndex,
	      nativeScroll = props.nativeScroll,
	      onDragRowMouseDown = props.onDragRowMouseDown,
	      theme = props.theme,
	      onContextMenu = props.onContextMenu,
	      setActiveIndex = props.setActiveIndex,
	      renderTreeCollapseTool = props.renderTreeCollapseTool,
	      renderTreeExpandTool = props.renderTreeExpandTool,
	      renderGroupCollapseTool = props.renderGroupCollapseTool,
	      renderGroupExpandTool = props.renderGroupExpandTool,
	      renderTreeLoadingTool = props.renderTreeLoadingTool,
	      onColumnMouseEnter = props.onColumnMouseEnter,
	      onColumnMouseLeave = props.onColumnMouseLeave,
	      columnIndexHovered = props.columnIndexHovered,
	      computedEnableColumnHover = props.computedEnableColumnHover,
	      columnHoverClassName = props.columnHoverClassName,
	      enableColumnAutosize = props.enableColumnAutosize,
	      renderRowDetailsExpandIcon = props.renderRowDetailsExpandIcon,
	      renderRowDetailsCollapsedIcon = props.renderRowDetailsCollapsedIcon,
	      disabledRow = props.disabledRow,
	      onCellDoubleClick = props.onCellDoubleClick,
	      onCellBulkUpdateMouseDown = props.onCellBulkUpdateMouseDown,
	      onCellBulkUpdateMouseUp = props.onCellBulkUpdateMouseUp,
	      bulkUpdateMouseDown = props.bulkUpdateMouseDown;
	    var dataSourceChange = !(0, _shallowequal.default)(lastDataSource, props.dataSourceArray);
	    var columnsChange = !(0, _shallowequal.default)(lastColumns, props.columns);
	    var expandColumnId = expandColumnFn ? expandColumnFn({
	      data: data
	    }) : undefined;
	    var virtualizeColumns = getVirtualizeColumns();
	    var visibleColumnCount = columns.length;
	    var expandColumnIndex = expandColumnId ? (_columns$filter$ = columns.filter(function (c) {
	      return c.id === expandColumnId;
	    })[0]) === null || _columns$filter$ === void 0 ? void 0 : _columns$filter$.computedVisibleIndex : undefined;
	    if (startIndex !== undefined) {
	      columns = columns.slice(startIndex, endIndex ? endIndex + 1 : startIndex + 1);
	    }
	    startIndex = startIndex || 0;
	    var hasBorderTopVar = false;
	    var hasBorderBottomVar = false;
	    var hiddenCells = {};
	    var belongsToColspan = {};
	    var columnsTillColspanStart = {};
	    var lastInGroup = indexInGroup == props.groupCount - 1;
	    var activeCell = props.computedActiveCell && getCellSelectionKey ? getCellSelectionKey.apply(void 0, (0, _toConsumableArray2.default)(props.computedActiveCell)) : null;
	    var lastInRange = lastCellInRange || activeCell || null;
	    var maxRowspanVar = 1;
	    var cellPropsArray = columns.map(function (column, idx) {
	      var theColumnIndex = idx + startIndex;
	      var columnProps = column;
	      var name = columnProps.name,
	        computedVisibleIndex = columnProps.computedVisibleIndex;
	      var value = data ? data[name] : null;
	      var rowIndex = realIndex;
	      if (groupProps && data && data.groupColumnSummary) {
	        value = data.groupColumnSummary[name];
	      }
	      if (groupProps && data && column.groupColumn) {
	        value = data.value;
	      }
	      if (columnProps.pivotColumnPath) {
	        value = data.pivotSummary ? getValueForPivotColumn(data.pivotSummary, columnProps.pivotColumnPath) : value;
	      }
	      if (columnProps.pivotGrandSummaryColumn) {} else {
	        if (columnProps.pivotSummaryPath) {
	          value = data.pivotSummary ? getValueForPivotColumnSummary(data, {
	            pivotSummaryPath: columnProps.pivotSummaryPath,
	            pivotGrandSummaryColumn: columnProps.pivotGrandSummaryColumn
	          }) : value;
	        }
	      }
	      var defaults = {};
	      if (columnUserSelect !== undefined) {
	        defaults.userSelect = columnUserSelect;
	      }
	      var groupTitleCell = !groupColumn && groupProps && groupProps.depth + 1 == computedVisibleIndex;
	      var groupExpandCell = !groupColumn && groupProps && groupProps.depth == computedVisibleIndex;
	      var hidden = groupProps ? expandGroupTitle && !groupColumn ? computedVisibleIndex > groupProps.depth + 1 : false : false;
	      if (expandColumnIndex != null && computedVisibleIndex > expandColumnIndex) {
	        hidden = true;
	      }
	      var cellProps = _objectSpread(_objectSpread(_objectSpread({}, defaults), columnProps), {}, {
	        remoteRowIndex: remoteRowIndex,
	        indexInColumns: theColumnIndex,
	        depth: depth,
	        expandColumnIndex: expandColumnIndex,
	        expandColumn: expandColumnIndex === computedVisibleIndex,
	        editStartEvent: editStartEvent,
	        onCellClick: onCellClick,
	        computedRowspan: computedRowspans ? computedRowspans[column.id] : 1,
	        groupNestingSize: props.groupNestingSize,
	        treeNestingSize: props.treeNestingSize,
	        data: data,
	        naturalRowHeight: naturalRowHeight,
	        totalDataCount: totalDataCount,
	        onCellSelectionDraggerMouseDown: onCellSelectionDraggerMouseDown,
	        onCellMouseDown: onCellMouseDown,
	        onCellEnter: onCellEnter,
	        rtl: rtl,
	        computedPivot: computedPivot,
	        selectAll: selectAll,
	        deselectAll: deselectAll,
	        selection: selection,
	        renderNodeTool: renderNodeTool,
	        onDragRowMouseDown: onDragRowMouseDown,
	        multiSelect: multiSelect,
	        treeColumn: treeColumn !== undefined ? treeColumn === columnProps.id : false,
	        setRowSelected: setRowSelected,
	        setRowExpanded: computedRowExpandEnabled ? setRowExpanded : null,
	        toggleRowExpand: computedRowExpandEnabled ? toggleRowExpand : null,
	        toggleNodeExpand: computedTreeEnabled ? toggleNodeExpand : null,
	        loadNodeAsync: computedTreeEnabled ? loadNodeAsync : null,
	        rowActive: props.active,
	        rowSelected: props.selected,
	        rowExpanded: rowExpanded,
	        rowIndex: rowIndex,
	        rowHeight: rowHeight,
	        groupColumnVisible: !!groupColumn,
	        minRowHeight: minRowHeight,
	        groupProps: groupProps,
	        summaryProps: summaryProps,
	        empty: empty,
	        computedGroupBy: computedGroupBy,
	        nativeScroll: nativeScroll,
	        computedCellMultiSelectionEnabled: computedCellMultiSelectionEnabled,
	        lastRowInGroup: lastInGroup,
	        columnIndex: computedVisibleIndex,
	        first: computedVisibleIndex == 0,
	        last: computedVisibleIndex == visibleColumnCount - 1,
	        value: value,
	        virtualizeColumns: virtualizeColumns,
	        hasLockedStart: hasLockedStart,
	        rowIndexInGroup: indexInGroup,
	        rowRenderIndex: renderIndex,
	        hidden: hidden,
	        groupTitleCell: groupTitleCell,
	        groupExpandCell: groupExpandCell,
	        isRowExpandable: computedRowExpandEnabled ? isRowExpandable : null,
	        tryRowCellEdit: tryRowCellEdit,
	        tryNextRowEdit: tryNextRowEdit,
	        onGroupToggle: onGroupToggle,
	        initialRowHeight: rowExpanded ? initialRowHeight : rowHeight,
	        theme: theme,
	        onContextMenu: onContextMenu,
	        setActiveIndex: setActiveIndex,
	        renderTreeCollapseTool: renderTreeCollapseTool,
	        renderTreeExpandTool: renderTreeExpandTool,
	        renderGroupCollapseTool: renderGroupCollapseTool,
	        renderGroupExpandTool: renderGroupExpandTool,
	        renderTreeLoadingTool: renderTreeLoadingTool,
	        onColumnMouseEnter: onColumnMouseEnter,
	        onColumnMouseLeave: onColumnMouseLeave,
	        columnIndexHovered: columnIndexHovered,
	        computedEnableColumnHover: computedEnableColumnHover,
	        columnHoverClassName: columnHoverClassName,
	        renderRowDetailsExpandIcon: renderRowDetailsExpandIcon,
	        renderRowDetailsCollapsedIcon: renderRowDetailsCollapsedIcon,
	        disabledRow: disabledRow,
	        dataSourceChange: dataSourceChange,
	        columnsChange: columnsChange,
	        onDoubleClick: onCellDoubleClick,
	        onCellBulkUpdateMouseDown: onCellBulkUpdateMouseDown,
	        onCellBulkUpdateMouseUp: onCellBulkUpdateMouseUp,
	        bulkUpdateMouseDown: bulkUpdateMouseDown
	      });
	      if (computedCellSelection && getCellSelectionKey) {
	        cellProps.cellSelected = computedCellSelection[getCellSelectionKey(rowIndex, computedVisibleIndex)];
	        if (cellProps.cellSelected) {
	          cellProps.hasRightSelectedSibling = cellProps.last ? false : computedCellSelection[getCellSelectionKey(rowIndex, computedVisibleIndex + 1)];
	          cellProps.hasLeftSelectedSibling = cellProps.first ? false : computedCellSelection[getCellSelectionKey(rowIndex, computedVisibleIndex - 1)];
	          cellProps.hasTopSelectedSibling = computedCellSelection[getCellSelectionKey(rowIndex - 1, computedVisibleIndex)];
	          cellProps.hasBottomSelectedSibling = computedCellSelection[getCellSelectionKey(rowIndex + 1, computedVisibleIndex)];
	        }
	      }
	      if (getCellSelectionKey && (activeCell || lastInRange)) {
	        var cellKey = getCellSelectionKey(rowIndex, computedVisibleIndex);
	        if (activeCell && activeCell === cellKey) {
	          cellProps.cellActive = true;
	        }
	        if (lastInRange && lastInRange === cellKey) {
	          cellProps.lastInRange = true;
	        }
	      }
	      if (cellProps.visibilityTransitionDuration || cellProps.showTransitionDuration || cellProps.hideTransitionDuration) {
	        cellProps.onTransitionEnd = onTransitionEnd(cellProps, columnProps);
	      }
	      if (props.editing && props.editColumnIndex === cellProps.columnIndex) {
	        cellProps.inEdit = true;
	        cellProps.editValue = props.editValue;
	      }
	      if (virtualizeColumns && !cellProps.computedLocked || enableColumnAutosize || props.editable || cellProps.computedEditable) {
	        cellProps.cellRef = cellRef;
	        cellProps.onUnmount = onCellUnmount;
	      }
	      var computedLocked = cellProps.computedLocked,
	        colspan = cellProps.colspan;
	      var lockedStart = computedLocked === 'start';
	      var lockedEnd = computedLocked === 'end';
	      var unlocked = !computedLocked;
	      var computedColspan = 1;
	      if (typeof colspan === 'function') {
	        computedColspan = cellProps.computedColspan = Math.max(1, colspan({
	          remoteRowIndex: remoteRowIndex,
	          dataSourceArray: dataSourceArray,
	          data: cellProps.data,
	          value: cellProps.value,
	          rowIndex: cellProps.rowIndex,
	          column: column,
	          columns: columns,
	          empty: empty
	        }));
	        if (lockedStart) {
	          computedColspan = (0, _clamp.default)(computedColspan, 1, Math.max(lastLockedStartIndex - computedVisibleIndex + 1, 1));
	        }
	        if (lockedEnd) {
	          computedColspan = (0, _clamp.default)(computedColspan, 1, Math.max(lastLockedEndIndex - computedVisibleIndex + 1, 1));
	        }
	        if (unlocked) {
	          computedColspan = (0, _clamp.default)(computedColspan, 1, Math.max(lastUnlockedIndex - computedVisibleIndex + 1, 1));
	        }
	        if (computedColspan > 1) {
	          cellProps.computedWidth = columns.slice(theColumnIndex, theColumnIndex + computedColspan).reduce(function (sum, col) {
	            if (col.id !== column.id) {
	              hiddenCells[col.id] = true;
	              if (column.computedLocked === col.computedLocked) {
	                belongsToColspan[col.id] = column.id;
	                columnsTillColspanStart[col.id] = col.computedVisibleIndex - column.computedVisibleIndex;
	              }
	            }
	            return sum + col.computedWidth;
	          }, 0);
	        }
	      }
	      cellProps.lastInSection = lockedStart ? computedVisibleIndex + computedColspan - 1 === firstUnlockedIndex - 1 : lockedEnd ? computedVisibleIndex + computedColspan - 1 === visibleColumnCount - 1 : computedVisibleIndex + computedColspan - 1 === firstLockedEndIndex - 1;
	      cellProps.firstInSection = lockedStart ? computedVisibleIndex === 0 : lockedEnd ? computedVisibleIndex === firstLockedEndIndex : computedVisibleIndex === firstUnlockedIndex;
	      if (computedGroupBy && !groupColumn && !!cellProps.depth) {
	        cellProps.noBackground = computedVisibleIndex < cellProps.depth;
	      }
	      if (hiddenCells[column.id]) {
	        cellProps.hidden = true;
	      }
	      if (belongsToColspan[column.id]) {
	        cellProps.computedColspanedBy = belongsToColspan[column.id];
	        cellProps.computedColspanToStart = columnsTillColspanStart[column.id];
	      }
	      if (groupProps && !groupColumn || expandColumnIndex != null) {
	        (0, _adjustCellProps.default)(cellProps, props);
	      }
	      if (cellProps.hidden) {
	        cellProps.last = false;
	        cellProps.lastInSection = false;
	      } else {
	        cellProps.showBorderLeft = showVerticalCellBorders && computedVisibleIndex > 0;
	        cellProps.showBorderBottom = showHorizontalCellBorders;
	        if (!showVerticalCellBorders && computedGroupBy) {
	          cellProps.showBorderLeft = computedVisibleIndex > 0 && computedVisibleIndex <= computedGroupBy.length;
	        }
	        if (computedGroupBy) {
	          if (!cellProps.groupProps) {
	            cellProps.showBorderBottom = groupColumn ? showHorizontalCellBorders : computedVisibleIndex >= computedGroupBy.length && showHorizontalCellBorders;
	            var summaryBefore = indexInGroup === 0 && !groupColumn ? dataSourceArray[rowIndex - indexInGroup] : null;
	            if (summaryBefore && summaryBefore.__summary && computedVisibleIndex >= computedGroupBy.length) {
	              cellProps.showBorderBottom = false;
	            }
	          }
	          if (!empty) {
	            if (!groupColumn && (computedVisibleIndex < computedGroupBy.length || lastInGroup)) {
	              cellProps.showBorderBottom = rowExpanded;
	            }
	            if (cellProps.groupProps) {
	              cellProps.showBorderBottom = cellProps.groupProps.collapsed ? !!groupColumn : groupColumn ? true : computedVisibleIndex > cellProps.groupProps.depth && cellProps.groupProps.depth >= computedGroupBy.length;
	              cellProps.showBorderTop = groupTitleCell || groupExpandCell || !expandGroupTitle && !groupColumn;
	            } else if (indexInGroup === 0 && !groupColumn) {
	              cellProps.showBorderTop = computedVisibleIndex >= computedGroupBy.length;
	            }
	            if (lastNonEmpty && !lastRow && showHorizontalCellBorders) {
	              cellProps.showBorderBottom = computedVisibleIndex >= (cellProps.groupProps ? cellProps.groupProps.depth : computedGroupBy.length);
	            }
	          } else if (rowIndex > 0 && showHorizontalCellBorders) {
	            if (rowIndex === totalDataCount) {
	              cellProps.showBorderBottom = computedVisibleIndex >= computedGroupBy.length;
	            } else {
	              cellProps.showBorderBottom = computedGroupBy ? computedVisibleIndex >= computedGroupBy.length : true;
	            }
	          }
	        }
	        if (lastRow) {
	          cellProps.showBorderBottom = rowIndex < maxVisibleRows - 1 || rowExpanded;
	        }
	        if (lockedStart && cellProps.lastInSection) {
	          cellProps.showBorderRight = true;
	        }
	        if (lockedEnd && computedVisibleIndex === firstLockedEndIndex) {
	          cellProps.showBorderLeft = true;
	        }
	        if (cellProps.groupProps && computedVisibleIndex >= cellProps.groupProps.depth + 1 && !groupColumn && props.expandGroupTitle) {
	          cellProps.showBorderLeft = false;
	        }
	        if (cellProps.summaryProps) {
	          cellProps.showBorderBottom = lastRow;
	          cellProps.showBorderTop = computedVisibleIndex > cellProps.summaryProps.depth;
	          if (cellProps.summaryProps.position == 'start') {
	            cellProps.showBorderTop = computedVisibleIndex >= cellProps.summaryProps.depth;
	            cellProps.showBorderBottom = false;
	          }
	          cellProps.showBorderLeft = showVerticalCellBorders ? true : computedVisibleIndex <= cellProps.summaryProps.depth;
	          if (computedVisibleIndex > cellProps.summaryProps.depth && computedVisibleIndex <= computedGroupBy.length && !groupColumn) {
	            cellProps.showBorderLeft = false;
	          }
	          if (computedVisibleIndex === 0) {
	            cellProps.showBorderLeft = false;
	          }
	          cellProps.noBackground = !groupColumn;
	        }
	        if (firstUnlockedIndex === computedVisibleIndex && hasLockedStart) {
	          cellProps.showBorderLeft = false;
	        }
	        if (cellProps.groupSpacerColumn && rowExpanded) {
	          cellProps.showBorderBottom = false;
	        }
	        if (cellProps.last) {
	          cellProps.showBorderRight = true;
	        }
	        var prevColumn = columns[theColumnIndex - 1];
	        var nextColumn = columns[theColumnIndex + 1];
	        if (nextColumn && nextColumn.prevBorderRight !== undefined && !(lockedStart && cellProps.lastInSection)) {
	          cellProps.showBorderRight = nextColumn.prevBorderRight;
	        }
	        if (prevColumn && prevColumn.nextBorderLeft !== undefined) {
	          cellProps.showBorderLeft = prevColumn.nextBorderLeft;
	        }
	        if (columnProps.showBorderRight !== undefined) {
	          cellProps.showBorderRight = columnProps.showBorderRight;
	        }
	        if (columnProps.showBorderLeft !== undefined) {
	          cellProps.showBorderLeft = columnProps.showBorderLeft;
	        }
	      }
	      if (cellProps.computedEditable) {
	        cellProps.onEditStopForRow = onCellStopEdit;
	        cellProps.onEditStartForRow = onCellStartEdit;
	        cellProps.onEditCancelForRow = onCellEditCancel;
	        cellProps.onEditValueChangeForRow = onCellEditValueChange;
	        cellProps.onEditCompleteForRow = onCellEditComplete;
	      }
	      hasBorderBottomVar = hasBorderBottomVar || cellProps.showBorderBottom;
	      hasBorderTopVar = hasBorderTopVar || cellProps.showBorderTop;
	      return cellProps;
	    });
	    maxRowspan.current = maxRowspanVar;
	    if (props.computedEnableRowspan) {
	      props.setRowSpan && props.setRowSpan(maxRowspan.current);
	    }
	    hasBorderTop.current = hasBorderTopVar;
	    hasBorderBottom.current = hasBorderBottomVar;
	    return cellPropsArray;
	  };
	  var onCellStopEdit = (0, _react.useCallback)(function (value, cellProps) {
	    if (props.onEditStop) {
	      props.onEditStop({
	        value: value,
	        data: cellProps.data,
	        rowId: props.getItemId(cellProps.data),
	        columnId: cellProps.id,
	        columnIndex: cellProps.computedVisibleIndex,
	        rowIndex: cellProps.rowIndex,
	        cellProps: cellProps
	      });
	    }
	  }, [props.onEditStop]);
	  var onCellStartEdit = (0, _react.useCallback)(function (value, cellProps) {
	    if (props.onEditStart) {
	      props.onEditStart({
	        data: cellProps.data,
	        value: value,
	        rowId: props.getItemId(cellProps.data),
	        columnId: cellProps.id,
	        columnIndex: cellProps.computedVisibleIndex,
	        rowIndex: cellProps.rowIndex,
	        cellProps: cellProps
	      });
	    }
	  }, [props.onEditStart]);
	  var onCellEditCancel = (0, _react.useCallback)(function (cellProps) {
	    if (props.onEditCancel) {
	      props.onEditCancel({
	        data: cellProps.data,
	        rowId: props.getItemId(cellProps.data),
	        columnIndex: cellProps.computedVisibleIndex,
	        columnId: cellProps.id,
	        rowIndex: cellProps.rowIndex,
	        cellProps: cellProps
	      });
	    }
	  }, [props.onEditCancel]);
	  var onCellEditValueChange = (0, _react.useCallback)(function (value, cellProps) {
	    if (props.onEditValueChange) {
	      props.onEditValueChange({
	        value: value,
	        data: cellProps.data,
	        rowId: props.getItemId(cellProps.data),
	        columnId: cellProps.id,
	        columnIndex: cellProps.computedVisibleIndex,
	        rowIndex: cellProps.rowIndex,
	        cellProps: cellProps
	      });
	    }
	  }, [props.onEditValueChange]);
	  var onCellEditComplete = (0, _react.useCallback)(function (value, cellProps) {
	    if (props.onEditComplete) {
	      props.onEditComplete({
	        value: value,
	        data: cellProps.data,
	        rowId: props.getItemId(cellProps.data),
	        columnId: cellProps.id,
	        columnIndex: cellProps.computedVisibleIndex,
	        rowIndex: cellProps.rowIndex,
	        cellProps: cellProps
	      });
	    }
	  }, [props.onEditComplete]);
	  var tryRowCellEdit = (0, _react.useCallback)(function (editIndex) {
	    var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var isEnterNavigation = arguments.length > 2 ? arguments[2] : undefined;
	    var cols = props.columns;
	    var col;
	    var colIndex;
	    if (!dir) {
	      dir = 1;
	    }
	    dir = dir == 1 ? 1 : -1;
	    var currentIndex = dir == 1 ? 0 : cols.length - 1;
	    var foundCols = [];
	    while (cols[currentIndex]) {
	      col = cols[currentIndex];
	      if (col.editable || props.editable && col.editable !== false) {
	        colIndex = col.computedVisibleIndex;
	        if (colIndex == editIndex) {
	          foundCols.push(col);
	        } else {
	          if (dir < 0) {
	            if (colIndex < editIndex) {
	              foundCols.push(col);
	            }
	          } else if (dir > 0) {
	            if (colIndex > editIndex) {
	              foundCols.push(col);
	            }
	          }
	        }
	      }
	      currentIndex += dir;
	    }
	    if (!foundCols.length) {
	      tryNextRowEdit(dir, isEnterNavigation ? editIndex : dir > 0 ? 0 : props.columns.length - 1);
	      return Promise.reject(null);
	    }
	    foundCols.sort(function (a, b) {
	      return dir > 0 ? a - b : b - a;
	    });
	    return new Promise(function (resolve, reject) {
	      var startEdit = function startEdit(cols) {
	        var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        props.currentEditCompletePromise.current.then(function () {
	          var errBack = function errBack() {
	            isEnterNavigation ? tryNextRowEdit(dir, editIndex, true) : startEdit(cols, index + 1);
	          };
	          var col = cols[index];
	          if (!col) {
	            tryNextRowEdit(dir, isEnterNavigation ? editIndex : dir > 0 ? 0 : props.columns.length - 1);
	            return reject('column not found');
	          }
	          var cell = getCellById(col.id);
	          if (!cell) {
	            if (props.scrollToColumn) {
	              props.scrollToColumn(col.id, undefined, function () {
	                setTimeout(function () {
	                  startEdit(cols, index);
	                }, 20);
	              });
	            }
	            return;
	          }
	          setTimeout(function () {
	            return cell.startEdit && cell.startEdit(undefined, errBack).then(resolve).catch(errBack);
	          }, 0);
	        }).catch(function (error) {
	          return reject(error);
	        });
	        return;
	      };
	      startEdit(foundCols, 0);
	    });
	  }, [props.columns, props.editable, props.currentEditCompletePromise, props.rowIndex, props.scrollToColumn]);
	  var tryNextRowEdit = (0, _react.useCallback)(function (dir, columnIndex, isEnterNavigation) {
	    if (props.scrollToIndexIfNeeded) {
	      props.scrollToIndexIfNeeded(props.rowIndex + 2 * dir, {
	        direction: dir == -1 ? 'top' : 'bottom'
	      }, function () {
	        if (props.tryNextRowEdit) {
	          props.tryNextRowEdit(props.rowIndex + dir, dir, columnIndex, isEnterNavigation);
	        }
	      });
	    }
	  }, [props.rowIndex, props.scrollToIndexIfNeeded, props.tryNextRowEdit]);
	  var onTransitionEnd = (0, _react.useCallback)(function (cellProps, columnProps, e) {
	    e.stopPropagation();
	    if (columnProps.onTransitionEnd) {
	      columnProps.onTransitionEnd(e);
	    }
	    if (props.onTransitionEnd) {
	      props.onTransitionEnd(e, cellProps);
	    }
	  }, [props.onTransitionEnd]);
	  var getColumnRenderRange = (0, _react.useCallback)(function (cellProps) {
	    var virtualizeColumns = getVirtualizeColumns();
	    if (!virtualizeColumns) {
	      return null;
	    }
	    var minStartIndex = props.lockedStartColumns.length ? props.lockedStartColumns.length : props.groupProps && !props.groupColumn ? props.groupProps.depth + 2 : 0;
	    var maxEndIndex = props.columns.length - props.lockedEndColumns.length - 1;
	    var columnStartIndex = columnRenderStartIndex.current == null ? props.columnRenderStartIndex || 0 : columnRenderStartIndex.current;
	    columnStartIndex = Math.max(columnStartIndex, minStartIndex);
	    var fixStartIndexForColspan = function fixStartIndexForColspan() {
	      if (cellProps) {
	        while (cellProps[columnStartIndex].computedColspanedBy) {
	          columnStartIndex--;
	        }
	      }
	    };
	    if (props.columnRenderCount != null) {
	      var columnRenderEndIndex = columnStartIndex + props.columnRenderCount;
	      columnRenderEndIndex = Math.min(columnRenderEndIndex, maxEndIndex);
	      if (columnRenderEndIndex - props.columnRenderCount != columnStartIndex) {
	        columnStartIndex = Math.max(columnRenderEndIndex - props.columnRenderCount, minStartIndex);
	      }
	      if (columnRenderEndIndex < 0) {
	        return {
	          start: 0,
	          end: 0
	        };
	      }
	      fixStartIndexForColspan();
	      return {
	        start: columnStartIndex,
	        end: columnRenderEndIndex
	      };
	    }
	    return null;
	  }, [props.virtualizeColumns, props.columnRenderCount, props.lockedStartColumns, props.lockedEndColumns, props.groupColumn, props.groupProps, props.columnRenderStartIndex, props.columns]);
	  var expandRangeWithColspan = (0, _react.useCallback)(function (range, cellProps) {
	    var extraNeededColumns = cellProps.reduce(function (total, cellProps) {
	      return total + (cellProps.computedColspan > 1 ? cellProps.computedColspan - 1 : 0);
	    }, 0);
	    if (!extraNeededColumns) {
	      return range;
	    }
	    if (range.start < props.firstUnlockedIndex) {
	      range.start = props.firstUnlockedIndex;
	    }
	    if (range.start > extraNeededColumns) {
	      range.start -= extraNeededColumns;
	      return range;
	    }
	    extraNeededColumns -= range.start;
	    range.start = 0;
	    if (extraNeededColumns) {
	      range.end += extraNeededColumns;
	    }
	    return range;
	  }, []);
	  var renderRowInstance = function renderRowInstance(_, __, style) {
	    var scrollLeft = props.scrollLeft,
	      hasLockedStart = props.hasLockedStart,
	      hasLockedEnd = props.hasLockedEnd,
	      lockedStartColumns = props.lockedStartColumns,
	      lockedEndColumns = props.lockedEndColumns,
	      computedHasColSpan = props.computedHasColSpan,
	      groupProps = props.groupProps,
	      columns = props.columns;
	    var virtualizeColumns = getVirtualizeColumns();
	    var cellProps;
	    if (!virtualizeColumns) {
	      cellProps = getPropsForCells();
	    } else {
	      var lockedStartCellProps = [];
	      var lockedEndCellProps = [];
	      var groupCellProps = [];
	      var renderRange;
	      if (computedHasColSpan) {
	        cellProps = getPropsForCells();
	        if (hasLockedStart) {
	          lockedStartCellProps = cellProps.slice(0, lockedStartColumns.length);
	        } else if (groupProps) {
	          groupCellProps = cellProps.slice(0, groupProps.depth + 2);
	        }
	        if (hasLockedEnd) {
	          lockedEndCellProps = cellProps.slice(columns.length - lockedEndColumns.length, columns.length);
	        }
	        renderRange = getColumnRenderRange(cellProps);
	        if (renderRange) {
	          renderRange = expandRangeWithColspan(renderRange, cellProps);
	          cellProps = cellProps.slice(renderRange.start, renderRange.end + 1);
	        }
	      } else {
	        var _renderRange4, _renderRange5;
	        renderRange = getColumnRenderRange();
	        cellProps = getPropsForCells((_renderRange4 = renderRange) === null || _renderRange4 === void 0 ? void 0 : _renderRange4.start, ((_renderRange5 = renderRange) === null || _renderRange5 === void 0 ? void 0 : _renderRange5.end) || 0);
	        if (hasLockedStart) {
	          lockedStartCellProps = getPropsForCells(0, lockedStartColumns.length - 1);
	        } else if (groupProps) {
	          groupCellProps = getPropsForCells(0, groupProps.depth + 2 - 1);
	        }
	        if (hasLockedEnd) {
	          lockedEndCellProps = getPropsForCells(lockedEndColumns[0].computedVisibleIndex, columns.length - 1);
	        }
	      }
	      if (hasLockedStart) {
	        cellProps = [].concat((0, _toConsumableArray2.default)(lockedStartCellProps), (0, _toConsumableArray2.default)(cellProps));
	      } else if (groupProps) {
	        cellProps = [].concat((0, _toConsumableArray2.default)(groupCellProps), (0, _toConsumableArray2.default)(cellProps));
	      }
	      if (hasLockedEnd) {
	        var _cellProps2;
	        (_cellProps2 = cellProps).push.apply(_cellProps2, (0, _toConsumableArray2.default)(lockedEndCellProps));
	      }
	    }
	    var result = cellProps.map(function (cProps, index) {
	      var cell;
	      var key = index;
	      if (!virtualizeColumns) {
	        key = cProps.id || index;
	      }
	      if (props.cellFactory) {
	        cell = props.cellFactory(cProps);
	      }
	      if (cell === undefined) {
	        cell = _react.default.createElement(_Cell.default, _objectSpread(_objectSpread({}, cProps), {}, {
	          timestamp: Date.now(),
	          cellRef: cProps.cellRef ? cProps.cellRef : null,
	          key: key
	        }));
	      }
	      return cell;
	    });
	    return (0, _renderCellsMaybeLocked.default)(result, props, scrollLeft, undefined, style);
	  };
	  var onClick = (0, _react.useCallback)(function (event) {
	    if (props.computedTreeEnabled && props.expandOnMouseDown) {
	      toggleNodeExpand(props.rowIndex);
	    }
	    if (props.onClick) {
	      props.onClick(event, props);
	    }
	    if (props.passedProps && props.passedProps.onClick) {
	      props.passedProps.onClick(event, props);
	    }
	  }, [props.passedProps, props.computedTreeEnabled, props.rowIndex, props.expandOnMouseDown, props.onClick]);
	  var onDoubleClick = (0, _react.useCallback)(function (event) {
	    if (props.onRowDoubleClick) {
	      props.onRowDoubleClick(event, props);
	    }
	  }, [props.onRowDoubleClick]);
	  var onMouseDown = (0, _react.useCallback)(function (event) {
	    if (props.onMouseDown) {
	      props.onMouseDown(event, props);
	    }
	  }, [props.onMouseDown]);
	  var onMouseUp = (0, _react.useCallback)(function (event) {
	    if (props.onMouseUp) {
	      props.onMouseUp(event);
	    }
	  }, []);
	  (0, _react.useImperativeHandle)(ref, function () {
	    return {
	      onCellUnmount: onCellUnmount,
	      cleanupCells: cleanupCells,
	      getDOMNode: getDOMNode,
	      orderCells: orderCells,
	      updateEditCell: updateEditCell,
	      fixForColspan: fixForColspan,
	      setScrolling: setScrolling,
	      renderRowDetails: renderRowDetails,
	      onContextMenu: onContextMenu,
	      setCellIndex: setCellIndex,
	      getCellIndex: getCellIndex,
	      sortCells: sortCells,
	      getCellAt: getCellAt,
	      getCellById: getCellById,
	      getCells: getCells,
	      getSortedCells: getSortedCells,
	      getGaps: getGaps,
	      getVirtualizeColumns: getVirtualizeColumns,
	      toggleRowExpand: toggleRowExpand,
	      toggleNodeExpand: toggleNodeExpand,
	      loadNodeAsync: loadNodeAsync,
	      isRowExpandable: isRowExpandable,
	      setRowExpanded: setRowExpanded,
	      setColumnRenderStartIndex: setColumnRenderStartIndex,
	      getPropsForCells: getPropsForCells,
	      onCellStopEdit: onCellStopEdit,
	      onCellStartEdit: onCellStartEdit,
	      onCellEditCancel: onCellEditCancel,
	      onCellEditValueChange: onCellEditValueChange,
	      onCellEditComplete: onCellEditComplete,
	      tryRowCellEdit: tryRowCellEdit,
	      tryNextRowEdit: tryNextRowEdit,
	      onTransitionEnd: onTransitionEnd,
	      getColumnRenderRange: getColumnRenderRange,
	      expandRangeWithColspan: expandRangeWithColspan,
	      renderRow: renderRow,
	      onClick: onClick,
	      onMouseDown: onMouseDown,
	      getCurrentGaps: getCurrentGaps,
	      totalDataCount: props.totalDataCount,
	      rowProps: rowProps,
	      domRef: domRef,
	      props: props
	    };
	  });
	  var rowHeight = props.rowHeight,
	    initialRowHeight = props.initialRowHeight,
	    maxRowHeight = props.maxRowHeight,
	    groupNestingSize = props.groupNestingSize,
	    summaryProps = props.summaryProps,
	    data = props.data,
	    id = props.id,
	    columns = props.columns,
	    minWidth = props.minWidth,
	    maxWidth = props.maxWidth,
	    rowStyle = props.rowStyle,
	    scrollbars = props.scrollbars,
	    renderRow = props.renderRow,
	    computedRowExpandEnabled = props.computedRowExpandEnabled,
	    even = props.even,
	    odd = props.odd,
	    active = props.active,
	    selected = props.selected,
	    expanded = props.expanded,
	    passedProps = props.passedProps,
	    realIndex = props.realIndex,
	    remoteRowIndex = props.remoteRowIndex,
	    nativeScroll = props.nativeScroll,
	    indexInGroup = props.indexInGroup,
	    naturalRowHeight = props.naturalRowHeight,
	    rowDetailsStyle = props.rowDetailsStyle,
	    renderDetailsGrid = props.renderDetailsGrid,
	    last = props.last,
	    empty = props.empty,
	    computedPivot = props.computedPivot,
	    computedShowZebraRows = props.computedShowZebraRows,
	    rowDetailsWidth = props.rowDetailsWidth,
	    availableWidth = props.availableWidth,
	    groupProps = props.groupProps,
	    groupColumn = props.groupColumn,
	    dataSourceArray = props.dataSourceArray,
	    onRenderRow = props.onRenderRow,
	    shouldRenderCollapsedRowDetails = props.shouldRenderCollapsedRowDetails,
	    editing = props.editing,
	    rtl = props.rtl,
	    sticky = props.sticky,
	    hasLockedEnd = props.hasLockedEnd,
	    hasLockedStart = props.hasLockedStart,
	    showHorizontalCellBorders = props.showHorizontalCellBorders,
	    disabledRow = props.disabledRow,
	    rowspanZIndex = props.rowspanZIndex,
	    focusedRow = props.focusedRow,
	    rowFocusClassName = props.rowFocusClassName;
	  var rowClassName = props.rowClassName;
	  var virtualizeColumns = getVirtualizeColumns();
	  var lastInGroup = indexInGroup == props.groupCount - 1;
	  var hasRowSpan = props.computedRowspans && Object.keys(props.computedRowspans).map(function (name) {
	    var rowspan = props.computedRowspans[name];
	    return rowspan > 1;
	  }).find(function (rowSpan) {
	    return rowSpan === true;
	  });
	  var className = (0, _join.default)(props.className, CLASS_NAME, scrollingInProgress.current && "".concat(CLASS_NAME, "--scrolling"), empty && "".concat(CLASS_NAME, "--empty"), editing && "".concat(CLASS_NAME, "--editing"), "".concat(CLASS_NAME, "--direction-").concat(rtl ? 'rtl' : 'ltr'), computedShowZebraRows && even && (!groupProps || computedPivot) && "".concat(CLASS_NAME, "--even"), computedShowZebraRows && odd && (!groupProps || computedPivot) && "".concat(CLASS_NAME, "--odd"), !computedShowZebraRows && !groupProps && "".concat(CLASS_NAME, "--no-zebra"), groupProps && "".concat(CLASS_NAME, "--group-row"), summaryProps && "".concat(CLASS_NAME, "--summary-row"), summaryProps && "".concat(CLASS_NAME, "--summary-position-").concat(summaryProps.position), groupProps && groupProps.collapsed && "".concat(CLASS_NAME, "--collapsed"), selected && "".concat(CLASS_NAME, "--selected"), expanded && "".concat(CLASS_NAME, "--expanded"), hasLockedStart ? "".concat(CLASS_NAME, "--has-locked-start") : "".concat(CLASS_NAME, "--no-locked-start"), hasLockedEnd ? "".concat(CLASS_NAME, "--has-locked-end") : "".concat(CLASS_NAME, "--no-locked-end"), showHorizontalCellBorders && "".concat(CLASS_NAME, "--show-horizontal-borders"), active && "".concat(CLASS_NAME, "--active"), virtualizeColumns && "".concat(CLASS_NAME, "--virtualize-columns"), rowHeight && "".concat(CLASS_NAME, "--rowheight"), naturalRowHeight && "".concat(CLASS_NAME, "--natural-rowheight"), realIndex == 0 && "".concat(CLASS_NAME, "--first"), last && "".concat(CLASS_NAME, "--last"), indexInGroup == 0 && "".concat(CLASS_NAME, "--first-in-group"), lastInGroup && "".concat(CLASS_NAME, "--last-in-group"), disabledRow ? "".concat(CLASS_NAME, "--disabled") : '', focusedRow ? (0, _join.default)("".concat(CLASS_NAME, "--focused"), rowFocusClassName ? rowFocusClassName : '') : '');
	  if (passedProps) {
	    className = (0, _join.default)(className, selected && passedProps.selectedClassName);
	  }
	  var style = _objectSpread(_objectSpread({}, props.style), {}, {
	    height: naturalRowHeight ? null : rowHeight,
	    width: props.width,
	    minWidth: minWidth,
	    direction: 'ltr'
	  });
	  if (hasRowSpan) {
	    style.zIndex = rowspanZIndex;
	  }
	  if (maxWidth != null) {
	    style.maxWidth = maxWidth;
	  }
	  if (maxRowHeight != null) {
	    style.maxHeight = maxRowHeight;
	  }
	  if (rowStyle) {
	    if (typeof rowStyle === 'function') {
	      var rowStyleResult = rowStyle({
	        data: data,
	        props: props,
	        style: style
	      });
	      if (rowStyleResult !== undefined) {
	        style = _objectSpread(_objectSpread({}, style), rowStyleResult);
	      }
	    } else {
	      style = _objectSpread(_objectSpread({}, style), rowStyle);
	    }
	  }
	  if (rowClassName) {
	    if (typeof rowClassName === 'function') {
	      rowClassName = rowClassName({
	        data: data,
	        props: props,
	        className: className
	      });
	    }
	    if (rowClassName && typeof rowClassName == 'string') {
	      className = (0, _join.default)(className, rowClassName);
	    }
	  }
	  var rowProps = _objectSpread(_objectSpread(_objectSpread({}, props), {}, {
	    className: className,
	    style: style,
	    ref: domRef
	  }, passedProps), {}, {
	    onClick: !disabledRow ? onClick : null,
	    onDoubleClick: !disabledRow ? onDoubleClick : null,
	    onContextMenu: !disabledRow ? onContextMenu : null,
	    onMouseUp: !disabledRow ? onMouseUp : null
	  });
	  rowProps.children = [_react.default.createElement("div", {
	    key: "cellWrap",
	    className: "InovuaReactDataGrid__row-cell-wrap InovuaReactDataGrid__row-hover-target",
	    style: {
	      width: props.width,
	      height: naturalRowHeight ? null : rowHeight,
	      position: 'absolute',
	      top: 0,
	      left: rtl ? -(props.emptyScrollOffset || 0) : 0
	    }
	  }, renderRowInstance(data, columns, style))];
	  var groupDepth = groupColumn ? 0 : data && data.__group ? data.depth - 1 : data && data.__summary ? rowProps.summaryProps.depth : props.depth || 0;
	  var activeBordersDiv = sticky ? _react.default.createElement("div", {
	    key: "active-row-borders",
	    className: (0, _join.default)("".concat(CLASS_NAME, "-active-borders"), hasBorderTop.current && "".concat(CLASS_NAME, "-active-borders--has-border-top"), hasBorderBottom.current && "".concat(CLASS_NAME, "-actived-borders--has-border-bottom"))
	  }) : null;
	  var shouldRender = expanded || shouldRenderCollapsedRowDetails;
	  if (computedRowExpandEnabled && shouldRender && !data.__group) {
	    var rowDetailsInfo = {
	      data: data,
	      rtl: rtl,
	      isRowExpandable: isRowExpandable,
	      rowIndex: realIndex,
	      remoteRowIndex: remoteRowIndex,
	      rowId: props.getItemId(data),
	      rowExpanded: expanded,
	      id: id,
	      rowSelected: selected,
	      rowActive: active,
	      toggleRowExpand: toggleRowExpand,
	      setRowExpanded: setRowExpanded,
	      dataSource: dataSourceArray
	    };
	    var detailsStyle = {
	      position: 'absolute',
	      height: rowHeight - initialRowHeight,
	      overflow: renderDetailsGrid ? 'visible' : 'auto',
	      top: initialRowHeight
	    };
	    if (rtl) {
	      detailsStyle.direction = 'rtl';
	    }
	    if (rowDetailsWidth == 'max-viewport-width') {
	      detailsStyle.width = Math.min(availableWidth, props.width || maxWidth);
	    }
	    if (rowDetailsWidth === 'min-viewport-width') {
	      detailsStyle.width = Math.max(availableWidth, props.width || maxWidth);
	    }
	    if (rowDetailsWidth === 'viewport-width') {
	      detailsStyle.width = availableWidth;
	    }
	    if (groupDepth) {
	      detailsStyle[rtl ? 'paddingRight' : 'paddingLeft'] = (groupNestingSize || 0) * groupDepth;
	    }
	    detailsStyle[rtl ? 'right' : 'left'] = 0;
	    if (isNaN(detailsStyle.width)) {
	      delete detailsStyle.width;
	    }
	    if (!expanded) {
	      detailsStyle.display = 'none';
	    }
	    if (rowProps.memorizedScrollLeft && rowDetailsWidth !== 'min-viewport-width') {
	      var scrollLeftMax = rowProps.getScrollLeftMax && rowProps.getScrollLeftMax();
	      var scrollLeft = !rtl ? rowProps.memorizedScrollLeft : -(scrollLeftMax - rowProps.memorizedScrollLeft);
	      detailsStyle.transform = "translate3d(".concat(scrollLeft, "px, 0px, 0px)");
	    }
	    if (rowDetailsStyle) {
	      if (typeof rowDetailsStyle === 'function') {
	        var styleResult = rowDetailsStyle(detailsStyle, rowDetailsInfo);
	        if (styleResult !== undefined) {
	          detailsStyle = styleResult;
	        }
	      } else {
	        detailsStyle = _objectSpread(_objectSpread({}, detailsStyle), rowDetailsStyle);
	      }
	    }
	    var showBorderBottom = !lastInGroup || last;
	    if (nativeScroll && last && expanded) {
	      showBorderBottom = false;
	    }
	    rowProps.children.push(_react.default.createElement("div", {
	      key: "rowDetails",
	      style: detailsStyle,
	      onClick: skipSelect,
	      className: (0, _join.default)("".concat(CLASS_NAME, "-details"), "".concat(CLASS_NAME, "-details--").concat(rowDetailsWidth), renderDetailsGrid ? "".concat(CLASS_NAME, "-details--details-grid") : null, !nativeScroll || nativeScroll && scrollbars && !scrollbars.vertical || availableWidth > minWidth ? "".concat(CLASS_NAME, "-details--show-border-right") : null, showBorderBottom ? "".concat(CLASS_NAME, "-details--show-border-bottom") : '')
	    }, renderRowDetails(rowDetailsInfo)), _react.default.createElement("div", {
	      className: "".concat(CLASS_NAME, "-details-special-bottom-border"),
	      key: "row-details-special-bottom-border",
	      style: (0, _defineProperty2.default)({}, rtl ? 'right' : 'left', (groupDepth || 0) * groupNestingSize)
	    }), groupDepth ? (0, _toConsumableArray2.default)(new Array(groupDepth)).map(function (_, index) {
	      var _style2;
	      return _react.default.createElement("div", {
	        key: index,
	        className: "".concat(CLASS_NAME, "-details-border"),
	        style: (_style2 = {
	          height: '100%',
	          position: 'absolute'
	        }, (0, _defineProperty2.default)(_style2, rtl ? 'right' : 'left', (index + 1) * groupNestingSize), (0, _defineProperty2.default)(_style2, "top", 0), _style2)
	      });
	    }) : null, rowDetailsWidth != 'max-viewport-width' ? _react.default.createElement("div", {
	      key: "rowDetailsBorder",
	      style: (0, _defineProperty2.default)({
	        top: initialRowHeight - 1,
	        width: availableWidth
	      }, rtl ? 'right' : 'left', (groupDepth || 0) * groupNestingSize),
	      className: "".concat(CLASS_NAME, "-details-special-top-border")
	    }) : null);
	  }
	  if (sticky) {
	    if (activeBordersDiv) {
	      var _style4;
	      rowProps.children.push(_react.default.createElement("div", {
	        key: "active-row-borders",
	        className: "InovuaReactDataGrid__row-active-borders-wrapper",
	        style: (_style4 = {
	          height: '100%',
	          position: 'absolute',
	          top: 0
	        }, (0, _defineProperty2.default)(_style4, rtl ? 'right' : 'left', (groupNestingSize || 0) * groupDepth), (0, _defineProperty2.default)(_style4, "width", availableWidth - (groupNestingSize || 0) * groupDepth), (0, _defineProperty2.default)(_style4, "pointerEvents", 'none'), _style4)
	      }, activeBordersDiv));
	    }
	  }
	  var row;
	  if (renderRow) {
	    row = renderRow(rowProps);
	  }
	  if (onRenderRow) {
	    onRenderRow(rowProps);
	  }
	  if (row === undefined) {
	    row = _react.default.createElement("div", _objectSpread(_objectSpread({}, (0, _reactCleanProps.default)(rowProps, DataGridRow.propTypes)), {}, {
	      id: null,
	      data: null,
	      value: null
	    }));
	  }
	  return row;
	});
	var emptyFn = function emptyFn() {};
	DataGridRow.defaultProps = {
	  onClick: emptyFn,
	  onMouseEnter: emptyFn,
	  onMouseLeave: emptyFn,
	  onMouseDown: emptyFn,
	  columnRenderStartIndex: 0,
	  showAllGroupCells: false
	};
	DataGridRow.propTypes = {
	  rowActive: _propTypes.default.bool,
	  rowSelected: _propTypes.default.bool,
	  availableWidth: _propTypes.default.number,
	  computedGroupBy: _propTypes.default.array,
	  expandGroupTitle: _propTypes.default.bool,
	  expandColumn: _propTypes.default.any,
	  getCellSelectionKey: _propTypes.default.func,
	  depth: _propTypes.default.number,
	  columns: _propTypes.default.array,
	  columnsMap: _propTypes.default.shape({}),
	  active: _propTypes.default.bool,
	  computedActiveCell: _propTypes.default.any,
	  cellFactory: _propTypes.default.func,
	  computedCellMultiSelectionEnabled: _propTypes.default.bool,
	  computedCellSelection: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
	  columnRenderCount: _propTypes.default.number,
	  columnRenderStartIndex: _propTypes.default.number,
	  columnUserSelect: _propTypes.default.bool,
	  deselectAll: _propTypes.default.func,
	  empty: _propTypes.default.bool,
	  even: _propTypes.default.bool,
	  firstLockedEndIndex: _propTypes.default.number,
	  firstLockedStartIndex: _propTypes.default.number,
	  firstUnlockedIndex: _propTypes.default.number,
	  flex: _propTypes.default.number,
	  groupCount: _propTypes.default.number,
	  groupNestingSize: _propTypes.default.number,
	  treeNestingSize: _propTypes.default.number,
	  groupProps: _propTypes.default.object,
	  summaryProps: _propTypes.default.object,
	  hasLockedEnd: _propTypes.default.bool,
	  hasLockedStart: _propTypes.default.bool,
	  indexInGroup: _propTypes.default.number,
	  last: _propTypes.default.bool,
	  lastCellInRange: _propTypes.default.any,
	  lastNonEmpty: _propTypes.default.bool,
	  lastRowInGroup: _propTypes.default.bool,
	  lockedEndColumns: _propTypes.default.array,
	  lockedStartColumns: _propTypes.default.array,
	  maxRowHeight: _propTypes.default.number,
	  minRowHeight: _propTypes.default.number,
	  maxVisibleRows: _propTypes.default.number,
	  minWidth: _propTypes.default.number,
	  multiSelect: _propTypes.default.bool,
	  odd: _propTypes.default.bool,
	  onArrowDown: _propTypes.default.func,
	  onArrowUp: _propTypes.default.func,
	  onCellClick: _propTypes.default.func,
	  onCellDoubleClick: _propTypes.default.func,
	  onRowDoubleClick: _propTypes.default.func,
	  onCellEnter: _propTypes.default.func,
	  onCellMouseDown: _propTypes.default.func,
	  onCellSelectionDraggerMouseDown: _propTypes.default.func,
	  onRowContextMenu: _propTypes.default.func,
	  passedProps: _propTypes.default.object,
	  realIndex: _propTypes.default.number,
	  renderIndex: _propTypes.default.number,
	  renderRow: _propTypes.default.func,
	  onRenderRow: _propTypes.default.func,
	  rowHeight: _propTypes.default.number,
	  rowExpandHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.func]),
	  initialRowHeight: _propTypes.default.number,
	  defaultRowHeight: _propTypes.default.number,
	  emptyScrollOffset: _propTypes.default.number,
	  rowIndex: _propTypes.default.number,
	  remoteRowIndex: _propTypes.default.number,
	  rowIndexInGroup: _propTypes.default.bool,
	  rowStyle: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	  rowClassName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	  scrollLeft: _propTypes.default.number,
	  selectAll: _propTypes.default.func,
	  selected: _propTypes.default.bool,
	  expanded: _propTypes.default.bool,
	  selection: _propTypes.default.any,
	  computedRowExpandEnabled: _propTypes.default.bool,
	  computedTreeEnabled: _propTypes.default.bool,
	  computedRenderRowDetails: _propTypes.default.func,
	  isRowExpandableAt: _propTypes.default.func,
	  setRowSelected: _propTypes.default.func,
	  setRowExpanded: _propTypes.default.func,
	  toggleRowExpand: _propTypes.default.func,
	  toggleNodeExpand: _propTypes.default.func,
	  expandOnMouseDown: _propTypes.default.bool,
	  loadNodeAsync: _propTypes.default.func,
	  showAllGroupCells: _propTypes.default.bool,
	  computedShowCellBorders: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
	  showHorizontalCellBorders: _propTypes.default.bool,
	  showVerticalCellBorders: _propTypes.default.bool,
	  totalColumnCount: _propTypes.default.number,
	  totalComputedWidth: _propTypes.default.number,
	  totalDataCount: _propTypes.default.number,
	  totalLockedEndWidth: _propTypes.default.number,
	  totalLockedStartWidth: _propTypes.default.number,
	  totalUnlockedWidth: _propTypes.default.number,
	  unlockedColumns: _propTypes.default.array,
	  virtualizeColumns: _propTypes.default.bool,
	  nativeScroll: _propTypes.default.bool,
	  shouldRenderCollapsedRowDetails: _propTypes.default.bool,
	  rowDetailsStyle: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
	  dataSourceArray: _propTypes.default.array,
	  getItemId: _propTypes.default.func.isRequired,
	  editable: _propTypes.default.bool,
	  editing: _propTypes.default.bool,
	  editValue: _propTypes.default.any,
	  editRowIndex: _propTypes.default.number,
	  editColumnIndex: _propTypes.default.number,
	  editColumnId: _propTypes.default.any,
	  naturalRowHeight: _propTypes.default.bool,
	  renderDetailsGrid: _propTypes.default.func,
	  scrollToColumn: _propTypes.default.func,
	  scrollToIndexIfNeeded: _propTypes.default.func,
	  renderNodeTool: _propTypes.default.func,
	  computedEnableRowspan: _propTypes.default.bool,
	  setRowSpan: _propTypes.default.func,
	  treeColumn: _propTypes.default.string,
	  scrollbars: _propTypes.default.shape({
	    horizontal: _propTypes.default.bool,
	    vertical: _propTypes.default.bool
	  }),
	  rtl: _propTypes.default.bool,
	  computedPivot: _propTypes.default.array,
	  groupColumnSummaries: _propTypes.default.any,
	  groupSummary: _propTypes.default.any,
	  groupColumn: _propTypes.default.any,
	  lastUnlockedIndex: _propTypes.default.number,
	  lastLockedEndIndex: _propTypes.default.number,
	  lastLockedStartIndex: _propTypes.default.number,
	  computedShowZebraRows: _propTypes.default.bool,
	  computedRowspans: _propTypes.default.any,
	  editStartEvent: _propTypes.default.string,
	  onGroupToggle: _propTypes.default.func,
	  onEditStop: _propTypes.default.func,
	  onEditStart: _propTypes.default.func,
	  onEditCancel: _propTypes.default.func,
	  onEditValueChange: _propTypes.default.func,
	  onEditComplete: _propTypes.default.func,
	  onFilterValueChange: _propTypes.default.func,
	  tryNextRowEdit: _propTypes.default.func,
	  getScrollLeftMax: _propTypes.default.func,
	  activeRowRef: _propTypes.default.any,
	  sticky: _propTypes.default.bool,
	  edition: _propTypes.default.string,
	  computedLicenseValid: _propTypes.default.bool,
	  parentGroupDataArray: _propTypes.default.any,
	  rowDetailsWidth: _propTypes.default.oneOf(['max-viewport-width', 'min-viewport-width', 'viewport-width']),
	  memorizedScrollLeft: _propTypes.default.number,
	  computedHasColSpan: _propTypes.default.bool,
	  onRowReorder: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool]),
	  onDragRowMouseDown: _propTypes.default.func,
	  renderLockedStartCells: _propTypes.default.func,
	  renderLockedEndCells: _propTypes.default.func,
	  setActiveIndex: _propTypes.default.func,
	  renderTreeCollapseTool: _propTypes.default.func,
	  renderTreeExpandTool: _propTypes.default.func,
	  renderTreeLoadingTool: _propTypes.default.func,
	  currentEditCompletePromise: _propTypes.default.any,
	  enableColumnAutosize: _propTypes.default.bool,
	  columnHoverClassName: _propTypes.default.string,
	  computedEnableColumnHover: _propTypes.default.bool,
	  onColumnMouseEnter: _propTypes.default.func,
	  onColumnMouseLeave: _propTypes.default.func,
	  columnIndexHovered: _propTypes.default.number,
	  renderRowDetailsExpandIcon: _propTypes.default.func,
	  renderRowDetailsCollapsedIcon: _propTypes.default.func,
	  renderGroupCollapseTool: _propTypes.default.func,
	  renderGroupExpandTool: _propTypes.default.func,
	  disabledRow: _propTypes.default.bool,
	  rowspanZIndex: _propTypes.default.number,
	  onRowFocus: _propTypes.default.func,
	  onRowBlur: _propTypes.default.func,
	  onRowKeyDown: _propTypes.default.func,
	  focusedRow: _propTypes.default.bool,
	  rowFocusClassName: _propTypes.default.string,
	  onCellBulkUpdateMouseDown: _propTypes.default.func,
	  onCellBulkUpdateMouseUp: _propTypes.default.func,
	  bulkUpdateMouseDown: _propTypes.default.bool
	};
	var _default = _react.default.memo(DataGridRow, function (prevProps, nextProps) {
	  var areEqual = (0, _shallowequal.equalReturnKey)(prevProps, nextProps, {
	    computedActiveCell: 1,
	    computedActiveIndex: 1,
	    columnRenderStartIndex: 1,
	    activeRowRef: 1,
	    active: 1,
	    onKeyDown: 1,
	    onFocus: 1,
	    setRowSpan: 1,
	    passedProps: 1,
	    computedRowspans: 1,
	    lockedStartColumns: 1,
	    selection: 1,
	    lockedEndColumns: 1,
	    unlockedColumns: 1,
	    maxVisibleRows: 1,
	    onClick: 1,
	    style: 1,
	    loadNodeAsync: 1,
	    scrollToIndexIfNeeded: 1,
	    onColumnMouseEnter: 1,
	    onColumnMouseLeave: 1,
	    getCellSelectionKey: 1
	  });
	  if (areEqual.result) {
	    if (prevProps.computedActiveCell != nextProps.computedActiveCell) {
	      var _ref2 = prevProps.computedActiveCell || [],
	        _ref3 = (0, _slicedToArray2.default)(_ref2, 1),
	        oldRowIndex = _ref3[0];
	      var _ref4 = nextProps.computedActiveCell || [],
	        _ref5 = (0, _slicedToArray2.default)(_ref4, 1),
	        newRowIndex = _ref5[0];
	      if (oldRowIndex === nextProps.rowIndex || newRowIndex === nextProps.rowIndex) {
	        return false;
	      }
	    }
	  }
	  if (!areEqual.result) {
	    return false;
	  }
	  if (prevProps.active !== nextProps.active) {
	    return false;
	  }
	  if (JSON.stringify(prevProps.style) !== JSON.stringify(nextProps.style)) {
	    return false;
	  }
	  var prevActiveCellRow, prevActiveColumn;
	  var activeCellRow, activeColumn;
	  if (prevProps.computedActiveCell) {
	    var _prevProps$computedAc = (0, _slicedToArray2.default)(prevProps.computedActiveCell, 2);
	    prevActiveCellRow = _prevProps$computedAc[0];
	    prevActiveColumn = _prevProps$computedAc[1];
	  }
	  if (nextProps.computedActiveCell) {
	    var _nextProps$computedAc = (0, _slicedToArray2.default)(nextProps.computedActiveCell, 2);
	    activeCellRow = _nextProps$computedAc[0];
	    activeColumn = _nextProps$computedAc[1];
	  }
	  if (activeCellRow !== prevActiveCellRow) {
	    if (nextProps.rowIndex === activeCellRow || nextProps.rowIndex === prevActiveCellRow) {
	      return false;
	    }
	  } else {
	    if (nextProps.rowIndex === activeCellRow && activeColumn !== prevActiveColumn) {
	      return false;
	    }
	  }
	  return true;
	});
	exports.default = _default;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _renderGroupTitle = _interopRequireDefault(__webpack_require__(558));
	var _default = function _default(cellProps, rowProps) {
	  var groupProps = rowProps.groupProps,
	    totalLockedStartWidth = rowProps.totalLockedStartWidth,
	    totalLockedEndWidth = rowProps.totalLockedEndWidth,
	    totalUnlockedWidth = rowProps.totalUnlockedWidth,
	    totalComputedWidth = rowProps.totalComputedWidth,
	    totalColumnCount = rowProps.totalColumnCount,
	    firstLockedEndIndex = rowProps.firstLockedEndIndex,
	    firstUnlockedIndex = rowProps.firstUnlockedIndex,
	    groupColumn = rowProps.groupColumn,
	    hasLockedEnd = rowProps.hasLockedEnd,
	    hasLockedStart = rowProps.hasLockedStart;
	  var computedVisibleIndex = cellProps.computedVisibleIndex,
	    computedLocked = cellProps.computedLocked,
	    expandColumnIndex = cellProps.expandColumnIndex;
	  var expandColumn = computedVisibleIndex === expandColumnIndex;
	  var expandGroupTitle = rowProps.expandGroupTitle;
	  if (!hasLockedStart && !hasLockedEnd) {
	    expandGroupTitle = true;
	  }
	  var data = rowProps.data;
	  var lockedStart = computedLocked === 'start';
	  var lockedEnd = computedLocked === 'end';
	  if (groupProps && computedVisibleIndex < groupProps.depth || expandColumnIndex != null && computedVisibleIndex < expandColumnIndex) {
	    cellProps.value = null;
	    cellProps.noBackground = true;
	    return cellProps;
	  }
	  if (computedVisibleIndex === (groupProps === null || groupProps === void 0 ? void 0 : groupProps.depth)) {
	    cellProps.value = null;
	    cellProps.collapsed = groupProps.collapsed;
	    cellProps.textAlign = 'center';
	    cellProps.noBackground = false;
	    cellProps.firstInSection = true;
	    return cellProps;
	  }
	  if (computedVisibleIndex === (groupProps === null || groupProps === void 0 ? void 0 : groupProps.depth) + 1 || expandColumn) {
	    var remainingWidth = lockedStart ? totalLockedStartWidth : totalComputedWidth - totalLockedEndWidth;
	    if (expandGroupTitle || expandColumn) {
	      remainingWidth = totalComputedWidth;
	      cellProps.last = true;
	      cellProps.computedColspan = Math.max(totalColumnCount - computedVisibleIndex, 1);
	    } else {
	      cellProps.computedColspan = Math.max(lockedStart ? firstUnlockedIndex - computedVisibleIndex : lockedEnd ? totalColumnCount - computedVisibleIndex : firstLockedEndIndex - computedVisibleIndex, 1);
	    }
	    cellProps.lastInSection = true;
	    cellProps.noBackground = false;
	    cellProps.computedWidth = remainingWidth - cellProps.computedOffset;
	    if (!expandColumn) {
	      cellProps.value = (0, _renderGroupTitle.default)({
	        cellProps: cellProps,
	        rowProps: rowProps,
	        groupProps: groupProps
	      });
	    }
	    cellProps.zIndex = 1;
	    cellProps.textAlign = 'start';
	    if (cellProps.render) {
	      if (!expandColumn) {
	        cellProps.render = function () {
	          return cellProps.value;
	        };
	      }
	    }
	    return cellProps;
	  }
	  if (lockedStart) {
	    cellProps.hidden = true;
	  } else {
	    var fakeHidden = lockedEnd ? computedVisibleIndex !== firstLockedEndIndex : computedVisibleIndex !== firstUnlockedIndex;
	    if (!cellProps.hidden) {
	      cellProps.textAlign = 'start';
	      cellProps.value = fakeHidden ? null : (0, _renderGroupTitle.default)({
	        cellProps: cellProps,
	        rowProps: rowProps,
	        groupProps: groupProps
	      });
	      if (cellProps.render) {
	        cellProps.render = function () {
	          return cellProps.value;
	        };
	      }
	      cellProps.computedWidth = lockedEnd ? totalLockedEndWidth : totalUnlockedWidth;
	      if (!lockedEnd && computedVisibleIndex >= firstUnlockedIndex + 1) {
	        cellProps.hidden = true;
	      }
	      cellProps.firstInSection = true;
	      cellProps.last = hasLockedEnd ? lockedEnd : true;
	      cellProps.lastInSection = true;
	      cellProps.computedColspan = Math.max(lockedEnd ? totalColumnCount - computedVisibleIndex : firstLockedEndIndex - computedVisibleIndex, 1);
	    }
	  }
	  return cellProps;
	};
	exports.default = _default;

/***/ },
/* 556 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(rowProps) {
	  var rowSpans = {};
	  var data = rowProps.data,
	    rowIndex = rowProps.realIndex,
	    remoteRowIndex = rowProps.remoteRowIndex,
	    columns = rowProps.columns,
	    empty = rowProps.empty,
	    dataSourceArray = rowProps.dataSourceArray;
	  columns === null || columns === void 0 ? void 0 : columns.forEach(function (column) {
	    var name = column.name;
	    var rowspan = column.rowspan;
	    var value = data && name ? data[name] : null;
	    var computedRowspan = 1;
	    if (typeof rowspan === 'function') {
	      computedRowspan = rowspan({
	        dataSourceArray: dataSourceArray,
	        data: data,
	        value: value,
	        remoteRowIndex: remoteRowIndex,
	        rowIndex: rowIndex,
	        column: column,
	        columns: columns,
	        empty: empty
	      });
	      rowSpans[column.id] = computedRowspan;
	    }
	  });
	  return rowSpans;
	};
	exports.default = _default;

/***/ },
/* 557 */
[1295, 553],
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _react = __webpack_require__(2);
	var _uglified = _interopRequireDefault(__webpack_require__(57));
	var emptyObject = {};
	var isValid = function isValid(value) {
	  if (value == null) {
	    return true;
	  }
	  if (Array.isArray(value)) {
	    return true;
	  }
	  var type = (0, _typeof2.default)(value);
	  if (type == 'string' || type == 'number') {
	    return true;
	  }
	  return (0, _react.isValidElement)(value);
	};
	var _default = function _default(_ref) {
	  var cellProps = _ref.cellProps,
	    rowProps = _ref.rowProps;
	  var computedLocked = cellProps.computedLocked;
	  var data = rowProps.data,
	    _rowProps$groupProps = rowProps.groupProps,
	    groupProps = _rowProps$groupProps === void 0 ? emptyObject : _rowProps$groupProps,
	    hasLockedStart = rowProps.hasLockedStart;
	  var renderGroupTitle = computedLocked === 'start' || !hasLockedStart && !computedLocked ? groupProps.renderGroupTitle : computedLocked === 'end' ? groupProps.renderLockedEndGroupTitle : groupProps.renderUnlockedGroupTitle;
	  var groupColId;
	  if (rowProps.data.fieldPath && rowProps.data.fieldPath.length) {
	    groupColId = rowProps.data.fieldPath[rowProps.data.fieldPath.length - 1];
	  }
	  groupColId = groupColId || rowProps.data.name || rowProps.data.id;
	  var col = rowProps.columnsMap[groupColId];
	  if (col && col.renderGroupTitle) {
	    return col.renderGroupTitle(rowProps.data.value, rowProps);
	  }
	  if (renderGroupTitle) {
	    return renderGroupTitle(rowProps.data.value, rowProps);
	  }
	  if (col && col.groupToString) {
	    return col.groupToString(rowProps.data.value, {
	      data: rowProps.data,
	      fieldName: col.name,
	      renderGroupTitle: true
	    });
	  }
	  if (computedLocked === 'start') {
	    if (!_uglified.default && !isValid(data.value)) {
	      return "Invalid group title for column \"".concat(groupColId, "\". Use \"renderGroupTitle\" column prop.");
	    }
	    return data.value;
	  }
	  if (!hasLockedStart && !computedLocked) {
	    if (!_uglified.default && !isValid(data.value)) {
	      return "Invalid group title for column \"".concat(groupColId, "\". Use \"renderGroupTitle\" column prop.");
	    }
	    return data.value;
	  }
	  return null;
	};
	exports.default = _default;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _Row = _interopRequireDefault(__webpack_require__(554));
	var _getRowSpans = _interopRequireDefault(__webpack_require__(556));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var emptyObject = Object.freeze ? Object.freeze({}) : {};
	var renderRows = function renderRows(_ref, _ref2) {
	  var from = _ref.from,
	    to = _ref.to,
	    empty = _ref.empty,
	    renderIndex = _ref.renderIndex,
	    editRowIndex = _ref.editRowIndex,
	    editValue = _ref.editValue,
	    editColumnIndex = _ref.editColumnIndex,
	    editColumnId = _ref.editColumnId,
	    setRowSpan = _ref.setRowSpan,
	    sticky = _ref.sticky,
	    rowHeight = _ref.rowHeight,
	    tryNextRowEdit = _ref.tryNextRowEdit,
	    onEditStop = _ref.onEditStop,
	    onEditStart = _ref.onEditStart,
	    onEditValueChange = _ref.onEditValueChange,
	    scrollLeft = _ref.scrollLeft,
	    columnRenderCount = _ref.columnRenderCount,
	    columnRenderStartIndex = _ref.columnRenderStartIndex,
	    memorizedScrollLeft = _ref.memorizedScrollLeft;
	  var availableWidth = _ref2.availableWidth,
	    data = _ref2.data,
	    onTransitionEnd = _ref2.onTransitionEnd,
	    columns = _ref2.columns,
	    computedPivot = _ref2.computedPivot,
	    groupColumn = _ref2.groupColumn,
	    activeRowRef = _ref2.activeRowRef,
	    columnsMap = _ref2.columnsMap,
	    renderLockedStartCells = _ref2.renderLockedStartCells,
	    renderLockedEndCells = _ref2.renderLockedEndCells,
	    computedOnCellMouseDown = _ref2.computedOnCellMouseDown,
	    computedEnableRowspan = _ref2.computedEnableRowspan,
	    lockedStartColumns = _ref2.lockedStartColumns,
	    lockedEndColumns = _ref2.lockedEndColumns,
	    renderDetailsGrid = _ref2.renderDetailsGrid,
	    editable = _ref2.editable,
	    rowDetailsWidth = _ref2.rowDetailsWidth,
	    scrollbars = _ref2.scrollbars,
	    scrollToColumn = _ref2.scrollToColumn,
	    scrollToIndexIfNeeded = _ref2.scrollToIndexIfNeeded,
	    hasLockedStart = _ref2.hasLockedStart,
	    hasLockedEnd = _ref2.hasLockedEnd,
	    computedShowEmptyRows = _ref2.computedShowEmptyRows,
	    setRowSelected = _ref2.setRowSelected,
	    setRowExpanded = _ref2.setRowExpanded,
	    toggleRowExpand = _ref2.toggleRowExpand,
	    toggleNodeExpand = _ref2.toggleNodeExpand,
	    expandOnMouseDown = _ref2.expandOnMouseDown,
	    loadNodeAsync = _ref2.loadNodeAsync,
	    computedTreeEnabled = _ref2.computedTreeEnabled,
	    computedActiveCell = _ref2.computedActiveCell,
	    rtl = _ref2.rtl,
	    naturalRowHeight = _ref2.naturalRowHeight,
	    lastCellInRange = _ref2.lastCellInRange,
	    getCellSelectionKey = _ref2.getCellSelectionKey,
	    onRowContextMenu = _ref2.onRowContextMenu,
	    columnUserSelect = _ref2.columnUserSelect,
	    selectAll = _ref2.selectAll,
	    deselectAll = _ref2.deselectAll,
	    expandGroupTitle = _ref2.expandGroupTitle,
	    expandColumn = _ref2.expandColumn,
	    computedCellSelection = _ref2.computedCellSelection,
	    lastLockedStartIndex = _ref2.lastLockedStartIndex,
	    lastLockedEndIndex = _ref2.lastLockedEndIndex,
	    lastUnlockedIndex = _ref2.lastUnlockedIndex,
	    computedGroupBy = _ref2.computedGroupBy,
	    computedIndexesInGroups = _ref2.computedIndexesInGroups,
	    edition = _ref2.edition,
	    computedLicenseValid = _ref2.computedLicenseValid,
	    computedGroupCounts = _ref2.computedGroupCounts,
	    rowHeightManager = _ref2.rowHeightManager,
	    maxRowHeight = _ref2.maxRowHeight,
	    minRowHeight = _ref2.minRowHeight,
	    editStartEvent = _ref2.editStartEvent,
	    getItemId = _ref2.getItemId,
	    firstUnlockedIndex = _ref2.firstUnlockedIndex,
	    firstLockedStartIndex = _ref2.firstLockedStartIndex,
	    firstLockedEndIndex = _ref2.firstLockedEndIndex,
	    maxVisibleRows = _ref2.maxVisibleRows,
	    onRowMouseEnter = _ref2.onRowMouseEnter,
	    onRowMouseLeave = _ref2.onRowMouseLeave,
	    computedOnRowClick = _ref2.computedOnRowClick,
	    computedRowDoubleClick = _ref2.computedRowDoubleClick,
	    onCellClick = _ref2.onCellClick,
	    computedCellDoubleClick = _ref2.computedCellDoubleClick,
	    onCellSelectionDraggerMouseDown = _ref2.onCellSelectionDraggerMouseDown,
	    onCellEnter = _ref2.onCellEnter,
	    onColumnMouseEnter = _ref2.onColumnMouseEnter,
	    onColumnMouseLeave = _ref2.onColumnMouseLeave,
	    columnIndexHovered = _ref2.columnIndexHovered,
	    onEditCancel = _ref2.onEditCancel,
	    onEditComplete = _ref2.onEditComplete,
	    computedCellMultiSelectionEnabled = _ref2.computedCellMultiSelectionEnabled,
	    nativeScroll = _ref2.nativeScroll,
	    renderRow = _ref2.renderRow,
	    onRenderRow = _ref2.onRenderRow,
	    rowClassName = _ref2.rowClassName,
	    rowStyle = _ref2.rowStyle,
	    rowFactory = _ref2.rowFactory,
	    _ref2$rowProps = _ref2.rowProps,
	    passedProps = _ref2$rowProps === void 0 ? emptyObject : _ref2$rowProps,
	    rowKey = _ref2.rowKey,
	    cellFactory = _ref2.cellFactory,
	    computedSelected = _ref2.computedSelected,
	    computedUnselected = _ref2.computedUnselected,
	    treeColumn = _ref2.treeColumn,
	    renderNodeTool = _ref2.renderNodeTool,
	    renderTreeCollapseTool = _ref2.renderTreeCollapseTool,
	    renderTreeExpandTool = _ref2.renderTreeExpandTool,
	    renderGroupCollapseTool = _ref2.renderGroupCollapseTool,
	    renderGroupExpandTool = _ref2.renderGroupExpandTool,
	    renderTreeLoadingTool = _ref2.renderTreeLoadingTool,
	    rowExpandHeight = _ref2.rowExpandHeight,
	    isRowExpandedById = _ref2.isRowExpandedById,
	    computedRenderRowDetails = _ref2.computedRenderRowDetails,
	    isRowExpandableAt = _ref2.isRowExpandableAt,
	    computedRowExpandEnabled = _ref2.computedRowExpandEnabled,
	    computedRowMultiSelectionEnabled = _ref2.computedRowMultiSelectionEnabled,
	    computedRowSelectionEnabled = _ref2.computedRowSelectionEnabled,
	    computedActiveIndex = _ref2.computedActiveIndex,
	    computedSkip = _ref2.computedSkip,
	    computedShowZebraRows = _ref2.computedShowZebraRows,
	    computedHasColSpan = _ref2.computedHasColSpan,
	    initialRowHeight = _ref2.rowHeight,
	    totalColumnCount = _ref2.totalColumnCount,
	    totalComputedWidth = _ref2.totalComputedWidth,
	    totalLockedStartWidth = _ref2.totalLockedStartWidth,
	    totalLockedEndWidth = _ref2.totalLockedEndWidth,
	    totalUnlockedWidth = _ref2.totalUnlockedWidth,
	    currentDataSourceCount = _ref2.currentDataSourceCount,
	    computedShowCellBorders = _ref2.computedShowCellBorders,
	    emptyScrollOffset = _ref2.emptyScrollOffset,
	    showHorizontalCellBorders = _ref2.showHorizontalCellBorders,
	    showVerticalCellBorders = _ref2.showVerticalCellBorders,
	    getScrollLeftMax = _ref2.getScrollLeftMax,
	    shouldRenderCollapsedRowDetails = _ref2.shouldRenderCollapsedRowDetails,
	    rowDetailsStyle = _ref2.rowDetailsStyle,
	    minRowWidth = _ref2.minRowWidth,
	    maxWidth = _ref2.maxWidth,
	    _ref2$startIndex = _ref2.startIndex,
	    startIndex = _ref2$startIndex === void 0 ? 0 : _ref2$startIndex,
	    groupNestingSize = _ref2.groupNestingSize,
	    treeNestingSize = _ref2.treeNestingSize,
	    onGroupToggle = _ref2.onGroupToggle,
	    computedCollapsedGroups = _ref2.computedCollapsedGroups,
	    computedExpandedGroups = _ref2.computedExpandedGroups,
	    groupPathSeparator = _ref2.groupPathSeparator,
	    renderGroupTitle = _ref2.renderGroupTitle,
	    renderGroupTool = _ref2.renderGroupTool,
	    renderLockedEndGroupTitle = _ref2.renderLockedEndGroupTitle,
	    renderUnlockedGroupTitle = _ref2.renderUnlockedGroupTitle,
	    virtualizeColumns = _ref2.virtualizeColumns,
	    computedLivePagination = _ref2.computedLivePagination,
	    onRowReorder = _ref2.onRowReorder,
	    onDragRowMouseDown = _ref2.onDragRowMouseDown,
	    theme = _ref2.theme,
	    onContextMenu = _ref2.onContextMenu,
	    setActiveIndex = _ref2.setActiveIndex,
	    currentEditCompletePromise = _ref2.currentEditCompletePromise,
	    enableColumnAutosize = _ref2.enableColumnAutosize,
	    columnHoverClassName = _ref2.columnHoverClassName,
	    computedEnableColumnHover = _ref2.computedEnableColumnHover,
	    renderRowDetailsExpandIcon = _ref2.renderRowDetailsExpandIcon,
	    renderRowDetailsCollapsedIcon = _ref2.renderRowDetailsCollapsedIcon,
	    computedOnRowMouseDown = _ref2.computedOnRowMouseDown,
	    disabledRows = _ref2.disabledRows,
	    rowFocusClassName = _ref2.rowFocusClassName,
	    computedCellBulkUpdateMouseDown = _ref2.computedCellBulkUpdateMouseDown,
	    computedCellBulkUpdateMouseUp = _ref2.computedCellBulkUpdateMouseUp,
	    bulkUpdateMouseDown = _ref2.bulkUpdateMouseDown;
	  var remoteOffset = computedLivePagination ? 0 : computedSkip || 0;
	  var totalCount = data.length;
	  var dataArray = data.slice(from, to);
	  var isGrouped = computedGroupBy && computedGroupBy.length;
	  var defaultRowHeight = rowHeightManager.getDefaultRowHeight();
	  if (computedShowEmptyRows && !dataArray.length) {
	    dataArray = [null];
	  }
	  var depth = null;
	  if (isGrouped) {
	    depth = computedGroupBy.length;
	  }
	  return dataArray.map(function (rowData, i) {
	    var index = i + startIndex;
	    var id = rowData ? getItemId(rowData) : i;
	    var realIndex = index + from;
	    var active = computedActiveIndex === realIndex;
	    var focusedRow = computedActiveIndex === realIndex;
	    var indexInGroup = isGrouped ? computedIndexesInGroups[realIndex] : null;
	    if (empty) {
	      indexInGroup = realIndex + (totalCount % 2 - 1);
	    }
	    var keyIndex = rowKey === 'realIndex' ? realIndex : index;
	    var key = "row-".concat(keyIndex);
	    var isSelected = !empty && computedRowSelectionEnabled && (computedRowMultiSelectionEnabled ? computedSelected === true ? computedUnselected ? computedUnselected[id] === undefined : true : computedSelected.hasOwnProperty(id) : computedSelected == id);
	    var rowExpanded = isRowExpandedById(id);
	    var rowProps = {
	      rowspanZIndex: totalCount - realIndex,
	      availableWidth: availableWidth,
	      computedGroupBy: computedGroupBy,
	      expandGroupTitle: expandGroupTitle,
	      expandColumn: expandColumn,
	      getCellSelectionKey: getCellSelectionKey,
	      id: id,
	      depth: depth,
	      columns: columns,
	      columnsMap: columnsMap,
	      computedHasColSpan: computedHasColSpan,
	      lockedStartColumns: lockedStartColumns,
	      lockedEndColumns: lockedEndColumns,
	      hasLockedStart: hasLockedStart,
	      rowDetailsWidth: rowDetailsWidth,
	      hasLockedEnd: hasLockedEnd,
	      columnUserSelect: columnUserSelect,
	      minWidth: minRowWidth,
	      width: totalComputedWidth,
	      active: active,
	      activeRowRef: activeRowRef,
	      emptyScrollOffset: emptyScrollOffset,
	      empty: empty,
	      editable: editable,
	      key: key,
	      scrollLeft: scrollLeft,
	      getScrollLeftMax: getScrollLeftMax,
	      groupColumn: groupColumn,
	      renderRow: renderRow,
	      onRenderRow: onRenderRow,
	      cellFactory: cellFactory,
	      computedActiveCell: computedActiveCell,
	      computedShowZebraRows: computedShowZebraRows,
	      lastCellInRange: lastCellInRange,
	      groupNestingSize: groupNestingSize,
	      treeNestingSize: treeNestingSize,
	      columnRenderCount: columnRenderCount,
	      rowStyle: rowStyle,
	      rowClassName: rowClassName,
	      onTransitionEnd: onTransitionEnd,
	      onRowContextMenu: onRowContextMenu,
	      renderNodeTool: renderNodeTool,
	      indexInGroup: isGrouped ? indexInGroup : null,
	      groupCount: isGrouped && computedGroupCounts ? computedGroupCounts[realIndex] : 0,
	      editStartEvent: editStartEvent,
	      virtualizeColumns: virtualizeColumns,
	      firstUnlockedIndex: firstUnlockedIndex,
	      firstLockedStartIndex: firstLockedStartIndex,
	      columnRenderStartIndex: columnRenderStartIndex,
	      firstLockedEndIndex: firstLockedEndIndex,
	      tryNextRowEdit: tryNextRowEdit,
	      totalComputedWidth: totalComputedWidth,
	      totalLockedStartWidth: totalLockedStartWidth,
	      totalLockedEndWidth: totalLockedEndWidth,
	      totalUnlockedWidth: totalUnlockedWidth,
	      sticky: sticky,
	      computedCellSelection: computedCellSelection,
	      computedCellMultiSelectionEnabled: computedCellMultiSelectionEnabled,
	      shouldRenderCollapsedRowDetails: shouldRenderCollapsedRowDetails,
	      rowDetailsStyle: rowDetailsStyle,
	      renderDetailsGrid: renderDetailsGrid,
	      renderIndex: renderIndex,
	      realIndex: realIndex,
	      rowIndex: realIndex,
	      remoteRowIndex: remoteOffset + realIndex,
	      maxVisibleRows: maxVisibleRows,
	      last: !computedShowEmptyRows ? realIndex == totalCount - 1 : !!(maxVisibleRows && realIndex >= maxVisibleRows - 1 && realIndex == totalCount - 1),
	      lastNonEmpty: realIndex === totalCount - 1,
	      totalDataCount: totalCount,
	      rowHeight: rowHeight,
	      defaultRowHeight: defaultRowHeight,
	      rowExpandHeight: rowExpandHeight,
	      initialRowHeight: initialRowHeight,
	      setRowSpan: setRowSpan,
	      maxRowHeight: maxRowHeight,
	      minRowHeight: minRowHeight,
	      getItemId: getItemId,
	      computedShowCellBorders: computedShowCellBorders,
	      showHorizontalCellBorders: showHorizontalCellBorders,
	      showVerticalCellBorders: showVerticalCellBorders,
	      passedProps: passedProps,
	      setRowSelected: setRowSelected,
	      setRowExpanded: setRowExpanded,
	      renderLockedStartCells: renderLockedStartCells,
	      renderLockedEndCells: renderLockedEndCells,
	      computedRowExpandEnabled: computedRowExpandEnabled,
	      computedRenderRowDetails: computedRenderRowDetails,
	      isRowExpandableAt: isRowExpandableAt,
	      treeColumn: treeColumn,
	      rtl: rtl,
	      toggleRowExpand: toggleRowExpand,
	      toggleNodeExpand: toggleNodeExpand,
	      expandOnMouseDown: expandOnMouseDown,
	      loadNodeAsync: loadNodeAsync,
	      edition: edition,
	      computedLicenseValid: computedLicenseValid,
	      computedEnableRowspan: computedEnableRowspan,
	      computedTreeEnabled: computedTreeEnabled,
	      naturalRowHeight: naturalRowHeight,
	      selectAll: selectAll,
	      deselectAll: deselectAll,
	      totalColumnCount: totalColumnCount,
	      computedPivot: computedPivot,
	      multiSelect: computedRowMultiSelectionEnabled,
	      selection: computedSelected,
	      selected: isSelected,
	      expanded: rowExpanded,
	      lastLockedStartIndex: lastLockedStartIndex,
	      lastLockedEndIndex: lastLockedEndIndex,
	      lastUnlockedIndex: lastUnlockedIndex,
	      data: rowData,
	      dataSourceArray: data,
	      onMouseEnter: !empty ? onRowMouseEnter : null,
	      onMouseLeave: !empty ? onRowMouseLeave : null,
	      onClick: !empty ? computedOnRowClick : null,
	      onMouseDown: !empty ? computedOnRowMouseDown : null,
	      onRowDoubleClick: !empty ? computedRowDoubleClick : null,
	      scrollToColumn: scrollToColumn,
	      scrollToIndexIfNeeded: scrollToIndexIfNeeded,
	      onCellClick: onCellClick,
	      onCellDoubleClick: computedCellDoubleClick,
	      onCellSelectionDraggerMouseDown: onCellSelectionDraggerMouseDown,
	      onCellMouseDown: computedOnCellMouseDown,
	      onColumnMouseEnter: onColumnMouseEnter,
	      onColumnMouseLeave: onColumnMouseLeave,
	      columnIndexHovered: columnIndexHovered,
	      onCellEnter: onCellEnter,
	      onEditStop: onEditStop,
	      onEditStart: onEditStart,
	      onEditCancel: onEditCancel,
	      onEditValueChange: onEditValueChange,
	      onEditComplete: onEditComplete,
	      scrollbars: scrollbars,
	      even: false,
	      odd: false,
	      nativeScroll: nativeScroll,
	      onRowReorder: onRowReorder,
	      onDragRowMouseDown: onDragRowMouseDown,
	      theme: theme,
	      onContextMenu: onContextMenu,
	      setActiveIndex: setActiveIndex,
	      renderTreeCollapseTool: renderTreeCollapseTool,
	      renderTreeExpandTool: renderTreeExpandTool,
	      renderGroupCollapseTool: renderGroupCollapseTool,
	      renderGroupExpandTool: renderGroupExpandTool,
	      renderTreeLoadingTool: renderTreeLoadingTool,
	      currentEditCompletePromise: currentEditCompletePromise,
	      enableColumnAutosize: enableColumnAutosize,
	      columnHoverClassName: columnHoverClassName,
	      computedEnableColumnHover: computedEnableColumnHover,
	      renderRowDetailsExpandIcon: renderRowDetailsExpandIcon,
	      renderRowDetailsCollapsedIcon: renderRowDetailsCollapsedIcon,
	      memorizedScrollLeft: memorizedScrollLeft,
	      disabledRow: disabledRows ? disabledRows[realIndex] : null,
	      focusedRow: focusedRow,
	      rowFocusClassName: rowFocusClassName,
	      onCellBulkUpdateMouseDown: computedCellBulkUpdateMouseDown,
	      onMouseUp: computedCellBulkUpdateMouseUp,
	      bulkUpdateMouseDown: bulkUpdateMouseDown
	    };
	    if (rowProps.rowIndex === editRowIndex) {
	      rowProps.editing = true;
	      rowProps.editValue = editValue;
	      rowProps.editColumnIndex = editColumnIndex;
	      rowProps.editColumnId = editColumnId;
	    }
	    if (rowData && rowData.__group) {
	      rowProps.indexInGroup = null;
	      var rowGroupKey = "".concat(rowData.keyPath.join(groupPathSeparator));
	      var collapsed;
	      if (computedCollapsedGroups === true) {
	        collapsed = true;
	        if (computedExpandedGroups[rowGroupKey]) {
	          collapsed = false;
	        }
	      } else if (computedExpandedGroups === true) {
	        collapsed = false;
	        if (computedCollapsedGroups[rowGroupKey]) {
	          collapsed = true;
	        }
	      } else {
	        collapsed = computedCollapsedGroups[rowGroupKey];
	      }
	      rowProps.groupProps = {
	        renderGroupTitle: renderGroupTitle,
	        renderGroupTool: renderGroupTool,
	        renderLockedEndGroupTitle: renderLockedEndGroupTitle,
	        renderUnlockedGroupTitle: renderUnlockedGroupTitle,
	        onGroupToggle: onGroupToggle,
	        collapsed: collapsed,
	        groupNestingSize: groupNestingSize,
	        depth: rowData.depth - 1
	      };
	      rowProps.onGroupToggle = onGroupToggle;
	      rowProps.groupSummary = rowData.groupSummary;
	      rowProps.groupColumnSummaries = rowData.groupColumnSummaries;
	    }
	    if (isGrouped) {
	      rowProps.parentGroupDataArray = [];
	    }
	    var even = !!((isGrouped && !computedPivot ? indexInGroup : realIndex) % 2);
	    if (empty && isGrouped) {
	      var tmpIndex = (computedIndexesInGroups[currentDataSourceCount - 1] || 0) + (realIndex - currentDataSourceCount - 1);
	      even = !!(tmpIndex % 2);
	    }
	    if (rowData && rowData.__summary) {
	      rowProps.summaryProps = {
	        position: rowData.__summary,
	        groupProps: rowData.__parentGroup,
	        value: rowData.__parentGroup.groupColumnSummaries,
	        depth: rowData.__parentGroup.depth - 1
	      };
	      even = true;
	    }
	    if (maxWidth != null) {
	      rowProps.maxWidth = maxWidth;
	    }
	    rowProps.even = even;
	    rowProps.odd = !even;
	    var row;
	    if (rowFactory) {
	      row = rowFactory(rowProps);
	    }
	    if (computedEnableRowspan) {
	      rowProps.computedRowspans = (0, _getRowSpans.default)(rowProps);
	      setRowSpan(Math.max.apply(Math, (0, _toConsumableArray2.default)(Object.keys(rowProps.computedRowspans).map(function (key) {
	        return rowProps.computedRowspans[key];
	      }))));
	    }
	    if (row === undefined) {
	      row = _react.default.createElement(_Row.default, _objectSpread({}, rowProps));
	    }
	    return row;
	  });
	};
	var _default = renderRows;
	exports.default = _default;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MAX_WIDTH = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _Cell = _interopRequireDefault(__webpack_require__(141));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var MAX_WIDTH = 350;
	exports.MAX_WIDTH = MAX_WIDTH;
	var DragCell = function (_React$Component) {
	  (0, _inherits2.default)(DragCell, _React$Component);
	  var _super = _createSuper(DragCell);
	  function DragCell(_props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, DragCell);
	    _this = _super.call(this, _props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "left", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "right", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "top", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "height", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "width", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getProps", function () {
	      return _this.state.props || _this.props;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setProps", function (props) {
	      _this.setState({
	        props: props
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCellMount", function (props, cell) {
	      if (_this.left) {
	        cell.setLeft(_this.left);
	      }
	      if (_this.right) {
	        cell.setRight(_this.right);
	      }
	      if (_this.top) {
	        cell.setTop(_this.top);
	      }
	      if (_this.height) {
	        cell.setHeight(_this.height);
	      }
	      if (_this.width) {
	        cell.setWidth(_this.width);
	      }
	      cell.setDragging(true);
	      _this.cell = cell;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCellUnmount", function () {
	      _this.cell = null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setDragging", function (visible, callback) {
	      if (!visible) {
	        _this.top = undefined;
	        _this.left = undefined;
	        _this.right = undefined;
	        _this.height = undefined;
	        _this.width = undefined;
	      }
	      _this.setState({
	        visible: visible
	      }, function () {
	        if (_this.cell && visible) {
	          _this.cell.setDragging(visible, callback);
	        }
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setTop", function (top) {
	      _this.top = top;
	      if (_this.cell && _this.state.visible) {
	        _this.cell.setTop(top);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setHeight", function (height) {
	      _this.height = height;
	      if (_this.cell && _this.state.visible) {
	        _this.cell.setHeight(height);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setWidth", function (width) {
	      _this.width = width;
	      if (_this.cell && _this.state.visible) {
	        _this.cell.setWidth(width);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setLeft", function (left) {
	      _this.left = left;
	      if (_this.cell && _this.state.visible) {
	        _this.cell.setLeft(left);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRight", function (right) {
	      _this.right = right;
	      if (_this.cell && _this.state.visible) {
	        _this.cell.setRight(right);
	      }
	    });
	    _this.state = {
	      visible: false
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(DragCell, [{
	    key: "render",
	    value: function render() {
	      if (this.state.visible) {
	        var props = this.getProps();
	        var className = props.className ? "".concat(props.className, " InovuaReactDataGrid__drag-proxy") : 'InovuaReactDataGrid__drag-proxy';
	        var headerWrapperClassName = props.headerWrapperClassName ? "".concat(props.headerWrapperClassName, " InovuaReactDataGrid__drag-proxy") : 'InovuaReactDataGrid__drag-proxy';
	        var maxWidth = props.maxWidth ? Math.min(props.maxWidth, MAX_WIDTH) : MAX_WIDTH;
	        var computedWidth = Math.min(props.computedWidth, maxWidth);
	        return _react.default.createElement(_Cell.default, _objectSpread(_objectSpread({}, props), {}, {
	          maxWidth: maxWidth,
	          computedWidth: computedWidth,
	          className: className,
	          headerWrapperClassName: headerWrapperClassName,
	          onMount: this.onCellMount,
	          onUnmount: this.onCellUnmount
	        }));
	      }
	      return null;
	    }
	  }]);
	  return DragCell;
	}(_react.default.Component);
	exports.default = DragCell;

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _HeaderGroup = _interopRequireDefault(__webpack_require__(211));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var extraChildrenProps = {
	  onUnmount: null,
	  ref: null,
	  dragging: true
	};
	var DragHeaderGroup = function (_React$Component) {
	  (0, _inherits2.default)(DragHeaderGroup, _React$Component);
	  var _super = _createSuper(DragHeaderGroup);
	  function DragHeaderGroup(_props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, DragHeaderGroup);
	    _this = _super.call(this, _props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getProps", function () {
	      return _this.state.props || _this.props;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setProps", function (props) {
	      _this.setState({
	        props: props
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setDragging", function (visible, callback) {
	      if (!visible) {
	        _this.top = undefined;
	        _this.left = undefined;
	        _this.right = undefined;
	        _this.width = undefined;
	        _this.height = undefined;
	      }
	      _this.setState({
	        visible: visible
	      }, function () {
	        if (_this.headerGroup && visible) {
	          _this.headerGroup.setDragging(visible, callback);
	          if (_this.top !== undefined) {
	            _this.headerGroup.setTop(_this.top);
	          }
	          if (_this.left !== undefined) {
	            _this.headerGroup.setLeft(_this.left);
	          }
	          if (_this.right !== undefined) {
	            _this.headerGroup.setRight(_this.right);
	          }
	          if (_this.height !== undefined) {
	            _this.headerGroup.setHeight(_this.height);
	          }
	          if (_this.width !== undefined) {
	            _this.headerGroup.setWidth(_this.width);
	          }
	        }
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setHeight", function (height) {
	      _this.height = height;
	      if (_this.headerGroup && _this.state.visible) {
	        _this.headerGroup.setHeight(height);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setWidth", function (width) {
	      _this.width = width;
	      if (_this.headerGroup && _this.state.visible) {
	        _this.headerGroup.setWidth(width);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setTop", function (top) {
	      _this.top = top;
	      if (_this.headerGroup && _this.state.visible) {
	        _this.headerGroup.setTop(top);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setLeft", function (left) {
	      _this.left = left;
	      if (_this.headerGroup && _this.state.visible) {
	        _this.headerGroup.setLeft(left);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRight", function (right) {
	      _this.right = right;
	      if (_this.headerGroup && _this.state.visible) {
	        _this.headerGroup.setRight(right);
	      }
	    });
	    _this.refHeaderGroup = function (group) {
	      _this.headerGroup = group;
	    };
	    _this.state = {
	      visible: false
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(DragHeaderGroup, [{
	    key: "render",
	    value: function render() {
	      if (this.state.visible) {
	        var props = this.getProps();
	        var className = props.className ? "".concat(props.className, " InovuaReactDataGrid__drag-proxy") : 'InovuaReactDataGrid__drag-proxy';
	        return _react.default.createElement(_HeaderGroup.default, _objectSpread(_objectSpread({}, props), {}, {
	          dragging: true,
	          extraChildrenProps: extraChildrenProps,
	          className: className,
	          ref: this.refHeaderGroup
	        }));
	      }
	      return null;
	    }
	  }]);
	  return DragHeaderGroup;
	}(_react.default.Component);
	exports.default = DragHeaderGroup;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _humanize = _interopRequireDefault(__webpack_require__(271));
	var _default = function _default(cellProps, column, headerProps, contextMenu) {
	  var header = cellProps.header,
	    name = cellProps.name;
	  if (header !== undefined) {
	    if (typeof header !== 'function') {
	      return header;
	    }
	    return header(cellProps, {
	      cellProps: cellProps,
	      column: column,
	      headerProps: headerProps,
	      contextMenu: contextMenu
	    });
	  }
	  return (0, _humanize.default)(name || '');
	};
	exports.default = _default;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _getScrollbarWidth = _interopRequireDefault(__webpack_require__(47));
	var _Header = _interopRequireDefault(__webpack_require__(142));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var fixScrollLeft = function fixScrollLeft(event) {
	  var target = event.currentTarget;
	  requestAnimationFrame(function () {
	    if (target.scrollLeft) {
	      target.scrollLeft = 0;
	    }
	  });
	};
	var HeaderWrapper = function (_React$Component) {
	  (0, _inherits2.default)(HeaderWrapper, _React$Component);
	  var _super = _createSuper(HeaderWrapper);
	  function HeaderWrapper() {
	    var _this;
	    (0, _classCallCheck2.default)(this, HeaderWrapper);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSortedColumnsInfo", function (_ref) {
	      var computedSortInfo = _ref.computedSortInfo,
	        columnsMap = _ref.columnsMap;
	      if (!computedSortInfo) {
	        return;
	      }
	      var sortedColumnsInfo = [];
	      if (Array.isArray(computedSortInfo)) {
	        computedSortInfo.map(function (sortInfo) {
	          sortedColumnsInfo.push(columnsMap[sortInfo.columnName || sortInfo.name]);
	        });
	      } else {
	        return columnsMap[computedSortInfo.columnName];
	      }
	      return sortedColumnsInfo;
	    });
	    return _this;
	  }
	  (0, _createClass2.default)(HeaderWrapper, [{
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var data = props.data,
	        deselectAll = props.deselectAll,
	        computedShowHeaderBorderRight = props.computedShowHeaderBorderRight,
	        headerProps = props.headerProps,
	        filterTypes = props.filterTypes,
	        filterable = props.filterable,
	        isMultiSort = props.isMultiSort,
	        nativeScroll = props.nativeScroll,
	        resizable = props.resizable,
	        resizeProxyStyle = props.resizeProxyStyle,
	        scrollLeft = props.scrollLeft,
	        scrollbars = props.scrollbars,
	        selectAll = props.selectAll,
	        selected = props.computedSelected,
	        unselected = props.computedUnselected,
	        selectedCount = props.computedSelectedCount,
	        sortInfo = props.sortInfo,
	        sortable = props.sortable,
	        renderSortTool = props.renderSortTool,
	        totalCount = props.paginationCount,
	        unselectedCount = props.computedUnselectedCount,
	        virtualListBorderLeft = props.virtualListBorderLeft,
	        virtualListBorderRight = props.virtualListBorderRight,
	        columns = props.visibleColumns,
	        lastLockedStartIndex = props.lastLockedStartIndex,
	        lastLockedEndIndex = props.lastLockedEndIndex,
	        lastUnlockedIndex = props.lastUnlockedIndex,
	        updateLockedWrapperPositions = props.updateLockedWrapperPositions,
	        theme = props.theme,
	        columnWidthPrefixSums = props.columnWidthPrefixSums,
	        renderMenuTool = props.renderMenuTool,
	        computedSortInfo = props.computedSortInfo,
	        columnsMap = props.columnsMap,
	        columnIndexHovered = props.columnIndexHovered,
	        onColumnMouseEnter = props.onColumnMouseEnter,
	        onColumnMouseLeave = props.onColumnMouseLeave,
	        columnHoverClassName = props.columnHoverClassName,
	        enableColumnFilterContextMenu = props.enableColumnFilterContextMenu,
	        computedEnableColumnHover = props.computedEnableColumnHover,
	        renderRowDetailsMoreIcon = props.renderRowDetailsMoreIcon,
	        hideColumnContextMenu = props.hideColumnContextMenu,
	        updateMenuPosition = props.updateMenuPosition;
	      var scrollbarWidth = 0;
	      if (nativeScroll && scrollbars.vertical) {
	        scrollbarWidth = (0, _getScrollbarWidth.default)();
	      }
	      var sortedColumnsInfo = this.getSortedColumnsInfo({
	        computedSortInfo: computedSortInfo,
	        columnsMap: columnsMap
	      });
	      var headerHeight = !props.computedGroups ? props.headerHeight : undefined;
	      return _react.default.createElement("div", {
	        className: "InovuaReactDataGrid__header-wrapper InovuaReactDataGrid__header-wrapper--direction-".concat(this.props.rtl ? 'rtl' : 'ltr'),
	        onFocus: fixScrollLeft
	      }, nativeScroll && this.props.rtl ? _react.default.createElement("div", {
	        className: "InovuaReactDataGrid__header-rtl-scroll-spacer",
	        style: {
	          minWidth: scrollbarWidth,
	          display: scrollbarWidth ? 'block' : 'none'
	        }
	      }) : null, _react.default.createElement(_Header.default, _objectSpread(_objectSpread({}, headerProps), {}, {
	        notifyColumnFilterVisibleStateChange: props.notifyColumnFilterVisibleStateChange,
	        setScrollLeft: props.setScrollLeft,
	        getScrollLeftMax: props.getScrollLeftMax,
	        availableWidth: props.availableWidth,
	        lockedRows: props.lockedRows,
	        rtl: props.rtl,
	        i18n: props.i18n,
	        lastLockedStartIndex: lastLockedStartIndex,
	        lastLockedEndIndex: lastLockedEndIndex,
	        lastUnlockedIndex: lastUnlockedIndex,
	        columnHeaderUserSelect: props.columnHeaderUserSelect,
	        columnRenderCount: props.columnRenderCount,
	        columnResizeHandleWidth: props.columnResizeHandleWidth,
	        columnUserSelect: props.columnUserSelect,
	        renderInPortal: props.renderInPortal,
	        columns: columns,
	        columnsMap: props.columnsMap,
	        data: data,
	        filterTypes: filterTypes,
	        showColumnMenuTool: props.showColumnMenuTool,
	        showColumnMenuToolOnHover: props.showColumnMenuToolOnHover,
	        deselectAll: deselectAll,
	        firstLockedEndIndex: props.firstLockedEndIndex,
	        firstUnlockedIndex: props.firstUnlockedIndex,
	        computedGroupsMap: props.computedGroupsMap,
	        computedGroupsDepth: props.computedGroupsDepth,
	        onColumnHeaderFocus: props.onColumnHeaderFocus,
	        filterable: filterable,
	        showColumnContextMenu: props.showColumnContextMenu,
	        showColumnFilterContextMenu: props.showColumnFilterContextMenu,
	        hideColumnFilterContextMenu: props.hideColumnFilterContextMenu,
	        computedShowHeaderBorderRight: computedShowHeaderBorderRight,
	        hasLockedEnd: props.hasLockedEnd,
	        hasLockedStart: props.hasLockedStart,
	        headerHeight: headerHeight,
	        isMultiSort: isMultiSort,
	        lockedEndColumns: props.lockedEndColumns,
	        lockedStartColumns: props.lockedStartColumns,
	        minWidth: props.minRowWidth,
	        nativeScroll: nativeScroll,
	        onCellClick: props.onHeaderCellClick,
	        onGroupMouseDown: props.onHeaderGroupMouseDown,
	        onCellMouseDown: props.onHeaderCellMouseDown,
	        onCellTouchStart: props.onHeaderCellTouchStart,
	        onResizeMouseDown: props.onResizeMouseDown,
	        onResizeTouchStart: props.onResizeTouchStart,
	        onSortClick: props.onHeaderSortClick,
	        onTransitionEnd: props.onTransitionEnd,
	        ref: props.refHeader,
	        renderSortTool: renderSortTool,
	        resizable: resizable,
	        resizeProxyStyle: resizeProxyStyle,
	        scrollLeft: scrollLeft,
	        scrollbarWidth: scrollbarWidth,
	        selectAll: selectAll,
	        selectedCount: selectedCount,
	        selected: selected,
	        unselected: unselected,
	        sortInfo: sortInfo,
	        sortable: sortable,
	        totalCount: totalCount,
	        theme: theme,
	        renderLockedStartCells: props.renderLockedStartCells,
	        renderLockedEndCells: props.renderLockedEndCells,
	        onFilterValueChange: props.onFilterValueChange,
	        unselectedCount: unselectedCount,
	        virtualListBorderLeft: virtualListBorderLeft,
	        virtualListBorderRight: virtualListBorderRight,
	        updateLockedWrapperPositions: updateLockedWrapperPositions,
	        virtualizeColumns: props.virtualizeColumns && !!headerHeight && !props.computedGroups,
	        columnWidthPrefixSums: columnWidthPrefixSums,
	        renderMenuTool: renderMenuTool,
	        sortedColumnsInfo: sortedColumnsInfo,
	        columnIndexHovered: columnIndexHovered,
	        onColumnMouseEnter: onColumnMouseEnter,
	        onColumnMouseLeave: onColumnMouseLeave,
	        columnHoverClassName: columnHoverClassName,
	        enableColumnFilterContextMenu: enableColumnFilterContextMenu,
	        computedEnableColumnHover: computedEnableColumnHover,
	        renderRowDetailsMoreIcon: renderRowDetailsMoreIcon,
	        hideColumnContextMenu: hideColumnContextMenu,
	        updateMenuPosition: updateMenuPosition,
	        computedFilterable: props.computedFilterable,
	        filterRowHeight: props.filterRowHeight
	      })), _react.default.createElement("div", {
	        className: "InovuaReactDataGrid__header-wrapper__fill"
	      }, props.computedFilterable && _react.default.createElement("div", {
	        className: "InovuaReactDataGrid__header-wrapper__fill__filters"
	      })));
	    }
	  }]);
	  return HeaderWrapper;
	}(_react.default.Component);
	exports.default = HeaderWrapper;
	HeaderWrapper.propTypes = {
	  visibleColumns: _propTypes.default.array.isRequired,
	  columnsMap: _propTypes.default.object.isRequired,
	  deselectAll: _propTypes.default.func,
	  headerHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  headerProps: _propTypes.default.object,
	  isMultiSort: _propTypes.default.bool,
	  refHeader: _propTypes.default.func.isRequired,
	  selectAll: _propTypes.default.func,
	  setScrollLeft: _propTypes.default.func,
	  sortable: _propTypes.default.bool,
	  virtualizeColumns: _propTypes.default.bool,
	  updateLockedWrapperPositions: _propTypes.default.func,
	  lastLockedStartIndex: _propTypes.default.number,
	  lastLockedEndIndex: _propTypes.default.number,
	  lastUnlockedIndex: _propTypes.default.number,
	  computedEnableColumnHover: _propTypes.default.bool,
	  renderRowDetailsMoreIcon: _propTypes.default.func,
	  computedFilterable: _propTypes.default.bool,
	  filterRowHeight: _propTypes.default.number
	};

/***/ },
/* 564 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(_ref) {
	  var dragTarget = _ref.dragTarget,
	    dropTarget = _ref.dropTarget,
	    dragMinIndex = _ref.dragMinIndex,
	    dragMaxIndex = _ref.dragMaxIndex,
	    dragRange = _ref.dragRange,
	    ranges = _ref.ranges,
	    rtl = _ref.rtl,
	    dir = _ref.dir,
	    validDropPositions = _ref.validDropPositions;
	  ranges = ranges || [];
	  var dragIndex = dragRange.index;
	  var draggingLocked = dragRange.computedLocked;
	  var locked = draggingLocked;
	  var isValid = function isValid(i) {
	    if (i === undefined) {
	      return false;
	    }
	    var validDropIndex = dropTarget === 'group' || !validDropPositions || validDropPositions[i];
	    if (dragMinIndex !== undefined && i < dragMinIndex || dragMaxIndex !== undefined && i > dragMaxIndex || !validDropIndex || i > ranges.length) {
	      return false;
	    }
	    return true;
	  };
	  var searchInRanges = dragTarget != dropTarget ? ranges : dir == 1 ? ranges.slice(dragIndex) : ranges.slice(0, dragIndex);
	  var currentRange;
	  var halfSize;
	  var thisDir;
	  var index;
	  var foundIndex;
	  for (var i = 0, len = searchInRanges.length; i < len; i++) {
	    currentRange = searchInRanges[i];
	    if (!currentRange) {
	      continue;
	    }
	    index = currentRange.index;
	    thisDir = index <= dragIndex || dragTarget !== dropTarget ? -1 : 1;
	    halfSize = (currentRange.right - currentRange.left) / 2;
	    if (thisDir > 0) {
	      if (isValid(index + 1) && (rtl ? dragRange.left <= currentRange.right - halfSize : dragRange.right >= currentRange.left + halfSize)) {
	        foundIndex = index + 1;
	      }
	    } else {
	      if (isValid(index) && (rtl ? dragRange.right > currentRange.right - halfSize : dragRange.left < currentRange.left + halfSize)) {
	        foundIndex = index;
	        if (dropTarget !== dragTarget || dir === -1) {
	          break;
	        }
	      }
	    }
	  }
	  if (dragTarget === dropTarget) {
	    if (foundIndex === dragIndex + 1) {
	      foundIndex++;
	    } else if (foundIndex === undefined) {
	      foundIndex = dragIndex === ranges.length - 1 || dragIndex === 0 ? dragIndex : dir > 1 ? ranges.length : undefined;
	    }
	  } else if (foundIndex === undefined) {
	    foundIndex = ranges.length;
	  }
	  if (!isValid(foundIndex)) {
	    foundIndex = undefined;
	  }
	  if (dragMinIndex !== undefined && foundIndex < dragMinIndex) {
	    foundIndex = dragMinIndex;
	  }
	  if (dragMaxIndex !== undefined && foundIndex > dragMaxIndex) {
	    foundIndex = dragMaxIndex;
	  }
	  if (!isValid(foundIndex)) {
	    foundIndex = dragIndex;
	  }
	  if (!isValid(foundIndex)) {
	    foundIndex = undefined;
	  }
	  if (isValid(foundIndex) && ranges[foundIndex]) {
	    locked = ranges[foundIndex].computedLocked;
	  }
	  var initialLocked = locked;
	  if (dir === 1) {
	    var targetRange = ranges[foundIndex];
	    var beforeTargetRange = ranges[foundIndex - 1];
	    var afterTargetRange = ranges[foundIndex + 1];
	    if (targetRange && !targetRange.computedLocked) {
	      if (rtl) {
	        if (dragRange.left < targetRange.right) {
	          locked = targetRange.computedLocked;
	        } else {
	          locked = beforeTargetRange ? beforeTargetRange.computedLocked : initialLocked;
	        }
	      } else {
	        if (dragRange.right > targetRange.left) {
	          locked = targetRange.computedLocked;
	        } else {
	          locked = beforeTargetRange ? beforeTargetRange.computedLocked : initialLocked;
	        }
	      }
	    } else if (targetRange && targetRange.computedLocked === 'end') {
	      if (rtl) {
	        locked = dragRange.left < targetRange.right ? 'end' : beforeTargetRange ? beforeTargetRange.computedLocked : initialLocked;
	      } else {
	        locked = dragRange.right > targetRange.left ? 'end' : beforeTargetRange ? beforeTargetRange.computedLocked : initialLocked;
	      }
	    } else if (afterTargetRange && !afterTargetRange.computedLocked && (rtl ? dragRange.left > afterTargetRange.right : dragRange.right > afterTargetRange.left)) {
	      locked = null;
	    } else if (beforeTargetRange && beforeTargetRange.computedLocked === 'end') {
	      locked = 'end';
	    }
	  }
	  if (dir === -1) {
	    var _targetRange = ranges[foundIndex];
	    var _beforeTargetRange = ranges[foundIndex - 1];
	    if (_beforeTargetRange && !_beforeTargetRange.computedLocked && (rtl ? dragRange.right > _beforeTargetRange.left : dragRange.left < _beforeTargetRange.right)) {
	      locked = null;
	    } else if (_beforeTargetRange && _beforeTargetRange.computedLocked === 'start' && (rtl ? dragRange.right > _beforeTargetRange.left : dragRange.left < _beforeTargetRange.right)) {
	      locked = 'start';
	    } else if (_targetRange && _targetRange.computedLocked === 'end' && (rtl ? dragRange.right > _targetRange.left : dragRange.left < _targetRange.right)) {
	      locked = 'end';
	    }
	  }
	  if (draggingLocked === 'start' && ranges[foundIndex] && ranges[foundIndex].computedLocked === 'start' && locked == null) {
	    foundIndex++;
	  }
	  return {
	    index: foundIndex,
	    locked: locked
	  };
	};
	exports.default = _default;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _region = _interopRequireDefault(__webpack_require__(43));
	var _default = function _default(cells, getIndex) {
	  return (cells || []).map(function (c, i) {
	    var node = c.domRef ? c.domRef.current : c.getDOMNode ? c.getDOMNode() : null;
	    var reg = _region.default.from(node);
	    var isCell = typeof c.getProps === 'function';
	    var props = isCell ? c.getProps() : c.props;
	    var result = {
	      left: reg.left,
	      right: reg.right,
	      width: reg.width,
	      computedLocked: props.computedLocked,
	      index: getIndex === undefined ? i : getIndex(i, c, props)
	    };
	    return result;
	  });
	};
	exports.default = _default;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _default = function _default(columns, _ref) {
	  var headerRegion = _ref.headerRegion,
	    initialOffset = _ref.initialOffset,
	    availableWidth = _ref.availableWidth,
	    totalLockedEndWidth = _ref.totalLockedEndWidth,
	    initialScrollLeft = _ref.initialScrollLeft,
	    rtlOffset = _ref.rtlOffset,
	    rtl = _ref.rtl;
	  var lockedEndOffset = 0;
	  var result = columns.map(function (c, i) {
	    var _result;
	    var computedLocked = c.computedLocked;
	    var offset = rtl ? initialOffset - (initialScrollLeft || 0) - c.computedOffset : c.computedOffset + (initialOffset - (initialScrollLeft || 0));
	    if (rtl) {
	      offset += rtlOffset;
	    }
	    if (computedLocked === 'end') {
	      offset = !rtl ? availableWidth - totalLockedEndWidth + lockedEndOffset + initialOffset : initialOffset - availableWidth + totalLockedEndWidth - lockedEndOffset;
	      lockedEndOffset += c.computedWidth;
	    }
	    if (computedLocked === 'start') {
	      offset = c.computedOffset + (initialOffset || 0);
	    }
	    var result = (_result = {}, (0, _defineProperty2.default)(_result, rtl ? 'right' : 'left', offset), (0, _defineProperty2.default)(_result, rtl ? 'left' : 'right', rtl ? offset - c.computedWidth : offset + c.computedWidth), (0, _defineProperty2.default)(_result, "width", c.computedWidth), (0, _defineProperty2.default)(_result, "computedLocked", computedLocked), (0, _defineProperty2.default)(_result, "index", i), _result);
	    return result;
	  });
	  return result;
	};
	exports.default = _default;

/***/ },
/* 567 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(columns) {
	  return columns.reduce(function (acc, col) {
	    if (col.draggable !== false) {
	      acc.stop = true;
	    }
	    if (col.draggable === false && !acc.stop) {
	      acc.count++;
	    }
	    return acc;
	  }, {
	    count: 0
	  }).count;
	};
	exports.default = _default;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _debounce = _interopRequireDefault(__webpack_require__(63));
	var _contains = _interopRequireDefault(__webpack_require__(157));
	var _assignDefined2 = _interopRequireDefault(__webpack_require__(259));
	var _region = _interopRequireDefault(__webpack_require__(43));
	var _isMobile = _interopRequireDefault(__webpack_require__(64));
	var _getRangesForBoxes = _interopRequireDefault(__webpack_require__(565));
	var _getRangesForColumns = _interopRequireDefault(__webpack_require__(566));
	var _setupColumnDrag = _interopRequireDefault(__webpack_require__(569));
	var _moveXBeforeY = _interopRequireDefault(__webpack_require__(797));
	var _isFocusable = _interopRequireDefault(__webpack_require__(273));
	var _getDropIndex2 = _interopRequireDefault(__webpack_require__(564));
	var _getUndraggableSuccessiveCount = _interopRequireDefault(__webpack_require__(567));
	var _DragCell = _interopRequireWildcard(__webpack_require__(560));
	var _DragHeaderGroup = _interopRequireDefault(__webpack_require__(561));
	var _HeaderWrapper = _interopRequireDefault(__webpack_require__(563));
	var _Header = __webpack_require__(142);
	var _getScrollbarWidth = _interopRequireDefault(__webpack_require__(47));
	var _getGlobal = __webpack_require__(18);
	var _join = _interopRequireDefault(__webpack_require__(31));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var SCROLL_MARGIN = 40;
	var DRAG_INFO = null;
	var preventDefault = function preventDefault(e) {
	  return e.preventDefault();
	};
	var getColumnOrder = function getColumnOrder(props, filter) {
	  var doFilter = function doFilter(c) {
	    return !c.groupColumn && filter ? filter(c) : true;
	  };
	  var order;
	  if (props.computedColumnOrder) {
	    order = props.computedColumnOrder.map(function (id) {
	      return props.columnsMap[id];
	    }).filter(Boolean);
	  } else {
	    order = props.allColumns;
	  }
	  var toId = function toId(c) {
	    return c.id;
	  };
	  order = (order || []).filter(doFilter).map(toId);
	  var lockedStart = props.lockedStartColumns.filter(doFilter).map(toId);
	  var lockedMap = lockedStart.reduce(function (acc, cId) {
	    acc[cId] = true;
	    return acc;
	  }, {});
	  var lockedEnd = props.lockedEndColumns.filter(doFilter).map(toId);
	  lockedEnd.reduce(function (acc, cId) {
	    acc[cId] = true;
	    return acc;
	  }, lockedMap);
	  return [].concat((0, _toConsumableArray2.default)(lockedStart), (0, _toConsumableArray2.default)(order.filter(function (cId) {
	    return !lockedMap[cId];
	  })), (0, _toConsumableArray2.default)(lockedEnd));
	};
	var getParentsForColumns = function getParentsForColumns(columns, groups, maxDepth) {
	  var parentsForColumns = columns.map(function (col) {
	    var result = [col.id].concat((0, _toConsumableArray2.default)((0, _Header.getParentGroups)(col.group, groups, {
	      includeSelf: true
	    }).map(function (g) {
	      return g.name;
	    })));
	    while (result.length <= maxDepth + 1) {
	      result.splice(0, 0, result[0]);
	    }
	    return result;
	  });
	  return parentsForColumns;
	};
	var getValidDropPositions = function getValidDropPositions(_ref) {
	  var dragTargetDepth = _ref.dragTargetDepth,
	    dragTargetIndex = _ref.dragTargetIndex,
	    dragTargetLength = _ref.dragTargetLength,
	    parentsForColumns = _ref.parentsForColumns,
	    lockedForColumns = _ref.lockedForColumns,
	    columns = _ref.columns,
	    allowGroupSplitOnReorder = _ref.allowGroupSplitOnReorder;
	  var getGroupsForColumn = function getGroupsForColumn(parents) {
	    parents = parents || [];
	    var initialName = parents[0];
	    var shouldCheck = true;
	    var groups = [];
	    parents.forEach(function (group) {
	      if (!shouldCheck) {
	        groups.push(group);
	        return;
	      }
	      if (shouldCheck && group !== initialName) {
	        shouldCheck = false;
	        groups.push(group);
	        return;
	      }
	      groups.push(null);
	    });
	    return groups;
	  };
	  var getGroupStartFor = function getGroupStartFor(parents, depth, index) {
	    var initialParent = parents[index].slice(-depth - 1)[0];
	    var initialLocked = lockedForColumns[index];
	    var itParents;
	    var currentParent;
	    var currentLocked;
	    do {
	      itParents = parents[index - 1];
	      if (!itParents) {
	        break;
	      }
	      currentParent = itParents.slice(-depth - 1)[0];
	      currentLocked = lockedForColumns[index];
	      if (currentParent !== initialParent || currentLocked !== initialLocked) {
	        break;
	      }
	      index--;
	    } while (index >= 0);
	    return index;
	  };
	  var getGroupEndFor = function getGroupEndFor(parents, depth, index) {
	    var initialParent = parents[index].slice(-depth - 1)[0];
	    var initialLocked = lockedForColumns[index];
	    var itParents;
	    var currentParent;
	    var currentLocked;
	    do {
	      index++;
	      itParents = parents[index];
	      if (!itParents) {
	        break;
	      }
	      currentParent = itParents.slice(-depth - 1)[0];
	      currentLocked = lockedForColumns[index];
	      if (currentParent !== initialParent || currentLocked !== initialLocked) {
	        break;
	      }
	    } while (index < parents.length);
	    return index;
	  };
	  var res = columns.reduce(function (acc, col, index) {
	    if (index > dragTargetIndex && index <= dragTargetIndex + dragTargetLength) {
	      return acc;
	    }
	    acc[index] = true;
	    return acc;
	  }, {});
	  res[columns.length] = true;
	  if (!allowGroupSplitOnReorder) {
	    var dragTargetParentGroups = getGroupsForColumn(parentsForColumns[dragTargetIndex]).filter(function (x) {
	      return x;
	    });
	    var isSingleColumn = !dragTargetParentGroups.length;
	    var usedDepth = isSingleColumn ? 0 : dragTargetDepth;
	    var parentGroupStartIndex = !usedDepth ? 0 : getGroupStartFor(parentsForColumns, usedDepth - 1, dragTargetIndex);
	    var parentGroupEndIndex = !usedDepth ? columns.length : getGroupEndFor(parentsForColumns, usedDepth - 1, dragTargetIndex);
	    var currentGroupEndIndex = getGroupEndFor(parentsForColumns, usedDepth, dragTargetIndex);
	    for (var i = 0; i <= columns.length; i++) {
	      delete res[i];
	    }
	    for (var _i = parentGroupStartIndex; _i < parentGroupEndIndex; _i++) {
	      var itGroupStartIndex = getGroupStartFor(parentsForColumns, usedDepth, _i);
	      var itGroupEndIndex = getGroupEndFor(parentsForColumns, usedDepth, _i);
	      res[itGroupStartIndex] = true;
	      res[itGroupEndIndex] = true;
	    }
	    var groupEndIsLastUnlocked = columns[currentGroupEndIndex] && columns[currentGroupEndIndex].computedLocked === 'end' && columns[currentGroupEndIndex - 1] && columns[currentGroupEndIndex - 1].computedLocked !== 'end';
	    if (!groupEndIsLastUnlocked) {
	      delete res[currentGroupEndIndex];
	    }
	  }
	  return res;
	};
	var ReorderArrow = function (_React$Component) {
	  (0, _inherits2.default)(ReorderArrow, _React$Component);
	  var _super = _createSuper(ReorderArrow);
	  function ReorderArrow(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, ReorderArrow);
	    _this = _super.call(this, props);
	    _this.state = {
	      visible: false,
	      bottom: 0,
	      top: 0,
	      left: 0
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(ReorderArrow, [{
	    key: "set",
	    value: function set(_ref2) {
	      var bottom = _ref2.bottom,
	        top = _ref2.top,
	        left = _ref2.left,
	        right = _ref2.right,
	        target = _ref2.target;
	      this.setState({
	        target: target,
	        bottom: bottom,
	        left: left,
	        top: top,
	        right: right
	      });
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible) {
	      if (visible != this.state.visible) {
	        this.setState({
	          visible: visible
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var size = this.props.size;
	      var _this$state = this.state,
	        bottom = _this$state.bottom,
	        top = _this$state.top,
	        left = _this$state.left,
	        right = _this$state.right,
	        visible = _this$state.visible,
	        target = _this$state.target;
	      return _react.default.createElement("div", {
	        ref: this.refReorderArrow,
	        style: {
	          position: 'absolute',
	          top: top,
	          left: left,
	          right: right,
	          width: size,
	          height: bottom - top,
	          bottom: bottom,
	          pointerEvents: 'none',
	          opacity: visible ? 1 : 0,
	          display: 'block'
	        },
	        className: "InovuaReactDataGrid__column-reorder-arrow InovuaReactDataGrid__column-reorder-arrow--direction-".concat(this.props.rtl ? 'rtl' : 'ltr')
	      }, _react.default.createElement("div", {
	        className: "InovuaReactDataGrid__column-reorder-arrow-fill InovuaReactDataGrid__column-reorder-arrow-fill--direction-".concat(this.props.rtl ? 'rtl' : 'ltr', " InovuaReactDataGrid__column-reorder-arrow-fill--target-").concat(target || 'none')
	      }), this.props.renderReorderIndicator());
	    }
	  }]);
	  return ReorderArrow;
	}(_react.default.Component);
	ReorderArrow.defaultProps = {
	  renderReorderIndicator: function renderReorderIndicator() {}
	};
	var InovuaDataGridHeaderLayout = function (_Component) {
	  (0, _inherits2.default)(InovuaDataGridHeaderLayout, _Component);
	  var _super2 = _createSuper(InovuaDataGridHeaderLayout);
	  function InovuaDataGridHeaderLayout(props) {
	    var _this2;
	    (0, _classCallCheck2.default)(this, InovuaDataGridHeaderLayout);
	    _this2 = _super2.call(this, props);
	    _this2.state = {
	      draggingProps: null
	    };
	    _this2.refDragGroupItem = function (item) {
	      _this2.dragGroupItem = item;
	    };
	    _this2.refDragCell = function (cell) {
	      _this2.dragCell = cell;
	    };
	    _this2.refDragHeaderGroup = function (item) {
	      _this2.dragHeaderGroup = item;
	    };
	    _this2.groupToolbar = (0, _react.createRef)();
	    _this2.refHeader = function (h) {
	      _this2.headerNode = null;
	      if (h) {
	        _this2.headerNode = h.getDOMNode ? h.getDOMNode() : null;
	        if (!_this2.headerNode) {
	          throw 'Cannot find header node';
	        }
	        if (_isMobile.default) {
	          _this2.headerNode.addEventListener('touchmove', preventDefault);
	        }
	      } else {
	        if (_this2.headerNode && _isMobile.default) {
	          _this2.headerNode.removeEventListener('touchmove', preventDefault);
	        }
	        _this2.headerNode = null;
	      }
	      _this2.header = h;
	    };
	    _this2.headerWrapper = (0, _react.createRef)();
	    _this2.refReorderArrow = function (cmp) {
	      _this2.reorderArrow = cmp;
	    };
	    _this2.headerDomNode = (0, _react.createRef)();
	    _this2.lazyNotifyHeaderScrollLeftMax = (0, _debounce.default)(_this2.notifyHeaderScrollLeftMax, 150);
	    return _this2;
	  }
	  (0, _createClass2.default)(InovuaDataGridHeaderLayout, [{
	    key: "notifyHeaderScrollLeftMax",
	    value: function notifyHeaderScrollLeftMax(scrollLeftMax) {
	      if (this.header && this.props.lockedEndColumns) {
	        this.header.notifyScrollLeftMax(scrollLeftMax === undefined ? this.getScrollLeftMax() : scrollLeftMax);
	      }
	    }
	  }, {
	    key: "onContainerScrollHorizontal",
	    value: function onContainerScrollHorizontal(scrollLeft, scrollLeftMax) {
	      this.scrollLeft = scrollLeft;
	      if (this.header) {
	        this.header.setScrollLeft(scrollLeft, scrollLeftMax);
	        this.lazyNotifyHeaderScrollLeftMax();
	      }
	    }
	  }, {
	    key: "setScrollLeft",
	    value: function setScrollLeft(scrollLeft) {
	      this.props.setScrollLeft(scrollLeft);
	    }
	  }, {
	    key: "getScrollLeft",
	    value: function getScrollLeft() {
	      return this.scrollLeft || 0;
	    }
	  }, {
	    key: "getScrollLeftMax",
	    value: function getScrollLeftMax() {
	      return this.props.getScrollLeftMax();
	    }
	  }, {
	    key: "setColumnRenderStartIndex",
	    value: function setColumnRenderStartIndex(columnRenderStartIndex) {
	      if (this.header) {
	        this.header.setColumnRenderStartIndex(columnRenderStartIndex);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var className = (0, _join.default)('InovuaReactDataGrid__header-layout', this.props.stickyHeader && 'InovuaReactDataGrid__header-layout__sticky-header');
	      return _react.default.createElement("div", {
	        ref: this.headerDomNode,
	        className: className
	      }, this.renderGroupToolbar(), this.renderHeaderWrapper(), this.renderDragCell(), this.renderDragGroupItem(), this.renderDragHeaderGroup(), this.renderReorderIndicator());
	    }
	  }, {
	    key: "renderGroupToolbar",
	    value: function renderGroupToolbar() {
	      var _this$props = this.props,
	        columnsMap = _this$props.columnsMap,
	        onGroupByChange = _this$props.onGroupByChange,
	        onHeaderSortClick = _this$props.onHeaderSortClick,
	        renderGroupItem = _this$props.renderGroupItem,
	        renderSortTool = _this$props.renderSortTool,
	        renderGroupToolbar = _this$props.renderGroupToolbar,
	        groupBy = _this$props.computedGroupBy,
	        disableGroupByToolbar = _this$props.disableGroupByToolbar,
	        i18n = _this$props.i18n,
	        rtl = _this$props.rtl,
	        theme = _this$props.theme;
	      if (!groupBy || !renderGroupToolbar) {
	        return null;
	      }
	      return renderGroupToolbar({
	        columnsMap: columnsMap,
	        groupBy: groupBy,
	        rtl: rtl,
	        theme: theme,
	        renderSortTool: renderSortTool,
	        onGroupByChange: onGroupByChange,
	        disableGroupByToolbar: disableGroupByToolbar,
	        renderGroupItem: renderGroupItem,
	        headerGroupPlaceholderText: i18n('dragHeaderToGroup'),
	        onItemMouseDown: this.onGroupItemMouseDown,
	        onSortClick: onHeaderSortClick,
	        ref: this.groupToolbar
	      });
	    }
	  }, {
	    key: "renderHeaderWrapper",
	    value: function renderHeaderWrapper() {
	      var props = this.props;
	      var computedShowHeader = props.computedShowHeader;
	      if (!computedShowHeader) {
	        return null;
	      }
	      var scrollLeft = (this.scrollLeft !== undefined ? this.scrollLeft : props.scrollLeft) || 0;
	      var groupBy = this.props.computedGroupBy && this.props.computedGroupBy.length ? this.props.computedGroupBy : null;
	      return _react.default.createElement(_HeaderWrapper.default, _objectSpread(_objectSpread({}, props), {}, {
	        groupBy: groupBy,
	        onHeaderGroupMouseDown: this.onHeaderGroupMouseDown,
	        onHeaderCellMouseDown: this.onHeaderCellMouseDown,
	        onHeaderCellTouchStart: this.onHeaderCellTouchStart,
	        ref: this.headerWrapper,
	        refHeader: this.refHeader,
	        scrollLeft: scrollLeft,
	        setScrollLeft: this.setScrollLeft
	      }));
	    }
	  }, {
	    key: "renderDragCell",
	    value: function renderDragCell() {
	      return _react.default.createElement(_DragCell.default, {
	        ref: this.refDragCell
	      });
	    }
	  }, {
	    key: "renderDragGroupItem",
	    value: function renderDragGroupItem() {
	      if (!this.props.renderDragGroupItem) {
	        return null;
	      }
	      return this.props.renderDragGroupItem(this.refDragGroupItem);
	    }
	  }, {
	    key: "renderDragHeaderGroup",
	    value: function renderDragHeaderGroup() {
	      if (!this.props.computedGroups) {
	        return;
	      }
	      return _react.default.createElement(_DragHeaderGroup.default, {
	        ref: this.refDragHeaderGroup
	      });
	    }
	  }, {
	    key: "onGroupItemMouseDown",
	    value: function onGroupItemMouseDown(column, index, event) {
	      this.onHeaderCellMouseDown(column, event, {
	        dragTarget: 'group',
	        dragIndex: index
	      });
	    }
	  }, {
	    key: "getCellDOMNodeAt",
	    value: function getCellDOMNodeAt(index) {
	      return this.header.getCellDOMNodeAt(index);
	    }
	  }, {
	    key: "getHeader",
	    value: function getHeader() {
	      return this.header;
	    }
	  }, {
	    key: "onHeaderGroupMouseDown",
	    value: function onHeaderGroupMouseDown(event, headerGroupProps, headerGroup) {
	      if (event.ctrlKey || event.metaKey) {
	        return;
	      }
	      if (this._dragIndex !== undefined) {
	        return;
	      }
	      if (headerGroupProps.group && headerGroupProps.group.draggable === false) {
	        return;
	      }
	      var dragTargetNode = headerGroup.domRef ? headerGroup.domRef.current : null;
	      var shouldStop = (0, _toConsumableArray2.default)(dragTargetNode.querySelectorAll('.InovuaReactDataGrid__column-header__filter-wrapper')).reduce(function (shouldStop, filterWrapperNode) {
	        if ((0, _contains.default)(filterWrapperNode, event.target) || filterWrapperNode === event.target) {
	          return true;
	        }
	        return shouldStop;
	      }, false);
	      if (shouldStop) {
	        return;
	      }
	      var groupColumns = headerGroupProps.columns.reduce(function (acc, colId) {
	        acc[colId] = true;
	        return acc;
	      }, {});
	      this.groupColumns = groupColumns;
	      var dragBoxes = this.header.getGroupsAndCells().filter(function (item) {
	        if (item === headerGroup) {
	          return true;
	        }
	        if (item.props.id in groupColumns) {
	          return false;
	        }
	        return !item.props.isHeaderGroup;
	      });
	      var dragIndex = dragBoxes.indexOf(headerGroup);
	      var dragTargetIndex = this.props.columnsMap[headerGroup.props.columns[0]].computedVisibleIndex;
	      var dragTargetDepth = headerGroup.props.depth;
	      var dragTargetLength = headerGroup.props.columns.length;
	      var parentsForColumns = getParentsForColumns(this.props.visibleColumns, this.props.computedGroupsMap, this.props.computedGroupsDepth);
	      this.maybeDragMouseDown(event, {
	        dragTarget: 'headergroup',
	        dragTargetIndex: dragTargetIndex,
	        dragTargetDepth: dragTargetDepth,
	        dragTargetLength: dragTargetLength,
	        parentsForColumns: parentsForColumns,
	        dragTargetNode: dragTargetNode,
	        dragIndex: dragIndex,
	        dragBoxes: dragBoxes,
	        allowTargetChange: false,
	        ranges: (0, _getRangesForBoxes.default)(dragBoxes, function (i) {
	          return i;
	        })
	      });
	    }
	  }, {
	    key: "onHeaderCellTouchStart",
	    value: function onHeaderCellTouchStart() {
	      return this.onHeaderCellMouseDown.apply(this, arguments);
	    }
	  }, {
	    key: "onHeaderCellMouseDown",
	    value: function onHeaderCellMouseDown(_ref3, event) {
	      var visibleIndex = _ref3.computedVisibleIndex;
	      var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	          dragTarget: 'header'
	        },
	        _ref4$dragTarget = _ref4.dragTarget,
	        dragTarget = _ref4$dragTarget === void 0 ? 'header' : _ref4$dragTarget,
	        dragIndex = _ref4.dragIndex;
	      if (this.props.reorderColumns === false) {
	        return;
	      }
	      if ((0, _isFocusable.default)(event.target)) {
	        return;
	      }
	      if (event.nativeEvent.which == 3 || event.metaKey || event.ctrlKey) {
	        return;
	      }
	      if (dragIndex === undefined) {
	        dragIndex = visibleIndex;
	      }
	      if (event.ctrlKey || event.metaKey) {
	        return;
	      }
	      var allowTargetChange = undefined;
	      var dragColumn;
	      var dragTargetNode = this.getCellDOMNodeAt(visibleIndex);
	      if (dragTarget == 'header') {
	        dragColumn = this.props.visibleColumns[visibleIndex];
	        if (!dragColumn || dragColumn.groupColumn || dragColumn.draggable === false) {
	          event.stopPropagation();
	          return;
	        }
	        if (this.props.computedGroupBy) {
	          if (this.props.computedGroupBy.indexOf(dragColumn.id) != -1 || this.props.computedGroupBy.indexOf(dragColumn.name) != -1) {
	            allowTargetChange = false;
	          }
	        }
	        if (dragColumn.draggable === false) {
	          return;
	        }
	        if (dragColumn.groupBy === false) {
	          allowTargetChange = false;
	        }
	      }
	      var dragTargetIndex = dragIndex;
	      var dragTargetDepth = dragColumn && dragColumn.group && this.props.computedGroupsMap && this.props.computedGroupsMap[dragColumn.group] ? this.props.computedGroupsMap[dragColumn.group].computedDepth + 1 : this.props.computedGroupsDepth + 1;
	      var parentsForColumns = getParentsForColumns(this.props.visibleColumns, this.props.computedGroupsMap, this.props.computedGroupsDepth);
	      this.maybeDragMouseDown(event, {
	        dragTarget: dragTarget,
	        dragIndex: dragIndex,
	        dragTargetNode: dragTargetNode,
	        parentsForColumns: parentsForColumns,
	        dragTargetIndex: dragTargetIndex,
	        dragTargetDepth: dragTargetDepth,
	        dragTargetLength: 1,
	        allowTargetChange: allowTargetChange
	      });
	    }
	  }, {
	    key: "maybeDragMouseDown",
	    value: function maybeDragMouseDown(event, _ref5) {
	      var _this3 = this;
	      var dragTarget = _ref5.dragTarget,
	        dragIndex = _ref5.dragIndex,
	        allowTargetChange = _ref5.allowTargetChange,
	        ranges = _ref5.ranges,
	        parentsForColumns = _ref5.parentsForColumns,
	        dragTargetIndex = _ref5.dragTargetIndex,
	        dragTargetDepth = _ref5.dragTargetDepth,
	        dragTargetNode = _ref5.dragTargetNode,
	        dragTargetLength = _ref5.dragTargetLength;
	      if (this.props.computedPivot) {
	        return;
	      }
	      this._dragIndex = dragIndex;
	      var _removeListeners;
	      var mouseMoveEventCount = 0;
	      var didSetupDrag = false;
	      var cleanup = function cleanup() {
	        delete _this3._dragIndex;
	        if (_removeListeners) {
	          _removeListeners();
	        }
	      };
	      var onMouseUp = cleanup;
	      var onMouseMove = function onMouseMove(event) {
	        if (didSetupDrag) {
	          return;
	        }
	        mouseMoveEventCount++;
	        if (mouseMoveEventCount > 1) {
	          didSetupDrag = true;
	          _removeListeners();
	          _this3.setupDrag({
	            dragTarget: dragTarget,
	            dragIndex: dragIndex,
	            allowTargetChange: allowTargetChange,
	            ranges: ranges,
	            parentsForColumns: parentsForColumns,
	            dragTargetIndex: dragTargetIndex,
	            dragTargetDepth: dragTargetDepth,
	            dragTargetLength: dragTargetLength,
	            dragTargetNode: dragTargetNode
	          }, event);
	        }
	      };
	      var mouseup = _isMobile.default ? 'touchend' : 'mouseup';
	      var mousemove = _isMobile.default ? 'touchmove' : 'mousemove';
	      _removeListeners = function removeListeners() {
	        _removeListeners = null;
	        globalObject.removeEventListener(mouseup, onMouseUp, false);
	        globalObject.removeEventListener(mousemove, onMouseMove, false);
	      };
	      if (_isMobile.default) {
	        setTimeout(function () {
	          onMouseUp();
	        }, 350);
	      }
	      globalObject.addEventListener(mouseup, onMouseUp, false);
	      globalObject.addEventListener(mousemove, onMouseMove, false);
	    }
	  }, {
	    key: "renderReorderIndicator",
	    value: function renderReorderIndicator() {
	      var size = this.props.reorderProxySize;
	      return _react.default.createElement(ReorderArrow, {
	        ref: this.refReorderArrow,
	        size: size,
	        rtl: this.props.rtl,
	        renderReorderIndicator: this.props.renderReorderIndicator
	      });
	    }
	  }, {
	    key: "setReorderArrowAt",
	    value: function setReorderArrowAt(index, ranges, target) {
	      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	      var visible = arguments.length > 4 ? arguments[4] : undefined;
	      visible = visible !== undefined ? visible : index != DRAG_INFO.dragIndex || target != DRAG_INFO.dragTarget;
	      if (offset) {
	        visible = true;
	      }
	      var rtl = this.props.rtl;
	      this.reorderArrow.setVisible(visible);
	      var last = index == ranges.length;
	      var box = ranges[index];
	      var _DRAG_INFO = DRAG_INFO,
	        headerRegion = _DRAG_INFO.headerRegion,
	        initialScrollLeft = _DRAG_INFO.initialScrollLeft;
	      if (!box && last) {
	        var _box;
	        var lastBox = ranges[ranges.length - 1] || {
	          left: headerRegion.left,
	          right: headerRegion.left
	        };
	        box = (_box = {}, (0, _defineProperty2.default)(_box, rtl ? 'right' : 'left', rtl ? lastBox.left : lastBox.right), (0, _defineProperty2.default)(_box, "computedLocked", lastBox.computedLocked), _box);
	      }
	      box = box || (rtl ? {
	        right: 0
	      } : {
	        left: 0
	      });
	      var boxPos = rtl ? box.right : box.left;
	      if (rtl && this.props.nativeScroll && this.props.scrollbars.vertical) {
	        boxPos -= (0, _getScrollbarWidth.default)();
	      }
	      return this.setReorderArrowPosition(rtl ? -boxPos + headerRegion.right - offset : boxPos - headerRegion.left + offset, target);
	    }
	  }, {
	    key: "setReorderArrowPosition",
	    value: function setReorderArrowPosition(pos, target) {
	      var rtl = this.props.rtl;
	      this.reorderArrowPosition = this.reorderArrowPosition || {};
	      (0, _assignDefined2.default)(this.reorderArrowPosition, (0, _defineProperty2.default)({}, rtl ? 'right' : 'left', pos));
	      this.reorderArrow.set(_objectSpread((0, _defineProperty2.default)({
	        target: target
	      }, rtl ? 'right' : 'left', rtl ? this.reorderArrowPosition.right : this.reorderArrowPosition.left), DRAG_INFO.reorderProxyPosition[target]));
	      return this;
	    }
	  }, {
	    key: "setReorderArrowVisible",
	    value: function setReorderArrowVisible(visible) {
	      this.reorderArrow.setVisible(visible);
	      return this;
	    }
	  }, {
	    key: "getGroupToolbar",
	    value: function getGroupToolbar() {
	      return this.groupToolbar.current;
	    }
	  }, {
	    key: "getGroupByItems",
	    value: function getGroupByItems() {
	      if (!this.groupToolbar.current) {
	        return null;
	      }
	      return this.groupToolbar.current.getSortedItemsInfo();
	    }
	  }, {
	    key: "getHeaderCells",
	    value: function getHeaderCells() {
	      return this.header.getCells();
	    }
	  }, {
	    key: "getBoxesFor",
	    value: function getBoxesFor(target) {
	      if (target == 'header') {
	        return this.header.getCells();
	      }
	      if (target == 'group' && this.groupToolbar.current) {
	        return this.groupToolbar.current.getCells();
	      }
	      if (target == 'headergroup') {
	        return this.header.getGroupsAndCells();
	      }
	      return [];
	    }
	  }, {
	    key: "getDragBoxInstance",
	    value: function getDragBoxInstance(dragIndex, dragTarget, dragTargetDepth, dragTargetLength) {
	      if (dragTarget === 'group') {
	        return this.getGroupToolbar() && this.getGroupToolbar().getCells()[dragIndex];
	      }
	      var dragCell = this.getHeaderCells()[dragIndex];
	      var dragBox = dragCell;
	      if (dragTargetLength) {
	        var cellProps = dragCell.getProps();
	        while (cellProps.depth > dragTargetDepth) {
	          if (cellProps.parent) {
	            dragBox = cellProps.parent;
	            cellProps = dragBox.props;
	          } else {
	            break;
	          }
	        }
	      }
	      return dragBox;
	    }
	  }, {
	    key: "setupDrag",
	    value: function setupDrag(_ref6, event) {
	      var _DRAG_INFO2;
	      var dragTarget = _ref6.dragTarget,
	        dragIndex = _ref6.dragIndex,
	        _ref6$allowTargetChan = _ref6.allowTargetChange,
	        allowTargetChange = _ref6$allowTargetChan === void 0 ? true : _ref6$allowTargetChan,
	        parentsForColumns = _ref6.parentsForColumns,
	        dragTargetIndex = _ref6.dragTargetIndex,
	        dragTargetDepth = _ref6.dragTargetDepth,
	        dragTargetLength = _ref6.dragTargetLength;
	      var columns = this.props.visibleColumns;
	      var rtl = this.props.rtl;
	      var headerRegion = _region.default.from(this.headerDomNode.current);
	      var dragBox = this.getDragBoxInstance(dragIndex, dragTarget, dragTargetDepth, dragTargetLength);
	      var initialScrollLeft = this.getScrollLeft();
	      var dragBoxProps = dragBox.getProps ? dragBox.getProps() : dragBox.props;
	      var rtlOffset = Math.max(this.props.totalComputedWidth - this.props.size.width, 0);
	      var columnRanges = (0, _getRangesForColumns.default)(columns, {
	        rtl: rtl,
	        rtlOffset: rtlOffset,
	        initialOffset: rtl ? headerRegion.right : headerRegion.left,
	        headerRegion: headerRegion,
	        initialScrollLeft: initialScrollLeft,
	        availableWidth: Math.min(this.props.availableWidth, this.props.totalComputedWidth),
	        totalLockedEndWidth: this.props.totalLockedEndWidth
	      });
	      var groupToolbarCells = this.getGroupToolbar() && this.getGroupToolbar().getCells();
	      var groupByRanges = this.props.computedGroupBy && this.props.computedGroupBy.length ? (0, _getRangesForBoxes.default)(groupToolbarCells) || [] : [];
	      var dragProxy = dragTarget == 'header' ? this.dragCell : dragTarget == 'group' ? this.dragGroupItem : this.dragHeaderGroup;
	      var dragColumn = dragTarget === 'group' ? dragBoxProps.column : columns[dragIndex];
	      var headerDragColumn = dragTarget == 'header' ? dragColumn : null;
	      var columnId = dragTarget == 'header' ? headerDragColumn.id : dragTarget == 'group' ? dragColumn.id : null;
	      var dragBoxNode = dragBox.getDOMNode ? dragBox.getDOMNode() : null;
	      var dragBoxInitialRegion = dragBox && dragBox.getProxyRegion ? dragBox.getProxyRegion() : _region.default.from(dragBoxNode);
	      if (_DragCell.MAX_WIDTH && dragBoxInitialRegion.getWidth() > _DragCell.MAX_WIDTH) {
	        dragBoxInitialRegion.setWidth(_DragCell.MAX_WIDTH);
	      }
	      if (_region.default.from(dragBoxNode).getWidth() > headerRegion.getWidth() / 2) {
	        if (rtl) {
	          dragBoxInitialRegion.shift({
	            right: event.pageX - dragBoxInitialRegion.right - this.props.columnReorderScrollByAmount
	          });
	        } else {
	          dragBoxInitialRegion.shift({
	            left: event.pageX - dragBoxInitialRegion.left - this.props.columnReorderScrollByAmount
	          });
	        }
	      }
	      var dragBoxOffsets = (0, _defineProperty2.default)({
	        top: headerRegion.top
	      }, rtl ? 'right' : 'left', rtl ? headerRegion.right : headerRegion.left);
	      var extendedDragBoxProps = _objectSpread({}, dragBoxProps);
	      if (this.props.renderColumnReorderProxy) {
	        Object.assign(extendedDragBoxProps, {
	          renderColumnReorderProxy: this.props.renderColumnReorderProxy
	        });
	      }
	      dragProxy.setProps(extendedDragBoxProps);
	      var dragProxyPosition = (0, _defineProperty2.default)({
	        top: dragBoxInitialRegion.top - dragBoxOffsets.top
	      }, rtl ? 'right' : 'left', rtl ? dragBoxOffsets.right - dragBoxInitialRegion.right : dragBoxInitialRegion.left - dragBoxOffsets.left);
	      dragProxy.setHeight(dragBoxInitialRegion.height);
	      dragProxy.setWidth(dragBoxInitialRegion.width);
	      dragProxy.setTop(dragProxyPosition.top);
	      if (rtl) {
	        dragProxy.setRight(dragProxyPosition.right);
	      } else {
	        dragProxy.setLeft(dragProxyPosition.left);
	      }
	      var maxHeaderIndex = columns.length - (0, _getUndraggableSuccessiveCount.default)((0, _toConsumableArray2.default)(columns).reverse());
	      var minHeaderIndex = (0, _getUndraggableSuccessiveCount.default)(columns);
	      var validDropPositions = columns.reduce(function (acc, col, i) {
	        acc[i] = true;
	        return acc;
	      }, {});
	      validDropPositions[columns.length] = true;
	      if (this.props.groups && this.props.groups.length && !this.props.allowGroupSplitOnReorder) {
	        validDropPositions = getValidDropPositions({
	          dragTargetDepth: dragTargetDepth,
	          dragTargetIndex: dragTargetIndex,
	          dragTargetLength: dragTargetLength,
	          parentsForColumns: parentsForColumns,
	          lockedForColumns: columns.map(function (c) {
	            return c.computedLocked;
	          }),
	          columns: columns,
	          allowGroupSplitOnReorder: this.props.allowGroupSplitOnReorder,
	          maxDepth: this.props.computedGroupsDepth + 1
	        });
	      }
	      if (validDropPositions && !validDropPositions[dragIndex] && dragTarget != 'group') {
	        validDropPositions[dragIndex] = true;
	      }
	      var wrapperNode = this.headerDomNode ? this.headerDomNode.current : null;
	      var filterRowHeight = 0;
	      if (this.props.computedFilterable) {
	        var filterWrapperNode = wrapperNode.querySelector('.InovuaReactDataGrid__column-header__filter-wrapper');
	        if (filterWrapperNode) {
	          filterRowHeight = filterWrapperNode.offsetHeight;
	        }
	      }
	      DRAG_INFO = (_DRAG_INFO2 = {
	        allowTargetChange: allowTargetChange,
	        columnId: columnId,
	        headerRegion: headerRegion,
	        headerDragColumn: headerDragColumn,
	        minHeaderIndex: minHeaderIndex,
	        maxHeaderIndex: maxHeaderIndex,
	        dragColumn: dragColumn,
	        dragColumnsIds: dragTarget == 'headergroup' ? dragBox.props.columns : null,
	        dragBox: dragBox,
	        dragBoxInitialRegion: dragBoxInitialRegion,
	        dragBoxRegion: dragBoxInitialRegion.clone(),
	        dragBoxProps: dragBoxProps,
	        dragBoxOffsets: dragBoxOffsets,
	        dragProxy: dragProxy,
	        dragProxyInitialPosition: dragProxyPosition,
	        dragTarget: dragTarget,
	        dropTarget: dragTarget,
	        dragIndex: dragIndex,
	        columnRanges: columnRanges,
	        groupByRanges: groupByRanges,
	        parentsForColumns: parentsForColumns,
	        dragTargetIndex: dragTargetIndex,
	        dragTargetDepth: dragTargetDepth,
	        dragTargetLength: dragTargetLength,
	        scrollLeftMax: this.props.getScrollLeftMax(),
	        initialScrollLeft: initialScrollLeft
	      }, (0, _defineProperty2.default)(_DRAG_INFO2, "headerRegion", headerRegion), (0, _defineProperty2.default)(_DRAG_INFO2, "validDropPositions", validDropPositions), _DRAG_INFO2);
	      var groupToolbarNode = this.groupToolbar.current ? this.groupToolbar.current.domRef ? this.groupToolbar.current.domRef.current : null : null;
	      var headerGroupTargetNode = wrapperNode;
	      var groupTargetNode = groupToolbarNode || this.headerDomNode.current;
	      var groupComputedStyle = getComputedStyle(groupTargetNode);
	      DRAG_INFO.reorderProxyPosition = {
	        group: {
	          top: parseInt(groupComputedStyle.paddingTop),
	          bottom: groupTargetNode.offsetHeight - parseInt(groupComputedStyle.paddingBottom)
	        },
	        header: {
	          top: this.props.computedGroupBy ? groupToolbarNode ? groupTargetNode.offsetHeight : this.headerDomNode.current.offsetTop : 0,
	          bottom: headerGroupTargetNode.offsetHeight - filterRowHeight
	        },
	        headergroup: {
	          top: this.props.computedGroupBy ? groupToolbarNode ? groupTargetNode.offsetHeight : this.headerDomNode.current.offsetTop : 0,
	          bottom: headerGroupTargetNode.offsetHeight - filterRowHeight
	        }
	      };
	      this.setReorderArrowAt(dragIndex, dragTarget === 'group' ? groupByRanges : columnRanges, dragTarget);
	      this.setReorderArrowPosition(undefined, dragTarget);
	      dragProxy.setDragging(true);
	      this.props.coverHandleRef.current.setActive(true);
	      this.props.coverHandleRef.current.setCursor('grabbing');
	      var headerNode = this.headerDomNode ? this.headerDomNode.current : null;
	      (0, _setupColumnDrag.default)({
	        constrainTo: this.props.constrainReorder ? _region.default.from(headerNode.parentNode) : undefined,
	        region: dragBoxInitialRegion
	      }, {
	        onDrag: this.onHeaderCellDrag,
	        onDrop: this.onHeaderCellDrop
	      }, event);
	    }
	  }, {
	    key: "onHeaderCellDrop",
	    value: function onHeaderCellDrop() {
	      var _this4 = this;
	      this.props.coverHandleRef.current.setActive(false);
	      delete this._dragIndex;
	      var dropIndex = this.dropIndex,
	        props = this.props;
	      if (dropIndex === undefined || !DRAG_INFO) {
	        if (DRAG_INFO) {
	          DRAG_INFO.dragProxy.setDragging(false);
	        }
	        this.setReorderArrowVisible(false);
	        DRAG_INFO = null;
	        return;
	      }
	      var _DRAG_INFO3 = DRAG_INFO,
	        dragColumn = _DRAG_INFO3.dragColumn,
	        columnId = _DRAG_INFO3.columnId,
	        dragColumnsIds = _DRAG_INFO3.dragColumnsIds,
	        dragTarget = _DRAG_INFO3.dragTarget,
	        dropTarget = _DRAG_INFO3.dropTarget,
	        dragProxy = _DRAG_INFO3.dragProxy,
	        newLocked = _DRAG_INFO3.newLocked;
	      var _DRAG_INFO4 = DRAG_INFO,
	        dragIndex = _DRAG_INFO4.dragIndex;
	      DRAG_INFO = null;
	      this.setReorderArrowVisible(false);
	      dragProxy.setDragging(false);
	      var columns = this.props.visibleColumns;
	      var currentLocked = columns[dragIndex].computedLocked;
	      if (dropIndex == dragIndex && newLocked === currentLocked && dragTarget == dropTarget) {
	        return;
	      }
	      if (this.props.virtualizeColumns) {
	        setTimeout(function () {
	          _this4.header.updateColumns();
	        }, 10);
	      }
	      if (dragTarget == 'headergroup') {
	        if (dropIndex == dragIndex && dragTarget == dropTarget && newLocked === currentLocked) {
	          return;
	        }
	        if (columns[dropIndex]) {
	          this.moveColumnsBeforeIndex(dragColumnsIds, columns[dropIndex].computedVisibleIndex, newLocked);
	        } else if (dropIndex == columns.length) {
	          var col = columns[columns.length - 1];
	          if (col) {
	            this.moveColumnsBeforeIndex(dragColumnsIds, col.computedVisibleIndex + 1, newLocked);
	          }
	        }
	        return;
	      }
	      var visibleColumns = props.visibleColumns,
	        groupBy = props.computedGroupBy;
	      if (dropTarget == dragTarget) {
	        if (dragTarget == 'group') {
	          this.setGroupBy((0, _moveXBeforeY.default)(groupBy, dragIndex, dropIndex));
	        }
	        if (dragTarget == 'header') {
	          this.moveColumnsBeforeIndex([columnId], dropIndex, newLocked);
	        }
	      }
	      if (dragTarget == 'header' && dropTarget == 'group') {
	        var groupByColumn = visibleColumns[dragIndex];
	        var newGroupBy = [].concat(groupBy);
	        newGroupBy.splice(dropIndex, 0, groupByColumn.id);
	        this.setGroupBy(newGroupBy);
	      }
	      if (dragTarget == 'group' && dropTarget == 'header') {
	        this.ungroupColumnToIndex(columnId, dropIndex);
	      }
	    }
	  }, {
	    key: "ungroupColumnToIndex",
	    value: function ungroupColumnToIndex(columnId, dropIndex) {
	      var props = this.props;
	      var allColumns = props.allColumns,
	        visibleColumns = props.visibleColumns;
	      var dragColumn = allColumns.filter(function (c) {
	        return c.id === columnId;
	      })[0];
	      var newGroupBy = [].concat(this.props.computedGroupBy).filter(function (g) {
	        return g != columnId;
	      });
	      var columnAtDropIndex = visibleColumns[dropIndex];
	      if (columnAtDropIndex && columnAtDropIndex.id === columnId) {
	        this.setGroupBy(newGroupBy);
	        return;
	      }
	      var order = getColumnOrder(props, function (c) {
	        return c.id !== columnId;
	      });
	      var insertIndex = columnAtDropIndex ? order.indexOf(columnAtDropIndex.id) : order.length;
	      order.splice(insertIndex, 0, columnId);
	      var columnAtDropIndexOrLast = columnAtDropIndex || visibleColumns[visibleColumns.length - 1];
	      if (columnAtDropIndexOrLast.computedLocked != dragColumn.computedLocked) {
	        this.props.setColumnLocked(columnId, columnAtDropIndexOrLast.computedLocked);
	      }
	      this.setGroupBy(newGroupBy);
	      this.setColumnOrder(order);
	    }
	  }, {
	    key: "moveColumnsBeforeIndex",
	    value: function moveColumnsBeforeIndex(columnsIds, dropIndex, newLocked) {
	      var _this5 = this;
	      var props = this.props;
	      var visibleColumns = props.visibleColumns,
	        columnVisibilityMap = props.columnVisibilityMap,
	        allowGroupSplitOnReorder = props.allowGroupSplitOnReorder;
	      var columnOrder = getColumnOrder(props);
	      var columns = visibleColumns.filter(function (col) {
	        return columnsIds.indexOf(col.id) != -1;
	      });
	      var dragColumnsIndexesInAllColumns = columnsIds.map(function (columnId) {
	        return columnOrder.indexOf(columnId);
	      });
	      var dropBeforeIndexInAllColumns = visibleColumns[dropIndex] ? columnOrder.indexOf(visibleColumns[dropIndex].id) : columnOrder.length;
	      var firstDragIndex = dragColumnsIndexesInAllColumns[0];
	      if (!allowGroupSplitOnReorder && firstDragIndex < dropBeforeIndexInAllColumns) {
	        while (true) {
	          var columnRightBefore = columnOrder[dropBeforeIndexInAllColumns - 1];
	          if (columnRightBefore && columnVisibilityMap[columnRightBefore] === false) {
	            dropBeforeIndexInAllColumns--;
	            continue;
	          }
	          break;
	        }
	      }
	      var targetColumn = visibleColumns[dropIndex] || visibleColumns[visibleColumns.length - 1];
	      columns.forEach(function (col) {
	        if (newLocked != col.computedLocked) {
	          _this5.props.setColumnLocked(col.id, newLocked);
	        }
	      });
	      var newColumnOrder = (0, _moveXBeforeY.default)(columnOrder, dragColumnsIndexesInAllColumns, dropBeforeIndexInAllColumns);
	      this.setColumnOrder(newColumnOrder);
	    }
	  }, {
	    key: "onHeaderCellDrag",
	    value: function onHeaderCellDrag(_ref7) {
	      var diffLeft = _ref7.left,
	        diffTop = _ref7.top;
	      if (!DRAG_INFO) {
	        return;
	      }
	      var _DRAG_INFO5 = DRAG_INFO,
	        allowTargetChange = _DRAG_INFO5.allowTargetChange,
	        dragTarget = _DRAG_INFO5.dragTarget,
	        dragIndex = _DRAG_INFO5.dragIndex,
	        dragProxy = _DRAG_INFO5.dragProxy,
	        dragColumn = _DRAG_INFO5.dragColumn,
	        dragBoxInitialRegion = _DRAG_INFO5.dragBoxInitialRegion,
	        dragBoxOffsets = _DRAG_INFO5.dragBoxOffsets,
	        dragBoxRegion = _DRAG_INFO5.dragBoxRegion,
	        groupByRanges = _DRAG_INFO5.groupByRanges,
	        theRanges = _DRAG_INFO5.columnRanges,
	        headerRegion = _DRAG_INFO5.headerRegion,
	        scrollLeftMax = _DRAG_INFO5.scrollLeftMax,
	        initialScrollLeft = _DRAG_INFO5.initialScrollLeft,
	        validDropPositions = _DRAG_INFO5.validDropPositions;
	      dragBoxRegion.set({
	        left: dragBoxInitialRegion.left,
	        top: dragBoxInitialRegion.top,
	        bottom: dragBoxInitialRegion.bottom,
	        right: dragBoxInitialRegion.right
	      });
	      var _DRAG_INFO6 = DRAG_INFO,
	        dropTarget = _DRAG_INFO6.dropTarget;
	      var _this$props2 = this.props,
	        columnReorderScrollByAmount = _this$props2.columnReorderScrollByAmount,
	        rtl = _this$props2.rtl;
	      var scrollLeft = this.getScrollLeft();
	      var scrollDiff = scrollLeft - initialScrollLeft;
	      var initialDiffLeft = diffLeft;
	      dragBoxRegion.shift({
	        top: diffTop,
	        left: diffLeft
	      });
	      diffLeft += scrollDiff;
	      var minScrollLeft = Math.max(headerRegion.left, 0);
	      var maxScrollRight = headerRegion.right;
	      var groupToolbarNode = this.groupToolbar && this.groupToolbar.current && this.groupToolbar.current.domRef ? this.groupToolbar.current.domRef.current : null;
	      if (this.groupToolbar.current && allowTargetChange) {
	        var groupToolbarRegion = _region.default.from(groupToolbarNode);
	        if (dragBoxRegion.top + dragBoxRegion.height / 2 < groupToolbarRegion.bottom) {
	          if (dropTarget !== 'group' && dragColumn.groupBy !== false) {
	            dropTarget = DRAG_INFO.dropTarget = 'group';
	          }
	        } else {
	          if (dropTarget != 'header') {
	            dropTarget = DRAG_INFO.dropTarget = 'header';
	          }
	        }
	      }
	      var scrollAdjust = 0;
	      var dragProxyAdjust = 0;
	      var dragComputedLocked = this.props.visibleColumns[dragIndex].computedLocked;
	      if (dropTarget == 'header' || dropTarget == 'headergroup') {
	        if (dragBoxInitialRegion.left + initialDiffLeft - this.props.totalLockedStartWidth < minScrollLeft + SCROLL_MARGIN && initialDiffLeft < 0) {
	          scrollAdjust = -columnReorderScrollByAmount;
	        } else if (dragBoxInitialRegion.right + initialDiffLeft > maxScrollRight - SCROLL_MARGIN - this.props.totalLockedEndWidth && initialDiffLeft > 0) {
	          scrollAdjust = columnReorderScrollByAmount;
	        }
	        if (scrollAdjust) {
	          if (scrollLeft + scrollAdjust < 0) {
	            scrollAdjust = -scrollLeft;
	          }
	          if (scrollLeft + scrollAdjust > scrollLeftMax) {
	            scrollAdjust = scrollLeftMax - scrollLeft;
	          }
	          if (scrollAdjust) {
	            this.setScrollLeft(scrollLeft + scrollAdjust);
	            dragProxyAdjust = scrollAdjust;
	          }
	        }
	      }
	      if (rtl) {
	        dragProxy.setRight(dragBoxOffsets.right + -initialDiffLeft - dragBoxInitialRegion.right - dragProxyAdjust);
	      } else {
	        dragProxy.setLeft(dragBoxInitialRegion.left + initialDiffLeft - dragBoxOffsets.left - dragProxyAdjust);
	      }
	      dragProxy.setTop(dragBoxRegion.top - dragBoxOffsets.top);
	      var dir = dropTarget == 'group' && dragTarget == 'group' ? initialDiffLeft < 0 ? -1 : 1 : dragTarget != dropTarget || diffLeft < 0 ? -1 : 1;
	      if (dragComputedLocked) {
	        dir = initialDiffLeft < 0 ? -1 : 1;
	      }
	      if (rtl) {
	        dir *= -1;
	      }
	      var mapRange = function mapRange(r) {
	        if (!r.computedLocked) {
	          return _objectSpread(_objectSpread({}, r), {}, {
	            left: r.left - scrollDiff,
	            right: r.right - scrollDiff
	          });
	        }
	        return r;
	      };
	      var currentRanges = dropTarget === 'group' ? groupByRanges : theRanges;
	      var ranges = currentRanges.map(mapRange);
	      var compareRanges = currentRanges.map(mapRange);
	      var dragMinIndex = dropTarget == 'header' ? DRAG_INFO.minHeaderIndex : undefined;
	      var dragMaxIndex = dropTarget == 'header' ? DRAG_INFO.maxHeaderIndex : undefined;
	      var dropIndex;
	      var _getDropIndex = (0, _getDropIndex2.default)({
	          dir: dir,
	          rtl: rtl,
	          dragMinIndex: dragMinIndex,
	          dragMaxIndex: dragMaxIndex,
	          dragTarget: dragTarget,
	          dropTarget: dropTarget,
	          dragRange: _objectSpread(_objectSpread({}, ranges[dragIndex]), {}, {
	            left: dragBoxRegion.left,
	            right: dragBoxRegion.right,
	            index: dragIndex
	          }),
	          dragIndex: dragIndex,
	          ranges: compareRanges,
	          validDropPositions: dropTarget === dragTarget ? validDropPositions : undefined
	        }),
	        newDropIndex = _getDropIndex.index,
	        locked = _getDropIndex.locked;
	      DRAG_INFO.newLocked = locked;
	      if (newDropIndex != undefined) {
	        dropIndex = newDropIndex;
	      }
	      var offset = 0;
	      var visible;
	      if (locked === 'start' && newDropIndex === this.props.firstUnlockedIndex) {
	        offset = (rtl ? -1 : 1) * -11;
	      }
	      if (newDropIndex === this.props.firstLockedEndIndex && dragIndex !== this.props.firstLockedEndIndex) {
	        if (locked === 'end') {
	          offset = (rtl ? -1 : 1) * 4;
	        } else if (!locked) {
	          offset = (rtl ? -1 : 1) * -6;
	        }
	      }
	      if (newDropIndex === this.props.visibleColumns.length) {
	        offset = rtl ? 6 : -6;
	      }
	      if (locked == null && dragComputedLocked === 'end' && newDropIndex === this.props.firstLockedEndIndex) {
	        visible = true;
	      }
	      this.dropIndex = dropIndex;
	      this.setReorderArrowPosition(undefined, dropTarget);
	      this.setReorderArrowAt(dropIndex, compareRanges, dropTarget, offset, visible);
	    }
	  }, {
	    key: "setColumnOrder",
	    value: function setColumnOrder(newColumnOrder) {
	      var columnOrder = getColumnOrder(this.props);
	      if (this.props.setColumnOrder && JSON.stringify(columnOrder) !== JSON.stringify(newColumnOrder)) {
	        this.props.setColumnOrder(newColumnOrder);
	      }
	    }
	  }, {
	    key: "setGroupBy",
	    value: function setGroupBy(groupBy) {
	      if (this.props.onGroupByChange && JSON.stringify(groupBy) !== JSON.stringify(this.props.computedGroupBy)) {
	        this.props.onGroupByChange(groupBy);
	      }
	    }
	  }, {
	    key: "insertGroupBy",
	    value: function insertGroupBy(at, column) {
	      var props = this.props;
	      var order = (0, _toConsumableArray2.default)(props.computedGroupBy);
	      order.splice(at, 0, column.id);
	      this.setGroupBy(order);
	    }
	  }]);
	  return InovuaDataGridHeaderLayout;
	}(_reactClass.default);
	exports.default = InovuaDataGridHeaderLayout;
	InovuaDataGridHeaderLayout.propTypes = {
	  i18n: _propTypes.default.func.isRequired,
	  renderGroupToolbar: _propTypes.default.func,
	  renderDragGroupItem: _propTypes.default.func,
	  getScrollLeftMax: _propTypes.default.func.isRequired,
	  setScrollLeft: _propTypes.default.func.isRequired,
	  renderColumnReorderProxy: _propTypes.default.func,
	  stickyHeader: _propTypes.default.bool
	};

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _dragHelper = _interopRequireDefault(__webpack_require__(261));
	var emptyFn = function emptyFn() {};
	var _default = function _default(_ref) {
	  var constrainTo = _ref.constrainTo,
	    region = _ref.region;
	  var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var event = arguments.length > 2 ? arguments[2] : undefined;
	  var _onDrag = cfg.onDrag || emptyFn;
	  var _onDrop = cfg.onDrop || emptyFn;
	  (0, _dragHelper.default)(event, {
	    constrainTo: constrainTo,
	    region: region,
	    onDrag: function onDrag(event, config) {
	      event.preventDefault();
	      _onDrag({
	        left: config.diff.left || 0,
	        top: config.diff.top || 0
	      }, event);
	    },
	    onDrop: function onDrop(event, config) {
	      _onDrop(config.diff);
	    }
	  });
	};
	exports.default = _default;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _join = _interopRequireDefault(__webpack_require__(31));
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var ResizeOverlay = function (_React$Component) {
	  (0, _inherits2.default)(ResizeOverlay, _React$Component);
	  var _super = _createSuper(ResizeOverlay);
	  function ResizeOverlay(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, ResizeOverlay);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setConstrained", function (constrained) {
	      if (_this.state.constrained != constrained) {
	        _this.setState({
	          constrained: constrained
	        });
	      }
	      return (0, _assertThisInitialized2.default)(_this);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setOffset", function (offset) {
	      _this.setState({
	        offset: offset
	      });
	      return (0, _assertThisInitialized2.default)(_this);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setActive", function (active, cfg) {
	      _this.setState({
	        active: active,
	        offsetTop: cfg ? cfg.offsetTop || 0 : 0
	      });
	      return (0, _assertThisInitialized2.default)(_this);
	    });
	    _this.state = {
	      offset: 0,
	      constrained: false,
	      active: false
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(ResizeOverlay, [{
	    key: "render",
	    value: function render() {
	      var _proxyStyle;
	      var props = this.props;
	      var state = this.state;
	      var constrained = state.constrained;
	      var active = props.active !== undefined ? props.active : state.active;
	      var rtl = props.rtl,
	        columnResizeProxyWidth = props.columnResizeProxyWidth,
	        columnResizeHandleWidth = props.columnResizeHandleWidth;
	      var style = props.style;
	      if (active && props.activeStyle) {
	        style = Object.assign({}, style, props.activeStyle);
	      }
	      var className = (0, _join.default)(props.className, 'InovuaReactDataGrid__resize-overlay', active && 'InovuaReactDataGrid__resize-overlay--active');
	      var proxyClassName = (0, _join.default)('InovuaReactDataGrid__resize-proxy', constrained && 'InovuaReactDataGrid__resize-proxy--constrained');
	      var offset = this.state.offset + (columnResizeHandleWidth - columnResizeProxyWidth) / 2;
	      var proxyStyle = (_proxyStyle = {
	        transform: "translate3d(".concat((rtl ? -1 : 1) * offset, "px,0px, 0px)")
	      }, (0, _defineProperty2.default)(_proxyStyle, rtl ? 'right' : 'left', 0), (0, _defineProperty2.default)(_proxyStyle, rtl ? 'left' : 'right', 'unset'), (0, _defineProperty2.default)(_proxyStyle, "width", columnResizeProxyWidth), (0, _defineProperty2.default)(_proxyStyle, "top", this.state.active ? this.state.offsetTop || 0 : 0), (0, _defineProperty2.default)(_proxyStyle, "bottom", 0), (0, _defineProperty2.default)(_proxyStyle, "height", 'initial'), _proxyStyle);
	      if (this.props.resizeProxyStyle) {
	        proxyStyle = Object.assign({}, this.props.resizeProxyStyle, proxyStyle);
	      }
	      return _react.default.createElement("div", {
	        style: style,
	        className: className
	      }, _react.default.createElement("div", {
	        className: proxyClassName,
	        style: proxyStyle
	      }));
	    }
	  }]);
	  return ResizeOverlay;
	}(_react.default.Component);
	exports.default = ResizeOverlay;
	ResizeOverlay.propTypes = {
	  resizeProxyStyle: _propTypes.default.shape({})
	};

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _region = _interopRequireDefault(__webpack_require__(43));
	var _ResizeOverlay = _interopRequireDefault(__webpack_require__(570));
	var _setupColumnResize = _interopRequireDefault(__webpack_require__(572));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _FakeFlex = _interopRequireDefault(__webpack_require__(208));
	var _HeaderLayout = _interopRequireDefault(__webpack_require__(568));
	var _Content = _interopRequireDefault(__webpack_require__(557));
	var _context = __webpack_require__(144);
	var _isMobile = _interopRequireDefault(__webpack_require__(64));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var height100 = {
	  height: '100%'
	};
	var InovuaDataGridColumnLayout = function (_React$Component) {
	  (0, _inherits2.default)(InovuaDataGridColumnLayout, _React$Component);
	  var _super = _createSuper(InovuaDataGridColumnLayout);
	  function InovuaDataGridColumnLayout(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaDataGridColumnLayout);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollTop", 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "lastComputedProps", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "headerLayout", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDOMNode", function () {
	      return _this.columnLayoutRef.current;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderScrollingTopRegion", function () {
	      return null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderScrollingBottomRegion", function () {
	      return null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getContentRows", function () {
	      return _this.content.getRows();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollTop", function () {
	      return _this.scrollTop || 0;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderHeaderLayout", function (computedProps) {
	      return _react.default.createElement(_HeaderLayout.default, _objectSpread(_objectSpread({}, computedProps), {}, {
	        onResizeMouseDown: _this.onResizeMouseDown.bind((0, _assertThisInitialized2.default)(_this), computedProps),
	        onResizeTouchStart: _this.onResizeTouchStart.bind((0, _assertThisInitialized2.default)(_this), computedProps),
	        onFilterValueChange: computedProps.computedOnColumnFilterValueChange,
	        ref: _this.refHeaderLayout,
	        getScrollLeftMax: _this.getScrollLeftMax,
	        setScrollLeft: _this.setScrollLeft
	      }));
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderContent", function (computedProps) {
	      var groupBy = computedProps.groupBy;
	      var groupByValue = groupBy && groupBy.length ? groupBy : null;
	      return _react.default.createElement(_Content.default, _objectSpread(_objectSpread({
	        key: "content"
	      }, computedProps), {}, {
	        getScrollLeftMax: _this.getScrollLeftMax,
	        groupBy: groupByValue,
	        before: _this.renderLockedStartRows(computedProps),
	        after: _this.renderLockedEndRows(computedProps),
	        ref: _this.refContent,
	        columns: computedProps.visibleColumns,
	        minWidth: computedProps.minWidth,
	        maxWidth: computedProps.maxWidth,
	        onDragRowMouseDown: _this.onDragRowMouseDownHandle,
	        onContainerScrollHorizontal: _this.onContainerScrollHorizontal.bind((0, _assertThisInitialized2.default)(_this), computedProps),
	        onContainerScrollVertical: _this.onContainerScrollVertical.bind((0, _assertThisInitialized2.default)(_this), computedProps),
	        onColumnRenderStartIndexChange: _this.onColumnRenderStartIndexChange
	      }));
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDragRowMouseDownHandle", function (ev, index, cellNode) {});
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderLockedEndRows", function (computedProps) {
	      return null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderLockedStartRows", function (computedProps) {
	      return null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderLockedRows", function (rows, position, computedProps) {
	      return null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderResizeOverlay", function (computedProps) {
	      return _react.default.createElement(_ResizeOverlay.default, {
	        resizeProxyStyle: computedProps.resizeProxyStyle,
	        columnResizeProxyWidth: computedProps.columnResizeProxyWidth,
	        columnResizeHandleWidth: computedProps.columnResizeHandleWidth,
	        rtl: computedProps.rtl,
	        ref: _this.refResizeOverlay
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onColumnRenderStartIndexChange", function (columnRenderStartIndex) {
	      if (_this.headerLayout) {
	        _this.headerLayout.setColumnRenderStartIndex(columnRenderStartIndex);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onContainerScrollVertical", function (computedProps, scrollTop) {
	      _this.scrollTop = scrollTop;
	      var computedLockedRows = computedProps.computedLockedRows,
	        rowHeight = computedProps.rowHeight,
	        stickyHeaders = computedProps.stickyHeaders,
	        groupBy = computedProps.groupBy;
	      if (rowHeight && stickyHeaders && groupBy && groupBy.length) {
	        _this.updateStickyHeader(scrollTop);
	      }
	      if (computedLockedRows && computedLockedRows.length) {
	        _this.updateLockedRows(scrollTop);
	      }
	      if (computedProps.onScroll) {
	        computedProps.onScroll();
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onContainerScrollHorizontal", function (computedProps, scrollLeft, scrollLeftMax) {
	      _this.scrollLeft = scrollLeft;
	      if (_this.headerLayout) {
	        _this.headerLayout.onContainerScrollHorizontal(scrollLeft, scrollLeftMax);
	      }
	      if (computedProps.onScroll) {
	        computedProps.onScroll();
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollLeft", function () {
	      return _this.scrollLeft || 0;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollLeftMax", function () {
	      var vl = _this.getVirtualList();
	      if (!vl) {
	        return 0;
	      }
	      return vl.scrollContainer.scrollLeftMax;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollTopMax", function () {
	      var vl = _this.getVirtualList();
	      if (!vl) {
	        return;
	      }
	      return vl.scrollContainer.scrollTopMax;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setScrollLeft", function (scrollLeft) {
	      var vl = _this.getVirtualList();
	      if (!vl) {
	        return;
	      }
	      vl.scrollLeft = scrollLeft;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setScrollTop", function (scrollTop) {
	      var vl = _this.getVirtualList();
	      if (!vl) {
	        return;
	      }
	      vl.scrollTop = scrollTop;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getVirtualList", function () {
	      return _this.content ? _this.content.getVirtualList() : null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "startEdit", function (args) {
	      return _this.content.startEdit(args);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cancelEdit", function (args) {
	      return _this.content.cancelEdit(args);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "completeEdit", function (args) {
	      return _this.content.completeEdit(args);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRenderRange", function () {
	      return _this.content.getRenderRange();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getHeaderLayout", function () {
	      return _this.headerLayout;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getHeaderCells", function () {
	      return _this.getHeaderLayout().getHeaderCells();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getHeader", function () {
	      return _this.headerLayout.getHeader();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getGroupToolbar", function () {
	      return _this.headerLayout.getGroupToolbar();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDOMColumnHeaderAt", function (index) {
	      return _this.headerLayout.getCellDOMNodeAt(index);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeMouseDown", function () {
	      var _this2;
	      if (_isMobile.default) {
	        return;
	      }
	      (_this2 = _this).onResizeDownAction.apply(_this2, arguments);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeDownAction", function (computedProps, config, _ref) {
	      var colHeaderNode = _ref.colHeaderNode,
	        event = _ref.event,
	        groupColumns = _ref.groupColumns;
	      var visibleIndex = config.computedVisibleIndex;
	      _this.setupColumnResize(computedProps, {
	        groupColumns: groupColumns,
	        visibleIndex: visibleIndex !== undefined ? visibleIndex : config.visibleIndex,
	        colHeaderNode: colHeaderNode,
	        headerNode: _this.getHeader().getDOMNode(),
	        event: event
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeTouchStart", function () {
	      var _this3;
	      (_this3 = _this).onResizeDownAction.apply(_this3, arguments);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setupColumnResize", function (computedProps, _ref2) {
	      var visibleIndex = _ref2.visibleIndex,
	        groupColumns = _ref2.groupColumns,
	        colHeaderNode = _ref2.colHeaderNode,
	        event = _ref2.event;
	      event.stopPropagation();
	      if (event.ctrlKey) {
	        return;
	      }
	      var rtl = computedProps.rtl;
	      var region = _region.default.from(event.currentTarget.firstChild || event.currentTarget);
	      var columns = computedProps.visibleColumns;
	      var firstFlexIndex = columns.reduce(function (index, col, i) {
	        if (col.flex != null && index == -1) {
	          return i;
	        }
	        return index;
	      }, -1);
	      var index = visibleIndex;
	      var headerRegion = _region.default.from(_this.getHeaderLayout().headerDomNode.current);
	      var constrainTo = _region.default.from(headerRegion.get());
	      constrainTo.set((0, _defineProperty2.default)({}, _this.props.rtl ? 'left' : 'right', (_this.props.rtl ? -1 : 1) * (globalObject.screen ? globalObject.screen.width * 3 : _region.default.from(document.documentElement).getRight() * 2)));
	      var column = columns[index];
	      var columnRegion = _region.default.from(colHeaderNode);
	      var extraOffset = column.lastInGroup ? region.width : region.width / 2;
	      var maxPos;
	      if (groupColumns) {
	        var columnsMap = computedProps.columnsMap;
	        var groupCols = groupColumns.map(function (colId) {
	          return columnsMap[colId];
	        });
	        var firstColumnRegion = _region.default.from(_this.getDOMColumnHeaderAt(groupCols[0].computedVisibleIndex));
	        var minWidth = groupCols.reduce(function (acc, col) {
	          return acc + col.computedMinWidth;
	        }, 0);
	        var maxWidth = groupCols.reduce(function (acc, col) {
	          return acc + (col.computedMaxWidth || Infinity);
	        }, 0);
	        var pos = rtl ? firstColumnRegion.right - minWidth - extraOffset : minWidth + firstColumnRegion.left - extraOffset;
	        constrainTo.set((0, _defineProperty2.default)({}, rtl ? 'right' : 'left', pos));
	        if (maxWidth !== Infinity) {
	          maxPos = rtl ? firstColumnRegion.right - maxWidth : firstColumnRegion.left + maxWidth + extraOffset;
	        }
	      } else {
	        var _minWidth = column.computedMinWidth;
	        if (_this.props.rtl) {
	          var right = columnRegion.right - _minWidth - extraOffset;
	          constrainTo.set({
	            right: right
	          });
	          if (column.computedMaxWidth) {
	            maxPos = columnRegion.right - column.computedMaxWidth;
	          }
	        } else {
	          var left = _minWidth + columnRegion.left - extraOffset;
	          constrainTo.set({
	            left: left
	          });
	          if (column.computedMaxWidth) {
	            maxPos = columnRegion.left + column.computedMaxWidth;
	          }
	        }
	      }
	      var shareSpace = computedProps.shareSpaceOnResize;
	      var nextCol = columns[index + 1];
	      var nextColHeaderNode = _this.getDOMColumnHeaderAt(index + 1);
	      var nextColumnRegion = nextCol ? _region.default.from(nextColHeaderNode) : null;
	      if (column && column.computedResizable === false || nextCol && nextCol.computedResizable === false) {
	        shareSpace = false;
	      }
	      if (shareSpace && nextColHeaderNode) {
	        if (_this.props.rtl) {
	          var nextColLeft = nextColumnRegion.left + nextCol.computedMinWidth;
	          if (!maxPos || nextColLeft > maxPos) {
	            maxPos = nextColLeft;
	          }
	        } else {
	          var nextColRight = nextColumnRegion.right - nextCol.computedMinWidth;
	          if (!maxPos || nextColRight < maxPos) {
	            maxPos = nextColRight;
	          }
	        }
	      }
	      if (maxPos != null) {
	        constrainTo.set((0, _defineProperty2.default)({}, _this.props.rtl ? 'left' : 'right', maxPos));
	      }
	      if (_this.props.rtl) {
	        if (nextCol) {
	          constrainTo.set({
	            left: constrainTo.left - computedProps.columnResizeHandleWidth / 2
	          });
	        }
	        constrainTo.set({
	          right: constrainTo.right + computedProps.columnResizeHandleWidth
	        });
	      }
	      _this.props.coverHandleRef.current.setCursor('col-resize');
	      (0, _setupColumnResize.default)({
	        headerRegion: headerRegion,
	        constrainTo: constrainTo,
	        region: region,
	        columns: columns,
	        index: index,
	        rtl: _this.props.rtl,
	        extraOffset: 0,
	        firstFlexIndex: firstFlexIndex,
	        groupColumns: groupColumns,
	        shareSpaceOnResize: computedProps.shareSpaceOnResize,
	        shareSpace: shareSpace,
	        nextColumnSize: nextColumnRegion ? nextColumnRegion.width : null,
	        initialSize: columnRegion.width
	      }, {
	        onResizeDragInit: _this.onResizeDragInit.bind((0, _assertThisInitialized2.default)(_this), computedProps),
	        onResizeDrag: _this.onResizeDrag.bind((0, _assertThisInitialized2.default)(_this), computedProps),
	        onResizeDrop: _this.onResizeDrop.bind((0, _assertThisInitialized2.default)(_this), computedProps)
	      }, event);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeDragInit", function (computedProps, _ref3) {
	      var offset = _ref3.offset,
	        constrained = _ref3.constrained;
	      var offsetTop = _this.getHeaderLayout().getHeader().domRef.current.offsetTop;
	      _this.props.coverHandleRef.current.setActive(true);
	      _this.resizeOverlay.setOffset(offset).setActive(true, {
	        offsetTop: offsetTop
	      }).setConstrained(constrained);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeDrop", function (computedProps, _ref4) {
	      var index = _ref4.index,
	        offset = _ref4.offset,
	        diff = _ref4.diff,
	        groupColumns = _ref4.groupColumns,
	        constrained = _ref4.constrained,
	        size = _ref4.size,
	        nextColumnSize = _ref4.nextColumnSize,
	        firstFlexIndex = _ref4.firstFlexIndex,
	        shareSpace = _ref4.shareSpace;
	      _this.props.coverHandleRef.current.setActive(false);
	      if (_this.resizeOverlay) {
	        _this.resizeOverlay.setOffset(offset).setConstrained(constrained).setActive(false);
	      }
	      if (computedProps.virtualizeColumns) {
	        setTimeout(function () {
	          _this.headerLayout.header.updateColumns();
	        }, 10);
	      }
	      computedProps.computedOnColumnResize({
	        groupColumns: groupColumns,
	        diff: diff,
	        index: index,
	        size: size,
	        nextColumnSize: nextColumnSize,
	        firstFlexIndex: firstFlexIndex,
	        shareSpace: shareSpace
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResizeDrag", function (computedProps, _ref5) {
	      var offset = _ref5.offset,
	        constrained = _ref5.constrained;
	      if (_this.resizeOverlay) {
	        _this.resizeOverlay.setOffset(offset).setConstrained(constrained);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isRowFullyVisible", function (index) {
	      return _this.content.isRowFullyVisible(index);
	    });
	    _this.refResizeOverlay = function (r) {
	      _this.resizeOverlay = r;
	    };
	    _this.refHeaderLayout = function (layout) {
	      _this.headerLayout = layout;
	    };
	    _this.columnLayoutRef = (0, _react.createRef)();
	    _this.refContent = function (c) {
	      _this.content = c;
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaDataGridColumnLayout, [{
	    key: "tryStartEdit",
	    value: function tryStartEdit(args) {
	      return this.content.tryStartEdit(args);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	      var className = (0, _join.default)('InovuaReactDataGrid__column-layout');
	      return _react.default.createElement(_context.Consumer, null, function (computedProps) {
	        var flexIndex = 1;
	        var useNativeFlex = computedProps.useNativeFlex;
	        _this4.lastComputedProps = computedProps;
	        return _react.default.createElement("div", {
	          ref: _this4.columnLayoutRef,
	          className: className,
	          style: _objectSpread(_objectSpread({}, height100), _this4.props.style)
	        }, _react.default.createElement(_FakeFlex.default, {
	          useNativeFlex: useNativeFlex,
	          flexIndex: flexIndex,
	          getNode: _this4.getDOMNode
	        }, _this4.renderHeaderLayout(computedProps), _this4.renderContent(computedProps)), computedProps && computedProps.rowReorderAutoScroll && _this4.renderScrollingTopRegion(), _this4.renderReorderRowProxy(computedProps), _this4.renderResizeOverlay(computedProps), _this4.renderDragRowArrow(computedProps), computedProps && computedProps.rowReorderAutoScroll && _this4.renderScrollingBottomRegion());
	      });
	    }
	  }, {
	    key: "renderReorderRowProxy",
	    value: function renderReorderRowProxy() {
	      return null;
	    }
	  }, {
	    key: "renderDragRowArrow",
	    value: function renderDragRowArrow() {
	      return null;
	    }
	  }, {
	    key: "updateLockedRows",
	    value: function updateLockedRows(scrollTop) {
	      return;
	    }
	  }, {
	    key: "updateStickyHeader",
	    value: function updateStickyHeader() {}
	  }]);
	  return InovuaDataGridColumnLayout;
	}(_react.default.Component);
	exports.default = InovuaDataGridColumnLayout;
	InovuaDataGridColumnLayout.defaultProps = {
	  reorderProxySize: 3
	};
	InovuaDataGridColumnLayout.propTypes = {
	  minRowWidth: _propTypes.default.number,
	  onMount: _propTypes.default.func,
	  onUnmount: _propTypes.default.func,
	  onRowMouseEnter: _propTypes.default.func,
	  onRowMouseLeave: _propTypes.default.func,
	  reorderProxySize: _propTypes.default.number.isRequired
	};

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	var _dragHelper = _interopRequireDefault(__webpack_require__(261));
	var emptyFn = function emptyFn() {};
	function _default(_ref, _ref2, event) {
	  var region = _ref.region,
	    headerRegion = _ref.headerRegion,
	    constrainTo = _ref.constrainTo,
	    columnHeaderNodes = _ref.columnHeaderNodes,
	    columns = _ref.columns,
	    rtl = _ref.rtl,
	    index = _ref.index,
	    firstFlexIndex = _ref.firstFlexIndex,
	    shareSpace = _ref.shareSpace,
	    shareSpaceOnResize = _ref.shareSpaceOnResize,
	    initialSize = _ref.initialSize,
	    nextColumnSize = _ref.nextColumnSize,
	    extraOffset = _ref.extraOffset,
	    groupColumns = _ref.groupColumns;
	  var _ref2$onResizeDragIni = _ref2.onResizeDragInit,
	    onResizeDragInit = _ref2$onResizeDragIni === void 0 ? emptyFn : _ref2$onResizeDragIni,
	    _ref2$onResizeDragSta = _ref2.onResizeDragStart,
	    onResizeDragStart = _ref2$onResizeDragSta === void 0 ? emptyFn : _ref2$onResizeDragSta,
	    _ref2$onResizeDrag = _ref2.onResizeDrag,
	    onResizeDrag = _ref2$onResizeDrag === void 0 ? emptyFn : _ref2$onResizeDrag,
	    _ref2$onResizeDrop = _ref2.onResizeDrop,
	    onResizeDrop = _ref2$onResizeDrop === void 0 ? emptyFn : _ref2$onResizeDrop;
	  var column = columns[index];
	  var nextColumn = columns[index + 1];
	  var initialPosition = rtl ? headerRegion.right - region.right : region.left - headerRegion.left;
	  var isContrained = function isContrained(dragRegion) {
	    var constrained = dragRegion.left <= constrainTo.left || dragRegion.right >= constrainTo.right;
	    return constrained;
	  };
	  (0, _dragHelper.default)(event, {
	    constrainTo: constrainTo,
	    region: region,
	    onDragInit: onResizeDragInit.bind(this, {
	      offset: initialPosition,
	      region: region,
	      initialPosition: initialPosition,
	      constrained: isContrained(region)
	    }),
	    onDragStart: function onDragStart(e, config) {
	      var constrained = isContrained(config.dragRegion);
	      onResizeDragStart({
	        initialPosition: initialPosition,
	        offset: initialPosition,
	        constrained: constrained,
	        resizing: true,
	        region: region,
	        column: column
	      });
	    },
	    onDrag: function onDrag(e, config) {
	      var diff = config.diff.left;
	      var offset = initialPosition + (rtl ? -1 : 1) * diff;
	      var constrained = isContrained(config.dragRegion);
	      e.preventDefault();
	      onResizeDrag({
	        constrained: constrained,
	        initialPosition: initialPosition,
	        diff: diff,
	        offset: offset,
	        region: region,
	        column: column
	      });
	    },
	    onDrop: function onDrop(e, config) {
	      var diff = (rtl ? -1 : 1) * Math.round(config.diff.left);
	      var offset = initialPosition + diff;
	      var constrained = isContrained(config.dragRegion);
	      var size = initialSize + diff;
	      var doShare = shareSpace;
	      var nextColSize;
	      if (doShare) {
	        nextColSize = nextColumnSize - diff;
	      }
	      onResizeDrop({
	        index: index,
	        constrained: constrained,
	        initialPosition: initialPosition,
	        region: region,
	        diff: diff,
	        offset: offset,
	        size: size,
	        shareSpaceOnResize: shareSpaceOnResize,
	        groupColumns: groupColumns,
	        initialSize: initialSize,
	        firstFlexIndex: firstFlexIndex,
	        shareSpace: doShare,
	        column: column,
	        nextColumn: nextColumn,
	        nextColumnSize: nextColSize
	      });
	    }
	  });
	}

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _reactDom = __webpack_require__(37);
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _PaginationToolbar = _interopRequireDefault(__webpack_require__(255));
	var _shouldComponentUpdate2 = _interopRequireDefault(__webpack_require__(56));
	var _ColumnLayout = _interopRequireDefault(__webpack_require__(571));
	var _FakeFlex = _interopRequireDefault(__webpack_require__(208));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _context = __webpack_require__(144);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	var InovuaDataGridLayout = function (_Component) {
	  (0, _inherits2.default)(InovuaDataGridLayout, _Component);
	  var _super = _createSuper(InovuaDataGridLayout);
	  function InovuaDataGridLayout(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaDataGridLayout);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "domNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refColumnLayout", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "columnLayout", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dragHeader", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDOMNode", function () {
	      return _this.domNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderPageList", function (list) {
	      if (!_reactDom.createPortal) {
	        return list;
	      }
	      return _this.props.renderInPortal(list);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowMouseEnter", function (event, rowProps) {
	      _this.props.onRowMouseEnter && _this.props.onRowMouseEnter(event, rowProps);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowMouseLeave", function (event, rowProps) {
	      _this.props.onRowMouseLeave && _this.props.onRowMouseLeave(event, rowProps);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getVirtualList", function () {
	      return _this.columnLayout && _this.columnLayout.getVirtualList();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRenderRange", function () {
	      return _this.columnLayout.getRenderRange();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isRowFullyVisible", function (index) {
	      return _this.columnLayout.isRowFullyVisible(index);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollLeft", function () {
	      return _this.columnLayout ? _this.columnLayout.scrollLeft || 0 : 0;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getColumnLayout", function () {
	      return _this.columnLayout;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setScrollLeft", function (scrollLeft) {
	      if (_this.columnLayout) {
	        _this.columnLayout.setScrollLeft(scrollLeft);
	        if (_this.dragHeader) {
	          _this.dragHeader.setScrollLeft(scrollLeft);
	        }
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollTop", function () {
	      return _this.columnLayout ? _this.columnLayout.scrollTop || 0 : 0;
	    });
	    _this.ref = function (domNode) {
	      _this.domNode = domNode;
	    };
	    _this.refColumnLayout = function (layout) {
	      _this.columnLayout = layout;
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaDataGridLayout, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _shouldComponentUpdate2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	      var Footer = this.props.Footer;
	      return _react.default.createElement(_context.Consumer, null, function (computedProps) {
	        var ColumnLayoutCmp = computedProps && computedProps.ColumnLayout || _ColumnLayout.default;
	        return _react.default.createElement("div", {
	          className: 'InovuaReactDataGrid__body',
	          ref: _this2.ref
	        }, _react.default.createElement(_FakeFlex.default, {
	          flexIndex: 0,
	          getNode: _this2.getDOMNode,
	          useNativeFlex: computedProps.useNativeFlex
	        }, _react.default.createElement(ColumnLayoutCmp, {
	          key: "collayout",
	          ref: _this2.refColumnLayout,
	          rtl: computedProps.rtl,
	          coverHandleRef: computedProps.coverHandleRef
	        }), _this2.renderPaginationToolbar(computedProps), computedProps.computedFooterRows && Footer ? _react.default.createElement(Footer, {
	          key: "footer",
	          rows: computedProps.computedFooterRows
	        }) : null));
	      });
	    }
	  }, {
	    key: "renderPaginationToolbar",
	    value: function renderPaginationToolbar(computedProps) {
	      var pagination = computedProps.pagination,
	        paginationProps = computedProps.paginationProps,
	        i18n = computedProps.i18n,
	        theme = computedProps.theme,
	        pageSizes = computedProps.pageSizes;
	      if (!pagination) {
	        return null;
	      }
	      if (!paginationProps || paginationProps.livePagination) {
	        return null;
	      }
	      var result;
	      if (computedProps.renderPaginationToolbar) {
	        result = computedProps.renderPaginationToolbar(paginationProps);
	      }
	      var paginationToolbarProps = _objectSpread(_objectSpread({
	        perPageText: i18n('perPageText'),
	        pageText: i18n('pageText'),
	        ofText: i18n('ofText'),
	        showingText: i18n('showingText'),
	        rtl: computedProps.rtl
	      }, paginationProps), {}, {
	        pageSizes: pageSizes,
	        onClick: stopPropagation,
	        theme: theme,
	        className: (0, _join.default)(paginationProps.className, this.props.useNativeFlex ? 'InovuaReactDataGrid-modifier--relative' : '')
	      });
	      paginationToolbarProps.bordered = false;
	      delete paginationToolbarProps.livePagination;
	      if (result === undefined) {
	        result = _react.default.createElement(_PaginationToolbar.default, _objectSpread(_objectSpread({
	          key: "paginationtoolbar"
	        }, paginationToolbarProps), {}, {
	          constrainTo: this.props.constrainTo,
	          renderPageList: this.renderPageList
	        }));
	      }
	      return result;
	    }
	  }]);
	  return InovuaDataGridLayout;
	}(_react.Component);
	(0, _defineProperty2.default)(InovuaDataGridLayout, "defaultProps", void 0);
	(0, _defineProperty2.default)(InovuaDataGridLayout, "propTypes", void 0);
	InovuaDataGridLayout.defaultProps = {
	  defaultScrollTop: 0,
	  onRowMouseEnter: function onRowMouseEnter() {},
	  onRowMouseLeave: function onRowMouseLeave() {},
	  rowPlaceholderDelay: 300
	};
	InovuaDataGridLayout.propTypes = {
	  i18n: _propTypes.default.func,
	  shouldComponentUpdate: _propTypes.default.func,
	  constrainTo: _propTypes.default.any,
	  Footer: _propTypes.default.any,
	  loading: _propTypes.default.bool,
	  onScroll: _propTypes.default.func,
	  onRowMouseEnter: _propTypes.default.func,
	  onRowMouseLeave: _propTypes.default.func
	};
	var _default = InovuaDataGridLayout;
	exports.default = _default;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _LoadMask = _interopRequireDefault(__webpack_require__(691));
	var _reactCleanProps = _interopRequireDefault(__webpack_require__(49));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _renderEmptyContent = _interopRequireDefault(__webpack_require__(270));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var stop = function stop(e) {
	  if (e.cancelable === false) {
	    return;
	  }
	  e.preventDefault();
	};
	var DEFAULT_CLASSNAME = 'InovuaReactDataGrid__load-mask';
	var DataGridLoadMask = function (_React$Component) {
	  (0, _inherits2.default)(DataGridLoadMask, _React$Component);
	  var _super = _createSuper(DataGridLoadMask);
	  function DataGridLoadMask(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, DataGridLoadMask);
	    _this = _super.call(this, props);
	    _this.visible = props.visible;
	    _this.maskRef = (0, _react.createRef)();
	    return _this;
	  }
	  (0, _createClass2.default)(DataGridLoadMask, [{
	    key: "setVisible",
	    value: function setVisible(visible) {
	      var _this2 = this;
	      if (this.props.livePagination) {
	        this.visible = visible;
	        var fn = function fn() {
	          var node = _this2.maskRef.current;
	          if (!node || !_this2.scroller) {
	            return;
	          }
	          node.style.visibility = visible ? 'visible' : 'hidden';
	          if (visible === false) {
	            _this2.scroller.scrollTop = 0;
	          }
	        };
	        if (!visible) {
	          globalObject.requestAnimationFrame(fn);
	        } else {
	          fn();
	        }
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setVisible(this.props.visible);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var livePagination = props.livePagination,
	        loadingText = props.loadingText,
	        visible = props.visible;
	      var style = props.style;
	      var cleanProps = (0, _reactCleanProps.default)(props, DataGridLoadMask.propTypes);
	      var className = (0, _join.default)(DEFAULT_CLASSNAME, props.className, livePagination && "".concat(DEFAULT_CLASSNAME, "--live-pagination"));
	      return _react.default.createElement(_LoadMask.default, _objectSpread(_objectSpread({}, cleanProps), {}, {
	        ref: this.maskRef,
	        style: style,
	        visible: visible,
	        className: className,
	        onWheel: livePagination ? stop : null
	      }), (0, _renderEmptyContent.default)(loadingText, 'loading'));
	    }
	  }]);
	  return DataGridLoadMask;
	}(_react.default.Component);
	exports.default = DataGridLoadMask;
	DataGridLoadMask.defaultProps = {
	  livePagination: false,
	  visible: false
	};
	DataGridLoadMask.propTypes = {
	  visible: _propTypes.default.bool,
	  loadingText: _propTypes.default.node,
	  livePagination: _propTypes.default.bool
	};

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _debounce = _interopRequireDefault(__webpack_require__(63));
	var _ComboBox = _interopRequireDefault(__webpack_require__(240));
	var _src = _interopRequireDefault(__webpack_require__(86));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var renderScroller = function renderScroller(props) {
	  delete props.tabIndex;
	  return _react.default.createElement("div", _objectSpread(_objectSpread({}, props), {}, {
	    className: "".concat(props.className, " InovuaReactDataGrid__column-header__filter--select__scroller")
	  }));
	};
	var renderListScroller = function renderListScroller(props) {
	  return _react.default.createElement(_src.default, _objectSpread(_objectSpread({}, props), {}, {
	    showScrollbars: true,
	    applyCSSContainOnScroll: false,
	    renderScroller: renderScroller,
	    viewStyle: {
	      width: '100%'
	    }
	  }));
	};
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	var defaultProps = {
	  nativeScroll: false
	};
	var SelectFilter = function (_React$Component) {
	  (0, _inherits2.default)(SelectFilter, _React$Component);
	  var _super = _createSuper(SelectFilter);
	  function SelectFilter(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, SelectFilter);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "selectRef", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getInputRef", function () {
	      var _this$selectRef;
	      return (_this$selectRef = _this.selectRef) === null || _this$selectRef === void 0 ? void 0 : _this$selectRef.current;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (_ref) {
	      var value = _ref.filterValue.value;
	      if (value && String(value).localeCompare(String(_this.props.filterValue && _this.props.filterValue.value))) {
	        if (_this.props.filterValue) {
	          _this.setValue(_this.props.filterValue.value);
	        }
	      }
	    });
	    var filterValue = props.filterValue;
	    _this.state = {
	      value: filterValue ? filterValue.value || null : null
	    };
	    _this.selectRef = (0, _react.createRef)();
	    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onValueChange = _this.onValueChange.bind((0, _assertThisInitialized2.default)(_this));
	    if (props.filterDelay && props.filterDelay >= 1) {
	      _this.onValueChange = (0, _debounce.default)(_this.onValueChange, props.filterDelay);
	    }
	    return _this;
	  }
	  (0, _createClass2.default)(SelectFilter, [{
	    key: "onChange",
	    value: function onChange(value) {
	      this.onValueChange(value);
	      this.setValue(value);
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value) {
	      this.setState({
	        value: value
	      });
	    }
	  }, {
	    key: "onValueChange",
	    value: function onValueChange(value) {
	      this.props.onChange && this.props.onChange(_objectSpread(_objectSpread({}, this.props.filterValue), {}, {
	        value: value
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	        filterValue = _this$props.filterValue,
	        readOnly = _this$props.readOnly,
	        disabled = _this$props.disabled,
	        style = _this$props.style,
	        nativeScroll = _this$props.nativeScroll,
	        filterEditorProps = _this$props.filterEditorProps,
	        rtl = _this$props.rtl,
	        theme = _this$props.theme;
	      var comboProps = {
	        readOnly: readOnly,
	        disabled: disabled,
	        theme: theme,
	        rtl: rtl,
	        style: _objectSpread({
	          minWidth: 0
	        }, style)
	      };
	      if (filterValue) {
	        comboProps.value = this.state.value;
	      }
	      var finalEditorProps = typeof filterEditorProps === 'function' ? filterEditorProps(this.props) : filterEditorProps;
	      var finalProps = _objectSpread(_objectSpread({
	        collapseOnSelect: true,
	        renderListScroller: nativeScroll ? undefined : renderListScroller,
	        dataSource: filterValue && filterValue.dataSource ? filterValue.dataSource : []
	      }, finalEditorProps), {}, {
	        onChange: this.onChange,
	        ref: this.selectRef,
	        className: 'InovuaReactDataGrid__column-header__filter InovuaReactDataGrid__column-header__filter--select'
	      }, comboProps);
	      var onKeyDown = finalProps.onKeyDown;
	      finalProps.onKeyDown = function (e) {
	        if (onKeyDown) {
	          onKeyDown(e);
	        }
	        stopPropagation(e);
	      };
	      return this.props.render && this.props.render(_react.default.createElement(_ComboBox.default, _objectSpread({}, finalProps)));
	    }
	  }]);
	  return SelectFilter;
	}(_react.default.Component);
	(0, _defineProperty2.default)(SelectFilter, "defaultProps", defaultProps);
	var _default = SelectFilter;
	exports.default = _default;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _TextInput = _interopRequireDefault(__webpack_require__(256));
	var _debounce = _interopRequireDefault(__webpack_require__(63));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var StringFilter = function (_React$Component) {
	  (0, _inherits2.default)(StringFilter, _React$Component);
	  var _super = _createSuper(StringFilter);
	  function StringFilter(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, StringFilter);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "input", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refInput", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (_ref) {
	      var value = _ref.filterValue.value;
	      if (String(value).localeCompare(String(_this.props.filterValue && _this.props.filterValue.value))) {
	        if (_this.props.filterValue) {
	          _this.onChange(_this.props.filterValue.value);
	        }
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getInputRef", function () {
	      return _this.input;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderClearIcon", function (_ref2) {
	      var width = _ref2.width,
	        height = _ref2.height;
	      return _react.default.createElement("svg", {
	        style: {
	          width: width,
	          height: height
	        },
	        viewBox: "0 0 10 10"
	      }, _react.default.createElement("path", {
	        fill: "none",
	        fillRule: "evenodd",
	        strokeLinecap: "round",
	        strokeWidth: "1.33",
	        d: "M1 1l8 8m0-8L1 9"
	      }));
	    });
	    _this.refInput = function (i) {
	      var _props$filterEditorPr;
	      var inputRef = props.inputRef || ((_props$filterEditorPr = props.filterEditorProps) === null || _props$filterEditorPr === void 0 ? void 0 : _props$filterEditorPr.inputRef);
	      if (inputRef) {
	        if (typeof inputRef === 'function') {
	          inputRef(i);
	        } else {
	          inputRef.current = i;
	        }
	      }
	      _this.input = i;
	    };
	    var filterValue = props.filterValue;
	    _this.state = {
	      value: filterValue ? filterValue.value || '' : ''
	    };
	    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onValueChange = _this.onValueChange.bind((0, _assertThisInitialized2.default)(_this));
	    if (props.filterDelay && props.filterDelay >= 1) {
	      _this.onValueChange = (0, _debounce.default)(_this.onValueChange, props.filterDelay, {
	        leading: false,
	        trailing: true
	      });
	    }
	    return _this;
	  }
	  (0, _createClass2.default)(StringFilter, [{
	    key: "onChange",
	    value: function onChange(value) {
	      this.onValueChange(value);
	      this.setValue(value);
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value) {
	      this.setState({
	        value: value
	      });
	    }
	  }, {
	    key: "onValueChange",
	    value: function onValueChange(value) {
	      this.props.onChange && this.props.onChange(_objectSpread(_objectSpread({}, this.props.filterValue), {}, {
	        value: value
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	        filterValue = _this$props.filterValue,
	        readOnly = _this$props.readOnly,
	        disabled = _this$props.disabled,
	        style = _this$props.style,
	        rtl = _this$props.rtl,
	        theme = _this$props.theme,
	        placeholder = _this$props.placeholder;
	      var inputProps = {
	        readOnly: readOnly,
	        disabled: disabled,
	        theme: theme,
	        rtl: rtl,
	        value: this.state.value,
	        placeholder: placeholder,
	        style: _objectSpread({
	          minWidth: 0
	        }, style)
	      };
	      var filterEditorProps;
	      if (filterValue) {
	        filterEditorProps = filterValue.filterEditorProps;
	        inputProps.value = this.state.value;
	      }
	      return this.props.render && this.props.render(_react.default.createElement(_TextInput.default, _objectSpread(_objectSpread({}, filterEditorProps), {}, {
	        type: "text",
	        ref: this.refInput,
	        onChange: this.onChange,
	        renderClearIcon: this.renderClearIcon,
	        className: "InovuaReactDataGrid__column-header__filter InovuaReactDataGrid__column-header__filter--string"
	      }, inputProps)));
	    }
	  }]);
	  return StringFilter;
	}(_react.default.Component);
	var _default = StringFilter;
	exports.default = _default;

/***/ },
/* 577 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(className) {
	  return function (element, modifier) {
	    var el = element ? "-".concat(element) : '';
	    var mod = modifier ? "--".concat(modifier) : '';
	    return "".concat(className).concat(el).concat(mod);
	  };
	};
	exports.default = _default;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(44));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _excluded = ["onClick", "className", "expanded", "size"];
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function ToggleIcon(_ref) {
	  var onClick = _ref.onClick,
	    className = _ref.className,
	    expanded = _ref.expanded,
	    _ref$size = _ref.size,
	    size = _ref$size === void 0 ? 17 : _ref$size,
	    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
	  return _react.default.createElement("div", _objectSpread(_objectSpread({}, rest), {}, {
	    className: className,
	    onClick: onClick
	  }), _react.default.createElement("svg", {
	    height: size,
	    width: size,
	    viewBox: "0 0 24 24"
	  }, expanded ? _react.default.createElement("path", {
	    d: "M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"
	  }) : _react.default.createElement("path", {
	    d: "M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
	  })));
	}
	var _default = ToggleIcon;
	exports.default = _default;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _isMobile = _interopRequireDefault(__webpack_require__(72));
	var _default = _isMobile.default ? {
	  onMouseDown: 'onTouchStart',
	  onMouseUp: 'onTouchEnd',
	  onMouseMove: 'onTouchMove'
	} : {
	  onMouseDown: 'onMouseDown',
	  onMouseUp: 'onMouseUp',
	  onMouseMove: 'onMouseMove'
	};
	exports.default = _default;

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getFocusableElements.default;
	  }
	});
	var _getFocusableElements = _interopRequireDefault(__webpack_require__(262));

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	function getMinMaxSize(props) {
	  var sizeType;
	  var single;
	  var style = props.style || {};
	  var result = {};
	  if (props.minSize) {
	    sizeType = (0, _typeof2.default)(props.minSize);
	    single = sizeType == 'number' || sizeType == 'string';
	    if (single) {
	      result.minWidth = props.minSize;
	      result.minHeight = props.minSize;
	    } else {
	      if (props.minSize.width) {
	        result.minWidth = props.minSize.width;
	      }
	      if (props.minSize.height) {
	        result.minHeight = props.minSize.height;
	      }
	    }
	  }
	  if (props.maxSize) {
	    sizeType = (0, _typeof2.default)(props.maxSize);
	    single = sizeType == 'number' || sizeType == 'string';
	    if (single) {
	      result.maxWidth = props.maxSize;
	      result.maxHeight = props.maxSize;
	    } else {
	      if (props.maxSize.width) {
	        result.maxWidth = props.maxSize.width;
	      }
	      if (props.maxSize.height) {
	        result.maxHeight = props.maxSize.height;
	      }
	    }
	  }
	  if (result.minWidth == undefined && style.minWidth != undefined) {
	    result.minWidth = style.minWidth;
	  }
	  if (result.maxWidth == undefined && style.maxWidth != undefined) {
	    result.maxWidth = style.maxWidth;
	  }
	  if (result.minHeight == undefined && style.minHeight != undefined) {
	    result.minHeight = style.minHeight;
	  }
	  if (result.maxHeight == undefined && style.maxHeight != undefined) {
	    result.maxHeight = style.maxHeight;
	  }
	  return result;
	}
	var _default = getMinMaxSize;
	exports.default = _default;

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _getArrowPositionDirection = _interopRequireDefault(__webpack_require__(583));
	var _clamp = _interopRequireDefault(__webpack_require__(81));
	function getLeftPosition(overlayRegion, targetRegion) {
	  return targetRegion.left - overlayRegion.left + targetRegion.width / 2;
	}
	function getTopPosition(overlayRegion, targetRegion) {
	  return targetRegion.top - overlayRegion.top + targetRegion.height / 2;
	}
	function getArrowPosition(_ref) {
	  var overlayRegion = _ref.overlayRegion,
	    targetRegion = _ref.targetRegion,
	    position = _ref.position,
	    arrowSize = _ref.arrowSize;
	  var arrowPosition = null;
	  var positionDirection = (0, _getArrowPositionDirection.default)(position);
	  var left = (0, _clamp.default)(getLeftPosition(overlayRegion, targetRegion), arrowSize / 2, overlayRegion.width - arrowSize / 2);
	  var top = (0, _clamp.default)(getTopPosition(overlayRegion, targetRegion), arrowSize / 2, overlayRegion.height - arrowSize / 2);
	  arrowPosition = {
	    top: {
	      position: {
	        left: left,
	        top: 'calc(100% - 1px)'
	      },
	      location: 'top'
	    },
	    bottom: {
	      position: {
	        left: left,
	        bottom: 'calc(100% - 1px)'
	      },
	      location: 'bottom'
	    },
	    right: {
	      position: {
	        top: top,
	        right: 'calc(100% - 1px)'
	      },
	      location: 'right'
	    },
	    left: {
	      position: {
	        top: top,
	        left: 'calc(100% - 1px)'
	      },
	      location: 'left'
	    }
	  }[positionDirection];
	  return arrowPosition;
	}
	var _default = getArrowPosition;
	exports.default = _default;

/***/ },
/* 583 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var topPositions = ['top', 'bc-tc', 'bl-tl', 'br-tr'];
	var bottomPositions = ['bottom', 'tc-bc', 'tl-bl', 'tr-br'];
	var rightPositions = ['right', 'lc-rc', 'tl-tr', 'bl-br'];
	var leftPositions = ['left', 'rc-lc', 'tr-tl', 'br-bl'];
	var noArrowPositions = ['br-tl', 'tl-br', 'tr-bl'];
	function isTopPosition(position) {
	  return topPositions.indexOf(position) !== -1;
	}
	function isBottomPosition(position) {
	  return bottomPositions.indexOf(position) !== -1;
	}
	function isLeftPosition(position) {
	  return leftPositions.indexOf(position) !== -1;
	}
	function isRightPosition(position) {
	  return rightPositions.indexOf(position) !== -1;
	}
	function getArrowPositionDirection(position) {
	  var positionTest = {
	    top: isTopPosition(position),
	    bottom: isBottomPosition(position),
	    right: isRightPosition(position),
	    left: isLeftPosition(position)
	  };
	  return Object.keys(positionTest).filter(function (position) {
	    return !!positionTest[position];
	  })[0];
	}
	var _default = getArrowPositionDirection;
	exports.default = _default;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	var _regionAlign = _interopRequireDefault(__webpack_require__(55));
	var _selectParent = _interopRequireDefault(__webpack_require__(101));
	var _getViewportRegion = _interopRequireDefault(__webpack_require__(215));
	function _default(constrainTo, domNode) {
	  var constrainRegion;
	  if (constrainTo === true) {
	    constrainRegion = (0, _getViewportRegion.default)();
	  }
	  if (!constrainRegion && typeof constrainTo === 'function') {
	    constrainTo = _regionAlign.default.from(constrainTo(domNode));
	  }
	  if (!constrainRegion && typeof constrainTo === 'string') {
	    constrainTo = (0, _selectParent.default)(constrainTo, domNode);
	  }
	  if (!constrainRegion && constrainTo) {
	    constrainRegion = _regionAlign.default.from(constrainTo);
	  }
	  return constrainRegion;
	}

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _regionAlign = _interopRequireDefault(__webpack_require__(55));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _getPositionOffsets = _interopRequireDefault(__webpack_require__(586));
	var _positionsMap = _interopRequireDefault(__webpack_require__(100));
	var _getArrowPosition = _interopRequireDefault(__webpack_require__(582));
	var _getConstrainRegion = _interopRequireDefault(__webpack_require__(584));
	var _isPositionBottom = _interopRequireDefault(__webpack_require__(587));
	var posiblePositions = Object.keys(_positionsMap.default);
	function getPosition(_ref) {
	  var _ref$constrainTo = _ref.constrainTo,
	    constrainTo = _ref$constrainTo === void 0 ? true : _ref$constrainTo,
	    targetNode = _ref.targetNode,
	    overlayNode = _ref.overlayNode,
	    _ref$offset = _ref.offset,
	    offset = _ref$offset === void 0 ? 0 : _ref$offset,
	    _ref$positions = _ref.positions,
	    positions = _ref$positions === void 0 ? posiblePositions : _ref$positions,
	    _ref$relativeToViewpo = _ref.relativeToViewport,
	    relativeToViewport = _ref$relativeToViewpo === void 0 ? true : _ref$relativeToViewpo,
	    _ref$arrowSize = _ref.arrowSize,
	    arrowSize = _ref$arrowSize === void 0 ? 10 : _ref$arrowSize,
	    _ref$adjustOnPosition = _ref.adjustOnPositionBottom,
	    adjustOnPositionBottom = _ref$adjustOnPosition === void 0 ? true : _ref$adjustOnPosition,
	    _ref$showArrow = _ref.showArrow,
	    showArrow = _ref$showArrow === void 0 ? true : _ref$showArrow;
	  if (!constrainTo || !overlayNode || !targetNode) {
	    return null;
	  }
	  var constrain = (0, _getConstrainRegion.default)(constrainTo, targetNode);
	  var overlayRegion = _regionAlign.default.from(overlayNode);
	  var alignRegion = _regionAlign.default.from(targetNode);
	  var newRegion = overlayRegion.clone();
	  var positionsNormalized = positions.map(function (position) {
	    var normalizedPosition;
	    if (_positionsMap.default[position]) {
	      normalizedPosition = _positionsMap.default[position].position;
	    } else {
	      normalizedPosition = position.position || position;
	    }
	    return normalizedPosition;
	  });
	  var positionsOffsets = (0, _getPositionOffsets.default)(positions, offset);
	  var positionsOffsetsClone = positionsOffsets.map(function (offset) {
	    return (0, _assign.default)({}, offset);
	  });
	  var succesfullPosition = newRegion.alignTo(alignRegion, positionsNormalized, {
	    constrain: constrain,
	    offset: positionsOffsetsClone
	  });
	  var constrainedWidth = newRegion.getWidth() != overlayRegion.getWidth();
	  var constrainedHeight = newRegion.getHeight() != overlayRegion.getHeight();
	  var arrowConfig = null;
	  if (showArrow) {
	    arrowConfig = (0, _getArrowPosition.default)({
	      arrowSize: arrowSize,
	      overlayRegion: newRegion,
	      targetRegion: alignRegion,
	      position: succesfullPosition
	    });
	  }
	  var position = {
	    top: newRegion.top,
	    left: newRegion.left
	  };
	  if (!relativeToViewport && overlayNode.offsetParent) {
	    var offsetParentRegion = _regionAlign.default.from(overlayNode.offsetParent);
	    position.left -= offsetParentRegion.left;
	    position.top -= offsetParentRegion.top;
	  }
	  if ((0, _isPositionBottom.default)(succesfullPosition) && adjustOnPositionBottom) {
	    position.bottom = -(overlayRegion.height + (alignRegion.height - position.top));
	    delete position.top;
	  }
	  return {
	    alignRegion: alignRegion,
	    constrainedHeight: constrainedHeight,
	    constrainedWidth: constrainedWidth,
	    constrained: constrainedHeight || constrainedWidth,
	    positionRegion: newRegion,
	    arrowConfig: arrowConfig,
	    position: position,
	    succesfullPosition: succesfullPosition
	  };
	}
	var _default = getPosition;
	exports.default = _default;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _positionsMap = _interopRequireDefault(__webpack_require__(100));
	function createEmptyArray(length, fn) {
	  return Array.apply(null, Array(length)).map(fn);
	}
	function handleNumericOffset(offset, offsetCorrection) {
	  var normalizedOffset = {
	    x: offset * offsetCorrection.x,
	    y: offset * offsetCorrection.y
	  };
	  if (offsetCorrection.resetNumeric) {
	    normalizedOffset[offsetCorrection.resetNumeric] = 0;
	  }
	  return normalizedOffset;
	}
	function handleObjectOffset(offset, offsetCorrection) {
	  var normalizedOffset = {
	    x: offset.x === undefined ? 0 : offset.x * offsetCorrection.x,
	    y: offset.y === undefined ? 0 : offset.y * offsetCorrection.y
	  };
	  return normalizedOffset;
	}
	function normalizeOffset(offset, positionsLength) {
	  var normalizedOffsets = null;
	  if (typeof offset === 'number' || !Array.isArray(offset) && (0, _typeof2.default)(offset) === 'object') {
	    normalizedOffsets = createEmptyArray(positionsLength, function () {
	      return offset;
	    });
	  } else if (Array.isArray(offset)) {
	    if (offset.length < positionsLength) {
	      var lastOffsetItem = offset[offset.length - 1];
	      var extraOffsets = createEmptyArray(positionsLength - offset.length, function () {
	        return lastOffsetItem;
	      });
	      normalizedOffsets = [].concat((0, _toConsumableArray2.default)(offset), (0, _toConsumableArray2.default)(extraOffsets));
	    } else {
	      normalizedOffsets = offset;
	    }
	  }
	  return normalizedOffsets;
	}
	function getPositionOffsets(positions, offset) {
	  var normalizedOffsets = normalizeOffset(offset, positions.length);
	  var positionOffsets = normalizedOffsets.map(function (normalizedOffset, index) {
	    var position = positions[index];
	    var positionMap = _positionsMap.default[position];
	    var offsetCorrection = positionMap ? positionMap.offset : position.offset || {
	      x: 0,
	      y: 0
	    };
	    if (typeof normalizedOffset === 'number') {
	      return handleNumericOffset(normalizedOffset, offsetCorrection);
	    }
	    return handleObjectOffset(normalizedOffset, offsetCorrection);
	  });
	  return positionOffsets;
	}
	var _default = getPositionOffsets;
	exports.default = _default;

/***/ },
/* 587 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var bottomPositions = {
	  'tl-br': true,
	  'tc-bc': true,
	  'tl-bl': true,
	  'tr-br': true,
	  'tr-bl': true
	};
	function isPositionBottom(position) {
	  return !!bottomPositions[position];
	}
	var _default = isPositionBottom;
	exports.default = _default;

/***/ },
/* 588 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function range() {
	  var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  var end = arguments.length > 1 ? arguments[1] : undefined;
	  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	  var collection = [];
	  for (var i = start; i < end; i += step) {
	    collection.push(i);
	  }
	  return collection;
	}
	var _default = range;
	exports.default = _default;

/***/ },
/* 589 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var WHITESPACE = "\xA0";
	var _default = WHITESPACE;
	exports.default = _default;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof3 = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	Object.defineProperty(exports, "filterTypes", {
	  enumerable: true,
	  get: function get() {
	    return _filterTypes.default;
	  }
	});
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(44));
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _reactDom = __webpack_require__(37);
	var _src = _interopRequireDefault(__webpack_require__(85));
	var _uglified = _interopRequireDefault(__webpack_require__(57));
	var _useProperty13 = _interopRequireDefault(__webpack_require__(48));
	var _getScrollbarWidth = _interopRequireDefault(__webpack_require__(47));
	var _clamp = _interopRequireDefault(__webpack_require__(65));
	var _isMobile = _interopRequireDefault(__webpack_require__(64));
	var _Layout = _interopRequireDefault(__webpack_require__(573));
	var _LoadMask = _interopRequireDefault(__webpack_require__(574));
	var _filterTypes = _interopRequireDefault(__webpack_require__(145));
	var _useColumns = _interopRequireDefault(__webpack_require__(595));
	var _useSize3 = _interopRequireDefault(__webpack_require__(611));
	var _useNamedState5 = _interopRequireDefault(__webpack_require__(105));
	var _useHeader = _interopRequireDefault(__webpack_require__(602));
	var _useEditable = _interopRequireDefault(__webpack_require__(600));
	var _useDataSource = _interopRequireDefault(__webpack_require__(599));
	var _useScrollProps = _interopRequireDefault(__webpack_require__(608));
	var _useColumnsSizing = _interopRequireDefault(__webpack_require__(596));
	var _useGroups = _interopRequireDefault(__webpack_require__(601));
	var _useSelection = _interopRequireDefault(__webpack_require__(609));
	var _useRow2 = _interopRequireDefault(__webpack_require__(607));
	var _RowHeightManager = _interopRequireDefault(__webpack_require__(265));
	var _ua = __webpack_require__(103);
	var _prepareClassName = _interopRequireDefault(__webpack_require__(800));
	var _context = __webpack_require__(144);
	var _Cover = _interopRequireDefault(__webpack_require__(545));
	var _useActiveIndex = _interopRequireDefault(__webpack_require__(593));
	var _batchUpdate = _interopRequireDefault(__webpack_require__(50));
	var _empty = _interopRequireDefault(__webpack_require__(782));
	var _ActiveRowIndicator = _interopRequireDefault(__webpack_require__(544));
	var _warn = __webpack_require__(274);
	var _StickyRowsContainer = __webpack_require__(266);
	var _getGlobal = __webpack_require__(18);
	var _useColumnHover = _interopRequireDefault(__webpack_require__(594));
	var _notifier = __webpack_require__(798);
	var _excluded = ["computedOnKeyDown", "computedOnFocus", "computedOnBlur"];
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var GRID_ID = 0;
	var globalObject = (0, _getGlobal.getGlobal)();
	var DEFAULT_I18N = {
	  pageText: 'Page ',
	  ofText: ' of ',
	  perPageText: 'Results per page',
	  showingText: 'Showing ',
	  clearAll: 'Clear all',
	  clear: 'Clear',
	  showFilteringRow: 'Show filtering row',
	  hideFilteringRow: 'Hide filtering row',
	  enable: 'Enable',
	  disable: 'Disable',
	  sortAsc: 'Sort ascending',
	  sortDesc: 'Sort descending',
	  unsort: 'Unsort',
	  group: 'Group',
	  ungroup: 'Ungroup',
	  lockStart: 'Lock start',
	  lockEnd: 'Lock end',
	  unlock: 'Unlock',
	  columns: 'Columns',
	  autoresizeThisColumn: 'Autoresize this column',
	  autoresizeAllColumns: 'Autoresize all columns',
	  autoSizeToFit: 'Autosize to fit',
	  contains: 'Contains',
	  startsWith: 'Starts with',
	  endsWith: 'Ends with',
	  notContains: 'Does not contain',
	  inlist: 'In list',
	  notinlist: 'Not in list',
	  neq: 'Does not equal',
	  inrange: 'In range',
	  notinrange: 'Not in range',
	  eq: 'Equals',
	  notEmpty: 'Not empty',
	  empty: 'Empty',
	  lt: 'Less than',
	  lte: 'Less than or equal',
	  gt: 'Greater than',
	  gte: 'Greater than or equal',
	  before: 'Before',
	  beforeOrOn: 'Before or on',
	  afterOrOn: 'After or on',
	  after: 'After',
	  start: 'Start',
	  end: 'End',
	  dragHeaderToGroup: 'Drag header to group',
	  noRecords: 'No records available',
	  'calendar.todayButtonText': 'Today',
	  'calendar.clearButtonText': 'Clear',
	  'calendar.okButtonText': 'OK',
	  'calendar.cancelButtonText': 'Cancel'
	};
	var renderLoadMask = function renderLoadMask(props) {
	  var loadMaskProps = {
	    visible: props.computedLoading,
	    livePagination: props.computedLivePagination,
	    loadingText: props.loadingText || 'Loading',
	    zIndex: 10000,
	    theme: props.theme
	  };
	  var loadMask;
	  if (props.renderLoadMask) {
	    loadMask = props.renderLoadMask(loadMaskProps);
	  }
	  if (loadMask !== undefined) {
	    return loadMask;
	  }
	  return _react.default.createElement(_LoadMask.default, _objectSpread({}, loadMaskProps));
	};
	var reducePlugins = function reducePlugins(acc, plugin) {
	  if (!plugin.name || typeof plugin.hook !== 'function') {
	    return acc;
	  }
	  acc[plugin.name] = plugin;
	  return acc;
	};
	var GridFactory = function GridFactory() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	    plugins = _ref.plugins;
	  var edition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'community';
	  plugins = plugins || [];
	  var maybeAddColumns;
	  var defaultSize = {
	    width: 0,
	    height: 0
	  };
	  var emptyCoverHandle = {
	    setActive: function setActive() {},
	    setCursor: function setCursor() {}
	  };
	  plugins = [].concat((0, _toConsumableArray2.default)(_empty.default), (0, _toConsumableArray2.default)(plugins));
	  var pluginsMap = plugins.reduce(reducePlugins, {});
	  var Grid = _react.default.memo(function (props) {
	    var _useState = (0, _react.useState)(false),
	      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	      computedFocused = _useState2[0],
	      computedSetFocused = _useState2[1];
	    var computedPropsRef = (0, _react.useRef)(null);
	    var warnRef = (0, _react.useMemo)(function () {
	      return {};
	    }, []);
	    var context = (0, _react.useContext)(props.context);
	    (0, _react.useEffect)(function () {
	      if (computedFocused && props.activateRowOnFocus) {
	        var _computedProps = computedPropsRef.current;
	        if (!_computedProps) {
	          return;
	        }
	        var count = _computedProps.count;
	        if (!count) {
	          return;
	        }
	        var _activeItem = _computedProps.getActiveItem();
	        if (!_activeItem) {
	          var index = _computedProps.computedLastActiveIndex || _computedProps.getFirstVisibleIndex();
	          _computedProps.setActiveIndex(index);
	        }
	      }
	    }, [computedFocused]);
	    var bodyRef = (0, _react.useRef)(null);
	    var domRef = (0, _react.useRef)(null);
	    var portalRef = (0, _react.useRef)(null);
	    var getDOMNode = function getDOMNode() {
	      return domRef.current;
	    };
	    var getBodyDOMNode = function getBodyDOMNode() {
	      var _bodyRef$current;
	      return bodyRef === null || bodyRef === void 0 ? void 0 : (_bodyRef$current = bodyRef.current) === null || _bodyRef$current === void 0 ? void 0 : _bodyRef$current.getDOMNode();
	    };
	    var getVirtualList = function getVirtualList() {
	      return bodyRef.current != null ? bodyRef.current.getVirtualList() : null;
	    };
	    var getColumnLayout = function getColumnLayout() {
	      return bodyRef.current != null ? bodyRef.current.columnLayout : null;
	    };
	    var getDefaultSize = function getDefaultSize() {
	      if (props.viewportSize) {
	        return props.viewportSize;
	      }
	      return defaultSize;
	    };
	    var _useProperty = (0, _useProperty13.default)(props, 'loading'),
	      _useProperty2 = (0, _slicedToArray2.default)(_useProperty, 2),
	      computedLoading = _useProperty2[0],
	      doSetLoading = _useProperty2[1];
	    var loadingTimeoutIdRef = (0, _react.useRef)();
	    var setLoading = function setLoading(loading) {
	      var computedProps = computedPropsRef.current;
	      var isLoading = loading instanceof Function ? loading(computedProps ? computedProps.computedLoading : false) : loading;
	      if (!computedProps) {
	        doSetLoading(isLoading);
	        return;
	      }
	      if (loadingTimeoutIdRef.current) {
	        clearTimeout(loadingTimeoutIdRef.current);
	      }
	      if (computedProps.computedLivePagination && !isLoading && computedProps.livePaginationLoadMaskHideDelay) {
	        loadingTimeoutIdRef.current = setTimeout(function () {
	          doSetLoading(isLoading);
	          loadingTimeoutIdRef.current = null;
	        }, computedProps.livePaginationLoadMaskHideDelay);
	      } else {
	        doSetLoading(isLoading);
	      }
	    };
	    var _useNamedState = (0, _useNamedState5.default)({}, props.context, 'columnSizes'),
	      _useNamedState2 = (0, _slicedToArray2.default)(_useNamedState, 2),
	      columnSizes = _useNamedState2[0],
	      setColumnSizes = _useNamedState2[1];
	    var _useNamedState3 = (0, _useNamedState5.default)({}, props.context, 'columnFlexes'),
	      _useNamedState4 = (0, _slicedToArray2.default)(_useNamedState3, 2),
	      columnFlexes = _useNamedState4[0],
	      setColumnFlexes = _useNamedState4[1];
	    var _useState3 = (0, _react.useState)({}),
	      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
	      lockedColumnsState = _useState4[0],
	      setLockedColumnsState = _useState4[1];
	    var _useState5 = (0, _react.useState)({
	        vertical: false,
	        horizontal: false
	      }),
	      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
	      scrollbars = _useState6[0],
	      setScrollbars = _useState6[1];
	    var _useProperty3 = (0, _useProperty13.default)(props, 'reservedViewportWidth', 0),
	      _useProperty4 = (0, _slicedToArray2.default)(_useProperty3, 2),
	      reservedViewportWidth = _useProperty4[0],
	      setReservedViewportWidth = _useProperty4[1];
	    var _useSize = (0, _useSize3.default)(getDefaultSize()),
	      _useSize2 = (0, _slicedToArray2.default)(_useSize, 2),
	      size = _useSize2[0],
	      setSize = _useSize2[1];
	    var _useState7 = (0, _react.useState)(0),
	      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
	      viewportAvailableWidth = _useState8[0],
	      setViewportAvailableWidth = _useState8[1];
	    (0, _react.useEffect)(function () {
	      if (props.viewportSize) {
	        setSize(props.viewportSize);
	      }
	    }, [props.viewportSize]);
	    var onResize = function onResize(size) {
	      (0, _batchUpdate.default)().commit(function () {
	        if (_ua.IS_MS_BROWSER || _ua.IS_FF) {
	          size.width -= 2;
	        }
	        setSize(size);
	        updateViewportAvailableWidth(size.width);
	        var rowHeight = typeof props.rowHeight !== 'number' ? props.minRowHeight : props.rowHeight;
	        if (rowHeight) {
	          setMaxVisibleRows(Math.ceil(size.height / rowHeight));
	        }
	      });
	    };
	    var updateViewportAvailableWidth = function updateViewportAvailableWidth(newViewportAvailableWidth) {
	      var scrolls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scrollbars;
	      if (props.nativeScroll && scrolls.vertical) {
	        newViewportAvailableWidth -= (0, _getScrollbarWidth.default)();
	      }
	      setViewportAvailableWidth(Math.round(newViewportAvailableWidth));
	    };
	    var _useState9 = (0, _react.useState)({
	        virtualListBorderLeft: 0,
	        virtualListBorderRight: 0,
	        virtualListExtraWidth: 0
	      }),
	      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
	      _useState10$ = _useState10[0],
	      virtualListBorderLeft = _useState10$.virtualListBorderLeft,
	      virtualListBorderRight = _useState10$.virtualListBorderRight,
	      virtualListExtraWidth = _useState10$.virtualListExtraWidth,
	      setVirtualListState = _useState10[1];
	    var onScrollbarsChange = function onScrollbarsChange(scrollbars) {
	      var onChange = function onChange() {
	        var vl = getVirtualList();
	        var computedStyle = vl && globalObject.getComputedStyle(vl.getDOMNode());
	        if (!computedStyle) {
	          return;
	        }
	        var virtualListBorderLeft = parseInt(computedStyle.borderLeftWidth, 10);
	        var virtualListBorderRight = parseInt(computedStyle.borderRightWidth, 10);
	        var virtualListExtraWidth = virtualListBorderLeft + virtualListBorderRight;
	        (0, _batchUpdate.default)().commit(function () {
	          setScrollbars(scrollbars);
	          if (size.width) {
	            updateViewportAvailableWidth(size.width, scrollbars);
	          }
	          setVirtualListState({
	            virtualListBorderLeft: virtualListBorderLeft,
	            virtualListBorderRight: virtualListBorderRight,
	            virtualListExtraWidth: virtualListExtraWidth
	          });
	        });
	      };
	      if (!bodyRef.current) {
	        requestAnimationFrame(onChange);
	      } else {
	        onChange();
	      }
	    };
	    var _useProperty5 = (0, _useProperty13.default)(props, 'showCellBorders'),
	      _useProperty6 = (0, _slicedToArray2.default)(_useProperty5, 2),
	      computedShowCellBorders = _useProperty6[0],
	      setShowCellBorders = _useProperty6[1];
	    var showHorizontalCellBorders = computedShowCellBorders === true || computedShowCellBorders === 'horizontal';
	    var showVerticalCellBorders = computedShowCellBorders === true || computedShowCellBorders === 'vertical';
	    var _useState11 = (0, _react.useState)(false),
	      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
	      listenOnCellEnter = _useState12[0],
	      updateListenOnCellEnter = _useState12[1];
	    var _useState13 = (0, _react.useState)(null),
	      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
	      selectionFixedCell = _useState14[0],
	      setSelectionFixedCell = _useState14[1];
	    var setListenOnCellEnter = function setListenOnCellEnter(value, callback) {
	      if (value) {
	        globalObject.addEventListener('mouseup', callback);
	      } else {
	        globalObject.removeEventListener('mouseup', callback);
	      }
	      updateListenOnCellEnter(value);
	    };
	    var renderCallbacks = (0, _react.useRef)([]);
	    var onNextRender = function onNextRender(fn) {
	      renderCallbacks.current.push(fn);
	    };
	    (0, _react.useEffect)(function () {
	      renderCallbacks.current.forEach(function (fn) {
	        return fn();
	      });
	      renderCallbacks.current.length = 0;
	    });
	    var _useState15 = (0, _react.useState)(''),
	      _useState16 = (0, _slicedToArray2.default)(_useState15, 2),
	      lastCellInRange = _useState16[0],
	      setLastCellInRange = _useState16[1];
	    var _useState17 = (0, _react.useState)(null),
	      _useState18 = (0, _slicedToArray2.default)(_useState17, 2),
	      lastSelectedCell = _useState18[0],
	      setLastSelectedCell = _useState18[1];
	    var renderInPortal = (0, _react.useMemo)(function () {
	      return props.renderInPortal || function (el) {
	        return portalRef.current ? (0, _reactDom.createPortal)(el, portalRef.current) : null;
	      };
	    }, [props.renderInPortal]);
	    var cProps = _objectSpread(_objectSpread({}, props), {}, {
	      initialProps: props,
	      selectionFixedCell: selectionFixedCell,
	      setSelectionFixedCell: setSelectionFixedCell,
	      bodyRef: bodyRef,
	      domRef: domRef,
	      portalRef: portalRef,
	      renderInPortal: renderInPortal,
	      listenOnCellEnter: listenOnCellEnter,
	      setListenOnCellEnter: setListenOnCellEnter,
	      lastCellInRange: lastCellInRange,
	      setLastCellInRange: setLastCellInRange,
	      setLastSelectedCell: setLastSelectedCell,
	      lastSelectedCell: lastSelectedCell,
	      onScrollbarsChange: onScrollbarsChange,
	      virtualListBorderLeft: virtualListBorderLeft,
	      virtualListBorderRight: virtualListBorderRight,
	      virtualListExtraWidth: virtualListExtraWidth,
	      scrollbars: scrollbars,
	      reservedViewportWidth: reservedViewportWidth,
	      setReservedViewportWidth: setReservedViewportWidth,
	      getColumnLayout: getColumnLayout,
	      getDOMNode: getDOMNode,
	      computedLoading: computedLoading,
	      computedFocused: computedFocused,
	      computedSetFocused: computedSetFocused,
	      columnFlexes: columnFlexes,
	      columnSizes: columnSizes,
	      setColumnFlexes: setColumnFlexes,
	      setColumnSizes: setColumnSizes,
	      lockedColumnsState: lockedColumnsState,
	      setLockedColumnsState: setLockedColumnsState,
	      setLoading: setLoading,
	      isLoading: function isLoading() {
	        return computedProps.computedLoading;
	      },
	      size: size,
	      setSize: setSize,
	      viewportAvailableWidth: viewportAvailableWidth,
	      availableWidth: viewportAvailableWidth,
	      maxAvailableWidthForColumns: viewportAvailableWidth - reservedViewportWidth,
	      showHorizontalCellBorders: showHorizontalCellBorders,
	      showVerticalCellBorders: showVerticalCellBorders,
	      shareSpaceOnResize: props.shareSpaceOnResize || false,
	      onNextRender: onNextRender,
	      computedEnableColumnHover: props.enableColumnHover || undefined
	    });
	    cProps.i18n = function (key, defaultLabel) {
	      return props.i18n[key] || DEFAULT_I18N[key] || defaultLabel;
	    };
	    Object.assign(cProps, (0, _useActiveIndex.default)(props, cProps, computedPropsRef));
	    Object.assign(cProps, pluginsMap['sortable-columns'].hook(props, cProps, computedPropsRef));
	    if (pluginsMap['group-and-pivot'] && pluginsMap['group-and-pivot'].hook) {
	      Object.assign(cProps, pluginsMap['group-and-pivot'].hook(props, cProps, computedPropsRef));
	    }
	    Object.assign(cProps, (0, _useGroups.default)(props, cProps, computedPropsRef));
	    if (pluginsMap.tree && pluginsMap.tree.hook) {
	      Object.assign(cProps, pluginsMap.tree.hook(props, cProps, computedPropsRef));
	    }
	    if (pluginsMap.filters && pluginsMap.filters.hook) {
	      Object.assign(cProps, pluginsMap.filters.hook(props, cProps, computedPropsRef));
	    }
	    Object.assign(cProps, (0, _useEditable.default)(props, cProps, computedPropsRef));
	    cProps.maybeAddColumns = maybeAddColumns;
	    var columnInfo = (0, _useColumns.default)(props, cProps, computedPropsRef);
	    Object.assign(cProps, columnInfo);
	    if (edition === 'enterprise') {
	      var columnsSizing = (0, _useColumnsSizing.default)(props, cProps, computedPropsRef);
	      Object.assign(cProps, columnsSizing);
	    }
	    Object.assign(cProps, (0, _useColumnHover.default)(props, cProps, computedPropsRef));
	    cProps.wasMountedRef = (0, _react.useRef)(false);
	    cProps.wasUnmountedRef = (0, _react.useRef)(false);
	    var dataInfo = (0, _useDataSource.default)(props, cProps, computedPropsRef);
	    Object.assign(cProps, pluginsMap['live-pagination'].hook(props, cProps, computedPropsRef));
	    var rowHeightManager = (0, _react.useMemo)(function () {
	      return new _RowHeightManager.default({
	        rowHeight: props.rowHeight || props.minRowHeight,
	        minRowHeight: props.minRowHeight
	      }, {}, {
	        cache: !!props.rowHeight
	      });
	    }, []);
	    var i18nFn = (0, _react.useCallback)(function (key, defaultLabel) {
	      if (!props.i18n) {
	        return defaultLabel;
	      }
	      return props.i18n[key] || DEFAULT_I18N[key] || defaultLabel;
	    }, [props.i18n]);
	    var getItemId = (0, _react.useCallback)(function (item) {
	      if (!item) return;
	      if (item.__group && Array.isArray(item.keyPath)) {
	        return item.keyPath.join(props.groupPathSeparator);
	      }
	      var itemId = computeIdProperty() ? compoundItemId(item) : simpleItemId(item);
	      return itemId;
	    }, []);
	    var simpleItemId = (0, _react.useCallback)(function (item) {
	      return item[props.idProperty];
	    }, []);
	    var compoundItemId = (0, _react.useCallback)(function (item) {
	      var parts = props.idProperty.split(props.idPropertySeparator);
	      return parts.reduce(function (itemObj, id) {
	        if (itemObj) {
	          return itemObj[id] ? itemObj[id] : itemObj;
	        }
	      }, item);
	    }, []);
	    var getItemIndexBy = function getItemIndexBy(fn) {
	      var data = computedProps.data;
	      if (!data || typeof fn != 'function') {
	        return -1;
	      }
	      if (data.findIndex) {
	        return data.findIndex(fn);
	      }
	      for (var i = 0, len = data.length; i < len; i++) {
	        if (fn(data[i]) === true) {
	          return i;
	        }
	      }
	      return -1;
	    };
	    var getItemAt = function getItemAt(index) {
	      if (!computedPropsRef.current) {
	        return undefined;
	      }
	      var item = computedPropsRef.current.data[index];
	      if (!item) {
	        return;
	      }
	      return getItemWithCache(item);
	    };
	    var getItemWithCache = function getItemWithCache(item) {
	      if (item && computedPropsRef.current && computedPropsRef.current.computedDataSourceCache) {
	        var itemId = getItemId(item);
	        var cachedItem = computedPropsRef.current.computedDataSourceCache[itemId];
	        if (cachedItem) {
	          item = _objectSpread(_objectSpread({}, item), cachedItem);
	        }
	      }
	      return item;
	    };
	    var getItemIndex = function getItemIndex(item) {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return -1;
	      }
	      var data = computedProps.data;
	      var itemId = getItemId(item);
	      for (var i = 0; i < data.length; i++) {
	        var dataItem = data[i];
	        var dataItemId = getItemId(dataItem);
	        if (dataItemId === itemId) {
	          return i;
	        }
	      }
	      return -1;
	    };
	    var getItemIdAt = function getItemIdAt(index) {
	      if (index === -1) return;
	      return getItemId(getItemAt(index));
	    };
	    var isRowExpandedById = function isRowExpandedById() {
	      return false;
	    };
	    var isCellVisible = function isCellVisible(_ref2) {
	      var rowIndex = _ref2.rowIndex,
	        columnIndex = _ref2.columnIndex;
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return false;
	      }
	      var column = computedProps.visibleColumns[columnIndex];
	      if (!computedProps.rowHeightManager) {
	        throw 'You need fixed row height for this method to work';
	      }
	      var columnStart = column.computedOffset;
	      var columnEnd = columnStart + column.computedWidth;
	      var rowStart = computedProps.rowHeightManager.getRowOffset(rowIndex);
	      var rowEnd = rowStart + computedProps.rowHeightManager.getRowHeight(rowIndex);
	      var virtualList = getVirtualList();
	      var visibleTop = virtualList.scrollTop;
	      var visibleBottom = visibleTop + computedProps.size.height;
	      var visibleLeft = virtualList.scrollLeft;
	      var visibleRight = visibleLeft + computedProps.size.width;
	      var leftDiff = columnStart - visibleLeft;
	      var rightDiff = visibleRight - columnEnd;
	      var topDiff = rowStart - visibleTop;
	      var bottomDiff = visibleBottom - rowEnd;
	      if (topDiff >= 0 && bottomDiff >= 0 && leftDiff >= 0 && rightDiff >= 0) {
	        return true;
	      }
	      return {
	        topDiff: topDiff,
	        bottomDiff: bottomDiff,
	        leftDiff: leftDiff,
	        rightDiff: rightDiff
	      };
	    };
	    var setScrollTop = function setScrollTop(scrollTop) {
	      var virtualList = getVirtualList();
	      if (virtualList) {
	        virtualList.scrollTop = scrollTop;
	      }
	    };
	    var incrementScrollTop = function incrementScrollTop(increment) {
	      var virtualList = getVirtualList();
	      if (virtualList) {
	        virtualList.scrollTop += increment;
	      }
	    };
	    var getScrollTop = function getScrollTop() {
	      var body = bodyRef.current;
	      if (body && body.columnLayout) {
	        return body.columnLayout.scrollTop || 0;
	      }
	      return 0;
	    };
	    var getScrollLeft = function getScrollLeft() {
	      var body = bodyRef.current;
	      if (body && body.columnLayout) {
	        return body.columnLayout.scrollLeft || 0;
	      }
	      return 0;
	    };
	    var getScrollLeftMax = function getScrollLeftMax() {
	      var virtualList = getVirtualList();
	      if (virtualList) {
	        return virtualList.scrollLeftMax || 0;
	      }
	      return 0;
	    };
	    var setScrollLeft = function setScrollLeft(scrollLeft) {
	      var virtualList = getVirtualList();
	      if (virtualList) {
	        virtualList.scrollLeft = scrollLeft;
	      }
	    };
	    var incrementScrollLeft = function incrementScrollLeft(increment) {
	      var virtualList = getVirtualList();
	      if (virtualList) {
	        virtualList.scrollLeft += increment;
	      }
	    };
	    var getRows = function getRows() {
	      var vl = getVirtualList();
	      return vl.getRows();
	    };
	    var getDOMNodeForRowIndex = function getDOMNodeForRowIndex(index) {
	      var rows = getRows();
	      var row = rows.find(function (row) {
	        return row.index === index;
	      });
	      var rowInstance = row.getInstance();
	      return rowInstance.getDOMNode ? rowInstance.getDOMNode() : rowInstance.domRef ? rowInstance.domRef.current : null;
	    };
	    var getHeader = function getHeader() {
	      var body = bodyRef.current;
	      var columnLayout = body && body.getColumnLayout();
	      var header = columnLayout.getHeader();
	      return header;
	    };
	    var scrollToId = function scrollToId(id, config, callback) {
	      var index = computedProps.getRowIndexById(id);
	      scrollToIndex(index, config, callback);
	    };
	    var scrollToIndex = function scrollToIndex(index, config, callback) {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      index = (0, _clamp.default)(index, 0, computedProps.data.length - 1);
	      config = config || {};
	      var top = config.top;
	      var force = config.force;
	      var direction = config.direction;
	      var duration = config.duration;
	      var offset = config.offset;
	      top = !!top;
	      force = !!force;
	      direction = direction || (top ? 'top' : 'bottom');
	      getVirtualList().scrollToIndex(index, {
	        direction: direction,
	        force: force,
	        duration: duration,
	        offset: offset
	      }, callback);
	    };
	    var scrollToCell = function scrollToCell(_ref3) {
	      var rowIndex = _ref3.rowIndex,
	        columnIndex = _ref3.columnIndex;
	      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        offset = _ref4.offset,
	        left = _ref4.left,
	        right = _ref4.right,
	        top = _ref4.top;
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      if (offset === undefined) {
	        offset = (computedProps.rowHeight || 50) / 2;
	      }
	      var columnDirection = left === true ? 'left' : left === false || right === true ? 'right' : undefined;
	      var col = computedProps.visibleColumns[columnIndex];
	      var scrollToRow = function scrollToRow() {
	        var maxIndex = computedProps.computedTreeEnabled ? computedProps.data.length - 1 : computedProps.count - 1;
	        computedProps.scrollToIndex((0, _clamp.default)(rowIndex + (top ? -0 : 0), 0, maxIndex), {
	          top: top,
	          offset: 0
	        });
	      };
	      if (!col) {
	        return;
	      }
	      if (col.computedLocked) {
	        scrollToRow();
	        return;
	      }
	      computedProps.scrollToColumn(columnIndex, {
	        offset: offset,
	        direction: columnDirection
	      }, function () {
	        scrollToRow();
	      });
	    };
	    var smoothScrollTo = (0, _react.useCallback)(function (value, config) {
	      var virtualList = getVirtualList();
	      virtualList.smoothScrollTo(value, config);
	    }, []);
	    var scrollToColumn = (0, _react.useCallback)(function (index, config, callback) {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      if (!computedProps.size.width) {
	        return requestAnimationFrame(function () {
	          scrollToColumn(index, config, callback);
	        });
	      }
	      config = config || {};
	      var _config = config,
	        direction = _config.direction,
	        force = _config.force,
	        duration = _config.duration,
	        offset = _config.offset;
	      if (offset === undefined) {
	        offset = (computedProps.rowHeight || 50) / 2;
	      }
	      var col = computedProps.getColumnBy(index);
	      if (col.computedLocked) {
	        if (callback) {
	          callback();
	        }
	        return;
	      }
	      var virtualList = getVirtualList();
	      var scrollLeft = virtualList.scrollLeft;
	      var scrollWidth = computedProps.size.width;
	      if (direction) {
	        if (direction != 'left' && direction != 'right') {
	          direction = null;
	        }
	      }
	      if (force && !direction) {
	        force = false;
	      }
	      if (typeof callback != 'function') {
	        callback = function callback() {};
	      }
	      var getColumnOffset = function getColumnOffset() {
	        return direction === 'left' || !direction ? col.computedOffset : col.computedOffset + col.computedWidth;
	      };
	      var getLeftDiff = function getLeftDiff() {
	        return getColumnOffset() - scrollLeft - (computedProps.totalLockedStartWidth || 0);
	      };
	      var getRightDiff = function getRightDiff() {
	        return scrollLeft + scrollWidth - getColumnOffset() - (computedProps.totalLockedEndWidth || 0);
	      };
	      var leftDiff = getLeftDiff();
	      var rightDiff = getRightDiff();
	      var toLeft = leftDiff < 0;
	      var toRight = rightDiff < 0;
	      var visible = !toLeft && !toRight;
	      if (!visible) {
	        if (!direction) {
	          direction = leftDiff < 0 ? 'left' : 'right';
	          force = true;
	          leftDiff = getLeftDiff();
	          rightDiff = getRightDiff();
	        }
	      }
	      if (!visible || direction && force) {
	        var newScrollLeft;
	        if (direction == 'left' || leftDiff < 0) {
	          newScrollLeft = scrollLeft + leftDiff - offset;
	        } else if (direction == 'right' || rightDiff < 0) {
	          newScrollLeft = scrollLeft - rightDiff + offset;
	        }
	        if (newScrollLeft != null) {
	          if (duration) {
	            virtualList.smoothScrollTo(newScrollLeft, {
	              duration: duration,
	              orientation: 'horizontal'
	            }, callback);
	            return;
	          }
	          virtualList.scrollLeft = newScrollLeft;
	        }
	      }
	      callback();
	    }, []);
	    var getStickyContainerHeight = function getStickyContainerHeight() {
	      var _getDOMNode, _stickyContainer$scro;
	      var stickyContainer = (_getDOMNode = getDOMNode()) === null || _getDOMNode === void 0 ? void 0 : _getDOMNode.querySelector(".".concat(_StickyRowsContainer.StickyRowsContainerClassName));
	      var stickyContainerHeight = (_stickyContainer$scro = stickyContainer === null || stickyContainer === void 0 ? void 0 : stickyContainer.scrollHeight) !== null && _stickyContainer$scro !== void 0 ? _stickyContainer$scro : 0;
	      return stickyContainerHeight;
	    };
	    var scrollToIndexIfNeeded = (0, _react.useCallback)(function (index, config, callback) {
	      var needed = !isRowFullyVisible(index);
	      if (!needed) {
	        var _computedProps2 = computedPropsRef.current;
	        if (_computedProps2 !== null && _computedProps2 !== void 0 && _computedProps2.computedStickyRows) {
	          if (_computedProps2.computedStickyRows[index]) {
	            needed = false;
	          } else {
	            var stickyContainerHeight = getStickyContainerHeight();
	            var scrollTop = getScrollTop();
	            var relativeScrollTop = scrollTop + stickyContainerHeight;
	            var rowOffset = _computedProps2.rowHeightManager.getRowOffset(index);
	            if (relativeScrollTop > rowOffset) {
	              needed = true;
	              config = config || {
	                direction: 'top'
	              };
	              config.offset = relativeScrollTop - rowOffset + rowHeightManager.getRowHeight(index);
	            }
	          }
	        }
	      } else {
	        if (computedProps !== null && computedProps !== void 0 && computedProps.computedStickyRows) {
	          config = config || {
	            direction: 'top'
	          };
	          config.offset = config.offset || 0;
	          if (config.direction === 'top' || config.top) {
	            config.offset += getStickyContainerHeight();
	          }
	        }
	      }
	      if (needed) {
	        scrollToIndex(index, config, callback);
	      } else {
	        if (callback) {
	          callback();
	        }
	      }
	      return needed;
	    }, []);
	    var isRowFullyVisible = function isRowFullyVisible(rowIndex) {
	      var list = getVirtualList();
	      if (!list) {
	        return false;
	      }
	      return list.isRowVisible(rowIndex);
	    };
	    var getRenderRange = function getRenderRange() {
	      return bodyRef.current != null ? bodyRef.current.getRenderRange() : {
	        from: 0,
	        to: 0
	      };
	    };
	    var isRowRendered = function isRowRendered(index) {
	      var _getRenderRange = getRenderRange(),
	        from = _getRenderRange.from,
	        to = _getRenderRange.to;
	      return index >= from && index < to;
	    };
	    var focus = function focus() {
	      var virtualList = getVirtualList();
	      if (!virtualList) {
	        return;
	      }
	      var scrollContainer = virtualList.scrollContainer;
	      if (!scrollContainer) {
	        return;
	      }
	      scrollContainer.focus();
	    };
	    var blur = function blur() {
	      var virtualList = getVirtualList();
	      if (!virtualList) {
	        return;
	      }
	      var scrollContainer = virtualList.scrollContainer;
	      if (!scrollContainer) {
	        return;
	      }
	      scrollContainer.blur();
	    };
	    var computeIdProperty = (0, _react.useCallback)(function () {
	      var idProperty = props.idProperty;
	      if (idProperty.includes(props.idPropertySeparator)) {
	        return true;
	      }
	      return false;
	    }, []);
	    var computedProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, cProps), {}, {
	      gridId: (0, _react.useMemo)(function () {
	        return ++GRID_ID;
	      }, []),
	      isRowFullyVisible: isRowFullyVisible,
	      bodyRef: bodyRef,
	      notifyColumnFilterVisibleStateChange: (0, _react.useMemo)(function () {
	        return (0, _notifier.notifier)(false);
	      }, []),
	      getMenuPortalContainer: getDOMNode,
	      scrollToIndexIfNeeded: scrollToIndexIfNeeded,
	      scrollToIndex: scrollToIndex,
	      scrollToId: scrollToId,
	      scrollToColumn: scrollToColumn,
	      scrollToCell: scrollToCell,
	      setScrollTop: setScrollTop,
	      setScrollLeft: setScrollLeft,
	      smoothScrollTo: smoothScrollTo,
	      incrementScrollLeft: incrementScrollLeft,
	      incrementScrollTop: incrementScrollTop,
	      getScrollTop: getScrollTop,
	      getScrollLeft: getScrollLeft,
	      getScrollLeftMax: getScrollLeftMax,
	      getHeader: getHeader,
	      isCellVisible: isCellVisible,
	      naturalRowHeight: typeof props.rowHeight !== 'number',
	      isRowRendered: isRowRendered,
	      getRenderRange: getRenderRange,
	      computedShowCellBorders: computedShowCellBorders,
	      setShowCellBorders: setShowCellBorders,
	      groupCounts: [],
	      computedLoading: computedLoading,
	      setLoading: setLoading
	    }, dataInfo), columnInfo), {}, {
	      rowHeightManager: rowHeightManager,
	      isRowExpandedById: isRowExpandedById,
	      getItemId: getItemId,
	      getRowId: getItemIdAt,
	      getItemIndexBy: getItemIndexBy,
	      getItemIndex: getItemIndex,
	      getItemAt: getItemAt,
	      getItemIdAt: getItemIdAt,
	      getRows: getRows,
	      focus: focus,
	      getDOMNodeForRowIndex: getDOMNodeForRowIndex,
	      blur: blur,
	      computedShowHeaderBorderRight: columnInfo.totalComputedWidth < viewportAvailableWidth || props.nativeScroll && (0, _getScrollbarWidth.default)() && scrollbars.vertical,
	      i18n: i18nFn,
	      totalColumnCount: columnInfo.allColumns.length,
	      totalComputedWidth: columnInfo.totalComputedWidth,
	      minRowWidth: columnInfo.totalComputedWidth,
	      columnResizeHandleWidth: (0, _clamp.default)(props.columnResizeHandleWidth, 2, 25),
	      compoundIdProperty: computeIdProperty()
	    });
	    computedProps.rtlOffset = props.rtl ? Math.min(computedProps.size.width - computedProps.totalComputedWidth, 0) : 0;
	    computedPropsRef.current = computedProps;
	    var menusRef = (0, _react.useRef)([]);
	    computedProps.menusRef = menusRef;
	    computedProps.updateMenuPositions = function () {
	      menusRef.current.forEach(function (menu) {
	        if (menu && menu.updatePosition) {
	          menu.updatePosition();
	        }
	      });
	    };
	    computedProps.updateMainMenuPosition = function (alignTo) {
	      menusRef.current.forEach(function (menu) {
	        if (menu && menu.updatePosition && !menu.props.subMenu) {
	          menu.updateAlignment(alignTo);
	        }
	      });
	    };
	    computedProps.onScroll = function () {
	      if (computedProps.initialProps.onScroll) {
	        computedProps.initialProps.onScroll();
	      }
	      if (computedProps.updateMenuPositionOnScroll) {
	        computedProps.updateMenuPositions();
	      }
	    };
	    if (pluginsMap['row-details'] && pluginsMap['row-details'].hook) {
	      Object.assign(computedProps, pluginsMap['row-details'].hook(props, computedProps, computedPropsRef));
	    }
	    computedProps.useCellSelection = pluginsMap['cell-selection'].hook;
	    Object.assign(computedProps, (0, _useSelection.default)(props, computedProps, computedPropsRef));
	    Object.assign(computedProps, (0, _useHeader.default)(props, computedProps));
	    computedProps.scrollProps = (0, _useScrollProps.default)(props, computedProps);
	    var _useState19 = (0, _react.useState)(0),
	      _useState20 = (0, _slicedToArray2.default)(_useState19, 2),
	      maxVisibleRows = _useState20[0],
	      setMaxVisibleRows = _useState20[1];
	    var _useProperty7 = (0, _useProperty13.default)(props, 'showZebraRows'),
	      _useProperty8 = (0, _slicedToArray2.default)(_useProperty7, 2),
	      computedShowZebraRows = _useProperty8[0],
	      setShowZebraRows = _useProperty8[1];
	    var _useProperty9 = (0, _useProperty13.default)(props, 'showHoverRows'),
	      _useProperty10 = (0, _slicedToArray2.default)(_useProperty9, 2),
	      computedShowHoverRows = _useProperty10[0],
	      setShowHoverRows = _useProperty10[1];
	    var _useProperty11 = (0, _useProperty13.default)(props, 'showEmptyRows'),
	      _useProperty12 = (0, _slicedToArray2.default)(_useProperty11, 2),
	      computedShowEmptyRows = _useProperty12[0],
	      setShowEmptyRows = _useProperty12[1];
	    computedProps.getVirtualList = getVirtualList;
	    computedProps.computedShowZebraRows = computedShowZebraRows;
	    computedProps.computedShowHoverRows = computedShowHoverRows;
	    computedProps.computedShowEmptyRows = computedShowEmptyRows;
	    computedProps.setShowZebraRows = setShowZebraRows;
	    computedProps.setShowHoverRows = setShowHoverRows;
	    computedProps.setShowEmptyRows = setShowEmptyRows;
	    computedProps.maxVisibleRows = maxVisibleRows;
	    var className = (0, _prepareClassName.default)(computedProps);
	    var _useRow = (0, _useRow2.default)(props, computedProps, computedPropsRef),
	      onKeyDown = _useRow.computedOnKeyDown,
	      onFocus = _useRow.computedOnFocus,
	      onBlur = _useRow.computedOnBlur,
	      useRowProps = (0, _objectWithoutProperties2.default)(_useRow, _excluded);
	    if (pluginsMap['locked-rows'] && pluginsMap['locked-rows'].hook) {
	      Object.assign(computedProps, pluginsMap['locked-rows'].hook(props, computedProps, computedPropsRef));
	    }
	    if (pluginsMap['locked-columns'] && pluginsMap['locked-columns'].hook) {
	      Object.assign(computedProps, pluginsMap['locked-columns'].hook(props, computedProps, computedPropsRef));
	    } else if (computedProps.lockedEndColumns && computedProps.lockedEndColumns.length || computedProps.lockedStartColumns && computedProps.lockedStartColumns.length) {
	      (0, _warn.communityFeatureWarn)("Locked columns", warnRef);
	    }
	    if (pluginsMap['footer-rows'] && pluginsMap['footer-rows'].hook) {
	      Object.assign(computedProps, pluginsMap['footer-rows'].hook(props, computedProps, computedPropsRef));
	    }
	    if ((props.renderRowDetails || props.expandedRows || props.defaultExpandedRows) && !pluginsMap['row-details']) {
	      (0, _warn.communityFeatureWarn)("Row Details and Master Details", warnRef);
	    }
	    if (props.lockedRows && !pluginsMap['locked-rows']) {
	      (0, _warn.communityFeatureWarn)("Locked rows", warnRef);
	    }
	    if (props.footerRows && !pluginsMap['footer-rows']) {
	      (0, _warn.communityFeatureWarn)("Footer rows", warnRef);
	    }
	    Object.assign(computedProps, useRowProps);
	    Object.assign(computedProps, pluginsMap['menus'].hook(props, computedProps, computedPropsRef));
	    var computedWillReceiveFocusRef = (0, _react.useRef)(false);
	    computedProps.getState = function () {
	      return context.state;
	    };
	    computedProps.setStateProperty = function (name, value) {
	      context.state[name] = value;
	    };
	    computedProps.computedWillReceiveFocusRef = computedWillReceiveFocusRef;
	    delete computedProps.style;
	    var getScrollingElement = function getScrollingElement() {
	      var scrollingElement = getVirtualList().getScrollingElement();
	      if (!scrollingElement.scrollerNode) {
	        scrollingElement = scrollingElement.scroller;
	      }
	      return scrollingElement.scrollerNode;
	    };
	    computedProps.getScrollingElement = getScrollingElement;
	    var onGridScrollIntoView = function onGridScrollIntoView(event) {
	      var gridNode = getBodyDOMNode();
	      var eventTarget = event.target;
	      if (event.target != gridNode) {
	        return;
	      }
	      var scrollLeft = gridNode.scrollLeft,
	        scrollTop = gridNode.scrollTop;
	      if (scrollLeft) {
	        gridNode.scrollLeft = computedProps.rtl ? getScrollLeftMax() : 0;
	        requestAnimationFrame(function () {
	          if (computedProps.wasUnmountedRef.current) {
	            return;
	          }
	          incrementScrollLeft(scrollLeft);
	        });
	      }
	      if (scrollTop && eventTarget) {
	        eventTarget.scrollTop = 0;
	        globalObject.requestAnimationFrame(function () {
	          if (computedProps.wasUnmountedRef.current) {
	            return;
	          }
	          incrementScrollTop(scrollTop);
	        });
	      }
	    };
	    var setupPassiveScrollListener = function setupPassiveScrollListener(node) {
	      node.addEventListener('scroll', onGridScrollIntoView, {
	        passive: true
	      });
	    };
	    var removePassiveScrollListener = function removePassiveScrollListener(node) {
	      if (node) {
	        node.removeEventListener('scroll', onGridScrollIntoView, {
	          passive: true
	        });
	      }
	    };
	    (0, _react.useEffect)(function () {
	      computedProps.wasMountedRef.current = true;
	      if (props.onDidMount) {
	        props.onDidMount(computedPropsRef);
	      }
	      var initialScrollLeft = props.initialScrollLeft,
	        initialScrollTop = props.initialScrollTop;
	      if (props.skipLoadOnMount) {
	        if (initialScrollTop) {
	          setScrollTop(initialScrollTop);
	        }
	        if (initialScrollLeft) {
	          setScrollLeft(initialScrollLeft);
	        }
	      }
	      var bodyNode = getBodyDOMNode();
	      setupPassiveScrollListener(bodyNode);
	      return function () {
	        removePassiveScrollListener(bodyNode);
	        if (props.onWillUnmount) {
	          props.onWillUnmount(computedPropsRef);
	        }
	        computedProps.wasUnmountedRef.current = true;
	      };
	    }, []);
	    (0, _react.useEffect)(function () {
	      if (props.handle) {
	        props.handle(computedPropsRef);
	      }
	      return function () {
	        if (props.handle) {
	          props.handle(null);
	        }
	      };
	    }, [props.handle]);
	    (0, _react.useEffect)(function () {
	      if (props.onReady && size.width) {
	        props.onReady(computedPropsRef);
	      }
	    }, [size.width !== 0]);
	    computedProps.cellNavigationRef = (0, _react.useRef)(null);
	    Object.assign(computedProps, pluginsMap['row-index-column'].hook(props, computedProps, computedPropsRef));
	    computedProps.coverHandleRef = (0, _react.useRef)(emptyCoverHandle);
	    computedProps.rowResizeIndexRef = (0, _react.useRef)(null);
	    var coverHandle = function coverHandle(_ref5) {
	      var setActive = _ref5.setActive,
	        setCursor = _ref5.setCursor;
	      computedPropsRef.current.coverHandleRef.current = {
	        setActive: setActive,
	        setCursor: setCursor
	      };
	    };
	    var activeItem = getItemAt(computedProps.computedActiveIndex);
	    var activeRowHeight = computedProps.computedRowHeights && activeItem ? computedProps.computedRowHeights[getItemId(activeItem)] : computedProps.rowHeight == null ? rowHeightManager.getRowHeight(computedProps.computedActiveIndex) : computedPropsRef.rowHeight;
	    computedProps.activeRowHeight = activeRowHeight || computedProps.rowHeight;
	    var emptyData = computedProps.data && computedProps.data.length;
	    if (computedFocused && computedProps.showActiveRowIndicator && emptyData) {
	      computedProps.renderActiveRowIndicator = function (handle) {
	        return _react.default.createElement(_ActiveRowIndicator.default, {
	          handle: handle,
	          rtl: computedProps.rtl,
	          rtlOffset: computedProps.rtlOffset,
	          getDOMNode: computedProps.getDOMNode,
	          dataSourceCount: computedProps.data.length,
	          width: computedProps.minRowWidth || 0,
	          computedRowHeights: computedProps.computedRowHeights,
	          computedExpandedRows: computedProps.computedExpandedRows,
	          computedExpandedNodes: computedProps.computedExpandedNodes,
	          activeRowHeight: computedProps.activeRowHeight,
	          activeIndex: computedProps.computedActiveIndex,
	          activeRowRef: computedProps.activeRowRef,
	          activeRowIndicatorClassName: computedProps.activeRowIndicatorClassName
	        });
	      };
	    }
	    computedProps.computedLicenseValid = false;
	    if (pluginsMap.license && pluginsMap.license.hook) {
	      Object.assign(computedProps, pluginsMap.license.hook(props, computedProps, computedPropsRef));
	    }
	    Object.assign(computedProps, pluginsMap['clipboard'].hook(props, computedProps, computedPropsRef));
	    if (edition !== 'enterprise') {
	      if (props.rowIndexColumn) {
	        (0, _warn.communityFeatureWarn)('Row resize (row index column)', warnRef);
	      }
	      if (props.livePagination) {
	        (0, _warn.communityFeatureWarn)('Live pagination', warnRef);
	      }
	      if (props.onRowReorder != null || props.rowReorderColumn != null) {
	        (0, _warn.communityFeatureWarn)('Row reorder', warnRef);
	      }
	      if (props.enableClipboard) {
	        (0, _warn.communityFeatureWarn)('Clipboard', warnRef);
	      }
	    }
	    delete computedProps.renderLockedStartCells;
	    delete computedProps.renderLockedEndCells;
	    if (pluginsMap['locked-columns']) {
	      computedProps.renderLockedStartCells = pluginsMap['locked-columns'].renderLockedStartCells;
	      computedProps.renderLockedEndCells = pluginsMap['locked-columns'].renderLockedEndCells;
	    }
	    Object.defineProperty(computedProps, 'scrollTop', {
	      get: function get() {
	        return getScrollTop();
	      },
	      set: function set(newValue) {
	        setScrollTop(newValue);
	      },
	      enumerable: true,
	      configurable: true
	    });
	    Object.defineProperty(computedProps, 'scrollLeft', {
	      get: function get() {
	        return getScrollLeft();
	      },
	      set: function set(newValue) {
	        setScrollLeft(newValue);
	      },
	      enumerable: true,
	      configurable: true
	    });
	    computedProps.edition = edition;
	    return _react.default.createElement("div", {
	      style: props.style,
	      className: className,
	      onKeyDown: onKeyDown,
	      onFocus: onFocus,
	      onBlur: onBlur,
	      ref: domRef
	    }, _react.default.createElement(_context.Provider, {
	      value: computedProps
	    }, pluginsMap['row-index-column'].renderRowResizeIndicator(computedProps, computedPropsRef), _react.default.createElement(_Layout.default, {
	      Footer: pluginsMap['footer-rows'] ? pluginsMap['footer-rows'].Footer : null,
	      ref: bodyRef,
	      renderInPortal: renderInPortal
	    }), _react.default.createElement(_Cover.default, {
	      handle: coverHandle
	    })), computedProps.computedLicenseValid === false && edition === 'enterprise' ? pluginsMap['license'].renderLicenseNotice(computedProps, computedPropsRef) : null, _react.default.createElement(_src.default, {
	      onResize: onResize,
	      notifyOnMount: true
	    }), renderLoadMask(computedProps), typeof pluginsMap['menus'].renderColumnContextMenu === 'function' ? pluginsMap['menus'].renderColumnContextMenu(computedProps, computedPropsRef) : null, typeof pluginsMap['menus'].renderRowContextMenu === 'function' ? pluginsMap['menus'].renderRowContextMenu(computedProps, computedPropsRef) : null, typeof pluginsMap['filters'].renderColumnFilterContextMenu === 'function' ? pluginsMap['filters'].renderColumnFilterContextMenu(computedProps, computedPropsRef) : null, _react.default.createElement("div", {
	      ref: portalRef,
	      className: "InovuaReactDataGrid__portal-host"
	    }));
	  });
	  var defaultProps = {
	    idProperty: 'id',
	    rowHeight: 40,
	    headerHeight: 40,
	    filterRowHeight: 40,
	    minRowHeight: 20,
	    nativeScroll: false,
	    autoCheckboxColumn: false,
	    activateRowOnFocus: true,
	    checkboxOnlyRowSelect: false,
	    checkboxSelectEnableShiftKey: false,
	    renderScroller: function renderScroller(domProps) {
	      domProps.tabIndex = 0;
	    },
	    stickyHeader: false,
	    enableCellBulkUpdate: false,
	    enableKeyboardNavigation: true,
	    scrollTopOnFilter: true,
	    scrollTopOnSort: true,
	    scrollTopOnGroupBy: true,
	    defaultShowHeader: true,
	    defaultShowEmptyRows: false,
	    defaultShowHoverRows: true,
	    defaultShowZebraRows: true,
	    defaultShowCellBorders: true,
	    allowRowTabNavigation: false,
	    cellSelectionByIndex: false,
	    columnResizeHandleWidth: _isMobile.default ? 15 : 5,
	    columnResizeProxyWidth: 5,
	    virtualizeColumnsThreshold: 15,
	    shareSpaceOnResize: false,
	    enableColumnFilterContextMenu: true,
	    copySpreadsheetCompatibleString: false,
	    clipboardSeparator: '\t',
	    resizable: true,
	    virtualized: true,
	    allowUnsort: true,
	    rtl: false,
	    theme: 'default-light',
	    filterTypes: _filterTypes.default,
	    keyPageStep: 10,
	    expandGroupTitle: true,
	    allowGroupSplitOnReorder: true,
	    defaultCollapsedGroups: {},
	    groupPathSeparator: '/',
	    nodePathSeparator: '/',
	    idPropertySeparator: '.',
	    groupNestingSize: 22,
	    treeNestingSize: 22,
	    columnMinWidth: 40,
	    enableTreeRowReorderNestingChange: true,
	    enableTreeRowReorderParentChange: true,
	    columnReorderScrollByAmount: 20,
	    rowReorderScrollByAmount: 20,
	    rowReorderAutoScroll: false,
	    rowReorderAutoScrollSpeed: 40,
	    allowRowReorderBetweenGroups: false,
	    reorderProxySize: 3,
	    expandOnMouseDown: false,
	    columnMaxWidth: null,
	    editStartEvent: 'dblclick',
	    hideGroupByColumns: true,
	    defaultColumnOrder: undefined,
	    columnUserSelect: false,
	    columnHeaderUserSelect: false,
	    stickyGroupRows: false,
	    showWarnings: !_uglified.default,
	    toggleRowSelectOnClick: false,
	    toggleCellSelectOnClick: true,
	    clearNodeCacheOnDataSourceChange: true,
	    clearDataSourceCacheOnChange: true,
	    preventDefaultTextSelectionOnShiftMouseDown: true,
	    preventRowSelectionOnClickWithMouseMove: true,
	    showColumnMenuSortOptions: true,
	    showColumnMenuLockOptions: true,
	    showColumnMenuFilterOptions: true,
	    showColumnMenuGroupOptions: true,
	    autoFocusOnEditComplete: true,
	    autoFocusOnEditEscape: true,
	    showActiveRowIndicator: true,
	    showPivotSummaryColumns: true,
	    showColumnMenuToolOnHover: !_isMobile.default,
	    columnFilterContextMenuConstrainTo: true,
	    columnFilterContextMenuPosition: 'absolute',
	    generateIdFromPath: true,
	    collapseChildrenOnAsyncNodeCollapse: true,
	    collapseChildrenRecursive: true,
	    selectNodesRecursive: true,
	    isExpandKeyPressed: function isExpandKeyPressed(_ref6) {
	      var event = _ref6.event;
	      return event.key === 'ArrowRight' && event.altKey;
	    },
	    isCollapseKeyPressed: function isCollapseKeyPressed(_ref7) {
	      var event = _ref7.event;
	      return event.key === 'ArrowLeft' && event.altKey;
	    },
	    isStartEditKeyPressed: function isStartEditKeyPressed(_ref8) {
	      var event = _ref8.event;
	      return event.key === 'e' && event.ctrlKey;
	    },
	    rowExpandHeight: 80,
	    growExpandHeightWithDetails: true,
	    livePaginationLoadNextDelay: true,
	    livePaginationLoadMaskHideDelay: 50,
	    checkResizeDelay: 0,
	    multiRowExpand: true,
	    useNativeFlex: false,
	    disableGroupByToolbar: false,
	    updateMenuPositionOnScroll: true,
	    updateMenuPositionOnColumnsChange: true,
	    useRowHeightForLockedRows: true,
	    nodesProperty: 'nodes',
	    rowDetailsWidth: 'max-viewport-width',
	    contain: 'style layout',
	    rowContain: 'style layout',
	    groupToString: function groupToString(obj) {
	      var type = (0, _typeof2.default)(obj);
	      return type == 'string' || type === 'number' || type === 'boolean' ? "".concat(obj) : JSON.stringify(obj);
	    },
	    scrollProps: {
	      autoHide: true,
	      scrollThumbMargin: 4,
	      scrollThumbWidth: 6,
	      scrollThumbOverWidth: 8
	    },
	    detailsGridCacheKey: true,
	    sortFunctions: {
	      date: function date(v1, v2, column) {
	        if (window.moment && column.dateFormat) {
	          return window.moment(v1, column.dateFormat) - window.moment(v2, column.dateFormat);
	        }
	        return v1 - v2;
	      }
	    },
	    i18n: DEFAULT_I18N,
	    emptyText: 'noRecords',
	    isBinaryOperator: function isBinaryOperator(operator) {
	      return operator === 'inrange' || operator === 'notinrange';
	    },
	    skipHeaderOnAutoSize: false,
	    enableColumnAutosize: true
	  };
	  var maybeAddCols = [];
	  plugins.forEach(function (plugin) {
	    if (!plugin.name) {
	      return;
	    }
	    if (typeof plugin.defaultProps === 'function') {
	      var result = plugin.defaultProps(Grid.defaultProps);
	      if (result != null) {
	        Grid.defaultProps = _objectSpread(_objectSpread({}, Grid.defaultProps), result);
	      }
	    }
	    if (typeof plugin.maybeAddColumns === 'function') {
	      maybeAddCols.push(plugin.maybeAddColumns);
	    }
	  });
	  if (maybeAddCols.length) {
	    maybeAddColumns = function maybeAddColumns(columns, props) {
	      var result = columns;
	      maybeAddCols.forEach(function (fn) {
	        result = fn(result, props);
	      });
	      return result;
	    };
	  }
	  var TheGrid = function TheGrid(props) {
	    var contextValue = (0, _react.useMemo)(function () {
	      return {
	        state: props.initialState || {}
	      };
	    }, []);
	    var Context = (0, _react.useMemo)(function () {
	      return _react.default.createContext(contextValue);
	    }, []);
	    return _react.default.createElement(Context.Provider, {
	      value: contextValue
	    }, _react.default.createElement(Grid, _objectSpread(_objectSpread({}, props), {}, {
	      context: Context
	    })));
	  };
	  TheGrid.defaultProps = defaultProps;
	  return TheGrid;
	};
	var _default = GridFactory;
	exports.default = _default;

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _default = function _default(_ref) {
	  var visibleColumns = _ref.visibleColumns,
	    availableWidth = _ref.availableWidth,
	    lockedStartColumns = _ref.lockedStartColumns,
	    lockedEndColumns = _ref.lockedEndColumns,
	    virtualizeColumns = _ref.virtualizeColumns;
	  if (virtualizeColumns === false) {
	    return visibleColumns.length;
	  }
	  var columns = (0, _toConsumableArray2.default)(visibleColumns).sort(function (a, b) {
	    return a.computedWidth - b.computedWidth;
	  });
	  var columnWidthPrefixSums = [];
	  var widthSum = 0;
	  var accumulateWidth = 0;
	  var columnRenderCount = 0;
	  columns.forEach(function (col) {
	    columnWidthPrefixSums.push(widthSum);
	    widthSum += col.computedWidth;
	    if (accumulateWidth <= availableWidth) {
	      columnRenderCount++;
	      accumulateWidth += col.computedWidth;
	    }
	  });
	  columnRenderCount += 1;
	  if (lockedStartColumns && lockedStartColumns.length) {
	    columnRenderCount -= lockedStartColumns.length;
	  }
	  if (lockedEndColumns && lockedEndColumns.length) {
	    columnRenderCount -= lockedEndColumns.length;
	  }
	  return columnRenderCount;
	};
	exports.default = _default;

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var _default = function _default(groups, props) {
	  var map = groups.reduce(function (acc, group) {
	    if (group.name) {
	      acc[group.name] = _objectSpread({}, group);
	    }
	    return acc;
	  }, {});
	  if (props.showWarnings) {
	    groups.forEach(function (group) {
	      if (group.group && !map[group.group]) {
	        console.error("You have referred group \"".concat(group.group, "\", but it is not defined in your groups prop."));
	      }
	    });
	  }
	  Object.keys(map).map(function (groupName) {
	    var count = -1;
	    var group;
	    var itGroupName = groupName;
	    while (group = map[itGroupName]) {
	      count++;
	      itGroupName = group.group;
	      if (!itGroupName) {
	        break;
	      }
	    }
	    map[groupName].computedDepth = count;
	  });
	  return map;
	};
	exports.default = _default;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _useProperty5 = _interopRequireDefault(__webpack_require__(48));
	var _react = __webpack_require__(2);
	var _clamp = _interopRequireDefault(__webpack_require__(65));
	var _usePrevious = _interopRequireDefault(__webpack_require__(61));
	var _throttle = _interopRequireDefault(__webpack_require__(269));
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var useActiveIndex = function useActiveIndex(props, computedProps, computedPropsRef) {
	  var _useProperty = (0, _useProperty5.default)(props, 'activeIndex', -1),
	    _useProperty2 = (0, _slicedToArray2.default)(_useProperty, 2),
	    computedActiveIndex = _useProperty2[0],
	    doSetActiveIndex = _useProperty2[1];
	  var _useProperty3 = (0, _useProperty5.default)(props, 'lastActiveIndex', null),
	    _useProperty4 = (0, _slicedToArray2.default)(_useProperty3, 2),
	    computedLastActiveIndex = _useProperty4[0],
	    doSetLastActiveIndex = _useProperty4[1];
	  if (!props.enableKeyboardNavigation) {
	    computedActiveIndex = -1;
	  }
	  var setActiveIndex = (0, _react.useCallback)(function (activeIndex) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps || !computedProps.computedHasRowNavigation || globalObject.isNaN(activeIndex)) {
	      return;
	    }
	    var data = computedProps.data;
	    if (activeIndex >= 0) {
	      activeIndex = (0, _clamp.default)(activeIndex, 0, data.length - 1);
	    } else {
	      activeIndex = -1;
	    }
	    if (activeIndex === computedProps.computedActiveIndex) {
	      return;
	    }
	    doSetActiveIndex(activeIndex);
	  }, []);
	  var incrementActiveIndex = (0, _react.useCallback)(function (inc) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var computedActiveIndex = computedProps.computedActiveIndex;
	    if (computedProps.activeIndexThrottle) {
	      (0, _throttle.default)(function () {
	        return setActiveIndex(computedActiveIndex + inc);
	      }, computedProps.activeIndexThrottle, {
	        trailing: true,
	        leading: false
	      });
	    } else {
	      setActiveIndex(computedActiveIndex + inc);
	    }
	  }, []);
	  var getActiveItem = (0, _react.useCallback)(function () {
	    var computedProps = computedPropsRef.current;
	    return computedProps ? computedProps.data[computedProps.computedActiveIndex] : null;
	  }, []);
	  var getFirstVisibleIndex = (0, _react.useCallback)(function () {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return -1;
	    }
	    var scrollTop = computedProps.getScrollTop();
	    var rowHeight = props.rowHeight;
	    return Math.ceil(scrollTop / rowHeight);
	  }, [props.rowHeight]);
	  var oldActiveIndex = (0, _usePrevious.default)(computedActiveIndex, -1);
	  (0, _react.useEffect)(function () {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (!computedProps.computedFocused) {
	      return;
	    }
	    if (oldActiveIndex !== computedActiveIndex) {
	      var top = computedActiveIndex < oldActiveIndex;
	      computedProps.scrollToIndexIfNeeded(computedActiveIndex, {
	        top: top
	      });
	    }
	  }, [computedActiveIndex, oldActiveIndex]);
	  computedProps.activeRowRef = (0, _react.useRef)(null);
	  return {
	    computedActiveIndex: computedActiveIndex,
	    setActiveIndex: setActiveIndex,
	    incrementActiveIndex: incrementActiveIndex,
	    getActiveItem: getActiveItem,
	    getFirstVisibleIndex: getFirstVisibleIndex,
	    computedLastActiveIndex: computedLastActiveIndex,
	    doSetLastActiveIndex: doSetLastActiveIndex
	  };
	};
	var _default = useActiveIndex;
	exports.default = _default;

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = __webpack_require__(2);
	var useColumnHover = function useColumnHover(_props, _computedProps, computedPropsRef) {
	  var _useState = (0, _react.useState)(-1),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    columnIndexHovered = _useState2[0],
	    setColumnIndexHovered = _useState2[1];
	  var onColumnMouseEnter = (0, _react.useCallback)(function (cellProps) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.computedEnableColumnHover || cellProps.computedEnableColumnHover) {
	      var columnIndex = cellProps.columnIndex;
	      if (columnIndex != null) {
	        setColumnIndexHovered(columnIndex);
	      }
	    }
	  }, []);
	  var onColumnMouseLeave = (0, _react.useCallback)(function (cellProps) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.computedEnableColumnHover || cellProps.computedEnableColumnHover) {
	      setColumnIndexHovered(-1);
	    }
	  }, []);
	  return {
	    columnIndexHovered: columnIndexHovered,
	    onColumnMouseEnter: onColumnMouseEnter,
	    onColumnMouseLeave: onColumnMouseLeave
	  };
	};
	var _default = useColumnHover;
	exports.default = _default;

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _columnResize = _interopRequireDefault(__webpack_require__(793));
	var _useColumnInfo2 = _interopRequireDefault(__webpack_require__(619));
	var _getColumnRenderCount = _interopRequireDefault(__webpack_require__(591));
	var _batchUpdate = _interopRequireDefault(__webpack_require__(50));
	var _useProperty3 = _interopRequireDefault(__webpack_require__(48));
	var _useNamedState3 = _interopRequireDefault(__webpack_require__(105));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var setColumnSizes = function setColumnSizes(newColumnSizes, columnFlexes, reservedViewportWidth, _ref) {
	  var columnSizes = _ref.columnSizes,
	    getColumnBy = _ref.getColumnBy,
	    setColumnFlexes = _ref.setColumnFlexes,
	    setColumnSizes = _ref.setColumnSizes,
	    onBatchColumnResize = _ref.onBatchColumnResize,
	    onColumnResize = _ref.onColumnResize;
	  var reservedViewportWidthWrapper = {
	    reservedViewportWidth: reservedViewportWidth
	  };
	  var batchColumns = onBatchColumnResize ? [] : null;
	  Object.keys(newColumnSizes).forEach(function (colId) {
	    var size = newColumnSizes[colId];
	    var column = getColumnBy(colId, {
	      initial: true
	    });
	    if (column != null) {
	      if (batchColumns) {
	        batchColumns.push({
	          column: column,
	          width: size,
	          flex: undefined
	        });
	      }
	      if (onColumnResize) {
	        onColumnResize({
	          column: column,
	          width: size,
	          flex: undefined
	        }, reservedViewportWidthWrapper);
	      }
	    }
	  });
	  Object.keys(columnFlexes || {}).forEach(function (colId) {
	    var size = columnFlexes[colId];
	    var column = getColumnBy(colId, {
	      initial: true
	    });
	    if (column) {
	      if (batchColumns) {
	        batchColumns.push({
	          column: column,
	          size: size,
	          width: undefined,
	          flex: size
	        });
	      }
	      if (onColumnResize) {
	        onColumnResize({
	          column: column,
	          size: size,
	          width: undefined,
	          flex: size
	        }, reservedViewportWidthWrapper);
	      }
	    }
	  });
	  if (onBatchColumnResize) {
	    onBatchColumnResize(batchColumns, reservedViewportWidthWrapper);
	  }
	  setColumnSizes(Object.assign({}, columnSizes, newColumnSizes));
	  setColumnFlexes(columnFlexes);
	};
	var getColumnBy = function getColumnBy(propColumns, visibleColumns, columnsMap) {
	  return function (idNameOrIndex, config) {
	    var column;
	    if ((0, _typeof2.default)(idNameOrIndex) === 'object') {
	      idNameOrIndex = idNameOrIndex.id == null ? idNameOrIndex.name : idNameOrIndex.id;
	    }
	    if (typeof idNameOrIndex === 'number') {
	      column = visibleColumns[idNameOrIndex];
	    } else {
	      column = columnsMap[idNameOrIndex];
	    }
	    if (!config || !config.initial || column && column.pivotColumn) {
	      return column;
	    }
	    return propColumns.filter(function (c) {
	      return c.id === column.id || c.name === column.id;
	    })[0];
	  };
	};
	var _default = function _default(props, _ref2, computedPropsRef) {
	  var maxAvailableWidthForColumns = _ref2.maxAvailableWidthForColumns,
	    lockedColumnsState = _ref2.lockedColumnsState,
	    computedPivotUniqueValuesPerColumn = _ref2.computedPivotUniqueValuesPerColumn,
	    computedGroups = _ref2.computedGroups,
	    computedSortInfo = _ref2.computedSortInfo,
	    computedFilterValueMap = _ref2.computedFilterValueMap,
	    computedGroupBy = _ref2.computedGroupBy,
	    computedFilterable = _ref2.computedFilterable,
	    columnFlexes = _ref2.columnFlexes,
	    columnSizes = _ref2.columnSizes,
	    maybeAddColumns = _ref2.maybeAddColumns;
	  var _useProperty = (0, _useProperty3.default)(props, 'columnOrder'),
	    _useProperty2 = (0, _slicedToArray2.default)(_useProperty, 2),
	    columnOrder = _useProperty2[0],
	    setColumnOrder = _useProperty2[1];
	  var _useNamedState = (0, _useNamedState3.default)(props.columns.reduce(function (acc, col) {
	      if (col.defaultVisible === false || col.visible === false) {
	        acc[col.id || col.name] = false;
	      }
	      return acc;
	    }, {}), props.context, 'stateColumnVisibilityMap'),
	    _useNamedState2 = (0, _slicedToArray2.default)(_useNamedState, 2),
	    stateColumnVisibilityMap = _useNamedState2[0],
	    setStateColumnVisibilityMap = _useNamedState2[1];
	  var _useColumnInfo = (0, _useColumnInfo2.default)({
	      showPivotSummaryColumns: props.showPivotSummaryColumns,
	      lockedColumnsState: lockedColumnsState,
	      columnOrder: columnOrder,
	      columnFlexes: columnFlexes,
	      columnSizes: columnSizes,
	      pivotGrandSummaryColumn: props.pivotGrandSummaryColumn,
	      columnVisibilityMap: stateColumnVisibilityMap,
	      columnMinWidth: props.columnMinWidth,
	      columnMaxWidth: props.columnMaxWidth,
	      resizable: props.resizable,
	      pivot: props.pivot,
	      computedGroups: computedGroups,
	      filterable: computedFilterable,
	      filterValueMap: computedFilterValueMap,
	      groupBy: computedGroupBy,
	      groupColumn: props.groupColumn,
	      rowIndexColumn: props.rowIndexColumn,
	      checkboxColumn: props.checkboxColumn,
	      computedPivotUniqueValuesPerColumn: computedPivotUniqueValuesPerColumn,
	      editable: props.editable,
	      sortable: props.sortable,
	      columns: props.columns,
	      rtl: props.rtl,
	      sortInfo: computedSortInfo,
	      availableWidth: maxAvailableWidthForColumns,
	      columnDefaultWidth: props.columnDefaultWidth,
	      inTransition: false,
	      hideGroupByColumns: props.hideGroupByColumns,
	      groupNestingSize: props.groupNestingSize,
	      groupForGroupColumns: props.groupForGroupColumns || '__',
	      enableRowExpand: props.enableRowExpand,
	      expandedRows: props.expandedRows,
	      defaultExpandedRows: props.defaultExpandedRows,
	      renderRowDetails: props.renderRowDetails,
	      renderDetailsGrid: props.renderDetailsGrid,
	      maybeAddColumns: maybeAddColumns,
	      rowExpandColumn: props.rowExpandColumn,
	      onRowReorder: props.onRowReorder,
	      rowReorderColumn: props.rowReorderColumn,
	      renderRowDetailsExpandIcon: props.renderRowDetailsExpandIcon,
	      renderRowDetailsCollapsedIcon: props.renderRowDetailsCollapsedIcon
	    }),
	    groupColumnSummaryReducers = _useColumnInfo.groupColumnSummaryReducers,
	    pivotColumnSummaryReducers = _useColumnInfo.pivotColumnSummaryReducers,
	    visibleColumns = _useColumnInfo.visibleColumns,
	    lockedStartColumns = _useColumnInfo.lockedStartColumns,
	    lockedEndColumns = _useColumnInfo.lockedEndColumns,
	    unlockedColumns = _useColumnInfo.unlockedColumns,
	    columnWidthPrefixSums = _useColumnInfo.columnWidthPrefixSums,
	    columnsMap = _useColumnInfo.columnsMap,
	    columnVisibilityMap = _useColumnInfo.columnVisibilityMap,
	    allColumns = _useColumnInfo.allColumns,
	    computedEnableRowspan = _useColumnInfo.computedEnableRowspan,
	    totalComputedWidth = _useColumnInfo.totalComputedWidth,
	    totalLockedStartWidth = _useColumnInfo.totalLockedStartWidth,
	    totalFlexColumnCount = _useColumnInfo.totalFlexColumnCount,
	    totalLockedEndWidth = _useColumnInfo.totalLockedEndWidth,
	    totalUnlockedWidth = _useColumnInfo.totalUnlockedWidth,
	    minColumnsSize = _useColumnInfo.minColumnsSize,
	    computedHasColSpan = _useColumnInfo.computedHasColSpan,
	    hasValueSetter = _useColumnInfo.hasValueSetter;
	  var virtualizeColumns = props.virtualizeColumns !== undefined ? props.virtualizeColumns : visibleColumns.length >= props.virtualizeColumnsThreshold;
	  if (typeof props.rowHeight !== 'number') {
	    virtualizeColumns = false;
	  }
	  var columnRenderCount = (0, _getColumnRenderCount.default)({
	    availableWidth: maxAvailableWidthForColumns,
	    visibleColumns: visibleColumns,
	    lockedStartColumns: lockedStartColumns,
	    lockedEndColumns: lockedEndColumns,
	    virtualizeColumns: virtualizeColumns
	  });
	  var hasLockedStart = !!lockedStartColumns.length;
	  var hasLockedEnd = !!lockedEndColumns.length;
	  var hasUnlocked = !!unlockedColumns.length;
	  var firstUnlockedIndex = hasUnlocked ? unlockedColumns[0].computedVisibleIndex : -1;
	  var firstLockedStartIndex = hasLockedStart ? lockedStartColumns[0].computedVisibleIndex : -1;
	  var firstLockedEndIndex = hasLockedEnd ? lockedEndColumns[0].computedVisibleIndex : -1;
	  var lastLockedEndIndex = hasLockedEnd ? lockedEndColumns[lockedEndColumns.length - 1].computedVisibleIndex : -1;
	  var lastLockedStartIndex = hasLockedStart ? lockedStartColumns[lockedStartColumns.length - 1].computedVisibleIndex : -1;
	  var lastUnlockedIndex = hasUnlocked ? unlockedColumns[unlockedColumns.length - 1].computedVisibleIndex : -1;
	  var computedOnColumnResize = function computedOnColumnResize(_ref3) {
	    var index = _ref3.index,
	      groupColumns = _ref3.groupColumns,
	      diff = _ref3.diff;
	    var computedProps = computedPropsRef.current;
	    if (computedProps == null) {
	      return;
	    }
	    var maxAvailableWidthForColumns = computedProps.maxAvailableWidthForColumns,
	      shareSpaceOnResize = computedProps.shareSpaceOnResize,
	      totalComputedWidth = computedProps.totalComputedWidth;
	    var result = (0, _columnResize.default)({
	      columns: computedProps.visibleColumns,
	      groupColumns: groupColumns,
	      maxAvailableWidthForColumns: maxAvailableWidthForColumns,
	      shareSpaceOnResize: shareSpaceOnResize,
	      totalComputedWidth: totalComputedWidth,
	      index: index,
	      diff: diff
	    });
	    if (computedProps.rtl && diff) {
	      var _totalComputedWidth = computedProps.totalComputedWidth;
	      var oldScrollLeft = computedProps.getScrollLeft();
	      computedProps.onNextRender(function () {
	        var computedProps = computedPropsRef.current;
	        if (computedProps == null) {
	          return;
	        }
	        if (computedProps.totalComputedWidth === _totalComputedWidth + diff) {
	          var newScrollLeft = oldScrollLeft + diff;
	          computedProps.setScrollLeft(newScrollLeft);
	        }
	      });
	    }
	    (0, _batchUpdate.default)().commit(function () {
	      var newReservedViewportWidth = computedProps.reservedViewportWidth;
	      if (typeof result.maxAvailableWidthForColumns == 'number' && result.maxAvailableWidthForColumns !== maxAvailableWidthForColumns) {
	        var widthDiff = result.maxAvailableWidthForColumns - maxAvailableWidthForColumns;
	        newReservedViewportWidth = computedProps.reservedViewportWidth - widthDiff;
	        computedProps.setReservedViewportWidth(newReservedViewportWidth);
	      }
	      setColumnSizes(result.newColumnSizes || {}, result.newColumnFlexes, newReservedViewportWidth, {
	        getColumnBy: computedProps.getColumnBy,
	        onColumnResize: computedProps.initialProps.onColumnResize,
	        onBatchColumnResize: computedProps.initialProps.onBatchColumnResize,
	        columnSizes: computedProps.columnSizes,
	        setColumnSizes: computedProps.setColumnSizes,
	        setColumnFlexes: computedProps.setColumnFlexes
	      });
	    });
	  };
	  var getColumn = getColumnBy(props.columns, visibleColumns, columnsMap);
	  var setColumnVisible = function setColumnVisible(indexOrColumn, visible) {
	    var column = getColumn(indexOrColumn);
	    if (!column) {
	      return;
	    }
	    if (isColumnVisible(column) === visible) {
	      return;
	    }
	    var col = getColumn(column, {
	      initial: true
	    });
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (typeof computedProps.initialProps.onColumnVisibleChange === 'function') {
	      computedProps.initialProps.onColumnVisibleChange({
	        column: col,
	        visible: visible
	      });
	    }
	    if (col.visible === undefined) {
	      setStateColumnVisibilityMap(_objectSpread(_objectSpread({}, stateColumnVisibilityMap), {}, (0, _defineProperty2.default)({}, column.id, !!visible)));
	    } else if (computedProps.showWarnings && !computedProps.initialProps.onColumnVisibleChange) {
	      console.warn("Column \"".concat(column.id, "\" has controlled visible prop set to \"").concat(column.visible, "\" but you have no \"onColumnVisibleChange\" callback prop to update column.visible prop. Use uncontrolled \"defaultVisible\" instead."));
	    }
	  };
	  var isColumnVisible = function isColumnVisible(nameOrId) {
	    var column = getColumn(nameOrId);
	    if (!column) {
	      return false;
	    }
	    return column.computedVisible === true;
	  };
	  var setColumnLocked = function setColumnLocked(indexOrColumn, locked) {
	    var column = getColumn(indexOrColumn);
	    if (locked === null) {
	      locked = false;
	    }
	    locked = locked === true ? 'start' : locked;
	    if (column.lockable === false) {
	      if (props.showWarnings) {
	        console.error("You are trying to lock the \"".concat(column.id, "\" column, but it is lockable===false, so it cannot be locked."));
	      }
	      return;
	    }
	    var initialColumn = getColumn(column, {
	      initial: true
	    });
	    if (props.onColumnLockedChange) {
	      props.onColumnLockedChange({
	        column: initialColumn,
	        locked: locked
	      });
	    }
	    if (initialColumn.locked !== undefined) {
	      return;
	    }
	    var computedProps = computedPropsRef.current;
	    if (computedProps == null) {
	      return;
	    }
	    var setLockedColumnsState = computedProps.setLockedColumnsState;
	    setLockedColumnsState(function (lockedColumnsState) {
	      return _objectSpread(_objectSpread({}, lockedColumnsState), {}, (0, _defineProperty2.default)({}, column.id, locked));
	    });
	  };
	  var getColumnsInOrder = function getColumnsInOrder() {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return [];
	    }
	    var computedColumnOrder = computedProps.computedColumnOrder;
	    if (!computedColumnOrder || !computedColumnOrder.length) {
	      return computedProps.initialProps.columns.map(function (cId) {
	        return computedProps.getColumnBy(cId);
	      });
	    }
	    return computedColumnOrder.map(function (cId) {
	      return computedProps.getColumnBy(cId);
	    });
	  };
	  return {
	    getColumnsInOrder: getColumnsInOrder,
	    groupColumnSummaryReducers: groupColumnSummaryReducers,
	    pivotColumnSummaryReducers: pivotColumnSummaryReducers,
	    groupColumn: props.pivot ? props.groupColumn || true : props.groupColumn,
	    firstLockedStartIndex: firstLockedStartIndex,
	    firstLockedEndIndex: firstLockedEndIndex,
	    firstUnlockedIndex: firstUnlockedIndex,
	    lastLockedStartIndex: lastLockedStartIndex,
	    lastUnlockedIndex: lastUnlockedIndex,
	    lastLockedEndIndex: lastLockedEndIndex,
	    visibleColumns: visibleColumns,
	    columnWidthPrefixSums: columnWidthPrefixSums,
	    lockedStartColumns: lockedStartColumns,
	    lockedEndColumns: lockedEndColumns,
	    unlockedColumns: unlockedColumns,
	    columnVisibilityMap: columnVisibilityMap,
	    computedHasColSpan: computedHasColSpan,
	    setColumnLocked: setColumnLocked,
	    computedColumnOrder: columnOrder,
	    setColumnOrder: setColumnOrder,
	    setColumnVisible: setColumnVisible,
	    computeColumnSizes: setColumnSizes,
	    computedPivot: props.pivot,
	    totalFlexColumnCount: totalFlexColumnCount,
	    showColumnMenuTool: props.pivot ? false : props.showColumnMenuTool,
	    columnsMap: columnsMap,
	    allColumns: allColumns,
	    totalComputedWidth: totalComputedWidth,
	    totalLockedStartWidth: totalLockedStartWidth,
	    totalLockedEndWidth: totalLockedEndWidth,
	    totalUnlockedWidth: totalUnlockedWidth,
	    minColumnsSize: minColumnsSize,
	    hasLockedStart: hasLockedStart,
	    hasLockedEnd: hasLockedEnd,
	    hasUnlocked: hasUnlocked,
	    computedEnableRowspan: computedEnableRowspan,
	    columnRenderCount: columnRenderCount,
	    virtualizeColumns: virtualizeColumns,
	    computedOnColumnResize: computedOnColumnResize,
	    getColumnBy: getColumn,
	    isColumnVisible: isColumnVisible,
	    hasValueSetter: hasValueSetter
	  };
	};
	exports.default = _default;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _getScrollbarWidth = _interopRequireDefault(__webpack_require__(47));
	var _defaultCheckColumnId = __webpack_require__(147);
	var _defaultRowReorderColumnId = __webpack_require__(148);
	var _defaultRowIndexColumnId = __webpack_require__(226);
	var _defaultRowExpandColumnId = __webpack_require__(225);
	var EMPTY_OBJECT = {};
	var removeItemFromArray = function removeItemFromArray(array, obj) {
	  var index = array.indexOf(obj);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	};
	var getColumnsWidths = function getColumnsWidths(columns) {
	  return columns.reduce(function (width, column) {
	    return width + column.computedWidth;
	  }, 0);
	};
	var checkForSpecialColumns = function checkForSpecialColumns(id) {
	  var specialColumns = [_defaultCheckColumnId.id, _defaultRowReorderColumnId.id, _defaultRowIndexColumnId.id, _defaultRowExpandColumnId.id];
	  if (specialColumns.indexOf(id) === -1) {
	    return false;
	  }
	  return true;
	};
	var useColumnsSizing = function useColumnsSizing(_props, _computedProps, computedPropsRef) {
	  var computeColumnSizesToFit = function computeColumnSizesToFit(gridWidth) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var visibleColumns = computedProps.visibleColumns;
	    if (gridWidth <= 0 || !visibleColumns.length) {
	      return;
	    }
	    var columnsToSize = [];
	    var columnsNotToSize = [];
	    visibleColumns.forEach(function (column) {
	      if (column.resizable === false) {
	        columnsNotToSize.push(column);
	      } else {
	        columnsToSize.push(column);
	      }
	    });
	    var columnsToResize = columnsToSize.slice(0);
	    var finished = false;
	    var updateColumnsNotToSize = function updateColumnsNotToSize(column) {
	      removeItemFromArray(columnsToResize, column);
	      columnsNotToSize.push(column);
	    };
	    var newColumnSizes = {};
	    while (!finished) {
	      finished = true;
	      var availableSpace = gridWidth - getColumnsWidths(columnsNotToSize);
	      var scale = availableSpace / getColumnsWidths(columnsToResize);
	      var spaceForLastColumn = availableSpace;
	      for (var i = columnsToResize.length - 1; i >= 0; i--) {
	        var column = columnsToResize[i];
	        var minWidth = column.computedMinWidth;
	        var maxWidth = column.computedMaxWidth;
	        var newWidth = Math.round(column.computedWidth * scale);
	        if (minWidth && newWidth < minWidth) {
	          newWidth = minWidth;
	          updateColumnsNotToSize(column);
	          finished = false;
	        } else if (maxWidth && newWidth > maxWidth) {
	          newWidth = maxWidth;
	          updateColumnsNotToSize(column);
	          finished = false;
	        } else if (i === 0) {
	          newWidth = spaceForLastColumn;
	        }
	        var columnId = column.id;
	        Object.assign(newColumnSizes, (0, _defineProperty2.default)({}, columnId, newWidth));
	        spaceForLastColumn -= newWidth;
	      }
	    }
	    if (computedProps.virtualizeColumns) {
	      var bodyRef = computedProps.bodyRef.current;
	      var columnLayout = bodyRef.columnLayout;
	      var headerLayout = columnLayout.headerLayout;
	      var header = headerLayout.header;
	      setTimeout(function () {
	        header.updateColumns();
	      }, 10);
	    }
	    var newReservedViewportWidth = computedProps.reservedViewportWidth;
	    var columnFlexes = computedProps.columnFlexes;
	    computedProps.computeColumnSizes(newColumnSizes || {}, columnFlexes || {}, newReservedViewportWidth, {
	      getColumnBy: computedProps.getColumnBy,
	      onColumnResize: computedProps.initialProps.onColumnResize,
	      onBatchColumnResize: computedProps.initialProps.onBatchColumnResize,
	      columnSizes: computedProps.columnSizes,
	      setColumnSizes: computedProps.setColumnSizes,
	      setColumnFlexes: computedProps.setColumnFlexes
	    });
	  };
	  var checkForAvaibleWidth = function checkForAvaibleWidth() {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var scrollbars = computedProps.scrollbars;
	    var hasVerticalScrollbar = scrollbars.vertical;
	    var scrollbarWidth = hasVerticalScrollbar ? (0, _getScrollbarWidth.default)() : 0;
	    var computedAvailableWidth = computedProps.availableWidth || 0;
	    var availableWidth = computedAvailableWidth - scrollbarWidth;
	    if (availableWidth > 0) {
	      computeColumnSizesToFit(availableWidth);
	    }
	  };
	  var computeColumnSizesAuto = function computeColumnSizesAuto(columns, callback) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (!columns.length) {
	      return;
	    }
	    columns.forEach(function (column) {
	      if (column.resizable === false || checkForSpecialColumns(column.id)) {} else {
	        callback(column);
	      }
	    });
	  };
	  var getCellForColumn = function getCellForColumn(column, row) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var result;
	    var columnId = column.id;
	    var cells = row.getCells();
	    if (!cells.length) {
	      return;
	    }
	    cells.forEach(function (cell) {
	      var cellProps = cell.props;
	      var cellId = cellProps.id;
	      if (columnId === cellId) {
	        result = cell.domRef ? cell.domRef.current : cell.getDOMNode ? cell.getDOMNode() : null;
	      }
	    });
	    return result;
	  };
	  var getCellsForColumn = function getCellsForColumn(column) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var result = [];
	    if (computedProps.getRows) {
	      computedProps.getRows().forEach(function (rowInstance) {
	        var row = rowInstance.row;
	        var cell = getCellForColumn(column, row);
	        result.push(cell);
	      });
	    }
	    return result;
	  };
	  var cloneIntoDummyContainer = function cloneIntoDummyContainer(cell, dummyContainer, skipSortTool) {
	    var cellClone = cell && cell.cloneNode(true);
	    if (!cellClone) {
	      return;
	    }
	    cellClone.style.width = '';
	    cellClone.style.minWidth = '';
	    cellClone.style.maxWidth = '';
	    cellClone.style.position = 'static';
	    cellClone.style.left = '';
	    var rowClassName = 'InovuaReactDataGrid__row';
	    var headerClassName = 'InovuaReactDataGrid__header';
	    var headerCellClassName = 'InovuaReactDataGrid__column-header';
	    var sortToolClassName = 'InovuaReactDataGrid__sort-icon-wrapper';
	    var isHeader = cellClone.classList.contains(headerCellClassName);
	    var cellContent;
	    cellContent = (0, _toConsumableArray2.default)(cellClone.children).find(function (cell) {
	      var className = isHeader ? 'InovuaReactDataGrid__column-header__content' : 'InovuaReactDataGrid__cell__content';
	      return cell.classList.contains(className);
	    });
	    if (isHeader && skipSortTool) {
	      var sortTool = cellContent.querySelector(".".concat(sortToolClassName));
	      if (sortTool) {
	        cellContent = cellContent.removeChild(sortTool);
	      }
	    }
	    if (cellContent) {
	      cellContent.style.width = 'fit-content';
	    } else {
	      cellClone.style.width = 'fit-content';
	    }
	    var cloneRow = document.createElement('div');
	    var cloneRowClassList = cloneRow.classList;
	    if (isHeader) {
	      cloneRowClassList.add(headerClassName);
	      cloneRow.style.position = 'static';
	    } else {
	      cloneRowClassList.add(rowClassName);
	    }
	    var rowElement = cell.parentElement;
	    while (rowElement) {
	      var isRow = [rowClassName, headerClassName].some(function (cls) {
	        return rowElement.classList.contains(cls);
	      });
	      if (isRow) {
	        for (var i = 0; i < rowElement.classList.length; i++) {
	          var item = rowElement.classList[i];
	          cloneRowClassList.add(item);
	        }
	        break;
	      }
	      rowElement = rowElement.parentElement;
	    }
	    cloneRow.appendChild(cellClone);
	    dummyContainer.appendChild(cloneRow);
	  };
	  var computeOptimizedWidth = function computeOptimizedWidth(column, skipHeader, skipSortTool) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return -1;
	    }
	    var cells = getCellsForColumn(column);
	    if (!cells || !cells.length) {
	      return -1;
	    }
	    if (!skipHeader) {
	      var headerCell;
	      var header = computedProps.getHeader();
	      var headerCells = header.getCells();
	      headerCells.find(function (cell) {
	        var cellProps = cell.props;
	        if (cellProps.id === column.id) {
	          headerCell = cell.getDOMNode();
	        }
	      });
	      if (headerCell && headerCell.classList.contains('InovuaReactDataGrid__column-header__resize-wrapper')) {
	        headerCell = (0, _toConsumableArray2.default)(headerCell.children).find(function (cell) {
	          return cell.classList.contains('InovuaReactDataGrid__column-header');
	        });
	      }
	      cells.push(headerCell);
	    }
	    return addCellsToContainer(cells, skipHeader, skipSortTool);
	  };
	  var addCellsToContainer = function addCellsToContainer(cells, skipHeader, skipSortTool) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return -1;
	    }
	    var dummyContainer = document.createElement('span');
	    dummyContainer.style.position = 'fixed';
	    var vl = computedProps.getVirtualList();
	    var container = vl.getContainerNode();
	    container.appendChild(dummyContainer);
	    (0, _toConsumableArray2.default)(cells).map(function (cell) {
	      return cloneIntoDummyContainer(cell, dummyContainer, skipSortTool);
	    });
	    var dummyContainerWidth = dummyContainer.offsetWidth;
	    if (!skipHeader) {
	      dummyContainerWidth += 3;
	    } else {
	      dummyContainerWidth += 1;
	    }
	    container.removeChild(dummyContainer);
	    return dummyContainerWidth;
	  };
	  var normaliseWidth = function normaliseWidth(column, width) {
	    var minWidth = column.minWidth;
	    var maxWidth = column.maxWidth;
	    if (minWidth && width < minWidth) {
	      width = minWidth;
	    }
	    if (maxWidth && width > maxWidth) {
	      width = maxWidth;
	    }
	    return width;
	  };
	  var setColumnSizesToFit = function setColumnSizesToFit() {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var enableColumnAutosize = computedProps.enableColumnAutosize;
	    if (!enableColumnAutosize) {
	      showWarning('setColumnSizesToFit');
	      return;
	    }
	    checkForAvaibleWidth();
	  };
	  var setColumnsSizesAuto = function setColumnsSizesAuto() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT,
	      columnIds = _ref.columnIds,
	      skipHeader = _ref.skipHeader,
	      skipSortTool = _ref.skipSortTool;
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var enableColumnAutosize = computedProps.enableColumnAutosize;
	    if (!enableColumnAutosize) {
	      showWarning('setColumnsSizesAuto');
	      return;
	    }
	    var shouldSkipHeader = skipHeader != null ? skipHeader : computedProps.skipHeaderOnAutoSize;
	    var shouldSkipSortTool = skipSortTool != null ? skipSortTool : false;
	    var allIds = [];
	    var columns = [];
	    if (columnIds !== undefined) {
	      if (Array.isArray(columnIds)) {
	        allIds = columnIds;
	      }
	    }
	    for (var i = 0; i < allIds.length; i++) {
	      var id = allIds[i];
	      var column = computedProps.getColumnBy(id);
	      columns.push(column);
	    }
	    if (columns && columns.length === 0) {
	      columns = computedProps.visibleColumns;
	    }
	    if (!columns || columns.length === 0) {
	      return;
	    }
	    var columnsToSize = [];
	    var counter = -1;
	    var newColumnSizes = {};
	    while (counter !== 0) {
	      counter = 0;
	      computeColumnSizesAuto(columns, function (column) {
	        if (columnsToSize.indexOf(column) >= 0) {
	          return false;
	        }
	        var optimizedWidth = computeOptimizedWidth(column, shouldSkipHeader, shouldSkipSortTool);
	        if (optimizedWidth > 0) {
	          var newWidth = normaliseWidth(column, optimizedWidth);
	          var columnId = column.id;
	          columnsToSize.push(column);
	          Object.assign(newColumnSizes, (0, _defineProperty2.default)({}, columnId, newWidth));
	          counter++;
	        }
	        return true;
	      });
	    }
	    if (computedProps.virtualizeColumns) {
	      var bodyRef = computedProps.bodyRef.current;
	      var columnLayout = bodyRef.columnLayout;
	      var headerLayout = columnLayout.headerLayout;
	      var header = headerLayout.header;
	      setTimeout(function () {
	        header.updateColumns();
	      }, 10);
	    }
	    var newReservedViewportWidth = computedProps.reservedViewportWidth;
	    var columnFlexes = computedProps.columnFlexes;
	    computedProps.computeColumnSizes(newColumnSizes || {}, columnFlexes || {}, newReservedViewportWidth, {
	      getColumnBy: computedProps.getColumnBy,
	      onColumnResize: computedProps.initialProps.onColumnResize,
	      onBatchColumnResize: computedProps.initialProps.onBatchColumnResize,
	      columnSizes: computedProps.columnSizes,
	      setColumnSizes: computedProps.setColumnSizes,
	      setColumnFlexes: computedProps.setColumnFlexes
	    });
	  };
	  var setColumnSizeAuto = function setColumnSizeAuto(id, skipHeader) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var enableColumnAutosize = computedProps.enableColumnAutosize;
	    if (!enableColumnAutosize) {
	      showWarning('setColumnSizeAuto');
	      return;
	    }
	    if (id) {
	      setColumnsSizesAuto({
	        columnIds: [id],
	        skipHeader: skipHeader
	      });
	    }
	    return;
	  };
	  var showWarning = function showWarning(method) {
	    return console.error("In order for ".concat(method, " to work, the 'enableColumnAutosize' prop should be 'true'."));
	  };
	  return {
	    setColumnSizesToFit: setColumnSizesToFit,
	    setColumnsSizesAuto: setColumnsSizesAuto,
	    setColumnSizeAuto: setColumnSizeAuto
	  };
	};
	var _default = useColumnsSizing;
	exports.default = _default;

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(44));
	var _filter = _interopRequireDefault(__webpack_require__(219));
	var _treeFilter = _interopRequireDefault(__webpack_require__(792));
	var _paginate = _interopRequireDefault(__webpack_require__(799));
	var _getFilterValueForColumns = _interopRequireDefault(__webpack_require__(220));
	var _getSortInfoForColumns = _interopRequireDefault(__webpack_require__(598));
	var _excluded = ["originalData"];
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var filterData = function filterData(data, _ref, config) {
	  var filterValue = _ref.filterValue,
	    remoteFilter = _ref.remoteFilter,
	    filterTypes = _ref.filterTypes,
	    columnsMap = _ref.columnsMap;
	  if (!Array.isArray(filterValue) || !filterValue.length) {
	    return data;
	  }
	  if (remoteFilter) {
	    return data;
	  }
	  var filterValueForColumns = (0, _getFilterValueForColumns.default)(filterValue, columnsMap);
	  if (!filterValueForColumns.length) {
	    return data;
	  }
	  if (config.treeEnabled) {
	    return (0, _treeFilter.default)(data, filterValueForColumns, filterTypes, columnsMap, {
	      props: config.computedProps
	    });
	  }
	  return (0, _filter.default)(data, filterValueForColumns, filterTypes, columnsMap);
	};
	var flow = function flow(_ref2) {
	  var originalData = _ref2.originalData,
	    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
	  var input = _objectSpread(_objectSpread({}, rest), {}, {
	    data: originalData,
	    originalData: originalData,
	    previousData: []
	  });
	  for (var _len = arguments.length, transforms = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    transforms[_key - 1] = arguments[_key];
	  }
	  return transforms.reduce(function (acc, transform) {
	    acc = transform(acc);
	    acc.previousData.push(acc.data);
	    return acc;
	  }, input);
	};
	var computeData = function computeData(config, computedProps, batchUpdateQueue) {
	  var columnsMap = computedProps.columnsMap;
	  var originalData = config.originalData || computedProps.originalData;
	  var dataCountAfterFilter = undefined;
	  var loading = config.loading === undefined ? computedProps.computedLoading : config.loading;
	  var filterValue = config.filterValue === undefined ? computedProps.computedFilterValue : config.filterValue;
	  var remoteFilter = config.remoteFilter === undefined ? computedProps.computedRemoteFilter : config.remoteFilter;
	  var dataSourceCache = config.dataSourceCache === undefined ? computedProps.computedDataSourceCache : config.dataSourceCache;
	  var filterTypes = computedProps.filterTypes;
	  var localPagination = config.localPagination === undefined ? computedProps.computedLocalPagination : config.localPagination;
	  var remoteData = config.remoteData === undefined ? computedProps.computedRemoteData : config.remoteData;
	  var sortInfo = config.sortInfo === undefined ? computedProps.computedSortInfo : config.sortInfo;
	  var skip = config.skip === undefined ? computedProps.computedSkip : config.skip;
	  var limit = config.limit === undefined ? computedProps.computedLimit : config.limit;
	  var groupBy = config.groupBy === undefined ? computedProps.computedGroupBy : config.groupBy;
	  var treeEnabled = computedProps.computedTreeEnabled;
	  var pivot = computedProps.pivot;
	  var computedSummary = !!computedProps.summaryReducer;
	  if (remoteData) {
	    return {
	      data: undefined,
	      dataCountAfterFilter: dataCountAfterFilter
	    };
	  }
	  var result = flow({
	    originalData: originalData
	  }, function (config) {
	    if (dataSourceCache && Object.keys(dataSourceCache).length) {
	      config.data = config.data.map(function (item) {
	        var id = computedProps.getItemId(item);
	        if (dataSourceCache[id]) {
	          item = _objectSpread(_objectSpread({}, item), dataSourceCache[id]);
	        }
	        return item;
	      });
	    }
	    return config;
	  }, function (config) {
	    if (filterValue && !computedProps.filterValue) {
	      filterValue = (0, _getFilterValueForColumns.default)(filterValue, columnsMap);
	      config.data = filterData(config.data, {
	        filterValue: filterValue,
	        filterTypes: filterTypes,
	        remoteFilter: remoteFilter,
	        columnsMap: columnsMap
	      }, {
	        treeEnabled: treeEnabled,
	        computedProps: computedProps
	      });
	    }
	    dataCountAfterFilter = config.data.length;
	    return config;
	  }, function (config) {
	    if (!computedProps.sortInfo) {
	      sortInfo = (0, _getSortInfoForColumns.default)(sortInfo, columnsMap);
	      if (sortInfo && computedProps.sorty) {
	        config.data = (0, _toConsumableArray2.default)(config.data);
	        computedProps.sorty(sortInfo, config.data);
	      }
	    }
	    return config;
	  }, function (config) {
	    if (treeEnabled && computedProps.computeTreeData) {
	      var expandedNodes = computedProps.computedExpandedNodes;
	      config.data = computedProps.computeTreeData(config.data, {
	        expandedNodes: expandedNodes,
	        isNodeLeaf: computedProps.isNodeLeaf,
	        isNodeAsync: computedProps.isNodeAsync,
	        pathSeparator: computedProps.nodePathSeparator,
	        loadingNodes: computedProps.computedLoadingNodes,
	        nodesName: computedProps.nodesProperty,
	        nodeCache: computedProps.computedNodeCache,
	        dataSourceCache: computedProps.computedDataSourceCache,
	        generateIdFromPath: computedProps.generateIdFromPath,
	        collapsingNodes: computedProps.collapsingNodesRef.current,
	        idProperty: !computedProps.compoundIdProperty ? computedProps.idProperty : 'id'
	      });
	    }
	    dataCountAfterFilter = config.data.length;
	    return config;
	  }, function (config) {
	    if (computedSummary) {
	      var summary = computedProps.summaryReducer.initialValue;
	      var reducerFn = computedProps.summaryReducer.reducer || computedProps.summaryReducer.reduce;
	      if (summary && (0, _typeof2.default)(summary) === 'object') {
	        summary = _objectSpread({}, summary);
	      }
	      var data = config.data;
	      var item;
	      for (var i = 0, len = data.length; i < len; i++) {
	        item = data[i];
	        summary = reducerFn(summary, item, computedProps);
	      }
	      if (computedProps.summaryReducer.complete) {
	        summary = computedProps.summaryReducer.complete(summary, data || [], computedProps);
	      }
	      batchUpdateQueue(function () {
	        computedProps.setSummary(summary);
	      });
	    }
	    return config;
	  }, function (config) {
	    if (localPagination && limit) {
	      skip = skip || 0;
	      config.data = (0, _paginate.default)(config.data, {
	        skip: skip,
	        limit: limit
	      });
	    }
	    return config;
	  }, function (config) {
	    batchUpdateQueue(function () {
	      computedProps.setUngroupedData(config.data);
	    });
	    var length = config.data.length;
	    if (Array.isArray(groupBy) && groupBy.length && computedProps.computeDataStep && length) {
	      config = computedProps.computeDataStep({
	        groupBy: groupBy,
	        batchUpdateQueue: batchUpdateQueue,
	        columnsMap: columnsMap,
	        computedProps: computedProps,
	        config: config
	      });
	    }
	    return config;
	  });
	  return {
	    data: result.data,
	    dataCountAfterFilter: dataCountAfterFilter || 0
	  };
	};
	var _default = computeData;
	exports.default = _default;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var getCol = function getCol(name, columnsMap) {
	  var col = columnsMap[name];
	  if (!col) {
	    Object.keys(columnsMap).forEach(function (colId) {
	      if (col) {
	        return;
	      }
	      var theCol = columnsMap[colId];
	      if (theCol.sortName === name) {
	        col = theCol;
	      }
	    });
	  }
	  return col;
	};
	var getSortInfoForColumns = function getSortInfoForColumns(sortInfo, columnsMap) {
	  if (!columnsMap) {
	    return sortInfo;
	  }
	  if (!Array.isArray(sortInfo)) {
	    if (sortInfo && sortInfo.name) {
	      var col = getCol(sortInfo.name, columnsMap);
	      sortInfo = _objectSpread({}, sortInfo);
	      if (col) {
	        if (typeof col.sortName === 'string') {
	          sortInfo.name = col.sortName;
	        }
	        if (col.type) {
	          sortInfo.type = col.type;
	        }
	        if (col.sort) {
	          sortInfo.fn = function (one, two, data1, data2, sortInfo) {
	            return col.sort ? col.sort(one, two, col, data1, data2, sortInfo) : 0;
	          };
	        }
	      }
	    }
	    return sortInfo;
	  } else {
	    return sortInfo.map(function (sortInfo) {
	      var col = getCol(sortInfo.name, columnsMap);
	      sortInfo = _objectSpread({}, sortInfo);
	      if (col && typeof col.sortName === 'string') {
	        sortInfo.name = col.sortName;
	      }
	      if (col.type) {
	        sortInfo.type = col.type;
	      }
	      if (col.sort) {
	        sortInfo.fn = function (one, two, data1, data2, sortInfo) {
	          return col.sort ? col.sort(one, two, col, data1, data2, sortInfo) : 0;
	        };
	      }
	      return sortInfo;
	    });
	  }
	};
	var _default = getSortInfoForColumns;
	exports.default = _default;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isLivePagination = exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = __webpack_require__(2);
	var _clamp = _interopRequireDefault(__webpack_require__(65));
	var _getIndexBy = _interopRequireDefault(__webpack_require__(795));
	var _fastDeepEqual = _interopRequireDefault(__webpack_require__(1040));
	var _useLoadDataEffect = _interopRequireDefault(__webpack_require__(603));
	var _useProperty7 = _interopRequireDefault(__webpack_require__(48));
	var _useNamedState9 = _interopRequireDefault(__webpack_require__(105));
	var _computeData = _interopRequireDefault(__webpack_require__(597));
	var _batchUpdate = _interopRequireDefault(__webpack_require__(50));
	var _usePrevious = _interopRequireDefault(__webpack_require__(61));
	var _isControlledProperty = _interopRequireDefault(__webpack_require__(115));
	var _getGlobal = __webpack_require__(18);
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var globalObject = (0, _getGlobal.getGlobal)();
	var raf = globalObject.requestAnimationFrame;
	var isRemoteData = function isRemoteData(props) {
	  if (props.dataSource == null) {
	    return false;
	  }
	  return typeof props.dataSource.then === 'function' || typeof props.dataSource === 'function';
	};
	var isRemoteSort = function isRemoteSort(props) {
	  var remoteSort = props.remoteSort;
	  return remoteSort === true || remoteSort === undefined && isRemoteData(props);
	};
	var isRemoteFilter = function isRemoteFilter(props) {
	  var remoteFilter = props.remoteFilter;
	  return remoteFilter === true || remoteFilter === undefined && isRemoteData(props);
	};
	var isPagination = function isPagination(props) {
	  return !!props.pagination;
	};
	var isLocalPagination = function isLocalPagination(props) {
	  return isPagination(props) && !isRemotePagination(props);
	};
	var isLivePagination = function isLivePagination(props) {
	  return !!props.livePagination && isRemotePagination(props);
	};
	exports.isLivePagination = isLivePagination;
	var isRemotePagination = function isRemotePagination(props) {
	  var remotePagination = props.remotePagination,
	    pagination = props.pagination,
	    livePagination = props.livePagination;
	  if (pagination === false || pagination === 'local') {
	    return false;
	  }
	  if (pagination === 'remote' || isRemoteData(props)) {
	    return true;
	  }
	  if (remotePagination !== undefined) {
	    return remotePagination;
	  }
	  return !!livePagination;
	};
	var loadDataSource = function loadDataSource(dataSource, _ref) {
	  var skip = _ref.skip,
	    limit = _ref.limit,
	    currentData = _ref.currentData,
	    sortInfo = _ref.sortInfo,
	    filterValue = _ref.filterValue,
	    groupBy = _ref.groupBy;
	  if (typeof dataSource === 'function') {
	    dataSource = loadDataSource(dataSource({
	      skip: skip,
	      limit: limit,
	      sortInfo: sortInfo,
	      currentData: currentData,
	      filterValue: filterValue,
	      groupBy: groupBy
	    }), {
	      skip: skip,
	      limit: limit,
	      sortInfo: sortInfo,
	      groupBy: groupBy,
	      filterValue: filterValue,
	      currentData: currentData
	    });
	  }
	  if (dataSource instanceof Promise) {
	    return dataSource.then(function (result) {
	      if (Array.isArray(result)) {
	        return {
	          data: result,
	          count: result.length
	        };
	      }
	      return {
	        data: result.data,
	        count: result.count
	      };
	    });
	  }
	  return Promise.resolve({
	    data: dataSource,
	    count: dataSource.length
	  });
	};
	var useData = function useData(_ref2, context) {
	  var dataSource = _ref2.dataSource,
	    skip = _ref2.skip,
	    limit = _ref2.limit,
	    localPagination = _ref2.localPagination;
	  var data;
	  var silentSetData;
	  var _useNamedState = (0, _useNamedState9.default)([], context, 'data');
	  var _useNamedState2 = (0, _slicedToArray2.default)(_useNamedState, 2);
	  data = _useNamedState2[0];
	  silentSetData = _useNamedState2[1];
	  var _useState = (0, _react.useState)(null),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    dataMap = _useState2[0],
	    setDataMap = _useState2[1];
	  var _useState3 = (0, _react.useState)(null),
	    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
	    dataIndexMap = _useState4[0],
	    setDataIndexMap = _useState4[1];
	  var originalData;
	  var setOriginalData;
	  var _useNamedState3 = (0, _useNamedState9.default)(Array.isArray(dataSource) ? dataSource : [], context, 'originalData');
	  var _useNamedState4 = (0, _slicedToArray2.default)(_useNamedState3, 2);
	  originalData = _useNamedState4[0];
	  setOriginalData = _useNamedState4[1];
	  var _useNamedState5 = (0, _useNamedState9.default)(data.length, context, 'count'),
	    _useNamedState6 = (0, _slicedToArray2.default)(_useNamedState5, 2),
	    count = _useNamedState6[0],
	    setCount = _useNamedState6[1];
	  var _useNamedState7 = (0, _useNamedState9.default)(0, context, 'dataCountAfterFilter'),
	    _useNamedState8 = (0, _slicedToArray2.default)(_useNamedState7, 2),
	    dataCountAfterFilter = _useNamedState8[0],
	    setDataCountAfterFilter = _useNamedState8[1];
	  return {
	    setDataMap: setDataMap,
	    dataMap: dataMap,
	    dataIndexMap: dataIndexMap,
	    setDataIndexMap: setDataIndexMap,
	    originalData: originalData,
	    setOriginalData: setOriginalData,
	    data: data,
	    count: count,
	    dataCountAfterFilter: dataCountAfterFilter,
	    silentSetData: silentSetData,
	    setDataCountAfterFilter: setDataCountAfterFilter,
	    setCount: setCount
	  };
	};
	var getDataCountForPagination = function getDataCountForPagination(props) {
	  var paginationCount = props.remotePagination ? props.count : props.dataCountAfterFilter != null ? props.dataCountAfterFilter : props.originalData.length;
	  return paginationCount;
	};
	var getCurrentPage = function getCurrentPage(props) {
	  return Math.floor(props.skip / props.limit) + 1;
	};
	var getPageCount = function getPageCount(_ref3) {
	  var count = _ref3.count,
	    limit = _ref3.limit;
	  return Math.ceil(count / limit);
	};
	var getSkipForPage = function getSkipForPage(_ref4) {
	  var page = _ref4.page,
	    limit = _ref4.limit;
	  return Math.max(0, limit * (page - 1));
	};
	var hasNextPage = function hasNextPage(_ref5) {
	  var skip = _ref5.skip,
	    limit = _ref5.limit,
	    count = _ref5.count;
	  return getCurrentPage({
	    skip: skip,
	    limit: limit
	  }) < getPageCount({
	    count: count,
	    limit: limit
	  });
	};
	var hasPrevPage = function hasPrevPage(_ref6) {
	  var skip = _ref6.skip,
	    limit = _ref6.limit,
	    count = _ref6.count;
	  var currentPage = getCurrentPage({
	    skip: skip,
	    limit: limit
	  });
	  return currentPage > 1 && currentPage - 1 < getPageCount({
	    count: count,
	    limit: limit
	  });
	};
	var usePagination = function usePagination(_ref7, computedPropsRef) {
	  var append = _ref7.append,
	    reload = _ref7.reload,
	    setAppend = _ref7.setAppend,
	    skip = _ref7.skip,
	    limit = _ref7.limit,
	    count = _ref7.count,
	    silentSetSkip = _ref7.setSkip,
	    silentSetLimit = _ref7.setLimit,
	    remotePagination = _ref7.remotePagination,
	    localPagination = _ref7.localPagination,
	    pagination = _ref7.pagination,
	    lastSkipRef = _ref7.lastSkipRef,
	    lastLimitRef = _ref7.lastLimitRef,
	    dataCountAfterFilter = _ref7.dataCountAfterFilter,
	    livePagination = _ref7.livePagination,
	    originalData = _ref7.originalData,
	    data = _ref7.data;
	  var paginationCount = getDataCountForPagination({
	    originalData: originalData,
	    remotePagination: remotePagination,
	    count: count,
	    dataCountAfterFilter: dataCountAfterFilter
	  });
	  var setLimitOrSkip = function setLimitOrSkip(computedProps, config, queue) {
	    return (0, _computeData.default)(_objectSpread(_objectSpread({
	      skip: skip,
	      limit: limit
	    }, config), {}, {
	      localPagination: localPagination
	    }), computedProps, queue);
	  };
	  var setSkip = function setSkip(skip, config) {
	    var computedProps = computedPropsRef.current;
	    var queue = (0, _batchUpdate.default)();
	    var computedRemoteData = computedProps.computedRemoteData;
	    queue.commit(function () {
	      if (config && config.append !== undefined) {
	        setAppend(config.append);
	      }
	      if (computedRemoteData) {
	        computedProps.setLoadDataTrigger(function (loadDataTrigger) {
	          return [].concat((0, _toConsumableArray2.default)(loadDataTrigger), ['skip']);
	        });
	      }
	      silentSetSkip(skip);
	    });
	  };
	  var setLimit = function setLimit(limit) {
	    var computedProps = computedPropsRef.current;
	    var queue = (0, _batchUpdate.default)();
	    var computedRemoteData = computedProps.computedRemoteData;
	    queue.commit(function () {
	      if (computedRemoteData) {
	        computedProps.setLoadDataTrigger(function (loadDataTrigger) {
	          return [].concat((0, _toConsumableArray2.default)(loadDataTrigger), ['limit']);
	        });
	      }
	      silentSetLimit(limit);
	    });
	  };
	  var incrementSkip = function incrementSkip(amount, config) {
	    setSkip(skip + amount, config);
	  };
	  var gotoNextPage = function gotoNextPage(config) {
	    if (hasNextPage({
	      skip: skip,
	      limit: lastLimitRef.current,
	      count: paginationCount
	    })) {
	      incrementSkip(lastLimitRef.current, config);
	    }
	  };
	  var gotoPrevPage = function gotoPrevPage() {
	    if (hasPrevPage({
	      skip: skip,
	      limit: limit,
	      count: paginationCount
	    })) {
	      incrementSkip(-limit);
	    }
	  };
	  var gotoPage = function gotoPage(page, config) {
	    page = (0, _clamp.default)(page, 1, getPageCount({
	      count: paginationCount,
	      limit: limit
	    }));
	    var force = config ? config.force : false;
	    if (page === getCurrentPage({
	      skip: skip,
	      limit: limit
	    }) && !force) {
	      return;
	    }
	    setSkip(getSkipForPage({
	      page: page,
	      limit: limit
	    }));
	  };
	  var hasNext = function hasNext() {
	    return hasNextPage({
	      skip: skip,
	      limit: limit,
	      count: paginationCount
	    });
	  };
	  var hasPrev = function hasPrev() {
	    return hasPrevPage({
	      skip: skip,
	      limit: limit,
	      count: paginationCount
	    });
	  };
	  var gotoFirstPage = function gotoFirstPage() {
	    return gotoPage(1);
	  };
	  var gotoLastPage = function gotoLastPage() {
	    return gotoPage(getPageCount({
	      count: paginationCount,
	      limit: limit
	    }));
	  };
	  var paginationProps;
	  if ((localPagination || remotePagination) && !livePagination) {
	    paginationProps = {
	      onSkipChange: setSkip,
	      onLimitChange: setLimit,
	      reload: reload,
	      onRefresh: reload,
	      totalCount: paginationCount,
	      count: count,
	      skip: skip,
	      limit: limit,
	      remotePagination: remotePagination,
	      localPagination: localPagination,
	      livePagination: livePagination,
	      pagination: pagination,
	      gotoPage: gotoPage,
	      gotoNextPage: gotoNextPage,
	      gotoFirstPage: gotoFirstPage,
	      gotoLastPage: gotoLastPage,
	      gotoPrevPage: gotoPrevPage,
	      hasNextPage: hasNext,
	      hasPrevPage: hasPrev
	    };
	  }
	  return {
	    count: count,
	    paginationCount: paginationCount,
	    reload: reload,
	    setSkip: setSkip,
	    setLimit: setLimit,
	    gotoNextPage: gotoNextPage,
	    gotoPrevPage: gotoPrevPage,
	    hasNextPage: hasNext,
	    hasPrevPage: hasPrev,
	    gotoFirstPage: gotoFirstPage,
	    gotoLastPage: gotoLastPage,
	    gotoPage: gotoPage,
	    paginationProps: paginationProps
	  };
	};
	var useDataSourceCache = function useDataSourceCache(props, computedProps, computedPropsRef) {
	  var prevDataSource = (0, _usePrevious.default)(props.dataSource, props.dataSource);
	  var _useProperty = (0, _useProperty7.default)(props, 'dataSourceCache', undefined, {
	      onChange: function onChange(dataSourceCache, info) {
	        var computedProps = computedPropsRef.current;
	        if (!computedProps) {
	          return;
	        }
	        if (computedProps.initialProps.onDataSourceCacheChange) {
	          computedProps.initialProps.onDataSourceCacheChange(dataSourceCache, info);
	        }
	      }
	    }),
	    _useProperty2 = (0, _slicedToArray2.default)(_useProperty, 2),
	    dataSourceCache = _useProperty2[0],
	    setDataSourceCache = _useProperty2[1];
	  if (props.clearDataSourceCacheOnChange && prevDataSource !== props.dataSource) {
	    dataSourceCache = undefined;
	  }
	  (0, _react.useLayoutEffect)(function () {
	    if (props.clearDataSourceCacheOnChange) {
	      setDataSourceCache(undefined);
	    }
	  }, [props.dataSource]);
	  return [dataSourceCache, setDataSourceCache];
	};
	var _default = function _default(props, computedProps, computedPropsRef) {
	  var computedRemoteData = isRemoteData(props);
	  var computedRemoteFilter = isRemoteFilter(props);
	  var computedRemoteSort = isRemoteSort(props);
	  var computedLivePagination = isLivePagination(props);
	  var computedRemotePagination = isRemotePagination(props);
	  var computedLocalPagination = isLocalPagination(props);
	  var computedPagination = computedRemotePagination || computedLocalPagination;
	  var _useState5 = (0, _react.useState)([]),
	    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
	    ungroupedData = _useState6[0],
	    setUngroupedData = _useState6[1];
	  var _useState7 = (0, _react.useState)([]),
	    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
	    loadDataTrigger = _useState8[0],
	    setLoadDataTrigger = _useState8[1];
	  var _useState9 = (0, _react.useState)(false),
	    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
	    append = _useState10[0],
	    setAppend = _useState10[1];
	  var _useProperty3 = (0, _useProperty7.default)(props, 'skip', 0),
	    _useProperty4 = (0, _slicedToArray2.default)(_useProperty3, 2),
	    computedSkip = _useProperty4[0],
	    setSkip = _useProperty4[1];
	  var _useProperty5 = (0, _useProperty7.default)(props, 'limit', 50),
	    _useProperty6 = (0, _slicedToArray2.default)(_useProperty5, 2),
	    computedLimit = _useProperty6[0],
	    setLimit = _useProperty6[1];
	  var _useDataSourceCache = useDataSourceCache(props, computedProps, computedPropsRef),
	    _useDataSourceCache2 = (0, _slicedToArray2.default)(_useDataSourceCache, 2),
	    computedDataSourceCache = _useDataSourceCache2[0],
	    setDataSourceCache = _useDataSourceCache2[1];
	  var _useState11 = (0, _react.useState)(props.summaryReducer ? props.summaryReducer.initialValue : null),
	    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
	    summary = _useState12[0],
	    setSummary = _useState12[1];
	  var setItemOnReorderingGroups = function setItemOnReorderingGroups(index, item, config) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    computedProps.setItemAt(index, item, config);
	    computedProps.reload();
	  };
	  var setItemAt = function setItemAt(index, item, config) {
	    var replace = config && config.replace;
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var newItem = computedProps.getItemAt(index);
	    var oldId = computedProps.getItemId(newItem);
	    if (!newItem) {
	      return;
	    }
	    if (replace) {
	      newItem = item;
	    } else {
	      if (config && config.property) {
	        newItem = _objectSpread(_objectSpread({}, newItem), {}, (0, _defineProperty2.default)({}, config.property, config.value));
	      } else {
	        if (config && config.deepCloning && computedProps.compoundIdProperty) {
	          var parts = computedProps.idProperty.split(computedProps.idPropertySeparator);
	          for (var i = 0; i < parts.length; i++) {
	            var part = parts[i];
	            if (newItem[part]) {
	              Object.assign(newItem[part], _objectSpread({}, item[part]));
	            }
	          }
	        } else {
	          newItem = _objectSpread(_objectSpread({}, newItem), item);
	        }
	      }
	    }
	    var newId = computedProps.getItemId(newItem);
	    if (newId !== oldId) {
	      if (computedProps.showWarnings) {
	        console.error("Cannot replace the item with another one that has a different value for the idProperty!");
	      }
	      return;
	    }
	    setDataSourceCache(_objectSpread(_objectSpread({}, computedProps.computedDataSourceCache), {}, (0, _defineProperty2.default)({}, newId, newItem)));
	  };
	  var setItemsAt = function setItemsAt(items, config) {
	    var replace = config && config.replace;
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var newIds = {};
	    for (var i = 0; i < items.length; i++) {
	      var item = items[i];
	      var oldId = computedProps.getItemId(item);
	      var index = computedProps.getItemIndex(item);
	      var newItem = computedProps.getItemAt(index);
	      if (!newItem) {
	        continue;
	      }
	      if (replace) {
	        newItem = item;
	      } else {
	        newItem = _objectSpread(_objectSpread({}, newItem), item);
	      }
	      var newId = computedProps.getItemId(newItem);
	      if (newId !== oldId) {
	        continue;
	      }
	      newIds[newId] = newItem;
	    }
	    if (!items.length) {
	      return;
	    }
	    setDataSourceCache(_objectSpread(_objectSpread({}, computedProps.computedDataSourceCache), newIds));
	  };
	  var setItemPropertyAt = function setItemPropertyAt(index, property, value) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (property === computedProps.idProperty) {
	      if (computedProps.showWarnings) {
	        console.error("Cannot update the value of the \"idProperty\" property!");
	      }
	    }
	    var item = computedProps.getItemAt(index);
	    if (item) {
	      item = _objectSpread({}, item);
	      item[property] = value;
	      setItemAt(index, item, {
	        property: property,
	        value: value
	      });
	    }
	  };
	  var setItemPropertyForId = function setItemPropertyForId(id, property, value) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var index = computedProps.getRowIndexById(id);
	    setItemPropertyAt(index, property, value);
	  };
	  var _useData = useData({
	      dataSource: props.dataSource,
	      skip: computedSkip,
	      limit: computedLimit,
	      localPagination: computedLocalPagination
	    }, props.context),
	    data = _useData.data,
	    dataMap = _useData.dataMap,
	    dataIndexMap = _useData.dataIndexMap,
	    setDataIndexMap = _useData.setDataIndexMap,
	    setDataMap = _useData.setDataMap,
	    count = _useData.count,
	    silentSetData = _useData.silentSetData,
	    setCount = _useData.setCount,
	    originalData = _useData.originalData,
	    setOriginalData = _useData.setOriginalData,
	    dataCountAfterFilter = _useData.dataCountAfterFilter,
	    setDataCountAfterFilter = _useData.setDataCountAfterFilter;
	  var _useState13 = (0, _react.useState)(Date.now),
	    _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
	    reloadTimestamp = _useState14[0],
	    setReloadTimestamp = _useState14[1];
	  var reload = function reload() {
	    setReloadTimestamp(Date.now());
	  };
	  var getFilteredRows = (0, _react.useCallback)(function (dataCount) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var filteredRowsCount = computedProps.filteredRowsCount;
	    if (dataCount === undefined) {
	      return;
	    }
	    if (filteredRowsCount) {
	      filteredRowsCount(dataCount);
	    }
	  }, [dataCountAfterFilter]);
	  if (computedProps.filteredRowsCount) {
	    getFilteredRows(dataCountAfterFilter);
	  }
	  var lastSkipRef = (0, _react.useRef)(computedSkip);
	  var lastFilterValueRef = (0, _react.useRef)(computedProps.computedFilterValue);
	  var lastLimitRef = (0, _react.useRef)(computedLimit);
	  var lastGroupBy = (0, _usePrevious.default)(computedProps.computedGroupBy, computedProps.computedGroupBy);
	  var lastDataSource = (0, _usePrevious.default)(props.dataSource, props.dataSource);
	  var dataPromiseRef = (0, _react.useRef)(null);
	  dataPromiseRef.current = (0, _useLoadDataEffect.default)({
	    getDataSource: function getDataSource(_ref8) {
	      var shouldReload = _ref8.shouldReload;
	      var computedProps = computedPropsRef.current;
	      return shouldReload ? computedProps.dataSource : computedProps.originalData;
	    }
	  }, function (dataToLoad, _ref9) {
	    var shouldReload = _ref9.shouldReload,
	      intercept = _ref9.intercept;
	    var _computedPropsRef$cur = computedPropsRef.current,
	      computedSortInfo = _computedPropsRef$cur.computedSortInfo,
	      computedRemoteData = _computedPropsRef$cur.computedRemoteData,
	      computedFilterValue = _computedPropsRef$cur.computedFilterValue,
	      computedGroupBy = _computedPropsRef$cur.computedGroupBy,
	      prevOriginalData = _computedPropsRef$cur.originalData,
	      skipLoadOnMount = _computedPropsRef$cur.skipLoadOnMount,
	      wasMountedRef = _computedPropsRef$cur.wasMountedRef,
	      initialState = _computedPropsRef$cur.initialState;
	    if (!prevOriginalData.length && computedRemoteData) {
	      computedPropsRef.current.setLoading(true);
	    }
	    var initialCount;
	    if (skipLoadOnMount && !wasMountedRef.current && initialState && initialState.data) {
	      dataToLoad = initialState.data;
	      initialCount = initialState.count;
	    }
	    if (computedRemoteData && !Array.isArray(dataToLoad)) {
	      computedPropsRef.current.setLoading(true);
	    }
	    var skipControlled = (0, _isControlledProperty.default)(computedProps.initialProps, 'skip');
	    var shouldResetSkip = shouldReload && typeof props.dataSource === 'function' && props.dataSource !== lastDataSource && !skipControlled && computedPropsRef.current.computedSkip !== 0;
	    if (!shouldResetSkip) {
	      if (shouldReload && typeof props.dataSource === 'function' && computedPropsRef.current.computedSkip !== 0 && computedPropsRef.current.computedFilterable && (!(0, _fastDeepEqual.default)(computedPropsRef.current.computedFilterValue, lastFilterValueRef.current) || computedPropsRef.current.computedGroupBy !== lastGroupBy)) {
	        shouldResetSkip = true;
	      }
	    }
	    if (shouldResetSkip) {
	      setSkip(0);
	      return Promise.resolve(true);
	    }
	    return intercept(loadDataSource(dataToLoad, {
	      sortInfo: computedSortInfo,
	      currentData: computedPropsRef.current.data,
	      skip: computedSkip,
	      limit: computedLimit,
	      filterValue: computedFilterValue,
	      groupBy: computedGroupBy
	    }), dataToLoad).then(function (_ref10) {
	      var originalData = _ref10.data,
	        count = _ref10.count;
	      if (initialCount) {
	        count = initialCount;
	      }
	      var computedProps = computedPropsRef.current;
	      var queue = (0, _batchUpdate.default)();
	      var data = originalData;
	      var shouldAppend = computedLivePagination && !shouldReload ? computedSkip > lastSkipRef.current : append;
	      if (shouldAppend) {
	        originalData = prevOriginalData.concat(originalData);
	        data = originalData;
	      }
	      var computeDataResult = (0, _computeData.default)({
	        remoteData: false,
	        originalData: originalData
	      }, computedProps, queue);
	      data = computeDataResult.data || originalData;
	      var dataCountAfterFilter = computeDataResult.dataCountAfterFilter;
	      var prevComputedSkip = lastSkipRef.current;
	      lastSkipRef.current = computedSkip;
	      lastFilterValueRef.current = computedFilterValue;
	      lastLimitRef.current = computedLimit;
	      var shouldIndexData = computedProps.computedRowSelectionEnabled || computedProps.computedRowExpandEnabled || computedProps.treeColumn || computedProps.treeEnabled || computedProps.rowIndexColumn || computedProps.computedRowHeights || computedProps.computedGroupBy && props.stickyGroupRows;
	      var dataIndexMap = shouldIndexData && Array.isArray(data) ? {} : null;
	      var stickyGroupsIndexes = props.stickyGroupRows === true || props.stickyTreeNodes === true ? {} : null;
	      var dataMap = shouldIndexData && Array.isArray(data) ? data.reduce(function (acc, item, index) {
	        var id = computedProps.getItemId(item);
	        if (stickyGroupsIndexes) {
	          if (item.__group) {
	            stickyGroupsIndexes[index] = item.depth;
	          }
	          if (item.__nodeProps && !item.__nodeProps.leafNode) {
	            stickyGroupsIndexes[index] = item.__nodeProps.depth + 1;
	          }
	        }
	        acc[id] = item;
	        dataIndexMap[id] = index;
	        return acc;
	      }, {}) : null;
	      return queue.commit(function () {
	        var computedProps = computedPropsRef.current;
	        setOriginalData(originalData);
	        if (computedProps.scrollTopOnSort === true && computedProps.loadDataTrigger.find(function (s) {
	          return s == 'sortInfo';
	        }) || computedProps.scrollTopOnSort === 'always') {
	          raf(function () {
	            computedProps.setScrollTop(0);
	          });
	        }
	        if (computedSkip === 0 && prevComputedSkip > 0) {
	          raf(function () {
	            computedProps.setScrollTop(0);
	          });
	        }
	        if (computedProps.scrollTopOnFilter && computedProps.loadDataTrigger.find(function (s) {
	          return s == 'filterValue';
	        })) {
	          raf(function () {
	            computedProps.setScrollTop(0);
	          });
	        }
	        setLoadDataTrigger([]);
	        if (append) {
	          setAppend(false);
	        }
	        computedProps.setDataMap(dataMap);
	        computedProps.setDataIndexMap(dataIndexMap);
	        if (stickyGroupsIndexes && computedProps.setStickyGroupsIndexes) {
	          computedProps.setStickyGroupsIndexes(stickyGroupsIndexes);
	        }
	        setDataCountAfterFilter(dataCountAfterFilter);
	        if (dataCountAfterFilter != null && computedSkip >= dataCountAfterFilter && !computedRemoteData) {
	          setSkip(0);
	        }
	        silentSetData(data || []);
	        computedProps.setLoading(false);
	        if (shouldReload) {
	          setCount(count);
	        }
	      });
	    }, function (_err) {});
	  }, {
	    reloadDeps: [props.dataSource, computedRemoteData ? computedSkip : null, computedRemoteData && !computedLivePagination ? computedLimit : null, reloadTimestamp, props.pagination, props.remotePagination, props.pivot, props.livePagination, computedRemoteData || props.groupBy ? computedProps.computedGroupBy : null, computedRemoteData ? JSON.stringify(computedProps.computedSortInfo) : null, computedRemoteData ? JSON.stringify(computedProps.computedFilterValue) : null, computedRemoteFilter ? JSON.stringify(computedProps.computedFilterValue) : null, JSON.stringify(computedProps.computedCollapsedGroups || ''), JSON.stringify(computedProps.computedExpandedGroups || '')],
	    noReloadDeps: [originalData, computedProps.computedGroupBy, computedProps.groupColumn, computedProps.renderRowDetails, computedProps.treeColumn, computedProps.showGroupSummaryRow, !computedRemoteData ? computedSkip : null, !computedRemoteData ? computedLimit : null, !computedRemoteData ? JSON.stringify(computedProps.computedSortInfo) : null, !computedRemoteFilter ? JSON.stringify(computedProps.computedFilterValue) : null, computedProps.computedExpandedNodes ? JSON.stringify(computedProps.computedExpandedNodes) : null, computedProps.computedNodeCache ? JSON.stringify(computedProps.computedNodeCache) : null, computedProps.computedLoadingNodes ? JSON.stringify(computedProps.computedLoadingNodes) : null, computedDataSourceCache, computedProps.stickyGroupRows, computedProps.stickyTreeNodes]
	  });
	  var paginationProps = usePagination({
	    append: append,
	    reload: reload,
	    setAppend: setAppend,
	    lastSkipRef: lastSkipRef,
	    lastLimitRef: lastLimitRef,
	    skip: computedSkip,
	    limit: computedLimit,
	    count: count,
	    setSkip: setSkip,
	    setLimit: setLimit,
	    pagination: computedPagination,
	    livePagination: computedLivePagination,
	    localPagination: computedLocalPagination,
	    remotePagination: computedRemotePagination,
	    dataCountAfterFilter: dataCountAfterFilter,
	    originalData: originalData,
	    data: data
	  }, computedPropsRef);
	  var getRowIndexById = (0, _react.useCallback)(function (rowId, data) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return -1;
	    }
	    var dataIndexMap = computedProps.dataIndexMap;
	    if (dataIndexMap) {
	      return dataIndexMap[rowId];
	    }
	    data = data || computedProps.data;
	    return (0, _getIndexBy.default)(data, computedProps.idProperty, rowId, computedProps.getItemId, computedProps.compoundIdProperty);
	  }, []);
	  var getItemIndexById = (0, _react.useCallback)(function (id, data) {
	    return getRowIndexById(id, data);
	  }, []);
	  var getData = (0, _react.useCallback)(function () {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return [];
	    }
	    return computedProps.data;
	  }, []);
	  return _objectSpread({
	    getData: getData,
	    getRowIndexById: getRowIndexById,
	    getItemIndexById: getItemIndexById,
	    data: data,
	    dataMap: dataMap,
	    setDataMap: setDataMap,
	    dataIndexMap: dataIndexMap,
	    setDataIndexMap: setDataIndexMap,
	    loadDataTrigger: loadDataTrigger,
	    setLoadDataTrigger: setLoadDataTrigger,
	    originalData: originalData,
	    setOriginalData: setOriginalData,
	    ungroupedData: ungroupedData,
	    setUngroupedData: setUngroupedData,
	    computedSkip: computedSkip,
	    computedPagination: computedPagination,
	    computedLimit: computedLimit,
	    computedSummary: summary,
	    setSummary: setSummary,
	    dataPromiseRef: dataPromiseRef,
	    silentSetData: silentSetData,
	    computedLivePagination: computedLivePagination,
	    computedLocalPagination: computedLocalPagination,
	    computedRemotePagination: computedRemotePagination,
	    computedRemoteData: computedRemoteData,
	    computedRemoteFilter: computedRemoteFilter,
	    computedRemoteSort: computedRemoteSort,
	    computedDataSourceCache: computedDataSourceCache,
	    setDataSourceCache: setDataSourceCache,
	    setItemPropertyAt: setItemPropertyAt,
	    setItemPropertyForId: setItemPropertyForId,
	    setItemAt: setItemAt,
	    setItemsAt: setItemsAt,
	    setItemOnReorderingGroups: setItemOnReorderingGroups
	  }, paginationProps);
	};
	exports.default = _default;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _react = __webpack_require__(2);
	var useEditable = function useEditable(props, computedProps, computedPropsRef) {
	  var editInfoRef = (0, _react.useRef)(null);
	  var isInEdit = (0, _react.useRef)(false);
	  var currentEditCompletePromise = (0, _react.useRef)(Promise.resolve(true));
	  var onEditStop = (0, _react.useCallback)(function (editProps) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.initialProps.onEditStop) {
	      computedProps.initialProps.onEditStop(editProps);
	    }
	    setTimeout(function () {
	      editInfoRef.current = null;
	    }, 0);
	  }, []);
	  var onEditCancel = (0, _react.useCallback)(function (editProps) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.initialProps.onEditCancel) {
	      computedProps.initialProps.onEditCancel(editProps);
	    }
	    setTimeout(function () {
	      computedProps.isInEdit.current = false;
	    }, 50);
	  }, []);
	  var onEditComplete = (0, _react.useCallback)(function (editProps) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.autoFocusOnEditComplete) {
	      computedProps.focus();
	    }
	    if (computedProps.initialProps.onEditComplete) {
	      currentEditCompletePromise.current = Promise.resolve(computedProps.initialProps.onEditComplete(editProps));
	    }
	    computedProps.isInEdit.current = false;
	  }, []);
	  var onEditValueChange = (0, _react.useCallback)(function (editProps) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.initialProps.onEditValueChange) {
	      computedProps.initialProps.onEditValueChange(editProps);
	    }
	  }, []);
	  var onEditStart = (0, _react.useCallback)(function (editProps) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var columnId = editProps.columnId;
	    editInfoRef.current = {
	      columnId: columnId,
	      columnIndex: editProps.columnIndex,
	      rowId: editProps.rowId,
	      rowIndex: editProps.rowIndex
	    };
	    if (computedProps.initialProps.onEditStart) {
	      computedProps.initialProps.onEditStart(editProps);
	    }
	    requestAnimationFrame(function () {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      var col = computedProps.getColumnBy(columnId);
	      if (!col) {
	        return;
	      }
	      computedProps.scrollToColumn(col.computedVisibleIndex, {
	        duration: 50
	      });
	    });
	    computedProps.isInEdit.current = true;
	  }, []);
	  var tryStartEdit = (0, _react.useCallback)(function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	        rowIndex: undefined,
	        rowId: undefined,
	        columnId: '',
	        dir: 1
	      },
	      rowIndex = _ref.rowIndex,
	      rowId = _ref.rowId,
	      columnId = _ref.columnId,
	      dir = _ref.dir;
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return Promise.reject(new Error("Grid was probably unmounted"));
	    }
	    var col = computedProps.getColumnBy(columnId);
	    if (!col) {
	      return Promise.reject(new Error("No column found for columnId: ".concat(columnId)));
	    }
	    if (rowIndex === undefined) {
	      rowIndex = computedProps.getRowIndexById(rowId);
	    }
	    return new Promise(function (resolve, reject) {
	      computedProps.scrollToIndex(rowIndex, undefined, function () {
	        setTimeout(function () {
	          computedProps.getColumnLayout().tryStartEdit({
	            rowIndex: rowIndex,
	            rowId: rowId,
	            columnIndex: col.computedVisibleIndex,
	            columnId: columnId,
	            dir: dir
	          }).then(resolve, reject);
	        }, 50);
	      });
	    });
	  }, []);
	  var startEdit = (0, _react.useCallback)(function () {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	        columnId: '',
	        rowIndex: -1,
	        value: '',
	        rowId: undefined
	      },
	      columnId = _ref2.columnId,
	      rowIndex = _ref2.rowIndex,
	      value = _ref2.value,
	      rowId = _ref2.rowId;
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return Promise.reject(new Error("Grid was probably unmounted"));
	    }
	    var col = computedProps.getColumnBy(columnId);
	    if (!col) {
	      return Promise.reject(new Error("No column found for columnId: ".concat(columnId)));
	    }
	    if (rowIndex === undefined) {
	      rowIndex = computedProps.getRowIndexById(rowId);
	    }
	    return new Promise(function (resolve, reject) {
	      computedProps.scrollToIndex(rowIndex, undefined, function () {
	        setTimeout(function () {
	          computedProps.getColumnLayout().startEdit({
	            rowIndex: rowIndex,
	            rowId: rowId,
	            columnIndex: col.computedVisibleIndex,
	            columnId: columnId,
	            value: value
	          }).then(resolve, reject);
	        }, 50);
	      });
	    });
	  }, []);
	  var completeEdit = (0, _react.useCallback)(function () {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	        rowIndex: undefined,
	        rowId: undefined,
	        columnId: '',
	        dir: 1,
	        value: ''
	      },
	      rowId = _ref3.rowId,
	      rowIndex = _ref3.rowIndex,
	      columnId = _ref3.columnId,
	      value = _ref3.value;
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return Promise.reject(new Error("Grid was probably unmounted"));
	    }
	    var col = computedProps.getColumnBy(columnId);
	    var editInfo = getCurrentEditInfo();
	    if (!editInfo) {
	      return;
	    }
	    if (!col && editInfo) {
	      col = computedProps.getColumnBy(editInfo.columnId);
	      rowIndex = editInfo.rowIndex;
	    }
	    if (!col) {
	      return;
	    }
	    if (rowIndex === undefined) {
	      rowIndex = computedProps.getRowIndexById(rowId);
	    }
	    computedProps.scrollToIndex(rowIndex, undefined, function () {
	      setTimeout(function () {
	        computedProps.getColumnLayout().completeEdit({
	          rowIndex: rowIndex,
	          columnIndex: col.computedVisibleIndex,
	          value: value
	        });
	      }, 50);
	    });
	  }, []);
	  var cancelEdit = (0, _react.useCallback)(function () {
	    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	        rowIndex: undefined,
	        columnId: undefined
	      },
	      rowIndex = _ref4.rowIndex,
	      columnId = _ref4.columnId;
	    var editInfo = editInfoRef.current;
	    if (!editInfo) {
	      return;
	    }
	    var col = columnId ? computedProps.getColumnBy(columnId) : null;
	    if (!col && editInfo) {
	      col = computedProps.getColumnBy(editInfo.columnId);
	      rowIndex = editInfo.rowIndex;
	    }
	    if (!col) {
	      return;
	    }
	    computedProps.getColumnLayout().cancelEdit({
	      rowIndex: rowIndex,
	      columnIndex: col.computedVisibleIndex
	    });
	  }, []);
	  var getCurrentEditInfo = (0, _react.useCallback)(function () {
	    return editInfoRef.current;
	  }, []);
	  return {
	    getCurrentEditInfo: getCurrentEditInfo,
	    startEdit: startEdit,
	    onEditStart: onEditStart,
	    onEditStop: onEditStop,
	    onEditCancel: onEditCancel,
	    onEditComplete: onEditComplete,
	    onEditValueChange: onEditValueChange,
	    completeEdit: completeEdit,
	    cancelEdit: cancelEdit,
	    tryStartEdit: tryStartEdit,
	    isInEdit: isInEdit,
	    currentEditCompletePromise: currentEditCompletePromise
	  };
	};
	var _default = useEditable;
	exports.default = _default;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _mapGroups = _interopRequireDefault(__webpack_require__(592));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var getGroupsDepth = function getGroupsDepth(groupsMap) {
	  if (!groupsMap) {
	    return 0;
	  }
	  return Math.max.apply(Math, (0, _toConsumableArray2.default)(Object.keys(groupsMap).map(function (groupName) {
	    return groupsMap[groupName].computedDepth || 0;
	  })));
	};
	var getPivotGroups = function getPivotGroups(uniqueValuesRoot, parentGroup, pivotSummaryGroups) {
	  var groups = [];
	  var field = uniqueValuesRoot.field,
	    values = uniqueValuesRoot.values;
	  if (field && values) {
	    Object.keys(values).forEach(function (value) {
	      var groupId = "".concat(parentGroup ? parentGroup + '_' : '').concat(field, ":").concat(value);
	      var defaultGroup = pivotSummaryGroups[field];
	      var group = {
	        name: groupId,
	        header: value
	      };
	      if (defaultGroup) {
	        if (typeof defaultGroup === 'function') {
	          group = _objectSpread(_objectSpread({}, defaultGroup(_objectSpread(_objectSpread({}, group), {}, {
	            field: field,
	            values: values
	          }))), group);
	        } else {
	          group = _objectSpread(_objectSpread({}, defaultGroup), group);
	        }
	      }
	      if (parentGroup) {
	        group.group = parentGroup;
	      }
	      groups.push(group);
	      var nextRoot = values[value];
	      groups.push.apply(groups, (0, _toConsumableArray2.default)(getPivotGroups(nextRoot, groupId, pivotSummaryGroups)));
	    });
	  }
	  return groups;
	};
	var useGroups = function useGroups(props, computedProps) {
	  var computedPivotUniqueValuesPerColumn = computedProps.computedPivotUniqueValuesPerColumn;
	  var groups = props.groups;
	  if (computedPivotUniqueValuesPerColumn && computedPivotUniqueValuesPerColumn.values) {
	    var pivotSummaryGroups = computedProps.pivot ? computedProps.pivot.reduce(function (acc, pivot) {
	      if (pivot && pivot.summaryGroup) {
	        acc[pivot.name] = pivot.summaryGroup;
	      }
	      return acc;
	    }, {}) : {};
	    groups = getPivotGroups(computedPivotUniqueValuesPerColumn, undefined, pivotSummaryGroups);
	  }
	  var groupsMap = groups ? (0, _mapGroups.default)(groups, props) : null;
	  var computedGroupsDepth = getGroupsDepth(groupsMap);
	  return {
	    computedGroups: groups,
	    computedGroupsMap: groupsMap,
	    computedGroupsDepth: computedGroupsDepth
	  };
	};
	var _default = useGroups;
	exports.default = _default;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _useProperty3 = _interopRequireDefault(__webpack_require__(48));
	var _default = function _default(props, computedProps) {
	  var _useProperty = (0, _useProperty3.default)(props, 'showHeader'),
	    _useProperty2 = (0, _slicedToArray2.default)(_useProperty, 2),
	    computedShowHeader = _useProperty2[0],
	    setShowHeader = _useProperty2[1];
	  var result = {
	    computedShowHeader: computedShowHeader,
	    setShowHeader: setShowHeader
	  };
	  if (computedShowHeader) {
	    result.onHeaderSortClick = function (colProps) {
	      if (computedProps.toggleColumnSort) {
	        computedProps.toggleColumnSort(colProps.id, colProps.defaultSortingDirection);
	      }
	    };
	  }
	  return result;
	};
	exports.default = _default;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = __webpack_require__(2);
	var diff = function diff(a1, a2) {
	  if (a1.length != a2.length) {
	    return true;
	  }
	  for (var i = 0; i < a1.length; i++) {
	    if (!Object.is(a1[i], a2[i])) {
	      return true;
	    }
	  }
	  return false;
	};
	var resolved = Promise.resolve(true);
	var useLoadDataEffect = function useLoadDataEffect(_ref, fn, _ref2) {
	  var getDataSource = _ref.getDataSource;
	  var reloadDeps = _ref2.reloadDeps,
	    noReloadDeps = _ref2.noReloadDeps;
	  var prevComputedDepsRef = (0, _react.useRef)([]);
	  var reloadRef = (0, _react.useRef)();
	  var noReloadRef = (0, _react.useRef)();
	  var reloadDepsDifferent = !reloadRef.current || diff(reloadRef.current, reloadDeps);
	  var noReloadDepsDifferent = !noReloadRef.current || diff(noReloadRef.current, noReloadDeps);
	  var depsDifferent = reloadDepsDifferent || noReloadDepsDifferent;
	  var shouldReload = reloadDepsDifferent;
	  var shouldReloadRef = (0, _react.useRef)(false);
	  var computedDeps = depsDifferent ? [{}] : prevComputedDepsRef.current;
	  var resolveRef = (0, _react.useRef)(null);
	  var promiseRef = (0, _react.useRef)(resolved);
	  if (depsDifferent) {
	    shouldReloadRef.current = shouldReload;
	    promiseRef.current = new Promise(function (resolve) {
	      resolveRef.current = resolve;
	    });
	  }
	  var _useState = (0, _react.useState)(function () {
	      return new Set();
	    }),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 1),
	    pendingSet = _useState2[0];
	  var intercept = (0, _react.useCallback)(function (promise, dataSource) {
	    var isRemote = typeof dataSource === 'function' || (dataSource === null || dataSource === void 0 ? void 0 : dataSource.then);
	    if (!isRemote) {}
	    pendingSet.clear();
	    pendingSet.add(promise);
	    return promise.then(function (r) {
	      if (pendingSet.has(promise)) {
	        pendingSet.delete(promise);
	        return r;
	      }
	      return Promise.reject({
	        message: "This request is discarded as it was still pending when a new request came in.",
	        result: r
	      });
	    });
	  }, []);
	  (0, _react.useLayoutEffect)(function () {
	    var reload = shouldReloadRef.current;
	    var dataSource = getDataSource({
	      shouldReload: reload
	    });
	    fn(dataSource, {
	      shouldReload: reload,
	      intercept: intercept
	    }).then(function () {
	      if (resolveRef.current) {
	        resolveRef.current();
	      }
	    });
	    shouldReloadRef.current = shouldReload;
	  }, computedDeps);
	  reloadRef.current = reloadDeps;
	  noReloadRef.current = noReloadDeps;
	  prevComputedDepsRef.current = computedDeps;
	  return promiseRef.current;
	};
	var _default = useLoadDataEffect;
	exports.default = _default;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _react = __webpack_require__(2);
	var _default = function _default(fn, deps, equalityCheck) {
	  var refId = (0, _react.useRef)(Number.MIN_SAFE_INTEGER);
	  var depsRef = (0, _react.useRef)(deps);
	  var prevDeps = depsRef.current;
	  if (!equalityCheck(deps, prevDeps)) {
	    refId.current++;
	  }
	  depsRef.current = deps;
	  return (0, _react.useMemo)(fn, [refId.current]);
	};
	exports.default = _default;

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _lodash = _interopRequireDefault(__webpack_require__(180));
	var waitFn = _lodash.default;
	var WAIT_TIME = 36;
	var WAIT_PARAMS = {
	  maxWait: 100,
	  leading: true
	};
	var handleCellNavigation = function handleCellNavigation(event, computedProps) {
	  var key = event.key;
	  var cellNavigationRef = computedProps.cellNavigationRef;
	  if (!cellNavigationRef.current) {
	    cellNavigationRef.current = {
	      onArrowUp: function onArrowUp() {
	        var computedProps = cellNavigationRef.current.computedProps;
	        if (computedProps.incrementActiveCell) {
	          computedProps.incrementActiveCell([-1, 0]);
	        }
	      },
	      onArrowDown: function onArrowDown() {
	        var computedProps = cellNavigationRef.current.computedProps;
	        if (computedProps.incrementActiveCell) {
	          computedProps.incrementActiveCell([1, 0]);
	        }
	      },
	      onArrowRight: function onArrowRight() {
	        var computedProps = cellNavigationRef.current.computedProps;
	        if (computedProps.incrementActiveCell) {
	          computedProps.incrementActiveCell([0, 1]);
	        }
	      },
	      onArrowLeft: function onArrowLeft() {
	        var computedProps = cellNavigationRef.current.computedProps;
	        if (computedProps.incrementActiveCell) {
	          computedProps.incrementActiveCell([0, -1]);
	        }
	      },
	      onHome: function onHome() {
	        var computedProps = cellNavigationRef.current.computedProps;
	        if (computedProps.setActiveCell && activeCell) {
	          computedProps.setActiveCell([0, activeCell[1]]);
	        }
	      },
	      onEnd: function onEnd() {
	        var computedProps = cellNavigationRef.current.computedProps;
	        if (computedProps.setActiveCell && activeCell) {
	          computedProps.setActiveCell([computedProps.data.length - 1, activeCell[1]]);
	        }
	      },
	      onPageUp: function onPageUp() {
	        var computedProps = cellNavigationRef.current.computedProps;
	        if (computedProps.incrementActiveCell) {
	          computedProps.incrementActiveCell([-computedProps.keyPageStep, 0]);
	        }
	      },
	      onPageDown: function onPageDown() {
	        var computedProps = cellNavigationRef.current.computedProps;
	        if (computedProps.incrementActiveCell) {
	          computedProps.incrementActiveCell([computedProps.keyPageStep, 0]);
	        }
	      },
	      onEnter: function onEnter() {
	        var computedProps = cellNavigationRef.current.computedProps;
	        if (computedProps.toggleActiveCellSelection) {
	          computedProps.toggleActiveCellSelection(event);
	        }
	      }
	    };
	    Object.keys(cellNavigationRef.current).forEach(function (key) {
	      var fn = cellNavigationRef.current[key];
	      cellNavigationRef.current[key] = waitFn(fn, WAIT_TIME, WAIT_PARAMS);
	    });
	  }
	  cellNavigationRef.current.computedProps = computedProps;
	  var activeCell = computedProps.computedActiveCell;
	  var options = {
	    ArrowUp: cellNavigationRef.current.onArrowUp,
	    ArrowDown: cellNavigationRef.current.onArrowDown,
	    ArrowRight: cellNavigationRef.current.onArrowRight,
	    ArrowLeft: cellNavigationRef.current.onArrowLeft,
	    Home: cellNavigationRef.current.onHome,
	    End: cellNavigationRef.current.onEnd,
	    PageUp: cellNavigationRef.current.onPageUp,
	    PageDown: cellNavigationRef.current.onPageDown,
	    Enter: cellNavigationRef.current.onEnter
	  };
	  var fn = options[key];
	  if (fn) {
	    fn({
	      shiftKey: event.shiftKey,
	      ctrlKey: event.ctrlKey,
	      metaKey: event.metaKey
	    });
	    return true;
	  }
	  return false;
	};
	var _default = handleCellNavigation;
	exports.default = _default;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _contains = _interopRequireDefault(__webpack_require__(157));
	var handleRowNavigation = function handleRowNavigation(event, computedProps) {
	  var key = event.key;
	  var activeItem = computedProps.computedActiveItem;
	  var isGroup = computedProps.isGroup(activeItem);
	  var options = {
	    ArrowUp: function ArrowUp() {
	      return computedProps.incrementActiveIndex(-1);
	    },
	    ArrowDown: function ArrowDown() {
	      return computedProps.incrementActiveIndex(1);
	    },
	    Home: function Home() {
	      return computedProps.setActiveIndex(0);
	    },
	    Enter: function Enter(event) {
	      if (!activeItem) {
	        return;
	      }
	      if (isGroup) {
	        computedProps.toggleGroup(activeItem);
	        return;
	      }
	      computedProps.toggleActiveRowSelection(event);
	    },
	    End: function End() {
	      return computedProps.setActiveIndex(computedProps.data.length - 1);
	    },
	    PageUp: function PageUp() {
	      return computedProps.incrementActiveIndex(-computedProps.keyPageStep);
	    },
	    PageDown: function PageDown() {
	      return computedProps.incrementActiveIndex(computedProps.keyPageStep);
	    }
	  };
	  var fn = options[key];
	  if (fn) {
	    fn(event);
	    return true;
	  }
	  if (computedProps.allowRowTabNavigation) {
	    if (key === 'Tab') {
	      var dir = event.shiftKey ? -1 : 1;
	      var rowNode = computedProps.getDOMNodeForRowIndex(computedProps.computedActiveIndex);
	      if (document.activeElement && rowNode && (0, _contains.default)(rowNode, document.activeElement)) {
	        return false;
	      }
	      var nextIndex = computedProps.computedActiveIndex + dir;
	      var validNextIndex = nextIndex >= 0 && nextIndex < computedProps.count;
	      if (validNextIndex) {
	        computedProps.incrementActiveIndex(dir);
	        return true;
	      }
	    }
	  }
	  return false;
	};
	var _default = handleRowNavigation;
	exports.default = _default;

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = __webpack_require__(2);
	var _batchUpdate = _interopRequireDefault(__webpack_require__(50));
	var _handleSelection = __webpack_require__(221);
	var _handleRowNavigation = _interopRequireDefault(__webpack_require__(606));
	var _handleCellNavigation = _interopRequireDefault(__webpack_require__(605));
	var _containsNode = _interopRequireDefault(__webpack_require__(71));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var _default = function _default(props, computedProps, computedPropsRef) {
	  var computedOnKeyDown = function computedOnKeyDown(event) {
	    if (props.onKeyDown) {
	      props.onKeyDown(event);
	    }
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (event.nativeEvent && event.nativeEvent.__handled_in_details) {
	      return;
	    }
	    var sameElement = event.target === computedProps.getScrollingElement();
	    var handled = false;
	    if (event.key === 'Escape' && !sameElement && computedProps.autoFocusOnEditEscape) {
	      handled = true;
	      computedProps.focus();
	    }
	    if (!sameElement) {
	      return;
	    }
	    if (computedProps.computedHasRowNavigation) {
	      handled = (0, _handleRowNavigation.default)(event, computedProps);
	    } else if (computedProps.computedCellNavigationEnabled) {
	      handled = (0, _handleCellNavigation.default)(event, computedProps);
	    }
	    var activeItem = computedProps.computedActiveItem;
	    var activeIndex = computedProps.computedActiveIndex;
	    var isGroup = computedProps.isGroup(activeItem);
	    var rowExpandEnabled = computedProps.computedRowExpandEnabled;
	    var rowExpandable = activeItem && computedProps.isRowExpandableAt ? computedProps.isRowExpandableAt(activeIndex) : false;
	    var rowExpanded = rowExpandable && activeItem ? computedProps.isRowExpanded(activeItem) : false;
	    var treeEnabled = computedProps.computedTreeEnabled;
	    var nodeExpandable = treeEnabled && activeItem && computedProps.isNodeExpandableAt ? computedProps.isNodeExpandableAt(activeIndex) : false;
	    var nodeExpanded = treeEnabled && activeItem && computedProps.isNodeExpanded ? computedProps.isNodeExpanded(activeItem) : false;
	    var rowSelectionEnabled = computedProps.computedRowSelectionEnabled;
	    var keyShortcutArg = {
	      event: event,
	      data: activeItem,
	      index: activeIndex,
	      activeItem: activeItem,
	      activeIndex: activeIndex,
	      handle: computedPropsRef,
	      isGroup: isGroup,
	      treeEnabled: treeEnabled,
	      rowSelectionEnabled: rowSelectionEnabled,
	      nodeExpandable: nodeExpandable,
	      nodeExpanded: nodeExpanded,
	      rowExpandEnabled: rowExpandEnabled,
	      rowExpandable: rowExpandable,
	      rowExpanded: rowExpanded
	    };
	    var editKeyPressed = !!computedProps.isStartEditKeyPressed(keyShortcutArg);
	    var expandKeyPressed = !!computedProps.isExpandKeyPressed(keyShortcutArg);
	    var collapseKeyPressed = !expandKeyPressed ? computedProps.isCollapseKeyPressed(keyShortcutArg) : false;
	    if (expandKeyPressed) {
	      handled = true;
	    }
	    if (expandKeyPressed && activeItem) {
	      if (rowExpandEnabled && rowExpandable && !rowExpanded) {
	        computedProps.setRowExpandedAt(activeIndex, true);
	      } else {
	        if (isGroup) {
	          computedProps.expandGroup(activeItem);
	        } else if (treeEnabled && nodeExpandable && !nodeExpanded) {
	          computedProps.setNodeExpandedAt(activeIndex, true);
	        }
	      }
	    }
	    if (collapseKeyPressed) {
	      handled = true;
	    }
	    if (collapseKeyPressed && activeItem) {
	      if (rowExpandEnabled && rowExpandable && rowExpanded) {
	        computedProps.setRowExpandedAt(activeIndex, false);
	      } else {
	        if (isGroup) {
	          computedProps.collapseGroup(activeItem);
	        } else if (treeEnabled && nodeExpandable && nodeExpanded) {
	          computedProps.setNodeExpandedAt(activeIndex, false);
	        }
	      }
	    }
	    if (editKeyPressed) {
	      handled = true;
	      if (computedProps.visibleColumns && computedProps.visibleColumns.length) {
	        if (computedProps.tryStartEdit) {
	          computedProps.tryStartEdit({
	            rowIndex: activeItem ? activeIndex : 0,
	            columnId: computedProps.visibleColumns[0].id,
	            dir: 1
	          });
	        }
	      }
	    }
	    if (activeItem && event.key === 'Enter') {
	      if (rowExpandEnabled && rowExpandable) {
	        if (!rowSelectionEnabled) {
	          computedProps.toggleRowExpand(activeIndex);
	          handled = true;
	        }
	      } else {
	        if (isGroup) {
	          computedProps.toggleGroup(activeItem);
	          handled = true;
	        } else if (nodeExpandable && !rowSelectionEnabled && computedProps.computedTreeEnabled) {
	          computedProps.toggleNodeExpand(activeItem);
	          handled = true;
	        }
	      }
	    }
	    if (handled) {
	      event.preventDefault();
	      if (event.nativeEvent) {
	        event.nativeEvent.__handled_in_details = true;
	      }
	    }
	    if (computedProps.enableClipboard) {
	      var cellSelection = !!computedProps.computedCellSelection;
	      var checkboxColumn = !!computedProps.checkboxColumn;
	      var selected = !!computedProps.computedSelected;
	      if ((event.ctrlKey || event.metaKey) && event.key == 'c') {
	        if (checkboxColumn || selected) {
	          computedProps.copySelectedRowsToClipboard && computedProps.copySelectedRowsToClipboard();
	        } else if (cellSelection) {
	          computedProps.copySelectedCellsToClipboard && computedProps.copySelectedCellsToClipboard();
	        } else {
	          computedProps.copyActiveRowToClipboard && computedProps.copyActiveRowToClipboard();
	        }
	      }
	      if ((event.ctrlKey || event.metaKey) && event.key == 'v') {
	        if (checkboxColumn || selected) {
	          computedProps.pasteSelectedRowsFromClipboard && computedProps.pasteSelectedRowsFromClipboard();
	        } else if (cellSelection) {
	          computedProps.pasteSelectedCellsFromClipboard && computedProps.pasteSelectedCellsFromClipboard();
	        } else {
	          computedProps.pasteActiveRowFromClipboard && computedProps.pasteActiveRowFromClipboard();
	        }
	      }
	    }
	  };
	  var onFullBlur = (0, _react.useCallback)(function (_event) {}, []);
	  var isGroup = (0, _react.useCallback)(function (item) {
	    return !!item && !!item.__group;
	  }, []);
	  var computedOnFocus = (0, _react.useCallback)(function (event) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    event.preventDefault();
	    if (props.onFocus) {
	      props.onFocus(event);
	    }
	    if (event.nativeEvent.preventParentFocus) {
	      onFullBlur(event);
	      return;
	    }
	    event.nativeEvent.preventParentFocus = true;
	    if (computedProps.computedWillReceiveFocusRef.current) {
	      computedProps.computedWillReceiveFocusRef.current = false;
	      return;
	    }
	    if (!computedProps.computedFocused) {
	      computedProps.computedSetFocused(true);
	    }
	  }, []);
	  var computedOnBlur = (0, _react.useCallback)(function (event) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.isInEdit.current) {
	      return;
	    }
	    event.preventDefault();
	    if (computedProps.preventBlurOnContextMenuOpen && computedProps.preventBlurOnContextMenuOpen.current) {
	      return;
	    }
	    var domNode = computedProps.getDOMNode();
	    if (event.relatedTarget && (0, _containsNode.default)(domNode, event.relatedTarget)) {
	      return;
	    }
	    if (props.onBlur) {
	      props.onBlur(event);
	    }
	    var computedActiveIndex = computedProps.computedActiveIndex;
	    if (computedActiveIndex >= 0) {
	      computedProps.doSetLastActiveIndex(computedActiveIndex);
	    }
	    computedProps.setActiveIndex(-1);
	    computedProps.computedSetFocused(false);
	  }, []);
	  var onGroupRowClick = (0, _react.useCallback)(function (rowProps, _ref, queue) {
	    var enableKeyboardNavigation = _ref.enableKeyboardNavigation,
	      setActiveIndex = _ref.setActiveIndex;
	    if (rowProps.groupProps || rowProps.data && rowProps.data.__group) {
	      if (enableKeyboardNavigation) {
	        queue(function () {
	          setActiveIndex(rowProps.rowIndex);
	        });
	      }
	      queue.commit();
	      return true;
	    }
	    return false;
	  }, []);
	  var handleRowSelectionOnClick = function handleRowSelectionOnClick(event, rowProps, computedProps, queue) {
	    if (event.nativeEvent.skipSelect) {
	      if (computedProps.enableKeyboardNavigation) {
	        queue(function () {
	          computedProps.setActiveIndex(rowProps.rowIndex);
	        });
	      }
	      queue.commit();
	      return;
	    }
	    var shiftKey = event.shiftKey,
	      metaKey = event.metaKey,
	      ctrlKey = event.ctrlKey;
	    var multiSelectKey = shiftKey || metaKey || ctrlKey;
	    var autoCheckboxColumn = props.autoCheckboxColumn;
	    if (autoCheckboxColumn && multiSelectKey) {
	      return;
	    }
	    if ((0, _handleSelection.handleSelection)(rowProps, computedProps, event, queue) !== false) {
	      queue(function () {
	        computedProps.setActiveIndex(rowProps.rowIndex);
	      });
	    }
	  };
	  var computedOnRowMouseDown = (0, _react.useCallback)(function () {}, []);
	  var computedOnRowClick = (0, _react.useCallback)(function (event, rowProps) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var preventRowSelectionOnClickWithMouseMove = computedProps.preventRowSelectionOnClickWithMouseMove,
	      initialProps = computedProps.initialProps;
	    if (initialProps.onRowClick) {
	      initialProps.onRowClick({
	        rowIndex: rowProps.rowIndex,
	        remoteRowIndex: rowProps.remoteRowIndex,
	        groupProps: rowProps.groupProps,
	        empty: rowProps.empty,
	        columns: rowProps.columns,
	        dataSourceArray: rowProps.dataSourceArray,
	        data: rowProps.data
	      }, event);
	    }
	    var queue = (0, _batchUpdate.default)();
	    var lastMouseDownEventProps = computedProps.lastMouseDownEventPropsRef.current;
	    var mouseDidNotMove = event.type !== 'click';
	    if (lastMouseDownEventProps && event.type === 'click') {
	      var pageX = lastMouseDownEventProps.pageX,
	        pageY = lastMouseDownEventProps.pageY,
	        rowIndex = lastMouseDownEventProps.rowIndex;
	      mouseDidNotMove = pageX === Math.floor(event.pageX) && pageY === Math.floor(event.pageY) && rowIndex === rowProps.rowIndex;
	    }
	    if (!computedProps.computedFocused) {
	      queue(function () {
	        computedProps.computedSetFocused(true);
	      });
	    }
	    if (computedProps.computedCellSelectionEnabled) {
	      queue.commit();
	      return;
	    }
	    if (onGroupRowClick(rowProps, computedProps, queue)) {
	      queue.commit();
	      return;
	    }
	    var threshold = 20;
	    var preventRowSelection = preventRowSelectionOnClickWithMouseMove ? mouseDidNotMove : true;
	    if (preventRowSelection === false && Math.abs(lastMouseDownEventProps.pageX - event.pageX) < threshold || Math.abs(lastMouseDownEventProps.pageY - event.pageY) < threshold) {
	      preventRowSelection = true;
	    }
	    if ((!props.checkboxOnlyRowSelect || event.type !== 'click') && preventRowSelection) {
	      handleRowSelectionOnClick(event, rowProps, computedProps, queue);
	    } else {
	      if (computedProps.enableKeyboardNavigation && computedProps.computedHasRowNavigation) {
	        queue(function () {
	          computedProps.setActiveIndex(rowProps.rowIndex);
	        });
	      }
	    }
	    queue.commit();
	  }, []);
	  var computedRowDoubleClick = (0, _react.useCallback)(function (event, rowProps) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.onRowDoubleClick) {
	      computedProps.onRowDoubleClick(event, rowProps);
	    }
	  }, []);
	  var computedCellDoubleClick = (0, _react.useCallback)(function (event, cellProps) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.onCellDoubleClick) {
	      computedProps.onCellDoubleClick(event, cellProps);
	    }
	  }, []);
	  var onCellClickAction = (0, _react.useCallback)(function (event, cellProps) {
	    if (cellProps.groupProps || cellProps.cellSelectable === false) {
	      return;
	    }
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var hasCellSelection = computedProps.computedCellSelectionEnabled;
	    var cellMultiSelect = computedProps.computedCellMultiSelectionEnabled;
	    var queue = (0, _batchUpdate.default)();
	    if (hasCellSelection) {
	      var ctrlKey = event.ctrlKey || event.metaKey;
	      var append = cellMultiSelect && ctrlKey;
	      var cellCoords = [cellProps.rowIndex, cellProps.columnIndex];
	      var key = computedProps.getCellSelectionKey(cellProps);
	      var shiftKey = event.shiftKey && (computedProps.computedActiveCell || computedProps.lastSelectedCell);
	      if (shiftKey && cellMultiSelect) {
	        var cellSelection = computedProps.getCellSelectionBetween(computedProps.computedActiveCell || computedProps.lastSelectedCell || undefined, cellCoords);
	        queue(function () {
	          computedProps.setLastCellInRange(Object.keys(cellSelection).pop() || '');
	          computedProps.setCellSelection(cellSelection);
	        });
	      } else {
	        var cellSelectionMap = computedProps.computedCellSelection;
	        var isSelected = !!cellSelectionMap[key];
	        var newCellSelectionMap = append ? Object.assign({}, cellSelectionMap) : {};
	        if (isSelected && (cellMultiSelect || computedProps.initialProps.toggleCellSelectOnClick || ctrlKey)) {
	          delete newCellSelectionMap[key];
	        } else {
	          if (!shiftKey) {
	            queue(function () {
	              computedProps.setLastSelectedCell(cellCoords);
	            });
	          }
	          newCellSelectionMap[key] = true;
	        }
	        queue(function () {
	          computedProps.setCellSelection(newCellSelectionMap);
	        });
	      }
	    }
	    var shouldSetActiveCell = computedProps.computedCellNavigationEnabled && (!event.shiftKey || !cellMultiSelect);
	    queue(function () {
	      if (shouldSetActiveCell) {
	        computedProps.setActiveCell([cellProps.rowIndex, cellProps.columnIndex]);
	      }
	    });
	    queue.commit();
	  }, []);
	  var setItemAtAsSelected = (0, _react.useCallback)(function (index, event) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var computedRowSelectionEnabled = computedProps.computedRowSelectionEnabled,
	      getItemAt = computedProps.getItemAt,
	      getItemId = computedProps.getItemId;
	    var item = getItemAt(index);
	    var itemId = item ? getItemId(item) : undefined;
	    if (itemId === undefined) {
	      return;
	    }
	    if (computedRowSelectionEnabled) {
	      (0, _handleSelection.handleSelection)({
	        rowIndex: index,
	        data: item
	      }, computedProps, event || {
	        nativeEvent: null
	      });
	    }
	  }, []);
	  var selectionIndexRef = (0, _react.useRef)(null);
	  var shiftKeyIndexRef = (0, _react.useRef)(null);
	  var lastMouseDownEventPropsRef = (0, _react.useRef)({
	    rowIndex: -1,
	    pageX: -1,
	    pageY: -1
	  });
	  var computedOnCellMouseDown = (0, _react.useCallback)(function (event, cellProps) {
	    lastMouseDownEventPropsRef.current = {
	      rowIndex: cellProps.rowIndex,
	      pageX: Math.floor(event.pageX),
	      pageY: Math.floor(event.pageY)
	    };
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.columnUserSelect && event.shiftKey && computedProps.preventDefaultTextSelectionOnShiftMouseDown) {
	      event.preventDefault();
	    }
	    computedProps.onCellClickAction(event, cellProps);
	    if (computedProps.onCellSelectionDraggerMouseDown) {
	      computedProps.onCellSelectionDraggerMouseDown(event, cellProps);
	    }
	  }, []);
	  var computedActiveIndex = computedProps.computedActiveIndex;
	  return {
	    selectionIndexRef: selectionIndexRef,
	    shiftKeyIndexRef: shiftKeyIndexRef,
	    onCellClickAction: onCellClickAction,
	    computedCellDoubleClick: computedCellDoubleClick,
	    computedOnKeyDown: computedOnKeyDown,
	    computedOnFocus: computedOnFocus,
	    computedOnBlur: computedOnBlur,
	    computedOnRowClick: computedOnRowClick,
	    computedRowDoubleClick: computedRowDoubleClick,
	    computedOnRowMouseDown: computedOnRowMouseDown,
	    computedOnCellMouseDown: computedOnCellMouseDown,
	    isGroup: isGroup,
	    computedActiveItem: computedActiveIndex !== -1 && computedProps.data ? computedProps.data[computedActiveIndex] : null,
	    lastMouseDownEventPropsRef: lastMouseDownEventPropsRef,
	    toggleActiveRowSelection: function toggleActiveRowSelection(event) {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      var computedActiveIndex = computedProps.computedActiveIndex;
	      if (computedActiveIndex == -1) {
	        return;
	      }
	      setItemAtAsSelected(computedActiveIndex, event);
	    },
	    rowProps: _objectSpread(_objectSpread({}, computedProps.initialProps.rowProps), {}, {
	      onMouseDown: function onMouseDown(event) {
	        if (computedProps.initialProps.rowProps && computedProps.initialProps.rowProps.onMouseDown) {
	          computedProps.initialProps.rowProps.onMouseDown(event);
	        }
	        if (!computedProps.computedFocused && computedProps.enableKeyboardNavigation) {
	          computedProps.computedWillReceiveFocusRef.current = true;
	        }
	      }
	    })
	  };
	};
	exports.default = _default;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _getScrollbarWidth = _interopRequireDefault(__webpack_require__(47));
	var _react = __webpack_require__(2);
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var _default = function _default(props, computedProps) {
	  var SCROLLBAR_WIDTH = (0, _react.useMemo)(function () {
	    return (0, _getScrollbarWidth.default)();
	  }, []);
	  var scrollProps = _objectSpread({
	    scrollMaxDelta: SCROLLBAR_WIDTH ? 1 : 1,
	    scrollThreshold: computedProps.scrollThreshold,
	    scrollDebounceDelay: 1
	  }, props.scrollProps);
	  if (computedProps.livePagination) {
	    var loadNextPage = function loadNextPage() {
	      if (!computedProps.computedLoading && computedProps.gotoNextPage) {
	        computedProps.gotoNextPage({
	          append: true
	        });
	      }
	    };
	    scrollProps.onContainerScrollVerticalMax = function () {
	      if (props.scrollProps && props.scrollProps.onContainerScrollVerticalMax) {
	        var _props$scrollProps;
	        (_props$scrollProps = props.scrollProps).onContainerScrollVerticalMax.apply(_props$scrollProps, arguments);
	      }
	      loadNextPage();
	    };
	  }
	  return scrollProps;
	};
	exports.default = _default;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = __webpack_require__(2);
	var _useProperty5 = _interopRequireDefault(__webpack_require__(48));
	var _isSelectionEnabled = _interopRequireDefault(__webpack_require__(223));
	var _isMultiSelect = _interopRequireDefault(__webpack_require__(610));
	var _isSelectionControlled = _interopRequireDefault(__webpack_require__(222));
	var _handleSelection = __webpack_require__(221);
	var _batchUpdate = _interopRequireDefault(__webpack_require__(50));
	var _usePrevious = _interopRequireDefault(__webpack_require__(61));
	function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	var EMPTY_OBJECT = {};
	var getUnselectedFromProps = function getUnselectedFromProps(computedProps) {
	  if (!computedProps) {
	    return null;
	  }
	  if (computedProps.computedUnselected === undefined) {
	    return null;
	  }
	  return computedProps.computedUnselected;
	};
	var getUnselectedCountFromProps = function getUnselectedCountFromProps(computedProps, unselected) {
	  if (!computedProps) {
	    return 0;
	  }
	  if (!computedProps.computedRowSelectionEnabled) {
	    return 0;
	  }
	  if (!computedProps.computedRowMultiSelectionEnabled) {
	    return 0;
	  }
	  unselected = unselected === undefined ? getUnselectedFromProps(computedProps) : unselected;
	  return unselected ? Object.keys(unselected).length : 0;
	};
	var getSelectedCountFromProps = function getSelectedCountFromProps(computedProps, selected, unselected) {
	  if (!computedProps) {
	    return 0;
	  }
	  if (!computedProps.computedRowSelectionEnabled) {
	    return 0;
	  }
	  var multiSelect = computedProps.computedRowMultiSelectionEnabled;
	  selected = selected === undefined ? computedProps.computedSelected : selected;
	  if (multiSelect && selected === true) {
	    var unselectedCount = getUnselectedCountFromProps(computedProps, unselected);
	    return computedProps.paginationCount - unselectedCount;
	  }
	  return multiSelect ? selected ? Object.keys(selected).length : 0 : !selected || Object.keys(selected).length === 0 ? 0 : 1;
	};
	var useUnselected = function useUnselected(props, _ref, _computedPropsRef) {
	  var rowSelectionEnabled = _ref.rowSelectionEnabled,
	    rowMultiSelectionEnabled = _ref.rowMultiSelectionEnabled;
	  var _useProperty = (0, _useProperty5.default)(props, 'unselected'),
	    _useProperty2 = (0, _slicedToArray2.default)(_useProperty, 2),
	    unselected = _useProperty2[0],
	    setUnselected = _useProperty2[1];
	  if (!rowSelectionEnabled) {
	    return {
	      unselected: null,
	      setUnselected: setUnselected
	    };
	  }
	  if (!rowMultiSelectionEnabled) {
	    return {
	      unselected: null,
	      setUnselected: setUnselected
	    };
	  }
	  return {
	    unselected: unselected,
	    setUnselected: setUnselected
	  };
	};
	var useSelected = function useSelected(props, _computedProps, computedPropsRef) {
	  var _useProperty3 = (0, _useProperty5.default)(props, 'selected', undefined, {
	      onChange: function onChange(selected) {
	        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          silent = _ref2.silent,
	          unselected = _ref2.unselected,
	          data = _ref2.data;
	        var computedProps = computedPropsRef.current;
	        if (props.onSelectionChange && !silent) {
	          props.onSelectionChange({
	            selected: selected,
	            data: data,
	            unselected: unselected !== undefined ? unselected : computedProps != null ? computedProps.computedUnselected : null
	          });
	        }
	      }
	    }),
	    _useProperty4 = (0, _slicedToArray2.default)(_useProperty3, 2),
	    selected = _useProperty4[0],
	    setSelected = _useProperty4[1];
	  var rowSelectionEnabled = (0, _isSelectionEnabled.default)(props);
	  var rowMultiSelectionEnabled = (0, _isMultiSelect.default)(props);
	  if (!rowSelectionEnabled) {
	    return {
	      selected: null,
	      setSelected: setSelected,
	      rowSelectionEnabled: rowSelectionEnabled,
	      rowMultiSelectionEnabled: rowMultiSelectionEnabled
	    };
	  }
	  if ((0, _isSelectionControlled.default)(props)) {
	    return {
	      selected: selected,
	      setSelected: setSelected,
	      rowSelectionEnabled: rowSelectionEnabled,
	      rowMultiSelectionEnabled: rowMultiSelectionEnabled
	    };
	  }
	  if (rowMultiSelectionEnabled && ((0, _typeof2.default)(selected) != 'object' || !selected) && selected !== true) {
	    selected = EMPTY_OBJECT;
	  }
	  return {
	    selected: selected,
	    setSelected: setSelected,
	    rowSelectionEnabled: rowSelectionEnabled,
	    rowMultiSelectionEnabled: rowMultiSelectionEnabled
	  };
	};
	var _default = function _default(props, computedProps, computedPropsRef) {
	  var _useSelected = useSelected(props, computedProps, computedPropsRef),
	    computedSelected = _useSelected.selected,
	    setSelected = _useSelected.setSelected,
	    rowMultiSelectionEnabled = _useSelected.rowMultiSelectionEnabled,
	    rowSelectionEnabled = _useSelected.rowSelectionEnabled;
	  var previousRowMultiSelectionEnabled = (0, _usePrevious.default)(rowMultiSelectionEnabled, rowMultiSelectionEnabled);
	  (0, _react.useEffect)(function () {
	    if (previousRowMultiSelectionEnabled === true && rowMultiSelectionEnabled === false) {
	      setSelected({});
	    }
	  }, [previousRowMultiSelectionEnabled, rowMultiSelectionEnabled]);
	  var computedRowSelectionEnabled = rowSelectionEnabled;
	  var computedRowMultiSelectionEnabled = rowMultiSelectionEnabled;
	  var _useUnselected = useUnselected(props, {
	      rowSelectionEnabled: rowSelectionEnabled,
	      rowMultiSelectionEnabled: rowMultiSelectionEnabled
	    }, computedPropsRef),
	    computedUnselected = _useUnselected.unselected,
	    setUnselected = _useUnselected.setUnselected;
	  var computedSelectedCount = getSelectedCountFromProps({
	    computedPagination: computedProps.computedPagination,
	    computedRemoteData: computedProps.computedRemoteData,
	    paginationCount: computedProps.paginationCount,
	    computedRowMultiSelectionEnabled: computedRowMultiSelectionEnabled,
	    computedRowSelectionEnabled: computedRowSelectionEnabled
	  }, computedSelected, computedUnselected);
	  var computedUnselectedCount = getUnselectedCountFromProps({
	    computedRowMultiSelectionEnabled: computedRowMultiSelectionEnabled,
	    computedRowSelectionEnabled: computedRowSelectionEnabled
	  }, computedUnselected);
	  var isSelectionEmpty = (0, _react.useCallback)(function () {
	    var selected = computedSelected;
	    var selectionEmpty = false;
	    if (selected == null) {
	      selectionEmpty = true;
	    }
	    if ((0, _typeof2.default)(selected) === 'object' && selected !== null) {
	      selectionEmpty = Object.keys(selected).length === 0;
	    }
	    return selectionEmpty;
	  }, [computedSelected]);
	  var getSelectedMap = (0, _react.useCallback)(function () {
	    if (computedRowMultiSelectionEnabled) {
	      return computedSelected;
	    }
	    return (0, _defineProperty2.default)({}, computedSelected, true);
	  }, [computedRowMultiSelectionEnabled, computedSelected]);
	  var getUnselected = (0, _react.useCallback)(function () {
	    return getUnselectedFromProps(computedPropsRef.current);
	  }, []);
	  var getUnselectedMap = (0, _react.useCallback)(function () {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return {};
	    }
	    var unselected = getUnselected();
	    if (computedProps.computedRowMultiSelectionEnabled) {
	      return unselected || {};
	    }
	    return {};
	  }, [getUnselected]);
	  var getUnselectedCount = function getUnselectedCount(unselected) {
	    return getUnselectedCountFromProps(computedPropsRef.current, unselected);
	  };
	  var getSelectedCount = function getSelectedCount(selected, unselected) {
	    return getSelectedCountFromProps(computedPropsRef.current, selected, unselected);
	  };
	  var isRowSelected = (0, _react.useCallback)(function (data) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return false;
	    }
	    if (typeof data == 'number') {
	      data = computedProps.getItemAt(data);
	    }
	    var selectedMap = getSelectedMap();
	    var id = computedProps.getItemId(data);
	    if (selectedMap === true) {
	      var unselectedMap = getUnselectedMap();
	      return !unselectedMap[id];
	    }
	    return !!selectedMap[id];
	  }, [getSelectedMap, getUnselectedMap]);
	  var cellSelectionTmp = props.cellSelection || props.defaultCellSelection;
	  var activeCellDefined = props.activeCell !== undefined || props.defaultActiveCell !== undefined;
	  var computedHasRowNavigation = (computedRowSelectionEnabled || !cellSelectionTmp) && computedProps.computedActiveIndex > -1 ? true : props.enableKeyboardNavigation !== false && !cellSelectionTmp && !activeCellDefined;
	  if (props.enableKeyboardNavigation === false) {
	    computedHasRowNavigation = false;
	  }
	  var _computedProps$useCel = computedProps.useCellSelection(props, {
	      rowSelectionEnabled: rowSelectionEnabled,
	      listenOnCellEnter: computedProps.listenOnCellEnter,
	      hasRowNavigation: computedHasRowNavigation
	    }, computedPropsRef),
	    computedCellSelection = _computedProps$useCel.computedCellSelection,
	    setCellSelection = _computedProps$useCel.setCellSelection,
	    computedCellSelectionEnabled = _computedProps$useCel.cellSelectionEnabled,
	    computedCellMultiSelectionEnabled = _computedProps$useCel.cellMultiSelectionEnabled,
	    computedCellNavigationEnabled = _computedProps$useCel.cellNavigationEnabled,
	    computedActiveCell = _computedProps$useCel.computedActiveCell,
	    incrementActiveCell = _computedProps$useCel.incrementActiveCell,
	    getCellSelectionIdKey = _computedProps$useCel.getCellSelectionIdKey,
	    getCellSelectionBetween = _computedProps$useCel.getCellSelectionBetween,
	    toggleActiveCellSelection = _computedProps$useCel.toggleActiveCellSelection,
	    onCellEnter = _computedProps$useCel.onCellEnter,
	    setActiveCell = _computedProps$useCel.setActiveCell,
	    getCellSelectionKey = _computedProps$useCel.getCellSelectionKey,
	    cellDragStartRowIndex = _computedProps$useCel.cellDragStartRowIndex,
	    setCellDragStartRowIndex = _computedProps$useCel.setCellDragStartRowIndex,
	    onCellSelectionDraggerMouseDown = _computedProps$useCel.onCellSelectionDraggerMouseDown,
	    computedCellBulkUpdateMouseDown = _computedProps$useCel.computedCellBulkUpdateMouseDown,
	    bulkUpdateMouseDown = _computedProps$useCel.bulkUpdateMouseDown,
	    computedCellBulkUpdateMouseUp = _computedProps$useCel.computedCellBulkUpdateMouseUp;
	  var selectAll = (0, _react.useCallback)(function () {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (!computedProps.computedRowSelectionEnabled) {
	      return;
	    }
	    var data = computedProps.data;
	    var dataMap = computedProps.dataMap;
	    if (computedProps.computedGroupBy) {
	      dataMap = {};
	      data = data.map(function (d) {
	        var id = computedProps.getItemId(d);
	        dataMap[id] = id;
	      });
	    }
	    if (computedProps.computedTreeEnabled && computedProps.stickyTreeNodes) {
	      var vl = computedProps.getVirtualList();
	      vl.updateStickyRows(undefined, undefined, {
	        force: true
	      });
	    }
	    (0, _handleSelection.notifySelection)(computedProps, computedProps.computedRemoteData || computedProps.computedPagination ? data.length === 0 ? false : true : dataMap, data, null);
	  }, []);
	  var deselectAll = (0, _react.useCallback)(function () {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.computedTreeEnabled && computedProps.stickyTreeNodes) {
	      var vl = computedProps.getVirtualList();
	      vl.updateStickyRows(undefined, undefined, {
	        force: true
	      });
	    }
	    (0, _handleSelection.notifySelection)(computedProps, {}, [], null);
	  }, []);
	  var setRowSelected = (0, _react.useCallback)(function (index, selected, event) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var queue = (0, _batchUpdate.default)();
	    if (computedProps.checkboxSelectEnableShiftKey && computedProps.computedRowMultiSelectionEnabled) {
	      if (event && event.target) {
	        var shiftKey = event.shiftKey,
	          metaKey = event.metaKey,
	          ctrlKey = event.ctrlKey;
	        if (shiftKey) {
	          var rowProps = {
	            data: computedProps.getItemAt(index),
	            rowIndex: index
	          };
	          (0, _handleSelection.handleSelection)(rowProps, computedProps, {
	            shiftKey: shiftKey,
	            metaKey: metaKey,
	            ctrlKey: ctrlKey
	          }, queue);
	          return;
	        }
	        computedProps.shiftKeyIndexRef.current = index;
	        computedProps.selectionIndexRef.current = index;
	      }
	    }
	    computedProps.setSelectedAt(index, selected, queue);
	    queue.commit();
	  }, [computedProps.initialProps.checkboxSelectEnableShiftKey]);
	  var setSelectedAt = (0, _react.useCallback)(function (index, selected, queue) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var data = computedProps.data[index];
	    if (!data) {
	      return;
	    }
	    var id = computedProps.getItemId(data);
	    computedProps.setSelectedById(id, selected, queue);
	  }, []);
	  var treeGridChildrenSelection = function treeGridChildrenSelection(dataArray, id, selected, clone, treeGridChildrenDeselectionEnabled, parentNode) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var idProperty = computedProps.idProperty;
	    var nodesName = computedProps.nodesProperty;
	    var pathSeparator = computedProps.nodePathSeparator;
	    var expandedNodes = computedProps.computedExpandedNodes || EMPTY_OBJECT;
	    var generateIdFromPath = computedProps.generateIdFromPath;
	    for (var i = 0; i < dataArray.length; i++) {
	      var item = dataArray[i];
	      if (item) {
	        var _id$split;
	        var itemId = item[idProperty];
	        var itemNodes = item[nodesName];
	        var parentNodeId = parentNode ? "".concat(parentNode[idProperty]) : undefined;
	        var path = parentNode ? "".concat(parentNodeId).concat(pathSeparator).concat(itemId) : "".concat(itemId);
	        if (generateIdFromPath) {
	          item[idProperty] = path;
	        }
	        var idLength = (_id$split = id.split(pathSeparator)) === null || _id$split === void 0 ? void 0 : _id$split.length;
	        var idFromPath = path.split(pathSeparator).slice(0, idLength).join(pathSeparator);
	        if (idFromPath === id) {
	          var treeData = computedProps.dataMap ? computedProps.dataMap[path] : null;
	          if (!treeData) {
	            continue;
	          }
	          if (selected) {
	            clone[path] = treeData;
	          } else {
	            if (treeGridChildrenDeselectionEnabled) {
	              delete clone[path];
	            } else {
	              delete clone[id];
	            }
	          }
	        }
	        if (expandedNodes && expandedNodes[idFromPath]) {
	          if (Array.isArray(itemNodes)) {
	            treeGridChildrenSelection(itemNodes, id, selected, clone, treeGridChildrenDeselectionEnabled, item);
	          }
	        }
	      }
	    }
	    return clone;
	  };
	  var groupChildrenSelection = function groupChildrenSelection(_ref4) {
	    var clone = _ref4.clone,
	      id = _ref4.id,
	      selected = _ref4.selected,
	      dataMap = _ref4.dataMap,
	      idProperty = _ref4.idProperty;
	    if (!dataMap) {
	      return;
	    }
	    for (var key in dataMap) {
	      if (!key) {
	        break;
	      }
	      if (!key.includes(id)) {
	        continue;
	      }
	      var data = dataMap[key];
	      if (data.__group) {
	        if (selected) {
	          if (!clone[key]) {
	            clone[key] = data;
	          }
	        } else {
	          delete clone[key];
	        }
	        if (data.array && Array.isArray(data.array)) {
	          var _iterator = _createForOfIteratorHelper(data.array),
	            _step;
	          try {
	            for (_iterator.s(); !(_step = _iterator.n()).done;) {
	              var item = _step.value;
	              var itemId = item[idProperty];
	              if (selected) {
	                if (!clone[itemId]) clone[itemId] = item;
	              } else {
	                delete clone[itemId];
	              }
	            }
	          } catch (err) {
	            _iterator.e(err);
	          } finally {
	            _iterator.f();
	          }
	        }
	      } else {
	        var dataId = data[idProperty];
	        if (dataId === id) {
	          if (selected) {
	            if (!clone[id]) clone[id] = data;
	          } else {
	            delete clone[id];
	          }
	        }
	      }
	    }
	    return clone;
	  };
	  var setSelectedById = (0, _react.useCallback)(function (id, selected, queue) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var data = computedProps.dataMap ? computedProps.dataMap[id] : null;
	    if (!data) {
	      return;
	    }
	    var isSelected = computedProps.isRowSelected(data);
	    var multiSelect = computedProps.computedRowMultiSelectionEnabled;
	    if (isSelected === selected) {
	      return;
	    }
	    if (multiSelect) {
	      var selectedMap = computedProps.computedSelected;
	      var unselectedMap = selectedMap === true ? computedProps.computedUnselected || {} : null;
	      var clone = selectedMap;
	      if (selectedMap === true) {
	        if (unselectedMap) {
	          unselectedMap = Object.assign({}, unselectedMap);
	        }
	        if (!selected && unselectedMap) {
	          unselectedMap[id] = true;
	          var totalCount = computedProps.paginationCount;
	          if (Object.keys(unselectedMap).length === totalCount) {
	            computedProps.deselectAll();
	            return;
	          }
	        } else {
	          if (unselectedMap) {
	            delete unselectedMap[id];
	          }
	          if (getUnselectedCountFromProps(computedProps, unselectedMap) === 0) {
	            unselectedMap = null;
	          }
	        }
	      } else {
	        clone = Object.assign({}, selectedMap);
	        if (computedProps.computedTreeEnabled && computedProps.treeGridChildrenSelectionEnabled) {
	          var originalData = JSON.stringify(computedProps.originalData || []);
	          var cloneOriginalData = (0, _toConsumableArray2.default)(JSON.parse(originalData));
	          var treeGridChildrenDeselectionEnabled = computedProps.treeGridChildrenDeselectionEnabled;
	          treeGridChildrenSelection(cloneOriginalData, id, selected, clone, treeGridChildrenDeselectionEnabled);
	        } else if (computedProps.groupColumn) {
	          groupChildrenSelection({
	            clone: clone,
	            id: id,
	            selected: selected,
	            dataMap: computedProps.dataMap,
	            idProperty: computedProps.idProperty
	          });
	        } else {
	          if (selected) {
	            clone[id] = data;
	          } else {
	            delete clone[id];
	          }
	        }
	      }
	      (0, _handleSelection.notifySelection)(computedProps, clone, data, unselectedMap, queue);
	    } else {
	      (0, _handleSelection.notifySelection)(computedProps, selected ? id : null, data, null, queue);
	    }
	  }, []);
	  return {
	    selectAll: selectAll,
	    deselectAll: deselectAll,
	    setRowSelected: setRowSelected,
	    setSelectedAt: setSelectedAt,
	    setSelectedById: setSelectedById,
	    setCellSelection: setCellSelection,
	    computedCellSelection: computedCellSelection,
	    computedCellSelectionEnabled: computedCellSelectionEnabled,
	    computedCellMultiSelectionEnabled: computedCellMultiSelectionEnabled,
	    computedCellNavigationEnabled: computedCellNavigationEnabled,
	    computedActiveCell: computedActiveCell,
	    getCellSelectionBetween: getCellSelectionBetween,
	    incrementActiveCell: incrementActiveCell,
	    cellDragStartRowIndex: cellDragStartRowIndex,
	    setCellDragStartRowIndex: setCellDragStartRowIndex,
	    onCellEnter: onCellEnter,
	    onCellSelectionDraggerMouseDown: onCellSelectionDraggerMouseDown,
	    toggleActiveCellSelection: toggleActiveCellSelection,
	    computedHasRowNavigation: computedHasRowNavigation,
	    computedRowSelectionEnabled: computedRowSelectionEnabled,
	    computedRowMultiSelectionEnabled: computedRowMultiSelectionEnabled,
	    computedSelected: computedSelected,
	    setSelected: setSelected,
	    computedUnselected: computedUnselected,
	    setUnselected: setUnselected,
	    isSelectionEmpty: isSelectionEmpty,
	    getSelectedMap: getSelectedMap,
	    getUnselectedMap: getUnselectedMap,
	    isRowSelected: isRowSelected,
	    getUnselectedCount: getUnselectedCount,
	    getSelectedCount: getSelectedCount,
	    computedUnselectedCount: computedUnselectedCount,
	    computedSelectedCount: computedSelectedCount,
	    getCellSelectionIdKey: getCellSelectionIdKey,
	    setActiveCell: setActiveCell,
	    getCellSelectionKey: getCellSelectionKey,
	    computedCellBulkUpdateMouseDown: computedCellBulkUpdateMouseDown,
	    computedCellBulkUpdateMouseUp: computedCellBulkUpdateMouseUp,
	    bulkUpdateMouseDown: bulkUpdateMouseDown
	  };
	};
	exports.default = _default;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _isSelectionEnabled = _interopRequireDefault(__webpack_require__(223));
	var _isSelectionControlled = _interopRequireDefault(__webpack_require__(222));
	var isMultiSelect = function isMultiSelect(props) {
	  if (!(0, _isSelectionEnabled.default)(props)) {
	    return false;
	  }
	  if (props.multiSelect !== undefined) {
	    return !!props.multiSelect;
	  }
	  var controlled = (0, _isSelectionControlled.default)(props);
	  var isMulti = controlled ? !!((0, _typeof2.default)(props.selected) == 'object' && props.selected) || typeof props.selected === 'boolean' : !!((0, _typeof2.default)(props.defaultSelected) == 'object' && props.defaultSelected) || typeof props.defaultSelected === 'boolean' || props.checkboxColumn;
	  return !!isMulti;
	};
	var _default = isMultiSelect;
	exports.default = _default;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = __webpack_require__(2);
	var _default = function _default(defaultSize) {
	  var size;
	  var setSize;
	  var _useState = (0, _react.useState)(defaultSize);
	  var _useState2 = (0, _slicedToArray2.default)(_useState, 2);
	  size = _useState2[0];
	  setSize = _useState2[1];
	  return [size, function (newSize) {
	    setSize({
	      width: Math.round(newSize.width || size.width || 0),
	      height: Math.round(newSize.height || size.height || 0)
	    });
	  }];
	};
	exports.default = _default;

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "checkboxColumnId", {
	  enumerable: true,
	  get: function get() {
	    return _defaultCheckColumnId.id;
	  }
	});
	exports.default = void 0;
	var _renderCheckbox = _interopRequireDefault(__webpack_require__(616));
	var _defaultCheckColumnId = __webpack_require__(147);
	var _default = {
	  id: _defaultCheckColumnId.id,
	  checkboxColumn: true,
	  autoLock: true,
	  cellSelectable: false,
	  headerAlign: 'center',
	  textAlign: 'center',
	  render: function render(_ref) {
	    var cellProps = _ref.cellProps;
	    return (0, _renderCheckbox.default)(cellProps);
	  },
	  header: _renderCheckbox.default,
	  showColumnMenuSortOptions: false,
	  showColumnMenuGroupOptions: false,
	  showColumnMenuTool: false,
	  showInContextMenu: false,
	  sortable: false,
	  editable: false,
	  draggable: false,
	  groupBy: false,
	  checkboxTabIndex: null,
	  defaultWidth: 40,
	  minWidth: 40,
	  isCheckboxColumn: true
	};
	exports.default = _default;

/***/ },
/* 613 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.id = void 0;
	var id = '__group-column';
	exports.id = id;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _setColumnId = _interopRequireDefault(__webpack_require__(791));
	var _computeFlexWidths = _interopRequireDefault(__webpack_require__(794));
	var _mapColumns = _interopRequireDefault(__webpack_require__(224));
	var _defaultCheckColumnId = __webpack_require__(147);
	var _defaultRowExpandColumnId = __webpack_require__(225);
	var _defaultRowIndexColumnId = __webpack_require__(226);
	var _defaultGroupColumnId = __webpack_require__(613);
	var _defaultRowReorderColumnId = __webpack_require__(148);
	var _setComputedColumnWidths = _interopRequireDefault(__webpack_require__(617));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var DEFAULT_COLUMN_PROPS = {
	  isColumn: true,
	  keepFlex: true
	};
	var defaultPivotGrandSummaryColumn = {
	  sortable: false,
	  draggable: false,
	  filterable: false
	};
	var defaultPivotSummaryColumn = defaultPivotGrandSummaryColumn;
	var emptyArray = [];
	var emptyObject = Object.freeze ? Object.freeze({}) : {};
	var _default = function _default(_ref) {
	  var _ref$generatedColumns = _ref.generatedColumnsLength,
	    generatedColumnsLength = _ref$generatedColumns === void 0 ? 0 : _ref$generatedColumns,
	    columns = _ref.columns,
	    columnMinWidth = _ref.columnMinWidth,
	    columnMaxWidth = _ref.columnMaxWidth,
	    columnDefaultWidth = _ref.columnDefaultWidth,
	    columnWidth = _ref.columnWidth,
	    _ref$columnSizes = _ref.columnSizes,
	    columnSizes = _ref$columnSizes === void 0 ? emptyObject : _ref$columnSizes,
	    _ref$columnVisibility = _ref.columnVisibilityMap,
	    columnVisibilityMap = _ref$columnVisibility === void 0 ? emptyObject : _ref$columnVisibility,
	    _ref$columnFlexes = _ref.columnFlexes,
	    columnFlexes = _ref$columnFlexes === void 0 ? emptyObject : _ref$columnFlexes,
	    _ref$lockedColumnsSta = _ref.lockedColumnsState,
	    lockedColumnsState = _ref$lockedColumnsSta === void 0 ? emptyObject : _ref$lockedColumnsSta,
	    columnOrder = _ref.columnOrder,
	    computedPivotUniqueValuesPerColumn = _ref.computedPivotUniqueValuesPerColumn,
	    editable = _ref.editable,
	    pivot = _ref.pivot,
	    sortable = _ref.sortable,
	    filterable = _ref.filterable,
	    resizable = _ref.resizable,
	    pivotGrandSummaryColumn = _ref.pivotGrandSummaryColumn,
	    lockable = _ref.lockable,
	    checkboxColumn = _ref.checkboxColumn,
	    rowIndexColumn = _ref.rowIndexColumn,
	    filter = _ref.filter,
	    rtl = _ref.rtl,
	    filterValueMap = _ref.filterValueMap,
	    sortInfo = _ref.sortInfo,
	    showPivotSummaryColumns = _ref.showPivotSummaryColumns,
	    _ref$availableWidth = _ref.availableWidth,
	    availableWidth = _ref$availableWidth === void 0 ? 0 : _ref$availableWidth,
	    onRowReorder = _ref.onRowReorder,
	    rowReorderColumn = _ref.rowReorderColumn,
	    computedGroupColumn = _ref.groupColumn;
	  if (columnVisibilityMap) {
	    columnVisibilityMap = _objectSpread({}, columnVisibilityMap);
	  }
	  var groupColumnSummaryReducers = {};
	  var pivotColumnSummaryReducers = {};
	  var addSortInfo = function addSortInfo(col) {
	    col.computedSortable = (typeof col.sortable === 'boolean' ? col.sortable : sortable) || false;
	    col.computedSortInfo = null;
	    if (col.computedSortable && sortInfo) {
	      col.computedSortInfo = Array.isArray(sortInfo) ? sortInfo.filter(function (info) {
	        return info.name === col.id || info.id === col.id || info.name === col.sortName;
	      })[0] : sortInfo.name === col.id || sortInfo.id === col.id || sortInfo.name === col.sortName ? sortInfo : null;
	    }
	  };
	  var addFilterValue = function addFilterValue(col) {
	    col.computedFilterable = (typeof col.filterable === 'boolean' ? col.filterable : filterable) || undefined;
	    col.computedFilterValue = null;
	    if (col.computedFilterable && filterValueMap) {
	      col.computedFilterValue = filterValueMap[col.id];
	    }
	    if (col.computedFilterable === undefined && col.computedFilterValue) {
	      col.computedFilterable = true;
	    }
	    col.computedFilterable = !!col.computedFilterable;
	  };
	  var hasLockedStart = false;
	  var hasLockedEnd = false;
	  var hasValueSetter = false;
	  var rowExpandColumn;
	  var setComputedColumnWidthsParam = {
	    columnFlexes: columnFlexes,
	    columnSizes: columnSizes,
	    columnDefaultWidth: columnDefaultWidth,
	    columnWidth: columnWidth,
	    columnMinWidth: columnMinWidth,
	    columnMaxWidth: columnMaxWidth
	  };
	  var hasDedicatedGroupColumn = false;
	  var normalizedColumns = columns.map(function (column) {
	    return _objectSpread(_objectSpread({}, DEFAULT_COLUMN_PROPS), column);
	  }).map(_setColumnId.default).map(function (col, i) {
	    col.computedInitialIndex = i - generatedColumnsLength;
	    (0, _setComputedColumnWidths.default)(col, setComputedColumnWidthsParam);
	    col.computedVisible = col.visible !== undefined ? !!col.visible : columnVisibilityMap[col.id] === false ? false : true;
	    if (col.computedVisible && pivot && !col.groupSummaryReducer && col.id !== _defaultGroupColumnId.id) {
	      col.computedVisible = false;
	    }
	    if (col.computedVisible === false) {
	      columnVisibilityMap[col.id] = false;
	    } else {
	      delete columnVisibilityMap[col.id];
	      if (col.id === _defaultGroupColumnId.id) {
	        hasDedicatedGroupColumn = true;
	      }
	    }
	    col.computedHeader = col.header === undefined ? col.name || '' : col.header;
	    col.computedLocked = col.locked;
	    if (col.computedLocked === undefined && lockedColumnsState[col.id] !== undefined) {
	      col.computedLocked = lockedColumnsState[col.id];
	    }
	    if (col.computedLocked === undefined && col.defaultLocked !== undefined) {
	      col.computedLocked = col.defaultLocked;
	    }
	    if (!filter || filter(col)) {
	      if (col.computedLocked === true || col.computedLocked === 'start') {
	        col.computedLocked = 'start';
	        hasLockedStart = true;
	      }
	      if (col.computedLocked === 'end') {
	        hasLockedEnd = true;
	      }
	    }
	    col.computedLocked = col.computedLocked || false;
	    if (col.id === _defaultRowExpandColumnId.id) {
	      rowExpandColumn = col;
	    }
	    if (col.enableColumnHover != null) {
	      col.computedEnableColumnHover = col.enableColumnHover;
	      delete col.enableColumnHover;
	    }
	    if (col.setValue) {
	      hasValueSetter = true;
	    }
	    return col;
	  });
	  if (hasLockedStart) {
	    if (rowExpandColumn != null) {
	      rowExpandColumn.computedLocked = 'start';
	    }
	    if (checkboxColumn) {
	      var normalizedCheckboxColumn = normalizedColumns.filter(function (c) {
	        return c.checkboxColumn && c.id == _defaultCheckColumnId.id;
	      })[0];
	      if (normalizedCheckboxColumn) {
	        normalizedCheckboxColumn.computedLocked = 'start';
	      }
	    }
	    if (hasDedicatedGroupColumn) {
	      var normalizedGroupColumn = normalizedColumns.filter(function (c) {
	        return c.groupColumn && c.id == _defaultGroupColumnId.id;
	      })[0];
	      if (normalizedGroupColumn) {
	        normalizedGroupColumn.computedLocked = 'start';
	      }
	    }
	    var autoLockColumns = normalizedColumns.filter(function (c) {
	      return !!c.autoLock;
	    });
	    if (autoLockColumns.length) {
	      autoLockColumns.forEach(function (c) {
	        c.computedLocked = 'start';
	      });
	    }
	    if (rowReorderColumn || onRowReorder && (typeof onRowReorder === 'function' || typeof onRowReorder === 'boolean')) {
	      var normalizedRowReorderColumn = normalizedColumns.filter(function (c) {
	        return c.id === _defaultRowReorderColumnId.id;
	      })[0];
	      if (normalizedRowReorderColumn) {
	        normalizedRowReorderColumn.computedLocked = 'start';
	      }
	    }
	  }
	  var computedEnableRowspan = false;
	  normalizedColumns.forEach(function (col, index) {
	    col.computedAbsoluteIndex = index;
	    addSortInfo(col);
	    addFilterValue(col);
	    if (typeof col.rowspan === 'function') {
	      computedEnableRowspan = true;
	    }
	    col.computedResizable = (typeof col.resizable !== 'boolean' ? resizable : col.resizable) || false;
	    col.computedLockable = (typeof col.lockable !== 'boolean' ? lockable : col.lockable) || false;
	  });
	  var columnsMap = (0, _mapColumns.default)(normalizedColumns, {
	    showWarnings: true
	  });
	  var visibleColumns = normalizedColumns.filter(function (c) {
	    return c.computedVisible !== false;
	  });
	  if (columnOrder) {
	    if (checkboxColumn) {
	      var checkboxColumnIndex = columnOrder.indexOf(_defaultCheckColumnId.id);
	      if (checkboxColumnIndex == -1) {
	        columnOrder = [_defaultCheckColumnId.id].concat((0, _toConsumableArray2.default)(columnOrder));
	      }
	    }
	  }
	  if (rowExpandColumn) {
	    if (!columnOrder) {
	      columnOrder = visibleColumns.map(function (c) {
	        return c.id;
	      });
	    }
	    var rowExpandColumnIndex = columnOrder.indexOf(_defaultRowExpandColumnId.id);
	    if (rowExpandColumnIndex !== 0) {
	      columnOrder = [_defaultRowExpandColumnId.id].concat((0, _toConsumableArray2.default)(columnOrder.filter(function (id) {
	        return id != _defaultRowExpandColumnId.id;
	      })));
	    }
	  }
	  if (rowReorderColumn || onRowReorder && (typeof onRowReorder === 'function' || typeof onRowReorder === 'boolean')) {
	    if (!columnOrder) {
	      columnOrder = visibleColumns.map(function (c) {
	        return c.id;
	      });
	    }
	    var rowReorderColumnIndex = columnOrder.indexOf(_defaultRowReorderColumnId.id);
	    if (rowReorderColumnIndex !== 0) {
	      columnOrder = [_defaultRowReorderColumnId.id].concat((0, _toConsumableArray2.default)(columnOrder.filter(function (id) {
	        return id !== _defaultRowReorderColumnId.id;
	      })));
	    }
	  }
	  if (rowIndexColumn) {
	    if (!columnOrder) {
	      columnOrder = visibleColumns.map(function (c) {
	        return c.id;
	      });
	    }
	    var rowIndexColumnIndex = columnOrder.indexOf(_defaultRowIndexColumnId.id);
	    if (rowIndexColumnIndex != 0) {
	      columnOrder = [].concat((0, _toConsumableArray2.default)(columnOrder.filter(function (id) {
	        var col = columnsMap[id];
	        return col && col.groupSpacerColumn;
	      })), [_defaultRowIndexColumnId.id], (0, _toConsumableArray2.default)(columnOrder.filter(function (id) {
	        var col = columnsMap[id];
	        if (!col) {
	          return false;
	        }
	        return id != _defaultRowIndexColumnId.id && !col.groupSpacerColumn;
	      })));
	    }
	  }
	  if (generatedColumnsLength) {
	    if (!columnOrder) {
	      columnOrder = visibleColumns.map(function (c) {
	        return c.id;
	      });
	    }
	    var generatedColumns = visibleColumns.filter(function (c) {
	      return c.groupSpacerColumn;
	    });
	    var generatedColumnIds = generatedColumns.reduce(function (acc, col) {
	      acc[col.id] = true;
	      return acc;
	    }, {});
	    columnOrder = [].concat((0, _toConsumableArray2.default)(generatedColumns.map(function (c) {
	      return c.id;
	    })), (0, _toConsumableArray2.default)(columnOrder.filter(function (id) {
	      return !generatedColumnIds[id];
	    })));
	  }
	  if (columnOrder) {
	    var groupSpacerColumns = visibleColumns.filter(function (col) {
	      return col.groupSpacerColumn;
	    });
	    var _checkboxColumn = visibleColumns.filter(function (col) {
	      return col.checkboxColumn;
	    });
	    var groupColumns = visibleColumns.filter(function (col) {
	      return col.groupColumn && !col.groupSpacerColumn;
	    });
	    var ungroupColumns = visibleColumns.filter(function (col) {
	      if (computedGroupColumn) {
	        return !col.groupColumn && !col.groupSpacerColumn && !col.checkboxColumn;
	      } else {
	        return !col.groupColumn && !col.groupSpacerColumn;
	      }
	    });
	    visibleColumns = columnOrder.map(function (colId) {
	      return ungroupColumns.find(function (col) {
	        return col.id == colId;
	      });
	    }).filter(function (x) {
	      return !!x;
	    });
	    if (computedGroupColumn) {
	      visibleColumns = [].concat((0, _toConsumableArray2.default)(_checkboxColumn), (0, _toConsumableArray2.default)(groupSpacerColumns), (0, _toConsumableArray2.default)(groupColumns), (0, _toConsumableArray2.default)(visibleColumns));
	    } else {
	      visibleColumns = [].concat((0, _toConsumableArray2.default)(groupSpacerColumns), (0, _toConsumableArray2.default)(groupColumns), (0, _toConsumableArray2.default)(visibleColumns));
	    }
	  }
	  if (typeof filter == 'function') {
	    visibleColumns = visibleColumns.filter(filter);
	  }
	  normalizedColumns.forEach(function (col) {
	    if (col.groupSummaryReducer) {
	      groupColumnSummaryReducers[col.id] = col.groupSummaryReducer;
	      if (!col.groupSummaryReducer.reducer && col.groupSummaryReducer.reduce) {
	        groupColumnSummaryReducers[col.id].reducer = col.groupSummaryReducer.reduce;
	      }
	    }
	  });
	  var groupColumn = visibleColumns.filter(function (col) {
	    return !!col.groupColumn;
	  })[0];
	  if (pivot && computedPivotUniqueValuesPerColumn && groupColumn) {
	    var aggregateColumns = visibleColumns.filter(function (col) {
	      return !!col.groupSummaryReducer;
	    });
	    var newColumns = [groupColumn].concat((0, _toConsumableArray2.default)(getPivotColumns(aggregateColumns, computedPivotUniqueValuesPerColumn, columnSizes, pivot, pivotGrandSummaryColumn, showPivotSummaryColumns))).map(function (col) {
	      (0, _setComputedColumnWidths.default)(col, setComputedColumnWidthsParam);
	      col.computedResizable = (typeof col.resizable !== 'boolean' ? resizable : col.resizable) || false;
	      return col;
	    });
	    visibleColumns = newColumns;
	    columnsMap = _objectSpread(_objectSpread({}, columnsMap), (0, _mapColumns.default)(newColumns, {
	      showWarnings: true
	    }));
	  }
	  var flexes = [];
	  var maxWidths = [];
	  var minWidths = [];
	  var minColumnsSize = 0;
	  var availableWidthForFlex = availableWidth;
	  visibleColumns.forEach(function (col) {
	    if (col.computedFlex == null) {
	      availableWidthForFlex -= col.computedWidth || col.computedDefaultWidth || col.computedMinWidth || 0;
	    }
	    flexes.push(col.computedFlex || 0);
	    maxWidths.push(col.computedMaxWidth || null);
	    minWidths.push(col.computedMinWidth || null);
	  });
	  availableWidthForFlex = Math.max(availableWidthForFlex, 0);
	  var flexWidths = (0, _computeFlexWidths.default)({
	    flexes: flexes,
	    availableSize: availableWidthForFlex,
	    maxWidths: maxWidths,
	    minWidths: minWidths
	  });
	  var totalFlexColumnCount = 0;
	  visibleColumns.forEach(function (col, index) {
	    if (col.computedFlex != null) {
	      col.computedWidth = flexWidths[index] || 0;
	      totalFlexColumnCount++;
	      minColumnsSize += col.minWidth || 0;
	    } else {
	      minColumnsSize += col.computedWidth || 0;
	    }
	  });
	  var unlockedColumns = visibleColumns;
	  var lockedStartColumns = [];
	  var lockedEndColumns = [];
	  if (hasLockedStart || hasLockedEnd) {
	    unlockedColumns = groupColumn && hasLockedStart ? visibleColumns.filter(function (col) {
	      return !col.computedLocked && !col.groupColumn;
	    }) : visibleColumns.filter(function (col) {
	      return !col.computedLocked;
	    });
	    lockedStartColumns = hasLockedStart ? visibleColumns.filter(function (col) {
	      return col.computedLocked === 'start' || col.groupColumn;
	    }) : emptyArray;
	    lockedEndColumns = hasLockedEnd ? groupColumn && hasLockedStart ? visibleColumns.filter(function (col) {
	      return col.computedLocked === 'end' && !col.groupColumn;
	    }) : visibleColumns.filter(function (col) {
	      return col.computedLocked === 'end';
	    }) : emptyArray;
	    visibleColumns = [].concat((0, _toConsumableArray2.default)(lockedStartColumns), (0, _toConsumableArray2.default)(unlockedColumns), (0, _toConsumableArray2.default)(lockedEndColumns));
	  }
	  var visibleColumnsMap = (0, _mapColumns.default)(visibleColumns, {
	    showWarnings: true
	  });
	  var sumPrefixWidth = 0;
	  var totalLockedStartWidth = 0;
	  var totalLockedEndWidth = 0;
	  var totalUnlockedWidth = 0;
	  var columnWidthPrefixSums = [];
	  var computedHasColSpan = false;
	  visibleColumns.forEach(function (col, index, arr) {
	    col.computedVisibleIndex = index;
	    col.computedVisibleCount = arr.length;
	    if (col.colspan) {
	      computedHasColSpan = true;
	    }
	    col.computedOffset = sumPrefixWidth;
	    var computedLocked = col.computedLocked,
	      computedWidth = col.computedWidth;
	    if (computedLocked === 'start') {
	      totalLockedStartWidth += computedWidth || 0;
	    } else if (computedLocked === 'end') {
	      totalLockedEndWidth += computedWidth || 0;
	    } else {
	      totalUnlockedWidth += computedWidth || 0;
	    }
	    addSortInfo(col);
	    if (editable && col.editable === undefined) {
	      col.computedEditable = true;
	    }
	    if (col.editable !== undefined) {
	      col.computedEditable = col.editable;
	    }
	    columnWidthPrefixSums.push(col.computedOffset || 0);
	    sumPrefixWidth += computedWidth || 0;
	  });
	  if (pivot) {
	    pivot.forEach(function (pivotCol) {
	      if (typeof pivotCol !== 'string' && pivotCol.summaryReducer) {
	        pivotColumnSummaryReducers[pivotCol.name] = pivotCol.summaryReducer;
	      }
	    });
	  }
	  return {
	    pivotColumnSummaryReducers: pivotColumnSummaryReducers,
	    minColumnsSize: minColumnsSize,
	    totalFlexColumnCount: totalFlexColumnCount,
	    groupColumnSummaryReducers: Object.keys(groupColumnSummaryReducers).length ? groupColumnSummaryReducers : undefined,
	    totalComputedWidth: sumPrefixWidth,
	    totalLockedStartWidth: totalLockedStartWidth,
	    totalLockedEndWidth: totalLockedEndWidth,
	    totalUnlockedWidth: totalUnlockedWidth,
	    lockedStartColumns: lockedStartColumns,
	    lockedEndColumns: lockedEndColumns,
	    unlockedColumns: unlockedColumns,
	    columnWidthPrefixSums: columnWidthPrefixSums,
	    columnVisibilityMap: columnVisibilityMap,
	    computedEnableRowspan: computedEnableRowspan,
	    computedHasColSpan: computedHasColSpan,
	    visibleColumns: visibleColumns,
	    allColumns: normalizedColumns,
	    columnsMap: columnsMap,
	    visibleColumnsMap: visibleColumnsMap,
	    hasValueSetter: hasValueSetter
	  };
	};
	exports.default = _default;
	var getPivotGroupColumnForPath = function getPivotGroupColumnForPath(columnConfig, _ref2) {
	  var pivot = _ref2.pivot,
	    pivotGrandSummaryColumn = _ref2.pivotGrandSummaryColumn;
	  var pivotMap = pivot.reduce(function (acc, p) {
	    if (!p.summaryReducer) {
	      return acc;
	    }
	    var col = p ? p.summaryColumn || {} : {};
	    acc[p.name || p] = col;
	    return acc;
	  }, {});
	  if (pivotGrandSummaryColumn === true) {
	    pivotGrandSummaryColumn = {};
	  }
	  if (pivotGrandSummaryColumn) {
	    pivotGrandSummaryColumn.pivotGrandSummaryColumn = true;
	    pivotGrandSummaryColumn = _objectSpread(_objectSpread({}, defaultPivotGrandSummaryColumn), pivotGrandSummaryColumn);
	  }
	  columnConfig = _objectSpread(_objectSpread({}, defaultPivotSummaryColumn), columnConfig);
	  var _columnConfig = columnConfig,
	    pivotSummaryPath = _columnConfig.pivotSummaryPath;
	  var lastItem = pivotSummaryPath[pivotSummaryPath.length - 1];
	  var name = lastItem ? lastItem.field : null;
	  var col = !lastItem ? pivotGrandSummaryColumn : pivotMap[name] || {};
	  var result = columnConfig;
	  if (lastItem) {
	    columnConfig.header = "Summary for ".concat(lastItem.field, " ").concat(lastItem.value);
	  }
	  if (!pivotGrandSummaryColumn && !pivotMap[name]) {
	    return null;
	  }
	  if (col) {
	    if (typeof col === 'function') {
	      result = _objectSpread(_objectSpread({}, columnConfig), col(columnConfig));
	    } else {
	      result = _objectSpread(_objectSpread({}, columnConfig), col);
	    }
	  }
	  return result;
	};
	var getPivotColumns = function getPivotColumns(aggregateColumns, uniqueValuesRoot, columnSizes, pivot, pivotGrandSummaryColumn, showPivotSummaryColumns) {
	  var parentGroups = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
	  var pivotColumnPath = arguments.length > 7 ? arguments[7] : undefined;
	  var newColumns = [];
	  var field = uniqueValuesRoot.field,
	    values = uniqueValuesRoot.values;
	  var parentGroup = parentGroups[parentGroups.length - 1];
	  if (field && values) {
	    Object.keys(values).forEach(function (value) {
	      var groupId = "".concat(parentGroup ? parentGroup.name + '_' : '').concat(field, ":").concat(value);
	      var group = {
	        name: groupId,
	        header: "".concat(field, "-").concat(value),
	        pivotPath: [{
	          value: value,
	          field: field
	        }]
	      };
	      if (parentGroup) {
	        group.group = parentGroup.name;
	        group.pivotPath = [].concat((0, _toConsumableArray2.default)(parentGroup.pivotPath || []), (0, _toConsumableArray2.default)(group.pivotPath));
	      }
	      var nextRoot = values[value];
	      pivotColumnPath = pivotColumnPath || [];
	      newColumns.push.apply(newColumns, (0, _toConsumableArray2.default)(getPivotColumns(aggregateColumns, nextRoot, columnSizes, pivot, pivotGrandSummaryColumn, showPivotSummaryColumns, [].concat((0, _toConsumableArray2.default)(parentGroups), [{
	        name: groupId,
	        pivotPath: group.pivotPath,
	        depth: parentGroup ? parentGroup.depth + 1 : 0
	      }]), [].concat((0, _toConsumableArray2.default)(pivotColumnPath), [value]))));
	      if (!parentGroup && showPivotSummaryColumns) {
	        var summaryCol = getPivotGroupColumnForPath({
	          header: "Summary for ".concat(group.header),
	          id: "__summary_".concat(group.name),
	          pivotSummaryColumn: true,
	          pivotSummaryPath: group.pivotPath
	        }, {
	          pivot: pivot
	        });
	        if (summaryCol) {
	          newColumns.push(summaryCol);
	        }
	      }
	    });
	  } else {
	    newColumns.push.apply(newColumns, (0, _toConsumableArray2.default)(aggregateColumns.map(function (col) {
	      var result = _objectSpread(_objectSpread({}, col), {}, {
	        sortable: false,
	        showInContextMenu: false,
	        draggable: false,
	        pivotColumn: true,
	        pivotColumnPath: [].concat((0, _toConsumableArray2.default)(pivotColumnPath || []), [col.pivotName || col.name || col.id]),
	        id: "".concat(parentGroup.name, "-").concat(col.id),
	        group: parentGroup.name
	      });
	      if (columnSizes[result.id]) {
	        result.computedWidth = columnSizes[result.id];
	      }
	      return result;
	    })));
	    var prevParentGroup = parentGroups[parentGroups.length - 2];
	    if (showPivotSummaryColumns && prevParentGroup) {
	      var summaryCol = getPivotGroupColumnForPath({
	        group: prevParentGroup ? prevParentGroup.name : undefined,
	        header: "Summary for ".concat(parentGroup.name, " - ").concat(prevParentGroup ? prevParentGroup.name : ''),
	        id: "__summary__".concat(parentGroup.name),
	        pivotSummaryPath: parentGroup.pivotPath,
	        pivotSummaryColumn: true
	      }, {
	        pivot: pivot
	      });
	      if (summaryCol) {
	        newColumns.push(summaryCol);
	      }
	    }
	  }
	  if (!parentGroup && pivotGrandSummaryColumn && showPivotSummaryColumns) {
	    newColumns.push(getPivotGroupColumnForPath({
	      header: "Grand summary",
	      id: "__summary__grand",
	      pivotSummaryColumn: true,
	      pivotSummaryPath: []
	    }, {
	      pivot: pivot,
	      pivotGrandSummaryColumn: pivotGrandSummaryColumn
	    }));
	  }
	  return newColumns;
	};

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _defaultCheckColumn = _interopRequireDefault(__webpack_require__(612));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _default(columns, props) {
	  var checkboxColumn = props.checkboxColumn;
	  if (checkboxColumn) {
	    var checkCol = _objectSpread(_objectSpread(_objectSpread({}, _defaultCheckColumn.default), checkboxColumn === true ? null : checkboxColumn), {}, {
	      name: null,
	      id: _defaultCheckColumn.default.id
	    });
	    if (checkCol.visible === false) {
	      checkCol.visible = true;
	    }
	    if (columns[0] && columns[0].group && props.groups && props.groups.length) {
	      delete checkCol.nextBorderLeft;
	    }
	    columns = [checkCol].concat(columns);
	  }
	  return columns;
	}

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _CheckBox = _interopRequireDefault(__webpack_require__(155));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var stopPropagation = function stopPropagation(e) {
	  e.stopPropagation();
	};
	var emptyObject = {};
	var _default = function _default(cellProps) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyObject,
	    headerProps = _ref.headerProps;
	  var selectAll = cellProps.selectAll,
	    deselectAll = cellProps.deselectAll,
	    selectedCount = cellProps.selectedCount,
	    unselectedCount = cellProps.unselectedCount,
	    totalCount = cellProps.totalCount,
	    headerCell = cellProps.headerCell,
	    empty = cellProps.empty,
	    rowIndex = cellProps.rowIndex,
	    rowSelected = cellProps.rowSelected,
	    setRowSelected = cellProps.setRowSelected,
	    renderCheckbox = cellProps.renderCheckbox,
	    hideIntermediateState = cellProps.hideIntermediateState;
	  if (empty && !renderCheckbox) {
	    return null;
	  }
	  var checkboxProps = {
	    disabled: empty,
	    tabIndex: cellProps.checkboxTabIndex,
	    onClick: stopPropagation,
	    supportIndeterminate: false,
	    theme: cellProps.theme,
	    className: 'InovuaReactDataGrid__checkbox'
	  };
	  if (headerCell) {
	    var selected = headerProps.selected,
	      unselected = headerProps.unselected;
	    checkboxProps.supportIndeterminate = !hideIntermediateState;
	    var checked;
	    if (selected === true) {
	      checked = unselected && (0, _typeof2.default)(unselected) == 'object' && Object.keys(unselected).length != 0 ? checkboxProps.supportIndeterminate ? null : false : true;
	    } else {
	      checked = selectedCount == 0 || !totalCount ? false : totalCount <= selectedCount && unselectedCount === 0 ? true : checkboxProps.supportIndeterminate ? null : false;
	    }
	    checkboxProps.checked = checked;
	    checkboxProps.onChange = checked === false ? selectAll : deselectAll;
	  } else {
	    checkboxProps.onChange = setRowSelected ? setRowSelected.bind(null, rowIndex) : null;
	    checkboxProps.checked = rowSelected;
	  }
	  if (renderCheckbox) {
	    if (checkboxProps.checked === null && checkboxProps.supportIndeterminate) {
	      checkboxProps.isIndeterminate = true;
	    }
	    var result = renderCheckbox(checkboxProps, cellProps);
	    if (result !== undefined) {
	      return result;
	    }
	  }
	  delete checkboxProps.isIndeterminate;
	  return _react.default.createElement(_CheckBox.default, _objectSpread({}, checkboxProps));
	};
	exports.default = _default;

/***/ },
/* 617 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var emptyObject = Object.freeze ? Object.freeze({}) : {};
	var DEFAULT_WIDTH = 150;
	var computeColumnWidths = function computeColumnWidths(col, _ref) {
	  var columnMinWidth = _ref.columnMinWidth,
	    columnWidth = _ref.columnWidth,
	    columnMaxWidth = _ref.columnMaxWidth,
	    _ref$columnDefaultWid = _ref.columnDefaultWidth,
	    columnDefaultWidth = _ref$columnDefaultWid === void 0 ? DEFAULT_WIDTH : _ref$columnDefaultWid,
	    _ref$columnSizes = _ref.columnSizes,
	    columnSizes = _ref$columnSizes === void 0 ? emptyObject : _ref$columnSizes,
	    _ref$columnFlexes = _ref.columnFlexes,
	    columnFlexes = _ref$columnFlexes === void 0 ? emptyObject : _ref$columnFlexes;
	  if (columnMinWidth && columnMaxWidth && columnMinWidth > columnMaxWidth) {
	    var _ref2 = [columnMaxWidth, columnMinWidth];
	    columnMinWidth = _ref2[0];
	    columnMaxWidth = _ref2[1];
	  }
	  var computedDefaultWidth = col.defaultWidth;
	  var computedWidth = col.width;
	  var computedFlex = col.defaultFlex;
	  var computedMinWidth = col.minWidth;
	  var computedMaxWidth = col.maxWidth;
	  if (col.defaultWidth == null && columnDefaultWidth != null) {
	    computedDefaultWidth = columnDefaultWidth;
	  }
	  if (columnFlexes[col.id]) {
	    computedFlex = columnFlexes[col.id];
	  }
	  if (col.flex) {
	    computedFlex = col.flex;
	  }
	  if (!computedFlex && computedWidth === undefined && columnSizes[col.id] !== undefined) {
	    computedFlex = null;
	    computedWidth = columnSizes[col.id];
	  }
	  if (!computedFlex) {
	    computedFlex = null;
	  }
	  if (computedFlex != null && computedWidth == null && columnWidth != null) {
	    computedWidth = columnWidth;
	  }
	  if (computedMinWidth == null && columnMinWidth != null) {
	    computedMinWidth = columnMinWidth;
	  }
	  if (computedMaxWidth == null && columnMaxWidth != null) {
	    computedMaxWidth = columnMaxWidth;
	  }
	  if (computedDefaultWidth != null && computedMinWidth != null && computedDefaultWidth < computedMinWidth) {
	    computedDefaultWidth = computedMinWidth;
	  }
	  if (computedDefaultWidth != null && computedMaxWidth != null && computedDefaultWidth > computedMaxWidth) {
	    computedDefaultWidth = computedMaxWidth;
	  }
	  if (computedWidth != null && computedMinWidth != null && computedWidth < computedMinWidth) {
	    computedWidth = computedMinWidth;
	  }
	  if (computedWidth != null && computedMaxWidth != null && computedWidth > computedMaxWidth) {
	    computedWidth = computedMaxWidth;
	  }
	  if (computedFlex == null) {
	    computedWidth = computedWidth || computedDefaultWidth || computedMinWidth;
	  }
	  col.computedMinWidth = computedMinWidth;
	  col.computedMaxWidth = computedMaxWidth;
	  col.computedWidth = computedWidth;
	  col.computedFlex = computedFlex;
	  return col;
	};
	var _default = computeColumnWidths;
	exports.default = _default;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	var _maybeAddCheckboxColumn = _interopRequireDefault(__webpack_require__(615));
	function _default(columns, props) {
	  if (props.maybeAddColumns) {
	    columns = props.maybeAddColumns(columns, props);
	  }
	  columns = (0, _maybeAddCheckboxColumn.default)(columns, props);
	  return columns;
	}

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _2 = _interopRequireDefault(__webpack_require__(614));
	var _shallowequal = __webpack_require__(73);
	var _useBuildColumns = _interopRequireDefault(__webpack_require__(618));
	var _useMemoWithObject = _interopRequireDefault(__webpack_require__(604));
	var includeAll = function includeAll() {
	  return true;
	};
	var useGroupByColumns = function useGroupByColumns(args) {
	  var generatedColumnsLength = 0;
	  var columns = args.columns;
	  var groupBy = args.groupBy,
	    groupColumn = args.groupColumn,
	    filter = args.filter,
	    groupForGroupColumns = args.groupForGroupColumns,
	    checkboxColumn = args.checkboxColumn,
	    lockedColumnsState = args.lockedColumnsState,
	    groupNestingSize = args.groupNestingSize,
	    inTransition = args.inTransition;
	  if (groupBy && groupBy.length && !groupColumn) {
	    var lockedStartCount = 0;
	    var groupColumnCount = 0;
	    columns.filter(filter || includeAll).forEach(function (col) {
	      if (col.groupSpacerColumn) {
	        groupColumnCount++;
	      }
	      var locked = col.locked === undefined ? col.defaultLocked : col.locked;
	      var colInLocked = lockedColumnsState[col.id] || lockedColumnsState[col.name];
	      if (colInLocked !== undefined) {
	        locked = colInLocked;
	      }
	      if (locked === 'start' || locked === true) {
	        lockedStartCount++;
	      }
	    });
	    if (lockedStartCount && checkboxColumn) {
	      lockedStartCount++;
	    }
	    var generatedColumns = (0, _toConsumableArray2.default)(Array(groupBy.length - groupColumnCount)).map(function (_, i) {
	      return {
	        name: "__col_generated-groupBy-".concat(groupColumnCount + i),
	        header: null,
	        inTransition: inTransition,
	        visibilityTransitionDuration: !!inTransition,
	        groupSpacerColumn: true,
	        group: groupForGroupColumns,
	        locked: !!lockedStartCount,
	        defaultWidth: groupNestingSize,
	        width: groupNestingSize,
	        minWidth: groupNestingSize,
	        maxWidth: groupNestingSize,
	        showInContextMenu: false,
	        cellSelectable: false,
	        draggable: false,
	        resizable: false,
	        sortable: false
	      };
	    });
	    generatedColumnsLength = generatedColumns.length;
	    columns = generatedColumnsLength ? [].concat((0, _toConsumableArray2.default)(generatedColumns), (0, _toConsumableArray2.default)(columns)) : columns;
	  }
	  return {
	    columns: columns,
	    generatedColumnsLength: generatedColumnsLength
	  };
	};
	var useColumnInfo = function useColumnInfo(params) {
	  return (0, _useMemoWithObject.default)(function () {
	    var columns = params.columns,
	      columnMinWidth = params.columnMinWidth,
	      columnMaxWidth = params.columnMaxWidth,
	      columnDefaultWidth = params.columnDefaultWidth,
	      columnWidth = params.columnWidth,
	      groupNestingSize = params.groupNestingSize,
	      columnOrder = params.columnOrder,
	      onRowReorder = params.onRowReorder,
	      columnVisibilityMap = params.columnVisibilityMap,
	      columnSizes = params.columnSizes,
	      columnFlexes = params.columnFlexes,
	      _params$lockedColumns = params.lockedColumnsState,
	      lockedColumnsState = _params$lockedColumns === void 0 ? {} : _params$lockedColumns,
	      groupBy = params.groupBy,
	      maybeAddColumns = params.maybeAddColumns,
	      editable = params.editable,
	      computedPivotUniqueValuesPerColumn = params.computedPivotUniqueValuesPerColumn,
	      checkboxColumn = params.checkboxColumn,
	      rowIndexColumn = params.rowIndexColumn,
	      groupColumn = params.groupColumn,
	      pivot = params.pivot,
	      groupForGroupColumns = params.groupForGroupColumns,
	      inTransition = params.inTransition,
	      rtl = params.rtl,
	      hideGroupByColumns = params.hideGroupByColumns,
	      availableWidth = params.availableWidth,
	      sortInfo = params.sortInfo,
	      filterValueMap = params.filterValueMap,
	      sortable = params.sortable,
	      filterable = params.filterable,
	      resizable = params.resizable,
	      pivotGrandSummaryColumn = params.pivotGrandSummaryColumn,
	      lockable = params.lockable,
	      groups = params.groups,
	      enableRowExpand = params.enableRowExpand,
	      showPivotSummaryColumns = params.showPivotSummaryColumns,
	      expandedRows = params.expandedRows,
	      defaultExpandedRows = params.defaultExpandedRows,
	      renderRowDetails = params.renderRowDetails,
	      renderDetailsGrid = params.renderDetailsGrid,
	      rowExpandColumn = params.rowExpandColumn,
	      rowReorderColumn = params.rowReorderColumn,
	      renderRowDetailsExpandIcon = params.renderRowDetailsExpandIcon,
	      renderRowDetailsCollapsedIcon = params.renderRowDetailsCollapsedIcon;
	    if (pivot) {
	      groupColumn = groupColumn || true;
	    }
	    columns = (0, _useBuildColumns.default)(columns, {
	      groups: groups,
	      checkboxColumn: checkboxColumn,
	      groupBy: groupBy,
	      groupColumn: groupColumn,
	      rowIndexColumn: rowIndexColumn,
	      enableRowExpand: enableRowExpand,
	      expandedRows: expandedRows,
	      maybeAddColumns: maybeAddColumns,
	      defaultExpandedRows: defaultExpandedRows,
	      renderRowDetails: renderRowDetails,
	      renderDetailsGrid: renderDetailsGrid,
	      rowExpandColumn: rowExpandColumn,
	      onRowReorder: onRowReorder,
	      rowReorderColumn: rowReorderColumn,
	      renderRowDetailsExpandIcon: renderRowDetailsExpandIcon,
	      renderRowDetailsCollapsedIcon: renderRowDetailsCollapsedIcon
	    });
	    var filter = !hideGroupByColumns || !groupBy || !groupBy.length ? null : function (col) {
	      return groupBy.indexOf(col.id || col.name) == -1;
	    };
	    var generatedColumnsLength;
	    var res = useGroupByColumns({
	      groupBy: groupBy,
	      groupColumn: groupColumn,
	      columns: columns,
	      filter: filter,
	      groupForGroupColumns: groupForGroupColumns,
	      checkboxColumn: checkboxColumn,
	      lockedColumnsState: lockedColumnsState,
	      groupNestingSize: groupNestingSize,
	      inTransition: inTransition
	    });
	    columns = res.columns;
	    generatedColumnsLength = res.generatedColumnsLength;
	    return (0, _2.default)({
	      pivotGrandSummaryColumn: pivotGrandSummaryColumn,
	      generatedColumnsLength: generatedColumnsLength,
	      columns: columns,
	      columnMinWidth: columnMinWidth,
	      columnMaxWidth: columnMaxWidth,
	      columnDefaultWidth: columnDefaultWidth,
	      columnWidth: columnWidth,
	      columnSizes: columnSizes,
	      columnFlexes: columnFlexes,
	      columnOrder: columnOrder,
	      showPivotSummaryColumns: showPivotSummaryColumns,
	      computedPivotUniqueValuesPerColumn: computedPivotUniqueValuesPerColumn,
	      rtl: rtl,
	      filterValueMap: filterValueMap,
	      pivot: pivot,
	      checkboxColumn: checkboxColumn,
	      rowIndexColumn: rowIndexColumn,
	      columnVisibilityMap: columnVisibilityMap,
	      lockedColumnsState: lockedColumnsState,
	      sortable: sortable,
	      filterable: filterable,
	      resizable: resizable,
	      lockable: lockable,
	      filter: filter,
	      sortInfo: sortInfo,
	      editable: editable,
	      availableWidth: availableWidth,
	      onRowReorder: onRowReorder,
	      rowReorderColumn: rowReorderColumn,
	      groupColumn: groupColumn
	    });
	  }, params, function (a, b) {
	    var _equalReturnKey = (0, _shallowequal.equalReturnKey)(a, b),
	      result = _equalReturnKey.result,
	      key = _equalReturnKey.key;
	    return result;
	  });
	};
	var _default = useColumnInfo;
	exports.default = _default;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _isMobile = _interopRequireDefault(__webpack_require__(72));
	var ARROWS = {
	  right: _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M4.738 5.262L.632 9.368c-.144.144-.379.144-.524 0C.04 9.298 0 9.204 0 9.106V.894C0 .69.166.524.37.524c.099 0 .193.039.262.108l4.106 4.106c.145.145.145.38 0 .524z"
	  }),
	  left: _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M.262 4.738L4.368.632c.144-.144.379-.144.524 0C4.96.702 5 .796 5 .894v8.212c0 .204-.166.37-.37.37-.099 0-.193-.039-.262-.108L.262 5.262c-.145-.145-.145-.38 0-.524z"
	  }),
	  down: _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M4.738 4.738L.632.632C.488.488.488.253.632.108.702.04.796 0 .894 0h8.212c.204 0 .37.166.37.37 0 .099-.039.193-.108.262L5.262 4.738c-.145.145-.38.145-.524 0z"
	  }),
	  up: _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M5.262.262l4.106 4.106c.144.144.144.379 0 .524-.07.069-.164.108-.262.108H.894c-.204 0-.37-.166-.37-.37 0-.099.039-.193.108-.262L4.738.262c.145-.145.38-.145.524 0z"
	  })
	};
	var Arrow = function Arrow(_ref) {
	  var name = _ref.name,
	    className = _ref.className,
	    _ref$size = _ref.size,
	    size = _ref$size === void 0 ? _isMobile.default ? 25 : 20 : _ref$size;
	  return _react.default.createElement("svg", {
	    className: "".concat(className, " ").concat(className, "--").concat(name),
	    height: size.height || size,
	    width: size.width || size,
	    viewBox: "0 0 10 20"
	  }, _react.default.createElement("g", {
	    transform: "translate(2.5, 5)"
	  }, ARROWS[name]));
	};
	var _default = Arrow;
	exports.default = _default;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _isMobile = _interopRequireDefault(__webpack_require__(72));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _debounce = _interopRequireDefault(__webpack_require__(212));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _Flex = __webpack_require__(41);
	var _NotifyResize = __webpack_require__(84);
	var _InertialScroller = __webpack_require__(688);
	var _ua = __webpack_require__(103);
	var _reactScrollContainerPro = _interopRequireDefault(__webpack_require__(754));
	var _Arrow = _interopRequireDefault(__webpack_require__(620));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var VIEW_STYLE_VERTICAL = {
	  maxHeight: '100%'
	};
	var VIEW_STYLE_HORIZONTAL = {
	  maxWidth: '100%'
	};
	var observe = function observe(targetNode, callback, cfg) {
	  var config = cfg || {
	    attributes: false,
	    childList: true,
	    subtree: true
	  };
	  var observer = new MutationObserver(callback);
	  observer.observe(targetNode, config);
	  return function () {
	    observer.disconnect();
	  };
	};
	var measureScrollSize = function measureScrollSize(node) {
	  return {
	    width: node.scrollWidth,
	    height: node.scrollHeight
	  };
	};
	var scrollerResizerProps = {
	  useNativeIfAvailable: false,
	  measureSize: measureScrollSize
	};
	var callAll = function callAll() {
	  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
	    fns[_key] = arguments[_key];
	  }
	  return function () {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	    fns.forEach(function (fn) {
	      fn && fn.apply(void 0, args);
	    });
	  };
	};
	var pint = globalObject.parseInt;
	var raf = globalObject.requestAnimationFrame;
	var getCompStyle = globalObject.getComputedStyle;
	var NO_SCROLLBARS = function NO_SCROLLBARS() {
	  return false;
	};
	var InovuaArrowScroller = function (_Component) {
	  (0, _inherits2.default)(InovuaArrowScroller, _Component);
	  var _super = _createSuper(InovuaArrowScroller);
	  function InovuaArrowScroller(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaArrowScroller);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollerNodeClientSize", function (node) {
	      var result = {
	        width: node.firstChild.offsetWidth,
	        height: node.firstChild.offsetHeight
	      };
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScrollContainerDidMount", function (scrollContainer, domNode, notifyResizer) {
	      _this._unobserve = observe(domNode, function () {
	        if (notifyResizer && notifyResizer.checkResize) {
	          notifyResizer.checkResize();
	        }
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScrollContainerWillUnmount", function () {
	      if (_this._unobserve) {
	        _this._unobserve();
	      }
	    });
	    _this.scrollInfo = {
	      scrollPos: 0,
	      hasStartScroll: false,
	      hasEndScroll: false,
	      scrollerSize: {
	        start: 0,
	        end: 0
	      }
	    };
	    _this.state = {
	      scrolling: false,
	      activeScroll: 0
	    };
	    _this.handleResize = (0, _debounce.default)(_this.handleResize.bind((0, _assertThisInitialized2.default)(_this)), 50, {
	      leading: false,
	      trailing: true
	    });
	    _this.updateScrollInfo = _this.updateScrollInfo.bind((0, _assertThisInitialized2.default)(_this));
	    _this.rafUpdateScrollInfo = _this.rafUpdateScrollInfo.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onContainerScroll = _this.onContainerScroll.bind((0, _assertThisInitialized2.default)(_this));
	    _this.strip = (0, _react.createRef)();
	    _this.refScrollContainer = function (scrollContainer) {
	      _this.scrollerTarget = scrollContainer;
	    };
	    _this.setRootRef = function (ref) {
	      _this.root = ref;
	      if (!_this.props.nativeScroll) {
	        _this.scrollerTarget = _this.root;
	      }
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaArrowScroller, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	      this.componentIsMounted = true;
	      raf(function () {
	        var name = _this2.getOffsetSizeName();
	        _this2.scrollInfo.scrollerSize = {
	          start: _this2.props.scroller === (true || 'auto') ? _this2.start[name] : null,
	          end: _this2.props.scroller === (true || 'auto') ? _this2.end[name] : null
	        };
	        _this2.syncScroll({
	          force: true
	        });
	        _this2.inertialManager = new _InertialScroller.InertialManager({
	          arrowSelector: ".".concat(_this2.props.rootClassName, "__arrow"),
	          node: _this2.root,
	          viewNode: _this2.strip.current,
	          setScrollPosition: function setScrollPosition() {
	            return raf(function () {
	              return _this2.setScrollPosition();
	            });
	          },
	          enableMouseDrag: false
	        });
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.componentIsMounted = false;
	      if (this.inertialManager) {
	        this.inertialManager.removeEventListeners();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var useTransformOnScroll = props.useTransformOnScroll,
	        nativeScroll = props.nativeScroll,
	        vertical = props.vertical,
	        rootClassName = props.rootClassName,
	        rtl = props.rtl,
	        theme = props.theme;
	      var scrollInfo = this.scrollInfo;
	      var scrollValue = rtl ? scrollInfo.scrollPos : -scrollInfo.scrollPos;
	      var innerWrapperClassName = (0, _join.default)("".concat(rootClassName, "__inner-wrapper"), "".concat(rootClassName, "__inner-wrapper--direction-").concat(vertical ? 'column' : 'row'));
	      var className = (0, _join.default)(props.className, rootClassName, !vertical && "".concat(rootClassName, "--direction-horizontal"), vertical && "".concat(rootClassName, "--direction-vertical"), rtl && "".concat(rootClassName, "--rtl"), nativeScroll && "".concat(rootClassName, "--native-scroll"), theme && "".concat(rootClassName, "--theme-").concat(theme));
	      var transformValue;
	      var moveStyle = {};
	      if (useTransformOnScroll) {
	        moveStyle.transform = 'translate3d(0px, 0px, 0px)';
	      }
	      if (vertical) {
	        if (useTransformOnScroll) {
	          moveStyle.transform = "translate3d(0px, ".concat(scrollValue, "px, 0px)");
	        } else {
	          moveStyle.top = scrollValue;
	        }
	      } else {
	        if (useTransformOnScroll) {
	          moveStyle.transform = "translate3d(".concat(scrollValue, "px, 0px, 0px)");
	        } else {
	          moveStyle.left = scrollValue;
	        }
	      }
	      var resizer = _react.default.createElement(_NotifyResize.NotifyResize, {
	        key: "resizer",
	        notifyOnMount: true,
	        onResize: this.handleResize,
	        notifyResizeDelay: props.notifyResizeDelay
	      });
	      var children = [].concat((0, _toConsumableArray2.default)(_react.default.Children.toArray(props.children)), [resizer]);
	      var content = _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({
	        key: "content",
	        wrap: false
	      }, props.childProps), {}, {
	        className: innerWrapperClassName,
	        ref: this.strip,
	        children: children,
	        style: nativeScroll ? null : moveStyle
	      }));
	      var finalChildren = [resizer, content, this.renderScroller(-1), this.renderScroller(1)];
	      if (nativeScroll) {
	        var scrollContainerProps = this.props.scrollContainerProps;
	        var viewStyle = vertical ? VIEW_STYLE_VERTICAL : VIEW_STYLE_HORIZONTAL;
	        if (scrollContainerProps && scrollContainerProps.viewStyle) {
	          viewStyle = _objectSpread(_objectSpread({}, scrollContainerProps.viewStyle), viewStyle);
	        }
	        var style = {
	          maxHeight: '100%'
	        };
	        var scrollerStyle;
	        if (this.props.rtl) {
	          viewStyle.direction = 'rtl';
	          viewStyle.maxWidth = '';
	          style.alignItems = 'flex-end';
	          style.maxWidth = '100%';
	          scrollerStyle = {
	            alignItems: 'flex-end'
	          };
	        }
	        var prevChildren = finalChildren;
	        finalChildren = _react.default.createElement(_reactScrollContainerPro.default, {
	          applyCSSContainOnScroll: false,
	          style: style,
	          scrollerStyle: scrollerStyle,
	          emptyScrollOffset: 20,
	          getScrollerNodeClientSize: this.props.rtl ? this.getScrollerNodeClientSize : null,
	          className: "".concat(this.props.rootClassName, "__scroll-container"),
	          shouldAllowScrollbars: NO_SCROLLBARS,
	          dragToScroll: false,
	          nativeScroll: scrollContainerProps ? scrollContainerProps.nativeScroll !== undefined ? scrollContainerProps.nativeScroll : false : false,
	          viewStyle: viewStyle,
	          ref: this.refScrollContainer,
	          scrollerResizerProps: scrollerResizerProps,
	          onDidMount: this.onScrollContainerDidMount,
	          onWillUnmount: this.onScrollContainerWillUnmount,
	          onResize: scrollContainerProps && scrollContainerProps.onResize ? callAll(scrollContainerProps.onResize, this.rafUpdateScrollInfo) : this.rafUpdateScrollInfo,
	          children: prevChildren,
	          onContainerScroll: this.onContainerScroll,
	          theme: props.theme
	        });
	        if (this.props.rtl) {
	          finalChildren = [finalChildren, resizer];
	        }
	      }
	      return _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({}, (0, _cleanProps.default)(props, InovuaArrowScroller.propTypes)), {}, {
	        ref: this.setRootRef,
	        className: className,
	        alignItems: "start",
	        children: finalChildren
	      }));
	    }
	  }, {
	    key: "renderScroller",
	    value: function renderScroller(direction) {
	      var _this3 = this;
	      var _this$props = this.props,
	        scroller = _this$props.scroller,
	        vertical = _this$props.vertical,
	        rootClassName = _this$props.rootClassName,
	        nativeScroll = _this$props.nativeScroll;
	      if (!scroller) {
	        return null;
	      }
	      var arrowName = vertical ? direction == (this.props.rtl ? 1 : -1) ? 'up' : 'down' : direction == (this.props.rtl ? 1 : -1) ? 'left' : 'right';
	      var scrollInfo = this.scrollInfo;
	      var disabled = direction == -1 ? !scrollInfo.hasStartScroll : !scrollInfo.hasEndScroll;
	      var arrowRootClassName = "".concat(rootClassName, "__arrow");
	      var className = (0, _join.default)(arrowRootClassName, "".concat(arrowRootClassName, "--auto"), "".concat(arrowRootClassName, "--direction-").concat(arrowName), this.state.activeScroll == direction && "".concat(arrowRootClassName, "--active"), scroller === 'auto' && disabled && "".concat(arrowRootClassName, "--hidden"), scroller === 'auto' && !disabled && "".concat(arrowRootClassName, "--visible"), scroller === true && disabled && "".concat(arrowRootClassName, "--disabled"), nativeScroll && "".concat(arrowRootClassName, "--native-scroll"));
	      var onClick = !disabled && this.props.scrollOnClick ? this.handleClick.bind(this, direction) : null;
	      var onMouseDown = !disabled && (!this.props.scrollOnClick || _isMobile.default) ? this.startScroll.bind(this, direction) : null;
	      var onMouseEnter = !disabled && this.props.scrollOnMouseEnter ? this.startMouseOverScroll.bind(this, direction) : null;
	      var onMouseLeave = !this.props.scrollOnClick || _isMobile.default || this.props.scrollOnMouseEnter ? this.stopMouseOverScroll.bind(this, direction) : null;
	      var onDoubleClick = !disabled ? this.handleScrollMax.bind(this, direction) : null;
	      var scrollerName = direction == -1 ? 'start' : 'end';
	      var domProps = {
	        ref: function ref(_ref) {
	          _this3[scrollerName] = _ref;
	        },
	        key: "scroller-".concat(direction),
	        disabled: disabled,
	        className: className,
	        onClick: onClick,
	        onDoubleClick: onDoubleClick,
	        onMouseDown: !_isMobile.default ? onMouseDown : null,
	        onTouchStart: _isMobile.default ? onMouseDown : null,
	        onTouchEnd: _isMobile.default ? onMouseLeave : null,
	        onMouseEnter: !_isMobile.default ? onMouseEnter : null,
	        onMouseLeave: !_isMobile.default ? onMouseLeave : null,
	        children: this.renderArrowIcon(arrowName)
	      };
	      var result;
	      if (typeof this.props.renderScroller === 'function') {
	        result = this.props.renderScroller({
	          domProps: domProps,
	          direction: direction
	        });
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("div", _objectSpread({}, domProps));
	      }
	      return result;
	    }
	  }, {
	    key: "renderArrowIcon",
	    value: function renderArrowIcon(name) {
	      var props = this.props;
	      return _react.default.createElement(_Arrow.default, {
	        name: name,
	        size: props.arrowSize,
	        height: props.arrowHeight,
	        width: props.arrowWidth,
	        className: "".concat(this.props.rootClassName, "__arrow-icon")
	      });
	    }
	  }, {
	    key: "getOffsetSizeName",
	    value: function getOffsetSizeName() {
	      return this.props.vertical ? 'offsetHeight' : 'offsetWidth';
	    }
	  }, {
	    key: "getBorderAndPaddingSize",
	    value: function getBorderAndPaddingSize() {
	      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.root;
	      var side = arguments.length > 1 ? arguments[1] : undefined;
	      var computedStyle = getCompStyle(node);
	      var start;
	      var end;
	      if (this.props.vertical) {
	        start = pint(computedStyle.borderTopWidth) + pint(computedStyle.paddingTop);
	        end = pint(computedStyle.borderBottomWidth) + pint(computedStyle.paddingBottom);
	        return start + end;
	      } else {
	        start = pint(computedStyle.borderLeftWidth) + pint(computedStyle.paddingLeft);
	        end = pint(computedStyle.borderRightWidth) + pint(computedStyle.paddingRight);
	      }
	      return side ? side == 'start' ? start : end : start + end;
	    }
	  }, {
	    key: "getSizeName",
	    value: function getSizeName() {
	      return this.props.vertical ? 'height' : 'width';
	    }
	  }, {
	    key: "getAvailableSize",
	    value: function getAvailableSize() {
	      if (!this.root) {
	        return null;
	      }
	      var size = this.availableSize || (this.props.nativeScroll ? this.props.vertical ? this.scrollerTarget.scrollTopMax : this.scrollerTarget.scrollLeftMax : this.root[this.getOffsetSizeName()] - this.getBorderAndPaddingSize());
	      if (this.props.rtl && size < 0) {
	        size = -size;
	      }
	      this.availableSize = size;
	      return size;
	    }
	  }, {
	    key: "getCurrentListSize",
	    value: function getCurrentListSize() {
	      if (!this.strip.current) {
	        return null;
	      }
	      return this.currentListSize = this.currentListSize || this.strip.current[this.getOffsetSizeName()];
	    }
	  }, {
	    key: "handleResize",
	    value: function handleResize() {
	      if (!this.componentIsMounted) {
	        return;
	      }
	      delete this.currentListSize;
	      delete this.availableSize;
	      this.syncScroll({
	        force: true
	      });
	    }
	  }, {
	    key: "handleScrollMax",
	    value: function handleScrollMax(direction, event) {
	      var _this4 = this;
	      event.stopPropagation();
	      event.preventDefault();
	      var maxPos = direction == -1 ? 0 : this.scrollInfo.maxScrollPos;
	      raf(function () {
	        _this4.setScrollPosition(maxPos);
	      });
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(direction) {
	      var offset = this.getAvailableSize();
	      this.scrollBy(offset, direction);
	    }
	  }, {
	    key: "stopScroll",
	    value: function stopScroll() {
	      globalObject.clearInterval(this.scrollInterval);
	      this.setState({
	        scrolling: false,
	        activeScroll: 0
	      });
	    }
	  }, {
	    key: "rafUpdateScrollInfo",
	    value: function rafUpdateScrollInfo() {
	      raf(this.updateScrollInfo);
	    }
	  }, {
	    key: "updateScrollInfo",
	    value: function updateScrollInfo(count) {
	      var _this5 = this;
	      if (this.componentIsMounted === false) {
	        return;
	      }
	      var availableSize = this.getAvailableSize();
	      if (!availableSize) {
	        if (!count || count < 5) {
	          raf(function () {
	            _this5.updateScrollInfo((count || 0) + 1);
	          });
	          return;
	        }
	      }
	      var listSize = this.getCurrentListSize();
	      var scrollInfo = Object.assign(this.scrollInfo, {
	        availableSize: availableSize,
	        listSize: listSize
	      });
	      if (this.props.nativeScroll) {
	        if (this.scrollerTarget) {
	          scrollInfo.maxScrollPos = this.props.vertical ? this.scrollerTarget.scrollTopMax : this.scrollerTarget.scrollLeftMax;
	        }
	      } else {
	        if (listSize > availableSize) {
	          scrollInfo.maxScrollPos = listSize - availableSize;
	        } else {
	          scrollInfo.maxScrollPos = 0;
	        }
	      }
	      if (this.props.rtl && scrollInfo.maxScrollPos < 0) {
	        scrollInfo.maxScrollPos = -scrollInfo.maxScrollPos;
	      }
	      scrollInfo.hasStartScroll = scrollInfo.scrollPos != 0;
	      scrollInfo.hasEndScroll = scrollInfo.scrollPos < scrollInfo.maxScrollPos;
	      var hasScroll = listSize > availableSize;
	      if (hasScroll !== this.state.hasScroll) {
	        this.props.onHasScrollChange(hasScroll);
	      }
	      this.setState({
	        hasScroll: hasScroll
	      });
	    }
	  }, {
	    key: "startScroll",
	    value: function startScroll(direction, event) {
	      var _this6 = this;
	      var eventName = _isMobile.default ? 'touchend' : 'mouseup';
	      event.preventDefault();
	      var mouseUpListener = function mouseUpListener() {
	        _this6.stopScroll();
	        globalObject.removeEventListener(eventName, mouseUpListener);
	      };
	      globalObject.addEventListener(eventName, mouseUpListener);
	      this.scrollInterval = globalObject.setInterval(this.doScroll.bind(this, direction), this.props.scrollSpeed);
	      this.setState({
	        scrolling: true,
	        activeScroll: direction
	      });
	    }
	  }, {
	    key: "onContainerScroll",
	    value: function onContainerScroll(_ref2) {
	      var scrollTop = _ref2.scrollTop,
	        scrollLeft = _ref2.scrollLeft;
	      this.setScrollPosition(this.props.vertical ? scrollTop : scrollLeft, {
	        skip: true
	      });
	    }
	  }, {
	    key: "startMouseOverScroll",
	    value: function startMouseOverScroll(direction, event) {
	      event.preventDefault();
	      globalObject.clearInterval(this.mouseOverScrollInterval);
	      this.mouseOverScrollInterval = globalObject.setInterval(this.doScroll.bind(this, direction), this.props.mouseoverScrollSpeed);
	      this.setState({
	        scrolling: true,
	        activeScroll: direction
	      });
	    }
	  }, {
	    key: "stopMouseOverScroll",
	    value: function stopMouseOverScroll() {
	      this.stopScroll();
	      globalObject.clearInterval(this.mouseOverScrollInterval);
	    }
	  }, {
	    key: "setScrollPosition",
	    value: function setScrollPosition(scrollPos) {
	      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        force = _ref3.force,
	        skip = _ref3.skip;
	      if (!this.componentIsMounted) {
	        return;
	      }
	      var scrollInfo = this.scrollInfo;
	      if (scrollPos > scrollInfo.maxScrollPos) {
	        scrollPos = scrollInfo.maxScrollPos;
	      }
	      if (scrollPos < 0) {
	        scrollPos = 0;
	      }
	      if (scrollPos === scrollInfo.scrollPos && force !== true) {
	        return null;
	      }
	      Object.assign(scrollInfo, {
	        hasStartScroll: scrollPos !== 0,
	        hasEndScroll: scrollPos < scrollInfo.maxScrollPos,
	        scrollPos: scrollPos
	      });
	      if (!skip && this.props.nativeScroll && this.scrollerTarget) {
	        if (this.props.vertical) {
	          this.scrollerTarget.scrollTop = scrollPos;
	        } else {
	          this.scrollerTarget.scrollLeft = scrollPos;
	        }
	      }
	      this.setState({});
	    }
	  }, {
	    key: "syncScroll",
	    value: function syncScroll() {
	      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        force = _ref4.force;
	      this.updateScrollInfo();
	      this.doScroll(0, null, {
	        force: force
	      });
	    }
	  }, {
	    key: "scrollIntoView",
	    value: function scrollIntoView(domNode) {
	      var rootNode = this.root;
	      if (!domNode || !rootNode) {
	        return;
	      }
	      var rect = domNode.getBoundingClientRect();
	      var mainRect = rootNode.getBoundingClientRect();
	      var vertical = this.props.vertical;
	      var startSideName = vertical ? 'top' : 'left';
	      var endSideName = vertical ? 'bottom' : 'right';
	      var startDiff = rect[startSideName] - (mainRect[startSideName] + this.getBorderAndPaddingSize(undefined, 'start'));
	      var endDiff = rect[endSideName] - (mainRect[endSideName] - this.getBorderAndPaddingSize(undefined, 'end'));
	      var scrollIntoViewOffset = this.props.scrollIntoViewOffset;
	      if (startDiff < 0) {
	        this.doScroll(-startDiff + scrollIntoViewOffset, -1);
	      } else if (endDiff > 0) {
	        this.doScroll(endDiff + scrollIntoViewOffset, 1);
	      }
	    }
	  }, {
	    key: "doScroll",
	    value: function doScroll(direction, step) {
	      var _this7 = this;
	      var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	        force = _ref5.force;
	      var scrollInfo = this.scrollInfo;
	      var newScrollPos = scrollInfo.scrollPos + direction * (step || this.props.scrollStep);
	      raf(function () {
	        _this7.setScrollPosition(newScrollPos, {
	          force: force
	        });
	      });
	    }
	  }, {
	    key: "scrollBy",
	    value: function scrollBy(offset, direction) {
	      var _this8 = this;
	      var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	        force = _ref6.force;
	      var scrollInfo = this.scrollInfo;
	      var newScrollPos = scrollInfo.scrollPos + direction * offset;
	      raf(function () {
	        _this8.setScrollPosition(newScrollPos, {
	          force: force
	        });
	      });
	    }
	  }]);
	  return InovuaArrowScroller;
	}(_react.Component);
	var emptyFn = function emptyFn() {};
	InovuaArrowScroller.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-arrow-scroller',
	  scroller: 'auto',
	  scrollStep: 15,
	  mouseoverScrollSpeed: 40,
	  scrollSpeed: 10,
	  scrollSpringConfig: {
	    stiffness: 370,
	    damping: 60
	  },
	  scrollIntoViewOffset: 1,
	  vertical: false,
	  scrollOnClick: false,
	  nativeScroll: !_ua.IS_IE,
	  scrollOnMouseEnter: true,
	  rtl: false,
	  useTransformOnScroll: false,
	  onHasScrollChange: emptyFn,
	  theme: 'default-light'
	};
	InovuaArrowScroller.propTypes = {
	  arrowSize: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    width: _propTypes.default.number,
	    height: _propTypes.default.number
	  })]),
	  theme: _propTypes.default.string,
	  scrollOnClick: _propTypes.default.bool,
	  childProps: _propTypes.default.object,
	  scrollOnMouseEnter: _propTypes.default.bool,
	  vertical: _propTypes.default.bool,
	  notifyResizeDelay: _propTypes.default.number,
	  scrollStep: _propTypes.default.number,
	  scrollSpeed: _propTypes.default.number,
	  mouseoverScrollSpeed: _propTypes.default.number,
	  scrollSpringConfig: _propTypes.default.shape({
	    stiffness: _propTypes.default.number,
	    damping: _propTypes.default.number
	  }),
	  nativeScroll: _propTypes.default.bool,
	  scrollIntoViewOffset: _propTypes.default.number,
	  scroller: _propTypes.default.oneOf(['auto', false, true]),
	  rootClassName: _propTypes.default.string,
	  rtl: _propTypes.default.bool,
	  scrollContainerProps: _propTypes.default.object,
	  useTransformOnScroll: _propTypes.default.bool,
	  onHasScrollChange: _propTypes.default.func,
	  renderScroller: _propTypes.default.func
	};
	var _default = InovuaArrowScroller;
	exports.default = _default;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _ArrowScroller = _interopRequireDefault(__webpack_require__(621));
	var _default = _ArrowScroller.default;
	exports.default = _default;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _prepareClassName = _interopRequireDefault(__webpack_require__(625));
	var _uglified = _interopRequireDefault(__webpack_require__(57));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var InovuaButton = function (_Component) {
	  (0, _inherits2.default)(InovuaButton, _Component);
	  var _super = _createSuper(InovuaButton);
	  function InovuaButton(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaButton);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps, prevState) {
	      if (!prevProps.disabled && _this.props.disabled && prevState.focused) {
	        _this.handleBlur();
	        _this.setState({
	          mouseOver: false
	        });
	      }
	      if (prevProps.disabled && !_this.props.disabled && _this.state.focused) {
	        _this.handleBlur();
	      }
	    });
	    _this.state = {
	      mouseOver: false,
	      active: false,
	      pressed: _this.props.defaultPressed
	    };
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleMouseEnter = _this.handleMouseEnter.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleMouseLeave = _this.handleMouseLeave.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getRootRef = function (ref) {
	      _this.rootNode = ref;
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaButton, [{
	    key: "handleKeyDown",
	    value: function handleKeyDown(event) {
	      var key = event.key;
	      if (this.tagName != 'button' && key == 'Enter') {
	        this.props.onClick(event);
	        event.preventDefault();
	      }
	      if (this.props.onKeyDown) {
	        this.props.onKeyDown(event);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var buttonStates = this.getButtonStates();
	      var style = this.prepareStyle(this.props, buttonStates);
	      var className = (0, _prepareClassName.default)(buttonStates, props);
	      var domProps = _objectSpread(_objectSpread({}, (0, _cleanProps.default)(this.props, InovuaButton.propTypes)), {}, {
	        style: style,
	        className: className,
	        onClick: this.handleClick,
	        onKeyDown: this.handleKeyDown,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        href: props.href
	      });
	      var topBottomVerticalAlign = this.props.verticalAlign == 'top' || this.props.verticalAlign == 'bottom';
	      var avoidButtonTag = !!this.props.icon || topBottomVerticalAlign;
	      var TagName = this.props.tagName;
	      if (!TagName && !avoidButtonTag) {
	        TagName = 'button';
	      }
	      if (TagName == 'button' && avoidButtonTag) {
	        if (this.props.showWarnings && console && console.warn) {
	          console.warn('Button html tags are not fully compatible with flexbox, so we\'re rendering a "div" instead. See http://stackoverflow.com/questions/35464067/flexbox-not-working-on-button-element-in-some-browsers for details.');
	        }
	      }
	      if (props.href) {
	        TagName = 'a';
	      }
	      TagName = TagName || 'div';
	      this.tagName = TagName;
	      if (TagName === 'div' && domProps.tabIndex === undefined && !this.props.disabled) {
	        domProps.tabIndex = 0;
	      }
	      return _react.default.createElement(TagName, _objectSpread(_objectSpread({}, domProps), {}, {
	        ref: this.getRootRef,
	        children: this.prepareChildren(props, buttonStates)
	      }));
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(event) {
	      if (this.props.disabled) {
	        return;
	      }
	      this.setState({
	        focused: true
	      });
	      this.props.onFocus(event);
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(event) {
	      this.setState({
	        focused: false
	      });
	      this.props.onBlur(event);
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      var props = this.props;
	      if (props.disabled) {
	        event.preventDefault();
	        event.stopPropagation();
	        return;
	      }
	      if (this.isToggleButon()) {
	        this.toggle();
	      }
	      this.props.onClick(event);
	    }
	  }, {
	    key: "isToggleButon",
	    value: function isToggleButon() {
	      return this.isPressed() !== undefined;
	    }
	  }, {
	    key: "toggle",
	    value: function toggle() {
	      var isPressed = this.isPressed();
	      var newPressed = !isPressed;
	      if (!this.isPressedControlled()) {
	        this.setState({
	          pressed: newPressed
	        });
	      }
	      this.props.onToggle(newPressed);
	    }
	  }, {
	    key: "isToggleButton",
	    value: function isToggleButton() {
	      return this.props.defaultPressed !== null || this.props.pressed !== null;
	    }
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(event) {
	      var props = this.props;
	      if (props.disabled) {
	        return;
	      }
	      this.setState({
	        mouseOver: true
	      });
	      this.props.onMouseEnter(event);
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(event) {
	      var props = this.props;
	      if (props.disabled) {
	        return;
	      }
	      this.setState({
	        mouseOver: false
	      });
	      this.props.onMouseLeave(event);
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp(event) {
	      var props = this.props;
	      if (props.disabled) {
	        return;
	      }
	      this.setState({
	        active: false
	      });
	      globalObject.removeEventListener('mouseup', this.handleMouseUp);
	      props.onMouseUp(event);
	      props.onDeactivate(event);
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(event) {
	      var props = this.props;
	      if (props.disabled) {
	        return;
	      }
	      this.setState({
	        active: true
	      });
	      globalObject.addEventListener('mouseup', this.handleMouseUp);
	      props.onMouseDown(event);
	      props.onActivate(event);
	    }
	  }, {
	    key: "isIconFirst",
	    value: function isIconFirst() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var iconPosition = props.iconPosition,
	        rtl = props.rtl;
	      var iconFirst = iconPosition == 'left' && !rtl || iconPosition == 'top' || rtl && iconPosition == 'start' || rtl && iconPosition == 'right' || !rtl && iconPosition == 'start';
	      return iconFirst;
	    }
	  }, {
	    key: "prepareChildren",
	    value: function prepareChildren(props, buttonStates) {
	      var _this2 = this;
	      var children = props.children;
	      children = _react.default.createElement("div", {
	        key: "text",
	        className: "".concat(this.props.rootClassName, "__text"),
	        children: children
	      });
	      var icon = this.props.icon;
	      var rtl = this.props.rtl;
	      if (icon) {
	        var iconPosition = this.props.iconPosition;
	        var iconFirst = this.isIconFirst(this.props);
	        if (typeof icon == 'function') {
	          icon = icon(buttonStates);
	        }
	        var wrapIcon = function wrapIcon(icon) {
	          return _react.default.createElement("div", {
	            key: "iconWrapper",
	            className: "".concat(_this2.props.rootClassName, "__icon-wrap") + (_this2.props.disabled ? " ".concat(_this2.props.rootClassName, "__icon-wrap--disabled") : ''),
	            children: icon
	          });
	        };
	        if (iconFirst) {
	          children = [wrapIcon(icon), children];
	        } else {
	          children = [children, wrapIcon(icon)];
	        }
	      }
	      if (this.props.renderChildren) {
	        children = this.props.renderChildren(children);
	      }
	      return children;
	    }
	  }, {
	    key: "getButtonStates",
	    value: function getButtonStates(props) {
	      props = props || this.props;
	      return {
	        disabled: props.disabled,
	        children: props.children,
	        active: this.isActive(),
	        pressed: this.isPressed(),
	        over: this.isOver(),
	        focused: this.isFocused(),
	        iconFirst: this.isIconFirst(),
	        rtl: this.props.rtl,
	        icon: this.props.icon,
	        ellipsis: props.ellipsis,
	        align: props.align,
	        verticalAlign: props.verticalAlign,
	        wrap: props.wrap,
	        overflow: props.overflow,
	        iconPosition: this.props.icon ? this.props.iconPosition : undefined
	      };
	    }
	  }, {
	    key: "prepareStyle",
	    value: function prepareStyle() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var buttonStates = arguments.length > 1 ? arguments[1] : undefined;
	      var style = typeof props.style !== 'function' ? (0, _assign.default)({}, props.style) : props.style(props, buttonStates);
	      if (props.disabled) {
	        (0, _assign.default)(style, props.disabledStyle);
	      } else {
	        if (this.isPressed()) {
	          (0, _assign.default)(style, props.pressedStyle);
	        }
	        if (this.isFocused()) {
	          (0, _assign.default)(style, props.focusedStyle);
	        }
	        if (this.isOver()) {
	          (0, _assign.default)(style, props.overStyle);
	        }
	        if (this.isActive()) {
	          (0, _assign.default)(style, this.props.activeStyle);
	        }
	      }
	      return style;
	    }
	  }, {
	    key: "isActive",
	    value: function isActive() {
	      return this.props.activeState == null ? !!this.state.active : this.props.activeState;
	    }
	  }, {
	    key: "isOver",
	    value: function isOver() {
	      return this.props.overState == null ? !!this.state.mouseOver : this.props.overState;
	    }
	  }, {
	    key: "isFocused",
	    value: function isFocused() {
	      return this.props.focusedState == null ? !!this.state.focused : this.props.focusedState;
	    }
	  }, {
	    key: "isPressedControlled",
	    value: function isPressedControlled() {
	      return this.props.pressed != null;
	    }
	  }, {
	    key: "isPressed",
	    value: function isPressed() {
	      return this.isPressedControlled() ? this.props.pressed : this.state.pressed;
	    }
	  }, {
	    key: "getRootNode",
	    value: function getRootNode() {
	      return this.rootNode;
	    }
	  }]);
	  return InovuaButton;
	}(_react.Component);
	function emptyFn() {}
	InovuaButton.defaultProps = {
	  isInovuaButton: true,
	  theme: 'default-light',
	  rootClassName: 'inovua-react-toolkit-button',
	  align: 'center',
	  verticalAlign: 'middle',
	  ellipsis: true,
	  href: null,
	  iconPosition: 'start',
	  onFocus: emptyFn,
	  onBlur: emptyFn,
	  onToggle: emptyFn,
	  onClick: emptyFn,
	  onMouseEnter: emptyFn,
	  onMouseUp: emptyFn,
	  onMouseDown: emptyFn,
	  onDeactivate: emptyFn,
	  onMouseLeave: emptyFn,
	  onActivate: emptyFn,
	  showWarnings: !_uglified.default
	};
	InovuaButton.propTypes = {
	  isInovuaButton: _propTypes.default.bool,
	  tagName: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	  primary: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  pressed: _propTypes.default.bool,
	  defaultPressed: _propTypes.default.bool,
	  href: _propTypes.default.string,
	  align: _propTypes.default.oneOf(['start', 'end', 'center', 'left', 'right']),
	  verticalAlign: _propTypes.default.oneOf(['top', 'middle', 'center', 'bottom']),
	  rtl: _propTypes.default.bool,
	  wrap: _propTypes.default.bool,
	  overflow: _propTypes.default.bool,
	  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	  iconPosition: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right', 'start', 'end']),
	  style: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	  disabledStyle: _propTypes.default.object,
	  focusedStyle: _propTypes.default.object,
	  pressedStyle: _propTypes.default.object,
	  overStyle: _propTypes.default.object,
	  activeStyle: _propTypes.default.object,
	  className: _propTypes.default.string,
	  activeClassName: _propTypes.default.string,
	  overClassName: _propTypes.default.string,
	  focusedClassName: _propTypes.default.string,
	  disabledClassName: _propTypes.default.string,
	  pressedClassName: _propTypes.default.string,
	  theme: _propTypes.default.string,
	  rootClassName: _propTypes.default.string,
	  ellipsis: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  onFocus: _propTypes.default.func,
	  onBlur: _propTypes.default.func,
	  onToggle: _propTypes.default.func,
	  onMouseEnter: _propTypes.default.func,
	  onMouseUp: _propTypes.default.func,
	  onMouseDown: _propTypes.default.func,
	  onDeactivate: _propTypes.default.func,
	  onMouseLeave: _propTypes.default.func,
	  onActivate: _propTypes.default.func,
	  showWarnings: _propTypes.default.bool
	};
	var _default = InovuaButton;
	exports.default = _default;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _Button = _interopRequireDefault(__webpack_require__(623));
	var _default = _Button.default;
	exports.default = _default;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _join = _interopRequireDefault(__webpack_require__(20));
	function prepareClassName() {
	  var states = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var classNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var disabled = states.disabled,
	    icon = states.icon,
	    active = states.active,
	    pressed = states.pressed,
	    over = states.over,
	    children = states.children,
	    focused = states.focused,
	    iconFirst = states.iconFirst,
	    rtl = states.rtl,
	    ellipsis = states.ellipsis,
	    align = states.align,
	    verticalAlign = states.verticalAlign,
	    wrap = states.wrap,
	    overflow = states.overflow,
	    iconPosition = states.iconPosition;
	  var className = classNames.className,
	    rootClassName = classNames.rootClassName,
	    disabledClassName = classNames.disabledClassName,
	    activeClassName = classNames.activeClassName,
	    pressedClassName = classNames.pressedClassName,
	    overClassName = classNames.overClassName,
	    focusedClassName = classNames.focusedClassName,
	    theme = classNames.theme;
	  var preparedClassname = (0, _join.default)(className, rootClassName, theme && "".concat(rootClassName, "--theme-").concat(theme), disabled && disabledClassName, disabled && "".concat(rootClassName, "--disabled"), active && activeClassName, active && "".concat(rootClassName, "--active"), pressed && pressedClassName, pressed && "".concat(rootClassName, "--pressed"), over && overClassName, over && "".concat(rootClassName, "--over"), focused && focusedClassName, focused && "".concat(rootClassName, "--focused"), rtl ? "".concat(rootClassName, "--rtl") : "".concat(rootClassName, "--ltr"), ellipsis && "".concat(rootClassName, "--ellipsis"), align && "".concat(rootClassName, "--align-").concat(align), !children && "".concat(rootClassName, "--no-children"), verticalAlign && "".concat(rootClassName, "--vertical-align-").concat(verticalAlign), overflow === true && "".concat(rootClassName, "--overflow-visible"), overflow === false && "".concat(rootClassName, "--overflow-hidden"), wrap === true && "".concat(rootClassName, "--wrap"), wrap === false && "".concat(rootClassName, "--nowrap"), icon && "".concat(rootClassName, "--has-icon"), iconPosition && "".concat(rootClassName, "--icon-position-").concat(iconPosition), iconFirst ? "".concat(rootClassName, "--icon-first") : "".concat(rootClassName, "--icon-last"));
	  return preparedClassname;
	}
	var _default = prepareClassName;
	exports.default = _default;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Calendar", {
	  enumerable: true,
	  get: function get() {
	    return _Calendar.default;
	  }
	});
	Object.defineProperty(exports, "Clock", {
	  enumerable: true,
	  get: function get() {
	    return _Clock.default;
	  }
	});
	Object.defineProperty(exports, "ClockInput", {
	  enumerable: true,
	  get: function get() {
	    return _ClockInput.default;
	  }
	});
	exports.DateEditor = void 0;
	Object.defineProperty(exports, "DateFormatInput", {
	  enumerable: true,
	  get: function get() {
	    return _DateFormatInput.default;
	  }
	});
	Object.defineProperty(exports, "DateFormatSpinnerInput", {
	  enumerable: true,
	  get: function get() {
	    return _DateFormatSpinnerInput.default;
	  }
	});
	Object.defineProperty(exports, "DateInput", {
	  enumerable: true,
	  get: function get() {
	    return _DateInput.default;
	  }
	});
	Object.defineProperty(exports, "DecadeView", {
	  enumerable: true,
	  get: function get() {
	    return _DecadeView.default;
	  }
	});
	Object.defineProperty(exports, "Footer", {
	  enumerable: true,
	  get: function get() {
	    return _Footer.default;
	  }
	});
	Object.defineProperty(exports, "MonthDecadeView", {
	  enumerable: true,
	  get: function get() {
	    return _MonthDecadeView.default;
	  }
	});
	Object.defineProperty(exports, "MonthView", {
	  enumerable: true,
	  get: function get() {
	    return _MonthView.default;
	  }
	});
	Object.defineProperty(exports, "MultiMonthView", {
	  enumerable: true,
	  get: function get() {
	    return _MultiMonthView.default;
	  }
	});
	Object.defineProperty(exports, "NavBar", {
	  enumerable: true,
	  get: function get() {
	    return _NavBar.default;
	  }
	});
	Object.defineProperty(exports, "TimeInput", {
	  enumerable: true,
	  get: function get() {
	    return _TimeInput.default;
	  }
	});
	Object.defineProperty(exports, "TimePicker", {
	  enumerable: true,
	  get: function get() {
	    return _TimePicker.default;
	  }
	});
	Object.defineProperty(exports, "TransitionView", {
	  enumerable: true,
	  get: function get() {
	    return _TransitionView.default;
	  }
	});
	Object.defineProperty(exports, "YearView", {
	  enumerable: true,
	  get: function get() {
	    return _YearView.default;
	  }
	});
	exports.default = void 0;
	var _MonthView = _interopRequireDefault(__webpack_require__(108));
	var _TimePicker = _interopRequireDefault(__webpack_require__(636));
	var _TimeInput = _interopRequireDefault(__webpack_require__(153));
	var _TransitionView = _interopRequireDefault(__webpack_require__(637));
	var _MultiMonthView = _interopRequireDefault(__webpack_require__(631));
	var _MonthDecadeView = _interopRequireDefault(__webpack_require__(232));
	var _YearView = _interopRequireDefault(__webpack_require__(236));
	var _DecadeView = _interopRequireDefault(__webpack_require__(151));
	var _NavBar = _interopRequireDefault(__webpack_require__(109));
	var _Footer = _interopRequireDefault(__webpack_require__(152));
	var _Clock = _interopRequireDefault(__webpack_require__(106));
	var _ClockInput = _interopRequireDefault(__webpack_require__(230));
	var _DateInput = _interopRequireDefault(__webpack_require__(630));
	var _Calendar = _interopRequireDefault(__webpack_require__(229));
	var _DateFormatInput = _interopRequireDefault(__webpack_require__(150));
	var _DateFormatSpinnerInput = _interopRequireDefault(__webpack_require__(231));
	var _default = _Calendar.default;
	exports.default = _default;
	var DateEditor = _DateInput.default;
	exports.DateEditor = DateEditor;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFormats = exports.default = void 0;
	var _leftPad = _interopRequireDefault(__webpack_require__(154));
	var _clamp = _interopRequireDefault(__webpack_require__(238));
	var _times = _interopRequireDefault(__webpack_require__(111));
	var isValid = function isValid(value, format) {
	  value *= 1;
	  return value >= format.min && value <= format.max;
	};
	var replaceAt = function replaceAt(_ref) {
	  var value = _ref.value,
	    index = _ref.index,
	    _ref$len = _ref.len,
	    len = _ref$len === void 0 ? 1 : _ref$len,
	    str = _ref.str;
	  return value.substring(0, index) + str + value.substring(index + len);
	};
	var handleArrow = function handleArrow(format, _ref2) {
	  var currentValue = _ref2.currentValue,
	    key = _ref2.key,
	    dir = _ref2.dir;
	  dir = dir || (key == 'ArrowUp' ? 1 : -1);
	  return {
	    value: (0, _clamp.default)(currentValue * 1 + dir, {
	      min: format.min,
	      max: format.max,
	      circular: true
	    }),
	    caretPos: true
	  };
	};
	var handleArrowLeftPad = function handleArrowLeftPad(format, config) {
	  var _handleArrow = handleArrow(format, config),
	    value = _handleArrow.value,
	    caretPos = _handleArrow.caretPos;
	  return {
	    value: (0, _leftPad.default)(value),
	    caretPos: caretPos
	  };
	};
	var handlePage = function handlePage(format, config) {
	  config.dir = config.dir || (config.key == 'PageUp' ? 10 : -10);
	  return handleArrow(format, config);
	};
	var handlePageLeftPad = function handlePageLeftPad(format, config) {
	  config.dir = config.dir || (config.key == 'PageUp' ? 10 : -10);
	  return handleArrowLeftPad(format, config);
	};
	var handleUpdate = function handleUpdate(value, format, _ref3) {
	  var range = _ref3.range;
	  value *= 1;
	  var len = range.end - range.start + 1;
	  var pow10 = "1".concat((0, _times.default)(3 - len).map(function () {
	    return '0';
	  }).join('')) * 1;
	  var modLen = value % pow10;
	  var newValue = (0, _clamp.default)(value, {
	    min: format.min,
	    max: format.max,
	    circular: false
	  });
	  if (pow10 > 1 && value % pow10 == 0) {
	    newValue += modLen;
	    newValue = (0, _clamp.default)(newValue, {
	      min: format.min,
	      max: format.max,
	      circular: false
	    });
	  }
	  return newValue;
	};
	var handleUnidentified = function handleUnidentified(format, _ref4) {
	  var event = _ref4.event,
	    currentValue = _ref4.currentValue,
	    range = _ref4.range;
	  var newChar = String.fromCharCode(event.which);
	  var index = range.start - format.start;
	  var caretPos = {
	    start: range.start + 1
	  };
	  if (newChar * 1 != newChar) {
	    return {
	      preventDefault: false,
	      value: currentValue
	    };
	  }
	  var value;
	  var valid;
	  value = replaceAt({
	    value: currentValue,
	    index: index,
	    str: newChar
	  });
	  valid = isValid(value, format);
	  if (!valid && index == 0 && newChar == "".concat(format.max)[0]) {
	    valid = true;
	    value = format.max;
	    caretPos.start++;
	  }
	  if (!valid) {
	    do {
	      value = (0, _times.default)(index).map(function () {
	        return '0';
	      }).join('') + replaceAt({
	        value: currentValue,
	        index: index,
	        str: newChar
	      }).substring(index);
	      valid = isValid(value, format);
	      index++;
	      if (!valid) {
	        caretPos.start++;
	      }
	    } while (!valid && index <= format.end);
	  }
	  if (valid) {
	    value = handleUpdate(value, format, {
	      range: range
	    });
	  } else {
	    var defaultValue = format.default;
	    value = 1 * replaceAt({
	      value: defaultValue,
	      index: defaultValue.length - 1,
	      str: newChar
	    });
	    if (isValid(value, format)) {
	      caretPos.start = format.start + defaultValue.length;
	    } else {
	      caretPos.start = range.start + 1;
	      value = currentValue;
	    }
	  }
	  return {
	    value: value,
	    caretPos: caretPos
	  };
	};
	var handleUnidentifiedLeftPad = function handleUnidentifiedLeftPad(format, config) {
	  var _handleUnidentified = handleUnidentified(format, config),
	    value = _handleUnidentified.value,
	    caretPos = _handleUnidentified.caretPos,
	    preventDefault = _handleUnidentified.preventDefault;
	  return {
	    value: (0, _leftPad.default)(value),
	    caretPos: caretPos,
	    preventDefault: preventDefault
	  };
	};
	var handleYearUnidentified = handleUnidentified;
	var handleDelete = function handleDelete(format, _ref5) {
	  var range = _ref5.range,
	    currentValue = _ref5.currentValue,
	    dir = _ref5.dir;
	  dir = dir || 0;
	  if (range.start <= format.start && range.end >= format.end) {
	    return {
	      value: format.default,
	      caretPos: true
	    };
	  }
	  var len = range.end - range.start + 1;
	  var str = (0, _times.default)(len).map(function () {
	    return '0';
	  }).join('');
	  var index = range.start - format.start + dir;
	  var value = replaceAt({
	    value: currentValue,
	    index: index,
	    str: str,
	    len: len
	  }) * 1;
	  value = (0, _leftPad.default)(handleUpdate(value, format, {
	    range: range
	  }));
	  return {
	    value: value,
	    caretPos: {
	      start: range.start + (dir < 0 ? -1 : 1)
	    }
	  };
	};
	var handleBackspace = function handleBackspace(format, config) {
	  config.dir = -1;
	  return handleDelete(format, config);
	};
	var toggleMeridiem = function toggleMeridiem(_ref6) {
	  var upper = _ref6.upper,
	    value = _ref6.value;
	  if (upper) {
	    return value == 'AM' ? 'PM' : 'AM';
	  }
	  return value == 'am' ? 'pm' : 'am';
	};
	var handleMeridiemArrow = function handleMeridiemArrow(format, _ref7) {
	  var currentValue = _ref7.currentValue;
	  return {
	    value: toggleMeridiem({
	      upper: format.upper,
	      value: currentValue
	    }),
	    caretPos: true
	  };
	};
	var handleMeridiemDelete = function handleMeridiemDelete(format, _ref8) {
	  var dir = _ref8.dir,
	    range = _ref8.range;
	  dir = dir || 0;
	  if (range.start <= format.start && range.end >= format.end) {
	    return {
	      value: format.default,
	      caretPos: true
	    };
	  }
	  return {
	    value: format.upper ? 'AM' : 'am',
	    caretPos: {
	      start: range.start + (dir < 0 ? -1 : 1)
	    }
	  };
	};
	var handleMeridiemBackspace = function handleMeridiemBackspace(format, config) {
	  config.dir = -1;
	  return handleMeridiemDelete(format, config);
	};
	var getFormats = function getFormats() {
	  return {
	    YYYY: {
	      min: 100,
	      max: 9999,
	      default: '0100',
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleArrow: handleArrow,
	      handlePageUp: handlePage,
	      handlePageDown: handlePage,
	      handleUnidentified: handleYearUnidentified
	    },
	    MM: {
	      min: 1,
	      max: 12,
	      default: '01',
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad
	    },
	    DD: {
	      min: 1,
	      max: 31,
	      default: '01',
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad,
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad
	    },
	    HH: {
	      time: true,
	      min: 0,
	      max: 23,
	      default: '00',
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad
	    },
	    H: {
	      time: true,
	      min: 0,
	      max: 23,
	      default: '0',
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad
	    },
	    kk: {
	      time: true,
	      min: 1,
	      max: 24,
	      default: '01',
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad
	    },
	    k: {
	      time: true,
	      min: 1,
	      max: 24,
	      default: '1',
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad
	    },
	    hh: {
	      min: 1,
	      max: 12,
	      default: '01',
	      time: true,
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad
	    },
	    h: {
	      min: 1,
	      max: 12,
	      default: '1',
	      time: true,
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad
	    },
	    a: {
	      time: true,
	      length: 2,
	      default: 'am',
	      handleArrow: handleMeridiemArrow,
	      handlePageUp: handleMeridiemArrow,
	      handlePageDown: handleMeridiemArrow,
	      handleDelete: handleMeridiemDelete,
	      handleBackspace: handleMeridiemBackspace
	    },
	    A: {
	      length: 2,
	      time: true,
	      default: 'AM',
	      upper: true,
	      handleArrow: handleMeridiemArrow,
	      handlePageUp: handleMeridiemArrow,
	      handlePageDown: handleMeridiemArrow,
	      handleDelete: handleMeridiemDelete,
	      handleBackspace: handleMeridiemBackspace
	    },
	    mm: {
	      min: 0,
	      max: 59,
	      default: '00',
	      time: true,
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad
	    },
	    ss: {
	      time: true,
	      min: 0,
	      max: 59,
	      default: '00',
	      handleDelete: handleDelete,
	      handleBackspace: handleBackspace,
	      handleUnidentified: handleUnidentifiedLeftPad,
	      handleArrow: handleArrowLeftPad,
	      handlePageUp: handlePageLeftPad,
	      handlePageDown: handlePageLeftPad
	    }
	  };
	};
	exports.getFormats = getFormats;
	var _default = getFormats();
	exports.default = _default;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _formats = _interopRequireDefault(__webpack_require__(627));
	var SUGGESTIONS = {
	  Y: ['YYYY', 'YY'],
	  M: ['MM'],
	  D: ['DD'],
	  H: ['HH'],
	  h: ['hh'],
	  k: ['kk'],
	  m: ['mm'],
	  s: ['ss']
	};
	var _default = function _default(format) {
	  var index = 0;
	  var positionIndex = 0;
	  var suggestions;
	  var suggestionMatch;
	  var positions = [];
	  var matches = [];
	  while (index < format.length) {
	    var char = format[index];
	    var match = _formats.default[char];
	    var matchObject = void 0;
	    suggestionMatch = null;
	    suggestions = SUGGESTIONS[char];
	    if (!match && !suggestions) {
	      positions[positionIndex] = char;
	      matches.push(char);
	    } else {
	      if (suggestions && suggestions.length) {
	        suggestionMatch = suggestions.filter(function (s) {
	          return format.substr(index, s.length) == s;
	        })[0];
	      }
	      if (!suggestionMatch) {
	        if (!_formats.default[char]) {
	          console.warn("Format ".concat(char, " is not supported yet!"));
	          if (suggestions) {
	            console.warn("Use one of [\"".concat(suggestions.join(','), "\"]"));
	          }
	          positions[positionIndex] = char;
	          matches.push(char);
	        } else {
	          var currentFormat = _formats.default[char];
	          var start = positionIndex;
	          var end = positionIndex + (currentFormat.length || 1) - 1;
	          matchObject = (0, _assign.default)({}, currentFormat, {
	            format: char,
	            start: start,
	            end: end
	          });
	          for (; start <= end; start++) {
	            positions[positionIndex] = matchObject;
	            positionIndex++;
	          }
	          index++;
	          matches.push(matchObject);
	          continue;
	        }
	      } else {
	        matchObject = (0, _assign.default)({}, _formats.default[suggestionMatch], {
	          format: suggestionMatch,
	          start: positionIndex
	        });
	        matches.push(matchObject);
	        var endIndex = positionIndex + suggestionMatch.length;
	        matchObject.end = endIndex - 1;
	        while (positionIndex < endIndex) {
	          positions[positionIndex] = matchObject;
	          positionIndex++;
	          index++;
	        }
	        continue;
	      }
	    }
	    positionIndex++;
	    index++;
	  }
	  return {
	    positions: positions,
	    matches: matches
	  };
	};
	exports.default = _default;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CLEAR_ICON = exports.CALENDAR_ICON = void 0;
	var _react = _interopRequireDefault(__webpack_require__(2));
	var CLEAR_ICON = _react.default.createElement("svg", {
	  height: "10",
	  width: "10",
	  viewBox: "4 4 16 16"
	}, _react.default.createElement("path", {
	  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
	}));
	exports.CLEAR_ICON = CLEAR_ICON;
	var CALENDAR_ICON = _react.default.createElement("svg", {
	  width: "16",
	  height: "16",
	  viewBox: "0 0 16 16"
	}, _react.default.createElement("g", {
	  fillRule: "evenodd"
	}, _react.default.createElement("path", {
	  fillRule: "nonzero",
	  d: "M8.304 13.527H6.17l2.327-4.72H5.538V7.384h4.914v.95l-2.148 5.192zM4.308 3.077c-.34 0-.616-.276-.616-.615V.615c0-.339.277-.615.616-.615.339 0 .615.276.615.615v1.847c0 .339-.276.615-.615.615z"
	}), _react.default.createElement("path", {
	  fillRule: "nonzero",
	  d: "M14.154 1.23h-1.23v1.232c0 .679-.552 1.23-1.232 1.23-.68 0-1.23-.551-1.23-1.23V1.23H5.538v1.23c0 .68-.55 1.231-1.23 1.231-.68 0-1.231-.551-1.231-1.23V1.23h-1.23C.826 1.23 0 2.058 0 3.077v11.077C0 15.173.827 16 1.846 16h12.308C15.173 16 16 15.173 16 14.154V3.077c0-1.02-.827-1.846-1.846-1.846zm.615 12.924c0 .339-.276.615-.615.615H1.846c-.339 0-.615-.276-.615-.615V5.538h13.538v8.616z"
	}), _react.default.createElement("path", {
	  d: "M11.692 3.077c-.339 0-.615-.276-.615-.615V.615c0-.339.276-.615.615-.615.34 0 .616.276.616.615v1.847c0 .339-.277.615-.616.615z"
	})));
	exports.CALENDAR_ICON = CALENDAR_ICON;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _moment = _interopRequireDefault(__webpack_require__(3));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _Flex = __webpack_require__(41);
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _Field = _interopRequireDefault(__webpack_require__(244));
	var _DateFormatInput = _interopRequireDefault(__webpack_require__(150));
	var _InlineBlock = _interopRequireDefault(__webpack_require__(107));
	var _Overlay = _interopRequireDefault(__webpack_require__(254));
	var _icons = __webpack_require__(629);
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _toMoment2 = _interopRequireDefault(__webpack_require__(40));
	var _Calendar = _interopRequireWildcard(__webpack_require__(229));
	var _joinFunctions = _interopRequireDefault(__webpack_require__(82));
	var _assignDefined = _interopRequireDefault(__webpack_require__(62));
	var _forwardTime = _interopRequireDefault(__webpack_require__(110));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var POSITIONS = {
	  top: 'top',
	  bottom: 'bottom'
	};
	var defaultOverlayProps = {
	  updatePositionOnScroll: true,
	  rootClassName: 'inovua-react-toolkit-date-input__overlay',
	  positions: ['tl-bl', 'bl-tl'],
	  offset: 2,
	  theme: null,
	  visible: true
	};
	var getPicker = function getPicker(props) {
	  var calendarProps = props.calendarProps;
	  return _react.default.Children.toArray(props.children).filter(function (c) {
	    return c && c.props && c.props.isDatePicker;
	  })[0] || _react.default.createElement(_Calendar.default, _objectSpread({}, calendarProps));
	};
	var FIND_INPUT = function FIND_INPUT(c) {
	  return c && (c.type === 'input' || c.props && c.isDateInput);
	};
	var preventDefault = function preventDefault(event) {
	  event.preventDefault();
	};
	var DateInput = function (_Component) {
	  (0, _inherits2.default)(DateInput, _Component);
	  var _super = _createSuper(DateInput);
	  function DateInput(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, DateInput);
	    _this = _super.call(this, props);
	    _this.state = {
	      viewDate: props.viewDate || props.defaultViewDate,
	      value: props.defaultValue === undefined ? '' : props.defaultValue,
	      expanded: props.defaultExpanded || false,
	      focused: false
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(DateInput, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.unmounted = false;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unmounted = true;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.prepareProps(this.props);
	      var flexProps = (0, _assign.default)({}, props);
	      delete flexProps.activeDate;
	      delete flexProps.rootClassName;
	      delete flexProps.cleanup;
	      delete flexProps.clearIcon;
	      delete flexProps.cancelButton;
	      delete flexProps.collapseOnDateClick;
	      delete flexProps.date;
	      delete flexProps.dateFormat;
	      delete flexProps.displayFormat;
	      delete flexProps.expanded;
	      delete flexProps.defaultExpanded;
	      delete flexProps.expandOnFocus;
	      delete flexProps.footer;
	      delete flexProps.forceValidDate;
	      delete flexProps.locale;
	      delete flexProps.onExpand;
	      delete flexProps.onExpandChange;
	      delete flexProps.onCollapse;
	      delete flexProps.minDate;
	      delete flexProps.maxDate;
	      delete flexProps.pickerProps;
	      delete flexProps.position;
	      delete flexProps.showClock;
	      delete flexProps.skipTodayTime;
	      delete flexProps.strict;
	      delete flexProps.valid;
	      delete flexProps.validateOnBlur;
	      delete flexProps.viewDate;
	      delete flexProps.value;
	      delete flexProps.text;
	      delete flexProps.theme;
	      delete flexProps.updateOnDateClick;
	      delete flexProps.defaultViewDate;
	      delete flexProps.onViewDateChange;
	      delete flexProps.onActiveDateChange;
	      delete flexProps.renderInput;
	      delete flexProps.renderClearIcon;
	      delete flexProps.renderCalendarIcon;
	      delete flexProps.renderPicker;
	      delete flexProps.overlayProps;
	      delete flexProps.relativeToViewport;
	      delete flexProps.enableMonthDecadeViewAnimation;
	      delete flexProps.showMonthDecadeViewAnimation;
	      delete flexProps.updateOnWheel;
	      delete flexProps.onTextChange;
	      delete flexProps.focusedClassName;
	      delete flexProps.expandedClassName;
	      delete flexProps.invalidClassName;
	      delete flexProps.onTimeChange;
	      delete flexProps.okButton;
	      delete flexProps.constrainTo;
	      delete flexProps.defaultDate;
	      delete flexProps.weekNumbers;
	      delete flexProps.highlightWeekends;
	      delete flexProps.calendarProps;
	      delete flexProps.cancelButtonText;
	      delete flexProps.clearButtonText;
	      delete flexProps.okButtonText;
	      delete flexProps.todayButtonText;
	      delete flexProps.rtl;
	      delete flexProps.pickerPosition;
	      delete flexProps.onLazyBlur;
	      if (typeof props.cleanup == 'function') {
	        props.cleanup(flexProps);
	      }
	      return _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({
	        inline: true,
	        row: true,
	        wrap: false
	      }, flexProps), {}, {
	        onClick: this.handleClick
	      }), this.renderInput(), this.renderClearIcon(), this.renderCalendarIcon(), this.renderPicker());
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      if (this.props.onClick) {
	        this.props.onClick(event);
	      }
	      if (!this.isLazyFocused()) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "renderInput",
	    value: function renderInput() {
	      var props = this.p;
	      var inputProps = this.prepareInputProps(props);
	      var input;
	      if (props.renderInput) {
	        input = props.renderInput(inputProps);
	      }
	      if (input === undefined) {
	        input = props.children.filter(FIND_INPUT)[0];
	        var FieldInput = props.forceValidDate ? _DateFormatInput.default : _Field.default;
	        var propsForInput = (0, _assign.default)({}, inputProps);
	        if (!props.forceValidDate) {
	          delete propsForInput.date;
	          delete propsForInput.maxDate;
	          delete propsForInput.minDate;
	          delete propsForInput.dateFormat;
	        }
	        input = input ? _react.default.cloneElement(input, propsForInput) : _react.default.createElement(FieldInput, _objectSpread({}, propsForInput));
	      }
	      return input;
	    }
	  }, {
	    key: "renderClearIcon",
	    value: function renderClearIcon() {
	      var props = this.p;
	      var rootClassName = props.rootClassName,
	        disabled = props.disabled,
	        text = props.text;
	      if (!props.clearIcon || props.forceValidDate) {
	        return undefined;
	      }
	      var clearIcon = props.clearIcon === true ? _icons.CLEAR_ICON : props.clearIcon;
	      var clearIconProps = {
	        className: (0, _join.default)("".concat(rootClassName, "__clear-icon"), text === '' || text == null ? "".concat(rootClassName, "__clear-icon--hidden") : "".concat(rootClassName, "__clear-icon--animation"), disabled && "".concat(rootClassName, "__clear-icon--disabled")),
	        onMouseDown: preventDefault,
	        onClick: this.onClearClick,
	        children: clearIcon
	      };
	      var result;
	      if (props.renderClearIcon) {
	        result = props.renderClearIcon(clearIconProps);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement(_InlineBlock.default, _objectSpread({}, clearIconProps));
	      }
	      return result;
	    }
	  }, {
	    key: "onClearClick",
	    value: function onClearClick(event) {
	      this.onFieldChange('');
	      if (!this.isFocused()) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "renderCalendarIcon",
	    value: function renderCalendarIcon() {
	      var result;
	      var renderIcon = this.props.renderCalendarIcon;
	      var _this$props = this.props,
	        rootClassName = _this$props.rootClassName,
	        disabled = _this$props.disabled;
	      var calendarIconProps = {
	        className: (0, _join.default)("".concat(rootClassName, "__calendar-icon"), disabled ? "".concat(rootClassName, "__calendar-icon--disabled") : ''),
	        onMouseDown: this.onCalendarIconMouseDown
	      };
	      if (renderIcon) {
	        result = renderIcon(calendarIconProps);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("div", _objectSpread({}, calendarIconProps), _icons.CALENDAR_ICON);
	      }
	      return result;
	    }
	  }, {
	    key: "onCalendarIconMouseDown",
	    value: function onCalendarIconMouseDown(event) {
	      if (this.props.disabled) {
	        return;
	      }
	      event.preventDefault();
	      this.toggleExpand();
	    }
	  }, {
	    key: "prepareExpanded",
	    value: function prepareExpanded(props) {
	      return props.expanded === undefined ? this.state.expanded : props.expanded;
	    }
	  }, {
	    key: "prepareDate",
	    value: function prepareDate(props, pickerProps) {
	      props = props || this.p;
	      pickerProps = pickerProps || props.pickerProps;
	      var locale = props.locale || pickerProps.locale;
	      var dateFormat = props.dateFormat === undefined ? pickerProps.dateFormat : props.dateFormat;
	      var value = props.value === undefined ? this.state.value : props.value;
	      var date = this.toMoment(value);
	      var valid = date.isValid();
	      if (value && typeof value != 'string' && valid) {
	        value = this.format(date);
	      }
	      if (date && valid) {
	        this.lastValidDate = date;
	      } else {
	        value = this.state.value;
	      }
	      var viewDate = this.props.viewDate || this.state.viewDate || this.lastValidDate || new Date();
	      var activeDate = this.state.activeDate || this.lastValidDate || new Date();
	      return {
	        viewDate: viewDate,
	        activeDate: activeDate,
	        dateFormat: dateFormat,
	        locale: locale,
	        valid: valid,
	        date: date,
	        value: value
	      };
	    }
	  }, {
	    key: "preparePickerProps",
	    value: function preparePickerProps(props) {
	      var picker = getPicker(props, this);
	      if (!picker) {
	        return null;
	      }
	      return picker.props || {};
	    }
	  }, {
	    key: "prepareProps",
	    value: function prepareProps(thisProps) {
	      var props = this.p = (0, _assign.default)({}, thisProps);
	      props.children = _react.default.Children.toArray(props.children);
	      props.expanded = this.prepareExpanded(props);
	      props.pickerProps = this.preparePickerProps(props);
	      var input = props.children.filter(FIND_INPUT)[0];
	      if (input && input.type === 'input') {
	        props.rawInput = true;
	        props.forceValidDate = false;
	      }
	      var dateInfo = this.prepareDate(props, props.pickerProps);
	      (0, _assign.default)(props, dateInfo);
	      if (props.text === undefined) {
	        props.text = this.state.text;
	        if (!props.text) {
	          props.text = props.valid && props.date ? props.value : this.props.value != null ? this.props.value : this.state.text || '';
	        }
	      }
	      if (props.text === undefined) {
	        props.text = '';
	      }
	      props.className = this.prepareClassName(props);
	      if (props.calendarProps) {
	        props.cancelButtonText = props.calendarProps.cancelButtonText;
	        props.clearButtonText = props.calendarProps.clearButtonText;
	        props.okButtonText = props.calendarProps.okButtonText;
	        props.todayButtonText = props.calendarProps.todayButtonText;
	      }
	      return props;
	    }
	  }, {
	    key: "prepareClassName",
	    value: function prepareClassName(props) {
	      var rootClassName = props.rootClassName;
	      var position = POSITIONS[props.pickerProps.position || props.pickerPosition] || 'bottom';
	      return (0, _join.default)([rootClassName, props.className, props.disabled && "".concat(rootClassName, "--disabled"), props.theme && "".concat(rootClassName, "--theme-").concat(props.theme), props.rtl ? "".concat(rootClassName, "--rtl") : "".concat(rootClassName, "--ltr"), "".concat(rootClassName, "--picker-position-").concat(position), this.isLazyFocused() && (0, _join.default)("".concat(rootClassName, "--focused"), props.focusedClassName), this.isExpanded() && (0, _join.default)("".concat(rootClassName, "--expanded"), props.expandedClassName), !props.valid && (0, _join.default)(props.invalidClassName, "".concat(rootClassName, "--invalid"))]);
	    }
	  }, {
	    key: "prepareInputProps",
	    value: function prepareInputProps(props) {
	      var _this2 = this;
	      var input = props.children.filter(FIND_INPUT)[0];
	      var inputProps = input && input.props || {};
	      var rootClassName = this.props.rootClassName;
	      var onBlur = (0, _joinFunctions.default)(inputProps.onBlur, this.onFieldBlur);
	      var onFocus = (0, _joinFunctions.default)(inputProps.onFocus, this.onFieldFocus);
	      var onChange = (0, _joinFunctions.default)(inputProps.onChange, this.onFieldChange);
	      var onKeyDown = (0, _joinFunctions.default)(inputProps.onKeyDown, this.onFieldKeyDown);
	      var newInputProps = (0, _assign.default)({}, inputProps, {
	        ref: function ref(f) {
	          _this2.field = f;
	        },
	        date: props.date,
	        onFocus: onFocus,
	        onBlur: onBlur,
	        onChange: onChange,
	        dateFormat: props.dateFormat,
	        value: props.text || '',
	        onKeyDown: onKeyDown,
	        placeholder: props.placeholder,
	        className: (0, _join.default)("".concat(rootClassName, "__input"), inputProps.className)
	      });
	      (0, _assignDefined.default)(newInputProps, {
	        placeholder: props.placeholder,
	        autoFocus: props.autoFocus,
	        disabled: props.disabled,
	        minDate: props.minDate,
	        maxDate: props.maxDate
	      });
	      return newInputProps;
	    }
	  }, {
	    key: "renderPicker",
	    value: function renderPicker() {
	      var _this3 = this;
	      var props = this.p;
	      var renderPicker = this.props.renderPicker;
	      if (this.isExpanded()) {
	        var newExpand = !this.picker;
	        var picker = getPicker(props, this);
	        var pickerProps = props.pickerProps;
	        var onMouseDown = (0, _joinFunctions.default)(pickerProps.onMouseDown, this.onPickerMouseDown);
	        var onChange = (0, _joinFunctions.default)(pickerProps.onChange, this.onPickerChange);
	        var date = props.valid && props.date;
	        var footer = pickerProps.footer !== undefined ? pickerProps.footer : props.footer;
	        var viewDate = props.viewDate || this.state.viewDate || props.defaultViewDate;
	        var activeDate = newExpand && date ? date : props.activeDate;
	        var pickerElement = _react.default.cloneElement(picker, (0, _assignDefined.default)({
	          ref: function ref(p) {
	            _this3.picker = _this3.pickerView = p;
	            if (p) {
	              var pickerView = p.getView ? p.getView() : p.view;
	              if (pickerView) {
	                _this3.pickerView = pickerView;
	              }
	            }
	            if (!_this3.state.viewDate) {
	              _this3.setViewDate(props.viewDate);
	            }
	          },
	          footer: footer,
	          okButton: props.okButton,
	          okButtonText: props.okButtonText,
	          cancelButton: props.cancelButton,
	          weekNumbers: props.weekNumbers,
	          highlightWeekends: props.highlightWeekends,
	          enableMonthDecadeViewAnimation: props.enableMonthDecadeViewAnimation,
	          showMonthDecadeViewAnimation: props.showMonthDecadeViewAnimation,
	          focusOnNavMouseDown: false,
	          focusOnFooterMouseDown: false,
	          insideField: true,
	          showClock: props.showClock,
	          getTransitionTime: this.getTime,
	          updateOnWheel: props.updateOnWheel,
	          onClockInputBlur: this.onClockInputBlur,
	          onClockEnterKey: this.onClockEnterKey,
	          onClockEscapeKey: this.onClockEscapeKey,
	          footerClearDate: props.clearDate || props.minDate,
	          onFooterCancelClick: this.onFooterCancelClick,
	          onFooterTodayClick: this.onFooterTodayClick,
	          onFooterOkClick: this.onFooterOkClick,
	          onFooterClearClick: this.onFooterClearClick,
	          dateFormat: props.dateFormat,
	          theme: props.theme || pickerProps.theme,
	          arrows: props.navBarArrows,
	          className: (0, _join.default)(pickerProps.className, "".concat(this.props.rootClassName, "__picker")),
	          date: date || null,
	          tabIndex: -1,
	          viewDate: viewDate,
	          activeDate: activeDate,
	          locale: props.locale,
	          triggerChangeOnTimeChange: this.props.triggerChangeOnTimeChange === undefined ? false : this.props.triggerChangeOnTimeChange,
	          onViewDateChange: (0, _joinFunctions.default)(pickerProps.onViewDateChange, this.onViewDateChange),
	          onActiveDateChange: (0, _joinFunctions.default)(pickerProps.onActiveDateChange, this.onActiveDateChange),
	          onTimeChange: this.onTimeChange,
	          onTransitionStart: this.onTransitionStart,
	          onMouseDown: onMouseDown,
	          onChange: onChange
	        }, {
	          minDate: props.minDate,
	          maxDate: props.maxDate
	        }));
	        var result = pickerElement;
	        if (props.relativeToViewport) {
	          result = _react.default.createElement(_Overlay.default, _objectSpread(_objectSpread(_objectSpread({}, defaultOverlayProps), props.overlayProps), {}, {
	            constrainTo: props.constrainTo
	          }), pickerElement);
	        }
	        if (renderPicker) {
	          var renderPickerResult = renderPicker(result, pickerElement);
	          if (renderPickerResult !== undefined) {
	            return renderPickerResult;
	          }
	        }
	        return result;
	      }
	      this.time = null;
	      if (renderPicker) {
	        return renderPicker(null);
	      }
	      return null;
	    }
	  }, {
	    key: "getValue",
	    value: function getValue() {
	      return this.state.value || this.props.value;
	    }
	  }, {
	    key: "onTimeChange",
	    value: function onTimeChange(value, timeFormat) {
	      var timeMoment = this.toMoment(value, {
	        dateFormat: timeFormat
	      });
	      var time = ['hour', 'minute', 'second', 'millisecond'].reduce(function (acc, part) {
	        acc[part] = timeMoment.get(part);
	        return acc;
	      }, {});
	      this.time = time;
	    }
	  }, {
	    key: "getTime",
	    value: function getTime() {
	      return this.time;
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value) {
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var dateMoment = this.toMoment(value);
	      var dateString = this.format(dateMoment);
	      this.setDate(dateString, (0, _assign.default)(config, {
	        dateMoment: dateMoment
	      }));
	    }
	  }, {
	    key: "onFooterOkClick",
	    value: function onFooterOkClick() {
	      var activeDate = this.p.activeDate;
	      if (activeDate) {
	        var date = this.toMoment(activeDate);
	        (0, _forwardTime.default)(this.time, date);
	        this.setValue(date, {
	          skipTime: !!this.time
	        });
	      }
	      this.setExpanded(false);
	    }
	  }, {
	    key: "onFooterCancelClick",
	    value: function onFooterCancelClick() {
	      this.setExpanded(false);
	    }
	  }, {
	    key: "onFooterTodayClick",
	    value: function onFooterTodayClick() {
	      var today = this.toMoment(new Date()).startOf('day');
	      this.onPickerChange(this.format(today), {
	        dateMoment: today
	      });
	      if (this.pickerView && this.pickerView.gotoViewDate) {
	        this.pickerView.gotoViewDate({
	          dateMoment: today
	        });
	      }
	      return false;
	    }
	  }, {
	    key: "onFooterClearClick",
	    value: function onFooterClearClick() {
	      var clearDate = this.props.clearDate === undefined ? this.props.minDate : this.props.clearDate;
	      if (clearDate !== undefined) {
	        this.setValue(clearDate, {
	          skipTime: true
	        });
	      }
	      this.setExpanded(false);
	      return false;
	    }
	  }, {
	    key: "toMoment",
	    value: function toMoment(value, props) {
	      if (_moment.default.isMoment(value)) {
	        return value;
	      }
	      props = props || this.p;
	      var dateFormat = props.displayFormat;
	      if (dateFormat === undefined) {
	        dateFormat = props.dateFormat;
	      }
	      if (dateFormat === undefined) {
	        dateFormat = this.p.dateFormat;
	      }
	      var date = (0, _toMoment2.default)(value, {
	        strict: props.strict,
	        locale: props.locale,
	        dateFormat: dateFormat
	      });
	      if (!date.isValid() && props.displayFormat) {
	        date = (0, _toMoment2.default)(value, {
	          strict: props.strict,
	          locale: props.locale,
	          dateFormat: props.dateFormat === undefined ? this.p.dateFormat : props.dateFormat
	        });
	      }
	      return date;
	    }
	  }, {
	    key: "isValid",
	    value: function isValid(text) {
	      if (text === undefined) {
	        text = this.p.text;
	      }
	      return this.toMoment(text).isValid();
	    }
	  }, {
	    key: "onViewDateChange",
	    value: function onViewDateChange(viewDate) {
	      this.setState({
	        viewDate: viewDate
	      });
	      if (this.props.onViewDateChange) {
	        this.props.onViewDateChange.apply(this, arguments);
	      }
	    }
	  }, {
	    key: "setViewDate",
	    value: function setViewDate(viewDate) {
	      if (this.pickerView) {
	        this.pickerView.gotoViewDate({
	          dateMoment: this.toMoment(viewDate)
	        });
	      }
	    }
	  }, {
	    key: "onActiveDateChange",
	    value: function onActiveDateChange(activeDate) {
	      this.setState({
	        activeDate: activeDate
	      });
	      if (this.props.onActiveDateChange) {
	        this.props.onActiveDateChange.apply(this, arguments);
	      }
	    }
	  }, {
	    key: "onViewKeyDown",
	    value: function onViewKeyDown(event) {
	      var key = event.key;
	      if (this.pickerView) {
	        this.onPickerViewKeyDown(event);
	      }
	    }
	  }, {
	    key: "onPickerViewKeyDown",
	    value: function onPickerViewKeyDown(event) {
	      this.pickerView.onViewKeyDown(event);
	    }
	  }, {
	    key: "onPickerMouseDown",
	    value: function onPickerMouseDown(event) {
	      preventDefault(event);
	      if (!this.isFocused()) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "isMonthDecadeViewVisible",
	    value: function isMonthDecadeViewVisible() {
	      if (this.picker && this.picker.isMonthDecadeViewVisible) {
	        return this.picker.isMonthDecadeViewVisible();
	      }
	      return false;
	    }
	  }, {
	    key: "onFieldKeyDown",
	    value: function onFieldKeyDown(event) {
	      var key = event.key;
	      var expanded = this.isExpanded();
	      var monthDecadeVisible = this.isMonthDecadeViewVisible();
	      if (key == 'Enter' && !monthDecadeVisible) {
	        this.onViewKeyDown(event);
	        this.toggleExpand();
	        return false;
	      }
	      if (monthDecadeVisible && (key == 'Escape' || key == 'Enter')) {
	        this.onViewKeyDown(event);
	        return false;
	      }
	      if (key == 'Escape') {
	        if (expanded) {
	          this.setExpanded(false);
	          return false;
	        }
	      }
	      if (expanded) {
	        if (key in _Calendar.NAV_KEYS) {
	          this.onViewKeyDown(event);
	          return false;
	        }
	      }
	      return true;
	    }
	  }, {
	    key: "getInput",
	    value: function getInput() {
	      return this.field;
	    }
	  }, {
	    key: "isFocused",
	    value: function isFocused() {
	      return this.state.focused;
	    }
	  }, {
	    key: "isLazyFocused",
	    value: function isLazyFocused() {
	      return this.isFocused() || this.isTimeInputFocused();
	    }
	  }, {
	    key: "isTimeInputFocused",
	    value: function isTimeInputFocused() {
	      if (this.picker && this.picker.isTimeInputFocused) {
	        return this.picker.isTimeInputFocused();
	      }
	      return false;
	    }
	  }, {
	    key: "onFieldFocus",
	    value: function onFieldFocus(event) {
	      if (this.state.focused) {
	        return;
	      }
	      this.setState({
	        focused: true
	      });
	      if (this.props.expandOnFocus) {
	        this.setExpanded(true);
	      }
	      this.props.onFocus(event);
	    }
	  }, {
	    key: "onFieldBlur",
	    value: function onFieldBlur(event) {
	      var _this4 = this;
	      if (!this.isFocused()) {
	        return;
	      }
	      this.setState({
	        focused: false
	      });
	      this.props.onBlur(event);
	      if (!this.picker || !this.picker.isTimeInputFocused) {
	        this.onLazyBlur();
	        return;
	      }
	      setTimeout(function () {
	        return _this4.onLazyBlur();
	      }, 0);
	    }
	  }, {
	    key: "onClockEnterKey",
	    value: function onClockEnterKey() {
	      if (!this.isFocused()) {
	        this.focus();
	      }
	      this.onFooterOkClick();
	    }
	  }, {
	    key: "onClockEscapeKey",
	    value: function onClockEscapeKey() {
	      if (!this.isFocused()) {
	        this.focus();
	      }
	      this.onFooterCancelClick();
	    }
	  }, {
	    key: "onClockInputBlur",
	    value: function onClockInputBlur() {
	      var _this5 = this;
	      setTimeout(function () {
	        if (!_this5.isFocused()) {
	          _this5.onLazyBlur();
	        }
	      }, 0);
	    }
	  }, {
	    key: "onLazyBlur",
	    value: function onLazyBlur() {
	      var _this6 = this;
	      if (this.unmounted) {
	        return;
	      }
	      if (this.isTimeInputFocused()) {
	        return;
	      }
	      this.setExpanded(false);
	      if (this.props.onLazyBlur) {
	        this.props.onLazyBlur();
	      }
	      if (!this.isValid() && this.props.validateOnBlur) {
	        var value = this.lastValidDate && this.p.text != '' ? this.format(this.lastValidDate) : '';
	        setTimeout(function () {
	          _this6.onFieldChange(value);
	        }, 0);
	      }
	    }
	  }, {
	    key: "onInputChange",
	    value: function onInputChange() {}
	  }, {
	    key: "isExpanded",
	    value: function isExpanded() {
	      return this.p.expanded;
	    }
	  }, {
	    key: "toggleExpand",
	    value: function toggleExpand() {
	      this.setExpanded(!this.p.expanded);
	    }
	  }, {
	    key: "setExpanded",
	    value: function setExpanded(bool) {
	      var _this7 = this;
	      var props = this.p;
	      if (bool === props.expanded) {
	        return;
	      }
	      if (!bool) {
	        this.onCollapse();
	      } else {
	        this.setState({}, function () {
	          _this7.onExpand();
	        });
	      }
	      if (bool && props.valid) {
	        this.setState({
	          activeDate: props.date
	        });
	      }
	      if (this.props.expanded === undefined) {
	        this.setState({
	          expanded: bool
	        });
	      }
	      this.props.onExpandChange(bool);
	    }
	  }, {
	    key: "onCollapse",
	    value: function onCollapse() {
	      this.props.onCollapse();
	    }
	  }, {
	    key: "onExpand",
	    value: function onExpand() {
	      this.props.onExpand();
	    }
	  }, {
	    key: "onFieldChange",
	    value: function onFieldChange(value) {
	      if (this.p.rawInput && typeof value != 'string') {
	        var event = value;
	        value = event.target.value;
	      }
	      var dateMoment = value == '' ? null : this.toMoment(value);
	      if (dateMoment === null || dateMoment.isValid()) {
	        this.onChange(dateMoment);
	      }
	      this.onTextChange(value);
	    }
	  }, {
	    key: "onTextChange",
	    value: function onTextChange(text) {
	      if (this.props.text === undefined) {
	        this.setState({
	          text: text
	        });
	      }
	      if (this.props.onTextChange) {
	        this.props.onTextChange(text);
	      }
	    }
	  }, {
	    key: "onPickerChange",
	    value: function onPickerChange(dateString, _ref, event) {
	      var dateMoment = _ref.dateMoment,
	        forceUpdate = _ref.forceUpdate,
	        noCollapse = _ref.noCollapse;
	      var isEnter = event && event.key == 'Enter';
	      var updateOnDateClick = forceUpdate ? true : this.props.updateOnDateClick || isEnter;
	      var shouldCollapse = this.props.collapseOnDateClick || isEnter;
	      if (noCollapse) {
	        shouldCollapse = false;
	      }
	      if (updateOnDateClick) {
	        (0, _forwardTime.default)(this.time, dateMoment);
	        this.setDate(dateString, {
	          dateMoment: dateMoment,
	          skipTime: true
	        });
	        if (shouldCollapse) {
	          this.setExpanded(false);
	        }
	      }
	    }
	  }, {
	    key: "setDate",
	    value: function setDate(dateString, _ref2) {
	      var dateMoment = _ref2.dateMoment,
	        _ref2$skipTime = _ref2.skipTime,
	        skipTime = _ref2$skipTime === void 0 ? false : _ref2$skipTime;
	      var props = this.p;
	      var currentDate = props.date;
	      if (props.valid && currentDate) {
	        var dateFormat = props.dateFormat ? props.dateFormat.toLowerCase() : '';
	        var hasTime = dateFormat.indexOf('k') != -1 || dateFormat.indexOf('h') != -1;
	        if (hasTime && !skipTime) {
	          ['hour', 'minute', 'second', 'millisecond'].forEach(function (part) {
	            dateMoment.set(part, currentDate.get(part));
	          });
	        }
	      }
	      this.onTextChange(this.format(dateMoment));
	      this.onChange(dateMoment);
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(dateMoment) {
	      if (dateMoment != null && !_moment.default.isMoment(dateMoment)) {
	        dateMoment = this.toMoment(dateMoment);
	      }
	      (0, _forwardTime.default)(this.time, dateMoment);
	      var newState = {};
	      if (this.props.value === undefined) {
	        (0, _assign.default)(newState, {
	          text: null,
	          value: dateMoment
	        });
	      }
	      newState.activeDate = dateMoment;
	      if (dateMoment) {
	        if (!this.pickerView || !this.pickerView.isInView || !this.pickerView.isInView(dateMoment)) {
	          newState.viewDate = dateMoment;
	        }
	      }
	      if (this.props.onChange) {
	        this.props.onChange(this.format(dateMoment), {
	          dateMoment: dateMoment
	        });
	      }
	      this.setState(newState);
	    }
	  }, {
	    key: "format",
	    value: function format(mom, _format) {
	      var theFormat = _format;
	      if (_format === undefined) {
	        theFormat = this.p.displayFormat;
	      }
	      if (_format === undefined) {
	        theFormat = this.p.dateFormat;
	      }
	      return mom == null ? '' : mom.format(theFormat);
	    }
	  }, {
	    key: "focusField",
	    value: function focusField() {
	      var input = this.field;
	      if (input) {
	        input.focus();
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.focusField();
	    }
	  }]);
	  return DateInput;
	}(_reactClass.default);
	exports.default = DateInput;
	DateInput.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-date-input',
	  showClock: undefined,
	  relativeToViewport: true,
	  enableMonthDecadeViewAnimation: true,
	  showMonthDecadeViewAnimation: 300,
	  overlayProps: undefined,
	  forceValidDate: false,
	  strict: false,
	  expandOnFocus: true,
	  updateOnDateClick: true,
	  collapseOnDateClick: true,
	  theme: 'default-light',
	  footer: true,
	  okButton: false,
	  onBlur: function onBlur() {},
	  onFocus: function onFocus() {},
	  clearIcon: true,
	  validateOnBlur: true,
	  onExpandChange: function onExpandChange() {},
	  onCollapse: function onCollapse() {},
	  onExpand: function onExpand() {},
	  minDate: (0, _moment.default)('1000-01-01', 'YYYY-MM-DD'),
	  maxDate: (0, _moment.default)('9999-12-31 HH:mm:ss', 'YYYY-MM-DD 23:59:59'),
	  skipTodayTime: false
	};
	var DateType = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object, _propTypes.default.string]);
	DateInput.propTypes = {
	  autoFocus: _propTypes.default.bool,
	  rootClassName: _propTypes.default.string,
	  dateFormat: _propTypes.default.string.isRequired,
	  displayFormat: _propTypes.default.string,
	  relativeToViewport: _propTypes.default.bool,
	  showClock: _propTypes.default.bool,
	  strict: _propTypes.default.bool,
	  expandOnFocus: _propTypes.default.bool,
	  updateOnDateClick: _propTypes.default.bool,
	  collapseOnDateClick: _propTypes.default.bool,
	  enableMonthDecadeViewAnimation: _propTypes.default.bool,
	  showMonthDecadeViewAnimation: _propTypes.default.number,
	  theme: _propTypes.default.string,
	  footer: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node]),
	  onBlur: _propTypes.default.func,
	  onFocus: _propTypes.default.func,
	  clearIcon: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node]),
	  validateOnBlur: _propTypes.default.bool,
	  onExpandChange: _propTypes.default.func,
	  onCollapse: _propTypes.default.func,
	  onExpand: _propTypes.default.func,
	  skipTodayTime: _propTypes.default.bool,
	  date: DateType,
	  value: DateType,
	  defaultDate: DateType,
	  viewDate: DateType,
	  minDate: DateType,
	  maxDate: DateType,
	  activeDate: DateType,
	  text: _propTypes.default.string,
	  pickerProps: _propTypes.default.object,
	  overlayProps: _propTypes.default.object,
	  constrainTo: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object, _propTypes.default.bool]),
	  cleanup: _propTypes.default.func,
	  expanded: _propTypes.default.bool,
	  triggerChangeOnTimeChange: _propTypes.default.bool,
	  defaultExpanded: _propTypes.default.bool,
	  forceValidDate: _propTypes.default.bool,
	  valid: _propTypes.default.bool,
	  updateOnWheel: _propTypes.default.bool,
	  clearDate: _propTypes.default.bool,
	  navBarArrows: _propTypes.default.bool,
	  locale: _propTypes.default.string,
	  focusedClassName: _propTypes.default.string,
	  expandedClassName: _propTypes.default.string,
	  invalidClassName: _propTypes.default.string,
	  placeholder: _propTypes.default.string,
	  onTextChange: _propTypes.default.func,
	  renderPicker: _propTypes.default.func,
	  onMouseDown: _propTypes.default.func,
	  onViewDateChange: _propTypes.default.func,
	  onActiveDateChange: _propTypes.default.func,
	  defaultViewDate: _propTypes.default.any,
	  onChange: _propTypes.default.func,
	  renderInput: _propTypes.default.func,
	  onLazyBlur: _propTypes.default.func,
	  onKeyDown: _propTypes.default.func,
	  position: _propTypes.default.oneOf(['top', 'bottom']),
	  weekNumbers: _propTypes.default.bool,
	  highlightWeekends: _propTypes.default.bool,
	  calendarProps: _propTypes.default.object,
	  cancelButtonText: _propTypes.default.string,
	  clearButtonText: _propTypes.default.string,
	  okButtonText: _propTypes.default.string,
	  todayButtonText: _propTypes.default.string
	};

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderNavBar = exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _Flex = __webpack_require__(41);
	var _InlineBlock = _interopRequireDefault(__webpack_require__(107));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _clampRange = _interopRequireDefault(__webpack_require__(237));
	var _NavBar = _interopRequireDefault(__webpack_require__(109));
	var _toMoment = _interopRequireDefault(__webpack_require__(40));
	var _isInRange2 = _interopRequireDefault(__webpack_require__(239));
	var _BasicMonthView = __webpack_require__(228);
	var _MonthView = _interopRequireWildcard(__webpack_require__(108));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var times = function times(count) {
	  return (0, _toConsumableArray2.default)(new Array(count)).map(function (v, i) {
	    return i;
	  });
	};
	var prepareDate = function prepareDate(props, state) {
	  if (props.range) {
	    return null;
	  }
	  return props.date === undefined ? state.date : props.date;
	};
	var prepareViewDate = function prepareViewDate(props, state) {
	  return props.viewDate === undefined ? state.viewDate : state.propViewDate || props.viewDate;
	};
	var prepareRange = function prepareRange(props, state) {
	  return props.range && props.range.length ? props.range : state.range;
	};
	var prepareActiveDate = function prepareActiveDate(props, state) {
	  var fallbackDate = prepareDate(props, state) || (prepareRange(props, state) || [])[0];
	  var activeDate = props.activeDate === undefined ? state.activeDate || fallbackDate : props.activeDate;
	  if (activeDate && props.inViewStart && props.inViewEnd && props.constrainActiveInView) {
	    var activeMoment = this.toMoment(activeDate);
	    if (!(0, _isInRange2.default)(activeMoment, [props.inViewStart, props.inViewEnd])) {
	      var date = fallbackDate;
	      var dateMoment = this.toMoment(date);
	      if (date && (0, _isInRange2.default)(dateMoment, [props.inViewStart, props.inViewEnd])) {
	        return date;
	      }
	      return null;
	    }
	  }
	  return activeDate;
	};
	var prepareViews = function prepareViews(props) {
	  var daysInView = [];
	  var viewMoments = [];
	  var viewMoment = props.viewMoment;
	  var index = 0;
	  var size = props.size;
	  while (index < size) {
	    var mom = this.toMoment(viewMoment).startOf('day').add(index, 'month');
	    var days = (0, _BasicMonthView.getDaysInMonthView)(mom, props);
	    viewMoments.push(mom);
	    daysInView.push(days);
	    index++;
	  }
	  props.daysInView = daysInView;
	  props.viewMoments = viewMoments;
	  var lastViewDays = daysInView[size - 1];
	  props.inViewStart = daysInView[0][0];
	  props.inViewEnd = lastViewDays[lastViewDays.length - 1];
	};
	var _renderNavBar = function renderNavBar(config, navBarProps) {
	  var props = this.props;
	  var index = config.index,
	    viewMoment = config.viewMoment;
	  navBarProps = (0, _assign.default)({}, navBarProps, {
	    secondary: true,
	    minDate: config.minDate || props.minDate,
	    maxDate: config.maxDate || props.maxDate,
	    renderNavNext: config.renderHiddenNav || this.renderHiddenNav,
	    renderNavPrev: config.renderHiddenNav || this.renderHiddenNav,
	    viewMoment: viewMoment,
	    size: props.size,
	    onViewDateChange: config.onViewDateChange || this.onNavViewDateChange,
	    onUpdate: config.onUpdate || this.updateViewMoment,
	    enableMonthDecadeView: props.enableMonthDecadeView
	  });
	  if (index == 0) {
	    delete navBarProps.renderNavPrev;
	  }
	  if (index == props.perRow - 1) {
	    delete navBarProps.renderNavNext;
	  }
	  var marginStyle;
	  if (index % 2 == 0) {
	    marginStyle = {
	      marginRight: 1
	    };
	  } else {
	    marginStyle = null;
	  }
	  return _react.default.createElement(_NavBar.default, _objectSpread({
	    key: "multi_month_nav_bar",
	    style: marginStyle
	  }, navBarProps));
	};
	exports.renderNavBar = _renderNavBar;
	var MultiMonthView = function (_Component) {
	  (0, _inherits2.default)(MultiMonthView, _Component);
	  var _super = _createSuper(MultiMonthView);
	  function MultiMonthView(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, MultiMonthView);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
	      _this.updateToMoment(_this.props);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
	      if (prevProps.locale !== _this.props.locale || prevProps.dateFormat !== _this.props.dateFormat) {
	        _this.updateToMoment(_this.props);
	      }
	    });
	    _this.state = {
	      hoverRange: null,
	      range: props.defaultRange,
	      date: props.defaultDate,
	      activeDate: props.defaultActiveDate,
	      viewDate: props.defaultViewDate
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(MultiMonthView, [{
	    key: "updateToMoment",
	    value: function updateToMoment(props) {
	      this.toMoment = function (value, dateFormat) {
	        return (0, _toMoment.default)(value, {
	          locale: props.locale,
	          dateFormat: dateFormat || props.dateFormat
	        });
	      };
	    }
	  }, {
	    key: "prepareProps",
	    value: function prepareProps(thisProps, state) {
	      var _this2 = this;
	      var props = (0, _assign.default)({}, thisProps);
	      state = state || this.state;
	      props.viewMoment = this.toMoment(prepareViewDate(props, state));
	      props.viewStart = this.toMoment(props.viewMoment).startOf('month');
	      props.viewEnd = this.toMoment(props.viewStart).add(props.size - 1, 'month').endOf('month');
	      prepareViews.call(this, props);
	      var activeDate = prepareActiveDate.call(this, props, state);
	      if (activeDate) {
	        props.activeDate = +this.toMoment(activeDate);
	      }
	      props.date = prepareDate(props, state);
	      if (!props.date) {
	        var range = prepareRange(props, state);
	        if (range) {
	          props.range = range.map(function (d) {
	            return _this2.toMoment(d).startOf('day');
	          });
	          props.rangeStart = state.rangeStart || (props.range.length == 1 ? props.range[0] : null);
	        }
	      }
	      return props;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      this.views = [];
	      var props = this.p = this.prepareProps(this.props, this.state);
	      var size = props.size;
	      var rowCount = Math.ceil(size / props.perRow);
	      var children = times(rowCount).map(this.renderRow).filter(function (x) {
	        return !!x;
	      });
	      var rootClassName = props.rootClassName;
	      var className = (0, _join.default)(props.className, rootClassName, props.theme && "".concat(rootClassName, "--theme-").concat(props.theme));
	      var footer = (0, _MonthView.renderFooter)(props, this);
	      if (footer) {
	        children.push(footer);
	      }
	      var flexProps = (0, _assign.default)({}, props);
	      delete flexProps.activeDate;
	      delete flexProps.clockTabIndex;
	      delete flexProps.constrainActiveInView;
	      delete flexProps.constrainViewDate;
	      delete flexProps.date;
	      delete flexProps.dateFormat;
	      delete flexProps.daysInView;
	      delete flexProps.defaultRange;
	      delete flexProps.enableMonthDecadeView;
	      delete flexProps.footer;
	      delete flexProps.footerClearDate;
	      delete flexProps.forceViewUpdate;
	      delete flexProps.highlightRangeOnMouseMove;
	      delete flexProps.inViewEnd;
	      delete flexProps.inViewStart;
	      delete flexProps.isDatePicker;
	      delete flexProps.locale;
	      delete flexProps.navigation;
	      delete flexProps.onViewDateChange;
	      delete flexProps.perRow;
	      delete flexProps.range;
	      delete flexProps.rangeStart;
	      delete flexProps.renderNavBar;
	      delete flexProps.theme;
	      delete flexProps.viewDate;
	      delete flexProps.viewEnd;
	      delete flexProps.viewMoment;
	      delete flexProps.viewMoments;
	      delete flexProps.viewStart;
	      delete flexProps.rootClassName;
	      delete flexProps.enableMonthDecadeViewAnimation;
	      delete flexProps.showMonthDecadeViewAnimation;
	      delete flexProps.okButton;
	      return _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({
	        key: "multi_month_view",
	        column: true,
	        inline: true,
	        alignItems: "stretch",
	        wrap: false
	      }, flexProps), {}, {
	        className: className
	      }), children);
	    }
	  }, {
	    key: "renderRow",
	    value: function renderRow(rowIndex) {
	      var _this3 = this;
	      var props = this.p;
	      var viewProps = (0, _assign.default)({}, this.p);
	      delete viewProps.rootClassName;
	      delete viewProps.forceViewUpdate;
	      delete viewProps.index;
	      delete viewProps.inViewEnd;
	      delete viewProps.inViewStart;
	      delete viewProps.navigate;
	      delete viewProps.perRow;
	      delete viewProps.viewEnd;
	      delete viewProps.viewMoments;
	      delete viewProps.viewStart;
	      var children = times(props.perRow).map(function (i) {
	        var index = rowIndex * props.perRow + i;
	        var keys = "row_".concat(index * i);
	        if (index >= props.size) {
	          return null;
	        }
	        return _this3.renderView(viewProps, index, props.size, keys);
	      });
	      return _react.default.createElement(_Flex.Flex, {
	        key: "row_index_".concat(rowIndex),
	        inline: true,
	        row: true,
	        wrap: false,
	        children: children
	      });
	    }
	  }, {
	    key: "renderView",
	    value: function renderView(viewProps, index, size, keys) {
	      var _this4 = this;
	      var props = this.p;
	      var viewMoment = props.viewMoments[index];
	      var range;
	      if (props.range) {
	        range = props.rangeStart && props.range.length == 0 ? [props.rangeStart] : props.range;
	      }
	      var navBarKeys = keys * 8;
	      return _react.default.createElement(_MonthView.default, _objectSpread(_objectSpread({
	        ref: function ref(view) {
	          _this4.views[index] = view;
	        },
	        constrainViewDate: false
	      }, viewProps), {}, {
	        className: null,
	        index: index,
	        key: keys,
	        footer: false,
	        constrainActiveInView: false,
	        navigate: this.onMonthNavigate.bind(this, index),
	        hoverRange: this.state.hoverRange,
	        onHoverRangeChange: this.setHoverRange,
	        activeDate: props.activeDate,
	        onActiveDateChange: this.onActiveDateChange,
	        onViewDateChange: this.onAdjustViewDateChange,
	        date: props.date,
	        defaultDate: null,
	        onChange: this.onChange,
	        range: range,
	        defaultRange: null,
	        onRangeChange: this.onRangeChange,
	        viewMoment: viewMoment,
	        insideMultiView: true,
	        daysInView: props.daysInView[index],
	        showDaysBeforeMonth: index == 0,
	        showDaysAfterMonth: index == size - 1,
	        select: this.select,
	        renderNavBar: this.props.navigation && (this.props.renderNavBar || this.renderNavBar).bind(this, {
	          index: index,
	          viewMoment: viewMoment,
	          navBarKeys: navBarKeys
	        })
	      }));
	    }
	  }, {
	    key: "onFooterTodayClick",
	    value: function onFooterTodayClick() {
	      this.views[0].onFooterTodayClick();
	    }
	  }, {
	    key: "onFooterClearClick",
	    value: function onFooterClearClick() {
	      this.views[0].onFooterClearClick();
	    }
	  }, {
	    key: "onFooterOkClick",
	    value: function onFooterOkClick() {
	      this.views[0].onFooterOkClick();
	    }
	  }, {
	    key: "onFooterCancelClick",
	    value: function onFooterCancelClick() {
	      this.views[0].onFooterCancelClick();
	    }
	  }, {
	    key: "isFocused",
	    value: function isFocused() {
	      var firstView = this.views[0];
	      if (firstView) {
	        return firstView.isFocused();
	      }
	      return false;
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      var firstView = this.views[0];
	      if (firstView) {
	        firstView.focus();
	      }
	    }
	  }, {
	    key: "setHoverRange",
	    value: function setHoverRange(hoverRange) {
	      this.setState({
	        hoverRange: hoverRange
	      });
	    }
	  }, {
	    key: "select",
	    value: function select(_ref, event) {
	      var dateMoment = _ref.dateMoment,
	        timestamp = _ref.timestamp;
	      var props = this.p;
	      var visibleRange = [props.inViewStart, props.inViewEnd];
	      this.onAdjustViewDateChange({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	      this.onActiveDateChange({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	      var range = props.range;
	      if (range) {
	        this.selectRange({
	          dateMoment: dateMoment,
	          timestamp: timestamp
	        });
	      } else {
	        this.onChange({
	          dateMoment: dateMoment,
	          timestamp: timestamp
	        }, event);
	      }
	    }
	  }, {
	    key: "selectRange",
	    value: function selectRange(_ref2) {
	      var dateMoment = _ref2.dateMoment,
	        timestamp = _ref2.timestamp;
	      return _MonthView.default.prototype.selectRange.call(this, {
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "onRangeChange",
	    value: function onRangeChange(range) {
	      return _MonthView.default.prototype.onRangeChange.call(this, range);
	    }
	  }, {
	    key: "onViewKeyDown",
	    value: function onViewKeyDown() {
	      var view = this.views[0];
	      if (view) {
	        view.onViewKeyDown.apply(view, arguments);
	      }
	    }
	  }, {
	    key: "renderNavBar",
	    value: function renderNavBar(config, navBarProps) {
	      return _renderNavBar.call(this, config, navBarProps);
	    }
	  }, {
	    key: "onMonthNavigate",
	    value: function onMonthNavigate(index, dir, event, getNavigationDate) {
	      var props = this.p;
	      event.preventDefault();
	      if (!props.activeDate) {
	        return;
	      }
	      var key = event.key;
	      var homeEndDate = key == 'Home' ? props.viewStart : props.viewEnd;
	      var mom = key == 'Home' || key == 'End' ? homeEndDate : props.activeDate;
	      var nextMoment = getNavigationDate(dir, this.toMoment(mom));
	      var viewMoment = this.toMoment(nextMoment);
	      this.onActiveDateChange({
	        dateMoment: nextMoment,
	        timestamp: +nextMoment
	      });
	      if (this.isInRange(viewMoment)) {
	        return;
	      }
	      if (viewMoment.isAfter(props.viewEnd)) {
	        viewMoment.add(-props.size + 1, 'month');
	      }
	      this.onViewDateChange({
	        dateMoment: viewMoment,
	        timestamp: +viewMoment
	      });
	    }
	  }, {
	    key: "onAdjustViewDateChange",
	    value: function onAdjustViewDateChange(_ref3) {
	      var dateMoment = _ref3.dateMoment,
	        timestamp = _ref3.timestamp;
	      var props = this.p;
	      var update = dateMoment == null;
	      if (dateMoment && dateMoment.isAfter(props.viewEnd)) {
	        dateMoment = this.toMoment(dateMoment).add(-props.size + 1, 'month');
	        timestamp = +dateMoment;
	        update = true;
	      } else if (dateMoment && dateMoment.isBefore(props.viewStart)) {
	        update = true;
	      }
	      if (update) {
	        this.onViewDateChange({
	          dateMoment: dateMoment,
	          timestamp: timestamp
	        });
	      }
	    }
	  }, {
	    key: "updateViewMoment",
	    value: function updateViewMoment(dateMoment, dir) {
	      var sign = dir < 0 ? -1 : 1;
	      var abs = Math.abs(dir);
	      var newMoment = this.toMoment(this.p.viewStart);
	      newMoment.add(sign, abs == 1 ? 'month' : 'year');
	      return newMoment;
	    }
	  }, {
	    key: "renderHiddenNav",
	    value: function renderHiddenNav(props) {
	      return _react.default.createElement(_InlineBlock.default, _objectSpread(_objectSpread({}, props), {}, {
	        style: {
	          visibility: 'hidden'
	        }
	      }));
	    }
	  }, {
	    key: "isInRange",
	    value: function isInRange(moment) {
	      return (0, _isInRange2.default)(moment, [this.p.viewStart, this.p.viewEnd]);
	    }
	  }, {
	    key: "isInView",
	    value: function isInView(moment) {
	      return this.isInRange(moment);
	    }
	  }, {
	    key: "onNavViewDateChange",
	    value: function onNavViewDateChange(dateString, _ref4) {
	      var dateMoment = _ref4.dateMoment,
	        timestamp = _ref4.timestamp;
	      this.onViewDateChange({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "onViewDateChange",
	    value: function onViewDateChange(_ref5) {
	      var dateMoment = _ref5.dateMoment,
	        timestamp = _ref5.timestamp;
	      if (this.props.viewDate === undefined) {
	        this.setState({
	          viewDate: timestamp
	        });
	      }
	      if (this.props.onViewDateChange) {
	        var dateString = this.format(dateMoment);
	        this.props.onViewDateChange(dateString, {
	          dateMoment: dateMoment,
	          dateString: dateString,
	          timestamp: timestamp
	        });
	      }
	    }
	  }, {
	    key: "onActiveDateChange",
	    value: function onActiveDateChange(_ref6) {
	      var dateMoment = _ref6.dateMoment,
	        timestamp = _ref6.timestamp;
	      var valid = this.views.reduce(function (isValid, view) {
	        return isValid && view.isValidActiveDate(timestamp);
	      }, true);
	      if (!valid) {
	        return;
	      }
	      var props = this.p;
	      var range = props.range;
	      if (range && props.rangeStart) {
	        this.setState({
	          rangeStart: props.rangeStart,
	          range: (0, _clampRange.default)([props.rangeStart, dateMoment])
	        });
	      }
	      if (this.props.activeDate === undefined) {
	        this.setState({
	          activeDate: timestamp
	        });
	      }
	      if (this.props.onActiveDateChange) {
	        var dateString = this.format(dateMoment);
	        this.props.onActiveDateChange(dateString, {
	          dateMoment: dateMoment,
	          dateString: dateString,
	          timestamp: timestamp
	        });
	      }
	    }
	  }, {
	    key: "gotoViewDate",
	    value: function gotoViewDate(_ref7) {
	      var dateMoment = _ref7.dateMoment,
	        timestamp = _ref7.timestamp;
	      if (!timestamp) {
	        timestamp = +dateMoment;
	      }
	      this.onViewDateChange({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	      this.onActiveDateChange({
	        dateMoment: dateMoment,
	        timestamp: timestamp
	      });
	    }
	  }, {
	    key: "format",
	    value: function format(mom) {
	      return mom == null ? '' : mom.format(this.props.dateFormat);
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(_ref8, event) {
	      var dateMoment = _ref8.dateMoment,
	        timestamp = _ref8.timestamp;
	      if (this.props.date === undefined) {
	        this.setState({
	          date: timestamp
	        });
	      }
	      if (this.props.onChange) {
	        var dateString = this.format(dateMoment);
	        this.props.onChange(dateString, {
	          dateMoment: dateMoment,
	          dateString: dateString,
	          timestamp: timestamp
	        }, event);
	      }
	    }
	  }, {
	    key: "getViewSize",
	    value: function getViewSize() {
	      return this.props.size;
	    }
	  }]);
	  return MultiMonthView;
	}(_reactClass.default);
	exports.default = MultiMonthView;
	MultiMonthView.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__multi-month-view',
	  perRow: 2,
	  size: 2,
	  enableMonthDecadeView: true,
	  enableMonthDecadeViewAnimation: true,
	  showMonthDecadeViewAnimation: 300,
	  footerClearDate: null,
	  okButton: true,
	  isDatePicker: true,
	  forceViewUpdate: false,
	  navigation: true,
	  theme: 'default',
	  constrainActiveInView: true,
	  dateFormat: 'YYYY-MM-DD'
	};
	MultiMonthView.propTypes = {
	  rootClassName: _propTypes.default.string,
	  theme: _propTypes.default.string,
	  dateFormat: _propTypes.default.string,
	  locale: _propTypes.default.string,
	  perRow: _propTypes.default.number,
	  size: _propTypes.default.number,
	  daysInView: _propTypes.default.number,
	  clockTabIndex: _propTypes.default.number,
	  enableMonthDecadeView: _propTypes.default.bool,
	  footerClearDate: _propTypes.default.bool,
	  isDatePicker: _propTypes.default.bool,
	  forceViewUpdate: _propTypes.default.bool,
	  navigation: _propTypes.default.bool,
	  constrainActiveInView: _propTypes.default.bool,
	  constrainViewDate: _propTypes.default.bool,
	  inViewStart: _propTypes.default.bool,
	  inViewEnd: _propTypes.default.bool,
	  footer: _propTypes.default.bool,
	  highlightRangeOnMouseMove: _propTypes.default.bool,
	  enableMonthDecadeViewAnimation: _propTypes.default.bool,
	  viewStart: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number]),
	  viewEnd: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number]),
	  date: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number]),
	  defaultDate: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number]),
	  minDate: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number]),
	  maxDate: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number]),
	  viewDate: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number]),
	  viewMoment: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number]),
	  viewMoments: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number])),
	  defaultViewDate: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number]),
	  activeDate: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number]),
	  defaultActiveDate: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number]),
	  range: _propTypes.default.array,
	  defaultRange: _propTypes.default.array
	};

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _toTimeValue = _interopRequireDefault(__webpack_require__(235));
	var _leftPad = _interopRequireDefault(__webpack_require__(154));
	var _clamp = __webpack_require__(238);
	var removeAt = function removeAt(_ref) {
	  var value = _ref.value,
	    index = _ref.index,
	    _ref$len = _ref.len,
	    len = _ref$len === void 0 ? 1 : _ref$len;
	  return value.substring(0, index) + value.substring(index + len);
	};
	var replaceAt = function replaceAt(_ref2) {
	  var value = _ref2.value,
	    index = _ref2.index,
	    _ref2$len = _ref2.len,
	    len = _ref2$len === void 0 ? 1 : _ref2$len,
	    str = _ref2.str;
	  return value.substring(0, index) + str + value.substring(index + len);
	};
	var replaceBetween = function replaceBetween(_ref3) {
	  var value = _ref3.value,
	    start = _ref3.start,
	    end = _ref3.end,
	    str = _ref3.str;
	  return (value.substring(0, start) || '') + str + (value.substring(end) || '');
	};
	var toggleMeridiem = function toggleMeridiem(meridiem) {
	  return {
	    am: 'pm',
	    AM: 'PM',
	    pm: 'am',
	    PM: 'pm'
	  }[meridiem];
	};
	var getValueOnDelete = function getValueOnDelete(_ref4) {
	  var oldValue = _ref4.oldValue,
	    range = _ref4.range,
	    key = _ref4.key,
	    separator = _ref4.separator,
	    meridiem = _ref4.meridiem;
	  var start = range.start,
	    end = range.end;
	  var selectedValue = oldValue.substring(start, end);
	  var value;
	  if (selectedValue) {
	    var _replacement = selectedValue.split('').map(function (c) {
	      if (c == separator || c == ' ') {
	        return c;
	      }
	      if (meridiem && c * 1 != c) {
	        return c == 'p' ? 'a' : c == 'P' ? 'A' : c;
	      }
	      return 0;
	    }).join('');
	    value = replaceBetween({
	      value: oldValue,
	      start: start,
	      end: end,
	      str: _replacement
	    });
	    return {
	      value: value,
	      update: value != oldValue,
	      caretPos: key == 'Backspace' ? start : end
	    };
	  }
	  var back = key == 'Backspace';
	  var index = start + (back ? -1 : 0);
	  var caretPos = start + (back ? -1 : 1);
	  if (index < 0) {
	    return {
	      value: oldValue,
	      update: false
	    };
	  }
	  var char = oldValue[index];
	  value = oldValue;
	  var replacement = char == separator || char == ' ' ? char : 0;
	  if (char && char * 1 != char && replacement === 0 && meridiem) {
	    if (char == 'p') {
	      replacement = 'a';
	    } else if (char == 'P') {
	      replacement = 'A';
	    } else if (char == 'M' || char == 'm' || char == 'a' || char == 'A') {
	      replacement = char;
	    }
	  }
	  value = replaceAt({
	    value: oldValue,
	    index: index,
	    str: replacement
	  });
	  return {
	    update: value != oldValue,
	    value: value,
	    caretPos: caretPos
	  };
	};
	var ARROWS = {
	  ArrowUp: 1,
	  ArrowDown: -1,
	  PageUp: 10,
	  PageDown: -10
	};
	var TIME_PARTS = {
	  24: [{
	    start: 0,
	    end: 2,
	    name: 'hours',
	    max: 23
	  }, {
	    start: 3,
	    end: 5,
	    name: 'minutes',
	    max: 59
	  }, {
	    start: 6,
	    end: 8,
	    name: 'seconds',
	    max: 59
	  }],
	  12: [{
	    start: 0,
	    end: 2,
	    name: 'hours',
	    max: 12,
	    min: 1
	  }, {
	    start: 3,
	    end: 5,
	    name: 'minutes',
	    max: 59
	  }, {
	    start: 6,
	    end: 8,
	    name: 'seconds',
	    max: 59
	  }]
	};
	var getActiveTimePartIndex = function getActiveTimePartIndex(_ref5) {
	  var value = _ref5.value,
	    timeValue = _ref5.timeValue,
	    separator = _ref5.separator,
	    range = _ref5.range,
	    hours24 = _ref5.hours24,
	    meridiem = _ref5.meridiem;
	  var start = range.start;
	  var timeParts = TIME_PARTS[hours24 ? 24 : 12];
	  var partIndex = 0;
	  var currentPart;
	  while (currentPart = timeParts[partIndex]) {
	    if (currentPart.name == 'seconds' && timeValue && !timeValue.seconds) {
	      return 4;
	    }
	    if (start >= currentPart.start && start <= currentPart.end) {
	      return partIndex;
	    }
	    partIndex++;
	  }
	  return 4;
	};
	var getTimePartAt = function getTimePartAt(index, _ref6) {
	  var hours24 = _ref6.hours24;
	  return (0, _assign.default)({}, TIME_PARTS[hours24 ? 24 : 12][index]);
	};
	var getActiveTimePart = function getActiveTimePart(_ref7) {
	  var value = _ref7.value,
	    timeValue = _ref7.timeValue,
	    separator = _ref7.separator,
	    range = _ref7.range,
	    hours24 = _ref7.hours24,
	    meridiem = _ref7.meridiem;
	  var index = getActiveTimePartIndex({
	    value: value,
	    timeValue: timeValue,
	    separator: separator,
	    range: range,
	    hours24: hours24
	  });
	  if (index == 4 && meridiem) {
	    var timePart = {
	      start: 6,
	      end: 8,
	      name: 'meridiem'
	    };
	    if (timeValue.seconds) {
	      timePart.start += 3;
	      timePart.end += 3;
	    }
	    return timePart;
	  }
	  return getTimePartAt(index, {
	    hours24: hours24
	  });
	};
	var getValueOnDirection = function getValueOnDirection(_ref8) {
	  var oldValue = _ref8.oldValue,
	    range = _ref8.range,
	    separator = _ref8.separator,
	    dir = _ref8.dir,
	    incrementNext = _ref8.incrementNext,
	    circular = _ref8.circular,
	    propagate = _ref8.propagate,
	    hours24 = _ref8.hours24,
	    meridiem = _ref8.meridiem;
	  var start = range.start,
	    end = range.end;
	  var value;
	  var timeValue = (0, _toTimeValue.default)({
	    value: oldValue,
	    separator: separator,
	    meridiem: meridiem
	  });
	  var activeTimePart = getActiveTimePart({
	    value: oldValue,
	    timeValue: timeValue,
	    separator: separator,
	    range: range,
	    hours24: hours24,
	    meridiem: meridiem
	  });
	  if (activeTimePart.name != 'meridiem') {
	    timeValue[activeTimePart.name] = dir + timeValue[activeTimePart.name] * 1;
	  }
	  var hours = timeValue.hours,
	    minutes = timeValue.minutes,
	    seconds = timeValue.seconds;
	  var toggleMeridiemValue = false;
	  hours *= 1;
	  minutes *= 1;
	  if (seconds) {
	    seconds *= 1;
	  }
	  if (activeTimePart.name != 'meridiem') {
	    if (seconds && (seconds > 59 || seconds < 0)) {
	      if (propagate) {
	        minutes += seconds > 59 ? 1 : -1;
	      }
	      if (circular) {
	        seconds %= 60;
	        if (seconds < 0) {
	          seconds = 60 + seconds;
	        }
	      }
	    }
	    if (minutes && (minutes > 59 || minutes < 0)) {
	      if (propagate) {
	        hours += minutes > 59 ? 1 : -1;
	      }
	      if (circular) {
	        minutes %= 60;
	        if (minutes < 0) {
	          minutes = 60 + minutes;
	        }
	      }
	    }
	    if (meridiem && circular && (hours > 12 || hours < 1)) {
	      toggleMeridiemValue = true;
	    }
	  }
	  hours = (0, _leftPad.default)((0, _clamp.clampHour)(hours * 1, {
	    circular: circular,
	    max: activeTimePart.max,
	    min: activeTimePart.min
	  }));
	  minutes = (0, _leftPad.default)((0, _clamp.clampMinute)(minutes * 1, {
	    circular: circular
	  }));
	  if (seconds != undefined) {
	    seconds = (0, _leftPad.default)((0, _clamp.clampSecond)(seconds * 1, {
	      circular: circular
	    }));
	  }
	  value = hours + separator + minutes;
	  if (seconds) {
	    value += separator + seconds;
	  }
	  if (activeTimePart.name == 'meridiem') {
	    toggleMeridiemValue = true;
	  }
	  if (meridiem) {
	    value += " ".concat(toggleMeridiemValue ? toggleMeridiem(timeValue.meridiem) : timeValue.meridiem);
	  }
	  return {
	    value: value,
	    caretPos: activeTimePart || range.start,
	    update: oldValue != value
	  };
	};
	var getValueOnNumber = function getValueOnNumber(_ref9) {
	  var oldValue = _ref9.oldValue,
	    num = _ref9.num,
	    range = _ref9.range,
	    separator = _ref9.separator,
	    circular = _ref9.circular,
	    hours24 = _ref9.hours24,
	    meridiem = _ref9.meridiem;
	  var activeTimePartIndex = getActiveTimePartIndex({
	    value: oldValue,
	    separator: separator,
	    range: range,
	    hours24: hours24
	  });
	  var activeTimePart = getTimePartAt(activeTimePartIndex, {
	    hours24: hours24
	  });
	  if (activeTimePart && range.start == range.end && activeTimePart.end == range.end) {
	    activeTimePart = getTimePartAt(activeTimePartIndex + 1, {
	      hours24: hours24
	    });
	  }
	  if (!activeTimePart) {
	    return {
	      value: value,
	      update: false
	    };
	  }
	  var name = activeTimePart.name;
	  var timeParts = (0, _toTimeValue.default)({
	    value: oldValue,
	    separator: separator,
	    meridiem: meridiem
	  });
	  var timePartValue = "".concat(timeParts[name]);
	  var caretPos;
	  if (range.start <= activeTimePart.start) {
	    var maxFirstChar = "".concat(activeTimePart.max).charAt(0) * 1;
	    caretPos = range.start + (num > maxFirstChar ? 3 : range.start < activeTimePart.start ? 2 : 1);
	    timeParts[name] = num > maxFirstChar ? "0".concat(num) : num + timeParts[name].charAt(1);
	  } else {
	    caretPos = range.start + 2;
	    timeParts[name] = (0, _clamp.clampNamed)(name, replaceAt({
	      value: timePartValue,
	      index: 1,
	      str: num
	    }) * 1, {
	      circular: circular
	    });
	  }
	  var hours = timeParts.hours,
	    minutes = timeParts.minutes,
	    seconds = timeParts.seconds;
	  var value = hours + separator + minutes;
	  if (seconds) {
	    value += separator + seconds;
	  }
	  if (meridiem) {
	    value += " ".concat(timeParts.meridiem);
	  }
	  return {
	    value: value,
	    caretPos: caretPos,
	    update: true
	  };
	};
	function _default(_ref10) {
	  var oldValue = _ref10.oldValue,
	    range = _ref10.range,
	    event = _ref10.event,
	    _ref10$separator = _ref10.separator,
	    separator = _ref10$separator === void 0 ? ':' : _ref10$separator,
	    incrementNext = _ref10.incrementNext,
	    circular = _ref10.circular,
	    propagate = _ref10.propagate,
	    hours24 = _ref10.hours24,
	    meridiem = _ref10.meridiem;
	  var newChar = String.fromCharCode(event.which);
	  var start = range.start,
	    end = range.end;
	  var key = event.key;
	  if (key == 'Delete' || key == 'Backspace') {
	    return getValueOnDelete({
	      key: key,
	      oldValue: oldValue,
	      range: range,
	      separator: separator,
	      meridiem: meridiem
	    });
	  }
	  var dir = ARROWS[key];
	  if (dir) {
	    return getValueOnDirection({
	      hours24: hours24,
	      meridiem: meridiem,
	      dir: dir,
	      oldValue: oldValue,
	      range: range,
	      circular: circular,
	      propagate: propagate,
	      separator: separator,
	      incrementNext: incrementNext
	    });
	  }
	  if (key == 'Unidentified' && newChar * 1 == newChar) {
	    return getValueOnNumber({
	      num: newChar * 1,
	      circular: circular,
	      separator: separator,
	      oldValue: oldValue,
	      range: range,
	      meridiem: meridiem
	    });
	  }
	  return {
	    value: oldValue
	  };
	}

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSelectionEnd;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	var document = globalObject.document;
	function getSelectionEnd(o) {
	  if (o.createTextRange && !globalObject.getSelection) {
	    var r = document.selection.createRange().duplicate();
	    r.moveStart('character', -o.value.length);
	    return r.text.length;
	  }
	  return o.selectionEnd;
	}

/***/ },
/* 634 */
253,
/* 635 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setCaretPosition;
	function setCaretPosition(elem, caretPos) {
	  var start = caretPos;
	  var end = caretPos;
	  if (caretPos && (caretPos.start != undefined || caretPos.end != undefined)) {
	    start = caretPos.start || 0;
	    end = caretPos.end || start;
	  }
	  if (elem != null) {
	    if (elem.createTextRange) {
	      var range = elem.createTextRange();
	      range.moveStart('character', start);
	      range.moveEnd('character', end);
	      range.select();
	    } else {
	      elem.focus();
	      elem.setSelectionRange(start, end);
	    }
	  }
	}

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _Flex = __webpack_require__(41);
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _TimeInput = _interopRequireDefault(__webpack_require__(153));
	var _Clock = _interopRequireDefault(__webpack_require__(106));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var TimePicker = function (_Component) {
	  (0, _inherits2.default)(TimePicker, _Component);
	  var _super = _createSuper(TimePicker);
	  function TimePicker(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, TimePicker);
	    _this = _super.call(this, props);
	    _this.state = {};
	    return _this;
	  }
	  (0, _createClass2.default)(TimePicker, [{
	    key: "render",
	    value: function render() {
	      var props = this.p = (0, _assign.default)({}, this.props);
	      var rootClassName = props.rootClassName;
	      props.children = _react.default.Children.toArray(props.children);
	      var timeFormat = props.timeFormat.toLowerCase();
	      props.hasTime = props.hasTime || timeFormat.indexOf('k') != -1 || timeFormat.indexOf('h') != -1;
	      var className = (0, _join.default)(props.className, rootClassName, props.theme && "".concat(rootClassName, "--theme-").concat(props.theme));
	      return _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({
	        inline: true,
	        column: true,
	        wrap: false
	      }, this.props), {}, {
	        className: className
	      }), this.renderClock(), this.renderInput());
	    }
	  }, {
	    key: "renderInput",
	    value: function renderInput() {
	      return _react.default.createElement(_TimeInput.default, {
	        className: "".concat(this.props.rootClassName, "__time-picker-input"),
	        format: this.props.timeFormat || this.props.format,
	        defaultValue: this.props.value || this.props.defaultValue,
	        onChange: this.onTimeChange
	      });
	    }
	  }, {
	    key: "onTimeChange",
	    value: function onTimeChange(value) {
	      var time = value.split(':');
	      var seconds = time[0] * 3600 + parseInt(time[1], 10) * 60;
	      if (time[2]) {
	        seconds += parseInt(time[2], 10);
	      }
	      this.setState({
	        seconds: seconds
	      });
	      if (this.props.onChange) {
	        this.props.onChange(value);
	      }
	    }
	  }, {
	    key: "renderClock",
	    value: function renderClock() {
	      var props = this.p;
	      var clock = props.children.filter(function (child) {
	        return child && child.props && child.props.isTimePickerClock;
	      })[0];
	      var clockProps = {
	        seconds: this.state.seconds,
	        showSecondsHand: true
	      };
	      if (clock) {
	        return _react.default.cloneElement(clock, clockProps);
	      }
	      return _react.default.createElement(_Clock.default, _objectSpread({}, clockProps));
	    }
	  }]);
	  return TimePicker;
	}(_reactClass.default);
	exports.default = TimePicker;
	TimePicker.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__time-picker',
	  format: 'HH:mm:ss a',
	  theme: 'default',
	  isTimePicker: true
	};
	TimePicker.propTypes = {
	  format: _propTypes.default.string,
	  theme: _propTypes.default.string,
	  isTimePicker: _propTypes.default.bool
	};

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _Flex = __webpack_require__(41);
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _toMoment2 = _interopRequireDefault(__webpack_require__(40));
	var _forwardTime = _interopRequireDefault(__webpack_require__(110));
	var _getTransitionEnd = _interopRequireDefault(__webpack_require__(639));
	var _assignDefined = _interopRequireDefault(__webpack_require__(62));
	var _MonthView = __webpack_require__(108);
	var _NavBar = _interopRequireDefault(__webpack_require__(109));
	var _times = _interopRequireDefault(__webpack_require__(111));
	var _InlineBlock = _interopRequireDefault(__webpack_require__(107));
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var renderHiddenNav = function renderHiddenNav(props) {
	  return _react.default.createElement(_InlineBlock.default, _objectSpread(_objectSpread({}, props), {}, {
	    style: {
	      visibility: 'hidden'
	    }
	  }));
	};
	var joinFunctions = function joinFunctions(a, b) {
	  if (a && b) {
	    return function () {
	      a.apply(void 0, arguments);
	      b.apply(void 0, arguments);
	    };
	  }
	  return a || b;
	};
	var TRANSITION_DURATION = '0.4s';
	var TransitionView = function (_Component) {
	  (0, _inherits2.default)(TransitionView, _Component);
	  var _super = _createSuper(TransitionView);
	  function TransitionView(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, TransitionView);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
	      if (prevProps.viewDate !== _this.props.viewDate) {
	        _this.transitionTo(_this.props.viewDate, _this.props);
	      }
	    });
	    var child = _react.default.Children.toArray(_this.props.children)[0];
	    var childProps = child.props;
	    var viewDate = props.viewDate || props.defaultViewDate || props.defaultDate || props.date || childProps.viewDate || childProps.defaultViewDate || childProps.defaultDate || childProps.date;
	    var dateFormat = props.dateFormat || childProps.dateFormat;
	    var locale = props.locale || childProps.locale;
	    _this.state = {
	      rendered: false,
	      viewDate: _this.toMoment(viewDate, {
	        dateFormat: dateFormat,
	        locale: locale
	      })
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(TransitionView, [{
	    key: "toMoment",
	    value: function toMoment(value, props) {
	      props = props || this.props;
	      return (0, _toMoment2.default)(value, {
	        locale: props.locale,
	        dateFormat: props.dateFormat
	      });
	    }
	  }, {
	    key: "format",
	    value: function format(mom, props) {
	      props = props || this.props;
	      return mom.format(props.dateFormat);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({
	        rendered: true
	      });
	    }
	  }, {
	    key: "transitionTo",
	    value: function transitionTo(date, props) {
	      props = props || this.props;
	      var dateMoment = this.toMoment(date, props);
	      this.doTransition(dateMoment);
	    }
	  }, {
	    key: "getViewChild",
	    value: function getViewChild() {
	      return _react.default.Children.toArray(this.props.children).filter(function (c) {
	        return c && c.props && c.props.isDatePicker;
	      })[0];
	    }
	  }, {
	    key: "prepareChildProps",
	    value: function prepareChildProps(child, extraProps) {
	      if (this.view) {
	        return this.view.p;
	      }
	      child = child || this.getViewChild();
	      return (0, _assign.default)({}, child.props, extraProps);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	      var props = this.props;
	      var rootClassName = props.rootClassName;
	      var child = this.child = this.getViewChild();
	      var viewDate = this.state.viewDate || props.viewMoment || props.viewDate;
	      var renderedChildProps = this.renderedChildProps = this.prepareChildProps(child, (0, _assignDefined.default)({
	        viewDate: viewDate
	      }));
	      viewDate = this.state.viewDate || renderedChildProps.viewMoment || renderedChildProps.viewDate;
	      if (!this.state.transition) {
	        this.viewDate = viewDate;
	      }
	      var multiView = !!(child.props.size && child.props.size >= 2);
	      var onViewDateChange = joinFunctions(this.onViewDateChange, props.onViewDateChange);
	      var newProps = {
	        key: 'picker',
	        ref: function ref(v) {
	          _this2.view = v;
	        },
	        viewDate: this.viewDate,
	        onViewDateChange: onViewDateChange,
	        navigation: multiView,
	        constrainActiveInView: props.constrainActiveInView,
	        className: (0, _join.default)(child.props.className, 'inovua-react-toolkit-calendar__center')
	      };
	      (0, _assignDefined.default)(newProps, {
	        range: props.range,
	        date: props.date,
	        activeDate: props.activeDate,
	        footer: false,
	        insideField: props.insideField,
	        defaultRange: props.defaultRange,
	        defaultDate: props.defaultDate,
	        defaultActiveDate: props.defaultActiveDate,
	        onTimeChange: props.onTimeChange,
	        onClockInputBlur: props.onClockInputBlur,
	        onClockInputFocus: props.onClockInputFocus,
	        onClockEnterKey: props.onClockEnterKey,
	        onClockEscapeKey: props.onClockEscapeKey,
	        showClock: props.showClock,
	        tabIndex: props.tabIndex,
	        dateFormat: props.dateFormat,
	        locale: props.locale,
	        theme: props.theme,
	        minDate: props.minDate,
	        maxDate: props.maxDate,
	        onKeyDown: this.onKeyDown,
	        onBlur: this.onBlur
	      });
	      if (props.onChange) {
	        newProps.onChange = joinFunctions(props.onChange, renderedChildProps.onChange);
	      }
	      if (props.onRangeChange) {
	        newProps.onRangeChange = joinFunctions(props.onRangeChange, renderedChildProps.onRangeChange);
	      }
	      if (props.onActiveDateChange) {
	        newProps.onActiveDateChange = joinFunctions(props.onActiveDateChange, renderedChildProps.onActiveDateChange);
	      }
	      if (this.state.transition) {
	        this.transitionDurationStyle = {
	          transitionDuration: props.transitionDuration || TRANSITION_DURATION
	        };
	        newProps.style = (0, _assign.default)({}, child.props.style, this.transitionDurationStyle);
	        newProps.className = (0, _join.default)(newProps.className, 'inovua-react-toolkit-calendar--transition', "inovua-react-toolkit-calendar--transition-".concat(this.state.transition == -1 ? 'left' : 'right'));
	      }
	      var navBar;
	      var navBarProps = {
	        minDate: props.minDate || renderedChildProps.minDate,
	        maxDate: props.maxDate || renderedChildProps.maxDate,
	        enableMonthDecadeView: props.enableMonthDecadeView === undefined ? renderedChildProps.enableMonthDecadeView : props.enableMonthDecadeView,
	        secondary: true,
	        viewDate: this.nextViewDate || this.viewDate,
	        onViewDateChange: onViewDateChange,
	        multiView: multiView,
	        enableMonthDecadeViewAnimation: props.enableMonthDecadeViewAnimation,
	        showMonthDecadeViewAnimation: props.showMonthDecadeViewAnimation
	      };
	      if (props.navigation) {
	        navBar = this.renderNavBar((0, _assign.default)({}, navBarProps, {
	          mainNavBar: true
	        }));
	      }
	      var footer;
	      if (props.footer) {
	        footer = (0, _MonthView.renderFooter)(props, props.insideField ? props : this.view);
	      }
	      if (multiView) {
	        newProps.renderNavBar = this.renderMultiViewNavBar.bind(this, navBarProps);
	      }
	      var clone = _react.default.cloneElement(child, newProps);
	      var flexProps = (0, _assign.default)({}, props);
	      delete flexProps.constrainActiveInView;
	      delete flexProps.enableMonthDecadeView;
	      delete flexProps.focusOnNavMouseDown;
	      delete flexProps.focusOnTransitionEnd;
	      delete flexProps.footerClearDate;
	      delete flexProps.isDatePicker;
	      delete flexProps.navigation;
	      delete flexProps.onTransitionEnd;
	      delete flexProps.onTransitionStart;
	      delete flexProps.theme;
	      delete flexProps.rootClassName;
	      delete flexProps.enableMonthDecadeViewAnimation;
	      delete flexProps.showMonthDecadeViewAnimation;
	      delete flexProps.footer;
	      return _react.default.createElement(_Flex.Flex, _objectSpread(_objectSpread({
	        column: true,
	        inline: true,
	        wrap: false,
	        alignItems: "stretch"
	      }, flexProps), {}, {
	        className: (0, _join.default)(props.className, rootClassName, props.theme && "".concat(rootClassName, "--theme-").concat(props.theme))
	      }), navBar, _react.default.createElement(_Flex.Flex, {
	        inline: true,
	        row: true,
	        style: {
	          position: 'relative',
	          overflow: 'hidden'
	        }
	      }, this.renderAt(-1, {
	        multiView: multiView,
	        navBarProps: navBarProps
	      }), clone, this.renderAt(1, {
	        multiView: multiView,
	        navBarProps: navBarProps
	      })), footer);
	    }
	  }, {
	    key: "tryNavBarKeyDown",
	    value: function tryNavBarKeyDown(event) {
	      if (this.navBar && this.navBar.getMonthDecadeView) {
	        var monthDecadeView = this.navBar.getMonthDecadeView();
	        if (monthDecadeView && monthDecadeView.onKeyDown) {
	          monthDecadeView.onKeyDown(event);
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: "onKeyDown",
	    value: function onKeyDown(event) {
	      var initialKeyDown = this.child.onKeyDown;
	      if (this.tryNavBarKeyDown(event)) {
	        return false;
	      }
	      if (initialKeyDown) {
	        return initialKeyDown(event);
	      }
	    }
	  }, {
	    key: "isMonthDecadeViewVisible",
	    value: function isMonthDecadeViewVisible() {
	      if (this.navBar && this.navBar.isMonthDecadeViewVisible) {
	        return this.navBar.isMonthDecadeViewVisible();
	      }
	      return false;
	    }
	  }, {
	    key: "showMonthDecadeView",
	    value: function showMonthDecadeView() {
	      if (this.navBar) {
	        this.navBar.showMonthDecadeView();
	      }
	    }
	  }, {
	    key: "hideMonthDecadeView",
	    value: function hideMonthDecadeView() {
	      if (this.navBar) {
	        this.navBar.hideMonthDecadeView();
	      }
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur(event) {
	      var initialBlur = this.child.onBlur;
	      this.hideMonthDecadeView();
	      if (initialBlur) {
	        initialBlur(event);
	      }
	      return true;
	    }
	  }, {
	    key: "renderMultiViewNavBar",
	    value: function renderMultiViewNavBar(navBarProps, config) {
	      var index = config.index;
	      var count = this.child.props.perRow;
	      if (index >= count) {
	        var viewDate = this.toMoment(navBarProps.viewDate).add(index, 'month');
	        return _react.default.createElement(_NavBar.default, _objectSpread(_objectSpread({}, navBarProps), {}, {
	          renderNavNext: renderHiddenNav,
	          renderNavPrev: renderHiddenNav,
	          onViewDateChange: null,
	          viewDate: this.toMoment(viewDate)
	        }));
	      }
	      return null;
	    }
	  }, {
	    key: "renderNavBar",
	    value: function renderNavBar(navBarProps) {
	      var _this3 = this;
	      navBarProps = (0, _assign.default)({}, navBarProps);
	      if (navBarProps.mainNavBar) {
	        navBarProps.ref = function (navBar) {
	          _this3.navBar = navBar;
	        };
	        navBarProps.onMouseDown = this.onNavMouseDown;
	      }
	      var props = this.props;
	      var _navBarProps = navBarProps,
	        multiView = _navBarProps.multiView;
	      var navBar = _react.default.Children.toArray(props.children).filter(function (c) {
	        return c && c.props && c.props.isDatePickerNavBar;
	      })[0];
	      var newProps = navBarProps;
	      if (navBar) {
	        newProps = (0, _assign.default)({}, navBarProps, navBar.props);
	        newProps.viewDate = navBarProps.viewDate;
	        newProps.onViewDateChange = navBarProps.onViewDateChange;
	      }
	      if (multiView) {
	        var count = this.child.props.perRow;
	        var viewSize = this.getViewSize();
	        var bars = (0, _times.default)(count).map(function (index) {
	          var onUpdate = function onUpdate(dateMoment, dir) {
	            var mom = _this3.toMoment(newProps.viewDate);
	            if (Math.abs(dir) == 1) {
	              mom.add(dir * viewSize, 'month');
	            } else {
	              var sign = dir > 0 ? 1 : -1;
	              mom.add(sign, 'year');
	            }
	            return mom;
	          };
	          var barProps = (0, _assign.default)({}, newProps, {
	            onUpdate: onUpdate,
	            renderNavNext: renderHiddenNav,
	            renderNavPrev: renderHiddenNav,
	            viewDate: _this3.toMoment(newProps.viewDate).add(index, 'month')
	          });
	          delete barProps.rootClassName;
	          if (index == 0) {
	            delete barProps.renderNavPrev;
	          }
	          if (index == count - 1) {
	            delete barProps.renderNavNext;
	          }
	          return _react.default.createElement(_NavBar.default, _objectSpread({
	            flex: true
	          }, barProps));
	        });
	        return _react.default.createElement(_Flex.Flex, {
	          row: true,
	          children: bars
	        });
	      }
	      return navBar ? _react.default.cloneElement(navBar, newProps) : _react.default.createElement(_NavBar.default, _objectSpread({}, newProps));
	    }
	  }, {
	    key: "getViewSize",
	    value: function getViewSize() {
	      return this.view && this.view.getViewSize ? this.view.getViewSize() || 1 : 1;
	    }
	  }, {
	    key: "renderAt",
	    value: function renderAt(index, _ref) {
	      var multiView = _ref.multiView,
	        navBarProps = _ref.navBarProps;
	      if (!this.state.rendered || !this.view) {
	        return null;
	      }
	      var viewSize = this.getViewSize();
	      var viewDiff = viewSize * index;
	      var childProps = this.child.props;
	      var renderedProps = this.renderedChildProps;
	      var viewDate = this.toMoment(this.viewDate).add(viewDiff, 'month');
	      if (this.nextViewDate && this.state.prepareTransition == -index) {
	        viewDate = this.nextViewDate;
	      }
	      var date = renderedProps.date || renderedProps.moment;
	      if (this.state.transitionTime) {
	        date = (0, _forwardTime.default)(this.state.transitionTime, this.toMoment(date));
	      }
	      var newProps = (0, _assign.default)({
	        date: date,
	        readOnly: true,
	        range: renderedProps.range,
	        activeDate: renderedProps.activeDate,
	        dateFormat: renderedProps.dateFormat,
	        locale: renderedProps.locale,
	        tabIndex: -1,
	        clockTabIndex: -1,
	        navigation: multiView,
	        viewDate: viewDate,
	        key: index,
	        footer: false,
	        className: (0, _join.default)(childProps.className, "inovua-react-toolkit-calendar__".concat(index == -1 ? 'prev' : 'next'))
	      });
	      (0, _assignDefined.default)(newProps, {
	        showClock: renderedProps.showClock,
	        minDate: renderedProps.minDate,
	        maxDate: renderedProps.maxDate
	      });
	      if (this.state.transition && this.state.transition != index) {
	        newProps.style = (0, _assign.default)({}, childProps.style, this.transitionDurationStyle);
	        newProps.className = (0, _join.default)(newProps.className, 'inovua-react-toolkit-calendar--transition', "inovua-react-toolkit-calendar--transition-".concat(this.state.transition == -1 ? 'left' : 'right'));
	      }
	      if (multiView) {
	        newProps.renderNavBar = this.renderMultiViewNavBar.bind(this, (0, _assign.default)({}, navBarProps, {
	          viewDate: viewDate,
	          onViewDateChange: null
	        }));
	      }
	      return _react.default.cloneElement(this.child, newProps);
	    }
	  }, {
	    key: "getView",
	    value: function getView() {
	      return this.view;
	    }
	  }, {
	    key: "isInView",
	    value: function isInView() {
	      var _this$view;
	      return (_this$view = this.view).isInView.apply(_this$view, arguments);
	    }
	  }, {
	    key: "onViewDateChange",
	    value: function onViewDateChange(dateString, _ref2) {
	      var dateMoment = _ref2.dateMoment;
	      this.doTransition(dateMoment);
	    }
	  }, {
	    key: "doTransition",
	    value: function doTransition(dateMoment) {
	      var _this4 = this;
	      if (this.state.transition) {
	        return;
	      }
	      dateMoment = this.toMoment(dateMoment);
	      var newMoment = this.toMoment(dateMoment).startOf('month');
	      var viewMoment = this.toMoment(this.viewDate).startOf('month');
	      if (newMoment.format('YYYY-MM') == viewMoment.format('YYYY-MM')) {
	        return;
	      }
	      var navNext = newMoment.isAfter(viewMoment);
	      var transition = navNext ? -1 : 1;
	      var viewSize = this.getViewSize();
	      if (Math.abs(viewSize) > 1) {
	        var temp = this.toMoment(viewMoment).add(viewSize * -transition, 'month');
	        if (navNext) {
	          dateMoment = dateMoment.isAfter(temp) ? dateMoment : temp;
	        } else {
	          dateMoment = dateMoment.isBefore(temp) ? dateMoment : temp;
	        }
	      }
	      var transitionTime = this.props.getTransitionTime ? this.props.getTransitionTime() : null;
	      this.setState({
	        transitionTime: transitionTime,
	        prepareTransition: transition
	      }, function () {
	        setTimeout(function () {
	          if (!_this4.getViewDOMNode()) {
	            return;
	          }
	          _this4.nextViewDate = dateMoment;
	          _this4.addTransitionEnd();
	          _this4.setState({
	            transition: transition
	          });
	        });
	      });
	    }
	  }, {
	    key: "getViewDOMNode",
	    value: function getViewDOMNode() {
	      return this.view.getDOMNode ? this.view.getDOMNode() : null;
	    }
	  }, {
	    key: "addTransitionEnd",
	    value: function addTransitionEnd() {
	      var dom = this.getViewDOMNode();
	      if (dom) {
	        dom.addEventListener((0, _getTransitionEnd.default)(), this.onTransitionEnd, false);
	      }
	    }
	  }, {
	    key: "removeTransitionEnd",
	    value: function removeTransitionEnd(dom) {
	      dom = dom || this.getViewDOMNode();
	      if (dom) {
	        dom.removeEventListener((0, _getTransitionEnd.default)(), this.onTransitionEnd);
	      }
	    }
	  }, {
	    key: "onTransitionEnd",
	    value: function onTransitionEnd() {
	      this.removeTransitionEnd();
	      if (!this.nextViewDate) {
	        return;
	      }
	      this.setState({
	        viewDate: this.nextViewDate,
	        transition: 0,
	        prepareTransition: 0
	      });
	      if (this.props.focusOnTransitionEnd) {
	        this.focus();
	      }
	      delete this.nextViewDate;
	    }
	  }, {
	    key: "onNavMouseDown",
	    value: function onNavMouseDown() {
	      if (this.props.focusOnNavMouseDown && !this.isFocused()) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "isFocused",
	    value: function isFocused() {
	      var view = this.getView();
	      if (view) {
	        return view.isFocused();
	      }
	      return false;
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.getView().focus();
	    }
	  }]);
	  return TransitionView;
	}(_reactClass.default);
	exports.default = TransitionView;
	TransitionView.propTypes = {
	  children: _propTypes.default.node.isRequired,
	  rootClassName: _propTypes.default.string,
	  focusOnNavMouseDown: _propTypes.default.bool,
	  onTransitionStart: _propTypes.default.func,
	  onTransitionEnd: _propTypes.default.func,
	  footerClearDate: _propTypes.default.bool,
	  enableMonthDecadeView: _propTypes.default.bool,
	  constrainActiveInView: _propTypes.default.bool,
	  focusOnTransitionEnd: _propTypes.default.bool,
	  navigation: _propTypes.default.bool,
	  theme: _propTypes.default.string,
	  isDatePicker: _propTypes.default.bool,
	  enableMonthDecadeViewAnimation: _propTypes.default.bool,
	  showMonthDecadeViewAnimation: _propTypes.default.number
	};
	TransitionView.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-calendar__transition-month-view',
	  focusOnNavMouseDown: true,
	  enableMonthDecadeViewAnimation: true,
	  showMonthDecadeViewAnimation: 300,
	  onTransitionStart: function onTransitionStart() {},
	  onTransitionEnd: function onTransitionEnd() {},
	  footerClearDate: null,
	  enableMonthDecadeView: true,
	  constrainActiveInView: false,
	  focusOnTransitionEnd: false,
	  navigation: true,
	  theme: 'default-light',
	  isDatePicker: true
	};

/***/ },
/* 638 */
577,
/* 639 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var map = {
	  WebkitTransition: 'webkitTransitionEnd',
	  MozTransition: 'transitionend',
	  OTransition: 'oTransitionEnd',
	  msTransition: 'MSTransitionEnd',
	  transition: 'transitionend'
	};
	var EL;
	var RESULT;
	var _default = function _default() {
	  if (!EL) {
	    EL = document.createElement('p');
	  }
	  if (RESULT) {
	    return RESULT;
	  }
	  for (var transition in map) {
	    if (EL.style[transition] != null) {
	      RESULT = map[transition];
	      break;
	    }
	  }
	  return RESULT;
	};
	exports.default = _default;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toMoment = _interopRequireDefault(__webpack_require__(40));
	var CONFIG = {
	  dayFormat: 'D',
	  monthFormat: 'MMMM',
	  yearFormat: 'YYYY'
	};
	var f = function f(mom, format) {
	  return (0, _toMoment.default)(mom).format(format);
	};
	var _default = {
	  day: function day(mom, format) {
	    return f(mom, format || CONFIG.dayFormat);
	  },
	  month: function month(mom, format) {
	    return f(mom, format || CONFIG.monthFormat);
	  },
	  year: function year(mom, format) {
	    return f(mom, format || CONFIG.yearFormat);
	  }
	};
	exports.default = _default;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekDayNames;
	var _moment = _interopRequireDefault(__webpack_require__(3));
	var DEFAULT_WEEK_START_DAY = (0, _moment.default)().startOf('week').format('d') * 1;
	function getWeekDayNames(startDay, locale) {
	  var weekDays;
	  if (locale) {
	    var data = _moment.default.localeData(locale);
	    weekDays = data && data._weekdaysShort ? data._weekdaysShort : weekDays;
	  }
	  weekDays = (weekDays || _moment.default.weekdaysMin()).concat();
	  var names = weekDays;
	  var index = startDay == null ? DEFAULT_WEEK_START_DAY : startDay;
	  while (index > 0) {
	    names.push(names.shift());
	    index--;
	  }
	  return names;
	}

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = __webpack_require__(30);
	var _uglified = _interopRequireDefault(__webpack_require__(57));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _getClassNames = _interopRequireDefault(__webpack_require__(645));
	var _icons = __webpack_require__(643);
	var _InovuaCheckBox$propT;
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	var isValidCheckValue = function isValidCheckValue(value, props) {
	  return value === props.checkedValue || value === props.uncheckedValue || value === props.indeterminateValue && props.supportIndeterminate;
	};
	var nextValue = function nextValue(oldValue, props) {
	  if (oldValue === props.checkedValue) {
	    return props.uncheckedValue;
	  }
	  if (oldValue === props.uncheckedValue) {
	    return props.supportIndeterminate ? props.indeterminateValue : props.checkedValue;
	  }
	  if (props.supportIndeterminate && oldValue === props.indeterminateValue) {
	    return props.checkedValue;
	  }
	  return props.uncheckedValue;
	};
	var getComponentStyle = function getComponentStyle(props, state) {
	  var focused = state.focused;
	  var disabled = props.disabled,
	    focusedStyle = props.focusedStyle,
	    disabledStyle = props.disabledStyle,
	    readOnly = props.readOnly,
	    readOnlyStyle = props.readOnlyStyle,
	    style = props.style;
	  var styles = [style || {}];
	  if (focused) {
	    styles.push(focusedStyle);
	  }
	  if (disabled) {
	    styles.push(disabledStyle);
	  }
	  if (readOnly) {
	    styles.push(readOnlyStyle);
	  }
	  return _assign.default.apply(void 0, [{}].concat(styles));
	};
	var getComputedIconStyle = function getComputedIconStyle(config) {
	  var focused = config.focused,
	    disabled = config.disabled,
	    focusedIconStyle = config.focusedIconStyle,
	    disabledIconStyle = config.disabledIconStyle,
	    iconStyle = config.iconStyle;
	  var styles = [iconStyle];
	  styles.push(getIconSizeStyle(config));
	  if (focused) {
	    styles.push(focusedIconStyle);
	  }
	  if (disabled) {
	    styles.push(disabledIconStyle);
	  }
	  return _assign.default.apply(void 0, [{}].concat(styles));
	};
	var getIconClassName = function getIconClassName(props) {
	  var iconClassName = '';
	  if (props.iconClassName) {
	    iconClassName = props.iconClassName;
	  }
	  if (props.disabled && props.disabledIconClassName) {
	    iconClassName = (0, _join.default)(iconClassName, props.disabledIconClassName);
	  }
	  if (props.focused && props.focusedIconClassName) {
	    iconClassName = (0, _join.default)(iconClassName, props.focusedIconClassName);
	  }
	  if (props.readOnly && props.readOnlyIconClassName) {
	    iconClassName = (0, _join.default)(iconClassName, props.readOnlyIconClassName);
	  }
	  return iconClassName;
	};
	var renderIconFunctionOrJSX = function renderIconFunctionOrJSX(iconRender, props, _ref) {
	  var style = _ref.style,
	    className = _ref.className;
	  if (typeof iconRender === 'function') {
	    return iconRender({
	      style: style,
	      className: className
	    }, props);
	  }
	  return _react.default.cloneElement(iconRender, {
	    style: _objectSpread(_objectSpread({}, iconRender.props.style), style),
	    className: (0, _join.default)(iconRender.props.className, className)
	  });
	};
	var renderCheckedIcon = function renderCheckedIcon(props, iconProps) {
	  var checkedIcon = props.checkedIcon,
	    checkedIconSrc = props.checkedIconSrc;
	  if (checkedIconSrc) {
	    return _react.default.createElement("img", _objectSpread(_objectSpread({}, iconProps), {}, {
	      src: checkedIconSrc
	    }));
	  }
	  return renderIconFunctionOrJSX(checkedIcon, props, iconProps);
	};
	var renderUncheckedIcon = function renderUncheckedIcon(props, iconProps) {
	  var uncheckedIcon = props.uncheckedIcon,
	    uncheckedIconSrc = props.uncheckedIconSrc;
	  if (uncheckedIconSrc) {
	    return _react.default.createElement("img", _objectSpread(_objectSpread({}, iconProps), {}, {
	      src: uncheckedIconSrc
	    }));
	  }
	  return renderIconFunctionOrJSX(uncheckedIcon, props, iconProps);
	};
	var renderIndeterminateIcon = function renderIndeterminateIcon(props, iconProps) {
	  var indeterminateIcon = props.indeterminateIcon,
	    indeterminateIconSrc = props.indeterminateIconSrc;
	  if (indeterminateIconSrc) {
	    return _react.default.createElement("img", _objectSpread(_objectSpread({}, iconProps), {}, {
	      src: indeterminateIconSrc
	    }));
	  }
	  return renderIconFunctionOrJSX(indeterminateIcon, props, iconProps);
	};
	var renderIcon = function renderIcon(config) {
	  var checkedDescriptor = getCheckedDescriptor(config.checked, config);
	  var checkBoxIconStyle = getComputedIconStyle(config);
	  var iconProps = {
	    className: getIconClassName(config),
	    style: checkBoxIconStyle
	  };
	  switch (checkedDescriptor) {
	    case CHECKED_STATE:
	      return renderCheckedIcon(config, iconProps);
	    case UNCHECKED_STATE:
	      return renderUncheckedIcon(config, iconProps);
	    case INDETERMINATE_STATE:
	      return renderIndeterminateIcon(config, iconProps);
	  }
	};
	var getIconSizeStyle = function getIconSizeStyle(props) {
	  var style = {};
	  var iconSize = props.iconSize;
	  if (Array.isArray(iconSize)) {
	    style.width = iconSize[0];
	    style.height = iconSize[1];
	  } else {
	    style.width = style.height = iconSize;
	  }
	  return style;
	};
	var CHECKED_STATE = 'checked';
	var UNCHECKED_STATE = 'unchecked';
	var INDETERMINATE_STATE = 'indeterminate';
	var getCheckedDescriptor = function getCheckedDescriptor(checked, props) {
	  var checkedValue = props.checkedValue,
	    supportIndeterminate = props.supportIndeterminate,
	    indeterminateValue = props.indeterminateValue;
	  if (checked === checkedValue) {
	    return CHECKED_STATE;
	  }
	  if (supportIndeterminate && checked === indeterminateValue) {
	    return INDETERMINATE_STATE;
	  }
	  return UNCHECKED_STATE;
	};
	var renderHiddenInput = function renderHiddenInput(props) {
	  var withHiddenInput = props.withHiddenInput,
	    name = props.name;
	  var checked = props.checked;
	  var checkedDescriptor = getCheckedDescriptor(checked, props);
	  switch (checkedDescriptor) {
	    case CHECKED_STATE:
	      checked = props.checkedSubmitValue === undefined ? props.checkedValue : props.checkedSubmitValue;
	      break;
	    case UNCHECKED_STATE:
	      checked = props.uncheckedSubmitValue === undefined ? props.uncheckedValue : props.uncheckedSubmitValue;
	      break;
	    case INDETERMINATE_STATE:
	      checked = props.indeterminateSubmitValue === undefined ? props.indeterminateValue : props.indeterminateSubmitValue;
	  }
	  if (checked === null) {
	    checked = '';
	  }
	  if (withHiddenInput) {
	    return _react.default.createElement("input", {
	      type: "hidden",
	      name: name,
	      value: checked
	    });
	  }
	  return null;
	};
	var getChecked = function getChecked(props, state) {
	  var checked = isControlledComponent(props) ? props.checked : state.checked;
	  return isValidCheckValue(checked, props) ? checked : props.uncheckedValue;
	};
	var isControlledComponent = function isControlledComponent(props) {
	  return props.checked !== undefined;
	};
	var InovuaCheckBox = function (_Component) {
	  (0, _inherits2.default)(InovuaCheckBox, _Component);
	  var _super = _createSuper(InovuaCheckBox);
	  function InovuaCheckBox(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaCheckBox);
	    _this = _super.call(this, props);
	    (0, _reactClass.autoBind)((0, _assertThisInitialized2.default)(_this));
	    var defaultChecked = props.defaultChecked,
	      uncheckedValue = props.uncheckedValue;
	    _this.state = {
	      checked: isValidCheckValue(defaultChecked, props) ? defaultChecked : uncheckedValue
	    };
	    _this.checkboxRef = (0, _react.createRef)();
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaCheckBox, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      this.checkUpdateIndeterminate(this.p);
	      if (prevProps.supportIndeterminate && !this.props.supportIndeterminate) {
	        this.setNativeIndeterminate(false);
	      }
	      if (!prevProps.autoFocus && this.props.autoFocus && !this.isFocused()) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.checkUpdateIndeterminate();
	      if (this.props.autoFocus) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.checkboxRef.current.focus();
	    }
	  }, {
	    key: "checkUpdateIndeterminate",
	    value: function checkUpdateIndeterminate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.p;
	      if (props.browserNative && props.supportIndeterminate) {
	        this.setNativeIndeterminate(getCheckedDescriptor(props.checked, props) === INDETERMINATE_STATE);
	      }
	    }
	  }, {
	    key: "isFocused",
	    value: function isFocused() {
	      return this.state.focused;
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(event) {
	      var onFocus = this.p.onFocus;
	      this.setState({
	        focused: true
	      });
	      onFocus && onFocus(event);
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(event) {
	      var onBlur = this.p.onBlur;
	      this.setState({
	        focused: false
	      });
	      onBlur && onBlur(event);
	    }
	  }, {
	    key: "changeToNextValue",
	    value: function changeToNextValue(event) {
	      var _this$p = this.p,
	        readOnly = _this$p.readOnly,
	        checked = _this$p.checked,
	        nextValue = _this$p.nextValue;
	      if (readOnly) {
	        return;
	      }
	      var nextCheckedValue = nextValue(checked, this.p);
	      this.setChecked(nextCheckedValue, event);
	    }
	  }, {
	    key: "setChecked",
	    value: function setChecked(value, event) {
	      var _this$p2 = this.p,
	        disabled = _this$p2.disabled,
	        onChange = _this$p2.onChange;
	      if (disabled) {
	        return;
	      }
	      if (!isValidCheckValue(value, this.p)) {
	        return;
	      }
	      if (!isControlledComponent(this.props)) {
	        this.setState({
	          checked: value
	        });
	      }
	      if (typeof onChange == 'function') {
	        onChange(value, event);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      var _this$p3 = this.p,
	        onClick = _this$p3.onClick,
	        disabled = _this$p3.disabled;
	      if (disabled) {
	        return;
	      }
	      this.changeToNextValue(event);
	      if (onClick) {
	        onClick(event);
	      }
	    }
	  }, {
	    key: "handleKeyDown",
	    value: function handleKeyDown(event) {
	      var onKeyDown = this.p.onKeyDown;
	      if (event.key === ' ') {
	        event.preventDefault();
	        this.changeToNextValue(event);
	      }
	      if (typeof onKeyDown == 'function') {
	        onKeyDown(event);
	      }
	    }
	  }, {
	    key: "getProps",
	    value: function getProps(props, state) {
	      var checked = getChecked(props, state);
	      var style = getComponentStyle(props, state);
	      var className = (0, _getClassNames.default)(props, state, {
	        checked: checked
	      });
	      var shouldSubmitIsFunction = typeof props.shouldSubmit === 'function';
	      var shouldSubmitValue = shouldSubmitIsFunction ? props.shouldSubmit(checked, props) : typeof props.shouldSubmit === 'undefined' || props.shouldSubmit;
	      if (props.showWarnings && shouldSubmitIsFunction && shouldSubmitValue && !props.name) {
	        console.warn('shouldSubmit function returned true, but "name" prop is missing');
	      }
	      var withHiddenInput = !!(props.name && shouldSubmitValue);
	      var focused = state.focused;
	      return _objectSpread(_objectSpread({}, props), {}, {
	        checked: checked,
	        style: style,
	        withHiddenInput: withHiddenInput,
	        focused: focused,
	        className: className
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props,
	        state = this.state;
	      var _this$p4 = this.p = this.getProps(props, state),
	        children = _this$p4.children,
	        className = _this$p4.className,
	        style = _this$p4.style,
	        tabIndex = _this$p4.tabIndex,
	        iconCheckOnly = _this$p4.iconCheckOnly,
	        browserNative = _this$p4.browserNative,
	        focusable = _this$p4.focusable;
	      var eventHandlers = {
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown
	      };
	      if (!iconCheckOnly) {
	        eventHandlers.onClick = this.handleClick;
	      }
	      var domProps = _objectSpread(_objectSpread(_objectSpread({}, (0, _cleanProps.default)(props, InovuaCheckBox.propTypes)), eventHandlers), {}, {
	        className: className,
	        style: style,
	        ref: this.checkboxRef,
	        tabIndex: props.disabled === true ? null : tabIndex
	      });
	      if (!props.focusable) {
	        delete domProps.tabIndex;
	      }
	      return browserNative ? this.renderBrowserNative(domProps) : _react.default.createElement("div", _objectSpread({}, domProps), this.renderCheckbox(this.p, iconCheckOnly && {
	        onClick: this.handleClick
	      }), children && _react.default.createElement("div", {
	        className: "".concat(props.rootClassName, "__inner-content-wrapper")
	      }, children));
	    }
	  }, {
	    key: "renderBrowserNative",
	    value: function renderBrowserNative(domProps) {
	      var _this$props = this.props,
	        children = _this$props.children,
	        iconCheckOnly = _this$props.iconCheckOnly;
	      var Factory = iconCheckOnly ? 'div' : 'label';
	      return _react.default.createElement(Factory, _objectSpread(_objectSpread({}, domProps), {}, {
	        onClick: this.props.onClick,
	        onChange: stopPropagation
	      }), this.renderBrowserNativeInput(), children);
	    }
	  }, {
	    key: "renderBrowserNativeInput",
	    value: function renderBrowserNativeInput() {
	      var _this2 = this;
	      var _this$p5 = this.p,
	        tabIndex = _this$p5.tabIndex,
	        rootClassName = _this$p5.rootClassName,
	        disabled = _this$p5.disabled,
	        checked = _this$p5.checked,
	        renderNativeBrowserInput = _this$p5.renderNativeBrowserInput,
	        withHiddenInput = _this$p5.withHiddenInput,
	        name = _this$p5.name;
	      var className = (0, _join.default)(this.p.className, "".concat(rootClassName, "--browser-native"));
	      var inputProps = {
	        disabled: disabled,
	        className: className,
	        type: 'checkbox',
	        ref: function ref(_ref2) {
	          return _this2.node = _ref2;
	        },
	        onClick: this.handleClick,
	        checked: !!checked,
	        tabIndex: disabled === true ? null : tabIndex
	      };
	      if (withHiddenInput) {
	        inputProps.name = name;
	      }
	      var result;
	      if (typeof renderNativeBrowserInput === 'function') {
	        result = renderNativeBrowserInput({
	          inputProps: inputProps,
	          props: this.p
	        });
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("input", _objectSpread({}, inputProps));
	      }
	      return result;
	    }
	  }, {
	    key: "renderCheckbox",
	    value: function renderCheckbox(config, eventHandlers) {
	      var input = config.disabled !== true && renderHiddenInput(config);
	      var icon = renderIcon(config);
	      var domProps = {};
	      if (config.disabled) {
	        domProps.disabled = 'disabled';
	      }
	      return _react.default.createElement("div", _objectSpread(_objectSpread({
	        className: "".concat(config.rootClassName, "__icon-wrapper")
	      }, domProps), eventHandlers), input, icon);
	    }
	  }, {
	    key: "setNativeIndeterminate",
	    value: function setNativeIndeterminate(indeterminate) {
	      if (this.node) {
	        this.node.indeterminate = indeterminate;
	      }
	    }
	  }]);
	  return InovuaCheckBox;
	}(_react.Component);
	InovuaCheckBox.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-checkbox',
	  browserNative: false,
	  iconStyle: {},
	  disabledIconStyle: {},
	  focusedIconStyle: {},
	  disabledStyle: {},
	  readOnlyStyle: {},
	  focusedStyle: {},
	  supportIndeterminate: false,
	  focusable: true,
	  disabled: false,
	  readOnly: false,
	  tabIndex: 0,
	  checkedValue: true,
	  uncheckedValue: false,
	  indeterminateValue: null,
	  checkedSubmitValue: undefined,
	  uncheckedSubmitValue: undefined,
	  indeterminateSubmitValue: undefined,
	  checked: undefined,
	  defaultChecked: undefined,
	  iconSize: 16,
	  checkedIcon: _icons.checkedIcon,
	  uncheckedIcon: _icons.uncheckedIcon,
	  indeterminateIcon: _icons.indeterminateIcon,
	  iconCheckOnly: false,
	  shouldSubmit: undefined,
	  nextValue: nextValue,
	  childrenPosition: 'end',
	  inlineBlock: true,
	  theme: 'default-light',
	  showWarnings: !_uglified.default
	};
	var func = _propTypes.default.func,
	  number = _propTypes.default.number,
	  object = _propTypes.default.object,
	  string = _propTypes.default.string,
	  bool = _propTypes.default.bool,
	  any = _propTypes.default.any;
	var nonNullPropType = function nonNullPropType(props, propName, componentName) {
	  if (props[propName] === null) {
	    return new Error("".concat(propName, " is null in ").concat(componentName, ". This is not valid for input; use undefined instead."));
	  }
	  return null;
	};
	InovuaCheckBox.propTypes = (_InovuaCheckBox$propT = {
	  rootClassName: string,
	  browserNative: bool,
	  focusable: bool,
	  renderNativeBrowserInput: func,
	  shouldSubmit: function shouldSubmit(props, propName, componentName) {
	    if (props.shouldSubmit && typeof props.shouldSubmit !== 'function' && !props.name) {
	      return new Error("\"shouldSubmit\" was true, but component ".concat(componentName, " requires prop \"name\" to be submitted."));
	    }
	  },
	  value: function value(props) {
	    if (typeof props.value !== 'undefined') {
	      return new Error('"value" prop is not supported. Use "checked" instead.');
	    }
	  },
	  defaultValue: function defaultValue(props) {
	    if (typeof props.defaultValue !== 'undefined') {
	      return new Error('"defaultValue" prop is not supported. Use "checked" instead.');
	    }
	  },
	  nextValue: func,
	  name: string,
	  iconClassName: string,
	  readOnlyClassName: string,
	  disabledClassName: string,
	  focusedClassName: string,
	  checked: any,
	  defaultChecked: any,
	  disabled: bool,
	  readOnly: bool,
	  tabIndex: number,
	  supportIndeterminate: bool,
	  checkedValue: any,
	  uncheckedValue: any,
	  indeterminateValue: any,
	  checkedSubmitValue: nonNullPropType,
	  uncheckedSubmitValue: nonNullPropType,
	  indeterminateSubmitValue: nonNullPropType,
	  iconSize: _propTypes.default.oneOfType([string, _propTypes.default.arrayOf([string]), number, _propTypes.default.arrayOf(number)]),
	  checkedIconSrc: string,
	  checkedIcon: any,
	  iconCheckOnly: bool,
	  uncheckedIconSrc: string,
	  uncheckedIcon: any,
	  indeterminateIconSrc: string,
	  indeterminateIcon: any,
	  childrenPosition: _propTypes.default.oneOf(['start', 'end']),
	  inlineBlock: bool,
	  rtl: bool,
	  theme: string,
	  iconStyle: object,
	  disabledIconStyle: object,
	  focusedIconStyle: object
	}, (0, _defineProperty2.default)(_InovuaCheckBox$propT, "iconClassName", string), (0, _defineProperty2.default)(_InovuaCheckBox$propT, "disabledIconClassName", string), (0, _defineProperty2.default)(_InovuaCheckBox$propT, "focusedIconClassName", string), (0, _defineProperty2.default)(_InovuaCheckBox$propT, "readOnlyIconClassName", string), (0, _defineProperty2.default)(_InovuaCheckBox$propT, "disabledStyle", object), (0, _defineProperty2.default)(_InovuaCheckBox$propT, "readOnlyStyle", object), (0, _defineProperty2.default)(_InovuaCheckBox$propT, "focusedStyle", object), (0, _defineProperty2.default)(_InovuaCheckBox$propT, "showWarnings", bool), _InovuaCheckBox$propT);
	var _default = InovuaCheckBox;
	exports.default = _default;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.uncheckedIcon = exports.indeterminateIcon = exports.checkedIcon = void 0;
	var _react = _interopRequireDefault(__webpack_require__(2));
	var checkedIcon = function checkedIcon(_ref) {
	  var style = _ref.style,
	    _ref$size = _ref.size,
	    size = _ref$size === void 0 ? 16 : _ref$size,
	    className = _ref.className;
	  return _react.default.createElement("svg", {
	    width: size,
	    height: size,
	    style: style,
	    className: className,
	    viewBox: "0 0 16 16"
	  }, _react.default.createElement("g", {
	    fillRule: "evenodd"
	  }, _react.default.createElement("rect", {
	    width: size,
	    height: size,
	    stroke: "none",
	    rx: "1"
	  }), _react.default.createElement("path", {
	    fill: "none",
	    strokeLinecap: "round",
	    strokeWidth: "2",
	    d: "M3.357 9.018L7.229 12 12.613 5"
	  })));
	};
	exports.checkedIcon = checkedIcon;
	var uncheckedIcon = function uncheckedIcon(_ref2) {
	  var style = _ref2.style,
	    _ref2$size = _ref2.size,
	    size = _ref2$size === void 0 ? 16 : _ref2$size,
	    className = _ref2.className;
	  return _react.default.createElement("svg", {
	    width: size,
	    height: size,
	    className: className,
	    style: style,
	    viewBox: "0 0 16 16"
	  }, _react.default.createElement("rect", {
	    width: size - 2,
	    height: size - 2,
	    x: "1",
	    y: "1",
	    fill: "none",
	    fillRule: "evenodd",
	    strokeWidth: "2",
	    rx: "1"
	  }));
	};
	exports.uncheckedIcon = uncheckedIcon;
	var indeterminateIcon = function indeterminateIcon(_ref3) {
	  var style = _ref3.style,
	    _ref3$size = _ref3.size,
	    size = _ref3$size === void 0 ? 16 : _ref3$size,
	    className = _ref3.className;
	  return _react.default.createElement("svg", {
	    width: size,
	    height: size,
	    style: style,
	    className: className,
	    viewBox: "0 0 16 16"
	  }, _react.default.createElement("g", {
	    fillRule: "evenodd"
	  }, _react.default.createElement("g", null, _react.default.createElement("rect", {
	    width: size,
	    height: size,
	    fill: "none",
	    rx: "1"
	  })), _react.default.createElement("g", null, _react.default.createElement("rect", {
	    width: "10",
	    height: "2",
	    x: "3",
	    y: "7",
	    rx: "1"
	  }))));
	};
	exports.indeterminateIcon = indeterminateIcon;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _CheckBox = _interopRequireDefault(__webpack_require__(642));
	var _default = _CheckBox.default;
	exports.default = _default;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _join = _interopRequireDefault(__webpack_require__(20));
	var getClassNames = function getClassNames(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	    checked = _ref.checked;
	  var rtl = props.rtl,
	    inlineBlock = props.inlineBlock,
	    readOnly = props.readOnly,
	    readOnlyClassName = props.readOnlyClassName,
	    theme = props.theme,
	    disabled = props.disabled,
	    disabledClassName = props.disabledClassName,
	    focusedClassName = props.focusedClassName,
	    className = props.className,
	    childrenPosition = props.childrenPosition;
	  var focused = state.focused;
	  return (0, _join.default)(props.rootClassName, className, childrenPosition && "".concat(props.rootClassName, "--children-position-").concat(childrenPosition), rtl ? "".concat(props.rootClassName, "--rtl") : "".concat(props.rootClassName, "--ltr"), readOnly && (0, _join.default)("".concat(props.rootClassName, "--read-only"), readOnlyClassName), focused && (0, _join.default)("".concat(props.rootClassName, "--focused"), focusedClassName), disabled && (0, _join.default)("".concat(props.rootClassName, "--disabled"), disabledClassName), inlineBlock && "".concat(props.rootClassName, "--inline-block"), checked === true ? "".concat(props.rootClassName, "--checked") : checked === false ? "".concat(props.rootClassName, "--unchecked") : "".concat(props.rootClassName, "--indeterminate"), theme && "".concat(props.rootClassName, "--theme-").concat(theme));
	};
	var _default = getClassNames;
	exports.default = _default;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _Icons = __webpack_require__(112);
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var ClearButton = function ClearButton(_ref) {
	  var onClear = _ref.onClear,
	    className = _ref.className,
	    closeIcon = _ref.closeIcon,
	    size = _ref.size;
	  var closeIconProps = {
	    className: className,
	    size: size,
	    onClick: function onClick(event) {
	      event.preventDefault();
	      event.stopPropagation();
	      onClear();
	    }
	  };
	  var closeIconEl;
	  if (closeIcon && closeIcon !== true) {
	    var closeIconParams = {
	      onClear: onClear,
	      domProps: closeIconProps
	    };
	    closeIconEl = typeof closeIcon === 'function' ? closeIcon(closeIconParams) : closeIcon;
	  }
	  if (closeIconEl === undefined) {
	    closeIconEl = _react.default.createElement(_Icons.CloseIcon, _objectSpread({}, closeIconProps));
	  }
	  return closeIconEl;
	};
	ClearButton.defaultProps = {
	  size: 10
	};
	var _default = ClearButton;
	exports.default = _default;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var FakeVirtualList = function (_Component) {
	  (0, _inherits2.default)(FakeVirtualList, _Component);
	  var _super = _createSuper(FakeVirtualList);
	  function FakeVirtualList(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, FakeVirtualList);
	    _this = _super.call(this, props);
	    _this.handleOnScroll = _this.handleOnScroll.bind((0, _assertThisInitialized2.default)(_this));
	    _this.targetRef = function (node) {
	      if (!node) {
	        _this.targetNode = null;
	      }
	      _this.targetNode = node;
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(FakeVirtualList, [{
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var count = this.props.count;
	      var list = [];
	      if (count > 0) {
	        for (var i = 0; i < count; i++) {
	          list.push(props.renderRow({
	            index: i
	          }));
	        }
	      }
	      var listProps = _objectSpread(_objectSpread({
	        ref: this.targetRef,
	        children: list
	      }, (0, _cleanProps.default)(props, FakeVirtualList.propTypes)), {}, {
	        onScroll: this.handleOnScroll
	      });
	      var result;
	      if (this.props.renderListScroller) {
	        result = this.props.renderListScroller(listProps);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("div", _objectSpread({}, listProps));
	      }
	      return result;
	    }
	  }, {
	    key: "getContainerNode",
	    value: function getContainerNode() {
	      return this.targetNode && this.targetNode.getContainerTargetNode ? this.targetNode.getContainerTargetNode() : this.targetNode;
	    }
	  }, {
	    key: "getRootNode",
	    value: function getRootNode() {
	      return this.targetNode;
	    }
	  }, {
	    key: "getScrollerNode",
	    value: function getScrollerNode() {
	      return this.targetNode && this.targetNode.getScrollerNode ? this.targetNode.getScrollerNode() : this.targetNode;
	    }
	  }, {
	    key: "scrollToIndex",
	    value: function scrollToIndex(index) {
	      var containerNode = this.getContainerNode();
	      var rootNode = this.getRootNode();
	      var scrollerNode = this.getScrollerNode();
	      if (!containerNode) {
	        return null;
	      }
	      if (containerNode && !containerNode.childNodes.length) {
	        return null;
	      }
	      var itemNode = containerNode.childNodes[index];
	      if (!itemNode) {
	        return null;
	      }
	      var itemHeight = itemNode.offsetHeight;
	      var itemOffsetTop = itemNode.offsetTop;
	      var scrollTop = scrollerNode.scrollTop;
	      var containerHeight = rootNode.offsetHeight;
	      if (scrollTop > itemOffsetTop) {
	        scrollerNode.scrollTop = itemOffsetTop;
	      }
	      if (scrollTop + containerHeight < itemHeight + itemOffsetTop) {
	        scrollerNode.scrollTop = itemOffsetTop + itemHeight - containerHeight;
	      }
	      return true;
	    }
	  }, {
	    key: "handleOnScroll",
	    value: function handleOnScroll(event) {
	      var rootNode = this.getRootNode();
	      var scrollTop = event.target.scrollTop;
	      var listHeight = rootNode.offsetHeight;
	      var scrollHeight = rootNode.scrollHeight;
	      if (scrollTop + listHeight + 5 >= scrollHeight) {
	        this.props.scrollProps.onContainerScrollVerticalMax();
	      }
	    }
	  }]);
	  return FakeVirtualList;
	}(_react.Component);
	FakeVirtualList.propTypes = {
	  autoHide: _propTypes.default.bool,
	  count: _propTypes.default.number,
	  renderRow: _propTypes.default.func,
	  minRowHeight: _propTypes.default.number,
	  tagIndex: _propTypes.default.number,
	  shouldComponentUpdate: _propTypes.default.func,
	  renderListScroller: _propTypes.default.func,
	  scrollProps: _propTypes.default.object,
	  virtualized: _propTypes.default.bool,
	  showScrollbars: _propTypes.default.bool
	};
	var _default = FakeVirtualList;
	exports.default = _default;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof3 = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _join = _interopRequireDefault(__webpack_require__(83));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var Item = function (_Component) {
	  (0, _inherits2.default)(Item, _Component);
	  var _super = _createSuper(Item);
	  function Item(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, Item);
	    _this = _super.call(this, props);
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	  (0, _createClass2.default)(Item, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	        selected = _this$props.selected,
	        rootClassName = _this$props.rootClassName,
	        selectedStyle = _this$props.selectedStyle,
	        active = _this$props.active,
	        background = _this$props.background,
	        item = _this$props.item,
	        index = _this$props.index,
	        disabledStyle = _this$props.disabledStyle,
	        disabledClassName = _this$props.disabledClassName,
	        activeStyle = _this$props.activeStyle,
	        activeClassName = _this$props.activeClassName,
	        selectedClassName = _this$props.selectedClassName,
	        renderItem = _this$props.renderItem,
	        rtl = _this$props.rtl,
	        itemHeight = _this$props.itemHeight,
	        itemEllipsis = _this$props.itemEllipsis;
	      var disabled = item.disabled;
	      var className = (0, _join.default)(this.props.className, rootClassName, selected && "".concat(rootClassName, "--selected"), rtl && "".concat(rootClassName, "--rtl"), active && "".concat(rootClassName, "--active"), disabled && "".concat(rootClassName, "--disabled"), itemEllipsis && "".concat(rootClassName, "--ellipsis"), disabled && disabledClassName, active && activeClassName, selected && selectedClassName);
	      var style = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.props.style), active && activeStyle), disabled && disabledStyle), selected && selectedStyle);
	      if (itemHeight) {
	        style.height = itemHeight;
	      }
	      if (background) {
	        style.background = background;
	      }
	      var label = this.props.label;
	      var matchText = item.matchText;
	      if (typeof label === 'string' && matchText) {
	        label = matchText.map(function (textPart, index) {
	          if ((0, _typeof2.default)(textPart) === 'object') {
	            return _react.default.createElement("span", {
	              className: "".concat(rootClassName, "__highlight"),
	              key: index
	            }, textPart.match);
	          }
	          return textPart;
	        });
	      }
	      var domProps = _objectSpread(_objectSpread({}, (0, _cleanProps.default)(this.props, Item.propTypes)), {}, {
	        style: style,
	        className: className,
	        onClick: this.handleClick,
	        onMouseDown: this.handleMouseDown,
	        children: label
	      });
	      var result;
	      if (typeof renderItem === 'function') {
	        result = renderItem({
	          domProps: domProps,
	          label: label,
	          item: item,
	          index: index
	        });
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("div", _objectSpread({}, domProps));
	      }
	      return result;
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(event) {
	      event.preventDefault();
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick() {
	      if (this.props.item.disabled) {
	        return null;
	      }
	      this.props.onClick(this.props.id);
	    }
	  }]);
	  return Item;
	}(_react.Component);
	function emptyFn() {}
	Item.defaultProps = {
	  onClick: emptyFn,
	  selectedStyle: {},
	  item: {}
	};
	Item.propTypes = {
	  rootClassName: _propTypes.default.string,
	  itemHeight: _propTypes.default.number,
	  itemEllipsis: _propTypes.default.bool,
	  renderItem: _propTypes.default.func,
	  selectedClassName: _propTypes.default.string,
	  selectedStyle: _propTypes.default.object,
	  background: _propTypes.default.string,
	  active: _propTypes.default.bool,
	  label: _propTypes.default.node,
	  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
	  item: _propTypes.default.object,
	  onClick: _propTypes.default.func,
	  index: _propTypes.default.number,
	  rtl: _propTypes.default.bool,
	  disabledStyle: _propTypes.default.object,
	  disabledClassName: _propTypes.default.string,
	  activeStyle: _propTypes.default.object,
	  activeClassName: _propTypes.default.string
	};
	var _default = Item;
	exports.default = _default;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _Overlay = _interopRequireDefault(__webpack_require__(254));
	var _FakeVirtualList = _interopRequireDefault(__webpack_require__(647));
	var _Item = _interopRequireDefault(__webpack_require__(648));
	var _getClassName = _interopRequireDefault(__webpack_require__(651));
	var _isSelected = _interopRequireDefault(__webpack_require__(243));
	var _getPositionRelativeToElement = _interopRequireDefault(__webpack_require__(214));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var List = function (_Component) {
	  (0, _inherits2.default)(List, _Component);
	  var _super = _createSuper(List);
	  function List(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, List);
	    _this = _super.call(this, props);
	    _this.renderRow = _this.renderRow.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getOverlayTarget = _this.getOverlayTarget.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleOnClick = _this.handleOnClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleItemClick = _this.handleItemClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.virtualListShouldComponentUpdate = _this.virtualListShouldComponentUpdate.bind((0, _assertThisInitialized2.default)(_this));
	    _this.setRootNode = function (ref) {
	      _this.listNode = ref;
	    };
	    _this.addVirtualListRef = function (ref) {
	      _this.virtualListNode = ref;
	    };
	    _this.state = {
	      succesfullPosition: 'bottom'
	    };
	    _this.listAligned = false;
	    return _this;
	  }
	  (0, _createClass2.default)(List, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.componentIsMounted = false;
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	      this.componentIsMounted = true;
	      if (!this.props.relativeToViewport) {
	        setTimeout(function () {
	          _this2.updateListPosition();
	        }, 0);
	      }
	      if (this.props.activeItemIndex != null) {
	        setTimeout(function () {
	          if (_this2.componentIsMounted) {
	            _this2.scrollToIndex(_this2.props.activeItemIndex);
	          }
	        }, 16);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var state = this.state,
	        props = this.props;
	      var renderFooter = props.renderFooter,
	        renderHeader = props.renderHeader,
	        isNewCustomTagValid = props.isNewCustomTagValid;
	      this.currentGroup = null;
	      var className = (0, _getClassName.default)({
	        state: state,
	        props: props
	      });
	      var style = props.style;
	      if (this.state.position) {
	        style = _objectSpread(_objectSpread({}, style), this.state.position);
	      }
	      if (this.state.succesfullPosition && this.props.offset) {
	        var positionName = this.state.succesfullPosition === 'bc-tc' ? 'top' : 'bottom';
	        if (this.props.offset) {
	          style = _objectSpread(_objectSpread({}, style), {}, (0, _defineProperty2.default)({}, positionName == 'top' ? 'marginBottom' : 'marginTop', this.props.offset));
	        }
	      }
	      if (!this.props.relativeToViewport && !this.listAligned) {
	        style = _objectSpread(_objectSpread({}, style), {}, {
	          visibility: 'hidden',
	          position: 'fixed'
	        });
	      }
	      var result = _react.default.createElement("div", _objectSpread(_objectSpread({}, (0, _cleanProps.default)(props, List.propTypes)), {}, {
	        className: className,
	        style: style,
	        ref: this.setRootNode,
	        onClick: this.handleOnClick
	      }), this.renderLoadingText(), isNewCustomTagValid && this.renderNewCustomTagText(), typeof renderHeader === 'function' && this.renderHeader(), this.renderEmptyText(), this.renderVirtualList(), typeof renderFooter === 'function' && this.renderFooter());
	      if (this.props.relativeToViewport) {
	        var overlayProps = _objectSpread(_objectSpread({}, props.overlayProps), {}, {
	          target: this.getOverlayTarget,
	          relativeToViewport: this.props.relativeToViewport,
	          constrainTo: this.props.constrainTo,
	          positions: this.props.positions
	        });
	        return _react.default.createElement(_Overlay.default, _objectSpread({}, overlayProps), result);
	      }
	      return result;
	    }
	  }, {
	    key: "getOverlayTarget",
	    value: function getOverlayTarget() {
	      return this.props.getComboNode();
	    }
	  }, {
	    key: "renderFooter",
	    value: function renderFooter() {
	      return this.props.renderFooter({
	        props: this.props,
	        data: this.props.data,
	        value: this.props.value
	      });
	    }
	  }, {
	    key: "renderHeader",
	    value: function renderHeader() {
	      return this.props.renderHeader({
	        props: this.props,
	        data: this.props.data,
	        value: this.props.value
	      });
	    }
	  }, {
	    key: "renderEmptyText",
	    value: function renderEmptyText() {
	      var data = this.props.data;
	      if (data && data.length || this.props.loading) {
	        return null;
	      }
	      if (this.props.isNewCustomTagValid) {
	        return null;
	      }
	      return _react.default.createElement("div", {
	        className: "".concat(this.props.rootClassName, "__empty-text")
	      }, this.props.emptyText);
	    }
	  }, {
	    key: "renderNewCustomTagText",
	    value: function renderNewCustomTagText() {
	      var text = this.props.text;
	      if (this.props.newCustomTagText) {
	        return typeof this.props.newCustomTagText === 'function' ? this.props.newCustomTagText({
	          text: text
	        }) : this.props.newCustomTagText;
	      }
	      return _react.default.createElement("div", {
	        className: "".concat(this.props.rootClassName, "__new-custom-tag-text")
	      }, "Create option \"", text, "\"");
	    }
	  }, {
	    key: "renderLoadingText",
	    value: function renderLoadingText() {
	      if (!this.props.loading) {
	        return null;
	      }
	      if (!this.props.loadingText) {
	        return null;
	      }
	      return _react.default.createElement("div", {
	        className: "".concat(this.props.rootClassName, "__loading-text")
	      }, this.props.loadingText);
	    }
	  }, {
	    key: "renderVirtualList",
	    value: function renderVirtualList() {
	      var className = "".concat(this.props.rootClassName, "__virtual-list");
	      var count = this.props.dataLength;
	      var VirtualList = this.props.virtualListFactory;
	      var renderVirtualList = this.props.renderVirtualList;
	      if (!count) {
	        return null;
	      }
	      var style = {};
	      if (this.props.maxHeight) {
	        style.maxHeight = this.props.maxHeight;
	      }
	      if (this.state.constrainedHeight) {
	        var constrainedOffset = 16;
	        var constrainedHeight = this.props.maxHeight ? Math.min(this.props.maxHeight, this.state.constrainedHeight - constrainedOffset) : this.state.constrainedHeight - constrainedOffset;
	        style.maxHeight = constrainedHeight;
	      }
	      if (typeof style.maxHeight === 'number' && typeof this.props.minHeight == 'number') {
	        style.maxHeight = Math.max(style.maxHeight || 0, style.minHeight || 0);
	      }
	      var virtualListProps = {
	        ref: this.addVirtualListRef,
	        className: className,
	        autoHide: false,
	        count: count,
	        theme: this.props.theme,
	        renderRow: this.renderRow,
	        minRowHeight: 10,
	        tabIndex: null,
	        shouldComponentUpdate: this.virtualListShouldComponentUpdate,
	        scrollProps: {
	          onContainerScrollVerticalMax: this.props.onScrollBottom
	        },
	        style: style
	      };
	      var result;
	      if (renderVirtualList) {
	        result = renderVirtualList(virtualListProps);
	      }
	      if (result === undefined) {
	        if (VirtualList === _FakeVirtualList.default) {
	          virtualListProps.renderListScroller = this.props.renderListScroller;
	        }
	        result = _react.default.createElement(VirtualList, _objectSpread({}, virtualListProps));
	      }
	      if (result && result.props) {
	        this.rowHeight = result.props.rowHeight;
	      }
	      return result;
	    }
	  }, {
	    key: "virtualListShouldComponentUpdate",
	    value: function virtualListShouldComponentUpdate() {
	      return true;
	    }
	  }, {
	    key: "renderRow",
	    value: function renderRow(_ref) {
	      var index = _ref.index;
	      var groups = this.props.groups;
	      if (groups && groups[index]) {
	        return this.renderGroup(groups[index], index);
	      }
	      var _this$props = this.props,
	        data = _this$props.data,
	        getIdProperty = _this$props.getIdProperty,
	        getDisplayProperty = _this$props.getDisplayProperty,
	        rootClassName = _this$props.rootClassName,
	        itemEllipsis = _this$props.itemEllipsis,
	        value = _this$props.value,
	        activeItem = _this$props.activeItem,
	        renderItem = _this$props.renderItem,
	        rtl = _this$props.rtl;
	      var renderIndex = this.currentGroup ? index - this.currentGroup.indexAjustment : index;
	      var item = data[renderIndex];
	      var id = getIdProperty(item);
	      var label = getDisplayProperty(item);
	      var selected = (0, _isSelected.default)({
	        value: value,
	        id: id
	      });
	      var active = id === activeItem;
	      var itemProps = _objectSpread(_objectSpread({}, this.props.itemProps), {}, {
	        index: renderIndex,
	        itemHeight: this.rowHeight,
	        itemEllipsis: itemEllipsis,
	        item: item,
	        id: id,
	        label: label,
	        selected: selected,
	        active: active,
	        renderItem: renderItem,
	        rtl: rtl,
	        rootClassName: "".concat(rootClassName, "__item"),
	        onClick: this.handleItemClick,
	        key: id || label
	      });
	      return _react.default.createElement(_Item.default, _objectSpread({}, itemProps));
	    }
	  }, {
	    key: "renderGroup",
	    value: function renderGroup(group, index) {
	      this.currentGroup = group;
	      var title = group.title;
	      var groupProps = {
	        children: title,
	        key: title,
	        className: "".concat(this.props.rootClassName, "__group")
	      };
	      var result;
	      if (typeof this.props.renderGroup === 'function') {
	        result = this.props.renderGroup({
	          domProps: groupProps,
	          index: index,
	          group: group
	        });
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("div", _objectSpread({}, groupProps));
	      }
	      return result;
	    }
	  }, {
	    key: "handleOnClick",
	    value: function handleOnClick(event) {
	      event.stopPropagation();
	    }
	  }, {
	    key: "handleItemClick",
	    value: function handleItemClick(index) {
	      this.props.onItemClick(index);
	    }
	  }, {
	    key: "updateListPosition",
	    value: function updateListPosition() {
	      var comboNode = this.props.getComboNode();
	      if (!comboNode) {
	        return null;
	      }
	      var listNode = this.listNode;
	      if (!listNode) {
	        return null;
	      }
	      var positionConfig = (0, _getPositionRelativeToElement.default)({
	        targetNode: comboNode,
	        overlayNode: listNode,
	        offset: this.props.offset,
	        constrainTo: this.props.constrainTo,
	        relativeToViewport: this.props.relativeToViewport,
	        positions: this.props.positions
	      });
	      this.listAligned = true;
	      if (positionConfig) {
	        var constrainedHeight = positionConfig.constrainedHeight,
	          positionRegion = positionConfig.positionRegion,
	          succesfullPosition = positionConfig.succesfullPosition,
	          position = positionConfig.position;
	        this.setState({
	          positionRegion: positionRegion,
	          succesfullPosition: succesfullPosition,
	          constrainedHeight: constrainedHeight ? positionRegion.getHeight() : null
	        });
	      }
	    }
	  }, {
	    key: "getVirtualListNode",
	    value: function getVirtualListNode() {
	      return this.virtualListNode;
	    }
	  }, {
	    key: "getlListNode",
	    value: function getlListNode() {
	      return this.listNode;
	    }
	  }, {
	    key: "scrollToIndex",
	    value: function scrollToIndex(index) {
	      var virtualListNode = this.getVirtualListNode();
	      return virtualListNode && virtualListNode.scrollToIndex(index);
	    }
	  }]);
	  return List;
	}(_react.Component);
	function emptyFn() {}
	List.defaultProps = {
	  selectedStyle: {},
	  style: {},
	  onItemClick: emptyFn,
	  getComboNode: emptyFn,
	  positions: ['bottom', 'top'],
	  offset: 0,
	  constrainTo: true,
	  virtualListFactory: _FakeVirtualList.default,
	  overlayProps: {
	    theme: null,
	    syncWidth: true,
	    rafOnMount: false,
	    adjustOnPositionBottom: false,
	    updatePositionOnScroll: true,
	    offset: 2,
	    visible: true
	  }
	};
	List.propTypes = {
	  data: _propTypes.default.array,
	  autoPosition: _propTypes.default.bool,
	  emptyText: _propTypes.default.node,
	  dataLength: _propTypes.default.number,
	  rootClassName: _propTypes.default.string,
	  highlightFirst: _propTypes.default.bool,
	  maxHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  minHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  groups: _propTypes.default.object,
	  itemEllipsis: _propTypes.default.bool,
	  onScrollBottom: _propTypes.default.func,
	  renderListScroller: _propTypes.default.func,
	  renderGroup: _propTypes.default.func,
	  renderFooter: _propTypes.default.func,
	  renderHeader: _propTypes.default.func,
	  renderItem: _propTypes.default.func,
	  activeItemIndex: _propTypes.default.number,
	  virtualListFactory: _propTypes.default.func,
	  renderVirtualList: _propTypes.default.func,
	  text: _propTypes.default.string,
	  newCustomTagText: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	  isNewCustomTagValid: _propTypes.default.bool,
	  positions: _propTypes.default.arrayOf(_propTypes.default.string),
	  constrainTo: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object, _propTypes.default.bool]),
	  offset: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }), _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  })]))]),
	  loadingText: _propTypes.default.node,
	  loading: _propTypes.default.bool,
	  relativeToViewport: _propTypes.default.bool,
	  overlayProps: _propTypes.default.object,
	  itemProps: _propTypes.default.object,
	  activeItem: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
	  selectedStyle: _propTypes.default.object,
	  getIdProperty: _propTypes.default.func,
	  getDisplayProperty: _propTypes.default.func,
	  rtl: _propTypes.default.bool,
	  onItemClick: _propTypes.default.func,
	  getComboNode: _propTypes.default.func
	};
	var _default = List;
	exports.default = _default;

/***/ },
/* 650 */
[1295, 649],
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _join = _interopRequireDefault(__webpack_require__(83));
	function getClassName(_ref) {
	  var props = _ref.props,
	    _ref$state = _ref.state,
	    state = _ref$state === void 0 ? {} : _ref$state;
	  var listPosition = props.listPosition,
	    _props$data = props.data,
	    data = _props$data === void 0 ? [] : _props$data,
	    className = props.className,
	    theme = props.theme,
	    rootClassName = props.rootClassName,
	    loading = props.loading,
	    relativeToViewport = props.relativeToViewport;
	  var succesfullPosition = state.succesfullPosition;
	  var constructedClassName = (0, _join.default)(rootClassName, className, listPosition && "".concat(rootClassName, "--").concat(listPosition), loading && "".concat(rootClassName, "--loading"), theme && "".concat(rootClassName, "--theme-").concat(theme), relativeToViewport && "".concat(rootClassName, "--relative-to-viewport"), data && !data.length && "".concat(rootClassName, "--empty"));
	  if (succesfullPosition) {
	    var positionName = succesfullPosition === 'bc-tc' ? 'top' : 'bottom';
	    constructedClassName = (0, _join.default)(constructedClassName, "".concat(rootClassName, "--position-").concat(positionName));
	  }
	  return constructedClassName;
	}
	var _default = getClassName;
	exports.default = _default;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof3 = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _join = _interopRequireDefault(__webpack_require__(83));
	var _getMinMaxSize = _interopRequireDefault(__webpack_require__(664));
	var _Icons = __webpack_require__(112);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var Tag = function (_Component) {
	  (0, _inherits2.default)(Tag, _Component);
	  var _super = _createSuper(Tag);
	  function Tag(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, Tag);
	    _this = _super.call(this, props);
	    _this.handleOnClose = _this.handleOnClose.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleOnMultipleClose = _this.handleOnMultipleClose.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	  (0, _createClass2.default)(Tag, [{
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var item = props.item,
	        index = props.index,
	        items = props.items,
	        rootClassName = props.rootClassName,
	        closeIconPosition = props.closeIconPosition,
	        _onClick = props.onClick,
	        active = props.active,
	        multiple = props.multiple,
	        renderTag = props.renderTag,
	        isMultiple = props.isMultiple;
	      var className = this.getClassName({
	        active: active
	      });
	      var labelClassName = "".concat(rootClassName, "__label");
	      var style = this.getStyle();
	      var closeIcon = this.renderCloseIcon();
	      var label = this.renderLabel();
	      var domProps = _objectSpread(_objectSpread({}, (0, _cleanProps.default)(props, Tag.propTypes)), {}, {
	        key: "tag_".concat(index),
	        style: style,
	        className: className,
	        onMouseDown: function onMouseDown(event) {
	          event.preventDefault();
	        },
	        onClick: function onClick(event) {
	          event.stopPropagation();
	          _onClick(item.id);
	        },
	        children: [closeIconPosition === 'start' && closeIcon, _react.default.createElement("span", {
	          key: "tag_label",
	          className: labelClassName
	        }, label), closeIconPosition === 'end' && closeIcon]
	      });
	      var result;
	      if (typeof renderTag === 'function') {
	        result = renderTag({
	          domProps: domProps,
	          item: item,
	          index: index,
	          items: items,
	          isMultiple: isMultiple,
	          props: props
	        });
	      }
	      if (result === undefined) {
	        return _react.default.createElement("div", _objectSpread({}, domProps));
	      }
	      return result || null;
	    }
	  }, {
	    key: "getClassName",
	    value: function getClassName(_ref) {
	      var active = _ref.active;
	      var _this$props = this.props,
	        rootClassName = _this$props.rootClassName,
	        ellipsis = _this$props.ellipsis,
	        isMultiple = _this$props.isMultiple;
	      var className = (0, _join.default)(rootClassName, active && "".concat(rootClassName, "--active"), ellipsis && "".concat(rootClassName, "--ellipsis"), isMultiple && "".concat(rootClassName, "--multiple"));
	      return className;
	    }
	  }, {
	    key: "getStyle",
	    value: function getStyle() {
	      var props = this.props;
	      var border = props.border,
	        padding = props.padding,
	        height = props.height,
	        width = props.width,
	        maxWidth = props.maxWidth,
	        activeStyle = props.activeStyle,
	        active = props.active;
	      var minMaxSize = (0, _getMinMaxSize.default)(props);
	      var style = _objectSpread(_objectSpread({}, props.style), minMaxSize);
	      if (border) {
	        style.border = border;
	      }
	      if (padding) {
	        style.padding = padding;
	      }
	      if (width) {
	        style.width = width;
	      }
	      if (height) {
	        style.height = height;
	      }
	      if (maxWidth) {
	        style.maxWidth = maxWidth;
	      }
	      if (active && activeStyle) {
	        style = _objectSpread(_objectSpread({}, style), activeStyle);
	      }
	      return style;
	    }
	  }, {
	    key: "renderLabel",
	    value: function renderLabel() {
	      var _this$props2 = this.props,
	        index = _this$props2.index,
	        maxTagsLength = _this$props2.maxTagsLength,
	        renderTagLabel = _this$props2.renderTagLabel,
	        items = _this$props2.items,
	        item = _this$props2.item,
	        isMultiple = _this$props2.isMultiple;
	      var label = item.label;
	      if (isMultiple) {
	        if (item.length === 1) {
	          label = item[0].label;
	        } else {
	          label = items.length === item.length ? "".concat(item.length, " item").concat(item.length ? 's' : '', " selected") : "and other ".concat(item.length, " selected");
	        }
	      }
	      if (renderTagLabel) {
	        return renderTagLabel({
	          label: label,
	          item: item,
	          items: items,
	          count: items.length,
	          index: index,
	          isMultiple: isMultiple,
	          maxTagsLength: maxTagsLength,
	          combined: isMultiple
	        });
	      }
	      return label;
	    }
	  }, {
	    key: "renderCloseIcon",
	    value: function renderCloseIcon() {
	      var _this$props3 = this.props,
	        closeIcon = _this$props3.closeIcon,
	        rootClassName = _this$props3.rootClassName,
	        isMultiple = _this$props3.isMultiple,
	        item = _this$props3.item;
	      var closeClassName = "".concat(rootClassName, "__clear-icon");
	      if (!closeIcon) {
	        return null;
	      }
	      var closeIconProps = {
	        key: 'close_icon',
	        onClick: isMultiple ? this.handleOnMultipleClose : this.handleOnClose,
	        className: closeClassName
	      };
	      var closeIconEl = closeIcon;
	      if (typeof closeIcon === 'function') {
	        var closeIconParams = {
	          item: item,
	          onDeselect: closeIconProps.onClick,
	          domProps: closeIconProps
	        };
	        closeIconEl = closeIcon(closeIconParams);
	      } else {
	        if (closeIcon && (0, _typeof2.default)(closeIcon) == 'object') {
	          closeIconEl = (0, _react.cloneElement)(closeIcon, {
	            className: (0, _join.default)(closeIcon.props && closeIcon.props.className, closeIconProps.className),
	            onClick: closeIcon.props && closeIcon.props.onClick ? function (event) {
	              closeIcon.props.onClick(event);
	              closeIconProps.onClick(event);
	            } : closeIconProps.onClick
	          });
	        }
	      }
	      if (closeIconEl === true || closeIconEl === undefined) {
	        closeIconEl = _react.default.createElement(_Icons.CloseIcon, _objectSpread({}, closeIconProps));
	      }
	      return closeIconEl;
	    }
	  }, {
	    key: "handleOnMultipleClose",
	    value: function handleOnMultipleClose() {
	      var ids = this.props.item.map(function (item) {
	        return item.id;
	      });
	      this.props.onMultipleTagClose(ids);
	    }
	  }, {
	    key: "handleOnClose",
	    value: function handleOnClose(event) {
	      var _this$props4 = this.props,
	        onCloseTagClick = _this$props4.onCloseTagClick,
	        item = _this$props4.item;
	      event.preventDefault();
	      event.stopPropagation();
	      var id = item.id;
	      onCloseTagClick(id);
	    }
	  }]);
	  return Tag;
	}(_react.Component);
	Tag.displayName = 'Tag';
	function emptyFn() {}
	Tag.defaultProps = {
	  onCloseTagClick: emptyFn,
	  onMultipleTagClose: emptyFn,
	  onClick: emptyFn,
	  closeIconPosition: 'end',
	  item: {},
	  ellipsis: true,
	  closeIcon: true
	};
	Tag.propTypes = {
	  active: _propTypes.default.bool,
	  renderTag: _propTypes.default.func,
	  renderTagLabel: _propTypes.default.func,
	  index: _propTypes.default.number,
	  onCloseTagClick: _propTypes.default.func,
	  onMultipleTagClose: _propTypes.default.func,
	  closeIcon: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node, _propTypes.default.func]),
	  closeIconPosition: _propTypes.default.oneOf(['start', 'end']),
	  isRemaining: _propTypes.default.bool,
	  onClick: _propTypes.default.func,
	  item: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
	  items: _propTypes.default.array,
	  isMultiple: _propTypes.default.bool,
	  rootClassName: _propTypes.default.string,
	  tags: _propTypes.default.array,
	  border: _propTypes.default.string,
	  visibleItems: _propTypes.default.array,
	  activeStyle: _propTypes.default.object,
	  padding: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  minSize: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
	    height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  })]),
	  maxSize: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
	    height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  })]),
	  maxWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  maxTagsLength: _propTypes.default.number,
	  ellipsis: _propTypes.default.bool
	};
	var _default = Tag;
	exports.default = _default;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _getSelectionStart2 = _interopRequireDefault(__webpack_require__(671));
	var _getSelectionEnd2 = _interopRequireDefault(__webpack_require__(670));
	var _setInputSelection = _interopRequireDefault(__webpack_require__(676));
	var _throttle = _interopRequireDefault(__webpack_require__(102));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _getCursorPosition = _interopRequireDefault(__webpack_require__(660));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var TextInput = function (_Component) {
	  (0, _inherits2.default)(TextInput, _Component);
	  var _super = _createSuper(TextInput);
	  function TextInput(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, TextInput);
	    _this = _super.call(this, props);
	    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
	    _this.updateValue = _this.updateValue.bind((0, _assertThisInitialized2.default)(_this));
	    if (props.throttle) {
	      _this.updateThrottledUpdateValue(props.throttle);
	    }
	    _this.state = {
	      value: props.value
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(TextInput, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	      var previousValue = prevProps.value || '';
	      var currentValue = this.props.value || '';
	      if (previousValue != currentValue) {
	        clearTimeout(this.suggestionTimeOut);
	      }
	      if (this.props.suggestion && this.props.suggestion !== currentValue && this.props.autocomplete && currentValue !== previousValue && currentValue.length > previousValue.length) {
	        this.suggestionTimeOut = setTimeout(function () {
	          _this2.selectForwardIfNecessary();
	        }, this.props.autocompleteDelay);
	      }
	      if (this.props.throttle && prevProps.value !== this.props.value) {
	        this.setState({
	          value: this.props.value
	        });
	      }
	      if (prevProps.throttle !== this.props.throttle) {
	        this.updateThrottledUpdateValue(this.props.throttle);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.suggestionTimeOut) {
	        clearTimeout(this.suggestionTimeOut);
	        this.suggestionTimeOut = null;
	      }
	    }
	  }, {
	    key: "updateThrottledUpdateValue",
	    value: function updateThrottledUpdateValue(throttleDelay) {
	      this.throttledUpdateValue = (0, _throttle.default)(this.updateValue, throttleDelay, {
	        trailing: true,
	        leading: false
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	      var _this$props = this.props,
	        rootClassName = _this$props.rootClassName,
	        onClick = _this$props.onClick,
	        maxWidth = _this$props.maxWidth,
	        visible = _this$props.visible,
	        searchable = _this$props.searchable;
	      var className = (0, _join.default)("".concat(rootClassName, "__wrapper"), this.props.className, !visible && "".concat(rootClassName, "__wrapper--invisible"), !searchable && "".concat(rootClassName, "__wrapper--non-searchable"));
	      var value = this.getValue() || '';
	      var valueLength = value != null && value.length;
	      var size = valueLength ? valueLength + 1 : 1;
	      var inputStyle = {};
	      if (size === 1 && valueLength === 0) {
	        inputStyle.width = 1;
	      }
	      if (maxWidth) {
	        inputStyle.maxWidth = maxWidth;
	      }
	      return _react.default.createElement("span", _objectSpread(_objectSpread({}, (0, _cleanProps.default)(this.props, TextInput.propTypes)), {}, {
	        onClick: onClick,
	        className: className
	      }), _react.default.createElement("input", {
	        style: inputStyle,
	        className: rootClassName,
	        ref: function ref(_ref) {
	          return _this3.inputNode = _ref;
	        },
	        type: "text",
	        value: value || '',
	        onChange: this.handleChange,
	        onClick: this.onClick,
	        tabIndex: this.props.tabIndex,
	        onMouseDown: this.handleMouseDown,
	        size: size
	      }), !value && this.renderPlaceholder());
	    }
	  }, {
	    key: "renderPlaceholder",
	    value: function renderPlaceholder() {
	      var _this4 = this;
	      if (!this.props.placeholder) {
	        return null;
	      }
	      var placeholderProps = {
	        className: "".concat(this.props.rootClassName, "__placeholder")
	      };
	      return _react.default.createElement("span", _objectSpread(_objectSpread({}, placeholderProps), {}, {
	        ref: function ref(_ref2) {
	          return _this4.placeholderNode = _ref2;
	        }
	      }), this.props.placeholder);
	    }
	  }, {
	    key: "getValue",
	    value: function getValue() {
	      var value = this.props.throttle ? this.state.value : this.props.value;
	      return value;
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      if (this.inputNode && this.inputNode.focus) {
	        this.inputNode.focus();
	      }
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      if (this.inputNode && this.inputNode.blur) {
	        this.inputNode.blur();
	      }
	    }
	  }, {
	    key: "hasFocus",
	    value: function hasFocus() {
	      var activeElement = globalObject && globalObject.document && globalObject.document.activeElement;
	      return this.inputNode === activeElement;
	    }
	  }, {
	    key: "handleChange",
	    value: function handleChange(event) {
	      var value = event.target.value;
	      if (this.props.throttle) {
	        this.setState({
	          value: value
	        });
	        this.throttledUpdateValue(value);
	      } else {
	        this.updateValue(value);
	      }
	    }
	  }, {
	    key: "handleMouseDown",
	    value: function handleMouseDown(event) {
	      event.stopPropagation();
	    }
	  }, {
	    key: "onClick",
	    value: function onClick(event) {
	      event.stopPropagation();
	    }
	  }, {
	    key: "updateValue",
	    value: function updateValue(value) {
	      this.props.onChange(value);
	    }
	  }, {
	    key: "selectForwardIfNecessary",
	    value: function selectForwardIfNecessary() {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.value;
	      if (!value || typeof value !== 'string') {
	        return null;
	      }
	      var suggestion = this.props.suggestion;
	      if (typeof suggestion !== 'string') {
	        return null;
	      }
	      if (suggestion.toLowerCase().indexOf(value.toLowerCase()) === -1) {
	        return null;
	      }
	      var firstPartLength = value.length;
	      var inputNode = this.inputNode;
	      this.inputNode.value = suggestion;
	      this.inputNode.size = this.inputNode.value.length;
	      this.inputNode.style.width = 'auto';
	      (0, _setInputSelection.default)(inputNode, firstPartLength, suggestion.length);
	      return true;
	    }
	  }, {
	    key: "getSelectionStart",
	    value: function getSelectionStart() {
	      return (0, _getSelectionStart2.default)(this.inputNode);
	    }
	  }, {
	    key: "getSelectionEnd",
	    value: function getSelectionEnd() {
	      return (0, _getSelectionEnd2.default)(this.inputNode);
	    }
	  }, {
	    key: "hasSelection",
	    value: function hasSelection() {
	      return this.getSelectionStart() !== this.getSelectionEnd();
	    }
	  }, {
	    key: "isCursorAtStartPosition",
	    value: function isCursorAtStartPosition() {
	      return this.getSelectionStart() === 0;
	    }
	  }, {
	    key: "isCursorAtEndPosition",
	    value: function isCursorAtEndPosition() {
	      var cursorLastPissiblePosition = this.props.value && this.props.value.length;
	      return (0, _getCursorPosition.default)(this.inputNode) === cursorLastPissiblePosition;
	    }
	  }]);
	  return TextInput;
	}(_react.Component);
	function emptyFn() {}
	TextInput.defaultProps = {
	  onChange: emptyFn,
	  value: '',
	  autocomplete: true
	};
	TextInput.propTypes = {
	  rootClassName: _propTypes.default.string,
	  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.arrayOf(_propTypes.default.number)]),
	  placeholder: _propTypes.default.node,
	  onChange: _propTypes.default.func,
	  maxWidth: _propTypes.default.number,
	  throttle: _propTypes.default.number,
	  tabIndex: _propTypes.default.number,
	  autocomplete: _propTypes.default.bool,
	  autocompleteDelay: _propTypes.default.number,
	  visible: _propTypes.default.bool,
	  suggestion: _propTypes.default.any,
	  searchable: _propTypes.default.bool
	};
	var _default = TextInput;
	exports.default = _default;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _Icons = __webpack_require__(112);
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var ToggleButton = function ToggleButton(_ref) {
	  var onToggle = _ref.onToggle,
	    className = _ref.className,
	    toggleIcon = _ref.toggleIcon,
	    size = _ref.size,
	    expanded = _ref.expanded;
	  var toggleIconProps = {
	    className: className,
	    size: size,
	    expanded: expanded,
	    onClick: function onClick(event) {
	      event.preventDefault();
	      onToggle();
	    }
	  };
	  var toggleButtonEl;
	  if (toggleIcon) {
	    var params = {
	      onToggle: onToggle,
	      expanded: expanded,
	      domProps: toggleIconProps
	    };
	    toggleButtonEl = typeof toggleIcon === 'function' ? toggleIcon(params) : toggleIcon;
	  }
	  if (toggleButtonEl === true || toggleButtonEl == undefined) {
	    toggleButtonEl = _react.default.createElement(_Icons.ToggleIcon, _objectSpread({}, toggleIconProps));
	  }
	  return toggleButtonEl;
	};
	ToggleButton.defaultProps = {
	  size: 10
	};
	ToggleButton.propTypes = {
	  expanded: _propTypes.default.bool,
	  size: _propTypes.default.number
	};
	var _default = ToggleButton;
	exports.default = _default;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _join = _interopRequireDefault(__webpack_require__(83));
	var _ComboBox = __webpack_require__(241);
	var _Tag = _interopRequireDefault(__webpack_require__(652));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var Value = function (_Component) {
	  (0, _inherits2.default)(Value, _Component);
	  var _super = _createSuper(Value);
	  function Value(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, Value);
	    _this = _super.call(this, props);
	    _this.state = {
	      size: null
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(Value, [{
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var value = props.value,
	        multiple = props.multiple,
	        rootClassName = props.rootClassName,
	        toolsSize = props.toolsSize,
	        focus = props.focus,
	        rtl = props.rtl,
	        searchable = props.searchable,
	        wrapMultiple = props.wrapMultiple,
	        label = props.label;
	      var showTags = value != null && multiple;
	      var style = _objectSpread({}, props.style);
	      if (toolsSize) {
	        style.maxWidth = "calc(100% - ".concat(toolsSize.width, "px)");
	      }
	      var className = (0, _join.default)(rootClassName, wrapMultiple ? "".concat(rootClassName, "--wrap") : "".concat(rootClassName, "--no-wrap"), "".concat(rootClassName, "--").concat(rtl ? 'rtl' : 'ltr'));
	      var isDisplayValueVisible = !showTags && !focus;
	      if (!showTags && !searchable) {
	        isDisplayValueVisible = true;
	      }
	      if (value == null) {
	        isDisplayValueVisible = false;
	      }
	      var displayValue = isDisplayValueVisible ? this.renderDisplayValue() : null;
	      return _react.default.createElement("div", {
	        className: className,
	        style: style
	      }, showTags && this.renderTags(), displayValue, this.renderTextInput({
	        isDisplayValueVisible: displayValue
	      }));
	    }
	  }, {
	    key: "renderTextInput",
	    value: function renderTextInput(_ref) {
	      var isDisplayValueVisible = _ref.isDisplayValueVisible;
	      var textInput = this.props.textInput;
	      if (!textInput) {
	        return null;
	      }
	      if (textInput.type !== 'input') {
	        return _react.default.cloneElement(textInput, _objectSpread(_objectSpread({}, textInput.props), {}, {
	          visible: !isDisplayValueVisible && this.props.searchable
	        }));
	      }
	      return textInput;
	    }
	  }, {
	    key: "renderDisplayValue",
	    value: function renderDisplayValue() {
	      var _this$props = this.props,
	        rootClassName = _this$props.rootClassName,
	        label = _this$props.label,
	        renderDisplayValue = _this$props.renderDisplayValue;
	      var domProps = {
	        className: "".concat(rootClassName, "__display-value"),
	        children: label
	      };
	      var result = null;
	      if (typeof renderDisplayValue === 'function') {
	        result = renderDisplayValue({
	          domProps: domProps,
	          label: label
	        });
	      }
	      if (result == null) {
	        result = _react.default.createElement("div", _objectSpread({}, domProps));
	      }
	      return result;
	    }
	  }, {
	    key: "renderTags",
	    value: function renderTags() {
	      var _this2 = this;
	      var _this$props2 = this.props,
	        renderTags = _this$props2.renderTags,
	        value = _this$props2.value,
	        items = _this$props2.items,
	        groupedItems = _this$props2.groupedItems;
	      if (!items) {
	        return null;
	      }
	      var remainingItems;
	      var visibleItems;
	      if (groupedItems) {
	        remainingItems = groupedItems.remainingItems;
	        visibleItems = groupedItems.visibleItems;
	      } else {
	        visibleItems = items;
	      }
	      var remainingTags = remainingItems && this.renderTag(remainingItems, this.props.maxTagsLength, {
	        visibleItems: visibleItems
	      });
	      var visibleTags = visibleItems && visibleItems.map(function (item, index) {
	        return _this2.renderTag(item, index);
	      });
	      var tags = [].concat((0, _toConsumableArray2.default)(visibleTags), [remainingTags]);
	      if (typeof renderTags === 'function') {
	        tags = renderTags({
	          tags: tags,
	          items: items,
	          value: value,
	          visibleItems: visibleItems,
	          remainingItems: remainingItems
	        });
	      }
	      return tags;
	    }
	  }, {
	    key: "renderTag",
	    value: function renderTag(item, index) {
	      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var items = this.props.items;
	      if (!item) {
	        return null;
	      }
	      var _this$props3 = this.props,
	        rootClassName = _this$props3.rootClassName,
	        renderTag = _this$props3.renderTag,
	        activeTag = _this$props3.activeTag,
	        maxTagsLength = _this$props3.maxTagsLength,
	        renderTagLabel = _this$props3.renderTagLabel,
	        renderRemainingTags = _this$props3.renderRemainingTags;
	      var tagRootClassName = "".concat(rootClassName, "__tag");
	      var isMultiple = Array.isArray(item);
	      var active = isMultiple ? activeTag === _ComboBox.REMAINING_ITEMS : activeTag === item.id;
	      var tagProps = _objectSpread(_objectSpread(_objectSpread({
	        item: item,
	        items: items,
	        active: active,
	        isMultiple: isMultiple,
	        renderTagLabel: renderTagLabel,
	        maxTagsLength: maxTagsLength,
	        index: index,
	        renderTag: renderTag
	      }, config), this.props.tagProps), {}, {
	        rootClassName: tagRootClassName,
	        key: index
	      });
	      var tag;
	      if (isMultiple && typeof renderRemainingTags === 'function') {
	        tag = renderRemainingTags({
	          remainingItems: item,
	          visibleItems: config.visibleItems,
	          domProps: tagProps
	        });
	      }
	      if (tag === undefined) {
	        tag = _react.default.createElement(_Tag.default, _objectSpread({}, tagProps));
	      }
	      return tag;
	    }
	  }]);
	  return Value;
	}(_react.Component);
	Value.defaultProps = {
	  tagProps: {},
	  groupedItems: null,
	  items: []
	};
	var VALUE_TYPE = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object, _propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object, _propTypes.default.bool]))]);
	Value.propTypes = {
	  size: _propTypes.default.shape({
	    width: _propTypes.default.number,
	    height: _propTypes.default.number
	  }),
	  focus: _propTypes.default.bool,
	  items: _propTypes.default.array,
	  item: _propTypes.default.object,
	  groupedItems: _propTypes.default.shape({
	    visibleItems: _propTypes.default.array,
	    remainingItems: _propTypes.default.array
	  }),
	  renderTag: _propTypes.default.func,
	  renderRemainingTags: _propTypes.default.func,
	  renderTags: _propTypes.default.func,
	  renderTagLabel: _propTypes.default.func,
	  tagProps: _propTypes.default.object,
	  maxTagsLength: _propTypes.default.number,
	  rootClassName: _propTypes.default.string,
	  multiple: _propTypes.default.bool,
	  textInput: _propTypes.default.node,
	  value: VALUE_TYPE
	};
	var _default = Value;
	exports.default = _default;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _ComboBox = _interopRequireDefault(__webpack_require__(241));
	var _default = _ComboBox.default;
	exports.default = _default;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	function deselectValue(_ref) {
	  var id = _ref.id,
	    value = _ref.value,
	    _ref$getIdProperty = _ref.getIdProperty,
	    getIdProperty = _ref$getIdProperty === void 0 ? function (item) {
	      return item && item.id;
	    } : _ref$getIdProperty;
	  var newValue;
	  var singleValueId = (0, _typeof2.default)(value) === 'object' ? getIdProperty(value) : value;
	  if (id === singleValueId || singleValueId === null) {
	    newValue = null;
	  }
	  if (Array.isArray(value)) {
	    newValue = value.filter(function (value) {
	      var valueId = (0, _typeof2.default)(value) === 'object' ? getIdProperty(value) : value;
	      return valueId !== id;
	    });
	    if (!newValue.length) {
	      newValue = null;
	    }
	  }
	  return newValue;
	}
	var _default = deselectValue;
	exports.default = _default;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _hightlightText = _interopRequireDefault(__webpack_require__(675));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var defaultFilterFunction = function defaultFilterFunction(_ref) {
	  var label = _ref.label,
	    text = _ref.text,
	    mode = _ref.mode;
	  label = label.toLowerCase ? label.toLowerCase() : "".concat(label);
	  text = text.toLowerCase ? text.toLowerCase() : "".concat(text);
	  return mode === 'contains' ? label.indexOf(text) !== -1 : label.startsWith(text);
	};
	function filterByText(_ref2) {
	  var data = _ref2.data,
	    getFilterProperty = _ref2.getFilterProperty,
	    text = _ref2.text,
	    _ref2$filterFunction = _ref2.filterFunction,
	    filterFunction = _ref2$filterFunction === void 0 ? defaultFilterFunction : _ref2$filterFunction,
	    _ref2$mode = _ref2.mode,
	    mode = _ref2$mode === void 0 ? 'contains' : _ref2$mode,
	    hightlight = _ref2.hightlight;
	  if (!Array.isArray(data)) {
	    return null;
	  }
	  var filteredData = data.reduce(function (acc, item) {
	    var label = getFilterProperty(item);
	    var match = filterFunction({
	      label: label,
	      text: text,
	      item: item,
	      mode: mode
	    });
	    if (match) {
	      if (hightlight) {
	        var newItem = _objectSpread(_objectSpread({}, item), {}, {
	          mode: mode,
	          matchText: (0, _hightlightText.default)({
	            queryText: text,
	            text: label
	          })
	        });
	        acc.push(newItem);
	      } else {
	        acc.push(item);
	      }
	    }
	    return acc;
	  }, []);
	  return filteredData;
	}
	var _default = filterByText;
	exports.default = _default;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _isSelected = _interopRequireDefault(__webpack_require__(243));
	function filterByValue(_ref) {
	  var data = _ref.data,
	    getIdProperty = _ref.getIdProperty,
	    value = _ref.value;
	  return data.filter(function (item) {
	    var id = getIdProperty(item);
	    return !(0, _isSelected.default)({
	      id: id,
	      value: value
	    });
	  });
	}
	var _default = filterByValue;
	exports.default = _default;

/***/ },
/* 660 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function getCursorPosition(field) {
	  var cursorPosition = 0;
	  if (document.selection) {
	    field.focus();
	    var oSel = document.selection.createRange();
	    oSel.moveStart('character', -field.value.length);
	    cursorPosition = oSel.text.length;
	  } else if (field.selectionStart || field.selectionStart == '0') {
	    cursorPosition = field.selectionStart;
	  }
	  return cursorPosition;
	}
	var _default = getCursorPosition;
	exports.default = _default;

/***/ },
/* 661 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var getDataProp = function getDataProp(propName) {
	  if (propName == null) {
	    return null;
	  }
	  return function (item) {
	    if (!item) {
	      return null;
	    }
	    return typeof propName === 'function' ? propName(item) : item[propName];
	  };
	};
	var _default = getDataProp;
	exports.default = _default;

/***/ },
/* 662 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function getGroups(data) {
	  var groupProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'group';
	  var groupsConfig = data.reduce(function (acc, item, index) {
	    var groupTitle = item[groupProperty];
	    var currentGroup = acc.groups[acc.currentGroup];
	    if (groupTitle && groupTitle !== (currentGroup && currentGroup.title)) {
	      var newGroup = {
	        title: groupTitle,
	        indexAjustment: acc.indexAjustment + 1
	      };
	      var groupIndex = index + acc.indexAjustment;
	      acc.groups[groupIndex] = newGroup;
	      acc.currentGroup = groupIndex;
	      acc.indexAjustment += 1;
	    }
	    return acc;
	  }, {
	    groups: {},
	    currentGroup: 0,
	    indexAjustment: 0
	  });
	  return groupsConfig.groups;
	}
	var _default = getGroups;
	exports.default = _default;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function getListProps(_ref) {
	  var props = _ref.props,
	    _ref$state = _ref.state,
	    state = _ref$state === void 0 ? {} : _ref$state,
	    computed = _ref.computed;
	  return _objectSpread(_objectSpread({}, computed), {}, {
	    style: props.listStyle,
	    relativeToViewport: props.relativeToViewport,
	    virtualListFactory: props.virtualListFactory,
	    renderListScroller: props.renderListScroller,
	    renderVirtualList: props.renderVirtualList,
	    className: props.listClassName,
	    rootClassName: "".concat(props.rootClassName, "__list"),
	    emptyText: props.listEmptyText,
	    maxHeight: props.listMaxHeight,
	    minHeight: props.listMinHeight,
	    positions: props.positions,
	    constrainTo: props.constrainTo,
	    offset: props.offset,
	    rtl: props.rtl,
	    theme: props.theme,
	    highlightFirst: props.highlightFirst,
	    loadingText: props.listLoadingText,
	    groups: state.groups,
	    renderGroup: props.renderGroup,
	    renderFooter: props.renderFooter,
	    renderHeader: props.renderHeader,
	    renderItem: props.renderItem,
	    itemEllipsis: props.itemEllipsis,
	    activeItemIndex: state.activeItemIndex,
	    newCustomTagText: props.newCustomTagText,
	    autoPosition: props.autoPosition,
	    itemProps: {
	      background: props.itemBackground,
	      disabledStyle: props.disabledItemStyle,
	      disabledClassName: props.disabledItemClassName,
	      activeStyle: props.activeItemStyle,
	      activeClassName: props.activeItemClassName,
	      selectedStyle: props.selectedStyle,
	      selectedClassName: props.selectedClassName
	    }
	  });
	}
	var _default = getListProps;
	exports.default = _default;

/***/ },
/* 664 */
581,
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _clamp = _interopRequireDefault(__webpack_require__(81));
	function getNewActiveTagOnRemove(_ref) {
	  var id = _ref.id,
	    value = _ref.value,
	    dir = _ref.dir;
	  dir = dir || -1;
	  if (!Array.isArray(value) || value.length === 1) {
	    return null;
	  }
	  var newActiveTag = null;
	  var currentIndex = value.indexOf(id);
	  var lastIndex = value.length - 1;
	  var newIndex = (0, _clamp.default)(currentIndex + dir, 0, lastIndex);
	  if (dir == 1 && currentIndex === lastIndex) {
	    newIndex = (0, _clamp.default)(currentIndex - 1, 0, lastIndex);
	  }
	  if (dir == -1 && currentIndex == 0 && lastIndex > 0) {
	    newIndex = 1;
	  }
	  newActiveTag = value[newIndex];
	  return newActiveTag;
	}
	var _default = getNewActiveTagOnRemove;
	exports.default = _default;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	function getNewMultipleValue(_ref) {
	  var id = _ref.id,
	    value = _ref.value;
	  var newValue;
	  var isArray = Array.isArray(value);
	  var hasValue = isArray && value.indexOf(id) !== -1;
	  if (hasValue) {
	    newValue = value.filter(function (itemId) {
	      return itemId !== id;
	    });
	    newValue = newValue.length ? newValue : null;
	  } else {
	    newValue = isArray ? [].concat((0, _toConsumableArray2.default)(value), [id]) : [id];
	  }
	  return newValue;
	}
	var _default = getNewMultipleValue;
	exports.default = _default;

/***/ },
/* 667 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function getNewSingleValue(_ref) {
	  var id = _ref.id,
	    value = _ref.value,
	    _ref$toggle = _ref.toggle,
	    toggle = _ref$toggle === void 0 ? true : _ref$toggle;
	  if (value == null) {
	    return id;
	  }
	  if (toggle) {
	    return id === value ? null : id;
	  }
	  return id;
	}
	var _default = getNewSingleValue;
	exports.default = _default;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _findItemIndex = _interopRequireDefault(__webpack_require__(242));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function getNextItem(config) {
	  var data = config.data,
	    id = config.id,
	    getIdProperty = config.getIdProperty,
	    _config$direction = config.direction,
	    direction = _config$direction === void 0 ? 1 : _config$direction;
	  if (!Array.isArray(data) || !data.length || !getIdProperty || id == null) {
	    return null;
	  }
	  if (data.length === 1) {
	    return id;
	  }
	  var enabledItems = data.filter(function (item) {
	    return !item.disabled;
	  });
	  if (enabledItems.length === 0) {
	    return null;
	  }
	  var currentIndex = (0, _findItemIndex.default)({
	    data: data,
	    id: id,
	    getIdProperty: getIdProperty
	  });
	  var nextIndex;
	  if (direction === 1) {
	    nextIndex = currentIndex + 1;
	    nextIndex = nextIndex > data.length - 1 ? 0 : nextIndex;
	  } else {
	    nextIndex = currentIndex - 1;
	    nextIndex = nextIndex >= 0 ? nextIndex : data.length - 1;
	  }
	  var newItem = data[nextIndex];
	  var newActiveId = getIdProperty(newItem);
	  if (newItem.disabled) {
	    newActiveId = getNextItem(_objectSpread(_objectSpread({}, config), {}, {
	      id: newActiveId
	    }));
	  }
	  return newActiveId;
	}
	var _default = getNextItem;
	exports.default = _default;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _join = _interopRequireDefault(__webpack_require__(83));
	function getRootClassName(_ref) {
	  var _ref$props = _ref.props,
	    props = _ref$props === void 0 ? {} : _ref$props,
	    _ref$state = _ref.state,
	    state = _ref$state === void 0 ? {} : _ref$state,
	    _ref$computed = _ref.computed,
	    computed = _ref$computed === void 0 ? {} : _ref$computed;
	  var rootClassName = props.rootClassName,
	    className = props.className,
	    rtl = props.rtl,
	    shadow = props.shadow,
	    showShadowOnMouseOver = props.showShadowOnMouseOver,
	    disabled = props.disabled,
	    readOnly = props.readOnly,
	    emptyClassName = props.emptyClassName,
	    disabledClassName = props.disabledClassName,
	    focusedClassName = props.focusedClassName,
	    inlineFlex = props.inlineFlex,
	    multiple = props.multiple,
	    theme = props.theme;
	  var over = state.over,
	    focus = state.focus;
	  var value = computed.value;
	  var showShadow = showShadowOnMouseOver ? over && shadow : shadow;
	  return (0, _join.default)(rootClassName, className, rtl ? "".concat(rootClassName, "--rtl") : "".concat(rootClassName, "--ltr"), showShadow && "".concat(rootClassName, "--shadow"), multiple && "".concat(rootClassName, "--multiple"), disabled && "".concat(rootClassName, "--disabled"), readOnly && "".concat(rootClassName, "--readOnly"), theme && "".concat(rootClassName, "--theme-").concat(theme), inlineFlex && "".concat(rootClassName, "--inlineFlex"), focus && "".concat(rootClassName, "--focus"), !value && emptyClassName, disabled && disabledClassName, focus && focusedClassName);
	}
	var _default = getRootClassName;
	exports.default = _default;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	function getSelectionEnd(input) {
	  if (!input) {
	    return null;
	  }
	  var document = globalObject.document;
	  if (input.createTextRange && !globalObject.getSelection) {
	    var range = document.selection.crangeeateRange().duplicate();
	    range.moveStart('character', -input.value.length);
	    return range.text.length;
	  }
	  return input.selectionEnd;
	}
	var _default = getSelectionEnd;
	exports.default = _default;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	function getSelectionStart(input) {
	  if (!input) {
	    return null;
	  }
	  if (input.createTextRange && !globalObject.getSelection) {
	    var document = globalObject.document;
	    var range = document.selection.createRange().duplicate();
	    range.moveEnd('character', input.value.length);
	    if (range.text == '') {
	      return input.value.length;
	    }
	    return input.value.lastIndexOf(range.text);
	  }
	  return input.selectionStart;
	}
	var _default = getSelectionStart;
	exports.default = _default;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var contains = function contains(stack, needle) {
	  for (var i = 0; i < stack.length; i++) {
	    if (stack[i] == needle) {
	      return true;
	    }
	  }
	  return false;
	};
	function getValueMap(_ref) {
	  var value = _ref.value,
	    dataMap = _ref.dataMap,
	    oldValueMap = _ref.oldValueMap;
	  if (value == null) {
	    return oldValueMap;
	  }
	  var valueMap = _objectSpread({}, oldValueMap);
	  value = Array.isArray(value) ? value : [value];
	  valueMap = Object.keys(valueMap).reduce(function (acc, id) {
	    if (contains(value, id)) {
	      acc[id] = valueMap[id];
	    }
	    return acc;
	  }, {});
	  value.forEach(function (id) {
	    if (dataMap && dataMap[id]) {
	      valueMap[id] = dataMap[id];
	    }
	  });
	  return valueMap;
	}
	var _default = getValueMap;
	exports.default = _default;

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function getValueProps(_ref) {
	  var _objectSpread2;
	  var state = _ref.state,
	    props = _ref.props,
	    computed = _ref.computed,
	    tagProps = _ref.tagProps;
	  var multiple = props.multiple,
	    renderTag = props.renderTag,
	    renderTags = props.renderTags,
	    tagBorder = props.tagBorder,
	    tagStyle = props.tagStyle,
	    tagPadding = props.tagPadding,
	    tagHeight = props.tagHeight,
	    tagWidth = props.tagWidth,
	    tagMinSize = props.tagMinSize,
	    tagMaxSize = props.tagMaxSize,
	    wrapMultiple = props.wrapMultiple,
	    tagCloseIcon = props.tagCloseIcon,
	    tagCloseIconPosition = props.tagCloseIconPosition,
	    maxTagsLength = props.maxTagsLength,
	    rtl = props.rtl,
	    renderRemainingTags = props.renderRemainingTags,
	    renderDisplayValue = props.renderDisplayValue,
	    searchable = props.searchable,
	    renderTagLabel = props.renderTagLabel;
	  var focus = state.focus;
	  var rootClassName = "".concat(props.rootClassName, "__value");
	  tagProps = _objectSpread(_objectSpread({}, tagProps), {}, {
	    closeIcon: tagCloseIcon,
	    border: tagBorder,
	    style: tagStyle,
	    padding: tagPadding,
	    height: tagHeight,
	    width: tagWidth,
	    minSize: tagMinSize,
	    maxSize: tagMaxSize,
	    closeIconPosition: tagCloseIconPosition,
	    ellipsis: props.tagEllipsis
	  });
	  var valueProps = _objectSpread((_objectSpread2 = {
	    renderTagLabel: renderTagLabel,
	    multiple: multiple,
	    searchable: searchable,
	    rootClassName: rootClassName,
	    renderTag: renderTag,
	    renderRemainingTags: renderRemainingTags,
	    renderTags: renderTags,
	    tagProps: tagProps,
	    wrapMultiple: wrapMultiple,
	    maxTagsLength: maxTagsLength,
	    focus: focus
	  }, (0, _defineProperty2.default)(_objectSpread2, "maxTagsLength", maxTagsLength), (0, _defineProperty2.default)(_objectSpread2, "rtl", rtl), (0, _defineProperty2.default)(_objectSpread2, "renderDisplayValue", renderDisplayValue), _objectSpread2), computed);
	  return valueProps;
	}
	var _default = getValueProps;
	exports.default = _default;

/***/ },
/* 674 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function groupItems(_ref) {
	  var items = _ref.items,
	    maxTagsLength = _ref.maxTagsLength;
	  var visibleItems = items;
	  var remainingItems = null;
	  if (items.length > maxTagsLength) {
	    var cutFrom = maxTagsLength;
	    remainingItems = items.slice(cutFrom);
	    visibleItems = items.slice(0, cutFrom);
	  }
	  return {
	    visibleItems: visibleItems,
	    remainingItems: remainingItems
	  };
	}
	var _default = groupItems;
	exports.default = _default;

/***/ },
/* 675 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function hightlightText(_ref) {
	  var queryText = _ref.queryText,
	    text = _ref.text,
	    _ref$mode = _ref.mode,
	    mode = _ref$mode === void 0 ? 'contains' : _ref$mode;
	  var regex = mode === 'contains' ? new RegExp(queryText, 'gi') : new RegExp("^".concat(queryText), 'gi');
	  var matchText = [];
	  var searchQueryLen = queryText.length;
	  var localMatch;
	  var previousLocalMatch;
	  while ((localMatch = regex.exec(text)) !== null) {
	    var index = localMatch.index;
	    var previousSegmentIndex = previousLocalMatch ? previousLocalMatch.index + searchQueryLen : 0;
	    matchText.push(text.slice(previousSegmentIndex, index));
	    matchText.push({
	      match: text.slice(localMatch.index, localMatch.index + searchQueryLen)
	    });
	    previousLocalMatch = localMatch;
	  }
	  matchText.push(text.slice(previousLocalMatch.index + searchQueryLen));
	  matchText = matchText.filter(function (match) {
	    return match;
	  });
	  return matchText;
	}
	var _default = hightlightText;
	exports.default = _default;

/***/ },
/* 676 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function setInputSelection(input, startPos, endPos) {
	  if (input.selectionStart !== undefined) {
	    input.selectionStart = startPos;
	    input.selectionEnd = endPos;
	  } else if (document.selection && document.selection.createRange) {
	    input.select();
	    var range = document.selection.createRange();
	    range.collapse(true);
	    range.moveEnd('character', endPos);
	    range.moveStart('character', startPos);
	    range.select();
	  }
	}
	var _default = setInputSelection;
	exports.default = _default;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _shallowequal = _interopRequireDefault(__webpack_require__(217));
	var _default = function _default(inst, nextProps, nextState) {
	  var props = inst.props;
	  var state = inst.state;
	  if (nextProps.shouldComponentUpdate) {
	    return nextProps.shouldComponentUpdate({
	      nextProps: nextProps,
	      props: props,
	      nextState: nextState,
	      state: state
	    });
	  }
	  return !(0, _shallowequal.default)(nextProps, props) || !(0, _shallowequal.default)(nextState, state);
	};
	exports.default = _default;

/***/ },
/* 678 */
[1296, 680],
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _regionAlign = _interopRequireDefault(__webpack_require__(55));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _Menu = _interopRequireDefault(__webpack_require__(113));
	var _Button = _interopRequireDefault(__webpack_require__(149));
	var _ToggleIcon = _interopRequireDefault(__webpack_require__(578));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _containsNode = _interopRequireDefault(__webpack_require__(71));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var ALIGN_OFFSET = {
	  top: 5
	};
	var returnFalse = function returnFalse() {
	  return false;
	};
	var InovuaDropDownButton = function (_Component) {
	  (0, _inherits2.default)(InovuaDropDownButton, _Component);
	  var _super = _createSuper(InovuaDropDownButton);
	  function InovuaDropDownButton(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaDropDownButton);
	    _this = _super.call(this, props);
	    _this.state = {
	      expanded: props.defaultExpanded,
	      focused: false
	    };
	    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleClickOutside = _this.handleClickOutside.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleWindowScroll = _this.handleWindowScroll.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onMenuDismiss = _this.onMenuDismiss.bind((0, _assertThisInitialized2.default)(_this));
	    _this.rootRef = function (ref) {
	      _this.rootNode = ref;
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaDropDownButton, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (nextProps.shouldComponentUpdate) {
	        return nextProps.shouldComponentUpdate(nextProps, nextState, this);
	      }
	      return true;
	    }
	  }, {
	    key: "onMenuDismiss",
	    value: function onMenuDismiss() {
	      this.props.onDismiss();
	    }
	  }, {
	    key: "handleKeyDown",
	    value: function handleKeyDown(event) {
	      var key = event.key;
	      if (this.props.hideMenuOnEscape && this.getExpanded()) {
	        this.collapse();
	        event.preventDefault();
	      }
	      if (this.props.onKeyDown) {
	        this.props.onKeyDown(event);
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateComponentReferenceRegion();
	      if (this.props.dismissOnScroll) {
	        window.addEventListener('scroll', this.handleWindowScroll, {
	          capture: true
	        });
	        window.addEventListener('scroll', this.handleWindowScroll, {
	          capture: false
	        });
	      }
	      globalObject.addEventListener('click', this.handleClickOutside);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      globalObject.removeEventListener('click', this.handleClickOutside);
	      globalObject.removeEventListener('scroll', this.handleWindowScroll, {
	        capture: true
	      });
	      globalObject.removeEventListener('scroll', this.handleWindowScroll, {
	        capture: false
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var className = (0, _join.default)(props.rootClassName, props.className, props.theme && "".concat(props.rootClassName, "--theme-").concat(props.theme), this.state.focused && "".concat(props.rootClassName, "--focused"), props.disabled && "".concat(props.rootClassName, "--disabled"), this.getExpanded() && "".concat(props.rootClassName, "--expanded"), props.rtl ? "".concat(props.rootClassName, "--rtl") : "".concat(props.rootClassName, "--ltr"));
	      return _react.default.createElement("div", _objectSpread(_objectSpread({}, (0, _cleanProps.default)(props, InovuaDropDownButton.propTypes)), {}, {
	        ref: this.rootRef,
	        className: className
	      }), this.renderButton(), this.renderMenu());
	    }
	  }, {
	    key: "renderButton",
	    value: function renderButton() {
	      var _objectSpread2;
	      var props = this.props;
	      var className = "".concat(props.rootClassName, "__button");
	      var buttonProps = _objectSpread(_objectSpread(_objectSpread({}, this.getCommonProps()), {}, {
	        key: 'button',
	        iconPosition: this.props.iconPosition || this.props.arrowPosition,
	        style: _objectSpread({}, props.buttonProps)
	      }, props.buttonProps), {}, (_objectSpread2 = {
	        className: className,
	        icon: props.icon,
	        disabled: props.disabled,
	        onClick: this.handleClick,
	        rtl: props.rtl,
	        onFocus: this.handleFocus,
	        onBlur: this.handleBlur,
	        onKeyDown: this.handleKeyDown
	      }, (0, _defineProperty2.default)(_objectSpread2, "icon", [props.icon && props.icon.type ? (0, _react.cloneElement)(props.icon, {
	        key: 'inovua-ddbuttonicon'
	      }) : props.icon, this.renderArrow()]), (0, _defineProperty2.default)(_objectSpread2, "children", props.children), (0, _defineProperty2.default)(_objectSpread2, "tagName", 'div'), _objectSpread2));
	      var result;
	      if (typeof props.renderButton === 'function') {
	        result = props.renderButton(buttonProps);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement(_Button.default, _objectSpread({}, buttonProps));
	      }
	      return result;
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(event) {
	      if (this.props.hideMenuOnClick) {
	        this.toggle();
	      } else {
	        this.expand();
	      }
	      this.props.onClick(event);
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(event) {
	      if (this.props.disabled) {
	        return;
	      }
	      this.setState({
	        focused: true
	      });
	      this.props.onFocus(event);
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(event) {
	      if (this.props.disabled) {
	        return;
	      }
	      this.setState({
	        focused: false
	      });
	      this.props.onBlur(event);
	    }
	  }, {
	    key: "expand",
	    value: function expand() {
	      this.setExpanded(true);
	    }
	  }, {
	    key: "collapse",
	    value: function collapse() {
	      this.setExpanded(false);
	    }
	  }, {
	    key: "toggle",
	    value: function toggle() {
	      var expanded = this.getExpanded();
	      this.setExpanded(!expanded);
	    }
	  }, {
	    key: "isExpandedControlled",
	    value: function isExpandedControlled() {
	      return this.props.expanded != undefined;
	    }
	  }, {
	    key: "setExpanded",
	    value: function setExpanded(expanded) {
	      if (expanded === this.getExpanded()) {
	        return null;
	      }
	      if (!this.isExpandedControlled()) {
	        this.setState({
	          expanded: expanded
	        });
	        this.updateComponentReferenceRegion();
	      }
	      if (!expanded) {
	        this.props.onDismiss();
	      }
	      this.props.onExpandedChange(expanded);
	    }
	  }, {
	    key: "getExpanded",
	    value: function getExpanded() {
	      return this.isExpandedControlled() ? this.props.expanded : this.state.expanded;
	    }
	  }, {
	    key: "updateComponentReferenceRegion",
	    value: function updateComponentReferenceRegion() {
	      var node = this.props.getAlignNode ? this.props.getAlignNode() : this.rootNode;
	      if (!node) {
	        return null;
	      }
	      var referenceRegion = _regionAlign.default.from(node);
	      this.setState({
	        referenceRegion: referenceRegion
	      });
	    }
	  }, {
	    key: "renderMenu",
	    value: function renderMenu() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var expanded = this.getExpanded();
	      if (!expanded && !this.props.renderMenuWhenCollapsed) {
	        return;
	      }
	      if (!props.items || !props.items.length) {
	        return null;
	      }
	      var style = _objectSpread({}, props.menuProps.style);
	      if (!expanded) {
	        style.display = 'none';
	      }
	      var menuProps = _objectSpread(_objectSpread(_objectSpread({}, this.getCommonProps()), {}, {
	        key: 'menu',
	        items: props.items,
	        alignOffset: ALIGN_OFFSET,
	        constrainTo: props.constrainTo
	      }, props.menuProps), {}, {
	        alignTo: this.state.referenceRegion,
	        alignPositions: props.alignPositions,
	        onChildClick: props.onMenuClick,
	        rtl: props.rtl,
	        style: style,
	        visible: expanded,
	        theme: 'default-light',
	        className: "".concat(props.rootClassName, "__menu"),
	        onDismiss: this.onMenuDismiss
	      });
	      if (!expanded && !this.prevExpanded && this.props.optimizeMenuSCUWhenCollapsed) {
	        menuProps.shouldComponentUpdate = returnFalse;
	      }
	      this.prevExpanded = expanded;
	      var MenuComp = this.props.menu ? this.props.menu : _Menu.default;
	      if (!MenuComp) {
	        return null;
	      }
	      var result;
	      if (typeof props.renderMenu === 'function') {
	        result = props.renderMenu(menuProps);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement(MenuComp, _objectSpread({}, menuProps));
	      }
	      return result;
	    }
	  }, {
	    key: "renderArrow",
	    value: function renderArrow() {
	      var props = this.props;
	      var result = null;
	      if (props.arrow !== true) {
	        if (typeof props.arrow === 'function') {
	          result = props.arrow(this.getExpanded());
	        } else {
	          result = props.arrow;
	        }
	      }
	      if (result === null) {
	        result = _react.default.createElement(_ToggleIcon.default, {
	          key: "icon",
	          className: "".concat(props.rootClassName, "__arrow"),
	          expanded: this.getExpanded()
	        });
	      }
	      return result;
	    }
	  }, {
	    key: "getCommonProps",
	    value: function getCommonProps() {
	      var props = this.props;
	      return {
	        theme: props.theme
	      };
	    }
	  }, {
	    key: "handleClickOutside",
	    value: function handleClickOutside(event) {
	      var node = this.rootNode;
	      var target = event.target;
	      if (!node || !target) {
	        return null;
	      }
	      if (node !== target && !node.contains(target)) {
	        if (this.props.hideMenuOnClickOutside) {
	          this.collapse();
	        }
	      }
	    }
	  }, {
	    key: "handleWindowScroll",
	    value: function handleWindowScroll(event) {
	      if (this.getExpanded() && !(0, _containsNode.default)(this.rootNode, event.target)) {
	        this.setExpanded(false);
	      }
	    }
	  }]);
	  return InovuaDropDownButton;
	}(_react.Component);
	function emptyFn() {}
	InovuaDropDownButton.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-dropdown-button',
	  theme: 'default-light',
	  menuProps: {},
	  rtl: false,
	  menu: null,
	  alignPositions: ['tl-bl', 'tr-br', 'bl-tl', 'br-tr', 'tl-tr', 'bl-br', 'tr-tl', 'tr-br'],
	  arrow: true,
	  arrowPosition: 'end',
	  constrainTo: true,
	  disabled: false,
	  hideMenuOnClick: true,
	  hideMenuOnClickOutside: true,
	  hideMenuOnEscape: true,
	  onExpandedChange: emptyFn,
	  onMenuClick: emptyFn,
	  optimizeMenuSCUWhenCollapsed: false,
	  onClick: emptyFn,
	  onFocus: emptyFn,
	  onBlur: emptyFn,
	  onDismiss: emptyFn,
	  defaultExpanded: false,
	  dismissOnScroll: false,
	  isInovuaButton: true
	};
	InovuaDropDownButton.propTypes = {
	  theme: _propTypes.default.string,
	  rtl: _propTypes.default.bool,
	  dismissOnScroll: _propTypes.default.bool,
	  icon: _propTypes.default.node,
	  iconPosition: _propTypes.default.oneOf(['left', 'right', 'start', 'end']),
	  rootClassName: _propTypes.default.string,
	  menuProps: _propTypes.default.object,
	  buttonProps: _propTypes.default.object,
	  disabled: _propTypes.default.bool,
	  menu: _propTypes.default.func,
	  arrow: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.bool, _propTypes.default.func]),
	  alignPositions: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	  onDismiss: _propTypes.default.func,
	  arrowPosition: _propTypes.default.oneOf(['left', 'right', 'start', 'end']),
	  hideMenuOnClick: _propTypes.default.bool,
	  hideMenuOnEscape: _propTypes.default.bool,
	  hideMenuOnClickOutside: _propTypes.default.bool,
	  renderMenuWhenCollapsed: _propTypes.default.bool,
	  optimizeMenuSCUWhenCollapsed: _propTypes.default.bool,
	  onExpandedChange: _propTypes.default.func,
	  onMenuClick: _propTypes.default.func,
	  onClick: _propTypes.default.func,
	  getAlignNode: _propTypes.default.func,
	  constrainTo: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.bool, _propTypes.default.func]),
	  items: _propTypes.default.array,
	  expanded: _propTypes.default.bool,
	  defaultExpanded: _propTypes.default.bool,
	  pressed: _propTypes.default.bool,
	  renderMenu: _propTypes.default.func,
	  renderButton: _propTypes.default.func,
	  isInovuaButton: _propTypes.default.bool
	};
	var _default = InovuaDropDownButton;
	exports.default = _default;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _DropdownButton = _interopRequireDefault(__webpack_require__(679));
	var _default = _DropdownButton.default;
	exports.default = _default;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var InovuaField = function (_Component) {
	  (0, _inherits2.default)(InovuaField, _Component);
	  var _super = _createSuper(InovuaField);
	  function InovuaField(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaField);
	    _this = _super.call(this, props);
	    _this.ref = function (ref) {
	      _this.input = ref;
	    };
	    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaField, [{
	    key: "render",
	    value: function render() {
	      var inputProps = _objectSpread({}, this.props);
	      delete inputProps.stopChangePropagation;
	      return _react.default.createElement("input", _objectSpread(_objectSpread({}, inputProps), {}, {
	        onChange: this.onChange,
	        ref: this.ref
	      }));
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      if (this.input) {
	        this.input.focus();
	      }
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(event) {
	      if (this.props.stopChangePropagation) {
	        event.stopPropagation();
	      }
	      this.props.onChange(event.target.value, event);
	    }
	  }, {
	    key: "getNode",
	    value: function getNode() {
	      return this.input;
	    }
	  }]);
	  return InovuaField;
	}(_react.Component);
	InovuaField.propTypes = {
	  type: _propTypes.default.string,
	  stopChangePropagation: _propTypes.default.bool
	};
	InovuaField.defaultProps = {
	  stopChangePropagation: true,
	  onChange: function onChange() {},
	  type: 'text'
	};
	var _default = InovuaField;
	exports.default = _default;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _props2className = _interopRequireDefault(__webpack_require__(246));
	var _cleanup = _interopRequireDefault(__webpack_require__(245));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var InovuaFlex = (0, _react.forwardRef)(function (props, ref) {
	  var className = (0, _join.default)('inovua-react-toolkit-flex', (0, _props2className.default)(props));
	  var allProps = _objectSpread({}, props);
	  (0, _cleanup.default)(allProps);
	  allProps.className = className;
	  delete allProps.livePagination;
	  if (props.factory) {
	    return props.factory(allProps);
	  }
	  return _react.default.createElement("div", _objectSpread({
	    ref: ref
	  }, allProps));
	});
	InovuaFlex.defaultProps = {
	  row: true,
	  wrap: true,
	  alignItems: 'center',
	  display: 'flex'
	};
	InovuaFlex.propTypes = {
	  shouldComponentUpdate: _propTypes.default.func,
	  flex: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
	  display: _propTypes.default.oneOf(['flex', 'inline-flex']),
	  inline: _propTypes.default.bool,
	  reverse: _propTypes.default.bool,
	  row: _propTypes.default.bool,
	  column: _propTypes.default.bool,
	  wrap: _propTypes.default.bool,
	  alignItems: _propTypes.default.string,
	  alignContent: _propTypes.default.string,
	  justifyContent: _propTypes.default.string
	};
	var _default = _react.default.memo(InovuaFlex);
	exports.default = _default;

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _shouldComponentUpdate2 = _interopRequireDefault(__webpack_require__(687));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _props2className = _interopRequireDefault(__webpack_require__(246));
	var _cleanup = _interopRequireDefault(__webpack_require__(245));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var InovuaFlexItem = function (_Component) {
	  (0, _inherits2.default)(InovuaFlexItem, _Component);
	  var _super = _createSuper(InovuaFlexItem);
	  function InovuaFlexItem() {
	    (0, _classCallCheck2.default)(this, InovuaFlexItem);
	    return _super.apply(this, arguments);
	  }
	  (0, _createClass2.default)(InovuaFlexItem, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var shouldUpdate = (0, _shouldComponentUpdate2.default)(this, nextProps, nextState);
	      return shouldUpdate;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var className = (0, _join.default)('inovua-react-toolkit-flex-item', (0, _props2className.default)(props));
	      var allProps = _objectSpread({}, props);
	      (0, _cleanup.default)(allProps);
	      allProps.className = className;
	      if (props.factory) {
	        return props.factory(allProps);
	      }
	      return _react.default.createElement("div", _objectSpread({}, allProps));
	    }
	  }]);
	  return InovuaFlexItem;
	}(_react.Component);
	InovuaFlexItem.defaultProps = {
	  flex: 1
	};
	InovuaFlexItem.propTypes = {
	  shouldComponentUpdate: _propTypes.default.func,
	  display: _propTypes.default.oneOf(['flex', 'inline-flex']),
	  inline: function inline(props, propName) {
	    if (props[propName] !== undefined) {
	      return new Error("\"inline\" prop should not be used on \"Item\". Use \"display='inline-flex'\" instead");
	    }
	  },
	  flex: _propTypes.default.any,
	  flexGrow: _propTypes.default.any,
	  flexShrink: _propTypes.default.any,
	  flexBasis: _propTypes.default.any
	};
	var _default = InovuaFlexItem;
	exports.default = _default;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Flex", {
	  enumerable: true,
	  get: function get() {
	    return _Flex.default;
	  }
	});
	Object.defineProperty(exports, "Item", {
	  enumerable: true,
	  get: function get() {
	    return _Item.default;
	  }
	});
	exports.default = void 0;
	var _Flex = _interopRequireDefault(__webpack_require__(682));
	var _Item = _interopRequireDefault(__webpack_require__(683));
	var _default = {
	  Flex: _Flex.default,
	  Item: _Item.default
	};
	exports.default = _default;

/***/ },
/* 685 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = 'inovua-react-toolkit-flex-v3';
	exports.default = _default;

/***/ },
/* 686 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(props) {
	  return props.flex === false ? 0 : props.flex === true ? 1 : props.flex;
	};
	exports.default = _default;

/***/ },
/* 687 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(inst, nextProps, nextState) {
	  var props = inst.props;
	  var state = inst.state;
	  if (nextProps.shouldComponentUpdate) {
	    return nextProps.shouldComponentUpdate({
	      nextProps: nextProps,
	      props: props,
	      nextState: nextState,
	      state: state
	    });
	  }
	  return true;
	};
	exports.default = _default;

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "InertialManager", {
	  enumerable: true,
	  get: function get() {
	    return _InertialManager.default;
	  }
	});
	exports.default = void 0;
	var _src = _interopRequireDefault(__webpack_require__(690));
	var _InertialManager = _interopRequireDefault(__webpack_require__(247));
	var _default = _src.default;
	exports.default = _default;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _isMobile = _interopRequireDefault(__webpack_require__(72));
	var _clamp = _interopRequireDefault(__webpack_require__(81));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	function ypos(e) {
	  if (e.targetTouches && e.targetTouches.length >= 1) {
	    return e.targetTouches[0].clientY;
	  }
	  return e.clientY;
	}
	var InovuaInertialScroller = function (_Component) {
	  (0, _inherits2.default)(InovuaInertialScroller, _Component);
	  var _super = _createSuper(InovuaInertialScroller);
	  function InovuaInertialScroller(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaInertialScroller);
	    _this = _super.call(this, props);
	    _this.state = {};
	    _this.setRootRef = function (ref) {
	      _this.node = ref;
	    };
	    _this.setViewRef = function (ref) {
	      _this.viewNode = ref;
	    };
	    _this.tap = _this.tap.bind((0, _assertThisInitialized2.default)(_this));
	    _this.drag = _this.drag.bind((0, _assertThisInitialized2.default)(_this));
	    _this.release = _this.release.bind((0, _assertThisInitialized2.default)(_this));
	    _this.track = _this.track.bind((0, _assertThisInitialized2.default)(_this));
	    _this.autoScroll = _this.autoScroll.bind((0, _assertThisInitialized2.default)(_this));
	    _this.min = 0;
	    _this.max = null;
	    _this.pressed = null;
	    _this.reference = null;
	    _this.offset = 0;
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaInertialScroller, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateMaxScroll();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var className = (0, _join.default)(props.rootClassName, props.className, "".concat(props.rootClassName, "--theme-").concat(props.theme));
	      var events;
	      if (_isMobile.default && this.props.enableTouchDrag) {
	        events = {
	          onTouchStart: this.tap,
	          onTouchEnd: this.release,
	          onTouchMove: this.drag
	        };
	      }
	      if (!_isMobile.default && props.enableMouseDrag) {
	        events = {
	          onMouseDown: this.tap,
	          onMouseUp: this.release,
	          onMouseMove: this.drag
	        };
	      }
	      return _react.default.createElement("div", _objectSpread(_objectSpread({}, (0, _cleanProps.default)(props, InovuaInertialScroller.propTypes)), {}, {
	        className: className,
	        ref: this.setRootRef
	      }, events), _react.default.createElement("div", {
	        ref: this.setViewRef,
	        className: "".concat(props.rootClassName, "__view")
	      }, props.children));
	    }
	  }, {
	    key: "tap",
	    value: function tap(event) {
	      this.pressed = true;
	      this.reference = ypos(event);
	      this.timeStamp = Date.now();
	      this.frame = this.offset;
	      this.velocity = 0;
	      this.amplitude = 0;
	      clearInterval(this.ticker);
	      this.ticker = setInterval(this.track, 16);
	      event.stopPropagation();
	      event.preventDefault();
	    }
	  }, {
	    key: "drag",
	    value: function drag(event) {
	      if (this.pressed) {
	        var y = ypos(event);
	        var delta = this.reference - y;
	        if (delta > this.props.threshold || delta < -this.props.threshold) {
	          this.reference = y;
	          this.scrollTo(this.offset + delta);
	        }
	      }
	    }
	  }, {
	    key: "release",
	    value: function release(event) {
	      this.pressed = false;
	      this.updateMaxScroll();
	      event.stopPropagation();
	      event.preventDefault();
	      clearInterval(this.ticker);
	      if (this.velocity > 10 || this.velocity < -10) {
	        this.amplitude = this.props.initialAmplitude * this.velocity;
	        this.target = Math.round(this.offset + this.amplitude);
	        this.timestamp = Date.now();
	        requestAnimationFrame(this.autoScroll);
	      }
	    }
	  }, {
	    key: "scrollTo",
	    value: function scrollTo(offset) {
	      if (!this.viewNode) {
	        return null;
	      }
	      this.offset = (0, _clamp.default)(offset, 0, this.max);
	      this.viewNode.style.transform = "translateY(".concat(-this.offset, "px)");
	    }
	  }, {
	    key: "autoScroll",
	    value: function autoScroll() {
	      var elapsed, delta;
	      var timeConstant = this.props.timeConstant;
	      if (this.amplitude) {
	        elapsed = Date.now() - this.timestamp;
	        delta = -this.amplitude * Math.exp(-elapsed / timeConstant);
	        if (delta > 0.1 || delta < -0.1) {
	          this.scrollTo(this.target + delta);
	          requestAnimationFrame(this.autoScroll);
	        } else {
	          this.scrollTo(this.target);
	        }
	      }
	    }
	  }, {
	    key: "updateMaxScroll",
	    value: function updateMaxScroll() {
	      this.max = this.viewNode && this.viewNode.offsetHeight - this.node.offsetHeight;
	    }
	  }, {
	    key: "track",
	    value: function track() {
	      var now, elapsed, delta, v;
	      now = Date.now();
	      elapsed = now - this.timeStamp;
	      this.timeStamp = now;
	      delta = this.offset - this.frame;
	      this.frame = this.offset;
	      v = 1000 * delta / (1 + elapsed);
	      this.velocity = 0.8 * v + 0.2 * this.velocity;
	    }
	  }]);
	  return InovuaInertialScroller;
	}(_react.Component);
	function emptyFn() {}
	InovuaInertialScroller.defaultProps = {
	  theme: 'default',
	  rootClassName: 'react-toolkit-inertial-scroller',
	  threshold: 5,
	  timeConstant: 360,
	  initialAmplitude: 0.5,
	  enableMouseDrag: true,
	  enableTouchDrag: true
	};
	InovuaInertialScroller.propTypes = {
	  theme: _propTypes.default.string,
	  rootClassName: _propTypes.default.string,
	  threshold: _propTypes.default.number,
	  timeConstant: _propTypes.default.number,
	  initialAmplitude: _propTypes.default.number,
	  enableMouseDrag: _propTypes.default.bool,
	  enableTouchDrag: _propTypes.default.bool
	};
	var _default = InovuaInertialScroller;
	exports.default = _default;

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "InertialManager", {
	  enumerable: true,
	  get: function get() {
	    return _InertialManager.default;
	  }
	});
	exports.default = void 0;
	var _InertialScroller = _interopRequireDefault(__webpack_require__(689));
	var _InertialManager = _interopRequireDefault(__webpack_require__(247));
	var _default = _InertialScroller.default;
	exports.default = _default;

/***/ },
/* 691 */
[1296, 694],
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _join = _interopRequireDefault(__webpack_require__(20));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var DEFAULT_CLASS_NAME = 'inovua-react-toolkit-load-mask__loader';
	var LOADBAR_CLASSNAME = "".concat(DEFAULT_CLASS_NAME, "-loadbar");
	var getMeasureName = function getMeasureName(duration) {
	  if (typeof duration == 'number' || duration * 1 == duration) {
	    return 's';
	  }
	  var measure;
	  duration.match(/[a-zA-Z]*$/, function (match) {
	    measure = match;
	  });
	  return measure || 's';
	};
	var InovuaSpinLoader = function (_React$Component) {
	  (0, _inherits2.default)(InovuaSpinLoader, _React$Component);
	  var _super = _createSuper(InovuaSpinLoader);
	  function InovuaSpinLoader() {
	    (0, _classCallCheck2.default)(this, InovuaSpinLoader);
	    return _super.apply(this, arguments);
	  }
	  (0, _createClass2.default)(InovuaSpinLoader, [{
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var style = _objectSpread(_objectSpread({}, props.style), {}, {
	        width: props.size,
	        height: props.size
	      });
	      var className = (0, _join.default)(props.className, DEFAULT_CLASS_NAME, "".concat(DEFAULT_CLASS_NAME, "--spin"), props.theme && "".concat(DEFAULT_CLASS_NAME, "--theme-").concat(props.theme));
	      var animationDuration = props.animationDuration;
	      var measureName = animationDuration ? getMeasureName(animationDuration) : '';
	      var bars = (0, _toConsumableArray2.default)(Array(12)).map(function (_, i) {
	        var index = i + 1;
	        return _react.default.createElement("div", {
	          key: index,
	          className: "".concat(LOADBAR_CLASSNAME, " ").concat(LOADBAR_CLASSNAME, "--").concat(index)
	        });
	      });
	      return _react.default.createElement("div", {
	        style: style,
	        className: className
	      }, bars);
	    }
	  }]);
	  return InovuaSpinLoader;
	}(_react.default.Component);
	InovuaSpinLoader.propTypes = {
	  size: _propTypes.default.number,
	  theme: _propTypes.default.string,
	  animationDuration: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
	};
	InovuaSpinLoader.defaultProps = {
	  size: 40
	};
	var _default = InovuaSpinLoader;
	exports.default = _default;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _join = _interopRequireDefault(__webpack_require__(20));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var DEFAULT_CLASS_NAME = 'inovua-react-toolkit-load-mask__loader';
	var InovuaSvgLoader = function (_React$Component) {
	  (0, _inherits2.default)(InovuaSvgLoader, _React$Component);
	  var _super = _createSuper(InovuaSvgLoader);
	  function InovuaSvgLoader() {
	    (0, _classCallCheck2.default)(this, InovuaSvgLoader);
	    return _super.apply(this, arguments);
	  }
	  (0, _createClass2.default)(InovuaSvgLoader, [{
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var style = _objectSpread(_objectSpread({}, props.style), {}, {
	        width: props.size,
	        height: props.size
	      });
	      if (props.animationDuration) {
	        style.animationDuration = props.animationDuration;
	      }
	      var className = (0, _join.default)(props.className, DEFAULT_CLASS_NAME, "".concat(DEFAULT_CLASS_NAME, "--svg"), props.theme && "".concat(DEFAULT_CLASS_NAME, "--theme-").concat(props.theme));
	      return _react.default.createElement("div", {
	        style: style,
	        className: className
	      }, _react.default.createElement("svg", {
	        className: "".concat(DEFAULT_CLASS_NAME, "-spinner"),
	        width: props.size,
	        height: props.size,
	        viewBox: "0 0 32 32"
	      }, _react.default.createElement("path", {
	        fillRule: "evenodd",
	        d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-4c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12z"
	      })));
	    }
	  }]);
	  return InovuaSvgLoader;
	}(_react.default.Component);
	exports.default = InovuaSvgLoader;
	InovuaSvgLoader.propTypes = {
	  size: _propTypes.default.number,
	  theme: _propTypes.default.string,
	  animationDuration: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
	};
	InovuaSvgLoader.defaultProps = {
	  size: 40
	};

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _SvgLoader = _interopRequireDefault(__webpack_require__(693));
	var _SpinLoader = _interopRequireDefault(__webpack_require__(692));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var DEFAULT_CLASS_NAME = 'inovua-react-toolkit-load-mask';
	var InovuaLoadMask = (0, _react.forwardRef)(function (props, ref) {
	  var visibleClassName = props.visible ? "".concat(props.rootClassName, "--visible") : '';
	  var className = (0, _join.default)(props.className, props.rootClassName, visibleClassName, props.theme && "".concat(props.rootClassName, "--theme-").concat(props.theme));
	  var layerClassName = (0, _join.default)(props.backgroundLayerClassName, "".concat(props.rootClassName, "__background-layer"));
	  var style = _objectSpread({}, props.style);
	  var layerStyle = _objectSpread({}, props.backgroundLayerStyle);
	  if (props.zIndex != null) {
	    style.zIndex = props.zIndex;
	  }
	  if (props.background !== true) {
	    layerStyle.background = props.background === false ? 'transparent' : props.background;
	  }
	  if (props.backgroundOpacity != null) {
	    layerStyle.opacity = props.backgroundOpacity;
	  }
	  var pointerEvents = props.pointerEvents;
	  if (pointerEvents !== true) {
	    style.pointerEvents = pointerEvents === false ? 'none' : pointerEvents;
	  }
	  var Loader = props.svgLoader ? _SvgLoader.default : _SpinLoader.default;
	  return _react.default.createElement("div", _objectSpread(_objectSpread({
	    ref: ref
	  }, (0, _cleanProps.default)(props, InovuaLoadMask.propTypes)), {}, {
	    className: className,
	    style: style
	  }), _react.default.createElement("div", {
	    style: layerStyle,
	    className: layerClassName
	  }), _react.default.createElement("div", {
	    className: "".concat(props.rootClassName, "__loader-container")
	  }, _react.default.createElement(Loader, {
	    size: props.size,
	    theme: props.theme,
	    animationDuration: props.animationDuration
	  }), props.children));
	});
	InovuaLoadMask.defaultProps = {
	  visible: true,
	  svgLoader: true,
	  theme: 'default-light',
	  zIndex: 100,
	  pointerEvents: true,
	  backgroundOpacity: 0.6,
	  background: true,
	  backgroundLayerStyle: {},
	  rootClassName: DEFAULT_CLASS_NAME
	};
	InovuaLoadMask.propTypes = {
	  animationDuration: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  svgLoader: _propTypes.default.bool,
	  zIndex: _propTypes.default.number,
	  visible: _propTypes.default.bool,
	  pointerEvents: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
	  backgroundOpacity: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  background: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
	  theme: _propTypes.default.string,
	  backgroundLayerClassName: _propTypes.default.string,
	  backgroundLayerStyle: _propTypes.default.object,
	  rootClassName: _propTypes.default.string
	};
	var _default = InovuaLoadMask;
	exports.default = _default;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var Expander = function Expander(_ref) {
	  var className = _ref.className,
	    rootClassName = _ref.rootClassName,
	    _ref$size = _ref.size,
	    size = _ref$size === void 0 ? 20 : _ref$size,
	    onClick = _ref.onClick,
	    fill = _ref.fill,
	    rtl = _ref.rtl;
	  return _react.default.createElement("div", {
	    className: "".concat(rootClassName, "__expander-wrapper")
	  }, _react.default.createElement("div", {
	    className: "".concat(rootClassName, "__expander-icon")
	  }, _react.default.createElement("svg", {
	    className: (0, _join.default)(className, "".concat(rootClassName, "__expander")),
	    onClick: onClick,
	    fill: fill,
	    height: size,
	    width: size / 2,
	    viewBox: "0 0 5 10"
	  }, rtl ? _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M.262 4.738L4.368.632c.144-.144.379-.144.524 0C4.96.702 5 .796 5 .894v8.212c0 .204-.166.37-.37.37-.099 0-.193-.039-.262-.108L.262 5.262c-.145-.145-.145-.38 0-.524z"
	  }) : _react.default.createElement("path", {
	    fillRule: "evenodd",
	    d: "M4.738 5.262L.632 9.368c-.144.144-.379.144-.524 0C.04 9.298 0 9.204 0 9.106V.894C0 .69.166.524.37.524c.099 0 .193.039.262.108l4.106 4.106c.145.145.145.38 0 .524z"
	  }))));
	};
	Expander.isExpander = true;
	var _default = Expander;
	exports.default = _default;

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _reactClass = _interopRequireDefault(__webpack_require__(30));
	var _regionAlign = _interopRequireDefault(__webpack_require__(55));
	var _uglified = _interopRequireDefault(__webpack_require__(57));
	var _shallowequal = _interopRequireDefault(__webpack_require__(217));
	var _ArrowScroller = _interopRequireDefault(__webpack_require__(227));
	var _MenuItem = _interopRequireDefault(__webpack_require__(248));
	var _MenuSeparator = _interopRequireDefault(__webpack_require__(249));
	var _containsNode = _interopRequireDefault(__webpack_require__(71));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _getConstrainRegion = _interopRequireDefault(__webpack_require__(213));
	var _isMobile = _interopRequireDefault(__webpack_require__(72));
	var _prepareStyle = _interopRequireDefault(__webpack_require__(708));
	var _getFirstNonDisabledItem = _interopRequireDefault(__webpack_require__(702));
	var _getNextNavigableItem = _interopRequireDefault(__webpack_require__(704));
	var _getSeparatorIndexes = _interopRequireDefault(__webpack_require__(705));
	var _prepareAlignOffset = _interopRequireDefault(__webpack_require__(251));
	var _getSingleSelectNames = _interopRequireDefault(__webpack_require__(706));
	var _increaseColSpan = __webpack_require__(707);
	var _getRegionRelativeToParent = _interopRequireDefault(__webpack_require__(250));
	var _shouldComponentUpdate2 = _interopRequireDefault(__webpack_require__(218));
	var _getSubMenuStyle = _interopRequireDefault(__webpack_require__(699));
	var _getItemStyleProps = _interopRequireDefault(__webpack_require__(703));
	var _submenuAlignPositions = __webpack_require__(701);
	var _ua = __webpack_require__(103);
	var _getGlobal = __webpack_require__(18);
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	function emptyFn() {}
	var raf = globalObject.requestAnimationFrame;
	var getAlignToRegion = function getAlignToRegion(alignTo, node) {
	  if (typeof alignTo === 'function') {
	    alignTo = alignTo(node);
	  }
	  if (typeof alignTo == 'string') {
	    alignTo = globalObject.document ? globalObject.document.querySelector(alignTo) : alignTo;
	  }
	  return _regionAlign.default.from(alignTo);
	};
	var InovuaMenu = function (_Component) {
	  (0, _inherits2.default)(InovuaMenu, _Component);
	  var _super = _createSuper(InovuaMenu);
	  function InovuaMenu(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaMenu);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updatePosition", function () {
	      _this.checkAlignment(undefined, true);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateAlignment", function (alignTo) {
	      _this.checkAlignment(undefined, true, alignTo);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDocumentScroll", function () {
	      if (_this.props.updatePositionOnScroll) {
	        _this.updatePosition();
	      }
	    });
	    _this.state = {
	      mouseOver: false,
	      hidden: true,
	      enableAnimation: false,
	      transitionEnded: false,
	      hasScroll: false,
	      activeSubMenuIndex: null,
	      nextActiveSubMenuIndex: null,
	      showUpArrow: false,
	      showDownArrow: true,
	      focusedItem: props.enableKeyboardNavigation ? props.defaultFocusedItem : null,
	      selected: props.defaultSelected
	    };
	    _this.setupShowHideDelay();
	    _this.setRootRef = function (ref) {
	      _this.node = ref;
	    };
	    _this.setItemRef = function (index) {
	      return function (ref) {
	        if (!_this.childrenRefs) {
	          _this.childrenRefs = [];
	        }
	        _this.childrenRefs[index] = ref;
	      };
	    };
	    _this.setSubMenuRef = function (ref) {
	      _this.subMenu = ref;
	    };
	    _this.setSubMenuWrapRef = function (ref) {
	      _this.subMenuWrap = ref;
	    };
	    _this.setScrollerRef = function (ref) {
	      _this.scroller = ref;
	    };
	    _this.setTableRef = function (ref) {
	      _this.table = ref;
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaMenu, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _shouldComponentUpdate2.default)(this, nextProps, nextProps);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.componentIsMounted = false;
	      this.chidrenRefs = null;
	      this.props.componentWillUnmount(this, {
	        hasFocus: this.hasFocus(),
	        depth: this.props.depth
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (this.props.autoFocus && prevState.hidden && !this.state.hidden) {
	        this.focus();
	      }
	      if (prevProps.visible && !this.props.visible) {
	        this.setState({
	          positionStyle: null
	        });
	      }
	      if (!prevProps.visible && this.props.visible || !(0, _shallowequal.default)(prevProps.alignTo, this.props.alignTo) || this.props.constrainTo != prevProps.constrainTo) {
	        this.checkAlignment(this.props, true);
	      }
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	      this.componentIsMounted = true;
	      if (this.props.visible === false) {
	        return;
	      }
	      if (this.props.componentDidMount) {
	        this.props.componentDidMount(this);
	      }
	      this.checkAlignment();
	      this.setupEnterAnimation();
	      if (this.props.autoFocus) {
	        requestAnimationFrame(function () {
	          _this2.focus();
	        });
	      }
	      if (this.props.updatePositionOnScroll) {
	        window.addEventListener('scroll', this.handleDocumentScroll, {
	          passive: true
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var state = this.state,
	        props = this.props;
	      var style = (0, _prepareStyle.default)(props, state);
	      var className = this.prepareClassName(props, state);
	      var table = this.renderTable();
	      var scrollerArrow = props.showScrollArrows === undefined ? 'auto' : !!props.showScrollArrows;
	      return _react.default.createElement("div", _objectSpread(_objectSpread({
	        tabIndex: 0
	      }, (0, _cleanProps.default)(props, InovuaMenu.propTypes)), {}, {
	        ref: this.setRootRef,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onKeyDown: this.handleKeyDown,
	        onBlur: this.handleOnBlur,
	        className: className,
	        style: style
	      }), this.state.activeSubMenuIndex !== null && this.renderSubMenu(props, state), props.disableScroller ? table : _react.default.createElement(_ArrowScroller.default, _objectSpread({
	        scroller: scrollerArrow
	      }, this.getScrollerProps()), table));
	    }
	  }, {
	    key: "renderTable",
	    value: function renderTable() {
	      var props = this.props,
	        state = this.state;
	      var className = (0, _join.default)("".concat(props.rootClassName, "__table"), props.tableClassName);
	      return _react.default.createElement("table", {
	        cellSpacing: 0,
	        cellPadding: 0,
	        className: className,
	        ref: this.setTableRef
	      }, _react.default.createElement("tbody", null, this.renderItems()));
	    }
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var _this3 = this;
	      var props = this.props,
	        state = this.state;
	      if (!props.items) {
	        return null;
	      }
	      var commonProps = this.getCommonItemProps();
	      var siblingItemHasSubMenu = this.doesAnyItemHasSubMenu();
	      var siblingItemHasSelectInput = this.dosAnyItemHaveSelectInput();
	      var hasDescription = props.items.filter(function (item) {
	        return !!item.secondaryLabel;
	      }).length;
	      var hasIcon = props.items.filter(function (item) {
	        return !!item.icon;
	      }).length;
	      return props.items.map(function (item, index, items) {
	        if (item === '-') {
	          return _react.default.createElement(_MenuSeparator.default, {
	            style: props.menuSeparatorStyle,
	            key: index,
	            rootClassName: props.rootClassName
	          });
	        }
	        var columns = props.columns;
	        if (hasDescription) {
	          columns = [].concat((0, _toConsumableArray2.default)(columns), [{
	            name: 'secondaryLabel',
	            isDescription: true,
	            style: _objectSpread(_objectSpread({}, props.secondaryLabelStyle), item.secondaryLabelStyle)
	          }]);
	        }
	        if (hasIcon) {
	          columns = [{
	            name: 'icon',
	            isIcon: true
	          }].concat((0, _toConsumableArray2.default)(columns));
	        }
	        if (props.labelStyle || item.labelStyle) {
	          columns = columns.map(function (column) {
	            if (!column) {
	              return column;
	            }
	            if (typeof column === 'string' && column === 'label') {
	              return {
	                name: 'label',
	                style: _objectSpread(_objectSpread({}, props.labelStyle), item.labelStyle)
	              };
	            }
	            if (column && column.name && column.name === 'label') {
	              return _objectSpread(_objectSpread({}, column), {}, {
	                style: _objectSpread(_objectSpread({}, columns.style), props.labelStyle)
	              });
	            }
	            return column;
	          });
	        }
	        var hasSubMenu = item.items && !!item.items.length || item.children && !!item.children.length;
	        var focused = state.focusedItem === index;
	        var expanded = commonProps.expandedIndex === index;
	        var className = props.itemClassName;
	        var selectionProps = _this3.getSelectionProps(item);
	        if (props.enableSelection && siblingItemHasSelectInput && !selectionProps) {
	          if (props.selectionInputPosition === 'start') {
	            columns = (0, _increaseColSpan.increaseFirstColumnColSpan)(columns);
	          } else {
	            columns = (0, _increaseColSpan.increaseLastColumnColSpan)(columns);
	          }
	        }
	        if (!hasSubMenu && siblingItemHasSubMenu) {
	          columns = (0, _increaseColSpan.increaseLastColumnColSpan)(columns);
	        }
	        var itemProps = _objectSpread(_objectSpread(_objectSpread({
	          index: index,
	          item: item,
	          hasSubMenu: hasSubMenu,
	          items: items,
	          focused: focused,
	          expanded: expanded,
	          className: className,
	          columns: columns,
	          key: index,
	          disabled: item.disabled,
	          theme: props.theme,
	          ref: _this3.setItemRef(index)
	        }, commonProps), selectionProps), item.props);
	        var Component = props.itemFactory || _MenuItem.default;
	        return _react.default.createElement(Component, _objectSpread({}, itemProps));
	      });
	    }
	  }, {
	    key: "getSelectionProps",
	    value: function getSelectionProps(item) {
	      var props = this.props;
	      if (!props.items || props.items && !props.items.length) {
	        return null;
	      }
	      var selected = this.getSelected();
	      var singleSelectNames = (0, _getSingleSelectNames.default)({
	        items: props.items,
	        nameProperty: props.nameProperty
	      });
	      var selectionProps;
	      if (props.enableSelection) {
	        var value = item[props.valueProperty];
	        var name = item[props.nameProperty];
	        var multiple = singleSelectNames && !singleSelectNames[name];
	        var checked = multiple ? value !== undefined ? selected[name] === value : selected[name] === name : selected[name] === value;
	        if (name) {
	          selectionProps = {
	            name: name,
	            value: value,
	            checked: checked,
	            multiple: multiple,
	            allowUnselect: props.allowUnselect,
	            enableSelection: true,
	            browserNativeSelectInputs: props.browserNativeSelectInputs,
	            renderCheckInput: item.renderCheckInput !== undefined ? item.renderCheckInput : props.renderCheckInput,
	            renderRadioInput: item.renderRadioInput !== undefined ? item.renderRadioInput : props.renderRadioInput,
	            selectionInputPosition: item.selectionInputPosition !== undefined ? item.selectionInputPosition : props.selectionInputPosition
	          };
	        }
	      }
	      return selectionProps;
	    }
	  }, {
	    key: "getCommonItemProps",
	    value: function getCommonItemProps() {
	      var _objectSpread2;
	      var props = this.props;
	      var menuHasSubmenu = !!props.items.filter(function (item) {
	        return item.items && item.items.length;
	      }).length;
	      var itemStyleProps = (0, _getItemStyleProps.default)(props);
	      return _objectSpread((_objectSpread2 = {
	        menuHasSubmenu: menuHasSubmenu,
	        expanderStyle: props.expanderStyle,
	        expanderSize: props.expanderSize,
	        globalCellStyle: props.cellStyle,
	        itemDisabledStyle: props.itemDisabledStyle,
	        itemDisabledClassName: props.itemDisabledClassName,
	        itemOverStyle: props.itemOverStyle,
	        itemActiveStyle: props.itemActiveStyle
	      }, (0, _defineProperty2.default)(_objectSpread2, "menuHasSubmenu", props.menuHasSubmenu), (0, _defineProperty2.default)(_objectSpread2, "rootClassName", props.rootClassName), (0, _defineProperty2.default)(_objectSpread2, "showWarnings", props.showWarnings), (0, _defineProperty2.default)(_objectSpread2, "titleStyle", props.titleStyle), (0, _defineProperty2.default)(_objectSpread2, "onClick", this.onMenuItemClick), (0, _defineProperty2.default)(_objectSpread2, "onMouseOver", this.onMenuItemMouseEnter), (0, _defineProperty2.default)(_objectSpread2, "onMouseOut", this.onMenuItemMouseLeave), (0, _defineProperty2.default)(_objectSpread2, "submenuWillUnmount", this.onSubmenuWillUnmount), (0, _defineProperty2.default)(_objectSpread2, "onExpanderClick", this.onMenuItemExpanderClick), (0, _defineProperty2.default)(_objectSpread2, "onSelectChange", this.handleSelectionChange), (0, _defineProperty2.default)(_objectSpread2, "selectOnClick", props.selectOnClick), (0, _defineProperty2.default)(_objectSpread2, "expander", props.expander), (0, _defineProperty2.default)(_objectSpread2, "rtl", props.rtl), (0, _defineProperty2.default)(_objectSpread2, "height", props.itemHeight), (0, _defineProperty2.default)(_objectSpread2, "checkIconSize", props.checkIconSize), (0, _defineProperty2.default)(_objectSpread2, "radioIconSize", props.radioIconSize), (0, _defineProperty2.default)(_objectSpread2, "closeSubmenuRecursively", this.closeSubmenuRecursively), (0, _defineProperty2.default)(_objectSpread2, "closeSubMenu", this.closeSubMenu), (0, _defineProperty2.default)(_objectSpread2, "expandedIndex", this.getExpandedIndex()), _objectSpread2), itemStyleProps);
	    }
	  }, {
	    key: "renderSubMenu",
	    value: function renderSubMenu(props, state) {
	      var domNode = this.node;
	      var menuProps = this.getSubMenuProps();
	      var wrapperStyle = _getSubMenuStyle.default.bind(this)(_objectSpread(_objectSpread({}, props), {}, {
	        alignPositions: this.getDefaultAlignPositions()
	      }), state, domNode);
	      var wrapperClassName = "".concat(this.props.rootClassName, "__submenu-wrapper");
	      return _react.default.createElement("div", {
	        className: wrapperClassName,
	        ref: this.setSubMenuWrapRef,
	        style: wrapperStyle,
	        onMouseEnter: this.handleSubMenuMouseEnter,
	        onMouseLeave: this.handleSubMenuMouseLeave
	      }, _react.default.createElement(InovuaMenu, _objectSpread({
	        key: state.activeSubMenuIndex
	      }, menuProps)));
	    }
	  }, {
	    key: "hasItemSubMenu",
	    value: function hasItemSubMenu(index) {
	      var items = this.getItemsByIndex(index);
	      return items && items.length;
	    }
	  }, {
	    key: "getItemsByIndex",
	    value: function getItemsByIndex(index) {
	      var item = this.props.items && this.props.items[index];
	      if (!item) {
	        return null;
	      }
	      var items = item && item.items;
	      return items;
	    }
	  }, {
	    key: "getSubMenuProps",
	    value: function getSubMenuProps() {
	      var props = this.props,
	        state = this.state;
	      var index = this.state.activeSubMenuIndex;
	      var items = this.getItemsByIndex(index);
	      var item = this.props.items[index];
	      var overridingProps = _objectSpread(_objectSpread({}, this.props.submenuProps), item.menuProps);
	      if (overridingProps.selected === undefined && overridingProps.defaultSelected === undefined) {
	        overridingProps.selected = this.getSelected();
	      }
	      var menuProps = _objectSpread(_objectSpread(_objectSpread({}, this.props), {}, {
	        onDismiss: emptyFn
	      }, overridingProps), {}, {
	        items: items,
	        depth: props.depth + 1,
	        ref: this.setSubMenuRef,
	        subMenu: true,
	        parentMenu: this,
	        closeSubMenu: this.closeSubMenu,
	        closeSubmenuRecursively: this.closeSubmenuRecursively,
	        componentWillUnmount: this.submenuWillUnmount,
	        parentIndex: index,
	        maxHeight: state.submenuMaxHeight || props.submenuMaxHeight || state.maxHeight || props.maxHeight,
	        onActivate: this.onSubMenuActivate,
	        onInactivate: this.onSubMenuInactivate,
	        scrollerProps: props.scrollerProps,
	        constrainTo: props.constrainTo,
	        expander: props.expander,
	        onSelectionChange: this.handleSubmenuSelectionChange,
	        alignPosition: state.submenuAlignPosition
	      });
	      delete menuProps.autoFocus;
	      delete menuProps.className;
	      delete menuProps.onClick;
	      delete menuProps.defaultFocusedItem;
	      delete menuProps.onChildClick;
	      delete menuProps.visible;
	      return menuProps;
	    }
	  }, {
	    key: "getAlignPositions",
	    value: function getAlignPositions(props) {
	      if (props.alignPositions == null) {
	        return this.getDefaultAlignPositions();
	      }
	      return props.alignPositions;
	    }
	  }, {
	    key: "getDefaultAlignPositions",
	    value: function getDefaultAlignPositions() {
	      var props = this.props;
	      return props.rtl ? _submenuAlignPositions.alignPositionRTL : _submenuAlignPositions.alignPositionLTR;
	    }
	  }, {
	    key: "getScrollerProps",
	    value: function getScrollerProps() {
	      var _this4 = this,
	        _objectSpread3;
	      var props = this.props,
	        state = this.state;
	      var className = (0, _join.default)(props.scrollerProps.className, "".concat(props.rootClassName, "__scroll-container"));
	      var style = (0, _assign.default)({}, props.scrollerProps.style);
	      var maxHeight = state.maxHeight != undefined && props.submenu ? state.maxHeight : props.maxHeight;
	      if (maxHeight != null) {
	        (0, _assign.default)(style, {
	          maxHeight: maxHeight
	        });
	      }
	      var scrollProps = _objectSpread(_objectSpread({}, props.scrollerProps), {}, (_objectSpread3 = {
	        renderScroller: props.renderScroller,
	        nativeScroll: props.nativeScroll,
	        scrollContainerProps: props.scrollContainerProps,
	        className: className,
	        notifyResizeDelay: props.notifyResizeDelay,
	        ref: this.setScrollerRef,
	        style: style,
	        theme: props.theme,
	        vertical: true
	      }, (0, _defineProperty2.default)(_objectSpread3, "theme", props.theme), (0, _defineProperty2.default)(_objectSpread3, "scrollOnMouseEnter", props.scrollOnMouseEnter), (0, _defineProperty2.default)(_objectSpread3, "onHasScrollChange", function onHasScrollChange(hasScroll) {
	        return _this4.setState({
	          hasScroll: hasScroll
	        });
	      }), _objectSpread3));
	      return scrollProps;
	    }
	  }, {
	    key: "prepareClassName",
	    value: function prepareClassName(props, state) {
	      var hidden = props.visible != undefined ? !props.visible : state.hidden;
	      var className = (0, _join.default)(props.rootClassName, props.theme && "".concat(props.rootClassName, "--theme-").concat(props.theme), props.className, !props.visible || props.items && !props.items.length && "".concat(props.rootClassName, "--no-display"), props.absolute && "".concat(props.rootClassName, "--absolute"), !props.rtl ? "".concat(props.rootClassName, "--ltr") : "".concat(props.rootClassName, "--rtl"), hidden && "".concat(props.rootClassName, "--hidden"), _isMobile.default && "".concat(props.rootClassName, "--mobile"), props.subMenu && "".concat(props.rootClassName, "__submenu"), "".concat(props.rootClassName, "--depth-").concat(props.depth), state.hasScroll && "".concat(props.rootClassName, "--has-overflow"), props.shadow && "".concat(props.rootClassName, "--shadow"), state.hasScroll && "".concat(props.rootClassName, "--has-scroll"));
	      if (props.alignPosition !== undefined) {
	        var position = props.alignPosition === 1 ? 'up' : 'down';
	        className = (0, _join.default)(className, "".concat(props.rootClassName, "--position-").concat(position));
	      }
	      if (state.enableAnimation) {
	        className = (0, _join.default)(className, "".concat(props.rootClassName, "--animation-enabled"), state.transitionEnded && "".concat(props.rootClassName, "--transition-end"), state.transitionStart && "".concat(props.rootClassName, "--transition-start"));
	      }
	      return className;
	    }
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(event) {
	      if (typeof this.props.onMouseEnter === 'function') {
	        this.props.onMouseEnter(event);
	      }
	      this.setState({
	        mouseInside: true
	      });
	      this.onActivate();
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(event) {
	      if (typeof this.props.onMouseLeave === 'function') {
	        this.props.onMouseLeave(event);
	      }
	      this.setNextSubmenu();
	      this.setState({
	        mouseInside: false
	      });
	      if (!this.state.activeSubMenuIndex && !this.state.nextActiveSubMenuIndex) {
	        this.onInactivate({
	          hasFocus: this.hasFocus(),
	          parentIndex: this.props.parentIndex
	        });
	      }
	    }
	  }, {
	    key: "handleKeyDown",
	    value: function handleKeyDown(event) {
	      if (typeof this.props.onKeyDown === 'function') {
	        this.props.onKeyDown(event);
	      }
	      if (!this.props.enableKeyboardNavigation) {
	        return;
	      }
	      var stop = function stop(event) {
	        event.stopPropagation();
	      };
	      stop(event);
	      switch (event.key) {
	        case 'ArrowUp':
	          this.handleArrowUp(event);
	          break;
	        case 'ArrowDown':
	          this.handleArrowDown(event);
	          break;
	        case 'ArrowLeft':
	          this.handleArrowLeft(event);
	          break;
	        case 'ArrowRight':
	          this.handleArrowRight(event);
	          break;
	        case 'Enter':
	          this.handleEnterOnFocusedItem(event);
	          break;
	        case 'Escape':
	          this.handleEscape(event);
	        case ' ':
	          this.handleSpaceOnFocusedItem(event);
	          break;
	      }
	    }
	  }, {
	    key: "handleEscape",
	    value: function handleEscape(event) {
	      if (this.props.dismissWithEscape) {
	        this.dismiss(event);
	      }
	    }
	  }, {
	    key: "handleArrowUp",
	    value: function handleArrowUp(event) {
	      var lastItemIndex = this.props.items && this.props.items.length ? this.props.items.length : null;
	      var props = this.props;
	      var focusedItemIndex = this.state.focusedItem != null ? this.state.focusedItem : lastItemIndex;
	      var newFocusedItemIndex = (0, _getNextNavigableItem.default)(props.items, focusedItemIndex, -1);
	      if (newFocusedItemIndex == null) {
	        return;
	      }
	      this.setFocusedIndex(newFocusedItemIndex);
	    }
	  }, {
	    key: "handleArrowDown",
	    value: function handleArrowDown(event) {
	      var props = this.props;
	      var focusedItemIndex = this.state.focusedItem != null ? this.state.focusedItem : -1;
	      var newFocusedItemIndex = (0, _getNextNavigableItem.default)(props.items, focusedItemIndex, 1);
	      if (newFocusedItemIndex == null) {
	        return;
	      }
	      this.setFocusedIndex(newFocusedItemIndex);
	    }
	  }, {
	    key: "handleArrowLeft",
	    value: function handleArrowLeft(event) {
	      if (this.props.rtl) {
	        this.openSubMenuAction(this.state.focusedItem);
	      } else {
	        this.closeSubMenuAction();
	      }
	    }
	  }, {
	    key: "handleArrowRight",
	    value: function handleArrowRight(event) {
	      if (this.props.rtl) {
	        this.closeSubMenuAction();
	      } else {
	        this.openSubMenuAction(this.state.focusedItem);
	      }
	    }
	  }, {
	    key: "handleEnterOnFocusedItem",
	    value: function handleEnterOnFocusedItem(event) {
	      var focusedItem = this.getFocusedItem();
	      if (this.props.simulateClickOnEnterKeyPress && focusedItem != null && typeof focusedItem.handleClick === 'function') {
	        focusedItem.handleClick({
	          stopPropagation: function stopPropagation() {}
	        });
	      }
	    }
	  }, {
	    key: "handleSpaceOnFocusedItem",
	    value: function handleSpaceOnFocusedItem() {
	      var activeItemProps = this.getFocusedItemProps();
	      if (!activeItemProps) {
	        return;
	      }
	      this.handleSelectionChange({
	        name: activeItemProps.name,
	        value: activeItemProps.value,
	        checked: !activeItemProps.checked,
	        multiple: activeItemProps.multiple
	      });
	    }
	  }, {
	    key: "handleOnBlur",
	    value: function handleOnBlur(event) {
	      var _this5 = this;
	      if (typeof this.props.onBlur === 'function') {
	        this.props.onBlur(event);
	      }
	      if (this.props.stopBlurPropagation) {
	        event.stopPropagation();
	      }
	      if (this.preventOnBlurRecursiveClose) {
	        return;
	      }
	      this.dismissTriggeredByBlur = true;
	      setTimeout(function () {
	        if (!_this5.hasGeneralFocus()) {
	          _this5.dismiss(event);
	        }
	      }, _ua.IS_IE ? this.props.hideSubMenuDelay : 20);
	    }
	  }, {
	    key: "dismiss",
	    value: function dismiss(event) {
	      this.closeSubmenuRecursively();
	      this.props.onDismiss(event);
	    }
	  }, {
	    key: "scrollItemIntoView",
	    value: function scrollItemIntoView(index) {
	      var itemNode = this.getItemDOMNodeByIndex(index);
	      if (!this.scroller || !itemNode) {
	        return;
	      }
	      this.scroller.scrollIntoView(itemNode);
	    }
	  }, {
	    key: "closeSubmenuRecursively",
	    value: function closeSubmenuRecursively() {
	      this.closeSubMenu();
	      this.props.closeSubmenuRecursively();
	    }
	  }, {
	    key: "closeSubMenuAction",
	    value: function closeSubMenuAction() {
	      if (this.hasSubMenuOpened()) {
	        this.closeSubMenu();
	      } else if (this.isSubMenu()) {
	        this.preventOnBlurRecursiveClose = true;
	        this.props.closeSubMenu({
	          autoFocus: true
	        });
	      }
	    }
	  }, {
	    key: "openSubMenuAction",
	    value: function openSubMenuAction(focusedItemIndex) {
	      var focusedItem = this.getItemByIndex(focusedItemIndex);
	      if (!focusedItem) {
	        return;
	      }
	      if (focusedItem && !focusedItem.hasSubmenu()) {
	        return;
	      }
	      if (focusedItemIndex === this.state.activeSubMenuIndex) {
	        this.subMenu && this.subMenu.focusFirstItem();
	        return;
	      }
	      var menuOffset = focusedItem && focusedItem.getOffset();
	      this.setSubMenu({
	        menuOffset: menuOffset,
	        index: focusedItemIndex
	      });
	    }
	  }, {
	    key: "onActivate",
	    value: function onActivate() {
	      if (!this.state.activated) {
	        this.setState({
	          activated: true
	        });
	        if (this.props.onActivate) {
	          this.props.onActivate();
	        }
	      }
	    }
	  }, {
	    key: "onInactivate",
	    value: function onInactivate(options) {
	      if (this.state.activated) {
	        this.setState({
	          activated: false
	        });
	        if (this.props.onInactivate) {
	          this.props.onInactivate(options);
	        }
	      }
	    }
	  }, {
	    key: "handleSubMenuMouseEnter",
	    value: function handleSubMenuMouseEnter() {
	      this.setState({
	        mouseOverSubMenu: true
	      });
	    }
	  }, {
	    key: "handleSubMenuMouseLeave",
	    value: function handleSubMenuMouseLeave() {
	      this.setState({
	        mouseOverSubMenu: false
	      });
	    }
	  }, {
	    key: "isSubMenuActive",
	    value: function isSubMenuActive() {
	      return this.state.subMenuActive;
	    }
	  }, {
	    key: "onSubMenuActivate",
	    value: function onSubMenuActivate() {
	      this.setState({
	        subMenuActive: true
	      });
	      if (this.closeSubmenuTimeout) {
	        clearTimeout(this.closeSubmenuTimeout);
	      }
	    }
	  }, {
	    key: "onSubMenuInactivate",
	    value: function onSubMenuInactivate(submenuConfig) {
	      var _this6 = this;
	      var ts = +new Date();
	      var nextItem = this.state.nextItem;
	      var nextTimestamp = this.state.nextTimestamp || 0;
	      this.setState({
	        subMenuActive: false,
	        timestamp: ts
	      }, function () {
	        setTimeout(function () {
	          if (ts != _this6.state.timestamp || nextItem && ts - nextTimestamp < 100) {
	            _this6.setSubMenu({
	              menuOffset: _this6.state.nextOffset,
	              index: _this6.state.nextActiveSubMenuIndex
	            }, function () {
	              _this6.focus();
	            });
	            return;
	          } else {
	            _this6.focus();
	          }
	          var mouseHasEnteredSubmenuParentItem = submenuConfig && submenuConfig.parentIndex === _this6.itemOverIndex;
	          if (!_this6.isSubMenuActive() && !mouseHasEnteredSubmenuParentItem) {
	            _this6.closeSubMenu({
	              autoFocus: submenuConfig && submenuConfig.hasFocus
	            });
	          }
	        }, 10);
	      });
	    }
	  }, {
	    key: "onMenuItemMouseEnter",
	    value: function onMenuItemMouseEnter(_ref) {
	      var menuOffset = _ref.menuOffset,
	        index = _ref.index,
	        hasSubMenu = _ref.hasSubMenu;
	      if (!this.componentIsMounted) {
	        return;
	      }
	      this.itemOverIndex = index;
	      if (!hasSubMenu) {
	        if (this.state.activeSubMenuIndex != null) {
	          this.setNextSubmenu({
	            menuOffset: null,
	            index: null
	          });
	        }
	        return;
	      }
	      if (this.state.activeSubMenuIndex == null) {
	        this.setSubMenu({
	          menuOffset: menuOffset,
	          index: index
	        });
	      } else {
	        this.setNextSubmenu({
	          menuOffset: menuOffset,
	          index: index
	        });
	      }
	    }
	  }, {
	    key: "onMenuItemMouseLeave",
	    value: function onMenuItemMouseLeave(_ref2) {
	      var leaveOffset = _ref2.leaveOffset,
	        index = _ref2.index,
	        event = _ref2.event;
	      if (this.itemOverIndex === index) {
	        this.itemOverIndex = null;
	      }
	      if (!leaveOffset) {
	        return;
	      }
	      var elementAtMousePosition = globalObject.document.elementFromPoint(leaveOffset.x, leaveOffset.y);
	      if (elementAtMousePosition === this.subMenuWrap || (0, _containsNode.default)(this.subMenuWrap, elementAtMousePosition)) {
	        return;
	      }
	      if (this.state.activeSubMenuIndex !== null) {
	        this.delayCloseSubmenu(leaveOffset);
	      }
	      if (this.showTimeout) {
	        clearTimeout(this.showTimeout);
	      }
	    }
	  }, {
	    key: "delayCloseSubmenu",
	    value: function delayCloseSubmenu() {
	      var _this7 = this;
	      if (!this.componentIsMounted) {
	        return;
	      }
	      if (this.closeSubmenuTimeoutId) {
	        return;
	      }
	      this.closeSubmenuTimeout = setTimeout(function () {
	        _this7.closeSubmenuTimeout = null;
	        _this7.setSubMenu({
	          menuOffset: _this7.state.nextOffset,
	          index: _this7.state.nextActiveSubMenuIndex
	        });
	      }, 100);
	    }
	  }, {
	    key: "removeMouseMoveListener",
	    value: function removeMouseMoveListener() {
	      if (this.onWindowMouseMove) {
	        globalObject.removeEventListener('mousemove', this.onWindowMouseMove);
	        this.onWindowMouseMove = null;
	      }
	    }
	  }, {
	    key: "setSubMenu",
	    value: function setSubMenu() {
	      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        menuOffset = _ref3.menuOffset,
	        _ref3$index = _ref3.index,
	        index = _ref3$index === void 0 ? null : _ref3$index;
	      var callback = arguments.length > 1 ? arguments[1] : undefined;
	      this.removeMouseMoveListener();
	      if (!this.componentIsMounted) {
	        return;
	      }
	      if (this.state.activeSubMenuIndex === index) {
	        if (callback) {
	          callback();
	        }
	        return;
	      }
	      if (this.hasItemSubMenu(index) && !this.state.mouseInside) {
	        this.onInactivate();
	      }
	      this.setState({
	        menuOffset: menuOffset,
	        activeSubMenuIndex: index,
	        nextOffset: null,
	        nextTimestamp: null,
	        timestamp: +new Date()
	      }, callback);
	    }
	  }, {
	    key: "setNextSubmenu",
	    value: function setNextSubmenu() {
	      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref4$menuOffset = _ref4.menuOffset,
	        menuOffset = _ref4$menuOffset === void 0 ? null : _ref4$menuOffset,
	        _ref4$index = _ref4.index,
	        index = _ref4$index === void 0 ? null : _ref4$index;
	      var ts = +new Date();
	      this.setState({
	        timestamp: ts,
	        nextOffset: menuOffset,
	        nextActiveSubMenuIndex: index,
	        nextTimestamp: +new Date()
	      });
	    }
	  }, {
	    key: "closeSubMenu",
	    value: function closeSubMenu(options) {
	      return;
	      this.setSubMenu();
	      if (options && options.autoFocus) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "onMenuItemExpanderClick",
	    value: function onMenuItemExpanderClick(event) {
	      event.nativeEvent.expanderClick = true;
	    }
	  }, {
	    key: "onMenuItemClick",
	    value: function onMenuItemClick() {
	      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var itemProps = arguments.length > 1 ? arguments[1] : undefined;
	      var index = arguments.length > 2 ? arguments[2] : undefined;
	      var props = this.props;
	      var stopped = event && event.isPropagationStopped ? event.isPropagationStopped() : false;
	      if (props.stopClickPropagation && event.stopPropagation) {
	        event.stopPropagation();
	      }
	      if (_isMobile.default && itemProps && event && event.nativeEvent && event.nativeEvent.expanderClick) {
	        var offset = {
	          x: event.pageX,
	          y: event.pageY
	        };
	        var menuOffset = (0, _getRegionRelativeToParent.default)(event.currentTarget, props.rootClassName);
	        this.onMenuItemMouseEnter({
	          hasSubMenu: itemProps.hasSubMenu,
	          menuOffset: menuOffset,
	          index: itemProps.index
	        });
	        return;
	      }
	      if (!stopped) {
	        props.onClick(event, itemProps, index);
	        if (_isMobile.default && props.onTouchStart) {
	          props.onTouchStart(event, itemProps, index);
	        }
	        var dismissOnClick = itemProps && itemProps.item && itemProps.item.dismissOnClick !== undefined ? itemProps.item.dismissOnClick : props.dismissOnClick;
	        if (props.autoDismiss) {
	          if (!itemProps.hasSubMenu) {
	            this.dismiss();
	          } else if (dismissOnClick) {
	            props.closeSubmenuRecursively();
	          }
	        } else if (dismissOnClick) {
	          props.closeSubmenuRecursively();
	        }
	        if (props.selectOnClick && itemProps.name !== undefined) {
	          this.handleSelectionChange({
	            name: itemProps.name,
	            value: itemProps.value,
	            checked: !itemProps.checked,
	            multiple: itemProps.multiple
	          });
	        }
	        this.onChildClick(event, itemProps);
	      }
	      if (!this.isSeparator(index)) {
	        this.setFocusedIndex(index);
	      }
	    }
	  }, {
	    key: "onChildClick",
	    value: function onChildClick(event, props) {
	      if (this.props.onChildClick) {
	        this.props.onChildClick(event, props);
	      }
	      if (this.props.parentMenu) {
	        this.props.parentMenu.onChildClick(event, props);
	      }
	    }
	  }, {
	    key: "setupShowHideDelay",
	    value: function setupShowHideDelay() {
	      var _this8 = this;
	      var setSubMenu = this.setSubMenu;
	      this.setSubMenu = function () {
	        var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	          menuOffset = _ref5.menuOffset,
	          index = _ref5.index;
	        var callback = arguments.length > 1 ? arguments[1] : undefined;
	        if (_this8.showTimeout) {
	          clearTimeout(_this8.showTimeout);
	        }
	        if (_this8.hideTimeout) {
	          clearTimeout(_this8.hideTimeout);
	        }
	        if (index != null) {
	          if (_this8.props.showSubMenuDelay) {
	            _this8.showTimeout = setTimeout(function () {
	              return setSubMenu({
	                menuOffset: menuOffset,
	                index: index
	              }, callback);
	            }, _this8.props.showSubMenuDelay);
	          } else {
	            setSubMenu({
	              menuOffset: menuOffset,
	              index: index
	            }, callback);
	          }
	        } else {
	          if (_this8.props.hideSubMenuDelay) {
	            _this8.hideTimeout = setTimeout(function () {
	              return setSubMenu({
	                menuOffset: menuOffset,
	                index: index
	              }, callback);
	            }, _this8.props.hideSubMenuDelay);
	          } else {
	            setSubMenu({
	              menuOffset: menuOffset,
	              index: index
	            }, callback);
	          }
	        }
	      };
	    }
	  }, {
	    key: "setupEnterAnimation",
	    value: function setupEnterAnimation() {
	      var _this9 = this;
	      setTimeout(function () {
	        var enableAnimation = _this9.props.enableAnimation && _this9.props.subMenu || _this9.props.enableRootAnimation && !_this9.props.subMenu;
	        if (_this9.componentIsMounted) {
	          _this9.setState({
	            hidden: false,
	            enableAnimation: enableAnimation
	          });
	        }
	        if (enableAnimation) {
	          setTimeout(function () {
	            if (_this9.componentIsMounted) {
	              _this9.setState({
	                transitionStart: true
	              });
	            }
	            setTimeout(function () {
	              if (_this9.componentIsMounted) {
	                _this9.setState({
	                  transitionEnded: true
	                });
	              }
	            }, 16);
	          }, 16);
	        }
	      }, 0);
	    }
	  }, {
	    key: "checkAlignment",
	    value: function checkAlignment(props, skipReset, alignTo) {
	      var _this10 = this;
	      props = props || this.props;
	      alignTo = alignTo || props.alignTo;
	      if (alignTo && alignTo instanceof HTMLElement && !(0, _containsNode.default)(document.body, alignTo)) {
	        return;
	      }
	      if (props.visible === false) {
	        return;
	      }
	      if ((props.constrainTo || alignTo) && !props.subMenu) {
	        var doAlign = function doAlign() {
	          var props = _this10.props;
	          var alignPositions = _this10.getAlignPositions(props);
	          var domNode = _this10.node;
	          if (!domNode) {
	            return;
	          }
	          domNode.style.visibility = '';
	          var alignOffset = (0, _prepareAlignOffset.default)(props.alignOffset);
	          var domRegion = _regionAlign.default.from(domNode);
	          var actualRegion = domRegion.clone();
	          var constrainRegion = props.constrainTo ? (0, _getConstrainRegion.default)(props.constrainTo, domNode) : null;
	          var positionStyle;
	          if (alignTo) {
	            var alignRegion = getAlignToRegion(alignTo, domNode);
	            actualRegion.alignTo(alignRegion, alignPositions, {
	              offset: alignOffset,
	              constrain: constrainRegion
	            });
	            var offsetParent = domNode.offsetParent;
	            if (_ua.IS_FF && offsetParent === document.body && getComputedStyle(domNode).position === 'fixed') {
	              offsetParent = null;
	            }
	            var offsetParentRect = offsetParent ? null : domNode.getBoundingClientRect();
	            var offsetParentRegion = _regionAlign.default.from(offsetParent || {
	              top: offsetParentRect.top,
	              left: offsetParentRect.left
	            });
	            var newTop = actualRegion.top - offsetParentRegion.top;
	            var newLeft = actualRegion.left - offsetParentRegion.left;
	            var transform = "translate3d(".concat(Math.floor(newLeft), "px, ").concat(Math.floor(newTop), "px, 0px)");
	            positionStyle = {
	              transform: transform,
	              top: 0,
	              left: 0
	            };
	          }
	          if (constrainRegion) {
	            positionStyle = positionStyle || {};
	            if (actualRegion.bottom >= constrainRegion.bottom) {
	              positionStyle.maxHeight = constrainRegion.bottom - actualRegion.top;
	            }
	          }
	          if (positionStyle) {
	            _this10.setState({
	              positionStyle: positionStyle
	            });
	          }
	        };
	        if (!skipReset) {
	          this.node.style.transform = 'translate3d(0px, 0px, 0px)';
	          this.node.style.visibility = 'hidden';
	          this.node.style.top = '0px';
	          this.node.style.left = '0px';
	        }
	        raf(doAlign);
	      }
	    }
	  }, {
	    key: "setFocusedIndex",
	    value: function setFocusedIndex(newFocusedItem) {
	      if (this.props.enableKeyboardNavigation) {
	        var focusedItem = this.state.focusedItem;
	        if (focusedItem === newFocusedItem) {
	          newFocusedItem = null;
	        }
	        this.scrollItemIntoView(newFocusedItem);
	        this.setState({
	          focusedItem: newFocusedItem
	        });
	      }
	    }
	  }, {
	    key: "getItemDOMNodeByIndex",
	    value: function getItemDOMNodeByIndex(index) {
	      var item = this.getItemByIndex(index);
	      var itemNode = item && item.getDOMNode();
	      return itemNode;
	    }
	  }, {
	    key: "getItemByIndex",
	    value: function getItemByIndex(index) {
	      return this.childrenRefs[index];
	    }
	  }, {
	    key: "getItemPropsByIndex",
	    value: function getItemPropsByIndex(index) {
	      var item = this.getItemByIndex(index);
	      return item && item.props;
	    }
	  }, {
	    key: "getFocusedItemProps",
	    value: function getFocusedItemProps() {
	      var focusedItemIndex = this.state.focusedItem;
	      var focusedItemProps = this.getItemPropsByIndex(focusedItemIndex);
	      return focusedItemProps;
	    }
	  }, {
	    key: "getFocusedItem",
	    value: function getFocusedItem() {
	      return this.state.focusedItem != null && this.getItemByIndex(this.state.focusedItem);
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      if (!this.node) {
	        return;
	      }
	      if (this.node.focus) {
	        this.node.focus();
	      }
	    }
	  }, {
	    key: "hasSubMenuOpened",
	    value: function hasSubMenuOpened() {
	      return this.state.activeSubMenuIndex != null;
	    }
	  }, {
	    key: "isSubMenu",
	    value: function isSubMenu() {
	      return !!this.props.subMenu;
	    }
	  }, {
	    key: "doesAnyItemHasSubMenu",
	    value: function doesAnyItemHasSubMenu() {
	      var props = this.props;
	      return props.items && !!props.items.filter(function (item) {
	        return item.items && item.items.length;
	      }).length;
	    }
	  }, {
	    key: "dosAnyItemHaveSelectInput",
	    value: function dosAnyItemHaveSelectInput() {
	      var _this11 = this;
	      var props = this.props;
	      return props.items && !!props.items.filter(function (item) {
	        return item[_this11.props.nameProperty];
	      }).length;
	    }
	  }, {
	    key: "hasGeneralFocus",
	    value: function hasGeneralFocus() {
	      var hasFocus = this.hasFocus();
	      if (hasFocus) {
	        return hasFocus;
	      }
	      if (this.hasSubMenuOpened()) {
	        return this.hasSubMenuFocus();
	      }
	      return this.hasChildFocus();
	    }
	  }, {
	    key: "hasSubMenuFocus",
	    value: function hasSubMenuFocus() {
	      if (this.subMenu) {
	        return this.subMenu.hasFocus();
	      }
	      return null;
	    }
	  }, {
	    key: "hasFocus",
	    value: function hasFocus() {
	      return globalObject.document ? this.node === globalObject.document.activeElement : false;
	    }
	  }, {
	    key: "hasChildFocus",
	    value: function hasChildFocus() {
	      if (!globalObject.document) {
	        return false;
	      }
	      return (0, _containsNode.default)(this.node, globalObject.document.activeElement);
	    }
	  }, {
	    key: "onSubmenuWillUnmount",
	    value: function onSubmenuWillUnmount(instance, config) {
	      var _this12 = this;
	      if (config && config.hasFocus) {
	        setTimeout(function () {
	          _this12.focus();
	        }, 0);
	      }
	    }
	  }, {
	    key: "focusFirstItem",
	    value: function focusFirstItem() {
	      var fistNonDisabledItem = (0, _getFirstNonDisabledItem.default)(this.props.items);
	      this.focusItem(fistNonDisabledItem);
	    }
	  }, {
	    key: "focusItem",
	    value: function focusItem(index) {
	      this.focus();
	      this.setFocusedIndex(index);
	    }
	  }, {
	    key: "getSubmenuNode",
	    value: function getSubmenuNode() {
	      return this.subMenu && this.subMenu.getNode();
	    }
	  }, {
	    key: "getNode",
	    value: function getNode() {
	      return this.node;
	    }
	  }, {
	    key: "getSelected",
	    value: function getSelected() {
	      return this.isSelectedControlled() ? this.props.selected : this.state.selected;
	    }
	  }, {
	    key: "isSelectedControlled",
	    value: function isSelectedControlled() {
	      return this.props.selected !== undefined;
	    }
	  }, {
	    key: "handleSelectionChange",
	    value: function handleSelectionChange(_ref6) {
	      var name = _ref6.name,
	        value = _ref6.value,
	        checked = _ref6.checked,
	        multiple = _ref6.multiple;
	      var newSelected = _objectSpread({}, this.getSelected());
	      var options = {
	        name: name,
	        value: value,
	        checked: checked,
	        multiple: multiple
	      };
	      if (!multiple) {
	        newSelected[name] = value;
	      } else if (checked) {
	        newSelected[name] = value === undefined ? name : value;
	      }
	      if (!checked) {
	        if (multiple || this.props.allowUnselect) {
	          delete newSelected[name];
	        }
	      }
	      this.setSelected(newSelected, options);
	    }
	  }, {
	    key: "setSelected",
	    value: function setSelected(newSelected, options) {
	      if (!this.isSelectedControlled()) {
	        this.setState({
	          selected: newSelected
	        });
	      }
	      this.props.onSelectionChange(newSelected, options);
	    }
	  }, {
	    key: "handleSubmenuSelectionChange",
	    value: function handleSubmenuSelectionChange(selected, options) {
	      this.setSelected(selected, options);
	    }
	  }, {
	    key: "getExpandedIndex",
	    value: function getExpandedIndex() {
	      return this.state.activeSubMenuIndex;
	    }
	  }, {
	    key: "isSeparator",
	    value: function isSeparator(index) {
	      var props = this.props;
	      var separatorIndexes = (0, _getSeparatorIndexes.default)(props.items);
	      return separatorIndexes.indexOf(index) !== -1;
	    }
	  }]);
	  return InovuaMenu;
	}(_reactClass.default);
	InovuaMenu.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-menu',
	  depth: 0,
	  rtl: false,
	  isMenu: true,
	  enableScroll: true,
	  submenuStyle: null,
	  scrollerProps: {},
	  theme: 'default-light',
	  dismissOnClick: true,
	  disableScroller: false,
	  shadow: true,
	  submenuAlignOffset: _submenuAlignPositions.alignOffsetLTR,
	  rtlSubmenuAlignOffset: _submenuAlignPositions.alignOffsetRTL,
	  showSubMenuDelay: 150,
	  hideSubMenuDelay: 150,
	  expanderSize: 10,
	  scrollOnMouseEnter: true,
	  onClick: function onClick() {},
	  onSelectionChange: function onSelectionChange() {},
	  columns: ['label'],
	  items: null,
	  maxHeight: 'auto',
	  scrollArrowIncrementType: 'step',
	  enableAnimation: true,
	  fadeDuration: 100,
	  fadeTransitionFunction: 'ease',
	  enableRootAnimation: false,
	  itemStyle: {},
	  itemOverStyle: {},
	  itemDisabledStyle: {},
	  itemExpandedStyle: {},
	  cellStyle: {},
	  stopClickPropagation: true,
	  stopBlurPropagation: true,
	  scrollProps: {},
	  inTriangleWaitDelay: 300,
	  alignOffset: {
	    x: 0,
	    y: 0
	  },
	  simulateClickOnEnterKeyPress: true,
	  enableKeyboardNavigation: true,
	  defaultFocusedItem: null,
	  autoFocus: false,
	  closeSubMenu: function closeSubMenu() {},
	  closeSubmenuRecursively: function closeSubmenuRecursively() {},
	  onDismiss: function onDismiss() {},
	  componentWillUnmount: function componentWillUnmount() {},
	  componentDidMount: function componentDidMount() {},
	  useMouseInTriangleCheck: false,
	  allowUnselect: false,
	  enableSelection: false,
	  nameProperty: 'name',
	  valueProperty: 'value',
	  selectionInputPosition: 'start',
	  defaultSelected: {},
	  selectOnClick: true,
	  checkIconSize: 16,
	  radioIconSize: 16,
	  notifyResizeDelay: 16,
	  browserNativeSelectInputs: false,
	  showWarnings: !_uglified.default
	};
	InovuaMenu.propTypes = {
	  rootClassName: _propTypes.default.string,
	  items: _propTypes.default.array,
	  columns: _propTypes.default.array,
	  dismissOnClick: _propTypes.default.bool,
	  autoDismiss: _propTypes.default.bool,
	  disableScroller: _propTypes.default.bool,
	  showSubMenuDelay: _propTypes.default.number,
	  hideSubMenuDelay: _propTypes.default.number,
	  notifyResizeDelay: _propTypes.default.number,
	  scrollOnMouseEnter: _propTypes.default.bool,
	  padding: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  border: _propTypes.default.string,
	  borderRadius: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  rowActiveStyle: _propTypes.default.object,
	  rowOverStyle: _propTypes.default.object,
	  rowStyle: _propTypes.default.object,
	  maxHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  submenuMaxHeight: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  minSize: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
	    height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  })]),
	  maxSize: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
	    height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  })]),
	  onClick: _propTypes.default.func,
	  showScrollArrows: _propTypes.default.bool,
	  scrollProps: _propTypes.default.object,
	  scrollArrowIncrementType: _propTypes.default.oneOf(['step', 'page']),
	  renderScroller: _propTypes.default.func,
	  enableAnimation: _propTypes.default.bool,
	  fadeDuration: _propTypes.default.number,
	  fadeTransitionFunction: _propTypes.default.string,
	  enableRootAnimation: _propTypes.default.bool,
	  itemStyle: _propTypes.default.object,
	  itemClassName: _propTypes.default.string,
	  itemActiveStyle: _propTypes.default.object,
	  itemActiveClassName: _propTypes.default.string,
	  itemOverStyle: _propTypes.default.object,
	  itemOverClassName: _propTypes.default.string,
	  itemDisabledStyle: _propTypes.default.object,
	  itemDisabledClassName: _propTypes.default.string,
	  itemExpandedStyle: _propTypes.default.object,
	  itemExpandedClassName: _propTypes.default.string,
	  itemFocusedStyle: _propTypes.default.object,
	  itemFocusedClassName: _propTypes.default.string,
	  itemOverFocusedStyle: _propTypes.default.object,
	  visible: _propTypes.default.bool,
	  itemHeight: _propTypes.default.number,
	  cellStyle: _propTypes.default.object,
	  secondaryLabelStyle: _propTypes.default.object,
	  labelStyle: _propTypes.default.object,
	  titleStyle: _propTypes.default.object,
	  alignTo: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func, _propTypes.default.string]),
	  inTriangleWaitDelay: _propTypes.default.number,
	  alignPositions: _propTypes.default.arrayOf(_propTypes.default.string),
	  alignOffset: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object, _propTypes.default.number]),
	  submenuAlignOffset: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }), _propTypes.default.number]),
	  rtlSubmenuAlignOffset: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }), _propTypes.default.number]),
	  alignPosition: _propTypes.default.oneOf([1, -1]),
	  rtl: _propTypes.default.bool,
	  enableKeyboardNavigation: _propTypes.default.bool,
	  defaultFocusedItem: _propTypes.default.number,
	  autoFocus: _propTypes.default.bool,
	  closeSubMenu: _propTypes.default.func,
	  closeSubmenuRecursively: _propTypes.default.func,
	  simulateClickOnEnterKeyPress: _propTypes.default.bool,
	  onChildClick: _propTypes.default.func,
	  onDismiss: _propTypes.default.func,
	  expanderStyle: _propTypes.default.object,
	  depth: _propTypes.default.number,
	  isMenu: _propTypes.default.bool,
	  constrainTo: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.bool, _propTypes.default.func]),
	  enableScroll: _propTypes.default.bool,
	  submenuStyle: _propTypes.default.object,
	  scrollerProps: _propTypes.default.object,
	  theme: _propTypes.default.string,
	  stopClickPropagation: _propTypes.default.bool,
	  componentWillUnmount: _propTypes.default.func,
	  componentDidMount: _propTypes.default.func,
	  itemStyleProps: _propTypes.default.object,
	  childrenLength: _propTypes.default.number,
	  separatorIndexes: _propTypes.default.string,
	  tableClassName: _propTypes.default.string,
	  shadow: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  stopBlurPropagation: _propTypes.default.bool,
	  submenuProps: _propTypes.default.object,
	  menuHasSubmenu: _propTypes.default.bool,
	  depthSet: _propTypes.default.bool,
	  subMenu: _propTypes.default.bool,
	  parentIndex: _propTypes.default.number,
	  parentMenu: _propTypes.default.object,
	  onActivate: _propTypes.default.func,
	  onInactivate: _propTypes.default.func,
	  expander: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.bool, _propTypes.default.func]),
	  expanderSize: _propTypes.default.number,
	  overStyle: _propTypes.default.object,
	  activeStyle: _propTypes.default.object,
	  disabledStyle: _propTypes.default.object,
	  expandedStyle: _propTypes.default.object,
	  menuSeparatorStyle: _propTypes.default.object,
	  useMouseInTriangleCheck: _propTypes.default.bool,
	  selected: _propTypes.default.object,
	  defaultSelected: _propTypes.default.object,
	  allowUnselect: _propTypes.default.bool,
	  enableSelection: _propTypes.default.bool,
	  nativeScroll: _propTypes.default.bool,
	  scrollContainerProps: _propTypes.default.object,
	  nameProperty: _propTypes.default.string,
	  valueProperty: _propTypes.default.string,
	  renderCheckInput: _propTypes.default.func,
	  renderRadioInput: _propTypes.default.func,
	  onSelectionChange: _propTypes.default.func,
	  selectionInputPosition: _propTypes.default.oneOf(['start', 'end']),
	  selectOnClick: _propTypes.default.bool,
	  checkIconSize: _propTypes.default.number,
	  radioIconSize: _propTypes.default.number,
	  showWarnings: _propTypes.default.bool,
	  updatePositionOnScroll: _propTypes.default.bool,
	  browserNativeSelectInputs: _propTypes.default.bool,
	  dismissWithEscape: _propTypes.default.bool
	};
	var _default = InovuaMenu;
	exports.default = _default;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _MenuItemCell = _interopRequireDefault(__webpack_require__(156));
	var _default = function _default(props, column, index, columns) {
	  var hasSubmenu = props.hasSubmenu,
	    rootClassName = props.rootClassName;
	  var globalCellStyle = props.globalCellStyle;
	  var item = props.items && props.items[index];
	  if (typeof globalCellStyle == 'function') {
	    globalCellStyle = globalCellStyle({
	      index: index,
	      columns: columns,
	      items: props.items,
	      item: item,
	      hasSubmenu: hasSubmenu
	    });
	  }
	  var style = (0, _assign.default)({}, globalCellStyle);
	  var isLast = index === columns.length - 1;
	  var cellProps = (0, _assign.default)({}, props.cellProps);
	  if (isLast && props.siblingItemHasSubMenu && !props.item.items) {}
	  var children;
	  if (column && typeof column.render == 'function') {
	    children = column.render(props.item, {
	      column: column,
	      columns: columns,
	      index: index,
	      items: props.items,
	      item: item,
	      hasSubmenu: hasSubmenu
	    });
	  } else {
	    var columnName = typeof column == 'string' ? column : column.name;
	    children = props.item[columnName];
	  }
	  if ((0, _typeof2.default)(column) === 'object') {
	    if (column.colSpan) {
	      cellProps.colSpan = column.colSpan;
	    }
	  }
	  if (column.style) {
	    var columnStyle;
	    if (typeof column.style === 'function') {
	      columnStyle = column.style({
	        index: index,
	        columns: columns,
	        items: props.items,
	        item: item,
	        hasSubmenu: hasSubmenu
	      });
	    } else {
	      columnStyle = column.style;
	    }
	    (0, _assign.default)(style, columnStyle);
	  }
	  var className = column.className;
	  if (item) {
	    if (item.cellStyle) {
	      (0, _assign.default)(style, item.cellStyle);
	    }
	    if (item.className) {
	      className = (0, _join.default)(className, item.cellClassName);
	    }
	  }
	  if (props.style) {
	    (0, _assign.default)(style, props.style);
	  }
	  return _react.default.createElement(_MenuItemCell.default, {
	    style: style,
	    className: className,
	    key: index,
	    rootClassName: rootClassName,
	    cellProps: cellProps,
	    isDescription: column.isDescription,
	    isIcon: column.isIcon,
	    align: column.align
	  }, children);
	};
	exports.default = _default;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _getConstrainRegion = _interopRequireDefault(__webpack_require__(213));
	var _prepareAlignOffset = _interopRequireDefault(__webpack_require__(251));
	var _this = void 0;
	var _default = function _default(props, subMenuRegion, targetAlignRegion, constrainTo, domNode) {
	  var constrainRegion = _getConstrainRegion.default.call(_this, constrainTo, domNode);
	  if (typeof props.alignSubMenu === 'function') {
	    props.alignSubMenu(subMenuRegion, targetAlignRegion, constrainRegion);
	  } else {
	    var alignPositions = props.alignPositions;
	    var offset = props.rtl ? props.rtlSubmenuAlignOffset : props.submenuAlignOffset;
	    offset = (0, _prepareAlignOffset.default)(offset, alignPositions.length);
	    var pos = subMenuRegion.alignTo(targetAlignRegion, alignPositions, {
	      offset: offset,
	      constrain: constrainRegion
	    });
	    return pos == 'tl-tr' || pos == 'tr-tl' ? 1 : -1;
	  }
	};
	exports.default = _default;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	var _regionAlign = _interopRequireDefault(__webpack_require__(55));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _align = _interopRequireDefault(__webpack_require__(698));
	var _getGlobal = __webpack_require__(18);
	var globalObject = (0, _getGlobal.getGlobal)();
	function transformPxStringToInt(pxValue) {
	  var value = parseFloat(pxValue.split('px')[0]);
	  return typeof value === 'number' && !isNaN(value) ? value : 0;
	}
	function _default(props, state, domNode) {
	  var _this = this;
	  if (state.activeSubMenuIndex == null || !this.componentIsMounted) {
	    this.prevMenuIndex = -1;
	    return;
	  }
	  var overItem = this.getItemByIndex(state.activeSubMenuIndex);
	  var offset = overItem && overItem.getOffset();
	  var left = offset.left + offset.width;
	  var top = offset.top;
	  var menuIndex = state.activeSubMenuIndex;
	  var sameMenu = this.prevMenuIndex == menuIndex;
	  if (this.aligning && !sameMenu) {
	    this.aligning = false;
	  }
	  this.prevMenuIndex = menuIndex;
	  var style = {
	    left: left,
	    top: top,
	    pointerEvents: 'none',
	    position: 'absolute'
	  };
	  if (!this.aligning && !sameMenu) {
	    setTimeout(function () {
	      if (!_this.componentIsMounted) {
	        return;
	      }
	      var thisRegion = _regionAlign.default.from(domNode);
	      var menuComputedStyle = globalObject.getComputedStyle(domNode);
	      var paddingLeft = transformPxStringToInt(menuComputedStyle.paddingLeft);
	      var menuItemRegion = _regionAlign.default.from({
	        left: thisRegion.left + paddingLeft,
	        top: thisRegion.top + offset.top,
	        width: offset.width,
	        height: offset.height
	      });
	      var subMenuMounted = _this.subMenu && _this.subMenu.componentIsMounted;
	      if (!subMenuMounted) {
	        return;
	      }
	      var submenuNode = _this.subMenu.node;
	      var subMenuRegion = _regionAlign.default.from(submenuNode);
	      var initialHeight = subMenuRegion.height;
	      var alignPosition = (0, _align.default)(props, subMenuRegion, menuItemRegion, props.constrainTo, domNode);
	      var newHeight = subMenuRegion.height;
	      var maxHeight;
	      if (newHeight < initialHeight && props.subMenuConstrainMargin != null) {
	        maxHeight = newHeight - props.subMenuConstrainMargin;
	      } else if (newHeight < initialHeight) {
	        maxHeight = newHeight;
	      }
	      if (maxHeight && alignPosition == -1) {
	        subMenuRegion.top = subMenuRegion.bottom - maxHeight;
	      }
	      var newLeft = subMenuRegion.left - thisRegion.left;
	      var newTop = subMenuRegion.top - thisRegion.top;
	      if (Math.abs(newLeft - left) < 5) {
	        newLeft = left;
	      }
	      if (Math.abs(newTop - top) < 5) {
	        newTop = top;
	      }
	      _this.subMenuPosition = newLeft < 0 ? 'left' : 'right';
	      if (newHeight === 0) {
	        return;
	      }
	      _this.alignOffset = {
	        left: newLeft,
	        top: newTop
	      };
	      _this.aligning = true;
	      _this.setState({
	        submenuAlignPosition: alignPosition,
	        submenuMaxHeight: props.submenuMaxHeight || maxHeight
	      });
	    }, 0);
	  }
	  if (sameMenu || this.aligning && this.alignOffset) {
	    (0, _assign.default)(style, this.alignOffset);
	    style.visibility = 'visible';
	    delete style.pointerEvents;
	    delete style.overflow;
	  }
	  this.aligning = false;
	  return style;
	}

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Cell", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItemCell.default;
	  }
	});
	Object.defineProperty(exports, "Item", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	Object.defineProperty(exports, "ItemCell", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItemCell.default;
	  }
	});
	Object.defineProperty(exports, "Separator", {
	  enumerable: true,
	  get: function get() {
	    return _MenuSeparator.default;
	  }
	});
	exports.default = void 0;
	var _Menu = _interopRequireDefault(__webpack_require__(696));
	var _MenuItem = _interopRequireDefault(__webpack_require__(248));
	var _MenuItemCell = _interopRequireDefault(__webpack_require__(156));
	var _MenuSeparator = _interopRequireDefault(__webpack_require__(249));
	var _default = _Menu.default;
	exports.default = _default;
	_Menu.default.Item = _MenuItem.default;
	_Menu.default.Item.Cell = _MenuItemCell.default;
	_MenuItem.default.Cell = _MenuItemCell.default;

/***/ },
/* 701 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.alignPositionRTL = exports.alignPositionLTR = exports.alignOffsetRTL = exports.alignOffsetLTR = void 0;
	var alignPositionLTR = ['tl-tr', 'bl-br', 'tr-tl', 'br-bl'];
	exports.alignPositionLTR = alignPositionLTR;
	var alignPositionRTL = ['tr-tl', 'br-bl', 'tl-tr', 'bl-br'];
	exports.alignPositionRTL = alignPositionRTL;
	var alignOffsetLTR = [{
	  x: -7,
	  y: 5
	}, {
	  x: -7,
	  y: -5
	}, {
	  x: 7,
	  y: 5
	}, {
	  x: 7,
	  y: -5
	}];
	exports.alignOffsetLTR = alignOffsetLTR;
	var alignOffsetRTL = [{
	  x: 7,
	  y: 5
	}, {
	  x: 7,
	  y: -5
	}, {
	  x: -7,
	  y: 5
	}, {
	  x: -7,
	  y: -5
	}];
	exports.alignOffsetRTL = alignOffsetRTL;

/***/ },
/* 702 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function getFirstNonDisabledItem(items) {
	  var fistNonDisabledItemIndex = null;
	  if (!items || items && !items.length) {
	    return null;
	  }
	  for (var i = 0, len = items.length; i < len; i++) {
	    var item = items[i];
	    if (item && !item.disabled && !item.isTitle) {
	      fistNonDisabledItemIndex = i;
	      break;
	    }
	  }
	  return fistNonDisabledItemIndex;
	}
	var _default = getFirstNonDisabledItem;
	exports.default = _default;

/***/ },
/* 703 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(props) {
	  var itemStyle = props.itemStyle,
	    itemOverStyle = props.itemOverStyle,
	    itemOverClassName = props.itemOverClassName,
	    itemActiveStyle = props.itemActiveStyle,
	    itemActiveClassName = props.itemActiveClassName,
	    itemDisabledStyle = props.itemDisabledStyle,
	    itemDisabledClassName = props.itemDisabledClassName,
	    itemExpandedStyle = props.itemExpandedStyle,
	    itemExpandedClassName = props.itemExpandedClassName,
	    cellStyle = props.cellStyle,
	    itemFocusedStyle = props.itemFocusedStyle,
	    itemFocusedClassName = props.itemFocusedClassName,
	    itemOverFocusedStyle = props.itemOverFocusedStyle;
	  return {
	    style: itemStyle,
	    overStyle: itemOverStyle,
	    overClassName: itemOverClassName,
	    activeStyle: itemActiveStyle,
	    activeClassName: itemActiveClassName,
	    disabledStyle: itemDisabledStyle,
	    disabledClassName: itemDisabledClassName,
	    expandedStyle: itemExpandedStyle,
	    expandedClassName: itemExpandedClassName,
	    focusedStyle: itemFocusedStyle,
	    focusedClassName: itemFocusedClassName,
	    overFocusedStyle: itemOverFocusedStyle,
	    cellStyle: cellStyle
	  };
	};
	exports.default = _default;

/***/ },
/* 704 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function getNextNavigableItem(items) {
	  var startFrom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	  var nextNavigableItem = null;
	  if (!items || items && !items.length) {
	    return null;
	  }
	  if (startFrom === null) {
	    return null;
	  }
	  if (direction === 1) {
	    for (var i = startFrom + 1, len = items.length; i < len; i++) {
	      var item = items[i];
	      var isDisabled = item && item.disabled;
	      var isSeparator = item === '-';
	      var isTitle = item.isTitle;
	      if (!isSeparator && !isDisabled && !isTitle) {
	        nextNavigableItem = i;
	        break;
	      }
	    }
	  } else {
	    for (var _i = startFrom - 1; _i >= 0; _i--) {
	      var _item = items[_i];
	      var _isDisabled = _item && _item.disabled;
	      var _isSeparator = _item === '-';
	      var _isTitle = _item.isTitle;
	      if (!_isSeparator && !_isDisabled && !_isTitle) {
	        nextNavigableItem = _i;
	        break;
	      }
	    }
	  }
	  return nextNavigableItem;
	}
	var _default = getNextNavigableItem;
	exports.default = _default;

/***/ },
/* 705 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function getSeparatorIndexes(children) {
	  return children.reduce(function (acc, child, index) {
	    if (child === '-' || child.props && child.props.isSeparator) {
	      acc.push(index);
	    }
	    return acc;
	  }, []);
	}
	var _default = getSeparatorIndexes;
	exports.default = _default;

/***/ },
/* 706 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function getSingleSelectNames(_ref) {
	  var items = _ref.items,
	    nameProperty = _ref.nameProperty;
	  if (!items || items.length <= 1) {
	    return null;
	  }
	  var names = items.reduce(function (acc, item) {
	    var name = item[nameProperty];
	    if (acc[name] !== undefined) {
	      acc[name] = true;
	    } else {
	      acc[name] = false;
	    }
	    return acc;
	  }, {});
	  return names;
	}
	var _default = getSingleSelectNames;
	exports.default = _default;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	exports.increaseFirstColumnColSpan = increaseFirstColumnColSpan;
	exports.increaseLastColumnColSpan = increaseLastColumnColSpan;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function increaseColSpan(column) {
	  var newColumn = column;
	  if (typeof newColumn === 'string') {
	    newColumn = {
	      name: newColumn,
	      colSpan: 2
	    };
	  } else {
	    newColumn = _objectSpread(_objectSpread({}, column), {}, {
	      colSpan: newColumn.colSpan ? newColumn.colSpan + 1 : 2
	    });
	  }
	  return newColumn;
	}
	function increaseLastColumnColSpan(columns) {
	  return [].concat((0, _toConsumableArray2.default)(columns.slice(0, -1)), [increaseColSpan(columns[columns.length - 1])]);
	}
	function increaseFirstColumnColSpan(columns) {
	  return [increaseColSpan(columns[0])].concat((0, _toConsumableArray2.default)(columns.slice(1)));
	}
	var _default = increaseColSpan;
	exports.default = _default;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _getMinMaxSize = _interopRequireDefault(__webpack_require__(581));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function prepareStyle(props, state) {
	  var style = {};
	  if (props.subMenu) {
	    (0, _assign.default)(style, props.submenuStyle);
	  } else {
	    (0, _assign.default)(style, props.style);
	  }
	  if (props.at) {
	    var isArray = Array.isArray(props.at);
	    var coords = {
	      left: isArray ? props.at[0] : props.at.left === undefined ? props.at.x || props.at.pageX : props.at.left,
	      top: isArray ? props.at[1] : props.at.top === undefined ? props.at.y || props.at.pageY : props.at.top
	    };
	    (0, _assign.default)(style, coords);
	  }
	  if (state.positionStyle && props.visible !== false) {
	    style = _objectSpread(_objectSpread({}, style), state.positionStyle);
	  }
	  var minMaxSize = (0, _getMinMaxSize.default)(props);
	  (0, _assign.default)(style, minMaxSize);
	  if (props.padding) {
	    (0, _assign.default)(style, {
	      padding: props.padding
	    });
	  }
	  if (props.border) {
	    (0, _assign.default)(style, {
	      border: props.border
	    });
	  }
	  if (typeof props.shadow === 'string') {
	    (0, _assign.default)(style, {
	      boxShadow: props.shadow
	    });
	  }
	  if (props.borderRadius) {
	    (0, _assign.default)(style, {
	      borderRadius: props.borderRadius
	    });
	  }
	  if (props.width) {
	    (0, _assign.default)(style, {
	      width: props.width
	    });
	  }
	  if (props.enableAnimation && (state.transitionEnded || state.transitionStart)) {
	    (0, _assign.default)(style, {
	      transitionDuration: "".concat(props.fadeDuration, "ms"),
	      transitionTimingFunction: props.transitionTimingFunction
	    });
	  }
	  return style;
	}
	var _default = prepareStyle;
	exports.default = _default;

/***/ },
/* 709 */
[1296, 713],
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _autoBind = _interopRequireDefault(__webpack_require__(52));
	var _hasTouch = _interopRequireDefault(__webpack_require__(264));
	var _raf = _interopRequireDefault(__webpack_require__(216));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _clamp = _interopRequireDefault(__webpack_require__(81));
	var _debounce = _interopRequireDefault(__webpack_require__(212));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _eventNames = _interopRequireDefault(__webpack_require__(579));
	var _getSelectionRange = _interopRequireDefault(__webpack_require__(719));
	var _getSelectionStart2 = _interopRequireDefault(__webpack_require__(253));
	var _setCaretPosition = _interopRequireDefault(__webpack_require__(721));
	var _getDecimalDelimiter = _interopRequireDefault(__webpack_require__(252));
	var _getTransformedStringValues2 = _interopRequireWildcard(__webpack_require__(720));
	var _getCurrencyForCountryCode = _interopRequireDefault(__webpack_require__(716));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var preventDefault = function preventDefault(e) {
	  return e.preventDefault();
	};
	var emptyObject = {};
	var isNumeric = function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	};
	var isInt = function isInt(n) {
	  return Number(n) === n && n % 1 === 0;
	};
	var getArrowClasses = function getArrowClasses(spinDirection, props) {
	  var upArrowClass = (0, _join.default)("".concat(props.rootClassName, "__spinner-arrow"), "".concat(props.rootClassName, "__spinner-arrow--up"), spinDirection === 1 && "".concat(props.rootClassName, "__spinner-arrow--active"));
	  var downArrowClass = (0, _join.default)("".concat(props.rootClassName, "__spinner-arrow"), "".concat(props.rootClassName, "__spinner-arrow--down"), spinDirection === -1 && "".concat(props.rootClassName, "__spinner-arrow--active"));
	  return {
	    upArrowClass: upArrowClass,
	    downArrowClass: downArrowClass
	  };
	};
	var getClearButtonClassNames = function getClearButtonClassNames(props) {
	  var clearButtonClassName = (0, _join.default)("".concat(props.rootClassName, "__clear-button"), "".concat(props.rootClassName, "__clear-button--").concat(props.rtl ? 'rtl' : 'ltr'), props.clearButtonClassName);
	  return {
	    clearButtonClassName: clearButtonClassName
	  };
	};
	var toUpperFirst = function toUpperFirst(str) {
	  return str ? str.charAt(0).toUpperCase() + str.substring(1) : '';
	};
	var noDot = function noDot(value) {
	  value += '';
	  return value.indexOf('.') === -1;
	};
	var isMinValueRespected = function isMinValueRespected(value, props) {
	  var minValue = props.minValue;
	  if (minValue == null || value === '') {
	    return true;
	  }
	  return value >= minValue;
	};
	var isMaxValueRespected = function isMaxValueRespected(value, props) {
	  var maxValue = props.maxValue;
	  if (maxValue == null || value === '') {
	    return true;
	  }
	  return value <= maxValue;
	};
	var checkNumeric = function checkNumeric(value, _ref) {
	  var numbersOnly = _ref.numbersOnly,
	    allowNegative = _ref.allowNegative,
	    allowFloat = _ref.allowFloat;
	  if (value === '') {
	    return true;
	  }
	  if (numbersOnly) {
	    var numeric = isNumeric(value);
	    return numeric || allowNegative && value === '-' || allowFloat && value === '.' || allowNegative && allowFloat && value == '-.';
	  }
	  return true;
	};
	var isPossibleNumericStart = function isPossibleNumericStart(value, _ref2) {
	  var allowFloat = _ref2.allowFloat,
	    allowNegative = _ref2.allowNegative;
	  if (allowFloat && value === '.') {
	    return true;
	  }
	  if (allowNegative && value === '-') {
	    return true;
	  }
	  if (allowNegative && allowFloat && value === '-.') {
	    return true;
	  }
	  return !isNaN(value);
	};
	var checkFloat = function checkFloat(value, _ref3) {
	  var allowFloat = _ref3.allowFloat;
	  if (allowFloat === false) {
	    return noDot(value) && isNumeric(value) && isInt(value * 1);
	  }
	};
	var isFloat = function isFloat(n) {
	  return Number(n) === n && n % 1 !== 0;
	};
	var isFloatString = function isFloatString(n) {
	  var str = "".concat(n);
	  return isFloat(str) || isNumeric(str) && str.indexOf('.') !== -1;
	};
	var checkPositive = function checkPositive(value, _ref4) {
	  var allowNegative = _ref4.allowNegative;
	  if (allowNegative === false) {
	    return isNumeric(value) && value * 1 >= 0;
	  }
	};
	var getInitialStateValue = function getInitialStateValue(props) {
	  var value = props.value,
	    defaultValue = props.defaultValue;
	  if (value) {
	    return null;
	  }
	  if (defaultValue || defaultValue === 0) {
	    return getFormatedValue(defaultValue, props);
	  }
	  return '';
	};
	var getFormatedValue = function getFormatedValue(value, props) {
	  if (value || value === 0) {
	    var locale = props.locale,
	      prefix = props.prefix,
	      suffix = props.suffix,
	      minValue = props.minValue,
	      maxValue = props.maxValue,
	      precision = props.precision;
	    return (0, _getTransformedStringValues2.default)(value, {
	      locale: locale,
	      precision: precision,
	      min: minValue,
	      max: maxValue,
	      prefix: prefix,
	      suffix: suffix
	    })[0];
	  }
	};
	var getCurrentValue = function getCurrentValue(props, state) {
	  var value = props.value,
	    defaultValue = props.defaultValue;
	  var formattedValue = state.formattedValue;
	  if (value != null) {
	    return value;
	  }
	  if (formattedValue == null) {
	    return getFormatedValue(defaultValue, props);
	  }
	  return formattedValue;
	};
	var isControlled = function isControlled(props) {
	  return props.value !== undefined;
	};
	var getInitialStatePrecision = function getInitialStatePrecision(props) {
	  if (isControlledPrecision(props)) {
	    return null;
	  }
	  return 0;
	};
	var isControlledPrecision = function isControlledPrecision(props) {
	  return props.precision === 0 || !!props.precision;
	};
	var getSuffix = function getSuffix(props) {
	  var suffix = props.suffix,
	    format = props.format,
	    currencySymbol = props.currencySymbol,
	    currencyPosition = props.currencyPosition,
	    locale = props.locale;
	  if (suffix) {
	    return suffix;
	  }
	  if (format === 'currency' && currencyPosition === 'end') {
	    if (currencySymbol) {
	      return currencySymbol;
	    }
	    return (0, _getCurrencyForCountryCode.default)(locale || (globalObject.navigator ? globalObject.navigator.language : ''));
	  }
	  if (format === 'percentage') {
	    return '%';
	  }
	};
	var getPrefix = function getPrefix(props) {
	  var prefix = props.prefix,
	    format = props.format,
	    currencySymbol = props.currencySymbol,
	    currencyPosition = props.currencyPosition,
	    locale = props.locale;
	  if (prefix) {
	    return prefix;
	  }
	  if (format === 'currency' && currencyPosition === 'start') {
	    if (currencySymbol) {
	      return currencySymbol;
	    }
	    return (0, _getCurrencyForCountryCode.default)(locale || (globalObject.navigator ? globalObject.navigator.language : ''));
	  }
	};
	var selectionContainsPosition = function selectionContainsPosition(selection, position) {
	  if (selection.start === selection.end) {
	    return false;
	  }
	  return selection.start <= position && selection.end > position;
	};
	var InovuaNumericInput = function (_Component) {
	  (0, _inherits2.default)(InovuaNumericInput, _Component);
	  var _super = _createSuper(InovuaNumericInput);
	  function InovuaNumericInput(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaNumericInput);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderClearIcon", function (svgProps) {
	      var result;
	      if (_this.props.renderClearIcon && typeof _this.props.renderClearIcon === 'function') {
	        result = _this.props.renderClearIcon({
	          width: svgProps.width,
	          height: svgProps.height
	        });
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("svg", {
	          style: _objectSpread({}, svgProps),
	          viewBox: "0 0 10 10"
	        }, _react.default.createElement("path", {
	          fill: "none",
	          fillRule: "evenodd",
	          strokeLinecap: "round",
	          strokeWidth: "1.33",
	          d: "M1 1l8 8m0-8L1 9"
	        }));
	      }
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderArrowUpIcon", function (svgProps) {
	      var height = svgProps.height;
	      var result;
	      if (_this.props.renderArrowUpIcon && typeof _this.props.renderArrowUpIcon === 'function') {
	        result = _this.props.renderArrowUpIcon(_objectSpread({}, svgProps));
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("svg", {
	          style: _objectSpread(_objectSpread({}, svgProps), {}, {
	            height: height / 2
	          }),
	          viewBox: "0 0 10 5"
	        }, _react.default.createElement("path", {
	          fillRule: "evenodd",
	          d: "M5.262.262l4.106 4.106c.144.144.144.379 0 .524-.07.069-.164.108-.262.108H.894c-.204 0-.37-.166-.37-.37 0-.099.039-.193.108-.262L4.738.262c.145-.145.38-.145.524 0z"
	        }));
	      }
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderArrowDownIcon", function (svgProps) {
	      var height = svgProps.height;
	      var result;
	      if (_this.props.renderArrowDownIcon && typeof _this.props.renderArrowDownIcon === 'function') {
	        result = _this.props.renderArrowDownIcon(_objectSpread({}, svgProps));
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("svg", {
	          style: _objectSpread(_objectSpread({}, svgProps), {}, {
	            height: height / 2
	          }),
	          viewBox: "0 0 10 5"
	        }, _react.default.createElement("path", {
	          fillRule: "evenodd",
	          d: "M4.738 4.738L.632.632C.488.488.488.253.632.108.702.04.796 0 .894 0h8.212c.204 0 .37.166.37.37 0 .099-.039.193-.108.262L5.262 4.738c-.145.145-.38.145-.524 0z"
	        }));
	      }
	      return result;
	    });
	    (0, _autoBind.default)((0, _assertThisInitialized2.default)(_this));
	    var value = isControlled(props) ? props.value : props.defaultValue;
	    if (props.triggerChangeOnSpinDelay > 0) {
	      _this.setValueOnSpin = (0, _debounce.default)(_this.setValueOnSpin, props.triggerChangeOnSpinDelay);
	    }
	    _this.state = {
	      value: value,
	      focused: false,
	      formattedValue: getFormatedValue(value, props),
	      spinDirection: null,
	      intermediateValue: null
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaNumericInput, [{
	    key: "setInputRef",
	    value: function setInputRef(el) {
	      this.input = el;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props,
	        state = this.state;
	      var toolPosition = props.toolPosition;
	      var _this$p = this.p = this.getProps(props, state),
	        formattedValue = _this$p.formattedValue,
	        enableSpinnerTools = _this$p.enableSpinnerTools,
	        className = _this$p.className,
	        style = _this$p.style,
	        enableClearButton = _this$p.enableClearButton,
	        wrapperProps = _this$p.wrapperProps;
	      var min = props.mim;
	      if (min === undefined && !props.allowNegative) {
	        min = 0;
	      }
	      var currentValue = state.focused ? this.p.value : this.p.formattedValue;
	      if (currentValue == null) {
	        currentValue = '';
	      }
	      var inputProps = props.inputProps || emptyObject;
	      var inputClassName = (0, _join.default)("".concat(props.rootClassName, "__input"), inputProps.className);
	      var input = _react.default.createElement("input", _objectSpread(_objectSpread({
	        size: Math.max(1, props.size || 0),
	        placeholder: this.props.placeholder
	      }, inputProps), {}, {
	        ref: this.setInputRef,
	        type: "text",
	        key: "input",
	        className: inputClassName,
	        disabled: props.disabled,
	        value: currentValue,
	        onWheel: this.handleWheel,
	        onKeyDown: this.handleKeyDown,
	        onKeyUp: this.handleKeyUp,
	        onChange: this.handleChange,
	        min: min
	      }));
	      var clearButtonWrapper = this.renderClearButtonWrapper();
	      var spinnerToolWrapper = this.renderSpinnerToolsWrapper();
	      var inputDisplay = [input, clearButtonWrapper, spinnerToolWrapper];
	      if (toolPosition === 'start') {
	        inputDisplay = [spinnerToolWrapper, clearButtonWrapper, input];
	      }
	      if (enableSpinnerTools === false) {
	        inputDisplay = [input, spinnerToolWrapper, clearButtonWrapper];
	      }
	      if (toolPosition === 'start' && enableSpinnerTools === false) {
	        inputDisplay = [clearButtonWrapper, input, spinnerToolWrapper];
	      }
	      var propsToWrapper = (0, _cleanProps.default)(wrapperProps, InovuaNumericInput.propTypes);
	      return _react.default.createElement("div", _objectSpread(_objectSpread({}, propsToWrapper), {}, {
	        className: (0, _join.default)(className, wrapperProps ? wrapperProps.className : null),
	        style: wrapperProps && wrapperProps.style ? _objectSpread(_objectSpread({}, style), wrapperProps.style) : style,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus
	      }), inputDisplay);
	    }
	  }, {
	    key: "renderClearButtonWrapper",
	    value: function renderClearButtonWrapper() {
	      var props = this.props,
	        state = this.state;
	      var enableClearButton = this.props.enableClearButton;
	      var _this$p2 = this.p,
	        clearButtonColor = _this$p2.clearButtonColor,
	        clearButtonStyle = _this$p2.clearButtonStyle,
	        clearButtonSize = _this$p2.clearButtonSize;
	      var value = isControlled(props) ? props.value : state.value;
	      var hasValue = state.intermediateValue != null ? true : value !== '' && value != null;
	      var clearButtonWrapperClassName = (0, _join.default)("".concat(props.rootClassName, "__clear-button-wrapper"), (!hasValue || !enableClearButton) && "".concat(props.rootClassName, "__clear-button-wrapper--hidden"));
	      return _react.default.createElement("div", {
	        key: "clearButton",
	        className: clearButtonWrapperClassName
	      }, this.renderClearButton(_objectSpread({
	        clearButtonColor: clearButtonColor,
	        clearButtonStyle: clearButtonStyle,
	        clearButtonSize: clearButtonSize
	      }, getClearButtonClassNames(props))));
	    }
	  }, {
	    key: "renderClearButton",
	    value: function renderClearButton(config) {
	      var clearButtonColor = config.clearButtonColor,
	        clearButtonStyle = config.clearButtonStyle,
	        clearButtonClassName = config.clearButtonClassName,
	        clearButtonSize = config.clearButtonSize;
	      var svgProps = {};
	      var tabIndex = this.props.acceptClearToolFocus ? 0 : -1;
	      if (clearButtonColor) {
	        svgProps.fill = clearButtonColor;
	      }
	      if (clearButtonSize) {
	        if (Array.isArray(clearButtonSize)) {
	          svgProps.width = clearButtonSize[0];
	          svgProps.height = clearButtonSize[1];
	        } else {
	          svgProps.width = clearButtonSize;
	          svgProps.height = clearButtonSize;
	        }
	      }
	      return _react.default.createElement("button", {
	        key: "clearButton",
	        type: "button",
	        onClick: this.handleClearButtonClick,
	        onMouseDown: preventDefault,
	        className: clearButtonClassName,
	        style: _objectSpread({}, clearButtonStyle),
	        tabIndex: tabIndex
	      }, this.renderClearIcon(svgProps));
	    }
	  }, {
	    key: "renderSpinnerToolsWrapper",
	    value: function renderSpinnerToolsWrapper() {
	      var props = this.props;
	      var enableSpinnerTools = props.enableSpinnerTools,
	        rtl = props.rtl;
	      var _this$p3 = this.p,
	        arrowColor = _this$p3.arrowColor,
	        arrowStyle = _this$p3.arrowStyle,
	        arrowUpStyle = _this$p3.arrowUpStyle,
	        arrowDownStyle = _this$p3.arrowDownStyle,
	        spinDirection = _this$p3.spinDirection,
	        arrowSize = _this$p3.arrowSize;
	      var spinnerToolsWrapperClassName = enableSpinnerTools ? "".concat(props.rootClassName, "__spinner-wrapper ").concat(props.rootClassName, "__spinner-wrapper--").concat(rtl ? 'rtl' : 'ltr') : "".concat(props.rootClassName, "__spinner-wrapper-hidden ").concat(props.rootClassName, "__spinner-wrapper-hidden--").concat(rtl ? 'rtl' : 'ltr');
	      return _react.default.createElement("div", {
	        key: "spinnerTool",
	        className: spinnerToolsWrapperClassName
	      }, this.renderSpinnerTools(_objectSpread({
	        arrowColor: arrowColor,
	        arrowStyle: arrowStyle,
	        arrowUpStyle: arrowUpStyle,
	        arrowDownStyle: arrowDownStyle,
	        spinDirection: spinDirection,
	        arrowSize: arrowSize
	      }, getArrowClasses(spinDirection, props))));
	    }
	  }, {
	    key: "renderSpinnerTools",
	    value: function renderSpinnerTools(config) {
	      var arrowColor = config.arrowColor,
	        arrowStyle = config.arrowStyle,
	        arrowUpStyle = config.arrowUpStyle,
	        arrowDownStyle = config.arrowDownStyle,
	        upArrowClass = config.upArrowClass,
	        downArrowClass = config.downArrowClass,
	        arrowSize = config.arrowSize;
	      var svgProps = {};
	      if (arrowColor) {
	        svgProps.fill = arrowColor;
	      }
	      if (arrowSize) {
	        if (Array.isArray(arrowSize)) {
	          svgProps.width = arrowSize[0];
	          svgProps.height = arrowSize[1];
	        } else {
	          svgProps.width = arrowSize;
	          svgProps.height = arrowSize;
	        }
	      }
	      var arrowEvents = this.getArrowEvents();
	      return [_react.default.createElement("span", _objectSpread(_objectSpread({
	        key: "up"
	      }, arrowEvents.upEvents), {}, {
	        className: upArrowClass,
	        style: _objectSpread(_objectSpread({}, arrowStyle), arrowUpStyle)
	      }), this.renderArrowUpIcon(svgProps)), _react.default.createElement("span", _objectSpread(_objectSpread({
	        key: "down"
	      }, arrowEvents.downEvents), {}, {
	        className: downArrowClass,
	        style: _objectSpread(_objectSpread({}, arrowStyle), arrowDownStyle)
	      }), this.renderArrowDownIcon(svgProps))];
	    }
	  }, {
	    key: "getArrowEvents",
	    value: function getArrowEvents() {
	      return {
	        upEvents: (0, _defineProperty2.default)({}, _eventNames.default.onMouseDown, this.handleArrowDown.bind(this, 1)),
	        downEvents: (0, _defineProperty2.default)({}, _eventNames.default.onMouseDown, this.handleArrowDown.bind(this, -1))
	      };
	    }
	  }, {
	    key: "handleClearButtonClick",
	    value: function handleClearButtonClick(event) {
	      this.setState({
	        focused: true
	      });
	      this.setValue(null);
	      this.focus();
	    }
	  }, {
	    key: "handleArrowDown",
	    value: function handleArrowDown(shiftStep, event) {
	      var _this2 = this;
	      event.preventDefault();
	      var step = this.props.step;
	      var target = _hasTouch.default ? event.target : window;
	      var eventName = _hasTouch.default ? 'touchend' : 'click';
	      var onUpEvent = function onUpEvent() {
	        _this2.handleMouseUp();
	        target.removeEventListener(eventName, onUpEvent, true);
	      };
	      target.addEventListener(eventName, onUpEvent, true);
	      var shiftKey = event.shiftKey;
	      var direction = shiftStep > 0 ? 1 : -1;
	      var spinConfig = {
	        step: Math.abs(step)
	      };
	      this.stepTo(direction, spinConfig);
	      this.handleArrowDownTimeoutId = setTimeout(function () {
	        _this2.setState({
	          shiftKey: shiftKey,
	          spinDirection: direction
	        });
	        _this2.startSpin(direction, spinConfig);
	      }, 300);
	    }
	  }, {
	    key: "handleMouseUp",
	    value: function handleMouseUp() {
	      this.stopSpin();
	      this.setState({
	        spinDirection: null,
	        shiftKey: null
	      });
	    }
	  }, {
	    key: "getTransformedStringValues",
	    value: function getTransformedStringValues(value) {
	      var _this$p4 = this.p,
	        suffix = _this$p4.suffix,
	        prefix = _this$p4.prefix,
	        locale = _this$p4.locale,
	        precision = _this$p4.precision,
	        isControlledPrecision = _this$p4.isControlledPrecision,
	        minValue = _this$p4.minValue,
	        maxValue = _this$p4.maxValue;
	      return (0, _getTransformedStringValues2.default)(value, {
	        locale: locale,
	        precision: isControlledPrecision && precision,
	        min: minValue,
	        max: maxValue,
	        suffix: suffix,
	        prefix: prefix
	      });
	    }
	  }, {
	    key: "handleFocus",
	    value: function handleFocus(event) {
	      var onFocus = this.props.onFocus;
	      if (event.target != this.input) {
	        return;
	      }
	      this.setState({
	        focused: true
	      });
	      if (this.props.inputProps && this.props.inputProps.onFocus) {
	        this.props.inputProps.onFocus(event);
	      }
	      if (onFocus) {
	        onFocus(event);
	      }
	    }
	  }, {
	    key: "handleBlur",
	    value: function handleBlur(event) {
	      this.setState({
	        focused: false
	      });
	      if (this.isSpinning()) {
	        this.stopSpin();
	      }
	      if (this.state.intermediateValue != null) {
	        var value = (0, _clamp.default)(parseFloat(this.state.intermediateValue), this.props.minValue, this.props.maxValue);
	        if (!this.props.allowEmpty && (isNaN(value) || value == null)) {
	          value = this.props.valueOnEmpty !== undefined ? this.props.valueOnEmpty : this.props.minValue || 0;
	        }
	        this.setValue(value);
	      }
	      if (this.props.inputProps && this.props.inputProps.onBlur) {
	        this.props.inputProps.onBlur(event);
	      }
	      var onBlur = this.props.onBlur;
	      if (onBlur) {
	        onBlur(event);
	      }
	    }
	  }, {
	    key: "handleChange",
	    value: function handleChange(event) {
	      event.stopPropagation();
	      if (this.props.inputProps && this.props.inputProps.onChange) {
	        this.props.inputProps.onChange(event);
	      }
	      var value = event.target.value;
	      this.setValue(value);
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value) {
	      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        silent = _ref5.silent;
	      if (this.props.allowNegative && value === '-') {
	        this.setIntermediateValue(value);
	        return;
	      }
	      if (this.props.allowFloat && value === '.') {
	        this.setIntermediateValue(value);
	        return;
	      }
	      if (this.props.allowFloat && this.props.allowNegative && value === '-.') {
	        this.setIntermediateValue(value);
	        return;
	      }
	      var parseResult = parseFloat(value);
	      var parsedValue = isNaN(parseResult) ? null : (0, _clamp.default)(parseResult, this.props.minValue, this.props.maxValue);
	      var isSameRepresentation = parsedValue === null || "".concat(value) === parsedValue.toString();
	      if (!this.props.allowEmpty && parsedValue === null) {
	        this.setIntermediateValue(value || '');
	        return;
	      }
	      if (isSameRepresentation) {
	        this.setIntermediateValue(null);
	        this.onChange(parsedValue);
	      } else {
	        this.setIntermediateValue(value);
	      }
	    }
	  }, {
	    key: "setIntermediateValue",
	    value: function setIntermediateValue(intermediateValue, callback) {
	      if (intermediateValue === this.state.intermediateValue) {
	        return;
	      }
	      this.setState({
	        intermediateValue: intermediateValue
	      });
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(value) {
	      if (!isControlled(this.props)) {
	        this.setState({
	          value: value
	        });
	      }
	      var allowNegative = this.props.allowNegative;
	      var isPositive = checkPositive(value, {
	        allowNegative: allowNegative
	      });
	      if (!allowNegative && !isPositive) {
	        return;
	      }
	      if (this.props.onChange) {
	        this.props.onChange(value);
	      }
	    }
	  }, {
	    key: "handleBackspaceKeyDown",
	    value: function handleBackspaceKeyDown(event) {
	      var _this3 = this;
	      var _this$p5 = this.p,
	        isControlledPrecision = _this$p5.isControlledPrecision,
	        currentValue = _this$p5.currentValue,
	        decimalDelimiter = _this$p5.decimalDelimiter;
	      if (isControlledPrecision) {
	        var currentSelection = (0, _getSelectionRange.default)(this.input);
	        var decimalPosition = (0, _getTransformedStringValues2.getDecimalDelimiterPosition)(currentValue, decimalDelimiter);
	        if (currentSelection.end - 1 > decimalPosition) {
	          this.backspaceOnControlledPrecision = true;
	        }
	        if (currentSelection.end - 1 === decimalPosition) {
	          (0, _raf.default)(function () {
	            (0, _setCaretPosition.default)(_this3.input, currentSelection.end - 1);
	          });
	          event.preventDefault();
	          event.stopPropagation();
	        }
	      }
	    }
	  }, {
	    key: "handleDigitKeyDown",
	    value: function handleDigitKeyDown() {
	      var _this$p6 = this.p,
	        isControlledPrecision = _this$p6.isControlledPrecision,
	        currentValue = _this$p6.currentValue,
	        decimalDelimiter = _this$p6.decimalDelimiter;
	      if (isControlledPrecision) {
	        var currentSelection = (0, _getSelectionRange.default)(this.input);
	        var decimalPosition = (0, _getTransformedStringValues2.getDecimalDelimiterPosition)(currentValue, decimalDelimiter);
	        if (currentSelection.end > decimalPosition) {
	          this.digitInputOnControlledPrecision = currentSelection.end > decimalPosition;
	        }
	      }
	    }
	  }, {
	    key: "handleDecimalDelimiterKeyDown",
	    value: function handleDecimalDelimiterKeyDown(event) {
	      var _this$p7 = this.p,
	        allowFloat = _this$p7.allowFloat,
	        value = _this$p7.value;
	      if (!allowFloat) {
	        event.preventDefault();
	        return;
	      }
	      var selectedText = this.getSelectedText();
	      if (selectedText == '.') {
	        return;
	      }
	      if (isFloatString(selectedText)) {
	        return;
	      }
	      if (isFloatString(value)) {
	        event.preventDefault();
	        return;
	      }
	    }
	  }, {
	    key: "getSelectedText",
	    value: function getSelectedText() {
	      var _getSelectedRange = (0, _getSelectionRange.default)(this.input),
	        start = _getSelectedRange.start,
	        end = _getSelectedRange.end;
	      var value = "".concat(this.getValue());
	      return value.substring(start, end);
	    }
	  }, {
	    key: "handleSelectionOverDecimalDelimiter",
	    value: function handleSelectionOverDecimalDelimiter(event, currentSelection) {
	      var _this$p8 = this.p,
	        decimalDelimiter = _this$p8.decimalDelimiter,
	        currentValue = _this$p8.currentValue,
	        isControlledPrecision = _this$p8.isControlledPrecision,
	        prefix = _this$p8.prefix,
	        suffix = _this$p8.suffix;
	      currentSelection = currentSelection || (0, _getSelectionRange.default)(this.input);
	      var selectionStartsAtBeginningOfNumber = currentSelection.start === 0;
	      if (prefix) {
	        selectionStartsAtBeginningOfNumber = currentSelection.start <= prefix.length + 1;
	      }
	      var selectionEndsAtEndOfNumber = currentSelection.end === currentValue.length;
	      if (suffix) {
	        selectionEndsAtEndOfNumber = currentSelection.end >= suffix.length + 1;
	      }
	      if (selectionStartsAtBeginningOfNumber && selectionEndsAtEndOfNumber) {
	        return;
	      }
	    }
	  }, {
	    key: "handleKeyUp",
	    value: function handleKeyUp(event) {
	      var key = event.key;
	      if (this.props.inputProps && this.props.inputProps.onKeyUp) {
	        this.props.inputProps.onKeyUp(event);
	      }
	      var name = "handle".concat(toUpperFirst(key), "KeyUp");
	      if (this[name]) {
	        this[name](event);
	      }
	    }
	  }, {
	    key: "handleKeyDown",
	    value: function handleKeyDown(event) {
	      var key = event.key;
	      var _this$p9 = this.p,
	        decimalDelimiter = _this$p9.decimalDelimiter,
	        decimalDelimiterPosition = _this$p9.decimalDelimiterPosition;
	      if (this.props.inputProps && this.props.inputProps.onKeyDown) {
	        this.props.inputProps.onKeyDown(event);
	      }
	      if (this.props.onKeyDown) {
	        this.props.onKeyDown(event);
	      }
	      if (!key) {
	        return;
	      }
	      var currentSelection = (0, _getSelectionRange.default)(this.input);
	      if (selectionContainsPosition(currentSelection, decimalDelimiterPosition)) {
	        this.handleSelectionOverDecimalDelimiter(event, currentSelection);
	      }
	      if (key.match(/[0-9]/)) {
	        this.handleDigitKeyDown(event);
	        return;
	      }
	      if (key === decimalDelimiter) {
	        this.handleDecimalDelimiterKeyDown(event);
	        return;
	      }
	      if (key === '-') {
	        var caretPos = this.getSelectionStart();
	        if (!this.props.allowNegative || caretPos) {
	          event.preventDefault();
	        }
	        return;
	      }
	      var isPrintableCharacter = key.length == 1;
	      if (isPrintableCharacter && !(event.metaKey || event.ctrlKey)) {
	        event.preventDefault();
	      }
	      var name = "handle".concat(toUpperFirst(key), "KeyDown");
	      if (this[name]) {
	        this[name](event);
	      }
	    }
	  }, {
	    key: "handleArrowDownKeyDown",
	    value: function handleArrowDownKeyDown(event) {
	      this.handleArrowKeySpin(-1, event);
	    }
	  }, {
	    key: "handleArrowUpKeyDown",
	    value: function handleArrowUpKeyDown(event) {
	      this.handleArrowKeySpin(1, event);
	    }
	  }, {
	    key: "handleArrowKeySpin",
	    value: function handleArrowKeySpin(direction, event) {
	      var _this4 = this;
	      if (this.isSpinning()) {
	        event.preventDefault();
	        event.stopPropagation();
	        return;
	      }
	      if (this.props.spinOnArrowKeys) {
	        event.preventDefault();
	        event.stopPropagation();
	        if (!this.isSpinning()) {
	          var config = {
	            shiftKey: event.shiftKey,
	            event: event
	          };
	          this.stepTo(direction, config);
	          this.spinTimeoutId = setTimeout(function () {
	            _this4.startSpin(direction, config);
	          }, 120);
	        }
	      }
	    }
	  }, {
	    key: "handleArrowUpKeyUp",
	    value: function handleArrowUpKeyUp() {
	      this.onSpinKeyUp();
	    }
	  }, {
	    key: "handleArrowDownKeyUp",
	    value: function handleArrowDownKeyUp() {
	      this.onSpinKeyUp();
	    }
	  }, {
	    key: "onSpinKeyUp",
	    value: function onSpinKeyUp() {
	      this.props.spinOnArrowKeys && this.stopSpin();
	    }
	  }, {
	    key: "getInput",
	    value: function getInput() {
	      return this.input;
	    }
	  }, {
	    key: "getNumericValue",
	    value: function getNumericValue() {
	      return this.p.numericValue;
	    }
	  }, {
	    key: "getValue",
	    value: function getValue() {
	      return this.p.value;
	    }
	  }, {
	    key: "isFocused",
	    value: function isFocused() {
	      return !!this.state.focused;
	    }
	  }, {
	    key: "getStepValue",
	    value: function getStepValue(props, direction, config) {
	      config = config || {};
	      var value = this.p.value;
	      var stepValue = config.step || props.step;
	      if (this.state.shiftKey || config.shiftKey && props.shiftStep) {
	        stepValue = props.shiftStep;
	      }
	      var theValue = isNumeric(this.p.value) ? value * 1 + direction * stepValue : this.props.initialStep || 0;
	      return (0, _clamp.default)(Math.round(theValue * 1000) / 1000, this.props.minValue, this.props.maxValue);
	    }
	  }, {
	    key: "stepTo",
	    value: function stepTo(direction, config) {
	      config = config || {};
	      this.stepToTriggered = true;
	      var props = this.props;
	      var step = config.step || props.step;
	      var allowNegative = props.allowNegative;
	      if (step != null) {
	        var stepFn = typeof props.stepFn === 'function' ? props.stepFn : this.getStepValue;
	        var value = stepFn(props, direction, config);
	        var isPositive = checkPositive(value, {
	          allowNegative: allowNegative
	        });
	        if (!allowNegative && !isPositive) {
	          return;
	        }
	        this.spinValue = value;
	        if (config.triggerChangeOnSpin) {
	          if (props.triggerChangeOnSpinDelay > 0) {
	            this.setIntermediateValue(value);
	          }
	          this.setValueOnSpin(value);
	        } else {
	          this.setIntermediateValue(value);
	        }
	      }
	    }
	  }, {
	    key: "setValueOnSpin",
	    value: function setValueOnSpin(value) {
	      this.setValue(value);
	    }
	  }, {
	    key: "stopSpin",
	    value: function stopSpin() {
	      clearTimeout(this.spinTimeoutId);
	      clearTimeout(this.handleArrowDownTimeoutId);
	      clearInterval(this.spinIntervalId);
	      this.setValue(this.spinValue);
	      this.handleArrowDownTimeoutId = null;
	      this.spinTimeoutId = null;
	      this.spinIntervalId = null;
	    }
	  }, {
	    key: "startSpin",
	    value: function startSpin(direction, config) {
	      if (this.spinIntervalId) {
	        clearInterval(this.spinIntervalId);
	      }
	      this.stepToTriggered = false;
	      this.spinValue = this.getValue();
	      var stepTo = this.stepTo.bind(this, direction, _objectSpread({
	        triggerChangeOnSpin: this.props.triggerChangeOnSpin
	      }, config));
	      this.spinIntervalId = setInterval(stepTo, this.props.stepDelay);
	    }
	  }, {
	    key: "isSpinning",
	    value: function isSpinning() {
	      return this.spinIntervalId != null;
	    }
	  }, {
	    key: "handleWheel",
	    value: function handleWheel(event) {
	      var props = this.props;
	      if ((props.requireFocusOnStep && this.isFocused() || !props.requireFocusOnStep) && props.stepOnWheel && props.step) {
	        event.preventDefault();
	        var nativeEvent = event.nativeEvent;
	        var y = nativeEvent.wheelDeltaY || nativeEvent.wheelDelta || -nativeEvent.deltaY;
	        y = y < 0 ? -1 : 1;
	        this.stepTo(y, {
	          shiftKey: event.shiftKey,
	          event: event
	        });
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "getSelectionStart",
	    value: function getSelectionStart() {
	      return (0, _getSelectionStart2.default)(this.input);
	    }
	  }, {
	    key: "getProps",
	    value: function getProps(props, state) {
	      props = props || this.props;
	      state = state || this.state;
	      var suffix = getSuffix(props);
	      var prefix = getPrefix(props);
	      var currentValue = getCurrentValue(_objectSpread(_objectSpread({}, props), {}, {
	        suffix: suffix,
	        prefix: prefix
	      }), state);
	      var decimalDelimiter = (0, _getDecimalDelimiter.default)(props.locale);
	      var decimalDelimiterPosition = (0, _getTransformedStringValues2.getDecimalDelimiterPosition)(currentValue, decimalDelimiter);
	      var className = (0, _join.default)(props.rootClassName, props.theme && "".concat(props.rootClassName, "--theme-").concat(props.theme), "".concat(props.rootClassName, "--").concat(props.rtl ? 'rtl' : 'ltr'), props.disabled && "".concat(props.rootClassName, "--disabled"), state.focused && "".concat(props.rootClassName, "--focused"), props.enableSpinnerTools && "".concat(props.rootClassName, "--enable-spinner-tools"), props.enableClearButton && "".concat(props.rootClassName, "--enable-clear-button"), props.className);
	      var controlled = isControlled(props);
	      var value = controlled ? props.value : state.value;
	      if (state.intermediateValue !== null) {
	        value = state.intermediateValue;
	      }
	      var numericValue = Number(value);
	      var p = _objectSpread(_objectSpread({}, props), {}, {
	        className: className,
	        isControlled: controlled,
	        isControlledPrecision: isControlledPrecision(props),
	        value: value,
	        numericValue: numericValue,
	        currentValue: currentValue,
	        suffix: suffix,
	        prefix: prefix,
	        decimalDelimiter: decimalDelimiter,
	        decimalDelimiterPosition: decimalDelimiterPosition
	      });
	      p.formattedValue = getFormatedValue(value, p);
	      return p;
	    }
	  }]);
	  return InovuaNumericInput;
	}(_react.Component);
	InovuaNumericInput.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-numeric-input',
	  spinOnArrowKeys: true,
	  numbersOnly: true,
	  step: 1,
	  shiftStep: 10,
	  requireFocusOnStep: true,
	  stepOnWheel: true,
	  allowNegative: true,
	  allowFloat: true,
	  triggerChangeOnSpin: true,
	  triggerChangeOnSpinDelay: 80,
	  stepDelay: 60,
	  prefix: '',
	  suffix: '',
	  theme: 'default-light',
	  format: 'number',
	  currencyPosition: 'end',
	  enableSpinnerTools: true,
	  enableClearButton: true,
	  acceptClearToolFocus: false,
	  allowEmpty: true,
	  toolPosition: 'end',
	  arrowSize: 10,
	  clearButtonSize: 10,
	  inputProps: {}
	};
	InovuaNumericInput.propTypes = {
	  rootClassName: _propTypes.default.string,
	  stepDelay: _propTypes.default.number,
	  step: _propTypes.default.number,
	  initialStep: _propTypes.default.number,
	  valueOnEmpty: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  minValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  maxValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  onChange: _propTypes.default.func,
	  triggerChangeOnSpin: _propTypes.default.bool,
	  allowEmpty: _propTypes.default.bool,
	  allowFloat: _propTypes.default.bool,
	  requireFocusOnStep: _propTypes.default.bool,
	  spinOnArrowKeys: _propTypes.default.bool,
	  numbersOnly: _propTypes.default.bool,
	  shiftStep: _propTypes.default.number,
	  stepOnWheel: _propTypes.default.bool,
	  allowNegative: _propTypes.default.bool,
	  precision: _propTypes.default.number,
	  format: _propTypes.default.oneOf(['currency', 'number', 'percentage']),
	  locale: _propTypes.default.string,
	  prefix: _propTypes.default.string,
	  suffix: _propTypes.default.string,
	  theme: _propTypes.default.string,
	  arrowColor: _propTypes.default.string,
	  arrowStyle: _propTypes.default.object,
	  currencySymbol: _propTypes.default.string,
	  currencyPosition: _propTypes.default.oneOf(['start', 'end']),
	  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  wrapperProps: _propTypes.default.object,
	  disabled: _propTypes.default.bool,
	  acceptClearToolFocus: _propTypes.default.bool,
	  renderClearIcon: _propTypes.default.func,
	  clearButtonSize: _propTypes.default.number,
	  clearButtonColor: _propTypes.default.string,
	  clearButtonStyle: _propTypes.default.object,
	  clearButtonClassName: _propTypes.default.string,
	  enableSpinnerTools: _propTypes.default.bool,
	  enableClearButton: _propTypes.default.bool,
	  toolPosition: _propTypes.default.oneOf(['start', 'end']),
	  arrowSize: _propTypes.default.number,
	  arrowDownStyle: _propTypes.default.object,
	  arrowUpStyle: _propTypes.default.object,
	  inputProps: _propTypes.default.object,
	  rtl: _propTypes.default.bool
	};
	globalObject.isNumeric = isNumeric;
	var _default = InovuaNumericInput;
	exports.default = _default;

/***/ },
/* 711 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = [{
	  name: 'Afghanistan',
	  code: 'AF'
	}, {
	  name: 'Åland Islands',
	  code: 'AX'
	}, {
	  name: 'Albania',
	  code: 'AL'
	}, {
	  name: 'Algeria',
	  code: 'DZ'
	}, {
	  name: 'American Samoa',
	  code: 'AS'
	}, {
	  name: 'AndorrA',
	  code: 'AD'
	}, {
	  name: 'Angola',
	  code: 'AO'
	}, {
	  name: 'Anguilla',
	  code: 'AI'
	}, {
	  name: 'Antarctica',
	  code: 'AQ'
	}, {
	  name: 'Antigua and Barbuda',
	  code: 'AG'
	}, {
	  name: 'Argentina',
	  code: 'AR'
	}, {
	  name: 'Armenia',
	  code: 'AM'
	}, {
	  name: 'Aruba',
	  code: 'AW'
	}, {
	  name: 'Australia',
	  code: 'AU'
	}, {
	  name: 'Austria',
	  code: 'AT'
	}, {
	  name: 'Azerbaijan',
	  code: 'AZ'
	}, {
	  name: 'Bahamas',
	  code: 'BS'
	}, {
	  name: 'Bahrain',
	  code: 'BH'
	}, {
	  name: 'Bangladesh',
	  code: 'BD'
	}, {
	  name: 'Barbados',
	  code: 'BB'
	}, {
	  name: 'Belarus',
	  code: 'BY'
	}, {
	  name: 'Belgium',
	  code: 'BE'
	}, {
	  name: 'Belize',
	  code: 'BZ'
	}, {
	  name: 'Benin',
	  code: 'BJ'
	}, {
	  name: 'Bermuda',
	  code: 'BM'
	}, {
	  name: 'Bhutan',
	  code: 'BT'
	}, {
	  name: 'Bolivia',
	  code: 'BO'
	}, {
	  name: 'Bosnia and Herzegovina',
	  code: 'BA'
	}, {
	  name: 'Botswana',
	  code: 'BW'
	}, {
	  name: 'Bouvet Island',
	  code: 'BV'
	}, {
	  name: 'Brazil',
	  code: 'BR'
	}, {
	  name: 'British Indian Ocean Territory',
	  code: 'IO'
	}, {
	  name: 'Brunei Darussalam',
	  code: 'BN'
	}, {
	  name: 'Bulgaria',
	  code: 'BG'
	}, {
	  name: 'Burkina Faso',
	  code: 'BF'
	}, {
	  name: 'Burundi',
	  code: 'BI'
	}, {
	  name: 'Cambodia',
	  code: 'KH'
	}, {
	  name: 'Cameroon',
	  code: 'CM'
	}, {
	  name: 'Canada',
	  code: 'CA'
	}, {
	  name: 'Cape Verde',
	  code: 'CV'
	}, {
	  name: 'Cayman Islands',
	  code: 'KY'
	}, {
	  name: 'Central African Republic',
	  code: 'CF'
	}, {
	  name: 'Chad',
	  code: 'TD'
	}, {
	  name: 'Chile',
	  code: 'CL'
	}, {
	  name: 'China',
	  code: 'CN'
	}, {
	  name: 'Christmas Island',
	  code: 'CX'
	}, {
	  name: 'Cocos (Keeling) Islands',
	  code: 'CC'
	}, {
	  name: 'Colombia',
	  code: 'CO'
	}, {
	  name: 'Comoros',
	  code: 'KM'
	}, {
	  name: 'Congo',
	  code: 'CG'
	}, {
	  name: 'Congo, The Democratic Republic of the',
	  code: 'CD'
	}, {
	  name: 'Cook Islands',
	  code: 'CK'
	}, {
	  name: 'Costa Rica',
	  code: 'CR'
	}, {
	  name: 'Cote D"Ivoire',
	  code: 'CI'
	}, {
	  name: 'Croatia',
	  code: 'HR'
	}, {
	  name: 'Cuba',
	  code: 'CU'
	}, {
	  name: 'Cyprus',
	  code: 'CY'
	}, {
	  name: 'Czech Republic',
	  code: 'CZ'
	}, {
	  name: 'Denmark',
	  code: 'DK'
	}, {
	  name: 'Djibouti',
	  code: 'DJ'
	}, {
	  name: 'Dominica',
	  code: 'DM'
	}, {
	  name: 'Dominican Republic',
	  code: 'DO'
	}, {
	  name: 'Ecuador',
	  code: 'EC'
	}, {
	  name: 'Egypt',
	  code: 'EG'
	}, {
	  name: 'El Salvador',
	  code: 'SV'
	}, {
	  name: 'Equatorial Guinea',
	  code: 'GQ'
	}, {
	  name: 'Eritrea',
	  code: 'ER'
	}, {
	  name: 'Estonia',
	  code: 'EE'
	}, {
	  name: 'Ethiopia',
	  code: 'ET'
	}, {
	  name: 'Falkland Islands (Malvinas)',
	  code: 'FK'
	}, {
	  name: 'Faroe Islands',
	  code: 'FO'
	}, {
	  name: 'Fiji',
	  code: 'FJ'
	}, {
	  name: 'Finland',
	  code: 'FI'
	}, {
	  name: 'France',
	  code: 'FR'
	}, {
	  name: 'French Guiana',
	  code: 'GF'
	}, {
	  name: 'French Polynesia',
	  code: 'PF'
	}, {
	  name: 'French Southern Territories',
	  code: 'TF'
	}, {
	  name: 'Gabon',
	  code: 'GA'
	}, {
	  name: 'Gambia',
	  code: 'GM'
	}, {
	  name: 'Georgia',
	  code: 'GE'
	}, {
	  name: 'Germany',
	  code: 'DE'
	}, {
	  name: 'Ghana',
	  code: 'GH'
	}, {
	  name: 'Gibraltar',
	  code: 'GI'
	}, {
	  name: 'Greece',
	  code: 'GR'
	}, {
	  name: 'Greenland',
	  code: 'GL'
	}, {
	  name: 'Grenada',
	  code: 'GD'
	}, {
	  name: 'Guadeloupe',
	  code: 'GP'
	}, {
	  name: 'Guam',
	  code: 'GU'
	}, {
	  name: 'Guatemala',
	  code: 'GT'
	}, {
	  name: 'Guernsey',
	  code: 'GG'
	}, {
	  name: 'Guinea',
	  code: 'GN'
	}, {
	  name: 'Guinea-Bissau',
	  code: 'GW'
	}, {
	  name: 'Guyana',
	  code: 'GY'
	}, {
	  name: 'Haiti',
	  code: 'HT'
	}, {
	  name: 'Heard Island and Mcdonald Islands',
	  code: 'HM'
	}, {
	  name: 'Holy See (Vatican City State)',
	  code: 'VA'
	}, {
	  name: 'Honduras',
	  code: 'HN'
	}, {
	  name: 'Hong Kong',
	  code: 'HK'
	}, {
	  name: 'Hungary',
	  code: 'HU'
	}, {
	  name: 'Iceland',
	  code: 'IS'
	}, {
	  name: 'India',
	  code: 'IN'
	}, {
	  name: 'Indonesia',
	  code: 'ID'
	}, {
	  name: 'Iran, Islamic Republic Of',
	  code: 'IR'
	}, {
	  name: 'Iraq',
	  code: 'IQ'
	}, {
	  name: 'Ireland',
	  code: 'IE'
	}, {
	  name: 'Isle of Man',
	  code: 'IM'
	}, {
	  name: 'Israel',
	  code: 'IL'
	}, {
	  name: 'Italy',
	  code: 'IT'
	}, {
	  name: 'Jamaica',
	  code: 'JM'
	}, {
	  name: 'Japan',
	  code: 'JP'
	}, {
	  name: 'Jersey',
	  code: 'JE'
	}, {
	  name: 'Jordan',
	  code: 'JO'
	}, {
	  name: 'Kazakhstan',
	  code: 'KZ'
	}, {
	  name: 'Kenya',
	  code: 'KE'
	}, {
	  name: 'Kiribati',
	  code: 'KI'
	}, {
	  name: 'Korea, Democratic People"S Republic of',
	  code: 'KP'
	}, {
	  name: 'Korea, Republic of',
	  code: 'KR'
	}, {
	  name: 'Kuwait',
	  code: 'KW'
	}, {
	  name: 'Kyrgyzstan',
	  code: 'KG'
	}, {
	  name: 'Lao People"S Democratic Republic',
	  code: 'LA'
	}, {
	  name: 'Latvia',
	  code: 'LV'
	}, {
	  name: 'Lebanon',
	  code: 'LB'
	}, {
	  name: 'Lesotho',
	  code: 'LS'
	}, {
	  name: 'Liberia',
	  code: 'LR'
	}, {
	  name: 'Libyan Arab Jamahiriya',
	  code: 'LY'
	}, {
	  name: 'Liechtenstein',
	  code: 'LI'
	}, {
	  name: 'Lithuania',
	  code: 'LT'
	}, {
	  name: 'Luxembourg',
	  code: 'LU'
	}, {
	  name: 'Macao',
	  code: 'MO'
	}, {
	  name: 'Macedonia, The Former Yugoslav Republic of',
	  code: 'MK'
	}, {
	  name: 'Madagascar',
	  code: 'MG'
	}, {
	  name: 'Malawi',
	  code: 'MW'
	}, {
	  name: 'Malaysia',
	  code: 'MY'
	}, {
	  name: 'Maldives',
	  code: 'MV'
	}, {
	  name: 'Mali',
	  code: 'ML'
	}, {
	  name: 'Malta',
	  code: 'MT'
	}, {
	  name: 'Marshall Islands',
	  code: 'MH'
	}, {
	  name: 'Martinique',
	  code: 'MQ'
	}, {
	  name: 'Mauritania',
	  code: 'MR'
	}, {
	  name: 'Mauritius',
	  code: 'MU'
	}, {
	  name: 'Mayotte',
	  code: 'YT'
	}, {
	  name: 'Mexico',
	  code: 'MX'
	}, {
	  name: 'Micronesia, Federated States of',
	  code: 'FM'
	}, {
	  name: 'Moldova, Republic of',
	  code: 'MD'
	}, {
	  name: 'Monaco',
	  code: 'MC'
	}, {
	  name: 'Mongolia',
	  code: 'MN'
	}, {
	  name: 'Montserrat',
	  code: 'MS'
	}, {
	  name: 'Morocco',
	  code: 'MA'
	}, {
	  name: 'Mozambique',
	  code: 'MZ'
	}, {
	  name: 'Myanmar',
	  code: 'MM'
	}, {
	  name: 'Namibia',
	  code: 'NA'
	}, {
	  name: 'Nauru',
	  code: 'NR'
	}, {
	  name: 'Nepal',
	  code: 'NP'
	}, {
	  name: 'Netherlands',
	  code: 'NL'
	}, {
	  name: 'Netherlands Antilles',
	  code: 'AN'
	}, {
	  name: 'New Caledonia',
	  code: 'NC'
	}, {
	  name: 'New Zealand',
	  code: 'NZ'
	}, {
	  name: 'Nicaragua',
	  code: 'NI'
	}, {
	  name: 'Niger',
	  code: 'NE'
	}, {
	  name: 'Nigeria',
	  code: 'NG'
	}, {
	  name: 'Niue',
	  code: 'NU'
	}, {
	  name: 'Norfolk Island',
	  code: 'NF'
	}, {
	  name: 'Northern Mariana Islands',
	  code: 'MP'
	}, {
	  name: 'Norway',
	  code: 'NO'
	}, {
	  name: 'Oman',
	  code: 'OM'
	}, {
	  name: 'Pakistan',
	  code: 'PK'
	}, {
	  name: 'Palau',
	  code: 'PW'
	}, {
	  name: 'Palestinian Territory, Occupied',
	  code: 'PS'
	}, {
	  name: 'Panama',
	  code: 'PA'
	}, {
	  name: 'Papua New Guinea',
	  code: 'PG'
	}, {
	  name: 'Paraguay',
	  code: 'PY'
	}, {
	  name: 'Peru',
	  code: 'PE'
	}, {
	  name: 'Philippines',
	  code: 'PH'
	}, {
	  name: 'Pitcairn',
	  code: 'PN'
	}, {
	  name: 'Poland',
	  code: 'PL'
	}, {
	  name: 'Portugal',
	  code: 'PT'
	}, {
	  name: 'Puerto Rico',
	  code: 'PR'
	}, {
	  name: 'Qatar',
	  code: 'QA'
	}, {
	  name: 'Reunion',
	  code: 'RE'
	}, {
	  name: 'Romania',
	  code: 'RO'
	}, {
	  name: 'Russian Federation',
	  code: 'RU'
	}, {
	  name: 'RWANDA',
	  code: 'RW'
	}, {
	  name: 'Saint Helena',
	  code: 'SH'
	}, {
	  name: 'Saint Kitts and Nevis',
	  code: 'KN'
	}, {
	  name: 'Saint Lucia',
	  code: 'LC'
	}, {
	  name: 'Saint Pierre and Miquelon',
	  code: 'PM'
	}, {
	  name: 'Saint Vincent and the Grenadines',
	  code: 'VC'
	}, {
	  name: 'Samoa',
	  code: 'WS'
	}, {
	  name: 'San Marino',
	  code: 'SM'
	}, {
	  name: 'Sao Tome and Principe',
	  code: 'ST'
	}, {
	  name: 'Saudi Arabia',
	  code: 'SA'
	}, {
	  name: 'Senegal',
	  code: 'SN'
	}, {
	  name: 'Serbia and Montenegro',
	  code: 'CS'
	}, {
	  name: 'Seychelles',
	  code: 'SC'
	}, {
	  name: 'Sierra Leone',
	  code: 'SL'
	}, {
	  name: 'Singapore',
	  code: 'SG'
	}, {
	  name: 'Slovakia',
	  code: 'SK'
	}, {
	  name: 'Slovenia',
	  code: 'SI'
	}, {
	  name: 'Solomon Islands',
	  code: 'SB'
	}, {
	  name: 'Somalia',
	  code: 'SO'
	}, {
	  name: 'South Africa',
	  code: 'ZA'
	}, {
	  name: 'South Georgia and the South Sandwich Islands',
	  code: 'GS'
	}, {
	  name: 'Spain',
	  code: 'ES'
	}, {
	  name: 'Sri Lanka',
	  code: 'LK'
	}, {
	  name: 'Sudan',
	  code: 'SD'
	}, {
	  name: 'Suriname',
	  code: 'SR'
	}, {
	  name: 'Svalbard and Jan Mayen',
	  code: 'SJ'
	}, {
	  name: 'Swaziland',
	  code: 'SZ'
	}, {
	  name: 'Sweden',
	  code: 'SE'
	}, {
	  name: 'Switzerland',
	  code: 'CH'
	}, {
	  name: 'Syrian Arab Republic',
	  code: 'SY'
	}, {
	  name: 'Taiwan, Province of China',
	  code: 'TW'
	}, {
	  name: 'Tajikistan',
	  code: 'TJ'
	}, {
	  name: 'Tanzania, United Republic of',
	  code: 'TZ'
	}, {
	  name: 'Thailand',
	  code: 'TH'
	}, {
	  name: 'Timor-Leste',
	  code: 'TL'
	}, {
	  name: 'Togo',
	  code: 'TG'
	}, {
	  name: 'Tokelau',
	  code: 'TK'
	}, {
	  name: 'Tonga',
	  code: 'TO'
	}, {
	  name: 'Trinidad and Tobago',
	  code: 'TT'
	}, {
	  name: 'Tunisia',
	  code: 'TN'
	}, {
	  name: 'Turkey',
	  code: 'TR'
	}, {
	  name: 'Turkmenistan',
	  code: 'TM'
	}, {
	  name: 'Turks and Caicos Islands',
	  code: 'TC'
	}, {
	  name: 'Tuvalu',
	  code: 'TV'
	}, {
	  name: 'Uganda',
	  code: 'UG'
	}, {
	  name: 'Ukraine',
	  code: 'UA'
	}, {
	  name: 'United Arab Emirates',
	  code: 'AE'
	}, {
	  name: 'United Kingdom',
	  code: 'GB'
	}, {
	  name: 'United States',
	  code: 'US'
	}, {
	  name: 'United States Minor Outlying Islands',
	  code: 'UM'
	}, {
	  name: 'Uruguay',
	  code: 'UY'
	}, {
	  name: 'Uzbekistan',
	  code: 'UZ'
	}, {
	  name: 'Vanuatu',
	  code: 'VU'
	}, {
	  name: 'Venezuela',
	  code: 'VE'
	}, {
	  name: 'Viet Nam',
	  code: 'VN'
	}, {
	  name: 'Virgin Islands, British',
	  code: 'VG'
	}, {
	  name: 'Virgin Islands, U.S.',
	  code: 'VI'
	}, {
	  name: 'Wallis and Futuna',
	  code: 'WF'
	}, {
	  name: 'Western Sahara',
	  code: 'EH'
	}, {
	  name: 'Yemen',
	  code: 'YE'
	}, {
	  name: 'Zambia',
	  code: 'ZM'
	}, {
	  name: 'Zimbabwe',
	  code: 'ZW'
	}];
	exports.default = _default;

/***/ },
/* 712 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = [{
	  code: 'AED',
	  number: '784',
	  digits: 2,
	  currency: 'United Arab Emirates dirham',
	  countries: ['united arab emirates']
	}, {
	  code: 'AFN',
	  number: '971',
	  digits: 2,
	  currency: 'Afghan afghani',
	  countries: ['afghanistan']
	}, {
	  code: 'ALL',
	  number: '008',
	  digits: 2,
	  currency: 'Albanian lek',
	  countries: ['albania']
	}, {
	  code: 'AMD',
	  number: '051',
	  digits: 2,
	  currency: 'Armenian dram',
	  countries: ['armenia']
	}, {
	  code: 'ANG',
	  number: '532',
	  digits: 2,
	  currency: 'Netherlands Antillean guilder',
	  countries: ['curaçao', 'sint maarten']
	}, {
	  code: 'AOA',
	  number: '973',
	  digits: 2,
	  currency: 'Angolan kwanza',
	  countries: ['angola']
	}, {
	  code: 'ARS',
	  number: '032',
	  digits: 2,
	  currency: 'Argentine peso',
	  countries: ['argentina']
	}, {
	  code: 'AUD',
	  number: '036',
	  digits: 2,
	  currency: 'Australian dollar',
	  countries: ['australia', 'australian antarctic territory', 'christmas island', 'cocos (keeling) islands', 'heard and mcdonald islands', 'kiribati', 'nauru', 'norfolk island', 'tuvalu']
	}, {
	  code: 'AWG',
	  number: '533',
	  digits: 2,
	  currency: 'Aruban florin',
	  countries: ['aruba']
	}, {
	  code: 'AZN',
	  number: '944',
	  digits: 2,
	  currency: 'Azerbaijani manat',
	  countries: ['azerbaijan']
	}, {
	  code: 'BAM',
	  number: '977',
	  digits: 2,
	  currency: 'Bosnia and Herzegovina convertible mark',
	  countries: ['bosnia and herzegovina']
	}, {
	  code: 'BBD',
	  number: '052',
	  digits: 2,
	  currency: 'Barbados dollar',
	  countries: ['barbados']
	}, {
	  code: 'BDT',
	  number: '050',
	  digits: 2,
	  currency: 'Bangladeshi taka',
	  countries: ['bangladesh']
	}, {
	  code: 'BGN',
	  number: '975',
	  digits: 2,
	  currency: 'Bulgarian lev',
	  countries: ['bulgaria']
	}, {
	  code: 'BHD',
	  number: '048',
	  digits: 3,
	  currency: 'Bahraini dinar',
	  countries: ['bahrain']
	}, {
	  code: 'BIF',
	  number: '108',
	  digits: 0,
	  currency: 'Burundian franc',
	  countries: ['burundi']
	}, {
	  code: 'BMD',
	  number: '060',
	  digits: 2,
	  currency: 'Bermudian dollar',
	  countries: ['bermuda']
	}, {
	  code: 'BND',
	  number: '096',
	  digits: 2,
	  currency: 'Brunei dollar',
	  countries: ['brunei', 'singapore']
	}, {
	  code: 'BOB',
	  number: '068',
	  digits: 2,
	  currency: 'Boliviano',
	  countries: ['bolivia']
	}, {
	  code: 'BOV',
	  number: '984',
	  digits: 2,
	  currency: 'Bolivian Mvdol (funds code)',
	  countries: ['bolivia']
	}, {
	  code: 'BRL',
	  number: '986',
	  digits: 2,
	  currency: 'Brazilian real',
	  countries: ['brazil']
	}, {
	  code: 'BSD',
	  number: '044',
	  digits: 2,
	  currency: 'Bahamian dollar',
	  countries: ['bahamas']
	}, {
	  code: 'BTN',
	  number: '064',
	  digits: 2,
	  currency: 'Bhutanese ngultrum',
	  countries: ['bhutan']
	}, {
	  code: 'BWP',
	  number: '072',
	  digits: 2,
	  currency: 'Botswana pula',
	  countries: ['botswana']
	}, {
	  code: 'BYR',
	  number: '974',
	  digits: 0,
	  currency: 'Belarusian ruble',
	  countries: ['belarus']
	}, {
	  code: 'BZD',
	  number: '084',
	  digits: 2,
	  currency: 'Belize dollar',
	  countries: ['belize']
	}, {
	  code: 'CAD',
	  number: '124',
	  digits: 2,
	  currency: 'Canadian dollar',
	  countries: ['canada', 'saint pierre and miquelon']
	}, {
	  code: 'CDF',
	  number: '976',
	  digits: 2,
	  currency: 'Congolese franc',
	  countries: ['democratic republic of congo']
	}, {
	  code: 'CHE',
	  number: '947',
	  digits: 2,
	  currency: 'WIR Euro (complementary currency)',
	  countries: ['switzerland']
	}, {
	  code: 'CHF',
	  number: '756',
	  digits: 2,
	  currency: 'Swiss franc',
	  countries: ['switzerland', 'liechtenstein']
	}, {
	  code: 'CHW',
	  number: '948',
	  digits: 2,
	  currency: 'WIR Franc (complementary currency)',
	  countries: ['switzerland']
	}, {
	  code: 'CLF',
	  number: '990',
	  digits: 0,
	  currency: 'Unidad de Fomento (funds code)',
	  countries: ['chile']
	}, {
	  code: 'CLP',
	  number: '152',
	  digits: 0,
	  currency: 'Chilean peso',
	  countries: ['chile']
	}, {
	  code: 'CNY',
	  number: '156',
	  digits: 2,
	  currency: 'Chinese yuan',
	  countries: ['china']
	}, {
	  code: 'COP',
	  number: '170',
	  digits: 2,
	  currency: 'Colombian peso',
	  countries: ['colombia']
	}, {
	  code: 'COU',
	  number: '970',
	  digits: 2,
	  currency: 'Unidad de Valor Real',
	  countries: ['colombia']
	}, {
	  code: 'CRC',
	  number: '188',
	  digits: 2,
	  currency: 'Costa Rican colon',
	  countries: ['costa rica']
	}, {
	  code: 'CUC',
	  number: '931',
	  digits: 2,
	  currency: 'Cuban convertible peso',
	  countries: ['cuba']
	}, {
	  code: 'CUP',
	  number: '192',
	  digits: 2,
	  currency: 'Cuban peso',
	  countries: ['cuba']
	}, {
	  code: 'CVE',
	  number: '132',
	  digits: 0,
	  currency: 'Cape Verde escudo',
	  countries: ['cape verde']
	}, {
	  code: 'CZK',
	  number: '203',
	  digits: 2,
	  currency: 'Czech koruna',
	  countries: ['czech republic']
	}, {
	  code: 'DJF',
	  number: '262',
	  digits: 0,
	  currency: 'Djiboutian franc',
	  countries: ['djibouti']
	}, {
	  code: 'DKK',
	  number: '208',
	  digits: 2,
	  currency: 'Danish krone',
	  countries: ['denmark', 'faroe islands', 'greenland']
	}, {
	  code: 'DOP',
	  number: '214',
	  digits: 2,
	  currency: 'Dominican peso',
	  countries: ['dominican republic']
	}, {
	  code: 'DZD',
	  number: '012',
	  digits: 2,
	  currency: 'Algerian dinar',
	  countries: ['algeria']
	}, {
	  code: 'EGP',
	  number: '818',
	  digits: 2,
	  currency: 'Egyptian pound',
	  countries: ['egypt', 'palestinian territories']
	}, {
	  code: 'ERN',
	  number: '232',
	  digits: 2,
	  currency: 'Eritrean nakfa',
	  countries: ['eritrea']
	}, {
	  code: 'ETB',
	  number: '230',
	  digits: 2,
	  currency: 'Ethiopian birr',
	  countries: ['ethiopia']
	}, {
	  code: 'EUR',
	  number: '978',
	  digits: 2,
	  currency: 'Euro',
	  countries: ['andorra', 'austria', 'belgium', 'cyprus', 'estonia', 'finland', 'france', 'germany', 'greece', 'ireland', 'italy', 'kosovo', 'luxembourg', 'malta', 'monaco', 'montenegro', 'netherlands', 'portugal', 'san marino', 'slovakia', 'slovenia', 'spain', 'vatican city']
	}, {
	  code: 'FJD',
	  number: '242',
	  digits: 2,
	  currency: 'Fiji dollar',
	  countries: ['fiji']
	}, {
	  code: 'FKP',
	  number: '238',
	  digits: 2,
	  currency: 'Falkland Islands pound',
	  countries: ['falkland islands']
	}, {
	  code: 'GBP',
	  number: '826',
	  digits: 2,
	  currency: 'Pound sterling',
	  countries: ['united kingdom', 'british crown dependencies (the  isle of man and the channel islands)', 'south georgia and the south sandwich islands', 'british antarctic territory', 'british indian ocean territory']
	}, {
	  code: 'GEL',
	  number: '981',
	  digits: 2,
	  currency: 'Georgian lari',
	  countries: ['georgia']
	}, {
	  code: 'GHS',
	  number: '936',
	  digits: 2,
	  currency: 'Ghanaian cedi',
	  countries: ['ghana']
	}, {
	  code: 'GIP',
	  number: '292',
	  digits: 2,
	  currency: 'Gibraltar pound',
	  countries: ['gibraltar']
	}, {
	  code: 'GMD',
	  number: '270',
	  digits: 2,
	  currency: 'Gambian dalasi',
	  countries: ['gambia']
	}, {
	  code: 'GNF',
	  number: '324',
	  digits: 0,
	  currency: 'Guinean franc',
	  countries: ['guinea']
	}, {
	  code: 'GTQ',
	  number: '320',
	  digits: 2,
	  currency: 'Guatemalan quetzal',
	  countries: ['guatemala']
	}, {
	  code: 'GYD',
	  number: '328',
	  digits: 2,
	  currency: 'Guyanese dollar',
	  countries: ['guyana']
	}, {
	  code: 'HKD',
	  number: '344',
	  digits: 2,
	  currency: 'Hong Kong dollar',
	  countries: ['hong kong', 'macao']
	}, {
	  code: 'HNL',
	  number: '340',
	  digits: 2,
	  currency: 'Honduran lempira',
	  countries: ['honduras']
	}, {
	  code: 'HRK',
	  number: '191',
	  digits: 2,
	  currency: 'Croatian kuna',
	  countries: ['croatia']
	}, {
	  code: 'HTG',
	  number: '332',
	  digits: 2,
	  currency: 'Haitian gourde',
	  countries: ['haiti']
	}, {
	  code: 'HUF',
	  number: '348',
	  digits: 2,
	  currency: 'Hungarian forint',
	  countries: ['hungary']
	}, {
	  code: 'IDR',
	  number: '360',
	  digits: 0,
	  currency: 'Indonesian rupiah',
	  countries: ['indonesia']
	}, {
	  code: 'ILS',
	  number: '376',
	  digits: 2,
	  currency: 'Israeli new shekel',
	  countries: ['israel', 'palestinian territories']
	}, {
	  code: 'INR',
	  number: '356',
	  digits: 2,
	  currency: 'Indian rupee',
	  countries: ['india']
	}, {
	  code: 'IQD',
	  number: '368',
	  digits: 3,
	  currency: 'Iraqi dinar',
	  countries: ['iraq']
	}, {
	  code: 'IRR',
	  number: '364',
	  digits: 0,
	  currency: 'Iranian rial',
	  countries: ['iran']
	}, {
	  code: 'ISK',
	  number: '352',
	  digits: 0,
	  currency: 'Icelandic króna',
	  countries: ['iceland']
	}, {
	  code: 'JMD',
	  number: '388',
	  digits: 2,
	  currency: 'Jamaican dollar',
	  countries: ['jamaica']
	}, {
	  code: 'JOD',
	  number: '400',
	  digits: 3,
	  currency: 'Jordanian dinar',
	  countries: ['jordan']
	}, {
	  code: 'JPY',
	  number: '392',
	  digits: 0,
	  currency: 'Japanese yen',
	  countries: ['japan']
	}, {
	  code: 'KES',
	  number: '404',
	  digits: 2,
	  currency: 'Kenyan shilling',
	  countries: ['kenya']
	}, {
	  code: 'KGS',
	  number: '417',
	  digits: 2,
	  currency: 'Kyrgyzstani som',
	  countries: ['kyrgyzstan']
	}, {
	  code: 'KHR',
	  number: '116',
	  digits: 2,
	  currency: 'Cambodian riel',
	  countries: ['cambodia']
	}, {
	  code: 'KMF',
	  number: '174',
	  digits: 0,
	  currency: 'Comoro franc',
	  countries: ['comoros']
	}, {
	  code: 'KPW',
	  number: '408',
	  digits: 0,
	  currency: 'North Korean won',
	  countries: ['north korea']
	}, {
	  code: 'KRW',
	  number: '410',
	  digits: 0,
	  currency: 'South Korean won',
	  countries: ['south korea']
	}, {
	  code: 'KWD',
	  number: '414',
	  digits: 3,
	  currency: 'Kuwaiti dinar',
	  countries: ['kuwait']
	}, {
	  code: 'KYD',
	  number: '136',
	  digits: 2,
	  currency: 'Cayman Islands dollar',
	  countries: ['cayman islands']
	}, {
	  code: 'KZT',
	  number: '398',
	  digits: 2,
	  currency: 'Kazakhstani tenge',
	  countries: ['kazakhstan']
	}, {
	  code: 'LAK',
	  number: '418',
	  digits: 0,
	  currency: 'Lao kip',
	  countries: ['laos']
	}, {
	  code: 'LBP',
	  number: '422',
	  digits: 0,
	  currency: 'Lebanese pound',
	  countries: ['lebanon']
	}, {
	  code: 'LKR',
	  number: '144',
	  digits: 2,
	  currency: 'Sri Lankan rupee',
	  countries: ['sri lanka']
	}, {
	  code: 'LRD',
	  number: '430',
	  digits: 2,
	  currency: 'Liberian dollar',
	  countries: ['liberia']
	}, {
	  code: 'LSL',
	  number: '426',
	  digits: 2,
	  currency: 'Lesotho loti',
	  countries: ['lesotho']
	}, {
	  code: 'LTL',
	  number: '440',
	  digits: 2,
	  currency: 'Lithuanian litas',
	  countries: ['lithuania']
	}, {
	  code: 'LVL',
	  number: '428',
	  digits: 2,
	  currency: 'Latvian lats',
	  countries: ['latvia']
	}, {
	  code: 'LYD',
	  number: '434',
	  digits: 3,
	  currency: 'Libyan dinar',
	  countries: ['libya']
	}, {
	  code: 'MAD',
	  number: '504',
	  digits: 2,
	  currency: 'Moroccan dirham',
	  countries: ['morocco']
	}, {
	  code: 'MDL',
	  number: '498',
	  digits: 2,
	  currency: 'Moldovan leu',
	  countries: ['moldova (except  transnistria)']
	}, {
	  code: 'MGA',
	  number: '969',
	  digits: 0,
	  currency: '*[8]	Malagasy ariary',
	  countries: ['madagascar']
	}, {
	  code: 'MKD',
	  number: '807',
	  digits: 0,
	  currency: 'Macedonian denar',
	  countries: ['macedonia']
	}, {
	  code: 'MMK',
	  number: '104',
	  digits: 0,
	  currency: 'Myanma kyat',
	  countries: ['myanmar']
	}, {
	  code: 'MNT',
	  number: '496',
	  digits: 2,
	  currency: 'Mongolian tugrik',
	  countries: ['mongolia']
	}, {
	  code: 'MOP',
	  number: '446',
	  digits: 2,
	  currency: 'Macanese pataca',
	  countries: ['macao']
	}, {
	  code: 'MRO',
	  number: '478',
	  digits: 0,
	  currency: '*[8]	Mauritanian ouguiya',
	  countries: ['mauritania']
	}, {
	  code: 'MUR',
	  number: '480',
	  digits: 2,
	  currency: 'Mauritian rupee',
	  countries: ['mauritius']
	}, {
	  code: 'MVR',
	  number: '462',
	  digits: 2,
	  currency: 'Maldivian rufiyaa',
	  countries: ['maldives']
	}, {
	  code: 'MWK',
	  number: '454',
	  digits: 2,
	  currency: 'Malawian kwacha',
	  countries: ['malawi']
	}, {
	  code: 'MXN',
	  number: '484',
	  digits: 2,
	  currency: 'Mexican peso',
	  countries: ['mexico']
	}, {
	  code: 'MXV',
	  number: '979',
	  digits: 2,
	  currency: 'Mexican Unidad de Inversion (UDI) (funds code)',
	  countries: ['mexico']
	}, {
	  code: 'MYR',
	  number: '458',
	  digits: 2,
	  currency: 'Malaysian ringgit',
	  countries: ['malaysia']
	}, {
	  code: 'MZN',
	  number: '943',
	  digits: 2,
	  currency: 'Mozambican metical',
	  countries: ['mozambique']
	}, {
	  code: 'NAD',
	  number: '516',
	  digits: 2,
	  currency: 'Namibian dollar',
	  countries: ['namibia']
	}, {
	  code: 'NGN',
	  number: '566',
	  digits: 2,
	  currency: 'Nigerian naira',
	  countries: ['nigeria']
	}, {
	  code: 'NIO',
	  number: '558',
	  digits: 2,
	  currency: 'Nicaraguan córdoba',
	  countries: ['nicaragua']
	}, {
	  code: 'NOK',
	  number: '578',
	  digits: 2,
	  currency: 'Norwegian krone',
	  countries: ['norway', 'svalbard', 'jan mayen', 'bouvet island', 'queen maud land', 'peter i island']
	}, {
	  code: 'NPR',
	  number: '524',
	  digits: 2,
	  currency: 'Nepalese rupee',
	  countries: ['nepal']
	}, {
	  code: 'NZD',
	  number: '554',
	  digits: 2,
	  currency: 'New Zealand dollar',
	  countries: ['cook islands', 'new zealand', 'niue', 'pitcairn', 'tokelau', 'ross dependency']
	}, {
	  code: 'OMR',
	  number: '512',
	  digits: 3,
	  currency: 'Omani rial',
	  countries: ['oman']
	}, {
	  code: 'PAB',
	  number: '590',
	  digits: 2,
	  currency: 'Panamanian balboa',
	  countries: ['panama']
	}, {
	  code: 'PEN',
	  number: '604',
	  digits: 2,
	  currency: 'Peruvian nuevo sol',
	  countries: ['peru']
	}, {
	  code: 'PGK',
	  number: '598',
	  digits: 2,
	  currency: 'Papua New Guinean kina',
	  countries: ['papua new guinea']
	}, {
	  code: 'PHP',
	  number: '608',
	  digits: 2,
	  currency: 'Philippine peso',
	  countries: ['philippines']
	}, {
	  code: 'PKR',
	  number: '586',
	  digits: 2,
	  currency: 'Pakistani rupee',
	  countries: ['pakistan']
	}, {
	  code: 'PLN',
	  number: '985',
	  digits: 2,
	  currency: 'Polish złoty',
	  countries: ['poland']
	}, {
	  code: 'PYG',
	  number: '600',
	  digits: 0,
	  currency: 'Paraguayan guaraní',
	  countries: ['paraguay']
	}, {
	  code: 'QAR',
	  number: '634',
	  digits: 2,
	  currency: 'Qatari riyal',
	  countries: ['qatar']
	}, {
	  code: 'RON',
	  number: '946',
	  digits: 2,
	  currency: 'Romanian new leu',
	  countries: ['romania']
	}, {
	  code: 'RSD',
	  number: '941',
	  digits: 2,
	  currency: 'Serbian dinar',
	  countries: ['serbia']
	}, {
	  code: 'RUB',
	  number: '643',
	  digits: 2,
	  currency: 'Russian rouble',
	  countries: ['russia', 'abkhazia', 'south ossetia']
	}, {
	  code: 'RWF',
	  number: '646',
	  digits: 0,
	  currency: 'Rwandan franc',
	  countries: ['rwanda']
	}, {
	  code: 'SAR',
	  number: '682',
	  digits: 2,
	  currency: 'Saudi riyal',
	  countries: ['saudi arabia']
	}, {
	  code: 'SBD',
	  number: '090',
	  digits: 2,
	  currency: 'Solomon Islands dollar',
	  countries: ['solomon islands']
	}, {
	  code: 'SCR',
	  number: '690',
	  digits: 2,
	  currency: 'Seychelles rupee',
	  countries: ['seychelles']
	}, {
	  code: 'SDG',
	  number: '938',
	  digits: 2,
	  currency: 'Sudanese pound',
	  countries: ['sudan']
	}, {
	  code: 'SEK',
	  number: '752',
	  digits: 2,
	  currency: 'Swedish krona/kronor',
	  countries: ['sweden']
	}, {
	  code: 'SGD',
	  number: '702',
	  digits: 2,
	  currency: 'Singapore dollar',
	  countries: ['singapore', 'brunei']
	}, {
	  code: 'SHP',
	  number: '654',
	  digits: 2,
	  currency: 'Saint Helena pound',
	  countries: ['saint helena']
	}, {
	  code: 'SLL',
	  number: '694',
	  digits: 0,
	  currency: 'Sierra Leonean leone',
	  countries: ['sierra leone']
	}, {
	  code: 'SOS',
	  number: '706',
	  digits: 2,
	  currency: 'Somali shilling',
	  countries: ['somalia']
	}, {
	  code: 'SRD',
	  number: '968',
	  digits: 2,
	  currency: 'Surinamese dollar',
	  countries: ['suriname']
	}, {
	  code: 'SSP',
	  number: '728',
	  digits: 2,
	  currency: 'South Sudanese pound',
	  countries: ['south sudan']
	}, {
	  code: 'STD',
	  number: '678',
	  digits: 0,
	  currency: 'São Tomé and Príncipe dobra',
	  countries: ['são tomé and príncipe']
	}, {
	  code: 'SYP',
	  number: '760',
	  digits: 2,
	  currency: 'Syrian pound',
	  countries: ['syria']
	}, {
	  code: 'SZL',
	  number: '748',
	  digits: 2,
	  currency: 'Swazi lilangeni',
	  countries: ['swaziland']
	}, {
	  code: 'THB',
	  number: '764',
	  digits: 2,
	  currency: 'Thai baht',
	  countries: ['thailand']
	}, {
	  code: 'TJS',
	  number: '972',
	  digits: 2,
	  currency: 'Tajikistani somoni',
	  countries: ['tajikistan']
	}, {
	  code: 'TMT',
	  number: '934',
	  digits: 2,
	  currency: 'Turkmenistani manat',
	  countries: ['turkmenistan']
	}, {
	  code: 'TND',
	  number: '788',
	  digits: 3,
	  currency: 'Tunisian dinar',
	  countries: ['tunisia']
	}, {
	  code: 'TOP',
	  number: '776',
	  digits: 2,
	  currency: 'Tongan paʻanga',
	  countries: ['tonga']
	}, {
	  code: 'TRY',
	  number: '949',
	  digits: 2,
	  currency: 'Turkish lira',
	  countries: ['turkey', 'northern cyprus']
	}, {
	  code: 'TTD',
	  number: '780',
	  digits: 2,
	  currency: 'Trinidad and Tobago dollar',
	  countries: ['trinidad and tobago']
	}, {
	  code: 'TWD',
	  number: '901',
	  digits: 2,
	  currency: 'New Taiwan dollar',
	  countries: ['republic of china (taiwan)']
	}, {
	  code: 'TZS',
	  number: '834',
	  digits: 2,
	  currency: 'Tanzanian shilling',
	  countries: ['tanzania']
	}, {
	  code: 'UAH',
	  number: '980',
	  digits: 2,
	  currency: 'Ukrainian hryvnia',
	  countries: ['ukraine']
	}, {
	  code: 'UGX',
	  number: '800',
	  digits: 2,
	  currency: 'Ugandan shilling',
	  countries: ['uganda']
	}, {
	  code: 'USD',
	  number: '840',
	  digits: 2,
	  currency: 'United States dollar',
	  countries: ['american samoa', 'barbados', 'bermuda', 'british indian ocean territory', 'british virgin islands, caribbean netherlands', 'ecuador', 'el salvador', 'guam', 'haiti', 'marshall islands', 'federated states of micronesia', 'northern mariana islands', 'palau', 'panama', 'puerto rico', 'timor-leste', 'turks and caicos islands', 'united states', 'u.s. virgin islands', 'zimbabwe']
	}, {
	  code: 'USN',
	  number: '997',
	  digits: 2,
	  currency: 'United States dollar (next day) (funds code)',
	  countries: ['united states']
	}, {
	  code: 'USS',
	  number: '998',
	  digits: 2,
	  currency: 'United States dollar',
	  countries: ['united states']
	}, {
	  code: 'UYI',
	  number: '940',
	  digits: 0,
	  currency: 'Uruguay Peso en Unidades Indexadas',
	  countries: ['uruguay']
	}, {
	  code: 'UYU',
	  number: '858',
	  digits: 2,
	  currency: 'Uruguayan peso',
	  countries: ['uruguay']
	}, {
	  code: 'UZS',
	  number: '860',
	  digits: 2,
	  currency: 'Uzbekistan som',
	  countries: ['uzbekistan']
	}, {
	  code: 'VEF',
	  number: '937',
	  digits: 2,
	  currency: 'Venezuelan bolívar',
	  countries: ['venezuela']
	}, {
	  code: 'VND',
	  number: '704',
	  digits: 0,
	  currency: 'Vietnamese dong',
	  countries: ['vietnam']
	}, {
	  code: 'VUV',
	  number: '548',
	  digits: 0,
	  currency: 'Vanuatu vatu',
	  countries: ['vanuatu']
	}, {
	  code: 'WST',
	  number: '882',
	  digits: 2,
	  currency: 'Samoan tala',
	  countries: ['samoa']
	}, {
	  code: 'XAF',
	  number: '950',
	  digits: 0,
	  currency: 'CFA franc BEAC',
	  countries: ['cameroon', 'central african republic', 'republic of the congo', 'chad', 'equatorial guinea', 'gabon']
	}, {
	  code: 'XAG',
	  number: '961',
	  currency: 'Silver (one troy ounce)'
	}, {
	  code: 'XAU',
	  number: '959',
	  currency: 'Gold (one troy ounce)'
	}, {
	  code: 'XBA',
	  number: '955',
	  currency: 'European Composite Unit (EURCO) (bond market unit)	'
	}, {
	  code: 'XBB',
	  number: '956',
	  currency: 'European Monetary Unit (E.M.U.-6) (bond market unit)	'
	}, {
	  code: 'XBC',
	  number: '957',
	  currency: 'European Unit of Account 9 (E.U.A.-9) (bond market unit)	'
	}, {
	  code: 'XBD',
	  number: '958',
	  currency: 'European Unit of Account 17 (E.U.A.-17) (bond market unit)	'
	}, {
	  code: 'XBT',
	  currency: 'Bitcoin'
	}, {
	  code: 'XCD',
	  number: '951',
	  digits: 2,
	  currency: 'East Caribbean dollar',
	  countries: ['anguilla', 'antigua and barbuda', 'dominica', 'grenada', 'montserrat', 'saint kitts and nevis', 'saint lucia', 'saint vincent and the grenadines']
	}, {
	  code: 'XDR',
	  number: '960',
	  currency: 'Special drawing rights',
	  countries: ['international monetary fund']
	}, {
	  code: 'XFU',
	  currency: 'UIC franc (special settlement currency)',
	  countries: ['international union of railways']
	}, {
	  code: 'XOF',
	  number: '952',
	  digits: 0,
	  currency: 'CFA franc BCEAO',
	  countries: ['benin', 'burkina faso', "côte d'ivoire", 'guinea-bissau', 'mali', 'niger', 'senegal', 'togo']
	}, {
	  code: 'XPD',
	  number: '964',
	  currency: 'Palladium (one troy ounce)'
	}, {
	  code: 'XPF',
	  number: '953',
	  digits: 0,
	  currency: 'CFP franc (Franc du Pacifique)',
	  countries: ['french polynesia', 'new caledonia', 'wallis and futuna']
	}, {
	  code: 'XPT',
	  number: '962',
	  currency: 'Platinum (one troy ounce)'
	}, {
	  code: 'XTS',
	  number: '963',
	  currency: 'Code reserved for testing purposes'
	}, {
	  code: 'XXX',
	  number: '999',
	  currency: 'No currency'
	}, {
	  code: 'YER',
	  number: '886',
	  digits: 2,
	  currency: 'Yemeni rial',
	  countries: ['yemen']
	}, {
	  code: 'ZAR',
	  number: '710',
	  digits: 2,
	  currency: 'South African rand',
	  countries: ['south africa']
	}, {
	  code: 'ZMW',
	  number: '967',
	  digits: 2,
	  currency: 'Zambian kwacha',
	  countries: ['zambia']
	}];
	exports.default = _default;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _NumberInput = _interopRequireDefault(__webpack_require__(710));
	var _default = _NumberInput.default;
	exports.default = _default;

/***/ },
/* 714 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = convertStringToNumber;
	function convertStringToNumber(stringToConvert) {
	  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _props$decimalDelimit = props.decimalDelimiter,
	    decimalDelimiter = _props$decimalDelimit === void 0 ? '.' : _props$decimalDelimit,
	    _props$digitGroupDeli = props.digitGroupDelimiter,
	    digitGroupDelimiter = _props$digitGroupDeli === void 0 ? ',' : _props$digitGroupDeli,
	    _props$min = props.min,
	    min = _props$min === void 0 ? Number.MIN_SAFE_INTEGER : _props$min,
	    _props$max = props.max,
	    max = _props$max === void 0 ? Number.MAX_SAFE_INTEGER : _props$max;
	  if (digitGroupDelimiter == '') {
	    return ',';
	  }
	  if (!stringToConvert) {
	    return NaN;
	  }
	  var cleanedString = stringToConvert;
	  var decmialPosition = cleanedString.lastIndexOf(decimalDelimiter);
	  if (decmialPosition !== -1 && decimalDelimiter !== '.') {
	    cleanedString = [cleanedString.substring(0, decmialPosition).replace(new RegExp("[\\".concat(digitGroupDelimiter, "]"), 'g'), ''), cleanedString.substring(decmialPosition).replace(new RegExp("[\\".concat(decimalDelimiter, "]"), 'g'), '.')].join('');
	  } else {
	    cleanedString = cleanedString.replace(new RegExp("[\\".concat(digitGroupDelimiter, "]"), 'g'), '');
	  }
	  var result = parseFloat(cleanedString, 10);
	  if (result < min) {
	    result = min;
	  }
	  if (result > max) {
	    result = max;
	  }
	  return result;
	}

/***/ },
/* 715 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function find(collection, test) {
	  if (!Array.isArray(collection)) {
	    return null;
	  }
	  if (collection.length === 0) {
	    return null;
	  }
	  if (Array.prototype.find) {
	    return collection.find(test);
	  }
	  if (typeof test !== 'function') {
	    return null;
	  }
	  var needle;
	  for (var i = 0, len = collection.length; i < len; i++) {
	    var item = collection[i];
	    if (test(item)) {
	      needle = item;
	      break;
	    }
	  }
	  return needle;
	}
	var _default = find;
	exports.default = _default;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getCurrencyForCountryCode;
	var _countryCurrencyCodes = _interopRequireDefault(__webpack_require__(712));
	var _countries = _interopRequireDefault(__webpack_require__(711));
	var _find = _interopRequireDefault(__webpack_require__(715));
	var countriesByCountryCode = _countries.default.reduce(function (accumulator, country) {
	  accumulator[country.code] = country.name;
	  accumulator[country.code.toLowerCase()] = country.name;
	  return accumulator;
	}, {});
	function getCurrencyForCountryCode(locale) {
	  var currencyDisplay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'symbol';
	  var code = locale.split('-')[1];
	  var countryNameByCode = countriesByCountryCode[code];
	  if (countryNameByCode) {
	    var country = countriesByCountryCode[code] && countriesByCountryCode[code].toLowerCase();
	    var currency = (0, _find.default)(_countryCurrencyCodes.default, function (countryCode) {
	      return (countryCode.countries || []).indexOf(country) !== -1;
	    });
	    if (currency) {
	      return new Number(1).toLocaleString(locale, {
	        style: 'currency',
	        currency: currency.code,
	        currencyDisplay: currencyDisplay
	      }).replace(/[0-9\.\,]/g, '');
	    }
	    return '';
	  } else {
	    console.error("Cannot get currency based on country code. Country ".concat(code, " not found."));
	    return '';
	  }
	}

/***/ },
/* 717 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDigitGroupDelimiter;
	function getDigitGroupDelimiter(locale) {
	  var number = 1000;
	  return number.toLocaleString(locale).replace(/[01]/g, '') || ',';
	}

/***/ },
/* 718 */
633,
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSelectedRange;
	var _getSelectionStart = _interopRequireDefault(__webpack_require__(253));
	var _getSelectionEnd = _interopRequireDefault(__webpack_require__(718));
	function getSelectedRange(dom) {
	  var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _api$getSelectionEnd = api.getSelectionEnd,
	    getSelectionEnd = _api$getSelectionEnd === void 0 ? _getSelectionEnd.default : _api$getSelectionEnd,
	    _api$getSelectionStar = api.getSelectionStart,
	    getSelectionStart = _api$getSelectionStar === void 0 ? _getSelectionStart.default : _api$getSelectionStar;
	  return {
	    start: getSelectionStart(dom),
	    end: getSelectionEnd(dom)
	  };
	}

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.countDecimalDigits = void 0;
	exports.default = getTransformedStringValues;
	exports.getDecimalDelimiterPosition = void 0;
	var _getDecimalDelimiter = _interopRequireDefault(__webpack_require__(252));
	var _getDigitGroupDelimiter = _interopRequireDefault(__webpack_require__(717));
	var _convertStringToNumber = _interopRequireDefault(__webpack_require__(714));
	var getDecimalDelimiterPosition = function getDecimalDelimiterPosition(value, decimalDelimiter) {
	  var string = value && value.toString();
	  var position = string && string.indexOf(decimalDelimiter);
	  return position !== -1 ? position : false;
	};
	exports.getDecimalDelimiterPosition = getDecimalDelimiterPosition;
	var countDecimalDigits = function countDecimalDigits(string, decimalDelimiter, decimalPosition) {
	  var position = decimalPosition || getDecimalDelimiterPosition(string, decimalDelimiter);
	  if (isNaN(position)) {
	    return 0;
	  }
	  if (typeof position === 'number' && position < string.length) {
	    return string.length - position - 1;
	  }
	  return 0;
	};
	exports.countDecimalDigits = countDecimalDigits;
	function getTransformedStringValues(stringInput) {
	  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var internalApi = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  if (typeof stringInput !== 'string') {
	    stringInput += '';
	  }
	  if (!stringInput) {
	    return ['', null];
	  }
	  stringInput = stringInput.replace(/[^0-9\,\.\-\+]/g, '');
	  if (stringInput === '-' || stringInput === '-.') {
	    return [stringInput, null];
	  }
	  var locale = props.locale,
	    _props$min = props.min,
	    min = _props$min === void 0 ? Number.MIN_SAFE_INTEGER : _props$min,
	    _props$max = props.max,
	    max = _props$max === void 0 ? Number.MAX_SAFE_INTEGER : _props$max,
	    suffix = props.suffix,
	    prefix = props.prefix;
	  var precision = props.precision || null;
	  if (precision > 20) {
	    precision = 20;
	  }
	  var _internalApi$getDecim = internalApi.getDecimalDelimiter,
	    getDecimalDelimiter = _internalApi$getDecim === void 0 ? _getDecimalDelimiter.default : _internalApi$getDecim,
	    _internalApi$getDigit = internalApi.getDigitGroupDelimiter,
	    getDigitGroupDelimiter = _internalApi$getDigit === void 0 ? _getDigitGroupDelimiter.default : _internalApi$getDigit,
	    _internalApi$convertS = internalApi.convertStringToNumber,
	    convertStringToNumber = _internalApi$convertS === void 0 ? _convertStringToNumber.default : _internalApi$convertS;
	  var decimalDelimiter = getDecimalDelimiter(locale);
	  if (stringInput === decimalDelimiter) {
	    return [stringInput, null];
	  }
	  var decimalDelimiterPosition = getDecimalDelimiterPosition(stringInput, decimalDelimiter);
	  var decimalDigitsInInput = countDecimalDigits(stringInput, decimalDelimiter, decimalDelimiterPosition);
	  if (precision || precision === 0 && decimalDigitsInInput > precision) {
	    stringInput = stringInput.substring(0, stringInput.length - (decimalDigitsInInput - precision));
	  }
	  var digitGroupDelimiter = getDigitGroupDelimiter(locale);
	  var parsedResult = convertStringToNumber(stringInput, {
	    digitGroupDelimiter: digitGroupDelimiter,
	    decimalDelimiter: decimalDelimiter,
	    min: min,
	    max: max
	  });
	  if (isNaN(parsedResult)) {
	    return ['', null];
	  }
	  var numberWasClamped = parsedResult === min || parsedResult === max;
	  if (numberWasClamped) {
	    decimalDigitsInInput = 0;
	  }
	  var formatingOptions = {
	    maximumFractionDigits: precision ? Math.min(precision, 20) : 20,
	    minimumFractionDigits: Math.min(precision || decimalDigitsInInput, 20)
	  };
	  var stringRepresentation = parsedResult.toLocaleString(locale, formatingOptions);
	  if (!precision && !numberWasClamped && !decimalDigitsInInput && decimalDelimiterPosition === stringInput.length - 1) {
	    stringRepresentation += '.';
	  }
	  if (prefix) {
	    stringRepresentation = "".concat(prefix, " ").concat(stringRepresentation);
	  }
	  if (suffix) {
	    stringRepresentation = "".concat(stringRepresentation, " ").concat(suffix);
	  }
	  return [stringRepresentation, parsedResult];
	}

/***/ },
/* 721 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setCaretPosition;
	function setCaretPosition(elem, caretPos) {
	  var start = caretPos;
	  var end = caretPos;
	  if (caretPos && (caretPos.start != undefined || caretPos.end != undefined)) {
	    start = caretPos.start || 0;
	    end = caretPos.end || start;
	  }
	  if (elem != null) {
	    if (elem.createTextRange) {
	      var range = elem.createTextRange();
	      range.moveStart('character', start);
	      range.moveEnd('character', end);
	      range.select();
	    } else {
	      elem.setSelectionRange(start, end);
	    }
	  }
	}

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	function Arrow(props) {
	  var style = (0, _assign.default)({}, props.style);
	  var wrapperStyle = (0, _assign.default)({}, props.position);
	  var arrowSize = {
	    height: props.size,
	    width: props.size
	  };
	  (0, _assign.default)(style, arrowSize);
	  var wrapperSize = 2 * (0.5 * props.size * Math.pow(2, 0.5));
	  if (wrapperSize) {
	    wrapperStyle.width = wrapperSize;
	    wrapperStyle.height = wrapperSize;
	  }
	  return _react.default.createElement("div", {
	    className: props.wrapperClassName,
	    style: wrapperStyle
	  }, _react.default.createElement("div", {
	    className: props.className,
	    style: style
	  }));
	}
	Arrow.propTypes = {
	  className: _propTypes.default.string,
	  style: _propTypes.default.object,
	  size: _propTypes.default.number,
	  position: _propTypes.default.shape({
	    top: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    left: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  })
	};
	var _default = Arrow;
	exports.default = _default;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof3 = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	var _eventManager = _interopRequireDefault(__webpack_require__(727));
	var _getMinMaxSize = _interopRequireDefault(__webpack_require__(733));
	var _join = _interopRequireDefault(__webpack_require__(734));
	var _shouldComponentUpdate2 = _interopRequireDefault(__webpack_require__(736));
	var _normalizeEvent = _interopRequireDefault(__webpack_require__(735));
	var _getFocusableElements = _interopRequireDefault(__webpack_require__(732));
	var _getPositionRelativeToElement = _interopRequireDefault(__webpack_require__(214));
	var _Arrow = _interopRequireDefault(__webpack_require__(722));
	var _positionsMap = __webpack_require__(100);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var InovuaOverlay = function (_Component) {
	  (0, _inherits2.default)(InovuaOverlay, _Component);
	  var _super = _createSuper(InovuaOverlay);
	  function InovuaOverlay(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaOverlay);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
	      if (prevProps.visible !== _this.props.visible) {
	        _this.handleVisibleChange(_this.props.visible);
	      }
	    });
	    _this.state = {
	      visible: props.defaultVisible,
	      position: null,
	      arrowConfig: null,
	      renderTrigger: null
	    };
	    _this.handleDocumentScroll = _this.handleDocumentScroll.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onHide = _this.onHide.bind((0, _assertThisInitialized2.default)(_this));
	    _this.onShow = _this.onShow.bind((0, _assertThisInitialized2.default)(_this));
	    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getOverlayNode = _this.getOverlayNode.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getVisible = _this.getVisible.bind((0, _assertThisInitialized2.default)(_this));
	    _this.getActiveTargetNode = _this.getActiveTargetNode.bind((0, _assertThisInitialized2.default)(_this));
	    _this.rootRef = function (node) {
	      _this.rootNode = node;
	    };
	    _this.fixedRef = function (node) {
	      _this.fixedNode = node;
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaOverlay, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _shouldComponentUpdate2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	      this.register();
	      this.componentIsMounted = true;
	      if (this.props.updatePositionOnScroll) {
	        window.addEventListener('scroll', this.handleDocumentScroll, true);
	      }
	      var doPosition = function doPosition() {
	        var target = _this2.getTarget();
	        if ((0, _typeof2.default)(target) === 'object') {
	          _this2.activeTargetNode = target;
	          _this2.setPosition(_this2.props.onInitialPosition);
	          if (_this2.getVisible()) {
	            _this2.onShow({
	              target: target
	            });
	          }
	        }
	      };
	      if (this.props.rafOnMount) {
	        requestAnimationFrame(doPosition);
	      } else {
	        doPosition();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.unregister();
	      this.componentIsMounted = null;
	      this.activeTargetNode = null;
	      if (this.props.updatePositionOnScroll) {
	        window.removeEventListener('scroll', this.handleDocumentScroll, true);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var className = this.prepareClassName();
	      var contentClassName = this.prepareContentClassName();
	      var style = this.prepareStyle();
	      var contentStyle = this.prepareContentStyle();
	      return _react.default.createElement("div", _objectSpread(_objectSpread({}, (0, _cleanProps.default)(props, InovuaOverlay.propTypes)), {}, {
	        className: className,
	        ref: this.rootRef,
	        style: style,
	        onKeyDown: this.handleKeyDown
	      }), _react.default.createElement("div", _objectSpread(_objectSpread({
	        className: contentClassName
	      }, this.getChildrenProps()), {}, {
	        style: contentStyle
	      })), props.arrow && this.renderArrow(), props.relativeToViewport && this.renderFixed());
	    }
	  }, {
	    key: "renderFixed",
	    value: function renderFixed() {
	      return _react.default.createElement("div", {
	        style: {
	          position: 'fixed',
	          top: 0,
	          left: 0,
	          width: 0,
	          height: 0
	        },
	        ref: this.fixedRef
	      });
	    }
	  }, {
	    key: "renderArrow",
	    value: function renderArrow() {
	      if (!this.state.arrowConfig) {
	        return null;
	      }
	      var rootClassName = this.props.rootClassName;
	      var position = this.state.arrowConfig.position;
	      var location = this.state.arrowConfig.location;
	      var className = (0, _join.default)("".concat(rootClassName, "__arrow"), "".concat(rootClassName, "__arrow--").concat(location), this.props.arrowClassName);
	      var style = (0, _assign.default)({}, this.props.arrowStyle);
	      if (this.props.border) {
	        (0, _assign.default)(style, {
	          border: this.props.border
	        });
	      }
	      if (this.props.background != undefined) {
	        (0, _assign.default)(style, {
	          background: this.props.background
	        });
	      }
	      var wrapperClassName = (0, _join.default)("".concat(rootClassName, "__arrow-wrapper"), "".concat(rootClassName, "__arrow-wrapper--").concat(location));
	      return _react.default.createElement(_Arrow.default, {
	        className: className,
	        wrapperClassName: wrapperClassName,
	        position: position,
	        style: style,
	        size: this.props.arrowSize
	      });
	    }
	  }, {
	    key: "getChildrenProps",
	    value: function getChildrenProps() {
	      var children = this.props.children;
	      var targetNode = this.getPositionTarget();
	      var childrenProps = {
	        children: children
	      };
	      var childrenParams = {
	        targetNode: targetNode,
	        visible: this.getVisible()
	      };
	      if (typeof children === 'function') {
	        return {
	          children: children(childrenParams)
	        };
	      }
	      if (children === undefined && targetNode) {
	        var tooltip = targetNode.getAttribute('data-tooltip');
	        if (tooltip != null) {
	          return {
	            dangerouslySetInnerHTML: {
	              __html: tooltip
	            }
	          };
	        }
	      }
	      return childrenProps;
	    }
	  }, {
	    key: "prepareClassName",
	    value: function prepareClassName() {
	      var props = this.props,
	        state = this.state;
	      var rootClassName = props.rootClassName,
	        theme = props.theme,
	        visibleClassName = props.visibleClassName,
	        relativeToViewport = props.relativeToViewport;
	      var visible = this.getVisible();
	      var className = (0, _join.default)(rootClassName, props.className, visible && "".concat(rootClassName, "--visible"), visible && visibleClassName, !visible && "".concat(rootClassName, "--invisible"), relativeToViewport && "".concat(rootClassName, "--position-fixed"), theme && "".concat(rootClassName, "--theme-").concat(theme));
	      if (this.props.fade) {
	        className = (0, _join.default)(className, props.fade && "".concat(rootClassName, "--has-transition"), state.transitionEnter && "".concat(rootClassName, "--transition-enter"), state.transitionEnterActive && "".concat(rootClassName, "--transition-enter-active"), state.transitionLeave && "".concat(rootClassName, "--transition-leave"), state.transitionLeaveActive && "".concat(rootClassName, "--transition-leave-active"));
	      }
	      return className;
	    }
	  }, {
	    key: "prepareContentClassName",
	    value: function prepareContentClassName() {
	      return (0, _join.default)(this.props.contentClassName, "".concat(this.props.rootClassName, "__content"));
	    }
	  }, {
	    key: "prepareStyle",
	    value: function prepareStyle() {
	      var style = (0, _assign.default)({
	        zIndex: this.props.zIndex
	      }, this.props.style);
	      if (this.props.fade) {
	        (0, _assign.default)(style, this.getTransitionStyle());
	      }
	      if (this.props.border) {
	        (0, _assign.default)(style, {
	          border: this.props.border
	        });
	      }
	      if (this.state.position) {
	        if (this.props.useTransform) {
	          style.transform = "translate3d(".concat(Math.round(this.state.position.left || 0), "px, ").concat(Math.round(this.state.position.top || 0), "px, 0px)");
	          style.left = 0;
	          style.top = 0;
	        } else {
	          (0, _assign.default)(style, {
	            left: Math.round(this.state.position.left)
	          });
	          if (this.state.position.top != null) {
	            style.top = Math.round(this.state.position.top);
	          }
	        }
	        if (this.state.position.bottom != null) {
	          style.bottom = Math.round(this.state.position.bottom);
	        }
	        if (this.state.position.width) {
	          style.width = this.state.position.width;
	        }
	      }
	      return style;
	    }
	  }, {
	    key: "prepareContentStyle",
	    value: function prepareContentStyle() {
	      var style = (0, _assign.default)({}, this.props.contentStyle);
	      if (this.props.background != undefined) {
	        (0, _assign.default)(style, {
	          background: this.props.background
	        });
	      }
	      if (this.props.padding != undefined) {
	        (0, _assign.default)(style, {
	          padding: this.props.padding
	        });
	      }
	      if (this.props.height != undefined) {
	        (0, _assign.default)(style, {
	          height: this.props.height
	        });
	      }
	      if (this.props.width != undefined) {
	        (0, _assign.default)(style, {
	          width: this.props.width
	        });
	      }
	      var maxMinSize = (0, _getMinMaxSize.default)(this.props);
	      (0, _assign.default)(style, maxMinSize);
	      return style;
	    }
	  }, {
	    key: "getTransitionStyle",
	    value: function getTransitionStyle() {
	      var state = this.state;
	      var style = {};
	      if (state.transitionEnterActive || state.transitionLeaveActive) {
	        style.transitionDuration = state.transitionEnterActive ? "".concat(this.getFadeInDuration(), "ms") : "".concat(this.getFadeOutDuration(), "ms");
	        style.transitionTimingFunction = state.transitionEnterActive ? this.getFadeInTransitionFunction() : this.getFadeOutTransitionFunction();
	      }
	      return style;
	    }
	  }, {
	    key: "onShow",
	    value: function onShow(event) {
	      var _this3 = this;
	      this.activeTargetNode = event.target;
	      this.setState({
	        renderTrigger: !this.state.renderTrigger
	      }, function () {
	        _this3.setPosition();
	        _this3.setVisible(true);
	      });
	    }
	  }, {
	    key: "onHide",
	    value: function onHide(event) {
	      this.setVisible(false);
	    }
	  }, {
	    key: "register",
	    value: function register() {
	      var _this4 = this;
	      this.eventManager = this.getEventManager()({
	        showEvent: (0, _normalizeEvent.default)(this.props.showEvent),
	        hideEvent: (0, _normalizeEvent.default)(this.props.hideEvent),
	        target: this.getTarget(),
	        hideOnScroll: this.props.hideOnScroll,
	        hideOnClickOutside: this.props.hideOnClickOutside,
	        hideOnEscape: this.props.hideOnEscape,
	        onShow: this.onShow,
	        onHide: this.onHide,
	        getShowDelay: function getShowDelay() {
	          return _this4.props.showDelay;
	        },
	        getHideDelay: function getHideDelay() {
	          return _this4.props.hideDelay;
	        },
	        getVisible: this.getVisible,
	        getOverlayNode: this.getOverlayNode,
	        getActiveTargetNode: this.getActiveTargetNode
	      });
	    }
	  }, {
	    key: "unregister",
	    value: function unregister() {
	      if (this.eventManager) {
	        this.eventManager.unregister();
	      }
	    }
	  }, {
	    key: "getEventManager",
	    value: function getEventManager() {
	      return this.props.eventManager;
	    }
	  }, {
	    key: "getTarget",
	    value: function getTarget() {
	      var target;
	      var rootNode = this.getOverlayNode();
	      if (this.props.target) {
	        target = this.props.target;
	        if (typeof target === 'function') {
	          target = target(this.props, rootNode, this);
	        }
	      } else {
	        if (rootNode) {
	          target = rootNode.parentElement;
	        }
	      }
	      return target;
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible) {
	      if (!this.isVisibleControlled()) {
	        if (visible !== this.getVisible()) {
	          this.handleVisibleChange(visible);
	        }
	        this.setState({
	          visible: visible
	        });
	      }
	      if (visible) {
	        this.props.onShow();
	      } else {
	        this.props.onHide();
	      }
	      this.props.onVisibleChange(visible);
	    }
	  }, {
	    key: "isVisibleControlled",
	    value: function isVisibleControlled() {
	      return this.props.visible != null;
	    }
	  }, {
	    key: "getVisible",
	    value: function getVisible() {
	      return this.isVisibleControlled() ? this.props.visible : this.state.visible;
	    }
	  }, {
	    key: "setPosition",
	    value: function setPosition(callback) {
	      this.setState(this.getPositionConfig(), callback);
	    }
	  }, {
	    key: "getPositionConfig",
	    value: function getPositionConfig() {
	      var _this$props = this.props,
	        constrainTo = _this$props.constrainTo,
	        offset = _this$props.offset,
	        syncWidth = _this$props.syncWidth;
	      var positions = this.props.positions;
	      var targetNode = this.getPositionTarget();
	      var tooltipPositions = targetNode ? targetNode.getAttribute('data-tooltip-positions') : null;
	      if (tooltipPositions) {
	        positions = tooltipPositions.split(',').map(function (position) {
	          return position && position.trim ? position.trim() : position;
	        });
	      }
	      var normalizedPositions = Array.isArray(positions) ? positions : [positions];
	      var newState = (0, _getPositionRelativeToElement.default)({
	        showArrow: true,
	        constrainTo: constrainTo,
	        offset: offset,
	        targetNode: targetNode,
	        overlayNode: this.getOverlayNode(),
	        positions: normalizedPositions,
	        adjustOnPositionBottom: this.props.adjustOnPositionBottom,
	        relativeToViewport: this.props.relativeToViewport,
	        arrowSize: this.props.arrowSize
	      });
	      if (this.props.relativeToViewport && this.fixedNode) {
	        var fixedRect = this.fixedNode.getBoundingClientRect();
	        if (newState && newState.position) {
	          var useTransform = this.props.useTransform;
	          newState.position = {
	            top: newState.position.top - (useTransform ? 0 : fixedRect.top),
	            left: newState.position.left - (useTransform ? 0 : fixedRect.left)
	          };
	          if (syncWidth) {
	            newState.position.width = newState.alignRegion.width;
	          }
	        }
	      }
	      return newState;
	    }
	  }, {
	    key: "handleDocumentScroll",
	    value: function handleDocumentScroll() {
	      if (this.props.updatePositionOnScroll) {
	        this.updateDomPosition();
	      }
	    }
	  }, {
	    key: "updateDomPosition",
	    value: function updateDomPosition() {
	      var positionConfig = this.getPositionConfig();
	      if (this.rootNode && positionConfig) {
	        var newPosition = positionConfig.position;
	        if (newPosition.bottom !== undefined) {
	          this.rootNode.style.bottom = "".concat(newPosition.bottom, "px");
	        }
	        if (this.props.useTransform) {
	          var oldPosition = this.state.position || {
	            top: 0,
	            left: 0
	          };
	          this.rootNode.style.transform = "translate3d(".concat(Math.round(newPosition.left || oldPosition.left), "px, ").concat(Math.round(newPosition.top || oldPosition.top), "px, 0px)");
	        } else {
	          if (newPosition.top !== undefined) {
	            this.rootNode.style.top = "".concat(Math.round(newPosition.top), "px");
	          }
	          this.rootNode.style.left = "".concat(Math.round(newPosition.left), "px");
	        }
	      }
	    }
	  }, {
	    key: "getOverlayNode",
	    value: function getOverlayNode() {
	      return this.rootNode;
	    }
	  }, {
	    key: "getActiveTargetNode",
	    value: function getActiveTargetNode() {
	      return this.activeTargetNode;
	    }
	  }, {
	    key: "getPositionTarget",
	    value: function getPositionTarget() {
	      var target = this.getTarget();
	      if (target instanceof Element) {
	        return target;
	      }
	      return this.getActiveTargetNode();
	    }
	  }, {
	    key: "handleVisibleChange",
	    value: function handleVisibleChange(visible) {
	      if (!this.props.fade) {
	        return null;
	      }
	      if (visible) {
	        this.setupEnterTransition();
	      } else {
	        this.setupLeaveTransition();
	      }
	    }
	  }, {
	    key: "setupEnterTransition",
	    value: function setupEnterTransition() {
	      var _this5 = this;
	      this.props.onFadeInStart();
	      this.setState({
	        transitionEnter: true,
	        transitionEnterActive: false,
	        transitionLeave: false,
	        transitionLeaveActive: false
	      }, function () {
	        setTimeout(function () {
	          if (_this5.componentIsMounted) {
	            _this5.setState({
	              transitionEnterActive: true
	            }, function () {
	              _this5.props.onFadeInEnd();
	            });
	          }
	        }, 16);
	      });
	    }
	  }, {
	    key: "setupLeaveTransition",
	    value: function setupLeaveTransition() {
	      var _this6 = this;
	      this.props.onFadeOutStart();
	      this.setState({
	        transitionLeave: true,
	        transitionLeaveActive: false,
	        transitionEnter: false,
	        transitionEnterActive: false
	      }, function () {
	        setTimeout(function () {
	          if (_this6.componentIsMounted) {
	            _this6.setState({
	              transitionLeaveActive: true
	            }, function () {
	              setTimeout(function () {
	                if (_this6.componentIsMounted) {
	                  _this6.setState({
	                    transitionLeave: false,
	                    transitionLeaveActive: false
	                  }, function () {
	                    _this6.props.onFadeOutEnd();
	                  });
	                }
	              }, _this6.getFadeOutDuration());
	            });
	          }
	        }, 16);
	      });
	    }
	  }, {
	    key: "getFadeInDuration",
	    value: function getFadeInDuration() {
	      if (this.props.fadeInDuration) {
	        return this.props.fadeInDuration;
	      }
	      return this.props.fadeDuration;
	    }
	  }, {
	    key: "getFadeOutDuration",
	    value: function getFadeOutDuration() {
	      if (this.props.fadeOutDuration) {
	        return this.props.fadeOutDuration;
	      }
	      return this.props.fadeDuration;
	    }
	  }, {
	    key: "getFadeInTransitionFunction",
	    value: function getFadeInTransitionFunction() {
	      if (this.props.fadeInTransitionFunction) {
	        return this.props.fadeInTransitionFunction;
	      }
	      return this.props.fadeTransitionFunction;
	    }
	  }, {
	    key: "getFadeOutTransitionFunction",
	    value: function getFadeOutTransitionFunction() {
	      if (this.props.fadeOutTransitionFunction) {
	        return this.props.fadeOutTransitionFunction;
	      }
	      return this.props.fadeTransitionFunction;
	    }
	  }, {
	    key: "handleKeyDown",
	    value: function handleKeyDown(event) {
	      if (this.props.captureTabNavigation && event.key === 'Tab') {
	        this.captureTabNavigation(event);
	      }
	      if (this.props.onKeyDown) {
	        this.props.onKeyDown(event);
	      }
	    }
	  }, {
	    key: "captureTabNavigation",
	    value: function captureTabNavigation(event) {
	      var shiftKey = event.shiftKey;
	      var nodes = (0, _getFocusableElements.default)(this.rootNode);
	      if (!nodes.length) {
	        return null;
	      }
	      var firstNode = nodes[0];
	      var lastNode = nodes[nodes.length - 1];
	      if (lastNode === event.target && !shiftKey) {
	        firstNode.focus();
	        event.preventDefault();
	        event.stopPropagation();
	      }
	      if (firstNode === event.target && shiftKey) {
	        lastNode.focus();
	        event.preventDefault();
	        event.stopPropagation();
	      }
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      this.setVisible(true);
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      this.setVisible(false);
	    }
	  }]);
	  return InovuaOverlay;
	}(_react.Component);
	var emptyFn = function emptyFn() {};
	InovuaOverlay.defaultProps = {
	  captureTabNavigation: false,
	  updatePositionOnScroll: false,
	  zIndex: 100,
	  theme: 'default',
	  rootClassName: 'inovua-react-toolkit-overlay',
	  background: null,
	  padding: null,
	  eventManager: _eventManager.default,
	  target: null,
	  showEvent: ['mouseenter'],
	  hideEvent: ['mouseleave'],
	  defaultVisible: false,
	  arrow: true,
	  arrowStyle: {},
	  arrowSize: 11,
	  showDelay: null,
	  hideDelay: null,
	  hideOnClickOutside: true,
	  hideOnScroll: false,
	  fade: false,
	  fadeDuration: 300,
	  fadeInDuration: 300,
	  fadeOutDuration: 50,
	  fadeTransitionFunction: 'ease',
	  positions: _positionsMap.posiblePositions,
	  constrainTo: true,
	  offset: 10,
	  rafOnMount: true,
	  relativeToViewport: true,
	  adjustOnPositionBottom: false,
	  onVisibleChange: emptyFn,
	  onShow: emptyFn,
	  onHide: emptyFn,
	  onFadeInStart: emptyFn,
	  onFadeOutStart: emptyFn,
	  onFadeInEnd: emptyFn,
	  onFadeOutEnd: emptyFn
	};
	InovuaOverlay.propTypes = {
	  shouldComponentUpdate: _propTypes.default.func,
	  captureTabNavigation: _propTypes.default.bool,
	  updatePositionOnScroll: _propTypes.default.bool,
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	  rootClassName: _propTypes.default.string,
	  border: _propTypes.default.string,
	  background: _propTypes.default.string,
	  theme: _propTypes.default.string,
	  zIndex: _propTypes.default.number,
	  contentStyle: _propTypes.default.object,
	  contentClassName: _propTypes.default.string,
	  padding: _propTypes.default.number,
	  height: _propTypes.default.number,
	  width: _propTypes.default.number,
	  minSize: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
	    height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  })]),
	  maxSize: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.shape({
	    height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	    width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	  })]),
	  arrow: _propTypes.default.bool,
	  arrowClassName: _propTypes.default.string,
	  arrowStyle: _propTypes.default.object,
	  arrowSize: _propTypes.default.number,
	  visible: _propTypes.default.bool,
	  visibleClassName: _propTypes.default.string,
	  defaultVisible: _propTypes.default.bool,
	  target: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.func]),
	  eventManager: _propTypes.default.func,
	  showEvent: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
	  hideEvent: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
	  showDelay: _propTypes.default.number,
	  hideDelay: _propTypes.default.number,
	  hideOnClickOutside: _propTypes.default.bool,
	  hideOnScroll: _propTypes.default.bool,
	  hideOnEscape: _propTypes.default.bool,
	  useTransform: _propTypes.default.bool,
	  fade: _propTypes.default.bool,
	  fadeDuration: _propTypes.default.number,
	  fadeInDuration: _propTypes.default.number,
	  fadeOutDuration: _propTypes.default.number,
	  fadeTransitionFunction: _propTypes.default.string,
	  fadeInTransitionFunction: _propTypes.default.string,
	  fadeOutTransitionFunction: _propTypes.default.string,
	  constrainTo: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.func, _propTypes.default.bool]),
	  positions: function positions(props, propName, componentName) {
	    var positions = props[propName];
	    if (typeof positions === 'string') {
	      if (_positionsMap.posiblePositions.indexOf(positions) === -1) {
	        return new Error("\nInvalid prop ".concat(propName, " suplied to ").concat(componentName, ".\nFollowing values are allowed: ").concat(_positionsMap.posiblePositions.join(', '), "\n"));
	      }
	    }
	  },
	  offset: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  }), _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    x: _propTypes.default.number,
	    y: _propTypes.default.number
	  })]))]),
	  rafOnMount: _propTypes.default.bool,
	  relativeToViewport: _propTypes.default.bool,
	  adjustOnPositionBottom: _propTypes.default.bool,
	  syncWidth: _propTypes.default.bool,
	  onInitialPosition: _propTypes.default.func,
	  onVisibleChange: _propTypes.default.func,
	  onShow: _propTypes.default.func,
	  onHide: _propTypes.default.func,
	  onFadeInStart: emptyFn,
	  onFadeOutStart: emptyFn,
	  onFadeInEnd: emptyFn,
	  onFadeOutEnd: emptyFn
	};
	var _default = InovuaOverlay;
	exports.default = _default;

/***/ },
/* 724 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function createHideOnClickOutsideAction(_ref) {
	  var getOverlayNode = _ref.getOverlayNode,
	    getActiveTargetNode = _ref.getActiveTargetNode,
	    onHide = _ref.onHide;
	  return function (event) {
	    var node = event.target;
	    var activeTargetNode = getActiveTargetNode();
	    var overlayNode = getOverlayNode();
	    if (!activeTargetNode || !overlayNode) {
	      return null;
	    }
	    if (overlayNode !== node && !overlayNode.contains(node) && activeTargetNode !== node && !activeTargetNode.contains(node)) {
	      onHide(event, {
	        target: null
	      });
	    }
	  };
	}
	var _default = createHideOnClickOutsideAction;
	exports.default = _default;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _separateEvents2 = _interopRequireDefault(__webpack_require__(730));
	var _registerEvents = __webpack_require__(729);
	var _generateHandlers = __webpack_require__(726);
	var _createHideOnClickOutsideAction = _interopRequireDefault(__webpack_require__(724));
	function eventManager(config) {
	  var _config$showEvent = config.showEvent,
	    showEvent = _config$showEvent === void 0 ? [] : _config$showEvent,
	    _config$hideEvent = config.hideEvent,
	    hideEvent = _config$hideEvent === void 0 ? [] : _config$hideEvent,
	    target = config.target,
	    hideOnScroll = config.hideOnScroll,
	    hideOnClickOutside = config.hideOnClickOutside,
	    hideOnEscape = config.hideOnEscape,
	    onShow = config.onShow,
	    onHide = config.onHide,
	    getShowDelay = config.getShowDelay,
	    getHideDelay = config.getHideDelay,
	    getVisible = config.getVisible,
	    _config$getOverlayNod = config.getOverlayNode,
	    getOverlayNode = _config$getOverlayNod === void 0 ? function () {} : _config$getOverlayNod,
	    getActiveTargetNode = config.getActiveTargetNode;
	  var timeoutState = {
	    showId: null,
	    hideId: null,
	    targetThatTriggeredEvent: null
	  };
	  var _separateEvents = (0, _separateEvents2.default)({
	      showEvent: showEvent,
	      hideEvent: hideEvent
	    }),
	    normalizedShowEvents = _separateEvents.normalizedShowEvents,
	    normalizedHideEvents = _separateEvents.normalizedHideEvents,
	    toggleEvents = _separateEvents.toggleEvents;
	  var showAction = (0, _generateHandlers.createShowHandler)({
	    timeoutState: timeoutState,
	    target: target,
	    getActiveTargetNode: getActiveTargetNode,
	    action: onShow,
	    getDelay: getShowDelay
	  });
	  if (normalizedShowEvents && onShow) {
	    (0, _registerEvents.registerListeners)({
	      events: normalizedShowEvents,
	      action: showAction
	    });
	  }
	  var hideAction = (0, _generateHandlers.createHideHandler)({
	    timeoutState: timeoutState,
	    target: target,
	    getActiveTargetNode: getActiveTargetNode,
	    action: onHide,
	    getDelay: getHideDelay
	  });
	  if (normalizedHideEvents && onHide) {
	    (0, _registerEvents.registerListeners)({
	      events: normalizedHideEvents,
	      action: hideAction
	    });
	  }
	  var toggleAction;
	  if (toggleEvents.length) {
	    toggleAction = (0, _generateHandlers.createToggleHandler)({
	      target: target,
	      getActiveTargetNode: getActiveTargetNode,
	      getVisible: getVisible,
	      onHide: hideAction,
	      onShow: showAction
	    });
	    (0, _registerEvents.registerListeners)({
	      events: toggleEvents,
	      action: toggleAction
	    });
	  }
	  var hideOnClickOutsideAction;
	  if (hideOnClickOutside) {
	    hideOnClickOutsideAction = (0, _createHideOnClickOutsideAction.default)({
	      getOverlayNode: getOverlayNode,
	      getActiveTargetNode: getActiveTargetNode,
	      onHide: hideAction
	    });
	    (0, _registerEvents.registerListeners)({
	      events: ['click'],
	      action: hideOnClickOutsideAction
	    });
	  }
	  var hideOnScrollAction;
	  if (hideOnScroll) {
	    hideOnScrollAction = function hideOnScrollAction(event) {
	      if (getVisible()) {
	        hideAction(event, {
	          target: null
	        });
	      }
	    };
	    (0, _registerEvents.registerListeners)({
	      events: ['scroll'],
	      action: hideOnScrollAction
	    });
	  }
	  var hideOnEscapeAction;
	  if (hideOnEscape) {
	    hideOnEscapeAction = function hideOnEscapeAction(event) {
	      if (getVisible() && event.key === 'Escape') {
	        hideAction(event, {
	          target: null
	        });
	      }
	    };
	    (0, _registerEvents.registerListeners)({
	      events: ['keydown'],
	      action: hideOnEscapeAction
	    });
	  }
	  var handleOverlayShowAction;
	  var handleOverlayHideAction;
	  if (normalizedHideEvents.indexOf('mouseleave') !== -1) {
	    handleOverlayShowAction = function handleOverlayShowAction(event) {
	      if (event.target === getOverlayNode()) {
	        var activeTargetNode = getActiveTargetNode();
	        showAction(event, {
	          target: activeTargetNode
	        });
	      }
	    };
	    (0, _registerEvents.registerListeners)({
	      events: ['mouseenter'],
	      action: handleOverlayShowAction
	    });
	    handleOverlayHideAction = function handleOverlayHideAction(event) {
	      if (event.target === getOverlayNode()) {
	        var activeTargetNode = getActiveTargetNode();
	        hideAction(event, {
	          target: activeTargetNode
	        });
	      }
	    };
	    (0, _registerEvents.registerListeners)({
	      events: ['mouseleave'],
	      action: handleOverlayHideAction
	    });
	  }
	  return {
	    unregister: function unregister() {
	      if (normalizedShowEvents && showAction) {
	        (0, _registerEvents.unregisterListeners)({
	          events: normalizedShowEvents,
	          action: showAction
	        });
	      }
	      if (normalizedHideEvents && hideAction) {
	        (0, _registerEvents.unregisterListeners)({
	          events: normalizedHideEvents,
	          action: hideAction
	        });
	      }
	      if (toggleEvents && toggleAction) {
	        (0, _registerEvents.unregisterListeners)({
	          events: toggleEvents,
	          action: toggleAction
	        });
	      }
	      if (hideOnClickOutsideAction) {
	        (0, _registerEvents.unregisterListeners)({
	          events: ['click'],
	          action: hideOnClickOutsideAction
	        });
	      }
	      if (hideOnScrollAction) {
	        (0, _registerEvents.unregisterListeners)({
	          events: ['scroll'],
	          action: hideOnScrollAction
	        });
	      }
	      if (handleOverlayShowAction) {
	        (0, _registerEvents.unregisterListeners)({
	          events: ['mouseenter'],
	          action: handleOverlayShowAction
	        });
	      }
	      if (handleOverlayHideAction) {
	        (0, _registerEvents.unregisterListeners)({
	          events: ['mouseleave'],
	          action: handleOverlayHideAction
	        });
	      }
	      if (hideOnEscapeAction) {
	        (0, _registerEvents.unregisterListeners)({
	          events: ['keydown'],
	          action: hideOnEscapeAction
	        });
	      }
	    }
	  };
	}
	var _default = eventManager;
	exports.default = _default;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createHideHandler = createHideHandler;
	exports.createShowHandler = createShowHandler;
	exports.createToggleHandler = createToggleHandler;
	var _matchesTarget = _interopRequireDefault(__webpack_require__(728));
	var _assign = _interopRequireDefault(__webpack_require__(26));
	function createShowHandler(_ref) {
	  var action = _ref.action,
	    target = _ref.target,
	    getDelay = _ref.getDelay,
	    timeoutState = _ref.timeoutState;
	  return function (event) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var delay = getDelay && getDelay();
	    if (config.target) {
	      event = (0, _assign.default)({}, event, {
	        target: config.target
	      });
	    }
	    var node = event.target;
	    if (!(0, _matchesTarget.default)(target, node)) {
	      return null;
	    }
	    var activeTargetNode = timeoutState.targetThatTriggeredEvent;
	    timeoutState.targetThatTriggeredEvent = node;
	    if (timeoutState.hideId) {
	      clearTimeout(timeoutState.hideId);
	      timeoutState.hideId = null;
	    }
	    if (delay) {
	      if (timeoutState.showId && activeTargetNode === node) {
	        return null;
	      }
	      if (timeoutState.showId) {
	        clearTimeout(timeoutState.showId);
	      }
	      timeoutState.showId = setTimeout(function () {
	        timeoutState.showId = null;
	        action(event);
	      }, delay);
	    } else {
	      action(event);
	    }
	  };
	}
	function createHideHandler(_ref2) {
	  var action = _ref2.action,
	    target = _ref2.target,
	    getDelay = _ref2.getDelay,
	    timeoutState = _ref2.timeoutState;
	  return function (event) {
	    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var delay = getDelay && getDelay();
	    if (config.target) {
	      event = (0, _assign.default)({}, event, {
	        target: config.target
	      });
	    }
	    var node = event.target;
	    if (config.target !== null) {
	      if (!(0, _matchesTarget.default)(target, node)) {
	        return null;
	      }
	    }
	    var activeTargetNode = timeoutState.targetThatTriggeredEvent;
	    timeoutState.targetThatTriggeredEvent = node;
	    if (activeTargetNode === node && timeoutState.showId) {
	      clearTimeout(timeoutState.showId);
	      timeoutState.showId = null;
	    }
	    if (delay) {
	      if (timeoutState.hideId && activeTargetNode === node) {
	        return null;
	      }
	      timeoutState.hideId = setTimeout(function () {
	        timeoutState.hideId = null;
	        action(event);
	      }, delay);
	    } else {
	      action(event);
	    }
	  };
	}
	function createToggleHandler(_ref3) {
	  var onHide = _ref3.onHide,
	    onShow = _ref3.onShow,
	    target = _ref3.target,
	    getActiveTargetNode = _ref3.getActiveTargetNode,
	    getVisible = _ref3.getVisible;
	  return function (event) {
	    var activeTargetNode = getActiveTargetNode();
	    var node = event.target;
	    if (!(0, _matchesTarget.default)(target, node)) {
	      return null;
	    }
	    if (getVisible() && node === activeTargetNode) {
	      onHide(event);
	    } else {
	      onShow(event);
	    }
	  };
	}

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _eventManager = _interopRequireDefault(__webpack_require__(725));
	var _default = _eventManager.default;
	exports.default = _default;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _matchesSelector = _interopRequireDefault(__webpack_require__(143));
	var _containsNode = _interopRequireDefault(__webpack_require__(71));
	function matchesTarget(target, node) {
	  if (node === document) {
	    return null;
	  }
	  if (target === node) {
	    return true;
	  }
	  if (typeof target === 'string' && (0, _matchesSelector.default)(node, target)) {
	    return true;
	  }
	  if ((0, _containsNode.default)(target, node)) {
	    return true;
	  }
	  return false;
	}
	var _default = matchesTarget;
	exports.default = _default;

/***/ },
/* 729 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerListeners = registerListeners;
	exports.unregisterListeners = unregisterListeners;
	function registerListeners(_ref) {
	  var events = _ref.events,
	    action = _ref.action;
	  events.forEach(function (eventName) {
	    if (eventName === 'mouseenter' || eventName === 'mouseleave' || eventName === 'scroll') {
	      document.addEventListener(eventName, action, {
	        capture: true
	      });
	    } else {
	      document.addEventListener(eventName, action);
	    }
	  });
	}
	function unregisterListeners(_ref2) {
	  var events = _ref2.events,
	    action = _ref2.action;
	  events.forEach(function (eventName) {
	    if (eventName === 'mouseenter' || eventName === 'mouseleave' || eventName === 'scroll') {
	      document.removeEventListener(eventName, action, {
	        capture: true
	      });
	    } else {
	      document.removeEventListener(eventName, action);
	    }
	  });
	}

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	function separateEvents(_ref) {
	  var showEvent = _ref.showEvent,
	    hideEvent = _ref.hideEvent;
	  if (!Array.isArray(showEvent) || !Array.isArray(hideEvent)) {
	    return {};
	  }
	  var normalizedShowEvents = (0, _toConsumableArray2.default)(showEvent);
	  var normalizedHideEvents = (0, _toConsumableArray2.default)(hideEvent);
	  var toggleEvents = [];
	  normalizedShowEvents.forEach(function (eventName, index) {
	    var searchIndex = normalizedHideEvents.indexOf(eventName);
	    if (searchIndex !== -1) {
	      toggleEvents.push(eventName);
	      delete normalizedShowEvents[index];
	      delete normalizedHideEvents[searchIndex];
	    }
	  });
	  normalizedShowEvents = normalizedShowEvents.filter(function (eventName) {
	    return eventName;
	  });
	  normalizedHideEvents = normalizedHideEvents.filter(function (eventName) {
	    return eventName;
	  });
	  return {
	    normalizedShowEvents: normalizedShowEvents,
	    normalizedHideEvents: normalizedHideEvents,
	    toggleEvents: toggleEvents
	  };
	}
	var _default = separateEvents;
	exports.default = _default;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _Overlay = _interopRequireDefault(__webpack_require__(723));
	var _default = _Overlay.default;
	exports.default = _default;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _getFocusableElements = _interopRequireDefault(__webpack_require__(580));
	var _default = _getFocusableElements.default;
	exports.default = _default;

/***/ },
/* 733 */
581,
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _default = _join.default;
	exports.default = _default;

/***/ },
/* 735 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function normalizeEvent(events) {
	  return Array.isArray(events) ? events : [events];
	}
	var _default = normalizeEvent;
	exports.default = _default;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _shouldComponentUpdate = _interopRequireDefault(__webpack_require__(218));
	var _default = _shouldComponentUpdate.default;
	exports.default = _default;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _Button = _interopRequireDefault(__webpack_require__(149));
	var _join = _interopRequireDefault(__webpack_require__(20));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var ICON_CLASS_NAME = 'inovua-react-pagination-toolbar__icon';
	var PaginationIcon = function PaginationIcon(props) {
	  var icon = props.icon,
	    size = props.size,
	    disabled = props.disabled,
	    action = props.action,
	    name = props.name,
	    theme = props.theme;
	  var className = (0, _join.default)(ICON_CLASS_NAME, "".concat(ICON_CLASS_NAME, "--named--").concat(name));
	  return _react.default.createElement(_Button.default, {
	    disabled: disabled,
	    className: className,
	    icon: (0, _react.cloneElement)(icon, {
	      width: size,
	      height: size
	    }),
	    onClick: action,
	    theme: theme
	  });
	};
	PaginationIcon.propTypes = {
	  name: _propTypes.default.string,
	  action: _propTypes.default.func,
	  disabled: _propTypes.default.bool,
	  icon: _propTypes.default.node,
	  size: _propTypes.default.number
	};
	var _default = PaginationIcon;
	exports.default = _default;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasPrevPage = exports.hasNextPage = exports.getSkipForPage = exports.getPageCount = exports.getCurrentPage = exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _autoBind = _interopRequireDefault(__webpack_require__(52));
	var _NumericInput = _interopRequireDefault(__webpack_require__(709));
	var _ComboBox = _interopRequireDefault(__webpack_require__(240));
	var _ToolBar = _interopRequireDefault(__webpack_require__(746));
	var _Separator = _interopRequireDefault(__webpack_require__(745));
	var _reactCleanProps = _interopRequireDefault(__webpack_require__(49));
	var _shouldComponentUpdate2 = _interopRequireDefault(__webpack_require__(56));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _PaginationIcon = _interopRequireDefault(__webpack_require__(737));
	var _getIcons = __webpack_require__(739);
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var stopPropagation = function stopPropagation(e) {
	  return e.stopPropagation();
	};
	var emptyObject = {};
	var PAGE_SIZES = [{
	  value: 5
	}, {
	  value: 10
	}, {
	  value: 20
	}, {
	  value: 25
	}, {
	  value: 40
	}, {
	  value: 50
	}, {
	  value: 100
	}];
	var ICONS = {
	  FIRST_PAGE: _getIcons.FIRST_PAGE,
	  LAST_PAGE: _getIcons.LAST_PAGE,
	  PREV_PAGE: _getIcons.PREV_PAGE,
	  NEXT_PAGE: _getIcons.NEXT_PAGE,
	  REFRESH: _getIcons.REFRESH
	};
	var CLASS_NAME = 'inovua-react-pagination-toolbar';
	var SPACER = _react.default.createElement("div", {
	  className: "".concat(CLASS_NAME, "__spacer")
	});
	var getPageCount = function getPageCount(_ref) {
	  var count = _ref.count,
	    limit = _ref.limit;
	  return Math.ceil(count / limit);
	};
	exports.getPageCount = getPageCount;
	var getSkipForPage = function getSkipForPage(_ref2) {
	  var page = _ref2.page,
	    limit = _ref2.limit;
	  return Math.max(0, limit * (page - 1));
	};
	exports.getSkipForPage = getSkipForPage;
	var getCurrentPage = function getCurrentPage(_ref3) {
	  var skip = _ref3.skip,
	    limit = _ref3.limit;
	  return Math.floor(skip / limit) + 1;
	};
	exports.getCurrentPage = getCurrentPage;
	var hasNextPage = function hasNextPage(_ref4) {
	  var skip = _ref4.skip,
	    limit = _ref4.limit,
	    count = _ref4.count;
	  return getCurrentPage({
	    skip: skip,
	    limit: limit
	  }) < getPageCount({
	    count: count,
	    limit: limit
	  });
	};
	exports.hasNextPage = hasNextPage;
	var hasPrevPage = function hasPrevPage(_ref5) {
	  var skip = _ref5.skip,
	    limit = _ref5.limit;
	  return getCurrentPage({
	    skip: skip,
	    limit: limit
	  }) > 1;
	};
	exports.hasPrevPage = hasPrevPage;
	var InovuaPaginationToolbar = function (_React$Component) {
	  (0, _inherits2.default)(InovuaPaginationToolbar, _React$Component);
	  var _super = _createSuper(InovuaPaginationToolbar);
	  function InovuaPaginationToolbar(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaPaginationToolbar);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
	      var skip = _this.getSkip(prevProps);
	      var limit = _this.getLimit(prevProps);
	      var pageCount = getPageCount({
	        count: prevProps.totalCount,
	        limit: limit
	      });
	      var currentPage = Math.min(pageCount, getCurrentPage({
	        skip: skip,
	        limit: limit
	      }));
	      var nextSkip = _this.getSkip(_this.props);
	      var nextLimit = _this.getLimit(_this.props);
	      var nextPageCount = getPageCount({
	        count: _this.props.totalCount,
	        limit: nextLimit
	      });
	      var nextCurrentPage = Math.min(nextPageCount, getCurrentPage({
	        skip: nextSkip,
	        limit: nextLimit
	      }));
	      if (prevProps.totalCount !== _this.props.totalCount || currentPage !== nextCurrentPage) {
	        _this.forceUpdate(function () {
	          _this.setCurrentPageInputValue(nextCurrentPage, _this.props);
	        });
	      }
	    });
	    (0, _autoBind.default)((0, _assertThisInitialized2.default)(_this));
	    _this.state = {
	      skip: props.defaultSkip,
	      limit: props.defaultLimit
	    };
	    _this.ACTIONS = {
	      REFRESH: _this.refresh,
	      FIRST_PAGE: _this.gotoFirstPage,
	      LAST_PAGE: _this.gotoLastPage,
	      PREV_PAGE: _this.gotoPrevPage,
	      NEXT_PAGE: _this.gotoNextPage
	    };
	    _this.refNumberInput = function (cmp) {
	      _this.numberInput = cmp;
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaPaginationToolbar, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _shouldComponentUpdate2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: "getSkip",
	    value: function getSkip() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      return props.skip === undefined ? this.state.skip : props.skip;
	    }
	  }, {
	    key: "getLimit",
	    value: function getLimit() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      return props.limit === undefined ? this.state.limit : props.limit;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	        totalCount = _this$props.totalCount,
	        theme = _this$props.theme,
	        rtl = _this$props.rtl,
	        remotePagination = _this$props.remotePagination,
	        rootClassName = _this$props.rootClassName,
	        changeButtonStyles = _this$props.changeButtonStyles;
	      var skip = this.getSkip();
	      var limit = this.getLimit();
	      var skipLimitCount = {
	        skip: skip,
	        limit: limit,
	        count: totalCount
	      };
	      var currentPage = getCurrentPage(skipLimitCount);
	      var pageCount = getPageCount(skipLimitCount);
	      var firstPage = this.renderIcon('FIRST_PAGE', currentPage <= 1);
	      var lastPage = this.renderIcon('LAST_PAGE', currentPage >= pageCount);
	      var prevPage = this.renderIcon('PREV_PAGE', !hasPrevPage(skipLimitCount));
	      var nextPage = this.renderIcon('NEXT_PAGE', !hasNextPage(skipLimitCount));
	      var refresh = remotePagination ? this.renderIcon('REFRESH', false) : null;
	      var start = totalCount ? skip + 1 : 0;
	      var end = Math.min(skip + limit, totalCount);
	      var className = (0, _join.default)(this.props.className, CLASS_NAME, theme && "".concat(CLASS_NAME, "--theme-").concat(theme), "".concat(CLASS_NAME, "--").concat(rtl ? 'rtl' : 'ltr'), this.props.bordered && "".concat(CLASS_NAME, "--bordered"));
	      var combo = this.renderPageSizeCombo();
	      var currentPageInput = this.renderCurrentPageInput({
	        pageCount: pageCount,
	        currentPage: currentPage
	      });
	      var domProps = _objectSpread(_objectSpread({}, (0, _reactCleanProps.default)(this.props, InovuaPaginationToolbar.propTypes)), {}, {
	        className: className,
	        theme: theme
	      });
	      var result;
	      if (this.props.renderToolbar) {
	        result = this.props.renderToolbar(domProps, {
	          gotoFirstPageIcon: firstPage,
	          gotoLastPageIcon: lastPage,
	          gotoPrevPageIcon: prevPage,
	          gotoNextPageIcon: nextPage,
	          refreshIcon: refresh,
	          pageSizeCombo: combo,
	          start: start,
	          end: end,
	          totalCount: totalCount,
	          currentPageInput: currentPageInput
	        });
	        if (result !== undefined) {
	          return result;
	        }
	      }
	      return _react.default.createElement(_ToolBar.default, _objectSpread(_objectSpread({}, domProps), {}, {
	        useTransformOnScroll: false,
	        onKeyDown: stopPropagation,
	        rtl: rtl
	      }), _react.default.createElement("div", {
	        className: "".concat(CLASS_NAME, "__region")
	      }, firstPage, prevPage, _react.default.createElement("span", {
	        className: "".concat(CLASS_NAME, "__page-text")
	      }, this.props.pageText), ' ', currentPageInput, " ", this.props.ofText, ' ', _react.default.createElement("span", {
	        className: "".concat(CLASS_NAME, "__page-count-text"),
	        style: {
	          minWidth: Math.max("".concat(pageCount).length * 10, 25)
	        }
	      }, ' ' + (pageCount.toLocaleString ? pageCount.toLocaleString() : pageCount)), nextPage, lastPage, _react.default.createElement(_Separator.default, null), _react.default.createElement("span", {
	        className: "".concat(CLASS_NAME, "__per-page-text")
	      }, this.props.pageSizes === false ? null : this.props.perPageText), ' ', combo, this.props.pageSizes !== false && refresh ? _react.default.createElement(_Separator.default, null) : null, refresh), SPACER, _react.default.createElement("div", {
	        className: "".concat(CLASS_NAME, "__region")
	      }, this.props.showingText, ' ', start.toLocaleString ? start.toLocaleString() : start, " -", ' ', end.toLocaleString ? end.toLocaleString() : end, " ", this.props.ofText, ' ', totalCount.toLocaleString ? totalCount.toLocaleString() : totalCount));
	    }
	  }, {
	    key: "renderCurrentPageInput",
	    value: function renderCurrentPageInput(_ref6) {
	      var pageCount = _ref6.pageCount,
	        currentPage = _ref6.currentPage;
	      var inputProps = {
	        updateOnArrowKeys: false,
	        className: "".concat(CLASS_NAME, "__current-page"),
	        onBlur: this.onBlur,
	        ref: this.refNumberInput,
	        defaultValue: currentPage,
	        currentPage: currentPage,
	        onChange: this.onNumberInputChange,
	        enableClearButton: false,
	        allowFloat: false,
	        allowNegative: false,
	        rtl: this.props.rtl,
	        minValue: 1,
	        maxValue: pageCount,
	        style: {
	          minWidth: 70
	        },
	        size: "".concat(pageCount).length,
	        theme: this.props.theme
	      };
	      var result;
	      if (this.props.renderCurrentPageInput) {
	        result = this.props.renderCurrentPageInput(inputProps);
	      }
	      if (result === undefined) {
	        delete inputProps.currentPage;
	        result = _react.default.createElement(_NumericInput.default, _objectSpread({}, inputProps));
	      }
	      return result;
	    }
	  }, {
	    key: "renderPageSizeCombo",
	    value: function renderPageSizeCombo() {
	      var _comboProps;
	      if (this.props.pageSizes === false) {
	        return null;
	      }
	      var limit = this.getLimit();
	      var comboProps = (_comboProps = {
	        shadow: false,
	        style: {
	          minWidth: 70,
	          width: 70
	        },
	        className: "".concat(CLASS_NAME, "__page-size-combo"),
	        borderRadius: 0,
	        idProperty: 'value',
	        displayProperty: 'value',
	        value: limit,
	        renderListComponent: this.props.renderPageList,
	        constrainTo: this.props.constrainTo,
	        onChange: this.setPageSize,
	        dataSource: this.props.pageSizes ? this.props.pageSizes.map(function (s) {
	          return {
	            value: s
	          };
	        }) : PAGE_SIZES,
	        collapseOnSelect: true,
	        changeValueOnNavigation: false,
	        multiple: false,
	        searchable: false,
	        clearIcon: false
	      }, (0, _defineProperty2.default)(_comboProps, "shadow", true), (0, _defineProperty2.default)(_comboProps, "rtl", this.props.rtl), (0, _defineProperty2.default)(_comboProps, "showShadowOnMouseOver", true), (0, _defineProperty2.default)(_comboProps, "allowSelectionToggle", false), (0, _defineProperty2.default)(_comboProps, "highlightFirst", false), (0, _defineProperty2.default)(_comboProps, "theme", this.props.theme), _comboProps);
	      var result;
	      if (this.props.renderPageSizeCombo) {
	        result = this.props.renderPageSizeCombo(comboProps);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement(_ComboBox.default, _objectSpread(_objectSpread({}, comboProps), {}, {
	          relativeToViewport: true
	        }));
	      }
	      return result;
	    }
	  }, {
	    key: "renderIcon",
	    value: function renderIcon(name, disabled) {
	      var icons = this.props.icons || ICONS;
	      var icon = icons[name];
	      if (this.props.rtl) {
	        if (name === 'LAST_PAGE') {
	          icon = icons['FIRST_PAGE'];
	        } else if (name === 'FIRST_PAGE') {
	          icon = icons['LAST_PAGE'];
	        }
	        if (name === 'NEXT_PAGE') {
	          icon = icons['PREV_PAGE'];
	        } else if (name === 'PREV_PAGE') {
	          icon = icons['NEXT_PAGE'];
	        }
	      }
	      var iconProps = {
	        name: name,
	        size: this.props.iconSize,
	        icon: icon,
	        disabled: disabled,
	        action: this.ACTIONS[name],
	        theme: this.props.theme
	      };
	      var result;
	      if (this.props.renderIcon) {
	        result = this.props.renderIcon(iconProps);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement(_PaginationIcon.default, _objectSpread({}, iconProps));
	      }
	      return result;
	    }
	  }, {
	    key: "setCurrentPageInputValue",
	    value: function setCurrentPageInputValue(value) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
	      this.lastNotifiedSkip = getSkipForPage({
	        page: value,
	        limit: this.getLimit(props)
	      });
	      if (this.numberInput && typeof this.numberInput.setValue === 'function') {
	        this.numberInput.setValue("".concat(value));
	      }
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur() {
	      var currentPage = getCurrentPage({
	        skip: this.getSkip(),
	        limit: this.getLimit()
	      });
	      this.setCurrentPageInputValue(currentPage);
	    }
	  }, {
	    key: "onNumberInputChange",
	    value: function onNumberInputChange(numericValue) {
	      this.gotoPage(numericValue || 1);
	    }
	  }, {
	    key: "setPageSize",
	    value: function setPageSize(limit) {
	      var currentSkip = this.getSkip();
	      var currentPage = getCurrentPage({
	        skip: currentSkip,
	        limit: this.getLimit()
	      });
	      var maxPage = getPageCount({
	        count: this.props.totalCount,
	        limit: limit
	      });
	      var newPage = Math.min(currentPage, maxPage);
	      var newSkip = getSkipForPage({
	        page: newPage,
	        limit: limit
	      });
	      if (this.props.onPageSizeChange) {
	        this.props.onPageSizeChange(limit);
	      }
	      if (this.props.onLimitChange) {
	        this.props.onLimitChange(limit);
	      }
	      if (this.props.limit === undefined) {
	        this.setState({
	          limit: limit
	        });
	      }
	      if (newSkip != currentSkip && this.props.adjustSkipOnLimitChange) {
	        this.gotoPage(newPage, {
	          limit: limit
	        });
	      }
	    }
	  }, {
	    key: "gotoPage",
	    value: function gotoPage(page) {
	      var _this2 = this;
	      var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyObject,
	        _ref7$limit = _ref7.limit,
	        limit = _ref7$limit === void 0 ? this.getLimit() : _ref7$limit;
	      var skip = getSkipForPage({
	        page: page,
	        limit: limit
	      });
	      if (this.lastNotifiedSkip === skip) {
	        return;
	      }
	      setTimeout(function () {
	        delete _this2.lastNotifiedSkip;
	      }, 50);
	      this.lastNotifiedSkip = skip;
	      if (this.props.onPageChange) {
	        this.props.onPageChange(page);
	      }
	      if (this.props.onSkipChange) {
	        this.props.onSkipChange(skip);
	      }
	      if (this.props.skip === undefined) {
	        this.setCurrentPageInputValue("".concat(page));
	        this.setState({
	          skip: skip
	        });
	      }
	    }
	  }, {
	    key: "refresh",
	    value: function refresh() {
	      if (this.props.onRefresh) {
	        this.props.onRefresh();
	      }
	    }
	  }, {
	    key: "gotoFirstPage",
	    value: function gotoFirstPage() {
	      this.gotoPage(1);
	    }
	  }, {
	    key: "gotoLastPage",
	    value: function gotoLastPage() {
	      var lastPage = getPageCount({
	        count: this.props.totalCount,
	        limit: this.getLimit()
	      });
	      this.gotoPage(lastPage);
	    }
	  }, {
	    key: "gotoNextPage",
	    value: function gotoNextPage() {
	      var nextPage = getCurrentPage({
	        skip: this.getSkip(),
	        limit: this.getLimit()
	      }) + 1;
	      this.gotoPage(nextPage);
	    }
	  }, {
	    key: "gotoPrevPage",
	    value: function gotoPrevPage() {
	      var prevPage = getCurrentPage({
	        skip: this.getSkip(),
	        limit: this.getLimit()
	      }) - 1;
	      this.gotoPage(prevPage);
	    }
	  }]);
	  return InovuaPaginationToolbar;
	}(_react.default.Component);
	exports.default = InovuaPaginationToolbar;
	InovuaPaginationToolbar.defaultProps = {
	  adjustSkipOnLimitChange: true,
	  theme: 'default-light',
	  bordered: true,
	  iconSize: 24,
	  rtl: false,
	  remotePagination: false,
	  pageText: 'Page ',
	  ofText: ' of ',
	  perPageText: 'Results per page',
	  showingText: 'Showing ',
	  rootClassName: 'inovua-react-pagination-toolbar'
	};
	InovuaPaginationToolbar.propTypes = {
	  adjustSkipOnLimitChange: _propTypes.default.bool,
	  pagination: _propTypes.default.any,
	  bordered: _propTypes.default.bool,
	  iconSize: _propTypes.default.number,
	  pageText: _propTypes.default.node,
	  ofText: _propTypes.default.node,
	  perPageText: _propTypes.default.node,
	  showingText: _propTypes.default.node,
	  limit: _propTypes.default.number,
	  defaultLimit: _propTypes.default.number,
	  skip: _propTypes.default.number,
	  defaultSkip: _propTypes.default.number,
	  totalCount: _propTypes.default.number,
	  gotoNextPage: _propTypes.default.func,
	  gotoPrevPage: _propTypes.default.func,
	  pageSize: _propTypes.default.number,
	  currentPage: _propTypes.default.number,
	  pageCount: _propTypes.default.number,
	  gotoPage: _propTypes.default.func,
	  onRefresh: _propTypes.default.func,
	  hasNextPage: _propTypes.default.func,
	  hasPrevPage: _propTypes.default.func,
	  gotoLastPage: _propTypes.default.func,
	  gotoFirstPage: _propTypes.default.func,
	  remotePagination: _propTypes.default.bool,
	  localPagination: _propTypes.default.any,
	  renderPageList: _propTypes.default.any,
	  reload: _propTypes.default.any,
	  constrainTo: _propTypes.default.any,
	  onPageChange: _propTypes.default.func,
	  onSkipChange: _propTypes.default.func,
	  onLimitChange: _propTypes.default.func,
	  onPageSizeChange: _propTypes.default.func,
	  pageSizes: _propTypes.default.arrayOf(_propTypes.default.number),
	  renderCurrentPageInput: _propTypes.default.func,
	  rootClassName: _propTypes.default.string,
	  renderIcon: _propTypes.default.func,
	  renderPageSizeCombo: _propTypes.default.func,
	  renderToolbar: _propTypes.default.func,
	  rtl: _propTypes.default.bool,
	  theme: _propTypes.default.string
	};

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.REFRESH = exports.PREV_PAGE = exports.NEXT_PAGE = exports.LAST_PAGE = exports.FIRST_PAGE = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(44));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _excluded = ["size"];
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var emptyObject = {};
	var SIZE = 20;
	var getIcons = function getIcons() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyObject,
	    size = _ref.size,
	    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
	  size = size || SIZE;
	  var FIRST_PAGE = _react.default.createElement("svg", _objectSpread(_objectSpread({}, props), {}, {
	    height: size,
	    viewBox: "0 0 24 24",
	    width: size
	  }), _react.default.createElement("path", {
	    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
	  }));
	  var LAST_PAGE = _react.default.createElement("svg", _objectSpread(_objectSpread({}, props), {}, {
	    height: size,
	    viewBox: "0 0 24 24",
	    width: size
	  }), _react.default.createElement("path", {
	    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
	  }));
	  var PREV_PAGE = _react.default.createElement("svg", _objectSpread(_objectSpread({}, props), {}, {
	    height: size,
	    viewBox: "0 0 24 24",
	    width: size
	  }), _react.default.createElement("path", {
	    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
	  }));
	  var NEXT_PAGE = _react.default.createElement("svg", _objectSpread(_objectSpread({}, props), {}, {
	    height: size,
	    viewBox: "0 0 24 24",
	    width: size
	  }), _react.default.createElement("path", {
	    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
	  }));
	  var REFRESH = _react.default.createElement("svg", _objectSpread(_objectSpread({}, props), {}, {
	    height: size,
	    viewBox: "0 0 24 24",
	    width: size
	  }), _react.default.createElement("path", {
	    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
	  }));
	  return {
	    FIRST_PAGE: FIRST_PAGE,
	    LAST_PAGE: LAST_PAGE,
	    PREV_PAGE: PREV_PAGE,
	    NEXT_PAGE: NEXT_PAGE,
	    REFRESH: REFRESH
	  };
	};
	var _getIcons = getIcons(),
	  FIRST_PAGE = _getIcons.FIRST_PAGE,
	  LAST_PAGE = _getIcons.LAST_PAGE,
	  PREV_PAGE = _getIcons.PREV_PAGE,
	  NEXT_PAGE = _getIcons.NEXT_PAGE,
	  REFRESH = _getIcons.REFRESH;
	exports.REFRESH = REFRESH;
	exports.NEXT_PAGE = NEXT_PAGE;
	exports.PREV_PAGE = PREV_PAGE;
	exports.LAST_PAGE = LAST_PAGE;
	exports.FIRST_PAGE = FIRST_PAGE;
	var _default = getIcons;
	exports.default = _default;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	exports.default = void 0;
	var _PaginationToolbar = _interopRequireWildcard(__webpack_require__(738));
	Object.keys(_PaginationToolbar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  if (key in exports && exports[key] === _PaginationToolbar[key]) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _PaginationToolbar[key];
	    }
	  });
	});
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var _default = _PaginationToolbar.default;
	exports.default = _default;

/***/ },
/* 741 */
[1296, 743],
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _CheckBox = _interopRequireDefault(__webpack_require__(155));
	var _join = _interopRequireDefault(__webpack_require__(20));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var defaultCheckedIcon = function defaultCheckedIcon(_ref) {
	  var style = _ref.style,
	    _ref$size = _ref.size,
	    size = _ref$size === void 0 ? 16 : _ref$size;
	  return _react.default.createElement("svg", {
	    style: style,
	    width: size,
	    height: size,
	    viewBox: "0 0 16 16"
	  }, _react.default.createElement("circle", {
	    cx: "8",
	    cy: "8",
	    r: "7",
	    fill: "none",
	    fillRule: "evenodd",
	    strokeWidth: "2"
	  }), _react.default.createElement("circle", {
	    cx: "8",
	    cy: "8",
	    r: "3",
	    fillRule: "evenodd",
	    stroke: "none"
	  }));
	};
	var defaultUncheckedIcon = function defaultUncheckedIcon(_ref2) {
	  var style = _ref2.style,
	    _ref2$size = _ref2.size,
	    size = _ref2$size === void 0 ? 16 : _ref2$size;
	  return _react.default.createElement("svg", {
	    style: style,
	    width: size,
	    height: size,
	    viewBox: "0 0 16 16"
	  }, _react.default.createElement("circle", {
	    cx: "8",
	    cy: "8",
	    r: "7",
	    fill: "none",
	    fillRule: "evenodd",
	    strokeWidth: "2"
	  }));
	};
	var InovuaRadioButton = function (_Component) {
	  (0, _inherits2.default)(InovuaRadioButton, _Component);
	  var _super = _createSuper(InovuaRadioButton);
	  function InovuaRadioButton() {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaRadioButton);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderNativeBrowserInput", function (config) {
	      if (props.renderNativeBrowserInput) {
	        return renderNativeBrowserInput(config);
	      }
	      config.inputProps.type = 'radio';
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
	      var props = _this.props;
	      var checkedIcon = defaultCheckedIcon || props.checkedIcon;
	      var uncheckedIcon = defaultUncheckedIcon || props.uncheckedIcon;
	      var className = (0, _join.default)("".concat(props.rootClassName), props.theme && "".concat(props.rootClassName, "--theme-").concat(props.theme));
	      var checkboxProps = _objectSpread(_objectSpread({}, props), {}, {
	        className: className,
	        checkedIcon: checkedIcon,
	        uncheckedIcon: uncheckedIcon,
	        renderNativeBrowserInput: _this.renderNativeBrowserInput
	      });
	      return _react.default.createElement(_CheckBox.default, _objectSpread({}, checkboxProps));
	    });
	    return _this;
	  }
	  return (0, _createClass2.default)(InovuaRadioButton);
	}(_react.Component);
	InovuaRadioButton.defaultProps = {
	  theme: 'default-light',
	  rootClassName: 'inovua-react-toolkit-radio-button'
	};
	InovuaRadioButton.propTypes = {
	  theme: _propTypes.default.string,
	  rootClassName: _propTypes.default.string
	};
	var _default = InovuaRadioButton;
	exports.default = _default;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _RadioButton = _interopRequireDefault(__webpack_require__(742));
	var _default = _RadioButton.default;
	exports.default = _default;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _autoBind = _interopRequireDefault(__webpack_require__(52));
	var _Field = _interopRequireDefault(__webpack_require__(244));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var preventDefault = function preventDefault(e) {
	  return e.preventDefault();
	};
	var getClearButtonClassNames = function getClearButtonClassNames(props) {
	  var clearButtonClassName = (0, _join.default)("".concat(props.rootClassName, "__clear-button"), props.clearButtonClassName);
	  return {
	    clearButtonClassName: clearButtonClassName
	  };
	};
	var isControlled = function isControlled(props) {
	  return props.value !== undefined;
	};
	var emptyObject = {};
	var TextInput = function (_Component) {
	  (0, _inherits2.default)(TextInput, _Component);
	  var _super = _createSuper(TextInput);
	  function TextInput(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, TextInput);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderClearIcon", function (svgProps) {
	      var result;
	      if (_this.props.renderClearIcon && typeof _this.props.renderClearIcon === 'function') {
	        result = _this.props.renderClearIcon(_objectSpread({}, svgProps));
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("svg", {
	          style: _objectSpread({}, svgProps),
	          viewBox: "0 0 10 10"
	        }, _react.default.createElement("path", {
	          fill: "none",
	          fillRule: "evenodd",
	          strokeLinecap: "round",
	          strokeWidth: "1.33",
	          d: "M1 1l8 8m0-8L1 9"
	        }));
	      }
	      return result;
	    });
	    _this.fieldRef = function (field) {
	      _this.field = field;
	    };
	    _this.state = {
	      focused: false,
	      value: props.defaultValue == null ? '' : props.defaultValue
	    };
	    (0, _autoBind.default)((0, _assertThisInitialized2.default)(_this));
	    return _this;
	  }
	  (0, _createClass2.default)(TextInput, [{
	    key: "handleChange",
	    value: function handleChange(value, event) {
	      this.setValue(value, event);
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.field.focus();
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value, event) {
	      if (!isControlled(this.props)) {
	        this.setState({
	          value: value
	        });
	      }
	      if (this.props.inputProps && this.props.inputProps.onChange) {
	        this.props.inputProps.onChange(value, event);
	      }
	      if (this.props.onChange) {
	        this.props.onChange(value, event);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props,
	        state = this.state;
	      var wrapperProps = props.wrapperProps,
	        style = props.style,
	        enableClearButton = props.enableClearButton;
	      var inputProps = props.inputProps || emptyObject;
	      var inputClassName = (0, _join.default)("".concat(props.rootClassName, "__input"), inputProps.className);
	      var value = isControlled(props) ? props.value : state.value;
	      var fieldProps = _objectSpread(_objectSpread({
	        size: 1
	      }, inputProps), {}, {
	        ref: this.fieldRef,
	        className: inputClassName,
	        onChange: this.handleChange,
	        value: value,
	        type: props.type,
	        stopChangePropagation: props.stopChangePropagation
	      });
	      if (props.hidden) {
	        fieldProps.hidden = props.hidden;
	      }
	      if (props.name) {
	        fieldProps.name = props.name;
	      }
	      if (props.placeholder) {
	        fieldProps.placeholder = props.placeholder;
	      }
	      if (props.required) {
	        fieldProps.required = props.required;
	      }
	      if (props.readOnly) {
	        fieldProps.readOnly = props.readOnly;
	      }
	      if (props.autoFocus) {
	        fieldProps.autoFocus = props.autoFocus;
	      }
	      if (props.maxLength != undefined) {
	        fieldProps.maxLength = props.maxLength;
	      }
	      if (props.minLength != undefined) {
	        fieldProps.minLength = props.minLength;
	      }
	      if (props.size != undefined) {
	        fieldProps.size = props.size;
	      }
	      if (props.disabled) {
	        fieldProps.disabled = props.disabled;
	      }
	      var className = (0, _join.default)(props.rootClassName, props.className, props.rtl ? "".concat(props.rootClassName, "--rtl") : "".concat(props.rootClassName, "--ltr"), props.theme && "".concat(props.rootClassName, "--theme-").concat(props.theme), enableClearButton && "".concat(props.rootClassName, "--enable-clear-button"), state.focused && "".concat(props.rootClassName, "--focused"), fieldProps.disabled && "".concat(props.rootClassName, "--disabled"));
	      var input = _react.default.createElement(_Field.default, _objectSpread({}, fieldProps));
	      var wrapperDomProps = (0, _cleanProps.default)(wrapperProps, TextInput.propTypes);
	      var domProps = (0, _cleanProps.default)(props, TextInput.propTypes);
	      delete domProps.onChange;
	      return _react.default.createElement("div", _objectSpread(_objectSpread(_objectSpread({}, domProps), wrapperDomProps), {}, {
	        className: className,
	        style: style,
	        onBlur: this.onBlur,
	        onClick: this.onClick,
	        onFocus: this.onFocus
	      }), input, this.renderClearButtonWrapper(fieldProps));
	    }
	  }, {
	    key: "handleClearButtonClick",
	    value: function handleClearButtonClick(event) {
	      this.setState({
	        focused: true
	      });
	      this.setValue('');
	      this.focus();
	    }
	  }, {
	    key: "renderClearButtonWrapper",
	    value: function renderClearButtonWrapper(fieldProps) {
	      var props = this.props,
	        state = this.state;
	      var clearButtonColor = props.clearButtonColor,
	        clearButtonStyle = props.clearButtonStyle,
	        clearButtonSize = props.clearButtonSize,
	        enableClearButton = props.enableClearButton,
	        rootClassName = props.rootClassName;
	      var value = isControlled(props) ? props.value : state.value;
	      var emptyValue = value == '' || value == null;
	      var showButton = enableClearButton && !emptyValue && !fieldProps.disabled && !fieldProps.readOnly;
	      return _react.default.createElement("div", {
	        key: "clearButton",
	        className: (0, _join.default)("".concat(rootClassName, "__clear-button-wrapper"), !showButton && "".concat(rootClassName, "__clear-button-wrapper--hidden"))
	      }, this.renderClearButton(_objectSpread({
	        clearButtonColor: clearButtonColor,
	        clearButtonStyle: clearButtonStyle,
	        clearButtonSize: clearButtonSize
	      }, getClearButtonClassNames(props))));
	    }
	  }, {
	    key: "renderClearButton",
	    value: function renderClearButton(config) {
	      var clearButtonColor = config.clearButtonColor,
	        clearButtonStyle = config.clearButtonStyle,
	        clearButtonClassName = config.clearButtonClassName,
	        clearButtonSize = config.clearButtonSize;
	      var svgProps = {};
	      var tabIndex = this.props.acceptClearToolFocus ? 0 : -1;
	      if (clearButtonColor) {
	        svgProps.fill = clearButtonColor;
	      }
	      if (clearButtonSize) {
	        if (Array.isArray(clearButtonSize)) {
	          svgProps.width = clearButtonSize[0];
	          svgProps.height = clearButtonSize[1];
	        } else {
	          svgProps.width = clearButtonSize;
	          svgProps.height = clearButtonSize;
	        }
	      }
	      return _react.default.createElement("button", {
	        key: "clearButton",
	        type: "button",
	        onClick: this.handleClearButtonClick,
	        onMouseDown: preventDefault,
	        className: clearButtonClassName,
	        style: _objectSpread({}, clearButtonStyle),
	        tabIndex: tabIndex
	      }, this.renderClearIcon(svgProps));
	    }
	  }, {
	    key: "onClick",
	    value: function onClick(event) {
	      if (!this.state.focused) {
	        this.focus();
	      }
	      if (this.props.wrapperProps && this.props.wrapperProps.onClick) {
	        this.props.wrapperProps.onClick(event);
	      }
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur(event) {
	      this.setState({
	        focused: false
	      });
	      if (this.props.onBlur) {
	        this.props.onBlur(event);
	      }
	    }
	  }, {
	    key: "onFocus",
	    value: function onFocus(event) {
	      this.setState({
	        focused: true
	      });
	      if (this.props.onFocus) {
	        this.props.onFocus(event);
	      }
	    }
	  }]);
	  return TextInput;
	}(_react.Component);
	TextInput.defaultProps = {
	  hidden: false,
	  type: 'text',
	  theme: 'default-light',
	  rootClassName: 'inovua-react-toolkit-text-input',
	  enableClearButton: true,
	  clearButtonSize: 10,
	  stopChangePropagation: true,
	  acceptClearToolFocus: false
	};
	TextInput.propTypes = {
	  type: _propTypes.default.string,
	  theme: _propTypes.default.string,
	  name: _propTypes.default.string,
	  placeholder: _propTypes.default.string,
	  autoFocus: _propTypes.default.bool,
	  maxLength: _propTypes.default.number,
	  size: _propTypes.default.number,
	  minLength: _propTypes.default.number,
	  required: _propTypes.default.bool,
	  readOnly: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  hidden: _propTypes.default.bool,
	  stopChangePropagation: _propTypes.default.bool,
	  enableClearButton: _propTypes.default.bool,
	  acceptClearToolFocus: _propTypes.default.bool,
	  rtl: _propTypes.default.bool,
	  rootClassName: _propTypes.default.string,
	  clearButtonSize: _propTypes.default.number,
	  clearButtonColor: _propTypes.default.string,
	  clearButtonStyle: _propTypes.default.object,
	  clearButtonClassName: _propTypes.default.string,
	  renderClearIcon: _propTypes.default.func
	};
	var _default = TextInput;
	exports.default = _default;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _src = __webpack_require__(258);
	var _default = _src.Separator;
	exports.default = _default;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Separator", {
	  enumerable: true,
	  get: function get() {
	    return _src.Separator;
	  }
	});
	exports.default = void 0;
	var _src = _interopRequireWildcard(__webpack_require__(258));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var _default = _src.default;
	exports.default = _default;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Separator = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _cleanProps = _interopRequireDefault(__webpack_require__(32));
	var _join = _interopRequireDefault(__webpack_require__(20));
	var _ArrowScroller = _interopRequireDefault(__webpack_require__(227));
	var _DropdownOverflow = _interopRequireDefault(__webpack_require__(257));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var InovuaToolbar = function (_Component) {
	  (0, _inherits2.default)(InovuaToolbar, _Component);
	  var _super = _createSuper(InovuaToolbar);
	  function InovuaToolbar(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaToolbar);
	    _this = _super.call(this, props);
	    _this.setRootRef = function (ref) {
	      _this.node = ref;
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaToolbar, [{
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var className = props.className;
	      var rootProps = _objectSpread(_objectSpread({
	        useTransformOnScroll: props.useTransformOnScroll,
	        ref: this.setRootRef
	      }, (0, _cleanProps.default)(props, InovuaToolbar.propTypes)), {}, {
	        className: className,
	        rtl: props.rtl,
	        rootClassName: props.rootClassName,
	        theme: props.theme
	      });
	      return props.overflowStrategy === 'scroll' ? _react.default.createElement(_ArrowScroller.default, _objectSpread(_objectSpread({}, rootProps), this.getScrollerProps())) : _react.default.createElement(_DropdownOverflow.default, _objectSpread(_objectSpread({}, rootProps), this.getDropdownOverflowProps()));
	    }
	  }, {
	    key: "scrollIntoView",
	    value: function scrollIntoView(node) {
	      return this.node && this.node.scrollIntoView(node);
	    }
	  }, {
	    key: "getInstance",
	    value: function getInstance() {
	      return this.node;
	    }
	  }, {
	    key: "getClassName",
	    value: function getClassName() {
	      var props = this.props;
	      return (0, _join.default)(this.props.className, props.rootClassName, props.theme && "".concat(props.rootClassName, "--theme-").concat(props.theme), props.changeButtonStyles && "".concat(props.rootClassName, "--change-button-styles"));
	    }
	  }, {
	    key: "getScrollerProps",
	    value: function getScrollerProps() {
	      var props = this.props;
	      var result = {
	        vertical: props.vertical,
	        scrollOnMouseEnter: props.scrollOnMouseEnter,
	        arrowSize: props.arrowSize,
	        className: (0, _join.default)(this.getClassName(), "".concat(props.rootClassName, "--arrowScroller"))
	      };
	      if (this.props.rtl) {
	        result.nativeScroll = false;
	      }
	      return result;
	    }
	  }, {
	    key: "getDropdownOverflowProps",
	    value: function getDropdownOverflowProps() {
	      var props = this.props;
	      return {
	        className: (0, _join.default)(this.getClassName(), "".concat(props.rootClassName, "--dropdown")),
	        constrainTo: props.constrainTo,
	        dropdownButtonProps: props.dropdownButtonProps,
	        renderDropdownButton: props.renderDropdownButton
	      };
	    }
	  }]);
	  return InovuaToolbar;
	}(_react.Component);
	InovuaToolbar.defaultProps = {
	  rootClassName: 'inovua-react-toolkit-toolbar',
	  vertical: false,
	  useTransformOnScroll: false,
	  changeButtonStyles: true,
	  rtl: false,
	  theme: 'default-light',
	  overflowStrategy: 'scroll'
	};
	InovuaToolbar.propTypes = {
	  rtl: _propTypes.default.bool,
	  rootClassName: _propTypes.default.string,
	  changeButtonStyles: _propTypes.default.bool,
	  scrollOnMouseEnter: _propTypes.default.bool,
	  theme: _propTypes.default.string,
	  constrainTo: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.bool, _propTypes.default.func]),
	  arrowSize: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    width: _propTypes.default.number,
	    height: _propTypes.default.number
	  })]),
	  overflowStrategy: _propTypes.default.oneOf(['scroll', 'dropdown']),
	  vertical: _propTypes.default.bool,
	  dropdownButtonProps: _propTypes.default.object,
	  renderDropdownButton: _propTypes.default.func,
	  useTransformOnScroll: _propTypes.default.bool
	};
	var Separator = function Separator(props) {
	  return _react.default.createElement("div", _objectSpread(_objectSpread({}, props), {}, {
	    className: (0, _join.default)(props.className, 'inovua-react-toolkit-toolbar__separator')
	  }));
	};
	exports.Separator = Separator;
	InovuaToolbar.Separator = Separator;
	var _default = InovuaToolbar;
	exports.default = _default;

/***/ },
/* 748 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function sum(a, b) {
	  return a + b;
	}
	function getGroupedItems(_ref) {
	  var boxes = _ref.boxes,
	    maxSize = _ref.maxSize,
	    _ref$overflowControlS = _ref.overflowControlSize,
	    overflowControlSize = _ref$overflowControlS === void 0 ? 0 : _ref$overflowControlS;
	  var boxesSize = boxes.reduce(sum);
	  if (boxesSize <= maxSize) {
	    return false;
	  }
	  var availableSize = maxSize - overflowControlSize;
	  var groups = boxes.reduce(function (acc, box, index) {
	    if (availableSize - box >= 0) {
	      acc.visibleIndexes.push(index);
	      availableSize -= box;
	    } else {
	      availableSize = 0;
	      acc.overflowIndexes.push(index);
	    }
	    return acc;
	  }, {
	    visibleIndexes: [],
	    overflowIndexes: []
	  });
	  return groups;
	}
	var _default = getGroupedItems;
	exports.default = _default;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	function assignFilter(filter, target) {
	  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	  var filteredArgs = args.map(function (obj) {
	    if (obj == null) {
	      return obj;
	    }
	    return Object.keys(obj).reduce(function (acc, propName) {
	      var value = obj[propName];
	      if (filter(value, propName, obj)) {
	        acc[propName] = value;
	      }
	      return acc;
	    }, {});
	  });
	  return Object.assign.apply(Object, [target].concat((0, _toConsumableArray2.default)(filteredArgs)));
	}
	var _default = assignFilter;
	exports.default = _default;

/***/ },
/* 750 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	function _default(obj, key, defaultValue, undef) {
	  var keys = key.split ? key.split('.') : Array.isArray(key) ? key : [key];
	  for (var propIndex = 0; propIndex < keys.length; propIndex++) {
	    obj = obj ? obj[keys[propIndex]] : undef;
	  }
	  return obj === undef ? defaultValue : obj;
	}

/***/ },
/* 751 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = once;
	function once(fn, scope) {
	  var called;
	  var result;
	  return function () {
	    if (called) {
	      return result;
	    }
	    called = true;
	    return result = fn && fn.apply(scope || this, arguments);
	  };
	}

/***/ },
/* 752 */
[1297, 85],
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	function shallowequal(object1, object2) {
	  if (object1 === object2) {
	    return true;
	  }
	  if ((0, _typeof2.default)(object1) !== 'object' || object1 === null || (0, _typeof2.default)(object2) !== 'object' || object2 === null) {
	    return false;
	  }
	  var keys1 = Object.keys(object1);
	  var keys2 = Object.keys(object2);
	  if (keys1.length !== keys2.length) {
	    return false;
	  }
	  var equal = true;
	  for (var i = 0, len = keys1.length; i < len; i++) {
	    var key = keys1[i];
	    if (object1[key] !== object2[key]) {
	      equal = false;
	      break;
	    }
	  }
	  return equal;
	}
	var _default = shallowequal;
	exports.default = _default;

/***/ },
/* 754 */
[1297, 86],
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _autoBind = _interopRequireDefault(__webpack_require__(52));
	var _reactCleanProps = _interopRequireDefault(__webpack_require__(49));
	var _shouldComponentUpdate2 = _interopRequireDefault(__webpack_require__(756));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _getGlobal = __webpack_require__(18);
	var _SIZES, _OTHER_SIZES, _MARGINS, _TRACK_SIDES;
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var HORIZONTAL = 'horizontal';
	var VERTICAL = 'vertical';
	var SIZES = (_SIZES = {}, (0, _defineProperty2.default)(_SIZES, VERTICAL, 'height'), (0, _defineProperty2.default)(_SIZES, HORIZONTAL, 'width'), _SIZES);
	var OTHER_SIZES = (_OTHER_SIZES = {}, (0, _defineProperty2.default)(_OTHER_SIZES, VERTICAL, 'width'), (0, _defineProperty2.default)(_OTHER_SIZES, HORIZONTAL, 'height'), _OTHER_SIZES);
	var MARGINS = (_MARGINS = {}, (0, _defineProperty2.default)(_MARGINS, VERTICAL, 'right'), (0, _defineProperty2.default)(_MARGINS, HORIZONTAL, 'bottom'), _MARGINS);
	var TRACK_SIDES = (_TRACK_SIDES = {}, (0, _defineProperty2.default)(_TRACK_SIDES, VERTICAL, ['top', 'bottom']), (0, _defineProperty2.default)(_TRACK_SIDES, HORIZONTAL, ['left', 'right']), _TRACK_SIDES);
	var STYLES = {
	  vertical: {
	    position: 'absolute',
	    top: 0,
	    bottom: 0,
	    right: 0,
	    contain: 'layout paint style'
	  },
	  horizontal: {
	    position: 'absolute',
	    left: 0,
	    right: 0,
	    bottom: 0,
	    contain: 'layout paint style'
	  }
	};
	var InovuaScrollbar = function (_Component) {
	  (0, _inherits2.default)(InovuaScrollbar, _Component);
	  var _super = _createSuper(InovuaScrollbar);
	  function InovuaScrollbar(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaScrollbar);
	    _this = _super.call(this, props);
	    (0, _autoBind.default)((0, _assertThisInitialized2.default)(_this));
	    _this.scrollPos = 0;
	    _this.state = {
	      scrollPos: 0
	    };
	    _this.refTrack = function (c) {
	      _this.trackNode = c;
	    };
	    _this.refThumb = function (c) {
	      _this.thumbNode = c;
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaScrollbar, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _shouldComponentUpdate2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible) {
	      this.visible = visible;
	      if (!visible && this.state.over) {
	        return;
	      }
	      if (this.state.visible === visible) {
	        return;
	      }
	      this.setState({
	        visible: visible
	      });
	    }
	  }, {
	    key: "setScrollPos",
	    value: function setScrollPos(scrollPos) {
	      this.scrollPos = scrollPos;
	      var transform = this.getThumbTransform();
	      if (this.currentTransform == transform) {
	        return;
	      }
	      this.thumbNode.style.transform = this.currentTransform = transform;
	    }
	  }, {
	    key: "getScrollPos",
	    value: function getScrollPos() {
	      return this.scrollPos;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _Object$assign;
	      var props = this.props;
	      var autoHide = props.autoHide;
	      var className = props.className,
	        style = props.style,
	        orientation = props.orientation,
	        vertical = props.vertical,
	        horizontal = props.horizontal,
	        thumbVisible = props.visible;
	      if (orientation) {
	        vertical = orientation == VERTICAL;
	        horizontal = !vertical;
	      }
	      this.orientation = orientation = horizontal ? HORIZONTAL : VERTICAL;
	      var sizeName = SIZES[orientation];
	      var otherSizeName = OTHER_SIZES[orientation];
	      if (autoHide === false) {
	        thumbVisible = true;
	      } else {
	        if (this.state.visible !== undefined) {
	          thumbVisible = this.state.visible;
	        }
	        if (this.state.active) {
	          thumbVisible = true;
	        }
	      }
	      var hiding = !thumbVisible && this.prevVisible;
	      var showing = thumbVisible && !this.prevVisible;
	      className = (0, _join.default)(className, 'inovua-react-scroll-container__scrollbar', "inovua-react-scroll-container__scrollbar--orientation-".concat(orientation), "inovua-react-scroll-container__scrollbar--direction-".concat(this.props.rtl ? 'rtl' : 'ltr'), !thumbVisible && 'inovua-react-scroll-container__scrollbar--hidden', hiding && 'inovua-react-scroll-container__scrollbar--hiding', this.state.active && 'inovua-react-scroll-container__scrollbar--active', showing && 'inovua-react-scroll-container__scrollbar--showing');
	      style = Object.assign({}, style, STYLES[orientation]);
	      if (showing && this.props.showTransitionDuration) {
	        style.transitionDuration = this.props.showTransitionDuration;
	      }
	      if (hiding && this.props.hideTransitionDuration) {
	        style.transitionDuration = this.props.hideTransitionDuration;
	      }
	      this.prevVisible = thumbVisible;
	      var divProps = (0, _reactCleanProps.default)(props, InovuaScrollbar.propTypes);
	      var thumbSize = this.getThumbSize();
	      var transform = this.getThumbTransform(orientation, thumbSize);
	      var scrollThumbOverWidth = Math.max(this.props.scrollThumbOverWidth, this.props.scrollThumbWidth);
	      var thumbRadius = this.props.scrollThumbRadius !== undefined ? this.props.scrollThumbRadius : this.props.scrollThumbWidth;
	      var thumbStyle = Object.assign({}, this.props.scrollThumbStyle, (_Object$assign = {}, (0, _defineProperty2.default)(_Object$assign, sizeName, thumbSize), (0, _defineProperty2.default)(_Object$assign, otherSizeName, this.state.over || this.state.active || this.props.alwaysShowTrack ? scrollThumbOverWidth : this.props.scrollThumbWidth), (0, _defineProperty2.default)(_Object$assign, "transform", transform), (0, _defineProperty2.default)(_Object$assign, "borderRadius", thumbRadius), (0, _defineProperty2.default)(_Object$assign, "transitionDuration", this.props.scrollTrackOverTransitionDuration), _Object$assign));
	      var trackSides = TRACK_SIDES[orientation];
	      var scrollThumbMargin = this.props.scrollThumbMargin || 0;
	      if (this.props.scrollThumbMargin) {
	        style[MARGINS[orientation]] = scrollThumbMargin;
	        if (this.props.scrollThumbStartEndRespectMargin) {
	          style[trackSides[0]] = this.props.scrollThumbMargin;
	        }
	      }
	      style[trackSides[1]] = scrollThumbMargin + (this.props.oppositeVisible ? this.props.scrollThumbWidth : 0);
	      var thumbClassName = "inovua-react-scroll-container__thumb inovua-react-scroll-container__thumb--orientation-".concat(orientation, " inovua-react-scroll-container__thumb--direction-").concat(this.props.rtl ? 'rtl' : 'ltr');
	      var trackClassName = "inovua-react-scroll-container__track inovua-react-scroll-container__track--orientation-".concat(orientation, " inovua-react-scroll-container__track--direction-").concat(this.props.rtl ? 'rtl' : 'ltr');
	      var trackVisible = this.props.alwaysShowTrack || thumbVisible && this.state.over || this.props.showTrackOnDrag && this.state.active;
	      if (trackVisible) {
	        trackClassName += ' inovua-react-scroll-container__track--visible';
	      }
	      var trackStyle = (0, _defineProperty2.default)({
	        pointerEvents: 'none'
	      }, otherSizeName, scrollThumbOverWidth);
	      if (this.props.dragToScroll) {
	        if (thumbVisible) {
	          trackStyle.pointerEvents = 'all';
	        }
	        trackStyle.borderRadius = thumbRadius;
	        trackClassName += ' inovua-react-scroll-container__track--drag-to-scroll';
	        if (this.state.active) {
	          trackStyle.cursor = 'auto';
	        }
	      }
	      if (this.props.rtl) {
	        var leftVal = style.left;
	        style.left = style.right;
	        style.right = leftVal;
	      }
	      var onThumbMouseDown = thumbVisible && this.props.dragToScroll ? this.onThumbMouseDown : null;
	      var onTrackClick = thumbVisible && this.props.dragToScroll ? this.onTrackClick : null;
	      var onTrackWheel = this.props.dragToScroll && this.state.over ? this.onTrackWheel : null;
	      return _react.default.createElement("div", _objectSpread(_objectSpread({}, divProps), {}, {
	        style: style,
	        className: className,
	        "data-orientation": orientation
	      }), _react.default.createElement("div", {
	        ref: this.refTrack,
	        style: trackStyle,
	        className: trackClassName,
	        onClick: onTrackClick,
	        onWheel: onTrackWheel,
	        onMouseEnter: this.props.dragToScroll ? this.onMouseEnter : null,
	        onMouseLeave: this.props.dragToScroll ? this.onMouseLeave : null
	      }, _react.default.createElement("div", {
	        ref: this.refThumb,
	        style: thumbStyle,
	        className: thumbClassName,
	        onMouseDown: onThumbMouseDown
	      })));
	    }
	  }, {
	    key: "setOver",
	    value: function setOver(over) {
	      var _this2 = this;
	      var doSetOver = function doSetOver(overValue) {
	        _this2.setState({
	          over: overValue
	        }, function () {
	          if (!overValue) {
	            if (_this2.visible !== _this2.state.visible) {
	              _this2.setVisible(_this2.visible);
	            }
	          }
	        });
	      };
	      if (this.setOverFalseTimeoutId) {
	        clearTimeout(this.setOverFalseTimeoutId);
	      }
	      if (!over) {
	        this.setOverFalseTimeoutId = setTimeout(function () {
	          doSetOver(false);
	        }, 500);
	      } else {
	        this.setOverFalseTimeoutId = setTimeout(function () {
	          doSetOver(true);
	        }, 35);
	      }
	    }
	  }, {
	    key: "onMouseEnter",
	    value: function onMouseEnter() {
	      this.setOver(true);
	    }
	  }, {
	    key: "onMouseLeave",
	    value: function onMouseLeave() {
	      this.setOver(false);
	    }
	  }, {
	    key: "onTrackWheel",
	    value: function onTrackWheel(event) {
	      var delta = this.orientation == VERTICAL ? event.deltaY : event.deltaX;
	      event.preventDefault();
	      this.props.onWheelScroll(this.orientation, delta, event);
	    }
	  }, {
	    key: "onTrackClick",
	    value: function onTrackClick(event) {
	      var target = event.target;
	      if (target != this.trackNode) {
	        return;
	      }
	      var rect = target.getBoundingClientRect();
	      var offsetX = event.clientX - rect.left;
	      var offsetY = event.clientY - rect.top;
	      var pos = this.orientation == VERTICAL ? offsetY : offsetX;
	      var thumbPos = this.getThumbPosition();
	      var direction = pos > thumbPos ? 1 : -1;
	      if (this.props.onPageScroll) {
	        this.props.onPageScroll(this.orientation, direction);
	      }
	    }
	  }, {
	    key: "getCoord",
	    value: function getCoord(event) {
	      return this.orientation == VERTICAL ? event.pageY : event.pageX;
	    }
	  }, {
	    key: "getThumbPosition",
	    value: function getThumbPosition() {
	      return this.scrollPosToThumbPos(this.getScrollPos(), this.orientation, this.getThumbSize());
	    }
	  }, {
	    key: "onThumbMouseDown",
	    value: function onThumbMouseDown(event) {
	      event.preventDefault();
	      event.stopPropagation();
	      this.initialPos = this.getCoord(event);
	      this.thumbSize = this.getThumbSize();
	      this.initialThumbPos = this.getThumbPosition();
	      this.setState({
	        active: true
	      });
	      globalObject.addEventListener('mousemove', this.onMouseMove);
	      globalObject.addEventListener('mouseup', this.onMouseUp);
	      this.props.onStartDrag(this.orientation);
	    }
	  }, {
	    key: "onMouseMove",
	    value: function onMouseMove(event) {
	      var pos = this.getCoord(event);
	      var diff = pos - this.initialPos;
	      var scrollPos = this.thumbPosToScrollPos(this.initialThumbPos + diff, this.orientation, this.thumbSize);
	      if (this.orientation == VERTICAL) {
	        this.onScrollThumbScrollTop(scrollPos);
	      } else {
	        this.onScrollThumbScrollLeft(scrollPos);
	      }
	    }
	  }, {
	    key: "onScrollThumbScrollTop",
	    value: function onScrollThumbScrollTop(scrollPos) {
	      this.props.onScrollThumbScrollTop(scrollPos);
	    }
	  }, {
	    key: "onScrollThumbScrollLeft",
	    value: function onScrollThumbScrollLeft(scrollPos) {
	      this.props.onScrollThumbScrollLeft(scrollPos);
	    }
	  }, {
	    key: "onMouseUp",
	    value: function onMouseUp() {
	      globalObject.removeEventListener('mousemove', this.onMouseMove);
	      globalObject.removeEventListener('mouseup', this.onMouseUp);
	      this.setState({
	        active: false
	      });
	      this.props.onStopDrag(this.orientation);
	    }
	  }, {
	    key: "getThumbTransform",
	    value: function getThumbTransform() {
	      var orientation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.orientation;
	      var thumbSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getThumbSize();
	      var scrollPos = this.scrollPosToThumbPos(this.getScrollPos(), orientation, thumbSize) || 0;
	      if (orientation == VERTICAL) {
	        return "translate3d(0px, ".concat(scrollPos, "px, 0px)");
	      }
	      if (this.props.rtl) {
	        scrollPos = -scrollPos;
	      }
	      return "translate3d(".concat(scrollPos, "px, 0px, 0px)");
	    }
	  }, {
	    key: "thumbPosToScrollPos",
	    value: function thumbPosToScrollPos(thumbPos, orientation, thumbSize) {
	      var _this$props = this.props,
	        clientSize = _this$props.clientSize,
	        scrollSize = _this$props.scrollSize,
	        trackSize = _this$props.trackSize;
	      var scrollPos = thumbPos * (scrollSize - clientSize) / (trackSize - thumbSize);
	      return scrollPos;
	    }
	  }, {
	    key: "scrollPosToThumbPos",
	    value: function scrollPosToThumbPos(scrollPos, orientation, thumbSize) {
	      var _this$props2 = this.props,
	        clientSize = _this$props2.clientSize,
	        scrollSize = _this$props2.scrollSize,
	        trackSize = _this$props2.trackSize;
	      var thumbPos = scrollPos / (scrollSize - clientSize) * (trackSize - thumbSize);
	      return Math.floor(thumbPos);
	    }
	  }, {
	    key: "getRatio",
	    value: function getRatio() {
	      return this.props.trackSize / this.props.clientSize;
	    }
	  }, {
	    key: "getThumbSize",
	    value: function getThumbSize() {
	      var _this$props3 = this.props,
	        scrollSize = _this$props3.scrollSize,
	        clientSize = _this$props3.clientSize;
	      var thumbSize = scrollSize ? clientSize * clientSize / scrollSize : 0;
	      thumbSize *= this.getRatio();
	      thumbSize = Math.max(thumbSize, this.props.scrollThumbMinSize);
	      return thumbSize || 0;
	    }
	  }]);
	  return InovuaScrollbar;
	}(_react.Component);
	exports.default = InovuaScrollbar;
	InovuaScrollbar.defaultProps = {
	  onScrollThumbScrollTop: function onScrollThumbScrollTop() {},
	  onScrollThumbScrollLeft: function onScrollThumbScrollLeft() {},
	  onStartDrag: function onStartDrag() {},
	  onStopDrag: function onStopDrag() {},
	  scrollThumbMargin: 2,
	  scrollThumbMinSize: 10,
	  showTrackOnDrag: false
	};
	InovuaScrollbar.propTypes = {
	  alwaysShowTrack: _propTypes.default.bool,
	  autoHide: _propTypes.default.bool,
	  clientSize: _propTypes.default.number,
	  dragToScroll: _propTypes.default.bool,
	  emptyScrollOffset: _propTypes.default.number,
	  hideTransitionDuration: _propTypes.default.string,
	  horizontal: _propTypes.default.bool,
	  showTrackOnDrag: _propTypes.default.bool,
	  onStartDrag: _propTypes.default.func,
	  onStopDrag: _propTypes.default.func,
	  onPageScroll: _propTypes.default.func,
	  onScrollThumbScrollLeft: _propTypes.default.func,
	  onScrollThumbScrollTop: _propTypes.default.func,
	  onWheelScroll: _propTypes.default.func,
	  oppositeVisible: _propTypes.default.bool,
	  orientation: _propTypes.default.oneOf([VERTICAL, HORIZONTAL]),
	  nativeScrollbarWidth: _propTypes.default.number.isRequired,
	  scrollSize: _propTypes.default.number,
	  scrollThumbMargin: _propTypes.default.number.isRequired,
	  scrollThumbMinSize: _propTypes.default.number,
	  scrollThumbOverWidth: _propTypes.default.number,
	  scrollThumbRadius: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  scrollThumbStartEndRespectMargin: _propTypes.default.bool,
	  scrollThumbStyle: _propTypes.default.shape({}),
	  scrollThumbWidth: _propTypes.default.number,
	  scrollTrackOverTransitionDuration: _propTypes.default.string,
	  showTransitionDuration: _propTypes.default.string,
	  size: _propTypes.default.number,
	  trackSize: _propTypes.default.number,
	  vertical: _propTypes.default.bool,
	  visible: _propTypes.default.bool,
	  rtl: _propTypes.default.bool
	};

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _shouldComponentUpdate.default;
	  }
	});
	var _shouldComponentUpdate = _interopRequireDefault(__webpack_require__(56));

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.propTypes = exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _shouldComponentUpdate2 = _interopRequireDefault(__webpack_require__(56));
	var _sealedObjectFactory = _interopRequireDefault(__webpack_require__(762));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var sharedRowProps = (0, _sealedObjectFactory.default)({
	  index: null,
	  count: null,
	  rowHeight: null,
	  renderIndex: null,
	  empty: null,
	  sticky: null,
	  rowSpan: null
	});
	var STR_HIDDEN = 'hidden';
	var STR_ABSOLUTE = 'absolute';
	var STR_ZERO_PX = '0px';
	var STR_VISIBLE = 'visible';
	var raf = globalObject.requestAnimationFrame;
	var caf = globalObject.cancelAnimationFrame;
	var InovuaVirtualListRow = function (_React$Component) {
	  (0, _inherits2.default)(InovuaVirtualListRow, _React$Component);
	  var _super = _createSuper(InovuaVirtualListRow);
	  function InovuaVirtualListRow(props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaVirtualListRow);
	    _this = _super.call(this, props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mounted", true);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_appliedIndex", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refetchNode", true);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visible", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "index", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "offset", 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rowSpan", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "oldRowSpan", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ref", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "row", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "node", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "prepareSetIndex", function () {
	      var rowHeightManager = _this.props.rowHeightManager;
	      if (rowHeightManager != null) {
	        var index = _this.getIndex();
	        delete _this.index;
	        _this.setIndex(index, undefined, false);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRowSpan", function () {
	      return _this.rowSpan;
	    });
	    _this.ref = function (r) {
	      _this.row = r;
	    };
	    _this.mounted = true;
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaVirtualListRow, [{
	    key: "getInstance",
	    value: function getInstance() {
	      return this.row;
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      if (!nextProps.pure) {
	        return true;
	      }
	      return (0, _shouldComponentUpdate2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	      if (this.props.onMount) {
	        this.props.onMount(this);
	      }
	      var naturalRowHeight = this.props.naturalRowHeight;
	      this.fetchNode();
	      if (naturalRowHeight && this.node) {
	        this.node.style.visibility = STR_HIDDEN;
	        return;
	      }
	      this.updateRowHeight();
	      this.updateRowSpan();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	      if (this.props.onUnmount) {
	        this.props.onUnmount(this);
	      }
	      this.node = null;
	      this.info = null;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.refetchNode) {
	        this.fetchNode();
	        this.refetchNode = false;
	      }
	      this.updateRowSpan();
	    }
	  }, {
	    key: "updateRowSpan",
	    value: function updateRowSpan() {
	      if (this.rowSpan !== this.oldRowSpan) {
	        this.props.notifyRowSpan(this.getIndex(), this.rowSpan);
	        var node = this.getDOMNode();
	        node.style.zIndex = this.rowSpan > 1 ? 1 : null;
	      }
	    }
	  }, {
	    key: "getDOMNode",
	    value: function getDOMNode() {
	      if (this.node) {
	        return this.node;
	      }
	      if (!this.row) {
	        return null;
	      }
	      this.node = this.row.domRef ? this.row.domRef.current : this.row;
	      return this.node;
	    }
	  }, {
	    key: "fetchNode",
	    value: function fetchNode() {
	      var node = this.getDOMNode();
	      if (!this.props.virtualized) {
	        this.prepareSetIndex();
	        return;
	      }
	      if (node && !this.isVisible()) {
	        node.style.visibility = STR_HIDDEN;
	      }
	      var contain = this.props.contain;
	      if (node) {
	        node.style.position = STR_ABSOLUTE;
	        node.style.top = STR_ZERO_PX;
	        if (contain) {
	          if (contain === true) {
	            node.style.contain = 'style layout paint';
	          } else {
	            node.style.contain = contain;
	          }
	        }
	        this.prepareSetIndex();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	        renderRow = _this$props.renderRow,
	        count = _this$props.count,
	        renderIndex = _this$props.index,
	        showEmptyRows = _this$props.showEmptyRows,
	        onKeyDown = _this$props.onKeyDown,
	        onFocus = _this$props.onFocus,
	        rowHeightManager = _this$props.rowHeightManager,
	        sticky = _this$props.sticky,
	        contain = _this$props.contain,
	        virtualized = _this$props.virtualized,
	        useTransformPosition = _this$props.useTransformPosition;
	      var index = this.getIndex();
	      sharedRowProps.empty = false;
	      if (index >= count) {
	        if (!showEmptyRows) {
	          this.renderResult = false;
	          return null;
	        }
	        sharedRowProps.empty = true;
	      }
	      var rowHeight = rowHeightManager ? rowHeightManager.getRowHeight(index) : this.props.rowHeight;
	      sharedRowProps.rowHeight = rowHeight;
	      sharedRowProps.count = count;
	      sharedRowProps.index = index;
	      sharedRowProps.renderIndex = renderIndex;
	      sharedRowProps.rowSpan = 1;
	      sharedRowProps.sticky = sticky;
	      var row = renderRow(sharedRowProps);
	      this.oldRowSpan = this.rowSpan || 1;
	      this.rowSpan = sharedRowProps.rowSpan;
	      if (this.renderResult === false && row) {
	        this.refetchNode = true;
	      }
	      this.renderResult = !!row;
	      if (!row) {
	        return null;
	      }
	      var extraStyle = null;
	      if (virtualized) {
	        extraStyle = {
	          top: 0,
	          position: STR_ABSOLUTE,
	          backfaceVisibility: STR_HIDDEN,
	          visibility: this.isVisible() ? STR_VISIBLE : STR_HIDDEN
	        };
	        extraStyle[useTransformPosition ? 'transform' : 'top'] = useTransformPosition ? "translate3d(0px, ".concat(this.offset, "px, 0px)") : this.offset;
	        if (contain) {
	          if (contain === true) {
	            extraStyle.contain = 'style layout paint';
	          } else {
	            extraStyle.contain = contain;
	          }
	        }
	        if (row.props && row.props.style) {
	          extraStyle = _objectSpread(_objectSpread({}, row.props.style), extraStyle);
	        }
	      }
	      return (0, _react.cloneElement)(row, {
	        key: this.props.index,
	        ref: this.ref,
	        onFocus: onFocus ? onFocus.bind(null, index) : null,
	        onKeyDown: onKeyDown ? onKeyDown.bind(null, index) : null,
	        style: extraStyle
	      });
	    }
	  }, {
	    key: "updateRowHeight",
	    value: function updateRowHeight(config) {
	      var _this2 = this;
	      var _this$props2 = this.props,
	        naturalRowHeight = _this$props2.naturalRowHeight,
	        rowHeightManager = _this$props2.rowHeightManager;
	      if (naturalRowHeight) {
	        var index = this.index;
	        var getDOMHeight = function getDOMHeight() {
	          var _this2$node;
	          return ((_this2$node = _this2.node) === null || _this2$node === void 0 ? void 0 : _this2$node.scrollHeight) || 0;
	        };
	        var rowHeight = rowHeightManager.getRowHeight(index);
	        var offsetHeight = getDOMHeight();
	        var height = offsetHeight;
	        if (rowHeight != offsetHeight) {
	          var info = {
	            index: index,
	            height: height
	          };
	          if (!offsetHeight) {
	            return;
	          }
	          var useRaf = config && config.useRaf !== undefined ? !!config.useRaf : true;
	          if (useRaf) {
	            rowHeightManager.setRowHeightLazy(info);
	          } else {
	            rowHeightManager.setRowHeight(info);
	          }
	        }
	      }
	    }
	  }, {
	    key: "update",
	    value: function update(callback) {
	      var _this3 = this;
	      if (this.mounted === false) {
	        return;
	      }
	      if (this.props.rowHeightManager != null) {
	        this.forceUpdate(function () {
	          _this3.updateRowHeight();
	          if (typeof callback === 'function') {
	            callback();
	          }
	        });
	        return;
	      }
	      this.forceUpdate(function () {
	        if (typeof callback == 'function') {
	          callback(_this3.getInfo(true));
	        }
	      });
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(value, callback) {
	      if (this.mounted === false) {
	        return;
	      }
	      this.visible = value;
	      if (this.node) {
	        this.node.style.visibility = value ? STR_VISIBLE : STR_HIDDEN;
	      }
	      if (typeof callback == 'function') {
	        callback(this.getInfo());
	      }
	    }
	  }, {
	    key: "setRowOffset",
	    value: function setRowOffset() {
	      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.index;
	      var _this$props3 = this.props,
	        rowHeightManager = _this$props3.rowHeightManager,
	        useTransformPosition = _this$props3.useTransformPosition;
	      if (!this.node) {
	        return;
	      }
	      if (rowHeightManager) {
	        var rowOffset = rowHeightManager.getRowOffset(index);
	        this.offset = rowOffset;
	        if (useTransformPosition) {
	          this.node.style.transform = "translate3d(0px, ".concat(rowOffset, "px, 0px)");
	        } else {
	          this.node.style.top = "".concat(rowOffset, "px");
	        }
	      }
	    }
	  }, {
	    key: "setIndex",
	    value: function setIndex(index, callback) {
	      var useRaf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	      var force = arguments.length > 3 ? arguments[3] : undefined;
	      if (this.mounted === false) {
	        return;
	      }
	      if (this.index === index && this.isVisible() && !force) {
	        if (callback) {
	          callback();
	        }
	        return;
	      }
	      this.index = index;
	      this._appliedIndex = undefined;
	      this.doSetIndex(index, callback, useRaf);
	    }
	  }, {
	    key: "doSetIndex",
	    value: function doSetIndex(index, callback, useRaf) {
	      var _this4 = this;
	      var sameIndex = this._appliedIndex === index;
	      this._appliedIndex = index;
	      if (useRaf !== true) {
	        this.setVisible(true);
	        this.setRowOffset(index);
	        if (sameIndex) {
	          if (callback) {
	            callback();
	          }
	          return;
	        }
	        this.update(callback);
	      } else {
	        if (this.setIndexRafId) {
	          caf(this.setIndexRafId);
	        }
	        this.setIndexRafId = raf(function () {
	          delete _this4.setIndexRafId;
	          _this4.setVisible(true);
	          _this4.setRowOffset(index);
	          if (sameIndex) {
	            if (callback) {
	              callback();
	            }
	            return;
	          }
	          _this4.update(callback);
	        });
	      }
	    }
	  }, {
	    key: "isVisible",
	    value: function isVisible() {
	      return this.visible !== false;
	    }
	  }, {
	    key: "setOffset",
	    value: function setOffset(offset) {
	      this.offset = offset;
	      if (this.node) {
	        var nodeStyle = this.node.style;
	        nodeStyle.position = STR_ABSOLUTE;
	        nodeStyle.top = STR_ZERO_PX;
	        nodeStyle.backfaceVisibility = STR_HIDDEN;
	        if (this.props.useTransformPosition) {
	          nodeStyle.transform = "translate3d(0px, ".concat(offset, "px, 0px)");
	        } else {
	          nodeStyle.top = "".concat(offset, "px");
	        }
	      }
	    }
	  }, {
	    key: "getIndex",
	    value: function getIndex() {
	      return this.index === undefined ? this.props.index : this.index;
	    }
	  }, {
	    key: "getInfo",
	    value: function getInfo(updateHeight) {
	      if (this.mounted === false) {
	        return this.info;
	      }
	      if (!this.info) {
	        this.info = (0, _sealedObjectFactory.default)({
	          row: null,
	          node: null,
	          height: null,
	          index: null,
	          key: null,
	          offset: null
	        });
	      }
	      this.info.row = this;
	      this.info.node = this.node;
	      this.info.height = updateHeight || this.height === undefined ? this.node ? this.node.offsetHeight : 0 : this.height;
	      this.info.index = this.getIndex();
	      this.info.key = this.props.index;
	      this.info.offset = this.props.virtualized ? this.offset : this.node ? this.node.offsetTop : 0;
	      return this.info;
	    }
	  }]);
	  return InovuaVirtualListRow;
	}(_react.default.Component);
	exports.default = InovuaVirtualListRow;
	InovuaVirtualListRow.defaultProps = {
	  pure: false,
	  useTransformPosition: false
	};
	var propTypes = {
	  pure: _propTypes.default.bool,
	  naturalRowHeight: _propTypes.default.bool,
	  rowHeightManager: _propTypes.default.object,
	  count: _propTypes.default.number,
	  contain: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  index: _propTypes.default.number.isRequired,
	  onRowHeightChange: _propTypes.default.func,
	  renderRow: _propTypes.default.func.isRequired,
	  useTransformPosition: _propTypes.default.bool,
	  virtualized: _propTypes.default.bool
	};
	exports.propTypes = propTypes;
	InovuaVirtualListRow.propTypes = propTypes;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "RowHeightManager", {
	  enumerable: true,
	  get: function get() {
	    return _RowHeightManager.default;
	  }
	});
	exports.default = void 0;
	Object.defineProperty(exports, "getScrollbarWidth", {
	  enumerable: true,
	  get: function get() {
	    return _src.getScrollbarWidth;
	  }
	});
	exports.propTypes = void 0;
	Object.defineProperty(exports, "shouldComponentUpdate", {
	  enumerable: true,
	  get: function get() {
	    return _shouldComponentUpdate2.default;
	  }
	});
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _contains = _interopRequireDefault(__webpack_require__(157));
	var _reactCleanProps = _interopRequireDefault(__webpack_require__(49));
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(200));
	var _src = _interopRequireWildcard(__webpack_require__(764));
	var _uglified = _interopRequireDefault(__webpack_require__(57));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _binarySearch = _interopRequireDefault(__webpack_require__(260));
	var _RowHeightManager = _interopRequireDefault(__webpack_require__(265));
	var _getFocusableElements = _interopRequireDefault(__webpack_require__(262));
	var _renderRows2 = _interopRequireDefault(__webpack_require__(761));
	var _shouldComponentUpdate2 = _interopRequireDefault(__webpack_require__(56));
	var _getVisibleRange = _interopRequireDefault(__webpack_require__(759));
	var _StickyRowsContainer = _interopRequireDefault(__webpack_require__(266));
	var _lodash = _interopRequireDefault(__webpack_require__(180));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var sortAsc = function sortAsc(a, b) {
	  return a - b;
	};
	var emptyFn = function emptyFn() {};
	var emptyObject = Object.freeze ? Object.freeze({}) : {};
	var ua = globalObject.navigator ? globalObject.navigator.userAgent : '';
	var IS_EDGE = ua.indexOf('Edge/') !== -1;
	var IS_FF = ua.toLowerCase().indexOf('firefox') > -1;
	var BASE_CLASS_NAME = 'inovua-react-virtual-list';
	var ResizeObserver = globalObject.ResizeObserver || _resizeObserverPolyfill.default;
	var sum = function sum(a, b) {
	  return a + b;
	};
	var unique = function unique(arr) {
	  if (Set) {
	    return (0, _toConsumableArray2.default)(new Set(arr));
	  }
	  return Object.keys(arr.reduce(function (acc, item) {
	    acc[item] = true;
	    return acc;
	  }, {}));
	};
	var InovuaVirtualList = function (_Component) {
	  (0, _inherits2.default)(InovuaVirtualList, _Component);
	  var _super = _createSuper(InovuaVirtualList);
	  function InovuaVirtualList(_props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, InovuaVirtualList);
	    _this = _super.call(this, _props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "size", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rows", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rowSpans", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rowCoveredBy", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scrollTopPos", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getContainerNode", function () {
	      return _this.containerNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderScroller", function (props) {
	      var offset = _this.getEmptyScrollOffset() || 0;
	      if (_this.props.nativeScroll) {
	        offset = 0;
	      }
	      var style = _objectSpread(_objectSpread({}, props.style), {}, {
	        overscrollBehavior: _this.props.overscrollBehavior || 'none',
	        backfaceVisibility: 'hidden',
	        WebkitOverscrollBehavior: _this.props.overscrollBehavior || 'none',
	        right: -offset,
	        bottom: -offset
	      });
	      props.style = style;
	      if (_this.props.showEmptyRows && _this.props.count < _this.strictVisibleCount && (0, _src.getScrollbarWidth)() && _this.props.nativeScroll) {
	        style.overflowY = 'hidden';
	      }
	      var result;
	      if (_this.props.renderScroller) {
	        result = _this.props.renderScroller(props);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("div", _objectSpread({}, props));
	      }
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderScrollerSpacerOnNaturalRowHeight", function (spacerProps) {
	      spacerProps.style.height = _this.getScrollHeight();
	      if (_this.props.renderScrollerSpacer) {
	        _this.props.renderScrollerSpacer(spacerProps);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderView", function (props) {
	      var offset = _this.getEmptyScrollOffset() || 0;
	      if (_this.props.nativeScroll) {
	        offset = 0;
	      }
	      var minHeight = offset ? "calc(100% - ".concat(offset, "px)") : '100%';
	      var maxWidth = offset ? "calc(100% - ".concat(offset, "px)") : '100%';
	      if (_this.props.rtl && !_this.props.nativeScroll) {
	        maxWidth = '100%';
	      }
	      var style = _objectSpread(_objectSpread({}, props.style), {}, {
	        minHeight: minHeight,
	        maxWidth: maxWidth
	      });
	      if (_this.props.rtl && !(0, _src.getScrollbarWidth)()) {
	        style.transform = "translateX(".concat(-offset, "px)");
	      }
	      var viewProps = _objectSpread(_objectSpread({}, props), {}, {
	        style: style,
	        'data-name': 'view'
	      });
	      var result;
	      if (_this.props.renderView) {
	        result = _this.props.renderView(viewProps);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("div", _objectSpread({}, viewProps));
	      }
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getTotalRowHeight", function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	      return props.rowHeightManager ? props.rowHeightManager.getTotalSize(props.count) : props.count * props.rowHeight;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollHeight", function () {
	      var SCROLLBAR_WIDTH = (0, _src.getScrollbarWidth)();
	      var offset = SCROLLBAR_WIDTH ? 0 : _this.getEmptyScrollOffset() || 0;
	      if (_this.props.nativeScroll) {
	        offset = 0;
	      }
	      var height = _this.getTotalRowHeight();
	      return height + offset;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollSize", function (node) {
	      var res = {
	        width: node.scrollWidth,
	        height: _this.getScrollHeight()
	      };
	      return res;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getClientSize", function (n) {
	      var node = n.firstChild;
	      var SCROLLBAR_WIDTH = (0, _src.getScrollbarWidth)();
	      var offset = SCROLLBAR_WIDTH ? 0 : _this.getEmptyScrollOffset() || 0;
	      if (_this.props.nativeScroll) {
	        offset = 0;
	      }
	      return {
	        width: node.clientWidth + offset,
	        height: node.clientHeight + offset
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initSizes", function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	      var minRowHeight = props.minRowHeight,
	        rowHeightManager = props.rowHeightManager;
	      if (rowHeightManager) {
	        return;
	      }
	      var count = _this.getMaxRenderCount(props);
	      var rowOffsets = [];
	      var totalHeight = 0;
	      var rowHeights = (0, _toConsumableArray2.default)(Array(count)).map(function () {
	        rowOffsets.push(totalHeight);
	        totalHeight += minRowHeight;
	        return minRowHeight;
	      });
	      rowOffsets[count] = totalHeight;
	      _this.rowOffsets = rowOffsets;
	      _this.rowHeights = rowHeights;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setHeightForRows", function (indexes, heights) {
	      if (!indexes.length || !heights.length) {
	        return 0;
	      }
	      if (_this.props.showWarnings) {
	        if (indexes.length != heights.length) {
	          console.warn('setHeightForRows signature mismatch!!!');
	          return 0;
	        }
	        indexes.forEach(function (_, i) {
	          if (i > 0) {
	            var _diff = indexes[i] - indexes[i - 1];
	            if (_diff !== 1) {
	              console.warn('setHeightForRows should be called with successive indexes!', indexes);
	            }
	          }
	        });
	      }
	      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
	        rowHeights = _assertThisInitialize.rowHeights,
	        rowOffsets = _assertThisInitialize.rowOffsets;
	      var count = _this.props.count;
	      var diff = 0;
	      indexes.forEach(function (index, i) {
	        var height = heights[i] || 0;
	        var oldHeight = rowHeights[index] || 0;
	        rowHeights[index] = height;
	        rowOffsets[index] = diff + (rowOffsets[index] || 0);
	        diff += height - oldHeight;
	      });
	      for (var i = indexes[indexes.length - 1] + 1; i <= count; i++) {
	        rowOffsets[i] = diff + (rowOffsets[i] || 0);
	      }
	      return diff;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSizer", function (scrollHeight) {
	      var _this$props = _this.props,
	        renderSizer = _this$props.renderSizer,
	        minRowWidth = _this$props.minRowWidth,
	        emptyScrollOffset = _this$props.emptyScrollOffset,
	        rowHeightManager = _this$props.rowHeightManager,
	        showEmptyRows = _this$props.showEmptyRows,
	        virtualized = _this$props.virtualized;
	      var SCROLLBAR_WIDTH = (0, _src.getScrollbarWidth)();
	      var offset = SCROLLBAR_WIDTH ? 0 : emptyScrollOffset || 0;
	      if (!virtualized) {
	        scrollHeight = 0;
	      }
	      var minHeight = scrollHeight + offset;
	      if (showEmptyRows) {
	        minHeight = Math.max(minHeight, _this.strictVisibleCount * rowHeightManager.getDefaultRowHeight());
	      }
	      var style = {
	        minHeight: isNaN(minHeight) ? '' : minHeight,
	        minWidth: minRowWidth ? minRowWidth + offset : 0
	      };
	      var result;
	      if (renderSizer) {
	        result = renderSizer({
	          style: style
	        }, scrollHeight);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("div", {
	          key: "sizer",
	          "data-name": "sizer",
	          style: style
	        });
	      }
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderRowContainer", function () {
	      var props = {
	        key: 'rowContainer',
	        className: "".concat(BASE_CLASS_NAME, "__row-container"),
	        ref: _this.refContainerNode,
	        children: _this.renderRows()
	      };
	      var result;
	      if (_this.props.renderRowContainer) {
	        result = _this.props.renderRowContainer(props);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("div", _objectSpread({}, props));
	      }
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onViewResize", function () {
	      requestAnimationFrame(function () {
	        _this.rafSync();
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScrollbarsChange", function (_ref) {
	      var vertical = _ref.vertical,
	        horizontal = _ref.horizontal;
	      if (!vertical && _this.scrollTopPos || !horizontal && _this.scrollLeftPos) {
	        _this.applyScrollStyle({
	          scrollTop: !vertical ? 0 : _this.scrollTopPos,
	          scrollLeft: !horizontal ? 0 : _this.scrollLeftPos
	        });
	      }
	      if (_this.props.onScrollbarsChange) {
	        _this.props.onScrollbarsChange({
	          vertical: vertical,
	          horizontal: horizontal
	        });
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowUnmount", function (row) {
	      if (!_this.rows) {
	        return;
	      }
	      var currentRowIndex = row.getIndex();
	      var isFound = _this.mapping[currentRowIndex];
	      if (!isFound) {
	        return;
	      }
	      delete _this.mapping[currentRowIndex];
	      var index = _this.rows.indexOf(row);
	      if (index != -1) {
	        _this.rows.splice(index, 1);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowMount", function (r) {
	      if (!r) {
	        return;
	      }
	      _this.mapping[r.props.index] = r;
	      _this.rows[r.props.index] = r;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScrollStart", function () {
	      _this.scrolling = true;
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	      if (_this.props.scrollOneDirectionOnly) {
	        var scrollPos = args[0],
	          prevScrollPos = args[1];
	        var absTop = Math.abs(scrollPos.scrollTop - prevScrollPos.scrollTop);
	        var absLeft = Math.abs(scrollPos.scrollLeft - prevScrollPos.scrollLeft);
	        var scrollerNode = _this.getScrollerNode();
	        if (absTop != absLeft) {
	          _this.disableScrollPropName = absTop > absLeft ? 'overflowX' : 'overflowY';
	          _this.disableScrollOtherPropName = absTop > absLeft ? 'overflowY' : 'overflowX';
	          _this.disableScrollPropValue = scrollerNode.style[_this.disableScrollPropName];
	          scrollerNode.style[_this.disableScrollOtherPropName] = 'scroll';
	          scrollerNode.style[_this.disableScrollPropName] = 'hidden';
	        }
	      }
	      if (_this.props.onScrollStart) {
	        var _this$props2;
	        (_this$props2 = _this.props).onScrollStart.apply(_this$props2, args);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollerNode", function () {
	      return _this.scrollContainer.scrollerNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScrollStop", function () {
	      _this.scrolling = false;
	      if (_this.props.scrollOneDirectionOnly) {
	        var scrollerNode = _this.getScrollerNode();
	        scrollerNode.style[_this.disableScrollPropName] = _this.disableScrollPropValue;
	        scrollerNode.style.overflow = 'scroll';
	      }
	      if (_this.props.onScrollStop) {
	        var _this$props3;
	        (_this$props3 = _this.props).onScrollStop.apply(_this$props3, arguments);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRows", function () {
	      var rows = [];
	      _this.forEachRow(function (row) {
	        if (row) {
	          rows.push(row);
	        }
	      });
	      return rows;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "forEachRow", function (fn) {
	      var onlyVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var rows = _this.rows;
	      var visibleCount = _this.getVisibleCount();
	      var i = -1;
	      for (var initialIndex in rows) {
	        if (rows.hasOwnProperty(initialIndex) && (!onlyVisible || onlyVisible && initialIndex < visibleCount)) {
	          i++;
	          fn(rows[initialIndex], i);
	        }
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sortRows", function (rows) {
	      return rows.slice().sort(function (row1, row2) {
	        return row1.getIndex() - row2.getIndex();
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRowAt", function (index) {
	      var row = _this.mapping[index];
	      if (row && row.getIndex() != index) {
	        row = null;
	      }
	      return row;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getVisibleCount", function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	      var virtualized = props.virtualized,
	        enableRowSpan = props.enableRowSpan,
	        extraRowsProps = props.extraRows;
	      var extraRows = enableRowSpan ? 2 : extraRowsProps || 0;
	      if (_this.visibleCount === undefined) {
	        return 0;
	      }
	      if (!virtualized) {
	        return (props.showEmptyRows ? Math.max(_this.visibleCount || 0, props.count || 0) : props.count) + extraRows;
	      }
	      return (props.showEmptyRows ? _this.visibleCount || props.count : Math.min(_this.visibleCount || props.count, props.count)) + extraRows;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRowIndex", function (row, index, callback) {
	      var existingRow = _this.mapping[index];
	      if (existingRow) {
	        existingRow.setIndex(index, callback);
	        if (existingRow !== row) {
	          row.setVisible(false);
	        }
	        return;
	      }
	      var oldIndex = row.getIndex();
	      row.setIndex(index, callback);
	      delete _this.mapping[oldIndex];
	      _this.mapping[index] = row;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSortedRows", function () {
	      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.getRows();
	      return _this.sortRows(rows);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowsUpdated", function (newIndexes, range, updateScroll) {
	      newIndexes.sort(function (i1, i2) {
	        return i1 - i2;
	      });
	      var start = newIndexes[0];
	      var end = _this.props.showEmptyRows ? newIndexes[newIndexes.length - 1] : Math.min(newIndexes[newIndexes.length - 1], _this.props.count - 1);
	      var minRowHeight = _this.props.minRowHeight;
	      var rowIndexes = [];
	      var rowHeights = [];
	      var rows = [];
	      for (var row, rowHeight, i = start; i <= end; i++) {
	        row = _this.mapping[i];
	        rowHeight = row ? row.getInfo().height : minRowHeight;
	        if (row) {
	          rows.push(row);
	        }
	        rowIndexes.push(i);
	        rowHeights.push(rowHeight);
	      }
	      var newToTopHeight = 0;
	      var oldTop;
	      if (_this.oldRowIndexes) {
	        oldTop = _this.oldRowIndexes[0];
	        rowIndexes.forEach(function (rowIndex, i) {
	          var diff;
	          if (rowIndex < oldTop) {
	            diff = rowHeights[i] - _this.rowHeights[rowIndex];
	            newToTopHeight += diff;
	          }
	        });
	      }
	      if (rowIndexes.length) {
	        _this.setHeightForRows(rowIndexes, rowHeights);
	      }
	      rows.forEach(function (row) {
	        var index = row.getIndex();
	        var offset = _this.rowOffsets[index];
	        row.setOffset(offset);
	      });
	      _this.oldRowIndexes = rowIndexes;
	      var newScrollTop;
	      if (newToTopHeight) {
	        newScrollTop = _this.scrollTopPos + newToTopHeight;
	        updateScroll(newScrollTop);
	        _this.forceScrollTop = newScrollTop;
	        _this.scrollTop = newScrollTop;
	      } else {
	        updateScroll();
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getVisibleRange", function (args) {
	      return (0, _getVisibleRange.default)(args);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "applyScrollStyle", function (_ref2, domNode) {
	      var scrollTop = _ref2.scrollTop,
	        scrollLeft = _ref2.scrollLeft,
	        force = _ref2.force,
	        reorder = _ref2.reorder;
	      if (scrollTop < 0) {
	        scrollTop = 0;
	      }
	      if (!_this.props.rtl) {
	        if (scrollLeft < 0) {
	          scrollLeft = 0;
	        }
	      } else {
	        if (scrollLeft > 0) {
	          scrollLeft = 0;
	        }
	      }
	      if (_this.forceScrollTop !== undefined) {
	        scrollTop = _this.forceScrollTop;
	        _this.forceScrollTop = undefined;
	        return;
	      }
	      if (_this.props.applyScrollLeft && scrollLeft !== undefined) {
	        scrollLeft = 0;
	        _this.props.applyScrollLeft(scrollLeft, domNode);
	      }
	      if (scrollTop === undefined) {
	        scrollTop = _this.prevScrollTopPos;
	      }
	      if (scrollLeft === undefined) {
	        scrollLeft = _this.prevScrollLeftPos;
	      }
	      _this.scrollTopPos = scrollTop;
	      _this.scrollLeftPos = scrollLeft;
	      var _this$props4 = _this.props,
	        count = _this$props4.count,
	        useTransformPosition = _this$props4.useTransformPosition,
	        rowHeightManager = _this$props4.rowHeightManager,
	        naturalRowHeight = _this$props4.naturalRowHeight,
	        virtualized = _this$props4.virtualized,
	        showEmptyRows = _this$props4.showEmptyRows;
	      var range = _this.getVisibleRange({
	        scrollTop: scrollTop,
	        size: _this.size,
	        count: count,
	        naturalRowHeight: naturalRowHeight,
	        rowHeightManager: rowHeightManager,
	        showEmptyRows: showEmptyRows
	      });
	      var startRowIndex = range.start;
	      var prevStartRowIndex = _this.prevStartRowIndex;
	      _this.prevScrollTopPos = scrollTop;
	      _this.prevScrollLeftPos = scrollLeft;
	      _this.prevStartRowIndex = startRowIndex;
	      _this.updateStickyRows(scrollTop, undefined, {
	        force: false
	      });
	      var updateScroll = function updateScroll() {
	        var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : scrollTop;
	        var parentNodeStyle = _this.containerNode.parentNode.style;
	        _this.containerNode.parentNode.classList.add("".concat(BASE_CLASS_NAME, "__view-container"));
	        var scrollLeftTranslateValue = -scrollLeft;
	        if (useTransformPosition) {
	          parentNodeStyle.transform = "translate3d(".concat(scrollLeftTranslateValue, "px, ").concat(-top, "px, 0px)");
	        } else {
	          parentNodeStyle.left = "".concat(scrollLeftTranslateValue, "px");
	          parentNodeStyle.top = "".concat(-top, "px");
	        }
	      };
	      if (rowHeightManager == null) {
	        force = true;
	      }
	      if (startRowIndex == prevStartRowIndex && !force || !virtualized) {
	        updateScroll();
	        return;
	      }
	      updateScroll();
	      _this.updateRows(range, reorder, emptyFn);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollingElement", function () {
	      return _this.scrollContainer;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "smoothScrollTo", function () {
	      var _this$scrollContainer;
	      (_this$scrollContainer = _this.scrollContainer).smoothScrollTo.apply(_this$scrollContainer, arguments);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", function () {
	      _this.mounted = true;
	      _this.unmounted = false;
	      _this.setupRowHeightManager(_this.props.rowHeightManager);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fixEdgeScrollPosition", function () {
	      if (!(IS_EDGE || IS_FF)) {
	        return;
	      }
	      var maxTop = _this.getTotalRowHeight() - (_this.scrollContainer.viewNode ? _this.scrollContainer.viewNode.offsetHeight : 0);
	      if (_this.scrollTop > maxTop) {
	        globalObject.requestAnimationFrame(function () {
	          if (_this.unmounted) {
	            return;
	          }
	          _this.scrollTop = maxTop;
	        });
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setupRowHeightManager", function (rowHeightManager) {
	      if (rowHeightManager) {
	        rowHeightManager.on('index', _this.onIndex);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onIndex", function () {
	      _this.updateVisibleCount(_this.size.height);
	      _this.forceUpdate(function () {
	        if (_this.unmounted) {
	          return;
	        }
	        _this.refreshLayout({
	          reorder: false,
	          force: true
	        });
	        _this.cleanupRows();
	        _this.fixEdgeScrollPosition();
	        _this.rows.forEach(function (row) {
	          row.setIndex(row.getIndex(), undefined, undefined, true);
	        });
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refreshLayout", function (config) {
	      var defaults = {
	        force: true,
	        reorder: true
	      };
	      _this.adjustHeights();
	      var options = config ? _objectSpread(_objectSpread({}, defaults), config) : defaults;
	      _this.applyScrollStyle(options);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getOverlappingHeight", function () {
	      if (_this.scrollContainer && _this.scrollContainer.getBeforeAndAfterHeight) {
	        return _this.scrollContainer.getBeforeAndAfterHeight();
	      }
	      return 0;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateVisibleCount", function (height, props) {
	      props = props || _this.props;
	      var _props2 = props,
	        rowHeightManager = _props2.rowHeightManager,
	        minRowHeight = _props2.minRowHeight,
	        showEmptyRows = _props2.showEmptyRows;
	      var strictVisibleCount = rowHeightManager ? Math.ceil(height / rowHeightManager.getMinHeight()) : Math.ceil(height / (minRowHeight || 1));
	      _this.strictVisibleCount = strictVisibleCount;
	      _this.visibleCount = rowHeightManager ? strictVisibleCount + 1 : strictVisibleCount + 2;
	      var maxCount = props.count;
	      if (_this.visibleCount > maxCount && !showEmptyRows) {
	        _this.visibleCount = maxCount;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getGapsFor", function (startRowIndex, endRowIndex, sortedRows) {
	      var visibleRowPositions = {};
	      var enableRowSpan = _this.props.enableRowSpan;
	      var rows = sortedRows || _this.getSortedRows();
	      rows.forEach(function (row) {
	        if (row.isVisible()) {
	          visibleRowPositions[row.getIndex()] = true;
	        }
	      });
	      var gaps = [];
	      if (enableRowSpan && _this.rowCoveredBy[startRowIndex] != null) {
	        startRowIndex = _this.rowCoveredBy[startRowIndex];
	      }
	      var alreadyVisible;
	      var coveredBy;
	      for (; startRowIndex <= endRowIndex; startRowIndex++) {
	        alreadyVisible = visibleRowPositions[startRowIndex];
	        if (enableRowSpan && !alreadyVisible) {
	          coveredBy = _this.rowCoveredBy[startRowIndex];
	          if (coveredBy != null) {
	            alreadyVisible = _this.props.recycleCoveredRows;
	          }
	        }
	        if (!alreadyVisible) {
	          gaps.push(startRowIndex);
	        }
	      }
	      return gaps;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getCleanupRows", function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	      var indexes = [];
	      var length = _this.rows && _this.rows.length;
	      var visibleCount = _this.getVisibleCount(props);
	      for (var i = visibleCount; i < length; i++) {
	        indexes.push(i);
	      }
	      return indexes;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cleanupRows", function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	      _this.getCleanupRows(props).forEach(function (i) {
	        var row = _this.rows[i];
	        if (row) {
	          delete _this.mapping[row.getIndex()];
	          delete _this.rows[i];
	        }
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResize", function () {
	      var node = _this.getDOMNode();
	      if (!node) {
	        return;
	      }
	      var size = _this.props.measureSize ? _this.props.measureSize(node) : {
	        width: node.clientWidth,
	        height: node.clientHeight
	      };
	      size.height -= _this.getOverlappingHeight();
	      _this.size = size;
	      if (_this.props.scrollProps && typeof _this.props.scrollProps.onResize == 'function') {
	        _this.props.scrollProps.onResize(size);
	      }
	      _this.updateVisibleCount(size.height);
	      if (_this.props.virtualized) {
	        if (_this.props.showEmptyRows) {
	          _this.initSizes();
	        }
	        _this.forceUpdate(function () {
	          if (_this.unmounted) {
	            return;
	          }
	          _this.refreshLayout({
	            reorder: false,
	            force: true
	          });
	          _this.cleanupRows();
	        });
	      }
	      if (_this.props.onResize) {
	        _this.props.onResize(size);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setRowRowSpan", function (rowIndex, rowSpan) {
	      if (rowSpan === 1) {
	        return;
	      }
	      _this.rowSpans[rowIndex] = rowSpan;
	      var current = rowIndex + 1;
	      var last = rowIndex + rowSpan - 1;
	      for (; current <= last; current++) {
	        _this.rowCoveredBy[current] = rowIndex;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowKeyDown", function (index, event) {
	      if (event.key !== 'Tab') {
	        return;
	      }
	      if (_this.props.handleRowKeyDown) {
	        _this.props.handleRowKeyDown(index, event);
	        return;
	      }
	      var activeElement = globalObject.document.activeElement;
	      var theRow = _this.getRowAt(index);
	      var rowNode = theRow.getDOMNode ? theRow.getDOMNode() : theRow.node;
	      if (!activeElement || !(0, _contains.default)(rowNode, activeElement)) {
	        return;
	      }
	      var dir = event.shiftKey ? -1 : 1;
	      var nextIndex = index + dir;
	      var maxCount = _this.getMaxRenderCount();
	      if (nextIndex < 0 || nextIndex >= maxCount) {
	        return;
	      }
	      var thisElements = _this.props.getRowFocusableElements ? _this.props.getRowFocusableElements(index, rowNode) : (0, _getFocusableElements.default)(rowNode);
	      if (thisElements && thisElements.length) {
	        var limit = dir === -1 ? 0 : thisElements.length - 1;
	        if (thisElements[limit] !== activeElement) {
	          return;
	        }
	      }
	      if (typeof _this.props.shouldPreventDefaultTabKeyOnRow !== 'function' || _this.props.shouldPreventDefaultTabKeyOnRow(index, event) !== false) {
	        event.preventDefault();
	      }
	      _this.focusRow(nextIndex, dir);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getMaxRenderCount", function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	      var visibleCount = _this.getVisibleCount(props);
	      var maxCount = props.showEmptyRows ? Math.max(visibleCount || 0, props.count) : Math.max(props.count || 0, 0);
	      return maxCount;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focusRow", function (index, dir, callback) {
	      if (index >= _this.getMaxRenderCount() || index < 0) {
	        return;
	      }
	      _this.scrollToIndex(index, {
	        direction: dir == 1 ? 'bottom' : 'top',
	        duration: 50
	      }, function () {
	        var nextRow = _this.getRowAt(index);
	        var nextRowNode = nextRow.getDOMNode ? nextRow.getDOMNode() : nextRow.node;
	        var elements = _this.props.getRowFocusableElements ? _this.props.getRowFocusableElements(index, nextRowNode) : (0, _getFocusableElements.default)(nextRowNode);
	        if (elements.length) {
	          var focusIndex = dir === -1 ? elements.length - 1 : 0;
	          elements[focusIndex].focus();
	        }
	        if (typeof callback == 'function') {
	          callback();
	        }
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isRowRendered", function (index) {
	      return !!_this.getRowAt(index);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getStickyRowsArray", function () {
	      var stickyRows = _this.props.stickyRows;
	      var scaleMap = {};
	      var rows = Object.keys(stickyRows).map(function (key, i) {
	        var scale = +(stickyRows[key] || 1);
	        var row = {
	          index: +key,
	          scale: scale,
	          indexInAllRows: i
	        };
	        scaleMap[scale] = scaleMap[scale] || [];
	        scaleMap[scale].push(row);
	        return row;
	      }).sort(function (a, b) {
	        return sortAsc(a.index, b.index);
	      });
	      var scales = unique(rows.map(function (r) {
	        return r.scale;
	      })).sort(sortAsc);
	      var result = {
	        rows: rows,
	        scales: scales,
	        rowsPerScales: scales.map(function (scale) {
	          return scaleMap[scale];
	        })
	      };
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "currentStickyRows", []);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateStickyRows", function () {
	      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.scrollTop;
	      var firstVisibleRowIndex = arguments.length > 1 ? arguments[1] : undefined;
	      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	          force: true
	        },
	        force = _ref3.force;
	      if (!_this.props.stickyRows) {
	        return;
	      }
	      var _this$getStickyRowsAr = _this.getStickyRowsArray(),
	        rowsPerScales = _this$getStickyRowsAr.rowsPerScales,
	        allRows = _this$getStickyRowsAr.rows;
	      if (firstVisibleRowIndex === undefined) {
	        firstVisibleRowIndex = _this.getFirstVisibleRowIndexForSticky(scrollTop);
	      }
	      firstVisibleRowIndex = firstVisibleRowIndex || 0;
	      var enteringRows = [];
	      var comparator = function comparator(_ref4, b) {
	        var index = _ref4.index;
	        return sortAsc(index, b);
	      };
	      var initialIndex = -1;
	      var currentStickyRows = [];
	      var currentStickyRowsMap = [];
	      var maxStickyRowIndex = -1;
	      var firstFreeVisibleRowIndex = firstVisibleRowIndex;
	      rowsPerScales.forEach(function (rows) {
	        if (!rows.length) {
	          return;
	        }
	        var foundIndex = (0, _binarySearch.default)(rows, firstFreeVisibleRowIndex, comparator);
	        var computedFoundIndex = foundIndex;
	        var stickyRow;
	        var stickyRowIndex;
	        if (foundIndex < 0) {
	          computedFoundIndex = ~foundIndex - 1;
	        }
	        stickyRow = rows[computedFoundIndex];
	        if (stickyRow) {
	          stickyRowIndex = stickyRow.index;
	          if (stickyRowIndex > initialIndex) {
	            firstFreeVisibleRowIndex++;
	            currentStickyRows.push(stickyRow);
	            currentStickyRowsMap[stickyRowIndex] = true;
	            initialIndex = stickyRowIndex;
	            maxStickyRowIndex = Math.max(maxStickyRowIndex, stickyRowIndex);
	          }
	          var nextRow = allRows[stickyRow.indexInAllRows + 1];
	          if (nextRow && nextRow.index <= firstFreeVisibleRowIndex) {
	            enteringRows.push(nextRow);
	          }
	        }
	      });
	      enteringRows = enteringRows.filter(function (row) {
	        return !currentStickyRowsMap[row.index] && row.index > maxStickyRowIndex;
	      });
	      var enteringRow = enteringRows[0];
	      if (JSON.stringify(_this.currentStickyRows) === JSON.stringify(currentStickyRows) && !force) {
	        _this.stickyRowsContainer.setEnteringRow({
	          enteringRow: enteringRow,
	          scrollTop: scrollTop
	        });
	        return;
	      }
	      _this.setStickyRows(currentStickyRows, scrollTop, enteringRow);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setStickyRows", function () {
	      var currentStickyRows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.currentStickyRows;
	      var scrollTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.scrollTop;
	      var enteringRow = arguments.length > 2 ? arguments[2] : undefined;
	      _this.currentStickyRows = currentStickyRows;
	      var rowElements = currentStickyRows.map(function (row) {
	        return _this.renderStickyRow(row.index);
	      });
	      _this.stickyRowsContainer.setStickyRows(rowElements.length ? rowElements : null, currentStickyRows, {
	        enteringRow: enteringRow,
	        scrollTop: scrollTop
	      });
	      _this.currentStickyRows = currentStickyRows;
	      if (_this.props.onStickyRowUpdate) {
	        _this.props.onStickyRowUpdate();
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderStickyRow", function (index) {
	      var _this$props5 = _this.props,
	        rowHeight = _this$props5.rowHeight,
	        renderRow = _this$props5.renderRow,
	        count = _this$props5.count,
	        pureRows = _this$props5.pureRows,
	        rowHeightManager = _this$props5.rowHeightManager,
	        showEmptyRows = _this$props5.showEmptyRows,
	        virtualized = _this$props5.virtualized,
	        rowContain = _this$props5.rowContain,
	        naturalRowHeight = _this$props5.naturalRowHeight,
	        useTransformRowPosition = _this$props5.useTransformRowPosition;
	      return (0, _renderRows2.default)({
	        pure: pureRows,
	        renderRow: renderRow,
	        rowHeightManager: rowHeightManager,
	        rowHeight: rowHeight,
	        rowContain: rowContain,
	        count: count,
	        from: index,
	        to: index + 1,
	        naturalRowHeight: naturalRowHeight,
	        sticky: true,
	        useTransformPosition: useTransformRowPosition,
	        virtualized: false
	      })[0];
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isRowVisible", function (index) {
	      if (!_this.isRowRendered(index)) {
	        return false;
	      }
	      var rowHeightManager = _this.props.rowHeightManager;
	      var top = _this.scrollTop;
	      var bottom = top + _this.size.height;
	      var rowTop;
	      var rowBottom;
	      if (rowHeightManager) {
	        rowTop = rowHeightManager.getRowOffset(index);
	        rowBottom = rowTop + rowHeightManager.getRowHeight(index);
	      } else {
	        var row = _this.getRowAt(index);
	        var info = row.getInfo();
	        rowTop = info.offset;
	        rowBottom = rowTop + info.height;
	      }
	      return top <= rowTop && rowBottom <= bottom;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRowVisibilityInfo", function (index, offset) {
	      var rendered = _this.isRowRendered(index);
	      var _this$props6 = _this.props,
	        rowHeightManager = _this$props6.rowHeightManager,
	        rowHeight = _this$props6.rowHeight,
	        minRowHeight = _this$props6.minRowHeight;
	      var scrollTop = _this.scrollTop;
	      var top = scrollTop + offset;
	      var bottom = scrollTop + _this.size.height - offset;
	      var rowTop;
	      var rowBottom;
	      if (rowHeightManager) {
	        rowTop = rowHeightManager.getRowOffset(index);
	        rowBottom = rowTop + rowHeightManager.getRowHeight(index);
	      } else {
	        var row = _this.getRowAt(index);
	        if (row) {
	          var info = row.getInfo();
	          rowTop = info.offset;
	          rowBottom = rowTop + info.height;
	        } else {
	          var indexes = _this.getRenderedIndexes();
	          var firstRenderedIndex = indexes[0];
	          var lastRenderedIndex = indexes[indexes.length - 1];
	          if (index < firstRenderedIndex) {
	            rowTop = _this.rowOffsets[firstRenderedIndex] - (firstRenderedIndex - index) * minRowHeight;
	          } else if (index > lastRenderedIndex) {
	            rowTop = _this.rowOffsets[lastRenderedIndex] + _this.rowHeights[lastRenderedIndex] + (index - lastRenderedIndex) * minRowHeight;
	          } else {
	            rowTop = _this.rowOffsets[index];
	          }
	          rowBottom = rowTop + _this.rowHeights[index];
	        }
	      }
	      var visible = top <= rowTop && rowBottom <= bottom;
	      return {
	        rendered: rendered,
	        visible: visible,
	        top: rowTop,
	        bottom: rowBottom,
	        topDiff: rowTop - top,
	        bottomDiff: bottom - rowBottom
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRenderedIndexes", function () {
	      return Object.keys(_this.mapping).map(function (k) {
	        return k * 1;
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRowFocus", function (index, event) {});
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rafSync", function () {
	      if (_this.scrollContainer) {
	        _this.scrollContainer.rafSync();
	      }
	      _this.adjustHeights();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "adjustHeights", function () {
	      if (Array.isArray(_this.rows)) {
	        _this.rows.forEach(function (r) {
	          return r.updateRowHeight();
	        });
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkHeights", function () {
	      var rows = _this.getSortedRows();
	      var result = true;
	      rows.forEach(function (row) {
	        if (result !== true) {
	          return;
	        }
	        var index = row.getIndex();
	        if (row.node.offsetHeight != _this.rowHeights[index]) {
	          console.warn("row height mismatch at ".concat(index, "!"));
	          result = index;
	        }
	      });
	      if (result === true) {
	        _this.rowHeights.reduce(function (acc, height, index) {
	          if (_this.rowOffsets[index] !== acc && result === true && index < _this.props.count) {
	            console.warn("row offset mismatch at ".concat(index, "!"));
	            result = index;
	          }
	          return acc + height;
	        }, 0);
	      }
	      return result;
	    });
	    _this.initSizes(_props);
	    _this.visibleCount = undefined;
	    _this.size = {
	      height: 0,
	      width: 0
	    };
	    _this.scrollTopPos = 0;
	    _this.scrollLeftPos = 0;
	    _this.prevScrollLeftPos = 0;
	    _this.prevScrollTopPos = 0;
	    _this.mapping = {};
	    _this.rowSpans = {};
	    _this.rowCoveredBy = {};
	    _this.rows = [];
	    _this.rowRef = function (r) {
	      _this.row = r;
	    };
	    _this.refScrollContainer = function (c) {
	      _this.scrollContainer = c;
	    };
	    _this.refStickyContainer = function (c) {
	      _this.stickyRowsContainer = c;
	    };
	    _this.refContainerNode = function (domNode) {
	      _this.containerNode = domNode;
	    };
	    _this.updateRows = (0, _lodash.default)(_this.updateRows, 16);
	    return _this;
	  }
	  (0, _createClass2.default)(InovuaVirtualList, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _shouldComponentUpdate2.default)(this, nextProps, nextState);
	    }
	  }, {
	    key: "renderStickyRowsContainer",
	    value: function renderStickyRowsContainer() {
	      return this.props.stickyRows ? _react.default.createElement(_StickyRowsContainer.default, {
	        rtl: this.props.rtl,
	        key: "stickyrowscontainer",
	        stickyOffset: this.props.stickyOffset,
	        handle: this.refStickyContainer,
	        rowHeightManager: this.props.rowHeightManager
	      }) : null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = this.props;
	      var naturalRowHeight = props.naturalRowHeight,
	        scrollProps = props.scrollProps,
	        theme = props.theme,
	        minRowHeight = props.minRowHeight,
	        rowHeightManager = props.rowHeightManager,
	        count = props.count;
	      if (this.oldProps) {
	        this.transitionProps(props, this.oldProps);
	      }
	      this.oldProps = props;
	      var style = _objectSpread({
	        position: 'relative'
	      }, this.props.style);
	      var className = (0, _join.default)(props.className, BASE_CLASS_NAME, theme && "".concat(BASE_CLASS_NAME, "--theme-").concat(theme), "".concat(BASE_CLASS_NAME, "--virtual-scroll"));
	      var scrollHeight = rowHeightManager ? rowHeightManager.getTotalSize(count) : this.scrollHeight || minRowHeight * count;
	      var rowContainer = this.renderRowContainer();
	      var sizer = this.renderSizer(scrollHeight);
	      var stickyRowsContainer = this.renderStickyRowsContainer();
	      var children;
	      if ((0, _src.hasSticky)()) {
	        children = _react.default.Fragment ? _react.default.createElement(_react.default.Fragment, null, rowContainer, sizer) : [rowContainer, sizer];
	      } else {
	        children = _react.default.createElement("div", null, rowContainer, sizer);
	      }
	      var Factory = this.props.nativeScroll ? _src.NativeScrollContainer : _src.default;
	      var renderScrollerSpacer = this.props.renderScrollerSpacer;
	      if (naturalRowHeight) {
	        renderScrollerSpacer = this.renderScrollerSpacerOnNaturalRowHeight;
	      }
	      return _react.default.createElement(Factory, _objectSpread(_objectSpread(_objectSpread({
	        contain: this.props.contain,
	        ResizeObserver: this.props.ResizeObserver !== undefined ? this.props.ResizeObserver : ResizeObserver,
	        extraChildren: stickyRowsContainer,
	        useTransformToScroll: this.props.useTransformPosition
	      }, (0, _reactCleanProps.default)(props, InovuaVirtualList.propTypes)), scrollProps), {}, {
	        rtl: this.props.rtl,
	        nativeScroll: this.props.nativeScroll,
	        ref: this.refScrollContainer,
	        onScrollbarsChange: this.onScrollbarsChange,
	        style: style,
	        theme: theme,
	        className: className,
	        onScrollStart: this.onScrollStart,
	        onScrollStop: this.onScrollStop,
	        applyScrollStyle: this.applyScrollStyle,
	        onResize: this.onResize,
	        onViewResize: this.onViewResize,
	        renderScroller: this.renderScroller,
	        renderScrollerSpacer: renderScrollerSpacer,
	        renderView: this.renderView,
	        getClientSize: this.getClientSize,
	        getScrollSize: this.getScrollSize,
	        children: children
	      }));
	    }
	  }, {
	    key: "updateRows",
	    value: function updateRows(range, reorder, updateScroll) {
	      var _this2 = this;
	      var rowHeightManager = this.props.rowHeightManager;
	      var startRowIndex = range.start;
	      var endRowIndex = range.end;
	      if (this.props.onRenderRangeChange) {
	        this.props.onRenderRangeChange(startRowIndex, endRowIndex);
	      }
	      var rows = this.getSortedRows();
	      var gaps = this.getGapsFor(startRowIndex, endRowIndex, rows);
	      var newIndexes = [];
	      var _this$props7 = this.props,
	        recycleCoveredRows = _this$props7.recycleCoveredRows,
	        enableRowSpan = _this$props7.enableRowSpan;
	      var visited = {};
	      rows.forEach(function (row, i) {
	        var rowIndex = row.getIndex();
	        if (reorder) {
	          var newRowIndex = startRowIndex + i;
	          _this2.setRowIndex(row, newRowIndex);
	          if (rowHeightManager == null) {
	            newIndexes.push(newRowIndex);
	          }
	          return;
	        }
	        var extraRows = enableRowSpan ? row.getRowSpan() - 1 : 0;
	        var outOfView = rowIndex + extraRows < startRowIndex || rowIndex > endRowIndex || visited[rowIndex] || enableRowSpan && recycleCoveredRows && _this2.rowCoveredBy[rowIndex] !== undefined;
	        visited[rowIndex] = true;
	        if (rowHeightManager == null) {
	          if (outOfView) {
	            if (gaps.length) {
	              var newIndex = gaps.pop();
	              newIndexes.push(newIndex);
	              _this2.setRowIndex(row, newIndex);
	            } else {
	              row.setVisible(false);
	            }
	          } else {
	            row.setVisible(true);
	            newIndexes.push(row.getIndex());
	          }
	          return;
	        }
	        if (outOfView && gaps.length) {
	          var _newIndex = gaps.pop();
	          _this2.setRowIndex(row, _newIndex);
	        }
	      });
	      if (newIndexes.length && rowHeightManager == null) {
	        if (this.updateRafHandle) {
	          globalObject.cancelAnimationFrame(this.updateRafHandle);
	        }
	        this.updateRafHandle = globalObject.requestAnimationFrame(function () {
	          _this2.updateRafHandle = null;
	          _this2.onRowsUpdated(newIndexes, {
	            start: startRowIndex,
	            end: endRowIndex
	          }, function () {});
	        });
	      }
	    }
	  }, {
	    key: "scrollTopMax",
	    get: function get() {
	      return this.mounted ? this.scrollContainer.scrollTopMax : 0;
	    }
	  }, {
	    key: "scrollLeftMax",
	    get: function get() {
	      return this.mounted ? this.scrollContainer.scrollLeftMax : 0;
	    }
	  }, {
	    key: "scrollTop",
	    get: function get() {
	      return this.mounted ? this.getScrollingElement().scrollTop : 0;
	    },
	    set: function set(value) {
	      var element = this.getScrollingElement();
	      if (element) {
	        element.scrollTop = value;
	      }
	    }
	  }, {
	    key: "scrollLeft",
	    get: function get() {
	      return this.mounted ? this.getScrollingElement().scrollLeft : 0;
	    },
	    set: function set(value) {
	      var element = this.getScrollingElement();
	      if (element) {
	        element.scrollLeft = value;
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.props.rowHeightManager) {
	        this.props.rowHeightManager.removeListener('index', this.onIndex);
	      }
	      this.mounted = false;
	      this.unmounted = true;
	      this.rows.length = 0;
	      this.rowHeights = null;
	      this.rowOffsets = null;
	    }
	  }, {
	    key: "transitionProps",
	    value: function transitionProps(nextProps, thisProps) {
	      var nextCount = Math.max(nextProps.count, 0);
	      var rowHeightChange = thisProps.rowHeight && nextProps.rowHeight != thisProps.rowHeight;
	      if (thisProps.renderRow !== nextProps.renderRow) {
	        this.rowCoveredBy = {};
	        this.rowSpans = {};
	      }
	      if (nextCount != thisProps.count || nextProps.showEmptyRows != thisProps.showEmptyRows || rowHeightChange) {
	        var oldVisibleCount = this.getVisibleCount();
	        this.updateVisibleCount(this.size.height, nextProps);
	        this.cleanupRows(nextProps);
	        this.reorder = rowHeightChange || this.getVisibleCount(nextProps) < oldVisibleCount;
	        this.initSizes(nextProps);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this3 = this;
	      var prevScrollTopPos;
	      var prevScrollLeftPos;
	      if (this.props.nativeScroll !== prevProps.nativeScroll) {
	        prevScrollTopPos = this.scrollTopPos;
	        prevScrollLeftPos = this.scrollLeftPos;
	        globalObject.requestAnimationFrame(function () {
	          if (_this3.unmounted) {
	            return;
	          }
	          _this3.scrollTop = prevScrollTopPos;
	          _this3.scrollLeft = prevScrollLeftPos;
	        });
	      }
	      if (this.props.rowHeightManager !== prevProps.rowHeightManager) {
	        if (prevProps.rowHeightManager) {
	          prevProps.rowHeightManager.removeListener('index', this.onIndex);
	        }
	        this.setupRowHeightManager(this.props.rowHeightManager);
	      }
	      if (this.props.count != prevProps.count || this.props.renderRow != prevProps.renderRow || this.props.rowHeightManager != prevProps.rowHeightManager || this.props.rowHeightManager == null || this.props.showEmptyRows != prevProps.showEmptyRows) {
	        var refreshConfig = {
	          reorder: this.reorder
	        };
	        if (prevScrollTopPos !== undefined) {
	          refreshConfig.scrollTop = prevScrollTopPos;
	          refreshConfig.scrollLeft = prevScrollLeftPos;
	        }
	        if (this.props.count <= this.visibleCount) {
	          refreshConfig.scrollTop = 0;
	        }
	        if ((IS_EDGE || IS_FF) && this.props.count < prevProps.count) {
	          this.fixEdgeScrollPosition();
	        }
	        this.reorder = false;
	        this.refreshLayout(refreshConfig);
	      }
	      if (prevProps.stickyRows !== this.props.stickyRows) {
	        this.updateStickyRows(undefined, undefined, {
	          force: true
	        });
	      }
	    }
	  }, {
	    key: "getDOMNode",
	    value: function getDOMNode() {
	      return this.scrollContainer ? this.scrollContainer.domNode || this.scrollContainer.getDOMNode() : null;
	    }
	  }, {
	    key: "renderRows",
	    value: function renderRows() {
	      var props = this.props;
	      var rowHeight = props.rowHeight,
	        renderRow = props.renderRow,
	        count = props.count,
	        pureRows = props.pureRows,
	        rowHeightManager = props.rowHeightManager,
	        showEmptyRows = props.showEmptyRows,
	        virtualized = props.virtualized,
	        rowContain = props.rowContain,
	        naturalRowHeight = props.naturalRowHeight,
	        useTransformRowPosition = props.useTransformRowPosition;
	      var to = this.getVisibleCount();
	      return (0, _renderRows2.default)({
	        ref: this.rowRef,
	        onMount: this.onRowMount,
	        onUnmount: this.onRowUnmount,
	        notifyRowSpan: this.setRowRowSpan,
	        pure: pureRows,
	        renderRow: renderRow,
	        rowHeightManager: rowHeightManager,
	        rowHeight: rowHeight,
	        rowContain: rowContain,
	        count: count,
	        from: 0,
	        to: to,
	        naturalRowHeight: naturalRowHeight,
	        onKeyDown: this.onRowKeyDown,
	        onFocus: this.onRowFocus,
	        useTransformPosition: useTransformRowPosition,
	        showEmptyRows: showEmptyRows,
	        virtualized: virtualized
	      });
	    }
	  }, {
	    key: "getFirstVisibleRowIndexForSticky",
	    value: function getFirstVisibleRowIndexForSticky() {
	      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.scrollTopPos;
	      var rowHeightManager = this.props.rowHeightManager;
	      var stickyHeight = this.currentStickyRows ? this.currentStickyRows.reduce(function (_, row) {
	        return rowHeightManager.getRowHeight(row.index);
	      }, 0) : 0;
	      var rowIndex = Math.max(0, rowHeightManager.getRowAt(scrollTop + stickyHeight) - 1);
	      return rowIndex;
	    }
	  }, {
	    key: "scrollToIndex",
	    value: function scrollToIndex(index) {
	      var _this4 = this;
	      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyObject,
	        direction = _ref5.direction,
	        force = _ref5.force,
	        _ref5$duration = _ref5.duration,
	        duration = _ref5$duration === void 0 ? 0 : _ref5$duration,
	        _ref5$offset = _ref5.offset,
	        offset = _ref5$offset === void 0 ? 0 : _ref5$offset;
	      var callback = arguments.length > 2 ? arguments[2] : undefined;
	      if (direction) {
	        if (direction != 'top' && direction != 'bottom') {
	          direction = null;
	        }
	      }
	      if (force && !direction) {
	        force = false;
	      }
	      if (index < 0 || index >= this.getMaxRenderCount()) {
	        return;
	      }
	      if (typeof callback != 'function') {
	        callback = emptyFn;
	      }
	      var info = this.getRowVisibilityInfo(index, offset);
	      if (!info.rendered) {
	        var rowHeight = this.props.rowHeight;
	        if (!direction) {
	          var existingIndex = this.rows[0].getIndex();
	          direction = index > existingIndex ? 'bottom' : 'top';
	        }
	        var newScrollTop = direction === 'top' ? info.top - offset : this.scrollTop - info.bottomDiff + offset;
	        var afterScroll = function afterScroll() {
	          if (!rowHeight) {
	            setTimeout(function () {
	              globalObject.requestAnimationFrame(function () {
	                _this4.scrollToIndex(index, {
	                  direction: direction,
	                  force: force,
	                  duration: duration ? 100 : 0
	                }, callback);
	              });
	            });
	          } else {
	            callback();
	          }
	        };
	        if (duration) {
	          this.smoothScrollTo(newScrollTop, {
	            duration: duration
	          }, afterScroll);
	        } else {
	          this.scrollTop = newScrollTop;
	          afterScroll();
	        }
	        return;
	      }
	      var visible = info.visible;
	      if (!visible) {
	        if (!direction) {
	          direction = info.topDiff < 0 ? 'top' : 'bottom';
	          force = true;
	        }
	      }
	      if (!visible || direction && force) {
	        var _newScrollTop;
	        if (direction == 'top' || info.topDiff < 0) {
	          _newScrollTop = this.scrollTop + info.topDiff - offset;
	        } else if (direction == 'bottom' || info.bottomDiff < 0) {
	          _newScrollTop = this.scrollTop - info.bottomDiff + offset;
	        }
	        if (_newScrollTop != null) {
	          if (duration) {
	            this.smoothScrollTo(_newScrollTop, {
	              duration: duration
	            }, callback);
	            return;
	          }
	          this.scrollTop = _newScrollTop;
	        }
	      }
	      callback();
	    }
	  }, {
	    key: "getEmptyScrollOffset",
	    value: function getEmptyScrollOffset() {
	      if (this.props.emptyScrollOffset != null) {
	        return this.props.emptyScrollOffset;
	      }
	      var SCROLLBAR_WIDTH = (0, _src.getScrollbarWidth)();
	      return this.props.emptyScrollOffset || SCROLLBAR_WIDTH || 17;
	    }
	  }]);
	  return InovuaVirtualList;
	}(_react.Component);
	exports.default = InovuaVirtualList;
	InovuaVirtualList.defaultProps = {
	  minRowHeight: 20,
	  nativeScroll: false,
	  shouldAllowScrollbars: function shouldAllowScrollbars() {
	    return true;
	  },
	  rafOnResize: false,
	  theme: 'default-light',
	  showEmptyRows: false,
	  showWarnings: !_uglified.default,
	  virtualized: true,
	  scrollOneDirectionOnly: false,
	  useTransformPosition: !IS_EDGE && (0, _src.hasSticky)(),
	  useTransformRowPosition: false,
	  recycleCoveredRows: true,
	  scrollProps: {}
	};
	var propTypes = {
	  applyScrollLeft: _propTypes.default.func,
	  naturalRowHeight: _propTypes.default.bool,
	  count: function count(props) {
	    var count = props.count;
	    if (count == null) {
	      throw new Error("\"count\" is required!");
	    }
	    if (typeof count != 'number') {
	      throw new Error("\"count\" should be a number!");
	    }
	    if (count < 0) {
	      throw new Error("\"count\" should be >= 0!");
	    }
	  },
	  getRowFocusableElements: _propTypes.default.func,
	  contain: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  rowContain: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  handleRowKeyDown: _propTypes.default.func,
	  rafOnResize: _propTypes.default.bool,
	  checkResizeDelay: _propTypes.default.number,
	  extraRows: _propTypes.default.number,
	  measureSize: _propTypes.default.func,
	  minRowHeight: _propTypes.default.number,
	  minRowWidth: _propTypes.default.number,
	  nativeScroll: _propTypes.default.bool,
	  onRenderRangeChange: _propTypes.default.func,
	  shouldFocusNextRow: _propTypes.default.func,
	  onResize: _propTypes.default.func,
	  onScrollStart: _propTypes.default.func,
	  onScrollbarsChange: _propTypes.default.func,
	  onScrollStop: _propTypes.default.func,
	  pureRows: _propTypes.default.bool,
	  rowHeight: _propTypes.default.number,
	  renderRow: _propTypes.default.func.isRequired,
	  renderRowContainer: _propTypes.default.func,
	  renderSizer: _propTypes.default.func,
	  showEmptyRows: _propTypes.default.bool,
	  useTransformPosition: _propTypes.default.bool,
	  useTransformRowPosition: _propTypes.default.bool,
	  scrollProps: _propTypes.default.object,
	  showWarnings: _propTypes.default.bool,
	  renderView: _propTypes.default.func,
	  renderScroller: _propTypes.default.func,
	  renderScrollerSpacer: _propTypes.default.func,
	  shouldComponentUpdate: _propTypes.default.func,
	  shouldPreventDefaultTabKeyOnRow: _propTypes.default.func,
	  theme: _propTypes.default.string,
	  overscrollBehavior: _propTypes.default.string,
	  virtualized: _propTypes.default.bool,
	  scrollOneDirectionOnly: _propTypes.default.bool,
	  onStickyRowUpdate: _propTypes.default.func,
	  stickyRows: _propTypes.default.object,
	  recycleCoveredRows: _propTypes.default.bool,
	  stickyOffset: _propTypes.default.number,
	  enableRowSpan: _propTypes.default.bool,
	  rowHeightManager: function rowHeightManager(props, propName) {
	    var value = props[propName];
	    if (!value) {
	      return new Error("\n You have to provide a \"rowHeightManager\" property, which should be an instance of RowHeightManager.\n ");
	    }
	    if (!(value instanceof _RowHeightManager.default)) {
	      return new Error('The "rowHeightManager" property should be an instance of RowHeightManager!');
	    }
	  }
	};
	exports.propTypes = propTypes;
	InovuaVirtualList.propTypes = propTypes;

/***/ },
/* 759 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(_ref) {
	  var size = _ref.size,
	    scrollTop = _ref.scrollTop,
	    count = _ref.count,
	    rowHeightManager = _ref.rowHeightManager,
	    naturalRowHeight = _ref.naturalRowHeight,
	    showEmptyRows = _ref.showEmptyRows;
	  var start = rowHeightManager.getRowAt(scrollTop);
	  var end = naturalRowHeight ? rowHeightManager.getRowAt(scrollTop + size.height) + 1 : start + Math.ceil(size.height / rowHeightManager.getDefaultRowHeight());
	  if (!showEmptyRows) {
	    end = Math.min(count - 1, end);
	  }
	  return {
	    start: start,
	    end: end
	  };
	};
	exports.default = _default;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "RowHeightManager", {
	  enumerable: true,
	  get: function get() {
	    return _VirtualList.RowHeightManager;
	  }
	});
	exports.default = void 0;
	Object.defineProperty(exports, "getScrollbarWidth", {
	  enumerable: true,
	  get: function get() {
	    return _VirtualList.getScrollbarWidth;
	  }
	});
	Object.defineProperty(exports, "propTypes", {
	  enumerable: true,
	  get: function get() {
	    return _VirtualList.propTypes;
	  }
	});
	Object.defineProperty(exports, "shouldComponentUpdate", {
	  enumerable: true,
	  get: function get() {
	    return _VirtualList.shouldComponentUpdate;
	  }
	});
	var _VirtualList = _interopRequireWildcard(__webpack_require__(758));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var _default = _VirtualList.default;
	exports.default = _default;

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _Row = _interopRequireDefault(__webpack_require__(757));
	var _default = function _default(_ref) {
	  var count = _ref.count,
	    renderRow = _ref.renderRow,
	    rowHeight = _ref.rowHeight,
	    showEmptyRows = _ref.showEmptyRows,
	    ref = _ref.ref,
	    pure = _ref.pure,
	    sticky = _ref.sticky,
	    notifyRowSpan = _ref.notifyRowSpan,
	    rowHeightManager = _ref.rowHeightManager,
	    onRowHeightChange = _ref.onRowHeightChange,
	    onKeyDown = _ref.onKeyDown,
	    onFocus = _ref.onFocus,
	    onMount = _ref.onMount,
	    onUnmount = _ref.onUnmount,
	    rowContain = _ref.rowContain,
	    naturalRowHeight = _ref.naturalRowHeight,
	    useTransformPosition = _ref.useTransformPosition,
	    _ref$from = _ref.from,
	    from = _ref$from === void 0 ? 0 : _ref$from,
	    _ref$to = _ref.to,
	    to = _ref$to === void 0 ? count : _ref$to,
	    virtualized = _ref.virtualized;
	  var rows = [];
	  for (var i = from; i < to; i++) {
	    rows.push(_react.default.createElement(_Row.default, {
	      contain: rowContain,
	      pure: pure,
	      ref: ref,
	      sticky: sticky,
	      rowHeight: rowHeight,
	      useTransformPosition: useTransformPosition,
	      onRowHeightChange: onRowHeightChange,
	      notifyRowSpan: notifyRowSpan,
	      key: i,
	      index: i,
	      count: count,
	      renderRow: renderRow,
	      rowHeightManager: rowHeightManager,
	      showEmptyRows: showEmptyRows,
	      onKeyDown: onKeyDown,
	      onFocus: onFocus,
	      onMount: onMount,
	      onUnmount: onUnmount,
	      virtualized: virtualized,
	      naturalRowHeight: naturalRowHeight
	    }));
	  }
	  return rows;
	};
	exports.default = _default;

/***/ },
/* 762 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var DEFAULTS = {};
	var _default = function _default() {
	  var shape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULTS;
	  var sealed = Object.seal ? Object.seal(shape) : {};
	  return sealed;
	};
	exports.default = _default;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	Object.defineProperty(exports, "getScrollbarWidth", {
	  enumerable: true,
	  get: function get() {
	    return _getScrollbarWidth.default;
	  }
	});
	Object.defineProperty(exports, "isMobile", {
	  enumerable: true,
	  get: function get() {
	    return _isMobile.default;
	  }
	});
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(15));
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(13));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _reactDom = __webpack_require__(37);
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _src = _interopRequireDefault(__webpack_require__(86));
	var _reactCleanProps = _interopRequireDefault(__webpack_require__(49));
	var _hasSticky = __webpack_require__(158);
	var _smoothScrollTo = _interopRequireDefault(__webpack_require__(114));
	var _isMobile = _interopRequireDefault(__webpack_require__(64));
	var _getScrollbarWidth = _interopRequireDefault(__webpack_require__(47));
	var _join = _interopRequireDefault(__webpack_require__(31));
	var _isSafari = _interopRequireDefault(__webpack_require__(159));
	var _src2 = _interopRequireDefault(__webpack_require__(85));
	var _getGlobal = __webpack_require__(18);
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var globalObject = (0, _getGlobal.getGlobal)();
	var STICKY_STYLE = {
	  position: _hasSticky.sticky,
	  top: 0,
	  left: 0
	};
	var WRAPPER_STYLE = {
	  display: 'block',
	  position: 'absolute',
	  flex: '',
	  top: 0,
	  left: 0,
	  right: 0,
	  bottom: 0
	};
	var ua = globalObject.navigator ? globalObject.navigator.userAgent : '';
	var IS_EDGE = ua.indexOf('Edge/') !== -1;
	var StickyVirtualScrollContainer = function (_React$Component) {
	  (0, _inherits2.default)(StickyVirtualScrollContainer, _React$Component);
	  var _super = _createSuper(StickyVirtualScrollContainer);
	  function StickyVirtualScrollContainer(_props) {
	    var _this;
	    (0, _classCallCheck2.default)(this, StickyVirtualScrollContainer);
	    _this = _super.call(this, _props);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initializeScrollLeftForRtl", function () {
	      var fixScrollLeft = function fixScrollLeft() {
	        if (_this.scroller && _this.scrollLeftMax) {
	          _this.scroller.getScrollerNode().scrollLeft = 1000000000;
	          return;
	        }
	        requestAnimationFrame(fixScrollLeft);
	      };
	      requestAnimationFrame(fixScrollLeft);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResize", function () {
	      if (_this.props.onResize) {
	        var _this$props;
	        (_this$props = _this.props).onResize.apply(_this$props, arguments);
	      }
	      _this.sync();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sync", function () {
	      _this.scroller.sync();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rafSync", function () {
	      if (_this.scroller.rafSync) {
	        _this.scroller.rafSync();
	      } else {
	        _this.scroller.sync();
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "smoothScrollTo", function (newValue, config, callback) {
	      (0, _smoothScrollTo.default)(_this.scroller, newValue, config, callback);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollbars", function () {
	      return {
	        horizontal: _this.hasHorizontalScrollbar(),
	        vertical: _this.hasVerticalScrollbar()
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasScrollbar", function (orientation) {
	      return _this.scroller.hasScrollbar.call((0, _assertThisInitialized2.default)(_this), orientation);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasVerticalScrollbar", function () {
	      return _this.hasScrollbar('vertical');
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasHorizontalScrollbar", function () {
	      return _this.hasScrollbar('horizontal');
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focus", function () {
	      _this.scroller.focus();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFocus", function (event) {
	      if (event.target === _this.domNode) {
	        _this.focus();
	      }
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getTransformNode", function () {
	      return _this.viewNode.children[0].children[0];
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollSize", function () {
	      var node = _this.getTransformNode();
	      var size;
	      if (_this.props.getScrollSize) {
	        size = _this.props.getScrollSize(node);
	      } else {
	        size = {
	          width: node.scrollWidth,
	          height: node.scrollHeight
	        };
	      }
	      return size;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getScrollPosition", function () {
	      return _this.scroller.getScrollPosition();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateScrollStyle", function (scrollPos, prevScrollPos) {
	      scrollPos = scrollPos || _this.getScrollPosition();
	      var _scrollPos = scrollPos,
	        scrollTop = _scrollPos.scrollTop,
	        scrollLeft = _scrollPos.scrollLeft,
	        scrollLeftMax = _scrollPos.scrollLeftMax;
	      _this.scrollLeftMaxValue = scrollLeftMax;
	      if (_this.props.onContainerScroll) {
	        _this.props.onContainerScroll(scrollPos, prevScrollPos);
	      }
	      var node = _this.getTransformNode();
	      var shouldApplyDefaultTransform = true;
	      if (_this.props.applyScrollStyle) {
	        shouldApplyDefaultTransform = _this.props.applyScrollStyle({
	          scrollLeft: scrollLeft,
	          scrollTop: scrollTop,
	          scrollLeftMax: scrollLeftMax
	        }, node) !== false;
	      }
	      if (shouldApplyDefaultTransform) {
	        node.style.willChange = "transform";
	        node.style.backfaceVisibility = "hidden";
	        if (_this.props.useTransformToScroll) {
	          node.style.transform = "translate3d(".concat(-scrollLeft, "px, ").concat(-scrollTop, "px, 0px)");
	        } else {
	          node.style.top = "".concat(-scrollTop, "px");
	          node.style.left = "".concat(-scrollLeft, "px");
	        }
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getBeforeHeight", function () {
	      return _this.props.before ? _this.state.beforeElementSize.height || 0 : 0;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAfterHeight", function () {
	      return _this.props.after ? _this.state.afterElementSize.height || 0 : 0;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getBeforeAndAfterHeight", function () {
	      return _this.getBeforeHeight() + _this.getAfterHeight();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onViewResize", function () {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	      var size = args[0];
	      _this.setState({
	        size: size
	      }, function () {
	        _this.rafSync();
	      });
	      if (_this.props.onViewResize) {
	        var _this$props2;
	        (_this$props2 = _this.props).onViewResize.apply(_this$props2, args);
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderScrollerSpacer", function () {
	      var spacerProps = {
	        key: 'spacer',
	        'data-name': 'spacer--sticky-scroller',
	        style: _objectSpread({
	          pointerEvents: 'none',
	          position: 'absolute',
	          top: 0,
	          left: 0
	        }, _this.state.size)
	      };
	      var result;
	      if (_this.props.renderScrollerSpacer) {
	        result = _this.props.renderScrollerSpacer(spacerProps, _this.state.size);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("div", _objectSpread({}, spacerProps));
	      }
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderScroller", function (scrollerProps) {
	      var scrollerOffset = _this.props.nativeScroll ? 0 : -_this.getEmptyScrollOffset();
	      var props = _objectSpread(_objectSpread({}, scrollerProps), {}, {
	        'data-name': 'scroller',
	        className: '',
	        style: {
	          display: 'block',
	          position: 'absolute',
	          WebkitOverflowScrolling: 'touch',
	          top: 0,
	          left: 0,
	          right: scrollerOffset,
	          bottom: scrollerOffset,
	          overflow: _this.props.nativeScroll ? 'auto' : 'scroll'
	        },
	        children: [_this.props.extraChildren, scrollerProps.children, _this.renderScrollerSpacer()]
	      });
	      var result;
	      if (_this.props.renderScroller) {
	        result = _this.props.renderScroller(props);
	      }
	      if (result === undefined) {
	        result = _react.default.createElement("div", _objectSpread({}, props));
	      }
	      return result;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getBefore", function () {
	      var before = _this.props.before;
	      if (!before) {
	        return null;
	      }
	      return _react.default.cloneElement(before, {
	        style: _objectSpread({
	          position: 'absolute',
	          top: 0
	        }, before.props.style),
	        children: _react.default.createElement(_react.default.Fragment, null, before.props.children, _react.default.createElement(_src2.default, {
	          notifyOnMount: true,
	          onResize: _this.onBeforeElementResize
	        }))
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAfter", function () {
	      var after = _this.props.after;
	      if (!after) {
	        return null;
	      }
	      return _react.default.cloneElement(after, {
	        style: _objectSpread({
	          position: 'absolute',
	          bottom: 0
	        }, after.props.style),
	        children: _react.default.createElement(_react.default.Fragment, null, after.props.children, _react.default.createElement(_src2.default, {
	          notifyOnMount: true,
	          onResize: _this.onAfterElementResize
	        }))
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBeforeElementResize", function (size) {
	      _this.setState({
	        beforeElementSize: size
	      });
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onAfterElementResize", function (size) {
	      _this.setState({
	        afterElementSize: size
	      });
	    });
	    _this.refView = function (c) {
	      _this.viewNode = c ? (0, _reactDom.findDOMNode)(c) : null;
	    };
	    _this.refScroller = function (s) {
	      _this.scroller = s;
	      _this.scrollerNode = s ? s.getScrollerNode() : null;
	    };
	    _this.state = {
	      size: {},
	      beforeElementSize: {
	        height: 0
	      },
	      afterElementSize: {
	        height: 0
	      }
	    };
	    return _this;
	  }
	  (0, _createClass2.default)(StickyVirtualScrollContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.sync();
	      if (this.props.rtl) {
	        this.initializeScrollLeftForRtl();
	      }
	    }
	  }, {
	    key: "getDOMNode",
	    value: function getDOMNode() {
	      return this.scroller.getDOMNode();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.rtl) {
	        if (prevProps.rtl !== this.props.rtl || prevProps.nativeScroll !== this.props.nativeScroll) {
	          this.initializeScrollLeftForRtl();
	        }
	      }
	    }
	  }, {
	    key: "scrollTop",
	    get: function get() {
	      return this.scroller.scrollTop;
	    },
	    set: function set(value) {
	      this.scroller.scrollTop = value;
	    }
	  }, {
	    key: "scrollTopMax",
	    get: function get() {
	      return this.scroller.scrollTopMax;
	    }
	  }, {
	    key: "scrollLeft",
	    get: function get() {
	      return this.scroller.scrollLeft;
	    },
	    set: function set(value) {
	      this.scroller.scrollLeft = this.props.rtl && value < 0 ? this.scrollLeftMax + value : value;
	    }
	  }, {
	    key: "scrollLeftMax",
	    get: function get() {
	      return this.scrollLeftMaxValue != null ? this.scrollLeftMaxValue : this.scroller.scrollLeftMax;
	    }
	  }, {
	    key: "getEmptyScrollOffset",
	    value: function getEmptyScrollOffset() {
	      return this.props.emptyScrollOffset == null ? (0, _getScrollbarWidth.default)() : this.props.emptyScrollOffset;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	      var props = this.props;
	      var style = props.style,
	        className = props.className;
	      var rtl = props.rtl,
	        contain = props.contain;
	      if (contain) {
	        style = _objectSpread({}, style);
	        if (contain === true) {
	          style.contain = 'style layout paint';
	        } else {
	          style.contain = contain;
	        }
	      }
	      if (this.props.rtl) {
	        style = _objectSpread(_objectSpread({}, style), {}, {
	          direction: 'ltr'
	        });
	      }
	      className = (0, _join.default)(className, 'inovua-react-virtual-scroll-container', rtl && 'inovua-react-virtual-scroll-container--rtl', 'inovua-react-virtual-scroll-container--sticky-strategy');
	      var stickyStyle = STICKY_STYLE;
	      if (this.props.rtl) {
	        stickyStyle = _objectSpread(_objectSpread({}, stickyStyle), {}, {
	          direction: 'rtl'
	        });
	      }
	      var beforeHeight = this.getBeforeHeight();
	      var afterHeight = this.getAfterHeight();
	      var renderView = function renderView(viewProps) {
	        var viewDOMProps = {
	          ref: _this2.refView,
	          style: stickyStyle,
	          key: 'view',
	          'data-name': 'view',
	          children: _react.default.createElement("div", {
	            style: {
	              position: 'absolute',
	              minWidth: '100%',
	              direction: 'ltr'
	            }
	          }, _react.default.createElement("div", {
	            style: {
	              position: 'absolute',
	              overflow: 'visible',
	              minWidth: '100%',
	              direction: _this2.props.rtl ? 'rtl' : 'ltr'
	            }
	          }, viewProps.children[0], viewProps.children[1]))
	        };
	        var result;
	        if (_this2.props.renderView) {
	          result = _this2.props.renderView(viewDOMProps);
	        }
	        if (result === undefined) {
	          result = _react.default.createElement("div", _objectSpread({}, viewDOMProps));
	        }
	        return result;
	      };
	      var cleanedProps = (0, _reactCleanProps.default)(this.props, this.constructor.propTypes);
	      if (this.props.nativeScroll) {
	        cleanedProps.scrollbars = false;
	      }
	      return _react.default.createElement(_src.default, _objectSpread(_objectSpread({
	        tabIndex: -1,
	        display: this.props.display || 'block',
	        className: className,
	        wrapperStyle: _objectSpread(_objectSpread({}, WRAPPER_STYLE), {}, {
	          top: beforeHeight,
	          bottom: afterHeight
	        })
	      }, cleanedProps), {}, {
	        style: style,
	        before: this.getBefore(),
	        after: this.getAfter(),
	        nativeScroll: this.props.nativeScroll,
	        emptyScrollOffset: 0,
	        getScrollSize: this.getScrollSize,
	        renderScroller: this.renderScroller,
	        renderView: renderView,
	        onViewResize: this.onViewResize,
	        onContainerScroll: this.updateScrollStyle,
	        ref: this.refScroller
	      }));
	    }
	  }]);
	  return StickyVirtualScrollContainer;
	}(_react.default.Component);
	StickyVirtualScrollContainer.propTypes = {
	  contain: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),
	  before: _propTypes.default.element,
	  after: _propTypes.default.element,
	  extraChildren: _propTypes.default.node,
	  renderScrollerSpacer: _propTypes.default.func,
	  applyScrollStyle: _propTypes.default.func,
	  useTransformToScroll: _propTypes.default.bool,
	  preventRtlInherit: _propTypes.default.bool
	};
	StickyVirtualScrollContainer.defaultProps = {
	  useTransformToScroll: !IS_EDGE,
	  shouldAllowScrollbars: function shouldAllowScrollbars(props, scrollbarWidth) {
	    if (props.nativeScroll) {
	      return false;
	    }
	    if (scrollbarWidth) {
	      return true;
	    }
	    if (_isMobile.default || (0, _isSafari.default)()) {
	      return false;
	    }
	    return true;
	  }
	};
	var _default = StickyVirtualScrollContainer;
	exports.default = _default;

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.NativeScrollContainer = void 0;
	Object.defineProperty(exports, "getScrollbarWidth", {
	  enumerable: true,
	  get: function get() {
	    return _getScrollbarWidth.default;
	  }
	});
	Object.defineProperty(exports, "hasSticky", {
	  enumerable: true,
	  get: function get() {
	    return _hasSticky.default;
	  }
	});
	Object.defineProperty(exports, "isMobile", {
	  enumerable: true,
	  get: function get() {
	    return _StickyScroller.isMobile;
	  }
	});
	var _getScrollbarWidth = _interopRequireDefault(__webpack_require__(47));
	var _hasSticky = _interopRequireDefault(__webpack_require__(158));
	var _StickyScroller = _interopRequireWildcard(__webpack_require__(763));
	var _old = _interopRequireDefault(__webpack_require__(766));
	var _NativeScrollContainer = _interopRequireDefault(__webpack_require__(765));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var _default = (0, _hasSticky.default)() ? _StickyScroller.default : _old.default;
	exports.default = _default;
	var NativeScrollContainer = (0, _hasSticky.default)() ? _StickyScroller.default : _NativeScrollContainer.default;
	exports.NativeScrollContainer = NativeScrollContainer;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _src = __webpack_require__(86);
	var _debounce = _interopRequireDefault(__webpack_require__(63));
	var _getScrollbarWidth = _interopRequireDefault(__webpack_require__(47));
	var _isSafari = _interopRequireDefault(__webpack_require__(159));
	var _ScrollerFactory = _interopRequireDefault(__webpack_require__(267));
	var _getGlobal = __webpack_require__(18);
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var globalObject = (0, _getGlobal.getGlobal)();
	var raf = globalObject.requestAnimationFrame;
	var emptyObject = {};
	var SCROLLBAR_WIDTH = (0, _getScrollbarWidth.default)();
	var onScrollbarsChange = function onScrollbarsChange(scrollbars) {
	  if (SCROLLBAR_WIDTH) {
	    var style = this.childNode.style;
	    var rtl = this.props.rtl;
	    var right = scrollbars.vertical ? SCROLLBAR_WIDTH : 0;
	    var bottom = scrollbars.horizontal ? SCROLLBAR_WIDTH : 0;
	    style ? style[rtl && !(0, _isSafari.default)() ? 'left' : 'right'] = "".concat(right, "px") : null;
	    style ? style.bottom = "".concat(bottom, "px") : null;
	  }
	  if (this.props.onScrollbarsChange) {
	    this.props.onScrollbarsChange(scrollbars);
	  }
	};
	var onStop = function onStop(scrollPos, prevScrollPos) {
	  this.scrollStarted = false;
	  if (this.props.onScrollStop) {
	    this.props.onScrollStop(scrollPos, prevScrollPos);
	  }
	};
	var onScroll = function onScroll(_ref) {
	  var target = _ref.target;
	  var _this$props = this.props,
	    onScrollStart = _this$props.onScrollStart,
	    onScrollStop = _this$props.onScrollStop;
	  var startStop = !!(onScrollStart || onScrollStop);
	  var scrollTop = target.scrollTop,
	    scrollLeft = target.scrollLeft;
	  var scrollPos = {
	    scrollTop: scrollTop,
	    scrollLeft: scrollLeft
	  };
	  var prevScrollPos = this.currentScrollPosition || emptyObject;
	  var prevScrollTop = prevScrollPos.scrollTop,
	    prevScrollLeft = prevScrollPos.scrollLeft;
	  if (startStop) {
	    if (!this.scrollStarted) {
	      if (onScrollStart) {
	        onScrollStart(scrollPos, prevScrollPos);
	      }
	    }
	  }
	  var scrollVertical = false;
	  var scrollHorizontal = false;
	  if (this.props.onContainerScroll) {
	    this.props.onContainerScroll(scrollPos, prevScrollPos);
	  }
	  var scrollTopChange = scrollTop !== prevScrollTop;
	  if (scrollTopChange) {
	    scrollVertical = true;
	    if (this.props.onContainerScrollVertical) {
	      this.props.onContainerScrollVertical(scrollTop, prevScrollTop);
	    }
	    if (this.props.onContainerScrollVerticalMin && scrollTop === 0) {
	      this.props.onContainerScrollVerticalMin(0);
	    }
	    if (this.props.onContainerScrollVerticalMax && scrollTop === this.scrollTopMax) {
	      this.props.onContainerScrollVerticalMax(scrollTop);
	    }
	  }
	  var scrollLeftChange = scrollLeft !== prevScrollLeft;
	  if (scrollLeftChange) {
	    scrollHorizontal = true;
	    if (this.props.onContainerScrollHorizontal) {
	      this.props.onContainerScrollHorizontal(scrollLeft, prevScrollLeft);
	    }
	    if (this.props.onContainerScrollHorizontalMin && scrollLeft === 0) {
	      this.props.onContainerScrollHorizontalMin(0);
	    }
	    if (this.props.onContainerScrollHorizontalMax && scrollLeft === this.scrollLeftMax) {
	      this.props.onContainerScrollHorizontalMax(scrollLeft);
	    }
	  }
	  if (startStop && (scrollTopChange || scrollLeftChange)) {
	    if (!this.scrollStarted || this.scrollStarted.vertical !== scrollVertical || this.scrollStarted.horizontal !== scrollHorizontal) {
	      this.scrollStarted = {
	        horizontal: scrollHorizontal,
	        vertical: scrollVertical
	      };
	    }
	    this.onStop(scrollPos, prevScrollPos);
	  }
	  this.currentScrollPosition = scrollPos;
	};
	var InovuaNativeScrollContainer = (0, _ScrollerFactory.default)('InovuaNativeScrollContainer', {
	  init: function init(props) {
	    var _this = this;
	    this.refScroller = function (s) {
	      _this.scroller = s;
	    };
	    this.onStop = (0, _debounce.default)(onStop.bind(this), props.scrollStopDelay, {
	      leading: false
	    });
	    this.onScrollerScroll = function (event) {
	      if (event.target === _this.scroller) {
	        raf(function () {
	          _this.updateScrollStyle();
	        });
	        onScroll.call(_this, event);
	        _this.onScrollIntent();
	      }
	      if (_this.props.onScroll) {
	        _this.props.onScroll(event);
	      }
	    };
	  },
	  prepareClassName: function prepareClassName(className) {
	    return "".concat(className, " inovua-react-virtual-scroll-container--native");
	  },
	  sync: function sync() {
	    if (!this.oldScrollbars) {
	      this.oldScrollbars = this.getScrollbars();
	      return;
	    }
	    var scrollbars = this.getScrollbars();
	    if (scrollbars.vertical !== this.oldScrollbars.vertical || scrollbars.horizontal !== this.oldScrollbars.horizontal) {
	      onScrollbarsChange.call(this, scrollbars);
	    }
	    this.oldScrollbars = scrollbars;
	  },
	  getClientSize: function getClientSize() {
	    var scroller = this.scroller;
	    return {
	      height: scroller.clientHeight,
	      width: scroller.clientWidth
	    };
	  },
	  hasScrollbar: function hasScrollbar(orientation) {
	    var scroller = this.scroller;
	    return orientation === 'horizontal' ? scroller.scrollWidth > scroller.clientWidth : scroller.scrollHeight > scroller.clientHeight;
	  },
	  getScrollLeftMax: function getScrollLeftMax() {
	    var scroller = this.scroller;
	    return scroller.scrollWidth - scroller.clientWidth;
	  },
	  getScrollTopMax: function getScrollTopMax() {
	    var scroller = this.scroller;
	    return scroller.scrollHeight - scroller.clientHeight;
	  },
	  getScrollPosition: function getScrollPosition() {
	    return {
	      scrollTop: this.scrollTop,
	      scrollLeft: this.scrollLeft
	    };
	  },
	  renderScroller: function renderScroller(_ref2) {
	    var content = _ref2.content,
	      spacer = _ref2.spacer,
	      scrollerStyle = _ref2.scrollerStyle,
	      props = _ref2.props;
	    var renderScroller = props.renderScroller;
	    var className = 'inovua-react-virtual-scroll-container__scroll-container';
	    if (props.avoidRepaintOnScroll) {
	      className += " ".concat(className, "--avoid-repaint");
	    }
	    var domProps = {
	      key: 'scroller',
	      tabIndex: -1,
	      onScroll: this.onScrollerScroll,
	      ref: this.refScroller,
	      style: scrollerStyle,
	      className: className,
	      children: [content, spacer]
	    };
	    var result = typeof renderScroller === 'function' ? renderScroller(domProps) : _react.default.createElement("div", _objectSpread({}, domProps));
	    return result;
	  }
	});
	InovuaNativeScrollContainer.propTypes = _objectSpread(_objectSpread({
	  renderScrollerSpacer: _propTypes.default.func
	}, _src.propTypes), InovuaNativeScrollContainer.propTypes);
	InovuaNativeScrollContainer.defaultProps.scrollStopDelay = 150;
	var _default = InovuaNativeScrollContainer;
	exports.default = _default;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	var _src = _interopRequireWildcard(__webpack_require__(86));
	var _ScrollerFactory = _interopRequireDefault(__webpack_require__(267));
	var _getGlobal = __webpack_require__(18);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var globalObject = (0, _getGlobal.getGlobal)();
	var raf = globalObject.requestAnimationFrame;
	var caf = globalObject.cancelAnimationFrame;
	var VIEW_STYLE = {
	  position: 'static'
	};
	var FLEX_1_STYLE = {
	  flex: 1
	};
	var filterScrollerProps = function filterScrollerProps(props) {
	  return Object.keys(props).reduce(function (acc, propName) {
	    if (_src.propTypes[propName] !== undefined) {
	      acc[propName] = props[propName];
	    }
	    return acc;
	  }, {});
	};
	var InovuaVirtualScrollContainer = (0, _ScrollerFactory.default)('InovuaVirtualScrollContainer', {
	  init: function init() {
	    var _this = this;
	    this.childScrollLeft = 0;
	    this.childScrollTop = 0;
	    this.refScroller = function (s) {
	      _this.scroller = s;
	      _this.scrollerNode = s ? s.getScrollerNode() : null;
	    };
	    this.onContainerScroll = function (scrollPos) {
	      var scrollLeft = scrollPos.scrollLeft,
	        scrollTop = scrollPos.scrollTop;
	      _this.childScrollLeft = scrollLeft;
	      _this.childScrollTop = scrollTop;
	      if (_this.containerScrollRafId) {
	        caf(_this.containerScrollRafId);
	      }
	      _this.containerScrollRafId = raf(function () {
	        delete _this.containerScrollRafId;
	        _this.updateScrollStyle(scrollPos);
	      });
	      if (_this.props.onContainerScroll) {
	        var _this$props;
	        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	        (_this$props = _this.props).onContainerScroll.apply(_this$props, [scrollPos].concat(args));
	      }
	      if (_this.onScrollIntent) {
	        _this.onScrollIntent();
	      }
	    };
	  },
	  sync: function sync() {
	    if (!this.scroller) {
	      return;
	    }
	    if (this.scroller.rafSync) {
	      this.scroller.rafSync();
	    } else if (this.scroller.sync) {
	      this.scroller.sync();
	    }
	  },
	  getClientSize: function getClientSize() {
	    var scroller = this.scroller;
	    return scroller.getClientSize();
	  },
	  hasScrollbar: function hasScrollbar(orientation) {
	    return this.scroller.hasScrollbar(orientation);
	  },
	  getScrollLeftMax: function getScrollLeftMax() {
	    var scroller = this.scroller;
	    return scroller.scrollLeftMax;
	  },
	  getScrollTopMax: function getScrollTopMax() {
	    var scroller = this.scroller;
	    return scroller.scrollTopMax;
	  },
	  getScrollPosition: function getScrollPosition() {
	    return {
	      scrollTop: this.childScrollTop,
	      scrollLeft: this.childScrollLeft
	    };
	  },
	  renderScroller: function renderScroller(_ref) {
	    var props = _ref.props,
	      content = _ref.content,
	      spacer = _ref.spacer,
	      scrollerStyle = _ref.scrollerStyle,
	      renderView = _ref.renderView,
	      viewStyle = _ref.viewStyle;
	    var className = 'inovua-react-virtual-scroll-container__scroll-container';
	    if (props.avoidRepaintOnScroll) {
	      className += " ".concat(className, "--avoid-repaint");
	    }
	    return _react.default.createElement(_src.default, _objectSpread(_objectSpread({}, filterScrollerProps(props)), {}, {
	      onContainerScroll: this.onContainerScroll,
	      ref: this.refScroller,
	      style: FLEX_1_STYLE,
	      className: className,
	      scrollerStyle: scrollerStyle,
	      renderView: renderView,
	      viewStyle: viewStyle ? Object.assign({}, VIEW_STYLE, viewStyle) : VIEW_STYLE,
	      resizer: false
	    }), content, spacer);
	  }
	});
	InovuaVirtualScrollContainer.propTypes = Object.assign({
	  renderSpacer: _propTypes.default.func,
	  renderScrollerSpacer: _propTypes.default.func
	}, _src.propTypes, InovuaVirtualScrollContainer.propTypes);
	var _default = InovuaVirtualScrollContainer;
	exports.default = _default;

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _region = _interopRequireDefault(__webpack_require__(43));
	_region.default.prototype.alignToRegion = function (region, alignPositions) {
	  _region.default.align(this, region, alignPositions);
	  return this;
	};
	_region.default.prototype.alignToPoint = function (point, anchor) {
	  _region.default.alignToPoint(this, point, anchor);
	  return this;
	};

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _region = _interopRequireDefault(__webpack_require__(43));
	_region.default.align = function (sourceRegion, targetRegion, align) {
	  targetRegion = _region.default.from(targetRegion);
	  align = (align || 'c-c').split('-');
	  if (align.length != 2) {
	    console.warn("Incorrect region alignment! The align parameter need to be in the form 'br-c', that is, a - separated string!", align);
	  }
	  return _region.default.alignToPoint(sourceRegion, targetRegion.getPoint(align[1]), align[0]);
	};
	_region.default.alignToPoint = function (region, point, anchor) {
	  region = _region.default.from(region);
	  var sourcePoint = region.getPoint(anchor);
	  var count = 0;
	  var shiftObj = {};
	  if (sourcePoint.x != null && point.x != null) {
	    count++;
	    shiftObj.left = point.x - sourcePoint.x;
	  }
	  if (sourcePoint.y != null && point.y != null) {
	    count++;
	    shiftObj.top = point.y - sourcePoint.y;
	  }
	  if (count) {
	    region.shift(shiftObj);
	  }
	  return region;
	};

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _region = _interopRequireDefault(__webpack_require__(43));
	function ALIGN_TO_NORMALIZED(sourceRegion, targetRegion, positions, config) {
	  targetRegion = _region.default.from(targetRegion);
	  config = config || {};
	  var constrainTo = config.constrain,
	    syncOption = config.sync,
	    offsets = config.offset || [],
	    syncWidth = false,
	    syncHeight = false,
	    sourceClone = sourceRegion.clone();
	  if (!Array.isArray(positions)) {
	    positions = positions ? [positions] : [];
	  }
	  if (!Array.isArray(offsets)) {
	    offsets = offsets ? [offsets] : [];
	  }
	  if (constrainTo) {
	    constrainTo = constrainTo === true ? _region.default.getDocRegion() : constrainTo.getRegion();
	  }
	  if (syncOption) {
	    if (syncOption.size) {
	      syncWidth = true;
	      syncHeight = true;
	    } else {
	      syncWidth = syncOption === true ? true : syncOption.width || false;
	      syncHeight = syncOption === true ? true : syncOption.height || false;
	    }
	  }
	  if (syncWidth) {
	    sourceClone.setWidth(targetRegion.getWidth());
	  }
	  if (syncHeight) {
	    sourceClone.setHeight(targetRegion.getHeight());
	  }
	  var offset,
	    i = 0,
	    len = positions.length,
	    pos,
	    intersection,
	    itArea,
	    maxArea = -1,
	    maxAreaIndex = -1;
	  for (; i < len; i++) {
	    pos = positions[i];
	    offset = offsets[i];
	    sourceClone.alignToRegion(targetRegion, pos);
	    if (offset) {
	      if (!Array.isArray(offset)) {
	        offset = offsets[i] = [offset.x || offset.left, offset.y || offset.top];
	      }
	      sourceClone.shift({
	        left: offset[0],
	        top: offset[1]
	      });
	    }
	    if (constrainTo) {
	      intersection = sourceClone.getIntersection(constrainTo);
	      if (intersection && intersection.equals(sourceClone)) {
	        sourceRegion.set(sourceClone);
	        return pos;
	      } else {
	        if (intersection && (itArea = intersection.getArea()) > maxArea) {
	          maxArea = itArea;
	          maxAreaIndex = i;
	        }
	      }
	    } else {
	      sourceRegion.set(sourceClone);
	      return pos;
	    }
	  }
	  if (~maxAreaIndex) {
	    pos = positions[maxAreaIndex];
	    offset = offsets[maxAreaIndex];
	    sourceClone.alignToRegion(targetRegion, pos);
	    if (offset) {
	      sourceClone.shift({
	        left: offset[0],
	        top: offset[1]
	      });
	    }
	    intersection = sourceClone.getIntersection(constrainTo);
	    sourceClone.setRegion(intersection);
	    sourceClone.alignToRegion(targetRegion, pos);
	    if (offset) {
	      sourceClone.shift({
	        left: offset[0],
	        top: offset[1]
	      });
	    }
	    sourceRegion.set(sourceClone);
	    return pos;
	  }
	}
	var _default = ALIGN_TO_NORMALIZED;
	exports.default = _default;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _region = _interopRequireDefault(__webpack_require__(43));
	var _alignToNormalized = _interopRequireDefault(__webpack_require__(769));
	function COMPUTE_ALIGN_REGION(sourceRegion, targetRegion, positions, config) {
	  sourceRegion = _region.default.from(sourceRegion);
	  var sourceClone = sourceRegion.clone();
	  var position = (0, _alignToNormalized.default)(sourceClone, targetRegion, positions, config);
	  return {
	    position: position,
	    region: sourceClone,
	    widthChanged: sourceClone.getWidth() != sourceRegion.getWidth(),
	    heightChanged: sourceClone.getHeight() != sourceRegion.getHeight(),
	    positionChanged: sourceClone.equalsPosition(sourceRegion)
	  };
	}
	var _default = COMPUTE_ALIGN_REGION;
	exports.default = _default;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _construct2 = _interopRequireDefault(__webpack_require__(525));
	var _hasOwn = _interopRequireDefault(__webpack_require__(263));
	var _statics = _interopRequireDefault(__webpack_require__(773));
	var _eventemitter = _interopRequireDefault(__webpack_require__(329));
	var _inherits = _interopRequireDefault(__webpack_require__(772));
	var _validate = _interopRequireDefault(__webpack_require__(268));
	var objectToString = Object.prototype.toString;
	var isObject = function isObject(value) {
	  return objectToString.apply(value) === '[object Object]';
	};
	function copyList(source, target, list) {
	  if (source) {
	    list.forEach(function (key) {
	      if ((0, _hasOwn.default)(source, key)) {
	        target[key] = source[key];
	      }
	    });
	  }
	  return target;
	}
	var POINT_POSITIONS = {
	  cy: 'YCenter',
	  cx: 'XCenter',
	  t: 'Top',
	  tc: 'TopCenter',
	  tl: 'TopLeft',
	  tr: 'TopRight',
	  b: 'Bottom',
	  bc: 'BottomCenter',
	  bl: 'BottomLeft',
	  br: 'BottomRight',
	  l: 'Left',
	  lc: 'LeftCenter',
	  r: 'Right',
	  rc: 'RightCenter',
	  c: 'Center'
	};
	var REGION = function REGION() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	  var top = args[0],
	    right = args[1],
	    bottom = args[2],
	    left = args[3];
	  if (!(this instanceof REGION)) {
	    return (0, _construct2.default)(REGION, args);
	  }
	  _eventemitter.default.call(this);
	  if (isObject(top)) {
	    copyList(top, this, ['top', 'right', 'bottom', 'left']);
	    if (top.bottom == null && top.height != null) {
	      this.bottom = this.top + top.height;
	    }
	    if (top.right == null && top.width != null) {
	      this.right = this.left + top.width;
	    }
	    if (this.right == null) {
	      this.right = this.left;
	    }
	    if (this.bottom == null) {
	      this.bottom = this.top;
	    }
	    if (top.emitChangeEvents) {
	      this.emitChangeEvents = top.emitChangeEvents;
	    }
	  } else {
	    this.top = top;
	    this.right = right;
	    this.bottom = bottom;
	    this.left = left;
	  }
	  this[0] = this.left;
	  this[1] = this.top;
	  (0, _validate.default)(this);
	};
	(0, _inherits.default)(REGION, _eventemitter.default);
	Object.assign(REGION.prototype, {
	  emitChangeEvents: false,
	  getRegion: function getRegion(clone) {
	    return clone ? this.clone() : this;
	  },
	  setRegion: function setRegion(reg) {
	    if (reg instanceof REGION) {
	      this.set(reg.get());
	    } else {
	      this.set(reg);
	    }
	    return this;
	  },
	  validate: function validate() {
	    return REGION.validate(this);
	  },
	  _before: function _before() {
	    if (this.emitChangeEvents) {
	      return copyList(this, {}, ['left', 'top', 'bottom', 'right']);
	    }
	  },
	  _after: function _after(before) {
	    if (this.emitChangeEvents) {
	      if (this.top != before.top || this.left != before.left) {
	        this.emitPositionChange();
	      }
	      if (this.right != before.right || this.bottom != before.bottom) {
	        this.emitSizeChange();
	      }
	    }
	  },
	  notifyPositionChange: function notifyPositionChange() {
	    this.emit('changeposition', this);
	  },
	  emitPositionChange: function emitPositionChange() {
	    this.notifyPositionChange();
	  },
	  notifySizeChange: function notifySizeChange() {
	    this.emit('changesize', this);
	  },
	  emitSizeChange: function emitSizeChange() {
	    this.notifySizeChange();
	  },
	  add: function add(directions) {
	    var before = this._before();
	    var direction;
	    for (direction in directions) if ((0, _hasOwn.default)(directions, direction)) {
	      this[direction] += directions[direction];
	    }
	    this[0] = this.left;
	    this[1] = this.top;
	    this._after(before);
	    return this;
	  },
	  substract: function substract(directions) {
	    var before = this._before();
	    var direction;
	    for (direction in directions) if ((0, _hasOwn.default)(directions, direction)) {
	      this[direction] -= directions[direction];
	    }
	    this[0] = this.left;
	    this[1] = this.top;
	    this._after(before);
	    return this;
	  },
	  getSize: function getSize() {
	    return {
	      width: this.width,
	      height: this.height
	    };
	  },
	  setPosition: function setPosition(position) {
	    var width = this.width;
	    var height = this.height;
	    if (position.left != undefined) {
	      position.right = position.left + width;
	    }
	    if (position.top != undefined) {
	      position.bottom = position.top + height;
	    }
	    return this.set(position);
	  },
	  setSize: function setSize(size) {
	    if (size.height != undefined && size.width != undefined) {
	      return this.set({
	        right: this.left + size.width,
	        bottom: this.top + size.height
	      });
	    }
	    if (size.width != undefined) {
	      this.setWidth(size.width);
	    }
	    if (size.height != undefined) {
	      this.setHeight(size.height);
	    }
	    return this;
	  },
	  setWidth: function setWidth(width) {
	    return this.set({
	      right: this.left + width
	    });
	  },
	  setHeight: function setHeight(height) {
	    return this.set({
	      bottom: this.top + height
	    });
	  },
	  set: function set(directions) {
	    var before = this._before();
	    copyList(directions, this, ['left', 'top', 'bottom', 'right']);
	    if (directions.bottom == null && directions.height != null) {
	      this.bottom = this.top + directions.height;
	    }
	    if (directions.right == null && directions.width != null) {
	      this.right = this.left + directions.width;
	    }
	    this[0] = this.left;
	    this[1] = this.top;
	    this._after(before);
	    return this;
	  },
	  get: function get(dir) {
	    return dir ? this[dir] : copyList(this, {}, ['left', 'right', 'top', 'bottom']);
	  },
	  shift: function shift(directions) {
	    var before = this._before();
	    if (directions.top) {
	      this.top += directions.top;
	      this.bottom += directions.top;
	    }
	    if (directions.left) {
	      this.left += directions.left;
	      this.right += directions.left;
	    }
	    this[0] = this.left;
	    this[1] = this.top;
	    this._after(before);
	    return this;
	  },
	  unshift: function unshift(directions) {
	    if (directions.top) {
	      directions.top *= -1;
	    }
	    if (directions.left) {
	      directions.left *= -1;
	    }
	    return this.shift(directions);
	  },
	  equals: function equals(region) {
	    return this.equalsPosition(region) && this.equalsSize(region);
	  },
	  equalsSize: function equalsSize(size) {
	    var isInstance = size instanceof REGION;
	    var s = {
	      width: size.width == null && isInstance ? size.getWidth() : size.width,
	      height: size.height == null && isInstance ? size.getHeight() : size.height
	    };
	    return this.getWidth() == s.width && this.getHeight() == s.height;
	  },
	  equalsPosition: function equalsPosition(region) {
	    return this.top == region.top && this.left == region.left;
	  },
	  addLeft: function addLeft(left) {
	    var before = this._before();
	    this.left = this[0] = this.left + left;
	    this._after(before);
	    return this;
	  },
	  addTop: function addTop(top) {
	    var before = this._before();
	    this.top = this[1] = this.top + top;
	    this._after(before);
	    return this;
	  },
	  addBottom: function addBottom(bottom) {
	    var before = this._before();
	    this.bottom += bottom;
	    this._after(before);
	    return this;
	  },
	  addRight: function addRight(right) {
	    var before = this._before();
	    this.right += right;
	    this._after(before);
	    return this;
	  },
	  minTop: function minTop() {
	    return this.expand({
	      top: 1
	    });
	  },
	  maxBottom: function maxBottom() {
	    return this.expand({
	      bottom: 1
	    });
	  },
	  minLeft: function minLeft() {
	    return this.expand({
	      left: 1
	    });
	  },
	  maxRight: function maxRight() {
	    return this.expand({
	      right: 1
	    });
	  },
	  expand: function expand(directions, region) {
	    var docRegion = region || REGION.getDocRegion();
	    var list = [];
	    var direction;
	    var before = this._before();
	    for (direction in directions) if ((0, _hasOwn.default)(directions, direction)) {
	      list.push(direction);
	    }
	    copyList(docRegion, this, list);
	    this[0] = this.left;
	    this[1] = this.top;
	    this._after(before);
	    return this;
	  },
	  clone: function clone() {
	    return new REGION({
	      top: this.top,
	      left: this.left,
	      right: this.right,
	      bottom: this.bottom
	    });
	  },
	  containsPoint: function containsPoint(x, y) {
	    if (arguments.length == 1) {
	      y = x.y;
	      x = x.x;
	    }
	    return this.left <= x && x <= this.right && this.top <= y && y <= this.bottom;
	  },
	  containsRegion: function containsRegion(region) {
	    return this.containsPoint(region.left, region.top) && this.containsPoint(region.right, region.bottom);
	  },
	  diffHeight: function diffHeight(region) {
	    return this.diff(region, {
	      top: true,
	      bottom: true
	    });
	  },
	  diffWidth: function diffWidth(region) {
	    return this.diff(region, {
	      left: true,
	      right: true
	    });
	  },
	  diff: function diff(region, directions) {
	    var result = {};
	    var dirName;
	    for (dirName in directions) if ((0, _hasOwn.default)(directions, dirName)) {
	      result[dirName] = this[dirName] - region[dirName];
	    }
	    return result;
	  },
	  getPosition: function getPosition() {
	    return {
	      left: this.left,
	      top: this.top
	    };
	  },
	  getPoint: function getPoint(position, asLeftTop) {
	    if (!POINT_POSITIONS[position]) {
	      console.warn('The position ', position, ' could not be found! Available options are tl, bl, tr, br, l, r, t, b.');
	    }
	    var method = 'getPoint' + POINT_POSITIONS[position],
	      result = this[method]();
	    if (asLeftTop) {
	      return {
	        left: result.x,
	        top: result.y
	      };
	    }
	    return result;
	  },
	  getPointYCenter: function getPointYCenter() {
	    return {
	      x: null,
	      y: this.top + this.getHeight() / 2
	    };
	  },
	  getPointXCenter: function getPointXCenter() {
	    return {
	      x: this.left + this.getWidth() / 2,
	      y: null
	    };
	  },
	  getPointTop: function getPointTop() {
	    return {
	      x: null,
	      y: this.top
	    };
	  },
	  getPointTopCenter: function getPointTopCenter() {
	    return {
	      x: this.left + this.getWidth() / 2,
	      y: this.top
	    };
	  },
	  getPointTopLeft: function getPointTopLeft() {
	    return {
	      x: this.left,
	      y: this.top
	    };
	  },
	  getPointTopRight: function getPointTopRight() {
	    return {
	      x: this.right,
	      y: this.top
	    };
	  },
	  getPointBottom: function getPointBottom() {
	    return {
	      x: null,
	      y: this.bottom
	    };
	  },
	  getPointBottomCenter: function getPointBottomCenter() {
	    return {
	      x: this.left + this.getWidth() / 2,
	      y: this.bottom
	    };
	  },
	  getPointBottomLeft: function getPointBottomLeft() {
	    return {
	      x: this.left,
	      y: this.bottom
	    };
	  },
	  getPointBottomRight: function getPointBottomRight() {
	    return {
	      x: this.right,
	      y: this.bottom
	    };
	  },
	  getPointLeft: function getPointLeft() {
	    return {
	      x: this.left,
	      y: null
	    };
	  },
	  getPointLeftCenter: function getPointLeftCenter() {
	    return {
	      x: this.left,
	      y: this.top + this.getHeight() / 2
	    };
	  },
	  getPointRight: function getPointRight() {
	    return {
	      x: this.right,
	      y: null
	    };
	  },
	  getPointRightCenter: function getPointRightCenter() {
	    return {
	      x: this.right,
	      y: this.top + this.getHeight() / 2
	    };
	  },
	  getPointCenter: function getPointCenter() {
	    return {
	      x: this.left + this.getWidth() / 2,
	      y: this.top + this.getHeight() / 2
	    };
	  },
	  getHeight: function getHeight() {
	    return this.bottom - this.top;
	  },
	  getWidth: function getWidth() {
	    return this.right - this.left;
	  },
	  getTop: function getTop() {
	    return this.top;
	  },
	  getLeft: function getLeft() {
	    return this.left;
	  },
	  getBottom: function getBottom() {
	    return this.bottom;
	  },
	  getRight: function getRight() {
	    return this.right;
	  },
	  getArea: function getArea() {
	    return this.getWidth() * this.getHeight();
	  },
	  constrainTo: function constrainTo(contrain) {
	    var intersect = this.getIntersection(contrain);
	    var shift;
	    if (!intersect || !intersect.equals(this)) {
	      var contrainWidth = contrain.getWidth(),
	        contrainHeight = contrain.getHeight();
	      if (this.getWidth() > contrainWidth) {
	        this.left = contrain.left;
	        this.setWidth(contrainWidth);
	      }
	      if (this.getHeight() > contrainHeight) {
	        this.top = contrain.top;
	        this.setHeight(contrainHeight);
	      }
	      shift = {};
	      if (this.right > contrain.right) {
	        shift.left = contrain.right - this.right;
	      }
	      if (this.bottom > contrain.bottom) {
	        shift.top = contrain.bottom - this.bottom;
	      }
	      if (this.left < contrain.left) {
	        shift.left = contrain.left - this.left;
	      }
	      if (this.top < contrain.top) {
	        shift.top = contrain.top - this.top;
	      }
	      this.shift(shift);
	      return true;
	    }
	    return false;
	  },
	  __IS_REGION: true
	});
	Object.defineProperties(REGION.prototype, {
	  width: {
	    get: function get() {
	      return this.getWidth();
	    },
	    set: function set(width) {
	      return this.setWidth(width);
	    }
	  },
	  height: {
	    get: function get() {
	      return this.getHeight();
	    },
	    set: function set(height) {
	      return this.setHeight(height);
	    }
	  }
	});
	(0, _statics.default)(REGION);
	var _default = REGION;
	exports.default = _default;

/***/ },
/* 772 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	function _default(ctor, superCtor) {
	  ctor.super_ = superCtor;
	  ctor.prototype = Object.create(superCtor.prototype, {
	    constructor: {
	      value: ctor,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	}

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _default;
	var _hasOwn = _interopRequireDefault(__webpack_require__(263));
	var _validate = _interopRequireDefault(__webpack_require__(268));
	function _default(REGION) {
	  var MAX = Math.max;
	  var MIN = Math.min;
	  var statics = {
	    init: function init() {
	      var exportAsNonStatic = {
	        getIntersection: true,
	        getIntersectionArea: true,
	        getIntersectionHeight: true,
	        getIntersectionWidth: true,
	        getUnion: true
	      };
	      var thisProto = REGION.prototype;
	      var newName;
	      var exportHasOwn = (0, _hasOwn.default)(exportAsNonStatic);
	      var methodName;
	      for (methodName in exportAsNonStatic) if (exportHasOwn(methodName)) {
	        newName = exportAsNonStatic[methodName];
	        if (typeof newName != 'string') {
	          newName = methodName;
	        }
	        (function (proto, methodName, protoMethodName) {
	          proto[methodName] = function (region) {
	            if (!REGION[protoMethodName]) {
	              console.warn('cannot find method ', protoMethodName, ' on ', REGION);
	            }
	            return REGION[protoMethodName](this, region);
	          };
	        })(thisProto, newName, methodName);
	      }
	    },
	    validate: _validate.default,
	    getDocRegion: function getDocRegion() {
	      return REGION.fromDOM(document.documentElement);
	    },
	    from: function from(reg) {
	      if (!reg) {
	        return;
	      }
	      if (reg.__IS_REGION) {
	        return reg;
	      }
	      if (typeof document != 'undefined') {
	        if (reg && reg.getBoundingClientRect) {
	          return REGION.fromDOM(reg);
	        }
	        if (reg.type && typeof reg.pageX !== 'undefined' && typeof reg.pageY !== 'undefined') {
	          return REGION.fromEvent(reg);
	        }
	      }
	      return REGION(reg);
	    },
	    fromEvent: function fromEvent(event) {
	      return REGION.fromPoint({
	        x: event.pageX,
	        y: event.pageY
	      });
	    },
	    fromDOM: function fromDOM(dom) {
	      var rect = dom.getBoundingClientRect();
	      return new REGION({
	        top: rect.top,
	        left: rect.left,
	        bottom: rect.bottom,
	        right: rect.right
	      });
	    },
	    getIntersection: function getIntersection(first, second) {
	      var area = this.getIntersectionArea(first, second);
	      if (area) {
	        return new REGION(area);
	      }
	      return false;
	    },
	    getIntersectionWidth: function getIntersectionWidth(first, second) {
	      var minRight = MIN(first.right, second.right);
	      var maxLeft = MAX(first.left, second.left);
	      if (maxLeft < minRight) {
	        return minRight - maxLeft;
	      }
	      return 0;
	    },
	    getIntersectionHeight: function getIntersectionHeight(first, second) {
	      var maxTop = MAX(first.top, second.top);
	      var minBottom = MIN(first.bottom, second.bottom);
	      if (maxTop < minBottom) {
	        return minBottom - maxTop;
	      }
	      return 0;
	    },
	    getIntersectionArea: function getIntersectionArea(first, second) {
	      var maxTop = MAX(first.top, second.top);
	      var minRight = MIN(first.right, second.right);
	      var minBottom = MIN(first.bottom, second.bottom);
	      var maxLeft = MAX(first.left, second.left);
	      if (maxTop < minBottom && maxLeft < minRight) {
	        return {
	          top: maxTop,
	          right: minRight,
	          bottom: minBottom,
	          left: maxLeft,
	          width: minRight - maxLeft,
	          height: minBottom - maxTop
	        };
	      }
	      return false;
	    },
	    getUnion: function getUnion(first, second) {
	      var top = MIN(first.top, second.top);
	      var right = MAX(first.right, second.right);
	      var bottom = MAX(first.bottom, second.bottom);
	      var left = MIN(first.left, second.left);
	      return new REGION(top, right, bottom, left);
	    },
	    getRegion: function getRegion(reg) {
	      return REGION.from(reg);
	    },
	    fromPoint: function fromPoint(xy) {
	      return new REGION({
	        top: xy.y,
	        bottom: xy.y,
	        left: xy.x,
	        right: xy.x
	      });
	    }
	  };
	  Object.keys(statics).forEach(function (key) {
	    REGION[key] = statics[key];
	  });
	  REGION.init();
	}

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _smoothScrollTo = _interopRequireDefault(__webpack_require__(114));
	var _default = function _default(node, _ref) {
	  var orientation = _ref.orientation,
	    direction = _ref.direction,
	    pageSize = _ref.pageSize,
	    duration = _ref.duration;
	  if (!direction) {
	    throw new Error('Please provide a scroll direction: 1 or -1!');
	  }
	  var horiz = orientation == 'horizontal';
	  var scrollPosName = horiz ? 'scrollLeft' : 'scrollTop';
	  pageSize = pageSize || (horiz ? node.clientWidth - 20 : node.clientHeight - 20);
	  var currentValue = node[scrollPosName];
	  var newValue = currentValue + direction * pageSize;
	  (0, _smoothScrollTo.default)(node, newValue, {
	    orientation: orientation,
	    duration: duration
	  });
	};
	exports.default = _default;

/***/ },
/* 775 */
[1296, 777],
/* 776 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	function curry(fn, n) {
	  if (typeof n !== 'number') {
	    n = fn.length;
	  }
	  function getCurryClosure(prevArgs) {
	    function curryClosure() {
	      var len = arguments.length;
	      var args = [].concat(prevArgs);
	      if (len) {
	        args.push.apply(args, arguments);
	      }
	      if (args.length < n) {
	        return getCurryClosure(args);
	      }
	      return fn.apply(this, args);
	    }
	    return curryClosure;
	  }
	  return getCurryClosure([]);
	}
	var _default = curry;
	exports.default = _default;

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _deepGet = _interopRequireDefault(__webpack_require__(750));
	var _curry = _interopRequireDefault(__webpack_require__(776));
	var _types = _interopRequireDefault(__webpack_require__(778));
	function isFn(fn) {
	  return typeof fn === 'function';
	}
	var sorty = (0, _curry.default)(function (sortInfo, array) {
	  return array.sort(getMultiSortFunction(sortInfo));
	});
	sorty.types = _types.default;
	var getSingleSortFunction = function getSingleSortFunction(info) {
	  if (!info) {
	    return;
	  }
	  var field = info.name;
	  var dir = info.dir === 'desc' || info.dir < 0 ? -1 : info.dir === 'asc' || info.dir > 0 ? 1 : 0;
	  if (!dir) {
	    return;
	  }
	  if (!info.fn && info.type) {
	    info.fn = sorty.types[info.type];
	  }
	  if (!info.fn) {
	    info.fn = sorty.types.string || _types.default.string;
	  }
	  var fn = info.fn;
	  return function (first, second) {
	    var a = field ? (0, _deepGet.default)(first, field) : first;
	    var b = field ? (0, _deepGet.default)(second, field) : second;
	    return dir * fn(a, b, first, second, info);
	  };
	};
	var getSortFunctions = function getSortFunctions(sortInfo) {
	  if (!Array.isArray(sortInfo)) {
	    sortInfo = [sortInfo];
	  }
	  return sortInfo.map(getSingleSortFunction).filter(isFn);
	};
	var getMultiSortFunction = function getMultiSortFunction(sortInfo) {
	  var fns = getSortFunctions(sortInfo);
	  return function (first, second) {
	    var result = 0;
	    var i = 0;
	    var len = fns.length;
	    var fn;
	    for (; i < len; i++) {
	      fn = fns[i];
	      if (!fn) {
	        continue;
	      }
	      result = fn(first, second);
	      if (result != 0) {
	        return result;
	      }
	    }
	    return result;
	  };
	};
	sorty._getSortFunctions = getSortFunctions;
	sorty.getFunction = getMultiSortFunction;
	var _default = sorty;
	exports.default = _default;

/***/ },
/* 778 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = {
	  string: function string(a, b) {
	    a += '';
	    b += '';
	    return a.localeCompare(b);
	  },
	  number: function number(a, b) {
	    if (isFinite(a - b)) {
	      return a - b;
	    } else {
	      return isFinite(a) ? -1 : 1;
	    }
	  }
	};
	exports.default = _default;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _useCellSelection = __webpack_require__(781);
	var _default = {
	  name: 'cell-selection',
	  hook: _useCellSelection.useCellSelection,
	  defaultProps: function defaultProps() {
	    return {};
	  }
	};
	exports.default = _default;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _useProperty3 = _interopRequireDefault(__webpack_require__(48));
	var _react = __webpack_require__(2);
	var _clamp = _interopRequireDefault(__webpack_require__(65));
	var _usePrevious = _interopRequireDefault(__webpack_require__(61));
	var _batchUpdate = _interopRequireDefault(__webpack_require__(50));
	var _throttle = _interopRequireDefault(__webpack_require__(269));
	var useActiveCell = function useActiveCell(props, computedPropsRef) {
	  var _useProperty = (0, _useProperty3.default)(props, 'activeCell'),
	    _useProperty2 = (0, _slicedToArray2.default)(_useProperty, 2),
	    computedActiveCell = _useProperty2[0],
	    doSetActiveCell = _useProperty2[1];
	  if (!props.enableKeyboardNavigation) {
	    computedActiveCell = undefined;
	  }
	  var setActiveCell = (0, _react.useCallback)(function (activeCell, queue) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps || !computedProps.computedCellNavigationEnabled) {
	      return;
	    }
	    var computedActiveCell = computedProps.computedActiveCell,
	      data = computedProps.data,
	      visibleColumns = computedProps.visibleColumns;
	    var shouldCommit = !queue;
	    queue = queue || (0, _batchUpdate.default)();
	    if (activeCell) {
	      var _activeCell = activeCell,
	        _activeCell2 = (0, _slicedToArray2.default)(_activeCell, 2),
	        activeCellRowIndex = _activeCell2[0],
	        activeCellColumnIndex = _activeCell2[1];
	      activeCellRowIndex = (0, _clamp.default)(activeCellRowIndex, 0, data.length - 1);
	      activeCellColumnIndex = (0, _clamp.default)(activeCellColumnIndex, 0, visibleColumns.length - 1);
	      var col = computedProps.getColumnBy(activeCellColumnIndex);
	      if (col && col.cellSelectable === false) {
	        return;
	      }
	      if (!data || data.__group || activeCellRowIndex == null || activeCellColumnIndex == null) {
	        queue(function () {
	          doSetActiveCell(null);
	          computedProps.setLastCellInRange('');
	        });
	        if (shouldCommit) {
	          queue.commit();
	        }
	        return;
	      }
	      activeCell = [activeCellRowIndex, activeCellColumnIndex];
	      if (activeCell === computedActiveCell || computedActiveCell && activeCell && computedActiveCell[0] === activeCell[0] && computedActiveCell[1] === activeCell[1]) {
	        return;
	      }
	    }
	    queue(function () {
	      doSetActiveCell(activeCell);
	      computedProps.setLastCellInRange('');
	    });
	    if (shouldCommit) {
	      queue.commit();
	    }
	  }, []);
	  var oldActiveCell = (0, _usePrevious.default)(computedActiveCell, null);
	  (0, _react.useLayoutEffect)(function () {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (oldActiveCell !== computedActiveCell && computedActiveCell) {
	      var _computedActiveCell = computedActiveCell,
	        _computedActiveCell2 = (0, _slicedToArray2.default)(_computedActiveCell, 2),
	        rowIndex = _computedActiveCell2[0],
	        columnIndex = _computedActiveCell2[1];
	      if (rowIndex == null || columnIndex == null) {
	        return;
	      }
	      var top = !oldActiveCell || rowIndex < oldActiveCell[0];
	      var right = !oldActiveCell || columnIndex > oldActiveCell[1];
	      var scrollToColumnIndex = (0, _clamp.default)(columnIndex + (right ? 0 : -0), 0, computedProps.visibleColumns.length - 1);
	      computedProps.scrollToCell({
	        rowIndex: rowIndex,
	        columnIndex: scrollToColumnIndex
	      }, {
	        top: top,
	        right: right
	      });
	    }
	  }, [computedActiveCell, oldActiveCell]);
	  var getCellSelectionBetween = (0, _react.useCallback)(function (start, end) {
	    var computedProps = computedPropsRef.current;
	    if (!start || !end || !computedProps) {
	      return {};
	    }
	    var startRow = Math.min(start[0], end[0]);
	    var startCol = Math.min(start[1], end[1]);
	    var endRow = Math.max(start[0], end[0]);
	    var endCol = Math.max(start[1], end[1]);
	    var range = {};
	    var groupBy = computedProps.computedGroupBy;
	    var dataSource = groupBy ? computedProps.data : [];
	    var current;
	    for (var row = startRow; row <= endRow; row++) {
	      if (groupBy) {
	        current = dataSource[row];
	        if (!current) {
	          break;
	        }
	        if (current.__group) {
	          continue;
	        }
	      }
	      for (var col = startCol; col <= endCol; col++) {
	        range[getCellSelectionKey(row, col)] = true;
	      }
	    }
	    return range;
	  }, []);
	  var getCellSelectionKey = (0, _react.useCallback)(function (cellProps, col) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return -1;
	    }
	    var rowKey;
	    var colKey;
	    if (typeof cellProps === 'string') {
	      return cellProps;
	    }
	    if (typeof cellProps === 'number' && typeof col === 'number') {
	      rowKey = cellProps;
	      colKey = col;
	    } else {
	      if (cellProps) {
	        rowKey = cellProps.rowIndex;
	        colKey = cellProps.columnIndex;
	      }
	    }
	    if (!computedProps.cellSelectionByIndex) {
	      return computedProps.getCellSelectionIdKey(rowKey, colKey);
	    }
	    return "".concat([rowKey, colKey]);
	  }, [computedPropsRef, props.columns]);
	  var getCellSelectionIdKey = (0, _react.useCallback)(function (rowIndex, columnIndex) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return -1;
	    }
	    var col = computedProps.getColumnBy(columnIndex);
	    if (!col) {
	      return -1;
	    }
	    var colId = col.id || col.name;
	    var item = computedProps.getItemAt(rowIndex);
	    if (!item) {
	      return '';
	    }
	    var rowId = computedProps.getItemId(item);
	    return "".concat([rowId, colId]);
	  }, []);
	  var incrementActiveCell = (0, _react.useCallback)(function (direction) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var computedActiveCell = computedProps.computedActiveCell;
	    if (!computedActiveCell) {
	      computedActiveCell = [0, 0];
	    }
	    var _direction = (0, _slicedToArray2.default)(direction, 2),
	      row = _direction[0],
	      col = _direction[1];
	    var data = computedProps.data,
	      visibleColumns = computedProps.visibleColumns,
	      computedGroupBy = computedProps.computedGroupBy,
	      groupColumn = computedProps.groupColumn;
	    var maxRow = data.length - 1;
	    var columns = visibleColumns;
	    var maxCol = columns.length - 1;
	    var groupBy = computedGroupBy;
	    var minCol = groupBy && !groupColumn ? groupBy.length : 0;
	    var rowIndex = computedActiveCell[0];
	    var colIndex = computedActiveCell[1];
	    if (row) {
	      var rowSign = row < 0 ? -1 : 1;
	      var rowAdd = row;
	      while (data[rowIndex + rowAdd] && data[rowIndex + rowAdd].__group) {
	        rowIndex += rowAdd;
	        rowAdd = rowSign;
	      }
	      rowIndex += rowAdd;
	    }
	    if (col) {
	      var colSign = col < 0 ? -1 : 1;
	      var colAdd = col;
	      while (columns[colIndex + colAdd] && columns[colIndex + colAdd].cellSelectable === false) {
	        colIndex += colSign;
	        colAdd = colSign;
	      }
	      colIndex += colAdd;
	    }
	    rowIndex = (0, _clamp.default)(rowIndex, 0, maxRow);
	    colIndex = (0, _clamp.default)(colIndex, minCol, maxCol);
	    if (computedProps.activeCellThrottle) {
	      (0, _throttle.default)(function () {
	        return computedProps.setActiveCell([rowIndex, colIndex]);
	      }, computedProps.activeCellThrottle, {
	        trailing: true,
	        leading: false
	      });
	    } else {
	      computedProps.setActiveCell([rowIndex, colIndex]);
	    }
	  }, []);
	  return {
	    getCellSelectionBetween: getCellSelectionBetween,
	    getCellSelectionIdKey: getCellSelectionIdKey,
	    computedActiveCell: computedActiveCell,
	    setActiveCell: setActiveCell,
	    getCellSelectionKey: getCellSelectionKey,
	    incrementActiveCell: incrementActiveCell
	  };
	};
	var _default = useActiveCell;
	exports.default = _default;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useCellSelection = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = __webpack_require__(2);
	var _useProperty3 = _interopRequireDefault(__webpack_require__(48));
	var _batchUpdate = _interopRequireDefault(__webpack_require__(50));
	var _clamp = _interopRequireDefault(__webpack_require__(65));
	var _useActiveCell2 = _interopRequireDefault(__webpack_require__(780));
	var _usePrevious = _interopRequireDefault(__webpack_require__(61));
	var _useNamedState3 = _interopRequireDefault(__webpack_require__(105));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var getFirstSelectedCell = function getFirstSelectedCell(cellSelection) {
	  return cellSelection.sort(function (cell1, cell2) {
	    if (cell1[0] < cell2[0]) {
	      return -1;
	    } else if (cell1[0] > cell2[0]) {
	      return 1;
	    }
	    return cell1[1] < cell2[1] ? -1 : 1;
	  })[0];
	};
	var useCellSelection = function useCellSelection(props, _ref, computedPropsRef) {
	  var rowSelectionEnabled = _ref.rowSelectionEnabled,
	    hasRowNavigation = _ref.hasRowNavigation,
	    listenOnCellEnter = _ref.listenOnCellEnter;
	  var _useProperty = (0, _useProperty3.default)(props, 'cellSelection'),
	    _useProperty2 = (0, _slicedToArray2.default)(_useProperty, 2),
	    cellSelection = _useProperty2[0],
	    setCellSelection = _useProperty2[1];
	  var _useNamedState = (0, _useNamedState3.default)(false, props.context, 'bulkUpdateMouseDown'),
	    _useNamedState2 = (0, _slicedToArray2.default)(_useNamedState, 2),
	    bulkUpdateMouseDown = _useNamedState2[0],
	    setBulkUpdateMouseDown = _useNamedState2[1];
	  var _useActiveCell = (0, _useActiveCell2.default)(props, computedPropsRef),
	    computedActiveCell = _useActiveCell.computedActiveCell,
	    getCellSelectionIdKey = _useActiveCell.getCellSelectionIdKey,
	    getCellSelectionBetween = _useActiveCell.getCellSelectionBetween,
	    setActiveCell = _useActiveCell.setActiveCell,
	    getCellSelectionKey = _useActiveCell.getCellSelectionKey,
	    incrementActiveCell = _useActiveCell.incrementActiveCell;
	  var cellSelectionEnabled = !rowSelectionEnabled ? !!cellSelection : false;
	  if (rowSelectionEnabled || hasRowNavigation) {
	    computedActiveCell = undefined;
	  }
	  var cellNavigationEnabled = computedActiveCell !== undefined;
	  if (cellSelection) {
	    cellNavigationEnabled = props.enableKeyboardNavigation !== false && !hasRowNavigation ? true : computedActiveCell !== undefined || !!cellSelection;
	  }
	  if (props.enableKeyboardNavigation === false) {
	    cellNavigationEnabled = false;
	  }
	  var cellMultiSelectionEnabledRef = (0, _react.useRef)(false);
	  cellMultiSelectionEnabledRef.current = cellSelectionEnabled && props.multiSelect !== false;
	  var cellMultiSelectionEnabled = cellMultiSelectionEnabledRef.current;
	  var prevMultiSelectionEnabled = (0, _usePrevious.default)(cellMultiSelectionEnabled, cellMultiSelectionEnabled);
	  (0, _react.useEffect)(function () {
	    if (prevMultiSelectionEnabled && !cellMultiSelectionEnabled) {
	      setCellSelection({});
	    }
	  }, [cellMultiSelectionEnabled, prevMultiSelectionEnabled]);
	  var onCellEnter = (0, _react.useMemo)(function () {
	    return listenOnCellEnter ? function (event, _ref2) {
	      var columnIndex = _ref2.columnIndex,
	        rowIndex = _ref2.rowIndex;
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      var data = computedProps.getItemAt(rowIndex);
	      if (!data || data.__group) {
	        return;
	      }
	      var col = computedProps.getColumnBy(columnIndex);
	      if (col && col.cellSelectable === false) {
	        return;
	      }
	      var groupBy = computedProps.computedGroupBy;
	      var minCol = groupBy ? groupBy.length : 0;
	      if (columnIndex < minCol) {
	        return;
	      }
	      var range = computedProps.getCellSelectionBetween(computedProps.selectionFixedCell || computedProps.computedActiveCell || computedProps.lastSelectedCell, [rowIndex, columnIndex]);
	      var queue = (0, _batchUpdate.default)();
	      queue(function () {
	        computedProps.setCellSelection(range);
	        computedProps.setLastCellInRange(Object.keys(range).pop() || '');
	      });
	      var direction = computedProps.cellDragStartRowIndex != null ? rowIndex - computedProps.cellDragStartRowIndex : rowIndex;
	      var sign = direction < 0 ? -1 : direction > 0 ? 1 : 0;
	      var scrollToRowIndex = (0, _clamp.default)(rowIndex + sign, 0, computedProps.count - 1);
	      var visible = computedProps.isCellVisible({
	        columnIndex: columnIndex,
	        rowIndex: scrollToRowIndex
	      });
	      if (visible !== true) {
	        visible = visible;
	        var left = visible.leftDiff < 0;
	        var top = visible.topDiff < 0;
	        computedProps.scrollToCell({
	          columnIndex: columnIndex,
	          rowIndex: scrollToRowIndex
	        }, {
	          top: top,
	          left: left
	        });
	      }
	      queue.commit();
	    } : null;
	  }, [listenOnCellEnter]);
	  var getContinuousSelectedRangeFor = function getContinuousSelectedRangeFor(selectionMap, cell) {
	    if (!cell) {
	      return [];
	    }
	    selectionMap = selectionMap || {};
	    var _cell = (0, _slicedToArray2.default)(cell, 2),
	      row = _cell[0],
	      col = _cell[1];
	    var key = getCellSelectionKey(row, col);
	    var range = [];
	    while (selectionMap[key]) {
	      range.push([row, col]);
	      key = getCellSelectionKey(row - 1, col - 1);
	      if (selectionMap[key]) {
	        row -= 1;
	        col -= 1;
	        continue;
	      }
	      if (!selectionMap[key]) {
	        key = getCellSelectionKey(row - 1, col);
	      }
	      if (selectionMap[key]) {
	        row -= 1;
	        continue;
	      }
	      if (!selectionMap[key]) {
	        key = getCellSelectionKey(row, col - 1);
	        col -= 1;
	      }
	    }
	    return range;
	  };
	  var toggleActiveCellSelection = (0, _react.useCallback)(function (fakeEvent) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var computedActiveCell = computedProps.computedActiveCell;
	    if (!computedActiveCell) {
	      return;
	    }
	    var _computedActiveCell = (0, _slicedToArray2.default)(computedActiveCell, 2),
	      rowIndex = _computedActiveCell[0],
	      columnIndex = _computedActiveCell[1];
	    var column = computedProps.getColumnBy(columnIndex);
	    if (column && column.cellSelectable === false) {
	      return;
	    }
	    var selected = isCellSelected(rowIndex, columnIndex);
	    var event = fakeEvent || {
	      ctrlKey: selected
	    };
	    computedProps.onCellClickAction(event, {
	      rowIndex: rowIndex,
	      columnIndex: columnIndex
	    });
	  }, []);
	  var isCellSelected = (0, _react.useCallback)(function (row, col) {
	    if (row && (0, _typeof2.default)(row) === 'object') {
	      col = row.columnIndex;
	      row = row.rowIndex;
	    }
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.computedCellSelection) {
	      var key = computedProps.getCellSelectionKey(row, col);
	      return !!computedProps.computedCellSelection[key];
	    }
	    return false;
	  }, []);
	  var _useState = (0, _react.useState)(null),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    cellDragStartRowIndex = _useState2[0],
	    setCellDragStartRowIndex = _useState2[1];
	  var cellSelectionRef = (0, _react.useRef)(cellSelection);
	  cellSelectionRef.current = cellSelection;
	  var onCellSelectionDraggerMouseDown = (0, _react.useMemo)(function () {
	    if (cellMultiSelectionEnabled && cellSelectionRef.current) {
	      var _onCellSelectionDraggerMouseDown = function _onCellSelectionDraggerMouseDown(event, _ref3, selectionFixedCell) {
	        var columnIndex = _ref3.columnIndex,
	          rowIndex = _ref3.rowIndex;
	        var computedProps = computedPropsRef.current;
	        if (!computedProps) {
	          return;
	        }
	        var column = computedProps.getColumnBy(columnIndex);
	        if (column && column.cellSelectable === false) {
	          return;
	        }
	        if (!selectionFixedCell) {
	          var currentCell = [rowIndex, columnIndex];
	          var groupBy = computedProps.computedGroupBy;
	          var hasGroupBy = groupBy && groupBy.length;
	          var currentRange = !hasGroupBy ? getContinuousSelectedRangeFor(computedProps.computedCellSelection, currentCell) : [];
	          selectionFixedCell = !hasGroupBy ? getFirstSelectedCell(currentRange.length ? currentRange : [currentCell]) : computedProps.computedActiveCell || computedProps.lastSelectedCell;
	        }
	        var fn = function fn() {
	          computedProps.setListenOnCellEnter(false, fn);
	          setCellDragStartRowIndex(null);
	          computedProps.setSelectionFixedCell(null);
	        };
	        var queue = (0, _batchUpdate.default)();
	        queue(function () {
	          setCellDragStartRowIndex(rowIndex);
	          if (selectionFixedCell === undefined) {
	            selectionFixedCell = null;
	          }
	          computedProps.setSelectionFixedCell(selectionFixedCell);
	          computedProps.setListenOnCellEnter(true, fn);
	        });
	        queue.commit();
	      };
	      return _onCellSelectionDraggerMouseDown;
	    }
	    return null;
	  }, [cellMultiSelectionEnabled]);
	  var cellContentRef = (0, _react.useRef)(null);
	  var computedCellBulkUpdateMouseDown = (0, _react.useCallback)(function (_event, _cellProps) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (!computedProps.enableCellBulkUpdate) {
	      return;
	    }
	    var computedActiveCell = computedProps.computedActiveCell,
	      data = computedProps.data;
	    if (!computedActiveCell) {
	      return;
	    }
	    setBulkUpdateMouseDown(true);
	    var _computedActiveCell2 = (0, _slicedToArray2.default)(computedActiveCell, 2),
	      activeRow = _computedActiveCell2[0],
	      activeColumn = _computedActiveCell2[1];
	    var row = data[activeRow];
	    var column = computedProps.getColumnBy(activeColumn);
	    var columnName = column.name;
	    var cellContent = columnName ? row[columnName] : null;
	    cellContentRef.current = cellContent;
	  }, []);
	  var computedCellBulkUpdateMouseUp = (0, _react.useCallback)(function (_event) {
	    setBulkUpdateMouseDown(false);
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var cellContent = cellContentRef.current;
	    if (!cellContent) {
	      return;
	    }
	    if (!computedProps.enableCellBulkUpdate) {
	      return;
	    }
	    var cellSelectionMap = computedProps.computedCellSelection;
	    if (!cellSelectionMap) {
	      return;
	    }
	    var dataMap = {};
	    Object.keys(cellSelectionMap).map(function (key) {
	      var _key$split = key.split(','),
	        _key$split2 = (0, _slicedToArray2.default)(_key$split, 2),
	        rowId = _key$split2[0],
	        columnName = _key$split2[1];
	      if (!dataMap[rowId]) {
	        dataMap[rowId] = (0, _defineProperty2.default)({}, columnName, cellContent);
	      }
	      {
	        dataMap[rowId] = _objectSpread(_objectSpread({}, dataMap[rowId]), {}, (0, _defineProperty2.default)({}, columnName, cellContent));
	      }
	    });
	    var dataArray = Object.keys(dataMap).map(function (key) {
	      var index = -1;
	      index = computedProps.getItemIndexById(key);
	      if (index === -1) {
	        index = computedProps.getItemIndexById(Number(key));
	      }
	      if (index > -1) {
	        var item = computedProps.getItemAt(index);
	        var itemId = computedProps.getItemId(item);
	        return _objectSpread({
	          id: itemId
	        }, dataMap[key]);
	      }
	    });
	    computedProps.setItemsAt(dataArray, {
	      replace: false
	    });
	    cellContentRef.current = null;
	  }, []);
	  return {
	    onCellEnter: onCellEnter,
	    toggleActiveCellSelection: toggleActiveCellSelection,
	    cellDragStartRowIndex: cellDragStartRowIndex,
	    setCellDragStartRowIndex: setCellDragStartRowIndex,
	    onCellSelectionDraggerMouseDown: onCellSelectionDraggerMouseDown,
	    computedCellBulkUpdateMouseDown: computedCellBulkUpdateMouseDown,
	    bulkUpdateMouseDown: bulkUpdateMouseDown,
	    computedCellBulkUpdateMouseUp: computedCellBulkUpdateMouseUp,
	    getCellSelectionBetween: getCellSelectionBetween,
	    computedActiveCell: computedActiveCell,
	    incrementActiveCell: incrementActiveCell,
	    getCellSelectionIdKey: getCellSelectionIdKey,
	    setActiveCell: setActiveCell,
	    getCellSelectionKey: getCellSelectionKey,
	    cellSelectionEnabled: cellSelectionEnabled,
	    cellNavigationEnabled: cellNavigationEnabled,
	    cellMultiSelectionEnabled: cellMultiSelectionEnabled,
	    computedCellSelection: cellSelection,
	    setCellSelection: setCellSelection
	  };
	};
	exports.useCellSelection = useCellSelection;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _warn = __webpack_require__(274);
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var emptyPlugin = {
	  name: '',
	  hook: function hook(props, computedProps, computedPropsRef) {}
	};
	var _default = [_objectSpread(_objectSpread({}, emptyPlugin), {}, {
	  name: 'sortable-columns',
	  defaultProps: function defaultProps() {
	    return {
	      sortable: false
	    };
	  }
	}), _objectSpread(_objectSpread({}, emptyPlugin), {}, {
	  name: 'license',
	  defaultProps: function defaultProps() {
	    return {};
	  },
	  renderLicenseNotice: function renderLicenseNotice() {
	    return null;
	  }
	}), _objectSpread(_objectSpread({}, emptyPlugin), {}, {
	  name: 'menus',
	  defaultProps: function defaultProps() {
	    return {
	      showColumnMenuTool: false
	    };
	  }
	}), _objectSpread(_objectSpread({}, emptyPlugin), {}, {
	  name: 'group-and-pivot',
	  hook: function hook() {
	    return {
	      computeDataStep: function computeDataStep(_ref) {
	        var config = _ref.config;
	        (0, _warn.warnOnce)('You are trying to use the grouping or pivot functionality, but are currently using the community edition. Please use the enterprise edition for this functionality to be available.');
	        return config;
	      }
	    };
	  },
	  defaultProps: function defaultProps() {
	    return {};
	  }
	}), _objectSpread(_objectSpread({}, emptyPlugin), {}, {
	  name: 'tree',
	  hook: function hook() {
	    return {
	      computeTreeData: function computeTreeData(data, arg) {
	        (0, _warn.warnOnce)('You are trying to use the tree functionality, but are currently using the community edition. Please use the enterprise edition for this functionality to be available.');
	        return data;
	      }
	    };
	  },
	  defaultProps: function defaultProps() {
	    return {};
	  }
	}), _objectSpread(_objectSpread({}, emptyPlugin), {}, {
	  name: 'filters',
	  defaultProps: function defaultProps() {
	    return {
	      columnFilterContextMenuConstrainTo: true,
	      columnFilterContextMenuPosition: 'fixed'
	    };
	  }
	}), _objectSpread(_objectSpread({}, emptyPlugin), {}, {
	  name: 'cell-selection',
	  hook: function hook() {
	    return {};
	  },
	  defaultProps: function defaultProps() {
	    return {};
	  }
	}), _objectSpread(_objectSpread({}, emptyPlugin), {}, {
	  name: 'live-pagination',
	  hook: function hook() {
	    return {};
	  },
	  defaultProps: function defaultProps() {
	    return {};
	  }
	}), _objectSpread(_objectSpread({}, emptyPlugin), {}, {
	  name: 'row-index-column',
	  renderRowResizeIndicator: function renderRowResizeIndicator() {
	    return null;
	  },
	  defaultProps: function defaultProps() {
	    return {};
	  }
	}), _objectSpread(_objectSpread({}, emptyPlugin), {}, {
	  name: 'clipboard',
	  hook: function hook() {
	    return {};
	  },
	  defaultProps: function defaultProps() {
	    return {};
	  }
	})];
	exports.default = _default;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _useFilters = _interopRequireWildcard(__webpack_require__(784));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var _default = {
	  name: 'filters',
	  hook: _useFilters.default,
	  renderColumnFilterContextMenu: _useFilters.renderColumnFilterContextMenu,
	  defaultProps: function defaultProps() {
	    return {
	      columnFilterContextMenuConstrainTo: true,
	      columnFilterContextMenuPosition: 'absolute'
	    };
	  }
	};
	exports.default = _default;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderColumnFilterContextMenu = exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireWildcard(__webpack_require__(2));
	var _useProperty5 = _interopRequireDefault(__webpack_require__(48));
	var _getFilterValueForColumns = _interopRequireDefault(__webpack_require__(220));
	var _batchUpdate = _interopRequireDefault(__webpack_require__(50));
	var _mapColumns = _interopRequireDefault(__webpack_require__(224));
	var _ua = __webpack_require__(103);
	var _Menu = _interopRequireDefault(__webpack_require__(113));
	var _renderGridMenu = _interopRequireDefault(__webpack_require__(160));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var emptyArray = [];
	var COLUMN_MENU_ALIGN_POSITIONS = ['tl-bl', 'tr-br', 'tl-tr', 'tr-tl', 'br-tr', 'bl-tl', 'br-tl', 'bl-tr', 'lc-tr', 'rc-tl'];
	var COLUMN_MENU_ALIGN_POSITIONS_RTL = ['tr-br', 'tl-bl', 'tr-tl', 'tl-tr', 'br-tr', 'bl-tl', 'br-tl', 'bl-tr', 'lc-tr', 'rc-tl'];
	var renderColumnFilterContextMenu = function renderColumnFilterContextMenu(computedProps, computedPropsRef) {
	  if (!computedProps) {
	    return null;
	  }
	  var cellProps = computedProps.columnFilterContextMenuProps;
	  if (!cellProps) {
	    return null;
	  }
	  var filterValue = computedProps.computedFilterValueMap ? computedProps.computedFilterValueMap[cellProps.id] : null;
	  if (!filterValue) {
	    return null;
	  }
	  var columnOperators = computedProps.initialProps.filterTypes[filterValue.type].operators || emptyArray;
	  var selected = {
	    operator: filterValue.operator
	  };
	  var showEnableButton = filterValue.active === false;
	  var filterType = computedProps.initialProps.filterTypes[filterValue.type];
	  var isFiltered = computedProps.computedFiltered;
	  var items = function () {
	    var activationItems = ['-', {
	      label: computedProps.i18n('enable', 'Enable'),
	      itemId: 'enableFilter',
	      disabled: !showEnableButton,
	      onClick: function onClick() {
	        var newFilterValue = _objectSpread(_objectSpread({}, filterValue), {}, {
	          active: true
	        });
	        var computedProps = computedPropsRef.current;
	        if (!computedProps) {
	          return;
	        }
	        computedProps.computedOnColumnFilterValueChange({
	          columnId: cellProps.id,
	          columnIndex: cellProps.computedVisibleIndex,
	          cellProps: cellProps,
	          filterValue: newFilterValue
	        });
	        computedProps.hideColumnFilterContextMenu();
	      }
	    }, {
	      label: computedProps.i18n('disable', 'Disable'),
	      disabled: showEnableButton,
	      itemId: 'disableFilter',
	      onClick: function onClick() {
	        var computedProps = computedPropsRef.current;
	        if (!computedProps) {
	          return;
	        }
	        var newFilterValue = _objectSpread(_objectSpread({}, filterValue), {}, {
	          active: false
	        });
	        computedProps.computedOnColumnFilterValueChange({
	          columnId: cellProps.id,
	          cellProps: cellProps,
	          columnIndex: cellProps.computedVisibleIndex,
	          filterValue: newFilterValue
	        });
	        computedProps.hideColumnFilterContextMenu();
	      }
	    }, '-', {
	      label: computedProps.i18n('clear', 'Clear'),
	      itemId: 'clearFilter',
	      disabled: filterValue.value === filterType.emptyValue,
	      onClick: function onClick() {
	        var computedProps = computedPropsRef.current;
	        if (!computedProps) {
	          return;
	        }
	        computedProps.clearColumnFilter(cellProps.id);
	        computedProps.hideColumnFilterContextMenu();
	      }
	    }, {
	      label: computedProps.i18n('clearAll', 'Clear All'),
	      itemId: 'clearAllFilters',
	      disabled: !isFiltered,
	      onClick: function onClick() {
	        var computedProps = computedPropsRef.current;
	        if (!computedProps) {
	          return;
	        }
	        computedProps.clearAllFilters();
	        computedProps.hideColumnFilterContextMenu();
	      }
	    }];
	    var items = columnOperators.map(function (operator) {
	      return {
	        label: computedProps.i18n(operator.label, operator.label) || computedProps.i18n(operator.name, operator.name),
	        name: 'operator',
	        itemId: "operator-".concat(operator.name),
	        value: operator.name
	      };
	    });
	    items.push.apply(items, activationItems);
	    return items;
	  }();
	  var onSelectionChange = function onSelectionChange(selected) {
	    var operator = selected.operator;
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var filterTypes = computedProps.initialProps.filterTypes;
	    var filterTypeDescription = filterTypes[filterType.type] || {
	      operators: []
	    };
	    var operatorDescriptor = filterTypeDescription.operators.filter(function (op) {
	      return op.name === operator;
	    })[0];
	    var newFilterValue = _objectSpread(_objectSpread({}, filterValue), {}, {
	      operator: operator
	    });
	    if (operatorDescriptor && operatorDescriptor.valueOnOperatorSelect !== undefined) {
	      newFilterValue.value = operatorDescriptor.valueOnOperatorSelect;
	    }
	    computedProps.computedOnColumnFilterValueChange({
	      columnId: cellProps.id,
	      cellProps: cellProps,
	      columnIndex: cellProps.computedVisibleIndex,
	      filterValue: newFilterValue
	    });
	    computedProps.hideColumnFilterContextMenu();
	  };
	  var rtl = computedProps.rtl;
	  var menuProps = {
	    autoFocus: true,
	    dismissWithEscape: true,
	    items: items,
	    theme: computedProps.theme,
	    updatePositionOnScroll: computedProps.updateMenuPositionOnScroll,
	    nativeScroll: !_ua.IS_MS_BROWSER,
	    enableSelection: true,
	    maxHeight: computedProps.columnFilterContextMenuConstrainTo ? null : computedProps.getMenuAvailableHeight(),
	    style: {
	      zIndex: 10000,
	      position: computedProps.columnFilterContextMenuPosition || 'absolute'
	    },
	    selected: selected,
	    onSelectionChange: onSelectionChange,
	    onDismiss: computedProps.hideColumnFilterContextMenu,
	    constrainTo: computedProps.columnFilterContextMenuConstrainTo,
	    alignPositions: computedProps.columnFilterContextMenuAlignPositions || rtl ? COLUMN_MENU_ALIGN_POSITIONS_RTL : COLUMN_MENU_ALIGN_POSITIONS,
	    alignTo: computedProps.columnFilterContextMenuAlignToRef.current
	  };
	  var result;
	  if (computedProps.initialProps.renderColumnFilterContextMenu) {
	    result = computedProps.initialProps.renderColumnFilterContextMenu(menuProps, {
	      cellProps: cellProps,
	      grid: computedPropsRef,
	      props: computedProps
	    });
	  }
	  if (result === undefined) {
	    result = _react.default.createElement(_Menu.default, _objectSpread({}, menuProps));
	  }
	  if (computedProps.initialProps.renderGridMenu) {
	    return computedProps.initialProps.renderGridMenu(result, computedProps);
	  }
	  return (0, _renderGridMenu.default)(result, computedProps);
	};
	exports.renderColumnFilterContextMenu = renderColumnFilterContextMenu;
	var useFilterValue = function useFilterValue(props, _ref, computedPropsRef) {
	  var columnsMap = _ref.columnsMap,
	    enableFiltering = _ref.enableFiltering;
	  var _useProperty = (0, _useProperty5.default)(props, 'filterValue'),
	    _useProperty2 = (0, _slicedToArray2.default)(_useProperty, 2),
	    filterValue = _useProperty2[0],
	    doSetFilterValue = _useProperty2[1];
	  filterValue = (0, _react.useMemo)(function () {
	    return (0, _getFilterValueForColumns.default)(filterValue || [], columnsMap);
	  }, [filterValue || [], columnsMap]);
	  if (!filterValue.length) {
	    filterValue = null;
	  }
	  var setFilterValue = (0, _react.useCallback)(function (filterValue) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    filterValue = (0, _getFilterValueForColumns.default)(filterValue, computedProps.columnsMap);
	    var queue = (0, _batchUpdate.default)();
	    queue.commit(function () {
	      computedProps.setLoadDataTrigger(function (loadDataTrigger) {
	        return [].concat((0, _toConsumableArray2.default)(loadDataTrigger), ['filterValue']);
	      });
	      doSetFilterValue(filterValue);
	    });
	  }, [doSetFilterValue]);
	  return [filterValue, setFilterValue];
	};
	var isFilterable = function isFilterable(_ref2) {
	  var enableFiltering = _ref2.enableFiltering,
	    filterValue = _ref2.filterValue;
	  if (enableFiltering !== undefined) {
	    return enableFiltering;
	  }
	  if (!Array.isArray(filterValue) || !filterValue.length) {
	    return false;
	  }
	  return true;
	};
	var useFilters = function useFilters(props, computedProps, computedPropsRef) {
	  var _useProperty3 = (0, _useProperty5.default)(props, 'enableFiltering'),
	    _useProperty4 = (0, _slicedToArray2.default)(_useProperty3, 2),
	    enableFiltering = _useProperty4[0],
	    setEnableFiltering = _useProperty4[1];
	  var isColumnFiltered = (0, _react.useCallback)(function (col) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return false;
	    }
	    var filterValue = computedProps.getColumnFilterValue(col.id);
	    if (!filterValue) {
	      return false;
	    }
	    var filterType = computedProps.initialProps.filterTypes[filterValue.type];
	    return filterValue.value !== filterType.emptyValue;
	  }, []);
	  var columnsMap = (0, _react.useMemo)(function () {
	    return (0, _mapColumns.default)(props.columns, {
	      showWarnings: false
	    });
	  }, [props.columns]);
	  var _useFilterValue = useFilterValue(props, {
	      enableFiltering: enableFiltering,
	      columnsMap: columnsMap
	    }, computedPropsRef),
	    _useFilterValue2 = (0, _slicedToArray2.default)(_useFilterValue, 2),
	    computedFilterValue = _useFilterValue2[0],
	    setFilterValue = _useFilterValue2[1];
	  var getMenuAvailableHeight = (0, _react.useCallback)(function () {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return undefined;
	    }
	    var filtersHeight = 0;
	    if (computedProps.computedFilterable) {
	      var filterNode = computedProps.getDOMNode().querySelector('.InovuaReactDataGrid__column-header__filter-wrapper');
	      if (filterNode) {
	        filtersHeight = filterNode.offsetHeight;
	      }
	    }
	    return computedProps.size ? computedProps.size.height - 5 + filtersHeight : undefined;
	  }, []);
	  var clearAllFilters = (0, _react.useCallback)(function () {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (!computedProps.computedFilterValueMap) {
	      return;
	    }
	    var allFiltersValue = [];
	    var headerCells = computedProps.getColumnLayout().getHeaderCells();
	    computedProps.allColumns.forEach(function (column) {
	      var filterValue = computedProps.computedFilterValueMap[column.id];
	      if (!filterValue) {
	        return;
	      }
	      var filterType = computedProps.initialProps.filterTypes[filterValue.type];
	      var headerCell = headerCells[column.computedVisibleIndex];
	      var newFilterValue = _objectSpread(_objectSpread({}, filterValue), {}, {
	        value: filterType.emptyValue
	      });
	      if (headerCell && headerCell.filter) {
	        headerCell.filter.setValue(newFilterValue.value);
	      }
	      allFiltersValue.push(newFilterValue);
	    });
	    setFilterValue(allFiltersValue);
	  }, [setFilterValue]);
	  var columnFilterContextMenuAlignToRef = (0, _react.useRef)(null);
	  var columnFilterContextMenuConstrainToRef = (0, _react.useRef)(null);
	  var _useState = (0, _react.useState)(null),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    columnFilterContextMenuProps = _useState2[0],
	    setColumnFilterContextMenuProps = _useState2[1];
	  var showColumnFilterContextMenu = (0, _react.useCallback)(function (alignTo, cellProps) {
	    var computedProps = computedPropsRef.current;
	    if (columnFilterContextMenuProps || !computedProps) {
	      return;
	    }
	    columnFilterContextMenuAlignToRef.current = alignTo;
	    columnFilterContextMenuConstrainToRef.current = computedProps.columnFilterContextMenuConstrainTo || computedProps.getDOMNode();
	    if (computedProps.hideColumnContextMenu) {
	      computedProps.hideColumnContextMenu();
	    }
	    setColumnFilterContextMenuProps(cellProps);
	    computedProps.notifyColumnFilterVisibleStateChange(true);
	  }, [setColumnFilterContextMenuProps]);
	  var hideColumnFilterContextMenu = (0, _react.useCallback)(function (node) {
	    var computedProps = computedPropsRef.current;
	    if (columnFilterContextMenuProps && computedProps) {
	      setColumnFilterContextMenuProps(null);
	      computedProps.notifyColumnFilterVisibleStateChange(false);
	    }
	    if (node && !node.type) {
	      var filterIcon = node.querySelector('.InovuaReactDataGrid__column-header__filter-settings-icon');
	      filterIcon.focus();
	    }
	  }, [columnFilterContextMenuProps]);
	  var shouldShowFilteringMenuItems = (0, _react.useCallback)(function () {
	    if (props.showFilteringMenuItems) {
	      return true;
	    }
	    if (computedFilterValue) {
	      return true;
	    }
	    if (enableFiltering) {
	      return true;
	    }
	    return false;
	  }, [computedFilterValue, enableFiltering, props.showFilteringMenuItems]);
	  var computedFilterValueMap = (0, _react.useMemo)(function () {
	    return computedFilterValue ? computedFilterValue.reduce(function (acc, columnFilterValue) {
	      acc[columnFilterValue.name] = columnFilterValue;
	      return acc;
	    }, {}) : null;
	  }, [computedFilterValue]);
	  var computedOnColumnFilterValueChange = (0, _react.useCallback)(function (columnFilterValue) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var isBinaryOperator = computedProps.isBinaryOperator;
	    if (computedProps.onColumnFilterValueChange) {
	      computedProps.onColumnFilterValueChange(columnFilterValue);
	    }
	    var computedFilterValue = computedProps.computedFilterValue;
	    var newFilterValue = (computedFilterValue || []).map(function (oldFilterValue) {
	      if (oldFilterValue.name === columnFilterValue.columnId) {
	        var emptyValue = getColumnFilterEmptyValue(columnFilterValue.columnId);
	        if (columnFilterValue.filterValue.type === 'date' || columnFilterValue.filterValue.type === 'number') {
	          if (isBinaryOperator(oldFilterValue.operator) && !isBinaryOperator(columnFilterValue.filterValue.operator)) {
	            return _objectSpread(_objectSpread({}, columnFilterValue.filterValue), {}, {
	              value: emptyValue
	            });
	          }
	          if (!isBinaryOperator(oldFilterValue.operator) && isBinaryOperator(columnFilterValue.filterValue.operator)) {
	            return _objectSpread(_objectSpread({}, columnFilterValue.filterValue), {}, {
	              value: columnFilterValue.filterValue && columnFilterValue.filterValue.value != null && columnFilterValue.filterValue.value.start != null ? columnFilterValue.filterValue.value : {
	                start: emptyValue,
	                end: emptyValue
	              }
	            });
	          }
	        }
	        return columnFilterValue.filterValue;
	      }
	      return oldFilterValue;
	    }).filter(function (f) {
	      return !!f;
	    });
	    setFilterValue(newFilterValue);
	  }, [setFilterValue]);
	  var getColumnFilterValue = (0, _react.useCallback)(function (column) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return null;
	    }
	    var col = computedProps.getColumnBy(column);
	    if (!col) {
	      return null;
	    }
	    if (!computedProps.computedFilterValueMap) {
	      return null;
	    }
	    return computedProps.computedFilterValueMap[col.id];
	  }, []);
	  var setColumnFilterValue = (0, _react.useCallback)(function (column, value, operator) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return null;
	    }
	    var filterValue = getColumnFilterValue(column);
	    if (!filterValue) {
	      return;
	    }
	    var newFilterValue = _objectSpread(_objectSpread({}, filterValue), {}, {
	      value: value
	    });
	    if (operator) {
	      newFilterValue.operator = operator;
	    }
	    var col = computedProps.getColumnBy(column);
	    var headerCells = computedProps.getColumnLayout().getHeaderCells();
	    var headerCell = headerCells[col.computedVisibleIndex];
	    if (!headerCell || !headerCell.filter) {
	      return;
	    }
	    computedProps.computedOnColumnFilterValueChange({
	      columnId: col.id,
	      columnIndex: col.computedVisibleIndex,
	      filterValue: newFilterValue
	    });
	    headerCell.filter.setValue(value);
	  }, []);
	  var getColumnFilterEmptyValue = (0, _react.useCallback)(function (idNameOrIndex) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var col = computedProps.getColumnBy(idNameOrIndex);
	    if (!col) {
	      return;
	    }
	    if (!computedProps.computedFilterValueMap) {
	      return;
	    }
	    var filterValue = computedProps.computedFilterValueMap[col.id];
	    if (!filterValue) {
	      return;
	    }
	    var filterType = computedProps.initialProps.filterTypes[filterValue.type];
	    return filterType.emptyValue;
	  }, []);
	  var clearColumnFilter = (0, _react.useCallback)(function (idNameOrIndex) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var col = computedProps.getColumnBy(idNameOrIndex);
	    if (!col) {
	      return;
	    }
	    computedProps.setColumnFilterValue(idNameOrIndex, getColumnFilterEmptyValue(idNameOrIndex));
	  }, []);
	  var isFiltered = (0, _react.useCallback)(function () {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return false;
	    }
	    return (computedProps.computedFilterValue || []).reduce(function (result, filterValue) {
	      if (result) {
	        return true;
	      }
	      var col = computedProps.getColumnBy(filterValue.name);
	      if (col && isColumnFiltered(col)) {
	        return true;
	      }
	      return false;
	    }, false);
	  }, []);
	  var computedFiltered = isFiltered();
	  return {
	    clearColumnFilter: clearColumnFilter,
	    computedOnColumnFilterValueChange: computedOnColumnFilterValueChange,
	    computedFilterValueMap: computedFilterValueMap,
	    computedFilterValue: computedFilterValue,
	    computedFiltered: computedFiltered,
	    computedFilterable: isFilterable({
	      enableFiltering: enableFiltering,
	      filterValue: computedFilterValue
	    }),
	    setEnableFiltering: setEnableFiltering,
	    setFilterValue: setFilterValue,
	    getMenuAvailableHeight: getMenuAvailableHeight,
	    showColumnFilterContextMenu: showColumnFilterContextMenu,
	    hideColumnFilterContextMenu: hideColumnFilterContextMenu,
	    shouldShowFilteringMenuItems: shouldShowFilteringMenuItems,
	    renderColumnFilterContextMenu: renderColumnFilterContextMenu,
	    columnFilterContextMenuProps: columnFilterContextMenuProps,
	    columnFilterContextMenuAlignToRef: columnFilterContextMenuAlignToRef,
	    clearAllFilters: clearAllFilters,
	    getColumnFilterValue: getColumnFilterValue,
	    setColumnFilterValue: setColumnFilterValue,
	    isColumnFiltered: isColumnFiltered
	  };
	};
	var _default = useFilters;
	exports.default = _default;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _useMenus = _interopRequireWildcard(__webpack_require__(786));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var _default = {
	  name: 'menus',
	  hook: _useMenus.default,
	  renderColumnContextMenu: _useMenus.renderColumnContextMenu,
	  renderRowContextMenu: _useMenus.renderRowContextMenu,
	  defaultProps: function defaultProps() {
	    return {
	      showColumnMenuTool: true
	    };
	  }
	};
	exports.default = _default;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	Object.defineProperty(exports, "renderColumnContextMenu", {
	  enumerable: true,
	  get: function get() {
	    return _renderColumnContextMenu.default;
	  }
	});
	Object.defineProperty(exports, "renderRowContextMenu", {
	  enumerable: true,
	  get: function get() {
	    return _renderRowContextMenu.default;
	  }
	});
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _react = __webpack_require__(2);
	var _detectUa = __webpack_require__(104);
	var _region = _interopRequireDefault(__webpack_require__(43));
	var _getGlobal = __webpack_require__(18);
	var _renderColumnContextMenu = _interopRequireDefault(__webpack_require__(787));
	var _renderRowContextMenu = _interopRequireDefault(__webpack_require__(788));
	var globalObject = (0, _getGlobal.getGlobal)();
	var _default = function _default(props, computedProps, computedPropsRef) {
	  var _useState = (0, _react.useState)(null),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    columnContextMenuProps = _useState2[0],
	    setColumnContextMenuProps = _useState2[1];
	  var _useState3 = (0, _react.useState)(null),
	    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
	    rowContextMenuProps = _useState4[0],
	    setRowContextMenuProps = _useState4[1];
	  var _useState5 = (0, _react.useState)(null),
	    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
	    columnContextMenuInstanceProps = _useState6[0],
	    setColumnContextMenuInstanceProps = _useState6[1];
	  var getConstrainRegion = function getConstrainRegion(computedProps) {
	    if (!computedProps.parentComputedProps) {
	      return document.documentElement;
	    }
	    var node = computedProps.getDOMNode();
	    node = node ? node.querySelector('.InovuaReactDataGrid__virtual-list') || node : node;
	    return node;
	  };
	  var getColumnMenuConstrainTo = (0, _react.useCallback)(function () {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    return computedProps.initialProps.columnContextMenuConstrainTo || getConstrainRegion(computedProps);
	  }, []);
	  var getRowMenuConstrainTo = (0, _react.useCallback)(function () {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    return computedProps.initialProps.rowContextMenuConstrainTo || getConstrainRegion(computedProps);
	  }, []);
	  var columnContextMenuIndex = (0, _react.useRef)(-1);
	  var preventIEMenuCloseRef = (0, _react.useRef)(false);
	  var columnContextMenuInfoRef = (0, _react.useRef)({
	    menuAlignTo: null,
	    getMenuConstrainTo: getColumnMenuConstrainTo,
	    menuOnHide: function menuOnHide() {}
	  });
	  var rowContextMenuInfoRef = (0, _react.useRef)({
	    menuAlignTo: null,
	    getMenuConstrainTo: getRowMenuConstrainTo,
	    menuOnHide: function menuOnHide() {}
	  });
	  var hideColumnContextMenu = (0, _react.useCallback)(function () {
	    if (_detectUa.IS_IE && preventIEMenuCloseRef.current) {
	      return;
	    }
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.columnContextMenuProps) {
	      var columnContextMenuOnHide = columnContextMenuInfoRef.current.menuOnHide;
	      if (typeof columnContextMenuOnHide == 'function') {
	        columnContextMenuOnHide();
	      }
	      computedProps.setColumnContextMenuProps(null);
	    }
	  }, []);
	  var hideRowContextMenu = (0, _react.useCallback)(function () {
	    if (_detectUa.IS_IE && preventIEMenuCloseRef.current) {
	      return;
	    }
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.preventBlurOnContextMenuOpen && computedProps.preventBlurOnContextMenuOpen.current) {
	      computedProps.preventBlurOnContextMenuOpen.current = false;
	    }
	    if (computedProps.rowContextMenuProps) {
	      var rowContextMenuOnHide = rowContextMenuInfoRef.current.menuOnHide;
	      if (typeof rowContextMenuOnHide == 'function') {
	        rowContextMenuOnHide();
	      }
	      computedProps.setRowContextMenuProps(null);
	    }
	  }, []);
	  var showColumnContextMenu = (0, _react.useCallback)(function (alignTo, cellProps, _ref, onHide) {
	    var computedVisibleIndex = _ref.computedVisibleIndex;
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.columnContextMenuProps) {
	      computedProps.hideColumnContextMenu();
	      return;
	    }
	    columnContextMenuIndex.current = cellProps.columnIndex;
	    columnContextMenuInfoRef.current = {
	      menuAlignTo: alignTo,
	      getMenuConstrainTo: getColumnMenuConstrainTo,
	      menuOnHide: onHide
	    };
	    if (computedProps.hideColumnFilterContextMenu) {
	      computedProps.hideColumnFilterContextMenu();
	    }
	    computedProps.setColumnContextMenuProps(cellProps);
	    if (computedProps.setColumnContextMenuInstanceProps) {
	      computedProps.setColumnContextMenuInstanceProps({
	        computedVisibleIndex: computedVisibleIndex
	      });
	    }
	  }, []);
	  var getMenuAvailableHeight = (0, _react.useCallback)(function () {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return 0;
	    }
	    var filtersHeight = 0;
	    if (computedProps.computedIsFilterable) {
	      var filterNode = computedProps.getDOMNode().querySelector('.InovuaReactDataGrid__column-header__filter-wrapper');
	      if (filterNode) {
	        filtersHeight = filterNode.offsetHeight;
	      }
	    }
	    var size = computedProps.initialProps.parentComputedProps ? computedProps.initialProps.parentComputedProps.size : computedProps.size;
	    var result = size ? size.height - 5 + filtersHeight : 0;
	    return result;
	  }, []);
	  var onRowContextMenu = (0, _react.useCallback)(function (rowProps, event) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var initialProps = computedProps.initialProps;
	    if (initialProps.onRowContextMenu) {
	      initialProps.onRowContextMenu(rowProps, event);
	    }
	    if (!initialProps.renderRowContextMenu) {
	      return;
	    }
	    if (computedProps.preventBlurOnContextMenuOpen) {
	      computedProps.preventBlurOnContextMenuOpen.current = true;
	    }
	    event.preventDefault();
	    var cellProps = event.nativeEvent ? event.nativeEvent.__cellProps : undefined;
	    var alignTo = _region.default.from(event);
	    alignTo.shift({
	      top: -globalObject.scrollY,
	      left: -globalObject.scrollX
	    });
	    showRowContextMenu(alignTo, rowProps, cellProps, function () {});
	  }, []);
	  var showRowContextMenu = (0, _react.useCallback)(function (alignTo, rowProps, cellProps, onHide) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (computedProps.rowContextMenuProps) {
	      computedProps.hideRowContextMenu();
	      return;
	    }
	    rowContextMenuInfoRef.current = {
	      menuAlignTo: alignTo,
	      getMenuConstrainTo: getRowMenuConstrainTo,
	      cellProps: cellProps,
	      menuOnHide: onHide
	    };
	    if (computedProps.hideRowFilterContextMenu) {
	      computedProps.hideRowFilterContextMenu();
	    }
	    computedProps.setRowContextMenuProps(rowProps);
	  }, []);
	  return {
	    onRowContextMenu: onRowContextMenu,
	    getMenuAvailableHeight: getMenuAvailableHeight,
	    showRowContextMenu: showRowContextMenu,
	    showColumnContextMenu: showColumnContextMenu,
	    hideColumnContextMenu: hideColumnContextMenu,
	    hideRowContextMenu: hideRowContextMenu,
	    columnContextMenuProps: columnContextMenuProps,
	    columnContextMenuInstanceProps: columnContextMenuInstanceProps,
	    rowContextMenuProps: rowContextMenuProps,
	    columnContextMenuInfoRef: columnContextMenuInfoRef,
	    rowContextMenuInfoRef: rowContextMenuInfoRef,
	    setColumnContextMenuProps: setColumnContextMenuProps,
	    setColumnContextMenuInstanceProps: setColumnContextMenuInstanceProps,
	    setRowContextMenuProps: setRowContextMenuProps,
	    preventIEMenuCloseRef: preventIEMenuCloseRef,
	    columnContextMenuIndex: columnContextMenuIndex
	  };
	};
	exports.default = _default;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _detectUa = __webpack_require__(104);
	var _Header = __webpack_require__(142);
	var _Menu = _interopRequireDefault(__webpack_require__(113));
	var _renderGridMenu = _interopRequireDefault(__webpack_require__(160));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var COLUMN_MENU_ALIGN_POSITIONS = ['tl-bl', 'tr-br', 'tl-tr', 'tr-tl', 'br-tr', 'bl-tl', 'br-tl', 'bl-tr', 'lc-tr', 'rc-tl'];
	var COLUMN_MENU_ALIGN_POSITIONS_RTL = ['tr-br', 'tl-bl', 'tr-tl', 'tl-tr', 'br-tr', 'bl-tl', 'br-tl', 'bl-tr', 'lc-tr', 'rc-tl'];
	var notEmpty = function notEmpty(x) {
	  return !!x;
	};
	var getTopComputedProps = function getTopComputedProps(computedProps) {
	  while (computedProps.initialProps.parentComputedProps) {
	    computedProps = computedProps.initialProps.parentComputedProps;
	  }
	  return computedProps;
	};
	var getAlignTo = function getAlignTo(selection, menuTools, index) {
	  var filteredTools = menuTools.filter(function (_, i) {
	    return i !== Object.keys(selection).length;
	  });
	  var length = filteredTools.length;
	  var alignTo;
	  if (index > length) {
	    alignTo = filteredTools[length - 1];
	  } else if (index <= length) {
	    alignTo = filteredTools[index - 1];
	  }
	  if (!alignTo) {
	    alignTo = filteredTools[0];
	  }
	  return alignTo;
	};
	var _default = function _default(computedProps, computedPropsRef) {
	  var cellProps = computedProps.columnContextMenuProps;
	  if (!cellProps) {
	    return null;
	  }
	  var groupBy = computedProps.computedGroupBy;
	  var visibleCountWithColumnMenu = 0;
	  var visibleMap = computedProps.initialProps.columns.reduce(function (acc, col) {
	    var column = computedProps.getColumnBy(col.name || col.id);
	    if (column && computedProps.isColumnVisible(column)) {
	      var value = column.id || column.name;
	      acc[value] = column.id || column.name;
	      if (column.showColumnMenuTool !== false) {
	        visibleCountWithColumnMenu++;
	      }
	    }
	    return acc;
	  }, {});
	  var onSelectionChange = function onSelectionChange(selection) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    if (_detectUa.IS_IE) {
	      computedProps.preventIEMenuCloseRef.current = true;
	      setTimeout(function () {
	        computedProps.preventIEMenuCloseRef.current = false;
	      }, 100);
	    }
	    computedProps.initialProps.columns.forEach(function (col) {
	      var computedCol = computedProps.getColumnBy(col);
	      if (computedCol) {
	        var visible = (computedCol.id in selection);
	        computedProps.setColumnVisible(col, visible);
	      }
	    });
	    if (computedProps.updateMenuPositionOnColumnsChange) {
	      requestAnimationFrame(function () {
	        var menuTools = Array.prototype.slice.call(computedProps.domRef.current.querySelectorAll('.InovuaReactDataGrid__column-header__menu-tool'));
	        var mainMenu = computedProps.domRef.current.querySelector('.InovuaReactDataGrid > .inovua-react-toolkit-menu');
	        var cellInstance = computedProps.columnContextMenuInstanceProps;
	        var columnIndex = cellInstance.computedVisibleIndex;
	        var alignTo = getAlignTo(selection, menuTools, columnIndex);
	        if (alignTo) {
	          computedProps.updateMainMenuPosition(alignTo);
	          if (mainMenu) {
	            mainMenu.style.transition = 'transform 200ms';
	            setTimeout(function () {
	              mainMenu.style.transition = '';
	            }, 200);
	          }
	        }
	      });
	    }
	  };
	  var currentColumn = computedProps.getColumnBy(cellProps.id);
	  var colSortInfo = currentColumn.computedSortInfo;
	  var lockLimit = !cellProps.computedLocked && computedProps.unlockedColumns.length <= 1;
	  var isAutoLock = cellProps.autoLock && computedProps.lockedStartColumns && !!computedProps.lockedStartColumns.filter(function (c) {
	    return !c.autoLock;
	  }).length;
	  var showColumnMenuLockOptions = cellProps.showColumnMenuLockOptions !== undefined ? cellProps.showColumnMenuLockOptions : computedProps.initialProps.showColumnMenuLockOptions;
	  if (cellProps.lockable === false) {
	    showColumnMenuLockOptions = false;
	  }
	  var showColumnMenuGroupOptions = cellProps.showColumnMenuGroupOptions !== undefined ? cellProps.showColumnMenuGroupOptions : computedProps.initialProps.showColumnMenuGroupOptions;
	  var showColumnMenuFilterOptions = cellProps.showColumnMenuFilterOptions !== undefined ? cellProps.showColumnMenuFilterOptions : computedProps.initialProps.showColumnMenuFilterOptions;
	  var showColumnMenuSortOptions = cellProps.showColumnMenuSortOptions !== undefined ? cellProps.showColumnMenuSortOptions : computedProps.initialProps.showColumnMenuSortOptions;
	  var enableColumnAutosize = computedProps.enableColumnAutosize ? computedProps.enableColumnAutosize : computedProps.initialProps.enableColumnAutosize;
	  var columnsItem = {
	    label: computedProps.i18n('columns'),
	    itemId: 'columns',
	    menuProps: {
	      dismissOnClick: false
	    },
	    items: computedProps.getColumnsInOrder().filter(function (c) {
	      return c.showInContextMenu !== false;
	    }).map(function (c) {
	      var value = c.id || c.name || '';
	      return {
	        label: (0, _Header.getCellHeader)(c, c, null, {
	          currentColumn: currentColumn
	        }),
	        itemId: "column-".concat(c.id),
	        value: value,
	        disabled: c.hideable === false || visibleCountWithColumnMenu === 1 && visibleMap[value],
	        name: value
	      };
	    })
	  };
	  if (computedProps.computedPivot) {
	    columnsItem = null;
	  }
	  var items = [showColumnMenuSortOptions === false ? null : {
	    label: computedProps.i18n('sortAsc'),
	    itemId: 'sortAsc',
	    disabled: !cellProps.computedSortable || colSortInfo && colSortInfo.dir === 1,
	    onClick: function onClick() {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      computedProps.setColumnSortInfo(cellProps.id, 1);
	      computedProps.hideColumnContextMenu();
	    }
	  }, showColumnMenuSortOptions === false ? null : {
	    label: computedProps.i18n('sortDesc'),
	    itemId: 'sortDesc',
	    disabled: !cellProps.computedSortable || colSortInfo && colSortInfo.dir === -1,
	    onClick: function onClick() {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      computedProps.setColumnSortInfo(cellProps.id, -1);
	      computedProps.hideColumnContextMenu();
	    }
	  }, (computedProps.initialProps.allowUnsort || computedProps.computedIsMultiSort) && showColumnMenuSortOptions !== false ? {
	    label: computedProps.i18n('unsort'),
	    itemId: 'unsort',
	    disabled: !colSortInfo,
	    onClick: function onClick() {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      computedProps.unsortColumn(cellProps.id);
	      computedProps.hideColumnContextMenu();
	    }
	  } : null, showColumnMenuGroupOptions === false ? null : '-', showColumnMenuGroupOptions === false ? null : {
	    label: computedProps.i18n('group'),
	    itemId: 'group',
	    disabled: !groupBy || groupBy.indexOf(cellProps.id) !== -1 || currentColumn.groupBy === false,
	    onClick: function onClick() {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      computedProps.addGroupByColumn(cellProps.id);
	      computedProps.hideColumnContextMenu();
	    }
	  }, showColumnMenuGroupOptions === false ? null : {
	    label: computedProps.i18n('ungroup'),
	    itemId: 'ungroup',
	    disabled: !groupBy || groupBy.indexOf(cellProps.id) === -1 || currentColumn.groupBy === false,
	    onClick: function onClick() {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      computedProps.removeGroupByColumn(cellProps.id);
	      computedProps.hideColumnContextMenu();
	    }
	  }, showColumnMenuLockOptions === false ? null : '-', showColumnMenuLockOptions === false ? null : {
	    label: computedProps.i18n('lockStart'),
	    itemId: 'lockStart',
	    disabled: cellProps.computedLocked === 'start' || lockLimit,
	    onClick: function onClick() {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      computedProps.setColumnLocked(cellProps.id, 'start');
	      computedProps.hideColumnContextMenu();
	    }
	  }, showColumnMenuLockOptions === false ? null : {
	    label: computedProps.i18n('lockEnd'),
	    itemId: 'lockEnd',
	    disabled: cellProps.computedLocked === 'end' || lockLimit || isAutoLock,
	    onClick: function onClick() {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      computedProps.setColumnLocked(cellProps.id, 'end');
	      computedProps.hideColumnContextMenu();
	    }
	  }, showColumnMenuLockOptions === false ? null : {
	    label: computedProps.i18n('unlock'),
	    itemId: 'unlock',
	    disabled: !cellProps.computedLocked || isAutoLock,
	    onClick: function onClick() {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      computedProps.setColumnLocked(cellProps.id, false);
	      computedProps.hideColumnContextMenu();
	    }
	  }, computedProps.enableColumnAutosize ? '-' : null, computedProps.enableColumnAutosize === false ? null : {
	    label: computedProps.i18n('autoSizeToFit'),
	    itemId: 'autoSizeToFit',
	    menuProps: {
	      dismissOnClick: true
	    },
	    onClick: function onClick() {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      if (computedProps.setColumnSizesToFit) {
	        computedProps.setColumnSizesToFit();
	        computedProps.hideColumnContextMenu();
	      }
	    }
	  }, computedProps.enableColumnAutosize === false ? null : {
	    label: computedProps.i18n('autoresizeThisColumn'),
	    itemId: 'autoresizeThisColumn',
	    menuProps: {
	      dismissOnClick: true
	    },
	    onClick: function onClick() {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      var columnId = cellProps.id;
	      if (computedProps.setColumnSizeAuto) {
	        computedProps.setColumnSizeAuto(columnId);
	        computedProps.hideColumnContextMenu();
	      }
	    }
	  }, enableColumnAutosize === false ? null : {
	    label: computedProps.i18n('autoresizeAllColumns'),
	    itemId: 'autoresizeAllColumns',
	    menuProps: {
	      dismissOnClick: true
	    },
	    onClick: function onClick() {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      if (computedProps.setColumnsSizesAuto) {
	        computedProps.setColumnsSizesAuto();
	        computedProps.hideColumnContextMenu();
	      }
	    }
	  }, columnsItem ? '-' : null, columnsItem].filter(notEmpty);
	  if (items[0] === '-') {
	    items = items.slice(1);
	  }
	  if (computedProps.initialProps.enableFiltering !== false && showColumnMenuFilterOptions !== false) {
	    var isFilterable = computedProps.computedFilterable;
	    var showFilteringMenuItems = computedProps.shouldShowFilteringMenuItems ? computedProps.shouldShowFilteringMenuItems() : false;
	    if (showFilteringMenuItems) {
	      items.push('-');
	      items.push({
	        label: computedProps.i18n('showFilteringRow', 'Show Filtering Row'),
	        itemId: 'showFilteringRow',
	        disabled: isFilterable,
	        onClick: function onClick() {
	          var computedProps = computedPropsRef.current;
	          if (!computedProps) {
	            return;
	          }
	          computedProps.setEnableFiltering(true);
	          computedProps.hideColumnContextMenu();
	        }
	      });
	      items.push({
	        label: computedProps.i18n('hideFilteringRow', 'Hide Filtering Row'),
	        itemId: 'hideFilteringRow',
	        disabled: !isFilterable,
	        onClick: function onClick() {
	          var computedProps = computedPropsRef.current;
	          if (!computedProps) {
	            return;
	          }
	          computedProps.setEnableFiltering(false);
	          computedProps.hideColumnContextMenu();
	        }
	      });
	    }
	  }
	  items.forEach(function (item) {
	    var onClick = item.onClick;
	    if (onClick && _detectUa.IS_MS_BROWSER) {
	      item.onClick = function () {
	        requestAnimationFrame(onClick);
	      };
	    }
	  });
	  var constrainToComputedProps = getTopComputedProps(computedProps);
	  var constrainTo = true;
	  var menuProps = {
	    updatePositionOnScroll: computedProps.updateMenuPositionOnScroll,
	    stopBlurPropagation: false,
	    maxHeight: constrainToComputedProps.initialProps.columnContextMenuConstrainTo ? null : constrainTo === true ? null : computedProps.getMenuAvailableHeight(),
	    nativeScroll: !_detectUa.IS_MS_BROWSER,
	    autoFocus: true,
	    enableSelection: true,
	    defaultSelected: visibleMap,
	    onDismiss: function onDismiss() {
	      var computedProps = computedPropsRef.current;
	      if (!computedProps) {
	        return;
	      }
	      computedProps.hideColumnContextMenu();
	    },
	    onSelectionChange: onSelectionChange,
	    style: {
	      zIndex: 110000,
	      position: computedProps.initialProps.columnContextMenuPosition || 'absolute'
	    },
	    items: items,
	    theme: computedProps.theme,
	    constrainTo: constrainTo,
	    alignPositions: computedProps.initialProps.columnContextMenuAlignPositions || computedProps.rtl ? COLUMN_MENU_ALIGN_POSITIONS_RTL : COLUMN_MENU_ALIGN_POSITIONS,
	    alignTo: computedProps.columnContextMenuInfoRef.current.menuAlignTo
	  };
	  var result;
	  if (computedProps.initialProps.renderColumnContextMenu) {
	    result = computedProps.initialProps.renderColumnContextMenu(menuProps, {
	      cellProps: cellProps,
	      grid: computedProps.publicAPI,
	      computedProps: computedProps,
	      computedPropsRef: computedPropsRef
	    });
	  }
	  if (result === undefined) {
	    result = _react.default.createElement(_Menu.default, _objectSpread({}, menuProps));
	  }
	  if (computedProps.initialProps.renderGridMenu) {
	    return computedProps.initialProps.renderGridMenu(result, computedProps);
	  }
	  return (0, _renderGridMenu.default)(result, computedProps);
	};
	exports.default = _default;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _react = _interopRequireDefault(__webpack_require__(2));
	var _detectUa = __webpack_require__(104);
	var _Menu = _interopRequireDefault(__webpack_require__(113));
	var _renderGridMenu = _interopRequireDefault(__webpack_require__(160));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var ROW_MENU_ALIGN_POSITIONS = ['tl-bl', 'tr-br', 'tl-tr', 'tr-tl', 'br-tr', 'bl-tl', 'br-tl', 'bl-tr', 'lc-tr', 'rc-tl'];
	var ROW_MENU_ALIGN_POSITIONS_RTL = ['tr-br', 'tl-bl', 'tr-tl', 'tl-tr', 'br-tr', 'bl-tl', 'br-tl', 'bl-tr', 'lc-tr', 'rc-tl'];
	var notEmpty = function notEmpty(x) {
	  return !!x;
	};
	var getTopComputedProps = function getTopComputedProps(computedProps) {
	  while (computedProps.initialProps.parentComputedProps) {
	    computedProps = computedProps.initialProps.parentComputedProps;
	  }
	  return computedProps;
	};
	var _default = function _default(computedProps, computedPropsRef) {
	  var rowProps = computedProps.rowContextMenuProps;
	  if (!rowProps) {
	    return null;
	  }
	  var rowContextMenuInfo = computedProps.rowContextMenuInfoRef;
	  if (!rowProps || !rowContextMenuInfo.current) {
	    return null;
	  }
	  var cellProps = rowContextMenuInfo.current.cellProps;
	  var constrainToComputedProps = getTopComputedProps(computedProps);
	  var items = [];
	  var menuProps = {
	    updatePositionOnScroll: computedProps.updateMenuPositionOnScroll,
	    stopBlurPropagation: false,
	    maxHeight: constrainToComputedProps.initialProps.columnContextMenuConstrainTo ? null : computedProps.getMenuAvailableHeight(),
	    autoFocus: true,
	    theme: computedProps.theme,
	    onDismiss: computedProps.hideRowContextMenu,
	    nativeScroll: !_detectUa.IS_MS_BROWSER,
	    style: {
	      zIndex: 110000,
	      position: computedProps.initialProps.rowContextMenuPosition || 'absolute'
	    },
	    items: items,
	    constrainTo: constrainToComputedProps.columnContextMenuInfoRef.current.getMenuConstrainTo(),
	    alignPositions: computedProps.initialProps.rowContextMenuAlignPositions || computedProps.rtl ? ROW_MENU_ALIGN_POSITIONS_RTL : ROW_MENU_ALIGN_POSITIONS,
	    alignTo: computedProps.rowContextMenuInfoRef.current.menuAlignTo
	  };
	  var result;
	  if (computedProps.initialProps.renderRowContextMenu) {
	    result = computedProps.initialProps.renderRowContextMenu(menuProps, {
	      rowProps: rowProps,
	      cellProps: cellProps,
	      grid: computedProps.publicAPI,
	      computedProps: computedProps,
	      computedPropsRef: computedPropsRef
	    });
	  }
	  if (result === undefined) {
	    result = _react.default.createElement(_Menu.default, _objectSpread({}, menuProps));
	  }
	  if (computedProps.initialProps.renderGridMenu) {
	    return computedProps.initialProps.renderGridMenu(result, computedProps);
	  }
	  return (0, _renderGridMenu.default)(result, computedProps);
	};
	exports.default = _default;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _useSortInfo = _interopRequireDefault(__webpack_require__(790));
	var _sorty = _interopRequireDefault(__webpack_require__(775));
	var _default = {
	  name: 'sortable-columns',
	  hook: _useSortInfo.default,
	  defaultProps: function defaultProps() {
	    return {
	      sorty: _sorty.default,
	      sortable: true
	    };
	  }
	};
	exports.default = _default;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var _react = __webpack_require__(2);
	var _isControlledProperty = _interopRequireDefault(__webpack_require__(115));
	var _useProperty3 = _interopRequireDefault(__webpack_require__(48));
	var _batchUpdate = _interopRequireDefault(__webpack_require__(50));
	var getNextSortInfoForColumn = function getNextSortInfoForColumn(currentDir, column, _ref) {
	  var allowUnsort = _ref.allowUnsort,
	    multiSort = _ref.multiSort,
	    forceDir = _ref.forceDir,
	    defaultDir = _ref.defaultDir,
	    sortFunctions = _ref.sortFunctions;
	  var newSortInfo = {
	    dir: 1,
	    id: column.id,
	    name: column.sortName || column.name || '',
	    columnName: column.name || '',
	    type: column.type
	  };
	  var sortName = newSortInfo.name;
	  if (!sortName && !column.sort) {
	    return null;
	  }
	  var sortFn = column.sort;
	  if (!sortFn && sortFunctions && sortFunctions[column.type]) {
	    sortFn = sortFunctions[column.type];
	  }
	  if (sortFn) {
	    newSortInfo.fn = function (one, two) {
	      return sortFn(one, two, column);
	    };
	  }
	  if (forceDir !== undefined) {
	    newSortInfo.dir = forceDir;
	    return newSortInfo;
	  }
	  if (defaultDir === undefined) {
	    defaultDir = 1;
	  }
	  if (defaultDir === 1) {
	    if (!currentDir) {
	      newSortInfo.dir = 1;
	    } else if (currentDir === 1) {
	      newSortInfo.dir = -1;
	    } else if (currentDir === -1) {
	      if (allowUnsort || multiSort) {
	        return null;
	      }
	      newSortInfo.dir = 1;
	    }
	  } else if (defaultDir === -1) {
	    if (!currentDir) {
	      newSortInfo.dir = -1;
	    } else if (currentDir === -1) {
	      newSortInfo.dir = 1;
	    } else if (currentDir === 1) {
	      if (allowUnsort || multiSort) {
	        return null;
	      }
	      newSortInfo.dir = 1;
	    }
	  }
	  return newSortInfo;
	};
	var getNextSingleSortInfo = function getNextSingleSortInfo(column, currentSortInfo, _ref2) {
	  var _ref2$allowUnsort = _ref2.allowUnsort,
	    allowUnsort = _ref2$allowUnsort === void 0 ? false : _ref2$allowUnsort,
	    multiSort = _ref2.multiSort,
	    forceDir = _ref2.forceDir,
	    defaultDir = _ref2.defaultDir,
	    sortFunctions = _ref2.sortFunctions;
	  if (Array.isArray(currentSortInfo)) {
	    return null;
	  }
	  return getNextSortInfoForColumn(currentSortInfo && (currentSortInfo.name === column.id || currentSortInfo.id === column.id || currentSortInfo.name === column.sortName) ? currentSortInfo.dir : 0, column, {
	    allowUnsort: allowUnsort,
	    multiSort: multiSort,
	    forceDir: forceDir,
	    defaultDir: defaultDir,
	    sortFunctions: sortFunctions
	  });
	};
	var getNextMultipleSortInfo = function getNextMultipleSortInfo(column, currentSortInfo, _ref3) {
	  var _ref3$allowUnsort = _ref3.allowUnsort,
	    allowUnsort = _ref3$allowUnsort === void 0 ? false : _ref3$allowUnsort,
	    forceDir = _ref3.forceDir,
	    sortFunctions = _ref3.sortFunctions;
	  var result;
	  if (!Array.isArray(currentSortInfo)) {
	    var info = getNextSingleSortInfo(column, currentSortInfo, {
	      allowUnsort: allowUnsort,
	      multiSort: true,
	      forceDir: forceDir,
	      sortFunctions: sortFunctions
	    });
	    result = [info].filter(function (x) {
	      return x;
	    });
	  } else {
	    var sortInfoIndex = currentSortInfo.findIndex(function (value) {
	      return value.id ? value.id === column.id : value.name === column.name || value.name === column.sortName;
	    });
	    var currentSortInfoForColumn = currentSortInfo[sortInfoIndex];
	    var nextSortInfoForColumn = getNextSingleSortInfo(column, currentSortInfo[sortInfoIndex], {
	      allowUnsort: allowUnsort,
	      multiSort: true,
	      forceDir: forceDir,
	      sortFunctions: sortFunctions
	    });
	    if (nextSortInfoForColumn && forceDir !== undefined) {
	      nextSortInfoForColumn.dir = forceDir;
	    }
	    result = (currentSortInfoForColumn ? [].concat((0, _toConsumableArray2.default)(currentSortInfo.slice(0, sortInfoIndex)), [nextSortInfoForColumn], (0, _toConsumableArray2.default)(currentSortInfo.slice(sortInfoIndex + 1))) : [].concat((0, _toConsumableArray2.default)(currentSortInfo), [nextSortInfoForColumn])).filter(function (x) {
	      return x;
	    });
	  }
	  return result;
	};
	var useSortInfo = function useSortInfo(props, _, computedPropsRef) {
	  var controlled = (0, _isControlledProperty.default)(props, 'sortInfo');
	  var _useProperty = (0, _useProperty3.default)(props, 'sortInfo'),
	    _useProperty2 = (0, _slicedToArray2.default)(_useProperty, 2),
	    sortInfo = _useProperty2[0],
	    silentSetSortInfo = _useProperty2[1];
	  if (controlled) {}
	  var setSortInfo = (0, _react.useCallback)(function (sortInfo) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var queue = (0, _batchUpdate.default)();
	    var computedRemoteData = computedProps.computedRemoteData;
	    queue.commit(function () {
	      if (computedProps.computedPagination && computedProps.setSkip && computedProps.computedSkip) {
	        computedProps.setSkip(0);
	      }
	      silentSetSortInfo(sortInfo);
	      if (computedRemoteData) {
	        computedProps.setLoadDataTrigger(function (loadDataTrigger) {
	          return [].concat((0, _toConsumableArray2.default)(loadDataTrigger), ['sortInfo']);
	        });
	      }
	    });
	  }, [silentSetSortInfo]);
	  var toggleColumnSort = (0, _react.useCallback)(function (colId, defaultSortingDirection) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var allowUnsort = computedProps.allowUnsort;
	    var computedColumn = computedProps.getColumnBy(colId);
	    if (!computedColumn) {
	      return;
	    }
	    var sortInfo = computedProps.computedSortInfo === undefined ? null : computedProps.computedSortInfo;
	    var sortingDirection;
	    if (computedProps.defaultSortingDirection) {
	      sortingDirection = computedProps.defaultSortingDirection === 'asc' ? 1 : -1;
	    }
	    if (defaultSortingDirection) {
	      sortingDirection = defaultSortingDirection === 'asc' ? 1 : -1;
	    }
	    var computedIsMultiSort = computedProps.computedIsMultiSort;
	    var nextSortInfo = computedIsMultiSort ? getNextMultipleSortInfo(computedColumn, sortInfo, {
	      allowUnsort: allowUnsort,
	      sortFunctions: computedProps.sortFunctions
	    }) : getNextSingleSortInfo(computedColumn, sortInfo, {
	      allowUnsort: allowUnsort,
	      multiSort: false,
	      forceDir: undefined,
	      defaultDir: sortingDirection,
	      sortFunctions: computedProps.sortFunctions
	    });
	    setSortInfo(nextSortInfo);
	  }, [setSortInfo]);
	  var setColumnSortInfo = (0, _react.useCallback)(function (column, dir) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var allowUnsort = computedProps.allowUnsort;
	    var computedColumn = computedProps.getColumnBy(column);
	    if (!computedColumn) {
	      return;
	    }
	    var computedIsMultiSort = computedProps.computedIsMultiSort;
	    var nextSortInfo = computedIsMultiSort ? getNextMultipleSortInfo(computedColumn, sortInfo, {
	      allowUnsort: allowUnsort,
	      forceDir: dir,
	      sortFunctions: computedProps.sortFunctions
	    }) : getNextSingleSortInfo(computedColumn, sortInfo, {
	      allowUnsort: allowUnsort,
	      multiSort: false,
	      forceDir: dir,
	      sortFunctions: computedProps.sortFunctions
	    });
	    setSortInfo(nextSortInfo);
	  }, [setSortInfo]);
	  var unsortColumn = function unsortColumn(column) {
	    var computedProps = computedPropsRef.current;
	    if (!computedProps) {
	      return;
	    }
	    var computedColumn = computedProps.getColumnBy(column);
	    if (!computedColumn) {
	      return;
	    }
	    var columnSortInfo = computedColumn.computedSortInfo;
	    if (!columnSortInfo) {
	      return;
	    }
	    var sortInfo = computedProps.computedSortInfo;
	    var newSortInfo = null;
	    if (Array.isArray(sortInfo)) {
	      newSortInfo = sortInfo.filter(function (sortInfo) {
	        if (sortInfo && (sortInfo.id === columnSortInfo.id || sortInfo.name === columnSortInfo.name)) {
	          return false;
	        }
	        return true;
	      });
	    }
	    setSortInfo(newSortInfo);
	  };
	  return {
	    computedSortInfo: sortInfo,
	    unsortColumn: unsortColumn,
	    setSortInfo: setSortInfo,
	    computedIsMultiSort: Array.isArray(sortInfo),
	    toggleColumnSort: toggleColumnSort,
	    setColumnSortInfo: setColumnSortInfo
	  };
	};
	var _default = useSortInfo;
	exports.default = _default;

/***/ },
/* 791 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var random = function random() {
	  return Date.now ? "".concat(Date.now()).concat(Math.random()) : "".concat(new Date().getTime()) + Math.random();
	};
	var _default = function _default(col) {
	  col.id = col.id == null ? col.name || random() : col.id;
	  return col;
	};
	exports.default = _default;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _filterTypes = _interopRequireDefault(__webpack_require__(145));
	var _filter = __webpack_require__(219);
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var doFilter = function doFilter(item, filterValueArray) {
	  var filterTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _filterTypes.default;
	  var columnsMap = arguments.length > 3 ? arguments[3] : undefined;
	  var typeOperators = (0, _filter.buildTypeOperators)(filterTypes);
	  for (var i = 0, len = filterValueArray.length; i < len; i++) {
	    var fv = filterValueArray[i];
	    var type = fv.type,
	      operator = fv.operator,
	      fn = fv.fn;
	    var currentTypeOperators = typeOperators[type];
	    if ((0, _filter.validateFilters)(fv, filterTypes, currentTypeOperators)) {
	      continue;
	    }
	    var filterParam = (0, _filter.buildFilterParam)(item, fv, filterTypes, columnsMap);
	    var filterFn = fn || currentTypeOperators[operator].fn;
	    if (filterFn(filterParam) !== true) {
	      return false;
	    }
	  }
	  return true;
	};
	var filterData = function filterData(dataArray, filterFn, config) {
	  var nodesName = config.nodesName;
	  return dataArray.map(function (item) {
	    return _objectSpread({}, item);
	  }).filter(function (item) {
	    var itemNodes = item[nodesName];
	    if (!itemNodes) {
	      return filterFn(item);
	    }
	    var filteredItemNodes = filterData(itemNodes, filterFn, config);
	    if (filteredItemNodes.length) {
	      item[nodesName] = filteredItemNodes;
	      return true;
	    }
	    return filterFn(item);
	  });
	};
	var treeFilter = function treeFilter(data, filterValueArray) {
	  var filterTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _filterTypes.default;
	  var columnsMap = arguments.length > 3 ? arguments[3] : undefined;
	  var options = arguments.length > 4 ? arguments[4] : undefined;
	  var computedProps = options && options.props || {};
	  var nodesName = computedProps && computedProps.nodesProperty || 'nodes';
	  var config = {
	    nodesName: nodesName
	  };
	  var filterFn = function filterFn(item) {
	    var filterItem = doFilter(item, filterValueArray, filterTypes, columnsMap);
	    return filterItem;
	  };
	  return filterData(data, filterFn, config) || [];
	};
	var _default = treeFilter;
	exports.default = _default;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _clamp = _interopRequireDefault(__webpack_require__(65));
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	var normalize = function normalize(result) {
	  var newColumnFlexes = result.newColumnFlexes,
	    newColumnSizes = result.newColumnSizes,
	    maxAvailableWidthForColumns = result.maxAvailableWidthForColumns;
	  if (newColumnFlexes && !Object.keys(newColumnFlexes).length) {
	    newColumnFlexes = undefined;
	  }
	  if (newColumnSizes && !Object.keys(newColumnSizes).length) {
	    newColumnSizes = undefined;
	  }
	  return _objectSpread(_objectSpread({}, result), {}, {
	    newColumnFlexes: newColumnFlexes,
	    newColumnSizes: newColumnSizes,
	    maxAvailableWidthForColumns: maxAvailableWidthForColumns
	  });
	};
	var assignFlexes = function assignFlexes(columns) {
	  return columns.reduce(function (flexes, col) {
	    if (col.computedFlex) {
	      flexes[col.id] = col.computedWidth;
	    }
	    return flexes;
	  }, {});
	};
	var clampColSize = function clampColSize(size, col) {
	  return (0, _clamp.default)(size, col.computedMinWidth, col.computedMaxWidth);
	};
	var resizeGroupColumns = function resizeGroupColumns(arg, config) {
	  var totalDiff = arg.diff,
	    maxAvailableWidthForColumns = arg.maxAvailableWidthForColumns,
	    shareSpaceOnResize = arg.shareSpaceOnResize,
	    index = arg.index,
	    groupColumns = arg.groupColumns,
	    columns = arg.columns;
	  columns = columns.map(function (c) {
	    return _objectSpread({}, c);
	  });
	  var newColumnSizes = config.newColumnSizes || {};
	  var columnsMap = columns.reduce(function (map, col) {
	    map[col.id] = col;
	    return map;
	  }, {});
	  var newColumnFlexes = _objectSpread(_objectSpread({}, assignFlexes(groupColumns.map(function (colId) {
	    return columnsMap[colId];
	  }))), config.newColumnFlexes);
	  while (Math.abs(totalDiff) > 0) {
	    groupColumns.forEach(function (colId, idx) {
	      var col = columnsMap[colId];
	      if (col.computedResizable === false) {
	        return;
	      }
	      var totalGroupResizableWidth = groupColumns.slice(idx).reduce(function (total, colId) {
	        var col = columnsMap[colId];
	        if (col.computedResizable === false) {
	          return total;
	        }
	        if (totalDiff > 0 && col.computedMaxWidth && col.computedWidth >= col.computedMaxWidth) {
	          return total;
	        }
	        if (totalDiff < 0 && col.computedMinWidth && col.computedWidth <= col.computedMinWidth) {
	          return total;
	        }
	        return total + col.computedWidth;
	      }, 0);
	      var diff = totalGroupResizableWidth ? Math.round(col.computedWidth / totalGroupResizableWidth * totalDiff) : 0;
	      var adjustment = 0;
	      if (!col.computedFlex) {
	        newColumnSizes[col.id] = col.computedWidth = col.computedWidth + diff;
	      } else {
	        delete newColumnSizes[col.id];
	        newColumnFlexes[col.id] = col.computedWidth = col.computedWidth + diff;
	      }
	      if (newColumnSizes[col.id] !== undefined) {
	        var size = newColumnSizes[col.id];
	        var clampedSize = (0, _clamp.default)(size, col.computedMinWidth, col.computedMaxWidth);
	        if (clampedSize !== size) {
	          adjustment = size - clampedSize;
	          newColumnSizes[col.id] = clampedSize;
	        }
	      } else if (newColumnFlexes[col.id] !== undefined) {
	        var _size = newColumnFlexes[col.id];
	        var _clampedSize = (0, _clamp.default)(_size, col.computedMinWidth, col.computedMaxWidth);
	        if (_clampedSize !== _size) {
	          adjustment = _size - _clampedSize;
	          newColumnFlexes[col.id] = col.computedWidth = _clampedSize;
	        }
	      }
	      if (diff === 0) {
	        totalDiff = 0;
	      } else {
	        totalDiff = totalDiff - diff + adjustment;
	      }
	    });
	  }
	  return normalize(_objectSpread(_objectSpread({}, config), {}, {
	    newColumnSizes: newColumnSizes,
	    newColumnFlexes: newColumnFlexes
	  }));
	};
	var _default = function _default(arg) {
	  var shareSpaceOnResize = arg.shareSpaceOnResize,
	    groupColumns = arg.groupColumns;
	  var result = shareSpaceOnResize ? resizeShareSpace(arg) : resizeNoShareSpace(arg);
	  if (groupColumns) {
	    return resizeGroupColumns(arg, result);
	  }
	  return result;
	};
	exports.default = _default;
	var resizeShareSpace = function resizeShareSpace(arg) {
	  var columns = arg.columns,
	    index = arg.index,
	    diff = arg.diff;
	  var maxAvailableWidthForColumns = arg.maxAvailableWidthForColumns;
	  var colLeft = columns[index];
	  var colsToRight = columns.slice(index + 1);
	  var colRight = colsToRight[0];
	  if (!colRight || colRight.computedResizable === false) {
	    return resizeNoShareSpace(arg);
	  }
	  if (!colLeft.computedFlex && !colRight.computedFlex) {
	    var _newColumnSizes;
	    var newColLeftSize = colLeft.computedWidth + diff;
	    var newColRightSize = clampColSize(colRight.computedWidth - diff, colRight);
	    var remainingDiff = newColRightSize - (colRight.computedWidth - diff);
	    var newColumnSizes = (_newColumnSizes = {}, (0, _defineProperty2.default)(_newColumnSizes, colLeft.id, newColLeftSize + remainingDiff), (0, _defineProperty2.default)(_newColumnSizes, colRight.id, newColRightSize), _newColumnSizes);
	    return normalize({
	      newColumnSizes: newColumnSizes,
	      maxAvailableWidthForColumns: maxAvailableWidthForColumns
	    });
	  }
	  if (colLeft.computedFlex && colRight.computedFlex) {
	    var newColumnFlexes = assignFlexes(columns);
	    newColumnFlexes[colLeft.id] = colLeft.computedWidth + diff;
	    newColumnFlexes[colRight.id] = colRight.computedWidth - diff;
	    return normalize({
	      newColumnFlexes: newColumnFlexes,
	      maxAvailableWidthForColumns: maxAvailableWidthForColumns
	    });
	  }
	  if (!colLeft.computedFlex) {
	    var _newColumnFlexes = assignFlexes(columns);
	    var _newColumnSizes2 = (0, _defineProperty2.default)({}, colLeft.id, colLeft.computedWidth + diff);
	    _newColumnFlexes[colRight.id] = colRight.computedWidth - diff;
	    return normalize({
	      newColumnFlexes: _newColumnFlexes,
	      newColumnSizes: _newColumnSizes2,
	      maxAvailableWidthForColumns: maxAvailableWidthForColumns
	    });
	  }
	  if (!colRight.computedFlex) {
	    var flexCount = columns.reduce(function (count, col) {
	      return count + (col.computedFlex ? 1 : 0);
	    }, 0);
	    var _newColumnFlexes2 = assignFlexes(columns);
	    var _newColumnSizes4 = (0, _defineProperty2.default)({}, colRight.id, colRight.computedWidth - diff);
	    _newColumnFlexes2[colLeft.id] = colLeft.computedWidth + diff;
	    if (flexCount === 1 && colLeft.computedFlex) {
	      _newColumnFlexes2 = {};
	    }
	    return normalize({
	      newColumnFlexes: _newColumnFlexes2,
	      newColumnSizes: _newColumnSizes4,
	      maxAvailableWidthForColumns: maxAvailableWidthForColumns
	    });
	  }
	};
	var resizeNoShareSpace = function resizeNoShareSpace(arg) {
	  var columns = arg.columns,
	    index = arg.index,
	    diff = arg.diff,
	    totalComputedWidth = arg.totalComputedWidth;
	  var maxAvailableWidthForColumns = arg.maxAvailableWidthForColumns;
	  var colLeft = columns[index];
	  var colsToRight = columns.slice(index + 1);
	  var colRight = colsToRight[0];
	  var newColumnSizes;
	  var newColumnFlexes;
	  var flexCount = columns.reduce(function (count, col) {
	    return count + (col.computedFlex ? 1 : 0);
	  }, 0);
	  if (!colLeft.computedFlex) {
	    if (!flexCount) {
	      newColumnSizes = {};
	      if (colLeft.computedResizable !== false) {
	        newColumnSizes[colLeft.id] = clampColSize(colLeft.computedWidth + diff, colLeft);
	      }
	      return normalize({
	        newColumnSizes: newColumnSizes,
	        newColumnFlexes: undefined,
	        maxAvailableWidthForColumns: maxAvailableWidthForColumns
	      });
	    }
	    newColumnSizes = {};
	    newColumnSizes[colLeft.id] = clampColSize(colLeft.computedWidth + diff, colLeft);
	    return normalize({
	      newColumnSizes: newColumnSizes,
	      newColumnFlexes: assignFlexes(columns),
	      maxAvailableWidthForColumns: totalComputedWidth + diff
	    });
	  }
	  newColumnFlexes = assignFlexes(columns);
	  newColumnFlexes[colLeft.id] = colLeft.computedWidth + diff;
	  if (flexCount === 1) {
	    if (!colLeft.keepFlex) {
	      delete newColumnFlexes[colLeft.id];
	      newColumnSizes = {};
	      newColumnSizes[colLeft.id] = clampColSize(colLeft.computedWidth + diff, colLeft);
	    } else {
	      newColumnFlexes = {};
	      maxAvailableWidthForColumns = totalComputedWidth + diff;
	    }
	  } else {
	    if (!colLeft.keepFlex) {
	      delete newColumnFlexes[colLeft.id];
	      newColumnSizes = {};
	      newColumnSizes[colLeft.id] = clampColSize(colLeft.computedWidth + diff, colLeft);
	      maxAvailableWidthForColumns = totalComputedWidth + diff;
	    } else {
	      newColumnFlexes[colLeft.id] = colLeft.computedWidth + diff;
	      maxAvailableWidthForColumns = totalComputedWidth + diff;
	    }
	  }
	  return normalize({
	    newColumnFlexes: newColumnFlexes,
	    newColumnSizes: newColumnSizes,
	    maxAvailableWidthForColumns: maxAvailableWidthForColumns
	  });
	};

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	var sum = function sum(a, b) {
	  return (a || 0) + (b || 0);
	};
	var EMPTY_ARRAY = [];
	var _default = function _default(_ref) {
	  var flexes = _ref.flexes,
	    availableSize = _ref.availableSize,
	    _ref$maxWidths = _ref.maxWidths,
	    maxWidths = _ref$maxWidths === void 0 ? EMPTY_ARRAY : _ref$maxWidths,
	    _ref$minWidths = _ref.minWidths,
	    minWidths = _ref$minWidths === void 0 ? EMPTY_ARRAY : _ref$minWidths;
	  flexes = (0, _toConsumableArray2.default)(flexes);
	  var sumOfAllFlexes = flexes.reduce(sum, 0);
	  if (minWidths.length && minWidths.length != flexes.length) {
	    throw 'minWidths.length needs to be === flexes.length';
	  }
	  if (maxWidths.length && maxWidths.length != flexes.length) {
	    throw 'maxWidths.length needs to be === flexes.length';
	  }
	  var oneFlex = sumOfAllFlexes ? availableSize / sumOfAllFlexes : 0;
	  var result = flexes.map(function (_) {
	    return null;
	  });
	  flexes.forEach(function (flex, index) {
	    var minWidth = minWidths[index];
	    flex = flex || 0;
	    if (flex === 0) {
	      return;
	    }
	    var size;
	    var flexSize = Math.round(flex * oneFlex);
	    var maxWidth = maxWidths[index];
	    if (minWidth != null && flexSize < minWidth) {
	      availableSize -= minWidth;
	      flexes[index] = 0;
	      size = minWidth;
	      sumOfAllFlexes -= flex;
	      oneFlex = sumOfAllFlexes ? availableSize / sumOfAllFlexes : 0;
	    } else if (maxWidth != null && flexSize > maxWidth) {
	      availableSize -= maxWidth;
	      flexes[index] = 0;
	      size = maxWidth;
	      sumOfAllFlexes -= flex;
	      oneFlex = sumOfAllFlexes ? availableSize / sumOfAllFlexes : 0;
	    }
	    if (size) {
	      result[index] = size;
	    }
	  });
	  var lastValidFlexIndex = flexes.reduce(function (acc, flex, index) {
	    return flex ? index : acc;
	  }, -1);
	  flexes.forEach(function (flex, index) {
	    if (!flex) {
	      return;
	    }
	    var flexSize = Math.round(flex * oneFlex);
	    if (index === lastValidFlexIndex) {
	      flexSize = availableSize;
	    }
	    if (minWidths[index] != null) {
	      flexSize = Math.max(flexSize, minWidths[index] || 0);
	    }
	    if (maxWidths[index] != null) {
	      flexSize = Math.min(flexSize, maxWidths[index] || Infinity);
	    }
	    availableSize -= Math.max(flexSize, 0);
	    result[index] = flexSize;
	  });
	  return result;
	};
	exports.default = _default;

/***/ },
/* 795 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var getIndexBy = function getIndexBy(data, by, id, getItemId, compoundIdProperty) {
	  var index = -1;
	  for (var i = 0, len = data.length; i < len; i++) {
	    var item = data[i];
	    var itemId = compoundIdProperty ? getItemId(item) : item[by];
	    var parsedId = typeof itemId === 'number' ? Number(id) : id;
	    if (itemId === parsedId) {
	      index = i;
	      break;
	    }
	  }
	  return index;
	};
	var _default = getIndexBy;
	exports.default = _default;

/***/ },
/* 796 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(element, selector) {
	  var proto = Element.prototype;
	  var vendor = proto.matches || proto.matchesSelector || proto.webkitMatchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector;
	  function match(el, sel) {
	    if (vendor) {
	      return vendor.call(el, sel);
	    }
	    var nodes = el.parentNode.querySelectorAll(sel);
	    for (var i = 0, len = nodes.length; i < len; i++) {
	      if (nodes[i] == el) {
	        return true;
	      }
	    }
	    return false;
	  }
	  return match(element, selector);
	};
	exports.default = _default;

/***/ },
/* 797 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(array, from, to) {
	  if (!Array.isArray(array)) {
	    array = [];
	  }
	  var result = [].concat(array);
	  var len = array.length;
	  if (from === to || !len || from == null || to == null || from >= len || to > len) {
	    return result;
	  }
	  from = Array.isArray(from) ? from : [from];
	  var lessThanCount = from.reduce(function (acc, index) {
	    return acc + (index < to ? 1 : 0);
	  }, 0);
	  var values = from.map(function (index) {
	    return array[index];
	  }).reverse();
	  var emptyArray = [];
	  emptyArray.concat(from).sort(function (a, b) {
	    return b - a;
	  }).forEach(function (index) {
	    result.splice(index, 1);
	  });
	  from.reverse().forEach(function (_, i) {
	    result.splice(to - lessThanCount, 0, values[i]);
	  });
	  return result;
	};
	exports.default = _default;

/***/ },
/* 798 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.notifier = notifier;
	function notifier(defaultValue) {
	  var lastValue = defaultValue;
	  var listeners = [];
	  function fn(value) {
	    lastValue = value;
	    listeners.forEach(function (listener) {
	      return listener(lastValue);
	    });
	  }
	  fn.get = function () {
	    return lastValue;
	  };
	  fn.onCalled = function (listener) {
	    listeners.push(listener);
	    return function () {
	      listeners = listeners.filter(function (l) {
	        return l !== listener;
	      });
	    };
	  };
	  fn.destroy = function () {
	    listeners.length = 0;
	  };
	  return fn;
	}

/***/ },
/* 799 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(array, _ref) {
	  var skip = _ref.skip,
	    limit = _ref.limit;
	  return array.slice(skip, skip + limit);
	};
	exports.default = _default;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _join = _interopRequireDefault(__webpack_require__(31));
	var prepareClassName = function prepareClassName(computedProps) {
	  var visibleColumns = computedProps.visibleColumns,
	    computedShowCellBorders = computedProps.computedShowCellBorders,
	    computedShowZebraRows = computedProps.computedShowZebraRows,
	    theme = computedProps.theme,
	    rtl = computedProps.rtl,
	    viewportAvailableWidth = computedProps.viewportAvailableWidth,
	    totalComputedWidth = computedProps.totalComputedWidth,
	    computedFocused = computedProps.computedFocused,
	    computedShowHoverRows = computedProps.computedShowHoverRows,
	    nativeScroll = computedProps.nativeScroll,
	    focusedClassName = computedProps.focusedClassName,
	    computedFilterable = computedProps.computedFilterable,
	    computedShowHeaderBorderRight = computedProps.computedShowHeaderBorderRight,
	    virtualizeColumns = computedProps.virtualizeColumns,
	    className = computedProps.className,
	    stickyHeader = computedProps.stickyHeader;
	  return (0, _join.default)('InovuaReactDataGrid', className, theme && "InovuaReactDataGrid--theme-".concat(theme), virtualizeColumns && 'InovuaReactDataGrid--virtualize-columns', nativeScroll && 'InovuaReactDataGrid--native-scroll', visibleColumns.length && 'InovuaReactDataGrid--columns-ready', computedShowZebraRows && 'InovuaReactDataGrid--zebra-rows', computedFilterable && 'InovuaReactDataGrid--filterable', computedFocused && 'InovuaReactDataGrid--focused', computedShowHoverRows && 'InovuaReactDataGrid--show-hover-rows', rtl ? 'InovuaReactDataGrid--direction-rtl' : 'InovuaReactDataGrid--direction-ltr', computedFocused && focusedClassName, computedShowHeaderBorderRight ? 'InovuaReactDataGrid--show-header-border-right' : 'InovuaReactDataGrid--no-header-border-right', viewportAvailableWidth > totalComputedWidth && 'InovuaReactDataGrid--show-border-right', computedShowCellBorders && (computedShowCellBorders === true ? 'InovuaReactDataGrid--cell-borders-horizontal InovuaReactDataGrid--cell-borders-vertical' : "InovuaReactDataGrid--cell-borders-".concat(computedShowCellBorders)), stickyHeader && 'InovuaReactDataGrid--sticky-header');
	};
	var _default = prepareClassName;
	exports.default = _default;

/***/ },
/* 801 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(props) {
	  var rowProps = Object.seal ? Object.seal(props) : {};
	  return rowProps;
	};
	exports.default = _default;

/***/ },
/* 802 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(array, value) {
	  var low = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var high = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : array.length - 1;
	  var mid;
	  var midValue;
	  var midNextIndex;
	  var midNextValue;
	  while (low <= high) {
	    mid = low + (high - low >> 1);
	    midValue = array[mid];
	    midNextIndex = mid + 1;
	    midNextValue = array[midNextIndex];
	    if (midValue <= value) {
	      if (midNextValue === undefined || midNextValue > value) {
	        return mid;
	      }
	      low = mid + 1;
	    } else {
	      high = mid - 1;
	    }
	  }
	  return -1;
	};
	exports.default = _default;

/***/ },
/* 803 */
/***/ function(module, exports) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = function _default(s) {
	  return "".concat(s.charAt(0).toUpperCase()).concat(s.substring(1));
	};
	exports.default = _default;

/***/ },
/* 804 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(116);
	
	var invariant = __webpack_require__(93);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(67);
	
	var ReactBaseClasses = __webpack_require__(275);
	var ReactChildren = __webpack_require__(807);
	var ReactDOMFactories = __webpack_require__(808);
	var ReactElement = __webpack_require__(74);
	var ReactPropTypes = __webpack_require__(809);
	var ReactVersion = __webpack_require__(810);
	
	var createReactClass = __webpack_require__(811);
	var onlyChild = __webpack_require__(814);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(805);
	var ReactElement = __webpack_require__(74);
	
	var emptyFunction = __webpack_require__(176);
	var traverseAllChildren = __webpack_require__(815);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(74);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(74),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(1094);
	
	module.exports = factory(isValidElement);

/***/ },
/* 810 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(275),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(74),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(278);
	var factory = __webpack_require__(310);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 812 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(116);
	
	var ReactElement = __webpack_require__(74);
	
	var invariant = __webpack_require__(93);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(116);
	
	var ReactCurrentOwner = __webpack_require__(276);
	var REACT_ELEMENT_TYPE = __webpack_require__(277);
	
	var getIteratorFn = __webpack_require__(812);
	var invariant = __webpack_require__(93);
	var KeyEscapeUtils = __webpack_require__(804);
	var warning = __webpack_require__(177);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(806);


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * accounting.js v0.4.1
	 * Copyright 2014 Open Exchange Rates
	 *
	 * Freely distributable under the MIT license.
	 * Portions of accounting.js are inspired or borrowed from underscore.js
	 *
	 * Full details and documentation:
	 * http://openexchangerates.github.io/accounting.js/
	 */
	
	(function(root, undefined) {
	
		/* --- Setup --- */
	
		// Create the local library object, to be exported or referenced globally later
		var lib = {};
	
		// Current version
		lib.version = '0.4.1';
	
	
		/* --- Exposed settings --- */
	
		// The library's settings configuration object. Contains default parameters for
		// currency and number formatting
		lib.settings = {
			currency: {
				symbol : "$",		// default currency symbol is '$'
				format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
				decimal : ".",		// decimal point separator
				thousand : ",",		// thousands separator
				precision : 2,		// decimal places
				grouping : 3		// digit grouping (not implemented yet)
			},
			number: {
				precision : 0,		// default precision on numbers is 0
				grouping : 3,		// digit grouping (not implemented yet)
				thousand : ",",
				decimal : "."
			}
		};
	
	
		/* --- Internal Helper Methods --- */
	
		// Store reference to possibly-available ECMAScript 5 methods for later
		var nativeMap = Array.prototype.map,
			nativeIsArray = Array.isArray,
			toString = Object.prototype.toString;
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js
		 */
		function isString(obj) {
			return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
		}
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js, delegates to ECMA5's native Array.isArray
		 */
		function isArray(obj) {
			return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
		}
	
		/**
		 * Tests whether supplied parameter is a true object
		 */
		function isObject(obj) {
			return obj && toString.call(obj) === '[object Object]';
		}
	
		/**
		 * Extends an object with a defaults object, similar to underscore's _.defaults
		 *
		 * Used for abstracting parameter handling from API methods
		 */
		function defaults(object, defs) {
			var key;
			object = object || {};
			defs = defs || {};
			// Iterate over object non-prototype properties:
			for (key in defs) {
				if (defs.hasOwnProperty(key)) {
					// Replace values with defaults only if undefined (allow empty/zero values):
					if (object[key] == null) object[key] = defs[key];
				}
			}
			return object;
		}
	
		/**
		 * Implementation of `Array.map()` for iteration loops
		 *
		 * Returns a new Array as a result of calling `iterator` on each array value.
		 * Defers to native Array.map if available
		 */
		function map(obj, iterator, context) {
			var results = [], i, j;
	
			if (!obj) return results;
	
			// Use native .map method if it exists:
			if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	
			// Fallback for native .map:
			for (i = 0, j = obj.length; i < j; i++ ) {
				results[i] = iterator.call(context, obj[i], i, obj);
			}
			return results;
		}
	
		/**
		 * Check and normalise the value of precision (must be positive integer)
		 */
		function checkPrecision(val, base) {
			val = Math.round(Math.abs(val));
			return isNaN(val)? base : val;
		}
	
	
		/**
		 * Parses a format string or object and returns format obj for use in rendering
		 *
		 * `format` is either a string with the default (positive) format, or object
		 * containing `pos` (required), `neg` and `zero` values (or a function returning
		 * either a string or object)
		 *
		 * Either string or format.pos must contain "%v" (value) to be valid
		 */
		function checkCurrencyFormat(format) {
			var defaults = lib.settings.currency.format;
	
			// Allow function as format parameter (should return string or object):
			if ( typeof format === "function" ) format = format();
	
			// Format can be a string, in which case `value` ("%v") must be present:
			if ( isString( format ) && format.match("%v") ) {
	
				// Create and return positive, negative and zero formats:
				return {
					pos : format,
					neg : format.replace("-", "").replace("%v", "-%v"),
					zero : format
				};
	
			// If no format, or object is missing valid positive value, use defaults:
			} else if ( !format || !format.pos || !format.pos.match("%v") ) {
	
				// If defaults is a string, casts it to an object for faster checking next time:
				return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
					pos : defaults,
					neg : defaults.replace("%v", "-%v"),
					zero : defaults
				};
	
			}
			// Otherwise, assume format was fine:
			return format;
		}
	
	
		/* --- API Methods --- */
	
		/**
		 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
		 * Alias: `accounting.parse(string)`
		 *
		 * Decimal must be included in the regular expression to match floats (defaults to
		 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
		 * separator, provide it as the second argument.
		 *
		 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
		 *
		 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
		 */
		var unformat = lib.unformat = lib.parse = function(value, decimal) {
			// Recursively unformat arrays:
			if (isArray(value)) {
				return map(value, function(val) {
					return unformat(val, decimal);
				});
			}
	
			// Fails silently (need decent errors):
			value = value || 0;
	
			// Return the value as-is if it's already a number:
			if (typeof value === "number") return value;
	
			// Default decimal point comes from settings, but could be set to eg. "," in opts:
			decimal = decimal || lib.settings.number.decimal;
	
			 // Build regex to strip out everything except digits, decimal point and minus sign:
			var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
				unformatted = parseFloat(
					("" + value)
					.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
					.replace(regex, '')         // strip out any cruft
					.replace(decimal, '.')      // make sure decimal point is standard
				);
	
			// This will fail silently which may cause trouble, let's wait and see:
			return !isNaN(unformatted) ? unformatted : 0;
		};
	
	
		/**
		 * Implementation of toFixed() that treats floats more like decimals
		 *
		 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
		 * problems for accounting- and finance-related software.
		 */
		var toFixed = lib.toFixed = function(value, precision) {
			precision = checkPrecision(precision, lib.settings.number.precision);
			var power = Math.pow(10, precision);
	
			// Multiply up by precision, round accurately, then divide and use native toFixed():
			return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
		};
	
	
		/**
		 * Format a number, with comma-separated thousands and custom precision/decimal places
		 * Alias: `accounting.format()`
		 *
		 * Localise by overriding the precision and thousand / decimal separators
		 * 2nd parameter `precision` can be an object matching `settings.number`
		 */
		var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val) {
					return formatNumber(val, precision, thousand, decimal);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(precision) ? precision : {
						precision : precision,
						thousand : thousand,
						decimal : decimal
					}),
					lib.settings.number
				),
	
				// Clean up precision
				usePrecision = checkPrecision(opts.precision),
	
				// Do some calc:
				negative = number < 0 ? "-" : "",
				base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
				mod = base.length > 3 ? base.length % 3 : 0;
	
			// Format the number:
			return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
		};
	
	
		/**
		 * Format a number into currency
		 *
		 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
		 * defaults: (0, "$", 2, ",", ".", "%s%v")
		 *
		 * Localise by overriding the symbol, precision, thousand / decimal separators and format
		 * Second param can be an object matching `settings.currency` which is the easiest way.
		 *
		 * To do: tidy up the parameters
		 */
		var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val){
					return formatMoney(val, symbol, precision, thousand, decimal, format);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero):
				formats = checkCurrencyFormat(opts.format),
	
				// Choose which format to use for this value:
				useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;
	
			// Return with currency symbol added:
			return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
		};
	
	
		/**
		 * Format a list of numbers into an accounting column, padding with whitespace
		 * to line up currency symbols, thousand separators and decimals places
		 *
		 * List should be an array of numbers
		 * Second parameter can be an object containing keys that match the params
		 *
		 * Returns array of accouting-formatted number strings of same length
		 *
		 * NB: `white-space:pre` CSS rule is required on the list container to prevent
		 * browsers from collapsing the whitespace in the output strings.
		 */
		lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
			if (!list) return [];
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero), only need pos for now:
				formats = checkCurrencyFormat(opts.format),
	
				// Whether to pad at start of string or after currency symbol:
				padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,
	
				// Store value for the length of the longest string in the column:
				maxLength = 0,
	
				// Format the list according to options, store the length of the longest string:
				formatted = map(list, function(val, i) {
					if (isArray(val)) {
						// Recursively format columns if list is a multi-dimensional array:
						return lib.formatColumn(val, opts);
					} else {
						// Clean up the value
						val = unformat(val);
	
						// Choose which format to use for this value (pos, neg or zero):
						var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,
	
							// Format this value, push into formatted list and save the length:
							fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	
						if (fVal.length > maxLength) maxLength = fVal.length;
						return fVal;
					}
				});
	
			// Pad each number in the list and send back the column of numbers:
			return map(formatted, function(val, i) {
				// Only if this is a string (not a nested array, which would have already been padded):
				if (isString(val) && val.length < maxLength) {
					// Depending on symbol position, pad after symbol or at index 0:
					return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
				}
				return val;
			});
		};
	
	
		/* --- Module Definition --- */
	
		// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
		// Otherwise, just add `accounting` to the global object
		if (true) {
			if (typeof module !== 'undefined' && module.exports) {
				exports = module.exports = lib;
			}
			exports.accounting = lib;
		} else if (typeof define === 'function' && define.amd) {
			// Return the library as an AMD module:
			define([], function() {
				return lib;
			});
		} else {
			// Use accounting.noConflict to restore `accounting` back to its original value.
			// Returns a reference to the library's `accounting` object;
			// e.g. `var numbers = accounting.noConflict();`
			lib.noConflict = (function(oldAccounting) {
				return function() {
					// Reset the value of the root's `accounting` variable:
					root.accounting = oldAccounting;
					// Delete the noConflict method:
					lib.noConflict = undefined;
					// Return reference to the library to re-assign it:
					return lib;
				};
			})(root.accounting);
	
			// Declare `fx` on the root (global/window) object:
			root['accounting'] = lib;
		}
	
		// Root will be `window` in browser or `global` on the server:
	}(this));


/***/ },
/* 818 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/*! AtatusJs - v4.6.0 - 2023-08-09
	* Copyright (c) 2023 Atatus */
	!function(){"undefined"!=typeof window&&(!function(a){function b(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function c(a){return"undefined"==typeof a}if(a){var d={},e=a.TraceKit,f=[].slice,g="?";d.noConflict=function(){return a.TraceKit=e,d},d.wrap=function(a){function b(){try{return a.apply(this,arguments)}catch(b){throw d.report(b),b}}try{if("function"!=typeof a||!a.apply)return a}catch(c){return a}return b},d.report=function(){function c(a){h(),m.push(a)}function e(a){for(var b=m.length-1;b>=0;--b)m[b]===a&&m.splice(b,1)}function f(a,c,e){var f=null;if(!c||d.collectWindowErrors){for(var g in m)if(b(m,g))try{m[g](a,c,e)}catch(h){f=h}if(f)throw f}}function g(a,b,c,e,g){var h=null;if(o)d.computeStackTrace.augmentStackTraceWithInitialElement(o,b,c,a),i();else if(g)h=d.computeStackTrace(g),f(h,!0,g);else{var j={url:b,line:c,column:e};j.func=d.computeStackTrace.guessFunctionName(j.url,j.line),j.context=d.computeStackTrace.gatherContext(j.url,j.line),h={mode:"onerror",message:a,stack:[j]},f(h,!0,null)}return k?k.apply(this,arguments):!1}function h(){l!==!0&&(k=a.onerror,a.onerror=g,l=!0)}function i(){var a=o,b=n;o=null,n=null,f(a,!1,b)}function j(b){if(o){if(n===b)return;i()}var c=d.computeStackTrace(b);throw o=c,n=b,a.setTimeout(function(){n===b&&i()},c.incomplete?2e3:0),b}var k,l,m=[],n=null,o=null;return j.subscribe=c,j.unsubscribe=e,j}(),d.computeStackTrace=function(){function e(a){return"string"!=typeof a?[]:""}function f(c){if("string"!=typeof c)return[];if(!b(w,c)){var d="",f="";try{f=a.document.domain}catch(g){}var h=/(.*)\:\/\/([^:\/]+)([:\d]*)\/{0,1}([\s\S]*)/.exec(c);h&&h[2]===f&&(d=e(c)),w[c]=d?d.split("\n"):[]}return w[c]}function h(a,b){var d,e=/function ([^(]*)\(([^)]*)\)/,h=/['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,i="",j=10,k=f(a);if(!k.length)return g;for(var l=0;j>l;++l)if(i=k[b-l]+i,!c(i)){if(d=h.exec(i))return d[1];if(d=e.exec(i))return d[1]}return g}function i(a,b){var e=f(a);if(!e.length)return null;var g=[],h=Math.floor(d.linesOfContext/2),i=h+d.linesOfContext%2,j=Math.max(0,b-h-1),k=Math.min(e.length,b+i-1);b-=1;for(var l=j;k>l;++l)c(e[l])||g.push(e[l]);return g.length>0?g:null}function j(a){return a.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g,"\\$&")}function k(a){return j(a).replace("<","(?:<|&lt;)").replace(">","(?:>|&gt;)").replace("&","(?:&|&amp;)").replace('"','(?:"|&quot;)').replace(/\s+/g,"\\s+")}function l(a,b){for(var c,d,e=0,g=b.length;g>e;++e)if((c=f(b[e])).length&&(c=c.join("\n"),d=a.exec(c)))return{url:b[e],line:c.substring(0,d.index).split("\n").length,column:d.index-c.lastIndexOf("\n",d.index)-1};return null}function m(a,b,c){var d,e=f(b),g=new RegExp("\\b"+j(a)+"\\b");return c-=1,e&&e.length>c&&(d=g.exec(e[c]))?d.index:null}function n(b){if(!c(a&&a.document)){for(var d,e,f,g,h=[a.location.href],i=a.document.getElementsByTagName("script"),m=""+b,n=/^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,o=/^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,p=0;p<i.length;++p){var q=i[p];q.src&&h.push(q.src)}if(f=n.exec(m)){var r=f[1]?"\\s+"+f[1]:"",s=f[2].split(",").join("\\s*,\\s*");d=j(f[3]).replace(/;$/,";?"),e=new RegExp("function"+r+"\\s*\\(\\s*"+s+"\\s*\\)\\s*{\\s*"+d+"\\s*}")}else e=new RegExp(j(m).replace(/\s+/g,"\\s+"));if(g=l(e,h))return g;if(f=o.exec(m)){var t=f[1];if(d=k(f[2]),e=new RegExp("on"+t+"=[\\'\"]\\s*"+d+"\\s*[\\'\"]","i"),g=l(e,h[0]))return g;if(e=new RegExp(d),g=l(e,h))return g}return null}}function o(a){if(!a.stack)return null;for(var b,d,e=/^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|webpack|eval).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,f=/^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,j=/^\s*at (?:((?:\[object object\])?.+) )?\(?((?:ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,k=a.stack.split("\n"),l=[],n=/^(.*) is undefined$/.exec(a.message),o=0,p=k.length;p>o;++o){if(b=e.exec(k[o])){var q=b[2]&&-1!==b[2].indexOf("native");d={url:q?null:b[2],func:b[1]||g,args:q?[b[2]]:[],line:b[3]?+b[3]:null,column:b[4]?+b[4]:null}}else if(b=j.exec(k[o]))d={url:b[2],func:b[1]||g,args:[],line:+b[3],column:b[4]?+b[4]:null};else{if(!(b=f.exec(k[o])))continue;d={url:b[3],func:b[1]||g,args:b[2]?b[2].split(","):[],line:b[4]?+b[4]:null,column:b[5]?+b[5]:null}}!d.func&&d.line&&(d.func=h(d.url,d.line)),d.line&&(d.context=i(d.url,d.line)),l.push(d)}return l.length?(l[0]&&l[0].line&&!l[0].column&&n?l[0].column=m(n[1],l[0].url,l[0].line):l[0].column||c(a.columnNumber)||(l[0].column=a.columnNumber+1),{mode:"stack",name:a.name,message:a.message,stack:l}):null}function p(a){var b=a.stacktrace;if(b){for(var c,d=/ line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i,e=/ line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i,f=b.split("\n"),g=[],j=0;j<f.length;j+=2){var k=null;if((c=d.exec(f[j]))?k={url:c[2],line:+c[1],column:null,func:c[3],args:[]}:(c=e.exec(f[j]))&&(k={url:c[6],line:+c[1],column:+c[2],func:c[3]||c[4],args:c[5]?c[5].split(","):[]}),k){if(!k.func&&k.line&&(k.func=h(k.url,k.line)),k.line)try{k.context=i(k.url,k.line)}catch(l){}k.context||(k.context=[f[j+1]]),g.push(k)}}return g.length?{mode:"stacktrace",name:a.name,message:a.message,stack:g}:null}}function q(c){var d=c.message.split("\n");if(d.length<4)return null;var e,g=/^\s*Line (\d+) of linked script ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i,j=/^\s*Line (\d+) of inline#(\d+) script in ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i,m=/^\s*Line (\d+) of function script\s*$/i,n=[],o=a&&a.document&&a.document.getElementsByTagName("script"),p=[];for(var q in o)b(o,q)&&!o[q].src&&p.push(o[q]);for(var r=2;r<d.length;r+=2){var s=null;if(e=g.exec(d[r]))s={url:e[2],func:e[3],args:[],line:+e[1],column:null};else if(e=j.exec(d[r])){s={url:e[3],func:e[4],args:[],line:+e[1],column:null};var t=+e[1],u=p[e[2]-1];if(u){var v=f(s.url);if(v){v=v.join("\n");var w=v.indexOf(u.innerText);w>=0&&(s.line=t+v.substring(0,w).split("\n").length)}}}else if(e=m.exec(d[r])){var x=a.location.href.replace(/#.*$/,""),y=new RegExp(k(d[r+1])),z=l(y,[x]);s={url:x,func:"",args:[],line:z?z.line:e[1],column:null}}if(s){s.func||(s.func=h(s.url,s.line));var A=i(s.url,s.line),B=A?A[Math.floor(A.length/2)]:null;s.context=A&&B.replace(/^\s*/,"")===d[r+1].replace(/^\s*/,"")?A:[d[r+1]],n.push(s)}}return n.length?{mode:"multiline",name:c.name,message:d[0],stack:n}:null}function r(a,b,c,d){var e={url:b,line:c};if(e.url&&e.line){a.incomplete=!1,e.func||(e.func=h(e.url,e.line)),e.context||(e.context=i(e.url,e.line));var f=/ '([^']+)' /.exec(d);if(f&&(e.column=m(f[1],e.url,e.line)),a.stack.length>0&&a.stack[0].url===e.url){if(a.stack[0].line===e.line)return!1;if(!a.stack[0].line&&a.stack[0].func===e.func)return a.stack[0].line=e.line,a.stack[0].context=e.context,!1}return a.stack.unshift(e),a.partial=!0,!0}return a.incomplete=!0,!1}function s(a,b){for(var c,e,f,i=/function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,j=[],k={},l=!1,o=s.caller;o&&!l;o=o.caller)if(o!==t&&o!==d.report){if(e={url:null,func:g,args:[],line:null,column:null},o.name?e.func=o.name:(c=i.exec(o.toString()))&&(e.func=c[1]),"undefined"==typeof e.func)try{e.func=c.input.substring(0,c.input.indexOf("{"))}catch(p){}if(f=n(o)){e.url=f.url,e.line=f.line,e.func===g&&(e.func=h(e.url,e.line));var q=/ '([^']+)' /.exec(a.message||a.description);q&&(e.column=m(q[1],f.url,f.line))}k[""+o]?l=!0:k[""+o]=!0,j.push(e)}b&&j.splice(0,b);var u={mode:"callers",name:a.name,message:a.message,stack:j};return r(u,a.sourceURL||a.fileName,a.line||a.lineNumber,a.message||a.description),u}function t(a,b){var c=null;b=null==b?0:+b;try{if(c=p(a))return c}catch(d){if(v)throw d}try{if(c=o(a))return c}catch(d){if(v)throw d}try{if(c=q(a))return c}catch(d){if(v)throw d}try{if(c=s(a,b+1))return c}catch(d){if(v)throw d}return{mode:"failed"}}function u(a){a=(null==a?0:+a)+1;try{throw new Error}catch(b){return t(b,a+1)}}var v=!1,w={};return t.augmentStackTraceWithInitialElement=r,t.guessFunctionName=h,t.gatherContext=i,t.ofCaller=u,t.getSource=f,t}(),d.extendToAsynchronousCallbacks=function(){var b=function(b){var c=a[b];a[b]=function(){var a=f.call(arguments),b=a[0];return"function"==typeof b&&(a[0]=d.wrap(b)),c.apply?c.apply(this,a):c(a[0],a[1])}};b("setTimeout"),b("setInterval")},d.remoteFetching||(d.remoteFetching=!0),d.collectWindowErrors||(d.collectWindowErrors=!0),(!d.linesOfContext||d.linesOfContext<1)&&(d.linesOfContext=11),a.TraceKit=d}}("undefined"!=typeof window?window:global),function(a,b){"use strict";if(a&&a.event&&a.event.add){var c=a.event.add;a.event.add=function(d,e,f,g,h){if("function"!=typeof f&&"function"!=typeof f.handler)return c.call(this,d,e,f,g,h);var i;return f.handler?(i=f.handler,f.handler=b.wrap(f.handler)):(i=f,f=b.wrap(f)),f.guid=i.guid?i.guid:i.guid=a.guid++,c.call(this,d,e,f,g,h)};var d=a.fn.ready;a.fn.ready=function(a){return d.call(this,b.wrap(a))};var e=a.ajax;a.ajax=function(c,d){"object"==typeof c&&(d=c,c=void 0),d=d||{};for(var f,g=["complete","error","success"];f=g.pop();)a.isFunction(d[f])&&(d[f]=b.wrap(d[f]));try{return c?e.call(this,c,d):e.call(this,d)}catch(h){throw b.report(h),h}}}}(window.jQuery,window.TraceKit),window.webVitals=function(a){"use strict";var b,c,d,e,f=function(a,b){return{name:a,value:void 0===b?-1:b,delta:0,entries:[],id:"v2-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12)}},g=function(a,b){try{if(PerformanceObserver.supportedEntryTypes.includes(a)){if("first-input"===a&&!("PerformanceEventTiming"in self))return;var c=new PerformanceObserver(function(a){return a.getEntries().map(b)});return c.observe({type:a,buffered:!0}),c}}catch(a){}},h=function(a,b){var c=function d(c){"pagehide"!==c.type&&"hidden"!==document.visibilityState||(a(c),b&&(removeEventListener("visibilitychange",d,!0),removeEventListener("pagehide",d,!0)))};addEventListener("visibilitychange",c,!0),addEventListener("pagehide",c,!0)},i=function(a){addEventListener("pageshow",function(b){b.persisted&&a(b)},!0)},j=function(a,b,c){var d;return function(e){b.value>=0&&(e||c)&&(b.delta=b.value-(d||0),(b.delta||void 0===d)&&(d=b.value,a(b)))}},k=-1,l=function(){return"hidden"===document.visibilityState?0:1/0},m=function(){h(function(a){var b=a.timeStamp;k=b},!0)},n=function(){return 0>k&&(k=l(),m(),i(function(){setTimeout(function(){k=l(),m()},0)})),{get firstHiddenTime(){return k}}},o=function(a,b){var c,d=n(),e=f("FCP"),h=function(a){"first-contentful-paint"===a.name&&(l&&l.disconnect(),a.startTime<d.firstHiddenTime&&(e.value=a.startTime,e.entries.push(a),c(!0)))},k=window.performance&&performance.getEntriesByName&&performance.getEntriesByName("first-contentful-paint")[0],l=k?null:g("paint",h);(k||l)&&(c=j(a,e,b),k&&h(k),i(function(d){e=f("FCP"),c=j(a,e,b),requestAnimationFrame(function(){requestAnimationFrame(function(){e.value=performance.now()-d.timeStamp,c(!0)})})}))},p=!1,q=-1,r={passive:!0,capture:!0},s=new Date,t=function(a,e){b||(b=e,c=a,d=new Date,w(removeEventListener),u())},u=function(){if(c>=0&&d-s>c){var a={entryType:"first-input",name:b.type,target:b.target,cancelable:b.cancelable,startTime:b.timeStamp,processingStart:b.timeStamp+c};e.forEach(function(b){b(a)}),e=[]}},v=function(a){if(a.cancelable){var b=(a.timeStamp>1e12?new Date:performance.now())-a.timeStamp;"pointerdown"==a.type?function(a,b){var c=function(){t(a,b),e()},d=function(){e()},e=function(){removeEventListener("pointerup",c,r),removeEventListener("pointercancel",d,r)};addEventListener("pointerup",c,r),addEventListener("pointercancel",d,r)}(b,a):t(b,a)}},w=function(a){["mousedown","keydown","touchstart","pointerdown"].forEach(function(b){return a(b,v,r)})},x={};return a.getCLS=function(a,b){p||(o(function(a){q=a.value}),p=!0);var c,d=function(b){q>-1&&a(b)},e=f("CLS",0),k=0,l=[],m=function(a){if(!a.hadRecentInput){var b=l[0],d=l[l.length-1];k&&a.startTime-d.startTime<1e3&&a.startTime-b.startTime<5e3?(k+=a.value,l.push(a)):(k=a.value,l=[a]),k>e.value&&(e.value=k,e.entries=l,c())}},n=g("layout-shift",m);n&&(c=j(d,e,b),h(function(){n.takeRecords().map(m),c(!0)}),i(function(){k=0,q=-1,e=f("CLS",0),c=j(d,e,b)}))},a.getFCP=o,a.getFID=function(a,d){var k,l=n(),m=f("FID"),o=function(a){a.startTime<l.firstHiddenTime&&(m.value=a.processingStart-a.startTime,m.entries.push(a),k(!0))},p=g("first-input",o);k=j(a,m,d),p&&h(function(){p.takeRecords().map(o),p.disconnect()},!0),p&&i(function(){var g;m=f("FID"),k=j(a,m,d),e=[],c=-1,b=null,w(addEventListener),g=o,e.push(g),u()})},a.getLCP=function(a,b){var c,d=n(),e=f("LCP"),k=function(a){var b=a.startTime;b<d.firstHiddenTime&&(e.value=b,e.entries.push(a)),c()},l=g("largest-contentful-paint",k);if(l){c=j(a,e,b);var m=function(){x[e.id]||(l.takeRecords().map(k),l.disconnect(),x[e.id]=!0,c(!0))};["keydown","click"].forEach(function(a){addEventListener(a,m,{once:!0,capture:!0})}),h(m,!0),i(function(d){e=f("LCP"),c=j(a,e,b),requestAnimationFrame(function(){requestAnimationFrame(function(){e.value=performance.now()-d.timeStamp,x[e.id]=!0,c(!0)})})})}},a.getTTFB=function(){var a,b=f("TTFB");a=function(){try{var a=performance.getEntriesByType("navigation")[0]||function(){var a=performance.timing,b={entryType:"navigation",startTime:0};for(var c in a)"navigationStart"!==c&&"toJSON"!==c&&(b[c]=Math.max(a[c]-a.navigationStart,0));return b}();if(b.value=b.delta=a.responseStart,b.value<0||b.value>performance.now())return;b.entries=[a],c(b)}catch(c){}},"complete"===document.readyState?setTimeout(a,0):addEventListener("pageshow",a)},Object.defineProperty(a,"__esModule",{value:!0}),a}({}),function(a,b,c,d){function e(){try{C=null,o()&&localStorage.removeItem(ha),D=null,Ea.createCookie(ia,"",-1)}catch(a){Ea.log("Atatus Reset User",a)}}function f(a,b,c,d){if(a){C={},a&&(C.id=""+a),b&&(C.email=""+b),c&&(C.name=""+c),d&&(C.anonymous=d);try{o()&&localStorage.setItem(ha,JSON.stringify(C)),D=null,Ea.createCookie(ia,"",-1)}catch(e){Ea.log("Atatus Set User: Invalid JSON object in LocalStorage",e)}}}function g(){try{var a;if(o()&&(a=localStorage.getItem(ha)),a)C=JSON.parse(a),D=null;else{var b,c=Ea.readCookie(ia);c&&(b=Ea.readCookieElement(c,"id")),b&&"undefined"!==b?D=b:(D=Ea.uuid4(),Ea.createCookie(ia,D))}}catch(d){Ea.log("Atatus Get User: Invalid JSON object in LocalStorage",d)}}function h(a){var b=a,c=a.split("//")[1];if(c){var d=c.indexOf("?"),e=c.toString().substring(0,d),f=e.split("/").slice(0,4).join("/"),g=e.substring(0,48);b=f.length<g.length?f:g,b!==e&&(b+="..")}return b}function i(a,b,c,e){if(0!==b.status&&b.getAllResponseHeaders()){var f="AJAX Error: "+(b.statusText||"unknown")+" "+(c.type||"unknown")+" "+(h(c.url)||"unknown");Ia.send(e||a.type,{status:b.status,statusText:b.statusText,type:c.type,url:c.url,ajaxErrorMessage:f,contentType:c.contentType,requestData:c.data&&c.data.slice?c.data.slice(0,10240):d,responseData:b.responseText&&b.responseText.slice?b.responseText.slice(0,10240):d,activeTarget:a.target&&a.target.activeElement&&a.target.activeElement.outerHTML&&a.target.activeElement.outerHTML.slice?a.target.activeElement.outerHTML.slice(0,10240):d})}}function j(a){if(Ea.log("Atatus: Caught unhandled promise rejection:",a),a){var b=a.reason||"<no reason specified>";b&&(b instanceof Error||b.message)?Ia.notify(b):(b="object"==typeof b?"<object>":"function"==typeof b?"<function>":b,Ia.notify(new Error("UnhandledRejection: "+b)))}}function k(){"addEventListener"in a&&a.addEventListener("unhandledrejection",j)}function l(){"removeEventListener"in a&&a.removeEventListener("unhandledrejection",j)}function m(){return A&&""!==A?!0:(Ea.log("Atatus API key has not been configured, make sure you call atatus.config(yourApiKey)"),!1)}function n(){var c=b.documentElement,d=b.getElementsByTagName("body")[0],e=a.innerWidth||c.clientWidth||d.clientWidth,f=a.innerHeight||c.clientHeight||d.clientHeight;return{width:e,height:f}}function o(){try{return"localStorage"in a&&null!==a.localStorage}catch(b){return!1}}function p(a){try{if(o()&&localStorage.length<50){var b=(new Date).toJSON(),c="atatusjs="+b+"="+Ea.getRandomInt();"undefined"==typeof localStorage[c]&&(localStorage[c]=a)}else Ea.log("Atatus: Reached local storage limit.")}catch(d){Ea.log("Atatus: LocalStorage full, cannot save exception")}}function q(){try{if(o()&&localStorage.length>0)for(var a in localStorage)if("atatusjs="===a.substring(0,9)){try{var b=JSON.parse(localStorage[a]);"apikey"in b&&t(ka,b)}catch(c){Ea.log("Atatus: Invalid JSON object in LocalStorage")}localStorage.removeItem(a)}}catch(c){Ea.log("Atatus sendSavedErrors: LocalStorage read failed!",c)}}function r(a,c){if(c=Ea.isObject(c)?c:{},!a.stack||!a.stack.length)return void Ea.log("Atatus: Canceling send due to no stacktrace.");Ea.isObject(c.customData)||(c.customData=d),Ea.isArray(c.tags)||(c.tags=d);var e=c.customData&&c.customData.ajaxErrorMessage||a.message;if(e&&0===e.indexOf("Uncaught ")&&(e=a.message.substring(9)),e=e||c.status||"Script error.",N&&N.test(e))return void Ea.log("Atatus: canceling send due to Script error or ignored errors.");e=e.substr(0,ua);var f=[];a.stack&&a.stack.length&&Ea.forEach(a.stack,function(a,b){Ea.endsWith(b.url,"/atatus.js")||Ea.endsWith(b.url,"/atatus-spa.js")||Ea.endsWith(b.url,"/atatus-spa.min.js")||Ea.endsWith(b.url,"/atatus.min.js")||f.push({ln:parseInt(b.line||0),cn:parseInt(b.column||0),f:b.url||"anonymous",m:b.func||"[anonymous]"})});var g=[a.name,e,JSON.stringify(f)].join("|");if(g===O)return void Ea.log("Atatus: canceling send due to duplicate errors");O=g;var h=c.customData;try{JSON.stringify(h)}catch(i){var j="Cannot add custom data; may contain circular reference";h={error:j},Ea.log("Atatus: "+j)}var k=Ha.getAllEvents();Fa.clear();var l={"class":a.name,url:b.location.href,message:e,name:e,backTraces:f,breadCrumbs:k,customData:h||null,tags:c.tags,ts:(new Date).getTime()};if("function"==typeof Q&&(l.groupingKey=Q(l)),"function"==typeof S){var m=S(l);m&&(delete l.name,s(l))}else delete l.name,s(l)}function s(a){return G?void Ea.log("Error Tracking is disabled."):void t(ka,{customData:B||null,errors:[a]})}function t(c,d){if(m()){if(!Ia._isAllowedUrl(location.href))return void Ea.log("Atatus: canceling send due to not an allowed domain/url.");if(!d.ts){var e=a.screen||n();d.ts=(new Date).getTime(),d.apikey=A,d.request={url:b.location.href,ua:navigator.userAgent,w:e.width,h:e.height},d.connection=Ca,d.tags=d.tags||Z,d.user=C&&C.id?C:null,d.aid=D||null,d.sid=Ia.sessionId||"",d.v=E||"",d._v=Ia.VERSION||W||""}if(R){var f=R(d);if(!f)return void Ea.log("Atatus: canceling send due to false from beforeSend callback.")}if(P&&P(d),Ea.log("Sending data to Atatus Receiver:",d),c===la)w(c,d);else if(c===na){if(!d.sid)return void Ea.log("Atatus: canceling session send due to empty session id.");if(Ba.session>=xa)return void Ea.log("Atatus: Canceling session send. Reached maximum number of requests!");Ba.session+=1,y(c,d)}else if(c===oa){if(Ba.spa>=za)return void Ea.log("Atatus: Canceling SPA send. Reached maximum number of requests!");Ba.spa+=1,Ba.ajax=0,y(c,d)}else if(c===qa){if(Ba.webvitals>=Aa)return void Ea.log("Atatus: Canceling web vitals send. Reached maximum number of requests!");Ba.webvitals+=1,z(c,d)}else{if(c===ka){if(Ba.error>=va)return void Ea.log("Atatus: Canceling error send. Reached maximum number of requests!");Ba.error+=1}else if(c===ma){if(Ba.ajax>=wa)return void Ea.log("Atatus: Canceling AJAX send. Reached maximum number of requests!");Ba.ajax+=1}else if(c===pa){if(Ba.txn>=ya)return void Ea.log("Atatus: Canceling transaction send. Reached maximum number of requests!");Ba.txn+=1}v(c,d)}}}function u(a){return"apikey="+a.apikey+"&v="+a._v}function v(a,b){var c=ja+a+"?data="+encodeURIComponent(JSON.stringify(b))+"&"+u(b);if(c.length>ra)return void Ea.log("Atatus: Canceling request send due to large payload size.");var d=new Image;d.crossOrigin="anonymous",d.onload=function(){q()},d.onerror=d.onabort=function(){da&&a===ka&&p(JSON.stringify(b))},d.src=c}function w(a,c){var d=b.createElement("script"),e=ja+a+"?data="+encodeURIComponent(JSON.stringify(c))+"&callback=atatus._setFeatures&"+u(c);d.type="text/javascript",d.src=e;var f=b.getElementsByTagName("script")[0];f.parentNode.insertBefore(d,f)}function x(b,c){var d;return d=new a.XMLHttpRequest,"withCredentials"in d?d.open(b,c,!0):a.XDomainRequest&&(c=Ea.getTargetUrl(c),d=new a.XDomainRequest,d.open(b,c)),d.timeout=1e4,d}function y(b,c){var d=ja+b+"?"+u(c),e=x("POST",d);return e?("function"==typeof e.setRequestHeader&&e.setRequestHeader("Content-Type","application/json;charset=UTF-8"),"withCredentials"in e?(e.onreadystatechange=function(){4!==e.readyState},e.onload=function(){Ea.log("Sent data to Atatus. Status - "+e.status)}):a.XDomainRequest&&(e.ontimeout=function(){},e.onload=function(){Ea.log("Sent data to Atatus. Status - "+e.status)}),e.onerror=function(){Ea.log("Failed to send to Atatus. Status - "+e.status)},void e.send(JSON.stringify(c))):void Ea.log("XHR is not supported!")}function z(b,c){var d="[object Navigator]"===Object.prototype.toString.call(a&&a.navigator),e=d&&"function"==typeof a.navigator.sendBeacon;if(e){var f=a.navigator.sendBeacon.bind(a.navigator),g=ja+b;return f(g,JSON.stringify(c))}v(b,c)}var A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W="4.6.0",X=a.TraceKit.noConflict(),Y=a.atatus,Z=[],$=!1,_=[],aa=[],ba=[],ca=!1,da=!1,ea=!1,fa=!0,ga=!1,ha="atatus-user",ia="atatus-aid",ja="https://bm-rx.atatus.com",ka="/track/browser/errors",la="/track/browser/perf/pageload",ma="/track/browser/perf/ajax",na="/track/browser/perf/session",oa="/track/browser/perf/spa",pa="/track/browser/perf/txn",qa="/track/browser/perf/webvitals",ra=4e4,sa=10,ta=500,ua=1e3,va=20,wa=5,xa=10,ya=100,za=100,Aa=3,Ba={error:0,ajax:0,session:0,txn:0,spa:0,webvitals:0},Ca=null,Da=["google-analytics.com","mixpanel.com","bam.nr-data.net","br-rx.atatus.com","bm-rx.atatus.com","segment.io","hotjar.io","hotjar.com","amplitude.com","fullstory.com","autopilothq.com","smartlook.com","charmerly.com","googleapis.com","logrocket.io","taboola.com","sentry.io","doubleclick.net","logentries.com","rb-collector.com","js.hs-banner.com","clarity.ms","lr-ingest.io","collector.replaybird.com"];c&&(V=c(b));var Ea={isBoolean:function(a){return"undefined"!=typeof a&&"boolean"==typeof a},isString:function(a){return"string"==typeof a},isNumber:function(a){return"number"==typeof a},isFunction:function(a){return"function"==typeof a},isArray:function(a){return"[object Array]"===Object.prototype.toString.call(a)},isObject:function(a){return"[object Object]"===Object.prototype.toString.call(a)},serialize:function(a){if(!a)return"";if(Ea.isString(a)||Ea.isNumber(a)||Ea.isBoolean(a)||Ea.isFunction(a))return""+a;if("object"==typeof a)try{return JSON.stringify(a)}catch(b){return"Unserializable Object"}return""},endsWith:function(a,b){return a&&b?-1!==a.indexOf(b,a.length-b.length):!1},joinRegExp:function(a){if(0===a.length)return null;for(var b,c=[],d=0,e=a.length;e>d;d++)b=a[d],Ea.isString(b)?c.push(b.replace(/([.*+?^=!:${}()|\[\]\/\\])/g,"\\$1")):b&&b.source&&c.push(b.source);return new RegExp(c.join("|"),"i")},getTargetUrl:function(b){return a.XDomainRequest&&ca&&(b=b.slice(6)),b},now:function(){return(new Date).getTime()},pad:function(a){return a=String(a),1===a.length&&(a="0"+a),a},merge:function(a,b){var c,d={};for(c in a)d[c]=a[c];for(c in b)d[c]=b[c];return d},mergeArray:function(a,b){return null!=b?a.concat(b):a},forEach:function(a,b){for(var c=0;c<a.length;c++)b.call(null,c,a[c])},isEmpty:function(a){for(var b in a)if(a.hasOwnProperty(b))return!1;return!0},getRandomInt:function(){return Math.floor(9007199254740992*Math.random())},log:function(b,c){$&&a.console&&a.console.log&&(a.console.log(b),c&&a.console.log(c))},bind:function(a,b){return function(){return a.apply(b,Array.prototype.slice.call(arguments))}},canAllowInsecureSubmissions:function(){var b=a.navigator.userAgent,c=b.match(/Trident\/([\d.]+)/),d=c&&"7.0"===c[1]?11:(b=b.match(/MSIE ([\d.]+)/))?parseInt(b[1],10):!1;return d&&9>=d},uuid4:function(){return"xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g,function(a){var b=16*Math.random()|0,c="x"===a?b:3&b|8;return c.toString(16)})},addEventListener:function(b,c,d){return"undefined"!=typeof a.attachEvent?a.attachEvent("on"+b,c):a.addEventListener?a.addEventListener(b,c,d):void 0},arrayFromObject:function(a){var b=[];for(var c in a)a.hasOwnProperty(c)&&b.push(a[c]);return b},createCookie:function(a,c,d,e,f){try{var g,h;if(d){var i=new Date;i.setTime(i.getTime()+60*d*60*1e3),g="; expires="+i.toGMTString()}else g="";var j=e?"; SameSite=Lax; secure":"; SameSite=Lax",k=/[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i,l="";if(f){var m=b.location.hostname.match(k),n=m?m[0]:"";l=n?"; domain=."+n:""}return h=(new Date).toISOString(),b.cookie=a+"=id|"+c+"&timestamp|"+h+g+"; path=/"+l+j,h}catch(o){Ea.log("Creating cookie failed.",o)}},clearCookie:function(a){this.createCookie(a,"",-1)},readCookieElement:function(a,b){var c=a.split(/[|&]/);return"id"===b?c[1]:"timestamp"===b?c[3]:void 0},readCookie:function(a){try{for(var c=a+"=",d=b.cookie.split(";"),e=0;e<d.length;e++){for(var f=d[e];" "===f.charAt(0);)f=f.substring(1,f.length);if(0===f.indexOf(c))return f.substring(c.length,f.length)}return null}catch(g){Ea.log("Reading cookie failed.",g)}}},Fa={eventObject:{},all:function(a){for(var b=this.getEventObject(a),c=[],d=0;d<b.length;d++)c.push(b[d].value);return c},clear:function(){for(var a in this.eventObject)this.eventObject.hasOwnProperty(a)&&(this.eventObject[a].length=0)},add:function(a,b){var c=this.getEventObject(a),d=Ea.uuid4();return b.m?b.m=b.m.length<=ta?b.m:b.m.substr(0,ta):b.e&&(b.e=b.e.length<=ta?b.e:b.e.substr(0,ta)),c.push({key:d,value:b}),this.truncateEventObject(a,sa),d},get:function(a,b){for(var c=this.getEventObject(a),d=0;d<c.length;d++)if(c[d].key===b)return c[d].value;return!1},getEventObject:function(a){return this.eventObject[a]||(this.eventObject[a]=[]),this.eventObject[a]},truncateEventObject:function(a,b){var c=this.getEventObject(a);c.length>b&&(this.eventObject[a]=c.slice(c.length-b))}},Ga={attach:function(b,c,d,e,f){b=b||a.console||{};for(var g=f||["log","debug","info","warn","error"],h=g.pop(),i=function(a,b,d){c&&Fa.add("timeline",{ts:Ea.now(),c:"console",l:a,m:Ea.serialize(b)}),"error"===a&&e&&Ia.notify(new Error(b),d)};h;)this.wrapConsoleMethod(b,h,d,i),h=g.pop()},wrapConsoleMethod:function(a,b,c,d){var e=a[b],f=a;b in a&&(a[b]=function(){var a=[].slice.call(arguments),g=""+a.join(" "),h={level:b,logger:"console"};d&&d(b,g,h),e&&c&&Function.prototype.apply.call(e,f,a)})}},Ha={attach:function(){var a=Ea.bind(this.onDocumentClicked,this),c=Ea.bind(this.onInputChanged,this);b.addEventListener?(b.addEventListener("click",a,!0),b.addEventListener("blur",c,!0)):b.attachEvent&&(b.attachEvent("onclick",a),b.attachEvent("onfocusout",c))},writeUserEvent:function(a,b,c,d){"password"===this.getElementType(a)&&(c=void 0),Fa.add("timeline",{ts:Ea.now(),a:b,e:this.getOuterHTML(a),v:this.getValueKind(c,d)})},onDocumentClicked:function(a){var b=this.getElementFromEvent(a);b&&b.tagName&&(this.isTarget(b,"a")||this.isTarget(b,"button")||this.isTarget(b,"input",["button","submit"])?this.writeUserEvent(b,"click"):this.isTarget(b,"input",["checkbox","radio"])&&this.writeUserEvent(b,"check",b.value,b.checked))},onInputChanged:function(a){var b=this.getElementFromEvent(a);b&&b.tagName&&(this.isTarget(b,"textarea")?this.writeUserEvent(b,"input",b.value):this.isTarget(b,"select")&&b.options&&b.options.length?this.onSelectInputChanged(b):this.isTarget(b,"input")&&!this.isTarget(b,"input",["button","submit","hidden","checkbox","radio"])&&this.writeUserEvent(b,"input",b.value))},onSelectInputChanged:function(a){if(a.multiple){for(var b=0;b<a.options.length;b++)if(a.options[b].selected){this.writeUserEvent(a,"select",a.options[b].value);break}}else 0<=a.selectedIndex&&a.options[a.selectedIndex]&&this.writeUserEvent(a,"select",a.options[a.selectedIndex].value)},getElementFromEvent:function(a){return a.target||b.elementFromPoint(a.clientX,a.clientY)},isTarget:function(a,b,c){if(a.tagName.toLowerCase()!==b.toLowerCase())return!1;if(!c)return!0;for(var d=this.getElementType(a),e=0;e<c.length;e++)if(c[e]===d)return!0;return!1},getElementType:function(a){return(a.getAttribute("type")||"").toLowerCase()},getOuterHTML:function(a){for(var b="<"+a.tagName.toLowerCase(),c=a.attributes,d=0,e=c.length;e>d;d++){var f=c[d].name;"value"!==f.toLowerCase()&&(b+=" "+f+'="'+c[d].value+'"')}return b+=" >"},getValueKind:function(a,b){return null==a?null:{length:a.length,checked:b,pattern:this.matchInputPattern(a)}},matchInputPattern:function(a){return""===a?"empty":/^[a-z0-9!#$%&'*+=?\^_`{|}~\-]+(?:\.[a-z0-9!#$%&'*+=?\^_`{|}~\-]+)*@(?:[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?$/.test(a)?"email":/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(a)||/^(\d{4}[\/\-](0?[1-9]|1[012])[\/\-]0?[1-9]|[12][0-9]|3[01])$/.test(a)?"date":/^(?:(?:\+?1\s*(?:[.\-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.\-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.\-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(a)?"phone":/^\s*$/.test(a)?"whitespace":/^\d*$/.test(a)?"numeric":"character"},getAllEvents:function(){return Fa.all("timeline")}},Ia={VERSION:W,paintPerformance:{},noConflict:function(){return a.atatus=Y,Ia},isConfigured:function(){return!!A},config:function(b,c){c=c||{},A=b,X.remoteFetching=!1,N=[],Ia.setCustomData(c.customData),Ia.setTags(c.tags),$=!!c.debugMode,ea=!!c.reportAjaxErrors,fa=c.reportUnhandledRejections===d?!0:!!c.reportUnhandledRejections,ga=!!c.allowChromeExtension,F=!!c.disableBreadcrumbs,G=!!c.disableErrorTracking,L=!!c.disableRUM,I=!!c.disableAjaxMonitoring,J=c.disableSession===d?!1:c.disableSession,K=c.disableSPA===d?!1:c.disableSPA,U=c.urlMaxLength,ca=Ea.canAllowInsecureSubmissions(),Ia.setIgnoreUrls(c.ignoreUrls),Ia.setWhitelistUrls(c.whitelistUrls),Ia.setAllowedDomains(c.allowedDomains),Ia.setVersion(c.version),Ia.enableOffline(c.enableOffline||c.offline),Ia.onBeforeSend(c.beforeSend),Ia.onBeforeErrorSend(c.beforeErrorSend),Ia.setGroupingKeyCallback(c.groupingKeyCallback),c.ignoreErrors&&Ea.isArray(c.ignoreErrors)&&(N=c.ignoreErrors),N.push(/^Script error\.?$/),N.push(/^Javascript error: Script error\.? on line 0$/),N=Ea.joinRegExp(N),q(),M={enabled:!1,timeline:!0,display:!0,error:!0,levels:null},Ea.isBoolean(c.console)&&(M.enabled=c.console),Ea.isBoolean(c.consoleTimeline)&&(M.timeline=c.consoleTimeline),Ea.isBoolean(c.consoleDisplay)&&(M.display=c.consoleDisplay),Ea.isBoolean(c.consoleErrorNotify)&&(M.error=c.consoleErrorNotify),Ea.isArray(c.consoleTimelineLevels)&&(M.levels=c.consoleTimelineLevels),M.enabled&&"console"in a&&a.console.log&&Ga.attach(a.console,M.timeline,M.display,M.error,M.levels),Ia.setHashRoutes(c.hashRoutes);var e=a.navigator.connection||a.navigator.mozConnection||a.navigator.webkitConnection;return e&&(Ca={},Ca.dlk=e.downlink,Ca.eft=e.effectiveType,Ca.rtt=e.rtt,Ca.type=e.type),Ia},install:function(){if(!m())return Ia;if(!ga&&-1!==b.location.href.indexOf("chrome-extension://"))return Ia;if(g(),F||Ha.attach(),G||(X.report.subscribe(r),X.extendToAsynchronousCallbacks(),V&&ea&&V.ajaxError(i),fa&&k()),I||L||Ia.__attachAjaxHooks(),!J&&!L&&Ia.SessionTracking){var c=function(){T=new Ia.SessionTracking,T.attach()};a.addEventListener?a.addEventListener("load",c):a.attachEvent("onload",c)}return K||L||!Ia.spa||Ia.spa.init({logLevel:$?"debug":"warn",urlMaxLength:U}),Ia},uninstall:function(){return A=null,G||(X.report.unsubscribe(r),V&&ea&&V.unbind("ajaxError",i),fa&&l()),Ia},setCustomData:function(a){return a?Ea.isObject(a)?B=a:Ea.log("Custom data must be an object."):B=null,Ia},setTags:function(a){return a?Ea.isArray(a)?Z=a:Ea.log("Tags must be an array of string."):Z=[],Ia},setHashRoutes:function(a){return a?(P=function(a){if(a&&a.request&&a.request.url&&(a.request.url=a.request.url.replace("/#/","/").replace("#/","/")),a&&a.data&&a.data[0]&&a.data[0].spans)for(var b=0;b<a.data.length;b++)a.data[b].n=(a.data[b].n||"").replace("/#/","/").replace("#","");
	
	if(a&&a.slowestRoutes&&a.slowestRoutes[0])for(var c=0;c<a.slowestRoutes.length;c++)a.slowestRoutes[c].n=(a.slowestRoutes[c].n||"").replace("/#/","/").replace("#","")},Ia):(P=null,Ia)},setIgnoreUrls:function(a){return a&&Ea.isArray(a)?Array.prototype.push.apply(a,Da):a=Da,aa=Ea.joinRegExp(a),Ia},getIgnoreUrls:function(){return aa},setWhitelistUrls:function(a){return a&&Ea.isArray(a)&&(ba=Ea.joinRegExp(a)),Ia},getWhitelistUrls:function(){return ba},setAllowedDomains:function(a){return a&&Ea.isArray(a)&&(_=Ea.joinRegExp(a)),Ia},getAllowedDomains:function(){return _},setUser:function(a,b,c,d){return f(a,b,c,d),Ia},resetUser:function(){return e(),Ia},setVersion:function(a){return a&&(E=""+a),Ia},enableOffline:function(a){return Ea.isBoolean(a)&&(da=a),Ia},onBeforeSend:function(a){return Ea.isFunction(a)&&(R=a),Ia},onBeforeErrorSend:function(a){return Ea.isFunction(a)&&(S=a),Ia},setGroupingKeyCallback:function(a){return Ea.isFunction(a)&&(Q=a),Ia},setAPIEndpoint:function(a){return ja=a,Ia},getAPIEndpoint:function(){return ja},init:function(a,b,c){return c&&(b=b||{},b.customData=c),Ia.config(a,b)},withCustomData:function(a){return Ia.setCustomData(a)},withTags:function(a){return Ia.setTags(a)},attach:function(){return Ia.install()},detach:function(){return Ia.uninstall()},endSession:function(){return T&&T.endSession(),Ia},_setFeatures:function(a){Ea.isObject(a)&&(I=!!a.daj,J=!!a.dss,K=!!a.dspa,L=!!a.drum,G=!!a.derror,H=!!a.dtxn,a.error&&Ea.log("Error in sending data to Atatus",a.error))},measureRoute:function(a){return T&&a&&T.virtualPageLoaded(a),Ia},leaveBreadcrumb:function(a,b){return a?(Fa.add("timeline",{ts:Ea.now(),c:"breadcrumb",l:b||"info",m:Ea.serialize(a)}),Ia):void 0},notify:function(a,b,c){return"string"==typeof a?void Ea.log("atatus.notify() was called with a string. Expected instance of Error."):Ia.send(a,b,c)},sendPerf:function(a){return L?void Ea.log("RUM is disabled."):t(la,a)},sendAjaxPerf:function(a){return L||I?void Ea.log("AJAX monitoring is disabled."):t(ma,a)},sendSessionPerf:function(a){return L||J?void Ea.log("Session Tracking is disabled."):t(na,a)},sendSPAPerf:function(a){return L||K?void Ea.log("SPA Tracking is disabled."):t(oa,a)},sendTxnPerf:function(a){return L||H?void Ea.log("Transaction monitoring is disabled."):t(pa,a)},sendWebVitals:function(a){return L?void Ea.log("Web vitals is disabled."):t(qa,a)},send:function(a,b,c){try{r(X.computeStackTrace(a),{customData:b,tags:c})}catch(d){if(a!==d)throw d}return Ia},_isAllowedUrl:function(a){return a=a||"",aa&&aa.test&&aa.test(a)?!1:ba&&ba.test?ba.test(a)?!0:!1:_&&_.test?_.test(a)?!0:!1:!0},_helper:Ea};a.atatus=Ia, true?(module.exports=Ia,"undefined"!=typeof global&&(global.atatus=Ia)):"function"==typeof define&&define.amd&&("object"==typeof require&&require.load?define(function(){return Ia}):define("atatus",function(){return Ia}))}(window,document,window.jQuery),function(a,b,c,d){function e(a){a.pl<=0||(a.nt=a.nt>0?a.nt:0,a.dp=a.dp>0?a.dp:0,a.pr=a.pr>0?a.pr:0,c.sendPerf(a))}function f(b,c){return"object"==typeof a.performance&&(!b||b&&typeof a.performance[b]===c)}function g(b){if(!f("getEntriesByName","function"))return b;var d=a.performance.getEntriesByName("first-paint");d.length>0&&d[0].startTime>0?b.fp=+d[0].startTime.toFixed(0):a.performance.timing&&a.performance.timing.msFirstPaint&&(b.fp=+(a.performance.timing.msFirstPaint-a.performance.timing.fetchStart).toFixed(0));var e=a.performance.getEntriesByName("first-contentful-paint");return e.length>0&&e[0].startTime>0&&(b.fcp=+e[0].startTime.toFixed(0)),c.paintPerformance={fp:b.fp,fcp:b.fcp},b}function h(){var b=a.performance||a.mozPerformance||a.msPerformance||a.webkitPerformance,c=b.timing;if(0===c.loadEventEnd)return!1;clearInterval(l),l=null;var d=c.navigationStart;0>=d&&(d=c.fetchStart);var f={};for(var h in m)f[m[h]]=-1,h in c&&(c[h]<=0||(f[m[h]]=c[h]-d));var i={nt:f.rps-f.ns,dp:f.dce-f.rps,pr:f.le-f.dce,pl:f.le-f.ns,timing:f};try{g(i)}catch(j){}e(i)}function i(){if(!k||!k.bDone)return!1;clearInterval(l),l=!1;var a=k.getMeasures();if(null!=a&&null!=a.backend&&null!=a.frontend&&null!=a["page load time"]&&null!=a["total load time"]){var b=a.backend,c=a.backend+a.frontend,d={nt:b,dp:c-b,pr:a["total load time"]-c,fe:a["total load time"]-b,pl:a["total load time"]};e(d)}}var j=(new Date).getTime(),k=k||{};k.q=k.q||[],k.version="0.3",k.targetOrigin=b.location.protocol+"//"+b.location.hostname,k.bPostMessage=!1,k.beaconUrl=k.beaconUrl||"/images/beacon.gif",k.autorun=!1,k.init=function(){if(k.bDone=!1,k.bUnloaded=!1,k.marks={},k.measures={},k.starts={},k.findStartTime(),k.addEventListener("beforeunload",k.beforeUnload,!1),k.addEventListener("pagehide",k.beforeUnload,!1),k.addEventListener("unload",k.beforeUnload,!1),k.processQ(),"complete"===b.readyState){var c=a.performance||a.mozPerformance||a.msPerformance||a.webkitPerformance;c&&"undefined"!=typeof c.timing&&"undefined"!=typeof c.timing.loadEventEnd&&(k.mark("firstbyte",c.timing.responseStart),k.mark("onload",c.timing.loadEventEnd)),k.done()}else k.addEventListener("load",k.onload,!1)},k.processQ=function(){for(var a=k.q.length,b=0;a>b;b++){var c=k.q[b],d=c[0];"mark"===d?k.mark(c[1],c[2]):"measure"===d?k.measure(c[1],c[2],c[3]):"done"===d&&k.done(c[1])}},k.mark=function(b,c){return k.dprint("RUM_EPISODES.mark: "+b+", "+c),b?(k.marks[b]=parseInt(c||(new Date).getTime()),k.bPostMessage&&a.postMessage("RUM_EPISODES:mark:"+b+":"+c,k.targetOrigin),void("firstbyte"===b?k.measure("backend","starttime","firstbyte"):"onload"===b?(k.measure("frontend","firstbyte","onload"),k.measure("page load time","starttime","onload")):"done"===b&&k.measure("total load time","starttime","done"))):void k.dprint("Error: markName is undefined in RUM_EPISODES.mark.")},k.measure=function(b,c,d){if(k.dprint("RUM_EPISODES.measure: "+b+", "+c+", "+d),!b)return void k.dprint("Error: episodeName is undefined in RUM_EPISODES.measure.");var e;if("undefined"==typeof c)e="number"==typeof k.marks[b]?k.marks[b]:(new Date).getTime();else if("number"==typeof k.marks[c])e=k.marks[c];else{if("number"!=typeof c)return void k.dprint("Error: unexpected startNameOrTime in RUM_EPISODES.measure: "+c);e=c}var f;if("undefined"==typeof d)f=(new Date).getTime();else if("number"==typeof k.marks[d])f=k.marks[d];else{if("number"!=typeof d)return void k.dprint("Error: unexpected endNameOrTime in RUM_EPISODES.measure: "+d);f=d}k.starts[b]=parseInt(e),k.measures[b]=parseInt(f-e),k.bPostMessage&&a.postMessage("RUM_EPISODES:measure:"+b+":"+e+":"+f,k.targetOrigin)},k.done=function(b){k.bDone=!0,k.mark("done"),k.bPostMessage&&a.postMessage("RUM_EPISODES:done",k.targetOrigin),"function"==typeof b&&b()},k.getMarks=function(){return k.marks},k.getMeasures=function(){return k.measures},k.getStarts=function(){return k.starts},k.findStartTime=function(){var a=k.findStartWebTiming()||k.findStartCookie();a&&k.mark("starttime",a)},k.findStartWebTiming=function(){var b,c=a.performance||a.mozPerformance||a.msPerformance||a.webkitPerformance;return c&&"undefined"!=typeof c.timing&&"undefined"!=typeof c.timing.navigationStart&&(b=c.timing.navigationStart,k.dprint("RUM_EPISODES.findStartWebTiming: startTime = "+b)),b},k.findStartCookie=function(){try{for(var c=b.cookie.split(" "),e=0;e<c.length;e++)if(0===c[e].indexOf("RUM_EPISODES=")){for(var f,g,h=c[e].substring("RUM_EPISODES=".length).split("&"),i=0;i<h.length;i++)if(0===h[i].indexOf("s="))f=h[i].substring(2);else if(0===h[i].indexOf("r=")){var j=h[i].substring(2);j=j.replace(/;$/,""),g=a.escape(b.referrer)===j}if(g&&f)return k.dprint("RUM_EPISODES.findStartCookie: startTime = "+f),f}}catch(l){}return d},k.beforeUnload=function(){try{if(k.bUnloaded)return;b.cookie="RUM_EPISODES=s="+Number(new Date)+"&r="+a.escape(b.location)+"; path=/",k.bUnloaded=!0}catch(c){}},k.onload=function(){k.mark("onload"),k.done()},k.addEventListener=function(b,c,d){return"undefined"!=typeof a.attachEvent?a.attachEvent("on"+b,c):a.addEventListener?a.addEventListener(b,c,d):void 0},k.dprint=function(){},k.init();var l=null,m={navigationStart:"ns",redirectStart:"rds",redirectEnd:"rde",unloadEventStart:"us",unloadEventEnd:"ue",fetchStart:"fs",domainLookupStart:"dls",domainLookupEnd:"dle",connectStart:"cs",secureConnectionStart:"scs",connectEnd:"ce",handshakeStart:"hs",requestStart:"rqs",responseStart:"rps",responseEnd:"rpe",domLoading:"dl",domInteractive:"di",domContentLoadedEventStart:"dcs",domContentLoadedEventEnd:"dce",domComplete:"dc",loadEventStart:"ls",loadEventEnd:"le"},n=a.performance||a.mozPerformance||a.msPerformance||a.webkitPerformance;n&&"undefined"!=typeof n.timing&&"undefined"!=typeof n.navigation?l=setInterval(h,100):(k.mark("firstbyte",j),l=setInterval(i,100))}(window,document,window.atatus),function(a,b,c){b.SessionTracking=function(){function d(a){b.sessionId=p.uuid4(),q.existingTimestamp=p.createCookie(q.cookieName,b.sessionId),a(!0)}function e(){var a;if(q.existingTimestamp){var b=new Date(new Date-s);a=q.existingTimestamp<b}a&&(q.stopSession=!0)}function f(a){return Math.min(a,3e5)}function g(a){for(var b in a)isNaN(a[b])&&"string"!=typeof a[b]?a[b]=0:a[b]<0&&(a[b]=0);return a}function h(b,c){var d;return d="object"==typeof a.performance&&"function"==typeof a.performance.now?a.performance.now():0,{du:Math.min(q.maxVirtualPageDuration,d-(b||c)),o:Math.min(q.maxVirtualPageDuration,d-c)}}function i(a){var c={du:a.loadEventEnd-a.navigationStart,s:a.fetchStart};return a.domainLookupStart&&a.domainLookupStart>0&&(c.dls=a.domainLookupStart-a.fetchStart),a.domainLookupEnd&&a.domainLookupEnd>0&&(c.dle=a.domainLookupEnd-a.fetchStart),a.connectStart&&a.connectStart>0&&(c.cs=a.connectStart-a.fetchStart),a.connectEnd&&a.connectEnd>0&&(c.ce=a.connectEnd-a.fetchStart),a.responseStart&&a.responseStart>0&&(c.rps=a.responseStart-a.fetchStart),a.responseEnd&&a.responseEnd>0&&(c.rpe=a.responseEnd-a.fetchStart),a.domLoading&&a.domLoading>0&&(c.dl=a.domLoading-a.fetchStart),a.domInteractive&&a.domInteractive>0&&(c.di=a.domInteractive-a.fetchStart),a.domContentLoadedEventEnd&&a.domContentLoadedEventEnd>0&&(c.dce=a.domContentLoadedEventEnd-a.fetchStart),a.domComplete&&a.domComplete>0&&(c.dc=f(a.domComplete-a.fetchStart)),a.loadEventStart&&a.loadEventStart>0&&(c.ls=a.loadEventStart-a.fetchStart),a.loadEventEnd&&a.loadEventEnd>0&&(c.le=a.loadEventEnd-a.fetchStart),a.secureConnectionStart&&a.secureConnectionStart>0&&(c.scs=a.secureConnectionStart-a.connectStart-a.fetchStart,c.scs=c.scs>0?c.scs:0),c=g(c),b.paintPerformance&&b.paintPerformance.fp&&(c.fp=b.paintPerformance.fp,c.fcp=b.paintPerformance.fcp),c}function j(a,b){var c={du:f(a.duration),s:b+a.fetchStart};return a.domainLookupStart&&a.domainLookupStart>0&&(c.dls=a.domainLookupStart-a.fetchStart),a.domainLookupEnd&&a.domainLookupEnd>0&&(c.dle=a.domainLookupEnd-a.fetchStart),a.connectStart&&a.connectStart>0&&(c.cs=a.connectStart-a.fetchStart),a.connectEnd&&a.connectEnd>0&&(c.ce=a.connectEnd-a.fetchStart),a.responseStart&&a.responseStart>0&&(c.rps=a.responseStart-a.fetchStart),a.responseEnd&&a.responseEnd>0&&(c.rpe=a.responseEnd-a.fetchStart),a.secureConnectionStart&&a.secureConnectionStart>0&&(c.scs=a.secureConnectionStart-a.connectStart-a.fetchStart,c.scs=c.scs>0?c.scs:0),c=g(c)}function k(){var b=a.location.pathname,c=a.location.protocol+"//"+a.location.host+b;return c.length>800&&(c=c.substring(0,800)),{u:c,t:i(a.performance.timing),g:"p"}}function l(b,c,d){var e=a.location.protocol+"//"+a.location.host+b;return e.length>800&&(e=e.substring(0,800)),{u:e,t:h(c,d),g:"r"}}function m(b,c){var d=b.name.split("?")[0];return d.length>800&&(d=d.substring(0,800)),{u:d,t:j(b,c?0:a.performance.timing.navigationStart),g:"xmlhttprequest"===b.initiatorType||"fetch"===b.initiatorType?"x":"s",z:b.decodedBodySize||b.transferSize||0}}function n(b,d){if(a.performance!==c&&a.performance.getEntriesByType)try{for(var e=a.performance.getEntriesByType("resource"),f=q.offset;f<e.length;f++){var g=e[f].name.split("?")[0];0!==g.indexOf(q.atatusHost)&&(g.indexOf("favicon.ico")>0||0!==g.indexOf("about:blank")&&("j"!==g[0]||1!==g.indexOf("avascript:"))&&0!==g.indexOf("chrome-extension://")&&0!==g.indexOf("res://")&&0!==g.indexOf("file://")&&e[f].name&&b.push(m(e[f],d)))}q.offset=e.length}catch(h){}}function o(b,d,e,f){if(a.performance===c||a.performance.timing===c||a.performance.timing.fetchStart===c||isNaN(a.performance.timing.fetchStart))return null;var g=[{rs:[]}];if(d&&(e&&(f?g[0].p=k():g[0].rs.push(k())),n(g[0].rs)),b){q.pendingVirtualPage&&(g[0].r=q.pendingVirtualPage);var h=null==q.pendingVirtualPage;if(q.pendingVirtualPage=l(b,q.previousVirtualPageLoadTimestamp,q.initalStaticPageLoadTimestamp),!h&&g.length>0)return g}return g}var p=b._helper,q=this,r={};b.sessionId=null,this.cookieName="atatus-sid",this.virtualPage=null,this.heartBeatInterval=null,this.offset=0,this.atatusHost=b.getAPIEndpoint(),this.maxVirtualPageDuration=18e5;var s=3e5;this.existingTimestamp=null,this.stopSession=!1,this.sendSessionPayload=function(a){q.stopSession||b.sendSessionPerf(a)},this.sendSPAPayload=function(){},this.attach=function(){d(function(a){setTimeout(function(){q.pageLoaded(a)},5e3)});var b=function(){var a=[{rs:[]}];if(n(a[0].rs),a[0].rs.length>0){var b={data:a};q.sendSessionPayload(b)}},c=function(){this.watchCookieTimestamp()}.bind(r),e=function(){"visible"===document.visibilityState&&this.watchCookieTimestamp()}.bind(r);a.addEventListener?(a.addEventListener("click",c),document.addEventListener("visibilitychange",e),a.addEventListener("beforeunload",b)):a.attachEvent&&document.attachEvent("onclick",c)},this.pageLoaded=function(b){q.sendPerformance(!0,!0,b),q.heartBeat(),q.initalStaticPageLoadTimestamp="object"==typeof a.performance&&"function"==typeof a.performance.now?a.performance.now():0},this.endSession=function(){q.stopSession=!0,p.createCookie(q.cookieName,b.sessionId,-1)},this.heartBeat=function(){q.heartBeatInterval=setInterval(function(){var a=[{rs:[]}];if(n(a[0].rs,q.virtualPage),a[0].rs.length>0){var b={data:a};q.sendSessionPayload(b)}},3e4)},this.virtualPageLoaded=function(b){var c=null==this.virtualPage;"string"==typeof b&&(b.length>0&&"/"!==b[0]&&(b+="/"),b.length>800&&(b=b.substring(0,800)),this.virtualPage=b),c?this.sendPerformance(!0,!1,!1):this.sendPerformance(!1,!1,!1),"string"==typeof b&&(this.previousVirtualPageLoadTimestamp="object"==typeof a.performance&&"function"==typeof a.performance.now?a.performance.now():0)},this.sendPerformance=function(a,b,c){var d=o(this.virtualPage,a,b,c);if(d){var e={data:d};d[0].r?q.sendSPAPayload(e):d[0].rs.length>0&&q.sendSessionPayload(e)}},r.watchCookieTimestamp=e}}(window,window.atatus),function(a,b,c){c.__attachAjaxHooks=function(){var d=c._helper,e={queue:[],batchSize:25,processing:!1,bUnloaded:!1,push:function(a){"string"==typeof a.url&&(a.url.indexOf(".html")>0||-1===a.url.indexOf("://")||!c._isAllowedUrl(a.url)||(this.queue.push(a),this.queue.length>=this.batchSize&&this._processQueue()))},_processQueue:function(){if(!this.processing&&this.queue.length){this.processing=!0;try{for(var a={},b={},e=0;e<this.queue.length;e++){var f,g=this.queue[e],h=g.status;if(400>h){f=g.method+g.url;var i=g.respAvailTime-g.sendTime,j=g.respProcTime-g.respAvailTime,k=g.receivedSize?+g.receivedSize:0,l=g.sendSize?+g.sendSize:0;0>i&&(i=0),0>j&&(j=0),isNaN(k)&&(k=0),isNaN(l)&&(l=0);var m=a[f];m?(m.rt.push(i),m.ct.push(j),m.rz.push(k),m.sz.push(l),m.ts.push(g.sendTime||(new Date).getTime())):a[f]={m:g.method,u:g.url,rt:[i],ct:[j],rz:[k],sz:[l],ts:[g.sendTime||(new Date).getTime()]}}else{f=g.method+h+g.url;var n=b[f];n&&n.sc?n.sc[h]?n.sc[h]++:n.sc[h]=1:(b[f]={m:g.method,u:g.url,sc:{}},b[f].sc[h]=1)}}var o={xhr:d.arrayFromObject(a),xhrError:d.arrayFromObject(b)};c.sendAjaxPerf(o)}catch(p){d.log("Error while processing queue: ",p)}finally{this.queue=[],this.processing=!1}}},beforeUnload:function(){e.bUnloaded||(e._processQueue(),e.bUnloaded=!0)}};d.addEventListener("beforeunload",e.beforeUnload,!1),setInterval(function(){e._processQueue()},3e4);var f={support:function(a){return!a||"apply"in a},around:function(a,b,c,e){return a=a||function(){},function(){var f,g=Array.prototype.slice.call(arguments);try{b&&(f=b.apply(this,g))}catch(h){d.log(e,h)}var i;try{i=a.apply(this,f||g)}finally{try{c&&c.apply(this,g)}catch(h){d.log(e,h)}}return i}},before:function(a,b){return f.around(a,b)},after:function(a,b){return f.around(a,null,b)},timeout:function(a){setTimeout(a,0)},wrapAddEventListener:function(){return function(a,b){if(("load"===a||"error"===a)&&b&&this._atrumXhrData){var c;b.__atrumInterceptor?c=b.__atrumInterceptor:f.support(b)?(c=h.wrapXHR(b,this,"XHR.invokeEventListener"),b.__atrumInterceptor=c):c=null;var d;return c&&(d=Array.prototype.slice.call(arguments),d[1]=c),d}}},wrapRemoveEventListener:function(){return function(a,b){if(this._atrumXhrData){var c=Array.prototype.slice.call(arguments);return b.__atrumInterceptor&&(c[1]=b.__atrumInterceptor),c}}},aroundWithHandleEvent:function(a,b,c,d){var e=a;return a&&"object"==typeof a&&"toString"in a&&"[xpconnect wrapped nsIDOMEventListener]"===a.toString()&&"handleEvent"in a&&(e=function(){a.handleEvent.apply(this,Array.prototype.slice.call(arguments))}),f.around(e,b,c,d)},getFullyQualifiedUrl:function(a){var c=b.createElement("a");return c.href=a,c.href}};if(a.XMLHttpRequest&&a.XMLHttpRequest.prototype){var g=a.XMLHttpRequest.prototype;if(!("open"in g&&"send"in g))return;if(!f.support(g.open)||!f.support(g.send))return;var h={};h.captureAjaxTimings=function(a){var b=a._atrumXhrData;if(b){var c=(new Date).getTime();2===a.readyState?b.firstByteTime=b.firstByteTime||c:4===a.readyState&&(b.respAvailTime=b.respAvailTime||c,b.firstByteTime=b.firstByteTime||c)}},h.sendPayload=function(a,b){b.receivedSize=0,a.responseType&&"text"!==a.responseType||"string"==typeof a.responseText&&(b.receivedSize=a.responseText.length),b.status=a.status,e.push(b)},h.wrapXHR=function(a,b,c){return f.aroundWithHandleEvent(a,function(){h.captureAjaxTimings(this)},function(){var a=b._atrumXhrData;if(a&&4===b.readyState){var c=(new Date).getTime();a.respProcTime=a.respProcTime||c,h.sendPayload(b,a),delete b._atrumXhrData}},c)},h.ajaxDone=function(a){if(a._atrumXhrData){var b=(new Date).getTime()+15e4,c=function(){h.captureAjaxTimings(a);var d=a._atrumXhrData;if(d){var e=(new Date).getTime();4===a.readyState?(d.respProcTime=d.respProcTime||e,h.sendPayload(a,d),delete a._atrumXhrData):b>e?setTimeout(c,50):delete a._atrumXhrData}};c()}},g.open=f.around(g.open,function(){var a=1<=arguments.length?String(arguments[0]):"",b=2<=arguments.length?String(arguments[1]):"";b=f.getFullyQualifiedUrl(b);var d=c._isAllowedUrl(b);d&&(b=b&&b.split("?")[0],this._atrumXhrData={method:a,url:b,sendTime:null,sendSize:null,firstByteTime:null,respAvailTime:null,respProcTime:null,receivedSize:null,parentPhase:null})},null,"XHR.open"),g.send=f.around(g.send,function(){var a=this,b=a._atrumXhrData;if(b){var c=(new Date).getTime();if(b.sendTime=b.sendTime||c,b.sendSize=1<=arguments.length&&arguments[0]?arguments[0].length||0:0,a.onreadystatechange&&"function"==typeof a.onreadystatechange){var d=0,e=function(){if(4===a.readyState)h.ajaxDone(a);else{var b=null;try{b=a.onreadystatechange}catch(c){return void h.ajaxDone(a)}d++,b?f.support(b)?a.onreadystatechange=h.wrapXHR(b,a,"XHR.onReadyStateChange"):h.ajaxDone(a):5>d?f.timeout(e):h.ajaxDone(a)}};e()}else a.addEventListener("readystatechange",function(){4===a.readyState&&h.ajaxDone(a)})}},null,"XHR.send"),"addEventListener"in g&&"removeEventListener"in g&&f.support(g.addEventListener)&&f.support(g.removeEventListener)&&(g.addEventListener=f.around(g.addEventListener,f.wrapAddEventListener(),null,"XHR.addEventListener"),g.removeEventListener=f.around(g.removeEventListener,f.wrapRemoveEventListener(),null,"XHR.removeEventListener"))}if("fetch"in a&&!a.fetch.polyfill){var i=a.fetch;a.fetch=function(a){return function(){for(var b=new Array(arguments.length),d=0;d<b.length;++d)b[d]=arguments[d];var f=b[0]&&b[0].method||b[1]&&b[1].method||"GET",g="Unknown URL";"string"==typeof b[0]?g=b[0]:b[0]&&b[0].url&&(g=b[0].url);var h=0;b[1]&&"string"==typeof b[1].body&&(h=b[1].body.length);var i={url:g,method:f,sendSize:h,receivedSize:0,sendTime:(new Date).getTime(),respAvailTime:0,respProcTime:0};return a.apply(this,b).then(function(a){return i.respAvailTime=(new Date).getTime(),c._isAllowedUrl(i.url)&&(i.respProcTime=i.respAvailTime,i.status=a.status,a.headers&&a.headers.get&&(i.receivedSize=a.headers.get("Content-Length")),e.push(i)),a})}}(i)}}}(window,document,window.atatus),function(a,b){function c(a,c,d){if(!(0>=c)){var e={data:[{t:{n:a,s:d,t:{du:c}}}]};b.sendTxnPerf(e)}}function d(a){return i+" "+a}function e(){try{return"localStorage"in a&&null!==a.localStorage}catch(b){return!1}}function f(a){var b=j.now();try{localStorage.setItem(d(a),b)}catch(c){}}function g(a){var b=null,c=d(a);try{b=localStorage.getItem(c),localStorage.removeItem(c)}catch(e){}var f=0;return b&&(f=j.now()-b),f}function h(a){try{var b=d(a);localStorage.removeItem(b)}catch(c){}}var i="atatus.com/",j=b._helper,k=1,l=0;b.beginTransaction=function(a){e()&&f(a)},b.endTransaction=function(a){if(e()){var b=g(a);c(a,b,k)}},b.failTransaction=function(a){if(e()){var b=g(a);c(a,b,l)}},b.cancelTransaction=function(a){e()&&h(a)},b.recordTransaction=function(a,b,d){e()&&a&&b&&c(a,b,d===!1?l:k)}}(window,window.atatus),function(a,b){function c(a){a=a||{};var b=a.name&&a.name.toLowerCase();b&&a.value&&(e[b]||f++,e[b]=a.value)}function d(){if(a.webVitals){a.webVitals.getFID(c),a.webVitals.getFCP(c),a.webVitals.getTTFB(c),a.webVitals.getCLS(c,!0),a.webVitals.getLCP(c,!0);var b=a.performance&&a.performance.timing;!e.ttfb&&b&&(e.ttfb=b.responseStart-b.navigationStart,e.ttfb&&f++)}}var e={},f=0,g=!1,h=function(){!g&&f>0&&(g=!0,b.sendWebVitals(e))};"loading"!==document.readyState?d():document.addEventListener("DOMContentLoaded",function(){d()}),a.addEventListener("beforeunload",function(){h()})}(window,window.atatus),function(a,b){a._atatusConfig&&a._atatusConfig.apikey&&b.config(a._atatusConfig.apikey,a._atatusConfig).install()}(window,window.atatus))}();
	!function(n){var r={};function i(t){if(r[t])return r[t].exports;var e=r[t]={i:t,l:!1,exports:{}};return n[t].call(e.exports,e,e.exports,i),e.l=!0,e.exports}i.m=n,i.c=r,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(e,t){if(1&t&&(e=i(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)i.d(n,r,function(t){return e[t]}.bind(null,r));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="",i(i.s=2)}([function(t,e,n){t.exports=function(){"use strict";function c(t){return"function"==typeof t}var n=Array.isArray?Array.isArray:function(t){return"[object Array]"===Object.prototype.toString.call(t)},r=0,e=void 0,i=void 0,a=function(t,e){h[r]=t,h[r+1]=e,2===(r+=2)&&(i?i(v):y())},t="undefined"!=typeof window?window:void 0,o=t||{},s=o.MutationObserver||o.WebKitMutationObserver,u="undefined"==typeof self&&"undefined"!=typeof process&&"[object process]"==={}.toString.call(process),d="undefined"!=typeof Uint8ClampedArray&&"undefined"!=typeof importScripts&&"undefined"!=typeof MessageChannel;function f(){var t=setTimeout;return function(){return t(v,1)}}var h=new Array(1e3);function v(){for(var t=0;t<r;t+=2){var e=h[t],n=h[t+1];e(n),h[t]=void 0,h[t+1]=void 0}r=0}var l,p,g,m,y=void 0;function _(t,e){var n=this,r=new this.constructor(T);void 0===r[w]&&j(r);var i=n._state;if(i){var o=arguments[i-1];a(function(){return F(i,r,o,n._result)})}else A(n,r,t,e);return r}function S(t){if(t&&"object"==typeof t&&t.constructor===this)return t;var e=new this(T);return I(e,t),e}y=u?function(){return process.nextTick(v)}:s?(p=0,g=new s(v),m=document.createTextNode(""),g.observe(m,{characterData:!0}),function(){m.data=p=++p%2}):d?((l=new MessageChannel).port1.onmessage=v,function(){return l.port2.postMessage(0)}):void 0===t?function(){try{var t=Function("return this")().require("vertx");return void 0===(e=t.runOnLoop||t.runOnContext)?f():function(){e(v)}}catch(t){return f()}}():f();var w=Math.random().toString(36).substring(2);function T(){}var b=void 0,x=1,L=2;function C(t,e,n,r){try{t.call(e,n,r)}catch(t){return t}}function E(t,e,n){var r,i,o,s;e.constructor===t.constructor&&n===_&&e.constructor.resolve===S?(o=t,(s=e)._state===x?O(o,s._result):s._state===L?R(o,s._result):A(s,void 0,function(t){return I(o,t)},function(t){return R(o,t)})):void 0===n?O(t,e):c(n)?(r=e,i=n,a(function(e){var n=!1,t=C(i,r,function(t){n||(n=!0,r!==t?I(e,t):O(e,t))},function(t){n||(n=!0,R(e,t))},e._label);!n&&t&&(n=!0,R(e,t))},t)):O(t,e)}function I(e,t){if(e===t)R(e,new TypeError("You cannot resolve a promise with itself"));else if(i=typeof(r=t),null===r||"object"!==i&&"function"!==i)O(e,t);else{var n=void 0;try{n=t.then}catch(t){return void R(e,t)}E(e,t,n)}var r,i}function k(t){t._onerror&&t._onerror(t._result),P(t)}function O(t,e){t._state===b&&(t._result=e,t._state=x,0!==t._subscribers.length&&a(P,t))}function R(t,e){t._state===b&&(t._state=L,t._result=e,a(k,t))}function A(t,e,n,r){var i=t._subscribers,o=i.length;t._onerror=null,i[o]=e,i[o+x]=n,i[o+L]=r,0===o&&t._state&&a(P,t)}function P(t){var e=t._subscribers,n=t._state;if(0!==e.length){for(var r=void 0,i=void 0,o=t._result,s=0;s<e.length;s+=3)r=e[s],i=e[s+n],r?F(n,r,i,o):i(o);t._subscribers.length=0}}function F(t,e,n,r){var i=c(n),o=void 0,s=void 0,a=!0;if(i){try{o=n(r)}catch(t){a=!1,s=t}if(e===o)return void R(e,new TypeError("A promises callback cannot return that same promise."))}else o=r;e._state!==b||(i&&a?I(e,o):!1===a?R(e,s):t===x?O(e,o):t===L&&R(e,o))}var M=0;function j(t){t[w]=M++,t._state=void 0,t._result=void 0,t._subscribers=[]}var q=function(){function t(t,e){this._instanceConstructor=t,this.promise=new t(T),this.promise[w]||j(this.promise),n(e)?(this.length=e.length,this._remaining=e.length,this._result=new Array(this.length),0===this.length?O(this.promise,this._result):(this.length=this.length||0,this._enumerate(e),0===this._remaining&&O(this.promise,this._result))):R(this.promise,new Error("Array Methods must be provided an Array"))}return t.prototype._enumerate=function(t){for(var e=0;this._state===b&&e<t.length;e++)this._eachEntry(t[e],e)},t.prototype._eachEntry=function(e,t){var n=this._instanceConstructor,r=n.resolve;if(r===S){var i=void 0,o=void 0,s=!1;try{i=e.then}catch(t){s=!0,o=t}if(i===_&&e._state!==b)this._settledAt(e._state,t,e._result);else if("function"!=typeof i)this._remaining--,this._result[t]=e;else if(n===N){var a=new n(T);s?R(a,o):E(a,e,i),this._willSettleAt(a,t)}else this._willSettleAt(new n(function(t){return t(e)}),t)}else this._willSettleAt(r(e),t)},t.prototype._settledAt=function(t,e,n){var r=this.promise;r._state===b&&(this._remaining--,t===L?R(r,n):this._result[e]=n),0===this._remaining&&O(r,this._result)},t.prototype._willSettleAt=function(t,e){var n=this;A(t,void 0,function(t){return n._settledAt(x,e,t)},function(t){return n._settledAt(L,e,t)})},t}(),N=function(){function e(t){this[w]=M++,this._result=this._state=void 0,this._subscribers=[],T!==t&&("function"!=typeof t&&function(){throw new TypeError("You must pass a resolver function as the first argument to the promise constructor")}(),this instanceof e?function(e,t){try{t(function(t){I(e,t)},function(t){R(e,t)})}catch(t){R(e,t)}}(this,t):function(){throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.")}())}return e.prototype.catch=function(t){return this.then(null,t)},e.prototype.finally=function(e){var n=this.constructor;return c(e)?this.then(function(t){return n.resolve(e()).then(function(){return t})},function(t){return n.resolve(e()).then(function(){throw t})}):this.then(e,e)},e}();return N.prototype.then=_,N.all=function(t){return new q(this,t).promise},N.race=function(i){var o=this;return n(i)?new o(function(t,e){for(var n=i.length,r=0;r<n;r++)o.resolve(i[r]).then(t,e)}):new o(function(t,e){return e(new TypeError("You must pass an array to race."))})},N.resolve=S,N.reject=function(t){var e=new this(T);return R(e,t),e},N._setScheduler=function(t){i=t},N._setAsap=function(t){a=t},N._asap=a,N.polyfill=function(){var t=void 0;if("undefined"!=typeof global)t=global;else if("undefined"!=typeof self)t=self;else try{t=Function("return this")()}catch(t){throw new Error("polyfill failed because global object is unavailable in this environment")}var e=t.Promise;if(e){var n=null;try{n=Object.prototype.toString.call(e.resolve())}catch(t){}if("[object Promise]"===n&&!e.cast)return}t.Promise=N},N.Promise=N}()},function(t,e){var n="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(n){var r=new Uint8Array(16);t.exports=function(){return n(r),r}}else{var i=new Array(16);t.exports=function(){for(var t,e=0;e<16;e++)0==(3&e)&&(t=4294967296*Math.random()),i[e]=t>>>((3&e)<<3)&255;return i}}},function(t,e,n){"use strict";n.r(e);var r=n(1),o=n.n(r),i=[].slice;for(var s=[],a=0;a<256;++a)s[a]=(a+256).toString(16).substr(1);function c(t){if(t&&t.traceId&&t.id&&t.parentId){var e=t.sampled?"01":"00",n=t.sampled?t.id:t.parentId;return"00-"+t.traceId+"-"+n+"-"+e}}function l(e,t){var n=!1;return"string"==typeof t?n=e===t:Array.isArray(t)&&t.forEach(function(t){n||(n=l(e,t))}),n}function u(t){var e,n,r,i;return(e=o()(),r=n||0,[(i=s)[e[r++]],i[e[r++]],i[e[r++]],i[e[r++]],i[e[r++]],i[e[r++]],i[e[r++]],i[e[r++]],i[e[r++]],i[e[r++]],i[e[r++]],i[e[r++]],i[e[r++]],i[e[r++]],i[e[r++]],i[e[r++]]].join("")).substr(0,t)}function d(){return"undefined"!=typeof window&&"function"==typeof Array.prototype.forEach&&"function"==typeof JSON.stringify&&"function"==typeof Function.bind&&window.performance&&"function"==typeof window.performance.now&&"withCredentials"in new window.XMLHttpRequest}function f(t,e,n){if(n&&t){var r=w(t);return e&&(e=String(e)),n[r]=e,n}}var h=["fetchStart","domainLookupStart","domainLookupEnd","connectStart","connectEnd","secureConnectionStart","requestStart","responseStart","responseEnd","domLoading","domInteractive","domContentLoadedEventStart","domContentLoadedEventEnd","domComplete","loadEventStart","loadEventEnd"];function p(t){return t&&t.split("?")[0]}function v(t){return null!==t&&"object"==typeof t}function g(t,e,n){for(var r=0,i=e.length;r<i;++r){var o=e[r];if(v(o)||"function"==typeof o)for(var s=Object.keys(o),a=0,c=s.length;a<c;a++){var u=s[a],d=o[u];n&&v(d)?(v(t[u])||(t[u]=Array.isArray(d)?[]:{}),g(t[u],[d],!1)):t[u]=d}}return t}function m(t){return g(t,i.call(arguments,1),!1)}function y(t){return g(t,i.call(arguments,1),!0)}function _(t){return void 0===t}function S(){}function w(t){return t.replace(/[.*"]/g,"_")}function T(){var n,r,i,t=(n=window.performance.timing,r=n.fetchStart,i={},h.forEach(function(t){var e=n[t];e&&r<=e&&(i[t]=e-r)}),i),e=function(){var t={},e=window.performance;if(e.getEntriesByType){var n=e.getEntriesByType("paint");if(0<n.length)for(var r=e.timing,i=r.fetchStart-r.navigationStart,o=0;o<n.length;o++){var s=n[o],a=0<=i?s.startTime-i:s.startTime;t[s.name]=a}}return t}(),o={timeToFirstByte:t.responseStart,domInteractive:t.domInteractive,domComplete:t.domComplete};return e["first-contentful-paint"]&&(o.firstContentfulPaint=e["first-contentful-paint"]),{navigationTiming:t,agent:o}}var b={fetchInProgress:!1};function x(t){return"__apm_symbol__"+t}function L(t,e,n){for(var r=t;r&&!r.hasOwnProperty(e);)r=Object.getPrototypeOf(r);!r&&t[e]&&(r=t);var i,o,s,a,c=x(e);if(r&&!(i=r[c])){i=r[c]=r[e];var u=r&&Object.getOwnPropertyDescriptor(r,e);if(!(a=u)||!1!==a.writable&&("function"!=typeof a.get||void 0!==a.set)){var d=n(i,c,e);r[e]=function(){return d(this,arguments)},o=r[e],s=i,o[x("OriginalDelegate")]=s}}return i}var C=x("xhrIgnore"),E=x("xhrSync"),I=x("xhrURL"),k=x("xhrMethod"),O="schedule",R="invoke",A="clear",P="addEventListener",F="removeEventListener",M=["link","css","script","img","xmlhttprequest","fetch","beacon","iframe"],j=3e5,q="page-load",N="Unknown",H=60,Q=1024,D="transaction:end",B="config:change",z="xmlhttprequest",U="fetch",V="history",X="error",J=x("xhrTask"),Y=x("xhrListener"),$=x("xhrScheduled");function Z(s){var t=XMLHttpRequest.prototype,a=t[P],c=t[F];if(!a){var e=window.XMLHttpRequestEventTarget;if(e){var n=e.prototype;a=n[P],c=n[F]}}var u="readystatechange";function d(t){t.state=R,t.ignore||s(R,t)}var r=L(t,"open",function(){return function(t,e){return t[k]=e[0],t[I]=e[1],t[E]=!1===e[2],r.apply(t,e)}}),f=L(t,"send",function(){return function(t,e){var n={source:z,state:"",type:"macroTask",ignore:t[C],data:{target:t,method:t[k],sync:t[E],url:t[I],args:e,aborted:!1}},r=function(t){XMLHttpRequest[$]=!1,t.state=O,t.ignore||s(O,t);var e=t.data,n=e.target,r=n[Y];a||(a=n[P],c=n[F]),r&&c.call(n,u,r);var i=n[Y]=function(){n.readyState===n.DONE&&!e.aborted&&XMLHttpRequest[$]&&t.state===O&&d(t)};a.call(n,u,i),n[J]||(n[J]=t);var o=f.apply(n,e.args);return XMLHttpRequest[$]=!0,o}(n);return t[E]&&d(n),r}}),i=L(t,"abort",function(){return function(t,e){var n,r=t[J];if(r&&"string"==typeof r.type){if(r.data&&r.data.aborted)return;(n=r).state=A,s(A,n),n.data.aborted=!0}return i.apply(t,e)}})}var G=n(0);function K(a){if(window.fetch&&window.Request){var c=window.fetch;window.fetch=function(t,e){var i,n,o=this,r=arguments;if("string"==typeof t)i=new Request(t,e),n=t;else{if(!t)return c.apply(o,r);n=(i=t).url}var s={source:U,state:"",type:"macroTask",data:{target:i,method:i.method,sync:!1,url:n,args:r,aborted:!1}};return new G.Promise(function(e,n){var t,r;b.fetchInProgress=!0,(t=s).state=O,a(O,t);try{r=c.apply(o,[i])}catch(t){return n(t),s.data.error=t,u(s),void(b.fetchInProgress=!1)}r.then(function(t){e(t),G.Promise.resolve().then(function(){s.data.response=t,u(s)})},function(t){n(t),G.Promise.resolve().then(function(){s.data.error=t,u(s)})}),b.fetchInProgress=!1})}}function u(t){t.state=R,a(R,t)}}var W=function(){function t(){this.observers={}}var e=t.prototype;return e.observe=function(e,n){var r=this;if("function"==typeof n)return this.observers[e]||(this.observers[e]=[]),this.observers[e].push(n),function(){var t=r.observers[e].indexOf(n);-1<t&&r.observers[e].splice(t,1)}},e.sendOnly=function(t,e){var n=this.observers[t];n&&n.forEach(function(t){try{t.apply(void 0,e)}catch(t){console.log(t,t.stack)}})},e.send=function(t,e){this.sendOnly(t+":before",e),this.sendOnly(t,e),this.sendOnly(t+":after",e)},t}(),tt=new W,et=!1;function nt(){return et||(et=!0,Z(function(t,e){tt.send(z,[t,e])}),K(function(t,e){tt.send(U,[t,e])}),function(r){if(window.history){var i=history.pushState;"function"==typeof i&&(history.pushState=function(t,e,n){r(R,{source:V,data:{state:t,title:e,url:n}}),i.apply(this,arguments)})}}(function(t,e){tt.send(V,[t,e])})),tt}var rt=!1,it=!1;var ot=[["#","hash"],["?","query"],["/","path"],["@","auth",1],[NaN,"host",void 0,1]],st=/^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i,at=function(){function t(t){var e,n=this.extractProtocol(t||""),r=n.protocol,i=n.address,o=n.slashes,s=!r&&!o,a=this.getLocation(),c=ot.slice();i=i.replace("\\","/");for(var u=0;u<c.length;u++){var d=c[u],f=d[0],h=d[1];if("string"==typeof f){if(~(e=i.indexOf(f))){var v=d[2];if(v){var l=i.lastIndexOf(f);e=Math.max(e,l),this[h]=i.slice(0,e),i=i.slice(e+v)}else this[h]=i.slice(e),i=i.slice(0,e)}}else this[h]=i;this[h]=this[h]||s&&d[3]&&a[h]||"",d[3]&&(this[h]=this[h].toLowerCase())}this.relative=s,this.protocol=r||a.protocol||"",this.origin=this.protocol&&this.host&&"file:"!==this.protocol?this.protocol+"//"+this.host:"null",this.href=this.toString()}var e=t.prototype;return e.toString=function(){var t=this.protocol;if(t+="//",this.auth){var e="[REDACTED]",n=this.auth.split(":");t+=(n[0]?e:"")+(n[1]?":"+e:"")+"@"}return t+=this.host,t+=this.path,t+=this.query,t+=this.hash},e.getLocation=function(){var t={};return"undefined"!=typeof window&&(t=window),t.location},e.extractProtocol=function(t){var e=st.exec(t);return{protocol:e[1]?e[1].toLowerCase():"",slashes:!!e[2],address:e[3]}},t}(),ct={service:{name:[Q,!0],version:!0,agent:{version:[Q,!0]},environment:!0}},ut={"*":!0,headers:{"*":!0}},dt={user:{id:!0,email:!0,username:!0},tags:{"*":!0},http:{response:ut},response:ut},ft={name:[Q,!0],type:[Q,!0],id:[Q,!0],trace_id:[Q,!0],parent_id:[Q,!0],transaction_id:[Q,!0],subtype:!0,action:!0,context:dt},ht={name:!0,parent_id:!0,type:[Q,!0],id:[Q,!0],trace_id:[Q,!0],span_count:{started:[Q,!0]},context:dt};function vt(t){return null==t||""===t||void 0===t}function lt(t,e,n){var r,i,o,s,a=(r=t[e],i=n[0],o=n[1],void 0===i&&(i=Q),void 0===o&&(o=!1),void 0===s&&(s="N/A"),o&&vt(r)&&(r=s),"string"==typeof r?r.substring(0,i):r);vt(a)?delete t[e]:t[e]=a}function pt(r,i,o){void 0===r&&(r={}),void 0===o&&(o=i);for(var s=Object.keys(r),a=[],t=function(t){var e=s[t],n=!0===r[e]?a:r[e];Array.isArray(n)?"*"===e?Object.keys(o).forEach(function(t){return lt(o,t,n)}):lt(o,e,n):pt(n,i,o[e])},e=0;e<s.length;e++)t(e);return i}var gt=function(){function t(t,e,n,r){this._apmServer=t,this._configService=e,this._logginService=n,this._transactionService=r}var e=t.prototype;return e.init=function(t){var n=this;void 0===t&&(t={}),this._configService.events.observe(D+":after",function(t){var e=n.createTransactionPayload(t);e&&n._apmServer.addTransaction(e)}),t[V]&&tt.observe(V,this.getHistorySub()),t[z]&&tt.observe(z,this.getXHRSub()),t[U]&&tt.observe(U,this.getFetchSub())},e.getHistorySub=function(){var n=this._transactionService;return function(t,e){e.source===V&&t===R&&n.startTransaction(e.data.title,"route-change",{canReuse:!0})}},e.getXHRSub=function(){var n=this;return function(t,e){e.source!==z||b.fetchInProgress||n.processAPICalls(t,e)}},e.getFetchSub=function(){var n=this;return function(t,e){e.source===U&&n.processAPICalls(t,e)}},e.processAPICalls=function(t,e){var n=this._configService,r=this._transactionService,i=n.get("ignoreSpansForRoutes");if(t===O&&e.data){var o=new at(e.data.url);if(i&&i.test&&i.test(e.data.url))return;var s=e.data.method+" "+(o.relative?o.path:p(o.href)),a=r.startSpan(s,"external.http"),c=r.addTask();if(!a)return;var u=n.get("distributedTracing"),d=n.get("distributedTracingOrigins"),f=new at(window.location.href),h=l(o.origin,f.origin)||l(o.origin,d),v=e.data.target;u&&h&&v&&this.injectDtHeader(a,v),a.addContext({http:{method:e.data.method,url:o.href}}),a.sync=e.data.sync,e.data.span=a,e.id=c}t===R&&e.data&&e.data.span&&(void 0!==e.data.target.status?e.data.span.addContext({http:{status_code:e.data.target.status}}):e.data.response&&e.data.span.addContext({http:{status_code:e.data.response.status}}),e.data.span.end()),t===R&&e.id&&r.removeTask(e.id)},e.injectDtHeader=function(t,e){var n,r=this._configService,i=r.get("distributedTracingHeaderName"),o=r.get("distributedTracingHeaderValueCallback")(t),s=/^[\da-f]{2}-[\da-f]{32}-[\da-f]{16}-[\da-f]{2}$/.test(n=o)&&"00000000000000000000000000000000"!==n.slice(3,35)&&"0000000000000000"!==n.slice(36,52);i&&o&&s&&("function"==typeof e.setRequestHeader?e.setRequestHeader(i,o):e.headers&&"function"==typeof e.headers.append?e.headers.append(i,o):e[i]=o)},e.extractDtHeader=function(t){var e=this._configService.get("distributedTracingHeaderName");if(t)return function(t){var e=/^([\da-f]{2})-([\da-f]{32})-([\da-f]{16})-([\da-f]{2})$/.exec(t);if(e){var n="00"!==e[4];return{traceId:e[2],id:e[3],sampled:n}}}(t[e])},e.setTransactionContext=function(t){var e=this._configService.get("context");e&&t.addContext(e)},e.filterTransaction=function(t){var e=this._configService.get("transactionDurationThreshold"),n=t.duration();if(!n)return!1;if(e<n)return!1;if(0===t.spans.length)return!1;t.sampled||t.resetSpans();var r=this._configService.get("browserResponsivenessInterval");if(this._configService.get("checkBrowserResponsiveness")&&!t.isHardNavigation){var i=this._configService.get("browserResponsivenessBuffer");if(!this.checkBrowserResponsiveness(t,r,i))return!1}return!0},e.adjustTransactionTime=function(t){var e=t.spans,n=function(t){for(var e=t[0],n=1;n<t.length;n++){var r=t[n];e._start>r._start&&(e=r)}return e}(e);n&&n._start<t._start&&(t._start=n._start);var r=function(t){for(var e=null,n=0;n<t.length;n++){var r=t[n];-1===String(r.type).indexOf("external")&&(!e||e._end<r._end)&&(e=r)}return e}(e);r&&r._end>t._end&&(t._end=r._end);for(var i=t._end,o=0;o<e.length;o++){var s=e[o];s._end>i&&(s._end=i,s.type+=".truncated"),s._start>i&&(s._start=i)}},e.prepareTransaction=function(e){if(e.spans.sort(function(t,e){return t._start-e._start}),this._configService.get("groupSimilarSpans")){var t=this._configService.get("similarSpanThreshold");e.spans=this.groupSmallContinuouslySimilarSpans(e,t)}e.spans=e.spans.filter(function(t){return 0<t.duration()&&t._start>=e._start&&t._end<=e._end}),this.setTransactionContext(e)},e.createTransactionDataModel=function(n){var t=this._configService.get("context"),r=n._start,e=n.spans.map(function(t){var e={id:t.id,transaction_id:n.id,parent_id:t.parentId||n.id,trace_id:n.traceId,name:t.name,type:t.type,subType:t.subType,action:t.action,sync:t.sync,start:t._start-r,duration:t.duration(),context:t.context};return pt(ft,e)}),i=y({},t,n.context),o={id:n.id,trace_id:n.traceId,name:n.name,type:n.type,duration:n.duration(),spans:e,context:i,marks:n.marks,span_count:{started:e.length},sampled:n.sampled};return pt(ht,o)},e.createTransactionPayload=function(t){if(this.adjustTransactionTime(t),this.prepareTransaction(t),this.filterTransaction(t))return this.createTransactionDataModel(t)},e.convertTransactionsToServerModel=function(t){var e=this;return t.map(function(t){return e.createTransactionDataModel(t)})},e.groupSmallContinuouslySimilarSpans=function(o,s){var a=o.duration(),c=[],u=1;return o.spans.forEach(function(t,e){if(0===c.length)c.push(t);else{var n=c[c.length-1],r=n.type===t.type&&n.subType===t.subType&&n.action===t.action&&n.name===t.name&&t.duration()/a<s&&(t._start-n._end)/a<s,i=o.spans.length===e+1;r&&(u++,n._end=t._end),1<u&&(!r||i)&&(n.name=u+"x "+n.name,u=1),r||c.push(t)}}),c},e.checkBrowserResponsiveness=function(t,e,n){var r=t.browserResponsivenessCounter;if(void 0===e||void 0===r)return!0;var i=t.duration();return Math.floor(i/e)<=r+n},t}(),mt=function(){function t(t,e,n){void 0===n&&(n={}),t||(t=N),e||(e="custom"),this.options=n,this.name=t,this.type=e,this.id=this.options.id||u(16),this.traceId=this.options.traceId,this.sampled=this.options.sampled,this.timestamp=this.options.timestamp||Date.now(),this.ended=!1,this._start=window.performance.now(),this._end=void 0,this.onEnd=this.options.onEnd}var e=t.prototype;return e.ensureContext=function(){this.context||(this.context={})},e.addTags=function(t){console.warn("addTags deprecated, please use addLabels"),this.addLabels(t)},e.addLabels=function(e){this.ensureContext();var n=this.context;n.tags||(n.tags={}),Object.keys(e).forEach(function(t){return f(t,e[t],n.tags)})},e.addContext=function(t){t&&(this.ensureContext(),y(this.context,t))},e.end=function(){this.ended||(this.ended=!0,this._end=window.performance.now(),this.callOnEnd())},e.callOnEnd=function(){"function"==typeof this.onEnd&&this.onEnd(this)},e.duration=function(){if(_(this._end)||_(this._start))return null;var t=this._end-this._start;return parseFloat(t)},t}();var yt=function(o){var t,e;function n(t,e,n){var r;if((r=o.call(this,t,e,n)||this).parentId=r.options.parentId,r.subType=void 0,r.action=void 0,-1!==r.type.indexOf(".")){var i=r.type.split(".",3);r.type=i[0],r.subType=i[1],r.action=i[2]}return r.sync=r.options.sync,r}return e=o,(t=n).prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e,n}(mt);var _t=function(i){var t,e;function n(t,e,n){var r;return(r=i.call(this,t,e,n)||this).traceId=u(),r.marks=void 0,r.spans=[],r._activeSpans={},r.nextAutoTaskId=1,r._scheduledTasks=[],r.isHardNavigation=!1,r.sampled=Math.random()<=r.options.transactionSampleRate,r}e=i,(t=n).prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e;var r=n.prototype;return r.addMarks=function(t){this.marks=y(this.marks||{},t)},r.mark=function(t){var e=w(t),n=window.performance.now()-this._start,r={};r[e]=n,this.addMarks({custom:r})},r.canReuse=function(t){return void 0===t&&(t=5e3),!!this.options.canReuse&&!this.ended&&performance.now()-this._start<t},r.redefine=function(t,e,n){t&&(this.name=t),e&&(this.type=e),n&&(this.options=m(this.options,n))},r.startSpan=function(t,e,n){var r=this;if(!this.ended){var i=m({},n);i.onEnd=function(t){r._onSpanEnd(t)},i.traceId=this.traceId,i.sampled=this.sampled,i.parentId||(i.parentId=this.id);var o=new yt(t,e,i);return this._activeSpans[o.id]=o}},r.isFinished=function(){return 0===this._scheduledTasks.length},r.detectFinish=function(){this.isFinished()&&this.end()},r.end=function(){if(!this.ended){for(var t in this.ended=!0,this._end=window.performance.now(),this._activeSpans){var e=this._activeSpans[t];e.type=e.type+".truncated",e.end()}var n={page:{referer:document.referrer,url:window.location.href}};this.addContext(n),this.callOnEnd()}},r.addTask=function(t){if(void 0===t&&(t="task"+this.nextAutoTaskId++),-1==this._scheduledTasks.indexOf(t))return this._scheduledTasks.push(t),t},r.removeTask=function(t){var e=this._scheduledTasks.indexOf(t);-1<e&&this._scheduledTasks.splice(e,1),this.detectFinish()},r.resetSpans=function(){this.spans=[]},r._onSpanEnd=function(t){this.spans.push(t),delete this._activeSpans[t.id]},n}(mt),St=[["domainLookupStart","domainLookupEnd","Domain lookup"],["connectStart","connectEnd","Making a connection to the server"],["requestStart","responseEnd","Requesting and receiving the document"],["domLoading","domInteractive","Parsing the document, executing sync. scripts"],["domContentLoadedEventStart","domContentLoadedEventEnd",'Fire "DOMContentLoaded" event'],["loadEventStart","loadEventEnd",'Fire "load" event']];function wt(t,e,n,r){return"number"==typeof t&&"number"==typeof e&&n<=t&&t<e&&e-n<=r&&e-t<j&&t-n<j&&e-n<j}function Tt(t){var e={transfer_size:t.transferSize,encoded_body_size:t.encodedBodySize,decoded_body_size:t.decodedBodySize},n=function(t){void 0===t&&(t=[]);for(var e=[],n=0;n<t.length;n++){var r=t[n],i=r.name,o=r.duration,s=r.description,a=i;s&&(a+=";desc="+s),o&&(a+=";dur="+o),e.push(a)}return e.join(", ")}(t.serverTiming);return n&&(e.headers={"server-timing":n}),e}function bt(t){var e=t.name,n=t.initiatorType,r=t.startTime,i=t.responseEnd,o="resource";n&&(o+="."+n);var s=p(e),a=new yt(s,o);return a.addContext({http:{url:e,response:Tt(t)}}),a._start=r,a.end(),a._end=i,a}function xt(e){var t=window.performance;if(e.isHardNavigation&&t&&t.timing){var n=t.timing;if(e.marks&&e.marks.custom){var r=e.marks.custom;Object.keys(r).forEach(function(t){r[t]+=e._start})}e._start=0;var i=e._end;if(function(t,e,n){for(var r=[],i=0;i<St.length;i++){var o=t[St[i][0]],s=t[St[i][1]];if(wt(o,s,e,n)){var a=new yt(St[i][2],"hard-navigation.browser-timing");"requestStart"===St[i][0]&&(a.pageResponse=!0),a._start=o-e,a.ended=!0,a._end=s-e,r.push(a)}}return r}(n,n.fetchStart,i).forEach(function(t){t.traceId=e.traceId,t.sampled=e.sampled,t.pageResponse&&e.options.pageLoadSpanId&&(t.id=e.options.pageLoadSpanId),e.spans.push(t)}),"function"==typeof t.getEntriesByType){for(var o=t.getEntriesByType("resource"),s=[],a=0;a<e.spans;a++){var c=e.spans[a];"external"===c.type&&"http"===c.subType||s.push(c.name.split(" ")[1])}(function(t,e,n){for(var r=[],i=0;i<t.length;i++){var o=t[i],s=o.initiatorType,a=o.name,c=o.startTime,u=o.responseEnd;if("xmlhttprequest"!==s&&"fetch"!==s&&a)if(-1!==M.indexOf(s)){if(!wt(c,u,0,n))continue;r.push(bt(t[i]))}else{if(null!=s)continue;for(var d=!1,f=0;f<e.length;f++){var h=a.lastIndexOf(e[f]);if(-1<h&&h===a.length-e[f].length){d=!0;break}}!d&&wt(c,u,0,n)&&r.push(bt(t[i]))}}return r})(o,s,i).forEach(function(t){return e.spans.push(t)}),function(t,e){for(var n=[],r=0;r<t.length;r++){var i=t[r],o=i.name,s=i.startTime,a=i.duration,c=s+a;if(!(a<=H)&&wt(s,c,0,e)){var u=new yt(o,"app");u._start=s,u.end(),u._end=c,n.push(u)}}return n}(t.getEntriesByType("measure"),i).forEach(function(t){return e.spans.push(t)});var u=t.getEntriesByType("navigation");u&&0<u.length&&(u=u[0],e.addContext({response:Tt(u)}))}}}var Lt=function(){function t(t,e){this._config=e,this._logger=t,this.currentTransaction=void 0,this._alreadyCapturedPageLoad=!1}var e=t.prototype;return e.ensureCurrentTransaction=function(t){t||(t=this.createPerfOptions());var e=this.getCurrentTransaction();return e||(t.canReuse=!0,this.createTransaction(void 0,void 0,t))},e.getCurrentTransaction=function(){if(this.currentTransaction&&!this.currentTransaction.ended)return this.currentTransaction},e.setCurrentTransaction=function(t){this.currentTransaction=t},e.createTransaction=function(t,e,n){var r=new _t(t,e,n);return this.setCurrentTransaction(r),n.checkBrowserResponsiveness&&this.startCounter(r),r},e.startCounter=function(t){t.browserResponsivenessCounter=0;var e=this._config.get("browserResponsivenessInterval");if(void 0!==e)var n=setInterval(function(){t.ended?window.clearInterval(n):t.browserResponsivenessCounter++},e)},e.capturePageLoadMetrics=function(t){if(this._config.get("capturePageLoad")&&!this._alreadyCapturedPageLoad&&t.isHardNavigation)return xt(t),t.addMarks(T()),self._alreadyCapturedPageLoad=!0},e.createPerfOptions=function(t){var e=this._config.config;return m({pageLoadTraceId:e.pageLoadTraceId,pageLoadSampled:e.pageLoadSampled,pageLoadSpanId:e.pageLoadSpanId,pageLoadTransactionName:e.pageLoadTransactionName,transactionSampleRate:e.transactionSampleRate,checkBrowserResponsiveness:e.checkBrowserResponsiveness},t)},e.startTransaction=function(t,e,n){var r=this,i=this.createPerfOptions(n),o=this.getCurrentTransaction();return o?o.canReuse()&&i.canReuse?o.redefine(t,void 0,i):(o.end(),o=this.createTransaction(t,e,i)):o=this.createTransaction(t,e,i),e===q&&(o.isHardNavigation=!0,i.pageLoadTraceId&&(o.traceId=i.pageLoadTraceId),i.pageLoadSampled&&(o.sampled=i.pageLoadSampled),o.name===N&&i.pageLoadTransactionName&&(o.name=i.pageLoadTransactionName)),this._config.events.send("transaction:start",[o]),o.onEnd=function(){return G.Promise.resolve().then(function(){r.shouldIgnoreTransaction(o.name)||o.type===q||r.add(o)},function(t){0})},o},e.shouldIgnoreTransaction=function(t){var e=this._config.get("ignoreTransactions");if(e&&e.length)for(var n=0;n<e.length;n++){var r=e[n];if("function"==typeof r.test){if(r.test(t))return!0}else if(r===t)return!0}return!1},e.startSpan=function(t,e,n){var r=this.ensureCurrentTransaction();if(r)return r.startSpan(t,e,n)},e.add=function(t){this._config.events.send(D,[t])},e.addTask=function(t){var e=this.ensureCurrentTransaction();if(e){t=e.addTask(t);0}return t},e.removeTask=function(t){var e=this.getCurrentTransaction();e&&e.removeTask(t)},e.detectFinish=function(){var t=this.getCurrentTransaction();t&&t.detectFinish()},t}(),Ct=function(i){i.registerServiceCreator("TransactionService",function(){var t=i.getService("ConfigService"),e=i.getService("LoggingService");return new Lt(e,t)}),i.registerServiceCreator("PerformanceMonitoring",function(){var t=i.getService("ConfigService"),e=i.getService("LoggingService"),n=i.getService("ApmServer"),r=i.getService("TransactionService");return new gt(n,t,e,r)})},Et=function(){function t(t,e,n){e||(e={}),this.onFlush=t,this.routeDurationThreshold=e.routeDurationThreshold||500,this.queueLimit=e.queueLimit||-1,this.slowestTxnsQueueLimit=e.slowestTxnsQueueLimit||10,this.flushInterval=e.flushInterval||0,this.timeoutId=void 0,this.transactions={},this.slowestTxns=[],this.totalTrans=0,this.urlMaxLength=n.get("urlMaxLength")}var e=t.prototype;return e._setTimer=function(){var t=this;this.timeoutId=setTimeout(function(){t.flush()},this.flushInterval)},e.flush=function(){var t=Object.keys(this.transactions).map(function(t){var r=this.transactions[t],e={n:t,d:[r.duration.count,r.duration.total,r.duration.min,r.duration.max]};return e.spans=Object.keys(r.spans).map(function(t){var e=r.spans[t],n={};return n.n=t,n.t=e.type,n.d=[e.duration.count,e.duration.total,e.duration.min,e.duration.max],e.url&&e.method&&(n.u=e.url,n.m=e.method),n}),e},this),n=[];this.slowestTxns.forEach(function(t){var e=t.context&&t.context.page&&t.context.page.url;if(e){var r={n:e.slice(0,this.urlMaxLength),d:t.duration||0,spans:[]};t.spans=t.spans||[],t.spans.forEach(function(t){var e={n:t.name,d:t.duration,s:t.start,t:t.type};if("external"===t.type){var n=t.context&&t.context.http||{};if(window.atatus&&window.atatus._isAllowedUrl&&!window.atatus._isAllowedUrl(n.url||""))return;e.m=n.method,e.st=n.status_code,e.u=n.url.slice(0,this.urlMaxLength),e.t="ajax"}r.spans.push(e)}.bind(this)),n.push(r)}}.bind(this));var e={data:t,slowestRoutes:n};this.onFlush(e),this._clear()},e._clear=function(){void 0!==this.timeoutId&&(clearTimeout(this.timeoutId),this.timeoutId=void 0),this.transactions={},this.slowestTxns=[],this.totalTrans=0},e.addSlowestTxn=function(t){var e=this.slowestTxns.length;if(e<this.slowestTxnsQueueLimit)this.slowestTxns.push(t);else{var n=Math.floor(Math.random()*(e+2));n<this.slowestTxnsQueueLimit&&(this.slowestTxns[n]=t)}},e.add=function(t){var e=(t.context&&t.context.page&&t.context.page.url).split("?")[0];if(e&&(t.duration=t.duration||0,t.spans=t.spans||[],t.spans.length||!(4e3<t.duration))){var i=this.transactions[e]||{duration:{total:0,min:t.duration,max:t.duration,count:0},spans:{}};(this.transactions[e]=i).duration.total+=t.duration,i.duration.max=t.duration>=i.duration.max?t.duration:i.duration.max,i.duration.min=t.duration<i.duration.min?t.duration:i.duration.min,i.duration.count++,this.totalTrans++,t.spans.forEach(function(t){var e=t.name;if(e){var n=t.context&&t.context.http&&t.context.http.url||"";if(!window.atatus||!window.atatus._isAllowedUrl||window.atatus._isAllowedUrl(n)){t.duration=t.duration||0;var r=i.spans[e]||{duration:{total:0,min:t.duration,max:t.duration,count:0}};"external"===t.type?(r.method=t.context&&t.context.http&&t.context.http.method,r.url=n.split("?")[0],r.type="ajax"):r.type=t.type||"",r.duration.total+=t.duration,r.duration.max=t.duration>=r.duration.max?t.duration:r.duration.max,r.duration.min=t.duration<r.duration.min?t.duration:r.duration.min,r.duration.count++,i.spans[e]=r}}},this),t.duration>=this.routeDurationThreshold&&this.addSlowestTxn(t),-1!==this.queueLimit&&this.totalTrans>=this.queueLimit?this.flush():void 0===this.timeoutId&&this._setTimer()}},t}(),It=function(){function t(t,e){e||(e={}),this.onFlush=t,this.items=[],this.queueLimit=e.queueLimit||-1,this.flushInterval=e.flushInterval||0,this.timeoutId=void 0}var e=t.prototype;return e._setTimer=function(){var t=this;this.timeoutId=setTimeout(function(){t.flush()},this.flushInterval)},e.flush=function(){this.onFlush(this.items),this._clear()},e._clear=function(){void 0!==this.timeoutId&&(clearTimeout(this.timeoutId),this.timeoutId=void 0),this.items=[]},e.add=function(t){this.items.push(t),-1!==this.queueLimit&&this.items.length>=this.queueLimit?this.flush():void 0===this.timeoutId&&this._setTimer()},t}();var kt=function(e,n,t){var r,i=t.context||this,o=t.limit,s=t.interval,a=t.countFn||function(){},c=0;return function(){var t="function"==typeof a&&a.apply(i,arguments);return"number"!=typeof t&&(t=1),c+=t,void 0===r&&(r=setTimeout(function(){r=void(c=0)},s)),o<c?"function"==typeof n?n.apply(i,arguments):void 0:e.apply(i,arguments)}},Ot=function(){function t(){}return t.stringify=function(t){return JSON.stringify(t)+"\n"},t}(),Rt=function(){function t(t,e){this._configService=t,this._loggingService=e,this.errorQueue=void 0,this.transactionQueue=void 0,this.throttleAddError=void 0,this.throttleAddTransaction=void 0,this.initialized=!1,this.ndjsonSpan={}}var e=t.prototype;return e.init=function(){this.initialized||(this.initialized=!0,this.initErrorQueue(),this.initTransactionQueue())},e.createMetaData=function(){var t=this._configService,e={service:{name:t.get("serviceName"),version:t.get("serviceVersion"),agent:{name:"js-base",version:t.version},language:{name:"javascript"},environment:t.get("environment")}};return pt(ct,e)},e._postJson=function(t,e){return this._makeHttpRequest("POST",t,e,{"Content-Type":"application/x-ndjson"})},e._constructError=function(t){var e=t.url,n=t.status,r=(t.responseText,e+" HTTP status: "+n);return new Error(r)},e._makeHttpRequest=function(e,o,s,a){return new G.Promise(function(n,r){var i=new window.XMLHttpRequest;if(i[C]=!0,i.open(e,o,!0),i.timeout=1e4,a)for(var t in a)a.hasOwnProperty(t)&&i.setRequestHeader(t,a[t]);i.onreadystatechange=function(){if(4===i.readyState){var t=i.status,e=i.responseText;0===t||399<t&&t<600?r({url:o,status:t,responseText:e}):n(e)}},i.onerror=function(){var t=i.status,e=i.responseText;r({url:o,status:t,responseText:e})},i.send(s)})},e._createQueue=function(t){var e=this._configService.get("queueLimit"),n=this._configService.get("flushInterval");return new It(t,{queueLimit:e,flushInterval:n})},e._createTransactionQueue=function(t){var e=this._configService.get("queueLimit"),n=this._configService.get("flushInterval");return new Et(t,{queueLimit:e,flushInterval:n},this._configService)},e.initErrorQueue=function(){var n=this;this.errorQueue&&this.errorQueue.flush(),this.errorQueue=this._createQueue(function(t){var e=n.sendErrors(t);e&&e.catch(function(t){n._loggingService.warn("Failed sending errors!",n._constructError(t))})});var t=this._configService.get("errorThrottleLimit"),e=this._configService.get("errorThrottleInterval");this.throttleAddError=kt(this.errorQueue.add.bind(this.errorQueue),function(){return n._loggingService.warn("Dropped error due to throttling!")},{limit:t,interval:e})},e.initTransactionQueue=function(){var n=this;this.transactionQueue&&this.transactionQueue.flush(),this.transactionQueue=this._createTransactionQueue(function(t){var e=n.sendTransactions(t);e&&e.catch(function(t){n._loggingService.warn("Failed sending transactions!",n._constructError(t))})});var t=this._configService.get("transactionThrottleLimit"),e=this._configService.get("transactionThrottleInterval");this.throttleAddTransaction=kt(this.transactionQueue.add.bind(this.transactionQueue),function(){return n._loggingService.warn("Dropped transaction due to throttling!")},{limit:t,interval:e})},e.addError=function(t){this.errorQueue||this.initErrorQueue(),this.throttleAddError(t)},e.addTransaction=function(t){this.transactionQueue||this.initTransactionQueue(),this.throttleAddTransaction(t)},e.ndjsonErrors=function(t){return t.map(function(t){return Ot.stringify({error:t})})},e.ndjsonTransactions=function(t){var n=this.ndjsonSpan;return t.map(function(t){var e="";return t.spans&&(e=t.spans.map(function(t){return n.span=t,Ot.stringify(n)}).join(""),delete t.spans),Ot.stringify({transaction:t})+e})},e._send=function(t,e){if(void 0===t&&(t=[]),void 0===e&&(e="transaction"),0!==t.length){var n={service:this.createMetaData().service,data:t},r=this._configService.applyFilters(n);if(r){var i,o=this._configService.getEndpointUrl();if("errors"===e)i=this.ndjsonErrors(r.data);else{if("transaction"!==e)return void 0;i=this.ndjsonTransactions(r.data)}i.unshift(Ot.stringify({metadata:{service:r.service}}));var s=i.join("");return this._postJson(o,s)}this._loggingService.warn("Dropped payload due to filtering!")}},e.sendTransactions=function(t){window.atatus.sendSPAPerf(t)},e.sendErrors=function(t){},t}();var At=function(){function t(){this.config={},this.defaults={serviceName:"",serviceVersion:"",environment:"",serverUrl:"https://br-rx.atatus.com",serverUrlPrefix:"/browser/track",active:!0,instrument:!0,disableInstrumentations:[X,q],debug:!1,logLevel:"warn",browserResponsivenessInterval:500,browserResponsivenessBuffer:3,checkBrowserResponsiveness:!0,groupSimilarSpans:!0,similarSpanThreshold:.05,capturePageLoad:!0,ignoreTransactions:[],errorThrottleLimit:20,errorThrottleInterval:3e4,transactionThrottleLimit:20,transactionThrottleInterval:3e4,transactionDurationThreshold:6e4,queueLimit:-1,flushInterval:3e4,sendPageLoadTransaction:!0,distributedTracing:!0,distributedTracingOrigins:[],distributedTracingHeaderValueCallback:c,distributedTracingHeaderName:"atatus-apm-traceparent",pageLoadTraceId:"",pageLoadSpanId:"",pageLoadSampled:!1,pageLoadTransactionName:"",transactionSampleRate:1,context:{},urlMaxLength:250,ignoreSpansForRoutes:null},this.events=new W,this.filters=[],this.version=""}var e=t.prototype;return e.init=function(){this.setConfig({})},e.isActive=function(){return this.get("active")},e.setVersion=function(t){this.version=t},e.setIgnoreSpansForRoutes=function(t){this.config.ignoreSpansForRoutes=t},e.addFilter=function(t){if("function"!=typeof t)throw new Error("Argument to must be function");this.filters.push(t)},e.applyFilters=function(t){for(var e=0;e<this.filters.length;e++)if(!(t=this.filters[e](t)))return;return t},e.get=function(t){return t.split(".").reduce(function(t,e){return t&&t[e]},this.config)},e.getEndpointUrl=function(){return this.config.serverUrl+this.config.serverUrlPrefix},e.set=function(t,e){for(var n=t.split("."),r=n.length-1,i=this.config,o=0;o<r+1;o++){var s=n[o];if(s)if(o===r)i[s]=e;else{var a=i[s]||{};i[s]=a,i=a}}},e.setUserContext=function(t){void 0===t&&(t={});var e={},n=t,r=n.id,i=n.username,o=n.email;"number"!=typeof r&&"string"!=typeof r||(e.id=r),"string"==typeof i&&(e.username=i),"string"==typeof o&&(e.email=o),this.set("context.user",e)},e.setCustomContext=function(t){t&&"object"==typeof t&&this.set("context.custom",t)},e.addLabels=function(e){var n=this;this.config.context.tags||(this.config.context.tags={}),Object.keys(e).forEach(function(t){return f(t,e[t],n.config.context.tags)})},e.setConfig=function(t){void 0===t&&(t={}),this.config=y({},this.defaults,this.config,t),this.config.urlMaxLength=this.config.urlMaxLength||250,this.events.send(B,[this.config])},e.validate=function(e){void 0===e&&(e={});var n=["serviceName","serverUrl"],r={missing:[],invalid:[]};return Object.keys(e).forEach(function(t){-1===n.indexOf(t)||e[t]||r.missing.push(t)}),e.serviceName&&!/^[a-zA-Z0-9 _-]+$/.test(e.serviceName)&&r.invalid.push({key:"serviceName",value:e.serviceName,allowed:"a-z, A-Z, 0-9, _, -, <space>"}),r},t}(),Pt=function(){function t(t){t||(t={}),this.levels=["trace","debug","info","warn","error"],this.level=t.level||"info",this.prefix=t.prefix||"",this.resetLogMethods()}var e=t.prototype;return e.shouldLog=function(t){return this.levels.indexOf(t)>=this.levels.indexOf(this.level)},e.setLevel=function(t){this.level=t,this.resetLogMethods()},e.resetLogMethods=function(){var o=this;this.levels.forEach(function(i){o[i]=o.shouldLog(i)?function(){var t,e=o.prefix;switch(i){case"trace":case"debug":t="info";break;default:t=i}var n=arguments;e&&("function"==typeof e&&(e=e(i)),n[0]=e+n[0]);if(console){var r=console[t]?console[t]:console.log;"function"==typeof r&&r.apply(console,n)}}:S})},t}(),Ft=function(){function t(){this._serviceCreators={},this._serviceInstances={},this.initialized=!1}var e=t.prototype;return e.registerCoreServices=function(){var t=this;this.registerServiceCreator("ConfigService",function(){return new At}),this.registerServiceCreator("LoggingService",function(){return new Pt}),this.registerServiceCreator("ApmServer",function(){return new Rt(t.getService("ConfigService"),t.getService("LoggingService"))})},e.init=function(){if(!this.initialized){this.initialized=!0;var t=this.getService("ConfigService");t.init();var e=this.getService("LoggingService");n(e,t),t.events.observe(B,function(){n(e,t)}),this.getService("ApmServer").init()}function n(t,e){var n=e.get("debug"),r=e.get("logLevel");!0===n&&"trace"!==r?t.setLevel("debug"):t.setLevel(r)}},e.registerServiceCreator=function(t,e){this._serviceCreators[t]=e},e.registerServiceInstance=function(t,e){this._serviceInstances[t]=e},e.getService=function(t){if(!this._serviceInstances[t]){if("function"!=typeof this._serviceCreators[t])throw new Error("Can not get service, No creator for: "+t);this._serviceInstances[t]=this._serviceCreators[t](this)}return this._serviceInstances[t]},t}();var Mt=function(){function t(t,e){this._disable=e,this.serviceFactory=t,this._initialized=!1}var e=t.prototype;return e.init=function(t){if(this.isEnabled()&&!this._initialized){this._initialized=!0;var e=this.serviceFactory.getService("ConfigService");e.setVersion("4.0.2"),this.config(t);var n=this.serviceFactory.getService("LoggingService");if(!e.isActive())return n.info("Atatus agent is inactive"),this;this.serviceFactory.init();var r=(i=e.get("instrument"),o=e.get("disableInstrumentations"),(s={})[z]=!1,s[U]=!1,s[V]=!1,s[q]=!1,s[X]=!1,a=s,i&&Object.keys(a).forEach(function(t){-1===o.indexOf(t)&&(a[t]=!0)}),a);if(this.serviceFactory.getService("PerformanceMonitoring").init(r),r[X])this.serviceFactory.getService("ErrorLogging").registerGlobalEventListener();r[q]&&e.get("sendPageLoadTransaction")&&this._sendPageLoadMetrics()}var i,o,s,a;return this},e._sendPageLoadMetrics=function(){var t=this.serviceFactory.getService("TransactionService").startTransaction(void 0,q,{canReuse:!0});t&&t.addTask(q);var e=function(){setTimeout(function(){t&&t.removeTask(q)})};"complete"===document.readyState?e():window.addEventListener("load",e)},e.isEnabled=function(){return!this._disable},e.observe=function(t,e){this.serviceFactory.getService("ConfigService").events.observe(t,e)},e.config=function(t){var e=this.serviceFactory.getService("ConfigService"),n=e.validate(t),r=n.missing,o=n.invalid;if(0===r.length&&0===o.length)e.setConfig(t);else{var i=this.serviceFactory.getService("LoggingService"),s="RUM Agent isn't correctly configured: ";0<r.length&&(s+="Missing config - "+r.join(", "),0<o.length&&(s+=", ")),o.forEach(function(t,e){var n=t.key,r=t.value,i=t.allowed;s+=n+' "'+r+'" contains invalid characters! (allowed: '+i+")"+(e!==o.length-1?", ":"")}),i.error(s),e.setConfig({active:!1})}},e.setIgnoreSpansForRoutes=function(t){this.serviceFactory.getService("ConfigService").setIgnoreSpansForRoutes(t)},e.setUserContext=function(t){this.serviceFactory.getService("ConfigService").setUserContext(t)},e.setCustomContext=function(t){this.serviceFactory.getService("ConfigService").setCustomContext(t)},e.addTags=function(t){this.serviceFactory.getService("LoggingService").warn("addTags deprecated, please use addLabels"),this.addLabels(t)},e.addLabels=function(t){this.serviceFactory.getService("ConfigService").addLabels(t)},e.setInitialPageLoadName=function(t){this.isEnabled()&&this.serviceFactory.getService("ConfigService").setConfig({pageLoadTransactionName:t})},e.startTransaction=function(t,e,n){if(this.isEnabled())return this.serviceFactory.getService("TransactionService").startTransaction(t,e,n)},e.startSpan=function(t,e){if(this.isEnabled())return this.serviceFactory.getService("TransactionService").startSpan(t,e)},e.getCurrentTransaction=function(){if(this.isEnabled())return this.serviceFactory.getService("TransactionService").getCurrentTransaction()},e.getTransactionService=function(){if(this.isEnabled())return this.serviceFactory.getService("TransactionService")},e.addFilter=function(t){this.serviceFactory.getService("ConfigService").addFilter(t)},t}();n.d(e,"init",function(){return Qt}),n.d(e,"apmBase",function(){return Ht}),n.d(e,"apm",function(){return Ht}),n.d(e,"ApmBase",function(){return Mt});var jt,qt=(rt||(rt=!0,d()?(nt(),it=!0):"undefined"!=typeof window&&console.log("APM: Platform is not supported!")),it),Nt=((jt=new Ft).registerCoreServices(),Ct(jt),jt),Ht=new Mt(Nt,!qt);"undefined"!=typeof window&&window.atatus&&(window.atatus.spa=Ht,window.atatus.VERSION&&(window.atatus.VERSION+="-spa"));var Qt=Ht.init.bind(Ht);e.default=Qt}]);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(59)))

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return (root['Autolinker'] = factory());
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    root['Autolinker'] = factory();
	  }
	}(this, function () {
	
	/*!
	 * Autolinker.js
	 * 0.19.1
	 *
	 * Copyright(c) 2015 Gregory Jacobs <greg@greg-jacobs.com>
	 * MIT
	 *
	 * https://github.com/gregjacobs/Autolinker.js
	 */
	/**
	 * @class Autolinker
	 * @extends Object
	 *
	 * Utility class used to process a given string of text, and wrap the matches in
	 * the appropriate anchor (&lt;a&gt;) tags to turn them into links.
	 *
	 * Any of the configuration options may be provided in an Object (map) provided
	 * to the Autolinker constructor, which will configure how the {@link #link link()}
	 * method will process the links.
	 *
	 * For example:
	 *
	 *     var autolinker = new Autolinker( {
	 *         newWindow : false,
	 *         truncate  : 30
	 *     } );
	 *
	 *     var html = autolinker.link( "Joe went to www.yahoo.com" );
	 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
	 *
	 *
	 * The {@link #static-link static link()} method may also be used to inline options into a single call, which may
	 * be more convenient for one-off uses. For example:
	 *
	 *     var html = Autolinker.link( "Joe went to www.yahoo.com", {
	 *         newWindow : false,
	 *         truncate  : 30
	 *     } );
	 *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
	 *
	 *
	 * ## Custom Replacements of Links
	 *
	 * If the configuration options do not provide enough flexibility, a {@link #replaceFn}
	 * may be provided to fully customize the output of Autolinker. This function is
	 * called once for each URL/Email/Phone#/Twitter Handle/Hashtag match that is
	 * encountered.
	 *
	 * For example:
	 *
	 *     var input = "...";  // string with URLs, Email Addresses, Phone #s, Twitter Handles, and Hashtags
	 *
	 *     var linkedText = Autolinker.link( input, {
	 *         replaceFn : function( autolinker, match ) {
	 *             console.log( "href = ", match.getAnchorHref() );
	 *             console.log( "text = ", match.getAnchorText() );
	 *
	 *             switch( match.getType() ) {
	 *                 case 'url' :
	 *                     console.log( "url: ", match.getUrl() );
	 *
	 *                     if( match.getUrl().indexOf( 'mysite.com' ) === -1 ) {
	 *                         var tag = autolinker.getTagBuilder().build( match );  // returns an `Autolinker.HtmlTag` instance, which provides mutator methods for easy changes
	 *                         tag.setAttr( 'rel', 'nofollow' );
	 *                         tag.addClass( 'external-link' );
	 *
	 *                         return tag;
	 *
	 *                     } else {
	 *                         return true;  // let Autolinker perform its normal anchor tag replacement
	 *                     }
	 *
	 *                 case 'email' :
	 *                     var email = match.getEmail();
	 *                     console.log( "email: ", email );
	 *
	 *                     if( email === "my@own.address" ) {
	 *                         return false;  // don't auto-link this particular email address; leave as-is
	 *                     } else {
	 *                         return;  // no return value will have Autolinker perform its normal anchor tag replacement (same as returning `true`)
	 *                     }
	 *
	 *                 case 'phone' :
	 *                     var phoneNumber = match.getPhoneNumber();
	 *                     console.log( phoneNumber );
	 *
	 *                     return '<a href="http://newplace.to.link.phone.numbers.to/">' + phoneNumber + '</a>';
	 *
	 *                 case 'twitter' :
	 *                     var twitterHandle = match.getTwitterHandle();
	 *                     console.log( twitterHandle );
	 *
	 *                     return '<a href="http://newplace.to.link.twitter.handles.to/">' + twitterHandle + '</a>';
	 *
	 *                 case 'hashtag' :
	 *                     var hashtag = match.getHashtag();
	 *                     console.log( hashtag );
	 *
	 *                     return '<a href="http://newplace.to.link.hashtag.handles.to/">' + hashtag + '</a>';
	 *             }
	 *         }
	 *     } );
	 *
	 *
	 * The function may return the following values:
	 *
	 * - `true` (Boolean): Allow Autolinker to replace the match as it normally would.
	 * - `false` (Boolean): Do not replace the current match at all - leave as-is.
	 * - Any String: If a string is returned from the function, the string will be used directly as the replacement HTML for
	 *   the match.
	 * - An {@link Autolinker.HtmlTag} instance, which can be used to build/modify an HTML tag before writing out its HTML text.
	 *
	 * @constructor
	 * @param {Object} [config] The configuration options for the Autolinker instance, specified in an Object (map).
	 */
	var Autolinker = function( cfg ) {
		Autolinker.Util.assign( this, cfg );  // assign the properties of `cfg` onto the Autolinker instance. Prototype properties will be used for missing configs.
	
		// Validate the value of the `hashtag` cfg.
		var hashtag = this.hashtag;
		if( hashtag !== false && hashtag !== 'twitter' && hashtag !== 'facebook' && hashtag !== 'instagram' ) {
			throw new Error( "invalid `hashtag` cfg - see docs" );
		}
	};
	
	Autolinker.prototype = {
		constructor : Autolinker,  // fix constructor property
	
		/**
		 * @cfg {Boolean} urls
		 *
		 * `true` if miscellaneous URLs should be automatically linked, `false` if they should not be.
		 */
		urls : true,
	
		/**
		 * @cfg {Boolean} email
		 *
		 * `true` if email addresses should be automatically linked, `false` if they should not be.
		 */
		email : true,
	
		/**
		 * @cfg {Boolean} twitter
		 *
		 * `true` if Twitter handles ("@example") should be automatically linked, `false` if they should not be.
		 */
		twitter : true,
	
		/**
		 * @cfg {Boolean} phone
		 *
		 * `true` if Phone numbers ("(555)555-5555") should be automatically linked, `false` if they should not be.
		 */
		phone: true,
	
		/**
		 * @cfg {Boolean/String} hashtag
		 *
		 * A string for the service name to have hashtags (ex: "#myHashtag")
		 * auto-linked to. The currently-supported values are:
		 *
		 * - 'twitter'
		 * - 'facebook'
		 * - 'instagram'
		 *
		 * Pass `false` to skip auto-linking of hashtags.
		 */
		hashtag : false,
	
		/**
		 * @cfg {Boolean} newWindow
		 *
		 * `true` if the links should open in a new window, `false` otherwise.
		 */
		newWindow : true,
	
		/**
		 * @cfg {Boolean} stripPrefix
		 *
		 * `true` if 'http://' or 'https://' and/or the 'www.' should be stripped
		 * from the beginning of URL links' text, `false` otherwise.
		 */
		stripPrefix : true,
	
		/**
		 * @cfg {Number} truncate
		 *
		 * A number for how many characters long matched text should be truncated to inside the text of
		 * a link. If the matched text is over this number of characters, it will be truncated to this length by
		 * adding a two period ellipsis ('..') to the end of the string.
		 *
		 * For example: A url like 'http://www.yahoo.com/some/long/path/to/a/file' truncated to 25 characters might look
		 * something like this: 'yahoo.com/some/long/pat..'
		 */
		truncate : undefined,
	
		/**
		 * @cfg {String} className
		 *
		 * A CSS class name to add to the generated links. This class will be added to all links, as well as this class
		 * plus match suffixes for styling url/email/phone/twitter/hashtag links differently.
		 *
		 * For example, if this config is provided as "myLink", then:
		 *
		 * - URL links will have the CSS classes: "myLink myLink-url"
		 * - Email links will have the CSS classes: "myLink myLink-email", and
		 * - Twitter links will have the CSS classes: "myLink myLink-twitter"
		 * - Phone links will have the CSS classes: "myLink myLink-phone"
		 * - Hashtag links will have the CSS classes: "myLink myLink-hashtag"
		 */
		className : "",
	
		/**
		 * @cfg {Function} replaceFn
		 *
		 * A function to individually process each match found in the input string.
		 *
		 * See the class's description for usage.
		 *
		 * This function is called with the following parameters:
		 *
		 * @cfg {Autolinker} replaceFn.autolinker The Autolinker instance, which may be used to retrieve child objects from (such
		 *   as the instance's {@link #getTagBuilder tag builder}).
		 * @cfg {Autolinker.match.Match} replaceFn.match The Match instance which can be used to retrieve information about the
		 *   match that the `replaceFn` is currently processing. See {@link Autolinker.match.Match} subclasses for details.
		 */
	
	
		/**
		 * @private
		 * @property {Autolinker.htmlParser.HtmlParser} htmlParser
		 *
		 * The HtmlParser instance used to skip over HTML tags, while finding text nodes to process. This is lazily instantiated
		 * in the {@link #getHtmlParser} method.
		 */
		htmlParser : undefined,
	
		/**
		 * @private
		 * @property {Autolinker.matchParser.MatchParser} matchParser
		 *
		 * The MatchParser instance used to find matches in the text nodes of an input string passed to
		 * {@link #link}. This is lazily instantiated in the {@link #getMatchParser} method.
		 */
		matchParser : undefined,
	
		/**
		 * @private
		 * @property {Autolinker.AnchorTagBuilder} tagBuilder
		 *
		 * The AnchorTagBuilder instance used to build match replacement anchor tags. Note: this is lazily instantiated
		 * in the {@link #getTagBuilder} method.
		 */
		tagBuilder : undefined,
	
		/**
		 * Automatically links URLs, Email addresses, Phone numbers, Twitter
		 * handles, and Hashtags found in the given chunk of HTML. Does not link
		 * URLs found within HTML tags.
		 *
		 * For instance, if given the text: `You should go to http://www.yahoo.com`,
		 * then the result will be `You should go to
		 * &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
		 *
		 * This method finds the text around any HTML elements in the input
		 * `textOrHtml`, which will be the text that is processed. Any original HTML
		 * elements will be left as-is, as well as the text that is already wrapped
		 * in anchor (&lt;a&gt;) tags.
		 *
		 * @param {String} textOrHtml The HTML or text to autolink matches within
		 *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
		 *   {@link #twitter}, and {@link #hashtag} options are enabled).
		 * @return {String} The HTML, with matches automatically linked.
		 */
		link : function( textOrHtml ) {
			if( !textOrHtml ) { return ""; }  // handle `null` and `undefined`
	
			var htmlParser = this.getHtmlParser(),
			    htmlNodes = htmlParser.parse( textOrHtml ),
			    anchorTagStackCount = 0,  // used to only process text around anchor tags, and any inner text/html they may have
			    resultHtml = [];
	
			for( var i = 0, len = htmlNodes.length; i < len; i++ ) {
				var node = htmlNodes[ i ],
				    nodeType = node.getType(),
				    nodeText = node.getText();
	
				if( nodeType === 'element' ) {
					// Process HTML nodes in the input `textOrHtml`
					if( node.getTagName() === 'a' ) {
						if( !node.isClosing() ) {  // it's the start <a> tag
							anchorTagStackCount++;
						} else {   // it's the end </a> tag
							anchorTagStackCount = Math.max( anchorTagStackCount - 1, 0 );  // attempt to handle extraneous </a> tags by making sure the stack count never goes below 0
						}
					}
					resultHtml.push( nodeText );  // now add the text of the tag itself verbatim
	
				} else if( nodeType === 'entity' || nodeType === 'comment' ) {
					resultHtml.push( nodeText );  // append HTML entity nodes (such as '&nbsp;') or HTML comments (such as '<!-- Comment -->') verbatim
	
				} else {
					// Process text nodes in the input `textOrHtml`
					if( anchorTagStackCount === 0 ) {
						// If we're not within an <a> tag, process the text node to linkify
						var linkifiedStr = this.linkifyStr( nodeText );
						resultHtml.push( linkifiedStr );
	
					} else {
						// `text` is within an <a> tag, simply append the text - we do not want to autolink anything
						// already within an <a>...</a> tag
						resultHtml.push( nodeText );
					}
				}
			}
	
			return resultHtml.join( "" );
		},
	
		/**
		 * Process the text that lies in between HTML tags, performing the anchor
		 * tag replacements for the matches, and returns the string with the
		 * replacements made.
		 *
		 * This method does the actual wrapping of matches with anchor tags.
		 *
		 * @private
		 * @param {String} str The string of text to auto-link.
		 * @return {String} The text with anchor tags auto-filled.
		 */
		linkifyStr : function( str ) {
			return this.getMatchParser().replace( str, this.createMatchReturnVal, this );
		},
	
	
		/**
		 * Creates the return string value for a given match in the input string,
		 * for the {@link #linkifyStr} method.
		 *
		 * This method handles the {@link #replaceFn}, if one was provided.
		 *
		 * @private
		 * @param {Autolinker.match.Match} match The Match object that represents the match.
		 * @return {String} The string that the `match` should be replaced with. This is usually the anchor tag string, but
		 *   may be the `matchStr` itself if the match is not to be replaced.
		 */
		createMatchReturnVal : function( match ) {
			// Handle a custom `replaceFn` being provided
			var replaceFnResult;
			if( this.replaceFn ) {
				replaceFnResult = this.replaceFn.call( this, this, match );  // Autolinker instance is the context, and the first arg
			}
	
			if( typeof replaceFnResult === 'string' ) {
				return replaceFnResult;  // `replaceFn` returned a string, use that
	
			} else if( replaceFnResult === false ) {
				return match.getMatchedText();  // no replacement for the match
	
			} else if( replaceFnResult instanceof Autolinker.HtmlTag ) {
				return replaceFnResult.toAnchorString();
	
			} else {  // replaceFnResult === true, or no/unknown return value from function
				// Perform Autolinker's default anchor tag generation
				var tagBuilder = this.getTagBuilder(),
				    anchorTag = tagBuilder.build( match );  // returns an Autolinker.HtmlTag instance
	
				return anchorTag.toAnchorString();
			}
		},
	
	
		/**
		 * Lazily instantiates and returns the {@link #htmlParser} instance for this Autolinker instance.
		 *
		 * @protected
		 * @return {Autolinker.htmlParser.HtmlParser}
		 */
		getHtmlParser : function() {
			var htmlParser = this.htmlParser;
	
			if( !htmlParser ) {
				htmlParser = this.htmlParser = new Autolinker.htmlParser.HtmlParser();
			}
	
			return htmlParser;
		},
	
	
		/**
		 * Lazily instantiates and returns the {@link #matchParser} instance for this Autolinker instance.
		 *
		 * @protected
		 * @return {Autolinker.matchParser.MatchParser}
		 */
		getMatchParser : function() {
			var matchParser = this.matchParser;
	
			if( !matchParser ) {
				matchParser = this.matchParser = new Autolinker.matchParser.MatchParser( {
					urls        : this.urls,
					email       : this.email,
					twitter     : this.twitter,
					phone       : this.phone,
					hashtag     : this.hashtag,
					stripPrefix : this.stripPrefix
				} );
			}
	
			return matchParser;
		},
	
	
		/**
		 * Returns the {@link #tagBuilder} instance for this Autolinker instance, lazily instantiating it
		 * if it does not yet exist.
		 *
		 * This method may be used in a {@link #replaceFn} to generate the {@link Autolinker.HtmlTag HtmlTag} instance that
		 * Autolinker would normally generate, and then allow for modifications before returning it. For example:
		 *
		 *     var html = Autolinker.link( "Test google.com", {
		 *         replaceFn : function( autolinker, match ) {
		 *             var tag = autolinker.getTagBuilder().build( match );  // returns an {@link Autolinker.HtmlTag} instance
		 *             tag.setAttr( 'rel', 'nofollow' );
		 *
		 *             return tag;
		 *         }
		 *     } );
		 *
		 *     // generated html:
		 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
		 *
		 * @return {Autolinker.AnchorTagBuilder}
		 */
		getTagBuilder : function() {
			var tagBuilder = this.tagBuilder;
	
			if( !tagBuilder ) {
				tagBuilder = this.tagBuilder = new Autolinker.AnchorTagBuilder( {
					newWindow   : this.newWindow,
					truncate    : this.truncate,
					className   : this.className
				} );
			}
	
			return tagBuilder;
		}
	
	};
	
	
	/**
	 * Automatically links URLs, Email addresses, Phone Numbers, Twitter handles,
	 * and Hashtags found in the given chunk of HTML. Does not link URLs found
	 * within HTML tags.
	 *
	 * For instance, if given the text: `You should go to http://www.yahoo.com`,
	 * then the result will be `You should go to &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
	 *
	 * Example:
	 *
	 *     var linkedText = Autolinker.link( "Go to google.com", { newWindow: false } );
	 *     // Produces: "Go to <a href="http://google.com">google.com</a>"
	 *
	 * @static
	 * @param {String} textOrHtml The HTML or text to find matches within (depending
	 *   on if the {@link #urls}, {@link #email}, {@link #phone}, {@link #twitter},
	 *   and {@link #hashtag} options are enabled).
	 * @param {Object} [options] Any of the configuration options for the Autolinker
	 *   class, specified in an Object (map). See the class description for an
	 *   example call.
	 * @return {String} The HTML text, with matches automatically linked.
	 */
	Autolinker.link = function( textOrHtml, options ) {
		var autolinker = new Autolinker( options );
		return autolinker.link( textOrHtml );
	};
	
	
	// Autolinker Namespaces
	Autolinker.match = {};
	Autolinker.htmlParser = {};
	Autolinker.matchParser = {};
	
	/*global Autolinker */
	/*jshint eqnull:true, boss:true */
	/**
	 * @class Autolinker.Util
	 * @singleton
	 *
	 * A few utility methods for Autolinker.
	 */
	Autolinker.Util = {
	
		/**
		 * @property {Function} abstractMethod
		 *
		 * A function object which represents an abstract method.
		 */
		abstractMethod : function() { throw "abstract"; },
	
	
		/**
		 * @private
		 * @property {RegExp} trimRegex
		 *
		 * The regular expression used to trim the leading and trailing whitespace
		 * from a string.
		 */
		trimRegex : /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
	
		/**
		 * Assigns (shallow copies) the properties of `src` onto `dest`.
		 *
		 * @param {Object} dest The destination object.
		 * @param {Object} src The source object.
		 * @return {Object} The destination object (`dest`)
		 */
		assign : function( dest, src ) {
			for( var prop in src ) {
				if( src.hasOwnProperty( prop ) ) {
					dest[ prop ] = src[ prop ];
				}
			}
	
			return dest;
		},
	
	
		/**
		 * Extends `superclass` to create a new subclass, adding the `protoProps` to the new subclass's prototype.
		 *
		 * @param {Function} superclass The constructor function for the superclass.
		 * @param {Object} protoProps The methods/properties to add to the subclass's prototype. This may contain the
		 *   special property `constructor`, which will be used as the new subclass's constructor function.
		 * @return {Function} The new subclass function.
		 */
		extend : function( superclass, protoProps ) {
			var superclassProto = superclass.prototype;
	
			var F = function() {};
			F.prototype = superclassProto;
	
			var subclass;
			if( protoProps.hasOwnProperty( 'constructor' ) ) {
				subclass = protoProps.constructor;
			} else {
				subclass = function() { superclassProto.constructor.apply( this, arguments ); };
			}
	
			var subclassProto = subclass.prototype = new F();  // set up prototype chain
			subclassProto.constructor = subclass;  // fix constructor property
			subclassProto.superclass = superclassProto;
	
			delete protoProps.constructor;  // don't re-assign constructor property to the prototype, since a new function may have been created (`subclass`), which is now already there
			Autolinker.Util.assign( subclassProto, protoProps );
	
			return subclass;
		},
	
	
		/**
		 * Truncates the `str` at `len - ellipsisChars.length`, and adds the `ellipsisChars` to the
		 * end of the string (by default, two periods: '..'). If the `str` length does not exceed
		 * `len`, the string will be returned unchanged.
		 *
		 * @param {String} str The string to truncate and add an ellipsis to.
		 * @param {Number} truncateLen The length to truncate the string at.
		 * @param {String} [ellipsisChars=..] The ellipsis character(s) to add to the end of `str`
		 *   when truncated. Defaults to '..'
		 */
		ellipsis : function( str, truncateLen, ellipsisChars ) {
			if( str.length > truncateLen ) {
				ellipsisChars = ( ellipsisChars == null ) ? '..' : ellipsisChars;
				str = str.substring( 0, truncateLen - ellipsisChars.length ) + ellipsisChars;
			}
			return str;
		},
	
	
		/**
		 * Supports `Array.prototype.indexOf()` functionality for old IE (IE8 and below).
		 *
		 * @param {Array} arr The array to find an element of.
		 * @param {*} element The element to find in the array, and return the index of.
		 * @return {Number} The index of the `element`, or -1 if it was not found.
		 */
		indexOf : function( arr, element ) {
			if( Array.prototype.indexOf ) {
				return arr.indexOf( element );
	
			} else {
				for( var i = 0, len = arr.length; i < len; i++ ) {
					if( arr[ i ] === element ) return i;
				}
				return -1;
			}
		},
	
	
	
		/**
		 * Performs the functionality of what modern browsers do when `String.prototype.split()` is called
		 * with a regular expression that contains capturing parenthesis.
		 *
		 * For example:
		 *
		 *     // Modern browsers:
		 *     "a,b,c".split( /(,)/ );  // --> [ 'a', ',', 'b', ',', 'c' ]
		 *
		 *     // Old IE (including IE8):
		 *     "a,b,c".split( /(,)/ );  // --> [ 'a', 'b', 'c' ]
		 *
		 * This method emulates the functionality of modern browsers for the old IE case.
		 *
		 * @param {String} str The string to split.
		 * @param {RegExp} splitRegex The regular expression to split the input `str` on. The splitting
		 *   character(s) will be spliced into the array, as in the "modern browsers" example in the
		 *   description of this method.
		 *   Note #1: the supplied regular expression **must** have the 'g' flag specified.
		 *   Note #2: for simplicity's sake, the regular expression does not need
		 *   to contain capturing parenthesis - it will be assumed that any match has them.
		 * @return {String[]} The split array of strings, with the splitting character(s) included.
		 */
		splitAndCapture : function( str, splitRegex ) {
			if( !splitRegex.global ) throw new Error( "`splitRegex` must have the 'g' flag set" );
	
			var result = [],
			    lastIdx = 0,
			    match;
	
			while( match = splitRegex.exec( str ) ) {
				result.push( str.substring( lastIdx, match.index ) );
				result.push( match[ 0 ] );  // push the splitting char(s)
	
				lastIdx = match.index + match[ 0 ].length;
			}
			result.push( str.substring( lastIdx ) );
	
			return result;
		},
	
	
		/**
		 * Trims the leading and trailing whitespace from a string.
		 *
		 * @param {String} str The string to trim.
		 * @return {String}
		 */
		trim : function( str ) {
			return str.replace( this.trimRegex, '' );
		}
	
	};
	/*global Autolinker */
	/*jshint boss:true */
	/**
	 * @class Autolinker.HtmlTag
	 * @extends Object
	 *
	 * Represents an HTML tag, which can be used to easily build/modify HTML tags programmatically.
	 *
	 * Autolinker uses this abstraction to create HTML tags, and then write them out as strings. You may also use
	 * this class in your code, especially within a {@link Autolinker#replaceFn replaceFn}.
	 *
	 * ## Examples
	 *
	 * Example instantiation:
	 *
	 *     var tag = new Autolinker.HtmlTag( {
	 *         tagName : 'a',
	 *         attrs   : { 'href': 'http://google.com', 'class': 'external-link' },
	 *         innerHtml : 'Google'
	 *     } );
	 *
	 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
	 *
	 *     // Individual accessor methods
	 *     tag.getTagName();                 // 'a'
	 *     tag.getAttr( 'href' );            // 'http://google.com'
	 *     tag.hasClass( 'external-link' );  // true
	 *
	 *
	 * Using mutator methods (which may be used in combination with instantiation config properties):
	 *
	 *     var tag = new Autolinker.HtmlTag();
	 *     tag.setTagName( 'a' );
	 *     tag.setAttr( 'href', 'http://google.com' );
	 *     tag.addClass( 'external-link' );
	 *     tag.setInnerHtml( 'Google' );
	 *
	 *     tag.getTagName();                 // 'a'
	 *     tag.getAttr( 'href' );            // 'http://google.com'
	 *     tag.hasClass( 'external-link' );  // true
	 *
	 *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
	 *
	 *
	 * ## Example use within a {@link Autolinker#replaceFn replaceFn}
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( autolinker, match ) {
	 *             var tag = autolinker.getTagBuilder().build( match );  // returns an {@link Autolinker.HtmlTag} instance, configured with the Match's href and anchor text
	 *             tag.setAttr( 'rel', 'nofollow' );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
	 *
	 *
	 * ## Example use with a new tag for the replacement
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( autolinker, match ) {
	 *             var tag = new Autolinker.HtmlTag( {
	 *                 tagName : 'button',
	 *                 attrs   : { 'title': 'Load URL: ' + match.getAnchorHref() },
	 *                 innerHtml : 'Load URL: ' + match.getAnchorText()
	 *             } );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <button title="Load URL: http://google.com">Load URL: google.com</button>
	 */
	Autolinker.HtmlTag = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {String} tagName
		 *
		 * The tag name. Ex: 'a', 'button', etc.
		 *
		 * Not required at instantiation time, but should be set using {@link #setTagName} before {@link #toAnchorString}
		 * is executed.
		 */
	
		/**
		 * @cfg {Object.<String, String>} attrs
		 *
		 * An key/value Object (map) of attributes to create the tag with. The keys are the attribute names, and the
		 * values are the attribute values.
		 */
	
		/**
		 * @cfg {String} innerHtml
		 *
		 * The inner HTML for the tag.
		 *
		 * Note the camel case name on `innerHtml`. Acronyms are camelCased in this utility (such as not to run into the acronym
		 * naming inconsistency that the DOM developers created with `XMLHttpRequest`). You may alternatively use {@link #innerHTML}
		 * if you prefer, but this one is recommended.
		 */
	
		/**
		 * @cfg {String} innerHTML
		 *
		 * Alias of {@link #innerHtml}, accepted for consistency with the browser DOM api, but prefer the camelCased version
		 * for acronym names.
		 */
	
	
		/**
		 * @protected
		 * @property {RegExp} whitespaceRegex
		 *
		 * Regular expression used to match whitespace in a string of CSS classes.
		 */
		whitespaceRegex : /\s+/,
	
	
		/**
		 * @constructor
		 * @param {Object} [cfg] The configuration properties for this class, in an Object (map)
		 */
		constructor : function( cfg ) {
			Autolinker.Util.assign( this, cfg );
	
			this.innerHtml = this.innerHtml || this.innerHTML;  // accept either the camelCased form or the fully capitalized acronym
		},
	
	
		/**
		 * Sets the tag name that will be used to generate the tag with.
		 *
		 * @param {String} tagName
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setTagName : function( tagName ) {
			this.tagName = tagName;
			return this;
		},
	
	
		/**
		 * Retrieves the tag name.
		 *
		 * @return {String}
		 */
		getTagName : function() {
			return this.tagName || "";
		},
	
	
		/**
		 * Sets an attribute on the HtmlTag.
		 *
		 * @param {String} attrName The attribute name to set.
		 * @param {String} attrValue The attribute value to set.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setAttr : function( attrName, attrValue ) {
			var tagAttrs = this.getAttrs();
			tagAttrs[ attrName ] = attrValue;
	
			return this;
		},
	
	
		/**
		 * Retrieves an attribute from the HtmlTag. If the attribute does not exist, returns `undefined`.
		 *
		 * @param {String} name The attribute name to retrieve.
		 * @return {String} The attribute's value, or `undefined` if it does not exist on the HtmlTag.
		 */
		getAttr : function( attrName ) {
			return this.getAttrs()[ attrName ];
		},
	
	
		/**
		 * Sets one or more attributes on the HtmlTag.
		 *
		 * @param {Object.<String, String>} attrs A key/value Object (map) of the attributes to set.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setAttrs : function( attrs ) {
			var tagAttrs = this.getAttrs();
			Autolinker.Util.assign( tagAttrs, attrs );
	
			return this;
		},
	
	
		/**
		 * Retrieves the attributes Object (map) for the HtmlTag.
		 *
		 * @return {Object.<String, String>} A key/value object of the attributes for the HtmlTag.
		 */
		getAttrs : function() {
			return this.attrs || ( this.attrs = {} );
		},
	
	
		/**
		 * Sets the provided `cssClass`, overwriting any current CSS classes on the HtmlTag.
		 *
		 * @param {String} cssClass One or more space-separated CSS classes to set (overwrite).
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setClass : function( cssClass ) {
			return this.setAttr( 'class', cssClass );
		},
	
	
		/**
		 * Convenience method to add one or more CSS classes to the HtmlTag. Will not add duplicate CSS classes.
		 *
		 * @param {String} cssClass One or more space-separated CSS classes to add.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		addClass : function( cssClass ) {
			var classAttr = this.getClass(),
			    whitespaceRegex = this.whitespaceRegex,
			    indexOf = Autolinker.Util.indexOf,  // to support IE8 and below
			    classes = ( !classAttr ) ? [] : classAttr.split( whitespaceRegex ),
			    newClasses = cssClass.split( whitespaceRegex ),
			    newClass;
	
			while( newClass = newClasses.shift() ) {
				if( indexOf( classes, newClass ) === -1 ) {
					classes.push( newClass );
				}
			}
	
			this.getAttrs()[ 'class' ] = classes.join( " " );
			return this;
		},
	
	
		/**
		 * Convenience method to remove one or more CSS classes from the HtmlTag.
		 *
		 * @param {String} cssClass One or more space-separated CSS classes to remove.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		removeClass : function( cssClass ) {
			var classAttr = this.getClass(),
			    whitespaceRegex = this.whitespaceRegex,
			    indexOf = Autolinker.Util.indexOf,  // to support IE8 and below
			    classes = ( !classAttr ) ? [] : classAttr.split( whitespaceRegex ),
			    removeClasses = cssClass.split( whitespaceRegex ),
			    removeClass;
	
			while( classes.length && ( removeClass = removeClasses.shift() ) ) {
				var idx = indexOf( classes, removeClass );
				if( idx !== -1 ) {
					classes.splice( idx, 1 );
				}
			}
	
			this.getAttrs()[ 'class' ] = classes.join( " " );
			return this;
		},
	
	
		/**
		 * Convenience method to retrieve the CSS class(es) for the HtmlTag, which will each be separated by spaces when
		 * there are multiple.
		 *
		 * @return {String}
		 */
		getClass : function() {
			return this.getAttrs()[ 'class' ] || "";
		},
	
	
		/**
		 * Convenience method to check if the tag has a CSS class or not.
		 *
		 * @param {String} cssClass The CSS class to check for.
		 * @return {Boolean} `true` if the HtmlTag has the CSS class, `false` otherwise.
		 */
		hasClass : function( cssClass ) {
			return ( ' ' + this.getClass() + ' ' ).indexOf( ' ' + cssClass + ' ' ) !== -1;
		},
	
	
		/**
		 * Sets the inner HTML for the tag.
		 *
		 * @param {String} html The inner HTML to set.
		 * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
		 */
		setInnerHtml : function( html ) {
			this.innerHtml = html;
	
			return this;
		},
	
	
		/**
		 * Retrieves the inner HTML for the tag.
		 *
		 * @return {String}
		 */
		getInnerHtml : function() {
			return this.innerHtml || "";
		},
	
	
		/**
		 * Override of superclass method used to generate the HTML string for the tag.
		 *
		 * @return {String}
		 */
		toAnchorString : function() {
			var tagName = this.getTagName(),
			    attrsStr = this.buildAttrsStr();
	
			attrsStr = ( attrsStr ) ? ' ' + attrsStr : '';  // prepend a space if there are actually attributes
	
			return [ '<', tagName, attrsStr, '>', this.getInnerHtml(), '</', tagName, '>' ].join( "" );
		},
	
	
		/**
		 * Support method for {@link #toAnchorString}, returns the string space-separated key="value" pairs, used to populate
		 * the stringified HtmlTag.
		 *
		 * @protected
		 * @return {String} Example return: `attr1="value1" attr2="value2"`
		 */
		buildAttrsStr : function() {
			if( !this.attrs ) return "";  // no `attrs` Object (map) has been set, return empty string
	
			var attrs = this.getAttrs(),
			    attrsArr = [];
	
			for( var prop in attrs ) {
				if( attrs.hasOwnProperty( prop ) ) {
					attrsArr.push( prop + '="' + attrs[ prop ] + '"' );
				}
			}
			return attrsArr.join( " " );
		}
	
	} );
	
	/*global Autolinker */
	/*jshint sub:true */
	/**
	 * @protected
	 * @class Autolinker.AnchorTagBuilder
	 * @extends Object
	 *
	 * Builds anchor (&lt;a&gt;) tags for the Autolinker utility when a match is found.
	 *
	 * Normally this class is instantiated, configured, and used internally by an {@link Autolinker} instance, but may
	 * actually be retrieved in a {@link Autolinker#replaceFn replaceFn} to create {@link Autolinker.HtmlTag HtmlTag} instances
	 * which may be modified before returning from the {@link Autolinker#replaceFn replaceFn}. For example:
	 *
	 *     var html = Autolinker.link( "Test google.com", {
	 *         replaceFn : function( autolinker, match ) {
	 *             var tag = autolinker.getTagBuilder().build( match );  // returns an {@link Autolinker.HtmlTag} instance
	 *             tag.setAttr( 'rel', 'nofollow' );
	 *
	 *             return tag;
	 *         }
	 *     } );
	 *
	 *     // generated html:
	 *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
	 */
	Autolinker.AnchorTagBuilder = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {Boolean} newWindow
		 * @inheritdoc Autolinker#newWindow
		 */
	
		/**
		 * @cfg {Number} truncate
		 * @inheritdoc Autolinker#truncate
		 */
	
		/**
		 * @cfg {String} className
		 * @inheritdoc Autolinker#className
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} [cfg] The configuration options for the AnchorTagBuilder instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.Util.assign( this, cfg );
		},
	
	
		/**
		 * Generates the actual anchor (&lt;a&gt;) tag to use in place of the
		 * matched text, via its `match` object.
		 *
		 * @param {Autolinker.match.Match} match The Match instance to generate an
		 *   anchor tag from.
		 * @return {Autolinker.HtmlTag} The HtmlTag instance for the anchor tag.
		 */
		build : function( match ) {
			var tag = new Autolinker.HtmlTag( {
				tagName   : 'a',
				attrs     : this.createAttrs( match.getType(), match.getAnchorHref() ),
				innerHtml : this.processAnchorText( match.getAnchorText() )
			} );
	
			return tag;
		},
	
	
		/**
		 * Creates the Object (map) of the HTML attributes for the anchor (&lt;a&gt;)
		 *   tag being generated.
		 *
		 * @protected
		 * @param {"url"/"email"/"phone"/"twitter"/"hashtag"} matchType The type of
		 *   match that an anchor tag is being generated for.
		 * @param {String} href The href for the anchor tag.
		 * @return {Object} A key/value Object (map) of the anchor tag's attributes.
		 */
		createAttrs : function( matchType, anchorHref ) {
			var attrs = {
				'href' : anchorHref  // we'll always have the `href` attribute
			};
	
			var cssClass = this.createCssClass( matchType );
			if( cssClass ) {
				attrs[ 'class' ] = cssClass;
			}
			if( this.newWindow ) {
				attrs[ 'target' ] = "_blank";
			}
	
			return attrs;
		},
	
	
		/**
		 * Creates the CSS class that will be used for a given anchor tag, based on
		 * the `matchType` and the {@link #className} config.
		 *
		 * @private
		 * @param {"url"/"email"/"phone"/"twitter"/"hashtag"} matchType The type of
		 *   match that an anchor tag is being generated for.
		 * @return {String} The CSS class string for the link. Example return:
		 *   "myLink myLink-url". If no {@link #className} was configured, returns
		 *   an empty string.
		 */
		createCssClass : function( matchType ) {
			var className = this.className;
	
			if( !className )
				return "";
			else
				return className + " " + className + "-" + matchType;  // ex: "myLink myLink-url", "myLink myLink-email", "myLink myLink-phone", "myLink myLink-twitter", or "myLink myLink-hashtag"
		},
	
	
		/**
		 * Processes the `anchorText` by truncating the text according to the
		 * {@link #truncate} config.
		 *
		 * @private
		 * @param {String} anchorText The anchor tag's text (i.e. what will be
		 *   displayed).
		 * @return {String} The processed `anchorText`.
		 */
		processAnchorText : function( anchorText ) {
			anchorText = this.doTruncate( anchorText );
	
			return anchorText;
		},
	
	
		/**
		 * Performs the truncation of the `anchorText`, if the `anchorText` is
		 * longer than the {@link #truncate} option. Truncates the text to 2
		 * characters fewer than the {@link #truncate} option, and adds ".." to the
		 * end.
		 *
		 * @private
		 * @param {String} text The anchor tag's text (i.e. what will be displayed).
		 * @return {String} The truncated anchor text.
		 */
		doTruncate : function( anchorText ) {
			return Autolinker.Util.ellipsis( anchorText, this.truncate || Number.POSITIVE_INFINITY );
		}
	
	} );
	/*global Autolinker */
	/**
	 * @private
	 * @class Autolinker.htmlParser.HtmlParser
	 * @extends Object
	 *
	 * An HTML parser implementation which simply walks an HTML string and returns an array of
	 * {@link Autolinker.htmlParser.HtmlNode HtmlNodes} that represent the basic HTML structure of the input string.
	 *
	 * Autolinker uses this to only link URLs/emails/Twitter handles within text nodes, effectively ignoring / "walking
	 * around" HTML tags.
	 */
	Autolinker.htmlParser.HtmlParser = Autolinker.Util.extend( Object, {
	
		/**
		 * @private
		 * @property {RegExp} htmlRegex
		 *
		 * The regular expression used to pull out HTML tags from a string. Handles namespaced HTML tags and
		 * attribute names, as specified by http://www.w3.org/TR/html-markup/syntax.html.
		 *
		 * Capturing groups:
		 *
		 * 1. The "!DOCTYPE" tag name, if a tag is a &lt;!DOCTYPE&gt; tag.
		 * 2. If it is an end tag, this group will have the '/'.
		 * 3. If it is a comment tag, this group will hold the comment text (i.e.
		 *    the text inside the `&lt;!--` and `--&gt;`.
		 * 4. The tag name for all tags (other than the &lt;!DOCTYPE&gt; tag)
		 */
		htmlRegex : (function() {
			var commentTagRegex = /!--([\s\S]+?)--/,
			    tagNameRegex = /[0-9a-zA-Z][0-9a-zA-Z:]*/,
			    attrNameRegex = /[^\s\0"'>\/=\x01-\x1F\x7F]+/,   // the unicode range accounts for excluding control chars, and the delete char
			    attrValueRegex = /(?:"[^"]*?"|'[^']*?'|[^'"=<>`\s]+)/, // double quoted, single quoted, or unquoted attribute values
			    nameEqualsValueRegex = attrNameRegex.source + '(?:\\s*=\\s*' + attrValueRegex.source + ')?';  // optional '=[value]'
	
			return new RegExp( [
				// for <!DOCTYPE> tag. Ex: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
				'(?:',
					'<(!DOCTYPE)',  // *** Capturing Group 1 - If it's a doctype tag
	
						// Zero or more attributes following the tag name
						'(?:',
							'\\s+',  // one or more whitespace chars before an attribute
	
							// Either:
							// A. attr="value", or
							// B. "value" alone (To cover example doctype tag: <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">)
							'(?:', nameEqualsValueRegex, '|', attrValueRegex.source + ')',
						')*',
					'>',
				')',
	
				'|',
	
				// All other HTML tags (i.e. tags that are not <!DOCTYPE>)
				'(?:',
					'<(/)?',  // Beginning of a tag or comment. Either '<' for a start tag, or '</' for an end tag.
					          // *** Capturing Group 2: The slash or an empty string. Slash ('/') for end tag, empty string for start or self-closing tag.
	
						'(?:',
							commentTagRegex.source,  // *** Capturing Group 3 - A Comment Tag's Text
	
							'|',
	
							'(?:',
	
								// *** Capturing Group 4 - The tag name
								'(' + tagNameRegex.source + ')',
	
								// Zero or more attributes following the tag name
								'(?:',
									'\\s+',                // one or more whitespace chars before an attribute
									nameEqualsValueRegex,  // attr="value" (with optional ="value" part)
								')*',
	
								'\\s*/?',  // any trailing spaces and optional '/' before the closing '>'
	
							')',
						')',
					'>',
				')'
			].join( "" ), 'gi' );
		} )(),
	
		/**
		 * @private
		 * @property {RegExp} htmlCharacterEntitiesRegex
		 *
		 * The regular expression that matches common HTML character entities.
		 *
		 * Ignoring &amp; as it could be part of a query string -- handling it separately.
		 */
		htmlCharacterEntitiesRegex: /(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;|&quot;|&#34;|&#39;)/gi,
	
	
		/**
		 * Parses an HTML string and returns a simple array of {@link Autolinker.htmlParser.HtmlNode HtmlNodes}
		 * to represent the HTML structure of the input string.
		 *
		 * @param {String} html The HTML to parse.
		 * @return {Autolinker.htmlParser.HtmlNode[]}
		 */
		parse : function( html ) {
			var htmlRegex = this.htmlRegex,
			    currentResult,
			    lastIndex = 0,
			    textAndEntityNodes,
			    nodes = [];  // will be the result of the method
	
			while( ( currentResult = htmlRegex.exec( html ) ) !== null ) {
				var tagText = currentResult[ 0 ],
				    commentText = currentResult[ 3 ], // if we've matched a comment
				    tagName = currentResult[ 1 ] || currentResult[ 4 ],  // The <!DOCTYPE> tag (ex: "!DOCTYPE"), or another tag (ex: "a" or "img")
				    isClosingTag = !!currentResult[ 2 ],
				    inBetweenTagsText = html.substring( lastIndex, currentResult.index );
	
				// Push TextNodes and EntityNodes for any text found between tags
				if( inBetweenTagsText ) {
					textAndEntityNodes = this.parseTextAndEntityNodes( inBetweenTagsText );
					nodes.push.apply( nodes, textAndEntityNodes );
				}
	
				// Push the CommentNode or ElementNode
				if( commentText ) {
					nodes.push( this.createCommentNode( tagText, commentText ) );
				} else {
					nodes.push( this.createElementNode( tagText, tagName, isClosingTag ) );
				}
	
				lastIndex = currentResult.index + tagText.length;
			}
	
			// Process any remaining text after the last HTML element. Will process all of the text if there were no HTML elements.
			if( lastIndex < html.length ) {
				var text = html.substring( lastIndex );
	
				// Push TextNodes and EntityNodes for any text found between tags
				if( text ) {
					textAndEntityNodes = this.parseTextAndEntityNodes( text );
					nodes.push.apply( nodes, textAndEntityNodes );
				}
			}
	
			return nodes;
		},
	
	
		/**
		 * Parses text and HTML entity nodes from a given string. The input string
		 * should not have any HTML tags (elements) within it.
		 *
		 * @private
		 * @param {String} text The text to parse.
		 * @return {Autolinker.htmlParser.HtmlNode[]} An array of HtmlNodes to
		 *   represent the {@link Autolinker.htmlParser.TextNode TextNodes} and
		 *   {@link Autolinker.htmlParser.EntityNode EntityNodes} found.
		 */
		parseTextAndEntityNodes : function( text ) {
			var nodes = [],
			    textAndEntityTokens = Autolinker.Util.splitAndCapture( text, this.htmlCharacterEntitiesRegex );  // split at HTML entities, but include the HTML entities in the results array
	
			// Every even numbered token is a TextNode, and every odd numbered token is an EntityNode
			// For example: an input `text` of "Test &quot;this&quot; today" would turn into the
			//   `textAndEntityTokens`: [ 'Test ', '&quot;', 'this', '&quot;', ' today' ]
			for( var i = 0, len = textAndEntityTokens.length; i < len; i += 2 ) {
				var textToken = textAndEntityTokens[ i ],
				    entityToken = textAndEntityTokens[ i + 1 ];
	
				if( textToken ) nodes.push( this.createTextNode( textToken ) );
				if( entityToken ) nodes.push( this.createEntityNode( entityToken ) );
			}
			return nodes;
		},
	
	
		/**
		 * Factory method to create an {@link Autolinker.htmlParser.CommentNode CommentNode}.
		 *
		 * @private
		 * @param {String} tagText The full text of the tag (comment) that was
		 *   matched, including its &lt;!-- and --&gt;.
		 * @param {String} comment The full text of the comment that was matched.
		 */
		createCommentNode : function( tagText, commentText ) {
			return new Autolinker.htmlParser.CommentNode( {
				text: tagText,
				comment: Autolinker.Util.trim( commentText )
			} );
		},
	
	
		/**
		 * Factory method to create an {@link Autolinker.htmlParser.ElementNode ElementNode}.
		 *
		 * @private
		 * @param {String} tagText The full text of the tag (element) that was
		 *   matched, including its attributes.
		 * @param {String} tagName The name of the tag. Ex: An &lt;img&gt; tag would
		 *   be passed to this method as "img".
		 * @param {Boolean} isClosingTag `true` if it's a closing tag, false
		 *   otherwise.
		 * @return {Autolinker.htmlParser.ElementNode}
		 */
		createElementNode : function( tagText, tagName, isClosingTag ) {
			return new Autolinker.htmlParser.ElementNode( {
				text    : tagText,
				tagName : tagName.toLowerCase(),
				closing : isClosingTag
			} );
		},
	
	
		/**
		 * Factory method to create a {@link Autolinker.htmlParser.EntityNode EntityNode}.
		 *
		 * @private
		 * @param {String} text The text that was matched for the HTML entity (such
		 *   as '&amp;nbsp;').
		 * @return {Autolinker.htmlParser.EntityNode}
		 */
		createEntityNode : function( text ) {
			return new Autolinker.htmlParser.EntityNode( { text: text } );
		},
	
	
		/**
		 * Factory method to create a {@link Autolinker.htmlParser.TextNode TextNode}.
		 *
		 * @private
		 * @param {String} text The text that was matched.
		 * @return {Autolinker.htmlParser.TextNode}
		 */
		createTextNode : function( text ) {
			return new Autolinker.htmlParser.TextNode( { text: text } );
		}
	
	} );
	/*global Autolinker */
	/**
	 * @abstract
	 * @class Autolinker.htmlParser.HtmlNode
	 *
	 * Represents an HTML node found in an input string. An HTML node is one of the
	 * following:
	 *
	 * 1. An {@link Autolinker.htmlParser.ElementNode ElementNode}, which represents
	 *    HTML tags.
	 * 2. A {@link Autolinker.htmlParser.CommentNode CommentNode}, which represents
	 *    HTML comments.
	 * 3. A {@link Autolinker.htmlParser.TextNode TextNode}, which represents text
	 *    outside or within HTML tags.
	 * 4. A {@link Autolinker.htmlParser.EntityNode EntityNode}, which represents
	 *    one of the known HTML entities that Autolinker looks for. This includes
	 *    common ones such as &amp;quot; and &amp;nbsp;
	 */
	Autolinker.htmlParser.HtmlNode = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {String} text (required)
		 *
		 * The original text that was matched for the HtmlNode.
		 *
		 * - In the case of an {@link Autolinker.htmlParser.ElementNode ElementNode},
		 *   this will be the tag's text.
		 * - In the case of an {@link Autolinker.htmlParser.CommentNode CommentNode},
		 *   this will be the comment's text.
		 * - In the case of a {@link Autolinker.htmlParser.TextNode TextNode}, this
		 *   will be the text itself.
		 * - In the case of a {@link Autolinker.htmlParser.EntityNode EntityNode},
		 *   this will be the text of the HTML entity.
		 */
		text : "",
	
	
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match instance,
		 * specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.Util.assign( this, cfg );
		},
	
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @abstract
		 * @return {String}
		 */
		getType : Autolinker.Util.abstractMethod,
	
	
		/**
		 * Retrieves the {@link #text} for the HtmlNode.
		 *
		 * @return {String}
		 */
		getText : function() {
			return this.text;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.CommentNode
	 * @extends Autolinker.htmlParser.HtmlNode
	 *
	 * Represents an HTML comment node that has been parsed by the
	 * {@link Autolinker.htmlParser.HtmlParser}.
	 *
	 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
	 * details.
	 */
	Autolinker.htmlParser.CommentNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {
	
		/**
		 * @cfg {String} comment (required)
		 *
		 * The text inside the comment tag. This text is stripped of any leading or
		 * trailing whitespace.
		 */
		comment : '',
	
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'comment';
		},
	
	
		/**
		 * Returns the comment inside the comment tag.
		 *
		 * @return {String}
		 */
		getComment : function() {
			return this.comment;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.ElementNode
	 * @extends Autolinker.htmlParser.HtmlNode
	 *
	 * Represents an HTML element node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
	 *
	 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
	 * details.
	 */
	Autolinker.htmlParser.ElementNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {
	
		/**
		 * @cfg {String} tagName (required)
		 *
		 * The name of the tag that was matched.
		 */
		tagName : '',
	
		/**
		 * @cfg {Boolean} closing (required)
		 *
		 * `true` if the element (tag) is a closing tag, `false` if its an opening
		 * tag.
		 */
		closing : false,
	
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'element';
		},
	
	
		/**
		 * Returns the HTML element's (tag's) name. Ex: for an &lt;img&gt; tag,
		 * returns "img".
		 *
		 * @return {String}
		 */
		getTagName : function() {
			return this.tagName;
		},
	
	
		/**
		 * Determines if the HTML element (tag) is a closing tag. Ex: &lt;div&gt;
		 * returns `false`, while &lt;/div&gt; returns `true`.
		 *
		 * @return {Boolean}
		 */
		isClosing : function() {
			return this.closing;
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.EntityNode
	 * @extends Autolinker.htmlParser.HtmlNode
	 *
	 * Represents a known HTML entity node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
	 * Ex: '&amp;nbsp;', or '&amp#160;' (which will be retrievable from the {@link #getText}
	 * method.
	 *
	 * Note that this class will only be returned from the HtmlParser for the set of
	 * checked HTML entity nodes  defined by the {@link Autolinker.htmlParser.HtmlParser#htmlCharacterEntitiesRegex}.
	 *
	 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
	 * details.
	 */
	Autolinker.htmlParser.EntityNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'entity';
		}
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.htmlParser.TextNode
	 * @extends Autolinker.htmlParser.HtmlNode
	 *
	 * Represents a text node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
	 *
	 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
	 * details.
	 */
	Autolinker.htmlParser.TextNode = Autolinker.Util.extend( Autolinker.htmlParser.HtmlNode, {
	
		/**
		 * Returns a string name for the type of node that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'text';
		}
	
	} );
	/*global Autolinker */
	/**
	 * @private
	 * @class Autolinker.matchParser.MatchParser
	 * @extends Object
	 *
	 * Used by Autolinker to parse potential matches, given an input string of text.
	 *
	 * The MatchParser is fed a non-HTML string in order to search for matches.
	 * Autolinker first uses the {@link Autolinker.htmlParser.HtmlParser} to "walk
	 * around" HTML tags, and then the text around the HTML tags is passed into the
	 * MatchParser in order to find the actual matches.
	 */
	Autolinker.matchParser.MatchParser = Autolinker.Util.extend( Object, {
	
		/**
		 * @cfg {Boolean} urls
		 * @inheritdoc Autolinker#urls
		 */
		urls : true,
	
		/**
		 * @cfg {Boolean} email
		 * @inheritdoc Autolinker#email
		 */
		email : true,
	
		/**
		 * @cfg {Boolean} twitter
		 * @inheritdoc Autolinker#twitter
		 */
		twitter : true,
	
		/**
		 * @cfg {Boolean} phone
		 * @inheritdoc Autolinker#phone
		 */
		phone: true,
	
		/**
		 * @cfg {Boolean/String} hashtag
		 * @inheritdoc Autolinker#hashtag
		 */
		hashtag : false,
	
		/**
		 * @cfg {Boolean} stripPrefix
		 * @inheritdoc Autolinker#stripPrefix
		 */
		stripPrefix : true,
	
	
		/**
		 * @private
		 * @property {RegExp} matcherRegex
		 *
		 * The regular expression that matches URLs, email addresses, phone #s,
		 * Twitter handles, and Hashtags.
		 *
		 * This regular expression has the following capturing groups:
		 *
		 * 1.  Group that is used to determine if there is a Twitter handle match
		 *     (i.e. \@someTwitterUser). Simply check for its existence to determine
		 *     if there is a Twitter handle match. The next couple of capturing
		 *     groups give information about the Twitter handle match.
		 * 2.  The whitespace character before the \@sign in a Twitter handle. This
		 *     is needed because there are no lookbehinds in JS regular expressions,
		 *     and can be used to reconstruct the original string in a replace().
		 * 3.  The Twitter handle itself in a Twitter match. If the match is
		 *     '@someTwitterUser', the handle is 'someTwitterUser'.
		 * 4.  Group that matches an email address. Used to determine if the match
		 *     is an email address, as well as holding the full address. Ex:
		 *     'me@my.com'
		 * 5.  Group that matches a URL in the input text. Ex: 'http://google.com',
		 *     'www.google.com', or just 'google.com'. This also includes a path,
		 *     url parameters, or hash anchors. Ex: google.com/path/to/file?q1=1&q2=2#myAnchor
		 * 6.  Group that matches a protocol URL (i.e. 'http://google.com'). This is
		 *     used to match protocol URLs with just a single word, like 'http://localhost',
		 *     where we won't double check that the domain name has at least one '.'
		 *     in it.
		 * 7.  A protocol-relative ('//') match for the case of a 'www.' prefixed
		 *     URL. Will be an empty string if it is not a protocol-relative match.
		 *     We need to know the character before the '//' in order to determine
		 *     if it is a valid match or the // was in a string we don't want to
		 *     auto-link.
		 * 8.  A protocol-relative ('//') match for the case of a known TLD prefixed
		 *     URL. Will be an empty string if it is not a protocol-relative match.
		 *     See #6 for more info.
		 * 9.  Group that is used to determine if there is a phone number match. The
		 *     next 3 groups give segments of the phone number.
		 * 10. Group that is used to determine if there is a Hashtag match
		 *     (i.e. \#someHashtag). Simply check for its existence to determine if
		 *     there is a Hashtag match. The next couple of capturing groups give
		 *     information about the Hashtag match.
		 * 11. The whitespace character before the #sign in a Hashtag handle. This
		 *     is needed because there are no look-behinds in JS regular
		 *     expressions, and can be used to reconstruct the original string in a
		 *     replace().
		 * 12. The Hashtag itself in a Hashtag match. If the match is
		 *     '#someHashtag', the hashtag is 'someHashtag'.
		 */
		matcherRegex : (function() {
			var twitterRegex = /(^|[^\w])@(\w{1,15})/,              // For matching a twitter handle. Ex: @gregory_jacobs
	
			    hashtagRegex = /(^|[^\w])#(\w{1,139})/,              // For matching a Hashtag. Ex: #games
	
			    emailRegex = /(?:[\-;:&=\+\$,\w\.]+@)/,             // something@ for email addresses (a.k.a. local-part)
			    phoneRegex = /(?:\+?\d{1,3}[-\040.])?\(?\d{3}\)?[-\040.]?\d{3}[-\040.]\d{4}/,  // ex: (123) 456-7890, 123 456 7890, 123-456-7890, etc.
			    protocolRegex = /(?:[A-Za-z][-.+A-Za-z0-9]*:(?![A-Za-z][-.+A-Za-z0-9]*:\/\/)(?!\d+\/?)(?:\/\/)?)/,  // match protocol, allow in format "http://" or "mailto:". However, do not match the first part of something like 'link:http://www.google.com' (i.e. don't match "link:"). Also, make sure we don't interpret 'google.com:8000' as if 'google.com' was a protocol here (i.e. ignore a trailing port number in this regex)
			    wwwRegex = /(?:www\.)/,                             // starting with 'www.'
			    domainNameRegex = /[A-Za-z0-9\.\-]*[A-Za-z0-9\-]/,  // anything looking at all like a domain, non-unicode domains, not ending in a period
			    tldRegex = /\.(?:international|construction|contractors|enterprises|photography|productions|foundation|immobilien|industries|management|properties|technology|christmas|community|directory|education|equipment|institute|marketing|solutions|vacations|bargains|boutique|builders|catering|cleaning|clothing|computer|democrat|diamonds|graphics|holdings|lighting|partners|plumbing|supplies|training|ventures|academy|careers|company|cruises|domains|exposed|flights|florist|gallery|guitars|holiday|kitchen|neustar|okinawa|recipes|rentals|reviews|shiksha|singles|support|systems|agency|berlin|camera|center|coffee|condos|dating|estate|events|expert|futbol|kaufen|luxury|maison|monash|museum|nagoya|photos|repair|report|social|supply|tattoo|tienda|travel|viajes|villas|vision|voting|voyage|actor|build|cards|cheap|codes|dance|email|glass|house|mango|ninja|parts|photo|press|shoes|solar|today|tokyo|tools|watch|works|aero|arpa|asia|best|bike|blue|buzz|camp|club|cool|coop|farm|fish|gift|guru|info|jobs|kiwi|kred|land|limo|link|menu|mobi|moda|name|pics|pink|post|qpon|rich|ruhr|sexy|tips|vote|voto|wang|wien|wiki|zone|bar|bid|biz|cab|cat|ceo|com|edu|gov|int|kim|mil|net|onl|org|pro|pub|red|tel|uno|wed|xxx|xyz|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cw|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw)\b/,   // match our known top level domains (TLDs)
	
			    // Allow optional path, query string, and hash anchor, not ending in the following characters: "?!:,.;"
			    // http://blog.codinghorror.com/the-problem-with-urls/
			    urlSuffixRegex = /[\-A-Za-z0-9+&@#\/%=~_()|'$*\[\]?!:,.;]*[\-A-Za-z0-9+&@#\/%=~_()|'$*\[\]]/;
	
			return new RegExp( [
				'(',  // *** Capturing group $1, which can be used to check for a twitter handle match. Use group $3 for the actual twitter handle though. $2 may be used to reconstruct the original string in a replace()
					// *** Capturing group $2, which matches the whitespace character before the '@' sign (needed because of no lookbehinds), and
					// *** Capturing group $3, which matches the actual twitter handle
					twitterRegex.source,
				')',
	
				'|',
	
				'(',  // *** Capturing group $4, which is used to determine an email match
					emailRegex.source,
					domainNameRegex.source,
					tldRegex.source,
				')',
	
				'|',
	
				'(',  // *** Capturing group $5, which is used to match a URL
					'(?:', // parens to cover match for protocol (optional), and domain
						'(',  // *** Capturing group $6, for a protocol-prefixed url (ex: http://google.com)
							protocolRegex.source,
							domainNameRegex.source,
						')',
	
						'|',
	
						'(?:',  // non-capturing paren for a 'www.' prefixed url (ex: www.google.com)
							'(.?//)?',  // *** Capturing group $7 for an optional protocol-relative URL. Must be at the beginning of the string or start with a non-word character
							wwwRegex.source,
							domainNameRegex.source,
						')',
	
						'|',
	
						'(?:',  // non-capturing paren for known a TLD url (ex: google.com)
							'(.?//)?',  // *** Capturing group $8 for an optional protocol-relative URL. Must be at the beginning of the string or start with a non-word character
							domainNameRegex.source,
							tldRegex.source,
						')',
					')',
	
					'(?:' + urlSuffixRegex.source + ')?',  // match for path, query string, and/or hash anchor - optional
				')',
	
				'|',
	
				// this setup does not scale well for open extension :( Need to rethink design of autolinker...
				// ***  Capturing group $9, which matches a (USA for now) phone number
				'(',
					phoneRegex.source,
				')',
	
				'|',
	
				'(',  // *** Capturing group $10, which can be used to check for a Hashtag match. Use group $12 for the actual Hashtag though. $11 may be used to reconstruct the original string in a replace()
					// *** Capturing group $11, which matches the whitespace character before the '#' sign (needed because of no lookbehinds), and
					// *** Capturing group $12, which matches the actual Hashtag
					hashtagRegex.source,
				')'
			].join( "" ), 'gi' );
		} )(),
	
		/**
		 * @private
		 * @property {RegExp} charBeforeProtocolRelMatchRegex
		 *
		 * The regular expression used to retrieve the character before a
		 * protocol-relative URL match.
		 *
		 * This is used in conjunction with the {@link #matcherRegex}, which needs
		 * to grab the character before a protocol-relative '//' due to the lack of
		 * a negative look-behind in JavaScript regular expressions. The character
		 * before the match is stripped from the URL.
		 */
		charBeforeProtocolRelMatchRegex : /^(.)?\/\//,
	
		/**
		 * @private
		 * @property {Autolinker.MatchValidator} matchValidator
		 *
		 * The MatchValidator object, used to filter out any false positives from
		 * the {@link #matcherRegex}. See {@link Autolinker.MatchValidator} for details.
		 */
	
	
		/**
		 * @constructor
		 * @param {Object} [cfg] The configuration options for the AnchorTagBuilder
		 * instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.Util.assign( this, cfg );
	
			this.matchValidator = new Autolinker.MatchValidator();
		},
	
	
		/**
		 * Parses the input `text` to search for matches, and calls the `replaceFn`
		 * to allow replacements of the matches. Returns the `text` with matches
		 * replaced.
		 *
		 * @param {String} text The text to search and repace matches in.
		 * @param {Function} replaceFn The iterator function to handle the
		 *   replacements. The function takes a single argument, a {@link Autolinker.match.Match}
		 *   object, and should return the text that should make the replacement.
		 * @param {Object} [contextObj=window] The context object ("scope") to run
		 *   the `replaceFn` in.
		 * @return {String}
		 */
		replace : function( text, replaceFn, contextObj ) {
			var me = this;  // for closure
	
			return text.replace( this.matcherRegex, function( matchStr, $1, $2, $3, $4, $5, $6, $7, $8, $9, $10, $11, $12 ) {
				var matchDescObj = me.processCandidateMatch( matchStr, $1, $2, $3, $4, $5, $6, $7, $8, $9, $10, $11, $12 );  // "match description" object
	
				// Return out with no changes for match types that are disabled (url,
				// email, phone, etc.), or for matches that are invalid (false
				// positives from the matcherRegex, which can't use look-behinds
				// since they are unavailable in JS).
				if( !matchDescObj ) {
					return matchStr;
	
				} else {
					// Generate replacement text for the match from the `replaceFn`
					var replaceStr = replaceFn.call( contextObj, matchDescObj.match );
					return matchDescObj.prefixStr + replaceStr + matchDescObj.suffixStr;
				}
			} );
		},
	
	
		/**
		 * Processes a candidate match from the {@link #matcherRegex}.
		 *
		 * Not all matches found by the regex are actual URL/Email/Phone/Twitter/Hashtag
		 * matches, as determined by the {@link #matchValidator}. In this case, the
		 * method returns `null`. Otherwise, a valid Object with `prefixStr`,
		 * `match`, and `suffixStr` is returned.
		 *
		 * @private
		 * @param {String} matchStr The full match that was found by the
		 *   {@link #matcherRegex}.
		 * @param {String} twitterMatch The matched text of a Twitter handle, if the
		 *   match is a Twitter match.
		 * @param {String} twitterHandlePrefixWhitespaceChar The whitespace char
		 *   before the @ sign in a Twitter handle match. This is needed because of
		 *   no lookbehinds in JS regexes, and is need to re-include the character
		 *   for the anchor tag replacement.
		 * @param {String} twitterHandle The actual Twitter user (i.e the word after
		 *   the @ sign in a Twitter match).
		 * @param {String} emailAddressMatch The matched email address for an email
		 *   address match.
		 * @param {String} urlMatch The matched URL string for a URL match.
		 * @param {String} protocolUrlMatch The match URL string for a protocol
		 *   match. Ex: 'http://yahoo.com'. This is used to match something like
		 *   'http://localhost', where we won't double check that the domain name
		 *   has at least one '.' in it.
		 * @param {String} wwwProtocolRelativeMatch The '//' for a protocol-relative
		 *   match from a 'www' url, with the character that comes before the '//'.
		 * @param {String} tldProtocolRelativeMatch The '//' for a protocol-relative
		 *   match from a TLD (top level domain) match, with the character that
		 *   comes before the '//'.
		 * @param {String} phoneMatch The matched text of a phone number
		 * @param {String} hashtagMatch The matched text of a Twitter
		 *   Hashtag, if the match is a Hashtag match.
		 * @param {String} hashtagPrefixWhitespaceChar The whitespace char
		 *   before the # sign in a Hashtag match. This is needed because of no
		 *   lookbehinds in JS regexes, and is need to re-include the character for
		 *   the anchor tag replacement.
		 * @param {String} hashtag The actual Hashtag (i.e the word
		 *   after the # sign in a Hashtag match).
		 *
		 * @return {Object} A "match description object". This will be `null` if the
		 *   match was invalid, or if a match type is disabled. Otherwise, this will
		 *   be an Object (map) with the following properties:
		 * @return {String} return.prefixStr The char(s) that should be prepended to
		 *   the replacement string. These are char(s) that were needed to be
		 *   included from the regex match that were ignored by processing code, and
		 *   should be re-inserted into the replacement stream.
		 * @return {String} return.suffixStr The char(s) that should be appended to
		 *   the replacement string. These are char(s) that were needed to be
		 *   included from the regex match that were ignored by processing code, and
		 *   should be re-inserted into the replacement stream.
		 * @return {Autolinker.match.Match} return.match The Match object that
		 *   represents the match that was found.
		 */
		processCandidateMatch : function(
			matchStr, twitterMatch, twitterHandlePrefixWhitespaceChar, twitterHandle,
			emailAddressMatch, urlMatch, protocolUrlMatch, wwwProtocolRelativeMatch,
			tldProtocolRelativeMatch, phoneMatch, hashtagMatch,
			hashtagPrefixWhitespaceChar, hashtag
		) {
			// Note: The `matchStr` variable wil be fixed up to remove characters that are no longer needed (which will
			// be added to `prefixStr` and `suffixStr`).
	
			var protocolRelativeMatch = wwwProtocolRelativeMatch || tldProtocolRelativeMatch,
			    match,  // Will be an Autolinker.match.Match object
	
			    prefixStr = "",  // A string to use to prefix the anchor tag that is created. This is needed for the Twitter and Hashtag matches.
			    suffixStr = "";  // A string to suffix the anchor tag that is created. This is used if there is a trailing parenthesis that should not be auto-linked.
	
			// Return out with `null` for match types that are disabled (url, email,
			// twitter, hashtag), or for matches that are invalid (false positives
			// from the matcherRegex, which can't use look-behinds since they are
			// unavailable in JS).
			if(
				( urlMatch && !this.urls ) ||
				( emailAddressMatch && !this.email ) ||
				( phoneMatch && !this.phone ) ||
				( twitterMatch && !this.twitter ) ||
				( hashtagMatch && !this.hashtag ) ||
				!this.matchValidator.isValidMatch( urlMatch, protocolUrlMatch, protocolRelativeMatch )
			) {
				return null;
			}
	
			// Handle a closing parenthesis at the end of the match, and exclude it
			// if there is not a matching open parenthesis
			// in the match itself.
			if( this.matchHasUnbalancedClosingParen( matchStr ) ) {
				matchStr = matchStr.substr( 0, matchStr.length - 1 );  // remove the trailing ")"
				suffixStr = ")";  // this will be added after the generated <a> tag
			} else {
				// Handle an invalid character after the TLD
				var pos = this.matchHasInvalidCharAfterTld( urlMatch, protocolUrlMatch );
				if( pos > -1 ) {
					suffixStr = matchStr.substr(pos);  // this will be added after the generated <a> tag
					matchStr = matchStr.substr( 0, pos ); // remove the trailing invalid chars
				}
			}
	
			if( emailAddressMatch ) {
				match = new Autolinker.match.Email( { matchedText: matchStr, email: emailAddressMatch } );
	
			} else if( twitterMatch ) {
				// fix up the `matchStr` if there was a preceding whitespace char,
				// which was needed to determine the match itself (since there are
				// no look-behinds in JS regexes)
				if( twitterHandlePrefixWhitespaceChar ) {
					prefixStr = twitterHandlePrefixWhitespaceChar;
					matchStr = matchStr.slice( 1 );  // remove the prefixed whitespace char from the match
				}
				match = new Autolinker.match.Twitter( { matchedText: matchStr, twitterHandle: twitterHandle } );
	
			} else if( phoneMatch ) {
				// remove non-numeric values from phone number string
				var cleanNumber = matchStr.replace( /\D/g, '' );
	 			match = new Autolinker.match.Phone( { matchedText: matchStr, number: cleanNumber } );
	
			} else if( hashtagMatch ) {
				// fix up the `matchStr` if there was a preceding whitespace char,
				// which was needed to determine the match itself (since there are
				// no look-behinds in JS regexes)
				if( hashtagPrefixWhitespaceChar ) {
					prefixStr = hashtagPrefixWhitespaceChar;
					matchStr = matchStr.slice( 1 );  // remove the prefixed whitespace char from the match
				}
				match = new Autolinker.match.Hashtag( { matchedText: matchStr, serviceName: this.hashtag, hashtag: hashtag } );
	
			} else {  // url match
				// If it's a protocol-relative '//' match, remove the character
				// before the '//' (which the matcherRegex needed to match due to
				// the lack of a negative look-behind in JavaScript regular
				// expressions)
				if( protocolRelativeMatch ) {
					var charBeforeMatch = protocolRelativeMatch.match( this.charBeforeProtocolRelMatchRegex )[ 1 ] || "";
	
					if( charBeforeMatch ) {  // fix up the `matchStr` if there was a preceding char before a protocol-relative match, which was needed to determine the match itself (since there are no look-behinds in JS regexes)
						prefixStr = charBeforeMatch;
						matchStr = matchStr.slice( 1 );  // remove the prefixed char from the match
					}
				}
	
				match = new Autolinker.match.Url( {
					matchedText : matchStr,
					url : matchStr,
					protocolUrlMatch : !!protocolUrlMatch,
					protocolRelativeMatch : !!protocolRelativeMatch,
					stripPrefix : this.stripPrefix
				} );
			}
	
			return {
				prefixStr : prefixStr,
				suffixStr : suffixStr,
				match     : match
			};
		},
	
	
		/**
		 * Determines if a match found has an unmatched closing parenthesis. If so,
		 * this parenthesis will be removed from the match itself, and appended
		 * after the generated anchor tag in {@link #processCandidateMatch}.
		 *
		 * A match may have an extra closing parenthesis at the end of the match
		 * because the regular expression must include parenthesis for URLs such as
		 * "wikipedia.com/something_(disambiguation)", which should be auto-linked.
		 *
		 * However, an extra parenthesis *will* be included when the URL itself is
		 * wrapped in parenthesis, such as in the case of "(wikipedia.com/something_(disambiguation))".
		 * In this case, the last closing parenthesis should *not* be part of the
		 * URL itself, and this method will return `true`.
		 *
		 * @private
		 * @param {String} matchStr The full match string from the {@link #matcherRegex}.
		 * @return {Boolean} `true` if there is an unbalanced closing parenthesis at
		 *   the end of the `matchStr`, `false` otherwise.
		 */
		matchHasUnbalancedClosingParen : function( matchStr ) {
			var lastChar = matchStr.charAt( matchStr.length - 1 );
	
			if( lastChar === ')' ) {
				var openParensMatch = matchStr.match( /\(/g ),
				    closeParensMatch = matchStr.match( /\)/g ),
				    numOpenParens = ( openParensMatch && openParensMatch.length ) || 0,
				    numCloseParens = ( closeParensMatch && closeParensMatch.length ) || 0;
	
				if( numOpenParens < numCloseParens ) {
					return true;
				}
			}
	
			return false;
		},
	
	
		/**
		 * Determine if there's an invalid character after the TLD in a URL. Valid
		 * characters after TLD are ':/?#'. Exclude protocol matched URLs from this
		 * check.
		 *
		 * @private
		 * @param {String} urlMatch The matched URL, if there was one. Will be an
		 *   empty string if the match is not a URL match.
		 * @param {String} protocolUrlMatch The match URL string for a protocol
		 *   match. Ex: 'http://yahoo.com'. This is used to match something like
		 *   'http://localhost', where we won't double check that the domain name
		 *   has at least one '.' in it.
		 * @return {Number} the position where the invalid character was found. If
		 *   no such character was found, returns -1
		 */
		matchHasInvalidCharAfterTld : function( urlMatch, protocolUrlMatch ) {
			if ( !urlMatch ) {
				return -1;
			}
	
			var offset = 0;
			if ( protocolUrlMatch ) {
				offset = urlMatch.indexOf(':');
				urlMatch = urlMatch.slice(offset);
			}
	
			var re = /^((.?\/\/)?[A-Za-z0-9\.\-]*[A-Za-z0-9\-]\.[A-Za-z]+)/;
			var res = re.exec( urlMatch );
			if ( res === null ) {
				return -1;
			}
	
			offset += res[1].length;
			urlMatch = urlMatch.slice(res[1].length);
			if (/^[^.A-Za-z:\/?#]/.test(urlMatch)) {
				return offset;
			}
	
			return -1;
		}
	
	} );
	
	/*global Autolinker */
	/*jshint scripturl:true */
	/**
	 * @private
	 * @class Autolinker.MatchValidator
	 * @extends Object
	 *
	 * Used by Autolinker to filter out false positives from the
	 * {@link Autolinker.matchParser.MatchParser#matcherRegex}.
	 *
	 * Due to the limitations of regular expressions (including the missing feature
	 * of look-behinds in JS regular expressions), we cannot always determine the
	 * validity of a given match. This class applies a bit of additional logic to
	 * filter out any false positives that have been matched by the
	 * {@link Autolinker.matchParser.MatchParser#matcherRegex}.
	 */
	Autolinker.MatchValidator = Autolinker.Util.extend( Object, {
	
		/**
		 * @private
		 * @property {RegExp} invalidProtocolRelMatchRegex
		 *
		 * The regular expression used to check a potential protocol-relative URL
		 * match, coming from the {@link Autolinker.matchParser.MatchParser#matcherRegex}.
		 * A protocol-relative URL is, for example, "//yahoo.com"
		 *
		 * This regular expression checks to see if there is a word character before
		 * the '//' match in order to determine if we should actually autolink a
		 * protocol-relative URL. This is needed because there is no negative
		 * look-behind in JavaScript regular expressions.
		 *
		 * For instance, we want to autolink something like "Go to: //google.com",
		 * but we don't want to autolink something like "abc//google.com"
		 */
		invalidProtocolRelMatchRegex : /^[\w]\/\//,
	
		/**
		 * Regex to test for a full protocol, with the two trailing slashes. Ex: 'http://'
		 *
		 * @private
		 * @property {RegExp} hasFullProtocolRegex
		 */
		hasFullProtocolRegex : /^[A-Za-z][-.+A-Za-z0-9]*:\/\//,
	
		/**
		 * Regex to find the URI scheme, such as 'mailto:'.
		 *
		 * This is used to filter out 'javascript:' and 'vbscript:' schemes.
		 *
		 * @private
		 * @property {RegExp} uriSchemeRegex
		 */
		uriSchemeRegex : /^[A-Za-z][-.+A-Za-z0-9]*:/,
	
		/**
		 * Regex to determine if at least one word char exists after the protocol (i.e. after the ':')
		 *
		 * @private
		 * @property {RegExp} hasWordCharAfterProtocolRegex
		 */
		hasWordCharAfterProtocolRegex : /:[^\s]*?[A-Za-z]/,
	
	
		/**
		 * Determines if a given match found by the {@link Autolinker.matchParser.MatchParser}
		 * is valid. Will return `false` for:
		 *
		 * 1) URL matches which do not have at least have one period ('.') in the
		 *    domain name (effectively skipping over matches like "abc:def").
		 *    However, URL matches with a protocol will be allowed (ex: 'http://localhost')
		 * 2) URL matches which do not have at least one word character in the
		 *    domain name (effectively skipping over matches like "git:1.0").
		 * 3) A protocol-relative url match (a URL beginning with '//') whose
		 *    previous character is a word character (effectively skipping over
		 *    strings like "abc//google.com")
		 *
		 * Otherwise, returns `true`.
		 *
		 * @param {String} urlMatch The matched URL, if there was one. Will be an
		 *   empty string if the match is not a URL match.
		 * @param {String} protocolUrlMatch The match URL string for a protocol
		 *   match. Ex: 'http://yahoo.com'. This is used to match something like
		 *   'http://localhost', where we won't double check that the domain name
		 *   has at least one '.' in it.
		 * @param {String} protocolRelativeMatch The protocol-relative string for a
		 *   URL match (i.e. '//'), possibly with a preceding character (ex, a
		 *   space, such as: ' //', or a letter, such as: 'a//'). The match is
		 *   invalid if there is a word character preceding the '//'.
		 * @return {Boolean} `true` if the match given is valid and should be
		 *   processed, or `false` if the match is invalid and/or should just not be
		 *   processed.
		 */
		isValidMatch : function( urlMatch, protocolUrlMatch, protocolRelativeMatch ) {
			if(
				( protocolUrlMatch && !this.isValidUriScheme( protocolUrlMatch ) ) ||
				this.urlMatchDoesNotHaveProtocolOrDot( urlMatch, protocolUrlMatch ) ||       // At least one period ('.') must exist in the URL match for us to consider it an actual URL, *unless* it was a full protocol match (like 'http://localhost')
				this.urlMatchDoesNotHaveAtLeastOneWordChar( urlMatch, protocolUrlMatch ) ||  // At least one letter character must exist in the domain name after a protocol match. Ex: skip over something like "git:1.0"
				this.isInvalidProtocolRelativeMatch( protocolRelativeMatch )                 // A protocol-relative match which has a word character in front of it (so we can skip something like "abc//google.com")
			) {
				return false;
			}
	
			return true;
		},
	
	
		/**
		 * Determines if the URI scheme is a valid scheme to be autolinked. Returns
		 * `false` if the scheme is 'javascript:' or 'vbscript:'
		 *
		 * @private
		 * @param {String} uriSchemeMatch The match URL string for a full URI scheme
		 *   match. Ex: 'http://yahoo.com' or 'mailto:a@a.com'.
		 * @return {Boolean} `true` if the scheme is a valid one, `false` otherwise.
		 */
		isValidUriScheme : function( uriSchemeMatch ) {
			var uriScheme = uriSchemeMatch.match( this.uriSchemeRegex )[ 0 ].toLowerCase();
	
			return ( uriScheme !== 'javascript:' && uriScheme !== 'vbscript:' );
		},
	
	
		/**
		 * Determines if a URL match does not have either:
		 *
		 * a) a full protocol (i.e. 'http://'), or
		 * b) at least one dot ('.') in the domain name (for a non-full-protocol
		 *    match).
		 *
		 * Either situation is considered an invalid URL (ex: 'git:d' does not have
		 * either the '://' part, or at least one dot in the domain name. If the
		 * match was 'git:abc.com', we would consider this valid.)
		 *
		 * @private
		 * @param {String} urlMatch The matched URL, if there was one. Will be an
		 *   empty string if the match is not a URL match.
		 * @param {String} protocolUrlMatch The match URL string for a protocol
		 *   match. Ex: 'http://yahoo.com'. This is used to match something like
		 *   'http://localhost', where we won't double check that the domain name
		 *   has at least one '.' in it.
		 * @return {Boolean} `true` if the URL match does not have a full protocol,
		 *   or at least one dot ('.') in a non-full-protocol match.
		 */
		urlMatchDoesNotHaveProtocolOrDot : function( urlMatch, protocolUrlMatch ) {
			return ( !!urlMatch && ( !protocolUrlMatch || !this.hasFullProtocolRegex.test( protocolUrlMatch ) ) && urlMatch.indexOf( '.' ) === -1 );
		},
	
	
		/**
		 * Determines if a URL match does not have at least one word character after
		 * the protocol (i.e. in the domain name).
		 *
		 * At least one letter character must exist in the domain name after a
		 * protocol match. Ex: skip over something like "git:1.0"
		 *
		 * @private
		 * @param {String} urlMatch The matched URL, if there was one. Will be an
		 *   empty string if the match is not a URL match.
		 * @param {String} protocolUrlMatch The match URL string for a protocol
		 *   match. Ex: 'http://yahoo.com'. This is used to know whether or not we
		 *   have a protocol in the URL string, in order to check for a word
		 *   character after the protocol separator (':').
		 * @return {Boolean} `true` if the URL match does not have at least one word
		 *   character in it after the protocol, `false` otherwise.
		 */
		urlMatchDoesNotHaveAtLeastOneWordChar : function( urlMatch, protocolUrlMatch ) {
			if( urlMatch && protocolUrlMatch ) {
				return !this.hasWordCharAfterProtocolRegex.test( urlMatch );
			} else {
				return false;
			}
		},
	
	
		/**
		 * Determines if a protocol-relative match is an invalid one. This method
		 * returns `true` if there is a `protocolRelativeMatch`, and that match
		 * contains a word character before the '//' (i.e. it must contain
		 * whitespace or nothing before the '//' in order to be considered valid).
		 *
		 * @private
		 * @param {String} protocolRelativeMatch The protocol-relative string for a
		 *   URL match (i.e. '//'), possibly with a preceding character (ex, a
		 *   space, such as: ' //', or a letter, such as: 'a//'). The match is
		 *   invalid if there is a word character preceding the '//'.
		 * @return {Boolean} `true` if it is an invalid protocol-relative match,
		 *   `false` otherwise.
		 */
		isInvalidProtocolRelativeMatch : function( protocolRelativeMatch ) {
			return ( !!protocolRelativeMatch && this.invalidProtocolRelMatchRegex.test( protocolRelativeMatch ) );
		}
	
	} );
	
	/*global Autolinker */
	/**
	 * @abstract
	 * @class Autolinker.match.Match
	 * 
	 * Represents a match found in an input string which should be Autolinked. A Match object is what is provided in a 
	 * {@link Autolinker#replaceFn replaceFn}, and may be used to query for details about the match.
	 * 
	 * For example:
	 * 
	 *     var input = "...";  // string with URLs, Email Addresses, and Twitter Handles
	 *     
	 *     var linkedText = Autolinker.link( input, {
	 *         replaceFn : function( autolinker, match ) {
	 *             console.log( "href = ", match.getAnchorHref() );
	 *             console.log( "text = ", match.getAnchorText() );
	 *         
	 *             switch( match.getType() ) {
	 *                 case 'url' : 
	 *                     console.log( "url: ", match.getUrl() );
	 *                     
	 *                 case 'email' :
	 *                     console.log( "email: ", match.getEmail() );
	 *                     
	 *                 case 'twitter' :
	 *                     console.log( "twitter: ", match.getTwitterHandle() );
	 *             }
	 *         }
	 *     } );
	 *     
	 * See the {@link Autolinker} class for more details on using the {@link Autolinker#replaceFn replaceFn}.
	 */
	Autolinker.match.Match = Autolinker.Util.extend( Object, {
		
		/**
		 * @cfg {String} matchedText (required)
		 * 
		 * The original text that was matched.
		 */
		
		
		/**
		 * @constructor
		 * @param {Object} cfg The configuration properties for the Match instance, specified in an Object (map).
		 */
		constructor : function( cfg ) {
			Autolinker.Util.assign( this, cfg );
		},
	
		
		/**
		 * Returns a string name for the type of match that this class represents.
		 * 
		 * @abstract
		 * @return {String}
		 */
		getType : Autolinker.Util.abstractMethod,
		
		
		/**
		 * Returns the original text that was matched.
		 * 
		 * @return {String}
		 */
		getMatchedText : function() {
			return this.matchedText;
		},
		
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 * 
		 * @abstract
		 * @return {String}
		 */
		getAnchorHref : Autolinker.Util.abstractMethod,
		
		
		/**
		 * Returns the anchor text that should be generated for the match.
		 * 
		 * @abstract
		 * @return {String}
		 */
		getAnchorText : Autolinker.Util.abstractMethod
	
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Email
	 * @extends Autolinker.match.Match
	 * 
	 * Represents a Email match found in an input string which should be Autolinked.
	 * 
	 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
	 */
	Autolinker.match.Email = Autolinker.Util.extend( Autolinker.match.Match, {
		
		/**
		 * @cfg {String} email (required)
		 * 
		 * The email address that was matched.
		 */
		
	
		/**
		 * Returns a string name for the type of match that this class represents.
		 * 
		 * @return {String}
		 */
		getType : function() {
			return 'email';
		},
		
		
		/**
		 * Returns the email address that was matched.
		 * 
		 * @return {String}
		 */
		getEmail : function() {
			return this.email;
		},
		
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 * 
		 * @return {String}
		 */
		getAnchorHref : function() {
			return 'mailto:' + this.email;
		},
		
		
		/**
		 * Returns the anchor text that should be generated for the match.
		 * 
		 * @return {String}
		 */
		getAnchorText : function() {
			return this.email;
		}
		
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Hashtag
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Hashtag match found in an input string which should be
	 * Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more
	 * details.
	 */
	Autolinker.match.Hashtag = Autolinker.Util.extend( Autolinker.match.Match, {
	
		/**
		 * @cfg {String} serviceName (required)
		 *
		 * The service to point hashtag matches to. See {@link Autolinker#hashtag}
		 * for available values.
		 */
	
		/**
		 * @cfg {String} hashtag (required)
		 *
		 * The Hashtag that was matched, without the '#'.
		 */
	
	
		/**
		 * Returns the type of match that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'hashtag';
		},
	
	
		/**
		 * Returns the matched hashtag.
		 *
		 * @return {String}
		 */
		getHashtag : function() {
			return this.hashtag;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorHref : function() {
			var serviceName = this.serviceName,
			    hashtag = this.hashtag;
	
			switch( serviceName ) {
				case 'twitter' :
					return 'https://twitter.com/hashtag/' + hashtag;
				case 'facebook' :
					return 'https://www.facebook.com/hashtag/' + hashtag;
				case 'instagram' :
					return 'https://instagram.com/explore/tags/' + hashtag;
	
				default :  // Shouldn't happen because Autolinker's constructor should block any invalid values, but just in case.
					throw new Error( 'Unknown service name to point hashtag to: ', serviceName );
			}
		},
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorText : function() {
			return '#' + this.hashtag;
		}
	
	} );
	
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Phone
	 * @extends Autolinker.match.Match
	 *
	 * Represents a Phone number match found in an input string which should be
	 * Autolinked.
	 *
	 * See this class's superclass ({@link Autolinker.match.Match}) for more
	 * details.
	 */
	Autolinker.match.Phone = Autolinker.Util.extend( Autolinker.match.Match, {
	
		/**
		 * @cfg {String} number (required)
		 *
		 * The phone number that was matched.
		 */
	
	
		/**
		 * Returns a string name for the type of match that this class represents.
		 *
		 * @return {String}
		 */
		getType : function() {
			return 'phone';
		},
	
	
		/**
		 * Returns the phone number that was matched.
		 *
		 * @return {String}
		 */
		getNumber: function() {
			return this.number;
		},
	
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorHref : function() {
			return 'tel:' + this.number;
		},
	
	
		/**
		 * Returns the anchor text that should be generated for the match.
		 *
		 * @return {String}
		 */
		getAnchorText : function() {
			return this.matchedText;
		}
	
	} );
	
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Twitter
	 * @extends Autolinker.match.Match
	 * 
	 * Represents a Twitter match found in an input string which should be Autolinked.
	 * 
	 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
	 */
	Autolinker.match.Twitter = Autolinker.Util.extend( Autolinker.match.Match, {
		
		/**
		 * @cfg {String} twitterHandle (required)
		 * 
		 * The Twitter handle that was matched.
		 */
		
	
		/**
		 * Returns the type of match that this class represents.
		 * 
		 * @return {String}
		 */
		getType : function() {
			return 'twitter';
		},
		
		
		/**
		 * Returns a string name for the type of match that this class represents.
		 * 
		 * @return {String}
		 */
		getTwitterHandle : function() {
			return this.twitterHandle;
		},
		
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 * 
		 * @return {String}
		 */
		getAnchorHref : function() {
			return 'https://twitter.com/' + this.twitterHandle;
		},
		
		
		/**
		 * Returns the anchor text that should be generated for the match.
		 * 
		 * @return {String}
		 */
		getAnchorText : function() {
			return '@' + this.twitterHandle;
		}
		
	} );
	/*global Autolinker */
	/**
	 * @class Autolinker.match.Url
	 * @extends Autolinker.match.Match
	 * 
	 * Represents a Url match found in an input string which should be Autolinked.
	 * 
	 * See this class's superclass ({@link Autolinker.match.Match}) for more details.
	 */
	Autolinker.match.Url = Autolinker.Util.extend( Autolinker.match.Match, {
		
		/**
		 * @cfg {String} url (required)
		 * 
		 * The url that was matched.
		 */
		
		/**
		 * @cfg {Boolean} protocolUrlMatch (required)
		 * 
		 * `true` if the URL is a match which already has a protocol (i.e. 'http://'), `false` if the match was from a 'www' or
		 * known TLD match.
		 */
		
		/**
		 * @cfg {Boolean} protocolRelativeMatch (required)
		 * 
		 * `true` if the URL is a protocol-relative match. A protocol-relative match is a URL that starts with '//',
		 * and will be either http:// or https:// based on the protocol that the site is loaded under.
		 */
		
		/**
		 * @cfg {Boolean} stripPrefix (required)
		 * @inheritdoc Autolinker#stripPrefix
		 */
		
	
		/**
		 * @private
		 * @property {RegExp} urlPrefixRegex
		 * 
		 * A regular expression used to remove the 'http://' or 'https://' and/or the 'www.' from URLs.
		 */
		urlPrefixRegex: /^(https?:\/\/)?(www\.)?/i,
		
		/**
		 * @private
		 * @property {RegExp} protocolRelativeRegex
		 * 
		 * The regular expression used to remove the protocol-relative '//' from the {@link #url} string, for purposes
		 * of {@link #getAnchorText}. A protocol-relative URL is, for example, "//yahoo.com"
		 */
		protocolRelativeRegex : /^\/\//,
		
		/**
		 * @private
		 * @property {Boolean} protocolPrepended
		 * 
		 * Will be set to `true` if the 'http://' protocol has been prepended to the {@link #url} (because the
		 * {@link #url} did not have a protocol)
		 */
		protocolPrepended : false,
		
	
		/**
		 * Returns a string name for the type of match that this class represents.
		 * 
		 * @return {String}
		 */
		getType : function() {
			return 'url';
		},
		
		
		/**
		 * Returns the url that was matched, assuming the protocol to be 'http://' if the original
		 * match was missing a protocol.
		 * 
		 * @return {String}
		 */
		getUrl : function() {
			var url = this.url;
			
			// if the url string doesn't begin with a protocol, assume 'http://'
			if( !this.protocolRelativeMatch && !this.protocolUrlMatch && !this.protocolPrepended ) {
				url = this.url = 'http://' + url;
				
				this.protocolPrepended = true;
			}
			
			return url;
		},
		
	
		/**
		 * Returns the anchor href that should be generated for the match.
		 * 
		 * @return {String}
		 */
		getAnchorHref : function() {
			var url = this.getUrl();
			
			return url.replace( /&amp;/g, '&' );  // any &amp;'s in the URL should be converted back to '&' if they were displayed as &amp; in the source html 
		},
		
		
		/**
		 * Returns the anchor text that should be generated for the match.
		 * 
		 * @return {String}
		 */
		getAnchorText : function() {
			var anchorText = this.getUrl();
			
			if( this.protocolRelativeMatch ) {
				// Strip off any protocol-relative '//' from the anchor text
				anchorText = this.stripProtocolRelativePrefix( anchorText );
			}
			if( this.stripPrefix ) {
				anchorText = this.stripUrlPrefix( anchorText );
			}
			anchorText = this.removeTrailingSlash( anchorText );  // remove trailing slash, if there is one
			
			return anchorText;
		},
		
		
		// ---------------------------------------
		
		// Utility Functionality
		
		/**
		 * Strips the URL prefix (such as "http://" or "https://") from the given text.
		 * 
		 * @private
		 * @param {String} text The text of the anchor that is being generated, for which to strip off the
		 *   url prefix (such as stripping off "http://")
		 * @return {String} The `anchorText`, with the prefix stripped.
		 */
		stripUrlPrefix : function( text ) {
			return text.replace( this.urlPrefixRegex, '' );
		},
		
		
		/**
		 * Strips any protocol-relative '//' from the anchor text.
		 * 
		 * @private
		 * @param {String} text The text of the anchor that is being generated, for which to strip off the
		 *   protocol-relative prefix (such as stripping off "//")
		 * @return {String} The `anchorText`, with the protocol-relative prefix stripped.
		 */
		stripProtocolRelativePrefix : function( text ) {
			return text.replace( this.protocolRelativeRegex, '' );
		},
		
		
		/**
		 * Removes any trailing slash from the given `anchorText`, in preparation for the text to be displayed.
		 * 
		 * @private
		 * @param {String} anchorText The text of the anchor that is being generated, for which to remove any trailing
		 *   slash ('/') that may exist.
		 * @return {String} The `anchorText`, with the trailing slash removed.
		 */
		removeTrailingSlash : function( anchorText ) {
			if( anchorText.charAt( anchorText.length - 1 ) === '/' ) {
				anchorText = anchorText.slice( 0, -1 );
			}
			return anchorText;
		}
		
	} );
	return Autolinker;
	
	}));


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(45);
	var bind = __webpack_require__(284);
	var Axios = __webpack_require__(823);
	var defaults = __webpack_require__(162);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(281);
	axios.CancelToken = __webpack_require__(822);
	axios.isCancel = __webpack_require__(282);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(837);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(281);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(162);
	var utils = __webpack_require__(45);
	var InterceptorManager = __webpack_require__(824);
	var dispatchRequest = __webpack_require__(825);
	var isAbsoluteURL = __webpack_require__(833);
	var combineURLs = __webpack_require__(831);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(45);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(45);
	var transformData = __webpack_require__(828);
	var isCancel = __webpack_require__(282);
	var defaults = __webpack_require__(162);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 826 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 @ @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.response = response;
	  return error;
	};


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(283);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response
	    ));
	  }
	};


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(45);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 829 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(45);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 831 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(45);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 833 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(45);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(45);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(45);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 837 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(17);
	
	var _SignIn = __webpack_require__(839);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	var _ResetPassword = __webpack_require__(285);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _mobxReact = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Components
	// import SignUp from './SignUp.js';
	
	
	var Session = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Session, _React$Component);
	
	  function Session() {
	    _classCallCheck(this, Session);
	
	    var _this = _possibleConstructorReturn(this, (Session.__proto__ || Object.getPrototypeOf(Session)).call(this));
	
	    _this.createProctor = _this.createProctor.bind(_this);
	    _this.handleSignup = _this.handleSignup.bind(_this);
	    return _this;
	  }
	
	  _createClass(Session, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        pageContent: _react2.default.createElement(_SignIn2.default, Object.assign({}, this.props, { checkValidity: _helpers.checkValidity })),
	        username: null,
	        password: null
	      };
	
	      if (this.props.store.SessionStore.userData && sessionStorage.getItem('token')) {
	        // Redirect to dashboard if the user is already logged in
	        this.props.routing.history.push('/');
	      } else {
	        // Otherwise, clear out old session data
	        this.props.store.SessionStore.removeLocalStorage();
	      }
	
	      if (this.props.content === 'Reset') {
	        this.state = {
	          pageContent: _react2.default.createElement(_ResetPassword2.default, Object.assign({}, this.props, { checkValidity: _helpers.checkValidity }))
	        };
	      }
	
	      // if(this.props.content === 'SignUp') {
	      //   this.setState({
	      //     pageContent: <SignUp {...this.props} createProctor={this.createProctor} checkValidity={checkValidity} handleSignup={this.handleSignup} />
	      //   });
	      // }
	      //
	      // if(this.props.content === 'SignIn') {
	      //   this.setState({
	      //     pageContent: <SignIn {...this.props} checkValidity={checkValidity} />
	      //   });
	      // }
	    }
	  }, {
	    key: 'createProctor',
	    value: function createProctor() {
	      this.props.store.RegisterStore.createProctor(this.handleSignup);
	    }
	  }, {
	    key: 'handleSignup',
	    value: function handleSignup() {
	      this.props.routing.history.push('/register');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // const { translation } = this.props;
	
	      var backgroundImg = 'url(../static/img/bg-sign-up.jpg)';
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'page page--graphic page--pane-right', style: { backgroundImage: backgroundImg } },
	        _react2.default.createElement(
	          'div',
	          { className: 'page--graphic__content wrap' },
	          _react2.default.createElement('img', { src: '../static/img/logo-white.png', width: '300', alt: 'SmarterProctoring' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'pane pane--right pane--fixed' },
	          this.state.pageContent
	        )
	      );
	    }
	  }]);
	
	  return Session;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Session')(Session);

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { Link } from 'react-router';
	
	// Translations
	
	
	var SignIn = function (_React$Component) {
	  _inherits(SignIn, _React$Component);
	
	  function SignIn() {
	    _classCallCheck(this, SignIn);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (SignIn.__proto__ || Object.getPrototypeOf(SignIn)).call(this));
	
	    _this.handleLoginInput = _this.handleLoginInput.bind(_this);
	    _this.login = _this.login.bind(_this);
	    _this.handleLogin = _this.handleLogin.bind(_this);
	    _this.forgotPassword = _this.forgotPassword.bind(_this);
	    _this.resetPassword = _this.resetPassword.bind(_this);
	    return _this;
	  }
	
	  _createClass(SignIn, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        username: null,
	        password: null,
	        forgotPassword: false,
	        resetSent: false
	      };
	    }
	  }, {
	    key: 'handleLoginInput',
	    value: function handleLoginInput() {
	      this.setState({
	        username: this.username.value,
	        password: this.password.value
	      });
	    }
	  }, {
	    key: 'login',
	    value: function login() {
	      this.props.store.SessionStore.login(this.state.username, this.state.password, this.handleLogin);
	    }
	  }, {
	    key: 'handleLogin',
	    value: function handleLogin() {
	      this.props.routing.history.push('/');
	    }
	  }, {
	    key: 'forgotPassword',
	    value: function forgotPassword(e) {
	      e.preventDefault();
	
	      this.setState({
	        forgotPassword: !this.state.forgotPassword
	      });
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword() {
	      var _this2 = this;
	
	      var SettingsStore = this.props.store.SettingsStore;
	
	
	      var callback = function callback() {
	        _this2.setState({
	          resetSent: true
	        });
	      };
	
	      SettingsStore.resetPassword(this.email.value, callback);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	
	
	      if (!this.state.forgotPassword) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'pane__content' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'pane__title' },
	            translation.heading
	          ),
	          _react2.default.createElement(
	            'form',
	            {
	              onSubmit: function onSubmit(e) {
	                return _this3.props.checkValidity(e, _this3.login);
	              },
	              noValidate: true
	            },
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    {
	                      className: 'meta',
	                      htmlFor: 'signup-email'
	                    },
	                    translation.email
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'email',
	                    id: 'signup-email',
	                    placeholder: translation.email,
	                    required: true,
	                    'aria-required': 'true',
	                    onChange: this.handleLoginInput,
	                    ref: function ref(input) {
	                      return _this3.username = input;
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    {
	                      className: 'meta',
	                      htmlFor: 'signup-password'
	                    },
	                    translation.password
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'password',
	                    id: 'signup-password',
	                    placeholder: translation.password,
	                    required: true,
	                    'aria-required': 'true',
	                    onChange: this.handleLoginInput,
	                    ref: function ref(input) {
	                      return _this3.password = input;
	                    }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn--link',
	                type: 'button',
	                onClick: function onClick(e) {
	                  return _this3.forgotPassword(e);
	                }
	              },
	              translation.forgot_password
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn',
	                type: 'submit'
	              },
	              translation.sign_in
	            )
	          )
	        );
	      } else if (this.state.forgotPassword && !this.state.resetSent) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'pane__content' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'pane__title' },
	            translation.forgot_password
	          ),
	          _react2.default.createElement(
	            'form',
	            {
	              onSubmit: function onSubmit(e) {
	                return _this3.props.checkValidity(e, _this3.resetPassword);
	              },
	              noValidate: true
	            },
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    {
	                      className: 'meta',
	                      htmlFor: 'forgot-email'
	                    },
	                    translation.email
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'email',
	                    id: 'forgot-email',
	                    placeholder: translation.email,
	                    required: true,
	                    'aria-required': 'true',
	                    ref: function ref(input) {
	                      return _this3.email = input;
	                    }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn--link',
	                type: 'button',
	                onClick: function onClick(e) {
	                  return _this3.forgotPassword(e);
	                }
	              },
	              translation.cancel
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn',
	                type: 'submit'
	              },
	              translation.reset
	            )
	          )
	        );
	      } else if (this.state.forgotPassword && this.state.resetSent) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'pane__content' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'pane__title' },
	            translation.reset_heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.reset_body
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return SignIn;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('SignIn')(SignIn);

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(17);
	
	var _ResetPassword = __webpack_require__(285);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Components
	
	
	var UpdatePassword = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(UpdatePassword, _React$Component);
	
	  function UpdatePassword() {
	    _classCallCheck(this, UpdatePassword);
	
	    return _possibleConstructorReturn(this, (UpdatePassword.__proto__ || Object.getPrototypeOf(UpdatePassword)).apply(this, arguments));
	  }
	
	  _createClass(UpdatePassword, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'page wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            translation.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'note note--prominent' },
	            translation.body
	          ),
	          _react2.default.createElement(_ResetPassword2.default, Object.assign({}, this.props, {
	            checkValidity: _helpers.checkValidity,
	            standalone: true
	          }))
	        )
	      );
	    }
	  }]);
	
	  return UpdatePassword;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('UpdatePassword')(UpdatePassword);

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _config = __webpack_require__(24);
	
	var _helpers = __webpack_require__(17);
	
	var _reactLaunchDarkly = __webpack_require__(60);
	
	var _logrocket = __webpack_require__(334);
	
	var _logrocket2 = _interopRequireDefault(_logrocket);
	
	var _Header = __webpack_require__(288);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Tools = __webpack_require__(866);
	
	var _Tools2 = _interopRequireDefault(_Tools);
	
	var _DelayRender = __webpack_require__(855);
	
	var _DelayRender2 = _interopRequireDefault(_DelayRender);
	
	var _Footer = __webpack_require__(287);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Loader = __webpack_require__(164);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Dialog = __webpack_require__(163);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Confirm = __webpack_require__(286);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _Prompt = __webpack_require__(861);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	var _ExpireWarning = __webpack_require__(856);
	
	var _ExpireWarning2 = _interopRequireDefault(_ExpireWarning);
	
	var _FeatureNotice = __webpack_require__(857);
	
	var _FeatureNotice2 = _interopRequireDefault(_FeatureNotice);
	
	var _Toaster = __webpack_require__(291);
	
	var _Toaster2 = _interopRequireDefault(_Toaster);
	
	var _Notification = __webpack_require__(859);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _stores = __webpack_require__(118);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	// Store
	
	
	var App = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));
	
	    _this2.updateToken = _this2.updateToken.bind(_this2);
	    _this2.getData = _this2.getData.bind(_this2);
	    _this2.refresh = _this2.refresh.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(App, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var params = new URLSearchParams(location.search);
	      var SessionStore = _stores2.default.SessionStore,
	          HelpStore = _stores2.default.HelpStore;
	
	      // If there’s a token provided in the URL, add it to session storage
	
	      if (SessionStore.hasSessionStorage) {
	
	        if (sessionStorage.getItem('token') && params.get('token')) {
	          sessionStorage.removeItem('token');
	          sessionStorage.setItem('token', params.get('token'));
	          this.checkToken();
	        }
	
	        if (!sessionStorage.getItem('token') && params.get('token')) {
	          sessionStorage.setItem('token', params.get('token'));
	
	          // Check the token
	          this.checkToken();
	
	          // Set token to api header
	          (0, _config.setToken)(sessionStorage.getItem('token'));
	          SessionStore.startTokenTimer(sessionStorage.getitem('token'));
	        }
	      } else {
	        if ((0, _helpers.getCookie)('token') && this.props.routing.location.query.token) {
	          (0, _helpers.deleteCookie)('token');
	        }
	
	        if (!(0, _helpers.getCookie)('token') && this.props.routing.location.query.token) {
	          document.cookie = 'token=' + this.props.routing.location.query.token;
	
	          // Check the token
	          this.checkToken();
	
	          // Set token to api header
	          (0, _config.setToken)((0, _helpers.getCookie)('token'));
	          SessionStore.startTokenTimer((0, _helpers.getCookie)('token'));
	        }
	      }
	
	      // Retrieve user data from localStorage
	      var userData = {};
	
	      if (SessionStore.hasSessionStorage) {
	        userData = sessionStorage.getItem('userData');
	      } else {
	        userData = (0, _helpers.getCookie)('userData');
	      }
	
	      if (userData && !SessionStore.userData) {
	        _stores2.default.SessionStore.getLocalStorage(JSON.parse(userData));
	      }
	
	      // Get help documents
	      if (!HelpStore.helpLoaded) {
	        HelpStore.getHelp();
	      }
	
	      // Redirect if not logged in
	      var _this = this;
	
	      setTimeout(function () {
	        if (!(0, _helpers.isAuthenticated)()) {
	          _this.props.routing.history.push('/account/sign-in');
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	      var SessionStore = _stores2.default.SessionStore;
	
	
	      var tokenDelay = setInterval(function () {
	        if (SessionStore.hasSessionStorage) {
	          if (sessionStorage.getItem('token')) {
	            if (sessionStorage.getItem('token') === null) {
	              return;
	            }
	            _this.updateToken(sessionStorage.getItem('token'));
	            clearInterval(tokenDelay);
	            SessionStore.tokenSet = true;
	            SessionStore.token = sessionStorage.getItem('token');
	          }
	        } else {
	          if ((0, _helpers.getCookie)('token')) {
	            _this.updateToken((0, _helpers.getCookie)('token'));
	            clearInterval(tokenDelay);
	            SessionStore.tokenSet = true;
	            SessionStore.token = (0, _helpers.getCookie)('token');
	          }
	        }
	      }, 100);
	
	      var passwordReset = false;
	
	      if (SessionStore.hasSessionStorage && sessionStorage.getItem('passwordReset')) {
	        passwordReset = sessionStorage.getItem('passwordReset');
	      } else if ((0, _helpers.getCookie)('passwordReset')) {
	        passwordReset = (0, _helpers.getCookie)('passwordReset');
	      }
	
	      var userDataDelay = setInterval(function () {
	        if (SessionStore.userData) {
	          if (SessionStore.userData.forcePasswordReset && passwordReset !== 'true') {
	            _this.props.routing.history.push('/update-password');
	          }
	
	          // Redirect if there’s a route specified in the token
	          if (SessionStore.userData.route && !SessionStore.refresh) {
	            _this.props.routing.history.push(SessionStore.userData.route);
	          } else {
	            SessionStore.refresh = false;
	          }
	
	          // If there’s a custom stylesheet specified, load it
	          if (SessionStore.userData.cssUrl) {
	            var cssId = 'account-css';
	
	            if (!document.querySelector('#' + cssId)) {
	              var customCss = document.createElement('link');
	              customCss.type = 'text/css';
	              customCss.rel = 'stylesheet';
	              customCss.id = cssId;
	              customCss.href = SessionStore.userData.cssUrl;
	              document.head.appendChild(customCss);
	            }
	          }
	
	          clearInterval(userDataDelay);
	        }
	      }, 100);
	
	      document.querySelector('body').className = document.querySelector('body').className.replace('logged-out', '');
	
	      if (SessionStore.userData) {
	        if (true) {
	          if (!_stores2.default.SessionStore.logRocketInit) {
	            _logrocket2.default.init(_config.config.logRocket);
	            _stores2.default.SessionStore.logRocketInit = true;
	          }
	        }
	      }
	
	      // Check browser support
	      _stores2.default.SessionStore.checkBrowser();
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      // Set the feature in the HelpStore
	      _stores2.default.HelpStore.feature = nextProps.feature;
	    }
	
	    // componentWillUpdate() {
	    //   let storedToken = sessionStorage.getItem('token');
	    //
	    //   // If the token has changed, update it
	    //   if(this.state.token !== storedToken) {
	    //     this.setState({
	    //       token: storedToken
	    //     });
	    //     this.updateToken(storedToken);
	    //   }
	    // }
	
	  }, {
	    key: 'checkToken',
	    value: function checkToken() {
	      var SessionStore = _stores2.default.SessionStore;
	
	      SessionStore.checkToken();
	    }
	  }, {
	    key: 'updateToken',
	    value: function updateToken(token) {
	      var SessionStore = _stores2.default.SessionStore;
	
	
	      (0, _config.setToken)(token, this.getData);
	      SessionStore.startTokenTimer(token);
	
	      (0, _config.setValidate)();
	    }
	  }, {
	    key: 'getData',
	    value: function getData() {
	      var SessionStore = _stores2.default.SessionStore;
	      var history = this.props.history;
	
	
	      var profileDelay = setInterval(function () {
	        if (SessionStore.hasSessionStorage) {
	          if (sessionStorage.getItem('userData')) {
	            var parsedUserData = JSON.parse(sessionStorage.getItem('userData'));
	            SessionStore.getProctorAccount(parsedUserData.proctorAccountSid);
	            SessionStore.getProfile(history);
	            clearInterval(profileDelay);
	          }
	        } else {
	          if ((0, _helpers.getCookie)('userData')) {
	            var _parsedUserData = JSON.parse((0, _helpers.getCookie)('userData'));
	            SessionStore.getProctorAccount(_parsedUserData.proctorAccountSid);
	            SessionStore.getProfile(history);
	            clearInterval(profileDelay);
	          }
	        }
	      }, 100);
	    }
	  }, {
	    key: 'checkAgreements',
	    value: function checkAgreements(env) {
	      var agreementDelay = setInterval(function () {
	        var userData = _stores2.default.SessionStore.userData;
	
	
	        if (userData && userData.sid) {
	          clearInterval(agreementDelay);
	
	          var agrOpts = {
	            mode: 'popup',
	            location: 'general-user-agreements',
	            target: userData.sid,
	            account: userData.proctorAccountSid
	          };
	
	          if (env === 'production') {
	            agrOpts.application = 'AP6800b9e2e1794dbbbf6ad866194821d3';
	            window.Agreements.setup(agrOpts);
	          } else {
	            agrOpts.application = 'APfb4f76ee1dc24d058048fdaed04f56f1';
	            window.Agreements.setup(agrOpts);
	          }
	        }
	      }, 100);
	    }
	  }, {
	    key: 'refresh',
	    value: function refresh() {
	      var history = this.props.history;
	      var SessionStore = _stores2.default.SessionStore;
	
	      var thisLocation = this.props.routing.history.location;
	
	      history.replace('/refresh');
	
	      setTimeout(function () {
	        SessionStore.refresh = true;
	        history.replace({ pathname: thisLocation.pathname, query: thisLocation.query });
	      });
	    }
	  }, {
	    key: 'embedSupportChat',
	    value: function embedSupportChat() {
	      var userData = _stores2.default.SessionStore.userData;
	
	      var token = sessionStorage.getItem('token');
	      var optionsDefined = !!window.inAppHelpOptions;
	
	      if (!optionsDefined) {
	        window.inAppHelpOptions = {
	          token: token,
	          application_sid: 'AP6800b9e2e1794dbbbf6ad866194821d3',
	          context: 'proctor_account',
	          sids: {
	            proctor_account_sid: userData.proctorAccountSid,
	            proctor_user_sid: userData.sid
	          }
	        };
	
	        var script = document.createElement('script');
	        script.src = _config.config.supportScriptUrl;
	        script.type = 'text/javascript';
	        script.onload = function () {
	          return window.initHelpCenter();
	        };
	
	        document.body.appendChild(script);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SessionStore = _stores2.default.SessionStore;
	
	      var test = null;
	
	      // Environment (used by LaunchDarkly)
	      var environment = 'develop';
	
	      if (true) {
	        environment = 'production';
	      }
	
	      if (false) {
	        environment = 'stage';
	      }
	
	      if (SessionStore.ldReady) {
	        if (SessionStore.hasSessionStorage) {
	          test = sessionStorage.getItem('token') && sessionStorage.getItem('userData');
	        } else {
	          test = (0, _helpers.getCookie)('token') && (0, _helpers.getCookie)('userData');
	        }
	      }
	
	      // Detect touch device
	      var docRoot = document.querySelector('html');
	      if ('ontouchstart' in document.documentElement) {
	        docRoot.className += ' touch';
	      }
	
	      // Remove no nav class from body
	      document.querySelector('body').className = document.querySelector('body').className.replace('no-nav', '');
	
	      if (SessionStore.tokenSet) {
	        // LaunchDarkly user config
	        var ldConfig = {};
	
	        if (SessionStore.userData) {
	          ldConfig = {
	            key: SessionStore.userData.proctorAccountSid,
	            custom: {
	              domain: window.location.hostname,
	              environment: environment,
	              account: SessionStore.userData.proctorAccountSid,
	              user: SessionStore.userData.sid
	            }
	          };
	        }
	
	        // Agreements UI
	        var agrScript = document.querySelector('#agr-ui');
	
	        if (!agrScript) {
	          var agr = document.createElement('script');
	          agr.id = 'agr-ui';
	          agr.type = 'text/javascript';
	          agr.async = true;
	
	          if (true) {
	            agr.src = 'https://s3.amazonaws.com/cdn.smarterservices.com/agreements/js/agreements.min.js';
	          } else {
	            agr.src = 'https://s3.amazonaws.com/smarterservices-static-staging/agreements-ui/js/agreements.min.js';
	          }
	
	          var _this = this;
	
	          agr.onload = function () {
	            _this.checkAgreements(("production"));
	          };
	
	          document.body.appendChild(agr);
	        }
	
	        // SessionStore.userData.skin = 'embed';
	        // SessionStore.userData.route = '/reports';
	
	        if (SessionStore.userData && SessionStore.userData.skin === 'embed') {
	          if (document.body.className.indexOf('no-head') < 0) {
	            document.body.className += ' no-head';
	          }
	        }
	        return _react2.default.createElement(
	          _reactLaunchDarkly.LaunchDarkly,
	          { clientId: _config.config.ldApiKey, user: ldConfig },
	          _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'maintenance-message',
	            renderFeatureCallback: function renderFeatureCallback(flagValue) {
	              if (flagValue && (typeof flagValue === 'undefined' ? 'undefined' : _typeof(flagValue)) === 'object' && flagValue.message !== undefined) {
	                // Redirect to maintenance page
	                window.location.href = '/maintenance';
	              }
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'viewport fill' },
	            _react2.default.createElement(
	              _DelayRender2.default,
	              { test: test },
	              SessionStore.userData && SessionStore.userData.skin !== 'embed' && _react2.default.createElement(_Header2.default, Object.assign({ store: _stores2.default }, this.props)),
	              SessionStore.userData && SessionStore.userData.skin === 'embed' && this.props.routing.history.location.pathname.indexOf('/reports') > -1 && _react2.default.createElement(
	                'div',
	                { className: 'toaster toaster--sm' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'wrap' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'All reports on this page are provided by SmarterProctoring. Please contact',
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        href: 'mailto:proctors@smarterproctoring.com?subject=Support%20Ticket'
	                      },
	                      'SmarterProctoring support'
	                    ),
	                    ' if you need additional information.'
	                  )
	                )
	              ),
	              SessionStore.userData && SessionStore.userData.skin === 'embed' && _react2.default.createElement(_Tools2.default, Object.assign({ store: _stores2.default }, this.props, { refresh: this.refresh })),
	              _react2.default.cloneElement(this.props.children, this.props),
	              SessionStore.userData && SessionStore.userData.skin !== 'embed' && _react2.default.createElement(_Footer2.default, { store: _stores2.default }),
	              _stores2.default.SessionStore.expireWarning && _react2.default.createElement(_ExpireWarning2.default, { store: _stores2.default }),
	              _stores2.default.SessionStore.dialog && _react2.default.createElement(_Dialog2.default, Object.assign({ store: _stores2.default }, this.props)),
	              _stores2.default.SessionStore.confirm && _react2.default.createElement(_Confirm2.default, { store: _stores2.default }),
	              _stores2.default.SessionStore.prompt && _react2.default.createElement(_Prompt2.default, { store: _stores2.default }),
	              _stores2.default.SessionStore.featureNotice && _react2.default.createElement(_FeatureNotice2.default, Object.assign({ store: _stores2.default }, this.props)),
	              _stores2.default.SessionStore.toaster && _react2.default.createElement(_Toaster2.default, { store: _stores2.default }),
	              _stores2.default.SessionStore.notification && _react2.default.createElement(_Notification2.default, Object.assign({ store: _stores2.default }, this.props)),
	              _stores2.default.SessionStore.browserUnsupported && _react2.default.createElement(
	                'div',
	                { className: 'toaster toaster--warning toaster--sm' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'wrap' },
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'You are using an unsupported browser. We recommend that you ',
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'http://outdatedbrowser.com/', target: '_blank' },
	                      'update your browser'
	                    ),
	                    ' for the best experience.'
	                  )
	                )
	              ),
	              _stores2.default.SessionStore.loading && _react2.default.createElement(_Loader2.default, { store: _stores2.default }),
	              _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                flagKey: 'proctor-support-chat',
	                renderFeatureCallback: this.embedSupportChat,
	                renderDefaultCallback: function renderDefaultCallback() {
	                  return null;
	                }
	              })
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component));
	
	exports.default = App;

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Loader = __webpack_require__(164);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Dialog = __webpack_require__(163);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Toaster = __webpack_require__(291);
	
	var _Toaster2 = _interopRequireDefault(_Toaster);
	
	var _stores = __webpack_require__(118);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	// Store
	
	
	var AppLoggedOut = function (_React$Component) {
	  _inherits(AppLoggedOut, _React$Component);
	
	  function AppLoggedOut() {
	    _classCallCheck(this, AppLoggedOut);
	
	    return _possibleConstructorReturn(this, (AppLoggedOut.__proto__ || Object.getPrototypeOf(AppLoggedOut)).apply(this, arguments));
	  }
	
	  _createClass(AppLoggedOut, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Check browser support
	      _stores2.default.SessionStore.checkBrowser();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // Detect touch device
	      var docRoot = document.querySelector('html');
	      if ('ontouchstart' in document.documentElement) {
	        docRoot.className += ' touch';
	      }
	
	      if (document.querySelector('body').className.indexOf('logged-out') < 0) {
	        document.querySelector('body').className += ' logged-out';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'viewport' },
	        _react2.default.cloneElement(this.props.children, this.props),
	        _stores2.default.SessionStore.browserUnsupported && _react2.default.createElement(
	          'div',
	          { className: 'toaster toaster--warning toaster--sm' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'You are using an unsupported browser. We recommend that you ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://outdatedbrowser.com/', target: '_blank' },
	                'update your browser'
	              ),
	              ' for the best experience.'
	            )
	          )
	        ),
	        _stores2.default.SessionStore.loading && _react2.default.createElement(_Loader2.default, { store: _stores2.default }),
	        _stores2.default.SessionStore.dialog && _react2.default.createElement(_Dialog2.default, { store: _stores2.default }),
	        _stores2.default.SessionStore.toaster && _react2.default.createElement(_Toaster2.default, { store: _stores2.default })
	      );
	    }
	  }]);
	
	  return AppLoggedOut;
	}(_react2.default.Component);
	
	exports.default = (0, _mobxReact.observer)(AppLoggedOut);

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _config = __webpack_require__(24);
	
	var _helpers = __webpack_require__(17);
	
	var _reactLaunchDarkly = __webpack_require__(60);
	
	var _Header = __webpack_require__(288);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(287);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Loader = __webpack_require__(164);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	var _Dialog = __webpack_require__(163);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Confirm = __webpack_require__(286);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	var _stores = __webpack_require__(118);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	// Store
	
	
	var AppNoNav = function (_React$Component) {
	  _inherits(AppNoNav, _React$Component);
	
	  function AppNoNav() {
	    _classCallCheck(this, AppNoNav);
	
	    var _this2 = _possibleConstructorReturn(this, (AppNoNav.__proto__ || Object.getPrototypeOf(AppNoNav)).call(this));
	
	    _this2.updateToken = _this2.updateToken.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(AppNoNav, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = _stores2.default.SessionStore,
	          HelpStore = _stores2.default.HelpStore;
	
	      // Set default token
	
	      if (SessionStore.hasSessionStorage) {
	        this.setState({
	          token: sessionStorage.getItem('token')
	        });
	      } else {
	        this.setState({
	          token: (0, _helpers.getCookie)('token')
	        });
	      }
	
	      // Retrieve user data from localStorage
	      var userData = {};
	
	      if (SessionStore.hasSessionStorage) {
	        userData = sessionStorage.getItem('userData');
	      } else {
	        userData = (0, _helpers.getCookie)('userData');
	      }
	
	      if (userData) {
	        _stores2.default.SessionStore.getLocalStorage(JSON.parse(userData));
	      }
	
	      // Get help documents
	      if (!HelpStore.helpLoaded) {
	        HelpStore.getHelp();
	      }
	
	      // Redirect if not logged in
	      var _this = this;
	      setTimeout(function () {
	        if (!(0, _helpers.isAuthenticated)()) {
	          _this.props.routing.history.push('/account/sign-up');
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      this.updateToken(this.state.token);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps) {
	      var SessionStore = _stores2.default.SessionStore;
	
	      var storedToken = null;
	
	      if (SessionStore.hasSessionStorage) {
	        storedToken = sessionStorage.getItem('token');
	      } else {
	        storedToken = (0, _helpers.getCookie)('token');
	      }
	
	      // If the token has changed, update it
	      if (this.state.token !== storedToken) {
	        this.setState({
	          token: storedToken
	        });
	        this.updateToken(storedToken);
	      }
	
	      // Set the feature in the HelpStore
	      _stores2.default.HelpStore.feature = nextProps.feature;
	    }
	  }, {
	    key: 'updateToken',
	    value: function updateToken(token) {
	      var SessionStore = _stores2.default.SessionStore;
	
	
	      (0, _config.setToken)(token);
	      SessionStore.startTokenTimer(token);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SessionStore = _stores2.default.SessionStore;
	
	      // Detect touch device
	
	      var docRoot = document.querySelector('html');
	
	      if ('ontouchstart' in document.documentElement) {
	        docRoot.className += ' touch';
	      }
	
	      // Apply no-nav class to body
	      if (document.body.className.indexOf('no-nav') < 0) {
	        document.body.className += ' no-nav';
	      }
	
	      // Environment (used by LaunchDarkly)
	      var environment = 'develop';
	
	      if (true) {
	        environment = 'production';
	      }
	
	      if (false) {
	        environment = 'stage';
	      }
	
	      // LaunchDarkly user config
	      var ldConfig = {};
	
	      if (SessionStore.userData) {
	        ldConfig = {
	          key: SessionStore.userData.proctorAccountSid,
	          custom: {
	            domain: window.location.hostname,
	            environment: environment,
	            account: SessionStore.userData.proctorAccountSid,
	            user: SessionStore.userData.sid
	          }
	        };
	      }
	
	      return _react2.default.createElement(
	        _reactLaunchDarkly.LaunchDarkly,
	        { clientId: _config.config.ldApiKey, user: ldConfig },
	        _react2.default.createElement(
	          'div',
	          { className: 'viewport' },
	          _react2.default.createElement(_Header2.default, { store: _stores2.default, hideNav: true }),
	          _react2.default.cloneElement(this.props.children, this.props),
	          _react2.default.createElement(_Footer2.default, { store: _stores2.default }),
	          _stores2.default.SessionStore.loading && _react2.default.createElement(_Loader2.default, { store: _stores2.default }),
	          _stores2.default.SessionStore.dialog && _react2.default.createElement(_Dialog2.default, { store: _stores2.default }),
	          _stores2.default.SessionStore.confirm && _react2.default.createElement(_Confirm2.default, { store: _stores2.default })
	        )
	      );
	    }
	  }]);
	
	  return AppNoNav;
	}(_react2.default.Component);
	
	exports.default = (0, _mobxReact.observer)(AppNoNav);

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactSimpleDropdown = __webpack_require__(199);
	
	var _reactSimpleDropdown2 = _interopRequireDefault(_reactSimpleDropdown);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ics = __webpack_require__(1049);
	
	var _ics2 = _interopRequireDefault(_ics);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var AddToCalendar = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AddToCalendar, _React$Component);
	
	  function AddToCalendar() {
	    _classCallCheck(this, AddToCalendar);
	
	    return _possibleConstructorReturn(this, (AddToCalendar.__proto__ || Object.getPrototypeOf(AddToCalendar)).apply(this, arguments));
	  }
	
	  _createClass(AddToCalendar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          start = _props.start,
	          duration = _props.duration,
	          location = _props.location,
	          lat = _props.lat,
	          lon = _props.lon,
	          translation = _props.translation;
	
	      var startISO = (0, _moment2.default)(start, 'M-D-YYYY HH:mm Z').toISOString().replace(/-|:|\.\d\d\d/g, '');
	      var endISO = (0, _moment2.default)(start, 'M-D-YYYY HH:mm Z').add(duration, 'minutes').toISOString().replace(/-|:|\.\d\d\d/g, '');
	      var focus = false;
	
	      // Generate ICS file data
	      var newICS = new _ics2.default();
	
	      var calDownload = newICS.buildEvent({
	        start: (0, _moment2.default)(start).format('YYYY-MM-DD HH:mm'),
	        end: (0, _moment2.default)(start).add(duration, 'minutes').format('YYYY-MM-DD HH:mm'),
	        title: title,
	        location: location,
	        geo: {
	          lat: lat,
	          lon: lon
	        }
	      });
	
	      // Generate Google Calendar link
	      var calGoogle = 'https://calendar.google.com/calendar/render?action=TEMPLATE&dates=' + startISO + '/' + endISO + '&location=' + location + '&text=' + title;
	
	      // Generate Outlook.com link
	      var calOutlook = 'https://outlook.live.com/owa/?rru=addevent&startdt=' + startISO + '&enddt=' + endISO + '&subject=' + title + '&location=' + location + '&allday=false&path=/calendar/view/Month';
	
	      // Generate Yahoo Calendar link
	      var calYahoo = 'https://calendar.yahoo.com/?v=60&view=d&type=20&title=' + title + '&st=' + startISO + '&dur=' + duration + '&desc=&in_loc=' + location;
	
	      // Accessibility
	      function blurDropdown() {
	        if (focus) {
	          document.querySelector('.faux-select:focus').blur();
	        }
	
	        focus = !focus;
	      }
	
	      function focusButton(e) {
	        var el = e.target.parentElement;
	
	        while (el) {
	          if (el.className.indexOf('dropdown') > -1) {
	            el.className += ' dropdown--active';
	            return el;
	          } else {
	            el = el.parentElement;
	          }
	        }
	      }
	
	      function blurButton(e) {
	        var el = e.target.parentElement;
	
	        while (el) {
	          if (el.className.indexOf('dropdown') > -1) {
	            el.className = el.className.replace('dropdown--active', '');
	            return el;
	          } else {
	            el = el.parentElement;
	          }
	        }
	      }
	
	      // Return the menu
	      return _react2.default.createElement(
	        'div',
	        { className: 'faux-select calendar-add', tabIndex: '0' },
	        _react2.default.createElement(
	          _reactSimpleDropdown2.default,
	          { ref: 'fauxSelect' },
	          _react2.default.createElement(
	            _reactSimpleDropdown.DropdownTrigger,
	            { className: 'faux-select__selected', onClick: blurDropdown },
	            translation.label
	          ),
	          _react2.default.createElement(
	            _reactSimpleDropdown.DropdownContent,
	            null,
	            _react2.default.createElement(
	              'ul',
	              { className: 'faux-select__options dropdown__menu' },
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'faux-select__btn',
	                    href: 'data:text/calendar,' + encodeURI(calDownload),
	                    onFocus: function onFocus(e) {
	                      focusButton(e);
	                    },
	                    onBlur: function onBlur(e) {
	                      blurButton(e);
	                    }
	                  },
	                  _react2.default.createElement(icons.iconApple, null),
	                  translation.apple
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'faux-select__btn',
	                    target: '_blank',
	                    href: calGoogle,
	                    onFocus: function onFocus(e) {
	                      focusButton(e);
	                    },
	                    onBlur: function onBlur(e) {
	                      blurButton(e);
	                    }
	                  },
	                  _react2.default.createElement(icons.iconGoogle, null),
	                  translation.google
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'faux-select__btn',
	                    href: 'data:text/calendar,' + encodeURI(calDownload),
	                    onFocus: function onFocus(e) {
	                      focusButton(e);
	                    },
	                    onBlur: function onBlur(e) {
	                      blurButton(e);
	                    }
	                  },
	                  _react2.default.createElement(icons.iconMicrosoft, null),
	                  translation.outlook
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'faux-select__btn',
	                    target: '_blank',
	                    href: calOutlook,
	                    onFocus: function onFocus(e) {
	                      focusButton(e);
	                    },
	                    onBlur: function onBlur(e) {
	                      blurButton(e);
	                    }
	                  },
	                  _react2.default.createElement(icons.iconMicrosoft, null),
	                  translation.outlook_web
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'faux-select__btn',
	                    target: '_blank',
	                    href: calYahoo,
	                    onFocus: function onFocus(e) {
	                      focusButton(e);
	                    },
	                    onBlur: function onBlur(e) {
	                      blurButton(e);
	                    }
	                  },
	                  _react2.default.createElement(icons.iconYahoo, null),
	                  translation.yahoo
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddToCalendar;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('AddToCalendar')(AddToCalendar);

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(76);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _react3 = __webpack_require__(536);
	
	var _react4 = _interopRequireDefault(_react3);
	
	__webpack_require__(1038);
	
	__webpack_require__(1284);
	
	var _mobxReact = __webpack_require__(9);
	
	var _resourceTimeline = __webpack_require__(539);
	
	var _resourceTimeline2 = _interopRequireDefault(_resourceTimeline);
	
	var _helpers = __webpack_require__(17);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _IncidentForm = __webpack_require__(300);
	
	var _IncidentForm2 = _interopRequireDefault(_IncidentForm);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDatepicker = __webpack_require__(68);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Import the base FullCalendar styles
	
	
	var AppointmentTimeline = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AppointmentTimeline, _React$Component);
	
	  function AppointmentTimeline() {
	    _classCallCheck(this, AppointmentTimeline);
	
	    var _this = _possibleConstructorReturn(this, (AppointmentTimeline.__proto__ || Object.getPrototypeOf(AppointmentTimeline)).call(this));
	
	    _this.datesUpdated = function (dateInfo) {
	      var ScheduleStore = _this.props.store.ScheduleStore;
	
	      ScheduleStore.getTimelineEvents(dateInfo.startStr, dateInfo.endStr);
	      _this.setState({ dateSelected: dateInfo.startStr });
	    };
	
	    _this.handleSelectedDate = function (newDate) {
	      var calendarApi = _this.calendarRef.current.getApi();
	      calendarApi.gotoDate(newDate);
	      _this.setState({ showDatePicker: false });
	    };
	
	    _this.state = {
	      drawerOpen: false,
	      drawerContent: null,
	      session: null,
	      dateSelected: null,
	      showDatePicker: false
	    };
	    _this.completeIncident = _this.completeIncident.bind(_this);
	    _this.refreshEvents = _this.refreshEvents.bind(_this);
	    _this.calendarRef = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(AppointmentTimeline, [{
	    key: 'completeIncident',
	    value: function completeIncident() {
	      var _props$store = this.props.store,
	          ManagerStore = _props$store.ManagerStore,
	          SessionStore = _props$store.SessionStore;
	
	      ManagerStore.reportIncident = false;
	      SessionStore.showToaster("Incident Saved", 'success');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.refreshEvents();
	      setInterval(this.refreshEvents, 60000);
	    }
	  }, {
	    key: 'refreshEvents',
	    value: function refreshEvents() {
	      var ScheduleStore = this.props.store.ScheduleStore;
	      var dateSelected = this.state.dateSelected;
	
	
	      if (dateSelected) {
	        var startTime = (0, _moment2.default)(dateSelected).startOf('day').format('YYYY-MM-DDTHH:mm:ssZ');
	        var endTime = (0, _moment2.default)(dateSelected).endOf('day').format('YYYY-MM-DDTHH:mm:ssZ');
	
	        ScheduleStore.getTimelineEvents(startTime, endTime);
	      } else {
	        ScheduleStore.getTimelineEvents();
	      }
	
	      ScheduleStore.getTimelineResources();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$store2 = this.props.store,
	          ScheduleStore = _props$store2.ScheduleStore,
	          ManagerStore = _props$store2.ManagerStore;
	      var showDatePicker = this.state.showDatePicker;
	
	
	      var customButtons = {
	        selectDate: {
	          text: "Select a date",
	          click: function click() {
	            _this2.setState({ showDatePicker: true });
	          }
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'appointment-timeline' },
	        _react2.default.createElement(
	          'main',
	          { tabIndex: '0', id: 'main-content', className: 'page' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Appointment Timeline'
	          ),
	          showDatePicker && _react2.default.createElement(
	            'div',
	            { className: 'react-datepicker--wrap' },
	            _react2.default.createElement(_reactDatepicker2.default, {
	              inline: true,
	              onChange: this.handleSelectedDate,
	              onClickOutside: function onClickOutside() {
	                return _this2.setState({ showDatePicker: false });
	              }
	            })
	          ),
	          _react2.default.createElement(_react4.default, {
	            schedulerLicenseKey: '0832097408-fcs-1687374553',
	            ref: this.calendarRef,
	            aspectRatio: 1.6,
	            slotDuration: '00:15',
	            timeZone: 'local',
	            nowIndicator: true,
	            resourceAreaHeaderContent: "Locations",
	            plugins: [_resourceTimeline2.default],
	            initialView: 'resourceTimelineDay',
	            events: ScheduleStore.timelineEvents,
	            resources: ScheduleStore.timelineResources,
	            resourceGroupField: 'location',
	            resourceOrder: '',
	            editable: true,
	            datesSet: function datesSet(dateInfo) {
	              return _this2.datesUpdated(dateInfo);
	            },
	            eventMouseEnter: function eventMouseEnter(info) {
	              /*
	              TODO: Implement a sticky popup instead of a tooltip, trying to force our styles over the Full calendar styles is not going well
	              const tooltip = document.createElement('div');
	              tooltip.textContent = `Name: ${info.event.title} \n Appointment Start: ${moment.utc(info.event.start).format('HH:mm')} \n Appointment End: ${moment.utc(info.event.end).format('HH:mm')} \n Exam Name: \n Course `; // Set the tooltip text
	               // Apply styling to the tooltip element
	              tooltip.classList.add('timeline-tooltip');
	              tooltip.addEventListener('mouseout', () => {
	                tooltip.remove();
	              });
	              info.el.appendChild(tooltip);
	                */
	            },
	            eventClick: function () {
	              var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(info) {
	                var extendedProps, response;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        extendedProps = info.event.extendedProps;
	                        _context.next = 3;
	                        return ManagerStore.getExamSession(extendedProps.install.sid, extendedProps.exam.sid, extendedProps.session.sid, 'uggg', _this2, true);
	
	                      case 3:
	                        response = _context.sent;
	
	                        _this2.setState({ session: response });
	                        (0, _helpers.toggleDrawer)(null, _this2, 'SessionDetail');
	
	                      case 6:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this2);
	              }));
	
	              return function (_x) {
	                return _ref.apply(this, arguments);
	              };
	            }(),
	            customButtons: customButtons,
	
	            headerToolbar: {
	              left: 'prev,next today',
	              center: 'title',
	              right: 'selectDate'
	            }
	
	          })
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          sessionSid: this.state.session ? this.state.session.sid : null,
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          refreshEvents: this.refreshEvents,
	          handleSelectedDate: this.handleSelectedDate,
	          parent: this,
	          timeline: true,
	          appointmentTimeline: true
	        }, this.props)),
	        _react2.default.createElement(
	          'div',
	          { className: 'session-interact  ' + (ManagerStore.reportIncident ? 'active' : '') },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel--brief' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Report Incident'
	            ),
	            ManagerStore.reportIncident && _react2.default.createElement(_IncidentForm2.default, Object.assign({
	              installSid: this.props.store.ScheduleStore.session.installSid,
	              examSid: this.props.store.ScheduleStore.session.examSid,
	              complete: this.completeIncident
	            }, this.props))
	          )
	        )
	      );
	    }
	  }]);
	
	  return AppointmentTimeline;
	}(_react2.default.Component));exports.default = (0, _Translate2.default)('AppointmentTimeline')(AppointmentTimeline);

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _config = __webpack_require__(24);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	var Checkout = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Checkout, _React$Component);
	
	  function Checkout() {
	    _classCallCheck(this, Checkout);
	
	    var _this = _possibleConstructorReturn(this, (Checkout.__proto__ || Object.getPrototypeOf(Checkout)).call(this));
	
	    _this.handleEventListener = _this.handleEventListener.bind(_this);
	    return _this;
	  }
	
	  _createClass(Checkout, [{
	    key: 'handleEventListener',
	    value: function handleEventListener(event) {
	      // Verify the origin of the message
	      if (event.origin === 'https://support.smarterservices.com' || event.origin === 'https://support.dev.smarterservices.com') {
	        try {
	          // Parsing the received message
	          var message = JSON.parse(event.data);
	
	          if (message.type === 'checked-out') {
	            this.props.refreshList({});
	            (0, _helpers.closeDrawer)(null, this.props.parent);
	          }
	        } catch (e) {
	          console.error('Error parsing message:', e);
	        }
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('message', this.handleEventListener);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('message', this.handleEventListener);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          sessionSid = _props.sessionSid,
	          store = _props.store,
	          translation = _props.translation;
	      var userData = store.SessionStore.userData;
	
	      var token = sessionStorage.getItem('token');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap wrap--large' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.heading
	            )
	          )
	        ),
	        _react2.default.createElement('iframe', {
	          className: 'iframe--full',
	          src: _config.config.checkoutUrlBase + '&sessionSid=' + sessionSid + '&proctorUserSid=' + userData.sid + '&token=' + token
	        })
	      );
	    }
	  }]);
	
	  return Checkout;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Checkout')(Checkout);

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactdatagridCommunity = __webpack_require__(146);
	
	var _reactdatagridCommunity2 = _interopRequireDefault(_reactdatagridCommunity);
	
	__webpack_require__(330);
	
	__webpack_require__(331);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _helpers = __webpack_require__(17);
	
	var _iamReactClient = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var CheckoutQueue = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(CheckoutQueue, _React$Component);
	
	  function CheckoutQueue() {
	    _classCallCheck(this, CheckoutQueue);
	
	    var _this = _possibleConstructorReturn(this, (CheckoutQueue.__proto__ || Object.getPrototypeOf(CheckoutQueue)).call(this));
	
	    _this.renderDisconnectReason = _this.renderDisconnectReason.bind(_this);
	    _this.renderCheckoutButton = _this.renderCheckoutButton.bind(_this);
	    _this.loadData = _this.loadData.bind(_this);
	
	    _this.state = {
	      drawerOpen: false,
	      selectedSession: '',
	      limit: 0,
	      offset: 0
	    };
	    return _this;
	  }
	
	  _createClass(CheckoutQueue, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var iam = sessionStorage.getItem('iam');
	      var proctorAccountSid = this.props.store.SessionStore.userData.proctorAccountSid;
	
	
	      if (!(0, _iamReactClient.isAuthorized)('sp:DescribeCheckoutQueue', 'ssrn:ss:sp::' + proctorAccountSid + ':checkoutQueue', iam)) {
	        this.props.routing.history.push('/unauthorized');
	      }
	    }
	  }, {
	    key: 'renderDisconnectReason',
	    value: function renderDisconnectReason(_ref) {
	      var data = _ref.data;
	
	      switch (data.disconnectReasonId) {
	        case 'test-taker-ended':
	          return 'Completed successfully';
	
	        case 'proctor-ended':
	          return 'Removed from testing session';
	
	        case 'internet-disconnected':
	          return 'Internet disconnected';
	
	        default:
	          return 'Unknown';
	      }
	    }
	  }, {
	    key: 'renderCheckoutButton',
	    value: function renderCheckoutButton(data) {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	      var sessionSid = data.sid;
	      return _react2.default.createElement(
	        'span',
	        { className: 'data-grid--center' },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'btn',
	            onClick: function onClick() {
	              (0, _helpers.toggleDrawer)(null, _this2, 'Checkout');
	              _this2.setState({ selectedSession: sessionSid });
	            }
	          },
	          translation.checkout
	        )
	      );
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(_ref2) {
	      var skip = _ref2.skip,
	          limit = _ref2.limit;
	      var HybridStore = this.props.store.HybridStore;
	
	
	      if (!skip) skip = this.state.offset;
	      if (!limit) limit = this.state.limit;
	
	      this.setState({ limit: limit, offset: skip });
	
	      return HybridStore.listCheckoutSessions(limit, skip, true).then(function (response) {
	        return { data: response.results, count: response.total };
	      });
	    }
	  }, {
	    key: 'refreshData',
	    value: function refreshData() {
	      // This changes the instance of the function loadData which means a new prop
	      // gets passed to the data grid triggering a refresh of the list
	      this.loadData = this.loadData.bind(this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _state = this.state,
	          drawerOpen = _state.drawerOpen,
	          selectedSession = _state.selectedSession;
	
	
	      var gridStyle = { minHeight: 500, maxHeight: 2000 };
	      var columns = [{
	        name: 'appointmentDate',
	        header: 'Session Date',
	        defaultFlex: 1,
	        render: function render(_ref3) {
	          var data = _ref3.data;
	          return (0, _moment2.default)(data.appointmentDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z');
	        }
	      }, {
	        name: 'name',
	        header: 'Name',
	        type: 'string',
	        defaultFlex: 1,
	        render: function render(_ref4) {
	          var data = _ref4.data;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            data.enrollment.firstName + ' ' + data.enrollment.lastName
	          );
	        }
	      }, {
	        name: 'disconnectReasonId',
	        header: 'End Reason',
	        defaultFlex: 1,
	        render: function render(data) {
	          return _this3.renderDisconnectReason(data);
	        }
	      },
	      // {
	      //   name: 'sessionLength',
	      //   header: 'Duration'
	      // },
	      {
	        name: 'autoFlags',
	        header: 'AI Flags',
	        render: function render(_ref5) {
	          var data = _ref5.data;
	
	          return _react2.default.createElement(
	            'span',
	            { className: 'data-grid--center' },
	            data.annotationCounts.system
	          );
	        }
	      }, {
	        name: 'manualFlags',
	        header: 'Proctor Flags',
	        render: function render(_ref6) {
	          var data = _ref6.data;
	
	          return _react2.default.createElement(
	            'span',
	            { className: 'data-grid--center' },
	            data.annotationCounts.manual
	          );
	        }
	      }, {
	        name: 'checkout',
	        header: 'Checkout',
	        defaultFlex: 1,
	        render: function render(_ref7) {
	          var data = _ref7.data;
	          return _this3.renderCheckoutButton(data);
	        }
	      }];
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page fill' },
	        _react2.default.createElement(
	          'div',
	          { className: 'fill' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            translation.heading
	          ),
	          _react2.default.createElement(_reactdatagridCommunity2.default, {
	            className: 'reactDataGrid fill',
	            style: gridStyle,
	            idProperty: 'id',
	            columns: columns,
	            dataSource: this.loadData
	            //defaultFilterValue={filterValue}
	            //onFilterValueChange={setFilterObject}
	            //onSkipChange={setSkip}
	            //onLimitChange={setLimit}
	            //limit={limit}
	            //skip={skip}
	            //onRowClick={onRowClick}
	            , pagination: true
	          }),
	          drawerOpen && _react2.default.createElement(_Drawer2.default, Object.assign({
	            content: 'Checkout',
	            large: true,
	            isOpen: drawerOpen,
	            parent: this,
	            sessionSid: selectedSession,
	            refreshList: function refreshList() {
	              return _this3.refreshData();
	            }
	          }, this.props))
	        )
	      );
	    }
	  }]);
	
	  return CheckoutQueue;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('CheckoutQueue')(CheckoutQueue);

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GeneralInfo = __webpack_require__(850);
	
	var _GeneralInfo2 = _interopRequireDefault(_GeneralInfo);
	
	var _PasswordUpdate = __webpack_require__(853);
	
	var _PasswordUpdate2 = _interopRequireDefault(_PasswordUpdate);
	
	var _ProctoringInfo = __webpack_require__(297);
	
	var _ProctoringInfo2 = _interopRequireDefault(_ProctoringInfo);
	
	var _Locations = __webpack_require__(852);
	
	var _Locations2 = _interopRequireDefault(_Locations);
	
	var _ProfilePhoto = __webpack_require__(298);
	
	var _ProfilePhoto2 = _interopRequireDefault(_ProfilePhoto);
	
	var _Activate = __webpack_require__(295);
	
	var _Activate2 = _interopRequireDefault(_Activate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var CheckupStep = function (_React$Component) {
	  _inherits(CheckupStep, _React$Component);
	
	  function CheckupStep() {
	    _classCallCheck(this, CheckupStep);
	
	    return _possibleConstructorReturn(this, (CheckupStep.__proto__ || Object.getPrototypeOf(CheckupStep)).apply(this, arguments));
	  }
	
	  _createClass(CheckupStep, [{
	    key: 'render',
	    value: function render() {
	      var userData = this.props.store.SessionStore.userData;
	
	
	      if (userData.forcePasswordReset) {
	        switch (this.props.step) {
	          case 1:
	            return _react2.default.createElement(_GeneralInfo2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	          case 2:
	            return _react2.default.createElement(_PasswordUpdate2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	          case 3:
	            return _react2.default.createElement(_ProctoringInfo2.default, Object.assign({ nextStep: this.props.nextStep, lock: true }, this.props));
	
	          case 4:
	            return _react2.default.createElement(_Locations2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	          case 5:
	            return _react2.default.createElement(_ProfilePhoto2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	          case 6:
	            return _react2.default.createElement(_Activate2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	          default:
	            return _react2.default.createElement(_GeneralInfo2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	        }
	      } else {
	        switch (this.props.step) {
	          case 1:
	            return _react2.default.createElement(_GeneralInfo2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	          case 2:
	            return _react2.default.createElement(_ProctoringInfo2.default, Object.assign({ nextStep: this.props.nextStep, lock: true }, this.props));
	
	          case 3:
	            return _react2.default.createElement(_Locations2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	          case 4:
	            return _react2.default.createElement(_ProfilePhoto2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	          case 5:
	            return _react2.default.createElement(_Activate2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	          default:
	            return _react2.default.createElement(_GeneralInfo2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	        }
	      }
	    }
	  }]);
	
	  return CheckupStep;
	}(_react2.default.Component);
	
	exports.default = CheckupStep;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Step = __webpack_require__(290);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _CheckupStep = __webpack_require__(848);
	
	var _CheckupStep2 = _interopRequireDefault(_CheckupStep);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var CheckupForm = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(CheckupForm, _React$Component);
	
	  function CheckupForm() {
	    _classCallCheck(this, CheckupForm);
	
	    var _this2 = _possibleConstructorReturn(this, (CheckupForm.__proto__ || Object.getPrototypeOf(CheckupForm)).call(this));
	
	    _this2.setStep = _this2.setStep.bind(_this2);
	    _this2.nextStep = _this2.nextStep.bind(_this2);
	    _this2.prevStep = _this2.prevStep.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(CheckupForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          RegisterStore = _props$store.RegisterStore,
	          SessionStore = _props$store.SessionStore,
	          SettingsStore = _props$store.SettingsStore;
	
	
	      this.state = {
	        step: this.props.step || 1,
	        locationSid: null,
	        confirmedLocations: []
	
	        // Retrieve data from localStorage
	      };var registerData = null;
	
	      if (SessionStore.hasSessionStorage) {
	        registerData = sessionStorage.getItem('registerData');
	      } else {
	        registerData = (0, _helpers.getCookie)('registerData');
	      }
	
	      if (registerData && typeof registerData !== 'undefined') {
	        RegisterStore.getLocalStorage(JSON.parse(registerData));
	      } else {
	        RegisterStore.getProctorData();
	      }
	
	      // Get account settings
	      SettingsStore.getUserSettings(this);
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      e.preventDefault();
	
	      this.setState({
	        step: step
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var _this = this;
	
	      setTimeout(function () {
	        _this.props.routing.history.push('/checkup/step-0' + (_this.state.step + 1));
	      });
	
	      // this.setState({
	      //   step: this.state.step + 1
	      // });
	
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	
	      this.props.routing.history.push('/checkup/step-0' + (this.state.step - 1));
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var userData = this.props.store.SessionStore.userData;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap block-form' },
	          userData.forcePasswordReset && _react2.default.createElement(_Step2.default, {
	            step: this.state.step,
	            setStep: this.setStep,
	            data: translation.steps_password,
	            skippable: false
	          }),
	          !userData.forcePasswordReset && _react2.default.createElement(_Step2.default, {
	            step: this.state.step,
	            setStep: this.setStep,
	            data: translation.steps,
	            skippable: false
	          }),
	          _react2.default.createElement(_CheckupStep2.default, Object.assign({
	            step: this.state.step,
	            checkValidity: _helpers.checkValidity,
	            nextStep: this.nextStep,
	            prevStep: this.prevStep,
	            parent: this,
	            locationSid: this.state.locationSid,
	            confirmedLocations: this.state.confirmedLocations
	          }, this.props))
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this }, this.props, {
	          locationSid: this.state.locationSid,
	          callback: this.getLocations,
	          checkup: true
	        }))
	      );
	    }
	  }]);
	
	  return CheckupForm;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('CheckupForm')(CheckupForm);

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var GeneralInfo = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(GeneralInfo, _React$Component);
	
	  function GeneralInfo() {
	    _classCallCheck(this, GeneralInfo);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (GeneralInfo.__proto__ || Object.getPrototypeOf(GeneralInfo)).call(this));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    return _this;
	  }
	
	  _createClass(GeneralInfo, [{
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var RegisterStore = this.props.store.RegisterStore;
	
	
	      if (this.name) {
	        var data = {
	          accountName: this.name.value
	        };
	
	        RegisterStore.updateProctor(data, this.props.nextStep);
	      } else {
	        this.props.nextStep();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          SettingsStore = _props$store.SettingsStore;
	      var userData = SessionStore.userData;
	      var userSettings = SettingsStore.userSettings;
	
	
	      var noteText = translation.body.split('%contact support%');
	      var contactLink = _react2.default.createElement('a', {
	        href: 'mailto:proctors@smarterproctoring.com?subject=Support%20Ticket'
	      }, translation.contact);
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'form',
	          {
	            className: 'panel',
	            onSubmit: function onSubmit(e) {
	              return _this2.props.checkValidity(e, _this2.handleSubmit);
	            },
	            noValidate: true
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__header' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'panel__title' },
	              _react2.default.createElement(
	                'legend',
	                null,
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            { className: 'panel__body' },
	            _react2.default.createElement(
	              'p',
	              { className: 'note note--prominent' },
	              noteText[0],
	              ' ',
	              contactLink,
	              noteText[1]
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: 'fields' },
	              _react2.default.createElement(
	                'li',
	                { className: 'field--half' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'profile-fname' },
	                  translation.name.first
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'faux-input' },
	                  userData.firstName
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'field--half' },
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'profile-lname' },
	                  translation.name.last
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'faux-input' },
	                  userData.lastName
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'profile-email' },
	                  translation.email
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'faux-input' },
	                  userData.email
	                )
	              ),
	              userSettings.type !== 'individual-proctor' && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'profile-name' },
	                  translation.name.account
	                ),
	                _react2.default.createElement('input', {
	                  type: 'text',
	                  id: 'profile-name',
	                  defaultValue: userSettings.accountName || '',
	                  ref: function ref(input) {
	                    return _this2.name = input;
	                  },
	                  required: true,
	                  'aria-required': 'true'
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel__actions actions' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'actions__btn actions__btn--primary',
	                  type: 'submit'
	                },
	                translation.button
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return GeneralInfo;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('GeneralInfo')(GeneralInfo);

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _dompurify = __webpack_require__(92);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var CheckupIntro = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(CheckupIntro, _React$Component);
	
	  function CheckupIntro() {
	    _classCallCheck(this, CheckupIntro);
	
	    return _possibleConstructorReturn(this, (CheckupIntro.__proto__ || Object.getPrototypeOf(CheckupIntro)).apply(this, arguments));
	  }
	
	  _createClass(CheckupIntro, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'page wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            translation.heading
	          ),
	          _react2.default.createElement('div', { className: 'panel__copy', dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(translation.body) } }),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { className: 'btn', to: '/checkup/step-01' },
	            translation.button
	          )
	        )
	      );
	    }
	  }]);
	
	  return CheckupIntro;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('CheckupIntro')(CheckupIntro);

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var Locations = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Locations, _React$Component);
	
	  function Locations() {
	    _classCallCheck(this, Locations);
	
	    var _this = _possibleConstructorReturn(this, (Locations.__proto__ || Object.getPrototypeOf(Locations)).call(this));
	
	    _this.deleteLocation = _this.deleteLocation.bind(_this);
	    return _this;
	  }
	
	  _createClass(Locations, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var LocationStore = this.props.store.LocationStore;
	
	
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        locationSid: null
	      };
	
	      LocationStore.getLocations();
	    }
	  }, {
	    key: 'handleEdit',
	    value: function handleEdit(locationSid) {
	      var _props$store = this.props.store,
	          LocationStore = _props$store.LocationStore,
	          SessionStore = _props$store.SessionStore;
	      var confirmedLocations = this.props.confirmedLocations;
	
	
	      if (confirmedLocations.indexOf(locationSid) === -1) {
	        // Reset stored location data
	        LocationStore.resetLocation();
	
	        // Set this location sid
	        this.props.parent.setState({
	          locationSid: locationSid
	        });
	
	        // Hide the drawer button
	        SessionStore.hideDrawerClose = true;
	
	        // Open the drawer
	        (0, _helpers.toggleDrawer)(null, this.props.parent, 'LocationEdit');
	      }
	    }
	  }, {
	    key: 'deleteLocation',
	    value: function deleteLocation(location) {
	      var translation = this.props.translation;
	      var LocationStore = this.props.store.LocationStore;
	
	
	      var msg = {
	        heading: translation.delete_confirm.heading + ' ' + location.name + '?',
	        body: translation.delete_confirm.body,
	        button: translation.delete_confirm.button
	      };
	
	      (0, _helpers.confirm)(msg, function () {
	        return LocationStore.deleteLocation(location.sid);
	      });
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      var LocationStore = this.props.store.LocationStore;
	      var translation = this.props.translation;
	      var confirmedLocations = this.props.confirmedLocations;
	
	
	      if (LocationStore.locations.length > 0) {
	        return _react2.default.createElement(
	          'ul',
	          { className: 'tally' },
	          LocationStore.locations.map(function (key, i) {
	            return _react2.default.createElement(
	              'li',
	              {
	                key: i
	              },
	              _react2.default.createElement(
	                'h3',
	                {
	                  onClick: function onClick() {
	                    return _this2.handleEdit(key.sid);
	                  }
	                },
	                key.name
	              ),
	              confirmedLocations.indexOf(key.sid) === -1 && _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn--link',
	                  onClick: function onClick() {
	                    return _this2.handleEdit(key.sid);
	                  }
	                },
	                translation.confirm
	              ),
	              confirmedLocations.indexOf(key.sid) > -1 && translation.confirmed,
	              _react2.default.createElement(
	                'span',
	                {
	                  className: 'tally__status\n                  ' + (confirmedLocations.indexOf(key.sid) > -1 ? 'completed' : '') + '\n                ',
	                  onClick: function onClick() {
	                    return _this2.handleEdit(key.sid);
	                  }
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  confirmedLocations.indexOf(key.sid) > -1 ? 'completed' : ''
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'tally__delete btn--delete',
	                  type: 'button',
	                  onClick: function onClick() {
	                    return _this2.deleteLocation(key);
	                  }
	                },
	                _react2.default.createElement(icons.iconTrash, null),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation.delete
	                )
	              )
	            );
	          })
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          confirmedLocations = _props.confirmedLocations,
	          translation = _props.translation;
	      var LocationStore = this.props.store.LocationStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__header' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'panel__title' },
	            translation.heading
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__body' },
	          _react2.default.createElement(
	            'p',
	            { className: 'note note--prominent' },
	            translation.body
	          ),
	          this.renderResults(),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__actions actions' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'actions__btn actions__btn--secondary',
	                onClick: this.props.prevStep
	              },
	              translation.back
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'actions__btn actions__btn--primary',
	                onClick: this.props.nextStep,
	                disabled: confirmedLocations.length < LocationStore.locations.length
	              },
	              translation.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Locations;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Locations')(Locations);

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Password = __webpack_require__(165);
	
	var _Password2 = _interopRequireDefault(_Password);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var PasswordUpdate = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(PasswordUpdate, _React$Component);
	
	  function PasswordUpdate() {
	    _classCallCheck(this, PasswordUpdate);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (PasswordUpdate.__proto__ || Object.getPrototypeOf(PasswordUpdate)).call(this));
	
	    _this.updatePassword = _this.updatePassword.bind(_this);
	    return _this;
	  }
	
	  _createClass(PasswordUpdate, [{
	    key: 'confirmPassword',
	    value: function confirmPassword(e) {
	      e.preventDefault();
	
	      // Make sure confirm password matches
	      var newPass = document.querySelector('#password-new');
	      var confirm = document.querySelector('#password-confirm');
	
	      if (newPass.value !== this.confirmPass.value) {
	        confirm.setCustomValidity('Passwords do not match.');
	      } else {
	        confirm.setCustomValidity('');
	      }
	
	      this.props.checkValidity(e, this.updatePassword);
	    }
	  }, {
	    key: 'updatePassword',
	    value: function updatePassword() {
	      var SettingsStore = this.props.store.SettingsStore;
	
	      var newPass = document.querySelector('#password-new');
	
	      var data = {
	        currentPassword: this.currentPass.value,
	        newPassword: newPass.value,
	        confirmPassword: this.confirmPass.value
	      };
	
	      SettingsStore.updatePassword(data, this.props.nextStep);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var userData = this.props.store.SessionStore.userData;
	
	
	      return _react2.default.createElement(
	        'form',
	        {
	          className: 'panel',
	          onSubmit: function onSubmit(e) {
	            return _this2.confirmPassword(e);
	          },
	          noValidate: true
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__header' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'panel__title' },
	            _react2.default.createElement(
	              'legend',
	              null,
	              translation.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__body' },
	          _react2.default.createElement(
	            'p',
	            { className: 'note note--prominent' },
	            translation.body
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	              'ul',
	              { className: 'fields' },
	              !userData.passwordChangeKey && _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'password-current' },
	                  translation.current_password
	                ),
	                _react2.default.createElement('input', {
	                  id: 'password-current',
	                  type: 'password',
	                  ref: function ref(input) {
	                    _this2.currentPass = input;
	                  },
	                  required: true,
	                  'aria-required': 'true'
	                })
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'password-new' },
	                  translation.new_password
	                ),
	                _react2.default.createElement(_Password2.default, Object.assign({
	                  id: 'password-new',
	                  parent: this,
	                  name: 'password'
	                }, this.props))
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                  'label',
	                  { className: 'lbl-required', htmlFor: 'password-confirm' },
	                  translation.confirm_password
	                ),
	                _react2.default.createElement('input', {
	                  id: 'password-confirm',
	                  type: 'password',
	                  ref: function ref(input) {
	                    return _this2.confirmPass = input;
	                  },
	                  required: true,
	                  'aria-required': 'true'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__actions actions' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'actions__btn actions__btn--secondary',
	                onClick: this.props.prevStep,
	                type: 'button'
	              },
	              translation.back
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'actions__btn actions__btn--primary',
	                type: 'submit'
	              },
	              translation.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PasswordUpdate;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('PasswordUpdate')(PasswordUpdate);

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Renders a checkbox component
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {string} [className]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {boolean} [defaultChecked]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {boolean} [disabled]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {string} id
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {string} label
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {string} name
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {function} onChange
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {string} value
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Checkbox = function (_React$Component) {
	    _inherits(Checkbox, _React$Component);
	
	    function Checkbox() {
	        _classCallCheck(this, Checkbox);
	
	        return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	    }
	
	    _createClass(Checkbox, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                className = _props.className,
	                defaultChecked = _props.defaultChecked,
	                disabled = _props.disabled,
	                id = _props.id,
	                label = _props.label,
	                name = _props.name,
	                _onChange = _props.onChange,
	                required = _props.required,
	                value = _props.value;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'cbox' + (className ? ' ' + className : '') },
	                _react2.default.createElement('input', {
	                    'aria-required': required,
	                    className: 'cbox__input',
	                    checked: defaultChecked,
	                    disabled: disabled,
	                    id: id,
	                    onChange: function onChange(e) {
	                        return _onChange(e);
	                    },
	                    name: name,
	                    required: required,
	                    type: 'checkbox',
	                    value: value || true
	                }),
	                _react2.default.createElement(
	                    'label',
	                    {
	                        className: 'cbox__lbl',
	                        htmlFor: id
	                    },
	                    label
	                )
	            );
	        }
	    }]);
	
	    return Checkbox;
	}(_react2.default.Component);
	
	exports.default = Checkbox;

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DelayRender = function DelayRender(props) {
		if (props.test) {
			return _react2.default.createElement(
				'div',
				{ className: 'fill' },
				props.children
			);
		}
	
		return null;
	};
	
	exports.default = (0, _mobxReact.observer)(DelayRender);

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Counter = __webpack_require__(867);
	
	var _Counter2 = _interopRequireDefault(_Counter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var ExpireWarning = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExpireWarning, _React$Component);
	
	  function ExpireWarning() {
	    _classCallCheck(this, ExpireWarning);
	
	    var _this = _possibleConstructorReturn(this, (ExpireWarning.__proto__ || Object.getPrototypeOf(ExpireWarning)).call(this));
	
	    _this.confirmKey = _this.confirmKey.bind(_this);
	    _this.closeDialog = _this.closeDialog.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExpireWarning, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('keydown', this.confirmKey, false);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('keydown', this.confirmKey, false);
	    }
	  }, {
	    key: 'confirmKey',
	    value: function confirmKey(e) {
	      e.preventDefault();
	
	      if (e.keyCode && (e.keyCode === 13 || e.keyCode === 32)) {
	        this.closeDialog(e);
	      }
	    }
	  }, {
	    key: 'closeDialog',
	    value: function closeDialog(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.store.SessionStore.closeDialog();
	    }
	  }, {
	    key: 'extendSession',
	    value: function extendSession(e) {
	      e.preventDefault();
	      this.props.store.SessionStore.extendSession(this.closeDialog);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	      var endDate = (0, _moment2.default)().add(2, 'minutes');
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dialog dialog--confirm dialog--expire' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dialog__content' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'dialog__msg', tabIndex: '0' },
	            translation.heading,
	            _react2.default.createElement(_Counter2.default, Object.assign({ endDate: endDate }, this.props))
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.body
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dialog__btns' },
	            _react2.default.createElement(
	              'a',
	              { href: '#app', className: 'btn', onClick: function onClick(e) {
	                  return _this2.extendSession(e);
	                } },
	              translation.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExpireWarning;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExpireWarning')(ExpireWarning);

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _dompurify = __webpack_require__(92);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Dependencies
	
	
	var FeatureNotice = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(FeatureNotice, _React$Component);
	
	  function FeatureNotice() {
	    _classCallCheck(this, FeatureNotice);
	
	    var _this = _possibleConstructorReturn(this, (FeatureNotice.__proto__ || Object.getPrototypeOf(FeatureNotice)).call(this));
	
	    _this.closeDialog = _this.closeDialog.bind(_this);
	    return _this;
	  }
	
	  _createClass(FeatureNotice, [{
	    key: 'closeDialog',
	    value: function closeDialog(e) {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      e.preventDefault();
	
	      // Remove dialog
	      SessionStore.closeDialog();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	      var featureNoticeSetting = SessionStore.featureNoticeSetting,
	          featureNoticeToggle = SessionStore.featureNoticeToggle,
	          dialogContent = SessionStore.dialogContent;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dialog dialog--lg' },
	        _react2.default.createElement(
	          'div',
	          { className: 'dialog__content' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'dialog__msg' },
	            dialogContent.heading
	          ),
	          _react2.default.createElement('div', {
	            className: 'panel__copy',
	            dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(dialogContent.body) }
	          }),
	          typeof featureNoticeSetting !== 'undefined' && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('input', {
	              type: 'checkbox',
	              id: 'feature',
	              className: 'switch-input',
	              ref: function ref(input) {
	                return _this2.feature = input;
	              },
	              value: true,
	              defaultChecked: featureNoticeSetting,
	              onChange: featureNoticeToggle
	            }),
	            _react2.default.createElement(
	              'label',
	              {
	                className: 'switch-label',
	                htmlFor: 'feature'
	              },
	              _react2.default.createElement(
	                'span',
	                { className: 'meta' },
	                dialogContent.label
	              )
	            ),
	            _react2.default.createElement(
	              'label',
	              {
	                className: 'switch-label--alt',
	                htmlFor: 'feature'
	              },
	              dialogContent.label
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            {
	              href: '#app',
	              className: 'btn',
	              onClick: function onClick(e) {
	                return _this2.closeDialog(e);
	              }
	            },
	            dialogContent.button
	          )
	        )
	      );
	    }
	  }]);
	
	  return FeatureNotice;
	}(_react2.default.Component));
	
	exports.default = FeatureNotice;

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Checkbox = __webpack_require__(854);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Renders a listbox of checkboxes
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// Components
	
	
	var MultiSelect = function (_React$Component) {
	    _inherits(MultiSelect, _React$Component);
	
	    function MultiSelect() {
	        _classCallCheck(this, MultiSelect);
	
	        // Set the initial state
	        var _this = _possibleConstructorReturn(this, (MultiSelect.__proto__ || Object.getPrototypeOf(MultiSelect)).call(this));
	
	        _this.handleValue = function () {
	            var newValue = [].concat(_toConsumableArray(_this.props.value));
	
	            if (newValue && Array.isArray(newValue)) {
	                var selected = [];
	
	                newValue.forEach(function (val) {
	                    selected.push(val);
	                });
	
	                _this.setState({ selected: selected });
	            }
	        };
	
	        _this.handleOverflow = function () {
	            setTimeout(function () {
	                var el = _this.listBox;
	
	                if (el && el.scrollHeight > el.offsetHeight) {
	                    _this.setState({
	                        scrollable: true
	                    });
	                }
	            });
	        };
	
	        _this.handleChange = function (e) {
	            var _e$target = e.target,
	                checked = _e$target.checked,
	                value = _e$target.value;
	            var onChange = _this.props.onChange;
	
	            var selected = [].concat(_toConsumableArray(_this.state.selected));
	            var index = selected.indexOf(value);
	
	            if (!checked && index > -1) {
	                selected.splice(index, 1);
	            } else if (index === -1) {
	                selected.push(value);
	            }
	
	            if (onChange) {
	                onChange(selected);
	            }
	
	            _this.setState({
	                selected: selected
	            });
	        };
	
	        _this.state = {
	            scrollable: false,
	            selected: []
	
	            // Create refs
	            //this.listbox = React.createRef();
	        };_this.listBox = null;
	        _this.setListBoxRef = function (element) {
	            _this.listBox = element;
	        };
	        return _this;
	    }
	
	    _createClass(MultiSelect, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.handleValue();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            var newProps = [].concat(_toConsumableArray(this.props.value));
	            if (newProps.length !== prevProps.value.length) {
	                this.handleValue();
	            }
	        }
	
	        /**
	         * Handle any preset values
	         *
	         * @function handleValue
	         */
	
	
	        /**
	         * Check if listbox is scrollable
	         * (Timeout is necessary because the function may fire before render is completed)
	         *
	         * @function handleOverflow
	         */
	
	
	        /**
	         * Handle selection/deselection of an option
	         *
	         * @function handleChange
	         * @param {Event} e
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                className = _props.className,
	                errorMsg = _props.errorMsg,
	                disabled = _props.disabled,
	                helper = _props.helper,
	                hideLabel = _props.hideLabel,
	                id = _props.id,
	                label = _props.label,
	                options = _props.options,
	                required = _props.required;
	            var _state = this.state,
	                scrollable = _state.scrollable,
	                selected = _state.selected;
	
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: 'multi-select' + (className ? ' ' + className : '')
	                },
	                (label || helper) && _react2.default.createElement(
	                    'div',
	                    { className: 'multi-select__text' },
	                    label && _react2.default.createElement(
	                        'span',
	                        {
	                            className: '' + (hideLabel ? 'meta' : 'multi-select__lbl hybrid-form__lbl') + (required ? ' lbl-required' : ''),
	                            id: id + '-label'
	                        },
	                        label
	                    ),
	                    helper && _react2.default.createElement(
	                        'span',
	                        {
	                            className: 'multi-select__hint hybrid-form__hint',
	                            id: id + '-helper'
	                        },
	                        helper
	                    )
	                ),
	                required && _react2.default.createElement('input', {
	                    className: 'input--hidden',
	                    'data-errormsg': errorMsg,
	                    value: selected.length > 0 ? selected.toString() : '',
	                    required: true,
	                    type: 'text'
	                }),
	                _react2.default.createElement(
	                    'ul',
	                    {
	                        'aria-labelledby': id + '-label',
	                        className: 'multi-select__options' + (scrollable ? ' multi-select__options--scrollable' : ''),
	                        ref: this.setListBoxRef,
	                        role: 'listbox'
	                    },
	                    options.map(function (option, i) {
	                        return _react2.default.createElement(
	                            'li',
	                            { key: i },
	                            _react2.default.createElement(_Checkbox2.default, {
	                                defaultChecked: selected.indexOf(option.value) > -1,
	                                disabled: !!disabled,
	                                id: id + '-option-' + i,
	                                label: option.label,
	                                name: 'group-' + id,
	                                onChange: _this2.handleChange,
	                                value: option.value
	                            })
	                        );
	                    })
	                ),
	                this.handleOverflow()
	            );
	        }
	    }]);
	
	    return MultiSelect;
	}(_react2.default.Component);
	
	exports.default = MultiSelect;

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var Notification = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Notification, _React$Component);
	
	  function Notification() {
	    _classCallCheck(this, Notification);
	
	    var _this2 = _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this));
	
	    _this2.autoClose = _this2.autoClose.bind(_this2);
	    _this2.closeNotification = _this2.closeNotification.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Notification, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        closing: false
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      this.autoClose();
	
	      var notify = document.querySelector('.notify');
	
	      // Delay close if hovered
	      notify.addEventListener('mouseenter', function () {
	        clearTimeout(_this.closeTimer);
	      });
	
	      // Restart close timer on mouse leave
	      notify.addEventListener('mouseleave', function () {
	        _this.autoClose();
	      });
	    }
	  }, {
	    key: 'autoClose',
	    value: function autoClose() {
	      var _this = this;
	
	      this.closeTimer = setTimeout(function () {
	        _this.closeNotification();
	      }, 10000);
	    }
	  }, {
	    key: 'closeNotification',
	    value: function closeNotification(e) {
	      if (e) {
	        e.preventDefault();
	
	        if (e.target.href) {
	          this.props.routing.history.push(e.target.href.replace('#/', ''));
	        }
	      }
	
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.setState({
	        closing: true
	      });
	
	      clearTimeout(this.closeTimer);
	
	      // Wait for animation to finish before removing
	      setTimeout(function () {
	        SessionStore.closeNotification();
	      }, 250);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: '\n          notify\n          ' + (this.state.closing ? 'notify--closing' : '') + '\n          ' + SessionStore.notificationClass + '\n        '
	        },
	        SessionStore.notificationLink && _react2.default.createElement(
	          _reactRouterDom.Link,
	          {
	            className: 'notify__msg',
	            to: SessionStore.notificationLink,
	            onClick: function onClick(e) {
	              return _this3.closeNotification(e);
	            }
	          },
	          SessionStore.notificationContent
	        ),
	        !SessionStore.notificationLink && _react2.default.createElement(
	          'span',
	          { className: 'notify__msg' },
	          SessionStore.notificationContent
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            href: '#app',
	            className: 'notify__close',
	            onClick: function onClick(e) {
	              return _this3.closeNotification(e);
	            }
	          },
	          _react2.default.createElement(icons.iconTimes, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            'Close'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Notification;
	}(_react2.default.Component));
	
	exports.default = Notification;

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var Privacy = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Privacy, _React$Component);
	
	  function Privacy() {
	    _classCallCheck(this, Privacy);
	
	    var _this = _possibleConstructorReturn(this, (Privacy.__proto__ || Object.getPrototypeOf(Privacy)).call(this));
	
	    _this.toggle = _this.toggle.bind(_this);
	
	    _this.state = {
	      reveal: false
	    };
	    return _this;
	  }
	
	  _createClass(Privacy, [{
	    key: 'privatize',
	    value: function privatize() {
	      var masked = '';
	
	      for (var i = 0; i < this.props.private.length; i++) {
	        masked += '•';
	      }
	
	      return masked;
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({
	        reveal: !this.state.reveal
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'span',
	        {
	          className: '\n          privacy\n          ' + (this.props.className ? this.props.className : '') + '\n          ' + (this.state.reveal ? 'reveal' : '') + '\n        '
	        },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'privacy__toggle privacy__show',
	            onClick: this.toggle,
	            type: 'button',
	            title: this.props.show
	          },
	          _react2.default.createElement(icons.iconEye, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            this.props.show
	          )
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'privacy__toggle privacy__hide',
	            onClick: this.toggle,
	            type: 'button',
	            title: this.props.hide
	          },
	          _react2.default.createElement(icons.iconEyeSlash, null),
	          _react2.default.createElement(
	            'span',
	            { className: 'meta' },
	            this.props.hide
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'privacy__show' },
	          this.privatize()
	        ),
	        _react2.default.createElement(
	          'span',
	          { className: 'privacy__hide' },
	          this.props.private
	        )
	      );
	    }
	  }]);
	
	  return Privacy;
	}(_react2.default.Component));
	
	exports.default = Privacy;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	var Prompt = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    var _this2 = _possibleConstructorReturn(this, (Prompt.__proto__ || Object.getPrototypeOf(Prompt)).call(this));
	
	    _this2.closeDialog = _this2.closeDialog.bind(_this2);
	    _this2.confirmDialog = _this2.confirmDialog.bind(_this2);
	    _this2.handleOption = _this2.handleOption.bind(_this2);
	    _this2.handleInput = _this2.handleInput.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	
	    _this2.state = {
	      reason: null,
	      memo: null
	    };
	    return _this2;
	  }
	
	  _createClass(Prompt, [{
	    key: 'closeDialog',
	    value: function closeDialog(e) {
	      e.preventDefault();
	      this.props.store.SessionStore.closeDialog();
	    }
	  }, {
	    key: 'confirmDialog',
	    value: function confirmDialog(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.store.SessionStore.promptFunc();
	    }
	  }, {
	    key: 'handleOption',
	    value: function handleOption() {
	      this.setState({
	        reason: this.option.value
	      });
	
	      // Set the cancellation memo to the option selected or null if it’s other
	      if (this.option.value !== 'other-reason') {
	        this.setState({
	          memo: this.option.value
	        });
	      } else {
	        this.setState({
	          memo: null
	        });
	      }
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      // Cancel session reason
	      if (this.memo) {
	        this.setState({
	          memo: this.memo.value || null
	        });
	      }
	
	      // Export CSV prompt
	      if (this.title) {
	        this.props.store.ReportStore.reportExportTitle = this.title.value;
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      this.props.store.SessionStore.promptSelectFunc(this.state.memo, this.state.reason);
	
	      var _this = this;
	      setTimeout(function () {
	        _this.props.store.SessionStore.promptFunc();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var SessionStore = this.props.store.SessionStore;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'dialog dialog--confirm' },
	        _react2.default.createElement(
	          'form',
	          { className: 'dialog__content', onSubmit: function onSubmit(e) {
	              return (0, _helpers.checkValidity)(e, _this3.handleSubmit);
	            }, noValidate: true },
	          _react2.default.createElement(
	            'strong',
	            { className: 'dialog__msg', tabIndex: '0' },
	            SessionStore.promptContent.heading
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            SessionStore.promptContent.body
	          ),
	          SessionStore.promptContent.options && _react2.default.createElement(
	            'label',
	            { className: 'select dialog__select', htmlFor: 'prompt-options' },
	            _react2.default.createElement(
	              'select',
	              {
	                id: 'prompt-options',
	                onChange: this.handleOption,
	                ref: function ref(input) {
	                  _this3.option = input;
	                }
	              },
	              _react2.default.createElement(
	                'option',
	                { value: '', disabled: true, selected: true },
	                'Select an option...'
	              ),
	              SessionStore.promptContent.options.map(function (option, i) {
	                return _react2.default.createElement(
	                  'option',
	                  { key: i, value: option.value },
	                  option.label
	                );
	              })
	            )
	          ),
	          (!SessionStore.promptContent.options || this.state.reason === 'other-reason') && !SessionStore.promptContent.input && _react2.default.createElement('textarea', {
	            id: 'prompt-other',
	            className: 'dialog__input',
	            ref: function ref(input) {
	              _this3.memo = input;
	            },
	            onChange: this.handleInput,
	            required: true,
	            'aria-required': 'true'
	          }),
	          SessionStore.promptContent.input && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'label',
	              { htmlFor: 'prompt-input' },
	              SessionStore.promptContent.input
	            ),
	            _react2.default.createElement('input', {
	              type: 'text',
	              id: 'prompt-input',
	              className: 'dialog__input',
	              defaultValue: SessionStore.promptText,
	              ref: function ref(input) {
	                _this3.title = input;
	              },
	              onChange: this.handleInput,
	              required: true,
	              'aria-required': 'true',
	              placeholder: SessionStore.promptContent.input
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'dialog__btns' },
	            _react2.default.createElement(
	              'a',
	              { href: '#app', className: 'btn btn--outline', onClick: function onClick(e) {
	                  return _this3.closeDialog(e);
	                } },
	              'Cancel'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn',
	                disabled: !this.state.memo && !SessionStore.promptContent.input
	              },
	              SessionStore.promptContent.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Prompt;
	}(_react2.default.Component));
	
	exports.default = Prompt;

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Renders a tooltip element
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {boolean} [brief]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {string} content
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {boolean} [down]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {boolean} [hideLabel]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {icon} [icon]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {string} id
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {boolean} [left]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {boolean} [right]
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var RoomTooltip = function (_React$Component) {
	    _inherits(RoomTooltip, _React$Component);
	
	    function RoomTooltip() {
	        _classCallCheck(this, RoomTooltip);
	
	        return _possibleConstructorReturn(this, (RoomTooltip.__proto__ || Object.getPrototypeOf(RoomTooltip)).apply(this, arguments));
	    }
	
	    _createClass(RoomTooltip, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                brief = _props.brief,
	                content = _props.content,
	                down = _props.down,
	                hideLabel = _props.hideLabel,
	                icon = _props.icon,
	                id = _props.id,
	                left = _props.left,
	                right = _props.right;
	
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: 'room-tooltip' + (brief ? ' room-tooltip--brief' : '') + (down ? ' room-tooltip--down' : '') + (left ? ' room-tooltip--left' : '') + (right ? ' room-tooltip--right' : '')
	                },
	                !hideLabel && _react2.default.createElement(
	                    'span',
	                    {
	                        className: 'room-tooltip__label',
	                        role: 'presentation',
	                        'aria-hidden': 'true'
	                    },
	                    '(?)'
	                ),
	                icon ? icon : '',
	                _react2.default.createElement(
	                    'div',
	                    {
	                        id: id,
	                        className: 'room-tooltip__body',
	                        role: 'tooltip'
	                    },
	                    content
	                )
	            );
	        }
	    }]);
	
	    return RoomTooltip;
	}(_react2.default.Component);
	
	exports.default = RoomTooltip;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Renders a numeric spin button component
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {string} className
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {integer} defaultValue
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {boolean} disabled
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {string} helper A hint or description
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {string} label
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {integer} max The maximum possible value
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {integer} min The minimum possible value
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {function} onChange
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @property {boolean} required
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// Icons
	
	
	var SpinButton = function (_React$Component) {
	    _inherits(SpinButton, _React$Component);
	
	    function SpinButton(props) {
	        _classCallCheck(this, SpinButton);
	
	        // Set the initial state
	        var _this = _possibleConstructorReturn(this, (SpinButton.__proto__ || Object.getPrototypeOf(SpinButton)).call(this, props));
	
	        _this.handleKeyDown = function (e) {
	            var code = e.code.toLowerCase();
	
	            if (code === 'arrowup') {
	                _this.handleIncrement(1);
	            } else if (code === 'arrowdown') {
	                _this.handleIncrement(-1);
	            }
	        };
	
	        _this.handleIncrement = function (amount) {
	            var _this$props = _this.props,
	                max = _this$props.max,
	                min = _this$props.min;
	
	            var value = _this.state.value + amount;
	
	            if (value < min) {
	                value = min;
	            } else if (value > max) {
	                value = max;
	            }
	
	            _this.handleValidity(false);
	
	            _this.setState({
	                value: value
	            }, function () {
	                return _this.handleChange();
	            });
	        };
	
	        _this.handleInput = function (value) {
	            var _this$props2 = _this.props,
	                max = _this$props2.max,
	                min = _this$props2.min;
	
	
	            if (Number.isNaN(+value)) {
	                return;
	            }
	
	            if (+value < min || +value > max) {
	                _this.handleValidity(true);
	            } else {
	                _this.handleValidity(false);
	            }
	
	            _this.setState({
	                value: +value
	            }, function () {
	                return _this.handleChange();
	            });
	        };
	
	        _this.handleValidity = function (invalid) {
	            var inputEl = _this.textInput;
	
	            if (invalid) {
	                inputEl.setAttribute('aria-invalid', true);
	                inputEl.setCustomValidity('Invalid value');
	                inputEl.reportValidity();
	            } else {
	                inputEl.removeAttribute('aria-invalid');
	                inputEl.setCustomValidity('');
	                inputEl.reportValidity();
	            }
	        };
	
	        _this.handleChange = function () {
	            var onChange = _this.props.onChange;
	            var value = _this.state.value;
	
	
	            if (onChange) {
	                onChange(value);
	            }
	        };
	
	        _this.state = {
	            value: props.defaultValue || 0
	        };
	
	        _this.textInput = null;
	        _this.setTextInputRef = function (element) {
	            _this.textInput = element;
	        };
	        /*
	        this.focusTextInput = () => {
	            // Focus the text input using the raw DOM API
	            if (this.textInput) this.textInput.focus();
	        };
	          */
	        // Create refs
	        //this.input = React.createRef();
	        return _this;
	    }
	
	    _createClass(SpinButton, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps) {
	            // If the defaultValue prop is updated, update the value in state
	            if (prevProps.defaultValue !== this.props.defaultValue) {
	                this.setState({
	                    value: this.props.defaultValue
	                });
	            }
	        }
	
	        /**
	         * Increment and decrement with up and down keys.
	         *
	         * @function handleKeyDown
	         * @param {event} e
	         */
	
	
	        /**
	         * Handle increment/decrement button click.
	         *
	         * @function handleIncrement
	         * @param {integer} amount
	         */
	
	
	        /**
	         * Handle typing in the input
	         *
	         * @function handleInput
	         * @param {string} value
	         */
	
	
	        /**
	         * Set input validity.
	         *
	         * @function handleValidity
	         * @param {boolean} invalid
	         */
	
	
	        /**
	         * Handle onChange property
	         *
	         * @function handleChange
	         */
	
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                className = _props.className,
	                disabled = _props.disabled,
	                errorMsg = _props.errorMsg,
	                helper = _props.helper,
	                id = _props.id,
	                label = _props.label,
	                layout = _props.layout,
	                max = _props.max,
	                min = _props.min,
	                required = _props.required;
	            var value = this.state.value;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'spin-button' + (className ? ' ' + className : '') + (layout ? ' spin-button--' + layout : '') },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'spin-button__head' },
	                    _react2.default.createElement(
	                        'label',
	                        {
	                            className: 'spin-button__lbl hybrid-form__lbl',
	                            htmlFor: id
	                        },
	                        label
	                    ),
	                    helper && _react2.default.createElement(
	                        'span',
	                        {
	                            className: 'spin-button__hint hybrid-form__hint',
	                            id: id + '-helper'
	                        },
	                        helper
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'spin-button__wrap' },
	                    _react2.default.createElement('input', {
	                        'aria-describedby': id + '-helper',
	                        'aria-valuemax': max,
	                        'aria-valuemin': min,
	                        'aria-valuenow': value,
	                        className: 'spin-button__input' + (max <= 99 ? ' input--xs' : '') + (max > 99 & max <= 999 ? ' input--sm' : '') + (max > 999 & max <= 9999 ? ' input--md' : ''),
	                        'data-errormsg': errorMsg || null,
	                        disabled: disabled,
	                        id: id,
	                        inputMode: 'numeric',
	                        onKeyDown: function onKeyDown(e) {
	                            return _this2.handleKeyDown(e);
	                        },
	                        onChange: function onChange(e) {
	                            return _this2.handleInput(e.target.value);
	                        },
	                        pattern: '[-+,0-9]*',
	                        ref: this.setTextInputRef,
	                        required: required,
	                        role: 'spinbutton',
	                        type: 'text',
	                        value: value
	                    }),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'aria-label': 'decrease ' + label,
	                            'aria-live': 'polite',
	                            className: 'spin-button__control spin-button__down btn--reset btn--ghost',
	                            disabled: value <= min || disabled,
	                            onClick: function onClick() {
	                                return _this2.handleIncrement(-1);
	                            },
	                            tabIndex: '-1',
	                            type: 'button'
	                        },
	                        _react2.default.createElement(icons.iconMinusHybrid, null)
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'aria-label': 'increase ' + label,
	                            'aria-live': 'polite',
	                            className: 'spin-button__control spin-button__up btn--reset btn--ghost',
	                            disabled: value >= max || disabled,
	                            onClick: function onClick() {
	                                return _this2.handleIncrement(1);
	                            },
	                            tabIndex: '-1',
	                            type: 'button'
	                        },
	                        _react2.default.createElement(icons.iconPlusHybrid, null)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SpinButton;
	}(_react2.default.Component);
	
	exports.default = SpinButton;

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactSimpleDropdown = __webpack_require__(199);
	
	var _reactSimpleDropdown2 = _interopRequireDefault(_reactSimpleDropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var SplitButton = (0, _mobxReact.observer)(function (_React$Component) {
	    _inherits(SplitButton, _React$Component);
	
	    function SplitButton() {
	        _classCallCheck(this, SplitButton);
	
	        var _this = _possibleConstructorReturn(this, (SplitButton.__proto__ || Object.getPrototypeOf(SplitButton)).call(this));
	
	        _this.toggleOptions = _this.toggleOptions.bind(_this);
	        return _this;
	    }
	
	    _createClass(SplitButton, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.state = {
	                showing: false
	            };
	        }
	    }, {
	        key: 'toggleOptions',
	        value: function toggleOptions(e) {
	            this.setState({
	                showing: !this.state.showing
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                options = _props.options,
	                text = _props.text,
	                onClick = _props.onClick,
	                translation = _props.translation;
	
	
	            return _react2.default.createElement(
	                'div',
	                {
	                    className: 'split-btn ' + (!this.props.options ? 'split-btn--empty' : '')
	                },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        className: 'split-btn__link cover',
	                        onClick: onClick
	                    },
	                    text
	                ),
	                _react2.default.createElement(
	                    'span',
	                    {
	                        className: 'split-btn__text',
	                        'aria-hidden': 'true'
	                    },
	                    text
	                ),
	                this.props.options && _react2.default.createElement(
	                    _reactSimpleDropdown2.default,
	                    {
	                        className: 'split_dropdown',
	                        ref: 'splitButton',
	                        onShow: this.toggleOptions,
	                        onHide: this.toggleOptions
	                    },
	                    _react2.default.createElement(
	                        _reactSimpleDropdown.DropdownTrigger,
	                        {
	                            className: 'split-btn__trigger'
	                        },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'meta' },
	                            translation.dropdown
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _reactSimpleDropdown.DropdownContent,
	                        null,
	                        _react2.default.createElement(
	                            'ul',
	                            { className: 'dropdown__menu' },
	                            options.map(function (key, i) {
	                                return _react2.default.createElement(
	                                    'li',
	                                    { key: i },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            className: 'dropdown__item_split split-btn__option',
	                                            onClick: key.onClick
	                                        },
	                                        key.title
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SplitButton;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SplitButton')(SplitButton);

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var Toolbar = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Toolbar, _React$Component);
	
	  function Toolbar() {
	    _classCallCheck(this, Toolbar);
	
	    return _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).apply(this, arguments));
	  }
	
	  _createClass(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'toolbar ' + (this.props.selectedRows.length === 0 ? 'exiting' : '') },
	        _react2.default.createElement(
	          'button',
	          {
	            className: 'btn--outline btn--negative',
	            onClick: this.props.deleteFunction
	          },
	          _react2.default.createElement(icons.iconTrash, null),
	          this.props.deleteText
	        )
	      );
	    }
	  }]);
	
	  return Toolbar;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Toolbar')(Toolbar);

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var Tools = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Tools, _React$Component);
	
	  function Tools() {
	    _classCallCheck(this, Tools);
	
	    return _possibleConstructorReturn(this, (Tools.__proto__ || Object.getPrototypeOf(Tools)).apply(this, arguments));
	  }
	
	  _createClass(Tools, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'page' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'app-tools wrap' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'access-toggle btn--outline',
	                onClick: this.props.refresh
	              },
	              _react2.default.createElement(icons.iconRefresh, null),
	              _react2.default.createElement(
	                'span',
	                { className: 'meta' },
	                translation.refresh
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tools;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Tools')(Tools);

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var Counter = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Counter, _React$Component);
	
	  function Counter() {
	    _classCallCheck(this, Counter);
	
	    var _this = _possibleConstructorReturn(this, (Counter.__proto__ || Object.getPrototypeOf(Counter)).call(this));
	
	    _this.countdown = _this.countdown.bind(_this);
	    return _this;
	  }
	
	  _createClass(Counter, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        counter: null,
	        counterClass: ''
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.timer = setInterval(this.countdown, 1000);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.timer);
	    }
	  }, {
	    key: 'countdown',
	    value: function countdown() {
	      var now = (0, _moment2.default)();
	      var expire = (0, _moment2.default)(this.props.endDate).local();
	      var difference = new _moment2.default.duration(expire.diff(now));
	
	      var countdown = {};
	
	      countdown.days = difference.days();
	      countdown.hours = difference.hours();
	      countdown.minutes = difference.minutes();
	      countdown.seconds = difference.seconds();
	
	      if (countdown.days <= 0 && countdown.hours <= 0 && countdown.minutes <= 0) {
	        this.setState({
	          counterClass: 'counter--ending'
	        });
	      } else {
	        this.setState({
	          counterClass: ''
	        });
	      }
	
	      var counter = '';
	
	      Object.keys(countdown).map(function (key, i) {
	        if (countdown[key] < 0) {
	          countdown[key] = 0;
	        }
	
	        if (key === 'days' && countdown.days !== 0 || key === 'hours' && (countdown.days !== 0 || countdown.hours !== 0) || key !== 'days' && key !== 'hours') {
	          if (countdown[key] < 10) {
	            countdown[key] = '0' + countdown[key];
	          }
	          if (counter.length) {
	            counter += ':' + countdown[key];
	          } else {
	            counter += countdown[key];
	          }
	        }
	
	        return true;
	      });
	
	      this.setState({
	        counter: counter
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'span',
	        { className: 'counter' },
	        translation.time_remaining,
	        ': ',
	        _react2.default.createElement(
	          'strong',
	          { className: 'counter__time ' + this.state.counterClass },
	          this.state.counter
	        )
	      );
	    }
	  }]);
	
	  return Counter;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Counter')(Counter);

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _OwedPayments = __webpack_require__(869);
	
	var _OwedPayments2 = _interopRequireDefault(_OwedPayments);
	
	var _UpcomingSessions = __webpack_require__(870);
	
	var _UpcomingSessions2 = _interopRequireDefault(_UpcomingSessions);
	
	var _PendingSessions = __webpack_require__(301);
	
	var _PendingSessions2 = _interopRequireDefault(_PendingSessions);
	
	var _config = __webpack_require__(24);
	
	var _iamReactClient = __webpack_require__(58);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var Dashboard = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Dashboard, _React$Component);
	
	  function Dashboard() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Dashboard);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      drawerOpen: false,
	      drawerContent: null,
	      messageThreadSid: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Dashboard, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          PaymentStore = _props$store.PaymentStore,
	          ScheduleStore = _props$store.ScheduleStore,
	          SessionStore = _props$store.SessionStore;
	      var proctorAccountSid = SessionStore.userData.proctorAccountSid;
	
	      var iam = sessionStorage.getItem('iam');
	
	      var token = null;
	      var userData = null;
	
	      if (SessionStore.hasSessionStorage) {
	        token = sessionStorage.getItem('token');
	        userData = sessionStorage.getItem('userData');
	      } else {
	        token = (0, _helpers.getCookie)('token');
	        userData = (0, _helpers.getCookie)('userData');
	      }
	
	      if (token && userData) {
	        PaymentStore.getBalance();
	        ScheduleStore.getSessions(3, 'Scheduled', null, null, true);
	      }
	      if (!(0, _iamReactClient.isAuthorized)('sp:DescribeBalance', 'ssrn:ss:sp::' + proctorAccountSid + ':balance', iam) && (0, _iamReactClient.isAuthorized)('sp:DescribeHybridRooms', 'ssrn:ss:sp::' + proctorAccountSid + ':hybridRoom', iam)) {
	        this.props.routing.history.push('/hybrid-proctoring');
	      } else if (!(0, _iamReactClient.isAuthorized)('sp:DescribeBalance', 'ssrn:ss:sp::' + proctorAccountSid + ':balance', iam) && !(0, _iamReactClient.isAuthorized)('sp:DescribeHybridRooms', 'ssrn:ss:sp::' + proctorAccountSid + ':hybridRoom', iam)) {
	        this.props.routing.history.push('/unauthorized');
	      }
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (SessionStore.loadingCalls.indexOf('GetBalance') < 0 && SessionStore.loadingCalls.indexOf('GetSessions') < 0) {
	        return _react2.default.createElement(
	          'ul',
	          { className: 'panel-list' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(_OwedPayments2.default, this.props)
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(_UpcomingSessions2.default, this.props)
	          )
	        );
	      }
	
	      return '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SessionStore = this.props.store.SessionStore;
	      var proctorAccountSid = SessionStore.userData.proctorAccountSid;
	
	
	      return _react2.default.createElement(
	        _config.Validate,
	        null,
	        _react2.default.createElement(
	          'main',
	          { tabIndex: '0', id: 'main-content', className: 'page' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap', iamAction: 'sp:DescribeBalance', iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':balance' },
	            _react2.default.createElement(
	              'section',
	              { className: 'page__section' },
	              this.renderResults()
	            ),
	            _react2.default.createElement(
	              'section',
	              { className: 'page__section' },
	              _react2.default.createElement(_PendingSessions2.default, Object.assign({
	                parent: this
	              }, this.props))
	            )
	          ),
	          _react2.default.createElement(_Drawer2.default, Object.assign({
	            content: this.state.drawerContent,
	            isOpen: this.state.drawerOpen,
	            parent: this,
	            messageSid: this.state.messageThreadSid,
	            pending: true
	          }, this.props))
	        )
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Dashboard')(Dashboard);

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _currencyFormatter = __webpack_require__(87);
	
	var _currencyFormatter2 = _interopRequireDefault(_currencyFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var OwedPayments = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(OwedPayments, _React$Component);
	
	  function OwedPayments() {
	    _classCallCheck(this, OwedPayments);
	
	    return _possibleConstructorReturn(this, (OwedPayments.__proto__ || Object.getPrototypeOf(OwedPayments)).apply(this, arguments));
	  }
	
	  _createClass(OwedPayments, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          PaymentStore = _props$store.PaymentStore,
	          SessionStore = _props$store.SessionStore;
	      var balance = PaymentStore.balance;
	
	      var currency = SessionStore.defaultCurrency || 'USD';
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'panel--medium' },
	        _react2.default.createElement(
	          'header',
	          { className: 'panel__header' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'panel__title' },
	            translation.heading
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__copy' },
	            _react2.default.createElement(
	              'span',
	              { className: 'panel__subhdg' },
	              translation.owe
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'text-code' },
	              _currencyFormatter2.default.format(balance, { code: currency })
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'btn--outline', to: 'payments' },
	              translation.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OwedPayments;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('OwedPayments')(OwedPayments);

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var UpcomingSessions = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(UpcomingSessions, _React$Component);
	
	  function UpcomingSessions() {
	    _classCallCheck(this, UpcomingSessions);
	
	    return _possibleConstructorReturn(this, (UpcomingSessions.__proto__ || Object.getPrototypeOf(UpcomingSessions)).apply(this, arguments));
	  }
	
	  _createClass(UpcomingSessions, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.store.ScheduleStore.events = [];
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var translation = this.props.translation;
	      var ScheduleStore = this.props.store.ScheduleStore;
	      var events = ScheduleStore.events;
	
	
	      if (events.length > 0) {
	        return _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-date', className: 'subtitle', scope: 'col' },
	                translation.date
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-student', className: 'subtitle', scope: 'col' },
	                translation.student
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-exam', className: 'subtitle', scope: 'col' },
	                translation.exam
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            events.map(function (session, i) {
	              return _react2.default.createElement(
	                'tr',
	                { key: i },
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-date' },
	                  (0, _moment2.default)(session.appointmentDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-student' },
	                  session.enrollment && session.enrollment.firstName + ' ' + session.enrollment.lastName
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-exam' },
	                  session.exam && session.exam.title
	                )
	              );
	            })
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'article',
	        { className: 'panel--medium' },
	        _react2.default.createElement(
	          'header',
	          { className: 'panel__header' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'panel__title' },
	            translation.heading
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel__copy' },
	            this.renderResults(),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'btn--outline', to: 'sessions' },
	              translation.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return UpcomingSessions;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('UpcomingSessions')(UpcomingSessions);

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _config = __webpack_require__(24);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Config
	
	
	// Components
	
	
	var Help = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Help, _React$Component);
	
	  function Help() {
	    _classCallCheck(this, Help);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (Help.__proto__ || Object.getPrototypeOf(Help)).call(this));
	
	    _this2.renderArticles = _this2.renderArticles.bind(_this2);
	    _this2.toggleLinks = _this2.toggleLinks.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Help, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        collapsed: true,
	        docs: [],
	        feature: null
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	      var HelpStore = this.props.store.HelpStore;
	
	      var help = document.querySelector('.help');
	      var helpBtn = document.querySelector('.help-wrap > button');
	
	      document.onclick = function (e) {
	        var target = e.target;
	        var collapsed = true;
	
	        while (target.parentNode) {
	          if (target === help || target === helpBtn) {
	            collapsed = false;
	            return true;
	          }
	
	          target = target.parentNode;
	        }
	
	        _this.setState({
	          collapsed: collapsed
	        });
	      };
	
	      // Make sure docs are retreived and then set the state
	      var helpDelay = setInterval(function () {
	        if (HelpStore.helpLoaded) {
	          _this.renderArticles();
	          clearInterval(helpDelay);
	        }
	      }, 100);
	    }
	
	    /*
	    Unsupported logic as o fReact 18, I don't see this being an issue
	    shouldComponentUpdate(nextProps, nextState) {
	      const thisFeature = this.state.feature;
	      const nextFeature = nextProps.store.HelpStore.feature;
	       if(thisFeature !== nextFeature) {
	        this.renderArticles()
	      }
	       return true;
	    }*/
	
	  }, {
	    key: 'renderArticles',
	    value: function renderArticles() {
	      var HelpStore = this.props.store.HelpStore;
	      var feature = HelpStore.feature;
	
	      var role = 'proctor';
	      var docs = [];
	
	      // // Get the docs for the current feature
	      // if(HelpStore.help && HelpStore.help[role]) {
	      //   HelpStore.help[role].forEach(article => {
	      //     if(article.features.indexOf(feature) > -1) {
	      //       docs.push(article);
	      //     }
	      //   })
	      // }
	
	      // Get the docs for the current feature
	      if (HelpStore.help && HelpStore.help[feature] && HelpStore.help[feature][role]) {
	        docs = HelpStore.help[feature][role];
	      }
	
	      this.setState({
	        docs: docs,
	        feature: feature
	      });
	    }
	  }, {
	    key: 'toggleLinks',
	    value: function toggleLinks() {
	      this.setState({
	        collapsed: !this.state.collapsed
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	      // Get the docs for the current feature
	      // if(HelpStore.help[feature] && HelpStore.help[feature][role]) {
	      //   docs = HelpStore.help[feature][role];
	      // }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'help-wrap' },
	        _react2.default.createElement(
	          'button',
	          {
	            className: this.props.btnClass ? this.props.btnClass : '',
	            onClick: this.toggleLinks
	          },
	          _react2.default.createElement(icons.iconQuestion, null),
	          translation.help
	        ),
	        _react2.default.createElement(
	          'aside',
	          {
	            className: 'help ' + (this.state.collapsed ? 'help--collapsed' : '')
	          },
	          this.state.docs.length > 0 && _react2.default.createElement(
	            'h5',
	            { className: 'help__title' },
	            translation.articles
	          ),
	          this.state.docs.length > 0 && _react2.default.createElement(
	            'ul',
	            { className: 'help__list' },
	            this.state.docs.map(function (doc, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    target: '_blank',
	                    href: '' + (doc.url.indexOf('http') < 0 ? _config.config.docsDomain : '') + doc.url
	                  },
	                  _react2.default.createElement(icons.iconInfo, null),
	                  doc.title
	                )
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'footer',
	            { className: 'help__footer' },
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:proctors@smarterproctoring.com?subject=Support%20Ticket' },
	              translation.contact
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Help;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Help')(Help);

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HybridRooms = __webpack_require__(873);
	
	var _HybridRooms2 = _interopRequireDefault(_HybridRooms);
	
	var _HybridSettings = __webpack_require__(292);
	
	var _HybridSettings2 = _interopRequireDefault(_HybridSettings);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _mobxReact = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HybridProctoring = (0, _mobxReact.observer)(function (_React$Component) {
	    _inherits(HybridProctoring, _React$Component);
	
	    function HybridProctoring() {
	        _classCallCheck(this, HybridProctoring);
	
	        // Set the initial state
	        var _this = _possibleConstructorReturn(this, (HybridProctoring.__proto__ || Object.getPrototypeOf(HybridProctoring)).call(this));
	
	        _this.state = {
	            createNew: false
	        };
	        return _this;
	    }
	
	    _createClass(HybridProctoring, [{
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            var createNew = this.state.createNew;
	
	
	            if (!createNew) {
	                return _react2.default.createElement(_HybridRooms2.default, Object.assign({
	                    setCreateNew: function setCreateNew(boolean) {
	                        return _this2.setState({ createNew: boolean });
	                    }
	                }, this.props));
	            } else {
	                return _react2.default.createElement(_HybridSettings2.default, Object.assign({
	                    setCreateNew: function setCreateNew(boolean) {
	                        return _this2.setState({ createNew: boolean });
	                    }
	                }, this.props));
	            }
	        }
	    }]);
	
	    return HybridProctoring;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)("HybridProctoring")(HybridProctoring);

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(17);
	
	var _reactLaunchDarkly = __webpack_require__(60);
	
	var _RoomTooltip = __webpack_require__(862);
	
	var _RoomTooltip2 = _interopRequireDefault(_RoomTooltip);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _SplitButton = __webpack_require__(864);
	
	var _SplitButton2 = _interopRequireDefault(_SplitButton);
	
	var _iamReactClient = __webpack_require__(58);
	
	var _config = __webpack_require__(24);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translation
	
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	// Icons
	
	
	var HybridRooms = (0, _mobxReact.observer)(function (_React$Component) {
	    _inherits(HybridRooms, _React$Component);
	
	    function HybridRooms() {
	        _classCallCheck(this, HybridRooms);
	
	        // Set the initial state
	        var _this = _possibleConstructorReturn(this, (HybridRooms.__proto__ || Object.getPrototypeOf(HybridRooms)).call(this));
	
	        _this.hideProctorList = function (e) {
	            var classList = e.target.classList;
	
	
	            if (!classList.contains('proctor-list') && !classList.contains('room__show-proctors') && !(0, _helpers.parentHasClass)(e.target, 'proctor-list')) {
	                _this.setState({ showProctorDetails: null });
	            }
	        };
	
	        _this.state = {
	            showProctorDetails: null,
	            selectedDropdownLocation: 'Default',
	            showLocationDropdown: true
	        };
	        _this.hideDropdown = _this.hideDropdown.bind(_this);
	        return _this;
	    }
	
	    _createClass(HybridRooms, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _props$store = this.props.store,
	                HybridStore = _props$store.HybridStore,
	                SessionStore = _props$store.SessionStore;
	            var proctorAccountSid = SessionStore.userData.proctorAccountSid;
	
	            var iam = sessionStorage.getItem('iam');
	
	            HybridStore.setFocusedLocation('Default');
	            HybridStore.listAvailableRooms(this.hideDropdown);
	            document.addEventListener('click', this.hideProctorList);
	
	            if (!(0, _iamReactClient.isAuthorized)('sp:DescribeHybridRooms', "ssrn:ss:sp::" + proctorAccountSid + ":hybridRoom", iam)) {
	                this.props.routing.history.push('/unauthorized');
	            }
	        }
	    }, {
	        key: "hideDropdown",
	        value: function hideDropdown() {
	            this.setState({
	                showLocationDropdown: false
	            });
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            document.removeEventListener('click', this.hideProctorList);
	        }
	
	        /**
	         * Hide any visible proctor lists
	         *
	         * @function hideProctorList
	         * @param {event} e
	         */
	
	    }, {
	        key: "deleteProctorRoom",
	
	
	        /**
	         * Delete selected proctor room
	         *
	         * @function deleteProctorRoom
	         */
	        value: function deleteProctorRoom(roomSid) {
	            var _props = this.props,
	                store = _props.store,
	                translation = _props.translation;
	            var HybridStore = store.HybridStore;
	
	
	            var callback = function callback() {
	                HybridStore.deleteProctorRoom(roomSid);
	            };
	
	            var msg = {
	                heading: translation.delete_confirm.heading,
	                body: translation.delete_confirm.body,
	                button: translation.delete_confirm.button,
	                cancel: translation.delete_confirm.cancel
	            };
	
	            (0, _helpers.confirm)(msg, callback);
	        }
	    }, {
	        key: "editProctorRoom",
	        value: function editProctorRoom(roomDetails) {
	            var _props2 = this.props,
	                setCreateNew = _props2.setCreateNew,
	                store = _props2.store;
	            var HybridStore = store.HybridStore;
	
	
	            HybridStore.startEditing(roomDetails);
	            setCreateNew(true);
	        }
	    }, {
	        key: "selectProctorLocationInput",
	        value: function selectProctorLocationInput(e) {
	            this.props.store.HybridStore.setFocusedLocation(e.target.value);
	            this.setState({ selectedDropdownLocation: e.target.value });
	        }
	    }, {
	        key: "renderProctorLocationDropdown",
	        value: function renderProctorLocationDropdown(locations) {
	            var translation = this.props.translation;
	
	            var optionsElement = [_react2.default.createElement(
	                "option",
	                { value: 'Default', key: 'Default' },
	                translation.location_dropdown_instructions
	            )];
	            locations.map(function (location) {
	                optionsElement.push(_react2.default.createElement(
	                    "option",
	                    { value: location.proctorAccountLocationSid, key: location.proctorAccountLocationSid },
	                    location.locationName || location.proctorAccountLocationSid
	                ));
	                return true;
	            });
	            return optionsElement;
	        }
	    }, {
	        key: "renderAllButtons",
	        value: function renderAllButtons(room) {
	            var translation = this.props.translation;
	            var HybridStore = this.props.store.HybridStore;
	
	            var defaultAction = function defaultAction() {
	                return HybridStore.joinHybridProctoringRoom(room.sid);
	            };
	            var buttonOptions = [{
	                title: translation.join_room,
	                onClick: function onClick() {
	                    return HybridStore.joinHybridProctoringRoom(room.sid);
	                }
	            }, {
	                title: translation.join_room_beta,
	                onClick: function onClick() {
	                    return HybridStore.joinHybridProctoringRoom(room.sid, 'beta');
	                }
	            }, {
	                title: translation.join_room_alpha,
	                onClick: function onClick() {
	                    return HybridStore.joinHybridProctoringRoom(room.sid, 'alpha');
	                }
	            }];
	            return _react2.default.createElement(_SplitButton2.default, Object.assign({
	                onClick: defaultAction,
	                text: translation.join_room
	            }, this.props, {
	                options: buttonOptions
	            }));
	        }
	    }, {
	        key: "renderHybridButton",
	        value: function renderHybridButton(room) {
	            var translation = this.props.translation;
	            var HybridStore = this.props.store.HybridStore;
	
	            return _react2.default.createElement(
	                "button",
	                {
	                    className: "btn btn--outline",
	                    onClick: function onClick() {
	                        return HybridStore.joinHybridProctoringRoom(room.sid);
	                    }
	                },
	                translation.join_room
	            );
	        }
	    }, {
	        key: "renderV3Button",
	        value: function renderV3Button(room) {
	            var translation = this.props.translation;
	            var HybridStore = this.props.store.HybridStore;
	
	            return _react2.default.createElement(
	                "button",
	                {
	                    className: "btn btn--outline",
	                    onClick: function onClick() {
	                        return HybridStore.joinVtcProctoringRoom(room.sid);
	                    }
	                },
	                translation.join_room
	            );
	        }
	    }, {
	        key: "renderV2Button",
	        value: function renderV2Button(room) {
	            var _this2 = this;
	
	            return _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                flagKey: "allow-hybrid-beta-use",
	                renderFeatureCallback: function renderFeatureCallback() {
	                    return _this2.renderAllButtons(room);
	                },
	                renderDefaultCallback: function renderDefaultCallback() {
	                    return _this2.renderHybridButton(room);
	                }
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this3 = this;
	
	            var _props3 = this.props,
	                translation = _props3.translation,
	                setCreateNew = _props3.setCreateNew;
	            var _state = this.state,
	                showProctorDetails = _state.showProctorDetails,
	                selectedDropdownLocation = _state.selectedDropdownLocation,
	                showLocationDropdown = _state.showLocationDropdown;
	            var HybridStore = this.props.store.HybridStore;
	            var availableRooms = HybridStore.availableRooms,
	                proctorLocations = HybridStore.proctorLocations;
	
	
	            return _react2.default.createElement(
	                _config.Validate,
	                null,
	                _react2.default.createElement(
	                    "main",
	                    { tabIndex: "0", id: "main-content", className: "page" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "wrap" },
	                        _react2.default.createElement(
	                            "header",
	                            { className: "page__header" },
	                            _react2.default.createElement(
	                                "h1",
	                                { className: "page__title" },
	                                translation.heading
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "hybrid-panel hybrid-panel--md hybrid-panel--solo" },
	                        _react2.default.createElement(
	                            "h2",
	                            { className: "hybrid-panel__title--lg" },
	                            translation.start_proctoring
	                        ),
	                        showLocationDropdown && _react2.default.createElement(
	                            "label",
	                            { className: "select__sp_proctor_locations", htmlFor: "sp_proctor_locations_select" },
	                            _react2.default.createElement(
	                                "select",
	                                { onChange: function onChange(e) {
	                                        _this3.selectProctorLocationInput(e);
	                                    }, name: "sp_proctor_locations_select", id: "sp_proctor_locations_select" },
	                                this.renderProctorLocationDropdown(proctorLocations)
	                            )
	                        ),
	                        (selectedDropdownLocation !== 'Default' || !showLocationDropdown) && _react2.default.createElement(
	                            "div",
	                            null,
	                            availableRooms.length > 0 && _react2.default.createElement(
	                                "ul",
	                                { className: "room-list" },
	                                availableRooms.map(function (room) {
	                                    return (room.proctorAccountLocationSid === selectedDropdownLocation || !showLocationDropdown) && _react2.default.createElement(
	                                        "li",
	                                        { key: room.sid,
	                                            iamAction: "sp:DescribeHybridRoom",
	                                            iamResource: "ssrn:ss:sp:us-east:" + _SessionStore2.default.userData.proctorAccountSid + ":hybridRoom/" + room.sid },
	                                        _react2.default.createElement(
	                                            "article",
	                                            {
	                                                className: "room" + (room.isActive === true ? ' room--online' : ' room--offline')
	                                            },
	                                            _react2.default.createElement(
	                                                "span",
	                                                {
	                                                    className: "room__status" + (room.isActive === true ? ' room__status--online' : ' room__status--offline')
	                                                },
	                                                _react2.default.createElement(_RoomTooltip2.default, {
	                                                    brief: true,
	                                                    content: room.isActive === true ? translation.online : translation.offline,
	                                                    hideLabel: true,
	                                                    id: "room-" + room.sid + "-status",
	                                                    left: true
	                                                })
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "room__details" },
	                                                _react2.default.createElement(
	                                                    "h3",
	                                                    { className: "room__title" },
	                                                    room.roomName ? room.roomName : room.sid
	                                                ),
	                                                _react2.default.createElement(
	                                                    "span",
	                                                    null,
	                                                    room.activeSessions === 1 ? translation.active_session : translation.active_sessions.replace('%count%', room.activeSessions || 0)
	                                                ),
	                                                (!room.proctors || room.proctors.length === 0) && _react2.default.createElement(
	                                                    "span",
	                                                    { className: "room__no-proctors" },
	                                                    translation.proctors.replace('%count%', 0)
	                                                ),
	                                                room.proctors && room.proctors.length > 0 && _react2.default.createElement(
	                                                    "div",
	                                                    { className: "room__proctors" },
	                                                    _react2.default.createElement(
	                                                        "button",
	                                                        {
	                                                            className: "room__show-proctors btn--reset",
	                                                            onClick: function onClick() {
	                                                                if (showProctorDetails === room.sid) {
	                                                                    _this3.setState({ showProctorDetails: null });
	                                                                } else {
	                                                                    _this3.setState({ showProctorDetails: room.sid });
	                                                                }
	                                                            }
	                                                        },
	                                                        room.proctors && room.proctors.length === 1 ? translation.proctor : translation.proctors.replace('%count%', room.proctors.length || 0)
	                                                    ),
	                                                    _react2.default.createElement(
	                                                        "ul",
	                                                        {
	                                                            className: "proctor-list" + (showProctorDetails === room.sid ? ' proctor-list--visible' : '')
	                                                        },
	                                                        room.proctors.map(function (proctor, i) {
	                                                            return _react2.default.createElement(
	                                                                "li",
	                                                                {
	                                                                    className: "hybrid-icon--xs",
	                                                                    key: i
	                                                                },
	                                                                room.ownerSid === room.proctors[i].proctorAccountUserSid && _react2.default.createElement(icons.iconCrown, null),
	                                                                room.proctors[i].firstName + " " + room.proctors[i].lastName
	                                                            );
	                                                        })
	                                                    )
	                                                )
	                                            ),
	                                            _react2.default.createElement(
	                                                "div",
	                                                { className: "room__join action" },
	                                                _react2.default.createElement(
	                                                    "button",
	                                                    {
	                                                        className: "room__delete btn btn--ghost btn--inverse hybrid-icon--sm",
	                                                        iamAction: "sp:ModifyHybridRoom",
	                                                        iamResource: "ssrn:ss:sp:us-east:" + _SessionStore2.default.userData.proctorAccountSid + ":hybridRoom/" + room.sid,
	                                                        onClick: function onClick() {
	                                                            return _this3.editProctorRoom(room);
	                                                        }
	                                                    },
	                                                    _react2.default.createElement(icons.iconEdit, null),
	                                                    _react2.default.createElement(
	                                                        "span",
	                                                        { className: "meta" },
	                                                        translation.edit_room
	                                                    )
	                                                ),
	                                                !room.isActive && room.activeSessions === 0 && _react2.default.createElement(
	                                                    "button",
	                                                    {
	                                                        className: "room__delete btn btn--ghost btn--destructive hybrid-icon--sm",
	                                                        iamAction: "sp:DeleteHybridRoom",
	                                                        iamResource: "ssrn:ss:sp:us-east:" + _SessionStore2.default.userData.proctorAccountSid + ":hybridRoom/" + room.sid,
	                                                        onClick: function onClick() {
	                                                            return _this3.deleteProctorRoom(room.sid);
	                                                        }
	                                                    },
	                                                    _react2.default.createElement(icons.iconTrash2, null),
	                                                    _react2.default.createElement(
	                                                        "span",
	                                                        { className: "meta" },
	                                                        translation.delete_room
	                                                    )
	                                                ),
	                                                _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                                                    flagKey: "enable-v-3-for-live",
	                                                    renderFeatureCallback: function renderFeatureCallback() {
	                                                        console.log('renderV3Button', room.version);
	                                                        if (String(room.version) === '3') {
	                                                            return _this3.renderV3Button(room);
	                                                        } else {
	                                                            return _this3.renderV2Button(room);
	                                                        }
	                                                    },
	                                                    renderDefaultCallback: function renderDefaultCallback() {
	                                                        return _this3.renderV2Button(room);
	                                                    }
	                                                })
	                                            )
	                                        )
	                                    );
	                                })
	                            ),
	                            _react2.default.createElement(
	                                "button",
	                                {
	                                    className: "btn",
	                                    onClick: function onClick() {
	                                        return setCreateNew(true);
	                                    },
	                                    iamAction: "sp:CreateHybridRoom",
	                                    iamResource: "ssrn:ss:sp:us-east:" + _SessionStore2.default.userData.proctorAccountSid + ":hybridRoom",
	                                    type: "button"
	                                },
	                                _react2.default.createElement(icons.iconPlus, null),
	                                translation.create_room
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HybridRooms;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)("HybridRooms")(HybridRooms);

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Location = __webpack_require__(296);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var LocationEdit = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(LocationEdit, _React$Component);
	
	  function LocationEdit() {
	    _classCallCheck(this, LocationEdit);
	
	    return _possibleConstructorReturn(this, (LocationEdit.__proto__ || Object.getPrototypeOf(LocationEdit)).apply(this, arguments));
	  }
	
	  _createClass(LocationEdit, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(_Location2.default, Object.assign({}, this.props, { editing: true }))
	        )
	      );
	    }
	  }]);
	
	  return LocationEdit;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('LocationEdit')(LocationEdit);

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _iamReactClient = __webpack_require__(58);
	
	var _reactLaunchDarkly = __webpack_require__(60);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Toolbar = __webpack_require__(865);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Dependencies
	
	
	// Translations
	
	
	// Components
	
	
	var Locations = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Locations, _React$Component);
	
	  function Locations() {
	    _classCallCheck(this, Locations);
	
	    var _this2 = _possibleConstructorReturn(this, (Locations.__proto__ || Object.getPrototypeOf(Locations)).call(this));
	
	    _this2.getLocations = _this2.getLocations.bind(_this2);
	    _this2.deleteLocations = _this2.deleteLocations.bind(_this2);
	    _this2.renderResults = _this2.renderResults.bind(_this2);
	
	    _this2.state = {
	      drawerOpen: false,
	      drawerContent: null,
	      locationSid: null,
	      selectedRows: []
	    };
	    return _this2;
	  }
	
	  _createClass(Locations, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var pathname = this.props.routing.location.pathname;
	      var _props$store = this.props.store,
	          LocationStore = _props$store.LocationStore,
	          SessionStore = _props$store.SessionStore;
	      var proctorAccountSid = SessionStore.userData.proctorAccountSid;
	
	      var iam = sessionStorage.getItem('iam');
	
	      if (LocationStore.locations.length === 0) {
	        this.getLocations();
	      }
	      if (pathname.indexOf('/edit') > -1) {
	        var locationSid = pathname.substr(pathname.lastIndexOf('/') + 1);
	
	        this.setState({
	          locationSid: locationSid,
	          drawerContent: "LocationEdit"
	        });
	
	        (0, _helpers.toggleDrawer)(null, this, 'LocationEdit');
	      } else if (pathname.indexOf('/add') > -1) {
	        (0, _helpers.toggleDrawer)(null, this, 'LocationEdit');
	      } else if (pathname.indexOf('/schedule') > -1) {
	        var scheduleLocationSid = pathname.substr(pathname.lastIndexOf('/') + 1);
	
	        this.setState({
	          scheduleLocationSid: scheduleLocationSid
	        });
	
	        (0, _helpers.toggleDrawer)(null, this, 'ScheduleManage');
	      }
	
	      if (!(0, _iamReactClient.isAuthorized)('sp:CreateProctorAccountLocationAvailability', 'ssrn:ss:sp::' + proctorAccountSid + ':location', iam)) {
	        this.props.routing.history.push('/unauthorized');
	      }
	    }
	  }, {
	    key: 'getLocations',
	    value: function getLocations() {
	      var _props$store2 = this.props.store,
	          LocationStore = _props$store2.LocationStore,
	          ScheduleStore = _props$store2.ScheduleStore,
	          SessionStore = _props$store2.SessionStore;
	
	
	      if (SessionStore.smarterscheduling) {
	        var callback = function callback() {
	          // Check if scheduling is enabled by getting account
	          ScheduleStore.getScheduleAccount(ScheduleStore.getScheduleLocations);
	        };
	
	        LocationStore.getLocations(callback);
	      } else {
	        LocationStore.getLocations();
	      }
	    }
	  }, {
	    key: 'handleEdit',
	    value: function handleEdit(e, locationSid) {
	      e.preventDefault();
	
	      // Reset location data
	      this.setState({
	        locationSid: null
	      });
	      this.props.store.LocationStore.resetLocation();
	
	      // Update url
	      var path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '/');
	
	      if (this.props.routing.location.pathname !== path) {
	        this.props.routing.history.push(path);
	      }
	    }
	  }, {
	    key: 'deleteLocations',
	    value: function deleteLocations(location) {
	      var _this3 = this;
	
	      var _this = this;
	      var translation = this.props.translation;
	      var LocationStore = this.props.store.LocationStore;
	
	
	      LocationStore.locationSid = location.sid;
	
	      var msg = {
	        heading: translation.delete_confirm.heading_singular,
	        body: translation.delete_confirm.body_singular,
	        button: translation.delete_confirm.button
	      };
	
	      if (this.state.selectedRows.length > 1) {
	        msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
	        msg.body = translation.delete_confirm.body_plural;
	      }
	
	      (0, _helpers.confirm)(msg, function () {
	        for (var i = 0; i < _this.state.selectedRows.length; i++) {
	          LocationStore.deleteLocation(_this.state.selectedRows[i]);
	        }
	
	        _this.setState({
	          selectedRows: []
	        });
	
	        // Uncheck checkboxes
	        var cboxes = document.querySelectorAll('table input[type="checkbox"]:checked');
	        cboxes.forEach(function (cbox) {
	          cbox.checked = false;
	        });
	
	        // Refresh location list
	        _this3.getLocations();
	      });
	    }
	  }, {
	    key: 'enableSchedule',
	    value: function enableSchedule(location) {
	      var _this = this;
	      var ScheduleStore = this.props.store.ScheduleStore;
	
	
	      var callback = function callback(data) {
	        _this.getLocations();
	      };
	
	      var data = {
	        title: location.name,
	        externalId: location.sid,
	        seatManagement: 'basic',
	        sid: location.sid
	      };
	
	      ScheduleStore.enableLocationSchedule(data, callback);
	    }
	  }, {
	    key: 'renderEditButton',
	    value: function renderEditButton(location) {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        _reactRouterDom.Link,
	        {
	          className: 'btn--outline',
	          to: '/locations/edit/' + location.sid,
	          onClick: function onClick(e) {
	            _this4.handleEdit(e, location.sid);
	            _this4.setState({ locationSid: location.sid });
	            (0, _helpers.toggleDrawer)(null, _this4, 'LocationEdit');
	          }
	        },
	        translation.edit
	      );
	    }
	  }, {
	    key: 'renderScheduleButton',
	    value: function renderScheduleButton(location) {
	      var _this5 = this;
	
	      var translation = this.props.translation;
	      var scheduleLocations = this.props.store.ScheduleStore.scheduleLocations;
	
	      var scheduleEnabled = false;
	      var scheduleSid = null;
	
	      scheduleLocations.forEach(function (scheduleLocation) {
	        if (scheduleLocation.externalId === location.sid) {
	          scheduleEnabled = true;
	          scheduleSid = scheduleLocation.sid;
	        }
	      });
	
	      if (location.schedulingModule === 'smarter-scheduling') {
	        if (scheduleEnabled) {
	          // Return manage schedule button
	          return _react2.default.createElement(
	            _reactRouterDom.Link,
	            {
	              className: 'btn--outline',
	              to: '/locations/schedule/' + scheduleSid,
	              onClick: function onClick() {
	                _this5.setState({ scheduleLocationSid: scheduleSid });
	                (0, _helpers.toggleDrawer)(null, _this5, 'ScheduleManage');
	              }
	            },
	            _react2.default.createElement(icons.iconCalendar, null),
	            translation.manage_schedule
	          );
	        } else {
	          // Return enable schedule button
	          return _react2.default.createElement(
	            'button',
	            {
	              className: 'btn--link',
	              onClick: function onClick() {
	                return _this5.enableSchedule(location);
	              }
	            },
	            translation.enable_schedule
	          );
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(e, sid) {
	      var selectedRows = [].concat(_toConsumableArray(this.state.selectedRows));
	      var rowIndex = -1;
	
	      if (e.target.checked) {
	        selectedRows.push(sid);
	      } else {
	        rowIndex = selectedRows.indexOf(sid);
	        selectedRows.splice(rowIndex, 1);
	      }
	
	      this.setState({
	        selectedRows: selectedRows
	      });
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this6 = this;
	
	      var _props$store3 = this.props.store,
	          LocationStore = _props$store3.LocationStore,
	          ScheduleStore = _props$store3.ScheduleStore,
	          SessionStore = _props$store3.SessionStore;
	      var translation = this.props.translation;
	
	
	      if (!LocationStore.locations.length && !SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cta' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'cta__copy' },
	            translation.location_cta.heading
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { className: 'cta__btn btn--icn-right', to: '/locations/add', onClick: function onClick(e) {
	                _this6.handleEdit(e);
	                (0, _helpers.toggleDrawer)(null, _this6, 'LocationEdit');
	              } },
	            translation.location_cta.button,
	            _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	          )
	        );
	      } else if (LocationStore.locations.length > 0 && SessionStore.loadingCalls.indexOf('getScheduleLocations') < 0) {
	        return _react2.default.createElement(
	          'table',
	          { className: 'locations' },
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-select', scope: 'col' },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  'Select'
	                )
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-name', scope: 'col' },
	                translation.name
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-address', scope: 'col' },
	                translation.address
	              ),
	              ScheduleStore.scheduleAccountEnabled && _react2.default.createElement(
	                'th',
	                { id: 'heading-actions', scope: 'col' },
	                translation.actions
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            LocationStore.locations.map(function (key, i) {
	              return _react2.default.createElement(
	                'tr',
	                { key: i },
	                _react2.default.createElement(
	                  'td',
	                  { className: 'check-col', 'aria-labelledby': 'heading-select' },
	                  _react2.default.createElement('input', {
	                    id: 'select-' + key.sid,
	                    className: 'checkbox-input',
	                    type: 'checkbox',
	                    onChange: function onChange(e) {
	                      return _this6.handleSelect(e, key.sid);
	                    }
	                  }),
	                  _react2.default.createElement(
	                    'label',
	                    {
	                      className: 'checkbox-label checkbox-label--solo', htmlFor: 'select-' + key.sid
	                    },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'meta' },
	                      'Select ',
	                      key.hame
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'fn org', 'aria-labelledby': 'heading-name' },
	                  _react2.default.createElement(
	                    'h3',
	                    null,
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        to: '/locations/edit/' + key.sid,
	                        onClick: function onClick(e) {
	                          _this6.handleEdit(e, key.sid);
	                          _this6.setState({ locationSid: key.sid });
	                          (0, _helpers.toggleDrawer)(null, _this6, 'LocationEdit');
	                        }
	                      },
	                      key.name
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-address' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'adr' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'street-address' },
	                      key.address1,
	                      _react2.default.createElement('br', null),
	                      key.address2 || ''
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'locality' },
	                      key.place
	                    ),
	                    ', ',
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'region' },
	                      key.region
	                    ),
	                    ' ',
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'postal-code' },
	                      key.postalCode
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'country' },
	                      key.country
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { className: 'actions', 'aria-labelledby': 'heading-actions' },
	                  _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	                    flagKey: 'proctor-schedules',
	                    renderFeatureCallback: function renderFeatureCallback() {
	                      return _this6.renderScheduleButton(key);
	                    },
	                    renderDefaultCallback: function renderDefaultCallback() {
	                      return _this6.renderEditButton(key);
	                    }
	                  })
	                )
	              );
	            })
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        this.props.Validate,
	        null,
	        _react2.default.createElement(
	          'main',
	          { tabIndex: '0', id: 'main-content', className: 'page' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'header',
	              { className: 'page__header' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'page__title' },
	                  translation.heading
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'page__actions actions' },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { className: 'btn--outline', to: '/locations/add', onClick: function onClick(e) {
	                        _this7.handleEdit(e);
	                        (0, _helpers.toggleDrawer)(null, _this7, 'LocationEdit');
	                      } },
	                    _react2.default.createElement(icons.iconPlus, null),
	                    translation.add
	                  )
	                )
	              )
	            ),
	            this.renderResults()
	          ),
	          this.state.selectedRows.length > 0 && _react2.default.createElement(_Toolbar2.default, Object.assign({
	            selectedRows: this.state.selectedRows,
	            deleteText: translation.delete,
	            deleteFunction: this.deleteLocations
	          }, this.props)),
	          _react2.default.createElement(_Drawer2.default, Object.assign({
	            content: this.state.drawerContent,
	            isOpen: this.state.drawerOpen,
	            parent: this }, this.props, {
	            locationSid: this.state.locationSid,
	            callback: this.getLocations
	          }))
	        )
	      );
	    }
	  }]);
	
	  return Locations;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Locations')(Locations);

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _reactLaunchDarkly = __webpack_require__(60);
	
	var _config = __webpack_require__(24);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var Maintenance = function (_React$Component) {
	  _inherits(Maintenance, _React$Component);
	
	  function Maintenance() {
	    _classCallCheck(this, Maintenance);
	
	    return _possibleConstructorReturn(this, (Maintenance.__proto__ || Object.getPrototypeOf(Maintenance)).apply(this, arguments));
	  }
	
	  _createClass(Maintenance, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	      // Create a minimal anonymous user for LaunchDarkly
	
	      var anonymousUser = {
	        key: 'anonymous-user',
	        anonymous: true
	      };
	
	      return _react2.default.createElement(
	        _reactLaunchDarkly.LaunchDarkly,
	        { clientId: _config.config.ldApiKey, user: anonymousUser },
	        _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	          flagKey: 'maintenance-message',
	          renderFeatureCallback: function renderFeatureCallback(flagValue) {
	            if (flagValue && (typeof flagValue === 'undefined' ? 'undefined' : _typeof(flagValue)) === 'object' && flagValue.message !== undefined) {
	              return _react2.default.createElement(
	                'main',
	                { tabIndex: '0', id: 'main-content', className: 'page page--error wrap' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'panel--brief' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'page--error__icon' },
	                    _react2.default.createElement(icons.iconClock, null)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h1',
	                      { className: 'panel__title' },
	                      flagValue.title || translation.heading
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      flagValue.message || translation.message
	                    )
	                  )
	                )
	              );
	            } else {
	              return _react2.default.createElement(
	                'main',
	                { tabIndex: '0', id: 'main-content', className: 'page page--error wrap' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'panel--brief' },
	                  _react2.default.createElement(
	                    'i',
	                    { className: 'page--error__green__icon' },
	                    _react2.default.createElement(icons.iconBadgeCheck, null)
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'h1',
	                      { className: 'panel__title' },
	                      translation.up_heading
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      translation.up_message
	                    )
	                  )
	                )
	              );
	            }
	          }
	        })
	      );
	    }
	  }]);
	
	  return Maintenance;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('Maintenance')(Maintenance);

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var Address = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Address, _React$Component);
	
	  function Address() {
	    _classCallCheck(this, Address);
	
	    var _this2 = _possibleConstructorReturn(this, (Address.__proto__ || Object.getPrototypeOf(Address)).call(this));
	
	    _this2.geolocate = _this2.geolocate.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Address, [{
	    key: 'geolocate',
	    value: function geolocate(e) {
	      // To prevent autofilling, the address field is readonly which needs to be changed
	      e.target.removeAttribute('readOnly');
	
	      var _this = this;
	      var google = window.google;
	      var input = document.querySelector('#address-autocomplete');
	      var autocomplete = new google.maps.places.Autocomplete(input, { types: ['geocode'] });
	      autocomplete.addListener('place_changed', function (e) {
	        return updateAddress(e);
	      });
	
	      // Prevent submit on enter
	      google.maps.event.addDomListener(input, 'keydown', function (e) {
	        if (e.keyCode === 13) {
	          e.preventDefault();
	        }
	      });
	
	      function updateAddress() {
	        var place = autocomplete.getPlace();
	
	        var location = {
	          address1: null,
	          address2: null,
	          place: null,
	          region: null,
	          country: null,
	          postalCode: null
	        };
	
	        if (!place.geometry) {
	          // The user entered the name of a place that wasn’t suggested
	          // and pressed the Enter key, or the request failed
	          // window.alert(`No details available for “${place.name}”`);
	          var suggestions = document.querySelector('.pac-container');
	          setTimeout(function () {
	            suggestions.style.display = 'block';
	          });
	          return;
	        } else {
	          // Loop through address components to get data
	          for (var i = 0; i < place.address_components.length; i++) {
	            // Address 1 number
	            if (place.address_components[i].types.indexOf('street_number') > -1) {
	              location.address1 = place.address_components[i].short_name;
	            }
	
	            // Address 1 street
	            if (place.address_components[i].types.indexOf('route') > -1) {
	              if (location.address1) {
	                location.address1 += ' ' + place.address_components[i].short_name;
	              } else {
	                location.address1 = place.address_components[i].short_name;
	              }
	            }
	
	            // Address 2
	            if (place.address_components[i].types.indexOf('subpremise') > -1) {
	              location.address2 = place.address_components[i].short_name;
	            }
	
	            // City
	            if (place.address_components[i].types.indexOf('locality') > -1) {
	              location.place = place.address_components[i].short_name;
	            }
	
	            // Region
	            if (place.address_components[i].types.indexOf('administrative_area_level_1') > -1) {
	              location.region = place.address_components[i].short_name;
	            }
	
	            // Country
	            if (place.address_components[i].types.indexOf('country') > -1) {
	              location.country = place.address_components[i].short_name;
	            }
	
	            // Postal code
	            if (place.address_components[i].types.indexOf('postal_code') > -1) {
	              location.postalCode = place.address_components[i].short_name;
	            }
	          }
	
	          // Check if address components contained a street address
	          // and parse the formatted address if it didn’t
	          if (!location.address1) {
	            var addr_arr = place.formatted_address.split(',');
	
	            if (addr_arr.length > 3) {
	              location.address1 = addr_arr[0];
	
	              if (addr_arr.length > 4) {
	                location.address2 = addr_arr[1].replace(' ', '');
	              }
	            }
	          }
	
	          _this.props.locationParent.location = location;
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          mailing = _props.mailing,
	          translation = _props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'label',
	          {
	            className: 'lbl-required',
	            htmlFor: 'autocomplete'
	          },
	          mailing ? translation.label_mail : translation.label
	        ),
	        _react2.default.createElement('input', {
	          id: 'address-autocomplete',
	          type: 'text',
	          onFocus: function onFocus(e) {
	            return _this3.geolocate(e);
	          },
	          placeholder: mailing ? translation.helper_mail : translation.helper,
	          required: true,
	          'aria-required': 'true',
	          autoComplete: 'false',
	          readOnly: true
	        })
	      );
	    }
	  }]);
	
	  return Address;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Address')(Address);

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var Map = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Map, _React$Component);
	
	  function Map() {
	    _classCallCheck(this, Map);
	
	    var _this2 = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this));
	
	    _this2.state = {
	      mapRendered: false
	    };
	    return _this2;
	  }
	
	  /*
	  // I don't understand what this was doing aside from sometimes preventing the render of the map
	  // I'm commenting this out instead of deleting it in case getting rid of this creates some bug I'm not seeing
	  componentDidMount() {
	    if(!this.props.store.LocationStore.locationSid) {
	      this.setState({
	        mapRendered: true
	      });
	    }
	  }
	   shouldComponentUpdate() {
	    if(this.state.mapRendered) {
	      return false;
	    } else {
	      return true;
	    }
	  }
	  MobX should take care of this, but if not we'll use Memo
	   */
	
	  _createClass(Map, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var google = window.google;
	      var map = void 0;
	      var _this = this;
	
	      function initMap() {
	        map = new google.maps.Map(document.getElementById('map'), {
	          center: _this.props.center,
	          zoom: _this.props.zoom,
	          streetViewControl: false,
	          mapTypeControl: false,
	          scrollwheel: false,
	          clickableIcons: false
	        });
	
	        var name = null;
	        var address1 = null;
	        var address2 = null;
	        var city = null;
	        var region = null;
	        var country = null;
	        var postalCode = null;
	        var lat = null;
	        var lng = null;
	        var lastPosition = null;
	
	        // Custom marker
	        var pin = {
	          anchor: new google.maps.Point(10, 30),
	          path: 'm14.955742,10.044257q0,-2.051987 -1.451878,-3.503865t-3.503865,-1.451878t-3.503865,1.451878t-1.451878,3.503865t1.451878,3.503866t3.503865,1.451878t3.503865,-1.451878t1.451878,-3.503866zm4.955743,0q0,2.110063 -0.638826,3.465149l-7.046447,14.98338q-0.309734,0.638826 -0.919523,1.006635t-1.30669,0.367809t-1.30669,-0.367809t-0.900164,-1.006635l-7.065806,-14.98338q-0.638826,-1.355086 -0.638826,-3.465149q0,-4.103975 2.903756,-7.007731t7.007731,-2.903756t7.007731,2.903756t2.903756,7.007731z',
	          fillColor: '#9d80d8',
	          fillOpacity: 1,
	          strokeColor: '#7f59cc',
	          strokeWeight: 1,
	          scale: 1.25
	
	          // Create marker
	        };var marker = new google.maps.Marker({
	          map: map,
	          icon: pin,
	          draggable: true
	        });
	
	        // Create drag radius
	        var radius = new google.maps.Circle({
	          // strokeColor: '#ff0000',
	          strokeOpacity: 0,
	          // strokeWeight: 1,
	          clickable: false,
	          fillOpacity: 0,
	          map: map,
	          radius: 100
	        });
	
	        // If a center is provided, drop the marker and the radius
	        if (_this.props.dropPin) {
	          marker.setPosition(_this.props.center);
	          radius.setCenter(_this.props.center);
	        }
	
	        marker.addListener('dragend', function () {
	          var markerPosition = marker.getPosition();
	          lat = markerPosition.lat();
	          lng = markerPosition.lng();
	
	          _this.props.setLocation(name, address1, address2, city, region, country, postalCode, lat, lng, true);
	        });
	
	        // Limit marker drag to location bounds
	        marker.addListener('drag', function () {
	          var position = marker.getPosition();
	          var bounds = radius.getBounds();
	          bounds.contains(position) ? lastPosition = position : marker.setPosition(lastPosition);
	        });
	
	        // Places autocomplete
	        var input = document.querySelector('#map-search');
	
	        if (!input) {
	          input = document.querySelector('#map-addr1');
	        }
	
	        if (input) {
	          var options = {
	            types: [],
	            fields: ['address_components', 'name', 'geometry.location', 'place_id', 'formatted_address']
	          };
	
	          var autocomplete = new google.maps.places.Autocomplete(input, options);
	
	          // Bind the map’s bounds to the autocomplete object
	          autocomplete.bindTo('bounds', map);
	
	          autocomplete.addListener('place_changed', function () {
	            marker.setVisible(false);
	            var place = autocomplete.getPlace();
	
	            // Reset address variables
	            name = null;
	            address1 = null;
	            address2 = null;
	            city = null;
	            region = null;
	            country = null;
	            postalCode = null;
	            lat = null;
	            lng = null;
	
	            if (!place.geometry) {
	              // The user entered the name of a place that wasn’t suggested
	              // and pressed the Enter key, or the request failed
	              // window.alert(`No details available for “${place.name}”`);
	              var suggestions = document.querySelector('.pac-container');
	              setTimeout(function () {
	                suggestions.style.display = 'block';
	              });
	              return;
	            } else {
	              // Loop through address components to get data
	              for (var i = 0; i < place.address_components.length; i++) {
	                // Address 1 number
	                if (place.address_components[i].types.indexOf('street_number') > -1) {
	                  address1 = place.address_components[i].short_name;
	                }
	
	                // Address 1 street
	                if (place.address_components[i].types.indexOf('route') > -1) {
	                  if (address1) {
	                    address1 += ' ' + place.address_components[i].short_name;
	                  } else {
	                    address1 = place.address_components[i].short_name;
	                  }
	                }
	
	                // Address 2
	                if (place.address_components[i].types.indexOf('subpremise') > -1) {
	                  address2 = place.address_components[i].short_name;
	                }
	
	                // City
	                if (place.address_components[i].types.indexOf('locality') > -1) {
	                  city = place.address_components[i].short_name;
	                }
	
	                // Region
	                if (place.address_components[i].types.indexOf('administrative_area_level_1') > -1) {
	                  region = place.address_components[i].short_name;
	                }
	
	                // Country
	                if (place.address_components[i].types.indexOf('country') > -1) {
	                  country = place.address_components[i].long_name;
	                }
	
	                // Postal code
	                if (place.address_components[i].types.indexOf('postal_code') > -1) {
	                  postalCode = place.address_components[i].short_name;
	                }
	              }
	
	              // Check if address components contained a street address
	              // and parse the formatted address if it didn’t
	              if (!address1) {
	                var addr_arr = place.formatted_address.split(',');
	
	                if (addr_arr.length > 3) {
	                  address1 = addr_arr[0];
	
	                  if (addr_arr.length > 4) {
	                    address2 = addr_arr[1].replace(' ', '');
	                  }
	                }
	              }
	
	              // Set the name
	              if (place.name !== address1) {
	                name = place.name;
	              }
	
	              lat = place.geometry.location.lat();
	              lng = place.geometry.location.lng();
	
	              _this.props.setLocation(name, address1, address2, city, region, country, postalCode, lat, lng, true);
	            }
	
	            // Move the map
	            map.setCenter(place.geometry.location);
	            map.setZoom(17);
	
	            // Set marker drag bounds
	            radius.setCenter(place.geometry.location);
	
	            // Drop a marker
	            marker.setPosition(place.geometry.location);
	            marker.setVisible(true);
	          });
	        }
	      }
	
	      // If it’s a new location, initialize the map
	      if (this.props.store.LocationStore.renderMap && !this.props.store.LocationStore.locationSid) {
	        initMap();
	      }
	
	      // If it’s an exisiting location, wait for data and then initialize the map
	      if (this.props.store.LocationStore.locationSid && this.props.store.LocationStore.locationData.name) {
	        if (!this.state.mapRendered) {
	          this.setState({
	            mapRendered: true
	          });
	        }
	
	        if (!_this.state.mapRendered) {
	          initMap();
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'map' },
	        _react2.default.createElement(
	          'div',
	          { className: 'map__search' },
	          _react2.default.createElement(
	            'label',
	            {
	              className: 'meta',
	              htmlFor: 'map-search'
	            },
	            translation.location.label
	          ),
	          !this.props.locationSid && _react2.default.createElement('input', {
	            type: 'text',
	            id: 'map-search',
	            placeholder: translation.location.helper,
	            required: true,
	            'aria-required': 'true'
	          })
	        ),
	        _react2.default.createElement('div', { id: 'map', className: 'location__map' })
	      );
	    }
	  }]);
	
	  return Map;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Map')(Map);

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _MessageThread = __webpack_require__(293);
	
	var _MessageThread2 = _interopRequireDefault(_MessageThread);
	
	var _iamReactClient = __webpack_require__(58);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Inbox = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Inbox, _React$Component);
	
	  function Inbox() {
	    _classCallCheck(this, Inbox);
	
	    var _this = _possibleConstructorReturn(this, (Inbox.__proto__ || Object.getPrototypeOf(Inbox)).call(this));
	
	    _this.toggleNav = _this.toggleNav.bind(_this);
	    _this.viewThread = _this.viewThread.bind(_this);
	    return _this;
	  }
	
	  _createClass(Inbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        messageSid: null,
	        showNav: false
	      };
	
	      this.props.store.MessageStore.getThreads();
	
	      // Load thread if there’s one in the URL
	      if ((0, _helpers.getURLSegment)(this, 2) === 'view' && (0, _helpers.getURLSegment)(this, 3)) {
	        this.setState({
	          messageSid: (0, _helpers.getURLSegment)(this, 3)
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var iam = sessionStorage.getItem('iam');
	      var proctorAccountSid = this.props.store.SessionStore.userData.proctorAccountSid;
	
	
	      if (!(0, _iamReactClient.isAuthorized)('sp:CreateMessageThread', 'ssrn:ss:sp::' + proctorAccountSid + ':message', iam)) {
	        this.props.routing.history.push('/unauthorized');
	      }
	    }
	  }, {
	    key: 'toggleNav',
	    value: function toggleNav() {
	      this.setState({
	        showNav: !this.state.showNav
	      });
	    }
	  }, {
	    key: 'switchMailbox',
	    value: function switchMailbox(e, mailbox) {
	      e.preventDefault();
	
	      // Unhighlight previously selected tab
	      // const prevMailbox = document.querySelectorAll('.threads__switch .selected');
	      //
	      // prevMailbox.forEach(function(mailbox){
	      //   if(mailbox) {
	      //     mailbox.className = mailbox.className.replace('selected', '');
	      //   }
	      // })
	
	      // Highlight newly selected tab
	      e.target.className += ' selected';
	
	      // Get new mailbox (not included yet since the API doesn’t exist)
	    }
	  }, {
	    key: 'viewThread',
	    value: function viewThread(e, messageSid) {
	      this.setState({
	        messageSid: messageSid
	      });
	
	      this.toggleNav();
	
	      // Unhighlight any previously selected threads and
	      var prevThread = document.querySelector('.thread.active');
	
	      if (prevThread && prevThread.className.indexOf('active') > -1) {
	        prevThread.className = prevThread.className.replace('active', '');
	      }
	
	      var thisThread = document.querySelector('#thread-' + messageSid);
	
	      if (thisThread) {
	        thisThread.className = thisThread.className.replace('thread--unread', '');
	        thisThread.className += ' thread--read';
	      }
	    }
	  }, {
	    key: 'renderSubject',
	    value: function renderSubject(thread) {
	      var translation = this.props.translation;
	
	
	      var subject = null;
	
	      if (thread.dateOption1) {
	        subject = translation.subjects.session_request;
	      } else if (thread.proctorApproval) {
	        subject = translation.subjects.proctor_approval;
	      } else if (thread.examSessionEventReport) {
	        subject = translation.subjects.session_incident;
	      } else if ((thread.examConfiguration || thread.examSid) && thread.exam) {
	        subject = thread.exam.title;
	      }
	
	      if (subject) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'thread__subject', title: subject },
	          subject
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          MessageStore = _props$store.MessageStore,
	          SessionStore = _props$store.SessionStore;
	      var threads = MessageStore.threads;
	
	
	      var thisUserSid = SessionStore.userData.sid;
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header inbox-header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'meta' },
	              translation.page_title
	            ),
	            threads.length > 0 && _react2.default.createElement(
	              'button',
	              { className: 'btn--outline inbox-nav-btn', onClick: this.toggleNav },
	              _react2.default.createElement(icons.iconList, null),
	              translation.inbox_nav
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'inbox ' + (this.state.showNav ? 'show-threads' : '') },
	          _react2.default.createElement(
	            'section',
	            { className: 'threads' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'meta' },
	              translation.active_threads
	            ),
	            threads.length > 0 && _react2.default.createElement(
	              'ol',
	              { id: 'active-threads', className: 'thread-list' },
	              threads.map(function (thread, i) {
	                var threadUserUnread = null;
	
	                if (thisUserSid === thread.initiatingUserSid) {
	                  threadUserUnread = 'initiatingUserHasUnread';
	                } else {
	                  threadUserUnread = 'proctorAccountUserHasUnread';
	                }
	
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  _react2.default.createElement(
	                    'article',
	                    { id: 'thread-' + thread.sid, className: 'thread ' + (thread[threadUserUnread] ? 'thread--unread' : 'thread--read') },
	                    _react2.default.createElement(
	                      'header',
	                      { id: 'thread-' + i + '-title', className: 'thread_header' },
	                      _react2.default.createElement(
	                        'h3',
	                        { className: 'thread__title' },
	                        thread.recipientFirstName,
	                        ' ',
	                        thread.recipientLastName
	                      ),
	                      _this2.renderSubject(thread)
	                    ),
	                    _react2.default.createElement(
	                      'time',
	                      { className: 'thread__date' },
	                      _moment2.default.utc(thread.lastMessageDate).local().format('M/D/YYYY')
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      {
	                        className: 'cover',
	                        to: '/' + (0, _helpers.getURLSegment)(_this2, 1) + '/view/' + thread.sid,
	                        onClick: function onClick(e) {
	                          _this2.viewThread(e, thread.sid);
	                        },
	                        'aria-labelledby': 'thread-' + i + '-title'
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        translation.view_thread
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            { className: 'inbox__content' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'meta' },
	              translation.inbox_content
	            ),
	            threads.length === 0 && _react2.default.createElement(
	              'span',
	              { className: 'no-results' },
	              translation.no_messages
	            ),
	            threads.length > 0 && this.state.messageSid && _react2.default.createElement(_MessageThread2.default, Object.assign({ messageSid: this.state.messageSid, inbox: this }, this.props)),
	            threads.length > 0 && !this.state.messageSid && _react2.default.createElement(
	              'span',
	              { className: 'no-results' },
	              translation.choose_thread
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Inbox;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Inbox')(Inbox);

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var MessageContext = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(MessageContext, _React$Component);
	
	  function MessageContext() {
	    _classCallCheck(this, MessageContext);
	
	    return _possibleConstructorReturn(this, (MessageContext.__proto__ || Object.getPrototypeOf(MessageContext)).apply(this, arguments));
	  }
	
	  _createClass(MessageContext, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'aside',
	        { className: 'thread__context' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'thread__context__hdg' },
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'data--alt' },
	          this.props.data.map(function (data, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'strong',
	                null,
	                data.title
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                data.value
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return MessageContext;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('MessageContext')(MessageContext);

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactQuill = __webpack_require__(1155);
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	var MessageForm = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(MessageForm, _React$Component);
	
	  function MessageForm() {
	    _classCallCheck(this, MessageForm);
	
	    var _this = _possibleConstructorReturn(this, (MessageForm.__proto__ || Object.getPrototypeOf(MessageForm)).call(this));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.createThreadCallback = _this.createThreadCallback.bind(_this);
	    return _this;
	  }
	
	  _createClass(MessageForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        slot1Date: null,
	        slot2Date: null,
	        slot3Date: null,
	        content: null
	      };
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // Auto focus text editor when reply button is clicked
	      if (!prevProps.renderForm && this.props.renderForm) {
	        this.refs.quill.focus();
	      }
	    }
	  }, {
	    key: 'handleSlotChange',
	    value: function handleSlotChange(date, e, slot) {
	      this.setState(_defineProperty({}, slot, date));
	    }
	  }, {
	    key: 'handleContent',
	    value: function handleContent(content) {
	      this.setState({
	        content: content
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var _props$store = this.props.store,
	          MessageStore = _props$store.MessageStore,
	          SessionStore = _props$store.SessionStore;
	
	
	      var date1 = (0, _moment2.default)(this.state.slot1Date).format('YYYY-MM-DD Z');
	      var date2 = (0, _moment2.default)(this.state.slot2Date).format('YYYY-MM-DD Z');
	      var date3 = (0, _moment2.default)(this.state.slot3Date).format('YYYY-MM-DD Z');
	
	      var data = {
	        initiatingUserSid: SessionStore.userData.userSid,
	        courseSid: SessionStore.userData.courseSid,
	        sessionRequest: this.props.sessionRequest || false,
	        content: this.state.content
	      };
	
	      if (this.props.sessionRequest && date1 && date2 && date3) {
	        data.dateOption1 = (0, _moment2.default)(date1 + ' ' + this.slot1Time.value, 'YYYY-MM-DD Z HH:mm').toISOString();
	        data.dateOption2 = (0, _moment2.default)(date2 + ' ' + this.slot2Time.value, 'YYYY-MM-DD Z HH:mm').toISOString();
	        data.dateOption3 = (0, _moment2.default)(date3 + ' ' + this.slot3Time.value, 'YYYY-MM-DD Z HH:mm').toISOString();
	      }
	
	      if (this.props.examSid) {
	        data.examSid = this.props.examSid;
	      }
	
	      if (this.props.proctorApprovalSid) {
	        data.proctorApprovalSid = this.props.proctorApprovalSid;
	      }
	
	      if (this.props.examSessionEventReportSid) {
	        data.examSessionEventReportSid = this.props.examSessionEventReportSid;
	      }
	
	      if (this.props.proctorSid) {
	        data.toProctorAccountUserSid = this.props.proctorSid;
	      }
	
	      if (this.props.toUserSid && !this.props.proctorSid) {
	        data.toUserSid = this.props.toUserSid;
	      }
	
	      if (this.props.proctorLocationSid) {
	        data.locationSid = this.props.proctorLocationSid;
	      }
	
	      // Send the form data
	      if (data.content) {
	        if (this.props.mode === 'create') {
	          // Creating a new thread
	          MessageStore.createThread(data, this.createThreadCallback);
	        } else {
	          // Replying to an existing thread
	          data.source = 'messenger';
	          data.fromProctorAccountUserSid = SessionStore.userData.sid;
	
	          delete data.courseSid;
	          delete data.examSid;
	          delete data.examConfigurationSid;
	          delete data.examSessionEventReportSid;
	          delete data.initiatingUserSid;
	          delete data.proctorApprovalSid;
	          delete data.sessionRequest;
	          delete data.toProctorAccountUserSid;
	          delete data.toUserSid;
	          delete data.locationSid;
	
	          MessageStore.replyToThread(this.props.threadSid, data);
	        }
	
	        // Clear out the content
	        this.setState({
	          content: ''
	        });
	
	        this.props.parentThread.setState({
	          renderForm: false
	        });
	      } else {
	        var editor = document.querySelector('.quill');
	
	        if (editor) {
	          editor.className += ' error';
	        }
	      }
	    }
	  }, {
	    key: 'createThreadCallback',
	    value: function createThreadCallback() {
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	
	      SessionStore.showToaster(translation.message_sent, 'success');
	      (0, _helpers.closeDrawer)(null, this.props.parent);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	
	      // Quill text editor toolbar options
	
	      var modules = {
	        toolbar: [['bold', 'italic', 'underline'], [{ 'list': 'bullet' }, { 'list': 'ordered' }]]
	      };
	
	      if (this.props.renderForm) {
	        return _react2.default.createElement(
	          'form',
	          {
	            className: 'message-form ' + (SessionStore.backgroundLoading ? 'working' : ''),
	            onSubmit: function onSubmit(e) {
	              return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	            },
	            noValidate: true
	          },
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(_reactQuill2.default, {
	                modules: modules,
	                onChange: function onChange(e) {
	                  _this2.handleContent(e);
	                },
	                ref: 'quill'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'btn', type: 'submit' },
	            translation.send
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'inbox__init-reply' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn--link', onClick: this.props.showForm },
	            translation.reply
	          ),
	          ' ',
	          translation.to_message
	        );
	      }
	    }
	  }]);
	
	  return MessageForm;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('MessageForm')(MessageForm);

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactTextareaAutosize = __webpack_require__(98);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	var MessagesDetail = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(MessagesDetail, _React$Component);
	
	  function MessagesDetail() {
	    _classCallCheck(this, MessagesDetail);
	
	    return _possibleConstructorReturn(this, (MessagesDetail.__proto__ || Object.getPrototypeOf(MessagesDetail)).apply(this, arguments));
	  }
	
	  _createClass(MessagesDetail, [{
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              'Message subject goes here\u2026'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(
	            'ol',
	            { className: 'conversation' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'blockquote',
	                { className: 'conversation__message' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'conversation__body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'conversation__content' },
	                    'Maecenas faucibus mollis interdum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Nullam id dolor id nibh ultricies vehicula ut id elit.'
	                  ),
	                  _react2.default.createElement(
	                    'time',
	                    { className: 'conversation__timestamp' },
	                    '5/28/2017 10:00am'
	                  )
	                ),
	                _react2.default.createElement(
	                  'cite',
	                  { className: 'conversation__author' },
	                  _react2.default.createElement('img', { className: 'conversation__avatar avatar', src: 'https://fillmurray.com/200/200', alt: 'Chim Richalds\u2019s avatar' }),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Chim Richalds'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'blockquote',
	                { className: 'conversation__message' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'conversation__body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'conversation__content' },
	                    'Maecenas faucibus mollis interdum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Nullam id dolor id nibh ultricies vehicula ut id elit.'
	                  ),
	                  _react2.default.createElement(
	                    'time',
	                    { className: 'conversation__timestamp' },
	                    '5/28/2017 11:00am'
	                  )
	                ),
	                _react2.default.createElement(
	                  'cite',
	                  { className: 'conversation__author' },
	                  _react2.default.createElement('img', { className: 'conversation__avatar avatar', src: 'https://fillmurray.com/300/300', alt: 'Chim Richalds\u2019s avatar' }),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Mike Rithgen'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'blockquote',
	                { className: 'conversation__message' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'conversation__body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'conversation__content' },
	                    'Maecenas faucibus mollis interdum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Nullam id dolor id nibh ultricies vehicula ut id elit.'
	                  ),
	                  _react2.default.createElement(
	                    'time',
	                    { className: 'conversation__timestamp' },
	                    '5/28/2017 10:00am'
	                  )
	                ),
	                _react2.default.createElement(
	                  'cite',
	                  { className: 'conversation__author' },
	                  _react2.default.createElement('img', { className: 'conversation__avatar avatar', src: 'https://fillmurray.com/200/200', alt: 'Chim Richalds\u2019s avatar' }),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Chim Richalds'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'blockquote',
	                { className: 'conversation__message' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'conversation__body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'conversation__content' },
	                    'Maecenas faucibus mollis interdum. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Nullam id dolor id nibh ultricies vehicula ut id elit.'
	                  ),
	                  _react2.default.createElement(
	                    'time',
	                    { className: 'conversation__timestamp' },
	                    '5/28/2017 11:00am'
	                  )
	                ),
	                _react2.default.createElement(
	                  'cite',
	                  { className: 'conversation__author' },
	                  _react2.default.createElement('img', { className: 'conversation__avatar avatar', src: 'https://fillmurray.com/300/300', alt: 'Chim Richalds\u2019s avatar' }),
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Mike Rithgen'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            { className: 'reply__form', onSubmit: function onSubmit(e) {
	                return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	              }, noValidate: true },
	            _react2.default.createElement(
	              'div',
	              { className: 'panel--medium' },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'meta', htmlFor: 'ticket-comment' },
	                      'Reply'
	                    ),
	                    _react2.default.createElement(_reactTextareaAutosize2.default, {
	                      id: 'ticket-comment',
	                      className: 'textarea-grow',
	                      placeholder: 'Send your reply\u2026',
	                      required: true,
	                      'aria-required': 'true'
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn', type: 'submit' },
	                'Send Reply'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MessagesDetail;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('MessagesDetail')(MessagesDetail);

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	var RequestedDates = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(RequestedDates, _React$Component);
	
	  function RequestedDates() {
	    _classCallCheck(this, RequestedDates);
	
	    var _this2 = _possibleConstructorReturn(this, (RequestedDates.__proto__ || Object.getPrototypeOf(RequestedDates)).call(this));
	
	    _this2.confirmDate = _this2.confirmDate.bind(_this2);
	    _this2.updateExpiration = _this2.updateExpiration.bind(_this2);
	    _this2.rejectDates = _this2.rejectDates.bind(_this2);
	    _this2.cancelRequest = _this2.cancelRequest.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(RequestedDates, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        confirmationDate: null,
	        confirmedDateExpiration: 72
	      };
	    }
	  }, {
	    key: 'confirmDate',
	    value: function confirmDate(e, date) {
	      var prevSelected = document.querySelector('.thread__dates .selected--alt');
	
	      if (prevSelected) {
	        prevSelected.className = prevSelected.className.replace('selected--alt', '');
	      }
	
	      e.target.className += ' selected--alt';
	
	      this.setState({
	        confirmationDate: (0, _moment2.default)(date, 'YYYY-MM-DD HH:mm Z').toISOString()
	      });
	    }
	  }, {
	    key: 'updateExpiration',
	    value: function updateExpiration() {
	      this.setState({
	        confirmedDateExpiration: this.confirmedDateExpiration.value
	      });
	    }
	  }, {
	    key: 'handleDateConfirmation',
	    value: function handleDateConfirmation(e) {
	      var _this3 = this;
	
	      e.preventDefault();
	
	      var data = {
	        confirmationDate: this.state.confirmationDate,
	        confirmedDateExpiration: this.state.confirmedDateExpiration,
	        locationSid: this.props.locationSid
	      };
	
	      var callback = null;
	
	      if (this.props.pending) {
	        callback = function callback() {
	          _this3.props.store.ScheduleStore.getPendingSessions('request');
	        };
	      }
	
	      this.props.store.MessageStore.confirmDate(this.props.messageSid, data, callback);
	    }
	  }, {
	    key: 'rejectDates',
	    value: function rejectDates() {
	      var msg = this.props.translation.confirmReject;
	      (0, _helpers.confirm)(msg, this.cancelRequest);
	    }
	  }, {
	    key: 'cancelRequest',
	    value: function cancelRequest() {
	      var datesEl = document.querySelector('.thread__dates');
	      this.props.store.MessageStore.cancelRequest(this.props.messageSid, datesEl);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var threadObject = this.props.store.MessageStore.threadObject;
	
	      var _this = this;
	
	      var dates = [];
	
	      if (threadObject.dateOption1) {
	        dates.push(threadObject.dateOption1);
	      }
	      if (threadObject.dateOption2) {
	        dates.push(threadObject.dateOption2);
	      }
	      if (threadObject.dateOption3) {
	        dates.push(threadObject.dateOption3);
	      }
	
	      if (!threadObject.confirmedDate) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'thread__dates' },
	          _react2.default.createElement(
	            'strong',
	            null,
	            translation.requested_dates
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.requested_dates_helper.replace('%student%', this.props.studentName || translation.this_student)
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.requested_dates_note.replace('%student%', this.props.studentName || translation.this_student)
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'date-opts' },
	            dates.map(function (date, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn--outline',
	                    onClick: function onClick(e) {
	                      _this4.confirmDate(e, date);
	                    },
	                    type: 'button'
	                  },
	                  _moment2.default.utc(date).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	                )
	              );
	            }),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'btn--outline btn--negative',
	                  onClick: this.rejectDates,
	                  type: 'button'
	                },
	                translation.deny
	              )
	            )
	          ),
	          this.state.confirmationDate && _react2.default.createElement(
	            'form',
	            { className: 'thread__confirm form-inline', onSubmit: function onSubmit(e) {
	                _this4.handleDateConfirmation(e);
	              } },
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'date-expires', 'aria-describedby': 'expires-tooltip' },
	                translation.expires.label,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tooltip' },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'tooltip__label' },
	                    '(?)'
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { id: 'leadtime-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                    translation.expires.helper.replace('%expires%', this.state.confirmedDateExpiration)
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'label',
	                { className: 'select', htmlFor: 'date-expires' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    id: 'date-expires',
	                    ref: function ref(input) {
	                      _this4.confirmedDateExpiration = input;
	                    },
	                    defaultValue: this.state.confirmedDateExpiration,
	                    onChange: this.updateExpiration,
	                    required: true,
	                    'aria-required': 'true'
	                  },
	                  _react2.default.createElement(
	                    'option',
	                    { value: 12 },
	                    translation.expires.options.option12
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 24 },
	                    translation.expires.options.option24
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 48 },
	                    translation.expires.options.option48
	                  ),
	                  _react2.default.createElement(
	                    'option',
	                    { value: 72 },
	                    translation.expires.options.option72
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'btn', type: 'submit' },
	              translation.confirm_date
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'thread__dates note' },
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.confirmed_date,
	            _react2.default.createElement(
	              'strong',
	              null,
	              _moment2.default.utc(threadObject.confirmedDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            translation.confirmed_date_note.replace('%date%', _moment2.default.utc(threadObject.confirmedDateExpiration).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z'))
	          )
	        );
	      }
	    }
	  }]);
	
	  return RequestedDates;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('RequestedDates')(RequestedDates);

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var ExamAttachmentsList = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ExamAttachmentsList, _React$Component);
	
	  function ExamAttachmentsList() {
	    _classCallCheck(this, ExamAttachmentsList);
	
	    return _possibleConstructorReturn(this, (ExamAttachmentsList.__proto__ || Object.getPrototypeOf(ExamAttachmentsList)).apply(this, arguments));
	  }
	
	  _createClass(ExamAttachmentsList, [{
	    key: 'extension',
	    value: function extension(filename) {
	      var ext = null;
	
	      if (filename) {
	        ext = filename.substr(filename.lastIndexOf('.') + 1);
	      }
	
	      if (ext) {
	        switch (ext) {
	          case 'bmp':
	          case 'jpg':
	          case 'jpeg':
	          case 'png':
	          case 'gif':
	            return _react2.default.createElement(icons.icon_image, null);
	
	          case 'pdf':
	            return _react2.default.createElement(icons.icon_pdf, null);
	
	          case 'doc':
	          case 'docx':
	          case 'txt':
	          case 'rtf':
	            return _react2.default.createElement(icons.icon_text, null);
	
	          case 'xls':
	          case 'xlsx':
	          case 'csv':
	            return _react2.default.createElement(icons.icon_spreadsheet, null);
	
	          case 'wma':
	          case 'mpg':
	          case 'avi':
	          case 'flv':
	            return _react2.default.createElement(icons.icon_video, null);
	
	          case 'mp3':
	          case 'ogg':
	          case 'wav':
	          case 'midi':
	            return _react2.default.createElement(icons.icon_audio, null);
	
	          case 'zip':
	          case 'gz':
	          case 'iso':
	            return _react2.default.createElement(icons.icon_zip, null);
	
	          default:
	            return _react2.default.createElement(icons.icon_file, null);
	        }
	      }
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      var _props = this.props,
	          examConfiguration = _props.examConfiguration,
	          translation = _props.translation;
	
	
	      if (typeof examConfiguration.attachments !== 'undefined' && examConfiguration.attachments.length > 0) {
	        return _react2.default.createElement(
	          'ul',
	          { className: 'files panel__files' },
	          examConfiguration.attachments.map(function (key, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'a',
	                { className: 'files__title', href: key.attachmentUrl, target: '_blank' },
	                _this2.extension(key.attachmentAwsTitle),
	                key.attachmentAwsTitle
	              )
	            );
	          })
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'section',
	        { className: 'panel__section' },
	        !this.props.sessionManager && _react2.default.createElement(
	          'h2',
	          { className: 'panel__heading' },
	          translation.heading
	        ),
	        this.props.sessionManager && _react2.default.createElement(
	          'h4',
	          { className: 'data-heading' },
	          translation.heading
	        ),
	        this.renderResults()
	      );
	    }
	  }]);
	
	  return ExamAttachmentsList;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ExamAttachmentsList')(ExamAttachmentsList);

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDropzone = __webpack_require__(492);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var FileUpload = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(FileUpload, _React$Component);
	
	  function FileUpload() {
	    _classCallCheck(this, FileUpload);
	
	    var _this = _possibleConstructorReturn(this, (FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).call(this));
	
	    _this.handleDrop = _this.handleDrop.bind(_this);
	    _this.handleDragEnter = _this.handleDragEnter.bind(_this);
	    _this.handleDragLeave = _this.handleDragLeave.bind(_this);
	    _this.removeFile = _this.removeFile.bind(_this);
	    return _this;
	  }
	
	  _createClass(FileUpload, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        attachment: [],
	        dropClass: ''
	      };
	    }
	  }, {
	    key: 'handleDrop',
	    value: function handleDrop(file, rejected) {
	      var SessionStore = this.props.store.SessionStore;
	      var onDrop = this.props.onDrop;
	
	      var size = 0;
	      var maxFileSize = 4194304;
	
	      if (this.props.maxSize) {
	        maxFileSize = this.props.maxSize;
	      }
	
	      if (file.length === 0) {
	        var dialogContent = this.props.translation.invalid;
	        SessionStore.showDialog(dialogContent);
	
	        this.setState({
	          dropClass: ''
	        });
	      } else {
	        file.forEach(function (file) {
	          if (file.size) {
	            size += file.size;
	          }
	        });
	      }
	
	      if (this.state.attachment.length + file.length <= 5 && size <= maxFileSize) {
	        var attachment = [].concat(_toConsumableArray(this.state.attachment.concat(file)));
	
	        this.setState({
	          attachment: attachment,
	          dropClass: ''
	        });
	
	        if (onDrop) {
	          onDrop(attachment);
	        }
	      } else {
	        var _dialogContent = this.props.translation.limit;
	
	        if (size > maxFileSize) {
	          _dialogContent = this.props.translation.too_large;
	        }
	
	        SessionStore.showDialog(_dialogContent);
	
	        this.setState({
	          dropClass: ''
	        });
	      }
	    }
	  }, {
	    key: 'handleDragEnter',
	    value: function handleDragEnter() {
	      this.setState({
	        dropClass: 'file-drop--drag-enter'
	      });
	    }
	  }, {
	    key: 'handleDragLeave',
	    value: function handleDragLeave() {
	      this.setState({
	        dropClass: ''
	      });
	    }
	  }, {
	    key: 'removeFile',
	    value: function removeFile(i) {
	      var attachment = [].concat(_toConsumableArray(this.state.attachment));
	      attachment.splice(i, 1);
	
	      this.setState({
	        attachment: attachment
	      });
	    }
	  }, {
	    key: 'deleteFile',
	    value: function deleteFile(file, index) {
	      var ExamStore = this.props.store.ExamStore;
	
	
	      if (this.props.exception && this.props.customConfiguration.sid || !this.props.exception) {
	        ExamStore.deleteAttachments.push(file);
	      }
	
	      this.removeUploadedFile(index);
	    }
	  }, {
	    key: 'removeUploadedFile',
	    value: function removeUploadedFile(index) {
	      if (!this.props.exception) {
	        this.props.exam.configuration.attachments.splice(index, 1);
	      } else {
	        this.props.customConfiguration.attachments.splice(index, 1);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var SessionStore = this.props.store.SessionStore;
	      var _props = this.props,
	          files = _props.files,
	          fileType = _props.fileType,
	          maxSize = _props.maxSize,
	          single = _props.single;
	
	
	      var maxFileSize = 30000000; // set to 30MB to match the API.
	
	      if (maxSize) {
	        maxFileSize = maxSize;
	      }
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          !this.props.readonly && (this.props.single && this.state.attachment.length === 0 && (!files || files.length === 0) || !this.props.single) && _react2.default.createElement(
	            _reactDropzone2.default,
	            {
	              className: 'file-drop ' + this.state.dropClass,
	              onDrop: this.handleDrop,
	              onDragEnter: this.handleDragEnter,
	              onDragLeave: this.handleDragLeave,
	              multiple: single ? false : true,
	              accept: fileType ? fileType : 'audio/*, image/*, text/*, video/*, application/*, application/octet-stream',
	              maxSize: maxFileSize
	            },
	            _react2.default.createElement(
	              'label',
	              { className: 'file-drop__label' },
	              this.props.label ? this.props.label : translation.label
	            ),
	            this.props.helper && _react2.default.createElement(
	              'span',
	              { className: 'file-drop__helper' },
	              this.props.helper
	            )
	          ),
	          (this.state.attachment.length > 0 || files && files.length > 0) && _react2.default.createElement(
	            'ul',
	            { className: 'file-drop__files' },
	            files && files.length > 0 && files.map(function (file, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  file.attachmentAwsTitle
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn--remove',
	                    type: 'button',
	                    onClick: function onClick() {
	                      return _this2.deleteFile(file.attachmentAwsTitle, i);
	                    },
	                    disabled: _this2.props.readonly ? true : false
	                  },
	                  _react2.default.createElement(icons.iconMinus, null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.remove,
	                    ' ',
	                    file.name
	                  )
	                )
	              );
	            }),
	            this.state.attachment.map(function (file, i) {
	              return _react2.default.createElement(
	                'li',
	                { key: i },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  file.name
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn--remove',
	                    type: 'button',
	                    onClick: function onClick() {
	                      return _this2.removeFile(i);
	                    },
	                    disabled: _this2.props.readonly ? true : false
	                  },
	                  _react2.default.createElement(icons.iconMinus, null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.remove,
	                    ' ',
	                    file.name
	                  )
	                )
	              );
	            })
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return FileUpload;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('FileUpload')(FileUpload);

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeSelect2 = function (_React$Component) {
	  _inherits(TimeSelect2, _React$Component);
	
	  function TimeSelect2() {
	    _classCallCheck(this, TimeSelect2);
	
	    return _possibleConstructorReturn(this, (TimeSelect2.__proto__ || Object.getPrototypeOf(TimeSelect2)).apply(this, arguments));
	  }
	
	  _createClass(TimeSelect2, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "optgroup",
	        null,
	        _react2.default.createElement(
	          "option",
	          { value: "00:00" },
	          "12:00am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "00:30" },
	          "12:30am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "01:00" },
	          "1:00am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "01:30" },
	          "1:30am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "02:00" },
	          "2:00am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "02:30" },
	          "2:30am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "03:00" },
	          "3:00am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "03:30" },
	          "3:30am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "04:00" },
	          "4:00am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "04:30" },
	          "4:30am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "05:00" },
	          "5:00am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "05:30" },
	          "5:30am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "06:00" },
	          "6:00am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "06:30" },
	          "6:30am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "07:00" },
	          "7:00am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "07:30" },
	          "7:30am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "08:00" },
	          "8:00am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "08:30" },
	          "8:30am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "09:00" },
	          "9:00am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "09:30" },
	          "9:30am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "10:00" },
	          "10:00am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "10:30" },
	          "10:30am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "11:00" },
	          "11:00am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "11:30" },
	          "11:30am"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "12:00" },
	          "12:00pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "12:30" },
	          "12:30pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "13:00" },
	          "1:00pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "13:30" },
	          "1:30pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "14:00" },
	          "2:00pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "14:30" },
	          "2:30pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "15:00" },
	          "3:00pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "15:30" },
	          "3:30pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "16:00" },
	          "4:00pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "16:30" },
	          "4:30pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "17:00" },
	          "5:00pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "17:30" },
	          "5:30pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "18:00" },
	          "6:00pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "18:30" },
	          "6:30pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "19:00" },
	          "7:00pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "19:30" },
	          "7:30pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "20:00" },
	          "8:00pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "20:30" },
	          "8:30pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "21:00" },
	          "9:00pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "21:30" },
	          "9:30pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "22:00" },
	          "10:00pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "22:30" },
	          "10:30pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "23:00" },
	          "11:00pm"
	        ),
	        _react2.default.createElement(
	          "option",
	          { value: "23:30" },
	          "11:30pm"
	        )
	      );
	    }
	  }]);
	
	  return TimeSelect2;
	}(_react2.default.Component);
	
	exports.default = TimeSelect2;

/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	
	
	var NotFound = function (_React$Component) {
	  _inherits(NotFound, _React$Component);
	
	  function NotFound() {
	    _classCallCheck(this, NotFound);
	
	    return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
	  }
	
	  _createClass(NotFound, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'main',
	        { className: 'page page--error wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'i',
	            { className: 'page--error__icon' },
	            _react2.default.createElement(icons.iconChainBroken, null)
	          ),
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            'Page not found'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Sorry, the page you\u2019re trying to reach does not exist. You may have mistyped the URL, or the page may have been removed.'
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { className: 'btn--outline', to: '/' },
	            'Return to Dashboard'
	          )
	        )
	      );
	    }
	  }]);
	
	  return NotFound;
	}(_react2.default.Component);
	
	exports.default = NotFound;

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDatepicker = __webpack_require__(68);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _currencyFormatter = __webpack_require__(87);
	
	var _currencyFormatter2 = _interopRequireDefault(_currencyFormatter);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var PaymentCollect = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(PaymentCollect, _React$Component);
	
	  function PaymentCollect() {
	    _classCallCheck(this, PaymentCollect);
	
	    var _this = _possibleConstructorReturn(this, (PaymentCollect.__proto__ || Object.getPrototypeOf(PaymentCollect)).call(this));
	
	    _this.handleDateChange = _this.handleDateChange.bind(_this);
	    _this.handleLocationChange = _this.handleLocationChange.bind(_this);
	    _this.initPayment = _this.initPayment.bind(_this);
	    _this.collectAddress = _this.collectAddress.bind(_this);
	    return _this;
	  }
	
	  _createClass(PaymentCollect, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        startDate: null,
	        endDate: null
	      };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.paymentType === 'full') {
	        this.setState({
	          startDate: null,
	          startDateTime: '2000-01-01T00:00:00.000Z',
	          endDate: null,
	          endDateTime: '2070-01-01T00:00:00.000Z'
	        });
	      }
	    }
	  }, {
	    key: 'handleDateChange',
	    value: function handleDateChange(date, name) {
	      this.setState(_defineProperty({}, name, date), function () {
	        if (this.state.startDate && this.state.endDate) {
	          console.log((0, _moment2.default)(this.state.startDate).local().format('YYYY-MM-DD Z'));
	
	          // Convert the time of the date to 12:00am for start and  11:59pm for end
	          var startDate = (0, _moment2.default)(this.state.startDate).local().format('YYYY-MM-DD Z');
	          var startDateTime = (0, _moment2.default)(startDate + ' 00:00', 'YYYY-MM-DD Z HH:mm').toISOString();
	          var endDate = (0, _moment2.default)(this.state.endDate).local().format('YYYY-MM-DD Z');
	          var endDateTime = (0, _moment2.default)(endDate + ' 23:59', 'YYYY-MM-DD Z HH:mm').toISOString();
	
	          // Store the converted date
	          this.props.store.PaymentStore.paymentData.startDate = startDateTime;
	          this.props.store.PaymentStore.paymentData.endDate = endDateTime;
	
	          // Get the balance for the selected date range
	          this.props.store.PaymentStore.getBalance(false, true);
	        }
	      });
	    }
	  }, {
	    key: 'handleLocationChange',
	    value: function handleLocationChange() {
	      // Store the location
	      this.props.store.PaymentStore.paymentData.locationSid = this.location.value;
	
	      // Get the balance for the selected location
	      this.props.store.PaymentStore.getBalance(false, true);
	    }
	  }, {
	    key: 'initPayment',
	    value: function initPayment(type) {
	      this.props.store.PaymentStore.paymentData.type = type;
	
	      this.collectAddress();
	    }
	  }, {
	    key: 'collectAddress',
	    value: function collectAddress() {
	      (0, _helpers.toggleDrawer)(null, this.props.parent, 'PaymentForm');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          LocationStore = _props$store.LocationStore,
	          PaymentStore = _props$store.PaymentStore,
	          SessionStore = _props$store.SessionStore;
	      var balance = PaymentStore.balance;
	
	      var currency = SessionStore.defaultCurrency || 'USD';
	
	      return _react2.default.createElement(
	        'form',
	        { className: 'slideout ' + (this.props.open ? 'open' : '') },
	        this.props.paymentType === 'partial' && _react2.default.createElement(
	          'fieldset',
	          { className: 'form-inline--alt' },
	          _react2.default.createElement(
	            'h5',
	            null,
	            translation.collect_payment
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields payment-fields' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-inline preposition', htmlFor: 'payment-start' },
	                translation.from
	              ),
	              _react2.default.createElement(_reactDatepicker2.default, {
	                className: 'react-datepicker',
	                id: 'payment-start',
	                selected: this.state.startDate,
	                onChange: function onChange(date) {
	                  _this2.handleDateChange(date, 'startDate');
	                },
	                maxDate: (0, _moment2.default)(),
	                placeholderText: translation.date_helper,
	                required: true,
	                'aria-required': 'true',
	                ref: function ref(input) {
	                  _this2.startDate = input;
	                }
	              }),
	              _react2.default.createElement(
	                'label',
	                { className: 'lbl-inline preposition', htmlFor: 'payment-end' },
	                translation.to
	              ),
	              _react2.default.createElement(_reactDatepicker2.default, {
	                className: 'react-datepicker',
	
	                id: 'payment-end',
	                selected: this.state.endDate,
	                onChange: function onChange(date) {
	                  _this2.handleDateChange(date, 'endDate');
	                },
	                maxDate: (0, _moment2.default)(),
	                placeholderText: translation.date_helper,
	                required: true,
	                'aria-required': 'true',
	                ref: function ref(input) {
	                  _this2.endDate = input;
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'h5',
	            null,
	            translation.location
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { className: 'select', htmlFor: 'payment-location' },
	                _react2.default.createElement(
	                  'select',
	                  {
	                    id: 'payment-location',
	                    onChange: this.handleLocationChange,
	                    ref: function ref(input) {
	                      _this2.location = input;
	                    }
	                  },
	                  _react2.default.createElement(
	                    'option',
	                    { value: '' },
	                    translation.all_locations
	                  ),
	                  LocationStore.locations.map(function (location) {
	                    return _react2.default.createElement(
	                      'option',
	                      { key: location.sid, value: location.sid },
	                      location.name
	                    );
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'button-group button-group--alt' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'slideout__heading' },
	            translation.collect.replace('%total%', _currencyFormatter2.default.format(balance, { code: currency }))
	          ),
	          balance !== 0 && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn--success',
	              type: 'button',
	              onClick: function onClick() {
	                return _this2.initPayment('online-check');
	              }
	            },
	            _react2.default.createElement(icons.iconPrint, null),
	            translation.print_button
	          ),
	          balance !== 0 && _react2.default.createElement(
	            'button',
	            {
	              className: 'btn btn--success',
	              onClick: function onClick() {
	                return _this2.initPayment('physical-check');
	              },
	              type: 'button'
	            },
	            _react2.default.createElement(icons.iconEnvelope, null),
	            translation.mail_button
	          )
	        )
	      );
	    }
	  }]);
	
	  return PaymentCollect;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('PaymentCollect')(PaymentCollect);

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Address = __webpack_require__(877);
	
	var _Address2 = _interopRequireDefault(_Address);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var PaymentForm = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(PaymentForm, _React$Component);
	
	  function PaymentForm() {
	    _classCallCheck(this, PaymentForm);
	
	    var _this = _possibleConstructorReturn(this, (PaymentForm.__proto__ || Object.getPrototypeOf(PaymentForm)).call(this));
	
	    _this.handleInput = _this.handleInput.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    return _this;
	  }
	
	  _createClass(PaymentForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.store.PaymentStore.location = {};
	
	      this.state = {
	        password: null,
	        complete: false
	      };
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.store.PaymentStore.resetPaymentData();
	      this.props.store.PaymentStore.getBalance(true);
	      this.props.parent.setState({
	        collect: false,
	        paymentType: null
	      });
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      var location = {
	        address1: this.address1.value,
	        address2: this.address2.value,
	        place: this.place.value,
	        region: this.region.value,
	        country: this.country.value,
	        postalCode: this.postalCode.value
	      };
	
	      this.props.store.PaymentStore.location = location;
	
	      if (this.password) {
	        this.setState({
	          password: this.password.value
	        });
	      }
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      // const { errorMsg } = this.props.translation;
	
	      this.props.store.PaymentStore.createPayment(this.complete);
	
	      // this.props.store.PaymentStore.validatePayment(this.state.password, errorMsg, this.complete);
	    }
	  }, {
	    key: 'complete',
	    value: function complete() {
	      this.setState({
	        complete: true
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var PaymentStore = this.props.store.PaymentStore;
	      var checkUrl = PaymentStore.checkUrl,
	          location = PaymentStore.location,
	          paymentData = PaymentStore.paymentData;
	
	      var paymentType = PaymentStore.paymentData.type;
	
	      if (!this.state.complete) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content wrap' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            { className: 'panel--medium', onSubmit: function onSubmit(e) {
	                return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	              }, noValidate: true },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__subhdg' },
	              paymentType === 'physical-check' && translation.sub_heading,
	              paymentType === 'online-check' && translation.sub_heading_print
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields fields--alt' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'lbl-required', htmlFor: 'payto' },
	                    translation.pay_to
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'payto',
	                    defaultValue: paymentData.payTo || '',
	                    placeholder: translation.pay_to,
	                    onChange: function onChange() {
	                      return paymentData.payTo = _this2.payTo.value;
	                    },
	                    ref: function ref(input) {
	                      _this2.payTo = input;
	                    },
	                    required: true,
	                    'aria-required': 'true'
	                  })
	                )
	              )
	            ),
	            !location.address1 && _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(_Address2.default, Object.assign({
	                    locationParent: this.props.store.PaymentStore,
	                    mailing: true
	                  }, this.props))
	                )
	              )
	            ),
	            location.address1 && _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'lbl-required', htmlFor: 'map-addr1' },
	                    translation.address1
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'map-addr1',
	                    defaultValue: location.address1 || '',
	                    placeholder: translation.address1,
	                    onChange: this.handleInput,
	                    ref: function ref(input) {
	                      _this2.address1 = input;
	                    },
	                    required: true,
	                    'aria-required': 'true'
	                  }),
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'meta', htmlFor: 'map-addr2' },
	                    translation.address2
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'map-addr2',
	                    defaultValue: location.address2 || '',
	                    placeholder: translation.address2,
	                    onChange: this.handleInput,
	                    ref: function ref(input) {
	                      _this2.address2 = input;
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'lbl-required', htmlFor: 'map-city' },
	                    translation.city
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'map-city',
	                    defaultValue: location.place || '',
	                    placeholder: translation.place,
	                    onChange: this.handleInput,
	                    ref: function ref(input) {
	                      _this2.place = input;
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'field--third' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'lbl-required', htmlFor: 'map-region' },
	                    translation.region
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'map-region',
	                    defaultValue: location.region || '',
	                    placeholder: translation.region,
	                    onChange: this.handleInput,
	                    ref: function ref(input) {
	                      _this2.region = input;
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'field--third' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'lbl-required', htmlFor: 'map-postal' },
	                    translation.zip
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'map-postal',
	                    defaultValue: location.postalCode || '',
	                    placeholder: translation.zip,
	                    onChange: this.handleInput,
	                    ref: function ref(input) {
	                      _this2.postalCode = input;
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'field--third' },
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'lbl-required', htmlFor: 'map-country' },
	                    translation.country
	                  ),
	                  _react2.default.createElement('input', {
	                    type: 'text',
	                    id: 'map-country',
	                    defaultValue: location.country || '',
	                    placeholder: translation.country,
	                    onChange: this.handleInput,
	                    ref: function ref(input) {
	                      _this2.country = input;
	                    }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'panel__actions actions' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'actions__btn actions__btn--primary'
	                  // disabled={!location.address1 || !this.state.password}
	                  , disabled: !location.address1
	                },
	                translation.button
	              )
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading
	              )
	            )
	          ),
	          paymentType === 'physical-check' && _react2.default.createElement(
	            'div',
	            { className: 'panel--brief' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.success.physical.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.success.physical.body
	            )
	          ),
	          paymentType === 'online-check' && _react2.default.createElement(
	            'div',
	            { className: 'panel--brief' },
	            _react2.default.createElement(
	              'h2',
	              { className: 'panel__title' },
	              translation.success.online.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.success.online.body
	            ),
	            _react2.default.createElement(
	              'a',
	              { className: 'btn', href: checkUrl, target: '_blank' },
	              translation.success.online.button
	            )
	          )
	        );
	      }
	    }
	  }]);
	
	  return PaymentForm;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('PaymentForm')(PaymentForm);

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _currencyFormatter = __webpack_require__(87);
	
	var _currencyFormatter2 = _interopRequireDefault(_currencyFormatter);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var PaymentHistory = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(PaymentHistory, _React$Component);
	
	  function PaymentHistory() {
	    _classCallCheck(this, PaymentHistory);
	
	    return _possibleConstructorReturn(this, (PaymentHistory.__proto__ || Object.getPrototypeOf(PaymentHistory)).apply(this, arguments));
	  }
	
	  _createClass(PaymentHistory, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.store.PaymentStore.getPaymentHistory();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var paymentHistory = this.props.store.PaymentStore.paymentHistory;
	
	
	      if (paymentHistory.length > 0) {
	        return _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-date', className: 'subtitle', scope: 'col' },
	                translation.date
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-type', className: 'subtitle', scope: 'col' },
	                translation.type
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-check', className: 'subtitle', scope: 'col' },
	                translation.check
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-status', className: 'subtitle', scope: 'col' },
	                translation.status
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-amount', className: 'subtitle', scope: 'col' },
	                translation.amount
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            paymentHistory.map(function (payment, i) {
	              return _react2.default.createElement(
	                'tr',
	                { key: i },
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-date' },
	                  (0, _moment2.default)(payment.dateInitiated || payment.createdDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY')
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-date' },
	                  payment.paymentType === 'online-check' && translation.online_check,
	                  payment.paymentType === 'physical-check' && translation.physical_check,
	                  payment.paymentType === 'ach' && translation.ach
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-check' },
	                  payment.paymentType !== 'ach' && '#' + payment.paymentNumber + ' ',
	                  payment.paymentType === 'online-check' && !payment.clearedBank && _react2.default.createElement(
	                    'a',
	                    {
	                      href: payment.pdfUrl,
	                      target: '_blank'
	                    },
	                    translation.view_check
	                  )
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-status' },
	                  payment.clearedBank && payment.paymentType !== 'ach' && translation.cashed + ' on ' + (0, _moment2.default)(payment.clearedBank).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY'),
	                  payment.clearedBank && payment.paymentType === 'ach' && translation.transfered + ' on ' + (0, _moment2.default)(payment.clearedBank).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY'),
	                  !payment.clearedBank && translation.uncashed
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-amount', className: 'number' },
	                  _currencyFormatter2.default.format(payment.amount, { code: payment.currencyCode })
	                )
	              );
	            })
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_history
	        );
	      }
	    }
	  }]);
	
	  return PaymentHistory;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('PaymentHistory')(PaymentHistory);

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _currencyFormatter = __webpack_require__(87);
	
	var _currencyFormatter2 = _interopRequireDefault(_currencyFormatter);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var PaymentSessions = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(PaymentSessions, _React$Component);
	
	  function PaymentSessions() {
	    _classCallCheck(this, PaymentSessions);
	
	    return _possibleConstructorReturn(this, (PaymentSessions.__proto__ || Object.getPrototypeOf(PaymentSessions)).apply(this, arguments));
	  }
	
	  _createClass(PaymentSessions, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // Get initial balance
	      this.props.store.PaymentStore.getBalance(true);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var paymentSessions = this.props.store.PaymentStore.paymentSessions;
	
	
	      if (paymentSessions.length > 0) {
	        return _react2.default.createElement(
	          'table',
	          null,
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-date', className: 'subtitle', scope: 'col' },
	                translation.date
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-session', className: 'subtitle', scope: 'col' },
	                translation.session
	              ),
	              _react2.default.createElement(
	                'th',
	                { id: 'heading-amount', className: 'subtitle', scope: 'col' },
	                translation.amount
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'tbody',
	            null,
	            paymentSessions.map(function (session, i) {
	              return _react2.default.createElement(
	                'tr',
	                { key: i },
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-date' },
	                  (0, _moment2.default)(session.appointmentDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-session' },
	                  session.lastName,
	                  ', ',
	                  session.firstName
	                ),
	                _react2.default.createElement(
	                  'td',
	                  { 'aria-labelledby': 'heading-amount', className: 'number' },
	                  _currencyFormatter2.default.format(session.netAmount, { code: _this2.props.currency })
	                )
	              );
	            })
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      }
	    }
	  }]);
	
	  return PaymentSessions;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('PaymentSessions')(PaymentSessions);

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactTabs = __webpack_require__(79);
	
	var _currencyFormatter = __webpack_require__(87);
	
	var _currencyFormatter2 = _interopRequireDefault(_currencyFormatter);
	
	var _iamReactClient = __webpack_require__(58);
	
	var _PaymentSessions = __webpack_require__(891);
	
	var _PaymentSessions2 = _interopRequireDefault(_PaymentSessions);
	
	var _PaymentHistory = __webpack_require__(890);
	
	var _PaymentHistory2 = _interopRequireDefault(_PaymentHistory);
	
	var _PaymentCollect = __webpack_require__(888);
	
	var _PaymentCollect2 = _interopRequireDefault(_PaymentCollect);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Payments = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Payments, _React$Component);
	
	  function Payments() {
	    _classCallCheck(this, Payments);
	
	    var _this2 = _possibleConstructorReturn(this, (Payments.__proto__ || Object.getPrototypeOf(Payments)).call(this));
	
	    _this2.handleTabs = _this2.handleTabs.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Payments, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        activeTab: 1,
	        collect: false,
	        paymentType: null,
	        drawerContent: null,
	        drawerOpen: false
	
	        // Get locations to populate partial payment dropdown
	      };this.props.store.LocationStore.getLocations();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var proctorAccountSid = this.props.store.SessionStore.userData.proctorAccountSid;
	
	      var iam = sessionStorage.getItem('iam');
	
	      if (!(0, _iamReactClient.isAuthorized)('sp:DescribeBalance', 'ssrn:ss:sp::' + proctorAccountSid + ':balance', iam)) {
	        this.props.routing.history.push('/unauthorized');
	      }
	    }
	  }, {
	    key: 'handleTabs',
	    value: function handleTabs(index) {
	      this.setState({
	        activeTab: index + 1
	      });
	    }
	  }, {
	    key: 'collectPayment',
	    value: function collectPayment(e, paymentType) {
	      var PaymentStore = this.props.store.PaymentStore;
	
	      var typeDelay = null;
	
	      // If we’re collecting the entire payment, make sure there are no dates or locations applied
	      if (paymentType === 'full') {
	        PaymentStore.balance = PaymentStore.totalBalance;
	        PaymentStore.resetPaymentData();
	      }
	
	      // Open the slideout
	      if (!this.state.collect || this.state.paymentType !== paymentType) {
	        // Cancel any slide delay timeouts
	        clearTimeout(typeDelay);
	
	        // Remove the selected class from any previously-selected buttons
	        var prevSelected = document.querySelector('.select-payment.selected');
	
	        if (prevSelected) {
	          prevSelected.className = prevSelected.className.replace('selected', '');
	        }
	
	        // Then add the selected class to this button and set state
	        e.target.className += ' selected';
	
	        this.setState({
	          collect: true,
	          paymentType: paymentType
	        });
	      } else {
	        e.target.className = e.target.className.replace('selected', '');
	
	        this.setState({
	          collect: false
	        });
	
	        // Wait to change the payment type until the panel has finished sliding
	        var _this = this;
	
	        typeDelay = setTimeout(function () {
	          _this.setState({
	            paymentType: null
	          });
	        }, 250);
	      }
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          PaymentStore = _props$store.PaymentStore,
	          SessionStore = _props$store.SessionStore;
	      var totalBalance = PaymentStore.totalBalance;
	
	      var currency = SessionStore.defaultCurrency || 'USD';
	
	      if (!SessionStore.loading || PaymentStore.totalBalance !== null) {
	        // Don’t use the default tab styles
	        _reactTabs.Tabs.setUseDefaultStyles(false);
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap wrap--medium' },
	            _react2.default.createElement(
	              'article',
	              { className: 'panel panel--medium' },
	              _react2.default.createElement(
	                'span',
	                { className: 'panel__subhdg' },
	                translation.owe
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'text-code' },
	                _currencyFormatter2.default.format(totalBalance, { code: currency })
	              ),
	              totalBalance !== 0 && _react2.default.createElement(
	                'p',
	                null,
	                translation.payment_options
	              ),
	              totalBalance !== 0 && _react2.default.createElement(
	                'div',
	                { className: 'button-group' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn--outline btn--inline select-payment',
	                    onClick: function onClick(e) {
	                      return _this3.collectPayment(e, 'partial');
	                    }
	                  },
	                  translation.collect_part
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn btn--outline btn--inline select-payment',
	                    onClick: function onClick(e) {
	                      return _this3.collectPayment(e, 'full');
	                    }
	                  },
	                  translation.collect_all
	                )
	              )
	            ),
	            _react2.default.createElement(_PaymentCollect2.default, Object.assign({
	              paymentType: this.state.paymentType,
	              open: this.state.collect,
	              parent: this
	            }, this.props))
	          ),
	          _react2.default.createElement(
	            _reactTabs.Tabs,
	            {
	              onSelect: this.handleTabs
	            },
	            _react2.default.createElement(
	              _reactTabs.TabList,
	              null,
	              _react2.default.createElement(
	                _reactTabs.Tab,
	                null,
	                translation.sessions
	              ),
	              _react2.default.createElement(
	                _reactTabs.Tab,
	                null,
	                translation.history
	              )
	            ),
	            _react2.default.createElement(
	              _reactTabs.TabPanel,
	              null,
	              _react2.default.createElement(_PaymentSessions2.default, Object.assign({ currency: currency }, this.props))
	            ),
	            _react2.default.createElement(
	              _reactTabs.TabPanel,
	              null,
	              _react2.default.createElement(_PaymentHistory2.default, this.props)
	            )
	          )
	        );
	      }
	
	      return '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(
	            'header',
	            { className: 'page__header' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            )
	          ),
	          this.renderResults()
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this
	        }, this.props))
	      );
	    }
	  }]);
	
	  return Payments;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Payments')(Payments);

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _PolicyEdit = __webpack_require__(894);
	
	var _PolicyEdit2 = _interopRequireDefault(_PolicyEdit);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var Policies = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Policies, _React$Component);
	
	  function Policies() {
	    _classCallCheck(this, Policies);
	
	    return _possibleConstructorReturn(this, (Policies.__proto__ || Object.getPrototypeOf(Policies)).apply(this, arguments));
	  }
	
	  _createClass(Policies, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var PolicyStore = this.props.store.PolicyStore;
	
	
	      this.state = {
	        drawerContent: null,
	        drawerOpen: false
	
	        // Get existing cancellation policies
	      };PolicyStore.getCancellationPolicies();
	
	      // PolicyStore.initCancellationPolicy();
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          PolicyStore = _props$store.PolicyStore,
	          SessionStore = _props$store.SessionStore;
	
	
	      if (!SessionStore.loading && PolicyStore.cancellationPolicies.length === 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'cta' },
	          _react2.default.createElement(
	            'strong',
	            { className: 'cta__copy' },
	            translation.cta.heading
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'cta__btn btn--icn-right',
	              onClick: PolicyStore.initCancellationPolicy
	            },
	            translation.cta.button,
	            _react2.default.createElement(icons.iconCircleRight, { className: 'icon' })
	          )
	        );
	      } else if (PolicyStore.cancellationPolicies.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'wrap wrap--brief' },
	          PolicyStore.cancellationPolicies.map(function (policy) {
	            return _react2.default.createElement(_PolicyEdit2.default, Object.assign({
	              key: policy.sid,
	              policy: policy.versions[0],
	              policySid: policy.sid
	            }, _this2.props));
	          }),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'block-list__add btn--icn-right',
	              onClick: PolicyStore.initCancellationPolicy
	            },
	            translation.cta.button,
	            _react2.default.createElement(icons.iconPlus, { className: 'icon' })
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(
	            'header',
	            { className: 'page__header' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            )
	          ),
	          this.renderResults()
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this
	        }, this.props))
	      );
	    }
	  }]);
	
	  return Policies;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Policies')(Policies);

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDatepicker = __webpack_require__(68);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _reactTextareaAutosize = __webpack_require__(98);
	
	var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var PolicyEdit = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(PolicyEdit, _React$Component);
	
	  function PolicyEdit() {
	    _classCallCheck(this, PolicyEdit);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (PolicyEdit.__proto__ || Object.getPrototypeOf(PolicyEdit)).call(this));
	
	    _this2.toggleDateRange = _this2.toggleDateRange.bind(_this2);
	    _this2.handleInput = _this2.handleInput.bind(_this2);
	    _this2.handleDate = _this2.handleDate.bind(_this2);
	    _this2.handleRule = _this2.handleRule.bind(_this2);
	    _this2.addRule = _this2.addRule.bind(_this2);
	    _this2.handleSubmit = _this2.handleSubmit.bind(_this2);
	    _this2.handleDelete = _this2.handleDelete.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(PolicyEdit, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var policy = this.props.policy;
	
	
	      this.state = {
	        dateRange: false,
	        originalPolicy: Object.assign({}, policy)
	      };
	
	      if (policy.effectiveDate !== '2000-01-01T05:00:00.000Z' || policy.expirationDate !== '2070-01-01T05:00:00.000Z') {
	        this.setState({
	          dateRange: true
	        });
	      }
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      var policy = this.props.policy;
	
	
	      policy.title = this.title.value;
	      policy.notes = this.notes.value;
	    }
	  }, {
	    key: 'handleDate',
	    value: function handleDate(date, name) {
	      var policy = this.props.policy;
	
	
	      policy[name] = (0, _moment2.default)(date).toISOString();
	    }
	  }, {
	    key: 'togglePolicy',
	    value: function togglePolicy(e) {
	      var _this = this;
	      var policy = this.props.policy;
	      var originalPolicy = this.state.originalPolicy;
	
	
	      if (e.target.checked) {
	        policy.status = 'enabled';
	      } else {
	        policy.status = 'disabled';
	      }
	
	      // If this is a pre-existing policy, save it
	      originalPolicy.status = policy.status;
	
	      this.setState({
	        originalPolicy: originalPolicy
	      }, function () {
	        if (policy.rules[0].sid) {
	          this.handleSubmit(null, this.state.originalPolicy);
	        }
	      });
	    }
	  }, {
	    key: 'toggleDateRange',
	    value: function toggleDateRange() {
	      var policy = this.props.policy;
	
	      var _this = this;
	
	      this.setState({
	        dateRange: !this.state.dateRange
	      }, function () {
	        if (!_this.state.dateRange) {
	          policy.effectiveDate = '2000-01-01T05:00:00.000Z';
	          policy.expirationDate = '2070-01-01T05:00:00.000Z';
	        }
	      });
	    }
	  }, {
	    key: 'convertDuration',
	    value: function convertDuration(duration, unit) {
	      var days = Math.floor(duration / 1440);
	
	      if (unit === 'day') {
	        return days;
	      } else if (unit === 'hr') {
	        var durationMinusDays = duration - 1440 * days;
	        return Math.floor(durationMinusDays / 60);
	      } else {
	        return duration % 60;
	      }
	    }
	  }, {
	    key: 'handleRule',
	    value: function handleRule(i) {
	      var policy = this.props.policy;
	
	      // Set the rule time
	
	      var day = parseInt(this['durationDay-' + i].value, 10);
	      var hr = parseInt(this['durationHr-' + i].value, 10);
	      var min = parseInt(this['durationMin-' + i].value, 10);
	      var value = day * 1440 + hr * 60 + min;
	
	      policy.rules[i].minutesPrior = value;
	
	      // Set the rule percentage
	      policy.rules[i].penaltyPercentage = parseInt(this['percentage-' + i].value, 10);
	    }
	  }, {
	    key: 'addRule',
	    value: function addRule() {
	      var policy = this.props.policy;
	
	
	      var newRule = {
	        minutesPrior: 0,
	        penaltyPercentage: 0
	      };
	
	      policy.rules.push(newRule);
	    }
	  }, {
	    key: 'removeRule',
	    value: function removeRule(i) {
	      var policy = this.props.policy;
	      var rules = policy.rules;
	
	
	      rules.splice(i, 1);
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e, providedPolicy) {
	      var _props = this.props,
	          policy = _props.policy,
	          policySid = _props.policySid;
	      var PolicyStore = this.props.store.PolicyStore;
	
	      // Determine whether we’re editing or creating
	
	      if (policy.rules[0].sid) {
	        // Editing
	        if (!policy.policyVersionSid) {
	          policy.policyVersionSid = policy.sid;
	          policy.sid = policySid;
	        }
	
	        if (providedPolicy && !providedPolicy.policyVersionSid) {
	          providedPolicy.policyVersionSid = providedPolicy.sid;
	          providedPolicy.sid = policySid;
	        }
	
	        PolicyStore.updateCancellationPolicy(providedPolicy || policy);
	      } else {
	        // Creating
	        PolicyStore.createCancellationPolicy(policy);
	      }
	    }
	  }, {
	    key: 'handleDelete',
	    value: function handleDelete() {
	      var _props2 = this.props,
	          policySid = _props2.policySid,
	          translation = _props2.translation;
	      var PolicyStore = this.props.store.PolicyStore;
	
	
	      var msg = translation.delete_confirm;
	
	      (0, _helpers.confirm)(msg, function () {
	        return PolicyStore.deleteCancellationPolicy(policySid);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          policy = _props3.policy,
	          translation = _props3.translation;
	
	
	      return _react2.default.createElement(
	        'form',
	        {
	          className: '\n          panel panel--medium panel--editable\n          ' + (policy.status.toLowerCase() !== 'enabled' ? 'disabled' : '') + '\n        ',
	          onSubmit: function onSubmit(e) {
	            return (0, _helpers.checkValidity)(e, _this3.handleSubmit);
	          },
	          noValidate: true
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__header' },
	          _react2.default.createElement(
	            'h3',
	            {
	              className: 'panel__title'
	            },
	            policy.status.toLowerCase() === 'enabled' && _react2.default.createElement(
	              'label',
	              { htmlFor: 'title-' + policy.sid },
	              _react2.default.createElement(icons.iconEdit, null),
	              _react2.default.createElement(
	                'span',
	                { className: 'meta' },
	                translation.title
	              )
	            ),
	            _react2.default.createElement('input', {
	              id: 'title-' + policy.sid,
	              onChange: this.handleInput,
	              ref: function ref(input) {
	                return _this3.title = input;
	              },
	              defaultValue: policy.title,
	              required: true,
	              'aria-required': 'true',
	              disabled: policy.status.toLowerCase() === 'disabled'
	            })
	          ),
	          _react2.default.createElement(
	            'label',
	            {
	              htmlFor: 'enabled-' + policy.sid,
	              className: 'switch-label--alt'
	            },
	            policy.status.toLowerCase() === 'enabled' ? translation.enabled : translation.disabled
	          ),
	          _react2.default.createElement('input', {
	            type: 'checkbox',
	            id: 'enabled-' + policy.sid,
	            className: 'switch-input',
	            checked: policy.status.toLowerCase() === 'enabled',
	            onChange: function onChange(e) {
	              return _this3.togglePolicy(e);
	            }
	          }),
	          _react2.default.createElement(
	            'label',
	            {
	              htmlFor: 'enabled-' + policy.sid,
	              className: 'switch-label'
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              policy.status.toLowerCase() === 'enabled' ? translation.enabled : translation.disabled
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'fieldset',
	          { className: 'panel__fields' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'fields' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'strong',
	                { className: 'label-faux' },
	                translation.rules
	              ),
	              policy.rules.map(function (rule, i) {
	                return _react2.default.createElement(
	                  'ul',
	                  { className: 'form-inline text-block', key: i },
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'time-select time-select--alt', key: i },
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'lbl-required',
	                        htmlFor: 'days-' + policy.sid + '-' + i
	                      },
	                      translation.period
	                    ),
	                    _react2.default.createElement('input', {
	                      className: 'inp-hidden',
	                      type: 'text',
	                      value: rule.minutesPrior || '',
	                      ref: function ref(input) {
	                        return _this3['duration-' + i] = input;
	                      },
	                      onChange: function onChange() {
	                        return null;
	                      },
	                      required: true,
	                      'aria-required': 'true'
	                    }),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'days-' + policy.sid + '-' + i,
	                          value: _this3.convertDuration(rule.minutesPrior, 'day'),
	                          onChange: function onChange() {
	                            return _this3.handleRule(i);
	                          },
	                          ref: function ref(input) {
	                            return _this3['durationDay-' + i] = input;
	                          }
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '0' },
	                          '0 ',
	                          translation.days
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '1' },
	                          '1 ',
	                          translation.day
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '2' },
	                          '2 ',
	                          translation.days
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '3' },
	                          '3 ',
	                          translation.days
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '4' },
	                          '4 ',
	                          translation.days
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '5' },
	                          '5 ',
	                          translation.days
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '6' },
	                          '6 ',
	                          translation.days
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '7' },
	                          '7 ',
	                          translation.days
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'hours-' + policy.sid + '-' + i,
	                          value: _this3.convertDuration(rule.minutesPrior, 'hr'),
	                          onChange: function onChange() {
	                            return _this3.handleRule(i);
	                          },
	                          ref: function ref(input) {
	                            return _this3['durationHr-' + i] = input;
	                          }
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '0' },
	                          '0 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '1' },
	                          '1 ',
	                          translation.hour
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '2' },
	                          '2 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '3' },
	                          '3 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '4' },
	                          '4 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '5' },
	                          '5 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '6' },
	                          '6 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '7' },
	                          '7 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '8' },
	                          '8 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '9' },
	                          '9 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '10' },
	                          '10 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '11' },
	                          '11 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '12' },
	                          '12 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '13' },
	                          '13 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '14' },
	                          '14 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '15' },
	                          '15 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '16' },
	                          '16 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '17' },
	                          '17 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '18' },
	                          '18 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '19' },
	                          '19 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '20' },
	                          '21 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '21' },
	                          '20 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '22' },
	                          '22 ',
	                          translation.hours
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '23' },
	                          '23 ',
	                          translation.hours
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'select' },
	                      _react2.default.createElement(
	                        'select',
	                        {
	                          id: 'minutes-' + policy.sid + '-' + i,
	                          value: _this3.convertDuration(rule.minutesPrior, 'min'),
	                          onChange: function onChange() {
	                            return _this3.handleRule(i);
	                          },
	                          ref: function ref(input) {
	                            return _this3['durationMin-' + i] = input;
	                          }
	                        },
	                        _react2.default.createElement(
	                          'option',
	                          { value: '0' },
	                          '0 ',
	                          translation.minutes
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '5' },
	                          '5 ',
	                          translation.minutes
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '10' },
	                          '10 ',
	                          translation.minutes
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '15' },
	                          '15 ',
	                          translation.minutes
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '20' },
	                          '20 ',
	                          translation.minutes
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '25' },
	                          '25 ',
	                          translation.minutes
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '30' },
	                          '30 ',
	                          translation.minutes
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '35' },
	                          '35 ',
	                          translation.minutes
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '40' },
	                          '40 ',
	                          translation.minutes
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '45' },
	                          '45 ',
	                          translation.minutes
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '50' },
	                          '50 ',
	                          translation.minutes
	                        ),
	                        _react2.default.createElement(
	                          'option',
	                          { value: '55' },
	                          '55 ',
	                          translation.minutes
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'lbl-required',
	                        htmlFor: 'penalty-' + policy.sid + '-' + i
	                      },
	                      translation.penalty
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'decorated-input decorated-input--after' },
	                      _react2.default.createElement('input', {
	                        type: 'number',
	                        min: '1',
	                        max: '100',
	                        step: '1',
	                        value: rule.penaltyPercentage,
	                        onChange: function onChange() {
	                          return _this3.handleRule(i);
	                        },
	                        ref: function ref(input) {
	                          return _this3['percentage-' + i] = input;
	                        },
	                        required: true,
	                        'aria-required': 'true'
	                      }),
	                      _react2.default.createElement(
	                        'i',
	                        null,
	                        '%'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'btns' },
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'btn--add',
	                        onClick: _this3.addRule
	                      },
	                      _react2.default.createElement(icons.iconPlus, null),
	                      ' ',
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        translation.add_row
	                      )
	                    ),
	                    policy.rules.length > 1 && _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'btn--remove',
	                        onClick: function onClick() {
	                          return _this3.removeRule(i);
	                        }
	                      },
	                      _react2.default.createElement(icons.iconMinus, null),
	                      ' ',
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        translation.remove_row
	                      )
	                    )
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                {
	                  htmlFor: 'date-range-' + policy.sid
	                },
	                translation.date
	              ),
	              _react2.default.createElement('input', {
	                type: 'checkbox',
	                id: 'date-range-' + policy.sid,
	                className: 'switch-input',
	                defaultChecked: policy.effectiveDate !== '2000-01-01T05:00:00.000Z' || policy.expirationDate !== '2070-01-01T05:00:00.000Z',
	                onChange: this.toggleDateRange
	              }),
	              _react2.default.createElement(
	                'label',
	                {
	                  htmlFor: 'date-range-' + policy.sid,
	                  className: 'switch-label'
	                },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'meta' },
	                  translation.date
	                )
	              )
	            ),
	            this.state.dateRange && _react2.default.createElement(
	              'li',
	              { className: 'field--half' },
	              _react2.default.createElement(
	                'label',
	                {
	                  htmlFor: 'start-date-' + policy.sid,
	                  className: 'lbl-required'
	                },
	                translation.start_date
	              ),
	              _react2.default.createElement(_reactDatepicker2.default, {
	                id: 'start-date-' + policy.sid,
	                selected: policy.effectiveDate ? (0, _moment2.default)(policy.effectiveDate).tz(_moment2.default.tz.guess()) : null,
	                maxDate: policy.expirationDate,
	                onChange: function onChange(date, e) {
	                  return _this3.handleDate(date, 'effectiveDate', e);
	                },
	                placeholderText: translation.date_helper,
	                required: true,
	                'aria-required': 'true',
	                autoComplete: 'off'
	              })
	            ),
	            this.state.dateRange && _react2.default.createElement(
	              'li',
	              { className: 'field--half' },
	              _react2.default.createElement(
	                'label',
	                {
	                  htmlFor: 'end-date-' + policy.sid,
	                  className: 'lbl-required'
	                },
	                translation.end_date
	              ),
	              _react2.default.createElement(_reactDatepicker2.default, {
	                id: 'end-date-' + policy.sid,
	                selected: policy.expirationDate ? (0, _moment2.default)(policy.expirationDate).tz(_moment2.default.tz.guess()) : null,
	                maxDate: policy.expirationDate,
	                onChange: function onChange(date, e) {
	                  return _this3.handleDate(date, 'expirationDate', e);
	                },
	                placeholderText: translation.date_helper,
	                required: true,
	                'aria-required': 'true',
	                autoComplete: 'off'
	              })
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'label',
	                { htmlFor: 'notes-' + policy.sid },
	                translation.notes
	              ),
	              _react2.default.createElement(_reactTextareaAutosize2.default, {
	                id: 'notes-' + policy.sid,
	                className: 'textarea-grow',
	                ref: function ref(input) {
	                  return _this3.notes = input;
	                },
	                onChange: this.handleInput,
	                defaultValue: policy.notes
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel__actions actions' },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'btn--link negative',
	              type: 'button', onClick: this.handleDelete
	            },
	            translation.delete_button
	          ),
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'actions__btn actions__btn--primary',
	              type: 'submit'
	            },
	            translation.button
	          )
	        )
	      );
	    }
	  }]);
	
	  return PolicyEdit;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('PolicyEdit')(PolicyEdit);

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _dompurify = __webpack_require__(92);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	var RegisterIntro = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(RegisterIntro, _React$Component);
	
	  function RegisterIntro() {
	    _classCallCheck(this, RegisterIntro);
	
	    return _possibleConstructorReturn(this, (RegisterIntro.__proto__ || Object.getPrototypeOf(RegisterIntro)).apply(this, arguments));
	  }
	
	  _createClass(RegisterIntro, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'page wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'panel__title' },
	            translation.heading
	          ),
	          _react2.default.createElement('div', { className: 'panel__copy', dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(translation.body) } }),
	          _react2.default.createElement(
	            _reactRouterDom.Link,
	            { className: 'btn', to: '/register/step-01' },
	            translation.button
	          )
	        )
	      );
	    }
	  }]);
	
	  return RegisterIntro;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('RegisterIntro')(RegisterIntro);

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Step = __webpack_require__(290);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _RegisterStep = __webpack_require__(897);
	
	var _RegisterStep2 = _interopRequireDefault(_RegisterStep);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var RegisterForm = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(RegisterForm, _React$Component);
	
	  function RegisterForm() {
	    _classCallCheck(this, RegisterForm);
	
	    var _this2 = _possibleConstructorReturn(this, (RegisterForm.__proto__ || Object.getPrototypeOf(RegisterForm)).call(this));
	
	    _this2.setStep = _this2.setStep.bind(_this2);
	    _this2.nextStep = _this2.nextStep.bind(_this2);
	    _this2.prevStep = _this2.prevStep.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(RegisterForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      this.state = {
	        step: this.props.step || 1
	
	        // Retrieve data from localStorage
	      };var registerData = null;
	
	      if (SessionStore.hasSessionStorage) {
	        registerData = sessionStorage.getItem('registerData');
	      } else {
	        registerData = (0, _helpers.getCookie)('registerData');
	      }
	
	      if (registerData && typeof registerData !== 'undefined') {
	        this.props.store.RegisterStore.getLocalStorage(JSON.parse(registerData));
	      } else {
	        this.props.store.RegisterStore.getProctorData();
	      }
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(e, step) {
	      e.preventDefault();
	
	      this.setState({
	        step: step
	      });
	    }
	  }, {
	    key: 'nextStep',
	    value: function nextStep(e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var _this = this;
	
	      setTimeout(function () {
	        _this.props.routing.history.push('/register/step-0' + (_this.state.step + 1));
	      });
	
	      // this.setState({
	      //   step: this.state.step + 1
	      // });
	
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: 'prevStep',
	    value: function prevStep() {
	      this.setState({
	        step: this.state.step - 1
	      });
	
	      this.props.routing.history.push('/register/step-0' + (this.state.step - 1));
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'wrap block-form ' + (this.state.step === 2 ? 'block-form--alt' : 'no') },
	        _react2.default.createElement(_Step2.default, { step: this.state.step, setStep: this.setStep, data: translation.steps, skippable: false }),
	        _react2.default.createElement(_RegisterStep2.default, Object.assign({ step: this.state.step, checkValidity: _helpers.checkValidity, nextStep: this.nextStep, prevStep: this.prevStep }, this.props))
	      );
	    }
	  }]);
	
	  return RegisterForm;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('RegisterForm')(RegisterForm);

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProctoringInfo = __webpack_require__(297);
	
	var _ProctoringInfo2 = _interopRequireDefault(_ProctoringInfo);
	
	var _Location = __webpack_require__(296);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	var _ProfilePhoto = __webpack_require__(298);
	
	var _ProfilePhoto2 = _interopRequireDefault(_ProfilePhoto);
	
	var _Activate = __webpack_require__(295);
	
	var _Activate2 = _interopRequireDefault(_Activate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Components
	// import GeneralInfo from './GeneralInfo';
	
	
	var RegisterStep = function (_React$Component) {
	  _inherits(RegisterStep, _React$Component);
	
	  function RegisterStep() {
	    _classCallCheck(this, RegisterStep);
	
	    return _possibleConstructorReturn(this, (RegisterStep.__proto__ || Object.getPrototypeOf(RegisterStep)).apply(this, arguments));
	  }
	
	  _createClass(RegisterStep, [{
	    key: 'render',
	    value: function render() {
	      switch (this.props.step) {
	        // case 1:
	        //   return <GeneralInfo nextStep={this.props.nextStep} {...this.props} />;
	
	        case 1:
	          return _react2.default.createElement(_ProctoringInfo2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	        case 2:
	          return _react2.default.createElement(_Location2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	        case 3:
	          return _react2.default.createElement(_ProfilePhoto2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	        case 4:
	          return _react2.default.createElement(_Activate2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	
	        default:
	          return _react2.default.createElement(_ProctoringInfo2.default, Object.assign({ nextStep: this.props.nextStep }, this.props));
	      }
	    }
	  }]);
	
	  return RegisterStep;
	}(_react2.default.Component);
	
	exports.default = RegisterStep;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Downloads = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Downloads, _React$Component);
	
	  function Downloads() {
	    _classCallCheck(this, Downloads);
	
	    return _possibleConstructorReturn(this, (Downloads.__proto__ || Object.getPrototypeOf(Downloads)).apply(this, arguments));
	  }
	
	  _createClass(Downloads, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.props.store.ReportStore.getDownloads();
	    }
	  }, {
	    key: 'statusClass',
	    value: function statusClass(download) {
	      var className = '';
	
	      if (download.status) {
	        switch (download.status.toLowerCase()) {
	          case 'complete':
	            className = 'success';
	            break;
	
	          default:
	            className = 'pending';
	            break;
	        }
	      }
	
	      return className;
	    }
	  }, {
	    key: 'statusIcon',
	    value: function statusIcon(download) {
	      if (download.status) {
	        if (download.status.toLowerCase() === 'complete') {
	          return _react2.default.createElement(icons.iconCheckCircle, null);
	        } else if (download.status.toLowerCase() === 'exporting') {
	          return _react2.default.createElement(icons.iconHourglass, null);
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ReportStore = _props$store.ReportStore,
	          SessionStore = _props$store.SessionStore;
	      var downloads = ReportStore.downloads;
	
	
	      if (!SessionStore.loading) {
	        if (downloads.length > 0) {
	          return _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', id: 'heading-title', className: 'subtitle' },
	                  translation.title
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', id: 'heading-date', className: 'subtitle' },
	                  translation.date
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', id: 'heading-status', className: 'subtitle' },
	                  translation.status
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', id: 'heading-download', className: 'subtitle' },
	                  translation.download
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              downloads.map(function (download) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: download.sid },
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-title' },
	                    download.title
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-date' },
	                    _moment2.default.utc(download.createdDate).tz(_moment2.default.tz.guess()).format('M/D/YYYY h:mma z')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-status', className: 'capitalize ' + _this2.statusClass(download) },
	                    _this2.statusIcon(download),
	                    download.status,
	                    download.status && download.status.toLowerCase() === 'exporting' && _react2.default.createElement(
	                      'span',
	                      { className: 'pill pill--alt pill--right' },
	                      download.completionPercentage,
	                      '%'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-download', className: 'actions' },
	                    download.status === 'complete' && _react2.default.createElement(
	                      'a',
	                      {
	                        className: 'btn--outline',
	                        href: 'https://s3.amazonaws.com/' + download.s3Bucket + '/' + download.s3FilePath,
	                        target: '_blank',
	                        rel: 'noopener noreferrer'
	                      },
	                      _react2.default.createElement(icons.iconDownload, null),
	                      translation.download
	                    )
	                  )
	                );
	              })
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'span',
	            { className: 'no-results' },
	            translation.no_results
	          );
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title,
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { className: 'page__back', to: '/reports' },
	                'Back to all reports'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          this.renderResults()
	        )
	      );
	    }
	  }]);
	
	  return Downloads;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Downloads')(Downloads);

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _ReportStore = __webpack_require__(117);
	
	var _ReportStore2 = _interopRequireDefault(_ReportStore);
	
	var _config = __webpack_require__(24);
	
	var _ScheduleStore = __webpack_require__(75);
	
	var _ScheduleStore2 = _interopRequireDefault(_ScheduleStore);
	
	var _reactdatagridCommunity = __webpack_require__(146);
	
	var _reactdatagridCommunity2 = _interopRequireDefault(_reactdatagridCommunity);
	
	var _DateFilter = __webpack_require__(207);
	
	var _DateFilter2 = _interopRequireDefault(_DateFilter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filterValue = [{ name: 'appointmentDate', operator: 'equals', type: 'date', value: null }, { name: 'name', operator: 'contains', type: 'string', value: '' }, { name: 'email', operator: 'contains', type: 'string', value: '' }, { name: 'location', operator: 'contains', type: 'string', value: '' }];
	
	var gridStyle = { minHeight: 500 };
	
	var ExamAccommodations = (0, _mobxReact.observer)(function (props) {
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      skip = _useState2[0],
	      setSkip = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(50),
	      _useState4 = _slicedToArray(_useState3, 2),
	      limit = _useState4[0],
	      setLimit = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(filterValue),
	      _useState6 = _slicedToArray(_useState5, 2),
	      filterObject = _useState6[0],
	      setFilterObject = _useState6[1];
	
	  // eslint-disable-next-line
	
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      update = _useState8[0],
	      setUpdate = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      sort = _useState10[0],
	      setSort = _useState10[1];
	
	  var renderAccommodation = function renderAccommodation(acc, data) {
	
	    if (data[acc.key].info) {
	      return _react2.default.createElement(
	        "div",
	        { style: { margin: '10px' } },
	        _react2.default.createElement(
	          "b",
	          null,
	          acc.label,
	          ": "
	        ),
	        data[acc.key].info,
	        _react2.default.createElement("br", null)
	      );
	    } else if (typeof data[acc.key] === "string" || typeof data[acc.key] === "number") {
	      return _react2.default.createElement(
	        "div",
	        { style: { margin: '10px' } },
	        _react2.default.createElement(
	          "b",
	          null,
	          acc.label,
	          ": "
	        ),
	        data[acc.key],
	        _react2.default.createElement("br", null)
	      );
	    } else if (data[acc.key].permitted) {
	      return _react2.default.createElement(
	        "div",
	        { style: { margin: '10px' } },
	        _react2.default.createElement(
	          "b",
	          null,
	          acc.label,
	          ": "
	        ),
	        "Allowed",
	        _react2.default.createElement("br", null)
	      );
	    } else {
	      return _react2.default.createElement(
	        "div",
	        { style: { margin: '10px' } },
	        _react2.default.createElement(
	          "b",
	          null,
	          acc.label,
	          ": "
	        ),
	        "Not Allowed",
	        _react2.default.createElement("br", null)
	      );
	    }
	  };
	
	  var columns = [{
	    name: 'name',
	    header: "Student",
	    type: 'string',
	    defaultFlex: 1,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref) {
	      var data = _ref.data;
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        data.firstName,
	        " ",
	        data.lastName
	      );
	    }
	  }, {
	    name: 'email',
	    header: "Student Email",
	    type: 'string',
	    defaultFlex: 1.5,
	    defaultVisible: true,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref2) {
	      var data = _ref2.data;
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        data.email
	      );
	    }
	  }, {
	    name: 'appointmentDate',
	    header: 'Appointment Date',
	    defaultFlex: 1,
	    filterEditor: _DateFilter2.default,
	
	    dateFormat: 'MM/DD/YYYY',
	    render: function render(_ref3) {
	      var data = _ref3.data;
	
	      return _react2.default.createElement(
	        "span",
	        null,
	        (0, _moment2.default)(data.appointmentDate).format('MM/D/YYYY')
	      );
	    },
	    enableColumnFilterContextMenu: false
	  }, {
	    name: 'location',
	    header: "Location",
	    type: "string",
	    defaultFlex: 2,
	    enableColumnFilterContextMenu: false
	  }, {
	    name: 'accommodations',
	    header: 'Accommodations',
	    defaultFlex: 3,
	    render: function render(_ref4) {
	      var data = _ref4.data;
	
	      // Define the accommodations you want to check
	      var accommodations = [{ key: 'textbook', label: 'Textbook' }, { key: 'calculator', label: 'Calculator' }, { key: 'bathroom', label: 'Bathroom Breaks' }, { key: 'paper', label: 'Paper' }, { key: 'formulaSheet', label: 'Formula Sheet' }, { key: 'notes', label: 'Notes' }, { key: 'dictionary', label: 'Dictionary' }, { key: 'websites', label: 'Websites' }, { key: 'earplugs', label: 'Earplugs' }, { key: 'duration', label: 'Duration' }, { key: 'proctorNotes', label: 'Proctor Notes' }, { key: 'studentNotes', label: 'Student Notes' }, { key: 'examOpen', label: 'Exam Open Date' }, { key: 'examClose', label: 'Exam Close Date' }, { key: 'scheduleOpen', label: 'Schedule Open Date' }, { key: 'scheduleClose', label: 'Schedule Close Date' }, { key: 'otherItems', label: 'Other' }];
	
	      // Generate rows dynamically based on the accommodations
	
	      var accommodationRows = accommodations.filter(function (acc) {
	        var entry = data[acc.key];
	        if ((typeof entry === 'string' || typeof entry === 'number') && entry !== "") {
	          if (acc.key === 'examClose' || acc.key === 'examOpen' || acc.key === 'scheduleOpen' || acc.key === 'scheduleClose') {
	            data[acc.key] = (0, _moment2.default)(data[acc.key]).tz(_moment2.default.tz.guess()).format('MM/DD/YYYY hh:mm A');
	          }
	          return true;
	        } else if (entry && (typeof entry === "undefined" ? "undefined" : _typeof(entry)) === 'object' && (entry.info.trim() !== "" || entry.permitted === true)) {
	          return true;
	        }
	        return false;
	      }).map(function (acc) {
	        return renderAccommodation(acc, data);
	      });
	
	      return _react2.default.createElement(
	        "div",
	        { style: { whiteSpace: 'normal', wordWrap: 'break-word' } },
	        accommodationRows.length > 0 ? accommodationRows : _react2.default.createElement(
	          "div",
	          { style: { margin: '10px' } },
	          "This session has no accommodations."
	        )
	      );
	    }
	  }];
	
	  var formatAppointmentDate = function formatAppointmentDate(date) {
	    var addDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var dateString = (0, _moment2.default)(date).format('YYYY-MM-DD HH:mm');
	    var timezoneString = (0, _moment2.default)(date).local().tz(_moment2.default.tz.guess()).format('Z');
	    var newDate = _moment2.default.utc(dateString + " " + timezoneString, 'YYYY-MM-DD HH:mm Z').tz(_moment2.default.tz.guess()).toISOString();
	
	    if (addDay) {
	      return (0, _moment2.default)(newDate).add(1, 'd').toISOString();
	    } else return newDate;
	  };
	
	  var loadData = function loadData(_ref5) {
	    var skip = _ref5.skip,
	        limit = _ref5.limit;
	
	    setLimit(limit);
	    setSkip(skip);
	    var query = '?limit=' + limit;
	    if (skip) query += '&offset=' + skip;
	
	    filterObject.map(function (object) {
	      if (object.value && object.value.length > 0 || object.name === "appointmentDate") {
	        switch (object.name) {
	          case "appointmentDate":
	            if (object.value) {
	              query += "&appointmentStartDate=" + formatAppointmentDate(object.value);
	            }
	            break;
	          case "location":
	            query += "&location=" + object.value;
	            break;
	          case "name":
	            query += "&name=" + object.value;
	            break;
	          case "email":
	            query += "&email=" + object.value;
	            break;
	          default:
	            break;
	        }
	      }
	      return null;
	    });
	    var url = "/proctors/" + _SessionStore2.default.userData.proctorAccountSid + "/session-accommodations" + query;
	    _ReportStore2.default.reportUrl = url;
	
	    return _config.api.get(url).then(function (response) {
	      console.log(response);
	      return { data: response.data.results || [], count: response.data.total || 0 };
	    });
	  };
	
	  var dataSource = (0, _react.useCallback)(loadData, [skip, filterObject, limit, _ScheduleStore2.default.session, update, sort]);
	
	  return _react2.default.createElement(
	    "main",
	    { tabIndex: "0", id: "main-content", className: "page fill" },
	    _react2.default.createElement(
	      "div",
	      { className: "fill" },
	      _react2.default.createElement(
	        "div",
	        { "class": "split-row-container" },
	        _react2.default.createElement(
	          "div",
	          { className: "left" },
	          _react2.default.createElement(
	            "h1",
	            null,
	            "Session Accommodations"
	          )
	        ),
	        _react2.default.createElement("div", { className: "right" })
	      ),
	      _react2.default.createElement(_reactdatagridCommunity2.default, {
	        className: "reactDataGrid fill",
	        style: gridStyle,
	        idProperty: "id",
	        columns: columns,
	        dataSource: dataSource,
	        defaultFilterValue: filterValue,
	        onFilterValueChange: setFilterObject,
	        onSortInfoChange: setSort,
	        onSkipChange: setSkip,
	        onLimitChange: setLimit,
	        limit: limit,
	        skip: skip,
	        resizable: true
	        //onRowClick={onRowClick}
	        , pagination: true,
	        rowHeight: function rowHeight(_ref6) {
	          var data = _ref6.data;
	
	          var textLength = data.description.length;
	          if (textLength > 150) return 100; // Larger height for long descriptions
	          if (textLength > 50) return 70; // Medium height for moderate descriptions
	          return 40; // Default height for short descriptions
	        }
	      })
	    )
	  );
	});exports.default = ExamAccommodations;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _mobx = __webpack_require__(29);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dompurify = __webpack_require__(92);
	
	var _dompurify2 = _interopRequireDefault(_dompurify);
	
	var _LoadMore = __webpack_require__(289);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Report = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Report, _React$Component);
	
	  function Report() {
	    _classCallCheck(this, Report);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (Report.__proto__ || Object.getPrototypeOf(Report)).call(this));
	
	    _this2.handleClick = _this2.handleClick.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(Report, [{
	    key: 'handleClick',
	    value: function handleClick(e, action, actionType, sids) {
	      if (actionType === 'drawer') {
	        e.preventDefault();
	
	        var _this = this;
	        var url = e.target.href;
	        var sessionSid = (0, _helpers.getParam)('session', url);
	
	        this.props.parent.setState({
	          sessionSid: sessionSid
	        }, function () {
	          (0, _helpers.toggleDrawer)(null, _this.props.parent, action);
	        });
	      } else {
	        this.reportActions[action](sids, e);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ReportStore = _props$store.ReportStore,
	          SessionStore = _props$store.SessionStore;
	      var reportData = ReportStore.reportData,
	          appendReportData = ReportStore.appendReportData,
	          reportFormat = ReportStore.reportFormat,
	          reportNext = ReportStore.reportNext;
	
	
	      var group = null;
	      var concat = false;
	
	      if ((0, _helpers.getURLSegment)(this, 2) === 'sessions') {
	        group = this.props.store.ScheduleStore.events;
	        concat = true;
	      }
	
	      function renderData(element, index) {
	        if (element && (typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object' && !Array.isArray(element)) {
	          // If it’s an object, check for a URL and title
	          if (element.url && element.title) {
	            // If it’s a link, output an anchor tag
	            if (element.target && element.target === '_self') {
	              return _react2.default.createElement(
	                'li',
	                { key: index },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  {
	                    to: element.url,
	                    className: element.class,
	                    onClick: function onClick(e) {
	                      _this.handleClick(e, element.action, element.actionType);
	                    }
	                  },
	                  element.title
	                )
	              );
	            } else {
	              return _react2.default.createElement(
	                'li',
	                { key: index },
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: element.url,
	                    target: '_blank',
	                    className: element.class,
	                    onClick: function onClick(e) {
	                      _this.handleClick(e, element.action, element.actionType);
	                    }
	                  },
	                  element.title
	                )
	              );
	            }
	          } else if (element.button) {
	            return _react2.default.createElement(
	              'li',
	              { key: index },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: element.class,
	                  type: 'button',
	                  onClick: function onClick(e) {
	                    _this.handleClick(e, element.action, null, element.sids);
	                  },
	                  title: element.helper
	                },
	                element.title
	              )
	            );
	          } else if (element.raw && element.formatted) {
	            // Otherwise, if it’s raw and formatted data, output the formatted data
	            return element.formatted;
	          } else {
	            // If it’s not a link, loop through the keys
	            return Object.keys(element).map(function (key, i) {
	              if (element[key]) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i },
	                  (0, _moment2.default)(element[key], _moment2.default.ISO_8601).isValid() && _react2.default.createElement(
	                    'time',
	                    null,
	                    (0, _moment2.default)(element[key]).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	                  ),
	                  !(0, _moment2.default)(element[key], _moment2.default.ISO_8601).isValid() && _typeof(element[key]) === 'object' && element[key].url && !element[key].mailto && _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: element[key].url,
	                      target: '_blank'
	                    },
	                    element[key].title
	                  ),
	                  !(0, _moment2.default)(element[key], _moment2.default.ISO_8601).isValid() && _typeof(element[key]) === 'object' && element[key].mailto && _react2.default.createElement(
	                    'a',
	                    { href: element[key].url },
	                    element[key].title
	                  ),
	                  !(0, _moment2.default)(element[key], _moment2.default.ISO_8601).isValid() && _typeof(element[key]) === 'object' && element[key].onClick && _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn',
	                      onClick: _this[element[key].onClick],
	                      'data-sid': element[key].sid
	                    },
	                    element[key].title
	                  ),
	                  !(0, _moment2.default)(element[key], _moment2.default.ISO_8601).isValid() && _typeof(element[key]) === 'object' && !element[key].url && !element[key].onClick && _react2.default.createElement(
	                    'span',
	                    null,
	                    'object'
	                  ),
	                  !(0, _moment2.default)(element[key], _moment2.default.ISO_8601).isValid() && _typeof(element[key]) !== 'object' && key === 'truncate' && _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'truncate',
	                      title: element[key]
	                    },
	                    element[key].substring(0, 4),
	                    '\u2026',
	                    element[key].slice(-4)
	                  ),
	                  !(0, _moment2.default)(element[key], _moment2.default.ISO_8601).isValid() && _typeof(element[key]) !== 'object' && key !== 'truncate' && element[key]
	                );
	              }
	
	              return null;
	            });
	          }
	        } else {
	          return _react2.default.createElement(
	            'li',
	            { key: index },
	            element
	          );
	        }
	      }
	
	      if (!SessionStore.loading) {
	        if (reportData.length > 0) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'table-scrollable' },
	            _react2.default.createElement(
	              'div',
	              { className: 'table-wrap' },
	              _react2.default.createElement(
	                'table',
	                { className: 'report-table' },
	                _react2.default.createElement(
	                  'thead',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    Object.keys(reportData[0]).map(function (key, i) {
	                      return _react2.default.createElement(
	                        'th',
	                        {
	                          id: 'heading-' + i,
	                          key: i,
	                          scope: 'col',
	                          className: 'subtitle column-' + key
	                        },
	                        translation[key] || key,
	                        _react2.default.createElement(
	                          'div',
	                          {
	                            className: 'th-fixed column-' + key,
	                            'data-direction': 'asc',
	                            'aria-hidden': 'true'
	                          },
	                          translation[key] || key
	                        )
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  reportData.map(function (key, i) {
	                    return _react2.default.createElement(
	                      'tr',
	                      { key: i },
	                      Object.keys(reportData[0]).map(function (column, j) {
	                        if (reportData[i][column] && _typeof(reportData[i][column]) === 'object' && !(0, _mobx.isObservableArray)(reportData[i][column])) {
	                          // If the data is an object, loop through it
	                          return _react2.default.createElement(
	                            'td',
	                            {
	                              'aria-labelledby': 'heading-' + j,
	                              key: j,
	                              'data-col': column,
	                              className: 'column-' + column,
	                              'data-value': reportData[i][column].raw || ''
	                            },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'table-list' },
	                              renderData(reportData[i][column])
	                            )
	                          );
	                        } else if ((0, _mobx.isObservableArray)(reportData[i][column])) {
	                          // Otherwise, if it’s an array, loop through that
	                          return _react2.default.createElement(
	                            'td',
	                            {
	                              'aria-labelledby': 'heading-' + j,
	                              key: j,
	                              'data-col': column,
	                              className: 'column-' + column
	                            },
	                            _react2.default.createElement(
	                              'ul',
	                              { className: 'table-list' },
	                              reportData[i][column].map(function (subKey, k) {
	                                return renderData(subKey, k);
	                              })
	                            )
	                          );
	                        } else {
	                          // Otherwise, just output the data
	                          return _react2.default.createElement(
	                            'td',
	                            {
	                              'aria-labelledby': 'heading-' + j,
	                              key: j,
	                              className: (typeof reportData[i][column] === 'number' ? 'number' : '') + ' column-' + column,
	                              'data-col': column,
	                              'data-value': reportData[i][column]
	                            },
	                            (0, _moment2.default)(reportData[i][column], _moment2.default.ISO_8601).isValid() && column !== 'password' && _react2.default.createElement(
	                              'time',
	                              null,
	                              (0, _moment2.default)(reportData[i][column]).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY [at] h:mma z')
	                            ),
	                            (!(0, _moment2.default)(reportData[i][column], _moment2.default.ISO_8601).isValid() || column === 'password') && _react2.default.createElement('div', { dangerouslySetInnerHTML: {
	                                __html: _dompurify2.default.sanitize(reportData[i][column])
	                              } })
	                          );
	                        }
	                      })
	                    );
	                  })
	                )
	              ),
	              reportNext && _react2.default.createElement(_LoadMore2.default, Object.assign({
	                url: reportNext,
	                text: 'Load more results',
	                dataFormat: reportFormat,
	                dataSet: appendReportData,
	                concat: concat,
	                group: group,
	                wrapper: '.table-wrap'
	              }, this.props))
	            )
	          );
	        } else {
	          return _react2.default.createElement(
	            'span',
	            { className: 'no-results' },
	            translation.no_results
	          );
	        }
	      }
	
	      return null;
	    }
	  }]);
	
	  return Report;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Report')(Report);

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _mobx = __webpack_require__(29);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactDatepicker = __webpack_require__(68);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	var ReportFilter = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ReportFilter, _React$Component);
	
	  function ReportFilter() {
	    _classCallCheck(this, ReportFilter);
	
	    return _possibleConstructorReturn(this, (ReportFilter.__proto__ || Object.getPrototypeOf(ReportFilter)).apply(this, arguments));
	  }
	
	  _createClass(ReportFilter, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        institutions: null
	      };
	
	      // Bind this to functions
	      this.getInstitutions = this.getInstitutions.bind(this);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(key, value, exact) {
	      var reportFilters = this.props.store.ReportStore.reportFilters;
	
	
	      if (exact) {
	        reportFilters[key] = value;
	      } else {
	        reportFilters[key] = '*' + value + '*';
	      }
	    }
	  }, {
	    key: 'handleDateChange',
	    value: function handleDateChange(date, key) {
	      var reportFilters = this.props.store.ReportStore.reportFilters;
	
	      var formattedDate = (0, _moment2.default)(date).local().toISOString();
	
	      reportFilters[key] = formattedDate;
	
	      // Store the new date in state for display
	      this.setState(_defineProperty({}, key, date));
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      var ReportStore = this.props.store.ReportStore;
	
	
	      (0, _helpers.closeDrawer)(e, this.props.parent);
	
	      ReportStore.getReportData((0, _helpers.getURLSegment)(this, 2));
	    }
	  }, {
	    key: 'getInstitutions',
	    value: function getInstitutions() {
	      var SessionStore = this.props.store.SessionStore;
	
	
	      if (!SessionStore.installs) {
	        SessionStore.getInstalls();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ReportStore = _props$store.ReportStore,
	          SessionStore = _props$store.SessionStore;
	      var reportFilters = ReportStore.reportFilters,
	          reportFilterMap = ReportStore.reportFilterMap;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                'Filter Report'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'panel panel--brief' },
	            _react2.default.createElement(
	              'form',
	              { className: '', onSubmit: function onSubmit(e) {
	                  return _this2.handleSubmit(e);
	                }, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  Object.keys(reportFilterMap).map(function (key, i) {
	                    // Get the typeof to determine what kind of field we need
	                    var dataType = _typeof(reportFilterMap[key]);
	
	                    if (dataType === 'number') {
	                      // Number-based filter
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          key: i,
	                          className: 'field--select-text'
	                        },
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: key },
	                          translation[key + '_label'] || key
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select' },
	                          _react2.default.createElement(
	                            'select',
	                            { id: key },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '=' },
	                              translation.number.equals
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: '>' },
	                              translation.number.greater_than
	                            ),
	                            _react2.default.createElement(
	                              'option',
	                              { value: '<' },
	                              translation.number.less_than
	                            )
	                          )
	                        ),
	                        _react2.default.createElement('input', {
	                          type: 'number',
	                          placeholder: '0'
	                        })
	                      );
	                    } else if (Array.isArray((0, _mobx.toJS)(reportFilterMap[key]))) {
	                      // Select-based filter
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          key: i
	                        },
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: key },
	                          translation[key + '_label'] || key
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select' },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              id: key,
	                              defaultValue: reportFilters[key],
	                              onChange: function onChange(e) {
	                                return _this2.handleChange(key, e.target.value, true);
	                              }
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation[key + '_helper']
	                            ),
	                            reportFilterMap[key].map(function (option, i) {
	                              return _react2.default.createElement(
	                                'option',
	                                {
	                                  key: i,
	                                  value: option
	                                },
	                                translation.options[option] || option
	                              );
	                            })
	                          )
	                        )
	                      );
	                    } else if (dataType === 'string' && reportFilterMap[key] !== 'date' && reportFilterMap[key] !== 'install') {
	                      // String-based filter
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          key: i
	                        },
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: key },
	                          translation[key + '_label'] || key
	                        ),
	                        _react2.default.createElement('input', {
	                          id: key,
	                          type: 'text'
	                          // defaultValue={
	                          //   reportFilters[key] ?
	                          //   reportFilters[key].replace(/\*/g, '') :
	                          //   ''
	                          // }
	                          , onChange: function onChange(e) {
	                            return _this2.handleChange(key, e.target.value);
	                          }, placeholder: translation[key + '_helper'] || ''
	                        })
	                      );
	                    } else if (dataType === 'string' && reportFilterMap[key] === 'date') {
	                      // Date-based filter
	                      var date = null;
	
	                      if (_this2.state[key]) {
	                        date = _this2.state[key];
	                      } else if (reportFilters[key]) {
	                        date = (0, _moment2.default)(reportFilters[key]);
	                      }
	
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          key: i
	                        },
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: key },
	                          translation[key + '_label'] || key
	                        ),
	                        _react2.default.createElement(_reactDatepicker2.default, {
	                          id: key,
	                          selected: date,
	                          onChange: function onChange(date, e) {
	                            return _this2.handleDateChange(date, key);
	                          },
	                          placeholderText: 'mm/dd/yyyy',
	                          autoComplete: 'off'
	                        })
	                      );
	                    } else if (dataType === 'string' && reportFilterMap[key] === 'install') {
	                      // Install drop-down
	
	                      return _react2.default.createElement(
	                        'li',
	                        {
	                          key: i
	                        },
	                        _react2.default.createElement(
	                          'label',
	                          { htmlFor: key },
	                          translation[key + '_label'] || key
	                        ),
	                        _react2.default.createElement(
	                          'label',
	                          { className: 'select' },
	                          _react2.default.createElement(
	                            'select',
	                            {
	                              onChange: function onChange(e) {
	                                return _this2.handleChange('installSid', e.target.value, true);
	                              }
	                            },
	                            _react2.default.createElement(
	                              'option',
	                              { value: '' },
	                              translation[key + '_helper'] || key
	                            ),
	                            _this2.getInstitutions(),
	                            SessionStore.installs && SessionStore.installs.map(function (install, i) {
	                              return _react2.default.createElement(
	                                'option',
	                                { key: i, value: install.installSid },
	                                install.accountName
	                              );
	                            })
	                          )
	                        )
	                      );
	                    }
	
	                    return null;
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'btn', type: 'submit' },
	                translation.button
	              )
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ReportFilter;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ReportFilter')(ReportFilter);

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Report = __webpack_require__(900);
	
	var _Report2 = _interopRequireDefault(_Report);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _config = __webpack_require__(24);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var Reports = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Reports, _React$Component);
	
	  function Reports() {
	    _classCallCheck(this, Reports);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (Reports.__proto__ || Object.getPrototypeOf(Reports)).call(this));
	
	    _this.exportReport = _this.exportReport.bind(_this);
	    _this.completeExport = _this.completeExport.bind(_this);
	
	    _this.state = {
	      drawerContent: null,
	      drawerOpen: false,
	      sessionSid: null
	    };
	    return _this;
	  }
	
	  _createClass(Reports, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var ReportStore = this.props.store.ReportStore;
	
	
	      ReportStore.reportFilters = {};
	
	      if ((0, _helpers.getURLSegment)(this, 2)) {
	        ReportStore.getReportData((0, _helpers.getURLSegment)(this, 2));
	      } else {
	        ReportStore.reportData = [];
	      }
	    }
	  }, {
	    key: 'exportReport',
	    value: function exportReport() {
	      var translation = this.props.translation;
	      var ReportStore = this.props.store.ReportStore;
	
	      // Set the default export title
	
	      ReportStore.reportExportTitle = translation.reports[(0, _helpers.getURLSegment)(this, 2)].title;
	
	      // Show a dialog to let the user change the title
	      var msg = {
	        heading: translation.csv_prompt.heading,
	        input: translation.csv_prompt.input,
	        button: translation.csv_prompt.button
	      };
	
	      (0, _helpers.promptUser)(msg, this.completeExport, null, ReportStore.reportExportTitle);
	    }
	  }, {
	    key: 'completeExport',
	    value: function completeExport() {
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ReportStore = _props$store.ReportStore,
	          SessionStore = _props$store.SessionStore;
	
	
	      var callback = function callback() {
	        return SessionStore.showToaster(translation.exported, 'success');
	      };
	
	      ReportStore.exportData(callback);
	    }
	  }, {
	    key: 'reportList',
	    value: function reportList() {
	      var proctorAccountSid = this.props.store.SessionStore.userData.proctorAccountSid;
	
	      var reports = [{
	        url: 'exams',
	        icon: _react2.default.createElement(icons.iconFiles, null),
	        iamAction: 'sp:DescribeExamList',
	        iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':report'
	      }, {
	        url: 'sessions',
	        icon: _react2.default.createElement(icons.iconClock, null),
	        iamAction: 'sp:DescribeExamSessions',
	        iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':session'
	      }, {
	        url: 'appointment-timeline',
	        icon: _react2.default.createElement(icons.iconCalendar, null),
	        iamAction: 'sp:DescribeAppointmentTimeline',
	        iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':timeline'
	      }, {
	        url: 'exam-accommodations',
	        icon: _react2.default.createElement(icons.iconCalendar, null),
	        iamAction: 'sp:DescribeAppointmentTimeline',
	        iamResource: 'ssrn:ss:sp::' + proctorAccountSid + ':timeline'
	      }];
	
	      return reports;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var ReportStore = this.props.store.ReportStore;
	      var reportData = ReportStore.reportData;
	
	      var reportList = this.reportList();
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(
	            'header',
	            { className: 'page__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'page__title' },
	                translation.heading,
	                (0, _helpers.getURLSegment)(this, 2) && ': ' + translation.reports[(0, _helpers.getURLSegment)(this, 2)].title,
	                (0, _helpers.getURLSegment)(this, 2) && _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: 'page__back', to: '/reports' },
	                  'Back to all reports'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'page__actions actions' },
	                reportData && reportData.length > 0 && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn--outline',
	                    onClick: this.exportReport
	                  },
	                  _react2.default.createElement(icons.iconDownload, null),
	                  translation.csv_button
	                ),
	                (0, _helpers.getURLSegment)(this, 2) && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn',
	                    onClick: function onClick() {
	                      return (0, _helpers.toggleDrawer)(null, _this2, 'ReportFilter');
	                    }
	                  },
	                  _react2.default.createElement(icons.iconSettings, null),
	                  translation.filter_button
	                ),
	                !(0, _helpers.getURLSegment)(this, 2) && _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  {
	                    className: 'btn--outline',
	                    to: '/reports/downloads'
	                  },
	                  translation.exported_csvs
	                )
	              )
	            )
	          ),
	          !(0, _helpers.getURLSegment)(this, 2) && _react2.default.createElement(
	            _config.Validate,
	            null,
	            _react2.default.createElement(
	              'ul',
	              { className: 'block-list block-list--grid' },
	              reportList.map(function (report, i) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i, iamAction: report.iamAction, iamResource: report.iamResource },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      className: 'block-list__block block-list__link',
	                      to: (0, _helpers.getURLSegment)(_this2, 1) + '/' + report.url,
	                      onClick: function onClick() {
	                        //TODO: Remove force refresh and fix this routing, we shouldn't be depending on refreshes, this is just a quick fix to get this out
	                        if (report.url !== 'appointment-timeline') {
	                          ReportStore.data = [];
	                          ReportStore.getReportData(report.url);
	                        }
	                      }
	                    },
	                    report.icon,
	                    _react2.default.createElement(
	                      'strong',
	                      { className: 'block-list__title' },
	                      translation.reports[report.url].title
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'block__copy' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        translation.reports[report.url].description
	                      )
	                    )
	                  )
	                );
	              })
	            )
	          ),
	          (0, _helpers.getURLSegment)(this, 2) && _react2.default.createElement(_Report2.default, Object.assign({
	            reportData: ReportStore.reportData,
	            parent: this
	          }, this.props))
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this,
	          sessionSid: this.state.sessionSid
	        }, this.props))
	      );
	    }
	  }]);
	
	  return Reports;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Reports')(Reports);

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var CalendarList = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(CalendarList, _React$Component);
	
	  function CalendarList() {
	    _classCallCheck(this, CalendarList);
	
	    return _possibleConstructorReturn(this, (CalendarList.__proto__ || Object.getPrototypeOf(CalendarList)).apply(this, arguments));
	  }
	
	  _createClass(CalendarList, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var ScheduleStore = this.props.store.ScheduleStore;
	
	
	      ScheduleStore.getLocationCalendars(this.props.locationSid);
	    }
	  }, {
	    key: 'deleteCalendar',
	    value: function deleteCalendar(calendar) {
	      var _props$store = this.props.store,
	          ScheduleStore = _props$store.ScheduleStore,
	          SessionStore = _props$store.SessionStore;
	      var locationSid = calendar.locationSid,
	          sid = calendar.sid;
	
	      var dialogContent = this.props.translation.delete_content;
	
	      SessionStore.showConfirm(dialogContent, function () {
	        return ScheduleStore.deleteCalendar(locationSid, sid);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	      var _props$store2 = this.props.store,
	          ScheduleStore = _props$store2.ScheduleStore,
	          SessionStore = _props$store2.SessionStore;
	      var locationCalendars = ScheduleStore.locationCalendars;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'panel__title' },
	            translation.heading
	          ),
	          locationCalendars.length > 0 && _react2.default.createElement(
	            'ul',
	            { className: 'calendar-list' },
	            locationCalendars.map(function (calendar) {
	              return _react2.default.createElement(
	                'li',
	                { key: calendar.sid, className: 'media--alt' },
	                calendar.title,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'media__action' },
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: '/locations/schedule/' + _this2.props.locationSid + '/view/' + calendar.sid,
	                      className: 'neutral',
	                      onClick: function onClick() {
	                        return _this2.props.setStep(3);
	                      }
	                    },
	                    _react2.default.createElement(icons.iconCalendar, null),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'meta' },
	                      translation.view
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: '/locations/schedule/' + _this2.props.locationSid + '/calendar/' + calendar.sid,
	                      className: 'subdued',
	                      onClick: function onClick() {
	                        return _this2.props.setStep(2);
	                      }
	                    },
	                    _react2.default.createElement(icons.iconGear, null),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'meta' },
	                      translation.edit
	                    )
	                  )
	                )
	              );
	            })
	          ),
	          locationCalendars.length === 0 && _react2.default.createElement(
	            'p',
	            null,
	            translation.no_results
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'btn-group' },
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn--outline',
	                onClick: function onClick() {
	                  return _this2.props.setStep(4);
	                }
	              },
	              _react2.default.createElement(icons.iconSettings, null),
	              translation.manage
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'btn--outline',
	                onClick: function onClick() {
	                  return _this2.props.setStep(2);
	                }
	              },
	              _react2.default.createElement(icons.iconCalendarPlus, null),
	              translation.add_calendar
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return CalendarList;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('CalendarList')(CalendarList);

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _SeatSettings = __webpack_require__(909);
	
	var _SeatSettings2 = _interopRequireDefault(_SeatSettings);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	// Dependencies
	
	
	var CalendarSeats = (0, _mobxReact.observer)(function (_React$Component) {
	    _inherits(CalendarSeats, _React$Component);
	
	    function CalendarSeats() {
	        _classCallCheck(this, CalendarSeats);
	
	        var _this = _possibleConstructorReturn(this, (CalendarSeats.__proto__ || Object.getPrototypeOf(CalendarSeats)).call(this));
	
	        _this.state = {
	            editSeat: false,
	            seatSid: ''
	        };
	
	
	        _this.editSeat = _this.editSeat.bind(_this);
	        _this.stopEditing = _this.stopEditing.bind(_this);
	        return _this;
	    }
	
	    _createClass(CalendarSeats, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _props$store = this.props.store,
	                SessionStore = _props$store.SessionStore,
	                ScheduleStore = _props$store.ScheduleStore;
	            var proctorAccountSid = SessionStore.userData.proctorAccountSid;
	
	
	            ScheduleStore.listSeats(proctorAccountSid, this.props.locationSid, null, 'title');
	        }
	    }, {
	        key: 'deleteSeat',
	        value: function deleteSeat(seatSid) {
	            var _props$store2 = this.props.store,
	                SessionStore = _props$store2.SessionStore,
	                ScheduleStore = _props$store2.ScheduleStore;
	            var proctorAccountSid = SessionStore.userData.proctorAccountSid;
	
	
	            ScheduleStore.deleteSeat(seatSid, ScheduleStore.listSeats(proctorAccountSid, this.props.locationSid, null, 'title'));
	        }
	    }, {
	        key: 'editSeat',
	        value: function editSeat(seatSid) {
	            this.setState({ editSeat: true, seatSid: seatSid });
	        }
	    }, {
	        key: 'stopEditing',
	        value: function stopEditing() {
	            var _props$store3 = this.props.store,
	                SessionStore = _props$store3.SessionStore,
	                ScheduleStore = _props$store3.ScheduleStore;
	            var proctorAccountSid = SessionStore.userData.proctorAccountSid;
	
	
	            this.setState({ editSeat: false, seatSid: '' });
	
	            // Show newly updated seats
	            ScheduleStore.listSeats(proctorAccountSid, this.props.locationSid, null, 'title');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var translation = this.props.translation;
	            var ScheduleStore = this.props.store.ScheduleStore;
	
	            var calendars = ScheduleStore.locationCalendars;
	            var location = ScheduleStore.scheduleLocation;
	            var seats = ScheduleStore.locationSeats;
	            var filteredCalendars = calendars.filter(function (calendar) {
	                return calendar.useSeatManagement;
	            });
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel panel--large panel--large-alt' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        className: 'btn btn--inline',
	                        onClick: function onClick() {
	                            return _this2.setState({ editSeat: true });
	                        }
	                    },
	                    translation.add
	                ),
	                _react2.default.createElement(
	                    'button',
	                    {
	                        className: 'panel__close',
	                        onClick: function onClick() {
	                            return _this2.props.setStep(1);
	                        }
	                    },
	                    _react2.default.createElement(icons.iconTimes, null),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        translation.cancel
	                    )
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    { className: 'panel--title' },
	                    location.title + '\'s seats'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'scrollwrapper' },
	                    _react2.default.createElement(
	                        'table',
	                        { className: 'table-scrollable seats-table' },
	                        _react2.default.createElement(
	                            'thead',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    translation.seat.name
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    translation.seat.description
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    translation.seat.upcoming
	                                ),
	                                _react2.default.createElement(
	                                    'th',
	                                    null,
	                                    translation.seat.auto_assign
	                                ),
	                                filteredCalendars.length > 0 && filteredCalendars.map(function (calendar, i) {
	                                    return _react2.default.createElement(
	                                        'th',
	                                        { key: 'calendar-title-' + i },
	                                        calendar.title
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            seats.length > 0 && seats.map(function (seat, i) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    { key: 'seat-' + i },
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'seat-name-cell' },
	                                            seat.title,
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'btn-group--flex' },
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    {
	                                                        className: 'btn--reset',
	                                                        onClick: function onClick() {
	                                                            return _this2.editSeat(seat.sid);
	                                                        }
	                                                    },
	                                                    _react2.default.createElement(icons.iconSettings, null)
	                                                ),
	                                                _react2.default.createElement(
	                                                    'button',
	                                                    {
	                                                        className: 'btn--reset negative ' + (seat.upcomingAppointmentCount > 0 ? 'disabled' : ''),
	                                                        onClick: function onClick() {
	                                                            return _this2.deleteSeat(seat.sid);
	                                                        },
	                                                        disabled: seat.upcomingAppointmentCount > 0
	                                                    },
	                                                    _react2.default.createElement(icons.iconTrash, null)
	                                                )
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        seat.description || ''
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'center-divide' },
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                seat.upcomingAppointmentCount
	                                            ),
	                                            _react2.default.createElement(
	                                                'p',
	                                                null,
	                                                seat.nextAppointmentDate ? (0, _moment2.default)(seat.nextAppointmentDate).local().tz(_moment2.default.tz.guess()).format('M/DD/YYYY @ h:mma z') : 'N/A'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        seat.autoAssign && _react2.default.createElement(
	                                            'span',
	                                            { className: 'positive icon--lg' },
	                                            _react2.default.createElement(icons.iconCheck, null)
	                                        )
	                                    ),
	                                    filteredCalendars.length > 0 && filteredCalendars.map(function (calendar, i) {
	                                        return _react2.default.createElement(
	                                            'td',
	                                            { key: 'calendar-' + i },
	                                            seat.calendarSids.some(function (seatCalendar) {
	                                                return seatCalendar === calendar.sid;
	                                            }) && _react2.default.createElement(
	                                                'span',
	                                                { className: 'positive icon--lg' },
	                                                _react2.default.createElement(icons.iconCheck, null)
	                                            )
	                                        );
	                                    })
	                                );
	                            })
	                        )
	                    )
	                ),
	                this.state.editSeat && _react2.default.createElement(_SeatSettings2.default, {
	                    seatSid: this.state.seatSid,
	                    seats: seats,
	                    store: this.props.store,
	                    close: this.stopEditing,
	                    calendars: filteredCalendars
	                })
	            );
	        }
	    }]);
	
	    return CalendarSeats;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('CalendarSeats')(CalendarSeats);

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(17);
	
	var _reactTabs = __webpack_require__(79);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Availability = __webpack_require__(299);
	
	var _Availability2 = _interopRequireDefault(_Availability);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Dependencies
	
	
	// Components
	
	
	var CalendarSettings = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(CalendarSettings, _React$Component);
	
	  function CalendarSettings() {
	    _classCallCheck(this, CalendarSettings);
	
	    // Bind this to functions
	    var _this = _possibleConstructorReturn(this, (CalendarSettings.__proto__ || Object.getPrototypeOf(CalendarSettings)).call(this));
	
	    _this.handleInput = _this.handleInput.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	
	    _this.state = {
	      enableArrivalManagement: false,
	      maxStartingAppointments: null,
	      useSeatManagement: false,
	      enableLockoutPeriod: false,
	      lockoutPeriod: null,
	      lockoutPeriodUnits: null,
	
	      title: '',
	      numberOfSeats: '',
	      interval: '',
	      endBuffer: '',
	      activeTab: 0,
	      calendarRetrieved: false
	    };
	    return _this;
	  }
	
	  _createClass(CalendarSettings, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var ScheduleStore = this.props.store.ScheduleStore;
	
	
	      if (this.props.calendarSid) {
	        // If editing, get the calendar
	        var callback = function callback(data) {
	          _this2.setState({
	            title: data.title,
	            numberOfSeats: data.numberOfSeats,
	            useSeatManagement: data.useSeatManagement,
	            enableLockoutPeriod: data.schedule.enableLockoutPeriod,
	            maxStartingAppointments: data.schedule.maxStartingAppointments,
	            enableArrivalManagement: data.schedule.enableArrivalManagement,
	            lockoutPeriod: data.schedule.lockoutPeriod,
	            lockoutPeriodUnits: data.schedule.lockoutPeriodUnits,
	            interval: data.schedule.interval,
	            endBuffer: data.schedule.endBuffer,
	            calendarRetrieved: true
	          });
	        };
	        ScheduleStore.getCalendar(this.props.locationSid, this.props.calendarSid, callback);
	      }
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput() {
	      var title = this.title.value;
	      var numberOfSeats = this.numberOfSeats.value;
	      var interval = this.interval.value ? parseInt(this.interval.value, 10) : null;
	      var endBuffer = this.endBuffer.value ? parseInt(this.endBuffer.value, 10) : null;
	
	      this.setState({
	        title: title,
	        numberOfSeats: numberOfSeats,
	        interval: interval,
	        endBuffer: endBuffer
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ScheduleStore = _props$store.ScheduleStore,
	          SessionStore = _props$store.SessionStore;
	
	      var callback = null;
	
	      var data = {
	        title: this.state.title,
	        numberOfSeats: this.state.numberOfSeats,
	        interval: this.state.interval,
	        endBuffer: this.state.endBuffer,
	        enableArrivalManagement: this.state.enableArrivalManagement,
	        maxStartingAppointments: this.state.maxStartingAppointments && this.state.enableArrivalManagement ? parseInt(this.state.maxStartingAppointments, 10) : null,
	        useSeatManagement: this.state.useSeatManagement,
	        enableLockoutPeriod: this.state.enableLockoutPeriod,
	        lockoutPeriod: this.state.enableLockoutPeriod ? this.state.lockoutPeriod : null,
	        lockoutPeriodUnits: this.state.enableLockoutPeriod ? this.state.lockoutPeriodUnits : null
	      };
	
	      if (this.props.calendarSid) {
	        // Editing, so run update API call
	        callback = function callback() {
	          SessionStore.showToaster(translation.updated, 'success');
	        };
	
	        ScheduleStore.updateCalendar(this.props.locationSid, this.props.calendarSid, data, callback);
	      } else {
	        // Creating a new calendar
	        callback = function callback(data) {
	          var pathname = _this3.props.routing.location.pathname;
	
	          pathname += '/calendar/' + data.sid;
	
	          _this3.props.routing.history.push(pathname);
	
	          SessionStore.showToaster(translation.created, 'success');
	        };
	
	        ScheduleStore.createCalendar(this.props.locationSid, data, callback);
	      }
	      this.props.setStep(1);
	      ScheduleStore.getLocationCalendars(this.props.locationSid);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var ScheduleStore = this.props.store.ScheduleStore;
	      var locationCalendar = ScheduleStore.locationCalendar;
	
	      // Don’t use the default tab styles
	
	      _reactTabs.Tabs.setUseDefaultStyles(false);
	
	      if (this.props.calendarSid && this.state.calendarRetrieved || !this.props.calendarSid) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'panel--brief panel--brief-alt --xlarge' },
	          _react2.default.createElement(
	            'button',
	            {
	              className: 'panel__close',
	              onClick: function onClick() {
	                return _this4.props.setStep(1);
	              }
	            },
	            _react2.default.createElement(icons.iconTimes, null),
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              translation.cancel
	            )
	          ),
	          this.props.calendarSid && _react2.default.createElement(
	            'h2',
	            { className: 'panel__title' },
	            locationCalendar.title
	          ),
	          !this.props.calendarSid && _react2.default.createElement(
	            'h2',
	            { className: 'panel__title' },
	            translation.heading_new
	          ),
	          _react2.default.createElement(
	            _reactTabs.Tabs,
	            {
	              onSelect: this.handleTabs,
	              selectedIndex: this.state.activeTab
	            },
	            _react2.default.createElement(
	              _reactTabs.TabList,
	              { className: 'tabs-sm' },
	              _react2.default.createElement(
	                _reactTabs.Tab,
	                null,
	                translation.tabs.settings
	              ),
	              _react2.default.createElement(
	                _reactTabs.Tab,
	                null,
	                translation.tabs.availability
	              )
	            ),
	            _react2.default.createElement(
	              _reactTabs.TabPanel,
	              null,
	              _react2.default.createElement(
	                'form',
	                { onSubmit: function onSubmit(e) {
	                    return (0, _helpers.checkValidity)(e, _this4.handleSubmit);
	                  },
	                  noValidate: true },
	                _react2.default.createElement(
	                  'fieldset',
	                  null,
	                  _react2.default.createElement(
	                    'ul',
	                    { className: 'fields' },
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'calendar-name' },
	                        translation.name
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'text',
	                        defaultValue: this.state.title,
	                        onChange: this.handleInput,
	                        ref: function ref(input) {
	                          return _this4.title = input;
	                        },
	                        required: true,
	                        'aria-required': 'true'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        null,
	                        translation.seat_management
	                      ),
	                      _react2.default.createElement('input', {
	                        checked: this.state.useSeatManagement,
	                        id: 'seat-management',
	                        type: 'checkbox',
	                        className: 'switch-input',
	                        onClick: function onClick() {
	                          return _this4.setState(function (prevState) {
	                            return { useSeatManagement: !prevState.useSeatManagement };
	                          });
	                        }
	                      }),
	                      _react2.default.createElement('label', { className: 'switch-label', htmlFor: 'seat-management', checked: true })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'calendar-seats' },
	                        translation.seats
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'number',
	                        defaultValue: this.state.numberOfSeats,
	                        onChange: this.handleInput,
	                        ref: function ref(input) {
	                          return _this4.numberOfSeats = input;
	                        },
	                        step: '1',
	                        min: '1',
	                        required: true,
	                        'aria-required': 'true'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'arrival-management' },
	                        translation.arrival_management
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        className: 'switch-input',
	                        id: 'arrival-management',
	                        onChange: function onChange() {
	                          return _this4.setState(function (prevState) {
	                            return { enableArrivalManagement: !prevState.enableArrivalManagement };
	                          });
	                        },
	                        checked: this.state.enableArrivalManagement,
	                        defaultChecked: this.state.enableArrivalManagement
	                      }),
	                      _react2.default.createElement('label', { className: 'switch-label', htmlFor: 'arrival-management' })
	                    ),
	                    this.state.enableArrivalManagement && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'max-appointments' },
	                        translation.max_appointments_label
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'number',
	                        id: 'max-appointments',
	                        defaultValue: this.state.maxStartingAppointments,
	                        onChange: function onChange(e) {
	                          return _this4.setState({ maxStartingAppointments: e.target.value });
	                        },
	                        required: true,
	                        'aria-required': 'true'
	                      })
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'lockout-period' },
	                        translation.enable_lockout_period
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'checkbox',
	                        className: 'switch-input',
	                        onChange: function onChange() {
	                          return _this4.setState(function (prevState) {
	                            return { enableLockoutPeriod: !prevState.enableLockoutPeriod };
	                          });
	                        },
	                        checked: this.state.enableLockoutPeriod,
	                        id: 'lockout-period'
	                      }),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'switch-label', htmlFor: 'lockout-period' },
	                        _react2.default.createElement('span', { className: 'meta' })
	                      )
	                    ),
	                    this.state.enableLockoutPeriod && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'enable-lockout' },
	                        translation.lockout_period
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'number',
	                        id: 'enable-lockout',
	                        defaultValue: this.state.lockoutPeriod,
	                        onChange: function onChange(e) {
	                          return _this4.setState({ lockoutPeriod: e.target.value });
	                        },
	                        required: true,
	                        'aria-required': 'true'
	                      })
	                    ),
	                    this.state.enableLockoutPeriod && _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'lockout-unit-select' },
	                        translation.lockout_period_units
	                      ),
	                      _react2.default.createElement(
	                        'label',
	                        { className: 'select' },
	                        _react2.default.createElement(
	                          'select',
	                          {
	                            id: 'lockout-unit-select',
	                            onChange: function onChange(e) {
	                              return _this4.setState({ lockoutPeriodUnits: e.target.value });
	                            },
	                            defaultValue: this.state.lockoutPeriodUnits,
	                            required: true
	                          },
	                          _react2.default.createElement(
	                            'option',
	                            { value: '' },
	                            translation.select_placeholder
	                          ),
	                          _react2.default.createElement(
	                            'option',
	                            { value: 'business' },
	                            translation.business
	                          ),
	                          _react2.default.createElement(
	                            'option',
	                            { value: 'actual' },
	                            translation.actual
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'calendar-interval' },
	                        translation.start_times
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'number',
	                        id: 'calendar-interval',
	                        defaultValue: this.state.interval,
	                        onChange: this.handleInput,
	                        ref: function ref(input) {
	                          return _this4.interval = input;
	                        },
	                        step: '1',
	                        min: '0',
	                        required: true,
	                        'aria-required': 'true'
	                      }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'preposition form-note' },
	                        this.state.interval !== 1 && this.state.interval !== 0 && this.state.interval !== null && translation.start_times_helper.replace('%time%', this.state.interval),
	                        this.state.interval === 1 && translation.start_times_helper_single.replace('%time%', this.state.interval),
	                        !this.state.interval && translation.start_times_helper.replace('%time%', 'X')
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'li',
	                      null,
	                      _react2.default.createElement(
	                        'label',
	                        { htmlFor: 'calendar-buffer' },
	                        translation.buffer
	                      ),
	                      _react2.default.createElement('input', {
	                        type: 'number',
	                        id: 'calendar-buffer',
	                        defaultValue: this.state.endBuffer,
	                        onChange: this.handleInput,
	                        ref: function ref(input) {
	                          return _this4.endBuffer = input;
	                        },
	                        step: '1',
	                        min: '0',
	                        required: true,
	                        'aria-required': 'true'
	                      }),
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'preposition form-note' },
	                        this.state.endBuffer !== 1 && this.state.endBuffer !== 0 && this.state.endBuffer !== null && translation.buffer_helper.replace('%time%', this.state.endBuffer),
	                        this.state.endBuffer === 1 && translation.buffer_helper_single.replace('%time%', this.state.endBuffer),
	                        !this.state.endBuffer && translation.buffer_helper.replace('%time%', 'X')
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'panel__btns' },
	                  _react2.default.createElement(
	                    'button',
	                    { className: 'btn btn--inline', type: 'submit' },
	                    translation.button
	                  ),
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'btn--link',
	                      onClick: function onClick() {
	                        return _this4.props.setStep(1);
	                      }
	                    },
	                    translation.cancel
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _reactTabs.TabPanel,
	              null,
	              _react2.default.createElement(_Availability2.default, Object.assign({}, this.props, {
	                defaultNumberOfSeats: this.state.numberOfSeats,
	                dayOfWeek: [0, 1, 2, 3, 4, 5, 6],
	                callback: function callback() {
	                  _this4.setState({
	                    editAvailability: false,
	                    editAvailabilityDate: null,
	                    editAvailabilityDayOfWeek: null,
	                    editAvailabilitiesDefault: []
	                  });
	                }
	              }))
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return CalendarSettings;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('CalendarSettings')(CalendarSettings);

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _CustomAvailability = __webpack_require__(907);
	
	var _CustomAvailability2 = _interopRequireDefault(_CustomAvailability);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var CalendarView = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(CalendarView, _React$Component);
	
	  function CalendarView() {
	    _classCallCheck(this, CalendarView);
	
	    // Bind this to functions
	    var _this2 = _possibleConstructorReturn(this, (CalendarView.__proto__ || Object.getPrototypeOf(CalendarView)).call(this));
	
	    _this2.calc = _this2.calc.bind(_this2);
	    _this2.today = _this2.today.bind(_this2);
	    _this2.prevMonth = _this2.prevMonth.bind(_this2);
	    _this2.nextMonth = _this2.nextMonth.bind(_this2);
	    _this2.renderAvailabilityList = _this2.renderAvailabilityList.bind(_this2);
	
	    _this2.state = {
	      today: (0, _moment2.default)().startOf('day'),
	      year: (0, _moment2.default)().year(),
	      month: (0, _moment2.default)().month(),
	      startDay: 1,
	      disablePast: false,
	      firstOfMonth: new Date((0, _moment2.default)().year(), (0, _moment2.default)().month(), 1),
	      daysInMonth: new Date((0, _moment2.default)().year(), (0, _moment2.default)().month() + 1, 0).getDate(),
	      timeZone: ''
	    };
	    return _this2;
	  }
	
	  _createClass(CalendarView, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var _this = this;
	      var _props$store = this.props.store,
	          LocationStore = _props$store.LocationStore,
	          ScheduleStore = _props$store.ScheduleStore,
	          SessionStore = _props$store.SessionStore;
	
	      var timeZoneSid = '';
	
	      if (LocationStore.locations && LocationStore.locations.length > 0) {
	        var location = LocationStore.locations.find(function (location) {
	          return location.sid === _this3.props.locationSid;
	        });
	        timeZoneSid = location.timeZoneSid;
	      }
	
	      // Set the intial state
	
	
	      // Get the calendar’s availability
	      var callback = function callback() {
	        _this.getAvailability();
	
	        // Disabling exclusions until a later date
	        // ScheduleStore.getExclusions(data.schedule.sid);
	      };
	
	      var timeZoneCallback = function timeZoneCallback(timeZones) {
	        var timezoneObj = timeZones.find(function (result) {
	          return result.sid === timeZoneSid;
	        });
	        if (timezoneObj && timezoneObj.name) {
	          _this3.setState({ timeZone: _moment2.default.tz(timezoneObj.name).format('z') });
	        }
	      };
	
	      ScheduleStore.getCalendar(this.props.locationSid, this.props.calendarSid, callback);
	      SessionStore.getTimezones(timeZoneCallback);
	    }
	  }, {
	    key: 'renderAvailabilityList',
	    value: function renderAvailabilityList() {
	      var ScheduleStore = this.props.store.ScheduleStore;
	
	
	      var baseAvailabilities = ScheduleStore.availabilities[(0, _moment2.default)(this.state.editAvailabilityDate).format('YYYY-MM-DD')];
	      var availabilities = null;
	      if (baseAvailabilities) {
	
	        baseAvailabilities = baseAvailabilities.filter(function (obj) {
	          return !obj.excludeDate;
	        });
	
	        availabilities = baseAvailabilities.filter(function (obj) {
	          return obj.override === true;
	        });
	
	        if (availabilities.length === 0) {
	          availabilities = baseAvailabilities;
	        }
	      }
	
	      console.log('baseAvailabilities:', baseAvailabilities);
	
	      this.setState({ cleanedAvailabilities: availabilities });
	    }
	  }, {
	    key: 'getAvailability',
	    value: function getAvailability() {
	      var _this4 = this;
	
	      var ScheduleStore = this.props.store.ScheduleStore;
	
	
	      var month = parseInt(this.state.month, 10) + 1;
	
	      if (month < 10) {
	        month = '0' + month;
	      }
	
	      var startDate = this.state.year + '-' + month + '-01';
	      var endDate = this.state.year + '-' + month + '-' + this.state.daysInMonth;
	
	      var callback = function callback() {
	        if (_this4.state.editAvailabilityDate) {
	          _this4.renderAvailabilityList();
	        }
	      };
	
	      ScheduleStore.getAvailability(this.props.calendarSid, startDate, endDate, callback);
	    }
	  }, {
	    key: 'calc',
	    value: function calc(year, month) {
	      return {
	        firstOfMonth: new Date(year, month, 1),
	        daysInMonth: new Date(year, month + 1, 0).getDate()
	      };
	    }
	  }, {
	    key: 'today',
	    value: function today() {
	      var _this = this;
	
	      var state = {};
	      state.year = (0, _moment2.default)().year();
	      state.month = (0, _moment2.default)().month();
	
	      Object.assign(state, this.calc.call(null, state.year, state.month));
	      this.setState(state);
	
	      setTimeout(function () {
	        _this.getAvailability();
	      });
	    }
	  }, {
	    key: 'prevMonth',
	    value: function prevMonth() {
	      var _this = this;
	
	      var state = {};
	
	      if (this.state.month > 0) {
	        state.month = this.state.month - 1;
	        state.year = this.state.year;
	      } else {
	        state.month = 11;
	        state.year = this.state.year - 1;
	      }
	
	      Object.assign(state, this.calc.call(null, state.year, state.month));
	      this.setState(state);
	
	      setTimeout(function () {
	        _this.getAvailability();
	      });
	    }
	  }, {
	    key: 'nextMonth',
	    value: function nextMonth() {
	      var _this = this;
	
	      var state = {};
	
	      if (this.state.month < 11) {
	        state.month = this.state.month + 1;
	        state.year = this.state.year;
	      } else {
	        state.month = 0;
	        state.year = this.state.year + 1;
	      }
	
	      Object.assign(state, this.calc.call(null, state.year, state.month));
	      this.setState(state);
	
	      setTimeout(function () {
	        _this.getAvailability();
	      });
	    }
	  }, {
	    key: 'renderAvailabilities',
	    value: function renderAvailabilities(date, dayOfWeek, past) {
	      var _this5 = this;
	
	      var translation = this.props.translation;
	      var ScheduleStore = this.props.store.ScheduleStore;
	      var availabilities = ScheduleStore.availabilities;
	      // Add leading zeroes to dates
	
	      var month = this.state.month + 1;
	
	      if (month < 10) {
	        month = '0' + month;
	      }
	
	      var dayOfMonth = date;
	
	      if (dayOfMonth < 10) {
	        dayOfMonth = '0' + dayOfMonth;
	      }
	
	      // Format the date
	      var formattedDate = this.state.year + '-' + month + '-' + dayOfMonth;
	
	      // Render the list
	      if (availabilities[formattedDate]) {
	        var cleanedAvailabilities = [];
	
	        var baseAvailabilities = availabilities[formattedDate];
	
	        baseAvailabilities = baseAvailabilities.filter(function (obj) {
	          return !obj.excludeDate;
	        });
	
	        cleanedAvailabilities = baseAvailabilities.filter(function (obj) {
	          return obj.override === true;
	        });
	        if (cleanedAvailabilities.length === 0) {
	          cleanedAvailabilities = baseAvailabilities;
	        }
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'ol',
	            { className: 'calendar__slots' },
	            cleanedAvailabilities.map(function (key, i) {
	              if (!key.hide) {
	                return _react2.default.createElement(
	                  'li',
	                  { key: i, className: 'calendar-slot-item' },
	                  (0, _moment2.default)(key.startTime, 'HH:mm:ss').format('h:mma'),
	                  '\u2013',
	                  (0, _moment2.default)(key.endTime, 'HH:mm:ss').format('h:mma'),
	                  key.effectiveNumberOfSeats && _react2.default.createElement(
	                    'div',
	                    null,
	                    _this5.props.translation.capacity,
	                    ' ',
	                    key.effectiveNumberOfSeats
	                  )
	                );
	              }
	
	              return null;
	            })
	          ),
	          !past && _react2.default.createElement(
	            'button',
	            {
	              onClick: function onClick() {
	                return _this5.editAvailability(date, dayOfWeek);
	              }
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'meta' },
	              translation.edit_date.replace('%date%', this.state.year + '-' + this.state.month + '-' + date)
	            )
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'editAvailability',
	    value: function editAvailability(date, dayOfWeek) {
	      var _this6 = this;
	
	      var formattedDate = (0, _moment2.default)(this.state.year + '-' + (this.state.month + 1) + '-' + date, 'YYYY-MM-DD');
	
	      this.setState({
	        editAvailability: true,
	        editAvailabilityDate: formattedDate,
	        editAvailabilityDayOfWeek: [dayOfWeek]
	      }, function () {
	        return _this6.renderAvailabilityList();
	      });
	    }
	  }, {
	    key: 'renderBody',
	    value: function renderBody() {
	      var _this = this;
	
	      var monthstack = void 0,
	          day = void 0,
	          d = void 0,
	          current = void 0,
	          isDate = void 0,
	          className = void 0;
	      var weekstack = Array.apply(null, { length: 7 }).map(Number.call, Number);
	      var startDay = this.state.firstOfMonth.getUTCDay();
	      var first = this.state.firstOfMonth.getDay();
	      var rows = 5;
	      var that = this;
	
	      if (startDay === 5 && this.state.daysInMonth === 31 || startDay === 6 && this.state.daysInMonth > 29) {
	        rows = 6;
	      }
	
	      monthstack = Array.apply(null, { length: rows }).map(Number.call, Number);
	
	      day = this.state.startDay + 1 - first;
	
	      while (day > 1) {
	        day -= 7;
	      }
	
	      day -= 2;
	
	      return _react2.default.createElement(
	        'tbody',
	        null,
	        monthstack.map(function (key, i) {
	          d = day + i * 7;
	
	          if (first === 0) {
	            d = day + (i + 1) * 7;
	          }
	
	          return _react2.default.createElement(
	            'tr',
	            { key: i },
	            weekstack.map(function (key, i) {
	              d += 1;
	
	              isDate = d > 0 && d <= that.state.daysInMonth;
	
	              var dayOfWeek = i % 7;
	
	              if (isDate) {
	                var past = false;
	                current = new Date(that.state.year, that.state.month, d);
	                className = current.toString() !== that.state.today._d.toString() ? 'calendar__day' : 'calendar__day calendar__day--today';
	
	                if ((0, _moment2.default)(current).isBefore((0, _moment2.default)()) && className.indexOf('today') < 0) {
	                  past = true;
	                  className += ' calendar__day--past';
	                }
	
	                return _react2.default.createElement(
	                  'td',
	                  { key: i, className: className },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'calendar__day-number' },
	                      d
	                    ),
	                    _this.renderAvailabilities(d, dayOfWeek, past)
	                  )
	                );
	              }
	
	              if (d < 1) {
	                var prevMonthLength = new Date((0, _moment2.default)().year(), (0, _moment2.default)().month(), 0).getDate();
	                return _react2.default.createElement(
	                  'td',
	                  {
	                    key: i,
	                    className: 'calendar__day calendar__day--outside'
	                  },
	                  prevMonthLength + d
	                );
	              } else {
	                return _react2.default.createElement(
	                  'td',
	                  {
	                    key: i,
	                    className: 'calendar__day calendar__day--outside'
	                  },
	                  d - that.state.daysInMonth
	                );
	              }
	            })
	          );
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this7 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'calendar-wrap' },
	        _react2.default.createElement(
	          'table',
	          { className: 'calendar' },
	          _react2.default.createElement(
	            'caption',
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'calendar__month' },
	              _react2.default.createElement(
	                'h4',
	                { className: 'calendar__month-name' },
	                translation.month_names[this.state.month],
	                ' ',
	                this.state.year
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'calendar__btns' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn--outline',
	                    onClick: this.today
	                  },
	                  translation.today
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'calendar__nav calendar__nav--prev',
	                    onClick: this.prevMonth
	                  },
	                  _react2.default.createElement(icons.iconChevronLeft, null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.prev_month
	                  )
	                ),
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'calendar__nav calendar__nav--next',
	                    onClick: this.nextMonth
	                  },
	                  _react2.default.createElement(icons.iconChevronRight, null),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'meta' },
	                    translation.next_month
	                  )
	                )
	              ),
	              this.state.timeZone && _react2.default.createElement(
	                'h4',
	                { className: 'calendar__month-timezone' },
	                translation.times_shown_in,
	                ' ',
	                this.state.timeZone
	              ),
	              _react2.default.createElement(
	                'ul',
	                { className: 'calendar__tools' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: '/locations/schedule/' + this.props.locationSid + '/calendar/' + this.props.calendarSid,
	                      onClick: function onClick() {
	                        return _this7.props.setStep(2);
	                      }
	                    },
	                    translation.edit
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    {
	                      to: '/locations/schedule/' + this.props.locationSid,
	                      onClick: function onClick() {
	                        return _this7.props.setStep(1);
	                      }
	
	                    },
	                    translation.all
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	              'tr',
	              null,
	              translation.day_names.map(function (key, i) {
	                return _react2.default.createElement(
	                  'th',
	                  {
	                    key: i,
	                    scope: 'col',
	                    className: 'calendar__weekday'
	                  },
	                  _react2.default.createElement(
	                    'abbr',
	                    { title: translation.day_names[i] },
	                    key
	                  )
	                );
	              })
	            )
	          ),
	          this.renderBody()
	        ),
	        this.state.editAvailability && _react2.default.createElement(
	          'div',
	          { className: 'calendar__popup-wrap' },
	          _react2.default.createElement(
	            'div',
	            { className: 'calendar__popup' },
	            _react2.default.createElement(_CustomAvailability2.default, Object.assign({}, this.props, {
	              cleanedAvailabilities: this.state.cleanedAvailabilities,
	              date: this.state.editAvailabilityDate,
	              dayOfWeek: this.state.editAvailabilityDayOfWeek,
	              parent: this,
	              callback: function callback() {
	                _this7.getAvailability();
	              },
	              closeView: function closeView() {
	                _this7.setState({ editAvailability: false });
	              }
	            }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return CalendarView;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('CalendarView')(CalendarView);

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(76);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDatepicker = __webpack_require__(68);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _Availability = __webpack_require__(299);
	
	var _Availability2 = _interopRequireDefault(_Availability);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var CustomAvailability = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(CustomAvailability, _React$Component);
	
	  function CustomAvailability(props) {
	    _classCallCheck(this, CustomAvailability);
	
	    var _this = _possibleConstructorReturn(this, (CustomAvailability.__proto__ || Object.getPrototypeOf(CustomAvailability)).call(this, props));
	
	    _this.state = {
	      numberOfSeats: null,
	      startDate: _this.props.date,
	      endDate: _this.props.date,
	      dayOfWeek: _this.props.dayOfWeek,
	      chooseDate: false
	    };
	    return _this;
	  }
	
	  _createClass(CustomAvailability, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var ScheduleStore, callback;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                ScheduleStore = this.props.store.ScheduleStore;
	
	                callback = function callback(data) {
	                  _this2.setState({ numberOfSeats: data.numberOfSeats });
	                };
	
	                ScheduleStore.getCalendar(this.props.locationSid, this.props.calendarSid, callback);
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'handleDateChange',
	    value: function handleDateChange(date) {
	      var endDate = (0, _moment2.default)(date).format('YYYY-MM-DD');
	
	      // Check if we need to add days of the week
	      var dayOfWeek = [].concat(_toConsumableArray(this.state.dayOfWeek));
	      var filteredDayOfWeek = [];
	      var momentStartDate = (0, _moment2.default)(this.state.startDate);
	      var momentEndDate = (0, _moment2.default)(endDate);
	      var duration = _moment2.default.duration(momentEndDate.diff(momentStartDate)).as('days');
	
	      if (duration > 0) {
	        for (var i = 1; i <= duration && i <= 7; i++) {
	          var newDay = (dayOfWeek[i - 1] + 1) % 7;
	          dayOfWeek.push(newDay);
	        }
	
	        // Remove duplicate days of week
	        filteredDayOfWeek = dayOfWeek.filter(function (value, index, self) {
	          return self.indexOf(value) === index;
	        });
	      }
	
	      this.setState({
	        endDate: endDate,
	        dayOfWeek: filteredDayOfWeek,
	        chooseDate: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: 'calendar__popup-head' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'subdued' },
	            _react2.default.createElement(
	              'strong',
	              { className: 'strong' },
	              (0, _moment2.default)(this.state.startDate).format('MMMM D, YYYY')
	            )
	          ),
	          this.state.chooseDate && _react2.default.createElement(_reactDatepicker2.default, {
	            id: 'enddate',
	            selected: this.state.endDate,
	            onChange: function onChange(date) {
	              return _this3.handleDateChange(date);
	            },
	            minDate: this.state.startDate,
	            placeholderText: translation.date_helper,
	            required: true,
	            'aria-required': 'true',
	            autoFocus: true,
	            ref: function ref(input) {
	              return _this3.endDate = input;
	            }
	          })
	        ),
	        _react2.default.createElement(_Availability2.default, Object.assign({}, this.props, {
	          cleanedAvailabilities: this.props.cleanedAvailabilities,
	          defaultNumberOfSeats: this.state.numberOfSeats,
	          calendar: true,
	          dayOfWeek: this.state.dayOfWeek,
	          startDate: this.state.startDate,
	          endDate: this.state.endDate
	        }))
	      );
	    }
	  }]);
	
	  return CustomAvailability;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('CustomAvailability')(CustomAvailability);

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(17);
	
	var _CalendarList = __webpack_require__(903);
	
	var _CalendarList2 = _interopRequireDefault(_CalendarList);
	
	var _CalendarSettings = __webpack_require__(905);
	
	var _CalendarSettings2 = _interopRequireDefault(_CalendarSettings);
	
	var _CalendarView = __webpack_require__(906);
	
	var _CalendarView2 = _interopRequireDefault(_CalendarView);
	
	var _CalendarSeats = __webpack_require__(904);
	
	var _CalendarSeats2 = _interopRequireDefault(_CalendarSeats);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Components
	
	
	var ScheduleManage = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(ScheduleManage, _React$Component);
	
	  function ScheduleManage() {
	    _classCallCheck(this, ScheduleManage);
	
	    var _this2 = _possibleConstructorReturn(this, (ScheduleManage.__proto__ || Object.getPrototypeOf(ScheduleManage)).call(this));
	
	    _this2.state = {
	      step: 1
	      // Bind this to functions
	    };_this2.setStep = _this2.setStep.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(ScheduleManage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	      var _props$store = this.props.store,
	          ScheduleStore = _props$store.ScheduleStore,
	          SessionStore = _props$store.SessionStore;
	
	      var locationSid = (0, _helpers.getURLSegment)(this, 3);
	
	      this.setState({ locationSid: locationSid });
	
	      // Wait for schedule locations to be retrieved
	      var locationDelay = setInterval(function () {
	        if (!SessionStore.loading) {
	          clearInterval(locationDelay);
	          ScheduleStore.setScheduleLocation(locationSid);
	        }
	      }, 100);
	
	      if ((0, _helpers.getURLSegment)(this, 4) === 'calendar') {
	        // Editing a calendar
	        var calendarSid = (0, _helpers.getURLSegment)(this, 5);
	
	        this.setState({
	          step: 2,
	          calendarSid: calendarSid
	        });
	      } else if ((0, _helpers.getURLSegment)(this, 4) === 'view') {
	        // Editing a calendar
	        var _calendarSid = (0, _helpers.getURLSegment)(this, 5);
	
	        this.setState({
	          step: 3,
	          calendarSid: _calendarSid
	        });
	      }
	    }
	  }, {
	    key: 'setStep',
	    value: function setStep(step) {
	      this.setState({
	        step: step
	      });
	
	      if (step === 1) {
	        var baseUrl = '/' + (0, _helpers.getURLSegment)(this, 1) + '/' + (0, _helpers.getURLSegment)(this, 2) + '/' + (0, _helpers.getURLSegment)(this, 3);
	
	        this.props.routing.history.push(baseUrl);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	      var ScheduleStore = this.props.store.ScheduleStore;
	      var scheduleLocation = ScheduleStore.scheduleLocation;
	
	
	      if (scheduleLocation) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading.replace('%location%', scheduleLocation.title)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            this.state.step === 1 && this.state.locationSid && _react2.default.createElement(_CalendarList2.default, Object.assign({}, this.props, {
	              locationSid: this.state.locationSid,
	              setStep: this.setStep
	            })),
	            this.state.step === 2 && _react2.default.createElement(_CalendarSettings2.default, Object.assign({}, this.props, {
	              locationSid: this.state.locationSid,
	              calendarSid: (0, _helpers.getURLSegment)(this, 5),
	              setStep: this.setStep
	            })),
	            this.state.step === 3 && _react2.default.createElement(_CalendarView2.default, Object.assign({}, this.props, {
	              locationSid: this.state.locationSid,
	              calendarSid: (0, _helpers.getURLSegment)(this, 5),
	              setStep: this.setStep
	            })),
	            this.state.step === 4 && _react2.default.createElement(_CalendarSeats2.default, {
	              locationSid: this.state.locationSid,
	              store: this.props.store,
	              setStep: this.setStep
	            })
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return ScheduleManage;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('ScheduleManage')(ScheduleManage);

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _helpers = __webpack_require__(17);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var SeatSettings = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SeatSettings, _React$Component);
	
	  function SeatSettings() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SeatSettings);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SeatSettings.__proto__ || Object.getPrototypeOf(SeatSettings)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      seatName: "",
	      seatDescription: "",
	      autoAssign: true,
	      priority: null,
	      calendars: _this.props.calendars.map(function (calendar) {
	        return calendar.sid;
	      })
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SeatSettings, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      var _props = this.props,
	          seats = _props.seats,
	          seatSid = _props.seatSid;
	
	
	      if (seatSid) {
	        // I know this is gross but this is the only way that I know to create a deep copy of an object.
	        // Before using the JSON methods this would update the seat view in the background while
	        // changing settings before saving your choices
	        var seat = JSON.parse(JSON.stringify(seats.find(function (seat) {
	          return seat.sid === seatSid;
	        })));
	
	        this.setState({
	          seatName: seat.title,
	          seatDescription: seat.description,
	          autoAssign: seat.autoAssign,
	          priority: seat.autoAssignPriority,
	          calendars: seat.calendarSids
	        });
	      }
	    }
	  }, {
	    key: "handleAssociatedCalendar",
	    value: function handleAssociatedCalendar(calendarSid) {
	      var index = this.state.calendars.findIndex(function (calendar) {
	        return calendar === calendarSid;
	      });
	
	      if (index === -1) {
	        this.setState({ calendars: [].concat(_toConsumableArray(this.state.calendars), [calendarSid]) });
	      } else {
	        var newArr = this.state.calendars;
	        newArr.splice(index, 1);
	
	        this.setState({ calendars: newArr });
	      }
	    }
	  }, {
	    key: "handlePriority",
	    value: function handlePriority(e) {
	      if (e.target.value > 999) {
	        e.target.value = 999;
	      }
	
	      var priority = parseInt(e.target.value, 10);
	
	      if (isNaN(priority)) {
	        this.setState({ priority: null });
	      } else {
	        this.setState({ priority: priority });
	      }
	    }
	  }, {
	    key: "handleSubmit",
	    value: function handleSubmit(e, closeSettings) {
	      var _this2 = this;
	
	      e.preventDefault();
	      var _state = this.state,
	          seatName = _state.seatName,
	          seatDescription = _state.seatDescription,
	          autoAssign = _state.autoAssign,
	          priority = _state.priority,
	          calendars = _state.calendars;
	      var _props2 = this.props,
	          close = _props2.close,
	          seatSid = _props2.seatSid,
	          store = _props2.store;
	      var ScheduleStore = store.ScheduleStore;
	
	
	      var payload = {
	        title: seatName,
	        description: seatDescription,
	        autoAssign: autoAssign,
	        autoAssignPriority: priority || null,
	        calendarSids: calendars
	      };
	
	      if (seatSid) {
	        ScheduleStore.updateSeat(payload, seatSid, close);
	      } else {
	        var callback = function callback() {
	          _this2.setState({
	            seatName: "",
	            seatDescription: "",
	            autoAssign: true,
	            priority: '',
	            calendars: []
	          });
	
	          if (!closeSettings) {
	            document.getElementById("seat-settings-form").reset();
	
	            // Auto assign should be on by default
	            document.getElementById("auto-assign").click();
	            _this2.setState({ autoAssign: true });
	          }
	        };
	
	        ScheduleStore.addSeat(payload, callback);
	      }
	
	      if (closeSettings) {
	        close();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          seatSid = _props3.seatSid,
	          close = _props3.close,
	          calendars = _props3.calendars,
	          translation = _props3.translation;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "dialog" },
	        _react2.default.createElement(
	          "div",
	          { className: "dialog__content" },
	          _react2.default.createElement(
	            "strong",
	            { className: "dialog__msg" },
	            seatSid ? translation.edit : translation.add
	          ),
	          _react2.default.createElement(
	            "button",
	            { className: "panel__close panel__close-alt", onClick: close },
	            _react2.default.createElement(icons.iconTimes, null),
	            _react2.default.createElement(
	              "span",
	              { className: "meta" },
	              translation.cancel
	            )
	          ),
	          _react2.default.createElement(
	            "form",
	            {
	              onSubmit: function onSubmit(e) {
	                return (0, _helpers.checkValidity)(e, _this3.handleSubmit);
	              },
	              id: "seat-settings-form"
	            },
	            _react2.default.createElement(
	              "fieldset",
	              null,
	              _react2.default.createElement(
	                "ul",
	                { className: "fields" },
	                _react2.default.createElement(
	                  "li",
	                  { className: "field--full" },
	                  _react2.default.createElement(
	                    "label",
	                    { className: "lbl-required", htmlFor: "seat-name" },
	                    translation.name
	                  ),
	                  _react2.default.createElement("input", {
	                    id: "seat-name",
	                    type: "text",
	                    onChange: function onChange(e) {
	                      return _this3.setState({ seatName: e.target.value });
	                    },
	                    defaultValue: this.state.seatName,
	                    required: true,
	                    "aria-required": "true"
	                  })
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "field--full" },
	                  _react2.default.createElement(
	                    "label",
	                    { htmlFor: "seat-description" },
	                    translation.description
	                  ),
	                  _react2.default.createElement("input", {
	                    id: "seat-description",
	                    type: "text",
	                    onChange: function onChange(e) {
	                      return _this3.setState({ seatDescription: e.target.value });
	                    },
	                    defaultValue: this.state.seatDescription
	                  })
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "field--full" },
	                  _react2.default.createElement(
	                    "label",
	                    { className: "switch-label--alt", htmlFor: "auto-assign" },
	                    translation.auto_assign
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "checkbox",
	                    id: "auto-assign",
	                    className: "switch-input",
	                    value: this.state.autoAssign,
	                    defaultChecked: this.state.autoAssign,
	                    onChange: function onChange() {
	                      return _this3.setState({ autoAssign: !_this3.state.autoAssign });
	                    }
	                  }),
	                  _react2.default.createElement(
	                    "label",
	                    { className: "switch-label", htmlFor: "auto-assign" },
	                    _react2.default.createElement(
	                      "span",
	                      { className: "meta" },
	                      "Auto Assign"
	                    )
	                  ),
	                  this.state.autoAssign && _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                      "label",
	                      { htmlFor: "priority" },
	                      translation.priority
	                    ),
	                    _react2.default.createElement("input", {
	                      id: "priority",
	                      type: "number",
	                      value: this.state.priority || '',
	                      min: "1",
	                      max: "999",
	                      onChange: function onChange(e) {
	                        return _this3.handlePriority(e);
	                      }
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "field--full" },
	                  _react2.default.createElement(
	                    "h4",
	                    null,
	                    translation.calendars
	                  ),
	                  calendars.length === 0 && _react2.default.createElement(
	                    "p",
	                    null,
	                    translation.no_results
	                  ),
	                  calendars.length > 0 && calendars.map(function (calendar, i) {
	                    return _react2.default.createElement(
	                      "div",
	                      { key: "calender-" + i },
	                      _react2.default.createElement("input", {
	                        type: "checkbox",
	                        id: "calender-" + calendar.sid,
	                        className: "switch-input",
	                        value: _this3.state.calendars.some(function (calendarSid) {
	                          return calendar.sid === calendarSid;
	                        }) || !_this3.props.seatSid,
	                        defaultChecked: _this3.state.calendars.some(function (calendarSid) {
	                          return calendar.sid === calendarSid;
	                        }) || !_this3.props.seatSid,
	                        onChange: function onChange() {
	                          return _this3.handleAssociatedCalendar(calendar.sid);
	                        }
	                      }),
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "switch-label",
	                          htmlFor: "calender-" + calendar.sid
	                        },
	                        _react2.default.createElement(
	                          "span",
	                          { className: "meta" },
	                          calendar.title
	                        )
	                      ),
	                      _react2.default.createElement(
	                        "label",
	                        {
	                          className: "switch-label--alt",
	                          htmlFor: "calender-" + calendar.sid
	                        },
	                        calendar.title || "Calendar " + i
	                      )
	                    );
	                  })
	                )
	              ),
	              !this.props.seatSid && _react2.default.createElement(
	                "div",
	                { className: "btn-group" },
	                _react2.default.createElement(
	                  "button",
	                  {
	                    className: "btn",
	                    onClick: function onClick(e) {
	                      return _this3.handleSubmit(e, true);
	                    }
	                  },
	                  translation.save
	                ),
	                _react2.default.createElement(
	                  "button",
	                  {
	                    className: "btn",
	                    onClick: function onClick(e) {
	                      return _this3.handleSubmit(e, false);
	                    }
	                  },
	                  translation.save,
	                  translation.new
	                )
	              ),
	              this.props.seatSid && _react2.default.createElement(
	                "button",
	                {
	                  className: "btn",
	                  onClick: function onClick(e) {
	                    return _this3.handleSubmit(e, true);
	                  }
	                },
	                translation.save
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SeatSettings;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SeatSettings')(SeatSettings);

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var SessionExpired = function (_React$Component) {
	  _inherits(SessionExpired, _React$Component);
	
	  function SessionExpired() {
	    _classCallCheck(this, SessionExpired);
	
	    return _possibleConstructorReturn(this, (SessionExpired.__proto__ || Object.getPrototypeOf(SessionExpired)).apply(this, arguments));
	  }
	
	  _createClass(SessionExpired, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page page--error wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'i',
	            { className: 'page--error__icon' },
	            _react2.default.createElement(icons.iconClock, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'panel__title' },
	              translation.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.message
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SessionExpired;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('SessionExpired')(SessionExpired);

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _LoadMore = __webpack_require__(289);
	
	var _LoadMore2 = _interopRequireDefault(_LoadMore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var PendingSessionList = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(PendingSessionList, _React$Component);
	
	  function PendingSessionList() {
	    _classCallCheck(this, PendingSessionList);
	
	    return _possibleConstructorReturn(this, (PendingSessionList.__proto__ || Object.getPrototypeOf(PendingSessionList)).apply(this, arguments));
	  }
	
	  _createClass(PendingSessionList, [{
	    key: 'viewMessage',
	    value: function viewMessage(messageThreadSid) {
	      var _this = this;
	
	      this.props.parent.setState({
	        messageThreadSid: messageThreadSid
	      }, function () {
	        (0, _helpers.toggleDrawer)(null, _this.props.parent, 'MessageThread');
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store = this.props.store,
	          ScheduleStore = _props$store.ScheduleStore,
	          SessionStore = _props$store.SessionStore;
	      var pendingNext = ScheduleStore.pendingNext,
	          pendingSessions = ScheduleStore.pendingSessions;
	
	
	      if (SessionStore.backgroundLoadingCalls.indexOf('GetPendingSessions') < 0 && ScheduleStore.pendingSessions.length > 0) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-student', className: 'subtitle', scope: 'col' },
	                  translation.student
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-exam', className: 'subtitle', scope: 'col' },
	                  translation.exam
	                ),
	                this.props.type === 'pending' && _react2.default.createElement(
	                  'th',
	                  { id: 'heading-accepted', className: 'subtitle', scope: 'col' },
	                  translation.accepted_date
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-date', className: 'subtitle', scope: 'col' },
	                  translation['date_' + this.props.type]
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { id: 'heading-view', className: 'subtitle', scope: 'col' },
	                  translation.view
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              ScheduleStore.pendingSessions.map(function (session, i) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: i },
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-student' },
	                    session.candidate.firstName,
	                    ' ',
	                    session.candidate.lastName
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-exam' },
	                    session.exam.title
	                  ),
	                  _this3.props.type === 'pending' && _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-accepted' },
	                    (0, _moment2.default)(session.request.confirmedDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY h:mma z')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { 'aria-labelledby': 'heading-date' },
	                    _this3.props.type === 'request' && (0, _moment2.default)(session.request.createdDate).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY h:mma z'),
	                    _this3.props.type === 'pending' && (0, _moment2.default)(session.request.confirmedDateExpiration).local().tz(_moment2.default.tz.guess()).format('M/D/YYYY h:mma z')
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { className: 'actions', 'aria-labelledby': 'heading-view' },
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        className: 'btn--outline',
	                        onClick: function onClick() {
	                          return _this3.viewMessage(session.request.messageThreadSid);
	                        }
	                      },
	                      translation.view_message
	                    )
	                  )
	                );
	              })
	            )
	          ),
	          pendingNext && _react2.default.createElement(_LoadMore2.default, Object.assign({
	            url: pendingNext,
	            group: pendingSessions,
	            text: 'Load more pending sessions'
	          }, this.props))
	        );
	      } else if (SessionStore.backgroundLoadingCalls.indexOf('GetPendingSessions') >= 0) {
	        return _react2.default.createElement(
	          'span',
	          { className: 'loader-bar' },
	          'Loading\u2026'
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation['no_results_' + this.props.type]
	        );
	      }
	    }
	  }]);
	
	  return PendingSessionList;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('PendingSessionList')(PendingSessionList);

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _config = __webpack_require__(24);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SmarterElements = (0, _config.getSmarterElementsInstance)();
	
	// Translations
	
	
	// Components
	
	var SessionPlayer = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionPlayer, _React$Component);
	
	  function SessionPlayer() {
	    _classCallCheck(this, SessionPlayer);
	
	    return _possibleConstructorReturn(this, (SessionPlayer.__proto__ || Object.getPrototypeOf(SessionPlayer)).apply(this, arguments));
	  }
	
	  _createClass(SessionPlayer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {};
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var SessionStore = this.props.store.SessionStore;
	      var userSid = SessionStore.userData.userSid;
	      var token = SessionStore.token;
	
	      var examSession = this.props.session;
	
	      var SessionViewer = null;
	
	      // get the position of the session viewer container
	      // wait for the dom to be ready
	      //document.addEventListener('DOMContentLoaded', function() {
	      if (this && this.refs && this.refs["v3-container"] && SmarterElements) {
	        var resizeContainer = function resizeContainer() {
	
	          var scontainer = document.getElementById('v3-container');
	          var containerRect = scontainer.getBoundingClientRect();
	
	          var containerTop = containerRect.top + 10;
	          // get the px amoutn for the vh
	          var vh = window.innerHeight;
	          scontainer.style.height = vh - containerTop + 'px';
	
	          if (SessionViewer) {
	            SessionViewer.updateConstraints({
	              maxHeight: vh - containerTop
	            });
	            SessionViewer.recalculateSize();
	          }
	        };
	
	        resizeContainer();
	
	        // ensure that the resizing is performat...
	        var debouncedResize = window.SmarterElements.throttle(function () {
	          resizeContainer();
	        }, 250);
	
	        // add a lisenter that will run on document resize to resize the contaner
	        window.addEventListener('resize', debouncedResize);
	      }
	
	      // Create a session viewer
	      var viewerProperties = {
	        sessionSid: examSession.sid,
	        installSid: examSession.installSid,
	        examSid: examSession.examSid,
	        token: token,
	        identity: userSid,
	        viewMode: 'instructor',
	        allowPopout: true,
	        enabledComponents: {
	          controls: true,
	          sessionDetails: {
	            tabs: ['info', 'identity', 'flags', 'communication', 'incidentReport']
	          },
	
	          annotations: true,
	          timeline: true
	        },
	        elementId: 'v3-container',
	        autoResize: true,
	        resizeOffset: 10
	      };
	
	      SessionViewer = SmarterElements.create('proctoring/session-viewer', viewerProperties);
	      SessionViewer.mount(this.refs["v3-container"]);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	          'style',
	          null,
	          '\n            .drawer__close {\n                margin-right: 15px;\n            }\n            '
	        ),
	        _react2.default.createElement('div', { id: 'v3-container', ref: 'v3-container', style: { width: '100%', height: 'calc(100vh - 82px)', marginTop: '20px' } })
	      );
	    }
	  }]);
	
	  return SessionPlayer;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionPlayer')(SessionPlayer);

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactdatagridCommunity = __webpack_require__(146);
	
	var _reactdatagridCommunity2 = _interopRequireDefault(_reactdatagridCommunity);
	
	__webpack_require__(330);
	
	__webpack_require__(331);
	
	var _DateFilter = __webpack_require__(207);
	
	var _DateFilter2 = _interopRequireDefault(_DateFilter);
	
	var _SelectFilter = __webpack_require__(575);
	
	var _SelectFilter2 = _interopRequireDefault(_SelectFilter);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _mobxReact = __webpack_require__(9);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _config = __webpack_require__(24);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _helpers = __webpack_require__(17);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _ReportStore = __webpack_require__(117);
	
	var _ReportStore2 = _interopRequireDefault(_ReportStore);
	
	var _ScheduleStore = __webpack_require__(75);
	
	var _ScheduleStore2 = _interopRequireDefault(_ScheduleStore);
	
	var _IncidentForm = __webpack_require__(300);
	
	var _IncidentForm2 = _interopRequireDefault(_IncidentForm);
	
	var _ManagerStore = __webpack_require__(307);
	
	var _ManagerStore2 = _interopRequireDefault(_ManagerStore);
	
	var _iamReactClient = __webpack_require__(58);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var filterValue = [{ name: 'exam.title', operator: 'contains', type: 'string', value: '' }, { name: 'status', operator: 'contains', type: 'select', value: 'Scheduled' }, { name: 'appointmentDate', operator: 'equals', type: 'date', value: '' }, { name: 'location.type.type', operator: 'equals', type: 'select', value: '' }, { name: 'exam.type', operator: 'equals', type: 'select', value: '' }, { name: 'name', operator: 'contains', type: 'string', value: '' }, { name: 'enrollment.email', operator: 'contains', type: 'string', value: '' }, { name: 'course.instructor.email', operator: 'contains', type: 'string', value: '' }, { name: 'course.instructor.name', operator: 'contains', type: 'string', value: '' }, { name: 'course.code', operator: 'contains', type: 'string', value: '' }, { name: 'course.title', operator: 'contains', type: 'string', value: '' }, { name: 'course.offering.title', operator: 'contains', type: 'string', value: '' }, { name: 'location.name', operator: 'contains', type: 'string', value: '' }, { name: 'appointment.seat.title', operator: 'contains', type: 'string', value: '' }];
	var statuses = [{ label: "Scheduled", id: "Scheduled" }, { label: "Cancelled", id: "Cancelled" }, { label: "Closed", id: "Closed" }, { label: "Checked In", id: "Checked In" }, { label: "In Progress", id: "In Progress" }];
	var sessionTypes = [{ label: "In Person", id: "in-person" }, { label: "Live Virtual", id: "online" }];
	var examTypes = [{ label: "Written", id: "Written" }, { label: "Computer Based", id: "Online" }];
	var gridStyle = { minHeight: 500 };
	
	var Sessions = (0, _mobxReact.observer)(function (props) {
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      skip = _useState2[0],
	      setSkip = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(50),
	      _useState4 = _slicedToArray(_useState3, 2),
	      limit = _useState4[0],
	      setLimit = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(filterValue),
	      _useState6 = _slicedToArray(_useState5, 2),
	      filterObject = _useState6[0],
	      setFilterObject = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      drawerOpen = _useState8[0],
	      setDrawerOpen = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      session = _useState10[0],
	      setSession = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      update = _useState12[0],
	      setUpdate = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(null),
	      _useState14 = _slicedToArray(_useState13, 2),
	      sort = _useState14[0],
	      setSort = _useState14[1];
	
	  var columns = [{
	    name: 'sid',
	    header: 'Id',
	    defaultVisible: false,
	    type: 'number',
	    defaultWidth: 50
	  }, {
	    name: 'name',
	    header: "Student",
	    type: 'string',
	    defaultFlex: .5,
	    render: function render(_ref) {
	      var data = _ref.data;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        data.enrollment.firstName,
	        ' ',
	        data.enrollment.lastName
	      );
	    },
	    enableColumnFilterContextMenu: false
	  }, {
	    name: 'appointmentDate',
	    header: 'Start Date',
	    filterEditor: _DateFilter2.default,
	    dateFormat: 'MM/DD/YYYY',
	    render: function render(_ref2) {
	      var data = _ref2.data;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        (0, _moment2.default)(data.appointmentDate).format('MM/D/YYYY')
	      );
	    },
	    enableColumnFilterContextMenu: false
	  }, {
	    name: 'startTime',
	    header: 'Start Time',
	    type: 'string',
	    render: function render(_ref3) {
	      var data = _ref3.data;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        (0, _moment2.default)(data.appointmentDate).format('hh:mm A')
	      );
	    }
	  }, {
	    name: 'exam.title',
	    header: 'Exam Title',
	    defaultFlex: 1,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref4) {
	      var data = _ref4.data;
	
	      if (data.exam) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          data.exam.title
	        );
	      }
	    }
	  }, {
	    name: 'status',
	    header: 'Status',
	    filterEditor: _SelectFilter2.default,
	    filterEditorProps: {
	      placeholder: 'All',
	      dataSource: statuses
	    },
	    enableColumnFilterContextMenu: false
	  }, {
	    name: 'location.type.type',
	    header: 'Session Type',
	    filterEditor: _SelectFilter2.default,
	    filterEditorProps: {
	      placeholder: 'All',
	      dataSource: sessionTypes
	    },
	    render: function render(_ref5) {
	      var data = _ref5.data;
	
	      var type = data.location.type.type;
	      //Reg ex to capitalize the first letter of each word in this case it would be in-person or online(and remove hyphens)
	      type = type.replace(/\b\w/g, function (char) {
	        return char.toUpperCase();
	      });
	      type = type.replace(/-/g, ' ');
	
	      if (type === "Online") {
	        return _react2.default.createElement(
	          'span',
	          null,
	          'Live Virtual'
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          null,
	          type
	        );
	      }
	    },
	    enableColumnFilterContextMenu: false
	
	  }, {
	
	    name: 'examConfiguration.type',
	    header: 'Accommodation',
	    render: function render(_ref6) {
	      var data = _ref6.data;
	
	      if (data.examConfiguration.type === 'accommodation') {
	        return _react2.default.createElement(icons.iconCheck, null);
	      } else {
	        return _react2.default.createElement(icons.iconTimes, null);
	      }
	    },
	    enableColumnFilterContextMenu: false,
	    sortable: false
	  }, {
	    name: 'course.instructor.email',
	    header: 'Instructor Email',
	    defaultVisible: false,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref7) {
	      var data = _ref7.data;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        data.course.instructor.email
	      );
	    }
	  }, {
	    name: 'course.instructor.name',
	    header: 'Instructor Name',
	    defaultFlex: 1,
	    defaultVisible: false,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref8) {
	      var data = _ref8.data;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        data.course.instructor.firstName,
	        ' ',
	        data.course.instructor.lastName
	      );
	    }
	  }, {
	    name: 'enrollment.email',
	    header: 'Tester\'s Email',
	    defaultVisible: false,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref9) {
	      var data = _ref9.data;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        data.enrollment.email
	      );
	    }
	  }, {
	    name: 'course.title',
	    header: 'Course Name',
	    defaultVisible: false,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref10) {
	      var data = _ref10.data;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        data.course.title
	      );
	    }
	  }, {
	    name: 'configuration.examOpenDate',
	    header: 'Exam Open/Close',
	    defaultVisible: false,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref11) {
	      var data = _ref11.data;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        (0, _moment2.default)(data.examConfiguration.examOpenDate).format('MM/DD/YYYY'),
	        ' - ',
	        (0, _moment2.default)(data.examConfiguration.examCloseDate).format('MM/DD/YYYY')
	      );
	    }
	  }, {
	    name: 'configuration.duration',
	    header: 'Exam Duration',
	    defaultVisible: false,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref12) {
	      var data = _ref12.data;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        data.examConfiguration.duration
	      );
	    }
	  }, {
	    name: 'course.code',
	    header: 'Course Code',
	    defaultVisible: false,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref13) {
	      var data = _ref13.data;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        data.course.code
	      );
	    }
	  }, {
	    name: 'exam.type',
	    header: 'Exam Type',
	    defaultVisible: false,
	    enableColumnFilterContextMenu: false,
	    filterEditor: _SelectFilter2.default,
	    filterEditorProps: {
	      placeholder: 'All',
	      dataSource: examTypes
	    },
	    render: function render(_ref14) {
	      var data = _ref14.data;
	
	      if (data.exam) {
	        if (data.exam.type === "Online") {
	          return _react2.default.createElement(
	            'span',
	            null,
	            'Computer Based'
	          );
	        } else {
	          return _react2.default.createElement(
	            'span',
	            null,
	            data.exam.type
	          );
	        }
	      }
	    }
	  }, {
	    name: 'course.offering.title',
	    header: 'Course Offering',
	    defaultVisible: false,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref15) {
	      var data = _ref15.data;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        data.course.offering.title
	      );
	    }
	  }, {
	    name: 'location.name',
	    header: 'Proctoring Location',
	    defaultVisible: false,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref16) {
	      var data = _ref16.data;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        data.location.name
	      );
	    }
	  }, {
	    name: 'appointment.seat.title',
	    header: 'Seat',
	    defaultFlex: 1,
	    defaultVisible: false,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref17) {
	      var data = _ref17.data;
	
	      if (data.appointment && data.appointment.seat) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          data.appointment.seat.title
	        );
	      }
	    }
	  }, {
	    name: 'sessionReportCount',
	    header: 'Incidents',
	    defaultVisible: false,
	    enableColumnFilterContextMenu: false,
	    render: function render(_ref18) {
	      var data = _ref18.data;
	
	      if (data.sessionReportCount > 0) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          data.sessionReportCount
	        );
	      }
	    }
	  }];
	
	  var completeIncident = function completeIncident() {
	    var _props$store = props.store,
	        ManagerStore = _props$store.ManagerStore,
	        SessionStore = _props$store.SessionStore;
	
	    ManagerStore.reportIncident = false;
	    SessionStore.showToaster("Incident Saved", 'success');
	  };
	
	  var formatAppointmentDate = function formatAppointmentDate(date) {
	    var addDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var dateString = (0, _moment2.default)(date).format('YYYY-MM-DD HH:mm');
	    var timezoneString = (0, _moment2.default)(date).local().tz(_moment2.default.tz.guess()).format('Z');
	    var newDate = _moment2.default.utc(dateString + ' ' + timezoneString, 'YYYY-MM-DD HH:mm Z').tz(_moment2.default.tz.guess()).toISOString();
	
	    if (addDay) {
	      return (0, _moment2.default)(newDate).add(1, 'd').toISOString();
	    } else return newDate;
	  };
	
	  var loadData = function loadData(_ref19) {
	    var skip = _ref19.skip,
	        limit = _ref19.limit;
	
	    setLimit(limit);
	    setSkip(skip);
	    var query = '?limit=' + limit;
	    filterObject.map(function (object) {
	      if (object.value && object.value.length > 0) {
	        switch (object.name) {
	          case "appointmentDate":
	            query += '&appointmentStartDate=' + formatAppointmentDate(object.value) + '&appointmentEndDate=' + formatAppointmentDate(object.value, true);
	            break;
	          case "configuration.examOpenDate":
	            query += '&examOpenDate=' + object.value;
	            break;
	          case "configuration.examCloseDate":
	            query += '&examCloseDate=' + object.value;
	            break;
	          case "status":
	            query += '&status=' + object.value;
	            break;
	          case "location.type.type":
	            query += '&locationType=' + object.value;
	            break;
	          case "name":
	            query += '&name=' + object.value;
	            break;
	          case "exam.title":
	            query += '&examTitle=' + object.value;
	            break;
	          case "exam.type":
	            query += '&examType=' + object.value;
	            break;
	          case "course.instructor.name":
	            query += '&instructorName=' + object.value;
	            break;
	          case "course.code":
	            query += '&courseCode=' + object.value;
	            break;
	          case "course.instructor.email":
	            query += '&instructorEmail=' + object.value;
	            break;
	          case "course.title":
	            query += '&courseTitle=' + object.value;
	            break;
	          case "course.offering.title":
	            query += '&courseOffering=' + object.value;
	            break;
	          case "enrollment.email":
	            query += '&testerEmail=' + object.value;
	            break;
	          case "location.name":
	            query += '&locationName=' + object.value;
	            break;
	          case "appointment.seat.title":
	            query += '&seatName=' + object.value;
	            break;
	          default:
	            break;
	        }
	      }
	      return null;
	    });
	    var url = '/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/sessions' + query;
	    if (sort) {
	      var sortDirection = sort.dir === 1 ? 'asc' : 'desc';
	      var columnName = sort.columnName;
	
	      url += '&sort=' + columnName + '&sortDir=' + sortDirection;
	    }
	    _ReportStore2.default.reportUrl = url;
	    url += '&offset=' + skip;
	    return _config.api.get(url).then(function (response) {
	      return { data: response.data.results, count: response.data.total };
	    });
	  };
	
	  var dataSource = (0, _react.useCallback)(loadData, [skip, filterObject, limit, _ScheduleStore2.default.session, update, sort]);
	
	  var onRowClick = function onRowClick(rowProps, event) {
	
	    setSession(rowProps.data.sid);
	    _ScheduleStore2.default.getSingleSession(rowProps.data.sid);
	    setDrawerOpen(true);
	    (0, _helpers.toggleDrawer)(null, null, 'SessionDetail');
	  };
	  var exportCSV = function exportCSV() {
	    var SessionStore = props.store.SessionStore;
	
	
	    SessionStore.exportSessionsCSV();
	  };
	
	  (0, _react.useEffect)(function () {
	    var proctorAccountSid = _SessionStore2.default.userData.proctorAccountSid;
	
	    var iam = sessionStorage.getItem('iam');
	
	    if (!(0, _iamReactClient.isAuthorized)('sp:DescribeExamSessions', 'ssrn:ss:sp::' + proctorAccountSid + ':session', iam)) {
	      props.routing.history.push('/unauthorized');
	    }
	  }, []);
	
	  return _react2.default.createElement(
	    'main',
	    { tabIndex: '0', id: 'main-content', className: 'page fill' },
	    _react2.default.createElement(
	      'div',
	      { className: 'fill' },
	      _react2.default.createElement(
	        'div',
	        { 'class': 'split-row-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'left' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Sessions'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Click on any session\'s row to view its details'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'right' },
	          _react2.default.createElement(
	            'button',
	            { className: 'btn--outline ', onClick: exportCSV },
	            'Export CSV'
	          )
	        )
	      ),
	      session && drawerOpen && _react2.default.createElement(_Drawer2.default, Object.assign({
	        content: 'SessionDetail',
	        isOpen: drawerOpen,
	        parent: undefined,
	        sessionSid: session,
	        noInteract: false,
	        callback: function callback() {
	          return setDrawerOpen(false);
	        },
	        timeline: true,
	        refreshEvents: function refreshEvents() {
	          return setUpdate(!update);
	        }
	      }, props)),
	      _react2.default.createElement(_reactdatagridCommunity2.default, {
	        className: 'reactDataGrid fill',
	        style: gridStyle,
	        idProperty: 'id',
	        columns: columns,
	        dataSource: dataSource,
	        defaultFilterValue: filterValue,
	        onFilterValueChange: setFilterObject,
	        onSortInfoChange: setSort,
	        onSkipChange: setSkip,
	        onLimitChange: setLimit,
	        limit: limit,
	        skip: skip,
	        onRowClick: onRowClick,
	        pagination: true
	
	      })
	    ),
	    _ManagerStore2.default.reportIncident && session && _react2.default.createElement(
	      'div',
	      { className: 'session-interact  ' + (_ManagerStore2.default.reportIncident ? 'active' : '') },
	      _react2.default.createElement(
	        'div',
	        { className: 'panel--brief --xlarge' },
	        _react2.default.createElement(_IncidentForm2.default, Object.assign({
	          installSid: session.installSid,
	          examSid: session.examSid,
	          complete: completeIncident
	        }, props))
	      )
	    )
	  );
	});exports.default = Sessions;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _PendingSessions = __webpack_require__(301);
	
	var _PendingSessions2 = _interopRequireDefault(_PendingSessions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var SessionsPending = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SessionsPending, _React$Component);
	
	  function SessionsPending() {
	    _classCallCheck(this, SessionsPending);
	
	    return _possibleConstructorReturn(this, (SessionsPending.__proto__ || Object.getPrototypeOf(SessionsPending)).apply(this, arguments));
	  }
	
	  _createClass(SessionsPending, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        messageThreadSid: null
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(_PendingSessions2.default, Object.assign({
	            parent: this,
	            root: true
	          }, this.props))
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this,
	          messageSid: this.state.messageThreadSid,
	          pending: true
	        }, this.props))
	      );
	    }
	  }]);
	
	  return SessionsPending;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SessionsPending')(SessionsPending);

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _UserSettings = __webpack_require__(916);
	
	var _UserSettings2 = _interopRequireDefault(_UserSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var Settings = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Settings, _React$Component);
	
	  function Settings(props) {
	    _classCallCheck(this, Settings);
	
	    var _this = _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).call(this, props));
	
	    _this.state = {
	      pageContent: null
	    };
	    return _this;
	  }
	
	  _createClass(Settings, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      // Determine which settings page to show
	      if (this.props.content === 'User') {
	        this.setState({
	          pageContent: _react2.default.createElement(_UserSettings2.default, this.props)
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(
	            'header',
	            { className: 'page__header' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            )
	          ),
	          this.state.pageContent
	        )
	      );
	    }
	  }]);
	
	  return Settings;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Settings')(Settings);

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _config = __webpack_require__(24);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _reactTabs = __webpack_require__(79);
	
	var _reactLaunchDarkly = __webpack_require__(60);
	
	var _PhotoUpload = __webpack_require__(294);
	
	var _PhotoUpload2 = _interopRequireDefault(_PhotoUpload);
	
	var _Password = __webpack_require__(165);
	
	var _Password2 = _interopRequireDefault(_Password);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var UserSettings = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(UserSettings, _React$Component);
	
	  function UserSettings() {
	    _classCallCheck(this, UserSettings);
	
	    var _this = _possibleConstructorReturn(this, (UserSettings.__proto__ || Object.getPrototypeOf(UserSettings)).call(this));
	
	    _this.handleTabs = _this.handleTabs.bind(_this);
	    _this.handleInput = _this.handleInput.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handlePhotoSubmit = _this.handlePhotoSubmit.bind(_this);
	    _this.handlePasswordSubmit = _this.handlePasswordSubmit.bind(_this);
	    _this.handleSchedulingSubmit = _this.handleSchedulingSubmit.bind(_this);
	    _this.resetPhoto = _this.resetPhoto.bind(_this);
	    _this.complete = _this.complete.bind(_this);
	    _this.renderScheduleTab = _this.renderScheduleTab.bind(_this);
	    _this.renderNoScheduleTab = _this.renderNoScheduleTab.bind(_this);
	    return _this;
	  }
	
	  _createClass(UserSettings, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          ScheduleStore = _props$store.ScheduleStore,
	          SessionStore = _props$store.SessionStore;
	
	
	      this.state = {
	        attachment: [],
	        activeTab: 1,
	        existingImage: [],
	        oldImage: [],
	        proctorTypes: [],
	        proctorTypesInvalid: false
	      };
	
	      SessionStore.getProfile();
	      this.getUserSettings();
	      SessionStore.getProctorTypes();
	
	      if (SessionStore.smarterscheduling) {
	        ScheduleStore.getScheduleAccount();
	      }
	    }
	  }, {
	    key: 'handleTabs',
	    value: function handleTabs(index) {
	      this.setState({
	        activeTab: index + 1
	      });
	    }
	  }, {
	    key: 'getUserSettings',
	    value: function getUserSettings() {
	      this.props.store.SettingsStore.getUserSettings(this);
	    }
	  }, {
	    key: 'handleInput',
	    value: function handleInput(e, name) {
	      var data = null;
	      var value = null;
	
	      if (name === 'phone') {
	        value = e;
	      } else {
	        value = e.target.value;
	      }
	
	      // Make sure boolean values are boolean
	      if (value === 'true') {
	        if (e.target.checked) {
	          value = true;
	        } else {
	          value = false;
	        }
	      }
	
	      if (value === 'false') {
	        value = false;
	      }
	
	      data = _defineProperty({}, name, value);
	
	      this.props.store.SettingsStore.updateUserData(data);
	    }
	  }, {
	    key: 'handleToggle',
	    value: function handleToggle(e) {
	      var proctorTypes = [].concat(_toConsumableArray(this.state.proctorTypes));
	
	      if (e.target.checked) {
	        proctorTypes.push(e.target.value);
	      } else {
	        var index = proctorTypes.indexOf(e.target.value);
	        proctorTypes.splice(index, 1);
	      }
	
	      this.setState({
	        proctorTypes: proctorTypes
	      }, function () {
	        var data = {
	          proctorTypes: this.state.proctorTypes
	        };
	
	        this.props.store.SettingsStore.updateUserData(data);
	      });
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit() {
	      var checked = document.querySelectorAll('.proctor-type-cbox:checked').length;
	
	      if (checked < 1) {
	        this.setState({
	          proctorTypesInvalid: true
	        }, function () {
	          window.scrollTo(0, 0);
	        });
	
	        return false;
	      } else {
	        this.setState({
	          proctorTypesInvalid: false
	        });
	      }
	
	      this.props.store.SettingsStore.updateUserSettings(this.complete);
	    }
	  }, {
	    key: 'handlePhotoSubmit',
	    value: function handlePhotoSubmit() {
	      var data = {
	        image: this.state.attachment[0]
	      };
	
	      if (this.state.attachment.length > 0) {
	        this.props.store.SettingsStore.updateProfilePhoto(data, this.complete('addPhoto', data), this);
	      } else {
	        this.props.store.SettingsStore.deleteProfilePhoto(this.complete('removePhoto'));
	      }
	    }
	  }, {
	    key: 'resetPhoto',
	    value: function resetPhoto() {
	      this.setState({
	        existingImage: this.state.oldImage,
	        oldImage: []
	      });
	    }
	  }, {
	    key: 'confirmPassword',
	    value: function confirmPassword(e) {
	      e.preventDefault();
	
	      // Make sure confirm password matches
	      var newPass = document.querySelector('#password-new');
	      var confirm = document.querySelector('#password-confirm');
	
	      if (newPass.value !== this.confirmPass.value) {
	        confirm.setCustomValidity('Passwords do not match.');
	      } else {
	        confirm.setCustomValidity('');
	      }
	
	      (0, _helpers.checkValidity)(e, this.handlePasswordSubmit);
	    }
	  }, {
	    key: 'handlePasswordSubmit',
	    value: function handlePasswordSubmit() {
	      var newPass = document.querySelector('#password-new');
	
	      var data = {
	        currentPassword: this.currentPass.value,
	        newPassword: newPass.value,
	        confirmPassword: this.confirmPass.value
	      };
	
	      this.props.store.SettingsStore.updatePassword(data, this.complete);
	
	      // Reset the password form
	      this.currentPass.value = '';
	      newPass.value = '';
	      this.confirmPass.value = '';
	
	      // Make sure the now empty input fields aren't flagged as invalid
	      var form = document.querySelector('form.submitted');
	
	      if (form) {
	        form.className = form.className.replace('submitted', '');
	      }
	    }
	  }, {
	    key: 'handleSchedulingSubmit',
	    value: function handleSchedulingSubmit(e) {
	      var _this2 = this;
	
	      var _props$store2 = this.props.store,
	          ScheduleStore = _props$store2.ScheduleStore,
	          SessionStore = _props$store2.SessionStore;
	
	
	      e.preventDefault();
	
	      if (this.scheduling.checked) {
	        var data = {
	          sid: SessionStore.userData.proctorAccountSid,
	          title: SessionStore.profile.accountName || SessionStore.profile.firstName + ' ' + SessionStore.profile.lastName,
	          externalId: SessionStore.userData.proctorAccountSid
	        };
	
	        var callback = function callback() {
	          SessionStore.showToaster(_this2.props.translation.scheduling.saved, 'success');
	        };
	
	        ScheduleStore.createScheduleAccount(data, callback);
	      }
	    }
	  }, {
	    key: 'complete',
	    value: function complete(type, data) {
	      if (this.props.enrollment) {
	        this.props.routing.history.push({
	          pathname: '/'
	        });
	      }
	
	      if (type === 'removePhoto') {
	        this.props.store.SessionStore.showToaster(this.props.translation.photo_removed, 'success');
	
	        this.setState({
	          attachment: [],
	          oldImage: [],
	          existingImage: []
	        });
	      } else {
	        this.props.store.SessionStore.showToaster(this.props.translation.settings_saved, 'success');
	
	        this.setState({
	          attachment: []
	        });
	      }
	    }
	
	    // This is annoying and not DRY, but because
	    // of the way that LaunchDarkly’s FeatureFlag
	    // component works, we need to duplicate some
	    // code for the render functions to handle
	    // SmarterScheduling enabled/disabled…
	
	  }, {
	    key: 'renderScheduleTab',
	    value: function renderScheduleTab() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var _props$store3 = this.props.store,
	          ScheduleStore = _props$store3.ScheduleStore,
	          SessionStore = _props$store3.SessionStore,
	          SettingsStore = _props$store3.SettingsStore;
	      var userSettings = SettingsStore.userSettings;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactTabs.Tabs,
	          {
	            onSelect: this.handleTabs
	          },
	          _react2.default.createElement(
	            _reactTabs.TabList,
	            { className: 'tabs-enabled' },
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              translation.tabs.general
	            ),
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              translation.tabs.photo
	            ),
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              translation.tabs.password
	            ),
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              translation.tabs.scheduling
	            )
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            _react2.default.createElement(
	              'form',
	              { onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this3.handleSubmit);
	                }, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--half inp-hidden' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'profile-fname' },
	                      translation.name.first
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'faux-input' },
	                      userSettings.firstName
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--half inp-hidden' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'profile-lname' },
	                      translation.name.last
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'faux-input' },
	                      userSettings.lastName
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'inp-hidden' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'profile-email' },
	                      translation.email
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'faux-input' },
	                      userSettings.email
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('input', {
	                      type: 'checkbox',
	                      id: 'written',
	                      className: 'switch-input',
	                      ref: function ref(input) {
	                        return _this3.written = input;
	                      },
	                      value: true,
	                      defaultChecked: userSettings.acceptWrittenExams,
	                      onChange: function onChange(e) {
	                        return _this3.handleInput(e, 'acceptWrittenExams');
	                      }
	                    }),
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'switch-label',
	                        htmlFor: 'written'
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        translation.written.label
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'switch-label--alt',
	                        htmlFor: 'written',
	                        'aria-describedby': 'written-tooltip'
	                      },
	                      translation.written.label,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tooltip' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'tooltip__label' },
	                          '(?)'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { id: 'written-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                          translation.written.helper
	                        )
	                      )
	                    )
	                  ),
	                  userSettings.verifiedBy && _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('input', {
	                      type: 'checkbox',
	                      id: 'activate',
	                      className: 'switch-input',
	                      ref: function ref(input) {
	                        return _this3.active = input;
	                      },
	                      value: true,
	                      defaultChecked: userSettings.active,
	                      onChange: function onChange(e) {
	                        return _this3.handleInput(e, 'active');
	                      }
	                    }),
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'switch-label',
	                        htmlFor: 'activate'
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        translation.activate.label
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'switch-label--alt',
	                        htmlFor: 'activate',
	                        'aria-describedby': 'activate-tooltip'
	                      },
	                      translation.activate.label,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tooltip' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'tooltip__label' },
	                          '(?)'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { id: 'activate-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                          translation.activate.helper
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'form-heading' },
	                  translation.proctor_type.heading,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tooltip' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip__label' },
	                      '(?)'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'proctor-type-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                      translation.proctor_type.tooltip
	                    )
	                  )
	                ),
	                this.state.proctorTypesInvalid && _react2.default.createElement(
	                  'span',
	                  { className: 'note note--prominent note--error' },
	                  translation.proctor_type.none_selected
	                ),
	                SessionStore.proctorTypeList.map(function (key, i) {
	                  if (userSettings.type === 'individual-proctor' && key.sid !== _config.config.testingCenterSid || userSettings.type !== 'individual-proctor' && key.sid === _config.config.testingCenterSid) {
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'form-subgroup', key: i },
	                      _react2.default.createElement(
	                        'strong',
	                        { className: 'form-subheading' },
	                        key.title
	                      ),
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'switch-list' },
	                        key.subCategories.filter(function (obj) {
	                          return obj.allowSelfSelection;
	                        }).map(function (subKey, j) {
	                          if (subKey.sid !== _config.config.testingAdministratorSid && subKey.sid !== _config.config.generalPublicSid) {
	                            return _react2.default.createElement(
	                              'li',
	                              { key: j },
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'register-type' + i + '-' + j },
	                                subKey.title
	                              ),
	                              _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                id: 'register-type' + i + '-' + j,
	                                className: 'switch-input proctor-type-cbox',
	                                value: subKey.sid,
	                                onChange: function onChange(e) {
	                                  _this3.handleToggle(e);
	                                },
	                                defaultChecked: _this3.state.proctorTypes.indexOf(subKey.sid) > -1,
	                                disabled: true
	                              }),
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'switch-label', htmlFor: 'register-type' + i + '-' + j },
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'meta' },
	                                  subKey.title
	                                )
	                              )
	                            );
	                          }
	
	                          return null;
	                        })
	                      )
	                    );
	                  }
	
	                  return null;
	                })
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--primary', type: 'submit' },
	                translation.save
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            _react2.default.createElement(
	              'form',
	              { className: 'block-form block-form--brief', onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this3.handlePhotoSubmit);
	                }, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(_PhotoUpload2.default, Object.assign({
	                  attachment: this.state.attachment,
	                  parent: this,
	                  existingImage: this.state.existingImage
	                }, this.props))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'actions' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'actions__btn actions__btn--primary',
	                    type: 'submit',
	                    disabled: this.state.attachment.length === 0 && this.state.oldImage.length === 0
	                  },
	                  translation.save
	                ),
	                this.state.oldImage.length > 0 && this.state.existingImage.length === 0 && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn--link',
	                    onClick: this.resetPhoto,
	                    type: 'button'
	                  },
	                  translation.cancel
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            _react2.default.createElement(
	              'form',
	              { onSubmit: function onSubmit(e) {
	                  return _this3.confirmPassword(e);
	                }, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'password-current' },
	                      translation.current_password
	                    ),
	                    _react2.default.createElement('input', {
	                      id: 'password-current',
	                      type: 'password',
	                      ref: function ref(input) {
	                        _this3.currentPass = input;
	                      },
	                      required: true,
	                      'aria-required': 'true'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'password-new' },
	                      translation.new_password
	                    ),
	                    _react2.default.createElement(_Password2.default, Object.assign({
	                      id: 'password-new',
	                      parent: this,
	                      name: 'password'
	                    }, this.props))
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'password-confirm' },
	                      translation.confirm_password
	                    ),
	                    _react2.default.createElement('input', {
	                      id: 'password-confirm',
	                      type: 'password',
	                      ref: function ref(input) {
	                        _this3.confirmPass = input;
	                      },
	                      required: true,
	                      'aria-required': 'true'
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--primary', type: 'submit' },
	                translation.save
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            _react2.default.createElement(
	              'form',
	              { onSubmit: function onSubmit(e) {
	                  return _this3.handleSchedulingSubmit(e);
	                }, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'switch-label--alt',
	                        htmlFor: 'activate'
	                      },
	                      translation.scheduling.label,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tooltip' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'tooltip__label' },
	                          '(?)'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { id: 'activate-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                          translation.scheduling.helper
	                        )
	                      )
	                    ),
	                    _react2.default.createElement('input', {
	                      type: 'checkbox',
	                      id: 'activate',
	                      className: 'switch-input',
	                      ref: function ref(input) {
	                        return _this3.scheduling = input;
	                      },
	                      value: true,
	                      defaultChecked: ScheduleStore.scheduleAccountEnabled,
	                      disabled: ScheduleStore.scheduleAccountEnabled
	                    }),
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'switch-label',
	                        htmlFor: 'activate',
	                        'aria-describedby': 'activate-tooltip'
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        translation.scheduling.label
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--primary', type: 'submit' },
	                translation.save
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderNoScheduleTab',
	    value: function renderNoScheduleTab() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	      var _props$store4 = this.props.store,
	          SessionStore = _props$store4.SessionStore,
	          SettingsStore = _props$store4.SettingsStore;
	      var userSettings = SettingsStore.userSettings;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactTabs.Tabs,
	          {
	            onSelect: this.handleTabs
	          },
	          _react2.default.createElement(
	            _reactTabs.TabList,
	            { className: 'tabs-enabled' },
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              translation.tabs.general
	            ),
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              translation.tabs.photo
	            ),
	            _react2.default.createElement(
	              _reactTabs.Tab,
	              null,
	              translation.tabs.password
	            )
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            _react2.default.createElement(
	              'form',
	              { onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this4.handleSubmit);
	                }, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--half inp-hidden' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'profile-fname' },
	                      translation.name.first
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'faux-input' },
	                      userSettings.firstName
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'field--half inp-hidden' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'profile-lname' },
	                      translation.name.last
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'faux-input' },
	                      userSettings.lastName
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    { className: 'inp-hidden' },
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'profile-email' },
	                      translation.email
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'faux-input' },
	                      userSettings.email
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('input', {
	                      type: 'checkbox',
	                      id: 'written',
	                      className: 'switch-input',
	                      ref: function ref(input) {
	                        return _this4.written = input;
	                      },
	                      value: true,
	                      defaultChecked: userSettings.acceptWrittenExams,
	                      onChange: function onChange(e) {
	                        return _this4.handleInput(e, 'acceptWrittenExams');
	                      }
	                    }),
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'switch-label',
	                        htmlFor: 'written'
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        translation.written.label
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'switch-label--alt',
	                        htmlFor: 'written',
	                        'aria-describedby': 'written-tooltip'
	                      },
	                      translation.written.label,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tooltip' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'tooltip__label' },
	                          '(?)'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { id: 'written-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                          translation.written.helper
	                        )
	                      )
	                    )
	                  ),
	                  userSettings.verifiedBy && _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement('input', {
	                      type: 'checkbox',
	                      id: 'activate',
	                      className: 'switch-input',
	                      ref: function ref(input) {
	                        return _this4.active = input;
	                      },
	                      value: true,
	                      defaultChecked: userSettings.active,
	                      onChange: function onChange(e) {
	                        return _this4.handleInput(e, 'active');
	                      }
	                    }),
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'switch-label',
	                        htmlFor: 'activate'
	                      },
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'meta' },
	                        translation.activate.label
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'label',
	                      {
	                        className: 'switch-label--alt',
	                        htmlFor: 'activate',
	                        'aria-describedby': 'activate-tooltip'
	                      },
	                      translation.activate.label,
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'tooltip' },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'tooltip__label' },
	                          '(?)'
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { id: 'activate-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                          translation.activate.helper
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'h4',
	                  { className: 'form-heading' },
	                  translation.proctor_type.heading,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'tooltip' },
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltip__label' },
	                      '(?)'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { id: 'proctor-type-tooltip', className: 'tooltip__body', role: 'tooltip' },
	                      translation.proctor_type.tooltip
	                    )
	                  )
	                ),
	                this.state.proctorTypesInvalid && _react2.default.createElement(
	                  'span',
	                  { className: 'note note--prominent note--error' },
	                  translation.proctor_type.none_selected
	                ),
	                SessionStore.proctorTypeList.map(function (key, i) {
	                  if (userSettings.type === 'individual-proctor' && key.sid !== _config.config.testingCenterSid || userSettings.type !== 'individual-proctor' && key.sid === _config.config.testingCenterSid) {
	                    return _react2.default.createElement(
	                      'div',
	                      { className: 'form-subgroup', key: i },
	                      _react2.default.createElement(
	                        'strong',
	                        { className: 'form-subheading' },
	                        key.title
	                      ),
	                      _react2.default.createElement(
	                        'ul',
	                        { className: 'switch-list' },
	                        key.subCategories.filter(function (obj) {
	                          return obj.allowSelfSelection;
	                        }).map(function (subKey, j) {
	                          if (subKey.sid !== _config.config.testingAdministratorSid && subKey.sid !== _config.config.generalPublicSid) {
	                            return _react2.default.createElement(
	                              'li',
	                              { key: j },
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'register-type' + i + '-' + j },
	                                subKey.title
	                              ),
	                              _react2.default.createElement('input', {
	                                type: 'checkbox',
	                                id: 'register-type' + i + '-' + j,
	                                className: 'switch-input proctor-type-cbox',
	                                value: subKey.sid,
	                                onChange: function onChange(e) {
	                                  _this4.handleToggle(e);
	                                },
	                                defaultChecked: _this4.state.proctorTypes.indexOf(subKey.sid) > -1,
	                                disabled: true
	                              }),
	                              _react2.default.createElement(
	                                'label',
	                                { className: 'switch-label', htmlFor: 'register-type' + i + '-' + j },
	                                _react2.default.createElement(
	                                  'span',
	                                  { className: 'meta' },
	                                  subKey.title
	                                )
	                              )
	                            );
	                          }
	
	                          return null;
	                        })
	                      )
	                    );
	                  }
	
	                  return null;
	                })
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--primary', type: 'submit' },
	                translation.save
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            _react2.default.createElement(
	              'form',
	              { className: 'block-form block-form--brief', onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this4.handlePhotoSubmit);
	                }, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(_PhotoUpload2.default, Object.assign({
	                  attachment: this.state.attachment,
	                  parent: this,
	                  existingImage: this.state.existingImage
	                }, this.props))
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'actions' },
	                _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'actions__btn actions__btn--primary',
	                    type: 'submit',
	                    disabled: this.state.attachment.length === 0 && this.state.oldImage.length === 0
	                  },
	                  translation.save
	                ),
	                this.state.oldImage.length > 0 && this.state.existingImage.length === 0 && _react2.default.createElement(
	                  'button',
	                  {
	                    className: 'btn--link',
	                    onClick: this.resetPhoto,
	                    type: 'button'
	                  },
	                  translation.cancel
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _reactTabs.TabPanel,
	            null,
	            _react2.default.createElement(
	              'form',
	              { onSubmit: function onSubmit(e) {
	                  return _this4.confirmPassword(e);
	                }, noValidate: true },
	              _react2.default.createElement(
	                'fieldset',
	                null,
	                _react2.default.createElement(
	                  'ul',
	                  { className: 'fields' },
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'password-current' },
	                      translation.current_password
	                    ),
	                    _react2.default.createElement('input', {
	                      id: 'password-current',
	                      type: 'password',
	                      ref: function ref(input) {
	                        _this4.currentPass = input;
	                      },
	                      required: true,
	                      'aria-required': 'true'
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'password-new' },
	                      translation.new_password
	                    ),
	                    _react2.default.createElement(_Password2.default, Object.assign({
	                      id: 'password-new',
	                      parent: this,
	                      name: 'password'
	                    }, this.props))
	                  ),
	                  _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                      'label',
	                      { className: 'lbl-required', htmlFor: 'password-confirm' },
	                      translation.confirm_password
	                    ),
	                    _react2.default.createElement('input', {
	                      id: 'password-confirm',
	                      type: 'password',
	                      ref: function ref(input) {
	                        _this4.confirmPass = input;
	                      },
	                      required: true,
	                      'aria-required': 'true'
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'button',
	                { className: 'actions__btn actions__btn--primary', type: 'submit' },
	                translation.save
	              )
	            )
	          )
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var SessionStore = this.props.store.SessionStore;
	
	      // Don’t use the default tab styles
	
	      _reactTabs.Tabs.setUseDefaultStyles(false);
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'wrap block-form block-form--brief' },
	          _react2.default.createElement(_reactLaunchDarkly.FeatureFlag, {
	            flagKey: 'proctor-schedules',
	            renderFeatureCallback: this.renderScheduleTab,
	            renderDefaultCallback: this.renderNoScheduleTab
	          })
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return UserSettings;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('UserSettings')(UserSettings);

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _TicketForm = __webpack_require__(304);
	
	var _TicketForm2 = _interopRequireDefault(_TicketForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Components
	
	
	var AddSupportTicket = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AddSupportTicket, _React$Component);
	
	  function AddSupportTicket() {
	    _classCallCheck(this, AddSupportTicket);
	
	    return _possibleConstructorReturn(this, (AddSupportTicket.__proto__ || Object.getPrototypeOf(AddSupportTicket)).apply(this, arguments));
	  }
	
	  _createClass(AddSupportTicket, [{
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'drawer__content' },
	        _react2.default.createElement(
	          'header',
	          { className: 'drawer__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'drawer__title' },
	              translation.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap block-form' },
	          _react2.default.createElement(_TicketForm2.default, Object.assign({}, this.props, { newTicket: true }))
	        )
	      );
	    }
	  }]);
	
	  return AddSupportTicket;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('AddSupportTicket')(AddSupportTicket);

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactAutolinker = __webpack_require__(1135);
	
	var _reactAutolinker2 = _interopRequireDefault(_reactAutolinker);
	
	var _TicketForm = __webpack_require__(304);
	
	var _TicketForm2 = _interopRequireDefault(_TicketForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var SupportTicketDetail = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SupportTicketDetail, _React$Component);
	
	  function SupportTicketDetail() {
	    _classCallCheck(this, SupportTicketDetail);
	
	    var _this = _possibleConstructorReturn(this, (SupportTicketDetail.__proto__ || Object.getPrototypeOf(SupportTicketDetail)).call(this));
	
	    _this.renderConversation = _this.renderConversation.bind(_this);
	    return _this;
	  }
	
	  _createClass(SupportTicketDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var TicketStore = this.props.store.TicketStore;
	
	      var ticketSid = (0, _helpers.getURLSegment)(this, 3);
	
	      TicketStore.getTicket(ticketSid);
	    }
	  }, {
	    key: 'initials',
	    value: function initials(name, className) {
	      var names = name.split(' ');
	      var firstInitial = names[0].charAt(0);
	      var secondInitial = names[1].charAt(0);
	
	      if (className) {
	        return '' + firstInitial.toLowerCase();
	      }
	
	      return firstInitial + secondInitial;
	    }
	  }, {
	    key: 'renderConversation',
	    value: function renderConversation() {
	      var _this2 = this;
	
	      var _props = this.props,
	          store = _props.store,
	          translation = _props.translation;
	      var SessionStore = store.SessionStore,
	          TicketStore = store.TicketStore;
	      var activeTicket = TicketStore.activeTicket;
	      var requester = activeTicket.requester;
	
	
	      var linkOptions = {
	        target: '_blank'
	      };
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'ol',
	          { className: 'conversation' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'blockquote',
	              { className: 'conversation__message sent' },
	              _react2.default.createElement(
	                'div',
	                { className: 'conversation__body' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'conversation__content' },
	                  _react2.default.createElement(_reactAutolinker2.default, {
	                    text: activeTicket.descriptionText,
	                    options: linkOptions
	                  })
	                ),
	                _react2.default.createElement(
	                  'time',
	                  { className: 'conversation__timestamp' },
	                  (0, _moment2.default)(activeTicket.createdDate).format('M/D/YYYY h:mma')
	                )
	              ),
	              _react2.default.createElement(
	                'cite',
	                { className: 'conversation__author conversation__author--sm' },
	                _react2.default.createElement(
	                  'abbr',
	                  {
	                    className: '\n                    avatar--initials conversation__avatar ' + this.initials(requester.firstName + ' ' + requester.lastName, true) + '\n                  ',
	                    title: requester.firstName + ' ' + requester.lastName },
	                  requester.firstName.charAt(0),
	                  requester.lastName.charAt(0)
	                ),
	                requester.role === 'admin' && _react2.default.createElement(
	                  'em',
	                  { className: 'conversation__tag' },
	                  translation.admin
	                )
	              )
	            )
	          ),
	          activeTicket.conversations.map(function (key, i) {
	            return _react2.default.createElement(
	              'li',
	              { key: i },
	              _react2.default.createElement(
	                'blockquote',
	                { className: 'conversation__message ' + (key.jobTitle !== null ? 'received' : 'sent') },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'conversation__body' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'conversation__content' },
	                    key.bodyText
	                  ),
	                  _react2.default.createElement(
	                    'time',
	                    { className: 'conversation__timestamp' },
	                    (0, _moment2.default)(key.created_at).format('M/D/YYYY h:mma')
	                  )
	                ),
	                _react2.default.createElement(
	                  'cite',
	                  { className: 'conversation__author conversation__author--sm' },
	                  _react2.default.createElement(
	                    'abbr',
	                    {
	                      className: '\n                      avatar--initials\n                      conversation__avatar\n                      ' + _this2.initials(key.name, true) + '\n                    ',
	                      title: '' + key.name },
	                    _this2.initials(key.name, false)
	                  ),
	                  key.jobTitle !== null && _react2.default.createElement(
	                    'em',
	                    { className: 'conversation__tag' },
	                    translation.admin
	                  )
	                )
	              )
	            );
	          })
	        );
	      }
	
	      return '';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          store = _props2.store,
	          translation = _props2.translation;
	      var SessionStore = store.SessionStore,
	          TicketStore = store.TicketStore;
	      var activeTicket = TicketStore.activeTicket;
	
	
	      if (!SessionStore.loading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'drawer__content' },
	          _react2.default.createElement(
	            'header',
	            { className: 'drawer__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'drawer__title' },
	                translation.heading,
	                activeTicket.ticketNumber
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'article',
	              { className: 'ticket' },
	              _react2.default.createElement(
	                'header',
	                { className: 'ticket__header' },
	                _react2.default.createElement(
	                  'h3',
	                  null,
	                  activeTicket.subject
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'pill pill--' + activeTicket.status.toLowerCase() },
	                  activeTicket.status
	                )
	              ),
	              this.renderConversation()
	            ),
	            _react2.default.createElement(_TicketForm2.default, Object.assign({ activeTicket: activeTicket }, this.props))
	          )
	        );
	      }
	
	      return null;
	    }
	  }]);
	
	  return SupportTicketDetail;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SupportTicketDetail')(SupportTicketDetail);

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(17);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Helpers
	
	
	// Components
	
	
	// Dependencies
	
	
	var SupportTickets = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(SupportTickets, _React$Component);
	
	  function SupportTickets() {
	    _classCallCheck(this, SupportTickets);
	
	    var _this2 = _possibleConstructorReturn(this, (SupportTickets.__proto__ || Object.getPrototypeOf(SupportTickets)).call(this));
	
	    _this2.handleDrawer = _this2.handleDrawer.bind(_this2);
	    _this2.filterTickets = _this2.filterTickets.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(SupportTickets, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props$store = this.props.store,
	          SessionStore = _props$store.SessionStore,
	          TicketStore = _props$store.TicketStore;
	
	
	      this.state = {
	        drawerOpen: false,
	        drawerContent: null,
	        dataReceived: false
	      };
	
	      TicketStore.getTickets(SessionStore.userData.enrollmentSid);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var pathname = this.props.routing.location.pathname;
	
	
	      if (pathname.indexOf('/view') > -1) {
	        (0, _helpers.toggleDrawer)(null, this, 'SupportTicketDetail');
	      } else if (pathname.indexOf('/add') > -1) {
	        (0, _helpers.toggleDrawer)(null, this, 'AddSupportTicket');
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var _props$store2 = this.props.store,
	          SessionStore = _props$store2.SessionStore,
	          TicketStore = _props$store2.TicketStore;
	
	      // Set the state’s filtered tickets to all the tickets received from the API
	      // then set the state dataReceived to true to prevent this from running again
	
	      if (!SessionStore.loading && !this.state.dataReceived) {
	        this.setState({
	          filteredTickets: TicketStore.tickets,
	          dataReceived: true
	        });
	      }
	    }
	  }, {
	    key: 'handleDrawer',
	    value: function handleDrawer(e) {
	      e.preventDefault();
	
	      // Update url
	      var path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');
	
	      if (this.props.routing.location.pathname !== path) {
	        this.props.routing.history.push(path);
	      }
	    }
	  }, {
	    key: 'filterTickets',
	    value: function filterTickets() {
	      var _this = this;
	      var tickets = this.props.store.TicketStore.tickets;
	
	
	      if (this.filter.value) {
	        var newFilteredTickets = tickets.filter(function (key) {
	          return key.statusId.toString() === _this.filter.value;
	        });
	
	        this.setState({
	          filter: this.filter.value
	        });
	
	        this.props.store.TicketStore.filterTickets(newFilteredTickets);
	      } else {
	        this.setState({
	          filter: null
	        });
	
	        this.props.store.TicketStore.filterTickets(tickets);
	      }
	    }
	  }, {
	    key: 'renderResults',
	    value: function renderResults() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var TicketStore = this.props.store.TicketStore;
	      var filteredTickets = TicketStore.filteredTickets;
	
	      var segment1 = (0, _helpers.getURLSegment)(this, 1);
	
	      if (filteredTickets.length > 0) {
	        // const paginate = {
	        //   total: 10,
	        //   first: '#',
	        //   next: '#',
	        //   prev: '#',
	        //   last: '#',
	        //   count: 1,
	        //   limit: 1,
	        //   current: 1
	        // }
	
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', className: 'subtitle' },
	                  translation.ticket_id
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', className: 'subtitle' },
	                  translation.subject
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', className: 'subtitle' },
	                  translation.status
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col', className: 'subtitle' },
	                  translation.last_update
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              filteredTickets.map(function (key, i) {
	                return _react2.default.createElement(
	                  'tr',
	                  { key: i },
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      { className: 'title-link--alt', to: segment1 + '/view/' + key.sid, onClick: function onClick(e) {
	                          _this3.handleDrawer(e);
	                        } },
	                      key.ticketNumber
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      _reactRouterDom.Link,
	                      { className: 'title-link--alt', to: segment1 + '/view/' + key.sid, onClick: function onClick(e) {
	                          _this3.handleDrawer(e);
	                        } },
	                      key.subject
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'pill pill--' + key.status.toLowerCase() },
	                      key.status
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    _moment2.default.utc(key.ticketLastUpdated).local().format('M/D/YYYY h:mma')
	                  )
	                );
	              })
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement(
	          'span',
	          { className: 'no-results' },
	          translation.no_results
	        );
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var translation = this.props.translation;
	
	      var segment1 = (0, _helpers.getURLSegment)(this, 1);
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'header',
	          { className: 'page__header' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'page__title' },
	              translation.page_title
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'page__actions actions' },
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { to: segment1 + '/add', className: 'btn--outline', onClick: function onClick(e) {
	                    _this4.handleDrawer(e);
	                  } },
	                _react2.default.createElement(icons.iconPlus, null),
	                translation.button
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          { className: 'filter' },
	          _react2.default.createElement(
	            'div',
	            { className: 'wrap' },
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'filter__filters' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'fields fields--inline' },
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'legend',
	                    null,
	                    translation.show,
	                    ':'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'label',
	                    { className: 'select' },
	                    _react2.default.createElement(
	                      'select',
	                      { onChange: this.filterTickets, ref: function ref(input) {
	                          _this4.filter = input;
	                        } },
	                      _react2.default.createElement(
	                        'option',
	                        { value: '' },
	                        translation.filters.all
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '2' },
	                        translation.filters.open
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '4' },
	                        translation.filters.resolved
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '5' },
	                        translation.filters.closed
	                      ),
	                      _react2.default.createElement(
	                        'option',
	                        { value: '3' },
	                        translation.filters.pending
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          this.renderResults()
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({ content: this.state.drawerContent, isOpen: this.state.drawerOpen, parent: this }, this.props))
	      );
	    }
	  }]);
	
	  return SupportTickets;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('SupportTickets')(SupportTickets);

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _jwtDecode = __webpack_require__(1063);
	
	var _jwtDecode2 = _interopRequireDefault(_jwtDecode);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	// Dependencies
	
	
	// Components
	
	
	var Unauthorized = function (_React$Component) {
	  _inherits(Unauthorized, _React$Component);
	
	  function Unauthorized() {
	    _classCallCheck(this, Unauthorized);
	
	    return _possibleConstructorReturn(this, (Unauthorized.__proto__ || Object.getPrototypeOf(Unauthorized)).apply(this, arguments));
	  }
	
	  _createClass(Unauthorized, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var token = this.props.routing.location.search.split('token=')[1];
	      if (token) {
	        this.payload = (0, _jwtDecode2.default)(token);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        'main',
	        { className: 'page page--error wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'panel--brief' },
	          _react2.default.createElement(
	            'i',
	            { className: 'page--error__icon' },
	            _react2.default.createElement(icons.iconLock, null)
	          ),
	          typeof this.payload !== 'undefined' && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'panel__title' },
	              translation[this.payload.errorCode].heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation[this.payload.errorCode].message
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'btn--outline', to: this.payload.returnUrl },
	              translation[this.payload.errorCode].button
	            )
	          ),
	          typeof this.payload === 'undefined' && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h1',
	              { className: 'panel__title' },
	              translation.default.heading
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              translation.default.message
	            ),
	            _react2.default.createElement(
	              _reactRouterDom.Link,
	              { className: 'btn--outline', to: '/' },
	              translation.default.button
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Unauthorized;
	}(_react2.default.Component);
	
	exports.default = (0, _Translate2.default)('Unauthorized')(Unauthorized);

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var CreateUser = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(CreateUser, _React$Component);
	
	  function CreateUser() {
	    _classCallCheck(this, CreateUser);
	
	    var _this = _possibleConstructorReturn(this, (CreateUser.__proto__ || Object.getPrototypeOf(CreateUser)).call(this));
	
	    _this.handleSubmit = function () {
	      var _this$props$store = _this.props.store,
	          EnrollmentStore = _this$props$store.EnrollmentStore,
	          SessionStore = _this$props$store.SessionStore;
	      var _this$state = _this.state,
	          firstName = _this$state.firstName,
	          lastName = _this$state.lastName,
	          email = _this$state.email,
	          password = _this$state.password;
	
	
	      var data = {
	        firstName: firstName,
	        lastName: lastName,
	        email: email,
	        // Set username to the email the user inputs
	        username: _this.state.email,
	        password: password
	      };
	
	      var callback = function callback() {
	        (0, _helpers.closeDrawer)(null, _this.props.parent, "/users");
	        SessionStore.showToaster(_this.props.translation.userCreated, "success");
	      };
	
	      EnrollmentStore.newProctorUser(data, callback);
	    };
	
	    _this.handleInput = function (e) {
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value;
	
	      _this.setState(_defineProperty({}, name, value));
	    };
	
	    _this.state = {
	      firstName: null,
	      lastName: null,
	      email: null,
	      username: null
	    };
	    return _this;
	  }
	
	  /**
	   * Submit the settings form.
	   *
	   * @function handleSubmit
	   */
	
	
	  /**
	   * Store input values.
	   *
	   * @function handleInput
	   * @param {event} e
	   */
	
	
	  _createClass(CreateUser, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var translation = this.props.translation;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "drawer__content" },
	        _react2.default.createElement(
	          "header",
	          { className: "drawer__header" },
	          _react2.default.createElement(
	            "div",
	            { className: "wrap" },
	            _react2.default.createElement(
	              "h1",
	              { className: "drawer__title" },
	              translation.heading
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "wrap" },
	          _react2.default.createElement(
	            "form",
	            { className: "form panel panel__body", onSubmit: function onSubmit(e) {
	                return (0, _helpers.checkValidity)(e, _this2.handleSubmit);
	              } },
	            _react2.default.createElement(
	              "fieldset",
	              null,
	              _react2.default.createElement(
	                "ul",
	                { className: "fields" },
	                _react2.default.createElement(
	                  "li",
	                  { className: "field--half" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "form__lbl required",
	                      htmlFor: "user-first-name"
	                    },
	                    translation.firstName
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    id: "fuser-first-name",
	                    name: "firstName",
	                    required: true,
	                    "aria-required": "true",
	                    "data-errormsg": "Error message with instructions to correct",
	                    onChange: this.handleInput
	                  })
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "field--half" },
	                  _react2.default.createElement(
	                    "label",
	                    {
	                      className: "form__lbl required",
	                      htmlFor: "user-last-name"
	                    },
	                    translation.lastName
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    id: "user-last-name",
	                    name: "lastName",
	                    required: true,
	                    "aria-required": "true",
	                    "data-errormsg": "Error message with instructions to correct",
	                    onChange: this.handleInput
	                  })
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "field--half" },
	                  _react2.default.createElement(
	                    "label",
	                    { className: "form__lbl required", htmlFor: "user-email" },
	                    translation.email
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    id: "user-email",
	                    name: "email",
	                    onChange: this.handleInput
	                  })
	                ),
	                _react2.default.createElement(
	                  "li",
	                  { className: "field--half" },
	                  _react2.default.createElement(
	                    "label",
	                    { className: "form__lbl required", htmlFor: "user-password" },
	                    translation.password
	                  ),
	                  _react2.default.createElement("input", {
	                    type: "text",
	                    id: "user-password",
	                    name: "password",
	                    onChange: this.handleInput
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "panel__actions" },
	              _react2.default.createElement(
	                "button",
	                { className: "btn", type: "submit" },
	                "Submit"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CreateUser;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)("CreateUser")(CreateUser);

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(76);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _helpers = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Translations
	
	
	var EditUsers = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(EditUsers, _React$Component);
	
	  function EditUsers() {
	    var _this2 = this;
	
	    _classCallCheck(this, EditUsers);
	
	    var _this = _possibleConstructorReturn(this, (EditUsers.__proto__ || Object.getPrototypeOf(EditUsers)).call(this));
	
	    _this.handleSubmit = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var _this$props$store, EnrollmentStore, SessionStore, _this$state, firstName, lastName, email, username, data, callback;
	
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _this$props$store = _this.props.store, EnrollmentStore = _this$props$store.EnrollmentStore, SessionStore = _this$props$store.SessionStore;
	              _this$state = _this.state, firstName = _this$state.firstName, lastName = _this$state.lastName, email = _this$state.email, username = _this$state.username;
	              data = {
	                firstName: firstName,
	                lastName: lastName,
	                email: email,
	                username: username
	              };
	
	              callback = function callback() {
	                (0, _helpers.closeDrawer)(null, _this.props.parent, "/users");
	                SessionStore.showToaster(_this.props.translation.user_updated, "success");
	              };
	
	              EnrollmentStore.updateProctorUser(data, callback);
	
	            case 5:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.handleInput = function (e) {
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value;
	
	
	      if (name === 'email') {
	        _this.setState({
	          email: value,
	          username: value
	        });
	      } else {
	        _this.setState(_defineProperty({}, name, value));
	      }
	    };
	
	    _this.handleDelete = function () {
	      var _this$props$store2 = _this.props.store,
	          EnrollmentStore = _this$props$store2.EnrollmentStore,
	          SessionStore = _this$props$store2.SessionStore;
	      var translation = _this.props.translation;
	
	      var msg = translation.delete_confirm;
	
	      var callback = function callback() {
	        (0, _helpers.closeDrawer)(null, _this.props.parent, "/users");
	        SessionStore.showToaster(_this.props.translation.user_deleted, "success");
	      };
	      (0, _helpers.confirm)(msg, function () {
	        return EnrollmentStore.deleteProctorUser(callback);
	      });
	    };
	
	    _this.state = {
	      firstName: null,
	      lastName: null,
	      email: null,
	      username: null
	    };
	    return _this;
	  }
	
	  _createClass(EditUsers, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var EnrollmentStore = this.props.store.EnrollmentStore;
	
	      var userSid = (0, _helpers.getURLSegment)(this, 3);
	
	      EnrollmentStore.proctorUser = null;
	
	      EnrollmentStore.listProctorUsers(userSid);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _state = this.state,
	          firstName = _state.firstName,
	          lastName = _state.lastName,
	          email = _state.email,
	          username = _state.username;
	
	      var proctorUser = this.props.store.EnrollmentStore.proctorUser;
	
	      // console.log(JSON.stringify(proctorUser))
	
	      if (proctorUser && (!firstName || !lastName || !email || !username)) {
	
	        this.setState({
	          firstName: proctorUser.firstName,
	          lastName: proctorUser.lastName,
	          email: proctorUser.email,
	          username: this.state.email
	        });
	      }
	    }
	
	    /**
	     * Submit the settings form.
	     *
	     * @function handleSubmit
	     */
	
	
	    /**
	     * Store input values.
	     *
	     * @function handleInput
	     * @param {event} e
	     */
	
	
	    /**
	     * Delete Proctor User.
	     *
	     * @function handleDelete
	     * 
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var translation = this.props.translation;
	      var EnrollmentStore = this.props.store.EnrollmentStore;
	
	      var proctorUser = EnrollmentStore.proctorUser;
	
	      if (proctorUser) {
	        return _react2.default.createElement(
	          "div",
	          { className: "drawer__content" },
	          _react2.default.createElement(
	            "header",
	            { className: "drawer__header" },
	            _react2.default.createElement(
	              "div",
	              { className: "wrap" },
	              _react2.default.createElement(
	                "h1",
	                { className: "drawer__title" },
	                translation.heading
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "wrap" },
	            _react2.default.createElement(
	              "form",
	              { className: "form panel panel__body", onSubmit: function onSubmit(e) {
	                  return (0, _helpers.checkValidity)(e, _this3.handleSubmit);
	                } },
	              _react2.default.createElement(
	                "fieldset",
	                null,
	                _react2.default.createElement(
	                  "ul",
	                  { className: "fields" },
	                  _react2.default.createElement(
	                    "li",
	                    { className: "field--half" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "form__lbl required",
	                        htmlFor: "form-text1"
	                      },
	                      translation.first_name
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      id: "form-text1",
	                      name: "firstName",
	                      defaultValue: proctorUser.firstName,
	                      required: true,
	                      "aria-required": "true",
	                      "data-errormsg": "Error message with instructions to correct",
	                      onChange: this.handleInput
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    { className: "field--half" },
	                    _react2.default.createElement(
	                      "label",
	                      {
	                        className: "form__lbl required",
	                        htmlFor: "form-text2"
	                      },
	                      translation.last_name
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      id: "form-text2",
	                      name: "lastName",
	                      defaultValue: proctorUser.lastName,
	                      required: true,
	                      "aria-required": "true",
	                      "data-errormsg": "Error message with instructions to correct",
	                      onChange: this.handleInput
	                    })
	                  ),
	                  _react2.default.createElement(
	                    "li",
	                    null,
	                    _react2.default.createElement(
	                      "label",
	                      { className: "form__lbl", htmlFor: "form-text3" },
	                      translation.email
	                    ),
	                    _react2.default.createElement("input", {
	                      type: "text",
	                      id: "form-text3",
	                      name: "email",
	                      defaultValue: proctorUser.email,
	                      onChange: this.handleInput
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "panel__actions actions" },
	                _react2.default.createElement(
	                  "button",
	                  { className: "btn btn--negative",
	                    type: "button",
	                    onClick: this.handleDelete },
	                  translation.delete
	                ),
	                _react2.default.createElement(
	                  "button",
	                  { className: "btn", type: "submit" },
	                  translation.save
	                )
	              )
	            )
	          )
	        );
	      }
	      return null;
	    }
	  }]);
	
	  return EditUsers;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)("EditUsers")(EditUsers);

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _helpers = __webpack_require__(17);
	
	var _Translate = __webpack_require__(12);
	
	var _Translate2 = _interopRequireDefault(_Translate);
	
	var _Icons = __webpack_require__(22);
	
	var icons = _interopRequireWildcard(_Icons);
	
	var _Drawer = __webpack_require__(46);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Helpers
	
	
	// Translations
	
	
	// Components
	
	
	var Users = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(Users, _React$Component);
	
	  function Users() {
	    _classCallCheck(this, Users);
	
	    var _this = _possibleConstructorReturn(this, (Users.__proto__ || Object.getPrototypeOf(Users)).call(this));
	
	    _this.state = {
	      drawerOpen: false,
	      drawerContent: null,
	      userSid: null
	    };
	
	    return _this;
	  }
	
	  _createClass(Users, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var pathname = this.props.routing.location.pathname;
	      var _props$store = this.props.store,
	          EnrollmentStore = _props$store.EnrollmentStore,
	          SessionStore = _props$store.SessionStore;
	
	
	      if (!SessionStore.userData.isSuperAdmin) {
	        this.props.routing.history.push('/unauthorized');
	      }
	
	      EnrollmentStore.listProctorUsers();
	
	      this.setState({
	        userSid: null
	      });
	
	      if (pathname.indexOf('/edit') > -1) {
	        var userSid = pathname.substr(pathname.lastIndexOf('/') + 1);
	
	        this.setState({
	          userSid: userSid
	        });
	        (0, _helpers.toggleDrawer)(null, this, 'UserEdit');
	      } else if (pathname.indexOf('/add') > -1) {
	        this.setState({
	          userSid: null
	        });
	        (0, _helpers.toggleDrawer)(null, this, 'CreateUser');
	      }
	    }
	  }, {
	    key: 'handleEdit',
	    value: function handleEdit(e, userSid) {
	      e.preventDefault();
	
	      // Update url
	      var path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');
	
	      if (this.props.routing.location.pathname !== path) {
	        this.props.routing.history.push(path);
	      }
	      // Reset userSid data
	      this.setState({
	        userSid: null
	      });
	    }
	  }, {
	    key: 'handleNew',
	    value: function handleNew(e) {
	      e.preventDefault();
	
	      // Reset userSid data
	      this.setState({
	        userSid: null
	      });
	
	      // Update url
	      var path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '');
	
	      if (this.props.routing.location.pathname !== path) {
	        this.props.routing.history.push(path);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          store = _props.store,
	          translation = _props.translation;
	      var EnrollmentStore = store.EnrollmentStore;
	      var proctorUsers = EnrollmentStore.proctorUsers;
	
	
	      return _react2.default.createElement(
	        'main',
	        { tabIndex: '0', id: 'main-content', className: 'page' },
	        _react2.default.createElement(
	          'div',
	          { className: 'wrap' },
	          _react2.default.createElement(
	            'header',
	            { className: 'page__header' },
	            _react2.default.createElement(
	              'div',
	              { className: 'wrap' },
	              _react2.default.createElement(
	                'h1',
	                { className: 'page__title' },
	                translation.users
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'page__actions actions' },
	                _react2.default.createElement(
	                  _reactRouterDom.Link,
	                  { className: 'btn--outline', to: '/users/add', onClick: function onClick(e) {
	                      _this2.handleNew(e);
	                    } },
	                  _react2.default.createElement(icons.iconPlus, null),
	                  translation.new_user
	                )
	              )
	            )
	          ),
	          proctorUsers && proctorUsers.length > 0 && _react2.default.createElement(
	            'table',
	            { className: 'panel' },
	            _react2.default.createElement(
	              'thead',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col' },
	                  translation.first_name
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col' },
	                  translation.last_name
	                ),
	                _react2.default.createElement(
	                  'th',
	                  { scope: 'col' },
	                  translation.email
	                ),
	                _react2.default.createElement('th', { scope: 'col' })
	              )
	            ),
	            _react2.default.createElement(
	              'tbody',
	              null,
	              proctorUsers.map(function (user, i) {
	                if (!user.isSuperAdmin) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: i },
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      user.firstName
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      user.lastName
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      user.email
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { className: 'actions' },
	                      _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        {
	                          className: 'btn--outline',
	                          to: '/users/edit/' + user.sid,
	                          onClick: function onClick(e) {
	                            return _this2.handleEdit(e, user.sid);
	                          }
	                        },
	                        translation.edit
	                      )
	                    )
	                  );
	                }
	                return null;
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(_Drawer2.default, Object.assign({
	          content: this.state.drawerContent,
	          isOpen: this.state.drawerOpen,
	          parent: this }, this.props, {
	          userSid: this.state.userSid
	        }))
	      );
	    }
	  }]);
	
	  return Users;
	}(_react2.default.Component));
	
	exports.default = (0, _Translate2.default)('Users')(Users);

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(9);
	
	var _reactRouterDom = __webpack_require__(35);
	
	var _AppLoggedOut = __webpack_require__(842);
	
	var _AppLoggedOut2 = _interopRequireDefault(_AppLoggedOut);
	
	var _Session = __webpack_require__(838);
	
	var _Session2 = _interopRequireDefault(_Session);
	
	var _NotFound = __webpack_require__(887);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _AppNoNav = __webpack_require__(843);
	
	var _AppNoNav2 = _interopRequireDefault(_AppNoNav);
	
	var _UpdatePassword = __webpack_require__(840);
	
	var _UpdatePassword2 = _interopRequireDefault(_UpdatePassword);
	
	var _App = __webpack_require__(841);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Locations = __webpack_require__(875);
	
	var _Locations2 = _interopRequireDefault(_Locations);
	
	var _config = __webpack_require__(24);
	
	var _Inbox = __webpack_require__(879);
	
	var _Inbox2 = _interopRequireDefault(_Inbox);
	
	var _Payments = __webpack_require__(892);
	
	var _Payments2 = _interopRequireDefault(_Payments);
	
	var _HybridProctoring = __webpack_require__(872);
	
	var _HybridProctoring2 = _interopRequireDefault(_HybridProctoring);
	
	var _HybridSettings = __webpack_require__(292);
	
	var _HybridSettings2 = _interopRequireDefault(_HybridSettings);
	
	var _Policies = __webpack_require__(893);
	
	var _Policies2 = _interopRequireDefault(_Policies);
	
	var _Reports = __webpack_require__(902);
	
	var _Reports2 = _interopRequireDefault(_Reports);
	
	var _Downloads = __webpack_require__(898);
	
	var _Downloads2 = _interopRequireDefault(_Downloads);
	
	var _Users = __webpack_require__(923);
	
	var _Users2 = _interopRequireDefault(_Users);
	
	var _Intro = __webpack_require__(895);
	
	var _Intro2 = _interopRequireDefault(_Intro);
	
	var _RegisterForm = __webpack_require__(896);
	
	var _RegisterForm2 = _interopRequireDefault(_RegisterForm);
	
	var _Intro3 = __webpack_require__(851);
	
	var _Intro4 = _interopRequireDefault(_Intro3);
	
	var _Form = __webpack_require__(849);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _Sessions = __webpack_require__(913);
	
	var _Sessions2 = _interopRequireDefault(_Sessions);
	
	var _SessionsPending = __webpack_require__(914);
	
	var _SessionsPending2 = _interopRequireDefault(_SessionsPending);
	
	var _SessionDetail = __webpack_require__(303);
	
	var _SessionDetail2 = _interopRequireDefault(_SessionDetail);
	
	var _Settings = __webpack_require__(915);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _SupportTickets = __webpack_require__(919);
	
	var _SupportTickets2 = _interopRequireDefault(_SupportTickets);
	
	var _SessionExpired = __webpack_require__(910);
	
	var _SessionExpired2 = _interopRequireDefault(_SessionExpired);
	
	var _Maintenance = __webpack_require__(876);
	
	var _Maintenance2 = _interopRequireDefault(_Maintenance);
	
	var _Unauthorized = __webpack_require__(920);
	
	var _Unauthorized2 = _interopRequireDefault(_Unauthorized);
	
	var _Dashboard = __webpack_require__(868);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _AppointmentTimeline = __webpack_require__(845);
	
	var _AppointmentTimeline2 = _interopRequireDefault(_AppointmentTimeline);
	
	var _CheckoutQueue = __webpack_require__(847);
	
	var _CheckoutQueue2 = _interopRequireDefault(_CheckoutQueue);
	
	var _ExamAccommodations = __webpack_require__(899);
	
	var _ExamAccommodations2 = _interopRequireDefault(_ExamAccommodations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppRouter = (0, _mobxReact.observer)(function (_React$Component) {
	  _inherits(AppRouter, _React$Component);
	
	  function AppRouter() {
	    _classCallCheck(this, AppRouter);
	
	    return _possibleConstructorReturn(this, (AppRouter.__proto__ || Object.getPrototypeOf(AppRouter)).apply(this, arguments));
	  }
	
	  _createClass(AppRouter, [{
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	
	      return _react2.default.createElement(
	        _reactRouterDom.BrowserRouter,
	        null,
	        _react2.default.createElement(_reactRouterDom.Route, {
	          render: function render(_ref) {
	            var location = _ref.location;
	            return _react2.default.createElement(
	              _reactRouterDom.Switch,
	              { location: location },
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/reports/exam-accommodations', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ routing: routing }, props),
	                    _react2.default.createElement(_ExamAccommodations2.default, Object.assign({ routing: routing }, props))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/reports/appointment-timeline', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ routing: routing }, props),
	                    _react2.default.createElement(_AppointmentTimeline2.default, Object.assign({ routing: routing }, props))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/account/sign-up', render: function render(routing) {
	                  return _react2.default.createElement(_Session2.default, Object.assign({ routing: routing }, props, { content: 'SignUp' }));
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/account/sign-in', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppLoggedOut2.default,
	                    Object.assign({ routing: routing }, props),
	                    _react2.default.createElement(_Session2.default, Object.assign({}, props, { content: 'SignIn' }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/reset-password', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppLoggedOut2.default,
	                    Object.assign({ routing: routing }, props),
	                    _react2.default.createElement(_Session2.default, Object.assign({}, props, { content: 'Reset' }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/update-password', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    null,
	                    _react2.default.createElement(_UpdatePassword2.default, Object.assign({ routing: routing }, props))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/locations', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({}, props, { routing: routing, feature: 'locations' }),
	                    _react2.default.createElement(_Locations2.default, Object.assign({}, props, { Validate: _config.Validate }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/locations/edit/:locationId', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ routing: routing }, props, { feature: 'locations' }),
	                    _react2.default.createElement(_Locations2.default, Object.assign({}, props, { Validate: _config.Validate }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/locations/add', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ routing: routing }, props, { feature: 'locations' }),
	                    _react2.default.createElement(_Locations2.default, Object.assign({}, props, { Validate: _config.Validate }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/locations/schedule/:scheduleLocation', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ routing: routing }, props, { feature: 'locations' }),
	                    _react2.default.createElement(_Locations2.default, Object.assign({}, props, { Validate: _config.Validate }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/locations/schedule/:scheduleLocation/calendar/:calendarId', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ routing: routing }, props, { feature: 'locations' }),
	                    _react2.default.createElement(_Locations2.default, Object.assign({}, props, { Validate: _config.Validate }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/locations/schedule/:scheduleLocation/view/:calendarId', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ routing: routing }, props, { feature: 'locations' }),
	                    _react2.default.createElement(_Locations2.default, Object.assign({}, props, { Validate: _config.Validate }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/messages', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'messages', routing: routing }, props),
	                    _react2.default.createElement(_Inbox2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/messages/view/:messageId', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'messages', routing: routing }, props),
	                    _react2.default.createElement(_Inbox2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/detail/:messageId', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'messages', routing: routing }, props),
	                    _react2.default.createElement(_Inbox2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/payments', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'payments', routing: routing }, props),
	                    _react2.default.createElement(_Payments2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/hybrid-proctoring', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'hybrid-proctoring', routing: routing }, props),
	                    _react2.default.createElement(_HybridProctoring2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/room/edit/:roomSid', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'hybrid-proctoring', routing: routing }, props),
	                    _react2.default.createElement(_HybridSettings2.default, Object.assign({ setCreateNew: false }, props))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/policies', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'policies', routing: routing }, props),
	                    _react2.default.createElement(_Policies2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/reports/downloads', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({}, props, { routing: routing }),
	                    _react2.default.createElement(_Downloads2.default, Object.assign({ routing: routing }, props))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/reports', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'reports', routing: routing }, props),
	                    _react2.default.createElement(_Reports2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/users', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'users', routing: routing }, props),
	                    _react2.default.createElement(_Users2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/register', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    null,
	                    _react2.default.createElement(_Intro2.default, Object.assign({ routing: routing }, props))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/register/step-01', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    Object.assign({ routing: routing }, props),
	                    _react2.default.createElement(_RegisterForm2.default, Object.assign({ routing: routing }, props, { step: 1 }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/register/step-02', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    Object.assign({ routing: routing }, props),
	                    _react2.default.createElement(_RegisterForm2.default, Object.assign({ routing: routing }, props, { step: 2 }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/register/step-03', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    Object.assign({ routing: routing }, props),
	                    _react2.default.createElement(_RegisterForm2.default, Object.assign({ routing: routing }, props, { step: 3 }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/register/step-04', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    Object.assign({ routing: routing }, props),
	                    _react2.default.createElement(_RegisterForm2.default, Object.assign({ routing: routing }, props, { step: 4 }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/register/step-05', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    Object.assign({ routing: routing }, props),
	                    _react2.default.createElement(_RegisterForm2.default, Object.assign({ routing: routing }, props, { step: 5 }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/checkup', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    Object.assign({ feature: 'onboarding', routing: routing }, props),
	                    _react2.default.createElement(_Intro4.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/checkup/step-01', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    Object.assign({ feature: 'onboarding', routing: routing }, props),
	                    _react2.default.createElement(_Form2.default, Object.assign({}, props, { step: 1 }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/checkup/step-02', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    Object.assign({ feature: 'onboarding', routing: routing }, props),
	                    _react2.default.createElement(_Form2.default, Object.assign({}, props, { step: 2 }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/checkup/step-03', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    Object.assign({ feature: 'onboarding', routing: routing }, props),
	                    _react2.default.createElement(_Form2.default, Object.assign({}, props, { step: 3 }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/checkup/step-04', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    Object.assign({ feature: 'onboarding', routing: routing }, props),
	                    _react2.default.createElement(_Form2.default, Object.assign({}, props, { step: 4 }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/checkup/step-05', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    Object.assign({ feature: 'onboarding', routing: routing }, props),
	                    _react2.default.createElement(_Form2.default, Object.assign({}, props, { step: 5 }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/checkup/step-06', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppNoNav2.default,
	                    Object.assign({ feature: 'onboarding', routing: routing }, props),
	                    _react2.default.createElement(_Form2.default, Object.assign({}, props, { step: 6 }))
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/sessions', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'sessions', routing: routing }, props),
	                    _react2.default.createElement(_Sessions2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/sessions/:sessionId', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'sessions', routing: routing }, props),
	                    _react2.default.createElement(_Sessions2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/pending-sessions', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'pending-sessions', routing: routing }, props),
	                    _react2.default.createElement(_SessionsPending2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/view-session/:sessionId', render: function render(routing) {
	                  return _react2.default.createElement(_SessionDetail2.default, Object.assign({ routing: routing }, props, { feature: 'sessions' }));
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/settings', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'settings', content: 'User', routing: routing }, props),
	                    _react2.default.createElement(_Settings2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/support', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'support', routing: routing }, props),
	                    _react2.default.createElement(_SupportTickets2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/support/view/:ticketId', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'support', routing: routing }, props),
	                    _react2.default.createElement(_SupportTickets2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/support/add', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'support', routing: routing }, props),
	                    _react2.default.createElement(_SupportTickets2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/session-expired', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppLoggedOut2.default,
	                    Object.assign({ routing: routing }, props),
	                    _react2.default.createElement(_SessionExpired2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/maintenance', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _AppLoggedOut2.default,
	                    Object.assign({ routing: routing }, props),
	                    _react2.default.createElement(_Maintenance2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/checkout', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'checkout', routing: routing }, props),
	                    _react2.default.createElement(_CheckoutQueue2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/unauthorized', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ routing: routing }, props),
	                    _react2.default.createElement(_Unauthorized2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/refresh', render: null }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'dashboard', routing: routing }, props),
	                    _react2.default.createElement(_Dashboard2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/index.html', render: function render(routing) {
	                  return _react2.default.createElement(_Dashboard2.default, Object.assign({ routing: routing }, props));
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { path: '/#/*', render: function render(routing) {
	                  return _react2.default.createElement(
	                    _App2.default,
	                    Object.assign({ feature: 'dashboard', routing: routing }, props),
	                    _react2.default.createElement(_Dashboard2.default, props)
	                  );
	                } }),
	              _react2.default.createElement(_reactRouterDom.Route, { path: '*', render: function render(routing) {
	                  return _react2.default.createElement(_NotFound2.default, Object.assign({ routing: routing }, props));
	                } })
	            );
	          }
	        })
	      );
	    }
	  }]);
	
	  return AppRouter;
	}(_react2.default.Component));
	
	/*
	  LEAVING THIS HERE FOR REFERENCE
	  <Provider {...stores}>
	    <Switch history={history} {...stores}>
	      <Route path="account" component={AppLoggedOut}>
	        <Route path="sign-up" component={(props) => <Session {...stores} content="SignUp" />} />
	        <Route path="sign-in" component={(props) => <Session {...stores} content="SignIn" />} />
	        <Route path="*" component={(props) => <NotFound {...stores} />} />
	      </Route>
	      <Route path="reset-password" component={AppLoggedOut}>
	        <IndexRoute component={(props) => <Session {...stores} content="Reset" />} />
	        <Route path="*" component={(props) => <NotFound {...stores} />} />
	      </Route>
	      <Route path="update-password" component={AppNoNav}>
	        <IndexRoute component={(props) => <UpdatePassword {...stores} />} />
	        <Route path="*" component={(props) => <NotFound {...stores} />} />
	      </Route>
	      <Route
	        path="locations"
	        component={App}
	        feature="locations"
	      >
	        <IndexRoute component={(props) => <Locations {...stores} Validate={Validate} />} />
	        <Route path="edit/:locationId" component={(props) => <Locations {...stores} Validate={Validate} />}></Route>
	        <Route path="add" component={(props) => <Locations {...stores} Validate={Validate} />}></Route>
	        <Route path="schedule/:scheduleLocation" component={(props) => <Locations {...stores} Validate={Validate} />}></Route>
	        <Route path="schedule/:scheduleLocation/calendar/:calendarId" component={(props) => <Locations {...stores} Validate={Validate} />}></Route>
	        <Route path="schedule/:scheduleLocation/view/:calendarId" component={(props) => <Locations {...stores} Validate={Validate} />}></Route>
	        <Route path="*" component={(props) => <NotFound {...stores} Validate={Validate} />} />
	      </Route>
	      <Route
	        path="messages"
	        component={App}
	        feature="messages"
	      >
	        <IndexRoute component={(props) => <Messages {...stores} />} />
	        <Route path="view/:messageId" component={(props) => <Messages {...stores} />} />
	        <Route path="detail/:messageId" component={(props) => <Messages {...stores} />} />
	        <Route path="*" component={(props) => <NotFound {...stores} Validate={Validate} />} />
	      </Route>
	      <Route
	        path="payments"
	        component={App}
	        feature="payments"
	      >
	        <IndexRoute component={(props) => <Payments {...stores} />} />
	        <Route path="*" component={(props) => <NotFound {...stores} Validate={Validate} />} />
	      </Route>
	      <Route
	          path="hybrid-proctoring"
	          component={App}
	          feature="hybrid-proctoring"
	      >
	        <IndexRoute component={(props) => <HybridProctoring {...stores} />} />
	        <Route path="*" component={(props) => <NotFound {...stores} Validate={Validate} />} />
	      </Route>
	      <Route
	          path="room/edit/:roomSid"
	          component={App}
	          feature="hybrid-proctoring"
	      >
	        <IndexRoute component={(props) => <HybridSettings {...stores} setCreateNew={false} />} />
	        <Route path="*" component={(props) => <NotFound {...stores} Validate={Validate} />} />
	      </Route>
	      <Route
	        path="policies"
	        component={App}
	        feature="policies"
	      >
	        <IndexRoute component={(props) => <Policies {...stores} />} />
	        <Route path="*" component={(props) => <NotFound {...stores} Validate={Validate} />} />
	      </Route>
	      <Route
	        path="reports"
	        component={App}
	        feature="reports"
	      >
	        <IndexRoute component={(props) => <Reports {...stores} />} />
	        <Route path="downloads" component={(props) => <Downloads {...stores} />} />
	        <Route path="*" component={(props) => <Reports {...stores} />} />
	      </Route>
	      <Route
	        path="users"
	        component={App}
	        feature="users"
	      >
	        <IndexRoute component={(props) => <Users {...stores} />} />
	        <Route path="users" component={(props) => <Users {...stores} />} />
	        <Route path="*" component={(props) => <Users {...stores} />} />
	      </Route>
	      <Route
	        path="register"
	        component={AppNoNav}
	        feature="register"
	      >
	        <IndexRoute component={(props) => <RegisterIntro {...stores} />} />
	        <Route path="step-01" component={(props) => <RegisterForm {...stores} step={1} />} />
	        <Route path="step-02" component={(props) => <RegisterForm {...stores} step={2} />} />
	        <Route path="step-03" component={(props) => <RegisterForm {...stores} step={3} />} />
	        <Route path="step-04" component={(props) => <RegisterForm {...stores} step={4} />} />
	        <Route path="step-05" component={(props) => <RegisterForm {...stores} step={5} />} />
	        <Route path="*" component={(props) => <NotFound {...stores} />} />
	      </Route>
	      <Route
	        path="checkup"
	        component={AppNoNav}
	        feature="onboarding"
	      >
	        <IndexRoute component={(props) => <CheckupIntro {...stores} />} />
	        <Route path="step-01" component={(props) => <CheckupForm {...stores} step={1} />} />
	        <Route path="step-02" component={(props) => <CheckupForm {...stores} step={2} />} />
	        <Route path="step-03" component={(props) => <CheckupForm {...stores} step={3} />} />
	        <Route path="step-04" component={(props) => <CheckupForm {...stores} step={4} />} />
	        <Route path="step-05" component={(props) => <CheckupForm {...stores} step={5} />} />
	        <Route path="step-06" component={(props) => <CheckupForm {...stores} step={6} />} />
	        <Route path="*" component={(props) => <NotFound {...stores} />} />
	      </Route>
	      <Route
	        path="sessions"
	        component={App}
	        feature="sessions"
	      >
	        <IndexRoute component={(props) => <Sessions {...stores} />} />
	        <Route path=":sessionId" component={(props) => <Sessions {...stores} />}></Route>
	        <Route path="*" component={(props) => <NotFound {...stores} />} />
	      </Route>
	      <Route
	        path="pending-sessions"
	        component={App}
	        feature="pending-sessions"
	      >
	        <IndexRoute component={(props) => <SessionsPending {...stores} />} />
	        <Route path="*" component={(props) => <NotFound {...stores} />} />
	      </Route>
	      <Route
	        path="view-session/:sessionId"
	        component={App}
	        feature="sessions"
	      >
	        <IndexRoute component={(props) => <SessionDetail {...stores} />} />
	      </Route>
	      <Route
	        path="settings"
	        component={App}
	        feature="settings"
	      >
	        <IndexRoute component={(props) => <Settings {...stores} content="User" />} />
	        <Route path="*" component={(props) => <NotFound {...stores} />} />
	      </Route>
	      <Route
	        path="support"
	        component={App}
	        feature="support"
	      >
	        <IndexRoute component={(props) => <SupportTickets {...stores} />} />
	        <Route path="view/:ticketId" component={(props) => <SupportTickets {...stores} />} />
	        <Route path="add" component={(props) => <SupportTickets {...stores} />} />
	        <Route path="*" component={(props) => <NotFound {...stores} />} />
	      </Route>
	      <Route path="session-expired" component={AppLoggedOut}>
	        <IndexRoute component={(props) => <SessionExpired {...stores} />} />
	        <Route path="*" component={(props) => <NotFound {...stores} />} />
	      </Route>
	      <Route
	        path="unauthorized"
	        component={App}
	      >
	        <IndexRoute component={(props) => <Unauthorized {...stores} />} />
	        <Route path="unauthorized" component={(props) => <Unauthorized {...stores} />}/>
	        <Route path="*" component={(props) => <NotFound {...stores} />} />
	      </Route>
	      <Route path="refresh" component={null} />
	      <Route
	        path="/"
	        component={App}
	        feature="dashboard"
	      >
	        <IndexRoute component={(props) => <Dashboard {...stores} />} />
	        <Route path="index.html" component={(props) => <Dashboard {...stores} />} />
	        <Route path="*" component={(props) => <NotFound {...stores} />} />
	      </Route>
	    </Router>
	  </Provider>
	 */
	exports.default = AppRouter;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  courseData: null,
	  getCourseData: (0, _mobx.action)(function (installSid, courseSid, backgroundLoad) {
	    if (!backgroundLoad) {
	      _SessionStore2.default.startLoading('Loading…', 'getCourseData');
	    } else {
	      _SessionStore2.default.startBackgroundLoading('getCourseData');
	    }
	
	    _config.api.get('/installs/' + installSid + '/courses/' + courseSid).then(function (response) {
	      obx.courseData = response.data;
	
	      if (!backgroundLoad) {
	        _SessionStore2.default.finishLoading('getCourseData');
	      } else {
	        _SessionStore2.default.finishBackgroundLoading('getCourseData');
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get roster
	  courseRoster: [],
	  getCourseRoster: (0, _mobx.action)(function (roles, installSid, courseSid, backgroundLoad) {
	    if (!backgroundLoad) {
	      _SessionStore2.default.startLoading('Loading…', 'CourseRoster');
	    } else {
	      _SessionStore2.default.startBackgroundLoading('CourseRoster');
	    }
	
	    obx.courseRoster = [];
	
	    if (roles) {
	      var roleData = '';
	
	      if (roles.constructor === Array) {
	
	        for (var i = 0; i < roles.length; i++) {
	          if (i === 0) {
	            roleData += roles[i];
	          } else {
	            roleData += '&roles=' + roles[i];
	          }
	        }
	      } else {
	        roleData = roles;
	      }
	
	      if (typeof installSid === 'undefined') {
	        installSid = _SessionStore2.default.userData.installSid;
	      }
	
	      if (typeof courseSid === 'undefined') {
	        courseSid = _SessionStore2.default.userData.courseSid;
	      }
	
	      _config.api.get('/installs/' + installSid + '/courses/' + courseSid + '/enrollments?roles=' + roleData).then(function (response) {
	        obx.courseRoster = response.data.results;
	
	        if (!backgroundLoad) {
	          _SessionStore2.default.finishLoading('CourseRoster');
	        } else {
	          _SessionStore2.default.finishBackgroundLoading('CourseRoster');
	        }
	      }).catch(function (error) {
	        _SessionStore2.default.throwError(error);
	      });
	    } else {
	      _config.api.get('/installs/' + _SessionStore2.default.userData.installSid + '/courses/' + _SessionStore2.default.userData.courseSid + '/enrollments').then(function (response) {
	        obx.courseRoster = response.data.results;
	        _SessionStore2.default.finishLoading('CourseRoster');
	      }).catch(function (error) {
	        _SessionStore2.default.throwError(error);
	      });
	    }
	  }),
	  // Get Proctor Users
	  proctorUsers: [],
	  proctorUser: null,
	  listProctorUsers: (0, _mobx.action)(function (userSid) {
	    _SessionStore2.default.startLoading('Loading…', 'listProctorUsers');
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/users').then(function (response) {
	      obx.proctorUsers = response.data.results;
	      if (userSid) {
	        response.data.results.some(function (user) {
	          if (user.sid === userSid) {
	            obx.proctorUser = user;
	            return true;
	          }
	          return false;
	        });
	      }
	      _SessionStore2.default.finishLoading('listProctorUsers');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  // Edit Proctor User
	  updateProctorUser: (0, _mobx.action)(function (data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'editProctorUsers');
	    _config.api.patch('proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/users/' + obx.proctorUser.sid, data).then(function (response) {
	      obx.courseRoster = response.data.results;
	      _SessionStore2.default.finishLoading('editProctorUsers');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  // Create New Proctor User
	  newProctorUser: (0, _mobx.action)(function (data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'createProctorUser');
	    _config.api.post('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/users/create', data).then(function (response) {
	      obx.courseRoster = response.data.results;
	      _SessionStore2.default.finishLoading('editProctorUsers');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	
	  // Delete Proctor User
	  deleteProctorUser: (0, _mobx.action)(function (callback) {
	    _SessionStore2.default.startLoading('Loading…', 'deleteProctorAccountUser');
	    _config.api.delete('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/users/' + obx.proctorUser.sid).then(function (response) {
	      obx.courseRoster = response.data.results;
	      _SessionStore2.default.finishLoading('deleteProctorAccountUser');
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(29);
	
	var _axios = __webpack_require__(161);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  feature: null,
	  help: null,
	  helpLoaded: false,
	  getHelp: (0, _mobx.action)(function () {
	    if (!obx.helpLoaded) {
	      var timestamp = new Date().getTime();
	
	      _axios2.default.get('https://raw.githubusercontent.com/SmarterServices/smarterproctoring-docs/master/docs.json?t=' + timestamp).then(function (response) {
	        obx.help = response.data;
	        obx.helpLoaded = true;
	      });
	    }
	  })
	});
	
	exports.default = obx;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(76);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _mobx = __webpack_require__(29);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _config = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var obx = (0, _mobx.observable)({
	    /**
	     * List available hybrid rooms.
	     *
	     * @function listAvailableRooms
	     */
	    availableRooms: [],
	    proctorLocations: [],
	
	    listAvailableRooms: (0, _mobx.action)(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	        var url, response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _SessionStore2.default.startLoading('Loading...', 'listAvailableRooms');
	                        url = "/hybrid/locations/rooms";
	                        _context.prev = 2;
	                        _context.next = 5;
	                        return _config.api.get(url);
	
	                    case 5:
	                        response = _context.sent;
	
	                        obx.availableRooms = response.data.rooms;
	                        obx.proctorLocations = response.data.locations;
	                        if (response.data.locations.length === 1 && callback) {
	                            // if there is only one location, we will hide the dropdown in HybridRooms, so we need to set the focused here
	                            obx.focusedProctorLocation = response.data.locations[0].proctorAccountLocationSid;
	                            callback();
	                        }
	                        _context.next = 14;
	                        break;
	
	                    case 11:
	                        _context.prev = 11;
	                        _context.t0 = _context["catch"](2);
	
	                        _SessionStore2.default.throwError(_context.t0);
	
	                    case 14:
	                        _SessionStore2.default.finishLoading('listAvailableRooms');
	
	                    case 15:
	                    case "end":
	                        return _context.stop();
	                }
	            }
	        }, _callee, this, [[2, 11]]);
	    }))),
	
	    focusedProctorLocation: 'Default',
	
	    setFocusedLocation: function setFocusedLocation(proctorLocationSid) {
	        obx.focusedProctorLocation = proctorLocationSid;
	    },
	
	    installs: null,
	
	    /**
	     * Get all available installs.
	     *
	     * @async
	     * @function listInstalls
	     * @param {string} proctorSid
	     */
	    listInstalls: (0, _mobx.action)(function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(proctorSid) {
	            var url, response;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            url = "/proctors/" + proctorSid + "/permittedInstalls";
	                            _context2.next = 3;
	                            return _config.api.get(url).then(function (response) {
	                                return response;
	                            }).catch(function (error) {
	                                _SessionStore2.default.throwError(error);
	                            });
	
	                        case 3:
	                            response = _context2.sent;
	                            return _context2.abrupt("return", response.data.results);
	
	                        case 5:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined);
	        }));
	
	        return function (_x2) {
	            return _ref2.apply(this, arguments);
	        };
	    }()),
	
	    /**
	     * Get all available courses for instructors.
	     *
	     * @async
	     * @function listInstructorCourses
	     * @param {string} installSid
	     * @param {string} userSid
	     */
	    listInstructorCourses: (0, _mobx.action)(function () {
	        var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(installSid, userSid) {
	            var url, response;
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            url = "/installs/" + installSid + "/courses?instructorSid=" + userSid;
	                            _context3.next = 3;
	                            return _config.api.get(url).then(function (response) {
	                                return response;
	                            }).catch(function (error) {
	                                _SessionStore2.default.throwError(error);
	                            });
	
	                        case 3:
	                            response = _context3.sent;
	                            return _context3.abrupt("return", response.data.results);
	
	                        case 5:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined);
	        }));
	
	        return function (_x3, _x4) {
	            return _ref3.apply(this, arguments);
	        };
	    }()),
	
	    /**
	     * Add proctor to task router, create a proctor sync doc
	     *
	     * @async
	     * @function createRoom
	     * @param {object} payload
	     */
	    createProctorRoom: (0, _mobx.action)(function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(payload) {
	            var url;
	            return _regenerator2.default.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            _SessionStore2.default.startLoading('Loading...', 'createProctorRoom');
	
	                            url = "/hybrid/proctors/location/" + obx.focusedProctorLocation + "/room";
	                            _context4.next = 4;
	                            return _config.api.post(url, payload).then(function (response) {
	                                _SessionStore2.default.finishLoading('createProctorRoom');
	                            }).catch(function (error) {
	                                _SessionStore2.default.throwError(error);
	                            });
	
	                        case 4:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, undefined);
	        }));
	
	        return function (_x5) {
	            return _ref4.apply(this, arguments);
	        };
	    }()),
	
	    deleteProctorRoom: function deleteProctorRoom(roomSid) {
	        _SessionStore2.default.startLoading('Loading...', 'deleteProctorRoom');
	
	        var url = "hybrid/rooms/" + roomSid;
	
	        _config.api.delete(url).then(function (response) {
	            // Remove the room from the list because the page will not rerender after deletion
	            obx.availableRooms.some(function (room, i) {
	                if (room.sid === roomSid) {
	                    obx.availableRooms.splice(i, 1);
	                    return true;
	                } else {
	                    return false;
	                }
	            });
	
	            _SessionStore2.default.finishLoading('deleteProctorRoom');
	        }).catch(function (error) {
	            _SessionStore2.default.throwError(error);
	        });
	    },
	
	    roomDefaultValues: {},
	    isEditing: false,
	
	    stopEditing: function stopEditing() {
	        obx.roomDefaultValues = {};
	        obx.isEditing = false;
	    },
	
	    startEditing: function startEditing(roomDefaults) {
	        obx.roomDefaultValues = roomDefaults;
	        obx.isEditing = true;
	    },
	
	    /**
	     * Update a room’s settings.
	     *
	     * @async
	     * @function updateRoom
	     * @param {string} roomSid
	     * @param {object} payload
	     */
	    updateProctorRoom: (0, _mobx.action)(function () {
	        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(roomSid, payload) {
	            var url;
	            return _regenerator2.default.wrap(function _callee5$(_context5) {
	                while (1) {
	                    switch (_context5.prev = _context5.next) {
	                        case 0:
	                            _SessionStore2.default.startLoading('updateProctorRoom');
	
	                            url = "/hybrid/rooms/" + roomSid;
	                            _context5.next = 4;
	                            return _config.api.patch(url, payload).then(function () {
	                                _SessionStore2.default.finishLoading('updateProctorRoom');
	                                _SessionStore2.default.showToaster('Room settings saved', 'success');
	                            }).catch(function (error) {
	                                _SessionStore2.default.throwError(error);
	                            });
	
	                        case 4:
	                        case "end":
	                            return _context5.stop();
	                    }
	                }
	            }, _callee5, undefined);
	        }));
	
	        return function (_x6, _x7) {
	            return _ref5.apply(this, arguments);
	        };
	    }()),
	    editProctorRoomStartingOutside: (0, _mobx.action)(function () {
	        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(roomSid) {
	            var index;
	            return _regenerator2.default.wrap(function _callee6$(_context6) {
	                while (1) {
	                    switch (_context6.prev = _context6.next) {
	                        case 0:
	                            index = obx.availableRooms.findIndex(function (room) {
	                                return room.sid === roomSid;
	                            });
	
	                            obx.startEditing(obx.availableRooms[index]);
	
	                        case 2:
	                        case "end":
	                            return _context6.stop();
	                    }
	                }
	            }, _callee6, undefined);
	        }));
	
	        return function (_x8) {
	            return _ref6.apply(this, arguments);
	        };
	    }()),
	
	    joinHybridProctoringRoom: (0, _mobx.action)(function () {
	        var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(roomSid) {
	            var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
	            var url, result, foundDomain, redirectUrl;
	            return _regenerator2.default.wrap(function _callee7$(_context7) {
	                while (1) {
	                    switch (_context7.prev = _context7.next) {
	                        case 0:
	                            _SessionStore2.default.startLoading('Loading...', 'joinProctorRoom');
	
	                            url = "/hybrid/proctors/join/rooms/" + roomSid;
	                            _context7.next = 4;
	                            return _config.api.get(url);
	
	                        case 4:
	                            result = _context7.sent;
	                            foundDomain = domain === 'alpha' ? _config.config.hybridAlphaDomain : domain === 'beta' ? _config.config.hybridBetaDomain : _config.config.hybridDomain;
	
	
	                            _SessionStore2.default.finishLoading('joinProctorRoom');
	                            if (result.data.success) {
	                                redirectUrl = foundDomain + "/" + roomSid + "?proctorAccountUserSid=" + result.data.proctorAccountUserSid + "&spToken=" + _SessionStore2.default.token + "&clientToken=" + result.data.token;
	
	
	                                window.open(redirectUrl, '_self');
	                            } else {
	                                _SessionStore2.default.throwError({
	                                    response: {
	                                        data: {
	                                            message: 'You are already active in a hybrid room. If you just exited a room, it can take up to 10 seconds to make you inactive.'
	                                        }
	                                    }
	                                });
	                            }
	
	                        case 8:
	                        case "end":
	                            return _context7.stop();
	                    }
	                }
	            }, _callee7, undefined);
	        }));
	
	        return function (_x10) {
	            return _ref7.apply(this, arguments);
	        };
	    }()),
	
	    joinVtcProctoringRoom: (0, _mobx.action)(function () {
	        var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(roomSid) {
	            var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
	            var redirectUrl;
	            return _regenerator2.default.wrap(function _callee8$(_context8) {
	                while (1) {
	                    switch (_context8.prev = _context8.next) {
	                        case 0:
	                            _SessionStore2.default.startLoading('Loading...', 'joinProctorRoom');
	
	                            _SessionStore2.default.finishLoading('joinProctorRoom');
	                            redirectUrl = _config.config.platformDomain + "/vtc/rooms/" + roomSid + "?token=" + _SessionStore2.default.token;
	
	
	                            window.open(redirectUrl, '_blank');
	
	                        case 4:
	                        case "end":
	                            return _context8.stop();
	                    }
	                }
	            }, _callee8, undefined);
	        }));
	
	        return function (_x12) {
	            return _ref8.apply(this, arguments);
	        };
	    }()),
	
	    checkoutSessionCount: 0,
	    checkoutSessions: [],
	    listCheckoutSessions: (0, _mobx.action)(function () {
	        var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(limit, offset) {
	            var updateList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	            var url;
	            return _regenerator2.default.wrap(function _callee9$(_context9) {
	                while (1) {
	                    switch (_context9.prev = _context9.next) {
	                        case 0:
	                            url = "/proctors/" + _SessionStore2.default.account.sid + "/sessions/checkout";
	
	
	                            if (limit && offset) {
	                                url += "?limit=" + limit + "&offset=" + offset;
	                            } else if (limit) {
	                                url += "?limit=" + limit;
	                            } else if (offset) {
	                                url += "?offset=" + offset;
	                            }
	
	                            _context9.next = 4;
	                            return _config.api.get(url).then(function (result) {
	                                obx.checkoutSessionCount = result.data.total;
	
	                                if (updateList) {
	                                    obx.checkoutSessions = result.data.results;
	                                }
	
	                                return result.data;
	                            }).catch(function (error) {
	                                _SessionStore2.default.throwError(error);
	                            });
	
	                        case 4:
	                            return _context9.abrupt("return", _context9.sent);
	
	                        case 5:
	                        case "end":
	                            return _context9.stop();
	                    }
	                }
	            }, _callee9, undefined);
	        }));
	
	        return function (_x14, _x15) {
	            return _ref9.apply(this, arguments);
	        };
	    }())
	});
	
	exports.default = obx;

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  cancellationPolicies: [],
	  // Get cancellation policies
	  getCancellationPolicies: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'getCancellationPolicies');
	
	    obx.courseRoster = [];
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/cancellationPolicies').then(function (response) {
	      obx.cancellationPolicies = response.data.results;
	      _SessionStore2.default.finishLoading('getCancellationPolicies');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Initialize a new cancellation policy
	  initCancellationPolicy: (0, _mobx.action)(function () {
	    var newPolicy = {
	      title: 'New Cancellation Policy',
	      dateRange: false,
	      effectiveDate: null,
	      expirationDate: null,
	      sid: Date.now(),
	      versions: [{
	        title: 'New Cancellation Policy',
	        effectiveDate: null,
	        expirationDate: null,
	        notes: '',
	        rules: [{
	          minutesPrior: null,
	          penaltyPercentage: 0
	        }],
	        status: 'enabled'
	      }]
	    };
	
	    obx.cancellationPolicies.push(newPolicy);
	  }),
	  // Create cancellation policy
	  createCancellationPolicy: (0, _mobx.action)(function (policy) {
	    _SessionStore2.default.startLoading('Loading…', 'createCancellationPolicy');
	
	    if (!policy.effectiveDate) {
	      policy.effectiveDate = '2000-01-01T05:00:00.000Z';
	    }
	
	    if (!policy.expirationDate) {
	      policy.expirationDate = '2070-01-01T05:00:00.000Z';
	    }
	
	    // Remove any empty properties
	    Object.keys(policy).forEach(function (property) {
	      if (!policy[property]) {
	        delete policy[property];
	      }
	    });
	
	    _config.api.post('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/cancellationPolicies', policy).then(function (response) {
	      _SessionStore2.default.finishLoading('createCancellationPolicy');
	      obx.getCancellationPolicies();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update cancellation policy
	  updateCancellationPolicy: (0, _mobx.action)(function (policy) {
	    _SessionStore2.default.startLoading('Loading…', 'updateCancellationPolicy');
	
	    if (!policy.effectiveDate) {
	      policy.effectiveDate = '2000-01-01T05:00:00.000Z';
	    }
	
	    if (!policy.expirationDate) {
	      policy.expirationDate = '2070-01-01T05:00:00.000Z';
	    }
	
	    // API returns status as uppercase, but only accepts lowercase…
	    policy.status = policy.status.toLowerCase();
	
	    // Remove any empty properties
	    Object.keys(policy).forEach(function (property) {
	      if (!policy[property]) {
	        delete policy[property];
	      }
	    });
	
	    _config.api.put('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/cancellationPolicies/' + policy.sid, policy).then(function (response) {
	      _SessionStore2.default.finishLoading('updateCancellationPolicy');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Delete cancellation policy
	  deleteCancellationPolicy: (0, _mobx.action)(function (policySid) {
	    _SessionStore2.default.startLoading('Loading…', 'deleteCancellationPolicy');
	
	    _config.api.delete('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/cancellationPolicies/' + policySid).then(function (response) {
	      _SessionStore2.default.finishLoading('deleteCancellationPolicy');
	      obx.getCancellationPolicies();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	var _SettingsStore = __webpack_require__(166);
	
	var _SettingsStore2 = _interopRequireDefault(_SettingsStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Components
	var obx = (0, _mobx.observable)({
	  registerData: {
	    accountData: {}
	  },
	  getLocalStorage: (0, _mobx.action)(function (data) {
	    obx.registerData = data;
	  }),
	  updateAccountInfo: (0, _mobx.action)(function (data) {
	    for (var key in data) {
	      if (data[key]) {
	        var newData = data[key];
	        obx.registerData.accountData[key] = newData;
	        obx.registerData.accountData.username = obx.registerData.accountData.email;
	      }
	    }
	
	    if (_SessionStore2.default.hasSessionStorage) {
	      sessionStorage.setItem('registerData', JSON.stringify(obx.registerData));
	    } else {
	      document.cookie = 'registerData=' + JSON.stringify(obx.registerData);
	    }
	  }),
	  // Get proctor data
	  getProctorData: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'GetProctorData');
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid).then(function (response) {
	      obx.registerData.accountData = response.data;
	      _SessionStore2.default.finishLoading('GetProctorData');
	    });
	  }),
	  // Create proctor account
	  createProctor: (0, _mobx.action)(function (func) {
	    _SessionStore2.default.startLoading('Loading…', 'CreateProctor');
	
	    var data = obx.registerData.accountData;
	
	    data.type = "individual-proctor";
	
	    delete data.metadata;
	
	    _config.api.post('/proctors', data).then(function (response) {
	      _SessionStore2.default.finishLoading('CreateProctor');
	      _SessionStore2.default.login(obx.registerData.accountData.username, obx.registerData.accountData.password, func);
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update proctor account
	  updateProctor: (0, _mobx.action)(function (data, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'UpdateProctor');
	
	    var payload = obx.registerData.accountData;
	
	    for (var key in data) {
	      if (data[key] || key === 'active') {
	        payload[key] = data[key];
	      }
	
	      if (key === 'forceSetupVerification') {
	        payload[key] = data[key];
	      }
	    }
	
	    // Make sure testing administrator cannot be selected
	    var taIndex = payload.proctorTypes.indexOf(_config.config.testingAdministratorSid);
	
	    if (taIndex > -1) {
	      payload.proctorTypes.splice(taIndex, 1);
	    }
	
	    delete payload.sid;
	    delete payload.authentication;
	    delete payload.createdDate;
	    delete payload.deploymentOwnerSid;
	    delete payload.editDate;
	    delete payload.email;
	    delete payload.firstName;
	    delete payload.lastName;
	    delete payload.type;
	    delete payload.verificationDate;
	    delete payload.verifiedBy;
	    delete payload.metadata;
	    delete payload.image;
	
	    if (!payload.timeZoneSid) {
	      delete payload.timeZoneSid;
	    }
	
	    _config.api.put('/proctors/' + _SessionStore2.default.userData.proctorAccountSid, payload).then(function (response) {
	      _SessionStore2.default.finishLoading('CreateProctor');
	
	      _SettingsStore2.default.userSettings = response.data;
	
	      if (callback) {
	        callback();
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	exports.default = obx;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  packages: [],
	  selectedPackage: {},
	  selectedPackageSids: [],
	  resetPackages: (0, _mobx.action)(function () {
	    obx.packages = [];
	    obx.selectedPackage = {};
	  }),
	  // List all review packages
	  getReviewPackages: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'GetReviewPackages');
	
	    // Reset package data
	    obx.resetPackages();
	
	    _config.api.get('proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/reviewPackages').then(function (response) {
	      obx.packages = response.data.results;
	      _SessionStore2.default.finishLoading('Loading…', 'GetReviewPackages');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get in-progress review package
	  getCurrentReviewPackage: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'getCurrentReviewPackage');
	
	    // Reset package data
	    obx.resetPackages();
	
	    _config.api.get('proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/reviewPackages?limit=1&status=incomplete').then(function (response) {
	      if (response.data.results.length > 0) {
	        obx.packages = response.data.results;
	      } else {
	        obx.getNextReviewPackage();
	      }
	
	      _SessionStore2.default.finishLoading('Loading…', 'getCurrentReviewPackage');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get the next available review package
	  getNextReviewPackage: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'GetNextReviewPackage');
	
	    // Reset package data
	    obx.resetPackages();
	
	    _config.api.get('proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/nextReviewPackage?limit=1').then(function (response) {
	      obx.packages = response.data.results;
	      _SessionStore2.default.finishLoading('Loading…', 'GetNextReviewPackage');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get package access keys
	  getPackageSessions: (0, _mobx.action)(function (packageSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'GetPackageSessions');
	
	    _config.api.get('proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/reviewPackages/' + packageSid).then(function (response) {
	      obx.selectedPackage = response.data;
	
	      // Loop through the package sessions to get the access keys
	      obx.selectedPackage.sessions.forEach(function (session) {
	        if (session) {
	          obx.selectedPackageSids.push(session.accessKey);
	        }
	      });
	
	      if (callback) {
	        callback();
	      }
	
	      _SessionStore2.default.finishLoading('Loading…', 'GetPackageSessions');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Claim package
	  claimPackage: (0, _mobx.action)(function (packageSid, callback) {
	    _SessionStore2.default.startLoading('Loading…', 'ClaimPackage');
	
	    var data = {
	      proctorUserSid: _SessionStore2.default.userData.sid
	    };
	
	    _config.api.post('proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/reviewPackages/' + packageSid, data).then(function (response) {
	      // Get the access keys for the sessions in the claimed package
	      obx.getPackageSessions(packageSid, callback);
	
	      _SessionStore2.default.finishLoading('ClaimPackage');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobx = __webpack_require__(29);
	
	var _config = __webpack_require__(24);
	
	var _SessionStore = __webpack_require__(33);
	
	var _SessionStore2 = _interopRequireDefault(_SessionStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var obx = (0, _mobx.observable)({
	  // Get ticket types
	  ticketTypes: [],
	  getTicketTypes: (0, _mobx.action)(function () {
	    _SessionStore2.default.startLoading('Loading…', 'GetTicketTypes');
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/ticketFields').then(function (response) {
	      obx.ticketTypes = response.data.ticketType;
	
	      // Finish loading
	      _SessionStore2.default.finishLoading('GetTicketTypes');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Get tickets
	  tickets: [],
	  filteredTickets: [],
	  getTickets: (0, _mobx.action)(function (enrollmentSid, examSid) {
	    _SessionStore2.default.startLoading('Loading…', 'GetTickets');
	
	    var query = '?';
	
	    if (typeof enrollmentSid !== 'undefined') {
	      query += 'enrollmentSid=' + enrollmentSid;
	    }
	
	    if (typeof examSid !== 'undefined') {
	      query += '&examSid=' + examSid;
	    }
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/tickets' + query).then(function (response) {
	      obx.tickets = response.data.results;
	      obx.filteredTickets = response.data.results;
	
	      // Finish loading
	      _SessionStore2.default.finishLoading('GetTickets');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Filter tickets
	  filterTickets: (0, _mobx.action)(function (newFilteredTickets) {
	    obx.filteredTickets = newFilteredTickets;
	  }),
	  // Get individual ticket
	  activeTicket: {},
	  getTicket: (0, _mobx.action)(function (ticketSid, bypassLoad) {
	    if (!bypassLoad) {
	      _SessionStore2.default.startLoading('Loading…', 'GetTicket');
	      obx.activeTicket = {};
	    }
	
	    _config.api.get('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/tickets/' + ticketSid).then(function (response) {
	      obx.activeTicket = response.data;
	
	      // Finish loading
	      if (!bypassLoad) {
	        _SessionStore2.default.finishLoading('GetTicket');
	      }
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Post ticket
	  postTicket: (0, _mobx.action)(function (data, func) {
	    _SessionStore2.default.startLoading('Loading…', 'PostTicket');
	
	    _config.api.post('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/tickets', data).then(function (response) {
	      // Finish loading
	      func();
	      _SessionStore2.default.finishLoading('PostTicket');
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Post reply
	  postReply: (0, _mobx.action)(function (ticketSid, data, func) {
	    _config.api.post('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/tickets/' + ticketSid, data).then(function (response) {
	      // Finish loading
	      obx.getTicket(ticketSid, true);
	      func();
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  }),
	  // Update ticket status
	  updateTicket: (0, _mobx.action)(function (ticketSid, status) {
	    var data = {
	      status: status
	    };
	
	    _config.api.put('/proctors/' + _SessionStore2.default.userData.proctorAccountSid + '/tickets/' + ticketSid, data).then(function (response) {
	      // Finish loading
	      obx.getTicket(ticketSid, true);
	    }).catch(function (error) {
	      _SessionStore2.default.throwError(error);
	    });
	  })
	});
	
	// Components
	exports.default = obx;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _client = __webpack_require__(1143);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _atatusSpa = __webpack_require__(819);
	
	var _atatusSpa2 = _interopRequireDefault(_atatusSpa);
	
	__webpack_require__(1039);
	
	var _stores = __webpack_require__(118);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	var _routes = __webpack_require__(924);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//const history = syncHistoryWithStore(hashHistory, routingStore);
	
	// Import stores
	// Import React
	_atatusSpa2.default.config('7bab4b9172ba4a0bbdf9cdcd710de4d8', {
	  console: true,
	  consoleTimeline: true,
	  customData: JSON.parse(sessionStorage.getItem('userData'))
	}).install();
	
	// Add the user agent as an attribute on the document
	
	
	// import { createHistory, useBasename } from 'history';
	
	
	// Import styles
	
	
	// Import dependencies
	var ua = navigator.userAgent;
	document.querySelector('html').setAttribute('data-ua', ua);
	
	// Flag IE 10
	if (ua.indexOf('MSIE 10.0') > -1) {
	  document.querySelector('html').className += ' ie-true lt-ie11';
	}
	
	// Flag IE 11
	if (!!window.MSInputMethodContext && !!document.documentMode) {
	  document.querySelector('html').className += ' ie-true';
	}
	
	// Aids with button focus styles
	document.querySelector('body').addEventListener('click', function (e) {
	  if (e.target.className && typeof e.target.className === 'string') {
	    if (e.target.className.indexOf('btn') > -1 || e.target.className.indexOf('calendar__nav') > -1) {
	      e.target.className += ' btn-clicked';
	
	      e.target.addEventListener('blur', function (e) {
	        e.target.className = e.target.className.replace('btn-clicked', '');
	      });
	    }
	  }
	});
	
	// Track pageviews
	/*
	let gaTimeout = null;
	
	/*history.listen(location => {
	  // Track on route change
	  if(window.ga) {
	    trackPageview(location.pathname + location.search);
	  }
	});
	
	// Track on initial load
	trackPageview(history.getCurrentLocation().pathname + history.getCurrentLocation().search);
	function sanitizeUrl(url) {
	  // Make sure there’s a leading slash
	  if(url.charAt(0) !== '/') {
	    url = `/${url}`;
	  }
	
	  // Replace sid segments with placeholders
	  if(url.indexOf('/sessions/ES') > -1) {
	    // Session sid
	    url = url.replace(/(\/sessions\/)\w+/, '$1{sessionSid}');
	  }
	
	  if(url.indexOf('/view/MT') > -1) {
	    // View message thread sid
	    url = url.replace(/(\/view\/)\w+/, '$1{messageThreadSid}');
	  }
	
	  if(url.indexOf('/detail/MT') > -1) {
	    // View message thread sid
	    url = url.replace(/(\/detail\/)\w+/, '$1{messageThreadSid}');
	  }
	
	  if(url.indexOf('/view/ST') > -1) {
	    // View support ticket sid
	    url = url.replace(/(\/view\/)\w+/, '$1{supportTicketSid}');
	  }
	
	  if(url.indexOf('/edit/PL') > -1) {
	    // Edit location sid
	    url = url.replace(/(\/edit\/)\w+/, '$1{locationSid}');
	  }
	
	  return url;
	}
	
	function trackPageview(url) {
	  if(url.indexOf('?token=') > -1) {
	    url='/';
	  }
	
	  // Wait until GA function is available
	  const gaDelay = setInterval(function(){
	    if(window.ga) {
	      clearInterval(gaDelay);
	
	      // Make sure we don't send the event multiple times
	      gaTimeout = setTimeout(function(){
	        clearTimeout(gaTimeout);
	        const cleanUrl = sanitizeUrl(url);
	        window.ga('send', 'pageview', cleanUrl);
	      }, 500);
	    }
	  }, 100);
	}*/
	
	var root = _client2.default.createRoot(document.getElementById('root'));
	root.render(_react2.default.createElement(_routes2.default, { store: _stores2.default }));

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(934);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 934 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	;(function (exports) {
	  'use strict'
	
	  var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	
	  var Arr = (typeof Uint8Array !== 'undefined')
	    ? Uint8Array
	    : Array
	
	  var PLUS = '+'.charCodeAt(0)
	  var SLASH = '/'.charCodeAt(0)
	  var NUMBER = '0'.charCodeAt(0)
	  var LOWER = 'a'.charCodeAt(0)
	  var UPPER = 'A'.charCodeAt(0)
	  var PLUS_URL_SAFE = '-'.charCodeAt(0)
	  var SLASH_URL_SAFE = '_'.charCodeAt(0)
	
	  function decode (elt) {
	    var code = elt.charCodeAt(0)
	    if (code === PLUS || code === PLUS_URL_SAFE) return 62 // '+'
	    if (code === SLASH || code === SLASH_URL_SAFE) return 63 // '/'
	    if (code < NUMBER) return -1 // no match
	    if (code < NUMBER + 10) return code - NUMBER + 26 + 26
	    if (code < UPPER + 26) return code - UPPER
	    if (code < LOWER + 26) return code - LOWER + 26
	  }
	
	  function b64ToByteArray (b64) {
	    var i, j, l, tmp, placeHolders, arr
	
	    if (b64.length % 4 > 0) {
	      throw new Error('Invalid string. Length must be a multiple of 4')
	    }
	
	    // the number of equal signs (place holders)
	    // if there are two placeholders, than the two characters before it
	    // represent one byte
	    // if there is only one, then the three characters before it represent 2 bytes
	    // this is just a cheap hack to not do indexOf twice
	    var len = b64.length
	    placeHolders = b64.charAt(len - 2) === '=' ? 2 : b64.charAt(len - 1) === '=' ? 1 : 0
	
	    // base64 is 4/3 + up to two characters of the original data
	    arr = new Arr(b64.length * 3 / 4 - placeHolders)
	
	    // if there are placeholders, only get up to the last complete 4 chars
	    l = placeHolders > 0 ? b64.length - 4 : b64.length
	
	    var L = 0
	
	    function push (v) {
	      arr[L++] = v
	    }
	
	    for (i = 0, j = 0; i < l; i += 4, j += 3) {
	      tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
	      push((tmp & 0xFF0000) >> 16)
	      push((tmp & 0xFF00) >> 8)
	      push(tmp & 0xFF)
	    }
	
	    if (placeHolders === 2) {
	      tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
	      push(tmp & 0xFF)
	    } else if (placeHolders === 1) {
	      tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
	      push((tmp >> 8) & 0xFF)
	      push(tmp & 0xFF)
	    }
	
	    return arr
	  }
	
	  function uint8ToBase64 (uint8) {
	    var i
	    var extraBytes = uint8.length % 3 // if we have 1 byte left, pad 2 bytes
	    var output = ''
	    var temp, length
	
	    function encode (num) {
	      return lookup.charAt(num)
	    }
	
	    function tripletToBase64 (num) {
	      return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
	    }
	
	    // go through the array every three bytes, we'll deal with trailing stuff later
	    for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
	      temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	      output += tripletToBase64(temp)
	    }
	
	    // pad the end with zeros, but make sure to not forget the extra bytes
	    switch (extraBytes) {
	      case 1:
	        temp = uint8[uint8.length - 1]
	        output += encode(temp >> 2)
	        output += encode((temp << 4) & 0x3F)
	        output += '=='
	        break
	      case 2:
	        temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
	        output += encode(temp >> 10)
	        output += encode((temp >> 4) & 0x3F)
	        output += encode((temp << 2) & 0x3F)
	        output += '='
	        break
	      default:
	        break
	    }
	
	    return output
	  }
	
	  exports.toByteArray = b64ToByteArray
	  exports.fromByteArray = uint8ToBase64
	}( false ? (this.base64js = {}) : exports))


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	//(c)2019, MIT Style License <browser-update.org/LICENSE.txt>
	//it is recommended to directly link to this file because we update the detection code
	"use strict";
	
	var $bu_= new function() {
	    var s=this;
	    this.version="3.3.44npm";
	    this.vsakt = {c:"106",f:"105",s:"15.6",e:"106",i:"12",ios:"15.6",samsung:"17.0.7",o:"89",e_a:"104",o_a:"70",y:"22.7.0",v:"5.4",uc:"13.4.0"};
	    //severely insecure below(!) this version, insecure means remote code execution that is actively being exploited
	    this.vsinsecure_below = {c:"100.0.5195.102",f:"100.3",s:"11.1.1",e:16,i:11,ios:"12.3",samsung:12.0,o:62,o_a:52,y:"20",v:"2.7",uc:"13.1"};
	    this.vsdefault = {c:-3,f:-3,s:-1,e:17,i:11,ios:10,samsung:9.9,o:-3,o_a:-3,y:20.4,v:2.6,uc:13.0,a:535};
	    this.names={c:"Chrome",f:'Firefox',s:'Safari',e:"Edge",i:'Internet Explorer',ios:"iOS",samsung:"Samsung Internet",o:'Opera',o_a:'Opera', e_a:"Edge", y:"Yandex Browser",v:"Vivaldi",uc:"UC Browser",a:"Android Browser",x:"Other",silk:"Silk"};
	
	    this.get_browser = function(ua) {
	    var n,ua=(ua||navigator.userAgent).replace("_","."),r={n:"x",v:0,t:"other browser",age_years:undefined,no_device_update:false,available:s.vsakt};
	    function ignore(reason,pattern){if (new RegExp(pattern,"i").test(ua)) return reason;return false}
	    r.other=ignore("bot","Pagespeed|pingdom|Preview|ktxn|dynatrace|Ruxit|PhantomJS|Headless|Lighthouse|bot|spider|archiver|transcoder|crawl|checker|monitoring|prerender|screenshot|python-|php|uptime|validator|fetcher|facebook|slurp|google|yahoo|node|mail.ru|github|cloudflare|addthis|thumb|proxy|feed|fetch|favicon|link|http|scrape|seo|page|search console|AOLBuild|Teoma|Expeditor")||
	        ignore("TV","SMART-TV|SmartTV") ||
	        ignore("niche browser","motorola edge|Comodo.Dragon|OculusBrowser|Falkon|Brave|Classic Browser|Dorado|LBBROWSER|Focus|waterfox|Firefox/56.2|Firefox/56.3|Whale|MIDP|k-meleon|sparrow|wii|Chromium|Puffin|Opera Mini|maxthon|maxton|dolfin|dolphin|seamonkey|opera mini|netfront|moblin|maemo|arora|kazehakase|epiphany|konqueror|rekonq|symbian|webos|PaleMoon|Basilisk|QupZilla|Otter|Midori|qutebrowser|slimjet") ||
	        ignore("mobile without upgrade path or landing page","OPR/44.12.2246|cros|kindle|tizen|silk|blackberry|bb10|RIM|PlayBook|meego|nokia|ucweb|ZuneWP7|537.85.10");
	//        ignore("android(chrome) web view","; wv");
	    r.embedded=/"QtWebEngine|Teams|Electron/i.test(ua);
	    r.mobile=(/iphone|ipod|ipad|android|mobile|phone|ios|iemobile/i.test(ua));
	    r.discontinued=(/netscape|greenbrowser|camino|flot|fennec|galeon|coolnovo/i.test(ua));
	
	    var pats=[
	        ["CriOS.VV","c",'ios'],
	        ["FxiOS.VV","f",'ios'],
	        ["Trident.*rv:VV","i",'i'],
	        ["Trident.VV","i",'i'],
	        ["UCBrowser.VV","uc",'c'],
	        ["MSIE.VV","i",'i'],
	        ["Edge.VV","e",'e'],
	        ["Edg.VV","e",'c'],
	        ["EdgA.VV","e_a",'c'],
	        ["Vivaldi.VV","v",'c'],
	        ["Android.*OPR.VV","o_a",'c'],
	        ["OPR.VV","o",'c'],
	        ["YaBrowser.VV","y",'c'],
	        ["SamsungBrowser.VV","samsung",'c'],
	        ["Silk.VV","silk",'c'],
	        ["Chrome.VV","c",'c'],
	        ["Firefox.VV","f",'f'],
	        [" OS.VV.*Safari","ios",'ios'],
	        ["Version.VV.*Safari","s",'s'],
	        ["Safari.VV","s",'s'],
	        ["Opera.*Version.VV","o"],
	        ["Opera.VV","o"]
	    ];
	    var VV="(\\d+\\.?\\d+\\.?\\d*\\.?\\d*)";
	    for (var i=0; i < pats.length; i++) {
	        if (ua.match(new RegExp(pats[i][0].replace("VV",VV),"i"))) {
	            r.n=pats[i][1];
	            r.engine=pats[i][2];
	            break;
	        }        
	    }
	    r.fullv=RegExp.$1;
	    r.v=parseFloat(r.fullv);
	
	    // Special treatment of some systems
	    //do not notify old systems since there is no up-to-date browser available
	    if (/windows.nt.5|windows.nt.4|windows.nt.6.0|windows.95|windows.98|os x 10.2|os x 10.3|os x 10.4|os x 10.5/i.test(ua)) {
	        r.no_device_update=true;
	        r.available={}
	    }
	    //Safari on iOS 13 in Desktop mode
	    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
	        r.n="ios";
	        r.engine='ios';
	        r.fullv=r.v=13;
	        r.no_device_update=true;//For now, never show a message, TODO!
	    }
	    //iOS
	    if (/iphone|ipod|ipad|ios/i.test(ua)) {
	        ua.match(new RegExp("OS."+VV,"i"));
	        r.n="ios";
	        r.fullv=RegExp.$1;
	        r.v=parseFloat(r.fullv);
	        r.engine='ios';
	        var av=s.available_ios(ua,r.v);
	        /*
	        var newmap={10:"10.3.4",11:"12.4.3",12:"12.4.3",13:s.vsakt["ios"]};
	        if (av in newmap)
	            av=newmap[av];
	        */
	        if (av < 12 && Math.round(r.v)===11)// all devices with ios 11 support ios 12
	            av=12
	        r.available = {"ios": av};
	        if (parseFloat(r.available.ios)<11)
	            r.no_device_update=true;
	    }
	    //winxp/vista/2003
	    if (/windows.nt.5.1|windows.nt.5.2|windows.nt.6.0/i.test(ua)) {
	        r.available={"c":49.9,"f":52.9}
	        r.no_device_update=true;
	    }
	    //old mac
	    if (/os x 10.6/i.test(ua)) {
	        r.available = {"s": "5.1.10", "c": 49.9, "f": 48}
	        r.no_device_update=true;
	    }
	
	    if (/os x 10.7|os x 10.8/i.test(ua)) {
	        r.available = {"s": "6.2.8", "c": 49.9, "f": 48}
	        r.no_device_update=true;
	    }
	    if (/os x 10.9/i.test(ua))
	        r.available.s="9.1.3"
	
	    if (/os x 10.10/i.test(ua))
	        r.available.s="10.1.2"
	
	    //check for android stock browser
	    if (ua.indexOf('Android')>-1 && r.n==="s") {
	        var v=parseInt((/WebKit\/([0-9]+)/i.exec(ua) || 0)[1],10) || 2000;
	        if (v <= 534) {
	            r.n="a";
	            r.fullv=r.v=v;
	            r.is_insecure=true;
	        }
	    }
	
	    r.t=s.names[r.n]+" "+r.v;
	    r.is_supported=r.is_latest= !s.vsakt[r.n] ? undefined : s.less(r.fullv,s.vsakt[r.n])<=0;
	    
	    r.vmaj=Math.round(r.v);
	
	    r.is_insecure= r.is_insecure|| !s.vsinsecure_below[r.n] ? undefined :  s.less(r.fullv,s.vsinsecure_below[r.n])===1;
	    
	    if ((r.n==="f" && (r.vmaj===102)) || (r.n==="i" && r.vmaj===11)) {
	        r.is_supported=true;
	        r.is_insecure=false;
	        if (r.n==="f")
	            r.esr=true;
	    }
	    
	    if (r.n==="ios" && r.v>10.3)
	        r.is_supported=true;
	    if (r.n==="a" || r.n==="x")
	        r.t=s.names[r.n];
	    if (r.n==="e") {
	        r.t = s.names[r.n] + " " + r.vmaj;
	        r.is_supported = s.less(r.fullv, "18.15063") != 1
	    }
	    if (r.n in ["c","f","o","e"] && s.less(r.fullv,parseFloat(s.vsakt[r.n])-1)<=0)
	        r.is_supported=true; //mark also the version before the current version as supported to make the transitions smoother
	
	    var releases_per_year={'f':7,'c':8,'o':8,'i':1,'e':1,'s':1}//,'v':1}
	    if (releases_per_year[r.n]) {
	        r.age_years=Math.round(((s.vsakt[r.n]-r.v)/releases_per_year[r.n])*10)/10 || 0
	    }
	    var engines={e:"Edge.VV",c:"Chrome.VV",f:"Firefox.VV",s:"Version.VV",i:"MSIE.VV","ios":" OS.VV"}
	    if (r.engine) {
	        ua.match(new RegExp(engines[r.engine].replace("VV",VV),"i"))
	        r.engine_version=parseFloat(RegExp.$1)
	    }    
	    return r
	}
	this.semver = function(vstr) {
	    if (vstr instanceof Array)
	        return vstr
	    var x = (vstr+(".0.0.0")).split('.')
	    return [parseInt(x[0]) || 0, parseInt(x[1]) || 0, parseInt(x[2]) || 0, parseInt(x[3]) || 0]
	}
	this.less= function(v1,v2) {
	    //semantic version comparison: returns 1 if v1<v2 , 0 if equal, -1 if v1>v2
	    v1=s.semver(v1)
	    v2=s.semver(v2)
	    for (var i=0; ;i++) {
	        if (i>=v1.length) return i>=v2.length ? 0 : 1;
	        if (i>=v2.length) return -1;
	        var diff = v2[i]-v1[i]
	        if (diff) return diff>0 ? 1 : -1;
	    }
	}
	this.available_ios=function(ua,v) {
	    //https://support.apple.com/de-de/guide/iphone/iphe3fa5df43/ios
	    var h = Math.max(window.screen.height, window.screen.width),pr = window.devicePixelRatio
	    if (/ipad/i.test(ua)) {
	        if (h == 1024 && pr == 2) // iPad 3 (iOS 9), 4, 5, Mini 2, Mini 3, Mini 4, Air, Air 2, Pro 9.7
	            return 10//? only ipad 4 has ios 10, all other can have ios 11
	        if (h == 1112)// iPad Pro 10.5
	            return 15;
	        if (h == 1366)//iPad Pro 12.9, Pro 12.9 (2nd Gen)
	            return 15
	        if (h == 1024 && v < 6)
	            return 5 // iPad
	        return 9 // iPad 2, iPad Mini
	    }
	    if (pr == 1)// 1/3G/3GS
	        return 6//for 3GS
	    if (pr == 3)
	        return 15
	    if (h == 812)// X
	        return 15
	    if ((h == 736 || h == 667))// && pr == 3)// 6+/6s+/7+ and 8+ or // 6+/6s+/7+ and 8+ in zoom mode + // 6/6s/7 and 8
	        return 15//slightly wrong as latest version for iphone 6 is 12
	    if (h == 568) // 5/5C/5s/SE or 6/6s/7 and 8 in zoom mode
	        return 10
	    if (h == 480) // i4/4s
	        return 7
	    return 6
	}
	/*
	this.sub= function(v,minus) {
	    //semantic version subtraction
	    v=s.semver(v)
	    minus=s.semver(minus)
	    for (var i=0; ;i++) {
	        if (i>=v.length||i>minus.length) break;
	        v[i]-=v[minus];
	    }
	    return v.join('.')
	}
	*/
	}
	
	window.$bu_getBrowser=$bu_.get_browser;
	
	var $buo = function(op,test) {
	var n = window.navigator,b;
	op=window._buorgres=op||{};
	var ll = op.l||(n.languages ? n.languages[0] : null) || n.language || n.browserLanguage || n.userLanguage||document.documentElement.getAttribute("lang")||"en";
	op.llfull=ll.replace("_","-").toLowerCase().substr(0,5);
	op.ll=op.llfull.substr(0,2);
	op.domain=op.domain!==undefined?op.domain:(/file:/.test(location.href)?"https:":"")+"//browser-update.org";
	op.apiver=op.api||op.c||-1;
	op.jsv=$bu_.version;
	
	var required_min=(op.apiver<2018&&{i:10,f:11,o:21,s:8,c:30})||{};
	
	var vs=op.notify||op.vs||{};//legacy config: maximum version to notify
	if (vs.e!==0)
	    vs.e=vs.e||vs.i;
	vs.i=vs.i||vs.e;
	var required=op.required||{};//minimum browser versions needed
	if (required.e!==0)
	    required.e=required.e||required.i;
	if (!required.i) {
	    required.i=required.e;
	    $bu_.vsakt.i=$bu_.vsakt.e;
	}
	
	for (b in $bu_.vsdefault) {
	    if (vs[b]) {//legacy style config: browsers to notify
	        if ($bu_.less(vs[b],0)>=0) // required <= 0
	            required[b]= parseFloat($bu_.vsakt[b])+parseFloat(vs[b])+0.01
	        else
	            required[b] = parseFloat(vs[b]) + 0.01
	    }
	    if (!(b in required) || required[b]==null)
	        required[b]=$bu_.vsdefault[b]
	    if ($bu_.less(required[b],0)>=0) // case for required <= 0 --> relative to latest version
	        required[b]=parseFloat($bu_.vsakt[b])+parseFloat(required[b]) // TODO: make it work for string version
	    if (required_min[b] && $bu_.less(required[b],required_min[b])===1) // required < required_min
	        required[b]=required_min[b]
	}
	required.ios=required.ios||required.s;
	
	if (required.i<79 && required.i>65)
	    required.i=required.i-60
	if (required.e<79 && required.e>65)
	    required.e=required.e-60
	op.required=required;
	op.reminder=op.reminder<0.1 ? 0 : op.reminder||(24*7);
	op.reminderClosed=op.reminderClosed<1 ? 0 : op.reminderClosed||(24*7);
	op.onshow = op.onshow||function(o){};
	op.onclick = op.onclick||function(o){};
	op.onclose = op.onclose||function(o){};
	op.pageurl = op.pageurl || location.hostname || "x";
	op.newwindow=(op.newwindow!==false);
	
	op.test=test||op.test||(location.hash==="#test-bu")||false;
	op.ignorecookie=op.ignorecookie||location.hash==="#ignorecookie-bu";
	
	op.reasons=[];
	op.hide_reasons=[];
	function check_show(op) {
	    var bb=op.browser=$bu_.get_browser(op.override_ua);
	    op.is_below_required = required[bb.n] && $bu_.less(bb.fullv,required[bb.n])===1; //bb.fullv<required
	    if (bb.other!==false)
	        op.hide_reasons.push("is other browser:" + bb.other)
	    if (bb.embedded!==false)
	        op.hide_reasons.push("is embedded browser:" + bb.embedded)
	    if ( bb.esr && !op.notify_esr)// || (bb.is_supported && !op.notify_also_supported))
	        op.hide_reasons.push("Extended support (ESR)")
	    if (bb.mobile&&op.mobile===false)
	        op.hide_reasons.push("do not notify mobile")
	    if (bb.is_latest)//the latest versions of a browser can not be notified
	            op.hide_reasons.push("is latest version of the browser")
	    if (bb.no_device_update)
	        op.hide_reasons.push("no device update")
	    if (op.is_below_required)
	        op.reasons.push("below required")
	    if ((op.insecure||op.unsecure) && bb.is_insecure)
	        op.reasons.push("insecure")
	    if (op.unsupported && !bb.is_supported)
	        op.reasons.push("no vendor support")
	    if (op.hide_reasons.length>0)
	        return false
	    if (op.reasons.length>0)
	        return true
	    return false
	 }
	
	op.notified=check_show(op);
	
	op.already_shown=document.cookie.indexOf("browserupdateorg=pause")>-1 && !op.ignorecookie;
	
	if (!op.test && (!op.notified || op.already_shown))
	    return;
	
	op.setCookie=function(hours) { //sets a cookie that the user has already seen the notification, closed it or permanently wants to hide it. No information on the user is stored.
	    document.cookie = 'browserupdateorg=pause; expires='+(new Date(new Date().getTime()+3600000*hours)).toGMTString()+'; path=/; SameSite=Lax'+(/https:/.test(location.href)?'; Secure':'')
	}
	
	if (op.already_shown && (op.ignorecookie || op.test))
	    op.setCookie(-10)// remove old cookies if in test mode
	
	if (op.reminder>0)
	    op.setCookie(op.reminder);
	
	if (op.nomessage) {
	    op.onshow(op);
	    return;
	}
	
	$buo_show();
	};
	
	
	if( true ) {
	    module.exports = $buo;
	}
	
	
	
	"use strict";
	var $buo_show = function () {
	    var op = window._buorgres;
	    var bb = $bu_getBrowser();
	    var burl = op.burl || ("http" + (/MSIE/i.test(navigator.userAgent) ? "" : "s") + "://browser-update.org/");
	    if (!op.url) {
	        op.url = burl + ((op.l && (op.l + "/")) || "") + "update-browser.html" + (op.test ? "?force_outdated=true" : "") + "#" + op.jsv + ":" + op.pageurl;
	    }
	    op.url_permanent_hide=op.url_permanent_hide || (burl + "block-ignore-browser-update-warning.html");
	    /*
	     if (Math.random()*1000<1 && !op.test && !op.betatest) {
	     var i = new Image();
	     var txt=op["text_"+ll]||op.text||"";
	     var extra=encodeURIComponent("frac="+frac+"&txt="+txt+"&apiver="+op.apiver);
	     i.src="https://browser-update.org/cnt?what=noti&from="+bb.n+"&fromv="+bb.v + "&ref="+ escape(op.pageurl) + "&jsv="+op.jsv+"&tv="+op.style+"&extra="+extra;
	     }
	     */
	    function busprintf() {
	        var args = arguments;
	        var data = args[0];
	        for (var k = 1; k < args.length; ++k) {
	            data = data.replace(/%s/, args[k]);
	        }
	        return data;
	    }
	
	
	var t = {}, ta;
	t.en= {'msg': 'Your web browser ({brow_name}) is out of date.', 'msgmore': 'Update your browser for more security, speed and the best experience on this site.', 'bupdate': 'Update browser', 'bignore': 'Ignore','remind': 'You will be reminded in {days} days.','bnever': 'Never show again'}
	t.ar= {'msg': 'متصفح الإنترنت الخاص بك ({brow_name}) غير مُحدّث.','msgmore': 'قم بتحديث المتصفح الخاص بك لمزيد من الأمان والسرعة ولأفضل تجربة على هذا الموقع.','bupdate': 'تحديث المتصفح','bignore': 'تجاهل', 'remind': 'سيتم تذكيرك في غضون {days} أيام.', 'bnever': 'لا تظهر مرة أخرى'}
	t.bg= {'msg': 'Вашият уеб браузър ({brow_name}) е остарял.','msgmore': 'Актуализирайте браузъра си за повече сигурност, бързина и най-доброто изживяване на този сайт.','bupdate': 'Актуализиране на браузъра','bignore': 'игнорирай', 'remind': 'Ще ви бъде напомнено след {days} дни.', 'bnever': 'Никога повече да не се показва'}
	t.ca= {'msg': 'El teu navegador ({brow_name}) està desactualitzat.','msgmore': 'Actualitzeu el vostre navegador per obtenir més seguretat, velocitat i una millor experiència en aquest lloc.','bupdate': 'Actualitza el navegador','bignore': 'Ignorar', 'remind': 'T\'ho recordarem d\'aquí a {days} dies.', 'bnever': 'No ho tornis a mostrar'}
	t.cs= {'msg': 'Váš prohlížeč ({brow_name}) je zastaralý.','msgmore': 'Aktualizujte prohlížeč pro lepší zabezpečení, rychlost a nejlepší zážitek z tohoto webu.','bupdate': 'Aktualizovat prohlížeč','bignore': 'Ignorovat', 'remind': 'Znovu budete upozorněni za {days} dnů.', 'bnever': 'Již nezobrazovat'}
	t.cy= {'msg': 'Mae eich porwr gwe ({brow_name}) angen ei ddiweddaru.','msgmore': 'Diweddarwch eich porwr i gael mwy o ddiogelwch, cyflymder a\'r profiad gorau ar y safle hwn.','bupdate': 'Diweddaru porwr','bignore': 'Anwybyddu', 'remind': 'Byddwn yn eich atgoffa mewn {days} diwrnod.', 'bnever': 'Peidiwch â dangos eto'}
	t.da= {'msg': 'Din web browser ({brow_name}) er forældet','msgmore': 'Opdater din browser for mere sikkerhed, hastighed og den bedste oplevelse på denne side.','bupdate': 'Opdater browser','bignore': 'Ignorer', 'remind': 'Du vil blive påmindet om {days} dage.', 'bnever': 'Vis aldrig igen'}
	t.de= {'msg': 'Ihr Webbrowser ({brow_name}) ist veraltet.','msgmore': 'Aktualisieren Sie Ihren Browser für mehr Sicherheit, Geschwindigkeit und den besten Komfort auf dieser Seite.','bupdate': 'Browser aktualisieren','bignore': 'Ignorieren', 'remind': 'Sie werden in {days} Tagen wieder erinnert.', 'bnever': 'Nie wieder anzeigen'}
	t.el= {'msg': 'Το πρόγραμμα περιήγησής σας ({brow_name}) είναι απαρχαιωμένο.','msgmore': 'Ενημερώστε το πρόγραμμα περιήγησής σας για περισσότερη ασφάλεια, ταχύτητα και την καλύτερη εμπειρία σ\' αυτόν τον ιστότοπο.','bupdate': 'Ενημερώστε το πρόγραμμα περιήγησης','bignore': 'Αγνοήστε', 'remind': 'Θα σας το υπενθυμίσουμε σε {days} ημέρες.', 'bnever': 'Να μην εμφανιστεί ξανά'}
	t.es= {'msg': 'Su navegador web ({brow_name}) está desactualizado.','msgmore': 'Actualice su navegador para obtener más seguridad, velocidad y para disfrutar de la mejor experiencia en este sitio.','bupdate': 'Actualizar navegador','bignore': 'Ignorar', 'remind': 'Se le recordará en {days} días.', 'bnever': 'No mostrar de nuevo'}
	t.et= {'msg': 'Teie veebilehitseja ({brow_name}) on vananenud.','msgmore': 'Veebilehitseja uuendamisega kaasneb nii parem turvalisus, kiirus kui ka kasutusmugavus.','bupdate': 'Uuenda veebilehitsejat','bignore': 'Eira', 'remind': 'Uus meeldetuletus {days} päeva pärast.', 'bnever': 'Ära kunagi enam näita'}
	t.fa= {'msg': 'مرورگر شما ({brow_name}) قدیمی است.','msgmore': 'برای ایمنی، سرعت و تجربه بهتر مرورگر خود را به‌روز کنید.','bupdate': 'به‌روزرسانی مرورگر','bignore': 'نادیده گرفتن', 'remind': 'به شما تا {days} روز دیگر دوباره یاد‌آوری خواهد شد.', 'bnever': 'هرگز نمایش نده'}
	t.fi= {'msg': 'Selaimesi ({brow_name}) on vanhentunut.','msgmore': 'Päivitä selaimesi saadaksesi tietoturvapäivityksiä, nopeutta sekä parhaan käyttökokemuksen sivustolla.','bupdate': 'Päivitä selain','bignore': 'Ohita', 'remind': 'Saat uuden muistutuksen {days} päivän päästä.', 'bnever': 'Älä näytä uudestaan'}
	t.fr= {'msg': 'Votre navigateur Web ({brow_name}) n\'est pas à jour.','msgmore': 'Mettez à jour votre navigateur pour plus de sécurité et de rapidité et une meilleure expérience sur ce site.','bupdate': 'Mettre à jour le navigateur','bignore': 'Ignorer', 'remind': 'Vous serez rappelé dans {days} jours.', 'bnever': 'Ne plus afficher'}
	t.gl= {'msg': 'Tá an líonléitheoir agat ({brow_name}) as dáta.','msgmore': 'Actualiza o teu navegador para obter máis seguridade, rapidez e mellor experiencia neste sitio.','bupdate': 'Actualizar navegador web','bignore': 'Ignorar', 'remind': 'Lembraralle en {days} días.', 'bnever': 'Non volver mostrar máis'}
	t.he= {'msg': 'דפדפן ({brow_name}) שלך אינו מעודכן.','msgmore': 'עדכן/י את הדפדפן שלך לשיפור האבטחה והמהירות וכדי ליהנות מהחוויה הטובה ביותר באתר זה.','bupdate': 'עדכן דפדפן','bignore': 'התעלם', 'remind': 'תקבל/י תזכורת בעוד  {days} ימים.', 'bnever': 'אל תציג שוב'}
	t.hi= {'msg': 'आपका वेब ब्राउज़र ({brow_name}) पुराना है।','msgmore': 'इस साइट पर अधिक सुरक्षा, गति और सर्वोत्तम अनुभव करने के लिए अपने ब्राउज़र को अपडेट करें ।','bupdate': 'ब्राउज़र अपडेट करें','bignore': 'नजरअंदाज करें', 'remind': 'आपको {days} दिनों में याद दिलाया जाएगा।', 'bnever': 'फिर कभी मत दिखाना'}
	t.hu= {'msg': 'Az Ön webböngészője ({brow_name}) elavult.','msgmore': 'Frissítse böngészőjét a nagyobb biztonság, sebesség és élmény érdekében!','bupdate': 'Böngésző frissítése','bignore': 'Mellőzés', 'remind': 'Újra emlékeztetünk {days} napon belül.', 'bnever': 'Ne mutassa többet'}
	t.id= {'msg': 'Peramban web ({brow_name}) Anda sudah usang.','msgmore': 'Perbarui peramban Anda untuk pengalaman terbaik, lebih aman, dan cepat di situs ini.','bupdate': 'Perbarui peramban','bignore': 'Abaikan', 'remind': 'Anda akan diingatkan kembali dalam {days} hari.', 'bnever': 'Jangan pernah tampilkan lagi'}
	t.it= {'msg': 'Il tuo browser ({brow_name}) non è aggiornato.','msgmore': 'Aggiorna il browser per una maggiore sicurezza, velocità e la migliore esperienza su questo sito.','bupdate': 'Aggiorna browser','bignore': 'Ignora', 'remind': 'Riceverai un promemoria tra {days} giorni.', 'bnever': 'Non mostrare di nuovo'}
	t.ja= {'msg': 'お使いのブラウザ（{brow_name}）は最新版ではありません。','msgmore': 'セキュリティ、スピード、そしてこのサイトでの最良の体験のためにお使いのブラウザを更新してください。','bupdate': 'ブラウザを更新する','bignore': '無視する', 'remind': '{days} 日後にもう一度お知らせします。', 'bnever': '次回から表示しない'}
	t.ko= {'msg': '귀하의 웹 브라우저({brow_name})는 오래되었습니다.','msgmore': '이 사이트에서 보안, 속도와 최상의 경험을 얻으려면 브라우저를 업데이트하십시오.','bupdate': '브라우저 업데이트하기','bignore': '무시하기', 'remind': '{days}일 후에 알려 드립니다.', 'bnever': '다시 표시하지 않기'}
	t.lt= {'msg': 'Jūsų naršyklė ({brow_name}) yra pasenusi.','msgmore': 'Atsinaujinkite savo naršyklę norėdami gauti daugiau saugumo, greičio ir pačių geriausių patirčių šioje svetainėje.','bupdate': 'Atnaujinti naršyklę','bignore': 'Nepaisyti', 'remind': 'Jums bus priminta po {days} dienų.', 'bnever': 'Daugiau niekada nerodyti'}
	t.lv= {'msg': 'Jūsu pārlūkprogramma ({brow_name}) ir novecojusi.','msgmore': 'Atjaunojiet savu pārlūkprogrammu lielākai drošībai, ātrumam un labākai pieredzei ar šo vietni.','bupdate': 'Atjaunināt pārlūkprogrammu','bignore': 'Ignorēt', 'remind': 'Jums tiks parādīts atgādinājums pēc {days} dienām.', 'bnever': 'Vairs nerādīt'}
	t.ms= {'msg': 'Pelayar web anda ({brow_name}) sudah lapuk.','msgmore': 'Kemas kini pelayar anda untuk lebih keselamatan, kelajuan dan pengalaman terbaik di laman web ini.','bupdate': 'Kemas kini pelayar','bignore': 'Abaikan', 'remind': 'Anda akan diingatkan dalam {days} hari.', 'bnever': 'Jangan tunjukkan lagi'}
	t.nl= {'msg': 'Uw webbrowser ({brow_name}) is verouderd.','msgmore': 'Update uw browser voor meer veiligheid, snelheid en om deze site optimaal te kunnen gebruiken.','bupdate': 'Browser updaten','bignore': 'Negeren', 'remind': 'We zullen u er in {days} dagen aan herinneren.', 'bnever': 'Nooit meer tonen'}
	t.no=t.nn=t.nb= {'msg': 'Nettleseren din ({brow_name}) er utdatert.','msgmore': 'Oppdater nettleseren din for økt sikkerhet, hastighet og den beste opplevelsen på dette nettstedet.','bupdate': 'Oppdater nettleser','bignore': 'Ignorer', 'remind': 'Du vil få en påminnelse om {days} dager.', 'bnever': 'Aldri vis igjen'}
	t.pl= {'msg': 'Twoja przeglądarka ({brow_name}) jest nieaktualna.','msgmore': 'Zaktualizuj przeglądarkę, by korzystać z tej strony bezpieczniej, szybciej i po prostu sprawniej.','bupdate': 'Aktualizuj przeglądarkę','bignore': 'Ignoruj', 'remind': 'Przypomnimy o tym za {days} dni.', 'bnever': 'Nie pokazuj więcej'}
	t.pt= {'msg': 'Seu navegador da web ({brow_name}) está desatualizado.','msgmore': 'Atualize seu navegador para ter mais segurança e velocidade, além da melhor experiência neste site.','bupdate': 'Atualizar navegador','bignore': 'Ignorar', 'remind': 'Você será relembrado em {days} dias.', 'bnever': 'Não mostrar novamente'}
	t.ro= {'msg': 'Browserul tău ({brow_name}) nu este actualizat.','msgmore': 'Actualizează browserul pentru o mai mare siguranță, viteză și cea mai bună experiență pe acest site.','bupdate': 'Actualizează browser','bignore': 'Ignoră', 'remind': 'Ți se va reaminti peste {days} zile.', 'bnever': 'Nu mai arăta'}
	t.ru= {'msg': 'Ваш браузер ({brow_name}) устарел.','msgmore': 'Обновите ваш браузер для повышения уровня безопасности, скорости и комфорта использования этого сайта.','bupdate': 'Обновить браузер','bignore': 'Игнорировать', 'remind': 'Вы получите напоминание через {days} дней.', 'bnever': 'Больше не показывать '}
	t.sk= {'msg': 'Váš internetový prehliadač ({brow_name}) je zastaraný.','msgmore': 'Pre väčšiu bezpečnosť, rýchlosť a lepšiu skúsenosť s touto stránkou si aktualizujte svoj prehliadač.','bupdate': 'Aktualizovať prehliadač','bignore': 'Ignorovať', 'remind': 'Bude vám to pripomenuté o {days} dní.', 'bnever': 'Už nikdy viac neukazovať'}
	t.sl= {'msg': 'Vaš spletni brskalnik ({brow_name}) je zastarel.','msgmore': 'Posodobite svoj brskalnik za dodatno varnost, hitrost in najboljšo izkušnjo na tem spletnem mestu.','bupdate': 'Posodobi brskalnik','bignore': 'Prezri', 'remind': 'Opomnik boste prejeli čez toliko dni: {days}.', 'bnever': 'Ne prikaži več'}
	t.sq= {'msg': 'Shfletuesi juaj ({brow_name}) është i vjetruar.','msgmore': 'Përditësoni shfletuesin tuaj për më tepër siguri, shpejtësi dhe për më të mirin e funksionimeve në këtë sajt.','bupdate': 'Përditëso shfletuesin','bignore': 'Shpërfille', 'remind': 'Do t’ju rikujtohet pas {days} ditësh.', 'bnever': 'Mos e shfaq kurrë më'}
	t.sr= {'msg': 'Vaš pretraživač ({brow_name}) je zastareo.','msgmore': 'Ima poznate sigurnosne probleme i najverovatnije neće prikazati sve funkcionalnisti ovog i drugih sajtova.','bupdate': 'Nadogradi pretraživač','bignore': 'Ignorisi', 'remind': 'Zaboravićete za {days} dana.', 'bnever': 'Ne prikazuj opet'}
	t.sv= {'msg': 'Din webbläsare ({brow_name}) är föråldrad. ','msgmore': 'Uppdatera din webbläsare för mer säkerhet, hastighet och den bästa upplevelsen på den här sajten. ','bupdate': 'Uppdatera webbläsaren','bignore': 'Ignorera', 'remind': 'Du får en påminnelse om {days} dagar.', 'bnever': 'Visa aldrig igen'}
	t.th= {'msg': 'เว็บเบราว์เซอร์ของคุณ ({brow_name}) ล้าสมัยแล้ว','msgmore': 'อัปเดทเบราว์เซอร์เพื่อเพิ่มความปลอดภัย, ความเร็ว และประสบการณ์ที่ดีที่สุดบนเว็บไซต์นี้','bupdate': 'อัปเดทเบราว์เซอร์','bignore': 'ข้าม', 'remind': 'คุณจะได้รับการแจ้งเตือนใน {days} วัน', 'bnever': 'ไม่ต้องแสดงอีก'}
	t.tr= {'msg': 'Web tarayıcınız ({brow_name}) güncel değil.','msgmore': 'Daha fazla güvenlik ve hız ile bu sitede en iyi deneyim için tarayıcınızı güncelleyin.','bupdate': 'Tarayıcıyı güncelle','bignore': 'Yok say', 'remind': '{days} gün sonra bir hatırlatma alacaksınız.', 'bnever': 'Bir daha gösterme'}
	t.uk= {'msg': 'Ваш браузер ({brow_name}) застарілий.','msgmore': 'Оновіть свій браузер для більшої безпеки, швидкості та повноцінної роботи цього сайту.','bupdate': 'Оновити браузер','bignore': 'Пропустити', 'remind': 'Ви отримаєте нагадування через {days} днів.', 'bnever': 'Більше не показувати'}
	t.uz= {'msg': 'Sizning ({brow_name}) veb-brauzeringiz eskirgan','msgmore': 'Xavfsizlik, tezkorlik va ushbu sayt imkoniyatlaridan to`liq foydalanish uchun brauzeringizni yangilang.','bupdate': 'Brauzeringizni yangilang','bignore': 'E’tibor bermaslik', 'remind': 'Sizga {days} kundan so`ng eslatammiz.', 'bnever': 'Hech qachon qayta ko\'rsatmang'}
	t.vi= {'msg': 'Trình duyệt web của bạn ({brow_name}) đã lỗi thời.','msgmore': 'Cập nhật trình duyệt của bạn để có thêm bảo mật, tốc độ và trải nghiệm tốt nhất trên trang web này.','bupdate': 'Cập nhật trình duyệt','bignore': 'Bỏ qua', 'remind': 'Bạn sẽ được nhắc nhở sau {days} ngày.', 'bnever': 'Không bao giờ hiển thị lại'}
	t.zh= {'msg': '您的网页浏览器（{brow_name}）已过期。','msgmore': '更新您的浏览器，以便在该网站上获得更安全、更快速和最好的体验。','bupdate': '更新浏览器','bignore': '忽略', 'remind': '会在{days}天后提醒您。', 'bnever': '不再显示'}
	t["zh-tw"]= t["zh-hans-cn"] ={'msg': '您的網路瀏覽器（{brow_name}）已過舊。','msgmore': '更新您的瀏覽器以獲得更佳的安全性、速度以及在此網站的最佳體驗。','bupdate': '更新瀏覽器','bignore': '忽略', 'remind': '您將在 {days} 天後收到提醒。', 'bnever': '不要再顯示'}
	
	var custom_text = op["text_for_"  + bb.n + "_in_" + op.ll] || op["text_for_" + bb.n] || op["text_" + op.llfull] || op["text_in_" + op.ll] || op["text_" + op.ll]  ||   op.text
	t = ta = t[op.llfull] || t[op.ll] || t.en;
	if (custom_text) {
	    if (typeof custom_text === 'string')
	        t=ta=custom_text;
	    else {
	        for (var i in custom_text) {
	            ta[i] = custom_text[i]
	        }
	    }
	}
	if (ta.msg)
	    t = '<b class="buorg-mainmsg">' + t.msg + '</b> <span class="buorg-moremsg">' + t.msgmore + '</span> <span class="buorg-buttons"><a{up_but}>' + t.bupdate + '</a> <a{ignore_but}>' + t.bignore + '</a></span>'
	
	var tar = "";
	if (op.newwindow)
	    tar = ' target="_blank" rel="noopener"';
	
	var div = op.div = document.createElement("div");
	div.id = div.className= "buorg";
	
	var style = '<style>.buorg-icon {width: 22px; height: 16px; vertical-align: middle; position: relative; top: -0.05em; display: inline-block; background: no-repeat 0px center url(https://browser-update.org/static/img/small/' + bb.n + '.png);}</style>';
	var style2 = '<style>.buorg {position:absolute;position:fixed;z-index:111111; width:100%; top:0px; left:0px; border-bottom:1px solid #A29330; text-align:center;  color:#000; background-color: #fff8ea; font: 18px Calibri,Helvetica,sans-serif; box-shadow: 0 0 5px rgba(0,0,0,0.2);animation: buorgfly 1s ease-out 0s;}'
	    + '.buorg-pad { padding: 9px;  line-height: 1.7em; }'
	    + '.buorg-buttons { display: block; text-align: center; }'
	    + '#buorgig,#buorgul,#buorgpermanent { color: #fff; text-decoration: none; cursor:pointer; box-shadow: 0 0 2px rgba(0,0,0,0.4); padding: 1px 10px; border-radius: 4px; font-weight: normal; background: #5ab400;    white-space: nowrap;    margin: 0 2px; display: inline-block;}'
	    + '#buorgig { background-color: #edbc68;}'
	    + '@media only screen and (max-width: 700px){.buorg div { padding:5px 12px 5px 9px; line-height: 1.3em;}}'
	    + '@keyframes buorgfly {from {opacity:0;transform:translateY(-50px)} to {opacity:1;transform:translateY(0px)}}'
	    + '.buorg-fadeout {transition: visibility 0s 8.5s, opacity 8s ease-out .5s;}</style>';
	if (ta.msg && (op.ll=="ar"||op.ll=="he"||op.ll=="fa"))
	    style2+='<style>.buorg {direction:RTL; unicode-bidi:embed;}</style>';
	if (!ta.msg && t.indexOf && t.indexOf("%s") !== -1) {//legacy style
	    t = busprintf(t, bb.t, ' id="buorgul" href="' + op.url + '"' + tar);
	
	    style += '<style>.buorg {position:absolute;position:fixed;z-index:111111; width:100%; top:0px; left:0px; border-bottom:1px solid #A29330; text-align:left; cursor:pointer; color:#000; font: 13px Arial,sans-serif;color:#000;}'
	        + '.buorg div { padding:5px 36px 5px 40px; }'
	        + '.buorg>div>a,.buorg>div>a:visited{color:#E25600; text-decoration: underline;}'
	        + '#buorgclose{position:absolute;right:6px;top:0px;height:20px;width:12px;font:18px bold;padding:0;}'
	        + '#buorga{display:block;}'
	        + '@media only screen and (max-width: 700px){.buorg div { padding:5px 15px 5px 9px; }}</style>';
	    div.innerHTML = '<div>' + t + '<div id="buorgclose"><a id="buorga">&times;</a></div></div>' + style;
	    op.addmargin = true;
	}
	else {
	    if (op.style === "bottom") {
	        style2 += '<style>.buorg {bottom:0; top:auto; border-top:1px solid #A29330; } @keyframes buorgfly {from {opacity:0;transform:translateY(50px)} to {opacity:1;transform:translateY(0px)}}</style>';
	    }
	    else if (op.style === "corner") {
	        style2 += '<style> .buorg { text-align: left; width:300px; top:50px; right:50px; left:auto; border:1px solid #A29330; } .buorg-buttons, .buorg-mainmsg, .buorg-moremsg { display: block; } .buorg-buttons a {margin: 4px 2px;} .buorg-icon {display: none;}</style>';
	    }
	    else {
	        op.addmargin = true;
	    }
	    t = t.replace("{brow_name}", bb.t).replace("{up_but}", ' id="buorgul" href="' + op.url + '"' + tar).replace("{ignore_but}", ' id="buorgig" role="button" tabindex="0"');
	    div.innerHTML = '<div class="buorg-pad" role="status" aria-live="polite"><span class="buorg-icon"> </span>' + t + '</div>' + style + style2;
	}
	
	op.text = t;
	if (op.container) {
	    op.container.appendChild(div);
	    op.addmargin = false;
	}
	else
	    document.body.insertBefore(div, document.body.firstChild);
	
	var updatebutton=document.getElementById("buorgul");
	if (updatebutton) {
	    updatebutton.onclick = function (e) {
	        div.onclick = null;
	        op.onclick(op);
	        if (op.noclose)
	            return
	        op.setCookie(op.reminderClosed);
	        if (!op.noclose) {
	            div.style.display = "none";
	            if (op.addmargin && op.shift_page_down !== false)
	                hm.style.marginTop = op.bodymt;
	        }
	    };
	}
	if (!custom_text) {//make whole bar clickable except if custom text is set
	    div.style.cursor="pointer";
	    div.onclick = function () {
	        if (op.newwindow)
	            window.open(op.url, "_blank");
	        else
	            window.location.href = op.url;
	        op.setCookie(op.reminderClosed);
	        op.onclick(op);
	    };
	}
	
	if (op.addmargin && op.shift_page_down !== false) {
	    var hm = document.getElementsByTagName("html")[0] || document.body;
	    op.bodymt = hm.style.marginTop;
	    hm.style.marginTop = (div.clientHeight) + "px";
	}
	var ignorebutton = document.getElementById("buorga") || document.getElementById("buorgig");
	if (ignorebutton) {
	    ignorebutton.onclick = function (e) {
	        div.onclick = null;
	        op.onclose(op);
	        if (op.addmargin && op.shift_page_down !== false)
	            hm.style.marginTop = op.bodymt;
	        op.setCookie(op.reminderClosed);
	        if (!op.no_permanent_hide && ta.bnever && ta.remind) {
	            op.div.innerHTML = '<div class="buorg-pad"><span class="buorg-moremsg">' + (op.reminderClosed > 24 ? ta.remind.replace("{days}", Math.round(op.reminderClosed/24)):"") + '</span> <span class="buorg-buttons"><a id="buorgpermanent" role="button" tabindex="0" href="' + op.url_permanent_hide +'"' + tar + '>' + ta.bnever + '</a></span></div>' + style + style2;
	            div.className = "buorg buorg-fadeout";
	            document.getElementById("buorgpermanent").onclick = function (e) {
	                op.setCookie(24 * 365);
	                op.div.style.display = "none";
	            }
	            op.div.style.opacity = 0;
	            op.div.style.visibility = "hidden";
	            return false;
	        }
	        op.div.style.display = "none";
	        return false;
	    }
	    if (op.noclose || op.reminderClosed==0) {
	        ignorebutton.parentNode.removeChild(ignorebutton)
	    }
	}
	
	
	op.onshow(op);
	
	if (op.test && !op.dont_show_debuginfo) {
	    var e = document.createElement("script");
	    e.src = op.domain + "/update.test.js";
	    document.body.appendChild(e);
	}
	
	};
	
	


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(935)
	var ieee754 = __webpack_require__(1052)
	var isArray = __webpack_require__(938)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 938 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 939 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assign;
	function assign(target, object) {
	  if (target == null) {
	    throw new TypeError('assign requires that input parameter not be null or undefined');
	  }
	  for (var property in object) {
	    if (Object.prototype.hasOwnProperty.call(object, property)) {
	      ;
	      target[property] = object[property];
	    }
	  }
	  return target;
	}
	module.exports = exports.default;

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(942));
	var _index2 = _interopRequireDefault(__webpack_require__(314));
	var _index3 = _interopRequireDefault(__webpack_require__(315));
	var _index4 = _interopRequireDefault(__webpack_require__(316));
	var _index5 = _interopRequireDefault(__webpack_require__(169));
	var _index6 = _interopRequireDefault(__webpack_require__(311));
	var _index7 = _interopRequireDefault(__webpack_require__(941));
	var dayPeriodEnum = {
	  am: 'am',
	  pm: 'pm',
	  midnight: 'midnight',
	  noon: 'noon',
	  morning: 'morning',
	  afternoon: 'afternoon',
	  evening: 'evening',
	  night: 'night'
	};
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
	 * |  p! | Long localized time            |  P! | Long localized date            |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 * - `P` is long localized date format
	 * - `p` is long localized time format
	 */
	
	var formatters = {
	  // Era
	  G: function G(date, token, localize) {
	    var era = date.getUTCFullYear() > 0 ? 1 : 0;
	    switch (token) {
	      // AD, BC
	      case 'G':
	      case 'GG':
	      case 'GGG':
	        return localize.era(era, {
	          width: 'abbreviated'
	        });
	      // A, B
	      case 'GGGGG':
	        return localize.era(era, {
	          width: 'narrow'
	        });
	      // Anno Domini, Before Christ
	      case 'GGGG':
	      default:
	        return localize.era(era, {
	          width: 'wide'
	        });
	    }
	  },
	  // Year
	  y: function y(date, token, localize) {
	    // Ordinal number
	    if (token === 'yo') {
	      var signedYear = date.getUTCFullYear();
	      // Returns 1 for 1 BC (which is year 0 in JavaScript)
	      var year = signedYear > 0 ? signedYear : 1 - signedYear;
	      return localize.ordinalNumber(year, {
	        unit: 'year'
	      });
	    }
	    return _index7.default.y(date, token);
	  },
	  // Local week-numbering year
	  Y: function Y(date, token, localize, options) {
	    var signedWeekYear = (0, _index5.default)(date, options);
	    // Returns 1 for 1 BC (which is year 0 in JavaScript)
	    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
	
	    // Two digit year
	    if (token === 'YY') {
	      var twoDigitYear = weekYear % 100;
	      return (0, _index6.default)(twoDigitYear, 2);
	    }
	
	    // Ordinal number
	    if (token === 'Yo') {
	      return localize.ordinalNumber(weekYear, {
	        unit: 'year'
	      });
	    }
	
	    // Padding
	    return (0, _index6.default)(weekYear, token.length);
	  },
	  // ISO week-numbering year
	  R: function R(date, token) {
	    var isoWeekYear = (0, _index3.default)(date);
	
	    // Padding
	    return (0, _index6.default)(isoWeekYear, token.length);
	  },
	  // Extended year. This is a single number designating the year of this calendar system.
	  // The main difference between `y` and `u` localizers are B.C. years:
	  // | Year | `y` | `u` |
	  // |------|-----|-----|
	  // | AC 1 |   1 |   1 |
	  // | BC 1 |   1 |   0 |
	  // | BC 2 |   2 |  -1 |
	  // Also `yy` always returns the last two digits of a year,
	  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
	  u: function u(date, token) {
	    var year = date.getUTCFullYear();
	    return (0, _index6.default)(year, token.length);
	  },
	  // Quarter
	  Q: function Q(date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'Q':
	        return String(quarter);
	      // 01, 02, 03, 04
	      case 'QQ':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	      case 'Qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	      case 'QQQ':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	      case 'QQQQQ':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // 1st quarter, 2nd quarter, ...
	      case 'QQQQ':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone quarter
	  q: function q(date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'q':
	        return String(quarter);
	      // 01, 02, 03, 04
	      case 'qq':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	      case 'qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	      case 'qqq':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	      case 'qqqqq':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // 1st quarter, 2nd quarter, ...
	      case 'qqqq':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Month
	  M: function M(date, token, localize) {
	    var month = date.getUTCMonth();
	    switch (token) {
	      case 'M':
	      case 'MM':
	        return _index7.default.M(date, token);
	      // 1st, 2nd, ..., 12th
	      case 'Mo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	      case 'MMM':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // J, F, ..., D
	      case 'MMMMM':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // January, February, ..., December
	      case 'MMMM':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone month
	  L: function L(date, token, localize) {
	    var month = date.getUTCMonth();
	    switch (token) {
	      // 1, 2, ..., 12
	      case 'L':
	        return String(month + 1);
	      // 01, 02, ..., 12
	      case 'LL':
	        return (0, _index6.default)(month + 1, 2);
	      // 1st, 2nd, ..., 12th
	      case 'Lo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	      case 'LLL':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // J, F, ..., D
	      case 'LLLLL':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // January, February, ..., December
	      case 'LLLL':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Local week of year
	  w: function w(date, token, localize, options) {
	    var week = (0, _index4.default)(date, options);
	    if (token === 'wo') {
	      return localize.ordinalNumber(week, {
	        unit: 'week'
	      });
	    }
	    return (0, _index6.default)(week, token.length);
	  },
	  // ISO week of year
	  I: function I(date, token, localize) {
	    var isoWeek = (0, _index2.default)(date);
	    if (token === 'Io') {
	      return localize.ordinalNumber(isoWeek, {
	        unit: 'week'
	      });
	    }
	    return (0, _index6.default)(isoWeek, token.length);
	  },
	  // Day of the month
	  d: function d(date, token, localize) {
	    if (token === 'do') {
	      return localize.ordinalNumber(date.getUTCDate(), {
	        unit: 'date'
	      });
	    }
	    return _index7.default.d(date, token);
	  },
	  // Day of year
	  D: function D(date, token, localize) {
	    var dayOfYear = (0, _index.default)(date);
	    if (token === 'Do') {
	      return localize.ordinalNumber(dayOfYear, {
	        unit: 'dayOfYear'
	      });
	    }
	    return (0, _index6.default)(dayOfYear, token.length);
	  },
	  // Day of week
	  E: function E(date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    switch (token) {
	      // Tue
	      case 'E':
	      case 'EE':
	      case 'EEE':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'EEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'EEEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'EEEE':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Local day of week
	  e: function e(date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	    switch (token) {
	      // Numerical value (Nth day of week with current locale or weekStartsOn)
	      case 'e':
	        return String(localDayOfWeek);
	      // Padded numerical value
	      case 'ee':
	        return (0, _index6.default)(localDayOfWeek, 2);
	      // 1st, 2nd, ..., 7th
	      case 'eo':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	      case 'eee':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'eeeee':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'eeeeee':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'eeee':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone local day of week
	  c: function c(date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	    switch (token) {
	      // Numerical value (same as in `e`)
	      case 'c':
	        return String(localDayOfWeek);
	      // Padded numerical value
	      case 'cc':
	        return (0, _index6.default)(localDayOfWeek, token.length);
	      // 1st, 2nd, ..., 7th
	      case 'co':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	      case 'ccc':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // T
	      case 'ccccc':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // Tu
	      case 'cccccc':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'standalone'
	        });
	      // Tuesday
	      case 'cccc':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // ISO day of week
	  i: function i(date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
	    switch (token) {
	      // 2
	      case 'i':
	        return String(isoDayOfWeek);
	      // 02
	      case 'ii':
	        return (0, _index6.default)(isoDayOfWeek, token.length);
	      // 2nd
	      case 'io':
	        return localize.ordinalNumber(isoDayOfWeek, {
	          unit: 'day'
	        });
	      // Tue
	      case 'iii':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'iiiii':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'iiiiii':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'iiii':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM or PM
	  a: function a(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'aaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	      case 'aaaaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'aaaa':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM, PM, midnight, noon
	  b: function b(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	    if (hours === 12) {
	      dayPeriodEnumValue = dayPeriodEnum.noon;
	    } else if (hours === 0) {
	      dayPeriodEnumValue = dayPeriodEnum.midnight;
	    } else {
	      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    }
	    switch (token) {
	      case 'b':
	      case 'bb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'bbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	      case 'bbbbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'bbbb':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: function B(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	    if (hours >= 17) {
	      dayPeriodEnumValue = dayPeriodEnum.evening;
	    } else if (hours >= 12) {
	      dayPeriodEnumValue = dayPeriodEnum.afternoon;
	    } else if (hours >= 4) {
	      dayPeriodEnumValue = dayPeriodEnum.morning;
	    } else {
	      dayPeriodEnumValue = dayPeriodEnum.night;
	    }
	    switch (token) {
	      case 'B':
	      case 'BB':
	      case 'BBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'BBBBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'BBBB':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Hour [1-12]
	  h: function h(date, token, localize) {
	    if (token === 'ho') {
	      var hours = date.getUTCHours() % 12;
	      if (hours === 0) hours = 12;
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return _index7.default.h(date, token);
	  },
	  // Hour [0-23]
	  H: function H(date, token, localize) {
	    if (token === 'Ho') {
	      return localize.ordinalNumber(date.getUTCHours(), {
	        unit: 'hour'
	      });
	    }
	    return _index7.default.H(date, token);
	  },
	  // Hour [0-11]
	  K: function K(date, token, localize) {
	    var hours = date.getUTCHours() % 12;
	    if (token === 'Ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Hour [1-24]
	  k: function k(date, token, localize) {
	    var hours = date.getUTCHours();
	    if (hours === 0) hours = 24;
	    if (token === 'ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Minute
	  m: function m(date, token, localize) {
	    if (token === 'mo') {
	      return localize.ordinalNumber(date.getUTCMinutes(), {
	        unit: 'minute'
	      });
	    }
	    return _index7.default.m(date, token);
	  },
	  // Second
	  s: function s(date, token, localize) {
	    if (token === 'so') {
	      return localize.ordinalNumber(date.getUTCSeconds(), {
	        unit: 'second'
	      });
	    }
	    return _index7.default.s(date, token);
	  },
	  // Fraction of second
	  S: function S(date, token) {
	    return _index7.default.S(date, token);
	  },
	  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
	  X: function X(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    if (timezoneOffset === 0) {
	      return 'Z';
	    }
	    switch (token) {
	      // Hours and optional minutes
	      case 'X':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XX`
	      case 'XXXX':
	      case 'XX':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XXX`
	      case 'XXXXX':
	      case 'XXX': // Hours and minutes with `:` delimiter
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
	  x: function x(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Hours and optional minutes
	      case 'x':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xx`
	      case 'xxxx':
	      case 'xx':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xxx`
	      case 'xxxxx':
	      case 'xxx': // Hours and minutes with `:` delimiter
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (GMT)
	  O: function O(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Short
	      case 'O':
	      case 'OO':
	      case 'OOO':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	      case 'OOOO':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (specific non-location)
	  z: function z(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Short
	      case 'z':
	      case 'zz':
	      case 'zzz':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	      case 'zzzz':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Seconds timestamp
	  t: function t(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = Math.floor(originalDate.getTime() / 1000);
	    return (0, _index6.default)(timestamp, token.length);
	  },
	  // Milliseconds timestamp
	  T: function T(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = originalDate.getTime();
	    return (0, _index6.default)(timestamp, token.length);
	  }
	};
	function formatTimezoneShort(offset, dirtyDelimiter) {
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	  if (minutes === 0) {
	    return sign + String(hours);
	  }
	  var delimiter = dirtyDelimiter || '';
	  return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
	}
	function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
	  if (offset % 60 === 0) {
	    var sign = offset > 0 ? '-' : '+';
	    return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
	  }
	  return formatTimezone(offset, dirtyDelimiter);
	}
	function formatTimezone(offset, dirtyDelimiter) {
	  var delimiter = dirtyDelimiter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
	  var minutes = (0, _index6.default)(absOffset % 60, 2);
	  return sign + hours + delimiter + minutes;
	}
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(311));
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* |                                |
	 * |  d  | Day of month                   |  D  |                                |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  y  | Year (abs)                     |  Y  |                                |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 */
	
	var formatters = {
	  // Year
	  y: function y(date, token) {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	
	    var signedYear = date.getUTCFullYear();
	    // Returns 1 for 1 BC (which is year 0 in JavaScript)
	    var year = signedYear > 0 ? signedYear : 1 - signedYear;
	    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
	  },
	  // Month
	  M: function M(date, token) {
	    var month = date.getUTCMonth();
	    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
	  },
	  // Day of the month
	  d: function d(date, token) {
	    return (0, _index.default)(date.getUTCDate(), token.length);
	  },
	  // AM or PM
	  a: function a(date, token) {
	    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return dayPeriodEnumValue.toUpperCase();
	      case 'aaa':
	        return dayPeriodEnumValue;
	      case 'aaaaa':
	        return dayPeriodEnumValue[0];
	      case 'aaaa':
	      default:
	        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
	    }
	  },
	  // Hour [1-12]
	  h: function h(date, token) {
	    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
	  },
	  // Hour [0-23]
	  H: function H(date, token) {
	    return (0, _index.default)(date.getUTCHours(), token.length);
	  },
	  // Minute
	  m: function m(date, token) {
	    return (0, _index.default)(date.getUTCMinutes(), token.length);
	  },
	  // Second
	  s: function s(date, token) {
	    return (0, _index.default)(date.getUTCSeconds(), token.length);
	  },
	  // Fraction of second
	  S: function S(date, token) {
	    var numberOfDigits = token.length;
	    var milliseconds = date.getUTCMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
	    return (0, _index.default)(fractionalSeconds, token.length);
	  }
	};
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_DAY = 86400000;
	function getUTCDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISODay;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	function setUTCISODay(dirtyDate, dirtyDay) {
	  (0, _index2.default)(2, arguments);
	  var day = (0, _index3.default)(dirtyDay);
	  if (day % 7 === 0) {
	    day = day - 7;
	  }
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(314));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCWeek;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(316));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	function setUTCWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index.default)(dirtyWeek);
	  var diff = (0, _index3.default)(date, options) - week;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(315));
	var _index2 = _interopRequireDefault(__webpack_require__(88));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	function startOfUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(169));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(89));
	var _index4 = _interopRequireDefault(__webpack_require__(25));
	var _index5 = __webpack_require__(51);
	function startOfUTCWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	  var year = (0, _index.default)(dirtyDate, options);
	  var firstWeek = new Date(0);
	  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index3.default)(firstWeek, options);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarDays;
	var _index = _interopRequireDefault(__webpack_require__(119));
	var _index2 = _interopRequireDefault(__webpack_require__(174));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_DAY = 86400000;
	
	/**
	 * @name differenceInCalendarDays
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates. This means that the times are removed
	 * from the dates and then the difference in days is calculated.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 * // How many calendar days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 1
	 */
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfDayRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfDayLeft.getTime() - (0, _index.default)(startOfDayLeft);
	  var timestampRight = startOfDayRight.getTime() - (0, _index.default)(startOfDayRight);
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	module.exports = exports.default;

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarMonths;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name differenceInCalendarMonths
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * const result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	  return yearDiff * 12 + monthDiff;
	}
	module.exports = exports.default;

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarWeeks;
	var _index = _interopRequireDefault(__webpack_require__(90));
	var _index2 = _interopRequireDefault(__webpack_require__(119));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_WEEK = 604800000;
	
	/**
	 * @name differenceInCalendarWeeks
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar weeks between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5),
	 *   { weekStartsOn: 1 }
	 * )
	 * //=> 2
	 */
	function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
	  (0, _index3.default)(2, arguments);
	  var startOfWeekLeft = (0, _index.default)(dirtyDateLeft, options);
	  var startOfWeekRight = (0, _index.default)(dirtyDateRight, options);
	  var timestampLeft = startOfWeekLeft.getTime() - (0, _index2.default)(startOfWeekLeft);
	  var timestampRight = startOfWeekRight.getTime() - (0, _index2.default)(startOfWeekRight);
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	module.exports = exports.default;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarYears;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name differenceInCalendarYears
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * const result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() - dateRight.getFullYear();
	}
	module.exports = exports.default;

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDay;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name endOfDay
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMonth;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name endOfMonth
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfWeek;
	var _index = __webpack_require__(51);
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name endOfWeek
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the end of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index4.default)(1, arguments);
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index2.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setDate(date.getDate() + diff);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	var _index = _interopRequireDefault(__webpack_require__(324));
	var _index2 = _interopRequireDefault(__webpack_require__(328));
	var _index3 = _interopRequireDefault(__webpack_require__(16));
	var _index4 = _interopRequireDefault(__webpack_require__(940));
	var _index5 = _interopRequireDefault(__webpack_require__(313));
	var _index6 = _interopRequireDefault(__webpack_require__(119));
	var _index7 = __webpack_require__(317);
	var _index8 = _interopRequireDefault(__webpack_require__(25));
	var _index9 = _interopRequireDefault(__webpack_require__(14));
	var _index10 = __webpack_require__(51);
	var _index11 = _interopRequireDefault(__webpack_require__(312));
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
	
	// This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. The result may vary by locale.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 * (see the last example)
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 7 below the table).
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   | Notes |
	 * |---------------------------------|---------|-----------------------------------|-------|
	 * | Era                             | G..GGG  | AD, BC                            |       |
	 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 | GGGGG   | A, B                              |       |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
	 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
	 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
	 * |                                 | yyyyy   | ...                               | 3,5   |
	 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
	 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
	 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
	 * |                                 | YYYYY   | ...                               | 3,5   |
	 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
	 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
	 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
	 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
	 * |                                 | RRRRR   | ...                               | 3,5,7 |
	 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
	 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
	 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
	 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
	 * |                                 | uuuuu   | ...                               | 3,5   |
	 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
	 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
	 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | qq      | 01, 02, 03, 04                    |       |
	 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
	 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | MM      | 01, 02, ..., 12                   |       |
	 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 | MMMM    | January, February, ..., December  | 2     |
	 * |                                 | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
	 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | LL      | 01, 02, ..., 12                   |       |
	 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 | LLLL    | January, February, ..., December  | 2     |
	 * |                                 | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
	 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
	 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | II      | 01, 02, ..., 53                   | 7     |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
	 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
	 * |                                 | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
	 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
	 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
	 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 | DDDD    | ...                               | 3     |
	 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
	 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
	 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
	 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
	 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
	 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
	 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
	 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | ee      | 02, 03, ..., 01                   |       |
	 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | cc      | 02, 03, ..., 01                   |       |
	 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          | a..aa   | AM, PM                            |       |
	 * |                                 | aaa     | am, pm                            |       |
	 * |                                 | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
	 * |                                 | bbb     | am, pm, noon, midnight            |       |
	 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
	 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
	 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          | m       | 0, 1, ..., 59                     |       |
	 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          | s       | 0, 1, ..., 59                     |       |
	 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | ss      | 00, 01, ..., 59                   |       |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
	 * |                                 | SS      | 00, 01, ..., 99                   |       |
	 * |                                 | SSS     | 000, 001, ..., 999                |       |
	 * |                                 | SSSS    | ...                               | 3     |
	 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
	 * |                                 | XX      | -0800, +0530, Z                   |       |
	 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
	 * |                                 | xx      | -0800, +0530, +0000               |       |
	 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
	 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
	 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
	 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
	 * | Seconds timestamp               | t       | 512969520                         | 7     |
	 * |                                 | tt      | ...                               | 3,7   |
	 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
	 * |                                 | TT      | ...                               | 3,7   |
	 * | Long localized date             | P       | 04/29/1453                        | 7     |
	 * |                                 | PP      | Apr 29, 1453                      | 7     |
	 * |                                 | PPP     | April 29th, 1453                  | 7     |
	 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
	 * | Long localized time             | p       | 12:00 AM                          | 7     |
	 * |                                 | pp      | 12:00:00 AM                       | 7     |
	 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
	 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
	 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
	 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
	 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
	 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
	 *    the output will be the same as default pattern for this unit, usually
	 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
	 *    are marked with "2" in the last column of the table.
	 *
	 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
	 *
	 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
	 *    The output will be padded with zeros to match the length of the pattern.
	 *
	 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
	 *
	 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 5. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` always returns the last two digits of a year,
	 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
	 *
	 *    | Year | `yy` | `uu` |
	 *    |------|------|------|
	 *    | 1    |   01 |   01 |
	 *    | 14   |   14 |   14 |
	 *    | 376  |   76 |  376 |
	 *    | 1453 |   53 | 1453 |
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
	 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
	 *
	 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
	 *    so right now these tokens fall back to GMT timezones.
	 *
	 * 7. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `t`: seconds timestamp
	 *    - `T`: milliseconds timestamp
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
	 *   locale: eoLocale
	 * })
	 * //=> '2-a de julio 2014'
	 *
	 * @example
	 * // Escape string by single quote characters:
	 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
	 * //=> "3 o'clock"
	 */
	
	function format(dirtyDate, dirtyFormatStr, options) {
	  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
	  (0, _index9.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var defaultOptions = (0, _index10.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
	  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	  var originalDate = (0, _index3.default)(dirtyDate);
	  if (!(0, _index.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	  var timezoneOffset = (0, _index6.default)(originalDate);
	  var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
	  var formatterOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale,
	    _originalDate: originalDate
	  };
	  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong);
	    }
	    return substring;
	  }).join('').match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	    var firstCharacter = substring[0];
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	    var formatter = _index4.default[firstCharacter];
	    if (formatter) {
	      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) {
	        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
	      }
	      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) {
	        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
	      }
	      return formatter(utcDate, substring, locale.localize, formatterOptions);
	    }
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	    return substring;
	  }).join('');
	  return result;
	}
	function cleanEscapedString(input) {
	  var matched = input.match(escapedStringRegExp);
	  if (!matched) {
	    return input;
	  }
	  return matched[1].replace(doubleQuoteRegExp, "'");
	}
	module.exports = exports.default;

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDate;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getDate
	 * @category Day Helpers
	 * @summary Get the day of the month of the given date.
	 *
	 * @description
	 * Get the day of the month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the month is 29 February 2012?
	 * const result = getDate(new Date(2012, 1, 29))
	 * //=> 29
	 */
	function getDate(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dayOfMonth = date.getDate();
	  return dayOfMonth;
	}
	module.exports = exports.default;

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDay;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getDay
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * const result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day;
	}
	module.exports = exports.default;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInMonth;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getDaysInMonth
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in February 2000?
	 * const result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var monthIndex = date.getMonth();
	  var lastDayOfMonth = new Date(0);
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	  lastDayOfMonth.setHours(0, 0, 0, 0);
	  return lastDayOfMonth.getDate();
	}
	module.exports = exports.default;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getHours;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getHours
	 * @category Hour Helpers
	 * @summary Get the hours of the given date.
	 *
	 * @description
	 * Get the hours of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the hours of 29 February 2012 11:45:00:
	 * const result = getHours(new Date(2012, 1, 29, 11, 45))
	 * //=> 11
	 */
	function getHours(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var hours = date.getHours();
	  return hours;
	}
	module.exports = exports.default;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMinutes;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getMinutes
	 * @category Minute Helpers
	 * @summary Get the minutes of the given date.
	 *
	 * @description
	 * Get the minutes of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the minutes of 29 February 2012 11:45:05:
	 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 45
	 */
	function getMinutes(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var minutes = date.getMinutes();
	  return minutes;
	}
	module.exports = exports.default;

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMonth;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getMonth
	 * @category Month Helpers
	 * @summary Get the month of the given date.
	 *
	 * @description
	 * Get the month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which month is 29 February 2012?
	 * const result = getMonth(new Date(2012, 1, 29))
	 * //=> 1
	 */
	function getMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  return month;
	}
	module.exports = exports.default;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getQuarter;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getQuarter
	 * @category Quarter Helpers
	 * @summary Get the year quarter of the given date.
	 *
	 * @description
	 * Get the year quarter of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which quarter is 2 July 2014?
	 * const result = getQuarter(new Date(2014, 6, 2))
	 * //=> 3
	 */
	function getQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var quarter = Math.floor(date.getMonth() / 3) + 1;
	  return quarter;
	}
	module.exports = exports.default;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSeconds;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getSeconds
	 * @category Second Helpers
	 * @summary Get the seconds of the given date.
	 *
	 * @description
	 * Get the seconds of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the seconds of 29 February 2012 11:45:05.123:
	 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 5
	 */
	function getSeconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds();
	  return seconds;
	}
	module.exports = exports.default;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTime;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getTime
	 * @category Timestamp Helpers
	 * @summary Get the milliseconds timestamp of the given date.
	 *
	 * @description
	 * Get the milliseconds timestamp of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05.123:
	 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 1330515905123
	 */
	function getTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  return timestamp;
	}
	module.exports = exports.default;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeek;
	var _index = _interopRequireDefault(__webpack_require__(90));
	var _index2 = _interopRequireDefault(__webpack_require__(1028));
	var _index3 = _interopRequireDefault(__webpack_require__(16));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	var MILLISECONDS_IN_WEEK = 604800000;
	
	/**
	 * @name getWeek
	 * @category Week Helpers
	 * @summary Get the local week index of the given date.
	 *
	 * @description
	 * Get the local week index of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week of the local week numbering year is 2 January 2005 with default options?
	 * const result = getWeek(new Date(2005, 0, 2))
	 * //=> 2
	 *
	 * // Which week of the local week numbering year is 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January?
	 * const result = getWeek(new Date(2005, 0, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> 53
	 */
	
	function getWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index3.default)(dirtyDate);
	  var diff = (0, _index.default)(date, options).getTime() - (0, _index2.default)(date, options).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(90));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	var _index5 = __webpack_require__(51);
	/**
	 * @name getWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Get the local week-numbering year of the given date.
	 *
	 * @description
	 * Get the local week-numbering year of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the local week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 with the default settings?
	 * const result = getWeekYear(new Date(2004, 11, 26))
	 * //=> 2005
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
	 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
	 * //=> 2004
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
	 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
	 * //=> 2004
	 */
	function getWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = date.getFullYear();
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index.default)(firstWeekOfNextYear, options);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index.default)(firstWeekOfThisYear, options);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name getYear
	 * @category Year Helpers
	 * @summary Get the year of the given date.
	 *
	 * @description
	 * Get the year of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which year is 2 July 2014?
	 * const result = getYear(new Date(2014, 6, 2))
	 * //=> 2014
	 */
	function getYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getFullYear();
	}
	module.exports = exports.default;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * @param {Date|Number} date - the date that should be after the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() > dateToCompare.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * @param {Date|Number} date - the date that should be before the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() < dateToCompare.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEqual;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isEqual
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Boolean} the dates are equal
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * const result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0),
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual(dirtyLeftDate, dirtyRightDate) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyLeftDate);
	  var dateRight = (0, _index.default)(dirtyRightDate);
	  return dateLeft.getTime() === dateRight.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameDay;
	var _index = _interopRequireDefault(__webpack_require__(174));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isSameDay
	 * @category Day Helpers
	 * @summary Are the given dates in the same day (and year and month)?
	 *
	 * @description
	 * Are the given dates in the same day (and year and month)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day (and year and month)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
	 * //=> true
	 *
	 * @example
	 * // Are 4 September and 4 October in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
	 * //=> false
	 *
	 * @example
	 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
	 * //=> false
	 */
	function isSameDay(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfDay = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfDay = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMonth;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isSameMonth
	 * @category Month Helpers
	 * @summary Are the given dates in the same month (and year)?
	 *
	 * @description
	 * Are the given dates in the same month (and year)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same month (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2015 in the same month?
	 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
	 * //=> false
	 */
	function isSameMonth(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
	}
	module.exports = exports.default;

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameQuarter;
	var _index = _interopRequireDefault(__webpack_require__(327));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isSameQuarter
	 * @category Quarter Helpers
	 * @summary Are the given dates in the same quarter (and year)?
	 *
	 * @description
	 * Are the given dates in the same quarter (and year)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same quarter (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
	 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
	 * //=> true
	 *
	 * @example
	 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
	 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
	 * //=> false
	 */
	function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfQuarter = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfQuarter = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isSameYear
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear();
	}
	module.exports = exports.default;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinInterval;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name isWithinInterval
	 * @category Interval Helpers
	 * @summary Is the given date within the interval?
	 *
	 * @description
	 * Is the given date within the interval? (Including start and end.)
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Interval} interval - the interval to check
	 * @returns {Boolean} the date is within the interval
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For the date within the interval:
	 * isWithinInterval(new Date(2014, 0, 3), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the interval:
	 * isWithinInterval(new Date(2014, 0, 10), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> false
	 *
	 * @example
	 * // For date equal to interval start:
	 * isWithinInterval(date, { start, end: date }) // => true
	 *
	 * @example
	 * // For date equal to interval end:
	 * isWithinInterval(date, { start: date, end }) // => true
	 */
	function isWithinInterval(dirtyDate, interval) {
	  (0, _index2.default)(2, arguments);
	  var time = (0, _index.default)(dirtyDate).getTime();
	  var startTime = (0, _index.default)(interval.start).getTime();
	  var endTime = (0, _index.default)(interval.end).getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  return time >= startTime && time <= endTime;
	}
	module.exports = exports.default;

/***/ },
/* 976 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	function buildFormatLongFn(args) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    // TODO: Remove String()
	    var width = options.width ? String(options.width) : args.defaultWidth;
	    var format = args.formats[width] || args.formats[args.defaultWidth];
	    return format;
	  };
	}
	module.exports = exports.default;

/***/ },
/* 977 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	function buildLocalizeFn(args) {
	  return function (dirtyIndex, options) {
	    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
	    var valuesArray;
	    if (context === 'formatting' && args.formattingValues) {
	      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
	      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
	      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
	    } else {
	      var _defaultWidth = args.defaultWidth;
	      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
	      valuesArray = args.values[_width] || args.values[_defaultWidth];
	    }
	    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
	    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
	    return valuesArray[index];
	  };
	}
	module.exports = exports.default;

/***/ },
/* 978 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	function buildMatchFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var width = options.width;
	    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
	    var matchResult = string.match(matchPattern);
	    if (!matchResult) {
	      return null;
	    }
	    var matchedString = matchResult[0];
	    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
	    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    }) : findKey(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    });
	    var value;
	    value = args.valueCallback ? args.valueCallback(key) : key;
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	function findKey(object, predicate) {
	  for (var key in object) {
	    if (object.hasOwnProperty(key) && predicate(object[key])) {
	      return key;
	    }
	  }
	  return undefined;
	}
	function findIndex(array, predicate) {
	  for (var key = 0; key < array.length; key++) {
	    if (predicate(array[key])) {
	      return key;
	    }
	  }
	  return undefined;
	}
	module.exports = exports.default;

/***/ },
/* 979 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	function buildMatchPatternFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var matchResult = string.match(args.matchPattern);
	    if (!matchResult) return null;
	    var matchedString = matchResult[0];
	    var parseResult = string.match(args.parsePattern);
	    if (!parseResult) return null;
	    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	module.exports = exports.default;

/***/ },
/* 980 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	  aboutXWeeks: {
	    one: 'about 1 week',
	    other: 'about {{count}} weeks'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weeks'
	  },
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	var formatDistance = function formatDistance(token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	  return result;
	};
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(976));
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 982 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'last' eeee 'at' p",
	  yesterday: "'yesterday at' p",
	  today: "'today at' p",
	  tomorrow: "'tomorrow at' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(977));
	var eraValues = {
	  narrow: ['B', 'A'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['Before Christ', 'Anno Domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
	};
	
	// Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  }
	};
	var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
	  var number = Number(dirtyNumber);
	
	  // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`.
	  //
	  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'.
	
	  var rem100 = number % 100;
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	      case 2:
	        return number + 'nd';
	      case 3:
	        return number + 'rd';
	    }
	  }
	  return number + 'th';
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function argumentCallback(quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(978));
	var _index2 = _interopRequireDefault(__webpack_require__(979));
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(before christ|before common era|anno domini|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](th|st|nd|rd)? quarter/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|mo|tu|we|th|fr|sa)/i,
	  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function valueCallback(value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function valueCallback(index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(980));
	var _index2 = _interopRequireDefault(__webpack_require__(981));
	var _index3 = _interopRequireDefault(__webpack_require__(982));
	var _index4 = _interopRequireDefault(__webpack_require__(983));
	var _index5 = _interopRequireDefault(__webpack_require__(984));
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'en-US',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0 /* Sunday */,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = max;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name max
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the latest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * const result = max([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray;
	  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	
	    // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if ((0, _typeof2.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	module.exports = exports.default;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = min;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name min
	 * @category Common Helpers
	 * @summary Returns the earliest of the given dates.
	 *
	 * @description
	 * Returns the earliest of the given dates.
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} - the earliest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * const result = min([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray;
	  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	    // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if ((0, _typeof2.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	module.exports = exports.default;

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AMPMMidnightParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(AMPMMidnightParser, _Parser);
	  var _super = (0, _createSuper2.default)(AMPMMidnightParser);
	  function AMPMMidnightParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, AMPMMidnightParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 80);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(AMPMMidnightParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'b':
	        case 'bb':
	        case 'bbb':
	          return match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'bbbbb':
	          return match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'bbbb':
	        default:
	          return match.dayPeriod(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
	      return date;
	    }
	  }]);
	  return AMPMMidnightParser;
	}(_Parser2.Parser);
	exports.AMPMMidnightParser = AMPMMidnightParser;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AMPMParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	var AMPMParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(AMPMParser, _Parser);
	  var _super = (0, _createSuper2.default)(AMPMParser);
	  function AMPMParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, AMPMParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 80);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(AMPMParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'a':
	        case 'aa':
	        case 'aaa':
	          return match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'aaaaa':
	          return match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'aaaa':
	        default:
	          return match.dayPeriod(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
	      return date;
	    }
	  }]);
	  return AMPMParser;
	}(_Parser2.Parser);
	exports.AMPMParser = AMPMParser;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DateParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _utils = __webpack_require__(28);
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	// Day of the month
	var DateParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DateParser, _Parser);
	  var _super = (0, _createSuper2.default)(DateParser);
	  function DateParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DateParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subPriority", 1);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DateParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'd':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.date, dateString);
	        case 'do':
	          return match.ordinalNumber(dateString, {
	            unit: 'date'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(date, value) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = (0, _utils.isLeapYearIndex)(year);
	      var month = date.getUTCMonth();
	      if (isLeapYear) {
	        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
	      } else {
	        return value >= 1 && value <= DAYS_IN_MONTH[month];
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCDate(value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DateParser;
	}(_Parser2.Parser);
	exports.DateParser = DateParser;

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DayOfYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var _utils = __webpack_require__(28);
	var DayOfYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DayOfYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(DayOfYearParser);
	  function DayOfYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DayOfYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subpriority", 1);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DayOfYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'D':
	        case 'DD':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.dayOfYear, dateString);
	        case 'Do':
	          return match.ordinalNumber(dateString, {
	            unit: 'date'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(date, value) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = (0, _utils.isLeapYearIndex)(year);
	      if (isLeapYear) {
	        return value >= 1 && value <= 366;
	      } else {
	        return value >= 1 && value <= 365;
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth(0, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DayOfYearParser;
	}(_Parser2.Parser);
	exports.DayOfYearParser = DayOfYearParser;

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _index = _interopRequireDefault(__webpack_require__(170));
	// Day of week
	var DayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DayParser, _Parser);
	  var _super = (0, _createSuper2.default)(DayParser);
	  function DayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // Tue
	        case 'E':
	        case 'EE':
	        case 'EEE':
	          return match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	        case 'EEEEE':
	          return match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	        case 'EEEEEE':
	          return match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	        case 'EEEE':
	        default:
	          return match.day(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 6;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      date = (0, _index.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DayParser;
	}(_Parser2.Parser);
	exports.DayParser = DayParser;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DayPeriodParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	// in the morning, in the afternoon, in the evening, at night
	var DayPeriodParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DayPeriodParser, _Parser);
	  var _super = (0, _createSuper2.default)(DayPeriodParser);
	  function DayPeriodParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DayPeriodParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 80);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DayPeriodParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'B':
	        case 'BB':
	        case 'BBB':
	          return match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'BBBBB':
	          return match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'BBBB':
	        default:
	          return match.dayPeriod(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DayPeriodParser;
	}(_Parser2.Parser);
	exports.DayPeriodParser = DayPeriodParser;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EraParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var EraParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(EraParser, _Parser);
	  var _super = (0, _createSuper2.default)(EraParser);
	  function EraParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, EraParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 140);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(EraParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // AD, BC
	        case 'G':
	        case 'GG':
	        case 'GGG':
	          return match.era(dateString, {
	            width: 'abbreviated'
	          }) || match.era(dateString, {
	            width: 'narrow'
	          });
	        // A, B
	        case 'GGGGG':
	          return match.era(dateString, {
	            width: 'narrow'
	          });
	        // Anno Domini, Before Christ
	        case 'GGGG':
	        default:
	          return match.era(dateString, {
	            width: 'wide'
	          }) || match.era(dateString, {
	            width: 'abbreviated'
	          }) || match.era(dateString, {
	            width: 'narrow'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      flags.era = value;
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return EraParser;
	}(_Parser2.Parser);
	exports.EraParser = EraParser;

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ExtendedYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ExtendedYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(ExtendedYearParser);
	  function ExtendedYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ExtendedYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ExtendedYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      if (token === 'u') {
	        return (0, _utils.parseNDigitsSigned)(4, dateString);
	      }
	      return (0, _utils.parseNDigitsSigned)(token.length, dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return ExtendedYearParser;
	}(_Parser2.Parser);
	exports.ExtendedYearParser = ExtendedYearParser;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FractionOfSecondParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(FractionOfSecondParser, _Parser);
	  var _super = (0, _createSuper2.default)(FractionOfSecondParser);
	  function FractionOfSecondParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, FractionOfSecondParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 30);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(FractionOfSecondParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      var valueCallback = function valueCallback(value) {
	        return Math.floor(value * Math.pow(10, -token.length + 3));
	      };
	      return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMilliseconds(value);
	      return date;
	    }
	  }]);
	  return FractionOfSecondParser;
	}(_Parser2.Parser);
	exports.FractionOfSecondParser = FractionOfSecondParser;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour0To11Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var _utils = __webpack_require__(28);
	var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour0To11Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour0To11Parser);
	  function Hour0To11Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour0To11Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour0To11Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'K':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour11h, dateString);
	        case 'Ko':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 11;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      var isPM = date.getUTCHours() >= 12;
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	      return date;
	    }
	  }]);
	  return Hour0To11Parser;
	}(_Parser2.Parser);
	exports.Hour0To11Parser = Hour0To11Parser;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour0to23Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var _utils = __webpack_require__(28);
	var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour0to23Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour0to23Parser);
	  function Hour0to23Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour0to23Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour0to23Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'H':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour23h, dateString);
	        case 'Ho':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 23;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours(value, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return Hour0to23Parser;
	}(_Parser2.Parser);
	exports.Hour0to23Parser = Hour0to23Parser;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour1To24Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var _utils = __webpack_require__(28);
	var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour1To24Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour1To24Parser);
	  function Hour1To24Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour1To24Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour1To24Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'k':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour24h, dateString);
	        case 'ko':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 24;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      var hours = value <= 24 ? value % 24 : value;
	      date.setUTCHours(hours, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return Hour1To24Parser;
	}(_Parser2.Parser);
	exports.Hour1To24Parser = Hour1To24Parser;

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour1to12Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var _utils = __webpack_require__(28);
	var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour1to12Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour1to12Parser);
	  function Hour1to12Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour1to12Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour1to12Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'h':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour12h, dateString);
	        case 'ho':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 12;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      var isPM = date.getUTCHours() >= 12;
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else if (!isPM && value === 12) {
	        date.setUTCHours(0, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	      return date;
	    }
	  }]);
	  return Hour1to12Parser;
	}(_Parser2.Parser);
	exports.Hour1to12Parser = Hour1to12Parser;

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISODayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	var _index = _interopRequireDefault(__webpack_require__(943));
	// ISO day of week
	var ISODayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISODayParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISODayParser);
	  function ISODayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISODayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISODayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(value) {
	        if (value === 0) {
	          return 7;
	        }
	        return value;
	      };
	      switch (token) {
	        // 2
	        case 'i':
	        case 'ii':
	          // 02
	          return (0, _utils.parseNDigits)(token.length, dateString);
	        // 2nd
	        case 'io':
	          return match.ordinalNumber(dateString, {
	            unit: 'day'
	          });
	        // Tue
	        case 'iii':
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	        // T
	        case 'iiiii':
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	        // Tu
	        case 'iiiiii':
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	        // Tuesday
	        case 'iiii':
	        default:
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 7;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date = (0, _index.default)(date, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return ISODayParser;
	}(_Parser2.Parser);
	exports.ISODayParser = ISODayParser;

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOTimezoneParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var _utils = __webpack_require__(28);
	// Timezone (ISO-8601)
	var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOTimezoneParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOTimezoneParser);
	  function ISOTimezoneParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOTimezoneParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 10);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T', 'X']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOTimezoneParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      switch (token) {
	        case 'x':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalMinutes, dateString);
	        case 'xx':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basic, dateString);
	        case 'xxxx':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalSeconds, dateString);
	        case 'xxxxx':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extendedOptionalSeconds, dateString);
	        case 'xxx':
	        default:
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extended, dateString);
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	      return new Date(date.getTime() - value);
	    }
	  }]);
	  return ISOTimezoneParser;
	}(_Parser2.Parser);
	exports.ISOTimezoneParser = ISOTimezoneParser;

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOTimezoneWithZParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var _utils = __webpack_require__(28);
	// Timezone (ISO-8601. +00:00 is `'Z'`)
	var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOTimezoneWithZParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOTimezoneWithZParser);
	  function ISOTimezoneWithZParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOTimezoneWithZParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 10);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T', 'x']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOTimezoneWithZParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      switch (token) {
	        case 'X':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalMinutes, dateString);
	        case 'XX':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basic, dateString);
	        case 'XXXX':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalSeconds, dateString);
	        case 'XXXXX':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extendedOptionalSeconds, dateString);
	        case 'XXX':
	        default:
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extended, dateString);
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	      return new Date(date.getTime() - value);
	    }
	  }]);
	  return ISOTimezoneWithZParser;
	}(_Parser2.Parser);
	exports.ISOTimezoneWithZParser = ISOTimezoneWithZParser;

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOWeekParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var _utils = __webpack_require__(28);
	var _index = _interopRequireDefault(__webpack_require__(944));
	var _index2 = _interopRequireDefault(__webpack_require__(88));
	// ISO week of year
	var ISOWeekParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOWeekParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOWeekParser);
	  function ISOWeekParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOWeekParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 100);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOWeekParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'I':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.week, dateString);
	        case 'Io':
	          return match.ordinalNumber(dateString, {
	            unit: 'week'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 53;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      return (0, _index2.default)((0, _index.default)(date, value));
	    }
	  }]);
	  return ISOWeekParser;
	}(_Parser2.Parser);
	exports.ISOWeekParser = ISOWeekParser;

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOWeekYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	var _index = _interopRequireDefault(__webpack_require__(88));
	// ISO week-numbering year
	var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOWeekYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOWeekYearParser);
	  function ISOWeekYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOWeekYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOWeekYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      if (token === 'R') {
	        return (0, _utils.parseNDigitsSigned)(4, dateString);
	      }
	      return (0, _utils.parseNDigitsSigned)(token.length, dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(_date, _flags, value) {
	      var firstWeekOfYear = new Date(0);
	      firstWeekOfYear.setUTCFullYear(value, 0, 4);
	      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
	      return (0, _index.default)(firstWeekOfYear);
	    }
	  }]);
	  return ISOWeekYearParser;
	}(_Parser2.Parser);
	exports.ISOWeekYearParser = ISOWeekYearParser;

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalDayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	var _index = _interopRequireDefault(__webpack_require__(170));
	// Local day of week
	var LocalDayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(LocalDayParser, _Parser);
	  var _super = (0, _createSuper2.default)(LocalDayParser);
	  function LocalDayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, LocalDayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(LocalDayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match, options) {
	      var valueCallback = function valueCallback(value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	      switch (token) {
	        // 3
	        case 'e':
	        case 'ee':
	          // 03
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	        // 3rd
	        case 'eo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'day'
	          }), valueCallback);
	        // Tue
	        case 'eee':
	          return match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	        case 'eeeee':
	          return match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	        case 'eeeeee':
	          return match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	        case 'eeee':
	        default:
	          return match.day(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 6;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      date = (0, _index.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return LocalDayParser;
	}(_Parser2.Parser);
	exports.LocalDayParser = LocalDayParser;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalWeekParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var _utils = __webpack_require__(28);
	var _index = _interopRequireDefault(__webpack_require__(945));
	var _index2 = _interopRequireDefault(__webpack_require__(89));
	// Local week of year
	var LocalWeekParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(LocalWeekParser, _Parser);
	  var _super = (0, _createSuper2.default)(LocalWeekParser);
	  function LocalWeekParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, LocalWeekParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 100);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(LocalWeekParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'w':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.week, dateString);
	        case 'wo':
	          return match.ordinalNumber(dateString, {
	            unit: 'week'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 53;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      return (0, _index2.default)((0, _index.default)(date, value, options), options);
	    }
	  }]);
	  return LocalWeekParser;
	}(_Parser2.Parser);
	exports.LocalWeekParser = LocalWeekParser;

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalWeekYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	var _index = _interopRequireDefault(__webpack_require__(169));
	var _index2 = _interopRequireDefault(__webpack_require__(89));
	// Local week-numbering year
	var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(LocalWeekYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(LocalWeekYearParser);
	  function LocalWeekYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, LocalWeekYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(LocalWeekYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'YY'
	        };
	      };
	      switch (token) {
	        case 'Y':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(4, dateString), valueCallback);
	        case 'Yo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'year'
	          }), valueCallback);
	        default:
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value.isTwoDigitYear || value.year > 0;
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value, options) {
	      var currentYear = (0, _index.default)(date, options);
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
	        date.setUTCHours(0, 0, 0, 0);
	        return (0, _index2.default)(date, options);
	      }
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
	      date.setUTCHours(0, 0, 0, 0);
	      return (0, _index2.default)(date, options);
	    }
	  }]);
	  return LocalWeekYearParser;
	}(_Parser2.Parser);
	exports.LocalWeekYearParser = LocalWeekYearParser;

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MinuteParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var _utils = __webpack_require__(28);
	var MinuteParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(MinuteParser, _Parser);
	  var _super = (0, _createSuper2.default)(MinuteParser);
	  function MinuteParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, MinuteParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 60);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(MinuteParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'm':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.minute, dateString);
	        case 'mo':
	          return match.ordinalNumber(dateString, {
	            unit: 'minute'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 59;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMinutes(value, 0, 0);
	      return date;
	    }
	  }]);
	  return MinuteParser;
	}(_Parser2.Parser);
	exports.MinuteParser = MinuteParser;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MonthParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _utils = __webpack_require__(28);
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var MonthParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(MonthParser, _Parser);
	  var _super = (0, _createSuper2.default)(MonthParser);
	  function MonthParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, MonthParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 110);
	    return _this;
	  }
	  (0, _createClass2.default)(MonthParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(value) {
	        return value - 1;
	      };
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'M':
	          return (0, _utils.mapValue)((0, _utils.parseNumericPattern)(_constants.numericPatterns.month, dateString), valueCallback);
	        // 01, 02, ..., 12
	        case 'MM':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(2, dateString), valueCallback);
	        // 1st, 2nd, ..., 12th
	        case 'Mo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'month'
	          }), valueCallback);
	        // Jan, Feb, ..., Dec
	        case 'MMM':
	          return match.month(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // J, F, ..., D
	        case 'MMMMM':
	          return match.month(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // January, February, ..., December
	        case 'MMMM':
	        default:
	          return match.month(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.month(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 11;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return MonthParser;
	}(_Parser2.Parser);
	exports.MonthParser = MonthParser;

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuarterParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	var QuarterParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(QuarterParser, _Parser);
	  var _super = (0, _createSuper2.default)(QuarterParser);
	  function QuarterParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, QuarterParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 120);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(QuarterParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'Q':
	        case 'QQ':
	          // 01, 02, 03, 04
	          return (0, _utils.parseNDigits)(token.length, dateString);
	        // 1st, 2nd, 3rd, 4th
	        case 'Qo':
	          return match.ordinalNumber(dateString, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	        case 'QQQ':
	          return match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	        case 'QQQQQ':
	          return match.quarter(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1st quarter, 2nd quarter, ...
	        case 'QQQQ':
	        default:
	          return match.quarter(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 4;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return QuarterParser;
	}(_Parser2.Parser);
	exports.QuarterParser = QuarterParser;

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SecondParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var _utils = __webpack_require__(28);
	var SecondParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(SecondParser, _Parser);
	  var _super = (0, _createSuper2.default)(SecondParser);
	  function SecondParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, SecondParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 50);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(SecondParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 's':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.second, dateString);
	        case 'so':
	          return match.ordinalNumber(dateString, {
	            unit: 'second'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 59;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCSeconds(value, 0);
	      return date;
	    }
	  }]);
	  return SecondParser;
	}(_Parser2.Parser);
	exports.SecondParser = SecondParser;

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StandAloneLocalDayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	var _index = _interopRequireDefault(__webpack_require__(170));
	// Stand-alone local day of week
	var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(StandAloneLocalDayParser, _Parser);
	  var _super = (0, _createSuper2.default)(StandAloneLocalDayParser);
	  function StandAloneLocalDayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, StandAloneLocalDayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(StandAloneLocalDayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match, options) {
	      var valueCallback = function valueCallback(value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	      switch (token) {
	        // 3
	        case 'c':
	        case 'cc':
	          // 03
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	        // 3rd
	        case 'co':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'day'
	          }), valueCallback);
	        // Tue
	        case 'ccc':
	          return match.day(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // T
	        case 'ccccc':
	          return match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tu
	        case 'cccccc':
	          return match.day(dateString, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tuesday
	        case 'cccc':
	        default:
	          return match.day(dateString, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 6;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      date = (0, _index.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return StandAloneLocalDayParser;
	}(_Parser2.Parser);
	exports.StandAloneLocalDayParser = StandAloneLocalDayParser;

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StandAloneMonthParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _constants = __webpack_require__(39);
	var _utils = __webpack_require__(28);
	var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(StandAloneMonthParser, _Parser);
	  var _super = (0, _createSuper2.default)(StandAloneMonthParser);
	  function StandAloneMonthParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, StandAloneMonthParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 110);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(StandAloneMonthParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(value) {
	        return value - 1;
	      };
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'L':
	          return (0, _utils.mapValue)((0, _utils.parseNumericPattern)(_constants.numericPatterns.month, dateString), valueCallback);
	        // 01, 02, ..., 12
	        case 'LL':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(2, dateString), valueCallback);
	        // 1st, 2nd, ..., 12th
	        case 'Lo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'month'
	          }), valueCallback);
	        // Jan, Feb, ..., Dec
	        case 'LLL':
	          return match.month(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // J, F, ..., D
	        case 'LLLLL':
	          return match.month(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // January, February, ..., December
	        case 'LLLL':
	        default:
	          return match.month(dateString, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.month(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 11;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return StandAloneMonthParser;
	}(_Parser2.Parser);
	exports.StandAloneMonthParser = StandAloneMonthParser;

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StandAloneQuarterParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(StandAloneQuarterParser, _Parser);
	  var _super = (0, _createSuper2.default)(StandAloneQuarterParser);
	  function StandAloneQuarterParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, StandAloneQuarterParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 120);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(StandAloneQuarterParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'q':
	        case 'qq':
	          // 01, 02, 03, 04
	          return (0, _utils.parseNDigits)(token.length, dateString);
	        // 1st, 2nd, 3rd, 4th
	        case 'qo':
	          return match.ordinalNumber(dateString, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	        case 'qqq':
	          return match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	        case 'qqqqq':
	          return match.quarter(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1st quarter, 2nd quarter, ...
	        case 'qqqq':
	        default:
	          return match.quarter(dateString, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 4;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return StandAloneQuarterParser;
	}(_Parser2.Parser);
	exports.StandAloneQuarterParser = StandAloneQuarterParser;

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimestampMillisecondsParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(TimestampMillisecondsParser, _Parser);
	  var _super = (0, _createSuper2.default)(TimestampMillisecondsParser);
	  function TimestampMillisecondsParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, TimestampMillisecondsParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 20);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", '*');
	    return _this;
	  }
	  (0, _createClass2.default)(TimestampMillisecondsParser, [{
	    key: "parse",
	    value: function parse(dateString) {
	      return (0, _utils.parseAnyDigitsSigned)(dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(_date, _flags, value) {
	      return [new Date(value), {
	        timestampIsSet: true
	      }];
	    }
	  }]);
	  return TimestampMillisecondsParser;
	}(_Parser2.Parser);
	exports.TimestampMillisecondsParser = TimestampMillisecondsParser;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimestampSecondsParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(TimestampSecondsParser, _Parser);
	  var _super = (0, _createSuper2.default)(TimestampSecondsParser);
	  function TimestampSecondsParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, TimestampSecondsParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 40);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", '*');
	    return _this;
	  }
	  (0, _createClass2.default)(TimestampSecondsParser, [{
	    key: "parse",
	    value: function parse(dateString) {
	      return (0, _utils.parseAnyDigitsSigned)(dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(_date, _flags, value) {
	      return [new Date(value * 1000), {
	        timestampIsSet: true
	      }];
	    }
	  }]);
	  return TimestampSecondsParser;
	}(_Parser2.Parser);
	exports.TimestampSecondsParser = TimestampSecondsParser;

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _Parser2 = __webpack_require__(27);
	var _utils = __webpack_require__(28);
	// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
	// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	// |----------|-------|----|-------|-------|-------|
	// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	var YearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(YearParser, _Parser);
	  var _super = (0, _createSuper2.default)(YearParser);
	  function YearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, YearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(YearParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'yy'
	        };
	      };
	      switch (token) {
	        case 'y':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(4, dateString), valueCallback);
	        case 'yo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'year'
	          }), valueCallback);
	        default:
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value.isTwoDigitYear || value.year > 0;
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      var currentYear = date.getUTCFullYear();
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
	        date.setUTCHours(0, 0, 0, 0);
	        return date;
	      }
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return YearParser;
	}(_Parser2.Parser);
	exports.YearParser = YearParser;

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parsers = void 0;
	var _EraParser = __webpack_require__(994);
	var _YearParser = __webpack_require__(1018);
	var _LocalWeekYearParser = __webpack_require__(1008);
	var _ISOWeekYearParser = __webpack_require__(1005);
	var _ExtendedYearParser = __webpack_require__(995);
	var _QuarterParser = __webpack_require__(1011);
	var _StandAloneQuarterParser = __webpack_require__(1015);
	var _MonthParser = __webpack_require__(1010);
	var _StandAloneMonthParser = __webpack_require__(1014);
	var _LocalWeekParser = __webpack_require__(1007);
	var _ISOWeekParser = __webpack_require__(1004);
	var _DateParser = __webpack_require__(990);
	var _DayOfYearParser = __webpack_require__(991);
	var _DayParser = __webpack_require__(992);
	var _LocalDayParser = __webpack_require__(1006);
	var _StandAloneLocalDayParser = __webpack_require__(1013);
	var _ISODayParser = __webpack_require__(1001);
	var _AMPMParser = __webpack_require__(989);
	var _AMPMMidnightParser = __webpack_require__(988);
	var _DayPeriodParser = __webpack_require__(993);
	var _Hour1to12Parser = __webpack_require__(1000);
	var _Hour0to23Parser = __webpack_require__(998);
	var _Hour0To11Parser = __webpack_require__(997);
	var _Hour1To24Parser = __webpack_require__(999);
	var _MinuteParser = __webpack_require__(1009);
	var _SecondParser = __webpack_require__(1012);
	var _FractionOfSecondParser = __webpack_require__(996);
	var _ISOTimezoneWithZParser = __webpack_require__(1003);
	var _ISOTimezoneParser = __webpack_require__(1002);
	var _TimestampSecondsParser = __webpack_require__(1017);
	var _TimestampMillisecondsParser = __webpack_require__(1016);
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
	 * |  p  |                                |  P  |                                |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 */
	var parsers = {
	  G: new _EraParser.EraParser(),
	  y: new _YearParser.YearParser(),
	  Y: new _LocalWeekYearParser.LocalWeekYearParser(),
	  R: new _ISOWeekYearParser.ISOWeekYearParser(),
	  u: new _ExtendedYearParser.ExtendedYearParser(),
	  Q: new _QuarterParser.QuarterParser(),
	  q: new _StandAloneQuarterParser.StandAloneQuarterParser(),
	  M: new _MonthParser.MonthParser(),
	  L: new _StandAloneMonthParser.StandAloneMonthParser(),
	  w: new _LocalWeekParser.LocalWeekParser(),
	  I: new _ISOWeekParser.ISOWeekParser(),
	  d: new _DateParser.DateParser(),
	  D: new _DayOfYearParser.DayOfYearParser(),
	  E: new _DayParser.DayParser(),
	  e: new _LocalDayParser.LocalDayParser(),
	  c: new _StandAloneLocalDayParser.StandAloneLocalDayParser(),
	  i: new _ISODayParser.ISODayParser(),
	  a: new _AMPMParser.AMPMParser(),
	  b: new _AMPMMidnightParser.AMPMMidnightParser(),
	  B: new _DayPeriodParser.DayPeriodParser(),
	  h: new _Hour1to12Parser.Hour1to12Parser(),
	  H: new _Hour0to23Parser.Hour0to23Parser(),
	  K: new _Hour0To11Parser.Hour0To11Parser(),
	  k: new _Hour1To24Parser.Hour1To24Parser(),
	  m: new _MinuteParser.MinuteParser(),
	  s: new _SecondParser.SecondParser(),
	  S: new _FractionOfSecondParser.FractionOfSecondParser(),
	  X: new _ISOTimezoneWithZParser.ISOTimezoneWithZParser(),
	  x: new _ISOTimezoneParser.ISOTimezoneParser(),
	  t: new _TimestampSecondsParser.TimestampSecondsParser(),
	  T: new _TimestampMillisecondsParser.TimestampMillisecondsParser()
	};
	exports.parsers = parsers;

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parse;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _createForOfIteratorHelper2 = _interopRequireDefault(__webpack_require__(526));
	var _index = _interopRequireDefault(__webpack_require__(312));
	var _index2 = _interopRequireDefault(__webpack_require__(328));
	var _index3 = _interopRequireDefault(__webpack_require__(16));
	var _index4 = _interopRequireDefault(__webpack_require__(939));
	var _index5 = _interopRequireDefault(__webpack_require__(313));
	var _index6 = _interopRequireDefault(__webpack_require__(119));
	var _index7 = __webpack_require__(317);
	var _index8 = _interopRequireDefault(__webpack_require__(25));
	var _index9 = _interopRequireDefault(__webpack_require__(14));
	var _Setter = __webpack_require__(325);
	var _index10 = __webpack_require__(1019);
	var _index11 = __webpack_require__(51);
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
	
	// This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var notWhitespaceRegExp = /\S/;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	
	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format string.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * parse('23 AM', 'HH a', new Date())
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `parse` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
	 *
	 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
	 *
	 *    while `uu` will just assign the year as is:
	 *
	 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
	 *
	 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be assigned to the date in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
	 *
	 * `referenceDate` must be passed for correct work of the function.
	 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
	 *   locale: eo
	 * })
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
	  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
	  (0, _index9.default)(3, arguments);
	  var dateString = String(dirtyDateString);
	  var formatString = String(dirtyFormatString);
	  var defaultOptions = (0, _index11.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index.default;
	  if (!locale.match) {
	    throw new RangeError('locale must contain match property');
	  }
	  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  if (formatString === '') {
	    if (dateString === '') {
	      return (0, _index3.default)(dirtyReferenceDate);
	    } else {
	      return new Date(NaN);
	    }
	  }
	  var subFnOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale
	  };
	
	  // If timezone isn't specified, it will be set to the system timezone
	  var setters = [new _Setter.DateToSystemTimezoneSetter()];
	  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	    if (firstCharacter in _index5.default) {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong);
	    }
	    return substring;
	  }).join('').match(formattingTokensRegExp);
	  var usedTokens = [];
	  var _iterator = (0, _createForOfIteratorHelper2.default)(tokens),
	    _step;
	  try {
	    var _loop = function _loop() {
	      var token = _step.value;
	      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(token)) {
	        (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	      }
	      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(token)) {
	        (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	      }
	      var firstCharacter = token[0];
	      var parser = _index10.parsers[firstCharacter];
	      if (parser) {
	        var incompatibleTokens = parser.incompatibleTokens;
	        if (Array.isArray(incompatibleTokens)) {
	          var incompatibleToken = usedTokens.find(function (usedToken) {
	            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
	          });
	          if (incompatibleToken) {
	            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
	          }
	        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
	          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
	        }
	        usedTokens.push({
	          token: firstCharacter,
	          fullToken: token
	        });
	        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
	        if (!parseResult) {
	          return {
	            v: new Date(NaN)
	          };
	        }
	        setters.push(parseResult.setter);
	        dateString = parseResult.rest;
	      } else {
	        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	        }
	
	        // Replace two single quote characters with one single quote character
	        if (token === "''") {
	          token = "'";
	        } else if (firstCharacter === "'") {
	          token = cleanEscapedString(token);
	        }
	
	        // Cut token from string, or, if string doesn't match the token, return Invalid Date
	        if (dateString.indexOf(token) === 0) {
	          dateString = dateString.slice(token.length);
	        } else {
	          return {
	            v: new Date(NaN)
	          };
	        }
	      }
	    };
	    for (_iterator.s(); !(_step = _iterator.n()).done;) {
	      var _ret = _loop();
	      if ((0, _typeof2.default)(_ret) === "object") return _ret.v;
	    }
	
	    // Check if the remaining input contains something other than whitespace
	  } catch (err) {
	    _iterator.e(err);
	  } finally {
	    _iterator.f();
	  }
	  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
	    return new Date(NaN);
	  }
	  var uniquePrioritySetters = setters.map(function (setter) {
	    return setter.priority;
	  }).sort(function (a, b) {
	    return b - a;
	  }).filter(function (priority, index, array) {
	    return array.indexOf(priority) === index;
	  }).map(function (priority) {
	    return setters.filter(function (setter) {
	      return setter.priority === priority;
	    }).sort(function (a, b) {
	      return b.subPriority - a.subPriority;
	    });
	  }).map(function (setterArray) {
	    return setterArray[0];
	  });
	  var date = (0, _index3.default)(dirtyReferenceDate);
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  var utcDate = (0, _index2.default)(date, (0, _index6.default)(date));
	  var flags = {};
	  var _iterator2 = (0, _createForOfIteratorHelper2.default)(uniquePrioritySetters),
	    _step2;
	  try {
	    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	      var setter = _step2.value;
	      if (!setter.validate(utcDate, subFnOptions)) {
	        return new Date(NaN);
	      }
	      var result = setter.set(utcDate, flags, subFnOptions);
	      // Result is tuple (date, flags)
	      if (Array.isArray(result)) {
	        utcDate = result[0];
	        (0, _index4.default)(flags, result[1]);
	        // Result is date
	      } else {
	        utcDate = result;
	      }
	    }
	  } catch (err) {
	    _iterator2.e(err);
	  } finally {
	    _iterator2.f();
	  }
	  return utcDate;
	}
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	module.exports = exports.default;

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseISO;
	var _index = __webpack_require__(322);
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	/**
	 * @name parseISO
	 * @category Common Helpers
	 * @summary Parse ISO string
	 *
	 * @description
	 * Parse the given string in ISO 8601 format and return an instance of Date.
	 *
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument isn't a string, the function cannot parse the string or
	 * the values are invalid, it returns Invalid Date.
	 *
	 * @param {String} argument - the value to convert
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * const result = parseISO('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * const result = parseISO('+02014101', { additionalDigits: 1 })
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function parseISO(argument, options) {
	  var _options$additionalDi;
	  (0, _index2.default)(1, arguments);
	  var additionalDigits = (0, _index3.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
	    return new Date(NaN);
	  }
	  var dateStrings = splitDateString(argument);
	  var date;
	  if (dateStrings.date) {
	    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
	  }
	  if (!date || isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	  var timestamp = date.getTime();
	  var time = 0;
	  var offset;
	  if (dateStrings.time) {
	    time = parseTime(dateStrings.time);
	    if (isNaN(time)) {
	      return new Date(NaN);
	    }
	  }
	  if (dateStrings.timezone) {
	    offset = parseTimezone(dateStrings.timezone);
	    if (isNaN(offset)) {
	      return new Date(NaN);
	    }
	  } else {
	    var dirtyDate = new Date(timestamp + time);
	    // js parsed string assuming it's in UTC timezone
	    // but we need it to be parsed in our timezone
	    // so we use utc values to build date in our timezone.
	    // Year values from 0 to 99 map to the years 1900 to 1999
	    // so set year explicitly with setFullYear.
	    var result = new Date(0);
	    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
	    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
	    return result;
	  }
	  return new Date(timestamp + time + offset);
	}
	var patterns = {
	  dateTimeDelimiter: /[T ]/,
	  timeZoneDelimiter: /[Z ]/i,
	  timezone: /([Z+-].*)$/
	};
	var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
	var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
	var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimiter);
	  var timeString;
	
	  // The regex match should only return at maximum two array elements.
	  // [date], [time], or [date, time].
	  if (array.length > 2) {
	    return dateStrings;
	  }
	  if (/:/.test(array[0])) {
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
	      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
	      timeString = dateString.substr(dateStrings.date.length, dateString.length);
	    }
	  }
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	  return dateStrings;
	}
	function parseYear(dateString, additionalDigits) {
	  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
	  var captures = dateString.match(regex);
	  // Invalid ISO-formatted year
	  if (!captures) return {
	    year: NaN,
	    restDateString: ''
	  };
	  var year = captures[1] ? parseInt(captures[1]) : null;
	  var century = captures[2] ? parseInt(captures[2]) : null;
	
	  // either year or century is null, not both
	  return {
	    year: century === null ? year : century * 100,
	    restDateString: dateString.slice((captures[1] || captures[2]).length)
	  };
	}
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) return new Date(NaN);
	  var captures = dateString.match(dateRegex);
	  // Invalid ISO-formatted string
	  if (!captures) return new Date(NaN);
	  var isWeekDate = !!captures[4];
	  var dayOfYear = parseDateUnit(captures[1]);
	  var month = parseDateUnit(captures[2]) - 1;
	  var day = parseDateUnit(captures[3]);
	  var week = parseDateUnit(captures[4]);
	  var dayOfWeek = parseDateUnit(captures[5]) - 1;
	  if (isWeekDate) {
	    if (!validateWeekDate(year, week, dayOfWeek)) {
	      return new Date(NaN);
	    }
	    return dayOfISOWeekYear(year, week, dayOfWeek);
	  } else {
	    var date = new Date(0);
	    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
	      return new Date(NaN);
	    }
	    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
	    return date;
	  }
	}
	function parseDateUnit(value) {
	  return value ? parseInt(value) : 1;
	}
	function parseTime(timeString) {
	  var captures = timeString.match(timeRegex);
	  if (!captures) return NaN; // Invalid ISO-formatted time
	
	  var hours = parseTimeUnit(captures[1]);
	  var minutes = parseTimeUnit(captures[2]);
	  var seconds = parseTimeUnit(captures[3]);
	  if (!validateTime(hours, minutes, seconds)) {
	    return NaN;
	  }
	  return hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * 1000;
	}
	function parseTimeUnit(value) {
	  return value && parseFloat(value.replace(',', '.')) || 0;
	}
	function parseTimezone(timezoneString) {
	  if (timezoneString === 'Z') return 0;
	  var captures = timezoneString.match(timezoneRegex);
	  if (!captures) return 0;
	  var sign = captures[1] === '+' ? -1 : 1;
	  var hours = parseInt(captures[2]);
	  var minutes = captures[3] && parseInt(captures[3]) || 0;
	  if (!validateTimezone(hours, minutes)) {
	    return NaN;
	  }
	  return sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute);
	}
	function dayOfISOWeekYear(isoWeekYear, week, day) {
	  var date = new Date(0);
	  date.setUTCFullYear(isoWeekYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	// Validation functions
	
	// February is null to handle the leap year (using ||)
	var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	function validateDate(year, month, date) {
	  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
	}
	function validateDayOfYearDate(year, dayOfYear) {
	  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
	}
	function validateWeekDate(_year, week, day) {
	  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
	}
	function validateTime(hours, minutes, seconds) {
	  if (hours === 24) {
	    return minutes === 0 && seconds === 0;
	  }
	  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
	}
	function validateTimezone(_hours, minutes) {
	  return minutes >= 0 && minutes <= 59;
	}
	module.exports = exports.default;

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setHours;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name setHours
	 * @category Hour Helpers
	 * @summary Set the hours to the given date.
	 *
	 * @description
	 * Set the hours to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} hours - the hours of the new date
	 * @returns {Date} the new date with the hours set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 4 hours to 1 September 2014 11:30:00:
	 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
	 * //=> Mon Sep 01 2014 04:30:00
	 */
	function setHours(dirtyDate, dirtyHours) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var hours = (0, _index.default)(dirtyHours);
	  date.setHours(hours);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMinutes;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name setMinutes
	 * @category Minute Helpers
	 * @summary Set the minutes to the given date.
	 *
	 * @description
	 * Set the minutes to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} minutes - the minutes of the new date
	 * @returns {Date} the new date with the minutes set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 minutes to 1 September 2014 11:30:40:
	 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:45:40
	 */
	function setMinutes(dirtyDate, dirtyMinutes) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var minutes = (0, _index.default)(dirtyMinutes);
	  date.setMinutes(minutes);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setQuarter;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(326));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name setQuarter
	 * @category Quarter Helpers
	 * @summary Set the year quarter to the given date.
	 *
	 * @description
	 * Set the year quarter to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} quarter - the quarter of the new date
	 * @returns {Date} the new date with the quarter set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd quarter to 2 July 2014:
	 * const result = setQuarter(new Date(2014, 6, 2), 2)
	 * //=> Wed Apr 02 2014 00:00:00
	 */
	function setQuarter(dirtyDate, dirtyQuarter) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var quarter = (0, _index.default)(dirtyQuarter);
	  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
	  var diff = quarter - oldQuarter;
	  return (0, _index3.default)(date, date.getMonth() + diff * 3);
	}
	module.exports = exports.default;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setSeconds;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name setSeconds
	 * @category Second Helpers
	 * @summary Set the seconds to the given date.
	 *
	 * @description
	 * Set the seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} seconds - the seconds of the new date
	 * @returns {Date} the new date with the seconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 seconds to 1 September 2014 11:30:40:
	 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:30:45
	 */
	function setSeconds(dirtyDate, dirtySeconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var seconds = (0, _index.default)(dirtySeconds);
	  date.setSeconds(seconds);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setYear;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(16));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name setYear
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @returns {Date} the new date with the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * const result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear(dirtyDate, dirtyYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = (0, _index.default)(dirtyYear);
	
	  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	  date.setFullYear(year);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMonth;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name startOfMonth
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(966));
	var _index2 = _interopRequireDefault(__webpack_require__(90));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	var _index4 = _interopRequireDefault(__webpack_require__(14));
	var _index5 = __webpack_require__(51);
	/**
	 * @name startOfWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Return the start of a local week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of a local week-numbering year.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the start of a week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // The start of an a week-numbering year for 2 July 2005 with default settings:
	 * const result = startOfWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // The start of a week-numbering year for 2 July 2005
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * const result = startOfWeekYear(new Date(2005, 6, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index4.default)(1, arguments);
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	  var year = (0, _index.default)(dirtyDate, options);
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(firstWeek, options);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYear;
	var _index = _interopRequireDefault(__webpack_require__(16));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name startOfYear
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var cleanDate = (0, _index.default)(dirtyDate);
	  var date = new Date(0);
	  date.setFullYear(cleanDate.getFullYear(), 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subDays;
	var _index = _interopRequireDefault(__webpack_require__(171));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	/**
	 * @name subDays
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * const result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subHours;
	var _index = _interopRequireDefault(__webpack_require__(318));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	/**
	 * @name subHours
	 * @category Hour Helpers
	 * @summary Subtract the specified number of hours from the given date.
	 *
	 * @description
	 * Subtract the specified number of hours from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 2 hours from 11 July 2014 01:00:00:
	 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
	 * //=> Thu Jul 10 2014 23:00:00
	 */
	function subHours(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMinutes;
	var _index = _interopRequireDefault(__webpack_require__(319));
	var _index2 = _interopRequireDefault(__webpack_require__(14));
	var _index3 = _interopRequireDefault(__webpack_require__(25));
	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMonths;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(173));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name subMonths
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * const result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subWeeks;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(320));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name subWeeks
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * const result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subYears;
	var _index = _interopRequireDefault(__webpack_require__(25));
	var _index2 = _interopRequireDefault(__webpack_require__(321));
	var _index3 = _interopRequireDefault(__webpack_require__(14));
	/**
	 * @name subYears
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * const result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(475);
	var isArguments = __webpack_require__(1053);
	var is = __webpack_require__(1085);
	var isRegex = __webpack_require__(1055);
	var flags = __webpack_require__(1271);
	var isDate = __webpack_require__(1054);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ },
/* 1037 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var vendorPrefix;
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};
	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }
	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }
	  return vendorPrefix;
	}
	function getTransitionName() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
	}
	function getTransformName() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
	}
	function setTransitionProperty(node, value) {
	  var name = getTransitionName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}
	function setTransform(node, value) {
	  var name = getTransformName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}
	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName()];
	}
	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return {
	      x: parseFloat(matrix[12] || matrix[4], 0),
	      y: parseFloat(matrix[13] || matrix[5], 0)
	    };
	  }
	  return {
	    x: 0,
	    y: 0
	  };
	}
	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;
	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var arr;
	    var match2d = transform.match(matrix2d);
	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, "matrix(".concat(arr.join(','), ")"));
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
	    }
	  } else {
	    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
	  }
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, _typeof(obj);
	}
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	var getComputedStyleX;
	
	// https://stackoverflow.com/a/3485654/3040605
	function forceRelayout(elem) {
	  var originalStyle = elem.style.display;
	  elem.style.display = 'none';
	  elem.offsetHeight; // eslint-disable-line
	  elem.style.display = originalStyle;
	}
	function css(el, name, v) {
	  var value = v;
	  if (_typeof(name) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = "".concat(value, "px");
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	function getClientPosition(elem) {
	  var box;
	  var x;
	  var y;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = Math.floor(box.left);
	  y = Math.floor(box.top);
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	  return {
	    left: x,
	    top: y
	  };
	}
	function getScroll(w, top) {
	  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
	  var method = "scroll".concat(top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	function getDocument(node) {
	  if (isWindow(node)) {
	    return node.document;
	  }
	  if (node.nodeType === 9) {
	    return node;
	  }
	  return node.ownerDocument;
	}
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = getDocument(elem);
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	  return val;
	}
	var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	  return option.useCssBottom ? 'bottom' : dir;
	}
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	}
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	  var originalTransition = '';
	  var originalOffset = getOffset(elem);
	  if ('left' in offset || 'top' in offset) {
	    originalTransition = getTransitionProperty(elem) || '';
	    setTransitionProperty(elem, 'none');
	  }
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = "".concat(presetH, "px");
	  }
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = "".concat(presetV, "px");
	  }
	  // force relayout
	  forceRelayout(elem);
	  var old = getOffset(elem);
	  var originalStyle = {};
	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];
	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }
	  css(elem, originalStyle);
	  // force relayout
	  forceRelayout(elem);
	  if ('left' in offset || 'top' in offset) {
	    setTransitionProperty(elem, originalTransition);
	  }
	  var ret = {};
	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);
	      var _off = offset[_key] - originalOffset[_key];
	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }
	  css(elem, ret);
	}
	function setTransform$1(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = getTransformXY(elem);
	  var resultXY = {
	    x: originalXY.x,
	    y: originalXY.y
	  };
	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }
	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }
	  setTransformXY(elem, resultXY);
	}
	function setOffset(elem, offset, option) {
	  if (option.ignoreShake) {
	    var oriOffset = getOffset(elem);
	    var oLeft = oriOffset.left.toFixed(0);
	    var oTop = oriOffset.top.toFixed(0);
	    var tLeft = offset.left.toFixed(0);
	    var tTop = offset.top.toFixed(0);
	    if (oLeft === tLeft && oTop === tTop) {
	      return;
	    }
	  }
	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && getTransformName() in document.body.style) {
	    setTransform$1(elem, offset);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop;
	  var j;
	  var i;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;
	        if (prop === 'border') {
	          cssProp = "".concat(prop).concat(which[i], "Width");
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	var domUtils = {
	  getParent: function getParent(element) {
	    var parent = element;
	    do {
	      if (parent.nodeType === 11 && parent.host) {
	        parent = parent.host;
	      } else {
	        parent = parent.parentNode;
	      }
	    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
	    return parent;
	  }
	};
	each(['Width', 'Height'], function (name) {
	  domUtils["doc".concat(name)] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement["scroll".concat(name)],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
	  };
	  domUtils["viewport".concat(name)] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = "client".concat(name);
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, ex) {
	  var extra = ex;
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
	  var isBorderBox = isBorderBoxFn(elem);
	  var cssBoxValue = 0;
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which);
	    }
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
	}
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	  var val;
	  var elem = args[0];
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils["outer".concat(first)] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  domUtils[name] = function (elem, v) {
	    var val = v;
	    if (val !== undefined) {
	      if (elem) {
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	  return to;
	}
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  getDocument: getDocument,
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i;
	    var ret = {};
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	    for (var i = 0; i < arguments.length; i++) {
	      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
	    }
	    return ret;
	  },
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	mix(utils, domUtils);
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	var getParent = utils.getParent;
	function getOffsetParent(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return null;
	  }
	  // ie 这个也不是完全可行
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent;
	  var positionStyle = utils.css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
	  }
	  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
	    positionStyle = utils.css(parent, 'position');
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	  return null;
	}
	
	var getParent$1 = utils.getParent;
	function isAncestorFixed(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return false;
	  }
	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent = null;
	  for (parent = getParent$1(element);
	  // 修复元素位于 document.documentElement 下导致崩溃问题
	  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
	    var positionStyle = utils.css(parent, 'position');
	    if (positionStyle === 'fixed') {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * 获得元素的显示部分的区域
	 */
	function getVisibleRectForElement(element, alwaysByViewport) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = getOffsetParent(element);
	  var doc = utils.getDocument(element);
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement;
	
	  // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
	    // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
	      var pos = utils.offset(el);
	      // add border
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right,
	      // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	    el = getOffsetParent(el);
	  }
	
	  // Set element position to fixed
	  // make sure absolute element itself don't affect it's visible area
	  // https://github.com/ant-design/ant-design/issues/7601
	  var originalPosition = null;
	  if (!utils.isWindow(element) && element.nodeType !== 9) {
	    originalPosition = element.style.position;
	    var position = utils.css(element, 'position');
	    if (position === 'absolute') {
	      element.style.position = 'fixed';
	    }
	  }
	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);
	  var documentWidth = documentElement.scrollWidth;
	  var documentHeight = documentElement.scrollHeight;
	
	  // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
	  // We should cut this ourself.
	  var bodyStyle = window.getComputedStyle(body);
	  if (bodyStyle.overflowX === 'hidden') {
	    documentWidth = win.innerWidth;
	  }
	  if (bodyStyle.overflowY === 'hidden') {
	    documentHeight = win.innerHeight;
	  }
	
	  // Reset element position after calculate the visible area
	  if (element.style) {
	    element.style.position = originalPosition;
	  }
	  if (alwaysByViewport || isAncestorFixed(element)) {
	    // Clip by viewport's size.
	    visibleRect.left = Math.max(visibleRect.left, scrollX);
	    visibleRect.top = Math.max(visibleRect.top, scrollY);
	    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
	    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
	  } else {
	    // Clip by document's size.
	    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
	    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
	    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
	    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
	  }
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = utils.clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  }
	
	  // Left edge inside and right edge outside viewport, try to resize it.
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  }
	
	  // Right edge outside viewport, try to move it.
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  }
	
	  // Top edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  }
	
	  // Top edge inside and bottom edge outside viewport, try to resize it.
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  }
	
	  // Bottom edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	  return utils.mix(pos, size);
	}
	
	function getRegion(node) {
	  var offset;
	  var w;
	  var h;
	  if (!utils.isWindow(node) && node.nodeType !== 9) {
	    offset = utils.offset(node);
	    w = utils.outerWidth(node);
	    h = utils.outerHeight(node);
	  } else {
	    var win = utils.getWindow(node);
	    offset = {
	      left: utils.getWindowScrollLeft(win),
	      top: utils.getWindowScrollTop(win)
	    };
	    w = utils.viewportWidth(win);
	    h = utils.viewportHeight(win);
	  }
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	  var x = region.left;
	  var y = region.top;
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var p1 = getAlignOffset(refNodeRegion, points[1]);
	  var p2 = getAlignOffset(elRegion, points[0]);
	  var diff = [p2.left - p1.left, p2.top - p1.top];
	  return {
	    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
	    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
	  };
	}
	
	/**
	 * align dom node flexibly
	 * @author yiminghe@gmail.com
	 */
	
	// http://yiminghe.iteye.com/blog/1124720
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	}
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	function flip(points, reg, map) {
	  var ret = [];
	  utils.each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	function convertOffset(str, offsetLen) {
	  var n;
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	  return n || 0;
	}
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	
	/**
	 * @param el
	 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
	 * @param align
	 */
	function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	  var fail = 0;
	  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
	  // 当前节点可以被放置的显示区域
	  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
	  // 当前节点所占的区域, left/top/width/height
	  var elRegion = getRegion(source);
	  // 将 offset 转换成数值，支持百分比
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, tgtRegion);
	  // 当前节点将要被放置的位置
	  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
	  // 当前节点将要所处的区域
	  var newElRegion = utils.merge(elRegion, elFuturePos);
	
	  // 如果可视区域不能完全放置当前节点时允许调整
	  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        });
	        // 偏移量也反下
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        });
	        // 偏移量也反下
	        var _newOffset = flipOffset(offset, 1);
	        var _newTargetOffset = flipOffset(targetOffset, 1);
	        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    }
	
	    // 如果失败，重新计算当前节点将要被放置的位置
	    if (fail) {
	      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
	      utils.mix(newElRegion, elFuturePos);
	    }
	    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
	    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
	    // 检查反下后的位置是否可以放下了，如果仍然放不下：
	    // 1. 复原修改过的定位参数
	    if (isStillFailX || isStillFailY) {
	      var _newPoints2 = points;
	
	      // 重置对应部分的翻转逻辑
	      if (isStillFailX) {
	        _newPoints2 = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        });
	      }
	      if (isStillFailY) {
	        _newPoints2 = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        });
	      }
	      points = _newPoints2;
	      offset = align.offset || [0, 0];
	      targetOffset = align.targetOffset || [0, 0];
	    }
	    // 2. 只有指定了可以调整当前方向才调整
	    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
	    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
	
	    // 确实要调整，甚至可能会调整高度宽度
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  }
	
	  // need judge to in case set fixed with in css on height auto element
	  if (newElRegion.width !== elRegion.width) {
	    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
	  }
	  if (newElRegion.height !== elRegion.height) {
	    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
	  }
	
	  // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	  utils.offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform,
	    ignoreShake: align.ignoreShake
	  });
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	
	function isOutOfVisibleRect(target, alwaysByViewport) {
	  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
	  var targetRegion = getRegion(target);
	  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
	}
	function alignElement(el, refNode, align) {
	  var target = align.target || refNode;
	  var refNodeRegion = getRegion(target);
	  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
	  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
	}
	alignElement.__getOffsetParent = getOffsetParent;
	alignElement.__getVisibleRectForElement = getVisibleRectForElement;
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	    enumerableOnly && (symbols = symbols.filter(function (sym) {
	      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	    })), keys.push.apply(keys, symbols);
	  }
	  return keys;
	}
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = null != arguments[i] ? arguments[i] : {};
	    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
	      _defineProperty(target, key, source[key]);
	    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
	      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	    });
	  }
	  return target;
	}
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}
	
	/**
	 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
	 * If client position provided, will internal convert to page position.
	 */
	
	function alignPoint(el, tgtPoint, align) {
	  var pageX;
	  var pageY;
	  var doc = utils.getDocument(el);
	  var win = doc.defaultView || doc.parentWindow;
	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);
	  if ('pageX' in tgtPoint) {
	    pageX = tgtPoint.pageX;
	  } else {
	    pageX = scrollX + tgtPoint.clientX;
	  }
	  if ('pageY' in tgtPoint) {
	    pageY = tgtPoint.pageY;
	  } else {
	    pageY = scrollY + tgtPoint.clientY;
	  }
	  var tgtRegion = {
	    left: pageX,
	    top: pageY,
	    width: 0,
	    height: 0
	  };
	  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
	
	  // Provide default target point
	  var points = [align.points[0], 'cc'];
	  return doAlign(el, tgtRegion, _objectSpread(_objectSpread({}, align), {}, {
	    points: points
	  }), pointInView);
	}
	
	exports.alignElement = alignElement;
	exports.alignPoint = alignPoint;
	exports.default = alignElement;
	//# sourceMappingURL=index.js.map


/***/ },
/* 1038 */
330,
/* 1039 */
330,
/* 1040 */
/***/ function(module, exports) {

	'use strict';
	
	// do not edit .js files directly - edit src/index.jst
	
	
	
	module.exports = function equal(a, b) {
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    if (a.constructor !== b.constructor) return false;
	
	    var length, i, keys;
	    if (Array.isArray(a)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	
	
	    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
	    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
	    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
	
	    keys = Object.keys(a);
	    length = keys.length;
	    if (length !== Object.keys(b).length) return false;
	
	    for (i = length; i-- !== 0;)
	      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
	
	    for (i = length; i-- !== 0;) {
	      var key = keys[i];
	
	      if (!equal(a[key], b[key])) return false;
	    }
	
	    return true;
	  }
	
	  // true if both NaN, false otherwise
	  return a!==a && b!==b;
	};


/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 1042 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 1043 */
/***/ function(module, exports) {

	'use strict';
	
	var functionsHaveNames = function functionsHaveNames() {
		return typeof function f() {}.name === 'string';
	};
	
	var gOPD = Object.getOwnPropertyDescriptor;
	if (gOPD) {
		try {
			gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			gOPD = null;
		}
	}
	
	functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
		if (!functionsHaveNames() || !gOPD) {
			return false;
		}
		var desc = gOPD(function () {}, 'name');
		return !!desc && !!desc.configurable;
	};
	
	var $bind = Function.prototype.bind;
	
	functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
		return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
	};
	
	module.exports = functionsHaveNames;


/***/ },
/* 1044 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1045 */
/***/ function(module, exports) {

	'use strict';
	
	var test = {
		foo: {}
	};
	
	var $Object = Object;
	
	module.exports = function hasProto() {
		return { __proto__: test }.foo === test.foo && !({ __proto__: null } instanceof $Object);
	};


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(333);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = __webpack_require__(178);
	
	/** @type {(o: {}, p: PropertyKey) => p is keyof o} */
	module.exports = bind.call(call, $hasOwn);


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(189);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	var ics = __webpack_require__(1050);
	
	module.exports = ics;

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var path = __webpack_require__(1089);
	var fs = __webpack_require__(1083);
	
	var _ = __webpack_require__(1051);
	var moment = __webpack_require__(1080);
	var uuid = __webpack_require__(1289);
	
	var DEFAULTS = {
	  filename: 'event'
	};
	
	function ICS(options) {
	  this.options = _.merge({}, DEFAULTS, options);
	}
	
	function buildEvent(attributes) {
	  if (!attributes || _.isEmpty(attributes)) {
	    return buildDefaultEvent();
	  } else {  
	    return _.compact([
	      'BEGIN:VCALENDAR',
	      'VERSION:2.0',
	      'CALSCALE:GREGORIAN',
	      'PRODID:-//Adam Gibbons//agibbons.com//ICS: iCalendar Generator'
	    ]
	    .concat(defineTimeZone(attributes))
	    .concat([
	      'BEGIN:VEVENT',
	      generateUID(attributes.uid),
	      'DTSTAMP:' + generateDateTimeStamp(),
	      formatDTSTART(attributes.start, attributes.timeZone),
	      formatDTEND(attributes.start, attributes.end, attributes.timeZone, attributes.timeZoneEnd),
	      formatProperty('SUMMARY', attributes.title),
	      formatProperty('DESCRIPTION', attributes.description),
	      formatProperty('LOCATION', attributes.location),
	      formatProperty('URL', attributes.url),
	      formatStatus(attributes.status),
	      formatGeo(attributes.geo)
	    ])
	    .concat(formatAttendees(attributes))
	    .concat(formatOrganizer(attributes))
	    .concat(formatCategories(attributes))
	    .concat(formatAttachments(attributes))
	    .concat(formatAlarms(attributes))
	    .concat(['END:VEVENT', 'END:VCALENDAR'])).join('\r\n');
	  }
	
	  function buildDefaultEvent() {
	    var file = [
	      'BEGIN:VCALENDAR',
	      'VERSION:2.0',
	      'CALSCALE:GREGORIAN',
	      'PRODID:-//Adam Gibbons//agibbons.com//ICS: iCalendar Generator',
	      'BEGIN:VEVENT',
	      generateUID(),
	      'DTSTAMP:' + generateDateTimeStamp(),
	      'END:VEVENT',
	      'END:VCALENDAR'
	    ].join('\r\n');
	
	    return file;
	  }
	
	  function generateUID(uid) {
	    if(uid) {
	      return 'UID:' + uid;
	    }
	    return 'UID:' + uuid.v1();
	  }
	
	  function setFileExtension(dest) {
	    return dest.slice(-4) === '.ics' ? dest : dest.concat('.ics');
	  }
	
	  // Follow ISO 8601 string rules:
	  // If `start` contains an uppercase T or a space,
	  // it's a date-time; otherwise, it's just a date.
	  function formatDTSTART(string, tz) {
	    
	    if (!string) {
	      return 'DTSTART:' + moment().format('YYYYMMDD');
	    }
	
	    if (tz) {
	      // Form #3: DATE WITH LOCAL TIME AND TIME ZONE REFERENCE
	      return 'DTSTART;TZID=' + tz + ':' + moment(string).format('YYYYMMDDTHHmm00');
	    }
	
	    if (isDateTime(string) && moment.parseZone(string).utcOffset() === 0 && !isUTC(string)) {
	      // Form #1: DATE WITH LOCAL TIME
	      return 'DTSTART:' + moment(string).format('YYYYMMDDTHHmm00');
	    }
	
	    if (isDateTime(string)) {
	      // Form #2: DATE WITH UTC TIME
	      return 'DTSTART:' + moment.utc(string).format('YYYYMMDDTHHmm00') + 'Z';
	    }
	
	    return 'DTSTART;VALUE=DATE:' + moment(string).format('YYYYMMDD');
	  }
	
	  function formatDTEND(startString, endString, tz, tzEnd) {
	
	    if (!startString) {
	      return 'DTEND:' + moment().add(1, 'days').format('YYYYMMDD');
	    }
	
	    if (tz && !tzEnd && !endString) {
	      return 'DTEND;TZID=' + tz + ':' + moment(startString).format('YYYYMMDDTHHmm00');
	    }
	
	    if (tz && !tzEnd && endString) {
	      return 'DTEND;TZID=' + tz + ':' + moment(endString).format('YYYYMMDDTHHmm00');
	    }
	
	    if (tz && tzEnd && endString) {
	      return 'DTEND;TZID=' + tzEnd + ':' + moment(endString).format('YYYYMMDDTHHmm00');
	    }
	
	    if (endString && !isDateTime(startString)) {
	      return 'DTEND;VALUE=DATE:' + moment(endString).format('YYYYMMDD');
	    }
	
	    if (endString && isDateTime(startString)) {
	      return 'DTEND:' + moment(endString).format('YYYYMMDDTHHmm00');
	    }
	
	    if (!endString && !isDateTime(startString)) {
	      return 'DTEND;VALUE=DATE:' + moment(startString).add(1, 'days').format('YYYYMMDD');
	    }
	
	    if (!endString && isDateTime(startString) && moment.parseZone(startString).utcOffset() === 0) {
	      return 'DTEND:' + moment(startString).format('YYYYMMDDTHHmm00');
	    }
	  }
	
	  function isDateTime(string) {
	    return ['T', ' '].some(function (char) {
	      return string.search(char) !== -1;
	    });
	  }
	
	  function isUTC(string) {
	    return string[string.length - 1] === 'Z';
	  }
	
	  function generateDateTimeStamp() {
	    return moment().utc().format('YYYYMMDDTHHmmss') + 'Z';
	  }
	
	  function formatProperty(key, value) {
	    if (value) {
	      return key + ':' + value;
	    }
	
	    return null;
	  }
	
	  function formatAlarms(attributes) {
	    if (attributes.alarms) {
	      return attributes.alarms.map(function (alarmObj) {
	        var alarmData = ['BEGIN:VALARM']
	          .concat(formatProperty('ACTION', alarmObj.action || 'DISPLAY'))
	          .concat(formatProperty('TRIGGER', alarmObj.trigger || '-PT1H'));
	
	        if (alarmObj.description) {
	          alarmData = alarmData.concat(formatProperty('DESCRIPTION', alarmObj.description));
	        }
	
	        if (alarmObj.summary) {
	          alarmData = alarmData.concat(formatProperty('SUMMARY', alarmObj.summary));
	        }
	
	        if (alarmObj.attach) {
	          alarmData = alarmData.concat(formatProperty('ATTACH', alarmObj.attach));
	        }
	
	        if (alarmObj.repeat && alarmObj.duration) {
	          alarmData = alarmData.concat(formatProperty('REPEAT', alarmObj.repeat ? 1 : 0))
	            .concat(formatProperty('DURATION', alarmObj.duration));
	        }
	
	        return alarmData.concat('END:VALARM').join('\r\n');
	      });
	    }
	    return null;
	  }
	
	  function formatAttachments(attributes) {
	    if (attributes.attachments) {
	      return attributes.attachments.map(function (path) {
	        return 'ATTACH:' + path;
	      });
	    }
	    return null;
	  }
	
	  function formatAttendees(attributes) {
	    if (attributes.attendees) {
	      return attributes.attendees.map(function (attendee) {
	        if (attendee.name && attendee.email) {
	          return 'ATTENDEE;CN=' + attendee.name + ':mailto:' + attendee.email;
	        }
	        return null;
	      });
	    }
	
	    return null;
	  }
	  
	  function formatOrganizer(attributes) {
	    if (attributes.organizer) {
	      if (attributes.organizer.name && attributes.organizer.email) {
	        return 'ORGANIZER;CN=' + attributes.organizer.name + ':mailto:' + attributes.organizer.email;
	      }
	      return null;
	    }
	
	    return null;
	  }
	
	  function formatCategories(attributes) {
	    if (attributes.categories) {
	      return 'CATEGORIES:' + attributes.categories.join(',');
	    }
	    
	    return null;
	  }
	
	  function formatGeo(geo) {
	    if (geo && geo.lat && geo.lon) {
	      return 'GEO:' + parseFloat(geo.lat) + ';' + parseFloat(geo.lon);
	    }
	
	    return null;
	  }
	
	  function formatStatus(status) {
	    if (status && ['TENTATIVE', 'CONFIRMED', 'CANCELLED'].indexOf(status.toUpperCase()) !== -1) {
	      return 'STATUS:' + status;
	    }
	
	    return null;
	  }
	
	  function defineTimeZone(attributes) {
	    // probs make this a switch statement...
	    switch (attributes.timeZone) {
	      case 'America/New_York':
	        return [
	          'BEGIN:VTIMEZONE',
	          'TZID:America/New_York',
	          'BEGIN:STANDARD',
	          'DTSTART:20071104T020000',
	          'RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU',
	          'TZOFFSETFROM:-0400',
	          'TZOFFSETTO:-0500',
	          'TZNAME:EST',
	          'END:STANDARD',
	          'BEGIN:DAYLIGHT',
	          'DTSTART:20070311T020000',
	          'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU',
	          'TZOFFSETFROM:-0500',
	          'TZOFFSETTO:-0400',
	          'TZNAME:EDT',
	          'END:DAYLIGHT',
	          'END:VTIMEZONE'
	        ];
	        break;
	      // case 'Ameria/Chicago':
	      default:
	        return null;
	    }
	  }
	}
	
	ICS.prototype.buildEvent = function(attributes) {
	  return buildEvent(attributes);
	};
	
	ICS.prototype.getDestination = function(_filepath_) {
	  var filepath = _filepath_ || this.options.filename + '.ics';
	  var fileObj = path.parse(filepath);
	  var result = path.resolve(process.cwd(), fileObj.dir, fileObj.name + '.ics');
	
	  return result;
	};
	
	ICS.prototype.createEvent = function(attributes, _options_, cb) {
	  var options = arguments.length === 3 ? _.merge(this.options, _options_) : this.options
	  ,   file = this.buildEvent(attributes)
	  ,   destination = this.getDestination(options.filepath)
	  ,   cb = arguments.length === 3 ? cb : _options_;
	
	  fs.writeFile(destination, file, function (err, data) {
	    if (err) return cb(err);
	    return cb(null, file);
	  });
	};
	
	module.exports = ICS;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(69)(module)))

/***/ },
/* 1052 */
/***/ function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasToStringTag = __webpack_require__(179)();
	var callBound = __webpack_require__(167);
	
	var $toString = callBound('Object.prototype.toString');
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return $toString(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			$toString(value) !== '[object Array]' &&
			$toString(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = __webpack_require__(179)();
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(167);
	var hasToStringTag = __webpack_require__(179)();
	var has;
	var $exec;
	var isRegexMarker;
	var badStringifier;
	
	if (hasToStringTag) {
		has = callBound('Object.prototype.hasOwnProperty');
		$exec = callBound('RegExp.prototype.exec');
		isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	}
	
	var $toString = callBound('Object.prototype.toString');
	var gOPD = Object.getOwnPropertyDescriptor;
	var regexClass = '[object RegExp]';
	
	module.exports = hasToStringTag
		// eslint-disable-next-line consistent-return
		? function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			var descriptor = gOPD(value, 'lastIndex');
			var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				$exec(value, badStringifier);
			} catch (e) {
				return e === isRegexMarker;
			}
		}
		: function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return $toString(value) === regexClass;
		};


/***/ },
/* 1056 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	!(function() {
	  function jss(blocks) {
	    var css = [];
	    for (var block in blocks)
	      css.push(createStyleBlock(block, blocks[block]));
	    injectCSS(css);
	  }
	
	  function createStyleBlock(selector, rules) {
	    return selector + ' {\n' + parseRules(rules) + '\n}';
	  }
	
	  function parseRules(rules) {
	    var css = [];
	    for (var rule in rules)
	      css.push('  '+rule+': '+rules[rule]+';');
	    return css.join('\n');
	  }
	
	  function injectCSS(css) {
	    var style = document.getElementById('jss-styles');
	    if (!style) {
	      style = document.createElement('style');
	      style.setAttribute('id', 'jss-styles');
	      var head = document.getElementsByTagName('head')[0];
	      head.insertBefore(style, head.firstChild);
	    }
	    var node = document.createTextNode(css.join('\n\n'));
	    style.appendChild(node);
	  }
	
	  if (true)
	    module.exports = jss;
	  else
	    window.jss = jss;
	
	})();
	


/***/ },
/* 1058 */
/***/ function(module, exports) {

	module.exports = {
		"AED": {
			"code": "AED",
			"symbol": "د.إ.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"AFN": {
			"code": "AFN",
			"symbol": "؋",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"ALL": {
			"code": "ALL",
			"symbol": "Lek",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"AMD": {
			"code": "AMD",
			"symbol": "֏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"ANG": {
			"code": "ANG",
			"symbol": "ƒ",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"AOA": {
			"code": "AOA",
			"symbol": "Kz",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"ARS": {
			"code": "ARS",
			"symbol": "$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"AUD": {
			"code": "AUD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"AWG": {
			"code": "AWG",
			"symbol": "ƒ",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"AZN": {
			"code": "AZN",
			"symbol": "₼",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BAM": {
			"code": "BAM",
			"symbol": "КМ",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BBD": {
			"code": "BBD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BDT": {
			"code": "BDT",
			"symbol": "৳",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 0
		},
		"BGN": {
			"code": "BGN",
			"symbol": "лв.",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BHD": {
			"code": "BHD",
			"symbol": "د.ب.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"BIF": {
			"code": "BIF",
			"symbol": "FBu",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"BMD": {
			"code": "BMD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BND": {
			"code": "BND",
			"symbol": "$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"BOB": {
			"code": "BOB",
			"symbol": "Bs",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BRL": {
			"code": "BRL",
			"symbol": "R$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BSD": {
			"code": "BSD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BTC": {
			"code": "BTC",
			"symbol": "Ƀ",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BTN": {
			"code": "BTN",
			"symbol": "Nu.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 1
		},
		"BWP": {
			"code": "BWP",
			"symbol": "P",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BYR": {
			"code": "BYR",
			"symbol": "р.",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BZD": {
			"code": "BZD",
			"symbol": "BZ$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CAD": {
			"code": "CAD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CDF": {
			"code": "CDF",
			"symbol": "FC",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CHF": {
			"code": "CHF",
			"symbol": "CHF",
			"thousandsSeparator": "'",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"CLP": {
			"code": "CLP",
			"symbol": "$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"CNY": {
			"code": "CNY",
			"symbol": "¥",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"COP": {
			"code": "COP",
			"symbol": "$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"CRC": {
			"code": "CRC",
			"symbol": "₡",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CUC": {
			"code": "CUC",
			"symbol": "CUC",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CUP": {
			"code": "CUP",
			"symbol": "$MN",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CVE": {
			"code": "CVE",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CZK": {
			"code": "CZK",
			"symbol": "Kč",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"DJF": {
			"code": "DJF",
			"symbol": "Fdj",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"DKK": {
			"code": "DKK",
			"symbol": "kr.",
			"thousandsSeparator": "",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"DOP": {
			"code": "DOP",
			"symbol": "RD$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"DZD": {
			"code": "DZD",
			"symbol": "د.ج.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"EGP": {
			"code": "EGP",
			"symbol": "ج.م.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"ERN": {
			"code": "ERN",
			"symbol": "Nfk",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"ETB": {
			"code": "ETB",
			"symbol": "ETB",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"EUR": {
			"code": "EUR",
			"symbol": "€",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"FJD": {
			"code": "FJD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"FKP": {
			"code": "FKP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GBP": {
			"code": "GBP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GEL": {
			"code": "GEL",
			"symbol": "Lari",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"GHS": {
			"code": "GHS",
			"symbol": "₵",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GIP": {
			"code": "GIP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GMD": {
			"code": "GMD",
			"symbol": "D",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GNF": {
			"code": "GNF",
			"symbol": "FG",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"GTQ": {
			"code": "GTQ",
			"symbol": "Q",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GYD": {
			"code": "GYD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"HKD": {
			"code": "HKD",
			"symbol": "HK$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"HNL": {
			"code": "HNL",
			"symbol": "L.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"HRK": {
			"code": "HRK",
			"symbol": "kn",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"HTG": {
			"code": "HTG",
			"symbol": "G",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"HUF": {
			"code": "HUF",
			"symbol": "Ft",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"IDR": {
			"code": "IDR",
			"symbol": "Rp",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"ILS": {
			"code": "ILS",
			"symbol": "₪",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"INR": {
			"code": "INR",
			"symbol": "₹",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"IQD": {
			"code": "IQD",
			"symbol": "د.ع.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"IRR": {
			"code": "IRR",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": "/",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"ISK": {
			"code": "ISK",
			"symbol": "kr.",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 0
		},
		"JMD": {
			"code": "JMD",
			"symbol": "J$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"JOD": {
			"code": "JOD",
			"symbol": "د.ا.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"JPY": {
			"code": "JPY",
			"symbol": "¥",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"KES": {
			"code": "KES",
			"symbol": "S",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"KGS": {
			"code": "KGS",
			"symbol": "сом",
			"thousandsSeparator": " ",
			"decimalSeparator": "-",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"KHR": {
			"code": "KHR",
			"symbol": "៛",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"KMF": {
			"code": "KMF",
			"symbol": "CF",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"KPW": {
			"code": "KPW",
			"symbol": "₩",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"KRW": {
			"code": "KRW",
			"symbol": "₩",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"KWD": {
			"code": "KWD",
			"symbol": "د.ك.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"KYD": {
			"code": "KYD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"KZT": {
			"code": "KZT",
			"symbol": "₸",
			"thousandsSeparator": " ",
			"decimalSeparator": "-",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"LAK": {
			"code": "LAK",
			"symbol": "₭",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"LBP": {
			"code": "LBP",
			"symbol": "ل.ل.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"LKR": {
			"code": "LKR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 0
		},
		"LRD": {
			"code": "LRD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"LSL": {
			"code": "LSL",
			"symbol": "M",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"LYD": {
			"code": "LYD",
			"symbol": "د.ل.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 3
		},
		"MAD": {
			"code": "MAD",
			"symbol": "د.م.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"MDL": {
			"code": "MDL",
			"symbol": "lei",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"MGA": {
			"code": "MGA",
			"symbol": "Ar",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"MKD": {
			"code": "MKD",
			"symbol": "ден.",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"MMK": {
			"code": "MMK",
			"symbol": "K",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MNT": {
			"code": "MNT",
			"symbol": "₮",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MOP": {
			"code": "MOP",
			"symbol": "MOP$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MRO": {
			"code": "MRO",
			"symbol": "UM",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MTL": {
			"code": "MTL",
			"symbol": "₤",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MUR": {
			"code": "MUR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MVR": {
			"code": "MVR",
			"symbol": "MVR",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 1
		},
		"MWK": {
			"code": "MWK",
			"symbol": "MK",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MXN": {
			"code": "MXN",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MYR": {
			"code": "MYR",
			"symbol": "RM",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MZN": {
			"code": "MZN",
			"symbol": "MT",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"NAD": {
			"code": "NAD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"NGN": {
			"code": "NGN",
			"symbol": "₦",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"NIO": {
			"code": "NIO",
			"symbol": "C$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"NOK": {
			"code": "NOK",
			"symbol": "kr",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"NPR": {
			"code": "NPR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"NZD": {
			"code": "NZD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"OMR": {
			"code": "OMR",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"PAB": {
			"code": "PAB",
			"symbol": "B/.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"PEN": {
			"code": "PEN",
			"symbol": "S/.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"PGK": {
			"code": "PGK",
			"symbol": "K",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"PHP": {
			"code": "PHP",
			"symbol": "₱",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"PKR": {
			"code": "PKR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"PLN": {
			"code": "PLN",
			"symbol": "zł",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"PYG": {
			"code": "PYG",
			"symbol": "₲",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"QAR": {
			"code": "QAR",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"RON": {
			"code": "RON",
			"symbol": "lei",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"RSD": {
			"code": "RSD",
			"symbol": "Дин.",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"RUB": {
			"code": "RUB",
			"symbol": "₽",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"RWF": {
			"code": "RWF",
			"symbol": "RWF",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"SAR": {
			"code": "SAR",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"SBD": {
			"code": "SBD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SCR": {
			"code": "SCR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SDD": {
			"code": "SDD",
			"symbol": "LSd",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SDG": {
			"code": "SDG",
			"symbol": "£‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SEK": {
			"code": "SEK",
			"symbol": "kr",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"SGD": {
			"code": "SGD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SHP": {
			"code": "SHP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SLL": {
			"code": "SLL",
			"symbol": "Le",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SOS": {
			"code": "SOS",
			"symbol": "S",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SRD": {
			"code": "SRD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"STD": {
			"code": "STD",
			"symbol": "Db",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SVC": {
			"code": "SVC",
			"symbol": "₡",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SYP": {
			"code": "SYP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"SZL": {
			"code": "SZL",
			"symbol": "E",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"THB": {
			"code": "THB",
			"symbol": "฿",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TJS": {
			"code": "TJS",
			"symbol": "TJS",
			"thousandsSeparator": " ",
			"decimalSeparator": ";",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"TMT": {
			"code": "TMT",
			"symbol": "m",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"TND": {
			"code": "TND",
			"symbol": "د.ت.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"TOP": {
			"code": "TOP",
			"symbol": "T$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TRY": {
			"code": "TRY",
			"symbol": "TL",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"TTD": {
			"code": "TTD",
			"symbol": "TT$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TVD": {
			"code": "TVD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TWD": {
			"code": "TWD",
			"symbol": "NT$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TZS": {
			"code": "TZS",
			"symbol": "TSh",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"UAH": {
			"code": "UAH",
			"symbol": "₴",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"UGX": {
			"code": "UGX",
			"symbol": "USh",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"USD": {
			"code": "USD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"UYU": {
			"code": "UYU",
			"symbol": "$U",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"UZS": {
			"code": "UZS",
			"symbol": "сўм",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"VEB": {
			"code": "VEB",
			"symbol": "Bs.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"VEF": {
			"code": "VEF",
			"symbol": "Bs. F.",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"VND": {
			"code": "VND",
			"symbol": "₫",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 1
		},
		"VUV": {
			"code": "VUV",
			"symbol": "VT",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"WST": {
			"code": "WST",
			"symbol": "WS$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"XAF": {
			"code": "XAF",
			"symbol": "F",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"XCD": {
			"code": "XCD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"XOF": {
			"code": "XOF",
			"symbol": "F",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"XPF": {
			"code": "XPF",
			"symbol": "F",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"YER": {
			"code": "YER",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"ZAR": {
			"code": "ZAR",
			"symbol": "R",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"ZMW": {
			"code": "ZMW",
			"symbol": "ZK",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"WON": {
			"code": "WON",
			"symbol": "₩",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		}
	};

/***/ },
/* 1059 */
/***/ function(module, exports) {

	module.exports = {
		"de-AT": {
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"el-GR": {
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"decimalDigits": 2
		},
		"en-IE": {
			"symbolOnLeft": true,
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"es-ES": {
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"it-IT": {
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"decimalDigits": 2
		},
		"nl-NL": {
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"decimalDigits": 2
		},
		"nl-BE": {
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"decimalDigits": 2
		}
	};

/***/ },
/* 1060 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2023c",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5",
			"Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6",
			"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6",
			"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5",
			"Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4",
			"Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
			"Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
			"America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5",
			"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
			"America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
			"America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
			"America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
			"America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
			"America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
			"America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
			"America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
			"America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5",
			"America/Bahia_Banderas|LMT MST CST MDT PST CDT|71 70 60 60 80 50|0121312141313131313131313131313131313152525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3",
			"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3",
			"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5",
			"America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4",
			"America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0|",
			"America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
			"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
			"America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3",
			"America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5",
			"America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST MDT PST|7n.Q 70 60 60 80|0121312141313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|01212134121212121212121212121512121212121212121212125212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|01212134121212121212121212121212156565212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5",
			"America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST MDT PST|75.E 70 60 60 80|0121312141313131313131313131313131313131313131313131313131313131|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4",
			"America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5",
			"America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6",
			"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5",
			"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|012121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0|",
			"America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
			"America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
			"America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5",
			"America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
			"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452",
			"America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
			"America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4",
			"Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40",
			"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
			"Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
			"Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4",
			"Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
			"Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
			"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
			"Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|01212121212121212121212121212121212343434343434343434343434343434312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 e10 2L0 WN0 14n0 gN0 5z0 11B0 WL0 e10 bb0 11B0 TX0 e10 dX0 11B0 On0 gN0 gL0 11B0 Lz0 e10 pb0 WN0 IL0 e10 rX0 WN0 Db0 gN0 uL0 11B0 xz0 e10 An0 11B0 rX0 gN0 Db0 11B0 pb0 e10 Lz0 WN0 mn0 e10 On0 WN0 gL0 gN0 Rb0 11B0 bb0 e10 WL0 11B0 5z0 gN0 11z0 11B0 2L0 gN0 14n0 1fB0 1cL0 1a10 1fz0 14p0 1lb0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 e10 28L0 e10 25X0 gN0 25X0 e10 gL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5",
			"Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 e10 2L0 WN0 14n0 gN0 5z0 11B0 WL0 e10 bb0 11B0 TX0 e10 dX0 11B0 On0 gN0 gL0 11B0 Lz0 e10 pb0 WN0 IL0 e10 rX0 WN0 Db0 gN0 uL0 11B0 xz0 e10 An0 11B0 rX0 gN0 Db0 11B0 pb0 e10 Lz0 WN0 mn0 e10 On0 WN0 gL0 gN0 Rb0 11B0 bb0 e10 WL0 11B0 5z0 gN0 11z0 11B0 2L0 gN0 14n0 1fB0 1cL0 1a10 1fz0 14p0 1lb0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 e10 28L0 e10 25X0 gN0 25X0 e10 gL0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5",
			"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|LMT LMT PST PDT JST|fU -84 -80 -90 -90|01232423232|-54m84 2clc0 1vfc4 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
			"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
			"Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 XA0 Wou JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|LMT HMT -02 -01 +00 WET|1G.E 1S.w 20 10 0 0|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232343434343434343434343434343434345434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30",
			"Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4",
			"Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
			"Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
			"Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"EST|EST|50|0||",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Etc/GMT-0|GMT|0|0||",
			"Etc/GMT-1|+01|-10|0||",
			"Etc/GMT-10|+10|-a0|0||",
			"Etc/GMT-11|+11|-b0|0||",
			"Etc/GMT-12|+12|-c0|0||",
			"Etc/GMT-13|+13|-d0|0||",
			"Etc/GMT-14|+14|-e0|0||",
			"Etc/GMT-2|+02|-20|0||",
			"Etc/GMT-3|+03|-30|0||",
			"Etc/GMT-4|+04|-40|0||",
			"Etc/GMT-5|+05|-50|0||",
			"Etc/GMT-6|+06|-60|0||",
			"Etc/GMT-7|+07|-70|0||",
			"Etc/GMT-8|+08|-80|0||",
			"Etc/GMT-9|+09|-90|0||",
			"Etc/GMT+1|-01|10|0||",
			"Etc/GMT+10|-10|a0|0||",
			"Etc/GMT+11|-11|b0|0||",
			"Etc/GMT+12|-12|c0|0||",
			"Etc/GMT+2|-02|20|0||",
			"Etc/GMT+3|-03|30|0||",
			"Etc/GMT+4|-04|40|0||",
			"Etc/GMT+5|-05|50|0||",
			"Etc/GMT+6|-06|60|0||",
			"Etc/GMT+7|-07|70|0||",
			"Etc/GMT+8|-08|80|0||",
			"Etc/GMT+9|-09|90|0||",
			"Etc/UTC|UTC|0|0||",
			"Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5",
			"Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
			"Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5",
			"Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4",
			"Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6",
			"Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
			"Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5",
			"Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
			"Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5",
			"Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5",
			"HST|HST|a0|0||",
			"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4",
			"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|",
			"MST|MST|70|0||",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600",
			"Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3",
			"Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4",
			"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1",
			"Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483",
			"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4",
			"Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3",
			"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
			"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
			"Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4",
			"Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2",
			"Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
			"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2",
			"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
			"Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2",
			"Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4",
			"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3",
			"Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56",
			"Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|"
		],
		"links": [
			"Africa/Abidjan|Africa/Accra",
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/Reykjavik",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Abidjan|Iceland",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Chicago|US/Central",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|America/Yellowknife",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Godthab|America/Nuuk",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Iqaluit|America/Pangnirtung",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Atikokan",
			"America/Panama|America/Cayman",
			"America/Panama|America/Coral_Harbour",
			"America/Phoenix|America/Creston",
			"America/Phoenix|US/Arizona",
			"America/Puerto_Rico|America/Anguilla",
			"America/Puerto_Rico|America/Antigua",
			"America/Puerto_Rico|America/Aruba",
			"America/Puerto_Rico|America/Blanc-Sablon",
			"America/Puerto_Rico|America/Curacao",
			"America/Puerto_Rico|America/Dominica",
			"America/Puerto_Rico|America/Grenada",
			"America/Puerto_Rico|America/Guadeloupe",
			"America/Puerto_Rico|America/Kralendijk",
			"America/Puerto_Rico|America/Lower_Princes",
			"America/Puerto_Rico|America/Marigot",
			"America/Puerto_Rico|America/Montserrat",
			"America/Puerto_Rico|America/Port_of_Spain",
			"America/Puerto_Rico|America/St_Barthelemy",
			"America/Puerto_Rico|America/St_Kitts",
			"America/Puerto_Rico|America/St_Lucia",
			"America/Puerto_Rico|America/St_Thomas",
			"America/Puerto_Rico|America/St_Vincent",
			"America/Puerto_Rico|America/Tortola",
			"America/Puerto_Rico|America/Virgin",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|America/Nassau",
			"America/Toronto|America/Nipigon",
			"America/Toronto|America/Thunder_Bay",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|America/Rainy_River",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Bangkok|Indian/Christmas",
			"Asia/Brunei|Asia/Kuching",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Dubai|Indian/Mahe",
			"Asia/Dubai|Indian/Reunion",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Kuala_Lumpur|Asia/Singapore",
			"Asia/Kuala_Lumpur|Singapore",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Rangoon|Indian/Cocos",
			"Asia/Riyadh|Antarctica/Syowa",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Antarctica/Vostok",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Currie",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT-0|Etc/GMT",
			"Etc/GMT-0|Etc/GMT+0",
			"Etc/GMT-0|Etc/GMT0",
			"Etc/GMT-0|Etc/Greenwich",
			"Etc/GMT-0|GMT",
			"Etc/GMT-0|GMT+0",
			"Etc/GMT-0|GMT-0",
			"Etc/GMT-0|GMT0",
			"Etc/GMT-0|Greenwich",
			"Etc/UTC|Etc/UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UCT",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Berlin|Arctic/Longyearbyen",
			"Europe/Berlin|Atlantic/Jan_Mayen",
			"Europe/Berlin|Europe/Copenhagen",
			"Europe/Berlin|Europe/Oslo",
			"Europe/Berlin|Europe/Stockholm",
			"Europe/Brussels|Europe/Amsterdam",
			"Europe/Brussels|Europe/Luxembourg",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Kiev|Europe/Kyiv",
			"Europe/Kiev|Europe/Uzhgorod",
			"Europe/Kiev|Europe/Zaporozhye",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Paris|Europe/Monaco",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Indian/Maldives|Indian/Kerguelen",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Enderbury|Pacific/Kanton",
			"Pacific/Guadalcanal|Pacific/Pohnpei",
			"Pacific/Guadalcanal|Pacific/Ponape",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Port_Moresby|Antarctica/DumontDUrville",
			"Pacific/Port_Moresby|Pacific/Chuuk",
			"Pacific/Port_Moresby|Pacific/Truk",
			"Pacific/Port_Moresby|Pacific/Yap",
			"Pacific/Tarawa|Pacific/Funafuti",
			"Pacific/Tarawa|Pacific/Majuro",
			"Pacific/Tarawa|Pacific/Wake",
			"Pacific/Tarawa|Pacific/Wallis"
		],
		"countries": [
			"AD|Europe/Andorra",
			"AE|Asia/Dubai",
			"AF|Asia/Kabul",
			"AG|America/Puerto_Rico America/Antigua",
			"AI|America/Puerto_Rico America/Anguilla",
			"AL|Europe/Tirane",
			"AM|Asia/Yerevan",
			"AO|Africa/Lagos Africa/Luanda",
			"AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Asia/Urumqi Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa Antarctica/Vostok",
			"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
			"AS|Pacific/Pago_Pago",
			"AT|Europe/Vienna",
			"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
			"AW|America/Puerto_Rico America/Aruba",
			"AX|Europe/Helsinki Europe/Mariehamn",
			"AZ|Asia/Baku",
			"BA|Europe/Belgrade Europe/Sarajevo",
			"BB|America/Barbados",
			"BD|Asia/Dhaka",
			"BE|Europe/Brussels",
			"BF|Africa/Abidjan Africa/Ouagadougou",
			"BG|Europe/Sofia",
			"BH|Asia/Qatar Asia/Bahrain",
			"BI|Africa/Maputo Africa/Bujumbura",
			"BJ|Africa/Lagos Africa/Porto-Novo",
			"BL|America/Puerto_Rico America/St_Barthelemy",
			"BM|Atlantic/Bermuda",
			"BN|Asia/Kuching Asia/Brunei",
			"BO|America/La_Paz",
			"BQ|America/Puerto_Rico America/Kralendijk",
			"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
			"BS|America/Toronto America/Nassau",
			"BT|Asia/Thimphu",
			"BW|Africa/Maputo Africa/Gaborone",
			"BY|Europe/Minsk",
			"BZ|America/Belize",
			"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston",
			"CC|Asia/Yangon Indian/Cocos",
			"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
			"CF|Africa/Lagos Africa/Bangui",
			"CG|Africa/Lagos Africa/Brazzaville",
			"CH|Europe/Zurich",
			"CI|Africa/Abidjan",
			"CK|Pacific/Rarotonga",
			"CL|America/Santiago America/Punta_Arenas Pacific/Easter",
			"CM|Africa/Lagos Africa/Douala",
			"CN|Asia/Shanghai Asia/Urumqi",
			"CO|America/Bogota",
			"CR|America/Costa_Rica",
			"CU|America/Havana",
			"CV|Atlantic/Cape_Verde",
			"CW|America/Puerto_Rico America/Curacao",
			"CX|Asia/Bangkok Indian/Christmas",
			"CY|Asia/Nicosia Asia/Famagusta",
			"CZ|Europe/Prague",
			"DE|Europe/Zurich Europe/Berlin Europe/Busingen",
			"DJ|Africa/Nairobi Africa/Djibouti",
			"DK|Europe/Berlin Europe/Copenhagen",
			"DM|America/Puerto_Rico America/Dominica",
			"DO|America/Santo_Domingo",
			"DZ|Africa/Algiers",
			"EC|America/Guayaquil Pacific/Galapagos",
			"EE|Europe/Tallinn",
			"EG|Africa/Cairo",
			"EH|Africa/El_Aaiun",
			"ER|Africa/Nairobi Africa/Asmara",
			"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
			"ET|Africa/Nairobi Africa/Addis_Ababa",
			"FI|Europe/Helsinki",
			"FJ|Pacific/Fiji",
			"FK|Atlantic/Stanley",
			"FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei",
			"FO|Atlantic/Faroe",
			"FR|Europe/Paris",
			"GA|Africa/Lagos Africa/Libreville",
			"GB|Europe/London",
			"GD|America/Puerto_Rico America/Grenada",
			"GE|Asia/Tbilisi",
			"GF|America/Cayenne",
			"GG|Europe/London Europe/Guernsey",
			"GH|Africa/Abidjan Africa/Accra",
			"GI|Europe/Gibraltar",
			"GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
			"GM|Africa/Abidjan Africa/Banjul",
			"GN|Africa/Abidjan Africa/Conakry",
			"GP|America/Puerto_Rico America/Guadeloupe",
			"GQ|Africa/Lagos Africa/Malabo",
			"GR|Europe/Athens",
			"GS|Atlantic/South_Georgia",
			"GT|America/Guatemala",
			"GU|Pacific/Guam",
			"GW|Africa/Bissau",
			"GY|America/Guyana",
			"HK|Asia/Hong_Kong",
			"HN|America/Tegucigalpa",
			"HR|Europe/Belgrade Europe/Zagreb",
			"HT|America/Port-au-Prince",
			"HU|Europe/Budapest",
			"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
			"IE|Europe/Dublin",
			"IL|Asia/Jerusalem",
			"IM|Europe/London Europe/Isle_of_Man",
			"IN|Asia/Kolkata",
			"IO|Indian/Chagos",
			"IQ|Asia/Baghdad",
			"IR|Asia/Tehran",
			"IS|Africa/Abidjan Atlantic/Reykjavik",
			"IT|Europe/Rome",
			"JE|Europe/London Europe/Jersey",
			"JM|America/Jamaica",
			"JO|Asia/Amman",
			"JP|Asia/Tokyo",
			"KE|Africa/Nairobi",
			"KG|Asia/Bishkek",
			"KH|Asia/Bangkok Asia/Phnom_Penh",
			"KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati",
			"KM|Africa/Nairobi Indian/Comoro",
			"KN|America/Puerto_Rico America/St_Kitts",
			"KP|Asia/Pyongyang",
			"KR|Asia/Seoul",
			"KW|Asia/Riyadh Asia/Kuwait",
			"KY|America/Panama America/Cayman",
			"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
			"LA|Asia/Bangkok Asia/Vientiane",
			"LB|Asia/Beirut",
			"LC|America/Puerto_Rico America/St_Lucia",
			"LI|Europe/Zurich Europe/Vaduz",
			"LK|Asia/Colombo",
			"LR|Africa/Monrovia",
			"LS|Africa/Johannesburg Africa/Maseru",
			"LT|Europe/Vilnius",
			"LU|Europe/Brussels Europe/Luxembourg",
			"LV|Europe/Riga",
			"LY|Africa/Tripoli",
			"MA|Africa/Casablanca",
			"MC|Europe/Paris Europe/Monaco",
			"MD|Europe/Chisinau",
			"ME|Europe/Belgrade Europe/Podgorica",
			"MF|America/Puerto_Rico America/Marigot",
			"MG|Africa/Nairobi Indian/Antananarivo",
			"MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro",
			"MK|Europe/Belgrade Europe/Skopje",
			"ML|Africa/Abidjan Africa/Bamako",
			"MM|Asia/Yangon",
			"MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
			"MO|Asia/Macau",
			"MP|Pacific/Guam Pacific/Saipan",
			"MQ|America/Martinique",
			"MR|Africa/Abidjan Africa/Nouakchott",
			"MS|America/Puerto_Rico America/Montserrat",
			"MT|Europe/Malta",
			"MU|Indian/Mauritius",
			"MV|Indian/Maldives",
			"MW|Africa/Maputo Africa/Blantyre",
			"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana",
			"MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur",
			"MZ|Africa/Maputo",
			"NA|Africa/Windhoek",
			"NC|Pacific/Noumea",
			"NE|Africa/Lagos Africa/Niamey",
			"NF|Pacific/Norfolk",
			"NG|Africa/Lagos",
			"NI|America/Managua",
			"NL|Europe/Brussels Europe/Amsterdam",
			"NO|Europe/Berlin Europe/Oslo",
			"NP|Asia/Kathmandu",
			"NR|Pacific/Nauru",
			"NU|Pacific/Niue",
			"NZ|Pacific/Auckland Pacific/Chatham",
			"OM|Asia/Dubai Asia/Muscat",
			"PA|America/Panama",
			"PE|America/Lima",
			"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
			"PG|Pacific/Port_Moresby Pacific/Bougainville",
			"PH|Asia/Manila",
			"PK|Asia/Karachi",
			"PL|Europe/Warsaw",
			"PM|America/Miquelon",
			"PN|Pacific/Pitcairn",
			"PR|America/Puerto_Rico",
			"PS|Asia/Gaza Asia/Hebron",
			"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
			"PW|Pacific/Palau",
			"PY|America/Asuncion",
			"QA|Asia/Qatar",
			"RE|Asia/Dubai Indian/Reunion",
			"RO|Europe/Bucharest",
			"RS|Europe/Belgrade",
			"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
			"RW|Africa/Maputo Africa/Kigali",
			"SA|Asia/Riyadh",
			"SB|Pacific/Guadalcanal",
			"SC|Asia/Dubai Indian/Mahe",
			"SD|Africa/Khartoum",
			"SE|Europe/Berlin Europe/Stockholm",
			"SG|Asia/Singapore",
			"SH|Africa/Abidjan Atlantic/St_Helena",
			"SI|Europe/Belgrade Europe/Ljubljana",
			"SJ|Europe/Berlin Arctic/Longyearbyen",
			"SK|Europe/Prague Europe/Bratislava",
			"SL|Africa/Abidjan Africa/Freetown",
			"SM|Europe/Rome Europe/San_Marino",
			"SN|Africa/Abidjan Africa/Dakar",
			"SO|Africa/Nairobi Africa/Mogadishu",
			"SR|America/Paramaribo",
			"SS|Africa/Juba",
			"ST|Africa/Sao_Tome",
			"SV|America/El_Salvador",
			"SX|America/Puerto_Rico America/Lower_Princes",
			"SY|Asia/Damascus",
			"SZ|Africa/Johannesburg Africa/Mbabane",
			"TC|America/Grand_Turk",
			"TD|Africa/Ndjamena",
			"TF|Asia/Dubai Indian/Maldives Indian/Kerguelen",
			"TG|Africa/Abidjan Africa/Lome",
			"TH|Asia/Bangkok",
			"TJ|Asia/Dushanbe",
			"TK|Pacific/Fakaofo",
			"TL|Asia/Dili",
			"TM|Asia/Ashgabat",
			"TN|Africa/Tunis",
			"TO|Pacific/Tongatapu",
			"TR|Europe/Istanbul",
			"TT|America/Puerto_Rico America/Port_of_Spain",
			"TV|Pacific/Tarawa Pacific/Funafuti",
			"TW|Asia/Taipei",
			"TZ|Africa/Nairobi Africa/Dar_es_Salaam",
			"UA|Europe/Simferopol Europe/Kyiv",
			"UG|Africa/Nairobi Africa/Kampala",
			"UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake",
			"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
			"UY|America/Montevideo",
			"UZ|Asia/Samarkand Asia/Tashkent",
			"VA|Europe/Rome Europe/Vatican",
			"VC|America/Puerto_Rico America/St_Vincent",
			"VE|America/Caracas",
			"VG|America/Puerto_Rico America/Tortola",
			"VI|America/Puerto_Rico America/St_Thomas",
			"VN|Asia/Bangkok Asia/Ho_Chi_Minh",
			"VU|Pacific/Efate",
			"WF|Pacific/Tarawa Pacific/Wallis",
			"WS|Pacific/Apia",
			"YE|Asia/Riyadh Asia/Aden",
			"YT|Africa/Nairobi Indian/Mayotte",
			"ZA|Africa/Johannesburg",
			"ZM|Africa/Maputo Africa/Lusaka",
			"ZW|Africa/Maputo Africa/Harare"
		]
	};

/***/ },
/* 1061 */
/***/ function(module, exports) {

	/**
	 * The code was extracted from:
	 * https://github.com/davidchambers/Base64.js
	 */
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function InvalidCharacterError(message) {
	  this.message = message;
	}
	
	InvalidCharacterError.prototype = new Error();
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	function polyfill (input) {
	  var str = String(input).replace(/=+$/, '');
	  if (str.length % 4 == 1) {
	    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	  }
	  for (
	    // initialize result and counters
	    var bc = 0, bs, buffer, idx = 0, output = '';
	    // get next character
	    buffer = str.charAt(idx++);
	    // character found in table? initialize bit storage and add its ascii value;
	    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	      // and if not first of each 4 characters,
	      // convert the first 8 bits to one ascii character
	      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
	  ) {
	    // try to find character in table (0-63, not found => -1)
	    buffer = chars.indexOf(buffer);
	  }
	  return output;
	}
	
	
	module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	var atob = __webpack_require__(1061);
	
	function b64DecodeUnicode(str) {
	  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
	    var code = p.charCodeAt(0).toString(16).toUpperCase();
	    if (code.length < 2) {
	      code = '0' + code;
	    }
	    return '%' + code;
	  }));
	}
	
	module.exports = function(str) {
	  var output = str.replace(/-/g, "+").replace(/_/g, "/");
	  switch (output.length % 4) {
	    case 0:
	      break;
	    case 2:
	      output += "==";
	      break;
	    case 3:
	      output += "=";
	      break;
	    default:
	      throw "Illegal base64url string!";
	  }
	
	  try{
	    return b64DecodeUnicode(output);
	  } catch (err) {
	    return atob(output);
	  }
	};


/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64_url_decode = __webpack_require__(1062);
	
	function InvalidTokenError(message) {
	  this.message = message;
	}
	
	InvalidTokenError.prototype = new Error();
	InvalidTokenError.prototype.name = 'InvalidTokenError';
	
	module.exports = function (token,options) {
	  if (typeof token !== 'string') {
	    throw new InvalidTokenError('Invalid token specified');
	  }
	
	  options = options || {};
	  var pos = options.header === true ? 0 : 1;
	  try {
	    return JSON.parse(base64_url_decode(token.split('.')[pos]));
	  } catch (e) {
	    throw new InvalidTokenError('Invalid token specified: ' + e.message);
	  }
	};
	
	module.exports.InvalidTokenError = InvalidTokenError;


/***/ },
/* 1064 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var _typeof2="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};function createCustomError(e){function n(e,n){Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor),this.message=e,this.code=n}return n.prototype=new Error,n.prototype.name=e,n.prototype.constructor=n,n}var LDUnexpectedResponseError=createCustomError("LaunchDarklyUnexpectedResponseError"),LDInvalidEnvironmentIdError=createCustomError("LaunchDarklyInvalidEnvironmentIdError"),LDInvalidUserError=createCustomError("LaunchDarklyInvalidUserError"),LDInvalidEventKeyError=createCustomError("LaunchDarklyInvalidEventKeyError"),LDInvalidArgumentError=createCustomError("LaunchDarklyInvalidArgumentError"),LDFlagFetchError=createCustomError("LaunchDarklyFlagFetchError");function isHttpErrorRecoverable(e){return!(e>=400&&e<500)||400===e||408===e||429===e}for(var errors=Object.freeze({LDUnexpectedResponseError:LDUnexpectedResponseError,LDInvalidEnvironmentIdError:LDInvalidEnvironmentIdError,LDInvalidUserError:LDInvalidUserError,LDInvalidEventKeyError:LDInvalidEventKeyError,LDInvalidArgumentError:LDInvalidArgumentError,LDFlagFetchError:LDFlagFetchError,isHttpErrorRecoverable:isHttpErrorRecoverable}),fromByteArray_1=fromByteArray,lookup=[],revLookup=[],code="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=0,len=code.length;i<len;++i)lookup[i]=code[i],revLookup[code.charCodeAt(i)]=i;function tripletToBase64(e){return lookup[e>>18&63]+lookup[e>>12&63]+lookup[e>>6&63]+lookup[63&e]}function encodeChunk(e,n,t){for(var r,o=[],i=n;i<t;i+=3)r=(e[i]<<16&16711680)+(e[i+1]<<8&65280)+(255&e[i+2]),o.push(tripletToBase64(r));return o.join("")}function fromByteArray(e){for(var n,t=e.length,r=t%3,o=[],i=0,a=t-r;i<a;i+=16383)o.push(encodeChunk(e,i,i+16383>a?a:i+16383));return 1===r?(n=e[t-1],o.push(lookup[n>>2]+lookup[n<<4&63]+"==")):2===r&&(n=(e[t-2]<<8)+e[t-1],o.push(lookup[n>>10]+lookup[n>>4&63]+lookup[n<<2&63]+"=")),o.join("")}revLookup["-".charCodeAt(0)]=62,revLookup["_".charCodeAt(0)]=63;var _typeof="function"==typeof Symbol&&"symbol"==_typeof2(Symbol.iterator)?function(e){return void 0===e?"undefined":_typeof2(e)}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":void 0===e?"undefined":_typeof2(e)},isArray=Array.isArray,keyList=Object.keys,hasProp=Object.prototype.hasOwnProperty,fastDeepEqual=function e(n,t){if(n===t)return!0;if(n&&t&&"object"==(void 0===n?"undefined":_typeof(n))&&"object"==(void 0===t?"undefined":_typeof(t))){var r,o,i,a=isArray(n),u=isArray(t);if(a&&u){if((o=n.length)!=t.length)return!1;for(r=o;0!=r--;)if(!e(n[r],t[r]))return!1;return!0}if(a!=u)return!1;var s=n instanceof Date,c=t instanceof Date;if(s!=c)return!1;if(s&&c)return n.getTime()==t.getTime();var l=n instanceof RegExp,d=t instanceof RegExp;if(l!=d)return!1;if(l&&d)return n.toString()==t.toString();var v=keyList(n);if((o=v.length)!==keyList(t).length)return!1;for(r=o;0!=r--;)if(!hasProp.call(t,v[r]))return!1;for(r=o;0!=r--;)if(!e(n[i=v[r]],t[i]))return!1;return!0}return n!=n&&t!=t},_extends=Object.assign||function(e){for(var n=1;n<arguments.length;n++){var t=arguments[n];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])}return e},userAttrsToStringify=["key","secondary","ip","country","email","firstName","lastName","avatar","name"];function btoa(e){var n=unescape(encodeURIComponent(e));return fromByteArray_1(stringToBytes(n))}function stringToBytes(e){for(var n=[],t=0;t<e.length;t++)n.push(e.charCodeAt(t));return n}function base64URLEncode(e){return btoa(e).replace(/=/g,"").replace(/\+/g,"-").replace(/\//g,"_")}function clone(e){return JSON.parse(JSON.stringify(e))}function deepEquals(e,n){return fastDeepEqual(e,n)}function onNextTick(e){setTimeout(e,0)}function wrapPromiseCallback(e,n){var t=e.then(function(e){return n&&setTimeout(function(){n(null,e)},0),e},function(e){if(!n)return Promise.reject(e);setTimeout(function(){n(e,null)},0)});return n?void 0:t}function transformValuesToVersionedValues(e){var n={};for(var t in e)e.hasOwnProperty(t)&&(n[t]={value:e[t],version:0});return n}function transformVersionedValuesToValues(e){var n={};for(var t in e)e.hasOwnProperty(t)&&(n[t]=e[t].value);return n}function chunkUserEventsForUrl(e,n){for(var t=n.slice(0),r=[],o=e,i=void 0;t.length>0;){for(i=[];o>0;){var a=t.shift();if(!a)break;(o-=base64URLEncode(JSON.stringify(a)).length)<0&&i.length>0?t.unshift(a):i.push(a)}o=e,r.push(i)}return r}function getLDUserAgentString(e){var n=e.version||"2.10.2";return e.userAgent+"/"+n}function getLDHeaders(e){return{"X-LaunchDarkly-User-Agent":getLDUserAgentString(e)}}function extend(){for(var e=arguments.length,n=Array(e),t=0;t<e;t++)n[t]=arguments[t];return n.reduce(function(e,n){return _extends({},e,n)},{})}function sanitizeUser(e){if(!e)return e;var n=void 0;for(var t in userAttrsToStringify){var r=userAttrsToStringify[t],o=e[r];void 0!==o&&"string"!=typeof o&&((n=n||Object.assign({},e))[r]=String(o))}return n||e}var utils=Object.freeze({btoa:btoa,base64URLEncode:base64URLEncode,clone:clone,deepEquals:deepEquals,onNextTick:onNextTick,wrapPromiseCallback:wrapPromiseCallback,transformValuesToVersionedValues:transformValuesToVersionedValues,transformVersionedValuesToValues:transformVersionedValuesToValues,chunkUserEventsForUrl:chunkUserEventsForUrl,getLDUserAgentString:getLDUserAgentString,getLDHeaders:getLDHeaders,extend:extend,sanitizeUser:sanitizeUser}),MAX_URL_LENGTH=2e3;function EventSender(e,n,t,r){var o=n+"/events/bulk/"+t,i=n+"/a/"+t+".gif",a={};function u(e){(new window.Image).src=e}function s(n,t){var a=r||u,s=JSON.stringify(n);return t?function n(t){var r=extend({"Content-Type":"application/json","X-LaunchDarkly-Event-Schema":"3"},getLDHeaders(e));return e.httpRequest("POST",o,r,s).promise.then(function(e){if(e)return e.status>=400&&isHttpErrorRecoverable(e.status)&&t?n(!1):function(e){var n={status:e.status},t=e.header("date");if(t){var r=Date.parse(t);r&&(n.serverTime=r)}return n}(e)}).catch(function(){return t?n(!1):Promise.reject()})}(!0).catch(function(){}):(a(i+"?d="+base64URLEncode(s)),Promise.resolve())}return a.sendEvents=function(t){if(!e.httpRequest)return Promise.resolve();var r,o=e.httpAllowsPost();r=o?[t]:chunkUserEventsForUrl(MAX_URL_LENGTH-n.length,t);for(var i=[],a=0;a<r.length;a++)i.push(s(r[a],o));return Promise.all(i)},a}function EventSummarizer(){var e={},n=0,t=0,r={};return e.summarizeEvent=function(e){if("feature"===e.kind){var o=e.key+":"+(null!==e.variation&&void 0!==e.variation?e.variation:"")+":"+(null!==e.version&&void 0!==e.version?e.version:""),i=r[o];i?i.count=i.count+1:r[o]={count:1,key:e.key,variation:e.variation,version:e.version,value:e.value,default:e.default},(0===n||e.creationDate<n)&&(n=e.creationDate),e.creationDate>t&&(t=e.creationDate)}},e.getSummary=function(){var e={},o=!0;for(var i in r){var a=r[i],u=e[a.key];u||(u={default:a.default,counters:[]},e[a.key]=u);var s={value:a.value,count:a.count};void 0!==a.variation&&null!==a.variation&&(s.variation=a.variation),a.version?s.version=a.version:s.unknown=!0,u.counters.push(s),o=!1}return o?null:{startDate:n,endDate:t,features:e}},e.clearSummary=function(){n=0,t=0,r={}},e}function UserFilter(e){var n={},t=e.allAttributesPrivate,r=e.privateAttributeNames||[],o={key:!0,custom:!0,anonymous:!0},i={key:!0,secondary:!0,ip:!0,country:!0,email:!0,firstName:!0,lastName:!0,avatar:!0,name:!0,anonymous:!0,custom:!0};return n.filterUser=function(e){if(!e)return null;var n=e.privateAttributeNames||[],a=function(e,i){return Object.keys(e).reduce(function(a,u){var s=a;return i(u)&&(function(e){return!o[e]&&(t||-1!==n.indexOf(e)||-1!==r.indexOf(e))}(u)?s[1][u]=!0:s[0][u]=e[u]),s},[{},{}])},u=a(e,function(e){return i[e]}),s=u[0],c=u[1];if(e.custom){var l=a(e.custom,function(){return!0});s.custom=l[0],c=extend({},c,l[1])}var d=Object.keys(c);return d.length&&(d.sort(),s.privateAttrs=d),s},n}var clientInitialized=function(){return"LaunchDarkly client initialized"},docLink=" Please see https://docs.launchdarkly.com/docs/js-sdk-reference#section-initializing-the-client for instructions on SDK initialization.",clientNotReady=function(){return"LaunchDarkly client is not ready"},eventWithoutUser=function(){return"Be sure to call `identify` in the LaunchDarkly client: http://docs.launchdarkly.com/docs/running-an-ab-test#include-the-client-side-snippet"},invalidKey=function(){return"Event key must be a string"},localStorageUnavailable=function(){return"localStorage is unavailable"},localStorageUnavailableForUserId=function(){return"localStorage is unavailable, so anonymous user ID cannot be cached"},networkError=function(e){return"network error"+(e?" ("+e+")":"")},unknownCustomEventKey=function(e){return'Custom event "'+e+'" does not exist'},environmentNotFound=function(){return"environment not found."+docLink},environmentNotSpecified=function(){return"No environment specified."+docLink},errorFetchingFlags=function(e){return"Error fetching flag settings: "+(e.message||e)},userNotSpecified=function(){return"No user specified."+docLink},invalidUser=function(){return"Invalid user specified."+docLink},bootstrapOldFormat=function(){return"LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly."+docLink},bootstrapInvalid=function(){return"LaunchDarkly bootstrap data is not available because the back end could not read the flags."},deprecated=function(e,n){return'[LaunchDarkly] "'+e+'" is deprecated, please use "'+n+'"'},httpErrorMessage=function(e,n,t){return"Received error "+e+(401===e?" (invalid SDK key)":"")+" for "+n+" - "+(isHttpErrorRecoverable(e)?t:"giving up permanently")},httpUnavailable=function(){return"Cannot make HTTP requests in this environment."+docLink},identifyDisabled=function(){return"identify() has no effect here; it must be called on the main client instance"},debugPolling=function(e){return"polling for feature flags at "+e},debugStreamPing=function(){return"received ping message from stream"},debugStreamPut=function(){return"received streaming update for all flags"},debugStreamPatch=function(e){return'received streaming update for flag "'+e+'"'},debugStreamPatchIgnored=function(e){return'received streaming update for flag "'+e+'" but ignored due to version check'},debugStreamDelete=function(e){return'received streaming deletion for flag "'+e+'"'},debugStreamDeleteIgnored=function(e){return'received streaming deletion for flag "'+e+'" but ignored due to version check'},debugEnqueueingEvent=function(e){return'enqueueing "'+e+'" event'},debugPostingEvents=function(e){return"sending "+e+" events"},messages=Object.freeze({clientInitialized:clientInitialized,clientNotReady:clientNotReady,eventWithoutUser:eventWithoutUser,invalidKey:invalidKey,localStorageUnavailable:localStorageUnavailable,localStorageUnavailableForUserId:localStorageUnavailableForUserId,networkError:networkError,unknownCustomEventKey:unknownCustomEventKey,environmentNotFound:environmentNotFound,environmentNotSpecified:environmentNotSpecified,errorFetchingFlags:errorFetchingFlags,userNotSpecified:userNotSpecified,invalidUser:invalidUser,bootstrapOldFormat:bootstrapOldFormat,bootstrapInvalid:bootstrapInvalid,deprecated:deprecated,httpErrorMessage:httpErrorMessage,httpUnavailable:httpUnavailable,identifyDisabled:identifyDisabled,debugPolling:debugPolling,debugStreamPing:debugStreamPing,debugStreamPut:debugStreamPut,debugStreamPatch:debugStreamPatch,debugStreamPatchIgnored:debugStreamPatchIgnored,debugStreamDelete:debugStreamDelete,debugStreamDeleteIgnored:debugStreamDeleteIgnored,debugEnqueueingEvent:debugEnqueueingEvent,debugPostingEvents:debugPostingEvents});function EventProcessor(e,n,t,r){var o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:null,i=arguments.length>5&&void 0!==arguments[5]?arguments[5]:null,a={},u=i||EventSender(e,n.eventsUrl,t),s=EventSummarizer(),c=UserFilter(n),l=n.inlineUsersInEvents,d=n.samplingInterval,v=n.flushInterval,f=[],g=0,p=!1,m=void 0;function h(){return 0===d||0===Math.floor(Math.random()*d)}return a.enqueue=function(e){if(!p){var n,t=!1,r=!1;if(s.summarizeEvent(e),"feature"===e.kind?h()&&(t=!!e.trackEvents,r=!!(n=e).debugEventsUntilDate&&n.debugEventsUntilDate>g&&n.debugEventsUntilDate>(new Date).getTime()):t=h(),t&&f.push(function(e){var n=extend({},e);return l||"identify"===e.kind?n.user=c.filterUser(e.user):(n.userKey=e.user.key,delete n.user),"feature"===e.kind&&(delete n.trackEvents,delete n.debugEventsUntilDate),n}(e)),r){var o=extend({},e,{kind:"debug"});delete o.trackEvents,delete o.debugEventsUntilDate,delete o.variation,f.push(o)}}},a.flush=function(){if(p)return Promise.resolve();var e=f,n=s.getSummary();return s.clearSummary(),n&&(n.kind="summary",e.push(n)),0===e.length?Promise.resolve():(f=[],r.debug(debugPostingEvents(e.length)),u.sendEvents(e).then(function(e){e&&(e.serverTime&&(g=e.serverTime),isHttpErrorRecoverable(e.status)||(p=!0),e.status>=400&&onNextTick(function(){o.maybeReportError(new LDUnexpectedResponseError(httpErrorMessage(e.status,"event posting","some events were dropped")))}))}))},a.start=function(){m=setTimeout(function e(){a.flush(),m=setTimeout(e,v)},v)},a.stop=function(){clearTimeout(m)},a}function EventEmitter(e){var n={},t={};return n.on=function(e,n,r){t[e]=t[e]||[],t[e]=t[e].concat({handler:n,context:r})},n.off=function(e,n,r){if(t[e])for(var o=0;o<t[e].length;o++)t[e][o].handler===n&&t[e][o].context===r&&(t[e]=t[e].slice(0,o).concat(t[e].slice(o+1)))},n.emit=function(e){if(t[e])for(var n=0;n<t[e].length;n++)t[e][n].handler.apply(t[e][n].context,Array.prototype.slice.call(arguments,1))},n.getEvents=function(){return Object.keys(t)},n.getEventListenerCount=function(e){return t[e]?t[e].length:0},n.maybeReportError=function(n){n&&(t.error?this.emit("error",n):(e||console).error(n.message))},n}function Store(e,n,t,r,o){var i={};function a(){var e="",o=r.getUser();return o&&(e=t||btoa(JSON.stringify(o))),"ld:"+n+":"+e}return i.loadFlags=function(){return e.get(a()).then(function(e){if(null==e)return null;try{var n=JSON.parse(e);if(n){var t=n.$schema;void 0===t||t<1?n=transformValuesToVersionedValues(n):delete n.$schema}return n}catch(e){return i.clearFlags().then(function(){return Promise.reject(e)})}}).catch(function(e){return o.warn(localStorageUnavailable()),Promise.reject(e)})},i.saveFlags=function(n){var t=extend({},n,{$schema:1});return e.set(a(),JSON.stringify(t)).catch(function(e){return o.warn(localStorageUnavailable()),Promise.reject(e)})},i.clearFlags=function(){return e.clear(a()).catch(function(e){return o.warn(localStorageUnavailable()),Promise.reject(e)})},i}function Stream(e,n,t,r){var o=n.streamUrl,i={},a=o+"/eval/"+t,u=n.useReport,s=n.evaluationReasons,c=n.streamReconnectDelay,l=null,d=null,v=null,f=null;function g(){h(),p(c)}function p(e){d||(e?d=setTimeout(m,e):m())}function m(){var n=void 0,i="",c={};if(e.eventSourceFactory){for(var d in null!=r&&(i="h="+r),u?e.eventSourceAllowsReport?(n=a,c.method="REPORT",c.headers={"Content-Type":"application/json"},c.body=JSON.stringify(v)):(n=o+"/ping/"+t,i=""):n=a+"/"+base64URLEncode(JSON.stringify(v)),s&&(i=i+(i?"&":"")+"withReasons=true"),n=n+(i?"?":"")+i,h(),l=e.eventSourceFactory(n,c),f)f.hasOwnProperty(d)&&l.addEventListener(d,f[d]);l.onerror=g}}function h(){l&&(l.close(),l=null)}return i.connect=function(e,n){v=e,f=n,p()},i.disconnect=function(){clearTimeout(d),d=null,h()},i.isConnected=function(){return l&&e.eventSourceIsActive&&e.eventSourceIsActive(l)},i}function promiseCoalescer(e){var n=void 0,t=void 0,r=void 0,o=void 0,i={addPromise:function(i,a){n=i,t&&t(),t=a,i.then(function(t){n===i&&(r(t),e&&e())},function(t){n===i&&(o(t),e&&e())})}};return i.resultPromise=new Promise(function(e,n){r=e,o=n}),i}var json="application/json";function getResponseError(e){return 404===e.status?new LDInvalidEnvironmentIdError(environmentNotFound()):new LDFlagFetchError(errorFetchingFlags(e.statusText||String(e.status)))}function Requestor(e,n,t,r){var o=n.baseUrl,i=n.useReport,a=n.evaluationReasons,u=n.sendLDHeaders,s={},c={};function l(n,t){if(!e.httpRequest)return new Promise(function(e,n){n(new LDFlagFetchError(httpUnavailable()))});var r=t?"REPORT":"GET",o=u?getLDHeaders(e):{};t&&(o["Content-Type"]="application/json");var i=c[n];i||(i=promiseCoalescer(function(){delete c[n]}),c[n]=i);var a=e.httpRequest(r,n,o,t),s=a.promise.then(function(e){return 200===e.status&&e.header("content-type")&&0===e.header("content-type").lastIndexOf(json)?JSON.parse(e.body):Promise.reject(getResponseError(e))},function(e){return Promise.reject(new LDFlagFetchError(networkError(e)))});return i.addPromise(s,function(){a.cancel&&a.cancel()}),i.resultPromise}return s.fetchFlagSettings=function(e,n){var u=void 0,s=void 0,c="",d=void 0;return i?(s=[o,"/sdk/evalx/",t,"/user"].join(""),d=JSON.stringify(e)):(u=base64URLEncode(JSON.stringify(e)),s=[o,"/sdk/evalx/",t,"/users/",u].join("")),n&&(c="h="+n),a&&(c=c+(c?"&":"")+"withReasons=true"),s=s+(c?"?":"")+c,r.debug(debugPolling(s)),l(s,d)},s.fetchGoals=function(){return l([o,"/sdk/goals/",t].join(""),null)},s}function Identity(e,n){var t={},r=void 0;return t.setUser=function(e){(r=sanitizeUser(e))&&n&&n(clone(r))},t.getUser=function(){return r?clone(r):null},e&&t.setUser(e),t}function createCommonjsModule(e,n){return e(n={exports:{}},n.exports),n.exports}for(var rngBrowser=createCommonjsModule(function(e){var n="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof window.msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto);if(n){var t=new Uint8Array(16);e.exports=function(){return n(t),t}}else{var r=new Array(16);e.exports=function(){for(var e,n=0;n<16;n++)0==(3&n)&&(e=4294967296*Math.random()),r[n]=e>>>((3&n)<<3)&255;return r}}}),byteToHex=[],i$1=0;i$1<256;++i$1)byteToHex[i$1]=(i$1+256).toString(16).substr(1);function bytesToUuid(e,n){var t=n||0,r=byteToHex;return[r[e[t++]],r[e[t++]],r[e[t++]],r[e[t++]],"-",r[e[t++]],r[e[t++]],"-",r[e[t++]],r[e[t++]],"-",r[e[t++]],r[e[t++]],"-",r[e[t++]],r[e[t++]],r[e[t++]],r[e[t++]],r[e[t++]],r[e[t++]]].join("")}var _nodeId,_clockseq,bytesToUuid_1=bytesToUuid,_lastMSecs=0,_lastNSecs=0;function v1(e,n,t){var r=n&&t||0,o=n||[],i=(e=e||{}).node||_nodeId,a=void 0!==e.clockseq?e.clockseq:_clockseq;if(null==i||null==a){var u=rngBrowser();null==i&&(i=_nodeId=[1|u[0],u[1],u[2],u[3],u[4],u[5]]),null==a&&(a=_clockseq=16383&(u[6]<<8|u[7]))}var s=void 0!==e.msecs?e.msecs:(new Date).getTime(),c=void 0!==e.nsecs?e.nsecs:_lastNSecs+1,l=s-_lastMSecs+(c-_lastNSecs)/1e4;if(l<0&&void 0===e.clockseq&&(a=a+1&16383),(l<0||s>_lastMSecs)&&void 0===e.nsecs&&(c=0),c>=1e4)throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");_lastMSecs=s,_lastNSecs=c,_clockseq=a;var d=(1e4*(268435455&(s+=122192928e5))+c)%4294967296;o[r++]=d>>>24&255,o[r++]=d>>>16&255,o[r++]=d>>>8&255,o[r++]=255&d;var v=s/4294967296*1e4&268435455;o[r++]=v>>>8&255,o[r++]=255&v,o[r++]=v>>>24&15|16,o[r++]=v>>>16&255,o[r++]=a>>>8|128,o[r++]=255&a;for(var f=0;f<6;++f)o[r+f]=i[f];return n||bytesToUuid_1(o)}var v1_1=v1,ldUserIdKey="ld:$anonUserId";function UserValidator(e,n){var t={validateUser:function(t){if(!t)return Promise.reject(new LDInvalidUserError(userNotSpecified()));var r=clone(t);return null!==r.key&&void 0!==r.key?(r.key=r.key.toString(),Promise.resolve(r)):r.anonymous?(e?e.get(ldUserIdKey).catch(function(){return null}):Promise.resolve(null)).then(function(t){if(t)return r.key=t,r;var o=v1_1();return r.key=o,function(t){return e?e.set(ldUserIdKey,t).catch(function(){n.warn(localStorageUnavailableForUserId())}):Promise.resolve()}(o).then(function(){return r})}):Promise.reject(new LDInvalidUserError(invalidUser()))}};return t}function validate(e,n,t,r){var o=extend({},{baseUrl:"https://app.launchdarkly.com",streamUrl:"https://clientstream.launchdarkly.com",eventsUrl:"https://events.launchdarkly.com",sendEvents:!0,sendLDHeaders:!0,inlineUsersInEvents:!1,allowFrequentDuplicateEvents:!1,sendEventsOnlyForVariation:!1,useReport:!1,evaluationReasons:!1,flushInterval:2e3,samplingInterval:0,streamReconnectDelay:1e3,allAttributesPrivate:!1,privateAttributeNames:[]},t),i={all_attributes_private:"allAttributesPrivate",private_attribute_names:"privateAttributeNames"};function a(e){onNextTick(function(){n&&n.maybeReportError(new LDInvalidArgumentError(e))})}var u=extend({},e||{});return function(e){var n=u;Object.keys(i).forEach(function(e){if(void 0!==n[e]){var t=i[e];r.warn(deprecated(e,t)),void 0===n[t]&&(n[t]=n[e]),delete n[e]}})}(),u=function(e,n){var t=extend({},u);return Object.keys(n).forEach(function(e){void 0!==t[e]&&null!==t[e]||(t[e]=n[e])}),t}(0,o),(isNaN(u.flushInterval)||u.flushInterval<2e3)&&(u.flushInterval=2e3,a("Invalid flush interval configured. Must be an integer >= 2000 (milliseconds).")),(isNaN(u.samplingInterval)||u.samplingInterval<0)&&(u.samplingInterval=0,a("Invalid sampling interval configured. Sampling interval must be an integer >= 0.")),u}function createConsoleLogger(e){var n=0;e&&(n="none"===e?100:["debug","info","warn","error"].indexOf(e));var t={};function r(e,t,r){e>=n&&t(r)}return t.debug=function(e){return r(0,console.log,e)},t.info=function(e){return r(1,console.info,e)},t.warn=function(e){return r(2,console.warn,e)},t.error=function(e){return r(3,console.error,e)},t}var _typeof$1="function"==typeof Symbol&&"symbol"==_typeof2(Symbol.iterator)?function(e){return void 0===e?"undefined":_typeof2(e)}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":void 0===e?"undefined":_typeof2(e)},readyEvent="ready",successEvent="initialized",failedEvent="failed",changeEvent="change",internalChangeEvent="internal-change";function initialize(e,n,t,r,o){var i=t&&t.logger?t.logger:o&&o.logger||createConsoleLogger("warn"),a=EventEmitter(i),u=validate(t,a,o,i),s=u.hash,c=u.sendEvents,l=e,d=Stream(r,u,l,s),v=u.eventProcessor||EventProcessor(r,u,l,i,a),f=Requestor(r,u,l,i),g={},p={},m=void 0,h=void 0,y=u.streaming,E=void 0,b=!1,k=!1,w=!0,S=u.stateProvider,U=Identity(null,function(e){S||e&&P({kind:"identify",key:e.key,user:e,creationDate:(new Date).getTime()})}),D=UserValidator(r.localStorage,i),L=void 0;function P(e){l&&(S&&S.enqueueEvent&&S.enqueueEvent(e)||(e.user?(w=!1,!c||k||r.isDoNotTrack()||(i.debug(debugEnqueueingEvent(e.kind)),v.enqueue(e))):w&&(i.warn(eventWithoutUser()),w=!1)))}function I(e,n,t){var r=U.getUser(),o=new Date,i=n?n.value:null;if(!u.allowFrequentDuplicateEvents){var a=JSON.stringify(i)+(r&&r.key?r.key:"")+e,s=g[a];if(s&&o-s<3e5)return;g[a]=o}var c={kind:"feature",key:e,user:r,value:i,variation:n?n.variationIndex:null,default:t,creationDate:o.getTime(),reason:n?n.reason:null},l=p[e];l&&(c.version=l.flagVersion?l.flagVersion:l.version,c.trackEvents=l.trackEvents,c.debugEventsUntilDate=l.debugEventsUntilDate),P(c)}function R(e,n,t){var r=void 0;if(p&&p.hasOwnProperty(e)&&p[e]&&!p[e].deleted){var o=p[e];r=T(o),null!==o.value&&void 0!==o.value||(r.value=n)}else r={value:n,variationIndex:null,reason:{kind:"ERROR",errorKind:"FLAG_NOT_FOUND"}};return t&&I(e,r,n),r}function T(e){return{value:e.value,variationIndex:void 0===e.variation?null:e.variation,reason:e.reason||null}}function F(){h=!0,U.getUser()&&d.connect(U.getUser(),{ping:function(){i.debug(debugStreamPing()),f.fetchFlagSettings(U.getUser(),s,function(e,n){e&&a.maybeReportError(new LDFlagFetchError(errorFetchingFlags(e))),N(n)})},put:function(e){var n=JSON.parse(e.data);i.debug(debugStreamPut()),N(n)},patch:function(e){var n=JSON.parse(e.data),t=p[n.key];if(!t||!t.version||!n.version||t.version<n.version){i.debug(debugStreamPatch(n.key));var r={},o=extend({},n);delete o.key,p[n.key]=o;var a=T(o);r[n.key]=t?{previous:t.value,current:a}:{current:a},C(r)}else i.debug(debugStreamPatchIgnored(n.key))},delete:function(e){var n=JSON.parse(e.data);if(!p[n.key]||p[n.key].version<n.version){i.debug(debugStreamDelete(n.key));var t={};p[n.key]&&!p[n.key].deleted&&(t[n.key]={previous:p[n.key].value}),p[n.key]={version:n.version,deleted:!0},C(t)}else i.debug(debugStreamDeleteIgnored(n.key))}})}function x(){h&&(d.disconnect(),h=!1)}function N(e){var n={};if(!e)return Promise.resolve();for(var t in p)p.hasOwnProperty(t)&&p[t]&&(e[t]&&!deepEquals(e[t].value,p[t].value)?n[t]={previous:p[t].value,current:T(e[t])}:e[t]&&!e[t].deleted||(n[t]={previous:p[t].value}));for(var r in e)e.hasOwnProperty(r)&&e[r]&&(!p[r]||p[r].deleted)&&(n[r]={current:T(e[r])});return p=e,C(n).catch(function(){})}function C(e){var n=Object.keys(e);if(n.length>0){var t={};n.forEach(function(n){var r=e[n].current,o=r?r.value:void 0,i=e[n].previous;a.emit(changeEvent+":"+n,o,i),t[n]=r?{current:o,previous:i}:{previous:i}}),a.emit(changeEvent,t),a.emit(internalChangeEvent,p),u.sendEventsOnlyForVariation||S||n.forEach(function(n){I(n,e[n].current)})}return m&&L?L.saveFlags(p).catch(function(){return null}):Promise.resolve()}function O(){var e=y||E&&void 0===y;e&&!h?F():!e&&h&&x()}function A(e){return e===changeEvent||e.substr(0,changeEvent.length+1)===changeEvent+":"}r.localStorage&&(L=new Store(r.localStorage,l,s,U,i));var _=new Promise(function(e){var n=a.on(readyEvent,function(){a.off(readyEvent,n),e()})}),j=new Promise(function(e,n){var t=a.on(successEvent,function(){a.off(successEvent,t),e()}),r=a.on(failedEvent,function(e){a.off(failedEvent,r),n(e)})});if("string"==typeof u.bootstrap&&"LOCALSTORAGE"===u.bootstrap.toUpperCase()&&(L?m=!0:i.warn(localStorageUnavailable())),S){var q=S.getInitialState();q?V(q):S.on("init",V),S.on("update",function(e){e.user&&U.setUser(e.user),e.flags&&N(e.flags)})}else(e?D.validateUser(n).then(function(e){return U.setUser(e),"object"===_typeof$1(u.bootstrap)?(p=function(e){var n=Object.keys(e),t=e.$flagsState;!t&&n.length&&i.warn(bootstrapOldFormat()),!1===e.$valid&&i.warn(bootstrapInvalid());var r={};return n.forEach(function(n){if("$flagsState"!==n&&"$valid"!==n){var o={value:e[n]};t&&t[n]?o=extend(o,t[n]):o.version=0,r[n]=o}}),r}(u.bootstrap),z()):m?L.loadFlags().catch(function(){return null}).then(function(e){return null==e?(p={},f.fetchFlagSettings(U.getUser(),s).then(function(e){return N(e||{})}).then(z).catch(function(e){H(new LDFlagFetchError(errorFetchingFlags(e)))})):(p=e,onNextTick(z),f.fetchFlagSettings(U.getUser(),s).then(function(e){return N(e)}).catch(function(e){return a.maybeReportError(e)}))}):f.fetchFlagSettings(U.getUser(),s).then(function(e){p=e||{},z()}).catch(function(e){p={},H(e)})}):Promise.reject(new LDInvalidEnvironmentIdError(environmentNotSpecified()))).catch(function(e){return a.maybeReportError(e)});function V(e){l=e.environment,U.setUser(e.user),p=e.flags,onNextTick(z)}function z(){i.info(clientInitialized()),b=!0,O(),a.emit(readyEvent),a.emit(successEvent)}function H(e){a.maybeReportError(e),a.emit(failedEvent,e),a.emit(readyEvent)}return{client:{waitForInitialization:function(){return j},waitUntilReady:function(){return _},identify:function(e,n,t){return k?wrapPromiseCallback(Promise.resolve({}),t):S?(i.warn(identifyDisabled()),wrapPromiseCallback(Promise.resolve(transformVersionedValuesToValues(p)),t)):wrapPromiseCallback((m&&L?L.clearFlags():Promise.resolve()).then(function(){return D.validateUser(e)}).then(function(e){return U.setUser(e)}).then(function(){return f.fetchFlagSettings(U.getUser(),n)}).then(function(e){var n=transformVersionedValuesToValues(e);return e?N(e).then(function(){return n}):n}).then(function(e){return h&&F(),e}).catch(function(e){return a.maybeReportError(e),Promise.reject(e)}),t)},getUser:function(){return U.getUser()},variation:function(e,n){return R(e,n,!0).value},variationDetail:function(e,n){return R(e,n,!0)},track:function(e,n){"string"==typeof e?(r.customEventFilter&&!r.customEventFilter(e)&&i.warn(unknownCustomEventKey(e)),P({kind:"custom",key:e,data:n,user:U.getUser(),url:r.getCurrentUrl(),creationDate:(new Date).getTime()})):a.maybeReportError(new LDInvalidEventKeyError(unknownCustomEventKey(e)))},on:function(e,n,t){A(e)?(E=!0,b&&O(),a.on(e,n,t)):a.on.apply(a,arguments)},off:function(e){if(a.off.apply(a,arguments),A(e)){var n=!1;a.getEvents().forEach(function(e){A(e)&&a.getEventListenerCount(e)>0&&(n=!0)}),n||(E=!1,h&&void 0===y&&x())}},setStreaming:function(e){var n=null===e?void 0:e;n!==y&&(y=n,O())},flush:function(e){return wrapPromiseCallback(c?v.flush():Promise.resolve(),e)},allFlags:function(){var e={};if(!p)return e;for(var n in p)p.hasOwnProperty(n)&&(e[n]=R(n,null,!u.sendEventsOnlyForVariation).value);return e},close:function(e){if(k)return wrapPromiseCallback(Promise.resolve(),e);var n=function(){k=!0,p={}};return wrapPromiseCallback(Promise.resolve().then(function(){if(x(),c)return v.stop(),v.flush()}).then(n).catch(n),e)}},options:u,emitter:a,ident:U,logger:i,requestor:f,start:function(){c&&v.start()},enqueueEvent:P,getFlagsInternal:function(){return p},internalChangeEventName:internalChangeEvent}}var version="2.10.2";function isSyncXhrSupported(){var e=window.navigator&&window.navigator.userAgent;if(e){var n=e.match(/Chrom(e|ium)\/([0-9]+)\./);if(n)return parseInt(n[2],10)<73}return!0}var emptyResult={promise:Promise.resolve({status:200,header:function(){return null},body:null})};function newHttpRequest(e,n,t,r,o){if(o&&!isSyncXhrSupported())return emptyResult;var i=new window.XMLHttpRequest;for(var a in i.open(e,n,!o),t||{})t.hasOwnProperty(a)&&i.setRequestHeader(a,t[a]);if(o)return i.send(r),emptyResult;var u=void 0;return{promise:new Promise(function(e,n){i.addEventListener("load",function(){u||e({status:i.status,header:function(e){return i.getResponseHeader(e)},body:i.responseText})}),i.addEventListener("error",function(){u||n(new Error)}),i.send(r)}),cancel:function(){u=!0,i.abort()}}}function makeBrowserPlatform(){var e={pageIsClosing:!1};window.XMLHttpRequest&&(e.httpRequest=function(n,t,r,o){return newHttpRequest(n,t,r,o,e.pageIsClosing)});var n=void 0;e.httpAllowsPost=function(){return void 0===n&&(n=!!window.XMLHttpRequest&&"withCredentials"in new window.XMLHttpRequest),n},e.getCurrentUrl=function(){return window.location.href},e.isDoNotTrack=function(){var e=void 0;return 1===(e=window.navigator&&void 0!==window.navigator.doNotTrack?window.navigator.doNotTrack:window.navigator&&void 0!==window.navigator.msDoNotTrack?window.navigator.msDoNotTrack:window.doNotTrack)||!0===e||"1"===e||"yes"===e};try{window.localStorage&&(e.localStorage={get:function(e){return new Promise(function(n){n(window.localStorage.getItem(e))})},set:function(e,n){return new Promise(function(t){window.localStorage.setItem(e,n),t()})},clear:function(e){return new Promise(function(n){window.localStorage.removeItem(e),n()})}})}catch(n){e.localStorage=null}if(window.EventSource){e.eventSourceFactory=function(e){var n={heartbeatTimeout:3e5,silentTimeout:3e5};return new window.EventSource(e,n)},e.eventSourceIsActive=function(e){return e.readyState===window.EventSource.OPEN||e.readyState===window.EventSource.CONNECTING}}return e.eventSourceAllowsReport=!1,e.userAgent="JSClient",e}var matchOperatorsRe=/[|\\{}()[\]^$+*?.]/g,escapeStringRegexp=function(e){if("string"!=typeof e)throw new TypeError("Expected a string");return e.replace(matchOperatorsRe,"\\$&")};function doesUrlMatch(e,n,t,r){var o=n.replace(t,"").replace(r,""),i=void 0,a=void 0;switch(e.kind){case"exact":a=n,i=new RegExp("^"+escapeStringRegexp(e.url)+"/?$");break;case"canonical":a=o,i=new RegExp("^"+escapeStringRegexp(e.url)+"/?$");break;case"substring":a=o,i=new RegExp(".*"+escapeStringRegexp(e.substring)+".*$");break;case"regex":a=o,i=new RegExp(e.pattern);break;default:return!1}return i.test(a)}function findGoalsForClick(e,n){for(var t=[],r=0;r<n.length;r++)for(var o=e.target,i=n[r],a=i.selector,u=document.querySelectorAll(a);o&&u.length>0;){for(var s=0;s<u.length;s++)o===u[s]&&t.push(i);o=o.parentNode}return t}function GoalTracker(e,n){for(var t={},r=null,o=[],i=0;i<e.length;i++)for(var a=e[i],u=a.urls||[],s=0;s<u.length;s++)if(doesUrlMatch(u[s],window.location.href,window.location.search,window.location.hash)){"pageview"===a.kind?n("pageview",a):(o.push(a),n("click_pageview",a));break}return o.length>0&&(r=function(e){for(var t=findGoalsForClick(e,o),r=0;r<t.length;r++)n("click",t[r])},document.addEventListener("click",r)),t.dispose=function(){document.removeEventListener("click",r)},t}var locationWatcherInterval=300;function GoalManager(e,n){var t=void 0,r=void 0,o={};function i(){r&&r.dispose(),t&&t.length&&(r=GoalTracker(t,a))}function a(n,t){var r={kind:n,key:t.key,data:null,url:window.location.href,user:e.ident.getUser(),creationDate:(new Date).getTime()};return"click"===n&&(r.selector=t.selector),e.enqueueEvent(r)}return o.goalKeyExists=function(e){if(!t)return!0;for(var n=0;n<t.length;n++)if("custom"===t[n].kind&&t[n].key===e)return!0;return!1},e.requestor.fetchGoals().then(function(e){e&&e.length>0&&(r=GoalTracker(t=e,a),function(e,n){var t=window.location.href,r=void 0;function o(){(r=window.location.href)!==t&&(t=r,n())}!function e(n,t){n(),setTimeout(function(){e(n,t)},t)}(o,e),window.history&&window.history.pushState?window.addEventListener("popstate",o):window.addEventListener("hashchange",o)}(locationWatcherInterval,i)),n()}).catch(function(t){e.emitter.maybeReportError(new errors.LDUnexpectedResponseError((t&&t.message,t.message))),n()}),o}var goalsEvent="goalsReady",extraDefaults={fetchGoals:!0};function initialize$1(e,n){var t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=makeBrowserPlatform(),o=initialize(e,n,t,r,extraDefaults),i=o.client,a=o.options,u=o.emitter,s=new Promise(function(e){var n=u.on(goalsEvent,function(){u.off(goalsEvent,n),e()})});if(i.waitUntilGoalsReady=function(){return s},a.fetchGoals){var c=GoalManager(o,function(){return u.emit(goalsEvent)});r.customEventFilter=c.goalKeyExists}else u.emit(goalsEvent);return"complete"!==document.readyState?window.addEventListener("load",o.start):o.start(),window.addEventListener("beforeunload",function(){r.pageIsClosing=!0,i.close()}),i}var createConsoleLogger$1=createConsoleLogger,version$1=version;function deprecatedInitialize(e,n){var t=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return console&&console.warn&&console.warn(messages.deprecated("default export","named LDClient export")),initialize$1(e,n,t)}var index={initialize:deprecatedInitialize,version:version$1};exports.initialize=initialize$1,exports.createConsoleLogger=createConsoleLogger$1,exports.version=version$1,exports.default=index;
	//# sourceMappingURL=ldclient.cjs.js.map


/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	var map = __webpack_require__(1066);
	
	var getCountryCode = function(localeString) {
	    var components = localeString.split("_");
	    if (components.length == 2) {
	        return components.pop();
	    }
	    components = localeString.split("-");
	    if (components.length == 2) {
	        return components.pop();
	    }
	    return localeString;
	}
	
	exports.getCurrency = function(locale) {
	    var countryCode = getCountryCode(locale).toUpperCase();
	    if (countryCode in map) {
	        return map[countryCode];
	    }
	    return null;
	}
	
	exports.getLocales = function(currencyCode) {
	    currencyCode = currencyCode.toUpperCase();
	    var locales = [];
	    for (countryCode in map) {
	        if (map[countryCode] === currencyCode) {
	            locales.push(countryCode);
	        }
	    }
	    return locales;
	}

/***/ },
/* 1066 */
/***/ function(module, exports) {

	// Generated using ShowCurrencies.java
	var map = {
	AD: 'EUR',
	AE: 'AED',
	AF: 'AFN',
	AG: 'XCD',
	AI: 'XCD',
	AL: 'ALL',
	AM: 'AMD',
	AN: 'ANG',
	AO: 'AOA',
	AR: 'ARS',
	AS: 'USD',
	AT: 'EUR',
	AU: 'AUD',
	AW: 'AWG',
	AX: 'EUR',
	AZ: 'AZN',
	BA: 'BAM',
	BB: 'BBD',
	BD: 'BDT',
	BE: 'EUR',
	BF: 'XOF',
	BG: 'BGN',
	BH: 'BHD',
	BI: 'BIF',
	BJ: 'XOF',
	BL: 'EUR',
	BM: 'BMD',
	BN: 'BND',
	BO: 'BOB',
	BQ: 'USD',
	BR: 'BRL',
	BS: 'BSD',
	BT: 'BTN',
	BV: 'NOK',
	BW: 'BWP',
	BY: 'BYR',
	BZ: 'BZD',
	CA: 'CAD',
	CC: 'AUD',
	CD: 'CDF',
	CF: 'XAF',
	CG: 'XAF',
	CH: 'CHF',
	CI: 'XOF',
	CK: 'NZD',
	CL: 'CLP',
	CM: 'XAF',
	CN: 'CNY',
	CO: 'COP',
	CR: 'CRC',
	CU: 'CUP',
	CV: 'CVE',
	CW: 'ANG',
	CX: 'AUD',
	CY: 'EUR',
	CZ: 'CZK',
	DE: 'EUR',
	DJ: 'DJF',
	DK: 'DKK',
	DM: 'XCD',
	DO: 'DOP',
	DZ: 'DZD',
	EC: 'USD',
	EE: 'EUR',
	EG: 'EGP',
	EH: 'MAD',
	ER: 'ERN',
	ES: 'EUR',
	ET: 'ETB',
	FI: 'EUR',
	FJ: 'FJD',
	FK: 'FKP',
	FM: 'USD',
	FO: 'DKK',
	FR: 'EUR',
	GA: 'XAF',
	GB: 'GBP',
	GD: 'XCD',
	GE: 'GEL',
	GF: 'EUR',
	GG: 'GBP',
	GH: 'GHS',
	GI: 'GIP',
	GL: 'DKK',
	GM: 'GMD',
	GN: 'GNF',
	GP: 'EUR',
	GQ: 'XAF',
	GR: 'EUR',
	GS: 'GBP',
	GT: 'GTQ',
	GU: 'USD',
	GW: 'XOF',
	GY: 'GYD',
	HK: 'HKD',
	HM: 'AUD',
	HN: 'HNL',
	HR: 'HRK',
	HT: 'HTG',
	HU: 'HUF',
	ID: 'IDR',
	IE: 'EUR',
	IL: 'ILS',
	IM: 'GBP',
	IN: 'INR',
	IO: 'USD',
	IQ: 'IQD',
	IR: 'IRR',
	IS: 'ISK',
	IT: 'EUR',
	JE: 'GBP',
	JM: 'JMD',
	JO: 'JOD',
	JP: 'JPY',
	KE: 'KES',
	KG: 'KGS',
	KH: 'KHR',
	KI: 'AUD',
	KM: 'KMF',
	KN: 'XCD',
	KP: 'KPW',
	KR: 'KRW',
	KW: 'KWD',
	KY: 'KYD',
	KZ: 'KZT',
	LA: 'LAK',
	LB: 'LBP',
	LC: 'XCD',
	LI: 'CHF',
	LK: 'LKR',
	LR: 'LRD',
	LS: 'LSL',
	LT: 'LTL',
	LU: 'EUR',
	LV: 'LVL',
	LY: 'LYD',
	MA: 'MAD',
	MC: 'EUR',
	MD: 'MDL',
	ME: 'EUR',
	MF: 'EUR',
	MG: 'MGA',
	MH: 'USD',
	MK: 'MKD',
	ML: 'XOF',
	MM: 'MMK',
	MN: 'MNT',
	MO: 'MOP',
	MP: 'USD',
	MQ: 'EUR',
	MR: 'MRO',
	MS: 'XCD',
	MT: 'EUR',
	MU: 'MUR',
	MV: 'MVR',
	MW: 'MWK',
	MX: 'MXN',
	MY: 'MYR',
	MZ: 'MZN',
	NA: 'NAD',
	NC: 'XPF',
	NE: 'XOF',
	NF: 'AUD',
	NG: 'NGN',
	NI: 'NIO',
	NL: 'EUR',
	NO: 'NOK',
	NP: 'NPR',
	NR: 'AUD',
	NU: 'NZD',
	NZ: 'NZD',
	OM: 'OMR',
	PA: 'PAB',
	PE: 'PEN',
	PF: 'XPF',
	PG: 'PGK',
	PH: 'PHP',
	PK: 'PKR',
	PL: 'PLN',
	PM: 'EUR',
	PN: 'NZD',
	PR: 'USD',
	PS: 'ILS',
	PT: 'EUR',
	PW: 'USD',
	PY: 'PYG',
	QA: 'QAR',
	RE: 'EUR',
	RO: 'RON',
	RS: 'RSD',
	RU: 'RUB',
	RW: 'RWF',
	SA: 'SAR',
	SB: 'SBD',
	SC: 'SCR',
	SD: 'SDG',
	SE: 'SEK',
	SG: 'SGD',
	SH: 'SHP',
	SI: 'EUR',
	SJ: 'NOK',
	SK: 'EUR',
	SL: 'SLL',
	SM: 'EUR',
	SN: 'XOF',
	SO: 'SOS',
	SR: 'SRD',
	ST: 'STD',
	SV: 'SVC',
	SX: 'ANG',
	SY: 'SYP',
	SZ: 'SZL',
	TC: 'USD',
	TD: 'XAF',
	TF: 'EUR',
	TG: 'XOF',
	TH: 'THB',
	TJ: 'TJS',
	TK: 'NZD',
	TL: 'USD',
	TM: 'TMT',
	TN: 'TND',
	TO: 'TOP',
	TR: 'TRY',
	TT: 'TTD',
	TV: 'AUD',
	TW: 'TWD',
	TZ: 'TZS',
	UA: 'UAH',
	UG: 'UGX',
	UM: 'USD',
	US: 'USD',
	UY: 'UYU',
	UZ: 'UZS',
	VA: 'EUR',
	VC: 'XCD',
	VE: 'VEF',
	VG: 'USD',
	VI: 'USD',
	VN: 'VND',
	VU: 'VUV',
	WF: 'XPF',
	WS: 'WST',
	YE: 'YER',
	YT: 'EUR',
	ZA: 'ZAR',
	ZM: 'ZMK',
	ZW: 'ZWL'
	};
	
	module.exports = map;

/***/ },
/* 1067 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)(module), (function() { return this; }())))

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var useObserver_1 = __webpack_require__(182);
	function ObserverComponent(_a) {
	    var children = _a.children, render = _a.render;
	    var component = children || render;
	    if (typeof component !== "function") {
	        return null;
	    }
	    return useObserver_1.useObserver(component);
	}
	exports.Observer = ObserverComponent;
	ObserverComponent.propTypes = {
	    children: ObserverPropsCheck,
	    render: ObserverPropsCheck
	};
	ObserverComponent.displayName = "Observer";
	function ObserverPropsCheck(props, key, componentName, location, propFullName) {
	    var extraKey = key === "children" ? "render" : "children";
	    var hasProp = typeof props[key] === "function";
	    var hasExtraProp = typeof props[extraKey] === "function";
	    if (hasProp && hasExtraProp) {
	        return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
	    }
	    if (hasProp || hasExtraProp) {
	        return null;
	    }
	    return new Error("Invalid prop `" +
	        propFullName +
	        "` of type `" +
	        typeof props[key] +
	        "` supplied to" +
	        " `" +
	        componentName +
	        "`, expected `function`.");
	}


/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_1 = __webpack_require__(29);
	var react_1 = __webpack_require__(2);
	if (!react_1.useState) {
	    throw new Error("mobx-react-lite requires React with Hooks support");
	}
	if (!mobx_1.spy) {
	    throw new Error("mobx-react-lite requires mobx at least version 4 to be available");
	}


/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	__webpack_require__(1070);
	var reactBatchedUpdates_1 = __webpack_require__(1076);
	var observerBatching_1 = __webpack_require__(335);
	observerBatching_1.observerBatching(reactBatchedUpdates_1.unstable_batchedUpdates);
	var staticRendering_1 = __webpack_require__(181);
	exports.isUsingStaticRendering = staticRendering_1.isUsingStaticRendering;
	exports.useStaticRendering = staticRendering_1.useStaticRendering;
	var observer_1 = __webpack_require__(1072);
	exports.observer = observer_1.observer;
	var useObserver_1 = __webpack_require__(182);
	exports.useObserver = useObserver_1.useObserver;
	var ObserverComponent_1 = __webpack_require__(1069);
	exports.Observer = ObserverComponent_1.Observer;
	var utils_1 = __webpack_require__(94);
	exports.useForceUpdate = utils_1.useForceUpdate;
	var useAsObservableSource_1 = __webpack_require__(336);
	exports.useAsObservableSource = useAsObservableSource_1.useAsObservableSource;
	var useLocalStore_1 = __webpack_require__(1075);
	exports.useLocalStore = useLocalStore_1.useLocalStore;
	var useQueuedForceUpdate_1 = __webpack_require__(337);
	exports.useQueuedForceUpdate = useQueuedForceUpdate_1.useQueuedForceUpdate;
	exports.useQueuedForceUpdateBlock = useQueuedForceUpdate_1.useQueuedForceUpdateBlock;
	var observerBatching_2 = __webpack_require__(335);
	exports.isObserverBatched = observerBatching_2.isObserverBatched;
	exports.observerBatching = observerBatching_2.observerBatching;


/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_1 = __webpack_require__(2);
	var staticRendering_1 = __webpack_require__(181);
	var useObserver_1 = __webpack_require__(182);
	// n.b. base case is not used for actual typings or exported in the typing files
	function observer(baseComponent, options) {
	    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
	    if (staticRendering_1.isUsingStaticRendering()) {
	        return baseComponent;
	    }
	    var realOptions = __assign({ forwardRef: false }, options);
	    var baseComponentName = baseComponent.displayName || baseComponent.name;
	    var wrappedComponent = function (props, ref) {
	        return useObserver_1.useObserver(function () { return baseComponent(props, ref); }, baseComponentName);
	    };
	    wrappedComponent.displayName = baseComponentName;
	    // memo; we are not interested in deep updates
	    // in props; we assume that if deep objects are changed,
	    // this is in observables, which would have been tracked anyway
	    var memoComponent;
	    if (realOptions.forwardRef) {
	        // we have to use forwardRef here because:
	        // 1. it cannot go before memo, only after it
	        // 2. forwardRef converts the function into an actual component, so we can't let the baseComponent do it
	        //    since it wouldn't be a callable function anymore
	        memoComponent = react_1.memo(react_1.forwardRef(wrappedComponent));
	    }
	    else {
	        memoComponent = react_1.memo(wrappedComponent);
	    }
	    copyStaticProperties(baseComponent, memoComponent);
	    memoComponent.displayName = baseComponentName;
	    return memoComponent;
	}
	exports.observer = observer;
	// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
	var hoistBlackList = {
	    $$typeof: true,
	    render: true,
	    compare: true,
	    type: true
	};
	function copyStaticProperties(base, target) {
	    Object.keys(base).forEach(function (key) {
	        if (!hoistBlackList[key]) {
	            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
	        }
	    });
	}


/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_1 = __webpack_require__(29);
	function printDebugValue(v) {
	    return mobx_1.getDependencyTree(v);
	}
	exports.printDebugValue = printDebugValue;


/***/ },
/* 1074 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function createTrackingData(reaction) {
	    var trackingData = {
	        cleanAt: Date.now() + exports.CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS,
	        reaction: reaction
	    };
	    return trackingData;
	}
	exports.createTrackingData = createTrackingData;
	/**
	 * The minimum time before we'll clean up a Reaction created in a render
	 * for a component that hasn't managed to run its effects. This needs to
	 * be big enough to ensure that a component won't turn up and have its
	 * effects run without being re-rendered.
	 */
	exports.CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS = 10000;
	/**
	 * The frequency with which we'll check for leaked reactions.
	 */
	exports.CLEANUP_TIMER_LOOP_MILLIS = 10000;
	/**
	 * Reactions created by components that have yet to be fully mounted.
	 */
	var uncommittedReactionRefs = new Set();
	/**
	 * Latest 'uncommitted reactions' cleanup timer handle.
	 */
	var reactionCleanupHandle;
	function ensureCleanupTimerRunning() {
	    if (reactionCleanupHandle === undefined) {
	        reactionCleanupHandle = setTimeout(cleanUncommittedReactions, exports.CLEANUP_TIMER_LOOP_MILLIS);
	    }
	}
	function scheduleCleanupOfReactionIfLeaked(ref) {
	    uncommittedReactionRefs.add(ref);
	    ensureCleanupTimerRunning();
	}
	exports.scheduleCleanupOfReactionIfLeaked = scheduleCleanupOfReactionIfLeaked;
	function recordReactionAsCommitted(reactionRef) {
	    uncommittedReactionRefs.delete(reactionRef);
	}
	exports.recordReactionAsCommitted = recordReactionAsCommitted;
	/**
	 * Run by the cleanup timer to dispose any outstanding reactions
	 */
	function cleanUncommittedReactions() {
	    reactionCleanupHandle = undefined;
	    // Loop through all the candidate leaked reactions; those older
	    // than CLEANUP_LEAKED_REACTIONS_AFTER_MILLIS get tidied.
	    var now = Date.now();
	    uncommittedReactionRefs.forEach(function (ref) {
	        var tracking = ref.current;
	        if (tracking) {
	            if (now >= tracking.cleanAt) {
	                // It's time to tidy up this leaked reaction.
	                tracking.reaction.dispose();
	                ref.current = null;
	                uncommittedReactionRefs.delete(ref);
	            }
	        }
	    });
	    if (uncommittedReactionRefs.size > 0) {
	        // We've just finished a round of cleanups but there are still
	        // some leak candidates outstanding.
	        ensureCleanupTimerRunning();
	    }
	}
	/* istanbul ignore next */
	/**
	 * Only to be used by test functions; do not export outside of mobx-react-lite
	 */
	function forceCleanupTimerToRunNowForTests() {
	    // This allows us to control the execution of the cleanup timer
	    // to force it to run at awkward times in unit tests.
	    if (reactionCleanupHandle) {
	        clearTimeout(reactionCleanupHandle);
	        cleanUncommittedReactions();
	    }
	}
	exports.forceCleanupTimerToRunNowForTests = forceCleanupTimerToRunNowForTests;
	/* istanbul ignore next */
	function resetCleanupScheduleForTests() {
	    if (reactionCleanupHandle) {
	        clearTimeout(reactionCleanupHandle);
	        reactionCleanupHandle = undefined;
	    }
	    uncommittedReactionRefs.clear();
	}
	exports.resetCleanupScheduleForTests = resetCleanupScheduleForTests;


/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var mobx_1 = __webpack_require__(29);
	var react_1 = __importDefault(__webpack_require__(2));
	var useAsObservableSource_1 = __webpack_require__(336);
	var utils_1 = __webpack_require__(94);
	function useLocalStore(initializer, current) {
	    var source = useAsObservableSource_1.useAsObservableSourceInternal(current, true);
	    return react_1.default.useState(function () {
	        var local = mobx_1.observable(initializer(source));
	        if (utils_1.isPlainObject(local)) {
	            mobx_1.runInAction(function () {
	                Object.keys(local).forEach(function (key) {
	                    var value = local[key];
	                    if (typeof value === "function") {
	                        // @ts-ignore No idea why ts2536 is popping out here
	                        local[key] = wrapInTransaction(value, local);
	                    }
	                });
	            });
	        }
	        return local;
	    })[0];
	}
	exports.useLocalStore = useLocalStore;
	// tslint:disable-next-line: ban-types
	function wrapInTransaction(fn, context) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        return mobx_1.transaction(function () { return fn.apply(context, args); });
	    };
	}


/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var react_dom_1 = __webpack_require__(37);
	exports.unstable_batchedUpdates = react_dom_1.unstable_batchedUpdates;


/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e,r=__webpack_require__(29),t=__webpack_require__(2),n=(e=t)&&"object"==typeof e&&"default"in e?e.default:e,o=__webpack_require__(1071),a=0,i={};function s(e){return i[e]||(i[e]=function(e){if("function"==typeof Symbol)return Symbol(e);var r="__$mobx-react "+e+" ("+a+")";return a++,r}(e)),i[e]}function c(e,r){if(u(e,r))return!0;if("object"!=typeof e||null===e||"object"!=typeof r||null===r)return!1;var t=Object.keys(e),n=Object.keys(r);if(t.length!==n.length)return!1;for(var o=0;o<t.length;o++)if(!Object.hasOwnProperty.call(r,t[o])||!u(e[t[o]],r[t[o]]))return!1;return!0}function u(e,r){return e===r?0!==e||1/e==1/r:e!=e&&r!=r}var f={$$typeof:1,render:1,compare:1,type:1,childContextTypes:1,contextType:1,contextTypes:1,defaultProps:1,getDefaultProps:1,getDerivedStateFromError:1,getDerivedStateFromProps:1,mixins:1,propTypes:1};function l(e,r,t){Object.hasOwnProperty.call(e,r)?e[r]=t:Object.defineProperty(e,r,{enumerable:!1,configurable:!0,writable:!0,value:t})}var p=s("patchMixins"),b=s("patchedDefinition");function d(e,r){for(var t=this,n=arguments.length,o=new Array(n>2?n-2:0),a=2;a<n;a++)o[a-2]=arguments[a];r.locks++;try{var i;return null!=e&&(i=e.apply(this,o)),i}finally{r.locks--,0===r.locks&&r.methods.forEach((function(e){e.apply(t,o)}))}}function y(e,r){return function(){for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];d.call.apply(d,[this,e,r].concat(n))}}function v(e,r,t){var n=function(e,r){var t=e[p]=e[p]||{},n=t[r]=t[r]||{};return n.locks=n.locks||0,n.methods=n.methods||[],n}(e,r);n.methods.indexOf(t)<0&&n.methods.push(t);var o=Object.getOwnPropertyDescriptor(e,r);if(!o||!o[b]){var a=function e(r,t,n,o,a){var i,s=y(a,o);return(i={})[b]=!0,i.get=function(){return s},i.set=function(a){if(this===r)s=y(a,o);else{var i=e(this,t,n,o,a);Object.defineProperty(this,t,i)}},i.configurable=!0,i.enumerable=n,i}(e,r,o?o.enumerable:void 0,n,e[r]);Object.defineProperty(e,r,a)}}var m=r.$mobx||"$mobx",h=s("isMobXReactObserver"),O=s("isUnmounted"),g=s("skipRender"),w=s("isForcingUpdate");function j(e){var r=e.prototype;if(e[h]){var n=x(r);console.warn("The provided component class ("+n+") \n                has already been declared as an observer component.")}else e[h]=!0;if(r.componentWillReact)throw new Error("The componentWillReact life-cycle event is no longer supported");if(e.__proto__!==t.PureComponent)if(r.shouldComponentUpdate){if(r.shouldComponentUpdate!==R)throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.")}else r.shouldComponentUpdate=R;S(r,"props"),S(r,"state");var a=r.render;return r.render=function(){return P.call(this,a)},v(r,"componentWillUnmount",(function(){var e;if(!0!==o.isUsingStaticRendering()&&(null===(e=this.render[m])||void 0===e||e.dispose(),this[O]=!0,!this.render[m])){var r=x(this);console.warn("The reactive render of an observer class component ("+r+") \n                was overriden after MobX attached. This may result in a memory leak if the \n                overriden reactive render was not properly disposed.")}})),e}function x(e){return e.displayName||e.name||e.constructor&&(e.constructor.displayName||e.constructor.name)||"<component>"}function P(e){var n=this;if(!0===o.isUsingStaticRendering())return e.call(this);l(this,g,!1),l(this,w,!1);var a=x(this),i=e.bind(this),s=!1,c=new r.Reaction(a+".render()",(function(){if(!s&&(s=!0,!0!==n[O])){var e=!0;try{l(n,w,!0),n[g]||t.Component.prototype.forceUpdate.call(n),e=!1}finally{l(n,w,!1),e&&c.dispose()}}}));function u(){s=!1;var e=void 0,t=void 0;if(c.track((function(){try{t=r._allowStateChanges(!1,i)}catch(r){e=r}})),e)throw e;return t}return c.reactComponent=this,u[m]=c,this.render=u,u.call(this)}function R(e,r){return o.isUsingStaticRendering()&&console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side."),this.state!==r||!c(this.props,e)}function S(e,t){var n=s("reactProp_"+t+"_valueHolder"),o=s("reactProp_"+t+"_atomHolder");function a(){return this[o]||l(this,o,r.createAtom("reactive "+t)),this[o]}Object.defineProperty(e,t,{configurable:!0,enumerable:!0,get:function(){var e=!1;return r._allowStateReadsStart&&r._allowStateReadsEnd&&(e=r._allowStateReadsStart(!0)),a.call(this).reportObserved(),r._allowStateReadsStart&&r._allowStateReadsEnd&&r._allowStateReadsEnd(e),this[n]},set:function(e){this[w]||c(this[n],e)?l(this,n,e):(l(this,n,e),l(this,g,!0),a.call(this).reportChanged(),l(this,g,!1))}})}var C="function"==typeof Symbol&&Symbol.for,E=C?Symbol.for("react.forward_ref"):"function"==typeof t.forwardRef&&t.forwardRef((function(e){return null})).$$typeof,A=C?Symbol.for("react.memo"):"function"==typeof t.memo&&t.memo((function(e){return null})).$$typeof;function k(e){if(!0===e.isMobxInjector&&console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'"),A&&e.$$typeof===A)throw new Error("Mobx observer: You are trying to use 'observer' on a function component wrapped in either another observer or 'React.memo'. The observer already applies 'React.memo' for you.");if(E&&e.$$typeof===E){var r=e.render;if("function"!=typeof r)throw new Error("render property of ForwardRef was not a function");return t.forwardRef((function(){var e=arguments;return t.createElement(o.Observer,null,(function(){return r.apply(void 0,e)}))}))}return"function"!=typeof e||e.prototype&&e.prototype.render||e.isReactClass||Object.prototype.isPrototypeOf.call(t.Component,e)?j(e):o.observer(e)}function U(){return(U=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])}return e}).apply(this,arguments)}var _=n.createContext({});function M(e){var r=e.children,t=function(e,r){if(null==e)return{};var t,n,o={},a=Object.keys(e);for(n=0;n<a.length;n++)r.indexOf(t=a[n])>=0||(o[t]=e[t]);return o}(e,["children"]),o=n.useContext(_),a=n.useRef(U({},o,t));return n.createElement(_.Provider,{value:a.current},r)}function T(e,r,t,o){var a,i,s,c=n.forwardRef((function(t,o){var a=U({},t),i=n.useContext(_);return Object.assign(a,e(i||{},a)||{}),o&&(a.ref=o),n.createElement(r,a)}));return o&&(c=k(c)),c.isMobxInjector=!0,a=r,i=c,s=Object.getOwnPropertyNames(Object.getPrototypeOf(a)),Object.getOwnPropertyNames(a).forEach((function(e){f[e]||-1!==s.indexOf(e)||Object.defineProperty(i,e,Object.getOwnPropertyDescriptor(a,e))})),c.wrappedComponent=r,c.displayName=function(e,r){var t=e.displayName||e.name||e.constructor&&e.constructor.name||"Component";return r?"inject-with-"+r+"("+t+")":"inject("+t+")"}(r,t),c}function $(e){return function(r,t){return e.forEach((function(e){if(!(e in t)){if(!(e in r))throw new Error("MobX injector: Store '"+e+"' is not available! Make sure it is provided by some Provider");t[e]=r[e]}})),t}}M.displayName="MobXProvider";var q=s("disposeOnUnmountProto"),D=s("disposeOnUnmountInst");function N(){var e=this;[].concat(this[q]||[],this[D]||[]).forEach((function(r){var t="string"==typeof r?e[r]:r;null!=t&&(Array.isArray(t)?t.map((function(e){return e()})):t())}))}function I(e){function t(t,n,o,a,i,s){for(var c=arguments.length,u=new Array(c>6?c-6:0),f=6;f<c;f++)u[f-6]=arguments[f];return r.untracked((function(){return a=a||"<<anonymous>>",s=s||o,null==n[o]?t?new Error("The "+i+" `"+s+"` is marked as required in `"+a+"`, but its value is `"+(null===n[o]?"null":"undefined")+"`."):null:e.apply(void 0,[n,o,a,i,s].concat(u))}))}var n=t.bind(null,!1);return n.isRequired=t.bind(null,!0),n}function X(e){var r=typeof e;return Array.isArray(e)?"array":e instanceof RegExp?"object":function(e,r){return"symbol"===e||"Symbol"===r["@@toStringTag"]||"function"==typeof Symbol&&r instanceof Symbol}(r,e)?"symbol":r}function F(e,t){return I((function(n,o,a,i,s){return r.untracked((function(){if(e&&X(n[o])===t.toLowerCase())return null;var i;switch(t){case"Array":i=r.isObservableArray;break;case"Object":i=r.isObservableObject;break;case"Map":i=r.isObservableMap;break;default:throw new Error("Unexpected mobxType: "+t)}var c=n[o];if(!i(c)){var u=function(e){var r=X(e);if("object"===r){if(e instanceof Date)return"date";if(e instanceof RegExp)return"regexp"}return r}(c),f=e?" or javascript `"+t.toLowerCase()+"`":"";return new Error("Invalid prop `"+s+"` of type `"+u+"` supplied to `"+a+"`, expected `mobx.Observable"+t+"`"+f+".")}return null}))}))}function L(e,t){return I((function(n,o,a,i,s){for(var c=arguments.length,u=new Array(c>5?c-5:0),f=5;f<c;f++)u[f-5]=arguments[f];return r.untracked((function(){if("function"!=typeof t)return new Error("Property `"+s+"` of component `"+a+"` has invalid PropType notation.");var r=F(e,"Array")(n,o,a,i,s);if(r instanceof Error)return r;for(var c=n[o],f=0;f<c.length;f++)if((r=t.apply(void 0,[c,f,a,i,s+"["+f+"]"].concat(u)))instanceof Error)return r;return null}))}))}var W={observableArray:F(!1,"Array"),observableArrayOf:L.bind(null,!1),observableMap:F(!1,"Map"),observableObject:F(!1,"Object"),arrayOrObservableArray:F(!0,"Array"),arrayOrObservableArrayOf:L.bind(null,!0),objectOrObservableObject:F(!0,"Object")};if(!t.Component)throw new Error("mobx-react requires React to be available");if(!r.observable)throw new Error("mobx-react requires mobx to be available");Object.defineProperty(exports,"Observer",{enumerable:!0,get:function(){return o.Observer}}),Object.defineProperty(exports,"isUsingStaticRendering",{enumerable:!0,get:function(){return o.isUsingStaticRendering}}),Object.defineProperty(exports,"observerBatching",{enumerable:!0,get:function(){return o.observerBatching}}),Object.defineProperty(exports,"useAsObservableSource",{enumerable:!0,get:function(){return o.useAsObservableSource}}),Object.defineProperty(exports,"useLocalStore",{enumerable:!0,get:function(){return o.useLocalStore}}),Object.defineProperty(exports,"useObserver",{enumerable:!0,get:function(){return o.useObserver}}),Object.defineProperty(exports,"useStaticRendering",{enumerable:!0,get:function(){return o.useStaticRendering}}),exports.MobXProviderContext=_,exports.PropTypes=W,exports.Provider=M,exports.disposeOnUnmount=function e(r,t){if(Array.isArray(t))return t.map((function(t){return e(r,t)}));var o=Object.getPrototypeOf(r).constructor,a=Object.getPrototypeOf(r.constructor),i=Object.getPrototypeOf(Object.getPrototypeOf(r));if(o!==n.Component&&o!==n.PureComponent&&a!==n.Component&&a!==n.PureComponent&&i!==n.Component&&i!==n.PureComponent)throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");if("string"!=typeof t&&"function"!=typeof t&&!Array.isArray(t))throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");var s=!!r[q]||!!r[D];return("string"==typeof t?r[q]||(r[q]=[]):r[D]||(r[D]=[])).push(t),s||v(r,"componentWillUnmount",N),"string"!=typeof t?t:void 0},exports.inject=function(){for(var e=arguments.length,r=new Array(e),t=0;t<e;t++)r[t]=arguments[t];if("function"==typeof arguments[0]){var n=arguments[0];return function(e){return T(n,e,n.name,!0)}}return function(e){return T($(r),e,r.join("-"),!1)}},exports.observer=k;
	//# sourceMappingURL=mobxreact.cjs.production.min.js.map


/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {/** MobX - (c) Michel Weststrate 2015 - 2020 - MIT Licensed */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var OBFUSCATED_ERROR = "An invariant failed, however the error is obfuscated because this is a production build.";
	var EMPTY_ARRAY = [];
	Object.freeze(EMPTY_ARRAY);
	var EMPTY_OBJECT = {};
	Object.freeze(EMPTY_OBJECT);
	function getNextId() {
	    return ++globalState.mobxGuid;
	}
	function fail(message) {
	    invariant(false, message);
	    throw "X"; // unreachable
	}
	function invariant(check, message) {
	    if (!check)
	        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR));
	}
	/**
	 * Prints a deprecation message, but only one time.
	 * Returns false if the deprecated message was already printed before
	 */
	var deprecatedMessages = [];
	function deprecated(msg, thing) {
	    if (thing) {
	        return deprecated("'" + msg + "', use '" + thing + "' instead.");
	    }
	    if (deprecatedMessages.indexOf(msg) !== -1)
	        return false;
	    deprecatedMessages.push(msg);
	    console.error("[mobx] Deprecated: " + msg);
	    return true;
	}
	/**
	 * Makes sure that the provided function is invoked at most once.
	 */
	function once(func) {
	    var invoked = false;
	    return function () {
	        if (invoked)
	            return;
	        invoked = true;
	        return func.apply(this, arguments);
	    };
	}
	var noop = function () { };
	function unique(list) {
	    var res = [];
	    list.forEach(function (item) {
	        if (res.indexOf(item) === -1)
	            res.push(item);
	    });
	    return res;
	}
	function isObject(value) {
	    return value !== null && typeof value === "object";
	}
	function isPlainObject(value) {
	    if (value === null || typeof value !== "object")
	        return false;
	    var proto = Object.getPrototypeOf(value);
	    return proto === Object.prototype || proto === null;
	}
	function convertToMap(dataStructure) {
	    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) {
	        return dataStructure;
	    }
	    else if (Array.isArray(dataStructure)) {
	        return new Map(dataStructure);
	    }
	    else if (isPlainObject(dataStructure)) {
	        var map = new Map();
	        for (var key in dataStructure) {
	            map.set(key, dataStructure[key]);
	        }
	        return map;
	    }
	    else {
	        return fail("Cannot convert to map from '" + dataStructure + "'");
	    }
	}
	function addHiddenProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: true,
	        configurable: true,
	        value: value
	    });
	}
	function addHiddenFinalProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: false,
	        configurable: true,
	        value: value
	    });
	}
	function isPropertyConfigurable(object, prop) {
	    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
	    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
	}
	function assertPropertyConfigurable(object, prop) {
	    if ( !isPropertyConfigurable(object, prop))
	        fail("Cannot make property '" + prop.toString() + "' observable, it is not configurable and writable in the target object");
	}
	function createInstanceofPredicate(name, clazz) {
	    var propName = "isMobX" + name;
	    clazz.prototype[propName] = true;
	    return function (x) {
	        return isObject(x) && x[propName] === true;
	    };
	}
	/**
	 * Returns whether the argument is an array, disregarding observability.
	 */
	function isArrayLike(x) {
	    return Array.isArray(x) || isObservableArray(x);
	}
	function isES6Map(thing) {
	    return thing instanceof Map;
	}
	function isES6Set(thing) {
	    return thing instanceof Set;
	}
	/**
	 * Returns the following: own keys, prototype keys & own symbol keys, if they are enumerable.
	 */
	function getPlainObjectKeys(object) {
	    var enumerables = new Set();
	    for (var key in object)
	        enumerables.add(key); // *all* enumerables
	    Object.getOwnPropertySymbols(object).forEach(function (k) {
	        if (Object.getOwnPropertyDescriptor(object, k).enumerable)
	            enumerables.add(k);
	    }); // *own* symbols
	    // Note: this implementation is missing enumerable, inherited, symbolic property names! That would however pretty expensive to add,
	    // as there is no efficient iterator that returns *all* properties
	    return Array.from(enumerables);
	}
	function stringifyKey(key) {
	    if (key && key.toString)
	        return key.toString();
	    else
	        return new String(key).toString();
	}
	function toPrimitive(value) {
	    return value === null ? null : typeof value === "object" ? "" + value : value;
	}
	var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys
	    ? Reflect.ownKeys
	    : Object.getOwnPropertySymbols
	        ? function (obj) { return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj)); }
	        : /* istanbul ignore next */ Object.getOwnPropertyNames;
	
	var $mobx = Symbol("mobx administration");
	var Atom = /** @class */ (function () {
	    /**
	     * Create a new atom. For debugging purposes it is recommended to give it a name.
	     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
	     */
	    function Atom(name) {
	        if (name === void 0) { name = "Atom@" + getNextId(); }
	        this.name = name;
	        this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
	        this.isBeingObserved = false;
	        this.observers = new Set();
	        this.diffValue = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.NOT_TRACKING;
	    }
	    Atom.prototype.onBecomeObserved = function () {
	        if (this.onBecomeObservedListeners) {
	            this.onBecomeObservedListeners.forEach(function (listener) { return listener(); });
	        }
	    };
	    Atom.prototype.onBecomeUnobserved = function () {
	        if (this.onBecomeUnobservedListeners) {
	            this.onBecomeUnobservedListeners.forEach(function (listener) { return listener(); });
	        }
	    };
	    /**
	     * Invoke this method to notify mobx that your atom has been used somehow.
	     * Returns true if there is currently a reactive context.
	     */
	    Atom.prototype.reportObserved = function () {
	        return reportObserved(this);
	    };
	    /**
	     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
	     */
	    Atom.prototype.reportChanged = function () {
	        startBatch();
	        propagateChanged(this);
	        endBatch();
	    };
	    Atom.prototype.toString = function () {
	        return this.name;
	    };
	    return Atom;
	}());
	var isAtom = createInstanceofPredicate("Atom", Atom);
	function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
	    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
	    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
	    var atom = new Atom(name);
	    // default `noop` listener will not initialize the hook Set
	    if (onBecomeObservedHandler !== noop) {
	        onBecomeObserved(atom, onBecomeObservedHandler);
	    }
	    if (onBecomeUnobservedHandler !== noop) {
	        onBecomeUnobserved(atom, onBecomeUnobservedHandler);
	    }
	    return atom;
	}
	
	function identityComparer(a, b) {
	    return a === b;
	}
	function structuralComparer(a, b) {
	    return deepEqual(a, b);
	}
	function shallowComparer(a, b) {
	    return deepEqual(a, b, 1);
	}
	function defaultComparer(a, b) {
	    return Object.is(a, b);
	}
	var comparer = {
	    identity: identityComparer,
	    structural: structuralComparer,
	    default: defaultComparer,
	    shallow: shallowComparer
	};
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = function(d, b) {
	    extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return extendStatics(d, b);
	};
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function __values(o) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
	    if (m) return m.call(o);
	    return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	}
	
	function __read(o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	}
	
	function __spread() {
	    for (var ar = [], i = 0; i < arguments.length; i++)
	        ar = ar.concat(__read(arguments[i]));
	    return ar;
	}
	
	var mobxDidRunLazyInitializersSymbol = Symbol("mobx did run lazy initializers");
	var mobxPendingDecorators = Symbol("mobx pending decorators");
	var enumerableDescriptorCache = {};
	var nonEnumerableDescriptorCache = {};
	function createPropertyInitializerDescriptor(prop, enumerable) {
	    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
	    return (cache[prop] ||
	        (cache[prop] = {
	            configurable: true,
	            enumerable: enumerable,
	            get: function () {
	                initializeInstance(this);
	                return this[prop];
	            },
	            set: function (value) {
	                initializeInstance(this);
	                this[prop] = value;
	            }
	        }));
	}
	function initializeInstance(target) {
	    var e_1, _a;
	    if (target[mobxDidRunLazyInitializersSymbol] === true)
	        return;
	    var decorators = target[mobxPendingDecorators];
	    if (decorators) {
	        addHiddenProp(target, mobxDidRunLazyInitializersSymbol, true);
	        // Build property key array from both strings and symbols
	        var keys = __spread(Object.getOwnPropertySymbols(decorators), Object.keys(decorators));
	        try {
	            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
	                var key = keys_1_1.value;
	                var d = decorators[key];
	                d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    }
	}
	function createPropDecorator(propertyInitiallyEnumerable, propertyCreator) {
	    return function decoratorFactory() {
	        var decoratorArguments;
	        var decorator = function decorate(target, prop, descriptor, applyImmediately
	        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
	        // as the instance to apply the decorator to equals the target
	        ) {
	            if (applyImmediately === true) {
	                propertyCreator(target, prop, descriptor, target, decoratorArguments);
	                return null;
	            }
	            if ( !quacksLikeADecorator(arguments))
	                fail("This function is a decorator, but it wasn't invoked like a decorator");
	            if (!Object.prototype.hasOwnProperty.call(target, mobxPendingDecorators)) {
	                var inheritedDecorators = target[mobxPendingDecorators];
	                addHiddenProp(target, mobxPendingDecorators, __assign({}, inheritedDecorators));
	            }
	            target[mobxPendingDecorators][prop] = {
	                prop: prop,
	                propertyCreator: propertyCreator,
	                descriptor: descriptor,
	                decoratorTarget: target,
	                decoratorArguments: decoratorArguments
	            };
	            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
	        };
	        if (quacksLikeADecorator(arguments)) {
	            // @decorator
	            decoratorArguments = EMPTY_ARRAY;
	            return decorator.apply(null, arguments);
	        }
	        else {
	            // @decorator(args)
	            decoratorArguments = Array.prototype.slice.call(arguments);
	            return decorator;
	        }
	    };
	}
	function quacksLikeADecorator(args) {
	    return (((args.length === 2 || args.length === 3) &&
	        (typeof args[1] === "string" || typeof args[1] === "symbol")) ||
	        (args.length === 4 && args[3] === true));
	}
	
	function deepEnhancer(v, _, name) {
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    if (Array.isArray(v))
	        return observable.array(v, { name: name });
	    if (isPlainObject(v))
	        return observable.object(v, undefined, { name: name });
	    if (isES6Map(v))
	        return observable.map(v, { name: name });
	    if (isES6Set(v))
	        return observable.set(v, { name: name });
	    return v;
	}
	function shallowEnhancer(v, _, name) {
	    if (v === undefined || v === null)
	        return v;
	    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v))
	        return v;
	    if (Array.isArray(v))
	        return observable.array(v, { name: name, deep: false });
	    if (isPlainObject(v))
	        return observable.object(v, undefined, { name: name, deep: false });
	    if (isES6Map(v))
	        return observable.map(v, { name: name, deep: false });
	    if (isES6Set(v))
	        return observable.set(v, { name: name, deep: false });
	    return fail(
	        "The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
	}
	function referenceEnhancer(newValue) {
	    // never turn into an observable
	    return newValue;
	}
	function refStructEnhancer(v, oldValue, name) {
	    if ( isObservable(v))
	        throw "observable.struct should not be used with observable values";
	    if (deepEqual(v, oldValue))
	        return oldValue;
	    return v;
	}
	
	function createDecoratorForEnhancer(enhancer) {
	    invariant(enhancer);
	    var decorator = createPropDecorator(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
	        {
	            invariant(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + stringifyKey(propertyName) + "\"), use @computed instead.");
	        }
	        var initialValue = descriptor
	            ? descriptor.initializer
	                ? descriptor.initializer.call(target)
	                : descriptor.value
	            : undefined;
	        asObservableObject(target).addObservableProp(propertyName, initialValue, enhancer);
	    });
	    var res = 
	    // Extra process checks, as this happens during module initialization
	    typeof process !== "undefined" && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ENVIRONMENT":"production","REACT_APP_REVISION":"a5bbd8d"}) && "development" !== "production"
	        ? function observableDecorator() {
	            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
	            // and simply return the created prop decorator
	            if (arguments.length < 2)
	                return fail("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
	            return decorator.apply(null, arguments);
	        }
	        : decorator;
	    res.enhancer = enhancer;
	    return res;
	}
	
	// Predefined bags of create observable options, to avoid allocating temporarily option objects
	// in the majority of cases
	var defaultCreateObservableOptions = {
	    deep: true,
	    name: undefined,
	    defaultDecorator: undefined,
	    proxy: true
	};
	Object.freeze(defaultCreateObservableOptions);
	function assertValidOption(key) {
	    if (!/^(deep|name|equals|defaultDecorator|proxy)$/.test(key))
	        fail("invalid option for (extend)observable: " + key);
	}
	function asCreateObservableOptions(thing) {
	    if (thing === null || thing === undefined)
	        return defaultCreateObservableOptions;
	    if (typeof thing === "string")
	        return { name: thing, deep: true, proxy: true };
	    {
	        if (typeof thing !== "object")
	            return fail("expected options object");
	        Object.keys(thing).forEach(assertValidOption);
	    }
	    return thing;
	}
	var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
	var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
	var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
	var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
	function getEnhancerFromOptions(options) {
	    return options.defaultDecorator
	        ? options.defaultDecorator.enhancer
	        : options.deep === false
	            ? referenceEnhancer
	            : deepEnhancer;
	}
	/**
	 * Turns an object, array or function into a reactive structure.
	 * @param v the value which should become observable.
	 */
	function createObservable(v, arg2, arg3) {
	    // @observable someProp;
	    if (typeof arguments[1] === "string" || typeof arguments[1] === "symbol") {
	        return deepDecorator.apply(null, arguments);
	    }
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    var res = isPlainObject(v)
	        ? observable.object(v, arg2, arg3)
	        : Array.isArray(v)
	            ? observable.array(v, arg2)
	            : isES6Map(v)
	                ? observable.map(v, arg2)
	                : isES6Set(v)
	                    ? observable.set(v, arg2)
	                    : v;
	    // this value could be converted to a new observable data structure, return it
	    if (res !== v)
	        return res;
	    // otherwise, just box it
	    fail(
	        "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
	}
	var observableFactories = {
	    box: function (value, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("box");
	        var o = asCreateObservableOptions(options);
	        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
	    },
	    array: function (initialValues, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("array");
	        var o = asCreateObservableOptions(options);
	        return createObservableArray(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    map: function (initialValues, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("map");
	        var o = asCreateObservableOptions(options);
	        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    set: function (initialValues, options) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("set");
	        var o = asCreateObservableOptions(options);
	        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
	    },
	    object: function (props, decorators, options) {
	        if (typeof arguments[1] === "string")
	            incorrectlyUsedAsDecorator("object");
	        var o = asCreateObservableOptions(options);
	        if (o.proxy === false) {
	            return extendObservable({}, props, decorators, o);
	        }
	        else {
	            var defaultDecorator = getDefaultDecoratorFromObjectOptions(o);
	            var base = extendObservable({}, undefined, undefined, o);
	            var proxy = createDynamicObservableObject(base);
	            extendObservableObjectWithProperties(proxy, props, decorators, defaultDecorator);
	            return proxy;
	        }
	    },
	    ref: refDecorator,
	    shallow: shallowDecorator,
	    deep: deepDecorator,
	    struct: refStructDecorator
	};
	var observable = createObservable;
	// weird trick to keep our typings nicely with our funcs, and still extend the observable function
	Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
	function incorrectlyUsedAsDecorator(methodName) {
	    fail(
	    // "development" !== "production" &&
	    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
	}
	
	var computedDecorator = createPropDecorator(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
	    {
	        invariant(descriptor && descriptor.get, "Trying to declare a computed value for unspecified getter '" + stringifyKey(propertyName) + "'");
	    }
	    var get = descriptor.get, set = descriptor.set; // initialValue is the descriptor for get / set props
	    // Optimization: faster on decorator target or instance? Assuming target
	    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
	    // Forcing instance now, fixes hot reloadig issues on React Native:
	    var options = decoratorArgs[0] || {};
	    asObservableObject(instance).addComputedProp(instance, propertyName, __assign({ get: get,
	        set: set, context: instance }, options));
	});
	var computedStructDecorator = computedDecorator({ equals: comparer.structural });
	/**
	 * Decorator for class properties: @computed get value() { return expr; }.
	 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
	 */
	var computed = function computed(arg1, arg2, arg3) {
	    if (typeof arg2 === "string") {
	        // @computed
	        return computedDecorator.apply(null, arguments);
	    }
	    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
	        // @computed({ options })
	        return computedDecorator.apply(null, arguments);
	    }
	    // computed(expr, options?)
	    {
	        invariant(typeof arg1 === "function", "First argument to `computed` should be an expression.");
	        invariant(arguments.length < 3, "Computed takes one or two arguments if used as function");
	    }
	    var opts = typeof arg2 === "object" ? arg2 : {};
	    opts.get = arg1;
	    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
	    opts.name = opts.name || arg1.name || ""; /* for generated name */
	    return new ComputedValue(opts);
	};
	computed.struct = computedStructDecorator;
	
	(function (IDerivationState) {
	    // before being run or (outside batch and not being observed)
	    // at this point derivation is not holding any data about dependency tree
	    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
	    // no shallow dependency changed since last computation
	    // won't recalculate derivation
	    // this is what makes mobx fast
	    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
	    // some deep dependency changed, but don't know if shallow dependency changed
	    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
	    // currently only ComputedValue will propagate POSSIBLY_STALE
	    //
	    // having this state is second big optimization:
	    // don't have to recompute on every dependency change, but only when it's needed
	    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
	    // A shallow dependency has changed since last computation and the derivation
	    // will need to recompute when it's needed next.
	    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
	})(exports.IDerivationState || (exports.IDerivationState = {}));
	var TraceMode;
	(function (TraceMode) {
	    TraceMode[TraceMode["NONE"] = 0] = "NONE";
	    TraceMode[TraceMode["LOG"] = 1] = "LOG";
	    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
	})(TraceMode || (TraceMode = {}));
	var CaughtException = /** @class */ (function () {
	    function CaughtException(cause) {
	        this.cause = cause;
	        // Empty
	    }
	    return CaughtException;
	}());
	function isCaughtException(e) {
	    return e instanceof CaughtException;
	}
	/**
	 * Finds out whether any dependency of the derivation has actually changed.
	 * If dependenciesState is 1 then it will recalculate dependencies,
	 * if any dependency changed it will propagate it by changing dependenciesState to 2.
	 *
	 * By iterating over the dependencies in the same order that they were reported and
	 * stopping on the first change, all the recalculations are only called for ComputedValues
	 * that will be tracked by derivation. That is because we assume that if the first x
	 * dependencies of the derivation doesn't change then the derivation should run the same way
	 * up until accessing x-th dependency.
	 */
	function shouldCompute(derivation) {
	    switch (derivation.dependenciesState) {
	        case exports.IDerivationState.UP_TO_DATE:
	            return false;
	        case exports.IDerivationState.NOT_TRACKING:
	        case exports.IDerivationState.STALE:
	            return true;
	        case exports.IDerivationState.POSSIBLY_STALE: {
	            // state propagation can occur outside of action/reactive context #2195
	            var prevAllowStateReads = allowStateReadsStart(true);
	            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
	            var obs = derivation.observing, l = obs.length;
	            for (var i = 0; i < l; i++) {
	                var obj = obs[i];
	                if (isComputedValue(obj)) {
	                    if (globalState.disableErrorBoundaries) {
	                        obj.get();
	                    }
	                    else {
	                        try {
	                            obj.get();
	                        }
	                        catch (e) {
	                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
	                            untrackedEnd(prevUntracked);
	                            allowStateReadsEnd(prevAllowStateReads);
	                            return true;
	                        }
	                    }
	                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
	                    // and `derivation` is an observer of `obj`
	                    // invariantShouldCompute(derivation)
	                    if (derivation.dependenciesState === exports.IDerivationState.STALE) {
	                        untrackedEnd(prevUntracked);
	                        allowStateReadsEnd(prevAllowStateReads);
	                        return true;
	                    }
	                }
	            }
	            changeDependenciesStateTo0(derivation);
	            untrackedEnd(prevUntracked);
	            allowStateReadsEnd(prevAllowStateReads);
	            return false;
	        }
	    }
	}
	// function invariantShouldCompute(derivation: IDerivation) {
	//     const newDepState = (derivation as any).dependenciesState
	//     if (
	//         "development" === "production" &&
	//         (newDepState === IDerivationState.POSSIBLY_STALE ||
	//             newDepState === IDerivationState.NOT_TRACKING)
	//     )
	//         fail("Illegal dependency state")
	// }
	function isComputingDerivation() {
	    return globalState.trackingDerivation !== null; // filter out actions inside computations
	}
	function checkIfStateModificationsAreAllowed(atom) {
	    var hasObservers = atom.observers.size > 0;
	    // Should never be possible to change an observed observable from inside computed, see #798
	    if (globalState.computationDepth > 0 && hasObservers)
	        fail(
	            "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
	    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
	    if (!globalState.allowStateChanges && (hasObservers || globalState.enforceActions === "strict"))
	        fail(
	            (globalState.enforceActions
	                ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: "
	                : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") +
	                atom.name);
	}
	function checkIfStateReadsAreAllowed(observable) {
	    if (
	        !globalState.allowStateReads &&
	        globalState.observableRequiresReaction) {
	        console.warn("[mobx] Observable " + observable.name + " being read outside a reactive context");
	    }
	}
	/**
	 * Executes the provided function `f` and tracks which observables are being accessed.
	 * The tracking information is stored on the `derivation` object and the derivation is registered
	 * as observer of any of the accessed observables.
	 */
	function trackDerivedFunction(derivation, f, context) {
	    var prevAllowStateReads = allowStateReadsStart(true);
	    // pre allocate array allocation + room for variation in deps
	    // array will be trimmed by bindDependencies
	    changeDependenciesStateTo0(derivation);
	    derivation.newObserving = new Array(derivation.observing.length + 100);
	    derivation.unboundDepsCount = 0;
	    derivation.runId = ++globalState.runId;
	    var prevTracking = globalState.trackingDerivation;
	    globalState.trackingDerivation = derivation;
	    var result;
	    if (globalState.disableErrorBoundaries === true) {
	        result = f.call(context);
	    }
	    else {
	        try {
	            result = f.call(context);
	        }
	        catch (e) {
	            result = new CaughtException(e);
	        }
	    }
	    globalState.trackingDerivation = prevTracking;
	    bindDependencies(derivation);
	    warnAboutDerivationWithoutDependencies(derivation);
	    allowStateReadsEnd(prevAllowStateReads);
	    return result;
	}
	function warnAboutDerivationWithoutDependencies(derivation) {
	    if (derivation.observing.length !== 0)
	        return;
	    if (globalState.reactionRequiresObservable || derivation.requiresObservable) {
	        console.warn("[mobx] Derivation " + derivation.name + " is created/updated without reading any observable value");
	    }
	}
	/**
	 * diffs newObserving with observing.
	 * update observing to be newObserving with unique observables
	 * notify observers that become observed/unobserved
	 */
	function bindDependencies(derivation) {
	    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
	    var prevObserving = derivation.observing;
	    var observing = (derivation.observing = derivation.newObserving);
	    var lowestNewObservingDerivationState = exports.IDerivationState.UP_TO_DATE;
	    // Go through all new observables and check diffValue: (this list can contain duplicates):
	    //   0: first occurrence, change to 1 and keep it
	    //   1: extra occurrence, drop it
	    var i0 = 0, l = derivation.unboundDepsCount;
	    for (var i = 0; i < l; i++) {
	        var dep = observing[i];
	        if (dep.diffValue === 0) {
	            dep.diffValue = 1;
	            if (i0 !== i)
	                observing[i0] = dep;
	            i0++;
	        }
	        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
	        // not hitting the condition
	        if (dep.dependenciesState > lowestNewObservingDerivationState) {
	            lowestNewObservingDerivationState = dep.dependenciesState;
	        }
	    }
	    observing.length = i0;
	    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
	    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
	    //   0: it's not in new observables, unobserve it
	    //   1: it keeps being observed, don't want to notify it. change to 0
	    l = prevObserving.length;
	    while (l--) {
	        var dep = prevObserving[l];
	        if (dep.diffValue === 0) {
	            removeObserver(dep, derivation);
	        }
	        dep.diffValue = 0;
	    }
	    // Go through all new observables and check diffValue: (now it should be unique)
	    //   0: it was set to 0 in last loop. don't need to do anything.
	    //   1: it wasn't observed, let's observe it. set back to 0
	    while (i0--) {
	        var dep = observing[i0];
	        if (dep.diffValue === 1) {
	            dep.diffValue = 0;
	            addObserver(dep, derivation);
	        }
	    }
	    // Some new observed derivations may become stale during this derivation computation
	    // so they have had no chance to propagate staleness (#916)
	    if (lowestNewObservingDerivationState !== exports.IDerivationState.UP_TO_DATE) {
	        derivation.dependenciesState = lowestNewObservingDerivationState;
	        derivation.onBecomeStale();
	    }
	}
	function clearObserving(derivation) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
	    var obs = derivation.observing;
	    derivation.observing = [];
	    var i = obs.length;
	    while (i--)
	        removeObserver(obs[i], derivation);
	    derivation.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	}
	function untracked(action) {
	    var prev = untrackedStart();
	    try {
	        return action();
	    }
	    finally {
	        untrackedEnd(prev);
	    }
	}
	function untrackedStart() {
	    var prev = globalState.trackingDerivation;
	    globalState.trackingDerivation = null;
	    return prev;
	}
	function untrackedEnd(prev) {
	    globalState.trackingDerivation = prev;
	}
	function allowStateReadsStart(allowStateReads) {
	    var prev = globalState.allowStateReads;
	    globalState.allowStateReads = allowStateReads;
	    return prev;
	}
	function allowStateReadsEnd(prev) {
	    globalState.allowStateReads = prev;
	}
	/**
	 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
	 *
	 */
	function changeDependenciesStateTo0(derivation) {
	    if (derivation.dependenciesState === exports.IDerivationState.UP_TO_DATE)
	        return;
	    derivation.dependenciesState = exports.IDerivationState.UP_TO_DATE;
	    var obs = derivation.observing;
	    var i = obs.length;
	    while (i--)
	        obs[i].lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	}
	
	// we don't use globalState for these in order to avoid possible issues with multiple
	// mobx versions
	var currentActionId = 0;
	var nextActionId = 1;
	var functionNameDescriptor = Object.getOwnPropertyDescriptor(function () { }, "name");
	var isFunctionNameConfigurable = functionNameDescriptor && functionNameDescriptor.configurable;
	function createAction(actionName, fn, ref) {
	    {
	        invariant(typeof fn === "function", "`action` can only be invoked on functions");
	        if (typeof actionName !== "string" || !actionName)
	            fail("actions should have valid names, got: '" + actionName + "'");
	    }
	    var res = function () {
	        return executeAction(actionName, fn, ref || this, arguments);
	    };
	    res.isMobxAction = true;
	    {
	        if (isFunctionNameConfigurable) {
	            Object.defineProperty(res, "name", { value: actionName });
	        }
	    }
	    return res;
	}
	function executeAction(actionName, fn, scope, args) {
	    var runInfo = _startAction(actionName, scope, args);
	    try {
	        return fn.apply(scope, args);
	    }
	    catch (err) {
	        runInfo.error = err;
	        throw err;
	    }
	    finally {
	        _endAction(runInfo);
	    }
	}
	function _startAction(actionName, scope, args) {
	    var notifySpy = isSpyEnabled() && !!actionName;
	    var startTime = 0;
	    if (notifySpy && "development" !== "production") {
	        startTime = Date.now();
	        var l = (args && args.length) || 0;
	        var flattendArgs = new Array(l);
	        if (l > 0)
	            for (var i = 0; i < l; i++)
	                flattendArgs[i] = args[i];
	        spyReportStart({
	            type: "action",
	            name: actionName,
	            object: scope,
	            arguments: flattendArgs
	        });
	    }
	    var prevDerivation = untrackedStart();
	    startBatch();
	    var prevAllowStateChanges = allowStateChangesStart(true);
	    var prevAllowStateReads = allowStateReadsStart(true);
	    var runInfo = {
	        prevDerivation: prevDerivation,
	        prevAllowStateChanges: prevAllowStateChanges,
	        prevAllowStateReads: prevAllowStateReads,
	        notifySpy: notifySpy,
	        startTime: startTime,
	        actionId: nextActionId++,
	        parentActionId: currentActionId
	    };
	    currentActionId = runInfo.actionId;
	    return runInfo;
	}
	function _endAction(runInfo) {
	    if (currentActionId !== runInfo.actionId) {
	        fail("invalid action stack. did you forget to finish an action?");
	    }
	    currentActionId = runInfo.parentActionId;
	    if (runInfo.error !== undefined) {
	        globalState.suppressReactionErrors = true;
	    }
	    allowStateChangesEnd(runInfo.prevAllowStateChanges);
	    allowStateReadsEnd(runInfo.prevAllowStateReads);
	    endBatch();
	    untrackedEnd(runInfo.prevDerivation);
	    if (runInfo.notifySpy && "development" !== "production") {
	        spyReportEnd({ time: Date.now() - runInfo.startTime });
	    }
	    globalState.suppressReactionErrors = false;
	}
	function allowStateChanges(allowStateChanges, func) {
	    var prev = allowStateChangesStart(allowStateChanges);
	    var res;
	    try {
	        res = func();
	    }
	    finally {
	        allowStateChangesEnd(prev);
	    }
	    return res;
	}
	function allowStateChangesStart(allowStateChanges) {
	    var prev = globalState.allowStateChanges;
	    globalState.allowStateChanges = allowStateChanges;
	    return prev;
	}
	function allowStateChangesEnd(prev) {
	    globalState.allowStateChanges = prev;
	}
	function allowStateChangesInsideComputed(func) {
	    var prev = globalState.computationDepth;
	    globalState.computationDepth = 0;
	    var res;
	    try {
	        res = func();
	    }
	    finally {
	        globalState.computationDepth = prev;
	    }
	    return res;
	}
	
	var ObservableValue = /** @class */ (function (_super) {
	    __extends(ObservableValue, _super);
	    function ObservableValue(value, enhancer, name, notifySpy, equals) {
	        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
	        if (notifySpy === void 0) { notifySpy = true; }
	        if (equals === void 0) { equals = comparer.default; }
	        var _this = _super.call(this, name) || this;
	        _this.enhancer = enhancer;
	        _this.name = name;
	        _this.equals = equals;
	        _this.hasUnreportedChange = false;
	        _this.value = enhancer(value, undefined, name);
	        if (notifySpy && isSpyEnabled() && "development" !== "production") {
	            // only notify spy if this is a stand-alone observable
	            spyReport({ type: "create", name: _this.name, newValue: "" + _this.value });
	        }
	        return _this;
	    }
	    ObservableValue.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableValue.prototype.set = function (newValue) {
	        var oldValue = this.value;
	        newValue = this.prepareNewValue(newValue);
	        if (newValue !== globalState.UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            if (notifySpy && "development" !== "production") {
	                spyReportStart({
	                    type: "update",
	                    name: this.name,
	                    newValue: newValue,
	                    oldValue: oldValue
	                });
	            }
	            this.setNewValue(newValue);
	            if (notifySpy && "development" !== "production")
	                spyReportEnd();
	        }
	    };
	    ObservableValue.prototype.prepareNewValue = function (newValue) {
	        checkIfStateModificationsAreAllowed(this);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this,
	                type: "update",
	                newValue: newValue
	            });
	            if (!change)
	                return globalState.UNCHANGED;
	            newValue = change.newValue;
	        }
	        // apply modifier
	        newValue = this.enhancer(newValue, this.value, this.name);
	        return this.equals(this.value, newValue) ? globalState.UNCHANGED : newValue;
	    };
	    ObservableValue.prototype.setNewValue = function (newValue) {
	        var oldValue = this.value;
	        this.value = newValue;
	        this.reportChanged();
	        if (hasListeners(this)) {
	            notifyListeners(this, {
	                type: "update",
	                object: this,
	                newValue: newValue,
	                oldValue: oldValue
	            });
	        }
	    };
	    ObservableValue.prototype.get = function () {
	        this.reportObserved();
	        return this.dehanceValue(this.value);
	    };
	    ObservableValue.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableValue.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately)
	            listener({
	                object: this,
	                type: "update",
	                newValue: this.value,
	                oldValue: undefined
	            });
	        return registerListener(this, listener);
	    };
	    ObservableValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ObservableValue.prototype.toString = function () {
	        return this.name + "[" + this.value + "]";
	    };
	    ObservableValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    ObservableValue.prototype[Symbol.toPrimitive] = function () {
	        return this.valueOf();
	    };
	    return ObservableValue;
	}(Atom));
	var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);
	
	/**
	 * A node in the state dependency root that observes other nodes, and can be observed itself.
	 *
	 * ComputedValue will remember the result of the computation for the duration of the batch, or
	 * while being observed.
	 *
	 * During this time it will recompute only when one of its direct dependencies changed,
	 * but only when it is being accessed with `ComputedValue.get()`.
	 *
	 * Implementation description:
	 * 1. First time it's being accessed it will compute and remember result
	 *    give back remembered result until 2. happens
	 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
	 * 3. When it's being accessed, recompute if any shallow dependency changed.
	 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
	 *    go to step 2. either way
	 *
	 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
	 */
	var ComputedValue = /** @class */ (function () {
	    /**
	     * Create a new computed value based on a function expression.
	     *
	     * The `name` property is for debug purposes only.
	     *
	     * The `equals` property specifies the comparer function to use to determine if a newly produced
	     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
	     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
	     * Structural comparison can be convenient if you always produce a new aggregated object and
	     * don't want to notify observers if it is structurally the same.
	     * This is useful for working with vectors, mouse coordinates etc.
	     */
	    function ComputedValue(options) {
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = null; // during tracking it's an array with new observed observers
	        this.isBeingObserved = false;
	        this.isPendingUnobservation = false;
	        this.observers = new Set();
	        this.diffValue = 0;
	        this.runId = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.value = new CaughtException(null);
	        this.isComputing = false; // to check for cycles
	        this.isRunningSetter = false;
	        this.isTracing = TraceMode.NONE;
	        invariant(options.get, "missing option for computed: get");
	        this.derivation = options.get;
	        this.name = options.name || "ComputedValue@" + getNextId();
	        if (options.set)
	            this.setter = createAction(this.name + "-setter", options.set);
	        this.equals =
	            options.equals ||
	                (options.compareStructural || options.struct
	                    ? comparer.structural
	                    : comparer.default);
	        this.scope = options.context;
	        this.requiresReaction = !!options.requiresReaction;
	        this.keepAlive = !!options.keepAlive;
	    }
	    ComputedValue.prototype.onBecomeStale = function () {
	        propagateMaybeChanged(this);
	    };
	    ComputedValue.prototype.onBecomeObserved = function () {
	        if (this.onBecomeObservedListeners) {
	            this.onBecomeObservedListeners.forEach(function (listener) { return listener(); });
	        }
	    };
	    ComputedValue.prototype.onBecomeUnobserved = function () {
	        if (this.onBecomeUnobservedListeners) {
	            this.onBecomeUnobservedListeners.forEach(function (listener) { return listener(); });
	        }
	    };
	    /**
	     * Returns the current value of this computed value.
	     * Will evaluate its computation first if needed.
	     */
	    ComputedValue.prototype.get = function () {
	        if (this.isComputing)
	            fail("Cycle detected in computation " + this.name + ": " + this.derivation);
	        if (globalState.inBatch === 0 && this.observers.size === 0 && !this.keepAlive) {
	            if (shouldCompute(this)) {
	                this.warnAboutUntrackedRead();
	                startBatch(); // See perf test 'computed memoization'
	                this.value = this.computeValue(false);
	                endBatch();
	            }
	        }
	        else {
	            reportObserved(this);
	            if (shouldCompute(this))
	                if (this.trackAndCompute())
	                    propagateChangeConfirmed(this);
	        }
	        var result = this.value;
	        if (isCaughtException(result))
	            throw result.cause;
	        return result;
	    };
	    ComputedValue.prototype.peek = function () {
	        var res = this.computeValue(false);
	        if (isCaughtException(res))
	            throw res.cause;
	        return res;
	    };
	    ComputedValue.prototype.set = function (value) {
	        if (this.setter) {
	            invariant(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
	            this.isRunningSetter = true;
	            try {
	                this.setter.call(this.scope, value);
	            }
	            finally {
	                this.isRunningSetter = false;
	            }
	        }
	        else
	            invariant(false, 
	                "[ComputedValue '" + this.name + "'] It is not possible to assign a new value to a computed value.");
	    };
	    ComputedValue.prototype.trackAndCompute = function () {
	        if (isSpyEnabled() && "development" !== "production") {
	            spyReport({
	                object: this.scope,
	                type: "compute",
	                name: this.name
	            });
	        }
	        var oldValue = this.value;
	        var wasSuspended = 
	        /* see #1208 */ this.dependenciesState === exports.IDerivationState.NOT_TRACKING;
	        var newValue = this.computeValue(true);
	        var changed = wasSuspended ||
	            isCaughtException(oldValue) ||
	            isCaughtException(newValue) ||
	            !this.equals(oldValue, newValue);
	        if (changed) {
	            this.value = newValue;
	        }
	        return changed;
	    };
	    ComputedValue.prototype.computeValue = function (track) {
	        this.isComputing = true;
	        globalState.computationDepth++;
	        var res;
	        if (track) {
	            res = trackDerivedFunction(this, this.derivation, this.scope);
	        }
	        else {
	            if (globalState.disableErrorBoundaries === true) {
	                res = this.derivation.call(this.scope);
	            }
	            else {
	                try {
	                    res = this.derivation.call(this.scope);
	                }
	                catch (e) {
	                    res = new CaughtException(e);
	                }
	            }
	        }
	        globalState.computationDepth--;
	        this.isComputing = false;
	        return res;
	    };
	    ComputedValue.prototype.suspend = function () {
	        if (!this.keepAlive) {
	            clearObserving(this);
	            this.value = undefined; // don't hold on to computed value!
	        }
	    };
	    ComputedValue.prototype.observe = function (listener, fireImmediately) {
	        var _this = this;
	        var firstTime = true;
	        var prevValue = undefined;
	        return autorun(function () {
	            var newValue = _this.get();
	            if (!firstTime || fireImmediately) {
	                var prevU = untrackedStart();
	                listener({
	                    type: "update",
	                    object: _this,
	                    newValue: newValue,
	                    oldValue: prevValue
	                });
	                untrackedEnd(prevU);
	            }
	            firstTime = false;
	            prevValue = newValue;
	        });
	    };
	    ComputedValue.prototype.warnAboutUntrackedRead = function () {
	        if (this.requiresReaction === true) {
	            fail("[mobx] Computed value " + this.name + " is read outside a reactive context");
	        }
	        if (this.isTracing !== TraceMode.NONE) {
	            console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
	        }
	        if (globalState.computedRequiresReaction) {
	            console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
	        }
	    };
	    ComputedValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ComputedValue.prototype.toString = function () {
	        return this.name + "[" + this.derivation.toString() + "]";
	    };
	    ComputedValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    ComputedValue.prototype[Symbol.toPrimitive] = function () {
	        return this.valueOf();
	    };
	    return ComputedValue;
	}());
	var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);
	
	/**
	 * These values will persist if global state is reset
	 */
	var persistentKeys = [
	    "mobxGuid",
	    "spyListeners",
	    "enforceActions",
	    "computedRequiresReaction",
	    "reactionRequiresObservable",
	    "observableRequiresReaction",
	    "allowStateReads",
	    "disableErrorBoundaries",
	    "runId",
	    "UNCHANGED"
	];
	var MobXGlobals = /** @class */ (function () {
	    function MobXGlobals() {
	        /**
	         * MobXGlobals version.
	         * MobX compatiblity with other versions loaded in memory as long as this version matches.
	         * It indicates that the global state still stores similar information
	         *
	         * N.B: this version is unrelated to the package version of MobX, and is only the version of the
	         * internal state storage of MobX, and can be the same across many different package versions
	         */
	        this.version = 5;
	        /**
	         * globally unique token to signal unchanged
	         */
	        this.UNCHANGED = {};
	        /**
	         * Currently running derivation
	         */
	        this.trackingDerivation = null;
	        /**
	         * Are we running a computation currently? (not a reaction)
	         */
	        this.computationDepth = 0;
	        /**
	         * Each time a derivation is tracked, it is assigned a unique run-id
	         */
	        this.runId = 0;
	        /**
	         * 'guid' for general purpose. Will be persisted amongst resets.
	         */
	        this.mobxGuid = 0;
	        /**
	         * Are we in a batch block? (and how many of them)
	         */
	        this.inBatch = 0;
	        /**
	         * Observables that don't have observers anymore, and are about to be
	         * suspended, unless somebody else accesses it in the same batch
	         *
	         * @type {IObservable[]}
	         */
	        this.pendingUnobservations = [];
	        /**
	         * List of scheduled, not yet executed, reactions.
	         */
	        this.pendingReactions = [];
	        /**
	         * Are we currently processing reactions?
	         */
	        this.isRunningReactions = false;
	        /**
	         * Is it allowed to change observables at this point?
	         * In general, MobX doesn't allow that when running computations and React.render.
	         * To ensure that those functions stay pure.
	         */
	        this.allowStateChanges = true;
	        /**
	         * Is it allowed to read observables at this point?
	         * Used to hold the state needed for `observableRequiresReaction`
	         */
	        this.allowStateReads = true;
	        /**
	         * If strict mode is enabled, state changes are by default not allowed
	         */
	        this.enforceActions = false;
	        /**
	         * Spy callbacks
	         */
	        this.spyListeners = [];
	        /**
	         * Globally attached error handlers that react specifically to errors in reactions
	         */
	        this.globalReactionErrorHandlers = [];
	        /**
	         * Warn if computed values are accessed outside a reactive context
	         */
	        this.computedRequiresReaction = false;
	        /**
	         * (Experimental)
	         * Warn if you try to create to derivation / reactive context without accessing any observable.
	         */
	        this.reactionRequiresObservable = false;
	        /**
	         * (Experimental)
	         * Warn if observables are accessed outside a reactive context
	         */
	        this.observableRequiresReaction = false;
	        /**
	         * Allows overwriting of computed properties, useful in tests but not prod as it can cause
	         * memory leaks. See https://github.com/mobxjs/mobx/issues/1867
	         */
	        this.computedConfigurable = false;
	        /*
	         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
	         * the stack when an exception occurs while debugging.
	         */
	        this.disableErrorBoundaries = false;
	        /*
	         * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
	         * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
	         */
	        this.suppressReactionErrors = false;
	    }
	    return MobXGlobals;
	}());
	var mockGlobal = {};
	function getGlobal() {
	    if (typeof window !== "undefined") {
	        return window;
	    }
	    if (typeof global !== "undefined") {
	        return global;
	    }
	    if (typeof self !== "undefined") {
	        return self;
	    }
	    return mockGlobal;
	}
	var canMergeGlobalState = true;
	var isolateCalled = false;
	var globalState = (function () {
	    var global = getGlobal();
	    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals)
	        canMergeGlobalState = false;
	    if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals().version)
	        canMergeGlobalState = false;
	    if (!canMergeGlobalState) {
	        setTimeout(function () {
	            if (!isolateCalled) {
	                fail("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
	            }
	        }, 1);
	        return new MobXGlobals();
	    }
	    else if (global.__mobxGlobals) {
	        global.__mobxInstanceCount += 1;
	        if (!global.__mobxGlobals.UNCHANGED)
	            global.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
	        return global.__mobxGlobals;
	    }
	    else {
	        global.__mobxInstanceCount = 1;
	        return (global.__mobxGlobals = new MobXGlobals());
	    }
	})();
	function isolateGlobalState() {
	    if (globalState.pendingReactions.length ||
	        globalState.inBatch ||
	        globalState.isRunningReactions)
	        fail("isolateGlobalState should be called before MobX is running any reactions");
	    isolateCalled = true;
	    if (canMergeGlobalState) {
	        if (--getGlobal().__mobxInstanceCount === 0)
	            getGlobal().__mobxGlobals = undefined;
	        globalState = new MobXGlobals();
	    }
	}
	function getGlobalState() {
	    return globalState;
	}
	/**
	 * For testing purposes only; this will break the internal state of existing observables,
	 * but can be used to get back at a stable state after throwing errors
	 */
	function resetGlobalState() {
	    var defaultGlobals = new MobXGlobals();
	    for (var key in defaultGlobals)
	        if (persistentKeys.indexOf(key) === -1)
	            globalState[key] = defaultGlobals[key];
	    globalState.allowStateChanges = !globalState.enforceActions;
	}
	
	function hasObservers(observable) {
	    return observable.observers && observable.observers.size > 0;
	}
	function getObservers(observable) {
	    return observable.observers;
	}
	// function invariantObservers(observable: IObservable) {
	//     const list = observable.observers
	//     const map = observable.observersIndexes
	//     const l = list.length
	//     for (let i = 0; i < l; i++) {
	//         const id = list[i].__mapid
	//         if (i) {
	//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
	//         } else {
	//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
	//         }
	//     }
	//     invariant(
	//         list.length === 0 || Object.keys(map).length === list.length - 1,
	//         "INTERNAL ERROR there is no junk in map"
	//     )
	// }
	function addObserver(observable, node) {
	    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
	    // invariantObservers(observable);
	    observable.observers.add(node);
	    if (observable.lowestObserverState > node.dependenciesState)
	        observable.lowestObserverState = node.dependenciesState;
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
	}
	function removeObserver(observable, node) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
	    // invariantObservers(observable);
	    observable.observers.delete(node);
	    if (observable.observers.size === 0) {
	        // deleting last observer
	        queueForUnobservation(observable);
	    }
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
	}
	function queueForUnobservation(observable) {
	    if (observable.isPendingUnobservation === false) {
	        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
	        observable.isPendingUnobservation = true;
	        globalState.pendingUnobservations.push(observable);
	    }
	}
	/**
	 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
	 * During a batch `onBecomeUnobserved` will be called at most once per observable.
	 * Avoids unnecessary recalculations.
	 */
	function startBatch() {
	    globalState.inBatch++;
	}
	function endBatch() {
	    if (--globalState.inBatch === 0) {
	        runReactions();
	        // the batch is actually about to finish, all unobserving should happen here.
	        var list = globalState.pendingUnobservations;
	        for (var i = 0; i < list.length; i++) {
	            var observable = list[i];
	            observable.isPendingUnobservation = false;
	            if (observable.observers.size === 0) {
	                if (observable.isBeingObserved) {
	                    // if this observable had reactive observers, trigger the hooks
	                    observable.isBeingObserved = false;
	                    observable.onBecomeUnobserved();
	                }
	                if (observable instanceof ComputedValue) {
	                    // computed values are automatically teared down when the last observer leaves
	                    // this process happens recursively, this computed might be the last observable of another, etc..
	                    observable.suspend();
	                }
	            }
	        }
	        globalState.pendingUnobservations = [];
	    }
	}
	function reportObserved(observable) {
	    checkIfStateReadsAreAllowed(observable);
	    var derivation = globalState.trackingDerivation;
	    if (derivation !== null) {
	        /**
	         * Simple optimization, give each derivation run an unique id (runId)
	         * Check if last time this observable was accessed the same runId is used
	         * if this is the case, the relation is already known
	         */
	        if (derivation.runId !== observable.lastAccessedBy) {
	            observable.lastAccessedBy = derivation.runId;
	            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
	            derivation.newObserving[derivation.unboundDepsCount++] = observable;
	            if (!observable.isBeingObserved) {
	                observable.isBeingObserved = true;
	                observable.onBecomeObserved();
	            }
	        }
	        return true;
	    }
	    else if (observable.observers.size === 0 && globalState.inBatch > 0) {
	        queueForUnobservation(observable);
	    }
	    return false;
	}
	// function invariantLOS(observable: IObservable, msg: string) {
	//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
	//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
	//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
	//     throw new Error(
	//         "lowestObserverState is wrong for " +
	//             msg +
	//             " because " +
	//             min +
	//             " < " +
	//             observable.lowestObserverState
	//     )
	// }
	/**
	 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
	 * It will propagate changes to observers from previous run
	 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
	 * Hopefully self reruning autoruns aren't a feature people should depend on
	 * Also most basic use cases should be ok
	 */
	// Called by Atom when its value changes
	function propagateChanged(observable) {
	    // invariantLOS(observable, "changed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    // Ideally we use for..of here, but the downcompiled version is really slow...
	    observable.observers.forEach(function (d) {
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	        d.dependenciesState = exports.IDerivationState.STALE;
	    });
	    // invariantLOS(observable, "changed end");
	}
	// Called by ComputedValue when it recalculate and its value changed
	function propagateChangeConfirmed(observable) {
	    // invariantLOS(observable, "confirmed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    observable.observers.forEach(function (d) {
	        if (d.dependenciesState === exports.IDerivationState.POSSIBLY_STALE)
	            d.dependenciesState = exports.IDerivationState.STALE;
	        else if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
	        )
	            observable.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	    });
	    // invariantLOS(observable, "confirmed end");
	}
	// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
	function propagateMaybeChanged(observable) {
	    // invariantLOS(observable, "maybe start");
	    if (observable.lowestObserverState !== exports.IDerivationState.UP_TO_DATE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.POSSIBLY_STALE;
	    observable.observers.forEach(function (d) {
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            d.dependenciesState = exports.IDerivationState.POSSIBLY_STALE;
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	    });
	    // invariantLOS(observable, "maybe end");
	}
	function logTraceInfo(derivation, observable) {
	    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
	    if (derivation.isTracing === TraceMode.BREAK) {
	        var lines = [];
	        printDepTree(getDependencyTree(derivation), lines, 1);
	        // prettier-ignore
	        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
	    }
	}
	function printDepTree(tree, lines, depth) {
	    if (lines.length >= 1000) {
	        lines.push("(and many more)");
	        return;
	    }
	    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
	    if (tree.dependencies)
	        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
	}
	
	var Reaction = /** @class */ (function () {
	    function Reaction(name, onInvalidate, errorHandler, requiresObservable) {
	        if (name === void 0) { name = "Reaction@" + getNextId(); }
	        if (requiresObservable === void 0) { requiresObservable = false; }
	        this.name = name;
	        this.onInvalidate = onInvalidate;
	        this.errorHandler = errorHandler;
	        this.requiresObservable = requiresObservable;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = [];
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.diffValue = 0;
	        this.runId = 0;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.isDisposed = false;
	        this._isScheduled = false;
	        this._isTrackPending = false;
	        this._isRunning = false;
	        this.isTracing = TraceMode.NONE;
	    }
	    Reaction.prototype.onBecomeStale = function () {
	        this.schedule();
	    };
	    Reaction.prototype.schedule = function () {
	        if (!this._isScheduled) {
	            this._isScheduled = true;
	            globalState.pendingReactions.push(this);
	            runReactions();
	        }
	    };
	    Reaction.prototype.isScheduled = function () {
	        return this._isScheduled;
	    };
	    /**
	     * internal, use schedule() if you intend to kick off a reaction
	     */
	    Reaction.prototype.runReaction = function () {
	        if (!this.isDisposed) {
	            startBatch();
	            this._isScheduled = false;
	            if (shouldCompute(this)) {
	                this._isTrackPending = true;
	                try {
	                    this.onInvalidate();
	                    if (this._isTrackPending &&
	                        isSpyEnabled() &&
	                        "development" !== "production") {
	                        // onInvalidate didn't trigger track right away..
	                        spyReport({
	                            name: this.name,
	                            type: "scheduled-reaction"
	                        });
	                    }
	                }
	                catch (e) {
	                    this.reportExceptionInDerivation(e);
	                }
	            }
	            endBatch();
	        }
	    };
	    Reaction.prototype.track = function (fn) {
	        if (this.isDisposed) {
	            return;
	            // console.warn("Reaction already disposed") // Note: Not a warning / error in mobx 4 either
	        }
	        startBatch();
	        var notify = isSpyEnabled();
	        var startTime;
	        if (notify && "development" !== "production") {
	            startTime = Date.now();
	            spyReportStart({
	                name: this.name,
	                type: "reaction"
	            });
	        }
	        this._isRunning = true;
	        var result = trackDerivedFunction(this, fn, undefined);
	        this._isRunning = false;
	        this._isTrackPending = false;
	        if (this.isDisposed) {
	            // disposed during last run. Clean up everything that was bound after the dispose call.
	            clearObserving(this);
	        }
	        if (isCaughtException(result))
	            this.reportExceptionInDerivation(result.cause);
	        if (notify && "development" !== "production") {
	            spyReportEnd({
	                time: Date.now() - startTime
	            });
	        }
	        endBatch();
	    };
	    Reaction.prototype.reportExceptionInDerivation = function (error) {
	        var _this = this;
	        if (this.errorHandler) {
	            this.errorHandler(error, this);
	            return;
	        }
	        if (globalState.disableErrorBoundaries)
	            throw error;
	        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
	        if (globalState.suppressReactionErrors) {
	            console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)"); // prettier-ignore
	        }
	        else {
	            console.error(message, error);
	            /** If debugging brought you here, please, read the above message :-). Tnx! */
	        }
	        if (isSpyEnabled()) {
	            spyReport({
	                type: "error",
	                name: this.name,
	                message: message,
	                error: "" + error
	            });
	        }
	        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
	    };
	    Reaction.prototype.dispose = function () {
	        if (!this.isDisposed) {
	            this.isDisposed = true;
	            if (!this._isRunning) {
	                // if disposed while running, clean up later. Maybe not optimal, but rare case
	                startBatch();
	                clearObserving(this);
	                endBatch();
	            }
	        }
	    };
	    Reaction.prototype.getDisposer = function () {
	        var r = this.dispose.bind(this);
	        r[$mobx] = this;
	        return r;
	    };
	    Reaction.prototype.toString = function () {
	        return "Reaction[" + this.name + "]";
	    };
	    Reaction.prototype.trace = function (enterBreakPoint) {
	        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
	        trace(this, enterBreakPoint);
	    };
	    return Reaction;
	}());
	function onReactionError(handler) {
	    globalState.globalReactionErrorHandlers.push(handler);
	    return function () {
	        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
	        if (idx >= 0)
	            globalState.globalReactionErrorHandlers.splice(idx, 1);
	    };
	}
	/**
	 * Magic number alert!
	 * Defines within how many times a reaction is allowed to re-trigger itself
	 * until it is assumed that this is gonna be a never ending loop...
	 */
	var MAX_REACTION_ITERATIONS = 100;
	var reactionScheduler = function (f) { return f(); };
	function runReactions() {
	    // Trampolining, if runReactions are already running, new reactions will be picked up
	    if (globalState.inBatch > 0 || globalState.isRunningReactions)
	        return;
	    reactionScheduler(runReactionsHelper);
	}
	function runReactionsHelper() {
	    globalState.isRunningReactions = true;
	    var allReactions = globalState.pendingReactions;
	    var iterations = 0;
	    // While running reactions, new reactions might be triggered.
	    // Hence we work with two variables and check whether
	    // we converge to no remaining reactions after a while.
	    while (allReactions.length > 0) {
	        if (++iterations === MAX_REACTION_ITERATIONS) {
	            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
	                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
	            allReactions.splice(0); // clear reactions
	        }
	        var remainingReactions = allReactions.splice(0);
	        for (var i = 0, l = remainingReactions.length; i < l; i++)
	            remainingReactions[i].runReaction();
	    }
	    globalState.isRunningReactions = false;
	}
	var isReaction = createInstanceofPredicate("Reaction", Reaction);
	function setReactionScheduler(fn) {
	    var baseScheduler = reactionScheduler;
	    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
	}
	
	function isSpyEnabled() {
	    return  !!globalState.spyListeners.length;
	}
	function spyReport(event) {
	    if (!globalState.spyListeners.length)
	        return;
	    var listeners = globalState.spyListeners;
	    for (var i = 0, l = listeners.length; i < l; i++)
	        listeners[i](event);
	}
	function spyReportStart(event) {
	    var change = __assign(__assign({}, event), { spyReportStart: true });
	    spyReport(change);
	}
	var END_EVENT = { spyReportEnd: true };
	function spyReportEnd(change) {
	    if (change)
	        spyReport(__assign(__assign({}, change), { spyReportEnd: true }));
	    else
	        spyReport(END_EVENT);
	}
	function spy(listener) {
	    {
	        globalState.spyListeners.push(listener);
	        return once(function () {
	            globalState.spyListeners = globalState.spyListeners.filter(function (l) { return l !== listener; });
	        });
	    }
	}
	
	function dontReassignFields() {
	    fail( "@action fields are not reassignable");
	}
	function namedActionDecorator(name) {
	    return function (target, prop, descriptor) {
	        if (descriptor) {
	            if ( descriptor.get !== undefined) {
	                return fail("@action cannot be used with getters");
	            }
	            // babel / typescript
	            // @action method() { }
	            if (descriptor.value) {
	                // typescript
	                return {
	                    value: createAction(name, descriptor.value),
	                    enumerable: false,
	                    configurable: true,
	                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
	                };
	            }
	            // babel only: @action method = () => {}
	            var initializer_1 = descriptor.initializer;
	            return {
	                enumerable: false,
	                configurable: true,
	                writable: true,
	                initializer: function () {
	                    // N.B: we can't immediately invoke initializer; this would be wrong
	                    return createAction(name, initializer_1.call(this));
	                }
	            };
	        }
	        // bound instance methods
	        return actionFieldDecorator(name).apply(this, arguments);
	    };
	}
	function actionFieldDecorator(name) {
	    // Simple property that writes on first invocation to the current instance
	    return function (target, prop, descriptor) {
	        Object.defineProperty(target, prop, {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                return undefined;
	            },
	            set: function (value) {
	                addHiddenProp(this, prop, action(name, value));
	            }
	        });
	    };
	}
	function boundActionDecorator(target, propertyName, descriptor, applyToInstance) {
	    if (applyToInstance === true) {
	        defineBoundAction(target, propertyName, descriptor.value);
	        return null;
	    }
	    if (descriptor) {
	        // if (descriptor.value)
	        // Typescript / Babel: @action.bound method() { }
	        // also: babel @action.bound method = () => {}
	        return {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                defineBoundAction(this, propertyName, descriptor.value || descriptor.initializer.call(this));
	                return this[propertyName];
	            },
	            set: dontReassignFields
	        };
	    }
	    // field decorator Typescript @action.bound method = () => {}
	    return {
	        enumerable: false,
	        configurable: true,
	        set: function (v) {
	            defineBoundAction(this, propertyName, v);
	        },
	        get: function () {
	            return undefined;
	        }
	    };
	}
	
	var action = function action(arg1, arg2, arg3, arg4) {
	    // action(fn() {})
	    if (arguments.length === 1 && typeof arg1 === "function")
	        return createAction(arg1.name || "<unnamed action>", arg1);
	    // action("name", fn() {})
	    if (arguments.length === 2 && typeof arg2 === "function")
	        return createAction(arg1, arg2);
	    // @action("name") fn() {}
	    if (arguments.length === 1 && typeof arg1 === "string")
	        return namedActionDecorator(arg1);
	    // @action fn() {}
	    if (arg4 === true) {
	        // apply to instance immediately
	        addHiddenProp(arg1, arg2, createAction(arg1.name || arg2, arg3.value, this));
	    }
	    else {
	        return namedActionDecorator(arg2).apply(null, arguments);
	    }
	};
	action.bound = boundActionDecorator;
	function runInAction(arg1, arg2) {
	    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
	    var fn = typeof arg1 === "function" ? arg1 : arg2;
	    {
	        invariant(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
	        if (typeof actionName !== "string" || !actionName)
	            fail("actions should have valid names, got: '" + actionName + "'");
	    }
	    return executeAction(actionName, fn, this, undefined);
	}
	function isAction(thing) {
	    return typeof thing === "function" && thing.isMobxAction === true;
	}
	function defineBoundAction(target, propertyName, fn) {
	    addHiddenProp(target, propertyName, createAction(propertyName, fn.bind(target)));
	}
	
	/**
	 * Creates a named reactive view and keeps it alive, so that the view is always
	 * updated if one of the dependencies changes, even when the view is not further used by something else.
	 * @param view The reactive view
	 * @returns disposer function, which can be used to stop the view from being updated in the future.
	 */
	function autorun(view, opts) {
	    if (opts === void 0) { opts = EMPTY_OBJECT; }
	    {
	        invariant(typeof view === "function", "Autorun expects a function as first argument");
	        invariant(isAction(view) === false, "Autorun does not accept actions since actions are untrackable");
	    }
	    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId();
	    var runSync = !opts.scheduler && !opts.delay;
	    var reaction;
	    if (runSync) {
	        // normal autorun
	        reaction = new Reaction(name, function () {
	            this.track(reactionRunner);
	        }, opts.onError, opts.requiresObservable);
	    }
	    else {
	        var scheduler_1 = createSchedulerFromOptions(opts);
	        // debounced autorun
	        var isScheduled_1 = false;
	        reaction = new Reaction(name, function () {
	            if (!isScheduled_1) {
	                isScheduled_1 = true;
	                scheduler_1(function () {
	                    isScheduled_1 = false;
	                    if (!reaction.isDisposed)
	                        reaction.track(reactionRunner);
	                });
	            }
	        }, opts.onError, opts.requiresObservable);
	    }
	    function reactionRunner() {
	        view(reaction);
	    }
	    reaction.schedule();
	    return reaction.getDisposer();
	}
	var run = function (f) { return f(); };
	function createSchedulerFromOptions(opts) {
	    return opts.scheduler
	        ? opts.scheduler
	        : opts.delay
	            ? function (f) { return setTimeout(f, opts.delay); }
	            : run;
	}
	function reaction(expression, effect, opts) {
	    if (opts === void 0) { opts = EMPTY_OBJECT; }
	    {
	        invariant(typeof expression === "function", "First argument to reaction should be a function");
	        invariant(typeof opts === "object", "Third argument of reactions should be an object");
	    }
	    var name = opts.name || "Reaction@" + getNextId();
	    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
	    var runSync = !opts.scheduler && !opts.delay;
	    var scheduler = createSchedulerFromOptions(opts);
	    var firstTime = true;
	    var isScheduled = false;
	    var value;
	    var equals = opts.compareStructural
	        ? comparer.structural
	        : opts.equals || comparer.default;
	    var r = new Reaction(name, function () {
	        if (firstTime || runSync) {
	            reactionRunner();
	        }
	        else if (!isScheduled) {
	            isScheduled = true;
	            scheduler(reactionRunner);
	        }
	    }, opts.onError, opts.requiresObservable);
	    function reactionRunner() {
	        isScheduled = false; // Q: move into reaction runner?
	        if (r.isDisposed)
	            return;
	        var changed = false;
	        r.track(function () {
	            var nextValue = expression(r);
	            changed = firstTime || !equals(value, nextValue);
	            value = nextValue;
	        });
	        if (firstTime && opts.fireImmediately)
	            effectAction(value, r);
	        if (!firstTime && changed === true)
	            effectAction(value, r);
	        if (firstTime)
	            firstTime = false;
	    }
	    r.schedule();
	    return r.getDisposer();
	}
	function wrapErrorHandler(errorHandler, baseFn) {
	    return function () {
	        try {
	            return baseFn.apply(this, arguments);
	        }
	        catch (e) {
	            errorHandler.call(this, e);
	        }
	    };
	}
	
	function onBecomeObserved(thing, arg2, arg3) {
	    return interceptHook("onBecomeObserved", thing, arg2, arg3);
	}
	function onBecomeUnobserved(thing, arg2, arg3) {
	    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
	}
	function interceptHook(hook, thing, arg2, arg3) {
	    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
	    var cb = typeof arg3 === "function" ? arg3 : arg2;
	    var listenersKey = hook + "Listeners";
	    if (atom[listenersKey]) {
	        atom[listenersKey].add(cb);
	    }
	    else {
	        atom[listenersKey] = new Set([cb]);
	    }
	    var orig = atom[hook];
	    if (typeof orig !== "function")
	        return fail( "Not an atom that can be (un)observed");
	    return function () {
	        var hookListeners = atom[listenersKey];
	        if (hookListeners) {
	            hookListeners.delete(cb);
	            if (hookListeners.size === 0) {
	                delete atom[listenersKey];
	            }
	        }
	    };
	}
	
	function configure(options) {
	    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, computedConfigurable = options.computedConfigurable, disableErrorBoundaries = options.disableErrorBoundaries, reactionScheduler = options.reactionScheduler, reactionRequiresObservable = options.reactionRequiresObservable, observableRequiresReaction = options.observableRequiresReaction;
	    if (options.isolateGlobalState === true) {
	        isolateGlobalState();
	    }
	    if (enforceActions !== undefined) {
	        if (typeof enforceActions === "boolean" || enforceActions === "strict")
	            deprecated("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
	        var ea = void 0;
	        switch (enforceActions) {
	            case true:
	            case "observed":
	                ea = true;
	                break;
	            case false:
	            case "never":
	                ea = false;
	                break;
	            case "strict":
	            case "always":
	                ea = "strict";
	                break;
	            default:
	                fail("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
	        }
	        globalState.enforceActions = ea;
	        globalState.allowStateChanges = ea === true || ea === "strict" ? false : true;
	    }
	    if (computedRequiresReaction !== undefined) {
	        globalState.computedRequiresReaction = !!computedRequiresReaction;
	    }
	    if (reactionRequiresObservable !== undefined) {
	        globalState.reactionRequiresObservable = !!reactionRequiresObservable;
	    }
	    if (observableRequiresReaction !== undefined) {
	        globalState.observableRequiresReaction = !!observableRequiresReaction;
	        globalState.allowStateReads = !globalState.observableRequiresReaction;
	    }
	    if (computedConfigurable !== undefined) {
	        globalState.computedConfigurable = !!computedConfigurable;
	    }
	    if (disableErrorBoundaries !== undefined) {
	        if (disableErrorBoundaries === true)
	            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled.");
	        globalState.disableErrorBoundaries = !!disableErrorBoundaries;
	    }
	    if (reactionScheduler) {
	        setReactionScheduler(reactionScheduler);
	    }
	}
	
	function decorate(thing, decorators) {
	    
	        invariant(isPlainObject(decorators), "Decorators should be a key value map");
	    var target = typeof thing === "function" ? thing.prototype : thing;
	    var _loop_1 = function (prop) {
	        var propertyDecorators = decorators[prop];
	        if (!Array.isArray(propertyDecorators)) {
	            propertyDecorators = [propertyDecorators];
	        }
	        
	            invariant(propertyDecorators.every(function (decorator) { return typeof decorator === "function"; }), "Decorate: expected a decorator function or array of decorator functions for '" + prop + "'");
	        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
	        var newDescriptor = propertyDecorators.reduce(function (accDescriptor, decorator) { return decorator(target, prop, accDescriptor); }, descriptor);
	        if (newDescriptor)
	            Object.defineProperty(target, prop, newDescriptor);
	    };
	    for (var prop in decorators) {
	        _loop_1(prop);
	    }
	    return thing;
	}
	
	function extendObservable(target, properties, decorators, options) {
	    {
	        invariant(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
	        invariant(typeof target === "object", "'extendObservable' expects an object as first argument");
	        invariant(!isObservableMap(target), "'extendObservable' should not be used on maps, use map.merge instead");
	    }
	    options = asCreateObservableOptions(options);
	    var defaultDecorator = getDefaultDecoratorFromObjectOptions(options);
	    initializeInstance(target); // Fixes #1740
	    asObservableObject(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
	    if (properties)
	        extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator);
	    return target;
	}
	function getDefaultDecoratorFromObjectOptions(options) {
	    return options.defaultDecorator || (options.deep === false ? refDecorator : deepDecorator);
	}
	function extendObservableObjectWithProperties(target, properties, decorators, defaultDecorator) {
	    var e_1, _a, e_2, _b;
	    {
	        invariant(!isObservable(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
	        if (decorators) {
	            var keys = getPlainObjectKeys(decorators);
	            try {
	                for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
	                    var key = keys_1_1.value;
	                    if (!(key in properties))
	                        fail("Trying to declare a decorator for unspecified property '" + stringifyKey(key) + "'");
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	    }
	    startBatch();
	    try {
	        var keys = ownKeys(properties);
	        try {
	            for (var keys_2 = __values(keys), keys_2_1 = keys_2.next(); !keys_2_1.done; keys_2_1 = keys_2.next()) {
	                var key = keys_2_1.value;
	                var descriptor = Object.getOwnPropertyDescriptor(properties, key);
	                if (true) {
	                    if (!isPlainObject(properties))
	                        fail("'extendObservable' only accepts plain objects as second argument");
	                    if (isComputed(descriptor.value))
	                        fail("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
	                }
	                var decorator = decorators && key in decorators
	                    ? decorators[key]
	                    : descriptor.get
	                        ? computedDecorator
	                        : defaultDecorator;
	                if ("development" !== "production" && typeof decorator !== "function")
	                    fail("Not a valid decorator for '" + stringifyKey(key) + "', got: " + decorator);
	                var resultDescriptor = decorator(target, key, descriptor, true);
	                if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
	                )
	                    Object.defineProperty(target, key, resultDescriptor);
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (keys_2_1 && !keys_2_1.done && (_b = keys_2.return)) _b.call(keys_2);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	    }
	    finally {
	        endBatch();
	    }
	}
	
	function getDependencyTree(thing, property) {
	    return nodeToDependencyTree(getAtom(thing, property));
	}
	function nodeToDependencyTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (node.observing && node.observing.length > 0)
	        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
	    return result;
	}
	function getObserverTree(thing, property) {
	    return nodeToObserverTree(getAtom(thing, property));
	}
	function nodeToObserverTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (hasObservers(node))
	        result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
	    return result;
	}
	
	var generatorId = 0;
	function FlowCancellationError() {
	    this.message = "FLOW_CANCELLED";
	}
	FlowCancellationError.prototype = Object.create(Error.prototype);
	function isFlowCancellationError(error) {
	    return error instanceof FlowCancellationError;
	}
	function flow(generator) {
	    if (arguments.length !== 1)
	        fail( "Flow expects 1 argument and cannot be used as decorator");
	    var name = generator.name || "<unnamed flow>";
	    // Implementation based on https://github.com/tj/co/blob/master/index.js
	    return function () {
	        var ctx = this;
	        var args = arguments;
	        var runId = ++generatorId;
	        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
	        var rejector;
	        var pendingPromise = undefined;
	        var promise = new Promise(function (resolve, reject) {
	            var stepId = 0;
	            rejector = reject;
	            function onFulfilled(res) {
	                pendingPromise = undefined;
	                var ret;
	                try {
	                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
	                }
	                catch (e) {
	                    return reject(e);
	                }
	                next(ret);
	            }
	            function onRejected(err) {
	                pendingPromise = undefined;
	                var ret;
	                try {
	                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
	                }
	                catch (e) {
	                    return reject(e);
	                }
	                next(ret);
	            }
	            function next(ret) {
	                if (ret && typeof ret.then === "function") {
	                    // an async iterator
	                    ret.then(next, reject);
	                    return;
	                }
	                if (ret.done)
	                    return resolve(ret.value);
	                pendingPromise = Promise.resolve(ret.value);
	                return pendingPromise.then(onFulfilled, onRejected);
	            }
	            onFulfilled(undefined); // kick off the process
	        });
	        promise.cancel = action(name + " - runid: " + runId + " - cancel", function () {
	            try {
	                if (pendingPromise)
	                    cancelPromise(pendingPromise);
	                // Finally block can return (or yield) stuff..
	                var res = gen.return(undefined);
	                // eat anything that promise would do, it's cancelled!
	                var yieldedPromise = Promise.resolve(res.value);
	                yieldedPromise.then(noop, noop);
	                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
	                // reject our original promise
	                rejector(new FlowCancellationError());
	            }
	            catch (e) {
	                rejector(e); // there could be a throwing finally block
	            }
	        });
	        return promise;
	    };
	}
	function cancelPromise(promise) {
	    if (typeof promise.cancel === "function")
	        promise.cancel();
	}
	
	function interceptReads(thing, propOrHandler, handler) {
	    var target;
	    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
	        target = getAdministration(thing);
	    }
	    else if (isObservableObject(thing)) {
	        if (typeof propOrHandler !== "string")
	            return fail(
	                "InterceptReads can only be used with a specific property, not with an object in general");
	        target = getAdministration(thing, propOrHandler);
	    }
	    else {
	        return fail(
	            "Expected observable map, object or array as first array");
	    }
	    if (target.dehancer !== undefined)
	        return fail( "An intercept reader was already established");
	    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
	    return function () {
	        target.dehancer = undefined;
	    };
	}
	
	function intercept(thing, propOrHandler, handler) {
	    if (typeof handler === "function")
	        return interceptProperty(thing, propOrHandler, handler);
	    else
	        return interceptInterceptable(thing, propOrHandler);
	}
	function interceptInterceptable(thing, handler) {
	    return getAdministration(thing).intercept(handler);
	}
	function interceptProperty(thing, property, handler) {
	    return getAdministration(thing, property).intercept(handler);
	}
	
	function _isComputed(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (isObservableObject(value) === false)
	            return false;
	        if (!value[$mobx].values.has(property))
	            return false;
	        var atom = getAtom(value, property);
	        return isComputedValue(atom);
	    }
	    return isComputedValue(value);
	}
	function isComputed(value) {
	    if (arguments.length > 1)
	        return fail(
	            "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
	    return _isComputed(value);
	}
	function isComputedProp(value, propName) {
	    if (typeof propName !== "string")
	        return fail(
	            "isComputed expected a property name as second argument");
	    return _isComputed(value, propName);
	}
	
	function _isObservable(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (
	            (isObservableMap(value) || isObservableArray(value)))
	            return fail("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
	        if (isObservableObject(value)) {
	            return value[$mobx].values.has(property);
	        }
	        return false;
	    }
	    // For first check, see #701
	    return (isObservableObject(value) ||
	        !!value[$mobx] ||
	        isAtom(value) ||
	        isReaction(value) ||
	        isComputedValue(value));
	}
	function isObservable(value) {
	    if (arguments.length !== 1)
	        fail(
	            "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
	    return _isObservable(value);
	}
	function isObservableProp(value, propName) {
	    if (typeof propName !== "string")
	        return fail( "expected a property name as second argument");
	    return _isObservable(value, propName);
	}
	
	function keys(obj) {
	    if (isObservableObject(obj)) {
	        return obj[$mobx].getKeys();
	    }
	    if (isObservableMap(obj)) {
	        return Array.from(obj.keys());
	    }
	    if (isObservableSet(obj)) {
	        return Array.from(obj.keys());
	    }
	    if (isObservableArray(obj)) {
	        return obj.map(function (_, index) { return index; });
	    }
	    return fail(
	        "'keys()' can only be used on observable objects, arrays, sets and maps");
	}
	function values(obj) {
	    if (isObservableObject(obj)) {
	        return keys(obj).map(function (key) { return obj[key]; });
	    }
	    if (isObservableMap(obj)) {
	        return keys(obj).map(function (key) { return obj.get(key); });
	    }
	    if (isObservableSet(obj)) {
	        return Array.from(obj.values());
	    }
	    if (isObservableArray(obj)) {
	        return obj.slice();
	    }
	    return fail(
	        "'values()' can only be used on observable objects, arrays, sets and maps");
	}
	function entries(obj) {
	    if (isObservableObject(obj)) {
	        return keys(obj).map(function (key) { return [key, obj[key]]; });
	    }
	    if (isObservableMap(obj)) {
	        return keys(obj).map(function (key) { return [key, obj.get(key)]; });
	    }
	    if (isObservableSet(obj)) {
	        return Array.from(obj.entries());
	    }
	    if (isObservableArray(obj)) {
	        return obj.map(function (key, index) { return [index, key]; });
	    }
	    return fail(
	        "'entries()' can only be used on observable objects, arrays and maps");
	}
	function set(obj, key, value) {
	    if (arguments.length === 2 && !isObservableSet(obj)) {
	        startBatch();
	        var values_1 = key;
	        try {
	            for (var key_1 in values_1)
	                set(obj, key_1, values_1[key_1]);
	        }
	        finally {
	            endBatch();
	        }
	        return;
	    }
	    if (isObservableObject(obj)) {
	        var adm = obj[$mobx];
	        var existingObservable = adm.values.get(key);
	        if (existingObservable) {
	            adm.write(key, value);
	        }
	        else {
	            adm.addObservableProp(key, value, adm.defaultEnhancer);
	        }
	    }
	    else if (isObservableMap(obj)) {
	        obj.set(key, value);
	    }
	    else if (isObservableSet(obj)) {
	        obj.add(key);
	    }
	    else if (isObservableArray(obj)) {
	        if (typeof key !== "number")
	            key = parseInt(key, 10);
	        invariant(key >= 0, "Not a valid index: '" + key + "'");
	        startBatch();
	        if (key >= obj.length)
	            obj.length = key + 1;
	        obj[key] = value;
	        endBatch();
	    }
	    else {
	        return fail(
	            "'set()' can only be used on observable objects, arrays and maps");
	    }
	}
	function remove(obj, key) {
	    if (isObservableObject(obj)) {
	        obj[$mobx].remove(key);
	    }
	    else if (isObservableMap(obj)) {
	        obj.delete(key);
	    }
	    else if (isObservableSet(obj)) {
	        obj.delete(key);
	    }
	    else if (isObservableArray(obj)) {
	        if (typeof key !== "number")
	            key = parseInt(key, 10);
	        invariant(key >= 0, "Not a valid index: '" + key + "'");
	        obj.splice(key, 1);
	    }
	    else {
	        return fail(
	            "'remove()' can only be used on observable objects, arrays and maps");
	    }
	}
	function has(obj, key) {
	    if (isObservableObject(obj)) {
	        // return keys(obj).indexOf(key) >= 0
	        var adm = getAdministration(obj);
	        return adm.has(key);
	    }
	    else if (isObservableMap(obj)) {
	        return obj.has(key);
	    }
	    else if (isObservableSet(obj)) {
	        return obj.has(key);
	    }
	    else if (isObservableArray(obj)) {
	        return key >= 0 && key < obj.length;
	    }
	    else {
	        return fail(
	            "'has()' can only be used on observable objects, arrays and maps");
	    }
	}
	function get(obj, key) {
	    if (!has(obj, key))
	        return undefined;
	    if (isObservableObject(obj)) {
	        return obj[key];
	    }
	    else if (isObservableMap(obj)) {
	        return obj.get(key);
	    }
	    else if (isObservableArray(obj)) {
	        return obj[key];
	    }
	    else {
	        return fail(
	            "'get()' can only be used on observable objects, arrays and maps");
	    }
	}
	
	function observe(thing, propOrCb, cbOrFire, fireImmediately) {
	    if (typeof cbOrFire === "function")
	        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
	    else
	        return observeObservable(thing, propOrCb, cbOrFire);
	}
	function observeObservable(thing, listener, fireImmediately) {
	    return getAdministration(thing).observe(listener, fireImmediately);
	}
	function observeObservableProperty(thing, property, listener, fireImmediately) {
	    return getAdministration(thing, property).observe(listener, fireImmediately);
	}
	
	var defaultOptions = {
	    detectCycles: true,
	    exportMapsAsObjects: true,
	    recurseEverything: false
	};
	function cache(map, key, value, options) {
	    if (options.detectCycles)
	        map.set(key, value);
	    return value;
	}
	function toJSHelper(source, options, __alreadySeen) {
	    if (!options.recurseEverything && !isObservable(source))
	        return source;
	    if (typeof source !== "object")
	        return source;
	    // Directly return null if source is null
	    if (source === null)
	        return null;
	    // Directly return the Date object itself if contained in the observable
	    if (source instanceof Date)
	        return source;
	    if (isObservableValue(source))
	        return toJSHelper(source.get(), options, __alreadySeen);
	    // make sure we track the keys of the object
	    if (isObservable(source))
	        keys(source);
	    var detectCycles = options.detectCycles === true;
	    if (detectCycles && source !== null && __alreadySeen.has(source)) {
	        return __alreadySeen.get(source);
	    }
	    if (isObservableArray(source) || Array.isArray(source)) {
	        var res_1 = cache(__alreadySeen, source, [], options);
	        var toAdd = source.map(function (value) { return toJSHelper(value, options, __alreadySeen); });
	        res_1.length = toAdd.length;
	        for (var i = 0, l = toAdd.length; i < l; i++)
	            res_1[i] = toAdd[i];
	        return res_1;
	    }
	    if (isObservableSet(source) || Object.getPrototypeOf(source) === Set.prototype) {
	        if (options.exportMapsAsObjects === false) {
	            var res_2 = cache(__alreadySeen, source, new Set(), options);
	            source.forEach(function (value) {
	                res_2.add(toJSHelper(value, options, __alreadySeen));
	            });
	            return res_2;
	        }
	        else {
	            var res_3 = cache(__alreadySeen, source, [], options);
	            source.forEach(function (value) {
	                res_3.push(toJSHelper(value, options, __alreadySeen));
	            });
	            return res_3;
	        }
	    }
	    if (isObservableMap(source) || Object.getPrototypeOf(source) === Map.prototype) {
	        if (options.exportMapsAsObjects === false) {
	            var res_4 = cache(__alreadySeen, source, new Map(), options);
	            source.forEach(function (value, key) {
	                res_4.set(key, toJSHelper(value, options, __alreadySeen));
	            });
	            return res_4;
	        }
	        else {
	            var res_5 = cache(__alreadySeen, source, {}, options);
	            source.forEach(function (value, key) {
	                res_5[key] = toJSHelper(value, options, __alreadySeen);
	            });
	            return res_5;
	        }
	    }
	    // Fallback to the situation that source is an ObservableObject or a plain object
	    var res = cache(__alreadySeen, source, {}, options);
	    getPlainObjectKeys(source).forEach(function (key) {
	        res[key] = toJSHelper(source[key], options, __alreadySeen);
	    });
	    return res;
	}
	function toJS(source, options) {
	    // backward compatibility
	    if (typeof options === "boolean")
	        options = { detectCycles: options };
	    if (!options)
	        options = defaultOptions;
	    options.detectCycles =
	        options.detectCycles === undefined
	            ? options.recurseEverything === true
	            : options.detectCycles === true;
	    var __alreadySeen;
	    if (options.detectCycles)
	        __alreadySeen = new Map();
	    return toJSHelper(source, options, __alreadySeen);
	}
	
	function trace() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var enterBreakPoint = false;
	    if (typeof args[args.length - 1] === "boolean")
	        enterBreakPoint = args.pop();
	    var derivation = getAtomFromArgs(args);
	    if (!derivation) {
	        return fail(
	            "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
	    }
	    if (derivation.isTracing === TraceMode.NONE) {
	        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
	    }
	    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
	}
	function getAtomFromArgs(args) {
	    switch (args.length) {
	        case 0:
	            return globalState.trackingDerivation;
	        case 1:
	            return getAtom(args[0]);
	        case 2:
	            return getAtom(args[0], args[1]);
	    }
	}
	
	/**
	 * During a transaction no views are updated until the end of the transaction.
	 * The transaction will be run synchronously nonetheless.
	 *
	 * @param action a function that updates some reactive state
	 * @returns any value that was returned by the 'action' parameter.
	 */
	function transaction(action, thisArg) {
	    if (thisArg === void 0) { thisArg = undefined; }
	    startBatch();
	    try {
	        return action.apply(thisArg);
	    }
	    finally {
	        endBatch();
	    }
	}
	
	function when(predicate, arg1, arg2) {
	    if (arguments.length === 1 || (arg1 && typeof arg1 === "object"))
	        return whenPromise(predicate, arg1);
	    return _when(predicate, arg1, arg2 || {});
	}
	function _when(predicate, effect, opts) {
	    var timeoutHandle;
	    if (typeof opts.timeout === "number") {
	        timeoutHandle = setTimeout(function () {
	            if (!disposer[$mobx].isDisposed) {
	                disposer();
	                var error = new Error("WHEN_TIMEOUT");
	                if (opts.onError)
	                    opts.onError(error);
	                else
	                    throw error;
	            }
	        }, opts.timeout);
	    }
	    opts.name = opts.name || "When@" + getNextId();
	    var effectAction = createAction(opts.name + "-effect", effect);
	    var disposer = autorun(function (r) {
	        if (predicate()) {
	            r.dispose();
	            if (timeoutHandle)
	                clearTimeout(timeoutHandle);
	            effectAction();
	        }
	    }, opts);
	    return disposer;
	}
	function whenPromise(predicate, opts) {
	    if ( opts && opts.onError)
	        return fail("the options 'onError' and 'promise' cannot be combined");
	    var cancel;
	    var res = new Promise(function (resolve, reject) {
	        var disposer = _when(predicate, resolve, __assign(__assign({}, opts), { onError: reject }));
	        cancel = function () {
	            disposer();
	            reject("WHEN_CANCELLED");
	        };
	    });
	    res.cancel = cancel;
	    return res;
	}
	
	function getAdm(target) {
	    return target[$mobx];
	}
	function isPropertyKey(val) {
	    return typeof val === "string" || typeof val === "number" || typeof val === "symbol";
	}
	// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
	// and skip either the internal values map, or the base object with its property descriptors!
	var objectProxyTraps = {
	    has: function (target, name) {
	        if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol)
	            return true;
	        var adm = getAdm(target);
	        // MWE: should `in` operator be reactive? If not, below code path will be faster / more memory efficient
	        // TODO: check performance stats!
	        // if (adm.values.get(name as string)) return true
	        if (isPropertyKey(name))
	            return adm.has(name);
	        return name in target;
	    },
	    get: function (target, name) {
	        if (name === $mobx || name === "constructor" || name === mobxDidRunLazyInitializersSymbol)
	            return target[name];
	        var adm = getAdm(target);
	        var observable = adm.values.get(name);
	        if (observable instanceof Atom) {
	            var result = observable.get();
	            if (result === undefined) {
	                // This fixes #1796, because deleting a prop that has an
	                // undefined value won't retrigger a observer (no visible effect),
	                // the autorun wouldn't subscribe to future key changes (see also next comment)
	                adm.has(name);
	            }
	            return result;
	        }
	        // make sure we start listening to future keys
	        // note that we only do this here for optimization
	        if (isPropertyKey(name))
	            adm.has(name);
	        return target[name];
	    },
	    set: function (target, name, value) {
	        if (!isPropertyKey(name))
	            return false;
	        set(target, name, value);
	        return true;
	    },
	    deleteProperty: function (target, name) {
	        if (!isPropertyKey(name))
	            return false;
	        var adm = getAdm(target);
	        adm.remove(name);
	        return true;
	    },
	    ownKeys: function (target) {
	        var adm = getAdm(target);
	        adm.keysAtom.reportObserved();
	        return Reflect.ownKeys(target);
	    },
	    preventExtensions: function (target) {
	        fail("Dynamic observable objects cannot be frozen");
	        return false;
	    }
	};
	function createDynamicObservableObject(base) {
	    var proxy = new Proxy(base, objectProxyTraps);
	    base[$mobx].proxy = proxy;
	    return proxy;
	}
	
	function hasInterceptors(interceptable) {
	    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
	}
	function registerInterceptor(interceptable, handler) {
	    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
	    interceptors.push(handler);
	    return once(function () {
	        var idx = interceptors.indexOf(handler);
	        if (idx !== -1)
	            interceptors.splice(idx, 1);
	    });
	}
	function interceptChange(interceptable, change) {
	    var prevU = untrackedStart();
	    try {
	        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
	        var interceptors = __spread((interceptable.interceptors || []));
	        for (var i = 0, l = interceptors.length; i < l; i++) {
	            change = interceptors[i](change);
	            invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
	            if (!change)
	                break;
	        }
	        return change;
	    }
	    finally {
	        untrackedEnd(prevU);
	    }
	}
	
	function hasListeners(listenable) {
	    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
	}
	function registerListener(listenable, handler) {
	    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
	    listeners.push(handler);
	    return once(function () {
	        var idx = listeners.indexOf(handler);
	        if (idx !== -1)
	            listeners.splice(idx, 1);
	    });
	}
	function notifyListeners(listenable, change) {
	    var prevU = untrackedStart();
	    var listeners = listenable.changeListeners;
	    if (!listeners)
	        return;
	    listeners = listeners.slice();
	    for (var i = 0, l = listeners.length; i < l; i++) {
	        listeners[i](change);
	    }
	    untrackedEnd(prevU);
	}
	
	var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
	var arrayTraps = {
	    get: function (target, name) {
	        if (name === $mobx)
	            return target[$mobx];
	        if (name === "length")
	            return target[$mobx].getArrayLength();
	        if (typeof name === "number") {
	            return arrayExtensions.get.call(target, name);
	        }
	        if (typeof name === "string" && !isNaN(name)) {
	            return arrayExtensions.get.call(target, parseInt(name));
	        }
	        if (arrayExtensions.hasOwnProperty(name)) {
	            return arrayExtensions[name];
	        }
	        return target[name];
	    },
	    set: function (target, name, value) {
	        if (name === "length") {
	            target[$mobx].setArrayLength(value);
	        }
	        if (typeof name === "number") {
	            arrayExtensions.set.call(target, name, value);
	        }
	        if (typeof name === "symbol" || isNaN(name)) {
	            target[name] = value;
	        }
	        else {
	            // numeric string
	            arrayExtensions.set.call(target, parseInt(name), value);
	        }
	        return true;
	    },
	    preventExtensions: function (target) {
	        fail("Observable arrays cannot be frozen");
	        return false;
	    }
	};
	function createObservableArray(initialValues, enhancer, name, owned) {
	    if (name === void 0) { name = "ObservableArray@" + getNextId(); }
	    if (owned === void 0) { owned = false; }
	    var adm = new ObservableArrayAdministration(name, enhancer, owned);
	    addHiddenFinalProp(adm.values, $mobx, adm);
	    var proxy = new Proxy(adm.values, arrayTraps);
	    adm.proxy = proxy;
	    if (initialValues && initialValues.length) {
	        var prev = allowStateChangesStart(true);
	        adm.spliceWithArray(0, 0, initialValues);
	        allowStateChangesEnd(prev);
	    }
	    return proxy;
	}
	var ObservableArrayAdministration = /** @class */ (function () {
	    function ObservableArrayAdministration(name, enhancer, owned) {
	        this.owned = owned;
	        this.values = [];
	        this.proxy = undefined;
	        this.lastKnownLength = 0;
	        this.atom = new Atom(name || "ObservableArray@" + getNextId());
	        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
	    }
	    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
	        if (this.dehancer !== undefined && values.length > 0)
	            return values.map(this.dehancer);
	        return values;
	    };
	    ObservableArrayAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        if (fireImmediately) {
	            listener({
	                object: this.proxy,
	                type: "splice",
	                index: 0,
	                added: this.values.slice(),
	                addedCount: this.values.length,
	                removed: [],
	                removedCount: 0
	            });
	        }
	        return registerListener(this, listener);
	    };
	    ObservableArrayAdministration.prototype.getArrayLength = function () {
	        this.atom.reportObserved();
	        return this.values.length;
	    };
	    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
	        if (typeof newLength !== "number" || newLength < 0)
	            throw new Error("[mobx.array] Out of range: " + newLength);
	        var currentLength = this.values.length;
	        if (newLength === currentLength)
	            return;
	        else if (newLength > currentLength) {
	            var newItems = new Array(newLength - currentLength);
	            for (var i = 0; i < newLength - currentLength; i++)
	                newItems[i] = undefined; // No Array.fill everywhere...
	            this.spliceWithArray(currentLength, 0, newItems);
	        }
	        else
	            this.spliceWithArray(newLength, currentLength - newLength);
	    };
	    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
	        if (oldLength !== this.lastKnownLength)
	            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed.");
	        this.lastKnownLength += delta;
	    };
	    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this.atom);
	        var length = this.values.length;
	        if (index === undefined)
	            index = 0;
	        else if (index > length)
	            index = length;
	        else if (index < 0)
	            index = Math.max(0, length + index);
	        if (arguments.length === 1)
	            deleteCount = length - index;
	        else if (deleteCount === undefined || deleteCount === null)
	            deleteCount = 0;
	        else
	            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
	        if (newItems === undefined)
	            newItems = EMPTY_ARRAY;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this.proxy,
	                type: "splice",
	                index: index,
	                removedCount: deleteCount,
	                added: newItems
	            });
	            if (!change)
	                return EMPTY_ARRAY;
	            deleteCount = change.removedCount;
	            newItems = change.added;
	        }
	        newItems = newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
	        {
	            var lengthDelta = newItems.length - deleteCount;
	            this.updateArrayLength(length, lengthDelta); // checks if internal array wasn't modified
	        }
	        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
	        if (deleteCount !== 0 || newItems.length !== 0)
	            this.notifyArraySplice(index, newItems, res);
	        return this.dehanceValues(res);
	    };
	    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
	        var _a;
	        if (newItems.length < MAX_SPLICE_SIZE) {
	            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
	        }
	        else {
	            var res = this.values.slice(index, index + deleteCount);
	            this.values = this.values
	                .slice(0, index)
	                .concat(newItems, this.values.slice(index + deleteCount));
	            return res;
	        }
	    };
	    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.proxy,
	                type: "update",
	                index: index,
	                newValue: newValue,
	                oldValue: oldValue
	            }
	            : null;
	        // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
	        // cause any runtime overhead in development mode without NODE_ENV set, unless spying is enabled
	        if (notifySpy && "development" !== "production")
	            spyReportStart(__assign(__assign({}, change), { name: this.atom.name }));
	        this.atom.reportChanged();
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy && "development" !== "production")
	            spyReportEnd();
	    };
	    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.proxy,
	                type: "splice",
	                index: index,
	                removed: removed,
	                added: added,
	                removedCount: removed.length,
	                addedCount: added.length
	            }
	            : null;
	        if (notifySpy && "development" !== "production")
	            spyReportStart(__assign(__assign({}, change), { name: this.atom.name }));
	        this.atom.reportChanged();
	        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy && "development" !== "production")
	            spyReportEnd();
	    };
	    return ObservableArrayAdministration;
	}());
	var arrayExtensions = {
	    intercept: function (handler) {
	        return this[$mobx].intercept(handler);
	    },
	    observe: function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        var adm = this[$mobx];
	        return adm.observe(listener, fireImmediately);
	    },
	    clear: function () {
	        return this.splice(0);
	    },
	    replace: function (newItems) {
	        var adm = this[$mobx];
	        return adm.spliceWithArray(0, adm.values.length, newItems);
	    },
	    /**
	     * Converts this array back to a (shallow) javascript structure.
	     * For a deep clone use mobx.toJS
	     */
	    toJS: function () {
	        return this.slice();
	    },
	    toJSON: function () {
	        // Used by JSON.stringify
	        return this.toJS();
	    },
	    /*
	     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
	     * since these functions alter the inner structure of the array, the have side effects.
	     * Because the have side effects, they should not be used in computed function,
	     * and for that reason the do not call dependencyState.notifyObserved
	     */
	    splice: function (index, deleteCount) {
	        var newItems = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            newItems[_i - 2] = arguments[_i];
	        }
	        var adm = this[$mobx];
	        switch (arguments.length) {
	            case 0:
	                return [];
	            case 1:
	                return adm.spliceWithArray(index);
	            case 2:
	                return adm.spliceWithArray(index, deleteCount);
	        }
	        return adm.spliceWithArray(index, deleteCount, newItems);
	    },
	    spliceWithArray: function (index, deleteCount, newItems) {
	        var adm = this[$mobx];
	        return adm.spliceWithArray(index, deleteCount, newItems);
	    },
	    push: function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this[$mobx];
	        adm.spliceWithArray(adm.values.length, 0, items);
	        return adm.values.length;
	    },
	    pop: function () {
	        return this.splice(Math.max(this[$mobx].values.length - 1, 0), 1)[0];
	    },
	    shift: function () {
	        return this.splice(0, 1)[0];
	    },
	    unshift: function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this[$mobx];
	        adm.spliceWithArray(0, 0, items);
	        return adm.values.length;
	    },
	    reverse: function () {
	        // reverse by default mutates in place before returning the result
	        // which makes it both a 'derivation' and a 'mutation'.
	        // so we deviate from the default and just make it an dervitation
	        {
	            console.warn("[mobx] `observableArray.reverse()` will not update the array in place. Use `observableArray.slice().reverse()` to suppress this warning and perform the operation on a copy, or `observableArray.replace(observableArray.slice().reverse())` to reverse & update in place");
	        }
	        var clone = this.slice();
	        return clone.reverse.apply(clone, arguments);
	    },
	    sort: function (compareFn) {
	        // sort by default mutates in place before returning the result
	        // which goes against all good practices. Let's not change the array in place!
	        {
	            console.warn("[mobx] `observableArray.sort()` will not update the array in place. Use `observableArray.slice().sort()` to suppress this warning and perform the operation on a copy, or `observableArray.replace(observableArray.slice().sort())` to sort & update in place");
	        }
	        var clone = this.slice();
	        return clone.sort.apply(clone, arguments);
	    },
	    remove: function (value) {
	        var adm = this[$mobx];
	        var idx = adm.dehanceValues(adm.values).indexOf(value);
	        if (idx > -1) {
	            this.splice(idx, 1);
	            return true;
	        }
	        return false;
	    },
	    get: function (index) {
	        var adm = this[$mobx];
	        if (adm) {
	            if (index < adm.values.length) {
	                adm.atom.reportObserved();
	                return adm.dehanceValue(adm.values[index]);
	            }
	            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + adm.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
	        }
	        return undefined;
	    },
	    set: function (index, newValue) {
	        var adm = this[$mobx];
	        var values = adm.values;
	        if (index < values.length) {
	            // update at index in range
	            checkIfStateModificationsAreAllowed(adm.atom);
	            var oldValue = values[index];
	            if (hasInterceptors(adm)) {
	                var change = interceptChange(adm, {
	                    type: "update",
	                    object: adm.proxy,
	                    index: index,
	                    newValue: newValue
	                });
	                if (!change)
	                    return;
	                newValue = change.newValue;
	            }
	            newValue = adm.enhancer(newValue, oldValue);
	            var changed = newValue !== oldValue;
	            if (changed) {
	                values[index] = newValue;
	                adm.notifyArrayChildUpdate(index, newValue, oldValue);
	            }
	        }
	        else if (index === values.length) {
	            // add a new item
	            adm.spliceWithArray(index, 0, [newValue]);
	        }
	        else {
	            // out of bounds
	            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
	        }
	    }
	};
	[
	    "concat",
	    "flat",
	    "includes",
	    "indexOf",
	    "join",
	    "lastIndexOf",
	    "slice",
	    "toString",
	    "toLocaleString"
	].forEach(function (funcName) {
	    // Feature detection (eg flat may not be available)
	    if (typeof Array.prototype[funcName] !== "function") {
	        return;
	    }
	    arrayExtensions[funcName] = function () {
	        var adm = this[$mobx];
	        adm.atom.reportObserved();
	        var dehancedValues = adm.dehanceValues(adm.values);
	        return dehancedValues[funcName].apply(dehancedValues, arguments);
	    };
	});
	["every", "filter", "find", "findIndex", "flatMap", "forEach", "map", "some"].forEach(function (funcName) {
	    // Feature detection (eg flatMap may not be available)
	    if (typeof Array.prototype[funcName] !== "function") {
	        return;
	    }
	    arrayExtensions[funcName] = function (callback, thisArg) {
	        var _this = this;
	        var adm = this[$mobx];
	        adm.atom.reportObserved();
	        var dehancedValues = adm.dehanceValues(adm.values);
	        return dehancedValues[funcName](function (element, index) {
	            return callback.call(thisArg, element, index, _this);
	        }, thisArg);
	    };
	});
	["reduce", "reduceRight"].forEach(function (funcName) {
	    arrayExtensions[funcName] = function () {
	        var _this = this;
	        var adm = this[$mobx];
	        adm.atom.reportObserved();
	        // #2432 - reduce behavior depends on arguments.length
	        var callback = arguments[0];
	        arguments[0] = function (accumulator, currentValue, index) {
	            currentValue = adm.dehanceValue(currentValue);
	            return callback(accumulator, currentValue, index, _this);
	        };
	        return adm.values[funcName].apply(adm.values, arguments);
	    };
	});
	var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
	function isObservableArray(thing) {
	    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
	}
	
	var _a;
	var ObservableMapMarker = {};
	// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
	// But: https://github.com/mobxjs/mobx/issues/1556
	var ObservableMap = /** @class */ (function () {
	    function ObservableMap(initialData, enhancer, name) {
	        if (enhancer === void 0) { enhancer = deepEnhancer; }
	        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
	        this.enhancer = enhancer;
	        this.name = name;
	        this[_a] = ObservableMapMarker;
	        this._keysAtom = createAtom(this.name + ".keys()");
	        this[Symbol.toStringTag] = "Map";
	        if (typeof Map !== "function") {
	            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
	        }
	        this._data = new Map();
	        this._hasMap = new Map();
	        this.merge(initialData);
	    }
	    ObservableMap.prototype._has = function (key) {
	        return this._data.has(key);
	    };
	    ObservableMap.prototype.has = function (key) {
	        var _this = this;
	        if (!globalState.trackingDerivation)
	            return this._has(key);
	        var entry = this._hasMap.get(key);
	        if (!entry) {
	            // todo: replace with atom (breaking change)
	            var newEntry = (entry = new ObservableValue(this._has(key), referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false));
	            this._hasMap.set(key, newEntry);
	            onBecomeUnobserved(newEntry, function () { return _this._hasMap.delete(key); });
	        }
	        return entry.get();
	    };
	    ObservableMap.prototype.set = function (key, value) {
	        var hasKey = this._has(key);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: hasKey ? "update" : "add",
	                object: this,
	                newValue: value,
	                name: key
	            });
	            if (!change)
	                return this;
	            value = change.newValue;
	        }
	        if (hasKey) {
	            this._updateValue(key, value);
	        }
	        else {
	            this._addValue(key, value);
	        }
	        return this;
	    };
	    ObservableMap.prototype.delete = function (key) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this._keysAtom);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "delete",
	                object: this,
	                name: key
	            });
	            if (!change)
	                return false;
	        }
	        if (this._has(key)) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "delete",
	                    object: this,
	                    oldValue: this._data.get(key).value,
	                    name: key
	                }
	                : null;
	            if (notifySpy && "development" !== "production")
	                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
	            transaction(function () {
	                _this._keysAtom.reportChanged();
	                _this._updateHasMapEntry(key, false);
	                var observable = _this._data.get(key);
	                observable.setNewValue(undefined);
	                _this._data.delete(key);
	            });
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy && "development" !== "production")
	                spyReportEnd();
	            return true;
	        }
	        return false;
	    };
	    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
	        var entry = this._hasMap.get(key);
	        if (entry) {
	            entry.setNewValue(value);
	        }
	    };
	    ObservableMap.prototype._updateValue = function (key, newValue) {
	        var observable = this._data.get(key);
	        newValue = observable.prepareNewValue(newValue);
	        if (newValue !== globalState.UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "update",
	                    object: this,
	                    oldValue: observable.value,
	                    name: key,
	                    newValue: newValue
	                }
	                : null;
	            if (notifySpy && "development" !== "production")
	                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
	            observable.setNewValue(newValue);
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy && "development" !== "production")
	                spyReportEnd();
	        }
	    };
	    ObservableMap.prototype._addValue = function (key, newValue) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this._keysAtom);
	        transaction(function () {
	            var observable = new ObservableValue(newValue, _this.enhancer, _this.name + "." + stringifyKey(key), false);
	            _this._data.set(key, observable);
	            newValue = observable.value; // value might have been changed
	            _this._updateHasMapEntry(key, true);
	            _this._keysAtom.reportChanged();
	        });
	        var notifySpy = isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                type: "add",
	                object: this,
	                name: key,
	                newValue: newValue
	            }
	            : null;
	        if (notifySpy && "development" !== "production")
	            spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy && "development" !== "production")
	            spyReportEnd();
	    };
	    ObservableMap.prototype.get = function (key) {
	        if (this.has(key))
	            return this.dehanceValue(this._data.get(key).get());
	        return this.dehanceValue(undefined);
	    };
	    ObservableMap.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) {
	            return this.dehancer(value);
	        }
	        return value;
	    };
	    ObservableMap.prototype.keys = function () {
	        this._keysAtom.reportObserved();
	        return this._data.keys();
	    };
	    ObservableMap.prototype.values = function () {
	        var self = this;
	        var keys = this.keys();
	        return makeIterable({
	            next: function () {
	                var _b = keys.next(), done = _b.done, value = _b.value;
	                return {
	                    done: done,
	                    value: done ? undefined : self.get(value)
	                };
	            }
	        });
	    };
	    ObservableMap.prototype.entries = function () {
	        var self = this;
	        var keys = this.keys();
	        return makeIterable({
	            next: function () {
	                var _b = keys.next(), done = _b.done, value = _b.value;
	                return {
	                    done: done,
	                    value: done ? undefined : [value, self.get(value)]
	                };
	            }
	        });
	    };
	    ObservableMap.prototype[(_a = $mobx, Symbol.iterator)] = function () {
	        return this.entries();
	    };
	    ObservableMap.prototype.forEach = function (callback, thisArg) {
	        var e_1, _b;
	        try {
	            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
	                callback.call(thisArg, value, key, this);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    };
	    /** Merge another object into this object, returns this. */
	    ObservableMap.prototype.merge = function (other) {
	        var _this = this;
	        if (isObservableMap(other)) {
	            other = other.toJS();
	        }
	        transaction(function () {
	            var prev = allowStateChangesStart(true);
	            try {
	                if (isPlainObject(other))
	                    getPlainObjectKeys(other).forEach(function (key) {
	                        return _this.set(key, other[key]);
	                    });
	                else if (Array.isArray(other))
	                    other.forEach(function (_b) {
	                        var _c = __read(_b, 2), key = _c[0], value = _c[1];
	                        return _this.set(key, value);
	                    });
	                else if (isES6Map(other)) {
	                    if (other.constructor !== Map)
	                        fail("Cannot initialize from classes that inherit from Map: " + other.constructor.name); // prettier-ignore
	                    other.forEach(function (value, key) { return _this.set(key, value); });
	                }
	                else if (other !== null && other !== undefined)
	                    fail("Cannot initialize map from " + other);
	            }
	            finally {
	                allowStateChangesEnd(prev);
	            }
	        });
	        return this;
	    };
	    ObservableMap.prototype.clear = function () {
	        var _this = this;
	        transaction(function () {
	            untracked(function () {
	                var e_2, _b;
	                try {
	                    for (var _c = __values(_this.keys()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                        var key = _d.value;
	                        _this.delete(key);
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            });
	        });
	    };
	    ObservableMap.prototype.replace = function (values) {
	        var _this = this;
	        // Implementation requirements:
	        // - respect ordering of replacement map
	        // - allow interceptors to run and potentially prevent individual operations
	        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
	        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
	        // - note that result map may differ from replacement map due to the interceptors
	        transaction(function () {
	            var e_3, _b, e_4, _c;
	            // Convert to map so we can do quick key lookups
	            var replacementMap = convertToMap(values);
	            var orderedData = new Map();
	            // Used for optimization
	            var keysReportChangedCalled = false;
	            try {
	                // Delete keys that don't exist in replacement map
	                // if the key deletion is prevented by interceptor
	                // add entry at the beginning of the result map
	                for (var _d = __values(_this._data.keys()), _e = _d.next(); !_e.done; _e = _d.next()) {
	                    var key = _e.value;
	                    // Concurrently iterating/deleting keys
	                    // iterator should handle this correctly
	                    if (!replacementMap.has(key)) {
	                        var deleted = _this.delete(key);
	                        // Was the key removed?
	                        if (deleted) {
	                            // _keysAtom.reportChanged() was already called
	                            keysReportChangedCalled = true;
	                        }
	                        else {
	                            // Delete prevented by interceptor
	                            var value = _this._data.get(key);
	                            orderedData.set(key, value);
	                        }
	                    }
	                }
	            }
	            catch (e_3_1) { e_3 = { error: e_3_1 }; }
	            finally {
	                try {
	                    if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
	                }
	                finally { if (e_3) throw e_3.error; }
	            }
	            try {
	                // Merge entries
	                for (var _f = __values(replacementMap.entries()), _g = _f.next(); !_g.done; _g = _f.next()) {
	                    var _h = __read(_g.value, 2), key = _h[0], value = _h[1];
	                    // We will want to know whether a new key is added
	                    var keyExisted = _this._data.has(key);
	                    // Add or update value
	                    _this.set(key, value);
	                    // The addition could have been prevent by interceptor
	                    if (_this._data.has(key)) {
	                        // The update could have been prevented by interceptor
	                        // and also we want to preserve existing values
	                        // so use value from _data map (instead of replacement map)
	                        var value_1 = _this._data.get(key);
	                        orderedData.set(key, value_1);
	                        // Was a new key added?
	                        if (!keyExisted) {
	                            // _keysAtom.reportChanged() was already called
	                            keysReportChangedCalled = true;
	                        }
	                    }
	                }
	            }
	            catch (e_4_1) { e_4 = { error: e_4_1 }; }
	            finally {
	                try {
	                    if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
	                }
	                finally { if (e_4) throw e_4.error; }
	            }
	            // Check for possible key order change
	            if (!keysReportChangedCalled) {
	                if (_this._data.size !== orderedData.size) {
	                    // If size differs, keys are definitely modified
	                    _this._keysAtom.reportChanged();
	                }
	                else {
	                    var iter1 = _this._data.keys();
	                    var iter2 = orderedData.keys();
	                    var next1 = iter1.next();
	                    var next2 = iter2.next();
	                    while (!next1.done) {
	                        if (next1.value !== next2.value) {
	                            _this._keysAtom.reportChanged();
	                            break;
	                        }
	                        next1 = iter1.next();
	                        next2 = iter2.next();
	                    }
	                }
	            }
	            // Use correctly ordered map
	            _this._data = orderedData;
	        });
	        return this;
	    };
	    Object.defineProperty(ObservableMap.prototype, "size", {
	        get: function () {
	            this._keysAtom.reportObserved();
	            return this._data.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns a plain object that represents this map.
	     * Note that all the keys being stringified.
	     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
	     */
	    ObservableMap.prototype.toPOJO = function () {
	        var e_5, _b;
	        var res = {};
	        try {
	            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var _e = __read(_d.value, 2), key = _e[0], value = _e[1];
	                // We lie about symbol key types due to https://github.com/Microsoft/TypeScript/issues/1863
	                res[typeof key === "symbol" ? key : stringifyKey(key)] = value;
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        return res;
	    };
	    /**
	     * Returns a shallow non observable object clone of this map.
	     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
	     */
	    ObservableMap.prototype.toJS = function () {
	        return new Map(this);
	    };
	    ObservableMap.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toPOJO();
	    };
	    ObservableMap.prototype.toString = function () {
	        var _this = this;
	        return (this.name +
	            "[{ " +
	            Array.from(this.keys())
	                .map(function (key) { return stringifyKey(key) + ": " + ("" + _this.get(key)); })
	                .join(", ") +
	            " }]");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableMap.prototype.observe = function (listener, fireImmediately) {
	        
	            invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
	        return registerListener(this, listener);
	    };
	    ObservableMap.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    return ObservableMap;
	}());
	/* 'var' fixes small-build issue */
	var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);
	
	var _a$1;
	var ObservableSetMarker = {};
	var ObservableSet = /** @class */ (function () {
	    function ObservableSet(initialData, enhancer, name) {
	        if (enhancer === void 0) { enhancer = deepEnhancer; }
	        if (name === void 0) { name = "ObservableSet@" + getNextId(); }
	        this.name = name;
	        this[_a$1] = ObservableSetMarker;
	        this._data = new Set();
	        this._atom = createAtom(this.name);
	        this[Symbol.toStringTag] = "Set";
	        if (typeof Set !== "function") {
	            throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
	        }
	        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name); };
	        if (initialData) {
	            this.replace(initialData);
	        }
	    }
	    ObservableSet.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) {
	            return this.dehancer(value);
	        }
	        return value;
	    };
	    ObservableSet.prototype.clear = function () {
	        var _this = this;
	        transaction(function () {
	            untracked(function () {
	                var e_1, _b;
	                try {
	                    for (var _c = __values(_this._data.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                        var value = _d.value;
	                        _this.delete(value);
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	            });
	        });
	    };
	    ObservableSet.prototype.forEach = function (callbackFn, thisArg) {
	        var e_2, _b;
	        try {
	            for (var _c = __values(this), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var value = _d.value;
	                callbackFn.call(thisArg, value, value, this);
	            }
	        }
	        catch (e_2_1) { e_2 = { error: e_2_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
	            }
	            finally { if (e_2) throw e_2.error; }
	        }
	    };
	    Object.defineProperty(ObservableSet.prototype, "size", {
	        get: function () {
	            this._atom.reportObserved();
	            return this._data.size;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ObservableSet.prototype.add = function (value) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this._atom);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "add",
	                object: this,
	                newValue: value
	            });
	            if (!change)
	                return this;
	            // TODO: ideally, value = change.value would be done here, so that values can be
	            // changed by interceptor. Same applies for other Set and Map api's.
	        }
	        if (!this.has(value)) {
	            transaction(function () {
	                _this._data.add(_this.enhancer(value, undefined));
	                _this._atom.reportChanged();
	            });
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "add",
	                    object: this,
	                    newValue: value
	                }
	                : null;
	            if (notifySpy && "development" !== "production")
	                spyReportStart(change);
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy && "development" !== "production")
	                spyReportEnd();
	        }
	        return this;
	    };
	    ObservableSet.prototype.delete = function (value) {
	        var _this = this;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "delete",
	                object: this,
	                oldValue: value
	            });
	            if (!change)
	                return false;
	        }
	        if (this.has(value)) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "delete",
	                    object: this,
	                    oldValue: value
	                }
	                : null;
	            if (notifySpy && "development" !== "production")
	                spyReportStart(__assign(__assign({}, change), { name: this.name }));
	            transaction(function () {
	                _this._atom.reportChanged();
	                _this._data.delete(value);
	            });
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy && "development" !== "production")
	                spyReportEnd();
	            return true;
	        }
	        return false;
	    };
	    ObservableSet.prototype.has = function (value) {
	        this._atom.reportObserved();
	        return this._data.has(this.dehanceValue(value));
	    };
	    ObservableSet.prototype.entries = function () {
	        var nextIndex = 0;
	        var keys = Array.from(this.keys());
	        var values = Array.from(this.values());
	        return makeIterable({
	            next: function () {
	                var index = nextIndex;
	                nextIndex += 1;
	                return index < values.length
	                    ? { value: [keys[index], values[index]], done: false }
	                    : { done: true };
	            }
	        });
	    };
	    ObservableSet.prototype.keys = function () {
	        return this.values();
	    };
	    ObservableSet.prototype.values = function () {
	        this._atom.reportObserved();
	        var self = this;
	        var nextIndex = 0;
	        var observableValues = Array.from(this._data.values());
	        return makeIterable({
	            next: function () {
	                return nextIndex < observableValues.length
	                    ? { value: self.dehanceValue(observableValues[nextIndex++]), done: false }
	                    : { done: true };
	            }
	        });
	    };
	    ObservableSet.prototype.replace = function (other) {
	        var _this = this;
	        if (isObservableSet(other)) {
	            other = other.toJS();
	        }
	        transaction(function () {
	            var prev = allowStateChangesStart(true);
	            try {
	                if (Array.isArray(other)) {
	                    _this.clear();
	                    other.forEach(function (value) { return _this.add(value); });
	                }
	                else if (isES6Set(other)) {
	                    _this.clear();
	                    other.forEach(function (value) { return _this.add(value); });
	                }
	                else if (other !== null && other !== undefined) {
	                    fail("Cannot initialize set from " + other);
	                }
	            }
	            finally {
	                allowStateChangesEnd(prev);
	            }
	        });
	        return this;
	    };
	    ObservableSet.prototype.observe = function (listener, fireImmediately) {
	        // TODO 'fireImmediately' can be true?
	        
	            invariant(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with sets.");
	        return registerListener(this, listener);
	    };
	    ObservableSet.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableSet.prototype.toJS = function () {
	        return new Set(this);
	    };
	    ObservableSet.prototype.toString = function () {
	        return this.name + "[ " + Array.from(this).join(", ") + " ]";
	    };
	    ObservableSet.prototype[(_a$1 = $mobx, Symbol.iterator)] = function () {
	        return this.values();
	    };
	    return ObservableSet;
	}());
	var isObservableSet = createInstanceofPredicate("ObservableSet", ObservableSet);
	
	var ObservableObjectAdministration = /** @class */ (function () {
	    function ObservableObjectAdministration(target, values, name, defaultEnhancer) {
	        if (values === void 0) { values = new Map(); }
	        this.target = target;
	        this.values = values;
	        this.name = name;
	        this.defaultEnhancer = defaultEnhancer;
	        this.keysAtom = new Atom(name + ".keys");
	    }
	    ObservableObjectAdministration.prototype.read = function (key) {
	        return this.values.get(key).get();
	    };
	    ObservableObjectAdministration.prototype.write = function (key, newValue) {
	        var instance = this.target;
	        var observable = this.values.get(key);
	        if (observable instanceof ComputedValue) {
	            observable.set(newValue);
	            return;
	        }
	        // intercept
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "update",
	                object: this.proxy || instance,
	                name: key,
	                newValue: newValue
	            });
	            if (!change)
	                return;
	            newValue = change.newValue;
	        }
	        newValue = observable.prepareNewValue(newValue);
	        // notify spy & observers
	        if (newValue !== globalState.UNCHANGED) {
	            var notify = hasListeners(this);
	            var notifySpy = isSpyEnabled();
	            var change = notify || notifySpy
	                ? {
	                    type: "update",
	                    object: this.proxy || instance,
	                    oldValue: observable.value,
	                    name: key,
	                    newValue: newValue
	                }
	                : null;
	            if (notifySpy && "development" !== "production")
	                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
	            observable.setNewValue(newValue);
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy && "development" !== "production")
	                spyReportEnd();
	        }
	    };
	    ObservableObjectAdministration.prototype.has = function (key) {
	        var map = this.pendingKeys || (this.pendingKeys = new Map());
	        var entry = map.get(key);
	        if (entry)
	            return entry.get();
	        else {
	            var exists = !!this.values.get(key);
	            // Possible optimization: Don't have a separate map for non existing keys,
	            // but store them in the values map instead, using a special symbol to denote "not existing"
	            entry = new ObservableValue(exists, referenceEnhancer, this.name + "." + stringifyKey(key) + "?", false);
	            map.set(key, entry);
	            return entry.get(); // read to subscribe
	        }
	    };
	    ObservableObjectAdministration.prototype.addObservableProp = function (propName, newValue, enhancer) {
	        if (enhancer === void 0) { enhancer = this.defaultEnhancer; }
	        var target = this.target;
	        assertPropertyConfigurable(target, propName);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this.proxy || target,
	                name: propName,
	                type: "add",
	                newValue: newValue
	            });
	            if (!change)
	                return;
	            newValue = change.newValue;
	        }
	        var observable = new ObservableValue(newValue, enhancer, this.name + "." + stringifyKey(propName), false);
	        this.values.set(propName, observable);
	        newValue = observable.value; // observableValue might have changed it
	        Object.defineProperty(target, propName, generateObservablePropConfig(propName));
	        this.notifyPropertyAddition(propName, newValue);
	    };
	    ObservableObjectAdministration.prototype.addComputedProp = function (propertyOwner, // where is the property declared?
	    propName, options) {
	        var target = this.target;
	        options.name = options.name || this.name + "." + stringifyKey(propName);
	        this.values.set(propName, new ComputedValue(options));
	        if (propertyOwner === target || isPropertyConfigurable(propertyOwner, propName))
	            Object.defineProperty(propertyOwner, propName, generateComputedPropConfig(propName));
	    };
	    ObservableObjectAdministration.prototype.remove = function (key) {
	        if (!this.values.has(key))
	            return;
	        var target = this.target;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this.proxy || target,
	                name: key,
	                type: "remove"
	            });
	            if (!change)
	                return;
	        }
	        try {
	            startBatch();
	            var notify = hasListeners(this);
	            var notifySpy = isSpyEnabled();
	            var oldObservable = this.values.get(key);
	            var oldValue = oldObservable && oldObservable.get();
	            oldObservable && oldObservable.set(undefined);
	            // notify key and keyset listeners
	            this.keysAtom.reportChanged();
	            this.values.delete(key);
	            if (this.pendingKeys) {
	                var entry = this.pendingKeys.get(key);
	                if (entry)
	                    entry.set(false);
	            }
	            // delete the prop
	            delete this.target[key];
	            var change = notify || notifySpy
	                ? {
	                    type: "remove",
	                    object: this.proxy || target,
	                    oldValue: oldValue,
	                    name: key
	                }
	                : null;
	            if (notifySpy && "development" !== "production")
	                spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy && "development" !== "production")
	                spyReportEnd();
	        }
	        finally {
	            endBatch();
	        }
	    };
	    ObservableObjectAdministration.prototype.illegalAccess = function (owner, propName) {
	        /**
	         * This happens if a property is accessed through the prototype chain, but the property was
	         * declared directly as own property on the prototype.
	         *
	         * E.g.:
	         * class A {
	         * }
	         * extendObservable(A.prototype, { x: 1 })
	         *
	         * classB extens A {
	         * }
	         * console.log(new B().x)
	         *
	         * It is unclear whether the property should be considered 'static' or inherited.
	         * Either use `console.log(A.x)`
	         * or: decorate(A, { x: observable })
	         *
	         * When using decorate, the property will always be redeclared as own property on the actual instance
	         */
	        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
	        
	            invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
	        return registerListener(this, callback);
	    };
	    ObservableObjectAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableObjectAdministration.prototype.notifyPropertyAddition = function (key, newValue) {
	        var notify = hasListeners(this);
	        var notifySpy = isSpyEnabled();
	        var change = notify || notifySpy
	            ? {
	                type: "add",
	                object: this.proxy || this.target,
	                name: key,
	                newValue: newValue
	            }
	            : null;
	        if (notifySpy && "development" !== "production")
	            spyReportStart(__assign(__assign({}, change), { name: this.name, key: key }));
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy && "development" !== "production")
	            spyReportEnd();
	        if (this.pendingKeys) {
	            var entry = this.pendingKeys.get(key);
	            if (entry)
	                entry.set(true);
	        }
	        this.keysAtom.reportChanged();
	    };
	    ObservableObjectAdministration.prototype.getKeys = function () {
	        var e_1, _a;
	        this.keysAtom.reportObserved();
	        // return Reflect.ownKeys(this.values) as any
	        var res = [];
	        try {
	            for (var _b = __values(this.values), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
	                if (value instanceof ObservableValue)
	                    res.push(key);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return res;
	    };
	    return ObservableObjectAdministration;
	}());
	function asObservableObject(target, name, defaultEnhancer) {
	    if (name === void 0) { name = ""; }
	    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer; }
	    if (Object.prototype.hasOwnProperty.call(target, $mobx))
	        return target[$mobx];
	    
	        invariant(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
	    if (!isPlainObject(target))
	        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
	    if (!name)
	        name = "ObservableObject@" + getNextId();
	    var adm = new ObservableObjectAdministration(target, new Map(), stringifyKey(name), defaultEnhancer);
	    addHiddenProp(target, $mobx, adm);
	    return adm;
	}
	var observablePropertyConfigs = Object.create(null);
	var computedPropertyConfigs = Object.create(null);
	function generateObservablePropConfig(propName) {
	    return (observablePropertyConfigs[propName] ||
	        (observablePropertyConfigs[propName] = {
	            configurable: true,
	            enumerable: true,
	            get: function () {
	                return this[$mobx].read(propName);
	            },
	            set: function (v) {
	                this[$mobx].write(propName, v);
	            }
	        }));
	}
	function getAdministrationForComputedPropOwner(owner) {
	    var adm = owner[$mobx];
	    if (!adm) {
	        // because computed props are declared on proty,
	        // the current instance might not have been initialized yet
	        initializeInstance(owner);
	        return owner[$mobx];
	    }
	    return adm;
	}
	function generateComputedPropConfig(propName) {
	    return (computedPropertyConfigs[propName] ||
	        (computedPropertyConfigs[propName] = {
	            configurable: globalState.computedConfigurable,
	            enumerable: false,
	            get: function () {
	                return getAdministrationForComputedPropOwner(this).read(propName);
	            },
	            set: function (v) {
	                getAdministrationForComputedPropOwner(this).write(propName, v);
	            }
	        }));
	}
	var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
	function isObservableObject(thing) {
	    if (isObject(thing)) {
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        initializeInstance(thing);
	        return isObservableObjectAdministration(thing[$mobx]);
	    }
	    return false;
	}
	
	function getAtom(thing, property) {
	    if (typeof thing === "object" && thing !== null) {
	        if (isObservableArray(thing)) {
	            if (property !== undefined)
	                fail(
	                    "It is not possible to get index atoms from arrays");
	            return thing[$mobx].atom;
	        }
	        if (isObservableSet(thing)) {
	            return thing[$mobx];
	        }
	        if (isObservableMap(thing)) {
	            var anyThing = thing;
	            if (property === undefined)
	                return anyThing._keysAtom;
	            var observable = anyThing._data.get(property) || anyThing._hasMap.get(property);
	            if (!observable)
	                fail(
	                    "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        initializeInstance(thing);
	        if (property && !thing[$mobx])
	            thing[property]; // See #1072
	        if (isObservableObject(thing)) {
	            if (!property)
	                return fail( "please specify a property");
	            var observable = thing[$mobx].values.get(property);
	            if (!observable)
	                fail(
	                    "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
	            return thing;
	        }
	    }
	    else if (typeof thing === "function") {
	        if (isReaction(thing[$mobx])) {
	            // disposer function
	            return thing[$mobx];
	        }
	    }
	    return fail( "Cannot obtain atom from " + thing);
	}
	function getAdministration(thing, property) {
	    if (!thing)
	        fail("Expecting some object");
	    if (property !== undefined)
	        return getAdministration(getAtom(thing, property));
	    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
	        return thing;
	    if (isObservableMap(thing) || isObservableSet(thing))
	        return thing;
	    // Initializers run lazily when transpiling to babel, so make sure they are run...
	    initializeInstance(thing);
	    if (thing[$mobx])
	        return thing[$mobx];
	    fail( "Cannot obtain administration from " + thing);
	}
	function getDebugName(thing, property) {
	    var named;
	    if (property !== undefined)
	        named = getAtom(thing, property);
	    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing))
	        named = getAdministration(thing);
	    else
	        named = getAtom(thing); // valid for arrays as well
	    return named.name;
	}
	
	var toString = Object.prototype.toString;
	function deepEqual(a, b, depth) {
	    if (depth === void 0) { depth = -1; }
	    return eq(a, b, depth);
	}
	// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
	// Internal recursive comparison function for `isEqual`.
	function eq(a, b, depth, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b)
	        return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null)
	        return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a)
	        return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== "function" && type !== "object" && typeof b != "object")
	        return false;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b))
	        return false;
	    switch (className) {
	        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	        case "[object RegExp]":
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	        case "[object String]":
	            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	            // equivalent to `new String("5")`.
	            return "" + a === "" + b;
	        case "[object Number]":
	            // `NaN`s are equivalent, but non-reflexive.
	            // Object(NaN) is equivalent to NaN.
	            if (+a !== +a)
	                return +b !== +b;
	            // An `egal` comparison is performed for other numeric values.
	            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	        case "[object Date]":
	        case "[object Boolean]":
	            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	            // millisecond representations. Note that invalid dates with millisecond representations
	            // of `NaN` are not equivalent.
	            return +a === +b;
	        case "[object Symbol]":
	            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
	        case "[object Map]":
	        case "[object Set]":
	            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
	            // Hide this extra level by increasing the depth.
	            if (depth >= 0) {
	                depth++;
	            }
	            break;
	    }
	    // Unwrap any wrapped objects.
	    a = unwrap(a);
	    b = unwrap(b);
	    var areArrays = className === "[object Array]";
	    if (!areArrays) {
	        if (typeof a != "object" || typeof b != "object")
	            return false;
	        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	        // from different frames are.
	        var aCtor = a.constructor, bCtor = b.constructor;
	        if (aCtor !== bCtor &&
	            !(typeof aCtor === "function" &&
	                aCtor instanceof aCtor &&
	                typeof bCtor === "function" &&
	                bCtor instanceof bCtor) &&
	            ("constructor" in a && "constructor" in b)) {
	            return false;
	        }
	    }
	    if (depth === 0) {
	        return false;
	    }
	    else if (depth < 0) {
	        depth = -1;
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	        // Linear search. Performance is inversely proportional to the number of
	        // unique nested structures.
	        if (aStack[length] === a)
	            return bStack[length] === b;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	        // Compare array lengths to determine if a deep comparison is necessary.
	        length = a.length;
	        if (length !== b.length)
	            return false;
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (length--) {
	            if (!eq(a[length], b[length], depth - 1, aStack, bStack))
	                return false;
	        }
	    }
	    else {
	        // Deep compare objects.
	        var keys = Object.keys(a);
	        var key = void 0;
	        length = keys.length;
	        // Ensure that both objects contain the same number of properties before comparing deep equality.
	        if (Object.keys(b).length !== length)
	            return false;
	        while (length--) {
	            // Deep compare each member
	            key = keys[length];
	            if (!(has$1(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack)))
	                return false;
	        }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	}
	function unwrap(a) {
	    if (isObservableArray(a))
	        return a.slice();
	    if (isES6Map(a) || isObservableMap(a))
	        return Array.from(a.entries());
	    if (isES6Set(a) || isObservableSet(a))
	        return Array.from(a.entries());
	    return a;
	}
	function has$1(a, key) {
	    return Object.prototype.hasOwnProperty.call(a, key);
	}
	
	function makeIterable(iterator) {
	    iterator[Symbol.iterator] = getSelf;
	    return iterator;
	}
	function getSelf() {
	    return this;
	}
	
	/**
	 * (c) Michel Weststrate 2015 - 2018
	 * MIT Licensed
	 *
	 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
	 * this is a good place to start:
	 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
	 *
	 * Source folders:
	 * ===============
	 *
	 * - api/     Most of the public static methods exposed by the module can be found here.
	 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
	 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
	 * - utils/   Utility stuff.
	 *
	 */
	if (typeof Proxy === "undefined" || typeof Symbol === "undefined") {
	    throw new Error("[mobx] MobX 5+ requires Proxy and Symbol objects. If your environment doesn't support Symbol or Proxy objects, please downgrade to MobX 4. For React Native Android, consider upgrading JSCore.");
	}
	try {
	    // define process.env if needed
	    // if this is not a production build in the first place
	    // (in which case the expression below would be substituted with 'production')
	    "development";
	}
	catch (e) {
	    var g = getGlobal();
	    if (typeof process === "undefined")
	        g.process = {};
	    g.process.env = {};
	}
	(function () {
	    function testCodeMinification() { }
	    if (testCodeMinification.name !== "testCodeMinification" &&
	        "development" !== "production" &&
	        typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ENVIRONMENT":"production","REACT_APP_REVISION":"a5bbd8d"}).IGNORE_MOBX_MINIFY_WARNING !== "true") {
	        // trick so it doesn't get replaced
	        var varName = ["process", "env", "NODE_ENV"].join(".");
	        console.warn("[mobx] you are running a minified build, but '" + varName + "' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
	    }
	})();
	if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
	    // See: https://github.com/andykog/mobx-devtools/
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
	        spy: spy,
	        extras: {
	            getDebugName: getDebugName
	        },
	        $mobx: $mobx
	    });
	}
	
	exports.$mobx = $mobx;
	exports.FlowCancellationError = FlowCancellationError;
	exports.ObservableMap = ObservableMap;
	exports.ObservableSet = ObservableSet;
	exports.Reaction = Reaction;
	exports._allowStateChanges = allowStateChanges;
	exports._allowStateChangesInsideComputed = allowStateChangesInsideComputed;
	exports._allowStateReadsEnd = allowStateReadsEnd;
	exports._allowStateReadsStart = allowStateReadsStart;
	exports._endAction = _endAction;
	exports._getAdministration = getAdministration;
	exports._getGlobalState = getGlobalState;
	exports._interceptReads = interceptReads;
	exports._isComputingDerivation = isComputingDerivation;
	exports._resetGlobalState = resetGlobalState;
	exports._startAction = _startAction;
	exports.action = action;
	exports.autorun = autorun;
	exports.comparer = comparer;
	exports.computed = computed;
	exports.configure = configure;
	exports.createAtom = createAtom;
	exports.decorate = decorate;
	exports.entries = entries;
	exports.extendObservable = extendObservable;
	exports.flow = flow;
	exports.get = get;
	exports.getAtom = getAtom;
	exports.getDebugName = getDebugName;
	exports.getDependencyTree = getDependencyTree;
	exports.getObserverTree = getObserverTree;
	exports.has = has;
	exports.intercept = intercept;
	exports.isAction = isAction;
	exports.isArrayLike = isArrayLike;
	exports.isBoxedObservable = isObservableValue;
	exports.isComputed = isComputed;
	exports.isComputedProp = isComputedProp;
	exports.isFlowCancellationError = isFlowCancellationError;
	exports.isObservable = isObservable;
	exports.isObservableArray = isObservableArray;
	exports.isObservableMap = isObservableMap;
	exports.isObservableObject = isObservableObject;
	exports.isObservableProp = isObservableProp;
	exports.isObservableSet = isObservableSet;
	exports.keys = keys;
	exports.observable = observable;
	exports.observe = observe;
	exports.onBecomeObserved = onBecomeObserved;
	exports.onBecomeUnobserved = onBecomeUnobserved;
	exports.onReactionError = onReactionError;
	exports.reaction = reaction;
	exports.remove = remove;
	exports.runInAction = runInAction;
	exports.set = set;
	exports.spy = spy;
	exports.toJS = toJS;
	exports.trace = trace;
	exports.transaction = transaction;
	exports.untracked = untracked;
	exports.values = values;
	exports.when = when;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), (function() { return this; }())))

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=[];Object.freeze(e);var t={};function r(){return++Re.mobxGuid}function n(e){throw o(!1,e),"X"}function o(e,t){if(!e)throw new Error("[mobx] "+(t||"An invariant failed, however the error is obfuscated because this is a production build."))}function i(e){var t=!1;return function(){if(!t)return t=!0,e.apply(this,arguments)}}Object.freeze(t);var a=function(){};function s(e){return null!==e&&"object"==typeof e}function u(e){if(null===e||"object"!=typeof e)return!1;var t=Object.getPrototypeOf(e);return t===Object.prototype||null===t}function c(e,t,r){Object.defineProperty(e,t,{enumerable:!1,writable:!0,configurable:!0,value:r})}function l(e,t){var r="isMobX"+e;return t.prototype[r]=!0,function(e){return s(e)&&!0===e[r]}}function f(e){return e instanceof Map}function p(e){return e instanceof Set}function h(e){var t=new Set;for(var r in e)t.add(r);return Object.getOwnPropertySymbols(e).forEach((function(r){Object.getOwnPropertyDescriptor(e,r).enumerable&&t.add(r)})),Array.from(t)}function d(e){return e&&e.toString?e.toString():new String(e).toString()}function v(e){return null===e?null:"object"==typeof e?""+e:e}var y="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:Object.getOwnPropertySymbols?function(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}:Object.getOwnPropertyNames,b=Symbol("mobx administration"),g=function(){function e(e){void 0===e&&(e="Atom@"+r()),this.name=e,this.isPendingUnobservation=!1,this.isBeingObserved=!1,this.observers=new Set,this.diffValue=0,this.lastAccessedBy=0,this.lowestObserverState=exports.IDerivationState.NOT_TRACKING}return e.prototype.onBecomeObserved=function(){this.onBecomeObservedListeners&&this.onBecomeObservedListeners.forEach((function(e){return e()}))},e.prototype.onBecomeUnobserved=function(){this.onBecomeUnobservedListeners&&this.onBecomeUnobservedListeners.forEach((function(e){return e()}))},e.prototype.reportObserved=function(){return ke(this)},e.prototype.reportChanged=function(){Ne(),function(e){if(e.lowestObserverState===exports.IDerivationState.STALE)return;e.lowestObserverState=exports.IDerivationState.STALE,e.observers.forEach((function(t){t.dependenciesState===exports.IDerivationState.UP_TO_DATE&&(t.isTracing!==Y.NONE&&Be(t,e),t.onBecomeStale()),t.dependenciesState=exports.IDerivationState.STALE}))}(this),Ve()},e.prototype.toString=function(){return this.name},e}(),m=l("Atom",g);function w(e,t,r){void 0===t&&(t=a),void 0===r&&(r=a);var n=new g(e);return t!==a&&Ze(n,t),r!==a&&et(n,r),n}var x={identity:function(e,t){return e===t},structural:function(e,t){return ar(e,t)},default:function(e,t){return Object.is(e,t)},shallow:function(e,t){return ar(e,t,1)}},O=function(e,t){return(O=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(e,t)};
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */var S=function(){return(S=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var o in t=arguments[r])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)};function A(e){var t="function"==typeof Symbol&&e[Symbol.iterator],r=0;return t?t.call(e):{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}}}function _(e,t){var r="function"==typeof Symbol&&e[Symbol.iterator];if(!r)return e;var n,o,i=r.call(e),a=[];try{for(;(void 0===t||t-- >0)&&!(n=i.next()).done;)a.push(n.value)}catch(e){o={error:e}}finally{try{n&&!n.done&&(r=i.return)&&r.call(i)}finally{if(o)throw o.error}}return a}function E(){for(var e=[],t=0;t<arguments.length;t++)e=e.concat(_(arguments[t]));return e}var D=Symbol("mobx did run lazy initializers"),j=Symbol("mobx pending decorators"),C={},R={};function T(e,t){var r=t?C:R;return r[e]||(r[e]={configurable:!0,enumerable:t,get:function(){return I(this),this[e]},set:function(t){I(this),this[e]=t}})}function I(e){var t,r;if(!0!==e[D]){var n=e[j];if(n){c(e,D,!0);var o=E(Object.getOwnPropertySymbols(n),Object.keys(n));try{for(var i=A(o),a=i.next();!a.done;a=i.next()){var s=n[a.value];s.propertyCreator(e,s.prop,s.descriptor,s.decoratorTarget,s.decoratorArguments)}}catch(e){t={error:e}}finally{try{a&&!a.done&&(r=i.return)&&r.call(i)}finally{if(t)throw t.error}}}}}function P(t,r){return function(){var n,o=function(e,o,i,a){if(!0===a)return r(e,o,i,e,n),null;if(!Object.prototype.hasOwnProperty.call(e,j)){var s=e[j];c(e,j,S({},s))}return e[j][o]={prop:o,propertyCreator:r,descriptor:i,decoratorTarget:e,decoratorArguments:n},T(o,t)};return N(arguments)?(n=e,o.apply(null,arguments)):(n=Array.prototype.slice.call(arguments),o)}}function N(e){return(2===e.length||3===e.length)&&("string"==typeof e[1]||"symbol"==typeof e[1])||4===e.length&&!0===e[3]}function V(e,t,r){return dt(e)?e:Array.isArray(e)?W.array(e,{name:r}):u(e)?W.object(e,void 0,{name:r}):f(e)?W.map(e,{name:r}):p(e)?W.set(e,{name:r}):e}function k(e){return e}function B(e){o(e);var t=P(!0,(function(t,r,n,o,i){var a=n?n.initializer?n.initializer.call(t):n.value:void 0;Ft(t).addObservableProp(r,a,e)})),r=("undefined"!=typeof process&&({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_ENVIRONMENT":"production","REACT_APP_REVISION":"a5bbd8d"}),t);return r.enhancer=e,r}var L={deep:!0,name:void 0,defaultDecorator:void 0,proxy:!0};function M(e){return null==e?L:"string"==typeof e?{name:e,deep:!0,proxy:!0}:e}Object.freeze(L);var U=B(V),G=B((function(e,t,r){return null==e?e:tr(e)||Gt(e)||Ht(e)||Xt(e)?e:Array.isArray(e)?W.array(e,{name:r,deep:!1}):u(e)?W.object(e,void 0,{name:r,deep:!1}):f(e)?W.map(e,{name:r,deep:!1}):p(e)?W.set(e,{name:r,deep:!1}):n(!1)})),q=B(k),K=B((function(e,t,r){return ar(e,t)?t:e}));function z(e){return e.defaultDecorator?e.defaultDecorator.enhancer:!1===e.deep?k:V}var H={box:function(e,t){arguments.length>2&&J("box");var r=M(t);return new we(e,z(r),r.name,!0,r.equals)},array:function(e,t){arguments.length>2&&J("array");var r=M(t);return kt(e,z(r),r.name)},map:function(e,t){arguments.length>2&&J("map");var r=M(t);return new zt(e,z(r),r.name)},set:function(e,t){arguments.length>2&&J("set");var r=M(t);return new Jt(e,z(r),r.name)},object:function(e,t,r){"string"==typeof arguments[1]&&J("object");var n=M(r);if(!1===n.proxy)return rt({},e,t,n);var o=nt(n),i=rt({},void 0,void 0,n),a=jt(i);return ot(a,e,t,o),a},ref:q,shallow:G,deep:U,struct:K},W=function(e,t,r){if("string"==typeof arguments[1]||"symbol"==typeof arguments[1])return U.apply(null,arguments);if(dt(e))return e;var o=u(e)?W.object(e,t,r):Array.isArray(e)?W.array(e,t):f(e)?W.map(e,t):p(e)?W.set(e,t):e;if(o!==e)return o;n(!1)};function J(e){n("Expected one or two arguments to observable."+e+". Did you accidentally try to use observable."+e+" as decorator?")}Object.keys(H).forEach((function(e){return W[e]=H[e]}));var X,Y,F=P(!1,(function(e,t,r,n,o){var i=r.get,a=r.set,s=o[0]||{};Ft(e).addComputedProp(e,t,S({get:i,set:a,context:e},s))})),$=F({equals:x.structural}),Q=function(e,t,r){if("string"==typeof t)return F.apply(null,arguments);if(null!==e&&"object"==typeof e&&1===arguments.length)return F.apply(null,arguments);var n="object"==typeof t?t:{};return n.get=e,n.set="function"==typeof t?t:n.set,n.name=n.name||e.name||"",new Oe(n)};Q.struct=$,(X=exports.IDerivationState||(exports.IDerivationState={}))[X.NOT_TRACKING=-1]="NOT_TRACKING",X[X.UP_TO_DATE=0]="UP_TO_DATE",X[X.POSSIBLY_STALE=1]="POSSIBLY_STALE",X[X.STALE=2]="STALE",function(e){e[e.NONE=0]="NONE",e[e.LOG=1]="LOG",e[e.BREAK=2]="BREAK"}(Y||(Y={}));var Z=function(e){this.cause=e};function ee(e){return e instanceof Z}function te(e){switch(e.dependenciesState){case exports.IDerivationState.UP_TO_DATE:return!1;case exports.IDerivationState.NOT_TRACKING:case exports.IDerivationState.STALE:return!0;case exports.IDerivationState.POSSIBLY_STALE:for(var t=ue(!0),r=ae(),n=e.observing,o=n.length,i=0;i<o;i++){var a=n[i];if(Se(a)){if(Re.disableErrorBoundaries)a.get();else try{a.get()}catch(e){return se(r),ce(t),!0}if(e.dependenciesState===exports.IDerivationState.STALE)return se(r),ce(t),!0}}return le(e),se(r),ce(t),!1}}function re(e){var t=e.observers.size>0;Re.computationDepth>0&&t&&n(!1),Re.allowStateChanges||!t&&"strict"!==Re.enforceActions||n(!1)}function ne(e,t,r){var n=ue(!0);le(e),e.newObserving=new Array(e.observing.length+100),e.unboundDepsCount=0,e.runId=++Re.runId;var o,i=Re.trackingDerivation;if(Re.trackingDerivation=e,!0===Re.disableErrorBoundaries)o=t.call(r);else try{o=t.call(r)}catch(e){o=new Z(e)}return Re.trackingDerivation=i,function(e){for(var t=e.observing,r=e.observing=e.newObserving,n=exports.IDerivationState.UP_TO_DATE,o=0,i=e.unboundDepsCount,a=0;a<i;a++){0===(s=r[a]).diffValue&&(s.diffValue=1,o!==a&&(r[o]=s),o++),s.dependenciesState>n&&(n=s.dependenciesState)}r.length=o,e.newObserving=null,i=t.length;for(;i--;){0===(s=t[i]).diffValue&&Ie(s,e),s.diffValue=0}for(;o--;){var s;1===(s=r[o]).diffValue&&(s.diffValue=0,Te(s,e))}n!==exports.IDerivationState.UP_TO_DATE&&(e.dependenciesState=n,e.onBecomeStale())}(e),ce(n),o}function oe(e){var t=e.observing;e.observing=[];for(var r=t.length;r--;)Ie(t[r],e);e.dependenciesState=exports.IDerivationState.NOT_TRACKING}function ie(e){var t=ae();try{return e()}finally{se(t)}}function ae(){var e=Re.trackingDerivation;return Re.trackingDerivation=null,e}function se(e){Re.trackingDerivation=e}function ue(e){var t=Re.allowStateReads;return Re.allowStateReads=e,t}function ce(e){Re.allowStateReads=e}function le(e){if(e.dependenciesState!==exports.IDerivationState.UP_TO_DATE){e.dependenciesState=exports.IDerivationState.UP_TO_DATE;for(var t=e.observing,r=t.length;r--;)t[r].lowestObserverState=exports.IDerivationState.UP_TO_DATE}}var fe=0,pe=1,he=Object.getOwnPropertyDescriptor((function(){}),"name");he&&he.configurable;function de(e,t,r){var n=function(){return ve(e,t,r||this,arguments)};return n.isMobxAction=!0,n}function ve(e,t,r,n){var o=ye();try{return t.apply(r,n)}catch(e){throw o.error=e,e}finally{be(o)}}function ye(e,t,r){var n=ae();Ne();var o={prevDerivation:n,prevAllowStateChanges:ge(!0),prevAllowStateReads:ue(!0),notifySpy:!1,startTime:0,actionId:pe++,parentActionId:fe};return fe=o.actionId,o}function be(e){fe!==e.actionId&&n("invalid action stack. did you forget to finish an action?"),fe=e.parentActionId,void 0!==e.error&&(Re.suppressReactionErrors=!0),me(e.prevAllowStateChanges),ce(e.prevAllowStateReads),Ve(),se(e.prevDerivation),e.notifySpy,Re.suppressReactionErrors=!1}function ge(e){var t=Re.allowStateChanges;return Re.allowStateChanges=e,t}function me(e){Re.allowStateChanges=e}var we=function(e){function t(t,n,o,i,a){void 0===o&&(o="ObservableValue@"+r()),void 0===i&&(i=!0),void 0===a&&(a=x.default);var s=e.call(this,o)||this;return s.enhancer=n,s.name=o,s.equals=a,s.hasUnreportedChange=!1,s.value=n(t,void 0,o),s}return function(e,t){function r(){this.constructor=e}O(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}(t,e),t.prototype.dehanceValue=function(e){return void 0!==this.dehancer?this.dehancer(e):e},t.prototype.set=function(e){this.value;if((e=this.prepareNewValue(e))!==Re.UNCHANGED){0,this.setNewValue(e)}},t.prototype.prepareNewValue=function(e){if(re(this),Ct(this)){var t=Tt(this,{object:this,type:"update",newValue:e});if(!t)return Re.UNCHANGED;e=t.newValue}return e=this.enhancer(e,this.value,this.name),this.equals(this.value,e)?Re.UNCHANGED:e},t.prototype.setNewValue=function(e){var t=this.value;this.value=e,this.reportChanged(),It(this)&&Nt(this,{type:"update",object:this,newValue:e,oldValue:t})},t.prototype.get=function(){return this.reportObserved(),this.dehanceValue(this.value)},t.prototype.intercept=function(e){return Rt(this,e)},t.prototype.observe=function(e,t){return t&&e({object:this,type:"update",newValue:this.value,oldValue:void 0}),Pt(this,e)},t.prototype.toJSON=function(){return this.get()},t.prototype.toString=function(){return this.name+"["+this.value+"]"},t.prototype.valueOf=function(){return v(this.get())},t.prototype[Symbol.toPrimitive]=function(){return this.valueOf()},t}(g),xe=l("ObservableValue",we),Oe=function(){function e(e){this.dependenciesState=exports.IDerivationState.NOT_TRACKING,this.observing=[],this.newObserving=null,this.isBeingObserved=!1,this.isPendingUnobservation=!1,this.observers=new Set,this.diffValue=0,this.runId=0,this.lastAccessedBy=0,this.lowestObserverState=exports.IDerivationState.UP_TO_DATE,this.unboundDepsCount=0,this.__mapid="#"+r(),this.value=new Z(null),this.isComputing=!1,this.isRunningSetter=!1,this.isTracing=Y.NONE,o(e.get,"missing option for computed: get"),this.derivation=e.get,this.name=e.name||"ComputedValue@"+r(),e.set&&(this.setter=de(this.name+"-setter",e.set)),this.equals=e.equals||(e.compareStructural||e.struct?x.structural:x.default),this.scope=e.context,this.requiresReaction=!!e.requiresReaction,this.keepAlive=!!e.keepAlive}return e.prototype.onBecomeStale=function(){!function(e){if(e.lowestObserverState!==exports.IDerivationState.UP_TO_DATE)return;e.lowestObserverState=exports.IDerivationState.POSSIBLY_STALE,e.observers.forEach((function(t){t.dependenciesState===exports.IDerivationState.UP_TO_DATE&&(t.dependenciesState=exports.IDerivationState.POSSIBLY_STALE,t.isTracing!==Y.NONE&&Be(t,e),t.onBecomeStale())}))}(this)},e.prototype.onBecomeObserved=function(){this.onBecomeObservedListeners&&this.onBecomeObservedListeners.forEach((function(e){return e()}))},e.prototype.onBecomeUnobserved=function(){this.onBecomeUnobservedListeners&&this.onBecomeUnobservedListeners.forEach((function(e){return e()}))},e.prototype.get=function(){this.isComputing&&n("Cycle detected in computation "+this.name+": "+this.derivation),0!==Re.inBatch||0!==this.observers.size||this.keepAlive?(ke(this),te(this)&&this.trackAndCompute()&&function(e){if(e.lowestObserverState===exports.IDerivationState.STALE)return;e.lowestObserverState=exports.IDerivationState.STALE,e.observers.forEach((function(t){t.dependenciesState===exports.IDerivationState.POSSIBLY_STALE?t.dependenciesState=exports.IDerivationState.STALE:t.dependenciesState===exports.IDerivationState.UP_TO_DATE&&(e.lowestObserverState=exports.IDerivationState.UP_TO_DATE)}))}(this)):te(this)&&(this.warnAboutUntrackedRead(),Ne(),this.value=this.computeValue(!1),Ve());var e=this.value;if(ee(e))throw e.cause;return e},e.prototype.peek=function(){var e=this.computeValue(!1);if(ee(e))throw e.cause;return e},e.prototype.set=function(e){if(this.setter){o(!this.isRunningSetter,"The setter of computed value '"+this.name+"' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?"),this.isRunningSetter=!0;try{this.setter.call(this.scope,e)}finally{this.isRunningSetter=!1}}else o(!1,!1)},e.prototype.trackAndCompute=function(){var e=this.value,t=this.dependenciesState===exports.IDerivationState.NOT_TRACKING,r=this.computeValue(!0),n=t||ee(e)||ee(r)||!this.equals(e,r);return n&&(this.value=r),n},e.prototype.computeValue=function(e){var t;if(this.isComputing=!0,Re.computationDepth++,e)t=ne(this,this.derivation,this.scope);else if(!0===Re.disableErrorBoundaries)t=this.derivation.call(this.scope);else try{t=this.derivation.call(this.scope)}catch(e){t=new Z(e)}return Re.computationDepth--,this.isComputing=!1,t},e.prototype.suspend=function(){this.keepAlive||(oe(this),this.value=void 0)},e.prototype.observe=function(e,t){var r=this,n=!0,o=void 0;return Fe((function(){var i=r.get();if(!n||t){var a=ae();e({type:"update",object:r,newValue:i,oldValue:o}),se(a)}n=!1,o=i}))},e.prototype.warnAboutUntrackedRead=function(){},e.prototype.toJSON=function(){return this.get()},e.prototype.toString=function(){return this.name+"["+this.derivation.toString()+"]"},e.prototype.valueOf=function(){return v(this.get())},e.prototype[Symbol.toPrimitive]=function(){return this.valueOf()},e}(),Se=l("ComputedValue",Oe),Ae=["mobxGuid","spyListeners","enforceActions","computedRequiresReaction","reactionRequiresObservable","observableRequiresReaction","allowStateReads","disableErrorBoundaries","runId","UNCHANGED"],_e=function(){this.version=5,this.UNCHANGED={},this.trackingDerivation=null,this.computationDepth=0,this.runId=0,this.mobxGuid=0,this.inBatch=0,this.pendingUnobservations=[],this.pendingReactions=[],this.isRunningReactions=!1,this.allowStateChanges=!0,this.allowStateReads=!0,this.enforceActions=!1,this.spyListeners=[],this.globalReactionErrorHandlers=[],this.computedRequiresReaction=!1,this.reactionRequiresObservable=!1,this.observableRequiresReaction=!1,this.computedConfigurable=!1,this.disableErrorBoundaries=!1,this.suppressReactionErrors=!1},Ee={};function De(){return"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:Ee}var je=!0,Ce=!1,Re=function(){var e=De();return e.__mobxInstanceCount>0&&!e.__mobxGlobals&&(je=!1),e.__mobxGlobals&&e.__mobxGlobals.version!==(new _e).version&&(je=!1),je?e.__mobxGlobals?(e.__mobxInstanceCount+=1,e.__mobxGlobals.UNCHANGED||(e.__mobxGlobals.UNCHANGED={}),e.__mobxGlobals):(e.__mobxInstanceCount=1,e.__mobxGlobals=new _e):(setTimeout((function(){Ce||n("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`")}),1),new _e)}();function Te(e,t){e.observers.add(t),e.lowestObserverState>t.dependenciesState&&(e.lowestObserverState=t.dependenciesState)}function Ie(e,t){e.observers.delete(t),0===e.observers.size&&Pe(e)}function Pe(e){!1===e.isPendingUnobservation&&(e.isPendingUnobservation=!0,Re.pendingUnobservations.push(e))}function Ne(){Re.inBatch++}function Ve(){if(0==--Re.inBatch){Ue();for(var e=Re.pendingUnobservations,t=0;t<e.length;t++){var r=e[t];r.isPendingUnobservation=!1,0===r.observers.size&&(r.isBeingObserved&&(r.isBeingObserved=!1,r.onBecomeUnobserved()),r instanceof Oe&&r.suspend())}Re.pendingUnobservations=[]}}function ke(e){var t=Re.trackingDerivation;return null!==t?(t.runId!==e.lastAccessedBy&&(e.lastAccessedBy=t.runId,t.newObserving[t.unboundDepsCount++]=e,e.isBeingObserved||(e.isBeingObserved=!0,e.onBecomeObserved())),!0):(0===e.observers.size&&Re.inBatch>0&&Pe(e),!1)}function Be(e,t){if(console.log("[mobx.trace] '"+e.name+"' is invalidated due to a change in: '"+t.name+"'"),e.isTracing===Y.BREAK){var r=[];!function e(t,r,n){if(r.length>=1e3)return void r.push("(and many more)");r.push(""+new Array(n).join("\t")+t.name),t.dependencies&&t.dependencies.forEach((function(t){return e(t,r,n+1)}))}(it(e),r,1),new Function("debugger;\n/*\nTracing '"+e.name+"'\n\nYou are entering this break point because derivation '"+e.name+"' is being traced and '"+t.name+"' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n"+(e instanceof Oe?e.derivation.toString().replace(/[*]\//g,"/"):"")+"\n\nThe dependencies for this derivation are:\n\n"+r.join("\n")+"\n*/\n    ")()}}var Le=function(){function e(e,t,n,o){void 0===e&&(e="Reaction@"+r()),void 0===o&&(o=!1),this.name=e,this.onInvalidate=t,this.errorHandler=n,this.requiresObservable=o,this.observing=[],this.newObserving=[],this.dependenciesState=exports.IDerivationState.NOT_TRACKING,this.diffValue=0,this.runId=0,this.unboundDepsCount=0,this.__mapid="#"+r(),this.isDisposed=!1,this._isScheduled=!1,this._isTrackPending=!1,this._isRunning=!1,this.isTracing=Y.NONE}return e.prototype.onBecomeStale=function(){this.schedule()},e.prototype.schedule=function(){this._isScheduled||(this._isScheduled=!0,Re.pendingReactions.push(this),Ue())},e.prototype.isScheduled=function(){return this._isScheduled},e.prototype.runReaction=function(){if(!this.isDisposed){if(Ne(),this._isScheduled=!1,te(this)){this._isTrackPending=!0;try{this.onInvalidate(),this._isTrackPending}catch(e){this.reportExceptionInDerivation(e)}}Ve()}},e.prototype.track=function(e){if(!this.isDisposed){Ne(),this._isRunning=!0;var t=ne(this,e,void 0);this._isRunning=!1,this._isTrackPending=!1,this.isDisposed&&oe(this),ee(t)&&this.reportExceptionInDerivation(t.cause),Ve()}},e.prototype.reportExceptionInDerivation=function(e){var t=this;if(this.errorHandler)this.errorHandler(e,this);else{if(Re.disableErrorBoundaries)throw e;var r="[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '"+this+"'";Re.suppressReactionErrors?console.warn("[mobx] (error in reaction '"+this.name+"' suppressed, fix error of causing action below)"):console.error(r,e),Re.globalReactionErrorHandlers.forEach((function(r){return r(e,t)}))}},e.prototype.dispose=function(){this.isDisposed||(this.isDisposed=!0,this._isRunning||(Ne(),oe(this),Ve()))},e.prototype.getDisposer=function(){var e=this.dispose.bind(this);return e[b]=this,e},e.prototype.toString=function(){return"Reaction["+this.name+"]"},e.prototype.trace=function(e){void 0===e&&(e=!1),wt(this,e)},e}();var Me=function(e){return e()};function Ue(){Re.inBatch>0||Re.isRunningReactions||Me(Ge)}function Ge(){Re.isRunningReactions=!0;for(var e=Re.pendingReactions,t=0;e.length>0;){100==++t&&(console.error("Reaction doesn't converge to a stable state after 100 iterations. Probably there is a cycle in the reactive function: "+e[0]),e.splice(0));for(var r=e.splice(0),n=0,o=r.length;n<o;n++)r[n].runReaction()}Re.isRunningReactions=!1}var qe=l("Reaction",Le);function Ke(e){var t=Me;Me=function(r){return e((function(){return t(r)}))}}function ze(e){return console.warn("[mobx.spy] Is a no-op in production builds"),function(){}}function He(){n(!1)}function We(e){return function(t,r,n){if(n){if(n.value)return{value:de(e,n.value),enumerable:!1,configurable:!0,writable:!0};var o=n.initializer;return{enumerable:!1,configurable:!0,writable:!0,initializer:function(){return de(e,o.call(this))}}}return Je(e).apply(this,arguments)}}function Je(e){return function(t,r,n){Object.defineProperty(t,r,{configurable:!0,enumerable:!1,get:function(){},set:function(t){c(this,r,Xe(e,t))}})}}var Xe=function(e,t,r,n){return 1===arguments.length&&"function"==typeof e?de(e.name||"<unnamed action>",e):2===arguments.length&&"function"==typeof t?de(e,t):1===arguments.length&&"string"==typeof e?We(e):!0!==n?We(t).apply(null,arguments):void c(e,t,de(e.name||t,r.value,this))};function Ye(e,t,r){c(e,t,de(t,r.bind(e)))}function Fe(e,n){void 0===n&&(n=t);var o,i=n&&n.name||e.name||"Autorun@"+r();if(!n.scheduler&&!n.delay)o=new Le(i,(function(){this.track(u)}),n.onError,n.requiresObservable);else{var a=Qe(n),s=!1;o=new Le(i,(function(){s||(s=!0,a((function(){s=!1,o.isDisposed||o.track(u)})))}),n.onError,n.requiresObservable)}function u(){e(o)}return o.schedule(),o.getDisposer()}Xe.bound=function(e,t,r,n){return!0===n?(Ye(e,t,r.value),null):r?{configurable:!0,enumerable:!1,get:function(){return Ye(this,t,r.value||r.initializer.call(this)),this[t]},set:He}:{enumerable:!1,configurable:!0,set:function(e){Ye(this,t,e)},get:function(){}}};var $e=function(e){return e()};function Qe(e){return e.scheduler?e.scheduler:e.delay?function(t){return setTimeout(t,e.delay)}:$e}function Ze(e,t,r){return tt("onBecomeObserved",e,t,r)}function et(e,t,r){return tt("onBecomeUnobserved",e,t,r)}function tt(e,t,r,o){var i="function"==typeof o?rr(t,r):rr(t),a="function"==typeof o?o:r,s=e+"Listeners";return i[s]?i[s].add(a):i[s]=new Set([a]),"function"!=typeof i[e]?n(!1):function(){var e=i[s];e&&(e.delete(a),0===e.size&&delete i[s])}}function rt(e,t,r,n){var o=nt(n=M(n));return I(e),Ft(e,n.name,o.enhancer),t&&ot(e,t,r,o),e}function nt(e){return e.defaultDecorator||(!1===e.deep?q:U)}function ot(e,t,r,n){var o,i;Ne();try{var a=y(t);try{for(var s=A(a),u=s.next();!u.done;u=s.next()){var c=u.value,l=Object.getOwnPropertyDescriptor(t,c);0;var f=r&&c in r?r[c]:l.get?F:n;0;var p=f(e,c,l,!0);p&&Object.defineProperty(e,c,p)}}catch(e){o={error:e}}finally{try{u&&!u.done&&(i=s.return)&&i.call(s)}finally{if(o)throw o.error}}}finally{Ve()}}function it(e,t){return at(rr(e,t))}function at(e){var t,r,n={name:e.name};return e.observing&&e.observing.length>0&&(n.dependencies=(t=e.observing,r=[],t.forEach((function(e){-1===r.indexOf(e)&&r.push(e)})),r).map(at)),n}function st(e){var t={name:e.name};return function(e){return e.observers&&e.observers.size>0}(e)&&(t.observers=Array.from(function(e){return e.observers}(e)).map(st)),t}var ut=0;function ct(){this.message="FLOW_CANCELLED"}function lt(e){"function"==typeof e.cancel&&e.cancel()}function ft(e,t){if(null==e)return!1;if(void 0!==t){if(!1===tr(e))return!1;if(!e[b].values.has(t))return!1;var r=rr(e,t);return Se(r)}return Se(e)}function pt(e){return arguments.length>1?n(!1):ft(e)}function ht(e,t){return null!=e&&(void 0!==t?!!tr(e)&&e[b].values.has(t):tr(e)||!!e[b]||m(e)||qe(e)||Se(e))}function dt(e){return 1!==arguments.length&&n(!1),ht(e)}function vt(e){return tr(e)?e[b].getKeys():Ht(e)?Array.from(e.keys()):Xt(e)?Array.from(e.keys()):Gt(e)?e.map((function(e,t){return t})):n(!1)}function yt(e,t,r){if(2!==arguments.length||Xt(e))if(tr(e)){var i=e[b],a=i.values.get(t);a?i.write(t,r):i.addObservableProp(t,r,i.defaultEnhancer)}else if(Ht(e))e.set(t,r);else if(Xt(e))e.add(t);else{if(!Gt(e))return n(!1);"number"!=typeof t&&(t=parseInt(t,10)),o(t>=0,"Not a valid index: '"+t+"'"),Ne(),t>=e.length&&(e.length=t+1),e[t]=r,Ve()}else{Ne();var s=t;try{for(var u in s)yt(e,u,s[u])}finally{Ve()}}}function bt(e,t){return tr(e)?nr(e).has(t):Ht(e)?e.has(t):Xt(e)?e.has(t):Gt(e)?t>=0&&t<e.length:n(!1)}ct.prototype=Object.create(Error.prototype);var gt={detectCycles:!0,exportMapsAsObjects:!0,recurseEverything:!1};function mt(e,t,r,n){return n.detectCycles&&e.set(t,r),r}function wt(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var r=!1;"boolean"==typeof e[e.length-1]&&(r=e.pop());var o=xt(e);if(!o)return n(!1);o.isTracing===Y.NONE&&console.log("[mobx.trace] '"+o.name+"' tracing enabled"),o.isTracing=r?Y.BREAK:Y.LOG}function xt(e){switch(e.length){case 0:return Re.trackingDerivation;case 1:return rr(e[0]);case 2:return rr(e[0],e[1])}}function Ot(e,t){void 0===t&&(t=void 0),Ne();try{return e.apply(t)}finally{Ve()}}function St(e,t,n){var o;"number"==typeof n.timeout&&(o=setTimeout((function(){if(!a[b].isDisposed){a();var e=new Error("WHEN_TIMEOUT");if(!n.onError)throw e;n.onError(e)}}),n.timeout)),n.name=n.name||"When@"+r();var i=de(n.name+"-effect",t),a=Fe((function(t){e()&&(t.dispose(),o&&clearTimeout(o),i())}),n);return a}function At(e,t){var r,n=new Promise((function(n,o){var i=St(e,n,S(S({},t),{onError:o}));r=function(){i(),o("WHEN_CANCELLED")}}));return n.cancel=r,n}function _t(e){return e[b]}function Et(e){return"string"==typeof e||"number"==typeof e||"symbol"==typeof e}var Dt={has:function(e,t){if(t===b||"constructor"===t||t===D)return!0;var r=_t(e);return Et(t)?r.has(t):t in e},get:function(e,t){if(t===b||"constructor"===t||t===D)return e[t];var r=_t(e),n=r.values.get(t);if(n instanceof g){var o=n.get();return void 0===o&&r.has(t),o}return Et(t)&&r.has(t),e[t]},set:function(e,t,r){return!!Et(t)&&(yt(e,t,r),!0)},deleteProperty:function(e,t){return!!Et(t)&&(_t(e).remove(t),!0)},ownKeys:function(e){return _t(e).keysAtom.reportObserved(),Reflect.ownKeys(e)},preventExtensions:function(e){return n("Dynamic observable objects cannot be frozen"),!1}};function jt(e){var t=new Proxy(e,Dt);return e[b].proxy=t,t}function Ct(e){return void 0!==e.interceptors&&e.interceptors.length>0}function Rt(e,t){var r=e.interceptors||(e.interceptors=[]);return r.push(t),i((function(){var e=r.indexOf(t);-1!==e&&r.splice(e,1)}))}function Tt(e,t){var r=ae();try{for(var n=E(e.interceptors||[]),i=0,a=n.length;i<a&&(o(!(t=n[i](t))||t.type,"Intercept handlers should return nothing or a change object"),t);i++);return t}finally{se(r)}}function It(e){return void 0!==e.changeListeners&&e.changeListeners.length>0}function Pt(e,t){var r=e.changeListeners||(e.changeListeners=[]);return r.push(t),i((function(){var e=r.indexOf(t);-1!==e&&r.splice(e,1)}))}function Nt(e,t){var r=ae(),n=e.changeListeners;if(n){for(var o=0,i=(n=n.slice()).length;o<i;o++)n[o](t);se(r)}}var Vt={get:function(e,t){return t===b?e[b]:"length"===t?e[b].getArrayLength():"number"==typeof t?Lt.get.call(e,t):"string"!=typeof t||isNaN(t)?Lt.hasOwnProperty(t)?Lt[t]:e[t]:Lt.get.call(e,parseInt(t))},set:function(e,t,r){return"length"===t&&e[b].setArrayLength(r),"number"==typeof t&&Lt.set.call(e,t,r),"symbol"==typeof t||isNaN(t)?e[t]=r:Lt.set.call(e,parseInt(t),r),!0},preventExtensions:function(e){return n("Observable arrays cannot be frozen"),!1}};function kt(e,t,n,o){void 0===n&&(n="ObservableArray@"+r()),void 0===o&&(o=!1);var i,a,s,u=new Bt(n,t,o);i=u.values,a=b,s=u,Object.defineProperty(i,a,{enumerable:!1,writable:!1,configurable:!0,value:s});var c=new Proxy(u.values,Vt);if(u.proxy=c,e&&e.length){var l=ge(!0);u.spliceWithArray(0,0,e),me(l)}return c}var Bt=function(){function t(e,t,n){this.owned=n,this.values=[],this.proxy=void 0,this.lastKnownLength=0,this.atom=new g(e||"ObservableArray@"+r()),this.enhancer=function(r,n){return t(r,n,e+"[..]")}}return t.prototype.dehanceValue=function(e){return void 0!==this.dehancer?this.dehancer(e):e},t.prototype.dehanceValues=function(e){return void 0!==this.dehancer&&e.length>0?e.map(this.dehancer):e},t.prototype.intercept=function(e){return Rt(this,e)},t.prototype.observe=function(e,t){return void 0===t&&(t=!1),t&&e({object:this.proxy,type:"splice",index:0,added:this.values.slice(),addedCount:this.values.length,removed:[],removedCount:0}),Pt(this,e)},t.prototype.getArrayLength=function(){return this.atom.reportObserved(),this.values.length},t.prototype.setArrayLength=function(e){if("number"!=typeof e||e<0)throw new Error("[mobx.array] Out of range: "+e);var t=this.values.length;if(e!==t)if(e>t){for(var r=new Array(e-t),n=0;n<e-t;n++)r[n]=void 0;this.spliceWithArray(t,0,r)}else this.spliceWithArray(e,t-e)},t.prototype.updateArrayLength=function(e,t){if(e!==this.lastKnownLength)throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed.");this.lastKnownLength+=t},t.prototype.spliceWithArray=function(t,r,n){var o=this;re(this.atom);var i=this.values.length;if(void 0===t?t=0:t>i?t=i:t<0&&(t=Math.max(0,i+t)),r=1===arguments.length?i-t:null==r?0:Math.max(0,Math.min(r,i-t)),void 0===n&&(n=e),Ct(this)){var a=Tt(this,{object:this.proxy,type:"splice",index:t,removedCount:r,added:n});if(!a)return e;r=a.removedCount,n=a.added}n=0===n.length?n:n.map((function(e){return o.enhancer(e,void 0)}));var s=this.spliceItemsIntoValues(t,r,n);return 0===r&&0===n.length||this.notifyArraySplice(t,n,s),this.dehanceValues(s)},t.prototype.spliceItemsIntoValues=function(e,t,r){var n;if(r.length<1e4)return(n=this.values).splice.apply(n,E([e,t],r));var o=this.values.slice(e,e+t);return this.values=this.values.slice(0,e).concat(r,this.values.slice(e+t)),o},t.prototype.notifyArrayChildUpdate=function(e,t,r){var n=!this.owned&&!1,o=It(this),i=o||n?{object:this.proxy,type:"update",index:e,newValue:t,oldValue:r}:null;this.atom.reportChanged(),o&&Nt(this,i)},t.prototype.notifyArraySplice=function(e,t,r){var n=!this.owned&&!1,o=It(this),i=o||n?{object:this.proxy,type:"splice",index:e,removed:r,added:t,removedCount:r.length,addedCount:t.length}:null;this.atom.reportChanged(),o&&Nt(this,i)},t}(),Lt={intercept:function(e){return this[b].intercept(e)},observe:function(e,t){return void 0===t&&(t=!1),this[b].observe(e,t)},clear:function(){return this.splice(0)},replace:function(e){var t=this[b];return t.spliceWithArray(0,t.values.length,e)},toJS:function(){return this.slice()},toJSON:function(){return this.toJS()},splice:function(e,t){for(var r=[],n=2;n<arguments.length;n++)r[n-2]=arguments[n];var o=this[b];switch(arguments.length){case 0:return[];case 1:return o.spliceWithArray(e);case 2:return o.spliceWithArray(e,t)}return o.spliceWithArray(e,t,r)},spliceWithArray:function(e,t,r){return this[b].spliceWithArray(e,t,r)},push:function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var r=this[b];return r.spliceWithArray(r.values.length,0,e),r.values.length},pop:function(){return this.splice(Math.max(this[b].values.length-1,0),1)[0]},shift:function(){return this.splice(0,1)[0]},unshift:function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var r=this[b];return r.spliceWithArray(0,0,e),r.values.length},reverse:function(){var e=this.slice();return e.reverse.apply(e,arguments)},sort:function(e){var t=this.slice();return t.sort.apply(t,arguments)},remove:function(e){var t=this[b],r=t.dehanceValues(t.values).indexOf(e);return r>-1&&(this.splice(r,1),!0)},get:function(e){var t=this[b];if(t){if(e<t.values.length)return t.atom.reportObserved(),t.dehanceValue(t.values[e]);console.warn("[mobx.array] Attempt to read an array index ("+e+") that is out of bounds ("+t.values.length+"). Please check length first. Out of bound indices will not be tracked by MobX")}},set:function(e,t){var r=this[b],n=r.values;if(e<n.length){re(r.atom);var o=n[e];if(Ct(r)){var i=Tt(r,{type:"update",object:r.proxy,index:e,newValue:t});if(!i)return;t=i.newValue}(t=r.enhancer(t,o))!==o&&(n[e]=t,r.notifyArrayChildUpdate(e,t,o))}else{if(e!==n.length)throw new Error("[mobx.array] Index out of bounds, "+e+" is larger than "+n.length);r.spliceWithArray(e,0,[t])}}};["concat","flat","includes","indexOf","join","lastIndexOf","slice","toString","toLocaleString"].forEach((function(e){"function"==typeof Array.prototype[e]&&(Lt[e]=function(){var t=this[b];t.atom.reportObserved();var r=t.dehanceValues(t.values);return r[e].apply(r,arguments)})})),["every","filter","find","findIndex","flatMap","forEach","map","some"].forEach((function(e){"function"==typeof Array.prototype[e]&&(Lt[e]=function(t,r){var n=this,o=this[b];return o.atom.reportObserved(),o.dehanceValues(o.values)[e]((function(e,o){return t.call(r,e,o,n)}),r)})})),["reduce","reduceRight"].forEach((function(e){Lt[e]=function(){var t=this,r=this[b];r.atom.reportObserved();var n=arguments[0];return arguments[0]=function(e,o,i){return o=r.dehanceValue(o),n(e,o,i,t)},r.values[e].apply(r.values,arguments)}}));var Mt,Ut=l("ObservableArrayAdministration",Bt);function Gt(e){return s(e)&&Ut(e[b])}var qt,Kt={},zt=function(){function e(e,t,n){if(void 0===t&&(t=V),void 0===n&&(n="ObservableMap@"+r()),this.enhancer=t,this.name=n,this[Mt]=Kt,this._keysAtom=w(this.name+".keys()"),this[Symbol.toStringTag]="Map","function"!=typeof Map)throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");this._data=new Map,this._hasMap=new Map,this.merge(e)}return e.prototype._has=function(e){return this._data.has(e)},e.prototype.has=function(e){var t=this;if(!Re.trackingDerivation)return this._has(e);var r=this._hasMap.get(e);if(!r){var n=r=new we(this._has(e),k,this.name+"."+d(e)+"?",!1);this._hasMap.set(e,n),et(n,(function(){return t._hasMap.delete(e)}))}return r.get()},e.prototype.set=function(e,t){var r=this._has(e);if(Ct(this)){var n=Tt(this,{type:r?"update":"add",object:this,newValue:t,name:e});if(!n)return this;t=n.newValue}return r?this._updateValue(e,t):this._addValue(e,t),this},e.prototype.delete=function(e){var t=this;if((re(this._keysAtom),Ct(this))&&!(n=Tt(this,{type:"delete",object:this,name:e})))return!1;if(this._has(e)){var r=It(this),n=r?{type:"delete",object:this,oldValue:this._data.get(e).value,name:e}:null;return Ot((function(){t._keysAtom.reportChanged(),t._updateHasMapEntry(e,!1),t._data.get(e).setNewValue(void 0),t._data.delete(e)})),r&&Nt(this,n),!0}return!1},e.prototype._updateHasMapEntry=function(e,t){var r=this._hasMap.get(e);r&&r.setNewValue(t)},e.prototype._updateValue=function(e,t){var r=this._data.get(e);if((t=r.prepareNewValue(t))!==Re.UNCHANGED){var n=It(this),o=n?{type:"update",object:this,oldValue:r.value,name:e,newValue:t}:null;0,r.setNewValue(t),n&&Nt(this,o)}},e.prototype._addValue=function(e,t){var r=this;re(this._keysAtom),Ot((function(){var n=new we(t,r.enhancer,r.name+"."+d(e),!1);r._data.set(e,n),t=n.value,r._updateHasMapEntry(e,!0),r._keysAtom.reportChanged()}));var n=It(this);n&&Nt(this,n?{type:"add",object:this,name:e,newValue:t}:null)},e.prototype.get=function(e){return this.has(e)?this.dehanceValue(this._data.get(e).get()):this.dehanceValue(void 0)},e.prototype.dehanceValue=function(e){return void 0!==this.dehancer?this.dehancer(e):e},e.prototype.keys=function(){return this._keysAtom.reportObserved(),this._data.keys()},e.prototype.values=function(){var e=this,t=this.keys();return cr({next:function(){var r=t.next(),n=r.done,o=r.value;return{done:n,value:n?void 0:e.get(o)}}})},e.prototype.entries=function(){var e=this,t=this.keys();return cr({next:function(){var r=t.next(),n=r.done,o=r.value;return{done:n,value:n?void 0:[o,e.get(o)]}}})},e.prototype[(Mt=b,Symbol.iterator)]=function(){return this.entries()},e.prototype.forEach=function(e,t){var r,n;try{for(var o=A(this),i=o.next();!i.done;i=o.next()){var a=_(i.value,2),s=a[0],u=a[1];e.call(t,u,s,this)}}catch(e){r={error:e}}finally{try{i&&!i.done&&(n=o.return)&&n.call(o)}finally{if(r)throw r.error}}},e.prototype.merge=function(e){var t=this;return Ht(e)&&(e=e.toJS()),Ot((function(){var r=ge(!0);try{u(e)?h(e).forEach((function(r){return t.set(r,e[r])})):Array.isArray(e)?e.forEach((function(e){var r=_(e,2),n=r[0],o=r[1];return t.set(n,o)})):f(e)?(e.constructor!==Map&&n("Cannot initialize from classes that inherit from Map: "+e.constructor.name),e.forEach((function(e,r){return t.set(r,e)}))):null!=e&&n("Cannot initialize map from "+e)}finally{me(r)}})),this},e.prototype.clear=function(){var e=this;Ot((function(){ie((function(){var t,r;try{for(var n=A(e.keys()),o=n.next();!o.done;o=n.next()){var i=o.value;e.delete(i)}}catch(e){t={error:e}}finally{try{o&&!o.done&&(r=n.return)&&r.call(n)}finally{if(t)throw t.error}}}))}))},e.prototype.replace=function(e){var t=this;return Ot((function(){var r,o,i,a,s=function(e){if(f(e)||Ht(e))return e;if(Array.isArray(e))return new Map(e);if(u(e)){var t=new Map;for(var r in e)t.set(r,e[r]);return t}return n("Cannot convert to map from '"+e+"'")}(e),c=new Map,l=!1;try{for(var p=A(t._data.keys()),h=p.next();!h.done;h=p.next()){var d=h.value;if(!s.has(d))if(t.delete(d))l=!0;else{var v=t._data.get(d);c.set(d,v)}}}catch(e){r={error:e}}finally{try{h&&!h.done&&(o=p.return)&&o.call(p)}finally{if(r)throw r.error}}try{for(var y=A(s.entries()),b=y.next();!b.done;b=y.next()){var g=_(b.value,2),m=(d=g[0],v=g[1],t._data.has(d));if(t.set(d,v),t._data.has(d)){var w=t._data.get(d);c.set(d,w),m||(l=!0)}}}catch(e){i={error:e}}finally{try{b&&!b.done&&(a=y.return)&&a.call(y)}finally{if(i)throw i.error}}if(!l)if(t._data.size!==c.size)t._keysAtom.reportChanged();else for(var x=t._data.keys(),O=c.keys(),S=x.next(),E=O.next();!S.done;){if(S.value!==E.value){t._keysAtom.reportChanged();break}S=x.next(),E=O.next()}t._data=c})),this},Object.defineProperty(e.prototype,"size",{get:function(){return this._keysAtom.reportObserved(),this._data.size},enumerable:!0,configurable:!0}),e.prototype.toPOJO=function(){var e,t,r={};try{for(var n=A(this),o=n.next();!o.done;o=n.next()){var i=_(o.value,2),a=i[0],s=i[1];r["symbol"==typeof a?a:d(a)]=s}}catch(t){e={error:t}}finally{try{o&&!o.done&&(t=n.return)&&t.call(n)}finally{if(e)throw e.error}}return r},e.prototype.toJS=function(){return new Map(this)},e.prototype.toJSON=function(){return this.toPOJO()},e.prototype.toString=function(){var e=this;return this.name+"[{ "+Array.from(this.keys()).map((function(t){return d(t)+": "+e.get(t)})).join(", ")+" }]"},e.prototype.observe=function(e,t){return Pt(this,e)},e.prototype.intercept=function(e){return Rt(this,e)},e}(),Ht=l("ObservableMap",zt),Wt={},Jt=function(){function e(e,t,n){if(void 0===t&&(t=V),void 0===n&&(n="ObservableSet@"+r()),this.name=n,this[qt]=Wt,this._data=new Set,this._atom=w(this.name),this[Symbol.toStringTag]="Set","function"!=typeof Set)throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");this.enhancer=function(e,r){return t(e,r,n)},e&&this.replace(e)}return e.prototype.dehanceValue=function(e){return void 0!==this.dehancer?this.dehancer(e):e},e.prototype.clear=function(){var e=this;Ot((function(){ie((function(){var t,r;try{for(var n=A(e._data.values()),o=n.next();!o.done;o=n.next()){var i=o.value;e.delete(i)}}catch(e){t={error:e}}finally{try{o&&!o.done&&(r=n.return)&&r.call(n)}finally{if(t)throw t.error}}}))}))},e.prototype.forEach=function(e,t){var r,n;try{for(var o=A(this),i=o.next();!i.done;i=o.next()){var a=i.value;e.call(t,a,a,this)}}catch(e){r={error:e}}finally{try{i&&!i.done&&(n=o.return)&&n.call(o)}finally{if(r)throw r.error}}},Object.defineProperty(e.prototype,"size",{get:function(){return this._atom.reportObserved(),this._data.size},enumerable:!0,configurable:!0}),e.prototype.add=function(e){var t=this;if((re(this._atom),Ct(this))&&!(n=Tt(this,{type:"add",object:this,newValue:e})))return this;if(!this.has(e)){Ot((function(){t._data.add(t.enhancer(e,void 0)),t._atom.reportChanged()}));var r=It(this),n=r?{type:"add",object:this,newValue:e}:null;r&&Nt(this,n)}return this},e.prototype.delete=function(e){var t=this;if(Ct(this)&&!(n=Tt(this,{type:"delete",object:this,oldValue:e})))return!1;if(this.has(e)){var r=It(this),n=r?{type:"delete",object:this,oldValue:e}:null;return Ot((function(){t._atom.reportChanged(),t._data.delete(e)})),r&&Nt(this,n),!0}return!1},e.prototype.has=function(e){return this._atom.reportObserved(),this._data.has(this.dehanceValue(e))},e.prototype.entries=function(){var e=0,t=Array.from(this.keys()),r=Array.from(this.values());return cr({next:function(){var n=e;return e+=1,n<r.length?{value:[t[n],r[n]],done:!1}:{done:!0}}})},e.prototype.keys=function(){return this.values()},e.prototype.values=function(){this._atom.reportObserved();var e=this,t=0,r=Array.from(this._data.values());return cr({next:function(){return t<r.length?{value:e.dehanceValue(r[t++]),done:!1}:{done:!0}}})},e.prototype.replace=function(e){var t=this;return Xt(e)&&(e=e.toJS()),Ot((function(){var r=ge(!0);try{Array.isArray(e)?(t.clear(),e.forEach((function(e){return t.add(e)}))):p(e)?(t.clear(),e.forEach((function(e){return t.add(e)}))):null!=e&&n("Cannot initialize set from "+e)}finally{me(r)}})),this},e.prototype.observe=function(e,t){return Pt(this,e)},e.prototype.intercept=function(e){return Rt(this,e)},e.prototype.toJS=function(){return new Set(this)},e.prototype.toString=function(){return this.name+"[ "+Array.from(this).join(", ")+" ]"},e.prototype[(qt=b,Symbol.iterator)]=function(){return this.values()},e}(),Xt=l("ObservableSet",Jt),Yt=function(){function e(e,t,r,n){void 0===t&&(t=new Map),this.target=e,this.values=t,this.name=r,this.defaultEnhancer=n,this.keysAtom=new g(r+".keys")}return e.prototype.read=function(e){return this.values.get(e).get()},e.prototype.write=function(e,t){var r=this.target,n=this.values.get(e);if(n instanceof Oe)n.set(t);else{if(Ct(this)){if(!(i=Tt(this,{type:"update",object:this.proxy||r,name:e,newValue:t})))return;t=i.newValue}if((t=n.prepareNewValue(t))!==Re.UNCHANGED){var o=It(this),i=o?{type:"update",object:this.proxy||r,oldValue:n.value,name:e,newValue:t}:null;0,n.setNewValue(t),o&&Nt(this,i)}}},e.prototype.has=function(e){var t=this.pendingKeys||(this.pendingKeys=new Map),r=t.get(e);if(r)return r.get();var n=!!this.values.get(e);return r=new we(n,k,this.name+"."+d(e)+"?",!1),t.set(e,r),r.get()},e.prototype.addObservableProp=function(e,t,r){void 0===r&&(r=this.defaultEnhancer);var n=this.target;if(Ct(this)){var o=Tt(this,{object:this.proxy||n,name:e,type:"add",newValue:t});if(!o)return;t=o.newValue}var i=new we(t,r,this.name+"."+d(e),!1);this.values.set(e,i),t=i.value,Object.defineProperty(n,e,function(e){return $t[e]||($t[e]={configurable:!0,enumerable:!0,get:function(){return this[b].read(e)},set:function(t){this[b].write(e,t)}})}(e)),this.notifyPropertyAddition(e,t)},e.prototype.addComputedProp=function(e,t,r){var n,o,i,a=this.target;r.name=r.name||this.name+"."+d(t),this.values.set(t,new Oe(r)),(e===a||(n=e,o=t,!(i=Object.getOwnPropertyDescriptor(n,o))||!1!==i.configurable&&!1!==i.writable))&&Object.defineProperty(e,t,function(e){return Qt[e]||(Qt[e]={configurable:Re.computedConfigurable,enumerable:!1,get:function(){return Zt(this).read(e)},set:function(t){Zt(this).write(e,t)}})}(t))},e.prototype.remove=function(e){if(this.values.has(e)){var t=this.target;if(Ct(this))if(!(a=Tt(this,{object:this.proxy||t,name:e,type:"remove"})))return;try{Ne();var r=It(this),n=this.values.get(e),o=n&&n.get();if(n&&n.set(void 0),this.keysAtom.reportChanged(),this.values.delete(e),this.pendingKeys){var i=this.pendingKeys.get(e);i&&i.set(!1)}delete this.target[e];var a=r?{type:"remove",object:this.proxy||t,oldValue:o,name:e}:null;0,r&&Nt(this,a)}finally{Ve()}}},e.prototype.illegalAccess=function(e,t){console.warn("Property '"+t+"' of '"+e+"' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner")},e.prototype.observe=function(e,t){return Pt(this,e)},e.prototype.intercept=function(e){return Rt(this,e)},e.prototype.notifyPropertyAddition=function(e,t){var r=It(this),n=r?{type:"add",object:this.proxy||this.target,name:e,newValue:t}:null;if(r&&Nt(this,n),this.pendingKeys){var o=this.pendingKeys.get(e);o&&o.set(!0)}this.keysAtom.reportChanged()},e.prototype.getKeys=function(){var e,t;this.keysAtom.reportObserved();var r=[];try{for(var n=A(this.values),o=n.next();!o.done;o=n.next()){var i=_(o.value,2),a=i[0];i[1]instanceof we&&r.push(a)}}catch(t){e={error:t}}finally{try{o&&!o.done&&(t=n.return)&&t.call(n)}finally{if(e)throw e.error}}return r},e}();function Ft(e,t,n){if(void 0===t&&(t=""),void 0===n&&(n=V),Object.prototype.hasOwnProperty.call(e,b))return e[b];u(e)||(t=(e.constructor.name||"ObservableObject")+"@"+r()),t||(t="ObservableObject@"+r());var o=new Yt(e,new Map,d(t),n);return c(e,b,o),o}var $t=Object.create(null),Qt=Object.create(null);function Zt(e){var t=e[b];return t||(I(e),e[b])}var er=l("ObservableObjectAdministration",Yt);function tr(e){return!!s(e)&&(I(e),er(e[b]))}function rr(e,t){if("object"==typeof e&&null!==e){if(Gt(e))return void 0!==t&&n(!1),e[b].atom;if(Xt(e))return e[b];if(Ht(e)){var r=e;return void 0===t?r._keysAtom:((o=r._data.get(t)||r._hasMap.get(t))||n(!1),o)}var o;if(I(e),t&&!e[b]&&e[t],tr(e))return t?((o=e[b].values.get(t))||n(!1),o):n(!1);if(m(e)||Se(e)||qe(e))return e}else if("function"==typeof e&&qe(e[b]))return e[b];return n(!1)}function nr(e,t){return e||n("Expecting some object"),void 0!==t?nr(rr(e,t)):m(e)||Se(e)||qe(e)?e:Ht(e)||Xt(e)?e:(I(e),e[b]?e[b]:void n(!1))}function or(e,t){return(void 0!==t?rr(e,t):tr(e)||Ht(e)||Xt(e)?nr(e):rr(e)).name}var ir=Object.prototype.toString;function ar(e,t,r){return void 0===r&&(r=-1),function e(t,r,n,o,i){if(t===r)return 0!==t||1/t==1/r;if(null==t||null==r)return!1;if(t!=t)return r!=r;var a=typeof t;if("function"!==a&&"object"!==a&&"object"!=typeof r)return!1;var s=ir.call(t);if(s!==ir.call(r))return!1;switch(s){case"[object RegExp]":case"[object String]":return""+t==""+r;case"[object Number]":return+t!=+t?+r!=+r:0==+t?1/+t==1/r:+t==+r;case"[object Date]":case"[object Boolean]":return+t==+r;case"[object Symbol]":return"undefined"!=typeof Symbol&&Symbol.valueOf.call(t)===Symbol.valueOf.call(r);case"[object Map]":case"[object Set]":n>=0&&n++}t=sr(t),r=sr(r);var u="[object Array]"===s;if(!u){if("object"!=typeof t||"object"!=typeof r)return!1;var c=t.constructor,l=r.constructor;if(c!==l&&!("function"==typeof c&&c instanceof c&&"function"==typeof l&&l instanceof l)&&"constructor"in t&&"constructor"in r)return!1}if(0===n)return!1;n<0&&(n=-1);i=i||[];var f=(o=o||[]).length;for(;f--;)if(o[f]===t)return i[f]===r;if(o.push(t),i.push(r),u){if((f=t.length)!==r.length)return!1;for(;f--;)if(!e(t[f],r[f],n-1,o,i))return!1}else{var p=Object.keys(t),h=void 0;if(f=p.length,Object.keys(r).length!==f)return!1;for(;f--;)if(h=p[f],!ur(r,h)||!e(t[h],r[h],n-1,o,i))return!1}return o.pop(),i.pop(),!0}(e,t,r)}function sr(e){return Gt(e)?e.slice():f(e)||Ht(e)?Array.from(e.entries()):p(e)||Xt(e)?Array.from(e.entries()):e}function ur(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function cr(e){return e[Symbol.iterator]=lr,e}function lr(){return this}if("undefined"==typeof Proxy||"undefined"==typeof Symbol)throw new Error("[mobx] MobX 5+ requires Proxy and Symbol objects. If your environment doesn't support Symbol or Proxy objects, please downgrade to MobX 4. For React Native Android, consider upgrading JSCore.");"object"==typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__&&__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({spy:ze,extras:{getDebugName:or},$mobx:b}),exports.$mobx=b,exports.FlowCancellationError=ct,exports.ObservableMap=zt,exports.ObservableSet=Jt,exports.Reaction=Le,exports._allowStateChanges=function(e,t){var r,n=ge(e);try{r=t()}finally{me(n)}return r},exports._allowStateChangesInsideComputed=function(e){var t,r=Re.computationDepth;Re.computationDepth=0;try{t=e()}finally{Re.computationDepth=r}return t},exports._allowStateReadsEnd=ce,exports._allowStateReadsStart=ue,exports._endAction=be,exports._getAdministration=nr,exports._getGlobalState=function(){return Re},exports._interceptReads=function(e,t,r){var o;if(Ht(e)||Gt(e)||xe(e))o=nr(e);else{if(!tr(e))return n(!1);if("string"!=typeof t)return n(!1);o=nr(e,t)}return void 0!==o.dehancer?n(!1):(o.dehancer="function"==typeof t?t:r,function(){o.dehancer=void 0})},exports._isComputingDerivation=function(){return null!==Re.trackingDerivation},exports._resetGlobalState=function(){var e=new _e;for(var t in e)-1===Ae.indexOf(t)&&(Re[t]=e[t]);Re.allowStateChanges=!Re.enforceActions},exports._startAction=ye,exports.action=Xe,exports.autorun=Fe,exports.comparer=x,exports.computed=Q,exports.configure=function(e){var t=e.enforceActions,r=e.computedRequiresReaction,o=e.computedConfigurable,i=e.disableErrorBoundaries,a=e.reactionScheduler,s=e.reactionRequiresObservable,u=e.observableRequiresReaction;if(!0===e.isolateGlobalState&&((Re.pendingReactions.length||Re.inBatch||Re.isRunningReactions)&&n("isolateGlobalState should be called before MobX is running any reactions"),Ce=!0,je&&(0==--De().__mobxInstanceCount&&(De().__mobxGlobals=void 0),Re=new _e)),void 0!==t){var c=void 0;switch(t){case!0:case"observed":c=!0;break;case!1:case"never":c=!1;break;case"strict":case"always":c="strict";break;default:n("Invalid value for 'enforceActions': '"+t+"', expected 'never', 'always' or 'observed'")}Re.enforceActions=c,Re.allowStateChanges=!0!==c&&"strict"!==c}void 0!==r&&(Re.computedRequiresReaction=!!r),void 0!==s&&(Re.reactionRequiresObservable=!!s),void 0!==u&&(Re.observableRequiresReaction=!!u,Re.allowStateReads=!Re.observableRequiresReaction),void 0!==o&&(Re.computedConfigurable=!!o),void 0!==i&&(!0===i&&console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."),Re.disableErrorBoundaries=!!i),a&&Ke(a)},exports.createAtom=w,exports.decorate=function(e,t){var r="function"==typeof e?e.prototype:e,n=function(e){var n=t[e];Array.isArray(n)||(n=[n]);var o=Object.getOwnPropertyDescriptor(r,e),i=n.reduce((function(t,n){return n(r,e,t)}),o);i&&Object.defineProperty(r,e,i)};for(var o in t)n(o);return e},exports.entries=function(e){return tr(e)?vt(e).map((function(t){return[t,e[t]]})):Ht(e)?vt(e).map((function(t){return[t,e.get(t)]})):Xt(e)?Array.from(e.entries()):Gt(e)?e.map((function(e,t){return[t,e]})):n(!1)},exports.extendObservable=rt,exports.flow=function(e){1!==arguments.length&&n("Flow expects 1 argument and cannot be used as decorator");var t=e.name||"<unnamed flow>";return function(){var r,n=this,o=arguments,i=++ut,s=Xe(t+" - runid: "+i+" - init",e).apply(n,o),u=void 0,c=new Promise((function(e,n){var o=0;function a(e){var r;u=void 0;try{r=Xe(t+" - runid: "+i+" - yield "+o++,s.next).call(s,e)}catch(e){return n(e)}l(r)}function c(e){var r;u=void 0;try{r=Xe(t+" - runid: "+i+" - yield "+o++,s.throw).call(s,e)}catch(e){return n(e)}l(r)}function l(t){if(!t||"function"!=typeof t.then)return t.done?e(t.value):(u=Promise.resolve(t.value)).then(a,c);t.then(l,n)}r=n,a(void 0)}));return c.cancel=Xe(t+" - runid: "+i+" - cancel",(function(){try{u&&lt(u);var e=s.return(void 0),t=Promise.resolve(e.value);t.then(a,a),lt(t),r(new ct)}catch(e){r(e)}})),c}},exports.get=function(e,t){if(bt(e,t))return tr(e)?e[t]:Ht(e)?e.get(t):Gt(e)?e[t]:n(!1)},exports.getAtom=rr,exports.getDebugName=or,exports.getDependencyTree=it,exports.getObserverTree=function(e,t){return st(rr(e,t))},exports.has=bt,exports.intercept=function(e,t,r){return"function"==typeof r?function(e,t,r){return nr(e,t).intercept(r)}(e,t,r):function(e,t){return nr(e).intercept(t)}(e,t)},exports.isAction=function(e){return"function"==typeof e&&!0===e.isMobxAction},exports.isArrayLike=function(e){return Array.isArray(e)||Gt(e)},exports.isBoxedObservable=xe,exports.isComputed=pt,exports.isComputedProp=function(e,t){return"string"!=typeof t?n(!1):ft(e,t)},exports.isFlowCancellationError=function(e){return e instanceof ct},exports.isObservable=dt,exports.isObservableArray=Gt,exports.isObservableMap=Ht,exports.isObservableObject=tr,exports.isObservableProp=function(e,t){return"string"!=typeof t?n(!1):ht(e,t)},exports.isObservableSet=Xt,exports.keys=vt,exports.observable=W,exports.observe=function(e,t,r,n){return"function"==typeof r?function(e,t,r,n){return nr(e,t).observe(r,n)}(e,t,r,n):function(e,t,r){return nr(e).observe(t,r)}(e,t,r)},exports.onBecomeObserved=Ze,exports.onBecomeUnobserved=et,exports.onReactionError=function(e){return Re.globalReactionErrorHandlers.push(e),function(){var t=Re.globalReactionErrorHandlers.indexOf(e);t>=0&&Re.globalReactionErrorHandlers.splice(t,1)}},exports.reaction=function(e,n,o){void 0===o&&(o=t);var i,a,s,u=o.name||"Reaction@"+r(),c=Xe(u,o.onError?(i=o.onError,a=n,function(){try{return a.apply(this,arguments)}catch(e){i.call(this,e)}}):n),l=!o.scheduler&&!o.delay,f=Qe(o),p=!0,h=!1,d=o.compareStructural?x.structural:o.equals||x.default,v=new Le(u,(function(){p||l?y():h||(h=!0,f(y))}),o.onError,o.requiresObservable);function y(){if(h=!1,!v.isDisposed){var t=!1;v.track((function(){var r=e(v);t=p||!d(s,r),s=r})),p&&o.fireImmediately&&c(s,v),p||!0!==t||c(s,v),p&&(p=!1)}}return v.schedule(),v.getDisposer()},exports.remove=function(e,t){if(tr(e))e[b].remove(t);else if(Ht(e))e.delete(t);else if(Xt(e))e.delete(t);else{if(!Gt(e))return n(!1);"number"!=typeof t&&(t=parseInt(t,10)),o(t>=0,"Not a valid index: '"+t+"'"),e.splice(t,1)}},exports.runInAction=function(e,t){return"string"==typeof e||e.name,ve(0,"function"==typeof e?e:t,this,void 0)},exports.set=yt,exports.spy=ze,exports.toJS=function(e,t){var r;return"boolean"==typeof t&&(t={detectCycles:t}),t||(t=gt),t.detectCycles=void 0===t.detectCycles?!0===t.recurseEverything:!0===t.detectCycles,t.detectCycles&&(r=new Map),function e(t,r,n){if(!r.recurseEverything&&!dt(t))return t;if("object"!=typeof t)return t;if(null===t)return null;if(t instanceof Date)return t;if(xe(t))return e(t.get(),r,n);if(dt(t)&&vt(t),!0===r.detectCycles&&null!==t&&n.has(t))return n.get(t);if(Gt(t)||Array.isArray(t)){var o=mt(n,t,[],r),i=t.map((function(t){return e(t,r,n)}));o.length=i.length;for(var a=0,s=i.length;a<s;a++)o[a]=i[a];return o}if(Xt(t)||Object.getPrototypeOf(t)===Set.prototype){if(!1===r.exportMapsAsObjects){var u=mt(n,t,new Set,r);return t.forEach((function(t){u.add(e(t,r,n))})),u}var c=mt(n,t,[],r);return t.forEach((function(t){c.push(e(t,r,n))})),c}if(Ht(t)||Object.getPrototypeOf(t)===Map.prototype){if(!1===r.exportMapsAsObjects){var l=mt(n,t,new Map,r);return t.forEach((function(t,o){l.set(o,e(t,r,n))})),l}var f=mt(n,t,{},r);return t.forEach((function(t,o){f[o]=e(t,r,n)})),f}var p=mt(n,t,{},r);return h(t).forEach((function(o){p[o]=e(t[o],r,n)})),p}(e,t,r)},exports.trace=wt,exports.transaction=Ot,exports.untracked=ie,exports.values=function(e){return tr(e)?vt(e).map((function(t){return e[t]})):Ht(e)?vt(e).map((function(t){return e.get(t)})):Xt(e)?Array.from(e.values()):Gt(e)?e.slice():n(!1)},exports.when=function(e,t,r){return 1===arguments.length||t&&"object"==typeof t?At(e,t):St(e,t,r||{})};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), (function() { return this; }())))

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(1081);
	moment.tz.load(__webpack_require__(1060));


/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.43
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (typeof module === 'object' && module.exports) {
			module.exports = factory(__webpack_require__(3)); // Node
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Resolves es6 module loading issue
		if (moment.version === undefined && moment.default) {
			moment = moment.default;
		}
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.43",
			zones = {},
			links = {},
			countries = {},
			names = {},
			guesses = {},
			cachedGuess;
	
		if (!moment || typeof moment.version !== 'string') {
			logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
		}
	
		var momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			countries : function () {
				var zone_name = this.name;
				return Object.keys(countries).filter(function (country_code) {
					return countries[country_code].zones.indexOf(zone_name) !== -1;
				});
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				logError("zone.offset has been deprecated in favor of zone.utcOffset");
				return this.offsets[this._index(mom)];
			},
	
			utcOffset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Country object
		************************************/
	
		function Country (country_name, zone_names) {
			this.name = country_name;
			this.zones = zone_names;
		}
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			if (a.zone.population !== b.zone.population) {
				return b.zone.population - a.zone.population;
			}
			return b.zone.name.localeCompare(a.zone.name);
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName && intlName.length > 3) {
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	
		function getZone (name, caller) {
	
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function getCountryNames () {
			return Object.keys(countries);
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function addCountries (data) {
			var i, country_code, country_zones, split;
			if (!data || !data.length) return;
			for (i = 0; i < data.length; i++) {
				split = data[i].split('|');
				country_code = split[0].toUpperCase();
				country_zones = split[1].split(' ');
				countries[country_code] = new Country(
					country_code,
					country_zones
				);
			}
		}
	
		function getCountry (name) {
			name = name.toUpperCase();
			return countries[name] || null;
		}
	
		function zonesForCountry(country, with_offset) {
			country = getCountry(country);
	
			if (!country) return null;
	
			var zones = country.zones.sort();
	
			if (with_offset) {
				return zones.map(function (zone_name) {
					var zone = getZone(zone_name);
					return {
						name: zone_name,
						offset: zone.utcOffset(new Date())
					};
				});
			}
	
			return zones;
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			addCountries(data.countries);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
			return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz._countries	= countries;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
		tz.countries    = getCountryNames;
		tz.zonesForCountry = zonesForCountry;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.utcOffset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					var z = mom._z;
					mom.utcOffset(-offset, keepTime);
					mom._z = z;
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name, keepTime) {
			if (name) {
				if (typeof name !== 'string') {
					throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
				}
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this, keepTime);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		function resetZoneWrap2 (old) {
			return function () {
				if (arguments.length > 0) this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName  = abbrWrap(fn.zoneName);
		fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
		fn.utc       = resetZoneWrap(fn.utc);
		fn.local     = resetZoneWrap(fn.local);
		fn.utcOffset = resetZoneWrap2(fn.utcOffset);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 338,
		"./af.js": 338,
		"./ar": 345,
		"./ar-dz": 339,
		"./ar-dz.js": 339,
		"./ar-kw": 340,
		"./ar-kw.js": 340,
		"./ar-ly": 341,
		"./ar-ly.js": 341,
		"./ar-ma": 342,
		"./ar-ma.js": 342,
		"./ar-sa": 343,
		"./ar-sa.js": 343,
		"./ar-tn": 344,
		"./ar-tn.js": 344,
		"./ar.js": 345,
		"./az": 346,
		"./az.js": 346,
		"./be": 347,
		"./be.js": 347,
		"./bg": 348,
		"./bg.js": 348,
		"./bm": 349,
		"./bm.js": 349,
		"./bn": 351,
		"./bn-bd": 350,
		"./bn-bd.js": 350,
		"./bn.js": 351,
		"./bo": 352,
		"./bo.js": 352,
		"./br": 353,
		"./br.js": 353,
		"./bs": 354,
		"./bs.js": 354,
		"./ca": 355,
		"./ca.js": 355,
		"./cs": 356,
		"./cs.js": 356,
		"./cv": 357,
		"./cv.js": 357,
		"./cy": 358,
		"./cy.js": 358,
		"./da": 359,
		"./da.js": 359,
		"./de": 362,
		"./de-at": 360,
		"./de-at.js": 360,
		"./de-ch": 361,
		"./de-ch.js": 361,
		"./de.js": 362,
		"./dv": 363,
		"./dv.js": 363,
		"./el": 364,
		"./el.js": 364,
		"./en-au": 365,
		"./en-au.js": 365,
		"./en-ca": 366,
		"./en-ca.js": 366,
		"./en-gb": 367,
		"./en-gb.js": 367,
		"./en-ie": 368,
		"./en-ie.js": 368,
		"./en-il": 369,
		"./en-il.js": 369,
		"./en-in": 370,
		"./en-in.js": 370,
		"./en-nz": 371,
		"./en-nz.js": 371,
		"./en-sg": 372,
		"./en-sg.js": 372,
		"./eo": 373,
		"./eo.js": 373,
		"./es": 377,
		"./es-do": 374,
		"./es-do.js": 374,
		"./es-mx": 375,
		"./es-mx.js": 375,
		"./es-us": 376,
		"./es-us.js": 376,
		"./es.js": 377,
		"./et": 378,
		"./et.js": 378,
		"./eu": 379,
		"./eu.js": 379,
		"./fa": 380,
		"./fa.js": 380,
		"./fi": 381,
		"./fi.js": 381,
		"./fil": 382,
		"./fil.js": 382,
		"./fo": 383,
		"./fo.js": 383,
		"./fr": 386,
		"./fr-ca": 384,
		"./fr-ca.js": 384,
		"./fr-ch": 385,
		"./fr-ch.js": 385,
		"./fr.js": 386,
		"./fy": 387,
		"./fy.js": 387,
		"./ga": 388,
		"./ga.js": 388,
		"./gd": 389,
		"./gd.js": 389,
		"./gl": 390,
		"./gl.js": 390,
		"./gom-deva": 391,
		"./gom-deva.js": 391,
		"./gom-latn": 392,
		"./gom-latn.js": 392,
		"./gu": 393,
		"./gu.js": 393,
		"./he": 394,
		"./he.js": 394,
		"./hi": 395,
		"./hi.js": 395,
		"./hr": 396,
		"./hr.js": 396,
		"./hu": 397,
		"./hu.js": 397,
		"./hy-am": 398,
		"./hy-am.js": 398,
		"./id": 399,
		"./id.js": 399,
		"./is": 400,
		"./is.js": 400,
		"./it": 402,
		"./it-ch": 401,
		"./it-ch.js": 401,
		"./it.js": 402,
		"./ja": 403,
		"./ja.js": 403,
		"./jv": 404,
		"./jv.js": 404,
		"./ka": 405,
		"./ka.js": 405,
		"./kk": 406,
		"./kk.js": 406,
		"./km": 407,
		"./km.js": 407,
		"./kn": 408,
		"./kn.js": 408,
		"./ko": 409,
		"./ko.js": 409,
		"./ku": 410,
		"./ku.js": 410,
		"./ky": 411,
		"./ky.js": 411,
		"./lb": 412,
		"./lb.js": 412,
		"./lo": 413,
		"./lo.js": 413,
		"./lt": 414,
		"./lt.js": 414,
		"./lv": 415,
		"./lv.js": 415,
		"./me": 416,
		"./me.js": 416,
		"./mi": 417,
		"./mi.js": 417,
		"./mk": 418,
		"./mk.js": 418,
		"./ml": 419,
		"./ml.js": 419,
		"./mn": 420,
		"./mn.js": 420,
		"./mr": 421,
		"./mr.js": 421,
		"./ms": 423,
		"./ms-my": 422,
		"./ms-my.js": 422,
		"./ms.js": 423,
		"./mt": 424,
		"./mt.js": 424,
		"./my": 425,
		"./my.js": 425,
		"./nb": 426,
		"./nb.js": 426,
		"./ne": 427,
		"./ne.js": 427,
		"./nl": 429,
		"./nl-be": 428,
		"./nl-be.js": 428,
		"./nl.js": 429,
		"./nn": 430,
		"./nn.js": 430,
		"./oc-lnc": 431,
		"./oc-lnc.js": 431,
		"./pa-in": 432,
		"./pa-in.js": 432,
		"./pl": 433,
		"./pl.js": 433,
		"./pt": 435,
		"./pt-br": 434,
		"./pt-br.js": 434,
		"./pt.js": 435,
		"./ro": 436,
		"./ro.js": 436,
		"./ru": 437,
		"./ru.js": 437,
		"./sd": 438,
		"./sd.js": 438,
		"./se": 439,
		"./se.js": 439,
		"./si": 440,
		"./si.js": 440,
		"./sk": 441,
		"./sk.js": 441,
		"./sl": 442,
		"./sl.js": 442,
		"./sq": 443,
		"./sq.js": 443,
		"./sr": 445,
		"./sr-cyrl": 444,
		"./sr-cyrl.js": 444,
		"./sr.js": 445,
		"./ss": 446,
		"./ss.js": 446,
		"./sv": 447,
		"./sv.js": 447,
		"./sw": 448,
		"./sw.js": 448,
		"./ta": 449,
		"./ta.js": 449,
		"./te": 450,
		"./te.js": 450,
		"./tet": 451,
		"./tet.js": 451,
		"./tg": 452,
		"./tg.js": 452,
		"./th": 453,
		"./th.js": 453,
		"./tk": 454,
		"./tk.js": 454,
		"./tl-ph": 455,
		"./tl-ph.js": 455,
		"./tlh": 456,
		"./tlh.js": 456,
		"./tr": 457,
		"./tr.js": 457,
		"./tzl": 458,
		"./tzl.js": 458,
		"./tzm": 460,
		"./tzm-latn": 459,
		"./tzm-latn.js": 459,
		"./tzm.js": 460,
		"./ug-cn": 461,
		"./ug-cn.js": 461,
		"./uk": 462,
		"./uk.js": 462,
		"./ur": 463,
		"./ur.js": 463,
		"./uz": 465,
		"./uz-latn": 464,
		"./uz-latn.js": 464,
		"./uz.js": 465,
		"./vi": 466,
		"./vi.js": 466,
		"./x-pseudo": 467,
		"./x-pseudo.js": 467,
		"./yo": 468,
		"./yo.js": 468,
		"./zh-cn": 469,
		"./zh-cn.js": 469,
		"./zh-hk": 470,
		"./zh-hk.js": 470,
		"./zh-mo": 471,
		"./zh-mo.js": 471,
		"./zh-tw": 472,
		"./zh-tw.js": 472
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1082;


/***/ },
/* 1083 */
/***/ function(module, exports) {



/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
	var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
	var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
	var mapForEach = hasMap && Map.prototype.forEach;
	var hasSet = typeof Set === 'function' && Set.prototype;
	var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
	var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
	var setForEach = hasSet && Set.prototype.forEach;
	var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
	var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
	var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
	var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
	var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
	var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
	var booleanValueOf = Boolean.prototype.valueOf;
	var objectToString = Object.prototype.toString;
	var functionToString = Function.prototype.toString;
	var $match = String.prototype.match;
	var $slice = String.prototype.slice;
	var $replace = String.prototype.replace;
	var $toUpperCase = String.prototype.toUpperCase;
	var $toLowerCase = String.prototype.toLowerCase;
	var $test = RegExp.prototype.test;
	var $concat = Array.prototype.concat;
	var $join = Array.prototype.join;
	var $arrSlice = Array.prototype.slice;
	var $floor = Math.floor;
	var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
	var gOPS = Object.getOwnPropertySymbols;
	var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
	var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
	// ie, `has-tostringtag/shams
	var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
	    ? Symbol.toStringTag
	    : null;
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	
	var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
	    [].__proto__ === Array.prototype // eslint-disable-line no-proto
	        ? function (O) {
	            return O.__proto__; // eslint-disable-line no-proto
	        }
	        : null
	);
	
	function addNumericSeparator(num, str) {
	    if (
	        num === Infinity
	        || num === -Infinity
	        || num !== num
	        || (num && num > -1000 && num < 1000)
	        || $test.call(/e/, str)
	    ) {
	        return str;
	    }
	    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
	    if (typeof num === 'number') {
	        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
	        if (int !== num) {
	            var intStr = String(int);
	            var dec = $slice.call(str, intStr.length + 1);
	            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
	        }
	    }
	    return $replace.call(str, sepRegex, '$&_');
	}
	
	var utilInspect = __webpack_require__(1294);
	var inspectCustom = utilInspect.custom;
	var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
	
	module.exports = function inspect_(obj, options, depth, seen) {
	    var opts = options || {};
	
	    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
	        throw new TypeError('option "quoteStyle" must be "single" or "double"');
	    }
	    if (
	        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
	            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
	            : opts.maxStringLength !== null
	        )
	    ) {
	        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
	    }
	    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
	    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
	        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
	    }
	
	    if (
	        has(opts, 'indent')
	        && opts.indent !== null
	        && opts.indent !== '\t'
	        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
	    ) {
	        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
	    }
	    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
	        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
	    }
	    var numericSeparator = opts.numericSeparator;
	
	    if (typeof obj === 'undefined') {
	        return 'undefined';
	    }
	    if (obj === null) {
	        return 'null';
	    }
	    if (typeof obj === 'boolean') {
	        return obj ? 'true' : 'false';
	    }
	
	    if (typeof obj === 'string') {
	        return inspectString(obj, opts);
	    }
	    if (typeof obj === 'number') {
	        if (obj === 0) {
	            return Infinity / obj > 0 ? '0' : '-0';
	        }
	        var str = String(obj);
	        return numericSeparator ? addNumericSeparator(obj, str) : str;
	    }
	    if (typeof obj === 'bigint') {
	        var bigIntStr = String(obj) + 'n';
	        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
	    }
	
	    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
	    if (typeof depth === 'undefined') { depth = 0; }
	    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
	        return isArray(obj) ? '[Array]' : '[Object]';
	    }
	
	    var indent = getIndent(opts, depth);
	
	    if (typeof seen === 'undefined') {
	        seen = [];
	    } else if (indexOf(seen, obj) >= 0) {
	        return '[Circular]';
	    }
	
	    function inspect(value, from, noIndent) {
	        if (from) {
	            seen = $arrSlice.call(seen);
	            seen.push(from);
	        }
	        if (noIndent) {
	            var newOpts = {
	                depth: opts.depth
	            };
	            if (has(opts, 'quoteStyle')) {
	                newOpts.quoteStyle = opts.quoteStyle;
	            }
	            return inspect_(value, newOpts, depth + 1, seen);
	        }
	        return inspect_(value, opts, depth + 1, seen);
	    }
	
	    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
	        var name = nameOf(obj);
	        var keys = arrObjKeys(obj, inspect);
	        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
	    }
	    if (isSymbol(obj)) {
	        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
	        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
	    }
	    if (isElement(obj)) {
	        var s = '<' + $toLowerCase.call(String(obj.nodeName));
	        var attrs = obj.attributes || [];
	        for (var i = 0; i < attrs.length; i++) {
	            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
	        }
	        s += '>';
	        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
	        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
	        return s;
	    }
	    if (isArray(obj)) {
	        if (obj.length === 0) { return '[]'; }
	        var xs = arrObjKeys(obj, inspect);
	        if (indent && !singleLineValues(xs)) {
	            return '[' + indentedJoin(xs, indent) + ']';
	        }
	        return '[ ' + $join.call(xs, ', ') + ' ]';
	    }
	    if (isError(obj)) {
	        var parts = arrObjKeys(obj, inspect);
	        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
	            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
	        }
	        if (parts.length === 0) { return '[' + String(obj) + ']'; }
	        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
	    }
	    if (typeof obj === 'object' && customInspect) {
	        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
	            return utilInspect(obj, { depth: maxDepth - depth });
	        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
	            return obj.inspect();
	        }
	    }
	    if (isMap(obj)) {
	        var mapParts = [];
	        if (mapForEach) {
	            mapForEach.call(obj, function (value, key) {
	                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
	            });
	        }
	        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
	    }
	    if (isSet(obj)) {
	        var setParts = [];
	        if (setForEach) {
	            setForEach.call(obj, function (value) {
	                setParts.push(inspect(value, obj));
	            });
	        }
	        return collectionOf('Set', setSize.call(obj), setParts, indent);
	    }
	    if (isWeakMap(obj)) {
	        return weakCollectionOf('WeakMap');
	    }
	    if (isWeakSet(obj)) {
	        return weakCollectionOf('WeakSet');
	    }
	    if (isWeakRef(obj)) {
	        return weakCollectionOf('WeakRef');
	    }
	    if (isNumber(obj)) {
	        return markBoxed(inspect(Number(obj)));
	    }
	    if (isBigInt(obj)) {
	        return markBoxed(inspect(bigIntValueOf.call(obj)));
	    }
	    if (isBoolean(obj)) {
	        return markBoxed(booleanValueOf.call(obj));
	    }
	    if (isString(obj)) {
	        return markBoxed(inspect(String(obj)));
	    }
	    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
	    /* eslint-env browser */
	    if (typeof window !== 'undefined' && obj === window) {
	        return '{ [object Window] }';
	    }
	    if (obj === global) {
	        return '{ [object globalThis] }';
	    }
	    if (!isDate(obj) && !isRegExp(obj)) {
	        var ys = arrObjKeys(obj, inspect);
	        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
	        var protoTag = obj instanceof Object ? '' : 'null prototype';
	        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
	        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
	        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
	        if (ys.length === 0) { return tag + '{}'; }
	        if (indent) {
	            return tag + '{' + indentedJoin(ys, indent) + '}';
	        }
	        return tag + '{ ' + $join.call(ys, ', ') + ' }';
	    }
	    return String(obj);
	};
	
	function wrapQuotes(s, defaultStyle, opts) {
	    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
	    return quoteChar + s + quoteChar;
	}
	
	function quote(s) {
	    return $replace.call(String(s), /"/g, '&quot;');
	}
	
	function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
	
	// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
	function isSymbol(obj) {
	    if (hasShammedSymbols) {
	        return obj && typeof obj === 'object' && obj instanceof Symbol;
	    }
	    if (typeof obj === 'symbol') {
	        return true;
	    }
	    if (!obj || typeof obj !== 'object' || !symToString) {
	        return false;
	    }
	    try {
	        symToString.call(obj);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	function isBigInt(obj) {
	    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
	        return false;
	    }
	    try {
	        bigIntValueOf.call(obj);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
	function has(obj, key) {
	    return hasOwn.call(obj, key);
	}
	
	function toStr(obj) {
	    return objectToString.call(obj);
	}
	
	function nameOf(f) {
	    if (f.name) { return f.name; }
	    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
	    if (m) { return m[1]; }
	    return null;
	}
	
	function indexOf(xs, x) {
	    if (xs.indexOf) { return xs.indexOf(x); }
	    for (var i = 0, l = xs.length; i < l; i++) {
	        if (xs[i] === x) { return i; }
	    }
	    return -1;
	}
	
	function isMap(x) {
	    if (!mapSize || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        mapSize.call(x);
	        try {
	            setSize.call(x);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof Map; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakMap(x) {
	    if (!weakMapHas || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakMapHas.call(x, weakMapHas);
	        try {
	            weakSetHas.call(x, weakSetHas);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakRef(x) {
	    if (!weakRefDeref || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakRefDeref.call(x);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	function isSet(x) {
	    if (!setSize || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        setSize.call(x);
	        try {
	            mapSize.call(x);
	        } catch (m) {
	            return true;
	        }
	        return x instanceof Set; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakSet(x) {
	    if (!weakSetHas || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakSetHas.call(x, weakSetHas);
	        try {
	            weakMapHas.call(x, weakMapHas);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isElement(x) {
	    if (!x || typeof x !== 'object') { return false; }
	    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
	        return true;
	    }
	    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
	}
	
	function inspectString(str, opts) {
	    if (str.length > opts.maxStringLength) {
	        var remaining = str.length - opts.maxStringLength;
	        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
	        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
	    }
	    // eslint-disable-next-line no-control-regex
	    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
	    return wrapQuotes(s, 'single', opts);
	}
	
	function lowbyte(c) {
	    var n = c.charCodeAt(0);
	    var x = {
	        8: 'b',
	        9: 't',
	        10: 'n',
	        12: 'f',
	        13: 'r'
	    }[n];
	    if (x) { return '\\' + x; }
	    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
	}
	
	function markBoxed(str) {
	    return 'Object(' + str + ')';
	}
	
	function weakCollectionOf(type) {
	    return type + ' { ? }';
	}
	
	function collectionOf(type, size, entries, indent) {
	    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
	    return type + ' (' + size + ') {' + joinedEntries + '}';
	}
	
	function singleLineValues(xs) {
	    for (var i = 0; i < xs.length; i++) {
	        if (indexOf(xs[i], '\n') >= 0) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function getIndent(opts, depth) {
	    var baseIndent;
	    if (opts.indent === '\t') {
	        baseIndent = '\t';
	    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
	        baseIndent = $join.call(Array(opts.indent + 1), ' ');
	    } else {
	        return null;
	    }
	    return {
	        base: baseIndent,
	        prev: $join.call(Array(depth + 1), baseIndent)
	    };
	}
	
	function indentedJoin(xs, indent) {
	    if (xs.length === 0) { return ''; }
	    var lineJoiner = '\n' + indent.prev + indent.base;
	    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
	}
	
	function arrObjKeys(obj, inspect) {
	    var isArr = isArray(obj);
	    var xs = [];
	    if (isArr) {
	        xs.length = obj.length;
	        for (var i = 0; i < obj.length; i++) {
	            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
	        }
	    }
	    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
	    var symMap;
	    if (hasShammedSymbols) {
	        symMap = {};
	        for (var k = 0; k < syms.length; k++) {
	            symMap['$' + syms[k]] = syms[k];
	        }
	    }
	
	    for (var key in obj) { // eslint-disable-line no-restricted-syntax
	        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
	        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
	        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
	            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
	            continue; // eslint-disable-line no-restricted-syntax, no-continue
	        } else if ($test.call(/[^\w$]/, key)) {
	            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
	        } else {
	            xs.push(key + ': ' + inspect(obj[key], obj));
	        }
	    }
	    if (typeof gOPS === 'function') {
	        for (var j = 0; j < syms.length; j++) {
	            if (isEnumerable.call(obj, syms[j])) {
	                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
	            }
	        }
	    }
	    return xs;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(91);
	var callBind = __webpack_require__(168);
	
	var implementation = __webpack_require__(473);
	var getPolyfill = __webpack_require__(474);
	var shim = __webpack_require__(1086);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(474);
	var define = __webpack_require__(91);
	
	module.exports = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(476); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	(function(){
	
	    'use strict';
	
	    var _ = __webpack_require__(1068);
	
	    function createRegExPatternForResource (input)
	    {
	        return input.replace(/\*/,'([0-9A-Za-z_]+/?)*')
	    }
	
	    function createRegExPatternForAction (input)
	    {
	        return input.replace(/\*/g,'([0-9A-Za-z\:])*')
	    }
	
	    // process iam file
	    function processIamData( data ) {
	
	        for (var i in data.Statement) {
	
	            var stmt = data.Statement[i];
	
	            stmt.ResourceRegex = [];
	            if (_.has(stmt, 'Resource') && stmt.Resource instanceof  Array) {
	
	                for (var j in stmt.Resource) {
	                    stmt.ResourceRegex.push(createRegExPatternForResource(stmt.Resource[j]));
	                }
	            }
	            else {
	                stmt.ResourceRegex.push(createRegExPatternForResource(stmt.Resource));
	            }
	
	            stmt.ActionRegex = [];
	            if (_.has(stmt, 'Action') && stmt.Action instanceof  Array) {
	
	                for (var j in stmt.Action) {
	                    stmt.ActionRegex.push(createRegExPatternForAction(stmt.Action[j]));
	                }
	            }
	            else {
	                stmt.ActionRegex.push(createRegExPatternForAction(stmt.Action));
	            }
	        }
	
	        return data;
	    }
	
	    // processed json data as input
	    function seperateStmts( stmts ) {
	
	        var allowString = 'Allow';
	        var denyString = 'Deny';
	
	        var allowStmts = [];
	        var denyStmts = [];
	
	        for (var i in stmts) {
	
	            var stmt = stmts[i];
	
	            if (_.has(stmt, 'Effect'))
	                if (stmt.Effect === allowString) {
	                    allowStmts.push(stmt);
	                }
	                else if (stmt.Effect === denyString) {
	                    denyStmts.push(stmt);
	                }
	        }
	
	        return {
	            denyStmts: denyStmts,
	            allowStmts: allowStmts
	        };
	
	    }
	
	    function processBlock(isAllow,stm,def) {
	        if(isAllow === false && stm === true) {
	            def = false
	        }
	        else if(isAllow === true && stm === true) {
	            def = true
	        }
	        return def
	    }
	    // authorize a resource for an action
	    function authorize( resource, action, data ) {
	        var defaultDeny = false;
	
	        if(Array.isArray(resource)) {
	            defaultDeny = resource.every(function(res) {
	                var localDDeny = false;
	                data.Statement.forEach(function(stm) {
	                    localDDeny = processBlock(stm.Effect === 'Allow',findActionForResource( res,  action, [stm] ),localDDeny)
	                })
	                return localDDeny
	            })
	        } else {
	
	            var localDDeny = false
	            data.Statement.forEach(function(stm) {
	                localDDeny = processBlock(stm.Effect === 'Allow',findActionForResource( resource,  action, [stm] ),localDDeny)
	            })
	            defaultDeny = localDDeny
	        }
	        return defaultDeny;
	    }
	
	    function getActionCriteria( action, data ) {
	
	        // seperate processed allow and deny stmts
	        var statements =  seperateStmts(data.Statement);
	
	        // default deny
	        var defaultDeny = false;
	        var accounts = {};
	        var permissions = {};
	
	        for(var a = 0; a < statements.allowStmts.length; a++){
	            if (_.has(statements.allowStmts[a], 'ActionRegex') && statements.allowStmts[a].ActionRegex instanceof  Array) {
	                for (var r in statements.allowStmts[a].ActionRegex) {
	                    if( new RegExp(statements.allowStmts[a].ActionRegex[r]).test(action) ){
	                        for(var t in statements.allowStmts[a].Resource){
	                            var AccountId = statements.allowStmts[a].Resource[t].split(':')[4];
	                            var arn_resource = statements.allowStmts[a].Resource[t].split(':')[5];
	
	                            if(!accounts[AccountId]){
	                                accounts[AccountId] = {allow: [], deny:[]};
	                            }
	
	                            accounts[AccountId].allow.push({
	                                Action: statements.allowStmts[a].Action[r],
	                                Resource: statements.allowStmts[a].Resource,
	                                ResourceRegex: statements.allowStmts[a].ResourceRegex,
	                                ArnResource: arn_resource
	                            });
	                        }
	                    }
	                }
	            }else{
	
	            }
	
	        }
	
	        for(var a = 0; a < statements.denyStmts.length; a++){
	            if (_.has(statements.denyStmts[a], 'ActionRegex') && statements.denyStmts[a].ActionRegex instanceof  Array) {
	                for (var r in statements.denyStmts[a].ActionRegex) {
	                    if( new RegExp(statements.denyStmts[a].ActionRegex[r]).test(action) ){
	                        for(var t in statements.denyStmts[a].Resource){
	                            var AccountId = statements.denyStmts[a].Resource[t].split(':')[4];
	                            var arn_resource = statements.denyStmts[a].Resource[t].split(':')[5];
	                            if(!accounts[AccountId]){
	                                accounts[AccountId] = {allow: [], deny:[]};
	                            }
	                            accounts[AccountId].deny.push({
	                                Action: statements.denyStmts[a].Action[r],
	                                Resource: statements.denyStmts[a].Resource,
	                                ResourceRegex: statements.denyStmts[a].ResourceRegex,
	                                ArnResource: arn_resource
	                            });
	                        }
	                    }
	                }
	            }else{
	
	            }
	        }
	
	        for(var a in accounts){
	            permissions[a] = {Must:[], MustNot:[]};
	        }
	
	        for(var p in permissions){
	            if(accounts[p]){
	                for(var a in accounts[p].allow){
	                    if(accounts[p].allow[a].ArnResource !== '*'){
	                        permissions[p].Must.push({type: accounts[p].allow[a].ArnResource.split('/')[0], id: accounts[p].allow[a].ArnResource.split('/')[1]});
	                    }
	                }
	                for(var d in accounts[p].deny){
	                    if(accounts[p].deny[d].ArnResource !== '*') {
	                        permissions[p].MustNot.push({type: accounts[p].deny[d].ArnResource.split('/')[0], id: accounts[p].deny[d].ArnResource.split('/')[1]});
	                    }else{
	                        // the deny is explict for all resources in the account...so delete it...
	                        delete permissions[p];
	                    }
	                }
	            }
	        }
	        return permissions;
	    }
	
	
	    function findActionForResource( resource, action, stmts ) {
	            var stmt = stmts[0];
	
	            for ( var j in stmt.ResourceRegex ) {
	                //need to swap any empty :: with a catch all '([0-9A-Za-z\-]+)*'
	                var localStatment = stmt.ResourceRegex[j].split(':').map(function(x){return x === "" ? "([0-9A-Za-z\-])*" : x}).join(":")
	                var regex = new RegExp(localStatment);
	                var resource_parts = resource.split(':');
	                var regex_resource_parts = stmt.Resource[0].split(':');
	                var resource = resource.split(':').map(function(x){return x === "" ? "PREFILL" : x}  ).join(":")
	                if ( regex.test(resource)  && _.has(stmt,'ActionRegex')) {
	                    var actions = stmt.ActionRegex;
	                    if( actions instanceof  Array ){
	
	                        for( var k in actions ) {
	                            if( new RegExp(actions[k]).test(action) ){
	                                return true;
	                            }
	                        }
	                    }else {
	                        if( new RegExp(actions).test(action) ){
	                            return true;
	                        }
	                    }
	                }
	            }
	        return false;
	    }
	
	
	    var iam = {
	        processIamData: processIamData,
	        authorize: authorize,
	        getActionCriteria: getActionCriteria
	    };
	
	    module.exports = iam;
	
	})();


/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(1056)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*!
	 * Platform.js v1.3.6
	 * Copyright 2014-2020 Benjamin Tan
	 * Copyright 2011-2013 John-David Dalton
	 * Available under MIT license
	 */
	;(function() {
	  'use strict';
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used as a reference to the global object. */
	  var root = (objectTypes[typeof window] && window) || this;
	
	  /** Backup possible global object. */
	  var oldRoot = root;
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global;
	  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
	    root = freeGlobal;
	  }
	
	  /**
	   * Used as the maximum length of an array-like object.
	   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
	   * for more details.
	   */
	  var maxSafeInteger = Math.pow(2, 53) - 1;
	
	  /** Regular expression to detect Opera. */
	  var reOpera = /\bOpera/;
	
	  /** Possible global object. */
	  var thisBinding = this;
	
	  /** Used for native method references. */
	  var objectProto = Object.prototype;
	
	  /** Used to check for own properties of an object. */
	  var hasOwnProperty = objectProto.hasOwnProperty;
	
	  /** Used to resolve the internal `[[Class]]` of values. */
	  var toString = objectProto.toString;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Capitalizes a string value.
	   *
	   * @private
	   * @param {string} string The string to capitalize.
	   * @returns {string} The capitalized string.
	   */
	  function capitalize(string) {
	    string = String(string);
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  }
	
	  /**
	   * A utility function to clean up the OS name.
	   *
	   * @private
	   * @param {string} os The OS name to clean up.
	   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
	   * @param {string} [label] A label for the OS.
	   */
	  function cleanupOS(os, pattern, label) {
	    // Platform tokens are defined at:
	    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
	    var data = {
	      '10.0': '10',
	      '6.4':  '10 Technical Preview',
	      '6.3':  '8.1',
	      '6.2':  '8',
	      '6.1':  'Server 2008 R2 / 7',
	      '6.0':  'Server 2008 / Vista',
	      '5.2':  'Server 2003 / XP 64-bit',
	      '5.1':  'XP',
	      '5.01': '2000 SP1',
	      '5.0':  '2000',
	      '4.0':  'NT',
	      '4.90': 'ME'
	    };
	    // Detect Windows version from platform tokens.
	    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) &&
	        (data = data[/[\d.]+$/.exec(os)])) {
	      os = 'Windows ' + data;
	    }
	    // Correct character case and cleanup string.
	    os = String(os);
	
	    if (pattern && label) {
	      os = os.replace(RegExp(pattern, 'i'), label);
	    }
	
	    os = format(
	      os.replace(/ ce$/i, ' CE')
	        .replace(/\bhpw/i, 'web')
	        .replace(/\bMacintosh\b/, 'Mac OS')
	        .replace(/_PowerPC\b/i, ' OS')
	        .replace(/\b(OS X) [^ \d]+/i, '$1')
	        .replace(/\bMac (OS X)\b/, '$1')
	        .replace(/\/(\d)/, ' $1')
	        .replace(/_/g, '.')
	        .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
	        .replace(/\bx86\.64\b/gi, 'x86_64')
	        .replace(/\b(Windows Phone) OS\b/, '$1')
	        .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
	        .split(' on ')[0]
	    );
	
	    return os;
	  }
	
	  /**
	   * An iteration utility for arrays and objects.
	   *
	   * @private
	   * @param {Array|Object} object The object to iterate over.
	   * @param {Function} callback The function called per iteration.
	   */
	  function each(object, callback) {
	    var index = -1,
	        length = object ? object.length : 0;
	
	    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
	      while (++index < length) {
	        callback(object[index], index, object);
	      }
	    } else {
	      forOwn(object, callback);
	    }
	  }
	
	  /**
	   * Trim and conditionally capitalize string values.
	   *
	   * @private
	   * @param {string} string The string to format.
	   * @returns {string} The formatted string.
	   */
	  function format(string) {
	    string = trim(string);
	    return /^(?:webOS|i(?:OS|P))/.test(string)
	      ? string
	      : capitalize(string);
	  }
	
	  /**
	   * Iterates over an object's own properties, executing the `callback` for each.
	   *
	   * @private
	   * @param {Object} object The object to iterate over.
	   * @param {Function} callback The function executed per own property.
	   */
	  function forOwn(object, callback) {
	    for (var key in object) {
	      if (hasOwnProperty.call(object, key)) {
	        callback(object[key], key, object);
	      }
	    }
	  }
	
	  /**
	   * Gets the internal `[[Class]]` of a value.
	   *
	   * @private
	   * @param {*} value The value.
	   * @returns {string} The `[[Class]]`.
	   */
	  function getClassOf(value) {
	    return value == null
	      ? capitalize(value)
	      : toString.call(value).slice(8, -1);
	  }
	
	  /**
	   * Host objects can return type values that are different from their actual
	   * data type. The objects we are concerned with usually return non-primitive
	   * types of "object", "function", or "unknown".
	   *
	   * @private
	   * @param {*} object The owner of the property.
	   * @param {string} property The property to check.
	   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
	   */
	  function isHostType(object, property) {
	    var type = object != null ? typeof object[property] : 'number';
	    return !/^(?:boolean|number|string|undefined)$/.test(type) &&
	      (type == 'object' ? !!object[property] : true);
	  }
	
	  /**
	   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
	   *
	   * @private
	   * @param {string} string The string to qualify.
	   * @returns {string} The qualified string.
	   */
	  function qualify(string) {
	    return String(string).replace(/([ -])(?!$)/g, '$1?');
	  }
	
	  /**
	   * A bare-bones `Array#reduce` like utility function.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} callback The function called per iteration.
	   * @returns {*} The accumulated result.
	   */
	  function reduce(array, callback) {
	    var accumulator = null;
	    each(array, function(value, index) {
	      accumulator = callback(accumulator, value, index, array);
	    });
	    return accumulator;
	  }
	
	  /**
	   * Removes leading and trailing whitespace from a string.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} The trimmed string.
	   */
	  function trim(string) {
	    return String(string).replace(/^ +| +$/g, '');
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Creates a new platform object.
	   *
	   * @memberOf platform
	   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
	   *  context object.
	   * @returns {Object} A platform object.
	   */
	  function parse(ua) {
	
	    /** The environment context object. */
	    var context = root;
	
	    /** Used to flag when a custom context is provided. */
	    var isCustomContext = ua && typeof ua == 'object' && getClassOf(ua) != 'String';
	
	    // Juggle arguments.
	    if (isCustomContext) {
	      context = ua;
	      ua = null;
	    }
	
	    /** Browser navigator object. */
	    var nav = context.navigator || {};
	
	    /** Browser user agent string. */
	    var userAgent = nav.userAgent || '';
	
	    ua || (ua = userAgent);
	
	    /** Used to flag when `thisBinding` is the [ModuleScope]. */
	    var isModuleScope = isCustomContext || thisBinding == oldRoot;
	
	    /** Used to detect if browser is like Chrome. */
	    var likeChrome = isCustomContext
	      ? !!nav.likeChrome
	      : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());
	
	    /** Internal `[[Class]]` value shortcuts. */
	    var objectClass = 'Object',
	        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
	        enviroClass = isCustomContext ? objectClass : 'Environment',
	        javaClass = (isCustomContext && context.java) ? 'JavaPackage' : getClassOf(context.java),
	        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';
	
	    /** Detect Java environments. */
	    var java = /\bJava/.test(javaClass) && context.java;
	
	    /** Detect Rhino. */
	    var rhino = java && getClassOf(context.environment) == enviroClass;
	
	    /** A character to represent alpha. */
	    var alpha = java ? 'a' : '\u03b1';
	
	    /** A character to represent beta. */
	    var beta = java ? 'b' : '\u03b2';
	
	    /** Browser document object. */
	    var doc = context.document || {};
	
	    /**
	     * Detect Opera browser (Presto-based).
	     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
	     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
	     */
	    var opera = context.operamini || context.opera;
	
	    /** Opera `[[Class]]`. */
	    var operaClass = reOpera.test(operaClass = (isCustomContext && opera) ? opera['[[Class]]'] : getClassOf(opera))
	      ? operaClass
	      : (opera = null);
	
	    /*------------------------------------------------------------------------*/
	
	    /** Temporary variable used over the script's lifetime. */
	    var data;
	
	    /** The CPU architecture. */
	    var arch = ua;
	
	    /** Platform description array. */
	    var description = [];
	
	    /** Platform alpha/beta indicator. */
	    var prerelease = null;
	
	    /** A flag to indicate that environment features should be used to resolve the platform. */
	    var useFeatures = ua == userAgent;
	
	    /** The browser/environment version. */
	    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();
	
	    /** A flag to indicate if the OS ends with "/ Version" */
	    var isSpecialCasedOS;
	
	    /* Detectable layout engines (order is important). */
	    var layout = getLayout([
	      { 'label': 'EdgeHTML', 'pattern': 'Edge' },
	      'Trident',
	      { 'label': 'WebKit', 'pattern': 'AppleWebKit' },
	      'iCab',
	      'Presto',
	      'NetFront',
	      'Tasman',
	      'KHTML',
	      'Gecko'
	    ]);
	
	    /* Detectable browser names (order is important). */
	    var name = getName([
	      'Adobe AIR',
	      'Arora',
	      'Avant Browser',
	      'Breach',
	      'Camino',
	      'Electron',
	      'Epiphany',
	      'Fennec',
	      'Flock',
	      'Galeon',
	      'GreenBrowser',
	      'iCab',
	      'Iceweasel',
	      'K-Meleon',
	      'Konqueror',
	      'Lunascape',
	      'Maxthon',
	      { 'label': 'Microsoft Edge', 'pattern': '(?:Edge|Edg|EdgA|EdgiOS)' },
	      'Midori',
	      'Nook Browser',
	      'PaleMoon',
	      'PhantomJS',
	      'Raven',
	      'Rekonq',
	      'RockMelt',
	      { 'label': 'Samsung Internet', 'pattern': 'SamsungBrowser' },
	      'SeaMonkey',
	      { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
	      'Sleipnir',
	      'SlimBrowser',
	      { 'label': 'SRWare Iron', 'pattern': 'Iron' },
	      'Sunrise',
	      'Swiftfox',
	      'Vivaldi',
	      'Waterfox',
	      'WebPositive',
	      { 'label': 'Yandex Browser', 'pattern': 'YaBrowser' },
	      { 'label': 'UC Browser', 'pattern': 'UCBrowser' },
	      'Opera Mini',
	      { 'label': 'Opera Mini', 'pattern': 'OPiOS' },
	      'Opera',
	      { 'label': 'Opera', 'pattern': 'OPR' },
	      'Chromium',
	      'Chrome',
	      { 'label': 'Chrome', 'pattern': '(?:HeadlessChrome)' },
	      { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' },
	      { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' },
	      { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' },
	      { 'label': 'IE', 'pattern': 'IEMobile' },
	      { 'label': 'IE', 'pattern': 'MSIE' },
	      'Safari'
	    ]);
	
	    /* Detectable products (order is important). */
	    var product = getProduct([
	      { 'label': 'BlackBerry', 'pattern': 'BB10' },
	      'BlackBerry',
	      { 'label': 'Galaxy S', 'pattern': 'GT-I9000' },
	      { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' },
	      { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' },
	      { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' },
	      { 'label': 'Galaxy S5', 'pattern': 'SM-G900' },
	      { 'label': 'Galaxy S6', 'pattern': 'SM-G920' },
	      { 'label': 'Galaxy S6 Edge', 'pattern': 'SM-G925' },
	      { 'label': 'Galaxy S7', 'pattern': 'SM-G930' },
	      { 'label': 'Galaxy S7 Edge', 'pattern': 'SM-G935' },
	      'Google TV',
	      'Lumia',
	      'iPad',
	      'iPod',
	      'iPhone',
	      'Kindle',
	      { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' },
	      'Nexus',
	      'Nook',
	      'PlayBook',
	      'PlayStation Vita',
	      'PlayStation',
	      'TouchPad',
	      'Transformer',
	      { 'label': 'Wii U', 'pattern': 'WiiU' },
	      'Wii',
	      'Xbox One',
	      { 'label': 'Xbox 360', 'pattern': 'Xbox' },
	      'Xoom'
	    ]);
	
	    /* Detectable manufacturers. */
	    var manufacturer = getManufacturer({
	      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
	      'Alcatel': {},
	      'Archos': {},
	      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
	      'Asus': { 'Transformer': 1 },
	      'Barnes & Noble': { 'Nook': 1 },
	      'BlackBerry': { 'PlayBook': 1 },
	      'Google': { 'Google TV': 1, 'Nexus': 1 },
	      'HP': { 'TouchPad': 1 },
	      'HTC': {},
	      'Huawei': {},
	      'Lenovo': {},
	      'LG': {},
	      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
	      'Motorola': { 'Xoom': 1 },
	      'Nintendo': { 'Wii U': 1,  'Wii': 1 },
	      'Nokia': { 'Lumia': 1 },
	      'Oppo': {},
	      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
	      'Sony': { 'PlayStation': 1, 'PlayStation Vita': 1 },
	      'Xiaomi': { 'Mi': 1, 'Redmi': 1 }
	    });
	
	    /* Detectable operating systems (order is important). */
	    var os = getOS([
	      'Windows Phone',
	      'KaiOS',
	      'Android',
	      'CentOS',
	      { 'label': 'Chrome OS', 'pattern': 'CrOS' },
	      'Debian',
	      { 'label': 'DragonFly BSD', 'pattern': 'DragonFly' },
	      'Fedora',
	      'FreeBSD',
	      'Gentoo',
	      'Haiku',
	      'Kubuntu',
	      'Linux Mint',
	      'OpenBSD',
	      'Red Hat',
	      'SuSE',
	      'Ubuntu',
	      'Xubuntu',
	      'Cygwin',
	      'Symbian OS',
	      'hpwOS',
	      'webOS ',
	      'webOS',
	      'Tablet OS',
	      'Tizen',
	      'Linux',
	      'Mac OS X',
	      'Macintosh',
	      'Mac',
	      'Windows 98;',
	      'Windows '
	    ]);
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Picks the layout engine from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected layout engine.
	     */
	    function getLayout(guesses) {
	      return reduce(guesses, function(result, guess) {
	        return result || RegExp('\\b' + (
	          guess.pattern || qualify(guess)
	        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }
	
	    /**
	     * Picks the manufacturer from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An object of guesses.
	     * @returns {null|string} The detected manufacturer.
	     */
	    function getManufacturer(guesses) {
	      return reduce(guesses, function(result, value, key) {
	        // Lookup the manufacturer by product or scan the UA for the manufacturer.
	        return result || (
	          value[product] ||
	          value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] ||
	          RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)
	        ) && key;
	      });
	    }
	
	    /**
	     * Picks the browser name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected browser name.
	     */
	    function getName(guesses) {
	      return reduce(guesses, function(result, guess) {
	        return result || RegExp('\\b' + (
	          guess.pattern || qualify(guess)
	        ) + '\\b', 'i').exec(ua) && (guess.label || guess);
	      });
	    }
	
	    /**
	     * Picks the OS name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected OS name.
	     */
	    function getOS(guesses) {
	      return reduce(guesses, function(result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result =
	              RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua)
	            )) {
	          result = cleanupOS(result, pattern, guess.label || guess);
	        }
	        return result;
	      });
	    }
	
	    /**
	     * Picks the product name from an array of guesses.
	     *
	     * @private
	     * @param {Array} guesses An array of guesses.
	     * @returns {null|string} The detected product name.
	     */
	    function getProduct(guesses) {
	      return reduce(guesses, function(result, guess) {
	        var pattern = guess.pattern || qualify(guess);
	        if (!result && (result =
	              RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) ||
	              RegExp('\\b' + pattern + ' *\\w+-[\\w]*', 'i').exec(ua) ||
	              RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua)
	            )) {
	          // Split by forward slash and append product version if needed.
	          if ((result = String((guess.label && !RegExp(pattern, 'i').test(guess.label)) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
	            result[0] += ' ' + result[1];
	          }
	          // Correct character case and cleanup string.
	          guess = guess.label || guess;
	          result = format(result[0]
	            .replace(RegExp(pattern, 'i'), guess)
	            .replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ')
	            .replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
	        }
	        return result;
	      });
	    }
	
	    /**
	     * Resolves the version using an array of UA patterns.
	     *
	     * @private
	     * @param {Array} patterns An array of UA patterns.
	     * @returns {null|string} The detected version.
	     */
	    function getVersion(patterns) {
	      return reduce(patterns, function(result, pattern) {
	        return result || (RegExp(pattern +
	          '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
	      });
	    }
	
	    /**
	     * Returns `platform.description` when the platform object is coerced to a string.
	     *
	     * @name toString
	     * @memberOf platform
	     * @returns {string} Returns `platform.description` if available, else an empty string.
	     */
	    function toStringPlatform() {
	      return this.description || '';
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Convert layout to an array so we can add extra details.
	    layout && (layout = [layout]);
	
	    // Detect Android products.
	    // Browsers on Android devices typically provide their product IDS after "Android;"
	    // up to "Build" or ") AppleWebKit".
	    // Example:
	    // "Mozilla/5.0 (Linux; Android 8.1.0; Moto G (5) Plus) AppleWebKit/537.36
	    // (KHTML, like Gecko) Chrome/70.0.3538.80 Mobile Safari/537.36"
	    if (/\bAndroid\b/.test(os) && !product &&
	        (data = /\bAndroid[^;]*;(.*?)(?:Build|\) AppleWebKit)\b/i.exec(ua))) {
	      product = trim(data[1])
	        // Replace any language codes (eg. "en-US").
	        .replace(/^[a-z]{2}-[a-z]{2};\s*/i, '')
	        || null;
	    }
	    // Detect product names that contain their manufacturer's name.
	    if (manufacturer && !product) {
	      product = getProduct([manufacturer]);
	    } else if (manufacturer && product) {
	      product = product
	        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.\\s]', 'i'), manufacturer + ' ')
	        .replace(RegExp('^(' + qualify(manufacturer) + ')[-_.]?(\\w)', 'i'), manufacturer + ' $2');
	    }
	    // Clean up Google TV.
	    if ((data = /\bGoogle TV\b/.exec(product))) {
	      product = data[0];
	    }
	    // Detect simulators.
	    if (/\bSimulator\b/i.test(ua)) {
	      product = (product ? product + ' ' : '') + 'Simulator';
	    }
	    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
	    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
	      description.push('running in Turbo/Uncompressed mode');
	    }
	    // Detect IE Mobile 11.
	    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
	      data = parse(ua.replace(/like iPhone OS/, ''));
	      manufacturer = data.manufacturer;
	      product = data.product;
	    }
	    // Detect iOS.
	    else if (/^iP/.test(product)) {
	      name || (name = 'Safari');
	      os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua))
	        ? ' ' + data[1].replace(/_/g, '.')
	        : '');
	    }
	    // Detect Kubuntu.
	    else if (name == 'Konqueror' && /^Linux\b/i.test(os)) {
	      os = 'Kubuntu';
	    }
	    // Detect Android browsers.
	    else if ((manufacturer && manufacturer != 'Google' &&
	        ((/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua)) || /\bVita\b/.test(product))) ||
	        (/\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua))) {
	      name = 'Android Browser';
	      os = /\bAndroid\b/.test(os) ? os : 'Android';
	    }
	    // Detect Silk desktop/accelerated modes.
	    else if (name == 'Silk') {
	      if (!/\bMobi/i.test(ua)) {
	        os = 'Android';
	        description.unshift('desktop mode');
	      }
	      if (/Accelerated *= *true/i.test(ua)) {
	        description.unshift('accelerated');
	      }
	    }
	    // Detect UC Browser speed mode.
	    else if (name == 'UC Browser' && /\bUCWEB\b/.test(ua)) {
	      description.push('speed mode');
	    }
	    // Detect PaleMoon identifying as Firefox.
	    else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
	      description.push('identifying as Firefox ' + data[1]);
	    }
	    // Detect Firefox OS and products running Firefox.
	    else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
	      os || (os = 'Firefox OS');
	      product || (product = data[1]);
	    }
	    // Detect false positives for Firefox/Safari.
	    else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
	      // Escape the `/` for Firefox 1.
	      if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
	        // Clear name of false positives.
	        name = null;
	      }
	      // Reassign a generic name.
	      if ((data = product || manufacturer || os) &&
	          (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
	        name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
	      }
	    }
	    // Add Chrome version to description for Electron.
	    else if (name == 'Electron' && (data = (/\bChrome\/([\d.]+)\b/.exec(ua) || 0)[1])) {
	      description.push('Chromium ' + data);
	    }
	    // Detect non-Opera (Presto-based) versions (order is important).
	    if (!version) {
	      version = getVersion([
	        '(?:Cloud9|CriOS|CrMo|Edge|Edg|EdgA|EdgiOS|FxiOS|HeadlessChrome|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|SamsungBrowser|Silk(?!/[\\d.]+$)|UCBrowser|YaBrowser)',
	        'Version',
	        qualify(name),
	        '(?:Firefox|Minefield|NetFront)'
	      ]);
	    }
	    // Detect stubborn layout engines.
	    if ((data =
	          layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' ||
	          /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') ||
	          /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' ||
	          !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') ||
	          layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront'
	        )) {
	      layout = [data];
	    }
	    // Detect Windows Phone 7 desktop mode.
	    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
	      name += ' Mobile';
	      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
	      description.unshift('desktop mode');
	    }
	    // Detect Windows Phone 8.x desktop mode.
	    else if (/\bWPDesktop\b/i.test(ua)) {
	      name = 'IE Mobile';
	      os = 'Windows Phone 8.x';
	      description.unshift('desktop mode');
	      version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
	    }
	    // Detect IE 11 identifying as other browsers.
	    else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
	      if (name) {
	        description.push('identifying as ' + name + (version ? ' ' + version : ''));
	      }
	      name = 'IE';
	      version = data[1];
	    }
	    // Leverage environment features.
	    if (useFeatures) {
	      // Detect server-side environments.
	      // Rhino has a global function while others have a global object.
	      if (isHostType(context, 'global')) {
	        if (java) {
	          data = java.lang.System;
	          arch = data.getProperty('os.arch');
	          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
	        }
	        if (rhino) {
	          try {
	            version = context.require('ringo/engine').version.join('.');
	            name = 'RingoJS';
	          } catch(e) {
	            if ((data = context.system) && data.global.system == context.system) {
	              name = 'Narwhal';
	              os || (os = data[0].os || null);
	            }
	          }
	          if (!name) {
	            name = 'Rhino';
	          }
	        }
	        else if (
	          typeof context.process == 'object' && !context.process.browser &&
	          (data = context.process)
	        ) {
	          if (typeof data.versions == 'object') {
	            if (typeof data.versions.electron == 'string') {
	              description.push('Node ' + data.versions.node);
	              name = 'Electron';
	              version = data.versions.electron;
	            } else if (typeof data.versions.nw == 'string') {
	              description.push('Chromium ' + version, 'Node ' + data.versions.node);
	              name = 'NW.js';
	              version = data.versions.nw;
	            }
	          }
	          if (!name) {
	            name = 'Node.js';
	            arch = data.arch;
	            os = data.platform;
	            version = /[\d.]+/.exec(data.version);
	            version = version ? version[0] : null;
	          }
	        }
	      }
	      // Detect Adobe AIR.
	      else if (getClassOf((data = context.runtime)) == airRuntimeClass) {
	        name = 'Adobe AIR';
	        os = data.flash.system.Capabilities.os;
	      }
	      // Detect PhantomJS.
	      else if (getClassOf((data = context.phantom)) == phantomClass) {
	        name = 'PhantomJS';
	        version = (data = data.version || null) && (data.major + '.' + data.minor + '.' + data.patch);
	      }
	      // Detect IE compatibility modes.
	      else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
	        // We're in compatibility mode when the Trident version + 4 doesn't
	        // equal the document mode.
	        version = [version, doc.documentMode];
	        if ((data = +data[1] + 4) != version[1]) {
	          description.push('IE ' + version[1] + ' mode');
	          layout && (layout[1] = '');
	          version[1] = data;
	        }
	        version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
	      }
	      // Detect IE 11 masking as other browsers.
	      else if (typeof doc.documentMode == 'number' && /^(?:Chrome|Firefox)\b/.test(name)) {
	        description.push('masking as ' + name + ' ' + version);
	        name = 'IE';
	        version = '11.0';
	        layout = ['Trident'];
	        os = 'Windows';
	      }
	      os = os && format(os);
	    }
	    // Detect prerelease phases.
	    if (version && (data =
	          /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) ||
	          /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) ||
	          /\bMinefield\b/i.test(ua) && 'a'
	        )) {
	      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
	      version = version.replace(RegExp(data + '\\+?$'), '') +
	        (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
	    }
	    // Detect Firefox Mobile.
	    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS|KaiOS)\b/.test(os)) {
	      name = 'Firefox Mobile';
	    }
	    // Obscure Maxthon's unreliable version.
	    else if (name == 'Maxthon' && version) {
	      version = version.replace(/\.[\d.]+/, '.x');
	    }
	    // Detect Xbox 360 and Xbox One.
	    else if (/\bXbox\b/i.test(product)) {
	      if (product == 'Xbox 360') {
	        os = null;
	      }
	      if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
	        description.unshift('mobile mode');
	      }
	    }
	    // Add mobile postfix.
	    else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) &&
	        (os == 'Windows CE' || /Mobi/i.test(ua))) {
	      name += ' Mobile';
	    }
	    // Detect IE platform preview.
	    else if (name == 'IE' && useFeatures) {
	      try {
	        if (context.external === null) {
	          description.unshift('platform preview');
	        }
	      } catch(e) {
	        description.unshift('embedded');
	      }
	    }
	    // Detect BlackBerry OS version.
	    // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
	    else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data =
	          (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] ||
	          version
	        )) {
	      data = [data, /BB10/.test(ua)];
	      os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
	      version = null;
	    }
	    // Detect Opera identifying/masking itself as another browser.
	    // http://www.opera.com/support/kb/view/843/
	    else if (this != forOwn && product != 'Wii' && (
	          (useFeatures && opera) ||
	          (/Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua)) ||
	          (name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os)) ||
	          (name == 'IE' && (
	            (os && !/^Win/.test(os) && version > 5.5) ||
	            /\bWindows XP\b/.test(os) && version > 8 ||
	            version == 8 && !/\bTrident\b/.test(ua)
	          ))
	        ) && !reOpera.test((data = parse.call(forOwn, ua.replace(reOpera, '') + ';'))) && data.name) {
	      // When "identifying", the UA contains both Opera and the other browser's name.
	      data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
	      if (reOpera.test(name)) {
	        if (/\bIE\b/.test(data) && os == 'Mac OS') {
	          os = null;
	        }
	        data = 'identify' + data;
	      }
	      // When "masking", the UA contains only the other browser's name.
	      else {
	        data = 'mask' + data;
	        if (operaClass) {
	          name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
	        } else {
	          name = 'Opera';
	        }
	        if (/\bIE\b/.test(data)) {
	          os = null;
	        }
	        if (!useFeatures) {
	          version = null;
	        }
	      }
	      layout = ['Presto'];
	      description.push(data);
	    }
	    // Detect WebKit Nightly and approximate Chrome/Safari versions.
	    if ((data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
	      // Correct build number for numeric comparison.
	      // (e.g. "532.5" becomes "532.05")
	      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
	      // Nightly builds are postfixed with a "+".
	      if (name == 'Safari' && data[1].slice(-1) == '+') {
	        name = 'WebKit Nightly';
	        prerelease = 'alpha';
	        version = data[1].slice(0, -1);
	      }
	      // Clear incorrect browser versions.
	      else if (version == data[1] ||
	          version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
	        version = null;
	      }
	      // Use the full Chrome version when available.
	      data[1] = (/\b(?:Headless)?Chrome\/([\d.]+)/i.exec(ua) || 0)[1];
	      // Detect Blink layout engine.
	      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
	        layout = ['Blink'];
	      }
	      // Detect JavaScriptCore.
	      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
	      if (!useFeatures || (!likeChrome && !data[1])) {
	        layout && (layout[1] = 'like Safari');
	        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : data < 602 ? 9 : data < 604 ? 10 : data < 606 ? 11 : data < 608 ? 12 : '12');
	      } else {
	        layout && (layout[1] = 'like Chrome');
	        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
	      }
	      // Add the postfix of ".x" or "+" for approximate versions.
	      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
	      // Obscure version for some Safari 1-2 releases.
	      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
	        version = data;
	      } else if (name == 'Chrome' && /\bHeadlessChrome/i.test(ua)) {
	        description.unshift('headless');
	      }
	    }
	    // Detect Opera desktop modes.
	    if (name == 'Opera' &&  (data = /\bzbov|zvav$/.exec(os))) {
	      name += ' ';
	      description.unshift('desktop mode');
	      if (data == 'zvav') {
	        name += 'Mini';
	        version = null;
	      } else {
	        name += 'Mobile';
	      }
	      os = os.replace(RegExp(' *' + data + '$'), '');
	    }
	    // Detect Chrome desktop mode.
	    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
	      description.unshift('desktop mode');
	      name = 'Chrome Mobile';
	      version = null;
	
	      if (/\bOS X\b/.test(os)) {
	        manufacturer = 'Apple';
	        os = 'iOS 4.3+';
	      } else {
	        os = null;
	      }
	    }
	    // Newer versions of SRWare Iron uses the Chrome tag to indicate its version number.
	    else if (/\bSRWare Iron\b/.test(name) && !version) {
	      version = getVersion('Chrome');
	    }
	    // Strip incorrect OS versions.
	    if (version && version.indexOf((data = /[\d.]+$/.exec(os))) == 0 &&
	        ua.indexOf('/' + data + '-') > -1) {
	      os = trim(os.replace(data, ''));
	    }
	    // Ensure OS does not include the browser name.
	    if (os && os.indexOf(name) != -1 && !RegExp(name + ' OS').test(os)) {
	      os = os.replace(RegExp(' *' + qualify(name) + ' *'), '');
	    }
	    // Add layout engine.
	    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (
	        /Browser|Lunascape|Maxthon/.test(name) ||
	        name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) ||
	        /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Samsung Internet|Sleipnir|SRWare Iron|Vivaldi|Web)/.test(name) && layout[1])) {
	      // Don't add layout details to description if they are falsey.
	      (data = layout[layout.length - 1]) && description.push(data);
	    }
	    // Combine contextual information.
	    if (description.length) {
	      description = ['(' + description.join('; ') + ')'];
	    }
	    // Append manufacturer to description.
	    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
	      description.push('on ' + manufacturer);
	    }
	    // Append product to description.
	    if (product) {
	      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
	    }
	    // Parse the OS into an object.
	    if (os) {
	      data = / ([\d.+]+)$/.exec(os);
	      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
	      os = {
	        'architecture': 32,
	        'family': (data && !isSpecialCasedOS) ? os.replace(data[0], '') : os,
	        'version': data ? data[1] : null,
	        'toString': function() {
	          var version = this.version;
	          return this.family + ((version && !isSpecialCasedOS) ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
	        }
	      };
	    }
	    // Add browser/OS architecture.
	    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
	      if (os) {
	        os.architecture = 64;
	        os.family = os.family.replace(RegExp(' *' + data), '');
	      }
	      if (
	          name && (/\bWOW64\b/i.test(ua) ||
	          (useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua)))
	      ) {
	        description.unshift('32-bit');
	      }
	    }
	    // Chrome 39 and above on OS X is always 64-bit.
	    else if (
	        os && /^OS X/.test(os.family) &&
	        name == 'Chrome' && parseFloat(version) >= 39
	    ) {
	      os.architecture = 64;
	    }
	
	    ua || (ua = null);
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The platform object.
	     *
	     * @name platform
	     * @type Object
	     */
	    var platform = {};
	
	    /**
	     * The platform description.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.description = ua;
	
	    /**
	     * The name of the browser's layout engine.
	     *
	     * The list of common layout engines include:
	     * "Blink", "EdgeHTML", "Gecko", "Trident" and "WebKit"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.layout = layout && layout[0];
	
	    /**
	     * The name of the product's manufacturer.
	     *
	     * The list of manufacturers include:
	     * "Apple", "Archos", "Amazon", "Asus", "Barnes & Noble", "BlackBerry",
	     * "Google", "HP", "HTC", "LG", "Microsoft", "Motorola", "Nintendo",
	     * "Nokia", "Samsung" and "Sony"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.manufacturer = manufacturer;
	
	    /**
	     * The name of the browser/environment.
	     *
	     * The list of common browser names include:
	     * "Chrome", "Electron", "Firefox", "Firefox for iOS", "IE",
	     * "Microsoft Edge", "PhantomJS", "Safari", "SeaMonkey", "Silk",
	     * "Opera Mini" and "Opera"
	     *
	     * Mobile versions of some browsers have "Mobile" appended to their name:
	     * eg. "Chrome Mobile", "Firefox Mobile", "IE Mobile" and "Opera Mobile"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.name = name;
	
	    /**
	     * The alpha/beta release indicator.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.prerelease = prerelease;
	
	    /**
	     * The name of the product hosting the browser.
	     *
	     * The list of common products include:
	     *
	     * "BlackBerry", "Galaxy S4", "Lumia", "iPad", "iPod", "iPhone", "Kindle",
	     * "Kindle Fire", "Nexus", "Nook", "PlayBook", "TouchPad" and "Transformer"
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.product = product;
	
	    /**
	     * The browser's user agent string.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.ua = ua;
	
	    /**
	     * The browser/environment version.
	     *
	     * @memberOf platform
	     * @type string|null
	     */
	    platform.version = name && version;
	
	    /**
	     * The name of the operating system.
	     *
	     * @memberOf platform
	     * @type Object
	     */
	    platform.os = os || {
	
	      /**
	       * The CPU architecture the OS is built for.
	       *
	       * @memberOf platform.os
	       * @type number|null
	       */
	      'architecture': null,
	
	      /**
	       * The family of the OS.
	       *
	       * Common values include:
	       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
	       * "Windows XP", "OS X", "Linux", "Ubuntu", "Debian", "Fedora", "Red Hat",
	       * "SuSE", "Android", "iOS" and "Windows Phone"
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'family': null,
	
	      /**
	       * The version of the OS.
	       *
	       * @memberOf platform.os
	       * @type string|null
	       */
	      'version': null,
	
	      /**
	       * Returns the OS string.
	       *
	       * @memberOf platform.os
	       * @returns {string} The OS string.
	       */
	      'toString': function() { return 'null'; }
	    };
	
	    platform.parse = parse;
	    platform.toString = toStringPlatform;
	
	    if (platform.version) {
	      description.unshift(version);
	    }
	    if (platform.name) {
	      description.unshift(name);
	    }
	    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
	      description.push(product ? '(' + os + ')' : 'on ' + os);
	    }
	    if (description.length) {
	      platform.description = description.join(' ');
	    }
	    return platform;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export platform.
	  var platform = parse();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
	  if (true) {
	    // Expose platform on the global object to prevent errors when platform is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    root.platform = platform;
	
	    // Define as an anonymous module so platform can be aliased through path mapping.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return platform;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for CommonJS support.
	    forOwn(platform, function(value, key) {
	      freeExports[key] = value;
	    });
	  }
	  else {
	    // Export to the global object.
	    root.platform = platform;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)(module), (function() { return this; }())))

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = require('./lib/has');
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1096);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(477);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(189);
	var assign = __webpack_require__(67);
	
	var ReactPropTypesSecret = __webpack_require__(477);
	var has = __webpack_require__(1097);
	var checkPropTypes = __webpack_require__(1093);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1097 */
/***/ function(module, exports) {

	module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.4.1 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw new RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * https://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.4.1',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) {
				// in Node.js, io.js, or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else {
				// in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else {
			// in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)(module), (function() { return this; }())))

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	
	var _domAlign = __webpack_require__(1037);
	
	var _isEqual = _interopRequireDefault(__webpack_require__(1131));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(121));
	
	var _isVisible = _interopRequireDefault(__webpack_require__(1127));
	
	var _useLayoutEffect = _interopRequireDefault(__webpack_require__(490));
	
	var _ref2 = __webpack_require__(124);
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _useBuffer3 = _interopRequireDefault(__webpack_require__(1100));
	
	var _util = __webpack_require__(1102);
	
	/**
	 * Removed props:
	 *  - childrenProps
	 */
	function getElement(func) {
	  if (typeof func !== 'function') return null;
	  return func();
	}
	
	function getPoint(point) {
	  if ((0, _typeof2.default)(point) !== 'object' || !point) return null;
	  return point;
	}
	
	var Align = function Align(_ref, ref) {
	  var children = _ref.children,
	      disabled = _ref.disabled,
	      target = _ref.target,
	      align = _ref.align,
	      onAlign = _ref.onAlign,
	      monitorWindowResize = _ref.monitorWindowResize,
	      _ref$monitorBufferTim = _ref.monitorBufferTime,
	      monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
	
	  var cacheRef = _react.default.useRef({});
	  /** Popup node ref */
	
	
	  var nodeRef = _react.default.useRef();
	
	  var childNode = _react.default.Children.only(children); // ===================== Align ======================
	  // We save the props here to avoid closure makes props ood
	
	
	  var forceAlignPropsRef = _react.default.useRef({});
	
	  forceAlignPropsRef.current.disabled = disabled;
	  forceAlignPropsRef.current.target = target;
	  forceAlignPropsRef.current.align = align;
	  forceAlignPropsRef.current.onAlign = onAlign;
	
	  var _useBuffer = (0, _useBuffer3.default)(function () {
	    var _forceAlignPropsRef$c = forceAlignPropsRef.current,
	        latestDisabled = _forceAlignPropsRef$c.disabled,
	        latestTarget = _forceAlignPropsRef$c.target,
	        latestAlign = _forceAlignPropsRef$c.align,
	        latestOnAlign = _forceAlignPropsRef$c.onAlign;
	    var source = nodeRef.current;
	
	    if (!latestDisabled && latestTarget && source) {
	      var _result;
	
	      var _element = getElement(latestTarget);
	
	      var _point = getPoint(latestTarget);
	
	      cacheRef.current.element = _element;
	      cacheRef.current.point = _point;
	      cacheRef.current.align = latestAlign; // IE lose focus after element realign
	      // We should record activeElement and restore later
	
	      var _document = document,
	          activeElement = _document.activeElement; // We only align when element is visible
	
	      if (_element && (0, _isVisible.default)(_element)) {
	        _result = (0, _domAlign.alignElement)(source, _element, latestAlign);
	      } else if (_point) {
	        _result = (0, _domAlign.alignPoint)(source, _point, latestAlign);
	      }
	
	      (0, _util.restoreFocus)(activeElement, source);
	
	      if (latestOnAlign && _result) {
	        latestOnAlign(source, _result);
	      }
	
	      return true;
	    }
	
	    return false;
	  }, monitorBufferTime),
	      _useBuffer2 = (0, _slicedToArray2.default)(_useBuffer, 2),
	      _forceAlign = _useBuffer2[0],
	      cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
	  // Handle props change
	
	
	  var _React$useState = _react.default.useState(),
	      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
	      element = _React$useState2[0],
	      setElement = _React$useState2[1];
	
	  var _React$useState3 = _react.default.useState(),
	      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
	      point = _React$useState4[0],
	      setPoint = _React$useState4[1];
	
	  (0, _useLayoutEffect.default)(function () {
	    setElement(getElement(target));
	    setPoint(getPoint(target));
	  });
	
	  _react.default.useEffect(function () {
	    if (cacheRef.current.element !== element || !(0, _util.isSamePoint)(cacheRef.current.point, point) || !(0, _isEqual.default)(cacheRef.current.align, align)) {
	      _forceAlign();
	    }
	  }); // Watch popup element resize
	
	
	  _react.default.useEffect(function () {
	    var cancelFn = (0, _util.monitorResize)(nodeRef.current, _forceAlign);
	    return cancelFn;
	  }, [nodeRef.current]); // Watch target element resize
	
	
	  _react.default.useEffect(function () {
	    var cancelFn = (0, _util.monitorResize)(element, _forceAlign);
	    return cancelFn;
	  }, [element]); // Listen for disabled change
	
	
	  _react.default.useEffect(function () {
	    if (!disabled) {
	      _forceAlign();
	    } else {
	      cancelForceAlign();
	    }
	  }, [disabled]); // Listen for window resize
	
	
	  _react.default.useEffect(function () {
	    if (monitorWindowResize) {
	      var cancelFn = (0, _addEventListener.default)(window, 'resize', _forceAlign);
	      return cancelFn.remove;
	    }
	  }, [monitorWindowResize]); // Clear all if unmount
	
	
	  _react.default.useEffect(function () {
	    return function () {
	      cancelForceAlign();
	    };
	  }, []); // ====================== Ref =======================
	
	
	  _react.default.useImperativeHandle(ref, function () {
	    return {
	      forceAlign: function forceAlign() {
	        return _forceAlign(true);
	      }
	    };
	  }); // ===================== Render =====================
	
	
	  if ( /*#__PURE__*/_react.default.isValidElement(childNode)) {
	    childNode = /*#__PURE__*/_react.default.cloneElement(childNode, {
	      ref: (0, _ref2.composeRef)(childNode.ref, nodeRef)
	    });
	  }
	
	  return childNode;
	};
	
	var RcAlign = /*#__PURE__*/_react.default.forwardRef(Align);
	
	RcAlign.displayName = 'Align';
	var _default = RcAlign;
	exports.default = _default;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _default = function _default(callback, buffer) {
	  var calledRef = _react.default.useRef(false);
	
	  var timeoutRef = _react.default.useRef(null);
	
	  function cancelTrigger() {
	    window.clearTimeout(timeoutRef.current);
	  }
	
	  function trigger(force) {
	    cancelTrigger();
	
	    if (!calledRef.current || force === true) {
	      if (callback(force) === false) {
	        // Not delay since callback cancelled self
	        return;
	      }
	
	      calledRef.current = true;
	      timeoutRef.current = window.setTimeout(function () {
	        calledRef.current = false;
	      }, buffer);
	    } else {
	      timeoutRef.current = window.setTimeout(function () {
	        calledRef.current = false;
	        trigger();
	      }, buffer);
	    }
	  }
	
	  return [trigger, function () {
	    calledRef.current = false;
	    cancelTrigger();
	  }];
	};
	
	exports.default = _default;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _Align = _interopRequireDefault(__webpack_require__(1099));
	
	// export this package's api
	var _default = _Align.default;
	exports.default = _default;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isSamePoint = isSamePoint;
	exports.monitorResize = monitorResize;
	exports.restoreFocus = restoreFocus;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(200));
	
	var _contains = _interopRequireDefault(__webpack_require__(488));
	
	function isSamePoint(prev, next) {
	  if (prev === next) return true;
	  if (!prev || !next) return false;
	
	  if ('pageX' in next && 'pageY' in next) {
	    return prev.pageX === next.pageX && prev.pageY === next.pageY;
	  }
	
	  if ('clientX' in next && 'clientY' in next) {
	    return prev.clientX === next.clientX && prev.clientY === next.clientY;
	  }
	
	  return false;
	}
	
	function restoreFocus(activeElement, container) {
	  // Focus back if is in the container
	  if (activeElement !== document.activeElement && (0, _contains.default)(container, activeElement) && typeof activeElement.focus === 'function') {
	    activeElement.focus();
	  }
	}
	
	function monitorResize(element, callback) {
	  var prevWidth = null;
	  var prevHeight = null;
	
	  function onResize(_ref) {
	    var _ref2 = (0, _slicedToArray2.default)(_ref, 1),
	        target = _ref2[0].target;
	
	    if (!document.documentElement.contains(target)) return;
	
	    var _target$getBoundingCl = target.getBoundingClientRect(),
	        width = _target$getBoundingCl.width,
	        height = _target$getBoundingCl.height;
	
	    var fixedWidth = Math.floor(width);
	    var fixedHeight = Math.floor(height);
	
	    if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) {
	      // https://webkit.org/blog/9997/resizeobserver-in-webkit/
	      Promise.resolve().then(function () {
	        callback({
	          width: fixedWidth,
	          height: fixedHeight
	        });
	      });
	    }
	
	    prevWidth = fixedWidth;
	    prevHeight = fixedHeight;
	  }
	
	  var resizeObserver = new _resizeObserverPolyfill.default(onResize);
	
	  if (element) {
	    resizeObserver.observe(element);
	  }
	
	  return function () {
	    resizeObserver.disconnect();
	  };
	}

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	exports.genCSSMotionList = genCSSMotionList;
	var _extends2 = _interopRequireDefault(__webpack_require__(42));
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(44));
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var React = _interopRequireWildcard(__webpack_require__(2));
	var _CSSMotion = _interopRequireDefault(__webpack_require__(479));
	var _diff = __webpack_require__(1108);
	var _motion = __webpack_require__(185);
	var _excluded = ["component", "children", "onVisibleChanged", "onAllRemoved"],
	  _excluded2 = ["status"];
	/* eslint react/prop-types: 0 */
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var MOTION_PROP_NAMES = ['eventProps', 'visible', 'children', 'motionName', 'motionAppear', 'motionEnter', 'motionLeave', 'motionLeaveImmediately', 'motionDeadline', 'removeOnLeave', 'leavedClassName', 'onAppearPrepare', 'onAppearStart', 'onAppearActive', 'onAppearEnd', 'onEnterStart', 'onEnterActive', 'onEnterEnd', 'onLeaveStart', 'onLeaveActive', 'onLeaveEnd'];
	/**
	 * Generate a CSSMotionList component with config
	 * @param transitionSupport No need since CSSMotionList no longer depends on transition support
	 * @param CSSMotion CSSMotion component
	 */
	function genCSSMotionList(transitionSupport) {
	  var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _CSSMotion.default;
	  var CSSMotionList = /*#__PURE__*/function (_React$Component) {
	    (0, _inherits2.default)(CSSMotionList, _React$Component);
	    var _super = (0, _createSuper2.default)(CSSMotionList);
	    function CSSMotionList() {
	      var _this;
	      (0, _classCallCheck2.default)(this, CSSMotionList);
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	      _this = _super.call.apply(_super, [this].concat(args));
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
	        keyEntities: []
	      });
	      // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeKey", function (removeKey) {
	        var keyEntities = _this.state.keyEntities;
	        var nextKeyEntities = keyEntities.map(function (entity) {
	          if (entity.key !== removeKey) return entity;
	          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, entity), {}, {
	            status: _diff.STATUS_REMOVED
	          });
	        });
	        _this.setState({
	          keyEntities: nextKeyEntities
	        });
	        return nextKeyEntities.filter(function (_ref) {
	          var status = _ref.status;
	          return status !== _diff.STATUS_REMOVED;
	        }).length;
	      });
	      return _this;
	    }
	    (0, _createClass2.default)(CSSMotionList, [{
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	        var keyEntities = this.state.keyEntities;
	        var _this$props = this.props,
	          component = _this$props.component,
	          children = _this$props.children,
	          _onVisibleChanged = _this$props.onVisibleChanged,
	          onAllRemoved = _this$props.onAllRemoved,
	          restProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
	        var Component = component || React.Fragment;
	        var motionProps = {};
	        MOTION_PROP_NAMES.forEach(function (prop) {
	          motionProps[prop] = restProps[prop];
	          delete restProps[prop];
	        });
	        delete restProps.keys;
	        return /*#__PURE__*/React.createElement(Component, restProps, keyEntities.map(function (_ref2, index) {
	          var status = _ref2.status,
	            eventProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
	          var visible = status === _diff.STATUS_ADD || status === _diff.STATUS_KEEP;
	          return /*#__PURE__*/React.createElement(CSSMotion, (0, _extends2.default)({}, motionProps, {
	            key: eventProps.key,
	            visible: visible,
	            eventProps: eventProps,
	            onVisibleChanged: function onVisibleChanged(changedVisible) {
	              _onVisibleChanged === null || _onVisibleChanged === void 0 ? void 0 : _onVisibleChanged(changedVisible, {
	                key: eventProps.key
	              });
	              if (!changedVisible) {
	                var restKeysCount = _this2.removeKey(eventProps.key);
	                if (restKeysCount === 0 && onAllRemoved) {
	                  onAllRemoved();
	                }
	              }
	            }
	          }), function (props, ref) {
	            return children((0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
	              index: index
	            }), ref);
	          });
	        }));
	      }
	    }], [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(_ref3, _ref4) {
	        var keys = _ref3.keys;
	        var keyEntities = _ref4.keyEntities;
	        var parsedKeyObjects = (0, _diff.parseKeys)(keys);
	        var mixedKeyEntities = (0, _diff.diffKeys)(keyEntities, parsedKeyObjects);
	        return {
	          keyEntities: mixedKeyEntities.filter(function (entity) {
	            var prevEntity = keyEntities.find(function (_ref5) {
	              var key = _ref5.key;
	              return entity.key === key;
	            });
	
	            // Remove if already mark as removed
	            if (prevEntity && prevEntity.status === _diff.STATUS_REMOVED && entity.status === _diff.STATUS_REMOVE) {
	              return false;
	            }
	            return true;
	          })
	        };
	      }
	    }]);
	    return CSSMotionList;
	  }(React.Component);
	  (0, _defineProperty2.default)(CSSMotionList, "defaultProps", {
	    component: 'div'
	  });
	  return CSSMotionList;
	}
	var _default = genCSSMotionList(_motion.supportTransition);
	exports.default = _default;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	var React = _interopRequireWildcard(__webpack_require__(2));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var DomWrapper = /*#__PURE__*/function (_React$Component) {
	  (0, _inherits2.default)(DomWrapper, _React$Component);
	  var _super = (0, _createSuper2.default)(DomWrapper);
	  function DomWrapper() {
	    (0, _classCallCheck2.default)(this, DomWrapper);
	    return _super.apply(this, arguments);
	  }
	  (0, _createClass2.default)(DomWrapper, [{
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return DomWrapper;
	}(React.Component);
	var _default = DomWrapper;
	exports.default = _default;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var React = _interopRequireWildcard(__webpack_require__(2));
	var _motion = __webpack_require__(185);
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var _default = function _default(callback) {
	  var cacheElementRef = (0, React.useRef)();
	
	  // Cache callback
	  var callbackRef = (0, React.useRef)(callback);
	  callbackRef.current = callback;
	
	  // Internal motion event handler
	  var onInternalMotionEnd = React.useCallback(function (event) {
	    callbackRef.current(event);
	  }, []);
	
	  // Remove events
	  function removeMotionEvents(element) {
	    if (element) {
	      element.removeEventListener(_motion.transitionEndName, onInternalMotionEnd);
	      element.removeEventListener(_motion.animationEndName, onInternalMotionEnd);
	    }
	  }
	
	  // Patch events
	  function patchMotionEvents(element) {
	    if (cacheElementRef.current && cacheElementRef.current !== element) {
	      removeMotionEvents(cacheElementRef.current);
	    }
	    if (element && element !== cacheElementRef.current) {
	      element.addEventListener(_motion.transitionEndName, onInternalMotionEnd);
	      element.addEventListener(_motion.animationEndName, onInternalMotionEnd);
	
	      // Save as cache in case dom removed trigger by `motionDeadline`
	      cacheElementRef.current = element;
	    }
	  }
	
	  // Clean up when removed
	  React.useEffect(function () {
	    return function () {
	      removeMotionEvents(cacheElementRef.current);
	    };
	  }, []);
	  return [patchMotionEvents, removeMotionEvents];
	};
	exports.default = _default;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _raf = _interopRequireDefault(__webpack_require__(123));
	var React = _interopRequireWildcard(__webpack_require__(2));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var _default = function _default() {
	  var nextFrameRef = React.useRef(null);
	  function cancelNextFrame() {
	    _raf.default.cancel(nextFrameRef.current);
	  }
	  function nextFrame(callback) {
	    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	    cancelNextFrame();
	    var nextFrameId = (0, _raf.default)(function () {
	      if (delay <= 1) {
	        callback({
	          isCanceled: function isCanceled() {
	            return nextFrameId !== nextFrameRef.current;
	          }
	        });
	      } else {
	        nextFrame(callback, delay - 1);
	      }
	    });
	    nextFrameRef.current = nextFrameId;
	  }
	  React.useEffect(function () {
	    return function () {
	      cancelNextFrame();
	    };
	  }, []);
	  return [nextFrame, cancelNextFrame];
	};
	exports.default = _default;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useStatus;
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	var _useState7 = _interopRequireDefault(__webpack_require__(188));
	var React = _interopRequireWildcard(__webpack_require__(2));
	var _interface = __webpack_require__(184);
	var _useDomMotionEvents3 = _interopRequireDefault(__webpack_require__(1105));
	var _useIsomorphicLayoutEffect = _interopRequireDefault(__webpack_require__(481));
	var _useStepQueue3 = _interopRequireWildcard(__webpack_require__(482));
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	function useStatus(supportMotion, visible, getElement, _ref) {
	  var _ref$motionEnter = _ref.motionEnter,
	    motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter,
	    _ref$motionAppear = _ref.motionAppear,
	    motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear,
	    _ref$motionLeave = _ref.motionLeave,
	    motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave,
	    motionDeadline = _ref.motionDeadline,
	    motionLeaveImmediately = _ref.motionLeaveImmediately,
	    onAppearPrepare = _ref.onAppearPrepare,
	    onEnterPrepare = _ref.onEnterPrepare,
	    onLeavePrepare = _ref.onLeavePrepare,
	    onAppearStart = _ref.onAppearStart,
	    onEnterStart = _ref.onEnterStart,
	    onLeaveStart = _ref.onLeaveStart,
	    onAppearActive = _ref.onAppearActive,
	    onEnterActive = _ref.onEnterActive,
	    onLeaveActive = _ref.onLeaveActive,
	    onAppearEnd = _ref.onAppearEnd,
	    onEnterEnd = _ref.onEnterEnd,
	    onLeaveEnd = _ref.onLeaveEnd,
	    onVisibleChanged = _ref.onVisibleChanged;
	  // Used for outer render usage to avoid `visible: false & status: none` to render nothing
	  var _useState = (0, _useState7.default)(),
	    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	    asyncVisible = _useState2[0],
	    setAsyncVisible = _useState2[1];
	  var _useState3 = (0, _useState7.default)(_interface.STATUS_NONE),
	    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
	    status = _useState4[0],
	    setStatus = _useState4[1];
	  var _useState5 = (0, _useState7.default)(null),
	    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
	    style = _useState6[0],
	    setStyle = _useState6[1];
	  var mountedRef = (0, React.useRef)(false);
	  var deadlineRef = (0, React.useRef)(null);
	
	  // =========================== Dom Node ===========================
	  function getDomElement() {
	    return getElement();
	  }
	
	  // ========================== Motion End ==========================
	  var activeRef = (0, React.useRef)(false);
	
	  /**
	   * Clean up status & style
	   */
	  function updateMotionEndStatus() {
	    setStatus(_interface.STATUS_NONE, true);
	    setStyle(null, true);
	  }
	  function onInternalMotionEnd(event) {
	    var element = getDomElement();
	    if (event && !event.deadline && event.target !== element) {
	      // event exists
	      // not initiated by deadline
	      // transitionEnd not fired by inner elements
	      return;
	    }
	    var currentActive = activeRef.current;
	    var canEnd;
	    if (status === _interface.STATUS_APPEAR && currentActive) {
	      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
	    } else if (status === _interface.STATUS_ENTER && currentActive) {
	      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
	    } else if (status === _interface.STATUS_LEAVE && currentActive) {
	      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
	    }
	
	    // Only update status when `canEnd` and not destroyed
	    if (status !== _interface.STATUS_NONE && currentActive && canEnd !== false) {
	      updateMotionEndStatus();
	    }
	  }
	  var _useDomMotionEvents = (0, _useDomMotionEvents3.default)(onInternalMotionEnd),
	    _useDomMotionEvents2 = (0, _slicedToArray2.default)(_useDomMotionEvents, 1),
	    patchMotionEvents = _useDomMotionEvents2[0];
	
	  // ============================= Step =============================
	  var getEventHandlers = function getEventHandlers(targetStatus) {
	    var _ref2, _ref3, _ref4;
	    switch (targetStatus) {
	      case _interface.STATUS_APPEAR:
	        return _ref2 = {}, (0, _defineProperty2.default)(_ref2, _interface.STEP_PREPARE, onAppearPrepare), (0, _defineProperty2.default)(_ref2, _interface.STEP_START, onAppearStart), (0, _defineProperty2.default)(_ref2, _interface.STEP_ACTIVE, onAppearActive), _ref2;
	      case _interface.STATUS_ENTER:
	        return _ref3 = {}, (0, _defineProperty2.default)(_ref3, _interface.STEP_PREPARE, onEnterPrepare), (0, _defineProperty2.default)(_ref3, _interface.STEP_START, onEnterStart), (0, _defineProperty2.default)(_ref3, _interface.STEP_ACTIVE, onEnterActive), _ref3;
	      case _interface.STATUS_LEAVE:
	        return _ref4 = {}, (0, _defineProperty2.default)(_ref4, _interface.STEP_PREPARE, onLeavePrepare), (0, _defineProperty2.default)(_ref4, _interface.STEP_START, onLeaveStart), (0, _defineProperty2.default)(_ref4, _interface.STEP_ACTIVE, onLeaveActive), _ref4;
	      default:
	        return {};
	    }
	  };
	  var eventHandlers = React.useMemo(function () {
	    return getEventHandlers(status);
	  }, [status]);
	  var _useStepQueue = (0, _useStepQueue3.default)(status, !supportMotion, function (newStep) {
	      // Only prepare step can be skip
	      if (newStep === _interface.STEP_PREPARE) {
	        var onPrepare = eventHandlers[_interface.STEP_PREPARE];
	        if (!onPrepare) {
	          return _useStepQueue3.SkipStep;
	        }
	        return onPrepare(getDomElement());
	      }
	
	      // Rest step is sync update
	      if (step in eventHandlers) {
	        var _eventHandlers$step;
	        setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
	      }
	      if (step === _interface.STEP_ACTIVE) {
	        // Patch events when motion needed
	        patchMotionEvents(getDomElement());
	        if (motionDeadline > 0) {
	          clearTimeout(deadlineRef.current);
	          deadlineRef.current = setTimeout(function () {
	            onInternalMotionEnd({
	              deadline: true
	            });
	          }, motionDeadline);
	        }
	      }
	      if (step === _interface.STEP_PREPARED) {
	        updateMotionEndStatus();
	      }
	      return _useStepQueue3.DoStep;
	    }),
	    _useStepQueue2 = (0, _slicedToArray2.default)(_useStepQueue, 2),
	    startStep = _useStepQueue2[0],
	    step = _useStepQueue2[1];
	  var active = (0, _useStepQueue3.isActive)(step);
	  activeRef.current = active;
	
	  // ============================ Status ============================
	  // Update with new status
	  (0, _useIsomorphicLayoutEffect.default)(function () {
	    setAsyncVisible(visible);
	    var isMounted = mountedRef.current;
	    mountedRef.current = true;
	
	    // if (!supportMotion) {
	    //   return;
	    // }
	
	    var nextStatus;
	
	    // Appear
	    if (!isMounted && visible && motionAppear) {
	      nextStatus = _interface.STATUS_APPEAR;
	    }
	
	    // Enter
	    if (isMounted && visible && motionEnter) {
	      nextStatus = _interface.STATUS_ENTER;
	    }
	
	    // Leave
	    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
	      nextStatus = _interface.STATUS_LEAVE;
	    }
	    var nextEventHandlers = getEventHandlers(nextStatus);
	
	    // Update to next status
	    if (nextStatus && (supportMotion || nextEventHandlers[_interface.STEP_PREPARE])) {
	      setStatus(nextStatus);
	      startStep();
	    } else {
	      // Set back in case no motion but prev status has prepare step
	      setStatus(_interface.STATUS_NONE);
	    }
	  }, [visible]);
	
	  // ============================ Effect ============================
	  // Reset when motion changed
	  (0, React.useEffect)(function () {
	    if (
	    // Cancel appear
	    status === _interface.STATUS_APPEAR && !motionAppear ||
	    // Cancel enter
	    status === _interface.STATUS_ENTER && !motionEnter ||
	    // Cancel leave
	    status === _interface.STATUS_LEAVE && !motionLeave) {
	      setStatus(_interface.STATUS_NONE);
	    }
	  }, [motionAppear, motionEnter, motionLeave]);
	  (0, React.useEffect)(function () {
	    return function () {
	      mountedRef.current = false;
	      clearTimeout(deadlineRef.current);
	    };
	  }, []);
	
	  // Trigger `onVisibleChanged`
	  var firstMountChangeRef = React.useRef(false);
	  (0, React.useEffect)(function () {
	    // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
	    if (asyncVisible) {
	      firstMountChangeRef.current = true;
	    }
	    if (asyncVisible !== undefined && status === _interface.STATUS_NONE) {
	      // Skip first render is invisible since it's nothing changed
	      if (firstMountChangeRef.current || asyncVisible) {
	        onVisibleChanged === null || onVisibleChanged === void 0 ? void 0 : onVisibleChanged(asyncVisible);
	      }
	      firstMountChangeRef.current = true;
	    }
	  }, [asyncVisible, status]);
	
	  // ============================ Styles ============================
	  var mergedStyle = style;
	  if (eventHandlers[_interface.STEP_PREPARE] && step === _interface.STEP_START) {
	    mergedStyle = (0, _objectSpread2.default)({
	      transition: 'none'
	    }, mergedStyle);
	  }
	  return [status, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
	}

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STATUS_REMOVED = exports.STATUS_REMOVE = exports.STATUS_KEEP = exports.STATUS_ADD = void 0;
	exports.diffKeys = diffKeys;
	exports.parseKeys = parseKeys;
	exports.wrapKeyToObject = wrapKeyToObject;
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var STATUS_ADD = 'add';
	exports.STATUS_ADD = STATUS_ADD;
	var STATUS_KEEP = 'keep';
	exports.STATUS_KEEP = STATUS_KEEP;
	var STATUS_REMOVE = 'remove';
	exports.STATUS_REMOVE = STATUS_REMOVE;
	var STATUS_REMOVED = 'removed';
	exports.STATUS_REMOVED = STATUS_REMOVED;
	function wrapKeyToObject(key) {
	  var keyObj;
	  if (key && (0, _typeof2.default)(key) === 'object' && 'key' in key) {
	    keyObj = key;
	  } else {
	    keyObj = {
	      key: key
	    };
	  }
	  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, keyObj), {}, {
	    key: String(keyObj.key)
	  });
	}
	function parseKeys() {
	  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  return keys.map(wrapKeyToObject);
	}
	function diffKeys() {
	  var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var list = [];
	  var currentIndex = 0;
	  var currentLen = currentKeys.length;
	  var prevKeyObjects = parseKeys(prevKeys);
	  var currentKeyObjects = parseKeys(currentKeys);
	
	  // Check prev keys to insert or keep
	  prevKeyObjects.forEach(function (keyObj) {
	    var hit = false;
	    for (var i = currentIndex; i < currentLen; i += 1) {
	      var currentKeyObj = currentKeyObjects[i];
	      if (currentKeyObj.key === keyObj.key) {
	        // New added keys should add before current key
	        if (currentIndex < i) {
	          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function (obj) {
	            return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, obj), {}, {
	              status: STATUS_ADD
	            });
	          }));
	          currentIndex = i;
	        }
	        list.push((0, _objectSpread2.default)((0, _objectSpread2.default)({}, currentKeyObj), {}, {
	          status: STATUS_KEEP
	        }));
	        currentIndex += 1;
	        hit = true;
	        break;
	      }
	    }
	
	    // If not hit, it means key is removed
	    if (!hit) {
	      list.push((0, _objectSpread2.default)((0, _objectSpread2.default)({}, keyObj), {}, {
	        status: STATUS_REMOVE
	      }));
	    }
	  });
	
	  // Add rest to the list
	  if (currentIndex < currentLen) {
	    list = list.concat(currentKeyObjects.slice(currentIndex).map(function (obj) {
	      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, obj), {}, {
	        status: STATUS_ADD
	      });
	    }));
	  }
	
	  /**
	   * Merge same key when it remove and add again:
	   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
	   */
	  var keys = {};
	  list.forEach(function (_ref) {
	    var key = _ref.key;
	    keys[key] = (keys[key] || 0) + 1;
	  });
	  var duplicatedKeys = Object.keys(keys).filter(function (key) {
	    return keys[key] > 1;
	  });
	  duplicatedKeys.forEach(function (matchKey) {
	    // Remove `STATUS_REMOVE` node.
	    list = list.filter(function (_ref2) {
	      var key = _ref2.key,
	        status = _ref2.status;
	      return key !== matchKey || status !== STATUS_REMOVE;
	    });
	
	    // Update `STATUS_ADD` to `STATUS_KEEP`
	    list.forEach(function (node) {
	      if (node.key === matchKey) {
	        // eslint-disable-next-line no-param-reassign
	        node.status = STATUS_KEEP;
	      }
	    });
	  });
	  return list;
	}

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(19));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(38));
	
	var _Track = _interopRequireDefault(__webpack_require__(484));
	
	var _createSlider = _interopRequireDefault(__webpack_require__(485));
	
	var utils = _interopRequireWildcard(__webpack_require__(187));
	
	var _trimAlignValue = function trimAlignValue(_ref) {
	  var value = _ref.value,
	      handle = _ref.handle,
	      bounds = _ref.bounds,
	      props = _ref.props;
	  var allowCross = props.allowCross,
	      pushable = props.pushable;
	  var thershold = Number(pushable);
	  var valInRange = utils.ensureValueInRange(value, props);
	  var valNotConflict = valInRange;
	
	  if (!allowCross && handle != null && bounds !== undefined) {
	    if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
	      valNotConflict = bounds[handle - 1] + thershold;
	    }
	
	    if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
	      valNotConflict = bounds[handle + 1] - thershold;
	    }
	  }
	
	  return utils.ensureValuePrecision(valNotConflict, props);
	};
	
	var Range = /*#__PURE__*/function (_React$Component) {
	  (0, _inherits2.default)(Range, _React$Component);
	
	  var _super = (0, _createSuper2.default)(Range);
	
	  function Range(props) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Range);
	    _this = _super.call(this, props);
	
	    _this.positionGetValue = function (position) {
	      var bounds = _this.getValue();
	
	      var value = _this.calcValueByPos(position);
	
	      var closestBound = _this.getClosestBound(value);
	
	      var index = _this.getBoundNeedMoving(value, closestBound);
	
	      var prevValue = bounds[index];
	      if (value === prevValue) return null;
	      var nextBounds = (0, _toConsumableArray2.default)(bounds);
	      nextBounds[index] = value;
	      return nextBounds;
	    };
	
	    _this.onEnd = function (force) {
	      var handle = _this.state.handle;
	
	      _this.removeDocumentEvents();
	
	      if (!handle) {
	        _this.dragTrack = false;
	      }
	
	      if (handle !== null || force) {
	        _this.props.onAfterChange(_this.getValue());
	      }
	
	      _this.setState({
	        handle: null
	      });
	    };
	
	    var count = props.count,
	        min = props.min,
	        max = props.max;
	    var initialValue = Array.apply(void 0, (0, _toConsumableArray2.default)(Array(count + 1))).map(function () {
	      return min;
	    });
	    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
	    var value = props.value !== undefined ? props.value : defaultValue;
	    var bounds = value.map(function (v, i) {
	      return _trimAlignValue({
	        value: v,
	        handle: i,
	        props: props
	      });
	    });
	    var recent = bounds[0] === max ? 0 : bounds.length - 1;
	    _this.state = {
	      handle: null,
	      recent: recent,
	      bounds: bounds
	    };
	    return _this;
	  }
	  /**
	   * [Legacy] Used for inherit other component.
	   * It's a bad code style which should be refactor.
	   */
	
	  /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */
	
	
	  (0, _createClass2.default)(Range, [{
	    key: "calcValueByPos",
	    value: function calcValueByPos(value) {
	      return 0;
	    }
	  }, {
	    key: "getSliderLength",
	    value: function getSliderLength() {
	      return 0;
	    }
	  }, {
	    key: "calcOffset",
	    value: function calcOffset(value) {
	      return 0;
	    }
	  }, {
	    key: "saveHandle",
	    value: function saveHandle(index, h) {}
	  }, {
	    key: "removeDocumentEvents",
	    value: function removeDocumentEvents() {}
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          onChange = _this$props.onChange,
	          value = _this$props.value,
	          min = _this$props.min,
	          max = _this$props.max;
	
	      if (!('min' in this.props || 'max' in this.props)) {
	        return;
	      }
	
	      if (min === prevProps.min && max === prevProps.max) {
	        return;
	      }
	
	      var currentValue = value || prevState.bounds;
	
	      if (currentValue.some(function (v) {
	        return utils.isValueOutOfRange(v, _this2.props);
	      })) {
	        var newValues = currentValue.map(function (v) {
	          return utils.ensureValueInRange(v, _this2.props);
	        });
	        onChange(newValues);
	      }
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(state) {
	      var props = this.props;
	      var isNotControlled = !('value' in props);
	
	      if (isNotControlled) {
	        this.setState(state);
	      } else {
	        var controlledState = {};
	        ['handle', 'recent'].forEach(function (item) {
	          if (state[item] !== undefined) {
	            controlledState[item] = state[item];
	          }
	        });
	
	        if (Object.keys(controlledState).length) {
	          this.setState(controlledState);
	        }
	      }
	
	      var data = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.state), state);
	      var changedValue = data.bounds;
	      props.onChange(changedValue);
	    }
	  }, {
	    key: "onStart",
	    value: function onStart(position) {
	      var props = this.props,
	          state = this.state;
	      var bounds = this.getValue();
	      props.onBeforeChange(bounds);
	      var value = this.calcValueByPos(position);
	      this.startValue = value;
	      this.startPosition = position;
	      var closestBound = this.getClosestBound(value);
	      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
	      this.setState({
	        handle: this.prevMovedHandleIndex,
	        recent: this.prevMovedHandleIndex
	      });
	      var prevValue = bounds[this.prevMovedHandleIndex];
	      if (value === prevValue) return;
	      var nextBounds = (0, _toConsumableArray2.default)(state.bounds);
	      nextBounds[this.prevMovedHandleIndex] = value;
	      this.onChange({
	        bounds: nextBounds
	      });
	    }
	  }, {
	    key: "onMove",
	    value: function onMove(e, position, dragTrack, startBounds) {
	      utils.pauseEvent(e);
	      var state = this.state,
	          props = this.props;
	      var maxValue = props.max || 100;
	      var minValue = props.min || 0;
	
	      if (dragTrack) {
	        var pos = props.vertical ? -position : position;
	        pos = props.reverse ? -pos : pos;
	        var max = maxValue - Math.max.apply(Math, (0, _toConsumableArray2.default)(startBounds));
	        var min = minValue - Math.min.apply(Math, (0, _toConsumableArray2.default)(startBounds));
	        var ratio = Math.min(Math.max(pos / (this.getSliderLength() / (maxValue - minValue)), min), max);
	        var nextBounds = startBounds.map(function (v) {
	          return Math.floor(Math.max(Math.min(v + ratio, maxValue), minValue));
	        });
	
	        if (state.bounds.map(function (c, i) {
	          return c === nextBounds[i];
	        }).some(function (c) {
	          return !c;
	        })) {
	          this.onChange({
	            bounds: nextBounds
	          });
	        }
	
	        return;
	      }
	
	      var value = this.calcValueByPos(position);
	      var oldValue = state.bounds[state.handle];
	      if (value === oldValue) return;
	      this.moveTo(value);
	    }
	  }, {
	    key: "onKeyboard",
	    value: function onKeyboard(e) {
	      var _this$props2 = this.props,
	          reverse = _this$props2.reverse,
	          vertical = _this$props2.vertical;
	      var valueMutator = utils.getKeyboardValueMutator(e, vertical, reverse);
	
	      if (valueMutator) {
	        utils.pauseEvent(e);
	        var state = this.state,
	            props = this.props;
	        var bounds = state.bounds,
	            handle = state.handle;
	        var oldValue = bounds[handle === null ? state.recent : handle];
	        var mutatedValue = valueMutator(oldValue, props);
	
	        var value = _trimAlignValue({
	          value: mutatedValue,
	          handle: handle,
	          bounds: state.bounds,
	          props: props
	        });
	
	        if (value === oldValue) return;
	        var isFromKeyboardEvent = true;
	        this.moveTo(value, isFromKeyboardEvent);
	      }
	    }
	  }, {
	    key: "getValue",
	    value: function getValue() {
	      return this.state.bounds;
	    }
	  }, {
	    key: "getClosestBound",
	    value: function getClosestBound(value) {
	      var bounds = this.state.bounds;
	      var closestBound = 0;
	
	      for (var i = 1; i < bounds.length - 1; i += 1) {
	        if (value >= bounds[i]) {
	          closestBound = i;
	        }
	      }
	
	      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
	        closestBound += 1;
	      }
	
	      return closestBound;
	    }
	  }, {
	    key: "getBoundNeedMoving",
	    value: function getBoundNeedMoving(value, closestBound) {
	      var _this$state = this.state,
	          bounds = _this$state.bounds,
	          recent = _this$state.recent;
	      var boundNeedMoving = closestBound;
	      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
	
	      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
	        boundNeedMoving = recent;
	      }
	
	      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
	        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
	      }
	
	      return boundNeedMoving;
	    }
	  }, {
	    key: "getLowerBound",
	    value: function getLowerBound() {
	      return this.state.bounds[0];
	    }
	  }, {
	    key: "getUpperBound",
	    value: function getUpperBound() {
	      var bounds = this.state.bounds;
	      return bounds[bounds.length - 1];
	    }
	    /**
	     * Returns an array of possible slider points, taking into account both
	     * `marks` and `step`. The result is cached.
	     */
	
	  }, {
	    key: "getPoints",
	    value: function getPoints() {
	      var _this$props3 = this.props,
	          marks = _this$props3.marks,
	          step = _this$props3.step,
	          min = _this$props3.min,
	          max = _this$props3.max;
	      var cache = this.internalPointsCache;
	
	      if (!cache || cache.marks !== marks || cache.step !== step) {
	        var pointsObject = (0, _objectSpread2.default)({}, marks);
	
	        if (step !== null) {
	          for (var point = min; point <= max; point += step) {
	            pointsObject[point] = point;
	          }
	        }
	
	        var points = Object.keys(pointsObject).map(parseFloat);
	        points.sort(function (a, b) {
	          return a - b;
	        });
	        this.internalPointsCache = {
	          marks: marks,
	          step: step,
	          points: points
	        };
	      }
	
	      return this.internalPointsCache.points;
	    }
	  }, {
	    key: "moveTo",
	    value: function moveTo(value, isFromKeyboardEvent) {
	      var _this3 = this;
	
	      var state = this.state,
	          props = this.props;
	      var nextBounds = (0, _toConsumableArray2.default)(state.bounds);
	      var handle = state.handle === null ? state.recent : state.handle;
	      nextBounds[handle] = value;
	      var nextHandle = handle;
	
	      if (props.pushable !== false) {
	        this.pushSurroundingHandles(nextBounds, nextHandle);
	      } else if (props.allowCross) {
	        nextBounds.sort(function (a, b) {
	          return a - b;
	        });
	        nextHandle = nextBounds.indexOf(value);
	      }
	
	      this.onChange({
	        recent: nextHandle,
	        handle: nextHandle,
	        bounds: nextBounds
	      });
	
	      if (isFromKeyboardEvent) {
	        // known problem: because setState is async,
	        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
	        // cause onBeforeChange and onAfterChange receive wrong value.
	        // here use setState callback to hack，but not elegant
	        this.props.onAfterChange(nextBounds);
	        this.setState({}, function () {
	          _this3.handlesRefs[nextHandle].focus();
	        });
	        this.onEnd();
	      }
	    }
	  }, {
	    key: "pushSurroundingHandles",
	    value: function pushSurroundingHandles(bounds, handle) {
	      var value = bounds[handle];
	      var pushable = this.props.pushable;
	      var threshold = Number(pushable);
	      var direction = 0;
	
	      if (bounds[handle + 1] - value < threshold) {
	        direction = +1; // push to right
	      }
	
	      if (value - bounds[handle - 1] < threshold) {
	        direction = -1; // push to left
	      }
	
	      if (direction === 0) {
	        return;
	      }
	
	      var nextHandle = handle + direction;
	      var diffToNext = direction * (bounds[nextHandle] - value);
	
	      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
	        // revert to original value if pushing is impossible
	        // eslint-disable-next-line no-param-reassign
	        bounds[handle] = bounds[nextHandle] - direction * threshold;
	      }
	    }
	  }, {
	    key: "pushHandle",
	    value: function pushHandle(bounds, handle, direction, amount) {
	      var originalValue = bounds[handle];
	      var currentValue = bounds[handle];
	
	      while (direction * (currentValue - originalValue) < amount) {
	        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
	          // can't push handle enough to create the needed `amount` gap, so we
	          // revert its position to the original value
	          // eslint-disable-next-line no-param-reassign
	          bounds[handle] = originalValue;
	          return false;
	        }
	
	        currentValue = bounds[handle];
	      } // the handle was pushed enough to create the needed `amount` gap
	
	
	      return true;
	    }
	  }, {
	    key: "pushHandleOnePoint",
	    value: function pushHandleOnePoint(bounds, handle, direction) {
	      var points = this.getPoints();
	      var pointIndex = points.indexOf(bounds[handle]);
	      var nextPointIndex = pointIndex + direction;
	
	      if (nextPointIndex >= points.length || nextPointIndex < 0) {
	        // reached the minimum or maximum available point, can't push anymore
	        return false;
	      }
	
	      var nextHandle = handle + direction;
	      var nextValue = points[nextPointIndex];
	      var pushable = this.props.pushable;
	      var threshold = Number(pushable);
	      var diffToNext = direction * (bounds[nextHandle] - nextValue);
	
	      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
	        // couldn't push next handle, so we won't push this one either
	        return false;
	      } // push the handle
	      // eslint-disable-next-line no-param-reassign
	
	
	      bounds[handle] = nextValue;
	      return true;
	    }
	  }, {
	    key: "trimAlignValue",
	    value: function trimAlignValue(value) {
	      var _this$state2 = this.state,
	          handle = _this$state2.handle,
	          bounds = _this$state2.bounds;
	      return _trimAlignValue({
	        value: value,
	        handle: handle,
	        bounds: bounds,
	        props: this.props
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this4 = this;
	
	      var _this$state3 = this.state,
	          handle = _this$state3.handle,
	          bounds = _this$state3.bounds;
	      var _this$props4 = this.props,
	          prefixCls = _this$props4.prefixCls,
	          vertical = _this$props4.vertical,
	          included = _this$props4.included,
	          disabled = _this$props4.disabled,
	          min = _this$props4.min,
	          max = _this$props4.max,
	          reverse = _this$props4.reverse,
	          handleGenerator = _this$props4.handle,
	          trackStyle = _this$props4.trackStyle,
	          handleStyle = _this$props4.handleStyle,
	          tabIndex = _this$props4.tabIndex,
	          ariaLabelGroupForHandles = _this$props4.ariaLabelGroupForHandles,
	          ariaLabelledByGroupForHandles = _this$props4.ariaLabelledByGroupForHandles,
	          ariaValueTextFormatterGroupForHandles = _this$props4.ariaValueTextFormatterGroupForHandles;
	      var offsets = bounds.map(function (v) {
	        return _this4.calcOffset(v);
	      });
	      var handleClassName = "".concat(prefixCls, "-handle");
	      var handles = bounds.map(function (v, i) {
	        var _classNames;
	
	        var mergedTabIndex = tabIndex[i] || 0;
	
	        if (disabled || tabIndex[i] === null) {
	          mergedTabIndex = null;
	        }
	
	        var dragging = handle === i;
	        return handleGenerator({
	          className: (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, handleClassName, true), (0, _defineProperty2.default)(_classNames, "".concat(handleClassName, "-").concat(i + 1), true), (0, _defineProperty2.default)(_classNames, "".concat(handleClassName, "-dragging"), dragging), _classNames)),
	          prefixCls: prefixCls,
	          vertical: vertical,
	          dragging: dragging,
	          offset: offsets[i],
	          value: v,
	          index: i,
	          tabIndex: mergedTabIndex,
	          min: min,
	          max: max,
	          reverse: reverse,
	          disabled: disabled,
	          style: handleStyle[i],
	          ref: function ref(h) {
	            return _this4.saveHandle(i, h);
	          },
	          ariaLabel: ariaLabelGroupForHandles[i],
	          ariaLabelledBy: ariaLabelledByGroupForHandles[i],
	          ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i]
	        });
	      });
	      var tracks = bounds.slice(0, -1).map(function (_, index) {
	        var _classNames2;
	
	        var i = index + 1;
	        var trackClassName = (0, _classnames.default)((_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, "".concat(prefixCls, "-track"), true), (0, _defineProperty2.default)(_classNames2, "".concat(prefixCls, "-track-").concat(i), true), _classNames2));
	        return /*#__PURE__*/_react.default.createElement(_Track.default, {
	          className: trackClassName,
	          vertical: vertical,
	          reverse: reverse,
	          included: included,
	          offset: offsets[i - 1],
	          length: offsets[i] - offsets[i - 1],
	          style: trackStyle[index],
	          key: i
	        });
	      });
	      return {
	        tracks: tracks,
	        handles: handles
	      };
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, state) {
	      if (!('value' in props || 'min' in props || 'max' in props)) {
	        return null;
	      }
	
	      var value = props.value || state.bounds;
	      var nextBounds = value.map(function (v, i) {
	        return _trimAlignValue({
	          value: v,
	          handle: i,
	          bounds: state.bounds,
	          props: props
	        });
	      });
	
	      if (state.bounds.length === nextBounds.length) {
	        if (nextBounds.every(function (v, i) {
	          return v === state.bounds[i];
	        })) {
	          return null;
	        }
	      } else {
	        nextBounds = value.map(function (v, i) {
	          return _trimAlignValue({
	            value: v,
	            handle: i,
	            props: props
	          });
	        });
	      }
	
	      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
	        bounds: nextBounds
	      });
	    }
	  }]);
	  return Range;
	}(_react.default.Component);
	/* eslint-enable */
	
	
	Range.displayName = 'Range';
	Range.defaultProps = {
	  count: 1,
	  allowCross: true,
	  pushable: false,
	  draggableTrack: false,
	  tabIndex: [],
	  ariaLabelGroupForHandles: [],
	  ariaLabelledByGroupForHandles: [],
	  ariaValueTextFormatterGroupForHandles: []
	};
	
	var _default = (0, _createSlider.default)(Range);
	
	exports.default = _default;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _warning = _interopRequireDefault(__webpack_require__(125));
	
	var _Track = _interopRequireDefault(__webpack_require__(484));
	
	var _createSlider = _interopRequireDefault(__webpack_require__(485));
	
	var utils = _interopRequireWildcard(__webpack_require__(187));
	
	var Slider = /*#__PURE__*/function (_React$Component) {
	  (0, _inherits2.default)(Slider, _React$Component);
	
	  var _super = (0, _createSuper2.default)(Slider);
	
	  /* eslint-enable */
	  function Slider(props) {
	    var _this;
	
	    (0, _classCallCheck2.default)(this, Slider);
	    _this = _super.call(this, props);
	
	    _this.positionGetValue = function (position) {
	      return [];
	    };
	
	    _this.onEnd = function (force) {
	      var dragging = _this.state.dragging;
	
	      _this.removeDocumentEvents();
	
	      if (dragging || force) {
	        _this.props.onAfterChange(_this.getValue());
	      }
	
	      _this.setState({
	        dragging: false
	      });
	    };
	
	    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
	    var value = props.value !== undefined ? props.value : defaultValue;
	    _this.state = {
	      value: _this.trimAlignValue(value),
	      dragging: false
	    };
	    (0, _warning.default)(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
	    (0, _warning.default)(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
	    return _this;
	  }
	  /**
	   * [Legacy] Used for inherit other component.
	   * It's a bad code style which should be refactor.
	   */
	
	  /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */
	
	
	  (0, _createClass2.default)(Slider, [{
	    key: "calcValueByPos",
	    value: function calcValueByPos(value) {
	      return 0;
	    }
	  }, {
	    key: "calcOffset",
	    value: function calcOffset(value) {
	      return 0;
	    }
	  }, {
	    key: "saveHandle",
	    value: function saveHandle(index, h) {}
	  }, {
	    key: "removeDocumentEvents",
	    value: function removeDocumentEvents() {}
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this$props = this.props,
	          min = _this$props.min,
	          max = _this$props.max,
	          value = _this$props.value,
	          onChange = _this$props.onChange;
	
	      if (!('min' in this.props || 'max' in this.props)) {
	        return;
	      }
	
	      var theValue = value !== undefined ? value : prevState.value;
	      var nextValue = this.trimAlignValue(theValue, this.props);
	
	      if (nextValue === prevState.value) {
	        return;
	      } // eslint-disable-next-line
	
	
	      this.setState({
	        value: nextValue
	      });
	
	      if (!(min === prevProps.min && max === prevProps.max) && utils.isValueOutOfRange(theValue, this.props)) {
	        onChange(nextValue);
	      }
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(state) {
	      var props = this.props;
	      var isNotControlled = !('value' in props);
	      var nextState = state.value > this.props.max ? (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state), {}, {
	        value: this.props.max
	      }) : state;
	
	      if (isNotControlled) {
	        this.setState(nextState);
	      }
	
	      var changedValue = nextState.value;
	      props.onChange(changedValue);
	    }
	  }, {
	    key: "onStart",
	    value: function onStart(position) {
	      this.setState({
	        dragging: true
	      });
	      var props = this.props;
	      var prevValue = this.getValue();
	      props.onBeforeChange(prevValue);
	      var value = this.calcValueByPos(position);
	      this.startValue = value;
	      this.startPosition = position;
	      if (value === prevValue) return;
	      this.prevMovedHandleIndex = 0;
	      this.onChange({
	        value: value
	      });
	    }
	  }, {
	    key: "onMove",
	    value: function onMove(e, position) {
	      utils.pauseEvent(e);
	      var oldValue = this.state.value;
	      var value = this.calcValueByPos(position);
	      if (value === oldValue) return;
	      this.onChange({
	        value: value
	      });
	    }
	  }, {
	    key: "onKeyboard",
	    value: function onKeyboard(e) {
	      var _this$props2 = this.props,
	          reverse = _this$props2.reverse,
	          vertical = _this$props2.vertical;
	      var valueMutator = utils.getKeyboardValueMutator(e, vertical, reverse);
	
	      if (valueMutator) {
	        utils.pauseEvent(e);
	        var state = this.state;
	        var oldValue = state.value;
	        var mutatedValue = valueMutator(oldValue, this.props);
	        var value = this.trimAlignValue(mutatedValue);
	        if (value === oldValue) return;
	        this.onChange({
	          value: value
	        });
	        this.props.onAfterChange(value);
	        this.onEnd();
	      }
	    }
	  }, {
	    key: "getValue",
	    value: function getValue() {
	      return this.state.value;
	    }
	  }, {
	    key: "getLowerBound",
	    value: function getLowerBound() {
	      var minPoint = this.props.startPoint || this.props.min;
	      return this.state.value > minPoint ? minPoint : this.state.value;
	    }
	  }, {
	    key: "getUpperBound",
	    value: function getUpperBound() {
	      if (this.state.value < this.props.startPoint) {
	        return this.props.startPoint;
	      }
	
	      return this.state.value;
	    }
	  }, {
	    key: "trimAlignValue",
	    value: function trimAlignValue(v) {
	      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (v === null) {
	        return null;
	      }
	
	      var mergedProps = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.props), nextProps);
	      var val = utils.ensureValueInRange(v, mergedProps);
	      return utils.ensureValuePrecision(val, mergedProps);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          prefixCls = _this$props3.prefixCls,
	          vertical = _this$props3.vertical,
	          included = _this$props3.included,
	          disabled = _this$props3.disabled,
	          minimumTrackStyle = _this$props3.minimumTrackStyle,
	          trackStyle = _this$props3.trackStyle,
	          handleStyle = _this$props3.handleStyle,
	          tabIndex = _this$props3.tabIndex,
	          ariaLabelForHandle = _this$props3.ariaLabelForHandle,
	          ariaLabelledByForHandle = _this$props3.ariaLabelledByForHandle,
	          ariaValueTextFormatterForHandle = _this$props3.ariaValueTextFormatterForHandle,
	          min = _this$props3.min,
	          max = _this$props3.max,
	          startPoint = _this$props3.startPoint,
	          reverse = _this$props3.reverse,
	          handleGenerator = _this$props3.handle;
	      var _this$state = this.state,
	          value = _this$state.value,
	          dragging = _this$state.dragging;
	      var offset = this.calcOffset(value);
	      var handle = handleGenerator({
	        className: "".concat(prefixCls, "-handle"),
	        prefixCls: prefixCls,
	        vertical: vertical,
	        offset: offset,
	        value: value,
	        dragging: dragging,
	        disabled: disabled,
	        min: min,
	        max: max,
	        reverse: reverse,
	        index: 0,
	        tabIndex: tabIndex,
	        ariaLabel: ariaLabelForHandle,
	        ariaLabelledBy: ariaLabelledByForHandle,
	        ariaValueTextFormatter: ariaValueTextFormatterForHandle,
	        style: handleStyle[0] || handleStyle,
	        ref: function ref(h) {
	          return _this2.saveHandle(0, h);
	        }
	      });
	      var trackOffset = startPoint !== undefined ? this.calcOffset(startPoint) : 0;
	      var mergedTrackStyle = trackStyle[0] || trackStyle;
	
	      var track = /*#__PURE__*/_react.default.createElement(_Track.default, {
	        className: "".concat(prefixCls, "-track"),
	        vertical: vertical,
	        included: included,
	        offset: trackOffset,
	        reverse: reverse,
	        length: offset - trackOffset,
	        style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, minimumTrackStyle), mergedTrackStyle)
	      });
	
	      return {
	        tracks: track,
	        handles: handle
	      };
	    }
	  }]);
	  return Slider;
	}(_react.default.Component);
	
	var _default = (0, _createSlider.default)(Slider);
	
	exports.default = _default;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(38));
	
	var Marks = function Marks(_ref) {
	  var className = _ref.className,
	      vertical = _ref.vertical,
	      reverse = _ref.reverse,
	      marks = _ref.marks,
	      included = _ref.included,
	      upperBound = _ref.upperBound,
	      lowerBound = _ref.lowerBound,
	      max = _ref.max,
	      min = _ref.min,
	      onClickLabel = _ref.onClickLabel;
	  var marksKeys = Object.keys(marks);
	  var range = max - min;
	  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
	    return a - b;
	  }).map(function (point) {
	    var _classNames;
	
	    var markPoint = marks[point];
	    var markPointIsObject = (0, _typeof2.default)(markPoint) === 'object' && ! /*#__PURE__*/_react.default.isValidElement(markPoint);
	    var markLabel = markPointIsObject ? markPoint.label : markPoint;
	
	    if (!markLabel && markLabel !== 0) {
	      return null;
	    }
	
	    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var markClassName = (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(className, "-text"), true), (0, _defineProperty2.default)(_classNames, "".concat(className, "-text-active"), isActive), _classNames));
	    var bottomStyle = (0, _defineProperty2.default)({
	      marginBottom: '-50%'
	    }, reverse ? 'top' : 'bottom', "".concat((point - min) / range * 100, "%"));
	    var leftStyle = (0, _defineProperty2.default)({
	      transform: "translateX(".concat(reverse ? "50%" : "-50%", ")"),
	      msTransform: "translateX(".concat(reverse ? "50%" : "-50%", ")")
	    }, reverse ? 'right' : 'left', "".concat((point - min) / range * 100, "%"));
	    var style = vertical ? bottomStyle : leftStyle;
	    var markStyle = markPointIsObject ? (0, _objectSpread2.default)((0, _objectSpread2.default)({}, style), markPoint.style) : style;
	    return /*#__PURE__*/_react.default.createElement("span", {
	      className: markClassName,
	      style: markStyle,
	      key: point,
	      onMouseDown: function onMouseDown(e) {
	        return onClickLabel(e, point);
	      },
	      onTouchStart: function onTouchStart(e) {
	        return onClickLabel(e, point);
	      }
	    }, markLabel);
	  });
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: className
	  }, elements);
	};
	
	var _default = Marks;
	exports.default = _default;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread4 = _interopRequireDefault(__webpack_require__(34));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(38));
	
	var _warning = _interopRequireDefault(__webpack_require__(125));
	
	var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
	  (0, _warning.default)(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
	  var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
	    return a - b;
	  });
	
	  if (dots && step) {
	    for (var i = min; i <= max; i += step) {
	      if (points.indexOf(i) === -1) {
	        points.push(i);
	      }
	    }
	  }
	
	  return points;
	};
	
	var Steps = function Steps(_ref) {
	  var prefixCls = _ref.prefixCls,
	      vertical = _ref.vertical,
	      reverse = _ref.reverse,
	      marks = _ref.marks,
	      dots = _ref.dots,
	      step = _ref.step,
	      included = _ref.included,
	      lowerBound = _ref.lowerBound,
	      upperBound = _ref.upperBound,
	      max = _ref.max,
	      min = _ref.min,
	      dotStyle = _ref.dotStyle,
	      activeDotStyle = _ref.activeDotStyle;
	  var range = max - min;
	  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
	    var _classNames;
	
	    var offset = "".concat(Math.abs(point - min) / range * 100, "%");
	    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var style = vertical ? (0, _objectSpread4.default)((0, _objectSpread4.default)({}, dotStyle), {}, (0, _defineProperty2.default)({}, reverse ? 'top' : 'bottom', offset)) : (0, _objectSpread4.default)((0, _objectSpread4.default)({}, dotStyle), {}, (0, _defineProperty2.default)({}, reverse ? 'right' : 'left', offset));
	
	    if (isActived) {
	      style = (0, _objectSpread4.default)((0, _objectSpread4.default)({}, style), activeDotStyle);
	    }
	
	    var pointClassName = (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-dot"), true), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-dot-active"), isActived), (0, _defineProperty2.default)(_classNames, "".concat(prefixCls, "-dot-reverse"), reverse), _classNames));
	    return /*#__PURE__*/_react.default.createElement("span", {
	      className: pointClassName,
	      style: style,
	      key: point
	    });
	  });
	  return /*#__PURE__*/_react.default.createElement("div", {
	    className: "".concat(prefixCls, "-step")
	  }, elements);
	};
	
	var _default = Steps;
	exports.default = _default;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSliderWithTooltip;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(42));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(44));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _objectSpread3 = _interopRequireDefault(__webpack_require__(34));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _SliderTooltip = _interopRequireDefault(__webpack_require__(483));
	
	var _Handle = _interopRequireDefault(__webpack_require__(186));
	
	function createSliderWithTooltip(Component) {
	  var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
	
	
	  return _a = /*#__PURE__*/function (_React$Component) {
	    (0, _inherits2.default)(ComponentWrapper, _React$Component);
	
	    var _super = (0, _createSuper2.default)(ComponentWrapper);
	
	    function ComponentWrapper() {
	      var _this;
	
	      (0, _classCallCheck2.default)(this, ComponentWrapper);
	      _this = _super.apply(this, arguments);
	      _this.state = {
	        visibles: {}
	      };
	
	      _this.handleTooltipVisibleChange = function (index, visible) {
	        _this.setState(function (prevState) {
	          return {
	            visibles: (0, _objectSpread3.default)((0, _objectSpread3.default)({}, prevState.visibles), {}, (0, _defineProperty2.default)({}, index, visible))
	          };
	        });
	      };
	
	      _this.handleWithTooltip = function (_ref) {
	        var value = _ref.value,
	            dragging = _ref.dragging,
	            index = _ref.index,
	            disabled = _ref.disabled,
	            restProps = (0, _objectWithoutProperties2.default)(_ref, ["value", "dragging", "index", "disabled"]);
	        var _this$props = _this.props,
	            tipFormatter = _this$props.tipFormatter,
	            tipProps = _this$props.tipProps,
	            handleStyle = _this$props.handleStyle,
	            getTooltipContainer = _this$props.getTooltipContainer;
	        var _tipProps$prefixCls = tipProps.prefixCls,
	            prefixCls = _tipProps$prefixCls === void 0 ? 'rc-slider-tooltip' : _tipProps$prefixCls,
	            _tipProps$overlay = tipProps.overlay,
	            overlay = _tipProps$overlay === void 0 ? tipFormatter(value) : _tipProps$overlay,
	            _tipProps$placement = tipProps.placement,
	            placement = _tipProps$placement === void 0 ? 'top' : _tipProps$placement,
	            _tipProps$visible = tipProps.visible,
	            visible = _tipProps$visible === void 0 ? false : _tipProps$visible,
	            restTooltipProps = (0, _objectWithoutProperties2.default)(tipProps, ["prefixCls", "overlay", "placement", "visible"]);
	        var handleStyleWithIndex;
	
	        if (Array.isArray(handleStyle)) {
	          handleStyleWithIndex = handleStyle[index] || handleStyle[0];
	        } else {
	          handleStyleWithIndex = handleStyle;
	        }
	
	        return /*#__PURE__*/_react.default.createElement(_SliderTooltip.default, (0, _extends2.default)({}, restTooltipProps, {
	          getTooltipContainer: getTooltipContainer,
	          prefixCls: prefixCls,
	          overlay: overlay,
	          placement: placement,
	          visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
	          key: index
	        }), /*#__PURE__*/_react.default.createElement(_Handle.default, (0, _extends2.default)({}, restProps, {
	          style: (0, _objectSpread3.default)({}, handleStyleWithIndex),
	          value: value,
	          onMouseEnter: function onMouseEnter() {
	            return _this.handleTooltipVisibleChange(index, true);
	          },
	          onMouseLeave: function onMouseLeave() {
	            return _this.handleTooltipVisibleChange(index, false);
	          }
	        })));
	      };
	
	      return _this;
	    }
	
	    (0, _createClass2.default)(ComponentWrapper, [{
	      key: "render",
	      value: function render() {
	        return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, this.props, {
	          handle: this.handleWithTooltip
	        }));
	      }
	    }]);
	    return ComponentWrapper;
	  }(_react.default.Component), _a.defaultProps = {
	    tipFormatter: function tipFormatter(value) {
	      return value;
	    },
	    handleStyle: [{}],
	    tipProps: {},
	    getTooltipContainer: function getTooltipContainer(node) {
	      return node.parentNode;
	    }
	  }, _a;
	}

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Range", {
	  enumerable: true,
	  get: function get() {
	    return _Range.default;
	  }
	});
	Object.defineProperty(exports, "Handle", {
	  enumerable: true,
	  get: function get() {
	    return _Handle.default;
	  }
	});
	Object.defineProperty(exports, "createSliderWithTooltip", {
	  enumerable: true,
	  get: function get() {
	    return _createSliderWithTooltip.default;
	  }
	});
	Object.defineProperty(exports, "SliderTooltip", {
	  enumerable: true,
	  get: function get() {
	    return _SliderTooltip.default;
	  }
	});
	exports.default = void 0;
	
	var _Slider = _interopRequireDefault(__webpack_require__(1110));
	
	var _Range = _interopRequireDefault(__webpack_require__(1109));
	
	var _Handle = _interopRequireDefault(__webpack_require__(186));
	
	var _createSliderWithTooltip = _interopRequireDefault(__webpack_require__(1113));
	
	var _SliderTooltip = _interopRequireDefault(__webpack_require__(483));
	
	var InternalSlider = _Slider.default;
	InternalSlider.Range = _Range.default;
	InternalSlider.Handle = _Handle.default;
	InternalSlider.createSliderWithTooltip = _createSliderWithTooltip.default;
	var _default = InternalSlider;
	exports.default = _default;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	var _typeof3 = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _extends2 = _interopRequireDefault(__webpack_require__(42));
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(44));
	var React = _interopRequireWildcard(__webpack_require__(2));
	var _rcTrigger = _interopRequireDefault(__webpack_require__(1125));
	var _placements = __webpack_require__(1117);
	var _Popup = _interopRequireDefault(__webpack_require__(486));
	var _excluded = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"];
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var Tooltip = function Tooltip(props, ref) {
	  var overlayClassName = props.overlayClassName,
	    _props$trigger = props.trigger,
	    trigger = _props$trigger === void 0 ? ['hover'] : _props$trigger,
	    _props$mouseEnterDela = props.mouseEnterDelay,
	    mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela,
	    _props$mouseLeaveDela = props.mouseLeaveDelay,
	    mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela,
	    overlayStyle = props.overlayStyle,
	    _props$prefixCls = props.prefixCls,
	    prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls,
	    children = props.children,
	    onVisibleChange = props.onVisibleChange,
	    afterVisibleChange = props.afterVisibleChange,
	    transitionName = props.transitionName,
	    animation = props.animation,
	    motion = props.motion,
	    _props$placement = props.placement,
	    placement = _props$placement === void 0 ? 'right' : _props$placement,
	    _props$align = props.align,
	    align = _props$align === void 0 ? {} : _props$align,
	    _props$destroyTooltip = props.destroyTooltipOnHide,
	    destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip,
	    defaultVisible = props.defaultVisible,
	    getTooltipContainer = props.getTooltipContainer,
	    overlayInnerStyle = props.overlayInnerStyle,
	    arrowContent = props.arrowContent,
	    overlay = props.overlay,
	    id = props.id,
	    _props$showArrow = props.showArrow,
	    showArrow = _props$showArrow === void 0 ? true : _props$showArrow,
	    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
	  var domRef = (0, React.useRef)(null);
	  (0, React.useImperativeHandle)(ref, function () {
	    return domRef.current;
	  });
	  var extraProps = (0, _objectSpread2.default)({}, restProps);
	  if ('visible' in props) {
	    extraProps.popupVisible = props.visible;
	  }
	  var getPopupElement = function getPopupElement() {
	    return /*#__PURE__*/React.createElement(_Popup.default, {
	      showArrow: showArrow,
	      arrowContent: arrowContent,
	      key: "content",
	      prefixCls: prefixCls,
	      id: id,
	      overlayInnerStyle: overlayInnerStyle
	    }, overlay);
	  };
	  var destroyTooltip = false;
	  var autoDestroy = false;
	  if (typeof destroyTooltipOnHide === 'boolean') {
	    destroyTooltip = destroyTooltipOnHide;
	  } else if (destroyTooltipOnHide && (0, _typeof2.default)(destroyTooltipOnHide) === 'object') {
	    var keepParent = destroyTooltipOnHide.keepParent;
	    destroyTooltip = keepParent === true;
	    autoDestroy = keepParent === false;
	  }
	  return /*#__PURE__*/React.createElement(_rcTrigger.default, (0, _extends2.default)({
	    popupClassName: overlayClassName,
	    prefixCls: prefixCls,
	    popup: getPopupElement,
	    action: trigger,
	    builtinPlacements: _placements.placements,
	    popupPlacement: placement,
	    ref: domRef,
	    popupAlign: align,
	    getPopupContainer: getTooltipContainer,
	    onPopupVisibleChange: onVisibleChange,
	    afterPopupVisibleChange: afterVisibleChange,
	    popupTransitionName: transitionName,
	    popupAnimation: animation,
	    popupMotion: motion,
	    defaultPopupVisible: defaultVisible,
	    destroyPopupOnHide: destroyTooltip,
	    autoDestroy: autoDestroy,
	    mouseLeaveDelay: mouseLeaveDelay,
	    popupStyle: overlayStyle,
	    mouseEnterDelay: mouseEnterDelay
	  }, extraProps), children);
	};
	var _default = /*#__PURE__*/(0, React.forwardRef)(Tooltip);
	exports.default = _default;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popup", {
	  enumerable: true,
	  get: function get() {
	    return _Popup.default;
	  }
	});
	exports.default = void 0;
	var _Tooltip = _interopRequireDefault(__webpack_require__(1115));
	var _Popup = _interopRequireDefault(__webpack_require__(486));
	var _default = _Tooltip.default;
	exports.default = _default;

/***/ },
/* 1117 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.placements = exports.default = void 0;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	var targetOffset = [0, 0];
	var placements = {
	  left: {
	    points: ['cr', 'cl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  right: {
	    points: ['cl', 'cr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  top: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottom: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  rightBottom: {
	    points: ['bl', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  leftBottom: {
	    points: ['br', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  }
	};
	exports.placements = placements;
	var _default = placements;
	exports.default = _default;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36).default;
	
	var _interopRequireDefault = __webpack_require__(1).default;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Mask;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(42));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(38));
	
	var _rcMotion = _interopRequireDefault(__webpack_require__(183));
	
	var _legacyUtil = __webpack_require__(487);
	
	function Mask(props) {
	  var prefixCls = props.prefixCls,
	      visible = props.visible,
	      zIndex = props.zIndex,
	      mask = props.mask,
	      maskMotion = props.maskMotion,
	      maskAnimation = props.maskAnimation,
	      maskTransitionName = props.maskTransitionName;
	
	  if (!mask) {
	    return null;
	  }
	
	  var motion = {};
	
	  if (maskMotion || maskTransitionName || maskAnimation) {
	    motion = (0, _objectSpread2.default)({
	      motionAppear: true
	    }, (0, _legacyUtil.getMotion)({
	      motion: maskMotion,
	      prefixCls: prefixCls,
	      transitionName: maskTransitionName,
	      animation: maskAnimation
	    }));
	  }
	
	  return /*#__PURE__*/React.createElement(_rcMotion.default, (0, _extends2.default)({}, motion, {
	    visible: visible,
	    removeOnLeave: true
	  }), function (_ref) {
	    var className = _ref.className;
	    return /*#__PURE__*/React.createElement("div", {
	      style: {
	        zIndex: zIndex
	      },
	      className: (0, _classnames.default)("".concat(prefixCls, "-mask"), className)
	    });
	  });
	}

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36).default;
	
	var _interopRequireDefault = __webpack_require__(1).default;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(42));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _rcMotion = _interopRequireDefault(__webpack_require__(183));
	
	var _classnames = _interopRequireDefault(__webpack_require__(38));
	
	var MobilePopupInner = /*#__PURE__*/React.forwardRef(function (props, ref) {
	  var prefixCls = props.prefixCls,
	      visible = props.visible,
	      zIndex = props.zIndex,
	      children = props.children,
	      _props$mobile = props.mobile;
	  _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
	  var popupClassName = _props$mobile.popupClassName,
	      popupStyle = _props$mobile.popupStyle,
	      _props$mobile$popupMo = _props$mobile.popupMotion,
	      popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo,
	      popupRender = _props$mobile.popupRender,
	      onClick = props.onClick;
	  var elementRef = React.useRef(); // ========================= Refs =========================
	
	  React.useImperativeHandle(ref, function () {
	    return {
	      forceAlign: function forceAlign() {},
	      getElement: function getElement() {
	        return elementRef.current;
	      }
	    };
	  }); // ======================== Render ========================
	
	  var mergedStyle = (0, _objectSpread2.default)({
	    zIndex: zIndex
	  }, popupStyle);
	  var childNode = children; // Wrapper when multiple children
	
	  if (React.Children.count(children) > 1) {
	    childNode = /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-content")
	    }, children);
	  } // Mobile support additional render
	
	
	  if (popupRender) {
	    childNode = popupRender(childNode);
	  }
	
	  return /*#__PURE__*/React.createElement(_rcMotion.default, (0, _extends2.default)({
	    visible: visible,
	    ref: elementRef,
	    removeOnLeave: true
	  }, popupMotion), function (_ref, motionRef) {
	    var motionClassName = _ref.className,
	        motionStyle = _ref.style;
	    var mergedClassName = (0, _classnames.default)(prefixCls, popupClassName, motionClassName);
	    return /*#__PURE__*/React.createElement("div", {
	      ref: motionRef,
	      className: mergedClassName,
	      onClick: onClick,
	      style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, motionStyle), mergedStyle)
	    }, childNode);
	  });
	});
	MobilePopupInner.displayName = 'MobilePopupInner';
	var _default = MobilePopupInner;
	exports.default = _default;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36).default;
	
	var _interopRequireDefault = __webpack_require__(1).default;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(42));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _rcAlign = _interopRequireDefault(__webpack_require__(1101));
	
	var _useLayoutEffect = _interopRequireDefault(__webpack_require__(490));
	
	var _rcMotion = _interopRequireDefault(__webpack_require__(183));
	
	var _classnames = _interopRequireDefault(__webpack_require__(38));
	
	var _useVisibleStatus3 = _interopRequireDefault(__webpack_require__(1123));
	
	var _legacyUtil = __webpack_require__(487);
	
	var _useStretchStyle3 = _interopRequireDefault(__webpack_require__(1122));
	
	var PopupInner = /*#__PURE__*/React.forwardRef(function (props, ref) {
	  var visible = props.visible,
	      prefixCls = props.prefixCls,
	      className = props.className,
	      style = props.style,
	      children = props.children,
	      zIndex = props.zIndex,
	      stretch = props.stretch,
	      destroyPopupOnHide = props.destroyPopupOnHide,
	      forceRender = props.forceRender,
	      align = props.align,
	      point = props.point,
	      getRootDomNode = props.getRootDomNode,
	      getClassNameFromAlign = props.getClassNameFromAlign,
	      onAlign = props.onAlign,
	      onMouseEnter = props.onMouseEnter,
	      onMouseLeave = props.onMouseLeave,
	      onMouseDown = props.onMouseDown,
	      onTouchStart = props.onTouchStart,
	      onClick = props.onClick;
	  var alignRef = (0, React.useRef)();
	  var elementRef = (0, React.useRef)();
	
	  var _useState = (0, React.useState)(),
	      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	      alignedClassName = _useState2[0],
	      setAlignedClassName = _useState2[1]; // ======================= Measure ========================
	
	
	  var _useStretchStyle = (0, _useStretchStyle3.default)(stretch),
	      _useStretchStyle2 = (0, _slicedToArray2.default)(_useStretchStyle, 2),
	      stretchStyle = _useStretchStyle2[0],
	      measureStretchStyle = _useStretchStyle2[1];
	
	  function doMeasure() {
	    if (stretch) {
	      measureStretchStyle(getRootDomNode());
	    }
	  } // ======================== Status ========================
	
	
	  var _useVisibleStatus = (0, _useVisibleStatus3.default)(visible, doMeasure),
	      _useVisibleStatus2 = (0, _slicedToArray2.default)(_useVisibleStatus, 2),
	      status = _useVisibleStatus2[0],
	      goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================
	
	  /**
	   * `alignedClassName` may modify `source` size,
	   * which means one time align may not move to the correct position at once.
	   *
	   * We will reset `alignTimes` for each status switch to `alignPre`
	   * and let `rc-align` to align for multiple times to ensure get final stable place.
	   * Currently we mark `alignTimes < 2` repeat align, it will increase if user report for align issue.
	   * 
	   * Update:
	   * In React 18. `rc-align` effect of align may faster than ref called trigger `forceAlign`.
	   * We adjust this to `alignTimes < 2`.
	   * We need refactor `rc-align` to support mark of `forceAlign` call if this still happen.
	   */
	
	
	  var _useState3 = (0, React.useState)(0),
	      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
	      alignTimes = _useState4[0],
	      setAlignTimes = _useState4[1];
	
	  var prepareResolveRef = (0, React.useRef)();
	  (0, _useLayoutEffect.default)(function () {
	    if (status === 'alignPre') {
	      setAlignTimes(0);
	    }
	  }, [status]); // `target` on `rc-align` can accept as a function to get the bind element or a point.
	  // ref: https://www.npmjs.com/package/rc-align
	
	  function getAlignTarget() {
	    if (point) {
	      return point;
	    }
	
	    return getRootDomNode;
	  }
	
	  function forceAlign() {
	    var _alignRef$current;
	
	    (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 ? void 0 : _alignRef$current.forceAlign();
	  }
	
	  function onInternalAlign(popupDomNode, matchAlign) {
	    var nextAlignedClassName = getClassNameFromAlign(matchAlign);
	
	    if (alignedClassName !== nextAlignedClassName) {
	      setAlignedClassName(nextAlignedClassName);
	    } // We will retry multi times to make sure that the element has been align in the right position.
	
	
	    setAlignTimes(function (val) {
	      return val + 1;
	    });
	
	    if (status === 'align') {
	      onAlign === null || onAlign === void 0 ? void 0 : onAlign(popupDomNode, matchAlign);
	    }
	  } // Delay to go to next status
	
	
	  (0, _useLayoutEffect.default)(function () {
	    if (status === 'align') {
	      // Repeat until not more align needed
	      if (alignTimes < 3) {
	        forceAlign();
	      } else {
	        goNextStatus(function () {
	          var _prepareResolveRef$cu;
	
	          (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 ? void 0 : _prepareResolveRef$cu.call(prepareResolveRef);
	        });
	      }
	    }
	  }, [alignTimes]); // ======================== Motion ========================
	
	  var motion = (0, _objectSpread2.default)({}, (0, _legacyUtil.getMotion)(props));
	  ['onAppearEnd', 'onEnterEnd', 'onLeaveEnd'].forEach(function (eventName) {
	    var originHandler = motion[eventName];
	
	    motion[eventName] = function (element, event) {
	      goNextStatus();
	      return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
	    };
	  });
	
	  function onShowPrepare() {
	    return new Promise(function (resolve) {
	      prepareResolveRef.current = resolve;
	    });
	  } // Go to stable directly when motion not provided
	
	
	  React.useEffect(function () {
	    if (!motion.motionName && status === 'motion') {
	      goNextStatus();
	    }
	  }, [motion.motionName, status]); // ========================= Refs =========================
	
	  React.useImperativeHandle(ref, function () {
	    return {
	      forceAlign: forceAlign,
	      getElement: function getElement() {
	        return elementRef.current;
	      }
	    };
	  }); // ======================== Render ========================
	
	  var mergedStyle = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stretchStyle), {}, {
	    zIndex: zIndex,
	    opacity: status === 'motion' || status === 'stable' || !visible ? undefined : 0,
	    // Cannot interact with disappearing elements
	    // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
	    pointerEvents: !visible && status !== 'stable' ? 'none' : undefined
	  }, style); // Align status
	
	  var alignDisabled = true;
	
	  if (align !== null && align !== void 0 && align.points && (status === 'align' || status === 'stable')) {
	    alignDisabled = false;
	  }
	
	  var childNode = children; // Wrapper when multiple children
	
	  if (React.Children.count(children) > 1) {
	    childNode = /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-content")
	    }, children);
	  }
	
	  return /*#__PURE__*/React.createElement(_rcMotion.default, (0, _extends2.default)({
	    visible: visible,
	    ref: elementRef,
	    leavedClassName: "".concat(prefixCls, "-hidden")
	  }, motion, {
	    onAppearPrepare: onShowPrepare,
	    onEnterPrepare: onShowPrepare,
	    removeOnLeave: destroyPopupOnHide,
	    forceRender: forceRender
	  }), function (_ref, motionRef) {
	    var motionClassName = _ref.className,
	        motionStyle = _ref.style;
	    var mergedClassName = (0, _classnames.default)(prefixCls, className, alignedClassName, motionClassName);
	    return /*#__PURE__*/React.createElement(_rcAlign.default, {
	      target: getAlignTarget(),
	      key: "popup",
	      ref: alignRef,
	      monitorWindowResize: true,
	      disabled: alignDisabled,
	      align: align,
	      onAlign: onInternalAlign
	    }, /*#__PURE__*/React.createElement("div", {
	      ref: motionRef,
	      className: mergedClassName,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      onMouseDownCapture: onMouseDown,
	      onTouchStartCapture: onTouchStart,
	      onClick: onClick,
	      style: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, motionStyle), mergedStyle)
	    }, childNode));
	  });
	});
	PopupInner.displayName = 'PopupInner';
	var _default = PopupInner;
	exports.default = _default;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	
	var _interopRequireWildcard = __webpack_require__(36).default;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(42));
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(44));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _isMobile = _interopRequireDefault(__webpack_require__(1132));
	
	var _Mask = _interopRequireDefault(__webpack_require__(1118));
	
	var _PopupInner = _interopRequireDefault(__webpack_require__(1120));
	
	var _MobilePopupInner = _interopRequireDefault(__webpack_require__(1119));
	
	var _excluded = ["visible", "mobile"];
	var Popup = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
	  var visible = _ref.visible,
	      mobile = _ref.mobile,
	      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
	
	  var _useState = (0, React.useState)(visible),
	      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	      innerVisible = _useState2[0],
	      serInnerVisible = _useState2[1];
	
	  var _useState3 = (0, React.useState)(false),
	      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
	      inMobile = _useState4[0],
	      setInMobile = _useState4[1];
	
	  var cloneProps = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
	    visible: innerVisible
	  }); // We check mobile in visible changed here.
	  // And this also delay set `innerVisible` to avoid popup component render flash
	
	  (0, React.useEffect)(function () {
	    serInnerVisible(visible);
	
	    if (visible && mobile) {
	      setInMobile((0, _isMobile.default)());
	    }
	  }, [visible, mobile]);
	  var popupNode = inMobile ? /*#__PURE__*/React.createElement(_MobilePopupInner.default, (0, _extends2.default)({}, cloneProps, {
	    mobile: mobile,
	    ref: ref
	  })) : /*#__PURE__*/React.createElement(_PopupInner.default, (0, _extends2.default)({}, cloneProps, {
	    ref: ref
	  })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic
	
	  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Mask.default, cloneProps), popupNode);
	});
	Popup.displayName = 'Popup';
	var _default = Popup;
	exports.default = _default;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36).default;
	
	var _interopRequireDefault = __webpack_require__(1).default;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _default = function _default(stretch) {
	  var _React$useState = React.useState({
	    width: 0,
	    height: 0
	  }),
	      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
	      targetSize = _React$useState2[0],
	      setTargetSize = _React$useState2[1];
	
	  function measureStretch(element) {
	    var tgtWidth = element.offsetWidth,
	        tgtHeight = element.offsetHeight;
	
	    var _element$getBoundingC = element.getBoundingClientRect(),
	        width = _element$getBoundingC.width,
	        height = _element$getBoundingC.height; // Rect is more accurate than offset, use if near
	
	
	    if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
	      tgtWidth = width;
	      tgtHeight = height;
	    }
	
	    setTargetSize({
	      width: tgtWidth,
	      height: tgtHeight
	    });
	  } // Merge stretch style
	
	
	  var style = React.useMemo(function () {
	    var sizeStyle = {};
	
	    if (stretch) {
	      var width = targetSize.width,
	          height = targetSize.height; // Stretch with target
	
	      if (stretch.indexOf('height') !== -1 && height) {
	        sizeStyle.height = height;
	      } else if (stretch.indexOf('minHeight') !== -1 && height) {
	        sizeStyle.minHeight = height;
	      }
	
	      if (stretch.indexOf('width') !== -1 && width) {
	        sizeStyle.width = width;
	      } else if (stretch.indexOf('minWidth') !== -1 && width) {
	        sizeStyle.minWidth = width;
	      }
	    }
	
	    return sizeStyle;
	  }, [stretch, targetSize]);
	  return [style, measureStretch];
	};
	
	exports.default = _default;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _regeneratorRuntime2 = _interopRequireDefault(__webpack_require__(532));
	
	var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(524));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(23));
	
	var _react = __webpack_require__(2);
	
	var _raf = _interopRequireDefault(__webpack_require__(123));
	
	var _useState3 = _interopRequireDefault(__webpack_require__(188));
	
	var StatusQueue = ['measure', 'alignPre', 'align', null, 'motion'];
	
	var _default = function _default(visible, doMeasure) {
	  var _useState = (0, _useState3.default)(null),
	      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
	      status = _useState2[0],
	      setInternalStatus = _useState2[1];
	
	  var rafRef = (0, _react.useRef)();
	
	  function setStatus(nextStatus) {
	    setInternalStatus(nextStatus, true);
	  }
	
	  function cancelRaf() {
	    _raf.default.cancel(rafRef.current);
	  }
	
	  function goNextStatus(callback) {
	    cancelRaf();
	    rafRef.current = (0, _raf.default)(function () {
	      // Only align should be manually trigger
	      setStatus(function (prev) {
	        switch (status) {
	          case 'align':
	            return 'motion';
	
	          case 'motion':
	            return 'stable';
	
	          default:
	        }
	
	        return prev;
	      });
	      callback === null || callback === void 0 ? void 0 : callback();
	    });
	  } // Init status
	
	
	  (0, _react.useEffect)(function () {
	    setStatus('measure');
	  }, [visible]); // Go next status
	
	  (0, _react.useEffect)(function () {
	    switch (status) {
	      case 'measure':
	        doMeasure();
	        break;
	
	      default:
	    }
	
	    if (status) {
	      rafRef.current = (0, _raf.default)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
	        var index, nextStatus;
	        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                index = StatusQueue.indexOf(status);
	                nextStatus = StatusQueue[index + 1];
	
	                if (nextStatus && index !== -1) {
	                  setStatus(nextStatus);
	                }
	
	              case 3:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee);
	      })));
	    }
	  }, [status]);
	  (0, _react.useEffect)(function () {
	    return function () {
	      cancelRaf();
	    };
	  }, []);
	  return [status, goNextStatus];
	};
	
	exports.default = _default;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36).default;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var TriggerContext = /*#__PURE__*/React.createContext(null);
	var _default = TriggerContext;
	exports.default = _default;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36).default;
	
	var _interopRequireDefault = __webpack_require__(1).default;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	exports.generateTrigger = generateTrigger;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(42));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(6));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(7));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(8));
	
	var _createSuper2 = _interopRequireDefault(__webpack_require__(21));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(37));
	
	var _raf = _interopRequireDefault(__webpack_require__(123));
	
	var _contains = _interopRequireDefault(__webpack_require__(488));
	
	var _findDOMNode = _interopRequireDefault(__webpack_require__(489));
	
	var _ref2 = __webpack_require__(124);
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(121));
	
	var _Portal = _interopRequireDefault(__webpack_require__(1129));
	
	var _classnames = _interopRequireDefault(__webpack_require__(38));
	
	var _alignUtil = __webpack_require__(1126);
	
	var _Popup = _interopRequireDefault(__webpack_require__(1121));
	
	var _context = _interopRequireDefault(__webpack_require__(1124));
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	function returnDocument(element) {
	  if (element) {
	    return element.ownerDocument;
	  }
	
	  return window.document;
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
	
	/**
	 * Internal usage. Do not use in your code since this will be removed.
	 */
	function generateTrigger(PortalComponent) {
	  var Trigger = /*#__PURE__*/function (_React$Component) {
	    (0, _inherits2.default)(Trigger, _React$Component);
	
	    var _super = (0, _createSuper2.default)(Trigger);
	
	    // ensure `getContainer` will be called only once
	    function Trigger(props) {
	      var _this;
	
	      (0, _classCallCheck2.default)(this, Trigger);
	      _this = _super.call(this, props);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popupRef", /*#__PURE__*/React.createRef());
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "triggerRef", /*#__PURE__*/React.createRef());
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "portalContainer", void 0);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "attachId", void 0);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "clickOutsideHandler", void 0);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "touchOutsideHandler", void 0);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "contextMenuOutsideHandler1", void 0);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "contextMenuOutsideHandler2", void 0);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mouseDownTimeout", void 0);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focusTime", void 0);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "preClickTime", void 0);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "preTouchTime", void 0);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "delayTimer", void 0);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "hasPopupMouseDown", void 0);
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMouseEnter", function (e) {
	        var mouseEnterDelay = _this.props.mouseEnterDelay;
	
	        _this.fireEvents('onMouseEnter', e);
	
	        _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMouseMove", function (e) {
	        _this.fireEvents('onMouseMove', e);
	
	        _this.setPoint(e);
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMouseLeave", function (e) {
	        _this.fireEvents('onMouseLeave', e);
	
	        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPopupMouseEnter", function () {
	        _this.clearDelayTimer();
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPopupMouseLeave", function (e) {
	        var _this$popupRef$curren;
	
	        // https://github.com/react-component/trigger/pull/13
	        // react bug?
	        if (e.relatedTarget && !e.relatedTarget.setTimeout && (0, _contains.default)((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) {
	          return;
	        }
	
	        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFocus", function (e) {
	        _this.fireEvents('onFocus', e); // incase focusin and focusout
	
	
	        _this.clearDelayTimer();
	
	        if (_this.isFocusToShow()) {
	          _this.focusTime = Date.now();
	
	          _this.delaySetPopupVisible(true, _this.props.focusDelay);
	        }
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onMouseDown", function (e) {
	        _this.fireEvents('onMouseDown', e);
	
	        _this.preClickTime = Date.now();
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTouchStart", function (e) {
	        _this.fireEvents('onTouchStart', e);
	
	        _this.preTouchTime = Date.now();
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBlur", function (e) {
	        _this.fireEvents('onBlur', e);
	
	        _this.clearDelayTimer();
	
	        if (_this.isBlurToHide()) {
	          _this.delaySetPopupVisible(false, _this.props.blurDelay);
	        }
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onContextMenu", function (e) {
	        e.preventDefault();
	
	        _this.fireEvents('onContextMenu', e);
	
	        _this.setPopupVisible(true, e);
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onContextMenuClose", function () {
	        if (_this.isContextMenuToShow()) {
	          _this.close();
	        }
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClick", function (event) {
	        _this.fireEvents('onClick', event); // focus will trigger click
	
	
	        if (_this.focusTime) {
	          var preTime;
	
	          if (_this.preClickTime && _this.preTouchTime) {
	            preTime = Math.min(_this.preClickTime, _this.preTouchTime);
	          } else if (_this.preClickTime) {
	            preTime = _this.preClickTime;
	          } else if (_this.preTouchTime) {
	            preTime = _this.preTouchTime;
	          }
	
	          if (Math.abs(preTime - _this.focusTime) < 20) {
	            return;
	          }
	
	          _this.focusTime = 0;
	        }
	
	        _this.preClickTime = 0;
	        _this.preTouchTime = 0; // Only prevent default when all the action is click.
	        // https://github.com/ant-design/ant-design/issues/17043
	        // https://github.com/ant-design/ant-design/issues/17291
	
	        if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) {
	          event.preventDefault();
	        }
	
	        var nextVisible = !_this.state.popupVisible;
	
	        if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) {
	          _this.setPopupVisible(!_this.state.popupVisible, event);
	        }
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPopupMouseDown", function () {
	        _this.hasPopupMouseDown = true;
	        clearTimeout(_this.mouseDownTimeout);
	        _this.mouseDownTimeout = window.setTimeout(function () {
	          _this.hasPopupMouseDown = false;
	        }, 0);
	
	        if (_this.context) {
	          var _this$context;
	
	          (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
	        }
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDocumentClick", function (event) {
	        if (_this.props.mask && !_this.props.maskClosable) {
	          return;
	        }
	
	        var target = event.target;
	
	        var root = _this.getRootDomNode();
	
	        var popupNode = _this.getPopupDomNode();
	
	        if ( // mousedown on the target should also close popup when action is contextMenu.
	        // https://github.com/ant-design/ant-design/issues/29853
	        (!(0, _contains.default)(root, target) || _this.isContextMenuOnly()) && !(0, _contains.default)(popupNode, target) && !_this.hasPopupMouseDown) {
	          _this.close();
	        }
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRootDomNode", function () {
	        var getTriggerDOMNode = _this.props.getTriggerDOMNode;
	
	        if (getTriggerDOMNode) {
	          return getTriggerDOMNode(_this.triggerRef.current);
	        }
	
	        try {
	          var domNode = (0, _findDOMNode.default)(_this.triggerRef.current);
	
	          if (domNode) {
	            return domNode;
	          }
	        } catch (err) {// Do nothing
	        }
	
	        return _reactDom.default.findDOMNode((0, _assertThisInitialized2.default)(_this));
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPopupClassNameFromAlign", function (align) {
	        var className = [];
	        var _this$props = _this.props,
	            popupPlacement = _this$props.popupPlacement,
	            builtinPlacements = _this$props.builtinPlacements,
	            prefixCls = _this$props.prefixCls,
	            alignPoint = _this$props.alignPoint,
	            getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;
	
	        if (popupPlacement && builtinPlacements) {
	          className.push((0, _alignUtil.getAlignPopupClassName)(builtinPlacements, prefixCls, align, alignPoint));
	        }
	
	        if (getPopupClassNameFromAlign) {
	          className.push(getPopupClassNameFromAlign(align));
	        }
	
	        return className.join(' ');
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getComponent", function () {
	        var _this$props2 = _this.props,
	            prefixCls = _this$props2.prefixCls,
	            destroyPopupOnHide = _this$props2.destroyPopupOnHide,
	            popupClassName = _this$props2.popupClassName,
	            onPopupAlign = _this$props2.onPopupAlign,
	            popupMotion = _this$props2.popupMotion,
	            popupAnimation = _this$props2.popupAnimation,
	            popupTransitionName = _this$props2.popupTransitionName,
	            popupStyle = _this$props2.popupStyle,
	            mask = _this$props2.mask,
	            maskAnimation = _this$props2.maskAnimation,
	            maskTransitionName = _this$props2.maskTransitionName,
	            maskMotion = _this$props2.maskMotion,
	            zIndex = _this$props2.zIndex,
	            popup = _this$props2.popup,
	            stretch = _this$props2.stretch,
	            alignPoint = _this$props2.alignPoint,
	            mobile = _this$props2.mobile,
	            forceRender = _this$props2.forceRender,
	            onPopupClick = _this$props2.onPopupClick;
	        var _this$state = _this.state,
	            popupVisible = _this$state.popupVisible,
	            point = _this$state.point;
	
	        var align = _this.getPopupAlign();
	
	        var mouseProps = {};
	
	        if (_this.isMouseEnterToShow()) {
	          mouseProps.onMouseEnter = _this.onPopupMouseEnter;
	        }
	
	        if (_this.isMouseLeaveToHide()) {
	          mouseProps.onMouseLeave = _this.onPopupMouseLeave;
	        }
	
	        mouseProps.onMouseDown = _this.onPopupMouseDown;
	        mouseProps.onTouchStart = _this.onPopupMouseDown;
	        return /*#__PURE__*/React.createElement(_Popup.default, (0, _extends2.default)({
	          prefixCls: prefixCls,
	          destroyPopupOnHide: destroyPopupOnHide,
	          visible: popupVisible,
	          point: alignPoint && point,
	          className: popupClassName,
	          align: align,
	          onAlign: onPopupAlign,
	          animation: popupAnimation,
	          getClassNameFromAlign: _this.getPopupClassNameFromAlign
	        }, mouseProps, {
	          stretch: stretch,
	          getRootDomNode: _this.getRootDomNode,
	          style: popupStyle,
	          mask: mask,
	          zIndex: zIndex,
	          transitionName: popupTransitionName,
	          maskAnimation: maskAnimation,
	          maskTransitionName: maskTransitionName,
	          maskMotion: maskMotion,
	          ref: _this.popupRef,
	          motion: popupMotion,
	          mobile: mobile,
	          forceRender: forceRender,
	          onClick: onPopupClick
	        }), typeof popup === 'function' ? popup() : popup);
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "attachParent", function (popupContainer) {
	        _raf.default.cancel(_this.attachId);
	
	        var _this$props3 = _this.props,
	            getPopupContainer = _this$props3.getPopupContainer,
	            getDocument = _this$props3.getDocument;
	
	        var domNode = _this.getRootDomNode();
	
	        var mountNode;
	
	        if (!getPopupContainer) {
	          mountNode = getDocument(_this.getRootDomNode()).body;
	        } else if (domNode || getPopupContainer.length === 0) {
	          // Compatible for legacy getPopupContainer with domNode argument.
	          // If no need `domNode` argument, will call directly.
	          // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
	          mountNode = getPopupContainer(domNode);
	        }
	
	        if (mountNode) {
	          mountNode.appendChild(popupContainer);
	        } else {
	          // Retry after frame render in case parent not ready
	          _this.attachId = (0, _raf.default)(function () {
	            _this.attachParent(popupContainer);
	          });
	        }
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getContainer", function () {
	        if (!_this.portalContainer) {
	          // In React.StrictMode component will call render multiple time in first mount.
	          // When you want to refactor with FC, useRef will also init multiple time and
	          // point to different useRef instance which will create multiple element
	          // (This multiple render will not trigger effect so you can not clean up this
	          // in effect). But this is safe with class component since it always point to same class instance.
	          var getDocument = _this.props.getDocument;
	          var popupContainer = getDocument(_this.getRootDomNode()).createElement('div'); // Make sure default popup container will never cause scrollbar appearing
	          // https://github.com/react-component/trigger/issues/41
	
	          popupContainer.style.position = 'absolute';
	          popupContainer.style.top = '0';
	          popupContainer.style.left = '0';
	          popupContainer.style.width = '100%';
	          _this.portalContainer = popupContainer;
	        }
	
	        _this.attachParent(_this.portalContainer);
	
	        return _this.portalContainer;
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setPoint", function (point) {
	        var alignPoint = _this.props.alignPoint;
	        if (!alignPoint || !point) return;
	
	        _this.setState({
	          point: {
	            pageX: point.pageX,
	            pageY: point.pageY
	          }
	        });
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handlePortalUpdate", function () {
	        if (_this.state.prevPopupVisible !== _this.state.popupVisible) {
	          _this.props.afterPopupVisibleChange(_this.state.popupVisible);
	        }
	      });
	      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "triggerContextValue", {
	        onPopupMouseDown: _this.onPopupMouseDown
	      });
	
	      var _popupVisible;
	
	      if ('popupVisible' in props) {
	        _popupVisible = !!props.popupVisible;
	      } else {
	        _popupVisible = !!props.defaultPopupVisible;
	      }
	
	      _this.state = {
	        prevPopupVisible: _popupVisible,
	        popupVisible: _popupVisible
	      };
	      ALL_HANDLERS.forEach(function (h) {
	        _this["fire".concat(h)] = function (e) {
	          _this.fireEvents(h, e);
	        };
	      });
	      return _this;
	    }
	
	    (0, _createClass2.default)(Trigger, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.componentDidUpdate();
	      }
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate() {
	        var props = this.props;
	        var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
	        // https://github.com/ant-design/ant-design/issues/5804
	        // https://github.com/react-component/calendar/issues/250
	        // https://github.com/react-component/trigger/issues/50
	
	        if (state.popupVisible) {
	          var currentDocument;
	
	          if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
	            currentDocument = props.getDocument(this.getRootDomNode());
	            this.clickOutsideHandler = (0, _addEventListener.default)(currentDocument, 'mousedown', this.onDocumentClick);
	          } // always hide on mobile
	
	
	          if (!this.touchOutsideHandler) {
	            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
	            this.touchOutsideHandler = (0, _addEventListener.default)(currentDocument, 'touchstart', this.onDocumentClick);
	          } // close popup when trigger type contains 'onContextMenu' and document is scrolling.
	
	
	          if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
	            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
	            this.contextMenuOutsideHandler1 = (0, _addEventListener.default)(currentDocument, 'scroll', this.onContextMenuClose);
	          } // close popup when trigger type contains 'onContextMenu' and window is blur.
	
	
	          if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
	            this.contextMenuOutsideHandler2 = (0, _addEventListener.default)(window, 'blur', this.onContextMenuClose);
	          }
	
	          return;
	        }
	
	        this.clearOutsideHandler();
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        this.clearDelayTimer();
	        this.clearOutsideHandler();
	        clearTimeout(this.mouseDownTimeout);
	
	        _raf.default.cancel(this.attachId);
	      }
	    }, {
	      key: "getPopupDomNode",
	      value: function getPopupDomNode() {
	        var _this$popupRef$curren2;
	
	        // for test
	        return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
	      }
	    }, {
	      key: "getPopupAlign",
	      value: function getPopupAlign() {
	        var props = this.props;
	        var popupPlacement = props.popupPlacement,
	            popupAlign = props.popupAlign,
	            builtinPlacements = props.builtinPlacements;
	
	        if (popupPlacement && builtinPlacements) {
	          return (0, _alignUtil.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	        }
	
	        return popupAlign;
	      }
	    }, {
	      key: "setPopupVisible",
	      value:
	      /**
	       * @param popupVisible    Show or not the popup element
	       * @param event           SyntheticEvent, used for `pointAlign`
	       */
	      function setPopupVisible(popupVisible, event) {
	        var alignPoint = this.props.alignPoint;
	        var prevPopupVisible = this.state.popupVisible;
	        this.clearDelayTimer();
	
	        if (prevPopupVisible !== popupVisible) {
	          if (!('popupVisible' in this.props)) {
	            this.setState({
	              popupVisible: popupVisible,
	              prevPopupVisible: prevPopupVisible
	            });
	          }
	
	          this.props.onPopupVisibleChange(popupVisible);
	        } // Always record the point position since mouseEnterDelay will delay the show
	
	
	        if (alignPoint && event && popupVisible) {
	          this.setPoint(event);
	        }
	      }
	    }, {
	      key: "delaySetPopupVisible",
	      value: function delaySetPopupVisible(visible, delayS, event) {
	        var _this2 = this;
	
	        var delay = delayS * 1000;
	        this.clearDelayTimer();
	
	        if (delay) {
	          var point = event ? {
	            pageX: event.pageX,
	            pageY: event.pageY
	          } : null;
	          this.delayTimer = window.setTimeout(function () {
	            _this2.setPopupVisible(visible, point);
	
	            _this2.clearDelayTimer();
	          }, delay);
	        } else {
	          this.setPopupVisible(visible, event);
	        }
	      }
	    }, {
	      key: "clearDelayTimer",
	      value: function clearDelayTimer() {
	        if (this.delayTimer) {
	          clearTimeout(this.delayTimer);
	          this.delayTimer = null;
	        }
	      }
	    }, {
	      key: "clearOutsideHandler",
	      value: function clearOutsideHandler() {
	        if (this.clickOutsideHandler) {
	          this.clickOutsideHandler.remove();
	          this.clickOutsideHandler = null;
	        }
	
	        if (this.contextMenuOutsideHandler1) {
	          this.contextMenuOutsideHandler1.remove();
	          this.contextMenuOutsideHandler1 = null;
	        }
	
	        if (this.contextMenuOutsideHandler2) {
	          this.contextMenuOutsideHandler2.remove();
	          this.contextMenuOutsideHandler2 = null;
	        }
	
	        if (this.touchOutsideHandler) {
	          this.touchOutsideHandler.remove();
	          this.touchOutsideHandler = null;
	        }
	      }
	    }, {
	      key: "createTwoChains",
	      value: function createTwoChains(event) {
	        var childPros = this.props.children.props;
	        var props = this.props;
	
	        if (childPros[event] && props[event]) {
	          return this["fire".concat(event)];
	        }
	
	        return childPros[event] || props[event];
	      }
	    }, {
	      key: "isClickToShow",
	      value: function isClickToShow() {
	        var _this$props4 = this.props,
	            action = _this$props4.action,
	            showAction = _this$props4.showAction;
	        return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	      }
	    }, {
	      key: "isContextMenuOnly",
	      value: function isContextMenuOnly() {
	        var action = this.props.action;
	        return action === 'contextMenu' || action.length === 1 && action[0] === 'contextMenu';
	      }
	    }, {
	      key: "isContextMenuToShow",
	      value: function isContextMenuToShow() {
	        var _this$props5 = this.props,
	            action = _this$props5.action,
	            showAction = _this$props5.showAction;
	        return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
	      }
	    }, {
	      key: "isClickToHide",
	      value: function isClickToHide() {
	        var _this$props6 = this.props,
	            action = _this$props6.action,
	            hideAction = _this$props6.hideAction;
	        return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	      }
	    }, {
	      key: "isMouseEnterToShow",
	      value: function isMouseEnterToShow() {
	        var _this$props7 = this.props,
	            action = _this$props7.action,
	            showAction = _this$props7.showAction;
	        return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	      }
	    }, {
	      key: "isMouseLeaveToHide",
	      value: function isMouseLeaveToHide() {
	        var _this$props8 = this.props,
	            action = _this$props8.action,
	            hideAction = _this$props8.hideAction;
	        return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	      }
	    }, {
	      key: "isFocusToShow",
	      value: function isFocusToShow() {
	        var _this$props9 = this.props,
	            action = _this$props9.action,
	            showAction = _this$props9.showAction;
	        return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	      }
	    }, {
	      key: "isBlurToHide",
	      value: function isBlurToHide() {
	        var _this$props10 = this.props,
	            action = _this$props10.action,
	            hideAction = _this$props10.hideAction;
	        return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	      }
	    }, {
	      key: "forcePopupAlign",
	      value: function forcePopupAlign() {
	        if (this.state.popupVisible) {
	          var _this$popupRef$curren3;
	
	          (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 ? void 0 : _this$popupRef$curren3.forceAlign();
	        }
	      }
	    }, {
	      key: "fireEvents",
	      value: function fireEvents(type, e) {
	        var childCallback = this.props.children.props[type];
	
	        if (childCallback) {
	          childCallback(e);
	        }
	
	        var callback = this.props[type];
	
	        if (callback) {
	          callback(e);
	        }
	      }
	    }, {
	      key: "close",
	      value: function close() {
	        this.setPopupVisible(false);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var popupVisible = this.state.popupVisible;
	        var _this$props11 = this.props,
	            children = _this$props11.children,
	            forceRender = _this$props11.forceRender,
	            alignPoint = _this$props11.alignPoint,
	            className = _this$props11.className,
	            autoDestroy = _this$props11.autoDestroy;
	        var child = React.Children.only(children);
	        var newChildProps = {
	          key: 'trigger'
	        }; // ============================== Visible Handlers ==============================
	        // >>> ContextMenu
	
	        if (this.isContextMenuToShow()) {
	          newChildProps.onContextMenu = this.onContextMenu;
	        } else {
	          newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
	        } // >>> Click
	
	
	        if (this.isClickToHide() || this.isClickToShow()) {
	          newChildProps.onClick = this.onClick;
	          newChildProps.onMouseDown = this.onMouseDown;
	          newChildProps.onTouchStart = this.onTouchStart;
	        } else {
	          newChildProps.onClick = this.createTwoChains('onClick');
	          newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	          newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	        } // >>> Hover(enter)
	
	
	        if (this.isMouseEnterToShow()) {
	          newChildProps.onMouseEnter = this.onMouseEnter; // Point align
	
	          if (alignPoint) {
	            newChildProps.onMouseMove = this.onMouseMove;
	          }
	        } else {
	          newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	        } // >>> Hover(leave)
	
	
	        if (this.isMouseLeaveToHide()) {
	          newChildProps.onMouseLeave = this.onMouseLeave;
	        } else {
	          newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	        } // >>> Focus
	
	
	        if (this.isFocusToShow() || this.isBlurToHide()) {
	          newChildProps.onFocus = this.onFocus;
	          newChildProps.onBlur = this.onBlur;
	        } else {
	          newChildProps.onFocus = this.createTwoChains('onFocus');
	          newChildProps.onBlur = this.createTwoChains('onBlur');
	        } // =================================== Render ===================================
	
	
	        var childrenClassName = (0, _classnames.default)(child && child.props && child.props.className, className);
	
	        if (childrenClassName) {
	          newChildProps.className = childrenClassName;
	        }
	
	        var cloneProps = (0, _objectSpread2.default)({}, newChildProps);
	
	        if ((0, _ref2.supportRef)(child)) {
	          cloneProps.ref = (0, _ref2.composeRef)(this.triggerRef, child.ref);
	        }
	
	        var trigger = /*#__PURE__*/React.cloneElement(child, cloneProps);
	        var portal; // prevent unmounting after it's rendered
	
	        if (popupVisible || this.popupRef.current || forceRender) {
	          portal = /*#__PURE__*/React.createElement(PortalComponent, {
	            key: "portal",
	            getContainer: this.getContainer,
	            didUpdate: this.handlePortalUpdate
	          }, this.getComponent());
	        }
	
	        if (!popupVisible && autoDestroy) {
	          portal = null;
	        }
	
	        return /*#__PURE__*/React.createElement(_context.default.Provider, {
	          value: this.triggerContextValue
	        }, trigger, portal);
	      }
	    }], [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(_ref, prevState) {
	        var popupVisible = _ref.popupVisible;
	        var newState = {};
	
	        if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
	          newState.popupVisible = popupVisible;
	          newState.prevPopupVisible = prevState.popupVisible;
	        }
	
	        return newState;
	      }
	    }]);
	    return Trigger;
	  }(React.Component);
	
	  (0, _defineProperty2.default)(Trigger, "contextType", _context.default);
	  (0, _defineProperty2.default)(Trigger, "defaultProps", {
	    prefixCls: 'rc-trigger-popup',
	    getPopupClassNameFromAlign: returnEmptyString,
	    getDocument: returnDocument,
	    onPopupVisibleChange: noop,
	    afterPopupVisibleChange: noop,
	    onPopupAlign: noop,
	    popupClassName: '',
	    mouseEnterDelay: 0,
	    mouseLeaveDelay: 0.1,
	    focusDelay: 0,
	    blurDelay: 0.15,
	    popupStyle: {},
	    destroyPopupOnHide: false,
	    popupAlign: {},
	    defaultPopupVisible: false,
	    mask: false,
	    maskClosable: true,
	    action: [],
	    showAction: [],
	    hideAction: [],
	    autoDestroy: false
	  });
	  return Trigger;
	}
	
	var _default = generateTrigger(_Portal.default);
	
	exports.default = _default;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getAlignPopupClassName = getAlignPopupClassName;
	
	var _objectSpread2 = _interopRequireDefault(__webpack_require__(34));
	
	function isPointsEq(a1, a2, isAlignPoint) {
	  if (isAlignPoint) {
	    return a1[0] === a2[0];
	  }
	
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, baseAlign), align);
	}
	
	function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
	  var points = align.points;
	  var placements = Object.keys(builtinPlacements);
	
	  for (var i = 0; i < placements.length; i += 1) {
	    var placement = placements[i];
	
	    if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
	      return "".concat(prefixCls, "-placement-").concat(placement);
	    }
	  }
	
	  return '';
	}

/***/ },
/* 1127 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = exports.default = function _default(element) {
	  if (!element) {
	    return false;
	  }
	  if (element instanceof Element) {
	    if (element.offsetParent) {
	      return true;
	    }
	    if (element.getBBox) {
	      var _getBBox = element.getBBox(),
	        width = _getBBox.width,
	        height = _getBBox.height;
	      if (width || height) {
	        return true;
	      }
	    }
	    if (element.getBoundingClientRect) {
	      var _element$getBoundingC = element.getBoundingClientRect(),
	        _width = _element$getBoundingC.width,
	        _height = _element$getBoundingC.height;
	      if (_width || _height) {
	        return true;
	      }
	    }
	  }
	  return false;
	};

/***/ },
/* 1128 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	/**
	 * @ignore
	 * some key-codes definition and utils from closure-library
	 * @author yiminghe@gmail.com
	 */
	
	var KeyCode = {
	  /**
	   * MAC_ENTER
	   */
	  MAC_ENTER: 3,
	  /**
	   * BACKSPACE
	   */
	  BACKSPACE: 8,
	  /**
	   * TAB
	   */
	  TAB: 9,
	  /**
	   * NUMLOCK on FF/Safari Mac
	   */
	  NUM_CENTER: 12,
	  // NUMLOCK on FF/Safari Mac
	  /**
	   * ENTER
	   */
	  ENTER: 13,
	  /**
	   * SHIFT
	   */
	  SHIFT: 16,
	  /**
	   * CTRL
	   */
	  CTRL: 17,
	  /**
	   * ALT
	   */
	  ALT: 18,
	  /**
	   * PAUSE
	   */
	  PAUSE: 19,
	  /**
	   * CAPS_LOCK
	   */
	  CAPS_LOCK: 20,
	  /**
	   * ESC
	   */
	  ESC: 27,
	  /**
	   * SPACE
	   */
	  SPACE: 32,
	  /**
	   * PAGE_UP
	   */
	  PAGE_UP: 33,
	  // also NUM_NORTH_EAST
	  /**
	   * PAGE_DOWN
	   */
	  PAGE_DOWN: 34,
	  // also NUM_SOUTH_EAST
	  /**
	   * END
	   */
	  END: 35,
	  // also NUM_SOUTH_WEST
	  /**
	   * HOME
	   */
	  HOME: 36,
	  // also NUM_NORTH_WEST
	  /**
	   * LEFT
	   */
	  LEFT: 37,
	  // also NUM_WEST
	  /**
	   * UP
	   */
	  UP: 38,
	  // also NUM_NORTH
	  /**
	   * RIGHT
	   */
	  RIGHT: 39,
	  // also NUM_EAST
	  /**
	   * DOWN
	   */
	  DOWN: 40,
	  // also NUM_SOUTH
	  /**
	   * PRINT_SCREEN
	   */
	  PRINT_SCREEN: 44,
	  /**
	   * INSERT
	   */
	  INSERT: 45,
	  // also NUM_INSERT
	  /**
	   * DELETE
	   */
	  DELETE: 46,
	  // also NUM_DELETE
	  /**
	   * ZERO
	   */
	  ZERO: 48,
	  /**
	   * ONE
	   */
	  ONE: 49,
	  /**
	   * TWO
	   */
	  TWO: 50,
	  /**
	   * THREE
	   */
	  THREE: 51,
	  /**
	   * FOUR
	   */
	  FOUR: 52,
	  /**
	   * FIVE
	   */
	  FIVE: 53,
	  /**
	   * SIX
	   */
	  SIX: 54,
	  /**
	   * SEVEN
	   */
	  SEVEN: 55,
	  /**
	   * EIGHT
	   */
	  EIGHT: 56,
	  /**
	   * NINE
	   */
	  NINE: 57,
	  /**
	   * QUESTION_MARK
	   */
	  QUESTION_MARK: 63,
	  // needs localization
	  /**
	   * A
	   */
	  A: 65,
	  /**
	   * B
	   */
	  B: 66,
	  /**
	   * C
	   */
	  C: 67,
	  /**
	   * D
	   */
	  D: 68,
	  /**
	   * E
	   */
	  E: 69,
	  /**
	   * F
	   */
	  F: 70,
	  /**
	   * G
	   */
	  G: 71,
	  /**
	   * H
	   */
	  H: 72,
	  /**
	   * I
	   */
	  I: 73,
	  /**
	   * J
	   */
	  J: 74,
	  /**
	   * K
	   */
	  K: 75,
	  /**
	   * L
	   */
	  L: 76,
	  /**
	   * M
	   */
	  M: 77,
	  /**
	   * N
	   */
	  N: 78,
	  /**
	   * O
	   */
	  O: 79,
	  /**
	   * P
	   */
	  P: 80,
	  /**
	   * Q
	   */
	  Q: 81,
	  /**
	   * R
	   */
	  R: 82,
	  /**
	   * S
	   */
	  S: 83,
	  /**
	   * T
	   */
	  T: 84,
	  /**
	   * U
	   */
	  U: 85,
	  /**
	   * V
	   */
	  V: 86,
	  /**
	   * W
	   */
	  W: 87,
	  /**
	   * X
	   */
	  X: 88,
	  /**
	   * Y
	   */
	  Y: 89,
	  /**
	   * Z
	   */
	  Z: 90,
	  /**
	   * META
	   */
	  META: 91,
	  // WIN_KEY_LEFT
	  /**
	   * WIN_KEY_RIGHT
	   */
	  WIN_KEY_RIGHT: 92,
	  /**
	   * CONTEXT_MENU
	   */
	  CONTEXT_MENU: 93,
	  /**
	   * NUM_ZERO
	   */
	  NUM_ZERO: 96,
	  /**
	   * NUM_ONE
	   */
	  NUM_ONE: 97,
	  /**
	   * NUM_TWO
	   */
	  NUM_TWO: 98,
	  /**
	   * NUM_THREE
	   */
	  NUM_THREE: 99,
	  /**
	   * NUM_FOUR
	   */
	  NUM_FOUR: 100,
	  /**
	   * NUM_FIVE
	   */
	  NUM_FIVE: 101,
	  /**
	   * NUM_SIX
	   */
	  NUM_SIX: 102,
	  /**
	   * NUM_SEVEN
	   */
	  NUM_SEVEN: 103,
	  /**
	   * NUM_EIGHT
	   */
	  NUM_EIGHT: 104,
	  /**
	   * NUM_NINE
	   */
	  NUM_NINE: 105,
	  /**
	   * NUM_MULTIPLY
	   */
	  NUM_MULTIPLY: 106,
	  /**
	   * NUM_PLUS
	   */
	  NUM_PLUS: 107,
	  /**
	   * NUM_MINUS
	   */
	  NUM_MINUS: 109,
	  /**
	   * NUM_PERIOD
	   */
	  NUM_PERIOD: 110,
	  /**
	   * NUM_DIVISION
	   */
	  NUM_DIVISION: 111,
	  /**
	   * F1
	   */
	  F1: 112,
	  /**
	   * F2
	   */
	  F2: 113,
	  /**
	   * F3
	   */
	  F3: 114,
	  /**
	   * F4
	   */
	  F4: 115,
	  /**
	   * F5
	   */
	  F5: 116,
	  /**
	   * F6
	   */
	  F6: 117,
	  /**
	   * F7
	   */
	  F7: 118,
	  /**
	   * F8
	   */
	  F8: 119,
	  /**
	   * F9
	   */
	  F9: 120,
	  /**
	   * F10
	   */
	  F10: 121,
	  /**
	   * F11
	   */
	  F11: 122,
	  /**
	   * F12
	   */
	  F12: 123,
	  /**
	   * NUMLOCK
	   */
	  NUMLOCK: 144,
	  /**
	   * SEMICOLON
	   */
	  SEMICOLON: 186,
	  // needs localization
	  /**
	   * DASH
	   */
	  DASH: 189,
	  // needs localization
	  /**
	   * EQUALS
	   */
	  EQUALS: 187,
	  // needs localization
	  /**
	   * COMMA
	   */
	  COMMA: 188,
	  // needs localization
	  /**
	   * PERIOD
	   */
	  PERIOD: 190,
	  // needs localization
	  /**
	   * SLASH
	   */
	  SLASH: 191,
	  // needs localization
	  /**
	   * APOSTROPHE
	   */
	  APOSTROPHE: 192,
	  // needs localization
	  /**
	   * SINGLE_QUOTE
	   */
	  SINGLE_QUOTE: 222,
	  // needs localization
	  /**
	   * OPEN_SQUARE_BRACKET
	   */
	  OPEN_SQUARE_BRACKET: 219,
	  // needs localization
	  /**
	   * BACKSLASH
	   */
	  BACKSLASH: 220,
	  // needs localization
	  /**
	   * CLOSE_SQUARE_BRACKET
	   */
	  CLOSE_SQUARE_BRACKET: 221,
	  // needs localization
	  /**
	   * WIN_KEY
	   */
	  WIN_KEY: 224,
	  /**
	   * MAC_FF_META
	   */
	  MAC_FF_META: 224,
	  // Firefox (Gecko) fires this for the meta key instead of 91
	  /**
	   * WIN_IME
	   */
	  WIN_IME: 229,
	  // ======================== Function ========================
	  /**
	   * whether text and modified key is entered at the same time.
	   */
	  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
	    var keyCode = e.keyCode;
	    if (e.altKey && !e.ctrlKey || e.metaKey ||
	    // Function keys don't generate text
	    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
	      return false;
	    }
	
	    // The following keys are quite harmless, even in combination with
	    // CTRL, ALT or SHIFT.
	    switch (keyCode) {
	      case KeyCode.ALT:
	      case KeyCode.CAPS_LOCK:
	      case KeyCode.CONTEXT_MENU:
	      case KeyCode.CTRL:
	      case KeyCode.DOWN:
	      case KeyCode.END:
	      case KeyCode.ESC:
	      case KeyCode.HOME:
	      case KeyCode.INSERT:
	      case KeyCode.LEFT:
	      case KeyCode.MAC_FF_META:
	      case KeyCode.META:
	      case KeyCode.NUMLOCK:
	      case KeyCode.NUM_CENTER:
	      case KeyCode.PAGE_DOWN:
	      case KeyCode.PAGE_UP:
	      case KeyCode.PAUSE:
	      case KeyCode.PRINT_SCREEN:
	      case KeyCode.RIGHT:
	      case KeyCode.SHIFT:
	      case KeyCode.UP:
	      case KeyCode.WIN_KEY:
	      case KeyCode.WIN_KEY_RIGHT:
	        return false;
	      default:
	        return true;
	    }
	  },
	  /**
	   * whether character is entered.
	   */
	  isCharacterKey: function isCharacterKey(keyCode) {
	    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
	      return true;
	    }
	    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
	      return true;
	    }
	    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
	      return true;
	    }
	
	    // Safari sends zero key code for non-latin characters.
	    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
	      return true;
	    }
	    switch (keyCode) {
	      case KeyCode.SPACE:
	      case KeyCode.QUESTION_MARK:
	      case KeyCode.NUM_PLUS:
	      case KeyCode.NUM_MINUS:
	      case KeyCode.NUM_PERIOD:
	      case KeyCode.NUM_DIVISION:
	      case KeyCode.SEMICOLON:
	      case KeyCode.DASH:
	      case KeyCode.EQUALS:
	      case KeyCode.COMMA:
	      case KeyCode.PERIOD:
	      case KeyCode.SLASH:
	      case KeyCode.APOSTROPHE:
	      case KeyCode.SINGLE_QUOTE:
	      case KeyCode.OPEN_SQUARE_BRACKET:
	      case KeyCode.BACKSLASH:
	      case KeyCode.CLOSE_SQUARE_BRACKET:
	        return true;
	      default:
	        return false;
	    }
	  }
	};
	var _default = exports.default = KeyCode;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _react = __webpack_require__(2);
	var _reactDom = _interopRequireDefault(__webpack_require__(37));
	var _canUseDom = _interopRequireDefault(__webpack_require__(122));
	var Portal = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
	  var didUpdate = props.didUpdate,
	    getContainer = props.getContainer,
	    children = props.children;
	  var parentRef = (0, _react.useRef)();
	  var containerRef = (0, _react.useRef)();
	
	  // Ref return nothing, only for wrapper check exist
	  (0, _react.useImperativeHandle)(ref, function () {
	    return {};
	  });
	
	  // Create container in client side with sync to avoid useEffect not get ref
	  var initRef = (0, _react.useRef)(false);
	  if (!initRef.current && (0, _canUseDom.default)()) {
	    containerRef.current = getContainer();
	    parentRef.current = containerRef.current.parentNode;
	    initRef.current = true;
	  }
	
	  // [Legacy] Used by `rc-trigger`
	  (0, _react.useEffect)(function () {
	    didUpdate === null || didUpdate === void 0 || didUpdate(props);
	  });
	  (0, _react.useEffect)(function () {
	    // Restore container to original place
	    // React 18 StrictMode will unmount first and mount back for effect test:
	    // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
	    if (containerRef.current.parentNode === null && parentRef.current !== null) {
	      parentRef.current.appendChild(containerRef.current);
	    }
	    return function () {
	      var _containerRef$current;
	      // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
	      // Since some component use `Portal` directly, we have to keep the logic here.
	      (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current = _containerRef$current.parentNode) === null || _containerRef$current === void 0 || _containerRef$current.removeChild(containerRef.current);
	    };
	  }, []);
	  return containerRef.current ? /*#__PURE__*/_reactDom.default.createPortal(children, containerRef.current) : null;
	});
	var _default = exports.default = Portal;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useMemo;
	var React = _interopRequireWildcard(__webpack_require__(2));
	function useMemo(getValue, condition, shouldUpdate) {
	  var cacheRef = React.useRef({});
	  if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
	    cacheRef.current.value = getValue();
	    cacheRef.current.condition = condition;
	  }
	  return cacheRef.current.value;
	}

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _typeof2 = _interopRequireDefault(__webpack_require__(5));
	var _warning = _interopRequireDefault(__webpack_require__(125));
	/**
	 * Deeply compares two object literals.
	 * @param obj1 object 1
	 * @param obj2 object 2
	 * @param shallow shallow compare
	 * @returns
	 */
	function isEqual(obj1, obj2) {
	  var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
	  var refSet = new Set();
	  function deepEqual(a, b) {
	    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	    var circular = refSet.has(a);
	    (0, _warning.default)(!circular, 'Warning: There may be circular references');
	    if (circular) {
	      return false;
	    }
	    if (a === b) {
	      return true;
	    }
	    if (shallow && level > 1) {
	      return false;
	    }
	    refSet.add(a);
	    var newLevel = level + 1;
	    if (Array.isArray(a)) {
	      if (!Array.isArray(b) || a.length !== b.length) {
	        return false;
	      }
	      for (var i = 0; i < a.length; i++) {
	        if (!deepEqual(a[i], b[i], newLevel)) {
	          return false;
	        }
	      }
	      return true;
	    }
	    if (a && b && (0, _typeof2.default)(a) === 'object' && (0, _typeof2.default)(b) === 'object') {
	      var keys = Object.keys(a);
	      if (keys.length !== Object.keys(b).length) {
	        return false;
	      }
	      return keys.every(function (key) {
	        return deepEqual(a[key], b[key], newLevel);
	      });
	    }
	    // other
	    return false;
	  }
	  return deepEqual(obj1, obj2);
	}
	var _default = exports.default = isEqual;

/***/ },
/* 1132 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _default = exports.default = function _default() {
	  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
	    return false;
	  }
	  var agent = navigator.userAgent || navigator.vendor || window.opera;
	  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
	};

/***/ },
/* 1133 */
/***/ function(module, exports) {

	/**
	 * @license React
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
	function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}exports.ContextConsumer=h;exports.ContextProvider=g;exports.Element=b;exports.ForwardRef=l;exports.Fragment=d;exports.Lazy=q;exports.Memo=p;exports.Portal=c;exports.Profiler=f;exports.StrictMode=e;exports.Suspense=m;
	exports.SuspenseList=n;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return v(a)===h};exports.isContextProvider=function(a){return v(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return v(a)===l};exports.isFragment=function(a){return v(a)===d};exports.isLazy=function(a){return v(a)===q};exports.isMemo=function(a){return v(a)===p};
	exports.isPortal=function(a){return v(a)===c};exports.isProfiler=function(a){return v(a)===f};exports.isStrictMode=function(a){return v(a)===e};exports.isSuspense=function(a){return v(a)===m};exports.isSuspenseList=function(a){return v(a)===n};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};exports.typeOf=v;


/***/ },
/* 1134 */
[1298, 1133],
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _autolinker = __webpack_require__(820);
	
	var _autolinker2 = _interopRequireDefault(_autolinker);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1137);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var ReactAutolinker = (function (_React$Component) {
	  _inherits(ReactAutolinker, _React$Component);
	
	  function ReactAutolinker() {
	    _classCallCheck(this, ReactAutolinker);
	
	    _get(Object.getPrototypeOf(ReactAutolinker.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(ReactAutolinker, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props;
	      var options = _props.options;
	      var text = _props.text;
	      var renderLink = _props.renderLink;
	      var tagName = _props.tagName;
	
	      var tags = [];
	      _autolinker2["default"].link(text, _extends({}, options, {
	        replaceFn: function replaceFn(autolinker, match) {
	          var tag = autolinker.getTagBuilder().build(match);
	          tags.push(tag);
	          return tag;
	        }
	      }));
	
	      var _text = text;
	      var children = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var tag = _step.value;
	
	          var splitText = _text.includes(tag.attrs.href) ? tag.attrs.href : tag.innerHtml;
	          var parts = _text.split(splitText);
	          if (tag.attrs && tag.attrs["class"]) {
	            tag.attrs.className = tag.attrs["class"];
	            delete tag.attrs["class"];
	          }
	          tag.attrs.key = tag.attrs.href + "-" + tags.indexOf(tag);
	          children.push(parts.shift());
	          children.push(renderLink(tag));
	          _text = parts.join(tag.attrs.href);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator["return"]) {
	            _iterator["return"]();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      children.push(_text);
	
	      var props = _extends({}, this.props);
	      var _arr = ["text", "options", "renderLink", "tagName"];
	      for (var _i = 0; _i < _arr.length; _i++) {
	        var prop = _arr[_i];
	        delete props[prop];
	      }
	      return _react2["default"].createElement(tagName, props, children);
	    }
	  }], [{
	    key: "propTypes",
	    value: {
	      options: _propTypes2["default"].object,
	      renderLink: _propTypes2["default"].func,
	      tagName: _propTypes2["default"].string
	    },
	    enumerable: true
	  }, {
	    key: "defaultProps",
	    value: {
	      options: {},
	      renderLink: function renderLink(tag) {
	        return _react2["default"].createElement(tag.tagName, tag.attrs, tag.innerHtml);
	      },
	      tagName: 'div'
	    },
	    enumerable: true
	  }]);
	
	  return ReactAutolinker;
	})(_react2["default"].Component);
	
	exports["default"] = ReactAutolinker;
	module.exports = exports["default"];

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(176);
	var invariant = __webpack_require__(93);
	var ReactPropTypesSecret = __webpack_require__(1138);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1136)();
	}


/***/ },
/* 1138 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckboxGroup = exports.Checkbox = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Checkbox = exports.Checkbox = function (_Component) {
	  _inherits(Checkbox, _Component);
	
	  function Checkbox() {
	    _classCallCheck(this, Checkbox);
	
	    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	  }
	
	  _createClass(Checkbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!(this.context && this.context.checkboxGroup)) {
	        throw new Error('The `Checkbox` component must be used as a child of `CheckboxGroup`.');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$checkboxGrou = this.context.checkboxGroup,
	          name = _context$checkboxGrou.name,
	          checkedValues = _context$checkboxGrou.checkedValues,
	          onChange = _context$checkboxGrou.onChange;
	
	      var optional = {};
	      if (checkedValues) {
	        optional.checked = checkedValues.indexOf(this.props.value) >= 0;
	      }
	      if (typeof onChange === 'function') {
	        optional.onChange = onChange.bind(null, this.props.value);
	      }
	
	      return _react2.default.createElement('input', _extends({}, this.props, {
	        type: 'checkbox',
	        name: name,
	        disabled: this.props.disabled
	      }, optional));
	    }
	  }]);
	
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.contextTypes = {
	  checkboxGroup: _propTypes2.default.object.isRequired
	};
	
	var CheckboxGroup = exports.CheckboxGroup = function (_Component2) {
	  _inherits(CheckboxGroup, _Component2);
	
	  function CheckboxGroup(props) {
	    _classCallCheck(this, CheckboxGroup);
	
	    var _this2 = _possibleConstructorReturn(this, (CheckboxGroup.__proto__ || Object.getPrototypeOf(CheckboxGroup)).call(this, props));
	
	    _this2._isControlledComponent = _this2._isControlledComponent.bind(_this2);
	    _this2._onCheckboxChange = _this2._onCheckboxChange.bind(_this2);
	    _this2.getChildContext = _this2.getChildContext.bind(_this2);
	    _this2.getValue = _this2.getValue.bind(_this2);
	    _this2.state = {
	      value: _this2.props.value || _this2.props.defaultValue || []
	    };
	    return _this2;
	  }
	
	  _createClass(CheckboxGroup, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var checkboxGroup = {
	        name: this.props.name,
	        checkedValues: this.state.value,
	        onChange: this._onCheckboxChange
	      };
	      return { checkboxGroup: checkboxGroup };
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (newProps.value) {
	        this.setState({
	          value: newProps.value
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          Component = _props.Component,
	          name = _props.name,
	          value = _props.value,
	          onChange = _props.onChange,
	          children = _props.children,
	          rest = _objectWithoutProperties(_props, ['Component', 'name', 'value', 'onChange', 'children']);
	
	      return _react2.default.createElement(
	        Component,
	        rest,
	        children
	      );
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.state.value;
	    }
	  }, {
	    key: '_isControlledComponent',
	    value: function _isControlledComponent() {
	      return Boolean(this.props.value);
	    }
	  }, {
	    key: '_onCheckboxChange',
	    value: function _onCheckboxChange(checkboxValue, event) {
	      var newValue = void 0;
	      if (event.target.checked) {
	        newValue = this.state.value.concat(checkboxValue);
	      } else {
	        newValue = this.state.value.filter(function (v) {
	          return v !== checkboxValue;
	        });
	      }
	
	      if (this._isControlledComponent()) {
	        this.setState({ value: this.props.value });
	      } else {
	        this.setState({ value: newValue });
	      }
	
	      if (typeof this.props.onChange === 'function') {
	        this.props.onChange(newValue, event, this.props.name);
	      }
	    }
	  }]);
	
	  return CheckboxGroup;
	}(_react.Component);
	
	CheckboxGroup.childContextTypes = {
	  checkboxGroup: _propTypes2.default.object.isRequired
	};
	CheckboxGroup.propTypes = {
	  name: _propTypes2.default.string,
	  defaultValue: _propTypes2.default.array,
	  value: _propTypes2.default.array,
	  onChange: _propTypes2.default.func,
	  children: _propTypes2.default.node.isRequired,
	  Component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.object])
	};
	CheckboxGroup.defaultProps = {
	  Component: "div"
	};


/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license React
	 * react-dom-server-legacy.browser.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var aa=__webpack_require__(2);function l(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var p=Object.prototype.hasOwnProperty,fa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ha={},ia={};
	function ja(a){if(p.call(ia,a))return!0;if(p.call(ha,a))return!1;if(fa.test(a))return ia[a]=!0;ha[a]=!0;return!1}function r(a,b,c,d,f,e,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=e;this.removeEmptyString=g}var t={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){t[a]=new r(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];t[b]=new r(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){t[a]=new r(a,2,!1,a.toLowerCase(),null,!1,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){t[a]=new r(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){t[a]=new r(a,3,!1,a.toLowerCase(),null,!1,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){t[a]=new r(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){t[a]=new r(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){t[a]=new r(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){t[a]=new r(a,5,!1,a.toLowerCase(),null,!1,!1)});var ka=/[\-:]([a-z])/g;function la(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(ka,
	la);t[b]=new r(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(ka,la);t[b]=new r(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(ka,la);t[b]=new r(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){t[a]=new r(a,1,!1,a.toLowerCase(),null,!1,!1)});
	t.xlinkHref=new r("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){t[a]=new r(a,1,!1,a.toLowerCase(),null,!0,!0)});
	var u={animationIterationCount:!0,aspectRatio:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,
	fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},ma=["Webkit","ms","Moz","O"];Object.keys(u).forEach(function(a){ma.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);u[b]=u[a]})});var na=/["'&<>]/;
	function v(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=na.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}var oa=/([A-Z])/g,pa=/^ms-/,qa=Array.isArray;function w(a,b){return{insertionMode:a,selectedValue:b}}
	function ra(a,b,c){switch(b){case "select":return w(1,null!=c.value?c.value:c.defaultValue);case "svg":return w(2,null);case "math":return w(3,null);case "foreignObject":return w(1,null);case "table":return w(4,null);case "thead":case "tbody":case "tfoot":return w(5,null);case "colgroup":return w(7,null);case "tr":return w(6,null)}return 4<=a.insertionMode||0===a.insertionMode?w(1,null):a}var sa=new Map;
	function ta(a,b,c){if("object"!==typeof c)throw Error(l(62));b=!0;for(var d in c)if(p.call(c,d)){var f=c[d];if(null!=f&&"boolean"!==typeof f&&""!==f){if(0===d.indexOf("--")){var e=v(d);f=v((""+f).trim())}else{e=d;var g=sa.get(e);void 0!==g?e=g:(g=v(e.replace(oa,"-$1").toLowerCase().replace(pa,"-ms-")),sa.set(e,g),e=g);f="number"===typeof f?0===f||p.call(u,d)?""+f:f+"px":v((""+f).trim())}b?(b=!1,a.push(' style="',e,":",f)):a.push(";",e,":",f)}}b||a.push('"')}
	function x(a,b,c,d){switch(c){case "style":ta(a,b,d);return;case "defaultValue":case "defaultChecked":case "innerHTML":case "suppressContentEditableWarning":case "suppressHydrationWarning":return}if(!(2<c.length)||"o"!==c[0]&&"O"!==c[0]||"n"!==c[1]&&"N"!==c[1])if(b=t.hasOwnProperty(c)?t[c]:null,null!==b){switch(typeof d){case "function":case "symbol":return;case "boolean":if(!b.acceptsBooleans)return}c=b.attributeName;switch(b.type){case 3:d&&a.push(" ",c,'=""');break;case 4:!0===d?a.push(" ",c,'=""'):
	!1!==d&&a.push(" ",c,'="',v(d),'"');break;case 5:isNaN(d)||a.push(" ",c,'="',v(d),'"');break;case 6:!isNaN(d)&&1<=d&&a.push(" ",c,'="',v(d),'"');break;default:b.sanitizeURL&&(d=""+d),a.push(" ",c,'="',v(d),'"')}}else if(ja(c)){switch(typeof d){case "function":case "symbol":return;case "boolean":if(b=c.toLowerCase().slice(0,5),"data-"!==b&&"aria-"!==b)return}a.push(" ",c,'="',v(d),'"')}}
	function y(a,b,c){if(null!=b){if(null!=c)throw Error(l(60));if("object"!==typeof b||!("__html"in b))throw Error(l(61));b=b.__html;null!==b&&void 0!==b&&a.push(""+b)}}function ua(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
	function va(a,b,c,d){a.push(A(c));var f=c=null,e;for(e in b)if(p.call(b,e)){var g=b[e];if(null!=g)switch(e){case "children":c=g;break;case "dangerouslySetInnerHTML":f=g;break;default:x(a,d,e,g)}}a.push(">");y(a,f,c);return"string"===typeof c?(a.push(v(c)),null):c}var wa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,xa=new Map;function A(a){var b=xa.get(a);if(void 0===b){if(!wa.test(a))throw Error(l(65,a));b="<"+a;xa.set(a,b)}return b}
	function ya(a,b,c,d,f){switch(b){case "select":a.push(A("select"));var e=null,g=null;for(n in c)if(p.call(c,n)){var h=c[n];if(null!=h)switch(n){case "children":e=h;break;case "dangerouslySetInnerHTML":g=h;break;case "defaultValue":case "value":break;default:x(a,d,n,h)}}a.push(">");y(a,g,e);return e;case "option":g=f.selectedValue;a.push(A("option"));var k=h=null,m=null;var n=null;for(e in c)if(p.call(c,e)){var q=c[e];if(null!=q)switch(e){case "children":h=q;break;case "selected":m=q;break;case "dangerouslySetInnerHTML":n=
	q;break;case "value":k=q;default:x(a,d,e,q)}}if(null!=g)if(c=null!==k?""+k:ua(h),qa(g))for(d=0;d<g.length;d++){if(""+g[d]===c){a.push(' selected=""');break}}else""+g===c&&a.push(' selected=""');else m&&a.push(' selected=""');a.push(">");y(a,n,h);return h;case "textarea":a.push(A("textarea"));n=g=e=null;for(h in c)if(p.call(c,h)&&(k=c[h],null!=k))switch(h){case "children":n=k;break;case "value":e=k;break;case "defaultValue":g=k;break;case "dangerouslySetInnerHTML":throw Error(l(91));default:x(a,d,
	h,k)}null===e&&null!==g&&(e=g);a.push(">");if(null!=n){if(null!=e)throw Error(l(92));if(qa(n)&&1<n.length)throw Error(l(93));e=""+n}"string"===typeof e&&"\n"===e[0]&&a.push("\n");null!==e&&a.push(v(""+e));return null;case "input":a.push(A("input"));k=n=h=e=null;for(g in c)if(p.call(c,g)&&(m=c[g],null!=m))switch(g){case "children":case "dangerouslySetInnerHTML":throw Error(l(399,"input"));case "defaultChecked":k=m;break;case "defaultValue":h=m;break;case "checked":n=m;break;case "value":e=m;break;
	default:x(a,d,g,m)}null!==n?x(a,d,"checked",n):null!==k&&x(a,d,"checked",k);null!==e?x(a,d,"value",e):null!==h&&x(a,d,"value",h);a.push("/>");return null;case "menuitem":a.push(A("menuitem"));for(var C in c)if(p.call(c,C)&&(e=c[C],null!=e))switch(C){case "children":case "dangerouslySetInnerHTML":throw Error(l(400));default:x(a,d,C,e)}a.push(">");return null;case "title":a.push(A("title"));e=null;for(q in c)if(p.call(c,q)&&(g=c[q],null!=g))switch(q){case "children":e=g;break;case "dangerouslySetInnerHTML":throw Error(l(434));
	default:x(a,d,q,g)}a.push(">");return e;case "listing":case "pre":a.push(A(b));g=e=null;for(k in c)if(p.call(c,k)&&(h=c[k],null!=h))switch(k){case "children":e=h;break;case "dangerouslySetInnerHTML":g=h;break;default:x(a,d,k,h)}a.push(">");if(null!=g){if(null!=e)throw Error(l(60));if("object"!==typeof g||!("__html"in g))throw Error(l(61));c=g.__html;null!==c&&void 0!==c&&("string"===typeof c&&0<c.length&&"\n"===c[0]?a.push("\n",c):a.push(""+c))}"string"===typeof e&&"\n"===e[0]&&a.push("\n");return e;
	case "area":case "base":case "br":case "col":case "embed":case "hr":case "img":case "keygen":case "link":case "meta":case "param":case "source":case "track":case "wbr":a.push(A(b));for(var D in c)if(p.call(c,D)&&(e=c[D],null!=e))switch(D){case "children":case "dangerouslySetInnerHTML":throw Error(l(399,b));default:x(a,d,D,e)}a.push("/>");return null;case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return va(a,
	c,b,d);case "html":return 0===f.insertionMode&&a.push("<!DOCTYPE html>"),va(a,c,b,d);default:if(-1===b.indexOf("-")&&"string"!==typeof c.is)return va(a,c,b,d);a.push(A(b));g=e=null;for(m in c)if(p.call(c,m)&&(h=c[m],null!=h))switch(m){case "children":e=h;break;case "dangerouslySetInnerHTML":g=h;break;case "style":ta(a,d,h);break;case "suppressContentEditableWarning":case "suppressHydrationWarning":break;default:ja(m)&&"function"!==typeof h&&"symbol"!==typeof h&&a.push(" ",m,'="',v(h),'"')}a.push(">");
	y(a,g,e);return e}}function za(a,b,c){a.push('\x3c!--$?--\x3e<template id="');if(null===c)throw Error(l(395));a.push(c);return a.push('"></template>')}
	function Aa(a,b,c,d){switch(c.insertionMode){case 0:case 1:return a.push('<div hidden id="'),a.push(b.segmentPrefix),b=d.toString(16),a.push(b),a.push('">');case 2:return a.push('<svg aria-hidden="true" style="display:none" id="'),a.push(b.segmentPrefix),b=d.toString(16),a.push(b),a.push('">');case 3:return a.push('<math aria-hidden="true" style="display:none" id="'),a.push(b.segmentPrefix),b=d.toString(16),a.push(b),a.push('">');case 4:return a.push('<table hidden id="'),a.push(b.segmentPrefix),
	b=d.toString(16),a.push(b),a.push('">');case 5:return a.push('<table hidden><tbody id="'),a.push(b.segmentPrefix),b=d.toString(16),a.push(b),a.push('">');case 6:return a.push('<table hidden><tr id="'),a.push(b.segmentPrefix),b=d.toString(16),a.push(b),a.push('">');case 7:return a.push('<table hidden><colgroup id="'),a.push(b.segmentPrefix),b=d.toString(16),a.push(b),a.push('">');default:throw Error(l(397));}}
	function Ba(a,b){switch(b.insertionMode){case 0:case 1:return a.push("</div>");case 2:return a.push("</svg>");case 3:return a.push("</math>");case 4:return a.push("</table>");case 5:return a.push("</tbody></table>");case 6:return a.push("</tr></table>");case 7:return a.push("</colgroup></table>");default:throw Error(l(397));}}var Ca=/[<\u2028\u2029]/g;
	function Da(a){return JSON.stringify(a).replace(Ca,function(a){switch(a){case "<":return"\\u003c";case "\u2028":return"\\u2028";case "\u2029":return"\\u2029";default:throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");}})}
	function Ea(a,b){b=void 0===b?"":b;return{bootstrapChunks:[],startInlineScript:"<script>",placeholderPrefix:b+"P:",segmentPrefix:b+"S:",boundaryPrefix:b+"B:",idPrefix:b,nextSuspenseID:0,sentCompleteSegmentFunction:!1,sentCompleteBoundaryFunction:!1,sentClientRenderFunction:!1,generateStaticMarkup:a}}function Fa(a,b,c,d){if(c.generateStaticMarkup)return a.push(v(b)),!1;""===b?a=d:(d&&a.push("\x3c!-- --\x3e"),a.push(v(b)),a=!0);return a}
	var B=Object.assign,Ga=Symbol.for("react.element"),Ha=Symbol.for("react.portal"),Ia=Symbol.for("react.fragment"),Ja=Symbol.for("react.strict_mode"),Ka=Symbol.for("react.profiler"),La=Symbol.for("react.provider"),Ma=Symbol.for("react.context"),Na=Symbol.for("react.forward_ref"),Oa=Symbol.for("react.suspense"),Pa=Symbol.for("react.suspense_list"),Qa=Symbol.for("react.memo"),Ra=Symbol.for("react.lazy"),Sa=Symbol.for("react.scope"),Ta=Symbol.for("react.debug_trace_mode"),Ua=Symbol.for("react.legacy_hidden"),
	Va=Symbol.for("react.default_value"),Wa=Symbol.iterator;
	function Xa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Oa:return"Suspense";case Pa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return(a.displayName||"Context")+".Consumer";case La:return(a._context.displayName||"Context")+".Provider";case Na:var b=a.render;a=a.displayName;a||(a=b.displayName||
	b.name||"",a=""!==a?"ForwardRef("+a+")":"ForwardRef");return a;case Qa:return b=a.displayName||null,null!==b?b:Xa(a.type)||"Memo";case Ra:b=a._payload;a=a._init;try{return Xa(a(b))}catch(c){}}return null}var Ya={};function Za(a,b){a=a.contextTypes;if(!a)return Ya;var c={},d;for(d in a)c[d]=b[d];return c}var E=null;
	function F(a,b){if(a!==b){a.context._currentValue2=a.parentValue;a=a.parent;var c=b.parent;if(null===a){if(null!==c)throw Error(l(401));}else{if(null===c)throw Error(l(401));F(a,c)}b.context._currentValue2=b.value}}function $a(a){a.context._currentValue2=a.parentValue;a=a.parent;null!==a&&$a(a)}function ab(a){var b=a.parent;null!==b&&ab(b);a.context._currentValue2=a.value}
	function bb(a,b){a.context._currentValue2=a.parentValue;a=a.parent;if(null===a)throw Error(l(402));a.depth===b.depth?F(a,b):bb(a,b)}function cb(a,b){var c=b.parent;if(null===c)throw Error(l(402));a.depth===c.depth?F(a,c):cb(a,c);b.context._currentValue2=b.value}function G(a){var b=E;b!==a&&(null===b?ab(a):null===a?$a(b):b.depth===a.depth?F(b,a):b.depth>a.depth?bb(b,a):cb(b,a),E=a)}
	var db={isMounted:function(){return!1},enqueueSetState:function(a,b){a=a._reactInternals;null!==a.queue&&a.queue.push(b)},enqueueReplaceState:function(a,b){a=a._reactInternals;a.replace=!0;a.queue=[b]},enqueueForceUpdate:function(){}};
	function eb(a,b,c,d){var f=void 0!==a.state?a.state:null;a.updater=db;a.props=c;a.state=f;var e={queue:[],replace:!1};a._reactInternals=e;var g=b.contextType;a.context="object"===typeof g&&null!==g?g._currentValue2:d;g=b.getDerivedStateFromProps;"function"===typeof g&&(g=g(c,f),f=null===g||void 0===g?f:B({},f,g),a.state=f);if("function"!==typeof b.getDerivedStateFromProps&&"function"!==typeof a.getSnapshotBeforeUpdate&&("function"===typeof a.UNSAFE_componentWillMount||"function"===typeof a.componentWillMount))if(b=
	a.state,"function"===typeof a.componentWillMount&&a.componentWillMount(),"function"===typeof a.UNSAFE_componentWillMount&&a.UNSAFE_componentWillMount(),b!==a.state&&db.enqueueReplaceState(a,a.state,null),null!==e.queue&&0<e.queue.length)if(b=e.queue,g=e.replace,e.queue=null,e.replace=!1,g&&1===b.length)a.state=b[0];else{e=g?b[0]:a.state;f=!0;for(g=g?1:0;g<b.length;g++){var h=b[g];h="function"===typeof h?h.call(a,e,c,d):h;null!=h&&(f?(f=!1,e=B({},e,h)):B(e,h))}a.state=e}else e.queue=null}
	var fb={id:1,overflow:""};function gb(a,b,c){var d=a.id;a=a.overflow;var f=32-H(d)-1;d&=~(1<<f);c+=1;var e=32-H(b)+f;if(30<e){var g=f-f%5;e=(d&(1<<g)-1).toString(32);d>>=g;f-=g;return{id:1<<32-H(b)+f|c<<f|d,overflow:e+a}}return{id:1<<e|c<<f|d,overflow:a}}var H=Math.clz32?Math.clz32:hb,ib=Math.log,jb=Math.LN2;function hb(a){a>>>=0;return 0===a?32:31-(ib(a)/jb|0)|0}function kb(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
	var lb="function"===typeof Object.is?Object.is:kb,I=null,ob=null,J=null,K=null,L=!1,M=!1,N=0,O=null,P=0;function Q(){if(null===I)throw Error(l(321));return I}function pb(){if(0<P)throw Error(l(312));return{memoizedState:null,queue:null,next:null}}function qb(){null===K?null===J?(L=!1,J=K=pb()):(L=!0,K=J):null===K.next?(L=!1,K=K.next=pb()):(L=!0,K=K.next);return K}function rb(){ob=I=null;M=!1;J=null;P=0;K=O=null}function sb(a,b){return"function"===typeof b?b(a):b}
	function tb(a,b,c){I=Q();K=qb();if(L){var d=K.queue;b=d.dispatch;if(null!==O&&(c=O.get(d),void 0!==c)){O.delete(d);d=K.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);K.memoizedState=d;return[d,b]}return[K.memoizedState,b]}a=a===sb?"function"===typeof b?b():b:void 0!==c?c(b):b;K.memoizedState=a;a=K.queue={last:null,dispatch:null};a=a.dispatch=ub.bind(null,I,a);return[K.memoizedState,a]}
	function vb(a,b){I=Q();K=qb();b=void 0===b?null:b;if(null!==K){var c=K.memoizedState;if(null!==c&&null!==b){var d=c[1];a:if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!lb(b[f],d[f])){d=!1;break a}d=!0}if(d)return c[0]}}a=a();K.memoizedState=[a,b];return a}function ub(a,b,c){if(25<=P)throw Error(l(301));if(a===I)if(M=!0,a={action:c,next:null},null===O&&(O=new Map),c=O.get(b),void 0===c)O.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}function wb(){throw Error(l(394));}
	function R(){}
	var xb={readContext:function(a){return a._currentValue2},useContext:function(a){Q();return a._currentValue2},useMemo:vb,useReducer:tb,useRef:function(a){I=Q();K=qb();var b=K.memoizedState;return null===b?(a={current:a},K.memoizedState=a):b},useState:function(a){return tb(sb,a)},useInsertionEffect:R,useLayoutEffect:function(){},useCallback:function(a,b){return vb(function(){return a},b)},useImperativeHandle:R,useEffect:R,useDebugValue:R,useDeferredValue:function(a){Q();return a},useTransition:function(){Q();return[!1,
	wb]},useId:function(){var a=ob.treeContext;var b=a.overflow;a=a.id;a=(a&~(1<<32-H(a)-1)).toString(32)+b;var c=S;if(null===c)throw Error(l(404));b=N++;a=":"+c.idPrefix+"R"+a;0<b&&(a+="H"+b.toString(32));return a+":"},useMutableSource:function(a,b){Q();return b(a._source)},useSyncExternalStore:function(a,b,c){if(void 0===c)throw Error(l(407));return c()}},S=null,yb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;function zb(a){console.error(a);return null}
	function T(){}
	function Ab(a,b,c,d,f,e,g,h,k){var m=[],n=new Set;b={destination:null,responseState:b,progressiveChunkSize:void 0===d?12800:d,status:0,fatalError:null,nextSegmentId:0,allPendingTasks:0,pendingRootTasks:0,completedRootSegment:null,abortableTasks:n,pingedTasks:m,clientRenderedBoundaries:[],completedBoundaries:[],partialBoundaries:[],onError:void 0===f?zb:f,onAllReady:void 0===e?T:e,onShellReady:void 0===g?T:g,onShellError:void 0===h?T:h,onFatalError:void 0===k?T:k};c=U(b,0,null,c,!1,!1);c.parentFlushed=
	!0;a=Bb(b,a,null,c,n,Ya,null,fb);m.push(a);return b}function Bb(a,b,c,d,f,e,g,h){a.allPendingTasks++;null===c?a.pendingRootTasks++:c.pendingTasks++;var k={node:b,ping:function(){var b=a.pingedTasks;b.push(k);1===b.length&&Cb(a)},blockedBoundary:c,blockedSegment:d,abortSet:f,legacyContext:e,context:g,treeContext:h};f.add(k);return k}function U(a,b,c,d,f,e){return{status:0,id:-1,index:b,parentFlushed:!1,chunks:[],children:[],formatContext:d,boundary:c,lastPushedText:f,textEmbedded:e}}
	function V(a,b){a=a.onError(b);if(null!=a&&"string"!==typeof a)throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "'+typeof a+'" instead');return a}function W(a,b){var c=a.onShellError;c(b);c=a.onFatalError;c(b);null!==a.destination?(a.status=2,a.destination.destroy(b)):(a.status=1,a.fatalError=b)}
	function Db(a,b,c,d,f){I={};ob=b;N=0;for(a=c(d,f);M;)M=!1,N=0,P+=1,K=null,a=c(d,f);rb();return a}function Eb(a,b,c,d){var f=c.render(),e=d.childContextTypes;if(null!==e&&void 0!==e){var g=b.legacyContext;if("function"!==typeof c.getChildContext)d=g;else{c=c.getChildContext();for(var h in c)if(!(h in e))throw Error(l(108,Xa(d)||"Unknown",h));d=B({},g,c)}b.legacyContext=d;X(a,b,f);b.legacyContext=g}else X(a,b,f)}
	function Fb(a,b){if(a&&a.defaultProps){b=B({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}
	function Gb(a,b,c,d,f){if("function"===typeof c)if(c.prototype&&c.prototype.isReactComponent){f=Za(c,b.legacyContext);var e=c.contextType;e=new c(d,"object"===typeof e&&null!==e?e._currentValue2:f);eb(e,c,d,f);Eb(a,b,e,c)}else{e=Za(c,b.legacyContext);f=Db(a,b,c,d,e);var g=0!==N;if("object"===typeof f&&null!==f&&"function"===typeof f.render&&void 0===f.$$typeof)eb(f,c,d,e),Eb(a,b,f,c);else if(g){d=b.treeContext;b.treeContext=gb(d,1,0);try{X(a,b,f)}finally{b.treeContext=d}}else X(a,b,f)}else if("string"===
	typeof c){f=b.blockedSegment;e=ya(f.chunks,c,d,a.responseState,f.formatContext);f.lastPushedText=!1;g=f.formatContext;f.formatContext=ra(g,c,d);Hb(a,b,e);f.formatContext=g;switch(c){case "area":case "base":case "br":case "col":case "embed":case "hr":case "img":case "input":case "keygen":case "link":case "meta":case "param":case "source":case "track":case "wbr":break;default:f.chunks.push("</",c,">")}f.lastPushedText=!1}else{switch(c){case Ua:case Ta:case Ja:case Ka:case Ia:X(a,b,d.children);return;
	case Pa:X(a,b,d.children);return;case Sa:throw Error(l(343));case Oa:a:{c=b.blockedBoundary;f=b.blockedSegment;e=d.fallback;d=d.children;g=new Set;var h={id:null,rootSegmentID:-1,parentFlushed:!1,pendingTasks:0,forceClientRender:!1,completedSegments:[],byteSize:0,fallbackAbortableTasks:g,errorDigest:null},k=U(a,f.chunks.length,h,f.formatContext,!1,!1);f.children.push(k);f.lastPushedText=!1;var m=U(a,0,null,f.formatContext,!1,!1);m.parentFlushed=!0;b.blockedBoundary=h;b.blockedSegment=m;try{if(Hb(a,
	b,d),a.responseState.generateStaticMarkup||m.lastPushedText&&m.textEmbedded&&m.chunks.push("\x3c!-- --\x3e"),m.status=1,Y(h,m),0===h.pendingTasks)break a}catch(n){m.status=4,h.forceClientRender=!0,h.errorDigest=V(a,n)}finally{b.blockedBoundary=c,b.blockedSegment=f}b=Bb(a,e,c,k,g,b.legacyContext,b.context,b.treeContext);a.pingedTasks.push(b)}return}if("object"===typeof c&&null!==c)switch(c.$$typeof){case Na:d=Db(a,b,c.render,d,f);if(0!==N){c=b.treeContext;b.treeContext=gb(c,1,0);try{X(a,b,d)}finally{b.treeContext=
	c}}else X(a,b,d);return;case Qa:c=c.type;d=Fb(c,d);Gb(a,b,c,d,f);return;case La:f=d.children;c=c._context;d=d.value;e=c._currentValue2;c._currentValue2=d;g=E;E=d={parent:g,depth:null===g?0:g.depth+1,context:c,parentValue:e,value:d};b.context=d;X(a,b,f);a=E;if(null===a)throw Error(l(403));d=a.parentValue;a.context._currentValue2=d===Va?a.context._defaultValue:d;a=E=a.parent;b.context=a;return;case Ma:d=d.children;d=d(c._currentValue2);X(a,b,d);return;case Ra:f=c._init;c=f(c._payload);d=Fb(c,d);Gb(a,
	b,c,d,void 0);return}throw Error(l(130,null==c?c:typeof c,""));}}
	function X(a,b,c){b.node=c;if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:Gb(a,b,c.type,c.props,c.ref);return;case Ha:throw Error(l(257));case Ra:var d=c._init;c=d(c._payload);X(a,b,c);return}if(qa(c)){Ib(a,b,c);return}null===c||"object"!==typeof c?d=null:(d=Wa&&c[Wa]||c["@@iterator"],d="function"===typeof d?d:null);if(d&&(d=d.call(c))){c=d.next();if(!c.done){var f=[];do f.push(c.value),c=d.next();while(!c.done);Ib(a,b,f)}return}a=Object.prototype.toString.call(c);throw Error(l(31,"[object Object]"===
	a?"object with keys {"+Object.keys(c).join(", ")+"}":a));}"string"===typeof c?(d=b.blockedSegment,d.lastPushedText=Fa(b.blockedSegment.chunks,c,a.responseState,d.lastPushedText)):"number"===typeof c&&(d=b.blockedSegment,d.lastPushedText=Fa(b.blockedSegment.chunks,""+c,a.responseState,d.lastPushedText))}function Ib(a,b,c){for(var d=c.length,f=0;f<d;f++){var e=b.treeContext;b.treeContext=gb(e,d,f);try{Hb(a,b,c[f])}finally{b.treeContext=e}}}
	function Hb(a,b,c){var d=b.blockedSegment.formatContext,f=b.legacyContext,e=b.context;try{return X(a,b,c)}catch(k){if(rb(),"object"===typeof k&&null!==k&&"function"===typeof k.then){c=k;var g=b.blockedSegment,h=U(a,g.chunks.length,null,g.formatContext,g.lastPushedText,!0);g.children.push(h);g.lastPushedText=!1;a=Bb(a,b.node,b.blockedBoundary,h,b.abortSet,b.legacyContext,b.context,b.treeContext).ping;c.then(a,a);b.blockedSegment.formatContext=d;b.legacyContext=f;b.context=e;G(e)}else throw b.blockedSegment.formatContext=
	d,b.legacyContext=f,b.context=e,G(e),k;}}function Jb(a){var b=a.blockedBoundary;a=a.blockedSegment;a.status=3;Kb(this,b,a)}
	function Lb(a,b,c){var d=a.blockedBoundary;a.blockedSegment.status=3;null===d?(b.allPendingTasks--,2!==b.status&&(b.status=2,null!==b.destination&&b.destination.push(null))):(d.pendingTasks--,d.forceClientRender||(d.forceClientRender=!0,a=void 0===c?Error(l(432)):c,d.errorDigest=b.onError(a),d.parentFlushed&&b.clientRenderedBoundaries.push(d)),d.fallbackAbortableTasks.forEach(function(a){return Lb(a,b,c)}),d.fallbackAbortableTasks.clear(),b.allPendingTasks--,0===b.allPendingTasks&&(d=b.onAllReady,
	d()))}function Y(a,b){if(0===b.chunks.length&&1===b.children.length&&null===b.children[0].boundary){var c=b.children[0];c.id=b.id;c.parentFlushed=!0;1===c.status&&Y(a,c)}else a.completedSegments.push(b)}
	function Kb(a,b,c){if(null===b){if(c.parentFlushed){if(null!==a.completedRootSegment)throw Error(l(389));a.completedRootSegment=c}a.pendingRootTasks--;0===a.pendingRootTasks&&(a.onShellError=T,b=a.onShellReady,b())}else b.pendingTasks--,b.forceClientRender||(0===b.pendingTasks?(c.parentFlushed&&1===c.status&&Y(b,c),b.parentFlushed&&a.completedBoundaries.push(b),b.fallbackAbortableTasks.forEach(Jb,a),b.fallbackAbortableTasks.clear()):c.parentFlushed&&1===c.status&&(Y(b,c),1===b.completedSegments.length&&
	b.parentFlushed&&a.partialBoundaries.push(b)));a.allPendingTasks--;0===a.allPendingTasks&&(a=a.onAllReady,a())}
	function Cb(a){if(2!==a.status){var b=E,c=yb.current;yb.current=xb;var d=S;S=a.responseState;try{var f=a.pingedTasks,e;for(e=0;e<f.length;e++){var g=f[e];var h=a,k=g.blockedSegment;if(0===k.status){G(g.context);try{X(h,g,g.node),h.responseState.generateStaticMarkup||k.lastPushedText&&k.textEmbedded&&k.chunks.push("\x3c!-- --\x3e"),g.abortSet.delete(g),k.status=1,Kb(h,g.blockedBoundary,k)}catch(z){if(rb(),"object"===typeof z&&null!==z&&"function"===typeof z.then){var m=g.ping;z.then(m,m)}else{g.abortSet.delete(g);
	k.status=4;var n=g.blockedBoundary,q=z,C=V(h,q);null===n?W(h,q):(n.pendingTasks--,n.forceClientRender||(n.forceClientRender=!0,n.errorDigest=C,n.parentFlushed&&h.clientRenderedBoundaries.push(n)));h.allPendingTasks--;if(0===h.allPendingTasks){var D=h.onAllReady;D()}}}finally{}}}f.splice(0,e);null!==a.destination&&Mb(a,a.destination)}catch(z){V(a,z),W(a,z)}finally{S=d,yb.current=c,c===xb&&G(b)}}}
	function Z(a,b,c){c.parentFlushed=!0;switch(c.status){case 0:var d=c.id=a.nextSegmentId++;c.lastPushedText=!1;c.textEmbedded=!1;a=a.responseState;b.push('<template id="');b.push(a.placeholderPrefix);a=d.toString(16);b.push(a);return b.push('"></template>');case 1:c.status=2;var f=!0;d=c.chunks;var e=0;c=c.children;for(var g=0;g<c.length;g++){for(f=c[g];e<f.index;e++)b.push(d[e]);f=Nb(a,b,f)}for(;e<d.length-1;e++)b.push(d[e]);e<d.length&&(f=b.push(d[e]));return f;default:throw Error(l(390));}}
	function Nb(a,b,c){var d=c.boundary;if(null===d)return Z(a,b,c);d.parentFlushed=!0;if(d.forceClientRender)return a.responseState.generateStaticMarkup||(d=d.errorDigest,b.push("\x3c!--$!--\x3e"),b.push("<template"),d&&(b.push(' data-dgst="'),d=v(d),b.push(d),b.push('"')),b.push("></template>")),Z(a,b,c),a=a.responseState.generateStaticMarkup?!0:b.push("\x3c!--/$--\x3e"),a;if(0<d.pendingTasks){d.rootSegmentID=a.nextSegmentId++;0<d.completedSegments.length&&a.partialBoundaries.push(d);var f=a.responseState;
	var e=f.nextSuspenseID++;f=f.boundaryPrefix+e.toString(16);d=d.id=f;za(b,a.responseState,d);Z(a,b,c);return b.push("\x3c!--/$--\x3e")}if(d.byteSize>a.progressiveChunkSize)return d.rootSegmentID=a.nextSegmentId++,a.completedBoundaries.push(d),za(b,a.responseState,d.id),Z(a,b,c),b.push("\x3c!--/$--\x3e");a.responseState.generateStaticMarkup||b.push("\x3c!--$--\x3e");c=d.completedSegments;if(1!==c.length)throw Error(l(391));Nb(a,b,c[0]);a=a.responseState.generateStaticMarkup?!0:b.push("\x3c!--/$--\x3e");
	return a}function Ob(a,b,c){Aa(b,a.responseState,c.formatContext,c.id);Nb(a,b,c);return Ba(b,c.formatContext)}
	function Pb(a,b,c){for(var d=c.completedSegments,f=0;f<d.length;f++)Qb(a,b,c,d[f]);d.length=0;a=a.responseState;d=c.id;c=c.rootSegmentID;b.push(a.startInlineScript);a.sentCompleteBoundaryFunction?b.push('$RC("'):(a.sentCompleteBoundaryFunction=!0,b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));if(null===
	d)throw Error(l(395));c=c.toString(16);b.push(d);b.push('","');b.push(a.segmentPrefix);b.push(c);return b.push('")\x3c/script>')}
	function Qb(a,b,c,d){if(2===d.status)return!0;var f=d.id;if(-1===f){if(-1===(d.id=c.rootSegmentID))throw Error(l(392));return Ob(a,b,d)}Ob(a,b,d);a=a.responseState;b.push(a.startInlineScript);a.sentCompleteSegmentFunction?b.push('$RS("'):(a.sentCompleteSegmentFunction=!0,b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));b.push(a.segmentPrefix);
	f=f.toString(16);b.push(f);b.push('","');b.push(a.placeholderPrefix);b.push(f);return b.push('")\x3c/script>')}
	function Mb(a,b){try{var c=a.completedRootSegment;if(null!==c&&0===a.pendingRootTasks){Nb(a,b,c);a.completedRootSegment=null;var d=a.responseState.bootstrapChunks;for(c=0;c<d.length-1;c++)b.push(d[c]);c<d.length&&b.push(d[c])}var f=a.clientRenderedBoundaries,e;for(e=0;e<f.length;e++){var g=f[e];d=b;var h=a.responseState,k=g.id,m=g.errorDigest,n=g.errorMessage,q=g.errorComponentStack;d.push(h.startInlineScript);h.sentClientRenderFunction?d.push('$RX("'):(h.sentClientRenderFunction=!0,d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
	if(null===k)throw Error(l(395));d.push(k);d.push('"');if(m||n||q){d.push(",");var C=Da(m||"");d.push(C)}if(n||q){d.push(",");var D=Da(n||"");d.push(D)}if(q){d.push(",");var z=Da(q);d.push(z)}if(!d.push(")\x3c/script>")){a.destination=null;e++;f.splice(0,e);return}}f.splice(0,e);var ba=a.completedBoundaries;for(e=0;e<ba.length;e++)if(!Pb(a,b,ba[e])){a.destination=null;e++;ba.splice(0,e);return}ba.splice(0,e);var ca=a.partialBoundaries;for(e=0;e<ca.length;e++){var mb=ca[e];a:{f=a;g=b;var da=mb.completedSegments;
	for(h=0;h<da.length;h++)if(!Qb(f,g,mb,da[h])){h++;da.splice(0,h);var nb=!1;break a}da.splice(0,h);nb=!0}if(!nb){a.destination=null;e++;ca.splice(0,e);return}}ca.splice(0,e);var ea=a.completedBoundaries;for(e=0;e<ea.length;e++)if(!Pb(a,b,ea[e])){a.destination=null;e++;ea.splice(0,e);return}ea.splice(0,e)}finally{0===a.allPendingTasks&&0===a.pingedTasks.length&&0===a.clientRenderedBoundaries.length&&0===a.completedBoundaries.length&&b.push(null)}}
	function Rb(a,b){try{var c=a.abortableTasks;c.forEach(function(c){return Lb(c,a,b)});c.clear();null!==a.destination&&Mb(a,a.destination)}catch(d){V(a,d),W(a,d)}}function Sb(){}
	function Tb(a,b,c,d){var f=!1,e=null,g="",h={push:function(a){null!==a&&(g+=a);return!0},destroy:function(a){f=!0;e=a}},k=!1;a=Ab(a,Ea(c,b?b.identifierPrefix:void 0),{insertionMode:1,selectedValue:null},Infinity,Sb,void 0,function(){k=!0},void 0,void 0);Cb(a);Rb(a,d);if(1===a.status)a.status=2,h.destroy(a.fatalError);else if(2!==a.status&&null===a.destination){a.destination=h;try{Mb(a,h)}catch(m){V(a,m),W(a,m)}}if(f)throw e;if(!k)throw Error(l(426));return g}
	exports.renderToNodeStream=function(){throw Error(l(207));};exports.renderToStaticMarkup=function(a,b){return Tb(a,b,!0,'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server')};exports.renderToStaticNodeStream=function(){throw Error(l(208));};exports.renderToString=function(a,b){return Tb(a,b,!1,'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server')};
	exports.version="18.2.0";


/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license React
	 * react-dom-server.browser.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var aa=__webpack_require__(2);function k(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var l=null,n=0;
	function p(a,b){if(0!==b.length)if(512<b.length)0<n&&(a.enqueue(new Uint8Array(l.buffer,0,n)),l=new Uint8Array(512),n=0),a.enqueue(b);else{var c=l.length-n;c<b.length&&(0===c?a.enqueue(l):(l.set(b.subarray(0,c),n),a.enqueue(l),b=b.subarray(c)),l=new Uint8Array(512),n=0);l.set(b,n);n+=b.length}}function t(a,b){p(a,b);return!0}function ba(a){l&&0<n&&(a.enqueue(new Uint8Array(l.buffer,0,n)),l=null,n=0)}var ca=new TextEncoder;function u(a){return ca.encode(a)}function w(a){return ca.encode(a)}
	function da(a,b){"function"===typeof a.error?a.error(b):a.close()}var x=Object.prototype.hasOwnProperty,ea=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,fa={},ha={};
	function ia(a){if(x.call(ha,a))return!0;if(x.call(fa,a))return!1;if(ea.test(a))return ha[a]=!0;fa[a]=!0;return!1}function y(a,b,c,d,f,e,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=e;this.removeEmptyString=g}var z={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){z[a]=new y(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];z[b]=new y(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){z[a]=new y(a,2,!1,a.toLowerCase(),null,!1,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){z[a]=new y(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){z[a]=new y(a,3,!1,a.toLowerCase(),null,!1,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){z[a]=new y(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){z[a]=new y(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){z[a]=new y(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){z[a]=new y(a,5,!1,a.toLowerCase(),null,!1,!1)});var ja=/[\-:]([a-z])/g;function ka(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(ja,
	ka);z[b]=new y(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(ja,ka);z[b]=new y(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(ja,ka);z[b]=new y(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){z[a]=new y(a,1,!1,a.toLowerCase(),null,!1,!1)});
	z.xlinkHref=new y("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){z[a]=new y(a,1,!1,a.toLowerCase(),null,!0,!0)});
	var B={animationIterationCount:!0,aspectRatio:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,
	fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},la=["Webkit","ms","Moz","O"];Object.keys(B).forEach(function(a){la.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);B[b]=B[a]})});var oa=/["'&<>]/;
	function C(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=oa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}
	var pa=/([A-Z])/g,qa=/^ms-/,ra=Array.isArray,sa=w("<script>"),ta=w("\x3c/script>"),ua=w('<script src="'),va=w('<script type="module" src="'),wa=w('" async="">\x3c/script>'),xa=/(<\/|<)(s)(cript)/gi;function ya(a,b,c,d){return""+b+("s"===c?"\\u0073":"\\u0053")+d}
	function za(a,b,c,d,f){a=void 0===a?"":a;b=void 0===b?sa:w('<script nonce="'+C(b)+'">');var e=[];void 0!==c&&e.push(b,u((""+c).replace(xa,ya)),ta);if(void 0!==d)for(c=0;c<d.length;c++)e.push(ua,u(C(d[c])),wa);if(void 0!==f)for(d=0;d<f.length;d++)e.push(va,u(C(f[d])),wa);return{bootstrapChunks:e,startInlineScript:b,placeholderPrefix:w(a+"P:"),segmentPrefix:w(a+"S:"),boundaryPrefix:a+"B:",idPrefix:a,nextSuspenseID:0,sentCompleteSegmentFunction:!1,sentCompleteBoundaryFunction:!1,sentClientRenderFunction:!1}}
	function D(a,b){return{insertionMode:a,selectedValue:b}}function Aa(a){return D("http://www.w3.org/2000/svg"===a?2:"http://www.w3.org/1998/Math/MathML"===a?3:0,null)}
	function Ba(a,b,c){switch(b){case "select":return D(1,null!=c.value?c.value:c.defaultValue);case "svg":return D(2,null);case "math":return D(3,null);case "foreignObject":return D(1,null);case "table":return D(4,null);case "thead":case "tbody":case "tfoot":return D(5,null);case "colgroup":return D(7,null);case "tr":return D(6,null)}return 4<=a.insertionMode||0===a.insertionMode?D(1,null):a}var Ca=w("\x3c!-- --\x3e");function Da(a,b,c,d){if(""===b)return d;d&&a.push(Ca);a.push(u(C(b)));return!0}
	var Ea=new Map,Fa=w(' style="'),Ga=w(":"),Ha=w(";");
	function Ia(a,b,c){if("object"!==typeof c)throw Error(k(62));b=!0;for(var d in c)if(x.call(c,d)){var f=c[d];if(null!=f&&"boolean"!==typeof f&&""!==f){if(0===d.indexOf("--")){var e=u(C(d));f=u(C((""+f).trim()))}else{e=d;var g=Ea.get(e);void 0!==g?e=g:(g=w(C(e.replace(pa,"-$1").toLowerCase().replace(qa,"-ms-"))),Ea.set(e,g),e=g);f="number"===typeof f?0===f||x.call(B,d)?u(""+f):u(f+"px"):u(C((""+f).trim()))}b?(b=!1,a.push(Fa,e,Ga,f)):a.push(Ha,e,Ga,f)}}b||a.push(E)}
	var H=w(" "),I=w('="'),E=w('"'),Ja=w('=""');
	function J(a,b,c,d){switch(c){case "style":Ia(a,b,d);return;case "defaultValue":case "defaultChecked":case "innerHTML":case "suppressContentEditableWarning":case "suppressHydrationWarning":return}if(!(2<c.length)||"o"!==c[0]&&"O"!==c[0]||"n"!==c[1]&&"N"!==c[1])if(b=z.hasOwnProperty(c)?z[c]:null,null!==b){switch(typeof d){case "function":case "symbol":return;case "boolean":if(!b.acceptsBooleans)return}c=u(b.attributeName);switch(b.type){case 3:d&&a.push(H,c,Ja);break;case 4:!0===d?a.push(H,c,Ja):!1!==
	d&&a.push(H,c,I,u(C(d)),E);break;case 5:isNaN(d)||a.push(H,c,I,u(C(d)),E);break;case 6:!isNaN(d)&&1<=d&&a.push(H,c,I,u(C(d)),E);break;default:b.sanitizeURL&&(d=""+d),a.push(H,c,I,u(C(d)),E)}}else if(ia(c)){switch(typeof d){case "function":case "symbol":return;case "boolean":if(b=c.toLowerCase().slice(0,5),"data-"!==b&&"aria-"!==b)return}a.push(H,u(c),I,u(C(d)),E)}}var K=w(">"),Ka=w("/>");
	function L(a,b,c){if(null!=b){if(null!=c)throw Error(k(60));if("object"!==typeof b||!("__html"in b))throw Error(k(61));b=b.__html;null!==b&&void 0!==b&&a.push(u(""+b))}}function La(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Ma=w(' selected=""');
	function Na(a,b,c,d){a.push(M(c));var f=c=null,e;for(e in b)if(x.call(b,e)){var g=b[e];if(null!=g)switch(e){case "children":c=g;break;case "dangerouslySetInnerHTML":f=g;break;default:J(a,d,e,g)}}a.push(K);L(a,f,c);return"string"===typeof c?(a.push(u(C(c))),null):c}var Oa=w("\n"),Pa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Qa=new Map;function M(a){var b=Qa.get(a);if(void 0===b){if(!Pa.test(a))throw Error(k(65,a));b=w("<"+a);Qa.set(a,b)}return b}var Ra=w("<!DOCTYPE html>");
	function Sa(a,b,c,d,f){switch(b){case "select":a.push(M("select"));var e=null,g=null;for(r in c)if(x.call(c,r)){var h=c[r];if(null!=h)switch(r){case "children":e=h;break;case "dangerouslySetInnerHTML":g=h;break;case "defaultValue":case "value":break;default:J(a,d,r,h)}}a.push(K);L(a,g,e);return e;case "option":g=f.selectedValue;a.push(M("option"));var m=h=null,q=null;var r=null;for(e in c)if(x.call(c,e)){var v=c[e];if(null!=v)switch(e){case "children":h=v;break;case "selected":q=v;break;case "dangerouslySetInnerHTML":r=
	v;break;case "value":m=v;default:J(a,d,e,v)}}if(null!=g)if(c=null!==m?""+m:La(h),ra(g))for(d=0;d<g.length;d++){if(""+g[d]===c){a.push(Ma);break}}else""+g===c&&a.push(Ma);else q&&a.push(Ma);a.push(K);L(a,r,h);return h;case "textarea":a.push(M("textarea"));r=g=e=null;for(h in c)if(x.call(c,h)&&(m=c[h],null!=m))switch(h){case "children":r=m;break;case "value":e=m;break;case "defaultValue":g=m;break;case "dangerouslySetInnerHTML":throw Error(k(91));default:J(a,d,h,m)}null===e&&null!==g&&(e=g);a.push(K);
	if(null!=r){if(null!=e)throw Error(k(92));if(ra(r)&&1<r.length)throw Error(k(93));e=""+r}"string"===typeof e&&"\n"===e[0]&&a.push(Oa);null!==e&&a.push(u(C(""+e)));return null;case "input":a.push(M("input"));m=r=h=e=null;for(g in c)if(x.call(c,g)&&(q=c[g],null!=q))switch(g){case "children":case "dangerouslySetInnerHTML":throw Error(k(399,"input"));case "defaultChecked":m=q;break;case "defaultValue":h=q;break;case "checked":r=q;break;case "value":e=q;break;default:J(a,d,g,q)}null!==r?J(a,d,"checked",
	r):null!==m&&J(a,d,"checked",m);null!==e?J(a,d,"value",e):null!==h&&J(a,d,"value",h);a.push(Ka);return null;case "menuitem":a.push(M("menuitem"));for(var A in c)if(x.call(c,A)&&(e=c[A],null!=e))switch(A){case "children":case "dangerouslySetInnerHTML":throw Error(k(400));default:J(a,d,A,e)}a.push(K);return null;case "title":a.push(M("title"));e=null;for(v in c)if(x.call(c,v)&&(g=c[v],null!=g))switch(v){case "children":e=g;break;case "dangerouslySetInnerHTML":throw Error(k(434));default:J(a,d,v,g)}a.push(K);
	return e;case "listing":case "pre":a.push(M(b));g=e=null;for(m in c)if(x.call(c,m)&&(h=c[m],null!=h))switch(m){case "children":e=h;break;case "dangerouslySetInnerHTML":g=h;break;default:J(a,d,m,h)}a.push(K);if(null!=g){if(null!=e)throw Error(k(60));if("object"!==typeof g||!("__html"in g))throw Error(k(61));c=g.__html;null!==c&&void 0!==c&&("string"===typeof c&&0<c.length&&"\n"===c[0]?a.push(Oa,u(c)):a.push(u(""+c)))}"string"===typeof e&&"\n"===e[0]&&a.push(Oa);return e;case "area":case "base":case "br":case "col":case "embed":case "hr":case "img":case "keygen":case "link":case "meta":case "param":case "source":case "track":case "wbr":a.push(M(b));
	for(var F in c)if(x.call(c,F)&&(e=c[F],null!=e))switch(F){case "children":case "dangerouslySetInnerHTML":throw Error(k(399,b));default:J(a,d,F,e)}a.push(Ka);return null;case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return Na(a,c,b,d);case "html":return 0===f.insertionMode&&a.push(Ra),Na(a,c,b,d);default:if(-1===b.indexOf("-")&&"string"!==typeof c.is)return Na(a,c,b,d);a.push(M(b));
	g=e=null;for(q in c)if(x.call(c,q)&&(h=c[q],null!=h))switch(q){case "children":e=h;break;case "dangerouslySetInnerHTML":g=h;break;case "style":Ia(a,d,h);break;case "suppressContentEditableWarning":case "suppressHydrationWarning":break;default:ia(q)&&"function"!==typeof h&&"symbol"!==typeof h&&a.push(H,u(q),I,u(C(h)),E)}a.push(K);L(a,g,e);return e}}
	var Ta=w("</"),Ua=w(">"),Va=w('<template id="'),Wa=w('"></template>'),Xa=w("\x3c!--$--\x3e"),Ya=w('\x3c!--$?--\x3e<template id="'),Za=w('"></template>'),$a=w("\x3c!--$!--\x3e"),ab=w("\x3c!--/$--\x3e"),bb=w("<template"),cb=w('"'),db=w(' data-dgst="');w(' data-msg="');w(' data-stck="');var eb=w("></template>");function fb(a,b,c){p(a,Ya);if(null===c)throw Error(k(395));p(a,c);return t(a,Za)}
	var gb=w('<div hidden id="'),hb=w('">'),ib=w("</div>"),jb=w('<svg aria-hidden="true" style="display:none" id="'),kb=w('">'),lb=w("</svg>"),mb=w('<math aria-hidden="true" style="display:none" id="'),nb=w('">'),ob=w("</math>"),pb=w('<table hidden id="'),qb=w('">'),rb=w("</table>"),sb=w('<table hidden><tbody id="'),tb=w('">'),ub=w("</tbody></table>"),vb=w('<table hidden><tr id="'),wb=w('">'),xb=w("</tr></table>"),yb=w('<table hidden><colgroup id="'),zb=w('">'),Ab=w("</colgroup></table>");
	function Bb(a,b,c,d){switch(c.insertionMode){case 0:case 1:return p(a,gb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,hb);case 2:return p(a,jb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,kb);case 3:return p(a,mb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,nb);case 4:return p(a,pb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,qb);case 5:return p(a,sb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,tb);case 6:return p(a,vb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,wb);case 7:return p(a,
	yb),p(a,b.segmentPrefix),p(a,u(d.toString(16))),t(a,zb);default:throw Error(k(397));}}function Cb(a,b){switch(b.insertionMode){case 0:case 1:return t(a,ib);case 2:return t(a,lb);case 3:return t(a,ob);case 4:return t(a,rb);case 5:return t(a,ub);case 6:return t(a,xb);case 7:return t(a,Ab);default:throw Error(k(397));}}
	var Db=w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'),Eb=w('$RS("'),Gb=w('","'),Hb=w('")\x3c/script>'),Ib=w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'),
	Jb=w('$RC("'),Kb=w('","'),Lb=w('")\x3c/script>'),Mb=w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'),Nb=w('$RX("'),Ob=w('"'),Pb=w(")\x3c/script>"),Qb=w(","),Rb=/[<\u2028\u2029]/g;
	function Sb(a){return JSON.stringify(a).replace(Rb,function(a){switch(a){case "<":return"\\u003c";case "\u2028":return"\\u2028";case "\u2029":return"\\u2029";default:throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");}})}
	var N=Object.assign,Tb=Symbol.for("react.element"),Ub=Symbol.for("react.portal"),Vb=Symbol.for("react.fragment"),Wb=Symbol.for("react.strict_mode"),Xb=Symbol.for("react.profiler"),Yb=Symbol.for("react.provider"),Zb=Symbol.for("react.context"),$b=Symbol.for("react.forward_ref"),ac=Symbol.for("react.suspense"),bc=Symbol.for("react.suspense_list"),cc=Symbol.for("react.memo"),dc=Symbol.for("react.lazy"),ec=Symbol.for("react.scope"),fc=Symbol.for("react.debug_trace_mode"),gc=Symbol.for("react.legacy_hidden"),
	hc=Symbol.for("react.default_value"),ic=Symbol.iterator;
	function jc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Vb:return"Fragment";case Ub:return"Portal";case Xb:return"Profiler";case Wb:return"StrictMode";case ac:return"Suspense";case bc:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Zb:return(a.displayName||"Context")+".Consumer";case Yb:return(a._context.displayName||"Context")+".Provider";case $b:var b=a.render;a=a.displayName;a||(a=b.displayName||
	b.name||"",a=""!==a?"ForwardRef("+a+")":"ForwardRef");return a;case cc:return b=a.displayName||null,null!==b?b:jc(a.type)||"Memo";case dc:b=a._payload;a=a._init;try{return jc(a(b))}catch(c){}}return null}var kc={};function lc(a,b){a=a.contextTypes;if(!a)return kc;var c={},d;for(d in a)c[d]=b[d];return c}var O=null;
	function P(a,b){if(a!==b){a.context._currentValue=a.parentValue;a=a.parent;var c=b.parent;if(null===a){if(null!==c)throw Error(k(401));}else{if(null===c)throw Error(k(401));P(a,c)}b.context._currentValue=b.value}}function mc(a){a.context._currentValue=a.parentValue;a=a.parent;null!==a&&mc(a)}function nc(a){var b=a.parent;null!==b&&nc(b);a.context._currentValue=a.value}
	function oc(a,b){a.context._currentValue=a.parentValue;a=a.parent;if(null===a)throw Error(k(402));a.depth===b.depth?P(a,b):oc(a,b)}function pc(a,b){var c=b.parent;if(null===c)throw Error(k(402));a.depth===c.depth?P(a,c):pc(a,c);b.context._currentValue=b.value}function Q(a){var b=O;b!==a&&(null===b?nc(a):null===a?mc(b):b.depth===a.depth?P(b,a):b.depth>a.depth?oc(b,a):pc(b,a),O=a)}
	var qc={isMounted:function(){return!1},enqueueSetState:function(a,b){a=a._reactInternals;null!==a.queue&&a.queue.push(b)},enqueueReplaceState:function(a,b){a=a._reactInternals;a.replace=!0;a.queue=[b]},enqueueForceUpdate:function(){}};
	function rc(a,b,c,d){var f=void 0!==a.state?a.state:null;a.updater=qc;a.props=c;a.state=f;var e={queue:[],replace:!1};a._reactInternals=e;var g=b.contextType;a.context="object"===typeof g&&null!==g?g._currentValue:d;g=b.getDerivedStateFromProps;"function"===typeof g&&(g=g(c,f),f=null===g||void 0===g?f:N({},f,g),a.state=f);if("function"!==typeof b.getDerivedStateFromProps&&"function"!==typeof a.getSnapshotBeforeUpdate&&("function"===typeof a.UNSAFE_componentWillMount||"function"===typeof a.componentWillMount))if(b=
	a.state,"function"===typeof a.componentWillMount&&a.componentWillMount(),"function"===typeof a.UNSAFE_componentWillMount&&a.UNSAFE_componentWillMount(),b!==a.state&&qc.enqueueReplaceState(a,a.state,null),null!==e.queue&&0<e.queue.length)if(b=e.queue,g=e.replace,e.queue=null,e.replace=!1,g&&1===b.length)a.state=b[0];else{e=g?b[0]:a.state;f=!0;for(g=g?1:0;g<b.length;g++){var h=b[g];h="function"===typeof h?h.call(a,e,c,d):h;null!=h&&(f?(f=!1,e=N({},e,h)):N(e,h))}a.state=e}else e.queue=null}
	var sc={id:1,overflow:""};function tc(a,b,c){var d=a.id;a=a.overflow;var f=32-uc(d)-1;d&=~(1<<f);c+=1;var e=32-uc(b)+f;if(30<e){var g=f-f%5;e=(d&(1<<g)-1).toString(32);d>>=g;f-=g;return{id:1<<32-uc(b)+f|c<<f|d,overflow:e+a}}return{id:1<<e|c<<f|d,overflow:a}}var uc=Math.clz32?Math.clz32:vc,wc=Math.log,xc=Math.LN2;function vc(a){a>>>=0;return 0===a?32:31-(wc(a)/xc|0)|0}function yc(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
	var zc="function"===typeof Object.is?Object.is:yc,R=null,Ac=null,Bc=null,S=null,T=!1,Cc=!1,U=0,V=null,Dc=0;function W(){if(null===R)throw Error(k(321));return R}function Ec(){if(0<Dc)throw Error(k(312));return{memoizedState:null,queue:null,next:null}}function Fc(){null===S?null===Bc?(T=!1,Bc=S=Ec()):(T=!0,S=Bc):null===S.next?(T=!1,S=S.next=Ec()):(T=!0,S=S.next);return S}function Gc(){Ac=R=null;Cc=!1;Bc=null;Dc=0;S=V=null}function Hc(a,b){return"function"===typeof b?b(a):b}
	function Ic(a,b,c){R=W();S=Fc();if(T){var d=S.queue;b=d.dispatch;if(null!==V&&(c=V.get(d),void 0!==c)){V.delete(d);d=S.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);S.memoizedState=d;return[d,b]}return[S.memoizedState,b]}a=a===Hc?"function"===typeof b?b():b:void 0!==c?c(b):b;S.memoizedState=a;a=S.queue={last:null,dispatch:null};a=a.dispatch=Jc.bind(null,R,a);return[S.memoizedState,a]}
	function Kc(a,b){R=W();S=Fc();b=void 0===b?null:b;if(null!==S){var c=S.memoizedState;if(null!==c&&null!==b){var d=c[1];a:if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!zc(b[f],d[f])){d=!1;break a}d=!0}if(d)return c[0]}}a=a();S.memoizedState=[a,b];return a}function Jc(a,b,c){if(25<=Dc)throw Error(k(301));if(a===R)if(Cc=!0,a={action:c,next:null},null===V&&(V=new Map),c=V.get(b),void 0===c)V.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}
	function Lc(){throw Error(k(394));}function Mc(){}
	var Oc={readContext:function(a){return a._currentValue},useContext:function(a){W();return a._currentValue},useMemo:Kc,useReducer:Ic,useRef:function(a){R=W();S=Fc();var b=S.memoizedState;return null===b?(a={current:a},S.memoizedState=a):b},useState:function(a){return Ic(Hc,a)},useInsertionEffect:Mc,useLayoutEffect:function(){},useCallback:function(a,b){return Kc(function(){return a},b)},useImperativeHandle:Mc,useEffect:Mc,useDebugValue:Mc,useDeferredValue:function(a){W();return a},useTransition:function(){W();
	return[!1,Lc]},useId:function(){var a=Ac.treeContext;var b=a.overflow;a=a.id;a=(a&~(1<<32-uc(a)-1)).toString(32)+b;var c=Nc;if(null===c)throw Error(k(404));b=U++;a=":"+c.idPrefix+"R"+a;0<b&&(a+="H"+b.toString(32));return a+":"},useMutableSource:function(a,b){W();return b(a._source)},useSyncExternalStore:function(a,b,c){if(void 0===c)throw Error(k(407));return c()}},Nc=null,Pc=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;function Qc(a){console.error(a);return null}
	function X(){}
	function Rc(a,b,c,d,f,e,g,h,m){var q=[],r=new Set;b={destination:null,responseState:b,progressiveChunkSize:void 0===d?12800:d,status:0,fatalError:null,nextSegmentId:0,allPendingTasks:0,pendingRootTasks:0,completedRootSegment:null,abortableTasks:r,pingedTasks:q,clientRenderedBoundaries:[],completedBoundaries:[],partialBoundaries:[],onError:void 0===f?Qc:f,onAllReady:void 0===e?X:e,onShellReady:void 0===g?X:g,onShellError:void 0===h?X:h,onFatalError:void 0===m?X:m};c=Sc(b,0,null,c,!1,!1);c.parentFlushed=
	!0;a=Tc(b,a,null,c,r,kc,null,sc);q.push(a);return b}function Tc(a,b,c,d,f,e,g,h){a.allPendingTasks++;null===c?a.pendingRootTasks++:c.pendingTasks++;var m={node:b,ping:function(){var b=a.pingedTasks;b.push(m);1===b.length&&Uc(a)},blockedBoundary:c,blockedSegment:d,abortSet:f,legacyContext:e,context:g,treeContext:h};f.add(m);return m}function Sc(a,b,c,d,f,e){return{status:0,id:-1,index:b,parentFlushed:!1,chunks:[],children:[],formatContext:d,boundary:c,lastPushedText:f,textEmbedded:e}}
	function Y(a,b){a=a.onError(b);if(null!=a&&"string"!==typeof a)throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "'+typeof a+'" instead');return a}function Vc(a,b){var c=a.onShellError;c(b);c=a.onFatalError;c(b);null!==a.destination?(a.status=2,da(a.destination,b)):(a.status=1,a.fatalError=b)}
	function Wc(a,b,c,d,f){R={};Ac=b;U=0;for(a=c(d,f);Cc;)Cc=!1,U=0,Dc+=1,S=null,a=c(d,f);Gc();return a}function Xc(a,b,c,d){var f=c.render(),e=d.childContextTypes;if(null!==e&&void 0!==e){var g=b.legacyContext;if("function"!==typeof c.getChildContext)d=g;else{c=c.getChildContext();for(var h in c)if(!(h in e))throw Error(k(108,jc(d)||"Unknown",h));d=N({},g,c)}b.legacyContext=d;Z(a,b,f);b.legacyContext=g}else Z(a,b,f)}
	function Yc(a,b){if(a&&a.defaultProps){b=N({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}
	function Zc(a,b,c,d,f){if("function"===typeof c)if(c.prototype&&c.prototype.isReactComponent){f=lc(c,b.legacyContext);var e=c.contextType;e=new c(d,"object"===typeof e&&null!==e?e._currentValue:f);rc(e,c,d,f);Xc(a,b,e,c)}else{e=lc(c,b.legacyContext);f=Wc(a,b,c,d,e);var g=0!==U;if("object"===typeof f&&null!==f&&"function"===typeof f.render&&void 0===f.$$typeof)rc(f,c,d,e),Xc(a,b,f,c);else if(g){d=b.treeContext;b.treeContext=tc(d,1,0);try{Z(a,b,f)}finally{b.treeContext=d}}else Z(a,b,f)}else if("string"===
	typeof c){f=b.blockedSegment;e=Sa(f.chunks,c,d,a.responseState,f.formatContext);f.lastPushedText=!1;g=f.formatContext;f.formatContext=Ba(g,c,d);$c(a,b,e);f.formatContext=g;switch(c){case "area":case "base":case "br":case "col":case "embed":case "hr":case "img":case "input":case "keygen":case "link":case "meta":case "param":case "source":case "track":case "wbr":break;default:f.chunks.push(Ta,u(c),Ua)}f.lastPushedText=!1}else{switch(c){case gc:case fc:case Wb:case Xb:case Vb:Z(a,b,d.children);return;
	case bc:Z(a,b,d.children);return;case ec:throw Error(k(343));case ac:a:{c=b.blockedBoundary;f=b.blockedSegment;e=d.fallback;d=d.children;g=new Set;var h={id:null,rootSegmentID:-1,parentFlushed:!1,pendingTasks:0,forceClientRender:!1,completedSegments:[],byteSize:0,fallbackAbortableTasks:g,errorDigest:null},m=Sc(a,f.chunks.length,h,f.formatContext,!1,!1);f.children.push(m);f.lastPushedText=!1;var q=Sc(a,0,null,f.formatContext,!1,!1);q.parentFlushed=!0;b.blockedBoundary=h;b.blockedSegment=q;try{if($c(a,
	b,d),q.lastPushedText&&q.textEmbedded&&q.chunks.push(Ca),q.status=1,ad(h,q),0===h.pendingTasks)break a}catch(r){q.status=4,h.forceClientRender=!0,h.errorDigest=Y(a,r)}finally{b.blockedBoundary=c,b.blockedSegment=f}b=Tc(a,e,c,m,g,b.legacyContext,b.context,b.treeContext);a.pingedTasks.push(b)}return}if("object"===typeof c&&null!==c)switch(c.$$typeof){case $b:d=Wc(a,b,c.render,d,f);if(0!==U){c=b.treeContext;b.treeContext=tc(c,1,0);try{Z(a,b,d)}finally{b.treeContext=c}}else Z(a,b,d);return;case cc:c=
	c.type;d=Yc(c,d);Zc(a,b,c,d,f);return;case Yb:f=d.children;c=c._context;d=d.value;e=c._currentValue;c._currentValue=d;g=O;O=d={parent:g,depth:null===g?0:g.depth+1,context:c,parentValue:e,value:d};b.context=d;Z(a,b,f);a=O;if(null===a)throw Error(k(403));d=a.parentValue;a.context._currentValue=d===hc?a.context._defaultValue:d;a=O=a.parent;b.context=a;return;case Zb:d=d.children;d=d(c._currentValue);Z(a,b,d);return;case dc:f=c._init;c=f(c._payload);d=Yc(c,d);Zc(a,b,c,d,void 0);return}throw Error(k(130,
	null==c?c:typeof c,""));}}
	function Z(a,b,c){b.node=c;if("object"===typeof c&&null!==c){switch(c.$$typeof){case Tb:Zc(a,b,c.type,c.props,c.ref);return;case Ub:throw Error(k(257));case dc:var d=c._init;c=d(c._payload);Z(a,b,c);return}if(ra(c)){bd(a,b,c);return}null===c||"object"!==typeof c?d=null:(d=ic&&c[ic]||c["@@iterator"],d="function"===typeof d?d:null);if(d&&(d=d.call(c))){c=d.next();if(!c.done){var f=[];do f.push(c.value),c=d.next();while(!c.done);bd(a,b,f)}return}a=Object.prototype.toString.call(c);throw Error(k(31,"[object Object]"===
	a?"object with keys {"+Object.keys(c).join(", ")+"}":a));}"string"===typeof c?(d=b.blockedSegment,d.lastPushedText=Da(b.blockedSegment.chunks,c,a.responseState,d.lastPushedText)):"number"===typeof c&&(d=b.blockedSegment,d.lastPushedText=Da(b.blockedSegment.chunks,""+c,a.responseState,d.lastPushedText))}function bd(a,b,c){for(var d=c.length,f=0;f<d;f++){var e=b.treeContext;b.treeContext=tc(e,d,f);try{$c(a,b,c[f])}finally{b.treeContext=e}}}
	function $c(a,b,c){var d=b.blockedSegment.formatContext,f=b.legacyContext,e=b.context;try{return Z(a,b,c)}catch(m){if(Gc(),"object"===typeof m&&null!==m&&"function"===typeof m.then){c=m;var g=b.blockedSegment,h=Sc(a,g.chunks.length,null,g.formatContext,g.lastPushedText,!0);g.children.push(h);g.lastPushedText=!1;a=Tc(a,b.node,b.blockedBoundary,h,b.abortSet,b.legacyContext,b.context,b.treeContext).ping;c.then(a,a);b.blockedSegment.formatContext=d;b.legacyContext=f;b.context=e;Q(e)}else throw b.blockedSegment.formatContext=
	d,b.legacyContext=f,b.context=e,Q(e),m;}}function cd(a){var b=a.blockedBoundary;a=a.blockedSegment;a.status=3;dd(this,b,a)}
	function ed(a,b,c){var d=a.blockedBoundary;a.blockedSegment.status=3;null===d?(b.allPendingTasks--,2!==b.status&&(b.status=2,null!==b.destination&&b.destination.close())):(d.pendingTasks--,d.forceClientRender||(d.forceClientRender=!0,a=void 0===c?Error(k(432)):c,d.errorDigest=b.onError(a),d.parentFlushed&&b.clientRenderedBoundaries.push(d)),d.fallbackAbortableTasks.forEach(function(a){return ed(a,b,c)}),d.fallbackAbortableTasks.clear(),b.allPendingTasks--,0===b.allPendingTasks&&(d=b.onAllReady,d()))}
	function ad(a,b){if(0===b.chunks.length&&1===b.children.length&&null===b.children[0].boundary){var c=b.children[0];c.id=b.id;c.parentFlushed=!0;1===c.status&&ad(a,c)}else a.completedSegments.push(b)}
	function dd(a,b,c){if(null===b){if(c.parentFlushed){if(null!==a.completedRootSegment)throw Error(k(389));a.completedRootSegment=c}a.pendingRootTasks--;0===a.pendingRootTasks&&(a.onShellError=X,b=a.onShellReady,b())}else b.pendingTasks--,b.forceClientRender||(0===b.pendingTasks?(c.parentFlushed&&1===c.status&&ad(b,c),b.parentFlushed&&a.completedBoundaries.push(b),b.fallbackAbortableTasks.forEach(cd,a),b.fallbackAbortableTasks.clear()):c.parentFlushed&&1===c.status&&(ad(b,c),1===b.completedSegments.length&&
	b.parentFlushed&&a.partialBoundaries.push(b)));a.allPendingTasks--;0===a.allPendingTasks&&(a=a.onAllReady,a())}
	function Uc(a){if(2!==a.status){var b=O,c=Pc.current;Pc.current=Oc;var d=Nc;Nc=a.responseState;try{var f=a.pingedTasks,e;for(e=0;e<f.length;e++){var g=f[e];var h=a,m=g.blockedSegment;if(0===m.status){Q(g.context);try{Z(h,g,g.node),m.lastPushedText&&m.textEmbedded&&m.chunks.push(Ca),g.abortSet.delete(g),m.status=1,dd(h,g.blockedBoundary,m)}catch(G){if(Gc(),"object"===typeof G&&null!==G&&"function"===typeof G.then){var q=g.ping;G.then(q,q)}else{g.abortSet.delete(g);m.status=4;var r=g.blockedBoundary,
	v=G,A=Y(h,v);null===r?Vc(h,v):(r.pendingTasks--,r.forceClientRender||(r.forceClientRender=!0,r.errorDigest=A,r.parentFlushed&&h.clientRenderedBoundaries.push(r)));h.allPendingTasks--;if(0===h.allPendingTasks){var F=h.onAllReady;F()}}}finally{}}}f.splice(0,e);null!==a.destination&&fd(a,a.destination)}catch(G){Y(a,G),Vc(a,G)}finally{Nc=d,Pc.current=c,c===Oc&&Q(b)}}}
	function gd(a,b,c){c.parentFlushed=!0;switch(c.status){case 0:var d=c.id=a.nextSegmentId++;c.lastPushedText=!1;c.textEmbedded=!1;a=a.responseState;p(b,Va);p(b,a.placeholderPrefix);a=u(d.toString(16));p(b,a);return t(b,Wa);case 1:c.status=2;var f=!0;d=c.chunks;var e=0;c=c.children;for(var g=0;g<c.length;g++){for(f=c[g];e<f.index;e++)p(b,d[e]);f=hd(a,b,f)}for(;e<d.length-1;e++)p(b,d[e]);e<d.length&&(f=t(b,d[e]));return f;default:throw Error(k(390));}}
	function hd(a,b,c){var d=c.boundary;if(null===d)return gd(a,b,c);d.parentFlushed=!0;if(d.forceClientRender)d=d.errorDigest,t(b,$a),p(b,bb),d&&(p(b,db),p(b,u(C(d))),p(b,cb)),t(b,eb),gd(a,b,c);else if(0<d.pendingTasks){d.rootSegmentID=a.nextSegmentId++;0<d.completedSegments.length&&a.partialBoundaries.push(d);var f=a.responseState;var e=f.nextSuspenseID++;f=w(f.boundaryPrefix+e.toString(16));d=d.id=f;fb(b,a.responseState,d);gd(a,b,c)}else if(d.byteSize>a.progressiveChunkSize)d.rootSegmentID=a.nextSegmentId++,
	a.completedBoundaries.push(d),fb(b,a.responseState,d.id),gd(a,b,c);else{t(b,Xa);c=d.completedSegments;if(1!==c.length)throw Error(k(391));hd(a,b,c[0])}return t(b,ab)}function id(a,b,c){Bb(b,a.responseState,c.formatContext,c.id);hd(a,b,c);return Cb(b,c.formatContext)}
	function jd(a,b,c){for(var d=c.completedSegments,f=0;f<d.length;f++)kd(a,b,c,d[f]);d.length=0;a=a.responseState;d=c.id;c=c.rootSegmentID;p(b,a.startInlineScript);a.sentCompleteBoundaryFunction?p(b,Jb):(a.sentCompleteBoundaryFunction=!0,p(b,Ib));if(null===d)throw Error(k(395));c=u(c.toString(16));p(b,d);p(b,Kb);p(b,a.segmentPrefix);p(b,c);return t(b,Lb)}
	function kd(a,b,c,d){if(2===d.status)return!0;var f=d.id;if(-1===f){if(-1===(d.id=c.rootSegmentID))throw Error(k(392));return id(a,b,d)}id(a,b,d);a=a.responseState;p(b,a.startInlineScript);a.sentCompleteSegmentFunction?p(b,Eb):(a.sentCompleteSegmentFunction=!0,p(b,Db));p(b,a.segmentPrefix);f=u(f.toString(16));p(b,f);p(b,Gb);p(b,a.placeholderPrefix);p(b,f);return t(b,Hb)}
	function fd(a,b){l=new Uint8Array(512);n=0;try{var c=a.completedRootSegment;if(null!==c&&0===a.pendingRootTasks){hd(a,b,c);a.completedRootSegment=null;var d=a.responseState.bootstrapChunks;for(c=0;c<d.length-1;c++)p(b,d[c]);c<d.length&&t(b,d[c])}var f=a.clientRenderedBoundaries,e;for(e=0;e<f.length;e++){var g=f[e];d=b;var h=a.responseState,m=g.id,q=g.errorDigest,r=g.errorMessage,v=g.errorComponentStack;p(d,h.startInlineScript);h.sentClientRenderFunction?p(d,Nb):(h.sentClientRenderFunction=!0,p(d,
	Mb));if(null===m)throw Error(k(395));p(d,m);p(d,Ob);if(q||r||v)p(d,Qb),p(d,u(Sb(q||"")));if(r||v)p(d,Qb),p(d,u(Sb(r||"")));v&&(p(d,Qb),p(d,u(Sb(v))));if(!t(d,Pb)){a.destination=null;e++;f.splice(0,e);return}}f.splice(0,e);var A=a.completedBoundaries;for(e=0;e<A.length;e++)if(!jd(a,b,A[e])){a.destination=null;e++;A.splice(0,e);return}A.splice(0,e);ba(b);l=new Uint8Array(512);n=0;var F=a.partialBoundaries;for(e=0;e<F.length;e++){var G=F[e];a:{f=a;g=b;var ma=G.completedSegments;for(h=0;h<ma.length;h++)if(!kd(f,
	g,G,ma[h])){h++;ma.splice(0,h);var Fb=!1;break a}ma.splice(0,h);Fb=!0}if(!Fb){a.destination=null;e++;F.splice(0,e);return}}F.splice(0,e);var na=a.completedBoundaries;for(e=0;e<na.length;e++)if(!jd(a,b,na[e])){a.destination=null;e++;na.splice(0,e);return}na.splice(0,e)}finally{ba(b),0===a.allPendingTasks&&0===a.pingedTasks.length&&0===a.clientRenderedBoundaries.length&&0===a.completedBoundaries.length&&b.close()}}
	function ld(a,b){try{var c=a.abortableTasks;c.forEach(function(c){return ed(c,a,b)});c.clear();null!==a.destination&&fd(a,a.destination)}catch(d){Y(a,d),Vc(a,d)}}
	exports.renderToReadableStream=function(a,b){return new Promise(function(c,d){var f,e,g=new Promise(function(a,b){e=a;f=b}),h=Rc(a,za(b?b.identifierPrefix:void 0,b?b.nonce:void 0,b?b.bootstrapScriptContent:void 0,b?b.bootstrapScripts:void 0,b?b.bootstrapModules:void 0),Aa(b?b.namespaceURI:void 0),b?b.progressiveChunkSize:void 0,b?b.onError:void 0,e,function(){var a=new ReadableStream({type:"bytes",pull:function(a){if(1===h.status)h.status=2,da(a,h.fatalError);else if(2!==h.status&&null===h.destination){h.destination=
	a;try{fd(h,a)}catch(A){Y(h,A),Vc(h,A)}}},cancel:function(){ld(h)}},{highWaterMark:0});a.allReady=g;c(a)},function(a){g.catch(function(){});d(a)},f);if(b&&b.signal){var m=b.signal,q=function(){ld(h,m.reason);m.removeEventListener("abort",q)};m.addEventListener("abort",q)}Uc(h)})};exports.version="18.2.0";


/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license React
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(2),ca=__webpack_require__(1275);function p(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var da=new Set,ea={};function fa(a,b){ha(a,b);ha(a+"Capture",b)}
	function ha(a,b){ea[a]=b;for(a=0;a<b.length;a++)da.add(b[a])}
	var ia=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ja=Object.prototype.hasOwnProperty,ka=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,la=
	{},ma={};function oa(a){if(ja.call(ma,a))return!0;if(ja.call(la,a))return!1;if(ka.test(a))return ma[a]=!0;la[a]=!0;return!1}function pa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function qa(a,b,c,d){if(null===b||"undefined"===typeof b||pa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g}var z={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){z[a]=new v(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];z[b]=new v(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){z[a]=new v(a,2,!1,a.toLowerCase(),null,!1,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){z[a]=new v(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){z[a]=new v(a,3,!1,a.toLowerCase(),null,!1,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){z[a]=new v(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){z[a]=new v(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){z[a]=new v(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){z[a]=new v(a,5,!1,a.toLowerCase(),null,!1,!1)});var ra=/[\-:]([a-z])/g;function sa(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(ra,
	sa);z[b]=new v(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(ra,sa);z[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(ra,sa);z[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){z[a]=new v(a,1,!1,a.toLowerCase(),null,!1,!1)});
	z.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){z[a]=new v(a,1,!1,a.toLowerCase(),null,!0,!0)});
	function ta(a,b,c,d){var e=z.hasOwnProperty(b)?z[b]:null;if(null!==e?0!==e.type:d||!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1])qa(b,c,e,d)&&(c=null),d||null===e?oa(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c)))}
	var ua=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,va=Symbol.for("react.element"),wa=Symbol.for("react.portal"),ya=Symbol.for("react.fragment"),za=Symbol.for("react.strict_mode"),Aa=Symbol.for("react.profiler"),Ba=Symbol.for("react.provider"),Ca=Symbol.for("react.context"),Da=Symbol.for("react.forward_ref"),Ea=Symbol.for("react.suspense"),Fa=Symbol.for("react.suspense_list"),Ga=Symbol.for("react.memo"),Ha=Symbol.for("react.lazy");Symbol.for("react.scope");Symbol.for("react.debug_trace_mode");
	var Ia=Symbol.for("react.offscreen");Symbol.for("react.legacy_hidden");Symbol.for("react.cache");Symbol.for("react.tracing_marker");var Ja=Symbol.iterator;function Ka(a){if(null===a||"object"!==typeof a)return null;a=Ja&&a[Ja]||a["@@iterator"];return"function"===typeof a?a:null}var A=Object.assign,La;function Ma(a){if(void 0===La)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);La=b&&b[1]||""}return"\n"+La+a}var Na=!1;
	function Oa(a,b){if(!a||Na)return"";Na=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[])}catch(l){var d=l}Reflect.construct(a,[],b)}else{try{b.call()}catch(l){d=l}a.call(b.prototype)}else{try{throw Error();}catch(l){d=l}a()}}catch(l){if(l&&d&&"string"===typeof l.stack){for(var e=l.stack.split("\n"),
	f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h]){var k="\n"+e[g].replace(" at new "," at ");a.displayName&&k.includes("<anonymous>")&&(k=k.replace("<anonymous>",a.displayName));return k}while(1<=g&&0<=h)}break}}}finally{Na=!1,Error.prepareStackTrace=c}return(a=a?a.displayName||a.name:"")?Ma(a):""}
	function Pa(a){switch(a.tag){case 5:return Ma(a.type);case 16:return Ma("Lazy");case 13:return Ma("Suspense");case 19:return Ma("SuspenseList");case 0:case 2:case 15:return a=Oa(a.type,!1),a;case 11:return a=Oa(a.type.render,!1),a;case 1:return a=Oa(a.type,!0),a;default:return""}}
	function Qa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ya:return"Fragment";case wa:return"Portal";case Aa:return"Profiler";case za:return"StrictMode";case Ea:return"Suspense";case Fa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ca:return(a.displayName||"Context")+".Consumer";case Ba:return(a._context.displayName||"Context")+".Provider";case Da:var b=a.render;a=a.displayName;a||(a=b.displayName||
	b.name||"",a=""!==a?"ForwardRef("+a+")":"ForwardRef");return a;case Ga:return b=a.displayName||null,null!==b?b:Qa(a.type)||"Memo";case Ha:b=a._payload;a=a._init;try{return Qa(a(b))}catch(c){}}return null}
	function Ra(a){var b=a.type;switch(a.tag){case 24:return"Cache";case 9:return(b.displayName||"Context")+".Consumer";case 10:return(b._context.displayName||"Context")+".Provider";case 18:return"DehydratedFragment";case 11:return a=b.render,a=a.displayName||a.name||"",b.displayName||(""!==a?"ForwardRef("+a+")":"ForwardRef");case 7:return"Fragment";case 5:return b;case 4:return"Portal";case 3:return"Root";case 6:return"Text";case 16:return Qa(b);case 8:return b===za?"StrictMode":"Mode";case 22:return"Offscreen";
	case 12:return"Profiler";case 21:return"Scope";case 13:return"Suspense";case 19:return"SuspenseList";case 25:return"TracingMarker";case 1:case 0:case 17:case 2:case 14:case 15:if("function"===typeof b)return b.displayName||b.name||null;if("string"===typeof b)return b}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "string":case "undefined":return a;case "object":return a;default:return""}}
	function Ta(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a))}function Wa(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
	function Ya(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function ab(a,b){b=b.checked;null!=b&&ta(a,"checked",b,!1)}
	function bb(a,b){ab(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?cb(a,b.type,c):b.hasOwnProperty("defaultValue")&&cb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function db(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function cb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var eb=Array.isArray;
	function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(p(91));return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(p(92));if(eb(c)){if(1<c.length)throw Error(p(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:Sa(c)}}
	function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}function kb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
	function lb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?kb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var mb,nb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if("http://www.w3.org/2000/svg"!==a.namespaceURI||"innerHTML"in a)a.innerHTML=b;else{mb=mb||document.createElement("div");mb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=mb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function ob(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var pb={animationIterationCount:!0,aspectRatio:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,
	zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},qb=["Webkit","ms","Moz","O"];Object.keys(pb).forEach(function(a){qb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);pb[b]=pb[a]})});function rb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||pb.hasOwnProperty(a)&&pb[a]?(""+b).trim():b+"px"}
	function sb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=rb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var tb=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function ub(a,b){if(b){if(tb[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(p(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(p(60));if("object"!==typeof b.dangerouslySetInnerHTML||!("__html"in b.dangerouslySetInnerHTML))throw Error(p(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(p(62));}}
	function vb(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var wb=null;function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
	function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(p(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b))}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a])}}function Gb(a,b){return a(b)}function Hb(){}var Ib=!1;function Jb(a,b,c){if(Ib)return a(b,c);Ib=!0;try{return Gb(a,b,c)}finally{if(Ib=!1,null!==zb||null!==Ab)Hb(),Fb()}}
	function Kb(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==
	typeof c)throw Error(p(231,b,typeof c));return c}var Lb=!1;if(ia)try{var Mb={};Object.defineProperty(Mb,"passive",{get:function(){Lb=!0}});window.addEventListener("test",Mb,Mb);window.removeEventListener("test",Mb,Mb)}catch(a){Lb=!1}function Nb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var Ob=!1,Pb=null,Qb=!1,Rb=null,Sb={onError:function(a){Ob=!0;Pb=a}};function Tb(a,b,c,d,e,f,g,h,k){Ob=!1;Pb=null;Nb.apply(Sb,arguments)}
	function Ub(a,b,c,d,e,f,g,h,k){Tb.apply(this,arguments);if(Ob){if(Ob){var l=Pb;Ob=!1;Pb=null}else throw Error(p(198));Qb||(Qb=!0,Rb=l)}}function Vb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.flags&4098)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function Wb(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function Xb(a){if(Vb(a)!==a)throw Error(p(188));}
	function Yb(a){var b=a.alternate;if(!b){b=Vb(a);if(null===b)throw Error(p(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return Xb(e),a;if(f===d)return Xb(e),b;f=f.sibling}throw Error(p(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(p(189));}}if(c.alternate!==d)throw Error(p(190));}if(3!==c.tag)throw Error(p(188));return c.stateNode.current===c?a:b}function Zb(a){a=Yb(a);return null!==a?$b(a):null}function $b(a){if(5===a.tag||6===a.tag)return a;for(a=a.child;null!==a;){var b=$b(a);if(null!==b)return b;a=a.sibling}return null}
	var ac=ca.unstable_scheduleCallback,bc=ca.unstable_cancelCallback,cc=ca.unstable_shouldYield,dc=ca.unstable_requestPaint,B=ca.unstable_now,ec=ca.unstable_getCurrentPriorityLevel,fc=ca.unstable_ImmediatePriority,gc=ca.unstable_UserBlockingPriority,hc=ca.unstable_NormalPriority,ic=ca.unstable_LowPriority,jc=ca.unstable_IdlePriority,kc=null,lc=null;function mc(a){if(lc&&"function"===typeof lc.onCommitFiberRoot)try{lc.onCommitFiberRoot(kc,a,void 0,128===(a.current.flags&128))}catch(b){}}
	var oc=Math.clz32?Math.clz32:nc,pc=Math.log,qc=Math.LN2;function nc(a){a>>>=0;return 0===a?32:31-(pc(a)/qc|0)|0}var rc=64,sc=4194304;
	function tc(a){switch(a&-a){case 1:return 1;case 2:return 2;case 4:return 4;case 8:return 8;case 16:return 16;case 32:return 32;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return a&4194240;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return a&130023424;case 134217728:return 134217728;case 268435456:return 268435456;case 536870912:return 536870912;case 1073741824:return 1073741824;
	default:return a}}function uc(a,b){var c=a.pendingLanes;if(0===c)return 0;var d=0,e=a.suspendedLanes,f=a.pingedLanes,g=c&268435455;if(0!==g){var h=g&~e;0!==h?d=tc(h):(f&=g,0!==f&&(d=tc(f)))}else g=c&~e,0!==g?d=tc(g):0!==f&&(d=tc(f));if(0===d)return 0;if(0!==b&&b!==d&&0===(b&e)&&(e=d&-d,f=b&-b,e>=f||16===e&&0!==(f&4194240)))return b;0!==(d&4)&&(d|=c&16);b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-oc(b),e=1<<c,d|=a[c],b&=~e;return d}
	function vc(a,b){switch(a){case 1:case 2:case 4:return b+250;case 8:case 16:case 32:case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return b+5E3;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return-1;case 134217728:case 268435456:case 536870912:case 1073741824:return-1;default:return-1}}
	function wc(a,b){for(var c=a.suspendedLanes,d=a.pingedLanes,e=a.expirationTimes,f=a.pendingLanes;0<f;){var g=31-oc(f),h=1<<g,k=e[g];if(-1===k){if(0===(h&c)||0!==(h&d))e[g]=vc(h,b)}else k<=b&&(a.expiredLanes|=h);f&=~h}}function xc(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function yc(){var a=rc;rc<<=1;0===(rc&4194240)&&(rc=64);return a}function zc(a){for(var b=[],c=0;31>c;c++)b.push(a);return b}
	function Ac(a,b,c){a.pendingLanes|=b;536870912!==b&&(a.suspendedLanes=0,a.pingedLanes=0);a=a.eventTimes;b=31-oc(b);a[b]=c}function Bc(a,b){var c=a.pendingLanes&~b;a.pendingLanes=b;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=b;a.mutableReadLanes&=b;a.entangledLanes&=b;b=a.entanglements;var d=a.eventTimes;for(a=a.expirationTimes;0<c;){var e=31-oc(c),f=1<<e;b[e]=0;d[e]=-1;a[e]=-1;c&=~f}}
	function Cc(a,b){var c=a.entangledLanes|=b;for(a=a.entanglements;c;){var d=31-oc(c),e=1<<d;e&b|a[d]&b&&(a[d]|=b);c&=~e}}var C=0;function Dc(a){a&=-a;return 1<a?4<a?0!==(a&268435455)?16:536870912:4:1}var Ec,Fc,Gc,Hc,Ic,Jc=!1,Kc=[],Lc=null,Mc=null,Nc=null,Oc=new Map,Pc=new Map,Qc=[],Rc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
	function Sc(a,b){switch(a){case "focusin":case "focusout":Lc=null;break;case "dragenter":case "dragleave":Mc=null;break;case "mouseover":case "mouseout":Nc=null;break;case "pointerover":case "pointerout":Oc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Pc.delete(b.pointerId)}}
	function Tc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a={blockedOn:b,domEventName:c,eventSystemFlags:d,nativeEvent:f,targetContainers:[e]},null!==b&&(b=Cb(b),null!==b&&Fc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
	function Uc(a,b,c,d,e){switch(b){case "focusin":return Lc=Tc(Lc,a,b,c,d,e),!0;case "dragenter":return Mc=Tc(Mc,a,b,c,d,e),!0;case "mouseover":return Nc=Tc(Nc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Oc.set(f,Tc(Oc.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Pc.set(f,Tc(Pc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Vc(a){var b=Wc(a.target);if(null!==b){var c=Vb(b);if(null!==c)if(b=c.tag,13===b){if(b=Wb(c),null!==b){a.blockedOn=b;Ic(a.priority,function(){Gc(c)});return}}else if(3===b&&c.stateNode.current.memoizedState.isDehydrated){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}
	function Xc(a){if(null!==a.blockedOn)return!1;for(var b=a.targetContainers;0<b.length;){var c=Yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null===c){c=a.nativeEvent;var d=new c.constructor(c.type,c);wb=d;c.target.dispatchEvent(d);wb=null}else return b=Cb(c),null!==b&&Fc(b),a.blockedOn=c,!1;b.shift()}return!0}function Zc(a,b,c){Xc(a)&&c.delete(b)}function $c(){Jc=!1;null!==Lc&&Xc(Lc)&&(Lc=null);null!==Mc&&Xc(Mc)&&(Mc=null);null!==Nc&&Xc(Nc)&&(Nc=null);Oc.forEach(Zc);Pc.forEach(Zc)}
	function ad(a,b){a.blockedOn===b&&(a.blockedOn=null,Jc||(Jc=!0,ca.unstable_scheduleCallback(ca.unstable_NormalPriority,$c)))}
	function bd(a){function b(b){return ad(b,a)}if(0<Kc.length){ad(Kc[0],a);for(var c=1;c<Kc.length;c++){var d=Kc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Lc&&ad(Lc,a);null!==Mc&&ad(Mc,a);null!==Nc&&ad(Nc,a);Oc.forEach(b);Pc.forEach(b);for(c=0;c<Qc.length;c++)d=Qc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Qc.length&&(c=Qc[0],null===c.blockedOn);)Vc(c),null===c.blockedOn&&Qc.shift()}var cd=ua.ReactCurrentBatchConfig,dd=!0;
	function ed(a,b,c,d){var e=C,f=cd.transition;cd.transition=null;try{C=1,fd(a,b,c,d)}finally{C=e,cd.transition=f}}function gd(a,b,c,d){var e=C,f=cd.transition;cd.transition=null;try{C=4,fd(a,b,c,d)}finally{C=e,cd.transition=f}}
	function fd(a,b,c,d){if(dd){var e=Yc(a,b,c,d);if(null===e)hd(a,b,d,id,c),Sc(a,d);else if(Uc(e,a,b,c,d))d.stopPropagation();else if(Sc(a,d),b&4&&-1<Rc.indexOf(a)){for(;null!==e;){var f=Cb(e);null!==f&&Ec(f);f=Yc(a,b,c,d);null===f&&hd(a,b,d,id,c);if(f===e)break;e=f}null!==e&&d.stopPropagation()}else hd(a,b,d,null,c)}}var id=null;
	function Yc(a,b,c,d){id=null;a=xb(d);a=Wc(a);if(null!==a)if(b=Vb(a),null===b)a=null;else if(c=b.tag,13===c){a=Wb(b);if(null!==a)return a;a=null}else if(3===c){if(b.stateNode.current.memoizedState.isDehydrated)return 3===b.tag?b.stateNode.containerInfo:null;a=null}else b!==a&&(a=null);id=a;return null}
	function jd(a){switch(a){case "cancel":case "click":case "close":case "contextmenu":case "copy":case "cut":case "auxclick":case "dblclick":case "dragend":case "dragstart":case "drop":case "focusin":case "focusout":case "input":case "invalid":case "keydown":case "keypress":case "keyup":case "mousedown":case "mouseup":case "paste":case "pause":case "play":case "pointercancel":case "pointerdown":case "pointerup":case "ratechange":case "reset":case "resize":case "seeked":case "submit":case "touchcancel":case "touchend":case "touchstart":case "volumechange":case "change":case "selectionchange":case "textInput":case "compositionstart":case "compositionend":case "compositionupdate":case "beforeblur":case "afterblur":case "beforeinput":case "blur":case "fullscreenchange":case "focus":case "hashchange":case "popstate":case "select":case "selectstart":return 1;case "drag":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "mousemove":case "mouseout":case "mouseover":case "pointermove":case "pointerout":case "pointerover":case "scroll":case "toggle":case "touchmove":case "wheel":case "mouseenter":case "mouseleave":case "pointerenter":case "pointerleave":return 4;
	case "message":switch(ec()){case fc:return 1;case gc:return 4;case hc:case ic:return 16;case jc:return 536870912;default:return 16}default:return 16}}var kd=null,ld=null,md=null;function nd(){if(md)return md;var a,b=ld,c=b.length,d,e="value"in kd?kd.value:kd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return md=e.slice(a,1<d?1-d:void 0)}
	function od(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function pd(){return!0}function qd(){return!1}
	function rd(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?pd:qd;this.isPropagationStopped=qd;return this}A(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
	(a.returnValue=!1),this.isDefaultPrevented=pd)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=pd)},persist:function(){},isPersistent:pd});return b}
	var sd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},td=rd(sd),ud=A({},sd,{view:0,detail:0}),vd=rd(ud),wd,xd,yd,Ad=A({},ud,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
	a)return a.movementX;a!==yd&&(yd&&"mousemove"===a.type?(wd=a.screenX-yd.screenX,xd=a.screenY-yd.screenY):xd=wd=0,yd=a);return wd},movementY:function(a){return"movementY"in a?a.movementY:xd}}),Bd=rd(Ad),Cd=A({},Ad,{dataTransfer:0}),Dd=rd(Cd),Ed=A({},ud,{relatedTarget:0}),Fd=rd(Ed),Gd=A({},sd,{animationName:0,elapsedTime:0,pseudoElement:0}),Hd=rd(Gd),Id=A({},sd,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Jd=rd(Id),Kd=A({},sd,{data:0}),Ld=rd(Kd),Md={Esc:"Escape",
	Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
	119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Od={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Od[a])?!!b[a]:!1}function zd(){return Pd}
	var Qd=A({},ud,{key:function(a){if(a.key){var b=Md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=od(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Nd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(a){return"keypress"===a.type?od(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
	a.type?od(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=rd(Qd),Sd=A({},Ad,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Td=rd(Sd),Ud=A({},ud,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd}),Vd=rd(Ud),Wd=A({},sd,{propertyName:0,elapsedTime:0,pseudoElement:0}),Xd=rd(Wd),Yd=A({},Ad,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
	deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),Zd=rd(Yd),$d=[9,13,27,32],ae=ia&&"CompositionEvent"in window,be=null;ia&&"documentMode"in document&&(be=document.documentMode);var ce=ia&&"TextEvent"in window&&!be,de=ia&&(!ae||be&&8<be&&11>=be),ee=String.fromCharCode(32),fe=!1;
	function ge(a,b){switch(a){case "keyup":return-1!==$d.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return!0;default:return!1}}function he(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var ie=!1;function je(a,b){switch(a){case "compositionend":return he(b);case "keypress":if(32!==b.which)return null;fe=!0;return ee;case "textInput":return a=b.data,a===ee&&fe?null:a;default:return null}}
	function ke(a,b){if(ie)return"compositionend"===a||!ae&&ge(a,b)?(a=nd(),md=ld=kd=null,ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return de&&"ko"!==b.locale?null:b.data;default:return null}}
	var le={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!le[a.type]:"textarea"===b?!0:!1}function ne(a,b,c,d){Eb(d);b=oe(b,"onChange");0<b.length&&(c=new td("onChange","change",null,c,d),a.push({event:c,listeners:b}))}var pe=null,qe=null;function re(a){se(a,0)}function te(a){var b=ue(a);if(Wa(b))return a}
	function ve(a,b){if("change"===a)return b}var we=!1;if(ia){var xe;if(ia){var ye="oninput"in document;if(!ye){var ze=document.createElement("div");ze.setAttribute("oninput","return;");ye="function"===typeof ze.oninput}xe=ye}else xe=!1;we=xe&&(!document.documentMode||9<document.documentMode)}function Ae(){pe&&(pe.detachEvent("onpropertychange",Be),qe=pe=null)}function Be(a){if("value"===a.propertyName&&te(qe)){var b=[];ne(b,qe,a,xb(a));Jb(re,b)}}
	function Ce(a,b,c){"focusin"===a?(Ae(),pe=b,qe=c,pe.attachEvent("onpropertychange",Be)):"focusout"===a&&Ae()}function De(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return te(qe)}function Ee(a,b){if("click"===a)return te(b)}function Fe(a,b){if("input"===a||"change"===a)return te(b)}function Ge(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var He="function"===typeof Object.is?Object.is:Ge;
	function Ie(a,b){if(He(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++){var e=c[d];if(!ja.call(b,e)||!He(a[e],b[e]))return!1}return!0}function Je(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Ke(a,b){var c=Je(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Je(c)}}function Le(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Le(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function Me(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xa(a.document)}return b}function Ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	function Oe(a){var b=Me(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Le(c.ownerDocument.documentElement,c)){if(null!==d&&Ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ke(c,f);var g=Ke(c,
	d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
	var Pe=ia&&"documentMode"in document&&11>=document.documentMode,Qe=null,Re=null,Se=null,Te=!1;
	function Ue(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;Te||null==Qe||Qe!==Xa(d)||(d=Qe,"selectionStart"in d&&Ne(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Se&&Ie(Se,d)||(Se=d,d=oe(Re,"onSelect"),0<d.length&&(b=new td("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Qe)))}
	function Ve(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var We={animationend:Ve("Animation","AnimationEnd"),animationiteration:Ve("Animation","AnimationIteration"),animationstart:Ve("Animation","AnimationStart"),transitionend:Ve("Transition","TransitionEnd")},Xe={},Ye={};
	ia&&(Ye=document.createElement("div").style,"AnimationEvent"in window||(delete We.animationend.animation,delete We.animationiteration.animation,delete We.animationstart.animation),"TransitionEvent"in window||delete We.transitionend.transition);function Ze(a){if(Xe[a])return Xe[a];if(!We[a])return a;var b=We[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Ye)return Xe[a]=b[c];return a}var $e=Ze("animationend"),af=Ze("animationiteration"),bf=Ze("animationstart"),cf=Ze("transitionend"),df=new Map,ef="abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
	function ff(a,b){df.set(a,b);fa(b,[a])}for(var gf=0;gf<ef.length;gf++){var hf=ef[gf],jf=hf.toLowerCase(),kf=hf[0].toUpperCase()+hf.slice(1);ff(jf,"on"+kf)}ff($e,"onAnimationEnd");ff(af,"onAnimationIteration");ff(bf,"onAnimationStart");ff("dblclick","onDoubleClick");ff("focusin","onFocus");ff("focusout","onBlur");ff(cf,"onTransitionEnd");ha("onMouseEnter",["mouseout","mouseover"]);ha("onMouseLeave",["mouseout","mouseover"]);ha("onPointerEnter",["pointerout","pointerover"]);
	ha("onPointerLeave",["pointerout","pointerover"]);fa("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));fa("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));fa("onBeforeInput",["compositionend","keypress","textInput","paste"]);fa("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));fa("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));
	fa("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var lf="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),mf=new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
	function nf(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Ub(d,b,void 0,a);a.currentTarget=null}
	function se(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;nf(e,h,l);f=k}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;nf(e,h,l);f=k}}}if(Qb)throw a=Rb,Qb=!1,Rb=null,a;}
	function D(a,b){var c=b[of];void 0===c&&(c=b[of]=new Set);var d=a+"__bubble";c.has(d)||(pf(b,a,2,!1),c.add(d))}function qf(a,b,c){var d=0;b&&(d|=4);pf(c,a,d,b)}var rf="_reactListening"+Math.random().toString(36).slice(2);function sf(a){if(!a[rf]){a[rf]=!0;da.forEach(function(b){"selectionchange"!==b&&(mf.has(b)||qf(b,!1,a),qf(b,!0,a))});var b=9===a.nodeType?a:a.ownerDocument;null===b||b[rf]||(b[rf]=!0,qf("selectionchange",!1,b))}}
	function pf(a,b,c,d){switch(jd(b)){case 1:var e=ed;break;case 4:e=gd;break;default:e=fd}c=e.bind(null,b,c,a);e=void 0;!Lb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1)}
	function hd(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return}for(;null!==h;){g=Wc(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode}}d=d.return}Jb(function(){var d=f,e=xb(c),g=[];
	a:{var h=df.get(a);if(void 0!==h){var k=td,n=a;switch(a){case "keypress":if(0===od(c))break a;case "keydown":case "keyup":k=Rd;break;case "focusin":n="focus";k=Fd;break;case "focusout":n="blur";k=Fd;break;case "beforeblur":case "afterblur":k=Fd;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
	Dd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Vd;break;case $e:case af:case bf:k=Hd;break;case cf:k=Xd;break;case "scroll":k=vd;break;case "wheel":k=Zd;break;case "copy":case "cut":case "paste":k=Jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Td}var t=0!==(b&4),J=!t&&"scroll"===a,x=t?null!==h?h+"Capture":null:h;t=[];for(var w=d,u;null!==
	w;){u=w;var F=u.stateNode;5===u.tag&&null!==F&&(u=F,null!==x&&(F=Kb(w,x),null!=F&&t.push(tf(w,F,u))));if(J)break;w=w.return}0<t.length&&(h=new k(h,n,null,c,e),g.push({event:h,listeners:t}))}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&c!==wb&&(n=c.relatedTarget||c.fromElement)&&(Wc(n)||n[uf]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(n=c.relatedTarget||c.toElement,k=d,n=n?Wc(n):null,null!==
	n&&(J=Vb(n),n!==J||5!==n.tag&&6!==n.tag))n=null}else k=null,n=d;if(k!==n){t=Bd;F="onMouseLeave";x="onMouseEnter";w="mouse";if("pointerout"===a||"pointerover"===a)t=Td,F="onPointerLeave",x="onPointerEnter",w="pointer";J=null==k?h:ue(k);u=null==n?h:ue(n);h=new t(F,w+"leave",k,c,e);h.target=J;h.relatedTarget=u;F=null;Wc(e)===d&&(t=new t(x,w+"enter",n,c,e),t.target=u,t.relatedTarget=J,F=t);J=F;if(k&&n)b:{t=k;x=n;w=0;for(u=t;u;u=vf(u))w++;u=0;for(F=x;F;F=vf(F))u++;for(;0<w-u;)t=vf(t),w--;for(;0<u-w;)x=
	vf(x),u--;for(;w--;){if(t===x||null!==x&&t===x.alternate)break b;t=vf(t);x=vf(x)}t=null}else t=null;null!==k&&wf(g,h,k,t,!1);null!==n&&null!==J&&wf(g,J,n,t,!0)}}}a:{h=d?ue(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var na=ve;else if(me(h))if(we)na=Fe;else{na=De;var xa=Ce}else(k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(na=Ee);if(na&&(na=na(a,d))){ne(g,na,c,e);break a}xa&&xa(a,h,d);"focusout"===a&&(xa=h._wrapperState)&&
	xa.controlled&&"number"===h.type&&cb(h,"number",h.value)}xa=d?ue(d):window;switch(a){case "focusin":if(me(xa)||"true"===xa.contentEditable)Qe=xa,Re=d,Se=null;break;case "focusout":Se=Re=Qe=null;break;case "mousedown":Te=!0;break;case "contextmenu":case "mouseup":case "dragend":Te=!1;Ue(g,c,e);break;case "selectionchange":if(Pe)break;case "keydown":case "keyup":Ue(g,c,e)}var $a;if(ae)b:{switch(a){case "compositionstart":var ba="onCompositionStart";break b;case "compositionend":ba="onCompositionEnd";
	break b;case "compositionupdate":ba="onCompositionUpdate";break b}ba=void 0}else ie?ge(a,c)&&(ba="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(ba="onCompositionStart");ba&&(de&&"ko"!==c.locale&&(ie||"onCompositionStart"!==ba?"onCompositionEnd"===ba&&ie&&($a=nd()):(kd=e,ld="value"in kd?kd.value:kd.textContent,ie=!0)),xa=oe(d,ba),0<xa.length&&(ba=new Ld(ba,a,null,c,e),g.push({event:ba,listeners:xa}),$a?ba.data=$a:($a=he(c),null!==$a&&(ba.data=$a))));if($a=ce?je(a,c):ke(a,c))d=oe(d,"onBeforeInput"),
	0<d.length&&(e=new Ld("onBeforeInput","beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=$a)}se(g,b)})}function tf(a,b,c){return{instance:a,listener:b,currentTarget:c}}function oe(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Kb(a,c),null!=f&&d.unshift(tf(a,f,e)),f=Kb(a,b),null!=f&&d.push(tf(a,f,e)));a=a.return}return d}function vf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function wf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Kb(c,f),null!=k&&g.unshift(tf(c,k,h))):e||(k=Kb(c,f),null!=k&&g.push(tf(c,k,h))));c=c.return}0!==g.length&&a.push({event:b,listeners:g})}var xf=/\r\n?/g,yf=/\u0000|\uFFFD/g;function zf(a){return("string"===typeof a?a:""+a).replace(xf,"\n").replace(yf,"")}function Af(a,b,c){b=zf(b);if(zf(a)!==b&&c)throw Error(p(425));}function Bf(){}
	var Cf=null,Df=null;function Ef(a,b){return"textarea"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
	var Ff="function"===typeof setTimeout?setTimeout:void 0,Gf="function"===typeof clearTimeout?clearTimeout:void 0,Hf="function"===typeof Promise?Promise:void 0,Jf="function"===typeof queueMicrotask?queueMicrotask:"undefined"!==typeof Hf?function(a){return Hf.resolve(null).then(a).catch(If)}:Ff;function If(a){setTimeout(function(){throw a;})}
	function Kf(a,b){var c=b,d=0;do{var e=c.nextSibling;a.removeChild(c);if(e&&8===e.nodeType)if(c=e.data,"/$"===c){if(0===d){a.removeChild(e);bd(b);return}d--}else"$"!==c&&"$?"!==c&&"$!"!==c||d++;c=e}while(c);bd(b)}function Lf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break;if(8===b){b=a.data;if("$"===b||"$!"===b||"$?"===b)break;if("/$"===b)return null}}return a}
	function Mf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--}else"/$"===c&&b++}a=a.previousSibling}return null}var Nf=Math.random().toString(36).slice(2),Of="__reactFiber$"+Nf,Pf="__reactProps$"+Nf,uf="__reactContainer$"+Nf,of="__reactEvents$"+Nf,Qf="__reactListeners$"+Nf,Rf="__reactHandles$"+Nf;
	function Wc(a){var b=a[Of];if(b)return b;for(var c=a.parentNode;c;){if(b=c[uf]||c[Of]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Mf(a);null!==a;){if(c=a[Of])return c;a=Mf(a)}return b}a=c;c=a.parentNode}return null}function Cb(a){a=a[Of]||a[uf];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function ue(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(p(33));}function Db(a){return a[Pf]||null}var Sf=[],Tf=-1;function Uf(a){return{current:a}}
	function E(a){0>Tf||(a.current=Sf[Tf],Sf[Tf]=null,Tf--)}function G(a,b){Tf++;Sf[Tf]=a.current;a.current=b}var Vf={},H=Uf(Vf),Wf=Uf(!1),Xf=Vf;function Yf(a,b){var c=a.type.contextTypes;if(!c)return Vf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}
	function Zf(a){a=a.childContextTypes;return null!==a&&void 0!==a}function $f(){E(Wf);E(H)}function ag(a,b,c){if(H.current!==Vf)throw Error(p(168));G(H,b);G(Wf,c)}function bg(a,b,c){var d=a.stateNode;b=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in b))throw Error(p(108,Ra(a)||"Unknown",e));return A({},c,d)}
	function cg(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Vf;Xf=H.current;G(H,a);G(Wf,Wf.current);return!0}function dg(a,b,c){var d=a.stateNode;if(!d)throw Error(p(169));c?(a=bg(a,b,Xf),d.__reactInternalMemoizedMergedChildContext=a,E(Wf),E(H),G(H,a)):E(Wf);G(Wf,c)}var eg=null,fg=!1,gg=!1;function hg(a){null===eg?eg=[a]:eg.push(a)}function ig(a){fg=!0;hg(a)}
	function jg(){if(!gg&&null!==eg){gg=!0;var a=0,b=C;try{var c=eg;for(C=1;a<c.length;a++){var d=c[a];do d=d(!0);while(null!==d)}eg=null;fg=!1}catch(e){throw null!==eg&&(eg=eg.slice(a+1)),ac(fc,jg),e;}finally{C=b,gg=!1}}return null}var kg=[],lg=0,mg=null,ng=0,og=[],pg=0,qg=null,rg=1,sg="";function tg(a,b){kg[lg++]=ng;kg[lg++]=mg;mg=a;ng=b}
	function ug(a,b,c){og[pg++]=rg;og[pg++]=sg;og[pg++]=qg;qg=a;var d=rg;a=sg;var e=32-oc(d)-1;d&=~(1<<e);c+=1;var f=32-oc(b)+e;if(30<f){var g=e-e%5;f=(d&(1<<g)-1).toString(32);d>>=g;e-=g;rg=1<<32-oc(b)+e|c<<e|d;sg=f+a}else rg=1<<f|c<<e|d,sg=a}function vg(a){null!==a.return&&(tg(a,1),ug(a,1,0))}function wg(a){for(;a===mg;)mg=kg[--lg],kg[lg]=null,ng=kg[--lg],kg[lg]=null;for(;a===qg;)qg=og[--pg],og[pg]=null,sg=og[--pg],og[pg]=null,rg=og[--pg],og[pg]=null}var xg=null,yg=null,I=!1,zg=null;
	function Ag(a,b){var c=Bg(5,null,null,0);c.elementType="DELETED";c.stateNode=b;c.return=a;b=a.deletions;null===b?(a.deletions=[c],a.flags|=16):b.push(c)}
	function Cg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,xg=a,yg=Lf(b.firstChild),!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,xg=a,yg=null,!0):!1;case 13:return b=8!==b.nodeType?null:b,null!==b?(c=null!==qg?{id:rg,overflow:sg}:null,a.memoizedState={dehydrated:b,treeContext:c,retryLane:1073741824},c=Bg(18,null,null,0),c.stateNode=b,c.return=a,a.child=c,xg=a,yg=
	null,!0):!1;default:return!1}}function Dg(a){return 0!==(a.mode&1)&&0===(a.flags&128)}function Eg(a){if(I){var b=yg;if(b){var c=b;if(!Cg(a,b)){if(Dg(a))throw Error(p(418));b=Lf(c.nextSibling);var d=xg;b&&Cg(a,b)?Ag(d,c):(a.flags=a.flags&-4097|2,I=!1,xg=a)}}else{if(Dg(a))throw Error(p(418));a.flags=a.flags&-4097|2;I=!1;xg=a}}}function Fg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;xg=a}
	function Gg(a){if(a!==xg)return!1;if(!I)return Fg(a),I=!0,!1;var b;(b=3!==a.tag)&&!(b=5!==a.tag)&&(b=a.type,b="head"!==b&&"body"!==b&&!Ef(a.type,a.memoizedProps));if(b&&(b=yg)){if(Dg(a))throw Hg(),Error(p(418));for(;b;)Ag(a,b),b=Lf(b.nextSibling)}Fg(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(p(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){yg=Lf(a.nextSibling);break a}b--}else"$"!==c&&"$!"!==c&&"$?"!==c||b++}a=a.nextSibling}yg=
	null}}else yg=xg?Lf(a.stateNode.nextSibling):null;return!0}function Hg(){for(var a=yg;a;)a=Lf(a.nextSibling)}function Ig(){yg=xg=null;I=!1}function Jg(a){null===zg?zg=[a]:zg.push(a)}var Kg=ua.ReactCurrentBatchConfig;function Lg(a,b){if(a&&a.defaultProps){b=A({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}var Mg=Uf(null),Ng=null,Og=null,Pg=null;function Qg(){Pg=Og=Ng=null}function Rg(a){var b=Mg.current;E(Mg);a._currentValue=b}
	function Sg(a,b,c){for(;null!==a;){var d=a.alternate;(a.childLanes&b)!==b?(a.childLanes|=b,null!==d&&(d.childLanes|=b)):null!==d&&(d.childLanes&b)!==b&&(d.childLanes|=b);if(a===c)break;a=a.return}}function Tg(a,b){Ng=a;Pg=Og=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(Ug=!0),a.firstContext=null)}
	function Vg(a){var b=a._currentValue;if(Pg!==a)if(a={context:a,memoizedValue:b,next:null},null===Og){if(null===Ng)throw Error(p(308));Og=a;Ng.dependencies={lanes:0,firstContext:a}}else Og=Og.next=a;return b}var Wg=null;function Xg(a){null===Wg?Wg=[a]:Wg.push(a)}function Yg(a,b,c,d){var e=b.interleaved;null===e?(c.next=c,Xg(b)):(c.next=e.next,e.next=c);b.interleaved=c;return Zg(a,d)}
	function Zg(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}var $g=!1;function ah(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null,interleaved:null,lanes:0},effects:null}}
	function bh(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects})}function ch(a,b){return{eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}
	function dh(a,b,c){var d=a.updateQueue;if(null===d)return null;d=d.shared;if(0!==(K&2)){var e=d.pending;null===e?b.next=b:(b.next=e.next,e.next=b);d.pending=b;return Zg(a,c)}e=d.interleaved;null===e?(b.next=b,Xg(d)):(b.next=e.next,e.next=b);d.interleaved=b;return Zg(a,c)}function eh(a,b,c){b=b.updateQueue;if(null!==b&&(b=b.shared,0!==(c&4194240))){var d=b.lanes;d&=a.pendingLanes;c|=d;b.lanes=c;Cc(a,c)}}
	function fh(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next}while(null!==c);null===f?e=f=b:f=f.next=b}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
	b;c.lastBaseUpdate=b}
	function gh(a,b,c,d){var e=a.updateQueue;$g=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var m=a.alternate;null!==m&&(m=m.updateQueue,h=m.lastBaseUpdate,h!==g&&(null===h?m.firstBaseUpdate=l:h.next=l,m.lastBaseUpdate=k))}if(null!==f){var q=e.baseState;g=0;m=l=k=null;h=f;do{var r=h.lane,y=h.eventTime;if((d&r)===r){null!==m&&(m=m.next={eventTime:y,lane:0,tag:h.tag,payload:h.payload,callback:h.callback,
	next:null});a:{var n=a,t=h;r=b;y=c;switch(t.tag){case 1:n=t.payload;if("function"===typeof n){q=n.call(y,q,r);break a}q=n;break a;case 3:n.flags=n.flags&-65537|128;case 0:n=t.payload;r="function"===typeof n?n.call(y,q,r):n;if(null===r||void 0===r)break a;q=A({},q,r);break a;case 2:$g=!0}}null!==h.callback&&0!==h.lane&&(a.flags|=64,r=e.effects,null===r?e.effects=[h]:r.push(h))}else y={eventTime:y,lane:r,tag:h.tag,payload:h.payload,callback:h.callback,next:null},null===m?(l=m=y,k=q):m=m.next=y,g|=r;
	h=h.next;if(null===h)if(h=e.shared.pending,null===h)break;else r=h,h=r.next,r.next=null,e.lastBaseUpdate=r,e.shared.pending=null}while(1);null===m&&(k=q);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=m;b=e.shared.interleaved;if(null!==b){e=b;do g|=e.lane,e=e.next;while(e!==b)}else null===f&&(e.shared.lanes=0);hh|=g;a.lanes=g;a.memoizedState=q}}
	function ih(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(p(191,e));e.call(d)}}}var jh=(new aa.Component).refs;function kh(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:A({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c)}
	var nh={isMounted:function(a){return(a=a._reactInternals)?Vb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=L(),e=lh(a),f=ch(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);b=dh(a,f,e);null!==b&&(mh(b,a,e,d),eh(b,a,e))},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=L(),e=lh(a),f=ch(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);b=dh(a,f,e);null!==b&&(mh(b,a,e,d),eh(b,a,e))},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=L(),d=
	lh(a),e=ch(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=b);b=dh(a,e,d);null!==b&&(mh(b,a,d,c),eh(b,a,d))}};function oh(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Ie(c,d)||!Ie(e,f):!0}
	function ph(a,b,c){var d=!1,e=Vf;var f=b.contextType;"object"===typeof f&&null!==f?f=Vg(f):(e=Zf(b)?Xf:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Yf(a,e):Vf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=nh;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function qh(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&nh.enqueueReplaceState(b,b.state,null)}
	function rh(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jh;ah(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=Vg(f):(f=Zf(b)?Xf:H.current,e.context=Yf(a,f));e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(kh(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(b=e.state,
	"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&nh.enqueueReplaceState(e,e.state,null),gh(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4194308)}
	function sh(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(p(309));var d=c.stateNode}if(!d)throw Error(p(147,a));var e=d,f=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===f)return b.ref;b=function(a){var b=e.refs;b===jh&&(b=e.refs={});null===a?delete b[f]:b[f]=a};b._stringRef=f;return b}if("string"!==typeof a)throw Error(p(284));if(!c._owner)throw Error(p(290,a));}return a}
	function th(a,b){a=Object.prototype.toString.call(b);throw Error(p(31,"[object Object]"===a?"object with keys {"+Object.keys(b).join(", ")+"}":a));}function uh(a){var b=a._init;return b(a._payload)}
	function vh(a){function b(b,c){if(a){var d=b.deletions;null===d?(b.deletions=[c],b.flags|=16):d.push(c)}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=wh(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return b.flags|=1048576,c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags|=2,c):d;b.flags|=2;return c}function g(b){a&&
	null===b.alternate&&(b.flags|=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=xh(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){var f=c.type;if(f===ya)return m(a,b,c.props.children,d,c.key);if(null!==b&&(b.elementType===f||"object"===typeof f&&null!==f&&f.$$typeof===Ha&&uh(f)===b.type))return d=e(b,c.props),d.ref=sh(a,b,c),d.return=a,d;d=yh(c.type,c.key,c.props,null,a.mode,d);d.ref=sh(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||
	b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=zh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ah(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function q(a,b,c){if("string"===typeof b&&""!==b||"number"===typeof b)return b=xh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case va:return c=yh(b.type,b.key,b.props,null,a.mode,c),
	c.ref=sh(a,null,b),c.return=a,c;case wa:return b=zh(b,a.mode,c),b.return=a,b;case Ha:var d=b._init;return q(a,d(b._payload),c)}if(eb(b)||Ka(b))return b=Ah(b,a.mode,c,null),b.return=a,b;th(a,b)}return null}function r(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c&&""!==c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case va:return c.key===e?k(a,b,c,d):null;case wa:return c.key===e?l(a,b,c,d):null;case Ha:return e=c._init,r(a,
	b,e(c._payload),d)}if(eb(c)||Ka(c))return null!==e?null:m(a,b,c,d,null);th(a,c)}return null}function y(a,b,c,d,e){if("string"===typeof d&&""!==d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case va:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e);case wa:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e);case Ha:var f=d._init;return y(a,b,c,f(d._payload),e)}if(eb(d)||Ka(d))return a=a.get(c)||null,m(b,a,d,e,null);th(b,d)}return null}
	function n(e,g,h,k){for(var l=null,m=null,u=g,w=g=0,x=null;null!==u&&w<h.length;w++){u.index>w?(x=u,u=null):x=u.sibling;var n=r(e,u,h[w],k);if(null===n){null===u&&(u=x);break}a&&u&&null===n.alternate&&b(e,u);g=f(n,g,w);null===m?l=n:m.sibling=n;m=n;u=x}if(w===h.length)return c(e,u),I&&tg(e,w),l;if(null===u){for(;w<h.length;w++)u=q(e,h[w],k),null!==u&&(g=f(u,g,w),null===m?l=u:m.sibling=u,m=u);I&&tg(e,w);return l}for(u=d(e,u);w<h.length;w++)x=y(u,e,w,h[w],k),null!==x&&(a&&null!==x.alternate&&u.delete(null===
	x.key?w:x.key),g=f(x,g,w),null===m?l=x:m.sibling=x,m=x);a&&u.forEach(function(a){return b(e,a)});I&&tg(e,w);return l}function t(e,g,h,k){var l=Ka(h);if("function"!==typeof l)throw Error(p(150));h=l.call(h);if(null==h)throw Error(p(151));for(var u=l=null,m=g,w=g=0,x=null,n=h.next();null!==m&&!n.done;w++,n=h.next()){m.index>w?(x=m,m=null):x=m.sibling;var t=r(e,m,n.value,k);if(null===t){null===m&&(m=x);break}a&&m&&null===t.alternate&&b(e,m);g=f(t,g,w);null===u?l=t:u.sibling=t;u=t;m=x}if(n.done)return c(e,
	m),I&&tg(e,w),l;if(null===m){for(;!n.done;w++,n=h.next())n=q(e,n.value,k),null!==n&&(g=f(n,g,w),null===u?l=n:u.sibling=n,u=n);I&&tg(e,w);return l}for(m=d(e,m);!n.done;w++,n=h.next())n=y(m,e,w,n.value,k),null!==n&&(a&&null!==n.alternate&&m.delete(null===n.key?w:n.key),g=f(n,g,w),null===u?l=n:u.sibling=n,u=n);a&&m.forEach(function(a){return b(e,a)});I&&tg(e,w);return l}function J(a,d,f,h){"object"===typeof f&&null!==f&&f.type===ya&&null===f.key&&(f=f.props.children);if("object"===typeof f&&null!==f){switch(f.$$typeof){case va:a:{for(var k=
	f.key,l=d;null!==l;){if(l.key===k){k=f.type;if(k===ya){if(7===l.tag){c(a,l.sibling);d=e(l,f.props.children);d.return=a;a=d;break a}}else if(l.elementType===k||"object"===typeof k&&null!==k&&k.$$typeof===Ha&&uh(k)===l.type){c(a,l.sibling);d=e(l,f.props);d.ref=sh(a,l,f);d.return=a;a=d;break a}c(a,l);break}else b(a,l);l=l.sibling}f.type===ya?(d=Ah(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=yh(f.type,f.key,f.props,null,a.mode,h),h.ref=sh(a,d,f),h.return=a,a=h)}return g(a);case wa:a:{for(l=f.key;null!==
	d;){if(d.key===l)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=zh(f,a.mode,h);d.return=a;a=d}return g(a);case Ha:return l=f._init,J(a,d,l(f._payload),h)}if(eb(f))return n(a,d,f,h);if(Ka(f))return t(a,d,f,h);th(a,f)}return"string"===typeof f&&""!==f||"number"===typeof f?(f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):
	(c(a,d),d=xh(f,a.mode,h),d.return=a,a=d),g(a)):c(a,d)}return J}var Bh=vh(!0),Ch=vh(!1),Dh={},Eh=Uf(Dh),Fh=Uf(Dh),Gh=Uf(Dh);function Hh(a){if(a===Dh)throw Error(p(174));return a}function Ih(a,b){G(Gh,b);G(Fh,a);G(Eh,Dh);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:lb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=lb(b,a)}E(Eh);G(Eh,b)}function Jh(){E(Eh);E(Fh);E(Gh)}
	function Kh(a){Hh(Gh.current);var b=Hh(Eh.current);var c=lb(b,a.type);b!==c&&(G(Fh,a),G(Eh,c))}function Lh(a){Fh.current===a&&(E(Eh),E(Fh))}var M=Uf(0);
	function Mh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&128))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}var Nh=[];
	function Oh(){for(var a=0;a<Nh.length;a++)Nh[a]._workInProgressVersionPrimary=null;Nh.length=0}var Ph=ua.ReactCurrentDispatcher,Qh=ua.ReactCurrentBatchConfig,Rh=0,N=null,O=null,P=null,Sh=!1,Th=!1,Uh=0,Vh=0;function Q(){throw Error(p(321));}function Wh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!He(a[c],b[c]))return!1;return!0}
	function Xh(a,b,c,d,e,f){Rh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;Ph.current=null===a||null===a.memoizedState?Yh:Zh;a=c(d,e);if(Th){f=0;do{Th=!1;Uh=0;if(25<=f)throw Error(p(301));f+=1;P=O=null;b.updateQueue=null;Ph.current=$h;a=c(d,e)}while(Th)}Ph.current=ai;b=null!==O&&null!==O.next;Rh=0;P=O=N=null;Sh=!1;if(b)throw Error(p(300));return a}function bi(){var a=0!==Uh;Uh=0;return a}
	function ci(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function di(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(p(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function ei(a,b){return"function"===typeof b?b(a):b}
	function fi(a){var b=di(),c=b.queue;if(null===c)throw Error(p(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){f=e.next;d=d.baseState;var h=g=null,k=null,l=f;do{var m=l.lane;if((Rh&m)===m)null!==k&&(k=k.next={lane:0,action:l.action,hasEagerState:l.hasEagerState,eagerState:l.eagerState,next:null}),d=l.hasEagerState?l.eagerState:a(d,l.action);else{var q={lane:m,action:l.action,hasEagerState:l.hasEagerState,
	eagerState:l.eagerState,next:null};null===k?(h=k=q,g=d):k=k.next=q;N.lanes|=m;hh|=m}l=l.next}while(null!==l&&l!==f);null===k?g=d:k.next=h;He(d,b.memoizedState)||(Ug=!0);b.memoizedState=d;b.baseState=g;b.baseQueue=k;c.lastRenderedState=d}a=c.interleaved;if(null!==a){e=a;do f=e.lane,N.lanes|=f,hh|=f,e=e.next;while(e!==a)}else null===e&&(c.lanes=0);return[b.memoizedState,c.dispatch]}
	function gi(a){var b=di(),c=b.queue;if(null===c)throw Error(p(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);He(f,b.memoizedState)||(Ug=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}function hi(){}
	function ii(a,b){var c=N,d=di(),e=b(),f=!He(d.memoizedState,e);f&&(d.memoizedState=e,Ug=!0);d=d.queue;ji(ki.bind(null,c,d,a),[a]);if(d.getSnapshot!==b||f||null!==P&&P.memoizedState.tag&1){c.flags|=2048;li(9,mi.bind(null,c,d,e,b),void 0,null);if(null===R)throw Error(p(349));0!==(Rh&30)||ni(c,b,e)}return e}function ni(a,b,c){a.flags|=16384;a={getSnapshot:b,value:c};b=N.updateQueue;null===b?(b={lastEffect:null,stores:null},N.updateQueue=b,b.stores=[a]):(c=b.stores,null===c?b.stores=[a]:c.push(a))}
	function mi(a,b,c,d){b.value=c;b.getSnapshot=d;oi(b)&&pi(a)}function ki(a,b,c){return c(function(){oi(b)&&pi(a)})}function oi(a){var b=a.getSnapshot;a=a.value;try{var c=b();return!He(a,c)}catch(d){return!0}}function pi(a){var b=Zg(a,1);null!==b&&mh(b,a,1,-1)}
	function qi(a){var b=ci();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:ei,lastRenderedState:a};b.queue=a;a=a.dispatch=ri.bind(null,N,a);return[b.memoizedState,a]}
	function li(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null,stores:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function si(){return di().memoizedState}function ti(a,b,c,d){var e=ci();N.flags|=a;e.memoizedState=li(1|b,c,void 0,void 0===d?null:d)}
	function ui(a,b,c,d){var e=di();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Wh(d,g.deps)){e.memoizedState=li(b,c,f,d);return}}N.flags|=a;e.memoizedState=li(1|b,c,f,d)}function vi(a,b){return ti(8390656,8,a,b)}function ji(a,b){return ui(2048,8,a,b)}function wi(a,b){return ui(4,2,a,b)}function xi(a,b){return ui(4,4,a,b)}
	function yi(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function zi(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return ui(4,4,yi.bind(null,b,a),c)}function Ai(){}function Bi(a,b){var c=di();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Wh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Ci(a,b){var c=di();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Wh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Di(a,b,c){if(0===(Rh&21))return a.baseState&&(a.baseState=!1,Ug=!0),a.memoizedState=c;He(c,b)||(c=yc(),N.lanes|=c,hh|=c,a.baseState=!0);return b}function Ei(a,b){var c=C;C=0!==c&&4>c?c:4;a(!0);var d=Qh.transition;Qh.transition={};try{a(!1),b()}finally{C=c,Qh.transition=d}}function Fi(){return di().memoizedState}
	function Gi(a,b,c){var d=lh(a);c={lane:d,action:c,hasEagerState:!1,eagerState:null,next:null};if(Hi(a))Ii(b,c);else if(c=Yg(a,b,c,d),null!==c){var e=L();mh(c,a,d,e);Ji(c,b,d)}}
	function ri(a,b,c){var d=lh(a),e={lane:d,action:c,hasEagerState:!1,eagerState:null,next:null};if(Hi(a))Ii(b,e);else{var f=a.alternate;if(0===a.lanes&&(null===f||0===f.lanes)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.hasEagerState=!0;e.eagerState=h;if(He(h,g)){var k=b.interleaved;null===k?(e.next=e,Xg(b)):(e.next=k.next,k.next=e);b.interleaved=e;return}}catch(l){}finally{}c=Yg(a,b,e,d);null!==c&&(e=L(),mh(c,a,d,e),Ji(c,b,d))}}
	function Hi(a){var b=a.alternate;return a===N||null!==b&&b===N}function Ii(a,b){Th=Sh=!0;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}function Ji(a,b,c){if(0!==(c&4194240)){var d=b.lanes;d&=a.pendingLanes;c|=d;b.lanes=c;Cc(a,c)}}
	var ai={readContext:Vg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useInsertionEffect:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useDeferredValue:Q,useTransition:Q,useMutableSource:Q,useSyncExternalStore:Q,useId:Q,unstable_isNewReconciler:!1},Yh={readContext:Vg,useCallback:function(a,b){ci().memoizedState=[a,void 0===b?null:b];return a},useContext:Vg,useEffect:vi,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return ti(4194308,
	4,yi.bind(null,b,a),c)},useLayoutEffect:function(a,b){return ti(4194308,4,a,b)},useInsertionEffect:function(a,b){return ti(4,2,a,b)},useMemo:function(a,b){var c=ci();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=ci();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};d.queue=a;a=a.dispatch=Gi.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=
	ci();a={current:a};return b.memoizedState=a},useState:qi,useDebugValue:Ai,useDeferredValue:function(a){return ci().memoizedState=a},useTransition:function(){var a=qi(!1),b=a[0];a=Ei.bind(null,a[1]);ci().memoizedState=a;return[b,a]},useMutableSource:function(){},useSyncExternalStore:function(a,b,c){var d=N,e=ci();if(I){if(void 0===c)throw Error(p(407));c=c()}else{c=b();if(null===R)throw Error(p(349));0!==(Rh&30)||ni(d,b,c)}e.memoizedState=c;var f={value:c,getSnapshot:b};e.queue=f;vi(ki.bind(null,d,
	f,a),[a]);d.flags|=2048;li(9,mi.bind(null,d,f,c,b),void 0,null);return c},useId:function(){var a=ci(),b=R.identifierPrefix;if(I){var c=sg;var d=rg;c=(d&~(1<<32-oc(d)-1)).toString(32)+c;b=":"+b+"R"+c;c=Uh++;0<c&&(b+="H"+c.toString(32));b+=":"}else c=Vh++,b=":"+b+"r"+c.toString(32)+":";return a.memoizedState=b},unstable_isNewReconciler:!1},Zh={readContext:Vg,useCallback:Bi,useContext:Vg,useEffect:ji,useImperativeHandle:zi,useInsertionEffect:wi,useLayoutEffect:xi,useMemo:Ci,useReducer:fi,useRef:si,useState:function(){return fi(ei)},
	useDebugValue:Ai,useDeferredValue:function(a){var b=di();return Di(b,O.memoizedState,a)},useTransition:function(){var a=fi(ei)[0],b=di().memoizedState;return[a,b]},useMutableSource:hi,useSyncExternalStore:ii,useId:Fi,unstable_isNewReconciler:!1},$h={readContext:Vg,useCallback:Bi,useContext:Vg,useEffect:ji,useImperativeHandle:zi,useInsertionEffect:wi,useLayoutEffect:xi,useMemo:Ci,useReducer:gi,useRef:si,useState:function(){return gi(ei)},useDebugValue:Ai,useDeferredValue:function(a){var b=di();return null===
	O?b.memoizedState=a:Di(b,O.memoizedState,a)},useTransition:function(){var a=gi(ei)[0],b=di().memoizedState;return[a,b]},useMutableSource:hi,useSyncExternalStore:ii,useId:Fi,unstable_isNewReconciler:!1};function Ki(a,b){try{var c="",d=b;do c+=Pa(d),d=d.return;while(d);var e=c}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack}return{value:a,source:b,stack:e,digest:null}}function Li(a,b,c){return{value:a,source:null,stack:null!=c?c:null,digest:null!=b?b:null}}
	function Mi(a,b){try{console.error(b.value)}catch(c){setTimeout(function(){throw c;})}}var Ni="function"===typeof WeakMap?WeakMap:Map;function Oi(a,b,c){c=ch(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Pi||(Pi=!0,Qi=d);Mi(a,b)};return c}
	function Ri(a,b,c){c=ch(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)};c.callback=function(){Mi(a,b)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){Mi(a,b);"function"!==typeof d&&(null===Si?Si=new Set([this]):Si.add(this));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	function Ti(a,b,c){var d=a.pingCache;if(null===d){d=a.pingCache=new Ni;var e=new Set;d.set(b,e)}else e=d.get(b),void 0===e&&(e=new Set,d.set(b,e));e.has(c)||(e.add(c),a=Ui.bind(null,a,b,c),b.then(a,a))}function Vi(a){do{var b;if(b=13===a.tag)b=a.memoizedState,b=null!==b?null!==b.dehydrated?!0:!1:!0;if(b)return a;a=a.return}while(null!==a);return null}
	function Wi(a,b,c,d,e){if(0===(a.mode&1))return a===b?a.flags|=65536:(a.flags|=128,c.flags|=131072,c.flags&=-52805,1===c.tag&&(null===c.alternate?c.tag=17:(b=ch(-1,1),b.tag=2,dh(c,b,1))),c.lanes|=1),a;a.flags|=65536;a.lanes=e;return a}var Xi=ua.ReactCurrentOwner,Ug=!1;function Yi(a,b,c,d){b.child=null===a?Ch(b,null,c,d):Bh(b,a.child,c,d)}
	function Zi(a,b,c,d,e){c=c.render;var f=b.ref;Tg(b,e);d=Xh(a,b,c,d,f,e);c=bi();if(null!==a&&!Ug)return b.updateQueue=a.updateQueue,b.flags&=-2053,a.lanes&=~e,$i(a,b,e);I&&c&&vg(b);b.flags|=1;Yi(a,b,d,e);return b.child}
	function aj(a,b,c,d,e){if(null===a){var f=c.type;if("function"===typeof f&&!bj(f)&&void 0===f.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=f,cj(a,b,f,d,e);a=yh(c.type,null,d,b,b.mode,e);a.ref=b.ref;a.return=b;return b.child=a}f=a.child;if(0===(a.lanes&e)){var g=f.memoizedProps;c=c.compare;c=null!==c?c:Ie;if(c(g,d)&&a.ref===b.ref)return $i(a,b,e)}b.flags|=1;a=wh(f,d);a.ref=b.ref;a.return=b;return b.child=a}
	function cj(a,b,c,d,e){if(null!==a){var f=a.memoizedProps;if(Ie(f,d)&&a.ref===b.ref)if(Ug=!1,b.pendingProps=d=f,0!==(a.lanes&e))0!==(a.flags&131072)&&(Ug=!0);else return b.lanes=a.lanes,$i(a,b,e)}return dj(a,b,c,d,e)}
	function ej(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode)if(0===(b.mode&1))b.memoizedState={baseLanes:0,cachePool:null,transitions:null},G(fj,gj),gj|=c;else{if(0===(c&1073741824))return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a,cachePool:null,transitions:null},b.updateQueue=null,G(fj,gj),gj|=a,null;b.memoizedState={baseLanes:0,cachePool:null,transitions:null};d=null!==f?f.baseLanes:c;G(fj,gj);gj|=d}else null!==
	f?(d=f.baseLanes|c,b.memoizedState=null):d=c,G(fj,gj),gj|=d;Yi(a,b,e,c);return b.child}function hj(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=512,b.flags|=2097152}function dj(a,b,c,d,e){var f=Zf(c)?Xf:H.current;f=Yf(b,f);Tg(b,e);c=Xh(a,b,c,d,f,e);d=bi();if(null!==a&&!Ug)return b.updateQueue=a.updateQueue,b.flags&=-2053,a.lanes&=~e,$i(a,b,e);I&&d&&vg(b);b.flags|=1;Yi(a,b,c,e);return b.child}
	function ij(a,b,c,d,e){if(Zf(c)){var f=!0;cg(b)}else f=!1;Tg(b,e);if(null===b.stateNode)jj(a,b),ph(b,c,d),rh(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=Vg(l):(l=Zf(c)?Xf:H.current,l=Yf(b,l));var m=c.getDerivedStateFromProps,q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;q||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||
	(h!==d||k!==l)&&qh(b,g,d,l);$g=!1;var r=b.memoizedState;g.state=r;gh(b,d,g,e);k=b.memoizedState;h!==d||r!==k||Wf.current||$g?("function"===typeof m&&(kh(b,c,m,d),k=b.memoizedState),(h=$g||oh(b,c,h,d,r,k,l))?(q||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.flags|=4194308)):
	("function"===typeof g.componentDidMount&&(b.flags|=4194308),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4194308),d=!1)}else{g=b.stateNode;bh(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:Lg(b.type,h);g.props=l;q=b.pendingProps;r=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=Vg(k):(k=Zf(c)?Xf:H.current,k=Yf(b,k));var y=c.getDerivedStateFromProps;(m="function"===typeof y||"function"===typeof g.getSnapshotBeforeUpdate)||
	"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==q||r!==k)&&qh(b,g,d,k);$g=!1;r=b.memoizedState;g.state=r;gh(b,d,g,e);var n=b.memoizedState;h!==q||r!==n||Wf.current||$g?("function"===typeof y&&(kh(b,c,y,d),n=b.memoizedState),(l=$g||oh(b,c,l,d,r,n,k)||!1)?(m||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,n,k),"function"===typeof g.UNSAFE_componentWillUpdate&&
	g.UNSAFE_componentWillUpdate(d,n,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=1024)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&r===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&r===a.memoizedState||(b.flags|=1024),b.memoizedProps=d,b.memoizedState=n),g.props=d,g.state=n,g.context=k,d=l):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&r===
	a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&r===a.memoizedState||(b.flags|=1024),d=!1)}return kj(a,b,c,d,f,e)}
	function kj(a,b,c,d,e,f){hj(a,b);var g=0!==(b.flags&128);if(!d&&!g)return e&&dg(b,c,!1),$i(a,b,f);d=b.stateNode;Xi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=Bh(b,a.child,null,f),b.child=Bh(b,null,h,f)):Yi(a,b,h,f);b.memoizedState=d.state;e&&dg(b,c,!0);return b.child}function lj(a){var b=a.stateNode;b.pendingContext?ag(a,b.pendingContext,b.pendingContext!==b.context):b.context&&ag(a,b.context,!1);Ih(a,b.containerInfo)}
	function mj(a,b,c,d,e){Ig();Jg(e);b.flags|=256;Yi(a,b,c,d);return b.child}var nj={dehydrated:null,treeContext:null,retryLane:0};function oj(a){return{baseLanes:a,cachePool:null,transitions:null}}
	function pj(a,b,c){var d=b.pendingProps,e=M.current,f=!1,g=0!==(b.flags&128),h;(h=g)||(h=null!==a&&null===a.memoizedState?!1:0!==(e&2));if(h)f=!0,b.flags&=-129;else if(null===a||null!==a.memoizedState)e|=1;G(M,e&1);if(null===a){Eg(b);a=b.memoizedState;if(null!==a&&(a=a.dehydrated,null!==a))return 0===(b.mode&1)?b.lanes=1:"$!"===a.data?b.lanes=8:b.lanes=1073741824,null;g=d.children;a=d.fallback;return f?(d=b.mode,f=b.child,g={mode:"hidden",children:g},0===(d&1)&&null!==f?(f.childLanes=0,f.pendingProps=
	g):f=qj(g,d,0,null),a=Ah(a,d,c,null),f.return=b,a.return=b,f.sibling=a,b.child=f,b.child.memoizedState=oj(c),b.memoizedState=nj,a):rj(b,g)}e=a.memoizedState;if(null!==e&&(h=e.dehydrated,null!==h))return sj(a,b,g,d,h,e,c);if(f){f=d.fallback;g=b.mode;e=a.child;h=e.sibling;var k={mode:"hidden",children:d.children};0===(g&1)&&b.child!==e?(d=b.child,d.childLanes=0,d.pendingProps=k,b.deletions=null):(d=wh(e,k),d.subtreeFlags=e.subtreeFlags&14680064);null!==h?f=wh(h,f):(f=Ah(f,g,c,null),f.flags|=2);f.return=
	b;d.return=b;d.sibling=f;b.child=d;d=f;f=b.child;g=a.child.memoizedState;g=null===g?oj(c):{baseLanes:g.baseLanes|c,cachePool:null,transitions:g.transitions};f.memoizedState=g;f.childLanes=a.childLanes&~c;b.memoizedState=nj;return d}f=a.child;a=f.sibling;d=wh(f,{mode:"visible",children:d.children});0===(b.mode&1)&&(d.lanes=c);d.return=b;d.sibling=null;null!==a&&(c=b.deletions,null===c?(b.deletions=[a],b.flags|=16):c.push(a));b.child=d;b.memoizedState=null;return d}
	function rj(a,b){b=qj({mode:"visible",children:b},a.mode,0,null);b.return=a;return a.child=b}function tj(a,b,c,d){null!==d&&Jg(d);Bh(b,a.child,null,c);a=rj(b,b.pendingProps.children);a.flags|=2;b.memoizedState=null;return a}
	function sj(a,b,c,d,e,f,g){if(c){if(b.flags&256)return b.flags&=-257,d=Li(Error(p(422))),tj(a,b,g,d);if(null!==b.memoizedState)return b.child=a.child,b.flags|=128,null;f=d.fallback;e=b.mode;d=qj({mode:"visible",children:d.children},e,0,null);f=Ah(f,e,g,null);f.flags|=2;d.return=b;f.return=b;d.sibling=f;b.child=d;0!==(b.mode&1)&&Bh(b,a.child,null,g);b.child.memoizedState=oj(g);b.memoizedState=nj;return f}if(0===(b.mode&1))return tj(a,b,g,null);if("$!"===e.data){d=e.nextSibling&&e.nextSibling.dataset;
	if(d)var h=d.dgst;d=h;f=Error(p(419));d=Li(f,d,void 0);return tj(a,b,g,d)}h=0!==(g&a.childLanes);if(Ug||h){d=R;if(null!==d){switch(g&-g){case 4:e=2;break;case 16:e=8;break;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:e=32;break;case 536870912:e=268435456;break;default:e=0}e=0!==(e&(d.suspendedLanes|g))?0:e;
	0!==e&&e!==f.retryLane&&(f.retryLane=e,Zg(a,e),mh(d,a,e,-1))}uj();d=Li(Error(p(421)));return tj(a,b,g,d)}if("$?"===e.data)return b.flags|=128,b.child=a.child,b=vj.bind(null,a),e._reactRetry=b,null;a=f.treeContext;yg=Lf(e.nextSibling);xg=b;I=!0;zg=null;null!==a&&(og[pg++]=rg,og[pg++]=sg,og[pg++]=qg,rg=a.id,sg=a.overflow,qg=b);b=rj(b,d.children);b.flags|=4096;return b}function wj(a,b,c){a.lanes|=b;var d=a.alternate;null!==d&&(d.lanes|=b);Sg(a.return,b,c)}
	function xj(a,b,c,d,e){var f=a.memoizedState;null===f?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e}:(f.isBackwards=b,f.rendering=null,f.renderingStartTime=0,f.last=d,f.tail=c,f.tailMode=e)}
	function yj(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;Yi(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.flags|=128;else{if(null!==a&&0!==(a.flags&128))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&wj(a,c,b);else if(19===a.tag)wj(a,c,b);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}G(M,d);if(0===(b.mode&1))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===Mh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);xj(b,!1,e,c,f);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===Mh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}xj(b,!0,c,null,f);break;case "together":xj(b,!1,null,null,void 0);break;default:b.memoizedState=null}return b.child}
	function jj(a,b){0===(b.mode&1)&&null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2)}function $i(a,b,c){null!==a&&(b.dependencies=a.dependencies);hh|=b.lanes;if(0===(c&b.childLanes))return null;if(null!==a&&b.child!==a.child)throw Error(p(153));if(null!==b.child){a=b.child;c=wh(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=wh(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}
	function zj(a,b,c){switch(b.tag){case 3:lj(b);Ig();break;case 5:Kh(b);break;case 1:Zf(b.type)&&cg(b);break;case 4:Ih(b,b.stateNode.containerInfo);break;case 10:var d=b.type._context,e=b.memoizedProps.value;G(Mg,d._currentValue);d._currentValue=e;break;case 13:d=b.memoizedState;if(null!==d){if(null!==d.dehydrated)return G(M,M.current&1),b.flags|=128,null;if(0!==(c&b.child.childLanes))return pj(a,b,c);G(M,M.current&1);a=$i(a,b,c);return null!==a?a.sibling:null}G(M,M.current&1);break;case 19:d=0!==(c&
	b.childLanes);if(0!==(a.flags&128)){if(d)return yj(a,b,c);b.flags|=128}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);G(M,M.current);if(d)break;else return null;case 22:case 23:return b.lanes=0,ej(a,b,c)}return $i(a,b,c)}var Aj,Bj,Cj,Dj;
	Aj=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Bj=function(){};
	Cj=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;Hh(Eh.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "select":e=A({},e,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=Bf)}ub(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&
	(c||(c={}),c[g]="")}else"dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ea.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||(c={}),c[g]=k[g])}else c||(f||(f=[]),f.push(l,
	c)),c=k;else"dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ea.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&D("scroll",a),f||h===k||(f=[])):(f=f||[]).push(l,k))}c&&(f=f||[]).push("style",c);var l=f;if(b.updateQueue=l)b.flags|=4}};Dj=function(a,b,c,d){c!==d&&(b.flags|=4)};
	function Ej(a,b){if(!I)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function S(a){var b=null!==a.alternate&&a.alternate.child===a.child,c=0,d=0;if(b)for(var e=a.child;null!==e;)c|=e.lanes|e.childLanes,d|=e.subtreeFlags&14680064,d|=e.flags&14680064,e.return=a,e=e.sibling;else for(e=a.child;null!==e;)c|=e.lanes|e.childLanes,d|=e.subtreeFlags,d|=e.flags,e.return=a,e=e.sibling;a.subtreeFlags|=d;a.childLanes=c;return b}
	function Fj(a,b,c){var d=b.pendingProps;wg(b);switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return S(b),null;case 1:return Zf(b.type)&&$f(),S(b),null;case 3:d=b.stateNode;Jh();E(Wf);E(H);Oh();d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Gg(b)?b.flags|=4:null===a||a.memoizedState.isDehydrated&&0===(b.flags&256)||(b.flags|=1024,null!==zg&&(Gj(zg),zg=null));Bj(a,b);S(b);return null;case 5:Lh(b);var e=Hh(Gh.current);
	c=b.type;if(null!==a&&null!=b.stateNode)Cj(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=512,b.flags|=2097152);else{if(!d){if(null===b.stateNode)throw Error(p(166));S(b);return null}a=Hh(Eh.current);if(Gg(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[Of]=b;d[Pf]=f;a=0!==(b.mode&1);switch(c){case "dialog":D("cancel",d);D("close",d);break;case "iframe":case "object":case "embed":D("load",d);break;case "video":case "audio":for(e=0;e<lf.length;e++)D(lf[e],d);break;case "source":D("error",d);break;case "img":case "image":case "link":D("error",
	d);D("load",d);break;case "details":D("toggle",d);break;case "input":Za(d,f);D("invalid",d);break;case "select":d._wrapperState={wasMultiple:!!f.multiple};D("invalid",d);break;case "textarea":hb(d,f),D("invalid",d)}ub(c,f);e=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(!0!==f.suppressHydrationWarning&&Af(d.textContent,h,a),e=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(!0!==f.suppressHydrationWarning&&Af(d.textContent,
	h,a),e=["children",""+h]):ea.hasOwnProperty(g)&&null!=h&&"onScroll"===g&&D("scroll",d)}switch(c){case "input":Va(d);db(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=Bf)}d=e;b.updateQueue=d;null!==d&&(b.flags|=4)}else{g=9===e.nodeType?e:e.ownerDocument;"http://www.w3.org/1999/xhtml"===a&&(a=kb(c));"http://www.w3.org/1999/xhtml"===a?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):
	"string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[Of]=b;a[Pf]=d;Aj(a,b,!1,!1);b.stateNode=a;a:{g=vb(c,d);switch(c){case "dialog":D("cancel",a);D("close",a);e=d;break;case "iframe":case "object":case "embed":D("load",a);e=d;break;case "video":case "audio":for(e=0;e<lf.length;e++)D(lf[e],a);e=d;break;case "source":D("error",a);e=d;break;case "img":case "image":case "link":D("error",
	a);D("load",a);e=d;break;case "details":D("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);D("invalid",a);break;case "option":e=d;break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=A({},d,{value:void 0});D("invalid",a);break;case "textarea":hb(a,d);e=gb(a,d);D("invalid",a);break;default:e=d}ub(c,e);h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?sb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&nb(a,k)):"children"===f?"string"===typeof k?("textarea"!==
	c||""!==k)&&ob(a,k):"number"===typeof k&&ob(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ea.hasOwnProperty(f)?null!=k&&"onScroll"===f&&D("scroll",a):null!=k&&ta(a,f,k,g))}switch(c){case "input":Va(a);db(a,d,!1);break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,
	!0);break;default:"function"===typeof e.onClick&&(a.onclick=Bf)}switch(c){case "button":case "input":case "select":case "textarea":d=!!d.autoFocus;break a;case "img":d=!0;break a;default:d=!1}}d&&(b.flags|=4)}null!==b.ref&&(b.flags|=512,b.flags|=2097152)}S(b);return null;case 6:if(a&&null!=b.stateNode)Dj(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(p(166));c=Hh(Gh.current);Hh(Eh.current);if(Gg(b)){d=b.stateNode;c=b.memoizedProps;d[Of]=b;if(f=d.nodeValue!==c)if(a=
	xg,null!==a)switch(a.tag){case 3:Af(d.nodeValue,c,0!==(a.mode&1));break;case 5:!0!==a.memoizedProps.suppressHydrationWarning&&Af(d.nodeValue,c,0!==(a.mode&1))}f&&(b.flags|=4)}else d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[Of]=b,b.stateNode=d}S(b);return null;case 13:E(M);d=b.memoizedState;if(null===a||null!==a.memoizedState&&null!==a.memoizedState.dehydrated){if(I&&null!==yg&&0!==(b.mode&1)&&0===(b.flags&128))Hg(),Ig(),b.flags|=98560,f=!1;else if(f=Gg(b),null!==d&&null!==d.dehydrated){if(null===
	a){if(!f)throw Error(p(318));f=b.memoizedState;f=null!==f?f.dehydrated:null;if(!f)throw Error(p(317));f[Of]=b}else Ig(),0===(b.flags&128)&&(b.memoizedState=null),b.flags|=4;S(b);f=!1}else null!==zg&&(Gj(zg),zg=null),f=!0;if(!f)return b.flags&65536?b:null}if(0!==(b.flags&128))return b.lanes=c,b;d=null!==d;d!==(null!==a&&null!==a.memoizedState)&&d&&(b.child.flags|=8192,0!==(b.mode&1)&&(null===a||0!==(M.current&1)?0===T&&(T=3):uj()));null!==b.updateQueue&&(b.flags|=4);S(b);return null;case 4:return Jh(),
	Bj(a,b),null===a&&sf(b.stateNode.containerInfo),S(b),null;case 10:return Rg(b.type._context),S(b),null;case 17:return Zf(b.type)&&$f(),S(b),null;case 19:E(M);f=b.memoizedState;if(null===f)return S(b),null;d=0!==(b.flags&128);g=f.rendering;if(null===g)if(d)Ej(f,!1);else{if(0!==T||null!==a&&0!==(a.flags&128))for(a=b.child;null!==a;){g=Mh(a);if(null!==g){b.flags|=128;Ej(f,!1);d=g.updateQueue;null!==d&&(b.updateQueue=d,b.flags|=4);b.subtreeFlags=0;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=14680066,
	g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.subtreeFlags=0,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,f.lanes=g.lanes,f.child=g.child,f.subtreeFlags=0,f.deletions=null,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;G(M,M.current&1|2);return b.child}a=
	a.sibling}null!==f.tail&&B()>Hj&&(b.flags|=128,d=!0,Ej(f,!1),b.lanes=4194304)}else{if(!d)if(a=Mh(g),null!==a){if(b.flags|=128,d=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Ej(f,!0),null===f.tail&&"hidden"===f.tailMode&&!g.alternate&&!I)return S(b),null}else 2*B()-f.renderingStartTime>Hj&&1073741824!==c&&(b.flags|=128,d=!0,Ej(f,!1),b.lanes=4194304);f.isBackwards?(g.sibling=b.child,b.child=g):(c=f.last,null!==c?c.sibling=g:b.child=g,f.last=g)}if(null!==f.tail)return b=f.tail,f.rendering=
	b,f.tail=b.sibling,f.renderingStartTime=B(),b.sibling=null,c=M.current,G(M,d?c&1|2:c&1),b;S(b);return null;case 22:case 23:return Ij(),d=null!==b.memoizedState,null!==a&&null!==a.memoizedState!==d&&(b.flags|=8192),d&&0!==(b.mode&1)?0!==(gj&1073741824)&&(S(b),b.subtreeFlags&6&&(b.flags|=8192)):S(b),null;case 24:return null;case 25:return null}throw Error(p(156,b.tag));}
	function Jj(a,b){wg(b);switch(b.tag){case 1:return Zf(b.type)&&$f(),a=b.flags,a&65536?(b.flags=a&-65537|128,b):null;case 3:return Jh(),E(Wf),E(H),Oh(),a=b.flags,0!==(a&65536)&&0===(a&128)?(b.flags=a&-65537|128,b):null;case 5:return Lh(b),null;case 13:E(M);a=b.memoizedState;if(null!==a&&null!==a.dehydrated){if(null===b.alternate)throw Error(p(340));Ig()}a=b.flags;return a&65536?(b.flags=a&-65537|128,b):null;case 19:return E(M),null;case 4:return Jh(),null;case 10:return Rg(b.type._context),null;case 22:case 23:return Ij(),
	null;case 24:return null;default:return null}}var Kj=!1,U=!1,Lj="function"===typeof WeakSet?WeakSet:Set,V=null;function Mj(a,b){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(d){W(a,b,d)}else c.current=null}function Nj(a,b,c){try{c()}catch(d){W(a,b,d)}}var Oj=!1;
	function Pj(a,b){Cf=dd;a=Me();if(Ne(a)){if("selectionStart"in a)var c={start:a.selectionStart,end:a.selectionEnd};else a:{c=(c=a.ownerDocument)&&c.defaultView||window;var d=c.getSelection&&c.getSelection();if(d&&0!==d.rangeCount){c=d.anchorNode;var e=d.anchorOffset,f=d.focusNode;d=d.focusOffset;try{c.nodeType,f.nodeType}catch(F){c=null;break a}var g=0,h=-1,k=-1,l=0,m=0,q=a,r=null;b:for(;;){for(var y;;){q!==c||0!==e&&3!==q.nodeType||(h=g+e);q!==f||0!==d&&3!==q.nodeType||(k=g+d);3===q.nodeType&&(g+=
	q.nodeValue.length);if(null===(y=q.firstChild))break;r=q;q=y}for(;;){if(q===a)break b;r===c&&++l===e&&(h=g);r===f&&++m===d&&(k=g);if(null!==(y=q.nextSibling))break;q=r;r=q.parentNode}q=y}c=-1===h||-1===k?null:{start:h,end:k}}else c=null}c=c||{start:0,end:0}}else c=null;Df={focusedElem:a,selectionRange:c};dd=!1;for(V=b;null!==V;)if(b=V,a=b.child,0!==(b.subtreeFlags&1028)&&null!==a)a.return=b,V=a;else for(;null!==V;){b=V;try{var n=b.alternate;if(0!==(b.flags&1024))switch(b.tag){case 0:case 11:case 15:break;
	case 1:if(null!==n){var t=n.memoizedProps,J=n.memoizedState,x=b.stateNode,w=x.getSnapshotBeforeUpdate(b.elementType===b.type?t:Lg(b.type,t),J);x.__reactInternalSnapshotBeforeUpdate=w}break;case 3:var u=b.stateNode.containerInfo;1===u.nodeType?u.textContent="":9===u.nodeType&&u.documentElement&&u.removeChild(u.documentElement);break;case 5:case 6:case 4:case 17:break;default:throw Error(p(163));}}catch(F){W(b,b.return,F)}a=b.sibling;if(null!==a){a.return=b.return;V=a;break}V=b.return}n=Oj;Oj=!1;return n}
	function Qj(a,b,c){var d=b.updateQueue;d=null!==d?d.lastEffect:null;if(null!==d){var e=d=d.next;do{if((e.tag&a)===a){var f=e.destroy;e.destroy=void 0;void 0!==f&&Nj(b,c,f)}e=e.next}while(e!==d)}}function Rj(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}function Sj(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=c;break;default:a=c}"function"===typeof b?b(a):b.current=a}}
	function Tj(a){var b=a.alternate;null!==b&&(a.alternate=null,Tj(b));a.child=null;a.deletions=null;a.sibling=null;5===a.tag&&(b=a.stateNode,null!==b&&(delete b[Of],delete b[Pf],delete b[of],delete b[Qf],delete b[Rf]));a.stateNode=null;a.return=null;a.dependencies=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.stateNode=null;a.updateQueue=null}function Uj(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Vj(a){a:for(;;){for(;null===a.sibling;){if(null===a.return||Uj(a.return))return null;a=a.return}a.sibling.return=a.return;for(a=a.sibling;5!==a.tag&&6!==a.tag&&18!==a.tag;){if(a.flags&2)continue a;if(null===a.child||4===a.tag)continue a;else a.child.return=a,a=a.child}if(!(a.flags&2))return a.stateNode}}
	function Wj(a,b,c){var d=a.tag;if(5===d||6===d)a=a.stateNode,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=Bf));else if(4!==d&&(a=a.child,null!==a))for(Wj(a,b,c),a=a.sibling;null!==a;)Wj(a,b,c),a=a.sibling}
	function Xj(a,b,c){var d=a.tag;if(5===d||6===d)a=a.stateNode,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Xj(a,b,c),a=a.sibling;null!==a;)Xj(a,b,c),a=a.sibling}var X=null,Yj=!1;function Zj(a,b,c){for(c=c.child;null!==c;)ak(a,b,c),c=c.sibling}
	function ak(a,b,c){if(lc&&"function"===typeof lc.onCommitFiberUnmount)try{lc.onCommitFiberUnmount(kc,c)}catch(h){}switch(c.tag){case 5:U||Mj(c,b);case 6:var d=X,e=Yj;X=null;Zj(a,b,c);X=d;Yj=e;null!==X&&(Yj?(a=X,c=c.stateNode,8===a.nodeType?a.parentNode.removeChild(c):a.removeChild(c)):X.removeChild(c.stateNode));break;case 18:null!==X&&(Yj?(a=X,c=c.stateNode,8===a.nodeType?Kf(a.parentNode,c):1===a.nodeType&&Kf(a,c),bd(a)):Kf(X,c.stateNode));break;case 4:d=X;e=Yj;X=c.stateNode.containerInfo;Yj=!0;
	Zj(a,b,c);X=d;Yj=e;break;case 0:case 11:case 14:case 15:if(!U&&(d=c.updateQueue,null!==d&&(d=d.lastEffect,null!==d))){e=d=d.next;do{var f=e,g=f.destroy;f=f.tag;void 0!==g&&(0!==(f&2)?Nj(c,b,g):0!==(f&4)&&Nj(c,b,g));e=e.next}while(e!==d)}Zj(a,b,c);break;case 1:if(!U&&(Mj(c,b),d=c.stateNode,"function"===typeof d.componentWillUnmount))try{d.props=c.memoizedProps,d.state=c.memoizedState,d.componentWillUnmount()}catch(h){W(c,b,h)}Zj(a,b,c);break;case 21:Zj(a,b,c);break;case 22:c.mode&1?(U=(d=U)||null!==
	c.memoizedState,Zj(a,b,c),U=d):Zj(a,b,c);break;default:Zj(a,b,c)}}function bk(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Lj);b.forEach(function(b){var d=ck.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	function dk(a,b){var c=b.deletions;if(null!==c)for(var d=0;d<c.length;d++){var e=c[d];try{var f=a,g=b,h=g;a:for(;null!==h;){switch(h.tag){case 5:X=h.stateNode;Yj=!1;break a;case 3:X=h.stateNode.containerInfo;Yj=!0;break a;case 4:X=h.stateNode.containerInfo;Yj=!0;break a}h=h.return}if(null===X)throw Error(p(160));ak(f,g,e);X=null;Yj=!1;var k=e.alternate;null!==k&&(k.return=null);e.return=null}catch(l){W(e,b,l)}}if(b.subtreeFlags&12854)for(b=b.child;null!==b;)ek(b,a),b=b.sibling}
	function ek(a,b){var c=a.alternate,d=a.flags;switch(a.tag){case 0:case 11:case 14:case 15:dk(b,a);fk(a);if(d&4){try{Qj(3,a,a.return),Rj(3,a)}catch(t){W(a,a.return,t)}try{Qj(5,a,a.return)}catch(t){W(a,a.return,t)}}break;case 1:dk(b,a);fk(a);d&512&&null!==c&&Mj(c,c.return);break;case 5:dk(b,a);fk(a);d&512&&null!==c&&Mj(c,c.return);if(a.flags&32){var e=a.stateNode;try{ob(e,"")}catch(t){W(a,a.return,t)}}if(d&4&&(e=a.stateNode,null!=e)){var f=a.memoizedProps,g=null!==c?c.memoizedProps:f,h=a.type,k=a.updateQueue;
	a.updateQueue=null;if(null!==k)try{"input"===h&&"radio"===f.type&&null!=f.name&&ab(e,f);vb(h,g);var l=vb(h,f);for(g=0;g<k.length;g+=2){var m=k[g],q=k[g+1];"style"===m?sb(e,q):"dangerouslySetInnerHTML"===m?nb(e,q):"children"===m?ob(e,q):ta(e,m,q,l)}switch(h){case "input":bb(e,f);break;case "textarea":ib(e,f);break;case "select":var r=e._wrapperState.wasMultiple;e._wrapperState.wasMultiple=!!f.multiple;var y=f.value;null!=y?fb(e,!!f.multiple,y,!1):r!==!!f.multiple&&(null!=f.defaultValue?fb(e,!!f.multiple,
	f.defaultValue,!0):fb(e,!!f.multiple,f.multiple?[]:"",!1))}e[Pf]=f}catch(t){W(a,a.return,t)}}break;case 6:dk(b,a);fk(a);if(d&4){if(null===a.stateNode)throw Error(p(162));e=a.stateNode;f=a.memoizedProps;try{e.nodeValue=f}catch(t){W(a,a.return,t)}}break;case 3:dk(b,a);fk(a);if(d&4&&null!==c&&c.memoizedState.isDehydrated)try{bd(b.containerInfo)}catch(t){W(a,a.return,t)}break;case 4:dk(b,a);fk(a);break;case 13:dk(b,a);fk(a);e=a.child;e.flags&8192&&(f=null!==e.memoizedState,e.stateNode.isHidden=f,!f||
	null!==e.alternate&&null!==e.alternate.memoizedState||(gk=B()));d&4&&bk(a);break;case 22:m=null!==c&&null!==c.memoizedState;a.mode&1?(U=(l=U)||m,dk(b,a),U=l):dk(b,a);fk(a);if(d&8192){l=null!==a.memoizedState;if((a.stateNode.isHidden=l)&&!m&&0!==(a.mode&1))for(V=a,m=a.child;null!==m;){for(q=V=m;null!==V;){r=V;y=r.child;switch(r.tag){case 0:case 11:case 14:case 15:Qj(4,r,r.return);break;case 1:Mj(r,r.return);var n=r.stateNode;if("function"===typeof n.componentWillUnmount){d=r;c=r.return;try{b=d,n.props=
	b.memoizedProps,n.state=b.memoizedState,n.componentWillUnmount()}catch(t){W(d,c,t)}}break;case 5:Mj(r,r.return);break;case 22:if(null!==r.memoizedState){hk(q);continue}}null!==y?(y.return=r,V=y):hk(q)}m=m.sibling}a:for(m=null,q=a;;){if(5===q.tag){if(null===m){m=q;try{e=q.stateNode,l?(f=e.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(h=q.stateNode,k=q.memoizedProps.style,g=void 0!==k&&null!==k&&k.hasOwnProperty("display")?k.display:null,h.style.display=
	rb("display",g))}catch(t){W(a,a.return,t)}}}else if(6===q.tag){if(null===m)try{q.stateNode.nodeValue=l?"":q.memoizedProps}catch(t){W(a,a.return,t)}}else if((22!==q.tag&&23!==q.tag||null===q.memoizedState||q===a)&&null!==q.child){q.child.return=q;q=q.child;continue}if(q===a)break a;for(;null===q.sibling;){if(null===q.return||q.return===a)break a;m===q&&(m=null);q=q.return}m===q&&(m=null);q.sibling.return=q.return;q=q.sibling}}break;case 19:dk(b,a);fk(a);d&4&&bk(a);break;case 21:break;default:dk(b,
	a),fk(a)}}function fk(a){var b=a.flags;if(b&2){try{a:{for(var c=a.return;null!==c;){if(Uj(c)){var d=c;break a}c=c.return}throw Error(p(160));}switch(d.tag){case 5:var e=d.stateNode;d.flags&32&&(ob(e,""),d.flags&=-33);var f=Vj(a);Xj(a,f,e);break;case 3:case 4:var g=d.stateNode.containerInfo,h=Vj(a);Wj(a,h,g);break;default:throw Error(p(161));}}catch(k){W(a,a.return,k)}a.flags&=-3}b&4096&&(a.flags&=-4097)}function ik(a,b,c){V=a;jk(a,b,c)}
	function jk(a,b,c){for(var d=0!==(a.mode&1);null!==V;){var e=V,f=e.child;if(22===e.tag&&d){var g=null!==e.memoizedState||Kj;if(!g){var h=e.alternate,k=null!==h&&null!==h.memoizedState||U;h=Kj;var l=U;Kj=g;if((U=k)&&!l)for(V=e;null!==V;)g=V,k=g.child,22===g.tag&&null!==g.memoizedState?kk(e):null!==k?(k.return=g,V=k):kk(e);for(;null!==f;)V=f,jk(f,b,c),f=f.sibling;V=e;Kj=h;U=l}lk(a,b,c)}else 0!==(e.subtreeFlags&8772)&&null!==f?(f.return=e,V=f):lk(a,b,c)}}
	function lk(a){for(;null!==V;){var b=V;if(0!==(b.flags&8772)){var c=b.alternate;try{if(0!==(b.flags&8772))switch(b.tag){case 0:case 11:case 15:U||Rj(5,b);break;case 1:var d=b.stateNode;if(b.flags&4&&!U)if(null===c)d.componentDidMount();else{var e=b.elementType===b.type?c.memoizedProps:Lg(b.type,c.memoizedProps);d.componentDidUpdate(e,c.memoizedState,d.__reactInternalSnapshotBeforeUpdate)}var f=b.updateQueue;null!==f&&ih(b,f,d);break;case 3:var g=b.updateQueue;if(null!==g){c=null;if(null!==b.child)switch(b.child.tag){case 5:c=
	b.child.stateNode;break;case 1:c=b.child.stateNode}ih(b,g,c)}break;case 5:var h=b.stateNode;if(null===c&&b.flags&4){c=h;var k=b.memoizedProps;switch(b.type){case "button":case "input":case "select":case "textarea":k.autoFocus&&c.focus();break;case "img":k.src&&(c.src=k.src)}}break;case 6:break;case 4:break;case 12:break;case 13:if(null===b.memoizedState){var l=b.alternate;if(null!==l){var m=l.memoizedState;if(null!==m){var q=m.dehydrated;null!==q&&bd(q)}}}break;case 19:case 17:case 21:case 22:case 23:case 25:break;
	default:throw Error(p(163));}U||b.flags&512&&Sj(b)}catch(r){W(b,b.return,r)}}if(b===a){V=null;break}c=b.sibling;if(null!==c){c.return=b.return;V=c;break}V=b.return}}function hk(a){for(;null!==V;){var b=V;if(b===a){V=null;break}var c=b.sibling;if(null!==c){c.return=b.return;V=c;break}V=b.return}}
	function kk(a){for(;null!==V;){var b=V;try{switch(b.tag){case 0:case 11:case 15:var c=b.return;try{Rj(4,b)}catch(k){W(b,c,k)}break;case 1:var d=b.stateNode;if("function"===typeof d.componentDidMount){var e=b.return;try{d.componentDidMount()}catch(k){W(b,e,k)}}var f=b.return;try{Sj(b)}catch(k){W(b,f,k)}break;case 5:var g=b.return;try{Sj(b)}catch(k){W(b,g,k)}}}catch(k){W(b,b.return,k)}if(b===a){V=null;break}var h=b.sibling;if(null!==h){h.return=b.return;V=h;break}V=b.return}}
	var mk=Math.ceil,nk=ua.ReactCurrentDispatcher,ok=ua.ReactCurrentOwner,pk=ua.ReactCurrentBatchConfig,K=0,R=null,Y=null,Z=0,gj=0,fj=Uf(0),T=0,qk=null,hh=0,rk=0,sk=0,tk=null,uk=null,gk=0,Hj=Infinity,vk=null,Pi=!1,Qi=null,Si=null,wk=!1,xk=null,yk=0,zk=0,Ak=null,Bk=-1,Ck=0;function L(){return 0!==(K&6)?B():-1!==Bk?Bk:Bk=B()}
	function lh(a){if(0===(a.mode&1))return 1;if(0!==(K&2)&&0!==Z)return Z&-Z;if(null!==Kg.transition)return 0===Ck&&(Ck=yc()),Ck;a=C;if(0!==a)return a;a=window.event;a=void 0===a?16:jd(a.type);return a}function mh(a,b,c,d){if(50<zk)throw zk=0,Ak=null,Error(p(185));Ac(a,c,d);if(0===(K&2)||a!==R)a===R&&(0===(K&2)&&(rk|=c),4===T&&Dk(a,Z)),Ek(a,d),1===c&&0===K&&0===(b.mode&1)&&(Hj=B()+500,fg&&jg())}
	function Ek(a,b){var c=a.callbackNode;wc(a,b);var d=uc(a,a===R?Z:0);if(0===d)null!==c&&bc(c),a.callbackNode=null,a.callbackPriority=0;else if(b=d&-d,a.callbackPriority!==b){null!=c&&bc(c);if(1===b)0===a.tag?ig(Fk.bind(null,a)):hg(Fk.bind(null,a)),Jf(function(){0===(K&6)&&jg()}),c=null;else{switch(Dc(d)){case 1:c=fc;break;case 4:c=gc;break;case 16:c=hc;break;case 536870912:c=jc;break;default:c=hc}c=Gk(c,Hk.bind(null,a))}a.callbackPriority=b;a.callbackNode=c}}
	function Hk(a,b){Bk=-1;Ck=0;if(0!==(K&6))throw Error(p(327));var c=a.callbackNode;if(Ik()&&a.callbackNode!==c)return null;var d=uc(a,a===R?Z:0);if(0===d)return null;if(0!==(d&30)||0!==(d&a.expiredLanes)||b)b=Jk(a,d);else{b=d;var e=K;K|=2;var f=Kk();if(R!==a||Z!==b)vk=null,Hj=B()+500,Lk(a,b);do try{Mk();break}catch(h){Nk(a,h)}while(1);Qg();nk.current=f;K=e;null!==Y?b=0:(R=null,Z=0,b=T)}if(0!==b){2===b&&(e=xc(a),0!==e&&(d=e,b=Ok(a,e)));if(1===b)throw c=qk,Lk(a,0),Dk(a,d),Ek(a,B()),c;if(6===b)Dk(a,d);
	else{e=a.current.alternate;if(0===(d&30)&&!Pk(e)&&(b=Jk(a,d),2===b&&(f=xc(a),0!==f&&(d=f,b=Ok(a,f))),1===b))throw c=qk,Lk(a,0),Dk(a,d),Ek(a,B()),c;a.finishedWork=e;a.finishedLanes=d;switch(b){case 0:case 1:throw Error(p(345));case 2:Qk(a,uk,vk);break;case 3:Dk(a,d);if((d&130023424)===d&&(b=gk+500-B(),10<b)){if(0!==uc(a,0))break;e=a.suspendedLanes;if((e&d)!==d){L();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=Ff(Qk.bind(null,a,uk,vk),b);break}Qk(a,uk,vk);break;case 4:Dk(a,d);if((d&4194240)===
	d)break;b=a.eventTimes;for(e=-1;0<d;){var g=31-oc(d);f=1<<g;g=b[g];g>e&&(e=g);d&=~f}d=e;d=B()-d;d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*mk(d/1960))-d;if(10<d){a.timeoutHandle=Ff(Qk.bind(null,a,uk,vk),d);break}Qk(a,uk,vk);break;case 5:Qk(a,uk,vk);break;default:throw Error(p(329));}}}Ek(a,B());return a.callbackNode===c?Hk.bind(null,a):null}
	function Ok(a,b){var c=tk;a.current.memoizedState.isDehydrated&&(Lk(a,b).flags|=256);a=Jk(a,b);2!==a&&(b=uk,uk=c,null!==b&&Gj(b));return a}function Gj(a){null===uk?uk=a:uk.push.apply(uk,a)}
	function Pk(a){for(var b=a;;){if(b.flags&16384){var c=b.updateQueue;if(null!==c&&(c=c.stores,null!==c))for(var d=0;d<c.length;d++){var e=c[d],f=e.getSnapshot;e=e.value;try{if(!He(f(),e))return!1}catch(g){return!1}}}c=b.child;if(b.subtreeFlags&16384&&null!==c)c.return=b,b=c;else{if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return!0;b=b.return}b.sibling.return=b.return;b=b.sibling}}return!0}
	function Dk(a,b){b&=~sk;b&=~rk;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-oc(b),d=1<<c;a[c]=-1;b&=~d}}function Fk(a){if(0!==(K&6))throw Error(p(327));Ik();var b=uc(a,0);if(0===(b&1))return Ek(a,B()),null;var c=Jk(a,b);if(0!==a.tag&&2===c){var d=xc(a);0!==d&&(b=d,c=Ok(a,d))}if(1===c)throw c=qk,Lk(a,0),Dk(a,b),Ek(a,B()),c;if(6===c)throw Error(p(345));a.finishedWork=a.current.alternate;a.finishedLanes=b;Qk(a,uk,vk);Ek(a,B());return null}
	function Rk(a,b){var c=K;K|=1;try{return a(b)}finally{K=c,0===K&&(Hj=B()+500,fg&&jg())}}function Sk(a){null!==xk&&0===xk.tag&&0===(K&6)&&Ik();var b=K;K|=1;var c=pk.transition,d=C;try{if(pk.transition=null,C=1,a)return a()}finally{C=d,pk.transition=c,K=b,0===(K&6)&&jg()}}function Ij(){gj=fj.current;E(fj)}
	function Lk(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Gf(c));if(null!==Y)for(c=Y.return;null!==c;){var d=c;wg(d);switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&$f();break;case 3:Jh();E(Wf);E(H);Oh();break;case 5:Lh(d);break;case 4:Jh();break;case 13:E(M);break;case 19:E(M);break;case 10:Rg(d.type._context);break;case 22:case 23:Ij()}c=c.return}R=a;Y=a=wh(a.current,null);Z=gj=b;T=0;qk=null;sk=rk=hh=0;uk=tk=null;if(null!==Wg){for(b=
	0;b<Wg.length;b++)if(c=Wg[b],d=c.interleaved,null!==d){c.interleaved=null;var e=d.next,f=c.pending;if(null!==f){var g=f.next;f.next=e;d.next=g}c.pending=d}Wg=null}return a}
	function Nk(a,b){do{var c=Y;try{Qg();Ph.current=ai;if(Sh){for(var d=N.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next}Sh=!1}Rh=0;P=O=N=null;Th=!1;Uh=0;ok.current=null;if(null===c||null===c.return){T=1;qk=b;Y=null;break}a:{var f=a,g=c.return,h=c,k=b;b=Z;h.flags|=32768;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k,m=h,q=m.tag;if(0===(m.mode&1)&&(0===q||11===q||15===q)){var r=m.alternate;r?(m.updateQueue=r.updateQueue,m.memoizedState=r.memoizedState,
	m.lanes=r.lanes):(m.updateQueue=null,m.memoizedState=null)}var y=Vi(g);if(null!==y){y.flags&=-257;Wi(y,g,h,f,b);y.mode&1&&Ti(f,l,b);b=y;k=l;var n=b.updateQueue;if(null===n){var t=new Set;t.add(k);b.updateQueue=t}else n.add(k);break a}else{if(0===(b&1)){Ti(f,l,b);uj();break a}k=Error(p(426))}}else if(I&&h.mode&1){var J=Vi(g);if(null!==J){0===(J.flags&65536)&&(J.flags|=256);Wi(J,g,h,f,b);Jg(Ki(k,h));break a}}f=k=Ki(k,h);4!==T&&(T=2);null===tk?tk=[f]:tk.push(f);f=g;do{switch(f.tag){case 3:f.flags|=65536;
	b&=-b;f.lanes|=b;var x=Oi(f,k,b);fh(f,x);break a;case 1:h=k;var w=f.type,u=f.stateNode;if(0===(f.flags&128)&&("function"===typeof w.getDerivedStateFromError||null!==u&&"function"===typeof u.componentDidCatch&&(null===Si||!Si.has(u)))){f.flags|=65536;b&=-b;f.lanes|=b;var F=Ri(f,h,b);fh(f,F);break a}}f=f.return}while(null!==f)}Tk(c)}catch(na){b=na;Y===c&&null!==c&&(Y=c=c.return);continue}break}while(1)}function Kk(){var a=nk.current;nk.current=ai;return null===a?ai:a}
	function uj(){if(0===T||3===T||2===T)T=4;null===R||0===(hh&268435455)&&0===(rk&268435455)||Dk(R,Z)}function Jk(a,b){var c=K;K|=2;var d=Kk();if(R!==a||Z!==b)vk=null,Lk(a,b);do try{Uk();break}catch(e){Nk(a,e)}while(1);Qg();K=c;nk.current=d;if(null!==Y)throw Error(p(261));R=null;Z=0;return T}function Uk(){for(;null!==Y;)Vk(Y)}function Mk(){for(;null!==Y&&!cc();)Vk(Y)}function Vk(a){var b=Wk(a.alternate,a,gj);a.memoizedProps=a.pendingProps;null===b?Tk(a):Y=b;ok.current=null}
	function Tk(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&32768)){if(c=Fj(c,b,gj),null!==c){Y=c;return}}else{c=Jj(c,b);if(null!==c){c.flags&=32767;Y=c;return}if(null!==a)a.flags|=32768,a.subtreeFlags=0,a.deletions=null;else{T=6;Y=null;return}}b=b.sibling;if(null!==b){Y=b;return}Y=b=a}while(null!==b);0===T&&(T=5)}function Qk(a,b,c){var d=C,e=pk.transition;try{pk.transition=null,C=1,Xk(a,b,c,d)}finally{pk.transition=e,C=d}return null}
	function Xk(a,b,c,d){do Ik();while(null!==xk);if(0!==(K&6))throw Error(p(327));c=a.finishedWork;var e=a.finishedLanes;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(p(177));a.callbackNode=null;a.callbackPriority=0;var f=c.lanes|c.childLanes;Bc(a,f);a===R&&(Y=R=null,Z=0);0===(c.subtreeFlags&2064)&&0===(c.flags&2064)||wk||(wk=!0,Gk(hc,function(){Ik();return null}));f=0!==(c.flags&15990);if(0!==(c.subtreeFlags&15990)||f){f=pk.transition;pk.transition=null;
	var g=C;C=1;var h=K;K|=4;ok.current=null;Pj(a,c);ek(c,a);Oe(Df);dd=!!Cf;Df=Cf=null;a.current=c;ik(c,a,e);dc();K=h;C=g;pk.transition=f}else a.current=c;wk&&(wk=!1,xk=a,yk=e);f=a.pendingLanes;0===f&&(Si=null);mc(c.stateNode,d);Ek(a,B());if(null!==b)for(d=a.onRecoverableError,c=0;c<b.length;c++)e=b[c],d(e.value,{componentStack:e.stack,digest:e.digest});if(Pi)throw Pi=!1,a=Qi,Qi=null,a;0!==(yk&1)&&0!==a.tag&&Ik();f=a.pendingLanes;0!==(f&1)?a===Ak?zk++:(zk=0,Ak=a):zk=0;jg();return null}
	function Ik(){if(null!==xk){var a=Dc(yk),b=pk.transition,c=C;try{pk.transition=null;C=16>a?16:a;if(null===xk)var d=!1;else{a=xk;xk=null;yk=0;if(0!==(K&6))throw Error(p(331));var e=K;K|=4;for(V=a.current;null!==V;){var f=V,g=f.child;if(0!==(V.flags&16)){var h=f.deletions;if(null!==h){for(var k=0;k<h.length;k++){var l=h[k];for(V=l;null!==V;){var m=V;switch(m.tag){case 0:case 11:case 15:Qj(8,m,f)}var q=m.child;if(null!==q)q.return=m,V=q;else for(;null!==V;){m=V;var r=m.sibling,y=m.return;Tj(m);if(m===
	l){V=null;break}if(null!==r){r.return=y;V=r;break}V=y}}}var n=f.alternate;if(null!==n){var t=n.child;if(null!==t){n.child=null;do{var J=t.sibling;t.sibling=null;t=J}while(null!==t)}}V=f}}if(0!==(f.subtreeFlags&2064)&&null!==g)g.return=f,V=g;else b:for(;null!==V;){f=V;if(0!==(f.flags&2048))switch(f.tag){case 0:case 11:case 15:Qj(9,f,f.return)}var x=f.sibling;if(null!==x){x.return=f.return;V=x;break b}V=f.return}}var w=a.current;for(V=w;null!==V;){g=V;var u=g.child;if(0!==(g.subtreeFlags&2064)&&null!==
	u)u.return=g,V=u;else b:for(g=w;null!==V;){h=V;if(0!==(h.flags&2048))try{switch(h.tag){case 0:case 11:case 15:Rj(9,h)}}catch(na){W(h,h.return,na)}if(h===g){V=null;break b}var F=h.sibling;if(null!==F){F.return=h.return;V=F;break b}V=h.return}}K=e;jg();if(lc&&"function"===typeof lc.onPostCommitFiberRoot)try{lc.onPostCommitFiberRoot(kc,a)}catch(na){}d=!0}return d}finally{C=c,pk.transition=b}}return!1}function Yk(a,b,c){b=Ki(c,b);b=Oi(a,b,1);a=dh(a,b,1);b=L();null!==a&&(Ac(a,1,b),Ek(a,b))}
	function W(a,b,c){if(3===a.tag)Yk(a,a,c);else for(;null!==b;){if(3===b.tag){Yk(b,a,c);break}else if(1===b.tag){var d=b.stateNode;if("function"===typeof b.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Si||!Si.has(d))){a=Ki(c,a);a=Ri(b,a,1);b=dh(b,a,1);a=L();null!==b&&(Ac(b,1,a),Ek(b,a));break}}b=b.return}}
	function Ui(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=L();a.pingedLanes|=a.suspendedLanes&c;R===a&&(Z&c)===c&&(4===T||3===T&&(Z&130023424)===Z&&500>B()-gk?Lk(a,0):sk|=c);Ek(a,b)}function Zk(a,b){0===b&&(0===(a.mode&1)?b=1:(b=sc,sc<<=1,0===(sc&130023424)&&(sc=4194304)));var c=L();a=Zg(a,b);null!==a&&(Ac(a,b,c),Ek(a,c))}function vj(a){var b=a.memoizedState,c=0;null!==b&&(c=b.retryLane);Zk(a,c)}
	function ck(a,b){var c=0;switch(a.tag){case 13:var d=a.stateNode;var e=a.memoizedState;null!==e&&(c=e.retryLane);break;case 19:d=a.stateNode;break;default:throw Error(p(314));}null!==d&&d.delete(b);Zk(a,c)}var Wk;
	Wk=function(a,b,c){if(null!==a)if(a.memoizedProps!==b.pendingProps||Wf.current)Ug=!0;else{if(0===(a.lanes&c)&&0===(b.flags&128))return Ug=!1,zj(a,b,c);Ug=0!==(a.flags&131072)?!0:!1}else Ug=!1,I&&0!==(b.flags&1048576)&&ug(b,ng,b.index);b.lanes=0;switch(b.tag){case 2:var d=b.type;jj(a,b);a=b.pendingProps;var e=Yf(b,H.current);Tg(b,c);e=Xh(null,b,d,a,e,c);var f=bi();b.flags|=1;"object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof?(b.tag=1,b.memoizedState=null,b.updateQueue=
	null,Zf(d)?(f=!0,cg(b)):f=!1,b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null,ah(b),e.updater=nh,b.stateNode=e,e._reactInternals=b,rh(b,d,a,c),b=kj(null,b,d,!0,f,c)):(b.tag=0,I&&f&&vg(b),Yi(null,b,e,c),b=b.child);return b;case 16:d=b.elementType;a:{jj(a,b);a=b.pendingProps;e=d._init;d=e(d._payload);b.type=d;e=b.tag=$k(d);a=Lg(d,a);switch(e){case 0:b=dj(null,b,d,a,c);break a;case 1:b=ij(null,b,d,a,c);break a;case 11:b=Zi(null,b,d,a,c);break a;case 14:b=aj(null,b,d,Lg(d.type,a),c);break a}throw Error(p(306,
	d,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Lg(d,e),dj(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Lg(d,e),ij(a,b,d,e,c);case 3:a:{lj(b);if(null===a)throw Error(p(387));d=b.pendingProps;f=b.memoizedState;e=f.element;bh(a,b);gh(b,d,null,c);var g=b.memoizedState;d=g.element;if(f.isDehydrated)if(f={element:d,isDehydrated:!1,cache:g.cache,pendingSuspenseBoundaries:g.pendingSuspenseBoundaries,transitions:g.transitions},b.updateQueue.baseState=
	f,b.memoizedState=f,b.flags&256){e=Ki(Error(p(423)),b);b=mj(a,b,d,c,e);break a}else if(d!==e){e=Ki(Error(p(424)),b);b=mj(a,b,d,c,e);break a}else for(yg=Lf(b.stateNode.containerInfo.firstChild),xg=b,I=!0,zg=null,c=Ch(b,null,d,c),b.child=c;c;)c.flags=c.flags&-3|4096,c=c.sibling;else{Ig();if(d===e){b=$i(a,b,c);break a}Yi(a,b,d,c)}b=b.child}return b;case 5:return Kh(b),null===a&&Eg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ef(d,e)?g=null:null!==f&&Ef(d,f)&&(b.flags|=32),
	hj(a,b),Yi(a,b,g,c),b.child;case 6:return null===a&&Eg(b),null;case 13:return pj(a,b,c);case 4:return Ih(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Bh(b,null,d,c):Yi(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Lg(d,e),Zi(a,b,d,e,c);case 7:return Yi(a,b,b.pendingProps,c),b.child;case 8:return Yi(a,b,b.pendingProps.children,c),b.child;case 12:return Yi(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;f=b.memoizedProps;
	g=e.value;G(Mg,d._currentValue);d._currentValue=g;if(null!==f)if(He(f.value,g)){if(f.children===e.children&&!Wf.current){b=$i(a,b,c);break a}}else for(f=b.child,null!==f&&(f.return=b);null!==f;){var h=f.dependencies;if(null!==h){g=f.child;for(var k=h.firstContext;null!==k;){if(k.context===d){if(1===f.tag){k=ch(-1,c&-c);k.tag=2;var l=f.updateQueue;if(null!==l){l=l.shared;var m=l.pending;null===m?k.next=k:(k.next=m.next,m.next=k);l.pending=k}}f.lanes|=c;k=f.alternate;null!==k&&(k.lanes|=c);Sg(f.return,
	c,b);h.lanes|=c;break}k=k.next}}else if(10===f.tag)g=f.type===b.type?null:f.child;else if(18===f.tag){g=f.return;if(null===g)throw Error(p(341));g.lanes|=c;h=g.alternate;null!==h&&(h.lanes|=c);Sg(g,c,b);g=f.sibling}else g=f.child;if(null!==g)g.return=f;else for(g=f;null!==g;){if(g===b){g=null;break}f=g.sibling;if(null!==f){f.return=g.return;g=f;break}g=g.return}f=g}Yi(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,d=b.pendingProps.children,Tg(b,c),e=Vg(e),d=d(e),b.flags|=1,Yi(a,b,d,c),
	b.child;case 14:return d=b.type,e=Lg(d,b.pendingProps),e=Lg(d.type,e),aj(a,b,d,e,c);case 15:return cj(a,b,b.type,b.pendingProps,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Lg(d,e),jj(a,b),b.tag=1,Zf(d)?(a=!0,cg(b)):a=!1,Tg(b,c),ph(b,d,e),rh(b,d,e,c),kj(null,b,d,!0,a,c);case 19:return yj(a,b,c);case 22:return ej(a,b,c)}throw Error(p(156,b.tag));};function Gk(a,b){return ac(a,b)}
	function al(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.subtreeFlags=this.flags=0;this.deletions=null;this.childLanes=this.lanes=0;this.alternate=null}function Bg(a,b,c,d){return new al(a,b,c,d)}function bj(a){a=a.prototype;return!(!a||!a.isReactComponent)}
	function $k(a){if("function"===typeof a)return bj(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Da)return 11;if(a===Ga)return 14}return 2}
	function wh(a,b){var c=a.alternate;null===c?(c=Bg(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.subtreeFlags=0,c.deletions=null);c.flags=a.flags&14680064;c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
	c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function yh(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bj(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ya:return Ah(c.children,e,f,b);case za:g=8;e|=8;break;case Aa:return a=Bg(12,c,b,e|2),a.elementType=Aa,a.lanes=f,a;case Ea:return a=Bg(13,c,b,e),a.elementType=Ea,a.lanes=f,a;case Fa:return a=Bg(19,c,b,e),a.elementType=Fa,a.lanes=f,a;case Ia:return qj(c,e,f,b);default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case Ba:g=10;break a;case Ca:g=9;break a;case Da:g=11;
	break a;case Ga:g=14;break a;case Ha:g=16;d=null;break a}throw Error(p(130,null==a?a:typeof a,""));}b=Bg(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function Ah(a,b,c,d){a=Bg(7,a,d,b);a.lanes=c;return a}function qj(a,b,c,d){a=Bg(22,a,d,b);a.elementType=Ia;a.lanes=c;a.stateNode={isHidden:!1};return a}function xh(a,b,c){a=Bg(6,a,null,b);a.lanes=c;return a}
	function zh(a,b,c){b=Bg(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function bl(a,b,c,d,e){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.callbackNode=this.pendingContext=this.context=null;this.callbackPriority=0;this.eventTimes=zc(0);this.expirationTimes=zc(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=zc(0);this.identifierPrefix=d;this.onRecoverableError=e;this.mutableSourceEagerHydrationData=
	null}function cl(a,b,c,d,e,f,g,h,k){a=new bl(a,b,c,h,k);1===b?(b=1,!0===f&&(b|=8)):b=0;f=Bg(3,null,null,b);a.current=f;f.stateNode=a;f.memoizedState={element:d,isDehydrated:c,cache:null,transitions:null,pendingSuspenseBoundaries:null};ah(f);return a}function dl(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:wa,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	function el(a){if(!a)return Vf;a=a._reactInternals;a:{if(Vb(a)!==a||1!==a.tag)throw Error(p(170));var b=a;do{switch(b.tag){case 3:b=b.stateNode.context;break a;case 1:if(Zf(b.type)){b=b.stateNode.__reactInternalMemoizedMergedChildContext;break a}}b=b.return}while(null!==b);throw Error(p(171));}if(1===a.tag){var c=a.type;if(Zf(c))return bg(a,c,b)}return b}
	function fl(a,b,c,d,e,f,g,h,k){a=cl(c,d,!0,a,e,f,g,h,k);a.context=el(null);c=a.current;d=L();e=lh(c);f=ch(d,e);f.callback=void 0!==b&&null!==b?b:null;dh(c,f,e);a.current.lanes=e;Ac(a,e,d);Ek(a,d);return a}function gl(a,b,c,d){var e=b.current,f=L(),g=lh(e);c=el(c);null===b.context?b.context=c:b.pendingContext=c;b=ch(f,g);b.payload={element:a};d=void 0===d?null:d;null!==d&&(b.callback=d);a=dh(e,b,g);null!==a&&(mh(a,e,g,f),eh(a,e,g));return g}
	function hl(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function il(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b}}function jl(a,b){il(a,b);(a=a.alternate)&&il(a,b)}function kl(){return null}var ll="function"===typeof reportError?reportError:function(a){console.error(a)};function ml(a){this._internalRoot=a}
	nl.prototype.render=ml.prototype.render=function(a){var b=this._internalRoot;if(null===b)throw Error(p(409));gl(a,b,null,null)};nl.prototype.unmount=ml.prototype.unmount=function(){var a=this._internalRoot;if(null!==a){this._internalRoot=null;var b=a.containerInfo;Sk(function(){gl(null,a,null,null)});b[uf]=null}};function nl(a){this._internalRoot=a}
	nl.prototype.unstable_scheduleHydration=function(a){if(a){var b=Hc();a={blockedOn:null,target:a,priority:b};for(var c=0;c<Qc.length&&0!==b&&b<Qc[c].priority;c++);Qc.splice(c,0,a);0===c&&Vc(a)}};function ol(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType)}function pl(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function ql(){}
	function rl(a,b,c,d,e){if(e){if("function"===typeof d){var f=d;d=function(){var a=hl(g);f.call(a)}}var g=fl(b,d,a,0,null,!1,!1,"",ql);a._reactRootContainer=g;a[uf]=g.current;sf(8===a.nodeType?a.parentNode:a);Sk();return g}for(;e=a.lastChild;)a.removeChild(e);if("function"===typeof d){var h=d;d=function(){var a=hl(k);h.call(a)}}var k=cl(a,0,!1,null,null,!1,!1,"",ql);a._reactRootContainer=k;a[uf]=k.current;sf(8===a.nodeType?a.parentNode:a);Sk(function(){gl(b,k,c,d)});return k}
	function sl(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f;if("function"===typeof e){var h=e;e=function(){var a=hl(g);h.call(a)}}gl(b,g,a,e)}else g=rl(c,b,a,e,d);return hl(g)}Ec=function(a){switch(a.tag){case 3:var b=a.stateNode;if(b.current.memoizedState.isDehydrated){var c=tc(b.pendingLanes);0!==c&&(Cc(b,c|1),Ek(b,B()),0===(K&6)&&(Hj=B()+500,jg()))}break;case 13:Sk(function(){var b=Zg(a,1);if(null!==b){var c=L();mh(b,a,1,c)}}),jl(a,1)}};
	Fc=function(a){if(13===a.tag){var b=Zg(a,134217728);if(null!==b){var c=L();mh(b,a,134217728,c)}jl(a,134217728)}};Gc=function(a){if(13===a.tag){var b=lh(a),c=Zg(a,b);if(null!==c){var d=L();mh(c,a,b,d)}jl(a,b)}};Hc=function(){return C};Ic=function(a,b){var c=C;try{return C=a,b()}finally{C=c}};
	yb=function(a,b,c){switch(b){case "input":bb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(p(90));Wa(d);bb(d,e)}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1)}};Gb=Rk;Hb=Sk;
	var tl={usingClientEntryPoint:!1,Events:[Cb,ue,Db,Eb,Fb,Rk]},ul={findFiberByHostInstance:Wc,bundleType:0,version:"18.2.0",rendererPackageName:"react-dom"};
	var vl={bundleType:ul.bundleType,version:ul.version,rendererPackageName:ul.rendererPackageName,rendererConfig:ul.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setErrorHandler:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ua.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=Zb(a);return null===a?null:a.stateNode},findFiberByHostInstance:ul.findFiberByHostInstance||
	kl,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null,reconcilerVersion:"18.2.0-next-9e3b772b8-20220608"};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var wl=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!wl.isDisabled&&wl.supportsFiber)try{kc=wl.inject(vl),lc=wl}catch(a){}}exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=tl;
	exports.createPortal=function(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!ol(b))throw Error(p(200));return dl(a,b,null,c)};exports.createRoot=function(a,b){if(!ol(a))throw Error(p(299));var c=!1,d="",e=ll;null!==b&&void 0!==b&&(!0===b.unstable_strictMode&&(c=!0),void 0!==b.identifierPrefix&&(d=b.identifierPrefix),void 0!==b.onRecoverableError&&(e=b.onRecoverableError));b=cl(a,1,!1,null,null,c,!1,d,e);a[uf]=b.current;sf(8===a.nodeType?a.parentNode:a);return new ml(b)};
	exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(p(188));a=Object.keys(a).join(",");throw Error(p(268,a));}a=Zb(b);a=null===a?null:a.stateNode;return a};exports.flushSync=function(a){return Sk(a)};exports.hydrate=function(a,b,c){if(!pl(b))throw Error(p(200));return sl(null,a,b,!0,c)};
	exports.hydrateRoot=function(a,b,c){if(!ol(a))throw Error(p(405));var d=null!=c&&c.hydratedSources||null,e=!1,f="",g=ll;null!==c&&void 0!==c&&(!0===c.unstable_strictMode&&(e=!0),void 0!==c.identifierPrefix&&(f=c.identifierPrefix),void 0!==c.onRecoverableError&&(g=c.onRecoverableError));b=fl(b,null,a,1,null!=c?c:null,e,!1,f,g);a[uf]=b.current;sf(a);if(d)for(a=0;a<d.length;a++)c=d[a],e=c._getVersion,e=e(c._source),null==b.mutableSourceEagerHydrationData?b.mutableSourceEagerHydrationData=[c,e]:b.mutableSourceEagerHydrationData.push(c,
	e);return new nl(b)};exports.render=function(a,b,c){if(!pl(b))throw Error(p(200));return sl(null,a,b,!1,c)};exports.unmountComponentAtNode=function(a){if(!pl(a))throw Error(p(40));return a._reactRootContainer?(Sk(function(){sl(null,null,a,!1,function(){a._reactRootContainer=null;a[uf]=null})}),!0):!1};exports.unstable_batchedUpdates=Rk;
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!pl(c))throw Error(p(200));if(null==a||void 0===a._reactInternals)throw Error(p(38));return sl(a,b,c,!1,d)};exports.version="18.2.0-next-9e3b772b8-20220608";


/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var m = __webpack_require__(37);
	if (true) {
	  exports.createRoot = m.createRoot;
	  exports.hydrateRoot = m.hydrateRoot;
	} else {
	  var i = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
	  exports.createRoot = function(c, o) {
	    i.usingClientEntryPoint = true;
	    try {
	      return m.createRoot(c, o);
	    } finally {
	      i.usingClientEntryPoint = false;
	    }
	  };
	  exports.hydrateRoot = function(c, h, o) {
	    i.usingClientEntryPoint = true;
	    try {
	      return m.hydrateRoot(c, h, o);
	    } finally {
	      i.usingClientEntryPoint = false;
	    }
	  };
	}


/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var l, s;
	if (true) {
	  l = __webpack_require__(1140);
	  s = __webpack_require__(1141);
	} else {
	  l = require('./cjs/react-dom-server-legacy.browser.development.js');
	  s = require('./cjs/react-dom-server.browser.development.js');
	}
	
	exports.version = l.version;
	exports.renderToString = l.renderToString;
	exports.renderToStaticMarkup = l.renderToStaticMarkup;
	exports.renderToNodeStream = l.renderToNodeStream;
	exports.renderToStaticNodeStream = l.renderToStaticNodeStream;
	exports.renderToReadableStream = s.renderToReadableStream;


/***/ },
/* 1145 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = FeatureFlag;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Context = __webpack_require__(493);
	
	var _FeatureFlagRenderer = __webpack_require__(1147);
	
	var _FeatureFlagRenderer2 = _interopRequireDefault(_FeatureFlagRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FeatureFlag(props) {
	  return _react2.default.createElement(
	    _Context.LaunchDarklyConsumer,
	    null,
	    function (config) {
	      if (config) {
	        return _react2.default.createElement(_FeatureFlagRenderer2.default, _extends({}, config, props));
	      }
	
	      return null;
	    }
	  );
	}

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _utils = __webpack_require__(494);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FeatureFlagRenderer = function (_Component) {
	  _inherits(FeatureFlagRenderer, _Component);
	
	  function FeatureFlagRenderer(props) {
	    _classCallCheck(this, FeatureFlagRenderer);
	
	    var _this = _possibleConstructorReturn(this, (FeatureFlagRenderer.__proto__ || Object.getPrototypeOf(FeatureFlagRenderer)).call(this, props));
	
	    var _this$props = _this.props,
	        flagKey = _this$props.flagKey,
	        clientOptions = _this$props.clientOptions;
	
	    var bootstrap = clientOptions && clientOptions.bootstrap;
	
	    _this.state = {
	      checkFeatureFlagComplete: false,
	      flagValue: bootstrap && (typeof bootstrap === "undefined" ? "undefined" : _typeof(bootstrap)) === "object" && bootstrap.hasOwnProperty(flagKey) ? bootstrap[flagKey] : false
	    };
	    return _this;
	  }
	
	  _createClass(FeatureFlagRenderer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _props = this.props,
	          clientId = _props.clientId,
	          user = _props.user,
	          clientOptions = _props.clientOptions;
	
	
	      this._isMounted = true;
	
	      if (clientOptions && clientOptions.disableClient) {
	        return;
	      }
	
	      // Only initialize the launch darkly js-client when in browser,
	      // can not be initialized on SSR due to dependency on XMLHttpRequest.
	      var ldClient = (0, _utils.ldClientWrapper)(clientId, user, clientOptions);
	
	      this.checkFeatureFlag(ldClient);
	      this.listenFlagChangeEvent(ldClient);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderLogic();
	    }
	  }, {
	    key: "renderLogic",
	    value: function renderLogic() {
	      var _state = this.state,
	          flagValue = _state.flagValue,
	          checkFeatureFlagComplete = _state.checkFeatureFlagComplete;
	      var _props2 = this.props,
	          renderFeatureCallback = _props2.renderFeatureCallback,
	          renderDefaultCallback = _props2.renderDefaultCallback,
	          initialRenderCallback = _props2.initialRenderCallback;
	
	
	      if (flagValue) {
	        return renderFeatureCallback(flagValue);
	      } else if (checkFeatureFlagComplete && renderDefaultCallback) {
	        return renderDefaultCallback();
	      }
	
	      if (initialRenderCallback) {
	        return initialRenderCallback();
	      }
	
	      return null;
	    }
	  }, {
	    key: "checkFeatureFlag",
	    value: function checkFeatureFlag(ldClient) {
	      var _this2 = this;
	
	      var flagKey = this.props.flagKey;
	
	
	      ldClient.onReady(function () {
	        var flagValue = ldClient.variation(flagKey, false);
	        _this2.setStateFlagValue(flagValue);
	      });
	    }
	  }, {
	    key: "listenFlagChangeEvent",
	    value: function listenFlagChangeEvent(ldClient) {
	      var _this3 = this;
	
	      var flagKey = this.props.flagKey;
	
	
	      ldClient.on("change:" + flagKey, function (value) {
	        _this3.setStateFlagValue(value);
	      });
	    }
	  }, {
	    key: "setStateFlagValue",
	    value: function setStateFlagValue(flagValue) {
	      var flagKey = this.props.flagKey;
	
	      var typeFlagValue = typeof flagValue === "undefined" ? "undefined" : _typeof(flagValue);
	      var defaultState = { checkFeatureFlagComplete: true };
	      var override = (0, _utils.ldOverrideFlag)(flagKey, typeFlagValue);
	
	      // Due to this function being called within a callback, we can run into issues
	      // where we try to set the state for an unmounted component. Since `isMounted()` is deprecated
	      // as part of a React class, we can create our own way to manage it within the protoype.
	      // See https://github.com/facebook/react/issues/5465#issuecomment-157888325 for more info
	      if (!this._isMounted) {
	        return;
	      }
	
	      if (typeof override !== "undefined") {
	        // Override is set for this flag key, use override instead
	        this.setState(_extends({ flagValue: override }, defaultState));
	      } else if (flagValue) {
	        this.setState(_extends({ flagValue: flagValue }, defaultState));
	      } else {
	        this.setState(_extends({ flagValue: false }, defaultState));
	      }
	    }
	  }]);
	
	  return FeatureFlagRenderer;
	}(_react.Component);
	
	exports.default = FeatureFlagRenderer;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LaunchDarkly;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Context = __webpack_require__(493);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LaunchDarkly(props) {
	  var clientId = props.clientId,
	      user = props.user,
	      children = props.children,
	      clientOptions = props.clientOptions;
	
	
	  var config = null;
	
	  // if clientId or user do not exist we still want to
	  // render the Consumer component but we want value
	  // to be null.
	  if (clientId && user) {
	    config = {
	      clientId: clientId,
	      user: user,
	      clientOptions: clientOptions
	    };
	  }
	
	  return _react2.default.createElement(
	    _Context.LaunchDarklyProvider,
	    { value: config },
	    children
	  );
	}

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});var react=__webpack_require__(2),reactDom=__webpack_require__(37);function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	
	  _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	  // Also cover shadowRoot node by checking current.host
	
	
	  while (current.parentNode || current.host) {
	    // Only check normal node without shadowRoot
	    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode || current.host;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = {};
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions.passive = !instance.props.preventDefault;
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class = /*#__PURE__*/function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.__getComponentNode = function () {
	        var instance = _this.getInstance();
	
	        if (config && typeof config.setClickOutsideRef === 'function') {
	          return config.setClickOutsideRef()(instance);
	        }
	
	        if (typeof instance.setClickOutsideRef === 'function') {
	          return instance.setClickOutsideRef();
	        }
	
	        return reactDom.findDOMNode(instance);
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = this.__getComponentNode();
	    }
	    /**
	     * Remove all document's event listeners for this component
	     */
	    ;
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    }
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	    ;
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _this$props = this.props;
	          _this$props.excludeScrollbar;
	          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}exports.IGNORE_CLASS_NAME=IGNORE_CLASS_NAME;exports.default=onClickOutsideHOC;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Popper;
	exports.placements = exports.InnerPopper = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(204));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(42));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(138));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var _deepEqual = _interopRequireDefault(__webpack_require__(1036));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _popper = _interopRequireDefault(__webpack_require__(1092));
	
	var _Manager = __webpack_require__(190);
	
	var _utils = __webpack_require__(495);
	
	var initialStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  opacity: 0,
	  pointerEvents: 'none'
	};
	var initialArrowStyle = {};
	
	var InnerPopper =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerPopper, _React$Component);
	
	  function InnerPopper() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
	      data: undefined,
	      placement: undefined
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "popperInstance", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "popperNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "arrowNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setPopperNode", function (popperNode) {
	      if (!popperNode || _this.popperNode === popperNode) return;
	      (0, _utils.setRef)(_this.props.innerRef, popperNode);
	      _this.popperNode = popperNode;
	
	      _this.updatePopperInstance();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "setArrowNode", function (arrowNode) {
	      _this.arrowNode = arrowNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "updateStateModifier", {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        var placement = data.placement;
	
	        _this.setState({
	          data: data,
	          placement: placement
	        });
	
	        return data;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getOptions", function () {
	      return {
	        placement: _this.props.placement,
	        eventsEnabled: _this.props.eventsEnabled,
	        positionFixed: _this.props.positionFixed,
	        modifiers: (0, _extends2.default)({}, _this.props.modifiers, {
	          arrow: (0, _extends2.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
	            enabled: !!_this.arrowNode,
	            element: _this.arrowNode
	          }),
	          applyStyle: {
	            enabled: false
	          },
	          updateStateModifier: _this.updateStateModifier
	        })
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPopperStyle", function () {
	      return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extends2.default)({
	        position: _this.state.data.offsets.popper.position
	      }, _this.state.data.styles);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getPopperPlacement", function () {
	      return !_this.state.data ? undefined : _this.state.placement;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getArrowStyle", function () {
	      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getOutOfBoundariesState", function () {
	      return _this.state.data ? _this.state.data.hide : undefined;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "destroyPopperInstance", function () {
	      if (!_this.popperInstance) return;
	
	      _this.popperInstance.destroy();
	
	      _this.popperInstance = null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "updatePopperInstance", function () {
	      _this.destroyPopperInstance();
	
	      var _assertThisInitialize = (0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)),
	          popperNode = _assertThisInitialize.popperNode;
	
	      var referenceElement = _this.props.referenceElement;
	      if (!referenceElement || !popperNode) return;
	      _this.popperInstance = new _popper.default(referenceElement, popperNode, _this.getOptions());
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "scheduleUpdate", function () {
	      if (_this.popperInstance) {
	        _this.popperInstance.scheduleUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = InnerPopper.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If the Popper.js options have changed, update the instance (destroy + create)
	    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !(0, _deepEqual.default)(this.props.modifiers, prevProps.modifiers, {
	      strict: true
	    })) {
	      // develop only check that modifiers isn't being updated needlessly
	      if (false) {
	        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && (0, _utils.shallowEqual)(this.props.modifiers, prevProps.modifiers)) {
	          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
	        }
	      }
	
	      this.updatePopperInstance();
	    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
	      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
	    } // A placement difference in state means popper determined a new placement
	    // apart from the props value. By the time the popper element is rendered with
	    // the new position Popper has already measured it, if the place change triggers
	    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
	
	
	    if (prevState.placement !== this.state.placement) {
	      this.scheduleUpdate();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	    this.destroyPopperInstance();
	  };
	
	  _proto.render = function render() {
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.setPopperNode,
	      style: this.getPopperStyle(),
	      placement: this.getPopperPlacement(),
	      outOfBoundaries: this.getOutOfBoundariesState(),
	      scheduleUpdate: this.scheduleUpdate,
	      arrowProps: {
	        ref: this.setArrowNode,
	        style: this.getArrowStyle()
	      }
	    });
	  };
	
	  return InnerPopper;
	}(React.Component);
	
	exports.InnerPopper = InnerPopper;
	(0, _defineProperty2.default)(InnerPopper, "defaultProps", {
	  placement: 'bottom',
	  eventsEnabled: true,
	  referenceElement: undefined,
	  positionFixed: false
	});
	var placements = _popper.default.placements;
	exports.placements = placements;
	
	function Popper(_ref) {
	  var referenceElement = _ref.referenceElement,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["referenceElement"]);
	  return React.createElement(_Manager.ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
	    return React.createElement(InnerPopper, (0, _extends2.default)({
	      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
	    }, props));
	  });
	}

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(36);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Reference;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(42));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(138));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(10));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(4));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _warning = _interopRequireDefault(__webpack_require__(1153));
	
	var _Manager = __webpack_require__(190);
	
	var _utils = __webpack_require__(495);
	
	var InnerReference =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerReference, _React$Component);
	
	  function InnerReference() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "refHandler", function (node) {
	      (0, _utils.setRef)(_this.props.innerRef, node);
	      (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
	    });
	    return _this;
	  }
	
	  var _proto = InnerReference.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	  };
	
	  _proto.render = function render() {
	    (0, _warning.default)(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.refHandler
	    });
	  };
	
	  return InnerReference;
	}(React.Component);
	
	function Reference(props) {
	  return React.createElement(_Manager.ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
	    return React.createElement(InnerReference, (0, _extends2.default)({
	      setReferenceNode: setReferenceNode
	    }, props));
	  });
	}

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(36);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "placements", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.placements;
	  }
	});
	Object.defineProperty(exports, "Manager", {
	  enumerable: true,
	  get: function get() {
	    return _Manager.default;
	  }
	});
	Object.defineProperty(exports, "Reference", {
	  enumerable: true,
	  get: function get() {
	    return _Reference.default;
	  }
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(1150));
	
	var _Manager = _interopRequireDefault(__webpack_require__(190));
	
	var _Reference = _interopRequireDefault(__webpack_require__(1151));

/***/ },
/* 1153 */
543,
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(37);
	var createClass = __webpack_require__(77);
	var QuillMixin = __webpack_require__(496);
	var find = __webpack_require__(506);
	var some = __webpack_require__(1244);
	var isEqual = __webpack_require__(509);
	var T = __webpack_require__(11);
	var DOM = __webpack_require__(491);
	
	var QuillComponent = createClass({
	
		displayName: 'Quill',
	
		mixins: [ QuillMixin ],
	
		propTypes: {
			id: T.string,
			className: T.string,
			theme: T.string,
			style: T.object,
			readOnly: T.bool,
			value: T.oneOfType([T.string, T.shape({ops: T.array})]),
			defaultValue: T.oneOfType([T.string, T.shape({ops: T.array})]),
			placeholder: T.string,
			tabIndex: T.number,
			bounds: T.oneOfType([T.string, T.element]),
			onChange: T.func,
			onChangeSelection: T.func,
			onFocus: T.func,
			onBlur: T.func,
			onKeyPress: T.func,
			onKeyDown: T.func,
			onKeyUp: T.func,
			preserveWhitespace: T.bool,
	
			modules: function(props) {
				var isNotObject = T.object.apply(this, arguments);
				if (isNotObject) return isNotObject;
	
				if (
					props.modules && 
					props.modules.toolbar &&
					props.modules.toolbar[0] &&
					props.modules.toolbar[0].type
				) return new Error(
					'Since v1.0.0, React Quill will not create a custom toolbar for you ' +
					'anymore. Create a toolbar explictly, or let Quill create one. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
				);
			},
	
			toolbar: function(props) {
				if ('toolbar' in props) return new Error(
					'The `toolbar` prop has been deprecated. Use `modules.toolbar` instead. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100'
				);
			},
	
			formats: function(props) {
				var isNotArrayOfString = T.arrayOf(T.string).apply(this, arguments);
	
				if (isNotArrayOfString) return new Error(
					'You cannot specify custom `formats` anymore. Use Parchment instead.  ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			styles: function(props) {
				if ('styles' in props) return new Error(
					'The `styles` prop has been deprecated. Use custom stylesheets instead. ' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			pollInterval: function(props) {
				if ('pollInterval' in props) return new Error(
					'The `pollInterval` property does not have any effect anymore. ' +
					'You can safely remove it from your props.' +
					'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v100.'
				);
			},
	
			children: function(props) {
				// Validate that the editor has only one child element and it is not a <textarea>
				var isNotASingleElement = T.element.apply(this, arguments);
				if (isNotASingleElement) return new Error(
					'The Quill editing area can only be composed of a single React element.'
				);
	
				if (React.Children.count(props.children)) {
					var child = React.Children.only(props.children);
					if (child.type === 'textarea') return new Error(
						'Quill does not support editing on a <textarea>. Use a <div> instead.'
					);
				}
			}
		},
			
		/*
		Changing one of these props should cause a full re-render.
		*/
		dirtyProps: [
			'modules',
			'formats',
			'bounds',
			'theme',
			'children',
		],
	
		/*
		Changing one of these props should cause a regular update.
		*/
		cleanProps: [
			'id',
			'className',
			'style',
			'placeholder',
			'tabIndex',
			'onChange',
			'onChangeSelection',
			'onFocus',
			'onBlur',
			'onKeyPress',
			'onKeyDown',
			'onKeyUp',
		],
	
		getDefaultProps: function() {
			return {
				theme: 'snow',
				modules: {},
			};
		},
	
		/*
		We consider the component to be controlled if `value` is being sent in props.
		*/
		isControlled: function() {
			return 'value' in this.props;
		},
	
		getInitialState: function() {
			return {
				generation: 0,
				value: this.isControlled()
					? this.props.value
					: this.props.defaultValue
			};
		},
	
		componentWillReceiveProps: function(nextProps, nextState) {
			var editor = this.editor;
	
			// If the component is unmounted and mounted too quickly
			// an error is thrown in setEditorContents since editor is
			// still undefined. Must check if editor is undefined
			// before performing this call.
			if (!editor) return;
			
			// Update only if we've been passed a new `value`.
			// This leaves components using `defaultValue` alone.
			if ('value' in nextProps) {
				var currentContents = this.getEditorContents();
				var nextContents = nextProps.value;
	
				if (nextContents === this.lastDeltaChangeSet) throw new Error(
					'You are passing the `delta` object from the `onChange` event back ' +
					'as `value`. You most probably want `editor.getContents()` instead. ' +
					'See: https://github.com/zenoamaro/react-quill#using-deltas'
				);
	
				// NOTE: Seeing that Quill is missing a way to prevent
				//       edits, we have to settle for a hybrid between
				//       controlled and uncontrolled mode. We can't prevent
				//       the change, but we'll still override content
				//       whenever `value` differs from current state.
				// NOTE: Comparing an HTML string and a Quill Delta will always trigger 
				//       a change, regardless of whether they represent the same document.
				if (!this.isEqualValue(nextContents, currentContents)) {
					this.setEditorContents(editor, nextContents);
				}
			}
			
			// We can update readOnly state in-place.
			if ('readOnly' in nextProps) {
				if (nextProps.readOnly !== this.props.readOnly) {
					this.setEditorReadOnly(editor, nextProps.readOnly);
				}
			}
	
			// If we need to regenerate the component, we can avoid a detailed
			// in-place update step, and just let everything rerender.
			if (this.shouldComponentRegenerate(nextProps, nextState)) {
				return this.regenerate();
			}
		},
	
		componentDidMount: function() {
			this.editor = this.createEditor(
				this.getEditingArea(),
				this.getEditorConfig()
			);
			// Restore editor from Quill's native formats in regeneration scenario
			if (this.quillDelta) {
				this.editor.setContents(this.quillDelta);
				this.editor.setSelection(this.quillSelection);		
				this.editor.focus();
				this.quillDelta = this.quillSelection = null;
				return;
			}
			if (this.state.value) {
				this.setEditorContents(this.editor, this.state.value);
				return;
			}
		},
	
		componentWillUnmount: function() {
			var editor; if ((editor = this.getEditor())) {
				this.unhookEditor(editor);
				this.editor = null;
			}
		},
	
		shouldComponentUpdate: function(nextProps, nextState) {
			var self = this;
	
			// If the component has been regenerated, we already know we should update.
			if (this.state.generation !== nextState.generation) {
				return true;
			}
			
			// Compare props that require React updating the DOM.
			return some(this.cleanProps, function(prop) {
				// Note that `isEqual` compares deeply, making it safe to perform
				// non-immutable updates, at the cost of performance.
				return !isEqual(nextProps[prop], self.props[prop]);
			});
		},
	
		shouldComponentRegenerate: function(nextProps, nextState) {
			var self = this;
			// Whenever a `dirtyProp` changes, the editor needs reinstantiation.
			return some(this.dirtyProps, function(prop) {
				// Note that `isEqual` compares deeply, making it safe to perform
				// non-immutable updates, at the cost of performance.
				return !isEqual(nextProps[prop], self.props[prop]);
			});
		},
	
		/*
		If we could not update settings from the new props in-place, we have to tear
		down everything and re-render from scratch.
		*/
		componentWillUpdate: function(nextProps, nextState) {
			if (this.state.generation !== nextState.generation) {
				this.componentWillUnmount();
			}
		},
	
		componentDidUpdate: function(prevProps, prevState) {
			if (this.state.generation !== prevState.generation) {
				this.componentDidMount();
			}
		},
	
		getEditorConfig: function() {
			return {
				bounds:       this.props.bounds,
				formats:      this.props.formats,
				modules:      this.props.modules,
				placeholder:  this.props.placeholder,
				readOnly:     this.props.readOnly,
	      			scrollingContainer: this.props.scrollingContainer,
				tabIndex:     this.props.tabIndex,
				theme:        this.props.theme,
			};
		},
	
		getEditor: function() {
			return this.editor;
		},
	
		getEditingArea: function () {
			return ReactDOM.findDOMNode(this.editingArea);
		},
	
		getEditorContents: function() {
			return this.state.value;
		},
	
		getEditorSelection: function() {
			return this.state.selection;
		},
	
		/*
		True if the value is a Delta instance or a Delta look-alike.
		*/
		isDelta: function(value) {
			return value && value.ops;
		},
	
		/*
		Special comparison function that knows how to compare Deltas.
		*/
		isEqualValue: function(value, nextValue) {
			if (this.isDelta(value) && this.isDelta(nextValue)) {
				return isEqual(value.ops, nextValue.ops);
			} else {
				return isEqual(value, nextValue);
			}
		},
	
		/*
		Regenerating the editor will cause the whole tree, including the container,
		to be cleaned up and re-rendered from scratch.
		*/
		regenerate: function() {
			// Cache selection and contents in Quill's native format to be restored later
			this.quillDelta = this.editor.getContents();
			this.quillSelection = this.editor.getSelection();
			this.setState({
				generation: this.state.generation + 1,
			});
		},
	
		/*
		Renders an editor area, unless it has been provided one to clone.
		*/
		renderEditingArea: function() {
			var self = this;
			var children = this.props.children;
			var preserveWhitespace = this.props.preserveWhitespace;
	
			var properties = {
				key: this.state.generation,
				tabIndex: this.props.tabIndex,
				ref: function(element) { self.editingArea = element },
			};
	
			var customElement = React.Children.count(children)
				? React.Children.only(children)
				: null;
			var defaultElement = preserveWhitespace ? DOM.pre : DOM.div;
			var editingArea = customElement
				? React.cloneElement(customElement, properties)
				: defaultElement(properties);
	
			return editingArea;
		},
	
		render: function() {
			return DOM.div({
				id: this.props.id,
				style: this.props.style,
				key: this.state.generation,
				className: ['quill'].concat(this.props.className).join(' '),
				onKeyPress: this.props.onKeyPress,
				onKeyDown: this.props.onKeyDown,
				onKeyUp: this.props.onKeyUp },
				this.renderEditingArea()
			);
		},
	
		onEditorChangeText: function(value, delta, source, editor) {
			var currentContents = this.getEditorContents();
	
			// We keep storing the same type of value as what the user gives us,
			// so that value comparisons will be more stable and predictable.
			var nextContents = this.isDelta(currentContents)
				? editor.getContents()
				: editor.getHTML();
			
			if (!this.isEqualValue(nextContents, currentContents)) {
				// Taint this `delta` object, so we can recognize whether the user
				// is trying to send it back as `value`, preventing a likely loop.
				this.lastDeltaChangeSet = delta;
	
				this.setState({ value: nextContents });
	
				if (this.props.onChange) {
					this.props.onChange(value, delta, source, editor);
				}
			}
		},
	
		onEditorChangeSelection: function(nextSelection, source, editor) {
			var currentSelection = this.getEditorSelection();
			var hasGainedFocus = !currentSelection && nextSelection;
			var hasLostFocus = currentSelection && !nextSelection;
	
			if (isEqual(nextSelection, currentSelection)) {
				return;
			}
			
			this.setState({ selection: nextSelection });
			
			if (this.props.onChangeSelection) {
				this.props.onChangeSelection(nextSelection, source, editor);
			}
	
			if (hasGainedFocus && this.props.onFocus) {
				this.props.onFocus(nextSelection, source, editor);
			} else if (hasLostFocus && this.props.onBlur) {
				this.props.onBlur(currentSelection, source, editor);
			}
		},
	
		focus: function() {
			this.editor.focus();
		},
	
		blur: function() {
			this.setEditorSelection(this.editor, null);
		}
	
	});
	
	module.exports = QuillComponent;


/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	/*
	React-Quill v1.0.0
	https://github.com/zenoamaro/react-quill
	*/
	var Quill = __webpack_require__(478);
	var Component = __webpack_require__(1154);
	
	module.exports = Component;
	module.exports.default = Component;
	module.exports.Quill = Quill;
	module.exports.Mixin = __webpack_require__(496);
	module.exports.Toolbar = __webpack_require__(1156);


/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	/*
	QuillToolbar is deprecated. Consider switching to the official Quill
	toolbar format, or providing your own toolbar instead. 
	See https://quilljs.com/docs/modules/toolbar
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	var ReactDOMServer = __webpack_require__(1144);
	var createClass = __webpack_require__(77);
	var find = __webpack_require__(506);
	var isEqual = __webpack_require__(509);
	var T = __webpack_require__(11);
	var DOM = __webpack_require__(491);
	
	var defaultColors = [
		'rgb(  0,   0,   0)', 'rgb(230,   0,   0)', 'rgb(255, 153,   0)',
		'rgb(255, 255,   0)', 'rgb(  0, 138,   0)', 'rgb(  0, 102, 204)',
		'rgb(153,  51, 255)', 'rgb(255, 255, 255)', 'rgb(250, 204, 204)',
		'rgb(255, 235, 204)', 'rgb(255, 255, 204)', 'rgb(204, 232, 204)',
		'rgb(204, 224, 245)', 'rgb(235, 214, 255)', 'rgb(187, 187, 187)',
		'rgb(240, 102, 102)', 'rgb(255, 194, 102)', 'rgb(255, 255, 102)',
		'rgb(102, 185, 102)', 'rgb(102, 163, 224)', 'rgb(194, 133, 255)',
		'rgb(136, 136, 136)', 'rgb(161,   0,   0)', 'rgb(178, 107,   0)',
		'rgb(178, 178,   0)', 'rgb(  0,  97,   0)', 'rgb(  0,  71, 178)',
		'rgb(107,  36, 178)', 'rgb( 68,  68,  68)', 'rgb( 92,   0,   0)',
		'rgb(102,  61,   0)', 'rgb(102, 102,   0)', 'rgb(  0,  55,   0)',
		'rgb(  0,  41, 102)', 'rgb( 61,  20,  10)',
	].map(function(color){ return { value: color } });
	
	var defaultItems = [
	
		{ label:'Formats', type:'group', items: [
			{ label:'Font', type:'font', items: [
				{ label:'Sans Serif',  value:'sans-serif', selected:true },
				{ label:'Serif',       value:'serif' },
				{ label:'Monospace',   value:'monospace' }
			]},
			{ label:'Size', type:'size', items: [
				{ label:'Small',  value:'10px' },
				{ label:'Normal', value:'13px', selected:true },
				{ label:'Large',  value:'18px' },
				{ label:'Huge',   value:'32px' }
			]},
			{ label:'Alignment', type:'align', items: [
				{ label:'', value:'', selected:true },
				{ label:'', value:'center' },
				{ label:'', value:'right' },
				{ label:'', value:'justify' }
			]}
		]},
	
		{ label:'Text', type:'group', items: [
			{ type:'bold', label:'Bold' },
			{ type:'italic', label:'Italic' },
			{ type:'strike', label:'Strike' },
			{ type:'underline', label:'Underline' },
			{ type:'color', label:'Color', items:defaultColors },
			{ type:'background', label:'Background color', items:defaultColors },
			{ type:'link', label:'Link' }
		]},
	
		{ label:'Blocks', type:'group', items: [
			{ type:'list', value:'bullet' },
			{ type:'list', value:'ordered' }
		]},
	
		{ label:'Blocks', type:'group', items: [
			{ type:'image', label:'Image' }
		]}
	
	];
	
	var QuillToolbar = createClass({
	
		displayName: 'Quill Toolbar',
	
		propTypes: {
			id:        T.string,
			className: T.string,
			style:     T.object,
			items:     T.array
		},
	
		getDefaultProps: function() {
			return {
				items: defaultItems
			};
		},
	
		componentDidMount: function() {
			console.warn(
				'QuillToolbar is deprecated. Consider switching to the official Quill ' +
				'toolbar format, or providing your own toolbar instead. ' +
				'See: https://github.com/zenoamaro/react-quill#upgrading-to-react-quill-v1-0-0'
			);
		},
	
		shouldComponentUpdate: function(nextProps, nextState) {
			return !isEqual(nextProps, this.props);
		},
	
		renderGroup: function(item, key) {
			return DOM.span({
				key: item.label || key,
				className:'ql-formats' },
				item.items.map(this.renderItem)
			);
		},
	
		renderChoiceItem: function(item, key) {
			return DOM.option({
				key: item.label || item.value || key,
				value: item.value },
				item.label
			);
		},
	
		renderChoices: function(item, key) {
			var choiceItems = item.items.map(this.renderChoiceItem);
			var selectedItem = find(item.items, function(item){ return item.selected });
			var attrs = {
				key: item.label || key,
				title: item.label,
				className: 'ql-'+item.type,
				value: selectedItem.value,
			};
			return DOM.select(attrs, choiceItems);
		},
	
		renderButton: function(item, key) {
			return DOM.button({
				type: 'button',
				key: item.label || item.value || key,
				value: item.value,
				className: 'ql-'+item.type,
				title: item.label },
				item.children
			);
		},
	
		renderAction: function(item, key) {
			return DOM.button({
				key: item.label || item.value || key,
				className: 'ql-'+item.type,
				title: item.label },
				item.children
			);
		},
	
		/* jshint maxcomplexity: false */
		renderItem: function(item, key) {
			switch (item.type) {
				case 'group':
					return this.renderGroup(item, key);
				case 'font':
				case 'header':
				case 'align':
				case 'size':
				case 'color':
				case 'background':
					return this.renderChoices(item, key);
				case 'bold':
				case 'italic':
				case 'underline':
				case 'strike':
				case 'link':
				case 'list':
				case 'bullet':
				case 'ordered':
				case 'indent':
				case 'image':
				case 'video':
					return this.renderButton(item, key);
				default:
					return this.renderAction(item, key);
			}
		},
	
		getClassName: function() {
			return 'quill-toolbar ' + (this.props.className||'');
		},
	
		render: function() {
			var children = this.props.items.map(this.renderItem);
			var html = children.map(ReactDOMServer.renderToStaticMarkup).join('');
			return DOM.div({
				id: this.props.id,
				className: this.getClassName(),
				style: this.props.style,
				dangerouslySetInnerHTML: { __html:html }
			});
		},
	
	});
	
	module.exports = QuillToolbar;
	QuillToolbar.defaultItems = defaultItems;
	QuillToolbar.defaultColors = defaultColors;


/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(78),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1203),
	    hashDelete = __webpack_require__(1204),
	    hashGet = __webpack_require__(1205),
	    hashHas = __webpack_require__(1206),
	    hashSet = __webpack_require__(1207);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(78),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(78),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(192),
	    setCacheAdd = __webpack_require__(1228),
	    setCacheHas = __webpack_require__(1229);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(53);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(78),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1164 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1185),
	    isArguments = __webpack_require__(507),
	    isArray = __webpack_require__(54),
	    isBuffer = __webpack_require__(508),
	    isIndex = __webpack_require__(195),
	    isTypedArray = __webpack_require__(511);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 1166 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 1167 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(1171),
	    createBaseEach = __webpack_require__(1191);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 1169 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1192);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1170),
	    keys = __webpack_require__(134);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1167),
	    isArray = __webpack_require__(54);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 1173 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(95),
	    isObjectLike = __webpack_require__(97);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(497),
	    equalArrays = __webpack_require__(501),
	    equalByTag = __webpack_require__(1194),
	    equalObjects = __webpack_require__(1195),
	    getTag = __webpack_require__(1200),
	    isArray = __webpack_require__(54),
	    isBuffer = __webpack_require__(508),
	    isTypedArray = __webpack_require__(511);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(497),
	    baseIsEqual = __webpack_require__(193);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(510),
	    isMasked = __webpack_require__(1210),
	    isObject = __webpack_require__(96),
	    toSource = __webpack_require__(505);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(95),
	    isLength = __webpack_require__(198),
	    isObjectLike = __webpack_require__(97);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(1211),
	    nativeKeys = __webpack_require__(1224);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1176),
	    getMatchData = __webpack_require__(1197),
	    matchesStrictComparable = __webpack_require__(504);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(193),
	    get = __webpack_require__(1239),
	    hasIn = __webpack_require__(1240),
	    isKey = __webpack_require__(196),
	    isStrictComparable = __webpack_require__(503),
	    matchesStrictComparable = __webpack_require__(504),
	    toKey = __webpack_require__(131);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1182 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(499);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(1168);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 1185 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(127),
	    arrayMap = __webpack_require__(1166),
	    isArray = __webpack_require__(54),
	    isSymbol = __webpack_require__(133);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(1237);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ },
/* 1188 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 1189 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(53);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(132);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1192 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(194),
	    isArrayLike = __webpack_require__(132),
	    keys = __webpack_require__(134);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(127),
	    Uint8Array = __webpack_require__(1162),
	    eq = __webpack_require__(197),
	    equalArrays = __webpack_require__(501),
	    mapToArray = __webpack_require__(1222),
	    setToArray = __webpack_require__(1230);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1196);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1172),
	    getSymbols = __webpack_require__(1199),
	    keys = __webpack_require__(134);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(503),
	    keys = __webpack_require__(134);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(127);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1164),
	    stubArray = __webpack_require__(1245);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1157),
	    Map = __webpack_require__(191),
	    Promise = __webpack_require__(1159),
	    Set = __webpack_require__(1160),
	    WeakMap = __webpack_require__(1163),
	    baseGetTag = __webpack_require__(95),
	    toSource = __webpack_require__(505);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 1201 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(500),
	    isArguments = __webpack_require__(507),
	    isArray = __webpack_require__(54),
	    isIndex = __webpack_require__(195),
	    isLength = __webpack_require__(198),
	    toKey = __webpack_require__(131);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(130);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1204 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(130);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(130);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(130);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(197),
	    isArrayLike = __webpack_require__(132),
	    isIndex = __webpack_require__(195),
	    isObject = __webpack_require__(96);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 1209 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1190);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1211 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 1212 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(128);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(128);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(128);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(128);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1158),
	    ListCache = __webpack_require__(126),
	    Map = __webpack_require__(191);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(129);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(129);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(129);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(129);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1222 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1242);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(1227);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(502);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)(module)))

/***/ },
/* 1226 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1227 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 1228 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1229 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1230 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(126);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1232 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1233 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1234 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(126),
	    Map = __webpack_require__(191),
	    MapCache = __webpack_require__(192);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1223);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 1237 */
/***/ function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(1169),
	    baseIteratee = __webpack_require__(194),
	    toInteger = __webpack_require__(1248);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(499);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1173),
	    hasPath = __webpack_require__(1202);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1241 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(192);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1182),
	    basePropertyDeep = __webpack_require__(1183),
	    isKey = __webpack_require__(196),
	    toKey = __webpack_require__(131);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(498),
	    baseIteratee = __webpack_require__(194),
	    baseSome = __webpack_require__(1184),
	    isArray = __webpack_require__(54),
	    isIterateeCall = __webpack_require__(1208);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 1245 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 1246 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(1249);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(1247);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(1187),
	    isObject = __webpack_require__(96),
	    isSymbol = __webpack_require__(133);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1186);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(1255),React=_interopDefault(__webpack_require__(2)),history=__webpack_require__(1253);__webpack_require__(11),__webpack_require__(137);var invariant=_interopDefault(__webpack_require__(136));function _extends(){return(_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),_setPrototypeOf(e.prototype.constructor=e,t)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function _objectWithoutPropertiesLoose(e,t){if(null==e)return{};var r,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)r=a[o],0<=t.indexOf(r)||(n[r]=e[r]);return n}var BrowserRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,t=arguments.length,r=new Array(t),o=0;o<t;o++)r[o]=arguments[o];return(e=n.call.apply(n,[this].concat(r))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,t){return"function"==typeof e?e(t):e},normalizeToLocation=function(e,t){return"string"==typeof e?history.createLocation(e,null,null,t):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,t){var r=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(t){try{n&&n(t)}catch(e){throw t.preventDefault(),e}t.defaultPrevented||0!==t.button||i&&"_self"!==i||isModifiedEvent(t)||(t.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&t||r,React.createElement("a",c)}),Link=forwardRef(function(e,a){var t=e.component,i=void 0===t?LinkAnchor:t,c=e.replace,u=e.to,f=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(r){r||invariant(!1);var o=r.history,e=normalizeToLocation(resolveToLocation(u,r.location),r.location),t=e?o.createHref(e):"",n=_extends({},s,{href:t,navigate:function(){var e=resolveToLocation(u,r.location),t=history.createPath(r.location)===history.createPath(normalizeToLocation(e));(c||t?o.replace:o.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||f:n.innerRef=f,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var t=e["aria-current"],l=void 0===t?"page":t,r=e.activeClassName,p=void 0===r?"active":r,R=e.activeStyle,h=e.className,y=e.exact,d=e.isActive,m=e.location,v=e.sensitive,b=e.strict,P=e.style,w=e.to,x=e.innerRef,g=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","sensitive","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var t=m||e.location,r=normalizeToLocation(resolveToLocation(w,t),t),o=r.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(t.pathname,{path:n,exact:y,sensitive:v,strict:b}):null,i=!!(d?d(a,t):a),c="function"==typeof h?h(i):h,u="function"==typeof P?P(i):P;i&&(c=joinClassnames(c,p),u=_extends({},u,R));var f=_extends({"aria-current":i&&l||null,className:c,style:u,to:r},g);return forwardRefShim$1!==forwardRef$1?f.ref=s||x:f.innerRef=x,React.createElement(Link,f)})});Object.defineProperty(exports,"MemoryRouter",{enumerable:!0,get:function(){return reactRouter.MemoryRouter}}),Object.defineProperty(exports,"Prompt",{enumerable:!0,get:function(){return reactRouter.Prompt}}),Object.defineProperty(exports,"Redirect",{enumerable:!0,get:function(){return reactRouter.Redirect}}),Object.defineProperty(exports,"Route",{enumerable:!0,get:function(){return reactRouter.Route}}),Object.defineProperty(exports,"Router",{enumerable:!0,get:function(){return reactRouter.Router}}),Object.defineProperty(exports,"StaticRouter",{enumerable:!0,get:function(){return reactRouter.StaticRouter}}),Object.defineProperty(exports,"Switch",{enumerable:!0,get:function(){return reactRouter.Switch}}),Object.defineProperty(exports,"generatePath",{enumerable:!0,get:function(){return reactRouter.generatePath}}),Object.defineProperty(exports,"matchPath",{enumerable:!0,get:function(){return reactRouter.matchPath}}),Object.defineProperty(exports,"useHistory",{enumerable:!0,get:function(){return reactRouter.useHistory}}),Object.defineProperty(exports,"useLocation",{enumerable:!0,get:function(){return reactRouter.useLocation}}),Object.defineProperty(exports,"useParams",{enumerable:!0,get:function(){return reactRouter.useParams}}),Object.defineProperty(exports,"useRouteMatch",{enumerable:!0,get:function(){return reactRouter.useRouteMatch}}),Object.defineProperty(exports,"withRouter",{enumerable:!0,get:function(){return reactRouter.withRouter}}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(517)),valueEqual=_interopDefault(__webpack_require__(521));__webpack_require__(137);var invariant=_interopDefault(__webpack_require__(136));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 1253 */
[1299, 1252],
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(2)),PropTypes=_interopDefault(__webpack_require__(11)),history=__webpack_require__(1257);__webpack_require__(137);var invariant=_interopDefault(__webpack_require__(136)),pathToRegexp=_interopDefault(__webpack_require__(1090));__webpack_require__(189);var hoistStatics=_interopDefault(__webpack_require__(1048));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),_setPrototypeOf(t.prototype.constructor=t,e)}function _setPrototypeOf(t,e){return(_setPrototypeOf=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},i=Object.keys(t);for(o=0;o<i.length;o++)n=i[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var MAX_SIGNED_31_BIT_INT=1073741823,commonjsGlobal="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:{};function getUniqueId(){var t="__global_unique_id__";return commonjsGlobal[t]=(commonjsGlobal[t]||0)+1}function objectIs(t,e){return t===e?0!==t||1/t==1/e:t!=t&&e!=e}function createEventEmitter(n){var o=[];return{on:function(t){o.push(t)},off:function(e){o=o.filter(function(t){return t!==e})},get:function(){return n},set:function(t,e){n=t,o.forEach(function(t){return t(n,e)})}}}function onlyChild(t){return Array.isArray(t)?t[0]:t}function createReactContext(n,i){var t,e,o="__create-react-context-"+getUniqueId()+"__",r=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).emitter=createEventEmitter(t.props.value),t}_inheritsLoose(t,r);var e=t.prototype;return e.getChildContext=function(){var t;return(t={})[o]=this.emitter,t},e.componentWillReceiveProps=function(t){if(this.props.value!==t.value){var e,n=this.props.value,o=t.value;objectIs(n,o)?e=0:(e="function"==typeof i?i(n,o):MAX_SIGNED_31_BIT_INT,0!==(e|=0)&&this.emitter.set(t.value,e))}},e.render=function(){return this.props.children},t}(React.Component);r.childContextTypes=((t={})[o]=PropTypes.object.isRequired,t);var a=function(r){function t(){for(var n,t=arguments.length,e=new Array(t),o=0;o<t;o++)e[o]=arguments[o];return(n=r.call.apply(r,[this].concat(e))||this).observedBits=void 0,n.state={value:n.getValue()},n.onUpdate=function(t,e){0!=((0|n.observedBits)&e)&&n.setState({value:n.getValue()})},n}_inheritsLoose(t,r);var e=t.prototype;return e.componentWillReceiveProps=function(t){var e=t.observedBits;this.observedBits=null==e?MAX_SIGNED_31_BIT_INT:e},e.componentDidMount=function(){this.context[o]&&this.context[o].on(this.onUpdate);var t=this.props.observedBits;this.observedBits=null==t?MAX_SIGNED_31_BIT_INT:t},e.componentWillUnmount=function(){this.context[o]&&this.context[o].off(this.onUpdate)},e.getValue=function(){return this.context[o]?this.context[o].get():n},e.render=function(){return onlyChild(this.props.children)(this.state.value)},t}(React.Component);return a.contextTypes=((e={})[o]=PropTypes.object,e),{Provider:r,Consumer:a}}var createContext=React.createContext||createReactContext,createNamedContext=function(t){var e=createContext();return e.displayName=t,e},historyContext=createNamedContext("Router-History"),context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){var e=this;this._isMounted=!0,this.unlisten&&this.unlisten(),this.props.staticContext||(this.unlisten=this.props.history.listen(function(t){e._isMounted&&e.setState({location:t})})),this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&(this.unlisten(),this._isMounted=!1,this._pendingLocation=null)},e.render=function(){return React.createElement(context.Provider,{value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}},React.createElement(historyContext.Provider,{children:this.props.children||null,value:this.props.history}))},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var i=t.computedMatch,a=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(i?"string"==typeof a?generatePath(a,i.params):_extends({},a,{pathname:generatePath(a.pathname,i.params)}):a);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:a})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],i={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=i,cacheCount$1++),i}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,i=e.sensitive,l=void 0!==i&&i;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,i=o.exec(u);if(!i)return null;var a=i[0],c=i.slice(1),s=u===a;return p&&!s?null:{path:e,url:"/"===e&&""===a?"/":a,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}function isEmptyChildren(t){return 0===React.Children.count(t)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,i=o.component,a=o.render;return Array.isArray(r)&&isEmptyChildren(r)&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:i?React.createElement(i,n):a?a(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,i=n.context,a=void 0===i?{}:i;a.action=e,a.location=addBasename(r,history.createLocation(t)),a.url=createURL(a.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,i=t.location,a=void 0===i?"/":i,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(a)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,i=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(i.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:i,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(historyContext)}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){var e=useLocation(),n=useContext(context).match;return t?matchPath(e.pathname,t):n}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__HistoryContext=historyContext,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(1254);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ },
/* 1256 */
1252,
/* 1257 */
[1299, 1256],
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1260).enable();
	  window.Promise = __webpack_require__(1259);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1261);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(67);


/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(513);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(513);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1261 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownContent = function (_Component) {
	  _inherits(DropdownContent, _Component);
	
	  function DropdownContent() {
	    _classCallCheck(this, DropdownContent);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(DropdownContent).apply(this, arguments));
	  }
	
	  _createClass(DropdownContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	
	      var dropdownContentProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      dropdownContentProps.className = 'dropdown__content ' + className;
	
	      return _react2.default.createElement(
	        'div',
	        dropdownContentProps,
	        children
	      );
	    }
	  }]);
	
	  return DropdownContent;
	}(_react.Component);
	
	DropdownContent.displayName = 'DropdownContent';
	
	DropdownContent.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string
	};
	
	DropdownContent.defaultProps = {
	  className: ''
	};
	
	exports.default = DropdownContent;

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DropdownTrigger = function (_Component) {
	  _inherits(DropdownTrigger, _Component);
	
	  function DropdownTrigger() {
	    _classCallCheck(this, DropdownTrigger);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(DropdownTrigger).apply(this, arguments));
	  }
	
	  _createClass(DropdownTrigger, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var className = _props.className;
	
	      var dropdownTriggerProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	      dropdownTriggerProps.className = 'dropdown__trigger ' + className;
	
	      return _react2.default.createElement(
	        'a',
	        dropdownTriggerProps,
	        children
	      );
	    }
	  }]);
	
	  return DropdownTrigger;
	}(_react.Component);
	
	DropdownTrigger.displayName = 'DropdownTrigger';
	
	DropdownTrigger.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string
	};
	
	DropdownTrigger.defaultProps = {
	  className: ''
	};
	
	exports.default = DropdownTrigger;

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(77);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(38);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'TabPanel',
	
	  propTypes: {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.string]),
	    className: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    selected: _propTypes2.default.bool,
	    style: _propTypes2.default.object,
	    tabId: _propTypes2.default.string
	  },
	
	  contextTypes: {
	    forceRenderTabPanel: _propTypes2.default.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selected: false,
	      id: null,
	      tabId: null
	    };
	  },
	  render: function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        selected = _props.selected,
	        id = _props.id,
	        tabId = _props.tabId,
	        style = _props.style,
	        attributes = _objectWithoutProperties(_props, ['className', 'children', 'selected', 'id', 'tabId', 'style']);
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs__TabPanel', className, {
	          'ReactTabs__TabPanel--selected': selected
	        }),
	        role: 'tabpanel',
	        id: id,
	        'aria-labelledby': tabId,
	        style: _extends({}, style, { display: selected ? null : 'none' })
	      }),
	      this.context.forceRenderTabPanel || selected ? children : null
	    );
	  }
	});

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(77);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactDom = __webpack_require__(37);
	
	var _classnames = __webpack_require__(38);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _jsStylesheet = __webpack_require__(1057);
	
	var _jsStylesheet2 = _interopRequireDefault(_jsStylesheet);
	
	var _uuid = __webpack_require__(1268);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _childrenPropType = __webpack_require__(1266);
	
	var _childrenPropType2 = _interopRequireDefault(_childrenPropType);
	
	var _Tab = __webpack_require__(135);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// Determine if a node from event.target is a Tab element
	function isTabNode(node) {
	  return node.nodeName === 'LI' && node.getAttribute('role') === 'tab';
	}
	
	// Determine if a tab node is disabled
	function isTabDisabled(node) {
	  return node.getAttribute('aria-disabled') === 'true';
	}
	
	var useDefaultStyles = true;
	
	module.exports = (0, _createReactClass2.default)({
	  displayName: 'Tabs',
	
	  propTypes: {
	    className: _propTypes2.default.string,
	    selectedIndex: _propTypes2.default.number,
	    onSelect: _propTypes2.default.func,
	    focus: _propTypes2.default.bool,
	    children: _childrenPropType2.default,
	    forceRenderTabPanel: _propTypes2.default.bool
	  },
	
	  childContextTypes: {
	    forceRenderTabPanel: _propTypes2.default.bool
	  },
	
	  statics: {
	    setUseDefaultStyles: function setUseDefaultStyles(use) {
	      useDefaultStyles = use;
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selectedIndex: -1,
	      focus: false,
	      forceRenderTabPanel: false
	    };
	  },
	  getInitialState: function getInitialState() {
	    return this.copyPropsToState(this.props, this.state);
	  },
	  getChildContext: function getChildContext() {
	    return {
	      forceRenderTabPanel: this.props.forceRenderTabPanel
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (useDefaultStyles) {
	      (0, _jsStylesheet2.default)(__webpack_require__(1267)); // eslint-disable-line global-require
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var _this = this;
	
	    // Use a transactional update to prevent race conditions
	    // when reading the state in copyPropsToState
	    // See https://github.com/reactjs/react-tabs/issues/51
	    this.setState(function (state) {
	      return _this.copyPropsToState(newProps, state);
	    });
	  },
	  setSelected: function setSelected(index, focus) {
	    // Don't do anything if nothing has changed
	    if (index === this.state.selectedIndex) return;
	    // Check index boundary
	    if (index < 0 || index >= this.getTabsCount()) return;
	
	    // Keep reference to last index for event handler
	    var last = this.state.selectedIndex;
	
	    // Check if the change event handler cancels the tab change
	    var cancel = false;
	
	    // Call change event handler
	    if (typeof this.props.onSelect === 'function') {
	      cancel = this.props.onSelect(index, last) === false;
	    }
	
	    if (!cancel) {
	      // Update selected index
	      this.setState({ selectedIndex: index, focus: focus === true });
	    }
	  },
	  getNextTab: function getNextTab(index) {
	    var count = this.getTabsCount();
	
	    // Look for non-disabled tab from index to the last tab on the right
	    for (var i = index + 1; i < count; i++) {
	      var tab = this.getTab(i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(tab))) {
	        return i;
	      }
	    }
	
	    // If no tab found, continue searching from first on left to index
	    for (var _i = 0; _i < index; _i++) {
	      var _tab = this.getTab(_i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(_tab))) {
	        return _i;
	      }
	    }
	
	    // No tabs are disabled, return index
	    return index;
	  },
	  getPrevTab: function getPrevTab(index) {
	    var i = index;
	
	    // Look for non-disabled tab from index to first tab on the left
	    while (i--) {
	      var tab = this.getTab(i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(tab))) {
	        return i;
	      }
	    }
	
	    // If no tab found, continue searching from last tab on right to index
	    i = this.getTabsCount();
	    while (i-- > index) {
	      var _tab2 = this.getTab(i);
	      if (!isTabDisabled((0, _reactDom.findDOMNode)(_tab2))) {
	        return i;
	      }
	    }
	
	    // No tabs are disabled, return index
	    return index;
	  },
	  getTabsCount: function getTabsCount() {
	    return this.props.children && this.props.children[0] ? _react2.default.Children.count(this.props.children[0].props.children) : 0;
	  },
	  getPanelsCount: function getPanelsCount() {
	    return _react2.default.Children.count(this.props.children.slice(1));
	  },
	  getTabList: function getTabList() {
	    return this.refs.tablist;
	  },
	  getTab: function getTab(index) {
	    return this.refs['tabs-' + index];
	  },
	  getPanel: function getPanel(index) {
	    return this.refs['panels-' + index];
	  },
	  getChildren: function getChildren() {
	    var index = 0;
	    var count = 0;
	    var children = this.props.children;
	    var state = this.state;
	    var tabIds = this.tabIds = this.tabIds || [];
	    var panelIds = this.panelIds = this.panelIds || [];
	    var diff = this.tabIds.length - this.getTabsCount();
	
	    // Add ids if new tabs have been added
	    // Don't bother removing ids, just keep them in case they are added again
	    // This is more efficient, and keeps the uuid counter under control
	    while (diff++ < 0) {
	      tabIds.push((0, _uuid2.default)());
	      panelIds.push((0, _uuid2.default)());
	    }
	
	    // Map children to dynamically setup refs
	    return _react2.default.Children.map(children, function (child) {
	      // null happens when conditionally rendering TabPanel/Tab
	      // see https://github.com/reactjs/react-tabs/issues/37
	      if (child === null) {
	        return null;
	      }
	
	      var result = null;
	
	      // Clone TabList and Tab components to have refs
	      if (count++ === 0) {
	        // TODO try setting the uuid in the "constructor" for `Tab`/`TabPanel`
	        result = (0, _react.cloneElement)(child, {
	          ref: 'tablist',
	          children: _react2.default.Children.map(child.props.children, function (tab) {
	            // null happens when conditionally rendering TabPanel/Tab
	            // see https://github.com/reactjs/react-tabs/issues/37
	            if (tab === null) {
	              return null;
	            }
	
	            var ref = 'tabs-' + index;
	            var id = tabIds[index];
	            var panelId = panelIds[index];
	            var selected = state.selectedIndex === index;
	            var focus = selected && state.focus;
	
	            index++;
	
	            if (tab.type === _Tab2.default) {
	              return (0, _react.cloneElement)(tab, {
	                ref: ref,
	                id: id,
	                panelId: panelId,
	                selected: selected,
	                focus: focus
	              });
	            }
	
	            return tab;
	          })
	        });
	
	        // Reset index for panels
	        index = 0;
	      }
	      // Clone TabPanel components to have refs
	      else {
	          var ref = 'panels-' + index;
	          var id = panelIds[index];
	          var tabId = tabIds[index];
	          var selected = state.selectedIndex === index;
	
	          index++;
	
	          result = (0, _react.cloneElement)(child, {
	            ref: ref,
	            id: id,
	            tabId: tabId,
	            selected: selected
	          });
	        }
	
	      return result;
	    });
	  },
	  handleKeyDown: function handleKeyDown(e) {
	    if (this.isTabFromContainer(e.target)) {
	      var index = this.state.selectedIndex;
	      var preventDefault = false;
	
	      // Select next tab to the left
	      if (e.keyCode === 37 || e.keyCode === 38) {
	        index = this.getPrevTab(index);
	        preventDefault = true;
	      }
	      // Select next tab to the right
	      /* eslint brace-style:0 */
	      else if (e.keyCode === 39 || e.keyCode === 40) {
	          index = this.getNextTab(index);
	          preventDefault = true;
	        }
	
	      // This prevents scrollbars from moving around
	      if (preventDefault) {
	        e.preventDefault();
	      }
	
	      this.setSelected(index, true);
	    }
	  },
	  handleClick: function handleClick(e) {
	    var node = e.target;
	    do {
	      // eslint-disable-line no-cond-assign
	      if (this.isTabFromContainer(node)) {
	        if (isTabDisabled(node)) {
	          return;
	        }
	
	        var index = [].slice.call(node.parentNode.children).indexOf(node);
	        this.setSelected(index);
	        return;
	      }
	    } while ((node = node.parentNode) !== null);
	  },
	
	
	  // This is an anti-pattern, so sue me
	  copyPropsToState: function copyPropsToState(props, state) {
	    var selectedIndex = props.selectedIndex;
	
	    // If no selectedIndex prop was supplied, then try
	    // preserving the existing selectedIndex from state.
	    // If the state has not selectedIndex, default
	    // to the first tab in the TabList.
	    //
	    // TODO: Need automation testing around this
	    // Manual testing can be done using examples/focus
	    // See 'should preserve selectedIndex when typing' in specs/Tabs.spec.js
	    if (selectedIndex === -1) {
	      if (state && state.selectedIndex) {
	        selectedIndex = state.selectedIndex;
	      } else {
	        selectedIndex = 0;
	      }
	    }
	
	    return {
	      selectedIndex: selectedIndex,
	      focus: props.focus
	    };
	  },
	
	
	  /**
	   * Determine if a node from event.target is a Tab element for the current Tabs container.
	   * If the clicked element is not a Tab, it returns false.
	   * If it finds another Tabs container between the Tab and `this`, it returns false.
	   */
	  isTabFromContainer: function isTabFromContainer(node) {
	    // return immediately if the clicked element is not a Tab.
	    if (!isTabNode(node)) {
	      return false;
	    }
	
	    // Check if the first occurrence of a Tabs container is `this` one.
	    var nodeAncestor = node.parentElement;
	    var tabsNode = (0, _reactDom.findDOMNode)(this);
	    do {
	      if (nodeAncestor === tabsNode) return true;else if (nodeAncestor.getAttribute('data-tabs')) break;
	
	      nodeAncestor = nodeAncestor.parentElement;
	    } while (nodeAncestor);
	
	    return false;
	  },
	  render: function render() {
	    var _this2 = this;
	
	    // This fixes an issue with focus management.
	    //
	    // Ultimately, when focus is true, and an input has focus,
	    // and any change on that input causes a state change/re-render,
	    // focus gets sent back to the active tab, and input loses focus.
	    //
	    // Since the focus state only needs to be remembered
	    // for the current render, we can reset it once the
	    // render has happened.
	    //
	    // Don't use setState, because we don't want to re-render.
	    //
	    // See https://github.com/reactjs/react-tabs/pull/7
	    if (this.state.focus) {
	      setTimeout(function () {
	        _this2.state.focus = false;
	      }, 0);
	    }
	
	    var _props = this.props,
	        className = _props.className,
	        attributes = _objectWithoutProperties(_props, ['className']);
	
	    // Delete all known props, so they don't get added to DOM
	
	
	    delete attributes.selectedIndex;
	    delete attributes.onSelect;
	    delete attributes.focus;
	    delete attributes.children;
	    delete attributes.forceRenderTabPanel;
	    delete attributes.onClick;
	    delete attributes.onKeyDown;
	
	    return _react2.default.createElement(
	      'div',
	      _extends({}, attributes, {
	        className: (0, _classnames2.default)('ReactTabs', 'react-tabs', className),
	        onClick: this.handleClick,
	        onKeyDown: this.handleKeyDown,
	        'data-tabs': true
	      }),
	      this.getChildren()
	    );
	  }
	});

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tab = __webpack_require__(135);
	
	var _Tab2 = _interopRequireDefault(_Tab);
	
	var _TabList = __webpack_require__(514);
	
	var _TabList2 = _interopRequireDefault(_TabList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = function childrenPropTypes(props, propName) {
	  var error = void 0;
	  var tabsCount = 0;
	  var panelsCount = 0;
	  var children = props[propName];
	
	  _react2.default.Children.forEach(children, function (child) {
	    // null happens when conditionally rendering TabPanel/Tab
	    // see https://github.com/reactjs/react-tabs/issues/37
	    if (child === null) {
	      return;
	    }
	
	    if (child.type === _TabList2.default) {
	      _react2.default.Children.forEach(child.props.children, function (c) {
	        // null happens when conditionally rendering TabPanel/Tab
	        // see https://github.com/reactjs/react-tabs/issues/37
	        if (c === null) {
	          return;
	        }
	
	        if (c.type === _Tab2.default) {
	          tabsCount++;
	        }
	      });
	    } else if (child.type.displayName === 'TabPanel') {
	      panelsCount++;
	    } else {
	      error = new Error('Expected \'TabList\' or \'TabPanel\' but found \'' + (child.type.displayName || child.type) + '\'');
	    }
	  });
	
	  if (tabsCount !== panelsCount) {
	    error = new Error("There should be an equal number of 'Tabs' and 'TabPanels'." + ('Received ' + tabsCount + ' \'Tabs\' and ' + panelsCount + ' \'TabPanels\'.'));
	  }
	
	  return error;
	};

/***/ },
/* 1267 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  '.react-tabs [role=tablist]': {
	    'border-bottom': '1px solid #aaa',
	    margin: '0 0 10px',
	    padding: '0'
	  },
	
	  '.react-tabs [role=tab]': {
	    display: 'inline-block',
	    border: '1px solid transparent',
	    'border-bottom': 'none',
	    bottom: '-1px',
	    position: 'relative',
	    'list-style': 'none',
	    padding: '6px 12px',
	    cursor: 'pointer'
	  },
	
	  '.react-tabs [role=tab][aria-selected=true]': {
	    background: '#fff',
	    'border-color': '#aaa',
	    color: 'black',
	    'border-radius': '5px 5px 0 0',
	    '-moz-border-radius': '5px 5px 0 0',
	    '-webkit-border-radius': '5px 5px 0 0'
	  },
	
	  '.react-tabs [role=tab][aria-disabled=true]': {
	    color: 'GrayText',
	    cursor: 'default'
	  },
	
	  '.react-tabs [role=tab]:focus': {
	    'box-shadow': '0 0 5px hsl(208, 99%, 50%)',
	    'border-color': 'hsl(208, 99%, 50%)',
	    outline: 'none'
	  },
	
	  '.react-tabs [role=tab]:focus:after': {
	    content: '""',
	    position: 'absolute',
	    height: '5px',
	    left: '-4px',
	    right: '-4px',
	    bottom: '-5px',
	    background: '#fff'
	  }
	};

/***/ },
/* 1268 */
/***/ function(module, exports) {

	"use strict";
	
	// Get a universally unique identifier
	var count = 0;
	module.exports = function uuid() {
	  return "react-tabs-" + count++;
	};

/***/ },
/* 1269 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = calculateNodeHeight;
	/**
	 * calculateNodeHeight(uiTextNode, useCache = false)
	 */
	var browser = typeof window !== 'undefined' && typeof document !== 'undefined';
	var isIE = browser ? !!document.documentElement.currentStyle : false;
	var boxSizingProp = function () {
	  if (!browser) {
	    return 'box-sizing';
	  }
	  var documentStyle = window.getComputedStyle(document.documentElement);
	  // TODO: remove prefixed - they are probably obsolete, were introduced in by df79cf502630744d40233b64cad01770e5584610 in 2014
	  return documentStyle.getPropertyValue('box-sizing') ? 'box-sizing' : documentStyle.getPropertyValue('-moz-box-sizing') ? '-moz-box-sizing' : documentStyle.getPropertyValue('-webkit-box-sizing') ? '-webkit-box-sizing' : 'box-sizing';
	}();
	
	var HIDDEN_TEXTAREA_STYLE = {
	  'min-height': '0',
	  'max-height': 'none',
	  'height': '0',
	  'visibility': 'hidden',
	  'overflow': 'hidden',
	  'position': 'absolute',
	  'z-index': '-1000',
	  'top': '0',
	  'right': '0'
	};
	
	var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', boxSizingProp];
	
	var computedStyleCache = {};
	var hiddenTextarea = void 0;
	
	function calculateNodeHeight(uiTextNode) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  } else if (hiddenTextarea.parentNode === null) {
	    document.body.appendChild(hiddenTextarea);
	  }
	
	  // Copy all CSS properties that have an impact on the height of the content in
	  // the textbox
	
	  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      sizingStyle = _calculateNodeStyling.sizingStyle;
	
	  // Need to have the overflow attribute to hide the scrollbar otherwise
	  // text-lines will not calculated properly as the shadow will technically be
	  // narrower for content
	
	
	  Object.keys(sizingStyle).map(function (key) {
	    hiddenTextarea.style[key] = sizingStyle[key];
	  });
	  Object.keys(HIDDEN_TEXTAREA_STYLE).map(function (key) {
	    hiddenTextarea.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
	  });
	  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';
	
	  var minHeight = -Infinity;
	  var maxHeight = Infinity;
	  var height = hiddenTextarea.scrollHeight;
	
	  if (boxSizing === 'border-box') {
	    // border-box: add border, since height = content + padding + border
	    height = height + borderSize;
	  } else if (boxSizing === 'content-box') {
	    // remove padding, since height = content
	    height = height - paddingSize;
	  }
	
	  if (minRows !== null || maxRows !== null) {
	    // measure height of a textarea with a single row
	    hiddenTextarea.value = 'x';
	    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	    if (minRows !== null) {
	      minHeight = singleRowHeight * minRows;
	      if (boxSizing === 'border-box') {
	        minHeight = minHeight + paddingSize + borderSize;
	      }
	      height = Math.max(minHeight, height);
	    }
	    if (maxRows !== null) {
	      maxHeight = singleRowHeight * maxRows;
	      if (boxSizing === 'border-box') {
	        maxHeight = maxHeight + paddingSize + borderSize;
	      }
	      height = Math.min(maxHeight, height);
	    }
	  }
	  return { height: height, minHeight: minHeight, maxHeight: maxHeight };
	}
	
	function calculateNodeStyling(node) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  // TODO: generate id in constructor + clear cache in componentWillUnmount
	  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
	
	  if (useCache && computedStyleCache[nodeRef]) {
	    return computedStyleCache[nodeRef];
	  }
	
	  var style = window.getComputedStyle(node);
	
	  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
	    obj[name] = style.getPropertyValue(name);
	    return obj;
	  }, {});
	
	  var boxSizing = sizingStyle[boxSizingProp];
	
	  // IE (Edge has already correct behaviour) returns content width as computed width
	  // so we need to add manually padding and border widths
	  if (isIE && boxSizing === 'border-box') {
	    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
	  }
	
	  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);
	
	  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);
	
	  var nodeInfo = {
	    sizingStyle: sizingStyle,
	    paddingSize: paddingSize,
	    borderSize: borderSize,
	    boxSizing: boxSizing
	  };
	
	  if (useCache && nodeRef) {
	    computedStyleCache[nodeRef] = nodeInfo;
	  }
	
	  return nodeInfo;
	}

/***/ },
/* 1270 */
/***/ function(module, exports) {

	/**
	 * @license React
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var l=Symbol.for("react.element"),n=Symbol.for("react.portal"),p=Symbol.for("react.fragment"),q=Symbol.for("react.strict_mode"),r=Symbol.for("react.profiler"),t=Symbol.for("react.provider"),u=Symbol.for("react.context"),v=Symbol.for("react.forward_ref"),w=Symbol.for("react.suspense"),x=Symbol.for("react.memo"),y=Symbol.for("react.lazy"),z=Symbol.iterator;function A(a){if(null===a||"object"!==typeof a)return null;a=z&&a[z]||a["@@iterator"];return"function"===typeof a?a:null}
	var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C=Object.assign,D={};function E(a,b,e){this.props=a;this.context=b;this.refs=D;this.updater=e||B}E.prototype.isReactComponent={};
	E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=D;this.updater=e||B}var H=G.prototype=new F;
	H.constructor=G;C(H,E.prototype);H.isPureReactComponent=!0;var I=Array.isArray,J=Object.prototype.hasOwnProperty,K={current:null},L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,e){var d,c={},k=null,h=null;if(null!=b)for(d in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)J.call(b,d)&&!L.hasOwnProperty(d)&&(c[d]=b[d]);var g=arguments.length-2;if(1===g)c.children=e;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];c.children=f}if(a&&a.defaultProps)for(d in g=a.defaultProps,g)void 0===c[d]&&(c[d]=g[d]);return{$$typeof:l,type:a,key:k,ref:h,props:c,_owner:K.current}}
	function N(a,b){return{$$typeof:l,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===l}function escape(a){var b={"=":"=0",":":"=2"};return"$"+a.replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g;function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
	function R(a,b,e,d,c){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case l:case n:h=!0}}if(h)return h=a,c=c(h),a=""===d?"."+Q(h,0):d,I(c)?(e="",null!=a&&(e=a.replace(P,"$&/")+"/"),R(c,b,e,"",function(a){return a})):null!=c&&(O(c)&&(c=N(c,e+(!c.key||h&&h.key===c.key?"":(""+c.key).replace(P,"$&/")+"/")+a)),b.push(c)),1;h=0;d=""===d?".":d+":";if(I(a))for(var g=0;g<a.length;g++){k=
	a[g];var f=d+Q(k,g);h+=R(k,b,e,f,c)}else if(f=A(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=d+Q(k,g++),h+=R(k,b,e,f,c);else if("object"===k)throw b=String(a),Error("Objects are not valid as a React child (found: "+("[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b)+"). If you meant to render a collection of children, use an array instead.");return h}
	function S(a,b,e){if(null==a)return a;var d=[],c=0;R(a,d,"","",function(a){return b.call(e,a,c++)});return d}function T(a){if(-1===a._status){var b=a._result;b=b();b.then(function(b){if(0===a._status||-1===a._status)a._status=1,a._result=b},function(b){if(0===a._status||-1===a._status)a._status=2,a._result=b});-1===a._status&&(a._status=0,a._result=b)}if(1===a._status)return a._result.default;throw a._result;}
	var U={current:null},V={transition:null},W={ReactCurrentDispatcher:U,ReactCurrentBatchConfig:V,ReactCurrentOwner:K};exports.Children={map:S,forEach:function(a,b,e){S(a,function(){b.apply(this,arguments)},e)},count:function(a){var b=0;S(a,function(){b++});return b},toArray:function(a){return S(a,function(a){return a})||[]},only:function(a){if(!O(a))throw Error("React.Children.only expected to receive a single React element child.");return a}};exports.Component=E;exports.Fragment=p;
	exports.Profiler=r;exports.PureComponent=G;exports.StrictMode=q;exports.Suspense=w;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=W;
	exports.cloneElement=function(a,b,e){if(null===a||void 0===a)throw Error("React.cloneElement(...): The argument must be a React element, but you passed "+a+".");var d=C({},a.props),c=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=K.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)J.call(b,f)&&!L.hasOwnProperty(f)&&(d[f]=void 0===b[f]&&void 0!==g?g[f]:b[f])}var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){g=Array(f);
	for(var m=0;m<f;m++)g[m]=arguments[m+2];d.children=g}return{$$typeof:l,type:a.type,key:c,ref:k,props:d,_owner:h}};exports.createContext=function(a){a={$$typeof:u,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null};a.Provider={$$typeof:t,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};
	exports.forwardRef=function(a){return{$$typeof:v,render:a}};exports.isValidElement=O;exports.lazy=function(a){return{$$typeof:y,_payload:{_status:-1,_result:a},_init:T}};exports.memo=function(a,b){return{$$typeof:x,type:a,compare:void 0===b?null:b}};exports.startTransition=function(a){var b=V.transition;V.transition={};try{a()}finally{V.transition=b}};exports.unstable_act=function(){throw Error("act(...) is not supported in production builds of React.");};
	exports.useCallback=function(a,b){return U.current.useCallback(a,b)};exports.useContext=function(a){return U.current.useContext(a)};exports.useDebugValue=function(){};exports.useDeferredValue=function(a){return U.current.useDeferredValue(a)};exports.useEffect=function(a,b){return U.current.useEffect(a,b)};exports.useId=function(){return U.current.useId()};exports.useImperativeHandle=function(a,b,e){return U.current.useImperativeHandle(a,b,e)};
	exports.useInsertionEffect=function(a,b){return U.current.useInsertionEffect(a,b)};exports.useLayoutEffect=function(a,b){return U.current.useLayoutEffect(a,b)};exports.useMemo=function(a,b){return U.current.useMemo(a,b)};exports.useReducer=function(a,b,e){return U.current.useReducer(a,b,e)};exports.useRef=function(a){return U.current.useRef(a)};exports.useState=function(a){return U.current.useState(a)};exports.useSyncExternalStore=function(a,b,e){return U.current.useSyncExternalStore(a,b,e)};
	exports.useTransition=function(){return U.current.useTransition()};exports.version="18.2.0";


/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(91);
	var callBind = __webpack_require__(168);
	
	var implementation = __webpack_require__(515);
	var getPolyfill = __webpack_require__(516);
	var shim = __webpack_require__(1272);
	
	var flagsBound = callBind(getPolyfill());
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(91).supportsDescriptors;
	var getPolyfill = __webpack_require__(516);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ },
/* 1273 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {/**
	 * @license React
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';function f(a,b){var c=a.length;a.push(b);a:for(;0<c;){var d=c-1>>>1,e=a[d];if(0<g(e,b))a[d]=b,a[c]=e,c=d;else break a}}function h(a){return 0===a.length?null:a[0]}function k(a){if(0===a.length)return null;var b=a[0],c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length,w=e>>>1;d<w;){var m=2*(d+1)-1,C=a[m],n=m+1,x=a[n];if(0>g(C,c))n<e&&0>g(x,C)?(a[d]=x,a[n]=c,d=n):(a[d]=C,a[m]=c,d=m);else if(n<e&&0>g(x,c))a[d]=x,a[n]=c,d=n;else break a}}return b}
	function g(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()}}else{var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q}}var r=[],t=[],u=1,v=null,y=3,z=!1,A=!1,B=!1,D="function"===typeof setTimeout?setTimeout:null,E="function"===typeof clearTimeout?clearTimeout:null,F="undefined"!==typeof setImmediate?setImmediate:null;
	"undefined"!==typeof navigator&&void 0!==navigator.scheduling&&void 0!==navigator.scheduling.isInputPending&&navigator.scheduling.isInputPending.bind(navigator.scheduling);function G(a){for(var b=h(t);null!==b;){if(null===b.callback)k(t);else if(b.startTime<=a)k(t),b.sortIndex=b.expirationTime,f(r,b);else break;b=h(t)}}function H(a){B=!1;G(a);if(!A)if(null!==h(r))A=!0,I(J);else{var b=h(t);null!==b&&K(H,b.startTime-a)}}
	function J(a,b){A=!1;B&&(B=!1,E(L),L=-1);z=!0;var c=y;try{G(b);for(v=h(r);null!==v&&(!(v.expirationTime>b)||a&&!M());){var d=v.callback;if("function"===typeof d){v.callback=null;y=v.priorityLevel;var e=d(v.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?v.callback=e:v===h(r)&&k(r);G(b)}else k(r);v=h(r)}if(null!==v)var w=!0;else{var m=h(t);null!==m&&K(H,m.startTime-b);w=!1}return w}finally{v=null,y=c,z=!1}}var N=!1,O=null,L=-1,P=5,Q=-1;
	function M(){return exports.unstable_now()-Q<P?!1:!0}function R(){if(null!==O){var a=exports.unstable_now();Q=a;var b=!0;try{b=O(!0,a)}finally{b?S():(N=!1,O=null)}}else N=!1}var S;if("function"===typeof F)S=function(){F(R)};else if("undefined"!==typeof MessageChannel){var T=new MessageChannel,U=T.port2;T.port1.onmessage=R;S=function(){U.postMessage(null)}}else S=function(){D(R,0)};function I(a){O=a;N||(N=!0,S())}function K(a,b){L=D(function(){a(exports.unstable_now())},b)}
	exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){A||z||(A=!0,I(J))};
	exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):P=0<a?Math.floor(1E3/a):5};exports.unstable_getCurrentPriorityLevel=function(){return y};exports.unstable_getFirstCallbackNode=function(){return h(r)};exports.unstable_next=function(a){switch(y){case 1:case 2:case 3:var b=3;break;default:b=y}var c=y;y=b;try{return a()}finally{y=c}};exports.unstable_pauseExecution=function(){};
	exports.unstable_requestPaint=function(){};exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=y;y=a;try{return b()}finally{y=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3}e=c+e;a={id:u++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,f(t,a),null===h(r)&&a===h(t)&&(B?(E(L),L=-1):B=!0,K(H,c-d))):(a.sortIndex=e,f(r,a),A||z||(A=!0,I(J)));return a};
	exports.unstable_shouldYield=M;exports.unstable_wrapCallback=function(a){var b=y;return function(){var c=y;y=b;try{return a.apply(this,arguments)}finally{y=c}}};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1280).setImmediate))

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1274);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(66);
	var define = __webpack_require__(175);
	var hasDescriptors = __webpack_require__(120)();
	var gOPD = __webpack_require__(332);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	var $floor = GetIntrinsic('%Math.floor%');
	
	module.exports = function setFunctionLength(fn, length) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
			throw new $TypeError('`length` must be a positive 32-bit integer');
		}
	
		var loose = arguments.length > 2 && !!arguments[2];
	
		var functionLengthIsConfigurable = true;
		var functionLengthIsWritable = true;
		if ('length' in fn && gOPD) {
			var desc = gOPD(fn, 'length');
			if (desc && !desc.configurable) {
				functionLengthIsConfigurable = false;
			}
			if (desc && !desc.writable) {
				functionLengthIsWritable = false;
			}
		}
	
		if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
			if (hasDescriptors) {
				define(fn, 'length', length, true, true);
			} else {
				define(fn, 'length', length);
			}
		}
		return fn;
	};


/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(175);
	var hasDescriptors = __webpack_require__(120)();
	var functionsHaveConfigurableNames = __webpack_require__(1043).functionsHaveConfigurableNames();
	
	var $TypeError = TypeError;
	
	module.exports = function setFunctionName(fn, name) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		var loose = arguments.length > 2 && !!arguments[2];
		if (!loose || functionsHaveConfigurableNames) {
			if (hasDescriptors) {
				define(fn, 'name', name, true, true);
			} else {
				define(fn, 'name', name);
			}
		}
		return fn;
	};


/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(59)))

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(66);
	var callBound = __webpack_require__(167);
	var inspect = __webpack_require__(1084);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	var $WeakMap = GetIntrinsic('%WeakMap%', true);
	var $Map = GetIntrinsic('%Map%', true);
	
	var $weakMapGet = callBound('WeakMap.prototype.get', true);
	var $weakMapSet = callBound('WeakMap.prototype.set', true);
	var $weakMapHas = callBound('WeakMap.prototype.has', true);
	var $mapGet = callBound('Map.prototype.get', true);
	var $mapSet = callBound('Map.prototype.set', true);
	var $mapHas = callBound('Map.prototype.has', true);
	
	/*
	 * This function traverses the list returning the node corresponding to the
	 * given key.
	 *
	 * That node is also moved to the head of the list, so that if it's accessed
	 * again we don't need to traverse the whole list. By doing so, all the recently
	 * used nodes can be accessed relatively quickly.
	 */
	var listGetNode = function (list, key) { // eslint-disable-line consistent-return
		for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
			if (curr.key === key) {
				prev.next = curr.next;
				curr.next = list.next;
				list.next = curr; // eslint-disable-line no-param-reassign
				return curr;
			}
		}
	};
	
	var listGet = function (objects, key) {
		var node = listGetNode(objects, key);
		return node && node.value;
	};
	var listSet = function (objects, key, value) {
		var node = listGetNode(objects, key);
		if (node) {
			node.value = value;
		} else {
			// Prepend the new node to the beginning of the list
			objects.next = { // eslint-disable-line no-param-reassign
				key: key,
				next: objects.next,
				value: value
			};
		}
	};
	var listHas = function (objects, key) {
		return !!listGetNode(objects, key);
	};
	
	module.exports = function getSideChannel() {
		var $wm;
		var $m;
		var $o;
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			get: function (key) { // eslint-disable-line consistent-return
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				} else if ($Map) {
					if ($m) {
						return $mapGet($m, key);
					}
				} else {
					if ($o) { // eslint-disable-line no-lonely-if
						return listGet($o, key);
					}
				}
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				} else if ($Map) {
					if ($m) {
						return $mapHas($m, key);
					}
				} else {
					if ($o) { // eslint-disable-line no-lonely-if
						return listHas($o, key);
					}
				}
				return false;
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if ($Map) {
					if (!$m) {
						$m = new $Map();
					}
					$mapSet($m, key, value);
				} else {
					if (!$o) {
						/*
						 * Initialize the linked list as an empty node, so that we don't have
						 * to special-case handling of the first node: we can always refer to
						 * it as (previous node).next, instead of something like (list).head
						 */
						$o = { key: {}, next: null };
					}
					listSet($o, key, value);
				}
			}
		};
		return channel;
	};


/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1278);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1281 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1282 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYgAAAA7CAYAAABhah1JAAABG2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS41LjAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+Gkqr6gAADCNpQ0NQRGlzcGxheQAASImll3dU08kWx+dXUggJLRABKaE3QYp06b0ISAdRCUmAUGJICCp2dFHBtYsoioquiKi4FkAWFRHFwiLY+4KKysq6WLCh8iYFdN3z3j9vzpnffHLnzp3vzO/+cmYAUPbOYeeKUBUAcvn5wuggX2ZiUjKT1AtQQAKqgAwUWGyRwCcqKhzAMtr+s7y7CRBJe81aEuvf/f+zqHK4IjYASBTkfI6InQu5DQBcky0Q5gNAuA/tRrPzBZCJEn91IRQIWV3CGTI2l3CajCdLfWKj/SDDmGQqiyXMAEApBdqZBewMGEdpPmRbPofHh3wAsic7k8WBPAB5Qm7uLMjKmpDN076Lk/GPmGljMVmsjDGWrUVayP48kSCHNXd0nWTgD3hABAQgB7DAmPn/L7k54tE5DWGlZgqDoyV7APdxX/asMAlTITfz0yIiIatBvsDjSP0lfDdTHBwn9x9gi/zgHgIGgK+fw/IPg6wDmSHOjvORsz1LKB0L/dEIXn5IrJzThLOi5fHRAn5ORLg8zopMbsgoV3JFATGjPum8wBDIMPPQY4WZsQkynWhbAS8+ArIS5C5RdkyYfOzDwky/iFEfoThaotkY8tt0YWC0zAfTlGcfjI/ZsFnSueB7xLzzM2ODZWOxRK4oMXxUA4frHyDTgHG4/Di5Ngxmm2+0fGyxICdK7o9VcnOComX7jB0WFcSMjr2aDxNOtg/YoyxWaJR8rneC/KhYmTYcBeHAD+YAE4hhTQOzQBbgdQ40DMBfsp5AmBdCkAG4wFpuGR2RIO3hw2cMKAR/QeLCTBod5yvt5YICaP8yZpU9rUG6tLdAOiIbPIWci2vjnrg7Hg6f3rDa4y646+g4pvLorMQAoj8xmBhItBjTwYaqc2AVwkz+ty0Mtly4OokW/ugavsUjPCV0Ex4RbhB6CHdAPHgijSL3mskrEv6gnAmmgB4YLVC+ujQYs3/UBzeFqh1xX9wD6ofacQauDazxSXAlPrgXXJsjtH6vUDym7dte/jifRPX365HblSyVHOUq0sbejN+Y149R/L7bIw5sw370xFZgR7F27Ax2EWvGGgATO401Yh3YSQmPZcITaSaMzhYt1ZYN4/BGfWxrbfttP/8wN0s+v2S/RPncOfmSj8FvlmCukJeRmc/0EQhyuMwQPttmAtPe1s4ZAMl/veyv4w1D+h+OMC59s+W1AOBaAo0Z32wsIwBOPAWA/u6bzeg1TPe1AJzsYouFBTIbLnkQAAUow69CC+gBI2AO12MPnIA78AYBIBREgliQBGbAHc8EuVDzbDAfLAHFoBSsBZvAVrAD7Ab7wEFwBDSAZnAGnAeXQRe4Ae7BvOgDL8AgeAeGEQQhITSEjmgh+ogJYoXYIy6IJxKAhCPRSBKSimQgfESMzEeWIqXIemQrsgupQX5FTiBnkItIN3IH6UX6kdfIJxRDqag6qouaohNRF9QHDUNj0eloBpqHFqLL0NVoOVqFHkDr0TPoZfQG2oO+QIcwgCliDMwAs8ZcMD8sEkvG0jEhthArwcqwKuwQ1gTf8zWsBxvAPuJEnI4zcWuYm8F4HM7G8/CF+Cp8K74Pr8fb8Gt4Lz6IfyXQCDoEK4IbIYSQSMggzCYUE8oIewnHCefgd9NHeEckEhlEM6Iz/C6TiFnEecRVxO3EOmILsZv4mDhEIpG0SFYkD1IkiUXKJxWTtpAOkE6TrpL6SB/IimR9sj05kJxM5pOLyGXk/eRT5KvkZ+RhBRUFEwU3hUgFjsJchTUKexSaFK4o9CkMU1QpZhQPSiwli7KEUk45RDlHuU95o6ioaKjoqjhVkae4WLFc8bDiBcVexY9UNaol1Y+aQhVTV1OrqS3UO9Q3NBrNlOZNS6bl01bTamhnaQ9pH5ToSjZKIUocpUVKFUr1SleVXiorKJso+yjPUC5ULlM+qnxFeUBFQcVUxU+FpbJQpULlhMotlSFVuqqdaqRqruoq1f2qF1Wfq5HUTNUC1Dhqy9R2q51Ve0zH6EZ0PzqbvpS+h36O3qdOVDdTD1HPUi9VP6jeqT6ooaYxSSNeY45GhcZJjR4GxjBlhDByGGsYRxg3GZ/G6Y7zGccdt3LcoXFXx73XHK/prcnVLNGs07yh+UmLqRWgla21TqtB64E2rm2pPVV7tnal9jntgfHq493Hs8eXjD8y/q4OqmOpE60zT2e3TofOkK6ebpCuQHeL7lndAT2Gnrdelt5GvVN6/fp0fU99nv5G/dP6fzI1mD7MHGY5s405aKBjEGwgNthl0GkwbGhmGGdYZFhn+MCIYuRilG600ajVaNBY33iK8XzjWuO7JgomLiaZJptN2k3em5qZJpguN20wfW6maRZiVmhWa3bfnGbuZZ5nXmV+3YJo4WKRbbHdossStXS0zLSssLxihVo5WfGstlt1TyBMcJ3An1A14ZY11drHusC61rrXhmETblNk02DzcqLxxOSJ6ya2T/xq62ibY7vH9p6dml2oXZFdk91re0t7tn2F/XUHmkOgwyKHRodXk6wmcSdVTrrtSHec4rjcsdXxi5Ozk9DpkFO/s7FzqvM251su6i5RLqtcLrgSXH1dF7k2u350c3LLdzvi9re7tXu2+37355PNJnMn75n82MPQg+Wxy6PHk+mZ6rnTs8fLwIvlVeX1yNvIm+O91/uZj4VPls8Bn5e+tr5C3+O+7/3c/Bb4tfhj/kH+Jf6dAWoBcQFbAx4GGgZmBNYGDgY5Bs0LagkmBIcFrwu+FaIbwg6pCRkMdQ5dENoWRg2LCdsa9ijcMlwY3jQFnRI6ZcOU+xEmEfyIhkgQGRK5IfJBlFlUXtRvU4lTo6ZWTH0abRc9P7o9hh4zM2Z/zLtY39g1sffizOPEca3xyvEp8TXx7xP8E9Yn9CROTFyQeDlJO4mX1JhMSo5P3ps8NC1g2qZpfSmOKcUpN6ebTZ8z/eIM7Rk5M07OVJ7Jmnk0lZCakLo/9TMrklXFGkoLSduWNsj2Y29mv+B4czZy+rke3PXcZ+ke6evTn2d4ZGzI6M/0yizLHOD58bbyXmUFZ+3Iep8dmV2dPZKTkFOXS85NzT3BV+Nn89tm6c2aM6tbYCUoFvTkueVtyhsUhgn3ihDRdFFjvjo85nSIzcU/iXsLPAsqCj7Mjp99dI7qHP6cjrmWc1fOfVYYWPjLPHwee17rfIP5S+b3LvBZsGshsjBtYesio0XLFvUtDlq8bwllSfaS34tsi9YXvV2asLRpme6yxcse/xT0U22xUrGw+NZy9+U7VuAreCs6Vzqs3LLyawmn5FKpbWlZ6edV7FWXfrb7ufznkdXpqzvXOK2pXEtcy197c53Xun3rVdcXrn+8YcqG+o3MjSUb326aueli2aSyHZspm8Wbe8rDyxu3GG9Zu+Xz1sytNyp8K+q26Wxbue39ds72q5XelYd26O4o3fFpJ2/n7V1Bu+qrTKvKdhN3F+x+uid+T/svLr/U7NXeW7r3SzW/umdf9L62Gueamv06+9fUorXi2v4DKQe6DvofbDxkfWhXHaOu9DA4LD7856+pv948Enak9ajL0UPHTI5tO04/XlKP1M+tH2zIbOhpTGrsPhF6orXJven4bza/VTcbNFec1Di55hTl1LJTI6cLTw+1CFoGzmScedw6s/Xe2cSz19umtnWeCzt34Xzg+bPtPu2nL3hcaL7odvHEJZdLDZedLtd3OHYc/93x9+OdTp31V5yvNHa5djV1T+4+ddXr6plr/tfOXw+5fvlGxI3um3E3b99KudVzm3P7+Z2cO6/uFtwdvrf4PuF+yQOVB2UPdR5W/WHxR12PU8/JXv/ejkcxj+49Zj9+8UT05HPfsqe0p2XP9J/VPLd/3twf2N/157Q/+14IXgwPFP+l+te2l+Yvj/3t/XfHYOJg3yvhq5HXq95oval+O+lt61DU0MN3ue+G35d80Pqw76PLx/ZPCZ+eDc/+TPpc/sXiS9PXsK/3R3JHRgQsIUt6FMBgRdPTAXhdDQAtCZ4dugCgKMnuYtKCyO6PUgL/jWX3NWlxAqDaG4C4xQCEwzNKJawmkKmwlRy9Y70B6uAwVuVFlO5gL4tFhTcYwoeRkTe6AJCaAPgiHBkZ3j4y8mUPFHsHgJY82R1QUojwfL/TRkJdfU/F4IfyH+N1cEuGLguxAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAZSElEQVR4nO2defQdRZXHvzcbSQhJgCAGCJvsUVZRMDqyCLgAKijiPorgMqDiyIiKjjPouAzoqBwUBREcFxAVyChCBJHNIPuWgBC2JMQQskAC2fOZP24/Xv36Vb/u/v3eb0vqc847p1931e3qrW4t996SehngImAFcH5vnyuRSCQSgwTgPGAlzgrgnP4uUyKRSCT6GeATxDmhv8uWSCQSiX4CGAY8XKAgHgCG9HcZE4lEItEPAJMLlAPAOmDn/i5jIpFIJNrTWy35bdscM0mTeum8iUQikegQlRUEMBrYDRjeAblpiCmRSCQGOJUqamBPSTMkzZQ0AzimJMvckuNPVTlvIpFIJAY4wNTIXMLb26TfCJhdMAfxKDCsL8ufSCQSiV4CeChS0S8ENm2T54wCBXFaX5Y9kUgkEr0I8LeCyv7kNnlGANfn0k9LvYdEIpFYjwC+UaAgLivJNwI4Dfg58JmkHBKJRGI9A5gELI8oiD/2d9kSiUQi0TtUsmIys9mSPho5dHtni5NIJBKJQQlwDHAvsBS4pt0kdSKRSCQ2QIAt+rsMiUQikUgkEolEIpFIJBKJgYI1NoATJb1P0jJJvzGzn9QRBGwm6VWS9pW0i6SJkjaVNFrSiOxc6yStzM6xUNKT8hAefzOz23p6MYlEDOALkl7SzewrJS2QNEvS3Wb2WMcKlhiUAB+R9PLs75Vmdl1/lqe7AJvL6+Vh8vd8pZm9kB0bKa+3JWD3iAnrNGBMhZNsA5wPLCrwlajKDOCk3rsdiQ0VYH4P380Gq4HrgEP7+5oS/QddHYC/3N/l6S7ACcAtwOXAv2bfyb6AZfXx3xsJi9ZvuLDkBLsA8zr08TX4Xp/cncQGA/Bgh99RgA/393Ul+gfgquA9OL2/y9MTgP8GDgX2AOYAXwLegodXmjVMkszsAeD3kt6Sy/9e4LNmtrBA/kWSXtrhMp8C/N7Mru6w3ERCkq6XVGX4dFj2Gy1fv2R/Sf8UHP8hcK2ZPdHxEiYGOk9L+ke2/Vx/FqQDDJe0kaTNJF0uX8vnDZIulnR6GPrivZIuyw42WCJpVUwq8DpJB5ScHPkNXC5pjXy8a6SksVnBiviUpKQgegHgJZK2y+1eYWb39Ud5+oH7zexn3ckIHCb/iEbL398TJZ3RwbINeoAjJR2Y/b3NzC7vz/L0EidKGpptr+7PgnSAZfI6fq18TniBvH6+WbG6H3gHcAHwY2CfIqnAt9p0v3+RdVNeBmwKjAKG47GZNgG2Bd4M3F6QfyGwce/cjw0b4JTI/V6vJ17pOsT04x7K+nEgKxlW5AB+EtYD/V2eRHuAkcAwYCg+MS1gSPYb1xI8z8wuk/ckytirYP+lZvaeNvlWSVoq6Ul8EmSGWnsTm8m79Q9WKEeiHmsj+6K9xESUayV9JNveCRhnZs/2Z4EGGMsKthMDEDNbEfxdm+1bl/1/tidLfxbNPVxQVYCZPSLpgYLD42uXKNFd6O8CDCIeD7bHqfNzcInEgKFbCgIwSUVDQPNqinu6YP/omnIS1Vga2bemz0sxeFmipkI1pYZMnuXB9orCVIlBQXfXZzAFTnY56iqdcyTdGNn/cPgHmCTpHbk0ayRdaGbLsjRTJE2RtKNcga2Ur399h6TrzKylcgR2lnSIpD3kQ1ur5RYKd2d5nqlzMcDekvaUtIOkCZLGyO8zkl6QtEjSbPnw2T1mtqhE3paSYkN2F5jZc8AOkt4ld1KcIOl5SfdK+qWZ3Z3J2FrScVm+KRFZWwCnllza/5rZgoIyjpJb+ewjv/dbyO//EPkzWCK/5vsk3WpmbdcsB96ayQm538ymBcffLGkn+WThXEnTsjL2trJbKe+KN76djcKDwGT5s5CkuWZ2Tbb/GLmV4K7yd2KVpEcl/SEr9zq1Adhe7oS6q9wJdZz8/iJX+vPl38ydZvZQnQsChsif337y+765mu/sUnkj7mFJd5nZzEj+V0p6RfZ33+DQnsCH2px6qdwpN9qDBXbP5O0kaUv5fTP5/X9W3hh9UH7NT1a4zreo6TB5g5nNAiZKOl5uobaNfLj7Ofn3/yszuyUi51C5tY/kE/H3546PknRsJmu1pMsaQznZvTogu6ZN1fxGns6uZbqZ/b3sWnLn20z+Xe+dXcNouVPywkzmjY3nlr1HB2dZF5nZFVVOsB1wLPD6GoWaUTDB/Iby3PUBDi8431DcueOWguMN5uAekA15Y3AHv1Vt8iwE/r1i+d4N3FdShpj8i4Gd2sg9sCDvCOBfgGUFx9eSLe8KHFyzXDH2i5RtFHAm8GQNOctwI4a8Agjl5lciBPgPYAJwYxvZtwNbReR1cpJ6O9xhrsHrcsc/Hxw7HzfIKFqRscFfceuy2PleDfwBWFkio8E64Ca8MqxyPSdQ/C3HuBl4Y07GOTXyhywGhkbK9Db8nlRlOXAlsG9eVk7uA0GeKcDxlDv4fjMi58/B8S9Fjk/MyTDgtRWvaQ3wO7xRV/bshgNfBxaUyFyHO8NNBF4f7C830QbOBZ4NMv2RChZE+IsS47ulJ+0GxCu5h4BDKK4kYxxXUv4Yba0xcMuvnrAQeHmB7P0j6W/HV+qrwhTcCaan7J0r1zjgth7IW4C3EGPXfGUu7Tr8eous3kJuwodAQ3mdVBC7ZeVp8Mrc8VODMp9P1/Xc5wDTs1/eu7vFrBv/mFfTyiq8Ynsaf3dWFNyLD5Rcy/9E8qwJZC+iWDG9LZDznYI0ZcwjpyCAkwrSLsev9WlcscTuy3Kg0PSeZgW9JFLmmXidcA+tjcYP5uSE7+dpkfO8lGadNBOvH9bkZD6PfwMLid/jGXhPpOhahuFLLuRZm92fp7PrDHkUeG9wffe2ez8aJ5odOcnLKuS7OJKP7Each7eoX4W3uMYD7fweqpQzpiDmUK/1CnAH8M2aeQD+uaBcQ+laCeRZATyV/Za2SdfSlc3kxxTEQtr3fEKuwVuhPWW/XLku6IDMvxZcc15BrKW8lRRyRE5eJxXEIYGsNeR6QnRVEGuz7YeBI8nMCLN0Y4Ev5Mq9f3B8CF1bvMtxr9eD8F7JeLwXPA7YGu9pngE8E+RZAkTnSIA35s59E3AcsGMgezweSucA4HN0VWpzaJpFbo83RKYAvw7SXBHsj/3yynULvOJs8A+8R/ZqYKvsWhvl2g5/Ft+hawVbuIgZTQURKpdf4MOCYbqdgT8FaWbgw3CN43UUxAKavZT5wFey+7klbvI/Dl+x8/DcvQP4WJtr+bdc2muBdwI70Xx+m+HRLt5Ds9ezgGaDopKCGIPH4ZiOd98/WJpJL3ZNq7A6u0FP4C/8rXgv5SLgq8AHgf1ooy2z85UNkywApgI/xCuvGyqW717gZ1m+q2l+1HnuI9cyzcpVFKZkCd4amoTbGo8EXpJdR2wIBSJ+J8QVRMhv8Irmv4gr++eBI/Ce4rnE78vi4HjRb5ugTNsSb8E9A5yNv5CHA4fhrafT8eceo6XFR6uCCHkIryhPB35bkOa8nLxOKogzA1lPAfk5iFPpylyg0NIJ7/o3OD3Y/5qcnKMrlm9Pui4P/P6CdGEF+JeKsifTtQI/IpLmrOD4OVXkBnk/GuRdCuxaMd/xuXu1d0G6/BBPocMkPpzZaIGvI2g0U09BNPgrbd6DIO8VQZ5pBWlG0PVb/1WZ3Czfz3JlKlcQ3QXYnPYt4rrMwbvkryg4XzsF8SN8oiaf52hau3YNngfeGcmzP949y9PlJQnSH1Mg/91t7t14Wrt/AKcUlCfGauCoXNqtibe0jwjSvD9y/P78edsBfCwi43lgj5J8sXmir0bSFSmIqwha4Vnab0fS3ZxLEyqI89RNcGUfvhv/F0mTVxAfickK0n88SPvDYH/Yu6jlD0TXWEEt8dTwhsoLQZo315A9NcgXG3//XnD8RzXL/asg729r5n08yPvpgjShgniWSJ2RSx/Od70+2F9XQSyk4iJrdO3ZPUlk5IWujYc1wC4VZU+ka+OhVEF02w8ii8/UUqH1gK0lnSDpTtzioyo3mNlJMWsgM7tS0l0F+T5lZr+O5LlN0hcj6U1ueRDbPzf3e1RtQoWY2ZKCchVOVke42Mym5uTOldRSacktGxpsEjle15rtwMi+v5jZjJJ8sRZby+R3ASslnZRz7JGkc9Xq/Lc5kd5eRtH+LuBDhxvjSncKcIakW+UWWg0uLhHzvDw0RzvCex8+m7ChdGdpgbvyt2A7prT3ktTosS+XW/lVJbQW2q1mucoI56RurZn37mB7zwrpryuzIFRXC7WRhanKubDIAjDCI3ILJMmtnGLLOr8q2J5V1erJzOapuD6M0l0z18YJfwrMl/Q5Sa9VMz5JTxgm6SLghoompmWT4g9JemVu33y1/7j/IDdDHJHbHxvP/Z2kqbl9a80s5rEcEvP/GFeSJ+Q3Bftj5n5th++6QUyRVemFPB7Zt21kX4w7zWx2ZP8iufII/WZGy9/FmMnrO8lZHuUwecNpeCZnnHKmrBk3qDziwKwK7/BzkhrzT/cE+ycF24+XyMgThk6ZCAw3szBm0M7B9lPy+DtVuUHNSuvmdgnrgBvGbBnserymiDB9lXeqcK4iYKaasZaK/LWqEB0qKmCl/L0dIVdKMX+wUDE/HDnejgcUb+BF6ZGCkCQzu0rSVfhk3avVtNWeJLenHqtmcLOqjJHb/peF/l4nt/lvR8wxbIaZtQsvsTj7bZnb39L6zOzXW2RlXcON5LbkyyN27jHb70qt24wiEzVT6zUvjyXsDlnLPNZdLor4GxJznNoUGGVmZWV8pGD/CPn1hgo5dGbLM149d267XNKHynwXVKHiNbOL5FGR84TDH3UqcEkKldJYuZIL94UmlM9UuI4XMbNLJF1SszxVGCcva4Mq71NIWIFvXiH9/LIEZlZpPrYCT9VIa7nt2ChPaMpdR7bkIxyV6bGCaGBmj8qHVn7Z2JdVkpvInabGZNvj5C//TnKHjaLFVw5VuYJYKe/GtyNWUcSURj5PWQ+gNZPbnr9V7jC2pbzljqRlwDx5q+VSM7u5O/ID1qnYS/Vbau1VdTImzkaKe9F/GnhfSd5YvpHZr0xBvFCwf4Gkybl97Xpwa1XNc3xd9lslVzhPyoduLo85T7U5V22y7ya8V2Xva57wmxip1h5kqCDryu4tRqtrT63su84TXsfGgBU54GX05PurS52Ir+2ckBuEz29JzbLUSt8xBREj69Yuyn4xvoY7on0lcqzQkSqgSgyh2M0uewBVHlKzED55/VP5MFuMLeSe1a+R9El8YrYnL2jhdWde5b0ZJG244r3Bl6p7cYmGqgfvYaYI6rQ2L5HUMrEYodFIWClpWYUhw2jxupFH8vsR3uO6wRTDCmmYWodKQ4UxUMJhjFDX1nLdMNrhPRouv+52Mrr7bAYC4fNbWTNvrfS9qiAq8gNJp6t1Emg8sJGZtbugWhV5Ll9HyKwT/qyuY8ZlnKH6LaSQ7l73QGSsql1Lp673OTOr2y3va4aqBwYk6tqAGKLWucHwXvZlS7odnZi/DGX15P51mk5/q+G9qhtos1ZZuqUgsgmlM9XadX3MzL5VU9wSeQsw71reaKnW1ZB9zX+qWDncKp9Eel4+xLaDfI5mpIqDHQ501ig+RPNzxWNqlbFKfbsq10BoFJWxVl0r7roVTJh+nVqfVyi7kxVzT8iXsSfXnL9/6xs9eTdiBheFdPdjGSEpFtztEfkYeF1ik2SovnbsUzJFeVzk0CxJx5tZi6UEHlzvm5JafDAGElnPaGKwa53cqmOl4vMFV5rZpX1Rtg2A1eo6PJIfIiojTL9arUNU4XxOT8w3O0ljVbOGwqobeSGs+Fb1QdDG/iQcFqxroRgzcy+kuwpitXxyMG/N0h2tPUrxQq/QwO897Kyu1iYNTokpB0kys8ckHYc7P1XyFO0DYor4BElfD/6vljTJzOYDsQVyJvRKyTZAzGwNEM4jjS1MHCf8nlaodYJ/cXdl4x71n8v+viDpKxUs0PIytpZHIJZ81OF38l72CjV71mPqyFTX61jfFyoKJ5rbOvtFiAaFLKK7CmK5/IHmFcQkYELNENk7Km52uHgQtAJiDwf5Knll3KiBoyBi5Luia9Qc150nt9QKKbU9Bw6U9O3c7hckHZs5DyaahBPveXPrMsLvcolah/DCOZgtgaE1JuEnSTo5+H+Wii3QikYA9pR0drY9Xe5L1ChnQ0FU8jwOCO9RrRD9g5DQVHWbwlRxqhj/vEi3JnKylylmTzta0qeqysEjORYt+v54/ZL1OUVWElUWO6qr+TtF7KOdAOSHMfLxbNao2UOMhX44pMK5J8tj4Ye/gzU45gX6mseD7VoftaQwJMzcSEMrdK7aSq3zf+0IW+rPqL15cpUh4qXSi0tfhoqrNGBojvAerddrrKvr97crkZDpMYBhquZl/iI9+TDvUHzxmTPwBTVulztzLZS3ElfLJ1RGyR1ZdpFXKtGQz5KikT4HGHPkY/OhojVJh8vH66PgwcQO792iFRJrXU2Qh005W5Ky5/emXJpGr1Fyz9/P5I7vD3zSzKK+K3hQu5jj0ROqb8u9IRB6VecjAZQRfpf3RY7fL3+eo+Rj/Qcr7qwXI/Q5md1YrCsgVApFwxmhgUY43HW/mqFXYnVLFDzSatijvbso7XrC9GB7W7nhy20V8h2seo2BHimISyR9suDYgarhzl1AWQybgcDjckWQd9T6GjBW0vVyj80V8onDrSS9QdKn5WOsqO/NVYvi+pwFvEs+7zNFreV60swaCuI6ecsvP3f0XeDDcuutufJGwcbyYYnXKt4SnjYIhhL7g2uD7e2Aj5vZD8oy4Yv5vCbYdU0+jZk9jYdab/T6vgxcb2ZtF5DJWqqhko99o+GSwwcBW0TiEB0bbIeREKYF8g8GDjKz69uVKeNUdfXBua5CnsHMHfK6Z/vs/9nAm4Lvs4Vs7qjM8biFnjgo3YJHszyyuzLacKGZ1Y0x0ueYGcA31BqEbmO5+WuDNXLrjLDSnaX6Qwc9Jltm8WpJLaGa5ctOFvFiC9PMFgPfl/SFSLq9sl8Vlkn6WsW0GxRmdg++Rkijsj8XOEwejPEhect7tfy9Gi8fkjlM0vvUtASaK+mqglN8W00FsaOku/CFsa6X9+qek/eOR8h7/HvJK+/GEMVcxSucq9U0bthU0tXAl+XDWmMlvV++xGeDMKbYFWoavwyXdA0eknuaPErDc/JhzuHyIdrdJR2V/Rr8qe6SnYMNM1sNnC3p+9mu10m6G4/cO12+ZPIqeQ9xkrzn8CH5c1ys5nK1vQuwKXAdnWUqkbUhiIf7foHIEpO5fD+InaMkz2g81n+e4wvS111y8Vzgi5H9Ld184uG+19JmmdIygB3wxViqMpXWlb+GU7weQxXmAFHPc+LhvnsSpjtc0On87sqpeK4w3HedIG0xWXsQDz1fhRW4Qmkn/6wyIQU8SkFY/kzu+RXlnBXJexTxtUaqMBdfY76oXNODtB+u9zS6yAlDnheF+w7XzSgaRo/J3i64/rW0X5r30pr35x7gEzRXROy9cN+StyTN7BC5ydoVqh84SvLW9aOSfiHpKDM7qsBsLjYRM0rlQzQxx5Aqtt8xR7Zoj8vMTpb0AZWPfT4m6TQz+4Sa3cOQWFljz2iIejA0lZnaHii3HmkXjuAJeejzo/NWLma22syOkQdVbAw5VWGmvHe1l5ndVJAm9nxqOfjkCJ9bb7ecQvk9ckLLwqfvKw9pXjXI2gK50+L+ZtZWQZnZZyW9XR4JoIqp6ixJX5W0j5nF5jYanCjpG5Ji5tCSvytnZufPl2mqPJz1JaoeQuVJeW9mv5KRh069B+FzLZIT+nHU/VYb5WxbRjM7Tj4XWBTIssGz8lBAB8mfYeXydHT8G1/MZXt5t2ZLeRdzY/nNMrkyWCF/QRbLu0Kz5ZNdbSNKAuPUOnSxVtJt7SKz4i3tfC9joZk90CbPEPlwS75SmlkW1x1vWU2WTwZtLO/qzZdXjHc2yoovrpP3HZhvZg/l5I2RVxJddsuvu8dxdHDHvf0kbZeVd2VW3gcl3VUS6iSUs4Xc8GBb+RDBGPmL3gh2N1fS3/PXVyBrslojcs7r7rAjsJuaz3JRQdjwjpDdh8b7tjQLYtkJuSPlQyovkzswjpVXVOvkQ3Xz5Q2tmWZW2zMd74nvLn8PJqippJfKG34PSrq/Tkyq7F4cIA/MuYn83Zol6SYz+0eF/OPk61nsIK9PxsjrkbXySm+evHJ8sMp7mvUuGhaGsyusB1EkZwc1rbmeytcJuLXQ7mpW8JXKl+UdnuVt1M0zSyJPN+aG9pHfq4nyd32N3CBllqR7Gq4HwHFqRuO9z8xqWTUlEolEYj0FXwKYqkNMyf48kUgkBhFZD+Vg+cjMOkl/rtpDUc2IuUlBJBKJxOBilKQr1RwG3FHVnQND35TFhakyBlJI3EQikUiU87zcSbdBnbAkoQNi2eR2UhCJRCIxmMgMesLK/Zgq+TJz26ODXdcWpU0kEonEICXzZ2iwCvg8sBswBl83XoABGwO7AicD84I88/DlCtqyvqxKlkgkEhsMWeV+h1ojQi+Qe5yvls8xj1U8JtaRZvb7Xi1kIpFIJPoHYBJwVU1v6puAg6qeI/UgEolEYhAD7CkPhjlZ7ig3Rj6/vEbem3hKvkbNdDMr9X0I+X+aQTvANSPI+QAAAABJRU5ErkJggg=="

/***/ },
/* 1283 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 1284 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,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"

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(1287);
	var parse = __webpack_require__(1286);
	var formats = __webpack_require__(201);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(518);
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    allowSparse: false,
	    arrayLimit: 20,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    comma: false,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    ignoreQueryPrefix: false,
	    interpretNumericEntities: false,
	    parameterLimit: 1000,
	    parseArrays: true,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var interpretNumericEntities = function (str) {
	    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
	        return String.fromCharCode(parseInt(numberStr, 10));
	    });
	};
	
	var parseArrayValue = function (val, options) {
	    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
	        return val.split(',');
	    }
	
	    return val;
	};
	
	// This is what browsers will submit when the ✓ character occurs in an
	// application/x-www-form-urlencoded body and the encoding of the page containing
	// the form is iso-8859-1, or when the submitted form has an accept-charset
	// attribute of iso-8859-1. Presumably also with other charsets that do not contain
	// the ✓ character, such as us-ascii.
	var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
	
	// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
	var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = { __proto__: null };
	
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
	    var i;
	
	    var charset = options.charset;
	    if (options.charsetSentinel) {
	        for (i = 0; i < parts.length; ++i) {
	            if (parts[i].indexOf('utf8=') === 0) {
	                if (parts[i] === charsetSentinel) {
	                    charset = 'utf-8';
	                } else if (parts[i] === isoSentinel) {
	                    charset = 'iso-8859-1';
	                }
	                skipIndex = i;
	                i = parts.length; // The eslint settings do not allow break;
	            }
	        }
	    }
	
	    for (i = 0; i < parts.length; ++i) {
	        if (i === skipIndex) {
	            continue;
	        }
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder, charset, 'key');
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
	            val = utils.maybeMap(
	                parseArrayValue(part.slice(pos + 1), options),
	                function (encodedVal) {
	                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
	                }
	            );
	        }
	
	        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
	            val = interpretNumericEntities(val);
	        }
	
	        if (part.indexOf('[]=') > -1) {
	            val = isArray(val) ? [val] : val;
	        }
	
	        if (has.call(obj, key)) {
	            obj[key] = utils.combine(obj[key], val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options, valuesParsed) {
	    var leaf = valuesParsed ? val : parseArrayValue(val, options);
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]' && options.parseArrays) {
	            obj = [].concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (!options.parseArrays && cleanRoot === '') {
	                obj = { 0: leaf };
	            } else if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else if (cleanRoot !== '__proto__') {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = options.depth > 0 && brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options, valuesParsed);
	};
	
	var normalizeParseOptions = function normalizeParseOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
	
	    return {
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
	        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
	        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
	        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
	        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
	        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
	        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
	        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
	        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
	        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
	        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
	        parseArrays: opts.parseArrays !== false,
	        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (str, opts) {
	    var options = normalizeParseOptions(opts);
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    if (options.allowSparse === true) {
	        return obj;
	    }
	
	    return utils.compact(obj);
	};


/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getSideChannel = __webpack_require__(1279);
	var utils = __webpack_require__(518);
	var formats = __webpack_require__(201);
	var has = Object.prototype.hasOwnProperty;
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    comma: 'comma',
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};
	
	var isArray = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function (arr, valueOrArray) {
	    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaultFormat = formats['default'];
	var defaults = {
	    addQueryPrefix: false,
	    allowDots: false,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    format: defaultFormat,
	    formatter: formats.formatters[defaultFormat],
	    // deprecated
	    indices: false,
	    serializeDate: function serializeDate(date) {
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
	    return typeof v === 'string'
	        || typeof v === 'number'
	        || typeof v === 'boolean'
	        || typeof v === 'symbol'
	        || typeof v === 'bigint';
	};
	
	var sentinel = {};
	
	var stringify = function stringify(
	    object,
	    prefix,
	    generateArrayPrefix,
	    commaRoundTrip,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    format,
	    formatter,
	    encodeValuesOnly,
	    charset,
	    sideChannel
	) {
	    var obj = object;
	
	    var tmpSc = sideChannel;
	    var step = 0;
	    var findFlag = false;
	    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
	        // Where object last appeared in the ref tree
	        var pos = tmpSc.get(object);
	        step += 1;
	        if (typeof pos !== 'undefined') {
	            if (pos === step) {
	                throw new RangeError('Cyclic object value');
	            } else {
	                findFlag = true; // Break while
	            }
	        }
	        if (typeof tmpSc.get(sentinel) === 'undefined') {
	            step = 0;
	        }
	    }
	
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        obj = utils.maybeMap(obj, function (value) {
	            if (value instanceof Date) {
	                return serializeDate(value);
	            }
	            return value;
	        });
	    }
	
	    if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        // we need to join elements in
	        if (encodeValuesOnly && encoder) {
	            obj = utils.maybeMap(obj, encoder);
	        }
	        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
	    } else if (isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;
	
	    for (var j = 0; j < objKeys.length; ++j) {
	        var key = objKeys[j];
	        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];
	
	        if (skipNulls && value === null) {
	            continue;
	        }
	
	        var keyPrefix = isArray(obj)
	            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
	            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');
	
	        sideChannel.set(object, step);
	        var valueSideChannel = getSideChannel();
	        valueSideChannel.set(sentinel, sideChannel);
	        pushToArray(values, stringify(
	            value,
	            keyPrefix,
	            generateArrayPrefix,
	            commaRoundTrip,
	            strictNullHandling,
	            skipNulls,
	            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            format,
	            formatter,
	            encodeValuesOnly,
	            charset,
	            valueSideChannel
	        ));
	    }
	
	    return values;
	};
	
	var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var charset = opts.charset || defaults.charset;
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	
	    var format = formats['default'];
	    if (typeof opts.format !== 'undefined') {
	        if (!has.call(formats.formatters, opts.format)) {
	            throw new TypeError('Unknown format option provided.');
	        }
	        format = opts.format;
	    }
	    var formatter = formats.formatters[format];
	
	    var filter = defaults.filter;
	    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
	        filter = opts.filter;
	    }
	
	    return {
	        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
	        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
	        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
	        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
	        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
	        filter: filter,
	        format: format,
	        formatter: formatter,
	        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
	        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
	        sort: typeof opts.sort === 'function' ? opts.sort : null,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = normalizeStringifyOptions(opts);
	
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = opts.arrayFormat;
	    } else if (opts && 'indices' in opts) {
	        arrayFormat = opts.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
	        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
	    }
	    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (options.sort) {
	        objKeys.sort(options.sort);
	    }
	
	    var sideChannel = getSideChannel();
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (options.skipNulls && obj[key] === null) {
	            continue;
	        }
	        pushToArray(keys, stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            commaRoundTrip,
	            options.strictNullHandling,
	            options.skipNulls,
	            options.encode ? options.encoder : null,
	            options.filter,
	            options.sort,
	            options.allowDots,
	            options.serializeDate,
	            options.format,
	            options.formatter,
	            options.encodeValuesOnly,
	            options.charset,
	            sideChannel
	        ));
	    }
	
	    var joined = keys.join(options.delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    if (options.charsetSentinel) {
	        if (options.charset === 'iso-8859-1') {
	            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
	            prefix += 'utf8=%26%2310003%3B&';
	        } else {
	            // encodeURIComponent('✓')
	            prefix += 'utf8=%E2%9C%93&';
	        }
	    }
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright Joyent, Inc. and other Node contributors.
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a
	 * copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the
	 * following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included
	 * in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	 * USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	'use strict';
	
	var punycode = __webpack_require__(1098);
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	/*
	 * define these here so at least they only have to be
	 * compiled once on the first module load.
	 */
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	  portPattern = /:[0-9]*$/,
	
	  // Special case for a simple path URL
	  simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,
	
	  /*
	   * RFC 2396: characters reserved for delimiting URLs.
	   * We actually just auto-escape these.
	   */
	  delims = [
	    '<', '>', '"', '`', ' ', '\r', '\n', '\t'
	  ],
	
	  // RFC 2396: characters not allowed for various reasons.
	  unwise = [
	    '{', '}', '|', '\\', '^', '`'
	  ].concat(delims),
	
	  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	  autoEscape = ['\''].concat(unwise),
	  /*
	   * Characters that are never ever allowed in a hostname.
	   * Note that any invalid chars are also handled, but these
	   * are the ones that are *expected* to be seen, so we fast-path
	   * them.
	   */
	  nonHostChars = [
	    '%', '/', '?', ';', '#'
	  ].concat(autoEscape),
	  hostEndingChars = [
	    '/', '?', '#'
	  ],
	  hostnameMaxLen = 255,
	  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	  // protocols that can allow "unsafe" and "unwise" chars.
	  unsafeProtocol = {
	    javascript: true,
	    'javascript:': true
	  },
	  // protocols that never have a hostname.
	  hostlessProtocol = {
	    javascript: true,
	    'javascript:': true
	  },
	  // protocols that always contain a // bit.
	  slashedProtocol = {
	    http: true,
	    https: true,
	    ftp: true,
	    gopher: true,
	    file: true,
	    'http:': true,
	    'https:': true,
	    'ftp:': true,
	    'gopher:': true,
	    'file:': true
	  },
	  querystring = __webpack_require__(1285);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && typeof url === 'object' && url instanceof Url) { return url; }
	
	  var u = new Url();
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
	  if (typeof url !== 'string') {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  /*
	   * Copy chrome, IE, opera backslash-handling behavior.
	   * Back slashes before the query string get converted to forward slashes
	   * See: https://code.google.com/p/chromium/issues/detail?id=25916
	   */
	  var queryIndex = url.indexOf('?'),
	    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
	    uSplit = url.split(splitter),
	    slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  /*
	   * trim before proceeding.
	   * This is to support parse stuff like "  http://foo.com  \n"
	   */
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  /*
	   * figure out if it's got a host
	   * user@server is *always* interpreted as a hostname, and url
	   * resolution will treat //foo/bar as host=foo,path=bar because that's
	   * how the browser resolves relative URLs.
	   */
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] && (slashes || (proto && !slashedProtocol[proto]))) {
	
	    /*
	     * there's a hostname.
	     * the first instance of /, ?, ;, or # ends the host.
	     *
	     * If there is an @ in the hostname, then non-host chars *are* allowed
	     * to the left of the last @ sign, unless some host-ending character
	     * comes *before* the @-sign.
	     * URLs are obnoxious.
	     *
	     * ex:
	     * http://a@b@c/ => user:a@b host:c
	     * http://a@b?@c => user:a host:c path:/?@c
	     */
	
	    /*
	     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
	     * Review our test case against browsers more comprehensively.
	     */
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
	    }
	
	    /*
	     * at this point, either we have an explicit point where the
	     * auth portion cannot go past, or the last @ char is the decider.
	     */
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      /*
	       * atSign must be in auth portion.
	       * http://a@b/c@d => host:b auth:a path:/c@d
	       */
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    /*
	     * Now we have a portion which is definitely the auth.
	     * Pull that off.
	     */
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1) { hostEnd = rest.length; }
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    /*
	     * we've indicated that there is a hostname,
	     * so even if it's empty, it has to be present.
	     */
	    this.hostname = this.hostname || '';
	
	    /*
	     * if hostname begins with [ and ends with ]
	     * assume that it's an IPv6 address.
	     */
	    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) { continue; }
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              /*
	               * we replace non-ASCII char with a temporary placeholder
	               * we need this to make sure size of hostname is not
	               * broken by replacing non-ASCII by nothing
	               */
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      /*
	       * IDNA Support: Returns a punycoded representation of "domain".
	       * It only converts parts of the domain name that
	       * have non-ASCII characters, i.e. it doesn't matter if
	       * you call it with a domain that already is ASCII-only.
	       */
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    /*
	     * strip [ and ] from the hostname
	     * the host field still retains them, though
	     */
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  /*
	   * now rest is set to the post-host stuff.
	   * chop off any delim chars.
	   */
	  if (!unsafeProtocol[lowerProto]) {
	
	    /*
	     * First, make 100% sure that any "autoEscape" chars get
	     * escaped, even if encodeURIComponent doesn't think they
	     * need to be.
	     */
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1) { continue; }
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) { this.pathname = rest; }
	  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  // to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  /*
	   * ensure it's an object, and not a string url.
	   * If it's an obj, this is a no-op.
	   * this way, you can call url_format() on strings
	   * to clean up potentially wonky urls.
	   */
	  if (typeof obj === 'string') { obj = urlParse(obj); }
	  if (!(obj instanceof Url)) { return Url.prototype.format.call(obj); }
	  return obj.format();
	}
	
	Url.prototype.format = function () {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	    pathname = this.pathname || '',
	    hash = this.hash || '',
	    host = false,
	    query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) {
	    query = querystring.stringify(this.query, {
	      arrayFormat: 'repeat',
	      addQueryPrefix: false
	    });
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') { protocol += ':'; }
	
	  /*
	   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	   * unless they had them to begin with.
	   */
	  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') { pathname = '/' + pathname; }
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') { hash = '#' + hash; }
	  if (search && search.charAt(0) !== '?') { search = '?' + search; }
	
	  pathname = pathname.replace(/[?#]/g, function (match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function (relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) { return relative; }
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function (relative) {
	  if (typeof relative === 'string') {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  /*
	   * hash is always overridden, no matter what.
	   * even href="" will remove it.
	   */
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol') { result[rkey] = relative[rkey]; }
	    }
	
	    // urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
	      result.pathname = '/';
	      result.path = result.pathname;
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    /*
	     * if it's a known url protocol, then changing
	     * the protocol does weird things
	     * first, if it's not file:, then we MUST have a host,
	     * and if there was a path
	     * to begin with, then we MUST have a path.
	     * if it is file:, then the host is dropped,
	     * because that's known to be hostless.
	     * anything else is assumed to be absolute.
	     */
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift())) { }
	      if (!relative.host) { relative.host = ''; }
	      if (!relative.hostname) { relative.hostname = ''; }
	      if (relPath[0] !== '') { relPath.unshift(''); }
	      if (relPath.length < 2) { relPath.unshift(''); }
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
	    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
	    mustEndAbs = isRelAbs || isSourceAbs || (result.host && relative.pathname),
	    removeAllDots = mustEndAbs,
	    srcPath = result.pathname && result.pathname.split('/') || [],
	    relPath = relative.pathname && relative.pathname.split('/') || [],
	    psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  /*
	   * if the url is a non-slashed url, then relative
	   * links like ../.. should be able
	   * to crawl up to the hostname, as well.  This is strange.
	   * result.protocol has already been set by now.
	   * Later on, put the first path part into the host field.
	   */
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') { srcPath[0] = result.host; } else { srcPath.unshift(result.host); }
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') { relPath[0] = relative.host; } else { relPath.unshift(relative.host); }
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = relative.host || relative.host === '' ? relative.host : result.host;
	    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    /*
	     * it's relative
	     * throw away the existing file, and take the new path instead.
	     */
	    if (!srcPath) { srcPath = []; }
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (relative.search != null) {
	    /*
	     * just pull out the search.
	     * like href='?foo'.
	     * Put this after the other two cases because it simplifies the booleans
	     */
	    if (psychotic) {
	      result.host = srcPath.shift();
	      result.hostname = result.host;
	      /*
	       * occationaly the auth can get stuck only in host
	       * this especially happens in cases like
	       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	       */
	      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.hostname = authInHost.shift();
	        result.host = result.hostname;
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    // to support http.request
	    if (result.pathname !== null || result.search !== null) {
	      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    /*
	     * no path at all.  easy.
	     * we've already handled the other stuff above.
	     */
	    result.pathname = null;
	    // to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  /*
	   * if a url ENDs in . or .., then it must get a trailing slash.
	   * however, if it ends in anything else non-slashy,
	   * then it must NOT get a trailing slash.
	   */
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
	
	  /*
	   * strip single dots, resolve double dots to parent dir
	   * if the path tries to go above the root, `up` ends up > 0
	   */
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' || (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
	    result.host = result.hostname;
	    /*
	     * occationaly the auth can get stuck only in host
	     * this especially happens in cases like
	     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	     */
	    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.hostname = authInHost.shift();
	      result.host = result.hostname;
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (srcPath.length > 0) {
	    result.pathname = srcPath.join('/');
	  } else {
	    result.pathname = null;
	    result.path = null;
	  }
	
	  // to support request.http
	  if (result.pathname !== null || result.search !== null) {
	    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function () {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) { this.hostname = host; }
	};
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;


/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	var v1 = __webpack_require__(1290);
	var v4 = __webpack_require__(1291);
	
	var uuid = v4;
	uuid.v1 = v1;
	uuid.v4 = v4;
	
	module.exports = uuid;


/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(520);
	var bytesToUuid = __webpack_require__(519);
	
	// **`v1()` - Generate time-based UUID**
	//
	// Inspired by https://github.com/LiosK/UUID.js
	// and http://docs.python.org/library/uuid.html
	
	var _nodeId;
	var _clockseq;
	
	// Previous uuid creation time
	var _lastMSecs = 0;
	var _lastNSecs = 0;
	
	// See https://github.com/uuidjs/uuid for API details
	function v1(options, buf, offset) {
	  var i = buf && offset || 0;
	  var b = buf || [];
	
	  options = options || {};
	  var node = options.node || _nodeId;
	  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
	  // node and clockseq need to be initialized to random values if they're not
	  // specified.  We do this lazily to minimize issues related to insufficient
	  // system entropy.  See #189
	  if (node == null || clockseq == null) {
	    var seedBytes = rng();
	    if (node == null) {
	      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
	      node = _nodeId = [
	        seedBytes[0] | 0x01,
	        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
	      ];
	    }
	    if (clockseq == null) {
	      // Per 4.2.2, randomize (14 bit) clockseq
	      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
	    }
	  }
	
	  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
	  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
	  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
	  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
	  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
	  // Per 4.2.1.2, use count of uuid's generated during the current clock
	  // cycle to simulate higher resolution clock
	  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
	  // Time since last uuid creation (in msecs)
	  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
	  // Per 4.2.1.2, Bump clockseq on clock regression
	  if (dt < 0 && options.clockseq === undefined) {
	    clockseq = clockseq + 1 & 0x3fff;
	  }
	
	  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
	  // time interval
	  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
	    nsecs = 0;
	  }
	
	  // Per 4.2.1.2 Throw error if too many uuids are requested
	  if (nsecs >= 10000) {
	    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
	  }
	
	  _lastMSecs = msecs;
	  _lastNSecs = nsecs;
	  _clockseq = clockseq;
	
	  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
	  msecs += 12219292800000;
	
	  // `time_low`
	  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
	  b[i++] = tl >>> 24 & 0xff;
	  b[i++] = tl >>> 16 & 0xff;
	  b[i++] = tl >>> 8 & 0xff;
	  b[i++] = tl & 0xff;
	
	  // `time_mid`
	  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
	  b[i++] = tmh >>> 8 & 0xff;
	  b[i++] = tmh & 0xff;
	
	  // `time_high_and_version`
	  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
	  b[i++] = tmh >>> 16 & 0xff;
	
	  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
	  b[i++] = clockseq >>> 8 | 0x80;
	
	  // `clock_seq_low`
	  b[i++] = clockseq & 0xff;
	
	  // `node`
	  for (var n = 0; n < 6; ++n) {
	    b[i + n] = node[n];
	  }
	
	  return buf ? buf : bytesToUuid(b);
	}
	
	module.exports = v1;


/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	var rng = __webpack_require__(520);
	var bytesToUuid = __webpack_require__(519);
	
	function v4(options, buf, offset) {
	  var i = buf && offset || 0;
	
	  if (typeof(options) == 'string') {
	    buf = options === 'binary' ? new Array(16) : null;
	    options = null;
	  }
	  options = options || {};
	
	  var rnds = options.random || (options.rng || rng)();
	
	  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	  rnds[6] = (rnds[6] & 0x0f) | 0x40;
	  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
	  // Copy bytes to buffer, if provided
	  if (buf) {
	    for (var ii = 0; ii < 16; ++ii) {
	      buf[i + ii] = rnds[ii];
	    }
	  }
	
	  return buf || bytesToUuid(rnds);
	}
	
	module.exports = v4;


/***/ },
/* 1292 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 1293 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1294 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _List = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	var _default = _List.default;
	exports.default = _default;

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _src = _interopRequireDefault(__webpack_require__(__webpack_module_template_argument_0__));
	var _default = _src.default;
	exports.default = _default;

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/** 
	 * Copyright © INOVUA TRADING.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _typeof = __webpack_require__(5);
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	exports.default = void 0;
	var _src = _interopRequireWildcard(__webpack_require__(__webpack_module_template_argument_0__));
	Object.keys(_src).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  if (key in exports && exports[key] === _src[key]) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _src[key];
	    }
	  });
	});
	function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
	function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	var _default = _src.default;
	exports.default = _default;

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.f3fcb280.js